/*! For license information please see swagger-ui-bundle.js.LICENSE.txt */
!function webpackUniversalModuleDefinition(s,o){"object"==typeof exports&&"object"==typeof module?module.exports=o():"function"==typeof define&&define.amd?define([],o):"object"==typeof exports?exports.SwaggerUIBundle=o():s.SwaggerUIBundle=o()}(this,(()=>(()=>{var s={67526(s,o){"use strict";o.byteLength=function byteLength(s){var o=getLens(s),i=o[0],a=o[1];return 3*(i+a)/4-a},o.toByteArray=function toByteArray(s){var o,i,_=getLens(s),w=_[0],x=_[1],C=new u(function _byteLength(s,o,i){return 3*(o+i)/4-i}(0,w,x)),j=0,L=x>0?w-4:w;for(i=0;i<L;i+=4)o=a[s.charCodeAt(i)]<<18|a[s.charCodeAt(i+1)]<<12|a[s.charCodeAt(i+2)]<<6|a[s.charCodeAt(i+3)],C[j++]=o>>16&255,C[j++]=o>>8&255,C[j++]=255&o;2===x&&(o=a[s.charCodeAt(i)]<<2|a[s.charCodeAt(i+1)]>>4,C[j++]=255&o);1===x&&(o=a[s.charCodeAt(i)]<<10|a[s.charCodeAt(i+1)]<<4|a[s.charCodeAt(i+2)]>>2,C[j++]=o>>8&255,C[j++]=255&o);return C},o.fromByteArray=function fromByteArray(s){for(var o,a=s.length,u=a%3,_=[],w=16383,x=0,C=a-u;x<C;x+=w)_.push(encodeChunk(s,x,x+w>C?C:x+w));1===u?(o=s[a-1],_.push(i[o>>2]+i[o<<4&63]+"==")):2===u&&(o=(s[a-2]<<8)+s[a-1],_.push(i[o>>10]+i[o>>4&63]+i[o<<2&63]+"="));return _.join("")};for(var i=[],a=[],u="undefined"!=typeof Uint8Array?Uint8Array:Array,_="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",w=0;w<64;++w)i[w]=_[w],a[_.charCodeAt(w)]=w;function getLens(s){var o=s.length;if(o%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var i=s.indexOf("=");return-1===i&&(i=o),[i,i===o?0:4-i%4]}function encodeChunk(s,o,a){for(var u,_,w=[],x=o;x<a;x+=3)u=(s[x]<<16&16711680)+(s[x+1]<<8&65280)+(255&s[x+2]),w.push(i[(_=u)>>18&63]+i[_>>12&63]+i[_>>6&63]+i[63&_]);return w.join("")}a["-".charCodeAt(0)]=62,a["_".charCodeAt(0)]=63},48287(s,o,i){"use strict";const a=i(67526),u=i(251),_="function"==typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("nodejs.util.inspect.custom"):null;o.Buffer=Buffer,o.SlowBuffer=function SlowBuffer(s){+s!=s&&(s=0);return Buffer.alloc(+s)},o.INSPECT_MAX_BYTES=50;const w=2147483647;function createBuffer(s){if(s>w)throw new RangeError('The value "'+s+'" is invalid for option "size"');const o=new Uint8Array(s);return Object.setPrototypeOf(o,Buffer.prototype),o}function Buffer(s,o,i){if("number"==typeof s){if("string"==typeof o)throw new TypeError('The "string" argument must be of type string. Received type number');return allocUnsafe(s)}return from(s,o,i)}function from(s,o,i){if("string"==typeof s)return function fromString(s,o){"string"==typeof o&&""!==o||(o="utf8");if(!Buffer.isEncoding(o))throw new TypeError("Unknown encoding: "+o);const i=0|byteLength(s,o);let a=createBuffer(i);const u=a.write(s,o);u!==i&&(a=a.slice(0,u));return a}(s,o);if(ArrayBuffer.isView(s))return function fromArrayView(s){if(isInstance(s,Uint8Array)){const o=new Uint8Array(s);return fromArrayBuffer(o.buffer,o.byteOffset,o.byteLength)}return fromArrayLike(s)}(s);if(null==s)throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof s);if(isInstance(s,ArrayBuffer)||s&&isInstance(s.buffer,ArrayBuffer))return fromArrayBuffer(s,o,i);if("undefined"!=typeof SharedArrayBuffer&&(isInstance(s,SharedArrayBuffer)||s&&isInstance(s.buffer,SharedArrayBuffer)))return fromArrayBuffer(s,o,i);if("number"==typeof s)throw new TypeError('The "value" argument must not be of type number. Received type number');const a=s.valueOf&&s.valueOf();if(null!=a&&a!==s)return Buffer.from(a,o,i);const u=function fromObject(s){if(Buffer.isBuffer(s)){const o=0|checked(s.length),i=createBuffer(o);return 0===i.length||s.copy(i,0,0,o),i}if(void 0!==s.length)return"number"!=typeof s.length||numberIsNaN(s.length)?createBuffer(0):fromArrayLike(s);if("Buffer"===s.type&&Array.isArray(s.data))return fromArrayLike(s.data)}(s);if(u)return u;if("undefined"!=typeof Symbol&&null!=Symbol.toPrimitive&&"function"==typeof s[Symbol.toPrimitive])return Buffer.from(s[Symbol.toPrimitive]("string"),o,i);throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof s)}function assertSize(s){if("number"!=typeof s)throw new TypeError('"size" argument must be of type number');if(s<0)throw new RangeError('The value "'+s+'" is invalid for option "size"')}function allocUnsafe(s){return assertSize(s),createBuffer(s<0?0:0|checked(s))}function fromArrayLike(s){const o=s.length<0?0:0|checked(s.length),i=createBuffer(o);for(let a=0;a<o;a+=1)i[a]=255&s[a];return i}function fromArrayBuffer(s,o,i){if(o<0||s.byteLength<o)throw new RangeError('"offset" is outside of buffer bounds');if(s.byteLength<o+(i||0))throw new RangeError('"length" is outside of buffer bounds');let a;return a=void 0===o&&void 0===i?new Uint8Array(s):void 0===i?new Uint8Array(s,o):new Uint8Array(s,o,i),Object.setPrototypeOf(a,Buffer.prototype),a}function checked(s){if(s>=w)throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+w.toString(16)+" bytes");return 0|s}function byteLength(s,o){if(Buffer.isBuffer(s))return s.length;if(ArrayBuffer.isView(s)||isInstance(s,ArrayBuffer))return s.byteLength;if("string"!=typeof s)throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type '+typeof s);const i=s.length,a=arguments.length>2&&!0===arguments[2];if(!a&&0===i)return 0;let u=!1;for(;;)switch(o){case"ascii":case"latin1":case"binary":return i;case"utf8":case"utf-8":return utf8ToBytes(s).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*i;case"hex":return i>>>1;case"base64":return base64ToBytes(s).length;default:if(u)return a?-1:utf8ToBytes(s).length;o=(""+o).toLowerCase(),u=!0}}function slowToString(s,o,i){let a=!1;if((void 0===o||o<0)&&(o=0),o>this.length)return"";if((void 0===i||i>this.length)&&(i=this.length),i<=0)return"";if((i>>>=0)<=(o>>>=0))return"";for(s||(s="utf8");;)switch(s){case"hex":return hexSlice(this,o,i);case"utf8":case"utf-8":return utf8Slice(this,o,i);case"ascii":return asciiSlice(this,o,i);case"latin1":case"binary":return latin1Slice(this,o,i);case"base64":return base64Slice(this,o,i);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return utf16leSlice(this,o,i);default:if(a)throw new TypeError("Unknown encoding: "+s);s=(s+"").toLowerCase(),a=!0}}function swap(s,o,i){const a=s[o];s[o]=s[i],s[i]=a}function bidirectionalIndexOf(s,o,i,a,u){if(0===s.length)return-1;if("string"==typeof i?(a=i,i=0):i>2147483647?i=2147483647:i<-2147483648&&(i=-2147483648),numberIsNaN(i=+i)&&(i=u?0:s.length-1),i<0&&(i=s.length+i),i>=s.length){if(u)return-1;i=s.length-1}else if(i<0){if(!u)return-1;i=0}if("string"==typeof o&&(o=Buffer.from(o,a)),Buffer.isBuffer(o))return 0===o.length?-1:arrayIndexOf(s,o,i,a,u);if("number"==typeof o)return o&=255,"function"==typeof Uint8Array.prototype.indexOf?u?Uint8Array.prototype.indexOf.call(s,o,i):Uint8Array.prototype.lastIndexOf.call(s,o,i):arrayIndexOf(s,[o],i,a,u);throw new TypeError("val must be string, number or Buffer")}function arrayIndexOf(s,o,i,a,u){let _,w=1,x=s.length,C=o.length;if(void 0!==a&&("ucs2"===(a=String(a).toLowerCase())||"ucs-2"===a||"utf16le"===a||"utf-16le"===a)){if(s.length<2||o.length<2)return-1;w=2,x/=2,C/=2,i/=2}function read(s,o){return 1===w?s[o]:s.readUInt16BE(o*w)}if(u){let a=-1;for(_=i;_<x;_++)if(read(s,_)===read(o,-1===a?0:_-a)){if(-1===a&&(a=_),_-a+1===C)return a*w}else-1!==a&&(_-=_-a),a=-1}else for(i+C>x&&(i=x-C),_=i;_>=0;_--){let i=!0;for(let a=0;a<C;a++)if(read(s,_+a)!==read(o,a)){i=!1;break}if(i)return _}return-1}function hexWrite(s,o,i,a){i=Number(i)||0;const u=s.length-i;a?(a=Number(a))>u&&(a=u):a=u;const _=o.length;let w;for(a>_/2&&(a=_/2),w=0;w<a;++w){const a=parseInt(o.substr(2*w,2),16);if(numberIsNaN(a))return w;s[i+w]=a}return w}function utf8Write(s,o,i,a){return blitBuffer(utf8ToBytes(o,s.length-i),s,i,a)}function asciiWrite(s,o,i,a){return blitBuffer(function asciiToBytes(s){const o=[];for(let i=0;i<s.length;++i)o.push(255&s.charCodeAt(i));return o}(o),s,i,a)}function base64Write(s,o,i,a){return blitBuffer(base64ToBytes(o),s,i,a)}function ucs2Write(s,o,i,a){return blitBuffer(function utf16leToBytes(s,o){let i,a,u;const _=[];for(let w=0;w<s.length&&!((o-=2)<0);++w)i=s.charCodeAt(w),a=i>>8,u=i%256,_.push(u),_.push(a);return _}(o,s.length-i),s,i,a)}function base64Slice(s,o,i){return 0===o&&i===s.length?a.fromByteArray(s):a.fromByteArray(s.slice(o,i))}function utf8Slice(s,o,i){i=Math.min(s.length,i);const a=[];let u=o;for(;u<i;){const o=s[u];let _=null,w=o>239?4:o>223?3:o>191?2:1;if(u+w<=i){let i,a,x,C;switch(w){case 1:o<128&&(_=o);break;case 2:i=s[u+1],128==(192&i)&&(C=(31&o)<<6|63&i,C>127&&(_=C));break;case 3:i=s[u+1],a=s[u+2],128==(192&i)&&128==(192&a)&&(C=(15&o)<<12|(63&i)<<6|63&a,C>2047&&(C<55296||C>57343)&&(_=C));break;case 4:i=s[u+1],a=s[u+2],x=s[u+3],128==(192&i)&&128==(192&a)&&128==(192&x)&&(C=(15&o)<<18|(63&i)<<12|(63&a)<<6|63&x,C>65535&&C<1114112&&(_=C))}}null===_?(_=65533,w=1):_>65535&&(_-=65536,a.push(_>>>10&1023|55296),_=56320|1023&_),a.push(_),u+=w}return function decodeCodePointsArray(s){const o=s.length;if(o<=x)return String.fromCharCode.apply(String,s);let i="",a=0;for(;a<o;)i+=String.fromCharCode.apply(String,s.slice(a,a+=x));return i}(a)}o.kMaxLength=w,Buffer.TYPED_ARRAY_SUPPORT=function typedArraySupport(){try{const s=new Uint8Array(1),o={foo:function(){return 42}};return Object.setPrototypeOf(o,Uint8Array.prototype),Object.setPrototypeOf(s,o),42===s.foo()}catch(s){return!1}}(),Buffer.TYPED_ARRAY_SUPPORT||"undefined"==typeof console||"function"!=typeof console.error||console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."),Object.defineProperty(Buffer.prototype,"parent",{enumerable:!0,get:function(){if(Buffer.isBuffer(this))return this.buffer}}),Object.defineProperty(Buffer.prototype,"offset",{enumerable:!0,get:function(){if(Buffer.isBuffer(this))return this.byteOffset}}),Buffer.poolSize=8192,Buffer.from=function(s,o,i){return from(s,o,i)},Object.setPrototypeOf(Buffer.prototype,Uint8Array.prototype),Object.setPrototypeOf(Buffer,Uint8Array),Buffer.alloc=function(s,o,i){return function alloc(s,o,i){return assertSize(s),s<=0?createBuffer(s):void 0!==o?"string"==typeof i?createBuffer(s).fill(o,i):createBuffer(s).fill(o):createBuffer(s)}(s,o,i)},Buffer.allocUnsafe=function(s){return allocUnsafe(s)},Buffer.allocUnsafeSlow=function(s){return allocUnsafe(s)},Buffer.isBuffer=function isBuffer(s){return null!=s&&!0===s._isBuffer&&s!==Buffer.prototype},Buffer.compare=function compare(s,o){if(isInstance(s,Uint8Array)&&(s=Buffer.from(s,s.offset,s.byteLength)),isInstance(o,Uint8Array)&&(o=Buffer.from(o,o.offset,o.byteLength)),!Buffer.isBuffer(s)||!Buffer.isBuffer(o))throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');if(s===o)return 0;let i=s.length,a=o.length;for(let u=0,_=Math.min(i,a);u<_;++u)if(s[u]!==o[u]){i=s[u],a=o[u];break}return i<a?-1:a<i?1:0},Buffer.isEncoding=function isEncoding(s){switch(String(s).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},Buffer.concat=function concat(s,o){if(!Array.isArray(s))throw new TypeError('"list" argument must be an Array of Buffers');if(0===s.length)return Buffer.alloc(0);let i;if(void 0===o)for(o=0,i=0;i<s.length;++i)o+=s[i].length;const a=Buffer.allocUnsafe(o);let u=0;for(i=0;i<s.length;++i){let o=s[i];if(isInstance(o,Uint8Array))u+o.length>a.length?(Buffer.isBuffer(o)||(o=Buffer.from(o)),o.copy(a,u)):Uint8Array.prototype.set.call(a,o,u);else{if(!Buffer.isBuffer(o))throw new TypeError('"list" argument must be an Array of Buffers');o.copy(a,u)}u+=o.length}return a},Buffer.byteLength=byteLength,Buffer.prototype._isBuffer=!0,Buffer.prototype.swap16=function swap16(){const s=this.length;if(s%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(let o=0;o<s;o+=2)swap(this,o,o+1);return this},Buffer.prototype.swap32=function swap32(){const s=this.length;if(s%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(let o=0;o<s;o+=4)swap(this,o,o+3),swap(this,o+1,o+2);return this},Buffer.prototype.swap64=function swap64(){const s=this.length;if(s%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(let o=0;o<s;o+=8)swap(this,o,o+7),swap(this,o+1,o+6),swap(this,o+2,o+5),swap(this,o+3,o+4);return this},Buffer.prototype.toString=function toString(){const s=this.length;return 0===s?"":0===arguments.length?utf8Slice(this,0,s):slowToString.apply(this,arguments)},Buffer.prototype.toLocaleString=Buffer.prototype.toString,Buffer.prototype.equals=function equals(s){if(!Buffer.isBuffer(s))throw new TypeError("Argument must be a Buffer");return this===s||0===Buffer.compare(this,s)},Buffer.prototype.inspect=function inspect(){let s="";const i=o.INSPECT_MAX_BYTES;return s=this.toString("hex",0,i).replace(/(.{2})/g,"$1 ").trim(),this.length>i&&(s+=" ... "),"<Buffer "+s+">"},_&&(Buffer.prototype[_]=Buffer.prototype.inspect),Buffer.prototype.compare=function compare(s,o,i,a,u){if(isInstance(s,Uint8Array)&&(s=Buffer.from(s,s.offset,s.byteLength)),!Buffer.isBuffer(s))throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type '+typeof s);if(void 0===o&&(o=0),void 0===i&&(i=s?s.length:0),void 0===a&&(a=0),void 0===u&&(u=this.length),o<0||i>s.length||a<0||u>this.length)throw new RangeError("out of range index");if(a>=u&&o>=i)return 0;if(a>=u)return-1;if(o>=i)return 1;if(this===s)return 0;let _=(u>>>=0)-(a>>>=0),w=(i>>>=0)-(o>>>=0);const x=Math.min(_,w),C=this.slice(a,u),j=s.slice(o,i);for(let s=0;s<x;++s)if(C[s]!==j[s]){_=C[s],w=j[s];break}return _<w?-1:w<_?1:0},Buffer.prototype.includes=function includes(s,o,i){return-1!==this.indexOf(s,o,i)},Buffer.prototype.indexOf=function indexOf(s,o,i){return bidirectionalIndexOf(this,s,o,i,!0)},Buffer.prototype.lastIndexOf=function lastIndexOf(s,o,i){return bidirectionalIndexOf(this,s,o,i,!1)},Buffer.prototype.write=function write(s,o,i,a){if(void 0===o)a="utf8",i=this.length,o=0;else if(void 0===i&&"string"==typeof o)a=o,i=this.length,o=0;else{if(!isFinite(o))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");o>>>=0,isFinite(i)?(i>>>=0,void 0===a&&(a="utf8")):(a=i,i=void 0)}const u=this.length-o;if((void 0===i||i>u)&&(i=u),s.length>0&&(i<0||o<0)||o>this.length)throw new RangeError("Attempt to write outside buffer bounds");a||(a="utf8");let _=!1;for(;;)switch(a){case"hex":return hexWrite(this,s,o,i);case"utf8":case"utf-8":return utf8Write(this,s,o,i);case"ascii":case"latin1":case"binary":return asciiWrite(this,s,o,i);case"base64":return base64Write(this,s,o,i);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ucs2Write(this,s,o,i);default:if(_)throw new TypeError("Unknown encoding: "+a);a=(""+a).toLowerCase(),_=!0}},Buffer.prototype.toJSON=function toJSON(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};const x=4096;function asciiSlice(s,o,i){let a="";i=Math.min(s.length,i);for(let u=o;u<i;++u)a+=String.fromCharCode(127&s[u]);return a}function latin1Slice(s,o,i){let a="";i=Math.min(s.length,i);for(let u=o;u<i;++u)a+=String.fromCharCode(s[u]);return a}function hexSlice(s,o,i){const a=s.length;(!o||o<0)&&(o=0),(!i||i<0||i>a)&&(i=a);let u="";for(let a=o;a<i;++a)u+=L[s[a]];return u}function utf16leSlice(s,o,i){const a=s.slice(o,i);let u="";for(let s=0;s<a.length-1;s+=2)u+=String.fromCharCode(a[s]+256*a[s+1]);return u}function checkOffset(s,o,i){if(s%1!=0||s<0)throw new RangeError("offset is not uint");if(s+o>i)throw new RangeError("Trying to access beyond buffer length")}function checkInt(s,o,i,a,u,_){if(!Buffer.isBuffer(s))throw new TypeError('"buffer" argument must be a Buffer instance');if(o>u||o<_)throw new RangeError('"value" argument is out of bounds');if(i+a>s.length)throw new RangeError("Index out of range")}function wrtBigUInt64LE(s,o,i,a,u){checkIntBI(o,a,u,s,i,7);let _=Number(o&BigInt(4294967295));s[i++]=_,_>>=8,s[i++]=_,_>>=8,s[i++]=_,_>>=8,s[i++]=_;let w=Number(o>>BigInt(32)&BigInt(4294967295));return s[i++]=w,w>>=8,s[i++]=w,w>>=8,s[i++]=w,w>>=8,s[i++]=w,i}function wrtBigUInt64BE(s,o,i,a,u){checkIntBI(o,a,u,s,i,7);let _=Number(o&BigInt(4294967295));s[i+7]=_,_>>=8,s[i+6]=_,_>>=8,s[i+5]=_,_>>=8,s[i+4]=_;let w=Number(o>>BigInt(32)&BigInt(4294967295));return s[i+3]=w,w>>=8,s[i+2]=w,w>>=8,s[i+1]=w,w>>=8,s[i]=w,i+8}function checkIEEE754(s,o,i,a,u,_){if(i+a>s.length)throw new RangeError("Index out of range");if(i<0)throw new RangeError("Index out of range")}function writeFloat(s,o,i,a,_){return o=+o,i>>>=0,_||checkIEEE754(s,0,i,4),u.write(s,o,i,a,23,4),i+4}function writeDouble(s,o,i,a,_){return o=+o,i>>>=0,_||checkIEEE754(s,0,i,8),u.write(s,o,i,a,52,8),i+8}Buffer.prototype.slice=function slice(s,o){const i=this.length;(s=~~s)<0?(s+=i)<0&&(s=0):s>i&&(s=i),(o=void 0===o?i:~~o)<0?(o+=i)<0&&(o=0):o>i&&(o=i),o<s&&(o=s);const a=this.subarray(s,o);return Object.setPrototypeOf(a,Buffer.prototype),a},Buffer.prototype.readUintLE=Buffer.prototype.readUIntLE=function readUIntLE(s,o,i){s>>>=0,o>>>=0,i||checkOffset(s,o,this.length);let a=this[s],u=1,_=0;for(;++_<o&&(u*=256);)a+=this[s+_]*u;return a},Buffer.prototype.readUintBE=Buffer.prototype.readUIntBE=function readUIntBE(s,o,i){s>>>=0,o>>>=0,i||checkOffset(s,o,this.length);let a=this[s+--o],u=1;for(;o>0&&(u*=256);)a+=this[s+--o]*u;return a},Buffer.prototype.readUint8=Buffer.prototype.readUInt8=function readUInt8(s,o){return s>>>=0,o||checkOffset(s,1,this.length),this[s]},Buffer.prototype.readUint16LE=Buffer.prototype.readUInt16LE=function readUInt16LE(s,o){return s>>>=0,o||checkOffset(s,2,this.length),this[s]|this[s+1]<<8},Buffer.prototype.readUint16BE=Buffer.prototype.readUInt16BE=function readUInt16BE(s,o){return s>>>=0,o||checkOffset(s,2,this.length),this[s]<<8|this[s+1]},Buffer.prototype.readUint32LE=Buffer.prototype.readUInt32LE=function readUInt32LE(s,o){return s>>>=0,o||checkOffset(s,4,this.length),(this[s]|this[s+1]<<8|this[s+2]<<16)+16777216*this[s+3]},Buffer.prototype.readUint32BE=Buffer.prototype.readUInt32BE=function readUInt32BE(s,o){return s>>>=0,o||checkOffset(s,4,this.length),16777216*this[s]+(this[s+1]<<16|this[s+2]<<8|this[s+3])},Buffer.prototype.readBigUInt64LE=defineBigIntMethod((function readBigUInt64LE(s){validateNumber(s>>>=0,"offset");const o=this[s],i=this[s+7];void 0!==o&&void 0!==i||boundsError(s,this.length-8);const a=o+256*this[++s]+65536*this[++s]+this[++s]*2**24,u=this[++s]+256*this[++s]+65536*this[++s]+i*2**24;return BigInt(a)+(BigInt(u)<<BigInt(32))})),Buffer.prototype.readBigUInt64BE=defineBigIntMethod((function readBigUInt64BE(s){validateNumber(s>>>=0,"offset");const o=this[s],i=this[s+7];void 0!==o&&void 0!==i||boundsError(s,this.length-8);const a=o*2**24+65536*this[++s]+256*this[++s]+this[++s],u=this[++s]*2**24+65536*this[++s]+256*this[++s]+i;return(BigInt(a)<<BigInt(32))+BigInt(u)})),Buffer.prototype.readIntLE=function readIntLE(s,o,i){s>>>=0,o>>>=0,i||checkOffset(s,o,this.length);let a=this[s],u=1,_=0;for(;++_<o&&(u*=256);)a+=this[s+_]*u;return u*=128,a>=u&&(a-=Math.pow(2,8*o)),a},Buffer.prototype.readIntBE=function readIntBE(s,o,i){s>>>=0,o>>>=0,i||checkOffset(s,o,this.length);let a=o,u=1,_=this[s+--a];for(;a>0&&(u*=256);)_+=this[s+--a]*u;return u*=128,_>=u&&(_-=Math.pow(2,8*o)),_},Buffer.prototype.readInt8=function readInt8(s,o){return s>>>=0,o||checkOffset(s,1,this.length),128&this[s]?-1*(255-this[s]+1):this[s]},Buffer.prototype.readInt16LE=function readInt16LE(s,o){s>>>=0,o||checkOffset(s,2,this.length);const i=this[s]|this[s+1]<<8;return 32768&i?4294901760|i:i},Buffer.prototype.readInt16BE=function readInt16BE(s,o){s>>>=0,o||checkOffset(s,2,this.length);const i=this[s+1]|this[s]<<8;return 32768&i?4294901760|i:i},Buffer.prototype.readInt32LE=function readInt32LE(s,o){return s>>>=0,o||checkOffset(s,4,this.length),this[s]|this[s+1]<<8|this[s+2]<<16|this[s+3]<<24},Buffer.prototype.readInt32BE=function readInt32BE(s,o){return s>>>=0,o||checkOffset(s,4,this.length),this[s]<<24|this[s+1]<<16|this[s+2]<<8|this[s+3]},Buffer.prototype.readBigInt64LE=defineBigIntMethod((function readBigInt64LE(s){validateNumber(s>>>=0,"offset");const o=this[s],i=this[s+7];void 0!==o&&void 0!==i||boundsError(s,this.length-8);const a=this[s+4]+256*this[s+5]+65536*this[s+6]+(i<<24);return(BigInt(a)<<BigInt(32))+BigInt(o+256*this[++s]+65536*this[++s]+this[++s]*2**24)})),Buffer.prototype.readBigInt64BE=defineBigIntMethod((function readBigInt64BE(s){validateNumber(s>>>=0,"offset");const o=this[s],i=this[s+7];void 0!==o&&void 0!==i||boundsError(s,this.length-8);const a=(o<<24)+65536*this[++s]+256*this[++s]+this[++s];return(BigInt(a)<<BigInt(32))+BigInt(this[++s]*2**24+65536*this[++s]+256*this[++s]+i)})),Buffer.prototype.readFloatLE=function readFloatLE(s,o){return s>>>=0,o||checkOffset(s,4,this.length),u.read(this,s,!0,23,4)},Buffer.prototype.readFloatBE=function readFloatBE(s,o){return s>>>=0,o||checkOffset(s,4,this.length),u.read(this,s,!1,23,4)},Buffer.prototype.readDoubleLE=function readDoubleLE(s,o){return s>>>=0,o||checkOffset(s,8,this.length),u.read(this,s,!0,52,8)},Buffer.prototype.readDoubleBE=function readDoubleBE(s,o){return s>>>=0,o||checkOffset(s,8,this.length),u.read(this,s,!1,52,8)},Buffer.prototype.writeUintLE=Buffer.prototype.writeUIntLE=function writeUIntLE(s,o,i,a){if(s=+s,o>>>=0,i>>>=0,!a){checkInt(this,s,o,i,Math.pow(2,8*i)-1,0)}let u=1,_=0;for(this[o]=255&s;++_<i&&(u*=256);)this[o+_]=s/u&255;return o+i},Buffer.prototype.writeUintBE=Buffer.prototype.writeUIntBE=function writeUIntBE(s,o,i,a){if(s=+s,o>>>=0,i>>>=0,!a){checkInt(this,s,o,i,Math.pow(2,8*i)-1,0)}let u=i-1,_=1;for(this[o+u]=255&s;--u>=0&&(_*=256);)this[o+u]=s/_&255;return o+i},Buffer.prototype.writeUint8=Buffer.prototype.writeUInt8=function writeUInt8(s,o,i){return s=+s,o>>>=0,i||checkInt(this,s,o,1,255,0),this[o]=255&s,o+1},Buffer.prototype.writeUint16LE=Buffer.prototype.writeUInt16LE=function writeUInt16LE(s,o,i){return s=+s,o>>>=0,i||checkInt(this,s,o,2,65535,0),this[o]=255&s,this[o+1]=s>>>8,o+2},Buffer.prototype.writeUint16BE=Buffer.prototype.writeUInt16BE=function writeUInt16BE(s,o,i){return s=+s,o>>>=0,i||checkInt(this,s,o,2,65535,0),this[o]=s>>>8,this[o+1]=255&s,o+2},Buffer.prototype.writeUint32LE=Buffer.prototype.writeUInt32LE=function writeUInt32LE(s,o,i){return s=+s,o>>>=0,i||checkInt(this,s,o,4,4294967295,0),this[o+3]=s>>>24,this[o+2]=s>>>16,this[o+1]=s>>>8,this[o]=255&s,o+4},Buffer.prototype.writeUint32BE=Buffer.prototype.writeUInt32BE=function writeUInt32BE(s,o,i){return s=+s,o>>>=0,i||checkInt(this,s,o,4,4294967295,0),this[o]=s>>>24,this[o+1]=s>>>16,this[o+2]=s>>>8,this[o+3]=255&s,o+4},Buffer.prototype.writeBigUInt64LE=defineBigIntMethod((function writeBigUInt64LE(s,o=0){return wrtBigUInt64LE(this,s,o,BigInt(0),BigInt("0xffffffffffffffff"))})),Buffer.prototype.writeBigUInt64BE=defineBigIntMethod((function writeBigUInt64BE(s,o=0){return wrtBigUInt64BE(this,s,o,BigInt(0),BigInt("0xffffffffffffffff"))})),Buffer.prototype.writeIntLE=function writeIntLE(s,o,i,a){if(s=+s,o>>>=0,!a){const a=Math.pow(2,8*i-1);checkInt(this,s,o,i,a-1,-a)}let u=0,_=1,w=0;for(this[o]=255&s;++u<i&&(_*=256);)s<0&&0===w&&0!==this[o+u-1]&&(w=1),this[o+u]=(s/_|0)-w&255;return o+i},Buffer.prototype.writeIntBE=function writeIntBE(s,o,i,a){if(s=+s,o>>>=0,!a){const a=Math.pow(2,8*i-1);checkInt(this,s,o,i,a-1,-a)}let u=i-1,_=1,w=0;for(this[o+u]=255&s;--u>=0&&(_*=256);)s<0&&0===w&&0!==this[o+u+1]&&(w=1),this[o+u]=(s/_|0)-w&255;return o+i},Buffer.prototype.writeInt8=function writeInt8(s,o,i){return s=+s,o>>>=0,i||checkInt(this,s,o,1,127,-128),s<0&&(s=255+s+1),this[o]=255&s,o+1},Buffer.prototype.writeInt16LE=function writeInt16LE(s,o,i){return s=+s,o>>>=0,i||checkInt(this,s,o,2,32767,-32768),this[o]=255&s,this[o+1]=s>>>8,o+2},Buffer.prototype.writeInt16BE=function writeInt16BE(s,o,i){return s=+s,o>>>=0,i||checkInt(this,s,o,2,32767,-32768),this[o]=s>>>8,this[o+1]=255&s,o+2},Buffer.prototype.writeInt32LE=function writeInt32LE(s,o,i){return s=+s,o>>>=0,i||checkInt(this,s,o,4,2147483647,-2147483648),this[o]=255&s,this[o+1]=s>>>8,this[o+2]=s>>>16,this[o+3]=s>>>24,o+4},Buffer.prototype.writeInt32BE=function writeInt32BE(s,o,i){return s=+s,o>>>=0,i||checkInt(this,s,o,4,2147483647,-2147483648),s<0&&(s=4294967295+s+1),this[o]=s>>>24,this[o+1]=s>>>16,this[o+2]=s>>>8,this[o+3]=255&s,o+4},Buffer.prototype.writeBigInt64LE=defineBigIntMethod((function writeBigInt64LE(s,o=0){return wrtBigUInt64LE(this,s,o,-BigInt("0x8000000000000000"),BigInt("0x7fffffffffffffff"))})),Buffer.prototype.writeBigInt64BE=defineBigIntMethod((function writeBigInt64BE(s,o=0){return wrtBigUInt64BE(this,s,o,-BigInt("0x8000000000000000"),BigInt("0x7fffffffffffffff"))})),Buffer.prototype.writeFloatLE=function writeFloatLE(s,o,i){return writeFloat(this,s,o,!0,i)},Buffer.prototype.writeFloatBE=function writeFloatBE(s,o,i){return writeFloat(this,s,o,!1,i)},Buffer.prototype.writeDoubleLE=function writeDoubleLE(s,o,i){return writeDouble(this,s,o,!0,i)},Buffer.prototype.writeDoubleBE=function writeDoubleBE(s,o,i){return writeDouble(this,s,o,!1,i)},Buffer.prototype.copy=function copy(s,o,i,a){if(!Buffer.isBuffer(s))throw new TypeError("argument should be a Buffer");if(i||(i=0),a||0===a||(a=this.length),o>=s.length&&(o=s.length),o||(o=0),a>0&&a<i&&(a=i),a===i)return 0;if(0===s.length||0===this.length)return 0;if(o<0)throw new RangeError("targetStart out of bounds");if(i<0||i>=this.length)throw new RangeError("Index out of range");if(a<0)throw new RangeError("sourceEnd out of bounds");a>this.length&&(a=this.length),s.length-o<a-i&&(a=s.length-o+i);const u=a-i;return this===s&&"function"==typeof Uint8Array.prototype.copyWithin?this.copyWithin(o,i,a):Uint8Array.prototype.set.call(s,this.subarray(i,a),o),u},Buffer.prototype.fill=function fill(s,o,i,a){if("string"==typeof s){if("string"==typeof o?(a=o,o=0,i=this.length):"string"==typeof i&&(a=i,i=this.length),void 0!==a&&"string"!=typeof a)throw new TypeError("encoding must be a string");if("string"==typeof a&&!Buffer.isEncoding(a))throw new TypeError("Unknown encoding: "+a);if(1===s.length){const o=s.charCodeAt(0);("utf8"===a&&o<128||"latin1"===a)&&(s=o)}}else"number"==typeof s?s&=255:"boolean"==typeof s&&(s=Number(s));if(o<0||this.length<o||this.length<i)throw new RangeError("Out of range index");if(i<=o)return this;let u;if(o>>>=0,i=void 0===i?this.length:i>>>0,s||(s=0),"number"==typeof s)for(u=o;u<i;++u)this[u]=s;else{const _=Buffer.isBuffer(s)?s:Buffer.from(s,a),w=_.length;if(0===w)throw new TypeError('The value "'+s+'" is invalid for argument "value"');for(u=0;u<i-o;++u)this[u+o]=_[u%w]}return this};const C={};function E(s,o,i){C[s]=class NodeError extends i{constructor(){super(),Object.defineProperty(this,"message",{value:o.apply(this,arguments),writable:!0,configurable:!0}),this.name=`${this.name} [${s}]`,this.stack,delete this.name}get code(){return s}set code(s){Object.defineProperty(this,"code",{configurable:!0,enumerable:!0,value:s,writable:!0})}toString(){return`${this.name} [${s}]: ${this.message}`}}}function addNumericalSeparator(s){let o="",i=s.length;const a="-"===s[0]?1:0;for(;i>=a+4;i-=3)o=`_${s.slice(i-3,i)}${o}`;return`${s.slice(0,i)}${o}`}function checkIntBI(s,o,i,a,u,_){if(s>i||s<o){const a="bigint"==typeof o?"n":"";let u;throw u=_>3?0===o||o===BigInt(0)?`>= 0${a} and < 2${a} ** ${8*(_+1)}${a}`:`>= -(2${a} ** ${8*(_+1)-1}${a}) and < 2 ** ${8*(_+1)-1}${a}`:`>= ${o}${a} and <= ${i}${a}`,new C.ERR_OUT_OF_RANGE("value",u,s)}!function checkBounds(s,o,i){validateNumber(o,"offset"),void 0!==s[o]&&void 0!==s[o+i]||boundsError(o,s.length-(i+1))}(a,u,_)}function validateNumber(s,o){if("number"!=typeof s)throw new C.ERR_INVALID_ARG_TYPE(o,"number",s)}function boundsError(s,o,i){if(Math.floor(s)!==s)throw validateNumber(s,i),new C.ERR_OUT_OF_RANGE(i||"offset","an integer",s);if(o<0)throw new C.ERR_BUFFER_OUT_OF_BOUNDS;throw new C.ERR_OUT_OF_RANGE(i||"offset",`>= ${i?1:0} and <= ${o}`,s)}E("ERR_BUFFER_OUT_OF_BOUNDS",(function(s){return s?`${s} is outside of buffer bounds`:"Attempt to access memory outside buffer bounds"}),RangeError),E("ERR_INVALID_ARG_TYPE",(function(s,o){return`The "${s}" argument must be of type number. Received type ${typeof o}`}),TypeError),E("ERR_OUT_OF_RANGE",(function(s,o,i){let a=`The value of "${s}" is out of range.`,u=i;return Number.isInteger(i)&&Math.abs(i)>2**32?u=addNumericalSeparator(String(i)):"bigint"==typeof i&&(u=String(i),(i>BigInt(2)**BigInt(32)||i<-(BigInt(2)**BigInt(32)))&&(u=addNumericalSeparator(u)),u+="n"),a+=` It must be ${o}. Received ${u}`,a}),RangeError);const j=/[^+/0-9A-Za-z-_]/g;function utf8ToBytes(s,o){let i;o=o||1/0;const a=s.length;let u=null;const _=[];for(let w=0;w<a;++w){if(i=s.charCodeAt(w),i>55295&&i<57344){if(!u){if(i>56319){(o-=3)>-1&&_.push(239,191,189);continue}if(w+1===a){(o-=3)>-1&&_.push(239,191,189);continue}u=i;continue}if(i<56320){(o-=3)>-1&&_.push(239,191,189),u=i;continue}i=65536+(u-55296<<10|i-56320)}else u&&(o-=3)>-1&&_.push(239,191,189);if(u=null,i<128){if((o-=1)<0)break;_.push(i)}else if(i<2048){if((o-=2)<0)break;_.push(i>>6|192,63&i|128)}else if(i<65536){if((o-=3)<0)break;_.push(i>>12|224,i>>6&63|128,63&i|128)}else{if(!(i<1114112))throw new Error("Invalid code point");if((o-=4)<0)break;_.push(i>>18|240,i>>12&63|128,i>>6&63|128,63&i|128)}}return _}function base64ToBytes(s){return a.toByteArray(function base64clean(s){if((s=(s=s.split("=")[0]).trim().replace(j,"")).length<2)return"";for(;s.length%4!=0;)s+="=";return s}(s))}function blitBuffer(s,o,i,a){let u;for(u=0;u<a&&!(u+i>=o.length||u>=s.length);++u)o[u+i]=s[u];return u}function isInstance(s,o){return s instanceof o||null!=s&&null!=s.constructor&&null!=s.constructor.name&&s.constructor.name===o.name}function numberIsNaN(s){return s!=s}const L=function(){const s="0123456789abcdef",o=new Array(256);for(let i=0;i<16;++i){const a=16*i;for(let u=0;u<16;++u)o[a+u]=s[i]+s[u]}return o}();function defineBigIntMethod(s){return"undefined"==typeof BigInt?BufferBigIntNotDefined:s}function BufferBigIntNotDefined(){throw new Error("BigInt not supported")}},13144(s,o,i){"use strict";var a=i(66743),u=i(11002),_=i(10076),w=i(47119);s.exports=w||a.call(_,u)},12205(s,o,i){"use strict";var a=i(66743),u=i(11002),_=i(13144);s.exports=function applyBind(){return _(a,u,arguments)}},11002(s){"use strict";s.exports=Function.prototype.apply},10076(s){"use strict";s.exports=Function.prototype.call},73126(s,o,i){"use strict";var a=i(66743),u=i(69675),_=i(10076),w=i(13144);s.exports=function callBindBasic(s){if(s.length<1||"function"!=typeof s[0])throw new u("a function is required");return w(a,_,s)}},47119(s){"use strict";s.exports="undefined"!=typeof Reflect&&Reflect&&Reflect.apply},10487(s,o,i){"use strict";var a=i(96897),u=i(30655),_=i(73126),w=i(12205);s.exports=function callBind(s){var o=_(arguments),i=s.length-(arguments.length-1);return a(o,1+(i>0?i:0),!0)},u?u(s.exports,"apply",{value:w}):s.exports.apply=w},36556(s,o,i){"use strict";var a=i(70453),u=i(73126),_=u([a("%String.prototype.indexOf%")]);s.exports=function callBoundIntrinsic(s,o){var i=a(s,!!o);return"function"==typeof i&&_(s,".prototype.")>-1?u([i]):i}},17965(s,o,i){"use strict";var a=i(16426),u={"text/plain":"Text","text/html":"Url",default:"Text"};s.exports=function copy(s,o){var i,_,w,x,C,j,L=!1;o||(o={}),i=o.debug||!1;try{if(w=a(),x=document.createRange(),C=document.getSelection(),(j=document.createElement("span")).textContent=s,j.ariaHidden="true",j.style.all="unset",j.style.position="fixed",j.style.top=0,j.style.clip="rect(0, 0, 0, 0)",j.style.whiteSpace="pre",j.style.webkitUserSelect="text",j.style.MozUserSelect="text",j.style.msUserSelect="text",j.style.userSelect="text",j.addEventListener("copy",(function(a){if(a.stopPropagation(),o.format)if(a.preventDefault(),void 0===a.clipboardData){i&&console.warn("unable to use e.clipboardData"),i&&console.warn("trying IE specific stuff"),window.clipboardData.clearData();var _=u[o.format]||u.default;window.clipboardData.setData(_,s)}else a.clipboardData.clearData(),a.clipboardData.setData(o.format,s);o.onCopy&&(a.preventDefault(),o.onCopy(a.clipboardData))})),document.body.appendChild(j),x.selectNodeContents(j),C.addRange(x),!document.execCommand("copy"))throw new Error("copy command was unsuccessful");L=!0}catch(a){i&&console.error("unable to copy using execCommand: ",a),i&&console.warn("trying IE specific stuff");try{window.clipboardData.setData(o.format||"text",s),o.onCopy&&o.onCopy(window.clipboardData),L=!0}catch(a){i&&console.error("unable to copy using clipboardData: ",a),i&&console.error("falling back to prompt"),_=function format(s){var o=(/mac os x/i.test(navigator.userAgent)?"⌘":"Ctrl")+"+C";return s.replace(/#{\s*key\s*}/g,o)}("message"in o?o.message:"Copy to clipboard: #{key}, Enter"),window.prompt(_,s)}}finally{C&&("function"==typeof C.removeRange?C.removeRange(x):C.removeAllRanges()),j&&document.body.removeChild(j),w()}return L}},2205(s,o,i){var a;a=void 0!==i.g?i.g:this,s.exports=function(s){if(s.CSS&&s.CSS.escape)return s.CSS.escape;var cssEscape=function(s){if(0==arguments.length)throw new TypeError("`CSS.escape` requires an argument.");for(var o,i=String(s),a=i.length,u=-1,_="",w=i.charCodeAt(0);++u<a;)0!=(o=i.charCodeAt(u))?_+=o>=1&&o<=31||127==o||0==u&&o>=48&&o<=57||1==u&&o>=48&&o<=57&&45==w?"\\"+o.toString(16)+" ":0==u&&1==a&&45==o||!(o>=128||45==o||95==o||o>=48&&o<=57||o>=65&&o<=90||o>=97&&o<=122)?"\\"+i.charAt(u):i.charAt(u):_+="�";return _};return s.CSS||(s.CSS={}),s.CSS.escape=cssEscape,cssEscape}(a)},81919(s,o,i){"use strict";var a=i(48287).Buffer;function isSpecificValue(s){return s instanceof a||s instanceof Date||s instanceof RegExp}function cloneSpecificValue(s){if(s instanceof a){var o=a.alloc?a.alloc(s.length):new a(s.length);return s.copy(o),o}if(s instanceof Date)return new Date(s.getTime());if(s instanceof RegExp)return new RegExp(s);throw new Error("Unexpected situation")}function deepCloneArray(s){var o=[];return s.forEach((function(s,i){"object"==typeof s&&null!==s?Array.isArray(s)?o[i]=deepCloneArray(s):isSpecificValue(s)?o[i]=cloneSpecificValue(s):o[i]=u({},s):o[i]=s})),o}function safeGetProperty(s,o){return"__proto__"===o?void 0:s[o]}var u=s.exports=function(){if(arguments.length<1||"object"!=typeof arguments[0])return!1;if(arguments.length<2)return arguments[0];var s,o,i=arguments[0];return Array.prototype.slice.call(arguments,1).forEach((function(a){"object"!=typeof a||null===a||Array.isArray(a)||Object.keys(a).forEach((function(_){return o=safeGetProperty(i,_),(s=safeGetProperty(a,_))===i?void 0:"object"!=typeof s||null===s?void(i[_]=s):Array.isArray(s)?void(i[_]=deepCloneArray(s)):isSpecificValue(s)?void(i[_]=cloneSpecificValue(s)):"object"!=typeof o||null===o||Array.isArray(o)?void(i[_]=u({},s)):void(i[_]=u(o,s))}))})),i}},14744(s){"use strict";var o=function isMergeableObject(s){return function isNonNullObject(s){return!!s&&"object"==typeof s}(s)&&!function isSpecial(s){var o=Object.prototype.toString.call(s);return"[object RegExp]"===o||"[object Date]"===o||function isReactElement(s){return s.$$typeof===i}(s)}(s)};var i="function"==typeof Symbol&&Symbol.for?Symbol.for("react.element"):60103;function cloneUnlessOtherwiseSpecified(s,o){return!1!==o.clone&&o.isMergeableObject(s)?deepmerge(function emptyTarget(s){return Array.isArray(s)?[]:{}}(s),s,o):s}function defaultArrayMerge(s,o,i){return s.concat(o).map((function(s){return cloneUnlessOtherwiseSpecified(s,i)}))}function getKeys(s){return Object.keys(s).concat(function getEnumerableOwnPropertySymbols(s){return Object.getOwnPropertySymbols?Object.getOwnPropertySymbols(s).filter((function(o){return Object.propertyIsEnumerable.call(s,o)})):[]}(s))}function propertyIsOnObject(s,o){try{return o in s}catch(s){return!1}}function mergeObject(s,o,i){var a={};return i.isMergeableObject(s)&&getKeys(s).forEach((function(o){a[o]=cloneUnlessOtherwiseSpecified(s[o],i)})),getKeys(o).forEach((function(u){(function propertyIsUnsafe(s,o){return propertyIsOnObject(s,o)&&!(Object.hasOwnProperty.call(s,o)&&Object.propertyIsEnumerable.call(s,o))})(s,u)||(propertyIsOnObject(s,u)&&i.isMergeableObject(o[u])?a[u]=function getMergeFunction(s,o){if(!o.customMerge)return deepmerge;var i=o.customMerge(s);return"function"==typeof i?i:deepmerge}(u,i)(s[u],o[u],i):a[u]=cloneUnlessOtherwiseSpecified(o[u],i))})),a}function deepmerge(s,i,a){(a=a||{}).arrayMerge=a.arrayMerge||defaultArrayMerge,a.isMergeableObject=a.isMergeableObject||o,a.cloneUnlessOtherwiseSpecified=cloneUnlessOtherwiseSpecified;var u=Array.isArray(i);return u===Array.isArray(s)?u?a.arrayMerge(s,i,a):mergeObject(s,i,a):cloneUnlessOtherwiseSpecified(i,a)}deepmerge.all=function deepmergeAll(s,o){if(!Array.isArray(s))throw new Error("first argument should be an array");return s.reduce((function(s,i){return deepmerge(s,i,o)}),{})};var a=deepmerge;s.exports=a},30041(s,o,i){"use strict";var a=i(30655),u=i(58068),_=i(69675),w=i(75795);s.exports=function defineDataProperty(s,o,i){if(!s||"object"!=typeof s&&"function"!=typeof s)throw new _("`obj` must be an object or a function`");if("string"!=typeof o&&"symbol"!=typeof o)throw new _("`property` must be a string or a symbol`");if(arguments.length>3&&"boolean"!=typeof arguments[3]&&null!==arguments[3])throw new _("`nonEnumerable`, if provided, must be a boolean or null");if(arguments.length>4&&"boolean"!=typeof arguments[4]&&null!==arguments[4])throw new _("`nonWritable`, if provided, must be a boolean or null");if(arguments.length>5&&"boolean"!=typeof arguments[5]&&null!==arguments[5])throw new _("`nonConfigurable`, if provided, must be a boolean or null");if(arguments.length>6&&"boolean"!=typeof arguments[6])throw new _("`loose`, if provided, must be a boolean");var x=arguments.length>3?arguments[3]:null,C=arguments.length>4?arguments[4]:null,j=arguments.length>5?arguments[5]:null,L=arguments.length>6&&arguments[6],B=!!w&&w(s,o);if(a)a(s,o,{configurable:null===j&&B?B.configurable:!j,enumerable:null===x&&B?B.enumerable:!x,value:i,writable:null===C&&B?B.writable:!C});else{if(!L&&(x||C||j))throw new u("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");s[o]=i}}},78004(s){"use strict";class SubRange{constructor(s,o){this.low=s,this.high=o,this.length=1+o-s}overlaps(s){return!(this.high<s.low||this.low>s.high)}touches(s){return!(this.high+1<s.low||this.low-1>s.high)}add(s){return new SubRange(Math.min(this.low,s.low),Math.max(this.high,s.high))}subtract(s){return s.low<=this.low&&s.high>=this.high?[]:s.low>this.low&&s.high<this.high?[new SubRange(this.low,s.low-1),new SubRange(s.high+1,this.high)]:s.low<=this.low?[new SubRange(s.high+1,this.high)]:[new SubRange(this.low,s.low-1)]}toString(){return this.low==this.high?this.low.toString():this.low+"-"+this.high}}class DRange{constructor(s,o){this.ranges=[],this.length=0,null!=s&&this.add(s,o)}_update_length(){this.length=this.ranges.reduce(((s,o)=>s+o.length),0)}add(s,o){var _add=s=>{for(var o=0;o<this.ranges.length&&!s.touches(this.ranges[o]);)o++;for(var i=this.ranges.slice(0,o);o<this.ranges.length&&s.touches(this.ranges[o]);)s=s.add(this.ranges[o]),o++;i.push(s),this.ranges=i.concat(this.ranges.slice(o)),this._update_length()};return s instanceof DRange?s.ranges.forEach(_add):(null==o&&(o=s),_add(new SubRange(s,o))),this}subtract(s,o){var _subtract=s=>{for(var o=0;o<this.ranges.length&&!s.overlaps(this.ranges[o]);)o++;for(var i=this.ranges.slice(0,o);o<this.ranges.length&&s.overlaps(this.ranges[o]);)i=i.concat(this.ranges[o].subtract(s)),o++;this.ranges=i.concat(this.ranges.slice(o)),this._update_length()};return s instanceof DRange?s.ranges.forEach(_subtract):(null==o&&(o=s),_subtract(new SubRange(s,o))),this}intersect(s,o){var i=[],_intersect=s=>{for(var o=0;o<this.ranges.length&&!s.overlaps(this.ranges[o]);)o++;for(;o<this.ranges.length&&s.overlaps(this.ranges[o]);){var a=Math.max(this.ranges[o].low,s.low),u=Math.min(this.ranges[o].high,s.high);i.push(new SubRange(a,u)),o++}};return s instanceof DRange?s.ranges.forEach(_intersect):(null==o&&(o=s),_intersect(new SubRange(s,o))),this.ranges=i,this._update_length(),this}index(s){for(var o=0;o<this.ranges.length&&this.ranges[o].length<=s;)s-=this.ranges[o].length,o++;return this.ranges[o].low+s}toString(){return"[ "+this.ranges.join(", ")+" ]"}clone(){return new DRange(this)}numbers(){return this.ranges.reduce(((s,o)=>{for(var i=o.low;i<=o.high;)s.push(i),i++;return s}),[])}subranges(){return this.ranges.map((s=>({low:s.low,high:s.high,length:1+s.high-s.low})))}}s.exports=DRange},7176(s,o,i){"use strict";var a,u=i(73126),_=i(75795);try{a=[].__proto__===Array.prototype}catch(s){if(!s||"object"!=typeof s||!("code"in s)||"ERR_PROTO_ACCESS"!==s.code)throw s}var w=!!a&&_&&_(Object.prototype,"__proto__"),x=Object,C=x.getPrototypeOf;s.exports=w&&"function"==typeof w.get?u([w.get]):"function"==typeof C&&function getDunder(s){return C(null==s?s:x(s))}},30655(s){"use strict";var o=Object.defineProperty||!1;if(o)try{o({},"a",{value:1})}catch(s){o=!1}s.exports=o},41237(s){"use strict";s.exports=EvalError},69383(s){"use strict";s.exports=Error},79290(s){"use strict";s.exports=RangeError},79538(s){"use strict";s.exports=ReferenceError},58068(s){"use strict";s.exports=SyntaxError},69675(s){"use strict";s.exports=TypeError},35345(s){"use strict";s.exports=URIError},79612(s){"use strict";s.exports=Object},37007(s){"use strict";var o,i="object"==typeof Reflect?Reflect:null,a=i&&"function"==typeof i.apply?i.apply:function ReflectApply(s,o,i){return Function.prototype.apply.call(s,o,i)};o=i&&"function"==typeof i.ownKeys?i.ownKeys:Object.getOwnPropertySymbols?function ReflectOwnKeys(s){return Object.getOwnPropertyNames(s).concat(Object.getOwnPropertySymbols(s))}:function ReflectOwnKeys(s){return Object.getOwnPropertyNames(s)};var u=Number.isNaN||function NumberIsNaN(s){return s!=s};function EventEmitter(){EventEmitter.init.call(this)}s.exports=EventEmitter,s.exports.once=function once(s,o){return new Promise((function(i,a){function errorListener(i){s.removeListener(o,resolver),a(i)}function resolver(){"function"==typeof s.removeListener&&s.removeListener("error",errorListener),i([].slice.call(arguments))}eventTargetAgnosticAddListener(s,o,resolver,{once:!0}),"error"!==o&&function addErrorHandlerIfEventEmitter(s,o,i){"function"==typeof s.on&&eventTargetAgnosticAddListener(s,"error",o,i)}(s,errorListener,{once:!0})}))},EventEmitter.EventEmitter=EventEmitter,EventEmitter.prototype._events=void 0,EventEmitter.prototype._eventsCount=0,EventEmitter.prototype._maxListeners=void 0;var _=10;function checkListener(s){if("function"!=typeof s)throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof s)}function _getMaxListeners(s){return void 0===s._maxListeners?EventEmitter.defaultMaxListeners:s._maxListeners}function _addListener(s,o,i,a){var u,_,w;if(checkListener(i),void 0===(_=s._events)?(_=s._events=Object.create(null),s._eventsCount=0):(void 0!==_.newListener&&(s.emit("newListener",o,i.listener?i.listener:i),_=s._events),w=_[o]),void 0===w)w=_[o]=i,++s._eventsCount;else if("function"==typeof w?w=_[o]=a?[i,w]:[w,i]:a?w.unshift(i):w.push(i),(u=_getMaxListeners(s))>0&&w.length>u&&!w.warned){w.warned=!0;var x=new Error("Possible EventEmitter memory leak detected. "+w.length+" "+String(o)+" listeners added. Use emitter.setMaxListeners() to increase limit");x.name="MaxListenersExceededWarning",x.emitter=s,x.type=o,x.count=w.length,function ProcessEmitWarning(s){console&&console.warn&&console.warn(s)}(x)}return s}function onceWrapper(){if(!this.fired)return this.target.removeListener(this.type,this.wrapFn),this.fired=!0,0===arguments.length?this.listener.call(this.target):this.listener.apply(this.target,arguments)}function _onceWrap(s,o,i){var a={fired:!1,wrapFn:void 0,target:s,type:o,listener:i},u=onceWrapper.bind(a);return u.listener=i,a.wrapFn=u,u}function _listeners(s,o,i){var a=s._events;if(void 0===a)return[];var u=a[o];return void 0===u?[]:"function"==typeof u?i?[u.listener||u]:[u]:i?function unwrapListeners(s){for(var o=new Array(s.length),i=0;i<o.length;++i)o[i]=s[i].listener||s[i];return o}(u):arrayClone(u,u.length)}function listenerCount(s){var o=this._events;if(void 0!==o){var i=o[s];if("function"==typeof i)return 1;if(void 0!==i)return i.length}return 0}function arrayClone(s,o){for(var i=new Array(o),a=0;a<o;++a)i[a]=s[a];return i}function eventTargetAgnosticAddListener(s,o,i,a){if("function"==typeof s.on)a.once?s.once(o,i):s.on(o,i);else{if("function"!=typeof s.addEventListener)throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type '+typeof s);s.addEventListener(o,(function wrapListener(u){a.once&&s.removeEventListener(o,wrapListener),i(u)}))}}Object.defineProperty(EventEmitter,"defaultMaxListeners",{enumerable:!0,get:function(){return _},set:function(s){if("number"!=typeof s||s<0||u(s))throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received '+s+".");_=s}}),EventEmitter.init=function(){void 0!==this._events&&this._events!==Object.getPrototypeOf(this)._events||(this._events=Object.create(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0},EventEmitter.prototype.setMaxListeners=function setMaxListeners(s){if("number"!=typeof s||s<0||u(s))throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received '+s+".");return this._maxListeners=s,this},EventEmitter.prototype.getMaxListeners=function getMaxListeners(){return _getMaxListeners(this)},EventEmitter.prototype.emit=function emit(s){for(var o=[],i=1;i<arguments.length;i++)o.push(arguments[i]);var u="error"===s,_=this._events;if(void 0!==_)u=u&&void 0===_.error;else if(!u)return!1;if(u){var w;if(o.length>0&&(w=o[0]),w instanceof Error)throw w;var x=new Error("Unhandled error."+(w?" ("+w.message+")":""));throw x.context=w,x}var C=_[s];if(void 0===C)return!1;if("function"==typeof C)a(C,this,o);else{var j=C.length,L=arrayClone(C,j);for(i=0;i<j;++i)a(L[i],this,o)}return!0},EventEmitter.prototype.addListener=function addListener(s,o){return _addListener(this,s,o,!1)},EventEmitter.prototype.on=EventEmitter.prototype.addListener,EventEmitter.prototype.prependListener=function prependListener(s,o){return _addListener(this,s,o,!0)},EventEmitter.prototype.once=function once(s,o){return checkListener(o),this.on(s,_onceWrap(this,s,o)),this},EventEmitter.prototype.prependOnceListener=function prependOnceListener(s,o){return checkListener(o),this.prependListener(s,_onceWrap(this,s,o)),this},EventEmitter.prototype.removeListener=function removeListener(s,o){var i,a,u,_,w;if(checkListener(o),void 0===(a=this._events))return this;if(void 0===(i=a[s]))return this;if(i===o||i.listener===o)0==--this._eventsCount?this._events=Object.create(null):(delete a[s],a.removeListener&&this.emit("removeListener",s,i.listener||o));else if("function"!=typeof i){for(u=-1,_=i.length-1;_>=0;_--)if(i[_]===o||i[_].listener===o){w=i[_].listener,u=_;break}if(u<0)return this;0===u?i.shift():function spliceOne(s,o){for(;o+1<s.length;o++)s[o]=s[o+1];s.pop()}(i,u),1===i.length&&(a[s]=i[0]),void 0!==a.removeListener&&this.emit("removeListener",s,w||o)}return this},EventEmitter.prototype.off=EventEmitter.prototype.removeListener,EventEmitter.prototype.removeAllListeners=function removeAllListeners(s){var o,i,a;if(void 0===(i=this._events))return this;if(void 0===i.removeListener)return 0===arguments.length?(this._events=Object.create(null),this._eventsCount=0):void 0!==i[s]&&(0==--this._eventsCount?this._events=Object.create(null):delete i[s]),this;if(0===arguments.length){var u,_=Object.keys(i);for(a=0;a<_.length;++a)"removeListener"!==(u=_[a])&&this.removeAllListeners(u);return this.removeAllListeners("removeListener"),this._events=Object.create(null),this._eventsCount=0,this}if("function"==typeof(o=i[s]))this.removeListener(s,o);else if(void 0!==o)for(a=o.length-1;a>=0;a--)this.removeListener(s,o[a]);return this},EventEmitter.prototype.listeners=function listeners(s){return _listeners(this,s,!0)},EventEmitter.prototype.rawListeners=function rawListeners(s){return _listeners(this,s,!1)},EventEmitter.listenerCount=function(s,o){return"function"==typeof s.listenerCount?s.listenerCount(o):listenerCount.call(s,o)},EventEmitter.prototype.listenerCount=listenerCount,EventEmitter.prototype.eventNames=function eventNames(){return this._eventsCount>0?o(this._events):[]}},85587(s,o,i){"use strict";var a=i(26311),u=create(Error);function create(s){return FormattedError.displayName=s.displayName||s.name,FormattedError;function FormattedError(o){return o&&(o=a.apply(null,arguments)),new s(o)}}s.exports=u,u.eval=create(EvalError),u.range=create(RangeError),u.reference=create(ReferenceError),u.syntax=create(SyntaxError),u.type=create(TypeError),u.uri=create(URIError),u.create=create},82682(s,o,i){"use strict";var a=i(69600),u=Object.prototype.toString,_=Object.prototype.hasOwnProperty;s.exports=function forEach(s,o,i){if(!a(o))throw new TypeError("iterator must be a function");var w;arguments.length>=3&&(w=i),function isArray(s){return"[object Array]"===u.call(s)}(s)?function forEachArray(s,o,i){for(var a=0,u=s.length;a<u;a++)_.call(s,a)&&(null==i?o(s[a],a,s):o.call(i,s[a],a,s))}(s,o,w):"string"==typeof s?function forEachString(s,o,i){for(var a=0,u=s.length;a<u;a++)null==i?o(s.charAt(a),a,s):o.call(i,s.charAt(a),a,s)}(s,o,w):function forEachObject(s,o,i){for(var a in s)_.call(s,a)&&(null==i?o(s[a],a,s):o.call(i,s[a],a,s))}(s,o,w)}},26311(s){!function(){var o;function format(s){for(var o,i,a,u,_=1,w=[].slice.call(arguments),x=0,C=s.length,j="",L=!1,B=!1,nextArg=function(){return w[_++]},slurpNumber=function(){for(var i="";/\d/.test(s[x]);)i+=s[x++],o=s[x];return i.length>0?parseInt(i):null};x<C;++x)if(o=s[x],L)switch(L=!1,"."==o?(B=!1,o=s[++x]):"0"==o&&"."==s[x+1]?(B=!0,o=s[x+=2]):B=!0,u=slurpNumber(),o){case"b":j+=parseInt(nextArg(),10).toString(2);break;case"c":j+="string"==typeof(i=nextArg())||i instanceof String?i:String.fromCharCode(parseInt(i,10));break;case"d":j+=parseInt(nextArg(),10);break;case"f":a=String(parseFloat(nextArg()).toFixed(u||6)),j+=B?a:a.replace(/^0/,"");break;case"j":j+=JSON.stringify(nextArg());break;case"o":j+="0"+parseInt(nextArg(),10).toString(8);break;case"s":j+=nextArg();break;case"x":j+="0x"+parseInt(nextArg(),10).toString(16);break;case"X":j+="0x"+parseInt(nextArg(),10).toString(16).toUpperCase();break;default:j+=o}else"%"===o?L=!0:j+=o;return j}(o=s.exports=format).format=format,o.vsprintf=function vsprintf(s,o){return format.apply(null,[s].concat(o))},"undefined"!=typeof console&&"function"==typeof console.log&&(o.printf=function printf(){console.log(format.apply(null,arguments))})}()},89353(s){"use strict";var o=Object.prototype.toString,i=Math.max,a=function concatty(s,o){for(var i=[],a=0;a<s.length;a+=1)i[a]=s[a];for(var u=0;u<o.length;u+=1)i[u+s.length]=o[u];return i};s.exports=function bind(s){var u=this;if("function"!=typeof u||"[object Function]"!==o.apply(u))throw new TypeError("Function.prototype.bind called on incompatible "+u);for(var _,w=function slicy(s,o){for(var i=[],a=o||0,u=0;a<s.length;a+=1,u+=1)i[u]=s[a];return i}(arguments,1),x=i(0,u.length-w.length),C=[],j=0;j<x;j++)C[j]="$"+j;if(_=Function("binder","return function ("+function(s,o){for(var i="",a=0;a<s.length;a+=1)i+=s[a],a+1<s.length&&(i+=o);return i}(C,",")+"){ return binder.apply(this,arguments); }")((function(){if(this instanceof _){var o=u.apply(this,a(w,arguments));return Object(o)===o?o:this}return u.apply(s,a(w,arguments))})),u.prototype){var L=function Empty(){};L.prototype=u.prototype,_.prototype=new L,L.prototype=null}return _}},66743(s,o,i){"use strict";var a=i(89353);s.exports=Function.prototype.bind||a},70453(s,o,i){"use strict";var a,u=i(79612),_=i(69383),w=i(41237),x=i(79290),C=i(79538),j=i(58068),L=i(69675),B=i(35345),$=i(71514),U=i(58968),V=i(6188),z=i(68002),Y=i(75880),Z=i(70414),ee=i(73093),ie=Function,getEvalledConstructor=function(s){try{return ie('"use strict"; return ('+s+").constructor;")()}catch(s){}},ae=i(75795),ce=i(30655),throwTypeError=function(){throw new L},le=ae?function(){try{return throwTypeError}catch(s){try{return ae(arguments,"callee").get}catch(s){return throwTypeError}}}():throwTypeError,pe=i(64039)(),de=i(93628),fe=i(71064),ye=i(48648),be=i(11002),Se=i(10076),_e={},we="undefined"!=typeof Uint8Array&&de?de(Uint8Array):a,xe={__proto__:null,"%AggregateError%":"undefined"==typeof AggregateError?a:AggregateError,"%Array%":Array,"%ArrayBuffer%":"undefined"==typeof ArrayBuffer?a:ArrayBuffer,"%ArrayIteratorPrototype%":pe&&de?de([][Symbol.iterator]()):a,"%AsyncFromSyncIteratorPrototype%":a,"%AsyncFunction%":_e,"%AsyncGenerator%":_e,"%AsyncGeneratorFunction%":_e,"%AsyncIteratorPrototype%":_e,"%Atomics%":"undefined"==typeof Atomics?a:Atomics,"%BigInt%":"undefined"==typeof BigInt?a:BigInt,"%BigInt64Array%":"undefined"==typeof BigInt64Array?a:BigInt64Array,"%BigUint64Array%":"undefined"==typeof BigUint64Array?a:BigUint64Array,"%Boolean%":Boolean,"%DataView%":"undefined"==typeof DataView?a:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":_,"%eval%":eval,"%EvalError%":w,"%Float32Array%":"undefined"==typeof Float32Array?a:Float32Array,"%Float64Array%":"undefined"==typeof Float64Array?a:Float64Array,"%FinalizationRegistry%":"undefined"==typeof FinalizationRegistry?a:FinalizationRegistry,"%Function%":ie,"%GeneratorFunction%":_e,"%Int8Array%":"undefined"==typeof Int8Array?a:Int8Array,"%Int16Array%":"undefined"==typeof Int16Array?a:Int16Array,"%Int32Array%":"undefined"==typeof Int32Array?a:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":pe&&de?de(de([][Symbol.iterator]())):a,"%JSON%":"object"==typeof JSON?JSON:a,"%Map%":"undefined"==typeof Map?a:Map,"%MapIteratorPrototype%":"undefined"!=typeof Map&&pe&&de?de((new Map)[Symbol.iterator]()):a,"%Math%":Math,"%Number%":Number,"%Object%":u,"%Object.getOwnPropertyDescriptor%":ae,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":"undefined"==typeof Promise?a:Promise,"%Proxy%":"undefined"==typeof Proxy?a:Proxy,"%RangeError%":x,"%ReferenceError%":C,"%Reflect%":"undefined"==typeof Reflect?a:Reflect,"%RegExp%":RegExp,"%Set%":"undefined"==typeof Set?a:Set,"%SetIteratorPrototype%":"undefined"!=typeof Set&&pe&&de?de((new Set)[Symbol.iterator]()):a,"%SharedArrayBuffer%":"undefined"==typeof SharedArrayBuffer?a:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":pe&&de?de(""[Symbol.iterator]()):a,"%Symbol%":pe?Symbol:a,"%SyntaxError%":j,"%ThrowTypeError%":le,"%TypedArray%":we,"%TypeError%":L,"%Uint8Array%":"undefined"==typeof Uint8Array?a:Uint8Array,"%Uint8ClampedArray%":"undefined"==typeof Uint8ClampedArray?a:Uint8ClampedArray,"%Uint16Array%":"undefined"==typeof Uint16Array?a:Uint16Array,"%Uint32Array%":"undefined"==typeof Uint32Array?a:Uint32Array,"%URIError%":B,"%WeakMap%":"undefined"==typeof WeakMap?a:WeakMap,"%WeakRef%":"undefined"==typeof WeakRef?a:WeakRef,"%WeakSet%":"undefined"==typeof WeakSet?a:WeakSet,"%Function.prototype.call%":Se,"%Function.prototype.apply%":be,"%Object.defineProperty%":ce,"%Object.getPrototypeOf%":fe,"%Math.abs%":$,"%Math.floor%":U,"%Math.max%":V,"%Math.min%":z,"%Math.pow%":Y,"%Math.round%":Z,"%Math.sign%":ee,"%Reflect.getPrototypeOf%":ye};if(de)try{null.error}catch(s){var Pe=de(de(s));xe["%Error.prototype%"]=Pe}var Te=function doEval(s){var o;if("%AsyncFunction%"===s)o=getEvalledConstructor("async function () {}");else if("%GeneratorFunction%"===s)o=getEvalledConstructor("function* () {}");else if("%AsyncGeneratorFunction%"===s)o=getEvalledConstructor("async function* () {}");else if("%AsyncGenerator%"===s){var i=doEval("%AsyncGeneratorFunction%");i&&(o=i.prototype)}else if("%AsyncIteratorPrototype%"===s){var a=doEval("%AsyncGenerator%");a&&de&&(o=de(a.prototype))}return xe[s]=o,o},Re={__proto__:null,"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]},$e=i(66743),qe=i(9957),ze=$e.call(Se,Array.prototype.concat),We=$e.call(be,Array.prototype.splice),He=$e.call(Se,String.prototype.replace),Ye=$e.call(Se,String.prototype.slice),Xe=$e.call(Se,RegExp.prototype.exec),Qe=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,et=/\\(\\)?/g,tt=function getBaseIntrinsic(s,o){var i,a=s;if(qe(Re,a)&&(a="%"+(i=Re[a])[0]+"%"),qe(xe,a)){var u=xe[a];if(u===_e&&(u=Te(a)),void 0===u&&!o)throw new L("intrinsic "+s+" exists, but is not available. Please file an issue!");return{alias:i,name:a,value:u}}throw new j("intrinsic "+s+" does not exist!")};s.exports=function GetIntrinsic(s,o){if("string"!=typeof s||0===s.length)throw new L("intrinsic name must be a non-empty string");if(arguments.length>1&&"boolean"!=typeof o)throw new L('"allowMissing" argument must be a boolean');if(null===Xe(/^%?[^%]*%?$/,s))throw new j("`%` may not be present anywhere but at the beginning and end of the intrinsic name");var i=function stringToPath(s){var o=Ye(s,0,1),i=Ye(s,-1);if("%"===o&&"%"!==i)throw new j("invalid intrinsic syntax, expected closing `%`");if("%"===i&&"%"!==o)throw new j("invalid intrinsic syntax, expected opening `%`");var a=[];return He(s,Qe,(function(s,o,i,u){a[a.length]=i?He(u,et,"$1"):o||s})),a}(s),a=i.length>0?i[0]:"",u=tt("%"+a+"%",o),_=u.name,w=u.value,x=!1,C=u.alias;C&&(a=C[0],We(i,ze([0,1],C)));for(var B=1,$=!0;B<i.length;B+=1){var U=i[B],V=Ye(U,0,1),z=Ye(U,-1);if(('"'===V||"'"===V||"`"===V||'"'===z||"'"===z||"`"===z)&&V!==z)throw new j("property names with quotes must have matching quotes");if("constructor"!==U&&$||(x=!0),qe(xe,_="%"+(a+="."+U)+"%"))w=xe[_];else if(null!=w){if(!(U in w)){if(!o)throw new L("base intrinsic for "+s+" exists, but the property is not available.");return}if(ae&&B+1>=i.length){var Y=ae(w,U);w=($=!!Y)&&"get"in Y&&!("originalValue"in Y.get)?Y.get:w[U]}else $=qe(w,U),w=w[U];$&&!x&&(xe[_]=w)}}return w}},71064(s,o,i){"use strict";var a=i(79612);s.exports=a.getPrototypeOf||null},48648(s){"use strict";s.exports="undefined"!=typeof Reflect&&Reflect.getPrototypeOf||null},93628(s,o,i){"use strict";var a=i(48648),u=i(71064),_=i(7176);s.exports=a?function getProto(s){return a(s)}:u?function getProto(s){if(!s||"object"!=typeof s&&"function"!=typeof s)throw new TypeError("getProto: not an object");return u(s)}:_?function getProto(s){return _(s)}:null},6549(s){"use strict";s.exports=Object.getOwnPropertyDescriptor},75795(s,o,i){"use strict";var a=i(6549);if(a)try{a([],"length")}catch(s){a=null}s.exports=a},30592(s,o,i){"use strict";var a=i(30655),u=function hasPropertyDescriptors(){return!!a};u.hasArrayLengthDefineBug=function hasArrayLengthDefineBug(){if(!a)return null;try{return 1!==a([],"length",{value:1}).length}catch(s){return!0}},s.exports=u},64039(s,o,i){"use strict";var a="undefined"!=typeof Symbol&&Symbol,u=i(41333);s.exports=function hasNativeSymbols(){return"function"==typeof a&&("function"==typeof Symbol&&("symbol"==typeof a("foo")&&("symbol"==typeof Symbol("bar")&&u())))}},41333(s){"use strict";s.exports=function hasSymbols(){if("function"!=typeof Symbol||"function"!=typeof Object.getOwnPropertySymbols)return!1;if("symbol"==typeof Symbol.iterator)return!0;var s={},o=Symbol("test"),i=Object(o);if("string"==typeof o)return!1;if("[object Symbol]"!==Object.prototype.toString.call(o))return!1;if("[object Symbol]"!==Object.prototype.toString.call(i))return!1;for(var a in s[o]=42,s)return!1;if("function"==typeof Object.keys&&0!==Object.keys(s).length)return!1;if("function"==typeof Object.getOwnPropertyNames&&0!==Object.getOwnPropertyNames(s).length)return!1;var u=Object.getOwnPropertySymbols(s);if(1!==u.length||u[0]!==o)return!1;if(!Object.prototype.propertyIsEnumerable.call(s,o))return!1;if("function"==typeof Object.getOwnPropertyDescriptor){var _=Object.getOwnPropertyDescriptor(s,o);if(42!==_.value||!0!==_.enumerable)return!1}return!0}},49092(s,o,i){"use strict";var a=i(41333);s.exports=function hasToStringTagShams(){return a()&&!!Symbol.toStringTag}},9957(s,o,i){"use strict";var a=Function.prototype.call,u=Object.prototype.hasOwnProperty,_=i(66743);s.exports=_.call(a,u)},45981(s){function deepFreeze(s){return s instanceof Map?s.clear=s.delete=s.set=function(){throw new Error("map is read-only")}:s instanceof Set&&(s.add=s.clear=s.delete=function(){throw new Error("set is read-only")}),Object.freeze(s),Object.getOwnPropertyNames(s).forEach((function(o){var i=s[o];"object"!=typeof i||Object.isFrozen(i)||deepFreeze(i)})),s}var o=deepFreeze,i=deepFreeze;o.default=i;class Response{constructor(s){void 0===s.data&&(s.data={}),this.data=s.data,this.isMatchIgnored=!1}ignoreMatch(){this.isMatchIgnored=!0}}function escapeHTML(s){return s.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;")}function inherit(s,...o){const i=Object.create(null);for(const o in s)i[o]=s[o];return o.forEach((function(s){for(const o in s)i[o]=s[o]})),i}const emitsWrappingTags=s=>!!s.kind;class HTMLRenderer{constructor(s,o){this.buffer="",this.classPrefix=o.classPrefix,s.walk(this)}addText(s){this.buffer+=escapeHTML(s)}openNode(s){if(!emitsWrappingTags(s))return;let o=s.kind;s.sublanguage||(o=`${this.classPrefix}${o}`),this.span(o)}closeNode(s){emitsWrappingTags(s)&&(this.buffer+="</span>")}value(){return this.buffer}span(s){this.buffer+=`<span class="${s}">`}}class TokenTree{constructor(){this.rootNode={children:[]},this.stack=[this.rootNode]}get top(){return this.stack[this.stack.length-1]}get root(){return this.rootNode}add(s){this.top.children.push(s)}openNode(s){const o={kind:s,children:[]};this.add(o),this.stack.push(o)}closeNode(){if(this.stack.length>1)return this.stack.pop()}closeAllNodes(){for(;this.closeNode(););}toJSON(){return JSON.stringify(this.rootNode,null,4)}walk(s){return this.constructor._walk(s,this.rootNode)}static _walk(s,o){return"string"==typeof o?s.addText(o):o.children&&(s.openNode(o),o.children.forEach((o=>this._walk(s,o))),s.closeNode(o)),s}static _collapse(s){"string"!=typeof s&&s.children&&(s.children.every((s=>"string"==typeof s))?s.children=[s.children.join("")]:s.children.forEach((s=>{TokenTree._collapse(s)})))}}class TokenTreeEmitter extends TokenTree{constructor(s){super(),this.options=s}addKeyword(s,o){""!==s&&(this.openNode(o),this.addText(s),this.closeNode())}addText(s){""!==s&&this.add(s)}addSublanguage(s,o){const i=s.root;i.kind=o,i.sublanguage=!0,this.add(i)}toHTML(){return new HTMLRenderer(this,this.options).value()}finalize(){return!0}}function source(s){return s?"string"==typeof s?s:s.source:null}const a=/\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;const u="[a-zA-Z]\\w*",_="[a-zA-Z_]\\w*",w="\\b\\d+(\\.\\d+)?",x="(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)",C="\\b(0b[01]+)",j={begin:"\\\\[\\s\\S]",relevance:0},L={className:"string",begin:"'",end:"'",illegal:"\\n",contains:[j]},B={className:"string",begin:'"',end:'"',illegal:"\\n",contains:[j]},$={begin:/\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/},COMMENT=function(s,o,i={}){const a=inherit({className:"comment",begin:s,end:o,contains:[]},i);return a.contains.push($),a.contains.push({className:"doctag",begin:"(?:TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):",relevance:0}),a},U=COMMENT("//","$"),V=COMMENT("/\\*","\\*/"),z=COMMENT("#","$"),Y={className:"number",begin:w,relevance:0},Z={className:"number",begin:x,relevance:0},ee={className:"number",begin:C,relevance:0},ie={className:"number",begin:w+"(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",relevance:0},ae={begin:/(?=\/[^/\n]*\/)/,contains:[{className:"regexp",begin:/\//,end:/\/[gimuy]*/,illegal:/\n/,contains:[j,{begin:/\[/,end:/\]/,relevance:0,contains:[j]}]}]},ce={className:"title",begin:u,relevance:0},le={className:"title",begin:_,relevance:0},pe={begin:"\\.\\s*"+_,relevance:0};var de=Object.freeze({__proto__:null,MATCH_NOTHING_RE:/\b\B/,IDENT_RE:u,UNDERSCORE_IDENT_RE:_,NUMBER_RE:w,C_NUMBER_RE:x,BINARY_NUMBER_RE:C,RE_STARTERS_RE:"!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~",SHEBANG:(s={})=>{const o=/^#![ ]*\//;return s.binary&&(s.begin=function concat(...s){return s.map((s=>source(s))).join("")}(o,/.*\b/,s.binary,/\b.*/)),inherit({className:"meta",begin:o,end:/$/,relevance:0,"on:begin":(s,o)=>{0!==s.index&&o.ignoreMatch()}},s)},BACKSLASH_ESCAPE:j,APOS_STRING_MODE:L,QUOTE_STRING_MODE:B,PHRASAL_WORDS_MODE:$,COMMENT,C_LINE_COMMENT_MODE:U,C_BLOCK_COMMENT_MODE:V,HASH_COMMENT_MODE:z,NUMBER_MODE:Y,C_NUMBER_MODE:Z,BINARY_NUMBER_MODE:ee,CSS_NUMBER_MODE:ie,REGEXP_MODE:ae,TITLE_MODE:ce,UNDERSCORE_TITLE_MODE:le,METHOD_GUARD:pe,END_SAME_AS_BEGIN:function(s){return Object.assign(s,{"on:begin":(s,o)=>{o.data._beginMatch=s[1]},"on:end":(s,o)=>{o.data._beginMatch!==s[1]&&o.ignoreMatch()}})}});function skipIfhasPrecedingDot(s,o){"."===s.input[s.index-1]&&o.ignoreMatch()}function beginKeywords(s,o){o&&s.beginKeywords&&(s.begin="\\b("+s.beginKeywords.split(" ").join("|")+")(?!\\.)(?=\\b|\\s)",s.__beforeBegin=skipIfhasPrecedingDot,s.keywords=s.keywords||s.beginKeywords,delete s.beginKeywords,void 0===s.relevance&&(s.relevance=0))}function compileIllegal(s,o){Array.isArray(s.illegal)&&(s.illegal=function either(...s){return"("+s.map((s=>source(s))).join("|")+")"}(...s.illegal))}function compileMatch(s,o){if(s.match){if(s.begin||s.end)throw new Error("begin & end are not supported with match");s.begin=s.match,delete s.match}}function compileRelevance(s,o){void 0===s.relevance&&(s.relevance=1)}const fe=["of","and","for","in","not","or","if","then","parent","list","value"];function compileKeywords(s,o,i="keyword"){const a={};return"string"==typeof s?compileList(i,s.split(" ")):Array.isArray(s)?compileList(i,s):Object.keys(s).forEach((function(i){Object.assign(a,compileKeywords(s[i],o,i))})),a;function compileList(s,i){o&&(i=i.map((s=>s.toLowerCase()))),i.forEach((function(o){const i=o.split("|");a[i[0]]=[s,scoreForKeyword(i[0],i[1])]}))}}function scoreForKeyword(s,o){return o?Number(o):function commonKeyword(s){return fe.includes(s.toLowerCase())}(s)?0:1}function compileLanguage(s,{plugins:o}){function langRe(o,i){return new RegExp(source(o),"m"+(s.case_insensitive?"i":"")+(i?"g":""))}class MultiRegex{constructor(){this.matchIndexes={},this.regexes=[],this.matchAt=1,this.position=0}addRule(s,o){o.position=this.position++,this.matchIndexes[this.matchAt]=o,this.regexes.push([o,s]),this.matchAt+=function countMatchGroups(s){return new RegExp(s.toString()+"|").exec("").length-1}(s)+1}compile(){0===this.regexes.length&&(this.exec=()=>null);const s=this.regexes.map((s=>s[1]));this.matcherRe=langRe(function join(s,o="|"){let i=0;return s.map((s=>{i+=1;const o=i;let u=source(s),_="";for(;u.length>0;){const s=a.exec(u);if(!s){_+=u;break}_+=u.substring(0,s.index),u=u.substring(s.index+s[0].length),"\\"===s[0][0]&&s[1]?_+="\\"+String(Number(s[1])+o):(_+=s[0],"("===s[0]&&i++)}return _})).map((s=>`(${s})`)).join(o)}(s),!0),this.lastIndex=0}exec(s){this.matcherRe.lastIndex=this.lastIndex;const o=this.matcherRe.exec(s);if(!o)return null;const i=o.findIndex(((s,o)=>o>0&&void 0!==s)),a=this.matchIndexes[i];return o.splice(0,i),Object.assign(o,a)}}class ResumableMultiRegex{constructor(){this.rules=[],this.multiRegexes=[],this.count=0,this.lastIndex=0,this.regexIndex=0}getMatcher(s){if(this.multiRegexes[s])return this.multiRegexes[s];const o=new MultiRegex;return this.rules.slice(s).forEach((([s,i])=>o.addRule(s,i))),o.compile(),this.multiRegexes[s]=o,o}resumingScanAtSamePosition(){return 0!==this.regexIndex}considerAll(){this.regexIndex=0}addRule(s,o){this.rules.push([s,o]),"begin"===o.type&&this.count++}exec(s){const o=this.getMatcher(this.regexIndex);o.lastIndex=this.lastIndex;let i=o.exec(s);if(this.resumingScanAtSamePosition())if(i&&i.index===this.lastIndex);else{const o=this.getMatcher(0);o.lastIndex=this.lastIndex+1,i=o.exec(s)}return i&&(this.regexIndex+=i.position+1,this.regexIndex===this.count&&this.considerAll()),i}}if(s.compilerExtensions||(s.compilerExtensions=[]),s.contains&&s.contains.includes("self"))throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");return s.classNameAliases=inherit(s.classNameAliases||{}),function compileMode(o,i){const a=o;if(o.isCompiled)return a;[compileMatch].forEach((s=>s(o,i))),s.compilerExtensions.forEach((s=>s(o,i))),o.__beforeBegin=null,[beginKeywords,compileIllegal,compileRelevance].forEach((s=>s(o,i))),o.isCompiled=!0;let u=null;if("object"==typeof o.keywords&&(u=o.keywords.$pattern,delete o.keywords.$pattern),o.keywords&&(o.keywords=compileKeywords(o.keywords,s.case_insensitive)),o.lexemes&&u)throw new Error("ERR: Prefer `keywords.$pattern` to `mode.lexemes`, BOTH are not allowed. (see mode reference) ");return u=u||o.lexemes||/\w+/,a.keywordPatternRe=langRe(u,!0),i&&(o.begin||(o.begin=/\B|\b/),a.beginRe=langRe(o.begin),o.endSameAsBegin&&(o.end=o.begin),o.end||o.endsWithParent||(o.end=/\B|\b/),o.end&&(a.endRe=langRe(o.end)),a.terminatorEnd=source(o.end)||"",o.endsWithParent&&i.terminatorEnd&&(a.terminatorEnd+=(o.end?"|":"")+i.terminatorEnd)),o.illegal&&(a.illegalRe=langRe(o.illegal)),o.contains||(o.contains=[]),o.contains=[].concat(...o.contains.map((function(s){return function expandOrCloneMode(s){s.variants&&!s.cachedVariants&&(s.cachedVariants=s.variants.map((function(o){return inherit(s,{variants:null},o)})));if(s.cachedVariants)return s.cachedVariants;if(dependencyOnParent(s))return inherit(s,{starts:s.starts?inherit(s.starts):null});if(Object.isFrozen(s))return inherit(s);return s}("self"===s?o:s)}))),o.contains.forEach((function(s){compileMode(s,a)})),o.starts&&compileMode(o.starts,i),a.matcher=function buildModeRegex(s){const o=new ResumableMultiRegex;return s.contains.forEach((s=>o.addRule(s.begin,{rule:s,type:"begin"}))),s.terminatorEnd&&o.addRule(s.terminatorEnd,{type:"end"}),s.illegal&&o.addRule(s.illegal,{type:"illegal"}),o}(a),a}(s)}function dependencyOnParent(s){return!!s&&(s.endsWithParent||dependencyOnParent(s.starts))}function BuildVuePlugin(s){const o={props:["language","code","autodetect"],data:function(){return{detectedLanguage:"",unknownLanguage:!1}},computed:{className(){return this.unknownLanguage?"":"hljs "+this.detectedLanguage},highlighted(){if(!this.autoDetect&&!s.getLanguage(this.language))return console.warn(`The language "${this.language}" you specified could not be found.`),this.unknownLanguage=!0,escapeHTML(this.code);let o={};return this.autoDetect?(o=s.highlightAuto(this.code),this.detectedLanguage=o.language):(o=s.highlight(this.language,this.code,this.ignoreIllegals),this.detectedLanguage=this.language),o.value},autoDetect(){return!this.language||function hasValueOrEmptyAttribute(s){return Boolean(s||""===s)}(this.autodetect)},ignoreIllegals:()=>!0},render(s){return s("pre",{},[s("code",{class:this.className,domProps:{innerHTML:this.highlighted}})])}};return{Component:o,VuePlugin:{install(s){s.component("highlightjs",o)}}}}const ye={"after:highlightElement":({el:s,result:o,text:i})=>{const a=nodeStream(s);if(!a.length)return;const u=document.createElement("div");u.innerHTML=o.value,o.value=function mergeStreams(s,o,i){let a=0,u="";const _=[];function selectStream(){return s.length&&o.length?s[0].offset!==o[0].offset?s[0].offset<o[0].offset?s:o:"start"===o[0].event?s:o:s.length?s:o}function open(s){function attributeString(s){return" "+s.nodeName+'="'+escapeHTML(s.value)+'"'}u+="<"+tag(s)+[].map.call(s.attributes,attributeString).join("")+">"}function close(s){u+="</"+tag(s)+">"}function render(s){("start"===s.event?open:close)(s.node)}for(;s.length||o.length;){let o=selectStream();if(u+=escapeHTML(i.substring(a,o[0].offset)),a=o[0].offset,o===s){_.reverse().forEach(close);do{render(o.splice(0,1)[0]),o=selectStream()}while(o===s&&o.length&&o[0].offset===a);_.reverse().forEach(open)}else"start"===o[0].event?_.push(o[0].node):_.pop(),render(o.splice(0,1)[0])}return u+escapeHTML(i.substr(a))}(a,nodeStream(u),i)}};function tag(s){return s.nodeName.toLowerCase()}function nodeStream(s){const o=[];return function _nodeStream(s,i){for(let a=s.firstChild;a;a=a.nextSibling)3===a.nodeType?i+=a.nodeValue.length:1===a.nodeType&&(o.push({event:"start",offset:i,node:a}),i=_nodeStream(a,i),tag(a).match(/br|hr|img|input/)||o.push({event:"stop",offset:i,node:a}));return i}(s,0),o}const be={},error=s=>{console.error(s)},warn=(s,...o)=>{console.log(`WARN: ${s}`,...o)},deprecated=(s,o)=>{be[`${s}/${o}`]||(console.log(`Deprecated as of ${s}. ${o}`),be[`${s}/${o}`]=!0)},Se=escapeHTML,_e=inherit,we=Symbol("nomatch");var xe=function(s){const i=Object.create(null),a=Object.create(null),u=[];let _=!0;const w=/(^(<[^>]+>|\t|)+|\n)/gm,x="Could not find the language '{}', did you forget to load/include a language module?",C={disableAutodetect:!0,name:"Plain text",contains:[]};let j={noHighlightRe:/^(no-?highlight)$/i,languageDetectRe:/\blang(?:uage)?-([\w-]+)\b/i,classPrefix:"hljs-",tabReplace:null,useBR:!1,languages:null,__emitter:TokenTreeEmitter};function shouldNotHighlight(s){return j.noHighlightRe.test(s)}function highlight(s,o,i,a){let u="",_="";"object"==typeof o?(u=s,i=o.ignoreIllegals,_=o.language,a=void 0):(deprecated("10.7.0","highlight(lang, code, ...args) has been deprecated."),deprecated("10.7.0","Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277"),_=s,u=o);const w={code:u,language:_};fire("before:highlight",w);const x=w.result?w.result:_highlight(w.language,w.code,i,a);return x.code=w.code,fire("after:highlight",x),x}function _highlight(s,o,a,w){function keywordData(s,o){const i=L.case_insensitive?o[0].toLowerCase():o[0];return Object.prototype.hasOwnProperty.call(s.keywords,i)&&s.keywords[i]}function processBuffer(){null!=U.subLanguage?function processSubLanguage(){if(""===Y)return;let s=null;if("string"==typeof U.subLanguage){if(!i[U.subLanguage])return void z.addText(Y);s=_highlight(U.subLanguage,Y,!0,V[U.subLanguage]),V[U.subLanguage]=s.top}else s=highlightAuto(Y,U.subLanguage.length?U.subLanguage:null);U.relevance>0&&(Z+=s.relevance),z.addSublanguage(s.emitter,s.language)}():function processKeywords(){if(!U.keywords)return void z.addText(Y);let s=0;U.keywordPatternRe.lastIndex=0;let o=U.keywordPatternRe.exec(Y),i="";for(;o;){i+=Y.substring(s,o.index);const a=keywordData(U,o);if(a){const[s,u]=a;if(z.addText(i),i="",Z+=u,s.startsWith("_"))i+=o[0];else{const i=L.classNameAliases[s]||s;z.addKeyword(o[0],i)}}else i+=o[0];s=U.keywordPatternRe.lastIndex,o=U.keywordPatternRe.exec(Y)}i+=Y.substr(s),z.addText(i)}(),Y=""}function startNewMode(s){return s.className&&z.openNode(L.classNameAliases[s.className]||s.className),U=Object.create(s,{parent:{value:U}}),U}function endOfMode(s,o,i){let a=function startsWith(s,o){const i=s&&s.exec(o);return i&&0===i.index}(s.endRe,i);if(a){if(s["on:end"]){const i=new Response(s);s["on:end"](o,i),i.isMatchIgnored&&(a=!1)}if(a){for(;s.endsParent&&s.parent;)s=s.parent;return s}}if(s.endsWithParent)return endOfMode(s.parent,o,i)}function doIgnore(s){return 0===U.matcher.regexIndex?(Y+=s[0],1):(ae=!0,0)}function doBeginMatch(s){const o=s[0],i=s.rule,a=new Response(i),u=[i.__beforeBegin,i["on:begin"]];for(const i of u)if(i&&(i(s,a),a.isMatchIgnored))return doIgnore(o);return i&&i.endSameAsBegin&&(i.endRe=function escape(s){return new RegExp(s.replace(/[-/\\^$*+?.()|[\]{}]/g,"\\$&"),"m")}(o)),i.skip?Y+=o:(i.excludeBegin&&(Y+=o),processBuffer(),i.returnBegin||i.excludeBegin||(Y=o)),startNewMode(i),i.returnBegin?0:o.length}function doEndMatch(s){const i=s[0],a=o.substr(s.index),u=endOfMode(U,s,a);if(!u)return we;const _=U;_.skip?Y+=i:(_.returnEnd||_.excludeEnd||(Y+=i),processBuffer(),_.excludeEnd&&(Y=i));do{U.className&&z.closeNode(),U.skip||U.subLanguage||(Z+=U.relevance),U=U.parent}while(U!==u.parent);return u.starts&&(u.endSameAsBegin&&(u.starts.endRe=u.endRe),startNewMode(u.starts)),_.returnEnd?0:i.length}let C={};function processLexeme(i,u){const w=u&&u[0];if(Y+=i,null==w)return processBuffer(),0;if("begin"===C.type&&"end"===u.type&&C.index===u.index&&""===w){if(Y+=o.slice(u.index,u.index+1),!_){const o=new Error("0 width match regex");throw o.languageName=s,o.badRule=C.rule,o}return 1}if(C=u,"begin"===u.type)return doBeginMatch(u);if("illegal"===u.type&&!a){const s=new Error('Illegal lexeme "'+w+'" for mode "'+(U.className||"<unnamed>")+'"');throw s.mode=U,s}if("end"===u.type){const s=doEndMatch(u);if(s!==we)return s}if("illegal"===u.type&&""===w)return 1;if(ie>1e5&&ie>3*u.index){throw new Error("potential infinite loop, way more iterations than matches")}return Y+=w,w.length}const L=getLanguage(s);if(!L)throw error(x.replace("{}",s)),new Error('Unknown language: "'+s+'"');const B=compileLanguage(L,{plugins:u});let $="",U=w||B;const V={},z=new j.__emitter(j);!function processContinuations(){const s=[];for(let o=U;o!==L;o=o.parent)o.className&&s.unshift(o.className);s.forEach((s=>z.openNode(s)))}();let Y="",Z=0,ee=0,ie=0,ae=!1;try{for(U.matcher.considerAll();;){ie++,ae?ae=!1:U.matcher.considerAll(),U.matcher.lastIndex=ee;const s=U.matcher.exec(o);if(!s)break;const i=processLexeme(o.substring(ee,s.index),s);ee=s.index+i}return processLexeme(o.substr(ee)),z.closeAllNodes(),z.finalize(),$=z.toHTML(),{relevance:Math.floor(Z),value:$,language:s,illegal:!1,emitter:z,top:U}}catch(i){if(i.message&&i.message.includes("Illegal"))return{illegal:!0,illegalBy:{msg:i.message,context:o.slice(ee-100,ee+100),mode:i.mode},sofar:$,relevance:0,value:Se(o),emitter:z};if(_)return{illegal:!1,relevance:0,value:Se(o),emitter:z,language:s,top:U,errorRaised:i};throw i}}function highlightAuto(s,o){o=o||j.languages||Object.keys(i);const a=function justTextHighlightResult(s){const o={relevance:0,emitter:new j.__emitter(j),value:Se(s),illegal:!1,top:C};return o.emitter.addText(s),o}(s),u=o.filter(getLanguage).filter(autoDetection).map((o=>_highlight(o,s,!1)));u.unshift(a);const _=u.sort(((s,o)=>{if(s.relevance!==o.relevance)return o.relevance-s.relevance;if(s.language&&o.language){if(getLanguage(s.language).supersetOf===o.language)return 1;if(getLanguage(o.language).supersetOf===s.language)return-1}return 0})),[w,x]=_,L=w;return L.second_best=x,L}const L={"before:highlightElement":({el:s})=>{j.useBR&&(s.innerHTML=s.innerHTML.replace(/\n/g,"").replace(/<br[ /]*>/g,"\n"))},"after:highlightElement":({result:s})=>{j.useBR&&(s.value=s.value.replace(/\n/g,"<br>"))}},B=/^(<[^>]+>|\t)+/gm,$={"after:highlightElement":({result:s})=>{j.tabReplace&&(s.value=s.value.replace(B,(s=>s.replace(/\t/g,j.tabReplace))))}};function highlightElement(s){let o=null;const i=function blockLanguage(s){let o=s.className+" ";o+=s.parentNode?s.parentNode.className:"";const i=j.languageDetectRe.exec(o);if(i){const o=getLanguage(i[1]);return o||(warn(x.replace("{}",i[1])),warn("Falling back to no-highlight mode for this block.",s)),o?i[1]:"no-highlight"}return o.split(/\s+/).find((s=>shouldNotHighlight(s)||getLanguage(s)))}(s);if(shouldNotHighlight(i))return;fire("before:highlightElement",{el:s,language:i}),o=s;const u=o.textContent,_=i?highlight(u,{language:i,ignoreIllegals:!0}):highlightAuto(u);fire("after:highlightElement",{el:s,result:_,text:u}),s.innerHTML=_.value,function updateClassName(s,o,i){const u=o?a[o]:i;s.classList.add("hljs"),u&&s.classList.add(u)}(s,i,_.language),s.result={language:_.language,re:_.relevance,relavance:_.relevance},_.second_best&&(s.second_best={language:_.second_best.language,re:_.second_best.relevance,relavance:_.second_best.relevance})}const initHighlighting=()=>{if(initHighlighting.called)return;initHighlighting.called=!0,deprecated("10.6.0","initHighlighting() is deprecated.  Use highlightAll() instead.");document.querySelectorAll("pre code").forEach(highlightElement)};let U=!1;function highlightAll(){if("loading"===document.readyState)return void(U=!0);document.querySelectorAll("pre code").forEach(highlightElement)}function getLanguage(s){return s=(s||"").toLowerCase(),i[s]||i[a[s]]}function registerAliases(s,{languageName:o}){"string"==typeof s&&(s=[s]),s.forEach((s=>{a[s.toLowerCase()]=o}))}function autoDetection(s){const o=getLanguage(s);return o&&!o.disableAutodetect}function fire(s,o){const i=s;u.forEach((function(s){s[i]&&s[i](o)}))}"undefined"!=typeof window&&window.addEventListener&&window.addEventListener("DOMContentLoaded",(function boot(){U&&highlightAll()}),!1),Object.assign(s,{highlight,highlightAuto,highlightAll,fixMarkup:function deprecateFixMarkup(s){return deprecated("10.2.0","fixMarkup will be removed entirely in v11.0"),deprecated("10.2.0","Please see https://github.com/highlightjs/highlight.js/issues/2534"),function fixMarkup(s){return j.tabReplace||j.useBR?s.replace(w,(s=>"\n"===s?j.useBR?"<br>":s:j.tabReplace?s.replace(/\t/g,j.tabReplace):s)):s}(s)},highlightElement,highlightBlock:function deprecateHighlightBlock(s){return deprecated("10.7.0","highlightBlock will be removed entirely in v12.0"),deprecated("10.7.0","Please use highlightElement now."),highlightElement(s)},configure:function configure(s){s.useBR&&(deprecated("10.3.0","'useBR' will be removed entirely in v11.0"),deprecated("10.3.0","Please see https://github.com/highlightjs/highlight.js/issues/2559")),j=_e(j,s)},initHighlighting,initHighlightingOnLoad:function initHighlightingOnLoad(){deprecated("10.6.0","initHighlightingOnLoad() is deprecated.  Use highlightAll() instead."),U=!0},registerLanguage:function registerLanguage(o,a){let u=null;try{u=a(s)}catch(s){if(error("Language definition for '{}' could not be registered.".replace("{}",o)),!_)throw s;error(s),u=C}u.name||(u.name=o),i[o]=u,u.rawDefinition=a.bind(null,s),u.aliases&&registerAliases(u.aliases,{languageName:o})},unregisterLanguage:function unregisterLanguage(s){delete i[s];for(const o of Object.keys(a))a[o]===s&&delete a[o]},listLanguages:function listLanguages(){return Object.keys(i)},getLanguage,registerAliases,requireLanguage:function requireLanguage(s){deprecated("10.4.0","requireLanguage will be removed entirely in v11."),deprecated("10.4.0","Please see https://github.com/highlightjs/highlight.js/pull/2844");const o=getLanguage(s);if(o)return o;throw new Error("The '{}' language is required, but not loaded.".replace("{}",s))},autoDetection,inherit:_e,addPlugin:function addPlugin(s){!function upgradePluginAPI(s){s["before:highlightBlock"]&&!s["before:highlightElement"]&&(s["before:highlightElement"]=o=>{s["before:highlightBlock"](Object.assign({block:o.el},o))}),s["after:highlightBlock"]&&!s["after:highlightElement"]&&(s["after:highlightElement"]=o=>{s["after:highlightBlock"](Object.assign({block:o.el},o))})}(s),u.push(s)},vuePlugin:BuildVuePlugin(s).VuePlugin}),s.debugMode=function(){_=!1},s.safeMode=function(){_=!0},s.versionString="10.7.3";for(const s in de)"object"==typeof de[s]&&o(de[s]);return Object.assign(s,de),s.addPlugin(L),s.addPlugin(ye),s.addPlugin($),s}({});s.exports=xe},35344(s){function concat(...s){return s.map((s=>function source(s){return s?"string"==typeof s?s:s.source:null}(s))).join("")}s.exports=function bash(s){const o={},i={begin:/\$\{/,end:/\}/,contains:["self",{begin:/:-/,contains:[o]}]};Object.assign(o,{className:"variable",variants:[{begin:concat(/\$[\w\d#@][\w\d_]*/,"(?![\\w\\d])(?![$])")},i]});const a={className:"subst",begin:/\$\(/,end:/\)/,contains:[s.BACKSLASH_ESCAPE]},u={begin:/<<-?\s*(?=\w+)/,starts:{contains:[s.END_SAME_AS_BEGIN({begin:/(\w+)/,end:/(\w+)/,className:"string"})]}},_={className:"string",begin:/"/,end:/"/,contains:[s.BACKSLASH_ESCAPE,o,a]};a.contains.push(_);const w={begin:/\$\(\(/,end:/\)\)/,contains:[{begin:/\d+#[0-9a-f]+/,className:"number"},s.NUMBER_MODE,o]},x=s.SHEBANG({binary:`(${["fish","bash","zsh","sh","csh","ksh","tcsh","dash","scsh"].join("|")})`,relevance:10}),C={className:"function",begin:/\w[\w\d_]*\s*\(\s*\)\s*\{/,returnBegin:!0,contains:[s.inherit(s.TITLE_MODE,{begin:/\w[\w\d_]*/})],relevance:0};return{name:"Bash",aliases:["sh","zsh"],keywords:{$pattern:/\b[a-z._-]+\b/,keyword:"if then else elif fi for while in do done case esac function",literal:"true false",built_in:"break cd continue eval exec exit export getopts hash pwd readonly return shift test times trap umask unset alias bind builtin caller command declare echo enable help let local logout mapfile printf read readarray source type typeset ulimit unalias set shopt autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate fc fg float functions getcap getln history integer jobs kill limit log noglob popd print pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof zpty zregexparse zsocket zstyle ztcp"},contains:[x,s.SHEBANG(),C,w,s.HASH_COMMENT_MODE,u,_,{className:"",begin:/\\"/},{className:"string",begin:/'/,end:/'/},o]}}},73402(s){function concat(...s){return s.map((s=>function source(s){return s?"string"==typeof s?s:s.source:null}(s))).join("")}s.exports=function http(s){const o="HTTP/(2|1\\.[01])",i={className:"attribute",begin:concat("^",/[A-Za-z][A-Za-z0-9-]*/,"(?=\\:\\s)"),starts:{contains:[{className:"punctuation",begin:/: /,relevance:0,starts:{end:"$",relevance:0}}]}},a=[i,{begin:"\\n\\n",starts:{subLanguage:[],endsWithParent:!0}}];return{name:"HTTP",aliases:["https"],illegal:/\S/,contains:[{begin:"^(?="+o+" \\d{3})",end:/$/,contains:[{className:"meta",begin:o},{className:"number",begin:"\\b\\d{3}\\b"}],starts:{end:/\b\B/,illegal:/\S/,contains:a}},{begin:"(?=^[A-Z]+ (.*?) "+o+"$)",end:/$/,contains:[{className:"string",begin:" ",end:" ",excludeBegin:!0,excludeEnd:!0},{className:"meta",begin:o},{className:"keyword",begin:"[A-Z]+"}],starts:{end:/\b\B/,illegal:/\S/,contains:a}},s.inherit(i,{relevance:0})]}}},95089(s){const o="[A-Za-z$_][0-9A-Za-z$_]*",i=["as","in","of","if","for","while","finally","var","new","function","do","return","void","else","break","catch","instanceof","with","throw","case","default","try","switch","continue","typeof","delete","let","yield","const","class","debugger","async","await","static","import","from","export","extends"],a=["true","false","null","undefined","NaN","Infinity"],u=[].concat(["setInterval","setTimeout","clearInterval","clearTimeout","require","exports","eval","isFinite","isNaN","parseFloat","parseInt","decodeURI","decodeURIComponent","encodeURI","encodeURIComponent","escape","unescape"],["arguments","this","super","console","window","document","localStorage","module","global"],["Intl","DataView","Number","Math","Date","String","RegExp","Object","Function","Boolean","Error","Symbol","Set","Map","WeakSet","WeakMap","Proxy","Reflect","JSON","Promise","Float64Array","Int16Array","Int32Array","Int8Array","Uint16Array","Uint32Array","Float32Array","Array","Uint8Array","Uint8ClampedArray","ArrayBuffer","BigInt64Array","BigUint64Array","BigInt"],["EvalError","InternalError","RangeError","ReferenceError","SyntaxError","TypeError","URIError"]);function lookahead(s){return concat("(?=",s,")")}function concat(...s){return s.map((s=>function source(s){return s?"string"==typeof s?s:s.source:null}(s))).join("")}s.exports=function javascript(s){const _=o,w="<>",x="</>",C={begin:/<[A-Za-z0-9\\._:-]+/,end:/\/[A-Za-z0-9\\._:-]+>|\/>/,isTrulyOpeningTag:(s,o)=>{const i=s[0].length+s.index,a=s.input[i];"<"!==a?">"===a&&(((s,{after:o})=>{const i="</"+s[0].slice(1);return-1!==s.input.indexOf(i,o)})(s,{after:i})||o.ignoreMatch()):o.ignoreMatch()}},j={$pattern:o,keyword:i,literal:a,built_in:u},L="[0-9](_?[0-9])*",B=`\\.(${L})`,$="0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*",U={className:"number",variants:[{begin:`(\\b(${$})((${B})|\\.)?|(${B}))[eE][+-]?(${L})\\b`},{begin:`\\b(${$})\\b((${B})\\b|\\.)?|(${B})\\b`},{begin:"\\b(0|[1-9](_?[0-9])*)n\\b"},{begin:"\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"},{begin:"\\b0[bB][0-1](_?[0-1])*n?\\b"},{begin:"\\b0[oO][0-7](_?[0-7])*n?\\b"},{begin:"\\b0[0-7]+n?\\b"}],relevance:0},V={className:"subst",begin:"\\$\\{",end:"\\}",keywords:j,contains:[]},z={begin:"html`",end:"",starts:{end:"`",returnEnd:!1,contains:[s.BACKSLASH_ESCAPE,V],subLanguage:"xml"}},Y={begin:"css`",end:"",starts:{end:"`",returnEnd:!1,contains:[s.BACKSLASH_ESCAPE,V],subLanguage:"css"}},Z={className:"string",begin:"`",end:"`",contains:[s.BACKSLASH_ESCAPE,V]},ee={className:"comment",variants:[s.COMMENT(/\/\*\*(?!\/)/,"\\*/",{relevance:0,contains:[{className:"doctag",begin:"@[A-Za-z]+",contains:[{className:"type",begin:"\\{",end:"\\}",relevance:0},{className:"variable",begin:_+"(?=\\s*(-)|$)",endsParent:!0,relevance:0},{begin:/(?=[^\n])\s/,relevance:0}]}]}),s.C_BLOCK_COMMENT_MODE,s.C_LINE_COMMENT_MODE]},ie=[s.APOS_STRING_MODE,s.QUOTE_STRING_MODE,z,Y,Z,U,s.REGEXP_MODE];V.contains=ie.concat({begin:/\{/,end:/\}/,keywords:j,contains:["self"].concat(ie)});const ae=[].concat(ee,V.contains),ce=ae.concat([{begin:/\(/,end:/\)/,keywords:j,contains:["self"].concat(ae)}]),le={className:"params",begin:/\(/,end:/\)/,excludeBegin:!0,excludeEnd:!0,keywords:j,contains:ce};return{name:"Javascript",aliases:["js","jsx","mjs","cjs"],keywords:j,exports:{PARAMS_CONTAINS:ce},illegal:/#(?![$_A-z])/,contains:[s.SHEBANG({label:"shebang",binary:"node",relevance:5}),{label:"use_strict",className:"meta",relevance:10,begin:/^\s*['"]use (strict|asm)['"]/},s.APOS_STRING_MODE,s.QUOTE_STRING_MODE,z,Y,Z,ee,U,{begin:concat(/[{,\n]\s*/,lookahead(concat(/(((\/\/.*$)|(\/\*(\*[^/]|[^*])*\*\/))\s*)*/,_+"\\s*:"))),relevance:0,contains:[{className:"attr",begin:_+lookahead("\\s*:"),relevance:0}]},{begin:"("+s.RE_STARTERS_RE+"|\\b(case|return|throw)\\b)\\s*",keywords:"return throw case",contains:[ee,s.REGEXP_MODE,{className:"function",begin:"(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|"+s.UNDERSCORE_IDENT_RE+")\\s*=>",returnBegin:!0,end:"\\s*=>",contains:[{className:"params",variants:[{begin:s.UNDERSCORE_IDENT_RE,relevance:0},{className:null,begin:/\(\s*\)/,skip:!0},{begin:/\(/,end:/\)/,excludeBegin:!0,excludeEnd:!0,keywords:j,contains:ce}]}]},{begin:/,/,relevance:0},{className:"",begin:/\s/,end:/\s*/,skip:!0},{variants:[{begin:w,end:x},{begin:C.begin,"on:begin":C.isTrulyOpeningTag,end:C.end}],subLanguage:"xml",contains:[{begin:C.begin,end:C.end,skip:!0,contains:["self"]}]}],relevance:0},{className:"function",beginKeywords:"function",end:/[{;]/,excludeEnd:!0,keywords:j,contains:["self",s.inherit(s.TITLE_MODE,{begin:_}),le],illegal:/%/},{beginKeywords:"while if switch catch for"},{className:"function",begin:s.UNDERSCORE_IDENT_RE+"\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",returnBegin:!0,contains:[le,s.inherit(s.TITLE_MODE,{begin:_})]},{variants:[{begin:"\\."+_},{begin:"\\$"+_}],relevance:0},{className:"class",beginKeywords:"class",end:/[{;=]/,excludeEnd:!0,illegal:/[:"[\]]/,contains:[{beginKeywords:"extends"},s.UNDERSCORE_TITLE_MODE]},{begin:/\b(?=constructor)/,end:/[{;]/,excludeEnd:!0,contains:[s.inherit(s.TITLE_MODE,{begin:_}),"self",le]},{begin:"(get|set)\\s+(?="+_+"\\()",end:/\{/,keywords:"get set",contains:[s.inherit(s.TITLE_MODE,{begin:_}),{begin:/\(\)/},le]},{begin:/\$[(.]/}]}}},65772(s){s.exports=function json(s){const o={literal:"true false null"},i=[s.C_LINE_COMMENT_MODE,s.C_BLOCK_COMMENT_MODE],a=[s.QUOTE_STRING_MODE,s.C_NUMBER_MODE],u={end:",",endsWithParent:!0,excludeEnd:!0,contains:a,keywords:o},_={begin:/\{/,end:/\}/,contains:[{className:"attr",begin:/"/,end:/"/,contains:[s.BACKSLASH_ESCAPE],illegal:"\\n"},s.inherit(u,{begin:/:/})].concat(i),illegal:"\\S"},w={begin:"\\[",end:"\\]",contains:[s.inherit(u)],illegal:"\\S"};return a.push(_,w),i.forEach((function(s){a.push(s)})),{name:"JSON",contains:a,keywords:o,illegal:"\\S"}}},26571(s){s.exports=function powershell(s){const o={$pattern:/-?[A-z\.\-]+\b/,keyword:"if else foreach return do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch hidden static parameter",built_in:"ac asnp cat cd CFS chdir clc clear clhy cli clp cls clv cnsn compare copy cp cpi cpp curl cvpa dbp del diff dir dnsn ebp echo|0 epal epcsv epsn erase etsn exsn fc fhx fl ft fw gal gbp gc gcb gci gcm gcs gdr gerr ghy gi gin gjb gl gm gmo gp gps gpv group gsn gsnp gsv gtz gu gv gwmi h history icm iex ihy ii ipal ipcsv ipmo ipsn irm ise iwmi iwr kill lp ls man md measure mi mount move mp mv nal ndr ni nmo npssc nsn nv ogv oh popd ps pushd pwd r rbp rcjb rcsn rd rdr ren ri rjb rm rmdir rmo rni rnp rp rsn rsnp rujb rv rvpa rwmi sajb sal saps sasv sbp sc scb select set shcm si sl sleep sls sort sp spjb spps spsv start stz sujb sv swmi tee trcm type wget where wjb write"},i={begin:"`[\\s\\S]",relevance:0},a={className:"variable",variants:[{begin:/\$\B/},{className:"keyword",begin:/\$this/},{begin:/\$[\w\d][\w\d_:]*/}]},u={className:"string",variants:[{begin:/"/,end:/"/},{begin:/@"/,end:/^"@/}],contains:[i,a,{className:"variable",begin:/\$[A-z]/,end:/[^A-z]/}]},_={className:"string",variants:[{begin:/'/,end:/'/},{begin:/@'/,end:/^'@/}]},w=s.inherit(s.COMMENT(null,null),{variants:[{begin:/#/,end:/$/},{begin:/<#/,end:/#>/}],contains:[{className:"doctag",variants:[{begin:/\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/},{begin:/\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\s+\S+/}]}]}),x={className:"built_in",variants:[{begin:"(".concat("Add|Clear|Close|Copy|Enter|Exit|Find|Format|Get|Hide|Join|Lock|Move|New|Open|Optimize|Pop|Push|Redo|Remove|Rename|Reset|Resize|Search|Select|Set|Show|Skip|Split|Step|Switch|Undo|Unlock|Watch|Backup|Checkpoint|Compare|Compress|Convert|ConvertFrom|ConvertTo|Dismount|Edit|Expand|Export|Group|Import|Initialize|Limit|Merge|Mount|Out|Publish|Restore|Save|Sync|Unpublish|Update|Approve|Assert|Build|Complete|Confirm|Deny|Deploy|Disable|Enable|Install|Invoke|Register|Request|Restart|Resume|Start|Stop|Submit|Suspend|Uninstall|Unregister|Wait|Debug|Measure|Ping|Repair|Resolve|Test|Trace|Connect|Disconnect|Read|Receive|Send|Write|Block|Grant|Protect|Revoke|Unblock|Unprotect|Use|ForEach|Sort|Tee|Where",")+(-)[\\w\\d]+")}]},C={className:"class",beginKeywords:"class enum",end:/\s*[{]/,excludeEnd:!0,relevance:0,contains:[s.TITLE_MODE]},j={className:"function",begin:/function\s+/,end:/\s*\{|$/,excludeEnd:!0,returnBegin:!0,relevance:0,contains:[{begin:"function",relevance:0,className:"keyword"},{className:"title",begin:/\w[\w\d]*((-)[\w\d]+)*/,relevance:0},{begin:/\(/,end:/\)/,className:"params",relevance:0,contains:[a]}]},L={begin:/using\s/,end:/$/,returnBegin:!0,contains:[u,_,{className:"keyword",begin:/(using|assembly|command|module|namespace|type)/}]},B={variants:[{className:"operator",begin:"(".concat("-and|-as|-band|-bnot|-bor|-bxor|-casesensitive|-ccontains|-ceq|-cge|-cgt|-cle|-clike|-clt|-cmatch|-cne|-cnotcontains|-cnotlike|-cnotmatch|-contains|-creplace|-csplit|-eq|-exact|-f|-file|-ge|-gt|-icontains|-ieq|-ige|-igt|-ile|-ilike|-ilt|-imatch|-in|-ine|-inotcontains|-inotlike|-inotmatch|-ireplace|-is|-isnot|-isplit|-join|-le|-like|-lt|-match|-ne|-not|-notcontains|-notin|-notlike|-notmatch|-or|-regex|-replace|-shl|-shr|-split|-wildcard|-xor",")\\b")},{className:"literal",begin:/(-)[\w\d]+/,relevance:0}]},$={className:"function",begin:/\[.*\]\s*[\w]+[ ]??\(/,end:/$/,returnBegin:!0,relevance:0,contains:[{className:"keyword",begin:"(".concat(o.keyword.toString().replace(/\s/g,"|"),")\\b"),endsParent:!0,relevance:0},s.inherit(s.TITLE_MODE,{endsParent:!0})]},U=[$,w,i,s.NUMBER_MODE,u,_,x,a,{className:"literal",begin:/\$(null|true|false)\b/},{className:"selector-tag",begin:/@\B/,relevance:0}],V={begin:/\[/,end:/\]/,excludeBegin:!0,excludeEnd:!0,relevance:0,contains:[].concat("self",U,{begin:"("+["string","char","byte","int","long","bool","decimal","single","double","DateTime","xml","array","hashtable","void"].join("|")+")",className:"built_in",relevance:0},{className:"type",begin:/[\.\w\d]+/,relevance:0})};return $.contains.unshift(V),{name:"PowerShell",aliases:["ps","ps1"],case_insensitive:!0,keywords:o,contains:U.concat(C,j,L,B,V)}}},17285(s){function source(s){return s?"string"==typeof s?s:s.source:null}function lookahead(s){return concat("(?=",s,")")}function concat(...s){return s.map((s=>source(s))).join("")}function either(...s){return"("+s.map((s=>source(s))).join("|")+")"}s.exports=function xml(s){const o=concat(/[A-Z_]/,function optional(s){return concat("(",s,")?")}(/[A-Z0-9_.-]*:/),/[A-Z0-9_.-]*/),i={className:"symbol",begin:/&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/},a={begin:/\s/,contains:[{className:"meta-keyword",begin:/#?[a-z_][a-z1-9_-]+/,illegal:/\n/}]},u=s.inherit(a,{begin:/\(/,end:/\)/}),_=s.inherit(s.APOS_STRING_MODE,{className:"meta-string"}),w=s.inherit(s.QUOTE_STRING_MODE,{className:"meta-string"}),x={endsWithParent:!0,illegal:/</,relevance:0,contains:[{className:"attr",begin:/[A-Za-z0-9._:-]+/,relevance:0},{begin:/=\s*/,relevance:0,contains:[{className:"string",endsParent:!0,variants:[{begin:/"/,end:/"/,contains:[i]},{begin:/'/,end:/'/,contains:[i]},{begin:/[^\s"'=<>`]+/}]}]}]};return{name:"HTML, XML",aliases:["html","xhtml","rss","atom","xjb","xsd","xsl","plist","wsf","svg"],case_insensitive:!0,contains:[{className:"meta",begin:/<![a-z]/,end:/>/,relevance:10,contains:[a,w,_,u,{begin:/\[/,end:/\]/,contains:[{className:"meta",begin:/<![a-z]/,end:/>/,contains:[a,u,w,_]}]}]},s.COMMENT(/<!--/,/-->/,{relevance:10}),{begin:/<!\[CDATA\[/,end:/\]\]>/,relevance:10},i,{className:"meta",begin:/<\?xml/,end:/\?>/,relevance:10},{className:"tag",begin:/<style(?=\s|>)/,end:/>/,keywords:{name:"style"},contains:[x],starts:{end:/<\/style>/,returnEnd:!0,subLanguage:["css","xml"]}},{className:"tag",begin:/<script(?=\s|>)/,end:/>/,keywords:{name:"script"},contains:[x],starts:{end:/<\/script>/,returnEnd:!0,subLanguage:["javascript","handlebars","xml"]}},{className:"tag",begin:/<>|<\/>/},{className:"tag",begin:concat(/</,lookahead(concat(o,either(/\/>/,/>/,/\s/)))),end:/\/?>/,contains:[{className:"name",begin:o,relevance:0,starts:x}]},{className:"tag",begin:concat(/<\//,lookahead(concat(o,/>/))),contains:[{className:"name",begin:o,relevance:0},{begin:/>/,relevance:0,endsParent:!0}]}]}}},17533(s){s.exports=function yaml(s){var o="true false yes no null",i="[\\w#;/?:@&=+$,.~*'()[\\]]+",a={className:"string",relevance:0,variants:[{begin:/'/,end:/'/},{begin:/"/,end:/"/},{begin:/\S+/}],contains:[s.BACKSLASH_ESCAPE,{className:"template-variable",variants:[{begin:/\{\{/,end:/\}\}/},{begin:/%\{/,end:/\}/}]}]},u=s.inherit(a,{variants:[{begin:/'/,end:/'/},{begin:/"/,end:/"/},{begin:/[^\s,{}[\]]+/}]}),_={className:"number",begin:"\\b[0-9]{4}(-[0-9][0-9]){0,2}([Tt \\t][0-9][0-9]?(:[0-9][0-9]){2})?(\\.[0-9]*)?([ \\t])*(Z|[-+][0-9][0-9]?(:[0-9][0-9])?)?\\b"},w={end:",",endsWithParent:!0,excludeEnd:!0,keywords:o,relevance:0},x={begin:/\{/,end:/\}/,contains:[w],illegal:"\\n",relevance:0},C={begin:"\\[",end:"\\]",contains:[w],illegal:"\\n",relevance:0},j=[{className:"attr",variants:[{begin:"\\w[\\w :\\/.-]*:(?=[ \t]|$)"},{begin:'"\\w[\\w :\\/.-]*":(?=[ \t]|$)'},{begin:"'\\w[\\w :\\/.-]*':(?=[ \t]|$)"}]},{className:"meta",begin:"^---\\s*$",relevance:10},{className:"string",begin:"[\\|>]([1-9]?[+-])?[ ]*\\n( +)[^ ][^\\n]*\\n(\\2[^\\n]+\\n?)*"},{begin:"<%[%=-]?",end:"[%-]?%>",subLanguage:"ruby",excludeBegin:!0,excludeEnd:!0,relevance:0},{className:"type",begin:"!\\w+!"+i},{className:"type",begin:"!<"+i+">"},{className:"type",begin:"!"+i},{className:"type",begin:"!!"+i},{className:"meta",begin:"&"+s.UNDERSCORE_IDENT_RE+"$"},{className:"meta",begin:"\\*"+s.UNDERSCORE_IDENT_RE+"$"},{className:"bullet",begin:"-(?=[ ]|$)",relevance:0},s.HASH_COMMENT_MODE,{beginKeywords:o,keywords:{literal:o}},_,{className:"number",begin:s.C_NUMBER_RE+"\\b",relevance:0},x,C,a],L=[...j];return L.pop(),L.push(u),w.contains=L,{name:"YAML",case_insensitive:!0,aliases:["yml"],contains:j}}},251(s,o){o.read=function(s,o,i,a,u){var _,w,x=8*u-a-1,C=(1<<x)-1,j=C>>1,L=-7,B=i?u-1:0,$=i?-1:1,U=s[o+B];for(B+=$,_=U&(1<<-L)-1,U>>=-L,L+=x;L>0;_=256*_+s[o+B],B+=$,L-=8);for(w=_&(1<<-L)-1,_>>=-L,L+=a;L>0;w=256*w+s[o+B],B+=$,L-=8);if(0===_)_=1-j;else{if(_===C)return w?NaN:1/0*(U?-1:1);w+=Math.pow(2,a),_-=j}return(U?-1:1)*w*Math.pow(2,_-a)},o.write=function(s,o,i,a,u,_){var w,x,C,j=8*_-u-1,L=(1<<j)-1,B=L>>1,$=23===u?Math.pow(2,-24)-Math.pow(2,-77):0,U=a?0:_-1,V=a?1:-1,z=o<0||0===o&&1/o<0?1:0;for(o=Math.abs(o),isNaN(o)||o===1/0?(x=isNaN(o)?1:0,w=L):(w=Math.floor(Math.log(o)/Math.LN2),o*(C=Math.pow(2,-w))<1&&(w--,C*=2),(o+=w+B>=1?$/C:$*Math.pow(2,1-B))*C>=2&&(w++,C/=2),w+B>=L?(x=0,w=L):w+B>=1?(x=(o*C-1)*Math.pow(2,u),w+=B):(x=o*Math.pow(2,B-1)*Math.pow(2,u),w=0));u>=8;s[i+U]=255&x,U+=V,x/=256,u-=8);for(w=w<<u|x,j+=u;j>0;s[i+U]=255&w,U+=V,w/=256,j-=8);s[i+U-V]|=128*z}},9404(s){s.exports=function(){"use strict";var s=Array.prototype.slice;function createClass(s,o){o&&(s.prototype=Object.create(o.prototype)),s.prototype.constructor=s}function Iterable(s){return isIterable(s)?s:Seq(s)}function KeyedIterable(s){return isKeyed(s)?s:KeyedSeq(s)}function IndexedIterable(s){return isIndexed(s)?s:IndexedSeq(s)}function SetIterable(s){return isIterable(s)&&!isAssociative(s)?s:SetSeq(s)}function isIterable(s){return!(!s||!s[o])}function isKeyed(s){return!(!s||!s[i])}function isIndexed(s){return!(!s||!s[a])}function isAssociative(s){return isKeyed(s)||isIndexed(s)}function isOrdered(s){return!(!s||!s[u])}createClass(KeyedIterable,Iterable),createClass(IndexedIterable,Iterable),createClass(SetIterable,Iterable),Iterable.isIterable=isIterable,Iterable.isKeyed=isKeyed,Iterable.isIndexed=isIndexed,Iterable.isAssociative=isAssociative,Iterable.isOrdered=isOrdered,Iterable.Keyed=KeyedIterable,Iterable.Indexed=IndexedIterable,Iterable.Set=SetIterable;var o="@@__IMMUTABLE_ITERABLE__@@",i="@@__IMMUTABLE_KEYED__@@",a="@@__IMMUTABLE_INDEXED__@@",u="@@__IMMUTABLE_ORDERED__@@",_="delete",w=5,x=1<<w,C=x-1,j={},L={value:!1},B={value:!1};function MakeRef(s){return s.value=!1,s}function SetRef(s){s&&(s.value=!0)}function OwnerID(){}function arrCopy(s,o){o=o||0;for(var i=Math.max(0,s.length-o),a=new Array(i),u=0;u<i;u++)a[u]=s[u+o];return a}function ensureSize(s){return void 0===s.size&&(s.size=s.__iterate(returnTrue)),s.size}function wrapIndex(s,o){if("number"!=typeof o){var i=o>>>0;if(""+i!==o||4294967295===i)return NaN;o=i}return o<0?ensureSize(s)+o:o}function returnTrue(){return!0}function wholeSlice(s,o,i){return(0===s||void 0!==i&&s<=-i)&&(void 0===o||void 0!==i&&o>=i)}function resolveBegin(s,o){return resolveIndex(s,o,0)}function resolveEnd(s,o){return resolveIndex(s,o,o)}function resolveIndex(s,o,i){return void 0===s?i:s<0?Math.max(0,o+s):void 0===o?s:Math.min(o,s)}var $=0,U=1,V=2,z="function"==typeof Symbol&&Symbol.iterator,Y="@@iterator",Z=z||Y;function Iterator(s){this.next=s}function iteratorValue(s,o,i,a){var u=0===s?o:1===s?i:[o,i];return a?a.value=u:a={value:u,done:!1},a}function iteratorDone(){return{value:void 0,done:!0}}function hasIterator(s){return!!getIteratorFn(s)}function isIterator(s){return s&&"function"==typeof s.next}function getIterator(s){var o=getIteratorFn(s);return o&&o.call(s)}function getIteratorFn(s){var o=s&&(z&&s[z]||s[Y]);if("function"==typeof o)return o}function isArrayLike(s){return s&&"number"==typeof s.length}function Seq(s){return null==s?emptySequence():isIterable(s)?s.toSeq():seqFromValue(s)}function KeyedSeq(s){return null==s?emptySequence().toKeyedSeq():isIterable(s)?isKeyed(s)?s.toSeq():s.fromEntrySeq():keyedSeqFromValue(s)}function IndexedSeq(s){return null==s?emptySequence():isIterable(s)?isKeyed(s)?s.entrySeq():s.toIndexedSeq():indexedSeqFromValue(s)}function SetSeq(s){return(null==s?emptySequence():isIterable(s)?isKeyed(s)?s.entrySeq():s:indexedSeqFromValue(s)).toSetSeq()}Iterator.prototype.toString=function(){return"[Iterator]"},Iterator.KEYS=$,Iterator.VALUES=U,Iterator.ENTRIES=V,Iterator.prototype.inspect=Iterator.prototype.toSource=function(){return this.toString()},Iterator.prototype[Z]=function(){return this},createClass(Seq,Iterable),Seq.of=function(){return Seq(arguments)},Seq.prototype.toSeq=function(){return this},Seq.prototype.toString=function(){return this.__toString("Seq {","}")},Seq.prototype.cacheResult=function(){return!this._cache&&this.__iterateUncached&&(this._cache=this.entrySeq().toArray(),this.size=this._cache.length),this},Seq.prototype.__iterate=function(s,o){return seqIterate(this,s,o,!0)},Seq.prototype.__iterator=function(s,o){return seqIterator(this,s,o,!0)},createClass(KeyedSeq,Seq),KeyedSeq.prototype.toKeyedSeq=function(){return this},createClass(IndexedSeq,Seq),IndexedSeq.of=function(){return IndexedSeq(arguments)},IndexedSeq.prototype.toIndexedSeq=function(){return this},IndexedSeq.prototype.toString=function(){return this.__toString("Seq [","]")},IndexedSeq.prototype.__iterate=function(s,o){return seqIterate(this,s,o,!1)},IndexedSeq.prototype.__iterator=function(s,o){return seqIterator(this,s,o,!1)},createClass(SetSeq,Seq),SetSeq.of=function(){return SetSeq(arguments)},SetSeq.prototype.toSetSeq=function(){return this},Seq.isSeq=isSeq,Seq.Keyed=KeyedSeq,Seq.Set=SetSeq,Seq.Indexed=IndexedSeq;var ee,ie,ae,ce="@@__IMMUTABLE_SEQ__@@";function ArraySeq(s){this._array=s,this.size=s.length}function ObjectSeq(s){var o=Object.keys(s);this._object=s,this._keys=o,this.size=o.length}function IterableSeq(s){this._iterable=s,this.size=s.length||s.size}function IteratorSeq(s){this._iterator=s,this._iteratorCache=[]}function isSeq(s){return!(!s||!s[ce])}function emptySequence(){return ee||(ee=new ArraySeq([]))}function keyedSeqFromValue(s){var o=Array.isArray(s)?new ArraySeq(s).fromEntrySeq():isIterator(s)?new IteratorSeq(s).fromEntrySeq():hasIterator(s)?new IterableSeq(s).fromEntrySeq():"object"==typeof s?new ObjectSeq(s):void 0;if(!o)throw new TypeError("Expected Array or iterable object of [k, v] entries, or keyed object: "+s);return o}function indexedSeqFromValue(s){var o=maybeIndexedSeqFromValue(s);if(!o)throw new TypeError("Expected Array or iterable object of values: "+s);return o}function seqFromValue(s){var o=maybeIndexedSeqFromValue(s)||"object"==typeof s&&new ObjectSeq(s);if(!o)throw new TypeError("Expected Array or iterable object of values, or keyed object: "+s);return o}function maybeIndexedSeqFromValue(s){return isArrayLike(s)?new ArraySeq(s):isIterator(s)?new IteratorSeq(s):hasIterator(s)?new IterableSeq(s):void 0}function seqIterate(s,o,i,a){var u=s._cache;if(u){for(var _=u.length-1,w=0;w<=_;w++){var x=u[i?_-w:w];if(!1===o(x[1],a?x[0]:w,s))return w+1}return w}return s.__iterateUncached(o,i)}function seqIterator(s,o,i,a){var u=s._cache;if(u){var _=u.length-1,w=0;return new Iterator((function(){var s=u[i?_-w:w];return w++>_?iteratorDone():iteratorValue(o,a?s[0]:w-1,s[1])}))}return s.__iteratorUncached(o,i)}function fromJS(s,o){return o?fromJSWith(o,s,"",{"":s}):fromJSDefault(s)}function fromJSWith(s,o,i,a){return Array.isArray(o)?s.call(a,i,IndexedSeq(o).map((function(i,a){return fromJSWith(s,i,a,o)}))):isPlainObj(o)?s.call(a,i,KeyedSeq(o).map((function(i,a){return fromJSWith(s,i,a,o)}))):o}function fromJSDefault(s){return Array.isArray(s)?IndexedSeq(s).map(fromJSDefault).toList():isPlainObj(s)?KeyedSeq(s).map(fromJSDefault).toMap():s}function isPlainObj(s){return s&&(s.constructor===Object||void 0===s.constructor)}function is(s,o){if(s===o||s!=s&&o!=o)return!0;if(!s||!o)return!1;if("function"==typeof s.valueOf&&"function"==typeof o.valueOf){if((s=s.valueOf())===(o=o.valueOf())||s!=s&&o!=o)return!0;if(!s||!o)return!1}return!("function"!=typeof s.equals||"function"!=typeof o.equals||!s.equals(o))}function deepEqual(s,o){if(s===o)return!0;if(!isIterable(o)||void 0!==s.size&&void 0!==o.size&&s.size!==o.size||void 0!==s.__hash&&void 0!==o.__hash&&s.__hash!==o.__hash||isKeyed(s)!==isKeyed(o)||isIndexed(s)!==isIndexed(o)||isOrdered(s)!==isOrdered(o))return!1;if(0===s.size&&0===o.size)return!0;var i=!isAssociative(s);if(isOrdered(s)){var a=s.entries();return o.every((function(s,o){var u=a.next().value;return u&&is(u[1],s)&&(i||is(u[0],o))}))&&a.next().done}var u=!1;if(void 0===s.size)if(void 0===o.size)"function"==typeof s.cacheResult&&s.cacheResult();else{u=!0;var _=s;s=o,o=_}var w=!0,x=o.__iterate((function(o,a){if(i?!s.has(o):u?!is(o,s.get(a,j)):!is(s.get(a,j),o))return w=!1,!1}));return w&&s.size===x}function Repeat(s,o){if(!(this instanceof Repeat))return new Repeat(s,o);if(this._value=s,this.size=void 0===o?1/0:Math.max(0,o),0===this.size){if(ie)return ie;ie=this}}function invariant(s,o){if(!s)throw new Error(o)}function Range(s,o,i){if(!(this instanceof Range))return new Range(s,o,i);if(invariant(0!==i,"Cannot step a Range by 0"),s=s||0,void 0===o&&(o=1/0),i=void 0===i?1:Math.abs(i),o<s&&(i=-i),this._start=s,this._end=o,this._step=i,this.size=Math.max(0,Math.ceil((o-s)/i-1)+1),0===this.size){if(ae)return ae;ae=this}}function Collection(){throw TypeError("Abstract")}function KeyedCollection(){}function IndexedCollection(){}function SetCollection(){}Seq.prototype[ce]=!0,createClass(ArraySeq,IndexedSeq),ArraySeq.prototype.get=function(s,o){return this.has(s)?this._array[wrapIndex(this,s)]:o},ArraySeq.prototype.__iterate=function(s,o){for(var i=this._array,a=i.length-1,u=0;u<=a;u++)if(!1===s(i[o?a-u:u],u,this))return u+1;return u},ArraySeq.prototype.__iterator=function(s,o){var i=this._array,a=i.length-1,u=0;return new Iterator((function(){return u>a?iteratorDone():iteratorValue(s,u,i[o?a-u++:u++])}))},createClass(ObjectSeq,KeyedSeq),ObjectSeq.prototype.get=function(s,o){return void 0===o||this.has(s)?this._object[s]:o},ObjectSeq.prototype.has=function(s){return this._object.hasOwnProperty(s)},ObjectSeq.prototype.__iterate=function(s,o){for(var i=this._object,a=this._keys,u=a.length-1,_=0;_<=u;_++){var w=a[o?u-_:_];if(!1===s(i[w],w,this))return _+1}return _},ObjectSeq.prototype.__iterator=function(s,o){var i=this._object,a=this._keys,u=a.length-1,_=0;return new Iterator((function(){var w=a[o?u-_:_];return _++>u?iteratorDone():iteratorValue(s,w,i[w])}))},ObjectSeq.prototype[u]=!0,createClass(IterableSeq,IndexedSeq),IterableSeq.prototype.__iterateUncached=function(s,o){if(o)return this.cacheResult().__iterate(s,o);var i=getIterator(this._iterable),a=0;if(isIterator(i))for(var u;!(u=i.next()).done&&!1!==s(u.value,a++,this););return a},IterableSeq.prototype.__iteratorUncached=function(s,o){if(o)return this.cacheResult().__iterator(s,o);var i=getIterator(this._iterable);if(!isIterator(i))return new Iterator(iteratorDone);var a=0;return new Iterator((function(){var o=i.next();return o.done?o:iteratorValue(s,a++,o.value)}))},createClass(IteratorSeq,IndexedSeq),IteratorSeq.prototype.__iterateUncached=function(s,o){if(o)return this.cacheResult().__iterate(s,o);for(var i,a=this._iterator,u=this._iteratorCache,_=0;_<u.length;)if(!1===s(u[_],_++,this))return _;for(;!(i=a.next()).done;){var w=i.value;if(u[_]=w,!1===s(w,_++,this))break}return _},IteratorSeq.prototype.__iteratorUncached=function(s,o){if(o)return this.cacheResult().__iterator(s,o);var i=this._iterator,a=this._iteratorCache,u=0;return new Iterator((function(){if(u>=a.length){var o=i.next();if(o.done)return o;a[u]=o.value}return iteratorValue(s,u,a[u++])}))},createClass(Repeat,IndexedSeq),Repeat.prototype.toString=function(){return 0===this.size?"Repeat []":"Repeat [ "+this._value+" "+this.size+" times ]"},Repeat.prototype.get=function(s,o){return this.has(s)?this._value:o},Repeat.prototype.includes=function(s){return is(this._value,s)},Repeat.prototype.slice=function(s,o){var i=this.size;return wholeSlice(s,o,i)?this:new Repeat(this._value,resolveEnd(o,i)-resolveBegin(s,i))},Repeat.prototype.reverse=function(){return this},Repeat.prototype.indexOf=function(s){return is(this._value,s)?0:-1},Repeat.prototype.lastIndexOf=function(s){return is(this._value,s)?this.size:-1},Repeat.prototype.__iterate=function(s,o){for(var i=0;i<this.size;i++)if(!1===s(this._value,i,this))return i+1;return i},Repeat.prototype.__iterator=function(s,o){var i=this,a=0;return new Iterator((function(){return a<i.size?iteratorValue(s,a++,i._value):iteratorDone()}))},Repeat.prototype.equals=function(s){return s instanceof Repeat?is(this._value,s._value):deepEqual(s)},createClass(Range,IndexedSeq),Range.prototype.toString=function(){return 0===this.size?"Range []":"Range [ "+this._start+"..."+this._end+(1!==this._step?" by "+this._step:"")+" ]"},Range.prototype.get=function(s,o){return this.has(s)?this._start+wrapIndex(this,s)*this._step:o},Range.prototype.includes=function(s){var o=(s-this._start)/this._step;return o>=0&&o<this.size&&o===Math.floor(o)},Range.prototype.slice=function(s,o){return wholeSlice(s,o,this.size)?this:(s=resolveBegin(s,this.size),(o=resolveEnd(o,this.size))<=s?new Range(0,0):new Range(this.get(s,this._end),this.get(o,this._end),this._step))},Range.prototype.indexOf=function(s){var o=s-this._start;if(o%this._step==0){var i=o/this._step;if(i>=0&&i<this.size)return i}return-1},Range.prototype.lastIndexOf=function(s){return this.indexOf(s)},Range.prototype.__iterate=function(s,o){for(var i=this.size-1,a=this._step,u=o?this._start+i*a:this._start,_=0;_<=i;_++){if(!1===s(u,_,this))return _+1;u+=o?-a:a}return _},Range.prototype.__iterator=function(s,o){var i=this.size-1,a=this._step,u=o?this._start+i*a:this._start,_=0;return new Iterator((function(){var w=u;return u+=o?-a:a,_>i?iteratorDone():iteratorValue(s,_++,w)}))},Range.prototype.equals=function(s){return s instanceof Range?this._start===s._start&&this._end===s._end&&this._step===s._step:deepEqual(this,s)},createClass(Collection,Iterable),createClass(KeyedCollection,Collection),createClass(IndexedCollection,Collection),createClass(SetCollection,Collection),Collection.Keyed=KeyedCollection,Collection.Indexed=IndexedCollection,Collection.Set=SetCollection;var le="function"==typeof Math.imul&&-2===Math.imul(4294967295,2)?Math.imul:function imul(s,o){var i=65535&(s|=0),a=65535&(o|=0);return i*a+((s>>>16)*a+i*(o>>>16)<<16>>>0)|0};function smi(s){return s>>>1&1073741824|3221225471&s}function hash(s){if(!1===s||null==s)return 0;if("function"==typeof s.valueOf&&(!1===(s=s.valueOf())||null==s))return 0;if(!0===s)return 1;var o=typeof s;if("number"===o){if(s!=s||s===1/0)return 0;var i=0|s;for(i!==s&&(i^=4294967295*s);s>4294967295;)i^=s/=4294967295;return smi(i)}if("string"===o)return s.length>_e?cachedHashString(s):hashString(s);if("function"==typeof s.hashCode)return s.hashCode();if("object"===o)return hashJSObj(s);if("function"==typeof s.toString)return hashString(s.toString());throw new Error("Value type "+o+" cannot be hashed.")}function cachedHashString(s){var o=Pe[s];return void 0===o&&(o=hashString(s),xe===we&&(xe=0,Pe={}),xe++,Pe[s]=o),o}function hashString(s){for(var o=0,i=0;i<s.length;i++)o=31*o+s.charCodeAt(i)|0;return smi(o)}function hashJSObj(s){var o;if(ye&&void 0!==(o=fe.get(s)))return o;if(void 0!==(o=s[Se]))return o;if(!de){if(void 0!==(o=s.propertyIsEnumerable&&s.propertyIsEnumerable[Se]))return o;if(void 0!==(o=getIENodeHash(s)))return o}if(o=++be,1073741824&be&&(be=0),ye)fe.set(s,o);else{if(void 0!==pe&&!1===pe(s))throw new Error("Non-extensible objects are not allowed as keys.");if(de)Object.defineProperty(s,Se,{enumerable:!1,configurable:!1,writable:!1,value:o});else if(void 0!==s.propertyIsEnumerable&&s.propertyIsEnumerable===s.constructor.prototype.propertyIsEnumerable)s.propertyIsEnumerable=function(){return this.constructor.prototype.propertyIsEnumerable.apply(this,arguments)},s.propertyIsEnumerable[Se]=o;else{if(void 0===s.nodeType)throw new Error("Unable to set a non-enumerable property on object.");s[Se]=o}}return o}var pe=Object.isExtensible,de=function(){try{return Object.defineProperty({},"@",{}),!0}catch(s){return!1}}();function getIENodeHash(s){if(s&&s.nodeType>0)switch(s.nodeType){case 1:return s.uniqueID;case 9:return s.documentElement&&s.documentElement.uniqueID}}var fe,ye="function"==typeof WeakMap;ye&&(fe=new WeakMap);var be=0,Se="__immutablehash__";"function"==typeof Symbol&&(Se=Symbol(Se));var _e=16,we=255,xe=0,Pe={};function assertNotInfinite(s){invariant(s!==1/0,"Cannot perform this action with an infinite size.")}function Map(s){return null==s?emptyMap():isMap(s)&&!isOrdered(s)?s:emptyMap().withMutations((function(o){var i=KeyedIterable(s);assertNotInfinite(i.size),i.forEach((function(s,i){return o.set(i,s)}))}))}function isMap(s){return!(!s||!s[Re])}createClass(Map,KeyedCollection),Map.of=function(){var o=s.call(arguments,0);return emptyMap().withMutations((function(s){for(var i=0;i<o.length;i+=2){if(i+1>=o.length)throw new Error("Missing value for key: "+o[i]);s.set(o[i],o[i+1])}}))},Map.prototype.toString=function(){return this.__toString("Map {","}")},Map.prototype.get=function(s,o){return this._root?this._root.get(0,void 0,s,o):o},Map.prototype.set=function(s,o){return updateMap(this,s,o)},Map.prototype.setIn=function(s,o){return this.updateIn(s,j,(function(){return o}))},Map.prototype.remove=function(s){return updateMap(this,s,j)},Map.prototype.deleteIn=function(s){return this.updateIn(s,(function(){return j}))},Map.prototype.update=function(s,o,i){return 1===arguments.length?s(this):this.updateIn([s],o,i)},Map.prototype.updateIn=function(s,o,i){i||(i=o,o=void 0);var a=updateInDeepMap(this,forceIterator(s),o,i);return a===j?void 0:a},Map.prototype.clear=function(){return 0===this.size?this:this.__ownerID?(this.size=0,this._root=null,this.__hash=void 0,this.__altered=!0,this):emptyMap()},Map.prototype.merge=function(){return mergeIntoMapWith(this,void 0,arguments)},Map.prototype.mergeWith=function(o){return mergeIntoMapWith(this,o,s.call(arguments,1))},Map.prototype.mergeIn=function(o){var i=s.call(arguments,1);return this.updateIn(o,emptyMap(),(function(s){return"function"==typeof s.merge?s.merge.apply(s,i):i[i.length-1]}))},Map.prototype.mergeDeep=function(){return mergeIntoMapWith(this,deepMerger,arguments)},Map.prototype.mergeDeepWith=function(o){var i=s.call(arguments,1);return mergeIntoMapWith(this,deepMergerWith(o),i)},Map.prototype.mergeDeepIn=function(o){var i=s.call(arguments,1);return this.updateIn(o,emptyMap(),(function(s){return"function"==typeof s.mergeDeep?s.mergeDeep.apply(s,i):i[i.length-1]}))},Map.prototype.sort=function(s){return OrderedMap(sortFactory(this,s))},Map.prototype.sortBy=function(s,o){return OrderedMap(sortFactory(this,o,s))},Map.prototype.withMutations=function(s){var o=this.asMutable();return s(o),o.wasAltered()?o.__ensureOwner(this.__ownerID):this},Map.prototype.asMutable=function(){return this.__ownerID?this:this.__ensureOwner(new OwnerID)},Map.prototype.asImmutable=function(){return this.__ensureOwner()},Map.prototype.wasAltered=function(){return this.__altered},Map.prototype.__iterator=function(s,o){return new MapIterator(this,s,o)},Map.prototype.__iterate=function(s,o){var i=this,a=0;return this._root&&this._root.iterate((function(o){return a++,s(o[1],o[0],i)}),o),a},Map.prototype.__ensureOwner=function(s){return s===this.__ownerID?this:s?makeMap(this.size,this._root,s,this.__hash):(this.__ownerID=s,this.__altered=!1,this)},Map.isMap=isMap;var Te,Re="@@__IMMUTABLE_MAP__@@",$e=Map.prototype;function ArrayMapNode(s,o){this.ownerID=s,this.entries=o}function BitmapIndexedNode(s,o,i){this.ownerID=s,this.bitmap=o,this.nodes=i}function HashArrayMapNode(s,o,i){this.ownerID=s,this.count=o,this.nodes=i}function HashCollisionNode(s,o,i){this.ownerID=s,this.keyHash=o,this.entries=i}function ValueNode(s,o,i){this.ownerID=s,this.keyHash=o,this.entry=i}function MapIterator(s,o,i){this._type=o,this._reverse=i,this._stack=s._root&&mapIteratorFrame(s._root)}function mapIteratorValue(s,o){return iteratorValue(s,o[0],o[1])}function mapIteratorFrame(s,o){return{node:s,index:0,__prev:o}}function makeMap(s,o,i,a){var u=Object.create($e);return u.size=s,u._root=o,u.__ownerID=i,u.__hash=a,u.__altered=!1,u}function emptyMap(){return Te||(Te=makeMap(0))}function updateMap(s,o,i){var a,u;if(s._root){var _=MakeRef(L),w=MakeRef(B);if(a=updateNode(s._root,s.__ownerID,0,void 0,o,i,_,w),!w.value)return s;u=s.size+(_.value?i===j?-1:1:0)}else{if(i===j)return s;u=1,a=new ArrayMapNode(s.__ownerID,[[o,i]])}return s.__ownerID?(s.size=u,s._root=a,s.__hash=void 0,s.__altered=!0,s):a?makeMap(u,a):emptyMap()}function updateNode(s,o,i,a,u,_,w,x){return s?s.update(o,i,a,u,_,w,x):_===j?s:(SetRef(x),SetRef(w),new ValueNode(o,a,[u,_]))}function isLeafNode(s){return s.constructor===ValueNode||s.constructor===HashCollisionNode}function mergeIntoNode(s,o,i,a,u){if(s.keyHash===a)return new HashCollisionNode(o,a,[s.entry,u]);var _,x=(0===i?s.keyHash:s.keyHash>>>i)&C,j=(0===i?a:a>>>i)&C;return new BitmapIndexedNode(o,1<<x|1<<j,x===j?[mergeIntoNode(s,o,i+w,a,u)]:(_=new ValueNode(o,a,u),x<j?[s,_]:[_,s]))}function createNodes(s,o,i,a){s||(s=new OwnerID);for(var u=new ValueNode(s,hash(i),[i,a]),_=0;_<o.length;_++){var w=o[_];u=u.update(s,0,void 0,w[0],w[1])}return u}function packNodes(s,o,i,a){for(var u=0,_=0,w=new Array(i),x=0,C=1,j=o.length;x<j;x++,C<<=1){var L=o[x];void 0!==L&&x!==a&&(u|=C,w[_++]=L)}return new BitmapIndexedNode(s,u,w)}function expandNodes(s,o,i,a,u){for(var _=0,w=new Array(x),C=0;0!==i;C++,i>>>=1)w[C]=1&i?o[_++]:void 0;return w[a]=u,new HashArrayMapNode(s,_+1,w)}function mergeIntoMapWith(s,o,i){for(var a=[],u=0;u<i.length;u++){var _=i[u],w=KeyedIterable(_);isIterable(_)||(w=w.map((function(s){return fromJS(s)}))),a.push(w)}return mergeIntoCollectionWith(s,o,a)}function deepMerger(s,o,i){return s&&s.mergeDeep&&isIterable(o)?s.mergeDeep(o):is(s,o)?s:o}function deepMergerWith(s){return function(o,i,a){if(o&&o.mergeDeepWith&&isIterable(i))return o.mergeDeepWith(s,i);var u=s(o,i,a);return is(o,u)?o:u}}function mergeIntoCollectionWith(s,o,i){return 0===(i=i.filter((function(s){return 0!==s.size}))).length?s:0!==s.size||s.__ownerID||1!==i.length?s.withMutations((function(s){for(var a=o?function(i,a){s.update(a,j,(function(s){return s===j?i:o(s,i,a)}))}:function(o,i){s.set(i,o)},u=0;u<i.length;u++)i[u].forEach(a)})):s.constructor(i[0])}function updateInDeepMap(s,o,i,a){var u=s===j,_=o.next();if(_.done){var w=u?i:s,x=a(w);return x===w?s:x}invariant(u||s&&s.set,"invalid keyPath");var C=_.value,L=u?j:s.get(C,j),B=updateInDeepMap(L,o,i,a);return B===L?s:B===j?s.remove(C):(u?emptyMap():s).set(C,B)}function popCount(s){return s=(s=(858993459&(s-=s>>1&1431655765))+(s>>2&858993459))+(s>>4)&252645135,s+=s>>8,127&(s+=s>>16)}function setIn(s,o,i,a){var u=a?s:arrCopy(s);return u[o]=i,u}function spliceIn(s,o,i,a){var u=s.length+1;if(a&&o+1===u)return s[o]=i,s;for(var _=new Array(u),w=0,x=0;x<u;x++)x===o?(_[x]=i,w=-1):_[x]=s[x+w];return _}function spliceOut(s,o,i){var a=s.length-1;if(i&&o===a)return s.pop(),s;for(var u=new Array(a),_=0,w=0;w<a;w++)w===o&&(_=1),u[w]=s[w+_];return u}$e[Re]=!0,$e[_]=$e.remove,$e.removeIn=$e.deleteIn,ArrayMapNode.prototype.get=function(s,o,i,a){for(var u=this.entries,_=0,w=u.length;_<w;_++)if(is(i,u[_][0]))return u[_][1];return a},ArrayMapNode.prototype.update=function(s,o,i,a,u,_,w){for(var x=u===j,C=this.entries,L=0,B=C.length;L<B&&!is(a,C[L][0]);L++);var $=L<B;if($?C[L][1]===u:x)return this;if(SetRef(w),(x||!$)&&SetRef(_),!x||1!==C.length){if(!$&&!x&&C.length>=qe)return createNodes(s,C,a,u);var U=s&&s===this.ownerID,V=U?C:arrCopy(C);return $?x?L===B-1?V.pop():V[L]=V.pop():V[L]=[a,u]:V.push([a,u]),U?(this.entries=V,this):new ArrayMapNode(s,V)}},BitmapIndexedNode.prototype.get=function(s,o,i,a){void 0===o&&(o=hash(i));var u=1<<((0===s?o:o>>>s)&C),_=this.bitmap;return _&u?this.nodes[popCount(_&u-1)].get(s+w,o,i,a):a},BitmapIndexedNode.prototype.update=function(s,o,i,a,u,_,x){void 0===i&&(i=hash(a));var L=(0===o?i:i>>>o)&C,B=1<<L,$=this.bitmap,U=!!($&B);if(!U&&u===j)return this;var V=popCount($&B-1),z=this.nodes,Y=U?z[V]:void 0,Z=updateNode(Y,s,o+w,i,a,u,_,x);if(Z===Y)return this;if(!U&&Z&&z.length>=ze)return expandNodes(s,z,$,L,Z);if(U&&!Z&&2===z.length&&isLeafNode(z[1^V]))return z[1^V];if(U&&Z&&1===z.length&&isLeafNode(Z))return Z;var ee=s&&s===this.ownerID,ie=U?Z?$:$^B:$|B,ae=U?Z?setIn(z,V,Z,ee):spliceOut(z,V,ee):spliceIn(z,V,Z,ee);return ee?(this.bitmap=ie,this.nodes=ae,this):new BitmapIndexedNode(s,ie,ae)},HashArrayMapNode.prototype.get=function(s,o,i,a){void 0===o&&(o=hash(i));var u=(0===s?o:o>>>s)&C,_=this.nodes[u];return _?_.get(s+w,o,i,a):a},HashArrayMapNode.prototype.update=function(s,o,i,a,u,_,x){void 0===i&&(i=hash(a));var L=(0===o?i:i>>>o)&C,B=u===j,$=this.nodes,U=$[L];if(B&&!U)return this;var V=updateNode(U,s,o+w,i,a,u,_,x);if(V===U)return this;var z=this.count;if(U){if(!V&&--z<We)return packNodes(s,$,z,L)}else z++;var Y=s&&s===this.ownerID,Z=setIn($,L,V,Y);return Y?(this.count=z,this.nodes=Z,this):new HashArrayMapNode(s,z,Z)},HashCollisionNode.prototype.get=function(s,o,i,a){for(var u=this.entries,_=0,w=u.length;_<w;_++)if(is(i,u[_][0]))return u[_][1];return a},HashCollisionNode.prototype.update=function(s,o,i,a,u,_,w){void 0===i&&(i=hash(a));var x=u===j;if(i!==this.keyHash)return x?this:(SetRef(w),SetRef(_),mergeIntoNode(this,s,o,i,[a,u]));for(var C=this.entries,L=0,B=C.length;L<B&&!is(a,C[L][0]);L++);var $=L<B;if($?C[L][1]===u:x)return this;if(SetRef(w),(x||!$)&&SetRef(_),x&&2===B)return new ValueNode(s,this.keyHash,C[1^L]);var U=s&&s===this.ownerID,V=U?C:arrCopy(C);return $?x?L===B-1?V.pop():V[L]=V.pop():V[L]=[a,u]:V.push([a,u]),U?(this.entries=V,this):new HashCollisionNode(s,this.keyHash,V)},ValueNode.prototype.get=function(s,o,i,a){return is(i,this.entry[0])?this.entry[1]:a},ValueNode.prototype.update=function(s,o,i,a,u,_,w){var x=u===j,C=is(a,this.entry[0]);return(C?u===this.entry[1]:x)?this:(SetRef(w),x?void SetRef(_):C?s&&s===this.ownerID?(this.entry[1]=u,this):new ValueNode(s,this.keyHash,[a,u]):(SetRef(_),mergeIntoNode(this,s,o,hash(a),[a,u])))},ArrayMapNode.prototype.iterate=HashCollisionNode.prototype.iterate=function(s,o){for(var i=this.entries,a=0,u=i.length-1;a<=u;a++)if(!1===s(i[o?u-a:a]))return!1},BitmapIndexedNode.prototype.iterate=HashArrayMapNode.prototype.iterate=function(s,o){for(var i=this.nodes,a=0,u=i.length-1;a<=u;a++){var _=i[o?u-a:a];if(_&&!1===_.iterate(s,o))return!1}},ValueNode.prototype.iterate=function(s,o){return s(this.entry)},createClass(MapIterator,Iterator),MapIterator.prototype.next=function(){for(var s=this._type,o=this._stack;o;){var i,a=o.node,u=o.index++;if(a.entry){if(0===u)return mapIteratorValue(s,a.entry)}else if(a.entries){if(u<=(i=a.entries.length-1))return mapIteratorValue(s,a.entries[this._reverse?i-u:u])}else if(u<=(i=a.nodes.length-1)){var _=a.nodes[this._reverse?i-u:u];if(_){if(_.entry)return mapIteratorValue(s,_.entry);o=this._stack=mapIteratorFrame(_,o)}continue}o=this._stack=this._stack.__prev}return iteratorDone()};var qe=x/4,ze=x/2,We=x/4;function List(s){var o=emptyList();if(null==s)return o;if(isList(s))return s;var i=IndexedIterable(s),a=i.size;return 0===a?o:(assertNotInfinite(a),a>0&&a<x?makeList(0,a,w,null,new VNode(i.toArray())):o.withMutations((function(s){s.setSize(a),i.forEach((function(o,i){return s.set(i,o)}))})))}function isList(s){return!(!s||!s[He])}createClass(List,IndexedCollection),List.of=function(){return this(arguments)},List.prototype.toString=function(){return this.__toString("List [","]")},List.prototype.get=function(s,o){if((s=wrapIndex(this,s))>=0&&s<this.size){var i=listNodeFor(this,s+=this._origin);return i&&i.array[s&C]}return o},List.prototype.set=function(s,o){return updateList(this,s,o)},List.prototype.remove=function(s){return this.has(s)?0===s?this.shift():s===this.size-1?this.pop():this.splice(s,1):this},List.prototype.insert=function(s,o){return this.splice(s,0,o)},List.prototype.clear=function(){return 0===this.size?this:this.__ownerID?(this.size=this._origin=this._capacity=0,this._level=w,this._root=this._tail=null,this.__hash=void 0,this.__altered=!0,this):emptyList()},List.prototype.push=function(){var s=arguments,o=this.size;return this.withMutations((function(i){setListBounds(i,0,o+s.length);for(var a=0;a<s.length;a++)i.set(o+a,s[a])}))},List.prototype.pop=function(){return setListBounds(this,0,-1)},List.prototype.unshift=function(){var s=arguments;return this.withMutations((function(o){setListBounds(o,-s.length);for(var i=0;i<s.length;i++)o.set(i,s[i])}))},List.prototype.shift=function(){return setListBounds(this,1)},List.prototype.merge=function(){return mergeIntoListWith(this,void 0,arguments)},List.prototype.mergeWith=function(o){return mergeIntoListWith(this,o,s.call(arguments,1))},List.prototype.mergeDeep=function(){return mergeIntoListWith(this,deepMerger,arguments)},List.prototype.mergeDeepWith=function(o){var i=s.call(arguments,1);return mergeIntoListWith(this,deepMergerWith(o),i)},List.prototype.setSize=function(s){return setListBounds(this,0,s)},List.prototype.slice=function(s,o){var i=this.size;return wholeSlice(s,o,i)?this:setListBounds(this,resolveBegin(s,i),resolveEnd(o,i))},List.prototype.__iterator=function(s,o){var i=0,a=iterateList(this,o);return new Iterator((function(){var o=a();return o===et?iteratorDone():iteratorValue(s,i++,o)}))},List.prototype.__iterate=function(s,o){for(var i,a=0,u=iterateList(this,o);(i=u())!==et&&!1!==s(i,a++,this););return a},List.prototype.__ensureOwner=function(s){return s===this.__ownerID?this:s?makeList(this._origin,this._capacity,this._level,this._root,this._tail,s,this.__hash):(this.__ownerID=s,this)},List.isList=isList;var He="@@__IMMUTABLE_LIST__@@",Ye=List.prototype;function VNode(s,o){this.array=s,this.ownerID=o}Ye[He]=!0,Ye[_]=Ye.remove,Ye.setIn=$e.setIn,Ye.deleteIn=Ye.removeIn=$e.removeIn,Ye.update=$e.update,Ye.updateIn=$e.updateIn,Ye.mergeIn=$e.mergeIn,Ye.mergeDeepIn=$e.mergeDeepIn,Ye.withMutations=$e.withMutations,Ye.asMutable=$e.asMutable,Ye.asImmutable=$e.asImmutable,Ye.wasAltered=$e.wasAltered,VNode.prototype.removeBefore=function(s,o,i){if(i===o?1<<o:0===this.array.length)return this;var a=i>>>o&C;if(a>=this.array.length)return new VNode([],s);var u,_=0===a;if(o>0){var x=this.array[a];if((u=x&&x.removeBefore(s,o-w,i))===x&&_)return this}if(_&&!u)return this;var j=editableVNode(this,s);if(!_)for(var L=0;L<a;L++)j.array[L]=void 0;return u&&(j.array[a]=u),j},VNode.prototype.removeAfter=function(s,o,i){if(i===(o?1<<o:0)||0===this.array.length)return this;var a,u=i-1>>>o&C;if(u>=this.array.length)return this;if(o>0){var _=this.array[u];if((a=_&&_.removeAfter(s,o-w,i))===_&&u===this.array.length-1)return this}var x=editableVNode(this,s);return x.array.splice(u+1),a&&(x.array[u]=a),x};var Xe,Qe,et={};function iterateList(s,o){var i=s._origin,a=s._capacity,u=getTailOffset(a),_=s._tail;return iterateNodeOrLeaf(s._root,s._level,0);function iterateNodeOrLeaf(s,o,i){return 0===o?iterateLeaf(s,i):iterateNode(s,o,i)}function iterateLeaf(s,w){var C=w===u?_&&_.array:s&&s.array,j=w>i?0:i-w,L=a-w;return L>x&&(L=x),function(){if(j===L)return et;var s=o?--L:j++;return C&&C[s]}}function iterateNode(s,u,_){var C,j=s&&s.array,L=_>i?0:i-_>>u,B=1+(a-_>>u);return B>x&&(B=x),function(){for(;;){if(C){var s=C();if(s!==et)return s;C=null}if(L===B)return et;var i=o?--B:L++;C=iterateNodeOrLeaf(j&&j[i],u-w,_+(i<<u))}}}}function makeList(s,o,i,a,u,_,w){var x=Object.create(Ye);return x.size=o-s,x._origin=s,x._capacity=o,x._level=i,x._root=a,x._tail=u,x.__ownerID=_,x.__hash=w,x.__altered=!1,x}function emptyList(){return Xe||(Xe=makeList(0,0,w))}function updateList(s,o,i){if((o=wrapIndex(s,o))!=o)return s;if(o>=s.size||o<0)return s.withMutations((function(s){o<0?setListBounds(s,o).set(0,i):setListBounds(s,0,o+1).set(o,i)}));o+=s._origin;var a=s._tail,u=s._root,_=MakeRef(B);return o>=getTailOffset(s._capacity)?a=updateVNode(a,s.__ownerID,0,o,i,_):u=updateVNode(u,s.__ownerID,s._level,o,i,_),_.value?s.__ownerID?(s._root=u,s._tail=a,s.__hash=void 0,s.__altered=!0,s):makeList(s._origin,s._capacity,s._level,u,a):s}function updateVNode(s,o,i,a,u,_){var x,j=a>>>i&C,L=s&&j<s.array.length;if(!L&&void 0===u)return s;if(i>0){var B=s&&s.array[j],$=updateVNode(B,o,i-w,a,u,_);return $===B?s:((x=editableVNode(s,o)).array[j]=$,x)}return L&&s.array[j]===u?s:(SetRef(_),x=editableVNode(s,o),void 0===u&&j===x.array.length-1?x.array.pop():x.array[j]=u,x)}function editableVNode(s,o){return o&&s&&o===s.ownerID?s:new VNode(s?s.array.slice():[],o)}function listNodeFor(s,o){if(o>=getTailOffset(s._capacity))return s._tail;if(o<1<<s._level+w){for(var i=s._root,a=s._level;i&&a>0;)i=i.array[o>>>a&C],a-=w;return i}}function setListBounds(s,o,i){void 0!==o&&(o|=0),void 0!==i&&(i|=0);var a=s.__ownerID||new OwnerID,u=s._origin,_=s._capacity,x=u+o,j=void 0===i?_:i<0?_+i:u+i;if(x===u&&j===_)return s;if(x>=j)return s.clear();for(var L=s._level,B=s._root,$=0;x+$<0;)B=new VNode(B&&B.array.length?[void 0,B]:[],a),$+=1<<(L+=w);$&&(x+=$,u+=$,j+=$,_+=$);for(var U=getTailOffset(_),V=getTailOffset(j);V>=1<<L+w;)B=new VNode(B&&B.array.length?[B]:[],a),L+=w;var z=s._tail,Y=V<U?listNodeFor(s,j-1):V>U?new VNode([],a):z;if(z&&V>U&&x<_&&z.array.length){for(var Z=B=editableVNode(B,a),ee=L;ee>w;ee-=w){var ie=U>>>ee&C;Z=Z.array[ie]=editableVNode(Z.array[ie],a)}Z.array[U>>>w&C]=z}if(j<_&&(Y=Y&&Y.removeAfter(a,0,j)),x>=V)x-=V,j-=V,L=w,B=null,Y=Y&&Y.removeBefore(a,0,x);else if(x>u||V<U){for($=0;B;){var ae=x>>>L&C;if(ae!==V>>>L&C)break;ae&&($+=(1<<L)*ae),L-=w,B=B.array[ae]}B&&x>u&&(B=B.removeBefore(a,L,x-$)),B&&V<U&&(B=B.removeAfter(a,L,V-$)),$&&(x-=$,j-=$)}return s.__ownerID?(s.size=j-x,s._origin=x,s._capacity=j,s._level=L,s._root=B,s._tail=Y,s.__hash=void 0,s.__altered=!0,s):makeList(x,j,L,B,Y)}function mergeIntoListWith(s,o,i){for(var a=[],u=0,_=0;_<i.length;_++){var w=i[_],x=IndexedIterable(w);x.size>u&&(u=x.size),isIterable(w)||(x=x.map((function(s){return fromJS(s)}))),a.push(x)}return u>s.size&&(s=s.setSize(u)),mergeIntoCollectionWith(s,o,a)}function getTailOffset(s){return s<x?0:s-1>>>w<<w}function OrderedMap(s){return null==s?emptyOrderedMap():isOrderedMap(s)?s:emptyOrderedMap().withMutations((function(o){var i=KeyedIterable(s);assertNotInfinite(i.size),i.forEach((function(s,i){return o.set(i,s)}))}))}function isOrderedMap(s){return isMap(s)&&isOrdered(s)}function makeOrderedMap(s,o,i,a){var u=Object.create(OrderedMap.prototype);return u.size=s?s.size:0,u._map=s,u._list=o,u.__ownerID=i,u.__hash=a,u}function emptyOrderedMap(){return Qe||(Qe=makeOrderedMap(emptyMap(),emptyList()))}function updateOrderedMap(s,o,i){var a,u,_=s._map,w=s._list,C=_.get(o),L=void 0!==C;if(i===j){if(!L)return s;w.size>=x&&w.size>=2*_.size?(a=(u=w.filter((function(s,o){return void 0!==s&&C!==o}))).toKeyedSeq().map((function(s){return s[0]})).flip().toMap(),s.__ownerID&&(a.__ownerID=u.__ownerID=s.__ownerID)):(a=_.remove(o),u=C===w.size-1?w.pop():w.set(C,void 0))}else if(L){if(i===w.get(C)[1])return s;a=_,u=w.set(C,[o,i])}else a=_.set(o,w.size),u=w.set(w.size,[o,i]);return s.__ownerID?(s.size=a.size,s._map=a,s._list=u,s.__hash=void 0,s):makeOrderedMap(a,u)}function ToKeyedSequence(s,o){this._iter=s,this._useKeys=o,this.size=s.size}function ToIndexedSequence(s){this._iter=s,this.size=s.size}function ToSetSequence(s){this._iter=s,this.size=s.size}function FromEntriesSequence(s){this._iter=s,this.size=s.size}function flipFactory(s){var o=makeSequence(s);return o._iter=s,o.size=s.size,o.flip=function(){return s},o.reverse=function(){var o=s.reverse.apply(this);return o.flip=function(){return s.reverse()},o},o.has=function(o){return s.includes(o)},o.includes=function(o){return s.has(o)},o.cacheResult=cacheResultThrough,o.__iterateUncached=function(o,i){var a=this;return s.__iterate((function(s,i){return!1!==o(i,s,a)}),i)},o.__iteratorUncached=function(o,i){if(o===V){var a=s.__iterator(o,i);return new Iterator((function(){var s=a.next();if(!s.done){var o=s.value[0];s.value[0]=s.value[1],s.value[1]=o}return s}))}return s.__iterator(o===U?$:U,i)},o}function mapFactory(s,o,i){var a=makeSequence(s);return a.size=s.size,a.has=function(o){return s.has(o)},a.get=function(a,u){var _=s.get(a,j);return _===j?u:o.call(i,_,a,s)},a.__iterateUncached=function(a,u){var _=this;return s.__iterate((function(s,u,w){return!1!==a(o.call(i,s,u,w),u,_)}),u)},a.__iteratorUncached=function(a,u){var _=s.__iterator(V,u);return new Iterator((function(){var u=_.next();if(u.done)return u;var w=u.value,x=w[0];return iteratorValue(a,x,o.call(i,w[1],x,s),u)}))},a}function reverseFactory(s,o){var i=makeSequence(s);return i._iter=s,i.size=s.size,i.reverse=function(){return s},s.flip&&(i.flip=function(){var o=flipFactory(s);return o.reverse=function(){return s.flip()},o}),i.get=function(i,a){return s.get(o?i:-1-i,a)},i.has=function(i){return s.has(o?i:-1-i)},i.includes=function(o){return s.includes(o)},i.cacheResult=cacheResultThrough,i.__iterate=function(o,i){var a=this;return s.__iterate((function(s,i){return o(s,i,a)}),!i)},i.__iterator=function(o,i){return s.__iterator(o,!i)},i}function filterFactory(s,o,i,a){var u=makeSequence(s);return a&&(u.has=function(a){var u=s.get(a,j);return u!==j&&!!o.call(i,u,a,s)},u.get=function(a,u){var _=s.get(a,j);return _!==j&&o.call(i,_,a,s)?_:u}),u.__iterateUncached=function(u,_){var w=this,x=0;return s.__iterate((function(s,_,C){if(o.call(i,s,_,C))return x++,u(s,a?_:x-1,w)}),_),x},u.__iteratorUncached=function(u,_){var w=s.__iterator(V,_),x=0;return new Iterator((function(){for(;;){var _=w.next();if(_.done)return _;var C=_.value,j=C[0],L=C[1];if(o.call(i,L,j,s))return iteratorValue(u,a?j:x++,L,_)}}))},u}function countByFactory(s,o,i){var a=Map().asMutable();return s.__iterate((function(u,_){a.update(o.call(i,u,_,s),0,(function(s){return s+1}))})),a.asImmutable()}function groupByFactory(s,o,i){var a=isKeyed(s),u=(isOrdered(s)?OrderedMap():Map()).asMutable();s.__iterate((function(_,w){u.update(o.call(i,_,w,s),(function(s){return(s=s||[]).push(a?[w,_]:_),s}))}));var _=iterableClass(s);return u.map((function(o){return reify(s,_(o))}))}function sliceFactory(s,o,i,a){var u=s.size;if(void 0!==o&&(o|=0),void 0!==i&&(i===1/0?i=u:i|=0),wholeSlice(o,i,u))return s;var _=resolveBegin(o,u),w=resolveEnd(i,u);if(_!=_||w!=w)return sliceFactory(s.toSeq().cacheResult(),o,i,a);var x,C=w-_;C==C&&(x=C<0?0:C);var j=makeSequence(s);return j.size=0===x?x:s.size&&x||void 0,!a&&isSeq(s)&&x>=0&&(j.get=function(o,i){return(o=wrapIndex(this,o))>=0&&o<x?s.get(o+_,i):i}),j.__iterateUncached=function(o,i){var u=this;if(0===x)return 0;if(i)return this.cacheResult().__iterate(o,i);var w=0,C=!0,j=0;return s.__iterate((function(s,i){if(!C||!(C=w++<_))return j++,!1!==o(s,a?i:j-1,u)&&j!==x})),j},j.__iteratorUncached=function(o,i){if(0!==x&&i)return this.cacheResult().__iterator(o,i);var u=0!==x&&s.__iterator(o,i),w=0,C=0;return new Iterator((function(){for(;w++<_;)u.next();if(++C>x)return iteratorDone();var s=u.next();return a||o===U?s:iteratorValue(o,C-1,o===$?void 0:s.value[1],s)}))},j}function takeWhileFactory(s,o,i){var a=makeSequence(s);return a.__iterateUncached=function(a,u){var _=this;if(u)return this.cacheResult().__iterate(a,u);var w=0;return s.__iterate((function(s,u,x){return o.call(i,s,u,x)&&++w&&a(s,u,_)})),w},a.__iteratorUncached=function(a,u){var _=this;if(u)return this.cacheResult().__iterator(a,u);var w=s.__iterator(V,u),x=!0;return new Iterator((function(){if(!x)return iteratorDone();var s=w.next();if(s.done)return s;var u=s.value,C=u[0],j=u[1];return o.call(i,j,C,_)?a===V?s:iteratorValue(a,C,j,s):(x=!1,iteratorDone())}))},a}function skipWhileFactory(s,o,i,a){var u=makeSequence(s);return u.__iterateUncached=function(u,_){var w=this;if(_)return this.cacheResult().__iterate(u,_);var x=!0,C=0;return s.__iterate((function(s,_,j){if(!x||!(x=o.call(i,s,_,j)))return C++,u(s,a?_:C-1,w)})),C},u.__iteratorUncached=function(u,_){var w=this;if(_)return this.cacheResult().__iterator(u,_);var x=s.__iterator(V,_),C=!0,j=0;return new Iterator((function(){var s,_,L;do{if((s=x.next()).done)return a||u===U?s:iteratorValue(u,j++,u===$?void 0:s.value[1],s);var B=s.value;_=B[0],L=B[1],C&&(C=o.call(i,L,_,w))}while(C);return u===V?s:iteratorValue(u,_,L,s)}))},u}function concatFactory(s,o){var i=isKeyed(s),a=[s].concat(o).map((function(s){return isIterable(s)?i&&(s=KeyedIterable(s)):s=i?keyedSeqFromValue(s):indexedSeqFromValue(Array.isArray(s)?s:[s]),s})).filter((function(s){return 0!==s.size}));if(0===a.length)return s;if(1===a.length){var u=a[0];if(u===s||i&&isKeyed(u)||isIndexed(s)&&isIndexed(u))return u}var _=new ArraySeq(a);return i?_=_.toKeyedSeq():isIndexed(s)||(_=_.toSetSeq()),(_=_.flatten(!0)).size=a.reduce((function(s,o){if(void 0!==s){var i=o.size;if(void 0!==i)return s+i}}),0),_}function flattenFactory(s,o,i){var a=makeSequence(s);return a.__iterateUncached=function(a,u){var _=0,w=!1;function flatDeep(s,x){var C=this;s.__iterate((function(s,u){return(!o||x<o)&&isIterable(s)?flatDeep(s,x+1):!1===a(s,i?u:_++,C)&&(w=!0),!w}),u)}return flatDeep(s,0),_},a.__iteratorUncached=function(a,u){var _=s.__iterator(a,u),w=[],x=0;return new Iterator((function(){for(;_;){var s=_.next();if(!1===s.done){var C=s.value;if(a===V&&(C=C[1]),o&&!(w.length<o)||!isIterable(C))return i?s:iteratorValue(a,x++,C,s);w.push(_),_=C.__iterator(a,u)}else _=w.pop()}return iteratorDone()}))},a}function flatMapFactory(s,o,i){var a=iterableClass(s);return s.toSeq().map((function(u,_){return a(o.call(i,u,_,s))})).flatten(!0)}function interposeFactory(s,o){var i=makeSequence(s);return i.size=s.size&&2*s.size-1,i.__iterateUncached=function(i,a){var u=this,_=0;return s.__iterate((function(s,a){return(!_||!1!==i(o,_++,u))&&!1!==i(s,_++,u)}),a),_},i.__iteratorUncached=function(i,a){var u,_=s.__iterator(U,a),w=0;return new Iterator((function(){return(!u||w%2)&&(u=_.next()).done?u:w%2?iteratorValue(i,w++,o):iteratorValue(i,w++,u.value,u)}))},i}function sortFactory(s,o,i){o||(o=defaultComparator);var a=isKeyed(s),u=0,_=s.toSeq().map((function(o,a){return[a,o,u++,i?i(o,a,s):o]})).toArray();return _.sort((function(s,i){return o(s[3],i[3])||s[2]-i[2]})).forEach(a?function(s,o){_[o].length=2}:function(s,o){_[o]=s[1]}),a?KeyedSeq(_):isIndexed(s)?IndexedSeq(_):SetSeq(_)}function maxFactory(s,o,i){if(o||(o=defaultComparator),i){var a=s.toSeq().map((function(o,a){return[o,i(o,a,s)]})).reduce((function(s,i){return maxCompare(o,s[1],i[1])?i:s}));return a&&a[0]}return s.reduce((function(s,i){return maxCompare(o,s,i)?i:s}))}function maxCompare(s,o,i){var a=s(i,o);return 0===a&&i!==o&&(null==i||i!=i)||a>0}function zipWithFactory(s,o,i){var a=makeSequence(s);return a.size=new ArraySeq(i).map((function(s){return s.size})).min(),a.__iterate=function(s,o){for(var i,a=this.__iterator(U,o),u=0;!(i=a.next()).done&&!1!==s(i.value,u++,this););return u},a.__iteratorUncached=function(s,a){var u=i.map((function(s){return s=Iterable(s),getIterator(a?s.reverse():s)})),_=0,w=!1;return new Iterator((function(){var i;return w||(i=u.map((function(s){return s.next()})),w=i.some((function(s){return s.done}))),w?iteratorDone():iteratorValue(s,_++,o.apply(null,i.map((function(s){return s.value}))))}))},a}function reify(s,o){return isSeq(s)?o:s.constructor(o)}function validateEntry(s){if(s!==Object(s))throw new TypeError("Expected [K, V] tuple: "+s)}function resolveSize(s){return assertNotInfinite(s.size),ensureSize(s)}function iterableClass(s){return isKeyed(s)?KeyedIterable:isIndexed(s)?IndexedIterable:SetIterable}function makeSequence(s){return Object.create((isKeyed(s)?KeyedSeq:isIndexed(s)?IndexedSeq:SetSeq).prototype)}function cacheResultThrough(){return this._iter.cacheResult?(this._iter.cacheResult(),this.size=this._iter.size,this):Seq.prototype.cacheResult.call(this)}function defaultComparator(s,o){return s>o?1:s<o?-1:0}function forceIterator(s){var o=getIterator(s);if(!o){if(!isArrayLike(s))throw new TypeError("Expected iterable or array-like: "+s);o=getIterator(Iterable(s))}return o}function Record(s,o){var i,a=function Record(_){if(_ instanceof a)return _;if(!(this instanceof a))return new a(_);if(!i){i=!0;var w=Object.keys(s);setProps(u,w),u.size=w.length,u._name=o,u._keys=w,u._defaultValues=s}this._map=Map(_)},u=a.prototype=Object.create(tt);return u.constructor=a,a}createClass(OrderedMap,Map),OrderedMap.of=function(){return this(arguments)},OrderedMap.prototype.toString=function(){return this.__toString("OrderedMap {","}")},OrderedMap.prototype.get=function(s,o){var i=this._map.get(s);return void 0!==i?this._list.get(i)[1]:o},OrderedMap.prototype.clear=function(){return 0===this.size?this:this.__ownerID?(this.size=0,this._map.clear(),this._list.clear(),this):emptyOrderedMap()},OrderedMap.prototype.set=function(s,o){return updateOrderedMap(this,s,o)},OrderedMap.prototype.remove=function(s){return updateOrderedMap(this,s,j)},OrderedMap.prototype.wasAltered=function(){return this._map.wasAltered()||this._list.wasAltered()},OrderedMap.prototype.__iterate=function(s,o){var i=this;return this._list.__iterate((function(o){return o&&s(o[1],o[0],i)}),o)},OrderedMap.prototype.__iterator=function(s,o){return this._list.fromEntrySeq().__iterator(s,o)},OrderedMap.prototype.__ensureOwner=function(s){if(s===this.__ownerID)return this;var o=this._map.__ensureOwner(s),i=this._list.__ensureOwner(s);return s?makeOrderedMap(o,i,s,this.__hash):(this.__ownerID=s,this._map=o,this._list=i,this)},OrderedMap.isOrderedMap=isOrderedMap,OrderedMap.prototype[u]=!0,OrderedMap.prototype[_]=OrderedMap.prototype.remove,createClass(ToKeyedSequence,KeyedSeq),ToKeyedSequence.prototype.get=function(s,o){return this._iter.get(s,o)},ToKeyedSequence.prototype.has=function(s){return this._iter.has(s)},ToKeyedSequence.prototype.valueSeq=function(){return this._iter.valueSeq()},ToKeyedSequence.prototype.reverse=function(){var s=this,o=reverseFactory(this,!0);return this._useKeys||(o.valueSeq=function(){return s._iter.toSeq().reverse()}),o},ToKeyedSequence.prototype.map=function(s,o){var i=this,a=mapFactory(this,s,o);return this._useKeys||(a.valueSeq=function(){return i._iter.toSeq().map(s,o)}),a},ToKeyedSequence.prototype.__iterate=function(s,o){var i,a=this;return this._iter.__iterate(this._useKeys?function(o,i){return s(o,i,a)}:(i=o?resolveSize(this):0,function(u){return s(u,o?--i:i++,a)}),o)},ToKeyedSequence.prototype.__iterator=function(s,o){if(this._useKeys)return this._iter.__iterator(s,o);var i=this._iter.__iterator(U,o),a=o?resolveSize(this):0;return new Iterator((function(){var u=i.next();return u.done?u:iteratorValue(s,o?--a:a++,u.value,u)}))},ToKeyedSequence.prototype[u]=!0,createClass(ToIndexedSequence,IndexedSeq),ToIndexedSequence.prototype.includes=function(s){return this._iter.includes(s)},ToIndexedSequence.prototype.__iterate=function(s,o){var i=this,a=0;return this._iter.__iterate((function(o){return s(o,a++,i)}),o)},ToIndexedSequence.prototype.__iterator=function(s,o){var i=this._iter.__iterator(U,o),a=0;return new Iterator((function(){var o=i.next();return o.done?o:iteratorValue(s,a++,o.value,o)}))},createClass(ToSetSequence,SetSeq),ToSetSequence.prototype.has=function(s){return this._iter.includes(s)},ToSetSequence.prototype.__iterate=function(s,o){var i=this;return this._iter.__iterate((function(o){return s(o,o,i)}),o)},ToSetSequence.prototype.__iterator=function(s,o){var i=this._iter.__iterator(U,o);return new Iterator((function(){var o=i.next();return o.done?o:iteratorValue(s,o.value,o.value,o)}))},createClass(FromEntriesSequence,KeyedSeq),FromEntriesSequence.prototype.entrySeq=function(){return this._iter.toSeq()},FromEntriesSequence.prototype.__iterate=function(s,o){var i=this;return this._iter.__iterate((function(o){if(o){validateEntry(o);var a=isIterable(o);return s(a?o.get(1):o[1],a?o.get(0):o[0],i)}}),o)},FromEntriesSequence.prototype.__iterator=function(s,o){var i=this._iter.__iterator(U,o);return new Iterator((function(){for(;;){var o=i.next();if(o.done)return o;var a=o.value;if(a){validateEntry(a);var u=isIterable(a);return iteratorValue(s,u?a.get(0):a[0],u?a.get(1):a[1],o)}}}))},ToIndexedSequence.prototype.cacheResult=ToKeyedSequence.prototype.cacheResult=ToSetSequence.prototype.cacheResult=FromEntriesSequence.prototype.cacheResult=cacheResultThrough,createClass(Record,KeyedCollection),Record.prototype.toString=function(){return this.__toString(recordName(this)+" {","}")},Record.prototype.has=function(s){return this._defaultValues.hasOwnProperty(s)},Record.prototype.get=function(s,o){if(!this.has(s))return o;var i=this._defaultValues[s];return this._map?this._map.get(s,i):i},Record.prototype.clear=function(){if(this.__ownerID)return this._map&&this._map.clear(),this;var s=this.constructor;return s._empty||(s._empty=makeRecord(this,emptyMap()))},Record.prototype.set=function(s,o){if(!this.has(s))throw new Error('Cannot set unknown key "'+s+'" on '+recordName(this));if(this._map&&!this._map.has(s)&&o===this._defaultValues[s])return this;var i=this._map&&this._map.set(s,o);return this.__ownerID||i===this._map?this:makeRecord(this,i)},Record.prototype.remove=function(s){if(!this.has(s))return this;var o=this._map&&this._map.remove(s);return this.__ownerID||o===this._map?this:makeRecord(this,o)},Record.prototype.wasAltered=function(){return this._map.wasAltered()},Record.prototype.__iterator=function(s,o){var i=this;return KeyedIterable(this._defaultValues).map((function(s,o){return i.get(o)})).__iterator(s,o)},Record.prototype.__iterate=function(s,o){var i=this;return KeyedIterable(this._defaultValues).map((function(s,o){return i.get(o)})).__iterate(s,o)},Record.prototype.__ensureOwner=function(s){if(s===this.__ownerID)return this;var o=this._map&&this._map.__ensureOwner(s);return s?makeRecord(this,o,s):(this.__ownerID=s,this._map=o,this)};var tt=Record.prototype;function makeRecord(s,o,i){var a=Object.create(Object.getPrototypeOf(s));return a._map=o,a.__ownerID=i,a}function recordName(s){return s._name||s.constructor.name||"Record"}function setProps(s,o){try{o.forEach(setProp.bind(void 0,s))}catch(s){}}function setProp(s,o){Object.defineProperty(s,o,{get:function(){return this.get(o)},set:function(s){invariant(this.__ownerID,"Cannot set on an immutable record."),this.set(o,s)}})}function Set(s){return null==s?emptySet():isSet(s)&&!isOrdered(s)?s:emptySet().withMutations((function(o){var i=SetIterable(s);assertNotInfinite(i.size),i.forEach((function(s){return o.add(s)}))}))}function isSet(s){return!(!s||!s[nt])}tt[_]=tt.remove,tt.deleteIn=tt.removeIn=$e.removeIn,tt.merge=$e.merge,tt.mergeWith=$e.mergeWith,tt.mergeIn=$e.mergeIn,tt.mergeDeep=$e.mergeDeep,tt.mergeDeepWith=$e.mergeDeepWith,tt.mergeDeepIn=$e.mergeDeepIn,tt.setIn=$e.setIn,tt.update=$e.update,tt.updateIn=$e.updateIn,tt.withMutations=$e.withMutations,tt.asMutable=$e.asMutable,tt.asImmutable=$e.asImmutable,createClass(Set,SetCollection),Set.of=function(){return this(arguments)},Set.fromKeys=function(s){return this(KeyedIterable(s).keySeq())},Set.prototype.toString=function(){return this.__toString("Set {","}")},Set.prototype.has=function(s){return this._map.has(s)},Set.prototype.add=function(s){return updateSet(this,this._map.set(s,!0))},Set.prototype.remove=function(s){return updateSet(this,this._map.remove(s))},Set.prototype.clear=function(){return updateSet(this,this._map.clear())},Set.prototype.union=function(){var o=s.call(arguments,0);return 0===(o=o.filter((function(s){return 0!==s.size}))).length?this:0!==this.size||this.__ownerID||1!==o.length?this.withMutations((function(s){for(var i=0;i<o.length;i++)SetIterable(o[i]).forEach((function(o){return s.add(o)}))})):this.constructor(o[0])},Set.prototype.intersect=function(){var o=s.call(arguments,0);if(0===o.length)return this;o=o.map((function(s){return SetIterable(s)}));var i=this;return this.withMutations((function(s){i.forEach((function(i){o.every((function(s){return s.includes(i)}))||s.remove(i)}))}))},Set.prototype.subtract=function(){var o=s.call(arguments,0);if(0===o.length)return this;o=o.map((function(s){return SetIterable(s)}));var i=this;return this.withMutations((function(s){i.forEach((function(i){o.some((function(s){return s.includes(i)}))&&s.remove(i)}))}))},Set.prototype.merge=function(){return this.union.apply(this,arguments)},Set.prototype.mergeWith=function(o){var i=s.call(arguments,1);return this.union.apply(this,i)},Set.prototype.sort=function(s){return OrderedSet(sortFactory(this,s))},Set.prototype.sortBy=function(s,o){return OrderedSet(sortFactory(this,o,s))},Set.prototype.wasAltered=function(){return this._map.wasAltered()},Set.prototype.__iterate=function(s,o){var i=this;return this._map.__iterate((function(o,a){return s(a,a,i)}),o)},Set.prototype.__iterator=function(s,o){return this._map.map((function(s,o){return o})).__iterator(s,o)},Set.prototype.__ensureOwner=function(s){if(s===this.__ownerID)return this;var o=this._map.__ensureOwner(s);return s?this.__make(o,s):(this.__ownerID=s,this._map=o,this)},Set.isSet=isSet;var rt,nt="@@__IMMUTABLE_SET__@@",st=Set.prototype;function updateSet(s,o){return s.__ownerID?(s.size=o.size,s._map=o,s):o===s._map?s:0===o.size?s.__empty():s.__make(o)}function makeSet(s,o){var i=Object.create(st);return i.size=s?s.size:0,i._map=s,i.__ownerID=o,i}function emptySet(){return rt||(rt=makeSet(emptyMap()))}function OrderedSet(s){return null==s?emptyOrderedSet():isOrderedSet(s)?s:emptyOrderedSet().withMutations((function(o){var i=SetIterable(s);assertNotInfinite(i.size),i.forEach((function(s){return o.add(s)}))}))}function isOrderedSet(s){return isSet(s)&&isOrdered(s)}st[nt]=!0,st[_]=st.remove,st.mergeDeep=st.merge,st.mergeDeepWith=st.mergeWith,st.withMutations=$e.withMutations,st.asMutable=$e.asMutable,st.asImmutable=$e.asImmutable,st.__empty=emptySet,st.__make=makeSet,createClass(OrderedSet,Set),OrderedSet.of=function(){return this(arguments)},OrderedSet.fromKeys=function(s){return this(KeyedIterable(s).keySeq())},OrderedSet.prototype.toString=function(){return this.__toString("OrderedSet {","}")},OrderedSet.isOrderedSet=isOrderedSet;var ot,it=OrderedSet.prototype;function makeOrderedSet(s,o){var i=Object.create(it);return i.size=s?s.size:0,i._map=s,i.__ownerID=o,i}function emptyOrderedSet(){return ot||(ot=makeOrderedSet(emptyOrderedMap()))}function Stack(s){return null==s?emptyStack():isStack(s)?s:emptyStack().unshiftAll(s)}function isStack(s){return!(!s||!s[ct])}it[u]=!0,it.__empty=emptyOrderedSet,it.__make=makeOrderedSet,createClass(Stack,IndexedCollection),Stack.of=function(){return this(arguments)},Stack.prototype.toString=function(){return this.__toString("Stack [","]")},Stack.prototype.get=function(s,o){var i=this._head;for(s=wrapIndex(this,s);i&&s--;)i=i.next;return i?i.value:o},Stack.prototype.peek=function(){return this._head&&this._head.value},Stack.prototype.push=function(){if(0===arguments.length)return this;for(var s=this.size+arguments.length,o=this._head,i=arguments.length-1;i>=0;i--)o={value:arguments[i],next:o};return this.__ownerID?(this.size=s,this._head=o,this.__hash=void 0,this.__altered=!0,this):makeStack(s,o)},Stack.prototype.pushAll=function(s){if(0===(s=IndexedIterable(s)).size)return this;assertNotInfinite(s.size);var o=this.size,i=this._head;return s.reverse().forEach((function(s){o++,i={value:s,next:i}})),this.__ownerID?(this.size=o,this._head=i,this.__hash=void 0,this.__altered=!0,this):makeStack(o,i)},Stack.prototype.pop=function(){return this.slice(1)},Stack.prototype.unshift=function(){return this.push.apply(this,arguments)},Stack.prototype.unshiftAll=function(s){return this.pushAll(s)},Stack.prototype.shift=function(){return this.pop.apply(this,arguments)},Stack.prototype.clear=function(){return 0===this.size?this:this.__ownerID?(this.size=0,this._head=void 0,this.__hash=void 0,this.__altered=!0,this):emptyStack()},Stack.prototype.slice=function(s,o){if(wholeSlice(s,o,this.size))return this;var i=resolveBegin(s,this.size);if(resolveEnd(o,this.size)!==this.size)return IndexedCollection.prototype.slice.call(this,s,o);for(var a=this.size-i,u=this._head;i--;)u=u.next;return this.__ownerID?(this.size=a,this._head=u,this.__hash=void 0,this.__altered=!0,this):makeStack(a,u)},Stack.prototype.__ensureOwner=function(s){return s===this.__ownerID?this:s?makeStack(this.size,this._head,s,this.__hash):(this.__ownerID=s,this.__altered=!1,this)},Stack.prototype.__iterate=function(s,o){if(o)return this.reverse().__iterate(s);for(var i=0,a=this._head;a&&!1!==s(a.value,i++,this);)a=a.next;return i},Stack.prototype.__iterator=function(s,o){if(o)return this.reverse().__iterator(s);var i=0,a=this._head;return new Iterator((function(){if(a){var o=a.value;return a=a.next,iteratorValue(s,i++,o)}return iteratorDone()}))},Stack.isStack=isStack;var at,ct="@@__IMMUTABLE_STACK__@@",lt=Stack.prototype;function makeStack(s,o,i,a){var u=Object.create(lt);return u.size=s,u._head=o,u.__ownerID=i,u.__hash=a,u.__altered=!1,u}function emptyStack(){return at||(at=makeStack(0))}function mixin(s,o){var keyCopier=function(i){s.prototype[i]=o[i]};return Object.keys(o).forEach(keyCopier),Object.getOwnPropertySymbols&&Object.getOwnPropertySymbols(o).forEach(keyCopier),s}function isProtoKey(s){return"string"==typeof s&&("__proto__"===s||"constructor"===s)}lt[ct]=!0,lt.withMutations=$e.withMutations,lt.asMutable=$e.asMutable,lt.asImmutable=$e.asImmutable,lt.wasAltered=$e.wasAltered,Iterable.Iterator=Iterator,mixin(Iterable,{toArray:function(){assertNotInfinite(this.size);var s=new Array(this.size||0);return this.valueSeq().__iterate((function(o,i){s[i]=o})),s},toIndexedSeq:function(){return new ToIndexedSequence(this)},toJS:function(){return this.toSeq().map((function(s){return s&&"function"==typeof s.toJS?s.toJS():s})).__toJS()},toJSON:function(){return this.toSeq().map((function(s){return s&&"function"==typeof s.toJSON?s.toJSON():s})).__toJS()},toKeyedSeq:function(){return new ToKeyedSequence(this,!0)},toMap:function(){return Map(this.toKeyedSeq())},toObject:function(){assertNotInfinite(this.size);var s={};return this.__iterate((function(o,i){isProtoKey(i)||(s[i]=o)})),s},toOrderedMap:function(){return OrderedMap(this.toKeyedSeq())},toOrderedSet:function(){return OrderedSet(isKeyed(this)?this.valueSeq():this)},toSet:function(){return Set(isKeyed(this)?this.valueSeq():this)},toSetSeq:function(){return new ToSetSequence(this)},toSeq:function(){return isIndexed(this)?this.toIndexedSeq():isKeyed(this)?this.toKeyedSeq():this.toSetSeq()},toStack:function(){return Stack(isKeyed(this)?this.valueSeq():this)},toList:function(){return List(isKeyed(this)?this.valueSeq():this)},toString:function(){return"[Iterable]"},__toString:function(s,o){return 0===this.size?s+o:s+" "+this.toSeq().map(this.__toStringMapper).join(", ")+" "+o},concat:function(){return reify(this,concatFactory(this,s.call(arguments,0)))},includes:function(s){return this.some((function(o){return is(o,s)}))},entries:function(){return this.__iterator(V)},every:function(s,o){assertNotInfinite(this.size);var i=!0;return this.__iterate((function(a,u,_){if(!s.call(o,a,u,_))return i=!1,!1})),i},filter:function(s,o){return reify(this,filterFactory(this,s,o,!0))},find:function(s,o,i){var a=this.findEntry(s,o);return a?a[1]:i},forEach:function(s,o){return assertNotInfinite(this.size),this.__iterate(o?s.bind(o):s)},join:function(s){assertNotInfinite(this.size),s=void 0!==s?""+s:",";var o="",i=!0;return this.__iterate((function(a){i?i=!1:o+=s,o+=null!=a?a.toString():""})),o},keys:function(){return this.__iterator($)},map:function(s,o){return reify(this,mapFactory(this,s,o))},reduce:function(s,o,i){var a,u;return assertNotInfinite(this.size),arguments.length<2?u=!0:a=o,this.__iterate((function(o,_,w){u?(u=!1,a=o):a=s.call(i,a,o,_,w)})),a},reduceRight:function(s,o,i){var a=this.toKeyedSeq().reverse();return a.reduce.apply(a,arguments)},reverse:function(){return reify(this,reverseFactory(this,!0))},slice:function(s,o){return reify(this,sliceFactory(this,s,o,!0))},some:function(s,o){return!this.every(not(s),o)},sort:function(s){return reify(this,sortFactory(this,s))},values:function(){return this.__iterator(U)},butLast:function(){return this.slice(0,-1)},isEmpty:function(){return void 0!==this.size?0===this.size:!this.some((function(){return!0}))},count:function(s,o){return ensureSize(s?this.toSeq().filter(s,o):this)},countBy:function(s,o){return countByFactory(this,s,o)},equals:function(s){return deepEqual(this,s)},entrySeq:function(){var s=this;if(s._cache)return new ArraySeq(s._cache);var o=s.toSeq().map(entryMapper).toIndexedSeq();return o.fromEntrySeq=function(){return s.toSeq()},o},filterNot:function(s,o){return this.filter(not(s),o)},findEntry:function(s,o,i){var a=i;return this.__iterate((function(i,u,_){if(s.call(o,i,u,_))return a=[u,i],!1})),a},findKey:function(s,o){var i=this.findEntry(s,o);return i&&i[0]},findLast:function(s,o,i){return this.toKeyedSeq().reverse().find(s,o,i)},findLastEntry:function(s,o,i){return this.toKeyedSeq().reverse().findEntry(s,o,i)},findLastKey:function(s,o){return this.toKeyedSeq().reverse().findKey(s,o)},first:function(){return this.find(returnTrue)},flatMap:function(s,o){return reify(this,flatMapFactory(this,s,o))},flatten:function(s){return reify(this,flattenFactory(this,s,!0))},fromEntrySeq:function(){return new FromEntriesSequence(this)},get:function(s,o){return this.find((function(o,i){return is(i,s)}),void 0,o)},getIn:function(s,o){for(var i,a=this,u=forceIterator(s);!(i=u.next()).done;){var _=i.value;if((a=a&&a.get?a.get(_,j):j)===j)return o}return a},groupBy:function(s,o){return groupByFactory(this,s,o)},has:function(s){return this.get(s,j)!==j},hasIn:function(s){return this.getIn(s,j)!==j},isSubset:function(s){return s="function"==typeof s.includes?s:Iterable(s),this.every((function(o){return s.includes(o)}))},isSuperset:function(s){return(s="function"==typeof s.isSubset?s:Iterable(s)).isSubset(this)},keyOf:function(s){return this.findKey((function(o){return is(o,s)}))},keySeq:function(){return this.toSeq().map(keyMapper).toIndexedSeq()},last:function(){return this.toSeq().reverse().first()},lastKeyOf:function(s){return this.toKeyedSeq().reverse().keyOf(s)},max:function(s){return maxFactory(this,s)},maxBy:function(s,o){return maxFactory(this,o,s)},min:function(s){return maxFactory(this,s?neg(s):defaultNegComparator)},minBy:function(s,o){return maxFactory(this,o?neg(o):defaultNegComparator,s)},rest:function(){return this.slice(1)},skip:function(s){return this.slice(Math.max(0,s))},skipLast:function(s){return reify(this,this.toSeq().reverse().skip(s).reverse())},skipWhile:function(s,o){return reify(this,skipWhileFactory(this,s,o,!0))},skipUntil:function(s,o){return this.skipWhile(not(s),o)},sortBy:function(s,o){return reify(this,sortFactory(this,o,s))},take:function(s){return this.slice(0,Math.max(0,s))},takeLast:function(s){return reify(this,this.toSeq().reverse().take(s).reverse())},takeWhile:function(s,o){return reify(this,takeWhileFactory(this,s,o))},takeUntil:function(s,o){return this.takeWhile(not(s),o)},valueSeq:function(){return this.toIndexedSeq()},hashCode:function(){return this.__hash||(this.__hash=hashIterable(this))}});var ut=Iterable.prototype;ut[o]=!0,ut[Z]=ut.values,ut.__toJS=ut.toArray,ut.__toStringMapper=quoteString,ut.inspect=ut.toSource=function(){return this.toString()},ut.chain=ut.flatMap,ut.contains=ut.includes,mixin(KeyedIterable,{flip:function(){return reify(this,flipFactory(this))},mapEntries:function(s,o){var i=this,a=0;return reify(this,this.toSeq().map((function(u,_){return s.call(o,[_,u],a++,i)})).fromEntrySeq())},mapKeys:function(s,o){var i=this;return reify(this,this.toSeq().flip().map((function(a,u){return s.call(o,a,u,i)})).flip())}});var pt=KeyedIterable.prototype;function keyMapper(s,o){return o}function entryMapper(s,o){return[o,s]}function not(s){return function(){return!s.apply(this,arguments)}}function neg(s){return function(){return-s.apply(this,arguments)}}function quoteString(s){return"string"==typeof s?JSON.stringify(s):String(s)}function defaultZipper(){return arrCopy(arguments)}function defaultNegComparator(s,o){return s<o?1:s>o?-1:0}function hashIterable(s){if(s.size===1/0)return 0;var o=isOrdered(s),i=isKeyed(s),a=o?1:0;return murmurHashOfSize(s.__iterate(i?o?function(s,o){a=31*a+hashMerge(hash(s),hash(o))|0}:function(s,o){a=a+hashMerge(hash(s),hash(o))|0}:o?function(s){a=31*a+hash(s)|0}:function(s){a=a+hash(s)|0}),a)}function murmurHashOfSize(s,o){return o=le(o,3432918353),o=le(o<<15|o>>>-15,461845907),o=le(o<<13|o>>>-13,5),o=le((o=o+3864292196^s)^o>>>16,2246822507),o=smi((o=le(o^o>>>13,3266489909))^o>>>16)}function hashMerge(s,o){return s^o+2654435769+(s<<6)+(s>>2)}return pt[i]=!0,pt[Z]=ut.entries,pt.__toJS=ut.toObject,pt.__toStringMapper=function(s,o){return JSON.stringify(o)+": "+quoteString(s)},mixin(IndexedIterable,{toKeyedSeq:function(){return new ToKeyedSequence(this,!1)},filter:function(s,o){return reify(this,filterFactory(this,s,o,!1))},findIndex:function(s,o){var i=this.findEntry(s,o);return i?i[0]:-1},indexOf:function(s){var o=this.keyOf(s);return void 0===o?-1:o},lastIndexOf:function(s){var o=this.lastKeyOf(s);return void 0===o?-1:o},reverse:function(){return reify(this,reverseFactory(this,!1))},slice:function(s,o){return reify(this,sliceFactory(this,s,o,!1))},splice:function(s,o){var i=arguments.length;if(o=Math.max(0|o,0),0===i||2===i&&!o)return this;s=resolveBegin(s,s<0?this.count():this.size);var a=this.slice(0,s);return reify(this,1===i?a:a.concat(arrCopy(arguments,2),this.slice(s+o)))},findLastIndex:function(s,o){var i=this.findLastEntry(s,o);return i?i[0]:-1},first:function(){return this.get(0)},flatten:function(s){return reify(this,flattenFactory(this,s,!1))},get:function(s,o){return(s=wrapIndex(this,s))<0||this.size===1/0||void 0!==this.size&&s>this.size?o:this.find((function(o,i){return i===s}),void 0,o)},has:function(s){return(s=wrapIndex(this,s))>=0&&(void 0!==this.size?this.size===1/0||s<this.size:-1!==this.indexOf(s))},interpose:function(s){return reify(this,interposeFactory(this,s))},interleave:function(){var s=[this].concat(arrCopy(arguments)),o=zipWithFactory(this.toSeq(),IndexedSeq.of,s),i=o.flatten(!0);return o.size&&(i.size=o.size*s.length),reify(this,i)},keySeq:function(){return Range(0,this.size)},last:function(){return this.get(-1)},skipWhile:function(s,o){return reify(this,skipWhileFactory(this,s,o,!1))},zip:function(){return reify(this,zipWithFactory(this,defaultZipper,[this].concat(arrCopy(arguments))))},zipWith:function(s){var o=arrCopy(arguments);return o[0]=this,reify(this,zipWithFactory(this,s,o))}}),IndexedIterable.prototype[a]=!0,IndexedIterable.prototype[u]=!0,mixin(SetIterable,{get:function(s,o){return this.has(s)?s:o},includes:function(s){return this.has(s)},keySeq:function(){return this.valueSeq()}}),SetIterable.prototype.has=ut.includes,SetIterable.prototype.contains=SetIterable.prototype.includes,mixin(KeyedSeq,KeyedIterable.prototype),mixin(IndexedSeq,IndexedIterable.prototype),mixin(SetSeq,SetIterable.prototype),mixin(KeyedCollection,KeyedIterable.prototype),mixin(IndexedCollection,IndexedIterable.prototype),mixin(SetCollection,SetIterable.prototype),{Iterable,Seq,Collection,Map,OrderedMap,List,Stack,Set,OrderedSet,Record,Range,Repeat,is,fromJS}}()},56698(s){"function"==typeof Object.create?s.exports=function inherits(s,o){o&&(s.super_=o,s.prototype=Object.create(o.prototype,{constructor:{value:s,enumerable:!1,writable:!0,configurable:!0}}))}:s.exports=function inherits(s,o){if(o){s.super_=o;var TempCtor=function(){};TempCtor.prototype=o.prototype,s.prototype=new TempCtor,s.prototype.constructor=s}}},69600(s){"use strict";var o,i,a=Function.prototype.toString,u="object"==typeof Reflect&&null!==Reflect&&Reflect.apply;if("function"==typeof u&&"function"==typeof Object.defineProperty)try{o=Object.defineProperty({},"length",{get:function(){throw i}}),i={},u((function(){throw 42}),null,o)}catch(s){s!==i&&(u=null)}else u=null;var _=/^\s*class\b/,w=function isES6ClassFunction(s){try{var o=a.call(s);return _.test(o)}catch(s){return!1}},x=function tryFunctionToStr(s){try{return!w(s)&&(a.call(s),!0)}catch(s){return!1}},C=Object.prototype.toString,j="function"==typeof Symbol&&!!Symbol.toStringTag,L=!(0 in[,]),B=function isDocumentDotAll(){return!1};if("object"==typeof document){var $=document.all;C.call($)===C.call(document.all)&&(B=function isDocumentDotAll(s){if((L||!s)&&(void 0===s||"object"==typeof s))try{var o=C.call(s);return("[object HTMLAllCollection]"===o||"[object HTML document.all class]"===o||"[object HTMLCollection]"===o||"[object Object]"===o)&&null==s("")}catch(s){}return!1})}s.exports=u?function isCallable(s){if(B(s))return!0;if(!s)return!1;if("function"!=typeof s&&"object"!=typeof s)return!1;try{u(s,null,o)}catch(s){if(s!==i)return!1}return!w(s)&&x(s)}:function isCallable(s){if(B(s))return!0;if(!s)return!1;if("function"!=typeof s&&"object"!=typeof s)return!1;if(j)return x(s);if(w(s))return!1;var o=C.call(s);return!("[object Function]"!==o&&"[object GeneratorFunction]"!==o&&!/^\[object HTML/.test(o))&&x(s)}},35680(s,o,i){"use strict";var a=i(25767);s.exports=function isTypedArray(s){return!!a(s)}},64634(s){var o={}.toString;s.exports=Array.isArray||function(s){return"[object Array]"==o.call(s)}},5419(s){s.exports=function(s,o,i,a){var u=new Blob(void 0!==a?[a,s]:[s],{type:i||"application/octet-stream"});if(void 0!==window.navigator.msSaveBlob)window.navigator.msSaveBlob(u,o);else{var _=window.URL&&window.URL.createObjectURL?window.URL.createObjectURL(u):window.webkitURL.createObjectURL(u),w=document.createElement("a");w.style.display="none",w.href=_,w.setAttribute("download",o),void 0===w.download&&w.setAttribute("target","_blank"),document.body.appendChild(w),w.click(),setTimeout((function(){document.body.removeChild(w),window.URL.revokeObjectURL(_)}),200)}}},20181(s,o,i){var a=/^\s+|\s+$/g,u=/^[-+]0x[0-9a-f]+$/i,_=/^0b[01]+$/i,w=/^0o[0-7]+$/i,x=parseInt,C="object"==typeof i.g&&i.g&&i.g.Object===Object&&i.g,j="object"==typeof self&&self&&self.Object===Object&&self,L=C||j||Function("return this")(),B=Object.prototype.toString,$=Math.max,U=Math.min,now=function(){return L.Date.now()};function isObject(s){var o=typeof s;return!!s&&("object"==o||"function"==o)}function toNumber(s){if("number"==typeof s)return s;if(function isSymbol(s){return"symbol"==typeof s||function isObjectLike(s){return!!s&&"object"==typeof s}(s)&&"[object Symbol]"==B.call(s)}(s))return NaN;if(isObject(s)){var o="function"==typeof s.valueOf?s.valueOf():s;s=isObject(o)?o+"":o}if("string"!=typeof s)return 0===s?s:+s;s=s.replace(a,"");var i=_.test(s);return i||w.test(s)?x(s.slice(2),i?2:8):u.test(s)?NaN:+s}s.exports=function debounce(s,o,i){var a,u,_,w,x,C,j=0,L=!1,B=!1,V=!0;if("function"!=typeof s)throw new TypeError("Expected a function");function invokeFunc(o){var i=a,_=u;return a=u=void 0,j=o,w=s.apply(_,i)}function shouldInvoke(s){var i=s-C;return void 0===C||i>=o||i<0||B&&s-j>=_}function timerExpired(){var s=now();if(shouldInvoke(s))return trailingEdge(s);x=setTimeout(timerExpired,function remainingWait(s){var i=o-(s-C);return B?U(i,_-(s-j)):i}(s))}function trailingEdge(s){return x=void 0,V&&a?invokeFunc(s):(a=u=void 0,w)}function debounced(){var s=now(),i=shouldInvoke(s);if(a=arguments,u=this,C=s,i){if(void 0===x)return function leadingEdge(s){return j=s,x=setTimeout(timerExpired,o),L?invokeFunc(s):w}(C);if(B)return x=setTimeout(timerExpired,o),invokeFunc(C)}return void 0===x&&(x=setTimeout(timerExpired,o)),w}return o=toNumber(o)||0,isObject(i)&&(L=!!i.leading,_=(B="maxWait"in i)?$(toNumber(i.maxWait)||0,o):_,V="trailing"in i?!!i.trailing:V),debounced.cancel=function cancel(){void 0!==x&&clearTimeout(x),j=0,a=C=u=x=void 0},debounced.flush=function flush(){return void 0===x?w:trailingEdge(now())},debounced}},55580(s,o,i){var a=i(56110)(i(9325),"DataView");s.exports=a},21549(s,o,i){var a=i(22032),u=i(63862),_=i(66721),w=i(12749),x=i(35749);function Hash(s){var o=-1,i=null==s?0:s.length;for(this.clear();++o<i;){var a=s[o];this.set(a[0],a[1])}}Hash.prototype.clear=a,Hash.prototype.delete=u,Hash.prototype.get=_,Hash.prototype.has=w,Hash.prototype.set=x,s.exports=Hash},30980(s,o,i){var a=i(39344),u=i(94033);function LazyWrapper(s){this.__wrapped__=s,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[]}LazyWrapper.prototype=a(u.prototype),LazyWrapper.prototype.constructor=LazyWrapper,s.exports=LazyWrapper},80079(s,o,i){var a=i(63702),u=i(70080),_=i(24739),w=i(48655),x=i(31175);function ListCache(s){var o=-1,i=null==s?0:s.length;for(this.clear();++o<i;){var a=s[o];this.set(a[0],a[1])}}ListCache.prototype.clear=a,ListCache.prototype.delete=u,ListCache.prototype.get=_,ListCache.prototype.has=w,ListCache.prototype.set=x,s.exports=ListCache},56017(s,o,i){var a=i(39344),u=i(94033);function LodashWrapper(s,o){this.__wrapped__=s,this.__actions__=[],this.__chain__=!!o,this.__index__=0,this.__values__=void 0}LodashWrapper.prototype=a(u.prototype),LodashWrapper.prototype.constructor=LodashWrapper,s.exports=LodashWrapper},68223(s,o,i){var a=i(56110)(i(9325),"Map");s.exports=a},53661(s,o,i){var a=i(63040),u=i(17670),_=i(90289),w=i(4509),x=i(72949);function MapCache(s){var o=-1,i=null==s?0:s.length;for(this.clear();++o<i;){var a=s[o];this.set(a[0],a[1])}}MapCache.prototype.clear=a,MapCache.prototype.delete=u,MapCache.prototype.get=_,MapCache.prototype.has=w,MapCache.prototype.set=x,s.exports=MapCache},32804(s,o,i){var a=i(56110)(i(9325),"Promise");s.exports=a},76545(s,o,i){var a=i(56110)(i(9325),"Set");s.exports=a},38859(s,o,i){var a=i(53661),u=i(31380),_=i(51459);function SetCache(s){var o=-1,i=null==s?0:s.length;for(this.__data__=new a;++o<i;)this.add(s[o])}SetCache.prototype.add=SetCache.prototype.push=u,SetCache.prototype.has=_,s.exports=SetCache},37217(s,o,i){var a=i(80079),u=i(51420),_=i(90938),w=i(63605),x=i(29817),C=i(80945);function Stack(s){var o=this.__data__=new a(s);this.size=o.size}Stack.prototype.clear=u,Stack.prototype.delete=_,Stack.prototype.get=w,Stack.prototype.has=x,Stack.prototype.set=C,s.exports=Stack},51873(s,o,i){var a=i(9325).Symbol;s.exports=a},37828(s,o,i){var a=i(9325).Uint8Array;s.exports=a},28303(s,o,i){var a=i(56110)(i(9325),"WeakMap");s.exports=a},91033(s){s.exports=function apply(s,o,i){switch(i.length){case 0:return s.call(o);case 1:return s.call(o,i[0]);case 2:return s.call(o,i[0],i[1]);case 3:return s.call(o,i[0],i[1],i[2])}return s.apply(o,i)}},83729(s){s.exports=function arrayEach(s,o){for(var i=-1,a=null==s?0:s.length;++i<a&&!1!==o(s[i],i,s););return s}},79770(s){s.exports=function arrayFilter(s,o){for(var i=-1,a=null==s?0:s.length,u=0,_=[];++i<a;){var w=s[i];o(w,i,s)&&(_[u++]=w)}return _}},15325(s,o,i){var a=i(96131);s.exports=function arrayIncludes(s,o){return!!(null==s?0:s.length)&&a(s,o,0)>-1}},70695(s,o,i){var a=i(78096),u=i(72428),_=i(56449),w=i(3656),x=i(30361),C=i(37167),j=Object.prototype.hasOwnProperty;s.exports=function arrayLikeKeys(s,o){var i=_(s),L=!i&&u(s),B=!i&&!L&&w(s),$=!i&&!L&&!B&&C(s),U=i||L||B||$,V=U?a(s.length,String):[],z=V.length;for(var Y in s)!o&&!j.call(s,Y)||U&&("length"==Y||B&&("offset"==Y||"parent"==Y)||$&&("buffer"==Y||"byteLength"==Y||"byteOffset"==Y)||x(Y,z))||V.push(Y);return V}},34932(s){s.exports=function arrayMap(s,o){for(var i=-1,a=null==s?0:s.length,u=Array(a);++i<a;)u[i]=o(s[i],i,s);return u}},14528(s){s.exports=function arrayPush(s,o){for(var i=-1,a=o.length,u=s.length;++i<a;)s[u+i]=o[i];return s}},40882(s){s.exports=function arrayReduce(s,o,i,a){var u=-1,_=null==s?0:s.length;for(a&&_&&(i=s[++u]);++u<_;)i=o(i,s[u],u,s);return i}},14248(s){s.exports=function arraySome(s,o){for(var i=-1,a=null==s?0:s.length;++i<a;)if(o(s[i],i,s))return!0;return!1}},61074(s){s.exports=function asciiToArray(s){return s.split("")}},1733(s){var o=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;s.exports=function asciiWords(s){return s.match(o)||[]}},87805(s,o,i){var a=i(43360),u=i(75288);s.exports=function assignMergeValue(s,o,i){(void 0!==i&&!u(s[o],i)||void 0===i&&!(o in s))&&a(s,o,i)}},16547(s,o,i){var a=i(43360),u=i(75288),_=Object.prototype.hasOwnProperty;s.exports=function assignValue(s,o,i){var w=s[o];_.call(s,o)&&u(w,i)&&(void 0!==i||o in s)||a(s,o,i)}},26025(s,o,i){var a=i(75288);s.exports=function assocIndexOf(s,o){for(var i=s.length;i--;)if(a(s[i][0],o))return i;return-1}},74733(s,o,i){var a=i(21791),u=i(95950);s.exports=function baseAssign(s,o){return s&&a(o,u(o),s)}},43838(s,o,i){var a=i(21791),u=i(37241);s.exports=function baseAssignIn(s,o){return s&&a(o,u(o),s)}},43360(s,o,i){var a=i(93243);s.exports=function baseAssignValue(s,o,i){"__proto__"==o&&a?a(s,o,{configurable:!0,enumerable:!0,value:i,writable:!0}):s[o]=i}},9999(s,o,i){var a=i(37217),u=i(83729),_=i(16547),w=i(74733),x=i(43838),C=i(93290),j=i(23007),L=i(92271),B=i(48948),$=i(50002),U=i(83349),V=i(5861),z=i(76189),Y=i(77199),Z=i(35529),ee=i(56449),ie=i(3656),ae=i(87730),ce=i(23805),le=i(38440),pe=i(95950),de=i(37241),fe="[object Arguments]",ye="[object Function]",be="[object Object]",Se={};Se[fe]=Se["[object Array]"]=Se["[object ArrayBuffer]"]=Se["[object DataView]"]=Se["[object Boolean]"]=Se["[object Date]"]=Se["[object Float32Array]"]=Se["[object Float64Array]"]=Se["[object Int8Array]"]=Se["[object Int16Array]"]=Se["[object Int32Array]"]=Se["[object Map]"]=Se["[object Number]"]=Se[be]=Se["[object RegExp]"]=Se["[object Set]"]=Se["[object String]"]=Se["[object Symbol]"]=Se["[object Uint8Array]"]=Se["[object Uint8ClampedArray]"]=Se["[object Uint16Array]"]=Se["[object Uint32Array]"]=!0,Se["[object Error]"]=Se[ye]=Se["[object WeakMap]"]=!1,s.exports=function baseClone(s,o,i,_e,we,xe){var Pe,Te=1&o,Re=2&o,$e=4&o;if(i&&(Pe=we?i(s,_e,we,xe):i(s)),void 0!==Pe)return Pe;if(!ce(s))return s;var qe=ee(s);if(qe){if(Pe=z(s),!Te)return j(s,Pe)}else{var ze=V(s),We=ze==ye||"[object GeneratorFunction]"==ze;if(ie(s))return C(s,Te);if(ze==be||ze==fe||We&&!we){if(Pe=Re||We?{}:Z(s),!Te)return Re?B(s,x(Pe,s)):L(s,w(Pe,s))}else{if(!Se[ze])return we?s:{};Pe=Y(s,ze,Te)}}xe||(xe=new a);var He=xe.get(s);if(He)return He;xe.set(s,Pe),le(s)?s.forEach((function(a){Pe.add(baseClone(a,o,i,a,s,xe))})):ae(s)&&s.forEach((function(a,u){Pe.set(u,baseClone(a,o,i,u,s,xe))}));var Ye=qe?void 0:($e?Re?U:$:Re?de:pe)(s);return u(Ye||s,(function(a,u){Ye&&(a=s[u=a]),_(Pe,u,baseClone(a,o,i,u,s,xe))})),Pe}},39344(s,o,i){var a=i(23805),u=Object.create,_=function(){function object(){}return function(s){if(!a(s))return{};if(u)return u(s);object.prototype=s;var o=new object;return object.prototype=void 0,o}}();s.exports=_},80909(s,o,i){var a=i(30641),u=i(38329)(a);s.exports=u},2523(s){s.exports=function baseFindIndex(s,o,i,a){for(var u=s.length,_=i+(a?1:-1);a?_--:++_<u;)if(o(s[_],_,s))return _;return-1}},83120(s,o,i){var a=i(14528),u=i(45891);s.exports=function baseFlatten(s,o,i,_,w){var x=-1,C=s.length;for(i||(i=u),w||(w=[]);++x<C;){var j=s[x];o>0&&i(j)?o>1?baseFlatten(j,o-1,i,_,w):a(w,j):_||(w[w.length]=j)}return w}},86649(s,o,i){var a=i(83221)();s.exports=a},30641(s,o,i){var a=i(86649),u=i(95950);s.exports=function baseForOwn(s,o){return s&&a(s,o,u)}},47422(s,o,i){var a=i(31769),u=i(77797);s.exports=function baseGet(s,o){for(var i=0,_=(o=a(o,s)).length;null!=s&&i<_;)s=s[u(o[i++])];return i&&i==_?s:void 0}},82199(s,o,i){var a=i(14528),u=i(56449);s.exports=function baseGetAllKeys(s,o,i){var _=o(s);return u(s)?_:a(_,i(s))}},72552(s,o,i){var a=i(51873),u=i(659),_=i(59350),w=a?a.toStringTag:void 0;s.exports=function baseGetTag(s){return null==s?void 0===s?"[object Undefined]":"[object Null]":w&&w in Object(s)?u(s):_(s)}},20426(s){var o=Object.prototype.hasOwnProperty;s.exports=function baseHas(s,i){return null!=s&&o.call(s,i)}},28077(s){s.exports=function baseHasIn(s,o){return null!=s&&o in Object(s)}},96131(s,o,i){var a=i(2523),u=i(85463),_=i(76959);s.exports=function baseIndexOf(s,o,i){return o==o?_(s,o,i):a(s,u,i)}},27534(s,o,i){var a=i(72552),u=i(40346);s.exports=function baseIsArguments(s){return u(s)&&"[object Arguments]"==a(s)}},60270(s,o,i){var a=i(87068),u=i(40346);s.exports=function baseIsEqual(s,o,i,_,w){return s===o||(null==s||null==o||!u(s)&&!u(o)?s!=s&&o!=o:a(s,o,i,_,baseIsEqual,w))}},87068(s,o,i){var a=i(37217),u=i(25911),_=i(21986),w=i(50689),x=i(5861),C=i(56449),j=i(3656),L=i(37167),B="[object Arguments]",$="[object Array]",U="[object Object]",V=Object.prototype.hasOwnProperty;s.exports=function baseIsEqualDeep(s,o,i,z,Y,Z){var ee=C(s),ie=C(o),ae=ee?$:x(s),ce=ie?$:x(o),le=(ae=ae==B?U:ae)==U,pe=(ce=ce==B?U:ce)==U,de=ae==ce;if(de&&j(s)){if(!j(o))return!1;ee=!0,le=!1}if(de&&!le)return Z||(Z=new a),ee||L(s)?u(s,o,i,z,Y,Z):_(s,o,ae,i,z,Y,Z);if(!(1&i)){var fe=le&&V.call(s,"__wrapped__"),ye=pe&&V.call(o,"__wrapped__");if(fe||ye){var be=fe?s.value():s,Se=ye?o.value():o;return Z||(Z=new a),Y(be,Se,i,z,Z)}}return!!de&&(Z||(Z=new a),w(s,o,i,z,Y,Z))}},29172(s,o,i){var a=i(5861),u=i(40346);s.exports=function baseIsMap(s){return u(s)&&"[object Map]"==a(s)}},41799(s,o,i){var a=i(37217),u=i(60270);s.exports=function baseIsMatch(s,o,i,_){var w=i.length,x=w,C=!_;if(null==s)return!x;for(s=Object(s);w--;){var j=i[w];if(C&&j[2]?j[1]!==s[j[0]]:!(j[0]in s))return!1}for(;++w<x;){var L=(j=i[w])[0],B=s[L],$=j[1];if(C&&j[2]){if(void 0===B&&!(L in s))return!1}else{var U=new a;if(_)var V=_(B,$,L,s,o,U);if(!(void 0===V?u($,B,3,_,U):V))return!1}}return!0}},85463(s){s.exports=function baseIsNaN(s){return s!=s}},45083(s,o,i){var a=i(1882),u=i(87296),_=i(23805),w=i(47473),x=/^\[object .+?Constructor\]$/,C=Function.prototype,j=Object.prototype,L=C.toString,B=j.hasOwnProperty,$=RegExp("^"+L.call(B).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");s.exports=function baseIsNative(s){return!(!_(s)||u(s))&&(a(s)?$:x).test(w(s))}},16038(s,o,i){var a=i(5861),u=i(40346);s.exports=function baseIsSet(s){return u(s)&&"[object Set]"==a(s)}},4901(s,o,i){var a=i(72552),u=i(30294),_=i(40346),w={};w["[object Float32Array]"]=w["[object Float64Array]"]=w["[object Int8Array]"]=w["[object Int16Array]"]=w["[object Int32Array]"]=w["[object Uint8Array]"]=w["[object Uint8ClampedArray]"]=w["[object Uint16Array]"]=w["[object Uint32Array]"]=!0,w["[object Arguments]"]=w["[object Array]"]=w["[object ArrayBuffer]"]=w["[object Boolean]"]=w["[object DataView]"]=w["[object Date]"]=w["[object Error]"]=w["[object Function]"]=w["[object Map]"]=w["[object Number]"]=w["[object Object]"]=w["[object RegExp]"]=w["[object Set]"]=w["[object String]"]=w["[object WeakMap]"]=!1,s.exports=function baseIsTypedArray(s){return _(s)&&u(s.length)&&!!w[a(s)]}},15389(s,o,i){var a=i(93663),u=i(87978),_=i(83488),w=i(56449),x=i(50583);s.exports=function baseIteratee(s){return"function"==typeof s?s:null==s?_:"object"==typeof s?w(s)?u(s[0],s[1]):a(s):x(s)}},88984(s,o,i){var a=i(55527),u=i(3650),_=Object.prototype.hasOwnProperty;s.exports=function baseKeys(s){if(!a(s))return u(s);var o=[];for(var i in Object(s))_.call(s,i)&&"constructor"!=i&&o.push(i);return o}},72903(s,o,i){var a=i(23805),u=i(55527),_=i(90181),w=Object.prototype.hasOwnProperty;s.exports=function baseKeysIn(s){if(!a(s))return _(s);var o=u(s),i=[];for(var x in s)("constructor"!=x||!o&&w.call(s,x))&&i.push(x);return i}},94033(s){s.exports=function baseLodash(){}},93663(s,o,i){var a=i(41799),u=i(10776),_=i(67197);s.exports=function baseMatches(s){var o=u(s);return 1==o.length&&o[0][2]?_(o[0][0],o[0][1]):function(i){return i===s||a(i,s,o)}}},87978(s,o,i){var a=i(60270),u=i(58156),_=i(80631),w=i(28586),x=i(30756),C=i(67197),j=i(77797);s.exports=function baseMatchesProperty(s,o){return w(s)&&x(o)?C(j(s),o):function(i){var w=u(i,s);return void 0===w&&w===o?_(i,s):a(o,w,3)}}},85250(s,o,i){var a=i(37217),u=i(87805),_=i(86649),w=i(42824),x=i(23805),C=i(37241),j=i(14974);s.exports=function baseMerge(s,o,i,L,B){s!==o&&_(o,(function(_,C){if(B||(B=new a),x(_))w(s,o,C,i,baseMerge,L,B);else{var $=L?L(j(s,C),_,C+"",s,o,B):void 0;void 0===$&&($=_),u(s,C,$)}}),C)}},42824(s,o,i){var a=i(87805),u=i(93290),_=i(71961),w=i(23007),x=i(35529),C=i(72428),j=i(56449),L=i(83693),B=i(3656),$=i(1882),U=i(23805),V=i(11331),z=i(37167),Y=i(14974),Z=i(69884);s.exports=function baseMergeDeep(s,o,i,ee,ie,ae,ce){var le=Y(s,i),pe=Y(o,i),de=ce.get(pe);if(de)a(s,i,de);else{var fe=ae?ae(le,pe,i+"",s,o,ce):void 0,ye=void 0===fe;if(ye){var be=j(pe),Se=!be&&B(pe),_e=!be&&!Se&&z(pe);fe=pe,be||Se||_e?j(le)?fe=le:L(le)?fe=w(le):Se?(ye=!1,fe=u(pe,!0)):_e?(ye=!1,fe=_(pe,!0)):fe=[]:V(pe)||C(pe)?(fe=le,C(le)?fe=Z(le):U(le)&&!$(le)||(fe=x(pe))):ye=!1}ye&&(ce.set(pe,fe),ie(fe,pe,ee,ae,ce),ce.delete(pe)),a(s,i,fe)}}},47237(s){s.exports=function baseProperty(s){return function(o){return null==o?void 0:o[s]}}},17255(s,o,i){var a=i(47422);s.exports=function basePropertyDeep(s){return function(o){return a(o,s)}}},54552(s){s.exports=function basePropertyOf(s){return function(o){return null==s?void 0:s[o]}}},85558(s){s.exports=function baseReduce(s,o,i,a,u){return u(s,(function(s,u,_){i=a?(a=!1,s):o(i,s,u,_)})),i}},69302(s,o,i){var a=i(83488),u=i(56757),_=i(32865);s.exports=function baseRest(s,o){return _(u(s,o,a),s+"")}},73170(s,o,i){var a=i(16547),u=i(31769),_=i(30361),w=i(23805),x=i(77797);s.exports=function baseSet(s,o,i,C){if(!w(s))return s;for(var j=-1,L=(o=u(o,s)).length,B=L-1,$=s;null!=$&&++j<L;){var U=x(o[j]),V=i;if("__proto__"===U||"constructor"===U||"prototype"===U)return s;if(j!=B){var z=$[U];void 0===(V=C?C(z,U,$):void 0)&&(V=w(z)?z:_(o[j+1])?[]:{})}a($,U,V),$=$[U]}return s}},68882(s,o,i){var a=i(83488),u=i(48152),_=u?function(s,o){return u.set(s,o),s}:a;s.exports=_},19570(s,o,i){var a=i(37334),u=i(93243),_=i(83488),w=u?function(s,o){return u(s,"toString",{configurable:!0,enumerable:!1,value:a(o),writable:!0})}:_;s.exports=w},25160(s){s.exports=function baseSlice(s,o,i){var a=-1,u=s.length;o<0&&(o=-o>u?0:u+o),(i=i>u?u:i)<0&&(i+=u),u=o>i?0:i-o>>>0,o>>>=0;for(var _=Array(u);++a<u;)_[a]=s[a+o];return _}},90916(s,o,i){var a=i(80909);s.exports=function baseSome(s,o){var i;return a(s,(function(s,a,u){return!(i=o(s,a,u))})),!!i}},78096(s){s.exports=function baseTimes(s,o){for(var i=-1,a=Array(s);++i<s;)a[i]=o(i);return a}},77556(s,o,i){var a=i(51873),u=i(34932),_=i(56449),w=i(44394),x=a?a.prototype:void 0,C=x?x.toString:void 0;s.exports=function baseToString(s){if("string"==typeof s)return s;if(_(s))return u(s,baseToString)+"";if(w(s))return C?C.call(s):"";var o=s+"";return"0"==o&&1/s==-1/0?"-0":o}},54128(s,o,i){var a=i(31800),u=/^\s+/;s.exports=function baseTrim(s){return s?s.slice(0,a(s)+1).replace(u,""):s}},27301(s){s.exports=function baseUnary(s){return function(o){return s(o)}}},19931(s,o,i){var a=i(31769),u=i(68090),_=i(68969),w=i(77797),x=Object.prototype.hasOwnProperty;s.exports=function baseUnset(s,o){var i=-1,C=(o=a(o,s)).length;if(!C)return!0;for(;++i<C;){var j=w(o[i]);if("__proto__"===j&&!x.call(s,"__proto__"))return!1;if(("constructor"===j||"prototype"===j)&&i<C-1)return!1}var L=_(s,o);return null==L||delete L[w(u(o))]}},51234(s){s.exports=function baseZipObject(s,o,i){for(var a=-1,u=s.length,_=o.length,w={};++a<u;){var x=a<_?o[a]:void 0;i(w,s[a],x)}return w}},19219(s){s.exports=function cacheHas(s,o){return s.has(o)}},31769(s,o,i){var a=i(56449),u=i(28586),_=i(61802),w=i(13222);s.exports=function castPath(s,o){return a(s)?s:u(s,o)?[s]:_(w(s))}},28754(s,o,i){var a=i(25160);s.exports=function castSlice(s,o,i){var u=s.length;return i=void 0===i?u:i,!o&&i>=u?s:a(s,o,i)}},49653(s,o,i){var a=i(37828);s.exports=function cloneArrayBuffer(s){var o=new s.constructor(s.byteLength);return new a(o).set(new a(s)),o}},93290(s,o,i){s=i.nmd(s);var a=i(9325),u=o&&!o.nodeType&&o,_=u&&s&&!s.nodeType&&s,w=_&&_.exports===u?a.Buffer:void 0,x=w?w.allocUnsafe:void 0;s.exports=function cloneBuffer(s,o){if(o)return s.slice();var i=s.length,a=x?x(i):new s.constructor(i);return s.copy(a),a}},76169(s,o,i){var a=i(49653);s.exports=function cloneDataView(s,o){var i=o?a(s.buffer):s.buffer;return new s.constructor(i,s.byteOffset,s.byteLength)}},73201(s){var o=/\w*$/;s.exports=function cloneRegExp(s){var i=new s.constructor(s.source,o.exec(s));return i.lastIndex=s.lastIndex,i}},93736(s,o,i){var a=i(51873),u=a?a.prototype:void 0,_=u?u.valueOf:void 0;s.exports=function cloneSymbol(s){return _?Object(_.call(s)):{}}},71961(s,o,i){var a=i(49653);s.exports=function cloneTypedArray(s,o){var i=o?a(s.buffer):s.buffer;return new s.constructor(i,s.byteOffset,s.length)}},91596(s){var o=Math.max;s.exports=function composeArgs(s,i,a,u){for(var _=-1,w=s.length,x=a.length,C=-1,j=i.length,L=o(w-x,0),B=Array(j+L),$=!u;++C<j;)B[C]=i[C];for(;++_<x;)($||_<w)&&(B[a[_]]=s[_]);for(;L--;)B[C++]=s[_++];return B}},53320(s){var o=Math.max;s.exports=function composeArgsRight(s,i,a,u){for(var _=-1,w=s.length,x=-1,C=a.length,j=-1,L=i.length,B=o(w-C,0),$=Array(B+L),U=!u;++_<B;)$[_]=s[_];for(var V=_;++j<L;)$[V+j]=i[j];for(;++x<C;)(U||_<w)&&($[V+a[x]]=s[_++]);return $}},23007(s){s.exports=function copyArray(s,o){var i=-1,a=s.length;for(o||(o=Array(a));++i<a;)o[i]=s[i];return o}},21791(s,o,i){var a=i(16547),u=i(43360);s.exports=function copyObject(s,o,i,_){var w=!i;i||(i={});for(var x=-1,C=o.length;++x<C;){var j=o[x],L=_?_(i[j],s[j],j,i,s):void 0;void 0===L&&(L=s[j]),w?u(i,j,L):a(i,j,L)}return i}},92271(s,o,i){var a=i(21791),u=i(4664);s.exports=function copySymbols(s,o){return a(s,u(s),o)}},48948(s,o,i){var a=i(21791),u=i(86375);s.exports=function copySymbolsIn(s,o){return a(s,u(s),o)}},55481(s,o,i){var a=i(9325)["__core-js_shared__"];s.exports=a},58523(s){s.exports=function countHolders(s,o){for(var i=s.length,a=0;i--;)s[i]===o&&++a;return a}},20999(s,o,i){var a=i(69302),u=i(36800);s.exports=function createAssigner(s){return a((function(o,i){var a=-1,_=i.length,w=_>1?i[_-1]:void 0,x=_>2?i[2]:void 0;for(w=s.length>3&&"function"==typeof w?(_--,w):void 0,x&&u(i[0],i[1],x)&&(w=_<3?void 0:w,_=1),o=Object(o);++a<_;){var C=i[a];C&&s(o,C,a,w)}return o}))}},38329(s,o,i){var a=i(64894);s.exports=function createBaseEach(s,o){return function(i,u){if(null==i)return i;if(!a(i))return s(i,u);for(var _=i.length,w=o?_:-1,x=Object(i);(o?w--:++w<_)&&!1!==u(x[w],w,x););return i}}},83221(s){s.exports=function createBaseFor(s){return function(o,i,a){for(var u=-1,_=Object(o),w=a(o),x=w.length;x--;){var C=w[s?x:++u];if(!1===i(_[C],C,_))break}return o}}},11842(s,o,i){var a=i(82819),u=i(9325);s.exports=function createBind(s,o,i){var _=1&o,w=a(s);return function wrapper(){return(this&&this!==u&&this instanceof wrapper?w:s).apply(_?i:this,arguments)}}},12507(s,o,i){var a=i(28754),u=i(49698),_=i(63912),w=i(13222);s.exports=function createCaseFirst(s){return function(o){o=w(o);var i=u(o)?_(o):void 0,x=i?i[0]:o.charAt(0),C=i?a(i,1).join(""):o.slice(1);return x[s]()+C}}},45539(s,o,i){var a=i(40882),u=i(50828),_=i(66645),w=RegExp("['’]","g");s.exports=function createCompounder(s){return function(o){return a(_(u(o).replace(w,"")),s,"")}}},82819(s,o,i){var a=i(39344),u=i(23805);s.exports=function createCtor(s){return function(){var o=arguments;switch(o.length){case 0:return new s;case 1:return new s(o[0]);case 2:return new s(o[0],o[1]);case 3:return new s(o[0],o[1],o[2]);case 4:return new s(o[0],o[1],o[2],o[3]);case 5:return new s(o[0],o[1],o[2],o[3],o[4]);case 6:return new s(o[0],o[1],o[2],o[3],o[4],o[5]);case 7:return new s(o[0],o[1],o[2],o[3],o[4],o[5],o[6])}var i=a(s.prototype),_=s.apply(i,o);return u(_)?_:i}}},77078(s,o,i){var a=i(91033),u=i(82819),_=i(37471),w=i(18073),x=i(11287),C=i(36306),j=i(9325);s.exports=function createCurry(s,o,i){var L=u(s);return function wrapper(){for(var u=arguments.length,B=Array(u),$=u,U=x(wrapper);$--;)B[$]=arguments[$];var V=u<3&&B[0]!==U&&B[u-1]!==U?[]:C(B,U);return(u-=V.length)<i?w(s,o,_,wrapper.placeholder,void 0,B,V,void 0,void 0,i-u):a(this&&this!==j&&this instanceof wrapper?L:s,this,B)}}},62006(s,o,i){var a=i(15389),u=i(64894),_=i(95950);s.exports=function createFind(s){return function(o,i,w){var x=Object(o);if(!u(o)){var C=a(i,3);o=_(o),i=function(s){return C(x[s],s,x)}}var j=s(o,i,w);return j>-1?x[C?o[j]:j]:void 0}}},37471(s,o,i){var a=i(91596),u=i(53320),_=i(58523),w=i(82819),x=i(18073),C=i(11287),j=i(68294),L=i(36306),B=i(9325);s.exports=function createHybrid(s,o,i,$,U,V,z,Y,Z,ee){var ie=128&o,ae=1&o,ce=2&o,le=24&o,pe=512&o,de=ce?void 0:w(s);return function wrapper(){for(var fe=arguments.length,ye=Array(fe),be=fe;be--;)ye[be]=arguments[be];if(le)var Se=C(wrapper),_e=_(ye,Se);if($&&(ye=a(ye,$,U,le)),V&&(ye=u(ye,V,z,le)),fe-=_e,le&&fe<ee){var we=L(ye,Se);return x(s,o,createHybrid,wrapper.placeholder,i,ye,we,Y,Z,ee-fe)}var xe=ae?i:this,Pe=ce?xe[s]:s;return fe=ye.length,Y?ye=j(ye,Y):pe&&fe>1&&ye.reverse(),ie&&Z<fe&&(ye.length=Z),this&&this!==B&&this instanceof wrapper&&(Pe=de||w(Pe)),Pe.apply(xe,ye)}}},24168(s,o,i){var a=i(91033),u=i(82819),_=i(9325);s.exports=function createPartial(s,o,i,w){var x=1&o,C=u(s);return function wrapper(){for(var o=-1,u=arguments.length,j=-1,L=w.length,B=Array(L+u),$=this&&this!==_&&this instanceof wrapper?C:s;++j<L;)B[j]=w[j];for(;u--;)B[j++]=arguments[++o];return a($,x?i:this,B)}}},18073(s,o,i){var a=i(85087),u=i(54641),_=i(70981);s.exports=function createRecurry(s,o,i,w,x,C,j,L,B,$){var U=8&o;o|=U?32:64,4&(o&=~(U?64:32))||(o&=-4);var V=[s,o,x,U?C:void 0,U?j:void 0,U?void 0:C,U?void 0:j,L,B,$],z=i.apply(void 0,V);return a(s)&&u(z,V),z.placeholder=w,_(z,s,o)}},66977(s,o,i){var a=i(68882),u=i(11842),_=i(77078),w=i(37471),x=i(24168),C=i(37381),j=i(3209),L=i(54641),B=i(70981),$=i(61489),U=Math.max;s.exports=function createWrap(s,o,i,V,z,Y,Z,ee){var ie=2&o;if(!ie&&"function"!=typeof s)throw new TypeError("Expected a function");var ae=V?V.length:0;if(ae||(o&=-97,V=z=void 0),Z=void 0===Z?Z:U($(Z),0),ee=void 0===ee?ee:$(ee),ae-=z?z.length:0,64&o){var ce=V,le=z;V=z=void 0}var pe=ie?void 0:C(s),de=[s,o,i,V,z,ce,le,Y,Z,ee];if(pe&&j(de,pe),s=de[0],o=de[1],i=de[2],V=de[3],z=de[4],!(ee=de[9]=void 0===de[9]?ie?0:s.length:U(de[9]-ae,0))&&24&o&&(o&=-25),o&&1!=o)fe=8==o||16==o?_(s,o,ee):32!=o&&33!=o||z.length?w.apply(void 0,de):x(s,o,i,V);else var fe=u(s,o,i);return B((pe?a:L)(fe,de),s,o)}},53138(s,o,i){var a=i(11331);s.exports=function customOmitClone(s){return a(s)?void 0:s}},24647(s,o,i){var a=i(54552)({À:"A",Á:"A",Â:"A",Ã:"A",Ä:"A",Å:"A",à:"a",á:"a",â:"a",ã:"a",ä:"a",å:"a",Ç:"C",ç:"c",Ð:"D",ð:"d",È:"E",É:"E",Ê:"E",Ë:"E",è:"e",é:"e",ê:"e",ë:"e",Ì:"I",Í:"I",Î:"I",Ï:"I",ì:"i",í:"i",î:"i",ï:"i",Ñ:"N",ñ:"n",Ò:"O",Ó:"O",Ô:"O",Õ:"O",Ö:"O",Ø:"O",ò:"o",ó:"o",ô:"o",õ:"o",ö:"o",ø:"o",Ù:"U",Ú:"U",Û:"U",Ü:"U",ù:"u",ú:"u",û:"u",ü:"u",Ý:"Y",ý:"y",ÿ:"y",Æ:"Ae",æ:"ae",Þ:"Th",þ:"th",ß:"ss",Ā:"A",Ă:"A",Ą:"A",ā:"a",ă:"a",ą:"a",Ć:"C",Ĉ:"C",Ċ:"C",Č:"C",ć:"c",ĉ:"c",ċ:"c",č:"c",Ď:"D",Đ:"D",ď:"d",đ:"d",Ē:"E",Ĕ:"E",Ė:"E",Ę:"E",Ě:"E",ē:"e",ĕ:"e",ė:"e",ę:"e",ě:"e",Ĝ:"G",Ğ:"G",Ġ:"G",Ģ:"G",ĝ:"g",ğ:"g",ġ:"g",ģ:"g",Ĥ:"H",Ħ:"H",ĥ:"h",ħ:"h",Ĩ:"I",Ī:"I",Ĭ:"I",Į:"I",İ:"I",ĩ:"i",ī:"i",ĭ:"i",į:"i",ı:"i",Ĵ:"J",ĵ:"j",Ķ:"K",ķ:"k",ĸ:"k",Ĺ:"L",Ļ:"L",Ľ:"L",Ŀ:"L",Ł:"L",ĺ:"l",ļ:"l",ľ:"l",ŀ:"l",ł:"l",Ń:"N",Ņ:"N",Ň:"N",Ŋ:"N",ń:"n",ņ:"n",ň:"n",ŋ:"n",Ō:"O",Ŏ:"O",Ő:"O",ō:"o",ŏ:"o",ő:"o",Ŕ:"R",Ŗ:"R",Ř:"R",ŕ:"r",ŗ:"r",ř:"r",Ś:"S",Ŝ:"S",Ş:"S",Š:"S",ś:"s",ŝ:"s",ş:"s",š:"s",Ţ:"T",Ť:"T",Ŧ:"T",ţ:"t",ť:"t",ŧ:"t",Ũ:"U",Ū:"U",Ŭ:"U",Ů:"U",Ű:"U",Ų:"U",ũ:"u",ū:"u",ŭ:"u",ů:"u",ű:"u",ų:"u",Ŵ:"W",ŵ:"w",Ŷ:"Y",ŷ:"y",Ÿ:"Y",Ź:"Z",Ż:"Z",Ž:"Z",ź:"z",ż:"z",ž:"z",Ĳ:"IJ",ĳ:"ij",Œ:"Oe",œ:"oe",ŉ:"'n",ſ:"s"});s.exports=a},93243(s,o,i){var a=i(56110),u=function(){try{var s=a(Object,"defineProperty");return s({},"",{}),s}catch(s){}}();s.exports=u},25911(s,o,i){var a=i(38859),u=i(14248),_=i(19219);s.exports=function equalArrays(s,o,i,w,x,C){var j=1&i,L=s.length,B=o.length;if(L!=B&&!(j&&B>L))return!1;var $=C.get(s),U=C.get(o);if($&&U)return $==o&&U==s;var V=-1,z=!0,Y=2&i?new a:void 0;for(C.set(s,o),C.set(o,s);++V<L;){var Z=s[V],ee=o[V];if(w)var ie=j?w(ee,Z,V,o,s,C):w(Z,ee,V,s,o,C);if(void 0!==ie){if(ie)continue;z=!1;break}if(Y){if(!u(o,(function(s,o){if(!_(Y,o)&&(Z===s||x(Z,s,i,w,C)))return Y.push(o)}))){z=!1;break}}else if(Z!==ee&&!x(Z,ee,i,w,C)){z=!1;break}}return C.delete(s),C.delete(o),z}},21986(s,o,i){var a=i(51873),u=i(37828),_=i(75288),w=i(25911),x=i(20317),C=i(84247),j=a?a.prototype:void 0,L=j?j.valueOf:void 0;s.exports=function equalByTag(s,o,i,a,j,B,$){switch(i){case"[object DataView]":if(s.byteLength!=o.byteLength||s.byteOffset!=o.byteOffset)return!1;s=s.buffer,o=o.buffer;case"[object ArrayBuffer]":return!(s.byteLength!=o.byteLength||!B(new u(s),new u(o)));case"[object Boolean]":case"[object Date]":case"[object Number]":return _(+s,+o);case"[object Error]":return s.name==o.name&&s.message==o.message;case"[object RegExp]":case"[object String]":return s==o+"";case"[object Map]":var U=x;case"[object Set]":var V=1&a;if(U||(U=C),s.size!=o.size&&!V)return!1;var z=$.get(s);if(z)return z==o;a|=2,$.set(s,o);var Y=w(U(s),U(o),a,j,B,$);return $.delete(s),Y;case"[object Symbol]":if(L)return L.call(s)==L.call(o)}return!1}},50689(s,o,i){var a=i(50002),u=Object.prototype.hasOwnProperty;s.exports=function equalObjects(s,o,i,_,w,x){var C=1&i,j=a(s),L=j.length;if(L!=a(o).length&&!C)return!1;for(var B=L;B--;){var $=j[B];if(!(C?$ in o:u.call(o,$)))return!1}var U=x.get(s),V=x.get(o);if(U&&V)return U==o&&V==s;var z=!0;x.set(s,o),x.set(o,s);for(var Y=C;++B<L;){var Z=s[$=j[B]],ee=o[$];if(_)var ie=C?_(ee,Z,$,o,s,x):_(Z,ee,$,s,o,x);if(!(void 0===ie?Z===ee||w(Z,ee,i,_,x):ie)){z=!1;break}Y||(Y="constructor"==$)}if(z&&!Y){var ae=s.constructor,ce=o.constructor;ae==ce||!("constructor"in s)||!("constructor"in o)||"function"==typeof ae&&ae instanceof ae&&"function"==typeof ce&&ce instanceof ce||(z=!1)}return x.delete(s),x.delete(o),z}},38816(s,o,i){var a=i(35970),u=i(56757),_=i(32865);s.exports=function flatRest(s){return _(u(s,void 0,a),s+"")}},34840(s,o,i){var a="object"==typeof i.g&&i.g&&i.g.Object===Object&&i.g;s.exports=a},50002(s,o,i){var a=i(82199),u=i(4664),_=i(95950);s.exports=function getAllKeys(s){return a(s,_,u)}},83349(s,o,i){var a=i(82199),u=i(86375),_=i(37241);s.exports=function getAllKeysIn(s){return a(s,_,u)}},37381(s,o,i){var a=i(48152),u=i(63950),_=a?function(s){return a.get(s)}:u;s.exports=_},62284(s,o,i){var a=i(84629),u=Object.prototype.hasOwnProperty;s.exports=function getFuncName(s){for(var o=s.name+"",i=a[o],_=u.call(a,o)?i.length:0;_--;){var w=i[_],x=w.func;if(null==x||x==s)return w.name}return o}},11287(s){s.exports=function getHolder(s){return s.placeholder}},12651(s,o,i){var a=i(74218);s.exports=function getMapData(s,o){var i=s.__data__;return a(o)?i["string"==typeof o?"string":"hash"]:i.map}},10776(s,o,i){var a=i(30756),u=i(95950);s.exports=function getMatchData(s){for(var o=u(s),i=o.length;i--;){var _=o[i],w=s[_];o[i]=[_,w,a(w)]}return o}},56110(s,o,i){var a=i(45083),u=i(10392);s.exports=function getNative(s,o){var i=u(s,o);return a(i)?i:void 0}},28879(s,o,i){var a=i(74335)(Object.getPrototypeOf,Object);s.exports=a},659(s,o,i){var a=i(51873),u=Object.prototype,_=u.hasOwnProperty,w=u.toString,x=a?a.toStringTag:void 0;s.exports=function getRawTag(s){var o=_.call(s,x),i=s[x];try{s[x]=void 0;var a=!0}catch(s){}var u=w.call(s);return a&&(o?s[x]=i:delete s[x]),u}},4664(s,o,i){var a=i(79770),u=i(63345),_=Object.prototype.propertyIsEnumerable,w=Object.getOwnPropertySymbols,x=w?function(s){return null==s?[]:(s=Object(s),a(w(s),(function(o){return _.call(s,o)})))}:u;s.exports=x},86375(s,o,i){var a=i(14528),u=i(28879),_=i(4664),w=i(63345),x=Object.getOwnPropertySymbols?function(s){for(var o=[];s;)a(o,_(s)),s=u(s);return o}:w;s.exports=x},5861(s,o,i){var a=i(55580),u=i(68223),_=i(32804),w=i(76545),x=i(28303),C=i(72552),j=i(47473),L="[object Map]",B="[object Promise]",$="[object Set]",U="[object WeakMap]",V="[object DataView]",z=j(a),Y=j(u),Z=j(_),ee=j(w),ie=j(x),ae=C;(a&&ae(new a(new ArrayBuffer(1)))!=V||u&&ae(new u)!=L||_&&ae(_.resolve())!=B||w&&ae(new w)!=$||x&&ae(new x)!=U)&&(ae=function(s){var o=C(s),i="[object Object]"==o?s.constructor:void 0,a=i?j(i):"";if(a)switch(a){case z:return V;case Y:return L;case Z:return B;case ee:return $;case ie:return U}return o}),s.exports=ae},10392(s){s.exports=function getValue(s,o){return null==s?void 0:s[o]}},75251(s){var o=/\{\n\/\* \[wrapped with (.+)\] \*/,i=/,? & /;s.exports=function getWrapDetails(s){var a=s.match(o);return a?a[1].split(i):[]}},49326(s,o,i){var a=i(31769),u=i(72428),_=i(56449),w=i(30361),x=i(30294),C=i(77797);s.exports=function hasPath(s,o,i){for(var j=-1,L=(o=a(o,s)).length,B=!1;++j<L;){var $=C(o[j]);if(!(B=null!=s&&i(s,$)))break;s=s[$]}return B||++j!=L?B:!!(L=null==s?0:s.length)&&x(L)&&w($,L)&&(_(s)||u(s))}},49698(s){var o=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");s.exports=function hasUnicode(s){return o.test(s)}},45434(s){var o=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;s.exports=function hasUnicodeWord(s){return o.test(s)}},22032(s,o,i){var a=i(81042);s.exports=function hashClear(){this.__data__=a?a(null):{},this.size=0}},63862(s){s.exports=function hashDelete(s){var o=this.has(s)&&delete this.__data__[s];return this.size-=o?1:0,o}},66721(s,o,i){var a=i(81042),u=Object.prototype.hasOwnProperty;s.exports=function hashGet(s){var o=this.__data__;if(a){var i=o[s];return"__lodash_hash_undefined__"===i?void 0:i}return u.call(o,s)?o[s]:void 0}},12749(s,o,i){var a=i(81042),u=Object.prototype.hasOwnProperty;s.exports=function hashHas(s){var o=this.__data__;return a?void 0!==o[s]:u.call(o,s)}},35749(s,o,i){var a=i(81042);s.exports=function hashSet(s,o){var i=this.__data__;return this.size+=this.has(s)?0:1,i[s]=a&&void 0===o?"__lodash_hash_undefined__":o,this}},76189(s){var o=Object.prototype.hasOwnProperty;s.exports=function initCloneArray(s){var i=s.length,a=new s.constructor(i);return i&&"string"==typeof s[0]&&o.call(s,"index")&&(a.index=s.index,a.input=s.input),a}},77199(s,o,i){var a=i(49653),u=i(76169),_=i(73201),w=i(93736),x=i(71961);s.exports=function initCloneByTag(s,o,i){var C=s.constructor;switch(o){case"[object ArrayBuffer]":return a(s);case"[object Boolean]":case"[object Date]":return new C(+s);case"[object DataView]":return u(s,i);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":case"[object Uint16Array]":case"[object Uint32Array]":return x(s,i);case"[object Map]":case"[object Set]":return new C;case"[object Number]":case"[object String]":return new C(s);case"[object RegExp]":return _(s);case"[object Symbol]":return w(s)}}},35529(s,o,i){var a=i(39344),u=i(28879),_=i(55527);s.exports=function initCloneObject(s){return"function"!=typeof s.constructor||_(s)?{}:a(u(s))}},62060(s){var o=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;s.exports=function insertWrapDetails(s,i){var a=i.length;if(!a)return s;var u=a-1;return i[u]=(a>1?"& ":"")+i[u],i=i.join(a>2?", ":" "),s.replace(o,"{\n/* [wrapped with "+i+"] */\n")}},45891(s,o,i){var a=i(51873),u=i(72428),_=i(56449),w=a?a.isConcatSpreadable:void 0;s.exports=function isFlattenable(s){return _(s)||u(s)||!!(w&&s&&s[w])}},30361(s){var o=/^(?:0|[1-9]\d*)$/;s.exports=function isIndex(s,i){var a=typeof s;return!!(i=null==i?9007199254740991:i)&&("number"==a||"symbol"!=a&&o.test(s))&&s>-1&&s%1==0&&s<i}},36800(s,o,i){var a=i(75288),u=i(64894),_=i(30361),w=i(23805);s.exports=function isIterateeCall(s,o,i){if(!w(i))return!1;var x=typeof o;return!!("number"==x?u(i)&&_(o,i.length):"string"==x&&o in i)&&a(i[o],s)}},28586(s,o,i){var a=i(56449),u=i(44394),_=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,w=/^\w*$/;s.exports=function isKey(s,o){if(a(s))return!1;var i=typeof s;return!("number"!=i&&"symbol"!=i&&"boolean"!=i&&null!=s&&!u(s))||(w.test(s)||!_.test(s)||null!=o&&s in Object(o))}},74218(s){s.exports=function isKeyable(s){var o=typeof s;return"string"==o||"number"==o||"symbol"==o||"boolean"==o?"__proto__"!==s:null===s}},85087(s,o,i){var a=i(30980),u=i(37381),_=i(62284),w=i(53758);s.exports=function isLaziable(s){var o=_(s),i=w[o];if("function"!=typeof i||!(o in a.prototype))return!1;if(s===i)return!0;var x=u(i);return!!x&&s===x[0]}},87296(s,o,i){var a,u=i(55481),_=(a=/[^.]+$/.exec(u&&u.keys&&u.keys.IE_PROTO||""))?"Symbol(src)_1."+a:"";s.exports=function isMasked(s){return!!_&&_ in s}},55527(s){var o=Object.prototype;s.exports=function isPrototype(s){var i=s&&s.constructor;return s===("function"==typeof i&&i.prototype||o)}},30756(s,o,i){var a=i(23805);s.exports=function isStrictComparable(s){return s==s&&!a(s)}},63702(s){s.exports=function listCacheClear(){this.__data__=[],this.size=0}},70080(s,o,i){var a=i(26025),u=Array.prototype.splice;s.exports=function listCacheDelete(s){var o=this.__data__,i=a(o,s);return!(i<0)&&(i==o.length-1?o.pop():u.call(o,i,1),--this.size,!0)}},24739(s,o,i){var a=i(26025);s.exports=function listCacheGet(s){var o=this.__data__,i=a(o,s);return i<0?void 0:o[i][1]}},48655(s,o,i){var a=i(26025);s.exports=function listCacheHas(s){return a(this.__data__,s)>-1}},31175(s,o,i){var a=i(26025);s.exports=function listCacheSet(s,o){var i=this.__data__,u=a(i,s);return u<0?(++this.size,i.push([s,o])):i[u][1]=o,this}},63040(s,o,i){var a=i(21549),u=i(80079),_=i(68223);s.exports=function mapCacheClear(){this.size=0,this.__data__={hash:new a,map:new(_||u),string:new a}}},17670(s,o,i){var a=i(12651);s.exports=function mapCacheDelete(s){var o=a(this,s).delete(s);return this.size-=o?1:0,o}},90289(s,o,i){var a=i(12651);s.exports=function mapCacheGet(s){return a(this,s).get(s)}},4509(s,o,i){var a=i(12651);s.exports=function mapCacheHas(s){return a(this,s).has(s)}},72949(s,o,i){var a=i(12651);s.exports=function mapCacheSet(s,o){var i=a(this,s),u=i.size;return i.set(s,o),this.size+=i.size==u?0:1,this}},20317(s){s.exports=function mapToArray(s){var o=-1,i=Array(s.size);return s.forEach((function(s,a){i[++o]=[a,s]})),i}},67197(s){s.exports=function matchesStrictComparable(s,o){return function(i){return null!=i&&(i[s]===o&&(void 0!==o||s in Object(i)))}}},62224(s,o,i){var a=i(50104);s.exports=function memoizeCapped(s){var o=a(s,(function(s){return 500===i.size&&i.clear(),s})),i=o.cache;return o}},3209(s,o,i){var a=i(91596),u=i(53320),_=i(36306),w="__lodash_placeholder__",x=128,C=Math.min;s.exports=function mergeData(s,o){var i=s[1],j=o[1],L=i|j,B=L<131,$=j==x&&8==i||j==x&&256==i&&s[7].length<=o[8]||384==j&&o[7].length<=o[8]&&8==i;if(!B&&!$)return s;1&j&&(s[2]=o[2],L|=1&i?0:4);var U=o[3];if(U){var V=s[3];s[3]=V?a(V,U,o[4]):U,s[4]=V?_(s[3],w):o[4]}return(U=o[5])&&(V=s[5],s[5]=V?u(V,U,o[6]):U,s[6]=V?_(s[5],w):o[6]),(U=o[7])&&(s[7]=U),j&x&&(s[8]=null==s[8]?o[8]:C(s[8],o[8])),null==s[9]&&(s[9]=o[9]),s[0]=o[0],s[1]=L,s}},48152(s,o,i){var a=i(28303),u=a&&new a;s.exports=u},81042(s,o,i){var a=i(56110)(Object,"create");s.exports=a},3650(s,o,i){var a=i(74335)(Object.keys,Object);s.exports=a},90181(s){s.exports=function nativeKeysIn(s){var o=[];if(null!=s)for(var i in Object(s))o.push(i);return o}},86009(s,o,i){s=i.nmd(s);var a=i(34840),u=o&&!o.nodeType&&o,_=u&&s&&!s.nodeType&&s,w=_&&_.exports===u&&a.process,x=function(){try{var s=_&&_.require&&_.require("util").types;return s||w&&w.binding&&w.binding("util")}catch(s){}}();s.exports=x},59350(s){var o=Object.prototype.toString;s.exports=function objectToString(s){return o.call(s)}},74335(s){s.exports=function overArg(s,o){return function(i){return s(o(i))}}},56757(s,o,i){var a=i(91033),u=Math.max;s.exports=function overRest(s,o,i){return o=u(void 0===o?s.length-1:o,0),function(){for(var _=arguments,w=-1,x=u(_.length-o,0),C=Array(x);++w<x;)C[w]=_[o+w];w=-1;for(var j=Array(o+1);++w<o;)j[w]=_[w];return j[o]=i(C),a(s,this,j)}}},68969(s,o,i){var a=i(47422),u=i(25160);s.exports=function parent(s,o){return o.length<2?s:a(s,u(o,0,-1))}},84629(s){s.exports={}},68294(s,o,i){var a=i(23007),u=i(30361),_=Math.min;s.exports=function reorder(s,o){for(var i=s.length,w=_(o.length,i),x=a(s);w--;){var C=o[w];s[w]=u(C,i)?x[C]:void 0}return s}},36306(s){var o="__lodash_placeholder__";s.exports=function replaceHolders(s,i){for(var a=-1,u=s.length,_=0,w=[];++a<u;){var x=s[a];x!==i&&x!==o||(s[a]=o,w[_++]=a)}return w}},9325(s,o,i){var a=i(34840),u="object"==typeof self&&self&&self.Object===Object&&self,_=a||u||Function("return this")();s.exports=_},14974(s){s.exports=function safeGet(s,o){if(("constructor"!==o||"function"!=typeof s[o])&&"__proto__"!=o)return s[o]}},31380(s){s.exports=function setCacheAdd(s){return this.__data__.set(s,"__lodash_hash_undefined__"),this}},51459(s){s.exports=function setCacheHas(s){return this.__data__.has(s)}},54641(s,o,i){var a=i(68882),u=i(51811)(a);s.exports=u},84247(s){s.exports=function setToArray(s){var o=-1,i=Array(s.size);return s.forEach((function(s){i[++o]=s})),i}},32865(s,o,i){var a=i(19570),u=i(51811)(a);s.exports=u},70981(s,o,i){var a=i(75251),u=i(62060),_=i(32865),w=i(75948);s.exports=function setWrapToString(s,o,i){var x=o+"";return _(s,u(x,w(a(x),i)))}},51811(s){var o=Date.now;s.exports=function shortOut(s){var i=0,a=0;return function(){var u=o(),_=16-(u-a);if(a=u,_>0){if(++i>=800)return arguments[0]}else i=0;return s.apply(void 0,arguments)}}},51420(s,o,i){var a=i(80079);s.exports=function stackClear(){this.__data__=new a,this.size=0}},90938(s){s.exports=function stackDelete(s){var o=this.__data__,i=o.delete(s);return this.size=o.size,i}},63605(s){s.exports=function stackGet(s){return this.__data__.get(s)}},29817(s){s.exports=function stackHas(s){return this.__data__.has(s)}},80945(s,o,i){var a=i(80079),u=i(68223),_=i(53661);s.exports=function stackSet(s,o){var i=this.__data__;if(i instanceof a){var w=i.__data__;if(!u||w.length<199)return w.push([s,o]),this.size=++i.size,this;i=this.__data__=new _(w)}return i.set(s,o),this.size=i.size,this}},76959(s){s.exports=function strictIndexOf(s,o,i){for(var a=i-1,u=s.length;++a<u;)if(s[a]===o)return a;return-1}},63912(s,o,i){var a=i(61074),u=i(49698),_=i(42054);s.exports=function stringToArray(s){return u(s)?_(s):a(s)}},61802(s,o,i){var a=i(62224),u=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,_=/\\(\\)?/g,w=a((function(s){var o=[];return 46===s.charCodeAt(0)&&o.push(""),s.replace(u,(function(s,i,a,u){o.push(a?u.replace(_,"$1"):i||s)})),o}));s.exports=w},77797(s,o,i){var a=i(44394);s.exports=function toKey(s){if("string"==typeof s||a(s))return s;var o=s+"";return"0"==o&&1/s==-1/0?"-0":o}},47473(s){var o=Function.prototype.toString;s.exports=function toSource(s){if(null!=s){try{return o.call(s)}catch(s){}try{return s+""}catch(s){}}return""}},31800(s){var o=/\s/;s.exports=function trimmedEndIndex(s){for(var i=s.length;i--&&o.test(s.charAt(i)););return i}},42054(s){var o="\\ud800-\\udfff",i="["+o+"]",a="[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",u="\\ud83c[\\udffb-\\udfff]",_="[^"+o+"]",w="(?:\\ud83c[\\udde6-\\uddff]){2}",x="[\\ud800-\\udbff][\\udc00-\\udfff]",C="(?:"+a+"|"+u+")"+"?",j="[\\ufe0e\\ufe0f]?",L=j+C+("(?:\\u200d(?:"+[_,w,x].join("|")+")"+j+C+")*"),B="(?:"+[_+a+"?",a,w,x,i].join("|")+")",$=RegExp(u+"(?="+u+")|"+B+L,"g");s.exports=function unicodeToArray(s){return s.match($)||[]}},22225(s){var o="\\ud800-\\udfff",i="\\u2700-\\u27bf",a="a-z\\xdf-\\xf6\\xf8-\\xff",u="A-Z\\xc0-\\xd6\\xd8-\\xde",_="\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",w="["+_+"]",x="\\d+",C="["+i+"]",j="["+a+"]",L="[^"+o+_+x+i+a+u+"]",B="(?:\\ud83c[\\udde6-\\uddff]){2}",$="[\\ud800-\\udbff][\\udc00-\\udfff]",U="["+u+"]",V="(?:"+j+"|"+L+")",z="(?:"+U+"|"+L+")",Y="(?:['’](?:d|ll|m|re|s|t|ve))?",Z="(?:['’](?:D|LL|M|RE|S|T|VE))?",ee="(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?",ie="[\\ufe0e\\ufe0f]?",ae=ie+ee+("(?:\\u200d(?:"+["[^"+o+"]",B,$].join("|")+")"+ie+ee+")*"),ce="(?:"+[C,B,$].join("|")+")"+ae,le=RegExp([U+"?"+j+"+"+Y+"(?="+[w,U,"$"].join("|")+")",z+"+"+Z+"(?="+[w,U+V,"$"].join("|")+")",U+"?"+V+"+"+Y,U+"+"+Z,"\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])","\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",x,ce].join("|"),"g");s.exports=function unicodeWords(s){return s.match(le)||[]}},75948(s,o,i){var a=i(83729),u=i(15325),_=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]];s.exports=function updateWrapDetails(s,o){return a(_,(function(i){var a="_."+i[0];o&i[1]&&!u(s,a)&&s.push(a)})),s.sort()}},80257(s,o,i){var a=i(30980),u=i(56017),_=i(23007);s.exports=function wrapperClone(s){if(s instanceof a)return s.clone();var o=new u(s.__wrapped__,s.__chain__);return o.__actions__=_(s.__actions__),o.__index__=s.__index__,o.__values__=s.__values__,o}},64626(s,o,i){var a=i(66977);s.exports=function ary(s,o,i){return o=i?void 0:o,o=s&&null==o?s.length:o,a(s,128,void 0,void 0,void 0,void 0,o)}},84058(s,o,i){var a=i(14792),u=i(45539)((function(s,o,i){return o=o.toLowerCase(),s+(i?a(o):o)}));s.exports=u},14792(s,o,i){var a=i(13222),u=i(55808);s.exports=function capitalize(s){return u(a(s).toLowerCase())}},32629(s,o,i){var a=i(9999);s.exports=function clone(s){return a(s,4)}},37334(s){s.exports=function constant(s){return function(){return s}}},49747(s,o,i){var a=i(66977);function curry(s,o,i){var u=a(s,8,void 0,void 0,void 0,void 0,void 0,o=i?void 0:o);return u.placeholder=curry.placeholder,u}curry.placeholder={},s.exports=curry},38221(s,o,i){var a=i(23805),u=i(10124),_=i(99374),w=Math.max,x=Math.min;s.exports=function debounce(s,o,i){var C,j,L,B,$,U,V=0,z=!1,Y=!1,Z=!0;if("function"!=typeof s)throw new TypeError("Expected a function");function invokeFunc(o){var i=C,a=j;return C=j=void 0,V=o,B=s.apply(a,i)}function shouldInvoke(s){var i=s-U;return void 0===U||i>=o||i<0||Y&&s-V>=L}function timerExpired(){var s=u();if(shouldInvoke(s))return trailingEdge(s);$=setTimeout(timerExpired,function remainingWait(s){var i=o-(s-U);return Y?x(i,L-(s-V)):i}(s))}function trailingEdge(s){return $=void 0,Z&&C?invokeFunc(s):(C=j=void 0,B)}function debounced(){var s=u(),i=shouldInvoke(s);if(C=arguments,j=this,U=s,i){if(void 0===$)return function leadingEdge(s){return V=s,$=setTimeout(timerExpired,o),z?invokeFunc(s):B}(U);if(Y)return clearTimeout($),$=setTimeout(timerExpired,o),invokeFunc(U)}return void 0===$&&($=setTimeout(timerExpired,o)),B}return o=_(o)||0,a(i)&&(z=!!i.leading,L=(Y="maxWait"in i)?w(_(i.maxWait)||0,o):L,Z="trailing"in i?!!i.trailing:Z),debounced.cancel=function cancel(){void 0!==$&&clearTimeout($),V=0,C=U=j=$=void 0},debounced.flush=function flush(){return void 0===$?B:trailingEdge(u())},debounced}},50828(s,o,i){var a=i(24647),u=i(13222),_=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,w=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g");s.exports=function deburr(s){return(s=u(s))&&s.replace(_,a).replace(w,"")}},75288(s){s.exports=function eq(s,o){return s===o||s!=s&&o!=o}},60680(s,o,i){var a=i(13222),u=/[\\^$.*+?()[\]{}|]/g,_=RegExp(u.source);s.exports=function escapeRegExp(s){return(s=a(s))&&_.test(s)?s.replace(u,"\\$&"):s}},7309(s,o,i){var a=i(62006)(i(24713));s.exports=a},24713(s,o,i){var a=i(2523),u=i(15389),_=i(61489),w=Math.max;s.exports=function findIndex(s,o,i){var x=null==s?0:s.length;if(!x)return-1;var C=null==i?0:_(i);return C<0&&(C=w(x+C,0)),a(s,u(o,3),C)}},35970(s,o,i){var a=i(83120);s.exports=function flatten(s){return(null==s?0:s.length)?a(s,1):[]}},73424(s,o,i){var a=i(16962),u=i(2874),_=Array.prototype.push;function baseAry(s,o){return 2==o?function(o,i){return s(o,i)}:function(o){return s(o)}}function cloneArray(s){for(var o=s?s.length:0,i=Array(o);o--;)i[o]=s[o];return i}function wrapImmutable(s,o){return function(){var i=arguments.length;if(i){for(var a=Array(i);i--;)a[i]=arguments[i];var u=a[0]=o.apply(void 0,a);return s.apply(void 0,a),u}}}s.exports=function baseConvert(s,o,i,w){var x="function"==typeof o,C=o===Object(o);if(C&&(w=i,i=o,o=void 0),null==i)throw new TypeError;w||(w={});var j=!("cap"in w)||w.cap,L=!("curry"in w)||w.curry,B=!("fixed"in w)||w.fixed,$=!("immutable"in w)||w.immutable,U=!("rearg"in w)||w.rearg,V=x?i:u,z="curry"in w&&w.curry,Y="fixed"in w&&w.fixed,Z="rearg"in w&&w.rearg,ee=x?i.runInContext():void 0,ie=x?i:{ary:s.ary,assign:s.assign,clone:s.clone,curry:s.curry,forEach:s.forEach,isArray:s.isArray,isError:s.isError,isFunction:s.isFunction,isWeakMap:s.isWeakMap,iteratee:s.iteratee,keys:s.keys,rearg:s.rearg,toInteger:s.toInteger,toPath:s.toPath},ae=ie.ary,ce=ie.assign,le=ie.clone,pe=ie.curry,de=ie.forEach,fe=ie.isArray,ye=ie.isError,be=ie.isFunction,Se=ie.isWeakMap,_e=ie.keys,we=ie.rearg,xe=ie.toInteger,Pe=ie.toPath,Te=_e(a.aryMethod),Re={castArray:function(s){return function(){var o=arguments[0];return fe(o)?s(cloneArray(o)):s.apply(void 0,arguments)}},iteratee:function(s){return function(){var o=arguments[1],i=s(arguments[0],o),a=i.length;return j&&"number"==typeof o?(o=o>2?o-2:1,a&&a<=o?i:baseAry(i,o)):i}},mixin:function(s){return function(o){var i=this;if(!be(i))return s(i,Object(o));var a=[];return de(_e(o),(function(s){be(o[s])&&a.push([s,i.prototype[s]])})),s(i,Object(o)),de(a,(function(s){var o=s[1];be(o)?i.prototype[s[0]]=o:delete i.prototype[s[0]]})),i}},nthArg:function(s){return function(o){var i=o<0?1:xe(o)+1;return pe(s(o),i)}},rearg:function(s){return function(o,i){var a=i?i.length:0;return pe(s(o,i),a)}},runInContext:function(o){return function(i){return baseConvert(s,o(i),w)}}};function castCap(s,o){if(j){var i=a.iterateeRearg[s];if(i)return function iterateeRearg(s,o){return overArg(s,(function(s){var i=o.length;return function baseArity(s,o){return 2==o?function(o,i){return s.apply(void 0,arguments)}:function(o){return s.apply(void 0,arguments)}}(we(baseAry(s,i),o),i)}))}(o,i);var u=!x&&a.iterateeAry[s];if(u)return function iterateeAry(s,o){return overArg(s,(function(s){return"function"==typeof s?baseAry(s,o):s}))}(o,u)}return o}function castFixed(s,o,i){if(B&&(Y||!a.skipFixed[s])){var u=a.methodSpread[s],w=u&&u.start;return void 0===w?ae(o,i):function flatSpread(s,o){return function(){for(var i=arguments.length,a=i-1,u=Array(i);i--;)u[i]=arguments[i];var w=u[o],x=u.slice(0,o);return w&&_.apply(x,w),o!=a&&_.apply(x,u.slice(o+1)),s.apply(this,x)}}(o,w)}return o}function castRearg(s,o,i){return U&&i>1&&(Z||!a.skipRearg[s])?we(o,a.methodRearg[s]||a.aryRearg[i]):o}function cloneByPath(s,o){for(var i=-1,a=(o=Pe(o)).length,u=a-1,_=le(Object(s)),w=_;null!=w&&++i<a;){var x=o[i],C=w[x];null==C||be(C)||ye(C)||Se(C)||(w[x]=le(i==u?C:Object(C))),w=w[x]}return _}function createConverter(s,o){var i=a.aliasToReal[s]||s,u=a.remap[i]||i,_=w;return function(s){var a=x?ee:ie,w=x?ee[u]:o,C=ce(ce({},_),s);return baseConvert(a,i,w,C)}}function overArg(s,o){return function(){var i=arguments.length;if(!i)return s();for(var a=Array(i);i--;)a[i]=arguments[i];var u=U?0:i-1;return a[u]=o(a[u]),s.apply(void 0,a)}}function wrap(s,o,i){var u,_=a.aliasToReal[s]||s,w=o,x=Re[_];return x?w=x(o):$&&(a.mutate.array[_]?w=wrapImmutable(o,cloneArray):a.mutate.object[_]?w=wrapImmutable(o,function createCloner(s){return function(o){return s({},o)}}(o)):a.mutate.set[_]&&(w=wrapImmutable(o,cloneByPath))),de(Te,(function(s){return de(a.aryMethod[s],(function(o){if(_==o){var i=a.methodSpread[_],x=i&&i.afterRearg;return u=x?castFixed(_,castRearg(_,w,s),s):castRearg(_,castFixed(_,w,s),s),u=function castCurry(s,o,i){return z||L&&i>1?pe(o,i):o}(0,u=castCap(_,u),s),!1}})),!u})),u||(u=w),u==o&&(u=z?pe(u,1):function(){return o.apply(this,arguments)}),u.convert=createConverter(_,o),u.placeholder=o.placeholder=i,u}if(!C)return wrap(o,i,V);var $e=i,qe=[];return de(Te,(function(s){de(a.aryMethod[s],(function(s){var o=$e[a.remap[s]||s];o&&qe.push([s,wrap(s,o,$e)])}))})),de(_e($e),(function(s){var o=$e[s];if("function"==typeof o){for(var i=qe.length;i--;)if(qe[i][0]==s)return;o.convert=createConverter(s,o),qe.push([s,o])}})),de(qe,(function(s){$e[s[0]]=s[1]})),$e.convert=function convertLib(s){return $e.runInContext.convert(s)(void 0)},$e.placeholder=$e,de(_e($e),(function(s){de(a.realToAlias[s]||[],(function(o){$e[o]=$e[s]}))})),$e}},16962(s,o){o.aliasToReal={each:"forEach",eachRight:"forEachRight",entries:"toPairs",entriesIn:"toPairsIn",extend:"assignIn",extendAll:"assignInAll",extendAllWith:"assignInAllWith",extendWith:"assignInWith",first:"head",conforms:"conformsTo",matches:"isMatch",property:"get",__:"placeholder",F:"stubFalse",T:"stubTrue",all:"every",allPass:"overEvery",always:"constant",any:"some",anyPass:"overSome",apply:"spread",assoc:"set",assocPath:"set",complement:"negate",compose:"flowRight",contains:"includes",dissoc:"unset",dissocPath:"unset",dropLast:"dropRight",dropLastWhile:"dropRightWhile",equals:"isEqual",identical:"eq",indexBy:"keyBy",init:"initial",invertObj:"invert",juxt:"over",omitAll:"omit",nAry:"ary",path:"get",pathEq:"matchesProperty",pathOr:"getOr",paths:"at",pickAll:"pick",pipe:"flow",pluck:"map",prop:"get",propEq:"matchesProperty",propOr:"getOr",props:"at",symmetricDifference:"xor",symmetricDifferenceBy:"xorBy",symmetricDifferenceWith:"xorWith",takeLast:"takeRight",takeLastWhile:"takeRightWhile",unapply:"rest",unnest:"flatten",useWith:"overArgs",where:"conformsTo",whereEq:"isMatch",zipObj:"zipObject"},o.aryMethod={1:["assignAll","assignInAll","attempt","castArray","ceil","create","curry","curryRight","defaultsAll","defaultsDeepAll","floor","flow","flowRight","fromPairs","invert","iteratee","memoize","method","mergeAll","methodOf","mixin","nthArg","over","overEvery","overSome","rest","reverse","round","runInContext","spread","template","trim","trimEnd","trimStart","uniqueId","words","zipAll"],2:["add","after","ary","assign","assignAllWith","assignIn","assignInAllWith","at","before","bind","bindAll","bindKey","chunk","cloneDeepWith","cloneWith","concat","conformsTo","countBy","curryN","curryRightN","debounce","defaults","defaultsDeep","defaultTo","delay","difference","divide","drop","dropRight","dropRightWhile","dropWhile","endsWith","eq","every","filter","find","findIndex","findKey","findLast","findLastIndex","findLastKey","flatMap","flatMapDeep","flattenDepth","forEach","forEachRight","forIn","forInRight","forOwn","forOwnRight","get","groupBy","gt","gte","has","hasIn","includes","indexOf","intersection","invertBy","invoke","invokeMap","isEqual","isMatch","join","keyBy","lastIndexOf","lt","lte","map","mapKeys","mapValues","matchesProperty","maxBy","meanBy","merge","mergeAllWith","minBy","multiply","nth","omit","omitBy","overArgs","pad","padEnd","padStart","parseInt","partial","partialRight","partition","pick","pickBy","propertyOf","pull","pullAll","pullAt","random","range","rangeRight","rearg","reject","remove","repeat","restFrom","result","sampleSize","some","sortBy","sortedIndex","sortedIndexOf","sortedLastIndex","sortedLastIndexOf","sortedUniqBy","split","spreadFrom","startsWith","subtract","sumBy","take","takeRight","takeRightWhile","takeWhile","tap","throttle","thru","times","trimChars","trimCharsEnd","trimCharsStart","truncate","union","uniqBy","uniqWith","unset","unzipWith","without","wrap","xor","zip","zipObject","zipObjectDeep"],3:["assignInWith","assignWith","clamp","differenceBy","differenceWith","findFrom","findIndexFrom","findLastFrom","findLastIndexFrom","getOr","includesFrom","indexOfFrom","inRange","intersectionBy","intersectionWith","invokeArgs","invokeArgsMap","isEqualWith","isMatchWith","flatMapDepth","lastIndexOfFrom","mergeWith","orderBy","padChars","padCharsEnd","padCharsStart","pullAllBy","pullAllWith","rangeStep","rangeStepRight","reduce","reduceRight","replace","set","slice","sortedIndexBy","sortedLastIndexBy","transform","unionBy","unionWith","update","xorBy","xorWith","zipWith"],4:["fill","setWith","updateWith"]},o.aryRearg={2:[1,0],3:[2,0,1],4:[3,2,0,1]},o.iterateeAry={dropRightWhile:1,dropWhile:1,every:1,filter:1,find:1,findFrom:1,findIndex:1,findIndexFrom:1,findKey:1,findLast:1,findLastFrom:1,findLastIndex:1,findLastIndexFrom:1,findLastKey:1,flatMap:1,flatMapDeep:1,flatMapDepth:1,forEach:1,forEachRight:1,forIn:1,forInRight:1,forOwn:1,forOwnRight:1,map:1,mapKeys:1,mapValues:1,partition:1,reduce:2,reduceRight:2,reject:1,remove:1,some:1,takeRightWhile:1,takeWhile:1,times:1,transform:2},o.iterateeRearg={mapKeys:[1],reduceRight:[1,0]},o.methodRearg={assignInAllWith:[1,0],assignInWith:[1,2,0],assignAllWith:[1,0],assignWith:[1,2,0],differenceBy:[1,2,0],differenceWith:[1,2,0],getOr:[2,1,0],intersectionBy:[1,2,0],intersectionWith:[1,2,0],isEqualWith:[1,2,0],isMatchWith:[2,1,0],mergeAllWith:[1,0],mergeWith:[1,2,0],padChars:[2,1,0],padCharsEnd:[2,1,0],padCharsStart:[2,1,0],pullAllBy:[2,1,0],pullAllWith:[2,1,0],rangeStep:[1,2,0],rangeStepRight:[1,2,0],setWith:[3,1,2,0],sortedIndexBy:[2,1,0],sortedLastIndexBy:[2,1,0],unionBy:[1,2,0],unionWith:[1,2,0],updateWith:[3,1,2,0],xorBy:[1,2,0],xorWith:[1,2,0],zipWith:[1,2,0]},o.methodSpread={assignAll:{start:0},assignAllWith:{start:0},assignInAll:{start:0},assignInAllWith:{start:0},defaultsAll:{start:0},defaultsDeepAll:{start:0},invokeArgs:{start:2},invokeArgsMap:{start:2},mergeAll:{start:0},mergeAllWith:{start:0},partial:{start:1},partialRight:{start:1},without:{start:1},zipAll:{start:0}},o.mutate={array:{fill:!0,pull:!0,pullAll:!0,pullAllBy:!0,pullAllWith:!0,pullAt:!0,remove:!0,reverse:!0},object:{assign:!0,assignAll:!0,assignAllWith:!0,assignIn:!0,assignInAll:!0,assignInAllWith:!0,assignInWith:!0,assignWith:!0,defaults:!0,defaultsAll:!0,defaultsDeep:!0,defaultsDeepAll:!0,merge:!0,mergeAll:!0,mergeAllWith:!0,mergeWith:!0},set:{set:!0,setWith:!0,unset:!0,update:!0,updateWith:!0}},o.realToAlias=function(){var s=Object.prototype.hasOwnProperty,i=o.aliasToReal,a={};for(var u in i){var _=i[u];s.call(a,_)?a[_].push(u):a[_]=[u]}return a}(),o.remap={assignAll:"assign",assignAllWith:"assignWith",assignInAll:"assignIn",assignInAllWith:"assignInWith",curryN:"curry",curryRightN:"curryRight",defaultsAll:"defaults",defaultsDeepAll:"defaultsDeep",findFrom:"find",findIndexFrom:"findIndex",findLastFrom:"findLast",findLastIndexFrom:"findLastIndex",getOr:"get",includesFrom:"includes",indexOfFrom:"indexOf",invokeArgs:"invoke",invokeArgsMap:"invokeMap",lastIndexOfFrom:"lastIndexOf",mergeAll:"merge",mergeAllWith:"mergeWith",padChars:"pad",padCharsEnd:"padEnd",padCharsStart:"padStart",propertyOf:"get",rangeStep:"range",rangeStepRight:"rangeRight",restFrom:"rest",spreadFrom:"spread",trimChars:"trim",trimCharsEnd:"trimEnd",trimCharsStart:"trimStart",zipAll:"zip"},o.skipFixed={castArray:!0,flow:!0,flowRight:!0,iteratee:!0,mixin:!0,rearg:!0,runInContext:!0},o.skipRearg={add:!0,assign:!0,assignIn:!0,bind:!0,bindKey:!0,concat:!0,difference:!0,divide:!0,eq:!0,gt:!0,gte:!0,isEqual:!0,lt:!0,lte:!0,matchesProperty:!0,merge:!0,multiply:!0,overArgs:!0,partial:!0,partialRight:!0,propertyOf:!0,random:!0,range:!0,rangeRight:!0,subtract:!0,zip:!0,zipObject:!0,zipObjectDeep:!0}},47934(s,o,i){s.exports={ary:i(64626),assign:i(74733),clone:i(32629),curry:i(49747),forEach:i(83729),isArray:i(56449),isError:i(23546),isFunction:i(1882),isWeakMap:i(47886),iteratee:i(33855),keys:i(88984),rearg:i(84195),toInteger:i(61489),toPath:i(42072)}},56367(s,o,i){s.exports=i(77731)},79920(s,o,i){var a=i(73424),u=i(47934);s.exports=function convert(s,o,i){return a(u,s,o,i)}},2874(s){s.exports={}},77731(s,o,i){var a=i(79920)("set",i(63560));a.placeholder=i(2874),s.exports=a},58156(s,o,i){var a=i(47422);s.exports=function get(s,o,i){var u=null==s?void 0:a(s,o);return void 0===u?i:u}},61448(s,o,i){var a=i(20426),u=i(49326);s.exports=function has(s,o){return null!=s&&u(s,o,a)}},80631(s,o,i){var a=i(28077),u=i(49326);s.exports=function hasIn(s,o){return null!=s&&u(s,o,a)}},83488(s){s.exports=function identity(s){return s}},72428(s,o,i){var a=i(27534),u=i(40346),_=Object.prototype,w=_.hasOwnProperty,x=_.propertyIsEnumerable,C=a(function(){return arguments}())?a:function(s){return u(s)&&w.call(s,"callee")&&!x.call(s,"callee")};s.exports=C},56449(s){var o=Array.isArray;s.exports=o},64894(s,o,i){var a=i(1882),u=i(30294);s.exports=function isArrayLike(s){return null!=s&&u(s.length)&&!a(s)}},83693(s,o,i){var a=i(64894),u=i(40346);s.exports=function isArrayLikeObject(s){return u(s)&&a(s)}},53812(s,o,i){var a=i(72552),u=i(40346);s.exports=function isBoolean(s){return!0===s||!1===s||u(s)&&"[object Boolean]"==a(s)}},3656(s,o,i){s=i.nmd(s);var a=i(9325),u=i(89935),_=o&&!o.nodeType&&o,w=_&&s&&!s.nodeType&&s,x=w&&w.exports===_?a.Buffer:void 0,C=(x?x.isBuffer:void 0)||u;s.exports=C},62193(s,o,i){var a=i(88984),u=i(5861),_=i(72428),w=i(56449),x=i(64894),C=i(3656),j=i(55527),L=i(37167),B=Object.prototype.hasOwnProperty;s.exports=function isEmpty(s){if(null==s)return!0;if(x(s)&&(w(s)||"string"==typeof s||"function"==typeof s.splice||C(s)||L(s)||_(s)))return!s.length;var o=u(s);if("[object Map]"==o||"[object Set]"==o)return!s.size;if(j(s))return!a(s).length;for(var i in s)if(B.call(s,i))return!1;return!0}},2404(s,o,i){var a=i(60270);s.exports=function isEqual(s,o){return a(s,o)}},23546(s,o,i){var a=i(72552),u=i(40346),_=i(11331);s.exports=function isError(s){if(!u(s))return!1;var o=a(s);return"[object Error]"==o||"[object DOMException]"==o||"string"==typeof s.message&&"string"==typeof s.name&&!_(s)}},1882(s,o,i){var a=i(72552),u=i(23805);s.exports=function isFunction(s){if(!u(s))return!1;var o=a(s);return"[object Function]"==o||"[object GeneratorFunction]"==o||"[object AsyncFunction]"==o||"[object Proxy]"==o}},30294(s){s.exports=function isLength(s){return"number"==typeof s&&s>-1&&s%1==0&&s<=9007199254740991}},87730(s,o,i){var a=i(29172),u=i(27301),_=i(86009),w=_&&_.isMap,x=w?u(w):a;s.exports=x},5187(s){s.exports=function isNull(s){return null===s}},98023(s,o,i){var a=i(72552),u=i(40346);s.exports=function isNumber(s){return"number"==typeof s||u(s)&&"[object Number]"==a(s)}},23805(s){s.exports=function isObject(s){var o=typeof s;return null!=s&&("object"==o||"function"==o)}},40346(s){s.exports=function isObjectLike(s){return null!=s&&"object"==typeof s}},11331(s,o,i){var a=i(72552),u=i(28879),_=i(40346),w=Function.prototype,x=Object.prototype,C=w.toString,j=x.hasOwnProperty,L=C.call(Object);s.exports=function isPlainObject(s){if(!_(s)||"[object Object]"!=a(s))return!1;var o=u(s);if(null===o)return!0;var i=j.call(o,"constructor")&&o.constructor;return"function"==typeof i&&i instanceof i&&C.call(i)==L}},38440(s,o,i){var a=i(16038),u=i(27301),_=i(86009),w=_&&_.isSet,x=w?u(w):a;s.exports=x},85015(s,o,i){var a=i(72552),u=i(56449),_=i(40346);s.exports=function isString(s){return"string"==typeof s||!u(s)&&_(s)&&"[object String]"==a(s)}},44394(s,o,i){var a=i(72552),u=i(40346);s.exports=function isSymbol(s){return"symbol"==typeof s||u(s)&&"[object Symbol]"==a(s)}},37167(s,o,i){var a=i(4901),u=i(27301),_=i(86009),w=_&&_.isTypedArray,x=w?u(w):a;s.exports=x},47886(s,o,i){var a=i(5861),u=i(40346);s.exports=function isWeakMap(s){return u(s)&&"[object WeakMap]"==a(s)}},33855(s,o,i){var a=i(9999),u=i(15389);s.exports=function iteratee(s){return u("function"==typeof s?s:a(s,1))}},95950(s,o,i){var a=i(70695),u=i(88984),_=i(64894);s.exports=function keys(s){return _(s)?a(s):u(s)}},37241(s,o,i){var a=i(70695),u=i(72903),_=i(64894);s.exports=function keysIn(s){return _(s)?a(s,!0):u(s)}},68090(s){s.exports=function last(s){var o=null==s?0:s.length;return o?s[o-1]:void 0}},50104(s,o,i){var a=i(53661);function memoize(s,o){if("function"!=typeof s||null!=o&&"function"!=typeof o)throw new TypeError("Expected a function");var memoized=function(){var i=arguments,a=o?o.apply(this,i):i[0],u=memoized.cache;if(u.has(a))return u.get(a);var _=s.apply(this,i);return memoized.cache=u.set(a,_)||u,_};return memoized.cache=new(memoize.Cache||a),memoized}memoize.Cache=a,s.exports=memoize},55364(s,o,i){var a=i(85250),u=i(20999)((function(s,o,i){a(s,o,i)}));s.exports=u},6048(s){s.exports=function negate(s){if("function"!=typeof s)throw new TypeError("Expected a function");return function(){var o=arguments;switch(o.length){case 0:return!s.call(this);case 1:return!s.call(this,o[0]);case 2:return!s.call(this,o[0],o[1]);case 3:return!s.call(this,o[0],o[1],o[2])}return!s.apply(this,o)}}},63950(s){s.exports=function noop(){}},10124(s,o,i){var a=i(9325);s.exports=function(){return a.Date.now()}},90179(s,o,i){var a=i(34932),u=i(9999),_=i(19931),w=i(31769),x=i(21791),C=i(53138),j=i(38816),L=i(83349),B=j((function(s,o){var i={};if(null==s)return i;var j=!1;o=a(o,(function(o){return o=w(o,s),j||(j=o.length>1),o})),x(s,L(s),i),j&&(i=u(i,7,C));for(var B=o.length;B--;)_(i,o[B]);return i}));s.exports=B},50583(s,o,i){var a=i(47237),u=i(17255),_=i(28586),w=i(77797);s.exports=function property(s){return _(s)?a(w(s)):u(s)}},84195(s,o,i){var a=i(66977),u=i(38816),_=u((function(s,o){return a(s,256,void 0,void 0,void 0,o)}));s.exports=_},40860(s,o,i){var a=i(40882),u=i(80909),_=i(15389),w=i(85558),x=i(56449);s.exports=function reduce(s,o,i){var C=x(s)?a:w,j=arguments.length<3;return C(s,_(o,4),i,j,u)}},63560(s,o,i){var a=i(73170);s.exports=function set(s,o,i){return null==s?s:a(s,o,i)}},42426(s,o,i){var a=i(14248),u=i(15389),_=i(90916),w=i(56449),x=i(36800);s.exports=function some(s,o,i){var C=w(s)?a:_;return i&&x(s,o,i)&&(o=void 0),C(s,u(o,3))}},63345(s){s.exports=function stubArray(){return[]}},89935(s){s.exports=function stubFalse(){return!1}},17400(s,o,i){var a=i(99374),u=1/0;s.exports=function toFinite(s){return s?(s=a(s))===u||s===-1/0?17976931348623157e292*(s<0?-1:1):s==s?s:0:0===s?s:0}},61489(s,o,i){var a=i(17400);s.exports=function toInteger(s){var o=a(s),i=o%1;return o==o?i?o-i:o:0}},80218(s,o,i){var a=i(13222);s.exports=function toLower(s){return a(s).toLowerCase()}},99374(s,o,i){var a=i(54128),u=i(23805),_=i(44394),w=/^[-+]0x[0-9a-f]+$/i,x=/^0b[01]+$/i,C=/^0o[0-7]+$/i,j=parseInt;s.exports=function toNumber(s){if("number"==typeof s)return s;if(_(s))return NaN;if(u(s)){var o="function"==typeof s.valueOf?s.valueOf():s;s=u(o)?o+"":o}if("string"!=typeof s)return 0===s?s:+s;s=a(s);var i=x.test(s);return i||C.test(s)?j(s.slice(2),i?2:8):w.test(s)?NaN:+s}},42072(s,o,i){var a=i(34932),u=i(23007),_=i(56449),w=i(44394),x=i(61802),C=i(77797),j=i(13222);s.exports=function toPath(s){return _(s)?a(s,C):w(s)?[s]:u(x(j(s)))}},69884(s,o,i){var a=i(21791),u=i(37241);s.exports=function toPlainObject(s){return a(s,u(s))}},13222(s,o,i){var a=i(77556);s.exports=function toString(s){return null==s?"":a(s)}},55808(s,o,i){var a=i(12507)("toUpperCase");s.exports=a},66645(s,o,i){var a=i(1733),u=i(45434),_=i(13222),w=i(22225);s.exports=function words(s,o,i){return s=_(s),void 0===(o=i?void 0:o)?u(s)?w(s):a(s):s.match(o)||[]}},53758(s,o,i){var a=i(30980),u=i(56017),_=i(94033),w=i(56449),x=i(40346),C=i(80257),j=Object.prototype.hasOwnProperty;function lodash(s){if(x(s)&&!w(s)&&!(s instanceof a)){if(s instanceof u)return s;if(j.call(s,"__wrapped__"))return C(s)}return new u(s)}lodash.prototype=_.prototype,lodash.prototype.constructor=lodash,s.exports=lodash},47248(s,o,i){var a=i(16547),u=i(51234);s.exports=function zipObject(s,o){return u(s||[],o||[],a)}},43768(s,o,i){"use strict";var a=i(45981),u=i(85587);o.highlight=highlight,o.highlightAuto=function highlightAuto(s,o){var i,w,x,C,j=o||{},L=j.subset||a.listLanguages(),B=j.prefix,$=L.length,U=-1;null==B&&(B=_);if("string"!=typeof s)throw u("Expected `string` for value, got `%s`",s);w={relevance:0,language:null,value:[]},i={relevance:0,language:null,value:[]};for(;++U<$;)C=L[U],a.getLanguage(C)&&((x=highlight(C,s,o)).language=C,x.relevance>w.relevance&&(w=x),x.relevance>i.relevance&&(w=i,i=x));w.language&&(i.secondBest=w);return i},o.registerLanguage=function registerLanguage(s,o){a.registerLanguage(s,o)},o.listLanguages=function listLanguages(){return a.listLanguages()},o.registerAlias=function registerAlias(s,o){var i,u=s;o&&((u={})[s]=o);for(i in u)a.registerAliases(u[i],{languageName:i})},Emitter.prototype.addText=function text(s){var o,i,a=this.stack;if(""===s)return;o=a[a.length-1],(i=o.children[o.children.length-1])&&"text"===i.type?i.value+=s:o.children.push({type:"text",value:s})},Emitter.prototype.addKeyword=function addKeyword(s,o){this.openNode(o),this.addText(s),this.closeNode()},Emitter.prototype.addSublanguage=function addSublanguage(s,o){var i=this.stack,a=i[i.length-1],u=s.rootNode.children,_=o?{type:"element",tagName:"span",properties:{className:[o]},children:u}:u;a.children=a.children.concat(_)},Emitter.prototype.openNode=function open(s){var o=this.stack,i=this.options.classPrefix+s,a=o[o.length-1],u={type:"element",tagName:"span",properties:{className:[i]},children:[]};a.children.push(u),o.push(u)},Emitter.prototype.closeNode=function close(){this.stack.pop()},Emitter.prototype.closeAllNodes=noop,Emitter.prototype.finalize=noop,Emitter.prototype.toHTML=function toHtmlNoop(){return""};var _="hljs-";function highlight(s,o,i){var w,x=a.configure({}),C=(i||{}).prefix;if("string"!=typeof s)throw u("Expected `string` for name, got `%s`",s);if(!a.getLanguage(s))throw u("Unknown language: `%s` is not registered",s);if("string"!=typeof o)throw u("Expected `string` for value, got `%s`",o);if(null==C&&(C=_),a.configure({__emitter:Emitter,classPrefix:C}),w=a.highlight(o,{language:s,ignoreIllegals:!0}),a.configure(x||{}),w.errorRaised)throw w.errorRaised;return{relevance:w.relevance,language:w.language,value:w.emitter.rootNode.children}}function Emitter(s){this.options=s,this.rootNode={children:[]},this.stack=[this.rootNode]}function noop(){}},71514(s){"use strict";s.exports=Math.abs},58968(s){"use strict";s.exports=Math.floor},94459(s){"use strict";s.exports=Number.isNaN||function isNaN(s){return s!=s}},6188(s){"use strict";s.exports=Math.max},68002(s){"use strict";s.exports=Math.min},75880(s){"use strict";s.exports=Math.pow},70414(s){"use strict";s.exports=Math.round},73093(s,o,i){"use strict";var a=i(94459);s.exports=function sign(s){return a(s)||0===s?s:s<0?-1:1}},92340(s,o,i){const a=i(6048);function coerceElementMatchingCallback(s){return"string"==typeof s?o=>o.element===s:s.constructor&&s.extend?o=>o instanceof s:s}class ArraySlice{constructor(s){this.elements=s||[]}toValue(){return this.elements.map((s=>s.toValue()))}map(s,o){return this.elements.map(s,o)}flatMap(s,o){return this.map(s,o).reduce(((s,o)=>s.concat(o)),[])}compactMap(s,o){const i=[];return this.forEach((a=>{const u=s.bind(o)(a);u&&i.push(u)})),i}filter(s,o){return s=coerceElementMatchingCallback(s),new ArraySlice(this.elements.filter(s,o))}reject(s,o){return s=coerceElementMatchingCallback(s),new ArraySlice(this.elements.filter(a(s),o))}find(s,o){return s=coerceElementMatchingCallback(s),this.elements.find(s,o)}forEach(s,o){this.elements.forEach(s,o)}reduce(s,o){return this.elements.reduce(s,o)}includes(s){return this.elements.some((o=>o.equals(s)))}shift(){return this.elements.shift()}unshift(s){this.elements.unshift(this.refract(s))}push(s){return this.elements.push(this.refract(s)),this}add(s){this.push(s)}get(s){return this.elements[s]}getValue(s){const o=this.elements[s];if(o)return o.toValue()}get length(){return this.elements.length}get isEmpty(){return 0===this.elements.length}get first(){return this.elements[0]}}"undefined"!=typeof Symbol&&(ArraySlice.prototype[Symbol.iterator]=function symbol(){return this.elements[Symbol.iterator]()}),s.exports=ArraySlice},55973(s){class KeyValuePair{constructor(s,o){this.key=s,this.value=o}clone(){const s=new KeyValuePair;return this.key&&(s.key=this.key.clone()),this.value&&(s.value=this.value.clone()),s}}s.exports=KeyValuePair},3110(s,o,i){const a=i(5187),u=i(85015),_=i(98023),w=i(53812),x=i(23805),C=i(85105),j=i(86804);class Namespace{constructor(s){this.elementMap={},this.elementDetection=[],this.Element=j.Element,this.KeyValuePair=j.KeyValuePair,s&&s.noDefault||this.useDefault(),this._attributeElementKeys=[],this._attributeElementArrayKeys=[]}use(s){return s.namespace&&s.namespace({base:this}),s.load&&s.load({base:this}),this}useDefault(){return this.register("null",j.NullElement).register("string",j.StringElement).register("number",j.NumberElement).register("boolean",j.BooleanElement).register("array",j.ArrayElement).register("object",j.ObjectElement).register("member",j.MemberElement).register("ref",j.RefElement).register("link",j.LinkElement),this.detect(a,j.NullElement,!1).detect(u,j.StringElement,!1).detect(_,j.NumberElement,!1).detect(w,j.BooleanElement,!1).detect(Array.isArray,j.ArrayElement,!1).detect(x,j.ObjectElement,!1),this}register(s,o){return this._elements=void 0,this.elementMap[s]=o,this}unregister(s){return this._elements=void 0,delete this.elementMap[s],this}detect(s,o,i){return void 0===i||i?this.elementDetection.unshift([s,o]):this.elementDetection.push([s,o]),this}toElement(s){if(s instanceof this.Element)return s;let o;for(let i=0;i<this.elementDetection.length;i+=1){const a=this.elementDetection[i][0],u=this.elementDetection[i][1];if(a(s)){o=new u(s);break}}return o}getElementClass(s){const o=this.elementMap[s];return void 0===o?this.Element:o}fromRefract(s){return this.serialiser.deserialise(s)}toRefract(s){return this.serialiser.serialise(s)}get elements(){return void 0===this._elements&&(this._elements={Element:this.Element},Object.keys(this.elementMap).forEach((s=>{const o=s[0].toUpperCase()+s.substr(1);this._elements[o]=this.elementMap[s]}))),this._elements}get serialiser(){return new C(this)}}C.prototype.Namespace=Namespace,s.exports=Namespace},10866(s,o,i){const a=i(6048),u=i(92340);class ObjectSlice extends u{map(s,o){return this.elements.map((i=>s.bind(o)(i.value,i.key,i)))}filter(s,o){return new ObjectSlice(this.elements.filter((i=>s.bind(o)(i.value,i.key,i))))}reject(s,o){return this.filter(a(s.bind(o)))}forEach(s,o){return this.elements.forEach(((i,a)=>{s.bind(o)(i.value,i.key,i,a)}))}keys(){return this.map(((s,o)=>o.toValue()))}values(){return this.map((s=>s.toValue()))}}s.exports=ObjectSlice},86804(s,o,i){const a=i(10316),u=i(41067),_=i(71167),w=i(40239),x=i(12242),C=i(6233),j=i(87726),L=i(61045),B=i(86303),$=i(14540),U=i(92340),V=i(10866),z=i(55973);function refract(s){if(s instanceof a)return s;if("string"==typeof s)return new _(s);if("number"==typeof s)return new w(s);if("boolean"==typeof s)return new x(s);if(null===s)return new u;if(Array.isArray(s))return new C(s.map(refract));if("object"==typeof s){return new L(s)}return s}a.prototype.ObjectElement=L,a.prototype.RefElement=$,a.prototype.MemberElement=j,a.prototype.refract=refract,U.prototype.refract=refract,s.exports={Element:a,NullElement:u,StringElement:_,NumberElement:w,BooleanElement:x,ArrayElement:C,MemberElement:j,ObjectElement:L,LinkElement:B,RefElement:$,refract,ArraySlice:U,ObjectSlice:V,KeyValuePair:z}},86303(s,o,i){const a=i(10316);s.exports=class LinkElement extends a{constructor(s,o,i){super(s||[],o,i),this.element="link"}get relation(){return this.attributes.get("relation")}set relation(s){this.attributes.set("relation",s)}get href(){return this.attributes.get("href")}set href(s){this.attributes.set("href",s)}}},14540(s,o,i){const a=i(10316);s.exports=class RefElement extends a{constructor(s,o,i){super(s||[],o,i),this.element="ref",this.path||(this.path="element")}get path(){return this.attributes.get("path")}set path(s){this.attributes.set("path",s)}}},34035(s,o,i){const a=i(3110),u=i(86804);o.g$=a,o.KeyValuePair=i(55973),o.G6=u.ArraySlice,o.ot=u.ObjectSlice,o.Hg=u.Element,o.Om=u.StringElement,o.kT=u.NumberElement,o.bd=u.BooleanElement,o.Os=u.NullElement,o.wE=u.ArrayElement,o.Sh=u.ObjectElement,o.Pr=u.MemberElement,o.sI=u.RefElement,o.Ft=u.LinkElement,o.e=u.refract,i(85105),i(75147)},6233(s,o,i){const a=i(6048),u=i(10316),_=i(92340);class ArrayElement extends u{constructor(s,o,i){super(s||[],o,i),this.element="array"}primitive(){return"array"}get(s){return this.content[s]}getValue(s){const o=this.get(s);if(o)return o.toValue()}getIndex(s){return this.content[s]}set(s,o){return this.content[s]=this.refract(o),this}remove(s){const o=this.content.splice(s,1);return o.length?o[0]:null}map(s,o){return this.content.map(s,o)}flatMap(s,o){return this.map(s,o).reduce(((s,o)=>s.concat(o)),[])}compactMap(s,o){const i=[];return this.forEach((a=>{const u=s.bind(o)(a);u&&i.push(u)})),i}filter(s,o){return new _(this.content.filter(s,o))}reject(s,o){return this.filter(a(s),o)}reduce(s,o){let i,a;void 0!==o?(i=0,a=this.refract(o)):(i=1,a="object"===this.primitive()?this.first.value:this.first);for(let o=i;o<this.length;o+=1){const i=this.content[o];a="object"===this.primitive()?this.refract(s(a,i.value,i.key,i,this)):this.refract(s(a,i,o,this))}return a}forEach(s,o){this.content.forEach(((i,a)=>{s.bind(o)(i,this.refract(a))}))}shift(){return this.content.shift()}unshift(s){this.content.unshift(this.refract(s))}push(s){return this.content.push(this.refract(s)),this}add(s){this.push(s)}findElements(s,o){const i=o||{},a=!!i.recursive,u=void 0===i.results?[]:i.results;return this.forEach(((o,i,_)=>{a&&void 0!==o.findElements&&o.findElements(s,{results:u,recursive:a}),s(o,i,_)&&u.push(o)})),u}find(s){return new _(this.findElements(s,{recursive:!0}))}findByElement(s){return this.find((o=>o.element===s))}findByClass(s){return this.find((o=>o.classes.includes(s)))}getById(s){return this.find((o=>o.id.toValue()===s)).first}includes(s){return this.content.some((o=>o.equals(s)))}contains(s){return this.includes(s)}empty(){return new this.constructor([])}"fantasy-land/empty"(){return this.empty()}concat(s){return new this.constructor(this.content.concat(s.content))}"fantasy-land/concat"(s){return this.concat(s)}"fantasy-land/map"(s){return new this.constructor(this.map(s))}"fantasy-land/chain"(s){return this.map((o=>s(o)),this).reduce(((s,o)=>s.concat(o)),this.empty())}"fantasy-land/filter"(s){return new this.constructor(this.content.filter(s))}"fantasy-land/reduce"(s,o){return this.content.reduce(s,o)}get length(){return this.content.length}get isEmpty(){return 0===this.content.length}get first(){return this.getIndex(0)}get second(){return this.getIndex(1)}get last(){return this.getIndex(this.length-1)}}ArrayElement.empty=function empty(){return new this},ArrayElement["fantasy-land/empty"]=ArrayElement.empty,"undefined"!=typeof Symbol&&(ArrayElement.prototype[Symbol.iterator]=function symbol(){return this.content[Symbol.iterator]()}),s.exports=ArrayElement},12242(s,o,i){const a=i(10316);s.exports=class BooleanElement extends a{constructor(s,o,i){super(s,o,i),this.element="boolean"}primitive(){return"boolean"}}},10316(s,o,i){const a=i(2404),u=i(55973),_=i(92340);class Element{constructor(s,o,i){o&&(this.meta=o),i&&(this.attributes=i),this.content=s}freeze(){Object.isFrozen(this)||(this._meta&&(this.meta.parent=this,this.meta.freeze()),this._attributes&&(this.attributes.parent=this,this.attributes.freeze()),this.children.forEach((s=>{s.parent=this,s.freeze()}),this),this.content&&Array.isArray(this.content)&&Object.freeze(this.content),Object.freeze(this))}primitive(){}clone(){const s=new this.constructor;return s.element=this.element,this.meta.length&&(s._meta=this.meta.clone()),this.attributes.length&&(s._attributes=this.attributes.clone()),this.content?this.content.clone?s.content=this.content.clone():Array.isArray(this.content)?s.content=this.content.map((s=>s.clone())):s.content=this.content:s.content=this.content,s}toValue(){return this.content instanceof Element?this.content.toValue():this.content instanceof u?{key:this.content.key.toValue(),value:this.content.value?this.content.value.toValue():void 0}:this.content&&this.content.map?this.content.map((s=>s.toValue()),this):this.content}toRef(s){if(""===this.id.toValue())throw Error("Cannot create reference to an element that does not contain an ID");const o=new this.RefElement(this.id.toValue());return s&&(o.path=s),o}findRecursive(...s){if(arguments.length>1&&!this.isFrozen)throw new Error("Cannot find recursive with multiple element names without first freezing the element. Call `element.freeze()`");const o=s.pop();let i=new _;const append=(s,o)=>(s.push(o),s),checkElement=(s,i)=>{i.element===o&&s.push(i);const a=i.findRecursive(o);return a&&a.reduce(append,s),i.content instanceof u&&(i.content.key&&checkElement(s,i.content.key),i.content.value&&checkElement(s,i.content.value)),s};return this.content&&(this.content.element&&checkElement(i,this.content),Array.isArray(this.content)&&this.content.reduce(checkElement,i)),s.isEmpty||(i=i.filter((o=>{let i=o.parents.map((s=>s.element));for(const o in s){const a=s[o],u=i.indexOf(a);if(-1===u)return!1;i=i.splice(0,u)}return!0}))),i}set(s){return this.content=s,this}equals(s){return a(this.toValue(),s)}getMetaProperty(s,o){if(!this.meta.hasKey(s)){if(this.isFrozen){const s=this.refract(o);return s.freeze(),s}this.meta.set(s,o)}return this.meta.get(s)}setMetaProperty(s,o){this.meta.set(s,o)}get element(){return this._storedElement||"element"}set element(s){this._storedElement=s}get content(){return this._content}set content(s){if(s instanceof Element)this._content=s;else if(s instanceof _)this.content=s.elements;else if("string"==typeof s||"number"==typeof s||"boolean"==typeof s||"null"===s||null==s)this._content=s;else if(s instanceof u)this._content=s;else if(Array.isArray(s))this._content=s.map(this.refract);else{if("object"!=typeof s)throw new Error("Cannot set content to given value");this._content=Object.keys(s).map((o=>new this.MemberElement(o,s[o])))}}get meta(){if(!this._meta){if(this.isFrozen){const s=new this.ObjectElement;return s.freeze(),s}this._meta=new this.ObjectElement}return this._meta}set meta(s){s instanceof this.ObjectElement?this._meta=s:this.meta.set(s||{})}get attributes(){if(!this._attributes){if(this.isFrozen){const s=new this.ObjectElement;return s.freeze(),s}this._attributes=new this.ObjectElement}return this._attributes}set attributes(s){s instanceof this.ObjectElement?this._attributes=s:this.attributes.set(s||{})}get id(){return this.getMetaProperty("id","")}set id(s){this.setMetaProperty("id",s)}get classes(){return this.getMetaProperty("classes",[])}set classes(s){this.setMetaProperty("classes",s)}get title(){return this.getMetaProperty("title","")}set title(s){this.setMetaProperty("title",s)}get description(){return this.getMetaProperty("description","")}set description(s){this.setMetaProperty("description",s)}get links(){return this.getMetaProperty("links",[])}set links(s){this.setMetaProperty("links",s)}get isFrozen(){return Object.isFrozen(this)}get parents(){let{parent:s}=this;const o=new _;for(;s;)o.push(s),s=s.parent;return o}get children(){if(Array.isArray(this.content))return new _(this.content);if(this.content instanceof u){const s=new _([this.content.key]);return this.content.value&&s.push(this.content.value),s}return this.content instanceof Element?new _([this.content]):new _}get recursiveChildren(){const s=new _;return this.children.forEach((o=>{s.push(o),o.recursiveChildren.forEach((o=>{s.push(o)}))})),s}}s.exports=Element},87726(s,o,i){const a=i(55973),u=i(10316);s.exports=class MemberElement extends u{constructor(s,o,i,u){super(new a,i,u),this.element="member",this.key=s,this.value=o}get key(){return this.content.key}set key(s){this.content.key=this.refract(s)}get value(){return this.content.value}set value(s){this.content.value=this.refract(s)}}},41067(s,o,i){const a=i(10316);s.exports=class NullElement extends a{constructor(s,o,i){super(s||null,o,i),this.element="null"}primitive(){return"null"}set(){return new Error("Cannot set the value of null")}}},40239(s,o,i){const a=i(10316);s.exports=class NumberElement extends a{constructor(s,o,i){super(s,o,i),this.element="number"}primitive(){return"number"}}},61045(s,o,i){const a=i(6048),u=i(23805),_=i(6233),w=i(87726),x=i(10866);s.exports=class ObjectElement extends _{constructor(s,o,i){super(s||[],o,i),this.element="object"}primitive(){return"object"}toValue(){return this.content.reduce(((s,o)=>(s[o.key.toValue()]=o.value?o.value.toValue():void 0,s)),{})}get(s){const o=this.getMember(s);if(o)return o.value}getMember(s){if(void 0!==s)return this.content.find((o=>o.key.toValue()===s))}remove(s){let o=null;return this.content=this.content.filter((i=>i.key.toValue()!==s||(o=i,!1))),o}getKey(s){const o=this.getMember(s);if(o)return o.key}set(s,o){if(u(s))return Object.keys(s).forEach((o=>{this.set(o,s[o])})),this;const i=s,a=this.getMember(i);return a?a.value=o:this.content.push(new w(i,o)),this}keys(){return this.content.map((s=>s.key.toValue()))}values(){return this.content.map((s=>s.value.toValue()))}hasKey(s){return this.content.some((o=>o.key.equals(s)))}items(){return this.content.map((s=>[s.key.toValue(),s.value.toValue()]))}map(s,o){return this.content.map((i=>s.bind(o)(i.value,i.key,i)))}compactMap(s,o){const i=[];return this.forEach(((a,u,_)=>{const w=s.bind(o)(a,u,_);w&&i.push(w)})),i}filter(s,o){return new x(this.content).filter(s,o)}reject(s,o){return this.filter(a(s),o)}forEach(s,o){return this.content.forEach((i=>s.bind(o)(i.value,i.key,i)))}}},71167(s,o,i){const a=i(10316);s.exports=class StringElement extends a{constructor(s,o,i){super(s,o,i),this.element="string"}primitive(){return"string"}get length(){return this.content.length}}},75147(s,o,i){const a=i(85105);s.exports=class JSON06Serialiser extends a{serialise(s){if(!(s instanceof this.namespace.elements.Element))throw new TypeError(`Given element \`${s}\` is not an Element instance`);let o;s._attributes&&s.attributes.get("variable")&&(o=s.attributes.get("variable"));const i={element:s.element};s._meta&&s._meta.length>0&&(i.meta=this.serialiseObject(s.meta));const a="enum"===s.element||-1!==s.attributes.keys().indexOf("enumerations");if(a){const o=this.enumSerialiseAttributes(s);o&&(i.attributes=o)}else if(s._attributes&&s._attributes.length>0){let{attributes:a}=s;a.get("metadata")&&(a=a.clone(),a.set("meta",a.get("metadata")),a.remove("metadata")),"member"===s.element&&o&&(a=a.clone(),a.remove("variable")),a.length>0&&(i.attributes=this.serialiseObject(a))}if(a)i.content=this.enumSerialiseContent(s,i);else if(this[`${s.element}SerialiseContent`])i.content=this[`${s.element}SerialiseContent`](s,i);else if(void 0!==s.content){let a;o&&s.content.key?(a=s.content.clone(),a.key.attributes.set("variable",o),a=this.serialiseContent(a)):a=this.serialiseContent(s.content),this.shouldSerialiseContent(s,a)&&(i.content=a)}else this.shouldSerialiseContent(s,s.content)&&s instanceof this.namespace.elements.Array&&(i.content=[]);return i}shouldSerialiseContent(s,o){return"parseResult"===s.element||"httpRequest"===s.element||"httpResponse"===s.element||"category"===s.element||"link"===s.element||void 0!==o&&(!Array.isArray(o)||0!==o.length)}refSerialiseContent(s,o){return delete o.attributes,{href:s.toValue(),path:s.path.toValue()}}sourceMapSerialiseContent(s){return s.toValue()}dataStructureSerialiseContent(s){return[this.serialiseContent(s.content)]}enumSerialiseAttributes(s){const o=s.attributes.clone(),i=o.remove("enumerations")||new this.namespace.elements.Array([]),a=o.get("default");let u=o.get("samples")||new this.namespace.elements.Array([]);if(a&&a.content&&(a.content.attributes&&a.content.attributes.remove("typeAttributes"),o.set("default",new this.namespace.elements.Array([a.content]))),u.forEach((s=>{s.content&&s.content.element&&s.content.attributes.remove("typeAttributes")})),s.content&&0!==i.length&&u.unshift(s.content),u=u.map((s=>s instanceof this.namespace.elements.Array?[s]:new this.namespace.elements.Array([s.content]))),u.length&&o.set("samples",u),o.length>0)return this.serialiseObject(o)}enumSerialiseContent(s){if(s._attributes){const o=s.attributes.get("enumerations");if(o&&o.length>0)return o.content.map((s=>{const o=s.clone();return o.attributes.remove("typeAttributes"),this.serialise(o)}))}if(s.content){const o=s.content.clone();return o.attributes.remove("typeAttributes"),[this.serialise(o)]}return[]}deserialise(s){if("string"==typeof s)return new this.namespace.elements.String(s);if("number"==typeof s)return new this.namespace.elements.Number(s);if("boolean"==typeof s)return new this.namespace.elements.Boolean(s);if(null===s)return new this.namespace.elements.Null;if(Array.isArray(s))return new this.namespace.elements.Array(s.map(this.deserialise,this));const o=this.namespace.getElementClass(s.element),i=new o;i.element!==s.element&&(i.element=s.element),s.meta&&this.deserialiseObject(s.meta,i.meta),s.attributes&&this.deserialiseObject(s.attributes,i.attributes);const a=this.deserialiseContent(s.content);if(void 0===a&&null!==i.content||(i.content=a),"enum"===i.element){i.content&&i.attributes.set("enumerations",i.content);let s=i.attributes.get("samples");if(i.attributes.remove("samples"),s){const a=s;s=new this.namespace.elements.Array,a.forEach((a=>{a.forEach((a=>{const u=new o(a);u.element=i.element,s.push(u)}))}));const u=s.shift();i.content=u?u.content:void 0,i.attributes.set("samples",s)}else i.content=void 0;let a=i.attributes.get("default");if(a&&a.length>0){a=a.get(0);const s=new o(a);s.element=i.element,i.attributes.set("default",s)}}else if("dataStructure"===i.element&&Array.isArray(i.content))[i.content]=i.content;else if("category"===i.element){const s=i.attributes.get("meta");s&&(i.attributes.set("metadata",s),i.attributes.remove("meta"))}else"member"===i.element&&i.key&&i.key._attributes&&i.key._attributes.getValue("variable")&&(i.attributes.set("variable",i.key.attributes.get("variable")),i.key.attributes.remove("variable"));return i}serialiseContent(s){if(s instanceof this.namespace.elements.Element)return this.serialise(s);if(s instanceof this.namespace.KeyValuePair){const o={key:this.serialise(s.key)};return s.value&&(o.value=this.serialise(s.value)),o}return s&&s.map?s.map(this.serialise,this):s}deserialiseContent(s){if(s){if(s.element)return this.deserialise(s);if(s.key){const o=new this.namespace.KeyValuePair(this.deserialise(s.key));return s.value&&(o.value=this.deserialise(s.value)),o}if(s.map)return s.map(this.deserialise,this)}return s}shouldRefract(s){return!!(s._attributes&&s.attributes.keys().length||s._meta&&s.meta.keys().length)||"enum"!==s.element&&(s.element!==s.primitive()||"member"===s.element)}convertKeyToRefract(s,o){return this.shouldRefract(o)?this.serialise(o):"enum"===o.element?this.serialiseEnum(o):"array"===o.element?o.map((o=>this.shouldRefract(o)||"default"===s?this.serialise(o):"array"===o.element||"object"===o.element||"enum"===o.element?o.children.map((s=>this.serialise(s))):o.toValue())):"object"===o.element?(o.content||[]).map(this.serialise,this):o.toValue()}serialiseEnum(s){return s.children.map((s=>this.serialise(s)))}serialiseObject(s){const o={};return s.forEach(((s,i)=>{if(s){const a=i.toValue();o[a]=this.convertKeyToRefract(a,s)}})),o}deserialiseObject(s,o){Object.keys(s).forEach((i=>{o.set(i,this.deserialise(s[i]))}))}}},85105(s){s.exports=class JSONSerialiser{constructor(s){this.namespace=s||new this.Namespace}serialise(s){if(!(s instanceof this.namespace.elements.Element))throw new TypeError(`Given element \`${s}\` is not an Element instance`);const o={element:s.element};s._meta&&s._meta.length>0&&(o.meta=this.serialiseObject(s.meta)),s._attributes&&s._attributes.length>0&&(o.attributes=this.serialiseObject(s.attributes));const i=this.serialiseContent(s.content);return void 0!==i&&(o.content=i),o}deserialise(s){if(!s.element)throw new Error("Given value is not an object containing an element name");const o=new(this.namespace.getElementClass(s.element));o.element!==s.element&&(o.element=s.element),s.meta&&this.deserialiseObject(s.meta,o.meta),s.attributes&&this.deserialiseObject(s.attributes,o.attributes);const i=this.deserialiseContent(s.content);return void 0===i&&null!==o.content||(o.content=i),o}serialiseContent(s){if(s instanceof this.namespace.elements.Element)return this.serialise(s);if(s instanceof this.namespace.KeyValuePair){const o={key:this.serialise(s.key)};return s.value&&(o.value=this.serialise(s.value)),o}if(s&&s.map){if(0===s.length)return;return s.map(this.serialise,this)}return s}deserialiseContent(s){if(s){if(s.element)return this.deserialise(s);if(s.key){const o=new this.namespace.KeyValuePair(this.deserialise(s.key));return s.value&&(o.value=this.deserialise(s.value)),o}if(s.map)return s.map(this.deserialise,this)}return s}serialiseObject(s){const o={};if(s.forEach(((s,i)=>{s&&(o[i.toValue()]=this.serialise(s))})),0!==Object.keys(o).length)return o}deserialiseObject(s,o){Object.keys(s).forEach((i=>{o.set(i,this.deserialise(s[i]))}))}}},76578(s){"use strict";s.exports=["Float16Array","Float32Array","Float64Array","Int8Array","Int16Array","Int32Array","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","BigInt64Array","BigUint64Array"]},65606(s){var o,i,a=s.exports={};function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}function runTimeout(s){if(o===setTimeout)return setTimeout(s,0);if((o===defaultSetTimout||!o)&&setTimeout)return o=setTimeout,setTimeout(s,0);try{return o(s,0)}catch(i){try{return o.call(null,s,0)}catch(i){return o.call(this,s,0)}}}!function(){try{o="function"==typeof setTimeout?setTimeout:defaultSetTimout}catch(s){o=defaultSetTimout}try{i="function"==typeof clearTimeout?clearTimeout:defaultClearTimeout}catch(s){i=defaultClearTimeout}}();var u,_=[],w=!1,x=-1;function cleanUpNextTick(){w&&u&&(w=!1,u.length?_=u.concat(_):x=-1,_.length&&drainQueue())}function drainQueue(){if(!w){var s=runTimeout(cleanUpNextTick);w=!0;for(var o=_.length;o;){for(u=_,_=[];++x<o;)u&&u[x].run();x=-1,o=_.length}u=null,w=!1,function runClearTimeout(s){if(i===clearTimeout)return clearTimeout(s);if((i===defaultClearTimeout||!i)&&clearTimeout)return i=clearTimeout,clearTimeout(s);try{return i(s)}catch(o){try{return i.call(null,s)}catch(o){return i.call(this,s)}}}(s)}}function Item(s,o){this.fun=s,this.array=o}function noop(){}a.nextTick=function(s){var o=new Array(arguments.length-1);if(arguments.length>1)for(var i=1;i<arguments.length;i++)o[i-1]=arguments[i];_.push(new Item(s,o)),1!==_.length||w||runTimeout(drainQueue)},Item.prototype.run=function(){this.fun.apply(null,this.array)},a.title="browser",a.browser=!0,a.env={},a.argv=[],a.version="",a.versions={},a.on=noop,a.addListener=noop,a.once=noop,a.off=noop,a.removeListener=noop,a.removeAllListeners=noop,a.emit=noop,a.prependListener=noop,a.prependOnceListener=noop,a.listeners=function(s){return[]},a.binding=function(s){throw new Error("process.binding is not supported")},a.cwd=function(){return"/"},a.chdir=function(s){throw new Error("process.chdir is not supported")},a.umask=function(){return 0}},2694(s,o,i){"use strict";var a=i(6925);function emptyFunction(){}function emptyFunctionWithReset(){}emptyFunctionWithReset.resetWarningCache=emptyFunction,s.exports=function(){function shim(s,o,i,u,_,w){if(w!==a){var x=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw x.name="Invariant Violation",x}}function getShim(){return shim}shim.isRequired=shim;var s={array:shim,bigint:shim,bool:shim,func:shim,number:shim,object:shim,string:shim,symbol:shim,any:shim,arrayOf:getShim,element:shim,elementType:shim,instanceOf:getShim,node:shim,objectOf:getShim,oneOf:getShim,oneOfType:getShim,shape:getShim,exact:getShim,checkPropTypes:emptyFunctionWithReset,resetWarningCache:emptyFunction};return s.PropTypes=s,s}},5556(s,o,i){s.exports=i(2694)()},6925(s){"use strict";s.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},73992(s,o){"use strict";var i=Object.prototype.hasOwnProperty;function decode(s){try{return decodeURIComponent(s.replace(/\+/g," "))}catch(s){return null}}function encode(s){try{return encodeURIComponent(s)}catch(s){return null}}o.stringify=function querystringify(s,o){o=o||"";var a,u,_=[];for(u in"string"!=typeof o&&(o="?"),s)if(i.call(s,u)){if((a=s[u])||null!=a&&!isNaN(a)||(a=""),u=encode(u),a=encode(a),null===u||null===a)continue;_.push(u+"="+a)}return _.length?o+_.join("&"):""},o.parse=function querystring(s){for(var o,i=/([^=?#&]+)=?([^&]*)/g,a={};o=i.exec(s);){var u=decode(o[1]),_=decode(o[2]);null===u||null===_||u in a||(a[u]=_)}return a}},41859(s,o,i){const a=i(27096),u=i(78004),_=a.types;s.exports=class RandExp{constructor(s,o){if(this._setDefaults(s),s instanceof RegExp)this.ignoreCase=s.ignoreCase,this.multiline=s.multiline,s=s.source;else{if("string"!=typeof s)throw new Error("Expected a regexp or string");this.ignoreCase=o&&-1!==o.indexOf("i"),this.multiline=o&&-1!==o.indexOf("m")}this.tokens=a(s)}_setDefaults(s){this.max=null!=s.max?s.max:null!=RandExp.prototype.max?RandExp.prototype.max:100,this.defaultRange=s.defaultRange?s.defaultRange:this.defaultRange.clone(),s.randInt&&(this.randInt=s.randInt)}gen(){return this._gen(this.tokens,[])}_gen(s,o){var i,a,u,w,x;switch(s.type){case _.ROOT:case _.GROUP:if(s.followedBy||s.notFollowedBy)return"";for(s.remember&&void 0===s.groupNumber&&(s.groupNumber=o.push(null)-1),a="",w=0,x=(i=s.options?this._randSelect(s.options):s.stack).length;w<x;w++)a+=this._gen(i[w],o);return s.remember&&(o[s.groupNumber]=a),a;case _.POSITION:return"";case _.SET:var C=this._expand(s);return C.length?String.fromCharCode(this._randSelect(C)):"";case _.REPETITION:for(u=this.randInt(s.min,s.max===1/0?s.min+this.max:s.max),a="",w=0;w<u;w++)a+=this._gen(s.value,o);return a;case _.REFERENCE:return o[s.value-1]||"";case _.CHAR:var j=this.ignoreCase&&this._randBool()?this._toOtherCase(s.value):s.value;return String.fromCharCode(j)}}_toOtherCase(s){return s+(97<=s&&s<=122?-32:65<=s&&s<=90?32:0)}_randBool(){return!this.randInt(0,1)}_randSelect(s){return s instanceof u?s.index(this.randInt(0,s.length-1)):s[this.randInt(0,s.length-1)]}_expand(s){if(s.type===a.types.CHAR)return new u(s.value);if(s.type===a.types.RANGE)return new u(s.from,s.to);{let o=new u;for(let i=0;i<s.set.length;i++){let a=this._expand(s.set[i]);if(o.add(a),this.ignoreCase)for(let s=0;s<a.length;s++){let i=a.index(s),u=this._toOtherCase(i);i!==u&&o.add(u)}}return s.not?this.defaultRange.clone().subtract(o):this.defaultRange.clone().intersect(o)}}randInt(s,o){return s+Math.floor(Math.random()*(1+o-s))}get defaultRange(){return this._range=this._range||new u(32,126)}set defaultRange(s){this._range=s}static randexp(s,o){var i;return"string"==typeof s&&(s=new RegExp(s,o)),void 0===s._randexp?(i=new RandExp(s,o),s._randexp=i):(i=s._randexp)._setDefaults(s),i.gen()}static sugar(){RegExp.prototype.gen=function(){return RandExp.randexp(this)}}}},53209(s,o,i){"use strict";var a=i(65606),u=65536,_=4294967295;var w=i(92861).Buffer,x=i.g.crypto||i.g.msCrypto;x&&x.getRandomValues?s.exports=function randomBytes(s,o){if(s>_)throw new RangeError("requested too many random bytes");var i=w.allocUnsafe(s);if(s>0)if(s>u)for(var C=0;C<s;C+=u)x.getRandomValues(i.slice(C,C+u));else x.getRandomValues(i);if("function"==typeof o)return a.nextTick((function(){o(null,i)}));return i}:s.exports=function oldBrowser(){throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11")}},25264(s,o,i){"use strict";function _typeof(s){return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(s){return typeof s}:function(s){return s&&"function"==typeof Symbol&&s.constructor===Symbol&&s!==Symbol.prototype?"symbol":typeof s},_typeof(s)}Object.defineProperty(o,"__esModule",{value:!0}),o.CopyToClipboard=void 0;var a=_interopRequireDefault(i(96540)),u=_interopRequireDefault(i(17965)),_=["text","onCopy","options","children"];function _interopRequireDefault(s){return s&&s.__esModule?s:{default:s}}function ownKeys(s,o){var i=Object.keys(s);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(s);o&&(a=a.filter((function(o){return Object.getOwnPropertyDescriptor(s,o).enumerable}))),i.push.apply(i,a)}return i}function _objectSpread(s){for(var o=1;o<arguments.length;o++){var i=null!=arguments[o]?arguments[o]:{};o%2?ownKeys(Object(i),!0).forEach((function(o){_defineProperty(s,o,i[o])})):Object.getOwnPropertyDescriptors?Object.defineProperties(s,Object.getOwnPropertyDescriptors(i)):ownKeys(Object(i)).forEach((function(o){Object.defineProperty(s,o,Object.getOwnPropertyDescriptor(i,o))}))}return s}function _objectWithoutProperties(s,o){if(null==s)return{};var i,a,u=function _objectWithoutPropertiesLoose(s,o){if(null==s)return{};var i,a,u={},_=Object.keys(s);for(a=0;a<_.length;a++)i=_[a],o.indexOf(i)>=0||(u[i]=s[i]);return u}(s,o);if(Object.getOwnPropertySymbols){var _=Object.getOwnPropertySymbols(s);for(a=0;a<_.length;a++)i=_[a],o.indexOf(i)>=0||Object.prototype.propertyIsEnumerable.call(s,i)&&(u[i]=s[i])}return u}function _defineProperties(s,o){for(var i=0;i<o.length;i++){var a=o[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(s,a.key,a)}}function _setPrototypeOf(s,o){return _setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(s,o){return s.__proto__=o,s},_setPrototypeOf(s,o)}function _createSuper(s){var o=function _isNativeReflectConstruct(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(s){return!1}}();return function _createSuperInternal(){var i,a=_getPrototypeOf(s);if(o){var u=_getPrototypeOf(this).constructor;i=Reflect.construct(a,arguments,u)}else i=a.apply(this,arguments);return function _possibleConstructorReturn(s,o){if(o&&("object"===_typeof(o)||"function"==typeof o))return o;if(void 0!==o)throw new TypeError("Derived constructors may only return object or undefined");return _assertThisInitialized(s)}(this,i)}}function _assertThisInitialized(s){if(void 0===s)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return s}function _getPrototypeOf(s){return _getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(s){return s.__proto__||Object.getPrototypeOf(s)},_getPrototypeOf(s)}function _defineProperty(s,o,i){return o in s?Object.defineProperty(s,o,{value:i,enumerable:!0,configurable:!0,writable:!0}):s[o]=i,s}var w=function(s){!function _inherits(s,o){if("function"!=typeof o&&null!==o)throw new TypeError("Super expression must either be null or a function");s.prototype=Object.create(o&&o.prototype,{constructor:{value:s,writable:!0,configurable:!0}}),Object.defineProperty(s,"prototype",{writable:!1}),o&&_setPrototypeOf(s,o)}(CopyToClipboard,s);var o=_createSuper(CopyToClipboard);function CopyToClipboard(){var s;!function _classCallCheck(s,o){if(!(s instanceof o))throw new TypeError("Cannot call a class as a function")}(this,CopyToClipboard);for(var i=arguments.length,_=new Array(i),w=0;w<i;w++)_[w]=arguments[w];return _defineProperty(_assertThisInitialized(s=o.call.apply(o,[this].concat(_))),"onClick",(function(o){var i=s.props,_=i.text,w=i.onCopy,x=i.children,C=i.options,j=a.default.Children.only(x),L=(0,u.default)(_,C);w&&w(_,L),j&&j.props&&"function"==typeof j.props.onClick&&j.props.onClick(o)})),s}return function _createClass(s,o,i){return o&&_defineProperties(s.prototype,o),i&&_defineProperties(s,i),Object.defineProperty(s,"prototype",{writable:!1}),s}(CopyToClipboard,[{key:"render",value:function render(){var s=this.props,o=(s.text,s.onCopy,s.options,s.children),i=_objectWithoutProperties(s,_),u=a.default.Children.only(o);return a.default.cloneElement(u,_objectSpread(_objectSpread({},i),{},{onClick:this.onClick}))}}]),CopyToClipboard}(a.default.PureComponent);o.CopyToClipboard=w,_defineProperty(w,"defaultProps",{onCopy:void 0,options:void 0})},59399(s,o,i){"use strict";var a=i(25264).CopyToClipboard;a.CopyToClipboard=a,s.exports=a},81214(s,o,i){"use strict";function _typeof(s){return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(s){return typeof s}:function(s){return s&&"function"==typeof Symbol&&s.constructor===Symbol&&s!==Symbol.prototype?"symbol":typeof s},_typeof(s)}Object.defineProperty(o,"__esModule",{value:!0}),o.DebounceInput=void 0;var a=_interopRequireDefault(i(96540)),u=_interopRequireDefault(i(20181)),_=["element","onChange","value","minLength","debounceTimeout","forceNotifyByEnter","forceNotifyOnBlur","onKeyDown","onBlur","inputRef"];function _interopRequireDefault(s){return s&&s.__esModule?s:{default:s}}function _objectWithoutProperties(s,o){if(null==s)return{};var i,a,u=function _objectWithoutPropertiesLoose(s,o){if(null==s)return{};var i,a,u={},_=Object.keys(s);for(a=0;a<_.length;a++)i=_[a],o.indexOf(i)>=0||(u[i]=s[i]);return u}(s,o);if(Object.getOwnPropertySymbols){var _=Object.getOwnPropertySymbols(s);for(a=0;a<_.length;a++)i=_[a],o.indexOf(i)>=0||Object.prototype.propertyIsEnumerable.call(s,i)&&(u[i]=s[i])}return u}function ownKeys(s,o){var i=Object.keys(s);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(s);o&&(a=a.filter((function(o){return Object.getOwnPropertyDescriptor(s,o).enumerable}))),i.push.apply(i,a)}return i}function _objectSpread(s){for(var o=1;o<arguments.length;o++){var i=null!=arguments[o]?arguments[o]:{};o%2?ownKeys(Object(i),!0).forEach((function(o){_defineProperty(s,o,i[o])})):Object.getOwnPropertyDescriptors?Object.defineProperties(s,Object.getOwnPropertyDescriptors(i)):ownKeys(Object(i)).forEach((function(o){Object.defineProperty(s,o,Object.getOwnPropertyDescriptor(i,o))}))}return s}function _defineProperties(s,o){for(var i=0;i<o.length;i++){var a=o[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(s,a.key,a)}}function _setPrototypeOf(s,o){return _setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(s,o){return s.__proto__=o,s},_setPrototypeOf(s,o)}function _createSuper(s){var o=function _isNativeReflectConstruct(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(s){return!1}}();return function _createSuperInternal(){var i,a=_getPrototypeOf(s);if(o){var u=_getPrototypeOf(this).constructor;i=Reflect.construct(a,arguments,u)}else i=a.apply(this,arguments);return function _possibleConstructorReturn(s,o){if(o&&("object"===_typeof(o)||"function"==typeof o))return o;if(void 0!==o)throw new TypeError("Derived constructors may only return object or undefined");return _assertThisInitialized(s)}(this,i)}}function _assertThisInitialized(s){if(void 0===s)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return s}function _getPrototypeOf(s){return _getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(s){return s.__proto__||Object.getPrototypeOf(s)},_getPrototypeOf(s)}function _defineProperty(s,o,i){return o in s?Object.defineProperty(s,o,{value:i,enumerable:!0,configurable:!0,writable:!0}):s[o]=i,s}var w=function(s){!function _inherits(s,o){if("function"!=typeof o&&null!==o)throw new TypeError("Super expression must either be null or a function");s.prototype=Object.create(o&&o.prototype,{constructor:{value:s,writable:!0,configurable:!0}}),Object.defineProperty(s,"prototype",{writable:!1}),o&&_setPrototypeOf(s,o)}(DebounceInput,s);var o=_createSuper(DebounceInput);function DebounceInput(s){var i;!function _classCallCheck(s,o){if(!(s instanceof o))throw new TypeError("Cannot call a class as a function")}(this,DebounceInput),_defineProperty(_assertThisInitialized(i=o.call(this,s)),"onChange",(function(s){s.persist();var o=i.state.value,a=i.props.minLength;i.setState({value:s.target.value},(function(){var u=i.state.value;u.length>=a?i.notify(s):o.length>u.length&&i.notify(_objectSpread(_objectSpread({},s),{},{target:_objectSpread(_objectSpread({},s.target),{},{value:""})}))}))})),_defineProperty(_assertThisInitialized(i),"onKeyDown",(function(s){"Enter"===s.key&&i.forceNotify(s);var o=i.props.onKeyDown;o&&(s.persist(),o(s))})),_defineProperty(_assertThisInitialized(i),"onBlur",(function(s){i.forceNotify(s);var o=i.props.onBlur;o&&(s.persist(),o(s))})),_defineProperty(_assertThisInitialized(i),"createNotifier",(function(s){if(s<0)i.notify=function(){return null};else if(0===s)i.notify=i.doNotify;else{var o=(0,u.default)((function(s){i.isDebouncing=!1,i.doNotify(s)}),s);i.notify=function(s){i.isDebouncing=!0,o(s)},i.flush=function(){return o.flush()},i.cancel=function(){i.isDebouncing=!1,o.cancel()}}})),_defineProperty(_assertThisInitialized(i),"doNotify",(function(){i.props.onChange.apply(void 0,arguments)})),_defineProperty(_assertThisInitialized(i),"forceNotify",(function(s){var o=i.props.debounceTimeout;if(i.isDebouncing||!(o>0)){i.cancel&&i.cancel();var a=i.state.value,u=i.props.minLength;a.length>=u?i.doNotify(s):i.doNotify(_objectSpread(_objectSpread({},s),{},{target:_objectSpread(_objectSpread({},s.target),{},{value:a})}))}})),i.isDebouncing=!1,i.state={value:void 0===s.value||null===s.value?"":s.value};var a=i.props.debounceTimeout;return i.createNotifier(a),i}return function _createClass(s,o,i){return o&&_defineProperties(s.prototype,o),i&&_defineProperties(s,i),Object.defineProperty(s,"prototype",{writable:!1}),s}(DebounceInput,[{key:"componentDidUpdate",value:function componentDidUpdate(s){if(!this.isDebouncing){var o=this.props,i=o.value,a=o.debounceTimeout,u=s.debounceTimeout,_=s.value,w=this.state.value;void 0!==i&&_!==i&&w!==i&&this.setState({value:i}),a!==u&&this.createNotifier(a)}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.flush&&this.flush()}},{key:"render",value:function render(){var s,o,i=this.props,u=i.element,w=(i.onChange,i.value,i.minLength,i.debounceTimeout,i.forceNotifyByEnter),x=i.forceNotifyOnBlur,C=i.onKeyDown,j=i.onBlur,L=i.inputRef,B=_objectWithoutProperties(i,_),$=this.state.value;s=w?{onKeyDown:this.onKeyDown}:C?{onKeyDown:C}:{},o=x?{onBlur:this.onBlur}:j?{onBlur:j}:{};var U=L?{ref:L}:{};return a.default.createElement(u,_objectSpread(_objectSpread(_objectSpread(_objectSpread({},B),{},{onChange:this.onChange,value:$},s),o),U))}}]),DebounceInput}(a.default.PureComponent);o.DebounceInput=w,_defineProperty(w,"defaultProps",{element:"input",type:"text",onKeyDown:void 0,onBlur:void 0,value:void 0,minLength:0,debounceTimeout:100,forceNotifyByEnter:!0,forceNotifyOnBlur:!0,inputRef:void 0})},24677(s,o,i){"use strict";var a=i(81214).DebounceInput;a.DebounceInput=a,s.exports=a},22551(s,o,i){"use strict";var a=i(96540),u=i(69982);function p(s){for(var o="https://reactjs.org/docs/error-decoder.html?invariant="+s,i=1;i<arguments.length;i++)o+="&args[]="+encodeURIComponent(arguments[i]);return"Minified React error #"+s+"; visit "+o+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var _=new Set,w={};function fa(s,o){ha(s,o),ha(s+"Capture",o)}function ha(s,o){for(w[s]=o,s=0;s<o.length;s++)_.add(o[s])}var x=!("undefined"==typeof window||void 0===window.document||void 0===window.document.createElement),C=Object.prototype.hasOwnProperty,j=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,L={},B={};function v(s,o,i,a,u,_,w){this.acceptsBooleans=2===o||3===o||4===o,this.attributeName=a,this.attributeNamespace=u,this.mustUseProperty=i,this.propertyName=s,this.type=o,this.sanitizeURL=_,this.removeEmptyString=w}var $={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach((function(s){$[s]=new v(s,0,!1,s,null,!1,!1)})),[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach((function(s){var o=s[0];$[o]=new v(o,1,!1,s[1],null,!1,!1)})),["contentEditable","draggable","spellCheck","value"].forEach((function(s){$[s]=new v(s,2,!1,s.toLowerCase(),null,!1,!1)})),["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach((function(s){$[s]=new v(s,2,!1,s,null,!1,!1)})),"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach((function(s){$[s]=new v(s,3,!1,s.toLowerCase(),null,!1,!1)})),["checked","multiple","muted","selected"].forEach((function(s){$[s]=new v(s,3,!0,s,null,!1,!1)})),["capture","download"].forEach((function(s){$[s]=new v(s,4,!1,s,null,!1,!1)})),["cols","rows","size","span"].forEach((function(s){$[s]=new v(s,6,!1,s,null,!1,!1)})),["rowSpan","start"].forEach((function(s){$[s]=new v(s,5,!1,s.toLowerCase(),null,!1,!1)}));var U=/[\-:]([a-z])/g;function sa(s){return s[1].toUpperCase()}function ta(s,o,i,a){var u=$.hasOwnProperty(o)?$[o]:null;(null!==u?0!==u.type:a||!(2<o.length)||"o"!==o[0]&&"O"!==o[0]||"n"!==o[1]&&"N"!==o[1])&&(function qa(s,o,i,a){if(null==o||function pa(s,o,i,a){if(null!==i&&0===i.type)return!1;switch(typeof o){case"function":case"symbol":return!0;case"boolean":return!a&&(null!==i?!i.acceptsBooleans:"data-"!==(s=s.toLowerCase().slice(0,5))&&"aria-"!==s);default:return!1}}(s,o,i,a))return!0;if(a)return!1;if(null!==i)switch(i.type){case 3:return!o;case 4:return!1===o;case 5:return isNaN(o);case 6:return isNaN(o)||1>o}return!1}(o,i,u,a)&&(i=null),a||null===u?function oa(s){return!!C.call(B,s)||!C.call(L,s)&&(j.test(s)?B[s]=!0:(L[s]=!0,!1))}(o)&&(null===i?s.removeAttribute(o):s.setAttribute(o,""+i)):u.mustUseProperty?s[u.propertyName]=null===i?3!==u.type&&"":i:(o=u.attributeName,a=u.attributeNamespace,null===i?s.removeAttribute(o):(i=3===(u=u.type)||4===u&&!0===i?"":""+i,a?s.setAttributeNS(a,o,i):s.setAttribute(o,i))))}"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach((function(s){var o=s.replace(U,sa);$[o]=new v(o,1,!1,s,null,!1,!1)})),"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach((function(s){var o=s.replace(U,sa);$[o]=new v(o,1,!1,s,"http://www.w3.org/1999/xlink",!1,!1)})),["xml:base","xml:lang","xml:space"].forEach((function(s){var o=s.replace(U,sa);$[o]=new v(o,1,!1,s,"http://www.w3.org/XML/1998/namespace",!1,!1)})),["tabIndex","crossOrigin"].forEach((function(s){$[s]=new v(s,1,!1,s.toLowerCase(),null,!1,!1)})),$.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1),["src","href","action","formAction"].forEach((function(s){$[s]=new v(s,1,!1,s.toLowerCase(),null,!0,!0)}));var V=a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,z=Symbol.for("react.element"),Y=Symbol.for("react.portal"),Z=Symbol.for("react.fragment"),ee=Symbol.for("react.strict_mode"),ie=Symbol.for("react.profiler"),ae=Symbol.for("react.provider"),ce=Symbol.for("react.context"),le=Symbol.for("react.forward_ref"),pe=Symbol.for("react.suspense"),de=Symbol.for("react.suspense_list"),fe=Symbol.for("react.memo"),ye=Symbol.for("react.lazy");Symbol.for("react.scope"),Symbol.for("react.debug_trace_mode");var be=Symbol.for("react.offscreen");Symbol.for("react.legacy_hidden"),Symbol.for("react.cache"),Symbol.for("react.tracing_marker");var Se=Symbol.iterator;function Ka(s){return null===s||"object"!=typeof s?null:"function"==typeof(s=Se&&s[Se]||s["@@iterator"])?s:null}var _e,we=Object.assign;function Ma(s){if(void 0===_e)try{throw Error()}catch(s){var o=s.stack.trim().match(/\n( *(at )?)/);_e=o&&o[1]||""}return"\n"+_e+s}var xe=!1;function Oa(s,o){if(!s||xe)return"";xe=!0;var i=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(o)if(o=function(){throw Error()},Object.defineProperty(o.prototype,"props",{set:function(){throw Error()}}),"object"==typeof Reflect&&Reflect.construct){try{Reflect.construct(o,[])}catch(s){var a=s}Reflect.construct(s,[],o)}else{try{o.call()}catch(s){a=s}s.call(o.prototype)}else{try{throw Error()}catch(s){a=s}s()}}catch(o){if(o&&a&&"string"==typeof o.stack){for(var u=o.stack.split("\n"),_=a.stack.split("\n"),w=u.length-1,x=_.length-1;1<=w&&0<=x&&u[w]!==_[x];)x--;for(;1<=w&&0<=x;w--,x--)if(u[w]!==_[x]){if(1!==w||1!==x)do{if(w--,0>--x||u[w]!==_[x]){var C="\n"+u[w].replace(" at new "," at ");return s.displayName&&C.includes("<anonymous>")&&(C=C.replace("<anonymous>",s.displayName)),C}}while(1<=w&&0<=x);break}}}finally{xe=!1,Error.prepareStackTrace=i}return(s=s?s.displayName||s.name:"")?Ma(s):""}function Pa(s){switch(s.tag){case 5:return Ma(s.type);case 16:return Ma("Lazy");case 13:return Ma("Suspense");case 19:return Ma("SuspenseList");case 0:case 2:case 15:return s=Oa(s.type,!1);case 11:return s=Oa(s.type.render,!1);case 1:return s=Oa(s.type,!0);default:return""}}function Qa(s){if(null==s)return null;if("function"==typeof s)return s.displayName||s.name||null;if("string"==typeof s)return s;switch(s){case Z:return"Fragment";case Y:return"Portal";case ie:return"Profiler";case ee:return"StrictMode";case pe:return"Suspense";case de:return"SuspenseList"}if("object"==typeof s)switch(s.$$typeof){case ce:return(s.displayName||"Context")+".Consumer";case ae:return(s._context.displayName||"Context")+".Provider";case le:var o=s.render;return(s=s.displayName)||(s=""!==(s=o.displayName||o.name||"")?"ForwardRef("+s+")":"ForwardRef"),s;case fe:return null!==(o=s.displayName||null)?o:Qa(s.type)||"Memo";case ye:o=s._payload,s=s._init;try{return Qa(s(o))}catch(s){}}return null}function Ra(s){var o=s.type;switch(s.tag){case 24:return"Cache";case 9:return(o.displayName||"Context")+".Consumer";case 10:return(o._context.displayName||"Context")+".Provider";case 18:return"DehydratedFragment";case 11:return s=(s=o.render).displayName||s.name||"",o.displayName||(""!==s?"ForwardRef("+s+")":"ForwardRef");case 7:return"Fragment";case 5:return o;case 4:return"Portal";case 3:return"Root";case 6:return"Text";case 16:return Qa(o);case 8:return o===ee?"StrictMode":"Mode";case 22:return"Offscreen";case 12:return"Profiler";case 21:return"Scope";case 13:return"Suspense";case 19:return"SuspenseList";case 25:return"TracingMarker";case 1:case 0:case 17:case 2:case 14:case 15:if("function"==typeof o)return o.displayName||o.name||null;if("string"==typeof o)return o}return null}function Sa(s){switch(typeof s){case"boolean":case"number":case"string":case"undefined":case"object":return s;default:return""}}function Ta(s){var o=s.type;return(s=s.nodeName)&&"input"===s.toLowerCase()&&("checkbox"===o||"radio"===o)}function Va(s){s._valueTracker||(s._valueTracker=function Ua(s){var o=Ta(s)?"checked":"value",i=Object.getOwnPropertyDescriptor(s.constructor.prototype,o),a=""+s[o];if(!s.hasOwnProperty(o)&&void 0!==i&&"function"==typeof i.get&&"function"==typeof i.set){var u=i.get,_=i.set;return Object.defineProperty(s,o,{configurable:!0,get:function(){return u.call(this)},set:function(s){a=""+s,_.call(this,s)}}),Object.defineProperty(s,o,{enumerable:i.enumerable}),{getValue:function(){return a},setValue:function(s){a=""+s},stopTracking:function(){s._valueTracker=null,delete s[o]}}}}(s))}function Wa(s){if(!s)return!1;var o=s._valueTracker;if(!o)return!0;var i=o.getValue(),a="";return s&&(a=Ta(s)?s.checked?"true":"false":s.value),(s=a)!==i&&(o.setValue(s),!0)}function Xa(s){if(void 0===(s=s||("undefined"!=typeof document?document:void 0)))return null;try{return s.activeElement||s.body}catch(o){return s.body}}function Ya(s,o){var i=o.checked;return we({},o,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=i?i:s._wrapperState.initialChecked})}function Za(s,o){var i=null==o.defaultValue?"":o.defaultValue,a=null!=o.checked?o.checked:o.defaultChecked;i=Sa(null!=o.value?o.value:i),s._wrapperState={initialChecked:a,initialValue:i,controlled:"checkbox"===o.type||"radio"===o.type?null!=o.checked:null!=o.value}}function ab(s,o){null!=(o=o.checked)&&ta(s,"checked",o,!1)}function bb(s,o){ab(s,o);var i=Sa(o.value),a=o.type;if(null!=i)"number"===a?(0===i&&""===s.value||s.value!=i)&&(s.value=""+i):s.value!==""+i&&(s.value=""+i);else if("submit"===a||"reset"===a)return void s.removeAttribute("value");o.hasOwnProperty("value")?cb(s,o.type,i):o.hasOwnProperty("defaultValue")&&cb(s,o.type,Sa(o.defaultValue)),null==o.checked&&null!=o.defaultChecked&&(s.defaultChecked=!!o.defaultChecked)}function db(s,o,i){if(o.hasOwnProperty("value")||o.hasOwnProperty("defaultValue")){var a=o.type;if(!("submit"!==a&&"reset"!==a||void 0!==o.value&&null!==o.value))return;o=""+s._wrapperState.initialValue,i||o===s.value||(s.value=o),s.defaultValue=o}""!==(i=s.name)&&(s.name=""),s.defaultChecked=!!s._wrapperState.initialChecked,""!==i&&(s.name=i)}function cb(s,o,i){"number"===o&&Xa(s.ownerDocument)===s||(null==i?s.defaultValue=""+s._wrapperState.initialValue:s.defaultValue!==""+i&&(s.defaultValue=""+i))}var Pe=Array.isArray;function fb(s,o,i,a){if(s=s.options,o){o={};for(var u=0;u<i.length;u++)o["$"+i[u]]=!0;for(i=0;i<s.length;i++)u=o.hasOwnProperty("$"+s[i].value),s[i].selected!==u&&(s[i].selected=u),u&&a&&(s[i].defaultSelected=!0)}else{for(i=""+Sa(i),o=null,u=0;u<s.length;u++){if(s[u].value===i)return s[u].selected=!0,void(a&&(s[u].defaultSelected=!0));null!==o||s[u].disabled||(o=s[u])}null!==o&&(o.selected=!0)}}function gb(s,o){if(null!=o.dangerouslySetInnerHTML)throw Error(p(91));return we({},o,{value:void 0,defaultValue:void 0,children:""+s._wrapperState.initialValue})}function hb(s,o){var i=o.value;if(null==i){if(i=o.children,o=o.defaultValue,null!=i){if(null!=o)throw Error(p(92));if(Pe(i)){if(1<i.length)throw Error(p(93));i=i[0]}o=i}null==o&&(o=""),i=o}s._wrapperState={initialValue:Sa(i)}}function ib(s,o){var i=Sa(o.value),a=Sa(o.defaultValue);null!=i&&((i=""+i)!==s.value&&(s.value=i),null==o.defaultValue&&s.defaultValue!==i&&(s.defaultValue=i)),null!=a&&(s.defaultValue=""+a)}function jb(s){var o=s.textContent;o===s._wrapperState.initialValue&&""!==o&&null!==o&&(s.value=o)}function kb(s){switch(s){case"svg":return"http://www.w3.org/2000/svg";case"math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function lb(s,o){return null==s||"http://www.w3.org/1999/xhtml"===s?kb(o):"http://www.w3.org/2000/svg"===s&&"foreignObject"===o?"http://www.w3.org/1999/xhtml":s}var Te,Re,$e=(Re=function(s,o){if("http://www.w3.org/2000/svg"!==s.namespaceURI||"innerHTML"in s)s.innerHTML=o;else{for((Te=Te||document.createElement("div")).innerHTML="<svg>"+o.valueOf().toString()+"</svg>",o=Te.firstChild;s.firstChild;)s.removeChild(s.firstChild);for(;o.firstChild;)s.appendChild(o.firstChild)}},"undefined"!=typeof MSApp&&MSApp.execUnsafeLocalFunction?function(s,o,i,a){MSApp.execUnsafeLocalFunction((function(){return Re(s,o)}))}:Re);function ob(s,o){if(o){var i=s.firstChild;if(i&&i===s.lastChild&&3===i.nodeType)return void(i.nodeValue=o)}s.textContent=o}var qe={animationIterationCount:!0,aspectRatio:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},ze=["Webkit","ms","Moz","O"];function rb(s,o,i){return null==o||"boolean"==typeof o||""===o?"":i||"number"!=typeof o||0===o||qe.hasOwnProperty(s)&&qe[s]?(""+o).trim():o+"px"}function sb(s,o){for(var i in s=s.style,o)if(o.hasOwnProperty(i)){var a=0===i.indexOf("--"),u=rb(i,o[i],a);"float"===i&&(i="cssFloat"),a?s.setProperty(i,u):s[i]=u}}Object.keys(qe).forEach((function(s){ze.forEach((function(o){o=o+s.charAt(0).toUpperCase()+s.substring(1),qe[o]=qe[s]}))}));var We=we({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});function ub(s,o){if(o){if(We[s]&&(null!=o.children||null!=o.dangerouslySetInnerHTML))throw Error(p(137,s));if(null!=o.dangerouslySetInnerHTML){if(null!=o.children)throw Error(p(60));if("object"!=typeof o.dangerouslySetInnerHTML||!("__html"in o.dangerouslySetInnerHTML))throw Error(p(61))}if(null!=o.style&&"object"!=typeof o.style)throw Error(p(62))}}function vb(s,o){if(-1===s.indexOf("-"))return"string"==typeof o.is;switch(s){case"annotation-xml":case"color-profile":case"font-face":case"font-face-src":case"font-face-uri":case"font-face-format":case"font-face-name":case"missing-glyph":return!1;default:return!0}}var He=null;function xb(s){return(s=s.target||s.srcElement||window).correspondingUseElement&&(s=s.correspondingUseElement),3===s.nodeType?s.parentNode:s}var Ye=null,Xe=null,Qe=null;function Bb(s){if(s=Cb(s)){if("function"!=typeof Ye)throw Error(p(280));var o=s.stateNode;o&&(o=Db(o),Ye(s.stateNode,s.type,o))}}function Eb(s){Xe?Qe?Qe.push(s):Qe=[s]:Xe=s}function Fb(){if(Xe){var s=Xe,o=Qe;if(Qe=Xe=null,Bb(s),o)for(s=0;s<o.length;s++)Bb(o[s])}}function Gb(s,o){return s(o)}function Hb(){}var et=!1;function Jb(s,o,i){if(et)return s(o,i);et=!0;try{return Gb(s,o,i)}finally{et=!1,(null!==Xe||null!==Qe)&&(Hb(),Fb())}}function Kb(s,o){var i=s.stateNode;if(null===i)return null;var a=Db(i);if(null===a)return null;i=a[o];e:switch(o){case"onClick":case"onClickCapture":case"onDoubleClick":case"onDoubleClickCapture":case"onMouseDown":case"onMouseDownCapture":case"onMouseMove":case"onMouseMoveCapture":case"onMouseUp":case"onMouseUpCapture":case"onMouseEnter":(a=!a.disabled)||(a=!("button"===(s=s.type)||"input"===s||"select"===s||"textarea"===s)),s=!a;break e;default:s=!1}if(s)return null;if(i&&"function"!=typeof i)throw Error(p(231,o,typeof i));return i}var tt=!1;if(x)try{var rt={};Object.defineProperty(rt,"passive",{get:function(){tt=!0}}),window.addEventListener("test",rt,rt),window.removeEventListener("test",rt,rt)}catch(Re){tt=!1}function Nb(s,o,i,a,u,_,w,x,C){var j=Array.prototype.slice.call(arguments,3);try{o.apply(i,j)}catch(s){this.onError(s)}}var nt=!1,st=null,ot=!1,it=null,at={onError:function(s){nt=!0,st=s}};function Tb(s,o,i,a,u,_,w,x,C){nt=!1,st=null,Nb.apply(at,arguments)}function Vb(s){var o=s,i=s;if(s.alternate)for(;o.return;)o=o.return;else{s=o;do{!!(4098&(o=s).flags)&&(i=o.return),s=o.return}while(s)}return 3===o.tag?i:null}function Wb(s){if(13===s.tag){var o=s.memoizedState;if(null===o&&(null!==(s=s.alternate)&&(o=s.memoizedState)),null!==o)return o.dehydrated}return null}function Xb(s){if(Vb(s)!==s)throw Error(p(188))}function Zb(s){return null!==(s=function Yb(s){var o=s.alternate;if(!o){if(null===(o=Vb(s)))throw Error(p(188));return o!==s?null:s}for(var i=s,a=o;;){var u=i.return;if(null===u)break;var _=u.alternate;if(null===_){if(null!==(a=u.return)){i=a;continue}break}if(u.child===_.child){for(_=u.child;_;){if(_===i)return Xb(u),s;if(_===a)return Xb(u),o;_=_.sibling}throw Error(p(188))}if(i.return!==a.return)i=u,a=_;else{for(var w=!1,x=u.child;x;){if(x===i){w=!0,i=u,a=_;break}if(x===a){w=!0,a=u,i=_;break}x=x.sibling}if(!w){for(x=_.child;x;){if(x===i){w=!0,i=_,a=u;break}if(x===a){w=!0,a=_,i=u;break}x=x.sibling}if(!w)throw Error(p(189))}}if(i.alternate!==a)throw Error(p(190))}if(3!==i.tag)throw Error(p(188));return i.stateNode.current===i?s:o}(s))?$b(s):null}function $b(s){if(5===s.tag||6===s.tag)return s;for(s=s.child;null!==s;){var o=$b(s);if(null!==o)return o;s=s.sibling}return null}var ct=u.unstable_scheduleCallback,lt=u.unstable_cancelCallback,ut=u.unstable_shouldYield,pt=u.unstable_requestPaint,ht=u.unstable_now,dt=u.unstable_getCurrentPriorityLevel,mt=u.unstable_ImmediatePriority,gt=u.unstable_UserBlockingPriority,yt=u.unstable_NormalPriority,vt=u.unstable_LowPriority,bt=u.unstable_IdlePriority,St=null,_t=null;var Et=Math.clz32?Math.clz32:function nc(s){return s>>>=0,0===s?32:31-(wt(s)/xt|0)|0},wt=Math.log,xt=Math.LN2;var kt=64,Ot=4194304;function tc(s){switch(s&-s){case 1:return 1;case 2:return 2;case 4:return 4;case 8:return 8;case 16:return 16;case 32:return 32;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return 4194240&s;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return 130023424&s;case 134217728:return 134217728;case 268435456:return 268435456;case 536870912:return 536870912;case 1073741824:return 1073741824;default:return s}}function uc(s,o){var i=s.pendingLanes;if(0===i)return 0;var a=0,u=s.suspendedLanes,_=s.pingedLanes,w=268435455&i;if(0!==w){var x=w&~u;0!==x?a=tc(x):0!==(_&=w)&&(a=tc(_))}else 0!==(w=i&~u)?a=tc(w):0!==_&&(a=tc(_));if(0===a)return 0;if(0!==o&&o!==a&&!(o&u)&&((u=a&-a)>=(_=o&-o)||16===u&&4194240&_))return o;if(4&a&&(a|=16&i),0!==(o=s.entangledLanes))for(s=s.entanglements,o&=a;0<o;)u=1<<(i=31-Et(o)),a|=s[i],o&=~u;return a}function vc(s,o){switch(s){case 1:case 2:case 4:return o+250;case 8:case 16:case 32:case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return o+5e3;default:return-1}}function xc(s){return 0!==(s=-1073741825&s.pendingLanes)?s:1073741824&s?1073741824:0}function yc(){var s=kt;return!(4194240&(kt<<=1))&&(kt=64),s}function zc(s){for(var o=[],i=0;31>i;i++)o.push(s);return o}function Ac(s,o,i){s.pendingLanes|=o,536870912!==o&&(s.suspendedLanes=0,s.pingedLanes=0),(s=s.eventTimes)[o=31-Et(o)]=i}function Cc(s,o){var i=s.entangledLanes|=o;for(s=s.entanglements;i;){var a=31-Et(i),u=1<<a;u&o|s[a]&o&&(s[a]|=o),i&=~u}}var At=0;function Dc(s){return 1<(s&=-s)?4<s?268435455&s?16:536870912:4:1}var Ct,jt,Pt,It,Tt,Nt=!1,Mt=[],Rt=null,Dt=null,Lt=null,Ft=new Map,Bt=new Map,$t=[],qt="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");function Sc(s,o){switch(s){case"focusin":case"focusout":Rt=null;break;case"dragenter":case"dragleave":Dt=null;break;case"mouseover":case"mouseout":Lt=null;break;case"pointerover":case"pointerout":Ft.delete(o.pointerId);break;case"gotpointercapture":case"lostpointercapture":Bt.delete(o.pointerId)}}function Tc(s,o,i,a,u,_){return null===s||s.nativeEvent!==_?(s={blockedOn:o,domEventName:i,eventSystemFlags:a,nativeEvent:_,targetContainers:[u]},null!==o&&(null!==(o=Cb(o))&&jt(o)),s):(s.eventSystemFlags|=a,o=s.targetContainers,null!==u&&-1===o.indexOf(u)&&o.push(u),s)}function Vc(s){var o=Wc(s.target);if(null!==o){var i=Vb(o);if(null!==i)if(13===(o=i.tag)){if(null!==(o=Wb(i)))return s.blockedOn=o,void Tt(s.priority,(function(){Pt(i)}))}else if(3===o&&i.stateNode.current.memoizedState.isDehydrated)return void(s.blockedOn=3===i.tag?i.stateNode.containerInfo:null)}s.blockedOn=null}function Xc(s){if(null!==s.blockedOn)return!1;for(var o=s.targetContainers;0<o.length;){var i=Yc(s.domEventName,s.eventSystemFlags,o[0],s.nativeEvent);if(null!==i)return null!==(o=Cb(i))&&jt(o),s.blockedOn=i,!1;var a=new(i=s.nativeEvent).constructor(i.type,i);He=a,i.target.dispatchEvent(a),He=null,o.shift()}return!0}function Zc(s,o,i){Xc(s)&&i.delete(o)}function $c(){Nt=!1,null!==Rt&&Xc(Rt)&&(Rt=null),null!==Dt&&Xc(Dt)&&(Dt=null),null!==Lt&&Xc(Lt)&&(Lt=null),Ft.forEach(Zc),Bt.forEach(Zc)}function ad(s,o){s.blockedOn===o&&(s.blockedOn=null,Nt||(Nt=!0,u.unstable_scheduleCallback(u.unstable_NormalPriority,$c)))}function bd(s){function b(o){return ad(o,s)}if(0<Mt.length){ad(Mt[0],s);for(var o=1;o<Mt.length;o++){var i=Mt[o];i.blockedOn===s&&(i.blockedOn=null)}}for(null!==Rt&&ad(Rt,s),null!==Dt&&ad(Dt,s),null!==Lt&&ad(Lt,s),Ft.forEach(b),Bt.forEach(b),o=0;o<$t.length;o++)(i=$t[o]).blockedOn===s&&(i.blockedOn=null);for(;0<$t.length&&null===(o=$t[0]).blockedOn;)Vc(o),null===o.blockedOn&&$t.shift()}var Ut=V.ReactCurrentBatchConfig,Vt=!0;function ed(s,o,i,a){var u=At,_=Ut.transition;Ut.transition=null;try{At=1,fd(s,o,i,a)}finally{At=u,Ut.transition=_}}function gd(s,o,i,a){var u=At,_=Ut.transition;Ut.transition=null;try{At=4,fd(s,o,i,a)}finally{At=u,Ut.transition=_}}function fd(s,o,i,a){if(Vt){var u=Yc(s,o,i,a);if(null===u)hd(s,o,a,zt,i),Sc(s,a);else if(function Uc(s,o,i,a,u){switch(o){case"focusin":return Rt=Tc(Rt,s,o,i,a,u),!0;case"dragenter":return Dt=Tc(Dt,s,o,i,a,u),!0;case"mouseover":return Lt=Tc(Lt,s,o,i,a,u),!0;case"pointerover":var _=u.pointerId;return Ft.set(_,Tc(Ft.get(_)||null,s,o,i,a,u)),!0;case"gotpointercapture":return _=u.pointerId,Bt.set(_,Tc(Bt.get(_)||null,s,o,i,a,u)),!0}return!1}(u,s,o,i,a))a.stopPropagation();else if(Sc(s,a),4&o&&-1<qt.indexOf(s)){for(;null!==u;){var _=Cb(u);if(null!==_&&Ct(_),null===(_=Yc(s,o,i,a))&&hd(s,o,a,zt,i),_===u)break;u=_}null!==u&&a.stopPropagation()}else hd(s,o,a,null,i)}}var zt=null;function Yc(s,o,i,a){if(zt=null,null!==(s=Wc(s=xb(a))))if(null===(o=Vb(s)))s=null;else if(13===(i=o.tag)){if(null!==(s=Wb(o)))return s;s=null}else if(3===i){if(o.stateNode.current.memoizedState.isDehydrated)return 3===o.tag?o.stateNode.containerInfo:null;s=null}else o!==s&&(s=null);return zt=s,null}function jd(s){switch(s){case"cancel":case"click":case"close":case"contextmenu":case"copy":case"cut":case"auxclick":case"dblclick":case"dragend":case"dragstart":case"drop":case"focusin":case"focusout":case"input":case"invalid":case"keydown":case"keypress":case"keyup":case"mousedown":case"mouseup":case"paste":case"pause":case"play":case"pointercancel":case"pointerdown":case"pointerup":case"ratechange":case"reset":case"resize":case"seeked":case"submit":case"touchcancel":case"touchend":case"touchstart":case"volumechange":case"change":case"selectionchange":case"textInput":case"compositionstart":case"compositionend":case"compositionupdate":case"beforeblur":case"afterblur":case"beforeinput":case"blur":case"fullscreenchange":case"focus":case"hashchange":case"popstate":case"select":case"selectstart":return 1;case"drag":case"dragenter":case"dragexit":case"dragleave":case"dragover":case"mousemove":case"mouseout":case"mouseover":case"pointermove":case"pointerout":case"pointerover":case"scroll":case"toggle":case"touchmove":case"wheel":case"mouseenter":case"mouseleave":case"pointerenter":case"pointerleave":return 4;case"message":switch(dt()){case mt:return 1;case gt:return 4;case yt:case vt:return 16;case bt:return 536870912;default:return 16}default:return 16}}var Wt=null,Jt=null,Ht=null;function nd(){if(Ht)return Ht;var s,o,i=Jt,a=i.length,u="value"in Wt?Wt.value:Wt.textContent,_=u.length;for(s=0;s<a&&i[s]===u[s];s++);var w=a-s;for(o=1;o<=w&&i[a-o]===u[_-o];o++);return Ht=u.slice(s,1<o?1-o:void 0)}function od(s){var o=s.keyCode;return"charCode"in s?0===(s=s.charCode)&&13===o&&(s=13):s=o,10===s&&(s=13),32<=s||13===s?s:0}function pd(){return!0}function qd(){return!1}function rd(s){function b(o,i,a,u,_){for(var w in this._reactName=o,this._targetInst=a,this.type=i,this.nativeEvent=u,this.target=_,this.currentTarget=null,s)s.hasOwnProperty(w)&&(o=s[w],this[w]=o?o(u):u[w]);return this.isDefaultPrevented=(null!=u.defaultPrevented?u.defaultPrevented:!1===u.returnValue)?pd:qd,this.isPropagationStopped=qd,this}return we(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var s=this.nativeEvent;s&&(s.preventDefault?s.preventDefault():"unknown"!=typeof s.returnValue&&(s.returnValue=!1),this.isDefaultPrevented=pd)},stopPropagation:function(){var s=this.nativeEvent;s&&(s.stopPropagation?s.stopPropagation():"unknown"!=typeof s.cancelBubble&&(s.cancelBubble=!0),this.isPropagationStopped=pd)},persist:function(){},isPersistent:pd}),b}var Kt,Gt,Yt,Xt={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(s){return s.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},Qt=rd(Xt),Zt=we({},Xt,{view:0,detail:0}),er=rd(Zt),tr=we({},Zt,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:zd,button:0,buttons:0,relatedTarget:function(s){return void 0===s.relatedTarget?s.fromElement===s.srcElement?s.toElement:s.fromElement:s.relatedTarget},movementX:function(s){return"movementX"in s?s.movementX:(s!==Yt&&(Yt&&"mousemove"===s.type?(Kt=s.screenX-Yt.screenX,Gt=s.screenY-Yt.screenY):Gt=Kt=0,Yt=s),Kt)},movementY:function(s){return"movementY"in s?s.movementY:Gt}}),rr=rd(tr),nr=rd(we({},tr,{dataTransfer:0})),sr=rd(we({},Zt,{relatedTarget:0})),ir=rd(we({},Xt,{animationName:0,elapsedTime:0,pseudoElement:0})),ar=we({},Xt,{clipboardData:function(s){return"clipboardData"in s?s.clipboardData:window.clipboardData}}),cr=rd(ar),lr=rd(we({},Xt,{data:0})),ur={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},pr={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},dr={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pd(s){var o=this.nativeEvent;return o.getModifierState?o.getModifierState(s):!!(s=dr[s])&&!!o[s]}function zd(){return Pd}var fr=we({},Zt,{key:function(s){if(s.key){var o=ur[s.key]||s.key;if("Unidentified"!==o)return o}return"keypress"===s.type?13===(s=od(s))?"Enter":String.fromCharCode(s):"keydown"===s.type||"keyup"===s.type?pr[s.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:zd,charCode:function(s){return"keypress"===s.type?od(s):0},keyCode:function(s){return"keydown"===s.type||"keyup"===s.type?s.keyCode:0},which:function(s){return"keypress"===s.type?od(s):"keydown"===s.type||"keyup"===s.type?s.keyCode:0}}),mr=rd(fr),gr=rd(we({},tr,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0})),yr=rd(we({},Zt,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:zd})),vr=rd(we({},Xt,{propertyName:0,elapsedTime:0,pseudoElement:0})),br=we({},tr,{deltaX:function(s){return"deltaX"in s?s.deltaX:"wheelDeltaX"in s?-s.wheelDeltaX:0},deltaY:function(s){return"deltaY"in s?s.deltaY:"wheelDeltaY"in s?-s.wheelDeltaY:"wheelDelta"in s?-s.wheelDelta:0},deltaZ:0,deltaMode:0}),Sr=rd(br),_r=[9,13,27,32],Er=x&&"CompositionEvent"in window,wr=null;x&&"documentMode"in document&&(wr=document.documentMode);var xr=x&&"TextEvent"in window&&!wr,kr=x&&(!Er||wr&&8<wr&&11>=wr),Or=String.fromCharCode(32),Ar=!1;function ge(s,o){switch(s){case"keyup":return-1!==_r.indexOf(o.keyCode);case"keydown":return 229!==o.keyCode;case"keypress":case"mousedown":case"focusout":return!0;default:return!1}}function he(s){return"object"==typeof(s=s.detail)&&"data"in s?s.data:null}var Cr=!1;var jr={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function me(s){var o=s&&s.nodeName&&s.nodeName.toLowerCase();return"input"===o?!!jr[s.type]:"textarea"===o}function ne(s,o,i,a){Eb(a),0<(o=oe(o,"onChange")).length&&(i=new Qt("onChange","change",null,i,a),s.push({event:i,listeners:o}))}var Pr=null,Ir=null;function re(s){se(s,0)}function te(s){if(Wa(ue(s)))return s}function ve(s,o){if("change"===s)return o}var Tr=!1;if(x){var Nr;if(x){var Mr="oninput"in document;if(!Mr){var Rr=document.createElement("div");Rr.setAttribute("oninput","return;"),Mr="function"==typeof Rr.oninput}Nr=Mr}else Nr=!1;Tr=Nr&&(!document.documentMode||9<document.documentMode)}function Ae(){Pr&&(Pr.detachEvent("onpropertychange",Be),Ir=Pr=null)}function Be(s){if("value"===s.propertyName&&te(Ir)){var o=[];ne(o,Ir,s,xb(s)),Jb(re,o)}}function Ce(s,o,i){"focusin"===s?(Ae(),Ir=i,(Pr=o).attachEvent("onpropertychange",Be)):"focusout"===s&&Ae()}function De(s){if("selectionchange"===s||"keyup"===s||"keydown"===s)return te(Ir)}function Ee(s,o){if("click"===s)return te(o)}function Fe(s,o){if("input"===s||"change"===s)return te(o)}var Dr="function"==typeof Object.is?Object.is:function Ge(s,o){return s===o&&(0!==s||1/s==1/o)||s!=s&&o!=o};function Ie(s,o){if(Dr(s,o))return!0;if("object"!=typeof s||null===s||"object"!=typeof o||null===o)return!1;var i=Object.keys(s),a=Object.keys(o);if(i.length!==a.length)return!1;for(a=0;a<i.length;a++){var u=i[a];if(!C.call(o,u)||!Dr(s[u],o[u]))return!1}return!0}function Je(s){for(;s&&s.firstChild;)s=s.firstChild;return s}function Ke(s,o){var i,a=Je(s);for(s=0;a;){if(3===a.nodeType){if(i=s+a.textContent.length,s<=o&&i>=o)return{node:a,offset:o-s};s=i}e:{for(;a;){if(a.nextSibling){a=a.nextSibling;break e}a=a.parentNode}a=void 0}a=Je(a)}}function Le(s,o){return!(!s||!o)&&(s===o||(!s||3!==s.nodeType)&&(o&&3===o.nodeType?Le(s,o.parentNode):"contains"in s?s.contains(o):!!s.compareDocumentPosition&&!!(16&s.compareDocumentPosition(o))))}function Me(){for(var s=window,o=Xa();o instanceof s.HTMLIFrameElement;){try{var i="string"==typeof o.contentWindow.location.href}catch(s){i=!1}if(!i)break;o=Xa((s=o.contentWindow).document)}return o}function Ne(s){var o=s&&s.nodeName&&s.nodeName.toLowerCase();return o&&("input"===o&&("text"===s.type||"search"===s.type||"tel"===s.type||"url"===s.type||"password"===s.type)||"textarea"===o||"true"===s.contentEditable)}function Oe(s){var o=Me(),i=s.focusedElem,a=s.selectionRange;if(o!==i&&i&&i.ownerDocument&&Le(i.ownerDocument.documentElement,i)){if(null!==a&&Ne(i))if(o=a.start,void 0===(s=a.end)&&(s=o),"selectionStart"in i)i.selectionStart=o,i.selectionEnd=Math.min(s,i.value.length);else if((s=(o=i.ownerDocument||document)&&o.defaultView||window).getSelection){s=s.getSelection();var u=i.textContent.length,_=Math.min(a.start,u);a=void 0===a.end?_:Math.min(a.end,u),!s.extend&&_>a&&(u=a,a=_,_=u),u=Ke(i,_);var w=Ke(i,a);u&&w&&(1!==s.rangeCount||s.anchorNode!==u.node||s.anchorOffset!==u.offset||s.focusNode!==w.node||s.focusOffset!==w.offset)&&((o=o.createRange()).setStart(u.node,u.offset),s.removeAllRanges(),_>a?(s.addRange(o),s.extend(w.node,w.offset)):(o.setEnd(w.node,w.offset),s.addRange(o)))}for(o=[],s=i;s=s.parentNode;)1===s.nodeType&&o.push({element:s,left:s.scrollLeft,top:s.scrollTop});for("function"==typeof i.focus&&i.focus(),i=0;i<o.length;i++)(s=o[i]).element.scrollLeft=s.left,s.element.scrollTop=s.top}}var Lr=x&&"documentMode"in document&&11>=document.documentMode,Fr=null,Br=null,$r=null,qr=!1;function Ue(s,o,i){var a=i.window===i?i.document:9===i.nodeType?i:i.ownerDocument;qr||null==Fr||Fr!==Xa(a)||("selectionStart"in(a=Fr)&&Ne(a)?a={start:a.selectionStart,end:a.selectionEnd}:a={anchorNode:(a=(a.ownerDocument&&a.ownerDocument.defaultView||window).getSelection()).anchorNode,anchorOffset:a.anchorOffset,focusNode:a.focusNode,focusOffset:a.focusOffset},$r&&Ie($r,a)||($r=a,0<(a=oe(Br,"onSelect")).length&&(o=new Qt("onSelect","select",null,o,i),s.push({event:o,listeners:a}),o.target=Fr)))}function Ve(s,o){var i={};return i[s.toLowerCase()]=o.toLowerCase(),i["Webkit"+s]="webkit"+o,i["Moz"+s]="moz"+o,i}var Ur={animationend:Ve("Animation","AnimationEnd"),animationiteration:Ve("Animation","AnimationIteration"),animationstart:Ve("Animation","AnimationStart"),transitionend:Ve("Transition","TransitionEnd")},Vr={},zr={};function Ze(s){if(Vr[s])return Vr[s];if(!Ur[s])return s;var o,i=Ur[s];for(o in i)if(i.hasOwnProperty(o)&&o in zr)return Vr[s]=i[o];return s}x&&(zr=document.createElement("div").style,"AnimationEvent"in window||(delete Ur.animationend.animation,delete Ur.animationiteration.animation,delete Ur.animationstart.animation),"TransitionEvent"in window||delete Ur.transitionend.transition);var Wr=Ze("animationend"),Jr=Ze("animationiteration"),Hr=Ze("animationstart"),Kr=Ze("transitionend"),Gr=new Map,Yr="abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");function ff(s,o){Gr.set(s,o),fa(o,[s])}for(var Xr=0;Xr<Yr.length;Xr++){var Qr=Yr[Xr];ff(Qr.toLowerCase(),"on"+(Qr[0].toUpperCase()+Qr.slice(1)))}ff(Wr,"onAnimationEnd"),ff(Jr,"onAnimationIteration"),ff(Hr,"onAnimationStart"),ff("dblclick","onDoubleClick"),ff("focusin","onFocus"),ff("focusout","onBlur"),ff(Kr,"onTransitionEnd"),ha("onMouseEnter",["mouseout","mouseover"]),ha("onMouseLeave",["mouseout","mouseover"]),ha("onPointerEnter",["pointerout","pointerover"]),ha("onPointerLeave",["pointerout","pointerover"]),fa("onChange","change click focusin focusout input keydown keyup selectionchange".split(" ")),fa("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")),fa("onBeforeInput",["compositionend","keypress","textInput","paste"]),fa("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" ")),fa("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" ")),fa("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var Zr="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),en=new Set("cancel close invalid load scroll toggle".split(" ").concat(Zr));function nf(s,o,i){var a=s.type||"unknown-event";s.currentTarget=i,function Ub(s,o,i,a,u,_,w,x,C){if(Tb.apply(this,arguments),nt){if(!nt)throw Error(p(198));var j=st;nt=!1,st=null,ot||(ot=!0,it=j)}}(a,o,void 0,s),s.currentTarget=null}function se(s,o){o=!!(4&o);for(var i=0;i<s.length;i++){var a=s[i],u=a.event;a=a.listeners;e:{var _=void 0;if(o)for(var w=a.length-1;0<=w;w--){var x=a[w],C=x.instance,j=x.currentTarget;if(x=x.listener,C!==_&&u.isPropagationStopped())break e;nf(u,x,j),_=C}else for(w=0;w<a.length;w++){if(C=(x=a[w]).instance,j=x.currentTarget,x=x.listener,C!==_&&u.isPropagationStopped())break e;nf(u,x,j),_=C}}}if(ot)throw s=it,ot=!1,it=null,s}function D(s,o){var i=o[mn];void 0===i&&(i=o[mn]=new Set);var a=s+"__bubble";i.has(a)||(pf(o,s,2,!1),i.add(a))}function qf(s,o,i){var a=0;o&&(a|=4),pf(i,s,a,o)}var tn="_reactListening"+Math.random().toString(36).slice(2);function sf(s){if(!s[tn]){s[tn]=!0,_.forEach((function(o){"selectionchange"!==o&&(en.has(o)||qf(o,!1,s),qf(o,!0,s))}));var o=9===s.nodeType?s:s.ownerDocument;null===o||o[tn]||(o[tn]=!0,qf("selectionchange",!1,o))}}function pf(s,o,i,a){switch(jd(o)){case 1:var u=ed;break;case 4:u=gd;break;default:u=fd}i=u.bind(null,o,i,s),u=void 0,!tt||"touchstart"!==o&&"touchmove"!==o&&"wheel"!==o||(u=!0),a?void 0!==u?s.addEventListener(o,i,{capture:!0,passive:u}):s.addEventListener(o,i,!0):void 0!==u?s.addEventListener(o,i,{passive:u}):s.addEventListener(o,i,!1)}function hd(s,o,i,a,u){var _=a;if(!(1&o||2&o||null===a))e:for(;;){if(null===a)return;var w=a.tag;if(3===w||4===w){var x=a.stateNode.containerInfo;if(x===u||8===x.nodeType&&x.parentNode===u)break;if(4===w)for(w=a.return;null!==w;){var C=w.tag;if((3===C||4===C)&&((C=w.stateNode.containerInfo)===u||8===C.nodeType&&C.parentNode===u))return;w=w.return}for(;null!==x;){if(null===(w=Wc(x)))return;if(5===(C=w.tag)||6===C){a=_=w;continue e}x=x.parentNode}}a=a.return}Jb((function(){var a=_,u=xb(i),w=[];e:{var x=Gr.get(s);if(void 0!==x){var C=Qt,j=s;switch(s){case"keypress":if(0===od(i))break e;case"keydown":case"keyup":C=mr;break;case"focusin":j="focus",C=sr;break;case"focusout":j="blur",C=sr;break;case"beforeblur":case"afterblur":C=sr;break;case"click":if(2===i.button)break e;case"auxclick":case"dblclick":case"mousedown":case"mousemove":case"mouseup":case"mouseout":case"mouseover":case"contextmenu":C=rr;break;case"drag":case"dragend":case"dragenter":case"dragexit":case"dragleave":case"dragover":case"dragstart":case"drop":C=nr;break;case"touchcancel":case"touchend":case"touchmove":case"touchstart":C=yr;break;case Wr:case Jr:case Hr:C=ir;break;case Kr:C=vr;break;case"scroll":C=er;break;case"wheel":C=Sr;break;case"copy":case"cut":case"paste":C=cr;break;case"gotpointercapture":case"lostpointercapture":case"pointercancel":case"pointerdown":case"pointermove":case"pointerout":case"pointerover":case"pointerup":C=gr}var L=!!(4&o),B=!L&&"scroll"===s,$=L?null!==x?x+"Capture":null:x;L=[];for(var U,V=a;null!==V;){var z=(U=V).stateNode;if(5===U.tag&&null!==z&&(U=z,null!==$&&(null!=(z=Kb(V,$))&&L.push(tf(V,z,U)))),B)break;V=V.return}0<L.length&&(x=new C(x,j,null,i,u),w.push({event:x,listeners:L}))}}if(!(7&o)){if(C="mouseout"===s||"pointerout"===s,(!(x="mouseover"===s||"pointerover"===s)||i===He||!(j=i.relatedTarget||i.fromElement)||!Wc(j)&&!j[fn])&&(C||x)&&(x=u.window===u?u:(x=u.ownerDocument)?x.defaultView||x.parentWindow:window,C?(C=a,null!==(j=(j=i.relatedTarget||i.toElement)?Wc(j):null)&&(j!==(B=Vb(j))||5!==j.tag&&6!==j.tag)&&(j=null)):(C=null,j=a),C!==j)){if(L=rr,z="onMouseLeave",$="onMouseEnter",V="mouse","pointerout"!==s&&"pointerover"!==s||(L=gr,z="onPointerLeave",$="onPointerEnter",V="pointer"),B=null==C?x:ue(C),U=null==j?x:ue(j),(x=new L(z,V+"leave",C,i,u)).target=B,x.relatedTarget=U,z=null,Wc(u)===a&&((L=new L($,V+"enter",j,i,u)).target=U,L.relatedTarget=B,z=L),B=z,C&&j)e:{for($=j,V=0,U=L=C;U;U=vf(U))V++;for(U=0,z=$;z;z=vf(z))U++;for(;0<V-U;)L=vf(L),V--;for(;0<U-V;)$=vf($),U--;for(;V--;){if(L===$||null!==$&&L===$.alternate)break e;L=vf(L),$=vf($)}L=null}else L=null;null!==C&&wf(w,x,C,L,!1),null!==j&&null!==B&&wf(w,B,j,L,!0)}if("select"===(C=(x=a?ue(a):window).nodeName&&x.nodeName.toLowerCase())||"input"===C&&"file"===x.type)var Y=ve;else if(me(x))if(Tr)Y=Fe;else{Y=De;var Z=Ce}else(C=x.nodeName)&&"input"===C.toLowerCase()&&("checkbox"===x.type||"radio"===x.type)&&(Y=Ee);switch(Y&&(Y=Y(s,a))?ne(w,Y,i,u):(Z&&Z(s,x,a),"focusout"===s&&(Z=x._wrapperState)&&Z.controlled&&"number"===x.type&&cb(x,"number",x.value)),Z=a?ue(a):window,s){case"focusin":(me(Z)||"true"===Z.contentEditable)&&(Fr=Z,Br=a,$r=null);break;case"focusout":$r=Br=Fr=null;break;case"mousedown":qr=!0;break;case"contextmenu":case"mouseup":case"dragend":qr=!1,Ue(w,i,u);break;case"selectionchange":if(Lr)break;case"keydown":case"keyup":Ue(w,i,u)}var ee;if(Er)e:{switch(s){case"compositionstart":var ie="onCompositionStart";break e;case"compositionend":ie="onCompositionEnd";break e;case"compositionupdate":ie="onCompositionUpdate";break e}ie=void 0}else Cr?ge(s,i)&&(ie="onCompositionEnd"):"keydown"===s&&229===i.keyCode&&(ie="onCompositionStart");ie&&(kr&&"ko"!==i.locale&&(Cr||"onCompositionStart"!==ie?"onCompositionEnd"===ie&&Cr&&(ee=nd()):(Jt="value"in(Wt=u)?Wt.value:Wt.textContent,Cr=!0)),0<(Z=oe(a,ie)).length&&(ie=new lr(ie,s,null,i,u),w.push({event:ie,listeners:Z}),ee?ie.data=ee:null!==(ee=he(i))&&(ie.data=ee))),(ee=xr?function je(s,o){switch(s){case"compositionend":return he(o);case"keypress":return 32!==o.which?null:(Ar=!0,Or);case"textInput":return(s=o.data)===Or&&Ar?null:s;default:return null}}(s,i):function ke(s,o){if(Cr)return"compositionend"===s||!Er&&ge(s,o)?(s=nd(),Ht=Jt=Wt=null,Cr=!1,s):null;switch(s){case"paste":default:return null;case"keypress":if(!(o.ctrlKey||o.altKey||o.metaKey)||o.ctrlKey&&o.altKey){if(o.char&&1<o.char.length)return o.char;if(o.which)return String.fromCharCode(o.which)}return null;case"compositionend":return kr&&"ko"!==o.locale?null:o.data}}(s,i))&&(0<(a=oe(a,"onBeforeInput")).length&&(u=new lr("onBeforeInput","beforeinput",null,i,u),w.push({event:u,listeners:a}),u.data=ee))}se(w,o)}))}function tf(s,o,i){return{instance:s,listener:o,currentTarget:i}}function oe(s,o){for(var i=o+"Capture",a=[];null!==s;){var u=s,_=u.stateNode;5===u.tag&&null!==_&&(u=_,null!=(_=Kb(s,i))&&a.unshift(tf(s,_,u)),null!=(_=Kb(s,o))&&a.push(tf(s,_,u))),s=s.return}return a}function vf(s){if(null===s)return null;do{s=s.return}while(s&&5!==s.tag);return s||null}function wf(s,o,i,a,u){for(var _=o._reactName,w=[];null!==i&&i!==a;){var x=i,C=x.alternate,j=x.stateNode;if(null!==C&&C===a)break;5===x.tag&&null!==j&&(x=j,u?null!=(C=Kb(i,_))&&w.unshift(tf(i,C,x)):u||null!=(C=Kb(i,_))&&w.push(tf(i,C,x))),i=i.return}0!==w.length&&s.push({event:o,listeners:w})}var rn=/\r\n?/g,nn=/\u0000|\uFFFD/g;function zf(s){return("string"==typeof s?s:""+s).replace(rn,"\n").replace(nn,"")}function Af(s,o,i){if(o=zf(o),zf(s)!==o&&i)throw Error(p(425))}function Bf(){}var sn=null,on=null;function Ef(s,o){return"textarea"===s||"noscript"===s||"string"==typeof o.children||"number"==typeof o.children||"object"==typeof o.dangerouslySetInnerHTML&&null!==o.dangerouslySetInnerHTML&&null!=o.dangerouslySetInnerHTML.__html}var an="function"==typeof setTimeout?setTimeout:void 0,cn="function"==typeof clearTimeout?clearTimeout:void 0,ln="function"==typeof Promise?Promise:void 0,un="function"==typeof queueMicrotask?queueMicrotask:void 0!==ln?function(s){return ln.resolve(null).then(s).catch(If)}:an;function If(s){setTimeout((function(){throw s}))}function Kf(s,o){var i=o,a=0;do{var u=i.nextSibling;if(s.removeChild(i),u&&8===u.nodeType)if("/$"===(i=u.data)){if(0===a)return s.removeChild(u),void bd(o);a--}else"$"!==i&&"$?"!==i&&"$!"!==i||a++;i=u}while(i);bd(o)}function Lf(s){for(;null!=s;s=s.nextSibling){var o=s.nodeType;if(1===o||3===o)break;if(8===o){if("$"===(o=s.data)||"$!"===o||"$?"===o)break;if("/$"===o)return null}}return s}function Mf(s){s=s.previousSibling;for(var o=0;s;){if(8===s.nodeType){var i=s.data;if("$"===i||"$!"===i||"$?"===i){if(0===o)return s;o--}else"/$"===i&&o++}s=s.previousSibling}return null}var pn=Math.random().toString(36).slice(2),hn="__reactFiber$"+pn,dn="__reactProps$"+pn,fn="__reactContainer$"+pn,mn="__reactEvents$"+pn,gn="__reactListeners$"+pn,yn="__reactHandles$"+pn;function Wc(s){var o=s[hn];if(o)return o;for(var i=s.parentNode;i;){if(o=i[fn]||i[hn]){if(i=o.alternate,null!==o.child||null!==i&&null!==i.child)for(s=Mf(s);null!==s;){if(i=s[hn])return i;s=Mf(s)}return o}i=(s=i).parentNode}return null}function Cb(s){return!(s=s[hn]||s[fn])||5!==s.tag&&6!==s.tag&&13!==s.tag&&3!==s.tag?null:s}function ue(s){if(5===s.tag||6===s.tag)return s.stateNode;throw Error(p(33))}function Db(s){return s[dn]||null}var vn=[],bn=-1;function Uf(s){return{current:s}}function E(s){0>bn||(s.current=vn[bn],vn[bn]=null,bn--)}function G(s,o){bn++,vn[bn]=s.current,s.current=o}var Sn={},_n=Uf(Sn),En=Uf(!1),wn=Sn;function Yf(s,o){var i=s.type.contextTypes;if(!i)return Sn;var a=s.stateNode;if(a&&a.__reactInternalMemoizedUnmaskedChildContext===o)return a.__reactInternalMemoizedMaskedChildContext;var u,_={};for(u in i)_[u]=o[u];return a&&((s=s.stateNode).__reactInternalMemoizedUnmaskedChildContext=o,s.__reactInternalMemoizedMaskedChildContext=_),_}function Zf(s){return null!=(s=s.childContextTypes)}function $f(){E(En),E(_n)}function ag(s,o,i){if(_n.current!==Sn)throw Error(p(168));G(_n,o),G(En,i)}function bg(s,o,i){var a=s.stateNode;if(o=o.childContextTypes,"function"!=typeof a.getChildContext)return i;for(var u in a=a.getChildContext())if(!(u in o))throw Error(p(108,Ra(s)||"Unknown",u));return we({},i,a)}function cg(s){return s=(s=s.stateNode)&&s.__reactInternalMemoizedMergedChildContext||Sn,wn=_n.current,G(_n,s),G(En,En.current),!0}function dg(s,o,i){var a=s.stateNode;if(!a)throw Error(p(169));i?(s=bg(s,o,wn),a.__reactInternalMemoizedMergedChildContext=s,E(En),E(_n),G(_n,s)):E(En),G(En,i)}var xn=null,kn=!1,On=!1;function hg(s){null===xn?xn=[s]:xn.push(s)}function jg(){if(!On&&null!==xn){On=!0;var s=0,o=At;try{var i=xn;for(At=1;s<i.length;s++){var a=i[s];do{a=a(!0)}while(null!==a)}xn=null,kn=!1}catch(o){throw null!==xn&&(xn=xn.slice(s+1)),ct(mt,jg),o}finally{At=o,On=!1}}return null}var An=[],Cn=0,jn=null,Pn=0,In=[],Tn=0,Nn=null,Mn=1,Rn="";function tg(s,o){An[Cn++]=Pn,An[Cn++]=jn,jn=s,Pn=o}function ug(s,o,i){In[Tn++]=Mn,In[Tn++]=Rn,In[Tn++]=Nn,Nn=s;var a=Mn;s=Rn;var u=32-Et(a)-1;a&=~(1<<u),i+=1;var _=32-Et(o)+u;if(30<_){var w=u-u%5;_=(a&(1<<w)-1).toString(32),a>>=w,u-=w,Mn=1<<32-Et(o)+u|i<<u|a,Rn=_+s}else Mn=1<<_|i<<u|a,Rn=s}function vg(s){null!==s.return&&(tg(s,1),ug(s,1,0))}function wg(s){for(;s===jn;)jn=An[--Cn],An[Cn]=null,Pn=An[--Cn],An[Cn]=null;for(;s===Nn;)Nn=In[--Tn],In[Tn]=null,Rn=In[--Tn],In[Tn]=null,Mn=In[--Tn],In[Tn]=null}var Dn=null,Ln=null,Fn=!1,Bn=null;function Ag(s,o){var i=Bg(5,null,null,0);i.elementType="DELETED",i.stateNode=o,i.return=s,null===(o=s.deletions)?(s.deletions=[i],s.flags|=16):o.push(i)}function Cg(s,o){switch(s.tag){case 5:var i=s.type;return null!==(o=1!==o.nodeType||i.toLowerCase()!==o.nodeName.toLowerCase()?null:o)&&(s.stateNode=o,Dn=s,Ln=Lf(o.firstChild),!0);case 6:return null!==(o=""===s.pendingProps||3!==o.nodeType?null:o)&&(s.stateNode=o,Dn=s,Ln=null,!0);case 13:return null!==(o=8!==o.nodeType?null:o)&&(i=null!==Nn?{id:Mn,overflow:Rn}:null,s.memoizedState={dehydrated:o,treeContext:i,retryLane:1073741824},(i=Bg(18,null,null,0)).stateNode=o,i.return=s,s.child=i,Dn=s,Ln=null,!0);default:return!1}}function Dg(s){return!(!(1&s.mode)||128&s.flags)}function Eg(s){if(Fn){var o=Ln;if(o){var i=o;if(!Cg(s,o)){if(Dg(s))throw Error(p(418));o=Lf(i.nextSibling);var a=Dn;o&&Cg(s,o)?Ag(a,i):(s.flags=-4097&s.flags|2,Fn=!1,Dn=s)}}else{if(Dg(s))throw Error(p(418));s.flags=-4097&s.flags|2,Fn=!1,Dn=s}}}function Fg(s){for(s=s.return;null!==s&&5!==s.tag&&3!==s.tag&&13!==s.tag;)s=s.return;Dn=s}function Gg(s){if(s!==Dn)return!1;if(!Fn)return Fg(s),Fn=!0,!1;var o;if((o=3!==s.tag)&&!(o=5!==s.tag)&&(o="head"!==(o=s.type)&&"body"!==o&&!Ef(s.type,s.memoizedProps)),o&&(o=Ln)){if(Dg(s))throw Hg(),Error(p(418));for(;o;)Ag(s,o),o=Lf(o.nextSibling)}if(Fg(s),13===s.tag){if(!(s=null!==(s=s.memoizedState)?s.dehydrated:null))throw Error(p(317));e:{for(s=s.nextSibling,o=0;s;){if(8===s.nodeType){var i=s.data;if("/$"===i){if(0===o){Ln=Lf(s.nextSibling);break e}o--}else"$"!==i&&"$!"!==i&&"$?"!==i||o++}s=s.nextSibling}Ln=null}}else Ln=Dn?Lf(s.stateNode.nextSibling):null;return!0}function Hg(){for(var s=Ln;s;)s=Lf(s.nextSibling)}function Ig(){Ln=Dn=null,Fn=!1}function Jg(s){null===Bn?Bn=[s]:Bn.push(s)}var $n=V.ReactCurrentBatchConfig;function Lg(s,o,i){if(null!==(s=i.ref)&&"function"!=typeof s&&"object"!=typeof s){if(i._owner){if(i=i._owner){if(1!==i.tag)throw Error(p(309));var a=i.stateNode}if(!a)throw Error(p(147,s));var u=a,_=""+s;return null!==o&&null!==o.ref&&"function"==typeof o.ref&&o.ref._stringRef===_?o.ref:(o=function(s){var o=u.refs;null===s?delete o[_]:o[_]=s},o._stringRef=_,o)}if("string"!=typeof s)throw Error(p(284));if(!i._owner)throw Error(p(290,s))}return s}function Mg(s,o){throw s=Object.prototype.toString.call(o),Error(p(31,"[object Object]"===s?"object with keys {"+Object.keys(o).join(", ")+"}":s))}function Ng(s){return(0,s._init)(s._payload)}function Og(s){function b(o,i){if(s){var a=o.deletions;null===a?(o.deletions=[i],o.flags|=16):a.push(i)}}function c(o,i){if(!s)return null;for(;null!==i;)b(o,i),i=i.sibling;return null}function d(s,o){for(s=new Map;null!==o;)null!==o.key?s.set(o.key,o):s.set(o.index,o),o=o.sibling;return s}function e(s,o){return(s=Pg(s,o)).index=0,s.sibling=null,s}function f(o,i,a){return o.index=a,s?null!==(a=o.alternate)?(a=a.index)<i?(o.flags|=2,i):a:(o.flags|=2,i):(o.flags|=1048576,i)}function g(o){return s&&null===o.alternate&&(o.flags|=2),o}function h(s,o,i,a){return null===o||6!==o.tag?((o=Qg(i,s.mode,a)).return=s,o):((o=e(o,i)).return=s,o)}function k(s,o,i,a){var u=i.type;return u===Z?m(s,o,i.props.children,a,i.key):null!==o&&(o.elementType===u||"object"==typeof u&&null!==u&&u.$$typeof===ye&&Ng(u)===o.type)?((a=e(o,i.props)).ref=Lg(s,o,i),a.return=s,a):((a=Rg(i.type,i.key,i.props,null,s.mode,a)).ref=Lg(s,o,i),a.return=s,a)}function l(s,o,i,a){return null===o||4!==o.tag||o.stateNode.containerInfo!==i.containerInfo||o.stateNode.implementation!==i.implementation?((o=Sg(i,s.mode,a)).return=s,o):((o=e(o,i.children||[])).return=s,o)}function m(s,o,i,a,u){return null===o||7!==o.tag?((o=Tg(i,s.mode,a,u)).return=s,o):((o=e(o,i)).return=s,o)}function q(s,o,i){if("string"==typeof o&&""!==o||"number"==typeof o)return(o=Qg(""+o,s.mode,i)).return=s,o;if("object"==typeof o&&null!==o){switch(o.$$typeof){case z:return(i=Rg(o.type,o.key,o.props,null,s.mode,i)).ref=Lg(s,null,o),i.return=s,i;case Y:return(o=Sg(o,s.mode,i)).return=s,o;case ye:return q(s,(0,o._init)(o._payload),i)}if(Pe(o)||Ka(o))return(o=Tg(o,s.mode,i,null)).return=s,o;Mg(s,o)}return null}function r(s,o,i,a){var u=null!==o?o.key:null;if("string"==typeof i&&""!==i||"number"==typeof i)return null!==u?null:h(s,o,""+i,a);if("object"==typeof i&&null!==i){switch(i.$$typeof){case z:return i.key===u?k(s,o,i,a):null;case Y:return i.key===u?l(s,o,i,a):null;case ye:return r(s,o,(u=i._init)(i._payload),a)}if(Pe(i)||Ka(i))return null!==u?null:m(s,o,i,a,null);Mg(s,i)}return null}function y(s,o,i,a,u){if("string"==typeof a&&""!==a||"number"==typeof a)return h(o,s=s.get(i)||null,""+a,u);if("object"==typeof a&&null!==a){switch(a.$$typeof){case z:return k(o,s=s.get(null===a.key?i:a.key)||null,a,u);case Y:return l(o,s=s.get(null===a.key?i:a.key)||null,a,u);case ye:return y(s,o,i,(0,a._init)(a._payload),u)}if(Pe(a)||Ka(a))return m(o,s=s.get(i)||null,a,u,null);Mg(o,a)}return null}function n(o,i,a,u){for(var _=null,w=null,x=i,C=i=0,j=null;null!==x&&C<a.length;C++){x.index>C?(j=x,x=null):j=x.sibling;var L=r(o,x,a[C],u);if(null===L){null===x&&(x=j);break}s&&x&&null===L.alternate&&b(o,x),i=f(L,i,C),null===w?_=L:w.sibling=L,w=L,x=j}if(C===a.length)return c(o,x),Fn&&tg(o,C),_;if(null===x){for(;C<a.length;C++)null!==(x=q(o,a[C],u))&&(i=f(x,i,C),null===w?_=x:w.sibling=x,w=x);return Fn&&tg(o,C),_}for(x=d(o,x);C<a.length;C++)null!==(j=y(x,o,C,a[C],u))&&(s&&null!==j.alternate&&x.delete(null===j.key?C:j.key),i=f(j,i,C),null===w?_=j:w.sibling=j,w=j);return s&&x.forEach((function(s){return b(o,s)})),Fn&&tg(o,C),_}function t(o,i,a,u){var _=Ka(a);if("function"!=typeof _)throw Error(p(150));if(null==(a=_.call(a)))throw Error(p(151));for(var w=_=null,x=i,C=i=0,j=null,L=a.next();null!==x&&!L.done;C++,L=a.next()){x.index>C?(j=x,x=null):j=x.sibling;var B=r(o,x,L.value,u);if(null===B){null===x&&(x=j);break}s&&x&&null===B.alternate&&b(o,x),i=f(B,i,C),null===w?_=B:w.sibling=B,w=B,x=j}if(L.done)return c(o,x),Fn&&tg(o,C),_;if(null===x){for(;!L.done;C++,L=a.next())null!==(L=q(o,L.value,u))&&(i=f(L,i,C),null===w?_=L:w.sibling=L,w=L);return Fn&&tg(o,C),_}for(x=d(o,x);!L.done;C++,L=a.next())null!==(L=y(x,o,C,L.value,u))&&(s&&null!==L.alternate&&x.delete(null===L.key?C:L.key),i=f(L,i,C),null===w?_=L:w.sibling=L,w=L);return s&&x.forEach((function(s){return b(o,s)})),Fn&&tg(o,C),_}return function J(s,o,i,a){if("object"==typeof i&&null!==i&&i.type===Z&&null===i.key&&(i=i.props.children),"object"==typeof i&&null!==i){switch(i.$$typeof){case z:e:{for(var u=i.key,_=o;null!==_;){if(_.key===u){if((u=i.type)===Z){if(7===_.tag){c(s,_.sibling),(o=e(_,i.props.children)).return=s,s=o;break e}}else if(_.elementType===u||"object"==typeof u&&null!==u&&u.$$typeof===ye&&Ng(u)===_.type){c(s,_.sibling),(o=e(_,i.props)).ref=Lg(s,_,i),o.return=s,s=o;break e}c(s,_);break}b(s,_),_=_.sibling}i.type===Z?((o=Tg(i.props.children,s.mode,a,i.key)).return=s,s=o):((a=Rg(i.type,i.key,i.props,null,s.mode,a)).ref=Lg(s,o,i),a.return=s,s=a)}return g(s);case Y:e:{for(_=i.key;null!==o;){if(o.key===_){if(4===o.tag&&o.stateNode.containerInfo===i.containerInfo&&o.stateNode.implementation===i.implementation){c(s,o.sibling),(o=e(o,i.children||[])).return=s,s=o;break e}c(s,o);break}b(s,o),o=o.sibling}(o=Sg(i,s.mode,a)).return=s,s=o}return g(s);case ye:return J(s,o,(_=i._init)(i._payload),a)}if(Pe(i))return n(s,o,i,a);if(Ka(i))return t(s,o,i,a);Mg(s,i)}return"string"==typeof i&&""!==i||"number"==typeof i?(i=""+i,null!==o&&6===o.tag?(c(s,o.sibling),(o=e(o,i)).return=s,s=o):(c(s,o),(o=Qg(i,s.mode,a)).return=s,s=o),g(s)):c(s,o)}}var qn=Og(!0),Un=Og(!1),Vn=Uf(null),zn=null,Wn=null,Jn=null;function $g(){Jn=Wn=zn=null}function ah(s){var o=Vn.current;E(Vn),s._currentValue=o}function bh(s,o,i){for(;null!==s;){var a=s.alternate;if((s.childLanes&o)!==o?(s.childLanes|=o,null!==a&&(a.childLanes|=o)):null!==a&&(a.childLanes&o)!==o&&(a.childLanes|=o),s===i)break;s=s.return}}function ch(s,o){zn=s,Jn=Wn=null,null!==(s=s.dependencies)&&null!==s.firstContext&&(!!(s.lanes&o)&&(bs=!0),s.firstContext=null)}function eh(s){var o=s._currentValue;if(Jn!==s)if(s={context:s,memoizedValue:o,next:null},null===Wn){if(null===zn)throw Error(p(308));Wn=s,zn.dependencies={lanes:0,firstContext:s}}else Wn=Wn.next=s;return o}var Hn=null;function gh(s){null===Hn?Hn=[s]:Hn.push(s)}function hh(s,o,i,a){var u=o.interleaved;return null===u?(i.next=i,gh(o)):(i.next=u.next,u.next=i),o.interleaved=i,ih(s,a)}function ih(s,o){s.lanes|=o;var i=s.alternate;for(null!==i&&(i.lanes|=o),i=s,s=s.return;null!==s;)s.childLanes|=o,null!==(i=s.alternate)&&(i.childLanes|=o),i=s,s=s.return;return 3===i.tag?i.stateNode:null}var Kn=!1;function kh(s){s.updateQueue={baseState:s.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null,interleaved:null,lanes:0},effects:null}}function lh(s,o){s=s.updateQueue,o.updateQueue===s&&(o.updateQueue={baseState:s.baseState,firstBaseUpdate:s.firstBaseUpdate,lastBaseUpdate:s.lastBaseUpdate,shared:s.shared,effects:s.effects})}function mh(s,o){return{eventTime:s,lane:o,tag:0,payload:null,callback:null,next:null}}function nh(s,o,i){var a=s.updateQueue;if(null===a)return null;if(a=a.shared,2&Ds){var u=a.pending;return null===u?o.next=o:(o.next=u.next,u.next=o),a.pending=o,ih(s,i)}return null===(u=a.interleaved)?(o.next=o,gh(a)):(o.next=u.next,u.next=o),a.interleaved=o,ih(s,i)}function oh(s,o,i){if(null!==(o=o.updateQueue)&&(o=o.shared,4194240&i)){var a=o.lanes;i|=a&=s.pendingLanes,o.lanes=i,Cc(s,i)}}function ph(s,o){var i=s.updateQueue,a=s.alternate;if(null!==a&&i===(a=a.updateQueue)){var u=null,_=null;if(null!==(i=i.firstBaseUpdate)){do{var w={eventTime:i.eventTime,lane:i.lane,tag:i.tag,payload:i.payload,callback:i.callback,next:null};null===_?u=_=w:_=_.next=w,i=i.next}while(null!==i);null===_?u=_=o:_=_.next=o}else u=_=o;return i={baseState:a.baseState,firstBaseUpdate:u,lastBaseUpdate:_,shared:a.shared,effects:a.effects},void(s.updateQueue=i)}null===(s=i.lastBaseUpdate)?i.firstBaseUpdate=o:s.next=o,i.lastBaseUpdate=o}function qh(s,o,i,a){var u=s.updateQueue;Kn=!1;var _=u.firstBaseUpdate,w=u.lastBaseUpdate,x=u.shared.pending;if(null!==x){u.shared.pending=null;var C=x,j=C.next;C.next=null,null===w?_=j:w.next=j,w=C;var L=s.alternate;null!==L&&((x=(L=L.updateQueue).lastBaseUpdate)!==w&&(null===x?L.firstBaseUpdate=j:x.next=j,L.lastBaseUpdate=C))}if(null!==_){var B=u.baseState;for(w=0,L=j=C=null,x=_;;){var $=x.lane,U=x.eventTime;if((a&$)===$){null!==L&&(L=L.next={eventTime:U,lane:0,tag:x.tag,payload:x.payload,callback:x.callback,next:null});e:{var V=s,z=x;switch($=o,U=i,z.tag){case 1:if("function"==typeof(V=z.payload)){B=V.call(U,B,$);break e}B=V;break e;case 3:V.flags=-65537&V.flags|128;case 0:if(null==($="function"==typeof(V=z.payload)?V.call(U,B,$):V))break e;B=we({},B,$);break e;case 2:Kn=!0}}null!==x.callback&&0!==x.lane&&(s.flags|=64,null===($=u.effects)?u.effects=[x]:$.push(x))}else U={eventTime:U,lane:$,tag:x.tag,payload:x.payload,callback:x.callback,next:null},null===L?(j=L=U,C=B):L=L.next=U,w|=$;if(null===(x=x.next)){if(null===(x=u.shared.pending))break;x=($=x).next,$.next=null,u.lastBaseUpdate=$,u.shared.pending=null}}if(null===L&&(C=B),u.baseState=C,u.firstBaseUpdate=j,u.lastBaseUpdate=L,null!==(o=u.shared.interleaved)){u=o;do{w|=u.lane,u=u.next}while(u!==o)}else null===_&&(u.shared.lanes=0);zs|=w,s.lanes=w,s.memoizedState=B}}function sh(s,o,i){if(s=o.effects,o.effects=null,null!==s)for(o=0;o<s.length;o++){var a=s[o],u=a.callback;if(null!==u){if(a.callback=null,a=i,"function"!=typeof u)throw Error(p(191,u));u.call(a)}}}var Gn={},Yn=Uf(Gn),Xn=Uf(Gn),Qn=Uf(Gn);function xh(s){if(s===Gn)throw Error(p(174));return s}function yh(s,o){switch(G(Qn,o),G(Xn,s),G(Yn,Gn),s=o.nodeType){case 9:case 11:o=(o=o.documentElement)?o.namespaceURI:lb(null,"");break;default:o=lb(o=(s=8===s?o.parentNode:o).namespaceURI||null,s=s.tagName)}E(Yn),G(Yn,o)}function zh(){E(Yn),E(Xn),E(Qn)}function Ah(s){xh(Qn.current);var o=xh(Yn.current),i=lb(o,s.type);o!==i&&(G(Xn,s),G(Yn,i))}function Bh(s){Xn.current===s&&(E(Yn),E(Xn))}var Zn=Uf(0);function Ch(s){for(var o=s;null!==o;){if(13===o.tag){var i=o.memoizedState;if(null!==i&&(null===(i=i.dehydrated)||"$?"===i.data||"$!"===i.data))return o}else if(19===o.tag&&void 0!==o.memoizedProps.revealOrder){if(128&o.flags)return o}else if(null!==o.child){o.child.return=o,o=o.child;continue}if(o===s)break;for(;null===o.sibling;){if(null===o.return||o.return===s)return null;o=o.return}o.sibling.return=o.return,o=o.sibling}return null}var es=[];function Eh(){for(var s=0;s<es.length;s++)es[s]._workInProgressVersionPrimary=null;es.length=0}var ts=V.ReactCurrentDispatcher,rs=V.ReactCurrentBatchConfig,ns=0,ss=null,os=null,as=null,cs=!1,ls=!1,us=0,ps=0;function P(){throw Error(p(321))}function Mh(s,o){if(null===o)return!1;for(var i=0;i<o.length&&i<s.length;i++)if(!Dr(s[i],o[i]))return!1;return!0}function Nh(s,o,i,a,u,_){if(ns=_,ss=o,o.memoizedState=null,o.updateQueue=null,o.lanes=0,ts.current=null===s||null===s.memoizedState?ds:fs,s=i(a,u),ls){_=0;do{if(ls=!1,us=0,25<=_)throw Error(p(301));_+=1,as=os=null,o.updateQueue=null,ts.current=ms,s=i(a,u)}while(ls)}if(ts.current=hs,o=null!==os&&null!==os.next,ns=0,as=os=ss=null,cs=!1,o)throw Error(p(300));return s}function Sh(){var s=0!==us;return us=0,s}function Th(){var s={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};return null===as?ss.memoizedState=as=s:as=as.next=s,as}function Uh(){if(null===os){var s=ss.alternate;s=null!==s?s.memoizedState:null}else s=os.next;var o=null===as?ss.memoizedState:as.next;if(null!==o)as=o,os=s;else{if(null===s)throw Error(p(310));s={memoizedState:(os=s).memoizedState,baseState:os.baseState,baseQueue:os.baseQueue,queue:os.queue,next:null},null===as?ss.memoizedState=as=s:as=as.next=s}return as}function Vh(s,o){return"function"==typeof o?o(s):o}function Wh(s){var o=Uh(),i=o.queue;if(null===i)throw Error(p(311));i.lastRenderedReducer=s;var a=os,u=a.baseQueue,_=i.pending;if(null!==_){if(null!==u){var w=u.next;u.next=_.next,_.next=w}a.baseQueue=u=_,i.pending=null}if(null!==u){_=u.next,a=a.baseState;var x=w=null,C=null,j=_;do{var L=j.lane;if((ns&L)===L)null!==C&&(C=C.next={lane:0,action:j.action,hasEagerState:j.hasEagerState,eagerState:j.eagerState,next:null}),a=j.hasEagerState?j.eagerState:s(a,j.action);else{var B={lane:L,action:j.action,hasEagerState:j.hasEagerState,eagerState:j.eagerState,next:null};null===C?(x=C=B,w=a):C=C.next=B,ss.lanes|=L,zs|=L}j=j.next}while(null!==j&&j!==_);null===C?w=a:C.next=x,Dr(a,o.memoizedState)||(bs=!0),o.memoizedState=a,o.baseState=w,o.baseQueue=C,i.lastRenderedState=a}if(null!==(s=i.interleaved)){u=s;do{_=u.lane,ss.lanes|=_,zs|=_,u=u.next}while(u!==s)}else null===u&&(i.lanes=0);return[o.memoizedState,i.dispatch]}function Xh(s){var o=Uh(),i=o.queue;if(null===i)throw Error(p(311));i.lastRenderedReducer=s;var a=i.dispatch,u=i.pending,_=o.memoizedState;if(null!==u){i.pending=null;var w=u=u.next;do{_=s(_,w.action),w=w.next}while(w!==u);Dr(_,o.memoizedState)||(bs=!0),o.memoizedState=_,null===o.baseQueue&&(o.baseState=_),i.lastRenderedState=_}return[_,a]}function Yh(){}function Zh(s,o){var i=ss,a=Uh(),u=o(),_=!Dr(a.memoizedState,u);if(_&&(a.memoizedState=u,bs=!0),a=a.queue,$h(ai.bind(null,i,a,s),[s]),a.getSnapshot!==o||_||null!==as&&1&as.memoizedState.tag){if(i.flags|=2048,bi(9,ci.bind(null,i,a,u,o),void 0,null),null===Ls)throw Error(p(349));30&ns||di(i,o,u)}return u}function di(s,o,i){s.flags|=16384,s={getSnapshot:o,value:i},null===(o=ss.updateQueue)?(o={lastEffect:null,stores:null},ss.updateQueue=o,o.stores=[s]):null===(i=o.stores)?o.stores=[s]:i.push(s)}function ci(s,o,i,a){o.value=i,o.getSnapshot=a,ei(o)&&fi(s)}function ai(s,o,i){return i((function(){ei(o)&&fi(s)}))}function ei(s){var o=s.getSnapshot;s=s.value;try{var i=o();return!Dr(s,i)}catch(s){return!0}}function fi(s){var o=ih(s,1);null!==o&&gi(o,s,1,-1)}function hi(s){var o=Th();return"function"==typeof s&&(s=s()),o.memoizedState=o.baseState=s,s={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:Vh,lastRenderedState:s},o.queue=s,s=s.dispatch=ii.bind(null,ss,s),[o.memoizedState,s]}function bi(s,o,i,a){return s={tag:s,create:o,destroy:i,deps:a,next:null},null===(o=ss.updateQueue)?(o={lastEffect:null,stores:null},ss.updateQueue=o,o.lastEffect=s.next=s):null===(i=o.lastEffect)?o.lastEffect=s.next=s:(a=i.next,i.next=s,s.next=a,o.lastEffect=s),s}function ji(){return Uh().memoizedState}function ki(s,o,i,a){var u=Th();ss.flags|=s,u.memoizedState=bi(1|o,i,void 0,void 0===a?null:a)}function li(s,o,i,a){var u=Uh();a=void 0===a?null:a;var _=void 0;if(null!==os){var w=os.memoizedState;if(_=w.destroy,null!==a&&Mh(a,w.deps))return void(u.memoizedState=bi(o,i,_,a))}ss.flags|=s,u.memoizedState=bi(1|o,i,_,a)}function mi(s,o){return ki(8390656,8,s,o)}function $h(s,o){return li(2048,8,s,o)}function ni(s,o){return li(4,2,s,o)}function oi(s,o){return li(4,4,s,o)}function pi(s,o){return"function"==typeof o?(s=s(),o(s),function(){o(null)}):null!=o?(s=s(),o.current=s,function(){o.current=null}):void 0}function qi(s,o,i){return i=null!=i?i.concat([s]):null,li(4,4,pi.bind(null,o,s),i)}function ri(){}function si(s,o){var i=Uh();o=void 0===o?null:o;var a=i.memoizedState;return null!==a&&null!==o&&Mh(o,a[1])?a[0]:(i.memoizedState=[s,o],s)}function ti(s,o){var i=Uh();o=void 0===o?null:o;var a=i.memoizedState;return null!==a&&null!==o&&Mh(o,a[1])?a[0]:(s=s(),i.memoizedState=[s,o],s)}function ui(s,o,i){return 21&ns?(Dr(i,o)||(i=yc(),ss.lanes|=i,zs|=i,s.baseState=!0),o):(s.baseState&&(s.baseState=!1,bs=!0),s.memoizedState=i)}function vi(s,o){var i=At;At=0!==i&&4>i?i:4,s(!0);var a=rs.transition;rs.transition={};try{s(!1),o()}finally{At=i,rs.transition=a}}function wi(){return Uh().memoizedState}function xi(s,o,i){var a=yi(s);if(i={lane:a,action:i,hasEagerState:!1,eagerState:null,next:null},zi(s))Ai(o,i);else if(null!==(i=hh(s,o,i,a))){gi(i,s,a,R()),Bi(i,o,a)}}function ii(s,o,i){var a=yi(s),u={lane:a,action:i,hasEagerState:!1,eagerState:null,next:null};if(zi(s))Ai(o,u);else{var _=s.alternate;if(0===s.lanes&&(null===_||0===_.lanes)&&null!==(_=o.lastRenderedReducer))try{var w=o.lastRenderedState,x=_(w,i);if(u.hasEagerState=!0,u.eagerState=x,Dr(x,w)){var C=o.interleaved;return null===C?(u.next=u,gh(o)):(u.next=C.next,C.next=u),void(o.interleaved=u)}}catch(s){}null!==(i=hh(s,o,u,a))&&(gi(i,s,a,u=R()),Bi(i,o,a))}}function zi(s){var o=s.alternate;return s===ss||null!==o&&o===ss}function Ai(s,o){ls=cs=!0;var i=s.pending;null===i?o.next=o:(o.next=i.next,i.next=o),s.pending=o}function Bi(s,o,i){if(4194240&i){var a=o.lanes;i|=a&=s.pendingLanes,o.lanes=i,Cc(s,i)}}var hs={readContext:eh,useCallback:P,useContext:P,useEffect:P,useImperativeHandle:P,useInsertionEffect:P,useLayoutEffect:P,useMemo:P,useReducer:P,useRef:P,useState:P,useDebugValue:P,useDeferredValue:P,useTransition:P,useMutableSource:P,useSyncExternalStore:P,useId:P,unstable_isNewReconciler:!1},ds={readContext:eh,useCallback:function(s,o){return Th().memoizedState=[s,void 0===o?null:o],s},useContext:eh,useEffect:mi,useImperativeHandle:function(s,o,i){return i=null!=i?i.concat([s]):null,ki(4194308,4,pi.bind(null,o,s),i)},useLayoutEffect:function(s,o){return ki(4194308,4,s,o)},useInsertionEffect:function(s,o){return ki(4,2,s,o)},useMemo:function(s,o){var i=Th();return o=void 0===o?null:o,s=s(),i.memoizedState=[s,o],s},useReducer:function(s,o,i){var a=Th();return o=void 0!==i?i(o):o,a.memoizedState=a.baseState=o,s={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:s,lastRenderedState:o},a.queue=s,s=s.dispatch=xi.bind(null,ss,s),[a.memoizedState,s]},useRef:function(s){return s={current:s},Th().memoizedState=s},useState:hi,useDebugValue:ri,useDeferredValue:function(s){return Th().memoizedState=s},useTransition:function(){var s=hi(!1),o=s[0];return s=vi.bind(null,s[1]),Th().memoizedState=s,[o,s]},useMutableSource:function(){},useSyncExternalStore:function(s,o,i){var a=ss,u=Th();if(Fn){if(void 0===i)throw Error(p(407));i=i()}else{if(i=o(),null===Ls)throw Error(p(349));30&ns||di(a,o,i)}u.memoizedState=i;var _={value:i,getSnapshot:o};return u.queue=_,mi(ai.bind(null,a,_,s),[s]),a.flags|=2048,bi(9,ci.bind(null,a,_,i,o),void 0,null),i},useId:function(){var s=Th(),o=Ls.identifierPrefix;if(Fn){var i=Rn;o=":"+o+"R"+(i=(Mn&~(1<<32-Et(Mn)-1)).toString(32)+i),0<(i=us++)&&(o+="H"+i.toString(32)),o+=":"}else o=":"+o+"r"+(i=ps++).toString(32)+":";return s.memoizedState=o},unstable_isNewReconciler:!1},fs={readContext:eh,useCallback:si,useContext:eh,useEffect:$h,useImperativeHandle:qi,useInsertionEffect:ni,useLayoutEffect:oi,useMemo:ti,useReducer:Wh,useRef:ji,useState:function(){return Wh(Vh)},useDebugValue:ri,useDeferredValue:function(s){return ui(Uh(),os.memoizedState,s)},useTransition:function(){return[Wh(Vh)[0],Uh().memoizedState]},useMutableSource:Yh,useSyncExternalStore:Zh,useId:wi,unstable_isNewReconciler:!1},ms={readContext:eh,useCallback:si,useContext:eh,useEffect:$h,useImperativeHandle:qi,useInsertionEffect:ni,useLayoutEffect:oi,useMemo:ti,useReducer:Xh,useRef:ji,useState:function(){return Xh(Vh)},useDebugValue:ri,useDeferredValue:function(s){var o=Uh();return null===os?o.memoizedState=s:ui(o,os.memoizedState,s)},useTransition:function(){return[Xh(Vh)[0],Uh().memoizedState]},useMutableSource:Yh,useSyncExternalStore:Zh,useId:wi,unstable_isNewReconciler:!1};function Ci(s,o){if(s&&s.defaultProps){for(var i in o=we({},o),s=s.defaultProps)void 0===o[i]&&(o[i]=s[i]);return o}return o}function Di(s,o,i,a){i=null==(i=i(a,o=s.memoizedState))?o:we({},o,i),s.memoizedState=i,0===s.lanes&&(s.updateQueue.baseState=i)}var gs={isMounted:function(s){return!!(s=s._reactInternals)&&Vb(s)===s},enqueueSetState:function(s,o,i){s=s._reactInternals;var a=R(),u=yi(s),_=mh(a,u);_.payload=o,null!=i&&(_.callback=i),null!==(o=nh(s,_,u))&&(gi(o,s,u,a),oh(o,s,u))},enqueueReplaceState:function(s,o,i){s=s._reactInternals;var a=R(),u=yi(s),_=mh(a,u);_.tag=1,_.payload=o,null!=i&&(_.callback=i),null!==(o=nh(s,_,u))&&(gi(o,s,u,a),oh(o,s,u))},enqueueForceUpdate:function(s,o){s=s._reactInternals;var i=R(),a=yi(s),u=mh(i,a);u.tag=2,null!=o&&(u.callback=o),null!==(o=nh(s,u,a))&&(gi(o,s,a,i),oh(o,s,a))}};function Fi(s,o,i,a,u,_,w){return"function"==typeof(s=s.stateNode).shouldComponentUpdate?s.shouldComponentUpdate(a,_,w):!o.prototype||!o.prototype.isPureReactComponent||(!Ie(i,a)||!Ie(u,_))}function Gi(s,o,i){var a=!1,u=Sn,_=o.contextType;return"object"==typeof _&&null!==_?_=eh(_):(u=Zf(o)?wn:_n.current,_=(a=null!=(a=o.contextTypes))?Yf(s,u):Sn),o=new o(i,_),s.memoizedState=null!==o.state&&void 0!==o.state?o.state:null,o.updater=gs,s.stateNode=o,o._reactInternals=s,a&&((s=s.stateNode).__reactInternalMemoizedUnmaskedChildContext=u,s.__reactInternalMemoizedMaskedChildContext=_),o}function Hi(s,o,i,a){s=o.state,"function"==typeof o.componentWillReceiveProps&&o.componentWillReceiveProps(i,a),"function"==typeof o.UNSAFE_componentWillReceiveProps&&o.UNSAFE_componentWillReceiveProps(i,a),o.state!==s&&gs.enqueueReplaceState(o,o.state,null)}function Ii(s,o,i,a){var u=s.stateNode;u.props=i,u.state=s.memoizedState,u.refs={},kh(s);var _=o.contextType;"object"==typeof _&&null!==_?u.context=eh(_):(_=Zf(o)?wn:_n.current,u.context=Yf(s,_)),u.state=s.memoizedState,"function"==typeof(_=o.getDerivedStateFromProps)&&(Di(s,o,_,i),u.state=s.memoizedState),"function"==typeof o.getDerivedStateFromProps||"function"==typeof u.getSnapshotBeforeUpdate||"function"!=typeof u.UNSAFE_componentWillMount&&"function"!=typeof u.componentWillMount||(o=u.state,"function"==typeof u.componentWillMount&&u.componentWillMount(),"function"==typeof u.UNSAFE_componentWillMount&&u.UNSAFE_componentWillMount(),o!==u.state&&gs.enqueueReplaceState(u,u.state,null),qh(s,i,u,a),u.state=s.memoizedState),"function"==typeof u.componentDidMount&&(s.flags|=4194308)}function Ji(s,o){try{var i="",a=o;do{i+=Pa(a),a=a.return}while(a);var u=i}catch(s){u="\nError generating stack: "+s.message+"\n"+s.stack}return{value:s,source:o,stack:u,digest:null}}function Ki(s,o,i){return{value:s,source:null,stack:null!=i?i:null,digest:null!=o?o:null}}function Li(s,o){try{console.error(o.value)}catch(s){setTimeout((function(){throw s}))}}var ys="function"==typeof WeakMap?WeakMap:Map;function Ni(s,o,i){(i=mh(-1,i)).tag=3,i.payload={element:null};var a=o.value;return i.callback=function(){Qs||(Qs=!0,Zs=a),Li(0,o)},i}function Qi(s,o,i){(i=mh(-1,i)).tag=3;var a=s.type.getDerivedStateFromError;if("function"==typeof a){var u=o.value;i.payload=function(){return a(u)},i.callback=function(){Li(0,o)}}var _=s.stateNode;return null!==_&&"function"==typeof _.componentDidCatch&&(i.callback=function(){Li(0,o),"function"!=typeof a&&(null===eo?eo=new Set([this]):eo.add(this));var s=o.stack;this.componentDidCatch(o.value,{componentStack:null!==s?s:""})}),i}function Si(s,o,i){var a=s.pingCache;if(null===a){a=s.pingCache=new ys;var u=new Set;a.set(o,u)}else void 0===(u=a.get(o))&&(u=new Set,a.set(o,u));u.has(i)||(u.add(i),s=Ti.bind(null,s,o,i),o.then(s,s))}function Ui(s){do{var o;if((o=13===s.tag)&&(o=null===(o=s.memoizedState)||null!==o.dehydrated),o)return s;s=s.return}while(null!==s);return null}function Vi(s,o,i,a,u){return 1&s.mode?(s.flags|=65536,s.lanes=u,s):(s===o?s.flags|=65536:(s.flags|=128,i.flags|=131072,i.flags&=-52805,1===i.tag&&(null===i.alternate?i.tag=17:((o=mh(-1,1)).tag=2,nh(i,o,1))),i.lanes|=1),s)}var vs=V.ReactCurrentOwner,bs=!1;function Xi(s,o,i,a){o.child=null===s?Un(o,null,i,a):qn(o,s.child,i,a)}function Yi(s,o,i,a,u){i=i.render;var _=o.ref;return ch(o,u),a=Nh(s,o,i,a,_,u),i=Sh(),null===s||bs?(Fn&&i&&vg(o),o.flags|=1,Xi(s,o,a,u),o.child):(o.updateQueue=s.updateQueue,o.flags&=-2053,s.lanes&=~u,Zi(s,o,u))}function $i(s,o,i,a,u){if(null===s){var _=i.type;return"function"!=typeof _||aj(_)||void 0!==_.defaultProps||null!==i.compare||void 0!==i.defaultProps?((s=Rg(i.type,null,a,o,o.mode,u)).ref=o.ref,s.return=o,o.child=s):(o.tag=15,o.type=_,bj(s,o,_,a,u))}if(_=s.child,!(s.lanes&u)){var w=_.memoizedProps;if((i=null!==(i=i.compare)?i:Ie)(w,a)&&s.ref===o.ref)return Zi(s,o,u)}return o.flags|=1,(s=Pg(_,a)).ref=o.ref,s.return=o,o.child=s}function bj(s,o,i,a,u){if(null!==s){var _=s.memoizedProps;if(Ie(_,a)&&s.ref===o.ref){if(bs=!1,o.pendingProps=a=_,!(s.lanes&u))return o.lanes=s.lanes,Zi(s,o,u);131072&s.flags&&(bs=!0)}}return cj(s,o,i,a,u)}function dj(s,o,i){var a=o.pendingProps,u=a.children,_=null!==s?s.memoizedState:null;if("hidden"===a.mode)if(1&o.mode){if(!(1073741824&i))return s=null!==_?_.baseLanes|i:i,o.lanes=o.childLanes=1073741824,o.memoizedState={baseLanes:s,cachePool:null,transitions:null},o.updateQueue=null,G(qs,$s),$s|=s,null;o.memoizedState={baseLanes:0,cachePool:null,transitions:null},a=null!==_?_.baseLanes:i,G(qs,$s),$s|=a}else o.memoizedState={baseLanes:0,cachePool:null,transitions:null},G(qs,$s),$s|=i;else null!==_?(a=_.baseLanes|i,o.memoizedState=null):a=i,G(qs,$s),$s|=a;return Xi(s,o,u,i),o.child}function gj(s,o){var i=o.ref;(null===s&&null!==i||null!==s&&s.ref!==i)&&(o.flags|=512,o.flags|=2097152)}function cj(s,o,i,a,u){var _=Zf(i)?wn:_n.current;return _=Yf(o,_),ch(o,u),i=Nh(s,o,i,a,_,u),a=Sh(),null===s||bs?(Fn&&a&&vg(o),o.flags|=1,Xi(s,o,i,u),o.child):(o.updateQueue=s.updateQueue,o.flags&=-2053,s.lanes&=~u,Zi(s,o,u))}function hj(s,o,i,a,u){if(Zf(i)){var _=!0;cg(o)}else _=!1;if(ch(o,u),null===o.stateNode)ij(s,o),Gi(o,i,a),Ii(o,i,a,u),a=!0;else if(null===s){var w=o.stateNode,x=o.memoizedProps;w.props=x;var C=w.context,j=i.contextType;"object"==typeof j&&null!==j?j=eh(j):j=Yf(o,j=Zf(i)?wn:_n.current);var L=i.getDerivedStateFromProps,B="function"==typeof L||"function"==typeof w.getSnapshotBeforeUpdate;B||"function"!=typeof w.UNSAFE_componentWillReceiveProps&&"function"!=typeof w.componentWillReceiveProps||(x!==a||C!==j)&&Hi(o,w,a,j),Kn=!1;var $=o.memoizedState;w.state=$,qh(o,a,w,u),C=o.memoizedState,x!==a||$!==C||En.current||Kn?("function"==typeof L&&(Di(o,i,L,a),C=o.memoizedState),(x=Kn||Fi(o,i,x,a,$,C,j))?(B||"function"!=typeof w.UNSAFE_componentWillMount&&"function"!=typeof w.componentWillMount||("function"==typeof w.componentWillMount&&w.componentWillMount(),"function"==typeof w.UNSAFE_componentWillMount&&w.UNSAFE_componentWillMount()),"function"==typeof w.componentDidMount&&(o.flags|=4194308)):("function"==typeof w.componentDidMount&&(o.flags|=4194308),o.memoizedProps=a,o.memoizedState=C),w.props=a,w.state=C,w.context=j,a=x):("function"==typeof w.componentDidMount&&(o.flags|=4194308),a=!1)}else{w=o.stateNode,lh(s,o),x=o.memoizedProps,j=o.type===o.elementType?x:Ci(o.type,x),w.props=j,B=o.pendingProps,$=w.context,"object"==typeof(C=i.contextType)&&null!==C?C=eh(C):C=Yf(o,C=Zf(i)?wn:_n.current);var U=i.getDerivedStateFromProps;(L="function"==typeof U||"function"==typeof w.getSnapshotBeforeUpdate)||"function"!=typeof w.UNSAFE_componentWillReceiveProps&&"function"!=typeof w.componentWillReceiveProps||(x!==B||$!==C)&&Hi(o,w,a,C),Kn=!1,$=o.memoizedState,w.state=$,qh(o,a,w,u);var V=o.memoizedState;x!==B||$!==V||En.current||Kn?("function"==typeof U&&(Di(o,i,U,a),V=o.memoizedState),(j=Kn||Fi(o,i,j,a,$,V,C)||!1)?(L||"function"!=typeof w.UNSAFE_componentWillUpdate&&"function"!=typeof w.componentWillUpdate||("function"==typeof w.componentWillUpdate&&w.componentWillUpdate(a,V,C),"function"==typeof w.UNSAFE_componentWillUpdate&&w.UNSAFE_componentWillUpdate(a,V,C)),"function"==typeof w.componentDidUpdate&&(o.flags|=4),"function"==typeof w.getSnapshotBeforeUpdate&&(o.flags|=1024)):("function"!=typeof w.componentDidUpdate||x===s.memoizedProps&&$===s.memoizedState||(o.flags|=4),"function"!=typeof w.getSnapshotBeforeUpdate||x===s.memoizedProps&&$===s.memoizedState||(o.flags|=1024),o.memoizedProps=a,o.memoizedState=V),w.props=a,w.state=V,w.context=C,a=j):("function"!=typeof w.componentDidUpdate||x===s.memoizedProps&&$===s.memoizedState||(o.flags|=4),"function"!=typeof w.getSnapshotBeforeUpdate||x===s.memoizedProps&&$===s.memoizedState||(o.flags|=1024),a=!1)}return jj(s,o,i,a,_,u)}function jj(s,o,i,a,u,_){gj(s,o);var w=!!(128&o.flags);if(!a&&!w)return u&&dg(o,i,!1),Zi(s,o,_);a=o.stateNode,vs.current=o;var x=w&&"function"!=typeof i.getDerivedStateFromError?null:a.render();return o.flags|=1,null!==s&&w?(o.child=qn(o,s.child,null,_),o.child=qn(o,null,x,_)):Xi(s,o,x,_),o.memoizedState=a.state,u&&dg(o,i,!0),o.child}function kj(s){var o=s.stateNode;o.pendingContext?ag(0,o.pendingContext,o.pendingContext!==o.context):o.context&&ag(0,o.context,!1),yh(s,o.containerInfo)}function lj(s,o,i,a,u){return Ig(),Jg(u),o.flags|=256,Xi(s,o,i,a),o.child}var Ss,_s,Es,ws={dehydrated:null,treeContext:null,retryLane:0};function nj(s){return{baseLanes:s,cachePool:null,transitions:null}}function oj(s,o,i){var a,u=o.pendingProps,_=Zn.current,w=!1,x=!!(128&o.flags);if((a=x)||(a=(null===s||null!==s.memoizedState)&&!!(2&_)),a?(w=!0,o.flags&=-129):null!==s&&null===s.memoizedState||(_|=1),G(Zn,1&_),null===s)return Eg(o),null!==(s=o.memoizedState)&&null!==(s=s.dehydrated)?(1&o.mode?"$!"===s.data?o.lanes=8:o.lanes=1073741824:o.lanes=1,null):(x=u.children,s=u.fallback,w?(u=o.mode,w=o.child,x={mode:"hidden",children:x},1&u||null===w?w=pj(x,u,0,null):(w.childLanes=0,w.pendingProps=x),s=Tg(s,u,i,null),w.return=o,s.return=o,w.sibling=s,o.child=w,o.child.memoizedState=nj(i),o.memoizedState=ws,s):qj(o,x));if(null!==(_=s.memoizedState)&&null!==(a=_.dehydrated))return function rj(s,o,i,a,u,_,w){if(i)return 256&o.flags?(o.flags&=-257,sj(s,o,w,a=Ki(Error(p(422))))):null!==o.memoizedState?(o.child=s.child,o.flags|=128,null):(_=a.fallback,u=o.mode,a=pj({mode:"visible",children:a.children},u,0,null),(_=Tg(_,u,w,null)).flags|=2,a.return=o,_.return=o,a.sibling=_,o.child=a,1&o.mode&&qn(o,s.child,null,w),o.child.memoizedState=nj(w),o.memoizedState=ws,_);if(!(1&o.mode))return sj(s,o,w,null);if("$!"===u.data){if(a=u.nextSibling&&u.nextSibling.dataset)var x=a.dgst;return a=x,sj(s,o,w,a=Ki(_=Error(p(419)),a,void 0))}if(x=!!(w&s.childLanes),bs||x){if(null!==(a=Ls)){switch(w&-w){case 4:u=2;break;case 16:u=8;break;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:u=32;break;case 536870912:u=268435456;break;default:u=0}0!==(u=u&(a.suspendedLanes|w)?0:u)&&u!==_.retryLane&&(_.retryLane=u,ih(s,u),gi(a,s,u,-1))}return tj(),sj(s,o,w,a=Ki(Error(p(421))))}return"$?"===u.data?(o.flags|=128,o.child=s.child,o=uj.bind(null,s),u._reactRetry=o,null):(s=_.treeContext,Ln=Lf(u.nextSibling),Dn=o,Fn=!0,Bn=null,null!==s&&(In[Tn++]=Mn,In[Tn++]=Rn,In[Tn++]=Nn,Mn=s.id,Rn=s.overflow,Nn=o),o=qj(o,a.children),o.flags|=4096,o)}(s,o,x,u,a,_,i);if(w){w=u.fallback,x=o.mode,a=(_=s.child).sibling;var C={mode:"hidden",children:u.children};return 1&x||o.child===_?(u=Pg(_,C)).subtreeFlags=14680064&_.subtreeFlags:((u=o.child).childLanes=0,u.pendingProps=C,o.deletions=null),null!==a?w=Pg(a,w):(w=Tg(w,x,i,null)).flags|=2,w.return=o,u.return=o,u.sibling=w,o.child=u,u=w,w=o.child,x=null===(x=s.child.memoizedState)?nj(i):{baseLanes:x.baseLanes|i,cachePool:null,transitions:x.transitions},w.memoizedState=x,w.childLanes=s.childLanes&~i,o.memoizedState=ws,u}return s=(w=s.child).sibling,u=Pg(w,{mode:"visible",children:u.children}),!(1&o.mode)&&(u.lanes=i),u.return=o,u.sibling=null,null!==s&&(null===(i=o.deletions)?(o.deletions=[s],o.flags|=16):i.push(s)),o.child=u,o.memoizedState=null,u}function qj(s,o){return(o=pj({mode:"visible",children:o},s.mode,0,null)).return=s,s.child=o}function sj(s,o,i,a){return null!==a&&Jg(a),qn(o,s.child,null,i),(s=qj(o,o.pendingProps.children)).flags|=2,o.memoizedState=null,s}function vj(s,o,i){s.lanes|=o;var a=s.alternate;null!==a&&(a.lanes|=o),bh(s.return,o,i)}function wj(s,o,i,a,u){var _=s.memoizedState;null===_?s.memoizedState={isBackwards:o,rendering:null,renderingStartTime:0,last:a,tail:i,tailMode:u}:(_.isBackwards=o,_.rendering=null,_.renderingStartTime=0,_.last=a,_.tail=i,_.tailMode=u)}function xj(s,o,i){var a=o.pendingProps,u=a.revealOrder,_=a.tail;if(Xi(s,o,a.children,i),2&(a=Zn.current))a=1&a|2,o.flags|=128;else{if(null!==s&&128&s.flags)e:for(s=o.child;null!==s;){if(13===s.tag)null!==s.memoizedState&&vj(s,i,o);else if(19===s.tag)vj(s,i,o);else if(null!==s.child){s.child.return=s,s=s.child;continue}if(s===o)break e;for(;null===s.sibling;){if(null===s.return||s.return===o)break e;s=s.return}s.sibling.return=s.return,s=s.sibling}a&=1}if(G(Zn,a),1&o.mode)switch(u){case"forwards":for(i=o.child,u=null;null!==i;)null!==(s=i.alternate)&&null===Ch(s)&&(u=i),i=i.sibling;null===(i=u)?(u=o.child,o.child=null):(u=i.sibling,i.sibling=null),wj(o,!1,u,i,_);break;case"backwards":for(i=null,u=o.child,o.child=null;null!==u;){if(null!==(s=u.alternate)&&null===Ch(s)){o.child=u;break}s=u.sibling,u.sibling=i,i=u,u=s}wj(o,!0,i,null,_);break;case"together":wj(o,!1,null,null,void 0);break;default:o.memoizedState=null}else o.memoizedState=null;return o.child}function ij(s,o){!(1&o.mode)&&null!==s&&(s.alternate=null,o.alternate=null,o.flags|=2)}function Zi(s,o,i){if(null!==s&&(o.dependencies=s.dependencies),zs|=o.lanes,!(i&o.childLanes))return null;if(null!==s&&o.child!==s.child)throw Error(p(153));if(null!==o.child){for(i=Pg(s=o.child,s.pendingProps),o.child=i,i.return=o;null!==s.sibling;)s=s.sibling,(i=i.sibling=Pg(s,s.pendingProps)).return=o;i.sibling=null}return o.child}function Dj(s,o){if(!Fn)switch(s.tailMode){case"hidden":o=s.tail;for(var i=null;null!==o;)null!==o.alternate&&(i=o),o=o.sibling;null===i?s.tail=null:i.sibling=null;break;case"collapsed":i=s.tail;for(var a=null;null!==i;)null!==i.alternate&&(a=i),i=i.sibling;null===a?o||null===s.tail?s.tail=null:s.tail.sibling=null:a.sibling=null}}function S(s){var o=null!==s.alternate&&s.alternate.child===s.child,i=0,a=0;if(o)for(var u=s.child;null!==u;)i|=u.lanes|u.childLanes,a|=14680064&u.subtreeFlags,a|=14680064&u.flags,u.return=s,u=u.sibling;else for(u=s.child;null!==u;)i|=u.lanes|u.childLanes,a|=u.subtreeFlags,a|=u.flags,u.return=s,u=u.sibling;return s.subtreeFlags|=a,s.childLanes=i,o}function Ej(s,o,i){var a=o.pendingProps;switch(wg(o),o.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return S(o),null;case 1:case 17:return Zf(o.type)&&$f(),S(o),null;case 3:return a=o.stateNode,zh(),E(En),E(_n),Eh(),a.pendingContext&&(a.context=a.pendingContext,a.pendingContext=null),null!==s&&null!==s.child||(Gg(o)?o.flags|=4:null===s||s.memoizedState.isDehydrated&&!(256&o.flags)||(o.flags|=1024,null!==Bn&&(Fj(Bn),Bn=null))),S(o),null;case 5:Bh(o);var u=xh(Qn.current);if(i=o.type,null!==s&&null!=o.stateNode)_s(s,o,i,a),s.ref!==o.ref&&(o.flags|=512,o.flags|=2097152);else{if(!a){if(null===o.stateNode)throw Error(p(166));return S(o),null}if(s=xh(Yn.current),Gg(o)){a=o.stateNode,i=o.type;var _=o.memoizedProps;switch(a[hn]=o,a[dn]=_,s=!!(1&o.mode),i){case"dialog":D("cancel",a),D("close",a);break;case"iframe":case"object":case"embed":D("load",a);break;case"video":case"audio":for(u=0;u<Zr.length;u++)D(Zr[u],a);break;case"source":D("error",a);break;case"img":case"image":case"link":D("error",a),D("load",a);break;case"details":D("toggle",a);break;case"input":Za(a,_),D("invalid",a);break;case"select":a._wrapperState={wasMultiple:!!_.multiple},D("invalid",a);break;case"textarea":hb(a,_),D("invalid",a)}for(var x in ub(i,_),u=null,_)if(_.hasOwnProperty(x)){var C=_[x];"children"===x?"string"==typeof C?a.textContent!==C&&(!0!==_.suppressHydrationWarning&&Af(a.textContent,C,s),u=["children",C]):"number"==typeof C&&a.textContent!==""+C&&(!0!==_.suppressHydrationWarning&&Af(a.textContent,C,s),u=["children",""+C]):w.hasOwnProperty(x)&&null!=C&&"onScroll"===x&&D("scroll",a)}switch(i){case"input":Va(a),db(a,_,!0);break;case"textarea":Va(a),jb(a);break;case"select":case"option":break;default:"function"==typeof _.onClick&&(a.onclick=Bf)}a=u,o.updateQueue=a,null!==a&&(o.flags|=4)}else{x=9===u.nodeType?u:u.ownerDocument,"http://www.w3.org/1999/xhtml"===s&&(s=kb(i)),"http://www.w3.org/1999/xhtml"===s?"script"===i?((s=x.createElement("div")).innerHTML="<script><\/script>",s=s.removeChild(s.firstChild)):"string"==typeof a.is?s=x.createElement(i,{is:a.is}):(s=x.createElement(i),"select"===i&&(x=s,a.multiple?x.multiple=!0:a.size&&(x.size=a.size))):s=x.createElementNS(s,i),s[hn]=o,s[dn]=a,Ss(s,o),o.stateNode=s;e:{switch(x=vb(i,a),i){case"dialog":D("cancel",s),D("close",s),u=a;break;case"iframe":case"object":case"embed":D("load",s),u=a;break;case"video":case"audio":for(u=0;u<Zr.length;u++)D(Zr[u],s);u=a;break;case"source":D("error",s),u=a;break;case"img":case"image":case"link":D("error",s),D("load",s),u=a;break;case"details":D("toggle",s),u=a;break;case"input":Za(s,a),u=Ya(s,a),D("invalid",s);break;case"option":default:u=a;break;case"select":s._wrapperState={wasMultiple:!!a.multiple},u=we({},a,{value:void 0}),D("invalid",s);break;case"textarea":hb(s,a),u=gb(s,a),D("invalid",s)}for(_ in ub(i,u),C=u)if(C.hasOwnProperty(_)){var j=C[_];"style"===_?sb(s,j):"dangerouslySetInnerHTML"===_?null!=(j=j?j.__html:void 0)&&$e(s,j):"children"===_?"string"==typeof j?("textarea"!==i||""!==j)&&ob(s,j):"number"==typeof j&&ob(s,""+j):"suppressContentEditableWarning"!==_&&"suppressHydrationWarning"!==_&&"autoFocus"!==_&&(w.hasOwnProperty(_)?null!=j&&"onScroll"===_&&D("scroll",s):null!=j&&ta(s,_,j,x))}switch(i){case"input":Va(s),db(s,a,!1);break;case"textarea":Va(s),jb(s);break;case"option":null!=a.value&&s.setAttribute("value",""+Sa(a.value));break;case"select":s.multiple=!!a.multiple,null!=(_=a.value)?fb(s,!!a.multiple,_,!1):null!=a.defaultValue&&fb(s,!!a.multiple,a.defaultValue,!0);break;default:"function"==typeof u.onClick&&(s.onclick=Bf)}switch(i){case"button":case"input":case"select":case"textarea":a=!!a.autoFocus;break e;case"img":a=!0;break e;default:a=!1}}a&&(o.flags|=4)}null!==o.ref&&(o.flags|=512,o.flags|=2097152)}return S(o),null;case 6:if(s&&null!=o.stateNode)Es(0,o,s.memoizedProps,a);else{if("string"!=typeof a&&null===o.stateNode)throw Error(p(166));if(i=xh(Qn.current),xh(Yn.current),Gg(o)){if(a=o.stateNode,i=o.memoizedProps,a[hn]=o,(_=a.nodeValue!==i)&&null!==(s=Dn))switch(s.tag){case 3:Af(a.nodeValue,i,!!(1&s.mode));break;case 5:!0!==s.memoizedProps.suppressHydrationWarning&&Af(a.nodeValue,i,!!(1&s.mode))}_&&(o.flags|=4)}else(a=(9===i.nodeType?i:i.ownerDocument).createTextNode(a))[hn]=o,o.stateNode=a}return S(o),null;case 13:if(E(Zn),a=o.memoizedState,null===s||null!==s.memoizedState&&null!==s.memoizedState.dehydrated){if(Fn&&null!==Ln&&1&o.mode&&!(128&o.flags))Hg(),Ig(),o.flags|=98560,_=!1;else if(_=Gg(o),null!==a&&null!==a.dehydrated){if(null===s){if(!_)throw Error(p(318));if(!(_=null!==(_=o.memoizedState)?_.dehydrated:null))throw Error(p(317));_[hn]=o}else Ig(),!(128&o.flags)&&(o.memoizedState=null),o.flags|=4;S(o),_=!1}else null!==Bn&&(Fj(Bn),Bn=null),_=!0;if(!_)return 65536&o.flags?o:null}return 128&o.flags?(o.lanes=i,o):((a=null!==a)!==(null!==s&&null!==s.memoizedState)&&a&&(o.child.flags|=8192,1&o.mode&&(null===s||1&Zn.current?0===Us&&(Us=3):tj())),null!==o.updateQueue&&(o.flags|=4),S(o),null);case 4:return zh(),null===s&&sf(o.stateNode.containerInfo),S(o),null;case 10:return ah(o.type._context),S(o),null;case 19:if(E(Zn),null===(_=o.memoizedState))return S(o),null;if(a=!!(128&o.flags),null===(x=_.rendering))if(a)Dj(_,!1);else{if(0!==Us||null!==s&&128&s.flags)for(s=o.child;null!==s;){if(null!==(x=Ch(s))){for(o.flags|=128,Dj(_,!1),null!==(a=x.updateQueue)&&(o.updateQueue=a,o.flags|=4),o.subtreeFlags=0,a=i,i=o.child;null!==i;)s=a,(_=i).flags&=14680066,null===(x=_.alternate)?(_.childLanes=0,_.lanes=s,_.child=null,_.subtreeFlags=0,_.memoizedProps=null,_.memoizedState=null,_.updateQueue=null,_.dependencies=null,_.stateNode=null):(_.childLanes=x.childLanes,_.lanes=x.lanes,_.child=x.child,_.subtreeFlags=0,_.deletions=null,_.memoizedProps=x.memoizedProps,_.memoizedState=x.memoizedState,_.updateQueue=x.updateQueue,_.type=x.type,s=x.dependencies,_.dependencies=null===s?null:{lanes:s.lanes,firstContext:s.firstContext}),i=i.sibling;return G(Zn,1&Zn.current|2),o.child}s=s.sibling}null!==_.tail&&ht()>Ys&&(o.flags|=128,a=!0,Dj(_,!1),o.lanes=4194304)}else{if(!a)if(null!==(s=Ch(x))){if(o.flags|=128,a=!0,null!==(i=s.updateQueue)&&(o.updateQueue=i,o.flags|=4),Dj(_,!0),null===_.tail&&"hidden"===_.tailMode&&!x.alternate&&!Fn)return S(o),null}else 2*ht()-_.renderingStartTime>Ys&&1073741824!==i&&(o.flags|=128,a=!0,Dj(_,!1),o.lanes=4194304);_.isBackwards?(x.sibling=o.child,o.child=x):(null!==(i=_.last)?i.sibling=x:o.child=x,_.last=x)}return null!==_.tail?(o=_.tail,_.rendering=o,_.tail=o.sibling,_.renderingStartTime=ht(),o.sibling=null,i=Zn.current,G(Zn,a?1&i|2:1&i),o):(S(o),null);case 22:case 23:return Hj(),a=null!==o.memoizedState,null!==s&&null!==s.memoizedState!==a&&(o.flags|=8192),a&&1&o.mode?!!(1073741824&$s)&&(S(o),6&o.subtreeFlags&&(o.flags|=8192)):S(o),null;case 24:case 25:return null}throw Error(p(156,o.tag))}function Ij(s,o){switch(wg(o),o.tag){case 1:return Zf(o.type)&&$f(),65536&(s=o.flags)?(o.flags=-65537&s|128,o):null;case 3:return zh(),E(En),E(_n),Eh(),65536&(s=o.flags)&&!(128&s)?(o.flags=-65537&s|128,o):null;case 5:return Bh(o),null;case 13:if(E(Zn),null!==(s=o.memoizedState)&&null!==s.dehydrated){if(null===o.alternate)throw Error(p(340));Ig()}return 65536&(s=o.flags)?(o.flags=-65537&s|128,o):null;case 19:return E(Zn),null;case 4:return zh(),null;case 10:return ah(o.type._context),null;case 22:case 23:return Hj(),null;default:return null}}Ss=function(s,o){for(var i=o.child;null!==i;){if(5===i.tag||6===i.tag)s.appendChild(i.stateNode);else if(4!==i.tag&&null!==i.child){i.child.return=i,i=i.child;continue}if(i===o)break;for(;null===i.sibling;){if(null===i.return||i.return===o)return;i=i.return}i.sibling.return=i.return,i=i.sibling}},_s=function(s,o,i,a){var u=s.memoizedProps;if(u!==a){s=o.stateNode,xh(Yn.current);var _,x=null;switch(i){case"input":u=Ya(s,u),a=Ya(s,a),x=[];break;case"select":u=we({},u,{value:void 0}),a=we({},a,{value:void 0}),x=[];break;case"textarea":u=gb(s,u),a=gb(s,a),x=[];break;default:"function"!=typeof u.onClick&&"function"==typeof a.onClick&&(s.onclick=Bf)}for(L in ub(i,a),i=null,u)if(!a.hasOwnProperty(L)&&u.hasOwnProperty(L)&&null!=u[L])if("style"===L){var C=u[L];for(_ in C)C.hasOwnProperty(_)&&(i||(i={}),i[_]="")}else"dangerouslySetInnerHTML"!==L&&"children"!==L&&"suppressContentEditableWarning"!==L&&"suppressHydrationWarning"!==L&&"autoFocus"!==L&&(w.hasOwnProperty(L)?x||(x=[]):(x=x||[]).push(L,null));for(L in a){var j=a[L];if(C=null!=u?u[L]:void 0,a.hasOwnProperty(L)&&j!==C&&(null!=j||null!=C))if("style"===L)if(C){for(_ in C)!C.hasOwnProperty(_)||j&&j.hasOwnProperty(_)||(i||(i={}),i[_]="");for(_ in j)j.hasOwnProperty(_)&&C[_]!==j[_]&&(i||(i={}),i[_]=j[_])}else i||(x||(x=[]),x.push(L,i)),i=j;else"dangerouslySetInnerHTML"===L?(j=j?j.__html:void 0,C=C?C.__html:void 0,null!=j&&C!==j&&(x=x||[]).push(L,j)):"children"===L?"string"!=typeof j&&"number"!=typeof j||(x=x||[]).push(L,""+j):"suppressContentEditableWarning"!==L&&"suppressHydrationWarning"!==L&&(w.hasOwnProperty(L)?(null!=j&&"onScroll"===L&&D("scroll",s),x||C===j||(x=[])):(x=x||[]).push(L,j))}i&&(x=x||[]).push("style",i);var L=x;(o.updateQueue=L)&&(o.flags|=4)}},Es=function(s,o,i,a){i!==a&&(o.flags|=4)};var xs=!1,ks=!1,Os="function"==typeof WeakSet?WeakSet:Set,As=null;function Lj(s,o){var i=s.ref;if(null!==i)if("function"==typeof i)try{i(null)}catch(i){W(s,o,i)}else i.current=null}function Mj(s,o,i){try{i()}catch(i){W(s,o,i)}}var Cs=!1;function Pj(s,o,i){var a=o.updateQueue;if(null!==(a=null!==a?a.lastEffect:null)){var u=a=a.next;do{if((u.tag&s)===s){var _=u.destroy;u.destroy=void 0,void 0!==_&&Mj(o,i,_)}u=u.next}while(u!==a)}}function Qj(s,o){if(null!==(o=null!==(o=o.updateQueue)?o.lastEffect:null)){var i=o=o.next;do{if((i.tag&s)===s){var a=i.create;i.destroy=a()}i=i.next}while(i!==o)}}function Rj(s){var o=s.ref;if(null!==o){var i=s.stateNode;s.tag,s=i,"function"==typeof o?o(s):o.current=s}}function Sj(s){var o=s.alternate;null!==o&&(s.alternate=null,Sj(o)),s.child=null,s.deletions=null,s.sibling=null,5===s.tag&&(null!==(o=s.stateNode)&&(delete o[hn],delete o[dn],delete o[mn],delete o[gn],delete o[yn])),s.stateNode=null,s.return=null,s.dependencies=null,s.memoizedProps=null,s.memoizedState=null,s.pendingProps=null,s.stateNode=null,s.updateQueue=null}function Tj(s){return 5===s.tag||3===s.tag||4===s.tag}function Uj(s){e:for(;;){for(;null===s.sibling;){if(null===s.return||Tj(s.return))return null;s=s.return}for(s.sibling.return=s.return,s=s.sibling;5!==s.tag&&6!==s.tag&&18!==s.tag;){if(2&s.flags)continue e;if(null===s.child||4===s.tag)continue e;s.child.return=s,s=s.child}if(!(2&s.flags))return s.stateNode}}function Vj(s,o,i){var a=s.tag;if(5===a||6===a)s=s.stateNode,o?8===i.nodeType?i.parentNode.insertBefore(s,o):i.insertBefore(s,o):(8===i.nodeType?(o=i.parentNode).insertBefore(s,i):(o=i).appendChild(s),null!=(i=i._reactRootContainer)||null!==o.onclick||(o.onclick=Bf));else if(4!==a&&null!==(s=s.child))for(Vj(s,o,i),s=s.sibling;null!==s;)Vj(s,o,i),s=s.sibling}function Wj(s,o,i){var a=s.tag;if(5===a||6===a)s=s.stateNode,o?i.insertBefore(s,o):i.appendChild(s);else if(4!==a&&null!==(s=s.child))for(Wj(s,o,i),s=s.sibling;null!==s;)Wj(s,o,i),s=s.sibling}var js=null,Ps=!1;function Yj(s,o,i){for(i=i.child;null!==i;)Zj(s,o,i),i=i.sibling}function Zj(s,o,i){if(_t&&"function"==typeof _t.onCommitFiberUnmount)try{_t.onCommitFiberUnmount(St,i)}catch(s){}switch(i.tag){case 5:ks||Lj(i,o);case 6:var a=js,u=Ps;js=null,Yj(s,o,i),Ps=u,null!==(js=a)&&(Ps?(s=js,i=i.stateNode,8===s.nodeType?s.parentNode.removeChild(i):s.removeChild(i)):js.removeChild(i.stateNode));break;case 18:null!==js&&(Ps?(s=js,i=i.stateNode,8===s.nodeType?Kf(s.parentNode,i):1===s.nodeType&&Kf(s,i),bd(s)):Kf(js,i.stateNode));break;case 4:a=js,u=Ps,js=i.stateNode.containerInfo,Ps=!0,Yj(s,o,i),js=a,Ps=u;break;case 0:case 11:case 14:case 15:if(!ks&&(null!==(a=i.updateQueue)&&null!==(a=a.lastEffect))){u=a=a.next;do{var _=u,w=_.destroy;_=_.tag,void 0!==w&&(2&_||4&_)&&Mj(i,o,w),u=u.next}while(u!==a)}Yj(s,o,i);break;case 1:if(!ks&&(Lj(i,o),"function"==typeof(a=i.stateNode).componentWillUnmount))try{a.props=i.memoizedProps,a.state=i.memoizedState,a.componentWillUnmount()}catch(s){W(i,o,s)}Yj(s,o,i);break;case 21:Yj(s,o,i);break;case 22:1&i.mode?(ks=(a=ks)||null!==i.memoizedState,Yj(s,o,i),ks=a):Yj(s,o,i);break;default:Yj(s,o,i)}}function ak(s){var o=s.updateQueue;if(null!==o){s.updateQueue=null;var i=s.stateNode;null===i&&(i=s.stateNode=new Os),o.forEach((function(o){var a=bk.bind(null,s,o);i.has(o)||(i.add(o),o.then(a,a))}))}}function ck(s,o){var i=o.deletions;if(null!==i)for(var a=0;a<i.length;a++){var u=i[a];try{var _=s,w=o,x=w;e:for(;null!==x;){switch(x.tag){case 5:js=x.stateNode,Ps=!1;break e;case 3:case 4:js=x.stateNode.containerInfo,Ps=!0;break e}x=x.return}if(null===js)throw Error(p(160));Zj(_,w,u),js=null,Ps=!1;var C=u.alternate;null!==C&&(C.return=null),u.return=null}catch(s){W(u,o,s)}}if(12854&o.subtreeFlags)for(o=o.child;null!==o;)dk(o,s),o=o.sibling}function dk(s,o){var i=s.alternate,a=s.flags;switch(s.tag){case 0:case 11:case 14:case 15:if(ck(o,s),ek(s),4&a){try{Pj(3,s,s.return),Qj(3,s)}catch(o){W(s,s.return,o)}try{Pj(5,s,s.return)}catch(o){W(s,s.return,o)}}break;case 1:ck(o,s),ek(s),512&a&&null!==i&&Lj(i,i.return);break;case 5:if(ck(o,s),ek(s),512&a&&null!==i&&Lj(i,i.return),32&s.flags){var u=s.stateNode;try{ob(u,"")}catch(o){W(s,s.return,o)}}if(4&a&&null!=(u=s.stateNode)){var _=s.memoizedProps,w=null!==i?i.memoizedProps:_,x=s.type,C=s.updateQueue;if(s.updateQueue=null,null!==C)try{"input"===x&&"radio"===_.type&&null!=_.name&&ab(u,_),vb(x,w);var j=vb(x,_);for(w=0;w<C.length;w+=2){var L=C[w],B=C[w+1];"style"===L?sb(u,B):"dangerouslySetInnerHTML"===L?$e(u,B):"children"===L?ob(u,B):ta(u,L,B,j)}switch(x){case"input":bb(u,_);break;case"textarea":ib(u,_);break;case"select":var $=u._wrapperState.wasMultiple;u._wrapperState.wasMultiple=!!_.multiple;var U=_.value;null!=U?fb(u,!!_.multiple,U,!1):$!==!!_.multiple&&(null!=_.defaultValue?fb(u,!!_.multiple,_.defaultValue,!0):fb(u,!!_.multiple,_.multiple?[]:"",!1))}u[dn]=_}catch(o){W(s,s.return,o)}}break;case 6:if(ck(o,s),ek(s),4&a){if(null===s.stateNode)throw Error(p(162));u=s.stateNode,_=s.memoizedProps;try{u.nodeValue=_}catch(o){W(s,s.return,o)}}break;case 3:if(ck(o,s),ek(s),4&a&&null!==i&&i.memoizedState.isDehydrated)try{bd(o.containerInfo)}catch(o){W(s,s.return,o)}break;case 4:default:ck(o,s),ek(s);break;case 13:ck(o,s),ek(s),8192&(u=s.child).flags&&(_=null!==u.memoizedState,u.stateNode.isHidden=_,!_||null!==u.alternate&&null!==u.alternate.memoizedState||(Gs=ht())),4&a&&ak(s);break;case 22:if(L=null!==i&&null!==i.memoizedState,1&s.mode?(ks=(j=ks)||L,ck(o,s),ks=j):ck(o,s),ek(s),8192&a){if(j=null!==s.memoizedState,(s.stateNode.isHidden=j)&&!L&&1&s.mode)for(As=s,L=s.child;null!==L;){for(B=As=L;null!==As;){switch(U=($=As).child,$.tag){case 0:case 11:case 14:case 15:Pj(4,$,$.return);break;case 1:Lj($,$.return);var V=$.stateNode;if("function"==typeof V.componentWillUnmount){a=$,i=$.return;try{o=a,V.props=o.memoizedProps,V.state=o.memoizedState,V.componentWillUnmount()}catch(s){W(a,i,s)}}break;case 5:Lj($,$.return);break;case 22:if(null!==$.memoizedState){gk(B);continue}}null!==U?(U.return=$,As=U):gk(B)}L=L.sibling}e:for(L=null,B=s;;){if(5===B.tag){if(null===L){L=B;try{u=B.stateNode,j?"function"==typeof(_=u.style).setProperty?_.setProperty("display","none","important"):_.display="none":(x=B.stateNode,w=null!=(C=B.memoizedProps.style)&&C.hasOwnProperty("display")?C.display:null,x.style.display=rb("display",w))}catch(o){W(s,s.return,o)}}}else if(6===B.tag){if(null===L)try{B.stateNode.nodeValue=j?"":B.memoizedProps}catch(o){W(s,s.return,o)}}else if((22!==B.tag&&23!==B.tag||null===B.memoizedState||B===s)&&null!==B.child){B.child.return=B,B=B.child;continue}if(B===s)break e;for(;null===B.sibling;){if(null===B.return||B.return===s)break e;L===B&&(L=null),B=B.return}L===B&&(L=null),B.sibling.return=B.return,B=B.sibling}}break;case 19:ck(o,s),ek(s),4&a&&ak(s);case 21:}}function ek(s){var o=s.flags;if(2&o){try{e:{for(var i=s.return;null!==i;){if(Tj(i)){var a=i;break e}i=i.return}throw Error(p(160))}switch(a.tag){case 5:var u=a.stateNode;32&a.flags&&(ob(u,""),a.flags&=-33),Wj(s,Uj(s),u);break;case 3:case 4:var _=a.stateNode.containerInfo;Vj(s,Uj(s),_);break;default:throw Error(p(161))}}catch(o){W(s,s.return,o)}s.flags&=-3}4096&o&&(s.flags&=-4097)}function hk(s,o,i){As=s,ik(s,o,i)}function ik(s,o,i){for(var a=!!(1&s.mode);null!==As;){var u=As,_=u.child;if(22===u.tag&&a){var w=null!==u.memoizedState||xs;if(!w){var x=u.alternate,C=null!==x&&null!==x.memoizedState||ks;x=xs;var j=ks;if(xs=w,(ks=C)&&!j)for(As=u;null!==As;)C=(w=As).child,22===w.tag&&null!==w.memoizedState?jk(u):null!==C?(C.return=w,As=C):jk(u);for(;null!==_;)As=_,ik(_,o,i),_=_.sibling;As=u,xs=x,ks=j}kk(s)}else 8772&u.subtreeFlags&&null!==_?(_.return=u,As=_):kk(s)}}function kk(s){for(;null!==As;){var o=As;if(8772&o.flags){var i=o.alternate;try{if(8772&o.flags)switch(o.tag){case 0:case 11:case 15:ks||Qj(5,o);break;case 1:var a=o.stateNode;if(4&o.flags&&!ks)if(null===i)a.componentDidMount();else{var u=o.elementType===o.type?i.memoizedProps:Ci(o.type,i.memoizedProps);a.componentDidUpdate(u,i.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}var _=o.updateQueue;null!==_&&sh(o,_,a);break;case 3:var w=o.updateQueue;if(null!==w){if(i=null,null!==o.child)switch(o.child.tag){case 5:case 1:i=o.child.stateNode}sh(o,w,i)}break;case 5:var x=o.stateNode;if(null===i&&4&o.flags){i=x;var C=o.memoizedProps;switch(o.type){case"button":case"input":case"select":case"textarea":C.autoFocus&&i.focus();break;case"img":C.src&&(i.src=C.src)}}break;case 6:case 4:case 12:case 19:case 17:case 21:case 22:case 23:case 25:break;case 13:if(null===o.memoizedState){var j=o.alternate;if(null!==j){var L=j.memoizedState;if(null!==L){var B=L.dehydrated;null!==B&&bd(B)}}}break;default:throw Error(p(163))}ks||512&o.flags&&Rj(o)}catch(s){W(o,o.return,s)}}if(o===s){As=null;break}if(null!==(i=o.sibling)){i.return=o.return,As=i;break}As=o.return}}function gk(s){for(;null!==As;){var o=As;if(o===s){As=null;break}var i=o.sibling;if(null!==i){i.return=o.return,As=i;break}As=o.return}}function jk(s){for(;null!==As;){var o=As;try{switch(o.tag){case 0:case 11:case 15:var i=o.return;try{Qj(4,o)}catch(s){W(o,i,s)}break;case 1:var a=o.stateNode;if("function"==typeof a.componentDidMount){var u=o.return;try{a.componentDidMount()}catch(s){W(o,u,s)}}var _=o.return;try{Rj(o)}catch(s){W(o,_,s)}break;case 5:var w=o.return;try{Rj(o)}catch(s){W(o,w,s)}}}catch(s){W(o,o.return,s)}if(o===s){As=null;break}var x=o.sibling;if(null!==x){x.return=o.return,As=x;break}As=o.return}}var Is,Ts=Math.ceil,Ns=V.ReactCurrentDispatcher,Ms=V.ReactCurrentOwner,Rs=V.ReactCurrentBatchConfig,Ds=0,Ls=null,Fs=null,Bs=0,$s=0,qs=Uf(0),Us=0,Vs=null,zs=0,Ws=0,Js=0,Hs=null,Ks=null,Gs=0,Ys=1/0,Xs=null,Qs=!1,Zs=null,eo=null,to=!1,ro=null,no=0,so=0,oo=null,io=-1,ao=0;function R(){return 6&Ds?ht():-1!==io?io:io=ht()}function yi(s){return 1&s.mode?2&Ds&&0!==Bs?Bs&-Bs:null!==$n.transition?(0===ao&&(ao=yc()),ao):0!==(s=At)?s:s=void 0===(s=window.event)?16:jd(s.type):1}function gi(s,o,i,a){if(50<so)throw so=0,oo=null,Error(p(185));Ac(s,i,a),2&Ds&&s===Ls||(s===Ls&&(!(2&Ds)&&(Ws|=i),4===Us&&Ck(s,Bs)),Dk(s,a),1===i&&0===Ds&&!(1&o.mode)&&(Ys=ht()+500,kn&&jg()))}function Dk(s,o){var i=s.callbackNode;!function wc(s,o){for(var i=s.suspendedLanes,a=s.pingedLanes,u=s.expirationTimes,_=s.pendingLanes;0<_;){var w=31-Et(_),x=1<<w,C=u[w];-1===C?x&i&&!(x&a)||(u[w]=vc(x,o)):C<=o&&(s.expiredLanes|=x),_&=~x}}(s,o);var a=uc(s,s===Ls?Bs:0);if(0===a)null!==i&&lt(i),s.callbackNode=null,s.callbackPriority=0;else if(o=a&-a,s.callbackPriority!==o){if(null!=i&&lt(i),1===o)0===s.tag?function ig(s){kn=!0,hg(s)}(Ek.bind(null,s)):hg(Ek.bind(null,s)),un((function(){!(6&Ds)&&jg()})),i=null;else{switch(Dc(a)){case 1:i=mt;break;case 4:i=gt;break;case 16:default:i=yt;break;case 536870912:i=bt}i=Fk(i,Gk.bind(null,s))}s.callbackPriority=o,s.callbackNode=i}}function Gk(s,o){if(io=-1,ao=0,6&Ds)throw Error(p(327));var i=s.callbackNode;if(Hk()&&s.callbackNode!==i)return null;var a=uc(s,s===Ls?Bs:0);if(0===a)return null;if(30&a||a&s.expiredLanes||o)o=Ik(s,a);else{o=a;var u=Ds;Ds|=2;var _=Jk();for(Ls===s&&Bs===o||(Xs=null,Ys=ht()+500,Kk(s,o));;)try{Lk();break}catch(o){Mk(s,o)}$g(),Ns.current=_,Ds=u,null!==Fs?o=0:(Ls=null,Bs=0,o=Us)}if(0!==o){if(2===o&&(0!==(u=xc(s))&&(a=u,o=Nk(s,u))),1===o)throw i=Vs,Kk(s,0),Ck(s,a),Dk(s,ht()),i;if(6===o)Ck(s,a);else{if(u=s.current.alternate,!(30&a||function Ok(s){for(var o=s;;){if(16384&o.flags){var i=o.updateQueue;if(null!==i&&null!==(i=i.stores))for(var a=0;a<i.length;a++){var u=i[a],_=u.getSnapshot;u=u.value;try{if(!Dr(_(),u))return!1}catch(s){return!1}}}if(i=o.child,16384&o.subtreeFlags&&null!==i)i.return=o,o=i;else{if(o===s)break;for(;null===o.sibling;){if(null===o.return||o.return===s)return!0;o=o.return}o.sibling.return=o.return,o=o.sibling}}return!0}(u)||(o=Ik(s,a),2===o&&(_=xc(s),0!==_&&(a=_,o=Nk(s,_))),1!==o)))throw i=Vs,Kk(s,0),Ck(s,a),Dk(s,ht()),i;switch(s.finishedWork=u,s.finishedLanes=a,o){case 0:case 1:throw Error(p(345));case 2:case 5:Pk(s,Ks,Xs);break;case 3:if(Ck(s,a),(130023424&a)===a&&10<(o=Gs+500-ht())){if(0!==uc(s,0))break;if(((u=s.suspendedLanes)&a)!==a){R(),s.pingedLanes|=s.suspendedLanes&u;break}s.timeoutHandle=an(Pk.bind(null,s,Ks,Xs),o);break}Pk(s,Ks,Xs);break;case 4:if(Ck(s,a),(4194240&a)===a)break;for(o=s.eventTimes,u=-1;0<a;){var w=31-Et(a);_=1<<w,(w=o[w])>u&&(u=w),a&=~_}if(a=u,10<(a=(120>(a=ht()-a)?120:480>a?480:1080>a?1080:1920>a?1920:3e3>a?3e3:4320>a?4320:1960*Ts(a/1960))-a)){s.timeoutHandle=an(Pk.bind(null,s,Ks,Xs),a);break}Pk(s,Ks,Xs);break;default:throw Error(p(329))}}}return Dk(s,ht()),s.callbackNode===i?Gk.bind(null,s):null}function Nk(s,o){var i=Hs;return s.current.memoizedState.isDehydrated&&(Kk(s,o).flags|=256),2!==(s=Ik(s,o))&&(o=Ks,Ks=i,null!==o&&Fj(o)),s}function Fj(s){null===Ks?Ks=s:Ks.push.apply(Ks,s)}function Ck(s,o){for(o&=~Js,o&=~Ws,s.suspendedLanes|=o,s.pingedLanes&=~o,s=s.expirationTimes;0<o;){var i=31-Et(o),a=1<<i;s[i]=-1,o&=~a}}function Ek(s){if(6&Ds)throw Error(p(327));Hk();var o=uc(s,0);if(!(1&o))return Dk(s,ht()),null;var i=Ik(s,o);if(0!==s.tag&&2===i){var a=xc(s);0!==a&&(o=a,i=Nk(s,a))}if(1===i)throw i=Vs,Kk(s,0),Ck(s,o),Dk(s,ht()),i;if(6===i)throw Error(p(345));return s.finishedWork=s.current.alternate,s.finishedLanes=o,Pk(s,Ks,Xs),Dk(s,ht()),null}function Qk(s,o){var i=Ds;Ds|=1;try{return s(o)}finally{0===(Ds=i)&&(Ys=ht()+500,kn&&jg())}}function Rk(s){null!==ro&&0===ro.tag&&!(6&Ds)&&Hk();var o=Ds;Ds|=1;var i=Rs.transition,a=At;try{if(Rs.transition=null,At=1,s)return s()}finally{At=a,Rs.transition=i,!(6&(Ds=o))&&jg()}}function Hj(){$s=qs.current,E(qs)}function Kk(s,o){s.finishedWork=null,s.finishedLanes=0;var i=s.timeoutHandle;if(-1!==i&&(s.timeoutHandle=-1,cn(i)),null!==Fs)for(i=Fs.return;null!==i;){var a=i;switch(wg(a),a.tag){case 1:null!=(a=a.type.childContextTypes)&&$f();break;case 3:zh(),E(En),E(_n),Eh();break;case 5:Bh(a);break;case 4:zh();break;case 13:case 19:E(Zn);break;case 10:ah(a.type._context);break;case 22:case 23:Hj()}i=i.return}if(Ls=s,Fs=s=Pg(s.current,null),Bs=$s=o,Us=0,Vs=null,Js=Ws=zs=0,Ks=Hs=null,null!==Hn){for(o=0;o<Hn.length;o++)if(null!==(a=(i=Hn[o]).interleaved)){i.interleaved=null;var u=a.next,_=i.pending;if(null!==_){var w=_.next;_.next=u,a.next=w}i.pending=a}Hn=null}return s}function Mk(s,o){for(;;){var i=Fs;try{if($g(),ts.current=hs,cs){for(var a=ss.memoizedState;null!==a;){var u=a.queue;null!==u&&(u.pending=null),a=a.next}cs=!1}if(ns=0,as=os=ss=null,ls=!1,us=0,Ms.current=null,null===i||null===i.return){Us=1,Vs=o,Fs=null;break}e:{var _=s,w=i.return,x=i,C=o;if(o=Bs,x.flags|=32768,null!==C&&"object"==typeof C&&"function"==typeof C.then){var j=C,L=x,B=L.tag;if(!(1&L.mode||0!==B&&11!==B&&15!==B)){var $=L.alternate;$?(L.updateQueue=$.updateQueue,L.memoizedState=$.memoizedState,L.lanes=$.lanes):(L.updateQueue=null,L.memoizedState=null)}var U=Ui(w);if(null!==U){U.flags&=-257,Vi(U,w,x,0,o),1&U.mode&&Si(_,j,o),C=j;var V=(o=U).updateQueue;if(null===V){var z=new Set;z.add(C),o.updateQueue=z}else V.add(C);break e}if(!(1&o)){Si(_,j,o),tj();break e}C=Error(p(426))}else if(Fn&&1&x.mode){var Y=Ui(w);if(null!==Y){!(65536&Y.flags)&&(Y.flags|=256),Vi(Y,w,x,0,o),Jg(Ji(C,x));break e}}_=C=Ji(C,x),4!==Us&&(Us=2),null===Hs?Hs=[_]:Hs.push(_),_=w;do{switch(_.tag){case 3:_.flags|=65536,o&=-o,_.lanes|=o,ph(_,Ni(0,C,o));break e;case 1:x=C;var Z=_.type,ee=_.stateNode;if(!(128&_.flags||"function"!=typeof Z.getDerivedStateFromError&&(null===ee||"function"!=typeof ee.componentDidCatch||null!==eo&&eo.has(ee)))){_.flags|=65536,o&=-o,_.lanes|=o,ph(_,Qi(_,x,o));break e}}_=_.return}while(null!==_)}Sk(i)}catch(s){o=s,Fs===i&&null!==i&&(Fs=i=i.return);continue}break}}function Jk(){var s=Ns.current;return Ns.current=hs,null===s?hs:s}function tj(){0!==Us&&3!==Us&&2!==Us||(Us=4),null===Ls||!(268435455&zs)&&!(268435455&Ws)||Ck(Ls,Bs)}function Ik(s,o){var i=Ds;Ds|=2;var a=Jk();for(Ls===s&&Bs===o||(Xs=null,Kk(s,o));;)try{Tk();break}catch(o){Mk(s,o)}if($g(),Ds=i,Ns.current=a,null!==Fs)throw Error(p(261));return Ls=null,Bs=0,Us}function Tk(){for(;null!==Fs;)Uk(Fs)}function Lk(){for(;null!==Fs&&!ut();)Uk(Fs)}function Uk(s){var o=Is(s.alternate,s,$s);s.memoizedProps=s.pendingProps,null===o?Sk(s):Fs=o,Ms.current=null}function Sk(s){var o=s;do{var i=o.alternate;if(s=o.return,32768&o.flags){if(null!==(i=Ij(i,o)))return i.flags&=32767,void(Fs=i);if(null===s)return Us=6,void(Fs=null);s.flags|=32768,s.subtreeFlags=0,s.deletions=null}else if(null!==(i=Ej(i,o,$s)))return void(Fs=i);if(null!==(o=o.sibling))return void(Fs=o);Fs=o=s}while(null!==o);0===Us&&(Us=5)}function Pk(s,o,i){var a=At,u=Rs.transition;try{Rs.transition=null,At=1,function Wk(s,o,i,a){do{Hk()}while(null!==ro);if(6&Ds)throw Error(p(327));i=s.finishedWork;var u=s.finishedLanes;if(null===i)return null;if(s.finishedWork=null,s.finishedLanes=0,i===s.current)throw Error(p(177));s.callbackNode=null,s.callbackPriority=0;var _=i.lanes|i.childLanes;if(function Bc(s,o){var i=s.pendingLanes&~o;s.pendingLanes=o,s.suspendedLanes=0,s.pingedLanes=0,s.expiredLanes&=o,s.mutableReadLanes&=o,s.entangledLanes&=o,o=s.entanglements;var a=s.eventTimes;for(s=s.expirationTimes;0<i;){var u=31-Et(i),_=1<<u;o[u]=0,a[u]=-1,s[u]=-1,i&=~_}}(s,_),s===Ls&&(Fs=Ls=null,Bs=0),!(2064&i.subtreeFlags)&&!(2064&i.flags)||to||(to=!0,Fk(yt,(function(){return Hk(),null}))),_=!!(15990&i.flags),!!(15990&i.subtreeFlags)||_){_=Rs.transition,Rs.transition=null;var w=At;At=1;var x=Ds;Ds|=4,Ms.current=null,function Oj(s,o){if(sn=Vt,Ne(s=Me())){if("selectionStart"in s)var i={start:s.selectionStart,end:s.selectionEnd};else e:{var a=(i=(i=s.ownerDocument)&&i.defaultView||window).getSelection&&i.getSelection();if(a&&0!==a.rangeCount){i=a.anchorNode;var u=a.anchorOffset,_=a.focusNode;a=a.focusOffset;try{i.nodeType,_.nodeType}catch(s){i=null;break e}var w=0,x=-1,C=-1,j=0,L=0,B=s,$=null;t:for(;;){for(var U;B!==i||0!==u&&3!==B.nodeType||(x=w+u),B!==_||0!==a&&3!==B.nodeType||(C=w+a),3===B.nodeType&&(w+=B.nodeValue.length),null!==(U=B.firstChild);)$=B,B=U;for(;;){if(B===s)break t;if($===i&&++j===u&&(x=w),$===_&&++L===a&&(C=w),null!==(U=B.nextSibling))break;$=(B=$).parentNode}B=U}i=-1===x||-1===C?null:{start:x,end:C}}else i=null}i=i||{start:0,end:0}}else i=null;for(on={focusedElem:s,selectionRange:i},Vt=!1,As=o;null!==As;)if(s=(o=As).child,1028&o.subtreeFlags&&null!==s)s.return=o,As=s;else for(;null!==As;){o=As;try{var V=o.alternate;if(1024&o.flags)switch(o.tag){case 0:case 11:case 15:case 5:case 6:case 4:case 17:break;case 1:if(null!==V){var z=V.memoizedProps,Y=V.memoizedState,Z=o.stateNode,ee=Z.getSnapshotBeforeUpdate(o.elementType===o.type?z:Ci(o.type,z),Y);Z.__reactInternalSnapshotBeforeUpdate=ee}break;case 3:var ie=o.stateNode.containerInfo;1===ie.nodeType?ie.textContent="":9===ie.nodeType&&ie.documentElement&&ie.removeChild(ie.documentElement);break;default:throw Error(p(163))}}catch(s){W(o,o.return,s)}if(null!==(s=o.sibling)){s.return=o.return,As=s;break}As=o.return}return V=Cs,Cs=!1,V}(s,i),dk(i,s),Oe(on),Vt=!!sn,on=sn=null,s.current=i,hk(i,s,u),pt(),Ds=x,At=w,Rs.transition=_}else s.current=i;if(to&&(to=!1,ro=s,no=u),_=s.pendingLanes,0===_&&(eo=null),function mc(s){if(_t&&"function"==typeof _t.onCommitFiberRoot)try{_t.onCommitFiberRoot(St,s,void 0,!(128&~s.current.flags))}catch(s){}}(i.stateNode),Dk(s,ht()),null!==o)for(a=s.onRecoverableError,i=0;i<o.length;i++)u=o[i],a(u.value,{componentStack:u.stack,digest:u.digest});if(Qs)throw Qs=!1,s=Zs,Zs=null,s;return!!(1&no)&&0!==s.tag&&Hk(),_=s.pendingLanes,1&_?s===oo?so++:(so=0,oo=s):so=0,jg(),null}(s,o,i,a)}finally{Rs.transition=u,At=a}return null}function Hk(){if(null!==ro){var s=Dc(no),o=Rs.transition,i=At;try{if(Rs.transition=null,At=16>s?16:s,null===ro)var a=!1;else{if(s=ro,ro=null,no=0,6&Ds)throw Error(p(331));var u=Ds;for(Ds|=4,As=s.current;null!==As;){var _=As,w=_.child;if(16&As.flags){var x=_.deletions;if(null!==x){for(var C=0;C<x.length;C++){var j=x[C];for(As=j;null!==As;){var L=As;switch(L.tag){case 0:case 11:case 15:Pj(8,L,_)}var B=L.child;if(null!==B)B.return=L,As=B;else for(;null!==As;){var $=(L=As).sibling,U=L.return;if(Sj(L),L===j){As=null;break}if(null!==$){$.return=U,As=$;break}As=U}}}var V=_.alternate;if(null!==V){var z=V.child;if(null!==z){V.child=null;do{var Y=z.sibling;z.sibling=null,z=Y}while(null!==z)}}As=_}}if(2064&_.subtreeFlags&&null!==w)w.return=_,As=w;else e:for(;null!==As;){if(2048&(_=As).flags)switch(_.tag){case 0:case 11:case 15:Pj(9,_,_.return)}var Z=_.sibling;if(null!==Z){Z.return=_.return,As=Z;break e}As=_.return}}var ee=s.current;for(As=ee;null!==As;){var ie=(w=As).child;if(2064&w.subtreeFlags&&null!==ie)ie.return=w,As=ie;else e:for(w=ee;null!==As;){if(2048&(x=As).flags)try{switch(x.tag){case 0:case 11:case 15:Qj(9,x)}}catch(s){W(x,x.return,s)}if(x===w){As=null;break e}var ae=x.sibling;if(null!==ae){ae.return=x.return,As=ae;break e}As=x.return}}if(Ds=u,jg(),_t&&"function"==typeof _t.onPostCommitFiberRoot)try{_t.onPostCommitFiberRoot(St,s)}catch(s){}a=!0}return a}finally{At=i,Rs.transition=o}}return!1}function Xk(s,o,i){s=nh(s,o=Ni(0,o=Ji(i,o),1),1),o=R(),null!==s&&(Ac(s,1,o),Dk(s,o))}function W(s,o,i){if(3===s.tag)Xk(s,s,i);else for(;null!==o;){if(3===o.tag){Xk(o,s,i);break}if(1===o.tag){var a=o.stateNode;if("function"==typeof o.type.getDerivedStateFromError||"function"==typeof a.componentDidCatch&&(null===eo||!eo.has(a))){o=nh(o,s=Qi(o,s=Ji(i,s),1),1),s=R(),null!==o&&(Ac(o,1,s),Dk(o,s));break}}o=o.return}}function Ti(s,o,i){var a=s.pingCache;null!==a&&a.delete(o),o=R(),s.pingedLanes|=s.suspendedLanes&i,Ls===s&&(Bs&i)===i&&(4===Us||3===Us&&(130023424&Bs)===Bs&&500>ht()-Gs?Kk(s,0):Js|=i),Dk(s,o)}function Yk(s,o){0===o&&(1&s.mode?(o=Ot,!(130023424&(Ot<<=1))&&(Ot=4194304)):o=1);var i=R();null!==(s=ih(s,o))&&(Ac(s,o,i),Dk(s,i))}function uj(s){var o=s.memoizedState,i=0;null!==o&&(i=o.retryLane),Yk(s,i)}function bk(s,o){var i=0;switch(s.tag){case 13:var a=s.stateNode,u=s.memoizedState;null!==u&&(i=u.retryLane);break;case 19:a=s.stateNode;break;default:throw Error(p(314))}null!==a&&a.delete(o),Yk(s,i)}function Fk(s,o){return ct(s,o)}function $k(s,o,i,a){this.tag=s,this.key=i,this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null,this.index=0,this.ref=null,this.pendingProps=o,this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null,this.mode=a,this.subtreeFlags=this.flags=0,this.deletions=null,this.childLanes=this.lanes=0,this.alternate=null}function Bg(s,o,i,a){return new $k(s,o,i,a)}function aj(s){return!(!(s=s.prototype)||!s.isReactComponent)}function Pg(s,o){var i=s.alternate;return null===i?((i=Bg(s.tag,o,s.key,s.mode)).elementType=s.elementType,i.type=s.type,i.stateNode=s.stateNode,i.alternate=s,s.alternate=i):(i.pendingProps=o,i.type=s.type,i.flags=0,i.subtreeFlags=0,i.deletions=null),i.flags=14680064&s.flags,i.childLanes=s.childLanes,i.lanes=s.lanes,i.child=s.child,i.memoizedProps=s.memoizedProps,i.memoizedState=s.memoizedState,i.updateQueue=s.updateQueue,o=s.dependencies,i.dependencies=null===o?null:{lanes:o.lanes,firstContext:o.firstContext},i.sibling=s.sibling,i.index=s.index,i.ref=s.ref,i}function Rg(s,o,i,a,u,_){var w=2;if(a=s,"function"==typeof s)aj(s)&&(w=1);else if("string"==typeof s)w=5;else e:switch(s){case Z:return Tg(i.children,u,_,o);case ee:w=8,u|=8;break;case ie:return(s=Bg(12,i,o,2|u)).elementType=ie,s.lanes=_,s;case pe:return(s=Bg(13,i,o,u)).elementType=pe,s.lanes=_,s;case de:return(s=Bg(19,i,o,u)).elementType=de,s.lanes=_,s;case be:return pj(i,u,_,o);default:if("object"==typeof s&&null!==s)switch(s.$$typeof){case ae:w=10;break e;case ce:w=9;break e;case le:w=11;break e;case fe:w=14;break e;case ye:w=16,a=null;break e}throw Error(p(130,null==s?s:typeof s,""))}return(o=Bg(w,i,o,u)).elementType=s,o.type=a,o.lanes=_,o}function Tg(s,o,i,a){return(s=Bg(7,s,a,o)).lanes=i,s}function pj(s,o,i,a){return(s=Bg(22,s,a,o)).elementType=be,s.lanes=i,s.stateNode={isHidden:!1},s}function Qg(s,o,i){return(s=Bg(6,s,null,o)).lanes=i,s}function Sg(s,o,i){return(o=Bg(4,null!==s.children?s.children:[],s.key,o)).lanes=i,o.stateNode={containerInfo:s.containerInfo,pendingChildren:null,implementation:s.implementation},o}function al(s,o,i,a,u){this.tag=o,this.containerInfo=s,this.finishedWork=this.pingCache=this.current=this.pendingChildren=null,this.timeoutHandle=-1,this.callbackNode=this.pendingContext=this.context=null,this.callbackPriority=0,this.eventTimes=zc(0),this.expirationTimes=zc(-1),this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0,this.entanglements=zc(0),this.identifierPrefix=a,this.onRecoverableError=u,this.mutableSourceEagerHydrationData=null}function bl(s,o,i,a,u,_,w,x,C){return s=new al(s,o,i,x,C),1===o?(o=1,!0===_&&(o|=8)):o=0,_=Bg(3,null,null,o),s.current=_,_.stateNode=s,_.memoizedState={element:a,isDehydrated:i,cache:null,transitions:null,pendingSuspenseBoundaries:null},kh(_),s}function dl(s){if(!s)return Sn;e:{if(Vb(s=s._reactInternals)!==s||1!==s.tag)throw Error(p(170));var o=s;do{switch(o.tag){case 3:o=o.stateNode.context;break e;case 1:if(Zf(o.type)){o=o.stateNode.__reactInternalMemoizedMergedChildContext;break e}}o=o.return}while(null!==o);throw Error(p(171))}if(1===s.tag){var i=s.type;if(Zf(i))return bg(s,i,o)}return o}function el(s,o,i,a,u,_,w,x,C){return(s=bl(i,a,!0,s,0,_,0,x,C)).context=dl(null),i=s.current,(_=mh(a=R(),u=yi(i))).callback=null!=o?o:null,nh(i,_,u),s.current.lanes=u,Ac(s,u,a),Dk(s,a),s}function fl(s,o,i,a){var u=o.current,_=R(),w=yi(u);return i=dl(i),null===o.context?o.context=i:o.pendingContext=i,(o=mh(_,w)).payload={element:s},null!==(a=void 0===a?null:a)&&(o.callback=a),null!==(s=nh(u,o,w))&&(gi(s,u,w,_),oh(s,u,w)),w}function gl(s){return(s=s.current).child?(s.child.tag,s.child.stateNode):null}function hl(s,o){if(null!==(s=s.memoizedState)&&null!==s.dehydrated){var i=s.retryLane;s.retryLane=0!==i&&i<o?i:o}}function il(s,o){hl(s,o),(s=s.alternate)&&hl(s,o)}Is=function(s,o,i){if(null!==s)if(s.memoizedProps!==o.pendingProps||En.current)bs=!0;else{if(!(s.lanes&i||128&o.flags))return bs=!1,function yj(s,o,i){switch(o.tag){case 3:kj(o),Ig();break;case 5:Ah(o);break;case 1:Zf(o.type)&&cg(o);break;case 4:yh(o,o.stateNode.containerInfo);break;case 10:var a=o.type._context,u=o.memoizedProps.value;G(Vn,a._currentValue),a._currentValue=u;break;case 13:if(null!==(a=o.memoizedState))return null!==a.dehydrated?(G(Zn,1&Zn.current),o.flags|=128,null):i&o.child.childLanes?oj(s,o,i):(G(Zn,1&Zn.current),null!==(s=Zi(s,o,i))?s.sibling:null);G(Zn,1&Zn.current);break;case 19:if(a=!!(i&o.childLanes),128&s.flags){if(a)return xj(s,o,i);o.flags|=128}if(null!==(u=o.memoizedState)&&(u.rendering=null,u.tail=null,u.lastEffect=null),G(Zn,Zn.current),a)break;return null;case 22:case 23:return o.lanes=0,dj(s,o,i)}return Zi(s,o,i)}(s,o,i);bs=!!(131072&s.flags)}else bs=!1,Fn&&1048576&o.flags&&ug(o,Pn,o.index);switch(o.lanes=0,o.tag){case 2:var a=o.type;ij(s,o),s=o.pendingProps;var u=Yf(o,_n.current);ch(o,i),u=Nh(null,o,a,s,u,i);var _=Sh();return o.flags|=1,"object"==typeof u&&null!==u&&"function"==typeof u.render&&void 0===u.$$typeof?(o.tag=1,o.memoizedState=null,o.updateQueue=null,Zf(a)?(_=!0,cg(o)):_=!1,o.memoizedState=null!==u.state&&void 0!==u.state?u.state:null,kh(o),u.updater=gs,o.stateNode=u,u._reactInternals=o,Ii(o,a,s,i),o=jj(null,o,a,!0,_,i)):(o.tag=0,Fn&&_&&vg(o),Xi(null,o,u,i),o=o.child),o;case 16:a=o.elementType;e:{switch(ij(s,o),s=o.pendingProps,a=(u=a._init)(a._payload),o.type=a,u=o.tag=function Zk(s){if("function"==typeof s)return aj(s)?1:0;if(null!=s){if((s=s.$$typeof)===le)return 11;if(s===fe)return 14}return 2}(a),s=Ci(a,s),u){case 0:o=cj(null,o,a,s,i);break e;case 1:o=hj(null,o,a,s,i);break e;case 11:o=Yi(null,o,a,s,i);break e;case 14:o=$i(null,o,a,Ci(a.type,s),i);break e}throw Error(p(306,a,""))}return o;case 0:return a=o.type,u=o.pendingProps,cj(s,o,a,u=o.elementType===a?u:Ci(a,u),i);case 1:return a=o.type,u=o.pendingProps,hj(s,o,a,u=o.elementType===a?u:Ci(a,u),i);case 3:e:{if(kj(o),null===s)throw Error(p(387));a=o.pendingProps,u=(_=o.memoizedState).element,lh(s,o),qh(o,a,null,i);var w=o.memoizedState;if(a=w.element,_.isDehydrated){if(_={element:a,isDehydrated:!1,cache:w.cache,pendingSuspenseBoundaries:w.pendingSuspenseBoundaries,transitions:w.transitions},o.updateQueue.baseState=_,o.memoizedState=_,256&o.flags){o=lj(s,o,a,i,u=Ji(Error(p(423)),o));break e}if(a!==u){o=lj(s,o,a,i,u=Ji(Error(p(424)),o));break e}for(Ln=Lf(o.stateNode.containerInfo.firstChild),Dn=o,Fn=!0,Bn=null,i=Un(o,null,a,i),o.child=i;i;)i.flags=-3&i.flags|4096,i=i.sibling}else{if(Ig(),a===u){o=Zi(s,o,i);break e}Xi(s,o,a,i)}o=o.child}return o;case 5:return Ah(o),null===s&&Eg(o),a=o.type,u=o.pendingProps,_=null!==s?s.memoizedProps:null,w=u.children,Ef(a,u)?w=null:null!==_&&Ef(a,_)&&(o.flags|=32),gj(s,o),Xi(s,o,w,i),o.child;case 6:return null===s&&Eg(o),null;case 13:return oj(s,o,i);case 4:return yh(o,o.stateNode.containerInfo),a=o.pendingProps,null===s?o.child=qn(o,null,a,i):Xi(s,o,a,i),o.child;case 11:return a=o.type,u=o.pendingProps,Yi(s,o,a,u=o.elementType===a?u:Ci(a,u),i);case 7:return Xi(s,o,o.pendingProps,i),o.child;case 8:case 12:return Xi(s,o,o.pendingProps.children,i),o.child;case 10:e:{if(a=o.type._context,u=o.pendingProps,_=o.memoizedProps,w=u.value,G(Vn,a._currentValue),a._currentValue=w,null!==_)if(Dr(_.value,w)){if(_.children===u.children&&!En.current){o=Zi(s,o,i);break e}}else for(null!==(_=o.child)&&(_.return=o);null!==_;){var x=_.dependencies;if(null!==x){w=_.child;for(var C=x.firstContext;null!==C;){if(C.context===a){if(1===_.tag){(C=mh(-1,i&-i)).tag=2;var j=_.updateQueue;if(null!==j){var L=(j=j.shared).pending;null===L?C.next=C:(C.next=L.next,L.next=C),j.pending=C}}_.lanes|=i,null!==(C=_.alternate)&&(C.lanes|=i),bh(_.return,i,o),x.lanes|=i;break}C=C.next}}else if(10===_.tag)w=_.type===o.type?null:_.child;else if(18===_.tag){if(null===(w=_.return))throw Error(p(341));w.lanes|=i,null!==(x=w.alternate)&&(x.lanes|=i),bh(w,i,o),w=_.sibling}else w=_.child;if(null!==w)w.return=_;else for(w=_;null!==w;){if(w===o){w=null;break}if(null!==(_=w.sibling)){_.return=w.return,w=_;break}w=w.return}_=w}Xi(s,o,u.children,i),o=o.child}return o;case 9:return u=o.type,a=o.pendingProps.children,ch(o,i),a=a(u=eh(u)),o.flags|=1,Xi(s,o,a,i),o.child;case 14:return u=Ci(a=o.type,o.pendingProps),$i(s,o,a,u=Ci(a.type,u),i);case 15:return bj(s,o,o.type,o.pendingProps,i);case 17:return a=o.type,u=o.pendingProps,u=o.elementType===a?u:Ci(a,u),ij(s,o),o.tag=1,Zf(a)?(s=!0,cg(o)):s=!1,ch(o,i),Gi(o,a,u),Ii(o,a,u,i),jj(null,o,a,!0,s,i);case 19:return xj(s,o,i);case 22:return dj(s,o,i)}throw Error(p(156,o.tag))};var co="function"==typeof reportError?reportError:function(s){console.error(s)};function ll(s){this._internalRoot=s}function ml(s){this._internalRoot=s}function nl(s){return!(!s||1!==s.nodeType&&9!==s.nodeType&&11!==s.nodeType)}function ol(s){return!(!s||1!==s.nodeType&&9!==s.nodeType&&11!==s.nodeType&&(8!==s.nodeType||" react-mount-point-unstable "!==s.nodeValue))}function pl(){}function rl(s,o,i,a,u){var _=i._reactRootContainer;if(_){var w=_;if("function"==typeof u){var x=u;u=function(){var s=gl(w);x.call(s)}}fl(o,w,s,u)}else w=function ql(s,o,i,a,u){if(u){if("function"==typeof a){var _=a;a=function(){var s=gl(w);_.call(s)}}var w=el(o,a,s,0,null,!1,0,"",pl);return s._reactRootContainer=w,s[fn]=w.current,sf(8===s.nodeType?s.parentNode:s),Rk(),w}for(;u=s.lastChild;)s.removeChild(u);if("function"==typeof a){var x=a;a=function(){var s=gl(C);x.call(s)}}var C=bl(s,0,!1,null,0,!1,0,"",pl);return s._reactRootContainer=C,s[fn]=C.current,sf(8===s.nodeType?s.parentNode:s),Rk((function(){fl(o,C,i,a)})),C}(i,o,s,u,a);return gl(w)}ml.prototype.render=ll.prototype.render=function(s){var o=this._internalRoot;if(null===o)throw Error(p(409));fl(s,o,null,null)},ml.prototype.unmount=ll.prototype.unmount=function(){var s=this._internalRoot;if(null!==s){this._internalRoot=null;var o=s.containerInfo;Rk((function(){fl(null,s,null,null)})),o[fn]=null}},ml.prototype.unstable_scheduleHydration=function(s){if(s){var o=It();s={blockedOn:null,target:s,priority:o};for(var i=0;i<$t.length&&0!==o&&o<$t[i].priority;i++);$t.splice(i,0,s),0===i&&Vc(s)}},Ct=function(s){switch(s.tag){case 3:var o=s.stateNode;if(o.current.memoizedState.isDehydrated){var i=tc(o.pendingLanes);0!==i&&(Cc(o,1|i),Dk(o,ht()),!(6&Ds)&&(Ys=ht()+500,jg()))}break;case 13:Rk((function(){var o=ih(s,1);if(null!==o){var i=R();gi(o,s,1,i)}})),il(s,1)}},jt=function(s){if(13===s.tag){var o=ih(s,134217728);if(null!==o)gi(o,s,134217728,R());il(s,134217728)}},Pt=function(s){if(13===s.tag){var o=yi(s),i=ih(s,o);if(null!==i)gi(i,s,o,R());il(s,o)}},It=function(){return At},Tt=function(s,o){var i=At;try{return At=s,o()}finally{At=i}},Ye=function(s,o,i){switch(o){case"input":if(bb(s,i),o=i.name,"radio"===i.type&&null!=o){for(i=s;i.parentNode;)i=i.parentNode;for(i=i.querySelectorAll("input[name="+JSON.stringify(""+o)+'][type="radio"]'),o=0;o<i.length;o++){var a=i[o];if(a!==s&&a.form===s.form){var u=Db(a);if(!u)throw Error(p(90));Wa(a),bb(a,u)}}}break;case"textarea":ib(s,i);break;case"select":null!=(o=i.value)&&fb(s,!!i.multiple,o,!1)}},Gb=Qk,Hb=Rk;var lo={usingClientEntryPoint:!1,Events:[Cb,ue,Db,Eb,Fb,Qk]},uo={findFiberByHostInstance:Wc,bundleType:0,version:"18.3.1",rendererPackageName:"react-dom"},po={bundleType:uo.bundleType,version:uo.version,rendererPackageName:uo.rendererPackageName,rendererConfig:uo.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setErrorHandler:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:V.ReactCurrentDispatcher,findHostInstanceByFiber:function(s){return null===(s=Zb(s))?null:s.stateNode},findFiberByHostInstance:uo.findFiberByHostInstance||function jl(){return null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null,reconcilerVersion:"18.3.1-next-f1338f8080-20240426"};if("undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var ho=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!ho.isDisabled&&ho.supportsFiber)try{St=ho.inject(po),_t=ho}catch(Re){}}o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lo,o.createPortal=function(s,o){var i=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!nl(o))throw Error(p(200));return function cl(s,o,i){var a=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Y,key:null==a?null:""+a,children:s,containerInfo:o,implementation:i}}(s,o,null,i)},o.createRoot=function(s,o){if(!nl(s))throw Error(p(299));var i=!1,a="",u=co;return null!=o&&(!0===o.unstable_strictMode&&(i=!0),void 0!==o.identifierPrefix&&(a=o.identifierPrefix),void 0!==o.onRecoverableError&&(u=o.onRecoverableError)),o=bl(s,1,!1,null,0,i,0,a,u),s[fn]=o.current,sf(8===s.nodeType?s.parentNode:s),new ll(o)},o.findDOMNode=function(s){if(null==s)return null;if(1===s.nodeType)return s;var o=s._reactInternals;if(void 0===o){if("function"==typeof s.render)throw Error(p(188));throw s=Object.keys(s).join(","),Error(p(268,s))}return s=null===(s=Zb(o))?null:s.stateNode},o.flushSync=function(s){return Rk(s)},o.hydrate=function(s,o,i){if(!ol(o))throw Error(p(200));return rl(null,s,o,!0,i)},o.hydrateRoot=function(s,o,i){if(!nl(s))throw Error(p(405));var a=null!=i&&i.hydratedSources||null,u=!1,_="",w=co;if(null!=i&&(!0===i.unstable_strictMode&&(u=!0),void 0!==i.identifierPrefix&&(_=i.identifierPrefix),void 0!==i.onRecoverableError&&(w=i.onRecoverableError)),o=el(o,null,s,1,null!=i?i:null,u,0,_,w),s[fn]=o.current,sf(s),a)for(s=0;s<a.length;s++)u=(u=(i=a[s])._getVersion)(i._source),null==o.mutableSourceEagerHydrationData?o.mutableSourceEagerHydrationData=[i,u]:o.mutableSourceEagerHydrationData.push(i,u);return new ml(o)},o.render=function(s,o,i){if(!ol(o))throw Error(p(200));return rl(null,s,o,!1,i)},o.unmountComponentAtNode=function(s){if(!ol(s))throw Error(p(40));return!!s._reactRootContainer&&(Rk((function(){rl(null,null,s,!1,(function(){s._reactRootContainer=null,s[fn]=null}))})),!0)},o.unstable_batchedUpdates=Qk,o.unstable_renderSubtreeIntoContainer=function(s,o,i,a){if(!ol(i))throw Error(p(200));if(null==s||void 0===s._reactInternals)throw Error(p(38));return rl(s,o,i,!1,a)},o.version="18.3.1-next-f1338f8080-20240426"},40961(s,o,i){"use strict";!function checkDCE(){if("undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE)try{__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE)}catch(s){console.error(s)}}(),s.exports=i(22551)},2209(s,o,i){"use strict";var a,u=i(9404),_=function productionTypeChecker(){invariant(!1,"ImmutablePropTypes type checking code is stripped in production.")};_.isRequired=_;var w=function getProductionTypeChecker(){return _};function getPropType(s){var o=typeof s;return Array.isArray(s)?"array":s instanceof RegExp?"object":s instanceof u.Iterable?"Immutable."+s.toSource().split(" ")[0]:o}function createChainableTypeChecker(s){function checkType(o,i,a,u,_,w){for(var x=arguments.length,C=Array(x>6?x-6:0),j=6;j<x;j++)C[j-6]=arguments[j];return w=w||a,u=u||"<<anonymous>>",null!=i[a]?s.apply(void 0,[i,a,u,_,w].concat(C)):o?new Error("Required "+_+" `"+w+"` was not specified in `"+u+"`."):void 0}var o=checkType.bind(null,!1);return o.isRequired=checkType.bind(null,!0),o}function createIterableSubclassTypeChecker(s,o){return function createImmutableTypeChecker(s,o){return createChainableTypeChecker((function validate(i,a,u,_,w){var x=i[a];if(!o(x)){var C=getPropType(x);return new Error("Invalid "+_+" `"+w+"` of type `"+C+"` supplied to `"+u+"`, expected `"+s+"`.")}return null}))}("Iterable."+s,(function(s){return u.Iterable.isIterable(s)&&o(s)}))}(a={listOf:w,mapOf:w,orderedMapOf:w,setOf:w,orderedSetOf:w,stackOf:w,iterableOf:w,recordOf:w,shape:w,contains:w,mapContains:w,orderedMapContains:w,list:_,map:_,orderedMap:_,set:_,orderedSet:_,stack:_,seq:_,record:_,iterable:_}).iterable.indexed=createIterableSubclassTypeChecker("Indexed",u.Iterable.isIndexed),a.iterable.keyed=createIterableSubclassTypeChecker("Keyed",u.Iterable.isKeyed),s.exports=a},15287(s,o){"use strict";var i=Symbol.for("react.element"),a=Symbol.for("react.portal"),u=Symbol.for("react.fragment"),_=Symbol.for("react.strict_mode"),w=Symbol.for("react.profiler"),x=Symbol.for("react.provider"),C=Symbol.for("react.context"),j=Symbol.for("react.forward_ref"),L=Symbol.for("react.suspense"),B=Symbol.for("react.memo"),$=Symbol.for("react.lazy"),U=Symbol.iterator;var V={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},z=Object.assign,Y={};function E(s,o,i){this.props=s,this.context=o,this.refs=Y,this.updater=i||V}function F(){}function G(s,o,i){this.props=s,this.context=o,this.refs=Y,this.updater=i||V}E.prototype.isReactComponent={},E.prototype.setState=function(s,o){if("object"!=typeof s&&"function"!=typeof s&&null!=s)throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,s,o,"setState")},E.prototype.forceUpdate=function(s){this.updater.enqueueForceUpdate(this,s,"forceUpdate")},F.prototype=E.prototype;var Z=G.prototype=new F;Z.constructor=G,z(Z,E.prototype),Z.isPureReactComponent=!0;var ee=Array.isArray,ie=Object.prototype.hasOwnProperty,ae={current:null},ce={key:!0,ref:!0,__self:!0,__source:!0};function M(s,o,a){var u,_={},w=null,x=null;if(null!=o)for(u in void 0!==o.ref&&(x=o.ref),void 0!==o.key&&(w=""+o.key),o)ie.call(o,u)&&!ce.hasOwnProperty(u)&&(_[u]=o[u]);var C=arguments.length-2;if(1===C)_.children=a;else if(1<C){for(var j=Array(C),L=0;L<C;L++)j[L]=arguments[L+2];_.children=j}if(s&&s.defaultProps)for(u in C=s.defaultProps)void 0===_[u]&&(_[u]=C[u]);return{$$typeof:i,type:s,key:w,ref:x,props:_,_owner:ae.current}}function O(s){return"object"==typeof s&&null!==s&&s.$$typeof===i}var le=/\/+/g;function Q(s,o){return"object"==typeof s&&null!==s&&null!=s.key?function escape(s){var o={"=":"=0",":":"=2"};return"$"+s.replace(/[=:]/g,(function(s){return o[s]}))}(""+s.key):o.toString(36)}function R(s,o,u,_,w){var x=typeof s;"undefined"!==x&&"boolean"!==x||(s=null);var C=!1;if(null===s)C=!0;else switch(x){case"string":case"number":C=!0;break;case"object":switch(s.$$typeof){case i:case a:C=!0}}if(C)return w=w(C=s),s=""===_?"."+Q(C,0):_,ee(w)?(u="",null!=s&&(u=s.replace(le,"$&/")+"/"),R(w,o,u,"",(function(s){return s}))):null!=w&&(O(w)&&(w=function N(s,o){return{$$typeof:i,type:s.type,key:o,ref:s.ref,props:s.props,_owner:s._owner}}(w,u+(!w.key||C&&C.key===w.key?"":(""+w.key).replace(le,"$&/")+"/")+s)),o.push(w)),1;if(C=0,_=""===_?".":_+":",ee(s))for(var j=0;j<s.length;j++){var L=_+Q(x=s[j],j);C+=R(x,o,u,L,w)}else if(L=function A(s){return null===s||"object"!=typeof s?null:"function"==typeof(s=U&&s[U]||s["@@iterator"])?s:null}(s),"function"==typeof L)for(s=L.call(s),j=0;!(x=s.next()).done;)C+=R(x=x.value,o,u,L=_+Q(x,j++),w);else if("object"===x)throw o=String(s),Error("Objects are not valid as a React child (found: "+("[object Object]"===o?"object with keys {"+Object.keys(s).join(", ")+"}":o)+"). If you meant to render a collection of children, use an array instead.");return C}function S(s,o,i){if(null==s)return s;var a=[],u=0;return R(s,a,"","",(function(s){return o.call(i,s,u++)})),a}function T(s){if(-1===s._status){var o=s._result;(o=o()).then((function(o){0!==s._status&&-1!==s._status||(s._status=1,s._result=o)}),(function(o){0!==s._status&&-1!==s._status||(s._status=2,s._result=o)})),-1===s._status&&(s._status=0,s._result=o)}if(1===s._status)return s._result.default;throw s._result}var pe={current:null},de={transition:null},fe={ReactCurrentDispatcher:pe,ReactCurrentBatchConfig:de,ReactCurrentOwner:ae};function X(){throw Error("act(...) is not supported in production builds of React.")}o.Children={map:S,forEach:function(s,o,i){S(s,(function(){o.apply(this,arguments)}),i)},count:function(s){var o=0;return S(s,(function(){o++})),o},toArray:function(s){return S(s,(function(s){return s}))||[]},only:function(s){if(!O(s))throw Error("React.Children.only expected to receive a single React element child.");return s}},o.Component=E,o.Fragment=u,o.Profiler=w,o.PureComponent=G,o.StrictMode=_,o.Suspense=L,o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=fe,o.act=X,o.cloneElement=function(s,o,a){if(null==s)throw Error("React.cloneElement(...): The argument must be a React element, but you passed "+s+".");var u=z({},s.props),_=s.key,w=s.ref,x=s._owner;if(null!=o){if(void 0!==o.ref&&(w=o.ref,x=ae.current),void 0!==o.key&&(_=""+o.key),s.type&&s.type.defaultProps)var C=s.type.defaultProps;for(j in o)ie.call(o,j)&&!ce.hasOwnProperty(j)&&(u[j]=void 0===o[j]&&void 0!==C?C[j]:o[j])}var j=arguments.length-2;if(1===j)u.children=a;else if(1<j){C=Array(j);for(var L=0;L<j;L++)C[L]=arguments[L+2];u.children=C}return{$$typeof:i,type:s.type,key:_,ref:w,props:u,_owner:x}},o.createContext=function(s){return(s={$$typeof:C,_currentValue:s,_currentValue2:s,_threadCount:0,Provider:null,Consumer:null,_defaultValue:null,_globalName:null}).Provider={$$typeof:x,_context:s},s.Consumer=s},o.createElement=M,o.createFactory=function(s){var o=M.bind(null,s);return o.type=s,o},o.createRef=function(){return{current:null}},o.forwardRef=function(s){return{$$typeof:j,render:s}},o.isValidElement=O,o.lazy=function(s){return{$$typeof:$,_payload:{_status:-1,_result:s},_init:T}},o.memo=function(s,o){return{$$typeof:B,type:s,compare:void 0===o?null:o}},o.startTransition=function(s){var o=de.transition;de.transition={};try{s()}finally{de.transition=o}},o.unstable_act=X,o.useCallback=function(s,o){return pe.current.useCallback(s,o)},o.useContext=function(s){return pe.current.useContext(s)},o.useDebugValue=function(){},o.useDeferredValue=function(s){return pe.current.useDeferredValue(s)},o.useEffect=function(s,o){return pe.current.useEffect(s,o)},o.useId=function(){return pe.current.useId()},o.useImperativeHandle=function(s,o,i){return pe.current.useImperativeHandle(s,o,i)},o.useInsertionEffect=function(s,o){return pe.current.useInsertionEffect(s,o)},o.useLayoutEffect=function(s,o){return pe.current.useLayoutEffect(s,o)},o.useMemo=function(s,o){return pe.current.useMemo(s,o)},o.useReducer=function(s,o,i){return pe.current.useReducer(s,o,i)},o.useRef=function(s){return pe.current.useRef(s)},o.useState=function(s){return pe.current.useState(s)},o.useSyncExternalStore=function(s,o,i){return pe.current.useSyncExternalStore(s,o,i)},o.useTransition=function(){return pe.current.useTransition()},o.version="18.3.1"},96540(s,o,i){"use strict";s.exports=i(15287)},86048(s){"use strict";var o={};function createErrorType(s,i,a){a||(a=Error);var u=function(s){function NodeError(o,a,u){return s.call(this,function getMessage(s,o,a){return"string"==typeof i?i:i(s,o,a)}(o,a,u))||this}return function _inheritsLoose(s,o){s.prototype=Object.create(o.prototype),s.prototype.constructor=s,s.__proto__=o}(NodeError,s),NodeError}(a);u.prototype.name=a.name,u.prototype.code=s,o[s]=u}function oneOf(s,o){if(Array.isArray(s)){var i=s.length;return s=s.map((function(s){return String(s)})),i>2?"one of ".concat(o," ").concat(s.slice(0,i-1).join(", "),", or ")+s[i-1]:2===i?"one of ".concat(o," ").concat(s[0]," or ").concat(s[1]):"of ".concat(o," ").concat(s[0])}return"of ".concat(o," ").concat(String(s))}createErrorType("ERR_INVALID_OPT_VALUE",(function(s,o){return'The value "'+o+'" is invalid for option "'+s+'"'}),TypeError),createErrorType("ERR_INVALID_ARG_TYPE",(function(s,o,i){var a,u;if("string"==typeof o&&function startsWith(s,o,i){return s.substr(!i||i<0?0:+i,o.length)===o}(o,"not ")?(a="must not be",o=o.replace(/^not /,"")):a="must be",function endsWith(s,o,i){return(void 0===i||i>s.length)&&(i=s.length),s.substring(i-o.length,i)===o}(s," argument"))u="The ".concat(s," ").concat(a," ").concat(oneOf(o,"type"));else{var _=function includes(s,o,i){return"number"!=typeof i&&(i=0),!(i+o.length>s.length)&&-1!==s.indexOf(o,i)}(s,".")?"property":"argument";u='The "'.concat(s,'" ').concat(_," ").concat(a," ").concat(oneOf(o,"type"))}return u+=". Received type ".concat(typeof i)}),TypeError),createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF"),createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(s){return"The "+s+" method is not implemented"})),createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close"),createErrorType("ERR_STREAM_DESTROYED",(function(s){return"Cannot call "+s+" after a stream was destroyed"})),createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times"),createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable"),createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end"),createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError),createErrorType("ERR_UNKNOWN_ENCODING",(function(s){return"Unknown encoding: "+s}),TypeError),createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event"),s.exports.F=o},25382(s,o,i){"use strict";var a=i(65606),u=Object.keys||function(s){var o=[];for(var i in s)o.push(i);return o};s.exports=Duplex;var _=i(45412),w=i(16708);i(56698)(Duplex,_);for(var x=u(w.prototype),C=0;C<x.length;C++){var j=x[C];Duplex.prototype[j]||(Duplex.prototype[j]=w.prototype[j])}function Duplex(s){if(!(this instanceof Duplex))return new Duplex(s);_.call(this,s),w.call(this,s),this.allowHalfOpen=!0,s&&(!1===s.readable&&(this.readable=!1),!1===s.writable&&(this.writable=!1),!1===s.allowHalfOpen&&(this.allowHalfOpen=!1,this.once("end",onend)))}function onend(){this._writableState.ended||a.nextTick(onEndNT,this)}function onEndNT(s){s.end()}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:!1,get:function get(){return this._writableState.highWaterMark}}),Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:!1,get:function get(){return this._writableState&&this._writableState.getBuffer()}}),Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:!1,get:function get(){return this._writableState.length}}),Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:!1,get:function get(){return void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed&&this._writableState.destroyed)},set:function set(s){void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed=s,this._writableState.destroyed=s)}})},63600(s,o,i){"use strict";s.exports=PassThrough;var a=i(74610);function PassThrough(s){if(!(this instanceof PassThrough))return new PassThrough(s);a.call(this,s)}i(56698)(PassThrough,a),PassThrough.prototype._transform=function(s,o,i){i(null,s)}},45412(s,o,i){"use strict";var a,u=i(65606);s.exports=Readable,Readable.ReadableState=ReadableState;i(37007).EventEmitter;var _=function EElistenerCount(s,o){return s.listeners(o).length},w=i(40345),x=i(48287).Buffer,C=(void 0!==i.g?i.g:"undefined"!=typeof window?window:"undefined"!=typeof self?self:{}).Uint8Array||function(){};var j,L=i(79838);j=L&&L.debuglog?L.debuglog("stream"):function debug(){};var B,$,U,V=i(80345),z=i(75896),Y=i(65291).getHighWaterMark,Z=i(86048).F,ee=Z.ERR_INVALID_ARG_TYPE,ie=Z.ERR_STREAM_PUSH_AFTER_EOF,ae=Z.ERR_METHOD_NOT_IMPLEMENTED,ce=Z.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;i(56698)(Readable,w);var le=z.errorOrDestroy,pe=["error","close","destroy","pause","resume"];function ReadableState(s,o,u){a=a||i(25382),s=s||{},"boolean"!=typeof u&&(u=o instanceof a),this.objectMode=!!s.objectMode,u&&(this.objectMode=this.objectMode||!!s.readableObjectMode),this.highWaterMark=Y(this,s,"readableHighWaterMark",u),this.buffer=new V,this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=!1,this.endEmitted=!1,this.reading=!1,this.sync=!0,this.needReadable=!1,this.emittedReadable=!1,this.readableListening=!1,this.resumeScheduled=!1,this.paused=!0,this.emitClose=!1!==s.emitClose,this.autoDestroy=!!s.autoDestroy,this.destroyed=!1,this.defaultEncoding=s.defaultEncoding||"utf8",this.awaitDrain=0,this.readingMore=!1,this.decoder=null,this.encoding=null,s.encoding&&(B||(B=i(83141).I),this.decoder=new B(s.encoding),this.encoding=s.encoding)}function Readable(s){if(a=a||i(25382),!(this instanceof Readable))return new Readable(s);var o=this instanceof a;this._readableState=new ReadableState(s,this,o),this.readable=!0,s&&("function"==typeof s.read&&(this._read=s.read),"function"==typeof s.destroy&&(this._destroy=s.destroy)),w.call(this)}function readableAddChunk(s,o,i,a,u){j("readableAddChunk",o);var _,w=s._readableState;if(null===o)w.reading=!1,function onEofChunk(s,o){if(j("onEofChunk"),o.ended)return;if(o.decoder){var i=o.decoder.end();i&&i.length&&(o.buffer.push(i),o.length+=o.objectMode?1:i.length)}o.ended=!0,o.sync?emitReadable(s):(o.needReadable=!1,o.emittedReadable||(o.emittedReadable=!0,emitReadable_(s)))}(s,w);else if(u||(_=function chunkInvalid(s,o){var i;(function _isUint8Array(s){return x.isBuffer(s)||s instanceof C})(o)||"string"==typeof o||void 0===o||s.objectMode||(i=new ee("chunk",["string","Buffer","Uint8Array"],o));return i}(w,o)),_)le(s,_);else if(w.objectMode||o&&o.length>0)if("string"==typeof o||w.objectMode||Object.getPrototypeOf(o)===x.prototype||(o=function _uint8ArrayToBuffer(s){return x.from(s)}(o)),a)w.endEmitted?le(s,new ce):addChunk(s,w,o,!0);else if(w.ended)le(s,new ie);else{if(w.destroyed)return!1;w.reading=!1,w.decoder&&!i?(o=w.decoder.write(o),w.objectMode||0!==o.length?addChunk(s,w,o,!1):maybeReadMore(s,w)):addChunk(s,w,o,!1)}else a||(w.reading=!1,maybeReadMore(s,w));return!w.ended&&(w.length<w.highWaterMark||0===w.length)}function addChunk(s,o,i,a){o.flowing&&0===o.length&&!o.sync?(o.awaitDrain=0,s.emit("data",i)):(o.length+=o.objectMode?1:i.length,a?o.buffer.unshift(i):o.buffer.push(i),o.needReadable&&emitReadable(s)),maybeReadMore(s,o)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:!1,get:function get(){return void 0!==this._readableState&&this._readableState.destroyed},set:function set(s){this._readableState&&(this._readableState.destroyed=s)}}),Readable.prototype.destroy=z.destroy,Readable.prototype._undestroy=z.undestroy,Readable.prototype._destroy=function(s,o){o(s)},Readable.prototype.push=function(s,o){var i,a=this._readableState;return a.objectMode?i=!0:"string"==typeof s&&((o=o||a.defaultEncoding)!==a.encoding&&(s=x.from(s,o),o=""),i=!0),readableAddChunk(this,s,o,!1,i)},Readable.prototype.unshift=function(s){return readableAddChunk(this,s,null,!0,!1)},Readable.prototype.isPaused=function(){return!1===this._readableState.flowing},Readable.prototype.setEncoding=function(s){B||(B=i(83141).I);var o=new B(s);this._readableState.decoder=o,this._readableState.encoding=this._readableState.decoder.encoding;for(var a=this._readableState.buffer.head,u="";null!==a;)u+=o.write(a.data),a=a.next;return this._readableState.buffer.clear(),""!==u&&this._readableState.buffer.push(u),this._readableState.length=u.length,this};var de=1073741824;function howMuchToRead(s,o){return s<=0||0===o.length&&o.ended?0:o.objectMode?1:s!=s?o.flowing&&o.length?o.buffer.head.data.length:o.length:(s>o.highWaterMark&&(o.highWaterMark=function computeNewHighWaterMark(s){return s>=de?s=de:(s--,s|=s>>>1,s|=s>>>2,s|=s>>>4,s|=s>>>8,s|=s>>>16,s++),s}(s)),s<=o.length?s:o.ended?o.length:(o.needReadable=!0,0))}function emitReadable(s){var o=s._readableState;j("emitReadable",o.needReadable,o.emittedReadable),o.needReadable=!1,o.emittedReadable||(j("emitReadable",o.flowing),o.emittedReadable=!0,u.nextTick(emitReadable_,s))}function emitReadable_(s){var o=s._readableState;j("emitReadable_",o.destroyed,o.length,o.ended),o.destroyed||!o.length&&!o.ended||(s.emit("readable"),o.emittedReadable=!1),o.needReadable=!o.flowing&&!o.ended&&o.length<=o.highWaterMark,flow(s)}function maybeReadMore(s,o){o.readingMore||(o.readingMore=!0,u.nextTick(maybeReadMore_,s,o))}function maybeReadMore_(s,o){for(;!o.reading&&!o.ended&&(o.length<o.highWaterMark||o.flowing&&0===o.length);){var i=o.length;if(j("maybeReadMore read 0"),s.read(0),i===o.length)break}o.readingMore=!1}function updateReadableListening(s){var o=s._readableState;o.readableListening=s.listenerCount("readable")>0,o.resumeScheduled&&!o.paused?o.flowing=!0:s.listenerCount("data")>0&&s.resume()}function nReadingNextTick(s){j("readable nexttick read 0"),s.read(0)}function resume_(s,o){j("resume",o.reading),o.reading||s.read(0),o.resumeScheduled=!1,s.emit("resume"),flow(s),o.flowing&&!o.reading&&s.read(0)}function flow(s){var o=s._readableState;for(j("flow",o.flowing);o.flowing&&null!==s.read(););}function fromList(s,o){return 0===o.length?null:(o.objectMode?i=o.buffer.shift():!s||s>=o.length?(i=o.decoder?o.buffer.join(""):1===o.buffer.length?o.buffer.first():o.buffer.concat(o.length),o.buffer.clear()):i=o.buffer.consume(s,o.decoder),i);var i}function endReadable(s){var o=s._readableState;j("endReadable",o.endEmitted),o.endEmitted||(o.ended=!0,u.nextTick(endReadableNT,o,s))}function endReadableNT(s,o){if(j("endReadableNT",s.endEmitted,s.length),!s.endEmitted&&0===s.length&&(s.endEmitted=!0,o.readable=!1,o.emit("end"),s.autoDestroy)){var i=o._writableState;(!i||i.autoDestroy&&i.finished)&&o.destroy()}}function indexOf(s,o){for(var i=0,a=s.length;i<a;i++)if(s[i]===o)return i;return-1}Readable.prototype.read=function(s){j("read",s),s=parseInt(s,10);var o=this._readableState,i=s;if(0!==s&&(o.emittedReadable=!1),0===s&&o.needReadable&&((0!==o.highWaterMark?o.length>=o.highWaterMark:o.length>0)||o.ended))return j("read: emitReadable",o.length,o.ended),0===o.length&&o.ended?endReadable(this):emitReadable(this),null;if(0===(s=howMuchToRead(s,o))&&o.ended)return 0===o.length&&endReadable(this),null;var a,u=o.needReadable;return j("need readable",u),(0===o.length||o.length-s<o.highWaterMark)&&j("length less than watermark",u=!0),o.ended||o.reading?j("reading or ended",u=!1):u&&(j("do read"),o.reading=!0,o.sync=!0,0===o.length&&(o.needReadable=!0),this._read(o.highWaterMark),o.sync=!1,o.reading||(s=howMuchToRead(i,o))),null===(a=s>0?fromList(s,o):null)?(o.needReadable=o.length<=o.highWaterMark,s=0):(o.length-=s,o.awaitDrain=0),0===o.length&&(o.ended||(o.needReadable=!0),i!==s&&o.ended&&endReadable(this)),null!==a&&this.emit("data",a),a},Readable.prototype._read=function(s){le(this,new ae("_read()"))},Readable.prototype.pipe=function(s,o){var i=this,a=this._readableState;switch(a.pipesCount){case 0:a.pipes=s;break;case 1:a.pipes=[a.pipes,s];break;default:a.pipes.push(s)}a.pipesCount+=1,j("pipe count=%d opts=%j",a.pipesCount,o);var w=(!o||!1!==o.end)&&s!==u.stdout&&s!==u.stderr?onend:unpipe;function onunpipe(o,u){j("onunpipe"),o===i&&u&&!1===u.hasUnpiped&&(u.hasUnpiped=!0,function cleanup(){j("cleanup"),s.removeListener("close",onclose),s.removeListener("finish",onfinish),s.removeListener("drain",x),s.removeListener("error",onerror),s.removeListener("unpipe",onunpipe),i.removeListener("end",onend),i.removeListener("end",unpipe),i.removeListener("data",ondata),C=!0,!a.awaitDrain||s._writableState&&!s._writableState.needDrain||x()}())}function onend(){j("onend"),s.end()}a.endEmitted?u.nextTick(w):i.once("end",w),s.on("unpipe",onunpipe);var x=function pipeOnDrain(s){return function pipeOnDrainFunctionResult(){var o=s._readableState;j("pipeOnDrain",o.awaitDrain),o.awaitDrain&&o.awaitDrain--,0===o.awaitDrain&&_(s,"data")&&(o.flowing=!0,flow(s))}}(i);s.on("drain",x);var C=!1;function ondata(o){j("ondata");var u=s.write(o);j("dest.write",u),!1===u&&((1===a.pipesCount&&a.pipes===s||a.pipesCount>1&&-1!==indexOf(a.pipes,s))&&!C&&(j("false write response, pause",a.awaitDrain),a.awaitDrain++),i.pause())}function onerror(o){j("onerror",o),unpipe(),s.removeListener("error",onerror),0===_(s,"error")&&le(s,o)}function onclose(){s.removeListener("finish",onfinish),unpipe()}function onfinish(){j("onfinish"),s.removeListener("close",onclose),unpipe()}function unpipe(){j("unpipe"),i.unpipe(s)}return i.on("data",ondata),function prependListener(s,o,i){if("function"==typeof s.prependListener)return s.prependListener(o,i);s._events&&s._events[o]?Array.isArray(s._events[o])?s._events[o].unshift(i):s._events[o]=[i,s._events[o]]:s.on(o,i)}(s,"error",onerror),s.once("close",onclose),s.once("finish",onfinish),s.emit("pipe",i),a.flowing||(j("pipe resume"),i.resume()),s},Readable.prototype.unpipe=function(s){var o=this._readableState,i={hasUnpiped:!1};if(0===o.pipesCount)return this;if(1===o.pipesCount)return s&&s!==o.pipes||(s||(s=o.pipes),o.pipes=null,o.pipesCount=0,o.flowing=!1,s&&s.emit("unpipe",this,i)),this;if(!s){var a=o.pipes,u=o.pipesCount;o.pipes=null,o.pipesCount=0,o.flowing=!1;for(var _=0;_<u;_++)a[_].emit("unpipe",this,{hasUnpiped:!1});return this}var w=indexOf(o.pipes,s);return-1===w||(o.pipes.splice(w,1),o.pipesCount-=1,1===o.pipesCount&&(o.pipes=o.pipes[0]),s.emit("unpipe",this,i)),this},Readable.prototype.on=function(s,o){var i=w.prototype.on.call(this,s,o),a=this._readableState;return"data"===s?(a.readableListening=this.listenerCount("readable")>0,!1!==a.flowing&&this.resume()):"readable"===s&&(a.endEmitted||a.readableListening||(a.readableListening=a.needReadable=!0,a.flowing=!1,a.emittedReadable=!1,j("on readable",a.length,a.reading),a.length?emitReadable(this):a.reading||u.nextTick(nReadingNextTick,this))),i},Readable.prototype.addListener=Readable.prototype.on,Readable.prototype.removeListener=function(s,o){var i=w.prototype.removeListener.call(this,s,o);return"readable"===s&&u.nextTick(updateReadableListening,this),i},Readable.prototype.removeAllListeners=function(s){var o=w.prototype.removeAllListeners.apply(this,arguments);return"readable"!==s&&void 0!==s||u.nextTick(updateReadableListening,this),o},Readable.prototype.resume=function(){var s=this._readableState;return s.flowing||(j("resume"),s.flowing=!s.readableListening,function resume(s,o){o.resumeScheduled||(o.resumeScheduled=!0,u.nextTick(resume_,s,o))}(this,s)),s.paused=!1,this},Readable.prototype.pause=function(){return j("call pause flowing=%j",this._readableState.flowing),!1!==this._readableState.flowing&&(j("pause"),this._readableState.flowing=!1,this.emit("pause")),this._readableState.paused=!0,this},Readable.prototype.wrap=function(s){var o=this,i=this._readableState,a=!1;for(var u in s.on("end",(function(){if(j("wrapped end"),i.decoder&&!i.ended){var s=i.decoder.end();s&&s.length&&o.push(s)}o.push(null)})),s.on("data",(function(u){(j("wrapped data"),i.decoder&&(u=i.decoder.write(u)),i.objectMode&&null==u)||(i.objectMode||u&&u.length)&&(o.push(u)||(a=!0,s.pause()))})),s)void 0===this[u]&&"function"==typeof s[u]&&(this[u]=function methodWrap(o){return function methodWrapReturnFunction(){return s[o].apply(s,arguments)}}(u));for(var _=0;_<pe.length;_++)s.on(pe[_],this.emit.bind(this,pe[_]));return this._read=function(o){j("wrapped _read",o),a&&(a=!1,s.resume())},this},"function"==typeof Symbol&&(Readable.prototype[Symbol.asyncIterator]=function(){return void 0===$&&($=i(2955)),$(this)}),Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:!1,get:function get(){return this._readableState.highWaterMark}}),Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:!1,get:function get(){return this._readableState&&this._readableState.buffer}}),Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:!1,get:function get(){return this._readableState.flowing},set:function set(s){this._readableState&&(this._readableState.flowing=s)}}),Readable._fromList=fromList,Object.defineProperty(Readable.prototype,"readableLength",{enumerable:!1,get:function get(){return this._readableState.length}}),"function"==typeof Symbol&&(Readable.from=function(s,o){return void 0===U&&(U=i(55157)),U(Readable,s,o)})},74610(s,o,i){"use strict";s.exports=Transform;var a=i(86048).F,u=a.ERR_METHOD_NOT_IMPLEMENTED,_=a.ERR_MULTIPLE_CALLBACK,w=a.ERR_TRANSFORM_ALREADY_TRANSFORMING,x=a.ERR_TRANSFORM_WITH_LENGTH_0,C=i(25382);function afterTransform(s,o){var i=this._transformState;i.transforming=!1;var a=i.writecb;if(null===a)return this.emit("error",new _);i.writechunk=null,i.writecb=null,null!=o&&this.push(o),a(s);var u=this._readableState;u.reading=!1,(u.needReadable||u.length<u.highWaterMark)&&this._read(u.highWaterMark)}function Transform(s){if(!(this instanceof Transform))return new Transform(s);C.call(this,s),this._transformState={afterTransform:afterTransform.bind(this),needTransform:!1,transforming:!1,writecb:null,writechunk:null,writeencoding:null},this._readableState.needReadable=!0,this._readableState.sync=!1,s&&("function"==typeof s.transform&&(this._transform=s.transform),"function"==typeof s.flush&&(this._flush=s.flush)),this.on("prefinish",prefinish)}function prefinish(){var s=this;"function"!=typeof this._flush||this._readableState.destroyed?done(this,null,null):this._flush((function(o,i){done(s,o,i)}))}function done(s,o,i){if(o)return s.emit("error",o);if(null!=i&&s.push(i),s._writableState.length)throw new x;if(s._transformState.transforming)throw new w;return s.push(null)}i(56698)(Transform,C),Transform.prototype.push=function(s,o){return this._transformState.needTransform=!1,C.prototype.push.call(this,s,o)},Transform.prototype._transform=function(s,o,i){i(new u("_transform()"))},Transform.prototype._write=function(s,o,i){var a=this._transformState;if(a.writecb=i,a.writechunk=s,a.writeencoding=o,!a.transforming){var u=this._readableState;(a.needTransform||u.needReadable||u.length<u.highWaterMark)&&this._read(u.highWaterMark)}},Transform.prototype._read=function(s){var o=this._transformState;null===o.writechunk||o.transforming?o.needTransform=!0:(o.transforming=!0,this._transform(o.writechunk,o.writeencoding,o.afterTransform))},Transform.prototype._destroy=function(s,o){C.prototype._destroy.call(this,s,(function(s){o(s)}))}},16708(s,o,i){"use strict";var a,u=i(65606);function CorkedRequest(s){var o=this;this.next=null,this.entry=null,this.finish=function(){!function onCorkedFinish(s,o,i){var a=s.entry;s.entry=null;for(;a;){var u=a.callback;o.pendingcb--,u(i),a=a.next}o.corkedRequestsFree.next=s}(o,s)}}s.exports=Writable,Writable.WritableState=WritableState;var _={deprecate:i(94643)},w=i(40345),x=i(48287).Buffer,C=(void 0!==i.g?i.g:"undefined"!=typeof window?window:"undefined"!=typeof self?self:{}).Uint8Array||function(){};var j,L=i(75896),B=i(65291).getHighWaterMark,$=i(86048).F,U=$.ERR_INVALID_ARG_TYPE,V=$.ERR_METHOD_NOT_IMPLEMENTED,z=$.ERR_MULTIPLE_CALLBACK,Y=$.ERR_STREAM_CANNOT_PIPE,Z=$.ERR_STREAM_DESTROYED,ee=$.ERR_STREAM_NULL_VALUES,ie=$.ERR_STREAM_WRITE_AFTER_END,ae=$.ERR_UNKNOWN_ENCODING,ce=L.errorOrDestroy;function nop(){}function WritableState(s,o,_){a=a||i(25382),s=s||{},"boolean"!=typeof _&&(_=o instanceof a),this.objectMode=!!s.objectMode,_&&(this.objectMode=this.objectMode||!!s.writableObjectMode),this.highWaterMark=B(this,s,"writableHighWaterMark",_),this.finalCalled=!1,this.needDrain=!1,this.ending=!1,this.ended=!1,this.finished=!1,this.destroyed=!1;var w=!1===s.decodeStrings;this.decodeStrings=!w,this.defaultEncoding=s.defaultEncoding||"utf8",this.length=0,this.writing=!1,this.corked=0,this.sync=!0,this.bufferProcessing=!1,this.onwrite=function(s){!function onwrite(s,o){var i=s._writableState,a=i.sync,_=i.writecb;if("function"!=typeof _)throw new z;if(function onwriteStateUpdate(s){s.writing=!1,s.writecb=null,s.length-=s.writelen,s.writelen=0}(i),o)!function onwriteError(s,o,i,a,_){--o.pendingcb,i?(u.nextTick(_,a),u.nextTick(finishMaybe,s,o),s._writableState.errorEmitted=!0,ce(s,a)):(_(a),s._writableState.errorEmitted=!0,ce(s,a),finishMaybe(s,o))}(s,i,a,o,_);else{var w=needFinish(i)||s.destroyed;w||i.corked||i.bufferProcessing||!i.bufferedRequest||clearBuffer(s,i),a?u.nextTick(afterWrite,s,i,w,_):afterWrite(s,i,w,_)}}(o,s)},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=!1,this.errorEmitted=!1,this.emitClose=!1!==s.emitClose,this.autoDestroy=!!s.autoDestroy,this.bufferedRequestCount=0,this.corkedRequestsFree=new CorkedRequest(this)}function Writable(s){var o=this instanceof(a=a||i(25382));if(!o&&!j.call(Writable,this))return new Writable(s);this._writableState=new WritableState(s,this,o),this.writable=!0,s&&("function"==typeof s.write&&(this._write=s.write),"function"==typeof s.writev&&(this._writev=s.writev),"function"==typeof s.destroy&&(this._destroy=s.destroy),"function"==typeof s.final&&(this._final=s.final)),w.call(this)}function doWrite(s,o,i,a,u,_,w){o.writelen=a,o.writecb=w,o.writing=!0,o.sync=!0,o.destroyed?o.onwrite(new Z("write")):i?s._writev(u,o.onwrite):s._write(u,_,o.onwrite),o.sync=!1}function afterWrite(s,o,i,a){i||function onwriteDrain(s,o){0===o.length&&o.needDrain&&(o.needDrain=!1,s.emit("drain"))}(s,o),o.pendingcb--,a(),finishMaybe(s,o)}function clearBuffer(s,o){o.bufferProcessing=!0;var i=o.bufferedRequest;if(s._writev&&i&&i.next){var a=o.bufferedRequestCount,u=new Array(a),_=o.corkedRequestsFree;_.entry=i;for(var w=0,x=!0;i;)u[w]=i,i.isBuf||(x=!1),i=i.next,w+=1;u.allBuffers=x,doWrite(s,o,!0,o.length,u,"",_.finish),o.pendingcb++,o.lastBufferedRequest=null,_.next?(o.corkedRequestsFree=_.next,_.next=null):o.corkedRequestsFree=new CorkedRequest(o),o.bufferedRequestCount=0}else{for(;i;){var C=i.chunk,j=i.encoding,L=i.callback;if(doWrite(s,o,!1,o.objectMode?1:C.length,C,j,L),i=i.next,o.bufferedRequestCount--,o.writing)break}null===i&&(o.lastBufferedRequest=null)}o.bufferedRequest=i,o.bufferProcessing=!1}function needFinish(s){return s.ending&&0===s.length&&null===s.bufferedRequest&&!s.finished&&!s.writing}function callFinal(s,o){s._final((function(i){o.pendingcb--,i&&ce(s,i),o.prefinished=!0,s.emit("prefinish"),finishMaybe(s,o)}))}function finishMaybe(s,o){var i=needFinish(o);if(i&&(function prefinish(s,o){o.prefinished||o.finalCalled||("function"!=typeof s._final||o.destroyed?(o.prefinished=!0,s.emit("prefinish")):(o.pendingcb++,o.finalCalled=!0,u.nextTick(callFinal,s,o)))}(s,o),0===o.pendingcb&&(o.finished=!0,s.emit("finish"),o.autoDestroy))){var a=s._readableState;(!a||a.autoDestroy&&a.endEmitted)&&s.destroy()}return i}i(56698)(Writable,w),WritableState.prototype.getBuffer=function getBuffer(){for(var s=this.bufferedRequest,o=[];s;)o.push(s),s=s.next;return o},function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:_.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.","DEP0003")})}catch(s){}}(),"function"==typeof Symbol&&Symbol.hasInstance&&"function"==typeof Function.prototype[Symbol.hasInstance]?(j=Function.prototype[Symbol.hasInstance],Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(s){return!!j.call(this,s)||this===Writable&&(s&&s._writableState instanceof WritableState)}})):j=function realHasInstance(s){return s instanceof this},Writable.prototype.pipe=function(){ce(this,new Y)},Writable.prototype.write=function(s,o,i){var a=this._writableState,_=!1,w=!a.objectMode&&function _isUint8Array(s){return x.isBuffer(s)||s instanceof C}(s);return w&&!x.isBuffer(s)&&(s=function _uint8ArrayToBuffer(s){return x.from(s)}(s)),"function"==typeof o&&(i=o,o=null),w?o="buffer":o||(o=a.defaultEncoding),"function"!=typeof i&&(i=nop),a.ending?function writeAfterEnd(s,o){var i=new ie;ce(s,i),u.nextTick(o,i)}(this,i):(w||function validChunk(s,o,i,a){var _;return null===i?_=new ee:"string"==typeof i||o.objectMode||(_=new U("chunk",["string","Buffer"],i)),!_||(ce(s,_),u.nextTick(a,_),!1)}(this,a,s,i))&&(a.pendingcb++,_=function writeOrBuffer(s,o,i,a,u,_){if(!i){var w=function decodeChunk(s,o,i){s.objectMode||!1===s.decodeStrings||"string"!=typeof o||(o=x.from(o,i));return o}(o,a,u);a!==w&&(i=!0,u="buffer",a=w)}var C=o.objectMode?1:a.length;o.length+=C;var j=o.length<o.highWaterMark;j||(o.needDrain=!0);if(o.writing||o.corked){var L=o.lastBufferedRequest;o.lastBufferedRequest={chunk:a,encoding:u,isBuf:i,callback:_,next:null},L?L.next=o.lastBufferedRequest:o.bufferedRequest=o.lastBufferedRequest,o.bufferedRequestCount+=1}else doWrite(s,o,!1,C,a,u,_);return j}(this,a,w,s,o,i)),_},Writable.prototype.cork=function(){this._writableState.corked++},Writable.prototype.uncork=function(){var s=this._writableState;s.corked&&(s.corked--,s.writing||s.corked||s.bufferProcessing||!s.bufferedRequest||clearBuffer(this,s))},Writable.prototype.setDefaultEncoding=function setDefaultEncoding(s){if("string"==typeof s&&(s=s.toLowerCase()),!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((s+"").toLowerCase())>-1))throw new ae(s);return this._writableState.defaultEncoding=s,this},Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:!1,get:function get(){return this._writableState&&this._writableState.getBuffer()}}),Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:!1,get:function get(){return this._writableState.highWaterMark}}),Writable.prototype._write=function(s,o,i){i(new V("_write()"))},Writable.prototype._writev=null,Writable.prototype.end=function(s,o,i){var a=this._writableState;return"function"==typeof s?(i=s,s=null,o=null):"function"==typeof o&&(i=o,o=null),null!=s&&this.write(s,o),a.corked&&(a.corked=1,this.uncork()),a.ending||function endWritable(s,o,i){o.ending=!0,finishMaybe(s,o),i&&(o.finished?u.nextTick(i):s.once("finish",i));o.ended=!0,s.writable=!1}(this,a,i),this},Object.defineProperty(Writable.prototype,"writableLength",{enumerable:!1,get:function get(){return this._writableState.length}}),Object.defineProperty(Writable.prototype,"destroyed",{enumerable:!1,get:function get(){return void 0!==this._writableState&&this._writableState.destroyed},set:function set(s){this._writableState&&(this._writableState.destroyed=s)}}),Writable.prototype.destroy=L.destroy,Writable.prototype._undestroy=L.undestroy,Writable.prototype._destroy=function(s,o){o(s)}},2955(s,o,i){"use strict";var a,u=i(65606);function _defineProperty(s,o,i){return(o=function _toPropertyKey(s){var o=function _toPrimitive(s,o){if("object"!=typeof s||null===s)return s;var i=s[Symbol.toPrimitive];if(void 0!==i){var a=i.call(s,o||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===o?String:Number)(s)}(s,"string");return"symbol"==typeof o?o:String(o)}(o))in s?Object.defineProperty(s,o,{value:i,enumerable:!0,configurable:!0,writable:!0}):s[o]=i,s}var _=i(86238),w=Symbol("lastResolve"),x=Symbol("lastReject"),C=Symbol("error"),j=Symbol("ended"),L=Symbol("lastPromise"),B=Symbol("handlePromise"),$=Symbol("stream");function createIterResult(s,o){return{value:s,done:o}}function readAndResolve(s){var o=s[w];if(null!==o){var i=s[$].read();null!==i&&(s[L]=null,s[w]=null,s[x]=null,o(createIterResult(i,!1)))}}function onReadable(s){u.nextTick(readAndResolve,s)}var U=Object.getPrototypeOf((function(){})),V=Object.setPrototypeOf((_defineProperty(a={get stream(){return this[$]},next:function next(){var s=this,o=this[C];if(null!==o)return Promise.reject(o);if(this[j])return Promise.resolve(createIterResult(void 0,!0));if(this[$].destroyed)return new Promise((function(o,i){u.nextTick((function(){s[C]?i(s[C]):o(createIterResult(void 0,!0))}))}));var i,a=this[L];if(a)i=new Promise(function wrapForNext(s,o){return function(i,a){s.then((function(){o[j]?i(createIterResult(void 0,!0)):o[B](i,a)}),a)}}(a,this));else{var _=this[$].read();if(null!==_)return Promise.resolve(createIterResult(_,!1));i=new Promise(this[B])}return this[L]=i,i}},Symbol.asyncIterator,(function(){return this})),_defineProperty(a,"return",(function _return(){var s=this;return new Promise((function(o,i){s[$].destroy(null,(function(s){s?i(s):o(createIterResult(void 0,!0))}))}))})),a),U);s.exports=function createReadableStreamAsyncIterator(s){var o,i=Object.create(V,(_defineProperty(o={},$,{value:s,writable:!0}),_defineProperty(o,w,{value:null,writable:!0}),_defineProperty(o,x,{value:null,writable:!0}),_defineProperty(o,C,{value:null,writable:!0}),_defineProperty(o,j,{value:s._readableState.endEmitted,writable:!0}),_defineProperty(o,B,{value:function value(s,o){var a=i[$].read();a?(i[L]=null,i[w]=null,i[x]=null,s(createIterResult(a,!1))):(i[w]=s,i[x]=o)},writable:!0}),o));return i[L]=null,_(s,(function(s){if(s&&"ERR_STREAM_PREMATURE_CLOSE"!==s.code){var o=i[x];return null!==o&&(i[L]=null,i[w]=null,i[x]=null,o(s)),void(i[C]=s)}var a=i[w];null!==a&&(i[L]=null,i[w]=null,i[x]=null,a(createIterResult(void 0,!0))),i[j]=!0})),s.on("readable",onReadable.bind(null,i)),i}},80345(s,o,i){"use strict";function ownKeys(s,o){var i=Object.keys(s);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(s);o&&(a=a.filter((function(o){return Object.getOwnPropertyDescriptor(s,o).enumerable}))),i.push.apply(i,a)}return i}function _objectSpread(s){for(var o=1;o<arguments.length;o++){var i=null!=arguments[o]?arguments[o]:{};o%2?ownKeys(Object(i),!0).forEach((function(o){_defineProperty(s,o,i[o])})):Object.getOwnPropertyDescriptors?Object.defineProperties(s,Object.getOwnPropertyDescriptors(i)):ownKeys(Object(i)).forEach((function(o){Object.defineProperty(s,o,Object.getOwnPropertyDescriptor(i,o))}))}return s}function _defineProperty(s,o,i){return(o=_toPropertyKey(o))in s?Object.defineProperty(s,o,{value:i,enumerable:!0,configurable:!0,writable:!0}):s[o]=i,s}function _defineProperties(s,o){for(var i=0;i<o.length;i++){var a=o[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(s,_toPropertyKey(a.key),a)}}function _toPropertyKey(s){var o=function _toPrimitive(s,o){if("object"!=typeof s||null===s)return s;var i=s[Symbol.toPrimitive];if(void 0!==i){var a=i.call(s,o||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===o?String:Number)(s)}(s,"string");return"symbol"==typeof o?o:String(o)}var a=i(48287).Buffer,u=i(15340).inspect,_=u&&u.custom||"inspect";s.exports=function(){function BufferList(){!function _classCallCheck(s,o){if(!(s instanceof o))throw new TypeError("Cannot call a class as a function")}(this,BufferList),this.head=null,this.tail=null,this.length=0}return function _createClass(s,o,i){return o&&_defineProperties(s.prototype,o),i&&_defineProperties(s,i),Object.defineProperty(s,"prototype",{writable:!1}),s}(BufferList,[{key:"push",value:function push(s){var o={data:s,next:null};this.length>0?this.tail.next=o:this.head=o,this.tail=o,++this.length}},{key:"unshift",value:function unshift(s){var o={data:s,next:this.head};0===this.length&&(this.tail=o),this.head=o,++this.length}},{key:"shift",value:function shift(){if(0!==this.length){var s=this.head.data;return 1===this.length?this.head=this.tail=null:this.head=this.head.next,--this.length,s}}},{key:"clear",value:function clear(){this.head=this.tail=null,this.length=0}},{key:"join",value:function join(s){if(0===this.length)return"";for(var o=this.head,i=""+o.data;o=o.next;)i+=s+o.data;return i}},{key:"concat",value:function concat(s){if(0===this.length)return a.alloc(0);for(var o,i,u,_=a.allocUnsafe(s>>>0),w=this.head,x=0;w;)o=w.data,i=_,u=x,a.prototype.copy.call(o,i,u),x+=w.data.length,w=w.next;return _}},{key:"consume",value:function consume(s,o){var i;return s<this.head.data.length?(i=this.head.data.slice(0,s),this.head.data=this.head.data.slice(s)):i=s===this.head.data.length?this.shift():o?this._getString(s):this._getBuffer(s),i}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(s){var o=this.head,i=1,a=o.data;for(s-=a.length;o=o.next;){var u=o.data,_=s>u.length?u.length:s;if(_===u.length?a+=u:a+=u.slice(0,s),0===(s-=_)){_===u.length?(++i,o.next?this.head=o.next:this.head=this.tail=null):(this.head=o,o.data=u.slice(_));break}++i}return this.length-=i,a}},{key:"_getBuffer",value:function _getBuffer(s){var o=a.allocUnsafe(s),i=this.head,u=1;for(i.data.copy(o),s-=i.data.length;i=i.next;){var _=i.data,w=s>_.length?_.length:s;if(_.copy(o,o.length-s,0,w),0===(s-=w)){w===_.length?(++u,i.next?this.head=i.next:this.head=this.tail=null):(this.head=i,i.data=_.slice(w));break}++u}return this.length-=u,o}},{key:_,value:function value(s,o){return u(this,_objectSpread(_objectSpread({},o),{},{depth:0,customInspect:!1}))}}]),BufferList}()},75896(s,o,i){"use strict";var a=i(65606);function emitErrorAndCloseNT(s,o){emitErrorNT(s,o),emitCloseNT(s)}function emitCloseNT(s){s._writableState&&!s._writableState.emitClose||s._readableState&&!s._readableState.emitClose||s.emit("close")}function emitErrorNT(s,o){s.emit("error",o)}s.exports={destroy:function destroy(s,o){var i=this,u=this._readableState&&this._readableState.destroyed,_=this._writableState&&this._writableState.destroyed;return u||_?(o?o(s):s&&(this._writableState?this._writableState.errorEmitted||(this._writableState.errorEmitted=!0,a.nextTick(emitErrorNT,this,s)):a.nextTick(emitErrorNT,this,s)),this):(this._readableState&&(this._readableState.destroyed=!0),this._writableState&&(this._writableState.destroyed=!0),this._destroy(s||null,(function(s){!o&&s?i._writableState?i._writableState.errorEmitted?a.nextTick(emitCloseNT,i):(i._writableState.errorEmitted=!0,a.nextTick(emitErrorAndCloseNT,i,s)):a.nextTick(emitErrorAndCloseNT,i,s):o?(a.nextTick(emitCloseNT,i),o(s)):a.nextTick(emitCloseNT,i)})),this)},undestroy:function undestroy(){this._readableState&&(this._readableState.destroyed=!1,this._readableState.reading=!1,this._readableState.ended=!1,this._readableState.endEmitted=!1),this._writableState&&(this._writableState.destroyed=!1,this._writableState.ended=!1,this._writableState.ending=!1,this._writableState.finalCalled=!1,this._writableState.prefinished=!1,this._writableState.finished=!1,this._writableState.errorEmitted=!1)},errorOrDestroy:function errorOrDestroy(s,o){var i=s._readableState,a=s._writableState;i&&i.autoDestroy||a&&a.autoDestroy?s.destroy(o):s.emit("error",o)}}},86238(s,o,i){"use strict";var a=i(86048).F.ERR_STREAM_PREMATURE_CLOSE;function noop(){}s.exports=function eos(s,o,i){if("function"==typeof o)return eos(s,null,o);o||(o={}),i=function once(s){var o=!1;return function(){if(!o){o=!0;for(var i=arguments.length,a=new Array(i),u=0;u<i;u++)a[u]=arguments[u];s.apply(this,a)}}}(i||noop);var u=o.readable||!1!==o.readable&&s.readable,_=o.writable||!1!==o.writable&&s.writable,w=function onlegacyfinish(){s.writable||C()},x=s._writableState&&s._writableState.finished,C=function onfinish(){_=!1,x=!0,u||i.call(s)},j=s._readableState&&s._readableState.endEmitted,L=function onend(){u=!1,j=!0,_||i.call(s)},B=function onerror(o){i.call(s,o)},$=function onclose(){var o;return u&&!j?(s._readableState&&s._readableState.ended||(o=new a),i.call(s,o)):_&&!x?(s._writableState&&s._writableState.ended||(o=new a),i.call(s,o)):void 0},U=function onrequest(){s.req.on("finish",C)};return!function isRequest(s){return s.setHeader&&"function"==typeof s.abort}(s)?_&&!s._writableState&&(s.on("end",w),s.on("close",w)):(s.on("complete",C),s.on("abort",$),s.req?U():s.on("request",U)),s.on("end",L),s.on("finish",C),!1!==o.error&&s.on("error",B),s.on("close",$),function(){s.removeListener("complete",C),s.removeListener("abort",$),s.removeListener("request",U),s.req&&s.req.removeListener("finish",C),s.removeListener("end",w),s.removeListener("close",w),s.removeListener("finish",C),s.removeListener("end",L),s.removeListener("error",B),s.removeListener("close",$)}}},55157(s){s.exports=function(){throw new Error("Readable.from is not available in the browser")}},57758(s,o,i){"use strict";var a;var u=i(86048).F,_=u.ERR_MISSING_ARGS,w=u.ERR_STREAM_DESTROYED;function noop(s){if(s)throw s}function call(s){s()}function pipe(s,o){return s.pipe(o)}s.exports=function pipeline(){for(var s=arguments.length,o=new Array(s),u=0;u<s;u++)o[u]=arguments[u];var x,C=function popCallback(s){return s.length?"function"!=typeof s[s.length-1]?noop:s.pop():noop}(o);if(Array.isArray(o[0])&&(o=o[0]),o.length<2)throw new _("streams");var j=o.map((function(s,u){var _=u<o.length-1;return function destroyer(s,o,u,_){_=function once(s){var o=!1;return function(){o||(o=!0,s.apply(void 0,arguments))}}(_);var x=!1;s.on("close",(function(){x=!0})),void 0===a&&(a=i(86238)),a(s,{readable:o,writable:u},(function(s){if(s)return _(s);x=!0,_()}));var C=!1;return function(o){if(!x&&!C)return C=!0,function isRequest(s){return s.setHeader&&"function"==typeof s.abort}(s)?s.abort():"function"==typeof s.destroy?s.destroy():void _(o||new w("pipe"))}}(s,_,u>0,(function(s){x||(x=s),s&&j.forEach(call),_||(j.forEach(call),C(x))}))}));return o.reduce(pipe)}},65291(s,o,i){"use strict";var a=i(86048).F.ERR_INVALID_OPT_VALUE;s.exports={getHighWaterMark:function getHighWaterMark(s,o,i,u){var _=function highWaterMarkFrom(s,o,i){return null!=s.highWaterMark?s.highWaterMark:o?s[i]:null}(o,u,i);if(null!=_){if(!isFinite(_)||Math.floor(_)!==_||_<0)throw new a(u?i:"highWaterMark",_);return Math.floor(_)}return s.objectMode?16:16384}}},40345(s,o,i){s.exports=i(37007).EventEmitter},84977(s,o,i){"use strict";Object.defineProperty(o,"__esModule",{value:!0});var a=function _interopRequireDefault(s){return s&&s.__esModule?s:{default:s}}(i(9404)),u=i(55674);o.default=function(s){var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:a.default.Map,i=Object.keys(s);return function(){var a=arguments.length>0&&void 0!==arguments[0]?arguments[0]:o(),_=arguments[1];return a.withMutations((function(o){i.forEach((function(i){var a=(0,s[i])(o.get(i),_);(0,u.validateNextState)(a,i,_),o.set(i,a)}))}))}},s.exports=o.default},89593(s,o,i){"use strict";o.H=void 0;var a=function _interopRequireDefault(s){return s&&s.__esModule?s:{default:s}}(i(84977));o.H=a.default},48590(s,o){"use strict";Object.defineProperty(o,"__esModule",{value:!0}),o.default=function(s){return s&&"@@redux/INIT"===s.type?"initialState argument passed to createStore":"previous state received by the reducer"},s.exports=o.default},82261(s,o,i){"use strict";Object.defineProperty(o,"__esModule",{value:!0});var a=_interopRequireDefault(i(9404)),u=_interopRequireDefault(i(48590));function _interopRequireDefault(s){return s&&s.__esModule?s:{default:s}}o.default=function(s,o,i){var _=Object.keys(o);if(!_.length)return"Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";var w=(0,u.default)(i);if(a.default.isImmutable?!a.default.isImmutable(s):!a.default.Iterable.isIterable(s))return"The "+w+' is of unexpected type. Expected argument to be an instance of Immutable.Collection or Immutable.Record with the following properties: "'+_.join('", "')+'".';var x=s.toSeq().keySeq().toArray().filter((function(s){return!o.hasOwnProperty(s)}));return x.length>0?"Unexpected "+(1===x.length?"property":"properties")+' "'+x.join('", "')+'" found in '+w+'. Expected to find one of the known reducer property names instead: "'+_.join('", "')+'". Unexpected properties will be ignored.':null},s.exports=o.default},55674(s,o,i){"use strict";Object.defineProperty(o,"__esModule",{value:!0}),o.validateNextState=o.getUnexpectedInvocationParameterMessage=o.getStateName=void 0;var a=_interopRequireDefault(i(48590)),u=_interopRequireDefault(i(82261)),_=_interopRequireDefault(i(27374));function _interopRequireDefault(s){return s&&s.__esModule?s:{default:s}}o.getStateName=a.default,o.getUnexpectedInvocationParameterMessage=u.default,o.validateNextState=_.default},27374(s,o){"use strict";Object.defineProperty(o,"__esModule",{value:!0}),o.default=function(s,o,i){if(void 0===s)throw new Error('Reducer "'+o+'" returned undefined when handling "'+i.type+'" action. To ignore an action, you must explicitly return the previous state.')},s.exports=o.default},75208(s){"use strict";var o,i="";s.exports=function repeat(s,a){if("string"!=typeof s)throw new TypeError("expected a string");if(1===a)return s;if(2===a)return s+s;var u=s.length*a;if(o!==s||void 0===o)o=s,i="";else if(i.length>=u)return i.substr(0,u);for(;u>i.length&&a>1;)1&a&&(i+=s),a>>=1,s+=s;return i=(i+=s).substr(0,u)}},92063(s){"use strict";s.exports=function required(s,o){if(o=o.split(":")[0],!(s=+s))return!1;switch(o){case"http":case"ws":return 80!==s;case"https":case"wss":return 443!==s;case"ftp":return 21!==s;case"gopher":return 70!==s;case"file":return!1}return 0!==s}},27096(s,o,i){const a=i(87586),u=i(6205),_=i(10023),w=i(8048);s.exports=s=>{var o,i,x=0,C={type:u.ROOT,stack:[]},j=C,L=C.stack,B=[],repeatErr=o=>{a.error(s,"Nothing to repeat at column "+(o-1))},$=a.strToChars(s);for(o=$.length;x<o;)switch(i=$[x++]){case"\\":switch(i=$[x++]){case"b":L.push(w.wordBoundary());break;case"B":L.push(w.nonWordBoundary());break;case"w":L.push(_.words());break;case"W":L.push(_.notWords());break;case"d":L.push(_.ints());break;case"D":L.push(_.notInts());break;case"s":L.push(_.whitespace());break;case"S":L.push(_.notWhitespace());break;default:/\d/.test(i)?L.push({type:u.REFERENCE,value:parseInt(i,10)}):L.push({type:u.CHAR,value:i.charCodeAt(0)})}break;case"^":L.push(w.begin());break;case"$":L.push(w.end());break;case"[":var U;"^"===$[x]?(U=!0,x++):U=!1;var V=a.tokenizeClass($.slice(x),s);x+=V[1],L.push({type:u.SET,set:V[0],not:U});break;case".":L.push(_.anyChar());break;case"(":var z={type:u.GROUP,stack:[],remember:!0};"?"===(i=$[x])&&(i=$[x+1],x+=2,"="===i?z.followedBy=!0:"!"===i?z.notFollowedBy=!0:":"!==i&&a.error(s,`Invalid group, character '${i}' after '?' at column `+(x-1)),z.remember=!1),L.push(z),B.push(j),j=z,L=z.stack;break;case")":0===B.length&&a.error(s,"Unmatched ) at column "+(x-1)),L=(j=B.pop()).options?j.options[j.options.length-1]:j.stack;break;case"|":j.options||(j.options=[j.stack],delete j.stack);var Y=[];j.options.push(Y),L=Y;break;case"{":var Z,ee,ie=/^(\d+)(,(\d+)?)?\}/.exec($.slice(x));null!==ie?(0===L.length&&repeatErr(x),Z=parseInt(ie[1],10),ee=ie[2]?ie[3]?parseInt(ie[3],10):1/0:Z,x+=ie[0].length,L.push({type:u.REPETITION,min:Z,max:ee,value:L.pop()})):L.push({type:u.CHAR,value:123});break;case"?":0===L.length&&repeatErr(x),L.push({type:u.REPETITION,min:0,max:1,value:L.pop()});break;case"+":0===L.length&&repeatErr(x),L.push({type:u.REPETITION,min:1,max:1/0,value:L.pop()});break;case"*":0===L.length&&repeatErr(x),L.push({type:u.REPETITION,min:0,max:1/0,value:L.pop()});break;default:L.push({type:u.CHAR,value:i.charCodeAt(0)})}return 0!==B.length&&a.error(s,"Unterminated group"),C},s.exports.types=u},8048(s,o,i){const a=i(6205);o.wordBoundary=()=>({type:a.POSITION,value:"b"}),o.nonWordBoundary=()=>({type:a.POSITION,value:"B"}),o.begin=()=>({type:a.POSITION,value:"^"}),o.end=()=>({type:a.POSITION,value:"$"})},10023(s,o,i){const a=i(6205),INTS=()=>[{type:a.RANGE,from:48,to:57}],WORDS=()=>[{type:a.CHAR,value:95},{type:a.RANGE,from:97,to:122},{type:a.RANGE,from:65,to:90}].concat(INTS()),WHITESPACE=()=>[{type:a.CHAR,value:9},{type:a.CHAR,value:10},{type:a.CHAR,value:11},{type:a.CHAR,value:12},{type:a.CHAR,value:13},{type:a.CHAR,value:32},{type:a.CHAR,value:160},{type:a.CHAR,value:5760},{type:a.RANGE,from:8192,to:8202},{type:a.CHAR,value:8232},{type:a.CHAR,value:8233},{type:a.CHAR,value:8239},{type:a.CHAR,value:8287},{type:a.CHAR,value:12288},{type:a.CHAR,value:65279}];o.words=()=>({type:a.SET,set:WORDS(),not:!1}),o.notWords=()=>({type:a.SET,set:WORDS(),not:!0}),o.ints=()=>({type:a.SET,set:INTS(),not:!1}),o.notInts=()=>({type:a.SET,set:INTS(),not:!0}),o.whitespace=()=>({type:a.SET,set:WHITESPACE(),not:!1}),o.notWhitespace=()=>({type:a.SET,set:WHITESPACE(),not:!0}),o.anyChar=()=>({type:a.SET,set:[{type:a.CHAR,value:10},{type:a.CHAR,value:13},{type:a.CHAR,value:8232},{type:a.CHAR,value:8233}],not:!0})},6205(s){s.exports={ROOT:0,GROUP:1,POSITION:2,SET:3,RANGE:4,REPETITION:5,REFERENCE:6,CHAR:7}},87586(s,o,i){const a=i(6205),u=i(10023),_={0:0,t:9,n:10,v:11,f:12,r:13};o.strToChars=function(s){return s=s.replace(/(\[\\b\])|(\\)?\\(?:u([A-F0-9]{4})|x([A-F0-9]{2})|(0?[0-7]{2})|c([@A-Z[\\\]^?])|([0tnvfr]))/g,(function(s,o,i,a,u,w,x,C){if(i)return s;var j=o?8:a?parseInt(a,16):u?parseInt(u,16):w?parseInt(w,8):x?"@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^ ?".indexOf(x):_[C],L=String.fromCharCode(j);return/[[\]{}^$.|?*+()]/.test(L)&&(L="\\"+L),L}))},o.tokenizeClass=(s,i)=>{for(var _,w,x=[],C=/\\(?:(w)|(d)|(s)|(W)|(D)|(S))|((?:(?:\\)(.)|([^\]\\]))-(?:\\)?([^\]]))|(\])|(?:\\)?([^])/g;null!=(_=C.exec(s));)if(_[1])x.push(u.words());else if(_[2])x.push(u.ints());else if(_[3])x.push(u.whitespace());else if(_[4])x.push(u.notWords());else if(_[5])x.push(u.notInts());else if(_[6])x.push(u.notWhitespace());else if(_[7])x.push({type:a.RANGE,from:(_[8]||_[9]).charCodeAt(0),to:_[10].charCodeAt(0)});else{if(!(w=_[12]))return[x,C.lastIndex];x.push({type:a.CHAR,value:w.charCodeAt(0)})}o.error(i,"Unterminated character class")},o.error=(s,o)=>{throw new SyntaxError("Invalid regular expression: /"+s+"/: "+o)}},92861(s,o,i){var a=i(48287),u=a.Buffer;function copyProps(s,o){for(var i in s)o[i]=s[i]}function SafeBuffer(s,o,i){return u(s,o,i)}u.from&&u.alloc&&u.allocUnsafe&&u.allocUnsafeSlow?s.exports=a:(copyProps(a,o),o.Buffer=SafeBuffer),SafeBuffer.prototype=Object.create(u.prototype),copyProps(u,SafeBuffer),SafeBuffer.from=function(s,o,i){if("number"==typeof s)throw new TypeError("Argument must not be a number");return u(s,o,i)},SafeBuffer.alloc=function(s,o,i){if("number"!=typeof s)throw new TypeError("Argument must be a number");var a=u(s);return void 0!==o?"string"==typeof i?a.fill(o,i):a.fill(o):a.fill(0),a},SafeBuffer.allocUnsafe=function(s){if("number"!=typeof s)throw new TypeError("Argument must be a number");return u(s)},SafeBuffer.allocUnsafeSlow=function(s){if("number"!=typeof s)throw new TypeError("Argument must be a number");return a.SlowBuffer(s)}},29844(s,o){"use strict";function f(s,o){var i=s.length;s.push(o);e:for(;0<i;){var a=i-1>>>1,u=s[a];if(!(0<g(u,o)))break e;s[a]=o,s[i]=u,i=a}}function h(s){return 0===s.length?null:s[0]}function k(s){if(0===s.length)return null;var o=s[0],i=s.pop();if(i!==o){s[0]=i;e:for(var a=0,u=s.length,_=u>>>1;a<_;){var w=2*(a+1)-1,x=s[w],C=w+1,j=s[C];if(0>g(x,i))C<u&&0>g(j,x)?(s[a]=j,s[C]=i,a=C):(s[a]=x,s[w]=i,a=w);else{if(!(C<u&&0>g(j,i)))break e;s[a]=j,s[C]=i,a=C}}}return o}function g(s,o){var i=s.sortIndex-o.sortIndex;return 0!==i?i:s.id-o.id}if("object"==typeof performance&&"function"==typeof performance.now){var i=performance;o.unstable_now=function(){return i.now()}}else{var a=Date,u=a.now();o.unstable_now=function(){return a.now()-u}}var _=[],w=[],x=1,C=null,j=3,L=!1,B=!1,$=!1,U="function"==typeof setTimeout?setTimeout:null,V="function"==typeof clearTimeout?clearTimeout:null,z="undefined"!=typeof setImmediate?setImmediate:null;function G(s){for(var o=h(w);null!==o;){if(null===o.callback)k(w);else{if(!(o.startTime<=s))break;k(w),o.sortIndex=o.expirationTime,f(_,o)}o=h(w)}}function H(s){if($=!1,G(s),!B)if(null!==h(_))B=!0,I(J);else{var o=h(w);null!==o&&K(H,o.startTime-s)}}function J(s,i){B=!1,$&&($=!1,V(ie),ie=-1),L=!0;var a=j;try{for(G(i),C=h(_);null!==C&&(!(C.expirationTime>i)||s&&!M());){var u=C.callback;if("function"==typeof u){C.callback=null,j=C.priorityLevel;var x=u(C.expirationTime<=i);i=o.unstable_now(),"function"==typeof x?C.callback=x:C===h(_)&&k(_),G(i)}else k(_);C=h(_)}if(null!==C)var U=!0;else{var z=h(w);null!==z&&K(H,z.startTime-i),U=!1}return U}finally{C=null,j=a,L=!1}}"undefined"!=typeof navigator&&void 0!==navigator.scheduling&&void 0!==navigator.scheduling.isInputPending&&navigator.scheduling.isInputPending.bind(navigator.scheduling);var Y,Z=!1,ee=null,ie=-1,ae=5,ce=-1;function M(){return!(o.unstable_now()-ce<ae)}function R(){if(null!==ee){var s=o.unstable_now();ce=s;var i=!0;try{i=ee(!0,s)}finally{i?Y():(Z=!1,ee=null)}}else Z=!1}if("function"==typeof z)Y=function(){z(R)};else if("undefined"!=typeof MessageChannel){var le=new MessageChannel,pe=le.port2;le.port1.onmessage=R,Y=function(){pe.postMessage(null)}}else Y=function(){U(R,0)};function I(s){ee=s,Z||(Z=!0,Y())}function K(s,i){ie=U((function(){s(o.unstable_now())}),i)}o.unstable_IdlePriority=5,o.unstable_ImmediatePriority=1,o.unstable_LowPriority=4,o.unstable_NormalPriority=3,o.unstable_Profiling=null,o.unstable_UserBlockingPriority=2,o.unstable_cancelCallback=function(s){s.callback=null},o.unstable_continueExecution=function(){B||L||(B=!0,I(J))},o.unstable_forceFrameRate=function(s){0>s||125<s?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):ae=0<s?Math.floor(1e3/s):5},o.unstable_getCurrentPriorityLevel=function(){return j},o.unstable_getFirstCallbackNode=function(){return h(_)},o.unstable_next=function(s){switch(j){case 1:case 2:case 3:var o=3;break;default:o=j}var i=j;j=o;try{return s()}finally{j=i}},o.unstable_pauseExecution=function(){},o.unstable_requestPaint=function(){},o.unstable_runWithPriority=function(s,o){switch(s){case 1:case 2:case 3:case 4:case 5:break;default:s=3}var i=j;j=s;try{return o()}finally{j=i}},o.unstable_scheduleCallback=function(s,i,a){var u=o.unstable_now();switch("object"==typeof a&&null!==a?a="number"==typeof(a=a.delay)&&0<a?u+a:u:a=u,s){case 1:var C=-1;break;case 2:C=250;break;case 5:C=1073741823;break;case 4:C=1e4;break;default:C=5e3}return s={id:x++,callback:i,priorityLevel:s,startTime:a,expirationTime:C=a+C,sortIndex:-1},a>u?(s.sortIndex=a,f(w,s),null===h(_)&&s===h(w)&&($?(V(ie),ie=-1):$=!0,K(H,a-u))):(s.sortIndex=C,f(_,s),B||L||(B=!0,I(J))),s},o.unstable_shouldYield=M,o.unstable_wrapCallback=function(s){var o=j;return function(){var i=j;j=o;try{return s.apply(this,arguments)}finally{j=i}}}},69982(s,o,i){"use strict";s.exports=i(29844)},20334(s,o,i){"use strict";var a=i(48287).Buffer;class NonError extends Error{constructor(s){super(NonError._prepareSuperMessage(s)),Object.defineProperty(this,"name",{value:"NonError",configurable:!0,writable:!0}),Error.captureStackTrace&&Error.captureStackTrace(this,NonError)}static _prepareSuperMessage(s){try{return JSON.stringify(s)}catch{return String(s)}}}const u=[{property:"name",enumerable:!1},{property:"message",enumerable:!1},{property:"stack",enumerable:!1},{property:"code",enumerable:!0}],_=Symbol(".toJSON called"),destroyCircular=({from:s,seen:o,to_:i,forceEnumerable:w,maxDepth:x,depth:C})=>{const j=i||(Array.isArray(s)?[]:{});if(o.push(s),C>=x)return j;if("function"==typeof s.toJSON&&!0!==s[_])return(s=>{s[_]=!0;const o=s.toJSON();return delete s[_],o})(s);for(const[i,u]of Object.entries(s))"function"==typeof a&&a.isBuffer(u)?j[i]="[object Buffer]":"function"!=typeof u&&(u&&"object"==typeof u?o.includes(s[i])?j[i]="[Circular]":(C++,j[i]=destroyCircular({from:s[i],seen:o.slice(),forceEnumerable:w,maxDepth:x,depth:C})):j[i]=u);for(const{property:o,enumerable:i}of u)"string"==typeof s[o]&&Object.defineProperty(j,o,{value:s[o],enumerable:!!w||i,configurable:!0,writable:!0});return j};s.exports={serializeError:(s,o={})=>{const{maxDepth:i=Number.POSITIVE_INFINITY}=o;return"object"==typeof s&&null!==s?destroyCircular({from:s,seen:[],forceEnumerable:!0,maxDepth:i,depth:0}):"function"==typeof s?`[Function: ${s.name||"anonymous"}]`:s},deserializeError:(s,o={})=>{const{maxDepth:i=Number.POSITIVE_INFINITY}=o;if(s instanceof Error)return s;if("object"==typeof s&&null!==s&&!Array.isArray(s)){const o=new Error;return destroyCircular({from:s,seen:[],to_:o,maxDepth:i,depth:0}),o}return new NonError(s)}}},96897(s,o,i){"use strict";var a=i(70453),u=i(30041),_=i(30592)(),w=i(75795),x=i(69675),C=a("%Math.floor%");s.exports=function setFunctionLength(s,o){if("function"!=typeof s)throw new x("`fn` is not a function");if("number"!=typeof o||o<0||o>4294967295||C(o)!==o)throw new x("`length` must be a positive 32-bit integer");var i=arguments.length>2&&!!arguments[2],a=!0,j=!0;if("length"in s&&w){var L=w(s,"length");L&&!L.configurable&&(a=!1),L&&!L.writable&&(j=!1)}return(a||j||!i)&&(_?u(s,"length",o,!0,!0):u(s,"length",o)),s}},90392(s,o,i){"use strict";var a=i(92861).Buffer,u=i(15377);function Hash(s,o){this._block=a.alloc(s),this._finalSize=o,this._blockSize=s,this._len=0}Hash.prototype.update=function(s,o){s=u(s,o||"utf8");for(var i=this._block,a=this._blockSize,_=s.length,w=this._len,x=0;x<_;){for(var C=w%a,j=Math.min(_-x,a-C),L=0;L<j;L++)i[C+L]=s[x+L];x+=j,(w+=j)%a==0&&this._update(i)}return this._len+=_,this},Hash.prototype.digest=function(s){var o=this._len%this._blockSize;this._block[o]=128,this._block.fill(0,o+1),o>=this._finalSize&&(this._update(this._block),this._block.fill(0));var i=8*this._len;if(i<=4294967295)this._block.writeUInt32BE(i,this._blockSize-4);else{var a=(4294967295&i)>>>0,u=(i-a)/4294967296;this._block.writeUInt32BE(u,this._blockSize-8),this._block.writeUInt32BE(a,this._blockSize-4)}this._update(this._block);var _=this._hash();return s?_.toString(s):_},Hash.prototype._update=function(){throw new Error("_update must be implemented by subclass")},s.exports=Hash},62802(s,o,i){"use strict";s.exports=function SHA(o){var i=o.toLowerCase(),a=s.exports[i];if(!a)throw new Error(i+" is not supported (we accept pull requests)");return new a},s.exports.sha=i(27816),s.exports.sha1=i(63737),s.exports.sha224=i(26710),s.exports.sha256=i(24107),s.exports.sha384=i(32827),s.exports.sha512=i(82890)},27816(s,o,i){"use strict";var a=i(56698),u=i(90392),_=i(92861).Buffer,w=[1518500249,1859775393,-1894007588,-899497514],x=new Array(80);function Sha(){this.init(),this._w=x,u.call(this,64,56)}function rotl30(s){return s<<30|s>>>2}function ft(s,o,i,a){return 0===s?o&i|~o&a:2===s?o&i|o&a|i&a:o^i^a}a(Sha,u),Sha.prototype.init=function(){return this._a=1732584193,this._b=4023233417,this._c=2562383102,this._d=271733878,this._e=3285377520,this},Sha.prototype._update=function(s){for(var o,i=this._w,a=0|this._a,u=0|this._b,_=0|this._c,x=0|this._d,C=0|this._e,j=0;j<16;++j)i[j]=s.readInt32BE(4*j);for(;j<80;++j)i[j]=i[j-3]^i[j-8]^i[j-14]^i[j-16];for(var L=0;L<80;++L){var B=~~(L/20),$=0|((o=a)<<5|o>>>27)+ft(B,u,_,x)+C+i[L]+w[B];C=x,x=_,_=rotl30(u),u=a,a=$}this._a=a+this._a|0,this._b=u+this._b|0,this._c=_+this._c|0,this._d=x+this._d|0,this._e=C+this._e|0},Sha.prototype._hash=function(){var s=_.allocUnsafe(20);return s.writeInt32BE(0|this._a,0),s.writeInt32BE(0|this._b,4),s.writeInt32BE(0|this._c,8),s.writeInt32BE(0|this._d,12),s.writeInt32BE(0|this._e,16),s},s.exports=Sha},63737(s,o,i){"use strict";var a=i(56698),u=i(90392),_=i(92861).Buffer,w=[1518500249,1859775393,-1894007588,-899497514],x=new Array(80);function Sha1(){this.init(),this._w=x,u.call(this,64,56)}function rotl5(s){return s<<5|s>>>27}function rotl30(s){return s<<30|s>>>2}function ft(s,o,i,a){return 0===s?o&i|~o&a:2===s?o&i|o&a|i&a:o^i^a}a(Sha1,u),Sha1.prototype.init=function(){return this._a=1732584193,this._b=4023233417,this._c=2562383102,this._d=271733878,this._e=3285377520,this},Sha1.prototype._update=function(s){for(var o,i=this._w,a=0|this._a,u=0|this._b,_=0|this._c,x=0|this._d,C=0|this._e,j=0;j<16;++j)i[j]=s.readInt32BE(4*j);for(;j<80;++j)i[j]=(o=i[j-3]^i[j-8]^i[j-14]^i[j-16])<<1|o>>>31;for(var L=0;L<80;++L){var B=~~(L/20),$=rotl5(a)+ft(B,u,_,x)+C+i[L]+w[B]|0;C=x,x=_,_=rotl30(u),u=a,a=$}this._a=a+this._a|0,this._b=u+this._b|0,this._c=_+this._c|0,this._d=x+this._d|0,this._e=C+this._e|0},Sha1.prototype._hash=function(){var s=_.allocUnsafe(20);return s.writeInt32BE(0|this._a,0),s.writeInt32BE(0|this._b,4),s.writeInt32BE(0|this._c,8),s.writeInt32BE(0|this._d,12),s.writeInt32BE(0|this._e,16),s},s.exports=Sha1},26710(s,o,i){"use strict";var a=i(56698),u=i(24107),_=i(90392),w=i(92861).Buffer,x=new Array(64);function Sha224(){this.init(),this._w=x,_.call(this,64,56)}a(Sha224,u),Sha224.prototype.init=function(){return this._a=3238371032,this._b=914150663,this._c=812702999,this._d=4144912697,this._e=4290775857,this._f=1750603025,this._g=1694076839,this._h=3204075428,this},Sha224.prototype._hash=function(){var s=w.allocUnsafe(28);return s.writeInt32BE(this._a,0),s.writeInt32BE(this._b,4),s.writeInt32BE(this._c,8),s.writeInt32BE(this._d,12),s.writeInt32BE(this._e,16),s.writeInt32BE(this._f,20),s.writeInt32BE(this._g,24),s},s.exports=Sha224},24107(s,o,i){"use strict";var a=i(56698),u=i(90392),_=i(92861).Buffer,w=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],x=new Array(64);function Sha256(){this.init(),this._w=x,u.call(this,64,56)}function ch(s,o,i){return i^s&(o^i)}function maj(s,o,i){return s&o|i&(s|o)}function sigma0(s){return(s>>>2|s<<30)^(s>>>13|s<<19)^(s>>>22|s<<10)}function sigma1(s){return(s>>>6|s<<26)^(s>>>11|s<<21)^(s>>>25|s<<7)}function gamma0(s){return(s>>>7|s<<25)^(s>>>18|s<<14)^s>>>3}a(Sha256,u),Sha256.prototype.init=function(){return this._a=1779033703,this._b=3144134277,this._c=1013904242,this._d=2773480762,this._e=1359893119,this._f=2600822924,this._g=528734635,this._h=1541459225,this},Sha256.prototype._update=function(s){for(var o,i=this._w,a=0|this._a,u=0|this._b,_=0|this._c,x=0|this._d,C=0|this._e,j=0|this._f,L=0|this._g,B=0|this._h,$=0;$<16;++$)i[$]=s.readInt32BE(4*$);for(;$<64;++$)i[$]=0|(((o=i[$-2])>>>17|o<<15)^(o>>>19|o<<13)^o>>>10)+i[$-7]+gamma0(i[$-15])+i[$-16];for(var U=0;U<64;++U){var V=B+sigma1(C)+ch(C,j,L)+w[U]+i[U]|0,z=sigma0(a)+maj(a,u,_)|0;B=L,L=j,j=C,C=x+V|0,x=_,_=u,u=a,a=V+z|0}this._a=a+this._a|0,this._b=u+this._b|0,this._c=_+this._c|0,this._d=x+this._d|0,this._e=C+this._e|0,this._f=j+this._f|0,this._g=L+this._g|0,this._h=B+this._h|0},Sha256.prototype._hash=function(){var s=_.allocUnsafe(32);return s.writeInt32BE(this._a,0),s.writeInt32BE(this._b,4),s.writeInt32BE(this._c,8),s.writeInt32BE(this._d,12),s.writeInt32BE(this._e,16),s.writeInt32BE(this._f,20),s.writeInt32BE(this._g,24),s.writeInt32BE(this._h,28),s},s.exports=Sha256},32827(s,o,i){"use strict";var a=i(56698),u=i(82890),_=i(90392),w=i(92861).Buffer,x=new Array(160);function Sha384(){this.init(),this._w=x,_.call(this,128,112)}a(Sha384,u),Sha384.prototype.init=function(){return this._ah=3418070365,this._bh=1654270250,this._ch=2438529370,this._dh=355462360,this._eh=1731405415,this._fh=2394180231,this._gh=3675008525,this._hh=1203062813,this._al=3238371032,this._bl=914150663,this._cl=812702999,this._dl=4144912697,this._el=4290775857,this._fl=1750603025,this._gl=1694076839,this._hl=3204075428,this},Sha384.prototype._hash=function(){var s=w.allocUnsafe(48);function writeInt64BE(o,i,a){s.writeInt32BE(o,a),s.writeInt32BE(i,a+4)}return writeInt64BE(this._ah,this._al,0),writeInt64BE(this._bh,this._bl,8),writeInt64BE(this._ch,this._cl,16),writeInt64BE(this._dh,this._dl,24),writeInt64BE(this._eh,this._el,32),writeInt64BE(this._fh,this._fl,40),s},s.exports=Sha384},82890(s,o,i){"use strict";var a=i(56698),u=i(90392),_=i(92861).Buffer,w=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591],x=new Array(160);function Sha512(){this.init(),this._w=x,u.call(this,128,112)}function Ch(s,o,i){return i^s&(o^i)}function maj(s,o,i){return s&o|i&(s|o)}function sigma0(s,o){return(s>>>28|o<<4)^(o>>>2|s<<30)^(o>>>7|s<<25)}function sigma1(s,o){return(s>>>14|o<<18)^(s>>>18|o<<14)^(o>>>9|s<<23)}function Gamma0(s,o){return(s>>>1|o<<31)^(s>>>8|o<<24)^s>>>7}function Gamma0l(s,o){return(s>>>1|o<<31)^(s>>>8|o<<24)^(s>>>7|o<<25)}function Gamma1(s,o){return(s>>>19|o<<13)^(o>>>29|s<<3)^s>>>6}function Gamma1l(s,o){return(s>>>19|o<<13)^(o>>>29|s<<3)^(s>>>6|o<<26)}function getCarry(s,o){return s>>>0<o>>>0?1:0}a(Sha512,u),Sha512.prototype.init=function(){return this._ah=1779033703,this._bh=3144134277,this._ch=1013904242,this._dh=2773480762,this._eh=1359893119,this._fh=2600822924,this._gh=528734635,this._hh=1541459225,this._al=4089235720,this._bl=2227873595,this._cl=4271175723,this._dl=1595750129,this._el=2917565137,this._fl=725511199,this._gl=4215389547,this._hl=327033209,this},Sha512.prototype._update=function(s){for(var o=this._w,i=0|this._ah,a=0|this._bh,u=0|this._ch,_=0|this._dh,x=0|this._eh,C=0|this._fh,j=0|this._gh,L=0|this._hh,B=0|this._al,$=0|this._bl,U=0|this._cl,V=0|this._dl,z=0|this._el,Y=0|this._fl,Z=0|this._gl,ee=0|this._hl,ie=0;ie<32;ie+=2)o[ie]=s.readInt32BE(4*ie),o[ie+1]=s.readInt32BE(4*ie+4);for(;ie<160;ie+=2){var ae=o[ie-30],ce=o[ie-30+1],le=Gamma0(ae,ce),pe=Gamma0l(ce,ae),de=Gamma1(ae=o[ie-4],ce=o[ie-4+1]),fe=Gamma1l(ce,ae),ye=o[ie-14],be=o[ie-14+1],Se=o[ie-32],_e=o[ie-32+1],we=pe+be|0,xe=le+ye+getCarry(we,pe)|0;xe=(xe=xe+de+getCarry(we=we+fe|0,fe)|0)+Se+getCarry(we=we+_e|0,_e)|0,o[ie]=xe,o[ie+1]=we}for(var Pe=0;Pe<160;Pe+=2){xe=o[Pe],we=o[Pe+1];var Te=maj(i,a,u),Re=maj(B,$,U),$e=sigma0(i,B),qe=sigma0(B,i),ze=sigma1(x,z),We=sigma1(z,x),He=w[Pe],Ye=w[Pe+1],Xe=Ch(x,C,j),Qe=Ch(z,Y,Z),et=ee+We|0,tt=L+ze+getCarry(et,ee)|0;tt=(tt=(tt=tt+Xe+getCarry(et=et+Qe|0,Qe)|0)+He+getCarry(et=et+Ye|0,Ye)|0)+xe+getCarry(et=et+we|0,we)|0;var rt=qe+Re|0,nt=$e+Te+getCarry(rt,qe)|0;L=j,ee=Z,j=C,Z=Y,C=x,Y=z,x=_+tt+getCarry(z=V+et|0,V)|0,_=u,V=U,u=a,U=$,a=i,$=B,i=tt+nt+getCarry(B=et+rt|0,et)|0}this._al=this._al+B|0,this._bl=this._bl+$|0,this._cl=this._cl+U|0,this._dl=this._dl+V|0,this._el=this._el+z|0,this._fl=this._fl+Y|0,this._gl=this._gl+Z|0,this._hl=this._hl+ee|0,this._ah=this._ah+i+getCarry(this._al,B)|0,this._bh=this._bh+a+getCarry(this._bl,$)|0,this._ch=this._ch+u+getCarry(this._cl,U)|0,this._dh=this._dh+_+getCarry(this._dl,V)|0,this._eh=this._eh+x+getCarry(this._el,z)|0,this._fh=this._fh+C+getCarry(this._fl,Y)|0,this._gh=this._gh+j+getCarry(this._gl,Z)|0,this._hh=this._hh+L+getCarry(this._hl,ee)|0},Sha512.prototype._hash=function(){var s=_.allocUnsafe(64);function writeInt64BE(o,i,a){s.writeInt32BE(o,a),s.writeInt32BE(i,a+4)}return writeInt64BE(this._ah,this._al,0),writeInt64BE(this._bh,this._bl,8),writeInt64BE(this._ch,this._cl,16),writeInt64BE(this._dh,this._dl,24),writeInt64BE(this._eh,this._el,32),writeInt64BE(this._fh,this._fl,40),writeInt64BE(this._gh,this._gl,48),writeInt64BE(this._hh,this._hl,56),s},s.exports=Sha512},8068(s){"use strict";var o=(()=>{var s=Object.defineProperty,o=Object.getOwnPropertyDescriptor,i=Object.getOwnPropertyNames,a=Object.getOwnPropertySymbols,u=Object.prototype.hasOwnProperty,_=Object.prototype.propertyIsEnumerable,__defNormalProp=(o,i,a)=>i in o?s(o,i,{enumerable:!0,configurable:!0,writable:!0,value:a}):o[i]=a,__spreadValues=(s,o)=>{for(var i in o||(o={}))u.call(o,i)&&__defNormalProp(s,i,o[i]);if(a)for(var i of a(o))_.call(o,i)&&__defNormalProp(s,i,o[i]);return s},__publicField=(s,o,i)=>__defNormalProp(s,"symbol"!=typeof o?o+"":o,i),w={};((o,i)=>{for(var a in i)s(o,a,{get:i[a],enumerable:!0})})(w,{DEFAULT_OPTIONS:()=>C,DEFAULT_UUID_LENGTH:()=>x,default:()=>B});var x=6,C={dictionary:"alphanum",shuffle:!0,debug:!1,length:x,counter:0},j=class _ShortUniqueId{constructor(s={}){__publicField(this,"counter"),__publicField(this,"debug"),__publicField(this,"dict"),__publicField(this,"version"),__publicField(this,"dictIndex",0),__publicField(this,"dictRange",[]),__publicField(this,"lowerBound",0),__publicField(this,"upperBound",0),__publicField(this,"dictLength",0),__publicField(this,"uuidLength"),__publicField(this,"_digit_first_ascii",48),__publicField(this,"_digit_last_ascii",58),__publicField(this,"_alpha_lower_first_ascii",97),__publicField(this,"_alpha_lower_last_ascii",123),__publicField(this,"_hex_last_ascii",103),__publicField(this,"_alpha_upper_first_ascii",65),__publicField(this,"_alpha_upper_last_ascii",91),__publicField(this,"_number_dict_ranges",{digits:[this._digit_first_ascii,this._digit_last_ascii]}),__publicField(this,"_alpha_dict_ranges",{lowerCase:[this._alpha_lower_first_ascii,this._alpha_lower_last_ascii],upperCase:[this._alpha_upper_first_ascii,this._alpha_upper_last_ascii]}),__publicField(this,"_alpha_lower_dict_ranges",{lowerCase:[this._alpha_lower_first_ascii,this._alpha_lower_last_ascii]}),__publicField(this,"_alpha_upper_dict_ranges",{upperCase:[this._alpha_upper_first_ascii,this._alpha_upper_last_ascii]}),__publicField(this,"_alphanum_dict_ranges",{digits:[this._digit_first_ascii,this._digit_last_ascii],lowerCase:[this._alpha_lower_first_ascii,this._alpha_lower_last_ascii],upperCase:[this._alpha_upper_first_ascii,this._alpha_upper_last_ascii]}),__publicField(this,"_alphanum_lower_dict_ranges",{digits:[this._digit_first_ascii,this._digit_last_ascii],lowerCase:[this._alpha_lower_first_ascii,this._alpha_lower_last_ascii]}),__publicField(this,"_alphanum_upper_dict_ranges",{digits:[this._digit_first_ascii,this._digit_last_ascii],upperCase:[this._alpha_upper_first_ascii,this._alpha_upper_last_ascii]}),__publicField(this,"_hex_dict_ranges",{decDigits:[this._digit_first_ascii,this._digit_last_ascii],alphaDigits:[this._alpha_lower_first_ascii,this._hex_last_ascii]}),__publicField(this,"_dict_ranges",{_number_dict_ranges:this._number_dict_ranges,_alpha_dict_ranges:this._alpha_dict_ranges,_alpha_lower_dict_ranges:this._alpha_lower_dict_ranges,_alpha_upper_dict_ranges:this._alpha_upper_dict_ranges,_alphanum_dict_ranges:this._alphanum_dict_ranges,_alphanum_lower_dict_ranges:this._alphanum_lower_dict_ranges,_alphanum_upper_dict_ranges:this._alphanum_upper_dict_ranges,_hex_dict_ranges:this._hex_dict_ranges}),__publicField(this,"log",((...s)=>{const o=[...s];o[0]="[short-unique-id] ".concat(s[0]),!0!==this.debug||"undefined"==typeof console||null===console||console.log(...o)})),__publicField(this,"_normalizeDictionary",((s,o)=>{let i;if(s&&Array.isArray(s)&&s.length>1)i=s;else{i=[],this.dictIndex=0;const o="_".concat(s,"_dict_ranges"),a=this._dict_ranges[o];let u=0;for(const[,s]of Object.entries(a)){const[o,i]=s;u+=Math.abs(i-o)}i=new Array(u);let _=0;for(const[,s]of Object.entries(a)){this.dictRange=s,this.lowerBound=this.dictRange[0],this.upperBound=this.dictRange[1];const o=this.lowerBound<=this.upperBound,a=this.lowerBound,u=this.upperBound;if(o)for(let s=a;s<u;s++)i[_++]=String.fromCharCode(s),this.dictIndex=s;else for(let s=a;s>u;s--)i[_++]=String.fromCharCode(s),this.dictIndex=s}i.length=_}if(o){for(let s=i.length-1;s>0;s--){const o=Math.floor(Math.random()*(s+1));[i[s],i[o]]=[i[o],i[s]]}}return i})),__publicField(this,"setDictionary",((s,o)=>{this.dict=this._normalizeDictionary(s,o),this.dictLength=this.dict.length,this.setCounter(0)})),__publicField(this,"seq",(()=>this.sequentialUUID())),__publicField(this,"sequentialUUID",(()=>{const s=this.dictLength,o=this.dict;let i=this.counter;const a=[];do{const u=i%s;i=Math.trunc(i/s),a.push(o[u])}while(0!==i);const u=a.join("");return this.counter+=1,u})),__publicField(this,"rnd",((s=this.uuidLength||x)=>this.randomUUID(s))),__publicField(this,"randomUUID",((s=this.uuidLength||x)=>{if(null==s||s<1)throw new Error("Invalid UUID Length Provided");const o=new Array(s),i=this.dictLength,a=this.dict;for(let u=0;u<s;u++){const s=Math.floor(Math.random()*i);o[u]=a[s]}return o.join("")})),__publicField(this,"fmt",((s,o)=>this.formattedUUID(s,o))),__publicField(this,"formattedUUID",((s,o)=>{const i={$r:this.randomUUID,$s:this.sequentialUUID,$t:this.stamp};return s.replace(/\$[rs]\d{0,}|\$t0|\$t[1-9]\d{1,}/g,(s=>{const a=s.slice(0,2),u=Number.parseInt(s.slice(2),10);return"$s"===a?i[a]().padStart(u,"0"):"$t"===a&&o?i[a](u,o):i[a](u)}))})),__publicField(this,"availableUUIDs",((s=this.uuidLength)=>Number.parseFloat(([...new Set(this.dict)].length**s).toFixed(0)))),__publicField(this,"_collisionCache",new Map),__publicField(this,"approxMaxBeforeCollision",((s=this.availableUUIDs(this.uuidLength))=>{const o=s,i=this._collisionCache.get(o);if(void 0!==i)return i;const a=Number.parseFloat(Math.sqrt(Math.PI/2*s).toFixed(20));return this._collisionCache.set(o,a),a})),__publicField(this,"collisionProbability",((s=this.availableUUIDs(this.uuidLength),o=this.uuidLength)=>Number.parseFloat((this.approxMaxBeforeCollision(s)/this.availableUUIDs(o)).toFixed(20)))),__publicField(this,"uniqueness",((s=this.availableUUIDs(this.uuidLength))=>{const o=Number.parseFloat((1-this.approxMaxBeforeCollision(s)/s).toFixed(20));return o>1?1:o<0?0:o})),__publicField(this,"getVersion",(()=>this.version)),__publicField(this,"stamp",((s,o)=>{const i=Math.floor(+(o||new Date)/1e3).toString(16);if("number"==typeof s&&0===s)return i;if("number"!=typeof s||s<10)throw new Error(["Param finalLength must be a number greater than or equal to 10,","or 0 if you want the raw hexadecimal timestamp"].join("\n"));const a=s-9,u=Math.round(Math.random()*(a>15?15:a)),_=this.randomUUID(a);return"".concat(_.substring(0,u)).concat(i).concat(_.substring(u)).concat(u.toString(16))})),__publicField(this,"parseStamp",((s,o)=>{if(o&&!/t0|t[1-9]\d{1,}/.test(o))throw new Error("Cannot extract date from a formated UUID with no timestamp in the format");const i=o?o.replace(/\$[rs]\d{0,}|\$t0|\$t[1-9]\d{1,}/g,(s=>{const o={$r:s=>[...Array(s)].map((()=>"r")).join(""),$s:s=>[...Array(s)].map((()=>"s")).join(""),$t:s=>[...Array(s)].map((()=>"t")).join("")},i=s.slice(0,2),a=Number.parseInt(s.slice(2),10);return o[i](a)})).replace(/^(.*?)(t{8,})(.*)$/g,((o,i,a)=>s.substring(i.length,i.length+a.length))):s;if(8===i.length)return new Date(1e3*Number.parseInt(i,16));if(i.length<10)throw new Error("Stamp length invalid");const a=Number.parseInt(i.substring(i.length-1),16);return new Date(1e3*Number.parseInt(i.substring(a,a+8),16))})),__publicField(this,"setCounter",(s=>{this.counter=s})),__publicField(this,"validate",((s,o)=>{const i=o?this._normalizeDictionary(o):this.dict;return s.split("").every((s=>i.includes(s)))}));const o=__spreadValues(__spreadValues({},C),s);this.counter=0,this.debug=!1,this.dict=[],this.version="5.3.2";const{dictionary:i,shuffle:a,length:u,counter:_}=o;this.uuidLength=u,this.setDictionary(i,a),this.setCounter(_),this.debug=o.debug,this.log(this.dict),this.log("Generator instantiated with Dictionary Size ".concat(this.dictLength," and counter set to ").concat(this.counter)),this.log=this.log.bind(this),this.setDictionary=this.setDictionary.bind(this),this.setCounter=this.setCounter.bind(this),this.seq=this.seq.bind(this),this.sequentialUUID=this.sequentialUUID.bind(this),this.rnd=this.rnd.bind(this),this.randomUUID=this.randomUUID.bind(this),this.fmt=this.fmt.bind(this),this.formattedUUID=this.formattedUUID.bind(this),this.availableUUIDs=this.availableUUIDs.bind(this),this.approxMaxBeforeCollision=this.approxMaxBeforeCollision.bind(this),this.collisionProbability=this.collisionProbability.bind(this),this.uniqueness=this.uniqueness.bind(this),this.getVersion=this.getVersion.bind(this),this.stamp=this.stamp.bind(this),this.parseStamp=this.parseStamp.bind(this)}};__publicField(j,"default",j);var L,B=j;return L=w,((a,_,w,x)=>{if(_&&"object"==typeof _||"function"==typeof _)for(let C of i(_))u.call(a,C)||C===w||s(a,C,{get:()=>_[C],enumerable:!(x=o(_,C))||x.enumerable});return a})(s({},"__esModule",{value:!0}),L)})();s.exports=o.default,"undefined"!=typeof window&&(o=o.default)},88310(s,o,i){s.exports=Stream;var a=i(37007).EventEmitter;function Stream(){a.call(this)}i(56698)(Stream,a),Stream.Readable=i(45412),Stream.Writable=i(16708),Stream.Duplex=i(25382),Stream.Transform=i(74610),Stream.PassThrough=i(63600),Stream.finished=i(86238),Stream.pipeline=i(57758),Stream.Stream=Stream,Stream.prototype.pipe=function(s,o){var i=this;function ondata(o){s.writable&&!1===s.write(o)&&i.pause&&i.pause()}function ondrain(){i.readable&&i.resume&&i.resume()}i.on("data",ondata),s.on("drain",ondrain),s._isStdio||o&&!1===o.end||(i.on("end",onend),i.on("close",onclose));var u=!1;function onend(){u||(u=!0,s.end())}function onclose(){u||(u=!0,"function"==typeof s.destroy&&s.destroy())}function onerror(s){if(cleanup(),0===a.listenerCount(this,"error"))throw s}function cleanup(){i.removeListener("data",ondata),s.removeListener("drain",ondrain),i.removeListener("end",onend),i.removeListener("close",onclose),i.removeListener("error",onerror),s.removeListener("error",onerror),i.removeListener("end",cleanup),i.removeListener("close",cleanup),s.removeListener("close",cleanup)}return i.on("error",onerror),s.on("error",onerror),i.on("end",cleanup),i.on("close",cleanup),s.on("close",cleanup),s.emit("pipe",i),s}},83141(s,o,i){"use strict";var a=i(92861).Buffer,u=a.isEncoding||function(s){switch((s=""+s)&&s.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return!0;default:return!1}};function StringDecoder(s){var o;switch(this.encoding=function normalizeEncoding(s){var o=function _normalizeEncoding(s){if(!s)return"utf8";for(var o;;)switch(s){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return s;default:if(o)return;s=(""+s).toLowerCase(),o=!0}}(s);if("string"!=typeof o&&(a.isEncoding===u||!u(s)))throw new Error("Unknown encoding: "+s);return o||s}(s),this.encoding){case"utf16le":this.text=utf16Text,this.end=utf16End,o=4;break;case"utf8":this.fillLast=utf8FillLast,o=4;break;case"base64":this.text=base64Text,this.end=base64End,o=3;break;default:return this.write=simpleWrite,void(this.end=simpleEnd)}this.lastNeed=0,this.lastTotal=0,this.lastChar=a.allocUnsafe(o)}function utf8CheckByte(s){return s<=127?0:s>>5==6?2:s>>4==14?3:s>>3==30?4:s>>6==2?-1:-2}function utf8FillLast(s){var o=this.lastTotal-this.lastNeed,i=function utf8CheckExtraBytes(s,o,i){if(128!=(192&o[0]))return s.lastNeed=0,"�";if(s.lastNeed>1&&o.length>1){if(128!=(192&o[1]))return s.lastNeed=1,"�";if(s.lastNeed>2&&o.length>2&&128!=(192&o[2]))return s.lastNeed=2,"�"}}(this,s);return void 0!==i?i:this.lastNeed<=s.length?(s.copy(this.lastChar,o,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(s.copy(this.lastChar,o,0,s.length),void(this.lastNeed-=s.length))}function utf16Text(s,o){if((s.length-o)%2==0){var i=s.toString("utf16le",o);if(i){var a=i.charCodeAt(i.length-1);if(a>=55296&&a<=56319)return this.lastNeed=2,this.lastTotal=4,this.lastChar[0]=s[s.length-2],this.lastChar[1]=s[s.length-1],i.slice(0,-1)}return i}return this.lastNeed=1,this.lastTotal=2,this.lastChar[0]=s[s.length-1],s.toString("utf16le",o,s.length-1)}function utf16End(s){var o=s&&s.length?this.write(s):"";if(this.lastNeed){var i=this.lastTotal-this.lastNeed;return o+this.lastChar.toString("utf16le",0,i)}return o}function base64Text(s,o){var i=(s.length-o)%3;return 0===i?s.toString("base64",o):(this.lastNeed=3-i,this.lastTotal=3,1===i?this.lastChar[0]=s[s.length-1]:(this.lastChar[0]=s[s.length-2],this.lastChar[1]=s[s.length-1]),s.toString("base64",o,s.length-i))}function base64End(s){var o=s&&s.length?this.write(s):"";return this.lastNeed?o+this.lastChar.toString("base64",0,3-this.lastNeed):o}function simpleWrite(s){return s.toString(this.encoding)}function simpleEnd(s){return s&&s.length?this.write(s):""}o.I=StringDecoder,StringDecoder.prototype.write=function(s){if(0===s.length)return"";var o,i;if(this.lastNeed){if(void 0===(o=this.fillLast(s)))return"";i=this.lastNeed,this.lastNeed=0}else i=0;return i<s.length?o?o+this.text(s,i):this.text(s,i):o||""},StringDecoder.prototype.end=function utf8End(s){var o=s&&s.length?this.write(s):"";return this.lastNeed?o+"�":o},StringDecoder.prototype.text=function utf8Text(s,o){var i=function utf8CheckIncomplete(s,o,i){var a=o.length-1;if(a<i)return 0;var u=utf8CheckByte(o[a]);if(u>=0)return u>0&&(s.lastNeed=u-1),u;if(--a<i||-2===u)return 0;if(u=utf8CheckByte(o[a]),u>=0)return u>0&&(s.lastNeed=u-2),u;if(--a<i||-2===u)return 0;if(u=utf8CheckByte(o[a]),u>=0)return u>0&&(2===u?u=0:s.lastNeed=u-3),u;return 0}(this,s,o);if(!this.lastNeed)return s.toString("utf8",o);this.lastTotal=i;var a=s.length-(i-this.lastNeed);return s.copy(this.lastChar,0,a),s.toString("utf8",o,a)},StringDecoder.prototype.fillLast=function(s){if(this.lastNeed<=s.length)return s.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal);s.copy(this.lastChar,this.lastTotal-this.lastNeed,0,s.length),this.lastNeed-=s.length}},15377(s,o,i){"use strict";var a=i(92861).Buffer,u=i(64634),_=i(74372),w=ArrayBuffer.isView||function isView(s){try{return _(s),!0}catch(s){return!1}},x="undefined"!=typeof Uint8Array,C="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array,j=C&&(a.prototype instanceof Uint8Array||a.TYPED_ARRAY_SUPPORT);s.exports=function toBuffer(s,o){if(s instanceof a)return s;if("string"==typeof s)return a.from(s,o);if(C&&w(s)){if(0===s.byteLength)return a.alloc(0);if(j){var i=a.from(s.buffer,s.byteOffset,s.byteLength);if(i.byteLength===s.byteLength)return i}var _=s instanceof Uint8Array?s:new Uint8Array(s.buffer,s.byteOffset,s.byteLength),L=a.from(_);if(L.length===s.byteLength)return L}if(x&&s instanceof Uint8Array)return a.from(s);var B=u(s);if(B)for(var $=0;$<s.length;$+=1){var U=s[$];if("number"!=typeof U||U<0||U>255||~~U!==U)throw new RangeError("Array items must be numbers in the range 0-255.")}if(B||a.isBuffer(s)&&s.constructor&&"function"==typeof s.constructor.isBuffer&&s.constructor.isBuffer(s))return a.from(s);throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.')}},16426(s){s.exports=function(){var s=document.getSelection();if(!s.rangeCount)return function(){};for(var o=document.activeElement,i=[],a=0;a<s.rangeCount;a++)i.push(s.getRangeAt(a));switch(o.tagName.toUpperCase()){case"INPUT":case"TEXTAREA":o.blur();break;default:o=null}return s.removeAllRanges(),function(){"Caret"===s.type&&s.removeAllRanges(),s.rangeCount||i.forEach((function(o){s.addRange(o)})),o&&o.focus()}}},74372(s,o,i){"use strict";var a=i(69675),u=i(36556)("TypedArray.prototype.buffer",!0),_=i(35680);s.exports=u||function typedArrayBuffer(s){if(!_(s))throw new a("Not a Typed Array");return s.buffer}},61160(s,o,i){"use strict";var a=i(92063),u=i(73992),_=/^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/,w=/[\n\r\t]/g,x=/^[A-Za-z][A-Za-z0-9+-.]*:\/\//,C=/:\d+$/,j=/^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i,L=/^[a-zA-Z]:/;function trimLeft(s){return(s||"").toString().replace(_,"")}var B=[["#","hash"],["?","query"],function sanitize(s,o){return isSpecial(o.protocol)?s.replace(/\\/g,"/"):s},["/","pathname"],["@","auth",1],[NaN,"host",void 0,1,1],[/:(\d*)$/,"port",void 0,1],[NaN,"hostname",void 0,1,1]],$={hash:1,query:1};function lolcation(s){var o,a=("undefined"!=typeof window?window:void 0!==i.g?i.g:"undefined"!=typeof self?self:{}).location||{},u={},_=typeof(s=s||a);if("blob:"===s.protocol)u=new Url(unescape(s.pathname),{});else if("string"===_)for(o in u=new Url(s,{}),$)delete u[o];else if("object"===_){for(o in s)o in $||(u[o]=s[o]);void 0===u.slashes&&(u.slashes=x.test(s.href))}return u}function isSpecial(s){return"file:"===s||"ftp:"===s||"http:"===s||"https:"===s||"ws:"===s||"wss:"===s}function extractProtocol(s,o){s=(s=trimLeft(s)).replace(w,""),o=o||{};var i,a=j.exec(s),u=a[1]?a[1].toLowerCase():"",_=!!a[2],x=!!a[3],C=0;return _?x?(i=a[2]+a[3]+a[4],C=a[2].length+a[3].length):(i=a[2]+a[4],C=a[2].length):x?(i=a[3]+a[4],C=a[3].length):i=a[4],"file:"===u?C>=2&&(i=i.slice(2)):isSpecial(u)?i=a[4]:u?_&&(i=i.slice(2)):C>=2&&isSpecial(o.protocol)&&(i=a[4]),{protocol:u,slashes:_||isSpecial(u),slashesCount:C,rest:i}}function Url(s,o,i){if(s=(s=trimLeft(s)).replace(w,""),!(this instanceof Url))return new Url(s,o,i);var _,x,C,j,$,U,V=B.slice(),z=typeof o,Y=this,Z=0;for("object"!==z&&"string"!==z&&(i=o,o=null),i&&"function"!=typeof i&&(i=u.parse),_=!(x=extractProtocol(s||"",o=lolcation(o))).protocol&&!x.slashes,Y.slashes=x.slashes||_&&o.slashes,Y.protocol=x.protocol||o.protocol||"",s=x.rest,("file:"===x.protocol&&(2!==x.slashesCount||L.test(s))||!x.slashes&&(x.protocol||x.slashesCount<2||!isSpecial(Y.protocol)))&&(V[3]=[/(.*)/,"pathname"]);Z<V.length;Z++)"function"!=typeof(j=V[Z])?(C=j[0],U=j[1],C!=C?Y[U]=s:"string"==typeof C?~($="@"===C?s.lastIndexOf(C):s.indexOf(C))&&("number"==typeof j[2]?(Y[U]=s.slice(0,$),s=s.slice($+j[2])):(Y[U]=s.slice($),s=s.slice(0,$))):($=C.exec(s))&&(Y[U]=$[1],s=s.slice(0,$.index)),Y[U]=Y[U]||_&&j[3]&&o[U]||"",j[4]&&(Y[U]=Y[U].toLowerCase())):s=j(s,Y);i&&(Y.query=i(Y.query)),_&&o.slashes&&"/"!==Y.pathname.charAt(0)&&(""!==Y.pathname||""!==o.pathname)&&(Y.pathname=function resolve(s,o){if(""===s)return o;for(var i=(o||"/").split("/").slice(0,-1).concat(s.split("/")),a=i.length,u=i[a-1],_=!1,w=0;a--;)"."===i[a]?i.splice(a,1):".."===i[a]?(i.splice(a,1),w++):w&&(0===a&&(_=!0),i.splice(a,1),w--);return _&&i.unshift(""),"."!==u&&".."!==u||i.push(""),i.join("/")}(Y.pathname,o.pathname)),"/"!==Y.pathname.charAt(0)&&isSpecial(Y.protocol)&&(Y.pathname="/"+Y.pathname),a(Y.port,Y.protocol)||(Y.host=Y.hostname,Y.port=""),Y.username=Y.password="",Y.auth&&(~($=Y.auth.indexOf(":"))?(Y.username=Y.auth.slice(0,$),Y.username=encodeURIComponent(decodeURIComponent(Y.username)),Y.password=Y.auth.slice($+1),Y.password=encodeURIComponent(decodeURIComponent(Y.password))):Y.username=encodeURIComponent(decodeURIComponent(Y.auth)),Y.auth=Y.password?Y.username+":"+Y.password:Y.username),Y.origin="file:"!==Y.protocol&&isSpecial(Y.protocol)&&Y.host?Y.protocol+"//"+Y.host:"null",Y.href=Y.toString()}Url.prototype={set:function set(s,o,i){var _=this;switch(s){case"query":"string"==typeof o&&o.length&&(o=(i||u.parse)(o)),_[s]=o;break;case"port":_[s]=o,a(o,_.protocol)?o&&(_.host=_.hostname+":"+o):(_.host=_.hostname,_[s]="");break;case"hostname":_[s]=o,_.port&&(o+=":"+_.port),_.host=o;break;case"host":_[s]=o,C.test(o)?(o=o.split(":"),_.port=o.pop(),_.hostname=o.join(":")):(_.hostname=o,_.port="");break;case"protocol":_.protocol=o.toLowerCase(),_.slashes=!i;break;case"pathname":case"hash":if(o){var w="pathname"===s?"/":"#";_[s]=o.charAt(0)!==w?w+o:o}else _[s]=o;break;case"username":case"password":_[s]=encodeURIComponent(o);break;case"auth":var x=o.indexOf(":");~x?(_.username=o.slice(0,x),_.username=encodeURIComponent(decodeURIComponent(_.username)),_.password=o.slice(x+1),_.password=encodeURIComponent(decodeURIComponent(_.password))):_.username=encodeURIComponent(decodeURIComponent(o))}for(var j=0;j<B.length;j++){var L=B[j];L[4]&&(_[L[1]]=_[L[1]].toLowerCase())}return _.auth=_.password?_.username+":"+_.password:_.username,_.origin="file:"!==_.protocol&&isSpecial(_.protocol)&&_.host?_.protocol+"//"+_.host:"null",_.href=_.toString(),_},toString:function toString(s){s&&"function"==typeof s||(s=u.stringify);var o,i=this,a=i.host,_=i.protocol;_&&":"!==_.charAt(_.length-1)&&(_+=":");var w=_+(i.protocol&&i.slashes||isSpecial(i.protocol)?"//":"");return i.username?(w+=i.username,i.password&&(w+=":"+i.password),w+="@"):i.password?(w+=":"+i.password,w+="@"):"file:"!==i.protocol&&isSpecial(i.protocol)&&!a&&"/"!==i.pathname&&(w+="@"),(":"===a[a.length-1]||C.test(i.hostname)&&!i.port)&&(a+=":"),w+=a+i.pathname,(o="object"==typeof i.query?s(i.query):i.query)&&(w+="?"!==o.charAt(0)?"?"+o:o),i.hash&&(w+=i.hash),w}},Url.extractProtocol=extractProtocol,Url.location=lolcation,Url.trimLeft=trimLeft,Url.qs=u,s.exports=Url},85160(s,o,i){"use strict";var a=i(96540);var u="function"==typeof Object.is?Object.is:function is(s,o){return s===o&&(0!==s||1/s==1/o)||s!=s&&o!=o},_=a.useSyncExternalStore,w=a.useRef,x=a.useEffect,C=a.useMemo,j=a.useDebugValue},78418(s,o,i){"use strict";i(85160)},94643(s,o,i){function config(s){try{if(!i.g.localStorage)return!1}catch(s){return!1}var o=i.g.localStorage[s];return null!=o&&"true"===String(o).toLowerCase()}s.exports=function deprecate(s,o){if(config("noDeprecation"))return s;var i=!1;return function deprecated(){if(!i){if(config("throwDeprecation"))throw new Error(o);config("traceDeprecation")?console.trace(o):console.warn(o),i=!0}return s.apply(this,arguments)}}},25767(s,o,i){"use strict";var a=i(82682),u=i(39209),_=i(10487),w=i(36556),x=i(75795),C=w("Object.prototype.toString"),j=i(49092)(),L="undefined"==typeof globalThis?i.g:globalThis,B=u(),$=w("String.prototype.slice"),U=Object.getPrototypeOf,V=w("Array.prototype.indexOf",!0)||function indexOf(s,o){for(var i=0;i<s.length;i+=1)if(s[i]===o)return i;return-1},z={__proto__:null};a(B,j&&x&&U?function(s){var o=new L[s];if(Symbol.toStringTag in o){var i=U(o),a=x(i,Symbol.toStringTag);if(!a){var u=U(i);a=x(u,Symbol.toStringTag)}z["$"+s]=_(a.get)}}:function(s){var o=new L[s],i=o.slice||o.set;i&&(z["$"+s]=_(i))});s.exports=function whichTypedArray(s){if(!s||"object"!=typeof s)return!1;if(!j){var o=$(C(s),8,-1);return V(B,o)>-1?o:"Object"===o&&function tryAllSlices(s){var o=!1;return a(z,(function(i,a){if(!o)try{i(s),o=$(a,1)}catch(s){}})),o}(s)}return x?function tryAllTypedArrays(s){var o=!1;return a(z,(function(i,a){if(!o)try{"$"+i(s)===a&&(o=$(a,1))}catch(s){}})),o}(s):null}},26657(s,o,i){"use strict";var a=i(75208),u=function isClosingTag(s){return/<\/+[^>]+>/.test(s)},_=function isSelfClosingTag(s){return/<[^>]+\/>/.test(s)};function getType(s){return u(s)?"ClosingTag":function isOpeningTag(s){return function isTag(s){return/<[^>!]+>/.test(s)}(s)&&!u(s)&&!_(s)}(s)?"OpeningTag":_(s)?"SelfClosingTag":"Text"}s.exports=function(s){var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=o.indentor,u=o.textNodesOnSameLine,_=0,w=[];i=i||"    ";var x=function lexer(s){return function splitOnTags(s){return s.split(/(<\/?[^>]+>)/g).filter((function(s){return""!==s.trim()}))}(s).map((function(s){return{value:s,type:getType(s)}}))}(s).map((function(s,o,x){var C=s.value,j=s.type;"ClosingTag"===j&&_--;var L=a(i,_),B=L+C;if("OpeningTag"===j&&_++,u){var $=x[o-1],U=x[o-2];"ClosingTag"===j&&"Text"===$.type&&"OpeningTag"===U.type&&(B=""+L+U.value+$.value+C,w.push(o-2,o-1))}return B}));return w.forEach((function(s){return x[s]=null})),x.filter((function(s){return!!s})).join("\n")}},31499(s){var o={"&":"&amp;",'"':"&quot;","'":"&apos;","<":"&lt;",">":"&gt;"};s.exports=function escapeForXML(s){return s&&s.replace?s.replace(/([&"<>'])/g,(function(s,i){return o[i]})):s}},19123(s,o,i){var a=i(65606),u=i(31499),_=i(88310).Stream;function resolve(s,o,i){var a,_=function create_indent(s,o){return new Array(o||0).join(s||"")}(o,i=i||0),w=s;if("object"==typeof s&&((w=s[a=Object.keys(s)[0]])&&w._elem))return w._elem.name=a,w._elem.icount=i,w._elem.indent=o,w._elem.indents=_,w._elem.interrupt=w,w._elem;var x,C=[],j=[];function get_attributes(s){Object.keys(s).forEach((function(o){C.push(function attribute(s,o){return s+'="'+u(o)+'"'}(o,s[o]))}))}switch(typeof w){case"object":if(null===w)break;w._attr&&get_attributes(w._attr),w._cdata&&j.push(("<![CDATA["+w._cdata).replace(/\]\]>/g,"]]]]><![CDATA[>")+"]]>"),w.forEach&&(x=!1,j.push(""),w.forEach((function(s){"object"==typeof s?"_attr"==Object.keys(s)[0]?get_attributes(s._attr):j.push(resolve(s,o,i+1)):(j.pop(),x=!0,j.push(u(s)))})),x||j.push(""));break;default:j.push(u(w))}return{name:a,interrupt:!1,attributes:C,content:j,icount:i,indents:_,indent:o}}function format(s,o,i){if("object"!=typeof o)return s(!1,o);var a=o.interrupt?1:o.content.length;function proceed(){for(;o.content.length;){var u=o.content.shift();if(void 0!==u){if(interrupt(u))return;format(s,u)}}s(!1,(a>1?o.indents:"")+(o.name?"</"+o.name+">":"")+(o.indent&&!i?"\n":"")),i&&i()}function interrupt(o){return!!o.interrupt&&(o.interrupt.append=s,o.interrupt.end=proceed,o.interrupt=!1,s(!0),!0)}if(s(!1,o.indents+(o.name?"<"+o.name:"")+(o.attributes.length?" "+o.attributes.join(" "):"")+(a?o.name?">":"":o.name?"/>":"")+(o.indent&&a>1?"\n":"")),!a)return s(!1,o.indent?"\n":"");interrupt(o)||proceed()}s.exports=function xml(s,o){"object"!=typeof o&&(o={indent:o});var i=o.stream?new _:null,u="",w=!1,x=o.indent?!0===o.indent?"    ":o.indent:"",C=!0;function delay(s){C?a.nextTick(s):s()}function append(s,o){if(void 0!==o&&(u+=o),s&&!w&&(i=i||new _,w=!0),s&&w){var a=u;delay((function(){i.emit("data",a)})),u=""}}function add(s,o){format(append,resolve(s,x,x?1:0),o)}function end(){if(i){var s=u;delay((function(){i.emit("data",s),i.emit("end"),i.readable=!1,i.emit("close")}))}}return delay((function(){C=!1})),o.declaration&&function addXmlDeclaration(s){var o={version:"1.0",encoding:s.encoding||"UTF-8"};s.standalone&&(o.standalone=s.standalone),add({"?xml":{_attr:o}}),u=u.replace("/>","?>")}(o.declaration),s&&s.forEach?s.forEach((function(o,i){var a;i+1===s.length&&(a=end),add(o,a)})):add(s,end),i?(i.readable=!0,i):u},s.exports.element=s.exports.Element=function element(){var s={_elem:resolve(Array.prototype.slice.call(arguments)),push:function(s){if(!this.append)throw new Error("not assigned to a parent!");var o=this,i=this._elem.indent;format(this.append,resolve(s,i,this._elem.icount+(i?1:0)),(function(){o.append(!0)}))},close:function(s){void 0!==s&&this.push(s),this.end&&this.end()}};return s}},86215(s,o){var i,a,u;a=[],i=function(){"use strict";var isNativeSmoothScrollEnabledOn=function(s){return s&&"getComputedStyle"in window&&"smooth"===window.getComputedStyle(s)["scroll-behavior"]};if("undefined"==typeof window||!("document"in window))return{};var makeScroller=function(s,o,i){var a;o=o||999,i||0===i||(i=9);var setScrollTimeoutId=function(s){a=s},stopScroll=function(){clearTimeout(a),setScrollTimeoutId(0)},getTopWithEdgeOffset=function(o){return Math.max(0,s.getTopOf(o)-i)},scrollToY=function(i,a,u){if(stopScroll(),0===a||a&&a<0||isNativeSmoothScrollEnabledOn(s.body))s.toY(i),u&&u();else{var _=s.getY(),w=Math.max(0,i)-_,x=(new Date).getTime();a=a||Math.min(Math.abs(w),o),function loopScroll(){setScrollTimeoutId(setTimeout((function(){var o=Math.min(1,((new Date).getTime()-x)/a),i=Math.max(0,Math.floor(_+w*(o<.5?2*o*o:o*(4-2*o)-1)));s.toY(i),o<1&&s.getHeight()+i<s.body.scrollHeight?loopScroll():(setTimeout(stopScroll,99),u&&u())}),9))}()}},scrollToElem=function(s,o,i){scrollToY(getTopWithEdgeOffset(s),o,i)},scrollIntoView=function(o,a,u){var _=o.getBoundingClientRect().height,w=s.getTopOf(o)+_,x=s.getHeight(),C=s.getY(),j=C+x;getTopWithEdgeOffset(o)<C||_+i>x?scrollToElem(o,a,u):w+i>j?scrollToY(w-x+i,a,u):u&&u()},scrollToCenterOf=function(o,i,a,u){scrollToY(Math.max(0,s.getTopOf(o)-s.getHeight()/2+(a||o.getBoundingClientRect().height/2)),i,u)};return{setup:function(s,a){return(0===s||s)&&(o=s),(0===a||a)&&(i=a),{defaultDuration:o,edgeOffset:i}},to:scrollToElem,toY:scrollToY,intoView:scrollIntoView,center:scrollToCenterOf,stop:stopScroll,moving:function(){return!!a},getY:s.getY,getTopOf:s.getTopOf}},s=document.documentElement,getDocY=function(){return window.scrollY||s.scrollTop},o=makeScroller({body:document.scrollingElement||document.body,toY:function(s){window.scrollTo(0,s)},getY:getDocY,getHeight:function(){return window.innerHeight||s.clientHeight},getTopOf:function(o){return o.getBoundingClientRect().top+getDocY()-s.offsetTop}});if(o.createScroller=function(o,i,a){return makeScroller({body:o,toY:function(s){o.scrollTop=s},getY:function(){return o.scrollTop},getHeight:function(){return Math.min(o.clientHeight,window.innerHeight||s.clientHeight)},getTopOf:function(s){return s.offsetTop}},i,a)},"addEventListener"in window&&!window.noZensmooth&&!isNativeSmoothScrollEnabledOn(document.body)){var i="history"in window&&"pushState"in history,a=i&&"scrollRestoration"in history;a&&(history.scrollRestoration="auto"),window.addEventListener("load",(function(){a&&(setTimeout((function(){history.scrollRestoration="manual"}),9),window.addEventListener("popstate",(function(s){s.state&&"zenscrollY"in s.state&&o.toY(s.state.zenscrollY)}),!1)),window.location.hash&&setTimeout((function(){var s=o.setup().edgeOffset;if(s){var i=document.getElementById(window.location.href.split("#")[1]);if(i){var a=Math.max(0,o.getTopOf(i)-s),u=o.getY()-a;0<=u&&u<9&&window.scrollTo(0,a)}}}),9)}),!1);var u=new RegExp("(^|\\s)noZensmooth(\\s|$)");window.addEventListener("click",(function(s){for(var _=s.target;_&&"A"!==_.tagName;)_=_.parentNode;if(!(!_||1!==s.which||s.shiftKey||s.metaKey||s.ctrlKey||s.altKey)){if(a){var w=history.state&&"object"==typeof history.state?history.state:{};w.zenscrollY=o.getY();try{history.replaceState(w,"")}catch(s){}}var x=_.getAttribute("href")||"";if(0===x.indexOf("#")&&!u.test(_.className)){var C=0,j=document.getElementById(x.substring(1));if("#"!==x){if(!j)return;C=o.getTopOf(j)}s.preventDefault();var onDone=function(){window.location=x},L=o.setup().edgeOffset;L&&(C=Math.max(0,C-L),i&&(onDone=function(){history.pushState({},"",x)})),o.toY(C,null,onDone)}}}),!1)}return o}(),void 0===(u="function"==typeof i?i.apply(o,a):i)||(s.exports=u)},15340(){},79838(){},8628(s,o,i){s.exports=i(76343)},48675(s,o,i){s.exports=i(20850)},7666(s,o,i){var a=i(84851),u=i(953);function _extends(){var o;return s.exports=_extends=a?u(o=a).call(o):function(s){for(var o=1;o<arguments.length;o++){var i=arguments[o];for(var a in i)({}).hasOwnProperty.call(i,a)&&(s[a]=i[a])}return s},s.exports.__esModule=!0,s.exports.default=s.exports,_extends.apply(null,arguments)}s.exports=_extends,s.exports.__esModule=!0,s.exports.default=s.exports},39209(s,o,i){"use strict";var a=i(76578),u="undefined"==typeof globalThis?i.g:globalThis;s.exports=function availableTypedArrays(){for(var s=[],o=0;o<a.length;o++)"function"==typeof u[a[o]]&&(s[s.length]=a[o]);return s}},46942(s,o){var i;!function(){"use strict";var a={}.hasOwnProperty;function classNames(){for(var s="",o=0;o<arguments.length;o++){var i=arguments[o];i&&(s=appendClass(s,parseValue(i)))}return s}function parseValue(s){if("string"==typeof s||"number"==typeof s)return s;if("object"!=typeof s)return"";if(Array.isArray(s))return classNames.apply(null,s);if(s.toString!==Object.prototype.toString&&!s.toString.toString().includes("[native code]"))return s.toString();var o="";for(var i in s)a.call(s,i)&&s[i]&&(o=appendClass(o,i));return o}function appendClass(s,o){return o?s?s+" "+o:s+o:s}s.exports?(classNames.default=classNames,s.exports=classNames):void 0===(i=function(){return classNames}.apply(o,[]))||(s.exports=i)}()},68623(s,o,i){"use strict";var a=i(694);s.exports=a},93700(s,o,i){"use strict";var a=i(19709);s.exports=a},462(s,o,i){"use strict";var a=i(40975);s.exports=a},37257(s,o,i){"use strict";i(96605),i(64502),i(36371),i(99363),i(7057);var a=i(92046);s.exports=a.AggregateError},11362(s,o,i){"use strict";i(19748);var a=i(61747);s.exports=a("Array","includes")},32567(s,o,i){"use strict";i(79307);var a=i(61747);s.exports=a("Function","bind")},23034(s,o,i){"use strict";var a=i(88280),u=i(32567),_=Function.prototype;s.exports=function(s){var o=s.bind;return s===_||a(_,s)&&o===_.bind?u:o}},36880(s,o,i){"use strict";var a=i(88280),u=i(11362),_=i(44378),w=Array.prototype,x=String.prototype;s.exports=function(s){var o=s.includes;return s===w||a(w,s)&&o===w.includes?u:"string"==typeof s||s===x||a(x,s)&&o===x.includes?_:o}},9748(s,o,i){"use strict";i(71340);var a=i(92046);s.exports=a.Object.assign},44378(s,o,i){"use strict";i(19770);var a=i(61747);s.exports=a("String","includes")},20850(s,o,i){"use strict";s.exports=i(46076)},953(s,o,i){"use strict";s.exports=i(53375)},84851(s,o,i){"use strict";s.exports=i(85401)},46076(s,o,i){"use strict";i(91599);var a=i(68623);s.exports=a},53375(s,o,i){"use strict";var a=i(93700);s.exports=a},85401(s,o,i){"use strict";var a=i(462);s.exports=a},82159(s,o,i){"use strict";var a=i(62250),u=i(4640),_=TypeError;s.exports=function(s){if(a(s))return s;throw new _(u(s)+" is not a function")}},10043(s,o,i){"use strict";var a=i(54018),u=String,_=TypeError;s.exports=function(s){if(a(s))return s;throw new _("Can't set "+u(s)+" as a prototype")}},42156(s){"use strict";s.exports=function(){}},36624(s,o,i){"use strict";var a=i(46285),u=String,_=TypeError;s.exports=function(s){if(a(s))return s;throw new _(u(s)+" is not an object")}},74436(s,o,i){"use strict";var a=i(4993),u=i(34849),_=i(20575),createMethod=function(s){return function(o,i,w){var x=a(o),C=_(x);if(0===C)return!s&&-1;var j,L=u(w,C);if(s&&i!=i){for(;C>L;)if((j=x[L++])!=j)return!0}else for(;C>L;L++)if((s||L in x)&&x[L]===i)return s||L||0;return!s&&-1}};s.exports={includes:createMethod(!0),indexOf:createMethod(!1)}},93427(s,o,i){"use strict";var a=i(1907);s.exports=a([].slice)},45807(s,o,i){"use strict";var a=i(1907),u=a({}.toString),_=a("".slice);s.exports=function(s){return _(u(s),8,-1)}},73948(s,o,i){"use strict";var a=i(52623),u=i(62250),_=i(45807),w=i(76264)("toStringTag"),x=Object,C="Arguments"===_(function(){return arguments}());s.exports=a?_:function(s){var o,i,a;return void 0===s?"Undefined":null===s?"Null":"string"==typeof(i=function(s,o){try{return s[o]}catch(s){}}(o=x(s),w))?i:C?_(o):"Object"===(a=_(o))&&u(o.callee)?"Arguments":a}},19595(s,o,i){"use strict";var a=i(49724),u=i(11042),_=i(13846),w=i(74284);s.exports=function(s,o,i){for(var x=u(o),C=w.f,j=_.f,L=0;L<x.length;L++){var B=x[L];a(s,B)||i&&a(i,B)||C(s,B,j(o,B))}}},25735(s,o,i){"use strict";var a=i(76264)("match");s.exports=function(s){var o=/./;try{"/./"[s](o)}catch(i){try{return o[a]=!1,"/./"[s](o)}catch(s){}}return!1}},57382(s,o,i){"use strict";var a=i(98828);s.exports=!a((function(){function F(){}return F.prototype.constructor=null,Object.getPrototypeOf(new F)!==F.prototype}))},59550(s){"use strict";s.exports=function(s,o){return{value:s,done:o}}},61626(s,o,i){"use strict";var a=i(39447),u=i(74284),_=i(75817);s.exports=a?function(s,o,i){return u.f(s,o,_(1,i))}:function(s,o,i){return s[o]=i,s}},75817(s){"use strict";s.exports=function(s,o){return{enumerable:!(1&s),configurable:!(2&s),writable:!(4&s),value:o}}},68055(s,o,i){"use strict";var a=i(61626);s.exports=function(s,o,i,u){return u&&u.enumerable?s[o]=i:a(s,o,i),s}},2532(s,o,i){"use strict";var a=i(45951),u=Object.defineProperty;s.exports=function(s,o){try{u(a,s,{value:o,configurable:!0,writable:!0})}catch(i){a[s]=o}return o}},39447(s,o,i){"use strict";var a=i(98828);s.exports=!a((function(){return 7!==Object.defineProperty({},1,{get:function(){return 7}})[1]}))},49552(s,o,i){"use strict";var a=i(45951),u=i(46285),_=a.document,w=u(_)&&u(_.createElement);s.exports=function(s){return w?_.createElement(s):{}}},19287(s){"use strict";s.exports={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0}},80376(s){"use strict";s.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"]},96794(s,o,i){"use strict";var a=i(45951).navigator,u=a&&a.userAgent;s.exports=u?String(u):""},20798(s,o,i){"use strict";var a,u,_=i(45951),w=i(96794),x=_.process,C=_.Deno,j=x&&x.versions||C&&C.version,L=j&&j.v8;L&&(u=(a=L.split("."))[0]>0&&a[0]<4?1:+(a[0]+a[1])),!u&&w&&(!(a=w.match(/Edge\/(\d+)/))||a[1]>=74)&&(a=w.match(/Chrome\/(\d+)/))&&(u=+a[1]),s.exports=u},85762(s,o,i){"use strict";var a=i(1907),u=Error,_=a("".replace),w=String(new u("zxcasd").stack),x=/\n\s*at [^:]*:[^\n]*/,C=x.test(w);s.exports=function(s,o){if(C&&"string"==typeof s&&!u.prepareStackTrace)for(;o--;)s=_(s,x,"");return s}},85884(s,o,i){"use strict";var a=i(61626),u=i(85762),_=i(23888),w=Error.captureStackTrace;s.exports=function(s,o,i,x){_&&(w?w(s,o):a(s,"stack",u(i,x)))}},23888(s,o,i){"use strict";var a=i(98828),u=i(75817);s.exports=!a((function(){var s=new Error("a");return!("stack"in s)||(Object.defineProperty(s,"stack",u(1,7)),7!==s.stack)}))},11091(s,o,i){"use strict";var a=i(45951),u=i(76024),_=i(92361),w=i(62250),x=i(13846).f,C=i(7463),j=i(92046),L=i(28311),B=i(61626),$=i(49724);i(36128);var wrapConstructor=function(s){var Wrapper=function(o,i,a){if(this instanceof Wrapper){switch(arguments.length){case 0:return new s;case 1:return new s(o);case 2:return new s(o,i)}return new s(o,i,a)}return u(s,this,arguments)};return Wrapper.prototype=s.prototype,Wrapper};s.exports=function(s,o){var i,u,U,V,z,Y,Z,ee,ie,ae=s.target,ce=s.global,le=s.stat,pe=s.proto,de=ce?a:le?a[ae]:a[ae]&&a[ae].prototype,fe=ce?j:j[ae]||B(j,ae,{})[ae],ye=fe.prototype;for(V in o)u=!(i=C(ce?V:ae+(le?".":"#")+V,s.forced))&&de&&$(de,V),Y=fe[V],u&&(Z=s.dontCallGetSet?(ie=x(de,V))&&ie.value:de[V]),z=u&&Z?Z:o[V],(i||pe||typeof Y!=typeof z)&&(ee=s.bind&&u?L(z,a):s.wrap&&u?wrapConstructor(z):pe&&w(z)?_(z):z,(s.sham||z&&z.sham||Y&&Y.sham)&&B(ee,"sham",!0),B(fe,V,ee),pe&&($(j,U=ae+"Prototype")||B(j,U,{}),B(j[U],V,z),s.real&&ye&&(i||!ye[V])&&B(ye,V,z)))}},98828(s){"use strict";s.exports=function(s){try{return!!s()}catch(s){return!0}}},76024(s,o,i){"use strict";var a=i(41505),u=Function.prototype,_=u.apply,w=u.call;s.exports="object"==typeof Reflect&&Reflect.apply||(a?w.bind(_):function(){return w.apply(_,arguments)})},28311(s,o,i){"use strict";var a=i(92361),u=i(82159),_=i(41505),w=a(a.bind);s.exports=function(s,o){return u(s),void 0===o?s:_?w(s,o):function(){return s.apply(o,arguments)}}},41505(s,o,i){"use strict";var a=i(98828);s.exports=!a((function(){var s=function(){}.bind();return"function"!=typeof s||s.hasOwnProperty("prototype")}))},44673(s,o,i){"use strict";var a=i(1907),u=i(82159),_=i(46285),w=i(49724),x=i(93427),C=i(41505),j=Function,L=a([].concat),B=a([].join),$={};s.exports=C?j.bind:function bind(s){var o=u(this),i=o.prototype,a=x(arguments,1),C=function bound(){var i=L(a,x(arguments));return this instanceof C?function(s,o,i){if(!w($,o)){for(var a=[],u=0;u<o;u++)a[u]="a["+u+"]";$[o]=j("C,a","return new C("+B(a,",")+")")}return $[o](s,i)}(o,i.length,i):o.apply(s,i)};return _(i)&&(C.prototype=i),C}},13930(s,o,i){"use strict";var a=i(41505),u=Function.prototype.call;s.exports=a?u.bind(u):function(){return u.apply(u,arguments)}},36833(s,o,i){"use strict";var a=i(39447),u=i(49724),_=Function.prototype,w=a&&Object.getOwnPropertyDescriptor,x=u(_,"name"),C=x&&"something"===function something(){}.name,j=x&&(!a||a&&w(_,"name").configurable);s.exports={EXISTS:x,PROPER:C,CONFIGURABLE:j}},51871(s,o,i){"use strict";var a=i(1907),u=i(82159);s.exports=function(s,o,i){try{return a(u(Object.getOwnPropertyDescriptor(s,o)[i]))}catch(s){}}},92361(s,o,i){"use strict";var a=i(45807),u=i(1907);s.exports=function(s){if("Function"===a(s))return u(s)}},1907(s,o,i){"use strict";var a=i(41505),u=Function.prototype,_=u.call,w=a&&u.bind.bind(_,_);s.exports=a?w:function(s){return function(){return _.apply(s,arguments)}}},61747(s,o,i){"use strict";var a=i(45951),u=i(92046);s.exports=function(s,o){var i=u[s+"Prototype"],_=i&&i[o];if(_)return _;var w=a[s],x=w&&w.prototype;return x&&x[o]}},85582(s,o,i){"use strict";var a=i(92046),u=i(45951),_=i(62250),aFunction=function(s){return _(s)?s:void 0};s.exports=function(s,o){return arguments.length<2?aFunction(a[s])||aFunction(u[s]):a[s]&&a[s][o]||u[s]&&u[s][o]}},73448(s,o,i){"use strict";var a=i(73948),u=i(29367),_=i(87136),w=i(93742),x=i(76264)("iterator");s.exports=function(s){if(!_(s))return u(s,x)||u(s,"@@iterator")||w[a(s)]}},10300(s,o,i){"use strict";var a=i(13930),u=i(82159),_=i(36624),w=i(4640),x=i(73448),C=TypeError;s.exports=function(s,o){var i=arguments.length<2?x(s):o;if(u(i))return _(a(i,s));throw new C(w(s)+" is not iterable")}},29367(s,o,i){"use strict";var a=i(82159),u=i(87136);s.exports=function(s,o){var i=s[o];return u(i)?void 0:a(i)}},45951(s,o,i){"use strict";var check=function(s){return s&&s.Math===Math&&s};s.exports=check("object"==typeof globalThis&&globalThis)||check("object"==typeof window&&window)||check("object"==typeof self&&self)||check("object"==typeof i.g&&i.g)||check("object"==typeof this&&this)||function(){return this}()||Function("return this")()},49724(s,o,i){"use strict";var a=i(1907),u=i(39298),_=a({}.hasOwnProperty);s.exports=Object.hasOwn||function hasOwn(s,o){return _(u(s),o)}},38530(s){"use strict";s.exports={}},62416(s,o,i){"use strict";var a=i(85582);s.exports=a("document","documentElement")},73648(s,o,i){"use strict";var a=i(39447),u=i(98828),_=i(49552);s.exports=!a&&!u((function(){return 7!==Object.defineProperty(_("div"),"a",{get:function(){return 7}}).a}))},16946(s,o,i){"use strict";var a=i(1907),u=i(98828),_=i(45807),w=Object,x=a("".split);s.exports=u((function(){return!w("z").propertyIsEnumerable(0)}))?function(s){return"String"===_(s)?x(s,""):w(s)}:w},34084(s,o,i){"use strict";var a=i(62250),u=i(46285),_=i(79192);s.exports=function(s,o,i){var w,x;return _&&a(w=o.constructor)&&w!==i&&u(x=w.prototype)&&x!==i.prototype&&_(s,x),s}},39259(s,o,i){"use strict";var a=i(46285),u=i(61626);s.exports=function(s,o){a(o)&&"cause"in o&&u(s,"cause",o.cause)}},64932(s,o,i){"use strict";var a,u,_,w=i(40551),x=i(45951),C=i(46285),j=i(61626),L=i(49724),B=i(36128),$=i(92522),U=i(38530),V="Object already initialized",z=x.TypeError,Y=x.WeakMap;if(w||B.state){var Z=B.state||(B.state=new Y);Z.get=Z.get,Z.has=Z.has,Z.set=Z.set,a=function(s,o){if(Z.has(s))throw new z(V);return o.facade=s,Z.set(s,o),o},u=function(s){return Z.get(s)||{}},_=function(s){return Z.has(s)}}else{var ee=$("state");U[ee]=!0,a=function(s,o){if(L(s,ee))throw new z(V);return o.facade=s,j(s,ee,o),o},u=function(s){return L(s,ee)?s[ee]:{}},_=function(s){return L(s,ee)}}s.exports={set:a,get:u,has:_,enforce:function(s){return _(s)?u(s):a(s,{})},getterFor:function(s){return function(o){var i;if(!C(o)||(i=u(o)).type!==s)throw new z("Incompatible receiver, "+s+" required");return i}}}},37812(s,o,i){"use strict";var a=i(76264),u=i(93742),_=a("iterator"),w=Array.prototype;s.exports=function(s){return void 0!==s&&(u.Array===s||w[_]===s)}},62250(s){"use strict";var o="object"==typeof document&&document.all;s.exports=void 0===o&&void 0!==o?function(s){return"function"==typeof s||s===o}:function(s){return"function"==typeof s}},7463(s,o,i){"use strict";var a=i(98828),u=i(62250),_=/#|\.prototype\./,isForced=function(s,o){var i=x[w(s)];return i===j||i!==C&&(u(o)?a(o):!!o)},w=isForced.normalize=function(s){return String(s).replace(_,".").toLowerCase()},x=isForced.data={},C=isForced.NATIVE="N",j=isForced.POLYFILL="P";s.exports=isForced},87136(s){"use strict";s.exports=function(s){return null==s}},46285(s,o,i){"use strict";var a=i(62250);s.exports=function(s){return"object"==typeof s?null!==s:a(s)}},54018(s,o,i){"use strict";var a=i(46285);s.exports=function(s){return a(s)||null===s}},7376(s){"use strict";s.exports=!0},72087(s,o,i){"use strict";var a=i(46285),u=i(45807),_=i(76264)("match");s.exports=function(s){var o;return a(s)&&(void 0!==(o=s[_])?!!o:"RegExp"===u(s))}},25594(s,o,i){"use strict";var a=i(85582),u=i(62250),_=i(88280),w=i(51175),x=Object;s.exports=w?function(s){return"symbol"==typeof s}:function(s){var o=a("Symbol");return u(o)&&_(o.prototype,x(s))}},24823(s,o,i){"use strict";var a=i(28311),u=i(13930),_=i(36624),w=i(4640),x=i(37812),C=i(20575),j=i(88280),L=i(10300),B=i(73448),$=i(40154),U=TypeError,Result=function(s,o){this.stopped=s,this.result=o},V=Result.prototype;s.exports=function(s,o,i){var z,Y,Z,ee,ie,ae,ce,le=i&&i.that,pe=!(!i||!i.AS_ENTRIES),de=!(!i||!i.IS_RECORD),fe=!(!i||!i.IS_ITERATOR),ye=!(!i||!i.INTERRUPTED),be=a(o,le),stop=function(s){return z&&$(z,"normal",s),new Result(!0,s)},callFn=function(s){return pe?(_(s),ye?be(s[0],s[1],stop):be(s[0],s[1])):ye?be(s,stop):be(s)};if(de)z=s.iterator;else if(fe)z=s;else{if(!(Y=B(s)))throw new U(w(s)+" is not iterable");if(x(Y)){for(Z=0,ee=C(s);ee>Z;Z++)if((ie=callFn(s[Z]))&&j(V,ie))return ie;return new Result(!1)}z=L(s,Y)}for(ae=de?s.next:z.next;!(ce=u(ae,z)).done;){try{ie=callFn(ce.value)}catch(s){$(z,"throw",s)}if("object"==typeof ie&&ie&&j(V,ie))return ie}return new Result(!1)}},40154(s,o,i){"use strict";var a=i(13930),u=i(36624),_=i(29367);s.exports=function(s,o,i){var w,x;u(s);try{if(!(w=_(s,"return"))){if("throw"===o)throw i;return i}w=a(w,s)}catch(s){x=!0,w=s}if("throw"===o)throw i;if(x)throw w;return u(w),i}},47181(s,o,i){"use strict";var a=i(95116).IteratorPrototype,u=i(58075),_=i(75817),w=i(14840),x=i(93742),returnThis=function(){return this};s.exports=function(s,o,i,C){var j=o+" Iterator";return s.prototype=u(a,{next:_(+!C,i)}),w(s,j,!1,!0),x[j]=returnThis,s}},60183(s,o,i){"use strict";var a=i(11091),u=i(13930),_=i(7376),w=i(36833),x=i(62250),C=i(47181),j=i(15972),L=i(79192),B=i(14840),$=i(61626),U=i(68055),V=i(76264),z=i(93742),Y=i(95116),Z=w.PROPER,ee=w.CONFIGURABLE,ie=Y.IteratorPrototype,ae=Y.BUGGY_SAFARI_ITERATORS,ce=V("iterator"),le="keys",pe="values",de="entries",returnThis=function(){return this};s.exports=function(s,o,i,w,V,Y,fe){C(i,o,w);var ye,be,Se,getIterationMethod=function(s){if(s===V&&Te)return Te;if(!ae&&s&&s in xe)return xe[s];switch(s){case le:return function keys(){return new i(this,s)};case pe:return function values(){return new i(this,s)};case de:return function entries(){return new i(this,s)}}return function(){return new i(this)}},_e=o+" Iterator",we=!1,xe=s.prototype,Pe=xe[ce]||xe["@@iterator"]||V&&xe[V],Te=!ae&&Pe||getIterationMethod(V),Re="Array"===o&&xe.entries||Pe;if(Re&&(ye=j(Re.call(new s)))!==Object.prototype&&ye.next&&(_||j(ye)===ie||(L?L(ye,ie):x(ye[ce])||U(ye,ce,returnThis)),B(ye,_e,!0,!0),_&&(z[_e]=returnThis)),Z&&V===pe&&Pe&&Pe.name!==pe&&(!_&&ee?$(xe,"name",pe):(we=!0,Te=function values(){return u(Pe,this)})),V)if(be={values:getIterationMethod(pe),keys:Y?Te:getIterationMethod(le),entries:getIterationMethod(de)},fe)for(Se in be)(ae||we||!(Se in xe))&&U(xe,Se,be[Se]);else a({target:o,proto:!0,forced:ae||we},be);return _&&!fe||xe[ce]===Te||U(xe,ce,Te,{name:V}),z[o]=Te,be}},95116(s,o,i){"use strict";var a,u,_,w=i(98828),x=i(62250),C=i(46285),j=i(58075),L=i(15972),B=i(68055),$=i(76264),U=i(7376),V=$("iterator"),z=!1;[].keys&&("next"in(_=[].keys())?(u=L(L(_)))!==Object.prototype&&(a=u):z=!0),!C(a)||w((function(){var s={};return a[V].call(s)!==s}))?a={}:U&&(a=j(a)),x(a[V])||B(a,V,(function(){return this})),s.exports={IteratorPrototype:a,BUGGY_SAFARI_ITERATORS:z}},93742(s){"use strict";s.exports={}},20575(s,o,i){"use strict";var a=i(3121);s.exports=function(s){return a(s.length)}},41176(s){"use strict";var o=Math.ceil,i=Math.floor;s.exports=Math.trunc||function trunc(s){var a=+s;return(a>0?i:o)(a)}},32096(s,o,i){"use strict";var a=i(90160);s.exports=function(s,o){return void 0===s?arguments.length<2?"":o:a(s)}},12074(s,o,i){"use strict";var a=i(72087),u=TypeError;s.exports=function(s){if(a(s))throw new u("The method doesn't accept regular expressions");return s}},29538(s,o,i){"use strict";var a=i(39447),u=i(1907),_=i(13930),w=i(98828),x=i(2875),C=i(87170),j=i(22574),L=i(39298),B=i(16946),$=Object.assign,U=Object.defineProperty,V=u([].concat);s.exports=!$||w((function(){if(a&&1!==$({b:1},$(U({},"a",{enumerable:!0,get:function(){U(this,"b",{value:3,enumerable:!1})}}),{b:2})).b)return!0;var s={},o={},i=Symbol("assign detection"),u="abcdefghijklmnopqrst";return s[i]=7,u.split("").forEach((function(s){o[s]=s})),7!==$({},s)[i]||x($({},o)).join("")!==u}))?function assign(s,o){for(var i=L(s),u=arguments.length,w=1,$=C.f,U=j.f;u>w;)for(var z,Y=B(arguments[w++]),Z=$?V(x(Y),$(Y)):x(Y),ee=Z.length,ie=0;ee>ie;)z=Z[ie++],a&&!_(U,Y,z)||(i[z]=Y[z]);return i}:$},58075(s,o,i){"use strict";var a,u=i(36624),_=i(42220),w=i(80376),x=i(38530),C=i(62416),j=i(49552),L=i(92522),B="prototype",$="script",U=L("IE_PROTO"),EmptyConstructor=function(){},scriptTag=function(s){return"<"+$+">"+s+"</"+$+">"},NullProtoObjectViaActiveX=function(s){s.write(scriptTag("")),s.close();var o=s.parentWindow.Object;return s=null,o},NullProtoObject=function(){try{a=new ActiveXObject("htmlfile")}catch(s){}var s,o,i;NullProtoObject="undefined"!=typeof document?document.domain&&a?NullProtoObjectViaActiveX(a):(o=j("iframe"),i="java"+$+":",o.style.display="none",C.appendChild(o),o.src=String(i),(s=o.contentWindow.document).open(),s.write(scriptTag("document.F=Object")),s.close(),s.F):NullProtoObjectViaActiveX(a);for(var u=w.length;u--;)delete NullProtoObject[B][w[u]];return NullProtoObject()};x[U]=!0,s.exports=Object.create||function create(s,o){var i;return null!==s?(EmptyConstructor[B]=u(s),i=new EmptyConstructor,EmptyConstructor[B]=null,i[U]=s):i=NullProtoObject(),void 0===o?i:_.f(i,o)}},42220(s,o,i){"use strict";var a=i(39447),u=i(58661),_=i(74284),w=i(36624),x=i(4993),C=i(2875);o.f=a&&!u?Object.defineProperties:function defineProperties(s,o){w(s);for(var i,a=x(o),u=C(o),j=u.length,L=0;j>L;)_.f(s,i=u[L++],a[i]);return s}},74284(s,o,i){"use strict";var a=i(39447),u=i(73648),_=i(58661),w=i(36624),x=i(70470),C=TypeError,j=Object.defineProperty,L=Object.getOwnPropertyDescriptor,B="enumerable",$="configurable",U="writable";o.f=a?_?function defineProperty(s,o,i){if(w(s),o=x(o),w(i),"function"==typeof s&&"prototype"===o&&"value"in i&&U in i&&!i[U]){var a=L(s,o);a&&a[U]&&(s[o]=i.value,i={configurable:$ in i?i[$]:a[$],enumerable:B in i?i[B]:a[B],writable:!1})}return j(s,o,i)}:j:function defineProperty(s,o,i){if(w(s),o=x(o),w(i),u)try{return j(s,o,i)}catch(s){}if("get"in i||"set"in i)throw new C("Accessors not supported");return"value"in i&&(s[o]=i.value),s}},13846(s,o,i){"use strict";var a=i(39447),u=i(13930),_=i(22574),w=i(75817),x=i(4993),C=i(70470),j=i(49724),L=i(73648),B=Object.getOwnPropertyDescriptor;o.f=a?B:function getOwnPropertyDescriptor(s,o){if(s=x(s),o=C(o),L)try{return B(s,o)}catch(s){}if(j(s,o))return w(!u(_.f,s,o),s[o])}},24443(s,o,i){"use strict";var a=i(23045),u=i(80376).concat("length","prototype");o.f=Object.getOwnPropertyNames||function getOwnPropertyNames(s){return a(s,u)}},87170(s,o){"use strict";o.f=Object.getOwnPropertySymbols},15972(s,o,i){"use strict";var a=i(49724),u=i(62250),_=i(39298),w=i(92522),x=i(57382),C=w("IE_PROTO"),j=Object,L=j.prototype;s.exports=x?j.getPrototypeOf:function(s){var o=_(s);if(a(o,C))return o[C];var i=o.constructor;return u(i)&&o instanceof i?i.prototype:o instanceof j?L:null}},88280(s,o,i){"use strict";var a=i(1907);s.exports=a({}.isPrototypeOf)},23045(s,o,i){"use strict";var a=i(1907),u=i(49724),_=i(4993),w=i(74436).indexOf,x=i(38530),C=a([].push);s.exports=function(s,o){var i,a=_(s),j=0,L=[];for(i in a)!u(x,i)&&u(a,i)&&C(L,i);for(;o.length>j;)u(a,i=o[j++])&&(~w(L,i)||C(L,i));return L}},2875(s,o,i){"use strict";var a=i(23045),u=i(80376);s.exports=Object.keys||function keys(s){return a(s,u)}},22574(s,o){"use strict";var i={}.propertyIsEnumerable,a=Object.getOwnPropertyDescriptor,u=a&&!i.call({1:2},1);o.f=u?function propertyIsEnumerable(s){var o=a(this,s);return!!o&&o.enumerable}:i},79192(s,o,i){"use strict";var a=i(51871),u=i(46285),_=i(74239),w=i(10043);s.exports=Object.setPrototypeOf||("__proto__"in{}?function(){var s,o=!1,i={};try{(s=a(Object.prototype,"__proto__","set"))(i,[]),o=i instanceof Array}catch(s){}return function setPrototypeOf(i,a){return _(i),w(a),u(i)?(o?s(i,a):i.__proto__=a,i):i}}():void 0)},54878(s,o,i){"use strict";var a=i(52623),u=i(73948);s.exports=a?{}.toString:function toString(){return"[object "+u(this)+"]"}},60581(s,o,i){"use strict";var a=i(13930),u=i(62250),_=i(46285),w=TypeError;s.exports=function(s,o){var i,x;if("string"===o&&u(i=s.toString)&&!_(x=a(i,s)))return x;if(u(i=s.valueOf)&&!_(x=a(i,s)))return x;if("string"!==o&&u(i=s.toString)&&!_(x=a(i,s)))return x;throw new w("Can't convert object to primitive value")}},11042(s,o,i){"use strict";var a=i(85582),u=i(1907),_=i(24443),w=i(87170),x=i(36624),C=u([].concat);s.exports=a("Reflect","ownKeys")||function ownKeys(s){var o=_.f(x(s)),i=w.f;return i?C(o,i(s)):o}},92046(s){"use strict";s.exports={}},54829(s,o,i){"use strict";var a=i(74284).f;s.exports=function(s,o,i){i in s||a(s,i,{configurable:!0,get:function(){return o[i]},set:function(s){o[i]=s}})}},74239(s,o,i){"use strict";var a=i(87136),u=TypeError;s.exports=function(s){if(a(s))throw new u("Can't call method on "+s);return s}},14840(s,o,i){"use strict";var a=i(52623),u=i(74284).f,_=i(61626),w=i(49724),x=i(54878),C=i(76264)("toStringTag");s.exports=function(s,o,i,j){var L=i?s:s&&s.prototype;L&&(w(L,C)||u(L,C,{configurable:!0,value:o}),j&&!a&&_(L,"toString",x))}},92522(s,o,i){"use strict";var a=i(85816),u=i(6499),_=a("keys");s.exports=function(s){return _[s]||(_[s]=u(s))}},36128(s,o,i){"use strict";var a=i(7376),u=i(45951),_=i(2532),w="__core-js_shared__",x=s.exports=u[w]||_(w,{});(x.versions||(x.versions=[])).push({version:"3.40.0",mode:a?"pure":"global",copyright:"© 2014-2025 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.40.0/LICENSE",source:"https://github.com/zloirock/core-js"})},85816(s,o,i){"use strict";var a=i(36128);s.exports=function(s,o){return a[s]||(a[s]=o||{})}},11470(s,o,i){"use strict";var a=i(1907),u=i(65482),_=i(90160),w=i(74239),x=a("".charAt),C=a("".charCodeAt),j=a("".slice),createMethod=function(s){return function(o,i){var a,L,B=_(w(o)),$=u(i),U=B.length;return $<0||$>=U?s?"":void 0:(a=C(B,$))<55296||a>56319||$+1===U||(L=C(B,$+1))<56320||L>57343?s?x(B,$):a:s?j(B,$,$+2):L-56320+(a-55296<<10)+65536}};s.exports={codeAt:createMethod(!1),charAt:createMethod(!0)}},19846(s,o,i){"use strict";var a=i(20798),u=i(98828),_=i(45951).String;s.exports=!!Object.getOwnPropertySymbols&&!u((function(){var s=Symbol("symbol detection");return!_(s)||!(Object(s)instanceof Symbol)||!Symbol.sham&&a&&a<41}))},34849(s,o,i){"use strict";var a=i(65482),u=Math.max,_=Math.min;s.exports=function(s,o){var i=a(s);return i<0?u(i+o,0):_(i,o)}},4993(s,o,i){"use strict";var a=i(16946),u=i(74239);s.exports=function(s){return a(u(s))}},65482(s,o,i){"use strict";var a=i(41176);s.exports=function(s){var o=+s;return o!=o||0===o?0:a(o)}},3121(s,o,i){"use strict";var a=i(65482),u=Math.min;s.exports=function(s){var o=a(s);return o>0?u(o,9007199254740991):0}},39298(s,o,i){"use strict";var a=i(74239),u=Object;s.exports=function(s){return u(a(s))}},46028(s,o,i){"use strict";var a=i(13930),u=i(46285),_=i(25594),w=i(29367),x=i(60581),C=i(76264),j=TypeError,L=C("toPrimitive");s.exports=function(s,o){if(!u(s)||_(s))return s;var i,C=w(s,L);if(C){if(void 0===o&&(o="default"),i=a(C,s,o),!u(i)||_(i))return i;throw new j("Can't convert object to primitive value")}return void 0===o&&(o="number"),x(s,o)}},70470(s,o,i){"use strict";var a=i(46028),u=i(25594);s.exports=function(s){var o=a(s,"string");return u(o)?o:o+""}},52623(s,o,i){"use strict";var a={};a[i(76264)("toStringTag")]="z",s.exports="[object z]"===String(a)},90160(s,o,i){"use strict";var a=i(73948),u=String;s.exports=function(s){if("Symbol"===a(s))throw new TypeError("Cannot convert a Symbol value to a string");return u(s)}},4640(s){"use strict";var o=String;s.exports=function(s){try{return o(s)}catch(s){return"Object"}}},6499(s,o,i){"use strict";var a=i(1907),u=0,_=Math.random(),w=a(1..toString);s.exports=function(s){return"Symbol("+(void 0===s?"":s)+")_"+w(++u+_,36)}},51175(s,o,i){"use strict";var a=i(19846);s.exports=a&&!Symbol.sham&&"symbol"==typeof Symbol.iterator},58661(s,o,i){"use strict";var a=i(39447),u=i(98828);s.exports=a&&u((function(){return 42!==Object.defineProperty((function(){}),"prototype",{value:42,writable:!1}).prototype}))},40551(s,o,i){"use strict";var a=i(45951),u=i(62250),_=a.WeakMap;s.exports=u(_)&&/native code/.test(String(_))},76264(s,o,i){"use strict";var a=i(45951),u=i(85816),_=i(49724),w=i(6499),x=i(19846),C=i(51175),j=a.Symbol,L=u("wks"),B=C?j.for||j:j&&j.withoutSetter||w;s.exports=function(s){return _(L,s)||(L[s]=x&&_(j,s)?j[s]:B("Symbol."+s)),L[s]}},19358(s,o,i){"use strict";var a=i(85582),u=i(49724),_=i(61626),w=i(88280),x=i(79192),C=i(19595),j=i(54829),L=i(34084),B=i(32096),$=i(39259),U=i(85884),V=i(39447),z=i(7376);s.exports=function(s,o,i,Y){var Z="stackTraceLimit",ee=Y?2:1,ie=s.split("."),ae=ie[ie.length-1],ce=a.apply(null,ie);if(ce){var le=ce.prototype;if(!z&&u(le,"cause")&&delete le.cause,!i)return ce;var pe=a("Error"),de=o((function(s,o){var i=B(Y?o:s,void 0),a=Y?new ce(s):new ce;return void 0!==i&&_(a,"message",i),U(a,de,a.stack,2),this&&w(le,this)&&L(a,this,de),arguments.length>ee&&$(a,arguments[ee]),a}));if(de.prototype=le,"Error"!==ae?x?x(de,pe):C(de,pe,{name:!0}):V&&Z in ce&&(j(de,ce,Z),j(de,ce,"prepareStackTrace")),C(de,ce),!z)try{le.name!==ae&&_(le,"name",ae),le.constructor=de}catch(s){}return de}}},36371(s,o,i){"use strict";var a=i(11091),u=i(85582),_=i(76024),w=i(98828),x=i(19358),C="AggregateError",j=u(C),L=!w((function(){return 1!==j([1]).errors[0]}))&&w((function(){return 7!==j([1],C,{cause:7}).cause}));a({global:!0,constructor:!0,arity:2,forced:L},{AggregateError:x(C,(function(s){return function AggregateError(o,i){return _(s,this,arguments)}}),L,!0)})},82048(s,o,i){"use strict";var a=i(11091),u=i(88280),_=i(15972),w=i(79192),x=i(19595),C=i(58075),j=i(61626),L=i(75817),B=i(39259),$=i(85884),U=i(24823),V=i(32096),z=i(76264)("toStringTag"),Y=Error,Z=[].push,ee=function AggregateError(s,o){var i,a=u(ie,this);w?i=w(new Y,a?_(this):ie):(i=a?this:C(ie),j(i,z,"Error")),void 0!==o&&j(i,"message",V(o)),$(i,ee,i.stack,1),arguments.length>2&&B(i,arguments[2]);var x=[];return U(s,Z,{that:x}),j(i,"errors",x),i};w?w(ee,Y):x(ee,Y,{name:!0});var ie=ee.prototype=C(Y.prototype,{constructor:L(1,ee),message:L(1,""),name:L(1,"AggregateError")});a({global:!0,constructor:!0,arity:2},{AggregateError:ee})},64502(s,o,i){"use strict";i(82048)},19748(s,o,i){"use strict";var a=i(11091),u=i(74436).includes,_=i(98828),w=i(42156);a({target:"Array",proto:!0,forced:_((function(){return!Array(1).includes()}))},{includes:function includes(s){return u(this,s,arguments.length>1?arguments[1]:void 0)}}),w("includes")},99363(s,o,i){"use strict";var a=i(4993),u=i(42156),_=i(93742),w=i(64932),x=i(74284).f,C=i(60183),j=i(59550),L=i(7376),B=i(39447),$="Array Iterator",U=w.set,V=w.getterFor($);s.exports=C(Array,"Array",(function(s,o){U(this,{type:$,target:a(s),index:0,kind:o})}),(function(){var s=V(this),o=s.target,i=s.index++;if(!o||i>=o.length)return s.target=null,j(void 0,!0);switch(s.kind){case"keys":return j(i,!1);case"values":return j(o[i],!1)}return j([i,o[i]],!1)}),"values");var z=_.Arguments=_.Array;if(u("keys"),u("values"),u("entries"),!L&&B&&"values"!==z.name)try{x(z,"name",{value:"values"})}catch(s){}},96605(s,o,i){"use strict";var a=i(11091),u=i(45951),_=i(76024),w=i(19358),x="WebAssembly",C=u[x],j=7!==new Error("e",{cause:7}).cause,exportGlobalErrorCauseWrapper=function(s,o){var i={};i[s]=w(s,o,j),a({global:!0,constructor:!0,arity:1,forced:j},i)},exportWebAssemblyErrorCauseWrapper=function(s,o){if(C&&C[s]){var i={};i[s]=w(x+"."+s,o,j),a({target:x,stat:!0,constructor:!0,arity:1,forced:j},i)}};exportGlobalErrorCauseWrapper("Error",(function(s){return function Error(o){return _(s,this,arguments)}})),exportGlobalErrorCauseWrapper("EvalError",(function(s){return function EvalError(o){return _(s,this,arguments)}})),exportGlobalErrorCauseWrapper("RangeError",(function(s){return function RangeError(o){return _(s,this,arguments)}})),exportGlobalErrorCauseWrapper("ReferenceError",(function(s){return function ReferenceError(o){return _(s,this,arguments)}})),exportGlobalErrorCauseWrapper("SyntaxError",(function(s){return function SyntaxError(o){return _(s,this,arguments)}})),exportGlobalErrorCauseWrapper("TypeError",(function(s){return function TypeError(o){return _(s,this,arguments)}})),exportGlobalErrorCauseWrapper("URIError",(function(s){return function URIError(o){return _(s,this,arguments)}})),exportWebAssemblyErrorCauseWrapper("CompileError",(function(s){return function CompileError(o){return _(s,this,arguments)}})),exportWebAssemblyErrorCauseWrapper("LinkError",(function(s){return function LinkError(o){return _(s,this,arguments)}})),exportWebAssemblyErrorCauseWrapper("RuntimeError",(function(s){return function RuntimeError(o){return _(s,this,arguments)}}))},79307(s,o,i){"use strict";var a=i(11091),u=i(44673);a({target:"Function",proto:!0,forced:Function.bind!==u},{bind:u})},71340(s,o,i){"use strict";var a=i(11091),u=i(29538);a({target:"Object",stat:!0,arity:2,forced:Object.assign!==u},{assign:u})},19770(s,o,i){"use strict";var a=i(11091),u=i(1907),_=i(12074),w=i(74239),x=i(90160),C=i(25735),j=u("".indexOf);a({target:"String",proto:!0,forced:!C("includes")},{includes:function includes(s){return!!~j(x(w(this)),x(_(s)),arguments.length>1?arguments[1]:void 0)}})},7057(s,o,i){"use strict";var a=i(11470).charAt,u=i(90160),_=i(64932),w=i(60183),x=i(59550),C="String Iterator",j=_.set,L=_.getterFor(C);w(String,"String",(function(s){j(this,{type:C,string:u(s),index:0})}),(function next(){var s,o=L(this),i=o.string,u=o.index;return u>=i.length?x(void 0,!0):(s=a(i,u),o.index+=s.length,x(s,!1))}))},91599(s,o,i){"use strict";i(64502)},12560(s,o,i){"use strict";i(99363);var a=i(19287),u=i(45951),_=i(14840),w=i(93742);for(var x in a)_(u[x],x),w[x]=w.Array},694(s,o,i){"use strict";i(91599);var a=i(37257);i(12560),s.exports=a},19709(s,o,i){"use strict";var a=i(23034);s.exports=a},76343(s,o,i){"use strict";var a=i(36880);s.exports=a},40975(s,o,i){"use strict";var a=i(9748);s.exports=a}},o={};function __webpack_require__(i){var a=o[i];if(void 0!==a)return a.exports;var u=o[i]={id:i,loaded:!1,exports:{}};return s[i].call(u.exports,u,u.exports,__webpack_require__),u.loaded=!0,u.exports}__webpack_require__.n=s=>{var o=s&&s.__esModule?()=>s.default:()=>s;return __webpack_require__.d(o,{a:o}),o},__webpack_require__.d=(s,o)=>{for(var i in o)__webpack_require__.o(o,i)&&!__webpack_require__.o(s,i)&&Object.defineProperty(s,i,{enumerable:!0,get:o[i]})},__webpack_require__.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(s){if("object"==typeof window)return window}}(),__webpack_require__.o=(s,o)=>Object.prototype.hasOwnProperty.call(s,o),__webpack_require__.r=s=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(s,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(s,"__esModule",{value:!0})},__webpack_require__.nmd=s=>(s.paths=[],s.children||(s.children=[]),s);var i={};return(()=>{"use strict";__webpack_require__.d(i,{default:()=>rN});var s={};__webpack_require__.r(s),__webpack_require__.d(s,{CLEAR:()=>at,CLEAR_BY:()=>ct,NEW_AUTH_ERR:()=>it,NEW_SPEC_ERR:()=>st,NEW_SPEC_ERR_BATCH:()=>ot,NEW_THROWN_ERR:()=>rt,NEW_THROWN_ERR_BATCH:()=>nt,clear:()=>clear,clearBy:()=>clearBy,newAuthErr:()=>newAuthErr,newSpecErr:()=>newSpecErr,newSpecErrBatch:()=>newSpecErrBatch,newThrownErr:()=>newThrownErr,newThrownErrBatch:()=>newThrownErrBatch});var o={};__webpack_require__.r(o),__webpack_require__.d(o,{AUTHORIZE:()=>Rt,AUTHORIZE_OAUTH2:()=>Lt,CONFIGURE_AUTH:()=>Ft,LOGOUT:()=>Dt,RESTORE_AUTHORIZATION:()=>Bt,SHOW_AUTH_POPUP:()=>Mt,authPopup:()=>authPopup,authorize:()=>authorize,authorizeAccessCodeWithBasicAuthentication:()=>authorizeAccessCodeWithBasicAuthentication,authorizeAccessCodeWithFormParams:()=>authorizeAccessCodeWithFormParams,authorizeApplication:()=>authorizeApplication,authorizeOauth2:()=>authorizeOauth2,authorizeOauth2WithPersistOption:()=>authorizeOauth2WithPersistOption,authorizePassword:()=>authorizePassword,authorizeRequest:()=>authorizeRequest,authorizeWithPersistOption:()=>authorizeWithPersistOption,configureAuth:()=>configureAuth,logout:()=>logout,logoutWithPersistOption:()=>logoutWithPersistOption,persistAuthorizationIfNeeded:()=>persistAuthorizationIfNeeded,preAuthorizeImplicit:()=>preAuthorizeImplicit,restoreAuthorization:()=>restoreAuthorization,showDefinitions:()=>showDefinitions});var a={};__webpack_require__.r(a),__webpack_require__.d(a,{authorized:()=>Jt,definitionsForRequirements:()=>definitionsForRequirements,definitionsToAuthorize:()=>Wt,getConfigs:()=>Ht,getDefinitionsByNames:()=>getDefinitionsByNames,isAuthorized:()=>isAuthorized,selectAuthPath:()=>selectAuthPath,shownDefinitions:()=>zt});var u={};__webpack_require__.r(u),__webpack_require__.d(u,{TOGGLE_CONFIGS:()=>gn,UPDATE_CONFIGS:()=>mn,downloadConfig:()=>downloadConfig,getConfigByUrl:()=>getConfigByUrl,loaded:()=>actions_loaded,toggle:()=>toggle,update:()=>update});var _={};__webpack_require__.r(_),__webpack_require__.d(_,{get:()=>get});var w={};__webpack_require__.r(w),__webpack_require__.d(w,{transform:()=>transform});var x={};__webpack_require__.r(x),__webpack_require__.d(x,{transform:()=>parameter_oneof_transform});var C={};__webpack_require__.r(C),__webpack_require__.d(C,{allErrors:()=>In,lastError:()=>Tn});var j={};__webpack_require__.r(j),__webpack_require__.d(j,{SHOW:()=>Fn,UPDATE_FILTER:()=>Dn,UPDATE_LAYOUT:()=>Rn,UPDATE_MODE:()=>Ln,changeMode:()=>changeMode,show:()=>actions_show,updateFilter:()=>updateFilter,updateLayout:()=>updateLayout});var L={};__webpack_require__.r(L),__webpack_require__.d(L,{current:()=>current,currentFilter:()=>currentFilter,isShown:()=>isShown,showSummary:()=>$n,whatMode:()=>whatMode});var B={};__webpack_require__.r(B),__webpack_require__.d(B,{taggedOperations:()=>taggedOperations});var $={};__webpack_require__.r($),__webpack_require__.d($,{getActiveLanguage:()=>Vn,getDefaultExpanded:()=>zn,getGenerators:()=>Un,getSnippetGenerators:()=>getSnippetGenerators});var U={};__webpack_require__.r(U),__webpack_require__.d(U,{JsonSchemaArrayItemFile:()=>JsonSchemaArrayItemFile,JsonSchemaArrayItemText:()=>JsonSchemaArrayItemText,JsonSchemaForm:()=>JsonSchemaForm,JsonSchema_array:()=>JsonSchema_array,JsonSchema_boolean:()=>JsonSchema_boolean,JsonSchema_object:()=>JsonSchema_object,JsonSchema_string:()=>JsonSchema_string});var V={};__webpack_require__.r(V),__webpack_require__.d(V,{allowTryItOutFor:()=>allowTryItOutFor,basePath:()=>Hs,canExecuteScheme:()=>canExecuteScheme,consumes:()=>Us,consumesOptionsFor:()=>consumesOptionsFor,contentTypeValues:()=>contentTypeValues,currentProducesFor:()=>currentProducesFor,definitions:()=>Js,externalDocs:()=>Ds,findDefinition:()=>findDefinition,getOAS3RequiredRequestBodyContentType:()=>getOAS3RequiredRequestBodyContentType,getParameter:()=>getParameter,hasHost:()=>ro,host:()=>Ks,info:()=>Rs,isMediaTypeSchemaPropertiesEqual:()=>isMediaTypeSchemaPropertiesEqual,isOAS3:()=>Ms,lastError:()=>Os,mutatedRequestFor:()=>mutatedRequestFor,mutatedRequests:()=>to,operationScheme:()=>operationScheme,operationWithMeta:()=>operationWithMeta,operations:()=>qs,operationsWithRootInherited:()=>Ys,operationsWithTags:()=>Qs,parameterInclusionSettingFor:()=>parameterInclusionSettingFor,parameterValues:()=>parameterValues,parameterWithMeta:()=>parameterWithMeta,parameterWithMetaByIdentity:()=>parameterWithMetaByIdentity,parametersIncludeIn:()=>parametersIncludeIn,parametersIncludeType:()=>parametersIncludeType,paths:()=>Bs,produces:()=>Vs,producesOptionsFor:()=>producesOptionsFor,requestFor:()=>requestFor,requests:()=>eo,responseFor:()=>responseFor,responses:()=>Zs,schemes:()=>Gs,security:()=>zs,securityDefinitions:()=>Ws,semver:()=>Fs,spec:()=>spec,specJS:()=>Is,specJson:()=>Ps,specJsonWithResolvedSubtrees:()=>Ns,specResolved:()=>Ts,specResolvedSubtree:()=>specResolvedSubtree,specSource:()=>js,specStr:()=>Cs,tagDetails:()=>tagDetails,taggedOperations:()=>selectors_taggedOperations,tags:()=>Xs,url:()=>As,validOperationMethods:()=>$s,validateBeforeExecute:()=>validateBeforeExecute,validationErrors:()=>validationErrors,version:()=>Ls});var z={};__webpack_require__.r(z),__webpack_require__.d(z,{CLEAR_REQUEST:()=>wo,CLEAR_RESPONSE:()=>Eo,CLEAR_VALIDATE_PARAMS:()=>xo,LOG_REQUEST:()=>_o,SET_MUTATED_REQUEST:()=>So,SET_REQUEST:()=>bo,SET_RESPONSE:()=>vo,SET_SCHEME:()=>Co,UPDATE_EMPTY_PARAM_INCLUSION:()=>go,UPDATE_JSON:()=>fo,UPDATE_OPERATION_META_VALUE:()=>ko,UPDATE_PARAM:()=>mo,UPDATE_RESOLVED:()=>Oo,UPDATE_RESOLVED_SUBTREE:()=>Ao,UPDATE_SPEC:()=>po,UPDATE_URL:()=>ho,VALIDATE_PARAMS:()=>yo,changeConsumesValue:()=>changeConsumesValue,changeParam:()=>changeParam,changeParamByIdentity:()=>changeParamByIdentity,changeProducesValue:()=>changeProducesValue,clearRequest:()=>clearRequest,clearResponse:()=>clearResponse,clearValidateParams:()=>clearValidateParams,execute:()=>actions_execute,executeRequest:()=>executeRequest,invalidateResolvedSubtreeCache:()=>invalidateResolvedSubtreeCache,logRequest:()=>logRequest,parseToJson:()=>parseToJson,requestResolvedSubtree:()=>requestResolvedSubtree,resolveSpec:()=>resolveSpec,setMutatedRequest:()=>setMutatedRequest,setRequest:()=>setRequest,setResponse:()=>setResponse,setScheme:()=>setScheme,updateEmptyParamInclusion:()=>updateEmptyParamInclusion,updateJsonSpec:()=>updateJsonSpec,updateResolved:()=>updateResolved,updateResolvedSubtree:()=>updateResolvedSubtree,updateSpec:()=>updateSpec,updateUrl:()=>updateUrl,validateParams:()=>validateParams});var Y={};__webpack_require__.r(Y),__webpack_require__.d(Y,{executeRequest:()=>wrap_actions_executeRequest,updateJsonSpec:()=>wrap_actions_updateJsonSpec,updateSpec:()=>wrap_actions_updateSpec,validateParams:()=>wrap_actions_validateParams});var Z={};__webpack_require__.r(Z),__webpack_require__.d(Z,{JsonPatchError:()=>Do,_areEquals:()=>_areEquals,applyOperation:()=>applyOperation,applyPatch:()=>applyPatch,applyReducer:()=>applyReducer,deepClone:()=>Lo,getValueByPointer:()=>getValueByPointer,validate:()=>validate,validator:()=>validator});var ee={};__webpack_require__.r(ee),__webpack_require__.d(ee,{compare:()=>compare,generate:()=>generate,observe:()=>observe,unobserve:()=>unobserve});var ie={};__webpack_require__.r(ie),__webpack_require__.d(ie,{hasElementSourceMap:()=>hasElementSourceMap,includesClasses:()=>includesClasses,includesSymbols:()=>includesSymbols,isAnnotationElement:()=>Pu,isArrayElement:()=>Ou,isBooleanElement:()=>xu,isCommentElement:()=>Iu,isElement:()=>Su,isLinkElement:()=>Cu,isMemberElement:()=>Au,isNullElement:()=>wu,isNumberElement:()=>Eu,isObjectElement:()=>ku,isParseResultElement:()=>Tu,isPrimitiveElement:()=>isPrimitiveElement,isRefElement:()=>ju,isStringElement:()=>_u});var ae={};__webpack_require__.r(ae),__webpack_require__.d(ae,{isJSONReferenceElement:()=>Ad,isJSONSchemaElement:()=>Od,isLinkDescriptionElement:()=>Id,isMediaElement:()=>Cd});var ce={};__webpack_require__.r(ce),__webpack_require__.d(ce,{isBooleanJsonSchemaElement:()=>isBooleanJsonSchemaElement,isCallbackElement:()=>xm,isComponentsElement:()=>km,isContactElement:()=>Om,isDiscriminatorElement:()=>Ym,isExampleElement:()=>Am,isExternalDocumentationElement:()=>Cm,isHeaderElement:()=>jm,isInfoElement:()=>Pm,isLicenseElement:()=>Im,isLinkElement:()=>Tm,isMediaTypeElement:()=>Km,isOpenApi3_0Element:()=>Mm,isOpenapiElement:()=>Nm,isOperationElement:()=>Rm,isParameterElement:()=>Dm,isPathItemElement:()=>Lm,isPathsElement:()=>Fm,isReferenceElement:()=>Bm,isRequestBodyElement:()=>$m,isResponseElement:()=>qm,isResponsesElement:()=>Um,isSchemaElement:()=>Vm,isSecurityRequirementElement:()=>zm,isSecuritySchemeElement:()=>Wm,isServerElement:()=>Jm,isServerVariableElement:()=>Hm,isServersElement:()=>Gm});var le={};__webpack_require__.r(le),__webpack_require__.d(le,{isJSONReferenceElement:()=>Ad,isJSONSchemaElement:()=>cS,isLinkDescriptionElement:()=>lS,isMediaElement:()=>Cd});var pe={};__webpack_require__.r(pe),__webpack_require__.d(pe,{isJSONReferenceElement:()=>Ad,isJSONSchemaElement:()=>vS,isLinkDescriptionElement:()=>bS});var de={};__webpack_require__.r(de),__webpack_require__.d(de,{isJSONSchemaElement:()=>BS,isLinkDescriptionElement:()=>$S});var fe={};__webpack_require__.r(fe),__webpack_require__.d(fe,{isJSONSchemaElement:()=>YS,isLinkDescriptionElement:()=>XS});var ye={};__webpack_require__.r(ye),__webpack_require__.d(ye,{isBooleanJsonSchemaElement:()=>predicates_isBooleanJsonSchemaElement,isCallbackElement:()=>D_,isComponentsElement:()=>L_,isContactElement:()=>F_,isExampleElement:()=>B_,isExternalDocumentationElement:()=>$_,isHeaderElement:()=>q_,isInfoElement:()=>U_,isJsonSchemaDialectElement:()=>V_,isLicenseElement:()=>z_,isLinkElement:()=>W_,isMediaTypeElement:()=>aE,isOpenApi3_1Element:()=>H_,isOpenapiElement:()=>J_,isOperationElement:()=>K_,isParameterElement:()=>G_,isPathItemElement:()=>Y_,isPathItemElementExternal:()=>isPathItemElementExternal,isPathsElement:()=>X_,isReferenceElement:()=>Q_,isReferenceElementExternal:()=>isReferenceElementExternal,isRequestBodyElement:()=>Z_,isResponseElement:()=>eE,isResponsesElement:()=>tE,isSchemaElement:()=>rE,isSecurityRequirementElement:()=>nE,isSecuritySchemeElement:()=>sE,isServerElement:()=>oE,isServerVariableElement:()=>iE});var be={};__webpack_require__.r(be),__webpack_require__.d(be,{cookie:()=>cookie,header:()=>parameter_builders_header,path:()=>parameter_builders_path,query:()=>query});var Se={};__webpack_require__.r(Se),__webpack_require__.d(Se,{Button:()=>Button,Col:()=>Col,Collapse:()=>Collapse,Container:()=>Container,Input:()=>Input,Link:()=>layout_utils_Link,Row:()=>Row,Select:()=>Select,TextArea:()=>TextArea});var _e={};__webpack_require__.r(_e),__webpack_require__.d(_e,{basePath:()=>kP,consumes:()=>OP,definitions:()=>_P,findDefinition:()=>SP,hasHost:()=>EP,host:()=>xP,produces:()=>AP,schemes:()=>CP,securityDefinitions:()=>wP,validOperationMethods:()=>wrap_selectors_validOperationMethods});var we={};__webpack_require__.r(we),__webpack_require__.d(we,{definitionsToAuthorize:()=>jP});var xe={};__webpack_require__.r(xe),__webpack_require__.d(xe,{callbacksOperations:()=>TP,findSchema:()=>findSchema,isOAS3:()=>selectors_isOAS3,isOAS30:()=>selectors_isOAS30,isSwagger2:()=>selectors_isSwagger2,servers:()=>IP});var Pe={};__webpack_require__.r(Pe),__webpack_require__.d(Pe,{CLEAR_REQUEST_BODY_VALIDATE_ERROR:()=>QP,CLEAR_REQUEST_BODY_VALUE:()=>ZP,SET_REQUEST_BODY_VALIDATE_ERROR:()=>XP,UPDATE_ACTIVE_EXAMPLES_MEMBER:()=>HP,UPDATE_REQUEST_BODY_INCLUSION:()=>JP,UPDATE_REQUEST_BODY_VALUE:()=>zP,UPDATE_REQUEST_BODY_VALUE_RETAIN_FLAG:()=>WP,UPDATE_REQUEST_CONTENT_TYPE:()=>KP,UPDATE_RESPONSE_CONTENT_TYPE:()=>GP,UPDATE_SELECTED_SERVER:()=>VP,UPDATE_SERVER_VARIABLE_VALUE:()=>YP,clearRequestBodyValidateError:()=>clearRequestBodyValidateError,clearRequestBodyValue:()=>clearRequestBodyValue,initRequestBodyValidateError:()=>initRequestBodyValidateError,setActiveExamplesMember:()=>setActiveExamplesMember,setRequestBodyInclusion:()=>setRequestBodyInclusion,setRequestBodyValidateError:()=>setRequestBodyValidateError,setRequestBodyValue:()=>setRequestBodyValue,setRequestContentType:()=>setRequestContentType,setResponseContentType:()=>setResponseContentType,setRetainRequestBodyValueFlag:()=>setRetainRequestBodyValueFlag,setSelectedServer:()=>setSelectedServer,setServerVariableValue:()=>setServerVariableValue});var Te={};__webpack_require__.r(Te),__webpack_require__.d(Te,{activeExamplesMember:()=>cI,hasUserEditedBody:()=>oI,requestBodyErrors:()=>aI,requestBodyInclusionSetting:()=>iI,requestBodyValue:()=>nI,requestContentType:()=>lI,responseContentType:()=>uI,selectDefaultRequestBodyValue:()=>selectDefaultRequestBodyValue,selectedServer:()=>rI,serverEffectiveValue:()=>dI,serverVariableValue:()=>pI,serverVariables:()=>hI,shouldRetainRequestBodyValue:()=>sI,validOperationMethods:()=>mI,validateBeforeExecute:()=>fI,validateShallowRequired:()=>validateShallowRequired});var Re=__webpack_require__(96540);function formatProdErrorMessage(s){return`Minified Redux error #${s}; visit https://redux.js.org/Errors?code=${s} for the full message or use the non-minified dev environment for full errors. `}var $e=(()=>"function"==typeof Symbol&&Symbol.observable||"@@observable")(),randomString=()=>Math.random().toString(36).substring(7).split("").join("."),qe={INIT:`@@redux/INIT${randomString()}`,REPLACE:`@@redux/REPLACE${randomString()}`,PROBE_UNKNOWN_ACTION:()=>`@@redux/PROBE_UNKNOWN_ACTION${randomString()}`};function isPlainObject(s){if("object"!=typeof s||null===s)return!1;let o=s;for(;null!==Object.getPrototypeOf(o);)o=Object.getPrototypeOf(o);return Object.getPrototypeOf(s)===o||null===Object.getPrototypeOf(s)}function createStore(s,o,i){if("function"!=typeof s)throw new Error(formatProdErrorMessage(2));if("function"==typeof o&&"function"==typeof i||"function"==typeof i&&"function"==typeof arguments[3])throw new Error(formatProdErrorMessage(0));if("function"==typeof o&&void 0===i&&(i=o,o=void 0),void 0!==i){if("function"!=typeof i)throw new Error(formatProdErrorMessage(1));return i(createStore)(s,o)}let a=s,u=o,_=new Map,w=_,x=0,C=!1;function ensureCanMutateNextListeners(){w===_&&(w=new Map,_.forEach(((s,o)=>{w.set(o,s)})))}function getState(){if(C)throw new Error(formatProdErrorMessage(3));return u}function subscribe(s){if("function"!=typeof s)throw new Error(formatProdErrorMessage(4));if(C)throw new Error(formatProdErrorMessage(5));let o=!0;ensureCanMutateNextListeners();const i=x++;return w.set(i,s),function unsubscribe(){if(o){if(C)throw new Error(formatProdErrorMessage(6));o=!1,ensureCanMutateNextListeners(),w.delete(i),_=null}}}function dispatch(s){if(!isPlainObject(s))throw new Error(formatProdErrorMessage(7));if(void 0===s.type)throw new Error(formatProdErrorMessage(8));if("string"!=typeof s.type)throw new Error(formatProdErrorMessage(17));if(C)throw new Error(formatProdErrorMessage(9));try{C=!0,u=a(u,s)}finally{C=!1}return(_=w).forEach((s=>{s()})),s}dispatch({type:qe.INIT});return{dispatch,subscribe,getState,replaceReducer:function replaceReducer(s){if("function"!=typeof s)throw new Error(formatProdErrorMessage(10));a=s,dispatch({type:qe.REPLACE})},[$e]:function observable(){const s=subscribe;return{subscribe(o){if("object"!=typeof o||null===o)throw new Error(formatProdErrorMessage(11));function observeState(){const s=o;s.next&&s.next(getState())}observeState();return{unsubscribe:s(observeState)}},[$e](){return this}}}}}function bindActionCreator(s,o){return function(...i){return o(s.apply(this,i))}}function compose(...s){return 0===s.length?s=>s:1===s.length?s[0]:s.reduce(((s,o)=>(...i)=>s(o(...i))))}var ze=__webpack_require__(9404),We=__webpack_require__.n(ze),He=__webpack_require__(81919),Ye=__webpack_require__.n(He),Xe=__webpack_require__(89593),Qe=__webpack_require__(20334),et=__webpack_require__(55364),tt=__webpack_require__.n(et);const rt="err_new_thrown_err",nt="err_new_thrown_err_batch",st="err_new_spec_err",ot="err_new_spec_err_batch",it="err_new_auth_err",at="err_clear",ct="err_clear_by";function newThrownErr(s){return{type:rt,payload:(0,Qe.serializeError)(s)}}function newThrownErrBatch(s){return{type:nt,payload:s}}function newSpecErr(s){return{type:st,payload:s}}function newSpecErrBatch(s){return{type:ot,payload:s}}function newAuthErr(s){return{type:it,payload:s}}function clear(s={}){return{type:at,payload:s}}function clearBy(s=()=>!0){return{type:ct,payload:s}}const lt=function makeWindow(){var s={location:{},history:{},open:()=>{},close:()=>{},File:function(){},FormData:function(){}};if("undefined"==typeof window)return s;try{s=window;for(var o of["File","Blob","FormData"])o in window&&(s[o]=window[o])}catch(s){console.error(s)}return s}();__webpack_require__(84058),__webpack_require__(55808);var ut=__webpack_require__(50104),pt=__webpack_require__.n(ut),ht=__webpack_require__(7309),dt=__webpack_require__.n(ht),mt=__webpack_require__(42426),gt=__webpack_require__.n(mt),yt=__webpack_require__(75288),vt=__webpack_require__.n(yt),bt=__webpack_require__(1882),St=__webpack_require__.n(bt),_t=__webpack_require__(2205),Et=__webpack_require__.n(_t),wt=__webpack_require__(53209),xt=__webpack_require__.n(wt),kt=__webpack_require__(62802),Ot=__webpack_require__.n(kt);const At=We().Set.of("type","format","items","default","maximum","exclusiveMaximum","minimum","exclusiveMinimum","maxLength","minLength","pattern","maxItems","minItems","uniqueItems","enum","multipleOf");function getParameterSchema(s,{isOAS3:o}={}){if(!We().Map.isMap(s))return{schema:We().Map(),parameterContentMediaType:null};if(!o)return"body"===s.get("in")?{schema:s.get("schema",We().Map()),parameterContentMediaType:null}:{schema:s.filter(((s,o)=>At.includes(o))),parameterContentMediaType:null};if(s.get("content")){const o=s.get("content",We().Map({})).keySeq().first();return{schema:s.getIn(["content",o,"schema"],We().Map()),parameterContentMediaType:o}}return{schema:s.get("schema")?s.get("schema",We().Map()):We().Map(),parameterContentMediaType:null}}var Ct=__webpack_require__(48287).Buffer;const jt="default",isImmutable=s=>We().Iterable.isIterable(s),immutableToJS=s=>isImmutable(s)?s.toJS():s;function objectify(s){return isObject(s)?immutableToJS(s):{}}function fromJSOrdered(s){if(isImmutable(s))return s;if(s instanceof lt.File)return s;if(!isObject(s))return s;if(Array.isArray(s))return We().Seq(s).map(fromJSOrdered).toList();if(St()(s.entries)){const o=function createObjWithHashedKeys(s){if(!St()(s.entries))return s;const o={},i="_**[]",a={};for(let u of s.entries())if(o[u[0]]||a[u[0]]&&a[u[0]].containsMultiple){if(!a[u[0]]){a[u[0]]={containsMultiple:!0,length:1},o[`${u[0]}${i}${a[u[0]].length}`]=o[u[0]],delete o[u[0]]}a[u[0]].length+=1,o[`${u[0]}${i}${a[u[0]].length}`]=u[1]}else o[u[0]]=u[1];return o}(s);return We().OrderedMap(o).map(fromJSOrdered)}return We().OrderedMap(s).map(fromJSOrdered)}function normalizeArray(s){return Array.isArray(s)?s:[s]}function isFn(s){return"function"==typeof s}function isObject(s){return!!s&&"object"==typeof s}function isFunc(s){return"function"==typeof s}function isArray(s){return Array.isArray(s)}const Pt=pt();function objMap(s,o){return Object.keys(s).reduce(((i,a)=>(i[a]=o(s[a],a),i)),{})}function objReduce(s,o){return Object.keys(s).reduce(((i,a)=>{let u=o(s[a],a);return u&&"object"==typeof u&&Object.assign(i,u),i}),{})}function systemThunkMiddleware(s){return({dispatch:o,getState:i})=>o=>i=>"function"==typeof i?i(s()):o(i)}function validateValueBySchema(s,o,i,a,u,_){if(!o)return[];let w=[],x=o.get("nullable"),C=o.get("required"),j=o.get("maximum"),L=o.get("minimum"),B=o.get("type"),$=o.get("format"),U=o.get("maxLength"),V=o.get("minLength"),z=o.get("uniqueItems"),Y=o.get("maxItems"),Z=o.get("minItems"),ee=o.get("pattern");const ie=i||!0===C,ae=null!=s,ce=ie||ae&&"array"===B||!(!ie&&!ae),le=x&&null===s;if(ie&&!ae&&!le&&!a&&!B)return w.push("Required field is not provided"),w;if(le||!B||!ce)return[];let pe="string"===B&&s,de="array"===B&&Array.isArray(s)&&s.length,fe="array"===B&&We().List.isList(s)&&s.count(),ye="array"===B&&"string"==typeof s&&s;const be=[pe,de,fe,"file"===B&&s instanceof lt.File,"boolean"===B&&(s||!1===s),"number"===B&&(s||0===s),"integer"===B&&(s||0===s),"object"===B&&"object"==typeof s&&null!==s,"object"===B&&"string"==typeof s&&s],Se=(_?be:be.concat(ye)).some((s=>!!s));if(ie&&!Se&&!a)return w.push("Required field is not provided"),w;if("object"===B&&(null===u||"application/json"===u)){let i=s;if("string"==typeof s)try{i=JSON.parse(s)}catch(s){return w.push("Parameter string value must be valid JSON"),w}o&&o.has("required")&&isFunc(C.isList)&&C.isList()&&C.forEach((s=>{void 0===i[s]&&w.push({propKey:s,error:"Required property not found"})})),o&&o.has("properties")&&o.get("properties").forEach(((s,o)=>{const x=validateValueBySchema(i[o],s,!1,a,u,_);w.push(...x.map((s=>({propKey:o,error:s}))))}))}if(ee){let o=((s,o)=>{if(!new RegExp(o).test(s))return"Value must follow pattern "+o})(s,ee);o&&w.push(o)}if(Z&&"array"===B){let o=((s,o)=>{if(!s&&o>=1||s&&s.length<o)return`Array must contain at least ${o} item${1===o?"":"s"}`})(s,Z);o&&w.push(o)}if(Y&&"array"===B){let o=((s,o)=>{if(s&&s.length>o)return`Array must not contain more then ${o} item${1===o?"":"s"}`})(s,Y);o&&w.push({needRemove:!0,error:o})}if(z&&"array"===B){let o=((s,o)=>{if(s&&("true"===o||!0===o)){const o=(0,ze.fromJS)(s),i=o.toSet();if(s.length>i.size){let s=(0,ze.Set)();if(o.forEach(((i,a)=>{o.filter((s=>isFunc(s.equals)?s.equals(i):s===i)).size>1&&(s=s.add(a))})),0!==s.size)return s.map((s=>({index:s,error:"No duplicates allowed."}))).toArray()}}})(s,z);o&&w.push(...o)}if(U||0===U){let o=((s,o)=>{if(s.length>o)return`Value must be no longer than ${o} character${1!==o?"s":""}`})(s,U);o&&w.push(o)}if(V){let o=((s,o)=>{if(s.length<o)return`Value must be at least ${o} character${1!==o?"s":""}`})(s,V);o&&w.push(o)}if(j||0===j){let o=((s,o)=>{if(s>o)return`Value must be less than or equal to ${o}`})(s,j);o&&w.push(o)}if(L||0===L){let o=((s,o)=>{if(s<o)return`Value must be greater than or equal to ${o}`})(s,L);o&&w.push(o)}if("string"===B){let o;if(o="date-time"===$?(s=>{if(isNaN(Date.parse(s)))return"Value must be a DateTime"})(s):"uuid"===$?(s=>{if(s=s.toString().toLowerCase(),!/^[{(]?[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}[)}]?$/.test(s))return"Value must be a Guid"})(s):(s=>{if(s&&"string"!=typeof s)return"Value must be a string"})(s),!o)return w;w.push(o)}else if("boolean"===B){let o=(s=>{if("true"!==s&&"false"!==s&&!0!==s&&!1!==s)return"Value must be a boolean"})(s);if(!o)return w;w.push(o)}else if("number"===B){let o=(s=>{if(!/^-?\d+(\.?\d+)?$/.test(s))return"Value must be a number"})(s);if(!o)return w;w.push(o)}else if("integer"===B){let o=(s=>{if(!/^-?\d+$/.test(s))return"Value must be an integer"})(s);if(!o)return w;w.push(o)}else if("array"===B){if(!de&&!fe)return w;s&&s.forEach(((s,i)=>{const x=validateValueBySchema(s,o.get("items"),!1,a,u,_);w.push(...x.map((s=>({index:i,error:s}))))}))}else if("file"===B){let o=(s=>{if(s&&!(s instanceof lt.File))return"Value must be a file"})(s);if(!o)return w;w.push(o)}return w}const utils_btoa=s=>{let o;return o=s instanceof Ct?s:Ct.from(s.toString(),"utf-8"),o.toString("base64")},It={operationsSorter:{alpha:(s,o)=>s.get("path").localeCompare(o.get("path")),method:(s,o)=>s.get("method").localeCompare(o.get("method"))},tagsSorter:{alpha:(s,o)=>s.localeCompare(o)}},buildFormData=s=>{let o=[];for(let i in s){let a=s[i];void 0!==a&&""!==a&&o.push([i,"=",encodeURIComponent(a).replace(/%20/g,"+")].join(""))}return o.join("&")},shallowEqualKeys=(s,o,i)=>!!dt()(i,(i=>vt()(s[i],o[i])));function requiresValidationURL(s){return!(!s||s.indexOf("localhost")>=0||s.indexOf("127.0.0.1")>=0||"none"===s)}const createDeepLinkPath=s=>"string"==typeof s||s instanceof String?s.trim().replace(/\s/g,"%20"):"",escapeDeepLinkPath=s=>Et()(createDeepLinkPath(s).replace(/%20/g,"_")),isExtension=s=>/^x-/.test(s),getExtensions=s=>ze.Map.isMap(s)?s.filter(((s,o)=>isExtension(o))):Object.keys(s).filter((s=>isExtension(s))),getCommonExtensions=s=>s.filter(((s,o)=>/^pattern|maxLength|minLength|maximum|minimum/.test(o)));function deeplyStripKey(s,o,i=()=>!0){if("object"!=typeof s||Array.isArray(s)||null===s||!o)return s;const a=Object.assign({},s);return Object.keys(a).forEach((s=>{s===o&&i(a[s],s)?delete a[s]:a[s]=deeplyStripKey(a[s],o,i)})),a}function stringify(s){if("string"==typeof s)return s;if(s&&s.toJS&&(s=s.toJS()),"object"==typeof s&&null!==s)try{return JSON.stringify(s,null,2)}catch(o){return String(s)}return null==s?"":s.toString()}function paramToIdentifier(s,{returnAll:o=!1,allowHashes:i=!0}={}){if(!We().Map.isMap(s))throw new Error("paramToIdentifier: received a non-Im.Map parameter as input");const a=s.get("name"),u=s.get("in");let _=[];return s&&s.hashCode&&u&&a&&i&&_.push(`${u}.${a}.hash-${s.hashCode()}`),u&&a&&_.push(`${u}.${a}`),_.push(a),o?_:_[0]||""}function paramToValue(s,o){return paramToIdentifier(s,{returnAll:!0}).map((s=>o[s])).filter((s=>void 0!==s))[0]}function b64toB64UrlEncoded(s){return s.replace(/\+/g,"-").replace(/\//g,"_").replace(/=/g,"")}const isEmptyValue=s=>!s||!(!isImmutable(s)||!s.isEmpty()),idFn=s=>s;function createStoreWithMiddleware(s,o,i){let a=[systemThunkMiddleware(i)];return createStore(s,o,(lt.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||compose)(function applyMiddleware(...s){return o=>(i,a)=>{const u=o(i,a);let dispatch=()=>{throw new Error(formatProdErrorMessage(15))};const _={getState:u.getState,dispatch:(s,...o)=>dispatch(s,...o)},w=s.map((s=>s(_)));return dispatch=compose(...w)(u.dispatch),{...u,dispatch}}}(...a)))}class Store{constructor(s={}){Ye()(this,{state:{},plugins:[],system:{configs:{},fn:{},components:{},rootInjects:{},statePlugins:{}},boundSystem:{},toolbox:{}},s),this.getSystem=this._getSystem.bind(this),this.store=function configureStore(s,o,i){return createStoreWithMiddleware(s,o,i)}(idFn,(0,ze.fromJS)(this.state),this.getSystem),this.buildSystem(!1),this.register(this.plugins)}getStore(){return this.store}register(s,o=!0){var i=combinePlugins(s,this.getSystem());systemExtend(this.system,i),o&&this.buildSystem();callAfterLoad.call(this.system,s,this.getSystem())&&this.buildSystem()}buildSystem(s=!0){let o=this.getStore().dispatch,i=this.getStore().getState;this.boundSystem=Object.assign({},this.getRootInjects(),this.getWrappedAndBoundActions(o),this.getWrappedAndBoundSelectors(i,this.getSystem),this.getStateThunks(i),this.getFn(),this.getConfigs()),s&&this.rebuildReducer()}_getSystem(){return this.boundSystem}getRootInjects(){return Object.assign({getSystem:this.getSystem,getStore:this.getStore.bind(this),getComponents:this.getComponents.bind(this),getState:this.getStore().getState,getConfigs:this._getConfigs.bind(this),Im:We(),React:Re},this.system.rootInjects||{})}_getConfigs(){return this.system.configs}getConfigs(){return{configs:this.system.configs}}setConfigs(s){this.system.configs=s}rebuildReducer(){this.store.replaceReducer(function buildReducer(s,o){return function allReducers(s,o){let i=Object.keys(s).reduce(((i,a)=>(i[a]=function makeReducer(s,o){return(i=new ze.Map,a)=>{if(!s)return i;let u=s[a.type];if(u){const s=wrapWithTryCatch(u,o)(i,a);return null===s?i:s}return i}}(s[a],o),i)),{});if(!Object.keys(i).length)return idFn;return(0,Xe.H)(i)}(objMap(s,(s=>s.reducers)),o)}(this.system.statePlugins,this.getSystem))}getType(s){let o=s[0].toUpperCase()+s.slice(1);return objReduce(this.system.statePlugins,((i,a)=>{let u=i[s];if(u)return{[a+o]:u}}))}getSelectors(){return this.getType("selectors")}getActions(){return objMap(this.getType("actions"),(s=>objReduce(s,((s,o)=>{if(isFn(s))return{[o]:s}}))))}getWrappedAndBoundActions(s){return objMap(this.getBoundActions(s),((s,o)=>{let i=this.system.statePlugins[o.slice(0,-7)].wrapActions;return i?objMap(s,((s,o)=>{let a=i[o];return a?(Array.isArray(a)||(a=[a]),a.reduce(((s,o)=>{let newAction=(...i)=>o(s,this.getSystem())(...i);if(!isFn(newAction))throw new TypeError("wrapActions needs to return a function that returns a new function (ie the wrapped action)");return wrapWithTryCatch(newAction,this.getSystem)}),s||Function.prototype)):s})):s}))}getWrappedAndBoundSelectors(s,o){return objMap(this.getBoundSelectors(s,o),((o,i)=>{let a=[i.slice(0,-9)],u=this.system.statePlugins[a].wrapSelectors;return u?objMap(o,((o,i)=>{let _=u[i];return _?(Array.isArray(_)||(_=[_]),_.reduce(((o,i)=>{let wrappedSelector=(...u)=>i(o,this.getSystem())(s().getIn(a),...u);if(!isFn(wrappedSelector))throw new TypeError("wrapSelector needs to return a function that returns a new function (ie the wrapped action)");return wrappedSelector}),o||Function.prototype)):o})):o}))}getStates(s){return Object.keys(this.system.statePlugins).reduce(((o,i)=>(o[i]=s.get(i),o)),{})}getStateThunks(s){return Object.keys(this.system.statePlugins).reduce(((o,i)=>(o[i]=()=>s().get(i),o)),{})}getFn(){return{fn:this.system.fn}}getComponents(s){const o=this.system.components[s];return Array.isArray(o)?o.reduce(((s,o)=>o(s,this.getSystem()))):void 0!==s?this.system.components[s]:this.system.components}getBoundSelectors(s,o){return objMap(this.getSelectors(),((i,a)=>{let u=[a.slice(0,-9)];return objMap(i,(i=>(...a)=>{let _=wrapWithTryCatch(i,this.getSystem).apply(null,[s().getIn(u),...a]);return"function"==typeof _&&(_=wrapWithTryCatch(_,this.getSystem)(o())),_}))}))}getBoundActions(s){s=s||this.getStore().dispatch;const o=this.getActions(),process=s=>"function"!=typeof s?objMap(s,(s=>process(s))):(...o)=>{var i=null;try{i=s(...o)}catch(s){i={type:rt,error:!0,payload:(0,Qe.serializeError)(s)}}finally{return i}};return objMap(o,(o=>function bindActionCreators(s,o){if("function"==typeof s)return bindActionCreator(s,o);if("object"!=typeof s||null===s)throw new Error(formatProdErrorMessage(16));const i={};for(const a in s){const u=s[a];"function"==typeof u&&(i[a]=bindActionCreator(u,o))}return i}(process(o),s)))}getMapStateToProps(){return()=>Object.assign({},this.getSystem())}getMapDispatchToProps(s){return o=>Ye()({},this.getWrappedAndBoundActions(o),this.getFn(),s)}}function combinePlugins(s,o){return isObject(s)&&!isArray(s)?tt()({},s):isFunc(s)?combinePlugins(s(o),o):isArray(s)?s.map((s=>combinePlugins(s,o))).reduce(systemExtend,{components:o.getComponents()}):{}}function callAfterLoad(s,o,{hasLoaded:i}={}){let a=i;return isObject(s)&&!isArray(s)&&"function"==typeof s.afterLoad&&(a=!0,wrapWithTryCatch(s.afterLoad,o.getSystem).call(this,o)),isFunc(s)?callAfterLoad.call(this,s(o),o,{hasLoaded:a}):isArray(s)?s.map((s=>callAfterLoad.call(this,s,o,{hasLoaded:a}))):a}function systemExtend(s={},o={}){if(!isObject(s))return{};if(!isObject(o))return s;o.wrapComponents&&(objMap(o.wrapComponents,((i,a)=>{const u=s.components&&s.components[a];u&&Array.isArray(u)?(s.components[a]=u.concat([i]),delete o.wrapComponents[a]):u&&(s.components[a]=[u,i],delete o.wrapComponents[a])})),Object.keys(o.wrapComponents).length||delete o.wrapComponents);const{statePlugins:i}=s;if(isObject(i))for(let s in i){const a=i[s];if(!isObject(a))continue;const{wrapActions:u,wrapSelectors:_}=a;if(isObject(u))for(let i in u){let a=u[i];Array.isArray(a)||(a=[a],u[i]=a),o&&o.statePlugins&&o.statePlugins[s]&&o.statePlugins[s].wrapActions&&o.statePlugins[s].wrapActions[i]&&(o.statePlugins[s].wrapActions[i]=u[i].concat(o.statePlugins[s].wrapActions[i]))}if(isObject(_))for(let i in _){let a=_[i];Array.isArray(a)||(a=[a],_[i]=a),o&&o.statePlugins&&o.statePlugins[s]&&o.statePlugins[s].wrapSelectors&&o.statePlugins[s].wrapSelectors[i]&&(o.statePlugins[s].wrapSelectors[i]=_[i].concat(o.statePlugins[s].wrapSelectors[i]))}}return Ye()(s,o)}function wrapWithTryCatch(s,o,{logErrors:i=!0}={}){return"function"!=typeof s?s:function(...a){try{return s.call(this,...a)}catch(s){if(i){const{uncaughtExceptionHandler:i}=o().getConfigs();"function"==typeof i?i(s):console.error(s)}return null}}}var Tt=__webpack_require__(61160),Nt=__webpack_require__.n(Tt);const Mt="show_popup",Rt="authorize",Dt="logout",Lt="authorize_oauth2",Ft="configure_auth",Bt="restore_authorization";function showDefinitions(s){return{type:Mt,payload:s}}function authorize(s){return{type:Rt,payload:s}}const authorizeWithPersistOption=s=>({authActions:o})=>{o.authorize(s),o.persistAuthorizationIfNeeded()};function logout(s){return{type:Dt,payload:s}}const logoutWithPersistOption=s=>({authActions:o})=>{o.logout(s),o.persistAuthorizationIfNeeded()},preAuthorizeImplicit=s=>({authActions:o,errActions:i})=>{let{auth:a,token:u,isValid:_}=s,{schema:w,name:x}=a,C=w.get("flow");delete lt.swaggerUIRedirectOauth2,"accessCode"===C||_||i.newAuthErr({authId:x,source:"auth",level:"warning",message:"Authorization may be unsafe, passed state was changed in server Passed state wasn't returned from auth server"}),u.error?i.newAuthErr({authId:x,source:"auth",level:"error",message:JSON.stringify(u)}):o.authorizeOauth2WithPersistOption({auth:a,token:u})};function authorizeOauth2(s){return{type:Lt,payload:s}}const authorizeOauth2WithPersistOption=s=>({authActions:o})=>{o.authorizeOauth2(s),o.persistAuthorizationIfNeeded()},authorizePassword=s=>({authActions:o})=>{let{schema:i,name:a,username:u,password:_,passwordType:w,clientId:x,clientSecret:C}=s,j={grant_type:"password",scope:s.scopes.join(" "),username:u,password:_},L={};switch(w){case"request-body":!function setClientIdAndSecret(s,o,i){o&&Object.assign(s,{client_id:o});i&&Object.assign(s,{client_secret:i})}(j,x,C);break;case"basic":L.Authorization="Basic "+utils_btoa(x+":"+C);break;default:console.warn(`Warning: invalid passwordType ${w} was passed, not including client id and secret`)}return o.authorizeRequest({body:buildFormData(j),url:i.get("tokenUrl"),name:a,headers:L,query:{},auth:s})};const authorizeApplication=s=>({authActions:o})=>{let{schema:i,scopes:a,name:u,clientId:_,clientSecret:w}=s,x={Authorization:"Basic "+utils_btoa(_+":"+w)},C={grant_type:"client_credentials",scope:a.join(" ")};return o.authorizeRequest({body:buildFormData(C),name:u,url:i.get("tokenUrl"),auth:s,headers:x})},authorizeAccessCodeWithFormParams=({auth:s,redirectUrl:o})=>({authActions:i})=>{let{schema:a,name:u,clientId:_,clientSecret:w,codeVerifier:x}=s,C={grant_type:"authorization_code",code:s.code,client_id:_,client_secret:w,redirect_uri:o,code_verifier:x};return i.authorizeRequest({body:buildFormData(C),name:u,url:a.get("tokenUrl"),auth:s})},authorizeAccessCodeWithBasicAuthentication=({auth:s,redirectUrl:o})=>({authActions:i})=>{let{schema:a,name:u,clientId:_,clientSecret:w,codeVerifier:x}=s,C={Authorization:"Basic "+utils_btoa(_+":"+w)},j={grant_type:"authorization_code",code:s.code,client_id:_,redirect_uri:o,code_verifier:x};return i.authorizeRequest({body:buildFormData(j),name:u,url:a.get("tokenUrl"),auth:s,headers:C})},authorizeRequest=s=>({fn:o,getConfigs:i,authActions:a,errActions:u,oas3Selectors:_,specSelectors:w,authSelectors:x})=>{let C,{body:j,query:L={},headers:B={},name:$,url:U,auth:V}=s,{additionalQueryStringParams:z}=x.getConfigs()||{};if(w.isOAS3()){let s=_.serverEffectiveValue(_.selectedServer());C=Nt()(U,s,!0)}else C=Nt()(U,w.url(),!0);"object"==typeof z&&(C.query=Object.assign({},C.query,z));const Y=C.toString();let Z=Object.assign({Accept:"application/json, text/plain, */*","Content-Type":"application/x-www-form-urlencoded","X-Requested-With":"XMLHttpRequest"},B);o.fetch({url:Y,method:"post",headers:Z,query:L,body:j,requestInterceptor:i().requestInterceptor,responseInterceptor:i().responseInterceptor}).then((function(s){let o=JSON.parse(s.data),i=o&&(o.error||""),_=o&&(o.parseError||"");s.ok?i||_?u.newAuthErr({authId:$,level:"error",source:"auth",message:JSON.stringify(o)}):a.authorizeOauth2WithPersistOption({auth:V,token:o}):u.newAuthErr({authId:$,level:"error",source:"auth",message:s.statusText})})).catch((s=>{let o=new Error(s).message;if(s.response&&s.response.data){const i=s.response.data;try{const s="string"==typeof i?JSON.parse(i):i;s.error&&(o+=`, error: ${s.error}`),s.error_description&&(o+=`, description: ${s.error_description}`)}catch(s){}}u.newAuthErr({authId:$,level:"error",source:"auth",message:o})}))};function configureAuth(s){return{type:Ft,payload:s}}function restoreAuthorization(s){return{type:Bt,payload:s}}const persistAuthorizationIfNeeded=()=>({authSelectors:s,getConfigs:o})=>{if(!o().persistAuthorization)return;const i=s.authorized().toJS();localStorage.setItem("authorized",JSON.stringify(i))},authPopup=(s,o)=>()=>{lt.swaggerUIRedirectOauth2=o,lt.open(s)},$t={[Mt]:(s,{payload:o})=>s.set("showDefinitions",o),[Rt]:(s,{payload:o})=>{let i=(0,ze.fromJS)(o),a=s.get("authorized")||(0,ze.Map)();return i.entrySeq().forEach((([o,i])=>{if(!isFunc(i.getIn))return s.set("authorized",a);let u=i.getIn(["schema","type"]);if("apiKey"===u||"http"===u)a=a.set(o,i);else if("basic"===u){let s=i.getIn(["value","username"]),u=i.getIn(["value","password"]);a=a.setIn([o,"value"],{username:s,header:"Basic "+utils_btoa(s+":"+u)}),a=a.setIn([o,"schema"],i.get("schema"))}})),s.set("authorized",a)},[Lt]:(s,{payload:o})=>{let i,{auth:a,token:u}=o;a.token=Object.assign({},u),i=(0,ze.fromJS)(a);let _=s.get("authorized")||(0,ze.Map)();return _=_.set(i.get("name"),i),s.set("authorized",_)},[Dt]:(s,{payload:o})=>{let i=s.get("authorized").withMutations((s=>{o.forEach((o=>{s.delete(o)}))}));return s.set("authorized",i)},[Ft]:(s,{payload:o})=>s.set("configs",o),[Bt]:(s,{payload:o})=>s.set("authorized",(0,ze.fromJS)(o.authorized))};function assertIsFunction(s,o="expected a function, instead received "+typeof s){if("function"!=typeof s)throw new TypeError(o)}var ensureIsArray=s=>Array.isArray(s)?s:[s];function getDependencies(s){const o=Array.isArray(s[0])?s[0]:s;return function assertIsArrayOfFunctions(s,o="expected all items to be functions, instead received the following types: "){if(!s.every((s=>"function"==typeof s))){const i=s.map((s=>"function"==typeof s?`function ${s.name||"unnamed"}()`:typeof s)).join(", ");throw new TypeError(`${o}[${i}]`)}}(o,"createSelector expects all input-selectors to be functions, but received the following types: "),o}Symbol(),Object.getPrototypeOf({});var qt="undefined"!=typeof WeakRef?WeakRef:class{constructor(s){this.value=s}deref(){return this.value}};function weakMapMemoize(s,o={}){let i={s:0,v:void 0,o:null,p:null};const{resultEqualityCheck:a}=o;let u,_=0;function memoized(){let o=i;const{length:w}=arguments;for(let s=0,i=w;s<i;s++){const i=arguments[s];if("function"==typeof i||"object"==typeof i&&null!==i){let s=o.o;null===s&&(o.o=s=new WeakMap);const a=s.get(i);void 0===a?(o={s:0,v:void 0,o:null,p:null},s.set(i,o)):o=a}else{let s=o.p;null===s&&(o.p=s=new Map);const a=s.get(i);void 0===a?(o={s:0,v:void 0,o:null,p:null},s.set(i,o)):o=a}}const x=o;let C;if(1===o.s)C=o.v;else if(C=s.apply(null,arguments),_++,a){const s=u?.deref?.()??u;null!=s&&a(s,C)&&(C=s,0!==_&&_--);u="object"==typeof C&&null!==C||"function"==typeof C?new qt(C):C}return x.s=1,x.v=C,C}return memoized.clearCache=()=>{i={s:0,v:void 0,o:null,p:null},memoized.resetResultsCount()},memoized.resultsCount=()=>_,memoized.resetResultsCount=()=>{_=0},memoized}function createSelectorCreator(s,...o){const i="function"==typeof s?{memoize:s,memoizeOptions:o}:s,createSelector2=(...s)=>{let o,a=0,u=0,_={},w=s.pop();"object"==typeof w&&(_=w,w=s.pop()),assertIsFunction(w,`createSelector expects an output function after the inputs, but received: [${typeof w}]`);const x={...i,..._},{memoize:C,memoizeOptions:j=[],argsMemoize:L=weakMapMemoize,argsMemoizeOptions:B=[],devModeChecks:$={}}=x,U=ensureIsArray(j),V=ensureIsArray(B),z=getDependencies(s),Y=C((function recomputationWrapper(){return a++,w.apply(null,arguments)}),...U);const Z=L((function dependenciesChecker(){u++;const s=function collectInputSelectorResults(s,o){const i=[],{length:a}=s;for(let u=0;u<a;u++)i.push(s[u].apply(null,o));return i}(z,arguments);return o=Y.apply(null,s),o}),...V);return Object.assign(Z,{resultFunc:w,memoizedResultFunc:Y,dependencies:z,dependencyRecomputations:()=>u,resetDependencyRecomputations:()=>{u=0},lastResult:()=>o,recomputations:()=>a,resetRecomputations:()=>{a=0},memoize:C,argsMemoize:L})};return Object.assign(createSelector2,{withTypes:()=>createSelector2}),createSelector2}var Ut=createSelectorCreator(weakMapMemoize),Vt=Object.assign(((s,o=Ut)=>{!function assertIsObject(s,o="expected an object, instead received "+typeof s){if("object"!=typeof s)throw new TypeError(o)}(s,"createStructuredSelector expects first argument to be an object where each property is a selector, instead received a "+typeof s);const i=Object.keys(s);return o(i.map((o=>s[o])),((...s)=>s.reduce(((s,o,a)=>(s[i[a]]=o,s)),{})))}),{withTypes:()=>Vt});const state=s=>s,zt=Ut(state,(s=>s.get("showDefinitions"))),Wt=Ut(state,(()=>({specSelectors:s})=>{let o=s.securityDefinitions()||(0,ze.Map)({}),i=(0,ze.List)();return o.entrySeq().forEach((([s,o])=>{let a=(0,ze.Map)();a=a.set(s,o),i=i.push(a)})),i})),selectAuthPath=(s,o)=>({specSelectors:s})=>(0,ze.List)(s.isOAS3()?["components","securitySchemes",o]:["securityDefinitions",o]),getDefinitionsByNames=(s,o)=>({specSelectors:s})=>{console.warn("WARNING: getDefinitionsByNames is deprecated and will be removed in the next major version.");let i=s.securityDefinitions(),a=(0,ze.List)();return o.valueSeq().forEach((s=>{let o=(0,ze.Map)();s.entrySeq().forEach((([s,a])=>{let u,_=i.get(s);"oauth2"===_.get("type")&&a.size&&(u=_.get("scopes"),u.keySeq().forEach((s=>{a.contains(s)||(u=u.delete(s))})),_=_.set("allowedScopes",u)),o=o.set(s,_)})),a=a.push(o)})),a},definitionsForRequirements=(s,o=(0,ze.List)())=>({authSelectors:s})=>{const i=s.definitionsToAuthorize()||(0,ze.List)();let a=(0,ze.List)();return i.forEach((s=>{let i=o.find((o=>o.get(s.keySeq().first())));i&&(s.forEach(((o,a)=>{if("oauth2"===o.get("type")){const u=i.get(a);let _=o.get("scopes");ze.List.isList(u)&&ze.Map.isMap(_)&&(_.keySeq().forEach((s=>{u.contains(s)||(_=_.delete(s))})),s=s.set(a,o.set("scopes",_)))}})),a=a.push(s))})),a},Jt=Ut(state,(s=>s.get("authorized")||(0,ze.Map)())),isAuthorized=(s,o)=>({authSelectors:s})=>{let i=s.authorized();return ze.List.isList(o)?!!o.toJS().filter((s=>-1===Object.keys(s).map((s=>!!i.get(s))).indexOf(!1))).length:null},Ht=Ut(state,(s=>s.get("configs"))),execute=(s,{authSelectors:o,specSelectors:i})=>({path:a,method:u,operation:_,extras:w})=>{let x={authorized:o.authorized()&&o.authorized().toJS(),definitions:i.securityDefinitions()&&i.securityDefinitions().toJS(),specSecurity:i.security()&&i.security().toJS()};return s({path:a,method:u,operation:_,securities:x,...w})},loaded=(s,o)=>i=>{const{getConfigs:a,authActions:u}=o,_=a();if(s(i),_.persistAuthorization){const s=localStorage.getItem("authorized");s&&u.restoreAuthorization({authorized:JSON.parse(s)})}},wrap_actions_authorize=(s,o)=>i=>{s(i);if(o.getConfigs().persistAuthorization)try{const[{schema:s,value:o}]=Object.values(i),a=(0,ze.fromJS)(s),u="apiKey"===a.get("type"),_="cookie"===a.get("in");u&&_&&(document.cookie=`${a.get("name")}=${o}; SameSite=None; Secure`)}catch(s){console.error("Error persisting cookie based apiKey in document.cookie.",s)}},wrap_actions_logout=(s,o)=>i=>{const a=o.getConfigs(),u=o.authSelectors.authorized();try{a.persistAuthorization&&Array.isArray(i)&&i.forEach((s=>{const o=u.get(s,{}),i="apiKey"===o.getIn(["schema","type"]),a="cookie"===o.getIn(["schema","in"]);if(i&&a){const s=o.getIn(["schema","name"]);document.cookie=`${s}=; Max-Age=-99999999`}}))}catch(s){console.error("Error deleting cookie based apiKey from document.cookie.",s)}s(i)};var Kt=__webpack_require__(90179),Gt=__webpack_require__.n(Kt);class LockAuthIcon extends Re.Component{mapStateToProps(s,o){return{state:s,ownProps:Gt()(o,Object.keys(o.getSystem()))}}render(){const{getComponent:s,ownProps:o}=this.props,i=s("LockIcon");return Re.createElement(i,o)}}const Yt=LockAuthIcon;class UnlockAuthIcon extends Re.Component{mapStateToProps(s,o){return{state:s,ownProps:Gt()(o,Object.keys(o.getSystem()))}}render(){const{getComponent:s,ownProps:o}=this.props,i=s("UnlockIcon");return Re.createElement(i,o)}}const Xt=UnlockAuthIcon;function auth(){return{afterLoad(s){this.rootInjects=this.rootInjects||{},this.rootInjects.initOAuth=s.authActions.configureAuth,this.rootInjects.preauthorizeApiKey=preauthorizeApiKey.bind(null,s),this.rootInjects.preauthorizeBasic=preauthorizeBasic.bind(null,s)},components:{LockAuthIcon:Yt,UnlockAuthIcon:Xt,LockAuthOperationIcon:Yt,UnlockAuthOperationIcon:Xt},statePlugins:{auth:{reducers:$t,actions:o,selectors:a,wrapActions:{authorize:wrap_actions_authorize,logout:wrap_actions_logout}},configs:{wrapActions:{loaded}},spec:{wrapActions:{execute}}}}}function preauthorizeBasic(s,o,i,a){const{authActions:{authorize:u},specSelectors:{specJson:_,isOAS3:w}}=s,x=w()?["components","securitySchemes"]:["securityDefinitions"],C=_().getIn([...x,o]);return C?u({[o]:{value:{username:i,password:a},schema:C.toJS()}}):null}function preauthorizeApiKey(s,o,i){const{authActions:{authorize:a},specSelectors:{specJson:u,isOAS3:_}}=s,w=_()?["components","securitySchemes"]:["securityDefinitions"],x=u().getIn([...w,o]);return x?a({[o]:{value:i,schema:x.toJS()}}):null}function isNothing(s){return null==s}var Qt=function repeat(s,o){var i,a="";for(i=0;i<o;i+=1)a+=s;return a},Zt=function isNegativeZero(s){return 0===s&&Number.NEGATIVE_INFINITY===1/s},er={isNothing,isObject:function js_yaml_isObject(s){return"object"==typeof s&&null!==s},toArray:function toArray(s){return Array.isArray(s)?s:isNothing(s)?[]:[s]},repeat:Qt,isNegativeZero:Zt,extend:function extend(s,o){var i,a,u,_;if(o)for(i=0,a=(_=Object.keys(o)).length;i<a;i+=1)s[u=_[i]]=o[u];return s}};function formatError(s,o){var i="",a=s.reason||"(unknown reason)";return s.mark?(s.mark.name&&(i+='in "'+s.mark.name+'" '),i+="("+(s.mark.line+1)+":"+(s.mark.column+1)+")",!o&&s.mark.snippet&&(i+="\n\n"+s.mark.snippet),a+" "+i):a}function YAMLException$1(s,o){Error.call(this),this.name="YAMLException",this.reason=s,this.mark=o,this.message=formatError(this,!1),Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):this.stack=(new Error).stack||""}YAMLException$1.prototype=Object.create(Error.prototype),YAMLException$1.prototype.constructor=YAMLException$1,YAMLException$1.prototype.toString=function toString(s){return this.name+": "+formatError(this,s)};var tr=YAMLException$1;function getLine(s,o,i,a,u){var _="",w="",x=Math.floor(u/2)-1;return a-o>x&&(o=a-x+(_=" ... ").length),i-a>x&&(i=a+x-(w=" ...").length),{str:_+s.slice(o,i).replace(/\t/g,"→")+w,pos:a-o+_.length}}function padStart(s,o){return er.repeat(" ",o-s.length)+s}var rr=function makeSnippet(s,o){if(o=Object.create(o||null),!s.buffer)return null;o.maxLength||(o.maxLength=79),"number"!=typeof o.indent&&(o.indent=1),"number"!=typeof o.linesBefore&&(o.linesBefore=3),"number"!=typeof o.linesAfter&&(o.linesAfter=2);for(var i,a=/\r?\n|\r|\0/g,u=[0],_=[],w=-1;i=a.exec(s.buffer);)_.push(i.index),u.push(i.index+i[0].length),s.position<=i.index&&w<0&&(w=u.length-2);w<0&&(w=u.length-1);var x,C,j="",L=Math.min(s.line+o.linesAfter,_.length).toString().length,B=o.maxLength-(o.indent+L+3);for(x=1;x<=o.linesBefore&&!(w-x<0);x++)C=getLine(s.buffer,u[w-x],_[w-x],s.position-(u[w]-u[w-x]),B),j=er.repeat(" ",o.indent)+padStart((s.line-x+1).toString(),L)+" | "+C.str+"\n"+j;for(C=getLine(s.buffer,u[w],_[w],s.position,B),j+=er.repeat(" ",o.indent)+padStart((s.line+1).toString(),L)+" | "+C.str+"\n",j+=er.repeat("-",o.indent+L+3+C.pos)+"^\n",x=1;x<=o.linesAfter&&!(w+x>=_.length);x++)C=getLine(s.buffer,u[w+x],_[w+x],s.position-(u[w]-u[w+x]),B),j+=er.repeat(" ",o.indent)+padStart((s.line+x+1).toString(),L)+" | "+C.str+"\n";return j.replace(/\n$/,"")},nr=["kind","multi","resolve","construct","instanceOf","predicate","represent","representName","defaultStyle","styleAliases"],sr=["scalar","sequence","mapping"];var ir=function Type$1(s,o){if(o=o||{},Object.keys(o).forEach((function(o){if(-1===nr.indexOf(o))throw new tr('Unknown option "'+o+'" is met in definition of "'+s+'" YAML type.')})),this.options=o,this.tag=s,this.kind=o.kind||null,this.resolve=o.resolve||function(){return!0},this.construct=o.construct||function(s){return s},this.instanceOf=o.instanceOf||null,this.predicate=o.predicate||null,this.represent=o.represent||null,this.representName=o.representName||null,this.defaultStyle=o.defaultStyle||null,this.multi=o.multi||!1,this.styleAliases=function compileStyleAliases(s){var o={};return null!==s&&Object.keys(s).forEach((function(i){s[i].forEach((function(s){o[String(s)]=i}))})),o}(o.styleAliases||null),-1===sr.indexOf(this.kind))throw new tr('Unknown kind "'+this.kind+'" is specified for "'+s+'" YAML type.')};function compileList(s,o){var i=[];return s[o].forEach((function(s){var o=i.length;i.forEach((function(i,a){i.tag===s.tag&&i.kind===s.kind&&i.multi===s.multi&&(o=a)})),i[o]=s})),i}function Schema$1(s){return this.extend(s)}Schema$1.prototype.extend=function extend(s){var o=[],i=[];if(s instanceof ir)i.push(s);else if(Array.isArray(s))i=i.concat(s);else{if(!s||!Array.isArray(s.implicit)&&!Array.isArray(s.explicit))throw new tr("Schema.extend argument should be a Type, [ Type ], or a schema definition ({ implicit: [...], explicit: [...] })");s.implicit&&(o=o.concat(s.implicit)),s.explicit&&(i=i.concat(s.explicit))}o.forEach((function(s){if(!(s instanceof ir))throw new tr("Specified list of YAML types (or a single Type object) contains a non-Type object.");if(s.loadKind&&"scalar"!==s.loadKind)throw new tr("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");if(s.multi)throw new tr("There is a multi type in the implicit list of a schema. Multi tags can only be listed as explicit.")})),i.forEach((function(s){if(!(s instanceof ir))throw new tr("Specified list of YAML types (or a single Type object) contains a non-Type object.")}));var a=Object.create(Schema$1.prototype);return a.implicit=(this.implicit||[]).concat(o),a.explicit=(this.explicit||[]).concat(i),a.compiledImplicit=compileList(a,"implicit"),a.compiledExplicit=compileList(a,"explicit"),a.compiledTypeMap=function compileMap(){var s,o,i={scalar:{},sequence:{},mapping:{},fallback:{},multi:{scalar:[],sequence:[],mapping:[],fallback:[]}};function collectType(s){s.multi?(i.multi[s.kind].push(s),i.multi.fallback.push(s)):i[s.kind][s.tag]=i.fallback[s.tag]=s}for(s=0,o=arguments.length;s<o;s+=1)arguments[s].forEach(collectType);return i}(a.compiledImplicit,a.compiledExplicit),a};var ar=Schema$1,cr=new ir("tag:yaml.org,2002:str",{kind:"scalar",construct:function(s){return null!==s?s:""}}),lr=new ir("tag:yaml.org,2002:seq",{kind:"sequence",construct:function(s){return null!==s?s:[]}}),ur=new ir("tag:yaml.org,2002:map",{kind:"mapping",construct:function(s){return null!==s?s:{}}}),pr=new ar({explicit:[cr,lr,ur]});var dr=new ir("tag:yaml.org,2002:null",{kind:"scalar",resolve:function resolveYamlNull(s){if(null===s)return!0;var o=s.length;return 1===o&&"~"===s||4===o&&("null"===s||"Null"===s||"NULL"===s)},construct:function constructYamlNull(){return null},predicate:function isNull(s){return null===s},represent:{canonical:function(){return"~"},lowercase:function(){return"null"},uppercase:function(){return"NULL"},camelcase:function(){return"Null"},empty:function(){return""}},defaultStyle:"lowercase"});var fr=new ir("tag:yaml.org,2002:bool",{kind:"scalar",resolve:function resolveYamlBoolean(s){if(null===s)return!1;var o=s.length;return 4===o&&("true"===s||"True"===s||"TRUE"===s)||5===o&&("false"===s||"False"===s||"FALSE"===s)},construct:function constructYamlBoolean(s){return"true"===s||"True"===s||"TRUE"===s},predicate:function isBoolean(s){return"[object Boolean]"===Object.prototype.toString.call(s)},represent:{lowercase:function(s){return s?"true":"false"},uppercase:function(s){return s?"TRUE":"FALSE"},camelcase:function(s){return s?"True":"False"}},defaultStyle:"lowercase"});function isOctCode(s){return 48<=s&&s<=55}function isDecCode(s){return 48<=s&&s<=57}var mr=new ir("tag:yaml.org,2002:int",{kind:"scalar",resolve:function resolveYamlInteger(s){if(null===s)return!1;var o,i,a=s.length,u=0,_=!1;if(!a)return!1;if("-"!==(o=s[u])&&"+"!==o||(o=s[++u]),"0"===o){if(u+1===a)return!0;if("b"===(o=s[++u])){for(u++;u<a;u++)if("_"!==(o=s[u])){if("0"!==o&&"1"!==o)return!1;_=!0}return _&&"_"!==o}if("x"===o){for(u++;u<a;u++)if("_"!==(o=s[u])){if(!(48<=(i=s.charCodeAt(u))&&i<=57||65<=i&&i<=70||97<=i&&i<=102))return!1;_=!0}return _&&"_"!==o}if("o"===o){for(u++;u<a;u++)if("_"!==(o=s[u])){if(!isOctCode(s.charCodeAt(u)))return!1;_=!0}return _&&"_"!==o}}if("_"===o)return!1;for(;u<a;u++)if("_"!==(o=s[u])){if(!isDecCode(s.charCodeAt(u)))return!1;_=!0}return!(!_||"_"===o)},construct:function constructYamlInteger(s){var o,i=s,a=1;if(-1!==i.indexOf("_")&&(i=i.replace(/_/g,"")),"-"!==(o=i[0])&&"+"!==o||("-"===o&&(a=-1),o=(i=i.slice(1))[0]),"0"===i)return 0;if("0"===o){if("b"===i[1])return a*parseInt(i.slice(2),2);if("x"===i[1])return a*parseInt(i.slice(2),16);if("o"===i[1])return a*parseInt(i.slice(2),8)}return a*parseInt(i,10)},predicate:function isInteger(s){return"[object Number]"===Object.prototype.toString.call(s)&&s%1==0&&!er.isNegativeZero(s)},represent:{binary:function(s){return s>=0?"0b"+s.toString(2):"-0b"+s.toString(2).slice(1)},octal:function(s){return s>=0?"0o"+s.toString(8):"-0o"+s.toString(8).slice(1)},decimal:function(s){return s.toString(10)},hexadecimal:function(s){return s>=0?"0x"+s.toString(16).toUpperCase():"-0x"+s.toString(16).toUpperCase().slice(1)}},defaultStyle:"decimal",styleAliases:{binary:[2,"bin"],octal:[8,"oct"],decimal:[10,"dec"],hexadecimal:[16,"hex"]}}),gr=new RegExp("^(?:[-+]?(?:[0-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$");var yr=/^[-+]?[0-9]+e/;var vr=new ir("tag:yaml.org,2002:float",{kind:"scalar",resolve:function resolveYamlFloat(s){return null!==s&&!(!gr.test(s)||"_"===s[s.length-1])},construct:function constructYamlFloat(s){var o,i;return i="-"===(o=s.replace(/_/g,"").toLowerCase())[0]?-1:1,"+-".indexOf(o[0])>=0&&(o=o.slice(1)),".inf"===o?1===i?Number.POSITIVE_INFINITY:Number.NEGATIVE_INFINITY:".nan"===o?NaN:i*parseFloat(o,10)},predicate:function isFloat(s){return"[object Number]"===Object.prototype.toString.call(s)&&(s%1!=0||er.isNegativeZero(s))},represent:function representYamlFloat(s,o){var i;if(isNaN(s))switch(o){case"lowercase":return".nan";case"uppercase":return".NAN";case"camelcase":return".NaN"}else if(Number.POSITIVE_INFINITY===s)switch(o){case"lowercase":return".inf";case"uppercase":return".INF";case"camelcase":return".Inf"}else if(Number.NEGATIVE_INFINITY===s)switch(o){case"lowercase":return"-.inf";case"uppercase":return"-.INF";case"camelcase":return"-.Inf"}else if(er.isNegativeZero(s))return"-0.0";return i=s.toString(10),yr.test(i)?i.replace("e",".e"):i},defaultStyle:"lowercase"}),br=pr.extend({implicit:[dr,fr,mr,vr]}),Sr=br,_r=new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"),Er=new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$");var wr=new ir("tag:yaml.org,2002:timestamp",{kind:"scalar",resolve:function resolveYamlTimestamp(s){return null!==s&&(null!==_r.exec(s)||null!==Er.exec(s))},construct:function constructYamlTimestamp(s){var o,i,a,u,_,w,x,C,j=0,L=null;if(null===(o=_r.exec(s))&&(o=Er.exec(s)),null===o)throw new Error("Date resolve error");if(i=+o[1],a=+o[2]-1,u=+o[3],!o[4])return new Date(Date.UTC(i,a,u));if(_=+o[4],w=+o[5],x=+o[6],o[7]){for(j=o[7].slice(0,3);j.length<3;)j+="0";j=+j}return o[9]&&(L=6e4*(60*+o[10]+ +(o[11]||0)),"-"===o[9]&&(L=-L)),C=new Date(Date.UTC(i,a,u,_,w,x,j)),L&&C.setTime(C.getTime()-L),C},instanceOf:Date,represent:function representYamlTimestamp(s){return s.toISOString()}});var xr=new ir("tag:yaml.org,2002:merge",{kind:"scalar",resolve:function resolveYamlMerge(s){return"<<"===s||null===s}}),kr="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r";var Or=new ir("tag:yaml.org,2002:binary",{kind:"scalar",resolve:function resolveYamlBinary(s){if(null===s)return!1;var o,i,a=0,u=s.length,_=kr;for(i=0;i<u;i++)if(!((o=_.indexOf(s.charAt(i)))>64)){if(o<0)return!1;a+=6}return a%8==0},construct:function constructYamlBinary(s){var o,i,a=s.replace(/[\r\n=]/g,""),u=a.length,_=kr,w=0,x=[];for(o=0;o<u;o++)o%4==0&&o&&(x.push(w>>16&255),x.push(w>>8&255),x.push(255&w)),w=w<<6|_.indexOf(a.charAt(o));return 0===(i=u%4*6)?(x.push(w>>16&255),x.push(w>>8&255),x.push(255&w)):18===i?(x.push(w>>10&255),x.push(w>>2&255)):12===i&&x.push(w>>4&255),new Uint8Array(x)},predicate:function isBinary(s){return"[object Uint8Array]"===Object.prototype.toString.call(s)},represent:function representYamlBinary(s){var o,i,a="",u=0,_=s.length,w=kr;for(o=0;o<_;o++)o%3==0&&o&&(a+=w[u>>18&63],a+=w[u>>12&63],a+=w[u>>6&63],a+=w[63&u]),u=(u<<8)+s[o];return 0===(i=_%3)?(a+=w[u>>18&63],a+=w[u>>12&63],a+=w[u>>6&63],a+=w[63&u]):2===i?(a+=w[u>>10&63],a+=w[u>>4&63],a+=w[u<<2&63],a+=w[64]):1===i&&(a+=w[u>>2&63],a+=w[u<<4&63],a+=w[64],a+=w[64]),a}}),Ar=Object.prototype.hasOwnProperty,Cr=Object.prototype.toString;var jr=new ir("tag:yaml.org,2002:omap",{kind:"sequence",resolve:function resolveYamlOmap(s){if(null===s)return!0;var o,i,a,u,_,w=[],x=s;for(o=0,i=x.length;o<i;o+=1){if(a=x[o],_=!1,"[object Object]"!==Cr.call(a))return!1;for(u in a)if(Ar.call(a,u)){if(_)return!1;_=!0}if(!_)return!1;if(-1!==w.indexOf(u))return!1;w.push(u)}return!0},construct:function constructYamlOmap(s){return null!==s?s:[]}}),Pr=Object.prototype.toString;var Ir=new ir("tag:yaml.org,2002:pairs",{kind:"sequence",resolve:function resolveYamlPairs(s){if(null===s)return!0;var o,i,a,u,_,w=s;for(_=new Array(w.length),o=0,i=w.length;o<i;o+=1){if(a=w[o],"[object Object]"!==Pr.call(a))return!1;if(1!==(u=Object.keys(a)).length)return!1;_[o]=[u[0],a[u[0]]]}return!0},construct:function constructYamlPairs(s){if(null===s)return[];var o,i,a,u,_,w=s;for(_=new Array(w.length),o=0,i=w.length;o<i;o+=1)a=w[o],u=Object.keys(a),_[o]=[u[0],a[u[0]]];return _}}),Tr=Object.prototype.hasOwnProperty;var Nr=new ir("tag:yaml.org,2002:set",{kind:"mapping",resolve:function resolveYamlSet(s){if(null===s)return!0;var o,i=s;for(o in i)if(Tr.call(i,o)&&null!==i[o])return!1;return!0},construct:function constructYamlSet(s){return null!==s?s:{}}}),Mr=Sr.extend({implicit:[wr,xr],explicit:[Or,jr,Ir,Nr]}),Rr=Object.prototype.hasOwnProperty,Dr=/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/,Lr=/[\x85\u2028\u2029]/,Fr=/[,\[\]\{\}]/,Br=/^(?:!|!!|![a-z\-]+!)$/i,$r=/^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;function _class(s){return Object.prototype.toString.call(s)}function is_EOL(s){return 10===s||13===s}function is_WHITE_SPACE(s){return 9===s||32===s}function is_WS_OR_EOL(s){return 9===s||32===s||10===s||13===s}function is_FLOW_INDICATOR(s){return 44===s||91===s||93===s||123===s||125===s}function fromHexCode(s){var o;return 48<=s&&s<=57?s-48:97<=(o=32|s)&&o<=102?o-97+10:-1}function simpleEscapeSequence(s){return 48===s?"\0":97===s?"":98===s?"\b":116===s||9===s?"\t":110===s?"\n":118===s?"\v":102===s?"\f":114===s?"\r":101===s?"":32===s?" ":34===s?'"':47===s?"/":92===s?"\\":78===s?"":95===s?" ":76===s?"\u2028":80===s?"\u2029":""}function charFromCodepoint(s){return s<=65535?String.fromCharCode(s):String.fromCharCode(55296+(s-65536>>10),56320+(s-65536&1023))}function setProperty(s,o,i){"__proto__"===o?Object.defineProperty(s,o,{configurable:!0,enumerable:!0,writable:!0,value:i}):s[o]=i}for(var qr=new Array(256),Ur=new Array(256),Vr=0;Vr<256;Vr++)qr[Vr]=simpleEscapeSequence(Vr)?1:0,Ur[Vr]=simpleEscapeSequence(Vr);function State$1(s,o){this.input=s,this.filename=o.filename||null,this.schema=o.schema||Mr,this.onWarning=o.onWarning||null,this.legacy=o.legacy||!1,this.json=o.json||!1,this.listener=o.listener||null,this.implicitTypes=this.schema.compiledImplicit,this.typeMap=this.schema.compiledTypeMap,this.length=s.length,this.position=0,this.line=0,this.lineStart=0,this.lineIndent=0,this.firstTabInLine=-1,this.documents=[]}function generateError(s,o){var i={name:s.filename,buffer:s.input.slice(0,-1),position:s.position,line:s.line,column:s.position-s.lineStart};return i.snippet=rr(i),new tr(o,i)}function throwError(s,o){throw generateError(s,o)}function throwWarning(s,o){s.onWarning&&s.onWarning.call(null,generateError(s,o))}var zr={YAML:function handleYamlDirective(s,o,i){var a,u,_;null!==s.version&&throwError(s,"duplication of %YAML directive"),1!==i.length&&throwError(s,"YAML directive accepts exactly one argument"),null===(a=/^([0-9]+)\.([0-9]+)$/.exec(i[0]))&&throwError(s,"ill-formed argument of the YAML directive"),u=parseInt(a[1],10),_=parseInt(a[2],10),1!==u&&throwError(s,"unacceptable YAML version of the document"),s.version=i[0],s.checkLineBreaks=_<2,1!==_&&2!==_&&throwWarning(s,"unsupported YAML version of the document")},TAG:function handleTagDirective(s,o,i){var a,u;2!==i.length&&throwError(s,"TAG directive accepts exactly two arguments"),a=i[0],u=i[1],Br.test(a)||throwError(s,"ill-formed tag handle (first argument) of the TAG directive"),Rr.call(s.tagMap,a)&&throwError(s,'there is a previously declared suffix for "'+a+'" tag handle'),$r.test(u)||throwError(s,"ill-formed tag prefix (second argument) of the TAG directive");try{u=decodeURIComponent(u)}catch(o){throwError(s,"tag prefix is malformed: "+u)}s.tagMap[a]=u}};function captureSegment(s,o,i,a){var u,_,w,x;if(o<i){if(x=s.input.slice(o,i),a)for(u=0,_=x.length;u<_;u+=1)9===(w=x.charCodeAt(u))||32<=w&&w<=1114111||throwError(s,"expected valid JSON character");else Dr.test(x)&&throwError(s,"the stream contains non-printable characters");s.result+=x}}function mergeMappings(s,o,i,a){var u,_,w,x;for(er.isObject(i)||throwError(s,"cannot merge mappings; the provided source object is unacceptable"),w=0,x=(u=Object.keys(i)).length;w<x;w+=1)_=u[w],Rr.call(o,_)||(setProperty(o,_,i[_]),a[_]=!0)}function storeMappingPair(s,o,i,a,u,_,w,x,C){var j,L;if(Array.isArray(u))for(j=0,L=(u=Array.prototype.slice.call(u)).length;j<L;j+=1)Array.isArray(u[j])&&throwError(s,"nested arrays are not supported inside keys"),"object"==typeof u&&"[object Object]"===_class(u[j])&&(u[j]="[object Object]");if("object"==typeof u&&"[object Object]"===_class(u)&&(u="[object Object]"),u=String(u),null===o&&(o={}),"tag:yaml.org,2002:merge"===a)if(Array.isArray(_))for(j=0,L=_.length;j<L;j+=1)mergeMappings(s,o,_[j],i);else mergeMappings(s,o,_,i);else s.json||Rr.call(i,u)||!Rr.call(o,u)||(s.line=w||s.line,s.lineStart=x||s.lineStart,s.position=C||s.position,throwError(s,"duplicated mapping key")),setProperty(o,u,_),delete i[u];return o}function readLineBreak(s){var o;10===(o=s.input.charCodeAt(s.position))?s.position++:13===o?(s.position++,10===s.input.charCodeAt(s.position)&&s.position++):throwError(s,"a line break is expected"),s.line+=1,s.lineStart=s.position,s.firstTabInLine=-1}function skipSeparationSpace(s,o,i){for(var a=0,u=s.input.charCodeAt(s.position);0!==u;){for(;is_WHITE_SPACE(u);)9===u&&-1===s.firstTabInLine&&(s.firstTabInLine=s.position),u=s.input.charCodeAt(++s.position);if(o&&35===u)do{u=s.input.charCodeAt(++s.position)}while(10!==u&&13!==u&&0!==u);if(!is_EOL(u))break;for(readLineBreak(s),u=s.input.charCodeAt(s.position),a++,s.lineIndent=0;32===u;)s.lineIndent++,u=s.input.charCodeAt(++s.position)}return-1!==i&&0!==a&&s.lineIndent<i&&throwWarning(s,"deficient indentation"),a}function testDocumentSeparator(s){var o,i=s.position;return!(45!==(o=s.input.charCodeAt(i))&&46!==o||o!==s.input.charCodeAt(i+1)||o!==s.input.charCodeAt(i+2)||(i+=3,0!==(o=s.input.charCodeAt(i))&&!is_WS_OR_EOL(o)))}function writeFoldedLines(s,o){1===o?s.result+=" ":o>1&&(s.result+=er.repeat("\n",o-1))}function readBlockSequence(s,o){var i,a,u=s.tag,_=s.anchor,w=[],x=!1;if(-1!==s.firstTabInLine)return!1;for(null!==s.anchor&&(s.anchorMap[s.anchor]=w),a=s.input.charCodeAt(s.position);0!==a&&(-1!==s.firstTabInLine&&(s.position=s.firstTabInLine,throwError(s,"tab characters must not be used in indentation")),45===a)&&is_WS_OR_EOL(s.input.charCodeAt(s.position+1));)if(x=!0,s.position++,skipSeparationSpace(s,!0,-1)&&s.lineIndent<=o)w.push(null),a=s.input.charCodeAt(s.position);else if(i=s.line,composeNode(s,o,3,!1,!0),w.push(s.result),skipSeparationSpace(s,!0,-1),a=s.input.charCodeAt(s.position),(s.line===i||s.lineIndent>o)&&0!==a)throwError(s,"bad indentation of a sequence entry");else if(s.lineIndent<o)break;return!!x&&(s.tag=u,s.anchor=_,s.kind="sequence",s.result=w,!0)}function readTagProperty(s){var o,i,a,u,_=!1,w=!1;if(33!==(u=s.input.charCodeAt(s.position)))return!1;if(null!==s.tag&&throwError(s,"duplication of a tag property"),60===(u=s.input.charCodeAt(++s.position))?(_=!0,u=s.input.charCodeAt(++s.position)):33===u?(w=!0,i="!!",u=s.input.charCodeAt(++s.position)):i="!",o=s.position,_){do{u=s.input.charCodeAt(++s.position)}while(0!==u&&62!==u);s.position<s.length?(a=s.input.slice(o,s.position),u=s.input.charCodeAt(++s.position)):throwError(s,"unexpected end of the stream within a verbatim tag")}else{for(;0!==u&&!is_WS_OR_EOL(u);)33===u&&(w?throwError(s,"tag suffix cannot contain exclamation marks"):(i=s.input.slice(o-1,s.position+1),Br.test(i)||throwError(s,"named tag handle cannot contain such characters"),w=!0,o=s.position+1)),u=s.input.charCodeAt(++s.position);a=s.input.slice(o,s.position),Fr.test(a)&&throwError(s,"tag suffix cannot contain flow indicator characters")}a&&!$r.test(a)&&throwError(s,"tag name cannot contain such characters: "+a);try{a=decodeURIComponent(a)}catch(o){throwError(s,"tag name is malformed: "+a)}return _?s.tag=a:Rr.call(s.tagMap,i)?s.tag=s.tagMap[i]+a:"!"===i?s.tag="!"+a:"!!"===i?s.tag="tag:yaml.org,2002:"+a:throwError(s,'undeclared tag handle "'+i+'"'),!0}function readAnchorProperty(s){var o,i;if(38!==(i=s.input.charCodeAt(s.position)))return!1;for(null!==s.anchor&&throwError(s,"duplication of an anchor property"),i=s.input.charCodeAt(++s.position),o=s.position;0!==i&&!is_WS_OR_EOL(i)&&!is_FLOW_INDICATOR(i);)i=s.input.charCodeAt(++s.position);return s.position===o&&throwError(s,"name of an anchor node must contain at least one character"),s.anchor=s.input.slice(o,s.position),!0}function composeNode(s,o,i,a,u){var _,w,x,C,j,L,B,$,U,V=1,z=!1,Y=!1;if(null!==s.listener&&s.listener("open",s),s.tag=null,s.anchor=null,s.kind=null,s.result=null,_=w=x=4===i||3===i,a&&skipSeparationSpace(s,!0,-1)&&(z=!0,s.lineIndent>o?V=1:s.lineIndent===o?V=0:s.lineIndent<o&&(V=-1)),1===V)for(;readTagProperty(s)||readAnchorProperty(s);)skipSeparationSpace(s,!0,-1)?(z=!0,x=_,s.lineIndent>o?V=1:s.lineIndent===o?V=0:s.lineIndent<o&&(V=-1)):x=!1;if(x&&(x=z||u),1!==V&&4!==i||($=1===i||2===i?o:o+1,U=s.position-s.lineStart,1===V?x&&(readBlockSequence(s,U)||function readBlockMapping(s,o,i){var a,u,_,w,x,C,j,L=s.tag,B=s.anchor,$={},U=Object.create(null),V=null,z=null,Y=null,Z=!1,ee=!1;if(-1!==s.firstTabInLine)return!1;for(null!==s.anchor&&(s.anchorMap[s.anchor]=$),j=s.input.charCodeAt(s.position);0!==j;){if(Z||-1===s.firstTabInLine||(s.position=s.firstTabInLine,throwError(s,"tab characters must not be used in indentation")),a=s.input.charCodeAt(s.position+1),_=s.line,63!==j&&58!==j||!is_WS_OR_EOL(a)){if(w=s.line,x=s.lineStart,C=s.position,!composeNode(s,i,2,!1,!0))break;if(s.line===_){for(j=s.input.charCodeAt(s.position);is_WHITE_SPACE(j);)j=s.input.charCodeAt(++s.position);if(58===j)is_WS_OR_EOL(j=s.input.charCodeAt(++s.position))||throwError(s,"a whitespace character is expected after the key-value separator within a block mapping"),Z&&(storeMappingPair(s,$,U,V,z,null,w,x,C),V=z=Y=null),ee=!0,Z=!1,u=!1,V=s.tag,z=s.result;else{if(!ee)return s.tag=L,s.anchor=B,!0;throwError(s,"can not read an implicit mapping pair; a colon is missed")}}else{if(!ee)return s.tag=L,s.anchor=B,!0;throwError(s,"can not read a block mapping entry; a multiline key may not be an implicit key")}}else 63===j?(Z&&(storeMappingPair(s,$,U,V,z,null,w,x,C),V=z=Y=null),ee=!0,Z=!0,u=!0):Z?(Z=!1,u=!0):throwError(s,"incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line"),s.position+=1,j=a;if((s.line===_||s.lineIndent>o)&&(Z&&(w=s.line,x=s.lineStart,C=s.position),composeNode(s,o,4,!0,u)&&(Z?z=s.result:Y=s.result),Z||(storeMappingPair(s,$,U,V,z,Y,w,x,C),V=z=Y=null),skipSeparationSpace(s,!0,-1),j=s.input.charCodeAt(s.position)),(s.line===_||s.lineIndent>o)&&0!==j)throwError(s,"bad indentation of a mapping entry");else if(s.lineIndent<o)break}return Z&&storeMappingPair(s,$,U,V,z,null,w,x,C),ee&&(s.tag=L,s.anchor=B,s.kind="mapping",s.result=$),ee}(s,U,$))||function readFlowCollection(s,o){var i,a,u,_,w,x,C,j,L,B,$,U,V=!0,z=s.tag,Y=s.anchor,Z=Object.create(null);if(91===(U=s.input.charCodeAt(s.position)))w=93,j=!1,_=[];else{if(123!==U)return!1;w=125,j=!0,_={}}for(null!==s.anchor&&(s.anchorMap[s.anchor]=_),U=s.input.charCodeAt(++s.position);0!==U;){if(skipSeparationSpace(s,!0,o),(U=s.input.charCodeAt(s.position))===w)return s.position++,s.tag=z,s.anchor=Y,s.kind=j?"mapping":"sequence",s.result=_,!0;V?44===U&&throwError(s,"expected the node content, but found ','"):throwError(s,"missed comma between flow collection entries"),$=null,x=C=!1,63===U&&is_WS_OR_EOL(s.input.charCodeAt(s.position+1))&&(x=C=!0,s.position++,skipSeparationSpace(s,!0,o)),i=s.line,a=s.lineStart,u=s.position,composeNode(s,o,1,!1,!0),B=s.tag,L=s.result,skipSeparationSpace(s,!0,o),U=s.input.charCodeAt(s.position),!C&&s.line!==i||58!==U||(x=!0,U=s.input.charCodeAt(++s.position),skipSeparationSpace(s,!0,o),composeNode(s,o,1,!1,!0),$=s.result),j?storeMappingPair(s,_,Z,B,L,$,i,a,u):x?_.push(storeMappingPair(s,null,Z,B,L,$,i,a,u)):_.push(L),skipSeparationSpace(s,!0,o),44===(U=s.input.charCodeAt(s.position))?(V=!0,U=s.input.charCodeAt(++s.position)):V=!1}throwError(s,"unexpected end of the stream within a flow collection")}(s,$)?Y=!0:(w&&function readBlockScalar(s,o){var i,a,u,_,w,x=1,C=!1,j=!1,L=o,B=0,$=!1;if(124===(_=s.input.charCodeAt(s.position)))a=!1;else{if(62!==_)return!1;a=!0}for(s.kind="scalar",s.result="";0!==_;)if(43===(_=s.input.charCodeAt(++s.position))||45===_)1===x?x=43===_?3:2:throwError(s,"repeat of a chomping mode identifier");else{if(!((u=48<=(w=_)&&w<=57?w-48:-1)>=0))break;0===u?throwError(s,"bad explicit indentation width of a block scalar; it cannot be less than one"):j?throwError(s,"repeat of an indentation width identifier"):(L=o+u-1,j=!0)}if(is_WHITE_SPACE(_)){do{_=s.input.charCodeAt(++s.position)}while(is_WHITE_SPACE(_));if(35===_)do{_=s.input.charCodeAt(++s.position)}while(!is_EOL(_)&&0!==_)}for(;0!==_;){for(readLineBreak(s),s.lineIndent=0,_=s.input.charCodeAt(s.position);(!j||s.lineIndent<L)&&32===_;)s.lineIndent++,_=s.input.charCodeAt(++s.position);if(!j&&s.lineIndent>L&&(L=s.lineIndent),is_EOL(_))B++;else{if(s.lineIndent<L){3===x?s.result+=er.repeat("\n",C?1+B:B):1===x&&C&&(s.result+="\n");break}for(a?is_WHITE_SPACE(_)?($=!0,s.result+=er.repeat("\n",C?1+B:B)):$?($=!1,s.result+=er.repeat("\n",B+1)):0===B?C&&(s.result+=" "):s.result+=er.repeat("\n",B):s.result+=er.repeat("\n",C?1+B:B),C=!0,j=!0,B=0,i=s.position;!is_EOL(_)&&0!==_;)_=s.input.charCodeAt(++s.position);captureSegment(s,i,s.position,!1)}}return!0}(s,$)||function readSingleQuotedScalar(s,o){var i,a,u;if(39!==(i=s.input.charCodeAt(s.position)))return!1;for(s.kind="scalar",s.result="",s.position++,a=u=s.position;0!==(i=s.input.charCodeAt(s.position));)if(39===i){if(captureSegment(s,a,s.position,!0),39!==(i=s.input.charCodeAt(++s.position)))return!0;a=s.position,s.position++,u=s.position}else is_EOL(i)?(captureSegment(s,a,u,!0),writeFoldedLines(s,skipSeparationSpace(s,!1,o)),a=u=s.position):s.position===s.lineStart&&testDocumentSeparator(s)?throwError(s,"unexpected end of the document within a single quoted scalar"):(s.position++,u=s.position);throwError(s,"unexpected end of the stream within a single quoted scalar")}(s,$)||function readDoubleQuotedScalar(s,o){var i,a,u,_,w,x,C;if(34!==(x=s.input.charCodeAt(s.position)))return!1;for(s.kind="scalar",s.result="",s.position++,i=a=s.position;0!==(x=s.input.charCodeAt(s.position));){if(34===x)return captureSegment(s,i,s.position,!0),s.position++,!0;if(92===x){if(captureSegment(s,i,s.position,!0),is_EOL(x=s.input.charCodeAt(++s.position)))skipSeparationSpace(s,!1,o);else if(x<256&&qr[x])s.result+=Ur[x],s.position++;else if((w=120===(C=x)?2:117===C?4:85===C?8:0)>0){for(u=w,_=0;u>0;u--)(w=fromHexCode(x=s.input.charCodeAt(++s.position)))>=0?_=(_<<4)+w:throwError(s,"expected hexadecimal character");s.result+=charFromCodepoint(_),s.position++}else throwError(s,"unknown escape sequence");i=a=s.position}else is_EOL(x)?(captureSegment(s,i,a,!0),writeFoldedLines(s,skipSeparationSpace(s,!1,o)),i=a=s.position):s.position===s.lineStart&&testDocumentSeparator(s)?throwError(s,"unexpected end of the document within a double quoted scalar"):(s.position++,a=s.position)}throwError(s,"unexpected end of the stream within a double quoted scalar")}(s,$)?Y=!0:!function readAlias(s){var o,i,a;if(42!==(a=s.input.charCodeAt(s.position)))return!1;for(a=s.input.charCodeAt(++s.position),o=s.position;0!==a&&!is_WS_OR_EOL(a)&&!is_FLOW_INDICATOR(a);)a=s.input.charCodeAt(++s.position);return s.position===o&&throwError(s,"name of an alias node must contain at least one character"),i=s.input.slice(o,s.position),Rr.call(s.anchorMap,i)||throwError(s,'unidentified alias "'+i+'"'),s.result=s.anchorMap[i],skipSeparationSpace(s,!0,-1),!0}(s)?function readPlainScalar(s,o,i){var a,u,_,w,x,C,j,L,B=s.kind,$=s.result;if(is_WS_OR_EOL(L=s.input.charCodeAt(s.position))||is_FLOW_INDICATOR(L)||35===L||38===L||42===L||33===L||124===L||62===L||39===L||34===L||37===L||64===L||96===L)return!1;if((63===L||45===L)&&(is_WS_OR_EOL(a=s.input.charCodeAt(s.position+1))||i&&is_FLOW_INDICATOR(a)))return!1;for(s.kind="scalar",s.result="",u=_=s.position,w=!1;0!==L;){if(58===L){if(is_WS_OR_EOL(a=s.input.charCodeAt(s.position+1))||i&&is_FLOW_INDICATOR(a))break}else if(35===L){if(is_WS_OR_EOL(s.input.charCodeAt(s.position-1)))break}else{if(s.position===s.lineStart&&testDocumentSeparator(s)||i&&is_FLOW_INDICATOR(L))break;if(is_EOL(L)){if(x=s.line,C=s.lineStart,j=s.lineIndent,skipSeparationSpace(s,!1,-1),s.lineIndent>=o){w=!0,L=s.input.charCodeAt(s.position);continue}s.position=_,s.line=x,s.lineStart=C,s.lineIndent=j;break}}w&&(captureSegment(s,u,_,!1),writeFoldedLines(s,s.line-x),u=_=s.position,w=!1),is_WHITE_SPACE(L)||(_=s.position+1),L=s.input.charCodeAt(++s.position)}return captureSegment(s,u,_,!1),!!s.result||(s.kind=B,s.result=$,!1)}(s,$,1===i)&&(Y=!0,null===s.tag&&(s.tag="?")):(Y=!0,null===s.tag&&null===s.anchor||throwError(s,"alias node should not have any properties")),null!==s.anchor&&(s.anchorMap[s.anchor]=s.result)):0===V&&(Y=x&&readBlockSequence(s,U))),null===s.tag)null!==s.anchor&&(s.anchorMap[s.anchor]=s.result);else if("?"===s.tag){for(null!==s.result&&"scalar"!==s.kind&&throwError(s,'unacceptable node kind for !<?> tag; it should be "scalar", not "'+s.kind+'"'),C=0,j=s.implicitTypes.length;C<j;C+=1)if((B=s.implicitTypes[C]).resolve(s.result)){s.result=B.construct(s.result),s.tag=B.tag,null!==s.anchor&&(s.anchorMap[s.anchor]=s.result);break}}else if("!"!==s.tag){if(Rr.call(s.typeMap[s.kind||"fallback"],s.tag))B=s.typeMap[s.kind||"fallback"][s.tag];else for(B=null,C=0,j=(L=s.typeMap.multi[s.kind||"fallback"]).length;C<j;C+=1)if(s.tag.slice(0,L[C].tag.length)===L[C].tag){B=L[C];break}B||throwError(s,"unknown tag !<"+s.tag+">"),null!==s.result&&B.kind!==s.kind&&throwError(s,"unacceptable node kind for !<"+s.tag+'> tag; it should be "'+B.kind+'", not "'+s.kind+'"'),B.resolve(s.result,s.tag)?(s.result=B.construct(s.result,s.tag),null!==s.anchor&&(s.anchorMap[s.anchor]=s.result)):throwError(s,"cannot resolve a node with !<"+s.tag+"> explicit tag")}return null!==s.listener&&s.listener("close",s),null!==s.tag||null!==s.anchor||Y}function readDocument(s){var o,i,a,u,_=s.position,w=!1;for(s.version=null,s.checkLineBreaks=s.legacy,s.tagMap=Object.create(null),s.anchorMap=Object.create(null);0!==(u=s.input.charCodeAt(s.position))&&(skipSeparationSpace(s,!0,-1),u=s.input.charCodeAt(s.position),!(s.lineIndent>0||37!==u));){for(w=!0,u=s.input.charCodeAt(++s.position),o=s.position;0!==u&&!is_WS_OR_EOL(u);)u=s.input.charCodeAt(++s.position);for(a=[],(i=s.input.slice(o,s.position)).length<1&&throwError(s,"directive name must not be less than one character in length");0!==u;){for(;is_WHITE_SPACE(u);)u=s.input.charCodeAt(++s.position);if(35===u){do{u=s.input.charCodeAt(++s.position)}while(0!==u&&!is_EOL(u));break}if(is_EOL(u))break;for(o=s.position;0!==u&&!is_WS_OR_EOL(u);)u=s.input.charCodeAt(++s.position);a.push(s.input.slice(o,s.position))}0!==u&&readLineBreak(s),Rr.call(zr,i)?zr[i](s,i,a):throwWarning(s,'unknown document directive "'+i+'"')}skipSeparationSpace(s,!0,-1),0===s.lineIndent&&45===s.input.charCodeAt(s.position)&&45===s.input.charCodeAt(s.position+1)&&45===s.input.charCodeAt(s.position+2)?(s.position+=3,skipSeparationSpace(s,!0,-1)):w&&throwError(s,"directives end mark is expected"),composeNode(s,s.lineIndent-1,4,!1,!0),skipSeparationSpace(s,!0,-1),s.checkLineBreaks&&Lr.test(s.input.slice(_,s.position))&&throwWarning(s,"non-ASCII line breaks are interpreted as content"),s.documents.push(s.result),s.position===s.lineStart&&testDocumentSeparator(s)?46===s.input.charCodeAt(s.position)&&(s.position+=3,skipSeparationSpace(s,!0,-1)):s.position<s.length-1&&throwError(s,"end of the stream or a document separator is expected")}function loadDocuments(s,o){o=o||{},0!==(s=String(s)).length&&(10!==s.charCodeAt(s.length-1)&&13!==s.charCodeAt(s.length-1)&&(s+="\n"),65279===s.charCodeAt(0)&&(s=s.slice(1)));var i=new State$1(s,o),a=s.indexOf("\0");for(-1!==a&&(i.position=a,throwError(i,"null byte is not allowed in input")),i.input+="\0";32===i.input.charCodeAt(i.position);)i.lineIndent+=1,i.position+=1;for(;i.position<i.length-1;)readDocument(i);return i.documents}var Wr={loadAll:function loadAll$1(s,o,i){null!==o&&"object"==typeof o&&void 0===i&&(i=o,o=null);var a=loadDocuments(s,i);if("function"!=typeof o)return a;for(var u=0,_=a.length;u<_;u+=1)o(a[u])},load:function load$1(s,o){var i=loadDocuments(s,o);if(0!==i.length){if(1===i.length)return i[0];throw new tr("expected a single document in the stream, but found more")}}},Jr=Object.prototype.toString,Hr=Object.prototype.hasOwnProperty,Kr=65279,Gr={0:"\\0",7:"\\a",8:"\\b",9:"\\t",10:"\\n",11:"\\v",12:"\\f",13:"\\r",27:"\\e",34:'\\"',92:"\\\\",133:"\\N",160:"\\_",8232:"\\L",8233:"\\P"},Yr=["y","Y","yes","Yes","YES","on","On","ON","n","N","no","No","NO","off","Off","OFF"],Xr=/^[-+]?[0-9_]+(?::[0-9_]+)+(?:\.[0-9_]*)?$/;function encodeHex(s){var o,i,a;if(o=s.toString(16).toUpperCase(),s<=255)i="x",a=2;else if(s<=65535)i="u",a=4;else{if(!(s<=4294967295))throw new tr("code point within a string may not be greater than 0xFFFFFFFF");i="U",a=8}return"\\"+i+er.repeat("0",a-o.length)+o}function State(s){this.schema=s.schema||Mr,this.indent=Math.max(1,s.indent||2),this.noArrayIndent=s.noArrayIndent||!1,this.skipInvalid=s.skipInvalid||!1,this.flowLevel=er.isNothing(s.flowLevel)?-1:s.flowLevel,this.styleMap=function compileStyleMap(s,o){var i,a,u,_,w,x,C;if(null===o)return{};for(i={},u=0,_=(a=Object.keys(o)).length;u<_;u+=1)w=a[u],x=String(o[w]),"!!"===w.slice(0,2)&&(w="tag:yaml.org,2002:"+w.slice(2)),(C=s.compiledTypeMap.fallback[w])&&Hr.call(C.styleAliases,x)&&(x=C.styleAliases[x]),i[w]=x;return i}(this.schema,s.styles||null),this.sortKeys=s.sortKeys||!1,this.lineWidth=s.lineWidth||80,this.noRefs=s.noRefs||!1,this.noCompatMode=s.noCompatMode||!1,this.condenseFlow=s.condenseFlow||!1,this.quotingType='"'===s.quotingType?2:1,this.forceQuotes=s.forceQuotes||!1,this.replacer="function"==typeof s.replacer?s.replacer:null,this.implicitTypes=this.schema.compiledImplicit,this.explicitTypes=this.schema.compiledExplicit,this.tag=null,this.result="",this.duplicates=[],this.usedDuplicates=null}function indentString(s,o){for(var i,a=er.repeat(" ",o),u=0,_=-1,w="",x=s.length;u<x;)-1===(_=s.indexOf("\n",u))?(i=s.slice(u),u=x):(i=s.slice(u,_+1),u=_+1),i.length&&"\n"!==i&&(w+=a),w+=i;return w}function generateNextLine(s,o){return"\n"+er.repeat(" ",s.indent*o)}function isWhitespace(s){return 32===s||9===s}function isPrintable(s){return 32<=s&&s<=126||161<=s&&s<=55295&&8232!==s&&8233!==s||57344<=s&&s<=65533&&s!==Kr||65536<=s&&s<=1114111}function isNsCharOrWhitespace(s){return isPrintable(s)&&s!==Kr&&13!==s&&10!==s}function isPlainSafe(s,o,i){var a=isNsCharOrWhitespace(s),u=a&&!isWhitespace(s);return(i?a:a&&44!==s&&91!==s&&93!==s&&123!==s&&125!==s)&&35!==s&&!(58===o&&!u)||isNsCharOrWhitespace(o)&&!isWhitespace(o)&&35===s||58===o&&u}function codePointAt(s,o){var i,a=s.charCodeAt(o);return a>=55296&&a<=56319&&o+1<s.length&&(i=s.charCodeAt(o+1))>=56320&&i<=57343?1024*(a-55296)+i-56320+65536:a}function needIndentIndicator(s){return/^\n* /.test(s)}function chooseScalarStyle(s,o,i,a,u,_,w,x){var C,j=0,L=null,B=!1,$=!1,U=-1!==a,V=-1,z=function isPlainSafeFirst(s){return isPrintable(s)&&s!==Kr&&!isWhitespace(s)&&45!==s&&63!==s&&58!==s&&44!==s&&91!==s&&93!==s&&123!==s&&125!==s&&35!==s&&38!==s&&42!==s&&33!==s&&124!==s&&61!==s&&62!==s&&39!==s&&34!==s&&37!==s&&64!==s&&96!==s}(codePointAt(s,0))&&function isPlainSafeLast(s){return!isWhitespace(s)&&58!==s}(codePointAt(s,s.length-1));if(o||w)for(C=0;C<s.length;j>=65536?C+=2:C++){if(!isPrintable(j=codePointAt(s,C)))return 5;z=z&&isPlainSafe(j,L,x),L=j}else{for(C=0;C<s.length;j>=65536?C+=2:C++){if(10===(j=codePointAt(s,C)))B=!0,U&&($=$||C-V-1>a&&" "!==s[V+1],V=C);else if(!isPrintable(j))return 5;z=z&&isPlainSafe(j,L,x),L=j}$=$||U&&C-V-1>a&&" "!==s[V+1]}return B||$?i>9&&needIndentIndicator(s)?5:w?2===_?5:2:$?4:3:!z||w||u(s)?2===_?5:2:1}function writeScalar(s,o,i,a,u){s.dump=function(){if(0===o.length)return 2===s.quotingType?'""':"''";if(!s.noCompatMode&&(-1!==Yr.indexOf(o)||Xr.test(o)))return 2===s.quotingType?'"'+o+'"':"'"+o+"'";var _=s.indent*Math.max(1,i),w=-1===s.lineWidth?-1:Math.max(Math.min(s.lineWidth,40),s.lineWidth-_),x=a||s.flowLevel>-1&&i>=s.flowLevel;switch(chooseScalarStyle(o,x,s.indent,w,(function testAmbiguity(o){return function testImplicitResolving(s,o){var i,a;for(i=0,a=s.implicitTypes.length;i<a;i+=1)if(s.implicitTypes[i].resolve(o))return!0;return!1}(s,o)}),s.quotingType,s.forceQuotes&&!a,u)){case 1:return o;case 2:return"'"+o.replace(/'/g,"''")+"'";case 3:return"|"+blockHeader(o,s.indent)+dropEndingNewline(indentString(o,_));case 4:return">"+blockHeader(o,s.indent)+dropEndingNewline(indentString(function foldString(s,o){var i,a,u=/(\n+)([^\n]*)/g,_=(x=s.indexOf("\n"),x=-1!==x?x:s.length,u.lastIndex=x,foldLine(s.slice(0,x),o)),w="\n"===s[0]||" "===s[0];var x;for(;a=u.exec(s);){var C=a[1],j=a[2];i=" "===j[0],_+=C+(w||i||""===j?"":"\n")+foldLine(j,o),w=i}return _}(o,w),_));case 5:return'"'+function escapeString(s){for(var o,i="",a=0,u=0;u<s.length;a>=65536?u+=2:u++)a=codePointAt(s,u),!(o=Gr[a])&&isPrintable(a)?(i+=s[u],a>=65536&&(i+=s[u+1])):i+=o||encodeHex(a);return i}(o)+'"';default:throw new tr("impossible error: invalid scalar style")}}()}function blockHeader(s,o){var i=needIndentIndicator(s)?String(o):"",a="\n"===s[s.length-1];return i+(a&&("\n"===s[s.length-2]||"\n"===s)?"+":a?"":"-")+"\n"}function dropEndingNewline(s){return"\n"===s[s.length-1]?s.slice(0,-1):s}function foldLine(s,o){if(""===s||" "===s[0])return s;for(var i,a,u=/ [^ ]/g,_=0,w=0,x=0,C="";i=u.exec(s);)(x=i.index)-_>o&&(a=w>_?w:x,C+="\n"+s.slice(_,a),_=a+1),w=x;return C+="\n",s.length-_>o&&w>_?C+=s.slice(_,w)+"\n"+s.slice(w+1):C+=s.slice(_),C.slice(1)}function writeBlockSequence(s,o,i,a){var u,_,w,x="",C=s.tag;for(u=0,_=i.length;u<_;u+=1)w=i[u],s.replacer&&(w=s.replacer.call(i,String(u),w)),(writeNode(s,o+1,w,!0,!0,!1,!0)||void 0===w&&writeNode(s,o+1,null,!0,!0,!1,!0))&&(a&&""===x||(x+=generateNextLine(s,o)),s.dump&&10===s.dump.charCodeAt(0)?x+="-":x+="- ",x+=s.dump);s.tag=C,s.dump=x||"[]"}function detectType(s,o,i){var a,u,_,w,x,C;for(_=0,w=(u=i?s.explicitTypes:s.implicitTypes).length;_<w;_+=1)if(((x=u[_]).instanceOf||x.predicate)&&(!x.instanceOf||"object"==typeof o&&o instanceof x.instanceOf)&&(!x.predicate||x.predicate(o))){if(i?x.multi&&x.representName?s.tag=x.representName(o):s.tag=x.tag:s.tag="?",x.represent){if(C=s.styleMap[x.tag]||x.defaultStyle,"[object Function]"===Jr.call(x.represent))a=x.represent(o,C);else{if(!Hr.call(x.represent,C))throw new tr("!<"+x.tag+'> tag resolver accepts not "'+C+'" style');a=x.represent[C](o,C)}s.dump=a}return!0}return!1}function writeNode(s,o,i,a,u,_,w){s.tag=null,s.dump=i,detectType(s,i,!1)||detectType(s,i,!0);var x,C=Jr.call(s.dump),j=a;a&&(a=s.flowLevel<0||s.flowLevel>o);var L,B,$="[object Object]"===C||"[object Array]"===C;if($&&(B=-1!==(L=s.duplicates.indexOf(i))),(null!==s.tag&&"?"!==s.tag||B||2!==s.indent&&o>0)&&(u=!1),B&&s.usedDuplicates[L])s.dump="*ref_"+L;else{if($&&B&&!s.usedDuplicates[L]&&(s.usedDuplicates[L]=!0),"[object Object]"===C)a&&0!==Object.keys(s.dump).length?(!function writeBlockMapping(s,o,i,a){var u,_,w,x,C,j,L="",B=s.tag,$=Object.keys(i);if(!0===s.sortKeys)$.sort();else if("function"==typeof s.sortKeys)$.sort(s.sortKeys);else if(s.sortKeys)throw new tr("sortKeys must be a boolean or a function");for(u=0,_=$.length;u<_;u+=1)j="",a&&""===L||(j+=generateNextLine(s,o)),x=i[w=$[u]],s.replacer&&(x=s.replacer.call(i,w,x)),writeNode(s,o+1,w,!0,!0,!0)&&((C=null!==s.tag&&"?"!==s.tag||s.dump&&s.dump.length>1024)&&(s.dump&&10===s.dump.charCodeAt(0)?j+="?":j+="? "),j+=s.dump,C&&(j+=generateNextLine(s,o)),writeNode(s,o+1,x,!0,C)&&(s.dump&&10===s.dump.charCodeAt(0)?j+=":":j+=": ",L+=j+=s.dump));s.tag=B,s.dump=L||"{}"}(s,o,s.dump,u),B&&(s.dump="&ref_"+L+s.dump)):(!function writeFlowMapping(s,o,i){var a,u,_,w,x,C="",j=s.tag,L=Object.keys(i);for(a=0,u=L.length;a<u;a+=1)x="",""!==C&&(x+=", "),s.condenseFlow&&(x+='"'),w=i[_=L[a]],s.replacer&&(w=s.replacer.call(i,_,w)),writeNode(s,o,_,!1,!1)&&(s.dump.length>1024&&(x+="? "),x+=s.dump+(s.condenseFlow?'"':"")+":"+(s.condenseFlow?"":" "),writeNode(s,o,w,!1,!1)&&(C+=x+=s.dump));s.tag=j,s.dump="{"+C+"}"}(s,o,s.dump),B&&(s.dump="&ref_"+L+" "+s.dump));else if("[object Array]"===C)a&&0!==s.dump.length?(s.noArrayIndent&&!w&&o>0?writeBlockSequence(s,o-1,s.dump,u):writeBlockSequence(s,o,s.dump,u),B&&(s.dump="&ref_"+L+s.dump)):(!function writeFlowSequence(s,o,i){var a,u,_,w="",x=s.tag;for(a=0,u=i.length;a<u;a+=1)_=i[a],s.replacer&&(_=s.replacer.call(i,String(a),_)),(writeNode(s,o,_,!1,!1)||void 0===_&&writeNode(s,o,null,!1,!1))&&(""!==w&&(w+=","+(s.condenseFlow?"":" ")),w+=s.dump);s.tag=x,s.dump="["+w+"]"}(s,o,s.dump),B&&(s.dump="&ref_"+L+" "+s.dump));else{if("[object String]"!==C){if("[object Undefined]"===C)return!1;if(s.skipInvalid)return!1;throw new tr("unacceptable kind of an object to dump "+C)}"?"!==s.tag&&writeScalar(s,s.dump,o,_,j)}null!==s.tag&&"?"!==s.tag&&(x=encodeURI("!"===s.tag[0]?s.tag.slice(1):s.tag).replace(/!/g,"%21"),x="!"===s.tag[0]?"!"+x:"tag:yaml.org,2002:"===x.slice(0,18)?"!!"+x.slice(18):"!<"+x+">",s.dump=x+" "+s.dump)}return!0}function getDuplicateReferences(s,o){var i,a,u=[],_=[];for(inspectNode(s,u,_),i=0,a=_.length;i<a;i+=1)o.duplicates.push(u[_[i]]);o.usedDuplicates=new Array(a)}function inspectNode(s,o,i){var a,u,_;if(null!==s&&"object"==typeof s)if(-1!==(u=o.indexOf(s)))-1===i.indexOf(u)&&i.push(u);else if(o.push(s),Array.isArray(s))for(u=0,_=s.length;u<_;u+=1)inspectNode(s[u],o,i);else for(u=0,_=(a=Object.keys(s)).length;u<_;u+=1)inspectNode(s[a[u]],o,i)}var Qr=function dump$1(s,o){var i=new State(o=o||{});i.noRefs||getDuplicateReferences(s,i);var a=s;return i.replacer&&(a=i.replacer.call({"":a},"",a)),writeNode(i,0,a,!0,!0)?i.dump+"\n":""};function renamed(s,o){return function(){throw new Error("Function yaml."+s+" is removed in js-yaml 4. Use yaml."+o+" instead, which is now safe by default.")}}var Zr=ir,en=ar,tn=pr,rn=br,nn=Sr,sn=Mr,on=Wr.load,an=Wr.loadAll,cn={dump:Qr}.dump,ln=tr,un={binary:Or,float:vr,map:ur,null:dr,pairs:Ir,set:Nr,timestamp:wr,bool:fr,int:mr,merge:xr,omap:jr,seq:lr,str:cr},pn=renamed("safeLoad","load"),hn=renamed("safeLoadAll","loadAll"),dn=renamed("safeDump","dump"),fn={Type:Zr,Schema:en,FAILSAFE_SCHEMA:tn,JSON_SCHEMA:rn,CORE_SCHEMA:nn,DEFAULT_SCHEMA:sn,load:on,loadAll:an,dump:cn,YAMLException:ln,types:un,safeLoad:pn,safeLoadAll:hn,safeDump:dn};const mn="configs_update",gn="configs_toggle";function update(s,o){return{type:mn,payload:{[s]:o}}}function toggle(s){return{type:gn,payload:s}}const actions_loaded=()=>()=>{},downloadConfig=s=>o=>{const{fn:{fetch:i}}=o;return i(s)},getConfigByUrl=(s,o)=>i=>{const{specActions:a,configsActions:u}=i;if(s)return u.downloadConfig(s).then(next,next);function next(u){u instanceof Error||u.status>=400?(a.updateLoadingStatus("failedConfig"),a.updateLoadingStatus("failedConfig"),a.updateUrl(""),console.error(u.statusText+" "+s.url),o(null)):o(((s,o)=>{try{return fn.load(s)}catch(s){return o&&o.errActions.newThrownErr(new Error(s)),{}}})(u.text,i))}},get=(s,o)=>s.getIn(Array.isArray(o)?o:[o]),yn={[mn]:(s,o)=>s.merge((0,ze.fromJS)(o.payload)),[gn]:(s,o)=>{const i=o.payload,a=s.get(i);return s.set(i,!a)}};function configsPlugin(){return{statePlugins:{configs:{reducers:yn,actions:u,selectors:_}}}}const setHash=s=>s?history.pushState(null,null,`#${s}`):window.location.hash="";var vn=__webpack_require__(86215),bn=__webpack_require__.n(vn);const Sn="layout_scroll_to",_n="layout_clear_scroll";const En={fn:{getScrollParent:function getScrollParent(s,o){const i=document.documentElement;let a=getComputedStyle(s);const u="absolute"===a.position,_=o?/(auto|scroll|hidden)/:/(auto|scroll)/;if("fixed"===a.position)return i;for(let o=s;o=o.parentElement;)if(a=getComputedStyle(o),(!u||"static"!==a.position)&&_.test(a.overflow+a.overflowY+a.overflowX))return o;return i}},statePlugins:{layout:{actions:{scrollToElement:(s,o)=>i=>{try{o=o||i.fn.getScrollParent(s),bn().createScroller(o).to(s)}catch(s){console.error(s)}},scrollTo:s=>({type:Sn,payload:Array.isArray(s)?s:[s]}),clearScrollTo:()=>({type:_n}),readyToScroll:(s,o)=>i=>{const a=i.layoutSelectors.getScrollToKey();We().is(a,(0,ze.fromJS)(s))&&(i.layoutActions.scrollToElement(o),i.layoutActions.clearScrollTo())},parseDeepLinkHash:s=>({layoutActions:o,layoutSelectors:i,getConfigs:a})=>{if(a().deepLinking&&s){let a=s.slice(1);"!"===a[0]&&(a=a.slice(1)),"/"===a[0]&&(a=a.slice(1));const u=a.split("/").map((s=>s||"")),_=i.isShownKeyFromUrlHashArray(u),[w,x="",C=""]=_;if("operations"===w){const s=i.isShownKeyFromUrlHashArray([x]);x.indexOf("_")>-1&&(console.warn("Warning: escaping deep link whitespace with `_` will be unsupported in v4.0, use `%20` instead."),o.show(s.map((s=>s.replace(/_/g," "))),!0)),o.show(s,!0)}(x.indexOf("_")>-1||C.indexOf("_")>-1)&&(console.warn("Warning: escaping deep link whitespace with `_` will be unsupported in v4.0, use `%20` instead."),o.show(_.map((s=>s.replace(/_/g," "))),!0)),o.show(_,!0),o.scrollTo(_)}}},selectors:{getScrollToKey:s=>s.get("scrollToKey"),isShownKeyFromUrlHashArray(s,o){const[i,a]=o;return a?["operations",i,a]:i?["operations-tag",i]:[]},urlHashArrayFromIsShownKey(s,o){let[i,a,u]=o;return"operations"==i?[a,u]:"operations-tag"==i?[a]:[]}},reducers:{[Sn]:(s,o)=>s.set("scrollToKey",We().fromJS(o.payload)),[_n]:s=>s.delete("scrollToKey")},wrapActions:{show:(s,{getConfigs:o,layoutSelectors:i})=>(...a)=>{if(s(...a),o().deepLinking)try{let[s,o]=a;s=Array.isArray(s)?s:[s];const u=i.urlHashArrayFromIsShownKey(s);if(!u.length)return;const[_,w]=u;if(!o)return setHash("/");2===u.length?setHash(createDeepLinkPath(`/${encodeURIComponent(_)}/${encodeURIComponent(w)}`)):1===u.length&&setHash(createDeepLinkPath(`/${encodeURIComponent(_)}`))}catch(s){console.error(s)}}}}}};var wn=__webpack_require__(2209),xn=__webpack_require__.n(wn);const operation_wrapper=(s,o)=>class OperationWrapper extends Re.Component{onLoad=s=>{const{operation:i}=this.props,{tag:a,operationId:u}=i.toObject();let{isShownKey:_}=i.toObject();_=_||["operations",a,u],o.layoutActions.readyToScroll(_,s)};render(){return Re.createElement("span",{ref:this.onLoad},Re.createElement(s,this.props))}},operation_tag_wrapper=(s,o)=>class OperationTagWrapper extends Re.Component{onLoad=s=>{const{tag:i}=this.props,a=["operations-tag",i];o.layoutActions.readyToScroll(a,s)};render(){return Re.createElement("span",{ref:this.onLoad},Re.createElement(s,this.props))}};function deep_linking(){return[En,{statePlugins:{configs:{wrapActions:{loaded:(s,o)=>(...i)=>{s(...i);const a=decodeURIComponent(window.location.hash);o.layoutActions.parseDeepLinkHash(a)}}}},wrapComponents:{operation:operation_wrapper,OperationTag:operation_tag_wrapper}}]}var kn=__webpack_require__(40860),On=__webpack_require__.n(kn);function transform(s){return s.map((s=>{let o="is not of a type(s)",i=s.get("message").indexOf(o);if(i>-1){let o=s.get("message").slice(i+19).split(",");return s.set("message",s.get("message").slice(0,i)+function makeNewMessage(s){return s.reduce(((s,o,i,a)=>i===a.length-1&&a.length>1?s+"or "+o:a[i+1]&&a.length>2?s+o+", ":a[i+1]?s+o+" ":s+o),"should be a")}(o))}return s}))}var An=__webpack_require__(58156),Cn=__webpack_require__.n(An);function parameter_oneof_transform(s,{jsSpec:o}){return s}const jn=[w,x];function transformErrors(s){let o={jsSpec:{}},i=On()(jn,((s,i)=>{try{return i.transform(s,o).filter((s=>!!s))}catch(o){return console.error("Transformer error:",o),s}}),s);return i.filter((s=>!!s)).map((s=>(!s.get("line")&&s.get("path"),s)))}let Pn={line:0,level:"error",message:"Unknown error"};const In=Ut((s=>s),(s=>s.get("errors",(0,ze.List)()))),Tn=Ut(In,(s=>s.last()));function err(o){return{statePlugins:{err:{reducers:{[rt]:(s,{payload:o})=>{let i=Object.assign(Pn,o,{type:"thrown"});return s.update("errors",(s=>(s||(0,ze.List)()).push((0,ze.fromJS)(i)))).update("errors",(s=>transformErrors(s)))},[nt]:(s,{payload:o})=>(o=o.map((s=>(0,ze.fromJS)(Object.assign(Pn,s,{type:"thrown"})))),s.update("errors",(s=>(s||(0,ze.List)()).concat((0,ze.fromJS)(o)))).update("errors",(s=>transformErrors(s)))),[st]:(s,{payload:o})=>{let i=(0,ze.fromJS)(o);return i=i.set("type","spec"),s.update("errors",(s=>(s||(0,ze.List)()).push((0,ze.fromJS)(i)).sortBy((s=>s.get("line"))))).update("errors",(s=>transformErrors(s)))},[ot]:(s,{payload:o})=>(o=o.map((s=>(0,ze.fromJS)(Object.assign(Pn,s,{type:"spec"})))),s.update("errors",(s=>(s||(0,ze.List)()).concat((0,ze.fromJS)(o)))).update("errors",(s=>transformErrors(s)))),[it]:(s,{payload:o})=>{let i=(0,ze.fromJS)(Object.assign({},o));return i=i.set("type","auth"),s.update("errors",(s=>(s||(0,ze.List)()).push((0,ze.fromJS)(i)))).update("errors",(s=>transformErrors(s)))},[at]:(s,{payload:o})=>{if(!o||!s.get("errors"))return s;let i=s.get("errors").filter((s=>s.keySeq().every((i=>{const a=s.get(i),u=o[i];return!u||a!==u}))));return s.merge({errors:i})},[ct]:(s,{payload:o})=>{if(!o||"function"!=typeof o)return s;let i=s.get("errors").filter((s=>o(s)));return s.merge({errors:i})}},actions:s,selectors:C}}}}function opsFilter(s,o){return s.filter(((s,i)=>-1!==i.indexOf(o)))}function filter(){return{fn:{opsFilter}}}var Nn=__webpack_require__(7666),Mn=__webpack_require__.n(Nn);const arrow_up=({className:s=null,width:o=20,height:i=20,...a})=>Re.createElement("svg",Mn()({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 20 20",className:s,width:o,height:i,"aria-hidden":"true",focusable:"false"},a),Re.createElement("path",{d:"M 17.418 14.908 C 17.69 15.176 18.127 15.176 18.397 14.908 C 18.667 14.64 18.668 14.207 18.397 13.939 L 10.489 6.109 C 10.219 5.841 9.782 5.841 9.51 6.109 L 1.602 13.939 C 1.332 14.207 1.332 14.64 1.602 14.908 C 1.873 15.176 2.311 15.176 2.581 14.908 L 10 7.767 L 17.418 14.908 Z"})),arrow_down=({className:s=null,width:o=20,height:i=20,...a})=>Re.createElement("svg",Mn()({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 20 20",className:s,width:o,height:i,"aria-hidden":"true",focusable:"false"},a),Re.createElement("path",{d:"M17.418 6.109c.272-.268.709-.268.979 0s.271.701 0 .969l-7.908 7.83c-.27.268-.707.268-.979 0l-7.908-7.83c-.27-.268-.27-.701 0-.969.271-.268.709-.268.979 0L10 13.25l7.418-7.141z"})),arrow=({className:s=null,width:o=20,height:i=20,...a})=>Re.createElement("svg",Mn()({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 20 20",className:s,width:o,height:i,"aria-hidden":"true",focusable:"false"},a),Re.createElement("path",{d:"M13.25 10L6.109 2.58c-.268-.27-.268-.707 0-.979.268-.27.701-.27.969 0l7.83 7.908c.268.271.268.709 0 .979l-7.83 7.908c-.268.271-.701.27-.969 0-.268-.269-.268-.707 0-.979L13.25 10z"})),components_close=({className:s=null,width:o=20,height:i=20,...a})=>Re.createElement("svg",Mn()({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 20 20",className:s,width:o,height:i,"aria-hidden":"true",focusable:"false"},a),Re.createElement("path",{d:"M14.348 14.849c-.469.469-1.229.469-1.697 0L10 11.819l-2.651 3.029c-.469.469-1.229.469-1.697 0-.469-.469-.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-.469-.469-.469-1.228 0-1.697.469-.469 1.228-.469 1.697 0L10 8.183l2.651-3.031c.469-.469 1.228-.469 1.697 0 .469.469.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c.469.469.469 1.229 0 1.698z"})),copy=({className:s=null,width:o=15,height:i=16,...a})=>Re.createElement("svg",Mn()({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 15 16",className:s,width:o,height:i,"aria-hidden":"true",focusable:"false"},a),Re.createElement("g",{transform:"translate(2, -1)"},Re.createElement("path",{fill:"#ffffff",fillRule:"evenodd",d:"M2 13h4v1H2v-1zm5-6H2v1h5V7zm2 3V8l-3 3 3 3v-2h5v-2H9zM4.5 9H2v1h2.5V9zM2 12h2.5v-1H2v1zm9 1h1v2c-.02.28-.11.52-.3.7-.19.18-.42.28-.7.3H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h3c0-1.11.89-2 2-2 1.11 0 2 .89 2 2h3c.55 0 1 .45 1 1v5h-1V6H1v9h10v-2zM2 5h8c0-.55-.45-1-1-1H8c-.55 0-1-.45-1-1s-.45-1-1-1-1 .45-1 1-.45 1-1 1H3c-.55 0-1 .45-1 1z"}))),lock=({className:s=null,width:o=20,height:i=20,...a})=>Re.createElement("svg",Mn()({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 20 20",className:s,width:o,height:i,"aria-hidden":"true",focusable:"false"},a),Re.createElement("path",{d:"M15.8 8H14V5.6C14 2.703 12.665 1 10 1 7.334 1 6 2.703 6 5.6V8H4c-.553 0-1 .646-1 1.199V17c0 .549.428 1.139.951 1.307l1.197.387C5.672 18.861 6.55 19 7.1 19h5.8c.549 0 1.428-.139 1.951-.307l1.196-.387c.524-.167.953-.757.953-1.306V9.199C17 8.646 16.352 8 15.8 8zM12 8H8V5.199C8 3.754 8.797 3 10 3c1.203 0 2 .754 2 2.199V8z"})),unlock=({className:s=null,width:o=20,height:i=20,...a})=>Re.createElement("svg",Mn()({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 20 20",className:s,width:o,height:i,"aria-hidden":"true",focusable:"false"},a),Re.createElement("path",{d:"M15.8 8H14V5.6C14 2.703 12.665 1 10 1 7.334 1 6 2.703 6 5.6V6h2v-.801C8 3.754 8.797 3 10 3c1.203 0 2 .754 2 2.199V8H4c-.553 0-1 .646-1 1.199V17c0 .549.428 1.139.951 1.307l1.197.387C5.672 18.861 6.55 19 7.1 19h5.8c.549 0 1.428-.139 1.951-.307l1.196-.387c.524-.167.953-.757.953-1.306V9.199C17 8.646 16.352 8 15.8 8z"})),icons=()=>({components:{ArrowUpIcon:arrow_up,ArrowDownIcon:arrow_down,ArrowIcon:arrow,CloseIcon:components_close,CopyIcon:copy,LockIcon:lock,UnlockIcon:unlock}}),Rn="layout_update_layout",Dn="layout_update_filter",Ln="layout_update_mode",Fn="layout_show";function updateLayout(s){return{type:Rn,payload:s}}function updateFilter(s){return{type:Dn,payload:s}}function actions_show(s,o=!0){return s=normalizeArray(s),{type:Fn,payload:{thing:s,shown:o}}}function changeMode(s,o=""){return s=normalizeArray(s),{type:Ln,payload:{thing:s,mode:o}}}const Bn={[Rn]:(s,o)=>s.set("layout",o.payload),[Dn]:(s,o)=>s.set("filter",o.payload),[Fn]:(s,o)=>{const i=o.payload.shown,a=(0,ze.fromJS)(o.payload.thing);return s.update("shown",(0,ze.fromJS)({}),(s=>s.set(a,i)))},[Ln]:(s,o)=>{let i=o.payload.thing,a=o.payload.mode;return s.setIn(["modes"].concat(i),(a||"")+"")}},current=s=>s.get("layout"),currentFilter=s=>s.get("filter"),isShown=(s,o,i)=>(o=normalizeArray(o),s.get("shown",(0,ze.fromJS)({})).get((0,ze.fromJS)(o),i)),whatMode=(s,o,i="")=>(o=normalizeArray(o),s.getIn(["modes",...o],i)),$n=Ut((s=>s),(s=>!isShown(s,"editor"))),taggedOperations=(s,o)=>(i,...a)=>{let u=s(i,...a);const{fn:_,layoutSelectors:w,getConfigs:x}=o.getSystem(),C=x(),{maxDisplayedTags:j}=C;let L=w.currentFilter();return L&&!0!==L&&(u=_.opsFilter(u,L)),j>=0&&(u=u.slice(0,j)),u};function plugins_layout(){return{statePlugins:{layout:{reducers:Bn,actions:j,selectors:L},spec:{wrapSelectors:B}}}}function logs({configs:s}){const o={debug:0,info:1,log:2,warn:3,error:4},getLevel=s=>o[s]||-1;let{logLevel:i}=s,a=getLevel(i);function log(s,...o){getLevel(s)>=a&&console[s](...o)}return log.warn=log.bind(null,"warn"),log.error=log.bind(null,"error"),log.info=log.bind(null,"info"),log.debug=log.bind(null,"debug"),{rootInjects:{log}}}let qn=!1;function on_complete(){return{statePlugins:{spec:{wrapActions:{updateSpec:s=>(...o)=>(qn=!0,s(...o)),updateJsonSpec:(s,o)=>(...i)=>{const a=o.getConfigs().onComplete;return qn&&"function"==typeof a&&(setTimeout(a,0),qn=!1),s(...i)}}}}}}const extractKey=s=>{const o="_**[]";return s.indexOf(o)<0?s:s.split(o)[0].trim()},escapeShell=s=>"-d "===s||/^[_\/-]/g.test(s)?s:"'"+s.replace(/'/g,"'\\''")+"'",escapeCMD=s=>"-d "===(s=s.replace(/\^/g,"^^").replace(/\\"/g,'\\\\"').replace(/"/g,'""').replace(/\n/g,"^\n"))?s.replace(/-d /g,"-d ^\n"):/^[_\/-]/g.test(s)?s:'"'+s+'"',escapePowershell=s=>{if("-d "===s)return s;if(/\n/.test(s)){return`@"\n${s.replace(/`/g,"``").replace(/\$/g,"`$")}\n"@`}if(!/^[_\/-]/.test(s)){return`'${s.replace(/'/g,"''")}'`}return s};const curlify=(s,o,i,a="")=>{let u=!1,_="";const addWords=(...s)=>_+=" "+s.map(o).join(" "),addWordsWithoutLeadingSpace=(...s)=>_+=s.map(o).join(" "),addNewLine=()=>_+=` ${i}`,addIndent=(s=1)=>_+="  ".repeat(s);let w=s.get("headers");_+="curl"+a;const x=s.get("curlOptions");if(ze.List.isList(x)&&!x.isEmpty()&&addWords(...s.get("curlOptions")),addWords("-X",s.get("method")),addNewLine(),addIndent(),addWordsWithoutLeadingSpace(`${s.get("url")}`),w&&w.size)for(let o of s.get("headers").entries()){addNewLine(),addIndent();let[s,i]=o;addWordsWithoutLeadingSpace("-H",`${s}: ${i}`),u=u||/^content-type$/i.test(s)&&/^multipart\/form-data$/i.test(i)}const C=s.get("body");if(C)if(u&&["POST","PUT","PATCH"].includes(s.get("method")))for(let[s,o]of C.entrySeq()){let i=extractKey(s);addNewLine(),addIndent(),addWordsWithoutLeadingSpace("-F"),o instanceof lt.File&&"string"==typeof o.valueOf()?addWords(`${i}=${o.data}${o.type?`;type=${o.type}`:""}`):o instanceof lt.File?addWords(`${i}=@${o.name}${o.type?`;type=${o.type}`:""}`):addWords(`${i}=${o}`)}else if(C instanceof lt.File)addNewLine(),addIndent(),addWordsWithoutLeadingSpace(`--data-binary '@${C.name}'`);else{addNewLine(),addIndent(),addWordsWithoutLeadingSpace("-d ");let o=C;ze.Map.isMap(o)?addWordsWithoutLeadingSpace(function getStringBodyOfMap(s){let o=[];for(let[i,a]of s.get("body").entrySeq()){let s=extractKey(i);a instanceof lt.File?o.push(`  "${s}": {\n    "name": "${a.name}"${a.type?`,\n    "type": "${a.type}"`:""}\n  }`):o.push(`  "${s}": ${JSON.stringify(a,null,2).replace(/(\r\n|\r|\n)/g,"\n  ")}`)}return`{\n${o.join(",\n")}\n}`}(s)):("string"!=typeof o&&(o=JSON.stringify(o)),addWordsWithoutLeadingSpace(o))}else C||"POST"!==s.get("method")||(addNewLine(),addIndent(),addWordsWithoutLeadingSpace("-d ''"));return _},requestSnippetGenerator_curl_powershell=s=>curlify(s,escapePowershell,"`\n",".exe"),requestSnippetGenerator_curl_bash=s=>curlify(s,escapeShell,"\\\n"),requestSnippetGenerator_curl_cmd=s=>curlify(s,escapeCMD,"^\n"),request_snippets_selectors_state=s=>s||(0,ze.Map)(),Un=Ut(request_snippets_selectors_state,(s=>{const o=s.get("languages"),i=s.get("generators",(0,ze.Map)());return!o||o.isEmpty()?i:i.filter(((s,i)=>o.includes(i)))})),getSnippetGenerators=s=>({fn:o})=>Un(s).map(((s,i)=>{const a=(s=>o[`requestSnippetGenerator_${s}`])(i);return"function"!=typeof a?null:s.set("fn",a)})).filter((s=>s)),Vn=Ut(request_snippets_selectors_state,(s=>s.get("activeLanguage"))),zn=Ut(request_snippets_selectors_state,(s=>s.get("defaultExpanded")));var Wn=__webpack_require__(46942),Jn=__webpack_require__.n(Wn),Hn=__webpack_require__(59399);const Kn={cursor:"pointer",lineHeight:1,display:"inline-flex",backgroundColor:"rgb(250, 250, 250)",paddingBottom:"0",paddingTop:"0",border:"1px solid rgb(51, 51, 51)",borderRadius:"4px 4px 0 0",boxShadow:"none",borderBottom:"none"},Gn={cursor:"pointer",lineHeight:1,display:"inline-flex",backgroundColor:"rgb(51, 51, 51)",boxShadow:"none",border:"1px solid rgb(51, 51, 51)",paddingBottom:"0",paddingTop:"0",borderRadius:"4px 4px 0 0",marginTop:"-5px",marginRight:"-5px",marginLeft:"-5px",zIndex:"9999",borderBottom:"none"},request_snippets=({request:s,requestSnippetsSelectors:o,getComponent:i})=>{const a=(0,Re.useRef)(null),u=i("ArrowUpIcon"),_=i("ArrowDownIcon"),w=i("SyntaxHighlighter",!0),[x,C]=(0,Re.useState)(o.getSnippetGenerators()?.keySeq().first()),[j,L]=(0,Re.useState)(o?.getDefaultExpanded()),B=o.getSnippetGenerators(),$=B.get(x),U=$.get("fn")(s),handleSetIsExpanded=()=>{L(!j)},handleGetBtnStyle=s=>s===x?Gn:Kn,handlePreventYScrollingBeyondElement=s=>{const{target:o,deltaY:i}=s,{scrollHeight:a,offsetHeight:u,scrollTop:_}=o;a>u&&(0===_&&i<0||u+_>=a&&i>0)&&s.preventDefault()};return(0,Re.useEffect)((()=>{}),[]),(0,Re.useEffect)((()=>{const s=Array.from(a.current.childNodes).filter((s=>!!s.nodeType&&s.classList?.contains("curl-command")));return s.forEach((s=>s.addEventListener("mousewheel",handlePreventYScrollingBeyondElement,{passive:!1}))),()=>{s.forEach((s=>s.removeEventListener("mousewheel",handlePreventYScrollingBeyondElement)))}}),[s]),Re.createElement("div",{className:"request-snippets",ref:a},Re.createElement("div",{style:{width:"100%",display:"flex",justifyContent:"flex-start",alignItems:"center",marginBottom:"15px"}},Re.createElement("h4",{onClick:()=>handleSetIsExpanded(),style:{cursor:"pointer"}},"Snippets"),Re.createElement("button",{onClick:()=>handleSetIsExpanded(),style:{border:"none",background:"none"},title:j?"Collapse operation":"Expand operation"},j?Re.createElement(_,{className:"arrow",width:"10",height:"10"}):Re.createElement(u,{className:"arrow",width:"10",height:"10"}))),j&&Re.createElement("div",{className:"curl-command"},Re.createElement("div",{style:{paddingLeft:"15px",paddingRight:"10px",width:"100%",display:"flex"}},B.entrySeq().map((([s,o])=>Re.createElement("div",{className:Jn()("btn",{active:s===x}),style:handleGetBtnStyle(s),key:s,onClick:()=>(s=>{x!==s&&C(s)})(s)},Re.createElement("h4",{style:s===x?{color:"white"}:{}},o.get("title")))))),Re.createElement("div",{className:"copy-to-clipboard"},Re.createElement(Hn.CopyToClipboard,{text:U},Re.createElement("button",null))),Re.createElement("div",null,Re.createElement(w,{language:$.get("syntax"),className:"curl microlight",renderPlainText:({children:s,PlainTextViewer:o})=>Re.createElement(o,{className:"curl"},s)},U))))},plugins_request_snippets=()=>({components:{RequestSnippets:request_snippets},fn:{requestSnippetGenerator_curl_bash,requestSnippetGenerator_curl_cmd,requestSnippetGenerator_curl_powershell},statePlugins:{requestSnippets:{selectors:$}}});class ModelCollapse extends Re.Component{static defaultProps={collapsedContent:"{...}",expanded:!1,title:null,onToggle:()=>{},hideSelfOnExpand:!1,specPath:We().List([])};constructor(s,o){super(s,o);let{expanded:i,collapsedContent:a}=this.props;this.state={expanded:i,collapsedContent:a||ModelCollapse.defaultProps.collapsedContent}}componentDidMount(){const{hideSelfOnExpand:s,expanded:o,modelName:i}=this.props;s&&o&&this.props.onToggle(i,o)}UNSAFE_componentWillReceiveProps(s){this.props.expanded!==s.expanded&&this.setState({expanded:s.expanded})}toggleCollapsed=()=>{this.props.onToggle&&this.props.onToggle(this.props.modelName,!this.state.expanded),this.setState({expanded:!this.state.expanded})};onLoad=s=>{if(s&&this.props.layoutSelectors){const o=this.props.layoutSelectors.getScrollToKey();We().is(o,this.props.specPath)&&this.toggleCollapsed(),this.props.layoutActions.readyToScroll(this.props.specPath,s.parentElement)}};render(){const{title:s,classes:o}=this.props;return this.state.expanded&&this.props.hideSelfOnExpand?Re.createElement("span",{className:o||""},this.props.children):Re.createElement("span",{className:o||"",ref:this.onLoad},Re.createElement("button",{"aria-expanded":this.state.expanded,className:"model-box-control",onClick:this.toggleCollapsed},s&&Re.createElement("span",{className:"pointer"},s),Re.createElement("span",{className:"model-toggle"+(this.state.expanded?"":" collapsed")}),!this.state.expanded&&Re.createElement("span",null,this.state.collapsedContent)),this.state.expanded&&this.props.children)}}const useTabs=({initialTab:s,isExecute:o,schema:i,example:a})=>{const u=(0,Re.useMemo)((()=>({example:"example",model:"model"})),[]),_=(0,Re.useMemo)((()=>Object.keys(u)),[u]).includes(s)&&i&&!o?s:u.example,w=(s=>{const o=(0,Re.useRef)();return(0,Re.useEffect)((()=>{o.current=s})),o.current})(o),[x,C]=(0,Re.useState)(_),j=(0,Re.useCallback)((s=>{C(s.target.dataset.name)}),[]);return(0,Re.useEffect)((()=>{w&&!o&&a&&C(u.example)}),[w,o,a]),{activeTab:x,onTabChange:j,tabs:u}},model_example=({schema:s,example:o,isExecute:i=!1,specPath:a,includeWriteOnly:u=!1,includeReadOnly:_=!1,getComponent:w,getConfigs:x,specSelectors:C})=>{const{defaultModelRendering:j,defaultModelExpandDepth:L}=x(),B=w("ModelWrapper"),$=w("HighlightCode",!0),U=xt()(5).toString("base64"),V=xt()(5).toString("base64"),z=xt()(5).toString("base64"),Y=xt()(5).toString("base64"),Z=C.isOAS3(),{activeTab:ee,tabs:ie,onTabChange:ae}=useTabs({initialTab:j,isExecute:i,schema:s,example:o});return Re.createElement("div",{className:"model-example"},Re.createElement("ul",{className:"tab",role:"tablist"},Re.createElement("li",{className:Jn()("tabitem",{active:ee===ie.example}),role:"presentation"},Re.createElement("button",{"aria-controls":V,"aria-selected":ee===ie.example,className:"tablinks","data-name":"example",id:U,onClick:ae,role:"tab"},i?"Edit Value":"Example Value")),s&&Re.createElement("li",{className:Jn()("tabitem",{active:ee===ie.model}),role:"presentation"},Re.createElement("button",{"aria-controls":Y,"aria-selected":ee===ie.model,className:Jn()("tablinks",{inactive:i}),"data-name":"model",id:z,onClick:ae,role:"tab"},Z?"Schema":"Model"))),ee===ie.example&&Re.createElement("div",{"aria-hidden":ee!==ie.example,"aria-labelledby":U,"data-name":"examplePanel",id:V,role:"tabpanel",tabIndex:"0"},o||Re.createElement($,null,"(no example available")),ee===ie.model&&Re.createElement("div",{className:"model-container","aria-hidden":ee===ie.example,"aria-labelledby":z,"data-name":"modelPanel",id:Y,role:"tabpanel",tabIndex:"0"},Re.createElement(B,{schema:s,getComponent:w,getConfigs:x,specSelectors:C,expandDepth:L,specPath:a,includeReadOnly:_,includeWriteOnly:u})))};class ModelWrapper extends Re.Component{onToggle=(s,o)=>{this.props.layoutActions&&this.props.layoutActions.show(this.props.fullPath,o)};render(){let{getComponent:s,getConfigs:o}=this.props;const i=s("Model");let a;return this.props.layoutSelectors&&(a=this.props.layoutSelectors.isShown(this.props.fullPath)),Re.createElement("div",{className:"model-box"},Re.createElement(i,Mn()({},this.props,{getConfigs:o,expanded:a,depth:1,onToggle:this.onToggle,expandDepth:this.props.expandDepth||0})))}}function _typeof(s){return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(s){return typeof s}:function(s){return s&&"function"==typeof Symbol&&s.constructor===Symbol&&s!==Symbol.prototype?"symbol":typeof s},_typeof(s)}function _defineProperties(s,o){for(var i=0;i<o.length;i++){var a=o[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(s,a.key,a)}}function _defineProperty(s,o,i){return o in s?Object.defineProperty(s,o,{value:i,enumerable:!0,configurable:!0,writable:!0}):s[o]=i,s}function ownKeys(s,o){var i=Object.keys(s);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(s);o&&(a=a.filter((function(o){return Object.getOwnPropertyDescriptor(s,o).enumerable}))),i.push.apply(i,a)}return i}function _getPrototypeOf(s){return _getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(s){return s.__proto__||Object.getPrototypeOf(s)},_getPrototypeOf(s)}function _setPrototypeOf(s,o){return _setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(s,o){return s.__proto__=o,s},_setPrototypeOf(s,o)}function _possibleConstructorReturn(s,o){return!o||"object"!=typeof o&&"function"!=typeof o?function _assertThisInitialized(s){if(void 0===s)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return s}(s):o}var Yn={};function react_immutable_pure_component_es_get(s,o,i){return function isInvalid(s){return null==s}(s)?i:function isMapLike(s){return null!==s&&"object"===_typeof(s)&&"function"==typeof s.get&&"function"==typeof s.has}(s)?s.has(o)?s.get(o):i:hasOwnProperty.call(s,o)?s[o]:i}function getIn(s,o,i){for(var a=0;a!==o.length;)if((s=react_immutable_pure_component_es_get(s,o[a++],Yn))===Yn)return i;return s}function check(s){var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},a=function createChecker(s,o){return function(i){if("string"==typeof i)return(0,ze.is)(o[i],s[i]);if(Array.isArray(i))return(0,ze.is)(getIn(o,i),getIn(s,i));throw new TypeError("Invalid key: expected Array or string: "+i)}}(o,i),u=s||Object.keys(function _objectSpread2(s){for(var o=1;o<arguments.length;o++){var i=null!=arguments[o]?arguments[o]:{};o%2?ownKeys(i,!0).forEach((function(o){_defineProperty(s,o,i[o])})):Object.getOwnPropertyDescriptors?Object.defineProperties(s,Object.getOwnPropertyDescriptors(i)):ownKeys(i).forEach((function(o){Object.defineProperty(s,o,Object.getOwnPropertyDescriptor(i,o))}))}return s}({},i,{},o));return u.every(a)}const Xn=function(s){function ImmutablePureComponent(){return function _classCallCheck(s,o){if(!(s instanceof o))throw new TypeError("Cannot call a class as a function")}(this,ImmutablePureComponent),_possibleConstructorReturn(this,_getPrototypeOf(ImmutablePureComponent).apply(this,arguments))}return function _inherits(s,o){if("function"!=typeof o&&null!==o)throw new TypeError("Super expression must either be null or a function");s.prototype=Object.create(o&&o.prototype,{constructor:{value:s,writable:!0,configurable:!0}}),o&&_setPrototypeOf(s,o)}(ImmutablePureComponent,s),function _createClass(s,o,i){return o&&_defineProperties(s.prototype,o),i&&_defineProperties(s,i),s}(ImmutablePureComponent,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(s){var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return!check(this.updateOnProps,this.props,s,"updateOnProps")||!check(this.updateOnStates,this.state,o,"updateOnStates")}}]),ImmutablePureComponent}(Re.Component);var Qn,Zn=__webpack_require__(5556),es=__webpack_require__.n(Zn);function _extends(){return _extends=Object.assign?Object.assign.bind():function(s){for(var o=1;o<arguments.length;o++){var i=arguments[o];for(var a in i)({}).hasOwnProperty.call(i,a)&&(s[a]=i[a])}return s},_extends.apply(null,arguments)}const rolling_load=s=>Re.createElement("svg",_extends({xmlns:"http://www.w3.org/2000/svg",width:200,height:200,className:"rolling-load_svg__lds-rolling",preserveAspectRatio:"xMidYMid",style:{backgroundImage:"none",backgroundPosition:"initial initial",backgroundRepeat:"initial initial"},viewBox:"0 0 100 100"},s),Qn||(Qn=Re.createElement("circle",{cx:50,cy:50,r:35,fill:"none",stroke:"#555",strokeDasharray:"164.93361431346415 56.97787143782138",strokeWidth:10},Re.createElement("animateTransform",{attributeName:"transform",begin:"0s",calcMode:"linear",dur:"1s",keyTimes:"0;1",repeatCount:"indefinite",type:"rotate",values:"0 50 50;360 50 50"})))),decodeRefName=s=>{const o=s.replace(/~1/g,"/").replace(/~0/g,"~");try{return decodeURIComponent(o)}catch{return o}};class Model extends Xn{static propTypes={schema:xn().map.isRequired,getComponent:es().func.isRequired,getConfigs:es().func.isRequired,specSelectors:es().object.isRequired,name:es().string,displayName:es().string,isRef:es().bool,required:es().bool,expandDepth:es().number,depth:es().number,specPath:xn().list.isRequired,includeReadOnly:es().bool,includeWriteOnly:es().bool};getModelName=s=>-1!==s.indexOf("#/definitions/")?decodeRefName(s.replace(/^.*#\/definitions\//,"")):-1!==s.indexOf("#/components/schemas/")?decodeRefName(s.replace(/^.*#\/components\/schemas\//,"")):void 0;getRefSchema=s=>{let{specSelectors:o}=this.props;return o.findDefinition(s)};render(){let{getComponent:s,getConfigs:o,specSelectors:i,schema:a,required:u,name:_,isRef:w,specPath:x,displayName:C,includeReadOnly:j,includeWriteOnly:L}=this.props;const B=s("ObjectModel"),$=s("ArrayModel"),U=s("PrimitiveModel");let V="object",z=a&&a.get("$$ref"),Y=a&&a.get("$ref");if(!_&&z&&(_=this.getModelName(z)),Y){const s=this.getModelName(Y),o=this.getRefSchema(s);ze.Map.isMap(o)?(a=o.mergeDeep(a),z||(a=a.set("$$ref",Y),z=Y)):ze.Map.isMap(a)&&1===a.size&&(a=null,_=Y)}if(!a)return Re.createElement("span",{className:"model model-title"},Re.createElement("span",{className:"model-title__text"},C||_),!Y&&Re.createElement(rolling_load,{height:"20px",width:"20px"}));const Z=i.isOAS3()&&a.get("deprecated");switch(w=void 0!==w?w:!!z,V=a&&a.get("type")||V,V){case"object":return Re.createElement(B,Mn()({className:"object"},this.props,{specPath:x,getConfigs:o,schema:a,name:_,deprecated:Z,isRef:w,includeReadOnly:j,includeWriteOnly:L}));case"array":return Re.createElement($,Mn()({className:"array"},this.props,{getConfigs:o,schema:a,name:_,deprecated:Z,required:u,includeReadOnly:j,includeWriteOnly:L}));default:return Re.createElement(U,Mn()({},this.props,{getComponent:s,getConfigs:o,schema:a,name:_,deprecated:Z,required:u}))}}}class Models extends Re.Component{getSchemaBasePath=()=>this.props.specSelectors.isOAS3()?["components","schemas"]:["definitions"];getCollapsedContent=()=>" ";handleToggle=(s,o)=>{const{layoutActions:i}=this.props;i.show([...this.getSchemaBasePath(),s],o),o&&this.props.specActions.requestResolvedSubtree([...this.getSchemaBasePath(),s])};onLoadModels=s=>{s&&this.props.layoutActions.readyToScroll(this.getSchemaBasePath(),s)};onLoadModel=s=>{if(s){const o=s.getAttribute("data-name");this.props.layoutActions.readyToScroll([...this.getSchemaBasePath(),o],s)}};render(){let{specSelectors:s,getComponent:o,layoutSelectors:i,layoutActions:a,getConfigs:u}=this.props,_=s.definitions(),{docExpansion:w,defaultModelsExpandDepth:x}=u();if(!_.size||x<0)return null;const C=this.getSchemaBasePath();let j=i.isShown(C,x>0&&"none"!==w);const L=s.isOAS3(),B=o("ModelWrapper"),$=o("Collapse"),U=o("ModelCollapse"),V=o("JumpToPath",!0),z=o("ArrowUpIcon"),Y=o("ArrowDownIcon");return Re.createElement("section",{className:j?"models is-open":"models",ref:this.onLoadModels},Re.createElement("h4",null,Re.createElement("button",{"aria-expanded":j,className:"models-control",onClick:()=>a.show(C,!j)},Re.createElement("span",null,L?"Schemas":"Models"),j?Re.createElement(z,null):Re.createElement(Y,null))),Re.createElement($,{isOpened:j},_.entrySeq().map((([_])=>{const w=[...C,_],j=We().List(w),L=s.specResolvedSubtree(w),$=s.specJson().getIn(w),z=ze.Map.isMap(L)?L:We().Map(),Y=ze.Map.isMap($)?$:We().Map(),Z=z.get("title")||Y.get("title")||_,ee=i.isShown(w,!1);ee&&0===z.size&&Y.size>0&&this.props.specActions.requestResolvedSubtree(w);const ie=Re.createElement(B,{name:_,expandDepth:x,schema:z||We().Map(),displayName:Z,fullPath:w,specPath:j,getComponent:o,specSelectors:s,getConfigs:u,layoutSelectors:i,layoutActions:a,includeReadOnly:!0,includeWriteOnly:!0}),ae=Re.createElement("span",{className:"model-box"},Re.createElement("span",{className:"model model-title"},Z));return Re.createElement("div",{id:`model-${_}`,className:"model-container",key:`models-section-${_}`,"data-name":_,ref:this.onLoadModel},Re.createElement("span",{className:"models-jump-to-path"},Re.createElement(V,{path:j})),Re.createElement(U,{classes:"model-box",collapsedContent:this.getCollapsedContent(_),onToggle:this.handleToggle,title:ae,displayName:Z,modelName:_,specPath:j,layoutSelectors:i,layoutActions:a,hideSelfOnExpand:!0,expanded:x>0&&ee},ie))})).toArray()))}}const enum_model=({value:s,getComponent:o})=>{let i=o("ModelCollapse"),a=Re.createElement("span",null,"Array [ ",s.count()," ]");return Re.createElement("span",{className:"prop-enum"},"Enum:",Re.createElement("br",null),Re.createElement(i,{collapsedContent:a},"[ ",s.map(String).join(", ")," ]"))};function isAbsoluteUrl(s){return s.match(/^(?:[a-z]+:)?\/\//i)}function buildBaseUrl(s,o){return s?isAbsoluteUrl(s)?function addProtocol(s){return s.match(/^\/\//i)?`${window.location.protocol}${s}`:s}(s):new URL(s,o).href:o}function safeBuildUrl(s,o,{selectedServer:i=""}={}){try{return function buildUrl(s,o,{selectedServer:i=""}={}){if(!s)return;if(isAbsoluteUrl(s))return s;const a=buildBaseUrl(i,o);return isAbsoluteUrl(a)?new URL(s,a).href:new URL(s,window.location.href).href}(s,o,{selectedServer:i})}catch{return}}function sanitizeUrl(s){if("string"!=typeof s||""===s.trim())return"";const o=s.trim(),i="about:blank";try{const s=`https://base${String(Math.random()).slice(2)}`,a=new URL(o,s),u=a.protocol.slice(0,-1);if(["javascript","data","vbscript"].includes(u.toLowerCase()))return i;if(a.origin===s){if(o.startsWith("/"))return`${a.pathname}${a.search}${a.hash}`;if(o.startsWith("./")||o.startsWith("../")){const s=o.match(/^(\.\.?\/)+/)[0];return`${s}${a.pathname.substring(1)}${a.search}${a.hash}`}return`${a.pathname.substring(1)}${a.search}${a.hash}`}return String(a)}catch{return i}}class ObjectModel extends Re.Component{render(){let{schema:s,name:o,displayName:i,isRef:a,getComponent:u,getConfigs:_,depth:w,onToggle:x,expanded:C,specPath:j,...L}=this.props,{specSelectors:B,expandDepth:$,includeReadOnly:U,includeWriteOnly:V}=L;const{isOAS3:z}=B,Y=w>2||2===w&&"items"!==j.last();if(!s)return null;const{showExtensions:Z}=_(),ee=Z?getExtensions(s):(0,ze.List)();let ie=s.get("description"),ae=s.get("properties"),ce=s.get("additionalProperties"),le=s.get("title")||i||o,pe=s.get("required"),de=s.filter(((s,o)=>-1!==["maxProperties","minProperties","nullable","example"].indexOf(o))),fe=s.get("deprecated"),ye=s.getIn(["externalDocs","url"]),be=s.getIn(["externalDocs","description"]);const Se=u("JumpToPath",!0),_e=u("Markdown",!0),we=u("Model"),xe=u("ModelCollapse"),Pe=u("Property"),Te=u("Link"),$e=u("ModelExtensions"),JumpToPathSection=()=>Re.createElement("span",{className:"model-jump-to-path"},Re.createElement(Se,{path:j})),qe=Re.createElement("span",null,Re.createElement("span",null,"{"),"...",Re.createElement("span",null,"}"),a?Re.createElement(JumpToPathSection,null):""),We=B.isOAS3()?s.get("allOf"):null,He=B.isOAS3()?s.get("anyOf"):null,Ye=B.isOAS3()?s.get("oneOf"):null,Xe=B.isOAS3()?s.get("not"):null,Qe=le&&Re.createElement("span",{className:"model-title"},a&&s.get("$$ref")&&Re.createElement("span",{className:Jn()("model-hint",{"model-hint--embedded":Y})},s.get("$$ref")),Re.createElement("span",{className:"model-title__text"},le));return Re.createElement("span",{className:"model"},Re.createElement(xe,{modelName:o,title:Qe,onToggle:x,expanded:!!C||w<=$,collapsedContent:qe},Re.createElement("span",{className:"brace-open object"},"{"),a?Re.createElement(JumpToPathSection,null):null,Re.createElement("span",{className:"inner-object"},Re.createElement("table",{className:"model"},Re.createElement("tbody",null,ie?Re.createElement("tr",{className:"description"},Re.createElement("td",null,"description:"),Re.createElement("td",null,Re.createElement(_e,{source:ie}))):null,ye&&Re.createElement("tr",{className:"external-docs"},Re.createElement("td",null,"externalDocs:"),Re.createElement("td",null,Re.createElement(Te,{target:"_blank",href:sanitizeUrl(ye)},be||ye))),fe?Re.createElement("tr",{className:"property"},Re.createElement("td",null,"deprecated:"),Re.createElement("td",null,"true")):null,ae&&ae.size?ae.entrySeq().filter((([,s])=>(!s.get("readOnly")||U)&&(!s.get("writeOnly")||V))).map((([s,i])=>{let a=z()&&i.get("deprecated"),x=ze.List.isList(pe)&&pe.contains(s),C=["property-row"];return a&&C.push("deprecated"),x&&C.push("required"),Re.createElement("tr",{key:s,className:C.join(" ")},Re.createElement("td",null,s,x&&Re.createElement("span",{className:"star"},"*")),Re.createElement("td",null,Re.createElement(we,Mn()({key:`object-${o}-${s}_${i}`},L,{required:x,getComponent:u,specPath:j.push("properties",s),getConfigs:_,schema:i,depth:w+1}))))})).toArray():null,0===ee.size?null:Re.createElement(Re.Fragment,null,Re.createElement("tr",null,Re.createElement("td",null," ")),Re.createElement($e,{extensions:ee,propClass:"extension"})),ce&&ce.size?Re.createElement("tr",null,Re.createElement("td",null,"< * >:"),Re.createElement("td",null,Re.createElement(we,Mn()({},L,{required:!1,getComponent:u,specPath:j.push("additionalProperties"),getConfigs:_,schema:ce,depth:w+1})))):null,We?Re.createElement("tr",null,Re.createElement("td",null,"allOf ->"),Re.createElement("td",null,We.map(((s,o)=>Re.createElement("div",{key:o},Re.createElement(we,Mn()({},L,{required:!1,getComponent:u,specPath:j.push("allOf",o),getConfigs:_,schema:s,depth:w+1}))))))):null,He?Re.createElement("tr",null,Re.createElement("td",null,"anyOf ->"),Re.createElement("td",null,He.map(((s,o)=>Re.createElement("div",{key:o},Re.createElement(we,Mn()({},L,{required:!1,getComponent:u,specPath:j.push("anyOf",o),getConfigs:_,schema:s,depth:w+1}))))))):null,Ye?Re.createElement("tr",null,Re.createElement("td",null,"oneOf ->"),Re.createElement("td",null,Ye.map(((s,o)=>Re.createElement("div",{key:o},Re.createElement(we,Mn()({},L,{required:!1,getComponent:u,specPath:j.push("oneOf",o),getConfigs:_,schema:s,depth:w+1}))))))):null,Xe?Re.createElement("tr",null,Re.createElement("td",null,"not ->"),Re.createElement("td",null,Re.createElement("div",null,Re.createElement(we,Mn()({},L,{required:!1,getComponent:u,specPath:j.push("not"),getConfigs:_,schema:Xe,depth:w+1}))))):null))),Re.createElement("span",{className:"brace-close"},"}")),de.size?de.entrySeq().map((([s,o])=>Re.createElement(Pe,{key:`${s}-${o}`,propKey:s,propVal:o,propClass:"property"}))):null)}}class ArrayModel extends Re.Component{render(){let{getComponent:s,getConfigs:o,schema:i,depth:a,expandDepth:u,name:_,displayName:w,specPath:x}=this.props,C=i.get("description"),j=i.get("items"),L=i.get("title")||w||_,B=i.filter(((s,o)=>-1===["type","items","description","$$ref","externalDocs"].indexOf(o))),$=i.getIn(["externalDocs","url"]),U=i.getIn(["externalDocs","description"]);const V=s("Markdown",!0),z=s("ModelCollapse"),Y=s("Model"),Z=s("Property"),ee=s("Link"),ie=L&&Re.createElement("span",{className:"model-title"},Re.createElement("span",{className:"model-title__text"},L));return Re.createElement("span",{className:"model"},Re.createElement(z,{title:ie,expanded:a<=u,collapsedContent:"[...]"},"[",B.size?B.entrySeq().map((([s,o])=>Re.createElement(Z,{key:`${s}-${o}`,propKey:s,propVal:o,propClass:"property"}))):null,C?Re.createElement(V,{source:C}):B.size?Re.createElement("div",{className:"markdown"}):null,$&&Re.createElement("div",{className:"external-docs"},Re.createElement(ee,{target:"_blank",href:sanitizeUrl($)},U||$)),Re.createElement("span",null,Re.createElement(Y,Mn()({},this.props,{getConfigs:o,specPath:x.push("items"),name:null,schema:j,required:!1,depth:a+1}))),"]"))}}const ts="property primitive";class Primitive extends Re.Component{render(){let{schema:s,getComponent:o,getConfigs:i,name:a,displayName:u,depth:_,expandDepth:w}=this.props;const{showExtensions:x}=i();if(!s||!s.get)return Re.createElement("div",null);let C=s.get("type"),j=s.get("format"),L=s.get("xml"),B=s.get("enum"),$=s.get("title")||u||a,U=s.get("description");const V=getExtensions(s);let z=s.filter(((s,o)=>-1===["enum","type","format","description","$$ref","externalDocs"].indexOf(o))).filterNot(((s,o)=>V.has(o))),Y=s.getIn(["externalDocs","url"]),Z=s.getIn(["externalDocs","description"]);const ee=o("Markdown",!0),ie=o("EnumModel"),ae=o("Property"),ce=o("ModelCollapse"),le=o("Link"),pe=o("ModelExtensions"),de=$&&Re.createElement("span",{className:"model-title"},Re.createElement("span",{className:"model-title__text"},$));return Re.createElement("span",{className:"model"},Re.createElement(ce,{title:de,expanded:_<=w,collapsedContent:"[...]"},Re.createElement("span",{className:"prop"},a&&_>1&&Re.createElement("span",{className:"prop-name"},$),Re.createElement("span",{className:"prop-type"},C),j&&Re.createElement("span",{className:"prop-format"},"($",j,")"),z.size?z.entrySeq().map((([s,o])=>Re.createElement(ae,{key:`${s}-${o}`,propKey:s,propVal:o,propClass:ts}))):null,x&&V.size>0?Re.createElement(pe,{extensions:V,propClass:`${ts} extension`}):null,U?Re.createElement(ee,{source:U}):null,Y&&Re.createElement("div",{className:"external-docs"},Re.createElement(le,{target:"_blank",href:sanitizeUrl(Y)},Z||Y)),L&&L.size?Re.createElement("span",null,Re.createElement("br",null),Re.createElement("span",{className:ts},"xml:"),L.entrySeq().map((([s,o])=>Re.createElement("span",{key:`${s}-${o}`,className:ts},Re.createElement("br",null),"   ",s,": ",String(o)))).toArray()):null,B&&Re.createElement(ie,{value:B,getComponent:o}))))}}class Schemes extends Re.Component{UNSAFE_componentWillMount(){let{schemes:s}=this.props;this.setScheme(s.first())}UNSAFE_componentWillReceiveProps(s){this.props.currentScheme&&s.schemes.includes(this.props.currentScheme)||this.setScheme(s.schemes.first())}onChange=s=>{this.setScheme(s.target.value)};setScheme=s=>{let{path:o,method:i,specActions:a}=this.props;a.setScheme(s,o,i)};render(){let{schemes:s,currentScheme:o}=this.props;return Re.createElement("label",{htmlFor:"schemes"},Re.createElement("span",{className:"schemes-title"},"Schemes"),Re.createElement("select",{onChange:this.onChange,value:o,id:"schemes"},s.valueSeq().map((s=>Re.createElement("option",{value:s,key:s},s))).toArray()))}}class SchemesContainer extends Re.Component{render(){const{specActions:s,specSelectors:o,getComponent:i}=this.props,a=o.operationScheme(),u=o.schemes(),_=i("schemes");return u&&u.size?Re.createElement(_,{currentScheme:a,schemes:u,specActions:s}):null}}var rs=__webpack_require__(24677),ns=__webpack_require__.n(rs);const ss={value:"",onChange:()=>{},schema:{},keyName:"",required:!1,errors:(0,ze.List)()};class JsonSchemaForm extends Re.Component{static defaultProps=ss;componentDidMount(){const{dispatchInitialValue:s,value:o,onChange:i}=this.props;s?i(o):!1===s&&i("")}render(){let{schema:s,errors:o,value:i,onChange:a,getComponent:u,fn:_,disabled:w}=this.props;const x=s&&s.get?s.get("format"):null,C=s&&s.get?s.get("type"):null,j=_.getSchemaObjectType(s),L=_.isFileUploadIntended(s);let getComponentSilently=s=>u(s,!1,{failSilently:!0}),B=C?getComponentSilently(x?`JsonSchema_${C}_${x}`:`JsonSchema_${C}`):u("JsonSchema_string");return L||!ze.List.isList(C)||"array"!==j&&"object"!==j||(B=u("JsonSchema_object")),B||(B=u("JsonSchema_string")),Re.createElement(B,Mn()({},this.props,{errors:o,fn:_,getComponent:u,value:i,onChange:a,schema:s,disabled:w}))}}class JsonSchema_string extends Re.Component{static defaultProps=ss;onChange=s=>{const o=this.props.schema&&"file"===this.props.schema.get("type")?s.target.files[0]:s.target.value;this.props.onChange(o,this.props.keyName)};onEnumChange=s=>this.props.onChange(s);render(){let{getComponent:s,value:o,schema:i,errors:a,required:u,description:_,disabled:w}=this.props;const x=i&&i.get?i.get("enum"):null,C=i&&i.get?i.get("format"):null,j=i&&i.get?i.get("type"):null,L=i&&i.get?i.get("in"):null;if(o?(isImmutable(o)||"object"==typeof o)&&(o=stringify(o)):o="",a=a.toJS?a.toJS():[],x){const i=s("Select");return Re.createElement(i,{className:a.length?"invalid":"",title:a.length?a:"",allowedValues:[...x],value:o,allowEmptyValue:!u,disabled:w,onChange:this.onEnumChange})}const B=w||L&&"formData"===L&&!("FormData"in window),$=s("Input");return j&&"file"===j?Re.createElement($,{type:"file",className:a.length?"invalid":"",title:a.length?a:"",onChange:this.onChange,disabled:B}):Re.createElement(ns(),{type:C&&"password"===C?"password":"text",className:a.length?"invalid":"",title:a.length?a:"",value:o,minLength:0,debounceTimeout:350,placeholder:_,onChange:this.onChange,disabled:B})}}class JsonSchema_array extends Re.PureComponent{static defaultProps=ss;constructor(s,o){super(s,o),this.state={value:valueOrEmptyList(s.value),schema:s.schema}}UNSAFE_componentWillReceiveProps(s){const o=valueOrEmptyList(s.value);o!==this.state.value&&this.setState({value:o}),s.schema!==this.state.schema&&this.setState({schema:s.schema})}onChange=()=>{this.props.onChange(this.state.value)};onItemChange=(s,o)=>{this.setState((({value:i})=>({value:i.set(o,s)})),this.onChange)};removeItem=s=>{this.setState((({value:o})=>({value:o.delete(s)})),this.onChange)};addItem=()=>{const{fn:s}=this.props;let o=valueOrEmptyList(this.state.value);this.setState((()=>({value:o.push(s.getSampleSchema(this.state.schema.get("items"),!1,{includeWriteOnly:!0}))})),this.onChange)};onEnumChange=s=>{this.setState((()=>({value:s})),this.onChange)};render(){let{getComponent:s,required:o,schema:i,errors:a,fn:u,disabled:_}=this.props;a=a.toJS?a.toJS():Array.isArray(a)?a:[];const w=a.filter((s=>"string"==typeof s)),x=a.filter((s=>void 0!==s.needRemove)).map((s=>s.error)),C=this.state.value,j=!!(C&&C.count&&C.count()>0),L=i.getIn(["items","enum"]),B=i.get("items"),$=u.getSchemaObjectType(B),U=u.getSchemaObjectTypeLabel(B),V=i.getIn(["items","format"]),z=i.get("items");let Y,Z=!1,ee="file"===$||"string"===$&&"binary"===V;if($&&V?Y=s(`JsonSchema_${$}_${V}`):"boolean"!==$&&"array"!==$&&"object"!==$||(Y=s(`JsonSchema_${$}`)),!ze.List.isList(B?.get("type"))||"array"!==$&&"object"!==$||(Y=s("JsonSchema_object")),Y||ee||(Z=!0),L){const i=s("Select");return Re.createElement(i,{className:a.length?"invalid":"",title:a.length?a:"",multiple:!0,value:C,disabled:_,allowedValues:L,allowEmptyValue:!o,onChange:this.onEnumChange})}const ie=s("Button");return Re.createElement("div",{className:"json-schema-array"},j?C.map(((o,i)=>{const w=(0,ze.fromJS)([...a.filter((s=>s.index===i)).map((s=>s.error))]);return Re.createElement("div",{key:i,className:"json-schema-form-item"},ee?Re.createElement(JsonSchemaArrayItemFile,{value:o,onChange:s=>this.onItemChange(s,i),disabled:_,errors:w,getComponent:s}):Z?Re.createElement(JsonSchemaArrayItemText,{value:o,onChange:s=>this.onItemChange(s,i),disabled:_,errors:w}):Re.createElement(Y,Mn()({},this.props,{value:o,onChange:s=>this.onItemChange(s,i),disabled:_,errors:w,schema:z,getComponent:s,fn:u})),_?null:Re.createElement(ie,{className:`btn btn-sm json-schema-form-item-remove ${x.length?"invalid":null}`,title:x.length?x:"",onClick:()=>this.removeItem(i)}," - "))})):null,_?null:Re.createElement(ie,{className:`btn btn-sm json-schema-form-item-add ${w.length?"invalid":null}`,title:w.length?w:"",onClick:this.addItem},"Add ",U," item"))}}class JsonSchemaArrayItemText extends Re.Component{static defaultProps=ss;onChange=s=>{const o=s.target.value;this.props.onChange(o,this.props.keyName)};render(){let{value:s,errors:o,description:i,disabled:a}=this.props;return s?(isImmutable(s)||"object"==typeof s)&&(s=stringify(s)):s="",o=o.toJS?o.toJS():[],Re.createElement(ns(),{type:"text",className:o.length?"invalid":"",title:o.length?o:"",value:s,minLength:0,debounceTimeout:350,placeholder:i,onChange:this.onChange,disabled:a})}}class JsonSchemaArrayItemFile extends Re.Component{static defaultProps=ss;onFileChange=s=>{const o=s.target.files[0];this.props.onChange(o,this.props.keyName)};render(){let{getComponent:s,errors:o,disabled:i}=this.props;const a=s("Input"),u=i||!("FormData"in window);return Re.createElement(a,{type:"file",className:o.length?"invalid":"",title:o.length?o:"",onChange:this.onFileChange,disabled:u})}}class JsonSchema_boolean extends Re.Component{static defaultProps=ss;onEnumChange=s=>this.props.onChange(s);render(){let{getComponent:s,value:o,errors:i,schema:a,required:u,disabled:_}=this.props;i=i.toJS?i.toJS():[];let w=a&&a.get?a.get("enum"):null,x=!w||!u,C=!w&&["true","false"];const j=s("Select");return Re.createElement(j,{className:i.length?"invalid":"",title:i.length?i:"",value:String(o),disabled:_,allowedValues:w?[...w]:C,allowEmptyValue:x,onChange:this.onEnumChange})}}const stringifyObjectErrors=s=>s.map((s=>{const o=void 0!==s.propKey?s.propKey:s.index;let i="string"==typeof s?s:"string"==typeof s.error?s.error:null;if(!o&&i)return i;let a=s.error,u=`/${s.propKey}`;for(;"object"==typeof a;){const s=void 0!==a.propKey?a.propKey:a.index;if(void 0===s)break;if(u+=`/${s}`,!a.error)break;a=a.error}return`${u}: ${a}`}));class JsonSchema_object extends Re.PureComponent{constructor(){super()}static defaultProps=ss;onChange=s=>{this.props.onChange(s)};handleOnChange=s=>{const o=s.target.value;this.onChange(o)};render(){let{getComponent:s,value:o,errors:i,disabled:a}=this.props;const u=s("TextArea");return i=i.toJS?i.toJS():Array.isArray(i)?i:[],Re.createElement("div",null,Re.createElement(u,{className:Jn()({invalid:i.length}),title:i.length?stringifyObjectErrors(i).join(", "):"",value:stringify(o),disabled:a,onChange:this.handleOnChange}))}}function valueOrEmptyList(s){return ze.List.isList(s)?s:Array.isArray(s)?(0,ze.fromJS)(s):(0,ze.List)()}const ModelExtensions=({extensions:s,propClass:o=""})=>s.entrySeq().map((([s,i])=>{const a=immutableToJS(i)??null;return Re.createElement("tr",{key:s,className:o},Re.createElement("td",null,s),Re.createElement("td",null,JSON.stringify(a)))})).toArray();var os=__webpack_require__(11331),as=__webpack_require__.n(os);const hasSchemaType=(s,o)=>{const i=ze.Map.isMap(s);if(!i&&!as()(s))return!1;const a=i?s.get("type"):s.type;return o===a||Array.isArray(o)&&o.includes(a)},getType=(s,o=new WeakSet)=>{if(null==s)return"any";if(o.has(s))return"any";o.add(s);const{type:i,items:a}=s;return Object.hasOwn(s,"items")?(()=>{if(a)return`array<${getType(a,o)}>`;return"array<any>"})():i},getSchemaObjectTypeLabel=s=>getType(immutableToJS(s)),json_schema_5=()=>({components:{modelExample:model_example,ModelWrapper,ModelCollapse,Model,Models,EnumModel:enum_model,ObjectModel,ArrayModel,PrimitiveModel:Primitive,ModelExtensions,schemes:Schemes,SchemesContainer,...U},fn:{hasSchemaType,getSchemaObjectTypeLabel}});var cs=__webpack_require__(19123),ls=__webpack_require__.n(cs),us=__webpack_require__(41859),ps=__webpack_require__.n(us),hs=__webpack_require__(62193),ds=__webpack_require__.n(hs);const shallowArrayEquals=s=>o=>Array.isArray(s)&&Array.isArray(o)&&s.length===o.length&&s.every(((s,i)=>s===o[i])),list=(...s)=>s;class Cache extends Map{delete(s){const o=Array.from(this.keys()).find(shallowArrayEquals(s));return super.delete(o)}get(s){const o=Array.from(this.keys()).find(shallowArrayEquals(s));return super.get(o)}has(s){return-1!==Array.from(this.keys()).findIndex(shallowArrayEquals(s))}}const utils_memoizeN=(s,o=list)=>{const{Cache:i}=pt();pt().Cache=Cache;const a=pt()(s,o);return pt().Cache=i,a},fs={string:s=>s.pattern?(s=>{try{const o=/(?<=(?<!\\)\{)(\d{3,})(?=\})|(?<=(?<!\\)\{\d*,)(\d{3,})(?=\})|(?<=(?<!\\)\{)(\d{3,})(?=,\d*\})/g,i=s.replace(o,"100"),a=new(ps())(i);return a.max=100,a.gen()}catch(s){return"string"}})(s.pattern):"string",string_email:()=>"user@example.com","string_date-time":()=>(new Date).toISOString(),string_date:()=>(new Date).toISOString().substring(0,10),string_time:()=>(new Date).toISOString().substring(11),string_uuid:()=>"3fa85f64-5717-4562-b3fc-2c963f66afa6",string_hostname:()=>"example.com",string_ipv4:()=>"198.51.100.42",string_ipv6:()=>"2001:0db8:5b96:0000:0000:426f:8e17:642a",number:()=>0,number_float:()=>0,integer:()=>0,boolean:s=>"boolean"!=typeof s.default||s.default},primitive=s=>{s=objectify(s);let{type:o,format:i}=s,a=fs[`${o}_${i}`]||fs[o];return isFunc(a)?a(s):"Unknown Type: "+s.type},sanitizeRef=s=>deeplyStripKey(s,"$$ref",(s=>"string"==typeof s&&s.indexOf("#")>-1)),ms=["maxProperties","minProperties"],gs=["minItems","maxItems"],ys=["minimum","maximum","exclusiveMinimum","exclusiveMaximum"],vs=["minLength","maxLength"],mergeJsonSchema=(s,o,i={})=>{const a={...s};if(["example","default","enum","xml","type",...ms,...gs,...ys,...vs].forEach((s=>(s=>{void 0===a[s]&&void 0!==o[s]&&(a[s]=o[s])})(s))),void 0!==o.required&&Array.isArray(o.required)&&(void 0!==a.required&&a.required.length||(a.required=[]),o.required.forEach((s=>{a.required.includes(s)||a.required.push(s)}))),o.properties){a.properties||(a.properties={});let s=objectify(o.properties);for(let u in s)Object.prototype.hasOwnProperty.call(s,u)&&(s[u]&&s[u].deprecated||s[u]&&s[u].readOnly&&!i.includeReadOnly||s[u]&&s[u].writeOnly&&!i.includeWriteOnly||a.properties[u]||(a.properties[u]=s[u],!o.required&&Array.isArray(o.required)&&-1!==o.required.indexOf(u)&&(a.required?a.required.push(u):a.required=[u])))}return o.items&&(a.items||(a.items={}),a.items=mergeJsonSchema(a.items,o.items,i)),a},sampleFromSchemaGeneric=(s,o={},i=void 0,a=!1)=>{s&&isFunc(s.toJS)&&(s=s.toJS());let u=void 0!==i||s&&void 0!==s.example||s&&void 0!==s.default;const _=!u&&s&&s.oneOf&&s.oneOf.length>0,w=!u&&s&&s.anyOf&&s.anyOf.length>0;if(!u&&(_||w)){const i=objectify(_?s.oneOf[0]:s.anyOf[0]);if(!(s=mergeJsonSchema(s,i,o)).xml&&i.xml&&(s.xml=i.xml),void 0!==s.example&&void 0!==i.example)u=!0;else if(i.properties){s.properties||(s.properties={});let a=objectify(i.properties);for(let u in a)Object.prototype.hasOwnProperty.call(a,u)&&(a[u]&&a[u].deprecated||a[u]&&a[u].readOnly&&!o.includeReadOnly||a[u]&&a[u].writeOnly&&!o.includeWriteOnly||s.properties[u]||(s.properties[u]=a[u],!i.required&&Array.isArray(i.required)&&-1!==i.required.indexOf(u)&&(s.required?s.required.push(u):s.required=[u])))}}const x={};let{xml:C,type:j,example:L,properties:B,additionalProperties:$,items:U}=s||{},{includeReadOnly:V,includeWriteOnly:z}=o;C=C||{};let Y,{name:Z,prefix:ee,namespace:ie}=C,ae={};if(a&&(Z=Z||"notagname",Y=(ee?ee+":":"")+Z,ie)){x[ee?"xmlns:"+ee:"xmlns"]=ie}a&&(ae[Y]=[]);const schemaHasAny=o=>o.some((o=>Object.prototype.hasOwnProperty.call(s,o)));s&&!j&&(B||$||schemaHasAny(ms)?j="object":U||schemaHasAny(gs)?j="array":schemaHasAny(ys)?(j="number",s.type="number"):u||s.enum||(j="string",s.type="string"));const handleMinMaxItems=o=>{if(null!=s?.maxItems&&(o=o.slice(0,s?.maxItems)),null!=s?.minItems){let i=0;for(;o.length<s?.minItems;)o.push(o[i++%o.length])}return o},ce=objectify(B);let le,pe=0;const hasExceededMaxProperties=()=>s&&null!==s.maxProperties&&void 0!==s.maxProperties&&pe>=s.maxProperties,canAddProperty=o=>!s||null===s.maxProperties||void 0===s.maxProperties||!hasExceededMaxProperties()&&(!(o=>!(s&&s.required&&s.required.length&&s.required.includes(o)))(o)||s.maxProperties-pe-(()=>{if(!s||!s.required)return 0;let o=0;return a?s.required.forEach((s=>o+=void 0===ae[s]?0:1)):s.required.forEach((s=>o+=void 0===ae[Y]?.find((o=>void 0!==o[s]))?0:1)),s.required.length-o})()>0);if(le=a?(i,u=void 0)=>{if(s&&ce[i]){if(ce[i].xml=ce[i].xml||{},ce[i].xml.attribute){const s=Array.isArray(ce[i].enum)?ce[i].enum[0]:void 0,o=ce[i].example,a=ce[i].default;return void(x[ce[i].xml.name||i]=void 0!==o?o:void 0!==a?a:void 0!==s?s:primitive(ce[i]))}ce[i].xml.name=ce[i].xml.name||i}else ce[i]||!1===$||(ce[i]={xml:{name:i}});let _=sampleFromSchemaGeneric(s&&ce[i]||void 0,o,u,a);canAddProperty(i)&&(pe++,Array.isArray(_)?ae[Y]=ae[Y].concat(_):ae[Y].push(_))}:(i,u)=>{if(canAddProperty(i)){if(Object.prototype.hasOwnProperty.call(s,"discriminator")&&s.discriminator&&Object.prototype.hasOwnProperty.call(s.discriminator,"mapping")&&s.discriminator.mapping&&Object.prototype.hasOwnProperty.call(s,"$$ref")&&s.$$ref&&s.discriminator.propertyName===i){for(let o in s.discriminator.mapping)if(-1!==s.$$ref.search(s.discriminator.mapping[o])){ae[i]=o;break}}else ae[i]=sampleFromSchemaGeneric(ce[i],o,u,a);pe++}},u){let u;if(u=sanitizeRef(void 0!==i?i:void 0!==L?L:s.default),!a){if("number"==typeof u&&"string"===j)return`${u}`;if("string"!=typeof u||"string"===j)return u;try{return JSON.parse(u)}catch(s){return u}}if(s||(j=Array.isArray(u)?"array":typeof u),"array"===j){if(!Array.isArray(u)){if("string"==typeof u)return u;u=[u]}const i=s?s.items:void 0;i&&(i.xml=i.xml||C||{},i.xml.name=i.xml.name||C.name);let _=u.map((s=>sampleFromSchemaGeneric(i,o,s,a)));return _=handleMinMaxItems(_),C.wrapped?(ae[Y]=_,ds()(x)||ae[Y].push({_attr:x})):ae=_,ae}if("object"===j){if("string"==typeof u)return u;for(let o in u)Object.prototype.hasOwnProperty.call(u,o)&&(s&&ce[o]&&ce[o].readOnly&&!V||s&&ce[o]&&ce[o].writeOnly&&!z||(s&&ce[o]&&ce[o].xml&&ce[o].xml.attribute?x[ce[o].xml.name||o]=u[o]:le(o,u[o])));return ds()(x)||ae[Y].push({_attr:x}),ae}return ae[Y]=ds()(x)?u:[{_attr:x},u],ae}if("object"===j){for(let s in ce)Object.prototype.hasOwnProperty.call(ce,s)&&(ce[s]&&ce[s].deprecated||ce[s]&&ce[s].readOnly&&!V||ce[s]&&ce[s].writeOnly&&!z||le(s));if(a&&x&&ae[Y].push({_attr:x}),hasExceededMaxProperties())return ae;if(!0===$)a?ae[Y].push({additionalProp:"Anything can be here"}):ae.additionalProp1={},pe++;else if($){const i=objectify($),u=sampleFromSchemaGeneric(i,o,void 0,a);if(a&&i.xml&&i.xml.name&&"notagname"!==i.xml.name)ae[Y].push(u);else{const o=i["x-additionalPropertiesName"]||"additionalProp",_=null!==s.minProperties&&void 0!==s.minProperties&&pe<s.minProperties?s.minProperties-pe:3;for(let s=1;s<=_;s++){if(hasExceededMaxProperties())return ae;if(a){const i={};i[o+s]=u.notagname,ae[Y].push(i)}else ae[o+s]=u;pe++}}}return ae}if("array"===j){if(!U)return;let i;if(a&&(U.xml=U.xml||s?.xml||{},U.xml.name=U.xml.name||C.name),Array.isArray(U.anyOf))i=U.anyOf.map((s=>sampleFromSchemaGeneric(mergeJsonSchema(s,U,o),o,void 0,a)));else if(Array.isArray(U.oneOf))i=U.oneOf.map((s=>sampleFromSchemaGeneric(mergeJsonSchema(s,U,o),o,void 0,a)));else{if(!(!a||a&&C.wrapped))return sampleFromSchemaGeneric(U,o,void 0,a);i=[sampleFromSchemaGeneric(U,o,void 0,a)]}return i=handleMinMaxItems(i),a&&C.wrapped?(ae[Y]=i,ds()(x)||ae[Y].push({_attr:x}),ae):i}let de;if(s&&Array.isArray(s.enum))de=normalizeArray(s.enum)[0];else{if(!s)return;if(de=primitive(s),"number"==typeof de){let o=s.minimum;null!=o&&(s.exclusiveMinimum&&o++,de=o);let i=s.maximum;null!=i&&(s.exclusiveMaximum&&i--,de=i)}if("string"==typeof de&&(null!==s.maxLength&&void 0!==s.maxLength&&(de=de.slice(0,s.maxLength)),null!==s.minLength&&void 0!==s.minLength)){let o=0;for(;de.length<s.minLength;)de+=de[o++%de.length]}}if("file"!==j)return a?(ae[Y]=ds()(x)?de:[{_attr:x},de],ae):de},inferSchema=s=>(s.schema&&(s=s.schema),s.properties&&(s.type="object"),s),createXMLExample=(s,o,i)=>{const a=sampleFromSchemaGeneric(s,o,i,!0);if(a)return"string"==typeof a?a:ls()(a,{declaration:!0,indent:"\t"})},sampleFromSchema=(s,o,i)=>sampleFromSchemaGeneric(s,o,i,!1),resolver=(s,o,i)=>[s,JSON.stringify(o),JSON.stringify(i)],bs=utils_memoizeN(createXMLExample,resolver),Ss=utils_memoizeN(sampleFromSchema,resolver),getSchemaObjectType=s=>immutableToJS(s)?.type??"string",_s=[{when:/json/,shouldStringifyTypes:["string"]}],Es=["object"],get_json_sample_schema=s=>(o,i,a,u)=>{const{fn:_}=s(),w=_.memoizedSampleFromSchema(o,i,u),x=typeof w,C=_s.reduce(((s,o)=>o.when.test(a)?[...s,...o.shouldStringifyTypes]:s),Es);return gt()(C,(s=>s===x))?JSON.stringify(w,null,2):w},get_yaml_sample_schema=s=>(o,i,a,u)=>{const{fn:_}=s(),w=_.getJsonSampleSchema(o,i,a,u);let x;try{x=fn.dump(fn.load(w),{lineWidth:-1},{schema:rn}),"\n"===x[x.length-1]&&(x=x.slice(0,x.length-1))}catch(s){return console.error(s),"error: could not generate yaml example"}return x.replace(/\t/g,"  ")},get_xml_sample_schema=s=>(o,i,a)=>{const{fn:u}=s();if(o&&!o.xml&&(o.xml={}),o&&!o.xml.name){if(!o.$$ref&&(o.type||o.items||o.properties||o.additionalProperties))return'<?xml version="1.0" encoding="UTF-8"?>\n\x3c!-- XML example cannot be generated; root element name is undefined --\x3e';if(o.$$ref){let s=o.$$ref.match(/\S*\/(\S+)$/);o.xml.name=s[1]}}return u.memoizedCreateXMLExample(o,i,a)},get_sample_schema=s=>(o,i="",a={},u=void 0)=>{const{fn:_}=s();return"function"==typeof u?.toJS&&(u=u.toJS()),/xml/.test(i)?("function"==typeof o?.toJS&&(o=o.toJS()),_.getXmlSampleSchema(o,a,u)):/(yaml|yml)/.test(i)?_.getYamlSampleSchema(o,a,i,u):_.getJsonSampleSchema(o,a,i,u)},json_schema_5_samples=({getSystem:s})=>{const o=get_json_sample_schema(s),i=get_yaml_sample_schema(s),a=get_xml_sample_schema(s),u=get_sample_schema(s);return{fn:{jsonSchema5:{inferSchema,sampleFromSchema,sampleFromSchemaGeneric,createXMLExample,memoizedSampleFromSchema:Ss,memoizedCreateXMLExample:bs,getJsonSampleSchema:o,getYamlSampleSchema:i,getXmlSampleSchema:a,getSampleSchema:u,mergeJsonSchema},inferSchema,sampleFromSchema,sampleFromSchemaGeneric,createXMLExample,memoizedSampleFromSchema:Ss,memoizedCreateXMLExample:bs,getJsonSampleSchema:o,getYamlSampleSchema:i,getXmlSampleSchema:a,getSampleSchema:u,mergeJsonSchema,getSchemaObjectType}}};var ws=__webpack_require__(37334),xs=__webpack_require__.n(ws);const ks=["get","put","post","delete","options","head","patch","trace","query"],spec_selectors_state=s=>s||(0,ze.Map)(),Os=Ut(spec_selectors_state,(s=>s.get("lastError"))),As=Ut(spec_selectors_state,(s=>s.get("url"))),Cs=Ut(spec_selectors_state,(s=>s.get("spec")||"")),js=Ut(spec_selectors_state,(s=>s.get("specSource")||"not-editor")),Ps=Ut(spec_selectors_state,(s=>s.get("json",(0,ze.Map)()))),Is=Ut(Ps,(s=>s.toJS())),Ts=Ut(spec_selectors_state,(s=>s.get("resolved",(0,ze.Map)()))),specResolvedSubtree=(s,o)=>s.getIn(["resolvedSubtrees",...o],void 0),mergerFn=(s,o)=>ze.Map.isMap(s)&&ze.Map.isMap(o)?o.get("$$ref")?o:(0,ze.OrderedMap)().mergeWith(mergerFn,s,o):o,Ns=Ut(spec_selectors_state,(s=>(0,ze.OrderedMap)().mergeWith(mergerFn,s.get("json"),s.get("resolvedSubtrees")))),spec=s=>Ps(s),Ms=Ut(spec,(()=>!1)),Rs=Ut(spec,(s=>returnSelfOrNewMap(s&&s.get("info")))),Ds=Ut(spec,(s=>returnSelfOrNewMap(s&&s.get("externalDocs")))),Ls=Ut(Rs,(s=>s&&s.get("version"))),Fs=Ut(Ls,(s=>/v?([0-9]*)\.([0-9]*)\.([0-9]*)/i.exec(s).slice(1))),Bs=Ut(Ns,(s=>s.get("paths"))),$s=xs()(["get","put","post","delete","options","head","patch"]),qs=Ut(Bs,(s=>{let o=(0,ze.List)();return!ze.Map.isMap(s)||s.isEmpty()||s.forEach(((s,i)=>{if(!s||!s.forEach)return{};s.forEach(((s,a)=>{ks.indexOf(a)<0||(o=o.push((0,ze.fromJS)({path:i,method:a,operation:s,id:`${a}-${i}`,specPath:["paths",i,a]})))}))})),o})),Us=Ut(spec,(s=>(0,ze.Set)(s.get("consumes")))),Vs=Ut(spec,(s=>(0,ze.Set)(s.get("produces")))),zs=Ut(spec,(s=>s.get("security",(0,ze.List)()))),Ws=Ut(spec,(s=>s.get("securityDefinitions"))),findDefinition=(s,o)=>{const i=s.getIn(["resolvedSubtrees","definitions",o],null),a=s.getIn(["json","definitions",o],null);return i||a||null},Js=Ut(spec,(s=>{const o=s.get("definitions");return ze.Map.isMap(o)?o:(0,ze.Map)()})),Hs=Ut(spec,(s=>s.get("basePath"))),Ks=Ut(spec,(s=>s.get("host"))),Gs=Ut(spec,(s=>s.get("schemes",(0,ze.Map)()))),Ys=Ut([qs,Us,Vs],((s,o,i)=>s.map((s=>s.update("operation",(s=>ze.Map.isMap(s)?s.withMutations((s=>(s.get("consumes")||s.update("consumes",(s=>(0,ze.Set)(s).merge(o))),s.get("produces")||s.update("produces",(s=>(0,ze.Set)(s).merge(i))),s))):(0,ze.Map)())))))),Xs=Ut(spec,(s=>{const o=s.get("tags",(0,ze.List)());return ze.List.isList(o)?o.filter((s=>ze.Map.isMap(s))):(0,ze.List)()})),tagDetails=(s,o)=>(Xs(s)||(0,ze.List)()).filter(ze.Map.isMap).find((s=>s.get("name")===o),(0,ze.Map)()),Qs=Ut(Ys,Xs,((s,o)=>s.reduce(((s,o)=>{let i=(0,ze.Set)(o.getIn(["operation","tags"]));return i.count()<1?s.update("default",(0,ze.List)(),(s=>s.push(o))):i.reduce(((s,i)=>s.update(i,(0,ze.List)(),(s=>s.push(o)))),s)}),o.reduce(((s,o)=>s.set(o.get("name"),(0,ze.List)())),(0,ze.OrderedMap)())))),selectors_taggedOperations=s=>({getConfigs:o})=>{let{tagsSorter:i,operationsSorter:a}=o();return Qs(s).sortBy(((s,o)=>o),((s,o)=>{let a="function"==typeof i?i:It.tagsSorter[i];return a?a(s,o):null})).map(((o,i)=>{let u="function"==typeof a?a:It.operationsSorter[a],_=u?o.sort(u):o;return(0,ze.Map)({tagDetails:tagDetails(s,i),operations:_})}))},Zs=Ut(spec_selectors_state,(s=>s.get("responses",(0,ze.Map)()))),eo=Ut(spec_selectors_state,(s=>s.get("requests",(0,ze.Map)()))),to=Ut(spec_selectors_state,(s=>s.get("mutatedRequests",(0,ze.Map)()))),responseFor=(s,o,i)=>Zs(s).getIn([o,i],null),requestFor=(s,o,i)=>eo(s).getIn([o,i],null),mutatedRequestFor=(s,o,i)=>to(s).getIn([o,i],null),allowTryItOutFor=()=>!0,parameterWithMetaByIdentity=(s,o,i)=>{const a=Ns(s).getIn(["paths",...o,"parameters"],(0,ze.OrderedMap)()),u=s.getIn(["meta","paths",...o,"parameters"],(0,ze.OrderedMap)());return a.map((s=>{const o=u.get(`${i.get("in")}.${i.get("name")}`),a=u.get(`${i.get("in")}.${i.get("name")}.hash-${i.hashCode()}`);return(0,ze.OrderedMap)().merge(s,o,a)})).find((s=>s.get("in")===i.get("in")&&s.get("name")===i.get("name")),(0,ze.OrderedMap)())},parameterInclusionSettingFor=(s,o,i,a)=>{const u=`${a}.${i}`;return s.getIn(["meta","paths",...o,"parameter_inclusions",u],!1)},parameterWithMeta=(s,o,i,a)=>{const u=Ns(s).getIn(["paths",...o,"parameters"],(0,ze.OrderedMap)()).find((s=>s.get("in")===a&&s.get("name")===i),(0,ze.OrderedMap)());return parameterWithMetaByIdentity(s,o,u)},operationWithMeta=(s,o,i)=>{const a=Ns(s).getIn(["paths",o,i],(0,ze.OrderedMap)()),u=s.getIn(["meta","paths",o,i],(0,ze.OrderedMap)()),_=a.get("parameters",(0,ze.List)()).map((a=>parameterWithMetaByIdentity(s,[o,i],a)));return(0,ze.OrderedMap)().merge(a,u).set("parameters",_)};function getParameter(s,o,i,a){return o=o||[],s.getIn(["meta","paths",...o,"parameters"],(0,ze.fromJS)([])).find((s=>ze.Map.isMap(s)&&s.get("name")===i&&s.get("in")===a))||(0,ze.Map)()}const ro=Ut(spec,(s=>{const o=s.get("host");return"string"==typeof o&&o.length>0&&"/"!==o[0]}));function parameterValues(s,o,i){return o=o||[],operationWithMeta(s,...o).get("parameters",(0,ze.List)()).reduce(((s,o)=>{let a=i&&"body"===o.get("in")?o.get("value_xml"):o.get("value");return ze.List.isList(a)&&(a=a.filter((s=>""!==s))),s.set(paramToIdentifier(o,{allowHashes:!1}),a)}),(0,ze.fromJS)({}))}function parametersIncludeIn(s,o=""){if(ze.List.isList(s))return s.some((s=>ze.Map.isMap(s)&&s.get("in")===o))}function parametersIncludeType(s,o=""){if(ze.List.isList(s))return s.some((s=>ze.Map.isMap(s)&&s.get("type")===o))}function contentTypeValues(s,o){o=o||[];let i=Ns(s).getIn(["paths",...o],(0,ze.fromJS)({})),a=s.getIn(["meta","paths",...o],(0,ze.fromJS)({})),u=currentProducesFor(s,o);const _=i.get("parameters")||new ze.List,w=a.get("consumes_value")?a.get("consumes_value"):parametersIncludeType(_,"file")?"multipart/form-data":parametersIncludeType(_,"formData")?"application/x-www-form-urlencoded":void 0;return(0,ze.fromJS)({requestContentType:w,responseContentType:u})}function currentProducesFor(s,o){o=o||[];const i=Ns(s).getIn(["paths",...o],null);if(null===i)return;const a=s.getIn(["meta","paths",...o,"produces_value"],null),u=i.getIn(["produces",0],null);return a||u||"application/json"}function producesOptionsFor(s,o){o=o||[];const i=Ns(s),a=i.getIn(["paths",...o],null);if(null===a)return;const[u]=o,_=a.get("produces",null),w=i.getIn(["paths",u,"produces"],null),x=i.getIn(["produces"],null);return _||w||x}function consumesOptionsFor(s,o){o=o||[];const i=Ns(s),a=i.getIn(["paths",...o],null);if(null===a)return;const[u]=o,_=a.get("consumes",null),w=i.getIn(["paths",u,"consumes"],null),x=i.getIn(["consumes"],null);return _||w||x}const operationScheme=(s,o,i)=>{let a=s.get("url").match(/^([a-z][a-z0-9+\-.]*):/),u=Array.isArray(a)?a[1]:null;return s.getIn(["scheme",o,i])||s.getIn(["scheme","_defaultScheme"])||u||""},canExecuteScheme=(s,o,i)=>["http","https"].indexOf(operationScheme(s,o,i))>-1,validationErrors=(s,o)=>{o=o||[];const i=s.getIn(["meta","paths",...o,"parameters"],(0,ze.fromJS)([])),a=[];if(0===i.length)return a;const getErrorsWithPaths=(s,o=[])=>{const getNestedErrorsWithPaths=(s,o)=>{const i=[...o,s.get("propKey")||s.get("index")];return ze.Map.isMap(s.get("error"))?getErrorsWithPaths(s.get("error"),i):{error:s.get("error"),path:i}};return ze.List.isList(s)?s.map((s=>ze.Map.isMap(s)?getNestedErrorsWithPaths(s,o):{error:s,path:o})):getNestedErrorsWithPaths(s,o)};return i.forEach(((s,o)=>{const i=o.split(".").slice(1,-1).join("."),u=s.get("errors");if(u&&u.count()){getErrorsWithPaths(u).forEach((({error:s,path:o})=>{a.push(((s,o,i)=>`For '${i}'${(o=o.reduce(((s,o)=>"number"==typeof o?`${s}[${o}]`:s?`${s}.${o}`:o),""))?` at path '${o}'`:""}: ${s}.`)(s,o,i))}))}})),a},validateBeforeExecute=(s,o)=>0===validationErrors(s,o).length,getOAS3RequiredRequestBodyContentType=(s,o)=>{let i={requestBody:!1,requestContentType:{}},a=s.getIn(["resolvedSubtrees","paths",...o,"requestBody"],(0,ze.fromJS)([]));return a.size<1||(a.getIn(["required"])&&(i.requestBody=a.getIn(["required"])),a.getIn(["content"]).entrySeq().forEach((s=>{const o=s[0];if(s[1].getIn(["schema","required"])){const a=s[1].getIn(["schema","required"]).toJS();i.requestContentType[o]=a}}))),i},isMediaTypeSchemaPropertiesEqual=(s,o,i,a)=>{if((i||a)&&i===a)return!0;let u=s.getIn(["resolvedSubtrees","paths",...o,"requestBody","content"],(0,ze.fromJS)([]));if(u.size<2||!i||!a)return!1;let _=u.getIn([i,"schema","properties"],(0,ze.fromJS)([])),w=u.getIn([a,"schema","properties"],(0,ze.fromJS)([]));return!!_.equals(w)};function returnSelfOrNewMap(s){return ze.Map.isMap(s)?s:new ze.Map}var no=__webpack_require__(85015),so=__webpack_require__.n(no),oo=__webpack_require__(38221),io=__webpack_require__.n(oo),ao=__webpack_require__(63560),co=__webpack_require__.n(ao),lo=__webpack_require__(56367),uo=__webpack_require__.n(lo);const po="spec_update_spec",ho="spec_update_url",fo="spec_update_json",mo="spec_update_param",go="spec_update_empty_param_inclusion",yo="spec_validate_param",vo="spec_set_response",bo="spec_set_request",So="spec_set_mutated_request",_o="spec_log_request",Eo="spec_clear_response",wo="spec_clear_request",xo="spec_clear_validate_param",ko="spec_update_operation_meta_value",Oo="spec_update_resolved",Ao="spec_update_resolved_subtree",Co="set_scheme",toStr=s=>so()(s)?s:"";function updateSpec(s){const o=toStr(s).replace(/\t/g,"  ");if("string"==typeof s)return{type:po,payload:o}}function updateResolved(s){return{type:Oo,payload:s}}function updateUrl(s){return{type:ho,payload:s}}function updateJsonSpec(s){return{type:fo,payload:s}}const parseToJson=s=>({specActions:o,specSelectors:i,errActions:a})=>{let{specStr:u}=i,_=null;try{s=s||u(),a.clear({source:"parser"}),_=fn.load(s,{schema:rn})}catch(s){return console.error(s),a.newSpecErr({source:"parser",level:"error",message:s.reason,line:s.mark&&s.mark.line?s.mark.line+1:void 0})}return _&&"object"==typeof _?o.updateJsonSpec(_):o.updateJsonSpec({})};let jo=!1;const resolveSpec=(s,o)=>({specActions:i,specSelectors:a,errActions:u,fn:{fetch:_,resolve:w,AST:x={}},getConfigs:C})=>{jo||(console.warn("specActions.resolveSpec is deprecated since v3.10.0 and will be removed in v4.0.0; use requestResolvedSubtree instead!"),jo=!0);const{modelPropertyMacro:j,parameterMacro:L,requestInterceptor:B,responseInterceptor:$}=C();void 0===s&&(s=a.specJson()),void 0===o&&(o=a.url());let U=x.getLineNumberForPath?x.getLineNumberForPath:()=>{},V=a.specStr();return w({fetch:_,spec:s,baseDoc:String(new URL(o,document.baseURI)),modelPropertyMacro:j,parameterMacro:L,requestInterceptor:B,responseInterceptor:$}).then((({spec:s,errors:o})=>{if(u.clear({type:"thrown"}),Array.isArray(o)&&o.length>0){let s=o.map((s=>(console.error(s),s.line=s.fullPath?U(V,s.fullPath):null,s.path=s.fullPath?s.fullPath.join("."):null,s.level="error",s.type="thrown",s.source="resolver",Object.defineProperty(s,"message",{enumerable:!0,value:s.message}),s)));u.newThrownErrBatch(s)}return i.updateResolved(s)}))};let Po=[];const Io=io()((()=>{const s=Po.reduce(((s,{path:o,system:i})=>(s.has(i)||s.set(i,[]),s.get(i).push(o),s)),new Map);Po=[],s.forEach((async(s,o)=>{if(!o)return void console.error("debResolveSubtrees: don't have a system to operate on, aborting.");if(!o.fn.resolveSubtree)return void console.error("Error: Swagger-Client did not provide a `resolveSubtree` method, doing nothing.");const{errActions:i,errSelectors:a,fn:{resolveSubtree:u,fetch:_,AST:w={}},specSelectors:x,specActions:C}=o,j=w.getLineNumberForPath??xs()(void 0),L=x.specStr(),{modelPropertyMacro:B,parameterMacro:$,requestInterceptor:U,responseInterceptor:V}=o.getConfigs();try{const o=await s.reduce((async(s,o)=>{let{resultMap:w,specWithCurrentSubtrees:C}=await s;const{errors:z,spec:Y}=await u(C,o,{baseDoc:String(new URL(x.url(),document.baseURI)),modelPropertyMacro:B,parameterMacro:$,requestInterceptor:U,responseInterceptor:V});if(a.allErrors().size&&i.clearBy((s=>"thrown"!==s.get("type")||"resolver"!==s.get("source")||!s.get("fullPath")?.every(((s,i)=>s===o[i]||void 0===o[i])))),Array.isArray(z)&&z.length>0){let s=z.map((s=>(s.line=s.fullPath?j(L,s.fullPath):null,s.path=s.fullPath?s.fullPath.join("."):null,s.level="error",s.type="thrown",s.source="resolver",Object.defineProperty(s,"message",{enumerable:!0,value:s.message}),s)));i.newThrownErrBatch(s)}return Y&&x.isOAS3()&&"components"===o[0]&&"securitySchemes"===o[1]&&await Promise.all(Object.values(Y).filter((s=>"openIdConnect"===s?.type)).map((async s=>{const o={url:s.openIdConnectUrl,requestInterceptor:U,responseInterceptor:V};try{const i=await _(o);i instanceof Error||i.status>=400?console.error(i.statusText+" "+o.url):s.openIdConnectData=JSON.parse(i.text)}catch(s){console.error(s)}}))),co()(w,o,Y),C=uo()(o,Y,C),{resultMap:w,specWithCurrentSubtrees:C}}),Promise.resolve({resultMap:(x.specResolvedSubtree([])||(0,ze.Map)()).toJS(),specWithCurrentSubtrees:x.specJS()}));C.updateResolvedSubtree([],o.resultMap)}catch(s){console.error(s)}}))}),35),requestResolvedSubtree=s=>o=>{Po.find((({path:i,system:a})=>a===o&&i.toString()===s.toString()))||(Po.push({path:s,system:o}),Io())};function changeParam(s,o,i,a,u){return{type:mo,payload:{path:s,value:a,paramName:o,paramIn:i,isXml:u}}}function changeParamByIdentity(s,o,i,a){return{type:mo,payload:{path:s,param:o,value:i,isXml:a}}}const updateResolvedSubtree=(s,o)=>({type:Ao,payload:{path:s,value:o}}),invalidateResolvedSubtreeCache=()=>({type:Ao,payload:{path:[],value:(0,ze.Map)()}}),validateParams=(s,o)=>({type:yo,payload:{pathMethod:s,isOAS3:o}}),updateEmptyParamInclusion=(s,o,i,a)=>({type:go,payload:{pathMethod:s,paramName:o,paramIn:i,includeEmptyValue:a}});function clearValidateParams(s){return{type:xo,payload:{pathMethod:s}}}function changeConsumesValue(s,o){return{type:ko,payload:{path:s,value:o,key:"consumes_value"}}}function changeProducesValue(s,o){return{type:ko,payload:{path:s,value:o,key:"produces_value"}}}const setResponse=(s,o,i)=>({payload:{path:s,method:o,res:i},type:vo}),setRequest=(s,o,i)=>({payload:{path:s,method:o,req:i},type:bo}),setMutatedRequest=(s,o,i)=>({payload:{path:s,method:o,req:i},type:So}),logRequest=s=>({payload:s,type:_o}),executeRequest=s=>({fn:o,specActions:i,specSelectors:a,getConfigs:u,oas3Selectors:_})=>{let{pathName:w,method:x,operation:C}=s,{requestInterceptor:j,responseInterceptor:L}=u(),B=C.toJS();if(C&&C.get("parameters")&&C.get("parameters").filter((s=>s&&!0===s.get("allowEmptyValue"))).forEach((o=>{if(a.parameterInclusionSettingFor([w,x],o.get("name"),o.get("in"))){s.parameters=s.parameters||{};const i=paramToValue(o,s.parameters);(!i||i&&0===i.size)&&(s.parameters[o.get("name")]="")}})),s.contextUrl=Nt()(a.url()).toString(),B&&B.operationId?s.operationId=B.operationId:B&&w&&x&&(s.operationId=o.opId(B,w,x)),a.isOAS3()){const o=`${w}:${x}`;s.server=_.selectedServer(o)||_.selectedServer();const i=_.serverVariables({server:s.server,namespace:o}).toJS(),a=_.serverVariables({server:s.server}).toJS();s.serverVariables=Object.keys(i).length?i:a,s.requestContentType=_.requestContentType(w,x),s.responseContentType=_.responseContentType(w,x)||"*/*";const u=_.requestBodyValue(w,x),C=_.requestBodyInclusionSetting(w,x);u&&u.toJS?s.requestBody=u.map((s=>ze.Map.isMap(s)?s.get("value"):s)).filter(((s,o)=>(Array.isArray(s)?0!==s.length:!isEmptyValue(s))||C.get(o))).toJS():s.requestBody=u}let $=Object.assign({},s);$=o.buildRequest($),i.setRequest(s.pathName,s.method,$);s.requestInterceptor=async o=>{let a=await j.apply(void 0,[o]),u=Object.assign({},a);return i.setMutatedRequest(s.pathName,s.method,u),a},s.responseInterceptor=L;const U=Date.now();return o.execute(s).then((o=>{o.duration=Date.now()-U,i.setResponse(s.pathName,s.method,o)})).catch((o=>{"Failed to fetch"===o.message&&(o.name="",o.message='**Failed to fetch.**  \n**Possible Reasons:** \n  - CORS \n  - Network Failure \n  - URL scheme must be "http" or "https" for CORS request.'),i.setResponse(s.pathName,s.method,{error:!0,err:o})}))},actions_execute=({path:s,method:o,...i}={})=>a=>{let{fn:{fetch:u},specSelectors:_,specActions:w}=a,x=_.specJsonWithResolvedSubtrees().toJS(),C=_.operationScheme(s,o),{requestContentType:j,responseContentType:L}=_.contentTypeValues([s,o]).toJS(),B=/xml/i.test(j),$=_.parameterValues([s,o],B).toJS();return w.executeRequest({...i,fetch:u,spec:x,pathName:s,method:o,parameters:$,requestContentType:j,scheme:C,responseContentType:L})};function clearResponse(s,o){return{type:Eo,payload:{path:s,method:o}}}function clearRequest(s,o){return{type:wo,payload:{path:s,method:o}}}function setScheme(s,o,i){return{type:Co,payload:{scheme:s,path:o,method:i}}}const To={[po]:(s,o)=>"string"==typeof o.payload?s.set("spec",o.payload):s,[ho]:(s,o)=>s.set("url",o.payload+""),[fo]:(s,o)=>s.set("json",fromJSOrdered(o.payload)),[Oo]:(s,o)=>s.setIn(["resolved"],fromJSOrdered(o.payload)),[Ao]:(s,o)=>{const{value:i,path:a}=o.payload;return s.setIn(["resolvedSubtrees",...a],fromJSOrdered(i))},[mo]:(s,{payload:o})=>{let{path:i,paramName:a,paramIn:u,param:_,value:w,isXml:x}=o,C=_?paramToIdentifier(_):`${u}.${a}`;const j=x?"value_xml":"value";return s.setIn(["meta","paths",...i,"parameters",C,j],(0,ze.fromJS)(w))},[go]:(s,{payload:o})=>{let{pathMethod:i,paramName:a,paramIn:u,includeEmptyValue:_}=o;if(!a||!u)return console.warn("Warning: UPDATE_EMPTY_PARAM_INCLUSION could not generate a paramKey."),s;const w=`${u}.${a}`;return s.setIn(["meta","paths",...i,"parameter_inclusions",w],_)},[yo]:(s,{payload:{pathMethod:o,isOAS3:i}})=>{const a=Ns(s).getIn(["paths",...o]),u=parameterValues(s,o).toJS();return s.updateIn(["meta","paths",...o,"parameters"],(0,ze.fromJS)({}),(_=>a.get("parameters",(0,ze.List)()).reduce(((a,_)=>{const w=paramToValue(_,u),x=parameterInclusionSettingFor(s,o,_.get("name"),_.get("in")),C=((s,o,{isOAS3:i=!1,bypassRequiredCheck:a=!1}={})=>{let u=s.get("required"),{schema:_,parameterContentMediaType:w}=getParameterSchema(s,{isOAS3:i});return validateValueBySchema(o,_,u,a,w,i)})(_,w,{bypassRequiredCheck:x,isOAS3:i});return a.setIn([paramToIdentifier(_),"errors"],(0,ze.fromJS)(C))}),_)))},[xo]:(s,{payload:{pathMethod:o}})=>s.updateIn(["meta","paths",...o,"parameters"],(0,ze.fromJS)([]),(s=>s.map((s=>s.set("errors",(0,ze.fromJS)([])))))),[vo]:(s,{payload:{res:o,path:i,method:a}})=>{let u;u=o.error?Object.assign({error:!0,name:o.err.name,message:o.err.message,statusCode:o.err.statusCode},o.err.response):o,u.headers=u.headers||{};let _=s.setIn(["responses",i,a],fromJSOrdered(u));return lt.Blob&&u.data instanceof lt.Blob&&(_=_.setIn(["responses",i,a,"text"],u.data)),_},[bo]:(s,{payload:{req:o,path:i,method:a}})=>s.setIn(["requests",i,a],fromJSOrdered(o)),[So]:(s,{payload:{req:o,path:i,method:a}})=>s.setIn(["mutatedRequests",i,a],fromJSOrdered(o)),[ko]:(s,{payload:{path:o,value:i,key:a}})=>{let u=["paths",...o],_=["meta","paths",...o];return s.getIn(["json",...u])||s.getIn(["resolved",...u])||s.getIn(["resolvedSubtrees",...u])?s.setIn([..._,a],(0,ze.fromJS)(i)):s},[Eo]:(s,{payload:{path:o,method:i}})=>s.deleteIn(["responses",o,i]),[wo]:(s,{payload:{path:o,method:i}})=>s.deleteIn(["requests",o,i]),[Co]:(s,{payload:{scheme:o,path:i,method:a}})=>i&&a?s.setIn(["scheme",i,a],o):i||a?void 0:s.setIn(["scheme","_defaultScheme"],o)},wrap_actions_updateSpec=(s,{specActions:o})=>(...i)=>{s(...i),o.parseToJson(...i)},wrap_actions_updateJsonSpec=(s,{specActions:o})=>(...i)=>{s(...i),o.invalidateResolvedSubtreeCache();const[a]=i,u=Cn()(a,["paths"])||{};Object.keys(u).forEach((s=>{const i=Cn()(u,[s]);as()(i)&&i.$ref&&o.requestResolvedSubtree(["paths",s])})),o.requestResolvedSubtree(["components","securitySchemes"])},wrap_actions_executeRequest=(s,{specActions:o})=>i=>(o.logRequest(i),s(i)),wrap_actions_validateParams=(s,{specSelectors:o})=>i=>s(i,o.isOAS3()),plugins_spec=()=>({statePlugins:{spec:{wrapActions:{...Y},reducers:{...To},actions:{...z},selectors:{...V}}}});var No=function(){var extendStatics=function(s,o){return extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(s,o){s.__proto__=o}||function(s,o){for(var i in o)o.hasOwnProperty(i)&&(s[i]=o[i])},extendStatics(s,o)};return function(s,o){function __(){this.constructor=s}extendStatics(s,o),s.prototype=null===o?Object.create(o):(__.prototype=o.prototype,new __)}}(),Mo=Object.prototype.hasOwnProperty;function module_helpers_hasOwnProperty(s,o){return Mo.call(s,o)}function _objectKeys(s){if(Array.isArray(s)){for(var o=new Array(s.length),i=0;i<o.length;i++)o[i]=""+i;return o}if(Object.keys)return Object.keys(s);var a=[];for(var u in s)module_helpers_hasOwnProperty(s,u)&&a.push(u);return a}function _deepClone(s){switch(typeof s){case"object":return JSON.parse(JSON.stringify(s));case"undefined":return null;default:return s}}function helpers_isInteger(s){for(var o,i=0,a=s.length;i<a;){if(!((o=s.charCodeAt(i))>=48&&o<=57))return!1;i++}return!0}function escapePathComponent(s){return-1===s.indexOf("/")&&-1===s.indexOf("~")?s:s.replace(/~/g,"~0").replace(/\//g,"~1")}function unescapePathComponent(s){return s.replace(/~1/g,"/").replace(/~0/g,"~")}function hasUndefined(s){if(void 0===s)return!0;if(s)if(Array.isArray(s)){for(var o=0,i=s.length;o<i;o++)if(hasUndefined(s[o]))return!0}else if("object"==typeof s)for(var a=_objectKeys(s),u=a.length,_=0;_<u;_++)if(hasUndefined(s[a[_]]))return!0;return!1}function patchErrorMessageFormatter(s,o){var i=[s];for(var a in o){var u="object"==typeof o[a]?JSON.stringify(o[a],null,2):o[a];void 0!==u&&i.push(a+": "+u)}return i.join("\n")}var Ro=function(s){function PatchError(o,i,a,u,_){var w=this.constructor,x=s.call(this,patchErrorMessageFormatter(o,{name:i,index:a,operation:u,tree:_}))||this;return x.name=i,x.index=a,x.operation=u,x.tree=_,Object.setPrototypeOf(x,w.prototype),x.message=patchErrorMessageFormatter(o,{name:i,index:a,operation:u,tree:_}),x}return No(PatchError,s),PatchError}(Error),Do=Ro,Lo=_deepClone,Fo={add:function(s,o,i){return s[o]=this.value,{newDocument:i}},remove:function(s,o,i){var a=s[o];return delete s[o],{newDocument:i,removed:a}},replace:function(s,o,i){var a=s[o];return s[o]=this.value,{newDocument:i,removed:a}},move:function(s,o,i){var a=getValueByPointer(i,this.path);a&&(a=_deepClone(a));var u=applyOperation(i,{op:"remove",path:this.from}).removed;return applyOperation(i,{op:"add",path:this.path,value:u}),{newDocument:i,removed:a}},copy:function(s,o,i){var a=getValueByPointer(i,this.from);return applyOperation(i,{op:"add",path:this.path,value:_deepClone(a)}),{newDocument:i}},test:function(s,o,i){return{newDocument:i,test:_areEquals(s[o],this.value)}},_get:function(s,o,i){return this.value=s[o],{newDocument:i}}},Bo={add:function(s,o,i){return helpers_isInteger(o)?s.splice(o,0,this.value):s[o]=this.value,{newDocument:i,index:o}},remove:function(s,o,i){return{newDocument:i,removed:s.splice(o,1)[0]}},replace:function(s,o,i){var a=s[o];return s[o]=this.value,{newDocument:i,removed:a}},move:Fo.move,copy:Fo.copy,test:Fo.test,_get:Fo._get};function getValueByPointer(s,o){if(""==o)return s;var i={op:"_get",path:o};return applyOperation(s,i),i.value}function applyOperation(s,o,i,a,u,_){if(void 0===i&&(i=!1),void 0===a&&(a=!0),void 0===u&&(u=!0),void 0===_&&(_=0),i&&("function"==typeof i?i(o,0,s,o.path):validator(o,0)),""===o.path){var w={newDocument:s};if("add"===o.op)return w.newDocument=o.value,w;if("replace"===o.op)return w.newDocument=o.value,w.removed=s,w;if("move"===o.op||"copy"===o.op)return w.newDocument=getValueByPointer(s,o.from),"move"===o.op&&(w.removed=s),w;if("test"===o.op){if(w.test=_areEquals(s,o.value),!1===w.test)throw new Do("Test operation failed","TEST_OPERATION_FAILED",_,o,s);return w.newDocument=s,w}if("remove"===o.op)return w.removed=s,w.newDocument=null,w;if("_get"===o.op)return o.value=s,w;if(i)throw new Do("Operation `op` property is not one of operations defined in RFC-6902","OPERATION_OP_INVALID",_,o,s);return w}a||(s=_deepClone(s));var x=(o.path||"").split("/"),C=s,j=1,L=x.length,B=void 0,$=void 0,U=void 0;for(U="function"==typeof i?i:validator;;){if(($=x[j])&&-1!=$.indexOf("~")&&($=unescapePathComponent($)),u&&("__proto__"==$||"prototype"==$&&j>0&&"constructor"==x[j-1]))throw new TypeError("JSON-Patch: modifying `__proto__` or `constructor/prototype` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README");if(i&&void 0===B&&(void 0===C[$]?B=x.slice(0,j).join("/"):j==L-1&&(B=o.path),void 0!==B&&U(o,0,s,B)),j++,Array.isArray(C)){if("-"===$)$=C.length;else{if(i&&!helpers_isInteger($))throw new Do("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index","OPERATION_PATH_ILLEGAL_ARRAY_INDEX",_,o,s);helpers_isInteger($)&&($=~~$)}if(j>=L){if(i&&"add"===o.op&&$>C.length)throw new Do("The specified index MUST NOT be greater than the number of elements in the array","OPERATION_VALUE_OUT_OF_BOUNDS",_,o,s);if(!1===(w=Bo[o.op].call(o,C,$,s)).test)throw new Do("Test operation failed","TEST_OPERATION_FAILED",_,o,s);return w}}else if(j>=L){if(!1===(w=Fo[o.op].call(o,C,$,s)).test)throw new Do("Test operation failed","TEST_OPERATION_FAILED",_,o,s);return w}if(C=C[$],i&&j<L&&(!C||"object"!=typeof C))throw new Do("Cannot perform operation at the desired path","OPERATION_PATH_UNRESOLVABLE",_,o,s)}}function applyPatch(s,o,i,a,u){if(void 0===a&&(a=!0),void 0===u&&(u=!0),i&&!Array.isArray(o))throw new Do("Patch sequence must be an array","SEQUENCE_NOT_AN_ARRAY");a||(s=_deepClone(s));for(var _=new Array(o.length),w=0,x=o.length;w<x;w++)_[w]=applyOperation(s,o[w],i,!0,u,w),s=_[w].newDocument;return _.newDocument=s,_}function applyReducer(s,o,i){var a=applyOperation(s,o);if(!1===a.test)throw new Do("Test operation failed","TEST_OPERATION_FAILED",i,o,s);return a.newDocument}function validator(s,o,i,a){if("object"!=typeof s||null===s||Array.isArray(s))throw new Do("Operation is not an object","OPERATION_NOT_AN_OBJECT",o,s,i);if(!Fo[s.op])throw new Do("Operation `op` property is not one of operations defined in RFC-6902","OPERATION_OP_INVALID",o,s,i);if("string"!=typeof s.path)throw new Do("Operation `path` property is not a string","OPERATION_PATH_INVALID",o,s,i);if(0!==s.path.indexOf("/")&&s.path.length>0)throw new Do('Operation `path` property must start with "/"',"OPERATION_PATH_INVALID",o,s,i);if(("move"===s.op||"copy"===s.op)&&"string"!=typeof s.from)throw new Do("Operation `from` property is not present (applicable in `move` and `copy` operations)","OPERATION_FROM_REQUIRED",o,s,i);if(("add"===s.op||"replace"===s.op||"test"===s.op)&&void 0===s.value)throw new Do("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)","OPERATION_VALUE_REQUIRED",o,s,i);if(("add"===s.op||"replace"===s.op||"test"===s.op)&&hasUndefined(s.value))throw new Do("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)","OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED",o,s,i);if(i)if("add"==s.op){var u=s.path.split("/").length,_=a.split("/").length;if(u!==_+1&&u!==_)throw new Do("Cannot perform an `add` operation at the desired path","OPERATION_PATH_CANNOT_ADD",o,s,i)}else if("replace"===s.op||"remove"===s.op||"_get"===s.op){if(s.path!==a)throw new Do("Cannot perform the operation at a path that does not exist","OPERATION_PATH_UNRESOLVABLE",o,s,i)}else if("move"===s.op||"copy"===s.op){var w=validate([{op:"_get",path:s.from,value:void 0}],i);if(w&&"OPERATION_PATH_UNRESOLVABLE"===w.name)throw new Do("Cannot perform the operation from a path that does not exist","OPERATION_FROM_UNRESOLVABLE",o,s,i)}}function validate(s,o,i){try{if(!Array.isArray(s))throw new Do("Patch sequence must be an array","SEQUENCE_NOT_AN_ARRAY");if(o)applyPatch(_deepClone(o),_deepClone(s),i||!0);else{i=i||validator;for(var a=0;a<s.length;a++)i(s[a],a,o,void 0)}}catch(s){if(s instanceof Do)return s;throw s}}function _areEquals(s,o){if(s===o)return!0;if(s&&o&&"object"==typeof s&&"object"==typeof o){var i,a,u,_=Array.isArray(s),w=Array.isArray(o);if(_&&w){if((a=s.length)!=o.length)return!1;for(i=a;0!=i--;)if(!_areEquals(s[i],o[i]))return!1;return!0}if(_!=w)return!1;var x=Object.keys(s);if((a=x.length)!==Object.keys(o).length)return!1;for(i=a;0!=i--;)if(!o.hasOwnProperty(x[i]))return!1;for(i=a;0!=i--;)if(!_areEquals(s[u=x[i]],o[u]))return!1;return!0}return s!=s&&o!=o}var $o=new WeakMap,qo=function qo(s){this.observers=new Map,this.obj=s},Uo=function Uo(s,o){this.callback=s,this.observer=o};function unobserve(s,o){o.unobserve()}function observe(s,o){var i,a=function getMirror(s){return $o.get(s)}(s);if(a){var u=function getObserverFromMirror(s,o){return s.observers.get(o)}(a,o);i=u&&u.observer}else a=new qo(s),$o.set(s,a);if(i)return i;if(i={},a.value=_deepClone(s),o){i.callback=o,i.next=null;var dirtyCheck=function(){generate(i)},fastCheck=function(){clearTimeout(i.next),i.next=setTimeout(dirtyCheck)};"undefined"!=typeof window&&(window.addEventListener("mouseup",fastCheck),window.addEventListener("keyup",fastCheck),window.addEventListener("mousedown",fastCheck),window.addEventListener("keydown",fastCheck),window.addEventListener("change",fastCheck))}return i.patches=[],i.object=s,i.unobserve=function(){generate(i),clearTimeout(i.next),function removeObserverFromMirror(s,o){s.observers.delete(o.callback)}(a,i),"undefined"!=typeof window&&(window.removeEventListener("mouseup",fastCheck),window.removeEventListener("keyup",fastCheck),window.removeEventListener("mousedown",fastCheck),window.removeEventListener("keydown",fastCheck),window.removeEventListener("change",fastCheck))},a.observers.set(o,new Uo(o,i)),i}function generate(s,o){void 0===o&&(o=!1);var i=$o.get(s.object);_generate(i.value,s.object,s.patches,"",o),s.patches.length&&applyPatch(i.value,s.patches);var a=s.patches;return a.length>0&&(s.patches=[],s.callback&&s.callback(a)),a}function _generate(s,o,i,a,u){if(o!==s){"function"==typeof o.toJSON&&(o=o.toJSON());for(var _=_objectKeys(o),w=_objectKeys(s),x=!1,C=w.length-1;C>=0;C--){var j=s[B=w[C]];if(!module_helpers_hasOwnProperty(o,B)||void 0===o[B]&&void 0!==j&&!1===Array.isArray(o))Array.isArray(s)===Array.isArray(o)?(u&&i.push({op:"test",path:a+"/"+escapePathComponent(B),value:_deepClone(j)}),i.push({op:"remove",path:a+"/"+escapePathComponent(B)}),x=!0):(u&&i.push({op:"test",path:a,value:s}),i.push({op:"replace",path:a,value:o}),!0);else{var L=o[B];"object"==typeof j&&null!=j&&"object"==typeof L&&null!=L&&Array.isArray(j)===Array.isArray(L)?_generate(j,L,i,a+"/"+escapePathComponent(B),u):j!==L&&(u&&i.push({op:"test",path:a+"/"+escapePathComponent(B),value:_deepClone(j)}),i.push({op:"replace",path:a+"/"+escapePathComponent(B),value:_deepClone(L)}))}}if(x||_.length!=w.length)for(C=0;C<_.length;C++){var B;module_helpers_hasOwnProperty(s,B=_[C])||void 0===o[B]||i.push({op:"add",path:a+"/"+escapePathComponent(B),value:_deepClone(o[B])})}}}function compare(s,o,i){void 0===i&&(i=!1);var a=[];return _generate(s,o,a,"",i),a}Object.assign({},Z,ee,{JsonPatchError:Ro,deepClone:_deepClone,escapePathComponent,unescapePathComponent});var Vo=__webpack_require__(14744),zo=__webpack_require__.n(Vo);const Wo={add:function add(s,o){return{op:"add",path:s,value:o}},replace,remove:function remove(s){return{op:"remove",path:s}},merge:function lib_merge(s,o){return{type:"mutation",op:"merge",path:s,value:o}},mergeDeep:function mergeDeep(s,o){return{type:"mutation",op:"mergeDeep",path:s,value:o}},context:function context(s,o){return{type:"context",path:s,value:o}},getIn:function lib_getIn(s,o){return o.reduce(((s,o)=>void 0!==o&&s?s[o]:s),s)},applyPatch:function lib_applyPatch(s,o,i){if(i=i||{},"merge"===(o={...o,path:o.path&&normalizeJSONPath(o.path)}).op){const i=getInByJsonPath(s,o.path);Object.assign(i,o.value),applyPatch(s,[replace(o.path,i)])}else if("mergeDeep"===o.op){const i=getInByJsonPath(s,o.path),a=zo()(i,o.value,{customMerge:s=>{if("enum"===s)return(s,o)=>Array.isArray(s)&&Array.isArray(o)?[...new Set([...s,...o])]:zo()(s,o)}});s=applyPatch(s,[replace(o.path,a)]).newDocument}else if("add"===o.op&&""===o.path&&lib_isObject(o.value)){applyPatch(s,Object.keys(o.value).reduce(((s,i)=>(s.push({op:"add",path:`/${normalizeJSONPath(i)}`,value:o.value[i]}),s)),[]))}else if("replace"===o.op&&""===o.path){let{value:a}=o;i.allowMetaPatches&&o.meta&&isAdditiveMutation(o)&&(Array.isArray(o.value)||lib_isObject(o.value))&&(a={...a,...o.meta}),s=a}else if(applyPatch(s,[o]),i.allowMetaPatches&&o.meta&&isAdditiveMutation(o)&&(Array.isArray(o.value)||lib_isObject(o.value))){const i={...getInByJsonPath(s,o.path),...o.meta};applyPatch(s,[replace(o.path,i)])}return s},parentPathMatch:function parentPathMatch(s,o){if(!Array.isArray(o))return!1;for(let i=0,a=o.length;i<a;i+=1)if(o[i]!==s[i])return!1;return!0},flatten,fullyNormalizeArray:function fullyNormalizeArray(s){return cleanArray(flatten(lib_normalizeArray(s)))},normalizeArray:lib_normalizeArray,isPromise:function isPromise(s){return lib_isObject(s)&&lib_isFunction(s.then)},forEachNew:function forEachNew(s,o){try{return forEachNewPatch(s,forEach,o)}catch(s){return s}},forEachNewPrimitive:function forEachNewPrimitive(s,o){try{return forEachNewPatch(s,forEachPrimitive,o)}catch(s){return s}},isJsonPatch,isContextPatch:function isContextPatch(s){return isPatch(s)&&"context"===s.type},isPatch,isMutation,isAdditiveMutation,isGenerator:function isGenerator(s){return"[object GeneratorFunction]"===Object.prototype.toString.call(s)},isFunction:lib_isFunction,isObject:lib_isObject,isError:function lib_isError(s){return s instanceof Error}};function normalizeJSONPath(s){return Array.isArray(s)?s.length<1?"":`/${s.map((s=>(s+"").replace(/~/g,"~0").replace(/\//g,"~1"))).join("/")}`:s}function replace(s,o,i){return{op:"replace",path:s,value:o,meta:i}}function forEachNewPatch(s,o,i){return cleanArray(flatten(s.filter(isAdditiveMutation).map((s=>o(s.value,i,s.path)))||[]))}function forEachPrimitive(s,o,i){return i=i||[],Array.isArray(s)?s.map(((s,a)=>forEachPrimitive(s,o,i.concat(a)))):lib_isObject(s)?Object.keys(s).map((a=>forEachPrimitive(s[a],o,i.concat(a)))):o(s,i[i.length-1],i)}function forEach(s,o,i){let a=[];if((i=i||[]).length>0){const u=o(s,i[i.length-1],i);u&&(a=a.concat(u))}if(Array.isArray(s)){const u=s.map(((s,a)=>forEach(s,o,i.concat(a))));u&&(a=a.concat(u))}else if(lib_isObject(s)){const u=Object.keys(s).map((a=>forEach(s[a],o,i.concat(a))));u&&(a=a.concat(u))}return a=flatten(a),a}function lib_normalizeArray(s){return Array.isArray(s)?s:[s]}function flatten(s){return[].concat(...s.map((s=>Array.isArray(s)?flatten(s):s)))}function cleanArray(s){return s.filter((s=>void 0!==s))}function lib_isObject(s){return s&&"object"==typeof s}function lib_isFunction(s){return s&&"function"==typeof s}function isJsonPatch(s){if(isPatch(s)){const{op:o}=s;return"add"===o||"remove"===o||"replace"===o}return!1}function isMutation(s){return isJsonPatch(s)||isPatch(s)&&"mutation"===s.type}function isAdditiveMutation(s){return isMutation(s)&&("add"===s.op||"replace"===s.op||"merge"===s.op||"mergeDeep"===s.op)}function isPatch(s){return s&&"object"==typeof s}function getInByJsonPath(s,o){try{return getValueByPointer(s,o)}catch(s){return console.error(s),{}}}var Jo=__webpack_require__(48675);const Ho=class ApiDOMAggregateError extends Jo{constructor(s,o,i){if(super(s,o,i),this.name=this.constructor.name,"string"==typeof o&&(this.message=o),"function"==typeof Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):this.stack=new Error(o).stack,null!=i&&"object"==typeof i&&Object.hasOwn(i,"cause")&&!("cause"in this)){const{cause:s}=i;this.cause=s,s instanceof Error&&"stack"in s&&(this.stack=`${this.stack}\nCAUSE: ${s.stack}`)}}};class ApiDOMError extends Error{static[Symbol.hasInstance](s){return super[Symbol.hasInstance](s)||Function.prototype[Symbol.hasInstance].call(Ho,s)}constructor(s,o){if(super(s,o),this.name=this.constructor.name,"string"==typeof s&&(this.message=s),"function"==typeof Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):this.stack=new Error(s).stack,null!=o&&"object"==typeof o&&Object.hasOwn(o,"cause")&&!("cause"in this)){const{cause:s}=o;this.cause=s,s instanceof Error&&"stack"in s&&(this.stack=`${this.stack}\nCAUSE: ${s.stack}`)}}}const Ko=ApiDOMError;const Go=class ApiDOMStructuredError extends Ko{constructor(s,o){if(super(s,o),null!=o&&"object"==typeof o){const{cause:s,...i}=o;Object.assign(this,i)}}};function _arity(s,o){switch(s){case 0:return function(){return o.apply(this,arguments)};case 1:return function(s){return o.apply(this,arguments)};case 2:return function(s,i){return o.apply(this,arguments)};case 3:return function(s,i,a){return o.apply(this,arguments)};case 4:return function(s,i,a,u){return o.apply(this,arguments)};case 5:return function(s,i,a,u,_){return o.apply(this,arguments)};case 6:return function(s,i,a,u,_,w){return o.apply(this,arguments)};case 7:return function(s,i,a,u,_,w,x){return o.apply(this,arguments)};case 8:return function(s,i,a,u,_,w,x,C){return o.apply(this,arguments)};case 9:return function(s,i,a,u,_,w,x,C,j){return o.apply(this,arguments)};case 10:return function(s,i,a,u,_,w,x,C,j,L){return o.apply(this,arguments)};default:throw new Error("First argument to _arity must be a non-negative integer no greater than ten")}}function _pipe(s,o){return function(){return o.call(this,s.apply(this,arguments))}}function _isPlaceholder(s){return null!=s&&"object"==typeof s&&!0===s["@@functional/placeholder"]}function _curry1(s){return function f1(o){return 0===arguments.length||_isPlaceholder(o)?f1:s.apply(this,arguments)}}function _curry2(s){return function f2(o,i){switch(arguments.length){case 0:return f2;case 1:return _isPlaceholder(o)?f2:_curry1((function(i){return s(o,i)}));default:return _isPlaceholder(o)&&_isPlaceholder(i)?f2:_isPlaceholder(o)?_curry1((function(o){return s(o,i)})):_isPlaceholder(i)?_curry1((function(i){return s(o,i)})):s(o,i)}}}function _curry3(s){return function f3(o,i,a){switch(arguments.length){case 0:return f3;case 1:return _isPlaceholder(o)?f3:_curry2((function(i,a){return s(o,i,a)}));case 2:return _isPlaceholder(o)&&_isPlaceholder(i)?f3:_isPlaceholder(o)?_curry2((function(o,a){return s(o,i,a)})):_isPlaceholder(i)?_curry2((function(i,a){return s(o,i,a)})):_curry1((function(a){return s(o,i,a)}));default:return _isPlaceholder(o)&&_isPlaceholder(i)&&_isPlaceholder(a)?f3:_isPlaceholder(o)&&_isPlaceholder(i)?_curry2((function(o,i){return s(o,i,a)})):_isPlaceholder(o)&&_isPlaceholder(a)?_curry2((function(o,a){return s(o,i,a)})):_isPlaceholder(i)&&_isPlaceholder(a)?_curry2((function(i,a){return s(o,i,a)})):_isPlaceholder(o)?_curry1((function(o){return s(o,i,a)})):_isPlaceholder(i)?_curry1((function(i){return s(o,i,a)})):_isPlaceholder(a)?_curry1((function(a){return s(o,i,a)})):s(o,i,a)}}}const Yo=Array.isArray||function _isArray(s){return null!=s&&s.length>=0&&"[object Array]"===Object.prototype.toString.call(s)};function _isString(s){return"[object String]"===Object.prototype.toString.call(s)}const Xo=_curry1((function isArrayLike(s){return!!Yo(s)||!!s&&("object"==typeof s&&(!_isString(s)&&(0===s.length||s.length>0&&(s.hasOwnProperty(0)&&s.hasOwnProperty(s.length-1)))))}));var Qo="undefined"!=typeof Symbol?Symbol.iterator:"@@iterator";function _createReduce(s,o,i){return function _reduce(a,u,_){if(Xo(_))return s(a,u,_);if(null==_)return u;if("function"==typeof _["fantasy-land/reduce"])return o(a,u,_,"fantasy-land/reduce");if(null!=_[Qo])return i(a,u,_[Qo]());if("function"==typeof _.next)return i(a,u,_);if("function"==typeof _.reduce)return o(a,u,_,"reduce");throw new TypeError("reduce: list must be array or iterable")}}function _xArrayReduce(s,o,i){for(var a=0,u=i.length;a<u;){if((o=s["@@transducer/step"](o,i[a]))&&o["@@transducer/reduced"]){o=o["@@transducer/value"];break}a+=1}return s["@@transducer/result"](o)}const Zo=_curry2((function bind(s,o){return _arity(s.length,(function(){return s.apply(o,arguments)}))}));function _xIterableReduce(s,o,i){for(var a=i.next();!a.done;){if((o=s["@@transducer/step"](o,a.value))&&o["@@transducer/reduced"]){o=o["@@transducer/value"];break}a=i.next()}return s["@@transducer/result"](o)}function _xMethodReduce(s,o,i,a){return s["@@transducer/result"](i[a](Zo(s["@@transducer/step"],s),o))}const _i=_createReduce(_xArrayReduce,_xMethodReduce,_xIterableReduce);var Ei=function(){function XWrap(s){this.f=s}return XWrap.prototype["@@transducer/init"]=function(){throw new Error("init not implemented on XWrap")},XWrap.prototype["@@transducer/result"]=function(s){return s},XWrap.prototype["@@transducer/step"]=function(s,o){return this.f(s,o)},XWrap}();function _xwrap(s){return new Ei(s)}var Oi=_curry3((function(s,o,i){return _i("function"==typeof s?_xwrap(s):s,o,i)}));const Pi=Oi;function _checkForMethod(s,o){return function(){var i=arguments.length;if(0===i)return o();var a=arguments[i-1];return Yo(a)||"function"!=typeof a[s]?o.apply(this,arguments):a[s].apply(a,Array.prototype.slice.call(arguments,0,i-1))}}var Mi=_curry3(_checkForMethod("slice",(function slice(s,o,i){return Array.prototype.slice.call(i,s,o)})));const Ri=Mi;const Wi=_curry1(_checkForMethod("tail",Ri(1,1/0)));function pipe(){if(0===arguments.length)throw new Error("pipe requires at least one argument");return _arity(arguments[0].length,Pi(_pipe,arguments[0],Wi(arguments)))}const ea=_curry2((function defaultTo(s,o){return null==o||o!=o?s:o})),ra=Number.isInteger||function _isInteger(s){return(s|0)===s};function _nth(s,o){var i=s<0?o.length+s:s;return _isString(o)?o.charAt(i):o[i]}const na=_curry2((function prop(s,o){if(null!=o)return ra(s)?_nth(s,o):o[s]}));const ia=_curry3((function propOr(s,o,i){return ea(s,na(o,i))}));var aa=_curry1((function(s){return _nth(-1,s)}));const ca=aa;function _curryN(s,o,i){return function(){for(var a=[],u=0,_=s,w=0,x=!1;w<o.length||u<arguments.length;){var C;w<o.length&&(!_isPlaceholder(o[w])||u>=arguments.length)?C=o[w]:(C=arguments[u],u+=1),a[w]=C,_isPlaceholder(C)?x=!0:_-=1,w+=1}return!x&&_<=0?i.apply(this,a):_arity(Math.max(0,_),_curryN(s,a,i))}}const la=_curry2((function curryN(s,o){return 1===s?_curry1(o):_arity(s,_curryN(s,[],o))}));const ua=_curry1((function curry(s){return la(s.length,s)}));function _isFunction(s){var o=Object.prototype.toString.call(s);return"[object Function]"===o||"[object AsyncFunction]"===o||"[object GeneratorFunction]"===o||"[object AsyncGeneratorFunction]"===o}function _arrayFromIterator(s){for(var o,i=[];!(o=s.next()).done;)i.push(o.value);return i}function _includesWith(s,o,i){for(var a=0,u=i.length;a<u;){if(s(o,i[a]))return!0;a+=1}return!1}function _has(s,o){return Object.prototype.hasOwnProperty.call(o,s)}const da="function"==typeof Object.is?Object.is:function _objectIs(s,o){return s===o?0!==s||1/s==1/o:s!=s&&o!=o};var ma=Object.prototype.toString;const ga=function(){return"[object Arguments]"===ma.call(arguments)?function _isArguments(s){return"[object Arguments]"===ma.call(s)}:function _isArguments(s){return _has("callee",s)}}();var ya=!{toString:null}.propertyIsEnumerable("toString"),va=["constructor","valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"],ba=function(){return arguments.propertyIsEnumerable("length")}(),_a=function contains(s,o){for(var i=0;i<s.length;){if(s[i]===o)return!0;i+=1}return!1},Ea="function"!=typeof Object.keys||ba?_curry1((function keys(s){if(Object(s)!==s)return[];var o,i,a=[],u=ba&&ga(s);for(o in s)!_has(o,s)||u&&"length"===o||(a[a.length]=o);if(ya)for(i=va.length-1;i>=0;)_has(o=va[i],s)&&!_a(a,o)&&(a[a.length]=o),i-=1;return a})):_curry1((function keys(s){return Object(s)!==s?[]:Object.keys(s)}));const wa=Ea;const xa=_curry1((function type(s){return null===s?"Null":void 0===s?"Undefined":Object.prototype.toString.call(s).slice(8,-1)}));function _uniqContentEquals(s,o,i,a){var u=_arrayFromIterator(s);function eq(s,o){return _equals(s,o,i.slice(),a.slice())}return!_includesWith((function(s,o){return!_includesWith(eq,o,s)}),_arrayFromIterator(o),u)}function _equals(s,o,i,a){if(da(s,o))return!0;var u=xa(s);if(u!==xa(o))return!1;if("function"==typeof s["fantasy-land/equals"]||"function"==typeof o["fantasy-land/equals"])return"function"==typeof s["fantasy-land/equals"]&&s["fantasy-land/equals"](o)&&"function"==typeof o["fantasy-land/equals"]&&o["fantasy-land/equals"](s);if("function"==typeof s.equals||"function"==typeof o.equals)return"function"==typeof s.equals&&s.equals(o)&&"function"==typeof o.equals&&o.equals(s);switch(u){case"Arguments":case"Array":case"Object":if("function"==typeof s.constructor&&"Promise"===function _functionName(s){var o=String(s).match(/^function (\w*)/);return null==o?"":o[1]}(s.constructor))return s===o;break;case"Boolean":case"Number":case"String":if(typeof s!=typeof o||!da(s.valueOf(),o.valueOf()))return!1;break;case"Date":if(!da(s.valueOf(),o.valueOf()))return!1;break;case"Error":return s.name===o.name&&s.message===o.message;case"RegExp":if(s.source!==o.source||s.global!==o.global||s.ignoreCase!==o.ignoreCase||s.multiline!==o.multiline||s.sticky!==o.sticky||s.unicode!==o.unicode)return!1}for(var _=i.length-1;_>=0;){if(i[_]===s)return a[_]===o;_-=1}switch(u){case"Map":return s.size===o.size&&_uniqContentEquals(s.entries(),o.entries(),i.concat([s]),a.concat([o]));case"Set":return s.size===o.size&&_uniqContentEquals(s.values(),o.values(),i.concat([s]),a.concat([o]));case"Arguments":case"Array":case"Object":case"Boolean":case"Number":case"String":case"Date":case"Error":case"RegExp":case"Int8Array":case"Uint8Array":case"Uint8ClampedArray":case"Int16Array":case"Uint16Array":case"Int32Array":case"Uint32Array":case"Float32Array":case"Float64Array":case"ArrayBuffer":break;default:return!1}var w=wa(s);if(w.length!==wa(o).length)return!1;var x=i.concat([s]),C=a.concat([o]);for(_=w.length-1;_>=0;){var j=w[_];if(!_has(j,o)||!_equals(o[j],s[j],x,C))return!1;_-=1}return!0}const ka=_curry2((function equals(s,o){return _equals(s,o,[],[])}));function _includes(s,o){return function _indexOf(s,o,i){var a,u;if("function"==typeof s.indexOf)switch(typeof o){case"number":if(0===o){for(a=1/o;i<s.length;){if(0===(u=s[i])&&1/u===a)return i;i+=1}return-1}if(o!=o){for(;i<s.length;){if("number"==typeof(u=s[i])&&u!=u)return i;i+=1}return-1}return s.indexOf(o,i);case"string":case"boolean":case"function":case"undefined":return s.indexOf(o,i);case"object":if(null===o)return s.indexOf(o,i)}for(;i<s.length;){if(ka(s[i],o))return i;i+=1}return-1}(o,s,0)>=0}function _map(s,o){for(var i=0,a=o.length,u=Array(a);i<a;)u[i]=s(o[i]),i+=1;return u}function _quote(s){return'"'+s.replace(/\\/g,"\\\\").replace(/[\b]/g,"\\b").replace(/\f/g,"\\f").replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\t/g,"\\t").replace(/\v/g,"\\v").replace(/\0/g,"\\0").replace(/"/g,'\\"')+'"'}var Aa=function pad(s){return(s<10?"0":"")+s};const Ca="function"==typeof Date.prototype.toISOString?function _toISOString(s){return s.toISOString()}:function _toISOString(s){return s.getUTCFullYear()+"-"+Aa(s.getUTCMonth()+1)+"-"+Aa(s.getUTCDate())+"T"+Aa(s.getUTCHours())+":"+Aa(s.getUTCMinutes())+":"+Aa(s.getUTCSeconds())+"."+(s.getUTCMilliseconds()/1e3).toFixed(3).slice(2,5)+"Z"};function _complement(s){return function(){return!s.apply(this,arguments)}}function _arrayReduce(s,o,i){for(var a=0,u=i.length;a<u;)o=s(o,i[a]),a+=1;return o}function _dispatchable(s,o,i){return function(){if(0===arguments.length)return i();var a=arguments[arguments.length-1];if(!Yo(a)){for(var u=0;u<s.length;){if("function"==typeof a[s[u]])return a[s[u]].apply(a,Array.prototype.slice.call(arguments,0,-1));u+=1}if(function _isTransformer(s){return null!=s&&"function"==typeof s["@@transducer/step"]}(a))return o.apply(null,Array.prototype.slice.call(arguments,0,-1))(a)}return i.apply(this,arguments)}}function _isObject(s){return"[object Object]"===Object.prototype.toString.call(s)}const _xfBase_init=function(){return this.xf["@@transducer/init"]()},_xfBase_result=function(s){return this.xf["@@transducer/result"](s)};var ja=function(){function XFilter(s,o){this.xf=o,this.f=s}return XFilter.prototype["@@transducer/init"]=_xfBase_init,XFilter.prototype["@@transducer/result"]=_xfBase_result,XFilter.prototype["@@transducer/step"]=function(s,o){return this.f(o)?this.xf["@@transducer/step"](s,o):s},XFilter}();function _xfilter(s){return function(o){return new ja(s,o)}}var Ia=_curry2(_dispatchable(["fantasy-land/filter","filter"],_xfilter,(function(s,o){return _isObject(o)?_arrayReduce((function(i,a){return s(o[a])&&(i[a]=o[a]),i}),{},wa(o)):function _filter(s,o){for(var i=0,a=o.length,u=[];i<a;)s(o[i])&&(u[u.length]=o[i]),i+=1;return u}(s,o)})));const Na=Ia;const Da=_curry2((function reject(s,o){return Na(_complement(s),o)}));function _toString_toString(s,o){var i=function recur(i){var a=o.concat([s]);return _includes(i,a)?"<Circular>":_toString_toString(i,a)},mapPairs=function(s,o){return _map((function(o){return _quote(o)+": "+i(s[o])}),o.slice().sort())};switch(Object.prototype.toString.call(s)){case"[object Arguments]":return"(function() { return arguments; }("+_map(i,s).join(", ")+"))";case"[object Array]":return"["+_map(i,s).concat(mapPairs(s,Da((function(s){return/^\d+$/.test(s)}),wa(s)))).join(", ")+"]";case"[object Boolean]":return"object"==typeof s?"new Boolean("+i(s.valueOf())+")":s.toString();case"[object Date]":return"new Date("+(isNaN(s.valueOf())?i(NaN):_quote(Ca(s)))+")";case"[object Map]":return"new Map("+i(Array.from(s))+")";case"[object Null]":return"null";case"[object Number]":return"object"==typeof s?"new Number("+i(s.valueOf())+")":1/s==-1/0?"-0":s.toString(10);case"[object Set]":return"new Set("+i(Array.from(s).sort())+")";case"[object String]":return"object"==typeof s?"new String("+i(s.valueOf())+")":_quote(s);case"[object Undefined]":return"undefined";default:if("function"==typeof s.toString){var a=s.toString();if("[object Object]"!==a)return a}return"{"+mapPairs(s,wa(s)).join(", ")+"}"}}const La=_curry1((function toString(s){return _toString_toString(s,[])}));const Fa=_curry2((function invoker(s,o){return la(s+1,(function(){var i=arguments[s];if(null!=i&&_isFunction(i[o]))return i[o].apply(i,Array.prototype.slice.call(arguments,0,s));throw new TypeError(La(i)+' does not have a method named "'+o+'"')}))}));const Ba=Fa(1,"split");function dropLastWhile(s,o){for(var i=o.length-1;i>=0&&s(o[i]);)i-=1;return Ri(0,i+1,o)}var $a=function(){function XDropLastWhile(s,o){this.f=s,this.retained=[],this.xf=o}return XDropLastWhile.prototype["@@transducer/init"]=_xfBase_init,XDropLastWhile.prototype["@@transducer/result"]=function(s){return this.retained=null,this.xf["@@transducer/result"](s)},XDropLastWhile.prototype["@@transducer/step"]=function(s,o){return this.f(o)?this.retain(s,o):this.flush(s,o)},XDropLastWhile.prototype.flush=function(s,o){return s=_i(this.xf,s,this.retained),this.retained=[],this.xf["@@transducer/step"](s,o)},XDropLastWhile.prototype.retain=function(s,o){return this.retained.push(o),s},XDropLastWhile}();function _xdropLastWhile(s){return function(o){return new $a(s,o)}}const za=_curry2(_dispatchable([],_xdropLastWhile,dropLastWhile));const Ja=Fa(1,"join");const Ha=_curry1((function flip(s){return la(s.length,(function(o,i){var a=Array.prototype.slice.call(arguments,0);return a[0]=i,a[1]=o,s.apply(this,a)}))}))(_curry2(_includes));const Ga=ua((function(s,o){return pipe(Ba(""),za(Ha(s)),Ja(""))(o)}));function _iterableReduce(s,o,i){for(var a=i.next();!a.done;)o=s(o,a.value),a=i.next();return o}function _methodReduce(s,o,i,a){return i[a](s,o)}const ec=_createReduce(_arrayReduce,_methodReduce,_iterableReduce);var rc=function(){function XMap(s,o){this.xf=o,this.f=s}return XMap.prototype["@@transducer/init"]=_xfBase_init,XMap.prototype["@@transducer/result"]=_xfBase_result,XMap.prototype["@@transducer/step"]=function(s,o){return this.xf["@@transducer/step"](s,this.f(o))},XMap}();const sc=_curry2(_dispatchable(["fantasy-land/map","map"],(function _xmap(s){return function(o){return new rc(s,o)}}),(function map(s,o){switch(Object.prototype.toString.call(o)){case"[object Function]":return la(o.length,(function(){return s.call(this,o.apply(this,arguments))}));case"[object Object]":return _arrayReduce((function(i,a){return i[a]=s(o[a]),i}),{},wa(o));default:return _map(s,o)}})));const oc=_curry2((function ap(s,o){return"function"==typeof o["fantasy-land/ap"]?o["fantasy-land/ap"](s):"function"==typeof s.ap?s.ap(o):"function"==typeof s?function(i){return s(i)(o(i))}:ec((function(s,i){return function _concat(s,o){var i;o=o||[];var a=(s=s||[]).length,u=o.length,_=[];for(i=0;i<a;)_[_.length]=s[i],i+=1;for(i=0;i<u;)_[_.length]=o[i],i+=1;return _}(s,sc(i,o))}),[],s)}));const ic=_curry2((function liftN(s,o){var i=la(s,o);return la(s,(function(){return _arrayReduce(oc,sc(i,arguments[0]),Array.prototype.slice.call(arguments,1))}))}));const ac=_curry1((function lift(s){return ic(s.length,s)}));const cc=ac(_curry1((function not(s){return!s})));const lc=_curry1((function always(s){return function(){return s}}));const pc=lc(void 0);const hc=ka(pc());const dc=cc(hc);const fc=_curry2((function max(s,o){if(s===o)return o;function safeMax(s,o){if(s>o!=o>s)return o>s?o:s}var i=safeMax(s,o);if(void 0!==i)return i;var a=safeMax(typeof s,typeof o);if(void 0!==a)return a===typeof s?s:o;var u=La(s),_=safeMax(u,La(o));return void 0!==_&&_===u?s:o}));var gc=_curry2((function pluck(s,o){return sc(na(s),o)}));const bc=gc;const _c=_curry1((function anyPass(s){return la(Pi(fc,0,bc("length",s)),(function(){for(var o=0,i=s.length;o<i;){if(s[o].apply(this,arguments))return!0;o+=1}return!1}))}));var identical=function(s,o){switch(arguments.length){case 0:return identical;case 1:return function unaryIdentical(o){return 0===arguments.length?unaryIdentical:da(s,o)};default:return da(s,o)}};const Ec=identical;const kc=la(1,pipe(xa,Ec("GeneratorFunction")));const Oc=la(1,pipe(xa,Ec("AsyncFunction")));const jc=_c([pipe(xa,Ec("Function")),kc,Oc]);var Pc=_curry3((function replace(s,o,i){return i.replace(s,o)}));const Ic=Pc;const Nc=la(1,pipe(xa,Ec("RegExp")));const Mc=_curry3((function when(s,o,i){return s(i)?o(i):i}));const Rc=la(1,pipe(xa,Ec("String")));const Lc=Mc(Rc,Ic(/[.*+?^${}()|[\]\\-]/g,"\\$&"));var Fc=function checkValue(s,o){if("string"!=typeof s&&!(s instanceof String))throw TypeError("`".concat(o,"` must be a string"))};const qc=function replaceAll(s,o,i){!function checkArguments(s,o,i){if(null==i||null==s||null==o)throw TypeError("Input values must not be `null` or `undefined`")}(s,o,i),Fc(i,"str"),Fc(o,"replaceValue"),function checkSearchValue(s){if(!("string"==typeof s||s instanceof String||s instanceof RegExp))throw TypeError("`searchValue` must be a string or an regexp")}(s);var a=new RegExp(Nc(s)?s:Lc(s),"g");return Ic(a,o,i)};var Jc=la(3,qc),Hc=Fa(2,"replaceAll");const Kc=jc(String.prototype.replaceAll)?Hc:Jc,isWindows=()=>{var s,o;return/^win/.test(null!==(s=null===(o=globalThis.process)||void 0===o?void 0:o.platform)&&void 0!==s?s:"")},getProtocol=s=>{try{const o=new URL(s);return Ga(":",o.protocol)}catch{return}},Gc=(pipe(getProtocol,dc),s=>{if(void 0!==globalThis.window)return!1;const o=getProtocol(s);return hc(o)||"file"===o||/^[a-zA-Z]$/.test(o)}),isHttpUrl=s=>{const o=getProtocol(s);return"http"===o||"https"===o},toFileSystemPath=(s,o)=>{const i=[/%23/g,"#",/%24/g,"$",/%26/g,"&",/%2C/g,",",/%40/g,"@"],a=ia(!1,"keepFileProtocol",o),u=ia(isWindows,"isWindows",o);let _=decodeURI(s);for(let s=0;s<i.length;s+=2)_=_.replace(i[s],i[s+1]);let w="file://"===_.substring(0,7).toLowerCase();return w&&(_="/"===_[7]?_.substring(8):_.substring(7),u()&&"/"===_[1]&&(_=`${_[0]}:${_.substring(1)}`),a?_=`file:///${_}`:(w=!1,_=u()?_:`/${_}`)),u()&&!w&&(_=Kc("/","\\",_),":\\"===_.substring(1,3)&&(_=_[0].toUpperCase()+_.substring(1))),_},getHash=s=>{const o=s.indexOf("#");return-1!==o?s.substring(o):"#"},stripHash=s=>{const o=s.indexOf("#");let i=s;return o>=0&&(i=s.substring(0,o)),i},url_cwd=()=>{var s,o;if(void 0!==globalThis.window)return stripHash(globalThis.location.href);const i=null!==(s=null===(o=globalThis.process)||void 0===o?void 0:o.cwd())&&void 0!==s?s:"/",a=ca(i);return["/","\\"].includes(a)?i:i+(isWindows()?"\\":"/")},resolve=(s,o)=>{const i=new URL(o,new URL(s,"resolve://"));if("resolve:"===i.protocol){const{pathname:s,search:o,hash:a}=i;return s+o+a}return i.toString()},sanitize=s=>{if(Gc(s))return(s=>{const o=[/\?/g,"%3F",/#/g,"%23"];let i=s;isWindows()&&(i=i.replace(/\\/g,"/")),i=encodeURI(i);for(let s=0;s<o.length;s+=2)i=i.replace(o[s],o[s+1]);return i})(toFileSystemPath(s));try{return new URL(s).toString()}catch{return encodeURI(decodeURI(s)).replace(/%5B/g,"[").replace(/%5D/g,"]")}},unsanitize=s=>Gc(s)?toFileSystemPath(s):decodeURI(s);var Qc=__webpack_require__(8628),tl=__webpack_require__.n(Qc);function _array_like_to_array(s,o){(null==o||o>s.length)&&(o=s.length);for(var i=0,a=new Array(o);i<o;i++)a[i]=s[i];return a}function legacy_defineProperties(s,o){for(var i=0;i<o.length;i++){var a=o[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(s,a.key,a)}}function _instanceof(s,o){return null!=o&&"undefined"!=typeof Symbol&&o[Symbol.hasInstance]?!!o[Symbol.hasInstance](s):s instanceof o}function _sliced_to_array(s,o){return function _array_with_holes(s){if(Array.isArray(s))return s}(s)||function _iterable_to_array_limit(s,o){var i=null==s?null:"undefined"!=typeof Symbol&&s[Symbol.iterator]||s["@@iterator"];if(null!=i){var a,u,_=[],w=!0,x=!1;try{for(i=i.call(s);!(w=(a=i.next()).done)&&(_.push(a.value),!o||_.length!==o);w=!0);}catch(s){x=!0,u=s}finally{try{w||null==i.return||i.return()}finally{if(x)throw u}}return _}}(s,o)||function _unsupported_iterable_to_array(s,o){if(!s)return;if("string"==typeof s)return _array_like_to_array(s,o);var i=Object.prototype.toString.call(s).slice(8,-1);"Object"===i&&s.constructor&&(i=s.constructor.name);if("Map"===i||"Set"===i)return Array.from(i);if("Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))return _array_like_to_array(s,o)}(s,o)||function _non_iterable_rest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function _type_of(s){return s&&"undefined"!=typeof Symbol&&s.constructor===Symbol?"symbol":typeof s}var __typeError=function(s){throw TypeError(s)},__accessCheck=function(s,o,i){return o.has(s)||__typeError("Cannot "+i)},__privateGet=function(s,o,i){return __accessCheck(s,o,"read from private field"),i?i.call(s):o.get(s)},__privateAdd=function(s,o,i){return o.has(s)?__typeError("Cannot add the same private member more than once"):_instanceof(o,WeakSet)?o.add(s):o.set(s,i)},__privateSet=function(s,o,i,a){return __accessCheck(s,o,"write to private field"),a?a.call(s,i):o.set(s,i),i},to_string=function(s){return Object.prototype.toString.call(s)},is_typed_array=function(s){return ArrayBuffer.isView(s)&&!_instanceof(s,DataView)},sl=Array.isArray,ul=Object.getOwnPropertyDescriptor,yl=Object.prototype.propertyIsEnumerable,vl=Object.getOwnPropertySymbols,Sl=Object.prototype.hasOwnProperty;function own_enumerable_keys(s){for(var o=Object.keys(s),i=vl(s),a=0;a<i.length;a++)yl.call(s,i[a])&&o.push(i[a]);return o}function is_writable(s,o){var i;return!(null===(i=ul(s,o))||void 0===i?void 0:i.writable)}function legacy_copy(s,o){if("object"===(void 0===s?"undefined":_type_of(s))&&null!==s){var i;if(sl(s))i=[];else if("[object Date]"===to_string(s))i=new Date(s.getTime?s.getTime():s);else if(function(s){return"[object RegExp]"===to_string(s)}(s))i=new RegExp(s);else if(function(s){return"[object Error]"===to_string(s)}(s))i={message:s.message};else if(function(s){return"[object Boolean]"===to_string(s)}(s)||function(s){return"[object Number]"===to_string(s)}(s)||function(s){return"[object String]"===to_string(s)}(s))i=Object(s);else{if(is_typed_array(s))return s.slice();i=Object.create(Object.getPrototypeOf(s))}var a=o.includeSymbols?own_enumerable_keys:Object.keys,u=!0,_=!1,w=void 0;try{for(var x,C=a(s)[Symbol.iterator]();!(u=(x=C.next()).done);u=!0){var j=x.value;i[j]=s[j]}}catch(s){_=!0,w=s}finally{try{u||null==C.return||C.return()}finally{if(_)throw w}}return i}return s}var _l,El,wl={includeSymbols:!1,immutable:!1};function walk(s,o){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:wl,a=[],u=[],_=!0,w=i.includeSymbols?own_enumerable_keys:Object.keys,x=!!i.immutable;return function walker(s){var C=x?legacy_copy(s,i):s,j={},L=!0,B={node:C,node_:s,path:[].concat(a),parent:u[u.length-1],parents:u,key:a[a.length-1],isRoot:0===a.length,level:a.length,circular:void 0,isLeaf:!1,notLeaf:!0,notRoot:!0,isFirst:!1,isLast:!1,update:function update(s){var o=arguments.length>1&&void 0!==arguments[1]&&arguments[1];B.isRoot||(B.parent.node[B.key]=s),B.node=s,o&&(L=!1)},delete:function _delete(s){delete B.parent.node[B.key],s&&(L=!1)},remove:function remove(s){sl(B.parent.node)?B.parent.node.splice(B.key,1):delete B.parent.node[B.key],s&&(L=!1)},keys:null,before:function before(s){j.before=s},after:function after(s){j.after=s},pre:function pre(s){j.pre=s},post:function post(s){j.post=s},stop:function stop(){_=!1},block:function block(){L=!1}};if(!_)return B;function update_state(){if("object"===_type_of(B.node)&&null!==B.node){B.keys&&B.node_===B.node||(B.keys=w(B.node)),B.isLeaf=0===B.keys.length;for(var o=0;o<u.length;o++)if(u[o].node_===s){B.circular=u[o];break}}else B.isLeaf=!0,B.keys=null;B.notLeaf=!B.isLeaf,B.notRoot=!B.isRoot}update_state();var $=o.call(B,B.node);if(void 0!==$&&B.update&&B.update($),j.before&&j.before.call(B,B.node),!L)return B;if("object"===_type_of(B.node)&&null!==B.node&&!B.circular){var U;u.push(B),update_state();var V=!0,z=!1,Y=void 0;try{for(var Z,ee=Object.entries(null!==(U=B.keys)&&void 0!==U?U:[])[Symbol.iterator]();!(V=(Z=ee.next()).done);V=!0){var ie,ae=_sliced_to_array(Z.value,2),ce=ae[0],le=ae[1];a.push(le),j.pre&&j.pre.call(B,B.node[le],le);var pe=walker(B.node[le]);x&&Sl.call(B.node,le)&&!is_writable(B.node,le)&&(B.node[le]=pe.node),pe.isLast=!!(null===(ie=B.keys)||void 0===ie?void 0:ie.length)&&+ce==B.keys.length-1,pe.isFirst=0==+ce,j.post&&j.post.call(B,pe),a.pop()}}catch(s){z=!0,Y=s}finally{try{V||null==ee.return||ee.return()}finally{if(z)throw Y}}u.pop()}return j.after&&j.after.call(B,B.node),B}(s).node}var xl=function(){function Traverse(s){var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:wl;!function _class_call_check(s,o){if(!(s instanceof o))throw new TypeError("Cannot call a class as a function")}(this,Traverse),__privateAdd(this,_l),__privateAdd(this,El),__privateSet(this,_l,s),__privateSet(this,El,o)}return function _create_class(s,o,i){return o&&legacy_defineProperties(s.prototype,o),i&&legacy_defineProperties(s,i),s}(Traverse,[{key:"get",value:function get(s){for(var o=__privateGet(this,_l),i=0;o&&i<s.length;i++){var a=s[i];if(!Sl.call(o,a)||!__privateGet(this,El).includeSymbols&&"symbol"===(void 0===a?"undefined":_type_of(a)))return;o=o[a]}return o}},{key:"has",value:function has(s){for(var o=__privateGet(this,_l),i=0;o&&i<s.length;i++){var a=s[i];if(!Sl.call(o,a)||!__privateGet(this,El).includeSymbols&&"symbol"===(void 0===a?"undefined":_type_of(a)))return!1;o=o[a]}return!0}},{key:"set",value:function set(s,o){var i=__privateGet(this,_l),a=0;for(a=0;a<s.length-1;a++){var u=s[a];Sl.call(i,u)||(i[u]={}),i=i[u]}return i[s[a]]=o,o}},{key:"map",value:function map(s){return walk(__privateGet(this,_l),s,{immutable:!0,includeSymbols:!!__privateGet(this,El).includeSymbols})}},{key:"forEach",value:function forEach(s){return __privateSet(this,_l,walk(__privateGet(this,_l),s,__privateGet(this,El))),__privateGet(this,_l)}},{key:"reduce",value:function reduce(s,o){var i=1===arguments.length,a=i?__privateGet(this,_l):o;return this.forEach((function(o){this.isRoot&&i||(a=s.call(this,a,o))})),a}},{key:"paths",value:function paths(){var s=[];return this.forEach((function(){s.push(this.path)})),s}},{key:"nodes",value:function nodes(){var s=[];return this.forEach((function(){s.push(this.node)})),s}},{key:"clone",value:function clone(){var s=[],o=[],i=__privateGet(this,El);return is_typed_array(__privateGet(this,_l))?__privateGet(this,_l).slice():function clone(a){for(var u=0;u<s.length;u++)if(s[u]===a)return o[u];if("object"===(void 0===a?"undefined":_type_of(a))&&null!==a){var _=legacy_copy(a,i);s.push(a),o.push(_);var w=i.includeSymbols?own_enumerable_keys:Object.keys,x=!0,C=!1,j=void 0;try{for(var L,B=w(a)[Symbol.iterator]();!(x=(L=B.next()).done);x=!0){var $=L.value;_[$]=clone(a[$])}}catch(s){C=!0,j=s}finally{try{x||null==B.return||B.return()}finally{if(C)throw j}}return s.pop(),o.pop(),_}return a}(__privateGet(this,_l))}}]),Traverse}();_l=new WeakMap,El=new WeakMap;var traverse=function(s,o){return new xl(s,o)};traverse.get=function(s,o,i){return new xl(s,i).get(o)},traverse.set=function(s,o,i,a){return new xl(s,a).set(o,i)},traverse.has=function(s,o,i){return new xl(s,i).has(o)},traverse.map=function(s,o,i){return new xl(s,i).map(o)},traverse.forEach=function(s,o,i){return new xl(s,i).forEach(o)},traverse.reduce=function(s,o,i,a){return new xl(s,a).reduce(o,i)},traverse.paths=function(s,o){return new xl(s,o).paths()},traverse.nodes=function(s,o){return new xl(s,o).nodes()},traverse.clone=function(s,o){return new xl(s,o).clone()};var kl=traverse;const Ol="application/json, application/yaml",Al="https://swagger.io",Cl=Object.freeze({url:"/"}),Pl=3e3,Il=["properties"],Tl=["properties"],Nl=["definitions","parameters","responses","securityDefinitions","components/schemas","components/responses","components/parameters","components/securitySchemes"],Ml=["schema/example","items/example"];function isFreelyNamed(s){const o=s[s.length-1],i=s[s.length-2],a=s.join("/");return Il.indexOf(o)>-1&&-1===Tl.indexOf(i)||Nl.indexOf(a)>-1||Ml.some((s=>a.indexOf(s)>-1))}function absolutifyPointer(s,o){const[i,a]=s.split("#"),u=o??"",_=i??"";let w;if(isHttpUrl(u))w=resolve(u,_);else{const s=resolve(Al,u),o=resolve(s,_).replace(Al,"");w=_.startsWith("/")?o:o.substring(1)}return a?`${w}#${a}`:w}const Rl=/^([a-z]+:\/\/|\/\/)/i;class JSONRefError extends Go{}const Dl={},Ll=new WeakMap,Fl=[s=>"paths"===s[0]&&"responses"===s[3]&&"examples"===s[5],s=>"paths"===s[0]&&"responses"===s[3]&&"content"===s[5]&&"example"===s[7],s=>"paths"===s[0]&&"responses"===s[3]&&"content"===s[5]&&"examples"===s[7]&&"value"===s[9],s=>"paths"===s[0]&&"requestBody"===s[3]&&"content"===s[4]&&"example"===s[6],s=>"paths"===s[0]&&"requestBody"===s[3]&&"content"===s[4]&&"examples"===s[6]&&"value"===s[8],s=>"paths"===s[0]&&"parameters"===s[2]&&"example"===s[4],s=>"paths"===s[0]&&"parameters"===s[3]&&"example"===s[5],s=>"paths"===s[0]&&"parameters"===s[2]&&"examples"===s[4]&&"value"===s[6],s=>"paths"===s[0]&&"parameters"===s[3]&&"examples"===s[5]&&"value"===s[7],s=>"paths"===s[0]&&"parameters"===s[2]&&"content"===s[4]&&"example"===s[6],s=>"paths"===s[0]&&"parameters"===s[2]&&"content"===s[4]&&"examples"===s[6]&&"value"===s[8],s=>"paths"===s[0]&&"parameters"===s[3]&&"content"===s[4]&&"example"===s[7],s=>"paths"===s[0]&&"parameters"===s[3]&&"content"===s[5]&&"examples"===s[7]&&"value"===s[9]],Bl={key:"$ref",plugin:(s,o,i,a)=>{const u=a.getInstance(),_=i.slice(0,-1);if(isFreelyNamed(_)||(s=>Fl.some((o=>o(s))))(_))return;const{baseDoc:w}=a.getContext(i);if("string"!=typeof s)return new JSONRefError("$ref: must be a string (JSON-Ref)",{$ref:s,baseDoc:w,fullPath:i});const x=refs_split(s),C=x[0],j=x[1]||"";let L,B,$;try{L=w||C?absoluteify(C,w):null}catch(o){return wrapError(o,{pointer:j,$ref:s,basePath:L,fullPath:i})}if(function pointerAlreadyInPath(s,o,i,a){let u=Ll.get(a);u||(u={},Ll.set(a,u));const _=function arrayToJsonPointer(s){if(0===s.length)return"";return`/${s.map(escapeJsonPointerToken).join("/")}`}(i),w=`${o||"<specmap-base>"}#${s}`,x=_.replace(/allOf\/\d+\/?/g,""),C=a.contextTree.get([]).baseDoc;if(o===C&&pointerIsAParent(x,s))return!0;let j="";const L=i.some((s=>(j=`${j}/${escapeJsonPointerToken(s)}`,u[j]&&u[j].some((s=>pointerIsAParent(s,w)||pointerIsAParent(w,s))))));if(L)return!0;return void(u[x]=(u[x]||[]).concat(w))}(j,L,_,a)&&!u.useCircularStructures){const o=absolutifyPointer(s,L);return s===o?null:Wo.replace(i,o)}if(null==L?($=jsonPointerToArray(j),B=a.get($),void 0===B&&(B=new JSONRefError(`Could not resolve reference: ${s}`,{pointer:j,$ref:s,baseDoc:w,fullPath:i}))):(B=extractFromDoc(L,j),B=null!=B.__value?B.__value:B.catch((o=>{throw wrapError(o,{pointer:j,$ref:s,baseDoc:w,fullPath:i})}))),B instanceof Error)return[Wo.remove(i),B];const U=absolutifyPointer(s,L),V=Wo.replace(_,B,{$$ref:U});if(L&&L!==w)return[V,Wo.context(_,{baseDoc:L})];try{if(!function patchValueAlreadyInPath(s,o){const i=[s];return o.path.reduce(((s,o)=>(i.push(s[o]),s[o])),s),pointToAncestor(o.value);function pointToAncestor(s){return Wo.isObject(s)&&(i.indexOf(s)>=0||Object.keys(s).some((o=>pointToAncestor(s[o]))))}}(a.state,V)||u.useCircularStructures)return V}catch(s){return null}}},$l=Object.assign(Bl,{docCache:Dl,absoluteify,clearCache:function clearCache(s){void 0!==s?delete Dl[s]:Object.keys(Dl).forEach((s=>{delete Dl[s]}))},JSONRefError,wrapError,getDoc,split:refs_split,extractFromDoc,fetchJSON:function fetchJSON(s){return fetch(s,{headers:{Accept:Ol},loadSpec:!0}).then((s=>s.text())).then((s=>fn.load(s)))},extract,jsonPointerToArray,unescapeJsonPointerToken}),Ul=$l;function absoluteify(s,o){if(!Rl.test(s)){if(!o)throw new JSONRefError(`Tried to resolve a relative URL, without having a basePath. path: '${s}' basePath: '${o}'`);return resolve(o,s)}return s}function wrapError(s,o){let i;return i=s&&s.response&&s.response.body?`${s.response.body.code} ${s.response.body.message}`:s.message,new JSONRefError(`Could not resolve reference: ${i}`,{...o,cause:s})}function refs_split(s){return(s+"").split("#")}function extractFromDoc(s,o){const i=Dl[s];if(i&&!Wo.isPromise(i))try{const s=extract(o,i);return Object.assign(Promise.resolve(s),{__value:s})}catch(s){return Promise.reject(s)}return getDoc(s).then((s=>extract(o,s)))}function getDoc(s){const o=Dl[s];return o?Wo.isPromise(o)?o:Promise.resolve(o):(Dl[s]=$l.fetchJSON(s).then((o=>(Dl[s]=o,o))),Dl[s])}function extract(s,o){const i=jsonPointerToArray(s);if(i.length<1)return o;const a=Wo.getIn(o,i);if(void 0===a)throw new JSONRefError(`Could not resolve pointer: ${s} does not exist in document`,{pointer:s});return a}function jsonPointerToArray(s){if("string"!=typeof s)throw new TypeError("Expected a string, got a "+typeof s);return"/"===s[0]&&(s=s.substr(1)),""===s?[]:s.split("/").map(unescapeJsonPointerToken)}function unescapeJsonPointerToken(s){if("string"!=typeof s)return s;return new URLSearchParams(`=${s.replace(/~1/g,"/").replace(/~0/g,"~")}`).get("")}function escapeJsonPointerToken(s){return new URLSearchParams([["",s.replace(/~/g,"~0").replace(/\//g,"~1")]]).toString().slice(1)}const pointerBoundaryChar=s=>!s||"/"===s||"#"===s;function pointerIsAParent(s,o){if(pointerBoundaryChar(o))return!0;const i=s.charAt(o.length),a=o.slice(-1);return 0===s.indexOf(o)&&(!i||"/"===i||"#"===i)&&"#"!==a}const Vl={key:"allOf",plugin:(s,o,i,a,u)=>{if(u.meta&&u.meta.$$ref)return;const _=i.slice(0,-1);if(isFreelyNamed(_))return;if(!Array.isArray(s)){const s=new TypeError("allOf must be an array");return s.fullPath=i,s}let w=!1,x=u.value;if(_.forEach((s=>{x&&(x=x[s])})),x={...x},0===Object.keys(x).length)return;delete x.allOf;const C=[];return C.push(a.replace(_,{})),s.forEach(((s,o)=>{if(!a.isObject(s)){if(w)return null;w=!0;const s=new TypeError("Elements in allOf must be objects");return s.fullPath=i,C.push(s)}C.push(a.mergeDeep(_,s));const u=function generateAbsoluteRefPatches(s,o,{specmap:i,getBaseUrlForNodePath:a=s=>i.getContext([...o,...s]).baseDoc,targetKeys:u=["$ref","$$ref"]}={}){const _=[];return kl(s).forEach((function callback(){if(tl()(u).call(u,this.key)&&"string"==typeof this.node){const s=this.path,u=o.concat(this.path),w=absolutifyPointer(this.node,a(s));_.push(i.replace(u,w))}})),_}(s,i.slice(0,-1),{getBaseUrlForNodePath:s=>a.getContext([...i,o,...s]).baseDoc,specmap:a});C.push(...u)})),x.example&&C.push(a.remove([].concat(_,"example"))),C.push(a.mergeDeep(_,x)),x.$$ref||C.push(a.remove([].concat(_,"$$ref"))),C}},zl={key:"parameters",plugin:(s,o,i,a)=>{if(Array.isArray(s)&&s.length){const o=Object.assign([],s),u=i.slice(0,-1),_={...Wo.getIn(a.spec,u)};for(let u=0;u<s.length;u+=1){const w=s[u];try{o[u].default=a.parameterMacro(_,w)}catch(s){const o=new Error(s);return o.fullPath=i,o}}return Wo.replace(i,o)}return Wo.replace(i,s)}},Wl={key:"properties",plugin:(s,o,i,a)=>{const u={...s};for(const o in s)try{u[o].default=a.modelPropertyMacro(u[o])}catch(s){const o=new Error(s);return o.fullPath=i,o}return Wo.replace(i,u)}};class ContextTree{constructor(s){this.root=context_tree_createNode(s||{})}set(s,o){const i=this.getParent(s,!0);if(!i)return void context_tree_updateNode(this.root,o,null);const a=s[s.length-1],{children:u}=i;u[a]?context_tree_updateNode(u[a],o,i):u[a]=context_tree_createNode(o,i)}get(s){if((s=s||[]).length<1)return this.root.value;let o,i,a=this.root;for(let u=0;u<s.length&&(i=s[u],o=a.children,o[i]);u+=1)a=o[i];return a&&a.protoValue}getParent(s,o){return!s||s.length<1?null:s.length<2?this.root:s.slice(0,-1).reduce(((s,i)=>{if(!s)return s;const{children:a}=s;return!a[i]&&o&&(a[i]=context_tree_createNode(null,s)),a[i]}),this.root)}}function context_tree_createNode(s,o){return context_tree_updateNode({children:{}},s,o)}function context_tree_updateNode(s,o,i){return s.value=o||{},s.protoValue=i?{...i.protoValue,...s.value}:s.value,Object.keys(s.children).forEach((o=>{const i=s.children[o];s.children[o]=context_tree_updateNode(i,i.value,s)})),s}const specmap_noop=()=>{};class SpecMap{static getPluginName(s){return s.pluginName}static getPatchesOfType(s,o){return s.filter(o)}constructor(s){Object.assign(this,{spec:"",debugLevel:"info",plugins:[],pluginHistory:{},errors:[],mutations:[],promisedPatches:[],state:{},patches:[],context:{},contextTree:new ContextTree,showDebug:!1,allPatches:[],pluginProp:"specMap",libMethods:Object.assign(Object.create(this),Wo,{getInstance:()=>this}),allowMetaPatches:!1},s),this.get=this._get.bind(this),this.getContext=this._getContext.bind(this),this.hasRun=this._hasRun.bind(this),this.wrappedPlugins=this.plugins.map(this.wrapPlugin.bind(this)).filter(Wo.isFunction),this.patches.push(Wo.add([],this.spec)),this.patches.push(Wo.context([],this.context)),this.updatePatches(this.patches)}debug(s,...o){this.debugLevel===s&&console.log(...o)}verbose(s,...o){"verbose"===this.debugLevel&&console.log(`[${s}]   `,...o)}wrapPlugin(s,o){const{pathDiscriminator:i}=this;let a,u=null;return s[this.pluginProp]?(u=s,a=s[this.pluginProp]):Wo.isFunction(s)?a=s:Wo.isObject(s)&&(a=function createKeyBasedPlugin(s){const isSubPath=(s,o)=>!Array.isArray(s)||s.every(((s,i)=>s===o[i]));return function*generator(o,a){const u={};for(const[s,i]of o.filter(Wo.isAdditiveMutation).entries()){if(!(s<Pl))return;yield*traverse(i.value,i.path,i)}function*traverse(o,_,w){if(Wo.isObject(o)){const x=_.length-1,C=_[x],j=_.indexOf("properties"),L="properties"===C&&x===j,B=a.allowMetaPatches&&u[o.$$ref];for(const x of Object.keys(o)){const C=o[x],j=_.concat(x),$=Wo.isObject(C),U=o.$$ref;if(B||$&&(a.allowMetaPatches&&U&&isSubPath(i,j)&&(u[U]=!0),yield*traverse(C,j,w)),!L&&x===s.key){const o=isSubPath(i,_);i&&!o||(yield s.plugin(C,x,j,a,w))}}}else s.key===_[_.length-1]&&(yield s.plugin(o,s.key,_,a))}}}(s)),Object.assign(a.bind(u),{pluginName:s.name||o,isGenerator:Wo.isGenerator(a)})}nextPlugin(){return this.wrappedPlugins.find((s=>this.getMutationsForPlugin(s).length>0))}nextPromisedPatch(){if(this.promisedPatches.length>0)return Promise.race(this.promisedPatches.map((s=>s.value)))}getPluginHistory(s){const o=this.constructor.getPluginName(s);return this.pluginHistory[o]||[]}getPluginRunCount(s){return this.getPluginHistory(s).length}getPluginHistoryTip(s){const o=this.getPluginHistory(s);return o&&o[o.length-1]||{}}getPluginMutationIndex(s){const o=this.getPluginHistoryTip(s).mutationIndex;return"number"!=typeof o?-1:o}updatePluginHistory(s,o){const i=this.constructor.getPluginName(s);this.pluginHistory[i]=this.pluginHistory[i]||[],this.pluginHistory[i].push(o)}updatePatches(s){Wo.normalizeArray(s).forEach((s=>{if(s instanceof Error)this.errors.push(s);else try{if(!Wo.isObject(s))return void this.debug("updatePatches","Got a non-object patch",s);if(this.showDebug&&this.allPatches.push(s),Wo.isPromise(s.value))return this.promisedPatches.push(s),void this.promisedPatchThen(s);if(Wo.isContextPatch(s))return void this.setContext(s.path,s.value);Wo.isMutation(s)&&this.updateMutations(s)}catch(s){console.error(s),this.errors.push(s)}}))}updateMutations(s){"object"==typeof s.value&&!Array.isArray(s.value)&&this.allowMetaPatches&&(s.value={...s.value});const o=Wo.applyPatch(this.state,s,{allowMetaPatches:this.allowMetaPatches});o&&(this.mutations.push(s),this.state=o)}removePromisedPatch(s){const o=this.promisedPatches.indexOf(s);o<0?this.debug("Tried to remove a promisedPatch that isn't there!"):this.promisedPatches.splice(o,1)}promisedPatchThen(s){return s.value=s.value.then((o=>{const i={...s,value:o};this.removePromisedPatch(s),this.updatePatches(i)})).catch((o=>{this.removePromisedPatch(s),this.updatePatches(o)})),s.value}getMutations(s,o){return s=s||0,"number"!=typeof o&&(o=this.mutations.length),this.mutations.slice(s,o)}getCurrentMutations(){return this.getMutationsForPlugin(this.getCurrentPlugin())}getMutationsForPlugin(s){const o=this.getPluginMutationIndex(s);return this.getMutations(o+1)}getCurrentPlugin(){return this.currentPlugin}getLib(){return this.libMethods}_get(s){return Wo.getIn(this.state,s)}_getContext(s){return this.contextTree.get(s)}setContext(s,o){return this.contextTree.set(s,o)}_hasRun(s){return this.getPluginRunCount(this.getCurrentPlugin())>(s||0)}dispatch(){const s=this,o=this.nextPlugin();if(!o){const s=this.nextPromisedPatch();if(s)return s.then((()=>this.dispatch())).catch((()=>this.dispatch()));const o={spec:this.state,errors:this.errors};return this.showDebug&&(o.patches=this.allPatches),Promise.resolve(o)}if(s.pluginCount=s.pluginCount||new WeakMap,s.pluginCount.set(o,(s.pluginCount.get(o)||0)+1),s.pluginCount[o]>100)return Promise.resolve({spec:s.state,errors:s.errors.concat(new Error("We've reached a hard limit of 100 plugin runs"))});if(o!==this.currentPlugin&&this.promisedPatches.length){const s=this.promisedPatches.map((s=>s.value));return Promise.all(s.map((s=>s.then(specmap_noop,specmap_noop)))).then((()=>this.dispatch()))}return function executePlugin(){s.currentPlugin=o;const i=s.getCurrentMutations(),a=s.mutations.length-1;try{if(o.isGenerator)for(const a of o(i,s.getLib()))updatePatches(a);else{updatePatches(o(i,s.getLib()))}}catch(s){console.error(s),updatePatches([Object.assign(Object.create(s),{plugin:o})])}finally{s.updatePluginHistory(o,{mutationIndex:a})}return s.dispatch()}();function updatePatches(i){i&&(i=Wo.fullyNormalizeArray(i),s.updatePatches(i,o))}}}const Jl={refs:Ul,allOf:Vl,parameters:zl,properties:Wl};function makeFetchJSON(s,o={}){const{requestInterceptor:i,responseInterceptor:a}=o,u=s.withCredentials?"include":"same-origin";return o=>s({url:o,loadSpec:!0,requestInterceptor:i,responseInterceptor:a,headers:{Accept:Ol},credentials:u}).then((s=>s.body))}function isFile(s,o){return o||"undefined"==typeof navigator||(o=navigator),o&&"ReactNative"===o.product?!(!s||"object"!=typeof s||"string"!=typeof s.uri):"undefined"!=typeof File&&s instanceof File||("undefined"!=typeof Blob&&s instanceof Blob||(!!ArrayBuffer.isView(s)||null!==s&&"object"==typeof s&&"function"==typeof s.pipe))}function isArrayOfFile(s,o){return Array.isArray(s)&&s.some((s=>isFile(s,o)))}class FileWithData extends File{constructor(s,o="",i={}){super([s],o,i),this.data=s}valueOf(){return this.data}toString(){return this.valueOf()}}const isRfc3986Reserved=s=>":/?#[]@!$&'()*+,;=".indexOf(s)>-1,isRfc3986Unreserved=s=>/^[a-z0-9\-._~]+$/i.test(s);function encodeCharacters(s,o="reserved"){return[...s].map((s=>{if(isRfc3986Unreserved(s))return s;if(isRfc3986Reserved(s)&&"unsafe"===o)return s;const i=new TextEncoder;return Array.from(i.encode(s)).map((s=>`0${s.toString(16).toUpperCase()}`.slice(-2))).map((s=>`%${s}`)).join("")})).join("")}function stylize(s){const{value:o}=s;return Array.isArray(o)?function encodeArray({key:s,value:o,style:i,explode:a,escape:u}){if("simple"===i)return o.map((s=>valueEncoder(s,u))).join(",");if("label"===i)return`.${o.map((s=>valueEncoder(s,u))).join(".")}`;if("matrix"===i)return o.map((s=>valueEncoder(s,u))).reduce(((o,i)=>!o||a?`${o||""};${s}=${i}`:`${o},${i}`),"");if("form"===i){const i=a?`&${s}=`:",";return o.map((s=>valueEncoder(s,u))).join(i)}if("spaceDelimited"===i){const i=a?`${s}=`:"";return o.map((s=>valueEncoder(s,u))).join(` ${i}`)}if("pipeDelimited"===i){const i=a?`${s}=`:"";return o.map((s=>valueEncoder(s,u))).join(`|${i}`)}return}(s):"object"==typeof o?function encodeObject({key:s,value:o,style:i,explode:a,escape:u}){const _=Object.keys(o);if("simple"===i)return _.reduce(((s,i)=>{const _=valueEncoder(o[i],u);return`${s?`${s},`:""}${i}${a?"=":","}${_}`}),"");if("label"===i)return _.reduce(((s,i)=>{const _=valueEncoder(o[i],u);return`${s?`${s}.`:"."}${i}${a?"=":"."}${_}`}),"");if("matrix"===i&&a)return _.reduce(((s,i)=>`${s?`${s};`:";"}${i}=${valueEncoder(o[i],u)}`),"");if("matrix"===i)return _.reduce(((i,a)=>{const _=valueEncoder(o[a],u);return`${i?`${i},`:`;${s}=`}${a},${_}`}),"");if("form"===i)return _.reduce(((s,i)=>{const _=valueEncoder(o[i],u);return`${s?`${s}${a?"&":","}`:""}${i}${a?"=":","}${_}`}),"");return}(s):function encodePrimitive({key:s,value:o,style:i,escape:a}){if("simple"===i)return valueEncoder(o,a);if("label"===i)return`.${valueEncoder(o,a)}`;if("matrix"===i)return`;${s}=${valueEncoder(o,a)}`;if("form"===i)return valueEncoder(o,a);if("deepObject"===i)return valueEncoder(o,a);return}(s)}function valueEncoder(s,o=!1){return Array.isArray(s)||null!==s&&"object"==typeof s?s=JSON.stringify(s):"number"!=typeof s&&"boolean"!=typeof s||(s=String(s)),o&&"string"==typeof s&&s.length>0?encodeCharacters(s,o):s??""}const Hl={form:",",spaceDelimited:"%20",pipeDelimited:"|"},Kl={csv:",",ssv:"%20",tsv:"%09",pipes:"|"};function formatKeyValue(s,o,i=!1){const{collectionFormat:a,allowEmptyValue:u,serializationOption:_,encoding:w}=o,x="object"!=typeof o||Array.isArray(o)?o:o.value,C=i?s=>s.toString():s=>encodeURIComponent(s),j=C(s);if(void 0===x&&u)return[[j,""]];if(isFile(x)||isArrayOfFile(x))return[[j,x]];if(_)return formatKeyValueBySerializationOption(s,x,i,_);if(w){if([typeof w.style,typeof w.explode,typeof w.allowReserved].some((s=>"undefined"!==s))){const{style:o,explode:a,allowReserved:u}=w;return formatKeyValueBySerializationOption(s,x,i,{style:o,explode:a,allowReserved:u})}if("string"==typeof w.contentType){if(w.contentType.startsWith("application/json")){const s=C("string"==typeof x?x:JSON.stringify(x));return[[j,new FileWithData(s,"blob",{type:w.contentType})]]}const s=C(String(x));return[[j,new FileWithData(s,"blob",{type:w.contentType})]]}return"object"!=typeof x?[[j,C(x)]]:Array.isArray(x)&&x.every((s=>"object"!=typeof s))?[[j,x.map(C).join(",")]]:[[j,C(JSON.stringify(x))]]}return"object"!=typeof x?[[j,C(x)]]:Array.isArray(x)?"multi"===a?[[j,x.map(C)]]:[[j,x.map(C).join(Kl[a||"csv"])]]:[[j,""]]}function formatKeyValueBySerializationOption(s,o,i,a){const u=a.style||"form",_=void 0===a.explode?"form"===u:a.explode,w=!i&&(a&&a.allowReserved?"unsafe":"reserved"),encodeFn=s=>valueEncoder(s,w),x=i?s=>s:s=>encodeFn(s);return"object"!=typeof o?[[x(s),encodeFn(o)]]:Array.isArray(o)?_?[[x(s),o.map(encodeFn)]]:[[x(s),o.map(encodeFn).join(Hl[u])]]:"deepObject"===u?Object.keys(o).map((i=>[x(`${s}[${i}]`),encodeFn(o[i])])):_?Object.keys(o).map((s=>[x(s),encodeFn(o[s])])):[[x(s),Object.keys(o).map((s=>[`${x(s)},${encodeFn(o[s])}`])).join(",")]]}function encodeFormOrQuery(s){return((s,{encode:o=!0}={})=>{const buildNestedParams=(s,o,i)=>(Array.isArray(i)?i.reduce(((i,a)=>buildNestedParams(s,o,a)),s):i instanceof Date?s.append(o,i.toISOString()):"object"==typeof i?Object.entries(i).reduce(((i,[a,u])=>buildNestedParams(s,`${o}[${a}]`,u)),s):s.append(o,i),s),i=Object.entries(s).reduce(((s,[o,i])=>buildNestedParams(s,o,i)),new URLSearchParams),a=String(i);return o?a:decodeURIComponent(a)})(Object.keys(s).reduce(((o,i)=>{for(const[a,u]of formatKeyValue(i,s[i]))o[a]=u instanceof FileWithData?u.valueOf():u;return o}),{}),{encode:!1})}function serializeRequest(s={}){const{url:o="",query:i,form:a}=s;if(a){const o=Object.keys(a).some((s=>{const{value:o}=a[s];return isFile(o)||isArrayOfFile(o)})),i=s.headers["content-type"]||s.headers["Content-Type"];if(o||/multipart\/form-data/i.test(i)){const o=function request_buildFormData(s){return Object.entries(s).reduce(((s,[o,i])=>{for(const[a,u]of formatKeyValue(o,i,!0))if(Array.isArray(u))for(const o of u)if(ArrayBuffer.isView(o)){const i=new Blob([o]);s.append(a,i)}else s.append(a,o);else if(ArrayBuffer.isView(u)){const o=new Blob([u]);s.append(a,o)}else s.append(a,u);return s}),new FormData)}(s.form);s.formdata=o,s.body=o}else s.body=encodeFormOrQuery(a);delete s.form}if(i){const[a,u]=o.split("?");let _="";if(u){const s=new URLSearchParams(u);Object.keys(i).forEach((o=>s.delete(o))),_=String(s)}const w=((...s)=>{const o=s.filter((s=>s)).join("&");return o?`?${o}`:""})(_,encodeFormOrQuery(i));s.url=a+w,delete s.query}return s}function serializeHeaders(s={}){return"function"!=typeof s.entries?{}:Array.from(s.entries()).reduce(((s,[o,i])=>(s[o]=function serializeHeaderValue(s){return tl()(s).call(s,", ")?s.split(", "):s}(i),s)),{})}function serializeResponse(s,o,{loadSpec:i=!1}={}){const a={ok:s.ok,url:s.url||o,status:s.status,statusText:s.statusText,headers:serializeHeaders(s.headers)},u=a.headers["content-type"],_=i||((s="")=>/(json|xml|yaml|text)\b/.test(s))(u);return(_?s.text:s.blob||s.buffer).call(s).then((s=>{if(a.text=s,a.data=s,_)try{const o=function parseBody(s,o){if(o){if(0===o.indexOf("application/json")||o.indexOf("+json")>0)return JSON.parse(s);if(0===o.indexOf("application/xml")||o.indexOf("+xml")>0)return s}return fn.load(s)}(s,u);a.body=o,a.obj=o}catch(s){a.parseError=s}return a}))}async function http_http(s,o={}){"object"==typeof s&&(s=(o=s).url),o.headers=o.headers||{},(o=serializeRequest(o)).headers&&Object.keys(o.headers).forEach((s=>{const i=o.headers[s];"string"==typeof i&&(o.headers[s]=i.replace(/\n+/g," "))})),o.requestInterceptor&&(o=await o.requestInterceptor(o)||o);const i=o.headers["content-type"]||o.headers["Content-Type"];let a;/multipart\/form-data/i.test(i)&&(delete o.headers["content-type"],delete o.headers["Content-Type"]);try{a=await(o.userFetch||fetch)(o.url,o),a=await serializeResponse(a,s,o),o.responseInterceptor&&(a=await o.responseInterceptor(a)||a)}catch(s){if(!a)throw s;const o=new Error(a.statusText||`response status is ${a.status}`);throw o.status=a.status,o.statusCode=a.status,o.responseError=s,o}if(!a.ok){const s=new Error(a.statusText||`response status is ${a.status}`);throw s.status=a.status,s.statusCode=a.status,s.response=a,s}return a}const options_retrievalURI=s=>{const{baseDoc:o,url:i}=s,a=o??i??"";return"string"==typeof globalThis.document?.baseURI?String(new URL(a,globalThis.document.baseURI)):a},options_httpClient=s=>{const{fetch:o,http:i}=s;return o||i||http_http};async function resolveGenericStrategy(s){const{spec:o,mode:i,allowMetaPatches:a=!0,pathDiscriminator:u,modelPropertyMacro:_,parameterMacro:w,requestInterceptor:x,responseInterceptor:C,skipNormalization:j=!1,useCircularStructures:L,strategies:B}=s,$=options_retrievalURI(s),U=options_httpClient(s),V=B.find((s=>s.match(o)));return async function doResolve(s){$&&(Jl.refs.docCache[$]=s);Jl.refs.fetchJSON=makeFetchJSON(U,{requestInterceptor:x,responseInterceptor:C});const o=[Jl.refs];"function"==typeof w&&o.push(Jl.parameters);"function"==typeof _&&o.push(Jl.properties);"strict"!==i&&o.push(Jl.allOf);const B=await function mapSpec(s){return new SpecMap(s).dispatch()}({spec:s,context:{baseDoc:$},plugins:o,allowMetaPatches:a,pathDiscriminator:u,parameterMacro:w,modelPropertyMacro:_,useCircularStructures:L});j||(B.spec=V.normalize(B.spec));return B}(o)}function _path(s,o){for(var i=o,a=0;a<s.length;a+=1){if(null==i)return;var u=s[a];i=ra(u)?_nth(u,i):i[u]}return i}const Gl=_curry3((function pathSatisfies(s,o,i){return s(_path(o,i))}));const Yl=_curry2((function and(s,o){return s&&o}));const Xl=_curry2((function both(s,o){return _isFunction(s)?function _both(){return s.apply(this,arguments)&&o.apply(this,arguments)}:ac(Yl)(s,o)}));const Ql=ka(null);const Zl=cc(Ql);function isOfTypeObject_typeof(s){return isOfTypeObject_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(s){return typeof s}:function(s){return s&&"function"==typeof Symbol&&s.constructor===Symbol&&s!==Symbol.prototype?"symbol":typeof s},isOfTypeObject_typeof(s)}const eu=function isOfTypeObject(s){return"object"===isOfTypeObject_typeof(s)};const tu=la(1,Xl(Zl,eu));var ru=pipe(xa,Ec("Object")),nu=pipe(La,ka(La(Object))),su=Gl(Xl(jc,nu),["constructor"]),ou=la(1,(function(s){if(!tu(s)||!ru(s))return!1;var o=Object.getPrototypeOf(s);return!!Ql(o)||su(o)}));const iu=ou,replace_special_chars_with_underscore=s=>s.replace(/\W/gi,"_");function opId(s,o,i="",{v2OperationIdCompatibilityMode:a}={}){if(!s||"object"!=typeof s)return null;return(s.operationId||"").replace(/\s/g,"").length?replace_special_chars_with_underscore(s.operationId):function idFromPathMethod(s,o,{v2OperationIdCompatibilityMode:i}={}){if(i){let i=`${o.toLowerCase()}_${s}`.replace(/[\s!@#$%^&*()_+=[{\]};:<>|./?,\\'""-]/g,"_");return i=i||`${s.substring(1)}_${o}`,i.replace(/((_){2,})/g,"_").replace(/^(_)*/g,"").replace(/([_])*$/g,"")}return`${o.toLowerCase()}${replace_special_chars_with_underscore(s)}`}(o,i,{v2OperationIdCompatibilityMode:a})}function normalize(s){const{spec:o}=s,{paths:i}=o,a={};if(!i||o.$$normalized)return s;for(const s in i){var u;const w=i[s];if(null==w||!tl()(u=["object","function"]).call(u,typeof w))continue;const x=w.parameters;for(const i in w){var _;const u=w[i];if(null==u||!tl()(_=["object","function"]).call(_,typeof u))continue;const C=opId(u,s,i);if(C){a[C]?a[C].push(u):a[C]=[u];const s=a[C];if(s.length>1)s.forEach(((s,o)=>{s.__originalOperationId=s.__originalOperationId||s.operationId,s.operationId=`${C}${o+1}`}));else if(void 0!==u.operationId){const o=s[0];o.__originalOperationId=o.__originalOperationId||u.operationId,o.operationId=C}}if("parameters"!==i){const s=[],i={};for(const a in o)"produces"!==a&&"consumes"!==a&&"security"!==a||(i[a]=o[a],s.push(i));if(x&&(i.parameters=x,s.push(i)),s.length)for(const o of s)for(const s in o)if(Array.isArray(u[s])){if("parameters"===s)for(const i of o[s]){u[s].some((s=>!(!iu(s)&&!iu(i))&&(s===i||["name","$ref","$$ref"].some((o=>"string"==typeof s[o]&&"string"==typeof i[o]&&s[o]===i[o])))))||u[s].push(i)}}else u[s]=o[s]}}}return o.$$normalized=!0,s}const au={name:"generic",match:()=>!0,normalize(s){const{spec:o}=normalize({spec:s});return o},resolve:async s=>resolveGenericStrategy(s)},cu=au;const isOpenAPI30=s=>{try{const{openapi:o}=s;return"string"==typeof o&&/^3\.0\.(?:[1-9]\d*|0)$/.test(o)}catch{return!1}},isOpenAPI31=s=>{try{const{openapi:o}=s;return"string"==typeof o&&/^3\.1\.(?:[1-9]\d*|0)$/.test(o)}catch{return!1}},isOpenAPI3=s=>isOpenAPI30(s)||isOpenAPI31(s)||(s=>{try{const{openapi:o}=s;return"string"==typeof o&&/^3\.2\.(?:[1-9]\d*|0)$/.test(o)}catch{return!1}})(s),lu={name:"openapi-2",match:s=>(s=>{try{const{swagger:o}=s;return"2.0"===o}catch{return!1}})(s),normalize(s){const{spec:o}=normalize({spec:s});return o},resolve:async s=>async function resolveOpenAPI2Strategy(s){return resolveGenericStrategy(s)}(s)},uu=lu;const pu={name:"openapi-3-0",match:s=>isOpenAPI30(s),normalize(s){const{spec:o}=normalize({spec:s});return o},resolve:async s=>async function resolveOpenAPI30Strategy(s){return resolveGenericStrategy(s)}(s)},hu=pu;var du=__webpack_require__(34035);function _reduced(s){return s&&s["@@transducer/reduced"]?s:{"@@transducer/value":s,"@@transducer/reduced":!0}}var fu=function(){function XAll(s,o){this.xf=o,this.f=s,this.all=!0}return XAll.prototype["@@transducer/init"]=_xfBase_init,XAll.prototype["@@transducer/result"]=function(s){return this.all&&(s=this.xf["@@transducer/step"](s,!0)),this.xf["@@transducer/result"](s)},XAll.prototype["@@transducer/step"]=function(s,o){return this.f(o)||(this.all=!1,s=_reduced(this.xf["@@transducer/step"](s,!1))),s},XAll}();function _xall(s){return function(o){return new fu(s,o)}}var mu=_curry2(_dispatchable(["all"],_xall,(function all(s,o){for(var i=0;i<o.length;){if(!s(o[i]))return!1;i+=1}return!0})));const gu=mu;class Annotation extends du.Om{constructor(s,o,i){super(s,o,i),this.element="annotation"}get code(){return this.attributes.get("code")}set code(s){this.attributes.set("code",s)}}const yu=Annotation;class Comment extends du.Om{constructor(s,o,i){super(s,o,i),this.element="comment"}}const vu=Comment;class ParseResult extends du.wE{constructor(s,o,i){super(s,o,i),this.element="parseResult"}get api(){return this.children.filter((s=>s.classes.contains("api"))).first}get results(){return this.children.filter((s=>s.classes.contains("result")))}get result(){return this.results.first}get annotations(){return this.children.filter((s=>"annotation"===s.element))}get warnings(){return this.children.filter((s=>"annotation"===s.element&&s.classes.contains("warning")))}get errors(){return this.children.filter((s=>"annotation"===s.element&&s.classes.contains("error")))}get isEmpty(){return this.children.reject((s=>"annotation"===s.element)).isEmpty}replaceResult(s){const{result:o}=this;if(hc(o))return!1;const i=this.content.findIndex((s=>s===o));return-1!==i&&(this.content[i]=s,!0)}}const bu=ParseResult,hasMethod=(s,o)=>"object"==typeof o&&null!==o&&s in o&&"function"==typeof o[s],hasBasicElementProps=s=>"object"==typeof s&&null!=s&&"_storedElement"in s&&"string"==typeof s._storedElement&&"_content"in s,primitiveEq=(s,o)=>"object"==typeof o&&null!==o&&"primitive"in o&&("function"==typeof o.primitive&&o.primitive()===s),hasClass=(s,o)=>"object"==typeof o&&null!==o&&"classes"in o&&(Array.isArray(o.classes)||o.classes instanceof du.wE)&&o.classes.includes(s),isElementType=(s,o)=>"object"==typeof o&&null!==o&&"element"in o&&o.element===s,helpers=s=>s({hasMethod,hasBasicElementProps,primitiveEq,isElementType,hasClass}),Su=helpers((({hasBasicElementProps:s,primitiveEq:o})=>i=>i instanceof du.Hg||s(i)&&o(void 0,i))),_u=helpers((({hasBasicElementProps:s,primitiveEq:o})=>i=>i instanceof du.Om||s(i)&&o("string",i))),Eu=helpers((({hasBasicElementProps:s,primitiveEq:o})=>i=>i instanceof du.kT||s(i)&&o("number",i))),wu=helpers((({hasBasicElementProps:s,primitiveEq:o})=>i=>i instanceof du.Os||s(i)&&o("null",i))),xu=helpers((({hasBasicElementProps:s,primitiveEq:o})=>i=>i instanceof du.bd||s(i)&&o("boolean",i))),ku=helpers((({hasBasicElementProps:s,primitiveEq:o,hasMethod:i})=>a=>a instanceof du.Sh||s(a)&&o("object",a)&&i("keys",a)&&i("values",a)&&i("items",a))),Ou=helpers((({hasBasicElementProps:s,primitiveEq:o,hasMethod:i})=>a=>a instanceof du.wE&&!(a instanceof du.Sh)||s(a)&&o("array",a)&&i("push",a)&&i("unshift",a)&&i("map",a)&&i("reduce",a))),Au=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof du.Pr||s(a)&&o("member",a)&&i(void 0,a))),Cu=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof du.Ft||s(a)&&o("link",a)&&i(void 0,a))),ju=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof du.sI||s(a)&&o("ref",a)&&i(void 0,a))),Pu=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof yu||s(a)&&o("annotation",a)&&i("array",a))),Iu=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof vu||s(a)&&o("comment",a)&&i("string",a))),Tu=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof bu||s(a)&&o("parseResult",a)&&i("array",a))),isPrimitiveElement=s=>isElementType("object",s)||isElementType("array",s)||isElementType("boolean",s)||isElementType("number",s)||isElementType("string",s)||isElementType("null",s)||isElementType("member",s),hasElementSourceMap=s=>!!Su(s)&&(Number.isInteger(s.startPositionRow)&&Number.isInteger(s.startPositionColumn)&&Number.isInteger(s.startIndex)&&Number.isInteger(s.endPositionRow)&&Number.isInteger(s.endPositionColumn)&&Number.isInteger(s.endIndex)),includesSymbols=(s,o)=>{if(0===s.length)return!0;const i=o.attributes.get("symbols");return!!Ou(i)&&gu(Ha(i.toValue()),s)},includesClasses=(s,o)=>0===s.length||gu(Ha(o.classes.toValue()),s);const es_T=function(){return!0};const es_F=function(){return!1},getVisitFn=(s,o,i)=>{const a=s[o];if(null!=a){if(!i&&"function"==typeof a)return a;const s=i?a.leave:a.enter;if("function"==typeof s)return s}else{const a=i?s.leave:s.enter;if(null!=a){if("function"==typeof a)return a;const s=a[o];if("function"==typeof s)return s}}return null},Nu={},getNodeType=s=>null==s?void 0:s.type,isNode=s=>"string"==typeof getNodeType(s),cloneNode=s=>Object.create(Object.getPrototypeOf(s),Object.getOwnPropertyDescriptors(s)),mergeAll=(s,{visitFnGetter:o=getVisitFn,nodeTypeGetter:i=getNodeType,breakSymbol:a=Nu,deleteNodeSymbol:u=null,skipVisitingNodeSymbol:_=!1,exposeEdits:w=!1}={})=>{const x=Symbol("skip"),C=new Array(s.length).fill(x);return{enter(j,L,B,$,U,V){let z=j,Y=!1;const Z={...V,replaceWith(s,o){V.replaceWith(s,o),z=s}};for(let j=0;j<s.length;j+=1)if(C[j]===x){const x=o(s[j],i(z),!1);if("function"==typeof x){const o=x.call(s[j],z,L,B,$,U,Z);if("function"==typeof(null==o?void 0:o.then))throw new Go("Async visitor not supported in sync mode",{visitor:s[j],visitFn:x});if(o===_)C[j]=z;else if(o===a)C[j]=a;else{if(o===u)return o;if(void 0!==o){if(!w)return o;z=o,Y=!0}}}}return Y?z:void 0},leave(u,w,j,L,B,$){let U=u;const V={...$,replaceWith(s,o){$.replaceWith(s,o),U=s}};for(let u=0;u<s.length;u+=1)if(C[u]===x){const x=o(s[u],i(U),!0);if("function"==typeof x){const o=x.call(s[u],U,w,j,L,B,V);if("function"==typeof(null==o?void 0:o.then))throw new Go("Async visitor not supported in sync mode",{visitor:s[u],visitFn:x});if(o===a)C[u]=a;else if(void 0!==o&&o!==_)return o}}else C[u]===U&&(C[u]=x)}}};mergeAll[Symbol.for("nodejs.util.promisify.custom")]=(s,{visitFnGetter:o=getVisitFn,nodeTypeGetter:i=getNodeType,breakSymbol:a=Nu,deleteNodeSymbol:u=null,skipVisitingNodeSymbol:_=!1,exposeEdits:w=!1}={})=>{const x=Symbol("skip"),C=new Array(s.length).fill(x);return{async enter(j,L,B,$,U,V){let z=j,Y=!1;const Z={...V,replaceWith(s,o){V.replaceWith(s,o),z=s}};for(let j=0;j<s.length;j+=1)if(C[j]===x){const x=o(s[j],i(z),!1);if("function"==typeof x){const o=await x.call(s[j],z,L,B,$,U,Z);if(o===_)C[j]=z;else if(o===a)C[j]=a;else{if(o===u)return o;if(void 0!==o){if(!w)return o;z=o,Y=!0}}}}return Y?z:void 0},async leave(u,w,j,L,B,$){let U=u;const V={...$,replaceWith(s,o){$.replaceWith(s,o),U=s}};for(let u=0;u<s.length;u+=1)if(C[u]===x){const x=o(s[u],i(U),!0);if("function"==typeof x){const o=await x.call(s[u],U,w,j,L,B,V);if(o===a)C[u]=a;else if(void 0!==o&&o!==_)return o}}else C[u]===U&&(C[u]=x)}}};const visit=(s,o,{keyMap:i=null,state:a={},breakSymbol:u=Nu,deleteNodeSymbol:_=null,skipVisitingNodeSymbol:w=!1,visitFnGetter:x=getVisitFn,nodeTypeGetter:C=getNodeType,nodePredicate:j=isNode,nodeCloneFn:L=cloneNode,detectCycles:B=!0,detectCyclesCallback:$=null}={})=>{const U=i||{};let V,z,Y=Array.isArray(s),Z=[s],ee=-1,ie=[],ae=s;const ce=[],le=[];do{ee+=1;const s=ee===Z.length;let i;const fe=s&&0!==ie.length;if(s){if(i=0===le.length?void 0:ce.pop(),ae=z,z=le.pop(),fe)if(Y){ae=ae.slice();let s=0;for(const[o,i]of ie){const a=o-s;i===_?(ae.splice(a,1),s+=1):ae[a]=i}}else{ae=L(ae);for(const[s,o]of ie)ae[s]=o}ee=V.index,Z=V.keys,ie=V.edits,Y=V.inArray,V=V.prev}else if(z!==_&&void 0!==z){if(i=Y?ee:Z[ee],ae=z[i],ae===_||void 0===ae)continue;ce.push(i)}let ye;if(!Array.isArray(ae)){var pe;if(!j(ae))throw new Go(`Invalid AST Node:  ${String(ae)}`,{node:ae});if(B&&le.includes(ae)){"function"==typeof $&&$(ae,i,z,ce,le),ce.pop();continue}const _=x(o,C(ae),s);if(_){for(const[s,i]of Object.entries(a))o[s]=i;const u={replaceWith(o,a){"function"==typeof a?a(o,ae,i,z,ce,le):z&&(z[i]=o),s||(ae=o)}};ye=_.call(o,ae,i,z,ce,le,u)}if("function"==typeof(null===(pe=ye)||void 0===pe?void 0:pe.then))throw new Go("Async visitor not supported in sync mode",{visitor:o,visitFn:_});if(ye===u)break;if(ye===w){if(!s){ce.pop();continue}}else if(void 0!==ye&&(ie.push([i,ye]),!s)){if(!j(ye)){ce.pop();continue}ae=ye}}var de;if(void 0===ye&&fe&&ie.push([i,ae]),!s)V={inArray:Y,index:ee,keys:Z,edits:ie,prev:V},Y=Array.isArray(ae),Z=Y?ae:null!==(de=U[C(ae)])&&void 0!==de?de:[],ee=-1,ie=[],z!==_&&void 0!==z&&le.push(z),z=ae}while(void 0!==V);return 0!==ie.length?ie[ie.length-1][1]:s};visit[Symbol.for("nodejs.util.promisify.custom")]=async(s,o,{keyMap:i=null,state:a={},breakSymbol:u=Nu,deleteNodeSymbol:_=null,skipVisitingNodeSymbol:w=!1,visitFnGetter:x=getVisitFn,nodeTypeGetter:C=getNodeType,nodePredicate:j=isNode,nodeCloneFn:L=cloneNode,detectCycles:B=!0,detectCyclesCallback:$=null}={})=>{const U=i||{};let V,z,Y=Array.isArray(s),Z=[s],ee=-1,ie=[],ae=s;const ce=[],le=[];do{ee+=1;const s=ee===Z.length;let i;const de=s&&0!==ie.length;if(s){if(i=0===le.length?void 0:ce.pop(),ae=z,z=le.pop(),de)if(Y){ae=ae.slice();let s=0;for(const[o,i]of ie){const a=o-s;i===_?(ae.splice(a,1),s+=1):ae[a]=i}}else{ae=L(ae);for(const[s,o]of ie)ae[s]=o}ee=V.index,Z=V.keys,ie=V.edits,Y=V.inArray,V=V.prev}else if(z!==_&&void 0!==z){if(i=Y?ee:Z[ee],ae=z[i],ae===_||void 0===ae)continue;ce.push(i)}let fe;if(!Array.isArray(ae)){if(!j(ae))throw new Go(`Invalid AST Node: ${String(ae)}`,{node:ae});if(B&&le.includes(ae)){"function"==typeof $&&$(ae,i,z,ce,le),ce.pop();continue}const _=x(o,C(ae),s);if(_){for(const[s,i]of Object.entries(a))o[s]=i;const u={replaceWith(o,a){"function"==typeof a?a(o,ae,i,z,ce,le):z&&(z[i]=o),s||(ae=o)}};fe=await _.call(o,ae,i,z,ce,le,u)}if(fe===u)break;if(fe===w){if(!s){ce.pop();continue}}else if(void 0!==fe&&(ie.push([i,fe]),!s)){if(!j(fe)){ce.pop();continue}ae=fe}}var pe;if(void 0===fe&&de&&ie.push([i,ae]),!s)V={inArray:Y,index:ee,keys:Z,edits:ie,prev:V},Y=Array.isArray(ae),Z=Y?ae:null!==(pe=U[C(ae)])&&void 0!==pe?pe:[],ee=-1,ie=[],z!==_&&void 0!==z&&le.push(z),z=ae}while(void 0!==V);return 0!==ie.length?ie[ie.length-1][1]:s};const Mu=class CloneError extends Go{value;constructor(s,o){super(s,o),void 0!==o&&(this.value=o.value)}};const Ru=class DeepCloneError extends Mu{};const Du=class ShallowCloneError extends Mu{};const Lu=_curry2((function mapObjIndexed(s,o){return _arrayReduce((function(i,a){return i[a]=s(o[a],a,o),i}),{},wa(o))}));const Fu=_curry1((function isNil(s){return null==s}));var Bu=_curry2((function hasPath(s,o){if(0===s.length||Fu(o))return!1;for(var i=o,a=0;a<s.length;){if(Fu(i)||!_has(s[a],i))return!1;i=i[s[a]],a+=1}return!0}));const $u=Bu;var qu=_curry2((function has(s,o){return $u([s],o)}));const Uu=qu;const Vu=_curry3((function propSatisfies(s,o,i){return s(na(o,i))}));const zu=_curry2(_path);var Wu=function(){function XDropWhile(s,o){this.xf=o,this.f=s}return XDropWhile.prototype["@@transducer/init"]=_xfBase_init,XDropWhile.prototype["@@transducer/result"]=_xfBase_result,XDropWhile.prototype["@@transducer/step"]=function(s,o){if(this.f){if(this.f(o))return s;this.f=null}return this.xf["@@transducer/step"](s,o)},XDropWhile}();function _xdropWhile(s){return function(o){return new Wu(s,o)}}const Ju=_curry2(_dispatchable(["dropWhile"],_xdropWhile,(function dropWhile(s,o){for(var i=0,a=o.length;i<a&&s(o[i]);)i+=1;return Ri(i,1/0,o)})));const Hu=ua((function(s,o){return pipe(Ba(""),Ju(Ha(s)),Ja(""))(o)})),dereference=(s,o)=>{const i=ea(s,o);return Lu((s=>{if(iu(s)&&Uu("$ref",s)&&Vu(Rc,"$ref",s)){const o=zu(["$ref"],s),a=Hu("#/",o);return zu(a.split("/"),i)}return iu(s)?dereference(s,i):s}),s)},assignSourceMap=(s,o)=>(s.startPositionRow=null==o?void 0:o.startPositionRow,s.startPositionColumn=null==o?void 0:o.startPositionColumn,s.startIndex=null==o?void 0:o.startIndex,s.endPositionRow=null==o?void 0:o.endPositionRow,s.endPositionColumn=null==o?void 0:o.endPositionColumn,s.endIndex=null==o?void 0:o.endIndex,s),cloneDeep=(s,o={})=>{const{visited:i=new WeakMap}=o,a={...o,visited:i};if(i.has(s))return i.get(s);if(s instanceof du.KeyValuePair){const{key:o,value:u}=s,_=Su(o)?cloneDeep(o,a):o,w=Su(u)?cloneDeep(u,a):u,x=new du.KeyValuePair(_,w);return i.set(s,x),x}if(s instanceof du.ot){const mapper=s=>cloneDeep(s,a),o=[...s].map(mapper),u=new du.ot(o);return i.set(s,u),u}if(s instanceof du.G6){const mapper=s=>cloneDeep(s,a),o=[...s].map(mapper),u=new du.G6(o);return i.set(s,u),u}if(Su(s)){const o=cloneShallow(s);if(i.set(s,o),s.content)if(Su(s.content))o.content=cloneDeep(s.content,a);else if(s.content instanceof du.KeyValuePair)o.content=cloneDeep(s.content,a);else if(Array.isArray(s.content)){const mapper=s=>cloneDeep(s,a);o.content=s.content.map(mapper)}else o.content=s.content;else o.content=s.content;return o}throw new Ru("Value provided to cloneDeep function couldn't be cloned",{value:s})};cloneDeep.safe=s=>{try{return cloneDeep(s)}catch{return s}};const cloneShallowKeyValuePair=s=>{const{key:o,value:i}=s;return new du.KeyValuePair(o,i)},cloneShallowElement=s=>{const o=new s.constructor;if(o.element=s.element,hasElementSourceMap(s)&&assignSourceMap(o,s),s.meta.length>0&&(o._meta=cloneDeep(s.meta)),s.attributes.length>0&&(o._attributes=cloneDeep(s.attributes)),Su(s.content)){const i=s.content;o.content=cloneShallowElement(i)}else Array.isArray(s.content)?o.content=[...s.content]:s.content instanceof du.KeyValuePair?o.content=cloneShallowKeyValuePair(s.content):o.content=s.content;return o},cloneShallow=s=>{if(s instanceof du.KeyValuePair)return cloneShallowKeyValuePair(s);if(s instanceof du.ot)return(s=>{const o=[...s];return new du.ot(o)})(s);if(s instanceof du.G6)return(s=>{const o=[...s];return new du.G6(o)})(s);if(Su(s))return cloneShallowElement(s);throw new Du("Value provided to cloneShallow function couldn't be cloned",{value:s})};cloneShallow.safe=s=>{try{return cloneShallow(s)}catch{return s}};const visitor_getNodeType=s=>ku(s)?"ObjectElement":Ou(s)?"ArrayElement":Au(s)?"MemberElement":_u(s)?"StringElement":xu(s)?"BooleanElement":Eu(s)?"NumberElement":wu(s)?"NullElement":Cu(s)?"LinkElement":ju(s)?"RefElement":void 0,visitor_cloneNode=s=>Su(s)?cloneShallow(s):cloneNode(s),Ku=pipe(visitor_getNodeType,Rc),Gu={ObjectElement:["content"],ArrayElement:["content"],MemberElement:["key","value"],StringElement:[],BooleanElement:[],NumberElement:[],NullElement:[],RefElement:[],LinkElement:[],Annotation:[],Comment:[],ParseResultElement:["content"]};class PredicateVisitor{result;predicate;returnOnTrue;returnOnFalse;constructor({predicate:s=es_F,returnOnTrue:o,returnOnFalse:i}={}){this.result=[],this.predicate=s,this.returnOnTrue=o,this.returnOnFalse=i}enter(s){return this.predicate(s)?(this.result.push(s),this.returnOnTrue):this.returnOnFalse}}const visitor_visit=(s,o,{keyMap:i=Gu,...a}={})=>visit(s,o,{keyMap:i,nodeTypeGetter:visitor_getNodeType,nodePredicate:Ku,nodeCloneFn:visitor_cloneNode,...a});visitor_visit[Symbol.for("nodejs.util.promisify.custom")]=async(s,o,{keyMap:i=Gu,...a}={})=>visit[Symbol.for("nodejs.util.promisify.custom")](s,o,{keyMap:i,nodeTypeGetter:visitor_getNodeType,nodePredicate:Ku,nodeCloneFn:visitor_cloneNode,...a});const nodeTypeGetter=s=>"string"==typeof(null==s?void 0:s.type)?s.type:visitor_getNodeType(s),Yu={EphemeralObject:["content"],EphemeralArray:["content"],...Gu},value_visitor_visit=(s,o,{keyMap:i=Yu,...a}={})=>visitor_visit(s,o,{keyMap:i,nodeTypeGetter,nodePredicate:es_T,detectCycles:!1,deleteNodeSymbol:Symbol.for("delete-node"),skipVisitingNodeSymbol:Symbol.for("skip-visiting-node"),...a});value_visitor_visit[Symbol.for("nodejs.util.promisify.custom")]=async(s,{keyMap:o=Yu,...i}={})=>visitor_visit[Symbol.for("nodejs.util.promisify.custom")](s,visitor,{keyMap:o,nodeTypeGetter,nodePredicate:es_T,detectCycles:!1,deleteNodeSymbol:Symbol.for("delete-node"),skipVisitingNodeSymbol:Symbol.for("skip-visiting-node"),...i});const Xu=class EphemeralArray{type="EphemeralArray";content=[];reference=void 0;constructor(s){this.content=s,this.reference=[]}toReference(){return this.reference}toArray(){return this.reference.push(...this.content),this.reference}};const Qu=class EphemeralObject{type="EphemeralObject";content=[];reference=void 0;constructor(s){this.content=s,this.reference={}}toReference(){return this.reference}toObject(){return Object.assign(this.reference,Object.fromEntries(this.content))}};class Visitor{ObjectElement={enter:s=>{if(this.references.has(s))return this.references.get(s).toReference();const o=new Qu(s.content);return this.references.set(s,o),o}};EphemeralObject={leave:s=>s.toObject()};MemberElement={enter:s=>[s.key,s.value]};ArrayElement={enter:s=>{if(this.references.has(s))return this.references.get(s).toReference();const o=new Xu(s.content);return this.references.set(s,o),o}};EphemeralArray={leave:s=>s.toArray()};references=new WeakMap;BooleanElement(s){return s.toValue()}NumberElement(s){return s.toValue()}StringElement(s){return s.toValue()}NullElement(){return null}RefElement(s,...o){var i;const a=o[3];return"EphemeralObject"===(null===(i=a[a.length-1])||void 0===i?void 0:i.type)?Symbol.for("delete-node"):String(s.toValue())}LinkElement(s){return _u(s.href)?s.href.toValue():""}}const serializers_value=s=>Su(s)?_u(s)||Eu(s)||xu(s)||wu(s)?s.toValue():value_visitor_visit(s,new Visitor):s;const Zu=_curry3((function mergeWithKey(s,o,i){var a,u={};for(a in i=i||{},o=o||{})_has(a,o)&&(u[a]=_has(a,i)?s(a,o[a],i[a]):o[a]);for(a in i)_has(a,i)&&!_has(a,u)&&(u[a]=i[a]);return u}));const ep=_curry3((function mergeDeepWithKey(s,o,i){return Zu((function(o,i,a){return _isObject(i)&&_isObject(a)?mergeDeepWithKey(s,i,a):s(o,i,a)}),o,i)}));const tp=_curry2((function mergeDeepRight(s,o){return ep((function(s,o,i){return i}),s,o)}));const rp=Ri(0,-1);const np=_curry2((function apply(s,o){return s.apply(this,o)}));const sp=cc(jc);var op=_curry1((function empty(s){return null!=s&&"function"==typeof s["fantasy-land/empty"]?s["fantasy-land/empty"]():null!=s&&null!=s.constructor&&"function"==typeof s.constructor["fantasy-land/empty"]?s.constructor["fantasy-land/empty"]():null!=s&&"function"==typeof s.empty?s.empty():null!=s&&null!=s.constructor&&"function"==typeof s.constructor.empty?s.constructor.empty():Yo(s)?[]:_isString(s)?"":_isObject(s)?{}:ga(s)?function(){return arguments}():function _isTypedArray(s){var o=Object.prototype.toString.call(s);return"[object Uint8ClampedArray]"===o||"[object Int8Array]"===o||"[object Uint8Array]"===o||"[object Int16Array]"===o||"[object Uint16Array]"===o||"[object Int32Array]"===o||"[object Uint32Array]"===o||"[object Float32Array]"===o||"[object Float64Array]"===o||"[object BigInt64Array]"===o||"[object BigUint64Array]"===o}(s)?s.constructor.from(""):void 0}));const ip=op;const cp=_curry1((function isEmpty(s){return null!=s&&ka(s,ip(s))}));const lp=la(1,jc(Array.isArray)?Array.isArray:pipe(xa,Ec("Array")));const up=Xl(lp,cp);var pp=la(3,(function(s,o,i){var a=zu(s,i),u=zu(rp(s),i);if(!sp(a)&&!up(s)){var _=Zo(a,u);return np(_,o)}}));const hp=pp;class Namespace extends du.g${constructor(){super(),this.register("annotation",yu),this.register("comment",vu),this.register("parseResult",bu)}}const dp=new Namespace,createNamespace=s=>{const o=new Namespace;return iu(s)&&o.use(s),o},fp=dp,toolbox=()=>({predicates:{...ie},namespace:fp}),mp={toolboxCreator:toolbox,visitorOptions:{nodeTypeGetter:visitor_getNodeType,exposeEdits:!0}},dispatchPluginsSync=(s,o,i={})=>{if(0===o.length)return s;const a=tp(mp,i),{toolboxCreator:u,visitorOptions:_}=a,w=u(),x=o.map((s=>s(w))),C=mergeAll(x.map(ia({},"visitor")),{..._});x.forEach(hp(["pre"],[]));const j=visitor_visit(s,C,_);return x.forEach(hp(["post"],[])),j};dispatchPluginsSync[Symbol.for("nodejs.util.promisify.custom")]=async(s,o,i={})=>{if(0===o.length)return s;const a=tp(mp,i),{toolboxCreator:u,visitorOptions:_}=a,w=u(),x=o.map((s=>s(w))),C=mergeAll[Symbol.for("nodejs.util.promisify.custom")],j=visitor_visit[Symbol.for("nodejs.util.promisify.custom")],L=C(x.map(ia({},"visitor")),{..._});await Promise.allSettled(x.map(hp(["pre"],[])));const B=await j(s,L,_);return await Promise.allSettled(x.map(hp(["post"],[]))),B};const refract=(s,{Type:o,plugins:i=[]})=>{const a=new o(s);return Su(s)&&(s.meta.length>0&&(a.meta=cloneDeep(s.meta)),s.attributes.length>0&&(a.attributes=cloneDeep(s.attributes))),dispatchPluginsSync(a,i,{toolboxCreator:toolbox,visitorOptions:{nodeTypeGetter:visitor_getNodeType}})},createRefractor=s=>(o,i={})=>refract(o,{...i,Type:s});du.Sh.refract=createRefractor(du.Sh),du.wE.refract=createRefractor(du.wE),du.Om.refract=createRefractor(du.Om),du.bd.refract=createRefractor(du.bd),du.Os.refract=createRefractor(du.Os),du.kT.refract=createRefractor(du.kT),du.Ft.refract=createRefractor(du.Ft),du.sI.refract=createRefractor(du.sI),yu.refract=createRefractor(yu),vu.refract=createRefractor(vu),bu.refract=createRefractor(bu);const computeEdges=(s,o=new WeakMap)=>(Au(s)?(o.set(s.key,s),computeEdges(s.key,o),o.set(s.value,s),computeEdges(s.value,o)):s.children.forEach((i=>{o.set(i,s),computeEdges(i,o)})),o);const gp=class Transcluder{element;edges;constructor({element:s}){this.element=s}transclude(s,o){var i;if(s===this.element)return o;if(s===o)return this.element;this.edges=null!==(i=this.edges)&&void 0!==i?i:computeEdges(this.element);const a=this.edges.get(s);return hc(a)?void 0:(ku(a)?((s,o,i)=>{const a=i.get(s);ku(a)&&(a.content=a.map(((u,_,w)=>w===s?(i.delete(s),i.set(o,a),o):w)))})(s,o,this.edges):Ou(a)?((s,o,i)=>{const a=i.get(s);Ou(a)&&(a.content=a.map((u=>u===s?(i.delete(s),i.set(o,a),o):u)))})(s,o,this.edges):Au(a)&&((s,o,i)=>{const a=i.get(s);Au(a)&&(a.key===s&&(a.key=o,i.delete(s),i.set(o,a)),a.value===s&&(a.value=o,i.delete(s),i.set(o,a)))})(s,o,this.edges),this.element)}};const fromURIReference=s=>{const o=s.indexOf("#");return(s=>{try{const o=s.startsWith("#")?s.slice(1):s;return decodeURIComponent(o)}catch{return s}})(-1===o?"#":s.substring(o))},yp=function fnparser(){const s=Ep,o=_p,i=this,a="parser.js: Parser(): ";i.ast=void 0,i.stats=void 0,i.trace=void 0,i.callbacks=[];let u,_,w,x,C,j,L,B=0,$=0,U=0,V=0,z=0,Y=new function systemData(){this.state=s.ACTIVE,this.phraseLength=0,this.refresh=()=>{this.state=s.ACTIVE,this.phraseLength=0}};i.parse=(Z,ee,ie,ae)=>{const ce=`${a}parse(): `;B=0,$=0,U=0,V=0,z=0,u=void 0,_=void 0,w=void 0,x=void 0,Y.refresh(),C=void 0,j=void 0,L=void 0,x=o.stringToChars(ie),u=Z.rules,_=Z.udts;const le=ee.toLowerCase();let pe;for(const s in u)if(u.hasOwnProperty(s)&&le===u[s].lower){pe=u[s].index;break}if(void 0===pe)throw new Error(`${ce}start rule name '${startRule}' not recognized`);(()=>{const s=`${a}initializeCallbacks(): `;let o,w;for(C=[],j=[],o=0;o<u.length;o+=1)C[o]=void 0;for(o=0;o<_.length;o+=1)j[o]=void 0;const x=[];for(o=0;o<u.length;o+=1)x.push(u[o].lower);for(o=0;o<_.length;o+=1)x.push(_[o].lower);for(const a in i.callbacks)if(i.callbacks.hasOwnProperty(a)){if(o=x.indexOf(a.toLowerCase()),o<0)throw new Error(`${s}syntax callback '${a}' not a rule or udt name`);if(w=i.callbacks[a]?i.callbacks[a]:void 0,"function"!=typeof w&&void 0!==w)throw new Error(`${s}syntax callback[${a}] must be function reference or falsy)`);o<u.length?C[o]=w:j[o-u.length]=w}})(),i.trace&&i.trace.init(u,_,x),i.stats&&i.stats.init(u,_),i.ast&&i.ast.init(u,_,x),L=ae,w=[{type:s.RNM,index:pe}],opExecute(0,0),w=void 0;let de=!1;switch(Y.state){case s.ACTIVE:throw new Error(`${ce}final state should never be 'ACTIVE'`);case s.NOMATCH:de=!1;break;case s.EMPTY:case s.MATCH:de=Y.phraseLength===x.length;break;default:throw new Error("unrecognized state")}return{success:de,state:Y.state,stateName:s.idName(Y.state),length:x.length,matched:Y.phraseLength,maxMatched:z,maxTreeDepth:U,nodeHits:V}};const validateRnmCallbackResult=(o,i,u,_)=>{if(i.phraseLength>u){let s=`${a}opRNM(${o.name}): callback function error: `;throw s+=`sysData.phraseLength: ${i.phraseLength}`,s+=` must be <= remaining chars: ${u}`,new Error(s)}switch(i.state){case s.ACTIVE:if(!_)throw new Error(`${a}opRNM(${o.name}): callback function return error. ACTIVE state not allowed.`);break;case s.EMPTY:i.phraseLength=0;break;case s.MATCH:0===i.phraseLength&&(i.state=s.EMPTY);break;case s.NOMATCH:i.phraseLength=0;break;default:throw new Error(`${a}opRNM(${o.name}): callback function return error. Unrecognized return state: ${i.state}`)}},opUDT=(o,C)=>{let $,U,V;const z=w[o],Z=_[z.index];Y.UdtIndex=Z.index,B||(V=i.ast&&i.ast.udtDefined(z.index),V&&(U=u.length+z.index,$=i.ast.getLength(),i.ast.down(U,Z.name)));const ee=x.length-C;j[z.index](Y,x,C,L),((o,i,u)=>{if(i.phraseLength>u){let s=`${a}opUDT(${o.name}): callback function error: `;throw s+=`sysData.phraseLength: ${i.phraseLength}`,s+=` must be <= remaining chars: ${u}`,new Error(s)}switch(i.state){case s.ACTIVE:throw new Error(`${a}opUDT(${o.name}) ACTIVE state return not allowed.`);case s.EMPTY:if(!o.empty)throw new Error(`${a}opUDT(${o.name}) may not return EMPTY.`);i.phraseLength=0;break;case s.MATCH:if(0===i.phraseLength){if(!o.empty)throw new Error(`${a}opUDT(${o.name}) may not return EMPTY.`);i.state=s.EMPTY}break;case s.NOMATCH:i.phraseLength=0;break;default:throw new Error(`${a}opUDT(${o.name}): callback function return error. Unrecognized return state: ${i.state}`)}})(Z,Y,ee),B||V&&(Y.state===s.NOMATCH?i.ast.setLength($):i.ast.up(U,Z.name,C,Y.phraseLength))},opExecute=(o,_)=>{const j=`${a}opExecute(): `,Z=w[o];switch(V+=1,$>U&&(U=$),$+=1,Y.refresh(),i.trace&&i.trace.down(Z,_),Z.type){case s.ALT:((o,i)=>{const a=w[o];for(let o=0;o<a.children.length&&(opExecute(a.children[o],i),Y.state===s.NOMATCH);o+=1);})(o,_);break;case s.CAT:((o,a)=>{let u,_,x,C;const j=w[o];i.ast&&(_=i.ast.getLength()),u=!0,x=a,C=0;for(let o=0;o<j.children.length;o+=1){if(opExecute(j.children[o],x),Y.state===s.NOMATCH){u=!1;break}x+=Y.phraseLength,C+=Y.phraseLength}u?(Y.state=0===C?s.EMPTY:s.MATCH,Y.phraseLength=C):(Y.state=s.NOMATCH,Y.phraseLength=0,i.ast&&i.ast.setLength(_))})(o,_);break;case s.REP:((o,a)=>{let u,_,C,j;const L=w[o];if(0===L.max)return Y.state=s.EMPTY,void(Y.phraseLength=0);for(_=a,C=0,j=0,i.ast&&(u=i.ast.getLength());!(_>=x.length)&&(opExecute(o+1,_),Y.state!==s.NOMATCH)&&Y.state!==s.EMPTY&&(j+=1,C+=Y.phraseLength,_+=Y.phraseLength,j!==L.max););Y.state===s.EMPTY||j>=L.min?(Y.state=0===C?s.EMPTY:s.MATCH,Y.phraseLength=C):(Y.state=s.NOMATCH,Y.phraseLength=0,i.ast&&i.ast.setLength(u))})(o,_);break;case s.RNM:((o,a)=>{let _,j,$;const U=w[o],V=u[U.index],z=C[V.index];if(B||(j=i.ast&&i.ast.ruleDefined(U.index),j&&(_=i.ast.getLength(),i.ast.down(U.index,u[U.index].name))),z){const o=x.length-a;z(Y,x,a,L),validateRnmCallbackResult(V,Y,o,!0),Y.state===s.ACTIVE&&($=w,w=V.opcodes,opExecute(0,a),w=$,z(Y,x,a,L),validateRnmCallbackResult(V,Y,o,!1))}else $=w,w=V.opcodes,opExecute(0,a,Y),w=$;B||j&&(Y.state===s.NOMATCH?i.ast.setLength(_):i.ast.up(U.index,V.name,a,Y.phraseLength))})(o,_);break;case s.TRG:((o,i)=>{const a=w[o];Y.state=s.NOMATCH,i<x.length&&a.min<=x[i]&&x[i]<=a.max&&(Y.state=s.MATCH,Y.phraseLength=1)})(o,_);break;case s.TBS:((o,i)=>{const a=w[o],u=a.string.length;if(Y.state=s.NOMATCH,i+u<=x.length){for(let s=0;s<u;s+=1)if(x[i+s]!==a.string[s])return;Y.state=s.MATCH,Y.phraseLength=u}})(o,_);break;case s.TLS:((o,i)=>{let a;const u=w[o];Y.state=s.NOMATCH;const _=u.string.length;if(0!==_){if(i+_<=x.length){for(let s=0;s<_;s+=1)if(a=x[i+s],a>=65&&a<=90&&(a+=32),a!==u.string[s])return;Y.state=s.MATCH,Y.phraseLength=_}}else Y.state=s.EMPTY})(o,_);break;case s.UDT:opUDT(o,_);break;case s.AND:((o,i)=>{switch(B+=1,opExecute(o+1,i),B-=1,Y.phraseLength=0,Y.state){case s.EMPTY:case s.MATCH:Y.state=s.EMPTY;break;case s.NOMATCH:Y.state=s.NOMATCH;break;default:throw new Error(`opAND: invalid state ${Y.state}`)}})(o,_);break;case s.NOT:((o,i)=>{switch(B+=1,opExecute(o+1,i),B-=1,Y.phraseLength=0,Y.state){case s.EMPTY:case s.MATCH:Y.state=s.NOMATCH;break;case s.NOMATCH:Y.state=s.EMPTY;break;default:throw new Error(`opNOT: invalid state ${Y.state}`)}})(o,_);break;default:throw new Error(`${j}unrecognized operator`)}B||_+Y.phraseLength>z&&(z=_+Y.phraseLength),i.stats&&i.stats.collect(Z,Y),i.trace&&i.trace.up(Z,Y.state,_,Y.phraseLength),$-=1}},vp=function fnast(){const s=Ep,o=_p,i=this;let a,u,_,w=0;const x=[],C=[],j=[];function indent(s){let o="";for(;s-- >0;)o+=" ";return o}i.callbacks=[],i.init=(s,o,L)=>{let B;C.length=0,j.length=0,w=0,a=s,u=o,_=L;const $=[];for(B=0;B<a.length;B+=1)$.push(a[B].lower);for(B=0;B<u.length;B+=1)$.push(u[B].lower);for(w=a.length+u.length,B=0;B<w;B+=1)x[B]=void 0;for(const s in i.callbacks)if(i.callbacks.hasOwnProperty(s)){const o=s.toLowerCase();if(B=$.indexOf(o),B<0)throw new Error(`parser.js: Ast()): init: node '${s}' not a rule or udt name`);x[B]=i.callbacks[s]}},i.ruleDefined=s=>!!x[s],i.udtDefined=s=>!!x[a.length+s],i.down=(o,i)=>{const a=j.length;return C.push(a),j.push({name:i,thisIndex:a,thatIndex:void 0,state:s.SEM_PRE,callbackIndex:o,phraseIndex:void 0,phraseLength:void 0,stack:C.length}),a},i.up=(o,i,a,u)=>{const _=j.length,w=C.pop();return j.push({name:i,thisIndex:_,thatIndex:w,state:s.SEM_POST,callbackIndex:o,phraseIndex:a,phraseLength:u,stack:C.length}),j[w].thatIndex=_,j[w].phraseIndex=a,j[w].phraseLength=u,_},i.translate=o=>{let i,a;for(let u=0;u<j.length;u+=1)a=j[u],i=x[a.callbackIndex],i&&(a.state===s.SEM_PRE?i(s.SEM_PRE,_,a.phraseIndex,a.phraseLength,o):i&&i(s.SEM_POST,_,a.phraseIndex,a.phraseLength,o))},i.setLength=s=>{j.length=s,C.length=s>0?j[s-1].stack:0},i.getLength=()=>j.length,i.toXml=()=>{let i="",a=0;return i+='<?xml version="1.0" encoding="utf-8"?>\n',i+=`<root nodes="${j.length/2}" characters="${_.length}">\n`,i+="\x3c!-- input string --\x3e\n",i+=indent(a+2),i+=o.charsToString(_),i+="\n",j.forEach((u=>{u.state===s.SEM_PRE?(a+=1,i+=indent(a),i+=`<node name="${u.name}" index="${u.phraseIndex}" length="${u.phraseLength}">\n`,i+=indent(a+2),i+=o.charsToString(_,u.phraseIndex,u.phraseLength),i+="\n"):(i+=indent(a),i+=`</node>\x3c!-- name="${u.name}" --\x3e\n`,a-=1)})),i+="</root>\n",i}},bp=function fntrace(){const s=Ep,o=_p,i="parser.js: Trace(): ";let a,u,_,w="",x=0;const C=this,indent=s=>{let o="",i=0;if(s>=0)for(;s--;)i+=1,5===i?(o+="|",i=0):o+=".";return o};C.init=(s,o,i)=>{u=s,_=o,a=i};const opName=a=>{let w;switch(a.type){case s.ALT:w="ALT";break;case s.CAT:w="CAT";break;case s.REP:w=a.max===1/0?`REP(${a.min},inf)`:`REP(${a.min},${a.max})`;break;case s.RNM:w=`RNM(${u[a.index].name})`;break;case s.TRG:w=`TRG(${a.min},${a.max})`;break;case s.TBS:w=a.string.length>6?`TBS(${o.charsToString(a.string,0,3)}...)`:`TBS(${o.charsToString(a.string,0,6)})`;break;case s.TLS:w=a.string.length>6?`TLS(${o.charsToString(a.string,0,3)}...)`:`TLS(${o.charsToString(a.string,0,6)})`;break;case s.UDT:w=`UDT(${_[a.index].name})`;break;case s.AND:w="AND";break;case s.NOT:w="NOT";break;default:throw new Error(`${i}Trace: opName: unrecognized opcode`)}return w};C.down=(s,i)=>{const u=indent(x),_=Math.min(100,a.length-i);let C=o.charsToString(a,i,_);_<a.length-i&&(C+="..."),C=`${u}|-|[${opName(s)}]${C}\n`,w+=C,x+=1},C.up=(u,_,C,j)=>{const L=`${i}trace.up: `;x-=1;const B=indent(x);let $,U,V;switch(_){case s.EMPTY:V="|E|",U="''";break;case s.MATCH:V="|M|",$=Math.min(100,j),U=$<j?`'${o.charsToString(a,C,$)}...'`:`'${o.charsToString(a,C,$)}'`;break;case s.NOMATCH:V="|N|",U="";break;default:throw new Error(`${L} unrecognized state`)}U=`${B}${V}[${opName(u)}]${U}\n`,w+=U},C.displayTrace=()=>w},Sp=function fnstats(){const s=Ep;let o,i,a;const u=[],_=[],w=[];this.init=(s,a)=>{o=s,i=a,clear()},this.collect=(o,i)=>{incStat(a,i.state,i.phraseLength),incStat(u[o.type],i.state,i.phraseLength),o.type===s.RNM&&incStat(_[o.index],i.state,i.phraseLength),o.type===s.UDT&&incStat(w[o.index],i.state,i.phraseLength)},this.displayStats=()=>{let o="";const i={match:0,empty:0,nomatch:0,total:0},displayRow=(s,o,a,u,_)=>{i.match+=o,i.empty+=a,i.nomatch+=u,i.total+=_;return`${s} | ${normalize(o)} | ${normalize(a)} | ${normalize(u)} | ${normalize(_)} |\n`};return o+="          OPERATOR STATS\n",o+="      |   MATCH |   EMPTY | NOMATCH |   TOTAL |\n",o+=displayRow("  ALT",u[s.ALT].match,u[s.ALT].empty,u[s.ALT].nomatch,u[s.ALT].total),o+=displayRow("  CAT",u[s.CAT].match,u[s.CAT].empty,u[s.CAT].nomatch,u[s.CAT].total),o+=displayRow("  REP",u[s.REP].match,u[s.REP].empty,u[s.REP].nomatch,u[s.REP].total),o+=displayRow("  RNM",u[s.RNM].match,u[s.RNM].empty,u[s.RNM].nomatch,u[s.RNM].total),o+=displayRow("  TRG",u[s.TRG].match,u[s.TRG].empty,u[s.TRG].nomatch,u[s.TRG].total),o+=displayRow("  TBS",u[s.TBS].match,u[s.TBS].empty,u[s.TBS].nomatch,u[s.TBS].total),o+=displayRow("  TLS",u[s.TLS].match,u[s.TLS].empty,u[s.TLS].nomatch,u[s.TLS].total),o+=displayRow("  UDT",u[s.UDT].match,u[s.UDT].empty,u[s.UDT].nomatch,u[s.UDT].total),o+=displayRow("  AND",u[s.AND].match,u[s.AND].empty,u[s.AND].nomatch,u[s.AND].total),o+=displayRow("  NOT",u[s.NOT].match,u[s.NOT].empty,u[s.NOT].nomatch,u[s.NOT].total),o+=displayRow("TOTAL",i.match,i.empty,i.nomatch,i.total),o},this.displayHits=s=>{let o="";const displayRow=(s,o,i,u,_)=>{a.match+=s,a.empty+=o,a.nomatch+=i,a.total+=u;return`| ${normalize(s)} | ${normalize(o)} | ${normalize(i)} | ${normalize(u)} | ${_}\n`};"string"==typeof s&&"a"===s.toLowerCase()[0]?(_.sort(sortAlpha),w.sort(sortAlpha),o+="    RULES/UDTS ALPHABETICALLY\n"):"string"==typeof s&&"i"===s.toLowerCase()[0]?(_.sort(sortIndex),w.sort(sortIndex),o+="    RULES/UDTS BY INDEX\n"):(_.sort(sortHits),w.sort(sortHits),o+="    RULES/UDTS BY HIT COUNT\n"),o+="|   MATCH |   EMPTY | NOMATCH |   TOTAL | NAME\n";for(let s=0;s<_.length;s+=1){let i=_[s];i.total&&(o+=displayRow(i.match,i.empty,i.nomatch,i.total,i.name))}for(let s=0;s<w.length;s+=1){let i=w[s];i.total&&(o+=displayRow(i.match,i.empty,i.nomatch,i.total,i.name))}return o};const normalize=s=>s<10?`      ${s}`:s<100?`     ${s}`:s<1e3?`    ${s}`:s<1e4?`   ${s}`:s<1e5?`  ${s}`:s<1e6?` ${s}`:`${s}`,sortAlpha=(s,o)=>s.lower<o.lower?-1:s.lower>o.lower?1:0,sortHits=(s,o)=>s.total<o.total?1:s.total>o.total?-1:sortAlpha(s,o),sortIndex=(s,o)=>s.index<o.index?-1:s.index>o.index?1:0,x=function fnempty(){this.empty=0,this.match=0,this.nomatch=0,this.total=0},clear=()=>{u.length=0,a=new x,u[s.ALT]=new x,u[s.CAT]=new x,u[s.REP]=new x,u[s.RNM]=new x,u[s.TRG]=new x,u[s.TBS]=new x,u[s.TLS]=new x,u[s.UDT]=new x,u[s.AND]=new x,u[s.NOT]=new x,_.length=0;for(let s=0;s<o.length;s+=1)_.push({empty:0,match:0,nomatch:0,total:0,name:o[s].name,lower:o[s].lower,index:o[s].index});if(i.length>0){w.length=0;for(let s=0;s<i.length;s+=1)w.push({empty:0,match:0,nomatch:0,total:0,name:i[s].name,lower:i[s].lower,index:i[s].index})}},incStat=(o,i)=>{switch(o.total+=1,i){case s.EMPTY:o.empty+=1;break;case s.MATCH:o.match+=1;break;case s.NOMATCH:o.nomatch+=1;break;default:throw new Error(`parser.js: Stats(): collect(): incStat(): unrecognized state: ${i}`)}}},_p={stringToChars:s=>[...s].map((s=>s.codePointAt(0))),charsToString:(s,o,i)=>{let a=s;for(;!(void 0===o||o<0);){if(void 0===i){a=s.slice(o);break}if(i<=0)return"";a=s.slice(o,o+i);break}return String.fromCodePoint(...a)}},Ep={ALT:1,CAT:2,REP:3,RNM:4,TRG:5,TBS:6,TLS:7,UDT:11,AND:12,NOT:13,ACTIVE:100,MATCH:101,EMPTY:102,NOMATCH:103,SEM_PRE:200,SEM_POST:201,SEM_OK:300,idName:s=>{switch(s){case Ep.ALT:return"ALT";case Ep.CAT:return"CAT";case Ep.REP:return"REP";case Ep.RNM:return"RNM";case Ep.TRG:return"TRG";case Ep.TBS:return"TBS";case Ep.TLS:return"TLS";case Ep.UDT:return"UDT";case Ep.AND:return"AND";case Ep.NOT:return"NOT";case Ep.ACTIVE:return"ACTIVE";case Ep.EMPTY:return"EMPTY";case Ep.MATCH:return"MATCH";case Ep.NOMATCH:return"NOMATCH";case Ep.SEM_PRE:return"SEM_PRE";case Ep.SEM_POST:return"SEM_POST";case Ep.SEM_OK:return"SEM_OK";default:return"UNRECOGNIZED STATE"}}};function grammar(){this.grammarObject="grammarObject",this.rules=[],this.rules[0]={name:"json-pointer",lower:"json-pointer",index:0,isBkr:!1},this.rules[1]={name:"reference-token",lower:"reference-token",index:1,isBkr:!1},this.rules[2]={name:"unescaped",lower:"unescaped",index:2,isBkr:!1},this.rules[3]={name:"escaped",lower:"escaped",index:3,isBkr:!1},this.rules[4]={name:"array-location",lower:"array-location",index:4,isBkr:!1},this.rules[5]={name:"array-index",lower:"array-index",index:5,isBkr:!1},this.rules[6]={name:"array-dash",lower:"array-dash",index:6,isBkr:!1},this.rules[7]={name:"slash",lower:"slash",index:7,isBkr:!1},this.udts=[],this.rules[0].opcodes=[],this.rules[0].opcodes[0]={type:3,min:0,max:1/0},this.rules[0].opcodes[1]={type:2,children:[2,3]},this.rules[0].opcodes[2]={type:4,index:7},this.rules[0].opcodes[3]={type:4,index:1},this.rules[1].opcodes=[],this.rules[1].opcodes[0]={type:3,min:0,max:1/0},this.rules[1].opcodes[1]={type:1,children:[2,3]},this.rules[1].opcodes[2]={type:4,index:2},this.rules[1].opcodes[3]={type:4,index:3},this.rules[2].opcodes=[],this.rules[2].opcodes[0]={type:1,children:[1,2,3]},this.rules[2].opcodes[1]={type:5,min:0,max:46},this.rules[2].opcodes[2]={type:5,min:48,max:125},this.rules[2].opcodes[3]={type:5,min:127,max:1114111},this.rules[3].opcodes=[],this.rules[3].opcodes[0]={type:2,children:[1,2]},this.rules[3].opcodes[1]={type:7,string:[126]},this.rules[3].opcodes[2]={type:1,children:[3,4]},this.rules[3].opcodes[3]={type:7,string:[48]},this.rules[3].opcodes[4]={type:7,string:[49]},this.rules[4].opcodes=[],this.rules[4].opcodes[0]={type:1,children:[1,2]},this.rules[4].opcodes[1]={type:4,index:5},this.rules[4].opcodes[2]={type:4,index:6},this.rules[5].opcodes=[],this.rules[5].opcodes[0]={type:1,children:[1,2]},this.rules[5].opcodes[1]={type:6,string:[48]},this.rules[5].opcodes[2]={type:2,children:[3,4]},this.rules[5].opcodes[3]={type:5,min:49,max:57},this.rules[5].opcodes[4]={type:3,min:0,max:1/0},this.rules[5].opcodes[5]={type:5,min:48,max:57},this.rules[6].opcodes=[],this.rules[6].opcodes[0]={type:7,string:[45]},this.rules[7].opcodes=[],this.rules[7].opcodes[0]={type:7,string:[47]},this.toString=function toString(){let s="";return s+="; JavaScript Object Notation (JSON) Pointer ABNF syntax\n",s+="; https://datatracker.ietf.org/doc/html/rfc6901\n",s+="json-pointer    = *( slash reference-token ) ; MODIFICATION: surrogate text rule used\n",s+="reference-token = *( unescaped / escaped )\n",s+="unescaped       = %x00-2E / %x30-7D / %x7F-10FFFF\n",s+="                ; %x2F ('/') and %x7E ('~') are excluded from 'unescaped'\n",s+='escaped         = "~" ( "0" / "1" )\n',s+="                ; representing '~' and '/', respectively\n",s+="\n",s+="; https://datatracker.ietf.org/doc/html/rfc6901#section-4\n",s+="array-location  = array-index / array-dash\n",s+="array-index     = %x30 / ( %x31-39 *(%x30-39) )\n",s+='                ; "0", or digits without a leading "0"\n',s+='array-dash      = "-"\n',s+="\n",s+="; Surrogate named rules\n",s+='slash           = "/"\n','; JavaScript Object Notation (JSON) Pointer ABNF syntax\n; https://datatracker.ietf.org/doc/html/rfc6901\njson-pointer    = *( slash reference-token ) ; MODIFICATION: surrogate text rule used\nreference-token = *( unescaped / escaped )\nunescaped       = %x00-2E / %x30-7D / %x7F-10FFFF\n                ; %x2F (\'/\') and %x7E (\'~\') are excluded from \'unescaped\'\nescaped         = "~" ( "0" / "1" )\n                ; representing \'~\' and \'/\', respectively\n\n; https://datatracker.ietf.org/doc/html/rfc6901#section-4\narray-location  = array-index / array-dash\narray-index     = %x30 / ( %x31-39 *(%x30-39) )\n                ; "0", or digits without a leading "0"\narray-dash      = "-"\n\n; Surrogate named rules\nslash           = "/"\n'}}class JSONPointerError extends Error{constructor(s,o=void 0){if(super(s,o),this.name=this.constructor.name,"string"==typeof s&&(this.message=s),"function"==typeof Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):this.stack=new Error(s).stack,null!=o&&"object"==typeof o&&Object.prototype.hasOwnProperty.call(o,"cause")&&!("cause"in this)){const{cause:s}=o;this.cause=s,s instanceof Error&&"stack"in s&&(this.stack=`${this.stack}\nCAUSE: ${s.stack}`)}if(null!=o&&"object"==typeof o){const{cause:s,...i}=o;Object.assign(this,i)}}}const wp=JSONPointerError;const xp=class JSONPointerParseError extends wp{},callbacks_cst=s=>(o,i,a,u,_)=>{if("object"!=typeof _||null===_||Array.isArray(_))throw new xp("parser's user data must be an object");if(o===Ep.SEM_PRE){const o={type:s,text:_p.charsToString(i,a,u),start:a,length:u,children:[]};if(_.stack.length>0){_.stack[_.stack.length-1].children.push(o)}else _.root=o;_.stack.push(o)}o===Ep.SEM_POST&&_.stack.pop()};const kp=class CSTTranslator extends vp{constructor(){super(),this.callbacks["json-pointer"]=callbacks_cst("json-pointer"),this.callbacks["reference-token"]=callbacks_cst("reference-token"),this.callbacks.slash=callbacks_cst("text")}getTree(){const s={stack:[],root:null};return this.translate(s),delete s.stack,s}},es_unescape=s=>{if("string"!=typeof s)throw new TypeError("Reference token must be a string");return s.replace(/~1/g,"/").replace(/~0/g,"~")};const Op=class ASTTranslator extends kp{getTree(){const{root:s}=super.getTree();return s.children.filter((({type:s})=>"reference-token"===s)).map((({text:s})=>es_unescape(s)))}};const Ap=class Expectations extends Array{toString(){return this.map((s=>`"${String(s)}"`)).join(", ")}};const Cp=class Trace extends bp{inferExpectations(){const s=this.displayTrace().split("\n"),o=new Set;let i=-1;for(let a=0;a<s.length;a++){const u=s[a];if(u.includes("M|")){const s=u.match(/]'(.*)'$/);s&&s[1]&&(i=a)}if(a>i){const s=u.match(/N\|\[TLS\(([^)]+)\)]/);s&&o.add(s[1])}}return new Ap(...o)}},jp=new grammar,es_parse=(s,{translator:o=new Op,stats:i=!1,trace:a=!1}={})=>{if("string"!=typeof s)throw new TypeError("JSON Pointer must be a string");try{const u=new yp;o&&(u.ast=o),i&&(u.stats=new Sp),a&&(u.trace=new Cp);const _=u.parse(jp,"json-pointer",s);return{result:_,tree:_.success&&o?u.ast.getTree():void 0,stats:u.stats,trace:u.trace}}catch(o){throw new xp("Unexpected error during JSON Pointer parsing",{cause:o,jsonPointer:s})}};new grammar,new yp,new grammar,new yp;const Pp=new grammar,Ip=new yp,array_index=s=>{if("string"!=typeof s)return!1;try{return Ip.parse(Pp,"array-index",s).success}catch{return!1}},Tp=new grammar,Np=new yp,array_dash=s=>{if("string"!=typeof s)return!1;try{return Np.parse(Tp,"array-dash",s).success}catch{return!1}},es_escape=s=>{if("string"!=typeof s&&"number"!=typeof s)throw new TypeError("Reference token must be a string or number");return String(s).replace(/~/g,"~0").replace(/\//g,"~1")};const Mp=class JSONPointerCompileError extends wp{},es_compile=s=>{if(!Array.isArray(s))throw new TypeError("Reference tokens must be a list of strings or numbers");try{return 0===s.length?"":`/${s.map((s=>{if("string"!=typeof s&&"number"!=typeof s)throw new TypeError("Reference token must be a string or number");return es_escape(String(s))})).join("/")}`}catch(o){throw new Mp("Unexpected error during JSON Pointer compilation",{cause:o,referenceTokens:s})}};const Rp=class TraceBuilder{#e;#t;#r;constructor(s,o={}){this.#e=s,this.#e.steps=[],this.#e.failed=!1,this.#e.failedAt=-1,this.#e.message=`JSON Pointer "${o.jsonPointer}" was successfully evaluated against the provided value`,this.#e.context={...o,realm:o.realm.name},this.#t=[],this.#r=o.realm}step({referenceToken:s,input:o,output:i,success:a=!0,reason:u}){const _=this.#t.length;this.#t.push(s);const w={referenceToken:s,referenceTokenPosition:_,input:o,inputType:this.#r.isObject(o)?"object":this.#r.isArray(o)?"array":"unrecognized",output:i,success:a};u&&(w.reason=u),this.#e.steps.push(w),a||(this.#e.failed=!0,this.#e.failedAt=_,this.#e.message=u)}};const Dp=class EvaluationRealm{name="";isArray(s){throw new wp("Realm.isArray(node) must be implemented in a subclass")}isObject(s){throw new wp("Realm.isObject(node) must be implemented in a subclass")}sizeOf(s){throw new wp("Realm.sizeOf(node) must be implemented in a subclass")}has(s,o){throw new wp("Realm.has(node) must be implemented in a subclass")}evaluate(s,o){throw new wp("Realm.evaluate(node) must be implemented in a subclass")}};const Lp=class JSONPointerEvaluateError extends wp{};const Fp=class JSONPointerIndexError extends Lp{};const Bp=class JSONEvaluationRealm extends Dp{name="json";isArray(s){return Array.isArray(s)}isObject(s){return"object"==typeof s&&null!==s&&!this.isArray(s)}sizeOf(s){return this.isArray(s)?s.length:this.isObject(s)?Object.keys(s).length:0}has(s,o){if(this.isArray(s)){const i=Number(o),a=i>>>0;if(i!==a)throw new Fp(`Invalid array index "${o}": index must be an unsinged 32-bit integer`,{referenceToken:o,currentValue:s,realm:this.name});return a<this.sizeOf(s)&&Object.prototype.hasOwnProperty.call(s,i)}return!!this.isObject(s)&&Object.prototype.hasOwnProperty.call(s,o)}evaluate(s,o){return this.isArray(s)?s[Number(o)]:s[o]}};const $p=class JSONPointerTypeError extends Lp{};const qp=class JSONPointerKeyError extends Lp{},es_evaluate=(s,o,{strictArrays:i=!0,strictObjects:a=!0,realm:u=new Bp,trace:_=!0}={})=>{const{result:w,tree:x,trace:C}=es_parse(o,{trace:!!_}),j="object"==typeof _&&null!==_?new Rp(_,{jsonPointer:o,referenceTokens:x,strictArrays:i,strictObjects:a,realm:u,value:s}):null;try{let _;if(!w.success){let i=`Invalid JSON Pointer: "${o}". Syntax error at position ${w.maxMatched}`;throw i+=C?`, expected ${C.inferExpectations()}`:"",new Lp(i,{jsonPointer:o,currentValue:s,realm:u.name})}return x.reduce(((s,w,C)=>{if(u.isArray(s)){if(array_dash(w)){if(i)throw new Fp(`Invalid array index "-" at position ${C} in "${o}". The "-" token always refers to a nonexistent element during evaluation`,{jsonPointer:o,referenceTokens:x,referenceToken:w,referenceTokenPosition:C,currentValue:s,realm:u.name});return _=u.evaluate(s,String(u.sizeOf(s))),null==j||j.step({referenceToken:w,input:s,output:_}),_}if(!array_index(w))throw new Fp(`Invalid array index "${w}" at position ${C} in "${o}": index MUST be "0", or digits without a leading "0"`,{jsonPointer:o,referenceTokens:x,referenceToken:w,referenceTokenPosition:C,currentValue:s,realm:u.name});const a=Number(w);if(!Number.isSafeInteger(a))throw new Fp(`Invalid array index "${w}" at position ${C} in "${o}": index must be a safe integer`,{jsonPointer:o,referenceTokens:x,referenceToken:w,referenceTokenPosition:C,currentValue:s,realm:u.name});if(!u.has(s,w)&&i)throw new Fp(`Invalid array index "${w}" at position ${C} in "${o}": index not found in array`,{jsonPointer:o,referenceTokens:x,referenceToken:w,referenceTokenPosition:C,currentValue:s,realm:u.name});return _=u.evaluate(s,w),null==j||j.step({referenceToken:w,input:s,output:_}),_}if(u.isObject(s)){if(!u.has(s,w)&&a)throw new qp(`Invalid object key "${w}" at position ${C} in "${o}": key not found in object`,{jsonPointer:o,referenceTokens:x,referenceToken:w,referenceTokenPosition:C,currentValue:s,realm:u.name});return _=u.evaluate(s,w),null==j||j.step({referenceToken:w,input:s,output:_}),_}throw new $p(`Invalid reference token "${w}" at position ${C} in "${o}": cannot be applied to a non-object/non-array value`,{jsonPointer:o,referenceTokens:x,referenceToken:w,referenceTokenPosition:C,currentValue:s,realm:u.name})}),s)}catch(s){if(null==j||j.step({referenceToken:s.referenceToken,input:s.currentValue,success:!1,reason:s.message}),s instanceof Lp)throw s;throw new Lp("Unexpected error during JSON Pointer evaluation",{cause:s,jsonPointer:o,referenceTokens:x})}};const Up=class ApiDOMEvaluationRealm extends Dp{name="apidom";isArray(s){return Ou(s)}isObject(s){return ku(s)}sizeOf(s){return this.isArray(s)||this.isObject(s)?s.length:0}has(s,o){if(this.isArray(s)){const i=Number(o),a=i>>>0;if(i!==a)throw new Fp(`Invalid array index "${o}": index must be an unsinged 32-bit integer`,{referenceToken:o,currentValue:s,realm:this.name});return a<this.sizeOf(s)}if(this.isObject(s)){const i=s.keys(),a=new Set(i);if(i.length!==a.size)throw new qp(`Object key "${o}" is not unique — JSON Pointer requires unique member names`,{referenceToken:o,currentValue:s,realm:this.name});return s.hasKey(o)}return!1}evaluate(s,o){return this.isArray(s)?s.get(Number(o)):s.get(o)}},apidom_evaluate=(s,o,i={})=>es_evaluate(s,o,{...i,realm:new Up});class Callback extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="callback"}}const Vp=Callback;class Components extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="components"}get schemas(){return this.get("schemas")}set schemas(s){this.set("schemas",s)}get responses(){return this.get("responses")}set responses(s){this.set("responses",s)}get parameters(){return this.get("parameters")}set parameters(s){this.set("parameters",s)}get examples(){return this.get("examples")}set examples(s){this.set("examples",s)}get requestBodies(){return this.get("requestBodies")}set requestBodies(s){this.set("requestBodies",s)}get headers(){return this.get("headers")}set headers(s){this.set("headers",s)}get securitySchemes(){return this.get("securitySchemes")}set securitySchemes(s){this.set("securitySchemes",s)}get links(){return this.get("links")}set links(s){this.set("links",s)}get callbacks(){return this.get("callbacks")}set callbacks(s){this.set("callbacks",s)}}const zp=Components;class Contact extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="contact"}get name(){return this.get("name")}set name(s){this.set("name",s)}get url(){return this.get("url")}set url(s){this.set("url",s)}get email(){return this.get("email")}set email(s){this.set("email",s)}}const Wp=Contact;class Discriminator extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="discriminator"}get propertyName(){return this.get("propertyName")}set propertyName(s){this.set("propertyName",s)}get mapping(){return this.get("mapping")}set mapping(s){this.set("mapping",s)}}const Jp=Discriminator;class Encoding extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="encoding"}get contentType(){return this.get("contentType")}set contentType(s){this.set("contentType",s)}get headers(){return this.get("headers")}set headers(s){this.set("headers",s)}get style(){return this.get("style")}set style(s){this.set("style",s)}get explode(){return this.get("explode")}set explode(s){this.set("explode",s)}get allowedReserved(){return this.get("allowedReserved")}set allowedReserved(s){this.set("allowedReserved",s)}}const Hp=Encoding;class Example extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="example"}get summary(){return this.get("summary")}set summary(s){this.set("summary",s)}get description(){return this.get("description")}set description(s){this.set("description",s)}get value(){return this.get("value")}set value(s){this.set("value",s)}get externalValue(){return this.get("externalValue")}set externalValue(s){this.set("externalValue",s)}}const Kp=Example;class ExternalDocumentation extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="externalDocumentation"}get description(){return this.get("description")}set description(s){this.set("description",s)}get url(){return this.get("url")}set url(s){this.set("url",s)}}const Gp=ExternalDocumentation;class Header extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="header"}get required(){return this.hasKey("required")?this.get("required"):new du.bd(!1)}set required(s){this.set("required",s)}get deprecated(){return this.hasKey("deprecated")?this.get("deprecated"):new du.bd(!1)}set deprecated(s){this.set("deprecated",s)}get allowEmptyValue(){return this.get("allowEmptyValue")}set allowEmptyValue(s){this.set("allowEmptyValue",s)}get style(){return this.get("style")}set style(s){this.set("style",s)}get explode(){return this.get("explode")}set explode(s){this.set("explode",s)}get allowReserved(){return this.get("allowReserved")}set allowReserved(s){this.set("allowReserved",s)}get schema(){return this.get("schema")}set schema(s){this.set("schema",s)}get example(){return this.get("example")}set example(s){this.set("example",s)}get examples(){return this.get("examples")}set examples(s){this.set("examples",s)}get contentProp(){return this.get("content")}set contentProp(s){this.set("content",s)}}Object.defineProperty(Header.prototype,"description",{get(){return this.get("description")},set(s){this.set("description",s)},enumerable:!0});const Yp=Header;class Info extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="info",this.classes.push("info")}get title(){return this.get("title")}set title(s){this.set("title",s)}get description(){return this.get("description")}set description(s){this.set("description",s)}get termsOfService(){return this.get("termsOfService")}set termsOfService(s){this.set("termsOfService",s)}get contact(){return this.get("contact")}set contact(s){this.set("contact",s)}get license(){return this.get("license")}set license(s){this.set("license",s)}get version(){return this.get("version")}set version(s){this.set("version",s)}}const Xp=Info;class License extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="license"}get name(){return this.get("name")}set name(s){this.set("name",s)}get url(){return this.get("url")}set url(s){this.set("url",s)}}const Qp=License;class Link extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="link"}get operationRef(){return this.get("operationRef")}set operationRef(s){this.set("operationRef",s)}get operationId(){return this.get("operationId")}set operationId(s){this.set("operationId",s)}get operation(){var s,o;return _u(this.operationRef)?null===(s=this.operationRef)||void 0===s?void 0:s.meta.get("operation"):_u(this.operationId)?null===(o=this.operationId)||void 0===o?void 0:o.meta.get("operation"):void 0}set operation(s){this.set("operation",s)}get parameters(){return this.get("parameters")}set parameters(s){this.set("parameters",s)}get requestBody(){return this.get("requestBody")}set requestBody(s){this.set("requestBody",s)}get description(){return this.get("description")}set description(s){this.set("description",s)}get server(){return this.get("server")}set server(s){this.set("server",s)}}const Zp=Link;class MediaType extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="mediaType"}get schema(){return this.get("schema")}set schema(s){this.set("schema",s)}get example(){return this.get("example")}set example(s){this.set("example",s)}get examples(){return this.get("examples")}set examples(s){this.set("examples",s)}get encoding(){return this.get("encoding")}set encoding(s){this.set("encoding",s)}}const th=MediaType;class OAuthFlow extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="oAuthFlow"}get authorizationUrl(){return this.get("authorizationUrl")}set authorizationUrl(s){this.set("authorizationUrl",s)}get tokenUrl(){return this.get("tokenUrl")}set tokenUrl(s){this.set("tokenUrl",s)}get refreshUrl(){return this.get("refreshUrl")}set refreshUrl(s){this.set("refreshUrl",s)}get scopes(){return this.get("scopes")}set scopes(s){this.set("scopes",s)}}const rh=OAuthFlow;class OAuthFlows extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="oAuthFlows"}get implicit(){return this.get("implicit")}set implicit(s){this.set("implicit",s)}get password(){return this.get("password")}set password(s){this.set("password",s)}get clientCredentials(){return this.get("clientCredentials")}set clientCredentials(s){this.set("clientCredentials",s)}get authorizationCode(){return this.get("authorizationCode")}set authorizationCode(s){this.set("authorizationCode",s)}}const uh=OAuthFlows;class Openapi extends du.Om{constructor(s,o,i){super(s,o,i),this.element="openapi",this.classes.push("spec-version"),this.classes.push("version")}}const dh=Openapi;class OpenApi3_0 extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="openApi3_0",this.classes.push("api")}get openapi(){return this.get("openapi")}set openapi(s){this.set("openapi",s)}get info(){return this.get("info")}set info(s){this.set("info",s)}get servers(){return this.get("servers")}set servers(s){this.set("servers",s)}get paths(){return this.get("paths")}set paths(s){this.set("paths",s)}get components(){return this.get("components")}set components(s){this.set("components",s)}get security(){return this.get("security")}set security(s){this.set("security",s)}get tags(){return this.get("tags")}set tags(s){this.set("tags",s)}get externalDocs(){return this.get("externalDocs")}set externalDocs(s){this.set("externalDocs",s)}}const fh=OpenApi3_0;class Operation extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="operation"}get tags(){return this.get("tags")}set tags(s){this.set("tags",s)}get summary(){return this.get("summary")}set summary(s){this.set("summary",s)}get description(){return this.get("description")}set description(s){this.set("description",s)}set externalDocs(s){this.set("externalDocs",s)}get externalDocs(){return this.get("externalDocs")}get operationId(){return this.get("operationId")}set operationId(s){this.set("operationId",s)}get parameters(){return this.get("parameters")}set parameters(s){this.set("parameters",s)}get requestBody(){return this.get("requestBody")}set requestBody(s){this.set("requestBody",s)}get responses(){return this.get("responses")}set responses(s){this.set("responses",s)}get callbacks(){return this.get("callbacks")}set callbacks(s){this.set("callbacks",s)}get deprecated(){return this.hasKey("deprecated")?this.get("deprecated"):new du.bd(!1)}set deprecated(s){this.set("deprecated",s)}get security(){return this.get("security")}set security(s){this.set("security",s)}get servers(){return this.get("severs")}set servers(s){this.set("servers",s)}}const vh=Operation;class Parameter extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="parameter"}get name(){return this.get("name")}set name(s){this.set("name",s)}get in(){return this.get("in")}set in(s){this.set("in",s)}get required(){return this.hasKey("required")?this.get("required"):new du.bd(!1)}set required(s){this.set("required",s)}get deprecated(){return this.hasKey("deprecated")?this.get("deprecated"):new du.bd(!1)}set deprecated(s){this.set("deprecated",s)}get allowEmptyValue(){return this.get("allowEmptyValue")}set allowEmptyValue(s){this.set("allowEmptyValue",s)}get style(){return this.get("style")}set style(s){this.set("style",s)}get explode(){return this.get("explode")}set explode(s){this.set("explode",s)}get allowReserved(){return this.get("allowReserved")}set allowReserved(s){this.set("allowReserved",s)}get schema(){return this.get("schema")}set schema(s){this.set("schema",s)}get example(){return this.get("example")}set example(s){this.set("example",s)}get examples(){return this.get("examples")}set examples(s){this.set("examples",s)}get contentProp(){return this.get("content")}set contentProp(s){this.set("content",s)}}Object.defineProperty(Parameter.prototype,"description",{get(){return this.get("description")},set(s){this.set("description",s)},enumerable:!0});const _h=Parameter;class PathItem extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="pathItem"}get $ref(){return this.get("$ref")}set $ref(s){this.set("$ref",s)}get summary(){return this.get("summary")}set summary(s){this.set("summary",s)}get description(){return this.get("description")}set description(s){this.set("description",s)}get GET(){return this.get("get")}set GET(s){this.set("GET",s)}get PUT(){return this.get("put")}set PUT(s){this.set("PUT",s)}get POST(){return this.get("post")}set POST(s){this.set("POST",s)}get DELETE(){return this.get("delete")}set DELETE(s){this.set("DELETE",s)}get OPTIONS(){return this.get("options")}set OPTIONS(s){this.set("OPTIONS",s)}get HEAD(){return this.get("head")}set HEAD(s){this.set("HEAD",s)}get PATCH(){return this.get("patch")}set PATCH(s){this.set("PATCH",s)}get TRACE(){return this.get("trace")}set TRACE(s){this.set("TRACE",s)}get servers(){return this.get("servers")}set servers(s){this.set("servers",s)}get parameters(){return this.get("parameters")}set parameters(s){this.set("parameters",s)}}const wh=PathItem;class Paths extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="paths"}}const Oh=Paths;class Reference extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="reference",this.classes.push("openapi-reference")}get $ref(){return this.get("$ref")}set $ref(s){this.set("$ref",s)}}const jh=Reference;class RequestBody extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="requestBody"}get description(){return this.get("description")}set description(s){this.set("description",s)}get contentProp(){return this.get("content")}set contentProp(s){this.set("content",s)}get required(){return this.hasKey("required")?this.get("required"):new du.bd(!1)}set required(s){this.set("required",s)}}const Ph=RequestBody;class Response_Response extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="response"}get description(){return this.get("description")}set description(s){this.set("description",s)}get headers(){return this.get("headers")}set headers(s){this.set("headers",s)}get contentProp(){return this.get("content")}set contentProp(s){this.set("content",s)}get links(){return this.get("links")}set links(s){this.set("links",s)}}const Ih=Response_Response;class Responses extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="responses"}get default(){return this.get("default")}set default(s){this.set("default",s)}}const Rh=Responses;const Dh=class UnsupportedOperationError extends Ko{};class JSONSchema extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="JSONSchemaDraft4"}get idProp(){return this.get("id")}set idProp(s){this.set("id",s)}get $schema(){return this.get("$schema")}set $schema(s){this.set("$schema",s)}get multipleOf(){return this.get("multipleOf")}set multipleOf(s){this.set("multipleOf",s)}get maximum(){return this.get("maximum")}set maximum(s){this.set("maximum",s)}get exclusiveMaximum(){return this.get("exclusiveMaximum")}set exclusiveMaximum(s){this.set("exclusiveMaximum",s)}get minimum(){return this.get("minimum")}set minimum(s){this.set("minimum",s)}get exclusiveMinimum(){return this.get("exclusiveMinimum")}set exclusiveMinimum(s){this.set("exclusiveMinimum",s)}get maxLength(){return this.get("maxLength")}set maxLength(s){this.set("maxLength",s)}get minLength(){return this.get("minLength")}set minLength(s){this.set("minLength",s)}get pattern(){return this.get("pattern")}set pattern(s){this.set("pattern",s)}get additionalItems(){return this.get("additionalItems")}set additionalItems(s){this.set("additionalItems",s)}get items(){return this.get("items")}set items(s){this.set("items",s)}get maxItems(){return this.get("maxItems")}set maxItems(s){this.set("maxItems",s)}get minItems(){return this.get("minItems")}set minItems(s){this.set("minItems",s)}get uniqueItems(){return this.get("uniqueItems")}set uniqueItems(s){this.set("uniqueItems",s)}get maxProperties(){return this.get("maxProperties")}set maxProperties(s){this.set("maxProperties",s)}get minProperties(){return this.get("minProperties")}set minProperties(s){this.set("minProperties",s)}get required(){return this.get("required")}set required(s){this.set("required",s)}get properties(){return this.get("properties")}set properties(s){this.set("properties",s)}get additionalProperties(){return this.get("additionalProperties")}set additionalProperties(s){this.set("additionalProperties",s)}get patternProperties(){return this.get("patternProperties")}set patternProperties(s){this.set("patternProperties",s)}get dependencies(){return this.get("dependencies")}set dependencies(s){this.set("dependencies",s)}get enum(){return this.get("enum")}set enum(s){this.set("enum",s)}get type(){return this.get("type")}set type(s){this.set("type",s)}get allOf(){return this.get("allOf")}set allOf(s){this.set("allOf",s)}get anyOf(){return this.get("anyOf")}set anyOf(s){this.set("anyOf",s)}get oneOf(){return this.get("oneOf")}set oneOf(s){this.set("oneOf",s)}get not(){return this.get("not")}set not(s){this.set("not",s)}get definitions(){return this.get("definitions")}set definitions(s){this.set("definitions",s)}get title(){return this.get("title")}set title(s){this.set("title",s)}get description(){return this.get("description")}set description(s){this.set("description",s)}get default(){return this.get("default")}set default(s){this.set("default",s)}get format(){return this.get("format")}set format(s){this.set("format",s)}get base(){return this.get("base")}set base(s){this.set("base",s)}get links(){return this.get("links")}set links(s){this.set("links",s)}get media(){return this.get("media")}set media(s){this.set("media",s)}get readOnly(){return this.get("readOnly")}set readOnly(s){this.set("readOnly",s)}}const Lh=JSONSchema;class JSONReference extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="JSONReference",this.classes.push("json-reference")}get $ref(){return this.get("$ref")}set $ref(s){this.set("$ref",s)}}const Fh=JSONReference;class Media extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="media"}get binaryEncoding(){return this.get("binaryEncoding")}set binaryEncoding(s){this.set("binaryEncoding",s)}get type(){return this.get("type")}set type(s){this.set("type",s)}}const Jh=Media;class LinkDescription extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="linkDescription"}get href(){return this.get("href")}set href(s){this.set("href",s)}get rel(){return this.get("rel")}set rel(s){this.set("rel",s)}get title(){return this.get("title")}set title(s){this.set("title",s)}get targetSchema(){return this.get("targetSchema")}set targetSchema(s){this.set("targetSchema",s)}get mediaType(){return this.get("mediaType")}set mediaType(s){this.set("mediaType",s)}get method(){return this.get("method")}set method(s){this.set("method",s)}get encType(){return this.get("encType")}set encType(s){this.set("encType",s)}get schema(){return this.get("schema")}set schema(s){this.set("schema",s)}}const Hh=LinkDescription,emptyElement=s=>{const o=s.meta.length>0?cloneDeep(s.meta):void 0,i=s.attributes.length>0?cloneDeep(s.attributes):void 0;return new s.constructor(void 0,o,i)},cloneUnlessOtherwiseSpecified=(s,o)=>o.clone&&o.isMergeableElement(s)?deepmerge(emptyElement(s),s,o):s,Kh={clone:!0,isMergeableElement:s=>ku(s)||Ou(s),arrayElementMerge:(s,o,i)=>s.concat(o)["fantasy-land/map"]((s=>cloneUnlessOtherwiseSpecified(s,i))),objectElementMerge:(s,o,i)=>{const a=ku(s)?emptyElement(s):emptyElement(o);return ku(s)&&s.forEach(((s,o,u)=>{const _=cloneShallow(u);_.value=cloneUnlessOtherwiseSpecified(s,i),a.content.push(_)})),o.forEach(((o,u,_)=>{const w=serializers_value(u);let x;if(ku(s)&&s.hasKey(w)&&i.isMergeableElement(o)){const a=s.get(w);x=cloneShallow(_),x.value=((s,o)=>{if("function"!=typeof o.customMerge)return deepmerge;const i=o.customMerge(s,o);return"function"==typeof i?i:deepmerge})(u,i)(a,o,i)}else x=cloneShallow(_),x.value=cloneUnlessOtherwiseSpecified(o,i);a.remove(w),a.content.push(x)})),a},customMerge:void 0,customMetaMerge:void 0,customAttributesMerge:void 0},deepmerge=(s,o,i)=>{var a,u,_;const w={...Kh,...i};w.isMergeableElement=null!==(a=w.isMergeableElement)&&void 0!==a?a:Kh.isMergeableElement,w.arrayElementMerge=null!==(u=w.arrayElementMerge)&&void 0!==u?u:Kh.arrayElementMerge,w.objectElementMerge=null!==(_=w.objectElementMerge)&&void 0!==_?_:Kh.objectElementMerge;const x=Ou(o);if(!(x===Ou(s)))return cloneUnlessOtherwiseSpecified(o,w);const C=x&&"function"==typeof w.arrayElementMerge?w.arrayElementMerge(s,o,w):w.objectElementMerge(s,o,w);return C.meta=(s=>"function"!=typeof s.customMetaMerge?s=>cloneDeep(s):s.customMetaMerge)(w)(s.meta,o.meta),C.attributes=(s=>"function"!=typeof s.customAttributesMerge?s=>cloneDeep(s):s.customAttributesMerge)(w)(s.attributes,o.attributes),C};deepmerge.all=(s,o)=>{if(!Array.isArray(s))throw new TypeError("First argument of deepmerge should be an array.");return 0===s.length?new du.Sh:s.reduce(((s,i)=>deepmerge(s,i,o)),emptyElement(s[0]))};const Gh=deepmerge;const Qh=class Visitor_Visitor{element;constructor(s){Object.assign(this,s)}copyMetaAndAttributes(s,o){(s.meta.length>0||o.meta.length>0)&&(o.meta=Gh(o.meta,s.meta)),hasElementSourceMap(s)&&assignSourceMap(o,s),(s.attributes.length>0||s.meta.length>0)&&(o.attributes=Gh(o.attributes,s.attributes))}};const td=class FallbackVisitor extends Qh{enter(s){return this.element=cloneDeep(s),Nu}},copyProps=(s,o,i=[])=>{const a=Object.getOwnPropertyDescriptors(o);for(let s of i)delete a[s];Object.defineProperties(s,a)},protoChain=(s,o=[s])=>{const i=Object.getPrototypeOf(s);return null===i?o:protoChain(i,[...o,i])},hardMixProtos=(s,o,i=[])=>{var a;const u=null!==(a=((...s)=>{if(0===s.length)return;let o;const i=s.map((s=>protoChain(s)));for(;i.every((s=>s.length>0));){const s=i.map((s=>s.pop())),a=s[0];if(!s.every((s=>s===a)))break;o=a}return o})(...s))&&void 0!==a?a:Object.prototype,_=Object.create(u),w=protoChain(u);for(let o of s){let s=protoChain(o);for(let o=s.length-1;o>=0;o--){let a=s[o];-1===w.indexOf(a)&&(copyProps(_,a,["constructor",...i]),w.push(a))}}return _.constructor=o,_},unique=s=>s.filter(((o,i)=>s.indexOf(o)==i)),getIngredientWithProp=(s,o)=>{const i=o.map((s=>protoChain(s)));let a=0,u=!0;for(;u;){u=!1;for(let _=o.length-1;_>=0;_--){const o=i[_][a];if(null!=o&&(u=!0,null!=Object.getOwnPropertyDescriptor(o,s)))return i[_][0]}a++}},proxyMix=(s,o=Object.prototype)=>new Proxy({},{getPrototypeOf:()=>o,setPrototypeOf(){throw Error("Cannot set prototype of Proxies created by ts-mixer")},getOwnPropertyDescriptor:(o,i)=>Object.getOwnPropertyDescriptor(getIngredientWithProp(i,s)||{},i),defineProperty(){throw new Error("Cannot define new properties on Proxies created by ts-mixer")},has:(i,a)=>void 0!==getIngredientWithProp(a,s)||void 0!==o[a],get:(i,a)=>(getIngredientWithProp(a,s)||o)[a],set(o,i,a){const u=getIngredientWithProp(i,s);if(void 0===u)throw new Error("Cannot set new properties on Proxies created by ts-mixer");return u[i]=a,!0},deleteProperty(){throw new Error("Cannot delete properties on Proxies created by ts-mixer")},ownKeys:()=>s.map(Object.getOwnPropertyNames).reduce(((s,o)=>o.concat(s.filter((s=>o.indexOf(s)<0)))))}),sd=null,id="copy",cd="copy",ld="deep",ud=new WeakMap,getMixinsForClass=s=>ud.get(s),mergeObjectsOfDecorators=(s,o)=>{var i,a;const u=unique([...Object.getOwnPropertyNames(s),...Object.getOwnPropertyNames(o)]),_={};for(let w of u)_[w]=unique([...null!==(i=null==s?void 0:s[w])&&void 0!==i?i:[],...null!==(a=null==o?void 0:o[w])&&void 0!==a?a:[]]);return _},mergePropertyAndMethodDecorators=(s,o)=>{var i,a,u,_;return{property:mergeObjectsOfDecorators(null!==(i=null==s?void 0:s.property)&&void 0!==i?i:{},null!==(a=null==o?void 0:o.property)&&void 0!==a?a:{}),method:mergeObjectsOfDecorators(null!==(u=null==s?void 0:s.method)&&void 0!==u?u:{},null!==(_=null==o?void 0:o.method)&&void 0!==_?_:{})}},mergeDecorators=(s,o)=>{var i,a,u,_,w,x;return{class:unique([...null!==(i=null==s?void 0:s.class)&&void 0!==i?i:[],...null!==(a=null==o?void 0:o.class)&&void 0!==a?a:[]]),static:mergePropertyAndMethodDecorators(null!==(u=null==s?void 0:s.static)&&void 0!==u?u:{},null!==(_=null==o?void 0:o.static)&&void 0!==_?_:{}),instance:mergePropertyAndMethodDecorators(null!==(w=null==s?void 0:s.instance)&&void 0!==w?w:{},null!==(x=null==o?void 0:o.instance)&&void 0!==x?x:{})}},dd=new Map,deepDecoratorSearch=(...s)=>{const o=((...s)=>{var o;const i=new Set,a=new Set([...s]);for(;a.size>0;)for(let s of a){const u=protoChain(s.prototype).map((s=>s.constructor)),_=[...u,...null!==(o=getMixinsForClass(s))&&void 0!==o?o:[]].filter((s=>!i.has(s)));for(let s of _)a.add(s);i.add(s),a.delete(s)}return[...i]})(...s).map((s=>dd.get(s))).filter((s=>!!s));return 0==o.length?{}:1==o.length?o[0]:o.reduce(((s,o)=>mergeDecorators(s,o)))},getDecoratorsForClass=s=>{let o=dd.get(s);return o||(o={},dd.set(s,o)),o};function Mixin(...s){var o,i,a;const u=s.map((s=>s.prototype)),_=sd;if(null!==_){const s=u.map((s=>s[_])).filter((s=>"function"==typeof s)),combinedInitFunction=function(...o){for(let i of s)i.apply(this,o)},o={[_]:combinedInitFunction};u.push(o)}function MixedClass(...o){for(const i of s)copyProps(this,new i(...o));null!==_&&"function"==typeof this[_]&&this[_].apply(this,o)}var w,x;MixedClass.prototype="copy"===cd?hardMixProtos(u,MixedClass):(w=u,x=MixedClass,proxyMix([...w,{constructor:x}])),Object.setPrototypeOf(MixedClass,"copy"===id?hardMixProtos(s,null,["prototype"]):proxyMix(s,Function.prototype));let C=MixedClass;if("none"!==ld){const u="deep"===ld?deepDecoratorSearch(...s):((...s)=>{const o=s.map((s=>getDecoratorsForClass(s)));return 0===o.length?{}:1===o.length?o[0]:o.reduce(((s,o)=>mergeDecorators(s,o)))})(...s);for(let s of null!==(o=null==u?void 0:u.class)&&void 0!==o?o:[]){const o=s(C);o&&(C=o)}applyPropAndMethodDecorators(null!==(i=null==u?void 0:u.static)&&void 0!==i?i:{},C),applyPropAndMethodDecorators(null!==(a=null==u?void 0:u.instance)&&void 0!==a?a:{},C.prototype)}var j,L;return j=C,L=s,ud.set(j,L),C}const applyPropAndMethodDecorators=(s,o)=>{const i=s.property,a=s.method;if(i)for(let s in i)for(let a of i[s])a(o,s);if(a)for(let s in a)for(let i of a[s])i(o,s,Object.getOwnPropertyDescriptor(o,s))};const md=_curry1((function allPass(s){return la(Pi(fc,0,bc("length",s)),(function(){for(var o=0,i=s.length;o<i;){if(!s[o].apply(this,arguments))return!1;o+=1}return!0}))}));const yd=_curry1((function isNotEmpty(s){return!cp(s)}));const vd=_curry2((function or(s,o){return s||o}));var Sd=cc(la(1,Xl(Zl,_curry2((function either(s,o){return _isFunction(s)?function _either(){return s.apply(this,arguments)||o.apply(this,arguments)}:ac(vd)(s,o)}))(eu,jc))));const _d=md([Rc,Sd,yd]);const Ed=_curry2((function pick(s,o){for(var i={},a=0;a<s.length;)s[a]in o&&(i[s[a]]=o[s[a]]),a+=1;return i}));const wd=class SpecificationVisitor extends Qh{specObj;passingOptionsNames=["specObj","parent"];constructor({specObj:s,...o}){super({...o}),this.specObj=s}retrievePassingOptions(){return Ed(this.passingOptionsNames,this)}retrieveFixedFields(s){const o=zu(["visitors",...s,"fixedFields"],this.specObj);return"object"==typeof o&&null!==o?Object.keys(o):[]}retrieveVisitor(s){return Gl(jc,["visitors",...s],this.specObj)?zu(["visitors",...s],this.specObj):zu(["visitors",...s,"$visitor"],this.specObj)}retrieveVisitorInstance(s,o={}){const i=this.retrievePassingOptions();return new(this.retrieveVisitor(s))({...i,...o})}toRefractedElement(s,o,i={}){const a=this.retrieveVisitorInstance(s,i);return a instanceof td&&(null==a?void 0:a.constructor)===td?cloneDeep(o):(visitor_visit(o,a,i),a.element)}};const xd=class FixedFieldsVisitor extends wd{specPath;ignoredFields;constructor({specPath:s,ignoredFields:o,...i}){super({...i}),this.specPath=s,this.ignoredFields=o||[]}ObjectElement(s){const o=this.specPath(s),i=this.retrieveFixedFields(o);return s.forEach(((s,a,u)=>{if(_u(a)&&i.includes(serializers_value(a))&&!this.ignoredFields.includes(serializers_value(a))){const i=this.toRefractedElement([...o,"fixedFields",serializers_value(a)],s),_=new du.Pr(cloneDeep(a),i);this.copyMetaAndAttributes(u,_),_.classes.push("fixed-field"),this.element.content.push(_)}else this.ignoredFields.includes(serializers_value(a))||this.element.content.push(cloneDeep(u))})),this.copyMetaAndAttributes(s,this.element),Nu}};const kd=class ParentSchemaAwareVisitor{parent;constructor({parent:s}){this.parent=s}},Od=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Lh||s(a)&&o("JSONSchemaDraft4",a)&&i("object",a))),Ad=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Fh||s(a)&&o("JSONReference",a)&&i("object",a))),Cd=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Jh||s(a)&&o("media",a)&&i("object",a))),Id=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Hh||s(a)&&o("linkDescription",a)&&i("object",a)));class JSONSchemaVisitor extends(Mixin(xd,kd,td)){constructor(s){super(s),this.element=new Lh,this.specPath=lc(["document","objects","JSONSchema"])}get defaultDialectIdentifier(){return"http://json-schema.org/draft-04/schema#"}ObjectElement(s){return this.handleDialectIdentifier(s),this.handleSchemaIdentifier(s),this.parent=this.element,xd.prototype.ObjectElement.call(this,s)}handleDialectIdentifier(s){if(hc(this.parent)&&!_u(s.get("$schema")))this.element.setMetaProperty("inheritedDialectIdentifier",this.defaultDialectIdentifier);else if(Od(this.parent)&&!_u(s.get("$schema"))){const s=ea(serializers_value(this.parent.meta.get("inheritedDialectIdentifier")),serializers_value(this.parent.$schema));this.element.setMetaProperty("inheritedDialectIdentifier",s)}}handleSchemaIdentifier(s,o="id"){const i=void 0!==this.parent?cloneDeep(this.parent.getMetaProperty("ancestorsSchemaIdentifiers",[])):new du.wE,a=serializers_value(s.get(o));_d(a)&&i.push(a),this.element.setMetaProperty("ancestorsSchemaIdentifiers",i)}}const Td=JSONSchemaVisitor,isJSONReferenceLikeElement=s=>ku(s)&&s.hasKey("$ref");class ItemsVisitor extends(Mixin(wd,kd,td)){ObjectElement(s){const o=isJSONReferenceLikeElement(s)?["document","objects","JSONReference"]:["document","objects","JSONSchema"];return this.element=this.toRefractedElement(o,s),Nu}ArrayElement(s){return this.element=new du.wE,this.element.classes.push("json-schema-items"),s.forEach((s=>{const o=isJSONReferenceLikeElement(s)?["document","objects","JSONReference"]:["document","objects","JSONSchema"],i=this.toRefractedElement(o,s);this.element.push(i)})),this.copyMetaAndAttributes(s,this.element),Nu}}const Nd=ItemsVisitor;const Md=class RequiredVisitor extends td{ArrayElement(s){const o=this.enter(s);return this.element.classes.push("json-schema-required"),o}};const Rd=class PatternedFieldsVisitor extends wd{specPath;ignoredFields;fieldPatternPredicate=es_F;constructor({specPath:s,ignoredFields:o,fieldPatternPredicate:i,...a}){super({...a}),this.specPath=s,this.ignoredFields=o||[],"function"==typeof i&&(this.fieldPatternPredicate=i)}ObjectElement(s){return s.forEach(((s,o,i)=>{if(!this.ignoredFields.includes(serializers_value(o))&&this.fieldPatternPredicate(serializers_value(o))){const a=this.specPath(s),u=this.toRefractedElement(a,s),_=new du.Pr(cloneDeep(o),u);this.copyMetaAndAttributes(i,_),_.classes.push("patterned-field"),this.element.content.push(_)}else this.ignoredFields.includes(serializers_value(o))||this.element.content.push(cloneDeep(i))})),this.copyMetaAndAttributes(s,this.element),Nu}};const Dd=class MapVisitor extends Rd{constructor(s){super(s),this.fieldPatternPredicate=_d}};class PropertiesVisitor extends(Mixin(Dd,kd,td)){constructor(s){super(s),this.element=new du.Sh,this.element.classes.push("json-schema-properties"),this.specPath=s=>isJSONReferenceLikeElement(s)?["document","objects","JSONReference"]:["document","objects","JSONSchema"]}}const Ld=PropertiesVisitor;class PatternPropertiesVisitor extends(Mixin(Dd,kd,td)){constructor(s){super(s),this.element=new du.Sh,this.element.classes.push("json-schema-patternProperties"),this.specPath=s=>isJSONReferenceLikeElement(s)?["document","objects","JSONReference"]:["document","objects","JSONSchema"]}}const Fd=PatternPropertiesVisitor;class DependenciesVisitor extends(Mixin(Dd,kd,td)){constructor(s){super(s),this.element=new du.Sh,this.element.classes.push("json-schema-dependencies"),this.specPath=s=>isJSONReferenceLikeElement(s)?["document","objects","JSONReference"]:["document","objects","JSONSchema"]}}const Bd=DependenciesVisitor;const $d=class EnumVisitor extends td{ArrayElement(s){const o=this.enter(s);return this.element.classes.push("json-schema-enum"),o}};const Ud=class TypeVisitor extends td{StringElement(s){const o=this.enter(s);return this.element.classes.push("json-schema-type"),o}ArrayElement(s){const o=this.enter(s);return this.element.classes.push("json-schema-type"),o}};class AllOfVisitor extends(Mixin(wd,kd,td)){constructor(s){super(s),this.element=new du.wE,this.element.classes.push("json-schema-allOf")}ArrayElement(s){return s.forEach((s=>{const o=isJSONReferenceLikeElement(s)?["document","objects","JSONReference"]:["document","objects","JSONSchema"],i=this.toRefractedElement(o,s);this.element.push(i)})),this.copyMetaAndAttributes(s,this.element),Nu}}const Vd=AllOfVisitor;class AnyOfVisitor extends(Mixin(wd,kd,td)){constructor(s){super(s),this.element=new du.wE,this.element.classes.push("json-schema-anyOf")}ArrayElement(s){return s.forEach((s=>{const o=isJSONReferenceLikeElement(s)?["document","objects","JSONReference"]:["document","objects","JSONSchema"],i=this.toRefractedElement(o,s);this.element.push(i)})),this.copyMetaAndAttributes(s,this.element),Nu}}const Wd=AnyOfVisitor;class OneOfVisitor extends(Mixin(wd,kd,td)){constructor(s){super(s),this.element=new du.wE,this.element.classes.push("json-schema-oneOf")}ArrayElement(s){return s.forEach((s=>{const o=isJSONReferenceLikeElement(s)?["document","objects","JSONReference"]:["document","objects","JSONSchema"],i=this.toRefractedElement(o,s);this.element.push(i)})),this.copyMetaAndAttributes(s,this.element),Nu}}const Jd=OneOfVisitor;class DefinitionsVisitor extends(Mixin(Dd,kd,td)){constructor(s){super(s),this.element=new du.Sh,this.element.classes.push("json-schema-definitions"),this.specPath=s=>isJSONReferenceLikeElement(s)?["document","objects","JSONReference"]:["document","objects","JSONSchema"]}}const Hd=DefinitionsVisitor;class LinksVisitor extends(Mixin(wd,kd,td)){constructor(s){super(s),this.element=new du.wE,this.element.classes.push("json-schema-links")}ArrayElement(s){return s.forEach((s=>{const o=this.toRefractedElement(["document","objects","LinkDescription"],s);this.element.push(o)})),this.copyMetaAndAttributes(s,this.element),Nu}}const Kd=LinksVisitor;class JSONReferenceVisitor extends(Mixin(xd,td)){constructor(s){super(s),this.element=new Fh,this.specPath=lc(["document","objects","JSONReference"])}ObjectElement(s){const o=xd.prototype.ObjectElement.call(this,s);return _u(this.element.$ref)&&this.element.classes.push("reference-element"),o}}const Gd=JSONReferenceVisitor;const Yd=class $RefVisitor extends td{StringElement(s){const o=this.enter(s);return this.element.classes.push("reference-value"),o}};const Xd=_curry3((function ifElse(s,o,i){return la(Math.max(s.length,o.length,i.length),(function _ifElse(){return s.apply(this,arguments)?o.apply(this,arguments):i.apply(this,arguments)}))}));const Qd=_curry1((function comparator(s){return function(o,i){return s(o,i)?-1:s(i,o)?1:0}}));var Zd=_curry2((function sort(s,o){return Array.prototype.slice.call(o,0).sort(s)}));const ef=Zd;var rf=_curry1((function(s){return _nth(0,s)}));const of=rf;const af=_curry1(_reduced);const cf=cc(Fu);const lf=Xl(lp,yd);function _toConsumableArray(s){return function _arrayWithoutHoles(s){if(Array.isArray(s))return _arrayLikeToArray(s)}(s)||function _iterableToArray(s){if("undefined"!=typeof Symbol&&null!=s[Symbol.iterator]||null!=s["@@iterator"])return Array.from(s)}(s)||function _unsupportedIterableToArray(s,o){if(s){if("string"==typeof s)return _arrayLikeToArray(s,o);var i={}.toString.call(s).slice(8,-1);return"Object"===i&&s.constructor&&(i=s.constructor.name),"Map"===i||"Set"===i?Array.from(s):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?_arrayLikeToArray(s,o):void 0}}(s)||function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function _arrayLikeToArray(s,o){(null==o||o>s.length)&&(o=s.length);for(var i=0,a=Array(o);i<o;i++)a[i]=s[i];return a}var uf=pipe(ef(Qd((function(s,o){return s.length>o.length}))),of,na("length")),hf=ua((function(s,o,i){var a=i.apply(void 0,_toConsumableArray(s));return cf(a)?af(a):o}));const df=Xd(lf,(function dispatchImpl(s){var o=uf(s);return la(o,(function(){for(var o=arguments.length,i=new Array(o),a=0;a<o;a++)i[a]=arguments[a];return Pi(hf(i),void 0,s)}))}),pc);const mf=class AlternatingVisitor extends wd{alternator;constructor({alternator:s,...o}){super({...o}),this.alternator=s}enter(s){const o=this.alternator.map((({predicate:s,specPath:o})=>Xd(s,lc(o),pc))),i=df(o)(s);return this.element=this.toRefractedElement(i,s),Nu}};const gf=class SchemaOrReferenceVisitor extends mf{constructor(s){super(s),this.alternator=[{predicate:isJSONReferenceLikeElement,specPath:["document","objects","JSONReference"]},{predicate:es_T,specPath:["document","objects","JSONSchema"]}]}};class MediaVisitor extends(Mixin(xd,td)){constructor(s){super(s),this.element=new Jh,this.specPath=lc(["document","objects","Media"])}}const yf=MediaVisitor;class LinkDescriptionVisitor extends(Mixin(xd,td)){constructor(s){super(s),this.element=new Hh,this.specPath=lc(["document","objects","LinkDescription"])}}const bf=LinkDescriptionVisitor,Sf={visitors:{value:td,JSONSchemaOrJSONReferenceVisitor:gf,document:{objects:{JSONSchema:{$visitor:Td,fixedFields:{id:{$ref:"#/visitors/value"},$schema:{$ref:"#/visitors/value"},multipleOf:{$ref:"#/visitors/value"},maximum:{$ref:"#/visitors/value"},exclusiveMaximum:{$ref:"#/visitors/value"},minimum:{$ref:"#/visitors/value"},exclusiveMinimum:{$ref:"#/visitors/value"},maxLength:{$ref:"#/visitors/value"},minLength:{$ref:"#/visitors/value"},pattern:{$ref:"#/visitors/value"},additionalItems:gf,items:Nd,maxItems:{$ref:"#/visitors/value"},minItems:{$ref:"#/visitors/value"},uniqueItems:{$ref:"#/visitors/value"},maxProperties:{$ref:"#/visitors/value"},minProperties:{$ref:"#/visitors/value"},required:Md,properties:Ld,additionalProperties:gf,patternProperties:Fd,dependencies:Bd,enum:$d,type:Ud,allOf:Vd,anyOf:Wd,oneOf:Jd,not:gf,definitions:Hd,title:{$ref:"#/visitors/value"},description:{$ref:"#/visitors/value"},default:{$ref:"#/visitors/value"},format:{$ref:"#/visitors/value"},base:{$ref:"#/visitors/value"},links:Kd,media:{$ref:"#/visitors/document/objects/Media"},readOnly:{$ref:"#/visitors/value"}}},JSONReference:{$visitor:Gd,fixedFields:{$ref:Yd}},Media:{$visitor:yf,fixedFields:{binaryEncoding:{$ref:"#/visitors/value"},type:{$ref:"#/visitors/value"}}},LinkDescription:{$visitor:bf,fixedFields:{href:{$ref:"#/visitors/value"},rel:{$ref:"#/visitors/value"},title:{$ref:"#/visitors/value"},targetSchema:gf,mediaType:{$ref:"#/visitors/value"},method:{$ref:"#/visitors/value"},encType:{$ref:"#/visitors/value"},schema:gf}}}}}},traversal_visitor_getNodeType=s=>{if(Su(s))return`${s.element.charAt(0).toUpperCase()+s.element.slice(1)}Element`},_f={JSONSchemaDraft4Element:["content"],JSONReferenceElement:["content"],MediaElement:["content"],LinkDescriptionElement:["content"],...Gu},xf={namespace:s=>{const{base:o}=s;return o.register("jSONSchemaDraft4",Lh),o.register("jSONReference",Fh),o.register("media",Jh),o.register("linkDescription",Hh),o}},kf=xf,refractor_toolbox=()=>{const s=createNamespace(kf);return{predicates:{...ae,isStringElement:_u},namespace:s}},refractor_refract=(s,{specPath:o=["visitors","document","objects","JSONSchema","$visitor"],plugins:i=[],specificationObj:a=Sf}={})=>{const u=(0,du.e)(s),_=dereference(a),w=new(zu(o,_))({specObj:_});return visitor_visit(u,w),dispatchPluginsSync(w.element,i,{toolboxCreator:refractor_toolbox,visitorOptions:{keyMap:_f,nodeTypeGetter:traversal_visitor_getNodeType}})},refractor_createRefractor=s=>(o,i={})=>refractor_refract(o,{specPath:s,...i});Lh.refract=refractor_createRefractor(["visitors","document","objects","JSONSchema","$visitor"]),Fh.refract=refractor_createRefractor(["visitors","document","objects","JSONReference","$visitor"]),Jh.refract=refractor_createRefractor(["visitors","document","objects","Media","$visitor"]),Hh.refract=refractor_createRefractor(["visitors","document","objects","LinkDescription","$visitor"]);const Of=class Schema_Schema extends Lh{constructor(s,o,i){super(s,o,i),this.element="schema",this.classes.push("json-schema-draft-4")}get idProp(){throw new Dh("idProp getter in Schema class is not not supported.")}set idProp(s){throw new Dh("idProp setter in Schema class is not not supported.")}get $schema(){throw new Dh("$schema getter in Schema class is not not supported.")}set $schema(s){throw new Dh("$schema setter in Schema class is not not supported.")}get additionalItems(){return this.get("additionalItems")}set additionalItems(s){this.set("additionalItems",s)}get items(){return this.get("items")}set items(s){this.set("items",s)}get additionalProperties(){return this.get("additionalProperties")}set additionalProperties(s){this.set("additionalProperties",s)}get patternProperties(){throw new Dh("patternProperties getter in Schema class is not not supported.")}set patternProperties(s){throw new Dh("patternProperties setter in Schema class is not not supported.")}get dependencies(){throw new Dh("dependencies getter in Schema class is not not supported.")}set dependencies(s){throw new Dh("dependencies setter in Schema class is not not supported.")}get type(){return this.get("type")}set type(s){this.set("type",s)}get not(){return this.get("not")}set not(s){this.set("not",s)}get definitions(){throw new Dh("definitions getter in Schema class is not not supported.")}set definitions(s){throw new Dh("definitions setter in Schema class is not not supported.")}get base(){throw new Dh("base getter in Schema class is not not supported.")}set base(s){throw new Dh("base setter in Schema class is not not supported.")}get links(){throw new Dh("links getter in Schema class is not not supported.")}set links(s){throw new Dh("links setter in Schema class is not not supported.")}get media(){throw new Dh("media getter in Schema class is not not supported.")}set media(s){throw new Dh("media setter in Schema class is not not supported.")}get nullable(){return this.get("nullable")}set nullable(s){this.set("nullable",s)}get discriminator(){return this.get("discriminator")}set discriminator(s){this.set("discriminator",s)}get writeOnly(){return this.get("writeOnly")}set writeOnly(s){this.set("writeOnly",s)}get xml(){return this.get("xml")}set xml(s){this.set("xml",s)}get externalDocs(){return this.get("externalDocs")}set externalDocs(s){this.set("externalDocs",s)}get example(){return this.get("example")}set example(s){this.set("example",s)}get deprecated(){return this.get("deprecated")}set deprecated(s){this.set("deprecated",s)}};class SecurityRequirement extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="securityRequirement"}}const Cf=SecurityRequirement;class SecurityScheme extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="securityScheme"}get type(){return this.get("type")}set type(s){this.set("type",s)}get description(){return this.get("description")}set description(s){this.set("description",s)}get name(){return this.get("name")}set name(s){this.set("name",s)}get in(){return this.get("in")}set in(s){this.set("in",s)}get scheme(){return this.get("scheme")}set scheme(s){this.set("scheme",s)}get bearerFormat(){return this.get("bearerFormat")}set bearerFormat(s){this.set("bearerFormat",s)}get flows(){return this.get("flows")}set flows(s){this.set("flows",s)}get openIdConnectUrl(){return this.get("openIdConnectUrl")}set openIdConnectUrl(s){this.set("openIdConnectUrl",s)}}const jf=SecurityScheme;class Server extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="server"}get url(){return this.get("url")}set url(s){this.set("url",s)}get description(){return this.get("description")}set description(s){this.set("description",s)}get variables(){return this.get("variables")}set variables(s){this.set("variables",s)}}const Pf=Server;class ServerVariable extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="serverVariable"}get enum(){return this.get("enum")}set enum(s){this.set("enum",s)}get default(){return this.get("default")}set default(s){this.set("default",s)}get description(){return this.get("description")}set description(s){this.set("description",s)}}const Tf=ServerVariable;class Tag extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="tag"}get name(){return this.get("name")}set name(s){this.set("name",s)}get description(){return this.get("description")}set description(s){this.set("description",s)}get externalDocs(){return this.get("externalDocs")}set externalDocs(s){this.set("externalDocs",s)}}const Nf=Tag;class Xml extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="xml"}get name(){return this.get("name")}set name(s){this.set("name",s)}get namespace(){return this.get("namespace")}set namespace(s){this.set("namespace",s)}get prefix(){return this.get("prefix")}set prefix(s){this.set("prefix",s)}get attribute(){return this.get("attribute")}set attribute(s){this.set("attribute",s)}get wrapped(){return this.get("wrapped")}set wrapped(s){this.set("wrapped",s)}}const Rf=Xml;const Df=class visitors_Visitor_Visitor{element;constructor(s={}){Object.assign(this,s)}copyMetaAndAttributes(s,o){(s.meta.length>0||o.meta.length>0)&&(o.meta=Gh(o.meta,s.meta)),hasElementSourceMap(s)&&assignSourceMap(o,s),(s.attributes.length>0||s.meta.length>0)&&(o.attributes=Gh(o.attributes,s.attributes))}};const Ff=class FallbackVisitor_FallbackVisitor extends Df{enter(s){return this.element=cloneDeep(s),Nu}};const Vf=class SpecificationVisitor_SpecificationVisitor extends Df{specObj;passingOptionsNames=["specObj","openApiGenericElement","openApiSemanticElement"];openApiGenericElement;openApiSemanticElement;constructor({specObj:s,passingOptionsNames:o,openApiGenericElement:i,openApiSemanticElement:a,...u}){super({...u}),this.specObj=s,this.openApiGenericElement=i,this.openApiSemanticElement=a,Array.isArray(o)&&(this.passingOptionsNames=o)}retrievePassingOptions(){return Ed(this.passingOptionsNames,this)}retrieveFixedFields(s){const o=zu(["visitors",...s,"fixedFields"],this.specObj);return"object"==typeof o&&null!==o?Object.keys(o):[]}retrieveVisitor(s){return Gl(jc,["visitors",...s],this.specObj)?zu(["visitors",...s],this.specObj):zu(["visitors",...s,"$visitor"],this.specObj)}retrieveVisitorInstance(s,o={}){const i=this.retrievePassingOptions();return new(this.retrieveVisitor(s))({...i,...o})}toRefractedElement(s,o,i={}){const a=this.retrieveVisitorInstance(s,i);return a instanceof Ff&&(null==a?void 0:a.constructor)===Ff?cloneDeep(o):(visitor_visit(o,a,i),a.element)}};var Wf=function(){function XTake(s,o){this.xf=o,this.n=s,this.i=0}return XTake.prototype["@@transducer/init"]=_xfBase_init,XTake.prototype["@@transducer/result"]=_xfBase_result,XTake.prototype["@@transducer/step"]=function(s,o){this.i+=1;var i=0===this.n?s:this.xf["@@transducer/step"](s,o);return this.n>=0&&this.i>=this.n?_reduced(i):i},XTake}();function _xtake(s){return function(o){return new Wf(s,o)}}const Jf=_curry2(_dispatchable(["take"],_xtake,(function take(s,o){return Ri(0,s<0?1/0:s,o)})));var Hf=_curry2((function(s,o){return ka(Jf(s.length,o),s)}));const Gf=Hf,isReferenceLikeElement=s=>ku(s)&&s.hasKey("$ref"),Xf=ku,Qf=ku,isOpenApiExtension=s=>_u(s.key)&&Gf("x-",serializers_value(s.key));const em=class FixedFieldsVisitor_FixedFieldsVisitor extends Vf{specPath;ignoredFields;canSupportSpecificationExtensions=!0;specificationExtensionPredicate=isOpenApiExtension;constructor({specPath:s,ignoredFields:o,canSupportSpecificationExtensions:i,specificationExtensionPredicate:a,...u}){super({...u}),this.specPath=s,this.ignoredFields=o||[],"boolean"==typeof i&&(this.canSupportSpecificationExtensions=i),"function"==typeof a&&(this.specificationExtensionPredicate=a)}ObjectElement(s){const o=this.specPath(s),i=this.retrieveFixedFields(o);return s.forEach(((s,a,u)=>{if(_u(a)&&i.includes(serializers_value(a))&&!this.ignoredFields.includes(serializers_value(a))){const i=this.toRefractedElement([...o,"fixedFields",serializers_value(a)],s),_=new du.Pr(cloneDeep(a),i);this.copyMetaAndAttributes(u,_),_.classes.push("fixed-field"),this.element.content.push(_)}else if(this.canSupportSpecificationExtensions&&this.specificationExtensionPredicate(u)){const s=this.toRefractedElement(["document","extension"],u);this.element.content.push(s)}else this.ignoredFields.includes(serializers_value(a))||this.element.content.push(cloneDeep(u))})),this.copyMetaAndAttributes(s,this.element),Nu}};class OpenApi3_0Visitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new fh,this.specPath=lc(["document","objects","OpenApi"]),this.canSupportSpecificationExtensions=!0}ObjectElement(s){return em.prototype.ObjectElement.call(this,s)}}const tm=OpenApi3_0Visitor;class OpenapiVisitor extends(Mixin(Vf,Ff)){StringElement(s){const o=new dh(serializers_value(s));return this.copyMetaAndAttributes(s,o),this.element=o,Nu}}const rm=OpenapiVisitor;const nm=class SpecificationExtensionVisitor extends Vf{MemberElement(s){return this.element=cloneDeep(s),this.element.classes.push("specification-extension"),Nu}};class InfoVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Xp,this.specPath=lc(["document","objects","Info"]),this.canSupportSpecificationExtensions=!0}}const sm=InfoVisitor;const om=class VersionVisitor extends Ff{StringElement(s){const o=super.enter(s);return this.element.classes.push("api-version"),this.element.classes.push("version"),o}};class ContactVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Wp,this.specPath=lc(["document","objects","Contact"]),this.canSupportSpecificationExtensions=!0}}const im=ContactVisitor;class LicenseVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Qp,this.specPath=lc(["document","objects","License"]),this.canSupportSpecificationExtensions=!0}}const am=LicenseVisitor;class LinkVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Zp,this.specPath=lc(["document","objects","Link"]),this.canSupportSpecificationExtensions=!0}ObjectElement(s){const o=em.prototype.ObjectElement.call(this,s);return(_u(this.element.operationId)||_u(this.element.operationRef))&&this.element.classes.push("reference-element"),o}}const cm=LinkVisitor;const lm=class OperationRefVisitor extends Ff{StringElement(s){const o=super.enter(s);return this.element.classes.push("reference-value"),o}};const um=class OperationIdVisitor extends Ff{StringElement(s){const o=super.enter(s);return this.element.classes.push("reference-value"),o}};const pm=class PatternedFieldsVisitor_PatternedFieldsVisitor extends Vf{specPath;ignoredFields;fieldPatternPredicate=es_F;canSupportSpecificationExtensions=!1;specificationExtensionPredicate=isOpenApiExtension;constructor({specPath:s,ignoredFields:o,fieldPatternPredicate:i,canSupportSpecificationExtensions:a,specificationExtensionPredicate:u,..._}){super({..._}),this.specPath=s,this.ignoredFields=o||[],"function"==typeof i&&(this.fieldPatternPredicate=i),"boolean"==typeof a&&(this.canSupportSpecificationExtensions=a),"function"==typeof u&&(this.specificationExtensionPredicate=u)}ObjectElement(s){return s.forEach(((s,o,i)=>{if(this.canSupportSpecificationExtensions&&this.specificationExtensionPredicate(i)){const s=this.toRefractedElement(["document","extension"],i);this.element.content.push(s)}else if(!this.ignoredFields.includes(serializers_value(o))&&this.fieldPatternPredicate(serializers_value(o))){const a=this.specPath(s),u=this.toRefractedElement(a,s),_=new du.Pr(cloneDeep(o),u);this.copyMetaAndAttributes(i,_),_.classes.push("patterned-field"),this.element.content.push(_)}else this.ignoredFields.includes(serializers_value(o))||this.element.content.push(cloneDeep(i))})),this.copyMetaAndAttributes(s,this.element),Nu}};const hm=class MapVisitor_MapVisitor extends pm{constructor(s){super(s),this.fieldPatternPredicate=_d}};class LinkParameters extends du.Sh{static primaryClass="link-parameters";constructor(s,o,i){super(s,o,i),this.classes.push(LinkParameters.primaryClass)}}const dm=LinkParameters;class ParametersVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new dm,this.specPath=lc(["value"])}}const fm=ParametersVisitor;class ServerVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Pf,this.specPath=lc(["document","objects","Server"]),this.canSupportSpecificationExtensions=!0}}const mm=ServerVisitor;const gm=class UrlVisitor extends Ff{StringElement(s){const o=super.enter(s);return this.element.classes.push("server-url"),o}};class Servers extends du.wE{static primaryClass="servers";constructor(s,o,i){super(s,o,i),this.classes.push(Servers.primaryClass)}}const ym=Servers;class ServersVisitor extends(Mixin(Vf,Ff)){constructor(s){super(s),this.element=new ym}ArrayElement(s){return s.forEach((s=>{const o=Xf(s)?["document","objects","Server"]:["value"],i=this.toRefractedElement(o,s);this.element.push(i)})),this.copyMetaAndAttributes(s,this.element),Nu}}const vm=ServersVisitor;class ServerVariableVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Tf,this.specPath=lc(["document","objects","ServerVariable"]),this.canSupportSpecificationExtensions=!0}}const bm=ServerVariableVisitor;class ServerVariables extends du.Sh{static primaryClass="server-variables";constructor(s,o,i){super(s,o,i),this.classes.push(ServerVariables.primaryClass)}}const Sm=ServerVariables;class VariablesVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new Sm,this.specPath=lc(["document","objects","ServerVariable"])}}const _m=VariablesVisitor;class MediaTypeVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new th,this.specPath=lc(["document","objects","MediaType"]),this.canSupportSpecificationExtensions=!0}}const Em=MediaTypeVisitor;const wm=class AlternatingVisitor_AlternatingVisitor extends Vf{alternator;constructor({alternator:s,...o}){super({...o}),this.alternator=s||[]}enter(s){const o=this.alternator.map((({predicate:s,specPath:o})=>Xd(s,lc(o),pc))),i=df(o)(s);return this.element=this.toRefractedElement(i,s),Nu}},xm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Vp||s(a)&&o("callback",a)&&i("object",a))),km=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof zp||s(a)&&o("components",a)&&i("object",a))),Om=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Wp||s(a)&&o("contact",a)&&i("object",a))),Am=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Kp||s(a)&&o("example",a)&&i("object",a))),Cm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Gp||s(a)&&o("externalDocumentation",a)&&i("object",a))),jm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Yp||s(a)&&o("header",a)&&i("object",a))),Pm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Xp||s(a)&&o("info",a)&&i("object",a))),Im=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Qp||s(a)&&o("license",a)&&i("object",a))),Tm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Zp||s(a)&&o("link",a)&&i("object",a))),Nm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof dh||s(a)&&o("openapi",a)&&i("string",a))),Mm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i,hasClass:a})=>u=>u instanceof fh||s(u)&&o("openApi3_0",u)&&i("object",u)&&a("api",u))),Rm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof vh||s(a)&&o("operation",a)&&i("object",a))),Dm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof _h||s(a)&&o("parameter",a)&&i("object",a))),Lm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof wh||s(a)&&o("pathItem",a)&&i("object",a))),Fm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Oh||s(a)&&o("paths",a)&&i("object",a))),Bm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof jh||s(a)&&o("reference",a)&&i("object",a))),$m=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Ph||s(a)&&o("requestBody",a)&&i("object",a))),qm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Ih||s(a)&&o("response",a)&&i("object",a))),Um=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Rh||s(a)&&o("responses",a)&&i("object",a))),Vm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Of||s(a)&&o("schema",a)&&i("object",a))),isBooleanJsonSchemaElement=s=>xu(s)&&s.classes.includes("boolean-json-schema"),zm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Cf||s(a)&&o("securityRequirement",a)&&i("object",a))),Wm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof jf||s(a)&&o("securityScheme",a)&&i("object",a))),Jm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Pf||s(a)&&o("server",a)&&i("object",a))),Hm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Tf||s(a)&&o("serverVariable",a)&&i("object",a))),Km=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof th||s(a)&&o("mediaType",a)&&i("object",a))),Gm=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i,hasClass:a})=>u=>u instanceof ym||s(u)&&o("array",u)&&i("array",u)&&a("servers",u))),Ym=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Jp||s(a)&&o("discriminator",a)&&i("object",a)));class SchemaVisitor extends(Mixin(wm,Ff)){constructor(s){super(s),this.alternator=[{predicate:isReferenceLikeElement,specPath:["document","objects","Reference"]},{predicate:es_T,specPath:["document","objects","Schema"]}]}ObjectElement(s){const o=wm.prototype.enter.call(this,s);return Bm(this.element)&&this.element.setMetaProperty("referenced-element","schema"),o}}const Xm=SchemaVisitor;class ExamplesVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new du.Sh,this.element.classes.push("examples"),this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","Example"],this.canSupportSpecificationExtensions=!0}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","example")})),o}}const Qm=ExamplesVisitor;class MediaTypeExamples extends du.Sh{static primaryClass="media-type-examples";constructor(s,o,i){super(s,o,i),this.classes.push(MediaTypeExamples.primaryClass),this.classes.push("examples")}}const Zm=MediaTypeExamples;const eg=class ExamplesVisitor_ExamplesVisitor extends Qm{constructor(s){super(s),this.element=new Zm}};class MediaTypeEncoding extends du.Sh{static primaryClass="media-type-encoding";constructor(s,o,i){super(s,o,i),this.classes.push(MediaTypeEncoding.primaryClass)}}const rg=MediaTypeEncoding;class EncodingVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new rg,this.specPath=lc(["document","objects","Encoding"])}}const ng=EncodingVisitor;class SecurityRequirementVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new Cf,this.specPath=lc(["value"])}}const sg=SecurityRequirementVisitor;class Security extends du.wE{static primaryClass="security";constructor(s,o,i){super(s,o,i),this.classes.push(Security.primaryClass)}}const og=Security;class SecurityVisitor extends(Mixin(Vf,Ff)){constructor(s){super(s),this.element=new og}ArrayElement(s){return s.forEach((s=>{if(ku(s)){const o=this.toRefractedElement(["document","objects","SecurityRequirement"],s);this.element.push(o)}else this.element.push(cloneDeep(s))})),this.copyMetaAndAttributes(s,this.element),Nu}}const lg=SecurityVisitor;class ComponentsVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new zp,this.specPath=lc(["document","objects","Components"]),this.canSupportSpecificationExtensions=!0}}const pg=ComponentsVisitor;class TagVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Nf,this.specPath=lc(["document","objects","Tag"]),this.canSupportSpecificationExtensions=!0}}const fg=TagVisitor;class ReferenceVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new jh,this.specPath=lc(["document","objects","Reference"]),this.canSupportSpecificationExtensions=!1}ObjectElement(s){const o=em.prototype.ObjectElement.call(this,s);return _u(this.element.$ref)&&this.element.classes.push("reference-element"),o}}const mg=ReferenceVisitor;const gg=class $RefVisitor_$RefVisitor extends Ff{StringElement(s){const o=super.enter(s);return this.element.classes.push("reference-value"),o}};class ParameterVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new _h,this.specPath=lc(["document","objects","Parameter"]),this.canSupportSpecificationExtensions=!0}ObjectElement(s){const o=em.prototype.ObjectElement.call(this,s);return ku(this.element.contentProp)&&this.element.contentProp.filter(Km).forEach(((s,o)=>{s.setMetaProperty("media-type",serializers_value(o))})),o}}const yg=ParameterVisitor;class SchemaVisitor_SchemaVisitor extends(Mixin(wm,Ff)){constructor(s){super(s),this.alternator=[{predicate:isReferenceLikeElement,specPath:["document","objects","Reference"]},{predicate:es_T,specPath:["document","objects","Schema"]}]}ObjectElement(s){const o=wm.prototype.enter.call(this,s);return Bm(this.element)&&this.element.setMetaProperty("referenced-element","schema"),o}}const _g=SchemaVisitor_SchemaVisitor;class HeaderVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Yp,this.specPath=lc(["document","objects","Header"]),this.canSupportSpecificationExtensions=!0}}const xg=HeaderVisitor;class header_SchemaVisitor_SchemaVisitor extends(Mixin(wm,Ff)){constructor(s){super(s),this.alternator=[{predicate:isReferenceLikeElement,specPath:["document","objects","Reference"]},{predicate:es_T,specPath:["document","objects","Schema"]}]}ObjectElement(s){const o=wm.prototype.enter.call(this,s);return Bm(this.element)&&this.element.setMetaProperty("referenced-element","schema"),o}}const kg=header_SchemaVisitor_SchemaVisitor;class HeaderExamples extends du.Sh{static primaryClass="header-examples";constructor(s,o,i){super(s,o,i),this.classes.push(HeaderExamples.primaryClass),this.classes.push("examples")}}const qg=HeaderExamples;const Ug=class header_ExamplesVisitor_ExamplesVisitor extends Qm{constructor(s){super(s),this.element=new qg}};class ContentVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new du.Sh,this.element.classes.push("content"),this.specPath=lc(["document","objects","MediaType"])}}const Vg=ContentVisitor;class HeaderContent extends du.Sh{static primaryClass="header-content";constructor(s,o,i){super(s,o,i),this.classes.push(HeaderContent.primaryClass),this.classes.push("content")}}const zg=HeaderContent;const Wg=class ContentVisitor_ContentVisitor extends Vg{constructor(s){super(s),this.element=new zg}};class schema_SchemaVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Of,this.specPath=lc(["document","objects","Schema"]),this.canSupportSpecificationExtensions=!0}}const Kg=schema_SchemaVisitor,Yg=Sf.visitors.document.objects.JSONSchema.fixedFields.allOf;const Xg=class AllOfVisitor_AllOfVisitor extends Yg{ArrayElement(s){const o=Yg.prototype.ArrayElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","schema")})),o}},Zg=Sf.visitors.document.objects.JSONSchema.fixedFields.anyOf;const ey=class AnyOfVisitor_AnyOfVisitor extends Zg{ArrayElement(s){const o=Zg.prototype.ArrayElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","schema")})),o}},ty=Sf.visitors.document.objects.JSONSchema.fixedFields.oneOf;const ry=class OneOfVisitor_OneOfVisitor extends ty{ArrayElement(s){const o=ty.prototype.ArrayElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","schema")})),o}},ny=Sf.visitors.document.objects.JSONSchema.fixedFields.items;const sy=class ItemsVisitor_ItemsVisitor extends ny{ObjectElement(s){const o=ny.prototype.ObjectElement.call(this,s);return Bm(this.element)&&this.element.setMetaProperty("referenced-element","schema"),o}ArrayElement(s){return this.enter(s)}},oy=Sf.visitors.document.objects.JSONSchema.fixedFields.properties;const iy=class PropertiesVisitor_PropertiesVisitor extends oy{ObjectElement(s){const o=oy.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","schema")})),o}},ay=Sf.visitors.document.objects.JSONSchema.fixedFields.type;const cy=class TypeVisitor_TypeVisitor extends ay{ArrayElement(s){return this.enter(s)}},ly=Sf.visitors.JSONSchemaOrJSONReferenceVisitor;const uy=class SchemaOrReferenceVisitor_SchemaOrReferenceVisitor extends ly{ObjectElement(s){const o=ly.prototype.enter.call(this,s);return Bm(this.element)&&this.element.setMetaProperty("referenced-element","schema"),o}};class DiscriminatorVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Jp,this.specPath=lc(["document","objects","Discriminator"]),this.canSupportSpecificationExtensions=!1}}const py=DiscriminatorVisitor;class DiscriminatorMapping extends du.Sh{static primaryClass="discriminator-mapping";constructor(s,o,i){super(s,o,i),this.classes.push(DiscriminatorMapping.primaryClass)}}const hy=DiscriminatorMapping;class MappingVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new hy,this.specPath=lc(["value"])}}const dy=MappingVisitor;class XmlVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Rf,this.specPath=lc(["document","objects","XML"]),this.canSupportSpecificationExtensions=!0}}const fy=XmlVisitor;class ParameterExamples extends du.Sh{static primaryClass="parameter-examples";constructor(s,o,i){super(s,o,i),this.classes.push(ParameterExamples.primaryClass),this.classes.push("examples")}}const my=ParameterExamples;const gy=class parameter_ExamplesVisitor_ExamplesVisitor extends Qm{constructor(s){super(s),this.element=new my}};class ParameterContent extends du.Sh{static primaryClass="parameter-content";constructor(s,o,i){super(s,o,i),this.classes.push(ParameterContent.primaryClass),this.classes.push("content")}}const yy=ParameterContent;const vy=class parameter_ContentVisitor_ContentVisitor extends Vg{constructor(s){super(s),this.element=new yy}};class ComponentsSchemas extends du.Sh{static primaryClass="components-schemas";constructor(s,o,i){super(s,o,i),this.classes.push(ComponentsSchemas.primaryClass)}}const by=ComponentsSchemas;class SchemasVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new by,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","Schema"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","schema")})),o}}const Sy=SchemasVisitor;class ComponentsResponses extends du.Sh{static primaryClass="components-responses";constructor(s,o,i){super(s,o,i),this.classes.push(ComponentsResponses.primaryClass)}}const _y=ComponentsResponses;class ResponsesVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new _y,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","Response"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","response")})),this.element.filter(qm).forEach(((s,o)=>{s.setMetaProperty("http-status-code",serializers_value(o))})),o}}const Ey=ResponsesVisitor;class ComponentsParameters extends du.Sh{static primaryClass="components-parameters";constructor(s,o,i){super(s,o,i),this.classes.push(ComponentsParameters.primaryClass),this.classes.push("parameters")}}const wy=ComponentsParameters;class ParametersVisitor_ParametersVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new wy,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","Parameter"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","parameter")})),o}}const xy=ParametersVisitor_ParametersVisitor;class ComponentsExamples extends du.Sh{static primaryClass="components-examples";constructor(s,o,i){super(s,o,i),this.classes.push(ComponentsExamples.primaryClass),this.classes.push("examples")}}const ky=ComponentsExamples;class components_ExamplesVisitor_ExamplesVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new ky,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","Example"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","example")})),o}}const Oy=components_ExamplesVisitor_ExamplesVisitor;class ComponentsRequestBodies extends du.Sh{static primaryClass="components-request-bodies";constructor(s,o,i){super(s,o,i),this.classes.push(ComponentsRequestBodies.primaryClass)}}const Ay=ComponentsRequestBodies;class RequestBodiesVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new Ay,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","RequestBody"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","requestBody")})),o}}const Cy=RequestBodiesVisitor;class ComponentsHeaders extends du.Sh{static primaryClass="components-headers";constructor(s,o,i){super(s,o,i),this.classes.push(ComponentsHeaders.primaryClass)}}const jy=ComponentsHeaders;class HeadersVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new jy,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","Header"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","header")})),this.element.filter(jm).forEach(((s,o)=>{s.setMetaProperty("header-name",serializers_value(o))})),o}}const Py=HeadersVisitor;class ComponentsSecuritySchemes extends du.Sh{static primaryClass="components-security-schemes";constructor(s,o,i){super(s,o,i),this.classes.push(ComponentsSecuritySchemes.primaryClass)}}const Iy=ComponentsSecuritySchemes;class SecuritySchemesVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new Iy,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","SecurityScheme"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","securityScheme")})),o}}const Ty=SecuritySchemesVisitor;class ComponentsLinks extends du.Sh{static primaryClass="components-links";constructor(s,o,i){super(s,o,i),this.classes.push(ComponentsLinks.primaryClass)}}const Ny=ComponentsLinks;class LinksVisitor_LinksVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new Ny,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","Link"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","link")})),o}}const My=LinksVisitor_LinksVisitor;class ComponentsCallbacks extends du.Sh{static primaryClass="components-callbacks";constructor(s,o,i){super(s,o,i),this.classes.push(ComponentsCallbacks.primaryClass)}}const Ry=ComponentsCallbacks;class CallbacksVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new Ry,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","Callback"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","callback")})),o}}const Dy=CallbacksVisitor;class ExampleVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Kp,this.specPath=lc(["document","objects","Example"]),this.canSupportSpecificationExtensions=!0}ObjectElement(s){const o=em.prototype.ObjectElement.call(this,s);return _u(this.element.externalValue)&&this.element.classes.push("reference-element"),o}}const Ly=ExampleVisitor;const Fy=class ExternalValueVisitor extends Ff{StringElement(s){const o=super.enter(s);return this.element.classes.push("reference-value"),o}};class ExternalDocumentationVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Gp,this.specPath=lc(["document","objects","ExternalDocumentation"]),this.canSupportSpecificationExtensions=!0}}const By=ExternalDocumentationVisitor;class encoding_EncodingVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Hp,this.specPath=lc(["document","objects","Encoding"]),this.canSupportSpecificationExtensions=!0}ObjectElement(s){const o=em.prototype.ObjectElement.call(this,s);return ku(this.element.headers)&&this.element.headers.filter(jm).forEach(((s,o)=>{s.setMetaProperty("header-name",serializers_value(o))})),o}}const $y=encoding_EncodingVisitor;class EncodingHeaders extends du.Sh{static primaryClass="encoding-headers";constructor(s,o,i){super(s,o,i),this.classes.push(EncodingHeaders.primaryClass)}}const qy=EncodingHeaders;class HeadersVisitor_HeadersVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new qy,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","Header"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","header")})),this.element.forEach(((s,o)=>{if(!jm(s))return;const i=serializers_value(o);s.setMetaProperty("headerName",i)})),o}}const Uy=HeadersVisitor_HeadersVisitor;class PathsVisitor extends(Mixin(pm,Ff)){constructor(s){super(s),this.element=new Oh,this.specPath=lc(["document","objects","PathItem"]),this.canSupportSpecificationExtensions=!0,this.fieldPatternPredicate=es_T}ObjectElement(s){const o=pm.prototype.ObjectElement.call(this,s);return this.element.filter(Lm).forEach(((s,o)=>{o.classes.push("openapi-path-template"),o.classes.push("path-template"),s.setMetaProperty("path",cloneDeep(o))})),o}}const Vy=PathsVisitor;class RequestBodyVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Ph,this.specPath=lc(["document","objects","RequestBody"])}ObjectElement(s){const o=em.prototype.ObjectElement.call(this,s);return ku(this.element.contentProp)&&this.element.contentProp.filter(Km).forEach(((s,o)=>{s.setMetaProperty("media-type",serializers_value(o))})),o}}const zy=RequestBodyVisitor;class RequestBodyContent extends du.Sh{static primaryClass="request-body-content";constructor(s,o,i){super(s,o,i),this.classes.push(RequestBodyContent.primaryClass),this.classes.push("content")}}const Wy=RequestBodyContent;const Jy=class request_body_ContentVisitor_ContentVisitor extends Vg{constructor(s){super(s),this.element=new Wy}};class CallbackVisitor extends(Mixin(pm,Ff)){constructor(s){super(s),this.element=new Vp,this.specPath=lc(["document","objects","PathItem"]),this.canSupportSpecificationExtensions=!0,this.fieldPatternPredicate=s=>/{(?<expression>[^}]{1,2083})}/.test(String(s))}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Lm).forEach(((s,o)=>{s.setMetaProperty("runtime-expression",serializers_value(o))})),o}}const Hy=CallbackVisitor;class ResponseVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new Ih,this.specPath=lc(["document","objects","Response"])}ObjectElement(s){const o=em.prototype.ObjectElement.call(this,s);return ku(this.element.contentProp)&&this.element.contentProp.filter(Km).forEach(((s,o)=>{s.setMetaProperty("media-type",serializers_value(o))})),ku(this.element.headers)&&this.element.headers.filter(jm).forEach(((s,o)=>{s.setMetaProperty("header-name",serializers_value(o))})),o}}const Ky=ResponseVisitor;class ResponseHeaders extends du.Sh{static primaryClass="response-headers";constructor(s,o,i){super(s,o,i),this.classes.push(ResponseHeaders.primaryClass)}}const Gy=ResponseHeaders;class response_HeadersVisitor_HeadersVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new Gy,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","Header"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","header")})),this.element.forEach(((s,o)=>{if(!jm(s))return;const i=serializers_value(o);s.setMetaProperty("header-name",i)})),o}}const Yy=response_HeadersVisitor_HeadersVisitor;class ResponseContent extends du.Sh{static primaryClass="response-content";constructor(s,o,i){super(s,o,i),this.classes.push(ResponseContent.primaryClass),this.classes.push("content")}}const Xy=ResponseContent;const Qy=class response_ContentVisitor_ContentVisitor extends Vg{constructor(s){super(s),this.element=new Xy}};class ResponseLinks extends du.Sh{static primaryClass="response-links";constructor(s,o,i){super(s,o,i),this.classes.push(ResponseLinks.primaryClass)}}const Zy=ResponseLinks;class response_LinksVisitor_LinksVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new Zy,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","Link"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","link")})),o}}const ev=response_LinksVisitor_LinksVisitor;function _isNumber(s){return"[object Number]"===Object.prototype.toString.call(s)}var tv=_curry2((function range(s,o){if(!_isNumber(s)||!_isNumber(o))throw new TypeError("Both arguments to range must be numbers");for(var i=Array(s<o?o-s:0),a=s<0?o+Math.abs(s):o-s,u=0;u<a;)i[u]=u+s,u+=1;return i}));const rv=tv;function hasOrAdd(s,o,i){var a,u=typeof s;switch(u){case"string":case"number":return 0===s&&1/s==-1/0?!!i._items["-0"]||(o&&(i._items["-0"]=!0),!1):null!==i._nativeSet?o?(a=i._nativeSet.size,i._nativeSet.add(s),i._nativeSet.size===a):i._nativeSet.has(s):u in i._items?s in i._items[u]||(o&&(i._items[u][s]=!0),!1):(o&&(i._items[u]={},i._items[u][s]=!0),!1);case"boolean":if(u in i._items){var _=s?1:0;return!!i._items[u][_]||(o&&(i._items[u][_]=!0),!1)}return o&&(i._items[u]=s?[!1,!0]:[!0,!1]),!1;case"function":return null!==i._nativeSet?o?(a=i._nativeSet.size,i._nativeSet.add(s),i._nativeSet.size===a):i._nativeSet.has(s):u in i._items?!!_includes(s,i._items[u])||(o&&i._items[u].push(s),!1):(o&&(i._items[u]=[s]),!1);case"undefined":return!!i._items[u]||(o&&(i._items[u]=!0),!1);case"object":if(null===s)return!!i._items.null||(o&&(i._items.null=!0),!1);default:return(u=Object.prototype.toString.call(s))in i._items?!!_includes(s,i._items[u])||(o&&i._items[u].push(s),!1):(o&&(i._items[u]=[s]),!1)}}const nv=function(){function _Set(){this._nativeSet="function"==typeof Set?new Set:null,this._items={}}return _Set.prototype.add=function(s){return!hasOrAdd(s,!0,this)},_Set.prototype.has=function(s){return hasOrAdd(s,!1,this)},_Set}();var sv=_curry2((function difference(s,o){for(var i=[],a=0,u=s.length,_=o.length,w=new nv,x=0;x<_;x+=1)w.add(o[x]);for(;a<u;)w.add(s[a])&&(i[i.length]=s[a]),a+=1;return i}));const ov=sv;class MixedFieldsVisitor extends(Mixin(em,pm)){specPathFixedFields;specPathPatternedFields;constructor({specPathFixedFields:s,specPathPatternedFields:o,...i}){super({...i}),this.specPathFixedFields=s,this.specPathPatternedFields=o}ObjectElement(s){const{specPath:o,ignoredFields:i}=this;try{this.specPath=this.specPathFixedFields;const o=this.retrieveFixedFields(this.specPath(s));this.ignoredFields=[...i,...ov(s.keys(),o)],em.prototype.ObjectElement.call(this,s),this.specPath=this.specPathPatternedFields,this.ignoredFields=o,pm.prototype.ObjectElement.call(this,s)}catch(s){throw this.specPath=o,s}return Nu}}const iv=MixedFieldsVisitor;class responses_ResponsesVisitor extends(Mixin(iv,Ff)){constructor(s){super(s),this.element=new Rh,this.specPathFixedFields=lc(["document","objects","Responses"]),this.canSupportSpecificationExtensions=!0,this.specPathPatternedFields=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","Response"],this.fieldPatternPredicate=s=>new RegExp(`^(1XX|2XX|3XX|4XX|5XX|${rv(100,600).join("|")})$`).test(String(s))}ObjectElement(s){const o=iv.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","response")})),this.element.filter(qm).forEach(((s,o)=>{const i=cloneDeep(o);this.fieldPatternPredicate(serializers_value(i))&&s.setMetaProperty("http-status-code",i)})),o}}const av=responses_ResponsesVisitor;class DefaultVisitor extends(Mixin(wm,Ff)){constructor(s){super(s),this.alternator=[{predicate:isReferenceLikeElement,specPath:["document","objects","Reference"]},{predicate:es_T,specPath:["document","objects","Response"]}]}ObjectElement(s){const o=wm.prototype.enter.call(this,s);return Bm(this.element)?this.element.setMetaProperty("referenced-element","response"):qm(this.element)&&this.element.setMetaProperty("http-status-code","default"),o}}const cv=DefaultVisitor;class OperationVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new vh,this.specPath=lc(["document","objects","Operation"])}}const lv=OperationVisitor;class OperationTags extends du.wE{static primaryClass="operation-tags";constructor(s,o,i){super(s,o,i),this.classes.push(OperationTags.primaryClass)}}const uv=OperationTags;const pv=class TagsVisitor extends Ff{constructor(s){super(s),this.element=new uv}ArrayElement(s){return this.element=this.element.concat(cloneDeep(s)),Nu}};class OperationParameters extends du.wE{static primaryClass="operation-parameters";constructor(s,o,i){super(s,o,i),this.classes.push(OperationParameters.primaryClass),this.classes.push("parameters")}}const hv=OperationParameters;class open_api_3_0_ParametersVisitor_ParametersVisitor extends(Mixin(Vf,Ff)){constructor(s){super(s),this.element=new du.wE,this.element.classes.push("parameters")}ArrayElement(s){return s.forEach((s=>{const o=isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","Parameter"],i=this.toRefractedElement(o,s);Bm(i)&&i.setMetaProperty("referenced-element","parameter"),this.element.push(i)})),this.copyMetaAndAttributes(s,this.element),Nu}}const dv=open_api_3_0_ParametersVisitor_ParametersVisitor;const fv=class operation_ParametersVisitor_ParametersVisitor extends dv{constructor(s){super(s),this.element=new hv}};const mv=class RequestBodyVisitor_RequestBodyVisitor extends wm{constructor(s){super(s),this.alternator=[{predicate:isReferenceLikeElement,specPath:["document","objects","Reference"]},{predicate:es_T,specPath:["document","objects","RequestBody"]}]}ObjectElement(s){const o=wm.prototype.enter.call(this,s);return Bm(this.element)&&this.element.setMetaProperty("referenced-element","requestBody"),o}};class OperationCallbacks extends du.Sh{static primaryClass="operation-callbacks";constructor(s,o,i){super(s,o,i),this.classes.push(OperationCallbacks.primaryClass)}}const gv=OperationCallbacks;class CallbacksVisitor_CallbacksVisitor extends(Mixin(hm,Ff)){specPath;constructor(s){super(s),this.element=new gv,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","Callback"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Bm).forEach((s=>{s.setMetaProperty("referenced-element","callback")})),o}}const yv=CallbacksVisitor_CallbacksVisitor;class OperationSecurity extends du.wE{static primaryClass="operation-security";constructor(s,o,i){super(s,o,i),this.classes.push(OperationSecurity.primaryClass),this.classes.push("security")}}const vv=OperationSecurity;class SecurityVisitor_SecurityVisitor extends(Mixin(Vf,Ff)){constructor(s){super(s),this.element=new vv}ArrayElement(s){return s.forEach((s=>{const o=ku(s)?["document","objects","SecurityRequirement"]:["value"],i=this.toRefractedElement(o,s);this.element.push(i)})),this.copyMetaAndAttributes(s,this.element),Nu}}const bv=SecurityVisitor_SecurityVisitor;class OperationServers extends du.wE{static primaryClass="operation-servers";constructor(s,o,i){super(s,o,i),this.classes.push(OperationServers.primaryClass),this.classes.push("servers")}}const Sv=OperationServers;const _v=class ServersVisitor_ServersVisitor extends vm{constructor(s){super(s),this.element=new Sv}};class PathItemVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new wh,this.specPath=lc(["document","objects","PathItem"])}ObjectElement(s){const o=em.prototype.ObjectElement.call(this,s);return this.element.filter(Rm).forEach(((s,o)=>{const i=cloneDeep(o);i.content=serializers_value(i).toUpperCase(),s.setMetaProperty("http-method",i)})),_u(this.element.$ref)&&this.element.classes.push("reference-element"),o}}const Ev=PathItemVisitor;const wv=class path_item_$RefVisitor_$RefVisitor extends Ff{StringElement(s){const o=super.enter(s);return this.element.classes.push("reference-value"),o}};class PathItemServers extends du.wE{static primaryClass="path-item-servers";constructor(s,o,i){super(s,o,i),this.classes.push(PathItemServers.primaryClass),this.classes.push("servers")}}const xv=PathItemServers;const kv=class path_item_ServersVisitor_ServersVisitor extends vm{constructor(s){super(s),this.element=new xv}};class PathItemParameters extends du.wE{static primaryClass="path-item-parameters";constructor(s,o,i){super(s,o,i),this.classes.push(PathItemParameters.primaryClass),this.classes.push("parameters")}}const Ov=PathItemParameters;const Av=class path_item_ParametersVisitor_ParametersVisitor extends dv{constructor(s){super(s),this.element=new Ov}};class SecuritySchemeVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new jf,this.specPath=lc(["document","objects","SecurityScheme"]),this.canSupportSpecificationExtensions=!0}}const Cv=SecuritySchemeVisitor;class OAuthFlowsVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new uh,this.specPath=lc(["document","objects","OAuthFlows"]),this.canSupportSpecificationExtensions=!0}}const jv=OAuthFlowsVisitor;class OAuthFlowVisitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new rh,this.specPath=lc(["document","objects","OAuthFlow"]),this.canSupportSpecificationExtensions=!0}}const Pv=OAuthFlowVisitor;class OAuthFlowScopes extends du.Sh{static primaryClass="oauth-flow-scopes";constructor(s,o,i){super(s,o,i),this.classes.push(OAuthFlowScopes.primaryClass)}}const Iv=OAuthFlowScopes;class ScopesVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new Iv,this.specPath=lc(["value"])}}const Tv=ScopesVisitor;class Tags extends du.wE{static primaryClass="tags";constructor(s,o,i){super(s,o,i),this.classes.push(Tags.primaryClass)}}const Nv=Tags;class TagsVisitor_TagsVisitor extends(Mixin(Vf,Ff)){constructor(s){super(s),this.element=new Nv}ArrayElement(s){return s.forEach((s=>{const o=Qf(s)?["document","objects","Tag"]:["value"],i=this.toRefractedElement(o,s);this.element.push(i)})),this.copyMetaAndAttributes(s,this.element),Nu}}const Mv=TagsVisitor_TagsVisitor,{fixedFields:Rv}=Sf.visitors.document.objects.JSONSchema,Dv={visitors:{value:Ff,document:{objects:{OpenApi:{$visitor:tm,fixedFields:{openapi:rm,info:{$ref:"#/visitors/document/objects/Info"},servers:vm,paths:{$ref:"#/visitors/document/objects/Paths"},components:{$ref:"#/visitors/document/objects/Components"},security:lg,tags:Mv,externalDocs:{$ref:"#/visitors/document/objects/ExternalDocumentation"}}},Info:{$visitor:sm,fixedFields:{title:{$ref:"#/visitors/value"},description:{$ref:"#/visitors/value"},termsOfService:{$ref:"#/visitors/value"},contact:{$ref:"#/visitors/document/objects/Contact"},license:{$ref:"#/visitors/document/objects/License"},version:om}},Contact:{$visitor:im,fixedFields:{name:{$ref:"#/visitors/value"},url:{$ref:"#/visitors/value"},email:{$ref:"#/visitors/value"}}},License:{$visitor:am,fixedFields:{name:{$ref:"#/visitors/value"},url:{$ref:"#/visitors/value"}}},Server:{$visitor:mm,fixedFields:{url:gm,description:{$ref:"#/visitors/value"},variables:_m}},ServerVariable:{$visitor:bm,fixedFields:{enum:{$ref:"#/visitors/value"},default:{$ref:"#/visitors/value"},description:{$ref:"#/visitors/value"}}},Components:{$visitor:pg,fixedFields:{schemas:Sy,responses:Ey,parameters:xy,examples:Oy,requestBodies:Cy,headers:Py,securitySchemes:Ty,links:My,callbacks:Dy}},Paths:{$visitor:Vy},PathItem:{$visitor:Ev,fixedFields:{$ref:wv,summary:{$ref:"#/visitors/value"},description:{$ref:"#/visitors/value"},get:{$ref:"#/visitors/document/objects/Operation"},put:{$ref:"#/visitors/document/objects/Operation"},post:{$ref:"#/visitors/document/objects/Operation"},delete:{$ref:"#/visitors/document/objects/Operation"},options:{$ref:"#/visitors/document/objects/Operation"},head:{$ref:"#/visitors/document/objects/Operation"},patch:{$ref:"#/visitors/document/objects/Operation"},trace:{$ref:"#/visitors/document/objects/Operation"},servers:kv,parameters:Av}},Operation:{$visitor:lv,fixedFields:{tags:pv,summary:{$ref:"#/visitors/value"},description:{$ref:"#/visitors/value"},externalDocs:{$ref:"#/visitors/document/objects/ExternalDocumentation"},operationId:{$ref:"#/visitors/value"},parameters:fv,requestBody:mv,responses:{$ref:"#/visitors/document/objects/Responses"},callbacks:yv,deprecated:{$ref:"#/visitors/value"},security:bv,servers:_v}},ExternalDocumentation:{$visitor:By,fixedFields:{description:{$ref:"#/visitors/value"},url:{$ref:"#/visitors/value"}}},Parameter:{$visitor:yg,fixedFields:{name:{$ref:"#/visitors/value"},in:{$ref:"#/visitors/value"},description:{$ref:"#/visitors/value"},required:{$ref:"#/visitors/value"},deprecated:{$ref:"#/visitors/value"},allowEmptyValue:{$ref:"#/visitors/value"},style:{$ref:"#/visitors/value"},explode:{$ref:"#/visitors/value"},allowReserved:{$ref:"#/visitors/value"},schema:_g,example:{$ref:"#/visitors/value"},examples:gy,content:vy}},RequestBody:{$visitor:zy,fixedFields:{description:{$ref:"#/visitors/value"},content:Jy,required:{$ref:"#/visitors/value"}}},MediaType:{$visitor:Em,fixedFields:{schema:Xm,example:{$ref:"#/visitors/value"},examples:eg,encoding:ng}},Encoding:{$visitor:$y,fixedFields:{contentType:{$ref:"#/visitors/value"},headers:Uy,style:{$ref:"#/visitors/value"},explode:{$ref:"#/visitors/value"},allowReserved:{$ref:"#/visitors/value"}}},Responses:{$visitor:av,fixedFields:{default:cv}},Response:{$visitor:Ky,fixedFields:{description:{$ref:"#/visitors/value"},headers:Yy,content:Qy,links:ev}},Callback:{$visitor:Hy},Example:{$visitor:Ly,fixedFields:{summary:{$ref:"#/visitors/value"},description:{$ref:"#/visitors/value"},value:{$ref:"#/visitors/value"},externalValue:Fy}},Link:{$visitor:cm,fixedFields:{operationRef:lm,operationId:um,parameters:fm,requestBody:{$ref:"#/visitors/value"},description:{$ref:"#/visitors/value"},server:{$ref:"#/visitors/document/objects/Server"}}},Header:{$visitor:xg,fixedFields:{description:{$ref:"#/visitors/value"},required:{$ref:"#/visitors/value"},deprecated:{$ref:"#/visitors/value"},allowEmptyValue:{$ref:"#/visitors/value"},style:{$ref:"#/visitors/value"},explode:{$ref:"#/visitors/value"},allowReserved:{$ref:"#/visitors/value"},schema:kg,example:{$ref:"#/visitors/value"},examples:Ug,content:Wg}},Tag:{$visitor:fg,fixedFields:{name:{$ref:"#/visitors/value"},description:{$ref:"#/visitors/value"},externalDocs:{$ref:"#/visitors/document/objects/ExternalDocumentation"}}},Reference:{$visitor:mg,fixedFields:{$ref:gg}},JSONSchema:{$ref:"#/visitors/document/objects/Schema"},JSONReference:{$ref:"#/visitors/document/objects/Reference"},Schema:{$visitor:Kg,fixedFields:{title:Rv.title,multipleOf:Rv.multipleOf,maximum:Rv.maximum,exclusiveMaximum:Rv.exclusiveMaximum,minimum:Rv.minimum,exclusiveMinimum:Rv.exclusiveMinimum,maxLength:Rv.maxLength,minLength:Rv.minLength,pattern:Rv.pattern,maxItems:Rv.maxItems,minItems:Rv.minItems,uniqueItems:Rv.uniqueItems,maxProperties:Rv.maxProperties,minProperties:Rv.minProperties,required:Rv.required,enum:Rv.enum,type:cy,allOf:Xg,anyOf:ey,oneOf:ry,not:uy,items:sy,properties:iy,additionalProperties:uy,description:Rv.description,format:Rv.format,default:Rv.default,nullable:{$ref:"#/visitors/value"},discriminator:{$ref:"#/visitors/document/objects/Discriminator"},writeOnly:{$ref:"#/visitors/value"},xml:{$ref:"#/visitors/document/objects/XML"},externalDocs:{$ref:"#/visitors/document/objects/ExternalDocumentation"},example:{$ref:"#/visitors/value"},deprecated:{$ref:"#/visitors/value"}}},Discriminator:{$visitor:py,fixedFields:{propertyName:{$ref:"#/visitors/value"},mapping:dy}},XML:{$visitor:fy,fixedFields:{name:{$ref:"#/visitors/value"},namespace:{$ref:"#/visitors/value"},prefix:{$ref:"#/visitors/value"},attribute:{$ref:"#/visitors/value"},wrapped:{$ref:"#/visitors/value"}}},SecurityScheme:{$visitor:Cv,fixedFields:{type:{$ref:"#/visitors/value"},description:{$ref:"#/visitors/value"},name:{$ref:"#/visitors/value"},in:{$ref:"#/visitors/value"},scheme:{$ref:"#/visitors/value"},bearerFormat:{$ref:"#/visitors/value"},flows:{$ref:"#/visitors/document/objects/OAuthFlows"},openIdConnectUrl:{$ref:"#/visitors/value"}}},OAuthFlows:{$visitor:jv,fixedFields:{implicit:{$ref:"#/visitors/document/objects/OAuthFlow"},password:{$ref:"#/visitors/document/objects/OAuthFlow"},clientCredentials:{$ref:"#/visitors/document/objects/OAuthFlow"},authorizationCode:{$ref:"#/visitors/document/objects/OAuthFlow"}}},OAuthFlow:{$visitor:Pv,fixedFields:{authorizationUrl:{$ref:"#/visitors/value"},tokenUrl:{$ref:"#/visitors/value"},refreshUrl:{$ref:"#/visitors/value"},scopes:Tv}},SecurityRequirement:{$visitor:sg}},extension:{$visitor:nm}}}},src_traversal_visitor_getNodeType=s=>{if(Su(s))return`${s.element.charAt(0).toUpperCase()+s.element.slice(1)}Element`},Lv={CallbackElement:["content"],ComponentsElement:["content"],ContactElement:["content"],DiscriminatorElement:["content"],Encoding:["content"],Example:["content"],ExternalDocumentationElement:["content"],HeaderElement:["content"],InfoElement:["content"],LicenseElement:["content"],MediaTypeElement:["content"],OAuthFlowElement:["content"],OAuthFlowsElement:["content"],OpenApi3_0Element:["content"],OperationElement:["content"],ParameterElement:["content"],PathItemElement:["content"],PathsElement:["content"],ReferenceElement:["content"],RequestBodyElement:["content"],ResponseElement:["content"],ResponsesElement:["content"],SchemaElement:["content"],SecurityRequirementElement:["content"],SecuritySchemeElement:["content"],ServerElement:["content"],ServerVariableElement:["content"],TagElement:["content"],...Gu},Fv={namespace:s=>{const{base:o}=s;return o.register("callback",Vp),o.register("components",zp),o.register("contact",Wp),o.register("discriminator",Jp),o.register("encoding",Hp),o.register("example",Kp),o.register("externalDocumentation",Gp),o.register("header",Yp),o.register("info",Xp),o.register("license",Qp),o.register("link",Zp),o.register("mediaType",th),o.register("oAuthFlow",rh),o.register("oAuthFlows",uh),o.register("openapi",dh),o.register("openApi3_0",fh),o.register("operation",vh),o.register("parameter",_h),o.register("pathItem",wh),o.register("paths",Oh),o.register("reference",jh),o.register("requestBody",Ph),o.register("response",Ih),o.register("responses",Rh),o.register("schema",Of),o.register("securityRequirement",Cf),o.register("securityScheme",jf),o.register("server",Pf),o.register("serverVariable",Tf),o.register("tag",Nf),o.register("xml",Rf),o}},Bv=Fv,src_refractor_toolbox=()=>{const s=createNamespace(Bv);return{predicates:{...ce,isElement:Su,isStringElement:_u,isArrayElement:Ou,isObjectElement:ku,isMemberElement:Au,includesClasses,hasElementSourceMap},namespace:s}},src_refractor_refract=(s,{specPath:o=["visitors","document","objects","OpenApi","$visitor"],plugins:i=[]}={})=>{const a=(0,du.e)(s),u=dereference(Dv),_=new(zu(o,u))({specObj:u});return visitor_visit(a,_),dispatchPluginsSync(_.element,i,{toolboxCreator:src_refractor_toolbox,visitorOptions:{keyMap:Lv,nodeTypeGetter:src_traversal_visitor_getNodeType}})},src_refractor_createRefractor=s=>(o,i={})=>src_refractor_refract(o,{specPath:s,...i});Vp.refract=src_refractor_createRefractor(["visitors","document","objects","Callback","$visitor"]),zp.refract=src_refractor_createRefractor(["visitors","document","objects","Components","$visitor"]),Wp.refract=src_refractor_createRefractor(["visitors","document","objects","Contact","$visitor"]),Kp.refract=src_refractor_createRefractor(["visitors","document","objects","Example","$visitor"]),Jp.refract=src_refractor_createRefractor(["visitors","document","objects","Discriminator","$visitor"]),Hp.refract=src_refractor_createRefractor(["visitors","document","objects","Encoding","$visitor"]),Gp.refract=src_refractor_createRefractor(["visitors","document","objects","ExternalDocumentation","$visitor"]),Yp.refract=src_refractor_createRefractor(["visitors","document","objects","Header","$visitor"]),Xp.refract=src_refractor_createRefractor(["visitors","document","objects","Info","$visitor"]),Qp.refract=src_refractor_createRefractor(["visitors","document","objects","License","$visitor"]),Zp.refract=src_refractor_createRefractor(["visitors","document","objects","Link","$visitor"]),th.refract=src_refractor_createRefractor(["visitors","document","objects","MediaType","$visitor"]),rh.refract=src_refractor_createRefractor(["visitors","document","objects","OAuthFlow","$visitor"]),uh.refract=src_refractor_createRefractor(["visitors","document","objects","OAuthFlows","$visitor"]),dh.refract=src_refractor_createRefractor(["visitors","document","objects","OpenApi","fixedFields","openapi"]),fh.refract=src_refractor_createRefractor(["visitors","document","objects","OpenApi","$visitor"]),vh.refract=src_refractor_createRefractor(["visitors","document","objects","Operation","$visitor"]),_h.refract=src_refractor_createRefractor(["visitors","document","objects","Parameter","$visitor"]),wh.refract=src_refractor_createRefractor(["visitors","document","objects","PathItem","$visitor"]),Oh.refract=src_refractor_createRefractor(["visitors","document","objects","Paths","$visitor"]),jh.refract=src_refractor_createRefractor(["visitors","document","objects","Reference","$visitor"]),Ph.refract=src_refractor_createRefractor(["visitors","document","objects","RequestBody","$visitor"]),Ih.refract=src_refractor_createRefractor(["visitors","document","objects","Response","$visitor"]),Rh.refract=src_refractor_createRefractor(["visitors","document","objects","Responses","$visitor"]),Of.refract=src_refractor_createRefractor(["visitors","document","objects","Schema","$visitor"]),Cf.refract=src_refractor_createRefractor(["visitors","document","objects","SecurityRequirement","$visitor"]),jf.refract=src_refractor_createRefractor(["visitors","document","objects","SecurityScheme","$visitor"]),Pf.refract=src_refractor_createRefractor(["visitors","document","objects","Server","$visitor"]),Tf.refract=src_refractor_createRefractor(["visitors","document","objects","ServerVariable","$visitor"]),Nf.refract=src_refractor_createRefractor(["visitors","document","objects","Tag","$visitor"]),Rf.refract=src_refractor_createRefractor(["visitors","document","objects","XML","$visitor"]);const $v=class Callback_Callback extends Vp{};const qv=class Components_Components extends zp{get pathItems(){return this.get("pathItems")}set pathItems(s){this.set("pathItems",s)}};const Uv=class Contact_Contact extends Wp{};const Vv=class Discriminator_Discriminator extends Jp{};const zv=class Encoding_Encoding extends Hp{};const Wv=class Example_Example extends Kp{};const Jv=class ExternalDocumentation_ExternalDocumentation extends Gp{};const Hv=class Header_Header extends Yp{get schema(){return this.get("schema")}set schema(s){this.set("schema",s)}};const Kv=class Info_Info extends Xp{get license(){return this.get("license")}set license(s){this.set("license",s)}get summary(){return this.get("summary")}set summary(s){this.set("summary",s)}};class JsonSchemaDialect extends du.Om{static default=new JsonSchemaDialect("https://spec.openapis.org/oas/3.1/dialect/base");constructor(s,o,i){super(s,o,i),this.element="jsonSchemaDialect"}}const Gv=JsonSchemaDialect;const Yv=class License_License extends Qp{get identifier(){return this.get("identifier")}set identifier(s){this.set("identifier",s)}};const Xv=class Link_Link extends Zp{};const Qv=class MediaType_MediaType extends th{get schema(){return this.get("schema")}set schema(s){this.set("schema",s)}};const Zv=class OAuthFlow_OAuthFlow extends rh{};const eb=class OAuthFlows_OAuthFlows extends uh{};const tb=class Openapi_Openapi extends dh{};class OpenApi3_1 extends du.Sh{constructor(s,o,i){super(s,o,i),this.element="openApi3_1",this.classes.push("api")}get openapi(){return this.get("openapi")}set openapi(s){this.set("openapi",s)}get info(){return this.get("info")}set info(s){this.set("info",s)}get jsonSchemaDialect(){return this.get("jsonSchemaDialect")}set jsonSchemaDialect(s){this.set("jsonSchemaDialect",s)}get servers(){return this.get("servers")}set servers(s){this.set("servers",s)}get paths(){return this.get("paths")}set paths(s){this.set("paths",s)}get components(){return this.get("components")}set components(s){this.set("components",s)}get security(){return this.get("security")}set security(s){this.set("security",s)}get tags(){return this.get("tags")}set tags(s){this.set("tags",s)}get externalDocs(){return this.get("externalDocs")}set externalDocs(s){this.set("externalDocs",s)}get webhooks(){return this.get("webhooks")}set webhooks(s){this.set("webhooks",s)}}const nb=OpenApi3_1;const pb=class Operation_Operation extends vh{get requestBody(){return this.get("requestBody")}set requestBody(s){this.set("requestBody",s)}};const mb=class Parameter_Parameter extends _h{get schema(){return this.get("schema")}set schema(s){this.set("schema",s)}};const yb=class PathItem_PathItem extends wh{get GET(){return this.get("get")}set GET(s){this.set("GET",s)}get PUT(){return this.get("put")}set PUT(s){this.set("PUT",s)}get POST(){return this.get("post")}set POST(s){this.set("POST",s)}get DELETE(){return this.get("delete")}set DELETE(s){this.set("DELETE",s)}get OPTIONS(){return this.get("options")}set OPTIONS(s){this.set("OPTIONS",s)}get HEAD(){return this.get("head")}set HEAD(s){this.set("HEAD",s)}get PATCH(){return this.get("patch")}set PATCH(s){this.set("PATCH",s)}get TRACE(){return this.get("trace")}set TRACE(s){this.set("TRACE",s)}};const Sb=class Paths_Paths extends Oh{};class Reference_Reference extends jh{}Object.defineProperty(Reference_Reference.prototype,"description",{get(){return this.get("description")},set(s){this.set("description",s)},enumerable:!0}),Object.defineProperty(Reference_Reference.prototype,"summary",{get(){return this.get("summary")},set(s){this.set("summary",s)},enumerable:!0});const _b=Reference_Reference;const wb=class RequestBody_RequestBody extends Ph{};const Ob=class elements_Response_Response extends Ih{};const Ab=class Responses_Responses extends Rh{};const Pb=class JSONSchema_JSONSchema extends Lh{constructor(s,o,i){super(s,o,i),this.element="JSONSchemaDraft6"}get idProp(){throw new Dh("id keyword from Core vocabulary has been renamed to $id.")}set idProp(s){throw new Dh("id keyword from Core vocabulary has been renamed to $id.")}get $id(){return this.get("$id")}set $id(s){this.set("$id",s)}get exclusiveMaximum(){return this.get("exclusiveMaximum")}set exclusiveMaximum(s){this.set("exclusiveMaximum",s)}get exclusiveMinimum(){return this.get("exclusiveMinimum")}set exclusiveMinimum(s){this.set("exclusiveMinimum",s)}get containsProp(){return this.get("contains")}set containsProp(s){this.set("contains",s)}get items(){return this.get("items")}set items(s){this.set("items",s)}get propertyNames(){return this.get("propertyNames")}set propertyNames(s){this.set("propertyNames",s)}get const(){return this.get("const")}set const(s){this.set("const",s)}get not(){return this.get("not")}set not(s){this.set("not",s)}get examples(){return this.get("examples")}set examples(s){this.set("examples",s)}};const Ib=class LinkDescription_LinkDescription extends Hh{get hrefSchema(){return this.get("hrefSchema")}set hrefSchema(s){this.set("hrefSchema",s)}get targetSchema(){return this.get("targetSchema")}set targetSchema(s){this.set("targetSchema",s)}get schema(){throw new Dh("schema keyword from Hyper-Schema vocabulary has been renamed to submissionSchema.")}set schema(s){throw new Dh("schema keyword from Hyper-Schema vocabulary has been renamed to submissionSchema.")}get submissionSchema(){return this.get("submissionSchema")}set submissionSchema(s){this.set("submissionSchema",s)}get method(){throw new Dh("method keyword from Hyper-Schema vocabulary has been removed.")}set method(s){throw new Dh("method keyword from Hyper-Schema vocabulary has been removed.")}get encType(){throw new Dh("encType keyword from Hyper-Schema vocabulary has been renamed to submissionEncType.")}set encType(s){throw new Dh("encType keyword from Hyper-Schema vocabulary has been renamed to submissionEncType.")}get submissionEncType(){return this.get("submissionEncType")}set submissionEncType(s){this.set("submissionEncType",s)}};var Mb=_curry3((function assocPath(s,o,i){if(0===s.length)return o;var a=s[0];if(s.length>1){var u=!Fu(i)&&_has(a,i)&&"object"==typeof i[a]?i[a]:ra(s[1])?[]:{};o=assocPath(Array.prototype.slice.call(s,1),o,u)}return function _assoc(s,o,i){if(ra(s)&&Yo(i)){var a=[].concat(i);return a[s]=o,a}var u={};for(var _ in i)u[_]=i[_];return u[s]=o,u}(a,o,i)}));const Rb=Mb;var Lb=_curry3((function remove(s,o,i){var a=Array.prototype.slice.call(i,0);return a.splice(s,o),a}));const qb=Lb;var zb=_curry3((function assoc(s,o,i){return Rb([s],o,i)}));const Qb=zb;var eS=_curry2((function dissocPath(s,o){if(null==o)return o;switch(s.length){case 0:return o;case 1:return function _dissoc(s,o){if(null==o)return o;if(ra(s)&&Yo(o))return qb(s,1,o);var i={};for(var a in o)i[a]=o[a];return delete i[s],i}(s[0],o);default:var i=s[0],a=Array.prototype.slice.call(s,1);return null==o[i]?function _shallowCloneObject(s,o){if(ra(s)&&Yo(o))return[].concat(o);var i={};for(var a in o)i[a]=o[a];return i}(i,o):Qb(i,dissocPath(a,o[i]),o)}}));const tS=eS;const rS=class json_schema_JSONSchemaVisitor extends Td{constructor(s){super(s),this.element=new Pb}get defaultDialectIdentifier(){return"http://json-schema.org/draft-06/schema#"}BooleanElement(s){const o=this.enter(s);return this.element.classes.push("boolean-json-schema"),o}handleSchemaIdentifier(s,o="$id"){return super.handleSchemaIdentifier(s,o)}};const nS=class json_schema_ItemsVisitor_ItemsVisitor extends Nd{BooleanElement(s){return this.element=this.toRefractedElement(["document","objects","JSONSchema"],s),Nu}};const sS=class json_schema_ExamplesVisitor_ExamplesVisitor extends td{ArrayElement(s){const o=this.enter(s);return this.element.classes.push("json-schema-examples"),o}};const oS=class link_description_LinkDescriptionVisitor extends bf{constructor(s){super(s),this.element=new Ib}},iS=pipe(Rb(["visitors","document","objects","JSONSchema","$visitor"],rS),tS(["visitors","document","objects","JSONSchema","fixedFields","id"]),Rb(["visitors","document","objects","JSONSchema","fixedFields","$id"],Sf.visitors.value),Rb(["visitors","document","objects","JSONSchema","fixedFields","contains"],Sf.visitors.JSONSchemaOrJSONReferenceVisitor),Rb(["visitors","document","objects","JSONSchema","fixedFields","items"],nS),Rb(["visitors","document","objects","JSONSchema","fixedFields","propertyNames"],Sf.visitors.JSONSchemaOrJSONReferenceVisitor),Rb(["visitors","document","objects","JSONSchema","fixedFields","const"],Sf.visitors.value),Rb(["visitors","document","objects","JSONSchema","fixedFields","examples"],sS),Rb(["visitors","document","objects","LinkDescription","$visitor"],oS),Rb(["visitors","document","objects","LinkDescription","fixedFields","hrefSchema"],Sf.visitors.JSONSchemaOrJSONReferenceVisitor),tS(["visitors","document","objects","LinkDescription","fixedFields","schema"]),Rb(["visitors","document","objects","LinkDescription","fixedFields","submissionSchema"],Sf.visitors.JSONSchemaOrJSONReferenceVisitor),tS(["visitors","document","objects","LinkDescription","fixedFields","method"]),tS(["visitors","document","objects","LinkDescription","fixedFields","encType"]),Rb(["visitors","document","objects","LinkDescription","fixedFields","submissionEncType"],Sf.visitors.value))(Sf),aS={JSONSchemaDraft6Element:["content"],JSONReferenceElement:["content"],MediaElement:["content"],LinkDescriptionElement:["content"],...Gu},cS=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Pb||s(a)&&o("JSONSchemaDraft6",a)&&i("object",a))),lS=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Ib||s(a)&&o("linkDescription",a)&&i("object",a))),uS={namespace:s=>{const{base:o}=s;return o.register("jSONSchemaDraft6",Pb),o.register("jSONReference",Fh),o.register("media",Jh),o.register("linkDescription",Ib),o}},pS=uS,apidom_ns_json_schema_draft_6_src_refractor_toolbox=()=>{const s=createNamespace(pS);return{predicates:{...le,isStringElement:_u},namespace:s}},apidom_ns_json_schema_draft_6_src_refractor_refract=(s,{specPath:o=["visitors","document","objects","JSONSchema","$visitor"],plugins:i=[],specificationObj:a=iS}={})=>{const u=(0,du.e)(s),_=dereference(a),w=new(zu(o,_))({specObj:_});return visitor_visit(u,w),dispatchPluginsSync(w.element,i,{toolboxCreator:apidom_ns_json_schema_draft_6_src_refractor_toolbox,visitorOptions:{keyMap:aS,nodeTypeGetter:traversal_visitor_getNodeType}})},apidom_ns_json_schema_draft_6_src_refractor_createRefractor=s=>(o,i={})=>apidom_ns_json_schema_draft_6_src_refractor_refract(o,{specPath:s,...i});Pb.refract=apidom_ns_json_schema_draft_6_src_refractor_createRefractor(["visitors","document","objects","JSONSchema","$visitor"]),Ib.refract=apidom_ns_json_schema_draft_6_src_refractor_createRefractor(["visitors","document","objects","LinkDescription","$visitor"]);const hS=class elements_JSONSchema_JSONSchema extends Pb{constructor(s,o,i){super(s,o,i),this.element="JSONSchemaDraft7"}get $comment(){return this.get("$comment")}set $comment(s){this.set("$comment",s)}get items(){return this.get("items")}set items(s){this.set("items",s)}get if(){return this.get("if")}set if(s){this.set("if",s)}get then(){return this.get("then")}set then(s){this.set("then",s)}get else(){return this.get("else")}set else(s){this.set("else",s)}get not(){return this.get("not")}set not(s){this.set("not",s)}get contentEncoding(){return this.get("contentEncoding")}set contentEncoding(s){this.set("contentEncoding",s)}get contentMediaType(){return this.get("contentMediaType")}set contentMediaType(s){this.set("contentMediaType",s)}get media(){throw new Dh('media keyword from Hyper-Schema vocabulary has been moved to validation vocabulary as "contentMediaType" / "contentEncoding"')}set media(s){throw new Dh('media keyword from Hyper-Schema vocabulary has been moved to validation vocabulary as "contentMediaType" / "contentEncoding"')}get writeOnly(){return this.get("writeOnly")}set writeOnly(s){this.set("writeOnly",s)}};const dS=class elements_LinkDescription_LinkDescription extends Ib{get anchor(){return this.get("anchor")}set anchor(s){this.set("anchor",s)}get anchorPointer(){return this.get("anchorPointer")}set anchorPointer(s){this.set("anchorPointer",s)}get templatePointers(){return this.get("templatePointers")}set templatePointers(s){this.set("templatePointers",s)}get templateRequired(){return this.get("templateRequired")}set templateRequired(s){this.set("templateRequired",s)}get targetSchema(){return this.get("targetSchema")}set targetSchema(s){this.set("targetSchema",s)}get mediaType(){throw new Dh("mediaType keyword from Hyper-Schema vocabulary has been renamed to targetMediaType.")}set mediaType(s){throw new Dh("mediaType keyword from Hyper-Schema vocabulary has been renamed to targetMediaType.")}get targetMediaType(){return this.get("targetMediaType")}set targetMediaType(s){this.set("targetMediaType",s)}get targetHints(){return this.get("targetHints")}set targetHints(s){this.set("targetHints",s)}get description(){return this.get("description")}set description(s){this.set("description",s)}get $comment(){return this.get("$comment")}set $comment(s){this.set("$comment",s)}get hrefSchema(){return this.get("hrefSchema")}set hrefSchema(s){this.set("hrefSchema",s)}get headerSchema(){return this.get("headerSchema")}set headerSchema(s){this.set("headerSchema",s)}get submissionSchema(){return this.get("submissionSchema")}set submissionSchema(s){this.set("submissionSchema",s)}get submissionEncType(){throw new Dh("submissionEncType keyword from Hyper-Schema vocabulary has been renamed to submissionMediaType.")}set submissionEncType(s){throw new Dh("submissionEncType keyword from Hyper-Schema vocabulary has been renamed to submissionMediaType.")}get submissionMediaType(){return this.get("submissionMediaType")}set submissionMediaType(s){this.set("submissionMediaType",s)}};const fS=class visitors_json_schema_JSONSchemaVisitor extends rS{constructor(s){super(s),this.element=new hS}get defaultDialectIdentifier(){return"http://json-schema.org/draft-07/schema#"}};const mS=class json_schema_link_description_LinkDescriptionVisitor extends oS{constructor(s){super(s),this.element=new dS}},gS=pipe(Rb(["visitors","document","objects","JSONSchema","$visitor"],fS),Rb(["visitors","document","objects","JSONSchema","fixedFields","$comment"],iS.visitors.value),Rb(["visitors","document","objects","JSONSchema","fixedFields","if"],iS.visitors.JSONSchemaOrJSONReferenceVisitor),Rb(["visitors","document","objects","JSONSchema","fixedFields","then"],iS.visitors.JSONSchemaOrJSONReferenceVisitor),Rb(["visitors","document","objects","JSONSchema","fixedFields","else"],iS.visitors.JSONSchemaOrJSONReferenceVisitor),tS(["visitors","document","objects","JSONSchema","fixedFields","media"]),Rb(["visitors","document","objects","JSONSchema","fixedFields","contentEncoding"],iS.visitors.value),Rb(["visitors","document","objects","JSONSchema","fixedFields","contentMediaType"],iS.visitors.value),Rb(["visitors","document","objects","JSONSchema","fixedFields","writeOnly"],iS.visitors.value),Rb(["visitors","document","objects","LinkDescription","$visitor"],mS),Rb(["visitors","document","objects","LinkDescription","fixedFields","anchor"],iS.visitors.value),Rb(["visitors","document","objects","LinkDescription","fixedFields","anchorPointer"],iS.visitors.value),tS(["visitors","document","objects","LinkDescription","fixedFields","mediaType"]),Rb(["visitors","document","objects","LinkDescription","fixedFields","targetMediaType"],iS.visitors.value),Rb(["visitors","document","objects","LinkDescription","fixedFields","targetHints"],iS.visitors.value),Rb(["visitors","document","objects","LinkDescription","fixedFields","description"],iS.visitors.value),Rb(["visitors","document","objects","LinkDescription","fixedFields","$comment"],iS.visitors.value),Rb(["visitors","document","objects","LinkDescription","fixedFields","headerSchema"],iS.visitors.JSONSchemaOrJSONReferenceVisitor),tS(["visitors","document","objects","LinkDescription","fixedFields","submissionEncType"]),Rb(["visitors","document","objects","LinkDescription","fixedFields","submissionMediaType"],iS.visitors.value))(iS),yS={JSONSchemaDraft7Element:["content"],JSONReferenceElement:["content"],LinkDescriptionElement:["content"],...Gu},vS=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof hS||s(a)&&o("JSONSchemaDraft7",a)&&i("object",a))),bS=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof dS||s(a)&&o("linkDescription",a)&&i("object",a))),SS={namespace:s=>{const{base:o}=s;return o.register("jSONSchemaDraft7",hS),o.register("jSONReference",Fh),o.register("linkDescription",dS),o}},_S=SS,apidom_ns_json_schema_draft_7_src_refractor_toolbox=()=>{const s=createNamespace(_S);return{predicates:{...pe,isStringElement:_u},namespace:s}},apidom_ns_json_schema_draft_7_src_refractor_refract=(s,{specPath:o=["visitors","document","objects","JSONSchema","$visitor"],plugins:i=[],specificationObj:a=gS}={})=>{const u=(0,du.e)(s),_=dereference(a),w=new(zu(o,_))({specObj:_});return visitor_visit(u,w),dispatchPluginsSync(w.element,i,{toolboxCreator:apidom_ns_json_schema_draft_7_src_refractor_toolbox,visitorOptions:{keyMap:yS,nodeTypeGetter:traversal_visitor_getNodeType}})},apidom_ns_json_schema_draft_7_src_refractor_createRefractor=s=>(o,i={})=>apidom_ns_json_schema_draft_7_src_refractor_refract(o,{specPath:s,...i});hS.refract=apidom_ns_json_schema_draft_7_src_refractor_createRefractor(["visitors","document","objects","JSONSchema","$visitor"]),dS.refract=apidom_ns_json_schema_draft_7_src_refractor_createRefractor(["visitors","document","objects","LinkDescription","$visitor"]);const ES=class src_elements_JSONSchema_JSONSchema extends hS{constructor(s,o,i){super(s,o,i),this.element="JSONSchema201909"}get $vocabulary(){return this.get("$vocabulary")}set $vocabulary(s){this.set("$vocabulary",s)}get $anchor(){return this.get("$anchor")}set $anchor(s){this.set("$anchor",s)}get $recursiveAnchor(){return this.get("$recursiveAnchor")}set $recursiveAnchor(s){this.set("$recursiveAnchor",s)}get $recursiveRef(){return this.get("$recursiveRef")}set $recursiveRef(s){this.set("$recursiveRef",s)}get $ref(){return this.get("$ref")}set $ref(s){this.set("$ref",s)}get $defs(){return this.get("$defs")}set $defs(s){this.set("$defs",s)}get definitions(){throw new Dh("definitions keyword from Validation vocabulary has been renamed to $defs.")}set definitions(s){throw new Dh("definitions keyword from Validation vocabulary has been renamed to $defs.")}get not(){return this.get("not")}set not(s){this.set("not",s)}get if(){return this.get("if")}set if(s){this.set("if",s)}get then(){return this.get("then")}set then(s){this.set("then",s)}get else(){return this.get("else")}set else(s){this.set("else",s)}get dependentSchemas(){return this.get("dependentSchemas")}set dependentSchemas(s){this.set("dependentSchemas",s)}get dependencies(){throw new Dh("dependencies keyword from Validation vocabulary has been renamed to dependentSchemas.")}set dependencies(s){throw new Dh("dependencies keyword from Validation vocabulary has been renamed to dependentSchemas.")}get items(){return this.get("items")}set items(s){this.set("items",s)}get containsProp(){return this.get("contains")}set containsProp(s){this.set("contains",s)}get additionalProperties(){return this.get("additionalProperties")}set additionalProperties(s){this.set("additionalProperties",s)}get additionalItems(){return this.get("additionalItems")}set additionalItems(s){this.set("additionalItems",s)}get propertyNames(){return this.get("propertyNames")}set propertyNames(s){this.set("propertyNames",s)}get unevaluatedItems(){return this.get("unevaluatedItems")}set unevaluatedItems(s){this.set("unevaluatedItems",s)}get unevaluatedProperties(){return this.get("unevaluatedProperties")}set unevaluatedProperties(s){this.set("unevaluatedProperties",s)}get maxContains(){return this.get("maxContains")}set maxContains(s){this.set("maxContains",s)}get minContains(){return this.get("minContains")}set minContains(s){this.set("minContains",s)}get dependentRequired(){return this.get("dependentRequired")}set dependentRequired(s){this.set("dependentRequired",s)}get deprecated(){return this.get("deprecated")}set deprecated(s){this.set("deprecated",s)}get contentSchema(){return this.get("contentSchema")}set contentSchema(s){this.set("contentSchema",s)}};const wS=class src_elements_LinkDescription_LinkDescription extends dS{get targetSchema(){return this.get("targetSchema")}set targetSchema(s){this.set("targetSchema",s)}get hrefSchema(){return this.get("hrefSchema")}set hrefSchema(s){this.set("hrefSchema",s)}get headerSchema(){return this.get("headerSchema")}set headerSchema(s){this.set("headerSchema",s)}get submissionSchema(){return this.get("submissionSchema")}set submissionSchema(s){this.set("submissionSchema",s)}};const xS=class refractor_visitors_json_schema_JSONSchemaVisitor extends fS{constructor(s){super(s),this.element=new ES}get defaultDialectIdentifier(){return"https://json-schema.org/draft/2019-09/schema"}ObjectElement(s){this.handleDialectIdentifier(s),this.handleSchemaIdentifier(s),this.parent=this.element;const o=xd.prototype.ObjectElement.call(this,s);return _u(this.element.$ref)&&(this.element.classes.push("reference-element"),this.element.setMetaProperty("referenced-element","schema")),o}};const kS=class $vocabularyVisitor extends td{ObjectElement(s){const o=super.enter(s);return this.element.classes.push("json-schema-$vocabulary"),o}};const OS=class $refVisitor extends td{StringElement(s){const o=super.enter(s);return this.element.classes.push("reference-value"),o}};class $defsVisitor extends(Mixin(Dd,kd,td)){constructor(s){super(s),this.element=new du.Sh,this.element.classes.push("json-schema-$defs"),this.specPath=lc(["document","objects","JSONSchema"])}}const AS=$defsVisitor;class json_schema_AllOfVisitor_AllOfVisitor extends(Mixin(wd,kd,td)){constructor(s){super(s),this.element=new du.wE,this.element.classes.push("json-schema-allOf")}ArrayElement(s){return s.forEach((s=>{const o=this.toRefractedElement(["document","objects","JSONSchema"],s);this.element.push(o)})),this.copyMetaAndAttributes(s,this.element),Nu}}const CS=json_schema_AllOfVisitor_AllOfVisitor;class json_schema_AnyOfVisitor_AnyOfVisitor extends(Mixin(wd,kd,td)){constructor(s){super(s),this.element=new du.wE,this.element.classes.push("json-schema-anyOf")}ArrayElement(s){return s.forEach((s=>{const o=this.toRefractedElement(["document","objects","JSONSchema"],s);this.element.push(o)})),this.copyMetaAndAttributes(s,this.element),Nu}}const jS=json_schema_AnyOfVisitor_AnyOfVisitor;class json_schema_OneOfVisitor_OneOfVisitor extends(Mixin(wd,kd,td)){constructor(s){super(s),this.element=new du.wE,this.element.classes.push("json-schema-oneOf")}ArrayElement(s){return s.forEach((s=>{const o=this.toRefractedElement(["document","objects","JSONSchema"],s);this.element.push(o)})),this.copyMetaAndAttributes(s,this.element),Nu}}const PS=json_schema_OneOfVisitor_OneOfVisitor;class DependentSchemasVisitor extends(Mixin(Dd,kd,td)){constructor(s){super(s),this.element=new du.Sh,this.element.classes.push("json-schema-dependentSchemas"),this.specPath=lc(["document","objects","JSONSchema"])}}const IS=DependentSchemasVisitor;class visitors_json_schema_ItemsVisitor_ItemsVisitor extends(Mixin(wd,kd,td)){ObjectElement(s){return this.element=this.toRefractedElement(["document","objects","JSONSchema"],s),Nu}ArrayElement(s){return this.element=new du.wE,this.element.classes.push("json-schema-items"),s.forEach((s=>{const o=this.toRefractedElement(["document","objects","JSONSchema"],s);this.element.push(o)})),this.copyMetaAndAttributes(s,this.element),Nu}BooleanElement(s){return this.element=this.toRefractedElement(["document","objects","JSONSchema"],s),Nu}}const TS=visitors_json_schema_ItemsVisitor_ItemsVisitor;class json_schema_PropertiesVisitor_PropertiesVisitor extends(Mixin(Dd,kd,td)){constructor(s){super(s),this.element=new du.Sh,this.element.classes.push("json-schema-properties"),this.specPath=lc(["document","objects","JSONSchema"])}}const NS=json_schema_PropertiesVisitor_PropertiesVisitor;class PatternPropertiesVisitor_PatternPropertiesVisitor extends(Mixin(Dd,kd,td)){constructor(s){super(s),this.element=new du.Sh,this.element.classes.push("json-schema-patternProperties"),this.specPath=lc(["document","objects","JSONSchema"])}}const MS=PatternPropertiesVisitor_PatternPropertiesVisitor;const RS=class DependentRequiredVisitor extends td{ObjectElement(s){const o=super.enter(s);return this.element.classes.push("json-schema-dependentRequired"),o}};const DS=class visitors_json_schema_link_description_LinkDescriptionVisitor extends mS{constructor(s){super(s),this.element=new wS}},LS=pipe(Rb(["visitors","document","objects","JSONSchema","$visitor"],xS),Rb(["visitors","document","objects","JSONSchema","fixedFields","$vocabulary"],kS),Rb(["visitors","document","objects","JSONSchema","fixedFields","$anchor"],gS.visitors.value),Rb(["visitors","document","objects","JSONSchema","fixedFields","$recursiveAnchor"],gS.visitors.value),Rb(["visitors","document","objects","JSONSchema","fixedFields","$recursiveRef"],gS.visitors.value),tS(["visitors","document","objects","JSONReference","$visitor"]),Rb(["visitors","document","objects","JSONSchema","fixedFields","$ref"],OS),tS(["visitors","document","objects","JSONSchema","fixedFields","definitions"]),Rb(["visitors","document","objects","JSONSchema","fixedFields","$defs"],AS),Rb(["visitors","document","objects","JSONSchema","fixedFields","allOf"],CS),Rb(["visitors","document","objects","JSONSchema","fixedFields","anyOf"],jS),Rb(["visitors","document","objects","JSONSchema","fixedFields","oneOf"],PS),Rb(["visitors","document","objects","JSONSchema","fixedFields","not"],xS),Rb(["visitors","document","objects","JSONSchema","fixedFields","if"],xS),Rb(["visitors","document","objects","JSONSchema","fixedFields","then"],xS),Rb(["visitors","document","objects","JSONSchema","fixedFields","else"],xS),tS(["visitors","document","objects","JSONSchema","fixedFields","dependencies"]),Rb(["visitors","document","objects","JSONSchema","fixedFields","dependentSchemas"],IS),Rb(["visitors","document","objects","JSONSchema","fixedFields","items"],TS),Rb(["visitors","document","objects","JSONSchema","fixedFields","contains"],xS),Rb(["visitors","document","objects","JSONSchema","fixedFields","properties"],NS),Rb(["visitors","document","objects","JSONSchema","fixedFields","patternProperties"],MS),Rb(["visitors","document","objects","JSONSchema","fixedFields","additionalProperties"],xS),Rb(["visitors","document","objects","JSONSchema","fixedFields","additionalItems"],xS),Rb(["visitors","document","objects","JSONSchema","fixedFields","propertyNames"],xS),Rb(["visitors","document","objects","JSONSchema","fixedFields","unevaluatedItems"],xS),Rb(["visitors","document","objects","JSONSchema","fixedFields","unevaluatedProperties"],xS),Rb(["visitors","document","objects","JSONSchema","fixedFields","maxContains"],gS.visitors.value),Rb(["visitors","document","objects","JSONSchema","fixedFields","minContains"],gS.visitors.value),Rb(["visitors","document","objects","JSONSchema","fixedFields","dependentRequired"],RS),Rb(["visitors","document","objects","JSONSchema","fixedFields","deprecated"],gS.visitors.value),Rb(["visitors","document","objects","JSONSchema","fixedFields","contentSchema"],xS),Rb(["visitors","document","objects","LinkDescription","$visitor"],DS),Rb(["visitors","document","objects","LinkDescription","fixedFields","targetSchema"],xS),Rb(["visitors","document","objects","LinkDescription","fixedFields","hrefSchema"],xS),Rb(["visitors","document","objects","LinkDescription","fixedFields","headerSchema"],xS),Rb(["visitors","document","objects","LinkDescription","fixedFields","submissionSchema"],xS))(gS),FS={JSONSchema201909Element:["content"],LinkDescriptionElement:["content"],...Gu},BS=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof ES||s(a)&&o("JSONSchema201909",a)&&i("object",a))),$S=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof wS||s(a)&&o("linkDescription",a)&&i("object",a))),qS={namespace:s=>{const{base:o}=s;return o.register("jSONSchema201909",ES),o.register("linkDescription",wS),o}},US=qS,apidom_ns_json_schema_2019_09_src_refractor_toolbox=()=>{const s=createNamespace(US);return{predicates:{...de,isStringElement:_u},namespace:s}},apidom_ns_json_schema_2019_09_src_refractor_refract=(s,{specPath:o=["visitors","document","objects","JSONSchema","$visitor"],plugins:i=[],specificationObj:a=LS}={})=>{const u=(0,du.e)(s),_=dereference(a),w=new(zu(o,_))({specObj:_});return visitor_visit(u,w),dispatchPluginsSync(w.element,i,{toolboxCreator:apidom_ns_json_schema_2019_09_src_refractor_toolbox,visitorOptions:{keyMap:FS,nodeTypeGetter:traversal_visitor_getNodeType}})},apidom_ns_json_schema_2019_09_src_refractor_createRefractor=s=>(o,i={})=>apidom_ns_json_schema_2019_09_src_refractor_refract(o,{specPath:s,...i});ES.refract=apidom_ns_json_schema_2019_09_src_refractor_createRefractor(["visitors","document","objects","JSONSchema","$visitor"]),wS.refract=apidom_ns_json_schema_2019_09_src_refractor_createRefractor(["visitors","document","objects","LinkDescription","$visitor"]);const VS=class apidom_ns_json_schema_2020_12_src_elements_JSONSchema_JSONSchema extends ES{constructor(s,o,i){super(s,o,i),this.element="JSONSchema202012"}get $dynamicAnchor(){return this.get("$dynamicAnchor")}set $dynamicAnchor(s){this.set("$dynamicAnchor",s)}get $recursiveAnchor(){throw new Dh("$recursiveAnchor keyword from Core vocabulary has been renamed to $dynamicAnchor.")}set $recursiveAnchor(s){throw new Dh("$recursiveAnchor keyword from Core vocabulary has been renamed to $dynamicAnchor.")}get $dynamicRef(){return this.get("$dynamicRef")}set $dynamicRef(s){this.set("$dynamicRef",s)}get $recursiveRef(){throw new Dh("$recursiveRef keyword from Core vocabulary has been renamed to $dynamicRef.")}set $recursiveRef(s){throw new Dh("$recursiveRef keyword from Core vocabulary has been renamed to $dynamicRef.")}get prefixItems(){return this.get("prefixItems")}set prefixItems(s){this.set("prefixItems",s)}};const zS=class apidom_ns_json_schema_2020_12_src_elements_LinkDescription_LinkDescription extends wS{get targetSchema(){return this.get("targetSchema")}set targetSchema(s){this.set("targetSchema",s)}get hrefSchema(){return this.get("hrefSchema")}set hrefSchema(s){this.set("hrefSchema",s)}get headerSchema(){return this.get("headerSchema")}set headerSchema(s){this.set("headerSchema",s)}get submissionSchema(){return this.get("submissionSchema")}set submissionSchema(s){this.set("submissionSchema",s)}};const WS=class src_refractor_visitors_json_schema_JSONSchemaVisitor extends xS{constructor(s){super(s),this.element=new VS}get defaultDialectIdentifier(){return"https://json-schema.org/draft/2020-12/schema"}};class PrefixItemsVisitor extends(Mixin(wd,kd,td)){constructor(s){super(s),this.element=new du.wE,this.element.classes.push("json-schema-prefixItems")}ArrayElement(s){return s.forEach((s=>{const o=this.toRefractedElement(["document","objects","JSONSchema"],s);this.element.push(o)})),this.copyMetaAndAttributes(s,this.element),Nu}}const JS=PrefixItemsVisitor;const HS=class refractor_visitors_json_schema_link_description_LinkDescriptionVisitor extends DS{constructor(s){super(s),this.element=new zS}},KS=pipe(Rb(["visitors","document","objects","JSONSchema","$visitor"],WS),tS(["visitors","document","objects","JSONSchema","fixedFields","$recursiveAnchor"]),Rb(["visitors","document","objects","JSONSchema","fixedFields","$dynamicAnchor"],LS.visitors.value),tS(["visitors","document","objects","JSONSchema","fixedFields","$recursiveRef"]),Rb(["visitors","document","objects","JSONSchema","fixedFields","$dynamicRef"],LS.visitors.value),Rb(["visitors","document","objects","JSONSchema","fixedFields","not"],WS),Rb(["visitors","document","objects","JSONSchema","fixedFields","if"],WS),Rb(["visitors","document","objects","JSONSchema","fixedFields","then"],WS),Rb(["visitors","document","objects","JSONSchema","fixedFields","else"],WS),Rb(["visitors","document","objects","JSONSchema","fixedFields","prefixItems"],JS),Rb(["visitors","document","objects","JSONSchema","fixedFields","items"],WS),Rb(["visitors","document","objects","JSONSchema","fixedFields","contains"],WS),Rb(["visitors","document","objects","JSONSchema","fixedFields","additionalProperties"],WS),tS(["visitors","document","objects","JSONSchema","fixedFields","additionalItems"]),Rb(["visitors","document","objects","JSONSchema","fixedFields","propertyNames"],WS),Rb(["visitors","document","objects","JSONSchema","fixedFields","unevaluatedItems"],WS),Rb(["visitors","document","objects","JSONSchema","fixedFields","unevaluatedProperties"],WS),Rb(["visitors","document","objects","JSONSchema","fixedFields","contentSchema"],WS),Rb(["visitors","document","objects","LinkDescription","$visitor"],HS),Rb(["visitors","document","objects","LinkDescription","fixedFields","targetSchema"],WS),Rb(["visitors","document","objects","LinkDescription","fixedFields","hrefSchema"],WS),Rb(["visitors","document","objects","LinkDescription","fixedFields","headerSchema"],WS),Rb(["visitors","document","objects","LinkDescription","fixedFields","submissionSchema"],WS))(LS),GS={JSONSchema202012Element:["content"],LinkDescriptionElement:["content"],...Gu},YS=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof VS||s(a)&&o("JSONSchema202012",a)&&i("object",a))),XS=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof zS||s(a)&&o("linkDescription",a)&&i("object",a))),QS={namespace:s=>{const{base:o}=s;return o.register("jSONSchema202012",VS),o.register("linkDescription",zS),o}},ZS=QS,apidom_ns_json_schema_2020_12_src_refractor_toolbox=()=>{const s=createNamespace(ZS);return{predicates:{...fe,isStringElement:_u},namespace:s}},apidom_ns_json_schema_2020_12_src_refractor_refract=(s,{specPath:o=["visitors","document","objects","JSONSchema","$visitor"],plugins:i=[],specificationObj:a=KS}={})=>{const u=(0,du.e)(s),_=dereference(a),w=new(zu(o,_))({specObj:_});return visitor_visit(u,w),dispatchPluginsSync(w.element,i,{toolboxCreator:apidom_ns_json_schema_2020_12_src_refractor_toolbox,visitorOptions:{keyMap:GS,nodeTypeGetter:traversal_visitor_getNodeType}})},apidom_ns_json_schema_2020_12_src_refractor_createRefractor=s=>(o,i={})=>apidom_ns_json_schema_2020_12_src_refractor_refract(o,{specPath:s,...i});VS.refract=apidom_ns_json_schema_2020_12_src_refractor_createRefractor(["visitors","document","objects","JSONSchema","$visitor"]),zS.refract=apidom_ns_json_schema_2020_12_src_refractor_createRefractor(["visitors","document","objects","LinkDescription","$visitor"]);const e_=class elements_Schema_Schema extends VS{constructor(s,o,i){super(s,o,i),this.element="schema"}get discriminator(){return this.get("discriminator")}set discriminator(s){this.set("discriminator",s)}get xml(){return this.get("xml")}set xml(s){this.set("xml",s)}get externalDocs(){return this.get("externalDocs")}set externalDocs(s){this.set("externalDocs",s)}get example(){return this.get("example")}set example(s){this.set("example",s)}};const t_=class SecurityRequirement_SecurityRequirement extends Cf{};const r_=class SecurityScheme_SecurityScheme extends jf{};const n_=class Server_Server extends Pf{};const s_=class ServerVariable_ServerVariable extends Tf{};const o_=class Tag_Tag extends Nf{};const i_=class Xml_Xml extends Rf{};class OpenApi3_1Visitor extends(Mixin(em,Ff)){constructor(s){super(s),this.element=new nb,this.specPath=lc(["document","objects","OpenApi"]),this.canSupportSpecificationExtensions=!0,this.openApiSemanticElement=this.element}ObjectElement(s){return this.openApiGenericElement=s,em.prototype.ObjectElement.call(this,s)}}const a_=OpenApi3_1Visitor,c_=Dv.visitors.document.objects.Info.$visitor;const l_=class info_InfoVisitor extends c_{constructor(s){super(s),this.element=new Kv}},u_=Dv.visitors.document.objects.Contact.$visitor;const p_=class contact_ContactVisitor extends u_{constructor(s){super(s),this.element=new Uv}},h_=Dv.visitors.document.objects.License.$visitor;const d_=class license_LicenseVisitor extends h_{constructor(s){super(s),this.element=new Yv}},f_=Dv.visitors.document.objects.Link.$visitor;const m_=class link_LinkVisitor extends f_{constructor(s){super(s),this.element=new Xv}};class JsonSchemaDialectVisitor extends(Mixin(Vf,Ff)){StringElement(s){const o=new Gv(serializers_value(s));return this.copyMetaAndAttributes(s,o),this.element=o,Nu}}const g_=JsonSchemaDialectVisitor,y_=Dv.visitors.document.objects.Server.$visitor;const v_=class server_ServerVisitor extends y_{constructor(s){super(s),this.element=new n_}},b_=Dv.visitors.document.objects.ServerVariable.$visitor;const S_=class server_variable_ServerVariableVisitor extends b_{constructor(s){super(s),this.element=new s_}},E_=Dv.visitors.document.objects.MediaType.$visitor;const w_=class media_type_MediaTypeVisitor extends E_{constructor(s){super(s),this.element=new Qv}},x_=Dv.visitors.document.objects.SecurityRequirement.$visitor;const k_=class security_requirement_SecurityRequirementVisitor extends x_{constructor(s){super(s),this.element=new t_}},O_=Dv.visitors.document.objects.Components.$visitor;const A_=class components_ComponentsVisitor extends O_{constructor(s){super(s),this.element=new qv}},C_=Dv.visitors.document.objects.Tag.$visitor;const j_=class tag_TagVisitor extends C_{constructor(s){super(s),this.element=new o_}},P_=Dv.visitors.document.objects.Reference.$visitor;const I_=class reference_ReferenceVisitor extends P_{constructor(s){super(s),this.element=new _b}},T_=Dv.visitors.document.objects.Parameter.$visitor;const N_=class parameter_ParameterVisitor extends T_{constructor(s){super(s),this.element=new mb}},M_=Dv.visitors.document.objects.Header.$visitor;const R_=class header_HeaderVisitor extends M_{constructor(s){super(s),this.element=new Hv}},D_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof $v||s(a)&&o("callback",a)&&i("object",a))),L_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof qv||s(a)&&o("components",a)&&i("object",a))),F_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Uv||s(a)&&o("contact",a)&&i("object",a))),B_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Wv||s(a)&&o("example",a)&&i("object",a))),$_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Jv||s(a)&&o("externalDocumentation",a)&&i("object",a))),q_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Hv||s(a)&&o("header",a)&&i("object",a))),U_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Kv||s(a)&&o("info",a)&&i("object",a))),V_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Gv||s(a)&&o("jsonSchemaDialect",a)&&i("string",a))),z_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Yv||s(a)&&o("license",a)&&i("object",a))),W_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Xv||s(a)&&o("link",a)&&i("object",a))),J_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof tb||s(a)&&o("openapi",a)&&i("string",a))),H_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i,hasClass:a})=>u=>u instanceof nb||s(u)&&o("openApi3_1",u)&&i("object",u)&&a("api",u))),K_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof pb||s(a)&&o("operation",a)&&i("object",a))),G_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof mb||s(a)&&o("parameter",a)&&i("object",a))),Y_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof yb||s(a)&&o("pathItem",a)&&i("object",a))),isPathItemElementExternal=s=>{if(!Y_(s))return!1;if(!_u(s.$ref))return!1;const o=serializers_value(s.$ref);return"string"==typeof o&&o.length>0&&!o.startsWith("#")},X_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Sb||s(a)&&o("paths",a)&&i("object",a))),Q_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof _b||s(a)&&o("reference",a)&&i("object",a))),isReferenceElementExternal=s=>{if(!Q_(s))return!1;if(!_u(s.$ref))return!1;const o=serializers_value(s.$ref);return"string"==typeof o&&o.length>0&&!o.startsWith("#")},Z_=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof wb||s(a)&&o("requestBody",a)&&i("object",a))),eE=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Ob||s(a)&&o("response",a)&&i("object",a))),tE=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Ab||s(a)&&o("responses",a)&&i("object",a))),rE=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof e_||s(a)&&o("schema",a)&&i("object",a))),predicates_isBooleanJsonSchemaElement=s=>xu(s)&&s.classes.includes("boolean-json-schema"),nE=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof t_||s(a)&&o("securityRequirement",a)&&i("object",a))),sE=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof r_||s(a)&&o("securityScheme",a)&&i("object",a))),oE=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof n_||s(a)&&o("server",a)&&i("object",a))),iE=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof s_||s(a)&&o("serverVariable",a)&&i("object",a))),aE=helpers((({hasBasicElementProps:s,isElementType:o,primitiveEq:i})=>a=>a instanceof Qv||s(a)&&o("mediaType",a)&&i("object",a)));class open_api_3_1_schema_SchemaVisitor extends(Mixin(em,kd,Ff)){constructor(s){super(s),this.element=new e_,this.specPath=lc(["document","objects","Schema"]),this.canSupportSpecificationExtensions=!0,this.jsonSchemaDefaultDialect=Gv.default,this.passingOptionsNames.push("parent")}ObjectElement(s){this.handleDialectIdentifier(s),this.handleSchemaIdentifier(s),this.parent=this.element;const o=em.prototype.ObjectElement.call(this,s);return _u(this.element.$ref)&&(this.element.classes.push("reference-element"),this.element.setMetaProperty("referenced-element","schema")),o}BooleanElement(s){return WS.prototype.BooleanElement.call(this,s)}get defaultDialectIdentifier(){let s;return s=void 0!==this.openApiSemanticElement&&V_(this.openApiSemanticElement.jsonSchemaDialect)?serializers_value(this.openApiSemanticElement.jsonSchemaDialect):void 0!==this.openApiGenericElement&&_u(this.openApiGenericElement.get("jsonSchemaDialect"))?serializers_value(this.openApiGenericElement.get("jsonSchemaDialect")):serializers_value(this.jsonSchemaDefaultDialect),s}handleDialectIdentifier(s){return WS.prototype.handleDialectIdentifier.call(this,s)}handleSchemaIdentifier(s){return WS.prototype.handleSchemaIdentifier.call(this,s)}}const cE=open_api_3_1_schema_SchemaVisitor;const lE=class $defsVisitor_$defsVisitor extends AS{constructor(s){super(s),this.passingOptionsNames.push("parent")}};const uE=class schema_AllOfVisitor_AllOfVisitor extends CS{constructor(s){super(s),this.passingOptionsNames.push("parent")}};const pE=class schema_AnyOfVisitor_AnyOfVisitor extends jS{constructor(s){super(s),this.passingOptionsNames.push("parent")}};const hE=class schema_OneOfVisitor_OneOfVisitor extends PS{constructor(s){super(s),this.passingOptionsNames.push("parent")}};const dE=class DependentSchemasVisitor_DependentSchemasVisitor extends IS{constructor(s){super(s),this.passingOptionsNames.push("parent")}};const fE=class PrefixItemsVisitor_PrefixItemsVisitor extends JS{constructor(s){super(s),this.passingOptionsNames.push("parent")}};const mE=class schema_PropertiesVisitor_PropertiesVisitor extends NS{constructor(s){super(s),this.passingOptionsNames.push("parent")}};const gE=class schema_PatternPropertiesVisitor_PatternPropertiesVisitor extends MS{constructor(s){super(s),this.passingOptionsNames.push("parent")}},yE=Dv.visitors.document.objects.Discriminator.$visitor;const vE=class distriminator_DiscriminatorVisitor extends yE{constructor(s){super(s),this.element=new Vv,this.canSupportSpecificationExtensions=!0}},bE=Dv.visitors.document.objects.XML.$visitor;const SE=class xml_XmlVisitor extends bE{constructor(s){super(s),this.element=new i_}};class SchemasVisitor_SchemasVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new by,this.specPath=lc(["document","objects","Schema"])}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(rE).forEach(((s,o)=>{s.setMetaProperty("schemaName",serializers_value(o))})),o}}const _E=SchemasVisitor_SchemasVisitor;class ComponentsPathItems extends du.Sh{static primaryClass="components-path-items";constructor(s,o,i){super(s,o,i),this.classes.push(ComponentsPathItems.primaryClass)}}const EE=ComponentsPathItems;class PathItemsVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new EE,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","PathItem"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Q_).forEach((s=>{s.setMetaProperty("referenced-element","pathItem")})),o}}const wE=PathItemsVisitor,xE=Dv.visitors.document.objects.Example.$visitor;const kE=class example_ExampleVisitor extends xE{constructor(s){super(s),this.element=new Wv}},OE=Dv.visitors.document.objects.ExternalDocumentation.$visitor;const AE=class external_documentation_ExternalDocumentationVisitor extends OE{constructor(s){super(s),this.element=new Jv}},CE=Dv.visitors.document.objects.Encoding.$visitor;const jE=class open_api_3_1_encoding_EncodingVisitor extends CE{constructor(s){super(s),this.element=new zv}},PE=Dv.visitors.document.objects.Paths.$visitor;const IE=class paths_PathsVisitor extends PE{constructor(s){super(s),this.element=new Sb}},TE=Dv.visitors.document.objects.RequestBody.$visitor;const NE=class request_body_RequestBodyVisitor extends TE{constructor(s){super(s),this.element=new wb}},ME=Dv.visitors.document.objects.Callback.$visitor;const RE=class callback_CallbackVisitor extends ME{constructor(s){super(s),this.element=new $v,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","PathItem"]}ObjectElement(s){const o=ME.prototype.ObjectElement.call(this,s);return this.element.filter(Q_).forEach((s=>{s.setMetaProperty("referenced-element","pathItem")})),o}},DE=Dv.visitors.document.objects.Response.$visitor;const LE=class response_ResponseVisitor extends DE{constructor(s){super(s),this.element=new Ob}},FE=Dv.visitors.document.objects.Responses.$visitor;const BE=class open_api_3_1_responses_ResponsesVisitor extends FE{constructor(s){super(s),this.element=new Ab}},$E=Dv.visitors.document.objects.Operation.$visitor;const qE=class operation_OperationVisitor extends $E{constructor(s){super(s),this.element=new pb}},UE=Dv.visitors.document.objects.PathItem.$visitor;const VE=class path_item_PathItemVisitor extends UE{constructor(s){super(s),this.element=new yb}},zE=Dv.visitors.document.objects.SecurityScheme.$visitor;const WE=class security_scheme_SecuritySchemeVisitor extends zE{constructor(s){super(s),this.element=new r_}},JE=Dv.visitors.document.objects.OAuthFlows.$visitor;const HE=class oauth_flows_OAuthFlowsVisitor extends JE{constructor(s){super(s),this.element=new eb}},KE=Dv.visitors.document.objects.OAuthFlow.$visitor;const GE=class oauth_flow_OAuthFlowVisitor extends KE{constructor(s){super(s),this.element=new Zv}};class Webhooks extends du.Sh{static primaryClass="webhooks";constructor(s,o,i){super(s,o,i),this.classes.push(Webhooks.primaryClass)}}const YE=Webhooks;class WebhooksVisitor extends(Mixin(hm,Ff)){constructor(s){super(s),this.element=new YE,this.specPath=s=>isReferenceLikeElement(s)?["document","objects","Reference"]:["document","objects","PathItem"]}ObjectElement(s){const o=hm.prototype.ObjectElement.call(this,s);return this.element.filter(Q_).forEach((s=>{s.setMetaProperty("referenced-element","pathItem")})),this.element.filter(Y_).forEach(((s,o)=>{s.setMetaProperty("webhook-name",serializers_value(o))})),o}}const XE=WebhooksVisitor,{JSONSchema:QE,LinkDescription:ZE}=KS.visitors.document.objects,ew={visitors:{value:Dv.visitors.value,document:{objects:{OpenApi:{$visitor:a_,fixedFields:{openapi:Dv.visitors.document.objects.OpenApi.fixedFields.openapi,info:{$ref:"#/visitors/document/objects/Info"},jsonSchemaDialect:g_,servers:Dv.visitors.document.objects.OpenApi.fixedFields.servers,paths:{$ref:"#/visitors/document/objects/Paths"},webhooks:XE,components:{$ref:"#/visitors/document/objects/Components"},security:Dv.visitors.document.objects.OpenApi.fixedFields.security,tags:Dv.visitors.document.objects.OpenApi.fixedFields.tags,externalDocs:{$ref:"#/visitors/document/objects/ExternalDocumentation"}}},Info:{$visitor:l_,fixedFields:{title:Dv.visitors.document.objects.Info.fixedFields.title,description:Dv.visitors.document.objects.Info.fixedFields.description,summary:{$ref:"#/visitors/value"},termsOfService:Dv.visitors.document.objects.Info.fixedFields.termsOfService,contact:{$ref:"#/visitors/document/objects/Contact"},license:{$ref:"#/visitors/document/objects/License"},version:Dv.visitors.document.objects.Info.fixedFields.version}},Contact:{$visitor:p_,fixedFields:{name:Dv.visitors.document.objects.Contact.fixedFields.name,url:Dv.visitors.document.objects.Contact.fixedFields.url,email:Dv.visitors.document.objects.Contact.fixedFields.email}},License:{$visitor:d_,fixedFields:{name:Dv.visitors.document.objects.License.fixedFields.name,identifier:{$ref:"#/visitors/value"},url:Dv.visitors.document.objects.License.fixedFields.url}},Server:{$visitor:v_,fixedFields:{url:Dv.visitors.document.objects.Server.fixedFields.url,description:Dv.visitors.document.objects.Server.fixedFields.description,variables:Dv.visitors.document.objects.Server.fixedFields.variables}},ServerVariable:{$visitor:S_,fixedFields:{enum:Dv.visitors.document.objects.ServerVariable.fixedFields.enum,default:Dv.visitors.document.objects.ServerVariable.fixedFields.default,description:Dv.visitors.document.objects.ServerVariable.fixedFields.description}},Components:{$visitor:A_,fixedFields:{schemas:_E,responses:Dv.visitors.document.objects.Components.fixedFields.responses,parameters:Dv.visitors.document.objects.Components.fixedFields.parameters,examples:Dv.visitors.document.objects.Components.fixedFields.examples,requestBodies:Dv.visitors.document.objects.Components.fixedFields.requestBodies,headers:Dv.visitors.document.objects.Components.fixedFields.headers,securitySchemes:Dv.visitors.document.objects.Components.fixedFields.securitySchemes,links:Dv.visitors.document.objects.Components.fixedFields.links,callbacks:Dv.visitors.document.objects.Components.fixedFields.callbacks,pathItems:wE}},Paths:{$visitor:IE},PathItem:{$visitor:VE,fixedFields:{$ref:Dv.visitors.document.objects.PathItem.fixedFields.$ref,summary:Dv.visitors.document.objects.PathItem.fixedFields.summary,description:Dv.visitors.document.objects.PathItem.fixedFields.description,get:{$ref:"#/visitors/document/objects/Operation"},put:{$ref:"#/visitors/document/objects/Operation"},post:{$ref:"#/visitors/document/objects/Operation"},delete:{$ref:"#/visitors/document/objects/Operation"},options:{$ref:"#/visitors/document/objects/Operation"},head:{$ref:"#/visitors/document/objects/Operation"},patch:{$ref:"#/visitors/document/objects/Operation"},trace:{$ref:"#/visitors/document/objects/Operation"},servers:Dv.visitors.document.objects.PathItem.fixedFields.servers,parameters:Dv.visitors.document.objects.PathItem.fixedFields.parameters}},Operation:{$visitor:qE,fixedFields:{tags:Dv.visitors.document.objects.Operation.fixedFields.tags,summary:Dv.visitors.document.objects.Operation.fixedFields.summary,description:Dv.visitors.document.objects.Operation.fixedFields.description,externalDocs:{$ref:"#/visitors/document/objects/ExternalDocumentation"},operationId:Dv.visitors.document.objects.Operation.fixedFields.operationId,parameters:Dv.visitors.document.objects.Operation.fixedFields.parameters,requestBody:Dv.visitors.document.objects.Operation.fixedFields.requestBody,responses:{$ref:"#/visitors/document/objects/Responses"},callbacks:Dv.visitors.document.objects.Operation.fixedFields.callbacks,deprecated:Dv.visitors.document.objects.Operation.fixedFields.deprecated,security:Dv.visitors.document.objects.Operation.fixedFields.security,servers:Dv.visitors.document.objects.Operation.fixedFields.servers}},ExternalDocumentation:{$visitor:AE,fixedFields:{description:Dv.visitors.document.objects.ExternalDocumentation.fixedFields.description,url:Dv.visitors.document.objects.ExternalDocumentation.fixedFields.url}},Parameter:{$visitor:N_,fixedFields:{name:Dv.visitors.document.objects.Parameter.fixedFields.name,in:Dv.visitors.document.objects.Parameter.fixedFields.in,description:Dv.visitors.document.objects.Parameter.fixedFields.description,required:Dv.visitors.document.objects.Parameter.fixedFields.required,deprecated:Dv.visitors.document.objects.Parameter.fixedFields.deprecated,allowEmptyValue:Dv.visitors.document.objects.Parameter.fixedFields.allowEmptyValue,style:Dv.visitors.document.objects.Parameter.fixedFields.style,explode:Dv.visitors.document.objects.Parameter.fixedFields.explode,allowReserved:Dv.visitors.document.objects.Parameter.fixedFields.allowReserved,schema:{$ref:"#/visitors/document/objects/Schema"},example:Dv.visitors.document.objects.Parameter.fixedFields.example,examples:Dv.visitors.document.objects.Parameter.fixedFields.examples,content:Dv.visitors.document.objects.Parameter.fixedFields.content}},RequestBody:{$visitor:NE,fixedFields:{description:Dv.visitors.document.objects.RequestBody.fixedFields.description,content:Dv.visitors.document.objects.RequestBody.fixedFields.content,required:Dv.visitors.document.objects.RequestBody.fixedFields.required}},MediaType:{$visitor:w_,fixedFields:{schema:{$ref:"#/visitors/document/objects/Schema"},example:Dv.visitors.document.objects.MediaType.fixedFields.example,examples:Dv.visitors.document.objects.MediaType.fixedFields.examples,encoding:Dv.visitors.document.objects.MediaType.fixedFields.encoding}},Encoding:{$visitor:jE,fixedFields:{contentType:Dv.visitors.document.objects.Encoding.fixedFields.contentType,headers:Dv.visitors.document.objects.Encoding.fixedFields.headers,style:Dv.visitors.document.objects.Encoding.fixedFields.style,explode:Dv.visitors.document.objects.Encoding.fixedFields.explode,allowReserved:Dv.visitors.document.objects.Encoding.fixedFields.allowReserved}},Responses:{$visitor:BE,fixedFields:{default:Dv.visitors.document.objects.Responses.fixedFields.default}},Response:{$visitor:LE,fixedFields:{description:Dv.visitors.document.objects.Response.fixedFields.description,headers:Dv.visitors.document.objects.Response.fixedFields.headers,content:Dv.visitors.document.objects.Response.fixedFields.content,links:Dv.visitors.document.objects.Response.fixedFields.links}},Callback:{$visitor:RE},Example:{$visitor:kE,fixedFields:{summary:Dv.visitors.document.objects.Example.fixedFields.summary,description:Dv.visitors.document.objects.Example.fixedFields.description,value:Dv.visitors.document.objects.Example.fixedFields.value,externalValue:Dv.visitors.document.objects.Example.fixedFields.externalValue}},Link:{$visitor:m_,fixedFields:{operationRef:Dv.visitors.document.objects.Link.fixedFields.operationRef,operationId:Dv.visitors.document.objects.Link.fixedFields.operationId,parameters:Dv.visitors.document.objects.Link.fixedFields.parameters,requestBody:Dv.visitors.document.objects.Link.fixedFields.requestBody,description:Dv.visitors.document.objects.Link.fixedFields.description,server:{$ref:"#/visitors/document/objects/Server"}}},Header:{$visitor:R_,fixedFields:{description:Dv.visitors.document.objects.Header.fixedFields.description,required:Dv.visitors.document.objects.Header.fixedFields.required,deprecated:Dv.visitors.document.objects.Header.fixedFields.deprecated,allowEmptyValue:Dv.visitors.document.objects.Header.fixedFields.allowEmptyValue,style:Dv.visitors.document.objects.Header.fixedFields.style,explode:Dv.visitors.document.objects.Header.fixedFields.explode,allowReserved:Dv.visitors.document.objects.Header.fixedFields.allowReserved,schema:{$ref:"#/visitors/document/objects/Schema"},example:Dv.visitors.document.objects.Header.fixedFields.example,examples:Dv.visitors.document.objects.Header.fixedFields.examples,content:Dv.visitors.document.objects.Header.fixedFields.content}},Tag:{$visitor:j_,fixedFields:{name:Dv.visitors.document.objects.Tag.fixedFields.name,description:Dv.visitors.document.objects.Tag.fixedFields.description,externalDocs:{$ref:"#/visitors/document/objects/ExternalDocumentation"}}},Reference:{$visitor:I_,fixedFields:{$ref:Dv.visitors.document.objects.Reference.fixedFields.$ref,summary:{$ref:"#/visitors/value"},description:{$ref:"#/visitors/value"}}},JSONSchema:{$ref:"#/visitors/document/objects/Schema"},LinkDescription:{...ZE},Schema:{$visitor:cE,fixedFields:{...QE.fixedFields,$defs:lE,allOf:uE,anyOf:pE,oneOf:hE,not:{$ref:"#/visitors/document/objects/Schema"},if:{$ref:"#/visitors/document/objects/Schema"},then:{$ref:"#/visitors/document/objects/Schema"},else:{$ref:"#/visitors/document/objects/Schema"},dependentSchemas:dE,prefixItems:fE,items:{$ref:"#/visitors/document/objects/Schema"},contains:{$ref:"#/visitors/document/objects/Schema"},properties:mE,patternProperties:gE,additionalProperties:{$ref:"#/visitors/document/objects/Schema"},propertyNames:{$ref:"#/visitors/document/objects/Schema"},unevaluatedItems:{$ref:"#/visitors/document/objects/Schema"},unevaluatedProperties:{$ref:"#/visitors/document/objects/Schema"},contentSchema:{$ref:"#/visitors/document/objects/Schema"},discriminator:{$ref:"#/visitors/document/objects/Discriminator"},xml:{$ref:"#/visitors/document/objects/XML"},externalDocs:{$ref:"#/visitors/document/objects/ExternalDocumentation"},example:{$ref:"#/visitors/value"}}},Discriminator:{$visitor:vE,fixedFields:{propertyName:Dv.visitors.document.objects.Discriminator.fixedFields.propertyName,mapping:Dv.visitors.document.objects.Discriminator.fixedFields.mapping}},XML:{$visitor:SE,fixedFields:{name:Dv.visitors.document.objects.XML.fixedFields.name,namespace:Dv.visitors.document.objects.XML.fixedFields.namespace,prefix:Dv.visitors.document.objects.XML.fixedFields.prefix,attribute:Dv.visitors.document.objects.XML.fixedFields.attribute,wrapped:Dv.visitors.document.objects.XML.fixedFields.wrapped}},SecurityScheme:{$visitor:WE,fixedFields:{type:Dv.visitors.document.objects.SecurityScheme.fixedFields.type,description:Dv.visitors.document.objects.SecurityScheme.fixedFields.description,name:Dv.visitors.document.objects.SecurityScheme.fixedFields.name,in:Dv.visitors.document.objects.SecurityScheme.fixedFields.in,scheme:Dv.visitors.document.objects.SecurityScheme.fixedFields.scheme,bearerFormat:Dv.visitors.document.objects.SecurityScheme.fixedFields.bearerFormat,flows:{$ref:"#/visitors/document/objects/OAuthFlows"},openIdConnectUrl:Dv.visitors.document.objects.SecurityScheme.fixedFields.openIdConnectUrl}},OAuthFlows:{$visitor:HE,fixedFields:{implicit:{$ref:"#/visitors/document/objects/OAuthFlow"},password:{$ref:"#/visitors/document/objects/OAuthFlow"},clientCredentials:{$ref:"#/visitors/document/objects/OAuthFlow"},authorizationCode:{$ref:"#/visitors/document/objects/OAuthFlow"}}},OAuthFlow:{$visitor:GE,fixedFields:{authorizationUrl:Dv.visitors.document.objects.OAuthFlow.fixedFields.authorizationUrl,tokenUrl:Dv.visitors.document.objects.OAuthFlow.fixedFields.tokenUrl,refreshUrl:Dv.visitors.document.objects.OAuthFlow.fixedFields.refreshUrl,scopes:Dv.visitors.document.objects.OAuthFlow.fixedFields.scopes}},SecurityRequirement:{$visitor:k_}},extension:{$visitor:Dv.visitors.document.extension.$visitor}}}},apidom_ns_openapi_3_1_src_traversal_visitor_getNodeType=s=>{if(Su(s))return`${s.element.charAt(0).toUpperCase()+s.element.slice(1)}Element`},tw={CallbackElement:["content"],ComponentsElement:["content"],ContactElement:["content"],DiscriminatorElement:["content"],Encoding:["content"],Example:["content"],ExternalDocumentationElement:["content"],HeaderElement:["content"],InfoElement:["content"],LicenseElement:["content"],MediaTypeElement:["content"],OAuthFlowElement:["content"],OAuthFlowsElement:["content"],OpenApi3_1Element:["content"],OperationElement:["content"],ParameterElement:["content"],PathItemElement:["content"],PathsElement:["content"],ReferenceElement:["content"],RequestBodyElement:["content"],ResponseElement:["content"],ResponsesElement:["content"],SchemaElement:["content"],SecurityRequirementElement:["content"],SecuritySchemeElement:["content"],ServerElement:["content"],ServerVariableElement:["content"],TagElement:["content"],...Gu},rw={namespace:s=>{const{base:o}=s;return o.register("callback",$v),o.register("components",qv),o.register("contact",Uv),o.register("discriminator",Vv),o.register("encoding",zv),o.register("example",Wv),o.register("externalDocumentation",Jv),o.register("header",Hv),o.register("info",Kv),o.register("jsonSchemaDialect",Gv),o.register("license",Yv),o.register("link",Xv),o.register("mediaType",Qv),o.register("oAuthFlow",Zv),o.register("oAuthFlows",eb),o.register("openapi",tb),o.register("openApi3_1",nb),o.register("operation",pb),o.register("parameter",mb),o.register("pathItem",yb),o.register("paths",Sb),o.register("reference",_b),o.register("requestBody",wb),o.register("response",Ob),o.register("responses",Ab),o.register("schema",e_),o.register("securityRequirement",t_),o.register("securityScheme",r_),o.register("server",n_),o.register("serverVariable",s_),o.register("tag",o_),o.register("xml",i_),o}},nw=rw,ancestorLineageToJSONPointer=s=>{const o=s.reduce(((o,i,a)=>{if(Au(i)){const s=String(serializers_value(i.key));o.push(s)}else if(Ou(s[a-2])){const u=String(s[a-2].content.indexOf(i));o.push(u)}return o}),[]);return es_compile(o)},apidom_ns_openapi_3_1_src_refractor_toolbox=()=>{const s=createNamespace(nw);return{predicates:{...ye,isElement:Su,isStringElement:_u,isArrayElement:Ou,isObjectElement:ku,isMemberElement:Au,isServersElement:Gm,includesClasses,hasElementSourceMap},ancestorLineageToJSONPointer,namespace:s}},apidom_ns_openapi_3_1_src_refractor_refract=(s,{specPath:o=["visitors","document","objects","OpenApi","$visitor"],plugins:i=[]}={})=>{const a=(0,du.e)(s),u=dereference(ew),_=new(zu(o,u))({specObj:u});return visitor_visit(a,_),dispatchPluginsSync(_.element,i,{toolboxCreator:apidom_ns_openapi_3_1_src_refractor_toolbox,visitorOptions:{keyMap:tw,nodeTypeGetter:apidom_ns_openapi_3_1_src_traversal_visitor_getNodeType}})},apidom_ns_openapi_3_1_src_refractor_createRefractor=s=>(o,i={})=>apidom_ns_openapi_3_1_src_refractor_refract(o,{specPath:s,...i});$v.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Callback","$visitor"]),qv.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Components","$visitor"]),Uv.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Contact","$visitor"]),Wv.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Example","$visitor"]),Vv.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Discriminator","$visitor"]),zv.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Encoding","$visitor"]),Jv.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","ExternalDocumentation","$visitor"]),Hv.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Header","$visitor"]),Kv.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Info","$visitor"]),Gv.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","OpenApi","fixedFields","jsonSchemaDialect"]),Yv.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","License","$visitor"]),Xv.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Link","$visitor"]),Qv.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","MediaType","$visitor"]),Zv.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","OAuthFlow","$visitor"]),eb.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","OAuthFlows","$visitor"]),tb.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","OpenApi","fixedFields","openapi"]),nb.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","OpenApi","$visitor"]),pb.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Operation","$visitor"]),mb.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Parameter","$visitor"]),yb.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","PathItem","$visitor"]),Sb.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Paths","$visitor"]),_b.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Reference","$visitor"]),wb.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","RequestBody","$visitor"]),Ob.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Response","$visitor"]),Ab.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Responses","$visitor"]),e_.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Schema","$visitor"]),t_.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","SecurityRequirement","$visitor"]),r_.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","SecurityScheme","$visitor"]),n_.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Server","$visitor"]),s_.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","ServerVariable","$visitor"]),o_.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","Tag","$visitor"]),i_.refract=apidom_ns_openapi_3_1_src_refractor_createRefractor(["visitors","document","objects","XML","$visitor"]);const sw=class NotImplementedError extends Dh{};const ow=class MediaTypes extends Array{unknownMediaType="application/octet-stream";filterByFormat(){throw new sw("filterByFormat method in MediaTypes class is not yet implemented.")}findBy(){throw new sw("findBy method in MediaTypes class is not yet implemented.")}latest(){throw new sw("latest method in MediaTypes class is not yet implemented.")}};class OpenAPIMediaTypes extends ow{filterByFormat(s="generic"){const o="generic"===s?"openapi;version":s;return this.filter((s=>s.includes(o)))}findBy(s="3.1.0",o="generic"){const i="generic"===o?`vnd.oai.openapi;version=${s}`:`vnd.oai.openapi+${o};version=${s}`;return this.find((s=>s.includes(i)))||this.unknownMediaType}latest(s="generic"){return ca(this.filterByFormat(s))}}const iw=new OpenAPIMediaTypes("application/vnd.oai.openapi;version=3.1.0","application/vnd.oai.openapi+json;version=3.1.0","application/vnd.oai.openapi+yaml;version=3.1.0");const aw=class src_Reference_Reference{uri;depth;value;refSet;errors;constructor({uri:s,depth:o=0,refSet:i,value:a}){this.uri=s,this.value=a,this.depth=o,this.refSet=i,this.errors=[]}};const cw=class ReferenceSet{rootRef;refs;circular;constructor({refs:s=[],circular:o=!1}={}){this.refs=[],this.circular=o,s.forEach(this.add.bind(this))}get size(){return this.refs.length}add(s){return this.has(s)||(this.refs.push(s),this.rootRef=void 0===this.rootRef?s:this.rootRef,s.refSet=this),this}merge(s){for(const o of s.values())this.add(o);return this}has(s){const o=Rc(s)?s:s.uri;return dc(this.find((s=>s.uri===o)))}find(s){return this.refs.find(s)}*values(){yield*this.refs}clean(){this.refs.forEach((s=>{s.refSet=void 0})),this.rootRef=void 0,this.refs.length=0}};function _identity(s){return s}const lw=_curry1(_identity),uw={parse:{mediaType:"text/plain",parsers:[],parserOpts:{}},resolve:{baseURI:"",resolvers:[],resolverOpts:{},strategies:[],strategyOpts:{},internal:!0,external:!0,maxDepth:1/0},dereference:{strategies:[],strategyOpts:{},refSet:null,maxDepth:1/0,circular:"ignore",circularReplacer:lw,immutable:!0,dereferenceOpts:{}},bundle:{strategies:[],refSet:null,maxDepth:1/0}};const pw=_curry2((function lens(s,o){return function(i){return function(a){return sc((function(s){return o(s,a)}),i(s(a)))}}}));var Identity=function(s){return{value:s,map:function(o){return Identity(o(s))}}},hw=_curry3((function over(s,o,i){return s((function(s){return Identity(o(s))}))(i).value}));const dw=hw;const fw=ka(""),mw=pw(zu(["resolve","baseURI"]),Rb(["resolve","baseURI"])),baseURIDefault=s=>fw(s)?url_cwd():s,util_merge=(s,o)=>{const i=tp(s,o);return dw(mw,baseURIDefault,i)};const gw=class File_File{uri;mediaType;data;parseResult;constructor({uri:s,mediaType:o="text/plain",data:i,parseResult:a}){this.uri=s,this.mediaType=o,this.data=i,this.parseResult=a}get extension(){return Rc(this.uri)?(s=>{const o=s.lastIndexOf(".");return o>=0?s.substring(o).toLowerCase():""})(this.uri):""}toString(){if("string"==typeof this.data)return this.data;if(this.data instanceof ArrayBuffer||["ArrayBuffer"].includes(xa(this.data))||ArrayBuffer.isView(this.data)){return new TextDecoder("utf-8").decode(this.data)}return String(this.data)}};const yw=class PluginError extends Ko{plugin;constructor(s,o){super(s,{cause:o.cause}),this.plugin=o.plugin}},plugins_filter=async(s,o,i)=>{const a=await Promise.all(i.map(hp([s],o)));return i.filter(((s,o)=>a[o]))},run=async(s,o,i)=>{let a;for(const u of i)try{const i=await u[s].call(u,...o);return{plugin:u,result:i}}catch(s){a=new yw("Error while running plugin",{cause:s,plugin:u})}return Promise.reject(a)};const vw=class DereferenceError extends Ko{};const bw=class UnmatchedDereferenceStrategyError extends vw{};const dereferenceApiDOM=async(s,o)=>{let i=s,a=!1;if(!Tu(s)){const o=cloneShallow(s);o.classes.push("result"),i=new bu([o]),a=!0}const u=new gw({uri:o.resolve.baseURI,parseResult:i,mediaType:o.parse.mediaType}),_=await plugins_filter("canDereference",[u,o],o.dereference.strategies);if(cp(_))throw new bw(u.uri);try{const{result:s}=await run("dereference",[u,o],_);return a?s.get(0):s}catch(s){throw new vw(`Error while dereferencing file "${u.uri}"`,{cause:s})}};const Sw=class ParseError extends Ko{};const _w=class ParserError extends Sw{};const Ew=class Parser_Parser{name;allowEmpty;sourceMap;fileExtensions;mediaTypes;constructor({name:s,allowEmpty:o=!0,sourceMap:i=!1,fileExtensions:a=[],mediaTypes:u=[]}){this.name=s,this.allowEmpty=o,this.sourceMap=i,this.fileExtensions=a,this.mediaTypes=u}};const ww=class BinaryParser extends Ew{constructor(s){super({...null!=s?s:{},name:"binary"})}canParse(s){return 0===this.fileExtensions.length||this.fileExtensions.includes(s.extension)}parse(s){try{const o=unescape(encodeURIComponent(s.toString())),i=btoa(o),a=new bu;if(0!==i.length){const s=new du.Om(i);s.classes.push("result"),a.push(s)}return a}catch(o){throw new _w(`Error parsing "${s.uri}"`,{cause:o})}}};const xw=class ResolveStrategy{name;constructor({name:s}){this.name=s}};const kw=class OpenAPI3_1ResolveStrategy extends xw{constructor(s){super({...null!=s?s:{},name:"openapi-3-1"})}canResolve(s,o){const i=o.dereference.strategies.find((s=>"openapi-3-1"===s.name));return void 0!==i&&i.canDereference(s,o)}async resolve(s,o){const i=o.dereference.strategies.find((s=>"openapi-3-1"===s.name));if(void 0===i)throw new bw('"openapi-3-1" dereference strategy is not available.');const a=new cw,u=util_merge(o,{resolve:{internal:!1},dereference:{refSet:a}});return await i.dereference(s,u),a}};const Ow=class Resolver{name;constructor({name:s}){this.name=s}};const Aw=class HTTPResolver extends Ow{timeout;redirects;withCredentials;constructor(s){const{name:o="http-resolver",timeout:i=5e3,redirects:a=5,withCredentials:u=!1}=null!=s?s:{};super({name:o}),this.timeout=i,this.redirects=a,this.withCredentials=u}canRead(s){return isHttpUrl(s.uri)}};const Cw=class ResolveError extends Ko{};const jw=class ResolverError extends Cw{},{AbortController:Pw,AbortSignal:Iw}=globalThis;void 0===globalThis.AbortController&&(globalThis.AbortController=Pw),void 0===globalThis.AbortSignal&&(globalThis.AbortSignal=Iw);const Tw=class HTTPResolverSwaggerClient extends Aw{swaggerHTTPClient=http_http;swaggerHTTPClientConfig;constructor({swaggerHTTPClient:s=http_http,swaggerHTTPClientConfig:o={},...i}={}){super({...i,name:"http-swagger-client"}),this.swaggerHTTPClient=s,this.swaggerHTTPClientConfig=o}getHttpClient(){return this.swaggerHTTPClient}async read(s){const o=this.getHttpClient(),i=new AbortController,{signal:a}=i,u=setTimeout((()=>{i.abort()}),this.timeout),_=this.getHttpClient().withCredentials||this.withCredentials?"include":"same-origin",w=0===this.redirects?"error":"follow",x=this.redirects>0?this.redirects:void 0;try{return(await o({url:s.uri,signal:a,userFetch:async(s,o)=>{let i=await fetch(s,o);try{i.headers.delete("Content-Type")}catch{i=new Response(i.body,{...i,headers:new Headers(i.headers)}),i.headers.delete("Content-Type")}return i},credentials:_,redirect:w,follow:x,...this.swaggerHTTPClientConfig})).text.arrayBuffer()}catch(o){throw new jw(`Error downloading "${s.uri}"`,{cause:o})}finally{clearTimeout(u)}}},transformers_from=(s,o=fp)=>{if(Rc(s))try{return o.fromRefract(JSON.parse(s))}catch{}return iu(s)&&Uu("element",s)?o.fromRefract(s):o.toElement(s)};const Nw=class JSONParser extends Ew{constructor(s={}){super({name:"json-swagger-client",mediaTypes:["application/json"],...s})}async canParse(s){var o,i;const a=0===this.fileExtensions.length||tl()(o=this.fileExtensions).call(o,s.extension),u=tl()(i=this.mediaTypes).call(i,s.mediaType);if(!a)return!1;if(u)return!0;if(!u)try{return JSON.parse(s.toString()),!0}catch(s){return!1}return!1}async parse(s){if(this.sourceMap)throw new _w("json-swagger-client parser plugin doesn't support sourceMaps option");const o=new bu,i=s.toString();if(this.allowEmpty&&""===i.trim())return o;try{const s=transformers_from(JSON.parse(i));return s.classes.push("result"),o.push(s),o}catch(o){throw new _w(`Error parsing "${s.uri}"`,{cause:o})}}};const Mw=class YAMLParser extends Ew{constructor(s={}){super({name:"yaml-1-2-swagger-client",mediaTypes:["text/yaml","application/yaml"],...s})}async canParse(s){var o,i;const a=0===this.fileExtensions.length||tl()(o=this.fileExtensions).call(o,s.extension),u=tl()(i=this.mediaTypes).call(i,s.mediaType);if(!a)return!1;if(u)return!0;if(!u)try{return fn.load(s.toString(),{schema:rn}),!0}catch(s){return!1}return!1}async parse(s){if(this.sourceMap)throw new _w("yaml-1-2-swagger-client parser plugin doesn't support sourceMaps option");const o=new bu,i=s.toString();try{const s=fn.load(i,{schema:rn});if(this.allowEmpty&&void 0===s)return o;const a=transformers_from(s);return a.classes.push("result"),o.push(a),o}catch(o){throw new _w(`Error parsing "${s.uri}"`,{cause:o})}}};const Rw=class OpenAPIJSON3_1Parser extends Ew{detectionRegExp=/"openapi"\s*:\s*"(?<version_json>3\.1\.(?:[1-9]\d*|0))"/;constructor(s={}){super({name:"openapi-json-3-1-swagger-client",mediaTypes:new OpenAPIMediaTypes(...iw.filterByFormat("generic"),...iw.filterByFormat("json")),...s})}async canParse(s){var o,i;const a=0===this.fileExtensions.length||tl()(o=this.fileExtensions).call(o,s.extension),u=tl()(i=this.mediaTypes).call(i,s.mediaType);if(!a)return!1;if(u)return!0;if(!u)try{const o=s.toString();return JSON.parse(o),this.detectionRegExp.test(o)}catch(s){return!1}return!1}async parse(s){if(this.sourceMap)throw new _w("openapi-json-3-1-swagger-client parser plugin doesn't support sourceMaps option");const o=new bu,i=s.toString();if(this.allowEmpty&&""===i.trim())return o;try{const s=JSON.parse(i),a=nb.refract(s,this.refractorOpts);return a.classes.push("result"),o.push(a),o}catch(o){throw new _w(`Error parsing "${s.uri}"`,{cause:o})}}};const Dw=class OpenAPIYAML31Parser extends Ew{detectionRegExp=/(?<YAML>^(["']?)openapi\2\s*:\s*(["']?)(?<version_yaml>3\.1\.(?:[1-9]\d*|0))\3(?:\s+|$))|(?<JSON>"openapi"\s*:\s*"(?<version_json>3\.1\.(?:[1-9]\d*|0))")/m;constructor(s={}){super({name:"openapi-yaml-3-1-swagger-client",mediaTypes:new OpenAPIMediaTypes(...iw.filterByFormat("generic"),...iw.filterByFormat("yaml")),...s})}async canParse(s){var o,i;const a=0===this.fileExtensions.length||tl()(o=this.fileExtensions).call(o,s.extension),u=tl()(i=this.mediaTypes).call(i,s.mediaType);if(!a)return!1;if(u)return!0;if(!u)try{const o=s.toString();return fn.load(o),this.detectionRegExp.test(o)}catch(s){return!1}return!1}async parse(s){if(this.sourceMap)throw new _w("openapi-yaml-3-1-swagger-client parser plugin doesn't support sourceMaps option");const o=new bu,i=s.toString();try{const s=fn.load(i,{schema:rn});if(this.allowEmpty&&void 0===s)return o;const a=nb.refract(s,this.refractorOpts);return a.classes.push("result"),o.push(a),o}catch(o){throw new _w(`Error parsing "${s.uri}"`,{cause:o})}}};const Lw=_curry3((function propEq(s,o,i){return ka(s,na(o,i))}));const Fw=class DereferenceStrategy{name;constructor({name:s}){this.name=s}};const Bw=_curry2((function none(s,o){return gu(_complement(s),o)}));var $w=__webpack_require__(8068);const qw=class ElementIdentityError extends Go{value;constructor(s,o){super(s,o),void 0!==o&&(this.value=o.value)}};class IdentityManager{uuid;identityMap;constructor({length:s=6}={}){this.uuid=new $w({length:s}),this.identityMap=new WeakMap}identify(s){if(!Su(s))throw new qw("Cannot not identify the element. `element` is neither structurally compatible nor a subclass of an Element class.",{value:s});if(s.meta.hasKey("id")&&_u(s.meta.get("id"))&&!s.meta.get("id").equals(""))return s.id;if(this.identityMap.has(s))return this.identityMap.get(s);const o=new du.Om(this.generateId());return this.identityMap.set(s,o),o}forget(s){return!!this.identityMap.has(s)&&(this.identityMap.delete(s),!0)}generateId(){return this.uuid.randomUUID()}}new IdentityManager;const Uw=_curry3((function pathOr(s,o,i){return ea(s,_path(o,i))})),traversal_find=(s,o)=>{const i=new PredicateVisitor({predicate:s,returnOnTrue:Nu});return visitor_visit(o,i),Uw(void 0,[0],i.result)};const Vw=class JsonSchema$anchorError extends Ko{};const zw=class EvaluationJsonSchema$anchorError extends Vw{};const Ww=class InvalidJsonSchema$anchorError extends Vw{constructor(s){super(`Invalid JSON Schema $anchor "${s}".`)}},isAnchor=s=>/^[A-Za-z_][A-Za-z_0-9.-]*$/.test(s),uriToAnchor=s=>{const o=getHash(s);return Hu("#",o)},$anchor_evaluate=(s,o)=>{const i=(s=>{if(!isAnchor(s))throw new Ww(s);return s})(s),a=traversal_find((s=>rE(s)&&serializers_value(s.$anchor)===i),o);if(hc(a))throw new zw(`Evaluation failed on token: "${i}"`);return a},traversal_filter=(s,o)=>{const i=new PredicateVisitor({predicate:s});return visitor_visit(o,i),new du.G6(i.result)};const Jw=class JsonSchemaUriError extends Ko{};const Hw=class EvaluationJsonSchemaUriError extends Jw{},resolveSchema$refField=(s,o)=>{if(void 0===o.$ref)return;const i=getHash(serializers_value(o.$ref)),a=serializers_value(o.meta.get("ancestorsSchemaIdentifiers")),u=Pi(((s,o)=>resolve(s,sanitize(stripHash(o)))),s,[...a,serializers_value(o.$ref)]);return`${u}${"#"===i?"":i}`},refractToSchemaElement=s=>{if(refractToSchemaElement.cache.has(s))return refractToSchemaElement.cache.get(s);const o=e_.refract(s);return refractToSchemaElement.cache.set(s,o),o};refractToSchemaElement.cache=new WeakMap;const maybeRefractToSchemaElement=s=>isPrimitiveElement(s)?refractToSchemaElement(s):s,uri_evaluate=(s,o)=>{const{cache:i}=uri_evaluate,a=stripHash(s),isSchemaElementWith$id=s=>rE(s)&&void 0!==s.$id;if(!i.has(o)){const s=traversal_filter(isSchemaElementWith$id,o);i.set(o,Array.from(s))}const u=i.get(o).find((s=>{const o=((s,o)=>{if(void 0===o.$id)return;const i=serializers_value(o.meta.get("ancestorsSchemaIdentifiers"));return Pi(((s,o)=>resolve(s,sanitize(stripHash(o)))),s,i)})(a,s);return o===a}));if(hc(u))throw new Hw(`Evaluation failed on URI: "${s}"`);return isAnchor(uriToAnchor(s))?$anchor_evaluate(uriToAnchor(s),u):apidom_evaluate(u,fromURIReference(s))};uri_evaluate.cache=new WeakMap;const Kw=class MaximumDereferenceDepthError extends vw{};const Gw=class MaximumResolveDepthError extends Cw{};const Yw=class UnmatchedResolverError extends jw{},Xw="apidom-file-cache",setCacheFileResult=async({cacheKey:s,result:o,error:i,cacheTTL:a})=>{if(0!==a)try{const a={cachedResult:o,cachedError:i,timestamp:Date.now()},u=await caches.open(Xw),_=new Response(JSON.stringify(a),{headers:{"Content-Type":"application/json"}});await u.put(s,_)}catch(s){console.error("CacheStorage is not available")}},util_readFile=async(s,o)=>{const{cacheTTL:i=0}=o.resolve.resolverOpts,a=`read_${s.uri}`,{cachedResult:u,cachedError:_}=await(async({cacheKey:s,cacheTTL:o})=>{if(0===o)return{cachedResult:null,cachedError:null};try{const i=await caches.open(Xw),a=await i.match(s);if(a){const{cachedResult:u,cachedError:_,timestamp:w}=await a.json();if(Date.now()-w<o)return{cachedResult:u,cachedError:_};await i.delete(s)}}catch(s){return console.log("There was an error parsing the response"),{cachedResult:null,cachedError:null}}return{cachedResult:null,cachedError:null}})({cacheKey:a,cacheTTL:i});if(null!==u)return u;if(null!==_)throw new Cw(`Error while reading file "${s.uri}"`,{cause:_});const w=o.resolve.resolvers.map((s=>{const i=Object.create(s);return Object.assign(i,o.resolve.resolverOpts)})),x=await plugins_filter("canRead",[s,o],w);if(cp(x))throw new Yw(s.uri);try{const{result:o}=await run("read",[s],x),u=new gw({...s,data:o}).toString();return await setCacheFileResult({cacheKey:a,result:u,error:null,cacheTTL:i}),o}catch(o){var C,j,L;throw await setCacheFileResult({cacheKey:a,result:null,error:null!==(C=null!==(j=null==o||null===(L=o.cause)||void 0===L?void 0:L.cause)&&void 0!==j?j:null==o?void 0:o.cause)&&void 0!==C?C:o,cacheTTL:i}),new Cw(`Error while reading file "${s.uri}"`,{cause:o})}},apidom_reference_src_parse=async(s,o)=>{const i=new gw({uri:sanitize(stripHash(s)),mediaType:o.parse.mediaType}),a=await util_readFile(i,o);return(async(s,o)=>{const i=o.parse.parsers.map((s=>{const i=Object.create(s);return Object.assign(i,o.parse.parserOpts)})),a=await plugins_filter("canParse",[s,o],i);if(cp(a))throw new Yw(s.uri);try{const{plugin:i,result:u}=await run("parse",[s,o],a);return!i.allowEmpty&&u.isEmpty?Promise.reject(new Sw(`Error while parsing file "${s.uri}". File is empty.`)):u}catch(o){throw new Sw(`Error while parsing file "${s.uri}"`,{cause:o})}})(new gw({...i,data:a}),o)};class AncestorLineage extends Array{includesCycle(s){return this.filter((o=>o.has(s))).length>1}includes(s,o){return s instanceof Set?super.includes(s,o):this.some((o=>o.has(s)))}findItem(s){for(const o of this)for(const i of o)if(Su(i)&&s(i))return i}}const Qw=visitor_visit[Symbol.for("nodejs.util.promisify.custom")],Zw=new IdentityManager,mutationReplacer=(s,o,i,a)=>{Au(a)?a.value=s:Array.isArray(a)&&(a[i]=s)};class OpenAPI3_1DereferenceVisitor{indirections;namespace;reference;options;ancestors;refractCache;allOfDiscriminatorMapping;constructor({reference:s,namespace:o,options:i,indirections:a=[],ancestors:u=new AncestorLineage,refractCache:_=new Map,allOfDiscriminatorMapping:w=new Map}){this.indirections=a,this.namespace=o,this.reference=s,this.options=i,this.ancestors=new AncestorLineage(...u),this.refractCache=_,this.allOfDiscriminatorMapping=w}handleDereferenceError(s,o,i){var a,u;if(null===(a=this.options.dereference.dereferenceOpts)||void 0===a||!a.continueOnError)throw s;if(i){const o=[...i].find((s=>ku(s)&&s.getMetaProperty("ref-referencing-element")));var _;if(o)null===(_=this.options.dereference.dereferenceOpts)||void 0===_||_.errors.push({error:s,refEl:o.getMetaProperty("ref-referencing-element")})}null===(u=this.options.dereference.dereferenceOpts)||void 0===u||u.errors.push({error:s,refEl:o})}getNestedVisitorOptions(s){var o,i;return{...this.options,resolve:{...this.options.resolve,external:(null===(o=this.options.dereference)||void 0===o||null===(o=o.dereferenceOpts)||void 0===o||!o.skipNestedExternal||!serializers_value(s.get("$ref")).startsWith("#"))&&this.options.resolve.external},dereference:{...this.options.dereference,dereferenceOpts:{...null===(i=this.options.dereference)||void 0===i?void 0:i.dereferenceOpts,continueOnError:!1}}}}toBaseURI(s){return resolve(this.reference.uri,sanitize(stripHash(s)))}async toReference(s){if(this.reference.depth>=this.options.resolve.maxDepth)throw new Gw(`Maximum resolution depth of ${this.options.resolve.maxDepth} has been exceeded by file "${this.reference.uri}"`);const o=this.toBaseURI(s),{refSet:i}=this.reference;if(i.has(o))return i.find(Lw(o,"uri"));const a=await apidom_reference_src_parse(unsanitize(o),{...this.options,parse:{...this.options.parse,mediaType:"text/plain"}}),u=new aw({uri:o,value:cloneDeep(a),depth:this.reference.depth+1});if(i.add(u),this.options.dereference.immutable){const s=new aw({uri:`immutable://${o}`,value:a,depth:this.reference.depth+1});i.add(s)}return u}toAncestorLineage(s){const o=new Set(s.filter(Su));return[new AncestorLineage(...this.ancestors,o),o]}OpenApi3_1Element={leave:(s,o,i,a,u,_)=>{var w;if(null===(w=this.options.dereference.strategyOpts["openapi-3-1"])||void 0===w||!w.dereferenceDiscriminatorMapping)return;const x=cloneShallow(s);return x.setMetaProperty("allOfDiscriminatorMapping",Object.fromEntries(this.allOfDiscriminatorMapping)),_.replaceWith(x,mutationReplacer),i?void 0:x}};async ReferenceElement(s,o,i,a,u,_){var w,x;if(this.indirections.includes(s))return!1;const[C,j]=this.toAncestorLineage([...u,i]),L=this.toBaseURI(serializers_value(s.$ref)),B=stripHash(this.reference.uri)===L,$=!B;if(!this.options.resolve.internal&&B)return!1;if(!this.options.resolve.external&&$)return!1;let U;try{U=await this.toReference(serializers_value(s.$ref))}catch(o){return this.handleDereferenceError(o,s,j)}const V=resolve(L,serializers_value(s.$ref));this.indirections.push(s);const z=fromURIReference(V);let Y;try{Y=apidom_evaluate(U.value.result,z)}catch(o){return this.indirections.pop(),this.handleDereferenceError(o,s,j)}if(Y.id=Zw.identify(Y),isPrimitiveElement(Y)){const o=serializers_value(s.meta.get("referenced-element")),i=`${o}-${serializers_value(Zw.identify(Y))}`;if(this.refractCache.has(i))Y=this.refractCache.get(i);else if(isReferenceLikeElement(Y))Y=_b.refract(Y),Y.setMetaProperty("referenced-element",o),this.refractCache.set(i,Y);else{Y=this.namespace.getElementClass(o).refract(Y),this.refractCache.set(i,Y)}}if(s===Y){const o=new Ko("Recursive Reference Object detected");return this.indirections.pop(),this.handleDereferenceError(o,s,j)}if(this.indirections.length>this.options.dereference.maxDepth){const o=new Kw(`Maximum dereference depth of "${this.options.dereference.maxDepth}" has been exceeded in file "${this.reference.uri}"`);return this.indirections.pop(),this.handleDereferenceError(o,s,j)}if(C.includes(Y)){if(U.refSet.circular=!0,"error"===this.options.dereference.circular){const o=new Ko("Circular reference detected");return this.indirections.pop(),this.handleDereferenceError(o,s,j)}if("replace"===this.options.dereference.circular){var Z,ee;const o=new du.sI(Y.id,{type:"reference",uri:U.uri,$ref:serializers_value(s.$ref)}),a=(null!==(Z=null===(ee=this.options.dereference.strategyOpts["openapi-3-1"])||void 0===ee?void 0:ee.circularReplacer)&&void 0!==Z?Z:this.options.dereference.circularReplacer)(o);return _.replaceWith(a,mutationReplacer),!i&&a}}const ie=stripHash(U.refSet.rootRef.uri)!==U.uri,ae=["error","replace"].includes(this.options.dereference.circular);if(($||ie||Q_(Y)||ae||null!==(w=this.options.dereference.dereferenceOpts)&&void 0!==w&&w.continueOnError)&&!C.includesCycle(Y)){j.add(s);const o=new OpenAPI3_1DereferenceVisitor({reference:U,namespace:this.namespace,indirections:[...this.indirections],options:this.getNestedVisitorOptions(s),refractCache:this.refractCache,ancestors:C,allOfDiscriminatorMapping:this.allOfDiscriminatorMapping});try{Y=await Qw(Y,o,{keyMap:tw,nodeTypeGetter:apidom_ns_openapi_3_1_src_traversal_visitor_getNodeType})}catch(o){return this.indirections.pop(),this.handleDereferenceError(o,s,j)}j.delete(s)}this.indirections.pop();const ce=cloneShallow(Y);return ce.setMetaProperty("id",Zw.generateId()),ce.setMetaProperty("ref-fields",{$ref:serializers_value(s.$ref),description:serializers_value(s.description),summary:serializers_value(s.summary)}),ce.setMetaProperty("ref-origin",U.uri),ce.setMetaProperty("ref-referencing-element-id",cloneDeep(Zw.identify(s))),null!==(x=this.options.dereference.dereferenceOpts)&&void 0!==x&&x.continueOnError&&ce.setMetaProperty("ref-referencing-element",s),ku(Y)&&ku(ce)&&(s.hasKey("description")&&"description"in Y&&(ce.remove("description"),ce.set("description",s.get("description"))),s.hasKey("summary")&&"summary"in Y&&(ce.remove("summary"),ce.set("summary",s.get("summary")))),_.replaceWith(ce,mutationReplacer),!i&&ce}async PathItemElement(s,o,i,a,u,_){var w;if(!_u(s.$ref))return;if(this.indirections.includes(s))return!1;const[x,C]=this.toAncestorLineage([...u,i]),j=this.toBaseURI(serializers_value(s.$ref)),L=stripHash(this.reference.uri)===j,B=!L;if(!this.options.resolve.internal&&L)return;if(!this.options.resolve.external&&B)return;let $;try{$=await this.toReference(serializers_value(s.$ref))}catch(o){return this.handleDereferenceError(o,s,C)}const U=resolve(j,serializers_value(s.$ref));this.indirections.push(s);const V=fromURIReference(U);let z;try{z=apidom_evaluate($.value.result,V)}catch(o){return this.indirections.pop(),this.handleDereferenceError(o,s,C)}if(z.id=Zw.identify(z),isPrimitiveElement(z)){const s=`path-item-${serializers_value(Zw.identify(z))}`;this.refractCache.has(s)?z=this.refractCache.get(s):(z=yb.refract(z),this.refractCache.set(s,z))}if(s===z){const o=new Ko("Recursive Path Item Object reference detected");return this.indirections.pop(),this.handleDereferenceError(o,s,C)}if(this.indirections.length>this.options.dereference.maxDepth){const o=new Kw(`Maximum dereference depth of "${this.options.dereference.maxDepth}" has been exceeded in file "${this.reference.uri}"`);return this.indirections.pop(),this.handleDereferenceError(o,s,C)}if(x.includes(z)){if($.refSet.circular=!0,"error"===this.options.dereference.circular){const o=new Ko("Circular reference detected");return this.indirections.pop(),this.handleDereferenceError(o,s,C)}if("replace"===this.options.dereference.circular){var Y,Z;const o=new du.sI(z.id,{type:"path-item",uri:$.uri,$ref:serializers_value(s.$ref)}),a=(null!==(Y=null===(Z=this.options.dereference.strategyOpts["openapi-3-1"])||void 0===Z?void 0:Z.circularReplacer)&&void 0!==Y?Y:this.options.dereference.circularReplacer)(o);return _.replaceWith(a,mutationReplacer),!i&&a}}const ee=stripHash($.refSet.rootRef.uri)!==$.uri,ie=["error","replace"].includes(this.options.dereference.circular);if((B||ee||Y_(z)&&_u(z.$ref)||ie||null!==(w=this.options.dereference.dereferenceOpts)&&void 0!==w&&w.continueOnError)&&!x.includesCycle(z)){C.add(s);const o=new OpenAPI3_1DereferenceVisitor({reference:$,namespace:this.namespace,indirections:[...this.indirections],options:this.getNestedVisitorOptions(s),refractCache:this.refractCache,ancestors:x,allOfDiscriminatorMapping:this.allOfDiscriminatorMapping});try{z=await Qw(z,o,{keyMap:tw,nodeTypeGetter:apidom_ns_openapi_3_1_src_traversal_visitor_getNodeType})}catch(o){return this.indirections.pop(),this.handleDereferenceError(o,s,C)}C.delete(s)}if(this.indirections.pop(),Y_(z)){var ae;const o=new yb([...z.content],cloneDeep(z.meta),cloneDeep(z.attributes));o.setMetaProperty("id",Zw.generateId()),s.forEach(((s,i,a)=>{o.remove(serializers_value(i)),o.content.push(a)})),o.remove("$ref"),o.setMetaProperty("ref-fields",{$ref:serializers_value(s.$ref)}),o.setMetaProperty("ref-origin",$.uri),o.setMetaProperty("ref-referencing-element-id",cloneDeep(Zw.identify(s))),null!==(ae=this.options.dereference.dereferenceOpts)&&void 0!==ae&&ae.continueOnError&&o.setMetaProperty("ref-referencing-element",s),z=o}return _.replaceWith(z,mutationReplacer),i?void 0:z}async LinkElement(s,o,i,a,u,_){if(!_u(s.operationRef)&&!_u(s.operationId))return;if(_u(s.operationRef)&&_u(s.operationId)){const o=new Ko("LinkElement operationRef and operationId fields are mutually exclusive.");return this.handleDereferenceError(o,s)}let w;if(_u(s.operationRef)){var x;const o=fromURIReference(serializers_value(s.operationRef)),a=this.toBaseURI(serializers_value(s.operationRef)),u=stripHash(this.reference.uri)===a,C=!u;if(!this.options.resolve.internal&&u)return;if(!this.options.resolve.external&&C)return;let j;try{j=await this.toReference(serializers_value(s.operationRef)),w=apidom_evaluate(j.value.result,o)}catch(o){return this.handleDereferenceError(o,s)}if(isPrimitiveElement(w)){const s=`operation-${serializers_value(Zw.identify(w))}`;this.refractCache.has(s)?w=this.refractCache.get(s):(w=pb.refract(w),this.refractCache.set(s,w))}w=cloneShallow(w),w.setMetaProperty("ref-origin",j.uri);const L=cloneShallow(s);return null===(x=L.operationRef)||void 0===x||x.meta.set("operation",w),_.replaceWith(L,mutationReplacer),i?void 0:L}if(_u(s.operationId)){var C;const o=serializers_value(s.operationId);let a;try{a=await this.toReference(unsanitize(this.reference.uri))}catch(o){return this.handleDereferenceError(o,s)}if(w=traversal_find((s=>K_(s)&&Su(s.operationId)&&s.operationId.equals(o)),a.value.result),hc(w)){const i=new Ko(`OperationElement(operationId=${o}) not found.`);return this.handleDereferenceError(i,s)}const u=cloneShallow(s);return null===(C=u.operationId)||void 0===C||C.meta.set("operation",w),_.replaceWith(u,mutationReplacer),i?void 0:u}}async ExampleElement(s,o,i,a,u,_){if(!_u(s.externalValue))return;if(s.hasKey("value")&&_u(s.externalValue)){const o=new Ko("ExampleElement value and externalValue fields are mutually exclusive.");return this.handleDereferenceError(o,s)}const w=this.toBaseURI(serializers_value(s.externalValue)),x=stripHash(this.reference.uri)===w,C=!x;if(!this.options.resolve.internal&&x)return;if(!this.options.resolve.external&&C)return;let j;try{j=await this.toReference(serializers_value(s.externalValue))}catch(o){return this.handleDereferenceError(o,s)}const L=cloneShallow(j.value.result);L.setMetaProperty("ref-origin",j.uri);const B=cloneShallow(s);return B.value=L,_.replaceWith(B,mutationReplacer),i?void 0:B}async MemberElement(s,o,i,a,u,_){var w;const x=u[u.length-1];if(!ku(x)||!x.classes.contains("discriminator-mapping"))return;if(null===(w=this.options.dereference.strategyOpts["openapi-3-1"])||void 0===w||!w.dereferenceDiscriminatorMapping)return!1;if(!_u(s.key)||!_u(s.value))return!1;if(this.indirections.includes(s))return!1;this.indirections.push(s);const[C,j]=this.toAncestorLineage([...u,i]),L=[...j].findLast(rE),B=cloneDeep(L.getMetaProperty("ancestorsSchemaIdentifiers")),$=serializers_value(s.value),U=/^[a-zA-Z0-9\\.\\-_]+$/.test($)?`#/components/schemas/${$}`:$,V=new e_({$ref:U});V.setMetaProperty("ancestorsSchemaIdentifiers",B),j.add(V);const z=new OpenAPI3_1DereferenceVisitor({reference:this.reference,namespace:this.namespace,indirections:[...this.indirections],options:this.getNestedVisitorOptions(V),refractCache:this.refractCache,ancestors:C,allOfDiscriminatorMapping:this.allOfDiscriminatorMapping});let Y;try{Y=await Qw(V,z,{keyMap:tw,nodeTypeGetter:apidom_ns_openapi_3_1_src_traversal_visitor_getNodeType})}catch(s){return this.handleDereferenceError(s,V,j)}j.delete(V),this.indirections.pop();const Z=cloneShallow(s);return Z.value.setMetaProperty("ref-schema",Y),_.replaceWith(Z,mutationReplacer),i?void 0:Z}async SchemaElement(s,o,i,a,u,_){var w;if(!_u(s.$ref))return;if(this.indirections.includes(s))return!1;const[x,C]=this.toAncestorLineage([...u,i]);let j;try{j=await this.toReference(unsanitize(this.reference.uri))}catch(o){return this.handleDereferenceError(o,s,C)}let{uri:L}=j;const B=resolveSchema$refField(L,s),$=stripHash(B),U=new gw({uri:$}),V=Bw((s=>s.canRead(U)),this.options.resolve.resolvers),z=!V;let Y,Z=stripHash(this.reference.uri)===B,ee=!Z;this.indirections.push(s);try{if(V||z){L=this.toBaseURI(B);const s=B,o=maybeRefractToSchemaElement(j.value.result);if(Y=uri_evaluate(s,o),Y=maybeRefractToSchemaElement(Y),Y.id=Zw.identify(Y),!this.options.resolve.internal&&Z)return;if(!this.options.resolve.external&&ee)return}else{if(L=this.toBaseURI(B),Z=stripHash(this.reference.uri)===L,ee=!Z,!this.options.resolve.internal&&Z)return;if(!this.options.resolve.external&&ee)return;j=await this.toReference(unsanitize(B));const s=fromURIReference(B),o=maybeRefractToSchemaElement(j.value.result);Y=apidom_evaluate(o,s),Y=maybeRefractToSchemaElement(Y),Y.id=Zw.identify(Y)}}catch(o){if(!(z&&o instanceof Hw))return this.indirections.pop(),this.handleDereferenceError(o,s,C);if(isAnchor(uriToAnchor(B))){if(Z=stripHash(this.reference.uri)===L,ee=!Z,!this.options.resolve.internal&&Z)return;if(!this.options.resolve.external&&ee)return;try{j=await this.toReference(unsanitize(B))}catch(o){return this.indirections.pop(),this.handleDereferenceError(o,s,C)}const o=uriToAnchor(B),i=maybeRefractToSchemaElement(j.value.result);try{Y=$anchor_evaluate(o,i)}catch(o){return this.indirections.pop(),this.handleDereferenceError(o,s,C)}Y=maybeRefractToSchemaElement(Y),Y.id=Zw.identify(Y)}else{if(L=this.toBaseURI(B),Z=stripHash(this.reference.uri)===L,ee=!Z,!this.options.resolve.internal&&Z)return;if(!this.options.resolve.external&&ee)return;try{j=await this.toReference(unsanitize(B))}catch(o){return this.indirections.pop(),this.handleDereferenceError(o,s,C)}const o=fromURIReference(B),i=maybeRefractToSchemaElement(j.value.result);try{Y=apidom_evaluate(i,o)}catch(o){return this.indirections.pop(),this.handleDereferenceError(o,s,C)}Y=maybeRefractToSchemaElement(Y),Y.id=Zw.identify(Y)}}if(s===Y){const o=new Ko("Recursive Schema Object reference detected");return this.indirections.pop(),this.handleDereferenceError(o,s,C)}if(this.indirections.length>this.options.dereference.maxDepth){const o=new Kw(`Maximum dereference depth of "${this.options.dereference.maxDepth}" has been exceeded in file "${this.reference.uri}"`);return this.indirections.pop(),this.handleDereferenceError(o,s,C)}if(x.includes(Y)){if(j.refSet.circular=!0,"error"===this.options.dereference.circular){const o=new Ko("Circular reference detected");return this.indirections.pop(),this.handleDereferenceError(o,s,C)}if("replace"===this.options.dereference.circular){var ie,ae;const o=new du.sI(Y.id,{type:"json-schema",uri:j.uri,$ref:serializers_value(s.$ref)}),a=(null!==(ie=null===(ae=this.options.dereference.strategyOpts["openapi-3-1"])||void 0===ae?void 0:ae.circularReplacer)&&void 0!==ie?ie:this.options.dereference.circularReplacer)(o);return _.replaceWith(a,mutationReplacer),!i&&a}}const ce=stripHash(j.refSet.rootRef.uri)!==j.uri,le=["error","replace"].includes(this.options.dereference.circular);if((ee||ce||rE(Y)&&_u(Y.$ref)||le||null!==(w=this.options.dereference.dereferenceOpts)&&void 0!==w&&w.continueOnError)&&!x.includesCycle(Y)){C.add(s);const o=new OpenAPI3_1DereferenceVisitor({reference:j,namespace:this.namespace,indirections:[...this.indirections],options:this.getNestedVisitorOptions(s),refractCache:this.refractCache,ancestors:x,allOfDiscriminatorMapping:this.allOfDiscriminatorMapping});try{Y=await Qw(Y,o,{keyMap:tw,nodeTypeGetter:apidom_ns_openapi_3_1_src_traversal_visitor_getNodeType})}catch(o){return this.indirections.pop(),this.handleDereferenceError(o,s,C)}C.delete(s)}if(this.indirections.pop(),predicates_isBooleanJsonSchemaElement(Y)){const o=cloneDeep(Y);return o.setMetaProperty("id",Zw.generateId()),o.setMetaProperty("ref-fields",{$ref:serializers_value(s.$ref),$refBaseURI:B}),o.setMetaProperty("ref-origin",j.uri),o.setMetaProperty("ref-referencing-element-id",cloneDeep(Zw.identify(s))),_.replaceWith(o,mutationReplacer),!i&&o}if(rE(Y)){var pe,de;const o=new e_([...Y.content],cloneDeep(Y.meta),cloneDeep(Y.attributes));if(o.setMetaProperty("id",Zw.generateId()),s.forEach(((s,i,a)=>{o.remove(serializers_value(i)),o.content.push(a)})),o.remove("$ref"),o.setMetaProperty("ref-fields",{$ref:serializers_value(s.$ref),$refBaseURI:B}),o.setMetaProperty("ref-origin",j.uri),o.setMetaProperty("ref-referencing-element-id",cloneDeep(Zw.identify(s))),null!==(pe=this.options.dereference.dereferenceOpts)&&void 0!==pe&&pe.continueOnError&&o.setMetaProperty("ref-referencing-element",s),null!==(de=this.options.dereference.strategyOpts["openapi-3-1"])&&void 0!==de&&de.dereferenceDiscriminatorMapping){var fe;const s=u[u.length-1],i=[...C].findLast(rE),a=null==i?void 0:i.getMetaProperty("schemaName"),_=serializers_value(o.getMetaProperty("schemaName"));if(_&&a&&null!=s&&null!==(fe=s.classes)&&void 0!==fe&&fe.contains("json-schema-allOf")){var ye;const s=null!==(ye=this.allOfDiscriminatorMapping.get(_))&&void 0!==ye?ye:[];s.push(i),this.allOfDiscriminatorMapping.set(_,s)}}Y=o}return _.replaceWith(Y,mutationReplacer),i?void 0:Y}}const ex=OpenAPI3_1DereferenceVisitor,tx=visitor_visit[Symbol.for("nodejs.util.promisify.custom")];const rx=class OpenAPI3_1DereferenceStrategy extends Fw{constructor(s){super({...null!=s?s:{},name:"openapi-3-1"})}canDereference(s){var o;return"text/plain"!==s.mediaType?iw.includes(s.mediaType):H_(null===(o=s.parseResult)||void 0===o?void 0:o.result)}async dereference(s,o){var i;const a=createNamespace(nw),u=null!==(i=o.dereference.refSet)&&void 0!==i?i:new cw,_=new cw;let w,x=u;u.has(s.uri)?w=u.find(Lw(s.uri,"uri")):(w=new aw({uri:s.uri,value:s.parseResult}),u.add(w)),o.dereference.immutable&&(u.refs.map((s=>new aw({...s,value:cloneDeep(s.value)}))).forEach((s=>_.add(s))),w=_.find((o=>o.uri===s.uri)),x=_);const C=new ex({reference:w,namespace:a,options:o}),j=await tx(x.rootRef.value,C,{keyMap:tw,nodeTypeGetter:apidom_ns_openapi_3_1_src_traversal_visitor_getNodeType});return o.dereference.immutable&&_.refs.filter((s=>s.uri.startsWith("immutable://"))).map((s=>new aw({...s,uri:s.uri.replace(/^immutable:\/\//,"")}))).forEach((s=>u.add(s))),null===o.dereference.refSet&&u.clean(),_.clean(),j}},to_path=s=>{const o=(s=>s.slice(2))(s);return o.reduce(((s,i,a)=>{if(Au(i)){const o=String(serializers_value(i.key));s.push(o)}else if(Ou(o[a-2])){const u=o[a-2].content.indexOf(i);s.push(u)}return s}),[])};const nx=class ModelPropertyMacroVisitor{modelPropertyMacro;options;SchemaElement={leave:(s,o,i,a,u)=>{void 0!==s.properties&&ku(s.properties)&&s.properties.forEach((o=>{if(ku(o))try{const s=this.modelPropertyMacro(serializers_value(o));o.set("default",s)}catch(o){const a=new Error(o,{cause:o});a.fullPath=[...to_path([...u,i,s]),"properties"],this.options.dereference.dereferenceOpts?.errors?.push?.(a)}}))}};constructor({modelPropertyMacro:s,options:o}){this.modelPropertyMacro=s,this.options=o}};var sx=function(){function XUniqWith(s,o){this.xf=o,this.pred=s,this.items=[]}return XUniqWith.prototype["@@transducer/init"]=_xfBase_init,XUniqWith.prototype["@@transducer/result"]=_xfBase_result,XUniqWith.prototype["@@transducer/step"]=function(s,o){return _includesWith(this.pred,o,this.items)?s:(this.items.push(o),this.xf["@@transducer/step"](s,o))},XUniqWith}();function _xuniqWith(s){return function(o){return new sx(s,o)}}var ox=_curry2(_dispatchable([],_xuniqWith,(function(s,o){for(var i,a=0,u=o.length,_=[];a<u;)_includesWith(s,i=o[a],_)||(_[_.length]=i),a+=1;return _})));const ix=ox;const ax=class all_of_AllOfVisitor{options;SchemaElement={leave(s,o,i,a,u){if(void 0===s.allOf)return;if(!Ou(s.allOf)){const o=new TypeError("allOf must be an array");return o.fullPath=[...to_path([...u,i,s]),"allOf"],void this.options.dereference.dereferenceOpts?.errors?.push?.(o)}if(s.allOf.isEmpty)return void s.remove("allOf");if(!s.allOf.content.every(rE)){const o=new TypeError("Elements in allOf must be objects");return o.fullPath=[...to_path([...u,i,s]),"allOf"],void this.options.dereference.dereferenceOpts?.errors?.push?.(o)}for(;s.hasKey("allOf");){const{allOf:o}=s;s.remove("allOf");const i=Gh.all([...o.content,s],{customMerge:s=>"enum"===serializers_value(s)?(s,o)=>{if(includesClasses(["json-schema-enum"],s)&&includesClasses(["json-schema-enum"],o)){const areElementsEqual=(s,o)=>!(Ou(s)||Ou(o)||ku(s)||ku(o))&&s.equals(serializers_value(o)),i=cloneShallow(s);return i.content=ix(areElementsEqual)([...s.content,...o.content]),i}return Gh(s,o)}:Gh});if(s.hasKey("$$ref")||i.remove("$$ref"),s.hasKey("example")){const o=i.getMember("example");o&&(o.value=s.get("example"))}if(s.hasKey("examples")){const o=i.getMember("examples");o&&(o.value=s.get("examples"))}s.content=i.content}}};constructor({options:s}){this.options=s}};const cx=class ParameterMacroVisitor{parameterMacro;options;#n;OperationElement={enter:s=>{this.#n=s},leave:()=>{this.#n=void 0}};ParameterElement={leave:(s,o,i,a,u)=>{const _=this.#n?serializers_value(this.#n):null,w=serializers_value(s);try{const o=this.parameterMacro(_,w);s.set("default",o)}catch(s){const o=new Error(s,{cause:s});o.fullPath=to_path([...u,i]),this.options.dereference.dereferenceOpts?.errors?.push?.(o)}}};constructor({parameterMacro:s,options:o}){this.parameterMacro=s,this.options=o}},get_root_cause=s=>{if(null==s.cause)return s;let{cause:o}=s;for(;null!=o.cause;)o=o.cause;return o};const lx=class SchemaRefError extends Go{},{wrapError:ux}=Ul,px=visitor_visit[Symbol.for("nodejs.util.promisify.custom")],hx=new IdentityManager,dereference_mutationReplacer=(s,o,i,a)=>{Au(a)?a.value=s:Array.isArray(a)&&(a[i]=s)};class OpenAPI3_1SwaggerClientDereferenceVisitor extends ex{useCircularStructures;allowMetaPatches;basePath;constructor({allowMetaPatches:s=!0,useCircularStructures:o=!1,basePath:i=null,...a}){super(a),this.allowMetaPatches=s,this.useCircularStructures=o,this.basePath=i}async ReferenceElement(s,o,i,a,u,_){try{var w,x;if(tl()(w=this.indirections).call(w,s))return!1;const[o,a]=this.toAncestorLineage([...u,i]),C=this.toBaseURI(serializers_value(s.$ref)),j=stripHash(this.reference.uri)===C,L=!j;if(!this.options.resolve.internal&&j)return!1;if(!this.options.resolve.external&&L)return!1;const B=await this.toReference(serializers_value(s.$ref)),$=resolve(C,serializers_value(s.$ref));this.indirections.push(s);const U=fromURIReference($);let V=apidom_evaluate(B.value.result,U);if(V.id=hx.identify(V),isPrimitiveElement(V)){const o=serializers_value(s.meta.get("referenced-element")),i=`${o}-${serializers_value(hx.identify(V))}`;if(this.refractCache.has(i))V=this.refractCache.get(i);else if(isReferenceLikeElement(V))V=_b.refract(V),V.setMetaProperty("referenced-element",o),this.refractCache.set(i,V);else{V=this.namespace.getElementClass(o).refract(V),this.refractCache.set(i,V)}}if(s===V)throw new Ko("Recursive Reference Object detected");if(this.indirections.length>this.options.dereference.maxDepth)throw new Kw(`Maximum dereference depth of "${this.options.dereference.maxDepth}" has been exceeded in file "${this.reference.uri}"`);if(tl()(o).call(o,V)){if(B.refSet.circular=!0,"error"===this.options.dereference.circular)throw new Ko("Circular reference detected");if("replace"===this.options.dereference.circular){const o=new du.sI(V.id,{type:"reference",uri:B.uri,$ref:serializers_value(s.$ref),baseURI:$,referencingElement:s}),a=(this.options.dereference.strategyOpts["openapi-3-1"]?.circularReplacer??this.options.dereference.circularReplacer)(o);return _.replaceWith(o,dereference_mutationReplacer),!i&&a}}const z=stripHash(B.refSet.rootRef.uri)!==B.uri,Y=tl()(x=["error","replace"]).call(x,this.options.dereference.circular);if((L||z||Q_(V)||Y)&&!o.includesCycle(V)){a.add(s);const _=new OpenAPI3_1SwaggerClientDereferenceVisitor({reference:B,namespace:this.namespace,indirections:[...this.indirections],options:this.options,refractCache:this.refractCache,ancestors:o,allowMetaPatches:this.allowMetaPatches,useCircularStructures:this.useCircularStructures,basePath:this.basePath??[...to_path([...u,i,s]),"$ref"]});V=await px(V,_,{keyMap:tw,nodeTypeGetter:apidom_ns_openapi_3_1_src_traversal_visitor_getNodeType}),a.delete(s)}this.indirections.pop();const Z=cloneShallow(V);if(Z.setMetaProperty("ref-fields",{$ref:serializers_value(s.$ref),description:serializers_value(s.description),summary:serializers_value(s.summary)}),Z.setMetaProperty("ref-origin",B.uri),Z.setMetaProperty("ref-referencing-element-id",cloneDeep(hx.identify(s))),ku(V)&&(s.hasKey("description")&&"description"in V&&(Z.remove("description"),Z.set("description",s.get("description"))),s.hasKey("summary")&&"summary"in V&&(Z.remove("summary"),Z.set("summary",s.get("summary")))),this.allowMetaPatches&&ku(Z)&&!Z.hasKey("$$ref")){const s=resolve(C,$);Z.set("$$ref",s)}return _.replaceWith(Z,dereference_mutationReplacer),!i&&Z}catch(o){const a=get_root_cause(o),_=ux(a,{baseDoc:this.reference.uri,$ref:serializers_value(s.$ref),pointer:fromURIReference(serializers_value(s.$ref)),fullPath:this.basePath??[...to_path([...u,i,s]),"$ref"]});return void this.options.dereference.dereferenceOpts?.errors?.push?.(_)}}async PathItemElement(s,o,i,a,u,_){try{var w,x;if(!_u(s.$ref))return;if(tl()(w=this.indirections).call(w,s))return!1;if(includesClasses(["cycle"],s.$ref))return!1;const[o,a]=this.toAncestorLineage([...u,i]),C=this.toBaseURI(serializers_value(s.$ref)),j=stripHash(this.reference.uri)===C,L=!j;if(!this.options.resolve.internal&&j)return;if(!this.options.resolve.external&&L)return;const B=await this.toReference(serializers_value(s.$ref)),$=resolve(C,serializers_value(s.$ref));this.indirections.push(s);const U=fromURIReference($);let V=apidom_evaluate(B.value.result,U);if(V.id=hx.identify(V),isPrimitiveElement(V)){const s=`path-item-${serializers_value(hx.identify(V))}`;this.refractCache.has(s)?V=this.refractCache.get(s):(V=yb.refract(V),this.refractCache.set(s,V))}if(s===V)throw new Ko("Recursive Path Item Object reference detected");if(this.indirections.length>this.options.dereference.maxDepth)throw new Kw(`Maximum dereference depth of "${this.options.dereference.maxDepth}" has been exceeded in file "${this.reference.uri}"`);if(tl()(o).call(o,V)){if(B.refSet.circular=!0,"error"===this.options.dereference.circular)throw new Ko("Circular reference detected");if("replace"===this.options.dereference.circular){const o=new du.sI(V.id,{type:"path-item",uri:B.uri,$ref:serializers_value(s.$ref),baseURI:$,referencingElement:s}),a=(this.options.dereference.strategyOpts["openapi-3-1"]?.circularReplacer??this.options.dereference.circularReplacer)(o);return _.replaceWith(o,dereference_mutationReplacer),!i&&a}}const z=stripHash(B.refSet.rootRef.uri)!==B.uri,Y=tl()(x=["error","replace"]).call(x,this.options.dereference.circular);if((L||z||Y_(V)&&_u(V.$ref)||Y)&&!o.includesCycle(V)){a.add(s);const _=new OpenAPI3_1SwaggerClientDereferenceVisitor({reference:B,namespace:this.namespace,indirections:[...this.indirections],options:this.options,ancestors:o,allowMetaPatches:this.allowMetaPatches,useCircularStructures:this.useCircularStructures,basePath:this.basePath??[...to_path([...u,i,s]),"$ref"]});V=await px(V,_,{keyMap:tw,nodeTypeGetter:apidom_ns_openapi_3_1_src_traversal_visitor_getNodeType}),a.delete(s)}if(this.indirections.pop(),Y_(V)){const o=new yb([...V.content],cloneDeep(V.meta),cloneDeep(V.attributes));if(s.forEach(((s,i,a)=>{o.remove(serializers_value(i)),o.content.push(a)})),o.remove("$ref"),o.setMetaProperty("ref-fields",{$ref:serializers_value(s.$ref)}),o.setMetaProperty("ref-origin",B.uri),o.setMetaProperty("ref-referencing-element-id",cloneDeep(hx.identify(s))),this.allowMetaPatches&&void 0===o.get("$$ref")){const s=resolve(C,$);o.set("$$ref",s)}V=o}return _.replaceWith(V,dereference_mutationReplacer),i?void 0:V}catch(o){const a=get_root_cause(o),_=ux(a,{baseDoc:this.reference.uri,$ref:serializers_value(s.$ref),pointer:fromURIReference(serializers_value(s.$ref)),fullPath:this.basePath??[...to_path([...u,i,s]),"$ref"]});return void this.options.dereference.dereferenceOpts?.errors?.push?.(_)}}async SchemaElement(s,o,i,a,u,_){try{var w,x;if(!_u(s.$ref))return;if(tl()(w=this.indirections).call(w,s))return!1;const[o,a]=this.toAncestorLineage([...u,i]);let C=await this.toReference(unsanitize(this.reference.uri)),{uri:j}=C;const L=resolveSchema$refField(j,s),B=stripHash(L),$=new gw({uri:B}),U=!this.options.resolve.resolvers.some((s=>s.canRead($))),V=!U;let z,Y=stripHash(this.reference.uri)===L,Z=!Y;this.indirections.push(s);try{if(U||V){j=this.toBaseURI(L);const s=L,o=maybeRefractToSchemaElement(C.value.result);if(z=uri_evaluate(s,o),z=maybeRefractToSchemaElement(z),z.id=hx.identify(z),!this.options.resolve.internal&&Y)return;if(!this.options.resolve.external&&Z)return}else{if(j=this.toBaseURI(L),Y=stripHash(this.reference.uri)===j,Z=!Y,!this.options.resolve.internal&&Y)return;if(!this.options.resolve.external&&Z)return;C=await this.toReference(unsanitize(L));const s=fromURIReference(L),o=maybeRefractToSchemaElement(C.value.result);z=apidom_evaluate(o,s),z=maybeRefractToSchemaElement(z),z.id=hx.identify(z)}}catch(s){if(!(V&&s instanceof Hw))throw s;if(isAnchor(uriToAnchor(L))){if(Y=stripHash(this.reference.uri)===j,Z=!Y,!this.options.resolve.internal&&Y)return;if(!this.options.resolve.external&&Z)return;C=await this.toReference(unsanitize(L));const s=uriToAnchor(L),o=maybeRefractToSchemaElement(C.value.result);z=$anchor_evaluate(s,o),z=maybeRefractToSchemaElement(z),z.id=hx.identify(z)}else{if(j=this.toBaseURI(serializers_value(L)),Y=stripHash(this.reference.uri)===j,Z=!Y,!this.options.resolve.internal&&Y)return;if(!this.options.resolve.external&&Z)return;C=await this.toReference(unsanitize(L));const s=fromURIReference(L),o=maybeRefractToSchemaElement(C.value.result);z=apidom_evaluate(o,s),z=maybeRefractToSchemaElement(z),z.id=hx.identify(z)}}if(s===z)throw new Ko("Recursive Schema Object reference detected");if(this.indirections.length>this.options.dereference.maxDepth)throw new Kw(`Maximum dereference depth of "${this.options.dereference.maxDepth}" has been exceeded in file "${this.reference.uri}"`);if(tl()(o).call(o,z)){if(C.refSet.circular=!0,"error"===this.options.dereference.circular)throw new Ko("Circular reference detected");if("replace"===this.options.dereference.circular){const o=new du.sI(z.id,{type:"json-schema",uri:C.uri,$ref:serializers_value(s.$ref),baseURI:resolve(j,L),referencingElement:s}),a=(this.options.dereference.strategyOpts["openapi-3-1"]?.circularReplacer??this.options.dereference.circularReplacer)(o);return _.replaceWith(a,dereference_mutationReplacer),!i&&a}}const ee=stripHash(C.refSet.rootRef.uri)!==C.uri,ie=tl()(x=["error","replace"]).call(x,this.options.dereference.circular);if((Z||ee||rE(z)&&_u(z.$ref)||ie)&&!o.includesCycle(z)){a.add(s);const _=new OpenAPI3_1SwaggerClientDereferenceVisitor({reference:C,namespace:this.namespace,indirections:[...this.indirections],options:this.options,useCircularStructures:this.useCircularStructures,allowMetaPatches:this.allowMetaPatches,ancestors:o,basePath:this.basePath??[...to_path([...u,i,s]),"$ref"]});z=await px(z,_,{keyMap:tw,nodeTypeGetter:apidom_ns_openapi_3_1_src_traversal_visitor_getNodeType}),a.delete(s)}if(this.indirections.pop(),predicates_isBooleanJsonSchemaElement(z)){const o=cloneDeep(z);return o.setMetaProperty("ref-fields",{$ref:serializers_value(s.$ref)}),o.setMetaProperty("ref-origin",C.uri),o.setMetaProperty("ref-referencing-element-id",cloneDeep(hx.identify(s))),_.replaceWith(o,dereference_mutationReplacer),!i&&o}if(rE(z)){const o=new e_([...z.content],cloneDeep(z.meta),cloneDeep(z.attributes));if(s.forEach(((s,i,a)=>{o.remove(serializers_value(i)),o.content.push(a)})),o.remove("$ref"),o.setMetaProperty("ref-fields",{$ref:serializers_value(s.$ref)}),o.setMetaProperty("ref-origin",C.uri),o.setMetaProperty("ref-referencing-element-id",cloneDeep(hx.identify(s))),this.allowMetaPatches&&void 0===o.get("$$ref")){const s=resolve(j,L);o.set("$$ref",s)}z=o}return _.replaceWith(z,dereference_mutationReplacer),i?void 0:z}catch(o){const a=get_root_cause(o),_=new lx(`Could not resolve reference: ${a.message}`,{baseDoc:this.reference.uri,$ref:serializers_value(s.$ref),fullPath:this.basePath??[...to_path([...u,i,s]),"$ref"],cause:a});return void this.options.dereference.dereferenceOpts?.errors?.push?.(_)}}async LinkElement(){}async ExampleElement(s,o,i,a,u,_){try{return await super.ExampleElement(s,o,i,a,u,_)}catch(o){const a=get_root_cause(o),_=ux(a,{baseDoc:this.reference.uri,externalValue:serializers_value(s.externalValue),fullPath:this.basePath??[...to_path([...u,i,s]),"externalValue"]});return void this.options.dereference.dereferenceOpts?.errors?.push?.(_)}}}const dx=OpenAPI3_1SwaggerClientDereferenceVisitor,fx=mergeAll[Symbol.for("nodejs.util.promisify.custom")];const mx=class RootVisitor{constructor({parameterMacro:s,modelPropertyMacro:o,mode:i,options:a,...u}){const _=[];_.push(new dx({...u,options:a})),"function"==typeof o&&_.push(new nx({modelPropertyMacro:o,options:a})),"strict"!==i&&_.push(new ax({options:a})),"function"==typeof s&&_.push(new cx({parameterMacro:s,options:a}));const w=fx(_,{nodeTypeGetter:apidom_ns_openapi_3_1_src_traversal_visitor_getNodeType});Object.assign(this,w)}},gx=visitor_visit[Symbol.for("nodejs.util.promisify.custom")];const yx=class OpenAPI3_1SwaggerClientDereferenceStrategy extends rx{allowMetaPatches;parameterMacro;modelPropertyMacro;mode;ancestors;constructor({allowMetaPatches:s=!1,parameterMacro:o=null,modelPropertyMacro:i=null,mode:a="non-strict",ancestors:u=[],..._}={}){super({..._}),this.name="openapi-3-1-swagger-client",this.allowMetaPatches=s,this.parameterMacro=o,this.modelPropertyMacro=i,this.mode=a,this.ancestors=[...u]}async dereference(s,o){const i=createNamespace(nw),a=o.dereference.refSet??new cw,u=new cw;let _,w=a;a.has(s.uri)?_=a.find((o=>o.uri===s.uri)):(_=new aw({uri:s.uri,value:s.parseResult}),a.add(_)),o.dereference.immutable&&(a.refs.map((s=>new aw({...s,value:cloneDeep(s.value)}))).forEach((s=>u.add(s))),_=u.find((o=>o.uri===s.uri)),w=u);const x=new mx({reference:_,namespace:i,options:o,allowMetaPatches:this.allowMetaPatches,ancestors:this.ancestors,modelPropertyMacro:this.modelPropertyMacro,mode:this.mode,parameterMacro:this.parameterMacro}),C=await gx(w.rootRef.value,x,{keyMap:tw,nodeTypeGetter:apidom_ns_openapi_3_1_src_traversal_visitor_getNodeType});return o.dereference.immutable&&u.refs.filter((s=>s.uri.startsWith("immutable://"))).map((s=>new aw({...s,uri:s.uri.replace(/^immutable:\/\//,"")}))).forEach((s=>a.add(s))),null===o.dereference.refSet&&a.clean(),u.clean(),C}},circularReplacer=s=>{const o=serializers_value(s.meta.get("baseURI")),i=s.meta.get("referencingElement");return new du.Sh({$ref:o},cloneDeep(i.meta),cloneDeep(i.attributes))},resolveOpenAPI31Strategy=async s=>{const{spec:o,timeout:i,redirects:a,requestInterceptor:u,responseInterceptor:_,pathDiscriminator:w=[],allowMetaPatches:x=!1,useCircularStructures:C=!1,skipNormalization:j=!1,parameterMacro:L=null,modelPropertyMacro:B=null,mode:$="non-strict",strategies:U}=s;try{const{cache:V}=resolveOpenAPI31Strategy,z=U.find((s=>s.match(o))),Y=isHttpUrl(url_cwd())?url_cwd():Al,Z=options_retrievalURI(s),ee=resolve(Y,Z);let ie;V.has(o)?ie=V.get(o):(ie=nb.refract(o),ie.classes.push("result"),V.set(o,ie));const ae=new bu([ie]),ce=es_compile(w),le=""===ce?"":`#${ce}`,pe=apidom_evaluate(ie,ce),de=new aw({uri:ee,value:ae}),fe=new cw({refs:[de]});""!==ce&&(fe.rootRef=void 0);const ye=[new Set([pe])],be=[],Se=await(async(s,o={})=>{const i=util_merge(uw,o);return dereferenceApiDOM(s,i)})(pe,{resolve:{baseURI:`${ee}${le}`,resolvers:[new Tw({timeout:i||1e4,redirects:a||10})],resolverOpts:{swaggerHTTPClientConfig:{requestInterceptor:u,responseInterceptor:_}},strategies:[new kw]},parse:{mediaType:iw.latest(),parsers:[new Rw({allowEmpty:!1,sourceMap:!1}),new Dw({allowEmpty:!1,sourceMap:!1}),new Nw({allowEmpty:!1,sourceMap:!1}),new Mw({allowEmpty:!1,sourceMap:!1}),new ww({allowEmpty:!1,sourceMap:!1})]},dereference:{maxDepth:100,strategies:[new yx({allowMetaPatches:x,useCircularStructures:C,parameterMacro:L,modelPropertyMacro:B,mode:$,ancestors:ye})],refSet:fe,dereferenceOpts:{errors:be},immutable:!1,circular:C?"ignore":"replace",circularReplacer:C?uw.dereference.circularReplacer:circularReplacer}}),_e=((s,o,i)=>new gp({element:i}).transclude(s,o))(pe,Se,ie),we=j?_e:z.normalize(_e);return{spec:serializers_value(we),errors:be}}catch(s){if(s instanceof Lp)return{spec:o,errors:[]};throw s}};resolveOpenAPI31Strategy.cache=new WeakMap;const vx=resolveOpenAPI31Strategy;function _clone(s,o,i){if(i||(i=new bx),function _isPrimitive(s){var o=typeof s;return null==s||"object"!=o&&"function"!=o}(s))return s;var a=function copy(a){var u=i.get(s);if(u)return u;for(var _ in i.set(s,a),s)Object.prototype.hasOwnProperty.call(s,_)&&(a[_]=o?_clone(s[_],!0,i):s[_]);return a};switch(xa(s)){case"Object":return a(Object.create(Object.getPrototypeOf(s)));case"Array":return a(Array(s.length));case"Date":return new Date(s.valueOf());case"RegExp":return function _cloneRegExp(s){return new RegExp(s.source,s.flags?s.flags:(s.global?"g":"")+(s.ignoreCase?"i":"")+(s.multiline?"m":"")+(s.sticky?"y":"")+(s.unicode?"u":"")+(s.dotAll?"s":""))}(s);case"Int8Array":case"Uint8Array":case"Uint8ClampedArray":case"Int16Array":case"Uint16Array":case"Int32Array":case"Uint32Array":case"Float32Array":case"Float64Array":case"BigInt64Array":case"BigUint64Array":return s.slice();default:return s}}var bx=function(){function _ObjectMap(){this.map={},this.length=0}return _ObjectMap.prototype.set=function(s,o){var i=this.hash(s),a=this.map[i];a||(this.map[i]=a=[]),a.push([s,o]),this.length+=1},_ObjectMap.prototype.hash=function(s){var o=[];for(var i in s)o.push(Object.prototype.toString.call(s[i]));return o.join()},_ObjectMap.prototype.get=function(s){if(this.length<=180)for(var o in this.map)for(var i=this.map[o],a=0;a<i.length;a+=1){if((_=i[a])[0]===s)return _[1]}else{var u=this.hash(s);if(i=this.map[u])for(a=0;a<i.length;a+=1){var _;if((_=i[a])[0]===s)return _[1]}}},_ObjectMap}(),Sx=function(){function XReduceBy(s,o,i,a){this.valueFn=s,this.valueAcc=o,this.keyFn=i,this.xf=a,this.inputs={}}return XReduceBy.prototype["@@transducer/init"]=_xfBase_init,XReduceBy.prototype["@@transducer/result"]=function(s){var o;for(o in this.inputs)if(_has(o,this.inputs)&&(s=this.xf["@@transducer/step"](s,this.inputs[o]))["@@transducer/reduced"]){s=s["@@transducer/value"];break}return this.inputs=null,this.xf["@@transducer/result"](s)},XReduceBy.prototype["@@transducer/step"]=function(s,o){var i=this.keyFn(o);return this.inputs[i]=this.inputs[i]||[i,_clone(this.valueAcc,!1)],this.inputs[i][1]=this.valueFn(this.inputs[i][1],o),s},XReduceBy}();function _xreduceBy(s,o,i){return function(a){return new Sx(s,o,i,a)}}var _x=_curryN(4,[],_dispatchable([],_xreduceBy,(function reduceBy(s,o,i,a){var u=_xwrap((function(a,u){var _=i(u),w=s(_has(_,a)?a[_]:_clone(o,!1),u);return w&&w["@@transducer/reduced"]?_reduced(a):(a[_]=w,a)}));return _i(u,{},a)})));const Ex=_curry2(_checkForMethod("groupBy",_x((function(s,o){return s.push(o),s}),[])));const wx=class NormalizeStorage{internalStore;constructor(s,o,i){this.storageElement=s,this.storageField=o,this.storageSubField=i}get store(){if(!this.internalStore){let s=this.storageElement.get(this.storageField);ku(s)||(s=new du.Sh,this.storageElement.set(this.storageField,s));let o=s.get(this.storageSubField);Ou(o)||(o=new du.wE,s.set(this.storageSubField,o)),this.internalStore=o}return this.internalStore}append(s){this.includes(s)||this.store.push(s)}includes(s){return this.store.includes(s)}},removeSpaces=s=>s.replace(/\s/g,""),normalize_operation_ids_replaceSpecialCharsWithUnderscore=s=>s.replace(/\W/gi,"_"),normalizeOperationId=(s,o,i)=>{const a=removeSpaces(s);return a.length>0?normalize_operation_ids_replaceSpecialCharsWithUnderscore(a):((s,o)=>`${normalize_operation_ids_replaceSpecialCharsWithUnderscore(removeSpaces(o.toLowerCase()))}${normalize_operation_ids_replaceSpecialCharsWithUnderscore(removeSpaces(s))}`)(o,i)},normalize_operation_ids=({storageField:s="x-normalized",operationIdNormalizer:o=normalizeOperationId}={})=>i=>{const{predicates:a,ancestorLineageToJSONPointer:u,namespace:_}=i,w=[],x=[],C=[];let j;return{visitor:{OpenApi3_1Element:{enter(o){j=new wx(o,s,"operation-ids")},leave(){const s=Ex((s=>serializers_value(s.operationId)),x);Object.entries(s).forEach((([s,o])=>{Array.isArray(o)&&(o.length<=1||o.forEach(((o,i)=>{const a=`${s}${i+1}`;o.operationId=new _.elements.String(a)})))})),C.forEach((s=>{if(void 0===s.operationId)return;const o=String(serializers_value(s.operationId)),i=x.find((s=>serializers_value(s.meta.get("originalOperationId"))===o));void 0!==i&&(s.operationId=cloneDeep.safe(i.operationId),s.meta.set("originalOperationId",o),s.set("__originalOperationId",o))})),x.length=0,C.length=0,j=void 0}},PathItemElement:{enter(s){const o=ea("path",serializers_value(s.meta.get("path")));w.push(o)},leave(){w.pop()}},OperationElement:{enter(s,i,a,C,L){if(void 0===s.operationId)return;const B=u([...L,a,s]);if(j.includes(B))return;const $=String(serializers_value(s.operationId)),U=ca(w),V=ea("method",serializers_value(s.meta.get("http-method"))),z=o($,U,V);$!==z&&(s.operationId=new _.elements.String(z),s.set("__originalOperationId",$),s.meta.set("originalOperationId",$),x.push(s),j.append(B))}},LinkElement:{leave(s){a.isLinkElement(s)&&void 0!==s.operationId&&C.push(s)}}}}},normalize_parameters=({storageField:s="x-normalized"}={})=>o=>{const{predicates:i,ancestorLineageToJSONPointer:a}=o,parameterEquals=(s,o)=>!!i.isParameterElement(s)&&(!!i.isParameterElement(o)&&(!!i.isStringElement(s.name)&&(!!i.isStringElement(s.in)&&(!!i.isStringElement(o.name)&&(!!i.isStringElement(o.in)&&(serializers_value(s.name)===serializers_value(o.name)&&serializers_value(s.in)===serializers_value(o.in))))))),u=[];let _;return{visitor:{OpenApi3_1Element:{enter(o){_=new wx(o,s,"parameters")},leave(){_=void 0}},PathItemElement:{enter(s,o,a,_,w){if(w.some(i.isComponentsElement))return;const{parameters:x}=s;i.isArrayElement(x)?u.push([...x.content]):u.push([])},leave(){u.pop()}},OperationElement:{leave(s,o,i,w,x){const C=ca(u);if(!Array.isArray(C)||0===C.length)return;const j=a([...x,i,s]);if(_.includes(j))return;const L=Uw([],["parameters","content"],s),B=ix(parameterEquals,[...L,...C]);s.parameters=new hv(B),_.append(j)}}}}},normalize_security_requirements=({storageField:s="x-normalized"}={})=>o=>{const{predicates:i,ancestorLineageToJSONPointer:a}=o;let u,_;return{visitor:{OpenApi3_1Element:{enter(o){_=new wx(o,s,"security-requirements"),i.isArrayElement(o.security)&&(u=o.security)},leave(){_=void 0,u=void 0}},OperationElement:{leave(s,o,w,x,C){if(C.some(i.isComponentsElement))return;const j=a([...C,w,s]);if(_.includes(j))return;var L;void 0===s.security&&void 0!==u&&(s.security=new vv(null===(L=u)||void 0===L?void 0:L.content),_.append(j))}}}}},normalize_parameter_examples=({storageField:s="x-normalized"}={})=>o=>{const{predicates:i,ancestorLineageToJSONPointer:a}=o;let u;return{visitor:{OpenApi3_1Element:{enter(o){u=new wx(o,s,"parameter-examples")},leave(){u=void 0}},ParameterElement:{leave(s,o,_,w,x){var C,j;if(x.some(i.isComponentsElement))return;if(void 0===s.schema||!i.isSchemaElement(s.schema))return;if(void 0===(null===(C=s.schema)||void 0===C?void 0:C.example)&&void 0===(null===(j=s.schema)||void 0===j?void 0:j.examples))return;const L=a([...x,_,s]);if(!u.includes(L)){if(void 0!==s.examples&&i.isObjectElement(s.examples)){const o=s.examples.map((s=>cloneDeep.safe(s.value)));return void 0!==s.schema.examples&&(s.schema.set("examples",o),u.append(L)),void(void 0!==s.schema.example&&(s.schema.set("example",o[0]),u.append(L)))}void 0!==s.example&&(void 0!==s.schema.examples&&(s.schema.set("examples",[cloneDeep(s.example)]),u.append(L)),void 0!==s.schema.example&&(s.schema.set("example",cloneDeep(s.example)),u.append(L)))}}}}}},normalize_header_examples=({storageField:s="x-normalized"}={})=>o=>{const{predicates:i,ancestorLineageToJSONPointer:a}=o;let u;return{visitor:{OpenApi3_1Element:{enter(o){u=new wx(o,s,"header-examples")},leave(){u=void 0}},HeaderElement:{leave(s,o,_,w,x){var C,j;if(x.some(i.isComponentsElement))return;if(void 0===s.schema||!i.isSchemaElement(s.schema))return;if(void 0===(null===(C=s.schema)||void 0===C?void 0:C.example)&&void 0===(null===(j=s.schema)||void 0===j?void 0:j.examples))return;const L=a([...x,_,s]);if(!u.includes(L)){if(void 0!==s.examples&&i.isObjectElement(s.examples)){const o=s.examples.map((s=>cloneDeep.safe(s.value)));return void 0!==s.schema.examples&&(s.schema.set("examples",o),u.append(L)),void(void 0!==s.schema.example&&(s.schema.set("example",o[0]),u.append(L)))}void 0!==s.example&&(void 0!==s.schema.examples&&(s.schema.set("examples",[cloneDeep(s.example)]),u.append(L)),void 0!==s.schema.example&&(s.schema.set("example",cloneDeep(s.example)),u.append(L)))}}}}}},openapi_3_1_apidom_normalize=s=>{if(!ku(s))return s;const o=[normalize_operation_ids({operationIdNormalizer:(s,o,i)=>opId({operationId:s},o,i,{v2OperationIdCompatibilityMode:!1})}),normalize_parameters(),normalize_security_requirements(),normalize_parameter_examples(),normalize_header_examples()];return dispatchPluginsSync(s,o,{toolboxCreator:apidom_ns_openapi_3_1_src_refractor_toolbox,visitorOptions:{keyMap:tw,nodeTypeGetter:apidom_ns_openapi_3_1_src_traversal_visitor_getNodeType}})},xx={name:"openapi-3-1-apidom",match:s=>isOpenAPI31(s),normalize(s){if(!Su(s)&&iu(s)&&!s.$$normalized){const i=(o=openapi_3_1_apidom_normalize,s=>{const i=nb.refract(s);i.classes.push("result");const a=o(i),u=serializers_value(a);return vx.cache.set(u,a),serializers_value(a)})(s);return i.$$normalized=!0,i}var o;return Su(s)?openapi_3_1_apidom_normalize(s):s},resolve:async s=>vx(s)},kx=xx,makeResolve=s=>async o=>(async s=>{const{spec:o,requestInterceptor:i,responseInterceptor:a}=s,u=options_retrievalURI(s),_=options_httpClient(s),w=o||await makeFetchJSON(_,{requestInterceptor:i,responseInterceptor:a})(u),x={...s,spec:w};return s.strategies.find((s=>s.match(w))).resolve(x)})({...s,...o}),Ox=makeResolve({strategies:[hu,uu,cu]});const server_url_template=(s,o,i,a,u)=>{if(s===Ep.SEM_PRE){if(!1===Array.isArray(u))throw new Error("parser's user data must be an array");u.push(["server-url-template",_p.charsToString(o,i,a)])}return Ep.SEM_OK},callbacks_server_variable=(s,o,i,a,u)=>{if(s===Ep.SEM_PRE){if(!1===Array.isArray(u))throw new Error("parser's user data must be an array");u.push(["server-variable",_p.charsToString(o,i,a)])}return Ep.SEM_OK},server_variable_name=(s,o,i,a,u)=>{if(s===Ep.SEM_PRE){if(!1===Array.isArray(u))throw new Error("parser's user data must be an array");u.push(["server-variable-name",_p.charsToString(o,i,a)])}return Ep.SEM_OK},callbacks_literals=(s,o,i,a,u)=>{if(s===Ep.SEM_PRE){if(!1===Array.isArray(u))throw new Error("parser's user data must be an array");u.push(["literals",_p.charsToString(o,i,a)])}return Ep.SEM_OK},Ax=new function server_url_templating_grammar(){this.grammarObject="grammarObject",this.rules=[],this.rules[0]={name:"server-url-template",lower:"server-url-template",index:0,isBkr:!1},this.rules[1]={name:"server-variable",lower:"server-variable",index:1,isBkr:!1},this.rules[2]={name:"server-variable-name",lower:"server-variable-name",index:2,isBkr:!1},this.rules[3]={name:"literals",lower:"literals",index:3,isBkr:!1},this.rules[4]={name:"DIGIT",lower:"digit",index:4,isBkr:!1},this.rules[5]={name:"HEXDIG",lower:"hexdig",index:5,isBkr:!1},this.rules[6]={name:"pct-encoded",lower:"pct-encoded",index:6,isBkr:!1},this.rules[7]={name:"ucschar",lower:"ucschar",index:7,isBkr:!1},this.rules[8]={name:"iprivate",lower:"iprivate",index:8,isBkr:!1},this.udts=[],this.rules[0].opcodes=[],this.rules[0].opcodes[0]={type:3,min:1,max:1/0},this.rules[0].opcodes[1]={type:1,children:[2,3]},this.rules[0].opcodes[2]={type:4,index:3},this.rules[0].opcodes[3]={type:4,index:1},this.rules[1].opcodes=[],this.rules[1].opcodes[0]={type:2,children:[1,2,3]},this.rules[1].opcodes[1]={type:7,string:[123]},this.rules[1].opcodes[2]={type:4,index:2},this.rules[1].opcodes[3]={type:7,string:[125]},this.rules[2].opcodes=[],this.rules[2].opcodes[0]={type:3,min:1,max:1/0},this.rules[2].opcodes[1]={type:1,children:[2,3,4]},this.rules[2].opcodes[2]={type:5,min:0,max:122},this.rules[2].opcodes[3]={type:6,string:[124]},this.rules[2].opcodes[4]={type:5,min:126,max:1114111},this.rules[3].opcodes=[],this.rules[3].opcodes[0]={type:3,min:1,max:1/0},this.rules[3].opcodes[1]={type:1,children:[2,3,4,5,6,7,8,9,10,11,12,13]},this.rules[3].opcodes[2]={type:6,string:[33]},this.rules[3].opcodes[3]={type:5,min:35,max:36},this.rules[3].opcodes[4]={type:5,min:38,max:59},this.rules[3].opcodes[5]={type:6,string:[61]},this.rules[3].opcodes[6]={type:5,min:63,max:91},this.rules[3].opcodes[7]={type:6,string:[93]},this.rules[3].opcodes[8]={type:6,string:[95]},this.rules[3].opcodes[9]={type:5,min:97,max:122},this.rules[3].opcodes[10]={type:6,string:[126]},this.rules[3].opcodes[11]={type:4,index:7},this.rules[3].opcodes[12]={type:4,index:8},this.rules[3].opcodes[13]={type:4,index:6},this.rules[4].opcodes=[],this.rules[4].opcodes[0]={type:5,min:48,max:57},this.rules[5].opcodes=[],this.rules[5].opcodes[0]={type:1,children:[1,2,3,4,5,6,7]},this.rules[5].opcodes[1]={type:4,index:4},this.rules[5].opcodes[2]={type:7,string:[97]},this.rules[5].opcodes[3]={type:7,string:[98]},this.rules[5].opcodes[4]={type:7,string:[99]},this.rules[5].opcodes[5]={type:7,string:[100]},this.rules[5].opcodes[6]={type:7,string:[101]},this.rules[5].opcodes[7]={type:7,string:[102]},this.rules[6].opcodes=[],this.rules[6].opcodes[0]={type:2,children:[1,2,3]},this.rules[6].opcodes[1]={type:7,string:[37]},this.rules[6].opcodes[2]={type:4,index:5},this.rules[6].opcodes[3]={type:4,index:5},this.rules[7].opcodes=[],this.rules[7].opcodes[0]={type:1,children:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]},this.rules[7].opcodes[1]={type:5,min:160,max:55295},this.rules[7].opcodes[2]={type:5,min:63744,max:64975},this.rules[7].opcodes[3]={type:5,min:65008,max:65519},this.rules[7].opcodes[4]={type:5,min:65536,max:131069},this.rules[7].opcodes[5]={type:5,min:131072,max:196605},this.rules[7].opcodes[6]={type:5,min:196608,max:262141},this.rules[7].opcodes[7]={type:5,min:262144,max:327677},this.rules[7].opcodes[8]={type:5,min:327680,max:393213},this.rules[7].opcodes[9]={type:5,min:393216,max:458749},this.rules[7].opcodes[10]={type:5,min:458752,max:524285},this.rules[7].opcodes[11]={type:5,min:524288,max:589821},this.rules[7].opcodes[12]={type:5,min:589824,max:655357},this.rules[7].opcodes[13]={type:5,min:655360,max:720893},this.rules[7].opcodes[14]={type:5,min:720896,max:786429},this.rules[7].opcodes[15]={type:5,min:786432,max:851965},this.rules[7].opcodes[16]={type:5,min:851968,max:917501},this.rules[7].opcodes[17]={type:5,min:921600,max:983037},this.rules[8].opcodes=[],this.rules[8].opcodes[0]={type:1,children:[1,2,3]},this.rules[8].opcodes[1]={type:5,min:57344,max:63743},this.rules[8].opcodes[2]={type:5,min:983040,max:1048573},this.rules[8].opcodes[3]={type:5,min:1048576,max:1114109},this.toString=function toString(){let s="";return s+="; OpenAPI Server URL templating ABNF syntax\n",s+="server-url-template    = 1*( literals / server-variable ) ; variant of https://www.rfc-editor.org/rfc/rfc6570#section-2\n",s+='server-variable        = "{" server-variable-name "}"\n',s+="server-variable-name   = 1*( %x00-7A / %x7C / %x7E-10FFFF ) ; every UTF8 character except { and } (from OpenAPI)\n",s+="\n",s+="; https://www.rfc-editor.org/rfc/rfc6570#section-2.1\n",s+="; https://www.rfc-editor.org/errata/eid6937\n",s+="literals               = 1*( %x21 / %x23-24 / %x26-3B / %x3D / %x3F-5B\n",s+="                       / %x5D / %x5F / %x61-7A / %x7E / ucschar / iprivate\n",s+="                       / pct-encoded)\n",s+="                            ; any Unicode character except: CTL, SP,\n",s+='                            ;  DQUOTE, "%" (aside from pct-encoded),\n',s+='                            ;  "<", ">", "\\", "^", "`", "{", "|", "}"\n',s+="\n",s+="; https://www.rfc-editor.org/rfc/rfc6570#section-1.5\n",s+="DIGIT          =  %x30-39             ; 0-9\n",s+='HEXDIG         =  DIGIT / "A" / "B" / "C" / "D" / "E" / "F" ; case-insensitive\n',s+="\n",s+='pct-encoded    =  "%" HEXDIG HEXDIG\n',s+="\n",s+="ucschar        =  %xA0-D7FF / %xF900-FDCF / %xFDF0-FFEF\n",s+="               /  %x10000-1FFFD / %x20000-2FFFD / %x30000-3FFFD\n",s+="               /  %x40000-4FFFD / %x50000-5FFFD / %x60000-6FFFD\n",s+="               /  %x70000-7FFFD / %x80000-8FFFD / %x90000-9FFFD\n",s+="               /  %xA0000-AFFFD / %xB0000-BFFFD / %xC0000-CFFFD\n",s+="               /  %xD0000-DFFFD / %xE1000-EFFFD\n",s+="\n",s+="iprivate       =  %xE000-F8FF / %xF0000-FFFFD / %x100000-10FFFD\n",'; OpenAPI Server URL templating ABNF syntax\nserver-url-template    = 1*( literals / server-variable ) ; variant of https://www.rfc-editor.org/rfc/rfc6570#section-2\nserver-variable        = "{" server-variable-name "}"\nserver-variable-name   = 1*( %x00-7A / %x7C / %x7E-10FFFF ) ; every UTF8 character except { and } (from OpenAPI)\n\n; https://www.rfc-editor.org/rfc/rfc6570#section-2.1\n; https://www.rfc-editor.org/errata/eid6937\nliterals               = 1*( %x21 / %x23-24 / %x26-3B / %x3D / %x3F-5B\n                       / %x5D / %x5F / %x61-7A / %x7E / ucschar / iprivate\n                       / pct-encoded)\n                            ; any Unicode character except: CTL, SP,\n                            ;  DQUOTE, "%" (aside from pct-encoded),\n                            ;  "<", ">", "\\", "^", "`", "{", "|", "}"\n\n; https://www.rfc-editor.org/rfc/rfc6570#section-1.5\nDIGIT          =  %x30-39             ; 0-9\nHEXDIG         =  DIGIT / "A" / "B" / "C" / "D" / "E" / "F" ; case-insensitive\n\npct-encoded    =  "%" HEXDIG HEXDIG\n\nucschar        =  %xA0-D7FF / %xF900-FDCF / %xFDF0-FFEF\n               /  %x10000-1FFFD / %x20000-2FFFD / %x30000-3FFFD\n               /  %x40000-4FFFD / %x50000-5FFFD / %x60000-6FFFD\n               /  %x70000-7FFFD / %x80000-8FFFD / %x90000-9FFFD\n               /  %xA0000-AFFFD / %xB0000-BFFFD / %xC0000-CFFFD\n               /  %xD0000-DFFFD / %xE1000-EFFFD\n\niprivate       =  %xE000-F8FF / %xF0000-FFFFD / %x100000-10FFFD\n'}},openapi_server_url_templating_es_parse=s=>{const o=new yp;o.ast=new vp,o.ast.callbacks["server-url-template"]=server_url_template,o.ast.callbacks["server-variable"]=callbacks_server_variable,o.ast.callbacks["server-variable-name"]=server_variable_name,o.ast.callbacks.literals=callbacks_literals;return{result:o.parse(Ax,"server-url-template",s),ast:o.ast}},es_test=(s,{strict:o=!1}={})=>{try{const i=openapi_server_url_templating_es_parse(s);if(!i.result.success)return!1;const a=[];i.ast.translate(a);const u=a.some((([s])=>"server-variable"===s));if(!o&&!u)try{return new URL(s,"https://vladimirgorej.com"),!0}catch{return!1}return!o||u}catch{return!1}},encodeServerVariable=s=>(s=>{try{return"string"==typeof s&&decodeURIComponent(s)!==s}catch{return!1}})(s)?s:encodeURIComponent(s).replace(/%5B/g,"[").replace(/%5D/g,"]"),Cx=["literals","server-variable-name"],es_substitute=(s,o,i={})=>{const a={...{encoder:encodeServerVariable},...i},u=openapi_server_url_templating_es_parse(s);if(!u.result.success)return s;const _=[];u.ast.translate(_);const w=_.filter((([s])=>Cx.includes(s))).map((([s,i])=>"server-variable-name"===s?Object.hasOwn(o,i)?a.encoder(o[i],i):`{${i}}`:i));return w.join("")};function path_templating_grammar(){this.grammarObject="grammarObject",this.rules=[],this.rules[0]={name:"path-template",lower:"path-template",index:0,isBkr:!1},this.rules[1]={name:"path-segment",lower:"path-segment",index:1,isBkr:!1},this.rules[2]={name:"slash",lower:"slash",index:2,isBkr:!1},this.rules[3]={name:"path-literal",lower:"path-literal",index:3,isBkr:!1},this.rules[4]={name:"template-expression",lower:"template-expression",index:4,isBkr:!1},this.rules[5]={name:"template-expression-param-name",lower:"template-expression-param-name",index:5,isBkr:!1},this.rules[6]={name:"pchar",lower:"pchar",index:6,isBkr:!1},this.rules[7]={name:"unreserved",lower:"unreserved",index:7,isBkr:!1},this.rules[8]={name:"pct-encoded",lower:"pct-encoded",index:8,isBkr:!1},this.rules[9]={name:"sub-delims",lower:"sub-delims",index:9,isBkr:!1},this.rules[10]={name:"ALPHA",lower:"alpha",index:10,isBkr:!1},this.rules[11]={name:"DIGIT",lower:"digit",index:11,isBkr:!1},this.rules[12]={name:"HEXDIG",lower:"hexdig",index:12,isBkr:!1},this.udts=[],this.rules[0].opcodes=[],this.rules[0].opcodes[0]={type:2,children:[1,2,6]},this.rules[0].opcodes[1]={type:4,index:2},this.rules[0].opcodes[2]={type:3,min:0,max:1/0},this.rules[0].opcodes[3]={type:2,children:[4,5]},this.rules[0].opcodes[4]={type:4,index:1},this.rules[0].opcodes[5]={type:4,index:2},this.rules[0].opcodes[6]={type:3,min:0,max:1},this.rules[0].opcodes[7]={type:4,index:1},this.rules[1].opcodes=[],this.rules[1].opcodes[0]={type:3,min:1,max:1/0},this.rules[1].opcodes[1]={type:1,children:[2,3]},this.rules[1].opcodes[2]={type:4,index:3},this.rules[1].opcodes[3]={type:4,index:4},this.rules[2].opcodes=[],this.rules[2].opcodes[0]={type:7,string:[47]},this.rules[3].opcodes=[],this.rules[3].opcodes[0]={type:3,min:1,max:1/0},this.rules[3].opcodes[1]={type:4,index:6},this.rules[4].opcodes=[],this.rules[4].opcodes[0]={type:2,children:[1,2,3]},this.rules[4].opcodes[1]={type:7,string:[123]},this.rules[4].opcodes[2]={type:4,index:5},this.rules[4].opcodes[3]={type:7,string:[125]},this.rules[5].opcodes=[],this.rules[5].opcodes[0]={type:3,min:1,max:1/0},this.rules[5].opcodes[1]={type:1,children:[2,3,4]},this.rules[5].opcodes[2]={type:5,min:0,max:122},this.rules[5].opcodes[3]={type:6,string:[124]},this.rules[5].opcodes[4]={type:5,min:126,max:1114111},this.rules[6].opcodes=[],this.rules[6].opcodes[0]={type:1,children:[1,2,3,4,5]},this.rules[6].opcodes[1]={type:4,index:7},this.rules[6].opcodes[2]={type:4,index:8},this.rules[6].opcodes[3]={type:4,index:9},this.rules[6].opcodes[4]={type:7,string:[58]},this.rules[6].opcodes[5]={type:7,string:[64]},this.rules[7].opcodes=[],this.rules[7].opcodes[0]={type:1,children:[1,2,3,4,5,6]},this.rules[7].opcodes[1]={type:4,index:10},this.rules[7].opcodes[2]={type:4,index:11},this.rules[7].opcodes[3]={type:7,string:[45]},this.rules[7].opcodes[4]={type:7,string:[46]},this.rules[7].opcodes[5]={type:7,string:[95]},this.rules[7].opcodes[6]={type:7,string:[126]},this.rules[8].opcodes=[],this.rules[8].opcodes[0]={type:2,children:[1,2,3]},this.rules[8].opcodes[1]={type:7,string:[37]},this.rules[8].opcodes[2]={type:4,index:12},this.rules[8].opcodes[3]={type:4,index:12},this.rules[9].opcodes=[],this.rules[9].opcodes[0]={type:1,children:[1,2,3,4,5,6,7,8,9,10,11]},this.rules[9].opcodes[1]={type:7,string:[33]},this.rules[9].opcodes[2]={type:7,string:[36]},this.rules[9].opcodes[3]={type:7,string:[38]},this.rules[9].opcodes[4]={type:7,string:[39]},this.rules[9].opcodes[5]={type:7,string:[40]},this.rules[9].opcodes[6]={type:7,string:[41]},this.rules[9].opcodes[7]={type:7,string:[42]},this.rules[9].opcodes[8]={type:7,string:[43]},this.rules[9].opcodes[9]={type:7,string:[44]},this.rules[9].opcodes[10]={type:7,string:[59]},this.rules[9].opcodes[11]={type:7,string:[61]},this.rules[10].opcodes=[],this.rules[10].opcodes[0]={type:1,children:[1,2]},this.rules[10].opcodes[1]={type:5,min:65,max:90},this.rules[10].opcodes[2]={type:5,min:97,max:122},this.rules[11].opcodes=[],this.rules[11].opcodes[0]={type:5,min:48,max:57},this.rules[12].opcodes=[],this.rules[12].opcodes[0]={type:1,children:[1,2,3,4,5,6,7]},this.rules[12].opcodes[1]={type:4,index:11},this.rules[12].opcodes[2]={type:7,string:[97]},this.rules[12].opcodes[3]={type:7,string:[98]},this.rules[12].opcodes[4]={type:7,string:[99]},this.rules[12].opcodes[5]={type:7,string:[100]},this.rules[12].opcodes[6]={type:7,string:[101]},this.rules[12].opcodes[7]={type:7,string:[102]},this.toString=function toString(){let s="";return s+="; OpenAPI Path Templating ABNF syntax\n",s+="; variant of https://datatracker.ietf.org/doc/html/rfc3986#section-3.3\n",s+="path-template                  = slash *( path-segment slash ) [ path-segment ]\n",s+="path-segment                   = 1*( path-literal / template-expression )\n",s+='slash                          = "/"\n',s+="path-literal                   = 1*pchar\n",s+='template-expression            = "{" template-expression-param-name "}"\n',s+="template-expression-param-name = 1*( %x00-7A / %x7C / %x7E-10FFFF ) ; every UTF8 character except { and } (from OpenAPI)\n",s+="\n",s+="; https://datatracker.ietf.org/doc/html/rfc3986#section-3.3\n",s+='pchar               = unreserved / pct-encoded / sub-delims / ":" / "@"\n',s+='unreserved          = ALPHA / DIGIT / "-" / "." / "_" / "~"\n',s+="                    ; https://datatracker.ietf.org/doc/html/rfc3986#section-2.3\n",s+='pct-encoded         = "%" HEXDIG HEXDIG\n',s+="                    ; https://datatracker.ietf.org/doc/html/rfc3986#section-2.1\n",s+='sub-delims          = "!" / "$" / "&" / "\'" / "(" / ")"\n',s+='                    / "*" / "+" / "," / ";" / "="\n',s+="                    ; https://datatracker.ietf.org/doc/html/rfc3986#section-2.2\n",s+="\n",s+="; https://datatracker.ietf.org/doc/html/rfc5234#appendix-B.1\n",s+="ALPHA               = %x41-5A / %x61-7A   ; A-Z / a-z\n",s+="DIGIT               = %x30-39            ; 0-9\n",s+='HEXDIG              = DIGIT / "A" / "B" / "C" / "D" / "E" / "F"\n','; OpenAPI Path Templating ABNF syntax\n; variant of https://datatracker.ietf.org/doc/html/rfc3986#section-3.3\npath-template                  = slash *( path-segment slash ) [ path-segment ]\npath-segment                   = 1*( path-literal / template-expression )\nslash                          = "/"\npath-literal                   = 1*pchar\ntemplate-expression            = "{" template-expression-param-name "}"\ntemplate-expression-param-name = 1*( %x00-7A / %x7C / %x7E-10FFFF ) ; every UTF8 character except { and } (from OpenAPI)\n\n; https://datatracker.ietf.org/doc/html/rfc3986#section-3.3\npchar               = unreserved / pct-encoded / sub-delims / ":" / "@"\nunreserved          = ALPHA / DIGIT / "-" / "." / "_" / "~"\n                    ; https://datatracker.ietf.org/doc/html/rfc3986#section-2.3\npct-encoded         = "%" HEXDIG HEXDIG\n                    ; https://datatracker.ietf.org/doc/html/rfc3986#section-2.1\nsub-delims          = "!" / "$" / "&" / "\'" / "(" / ")"\n                    / "*" / "+" / "," / ";" / "="\n                    ; https://datatracker.ietf.org/doc/html/rfc3986#section-2.2\n\n; https://datatracker.ietf.org/doc/html/rfc5234#appendix-B.1\nALPHA               = %x41-5A / %x61-7A   ; A-Z / a-z\nDIGIT               = %x30-39            ; 0-9\nHEXDIG              = DIGIT / "A" / "B" / "C" / "D" / "E" / "F"\n'}}const callbacks_slash=(s,o,i,a,u)=>(s===Ep.SEM_PRE?u.push(["slash",_p.charsToString(o,i,a)]):Ep.SEM_POST,Ep.SEM_OK),path_template=(s,o,i,a,u)=>{if(s===Ep.SEM_PRE){if(!1===Array.isArray(u))throw new Error("parser's user data must be an array");u.push(["path-template",_p.charsToString(o,i,a)])}return Ep.SEM_OK},path_literal=(s,o,i,a,u)=>(s===Ep.SEM_PRE?u.push(["path-literal",_p.charsToString(o,i,a)]):Ep.SEM_POST,Ep.SEM_OK),template_expression=(s,o,i,a,u)=>(s===Ep.SEM_PRE?u.push(["template-expression",_p.charsToString(o,i,a)]):Ep.SEM_POST,Ep.SEM_OK),template_expression_param_name=(s,o,i,a,u)=>(s===Ep.SEM_PRE?u.push(["template-expression-param-name",_p.charsToString(o,i,a)]):Ep.SEM_POST,Ep.SEM_OK),jx=new path_templating_grammar,openapi_path_templating_es_parse=s=>{const o=new yp;o.ast=new vp,o.ast.callbacks["path-template"]=path_template,o.ast.callbacks.slash=callbacks_slash,o.ast.callbacks["path-literal"]=path_literal,o.ast.callbacks["template-expression"]=template_expression,o.ast.callbacks["template-expression-param-name"]=template_expression_param_name;return{result:o.parse(jx,"path-template",s),ast:o.ast}};const encodePathComponent=s=>(s=>{try{return"string"==typeof s&&decodeURIComponent(s)!==s}catch{return!1}})(s)?s:encodeURIComponent(s).replace(/%5B/g,"[").replace(/%5D/g,"]"),Px=["slash","path-literal","template-expression-param-name"],es_resolve=(s,o,i={})=>{const a={...{encoder:encodePathComponent},...i},u=openapi_path_templating_es_parse(s);if(!u.result.success)return s;const _=[];u.ast.translate(_);const w=_.filter((([s])=>Px.includes(s))).map((([s,i])=>"template-expression-param-name"===s?Object.prototype.hasOwnProperty.call(o,i)?a.encoder(o[i],i):`{${i}}`:i));return w.join("")};new path_templating_grammar,new yp;const Ix={body:function bodyBuilder({req:s,value:o}){void 0!==o&&(s.body=o)},header:function headerBuilder({req:s,parameter:o,value:i}){s.headers=s.headers||{},void 0!==i&&(s.headers[o.name]=i)},query:function queryBuilder({req:s,value:o,parameter:i}){s.query=s.query||{},!1===o&&"boolean"===i.type&&(o="false");0===o&&["number","integer"].indexOf(i.type)>-1&&(o="0");if(o)s.query[i.name]={collectionFormat:i.collectionFormat,value:o};else if(i.allowEmptyValue&&void 0!==o){const o=i.name;s.query[o]=s.query[o]||{},s.query[o].allowEmptyValue=!0}},path:function pathBuilder({req:s,value:o,parameter:i,baseURL:a}){if(void 0!==o){const u=s.url.replace(a,""),_=es_resolve(u,{[i.name]:o});s.url=a+_}},formData:function formDataBuilder({req:s,value:o,parameter:i}){!1===o&&"boolean"===i.type&&(o="false");0===o&&["number","integer"].indexOf(i.type)>-1&&(o="0");if(o)s.form=s.form||{},s.form[i.name]={collectionFormat:i.collectionFormat,value:o};else if(i.allowEmptyValue&&void 0!==o){s.form=s.form||{};const o=i.name;s.form[o]=s.form[o]||{},s.form[o].allowEmptyValue=!0}}};function serialize(s,o){return tl()(o).call(o,"application/json")?"string"==typeof s?s:(Array.isArray(s)&&(s=s.map((s=>{try{return JSON.parse(s)}catch(o){return s}}))),JSON.stringify(s)):String(s)}function grammar_grammar(){this.grammarObject="grammarObject",this.rules=[],this.rules[0]={name:"lenient-cookie-string",lower:"lenient-cookie-string",index:0,isBkr:!1},this.rules[1]={name:"lenient-cookie-entry",lower:"lenient-cookie-entry",index:1,isBkr:!1},this.rules[2]={name:"lenient-cookie-pair",lower:"lenient-cookie-pair",index:2,isBkr:!1},this.rules[3]={name:"lenient-cookie-pair-invalid",lower:"lenient-cookie-pair-invalid",index:3,isBkr:!1},this.rules[4]={name:"lenient-cookie-name",lower:"lenient-cookie-name",index:4,isBkr:!1},this.rules[5]={name:"lenient-cookie-value",lower:"lenient-cookie-value",index:5,isBkr:!1},this.rules[6]={name:"lenient-quoted-value",lower:"lenient-quoted-value",index:6,isBkr:!1},this.rules[7]={name:"lenient-quoted-char",lower:"lenient-quoted-char",index:7,isBkr:!1},this.rules[8]={name:"lenient-cookie-octet",lower:"lenient-cookie-octet",index:8,isBkr:!1},this.rules[9]={name:"cookie-string",lower:"cookie-string",index:9,isBkr:!1},this.rules[10]={name:"cookie-pair",lower:"cookie-pair",index:10,isBkr:!1},this.rules[11]={name:"cookie-name",lower:"cookie-name",index:11,isBkr:!1},this.rules[12]={name:"cookie-value",lower:"cookie-value",index:12,isBkr:!1},this.rules[13]={name:"cookie-octet",lower:"cookie-octet",index:13,isBkr:!1},this.rules[14]={name:"OWS",lower:"ows",index:14,isBkr:!1},this.rules[15]={name:"token",lower:"token",index:15,isBkr:!1},this.rules[16]={name:"tchar",lower:"tchar",index:16,isBkr:!1},this.rules[17]={name:"CHAR",lower:"char",index:17,isBkr:!1},this.rules[18]={name:"CTL",lower:"ctl",index:18,isBkr:!1},this.rules[19]={name:"separators",lower:"separators",index:19,isBkr:!1},this.rules[20]={name:"SP",lower:"sp",index:20,isBkr:!1},this.rules[21]={name:"HT",lower:"ht",index:21,isBkr:!1},this.rules[22]={name:"ALPHA",lower:"alpha",index:22,isBkr:!1},this.rules[23]={name:"DIGIT",lower:"digit",index:23,isBkr:!1},this.rules[24]={name:"DQUOTE",lower:"dquote",index:24,isBkr:!1},this.rules[25]={name:"WSP",lower:"wsp",index:25,isBkr:!1},this.rules[26]={name:"HTAB",lower:"htab",index:26,isBkr:!1},this.rules[27]={name:"CRLF",lower:"crlf",index:27,isBkr:!1},this.rules[28]={name:"CR",lower:"cr",index:28,isBkr:!1},this.rules[29]={name:"LF",lower:"lf",index:29,isBkr:!1},this.udts=[],this.rules[0].opcodes=[],this.rules[0].opcodes[0]={type:2,children:[1,2]},this.rules[0].opcodes[1]={type:4,index:1},this.rules[0].opcodes[2]={type:3,min:0,max:1/0},this.rules[0].opcodes[3]={type:2,children:[4,5,6]},this.rules[0].opcodes[4]={type:7,string:[59]},this.rules[0].opcodes[5]={type:4,index:14},this.rules[0].opcodes[6]={type:4,index:1},this.rules[1].opcodes=[],this.rules[1].opcodes[0]={type:1,children:[1,2]},this.rules[1].opcodes[1]={type:4,index:2},this.rules[1].opcodes[2]={type:4,index:3},this.rules[2].opcodes=[],this.rules[2].opcodes[0]={type:2,children:[1,2,3,4,5,6,7]},this.rules[2].opcodes[1]={type:4,index:14},this.rules[2].opcodes[2]={type:4,index:4},this.rules[2].opcodes[3]={type:4,index:14},this.rules[2].opcodes[4]={type:7,string:[61]},this.rules[2].opcodes[5]={type:4,index:14},this.rules[2].opcodes[6]={type:4,index:5},this.rules[2].opcodes[7]={type:4,index:14},this.rules[3].opcodes=[],this.rules[3].opcodes[0]={type:2,children:[1,2,4]},this.rules[3].opcodes[1]={type:4,index:14},this.rules[3].opcodes[2]={type:3,min:1,max:1/0},this.rules[3].opcodes[3]={type:4,index:16},this.rules[3].opcodes[4]={type:4,index:14},this.rules[4].opcodes=[],this.rules[4].opcodes[0]={type:3,min:1,max:1/0},this.rules[4].opcodes[1]={type:1,children:[2,3,4]},this.rules[4].opcodes[2]={type:5,min:33,max:58},this.rules[4].opcodes[3]={type:6,string:[60]},this.rules[4].opcodes[4]={type:5,min:62,max:126},this.rules[5].opcodes=[],this.rules[5].opcodes[0]={type:1,children:[1,6]},this.rules[5].opcodes[1]={type:2,children:[2,3]},this.rules[5].opcodes[2]={type:4,index:6},this.rules[5].opcodes[3]={type:3,min:0,max:1},this.rules[5].opcodes[4]={type:3,min:0,max:1/0},this.rules[5].opcodes[5]={type:4,index:8},this.rules[5].opcodes[6]={type:3,min:0,max:1/0},this.rules[5].opcodes[7]={type:4,index:8},this.rules[6].opcodes=[],this.rules[6].opcodes[0]={type:2,children:[1,2,4]},this.rules[6].opcodes[1]={type:4,index:24},this.rules[6].opcodes[2]={type:3,min:0,max:1/0},this.rules[6].opcodes[3]={type:4,index:7},this.rules[6].opcodes[4]={type:4,index:24},this.rules[7].opcodes=[],this.rules[7].opcodes[0]={type:1,children:[1,2]},this.rules[7].opcodes[1]={type:5,min:32,max:33},this.rules[7].opcodes[2]={type:5,min:35,max:126},this.rules[8].opcodes=[],this.rules[8].opcodes[0]={type:1,children:[1,2,3]},this.rules[8].opcodes[1]={type:5,min:33,max:43},this.rules[8].opcodes[2]={type:5,min:45,max:58},this.rules[8].opcodes[3]={type:5,min:60,max:126},this.rules[9].opcodes=[],this.rules[9].opcodes[0]={type:2,children:[1,2]},this.rules[9].opcodes[1]={type:4,index:10},this.rules[9].opcodes[2]={type:3,min:0,max:1/0},this.rules[9].opcodes[3]={type:2,children:[4,5,6]},this.rules[9].opcodes[4]={type:7,string:[59]},this.rules[9].opcodes[5]={type:4,index:20},this.rules[9].opcodes[6]={type:4,index:10},this.rules[10].opcodes=[],this.rules[10].opcodes[0]={type:2,children:[1,2,3]},this.rules[10].opcodes[1]={type:4,index:11},this.rules[10].opcodes[2]={type:7,string:[61]},this.rules[10].opcodes[3]={type:4,index:12},this.rules[11].opcodes=[],this.rules[11].opcodes[0]={type:4,index:15},this.rules[12].opcodes=[],this.rules[12].opcodes[0]={type:1,children:[1,6]},this.rules[12].opcodes[1]={type:2,children:[2,3,5]},this.rules[12].opcodes[2]={type:4,index:24},this.rules[12].opcodes[3]={type:3,min:0,max:1/0},this.rules[12].opcodes[4]={type:4,index:13},this.rules[12].opcodes[5]={type:4,index:24},this.rules[12].opcodes[6]={type:3,min:0,max:1/0},this.rules[12].opcodes[7]={type:4,index:13},this.rules[13].opcodes=[],this.rules[13].opcodes[0]={type:1,children:[1,2,3,4,5]},this.rules[13].opcodes[1]={type:6,string:[33]},this.rules[13].opcodes[2]={type:5,min:35,max:43},this.rules[13].opcodes[3]={type:5,min:45,max:58},this.rules[13].opcodes[4]={type:5,min:60,max:91},this.rules[13].opcodes[5]={type:5,min:93,max:126},this.rules[14].opcodes=[],this.rules[14].opcodes[0]={type:3,min:0,max:1/0},this.rules[14].opcodes[1]={type:2,children:[2,4]},this.rules[14].opcodes[2]={type:3,min:0,max:1},this.rules[14].opcodes[3]={type:4,index:27},this.rules[14].opcodes[4]={type:4,index:25},this.rules[15].opcodes=[],this.rules[15].opcodes[0]={type:3,min:1,max:1/0},this.rules[15].opcodes[1]={type:4,index:16},this.rules[16].opcodes=[],this.rules[16].opcodes[0]={type:1,children:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]},this.rules[16].opcodes[1]={type:7,string:[33]},this.rules[16].opcodes[2]={type:7,string:[35]},this.rules[16].opcodes[3]={type:7,string:[36]},this.rules[16].opcodes[4]={type:7,string:[37]},this.rules[16].opcodes[5]={type:7,string:[38]},this.rules[16].opcodes[6]={type:7,string:[39]},this.rules[16].opcodes[7]={type:7,string:[42]},this.rules[16].opcodes[8]={type:7,string:[43]},this.rules[16].opcodes[9]={type:7,string:[45]},this.rules[16].opcodes[10]={type:7,string:[46]},this.rules[16].opcodes[11]={type:7,string:[94]},this.rules[16].opcodes[12]={type:7,string:[95]},this.rules[16].opcodes[13]={type:7,string:[96]},this.rules[16].opcodes[14]={type:7,string:[124]},this.rules[16].opcodes[15]={type:7,string:[126]},this.rules[16].opcodes[16]={type:4,index:23},this.rules[16].opcodes[17]={type:4,index:22},this.rules[17].opcodes=[],this.rules[17].opcodes[0]={type:5,min:1,max:127},this.rules[18].opcodes=[],this.rules[18].opcodes[0]={type:1,children:[1,2]},this.rules[18].opcodes[1]={type:5,min:0,max:31},this.rules[18].opcodes[2]={type:6,string:[127]},this.rules[19].opcodes=[],this.rules[19].opcodes[0]={type:1,children:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19]},this.rules[19].opcodes[1]={type:7,string:[40]},this.rules[19].opcodes[2]={type:7,string:[41]},this.rules[19].opcodes[3]={type:7,string:[60]},this.rules[19].opcodes[4]={type:7,string:[62]},this.rules[19].opcodes[5]={type:7,string:[64]},this.rules[19].opcodes[6]={type:7,string:[44]},this.rules[19].opcodes[7]={type:7,string:[59]},this.rules[19].opcodes[8]={type:7,string:[58]},this.rules[19].opcodes[9]={type:7,string:[92]},this.rules[19].opcodes[10]={type:6,string:[34]},this.rules[19].opcodes[11]={type:7,string:[47]},this.rules[19].opcodes[12]={type:7,string:[91]},this.rules[19].opcodes[13]={type:7,string:[93]},this.rules[19].opcodes[14]={type:7,string:[63]},this.rules[19].opcodes[15]={type:7,string:[61]},this.rules[19].opcodes[16]={type:7,string:[123]},this.rules[19].opcodes[17]={type:7,string:[125]},this.rules[19].opcodes[18]={type:4,index:20},this.rules[19].opcodes[19]={type:4,index:21},this.rules[20].opcodes=[],this.rules[20].opcodes[0]={type:6,string:[32]},this.rules[21].opcodes=[],this.rules[21].opcodes[0]={type:6,string:[9]},this.rules[22].opcodes=[],this.rules[22].opcodes[0]={type:1,children:[1,2]},this.rules[22].opcodes[1]={type:5,min:65,max:90},this.rules[22].opcodes[2]={type:5,min:97,max:122},this.rules[23].opcodes=[],this.rules[23].opcodes[0]={type:5,min:48,max:57},this.rules[24].opcodes=[],this.rules[24].opcodes[0]={type:6,string:[34]},this.rules[25].opcodes=[],this.rules[25].opcodes[0]={type:1,children:[1,2]},this.rules[25].opcodes[1]={type:4,index:20},this.rules[25].opcodes[2]={type:4,index:26},this.rules[26].opcodes=[],this.rules[26].opcodes[0]={type:6,string:[9]},this.rules[27].opcodes=[],this.rules[27].opcodes[0]={type:2,children:[1,2]},this.rules[27].opcodes[1]={type:4,index:28},this.rules[27].opcodes[2]={type:4,index:29},this.rules[28].opcodes=[],this.rules[28].opcodes[0]={type:6,string:[13]},this.rules[29].opcodes=[],this.rules[29].opcodes[0]={type:6,string:[10]},this.toString=function toString(){let s="";return s+="; Lenient version of https://datatracker.ietf.org/doc/html/rfc6265#section-4.2.1\n",s+='lenient-cookie-string        = lenient-cookie-entry *( ";" OWS lenient-cookie-entry )\n',s+="lenient-cookie-entry         = lenient-cookie-pair / lenient-cookie-pair-invalid\n",s+='lenient-cookie-pair          = OWS lenient-cookie-name OWS "=" OWS lenient-cookie-value OWS\n',s+='lenient-cookie-pair-invalid  = OWS 1*tchar OWS ; Allow for standalone entries like "fizz" to be ignored\n',s+='lenient-cookie-name          = 1*( %x21-3A / %x3C / %x3E-7E ) ; Allow all printable US-ASCII except "="\n',s+="lenient-cookie-value         = lenient-quoted-value [ *lenient-cookie-octet ] / *lenient-cookie-octet\n",s+="lenient-quoted-value         = DQUOTE *( lenient-quoted-char ) DQUOTE\n",s+="lenient-quoted-char          = %x20-21 / %x23-7E ; Allow all printable US-ASCII except DQUOTE\n",s+="lenient-cookie-octet         = %x21-2B / %x2D-3A / %x3C-7E\n",s+="                             ; Allow all printable characters except CTLs, semicolon and SP\n",s+="\n",s+="; https://datatracker.ietf.org/doc/html/rfc6265#section-4.2.1\n",s+='cookie-string     = cookie-pair *( ";" SP cookie-pair )\n',s+="\n",s+="; https://datatracker.ietf.org/doc/html/rfc6265#section-4.1.1\n",s+="; https://www.rfc-editor.org/errata/eid5518\n",s+='cookie-pair       = cookie-name "=" cookie-value\n',s+="cookie-name       = token\n",s+="cookie-value      = ( DQUOTE *cookie-octet DQUOTE ) / *cookie-octet\n",s+="                  ; https://www.rfc-editor.org/errata/eid8242\n",s+="cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E\n",s+="                       ; US-ASCII characters excluding CTLs,\n",s+="                       ; whitespace, DQUOTE, comma, semicolon,\n",s+="                       ; and backslash\n",s+="\n",s+="; https://datatracker.ietf.org/doc/html/rfc6265#section-2.2\n",s+='OWS            = *( [ CRLF ] WSP ) ; "optional" whitespace\n',s+="\n",s+="; https://datatracker.ietf.org/doc/html/rfc9110#section-5.6.2\n",s+="token          = 1*(tchar)\n",s+='tchar          = "!" / "#" / "$" / "%" / "&" / "\'" / "*"\n',s+='                 / "+" / "-" / "." / "^" / "_" / "`" / "|" / "~"\n',s+="                 / DIGIT / ALPHA\n",s+="                 ; any VCHAR, except delimiters\n",s+="\n",s+="; https://datatracker.ietf.org/doc/html/rfc2616#section-2.2\n",s+="CHAR           = %x01-7F ; any US-ASCII character (octets 0 - 127)\n",s+="CTL            = %x00-1F / %x7F ; any US-ASCII control character\n",s+='separators     = "(" / ")" / "<" / ">" / "@" / "," / ";" / ":" / "\\" / %x22 / "/" / "[" / "]" / "?" / "=" / "{" / "}" / SP / HT\n',s+="SP             = %x20 ; US-ASCII SP, space (32)\n",s+="HT             = %x09 ; US-ASCII HT, horizontal-tab (9)\n",s+="\n",s+="; https://datatracker.ietf.org/doc/html/rfc5234#appendix-B.1\n",s+="ALPHA          =  %x41-5A / %x61-7A ; A-Z / a-z\n",s+="DIGIT          =  %x30-39 ; 0-9\n",s+='DQUOTE         =  %x22 ; " (Double Quote)\n',s+="WSP            =  SP / HTAB ; white space\n",s+="HTAB           =  %x09 ; horizontal tab\n",s+="CRLF           =  CR LF ; Internet standard newline\n",s+="CR             =  %x0D ; carriage return\n",s+="LF             =  %x0A ; linefeed\n",'; Lenient version of https://datatracker.ietf.org/doc/html/rfc6265#section-4.2.1\nlenient-cookie-string        = lenient-cookie-entry *( ";" OWS lenient-cookie-entry )\nlenient-cookie-entry         = lenient-cookie-pair / lenient-cookie-pair-invalid\nlenient-cookie-pair          = OWS lenient-cookie-name OWS "=" OWS lenient-cookie-value OWS\nlenient-cookie-pair-invalid  = OWS 1*tchar OWS ; Allow for standalone entries like "fizz" to be ignored\nlenient-cookie-name          = 1*( %x21-3A / %x3C / %x3E-7E ) ; Allow all printable US-ASCII except "="\nlenient-cookie-value         = lenient-quoted-value [ *lenient-cookie-octet ] / *lenient-cookie-octet\nlenient-quoted-value         = DQUOTE *( lenient-quoted-char ) DQUOTE\nlenient-quoted-char          = %x20-21 / %x23-7E ; Allow all printable US-ASCII except DQUOTE\nlenient-cookie-octet         = %x21-2B / %x2D-3A / %x3C-7E\n                             ; Allow all printable characters except CTLs, semicolon and SP\n\n; https://datatracker.ietf.org/doc/html/rfc6265#section-4.2.1\ncookie-string     = cookie-pair *( ";" SP cookie-pair )\n\n; https://datatracker.ietf.org/doc/html/rfc6265#section-4.1.1\n; https://www.rfc-editor.org/errata/eid5518\ncookie-pair       = cookie-name "=" cookie-value\ncookie-name       = token\ncookie-value      = ( DQUOTE *cookie-octet DQUOTE ) / *cookie-octet\n                  ; https://www.rfc-editor.org/errata/eid8242\ncookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E\n                       ; US-ASCII characters excluding CTLs,\n                       ; whitespace, DQUOTE, comma, semicolon,\n                       ; and backslash\n\n; https://datatracker.ietf.org/doc/html/rfc6265#section-2.2\nOWS            = *( [ CRLF ] WSP ) ; "optional" whitespace\n\n; https://datatracker.ietf.org/doc/html/rfc9110#section-5.6.2\ntoken          = 1*(tchar)\ntchar          = "!" / "#" / "$" / "%" / "&" / "\'" / "*"\n                 / "+" / "-" / "." / "^" / "_" / "`" / "|" / "~"\n                 / DIGIT / ALPHA\n                 ; any VCHAR, except delimiters\n\n; https://datatracker.ietf.org/doc/html/rfc2616#section-2.2\nCHAR           = %x01-7F ; any US-ASCII character (octets 0 - 127)\nCTL            = %x00-1F / %x7F ; any US-ASCII control character\nseparators     = "(" / ")" / "<" / ">" / "@" / "," / ";" / ":" / "\\" / %x22 / "/" / "[" / "]" / "?" / "=" / "{" / "}" / SP / HT\nSP             = %x20 ; US-ASCII SP, space (32)\nHT             = %x09 ; US-ASCII HT, horizontal-tab (9)\n\n; https://datatracker.ietf.org/doc/html/rfc5234#appendix-B.1\nALPHA          =  %x41-5A / %x61-7A ; A-Z / a-z\nDIGIT          =  %x30-39 ; 0-9\nDQUOTE         =  %x22 ; " (Double Quote)\nWSP            =  SP / HTAB ; white space\nHTAB           =  %x09 ; horizontal tab\nCRLF           =  CR LF ; Internet standard newline\nCR             =  %x0D ; carriage return\nLF             =  %x0A ; linefeed\n'}}new grammar_grammar;const percentEncodeChar=s=>{if("string"!=typeof s||1!==[...s].length)throw new TypeError("Input must be a single character string.");const o=s.codePointAt(0);return o<=127?`%${o.toString(16).toUpperCase().padStart(2,"0")}`:encodeURIComponent(s)},utils_isQuoted=s=>s.length>=2&&s.startsWith('"')&&s.endsWith('"'),unquote=s=>utils_isQuoted(s)?s.slice(1,-1):s,quote=s=>`"${s}"`,utils_identity=s=>s,Tx=new yp,Nx=new grammar_grammar,test_cookie_value=(s,{strict:o=!0,quoted:i=null}={})=>{try{const a=o?"cookie-value":"lenient-cookie-value",u=Tx.parse(Nx,a,s);return"boolean"==typeof i?u.success&&i===utils_isQuoted(s):u.success}catch{return!1}},base64_browser=s=>{const o=(new TextEncoder).encode(s).reduce(((s,o)=>s+String.fromCharCode(o)),"");return btoa(o)},cookie_value_strict_base64=(s,o=base64_browser)=>{const i=String(s);if(test_cookie_value(i))return i;const a=utils_isQuoted(i),u=o(a?unquote(i):i);return a?quote(u):u},base64url_browser=s=>(s=>s.replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/g,""))(base64_browser(s)),cookie_value_strict_base64url=s=>cookie_value_strict_base64(s,base64url_browser),Mx=new yp,Rx=new grammar_grammar,test_cookie_name=(s,{strict:o=!0}={})=>{try{const i=o?"cookie-name":"lenient-cookie-name";return Mx.parse(Rx,i,s).success}catch{return!1}},cookie_name_strict=s=>{if(!test_cookie_name(s))throw new TypeError(`Invalid cookie name: ${s}`)},cookie_value_strict=s=>{if(!test_cookie_value(s))throw new TypeError(`Invalid cookie value: ${s}`)},Dx={encoders:{name:utils_identity,value:cookie_value_strict_base64url},validators:{name:cookie_name_strict,value:cookie_value_strict}},set_cookie_serialize=(s,o,i={})=>{const a={...Dx,...i,encoders:{...Dx.encoders,...i.encoders},validators:{...Dx.validators,...i.validators}},u=a.encoders.name(s),_=a.encoders.value(o);return a.validators.name(u),a.validators.value(_),`${u}=${_}`},cookie_serialize=(s,o={})=>(Array.isArray(s)?s:"object"==typeof s&&null!==s?Object.entries(s):[]).map((([s,i])=>set_cookie_serialize(s,i,o))).join("; ");const Lx=new yp,Fx=new grammar_grammar,cookie_value_strict_percent=s=>{const o=String(s);if(test_cookie_value(o))return o;const i=utils_isQuoted(o),a=i?unquote(o):o;let u="";for(const s of a)u+=Lx.parse(Fx,"cookie-octet",s).success?s:percentEncodeChar(s);return i?quote(u):u};new yp,new grammar_grammar;const cookie_name_lenient=s=>{if(!test_cookie_name(s,{strict:!1}))throw new TypeError(`Invalid cookie name: ${s}`)};const valuePercentEncoder=s=>cookie_value_strict_percent(s).replace(/[=&]/gu,(s=>"="===s?"%3D":"%26")),helpers_cookie_serialize=(s,o={})=>cookie_serialize(s,tp({encoders:{name:utils_identity,value:valuePercentEncoder},validators:{name:cookie_name_lenient,value:cookie_value_strict}},o));function parameter_builders_path({req:s,value:o,parameter:i,baseURL:a}){const{name:u,style:_,explode:w,content:x}=i;if(void 0===o)return;const C=s.url.replace(a,"");let j;if(x){const s=Object.keys(x)[0];j=es_resolve(C,{[u]:o},{encoder:o=>encodeCharacters(serialize(o,s))})}else j=es_resolve(C,{[u]:o},{encoder:s=>stylize({key:i.name,value:s,style:_||"simple",explode:w??!1,escape:"reserved"})});s.url=a+j}function query({req:s,value:o,parameter:i}){if(s.query=s.query||{},void 0!==o&&i.content){const a=serialize(o,Object.keys(i.content)[0]);if(a)s.query[i.name]=a;else if(i.allowEmptyValue){const o=i.name;s.query[o]=s.query[o]||{},s.query[o].allowEmptyValue=!0}}else if(!1===o&&(o="false"),0===o&&(o="0"),o){const{style:a,explode:u,allowReserved:_}=i;s.query[i.name]={value:o,serializationOption:{style:a,explode:u,allowReserved:_}}}else if(i.allowEmptyValue&&void 0!==o){const o=i.name;s.query[o]=s.query[o]||{},s.query[o].allowEmptyValue=!0}}const Bx=["accept","authorization","content-type"];function parameter_builders_header({req:s,parameter:o,value:i}){if(s.headers=s.headers||{},!(Bx.indexOf(o.name.toLowerCase())>-1))if(void 0!==i&&o.content){const a=Object.keys(o.content)[0];s.headers[o.name]=serialize(i,a)}else void 0===i||Array.isArray(i)&&0===i.length||(s.headers[o.name]=stylize({key:o.name,value:i,style:o.style||"simple",explode:void 0!==o.explode&&o.explode,escape:!1}))}function cookie({req:s,parameter:o,value:i}){const{name:a}=o;if(s.headers=s.headers||{},void 0!==i&&o.content){const u=serialize(i,Object.keys(o.content)[0]);s.headers.Cookie=helpers_cookie_serialize({[a]:u})}else if(void 0!==i&&(!Array.isArray(i)||0!==i.length)){const u=stylize({key:o.name,value:i,escape:!1,style:o.style||"form",explode:o.explode??!1}),_=Array.isArray(i)&&o.explode?`${a}=${u}`:u;s.headers.Cookie=helpers_cookie_serialize({[a]:_})}}const $x="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:window,{btoa:qx}=$x,Ux=qx;function buildRequest(s,o){const{operation:i,requestBody:a,securities:u,spec:_,attachContentTypeForEmptyPayload:w}=s;let{requestContentType:x}=s;o=function applySecurities({request:s,securities:o={},operation:i={},spec:a}){const u={...s},{authorized:_={}}=o,w=i.security||a.security||[],x=_&&!!Object.keys(_).length,C=a?.components?.securitySchemes||{};if(u.headers=u.headers||{},u.query=u.query||{},!Object.keys(o).length||!x||!w||Array.isArray(i.security)&&!i.security.length)return s;return w.forEach((s=>{Object.keys(s).forEach((s=>{const o=_[s],i=C[s];if(!o)return;const a=o.value||o,{type:w}=i;if(o)if("apiKey"===w)"query"===i.in&&(u.query[i.name]=a),"header"===i.in&&(u.headers[i.name]=a),"cookie"===i.in&&(u.cookies[i.name]=a);else if("http"===w){if(/^basic$/i.test(i.scheme)){const s=a.username||"",o=a.password||"",i=Ux(`${s}:${o}`);u.headers.Authorization=`Basic ${i}`}/^bearer$/i.test(i.scheme)&&(u.headers.Authorization=`Bearer ${a}`)}else if("oauth2"===w||"openIdConnect"===w){const s=o.token||{},a=s[i["x-tokenName"]||"access_token"];let _=s.token_type;_&&"bearer"!==_.toLowerCase()||(_="Bearer"),u.headers.Authorization=`${_} ${a}`}}))})),u}({request:o,securities:u,operation:i,spec:_});const C=i.requestBody||{},j=Object.keys(C.content||{}),L=x&&j.indexOf(x)>-1;if(a||w){if(x&&L)o.headers["Content-Type"]=x;else if(!x){const s=j[0];s&&(o.headers["Content-Type"]=s,x=s)}}else x&&L&&(o.headers["Content-Type"]=x);if(!s.responseContentType&&i.responses){const s=Object.entries(i.responses).filter((([s,o])=>{const i=parseInt(s,10);return i>=200&&i<300&&iu(o.content)})).reduce(((s,[,o])=>s.concat(Object.keys(o.content))),[]);s.length>0&&(o.headers.accept=s.join(", "))}if(a)if(x){if(j.indexOf(x)>-1)if("application/x-www-form-urlencoded"===x||"multipart/form-data"===x)if("object"==typeof a){const s=C.content[x]?.encoding??{};o.form={},Object.keys(a).forEach((i=>{let u;try{u=JSON.parse(a[i])}catch{u=a[i]}o.form[i]={value:u,encoding:s[i]||{}}}))}else if("string"==typeof a){const s=C.content[x]?.encoding??{};try{o.form={};const i=JSON.parse(a);Object.entries(i).forEach((([i,a])=>{o.form[i]={value:a,encoding:s[i]||{}}}))}catch{o.form=a}}else o.form=a;else o.body=a}else o.body=a;return o}function build_request_buildRequest(s,o){const{spec:i,operation:a,securities:u,requestContentType:_,responseContentType:w,attachContentTypeForEmptyPayload:x}=s;if(o=function build_request_applySecurities({request:s,securities:o={},operation:i={},spec:a}){const u={...s},{authorized:_={},specSecurity:w=[]}=o,x=i.security||w,C=_&&!!Object.keys(_).length,j=a.securityDefinitions;if(u.headers=u.headers||{},u.query=u.query||{},!Object.keys(o).length||!C||!x||Array.isArray(i.security)&&!i.security.length)return s;return x.forEach((s=>{Object.keys(s).forEach((s=>{const o=_[s];if(!o)return;const{token:i}=o,a=o.value||o,w=j[s],{type:x}=w,C=w["x-tokenName"]||"access_token",L=i&&i[C];let B=i&&i.token_type;if(o)if("apiKey"===x){const s="query"===w.in?"query":"headers";u[s]=u[s]||{},u[s][w.name]=a}else if("basic"===x)if(a.header)u.headers.authorization=a.header;else{const s=a.username||"",o=a.password||"";a.base64=Ux(`${s}:${o}`),u.headers.authorization=`Basic ${a.base64}`}else"oauth2"===x&&L&&(B=B&&"bearer"!==B.toLowerCase()?B:"Bearer",u.headers.authorization=`${B} ${L}`)}))})),u}({request:o,securities:u,operation:a,spec:i}),o.body||o.form||x)_?o.headers["Content-Type"]=_:Array.isArray(a.consumes)?[o.headers["Content-Type"]]=a.consumes:Array.isArray(i.consumes)?[o.headers["Content-Type"]]=i.consumes:a.parameters&&a.parameters.filter((s=>"file"===s.type)).length?o.headers["Content-Type"]="multipart/form-data":a.parameters&&a.parameters.filter((s=>"formData"===s.in)).length&&(o.headers["Content-Type"]="application/x-www-form-urlencoded");else if(_){const s=a.parameters&&a.parameters.filter((s=>"body"===s.in)).length>0,i=a.parameters&&a.parameters.filter((s=>"formData"===s.in)).length>0;(s||i)&&(o.headers["Content-Type"]=_)}return!w&&Array.isArray(a.produces)&&a.produces.length>0&&(o.headers.accept=a.produces.join(", ")),o}function idFromPathMethodLegacy(s,o){return`${o.toLowerCase()}-${s}`}const arrayOrEmpty=s=>Array.isArray(s)?s:[],findObjectOrArraySchema=(s,{recurse:o=!0,depth:i=1}={})=>{var a,u;if(iu(s)){if("object"===s.type||"array"===s.type||Array.isArray(s.type)&&(tl()(a=s.type).call(a,"object")||tl()(u=s.type).call(u,"array")))return s;if(!(i>Pl)&&o){const a=Array.isArray(s.oneOf)?s.oneOf.find((s=>findObjectOrArraySchema(s,{recurse:o,depth:i+1}))):void 0;if(a)return a;const u=Array.isArray(s.anyOf)?s.anyOf.find((s=>findObjectOrArraySchema(s,{recurse:o,depth:i+1}))):void 0;if(u)return u}}},parseJsonObjectOrArray=({value:s,silentFail:o=!1})=>{try{const i=JSON.parse(s);if(iu(i)||Array.isArray(i))return i;if(!o)throw new Error("Expected JSON serialized object or array")}catch{if(!o)throw new Error("Could not parse parameter value string as JSON Object or JSON Array")}return s},parseURIReference=s=>{try{return new URL(s)}catch{const o=new URL(s,Al),i=String(s).startsWith("/")?o.pathname:o.pathname.substring(1);return{hash:o.hash,host:"",hostname:"",href:"",origin:"",password:"",pathname:i,port:"",protocol:"",search:o.search,searchParams:o.searchParams}}};class OperationNotFoundError extends Go{}const Vx={buildRequest:execute_buildRequest};function execute_execute({http:s,fetch:o,spec:i,operationId:a,pathName:u,method:_,parameters:w,securities:x,...C}){const j=s||o||http_http;u&&_&&!a&&(a=idFromPathMethodLegacy(u,_));const L=Vx.buildRequest({spec:i,operationId:a,parameters:w,securities:x,http:j,...C});return L.body&&(iu(L.body)||Array.isArray(L.body))&&(L.body=JSON.stringify(L.body)),j(L)}function execute_buildRequest(s){const{spec:o,operationId:i,responseContentType:a,scheme:u,requestInterceptor:_,responseInterceptor:w,contextUrl:x,userFetch:C,server:j,serverVariables:L,http:B,signal:$,serverVariableEncoder:U}=s;let{parameters:V,parameterBuilders:z,baseURL:Y}=s;const Z=isOpenAPI3(o);z||(z=Z?be:Ix);let ee={url:"",credentials:B&&B.withCredentials?"include":"same-origin",headers:{},cookies:{}};$&&(ee.signal=$),_&&(ee.requestInterceptor=_),w&&(ee.responseInterceptor=w),C&&(ee.userFetch=C);const ie=function getOperationRaw(s,o){return s&&s.paths?function findOperation(s,o){return function eachOperation(s,o,i){if(!s||"object"!=typeof s||!s.paths||"object"!=typeof s.paths)return null;const{paths:a}=s;for(const u in a)for(const _ in a[u]){if("PARAMETERS"===_.toUpperCase())continue;const w=a[u][_];if(!w||"object"!=typeof w)continue;const x={spec:s,pathName:u,method:_.toUpperCase(),operation:w},C=o(x);if(i&&C)return x}}(s,o,!0)||null}(s,(({pathName:s,method:i,operation:a})=>{if(!a||"object"!=typeof a)return!1;const u=a.operationId;return[opId(a,s,i),idFromPathMethodLegacy(s,i),u].some((s=>s&&s===o))})):null}(o,i);if(!ie)throw new OperationNotFoundError(`Operation ${i} not found`);const{operation:ae={},method:ce,pathName:le}=ie;if(Y=Y??function baseUrl(s){const o=isOpenAPI3(s.spec);return o?function oas3BaseUrl({spec:s,pathName:o,method:i,server:a,contextUrl:u,serverVariables:_={},serverVariableEncoder:w}){let x,C=[],j="";const L=s?.paths?.[o]?.[(i||"").toLowerCase()]?.servers,B=s?.paths?.[o]?.servers,$=s?.servers;C=isNonEmptyServerList(L)?L:isNonEmptyServerList(B)?B:isNonEmptyServerList($)?$:[Cl],a&&(x=C.find((s=>s.url===a)),x&&(j=a));j||([x]=C,j=x.url);if(es_test(j,{strict:!0})){const s=Object.entries({...x.variables}).reduce(((s,[o,i])=>(s[o]=i.default,s)),{});j=es_substitute(j,{...s,..._},{encoder:"function"==typeof w?w:lw})}return function buildOas3UrlWithContext(s="",o=""){const i=parseURIReference(s&&o?resolve(o,s):s),a=parseURIReference(o),u=stripNonAlpha(i.protocol)||stripNonAlpha(a.protocol),_=i.host||a.host,w=i.pathname;let x;x=u&&_?`${u}://${_+w}`:w;return"/"===x[x.length-1]?x.slice(0,-1):x}(j,u)}(s):function swagger2BaseUrl({spec:s,scheme:o,contextUrl:i=""}){const a=parseURIReference(i),u=Array.isArray(s.schemes)?s.schemes[0]:null,_=o||u||stripNonAlpha(a.protocol)||"http",w=s.host||a.host||"",x=s.basePath||"";let C;C=_&&w?`${_}://${w+x}`:x;return"/"===C[C.length-1]?C.slice(0,-1):C}(s)}({spec:o,scheme:u,contextUrl:x,server:j,serverVariables:L,pathName:le,method:ce,serverVariableEncoder:U}),ee.url+=Y,!i)return delete ee.cookies,ee;ee.url+=le,ee.method=`${ce}`.toUpperCase(),V=V||{};const pe=o.paths[le]||{};a&&(ee.headers.accept=a);const de=(s=>{const o={};s.forEach((s=>{o[s.in]||(o[s.in]={}),o[s.in][s.name]=s}));const i=[];return Object.keys(o).forEach((s=>{Object.keys(o[s]).forEach((a=>{i.push(o[s][a])}))})),i})([].concat(arrayOrEmpty(ae.parameters)).concat(arrayOrEmpty(pe.parameters)));de.forEach((s=>{const i=z[s.in];let a;if("body"===s.in&&s.schema&&s.schema.properties&&(a=V),a=s&&s.name&&V[s.name],void 0===a?a=s&&s.name&&V[`${s.in}.${s.name}`]:((s,o)=>o.filter((o=>o.name===s)))(s.name,de).length>1&&console.warn(`Parameter '${s.name}' is ambiguous because the defined spec has more than one parameter with the name: '${s.name}' and the passed-in parameter values did not define an 'in' value.`),null!==a){if(void 0!==s.default&&void 0===a&&(a=s.default),void 0===a&&s.required&&!s.allowEmptyValue)throw new Error(`Required parameter ${s.name} is not provided`);Z&&"string"==typeof a&&(Uu("type",s.schema)&&"string"==typeof s.schema.type&&findObjectOrArraySchema(s.schema,{recurse:!1})?a=parseJsonObjectOrArray({value:a,silentFail:!1}):(Uu("type",s.schema)&&Array.isArray(s.schema.type)&&findObjectOrArraySchema(s.schema,{recurse:!1})||!Uu("type",s.schema)&&findObjectOrArraySchema(s.schema,{recurse:!0}))&&(a=parseJsonObjectOrArray({value:a,silentFail:!0}))),i&&i({req:ee,parameter:s,value:a,operation:ae,spec:o,baseURL:Y})}}));const fe={...s,operation:ae};if(ee=Z?buildRequest(fe,ee):build_request_buildRequest(fe,ee),ee.cookies&&Object.keys(ee.cookies).length>0){const s=helpers_cookie_serialize(ee.cookies);_d(ee.headers.Cookie)?ee.headers.Cookie+=`; ${s}`:ee.headers.Cookie=s}return ee.cookies&&delete ee.cookies,serializeRequest(ee)}const stripNonAlpha=s=>s?s.replace(/\W/g,""):null;const isNonEmptyServerList=s=>Array.isArray(s)&&s.length>0;const makeResolveSubtree=s=>async(o,i,a={})=>(async(s,o,i={})=>{const{returnEntireTree:a,baseDoc:u,requestInterceptor:_,responseInterceptor:w,parameterMacro:x,modelPropertyMacro:C,useCircularStructures:j,strategies:L}=i,B={spec:s,pathDiscriminator:o,baseDoc:u,requestInterceptor:_,responseInterceptor:w,parameterMacro:x,modelPropertyMacro:C,useCircularStructures:j,strategies:L},$=L.find((o=>o.match(s))).normalize(s),U=await Ox({spec:$,...B,allowMetaPatches:!0,skipNormalization:!isOpenAPI31(s)});return!a&&Array.isArray(o)&&o.length&&(U.spec=o.reduce(((s,o)=>s?.[o]),U.spec)||null),U})(o,i,{...s,...a}),zx=(makeResolveSubtree({strategies:[hu,uu,cu]}),(s,o)=>(...i)=>{s(...i);const a=o.getConfigs().withCredentials;o.fn.fetch.withCredentials=a});function swagger_client({configs:s,getConfigs:o}){return{fn:{fetch:(i=http_http,a=s.preFetch,u=s.postFetch,u=u||(s=>s),a=a||(s=>s),s=>("string"==typeof s&&(s={url:s}),s=serializeRequest(s),s=a(s),u(i(s)))),buildRequest:execute_buildRequest,execute:execute_execute,resolve:makeResolve({strategies:[kx,hu,uu,cu]}),resolveSubtree:async(s,i,a={})=>{const u=o(),_={modelPropertyMacro:u.modelPropertyMacro,parameterMacro:u.parameterMacro,requestInterceptor:u.requestInterceptor,responseInterceptor:u.responseInterceptor,strategies:[kx,hu,uu,cu]};return makeResolveSubtree(_)(s,i,a)},serializeRes:serializeResponse,opId},statePlugins:{configs:{wrapActions:{loaded:zx}}}};var i,a,u}function util(){return{fn:{shallowEqualKeys,sanitizeUrl}}}var Wx=__webpack_require__(40961),Jx=(__webpack_require__(78418),Re.version.startsWith("19")),Hx=Symbol.for(Jx?"react.transitional.element":"react.element"),Kx=Symbol.for("react.portal"),Gx=Symbol.for("react.fragment"),Yx=Symbol.for("react.strict_mode"),Xx=Symbol.for("react.profiler"),Qx=Symbol.for("react.consumer"),Zx=Symbol.for("react.context"),tk=Symbol.for("react.forward_ref"),rk=Symbol.for("react.suspense"),nk=Symbol.for("react.suspense_list"),sk=Symbol.for("react.memo"),ok=Symbol.for("react.lazy"),lk=tk,uk=sk;function typeOf(s){if("object"==typeof s&&null!==s){const{$$typeof:o}=s;switch(o){case Hx:switch(s=s.type){case Gx:case Xx:case Yx:case rk:case nk:return s;default:switch(s=s&&s.$$typeof){case Zx:case tk:case ok:case sk:case Qx:return s;default:return o}}case Kx:return o}}}function pureFinalPropsSelectorFactory(s,o,i,a,{areStatesEqual:u,areOwnPropsEqual:_,areStatePropsEqual:w}){let x,C,j,L,B,$=!1;function handleSubsequentCalls($,U){const V=!_(U,C),z=!u($,x,U,C);return x=$,C=U,V&&z?function handleNewPropsAndNewState(){return j=s(x,C),o.dependsOnOwnProps&&(L=o(a,C)),B=i(j,L,C),B}():V?function handleNewProps(){return s.dependsOnOwnProps&&(j=s(x,C)),o.dependsOnOwnProps&&(L=o(a,C)),B=i(j,L,C),B}():z?function handleNewState(){const o=s(x,C),a=!w(o,j);return j=o,a&&(B=i(j,L,C)),B}():B}return function pureFinalPropsSelector(u,_){return $?handleSubsequentCalls(u,_):function handleFirstCall(u,_){return x=u,C=_,j=s(x,C),L=o(a,C),B=i(j,L,C),$=!0,B}(u,_)}}function wrapMapToPropsConstant(s){return function initConstantSelector(o){const i=s(o);function constantSelector(){return i}return constantSelector.dependsOnOwnProps=!1,constantSelector}}function getDependsOnOwnProps(s){return s.dependsOnOwnProps?Boolean(s.dependsOnOwnProps):1!==s.length}function wrapMapToPropsFunc(s,o){return function initProxySelector(o,{displayName:i}){const a=function mapToPropsProxy(s,o){return a.dependsOnOwnProps?a.mapToProps(s,o):a.mapToProps(s,void 0)};return a.dependsOnOwnProps=!0,a.mapToProps=function detectFactoryAndVerify(o,i){a.mapToProps=s,a.dependsOnOwnProps=getDependsOnOwnProps(s);let u=a(o,i);return"function"==typeof u&&(a.mapToProps=u,a.dependsOnOwnProps=getDependsOnOwnProps(u),u=a(o,i)),u},a}}function createInvalidArgFactory(s,o){return(i,a)=>{throw new Error(`Invalid value of type ${typeof s} for ${o} argument when connecting component ${a.wrappedComponentName}.`)}}function defaultMergeProps(s,o,i){return{...i,...s,...o}}function defaultNoopBatch(s){s()}var pk={notify(){},get:()=>[]};function createSubscription(s,o){let i,a=pk,u=0,_=!1;function handleChangeWrapper(){w.onStateChange&&w.onStateChange()}function trySubscribe(){u++,i||(i=o?o.addNestedSub(handleChangeWrapper):s.subscribe(handleChangeWrapper),a=function createListenerCollection(){let s=null,o=null;return{clear(){s=null,o=null},notify(){defaultNoopBatch((()=>{let o=s;for(;o;)o.callback(),o=o.next}))},get(){const o=[];let i=s;for(;i;)o.push(i),i=i.next;return o},subscribe(i){let a=!0;const u=o={callback:i,next:null,prev:o};return u.prev?u.prev.next=u:s=u,function unsubscribe(){a&&null!==s&&(a=!1,u.next?u.next.prev=u.prev:o=u.prev,u.prev?u.prev.next=u.next:s=u.next)}}}}())}function tryUnsubscribe(){u--,i&&0===u&&(i(),i=void 0,a.clear(),a=pk)}const w={addNestedSub:function addNestedSub(s){trySubscribe();const o=a.subscribe(s);let i=!1;return()=>{i||(i=!0,o(),tryUnsubscribe())}},notifyNestedSubs:function notifyNestedSubs(){a.notify()},handleChangeWrapper,isSubscribed:function isSubscribed(){return _},trySubscribe:function trySubscribeSelf(){_||(_=!0,trySubscribe())},tryUnsubscribe:function tryUnsubscribeSelf(){_&&(_=!1,tryUnsubscribe())},getListeners:()=>a};return w}var fk=(()=>!("undefined"==typeof window||void 0===window.document||void 0===window.document.createElement))(),mk=(()=>"undefined"!=typeof navigator&&"ReactNative"===navigator.product)(),yk=(()=>fk||mk?Re.useLayoutEffect:Re.useEffect)();function is(s,o){return s===o?0!==s||0!==o||1/s==1/o:s!=s&&o!=o}function shallowEqual(s,o){if(is(s,o))return!0;if("object"!=typeof s||null===s||"object"!=typeof o||null===o)return!1;const i=Object.keys(s),a=Object.keys(o);if(i.length!==a.length)return!1;for(let a=0;a<i.length;a++)if(!Object.prototype.hasOwnProperty.call(o,i[a])||!is(s[i[a]],o[i[a]]))return!1;return!0}var vk={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},_k={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},wk={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},xk={[lk]:{$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},[uk]:wk};function getStatics(s){return function isMemo(s){return typeOf(s)===sk}(s)?wk:xk[s.$$typeof]||vk}var Ak=Object.defineProperty,Bk=Object.getOwnPropertyNames,qk=Object.getOwnPropertySymbols,Vk=Object.getOwnPropertyDescriptor,zk=Object.getPrototypeOf,eO=Object.prototype;function hoistNonReactStatics(s,o){if("string"!=typeof o){if(eO){const i=zk(o);i&&i!==eO&&hoistNonReactStatics(s,i)}let i=Bk(o);qk&&(i=i.concat(qk(o)));const a=getStatics(s),u=getStatics(o);for(let _=0;_<i.length;++_){const w=i[_];if(!(_k[w]||u&&u[w]||a&&a[w])){const i=Vk(o,w);try{Ak(s,w,i)}catch(s){}}}}return s}var tO=Symbol.for("react-redux-context"),rO="undefined"!=typeof globalThis?globalThis:{};function getContext(){if(!Re.createContext)return{};const s=rO[tO]??=new Map;let o=s.get(Re.createContext);return o||(o=Re.createContext(null),s.set(Re.createContext,o)),o}var nO=getContext(),sO=[null,null];function captureWrapperProps(s,o,i,a,u,_){s.current=a,i.current=!1,u.current&&(u.current=null,_())}function strictEqual(s,o){return s===o}var oO=function connect(s,o,i,{pure:a,areStatesEqual:u=strictEqual,areOwnPropsEqual:_=shallowEqual,areStatePropsEqual:w=shallowEqual,areMergedPropsEqual:x=shallowEqual,forwardRef:C=!1,context:j=nO}={}){const L=j,B=function mapStateToPropsFactory(s){return s?"function"==typeof s?wrapMapToPropsFunc(s):createInvalidArgFactory(s,"mapStateToProps"):wrapMapToPropsConstant((()=>({})))}(s),$=function mapDispatchToPropsFactory(s){return s&&"object"==typeof s?wrapMapToPropsConstant((o=>function react_redux_bindActionCreators(s,o){const i={};for(const a in s){const u=s[a];"function"==typeof u&&(i[a]=(...s)=>o(u(...s)))}return i}(s,o))):s?"function"==typeof s?wrapMapToPropsFunc(s):createInvalidArgFactory(s,"mapDispatchToProps"):wrapMapToPropsConstant((s=>({dispatch:s})))}(o),U=function mergePropsFactory(s){return s?"function"==typeof s?function wrapMergePropsFunc(s){return function initMergePropsProxy(o,{displayName:i,areMergedPropsEqual:a}){let u,_=!1;return function mergePropsProxy(o,i,w){const x=s(o,i,w);return _?a(x,u)||(u=x):(_=!0,u=x),u}}}(s):createInvalidArgFactory(s,"mergeProps"):()=>defaultMergeProps}(i),V=Boolean(s);return s=>{const o=s.displayName||s.name||"Component",i=`Connect(${o})`,a={shouldHandleStateChanges:V,displayName:i,wrappedComponentName:o,WrappedComponent:s,initMapStateToProps:B,initMapDispatchToProps:$,initMergeProps:U,areStatesEqual:u,areStatePropsEqual:w,areOwnPropsEqual:_,areMergedPropsEqual:x};function ConnectFunction(o){const[i,u,_]=Re.useMemo((()=>{const{reactReduxForwardedRef:s,...i}=o;return[o.context,s,i]}),[o]),w=Re.useMemo((()=>L),[i,L]),x=Re.useContext(w),C=Boolean(o.store)&&Boolean(o.store.getState)&&Boolean(o.store.dispatch),j=Boolean(x)&&Boolean(x.store);const B=C?o.store:x.store,$=j?x.getServerState:B.getState,U=Re.useMemo((()=>function finalPropsSelectorFactory(s,{initMapStateToProps:o,initMapDispatchToProps:i,initMergeProps:a,...u}){return pureFinalPropsSelectorFactory(o(s,u),i(s,u),a(s,u),s,u)}(B.dispatch,a)),[B]),[z,Y]=Re.useMemo((()=>{if(!V)return sO;const s=createSubscription(B,C?void 0:x.subscription),o=s.notifyNestedSubs.bind(s);return[s,o]}),[B,C,x]),Z=Re.useMemo((()=>C?x:{...x,subscription:z}),[C,x,z]),ee=Re.useRef(void 0),ie=Re.useRef(_),ae=Re.useRef(void 0),ce=Re.useRef(!1),le=Re.useRef(!1),pe=Re.useRef(void 0);yk((()=>(le.current=!0,()=>{le.current=!1})),[]);const de=Re.useMemo((()=>()=>ae.current&&_===ie.current?ae.current:U(B.getState(),_)),[B,_]),fe=Re.useMemo((()=>s=>z?function subscribeUpdates(s,o,i,a,u,_,w,x,C,j,L){if(!s)return()=>{};let B=!1,$=null;const checkForUpdates=()=>{if(B||!x.current)return;const s=o.getState();let i,U;try{i=a(s,u.current)}catch(s){U=s,$=s}U||($=null),i===_.current?w.current||j():(_.current=i,C.current=i,w.current=!0,L())};return i.onStateChange=checkForUpdates,i.trySubscribe(),checkForUpdates(),()=>{if(B=!0,i.tryUnsubscribe(),i.onStateChange=null,$)throw $}}(V,B,z,U,ie,ee,ce,le,ae,Y,s):()=>{}),[z]);let ye;!function useIsomorphicLayoutEffectWithArgs(s,o,i){yk((()=>s(...o)),i)}(captureWrapperProps,[ie,ee,ce,_,ae,Y]);try{ye=Re.useSyncExternalStore(fe,de,$?()=>U($(),_):de)}catch(s){throw pe.current&&(s.message+=`\nThe error may be correlated with this previous error:\n${pe.current.stack}\n\n`),s}yk((()=>{pe.current=void 0,ae.current=void 0,ee.current=ye}));const be=Re.useMemo((()=>Re.createElement(s,{...ye,ref:u})),[u,s,ye]);return Re.useMemo((()=>V?Re.createElement(w.Provider,{value:Z},be):be),[w,be,Z])}const j=Re.memo(ConnectFunction);if(j.WrappedComponent=s,j.displayName=ConnectFunction.displayName=i,C){const o=Re.forwardRef((function forwardConnectRef(s,o){return Re.createElement(j,{...s,reactReduxForwardedRef:o})}));return o.displayName=i,o.WrappedComponent=s,hoistNonReactStatics(o,s)}return hoistNonReactStatics(j,s)}};var iO=function Provider(s){const{children:o,context:i,serverState:a,store:u}=s,_=Re.useMemo((()=>{const s=createSubscription(u);return{store:u,subscription:s,getServerState:a?()=>a:void 0}}),[u,a]),w=Re.useMemo((()=>u.getState()),[u]);yk((()=>{const{subscription:s}=_;return s.onStateChange=s.notifyNestedSubs,s.trySubscribe(),w!==u.getState()&&s.notifyNestedSubs(),()=>{s.tryUnsubscribe(),s.onStateChange=void 0}}),[_,w]);const x=i||nO;return Re.createElement(x.Provider,{value:_},o)};var aO=__webpack_require__(83488),cO=__webpack_require__.n(aO);const withSystem=s=>o=>{const{fn:i}=s();class WithSystem extends Re.Component{render(){return Re.createElement(o,Mn()({},s(),this.props,this.context))}}return WithSystem.displayName=`WithSystem(${i.getDisplayName(o)})`,WithSystem},withRoot=(s,o)=>i=>{const{fn:a}=s();class WithRoot extends Re.Component{render(){return Re.createElement(iO,{store:o},Re.createElement(i,Mn()({},this.props,this.context)))}}return WithRoot.displayName=`WithRoot(${a.getDisplayName(i)})`,WithRoot},withConnect=(s,o,i)=>compose(i?withRoot(s,i):cO(),oO(((i,a)=>{const u={...a,...s()},_=o.prototype?.mapStateToProps||(s=>({state:s}));return _(i,u)})),withSystem(s))(o),handleProps=(s,o,i,a)=>{for(const u in o){const _=o[u];"function"==typeof _&&_(i[u],a[u],s())}},withMappedContainer=(s,o,i)=>(o,a)=>{const{fn:u}=s(),_=i(o,"root");class WithMappedContainer extends Re.Component{constructor(o,i){super(o,i),handleProps(s,a,o,{})}UNSAFE_componentWillReceiveProps(o){handleProps(s,a,o,this.props)}render(){const s=Gt()(this.props,a?Object.keys(a):[]);return Re.createElement(_,s)}}return WithMappedContainer.displayName=`WithMappedContainer(${u.getDisplayName(_)})`,WithMappedContainer},render=(s,o,i,a)=>u=>{const _=i(s,o,a)("App","root"),{createRoot:w}=Wx;w(u).render(Re.createElement(_,null))},getComponent=(s,o,i)=>(a,u,_={})=>{if("string"!=typeof a)throw new TypeError("Need a string, to fetch a component. Was given a "+typeof a);const w=i(a);return w?u?"root"===u?withConnect(s,w,o()):withConnect(s,w):w:(_.failSilently||s().log.warn("Could not find component:",a),null)},getDisplayName=s=>s.displayName||s.name||"Component",view=({getComponents:s,getStore:o,getSystem:i})=>{const a=(u=getComponent(i,o,s),Pt(u,((...s)=>JSON.stringify(s))));var u;const _=(s=>utils_memoizeN(s,((...s)=>s)))(withMappedContainer(i,0,a));return{rootInjects:{getComponent:a,makeMappedContainer:_,render:render(i,o,getComponent,s)},fn:{getDisplayName}}},view_legacy=({React:s,getSystem:o,getStore:i,getComponents:a})=>{const u={},_=parseInt(s?.version,10);return _>=16&&_<18&&(u.render=((s,o,i,a)=>u=>{const _=i(s,o,a)("App","root");Wx.render(Re.createElement(_,null),u)})(o,i,getComponent,a)),{rootInjects:u}};function downloadUrlPlugin(s){let{fn:o}=s;const i={download:s=>({errActions:i,specSelectors:a,specActions:u,getConfigs:_})=>{let{fetch:w}=o;const x=_();function next(o){if(o instanceof Error||o.status>=400)return u.updateLoadingStatus("failed"),i.newThrownErr(Object.assign(new Error((o.message||o.statusText)+" "+s),{source:"fetch"})),void(!o.status&&o instanceof Error&&function checkPossibleFailReasons(){try{let o;if("URL"in lt?o=new URL(s):(o=document.createElement("a"),o.href=s),"https:"!==o.protocol&&"https:"===lt.location.protocol){const s=Object.assign(new Error(`Possible mixed-content issue? The page was loaded over https:// but a ${o.protocol}// URL was specified. Check that you are not attempting to load mixed content.`),{source:"fetch"});return void i.newThrownErr(s)}if(o.origin!==lt.location.origin){const s=Object.assign(new Error(`Possible cross-origin (CORS) issue? The URL origin (${o.origin}) does not match the page (${lt.location.origin}). Check the server returns the correct 'Access-Control-Allow-*' headers.`),{source:"fetch"});i.newThrownErr(s)}}catch(s){return}}());u.updateLoadingStatus("success"),u.updateSpec(o.text),a.url()!==s&&u.updateUrl(s)}s=s||a.url(),u.updateLoadingStatus("loading"),i.clear({source:"fetch"}),w({url:s,loadSpec:!0,requestInterceptor:x.requestInterceptor||(s=>s),responseInterceptor:x.responseInterceptor||(s=>s),credentials:"same-origin",headers:{Accept:"application/json,*/*"}}).then(next,next)},updateLoadingStatus:s=>{let o=[null,"loading","failed","success","failedConfig"];return-1===o.indexOf(s)&&console.error(`Error: ${s} is not one of ${JSON.stringify(o)}`),{type:"spec_update_loading_status",payload:s}}};let a={loadingStatus:Ut((s=>s||(0,ze.Map)()),(s=>s.get("loadingStatus")||null))};return{statePlugins:{spec:{actions:i,reducers:{spec_update_loading_status:(s,o)=>"string"==typeof o.payload?s.set("loadingStatus",o.payload):s},selectors:a}}}}function arrayLikeToArray_arrayLikeToArray(s,o){(null==o||o>s.length)&&(o=s.length);for(var i=0,a=Array(o);i<o;i++)a[i]=s[i];return a}function toConsumableArray_toConsumableArray(s){return function arrayWithoutHoles_arrayWithoutHoles(s){if(Array.isArray(s))return arrayLikeToArray_arrayLikeToArray(s)}(s)||function iterableToArray_iterableToArray(s){if("undefined"!=typeof Symbol&&null!=s[Symbol.iterator]||null!=s["@@iterator"])return Array.from(s)}(s)||function unsupportedIterableToArray_unsupportedIterableToArray(s,o){if(s){if("string"==typeof s)return arrayLikeToArray_arrayLikeToArray(s,o);var i={}.toString.call(s).slice(8,-1);return"Object"===i&&s.constructor&&(i=s.constructor.name),"Map"===i||"Set"===i?Array.from(s):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?arrayLikeToArray_arrayLikeToArray(s,o):void 0}}(s)||function nonIterableSpread_nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function typeof_typeof(s){return typeof_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(s){return typeof s}:function(s){return s&&"function"==typeof Symbol&&s.constructor===Symbol&&s!==Symbol.prototype?"symbol":typeof s},typeof_typeof(s)}function toPropertyKey(s){var o=function toPrimitive(s,o){if("object"!=typeof_typeof(s)||!s)return s;var i=s[Symbol.toPrimitive];if(void 0!==i){var a=i.call(s,o||"default");if("object"!=typeof_typeof(a))return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===o?String:Number)(s)}(s,"string");return"symbol"==typeof_typeof(o)?o:o+""}function defineProperty_defineProperty(s,o,i){return(o=toPropertyKey(o))in s?Object.defineProperty(s,o,{value:i,enumerable:!0,configurable:!0,writable:!0}):s[o]=i,s}function extends_extends(){return extends_extends=Object.assign?Object.assign.bind():function(s){for(var o=1;o<arguments.length;o++){var i=arguments[o];for(var a in i)({}).hasOwnProperty.call(i,a)&&(s[a]=i[a])}return s},extends_extends.apply(null,arguments)}function create_element_ownKeys(s,o){var i=Object.keys(s);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(s);o&&(a=a.filter((function(o){return Object.getOwnPropertyDescriptor(s,o).enumerable}))),i.push.apply(i,a)}return i}function _objectSpread(s){for(var o=1;o<arguments.length;o++){var i=null!=arguments[o]?arguments[o]:{};o%2?create_element_ownKeys(Object(i),!0).forEach((function(o){defineProperty_defineProperty(s,o,i[o])})):Object.getOwnPropertyDescriptors?Object.defineProperties(s,Object.getOwnPropertyDescriptors(i)):create_element_ownKeys(Object(i)).forEach((function(o){Object.defineProperty(s,o,Object.getOwnPropertyDescriptor(i,o))}))}return s}var lO={};function createStyleObject(s){var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2?arguments[2]:void 0;return function getClassNameCombinations(s){if(0===s.length||1===s.length)return s;var o=s.join(".");return lO[o]||(lO[o]=function powerSetPermutations(s){var o=s.length;return 0===o||1===o?s:2===o?[s[0],s[1],"".concat(s[0],".").concat(s[1]),"".concat(s[1],".").concat(s[0])]:3===o?[s[0],s[1],s[2],"".concat(s[0],".").concat(s[1]),"".concat(s[0],".").concat(s[2]),"".concat(s[1],".").concat(s[0]),"".concat(s[1],".").concat(s[2]),"".concat(s[2],".").concat(s[0]),"".concat(s[2],".").concat(s[1]),"".concat(s[0],".").concat(s[1],".").concat(s[2]),"".concat(s[0],".").concat(s[2],".").concat(s[1]),"".concat(s[1],".").concat(s[0],".").concat(s[2]),"".concat(s[1],".").concat(s[2],".").concat(s[0]),"".concat(s[2],".").concat(s[0],".").concat(s[1]),"".concat(s[2],".").concat(s[1],".").concat(s[0])]:o>=4?[s[0],s[1],s[2],s[3],"".concat(s[0],".").concat(s[1]),"".concat(s[0],".").concat(s[2]),"".concat(s[0],".").concat(s[3]),"".concat(s[1],".").concat(s[0]),"".concat(s[1],".").concat(s[2]),"".concat(s[1],".").concat(s[3]),"".concat(s[2],".").concat(s[0]),"".concat(s[2],".").concat(s[1]),"".concat(s[2],".").concat(s[3]),"".concat(s[3],".").concat(s[0]),"".concat(s[3],".").concat(s[1]),"".concat(s[3],".").concat(s[2]),"".concat(s[0],".").concat(s[1],".").concat(s[2]),"".concat(s[0],".").concat(s[1],".").concat(s[3]),"".concat(s[0],".").concat(s[2],".").concat(s[1]),"".concat(s[0],".").concat(s[2],".").concat(s[3]),"".concat(s[0],".").concat(s[3],".").concat(s[1]),"".concat(s[0],".").concat(s[3],".").concat(s[2]),"".concat(s[1],".").concat(s[0],".").concat(s[2]),"".concat(s[1],".").concat(s[0],".").concat(s[3]),"".concat(s[1],".").concat(s[2],".").concat(s[0]),"".concat(s[1],".").concat(s[2],".").concat(s[3]),"".concat(s[1],".").concat(s[3],".").concat(s[0]),"".concat(s[1],".").concat(s[3],".").concat(s[2]),"".concat(s[2],".").concat(s[0],".").concat(s[1]),"".concat(s[2],".").concat(s[0],".").concat(s[3]),"".concat(s[2],".").concat(s[1],".").concat(s[0]),"".concat(s[2],".").concat(s[1],".").concat(s[3]),"".concat(s[2],".").concat(s[3],".").concat(s[0]),"".concat(s[2],".").concat(s[3],".").concat(s[1]),"".concat(s[3],".").concat(s[0],".").concat(s[1]),"".concat(s[3],".").concat(s[0],".").concat(s[2]),"".concat(s[3],".").concat(s[1],".").concat(s[0]),"".concat(s[3],".").concat(s[1],".").concat(s[2]),"".concat(s[3],".").concat(s[2],".").concat(s[0]),"".concat(s[3],".").concat(s[2],".").concat(s[1]),"".concat(s[0],".").concat(s[1],".").concat(s[2],".").concat(s[3]),"".concat(s[0],".").concat(s[1],".").concat(s[3],".").concat(s[2]),"".concat(s[0],".").concat(s[2],".").concat(s[1],".").concat(s[3]),"".concat(s[0],".").concat(s[2],".").concat(s[3],".").concat(s[1]),"".concat(s[0],".").concat(s[3],".").concat(s[1],".").concat(s[2]),"".concat(s[0],".").concat(s[3],".").concat(s[2],".").concat(s[1]),"".concat(s[1],".").concat(s[0],".").concat(s[2],".").concat(s[3]),"".concat(s[1],".").concat(s[0],".").concat(s[3],".").concat(s[2]),"".concat(s[1],".").concat(s[2],".").concat(s[0],".").concat(s[3]),"".concat(s[1],".").concat(s[2],".").concat(s[3],".").concat(s[0]),"".concat(s[1],".").concat(s[3],".").concat(s[0],".").concat(s[2]),"".concat(s[1],".").concat(s[3],".").concat(s[2],".").concat(s[0]),"".concat(s[2],".").concat(s[0],".").concat(s[1],".").concat(s[3]),"".concat(s[2],".").concat(s[0],".").concat(s[3],".").concat(s[1]),"".concat(s[2],".").concat(s[1],".").concat(s[0],".").concat(s[3]),"".concat(s[2],".").concat(s[1],".").concat(s[3],".").concat(s[0]),"".concat(s[2],".").concat(s[3],".").concat(s[0],".").concat(s[1]),"".concat(s[2],".").concat(s[3],".").concat(s[1],".").concat(s[0]),"".concat(s[3],".").concat(s[0],".").concat(s[1],".").concat(s[2]),"".concat(s[3],".").concat(s[0],".").concat(s[2],".").concat(s[1]),"".concat(s[3],".").concat(s[1],".").concat(s[0],".").concat(s[2]),"".concat(s[3],".").concat(s[1],".").concat(s[2],".").concat(s[0]),"".concat(s[3],".").concat(s[2],".").concat(s[0],".").concat(s[1]),"".concat(s[3],".").concat(s[2],".").concat(s[1],".").concat(s[0])]:void 0}(s)),lO[o]}(s.filter((function(s){return"token"!==s}))).reduce((function(s,o){return _objectSpread(_objectSpread({},s),i[o])}),o)}function createClassNameString(s){return s.join(" ")}function createElement(s){var o=s.node,i=s.stylesheet,a=s.style,u=void 0===a?{}:a,_=s.useInlineStyles,w=s.key,x=o.properties,C=o.type,j=o.tagName,L=o.value;if("text"===C)return L;if(j){var B,$=function createChildren(s,o){var i=0;return function(a){return i+=1,a.map((function(a,u){return createElement({node:a,stylesheet:s,useInlineStyles:o,key:"code-segment-".concat(i,"-").concat(u)})}))}}(i,_);if(_){var U=Object.keys(i).reduce((function(s,o){return o.split(".").forEach((function(o){s.includes(o)||s.push(o)})),s}),[]),V=x.className&&x.className.includes("token")?["token"]:[],z=x.className&&V.concat(x.className.filter((function(s){return!U.includes(s)})));B=_objectSpread(_objectSpread({},x),{},{className:createClassNameString(z)||void 0,style:createStyleObject(x.className,Object.assign({},x.style,u),i)})}else B=_objectSpread(_objectSpread({},x),{},{className:createClassNameString(x.className)});var Y=$(o.children);return Re.createElement(j,extends_extends({key:w},B),Y)}}var uO=["language","children","style","customStyle","codeTagProps","useInlineStyles","showLineNumbers","showInlineLineNumbers","startingLineNumber","lineNumberContainerStyle","lineNumberStyle","wrapLines","wrapLongLines","lineProps","renderer","PreTag","CodeTag","code","astGenerator"];function highlight_ownKeys(s,o){var i=Object.keys(s);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(s);o&&(a=a.filter((function(o){return Object.getOwnPropertyDescriptor(s,o).enumerable}))),i.push.apply(i,a)}return i}function highlight_objectSpread(s){for(var o=1;o<arguments.length;o++){var i=null!=arguments[o]?arguments[o]:{};o%2?highlight_ownKeys(Object(i),!0).forEach((function(o){defineProperty_defineProperty(s,o,i[o])})):Object.getOwnPropertyDescriptors?Object.defineProperties(s,Object.getOwnPropertyDescriptors(i)):highlight_ownKeys(Object(i)).forEach((function(o){Object.defineProperty(s,o,Object.getOwnPropertyDescriptor(i,o))}))}return s}var pO=/\n/g;function AllLineNumbers(s){var o=s.codeString,i=s.codeStyle,a=s.containerStyle,u=void 0===a?{float:"left",paddingRight:"10px"}:a,_=s.numberStyle,w=void 0===_?{}:_,x=s.startingLineNumber;return Re.createElement("code",{style:Object.assign({},i,u)},function getAllLineNumbers(s){var o=s.lines,i=s.startingLineNumber,a=s.style;return o.map((function(s,o){var u=o+i;return Re.createElement("span",{key:"line-".concat(o),className:"react-syntax-highlighter-line-number",style:"function"==typeof a?a(u):a},"".concat(u,"\n"))}))}({lines:o.replace(/\n$/,"").split("\n"),style:w,startingLineNumber:x}))}function getInlineLineNumber(s,o){return{type:"element",tagName:"span",properties:{key:"line-number--".concat(s),className:["comment","linenumber","react-syntax-highlighter-line-number"],style:o},children:[{type:"text",value:s}]}}function assembleLineNumberStyles(s,o,i){var a,u={display:"inline-block",minWidth:(a=i,"".concat(a.toString().length,".25em")),paddingRight:"1em",textAlign:"right",userSelect:"none"},_="function"==typeof s?s(o):s;return highlight_objectSpread(highlight_objectSpread({},u),_)}function createLineElement(s){var o=s.children,i=s.lineNumber,a=s.lineNumberStyle,u=s.largestLineNumber,_=s.showInlineLineNumbers,w=s.lineProps,x=void 0===w?{}:w,C=s.className,j=void 0===C?[]:C,L=s.showLineNumbers,B=s.wrapLongLines,$=s.wrapLines,U=void 0!==$&&$?highlight_objectSpread({},"function"==typeof x?x(i):x):{};if(U.className=U.className?[].concat(toConsumableArray_toConsumableArray(U.className.trim().split(/\s+/)),toConsumableArray_toConsumableArray(j)):j,i&&_){var V=assembleLineNumberStyles(a,i,u);o.unshift(getInlineLineNumber(i,V))}return B&L&&(U.style=highlight_objectSpread({display:"flex"},U.style)),{type:"element",tagName:"span",properties:U,children:o}}function flattenCodeTree(s){var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[];void 0===s.length&&(s=[s]);for(var a=0;a<s.length;a++){var u=s[a];if("text"===u.type)i.push(createLineElement({children:[u],className:toConsumableArray_toConsumableArray(new Set(o))}));else if(u.children){var _,w=o.concat((null===(_=u.properties)||void 0===_?void 0:_.className)||[]);flattenCodeTree(u.children,w).forEach((function(s){return i.push(s)}))}}return i}function processLines(s,o,i,a,u,_,w,x,C){var j,L=flattenCodeTree(s.value),B=[],$=-1,U=0;function createLine(s,_){var j=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[];return o||j.length>0?function createWrappedLine(s,_){return createLineElement({children:s,lineNumber:_,lineNumberStyle:x,largestLineNumber:w,showInlineLineNumbers:u,lineProps:i,className:arguments.length>2&&void 0!==arguments[2]?arguments[2]:[],showLineNumbers:a,wrapLongLines:C,wrapLines:o})}(s,_,j):function createUnwrappedLine(s,o){if(a&&o&&u){var i=assembleLineNumberStyles(x,o,w);s.unshift(getInlineLineNumber(o,i))}return s}(s,_)}for(var V=function _loop(){var s=L[U],o=s.children[0].value,i=function getNewLines(s){return s.match(pO)}(o);if(i){var u=o.split("\n");u.forEach((function(o,i){var w=a&&B.length+_,x={type:"text",value:"".concat(o,"\n")};if(0===i){var C=createLine(L.slice($+1,U).concat(createLineElement({children:[x],className:s.properties.className})),w);B.push(C)}else if(i===u.length-1){var j=L[U+1]&&L[U+1].children&&L[U+1].children[0],V={type:"text",value:"".concat(o)};if(j){var z=createLineElement({children:[V],className:s.properties.className});L.splice(U+1,0,z)}else{var Y=createLine([V],w,s.properties.className);B.push(Y)}}else{var Z=createLine([x],w,s.properties.className);B.push(Z)}})),$=U}U++};U<L.length;)V();if($!==L.length-1){var z=L.slice($+1,L.length);if(z&&z.length){var Y=createLine(z,a&&B.length+_);B.push(Y)}}return o?B:(j=[]).concat.apply(j,B)}function defaultRenderer(s){var o=s.rows,i=s.stylesheet,a=s.useInlineStyles;return o.map((function(s,o){return createElement({node:s,stylesheet:i,useInlineStyles:a,key:"code-segment-".concat(o)})}))}function isHighlightJs(s){return s&&void 0!==s.highlightAuto}var hO=__webpack_require__(43768),dO=function highlight(s,o){return function SyntaxHighlighter(i){var a,u,_=i.language,w=i.children,x=i.style,C=void 0===x?o:x,j=i.customStyle,L=void 0===j?{}:j,B=i.codeTagProps,$=void 0===B?{className:_?"language-".concat(_):void 0,style:highlight_objectSpread(highlight_objectSpread({},C['code[class*="language-"]']),C['code[class*="language-'.concat(_,'"]')])}:B,U=i.useInlineStyles,V=void 0===U||U,z=i.showLineNumbers,Y=void 0!==z&&z,Z=i.showInlineLineNumbers,ee=void 0===Z||Z,ie=i.startingLineNumber,ae=void 0===ie?1:ie,ce=i.lineNumberContainerStyle,le=i.lineNumberStyle,pe=void 0===le?{}:le,de=i.wrapLines,fe=i.wrapLongLines,ye=void 0!==fe&&fe,be=i.lineProps,Se=void 0===be?{}:be,_e=i.renderer,we=i.PreTag,xe=void 0===we?"pre":we,Pe=i.CodeTag,Te=void 0===Pe?"code":Pe,$e=i.code,qe=void 0===$e?(Array.isArray(w)?w[0]:w)||"":$e,ze=i.astGenerator,We=function _objectWithoutProperties(s,o){if(null==s)return{};var i,a,u=function _objectWithoutPropertiesLoose(s,o){if(null==s)return{};var i={};for(var a in s)if({}.hasOwnProperty.call(s,a)){if(-1!==o.indexOf(a))continue;i[a]=s[a]}return i}(s,o);if(Object.getOwnPropertySymbols){var _=Object.getOwnPropertySymbols(s);for(a=0;a<_.length;a++)i=_[a],-1===o.indexOf(i)&&{}.propertyIsEnumerable.call(s,i)&&(u[i]=s[i])}return u}(i,uO);ze=ze||s;var He=Y?Re.createElement(AllLineNumbers,{containerStyle:ce,codeStyle:$.style||{},numberStyle:pe,startingLineNumber:ae,codeString:qe}):null,Ye=C.hljs||C['pre[class*="language-"]']||{backgroundColor:"#fff"},Xe=isHighlightJs(ze)?"hljs":"prismjs",Qe=V?Object.assign({},We,{style:Object.assign({},Ye,L)}):Object.assign({},We,{className:We.className?"".concat(Xe," ").concat(We.className):Xe,style:Object.assign({},L)});if($.style=highlight_objectSpread(ye?{whiteSpace:"pre-wrap"}:{whiteSpace:"pre"},$.style),!ze)return Re.createElement(xe,Qe,He,Re.createElement(Te,$,qe));(void 0===de&&_e||ye)&&(de=!0),_e=_e||defaultRenderer;var et=[{type:"text",value:qe}],tt=function getCodeTree(s){var o=s.astGenerator,i=s.language,a=s.code,u=s.defaultCodeValue;if(isHighlightJs(o)){var _=function(s,o){return-1!==s.listLanguages().indexOf(o)}(o,i);return"text"===i?{value:u,language:"text"}:_?o.highlight(i,a):o.highlightAuto(a)}try{return i&&"text"!==i?{value:o.highlight(a,i)}:{value:u}}catch(s){return{value:u}}}({astGenerator:ze,language:_,code:qe,defaultCodeValue:et});null===tt.language&&(tt.value=et);var rt=processLines(tt,de,Se,Y,ee,ae,ae+(null!==(a=null===(u=qe.match(/\n/g))||void 0===u?void 0:u.length)&&void 0!==a?a:0),pe,ye);return Re.createElement(xe,Qe,Re.createElement(Te,$,!ee&&He,_e({rows:rt,stylesheet:C,useInlineStyles:V})))}}(hO,{});dO.registerLanguage=hO.registerLanguage;const fO=dO;var mO=__webpack_require__(95089);const gO=__webpack_require__.n(mO)();var yO=__webpack_require__(65772);const vO=__webpack_require__.n(yO)();var bO=__webpack_require__(17285);const SO=__webpack_require__.n(bO)();var _O=__webpack_require__(35344);const EO=__webpack_require__.n(_O)();var wO=__webpack_require__(17533);const xO=__webpack_require__.n(wO)();var kO=__webpack_require__(73402);const OO=__webpack_require__.n(kO)();var AO=__webpack_require__(26571);const CO=__webpack_require__.n(AO)(),after_load=()=>{fO.registerLanguage("json",vO),fO.registerLanguage("js",gO),fO.registerLanguage("xml",SO),fO.registerLanguage("yaml",xO),fO.registerLanguage("http",OO),fO.registerLanguage("bash",EO),fO.registerLanguage("powershell",CO),fO.registerLanguage("javascript",gO)},jO={hljs:{display:"block",overflowX:"auto",padding:"0.5em",background:"#333",color:"white"},"hljs-name":{fontWeight:"bold"},"hljs-strong":{fontWeight:"bold"},"hljs-code":{fontStyle:"italic",color:"#888"},"hljs-emphasis":{fontStyle:"italic"},"hljs-tag":{color:"#62c8f3"},"hljs-variable":{color:"#ade5fc"},"hljs-template-variable":{color:"#ade5fc"},"hljs-selector-id":{color:"#ade5fc"},"hljs-selector-class":{color:"#ade5fc"},"hljs-string":{color:"#a2fca2"},"hljs-bullet":{color:"#d36363"},"hljs-type":{color:"#ffa"},"hljs-title":{color:"#ffa"},"hljs-section":{color:"#ffa"},"hljs-attribute":{color:"#ffa"},"hljs-quote":{color:"#ffa"},"hljs-built_in":{color:"#ffa"},"hljs-builtin-name":{color:"#ffa"},"hljs-number":{color:"#d36363"},"hljs-symbol":{color:"#d36363"},"hljs-keyword":{color:"#fcc28c"},"hljs-selector-tag":{color:"#fcc28c"},"hljs-literal":{color:"#fcc28c"},"hljs-comment":{color:"#888"},"hljs-deletion":{color:"#333",backgroundColor:"#fc9b9b"},"hljs-regexp":{color:"#c6b4f0"},"hljs-link":{color:"#c6b4f0"},"hljs-meta":{color:"#fc9b9b"},"hljs-addition":{backgroundColor:"#a2fca2",color:"#333"}},PO={agate:jO,arta:{hljs:{display:"block",overflowX:"auto",padding:"0.5em",background:"#222",color:"#aaa"},"hljs-subst":{color:"#aaa"},"hljs-section":{color:"#fff",fontWeight:"bold"},"hljs-comment":{color:"#444"},"hljs-quote":{color:"#444"},"hljs-meta":{color:"#444"},"hljs-string":{color:"#ffcc33"},"hljs-symbol":{color:"#ffcc33"},"hljs-bullet":{color:"#ffcc33"},"hljs-regexp":{color:"#ffcc33"},"hljs-number":{color:"#00cc66"},"hljs-addition":{color:"#00cc66"},"hljs-built_in":{color:"#32aaee"},"hljs-builtin-name":{color:"#32aaee"},"hljs-literal":{color:"#32aaee"},"hljs-type":{color:"#32aaee"},"hljs-template-variable":{color:"#32aaee"},"hljs-attribute":{color:"#32aaee"},"hljs-link":{color:"#32aaee"},"hljs-keyword":{color:"#6644aa"},"hljs-selector-tag":{color:"#6644aa"},"hljs-name":{color:"#6644aa"},"hljs-selector-id":{color:"#6644aa"},"hljs-selector-class":{color:"#6644aa"},"hljs-title":{color:"#bb1166"},"hljs-variable":{color:"#bb1166"},"hljs-deletion":{color:"#bb1166"},"hljs-template-tag":{color:"#bb1166"},"hljs-doctag":{fontWeight:"bold"},"hljs-strong":{fontWeight:"bold"},"hljs-emphasis":{fontStyle:"italic"}},monokai:{hljs:{display:"block",overflowX:"auto",padding:"0.5em",background:"#272822",color:"#ddd"},"hljs-tag":{color:"#f92672"},"hljs-keyword":{color:"#f92672",fontWeight:"bold"},"hljs-selector-tag":{color:"#f92672",fontWeight:"bold"},"hljs-literal":{color:"#f92672",fontWeight:"bold"},"hljs-strong":{color:"#f92672"},"hljs-name":{color:"#f92672"},"hljs-code":{color:"#66d9ef"},"hljs-class .hljs-title":{color:"white"},"hljs-attribute":{color:"#bf79db"},"hljs-symbol":{color:"#bf79db"},"hljs-regexp":{color:"#bf79db"},"hljs-link":{color:"#bf79db"},"hljs-string":{color:"#a6e22e"},"hljs-bullet":{color:"#a6e22e"},"hljs-subst":{color:"#a6e22e"},"hljs-title":{color:"#a6e22e",fontWeight:"bold"},"hljs-section":{color:"#a6e22e",fontWeight:"bold"},"hljs-emphasis":{color:"#a6e22e"},"hljs-type":{color:"#a6e22e",fontWeight:"bold"},"hljs-built_in":{color:"#a6e22e"},"hljs-builtin-name":{color:"#a6e22e"},"hljs-selector-attr":{color:"#a6e22e"},"hljs-selector-pseudo":{color:"#a6e22e"},"hljs-addition":{color:"#a6e22e"},"hljs-variable":{color:"#a6e22e"},"hljs-template-tag":{color:"#a6e22e"},"hljs-template-variable":{color:"#a6e22e"},"hljs-comment":{color:"#75715e"},"hljs-quote":{color:"#75715e"},"hljs-deletion":{color:"#75715e"},"hljs-meta":{color:"#75715e"},"hljs-doctag":{fontWeight:"bold"},"hljs-selector-id":{fontWeight:"bold"}},nord:{hljs:{display:"block",overflowX:"auto",padding:"0.5em",background:"#2E3440",color:"#D8DEE9"},"hljs-subst":{color:"#D8DEE9"},"hljs-selector-tag":{color:"#81A1C1"},"hljs-selector-id":{color:"#8FBCBB",fontWeight:"bold"},"hljs-selector-class":{color:"#8FBCBB"},"hljs-selector-attr":{color:"#8FBCBB"},"hljs-selector-pseudo":{color:"#88C0D0"},"hljs-addition":{backgroundColor:"rgba(163, 190, 140, 0.5)"},"hljs-deletion":{backgroundColor:"rgba(191, 97, 106, 0.5)"},"hljs-built_in":{color:"#8FBCBB"},"hljs-type":{color:"#8FBCBB"},"hljs-class":{color:"#8FBCBB"},"hljs-function":{color:"#88C0D0"},"hljs-function > .hljs-title":{color:"#88C0D0"},"hljs-keyword":{color:"#81A1C1"},"hljs-literal":{color:"#81A1C1"},"hljs-symbol":{color:"#81A1C1"},"hljs-number":{color:"#B48EAD"},"hljs-regexp":{color:"#EBCB8B"},"hljs-string":{color:"#A3BE8C"},"hljs-title":{color:"#8FBCBB"},"hljs-params":{color:"#D8DEE9"},"hljs-bullet":{color:"#81A1C1"},"hljs-code":{color:"#8FBCBB"},"hljs-emphasis":{fontStyle:"italic"},"hljs-formula":{color:"#8FBCBB"},"hljs-strong":{fontWeight:"bold"},"hljs-link:hover":{textDecoration:"underline"},"hljs-quote":{color:"#4C566A"},"hljs-comment":{color:"#4C566A"},"hljs-doctag":{color:"#8FBCBB"},"hljs-meta":{color:"#5E81AC"},"hljs-meta-keyword":{color:"#5E81AC"},"hljs-meta-string":{color:"#A3BE8C"},"hljs-attr":{color:"#8FBCBB"},"hljs-attribute":{color:"#D8DEE9"},"hljs-builtin-name":{color:"#81A1C1"},"hljs-name":{color:"#81A1C1"},"hljs-section":{color:"#88C0D0"},"hljs-tag":{color:"#81A1C1"},"hljs-variable":{color:"#D8DEE9"},"hljs-template-variable":{color:"#D8DEE9"},"hljs-template-tag":{color:"#5E81AC"},"abnf .hljs-attribute":{color:"#88C0D0"},"abnf .hljs-symbol":{color:"#EBCB8B"},"apache .hljs-attribute":{color:"#88C0D0"},"apache .hljs-section":{color:"#81A1C1"},"arduino .hljs-built_in":{color:"#88C0D0"},"aspectj .hljs-meta":{color:"#D08770"},"aspectj > .hljs-title":{color:"#88C0D0"},"bnf .hljs-attribute":{color:"#8FBCBB"},"clojure .hljs-name":{color:"#88C0D0"},"clojure .hljs-symbol":{color:"#EBCB8B"},"coq .hljs-built_in":{color:"#88C0D0"},"cpp .hljs-meta-string":{color:"#8FBCBB"},"css .hljs-built_in":{color:"#88C0D0"},"css .hljs-keyword":{color:"#D08770"},"diff .hljs-meta":{color:"#8FBCBB"},"ebnf .hljs-attribute":{color:"#8FBCBB"},"glsl .hljs-built_in":{color:"#88C0D0"},"groovy .hljs-meta:not(:first-child)":{color:"#D08770"},"haxe .hljs-meta":{color:"#D08770"},"java .hljs-meta":{color:"#D08770"},"ldif .hljs-attribute":{color:"#8FBCBB"},"lisp .hljs-name":{color:"#88C0D0"},"lua .hljs-built_in":{color:"#88C0D0"},"moonscript .hljs-built_in":{color:"#88C0D0"},"nginx .hljs-attribute":{color:"#88C0D0"},"nginx .hljs-section":{color:"#5E81AC"},"pf .hljs-built_in":{color:"#88C0D0"},"processing .hljs-built_in":{color:"#88C0D0"},"scss .hljs-keyword":{color:"#81A1C1"},"stylus .hljs-keyword":{color:"#81A1C1"},"swift .hljs-meta":{color:"#D08770"},"vim .hljs-built_in":{color:"#88C0D0",fontStyle:"italic"},"yaml .hljs-meta":{color:"#D08770"}},obsidian:{hljs:{display:"block",overflowX:"auto",padding:"0.5em",background:"#282b2e",color:"#e0e2e4"},"hljs-keyword":{color:"#93c763",fontWeight:"bold"},"hljs-selector-tag":{color:"#93c763",fontWeight:"bold"},"hljs-literal":{color:"#93c763",fontWeight:"bold"},"hljs-selector-id":{color:"#93c763"},"hljs-number":{color:"#ffcd22"},"hljs-attribute":{color:"#668bb0"},"hljs-code":{color:"white"},"hljs-class .hljs-title":{color:"white"},"hljs-section":{color:"white",fontWeight:"bold"},"hljs-regexp":{color:"#d39745"},"hljs-link":{color:"#d39745"},"hljs-meta":{color:"#557182"},"hljs-tag":{color:"#8cbbad"},"hljs-name":{color:"#8cbbad",fontWeight:"bold"},"hljs-bullet":{color:"#8cbbad"},"hljs-subst":{color:"#8cbbad"},"hljs-emphasis":{color:"#8cbbad"},"hljs-type":{color:"#8cbbad",fontWeight:"bold"},"hljs-built_in":{color:"#8cbbad"},"hljs-selector-attr":{color:"#8cbbad"},"hljs-selector-pseudo":{color:"#8cbbad"},"hljs-addition":{color:"#8cbbad"},"hljs-variable":{color:"#8cbbad"},"hljs-template-tag":{color:"#8cbbad"},"hljs-template-variable":{color:"#8cbbad"},"hljs-string":{color:"#ec7600"},"hljs-symbol":{color:"#ec7600"},"hljs-comment":{color:"#818e96"},"hljs-quote":{color:"#818e96"},"hljs-deletion":{color:"#818e96"},"hljs-selector-class":{color:"#A082BD"},"hljs-doctag":{fontWeight:"bold"},"hljs-title":{fontWeight:"bold"},"hljs-strong":{fontWeight:"bold"}},"tomorrow-night":{"hljs-comment":{color:"#969896"},"hljs-quote":{color:"#969896"},"hljs-variable":{color:"#cc6666"},"hljs-template-variable":{color:"#cc6666"},"hljs-tag":{color:"#cc6666"},"hljs-name":{color:"#cc6666"},"hljs-selector-id":{color:"#cc6666"},"hljs-selector-class":{color:"#cc6666"},"hljs-regexp":{color:"#cc6666"},"hljs-deletion":{color:"#cc6666"},"hljs-number":{color:"#de935f"},"hljs-built_in":{color:"#de935f"},"hljs-builtin-name":{color:"#de935f"},"hljs-literal":{color:"#de935f"},"hljs-type":{color:"#de935f"},"hljs-params":{color:"#de935f"},"hljs-meta":{color:"#de935f"},"hljs-link":{color:"#de935f"},"hljs-attribute":{color:"#f0c674"},"hljs-string":{color:"#b5bd68"},"hljs-symbol":{color:"#b5bd68"},"hljs-bullet":{color:"#b5bd68"},"hljs-addition":{color:"#b5bd68"},"hljs-title":{color:"#81a2be"},"hljs-section":{color:"#81a2be"},"hljs-keyword":{color:"#b294bb"},"hljs-selector-tag":{color:"#b294bb"},hljs:{display:"block",overflowX:"auto",background:"#1d1f21",color:"#c5c8c6",padding:"0.5em"},"hljs-emphasis":{fontStyle:"italic"},"hljs-strong":{fontWeight:"bold"}},idea:{hljs:{display:"block",overflowX:"auto",padding:"0.5em",color:"#000",background:"#fff"},"hljs-subst":{fontWeight:"normal",color:"#000"},"hljs-title":{fontWeight:"normal",color:"#000"},"hljs-comment":{color:"#808080",fontStyle:"italic"},"hljs-quote":{color:"#808080",fontStyle:"italic"},"hljs-meta":{color:"#808000"},"hljs-tag":{background:"#efefef"},"hljs-section":{fontWeight:"bold",color:"#000080"},"hljs-name":{fontWeight:"bold",color:"#000080"},"hljs-literal":{fontWeight:"bold",color:"#000080"},"hljs-keyword":{fontWeight:"bold",color:"#000080"},"hljs-selector-tag":{fontWeight:"bold",color:"#000080"},"hljs-type":{fontWeight:"bold",color:"#000080"},"hljs-selector-id":{fontWeight:"bold",color:"#000080"},"hljs-selector-class":{fontWeight:"bold",color:"#000080"},"hljs-attribute":{fontWeight:"bold",color:"#0000ff"},"hljs-number":{fontWeight:"normal",color:"#0000ff"},"hljs-regexp":{fontWeight:"normal",color:"#0000ff"},"hljs-link":{fontWeight:"normal",color:"#0000ff"},"hljs-string":{color:"#008000",fontWeight:"bold"},"hljs-symbol":{color:"#000",background:"#d0eded",fontStyle:"italic"},"hljs-bullet":{color:"#000",background:"#d0eded",fontStyle:"italic"},"hljs-formula":{color:"#000",background:"#d0eded",fontStyle:"italic"},"hljs-doctag":{textDecoration:"underline"},"hljs-variable":{color:"#660e7a"},"hljs-template-variable":{color:"#660e7a"},"hljs-addition":{background:"#baeeba"},"hljs-deletion":{background:"#ffc8bd"},"hljs-emphasis":{fontStyle:"italic"},"hljs-strong":{fontWeight:"bold"}}},IO=jO,components_SyntaxHighlighter=({language:s,className:o="",getConfigs:i,syntaxHighlighting:a={},children:u=""})=>{const _=i().syntaxHighlight.theme,{styles:w,defaultStyle:x}=a,C=w?.[_]??x;return Re.createElement(fO,{language:s,className:o,style:C},u)};var TO=__webpack_require__(5419),NO=__webpack_require__.n(TO);const components_HighlightCode=({fileName:s="response.txt",className:o,downloadable:i,getComponent:a,canCopy:u,language:_,children:w})=>{const x=(0,Re.useRef)(null),C=a("SyntaxHighlighter",!0),handlePreventYScrollingBeyondElement=s=>{const{target:o,deltaY:i}=s,{scrollHeight:a,offsetHeight:u,scrollTop:_}=o;a>u&&(0===_&&i<0||u+_>=a&&i>0)&&s.preventDefault()};return(0,Re.useEffect)((()=>{const s=Array.from(x.current.childNodes).filter((s=>!!s.nodeType&&s.classList.contains("microlight")));return s.forEach((s=>s.addEventListener("mousewheel",handlePreventYScrollingBeyondElement,{passive:!1}))),()=>{s.forEach((s=>s.removeEventListener("mousewheel",handlePreventYScrollingBeyondElement)))}}),[w,o,_]),Re.createElement("div",{className:"highlight-code",ref:x},u&&Re.createElement("div",{className:"copy-to-clipboard"},Re.createElement(Hn.CopyToClipboard,{text:w},Re.createElement("button",null))),i?Re.createElement("button",{className:"download-contents",onClick:()=>{NO()(w,s)}},"Download"):null,Re.createElement(C,{language:_,className:Jn()(o,"microlight"),renderPlainText:({children:s,PlainTextViewer:i})=>Re.createElement(i,{className:o},s)},w))},components_PlainTextViewer=({className:s="",children:o})=>Re.createElement("pre",{className:Jn()("microlight",s)},o),wrap_components_SyntaxHighlighter=(s,o)=>({renderPlainText:i,children:a,...u})=>{const _=o.getConfigs().syntaxHighlight.activated,w=o.getComponent("PlainTextViewer");return _||"function"!=typeof i?_?Re.createElement(s,u,a):Re.createElement(w,null,a):i({children:a,PlainTextViewer:w})},SyntaxHighlightingPlugin1=()=>({afterLoad:after_load,rootInjects:{syntaxHighlighting:{styles:PO,defaultStyle:IO}},components:{SyntaxHighlighter:components_SyntaxHighlighter,HighlightCode:components_HighlightCode,PlainTextViewer:components_PlainTextViewer}}),SyntaxHighlightingPlugin2=()=>({wrapComponents:{SyntaxHighlighter:wrap_components_SyntaxHighlighter}}),syntax_highlighting=()=>[SyntaxHighlightingPlugin1,SyntaxHighlightingPlugin2],versions_after_load=()=>{const{GIT_DIRTY:s,GIT_COMMIT:o,PACKAGE_VERSION:i,BUILD_TIME:a}={PACKAGE_VERSION:"5.32.6",GIT_COMMIT:"g871b8974",GIT_DIRTY:!0,BUILD_TIME:"Tue, 12 May 2026 09:34:58 GMT"};lt.versions=lt.versions||{},lt.versions.swaggerUI={version:i,gitRevision:o,gitDirty:s,buildTimestamp:a}},versions=()=>({afterLoad:versions_after_load});var MO=__webpack_require__(47248),RO=__webpack_require__.n(MO);const DO=console.error,withErrorBoundary=s=>o=>{const{getComponent:i,fn:a}=s(),u=i("ErrorBoundary"),_=a.getDisplayName(o);class WithErrorBoundary extends Re.Component{render(){return Re.createElement(u,{targetName:_,getComponent:i,fn:a},Re.createElement(o,Mn()({},this.props,this.context)))}}var w;return WithErrorBoundary.displayName=`WithErrorBoundary(${_})`,(w=o).prototype&&w.prototype.isReactComponent&&(WithErrorBoundary.prototype.mapStateToProps=o.prototype.mapStateToProps),WithErrorBoundary},fallback=({name:s})=>Re.createElement("div",{className:"fallback"},"😱 ",Re.createElement("i",null,"Could not render ","t"===s?"this component":s,", see the console."));class ErrorBoundary extends Re.Component{static defaultProps={targetName:"this component",getComponent:()=>fallback,fn:{componentDidCatch:DO},children:null};static getDerivedStateFromError(s){return{hasError:!0,error:s}}constructor(...s){super(...s),this.state={hasError:!1,error:null}}componentDidCatch(s,o){this.props.fn.componentDidCatch(s,o)}render(){const{getComponent:s,targetName:o,children:i}=this.props;if(this.state.hasError){const i=s("Fallback");return Re.createElement(i,{name:o})}return i}}const LO=ErrorBoundary,safe_render=({componentList:s=[],fullOverride:o=!1}={})=>({getSystem:i})=>{const a=o?s:["App","BaseLayout","VersionPragmaFilter","InfoContainer","ServersContainer","SchemesContainer","AuthorizeBtnContainer","FilterContainer","Operations","OperationContainer","parameters","responses","OperationServers","Models","ModelWrapper",...s],u=RO()(a,Array(a.length).fill(((s,{fn:o})=>o.withErrorBoundary(s))));return{fn:{componentDidCatch:DO,withErrorBoundary:withErrorBoundary(i)},components:{ErrorBoundary:LO,Fallback:fallback},wrapComponents:u}};class App extends Re.Component{getLayout(){const{getComponent:s,layoutSelectors:o}=this.props,i=o.current(),a=s(i,!0);return a||(()=>Re.createElement("h1",null,' No layout defined for "',i,'" '))}render(){const s=this.getLayout();return Re.createElement(s,null)}}const FO=App;class AuthorizationPopup extends Re.Component{close=()=>{let{authActions:s}=this.props;s.showDefinitions(!1)};render(){let{authSelectors:s,authActions:o,getComponent:i,errSelectors:a,specSelectors:u,fn:{AST:_={}}}=this.props,w=s.shownDefinitions();const x=i("auths"),C=i("CloseIcon");return Re.createElement("div",{className:"dialog-ux"},Re.createElement("div",{className:"backdrop-ux"}),Re.createElement("div",{className:"modal-ux"},Re.createElement("div",{className:"modal-dialog-ux"},Re.createElement("div",{className:"modal-ux-inner"},Re.createElement("div",{className:"modal-ux-header"},Re.createElement("h3",null,"Available authorizations"),Re.createElement("button",{type:"button",className:"close-modal",onClick:this.close},Re.createElement(C,null))),Re.createElement("div",{className:"modal-ux-content"},w.valueSeq().map(((w,C)=>Re.createElement(x,{key:C,AST:_,definitions:w,getComponent:i,errSelectors:a,authSelectors:s,authActions:o,specSelectors:u}))))))))}}class AuthorizeBtn extends Re.Component{render(){let{isAuthorized:s,showPopup:o,onClick:i,getComponent:a}=this.props;const u=a("authorizationPopup",!0),_=a("LockAuthIcon",!0),w=a("UnlockAuthIcon",!0);return Re.createElement("div",{className:"auth-wrapper"},Re.createElement("button",{className:s?"btn authorize locked":"btn authorize unlocked",onClick:i},Re.createElement("span",null,"Authorize"),s?Re.createElement(_,null):Re.createElement(w,null)),o&&Re.createElement(u,null))}}class AuthorizeBtnContainer extends Re.Component{render(){const{authActions:s,authSelectors:o,specSelectors:i,getComponent:a}=this.props,u=i.securityDefinitions(),_=o.definitionsToAuthorize(),w=a("authorizeBtn");return u?Re.createElement(w,{onClick:()=>s.showDefinitions(_),isAuthorized:!!o.authorized().size,showPopup:!!o.shownDefinitions(),getComponent:a}):null}}class AuthorizeOperationBtn extends Re.Component{onClick=s=>{s.stopPropagation();let{onClick:o}=this.props;o&&o()};render(){let{isAuthorized:s,getComponent:o}=this.props;const i=o("LockAuthOperationIcon",!0),a=o("UnlockAuthOperationIcon",!0);return Re.createElement("button",{className:"authorization__btn","aria-label":s?"authorization button locked":"authorization button unlocked",onClick:this.onClick},s?Re.createElement(i,{className:"locked"}):Re.createElement(a,{className:"unlocked"}))}}class Auths extends Re.Component{constructor(s,o){super(s,o),this.state={}}onAuthChange=s=>{let{name:o}=s;this.setState({[o]:s})};submitAuth=s=>{s.preventDefault();let{authActions:o}=this.props;o.authorizeWithPersistOption(this.state)};logoutClick=s=>{s.preventDefault();let{authActions:o,definitions:i}=this.props,a=i.map(((s,o)=>o)).toArray();this.setState(a.reduce(((s,o)=>(s[o]="",s)),{})),o.logoutWithPersistOption(a)};close=s=>{s.preventDefault();let{authActions:o}=this.props;o.showDefinitions(!1)};render(){let{definitions:s,getComponent:o,authSelectors:i,errSelectors:a}=this.props;const u=o("AuthItem"),_=o("oauth2",!0),w=o("Button");let x=i.authorized(),C=s.filter(((s,o)=>!!x.get(o))),j=s.filter((s=>"oauth2"!==s.get("type"))),L=s.filter((s=>"oauth2"===s.get("type")));return Re.createElement("div",{className:"auth-container"},!!j.size&&Re.createElement("form",{onSubmit:this.submitAuth},j.map(((s,_)=>Re.createElement(u,{key:_,schema:s,name:_,getComponent:o,onAuthChange:this.onAuthChange,authorized:x,errSelectors:a,authSelectors:i}))).toArray(),Re.createElement("div",{className:"auth-btn-wrapper"},j.size===C.size?Re.createElement(w,{className:"btn modal-btn auth",onClick:this.logoutClick,"aria-label":"Remove authorization"},"Logout"):Re.createElement(w,{type:"submit",className:"btn modal-btn auth authorize","aria-label":"Apply credentials"},"Authorize"),Re.createElement(w,{className:"btn modal-btn auth btn-done",onClick:this.close},"Close"))),L&&L.size?Re.createElement("div",null,Re.createElement("div",{className:"scope-def"},Re.createElement("p",null,"Scopes are used to grant an application different levels of access to data on behalf of the end user. Each API may declare one or more scopes."),Re.createElement("p",null,"API requires the following scopes. Select which ones you want to grant to Swagger UI.")),s.filter((s=>"oauth2"===s.get("type"))).map(((s,o)=>Re.createElement("div",{key:o},Re.createElement(_,{authorized:x,schema:s,name:o})))).toArray()):null)}}class auth_item_Auths extends Re.Component{render(){let{schema:s,name:o,getComponent:i,onAuthChange:a,authorized:u,errSelectors:_,authSelectors:w}=this.props;const x=i("apiKeyAuth"),C=i("basicAuth");let j;const L=s.get("type");switch(L){case"apiKey":j=Re.createElement(x,{key:o,schema:s,name:o,errSelectors:_,authorized:u,getComponent:i,onChange:a,authSelectors:w});break;case"basic":j=Re.createElement(C,{key:o,schema:s,name:o,errSelectors:_,authorized:u,getComponent:i,onChange:a,authSelectors:w});break;default:j=Re.createElement("div",{key:o},"Unknown security definition type ",L)}return Re.createElement("div",{key:`${o}-jump`},j)}}class AuthError extends Re.Component{render(){let{error:s}=this.props,o=s.get("level"),i=s.get("message"),a=s.get("source");return Re.createElement("div",{className:"errors"},Re.createElement("b",null,a," ",o),Re.createElement("span",null,i))}}class ApiKeyAuth extends Re.Component{constructor(s,o){super(s,o);let{name:i,schema:a}=this.props,u=this.getValue();this.state={name:i,schema:a,value:u}}getValue(){let{name:s,authorized:o}=this.props;return o&&o.getIn([s,"value"])}onChange=s=>{let{onChange:o}=this.props,i=s.target.value,a=Object.assign({},this.state,{value:i});this.setState(a),o(a)};render(){let{schema:s,getComponent:o,errSelectors:i,name:a,authSelectors:u}=this.props;const _=o("Input"),w=o("Row"),x=o("Col"),C=o("authError"),j=o("Markdown",!0),L=o("JumpToPath",!0),B=u.selectAuthPath(a);let $=this.getValue(),U=i.allErrors().filter((s=>s.get("authId")===a));return Re.createElement("div",null,Re.createElement("h4",null,Re.createElement("code",null,a||s.get("name"))," (apiKey)",Re.createElement(L,{path:B})),$&&Re.createElement("h6",null,"Authorized"),Re.createElement(w,null,Re.createElement(j,{source:s.get("description")})),Re.createElement(w,null,Re.createElement("p",null,"Name: ",Re.createElement("code",null,s.get("name")))),Re.createElement(w,null,Re.createElement("p",null,"In: ",Re.createElement("code",null,s.get("in")))),Re.createElement(w,null,Re.createElement("label",{htmlFor:"api_key_value"},"Value:"),$?Re.createElement("code",null," ****** "):Re.createElement(x,null,Re.createElement(_,{id:"api_key_value",type:"text",onChange:this.onChange,autoFocus:!0}))),U.valueSeq().map(((s,o)=>Re.createElement(C,{error:s,key:o}))))}}class BasicAuth extends Re.Component{constructor(s,o){super(s,o);let{schema:i,name:a}=this.props,u=this.getValue().username;this.state={name:a,schema:i,value:u?{username:u}:{}}}getValue(){let{authorized:s,name:o}=this.props;return s&&s.getIn([o,"value"])||{}}onChange=s=>{let{onChange:o}=this.props,{value:i,name:a}=s.target,u=this.state.value;u[a]=i,this.setState({value:u}),o(this.state)};render(){let{schema:s,getComponent:o,name:i,errSelectors:a,authSelectors:u}=this.props;const _=o("Input"),w=o("Row"),x=o("Col"),C=o("authError"),j=o("JumpToPath",!0),L=o("Markdown",!0),B=u.selectAuthPath(i);let $=this.getValue().username,U=a.allErrors().filter((s=>s.get("authId")===i));return Re.createElement("div",null,Re.createElement("h4",null,"Basic authorization",Re.createElement(j,{path:B})),$&&Re.createElement("h6",null,"Authorized"),Re.createElement(w,null,Re.createElement(L,{source:s.get("description")})),Re.createElement(w,null,Re.createElement("label",{htmlFor:"auth_username"},"Username:"),$?Re.createElement("code",null," ",$," "):Re.createElement(x,null,Re.createElement(_,{id:"auth_username",type:"text",required:"required",name:"username",onChange:this.onChange,autoFocus:!0}))),Re.createElement(w,null,Re.createElement("label",{htmlFor:"auth_password"},"Password:"),$?Re.createElement("code",null," ****** "):Re.createElement(x,null,Re.createElement(_,{id:"auth_password",autoComplete:"new-password",name:"password",type:"password",onChange:this.onChange}))),U.valueSeq().map(((s,o)=>Re.createElement(C,{error:s,key:o}))))}}function example_Example(s){const{example:o,showValue:i,getComponent:a}=s,u=a("Markdown",!0),_=a("HighlightCode",!0);return o&&ze.Map.isMap(o)?Re.createElement("div",{className:"example"},o.get("description")?Re.createElement("section",{className:"example__section"},Re.createElement("div",{className:"example__section-header"},"Example Description"),Re.createElement("p",null,Re.createElement(u,{source:o.get("description")}))):null,i&&o.has("value")?Re.createElement("section",{className:"example__section"},Re.createElement("div",{className:"example__section-header"},"Example Value"),Re.createElement(_,null,stringify(o.get("value")))):null):null}class ExamplesSelect extends Re.PureComponent{static defaultProps={examples:(0,ze.Map)({}),onSelect:(...s)=>console.log("DEBUG: ExamplesSelect was not given an onSelect callback",...s),currentExampleKey:null,showLabels:!0};_onSelect=(s,{isSyntheticChange:o=!1}={})=>{"function"==typeof this.props.onSelect&&this.props.onSelect(s,{isSyntheticChange:o})};_onDomSelect=s=>{if("function"==typeof this.props.onSelect){const o=s.target.selectedOptions[0].getAttribute("value");this._onSelect(o,{isSyntheticChange:!1})}};getCurrentExample=()=>{const{examples:s,currentExampleKey:o}=this.props,i=s.get(o),a=s.keySeq().first(),u=s.get(a);return i||u||(0,ze.Map)({})};componentDidMount(){const{onSelect:s,examples:o}=this.props;if("function"==typeof s){const s=o.first(),i=o.keyOf(s);this._onSelect(i,{isSyntheticChange:!0})}}UNSAFE_componentWillReceiveProps(s){const{currentExampleKey:o,examples:i}=s;if(i!==this.props.examples&&!i.has(o)){const s=i.first(),o=i.keyOf(s);this._onSelect(o,{isSyntheticChange:!0})}}render(){const{examples:s,currentExampleKey:o,isValueModified:i,isModifiedValueAvailable:a,showLabels:u}=this.props;return Re.createElement("div",{className:"examples-select"},u?Re.createElement("span",{className:"examples-select__section-label"},"Examples: "):null,Re.createElement("select",{className:"examples-select-element",onChange:this._onDomSelect,value:a&&i?"__MODIFIED__VALUE__":o||""},a?Re.createElement("option",{value:"__MODIFIED__VALUE__"},"[Modified value]"):null,s.map(((s,o)=>Re.createElement("option",{key:o,value:o},ze.Map.isMap(s)&&s.get("summary")||o))).valueSeq()))}}const stringifyUnlessList=s=>ze.List.isList(s)?s:stringify(s);class ExamplesSelectValueRetainer extends Re.PureComponent{static defaultProps={userHasEditedBody:!1,examples:(0,ze.Map)({}),currentNamespace:"__DEFAULT__NAMESPACE__",setRetainRequestBodyValueFlag:()=>{},onSelect:(...s)=>console.log("ExamplesSelectValueRetainer: no `onSelect` function was provided",...s),updateValue:(...s)=>console.log("ExamplesSelectValueRetainer: no `updateValue` function was provided",...s)};constructor(s){super(s);const o=this._getCurrentExampleValue();this.state={[s.currentNamespace]:(0,ze.Map)({lastUserEditedValue:this.props.currentUserInputValue,lastDownstreamValue:o,isModifiedValueSelected:this.props.userHasEditedBody||this.props.currentUserInputValue!==o})}}componentWillUnmount(){this.props.setRetainRequestBodyValueFlag(!1)}_getStateForCurrentNamespace=()=>{const{currentNamespace:s}=this.props;return(this.state[s]||(0,ze.Map)()).toObject()};_setStateForCurrentNamespace=s=>{const{currentNamespace:o}=this.props;return this._setStateForNamespace(o,s)};_setStateForNamespace=(s,o)=>{const i=(this.state[s]||(0,ze.Map)()).mergeDeep(o);return this.setState({[s]:i})};_isCurrentUserInputSameAsExampleValue=()=>{const{currentUserInputValue:s}=this.props;return this._getCurrentExampleValue()===s};_getValueForExample=(s,o)=>{const{examples:i}=o||this.props;return stringifyUnlessList((i||(0,ze.Map)({})).getIn([s,"value"]))};_getCurrentExampleValue=s=>{const{currentKey:o}=s||this.props;return this._getValueForExample(o,s||this.props)};_onExamplesSelect=(s,{isSyntheticChange:o}={},...i)=>{const{onSelect:a,updateValue:u,currentUserInputValue:_,userHasEditedBody:w}=this.props,{lastUserEditedValue:x}=this._getStateForCurrentNamespace(),C=this._getValueForExample(s);if("__MODIFIED__VALUE__"===s)return u(stringifyUnlessList(x)),this._setStateForCurrentNamespace({isModifiedValueSelected:!0});"function"==typeof a&&a(s,{isSyntheticChange:o},...i),this._setStateForCurrentNamespace({lastDownstreamValue:C,isModifiedValueSelected:o&&w||!!_&&_!==C}),o||"function"==typeof u&&u(stringifyUnlessList(C))};UNSAFE_componentWillReceiveProps(s){const{currentUserInputValue:o,examples:i,onSelect:a,userHasEditedBody:u}=s,{lastUserEditedValue:_,lastDownstreamValue:w}=this._getStateForCurrentNamespace(),x=this._getValueForExample(s.currentKey,s),C=i.filter((s=>ze.Map.isMap(s)&&(s.get("value")===o||stringify(s.get("value"))===o)));if(C.size){let o;o=C.has(s.currentKey)?s.currentKey:C.keySeq().first(),a(o,{isSyntheticChange:!0})}else o!==this.props.currentUserInputValue&&o!==_&&o!==w&&(this.props.setRetainRequestBodyValueFlag(!0),this._setStateForNamespace(s.currentNamespace,{lastUserEditedValue:s.currentUserInputValue,isModifiedValueSelected:u||o!==x}))}render(){const{currentUserInputValue:s,examples:o,currentKey:i,getComponent:a,userHasEditedBody:u}=this.props,{lastDownstreamValue:_,lastUserEditedValue:w,isModifiedValueSelected:x}=this._getStateForCurrentNamespace(),C=a("ExamplesSelect");return Re.createElement(C,{examples:o,currentExampleKey:i,onSelect:this._onExamplesSelect,isModifiedValueAvailable:!!w&&w!==_,isValueModified:void 0!==s&&x&&s!==this._getCurrentExampleValue()||u})}}function oauth2_authorize_authorize({auth:s,authActions:o,errActions:i,configs:a,authConfigs:u={},currentServer:_}){let{schema:w,scopes:x,name:C,clientId:j}=s,L=w.get("flow"),B=[];switch(L){case"password":return void o.authorizePassword(s);case"application":case"clientCredentials":case"client_credentials":return void o.authorizeApplication(s);case"accessCode":case"authorizationCode":case"authorization_code":B.push("response_type=code");break;case"implicit":B.push("response_type=token")}"string"==typeof j&&B.push("client_id="+encodeURIComponent(j));let $=a.oauth2RedirectUrl;if(void 0===$)return void i.newAuthErr({authId:C,source:"validation",level:"error",message:"oauth2RedirectUrl configuration is not passed. Oauth2 authorization cannot be performed."});B.push("redirect_uri="+encodeURIComponent($));let U=[];if(Array.isArray(x)?U=x:We().List.isList(x)&&(U=x.toArray()),U.length>0){let s=u.scopeSeparator||" ";B.push("scope="+encodeURIComponent(U.join(s)))}let V=utils_btoa(new Date);if(B.push("state="+encodeURIComponent(V)),void 0!==u.realm&&B.push("realm="+encodeURIComponent(u.realm)),("authorizationCode"===L||"authorization_code"===L||"accessCode"===L)&&u.usePkceWithAuthorizationCodeGrant){const o=function generateCodeVerifier(){return b64toB64UrlEncoded(xt()(32).toString("base64"))}(),i=function createCodeChallenge(s){return b64toB64UrlEncoded(Ot()("sha256").update(s).digest("base64"))}(o);B.push("code_challenge="+i),B.push("code_challenge_method=S256"),s.codeVerifier=o}let{additionalQueryStringParams:z}=u;for(let s in z)void 0!==z[s]&&B.push([s,z[s]].map(encodeURIComponent).join("="));const Y=w.get("authorizationUrl");let Z;Z=_?Nt()(sanitizeUrl(Y),_,!0).toString():sanitizeUrl(Y);let ee,ie=[Z,B.join("&")].join("string"!=typeof Y||Y.includes("?")?"&":"?");ee="implicit"===L?o.preAuthorizeImplicit:u.useBasicAuthenticationWithAccessCodeGrant?o.authorizeAccessCodeWithBasicAuthentication:o.authorizeAccessCodeWithFormParams,o.authPopup(ie,{auth:s,state:V,redirectUrl:$,callback:ee,errCb:i.newAuthErr})}class Oauth2 extends Re.Component{constructor(s,o){super(s,o);let{name:i,schema:a,authorized:u,authSelectors:_}=this.props,w=u&&u.get(i),x=_.getConfigs()||{},C=w&&w.get("username")||"",j=w&&w.get("clientId")||x.clientId||"",L=w&&w.get("clientSecret")||x.clientSecret||"",B=w&&w.get("passwordType")||"basic",$=w&&w.get("scopes")||x.scopes||[];"string"==typeof $&&($=$.split(x.scopeSeparator||" ")),this.state={appName:x.appName,name:i,schema:a,scopes:$,clientId:j,clientSecret:L,username:C,password:"",passwordType:B}}close=s=>{s.preventDefault();let{authActions:o}=this.props;o.showDefinitions(!1)};authorize=()=>{let{authActions:s,errActions:o,getConfigs:i,authSelectors:a,oas3Selectors:u}=this.props,_=i(),w=a.getConfigs();o.clear({authId:name,type:"auth",source:"auth"}),oauth2_authorize_authorize({auth:this.state,currentServer:u.serverEffectiveValue(u.selectedServer()),authActions:s,errActions:o,configs:_,authConfigs:w})};onScopeChange=s=>{let{target:o}=s,{checked:i}=o,a=o.dataset.value;if(i&&-1===this.state.scopes.indexOf(a)){let s=this.state.scopes.concat([a]);this.setState({scopes:s})}else!i&&this.state.scopes.indexOf(a)>-1&&this.setState({scopes:this.state.scopes.filter((s=>s!==a))})};onInputChange=s=>{let{target:{dataset:{name:o},value:i}}=s,a={[o]:i};this.setState(a)};selectScopes=s=>{s.target.dataset.all?this.setState({scopes:Array.from((this.props.schema.get("allowedScopes")||this.props.schema.get("scopes")).keys())}):this.setState({scopes:[]})};logout=s=>{s.preventDefault();let{authActions:o,errActions:i,name:a}=this.props;i.clear({authId:a,type:"auth",source:"auth"}),o.logoutWithPersistOption([a])};render(){let{schema:s,getComponent:o,authSelectors:i,errSelectors:a,name:u,specSelectors:_}=this.props;const w=o("Input"),x=o("Row"),C=o("Col"),j=o("Button"),L=o("authError"),B=o("JumpToPath",!0),$=o("Markdown",!0),U=o("InitializedInput"),{isOAS3:V}=_;let z=V()?s.get("openIdConnectUrl"):null;const Y="implicit",Z="password",ee=V()?z?"authorization_code":"authorizationCode":"accessCode",ie=V()?z?"client_credentials":"clientCredentials":"application",ae=i.selectAuthPath(u);let ce=!!(i.getConfigs()||{}).usePkceWithAuthorizationCodeGrant,le=s.get("flow"),pe=le===ee&&ce?le+" with PKCE":le,de=s.get("allowedScopes")||s.get("scopes"),fe=!!i.authorized().get(u),ye=a.allErrors().filter((s=>s.get("authId")===u)),be=!ye.filter((s=>"validation"===s.get("source"))).size,Se=s.get("description");return Re.createElement("div",null,Re.createElement("h4",null,u," (OAuth2, ",pe,") ",Re.createElement(B,{path:ae})),this.state.appName?Re.createElement("h5",null,"Application: ",this.state.appName," "):null,Se&&Re.createElement($,{source:s.get("description")}),fe&&Re.createElement("h6",null,"Authorized"),z&&Re.createElement("p",null,"OpenID Connect URL: ",Re.createElement("code",null,z)),(le===Y||le===ee)&&Re.createElement("p",null,"Authorization URL: ",Re.createElement("code",null,s.get("authorizationUrl"))),(le===Z||le===ee||le===ie)&&Re.createElement("p",null,"Token URL:",Re.createElement("code",null," ",s.get("tokenUrl"))),Re.createElement("p",{className:"flow"},"Flow: ",Re.createElement("code",null,pe)),le!==Z?null:Re.createElement(x,null,Re.createElement(x,null,Re.createElement("label",{htmlFor:"oauth_username"},"username:"),fe?Re.createElement("code",null," ",this.state.username," "):Re.createElement(C,{tablet:10,desktop:10},Re.createElement("input",{id:"oauth_username",type:"text","data-name":"username",onChange:this.onInputChange,autoFocus:!0}))),Re.createElement(x,null,Re.createElement("label",{htmlFor:"oauth_password"},"password:"),fe?Re.createElement("code",null," ****** "):Re.createElement(C,{tablet:10,desktop:10},Re.createElement("input",{id:"oauth_password",type:"password","data-name":"password",onChange:this.onInputChange}))),Re.createElement(x,null,Re.createElement("label",{htmlFor:"password_type"},"Client credentials location:"),fe?Re.createElement("code",null," ",this.state.passwordType," "):Re.createElement(C,{tablet:10,desktop:10},Re.createElement("select",{id:"password_type","data-name":"passwordType",onChange:this.onInputChange},Re.createElement("option",{value:"basic"},"Authorization header"),Re.createElement("option",{value:"request-body"},"Request body"))))),(le===ie||le===Y||le===ee||le===Z)&&(!fe||fe&&this.state.clientId)&&Re.createElement(x,null,Re.createElement("label",{htmlFor:`client_id_${le}`},"client_id:"),fe?Re.createElement("code",null," ****** "):Re.createElement(C,{tablet:10,desktop:10},Re.createElement(U,{id:`client_id_${le}`,type:"text",required:le===Z,initialValue:this.state.clientId,"data-name":"clientId",onChange:this.onInputChange}))),(le===ie||le===ee||le===Z)&&Re.createElement(x,null,Re.createElement("label",{htmlFor:`client_secret_${le}`},"client_secret:"),fe?Re.createElement("code",null," ****** "):Re.createElement(C,{tablet:10,desktop:10},Re.createElement(U,{id:`client_secret_${le}`,initialValue:this.state.clientSecret,type:"password","data-name":"clientSecret",onChange:this.onInputChange}))),!fe&&de&&de.size?Re.createElement("div",{className:"scopes"},Re.createElement("h2",null,"Scopes:",Re.createElement("a",{onClick:this.selectScopes,"data-all":!0},"select all"),Re.createElement("a",{onClick:this.selectScopes},"select none")),de.map(((s,o)=>Re.createElement(x,{key:o},Re.createElement("div",{className:"checkbox"},Re.createElement(w,{"data-value":o,id:`${o}-${le}-checkbox-${this.state.name}`,disabled:fe,checked:this.state.scopes.includes(o),type:"checkbox",onChange:this.onScopeChange}),Re.createElement("label",{htmlFor:`${o}-${le}-checkbox-${this.state.name}`},Re.createElement("span",{className:"item"}),Re.createElement("div",{className:"text"},Re.createElement("p",{className:"name"},o),Re.createElement("p",{className:"description"},s))))))).toArray()):null,ye.valueSeq().map(((s,o)=>Re.createElement(L,{error:s,key:o}))),Re.createElement("div",{className:"auth-btn-wrapper"},be&&(fe?Re.createElement(j,{className:"btn modal-btn auth authorize",onClick:this.logout,"aria-label":"Remove authorization"},"Logout"):Re.createElement(j,{className:"btn modal-btn auth authorize",onClick:this.authorize,"aria-label":"Apply given OAuth2 credentials"},"Authorize")),Re.createElement(j,{className:"btn modal-btn auth btn-done",onClick:this.close},"Close")))}}class Clear extends Re.Component{onClick=()=>{let{specActions:s,path:o,method:i}=this.props;s.clearResponse(o,i),s.clearRequest(o,i)};render(){return Re.createElement("button",{className:"btn btn-clear opblock-control__btn",onClick:this.onClick},"Clear")}}const live_response_Headers=({headers:s})=>Re.createElement("div",null,Re.createElement("h5",null,"Response headers"),Re.createElement("pre",{className:"microlight"},s)),Duration=({duration:s})=>Re.createElement("div",null,Re.createElement("h5",null,"Request duration"),Re.createElement("pre",{className:"microlight"},s," ms"));class LiveResponse extends Re.Component{shouldComponentUpdate(s){return this.props.response!==s.response||this.props.path!==s.path||this.props.method!==s.method||this.props.displayRequestDuration!==s.displayRequestDuration}render(){const{response:s,getComponent:o,getConfigs:i,displayRequestDuration:a,specSelectors:u,path:_,method:w}=this.props,{showMutatedRequest:x,requestSnippetsEnabled:C}=i(),j=x?u.mutatedRequestFor(_,w):u.requestFor(_,w),L=s.get("status"),B=j.get("url"),$=s.get("headers").toJS(),U=s.get("notDocumented"),V=s.get("error"),z=s.get("text"),Y=s.get("duration"),Z=Object.keys($),ee=$["content-type"]||$["Content-Type"],ie=o("responseBody"),ae=Z.map((s=>{var o=Array.isArray($[s])?$[s].join():$[s];return Re.createElement("span",{className:"headerline",key:s}," ",s,": ",o," ")})),ce=0!==ae.length,le=o("Markdown",!0),pe=o("RequestSnippets",!0),de=o("curl",!0);return Re.createElement("div",null,j&&C?Re.createElement(pe,{request:j}):Re.createElement(de,{request:j}),B&&Re.createElement("div",null,Re.createElement("div",{className:"request-url"},Re.createElement("h4",null,"Request URL"),Re.createElement("pre",{className:"microlight"},B))),Re.createElement("h4",null,"Server response"),Re.createElement("table",{className:"responses-table live-responses-table"},Re.createElement("thead",null,Re.createElement("tr",{className:"responses-header"},Re.createElement("td",{className:"col_header response-col_status"},"Code"),Re.createElement("td",{className:"col_header response-col_description"},"Details"))),Re.createElement("tbody",null,Re.createElement("tr",{className:"response"},Re.createElement("td",{className:"response-col_status"},L,U?Re.createElement("div",{className:"response-undocumented"},Re.createElement("i",null," Undocumented ")):null),Re.createElement("td",{className:"response-col_description"},V?Re.createElement(le,{source:`${""!==s.get("name")?`${s.get("name")}: `:""}${s.get("message")}`}):null,z?Re.createElement(ie,{content:z,contentType:ee,url:B,headers:$,getConfigs:i,getComponent:o}):null,ce?Re.createElement(live_response_Headers,{headers:ae}):null,a&&Y?Re.createElement(Duration,{duration:Y}):null)))))}}class OnlineValidatorBadge extends Re.Component{constructor(s,o){super(s,o);let{getConfigs:i}=s,{validatorUrl:a}=i();this.state={url:this.getDefinitionUrl(),validatorUrl:void 0===a?"https://validator.swagger.io/validator":a}}getDefinitionUrl=()=>{let{specSelectors:s}=this.props;return new(Nt())(s.url(),lt.location).toString()};UNSAFE_componentWillReceiveProps(s){let{getConfigs:o}=s,{validatorUrl:i}=o();this.setState({url:this.getDefinitionUrl(),validatorUrl:void 0===i?"https://validator.swagger.io/validator":i})}render(){let{getConfigs:s}=this.props,{spec:o}=s(),i=sanitizeUrl(this.state.validatorUrl);return"object"==typeof o&&Object.keys(o).length?null:this.state.url&&requiresValidationURL(this.state.validatorUrl)&&requiresValidationURL(this.state.url)?Re.createElement("span",{className:"float-right"},Re.createElement("a",{target:"_blank",rel:"noopener noreferrer",href:`${i}/debug?url=${encodeURIComponent(this.state.url)}`},Re.createElement(ValidatorImage,{src:`${i}?url=${encodeURIComponent(this.state.url)}`,alt:"Online validator badge"}))):null}}class ValidatorImage extends Re.Component{constructor(s){super(s),this.state={loaded:!1,error:!1}}componentDidMount(){const s=new Image;s.onload=()=>{this.setState({loaded:!0})},s.onerror=()=>{this.setState({error:!0})},s.src=this.props.src}UNSAFE_componentWillReceiveProps(s){if(s.src!==this.props.src){const o=new Image;o.onload=()=>{this.setState({loaded:!0})},o.onerror=()=>{this.setState({error:!0})},o.src=s.src}}render(){return this.state.error?Re.createElement("img",{alt:"Error"}):this.state.loaded?Re.createElement("img",{src:this.props.src,alt:this.props.alt}):null}}class Operations extends Re.Component{render(){let{specSelectors:s}=this.props;const o=s.taggedOperations();return 0===o.size?Re.createElement("h3",null," No operations defined in spec!"):Re.createElement("div",null,o.map(this.renderOperationTag).toArray(),o.size<1?Re.createElement("h3",null," No operations defined in spec! "):null)}renderOperationTag=(s,o)=>{const{specSelectors:i,getComponent:a,oas3Selectors:u,layoutSelectors:_,layoutActions:w,getConfigs:x}=this.props,C=i.validOperationMethods(),j=a("OperationContainer",!0),L=a("OperationTag"),B=s.get("operations");return Re.createElement(L,{key:"operation-"+o,tagObj:s,tag:o,oas3Selectors:u,layoutSelectors:_,layoutActions:w,getConfigs:x,getComponent:a,specUrl:i.url()},Re.createElement("div",{className:"operation-tag-content"},B.map((s=>{const i=s.get("path"),a=s.get("method"),u=s.get("specPath");return-1===C.indexOf(a)?null:Re.createElement(j,{key:`${i}-${a}`,specPath:u,op:s,path:i,method:a,tag:o})})).toArray()))}}class OperationTag extends Re.Component{static defaultProps={tagObj:We().fromJS({}),tag:""};render(){const{tagObj:s,tag:o,children:i,oas3Selectors:a,layoutSelectors:u,layoutActions:_,getConfigs:w,getComponent:x,specUrl:C}=this.props;let{docExpansion:j,deepLinking:L}=w();const B=x("Collapse"),$=x("Markdown",!0),U=x("DeepLink"),V=x("Link"),z=x("ArrowUpIcon"),Y=x("ArrowDownIcon");let Z,ee=s.getIn(["tagDetails","description"],null),ie=s.getIn(["tagDetails","externalDocs","description"]),ae=s.getIn(["tagDetails","externalDocs","url"]);Z=isFunc(a)&&isFunc(a.selectedServer)?safeBuildUrl(ae,C,{selectedServer:a.selectedServer()}):ae;let ce=["operations-tag",o],le=u.isShown(ce,"full"===j||"list"===j);return Re.createElement("div",{className:le?"opblock-tag-section is-open":"opblock-tag-section"},Re.createElement("h3",{onClick:()=>_.show(ce,!le),className:ee?"opblock-tag":"opblock-tag no-desc",id:ce.map((s=>escapeDeepLinkPath(s))).join("-"),"data-tag":o,"data-is-open":le},Re.createElement(U,{enabled:L,isShown:le,path:createDeepLinkPath(o),text:o}),ee?Re.createElement("small",null,Re.createElement($,{source:ee})):Re.createElement("small",null),Z?Re.createElement("div",{className:"info__externaldocs"},Re.createElement("small",null,Re.createElement(V,{href:sanitizeUrl(Z),onClick:s=>s.stopPropagation(),target:"_blank"},ie||Z))):null,Re.createElement("button",{"aria-expanded":le,className:"expand-operation",title:le?"Collapse operation":"Expand operation",onClick:()=>_.show(ce,!le)},le?Re.createElement(z,{className:"arrow"}):Re.createElement(Y,{className:"arrow"}))),Re.createElement(B,{isOpened:le},i))}}class operation_Operation extends Re.PureComponent{static defaultProps={operation:null,response:null,request:null,specPath:(0,ze.List)(),summary:""};render(){let{specPath:s,response:o,request:i,toggleShown:a,onTryoutClick:u,onResetClick:_,onCancelClick:w,onExecute:x,fn:C,getComponent:j,getConfigs:L,specActions:B,specSelectors:$,authActions:U,authSelectors:V,oas3Actions:z,oas3Selectors:Y}=this.props,Z=this.props.operation,{deprecated:ee,isShown:ie,path:ae,method:ce,op:le,tag:pe,operationId:de,allowTryItOut:fe,displayRequestDuration:ye,tryItOutEnabled:be,executeInProgress:Se}=Z.toObject();const _e=le.get("description"),we=le.get("externalDocs")?.toJS(),xe=le.get("schemes")?.toJS(),Pe=we?safeBuildUrl(we.url,$.url(),{selectedServer:Y.selectedServer()}):"";let Te=Z.getIn(["op"]),$e=Te.get("responses"),qe=function getList(s,o){if(!We().Iterable.isIterable(s))return We().List();let i=s.getIn(Array.isArray(o)?o:[o]);return We().List.isList(i)?i:We().List()}(Te,["parameters"]),ze=$.operationScheme(ae,ce),He=["operations",pe,de],Ye=getExtensions(Te);const Xe=j("responses",!0),Qe=j("parameters",!0),et=j("execute"),tt=j("clear"),rt=j("Collapse"),nt=j("Markdown",!0),st=j("schemes"),ot=j("OperationServers"),it=j("OperationExt"),at=j("OperationSummary"),ct=j("Link"),{showExtensions:lt}=L();if($e&&o&&o.size>0){let s=!$e.get(String(o.get("status")))&&!$e.get("default");o=o.set("notDocumented",s)}let ut=[ae,ce];const pt=$.validationErrors([ae,ce]);return Re.createElement("div",{className:ee?"opblock opblock-deprecated":ie?`opblock opblock-${ce} is-open`:`opblock opblock-${ce}`,id:escapeDeepLinkPath(He.join("-"))},Re.createElement(at,{operationProps:Z,isShown:ie,toggleShown:a,getComponent:j,authActions:U,authSelectors:V,specPath:s}),Re.createElement(rt,{isOpened:ie},Re.createElement("div",{className:"opblock-body"},Te&&Te.size||null===Te?null:Re.createElement(rolling_load,{height:"32px",width:"32px",className:"opblock-loading-animation"}),ee&&Re.createElement("h4",{className:"opblock-title_normal"}," Warning: Deprecated"),_e&&Re.createElement("div",{className:"opblock-description-wrapper"},Re.createElement("div",{className:"opblock-description"},Re.createElement(nt,{source:_e}))),Pe?Re.createElement("div",{className:"opblock-external-docs-wrapper"},Re.createElement("h4",{className:"opblock-title_normal"},"Find more details"),Re.createElement("div",{className:"opblock-external-docs"},we.description&&Re.createElement("span",{className:"opblock-external-docs__description"},Re.createElement(nt,{source:we.description})),Re.createElement(ct,{target:"_blank",className:"opblock-external-docs__link",href:sanitizeUrl(Pe)},Pe))):null,Te&&Te.size?Re.createElement(Qe,{parameters:qe,specPath:s.push("parameters"),operation:Te,onChangeKey:ut,onTryoutClick:u,onResetClick:_,onCancelClick:w,tryItOutEnabled:be,allowTryItOut:fe,fn:C,getComponent:j,specActions:B,specSelectors:$,pathMethod:[ae,ce],getConfigs:L,oas3Actions:z,oas3Selectors:Y}):null,be?Re.createElement(ot,{getComponent:j,path:ae,method:ce,operationServers:Te.get("servers"),pathServers:$.paths().getIn([ae,"servers"]),getSelectedServer:Y.selectedServer,setSelectedServer:z.setSelectedServer,setServerVariableValue:z.setServerVariableValue,getServerVariable:Y.serverVariableValue,getEffectiveServerValue:Y.serverEffectiveValue}):null,be&&fe&&xe&&xe.size?Re.createElement("div",{className:"opblock-schemes"},Re.createElement(st,{schemes:xe,path:ae,method:ce,specActions:B,currentScheme:ze})):null,!be||!fe||pt.length<=0?null:Re.createElement("div",{className:"validation-errors errors-wrapper"},"Please correct the following validation errors and try again.",Re.createElement("ul",null,pt.map(((s,o)=>Re.createElement("li",{key:o}," ",s," "))))),Re.createElement("div",{className:be&&o&&fe?"btn-group":"execute-wrapper"},be&&fe?Re.createElement(et,{operation:Te,specActions:B,specSelectors:$,oas3Selectors:Y,oas3Actions:z,path:ae,method:ce,onExecute:x,disabled:Se}):null,be&&o&&fe?Re.createElement(tt,{specActions:B,path:ae,method:ce}):null),Se?Re.createElement("div",{className:"loading-container"},Re.createElement("div",{className:"loading"})):null,$e?Re.createElement(Xe,{responses:$e,request:i,tryItOutResponse:o,getComponent:j,getConfigs:L,specSelectors:$,oas3Actions:z,oas3Selectors:Y,specActions:B,produces:$.producesOptionsFor([ae,ce]),producesValue:$.currentProducesFor([ae,ce]),specPath:s.push("responses"),path:ae,method:ce,displayRequestDuration:ye,fn:C}):null,lt&&Ye.size?Re.createElement(it,{extensions:Ye,getComponent:j}):null)))}}class OperationContainer extends Re.PureComponent{constructor(s,o){super(s,o);const{tryItOutEnabled:i}=s.getConfigs();this.state={tryItOutEnabled:i,executeInProgress:!1}}static defaultProps={showSummary:!0,response:null,allowTryItOut:!0,displayOperationId:!1,displayRequestDuration:!1};mapStateToProps(s,o){const{op:i,layoutSelectors:a,getConfigs:u}=o,{docExpansion:_,deepLinking:w,displayOperationId:x,displayRequestDuration:C,supportedSubmitMethods:j}=u(),L=a.showSummary(),B=i.getIn(["operation","__originalOperationId"])||i.getIn(["operation","operationId"])||opId(i.get("operation"),o.path,o.method)||i.get("id"),$=["operations",o.tag,B],U=j.indexOf(o.method)>=0&&(void 0===o.allowTryItOut?o.specSelectors.allowTryItOutFor(o.path,o.method):o.allowTryItOut),V=i.getIn(["operation","security"])||o.specSelectors.security();return{operationId:B,isDeepLinkingEnabled:w,showSummary:L,displayOperationId:x,displayRequestDuration:C,allowTryItOut:U,security:V,isAuthorized:o.authSelectors.isAuthorized(V),isShown:a.isShown($,"full"===_),jumpToKey:`paths.${o.path}.${o.method}`,response:o.specSelectors.responseFor(o.path,o.method),request:o.specSelectors.requestFor(o.path,o.method)}}componentDidMount(){const{isShown:s}=this.props,o=this.getResolvedSubtree();s&&void 0===o&&this.requestResolvedSubtree()}componentDidUpdate(s){const{response:o,isShown:i}=this.props,a=this.getResolvedSubtree();o!==s.response&&this.setState({executeInProgress:!1}),i&&void 0===a&&this.requestResolvedSubtree()}toggleShown=()=>{let{layoutActions:s,tag:o,operationId:i,isShown:a}=this.props;const u=this.getResolvedSubtree();a||void 0!==u||this.requestResolvedSubtree(),s.show(["operations",o,i],!a)};onCancelClick=()=>{this.setState({tryItOutEnabled:!this.state.tryItOutEnabled})};onTryoutClick=()=>{this.setState({tryItOutEnabled:!this.state.tryItOutEnabled})};onResetClick=s=>{const o=this.props.oas3Selectors.selectDefaultRequestBodyValue(...s),i=this.props.oas3Selectors.requestContentType(...s);if("application/x-www-form-urlencoded"===i||"multipart/form-data"===i){const i=JSON.parse(o);Object.entries(i).forEach((([s,o])=>{Array.isArray(o)?i[s]=i[s].map((s=>"object"==typeof s?JSON.stringify(s,null,2):s)):"object"==typeof o&&(i[s]=JSON.stringify(i[s],null,2))})),this.props.oas3Actions.setRequestBodyValue({value:(0,ze.fromJS)(i),pathMethod:s})}else this.props.oas3Actions.setRequestBodyValue({value:o,pathMethod:s})};onExecute=()=>{this.setState({executeInProgress:!0})};getResolvedSubtree=()=>{const{specSelectors:s,path:o,method:i,specPath:a}=this.props;return a?s.specResolvedSubtree(a.toJS()):s.specResolvedSubtree(["paths",o,i])};requestResolvedSubtree=()=>{const{specActions:s,path:o,method:i,specPath:a}=this.props;return a?s.requestResolvedSubtree(a.toJS()):s.requestResolvedSubtree(["paths",o,i])};render(){let{op:s,tag:o,path:i,method:a,security:u,isAuthorized:_,operationId:w,showSummary:x,isShown:C,jumpToKey:j,allowTryItOut:L,response:B,request:$,displayOperationId:U,displayRequestDuration:V,isDeepLinkingEnabled:z,specPath:Y,specSelectors:Z,specActions:ee,getComponent:ie,getConfigs:ae,layoutSelectors:ce,layoutActions:le,authActions:pe,authSelectors:de,oas3Actions:fe,oas3Selectors:ye,fn:be}=this.props;const Se=ie("operation"),_e=this.getResolvedSubtree()||(0,ze.Map)(),we=(0,ze.fromJS)({op:_e,tag:o,path:i,summary:s.getIn(["operation","summary"])||"",deprecated:_e.get("deprecated")||s.getIn(["operation","deprecated"])||!1,method:a,security:u,isAuthorized:_,operationId:w,originalOperationId:_e.getIn(["operation","__originalOperationId"]),showSummary:x,isShown:C,jumpToKey:j,allowTryItOut:L,request:$,displayOperationId:U,displayRequestDuration:V,isDeepLinkingEnabled:z,executeInProgress:this.state.executeInProgress,tryItOutEnabled:this.state.tryItOutEnabled});return Re.createElement(Se,{operation:we,response:B,request:$,isShown:C,toggleShown:this.toggleShown,onTryoutClick:this.onTryoutClick,onResetClick:this.onResetClick,onCancelClick:this.onCancelClick,onExecute:this.onExecute,specPath:Y,specActions:ee,specSelectors:Z,oas3Actions:fe,oas3Selectors:ye,layoutActions:le,layoutSelectors:ce,authActions:pe,authSelectors:de,getComponent:ie,getConfigs:ae,fn:be})}}var BO=__webpack_require__(13222),$O=__webpack_require__.n(BO);class OperationSummary extends Re.PureComponent{static defaultProps={operationProps:null,specPath:(0,ze.List)(),summary:""};render(){let{isShown:s,toggleShown:o,getComponent:i,authActions:a,authSelectors:u,operationProps:_,specPath:w}=this.props,{summary:x,isAuthorized:C,method:j,op:L,showSummary:B,path:$,operationId:U,originalOperationId:V,displayOperationId:z}=_.toObject();const Y=L.get("summary"),Z=_.get("security"),ee=i("authorizeOperationBtn",!0),ie=i("OperationSummaryMethod"),ae=i("OperationSummaryPath"),ce=i("JumpToPath",!0),le=i("CopyToClipboardBtn",!0),pe=i("ArrowUpIcon"),de=i("ArrowDownIcon"),fe=Z&&!!Z.count(),ye=fe&&1===Z.size&&Z.first().isEmpty(),be=!fe||ye;return Re.createElement("div",{className:`opblock-summary opblock-summary-${j}`},Re.createElement("button",{"aria-expanded":s,className:"opblock-summary-control",onClick:o},Re.createElement(ie,{method:j}),Re.createElement("div",{className:"opblock-summary-path-description-wrapper"},Re.createElement(ae,{getComponent:i,operationProps:_,specPath:w}),B?Re.createElement("div",{className:"opblock-summary-description"},$O()(Y||x)):null),z&&(V||U)?Re.createElement("span",{className:"opblock-summary-operation-id"},V||U):null),Re.createElement(le,{textToCopy:`${w.get(1)}`}),be?null:Re.createElement(ee,{isAuthorized:C,onClick:()=>{const s=u.definitionsForRequirements(Z);a.showDefinitions(s)}}),Re.createElement(ce,{path:w}),Re.createElement("button",{"aria-label":`${j} ${$.replace(/\//g,"​/")}`,className:"opblock-control-arrow","aria-expanded":s,tabIndex:"-1",onClick:o},s?Re.createElement(pe,{className:"arrow"}):Re.createElement(de,{className:"arrow"})))}}class OperationSummaryMethod extends Re.PureComponent{static defaultProps={operationProps:null};render(){let{method:s}=this.props;return Re.createElement("span",{className:"opblock-summary-method"},s.toUpperCase())}}class OperationSummaryPath extends Re.PureComponent{render(){let{getComponent:s,operationProps:o}=this.props,{deprecated:i,isShown:a,path:u,tag:_,operationId:w,isDeepLinkingEnabled:x}=o.toObject();const C=u.split(/(?=\/)/g);for(let s=1;s<C.length;s+=2)C.splice(s,0,Re.createElement("wbr",{key:s}));const j=s("DeepLink");return Re.createElement("span",{className:i?"opblock-summary-path__deprecated":"opblock-summary-path","data-path":u},Re.createElement(j,{enabled:x,isShown:a,path:createDeepLinkPath(`${_}/${w}`),text:C}))}}const operation_extensions=({extensions:s,getComponent:o})=>{let i=o("OperationExtRow");return Re.createElement("div",{className:"opblock-section"},Re.createElement("div",{className:"opblock-section-header"},Re.createElement("h4",null,"Extensions")),Re.createElement("div",{className:"table-container"},Re.createElement("table",null,Re.createElement("thead",null,Re.createElement("tr",null,Re.createElement("td",{className:"col_header"},"Field"),Re.createElement("td",{className:"col_header"},"Value"))),Re.createElement("tbody",null,s.entrySeq().map((([s,o])=>Re.createElement(i,{key:`${s}-${o}`,xKey:s,xVal:o})))))))},operation_extension_row=({xKey:s,xVal:o})=>{const i=o?o.toJS?o.toJS():o:null;return Re.createElement("tr",null,Re.createElement("td",null,s),Re.createElement("td",null,JSON.stringify(i)))};function createHtmlReadyId(s,o="_"){return s.replace(/[^\w-]/g,o)}class responses_Responses extends Re.Component{static defaultProps={tryItOutResponse:null,produces:(0,ze.fromJS)(["application/json"]),displayRequestDuration:!1};onChangeProducesWrapper=s=>this.props.specActions.changeProducesValue([this.props.path,this.props.method],s);onResponseContentTypeChange=({controlsAcceptHeader:s,value:o})=>{const{oas3Actions:i,path:a,method:u}=this.props;s&&i.setResponseContentType({value:o,path:a,method:u})};render(){let{responses:s,tryItOutResponse:o,getComponent:i,getConfigs:a,specSelectors:u,fn:_,producesValue:w,displayRequestDuration:x,specPath:C,path:j,method:L,oas3Selectors:B,oas3Actions:$}=this.props,U=function defaultStatusCode(s){let o=s.keySeq();return o.contains(jt)?jt:o.filter((s=>"2"===(s+"")[0])).sort().first()}(s);const V=i("contentType"),z=i("liveResponse"),Y=i("response");let Z=this.props.produces&&this.props.produces.size?this.props.produces:responses_Responses.defaultProps.produces;const ee=u.isOAS3()?function getAcceptControllingResponse(s){if(!We().OrderedMap.isOrderedMap(s))return null;if(!s.size)return null;const o=s.find(((s,o)=>o.startsWith("2")&&Object.keys(s.get("content")||{}).length>0)),i=s.get("default")||We().OrderedMap(),a=(i.get("content")||We().OrderedMap()).keySeq().toJS().length?i:null;return o||a}(s):null,ie=s.filter(((s,o)=>!isExtension(o))),ae=createHtmlReadyId(`${L}${j}_responses`),ce=`${ae}_select`;return ie&&ie.size?Re.createElement("div",{className:"responses-wrapper"},Re.createElement("div",{className:"opblock-section-header"},Re.createElement("h4",null,"Responses"),u.isOAS3()?null:Re.createElement("label",{htmlFor:ce},Re.createElement("span",null,"Response content type"),Re.createElement(V,{value:w,ariaControls:ae,ariaLabel:"Response content type",className:"execute-content-type",contentTypes:Z,controlId:ce,onChange:this.onChangeProducesWrapper}))),Re.createElement("div",{className:"responses-inner"},o?Re.createElement("div",null,Re.createElement(z,{response:o,getComponent:i,getConfigs:a,specSelectors:u,path:this.props.path,method:this.props.method,displayRequestDuration:x}),Re.createElement("h4",null,"Responses")):null,Re.createElement("table",{"aria-live":"polite",className:"responses-table",id:ae,role:"region"},Re.createElement("thead",null,Re.createElement("tr",{className:"responses-header"},Re.createElement("td",{className:"col_header response-col_status"},"Code"),Re.createElement("td",{className:"col_header response-col_description"},"Description"),u.isOAS3()?Re.createElement("td",{className:"col col_header response-col_links"},"Links"):null)),Re.createElement("tbody",null,ie.entrySeq().map((([s,x])=>{let V=o&&o.get("status")==s?"response_current":"";return Re.createElement(Y,{key:s,path:j,method:L,specPath:C.push(s),isDefault:U===s,fn:_,className:V,code:s,response:x,specSelectors:u,controlsAcceptHeader:x===ee,onContentTypeChange:this.onResponseContentTypeChange,contentType:w,getConfigs:a,activeExamplesKey:B.activeExamplesMember(j,L,"responses",s),oas3Actions:$,getComponent:i})})).toArray())))):null}}function getKnownSyntaxHighlighterLanguage(s){const o=function canJsonParse(s){try{return!!JSON.parse(s)}catch(s){return null}}(s);return o?"json":null}class response_Response extends Re.Component{constructor(s,o){super(s,o),this.state={responseContentType:""}}static defaultProps={response:(0,ze.fromJS)({}),onContentTypeChange:()=>{}};_onContentTypeChange=s=>{const{onContentTypeChange:o,controlsAcceptHeader:i}=this.props;this.setState({responseContentType:s}),o({value:s,controlsAcceptHeader:i})};getTargetExamplesKey=()=>{const{response:s,contentType:o,activeExamplesKey:i}=this.props,a=this.state.responseContentType||o,u=s.getIn(["content",a],(0,ze.Map)({})).get("examples",null).keySeq().first();return i||u};render(){let{path:s,method:o,code:i,response:a,className:u,specPath:_,fn:w,getComponent:x,getConfigs:C,specSelectors:j,contentType:L,controlsAcceptHeader:B,oas3Actions:$}=this.props,{inferSchema:U,getSampleSchema:V}=w,z=j.isOAS3();const{showExtensions:Y}=C();let Z=Y?getExtensions(a):null,ee=a.get("headers"),ie=a.get("links");const ae=x("ResponseExtension"),ce=x("headers"),le=x("HighlightCode",!0),pe=x("modelExample"),de=x("Markdown",!0),fe=x("operationLink"),ye=x("contentType"),be=x("ExamplesSelect"),Se=x("Example");var _e,we;const xe=this.state.responseContentType||L,Pe=a.getIn(["content",xe],(0,ze.Map)({})),Te=Pe.get("examples",null);if(z){const s=Pe.get("schema");_e=s?U(s.toJS()):null,we=s?_.push("content",this.state.responseContentType,"schema"):_}else _e=a.get("schema"),we=a.has("schema")?_.push("schema"):_;let $e,qe,We=!1,He={includeReadOnly:!0};if(z)if(qe=Pe.get("schema")?.toJS(),ze.Map.isMap(Te)&&!Te.isEmpty()){const s=this.getTargetExamplesKey(),getMediaTypeExample=s=>ze.Map.isMap(s)?s.get("value"):void 0;$e=getMediaTypeExample(Te.get(s,(0,ze.Map)({}))),void 0===$e&&($e=getMediaTypeExample(Te.values().next().value)),We=!0}else void 0!==Pe.get("example")&&($e=Pe.get("example"),We=!0);else{qe=_e,He={...He,includeWriteOnly:!0};const s=a.getIn(["examples",xe]);s&&($e=s,We=!0)}const Ye=((s,o)=>{if(null==s)return null;const i=getKnownSyntaxHighlighterLanguage(s)?"json":null;return Re.createElement("div",null,Re.createElement(o,{className:"example",language:i},stringify(s)))})(V(qe,xe,He,We?$e:void 0),le);return Re.createElement("tr",{className:"response "+(u||""),"data-code":i},Re.createElement("td",{className:"response-col_status"},i),Re.createElement("td",{className:"response-col_description"},Re.createElement("div",{className:"response-col_description__inner"},Re.createElement(de,{source:a.get("description")})),Y&&Z.size?Z.entrySeq().map((([s,o])=>Re.createElement(ae,{key:`${s}-${o}`,xKey:s,xVal:o}))):null,z&&a.get("content")?Re.createElement("section",{className:"response-controls"},Re.createElement("div",{className:Jn()("response-control-media-type",{"response-control-media-type--accept-controller":B})},Re.createElement("small",{className:"response-control-media-type__title"},"Media type"),Re.createElement(ye,{value:this.state.responseContentType,contentTypes:a.get("content")?a.get("content").keySeq():(0,ze.Seq)(),onChange:this._onContentTypeChange,ariaLabel:"Media Type"}),B?Re.createElement("small",{className:"response-control-media-type__accept-message"},"Controls ",Re.createElement("code",null,"Accept")," header."):null),ze.Map.isMap(Te)&&!Te.isEmpty()?Re.createElement("div",{className:"response-control-examples"},Re.createElement("small",{className:"response-control-examples__title"},"Examples"),Re.createElement(be,{examples:Te,currentExampleKey:this.getTargetExamplesKey(),onSelect:a=>$.setActiveExamplesMember({name:a,pathMethod:[s,o],contextType:"responses",contextName:i}),showLabels:!1})):null):null,Ye||_e?Re.createElement(pe,{specPath:we,getComponent:x,getConfigs:C,specSelectors:j,schema:fromJSOrdered(_e),example:Ye,includeReadOnly:!0}):null,z&&Te?Re.createElement(Se,{example:Te.get(this.getTargetExamplesKey(),(0,ze.Map)({})),getComponent:x,getConfigs:C,omitValue:!0}):null,ee?Re.createElement(ce,{headers:ee,getComponent:x}):null),z?Re.createElement("td",{className:"response-col_links"},ie?ie.toSeq().entrySeq().map((([s,o])=>Re.createElement(fe,{key:s,name:s,link:o,getComponent:x}))):Re.createElement("i",null,"No links")):null)}}const response_extension=({xKey:s,xVal:o})=>Re.createElement("div",{className:"response__extension"},s,": ",String(o));var qO=__webpack_require__(26657),UO=__webpack_require__.n(qO),VO=__webpack_require__(80218),zO=__webpack_require__.n(VO);class ResponseBody extends Re.PureComponent{state={parsedContent:null};updateParsedContent=s=>{const{content:o}=this.props;if(s!==o)if(o&&o instanceof Blob){var i=new FileReader;i.onload=()=>{this.setState({parsedContent:i.result})},i.readAsText(o)}else this.setState({parsedContent:o.toString()})};componentDidMount(){this.updateParsedContent(null)}componentDidUpdate(s){this.updateParsedContent(s.content)}render(){let{content:s,contentType:o,url:i,headers:a={},getComponent:u}=this.props;const{parsedContent:_}=this.state,w=u("HighlightCode",!0),x="response_"+(new Date).getTime();let C,j;if(i=i||"",(/^application\/octet-stream/i.test(o)||a["Content-Disposition"]&&/attachment/i.test(a["Content-Disposition"])||a["content-disposition"]&&/attachment/i.test(a["content-disposition"])||a["Content-Description"]&&/File Transfer/i.test(a["Content-Description"])||a["content-description"]&&/File Transfer/i.test(a["content-description"]))&&(s.size>0||s.length>0))if("Blob"in window){let u=o||"text/html",_=s instanceof Blob?s:new Blob([s],{type:u}),w=window.URL.createObjectURL(_),x=[u,i.substr(i.lastIndexOf("/")+1),w].join(":"),C=a["content-disposition"]||a["Content-Disposition"];if(void 0!==C){let s=function extractFileNameFromContentDispositionHeader(s){let o;if([/filename\*=[^']+'\w*'"([^"]+)";?/i,/filename\*=[^']+'\w*'([^;]+);?/i,/filename="([^;]*);?"/i,/filename=([^;]*);?/i].some((i=>(o=i.exec(s),null!==o))),null!==o&&o.length>1)try{return decodeURIComponent(o[1])}catch(s){console.error(s)}return null}(C);null!==s&&(x=s)}j=lt.navigator&&lt.navigator.msSaveOrOpenBlob?Re.createElement("div",null,Re.createElement("a",{href:w,onClick:()=>lt.navigator.msSaveOrOpenBlob(_,x)},"Download file")):Re.createElement("div",null,Re.createElement("a",{href:w,download:x},"Download file"))}else j=Re.createElement("pre",{className:"microlight"},"Download headers detected but your browser does not support downloading binary via XHR (Blob).");else if(/json/i.test(o)){let o=null;getKnownSyntaxHighlighterLanguage(s)&&(o="json");try{C=JSON.stringify(JSON.parse(s),null,"  ")}catch(o){C="can't parse JSON.  Raw result:\n\n"+s}j=Re.createElement(w,{language:o,downloadable:!0,fileName:`${x}.json`,canCopy:!0},C)}else/xml/i.test(o)?(C=UO()(s,{textNodesOnSameLine:!0,indentor:"  "}),j=Re.createElement(w,{downloadable:!0,fileName:`${x}.xml`,canCopy:!0},C)):j="text/html"===zO()(o)||/text\/plain/.test(o)?Re.createElement(w,{downloadable:!0,fileName:`${x}.html`,canCopy:!0},s):"text/csv"===zO()(o)||/text\/csv/.test(o)?Re.createElement(w,{downloadable:!0,fileName:`${x}.csv`,canCopy:!0},s):/^image\//i.test(o)?o.includes("svg")?Re.createElement("div",null," ",s," "):Re.createElement("img",{src:window.URL.createObjectURL(s)}):/^audio\//i.test(o)?Re.createElement("pre",{className:"microlight"},Re.createElement("audio",{controls:!0,key:i},Re.createElement("source",{src:i,type:o}))):"string"==typeof s?Re.createElement(w,{downloadable:!0,fileName:`${x}.txt`,canCopy:!0},s):s.size>0?_?Re.createElement("div",null,Re.createElement("p",{className:"i"},"Unrecognized response type; displaying content as text."),Re.createElement(w,{downloadable:!0,fileName:`${x}.txt`,canCopy:!0},_)):Re.createElement("p",{className:"i"},"Unrecognized response type; unable to display."):null;return j?Re.createElement("div",null,Re.createElement("h5",null,"Response body"),j):null}}class Parameters extends Re.Component{constructor(s){super(s),this.state={callbackVisible:!1,parametersVisible:!0}}static defaultProps={onTryoutClick:Function.prototype,onCancelClick:Function.prototype,tryItOutEnabled:!1,allowTryItOut:!0,onChangeKey:[],specPath:[]};onChange=(s,o,i)=>{let{specActions:{changeParamByIdentity:a},onChangeKey:u}=this.props;a(u,s,o,i)};onChangeConsumesWrapper=s=>{let{specActions:{changeConsumesValue:o},onChangeKey:i}=this.props;o(i,s)};toggleTab=s=>"parameters"===s?this.setState({parametersVisible:!0,callbackVisible:!1}):"callbacks"===s?this.setState({callbackVisible:!0,parametersVisible:!1}):void 0;onChangeMediaType=({value:s,pathMethod:o})=>{let{specActions:i,oas3Selectors:a,oas3Actions:u}=this.props;const _=a.hasUserEditedBody(...o),w=a.shouldRetainRequestBodyValue(...o);u.setRequestContentType({value:s,pathMethod:o}),u.initRequestBodyValidateError({pathMethod:o}),_||(w||u.setRequestBodyValue({value:void 0,pathMethod:o}),i.clearResponse(...o),i.clearRequest(...o),i.clearValidateParams(o))};render(){let{onTryoutClick:s,onResetClick:o,parameters:i,allowTryItOut:a,tryItOutEnabled:u,specPath:_,fn:w,getComponent:x,getConfigs:C,specSelectors:j,specActions:L,pathMethod:B,oas3Actions:$,oas3Selectors:U,operation:V}=this.props;const z=x("parameterRow"),Y=x("TryItOutButton"),Z=x("contentType"),ee=x("Callbacks",!0),ie=x("RequestBody",!0),ae=u&&a,ce=j.isOAS3(),le=`${createHtmlReadyId(`${B[1]}${B[0]}_requests`)}_select`,pe=V.get("requestBody"),de=Object.values(i.reduce(((s,o)=>{if(ze.Map.isMap(o)){const i=o.get("in");s[i]??=[],s[i].push(o)}return s}),{})).reduce(((s,o)=>s.concat(o)),[]);return Re.createElement("div",{className:"opblock-section"},Re.createElement("div",{className:"opblock-section-header"},ce?Re.createElement("div",{className:"tab-header"},Re.createElement("div",{onClick:()=>this.toggleTab("parameters"),className:`tab-item ${this.state.parametersVisible&&"active"}`},Re.createElement("h4",{className:"opblock-title"},Re.createElement("span",null,"Parameters"))),V.get("callbacks")?Re.createElement("div",{onClick:()=>this.toggleTab("callbacks"),className:`tab-item ${this.state.callbackVisible&&"active"}`},Re.createElement("h4",{className:"opblock-title"},Re.createElement("span",null,"Callbacks"))):null):Re.createElement("div",{className:"tab-header"},Re.createElement("h4",{className:"opblock-title"},"Parameters")),a?Re.createElement(Y,{isOAS3:j.isOAS3(),hasUserEditedBody:U.hasUserEditedBody(...B),enabled:u,onCancelClick:this.props.onCancelClick,onTryoutClick:s,onResetClick:()=>o(B)}):null),this.state.parametersVisible?Re.createElement("div",{className:"parameters-container"},de.length?Re.createElement("div",{className:"table-container"},Re.createElement("table",{className:"parameters"},Re.createElement("thead",null,Re.createElement("tr",null,Re.createElement("th",{className:"col_header parameters-col_name"},"Name"),Re.createElement("th",{className:"col_header parameters-col_description"},"Description"))),Re.createElement("tbody",null,de.map(((s,o)=>Re.createElement(z,{fn:w,specPath:_.push(o.toString()),getComponent:x,getConfigs:C,rawParam:s,param:j.parameterWithMetaByIdentity(B,s),key:`${s.get("in")}.${s.get("name")}`,onChange:this.onChange,onChangeConsumes:this.onChangeConsumesWrapper,specSelectors:j,specActions:L,oas3Actions:$,oas3Selectors:U,pathMethod:B,isExecute:ae})))))):Re.createElement("div",{className:"opblock-description-wrapper"},Re.createElement("p",null,"No parameters"))):null,this.state.callbackVisible?Re.createElement("div",{className:"callbacks-container opblock-description-wrapper"},Re.createElement(ee,{callbacks:(0,ze.Map)(V.get("callbacks")),specPath:_.slice(0,-1).push("callbacks")})):null,ce&&pe&&this.state.parametersVisible&&Re.createElement("div",{className:"opblock-section opblock-section-request-body"},Re.createElement("div",{className:"opblock-section-header"},Re.createElement("h4",{className:`opblock-title parameter__name ${pe.get("required")&&"required"}`},"Request body"),Re.createElement("label",{id:le},Re.createElement(Z,{value:U.requestContentType(...B),contentTypes:pe.get("content",(0,ze.List)()).keySeq(),onChange:s=>{this.onChangeMediaType({value:s,pathMethod:B})},className:"body-param-content-type",ariaLabel:"Request content type",controlId:le}))),Re.createElement("div",{className:"opblock-description-wrapper"},Re.createElement(ie,{setRetainRequestBodyValueFlag:s=>$.setRetainRequestBodyValueFlag({value:s,pathMethod:B}),userHasEditedBody:U.hasUserEditedBody(...B),specPath:_.slice(0,-1).push("requestBody"),requestBody:pe,requestBodyValue:U.requestBodyValue(...B),requestBodyInclusionSetting:U.requestBodyInclusionSetting(...B),requestBodyErrors:U.requestBodyErrors(...B),isExecute:ae,getConfigs:C,activeExamplesKey:U.activeExamplesMember(...B,"requestBody","requestBody"),updateActiveExamplesKey:s=>{this.props.oas3Actions.setActiveExamplesMember({name:s,pathMethod:this.props.pathMethod,contextType:"requestBody",contextName:"requestBody"})},onChange:(s,o)=>{if(o){const i=U.requestBodyValue(...B),a=ze.Map.isMap(i)?i:(0,ze.Map)();return $.setRequestBodyValue({pathMethod:B,value:a.setIn(o,s)})}$.setRequestBodyValue({value:s,pathMethod:B})},onChangeIncludeEmpty:(s,o)=>{$.setRequestBodyInclusion({pathMethod:B,value:o,name:s})},contentType:U.requestContentType(...B)}))))}}const parameter_extension=({xKey:s,xVal:o})=>Re.createElement("div",{className:"parameter__extension"},s,": ",String(o)),WO={onChange:()=>{},isIncludedOptions:{}};class ParameterIncludeEmpty extends Re.Component{static defaultProps=WO;componentDidMount(){const{isIncludedOptions:s,onChange:o}=this.props,{shouldDispatchInit:i,defaultValue:a}=s;i&&o(a)}onCheckboxChange=s=>{const{onChange:o}=this.props;o(s.target.checked)};render(){let{isIncluded:s,isDisabled:o}=this.props;return Re.createElement("div",null,Re.createElement("label",{htmlFor:"include_empty_value",className:Jn()("parameter__empty_value_toggle",{disabled:o})},Re.createElement("input",{id:"include_empty_value",type:"checkbox",disabled:o,checked:!o&&s,onChange:this.onCheckboxChange}),"Send empty value"))}}class ParameterRow extends Re.Component{constructor(s,o){super(s,o),this.setDefaultValue()}UNSAFE_componentWillReceiveProps(s){let o,{specSelectors:i,pathMethod:a,rawParam:u}=s,_=i.isOAS3(),w=i.parameterWithMetaByIdentity(a,u)||new ze.Map;if(w=w.isEmpty()?u:w,_){let{schema:s}=getParameterSchema(w,{isOAS3:_});o=s?s.get("enum"):void 0}else o=w?w.get("enum"):void 0;let x,C=w?w.get("value"):void 0;void 0!==C?x=C:u.get("required")&&o&&o.size&&(x=o.first()),void 0!==x&&x!==C&&this.onChangeWrapper(function numberToString(s){return"number"==typeof s?s.toString():s}(x)),this.setDefaultValue()}onChangeWrapper=(s,o=!1)=>{let i,{onChange:a,rawParam:u}=this.props;return i=""===s||s&&0===s.size?null:s,a(u,i,o)};_onExampleSelect=s=>{this.props.oas3Actions.setActiveExamplesMember({name:s,pathMethod:this.props.pathMethod,contextType:"parameters",contextName:this.getParamKey()})};onChangeIncludeEmpty=s=>{let{specActions:o,param:i,pathMethod:a}=this.props;const u=i.get("name"),_=i.get("in");return o.updateEmptyParamInclusion(a,u,_,s)};setDefaultValue=()=>{let{specSelectors:s,pathMethod:o,rawParam:i,oas3Selectors:a,fn:u}=this.props;const _=s.parameterWithMetaByIdentity(o,i)||(0,ze.Map)();let{schema:w}=getParameterSchema(_,{isOAS3:s.isOAS3()});const x=_.get("content",(0,ze.Map)()).keySeq().first(),C=w?u.getSampleSchema(w.toJS(),x,{includeWriteOnly:!0}):null;if(_&&void 0===_.get("value")&&"body"!==_.get("in")){let i;if(s.isSwagger2())i=void 0!==_.get("x-example")?_.get("x-example"):void 0!==_.getIn(["schema","example"])?_.getIn(["schema","example"]):w&&w.getIn(["default"]);else if(s.isOAS3()){w=this.composeJsonSchema(w);const s=a.activeExamplesMember(...o,"parameters",this.getParamKey());i=void 0!==_.getIn(["examples",s,"value"])?_.getIn(["examples",s,"value"]):void 0!==_.getIn(["content",x,"example"])?_.getIn(["content",x,"example"]):void 0!==_.get("example")?_.get("example"):void 0!==(w&&w.get("example"))?w&&w.get("example"):void 0!==(w&&w.get("default"))?w&&w.get("default"):_.get("default")}void 0===i||ze.List.isList(i)||(i=stringify(i));const j=u.getSchemaObjectType(w),L=u.getSchemaObjectType(w?.get("items"));void 0!==i?this.onChangeWrapper(i):"object"===j&&C&&!_.get("examples")?this.onChangeWrapper(ze.List.isList(C)?C:stringify(C)):"array"===j&&"object"===L&&C&&!_.get("examples")&&this.onChangeWrapper(ze.List.isList(C)?C:(0,ze.List)(JSON.parse(C)))}};getParamKey(){const{param:s}=this.props;return s?`${s.get("name")}-${s.get("in")}`:null}composeJsonSchema(s){const{fn:o}=this.props,i=s.get("oneOf")?.get(0)?.toJS(),a=s.get("anyOf")?.get(0)?.toJS();return(0,ze.fromJS)(o.mergeJsonSchema(s.toJS(),i??a??{}))}render(){let{param:s,rawParam:o,getComponent:i,getConfigs:a,isExecute:u,fn:_,onChangeConsumes:w,specSelectors:x,pathMethod:C,specPath:j,oas3Selectors:L}=this.props,B=x.isOAS3();const{showExtensions:$,showCommonExtensions:U}=a();if(s||(s=o),!o)return null;const V=i("JsonSchemaForm"),z=i("ParamBody");let Y=s.get("in"),Z="body"!==Y?null:Re.createElement(z,{getComponent:i,getConfigs:a,fn:_,param:s,consumes:x.consumesOptionsFor(C),consumesValue:x.contentTypeValues(C).get("requestContentType"),onChange:this.onChangeWrapper,onChangeConsumes:w,isExecute:u,specSelectors:x,pathMethod:C});const ee=i("modelExample"),ie=i("Markdown",!0),ae=i("ParameterExt"),ce=i("ParameterIncludeEmpty"),le=i("ExamplesSelectValueRetainer"),pe=i("Example");let{schema:de}=getParameterSchema(s,{isOAS3:B}),fe=x.parameterWithMetaByIdentity(C,o)||(0,ze.Map)();const ye=fe.get("content",(0,ze.Map)()).keySeq().first();B&&(de=this.composeJsonSchema(de));let be=de?de.get("format"):null,Se="formData"===Y,_e="FormData"in lt,we=s.get("required");const xe=_.getSchemaObjectType(de),Pe=_.getSchemaObjectType(de?.get("items")),Te=_.getSchemaObjectTypeLabel(de),$e=!Z&&"object"===xe,qe=!Z&&"object"===Pe;let We,He,Ye,Xe,Qe=fe?fe.get("value"):"",et=U?getCommonExtensions(de):null,tt=$?getExtensions(s):null,rt=!1;void 0!==s&&de&&(We=de.get("items")),void 0!==We?(He=We.get("enum"),Ye=We.get("default")):de&&(He=de.get("enum")),He&&He.size&&He.size>0&&(rt=!0),void 0!==s&&(de&&(Ye=de.get("default")),void 0===Ye&&(Ye=s.get("default")),Xe=s.get("example"),void 0===Xe&&(Xe=s.get("x-example")));const nt=Z?null:Re.createElement(V,{fn:_,getComponent:i,value:Qe,required:we,disabled:!u,description:s.get("name"),onChange:this.onChangeWrapper,errors:fe.get("errors"),schema:de});return Re.createElement("tr",{"data-param-name":s.get("name"),"data-param-in":s.get("in")},Re.createElement("td",{className:"parameters-col_name"},Re.createElement("div",{className:we?"parameter__name required":"parameter__name"},s.get("name"),we?Re.createElement("span",null," *"):null),Re.createElement("div",{className:"parameter__type"},Te,be&&Re.createElement("span",{className:"prop-format"},"($",be,")")),Re.createElement("div",{className:"parameter__deprecated"},B&&s.get("deprecated")?"deprecated":null),Re.createElement("div",{className:"parameter__in"},"(",s.get("in"),")")),Re.createElement("td",{className:"parameters-col_description"},s.get("description")?Re.createElement(ie,{source:s.get("description")}):null,!Z&&u||!rt?null:Re.createElement(ie,{className:"parameter__enum",source:"<i>Available values</i> : "+He.map((function(s){return s})).toArray().map(String).join(", ")}),!Z&&u||void 0===Ye?null:Re.createElement(ie,{className:"parameter__default",source:"<i>Default value</i> : "+Ye}),!Z&&u||void 0===Xe?null:Re.createElement(ie,{source:"<i>Example</i> : "+Xe}),Se&&!_e&&Re.createElement("div",null,"Error: your browser does not support FormData"),B&&s.get("examples")?Re.createElement("section",{className:"parameter-controls"},Re.createElement(le,{examples:s.get("examples"),onSelect:this._onExampleSelect,updateValue:this.onChangeWrapper,getComponent:i,defaultToFirstExample:!0,currentKey:L.activeExamplesMember(...C,"parameters",this.getParamKey()),currentUserInputValue:Qe})):null,$e||qe?Re.createElement(ee,{getComponent:i,specPath:ye?j.push("content",ye,"schema"):j.push("schema"),getConfigs:a,isExecute:u,specSelectors:x,schema:de,example:nt}):nt,Z&&de?Re.createElement(ee,{getComponent:i,specPath:j.push("schema"),getConfigs:a,isExecute:u,specSelectors:x,schema:de,example:Z,includeWriteOnly:!0}):null,!Z&&u&&s.get("allowEmptyValue")?Re.createElement(ce,{onChange:this.onChangeIncludeEmpty,isIncluded:x.parameterInclusionSettingFor(C,s.get("name"),s.get("in")),isDisabled:!isEmptyValue(Qe)}):null,B&&s.get("examples")?Re.createElement(pe,{example:s.getIn(["examples",L.activeExamplesMember(...C,"parameters",this.getParamKey())]),getComponent:i,getConfigs:a}):null,U&&et.size?et.entrySeq().map((([s,o])=>Re.createElement(ae,{key:`${s}-${o}`,xKey:s,xVal:o}))):null,$&&tt.size?tt.entrySeq().map((([s,o])=>Re.createElement(ae,{key:`${s}-${o}`,xKey:s,xVal:o}))):null))}}class Execute extends Re.Component{handleValidateParameters=()=>{let{specSelectors:s,specActions:o,path:i,method:a}=this.props;return o.validateParams([i,a]),s.validateBeforeExecute([i,a])};handleValidateRequestBody=()=>{let{path:s,method:o,specSelectors:i,oas3Selectors:a,oas3Actions:u}=this.props,_={missingBodyValue:!1,missingRequiredKeys:[]};u.clearRequestBodyValidateError({path:s,method:o});let w=i.getOAS3RequiredRequestBodyContentType([s,o]),x=a.requestBodyValue(s,o),C=a.validateBeforeExecute([s,o]),j=a.requestContentType(s,o);if(!C)return _.missingBodyValue=!0,u.setRequestBodyValidateError({path:s,method:o,validationErrors:_}),!1;if(!w)return!0;let L=a.validateShallowRequired({oas3RequiredRequestBodyContentType:w,oas3RequestContentType:j,oas3RequestBodyValue:x});return!L||L.length<1||(L.forEach((s=>{_.missingRequiredKeys.push(s)})),u.setRequestBodyValidateError({path:s,method:o,validationErrors:_}),!1)};handleValidationResultPass=()=>{let{specActions:s,operation:o,path:i,method:a}=this.props;this.props.onExecute&&this.props.onExecute(),s.execute({operation:o,path:i,method:a})};handleValidationResultFail=()=>{let{specActions:s,path:o,method:i}=this.props;s.clearValidateParams([o,i]),setTimeout((()=>{s.validateParams([o,i])}),40)};handleValidationResult=s=>{s?this.handleValidationResultPass():this.handleValidationResultFail()};onClick=()=>{let s=this.handleValidateParameters(),o=this.handleValidateRequestBody(),i=s&&o;this.handleValidationResult(i)};onChangeProducesWrapper=s=>this.props.specActions.changeProducesValue([this.props.path,this.props.method],s);render(){const{disabled:s}=this.props;return Re.createElement("button",{className:"btn execute opblock-control__btn",onClick:this.onClick,disabled:s},"Execute")}}class headers_Headers extends Re.Component{render(){let{headers:s,getComponent:o}=this.props;const i=o("Property"),a=o("Markdown",!0);return s&&s.size?Re.createElement("div",{className:"headers-wrapper"},Re.createElement("h4",{className:"headers__title"},"Headers:"),Re.createElement("table",{className:"headers"},Re.createElement("thead",null,Re.createElement("tr",{className:"header-row"},Re.createElement("th",{className:"header-col"},"Name"),Re.createElement("th",{className:"header-col"},"Description"),Re.createElement("th",{className:"header-col"},"Type"))),Re.createElement("tbody",null,s.entrySeq().map((([s,o])=>{if(!We().Map.isMap(o))return null;const u=o.get("description"),_=o.getIn(["schema"])?o.getIn(["schema","type"]):o.getIn(["type"]),w=o.getIn(["schema","example"]);return Re.createElement("tr",{key:s},Re.createElement("td",{className:"header-col"},s),Re.createElement("td",{className:"header-col"},u?Re.createElement(a,{source:u}):null),Re.createElement("td",{className:"header-col"},_," ",w?Re.createElement(i,{propKey:"Example",propVal:w,propClass:"header-example"}):null))})).toArray()))):null}}class Errors extends Re.Component{render(){let{editorActions:s,errSelectors:o,layoutSelectors:i,layoutActions:a,getComponent:u}=this.props;const _=u("Collapse");if(s&&s.jumpToLine)var w=s.jumpToLine;let x=o.allErrors().filter((s=>"thrown"===s.get("type")||"error"===s.get("level")));if(!x||x.count()<1)return null;let C=i.isShown(["errorPane"],!0),j=x.sortBy((s=>s.get("line")));return Re.createElement("pre",{className:"errors-wrapper"},Re.createElement("hgroup",{className:"error"},Re.createElement("h4",{className:"errors__title"},"Errors"),Re.createElement("button",{className:"btn errors__clear-btn",onClick:()=>a.show(["errorPane"],!C)},C?"Hide":"Show")),Re.createElement(_,{isOpened:C,animated:!0},Re.createElement("div",{className:"errors"},j.map(((s,o)=>{let i=s.get("type");return"thrown"===i||"auth"===i?Re.createElement(ThrownErrorItem,{key:o,error:s.get("error")||s,jumpToLine:w}):"spec"===i?Re.createElement(SpecErrorItem,{key:o,error:s,jumpToLine:w}):void 0})))))}}const ThrownErrorItem=({error:s,jumpToLine:o})=>{if(!s)return null;let i=s.get("line");return Re.createElement("div",{className:"error-wrapper"},s?Re.createElement("div",null,Re.createElement("h4",null,s.get("source")&&s.get("level")?toTitleCase(s.get("source"))+" "+s.get("level"):"",s.get("path")?Re.createElement("small",null," at ",s.get("path")):null),Re.createElement("span",{className:"message thrown"},s.get("message")),Re.createElement("div",{className:"error-line"},i&&o?Re.createElement("a",{onClick:o.bind(null,i)},"Jump to line ",i):null)):null)},SpecErrorItem=({error:s,jumpToLine:o=null})=>{let i=null;return s.get("path")?i=ze.List.isList(s.get("path"))?Re.createElement("small",null,"at ",s.get("path").join(".")):Re.createElement("small",null,"at ",s.get("path")):s.get("line")&&!o&&(i=Re.createElement("small",null,"on line ",s.get("line"))),Re.createElement("div",{className:"error-wrapper"},s?Re.createElement("div",null,Re.createElement("h4",null,toTitleCase(s.get("source"))+" "+s.get("level")," ",i),Re.createElement("span",{className:"message"},s.get("message")),Re.createElement("div",{className:"error-line"},o?Re.createElement("a",{onClick:o.bind(null,s.get("line"))},"Jump to line ",s.get("line")):null)):null)};function toTitleCase(s){return(s||"").split(" ").map((s=>s[0].toUpperCase()+s.slice(1))).join(" ")}const content_type_noop=()=>{};class ContentType extends Re.Component{static defaultProps={onChange:content_type_noop,value:null,contentTypes:(0,ze.fromJS)(["application/json"])};componentDidMount(){const{contentTypes:s,onChange:o}=this.props;s&&s.size&&o(s.first())}componentDidUpdate(){const{contentTypes:s,value:o,onChange:i}=this.props;s&&s.size&&(s.includes(o)||i(s.first()))}onChangeWrapper=s=>this.props.onChange(s.target.value);render(){let{ariaControls:s,ariaLabel:o,className:i,contentTypes:a,controlId:u,value:_}=this.props;return a&&a.size?Re.createElement("div",{className:"content-type-wrapper "+(i||"")},Re.createElement("select",{"aria-controls":s,"aria-label":o,className:"content-type",id:u,onChange:this.onChangeWrapper,value:_||""},a.map((s=>Re.createElement("option",{key:s,value:s},s))).toArray())):null}}function xclass(...s){return s.filter((s=>!!s)).join(" ").trim()}class Container extends Re.Component{render(){let{fullscreen:s,full:o,...i}=this.props;if(s)return Re.createElement("section",i);let a="swagger-container"+(o?"-full":"");return Re.createElement("section",Mn()({},i,{className:xclass(i.className,a)}))}}const JO={mobile:"",tablet:"-tablet",desktop:"-desktop",large:"-hd"};class Col extends Re.Component{render(){const{hide:s,keepContents:o,mobile:i,tablet:a,desktop:u,large:_,...w}=this.props;if(s&&!o)return Re.createElement("span",null);let x=[];for(let s in JO){if(!Object.prototype.hasOwnProperty.call(JO,s))continue;let o=JO[s];if(s in this.props){let i=this.props[s];if(i<1){x.push("none"+o);continue}x.push("block"+o),x.push("col-"+i+o)}}s&&x.push("hidden");let C=xclass(w.className,...x);return Re.createElement("section",Mn()({},w,{className:C}))}}class Row extends Re.Component{render(){return Re.createElement("div",Mn()({},this.props,{className:xclass(this.props.className,"wrapper")}))}}class Button extends Re.Component{static defaultProps={className:""};render(){return Re.createElement("button",Mn()({},this.props,{className:xclass(this.props.className,"button")}))}}const TextArea=s=>Re.createElement("textarea",s),Input=s=>Re.createElement("input",s);class Select extends Re.Component{static defaultProps={multiple:!1,allowEmptyValue:!0};constructor(s,o){let i;super(s,o),i=s.value?s.value:s.multiple?[""]:"",this.state={value:i}}onChange=s=>{let o,{onChange:i,multiple:a}=this.props,u=[].slice.call(s.target.options);o=a?u.filter((function(s){return s.selected})).map((function(s){return s.value})):s.target.value,this.setState({value:o}),i&&i(o)};UNSAFE_componentWillReceiveProps(s){s.value!==this.props.value&&this.setState({value:s.value})}render(){let{allowedValues:s,multiple:o,allowEmptyValue:i,disabled:a}=this.props,u=this.state.value?.toJS?.()||this.state.value;return Re.createElement("select",{className:this.props.className,multiple:o,value:u,onChange:this.onChange,disabled:a},i?Re.createElement("option",{value:""},"--"):null,s.map((function(s,o){return Re.createElement("option",{key:o,value:String(s)},String(s))})))}}class layout_utils_Link extends Re.Component{render(){return Re.createElement("a",Mn()({},this.props,{rel:"noopener noreferrer",className:xclass(this.props.className,"link")}))}}const NoMargin=({children:s})=>Re.createElement("div",{className:"no-margin"}," ",s," ");class Collapse extends Re.Component{static defaultProps={isOpened:!1,animated:!1};renderNotAnimated(){return this.props.isOpened?Re.createElement(NoMargin,null,this.props.children):Re.createElement("noscript",null)}render(){let{animated:s,isOpened:o,children:i}=this.props;return s?(i=o?i:null,Re.createElement(NoMargin,null,i)):this.renderNotAnimated()}}class Overview extends Re.Component{constructor(...s){super(...s),this.setTagShown=this._setTagShown.bind(this)}_setTagShown(s,o){this.props.layoutActions.show(s,o)}showOp(s,o){let{layoutActions:i}=this.props;i.show(s,o)}render(){let{specSelectors:s,layoutSelectors:o,layoutActions:i,getComponent:a}=this.props,u=s.taggedOperations();const _=a("Collapse");return Re.createElement("div",null,Re.createElement("h4",{className:"overview-title"},"Overview"),u.map(((s,a)=>{let u=s.get("operations"),w=["overview-tags",a],x=o.isShown(w,!0);return Re.createElement("div",{key:"overview-"+a},Re.createElement("h4",{onClick:()=>i.show(w,!x),className:"link overview-tag"}," ",x?"-":"+",a),Re.createElement(_,{isOpened:x,animated:!0},u.map((s=>{let{path:a,method:u,id:_}=s.toObject(),w="operations",x=_,C=o.isShown([w,x]);return Re.createElement(OperationLink,{key:_,path:a,method:u,id:a+"-"+u,shown:C,showOpId:x,showOpIdPrefix:w,href:`#operation-${x}`,onClick:i.show})})).toArray()))})).toArray(),u.size<1&&Re.createElement("h3",null," No operations defined in spec! "))}}class OperationLink extends Re.Component{constructor(s){super(s),this.onClick=this._onClick.bind(this)}_onClick(){let{showOpId:s,showOpIdPrefix:o,onClick:i,shown:a}=this.props;i([o,s],!a)}render(){let{id:s,method:o,shown:i,href:a}=this.props;return Re.createElement(layout_utils_Link,{href:a,onClick:this.onClick,className:"block opblock-link "+(i?"shown":"")},Re.createElement("div",null,Re.createElement("small",{className:`bold-label-${o}`},o.toUpperCase()),Re.createElement("span",{className:"bold-label"},s)))}}class InitializedInput extends Re.Component{componentDidMount(){this.props.initialValue&&(this.inputRef.value=this.props.initialValue)}render(){const{value:s,defaultValue:o,initialValue:i,...a}=this.props;return Re.createElement("input",Mn()({},a,{ref:s=>this.inputRef=s}))}}class InfoBasePath extends Re.Component{render(){const{host:s,basePath:o}=this.props;return Re.createElement("pre",{className:"base-url"},"[ Base URL: ",s,o," ]")}}class InfoUrl extends Re.PureComponent{render(){const{url:s,getComponent:o}=this.props,i=o("Link");return Re.createElement(i,{target:"_blank",href:sanitizeUrl(s)},Re.createElement("span",{className:"url"}," ",s))}}class info_Info extends Re.Component{render(){const{info:s,url:o,host:i,basePath:a,getComponent:u,externalDocs:_,selectedServer:w,url:x}=this.props,C=s.get("version"),j=s.get("description"),L=s.get("title"),B=safeBuildUrl(s.get("termsOfService"),x,{selectedServer:w}),$=s.get("contact"),U=s.get("license"),V=safeBuildUrl(_&&_.get("url"),x,{selectedServer:w}),z=_&&_.get("description"),Y=u("Markdown",!0),Z=u("Link"),ee=u("VersionStamp"),ie=u("OpenAPIVersion"),ae=u("InfoUrl"),ce=u("InfoBasePath"),le=u("License"),pe=u("Contact");return Re.createElement("div",{className:"info"},Re.createElement("hgroup",{className:"main"},Re.createElement("h1",{className:"title"},L,Re.createElement("span",null,C&&Re.createElement(ee,{version:C}),Re.createElement(ie,{oasVersion:"2.0"}))),i||a?Re.createElement(ce,{host:i,basePath:a}):null,o&&Re.createElement(ae,{getComponent:u,url:o})),Re.createElement("div",{className:"description"},Re.createElement(Y,{source:j})),B&&Re.createElement("div",{className:"info__tos"},Re.createElement(Z,{target:"_blank",href:sanitizeUrl(B)},"Terms of service")),$?.size>0&&Re.createElement(pe,{getComponent:u,data:$,selectedServer:w,url:o}),U?.size>0&&Re.createElement(le,{getComponent:u,license:U,selectedServer:w,url:o}),V?Re.createElement(Z,{className:"info__extdocs",target:"_blank",href:sanitizeUrl(V)},z||V):null)}}const HO=info_Info;class InfoContainer extends Re.Component{render(){const{specSelectors:s,getComponent:o,oas3Selectors:i}=this.props,a=s.info(),u=s.url(),_=s.basePath(),w=s.host(),x=s.externalDocs(),C=i.selectedServer(),j=o("info");return Re.createElement("div",null,a&&a.count()?Re.createElement(j,{info:a,url:u,host:w,basePath:_,externalDocs:x,getComponent:o,selectedServer:C}):null)}}class contact_Contact extends Re.Component{render(){const{data:s,getComponent:o,selectedServer:i,url:a}=this.props,u=s.get("name","the developer"),_=safeBuildUrl(s.get("url"),a,{selectedServer:i}),w=s.get("email"),x=o("Link");return Re.createElement("div",{className:"info__contact"},_&&Re.createElement("div",null,Re.createElement(x,{href:sanitizeUrl(_),target:"_blank"},u," - Website")),w&&Re.createElement(x,{href:sanitizeUrl(`mailto:${w}`)},_?`Send email to ${u}`:`Contact ${u}`))}}const KO=contact_Contact;class license_License extends Re.Component{render(){const{license:s,getComponent:o,selectedServer:i,url:a}=this.props,u=s.get("name","License"),_=safeBuildUrl(s.get("url"),a,{selectedServer:i}),w=o("Link");return Re.createElement("div",{className:"info__license"},_?Re.createElement("div",{className:"info__license__url"},Re.createElement(w,{target:"_blank",href:sanitizeUrl(_)},u)):Re.createElement("span",null,u))}}const GO=license_License;class JumpToPath extends Re.Component{render(){return null}}class CopyToClipboardBtn extends Re.Component{render(){let{getComponent:s}=this.props;const o=s("CopyIcon");return Re.createElement("div",{className:"view-line-link copy-to-clipboard",title:"Copy to clipboard"},Re.createElement(Hn.CopyToClipboard,{text:this.props.textToCopy},Re.createElement(o,null)))}}class Footer extends Re.Component{render(){return Re.createElement("div",{className:"footer"})}}class FilterContainer extends Re.Component{onFilterChange=s=>{const{target:{value:o}}=s;this.props.layoutActions.updateFilter(o)};render(){const{specSelectors:s,layoutSelectors:o,getComponent:i}=this.props,a=i("Col"),u="loading"===s.loadingStatus(),_="failed"===s.loadingStatus(),w=o.currentFilter(),x=["operation-filter-input"];return _&&x.push("failed"),u&&x.push("loading"),Re.createElement("div",null,!1===w?null:Re.createElement("div",{className:"filter-container"},Re.createElement(a,{className:"filter wrapper",mobile:12},Re.createElement("input",{className:x.join(" "),placeholder:"Filter by tag",type:"text",onChange:this.onFilterChange,value:"string"==typeof w?w:"",disabled:u}))))}}const YO=Function.prototype;class ParamBody extends Re.PureComponent{static defaultProp={consumes:(0,ze.fromJS)(["application/json"]),param:(0,ze.fromJS)({}),onChange:YO,onChangeConsumes:YO};constructor(s,o){super(s,o),this.state={isEditBox:!1,value:""}}componentDidMount(){this.updateValues.call(this,this.props)}UNSAFE_componentWillReceiveProps(s){this.updateValues.call(this,s)}updateValues=s=>{let{param:o,isExecute:i,consumesValue:a=""}=s,u=/xml/i.test(a),_=/json/i.test(a),w=u?o.get("value_xml"):o.get("value");if(void 0!==w){let s=!w&&_?"{}":w;this.setState({value:s}),this.onChange(s,{isXml:u,isEditBox:i})}else u?this.onChange(this.sample("xml"),{isXml:u,isEditBox:i}):this.onChange(this.sample(),{isEditBox:i})};sample=s=>{let{param:o,fn:i}=this.props,a=i.inferSchema(o.toJS());return i.getSampleSchema(a,s,{includeWriteOnly:!0})};onChange=(s,{isEditBox:o,isXml:i})=>{this.setState({value:s,isEditBox:o}),this._onChange(s,i)};_onChange=(s,o)=>{(this.props.onChange||YO)(s,o)};handleOnChange=s=>{const{consumesValue:o}=this.props,i=/xml/i.test(o),a=s.target.value;this.onChange(a,{isXml:i,isEditBox:this.state.isEditBox})};toggleIsEditBox=()=>this.setState((s=>({isEditBox:!s.isEditBox})));render(){let{onChangeConsumes:s,param:o,isExecute:i,specSelectors:a,pathMethod:u,getComponent:_}=this.props;const w=_("Button"),x=_("TextArea"),C=_("HighlightCode",!0),j=_("contentType");let L=(a?a.parameterWithMetaByIdentity(u,o):o).get("errors",(0,ze.List)()),B=a.contentTypeValues(u).get("requestContentType"),$=this.props.consumes&&this.props.consumes.size?this.props.consumes:ParamBody.defaultProp.consumes,{value:U,isEditBox:V}=this.state,z=null;getKnownSyntaxHighlighterLanguage(U)&&(z="json");const Y=`${createHtmlReadyId(`${u[1]}${u[0]}_parameters`)}_select`;return Re.createElement("div",{className:"body-param","data-param-name":o.get("name"),"data-param-in":o.get("in")},V&&i?Re.createElement(x,{className:"body-param__text"+(L.count()?" invalid":""),value:U,onChange:this.handleOnChange}):U&&Re.createElement(C,{className:"body-param__example",language:z},U),Re.createElement("div",{className:"body-param-options"},i?Re.createElement("div",{className:"body-param-edit"},Re.createElement(w,{className:V?"btn cancel body-param__example-edit":"btn edit body-param__example-edit",onClick:this.toggleIsEditBox},V?"Cancel":"Edit")):null,Re.createElement("label",{htmlFor:Y},Re.createElement("span",null,"Parameter content type"),Re.createElement(j,{value:B,contentTypes:$,onChange:s,className:"body-param-content-type",ariaLabel:"Parameter content type",controlId:Y}))))}}class Curl extends Re.Component{render(){const{request:s,getComponent:o}=this.props,i=requestSnippetGenerator_curl_bash(s),a=o("SyntaxHighlighter",!0);return Re.createElement("div",{className:"curl-command"},Re.createElement("h4",null,"Curl"),Re.createElement("div",{className:"copy-to-clipboard"},Re.createElement(Hn.CopyToClipboard,{text:i},Re.createElement("button",null))),Re.createElement("div",null,Re.createElement(a,{language:"bash",className:"curl microlight",renderPlainText:({children:s,PlainTextViewer:o})=>Re.createElement(o,{className:"curl"},s)},i)))}}const property=({propKey:s,propVal:o,propClass:i})=>Re.createElement("span",{className:i},Re.createElement("br",null),s,": ",stringify(o));class TryItOutButton extends Re.Component{static defaultProps={onTryoutClick:Function.prototype,onCancelClick:Function.prototype,onResetClick:Function.prototype,enabled:!1,hasUserEditedBody:!1,isOAS3:!1};render(){const{onTryoutClick:s,onCancelClick:o,onResetClick:i,enabled:a,hasUserEditedBody:u,isOAS3:_}=this.props,w=_&&u;return Re.createElement("div",{className:w?"try-out btn-group":"try-out"},a?Re.createElement("button",{className:"btn try-out__btn cancel",onClick:o},"Cancel"):Re.createElement("button",{className:"btn try-out__btn",onClick:s},"Try it out "),w&&Re.createElement("button",{className:"btn try-out__btn reset",onClick:i},"Reset"))}}class VersionPragmaFilter extends Re.PureComponent{static defaultProps={alsoShow:null,children:null,bypass:!1};render(){const{bypass:s,isSwagger2:o,isOAS3:i,alsoShow:a}=this.props;return s?Re.createElement("div",null,this.props.children):o&&i?Re.createElement("div",{className:"version-pragma"},a,Re.createElement("div",{className:"version-pragma__message version-pragma__message--ambiguous"},Re.createElement("div",null,Re.createElement("h3",null,"Unable to render this definition"),Re.createElement("p",null,Re.createElement("code",null,"swagger")," and ",Re.createElement("code",null,"openapi")," fields cannot be present in the same Swagger or OpenAPI definition. Please remove one of the fields."),Re.createElement("p",null,"Supported version fields are ",Re.createElement("code",null,"swagger: ",'"2.0"')," and those that match ",Re.createElement("code",null,"openapi: 3.0.n")," (for example, ",Re.createElement("code",null,"openapi: 3.0.4"),").")))):o||i?Re.createElement("div",null,this.props.children):Re.createElement("div",{className:"version-pragma"},a,Re.createElement("div",{className:"version-pragma__message version-pragma__message--missing"},Re.createElement("div",null,Re.createElement("h3",null,"Unable to render this definition"),Re.createElement("p",null,"The provided definition does not specify a valid version field."),Re.createElement("p",null,"Please indicate a valid Swagger or OpenAPI version field. Supported version fields are ",Re.createElement("code",null,"swagger: ",'"2.0"')," and those that match ",Re.createElement("code",null,"openapi: 3.0.n")," (for example, ",Re.createElement("code",null,"openapi: 3.0.4"),")."))))}}const version_stamp=({version:s})=>Re.createElement("small",null,Re.createElement("pre",{className:"version"}," ",s," ")),openapi_version=({oasVersion:s})=>Re.createElement("small",{className:"version-stamp"},Re.createElement("pre",{className:"version"},"OAS ",s)),deep_link=({enabled:s,path:o,text:i})=>Re.createElement("a",{className:"nostyle",onClick:s?s=>s.preventDefault():null,href:s?`#/${o}`:null},Re.createElement("span",null,i)),svg_assets=()=>Re.createElement("div",null,Re.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",className:"svg-assets"},Re.createElement("defs",null,Re.createElement("symbol",{viewBox:"0 0 20 20",id:"unlocked"},Re.createElement("path",{d:"M15.8 8H14V5.6C14 2.703 12.665 1 10 1 7.334 1 6 2.703 6 5.6V6h2v-.801C8 3.754 8.797 3 10 3c1.203 0 2 .754 2 2.199V8H4c-.553 0-1 .646-1 1.199V17c0 .549.428 1.139.951 1.307l1.197.387C5.672 18.861 6.55 19 7.1 19h5.8c.549 0 1.428-.139 1.951-.307l1.196-.387c.524-.167.953-.757.953-1.306V9.199C17 8.646 16.352 8 15.8 8z"})),Re.createElement("symbol",{viewBox:"0 0 20 20",id:"locked"},Re.createElement("path",{d:"M15.8 8H14V5.6C14 2.703 12.665 1 10 1 7.334 1 6 2.703 6 5.6V8H4c-.553 0-1 .646-1 1.199V17c0 .549.428 1.139.951 1.307l1.197.387C5.672 18.861 6.55 19 7.1 19h5.8c.549 0 1.428-.139 1.951-.307l1.196-.387c.524-.167.953-.757.953-1.306V9.199C17 8.646 16.352 8 15.8 8zM12 8H8V5.199C8 3.754 8.797 3 10 3c1.203 0 2 .754 2 2.199V8z"})),Re.createElement("symbol",{viewBox:"0 0 20 20",id:"close"},Re.createElement("path",{d:"M14.348 14.849c-.469.469-1.229.469-1.697 0L10 11.819l-2.651 3.029c-.469.469-1.229.469-1.697 0-.469-.469-.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-.469-.469-.469-1.228 0-1.697.469-.469 1.228-.469 1.697 0L10 8.183l2.651-3.031c.469-.469 1.228-.469 1.697 0 .469.469.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c.469.469.469 1.229 0 1.698z"})),Re.createElement("symbol",{viewBox:"0 0 20 20",id:"large-arrow"},Re.createElement("path",{d:"M13.25 10L6.109 2.58c-.268-.27-.268-.707 0-.979.268-.27.701-.27.969 0l7.83 7.908c.268.271.268.709 0 .979l-7.83 7.908c-.268.271-.701.27-.969 0-.268-.269-.268-.707 0-.979L13.25 10z"})),Re.createElement("symbol",{viewBox:"0 0 20 20",id:"large-arrow-down"},Re.createElement("path",{d:"M17.418 6.109c.272-.268.709-.268.979 0s.271.701 0 .969l-7.908 7.83c-.27.268-.707.268-.979 0l-7.908-7.83c-.27-.268-.27-.701 0-.969.271-.268.709-.268.979 0L10 13.25l7.418-7.141z"})),Re.createElement("symbol",{viewBox:"0 0 20 20",id:"large-arrow-up"},Re.createElement("path",{d:"M 17.418 14.908 C 17.69 15.176 18.127 15.176 18.397 14.908 C 18.667 14.64 18.668 14.207 18.397 13.939 L 10.489 6.109 C 10.219 5.841 9.782 5.841 9.51 6.109 L 1.602 13.939 C 1.332 14.207 1.332 14.64 1.602 14.908 C 1.873 15.176 2.311 15.176 2.581 14.908 L 10 7.767 L 17.418 14.908 Z"})),Re.createElement("symbol",{viewBox:"0 0 24 24",id:"jump-to"},Re.createElement("path",{d:"M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z"})),Re.createElement("symbol",{viewBox:"0 0 24 24",id:"expand"},Re.createElement("path",{d:"M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"})),Re.createElement("symbol",{viewBox:"0 0 15 16",id:"copy"},Re.createElement("g",{transform:"translate(2, -1)"},Re.createElement("path",{fill:"#ffffff",fillRule:"evenodd",d:"M2 13h4v1H2v-1zm5-6H2v1h5V7zm2 3V8l-3 3 3 3v-2h5v-2H9zM4.5 9H2v1h2.5V9zM2 12h2.5v-1H2v1zm9 1h1v2c-.02.28-.11.52-.3.7-.19.18-.42.28-.7.3H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h3c0-1.11.89-2 2-2 1.11 0 2 .89 2 2h3c.55 0 1 .45 1 1v5h-1V6H1v9h10v-2zM2 5h8c0-.55-.45-1-1-1H8c-.55 0-1-.45-1-1s-.45-1-1-1-1 .45-1 1-.45 1-1 1H3c-.55 0-1 .45-1 1z"}))))));var XO;function decodeEntity(s){return(XO=XO||document.createElement("textarea")).innerHTML="&"+s+";",XO.value}var QO=Object.prototype.hasOwnProperty;function index_browser_has(s,o){return!!s&&QO.call(s,o)}function index_browser_assign(s){return[].slice.call(arguments,1).forEach((function(o){if(o){if("object"!=typeof o)throw new TypeError(o+"must be object");Object.keys(o).forEach((function(i){s[i]=o[i]}))}})),s}var ZO=/\\([\\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;function unescapeMd(s){return s.indexOf("\\")<0?s:s.replace(ZO,"$1")}function isValidEntityCode(s){return!(s>=55296&&s<=57343)&&(!(s>=64976&&s<=65007)&&(!!(65535&~s&&65534!=(65535&s))&&(!(s>=0&&s<=8)&&(11!==s&&(!(s>=14&&s<=31)&&(!(s>=127&&s<=159)&&!(s>1114111)))))))}function fromCodePoint(s){if(s>65535){var o=55296+((s-=65536)>>10),i=56320+(1023&s);return String.fromCharCode(o,i)}return String.fromCharCode(s)}var eA=/&([a-z#][a-z0-9]{1,31});/gi,tA=/^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;function replaceEntityPattern(s,o){var i=0,a=decodeEntity(o);return o!==a?a:35===o.charCodeAt(0)&&tA.test(o)&&isValidEntityCode(i="x"===o[1].toLowerCase()?parseInt(o.slice(2),16):parseInt(o.slice(1),10))?fromCodePoint(i):s}function replaceEntities(s){return s.indexOf("&")<0?s:s.replace(eA,replaceEntityPattern)}var rA=/[&<>"]/,nA=/[&<>"]/g,sA={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"};function replaceUnsafeChar(s){return sA[s]}function escapeHtml(s){return rA.test(s)?s.replace(nA,replaceUnsafeChar):s}var oA={};function nextToken(s,o){return++o>=s.length-2?o:"paragraph_open"===s[o].type&&s[o].tight&&"inline"===s[o+1].type&&0===s[o+1].content.length&&"paragraph_close"===s[o+2].type&&s[o+2].tight?nextToken(s,o+2):o}oA.blockquote_open=function(){return"<blockquote>\n"},oA.blockquote_close=function(s,o){return"</blockquote>"+iA(s,o)},oA.code=function(s,o){return s[o].block?"<pre><code>"+escapeHtml(s[o].content)+"</code></pre>"+iA(s,o):"<code>"+escapeHtml(s[o].content)+"</code>"},oA.fence=function(s,o,i,a,u){var _,w,x=s[o],C="",j=i.langPrefix;if(x.params){if(w=(_=x.params.split(/\s+/g)).join(" "),index_browser_has(u.rules.fence_custom,_[0]))return u.rules.fence_custom[_[0]](s,o,i,a,u);C=' class="'+j+escapeHtml(replaceEntities(unescapeMd(w)))+'"'}return"<pre><code"+C+">"+(i.highlight&&i.highlight.apply(i.highlight,[x.content].concat(_))||escapeHtml(x.content))+"</code></pre>"+iA(s,o)},oA.fence_custom={},oA.heading_open=function(s,o){return"<h"+s[o].hLevel+">"},oA.heading_close=function(s,o){return"</h"+s[o].hLevel+">\n"},oA.hr=function(s,o,i){return(i.xhtmlOut?"<hr />":"<hr>")+iA(s,o)},oA.bullet_list_open=function(){return"<ul>\n"},oA.bullet_list_close=function(s,o){return"</ul>"+iA(s,o)},oA.list_item_open=function(){return"<li>"},oA.list_item_close=function(){return"</li>\n"},oA.ordered_list_open=function(s,o){var i=s[o];return"<ol"+(i.order>1?' start="'+i.order+'"':"")+">\n"},oA.ordered_list_close=function(s,o){return"</ol>"+iA(s,o)},oA.paragraph_open=function(s,o){return s[o].tight?"":"<p>"},oA.paragraph_close=function(s,o){var i=!(s[o].tight&&o&&"inline"===s[o-1].type&&!s[o-1].content);return(s[o].tight?"":"</p>")+(i?iA(s,o):"")},oA.link_open=function(s,o,i){var a=s[o].title?' title="'+escapeHtml(replaceEntities(s[o].title))+'"':"",u=i.linkTarget?' target="'+i.linkTarget+'"':"";return'<a href="'+escapeHtml(s[o].href)+'"'+a+u+">"},oA.link_close=function(){return"</a>"},oA.image=function(s,o,i){var a=' src="'+escapeHtml(s[o].src)+'"',u=s[o].title?' title="'+escapeHtml(replaceEntities(s[o].title))+'"':"";return"<img"+a+(' alt="'+(s[o].alt?escapeHtml(replaceEntities(unescapeMd(s[o].alt))):"")+'"')+u+(i.xhtmlOut?" /":"")+">"},oA.table_open=function(){return"<table>\n"},oA.table_close=function(){return"</table>\n"},oA.thead_open=function(){return"<thead>\n"},oA.thead_close=function(){return"</thead>\n"},oA.tbody_open=function(){return"<tbody>\n"},oA.tbody_close=function(){return"</tbody>\n"},oA.tr_open=function(){return"<tr>"},oA.tr_close=function(){return"</tr>\n"},oA.th_open=function(s,o){var i=s[o];return"<th"+(i.align?' style="text-align:'+i.align+'"':"")+">"},oA.th_close=function(){return"</th>"},oA.td_open=function(s,o){var i=s[o];return"<td"+(i.align?' style="text-align:'+i.align+'"':"")+">"},oA.td_close=function(){return"</td>"},oA.strong_open=function(){return"<strong>"},oA.strong_close=function(){return"</strong>"},oA.em_open=function(){return"<em>"},oA.em_close=function(){return"</em>"},oA.del_open=function(){return"<del>"},oA.del_close=function(){return"</del>"},oA.ins_open=function(){return"<ins>"},oA.ins_close=function(){return"</ins>"},oA.mark_open=function(){return"<mark>"},oA.mark_close=function(){return"</mark>"},oA.sub=function(s,o){return"<sub>"+escapeHtml(s[o].content)+"</sub>"},oA.sup=function(s,o){return"<sup>"+escapeHtml(s[o].content)+"</sup>"},oA.hardbreak=function(s,o,i){return i.xhtmlOut?"<br />\n":"<br>\n"},oA.softbreak=function(s,o,i){return i.breaks?i.xhtmlOut?"<br />\n":"<br>\n":"\n"},oA.text=function(s,o){return escapeHtml(s[o].content)},oA.htmlblock=function(s,o){return s[o].content},oA.htmltag=function(s,o){return s[o].content},oA.abbr_open=function(s,o){return'<abbr title="'+escapeHtml(replaceEntities(s[o].title))+'">'},oA.abbr_close=function(){return"</abbr>"},oA.footnote_ref=function(s,o){var i=Number(s[o].id+1).toString(),a="fnref"+i;return s[o].subId>0&&(a+=":"+s[o].subId),'<sup class="footnote-ref"><a href="#fn'+i+'" id="'+a+'">['+i+"]</a></sup>"},oA.footnote_block_open=function(s,o,i){return(i.xhtmlOut?'<hr class="footnotes-sep" />\n':'<hr class="footnotes-sep">\n')+'<section class="footnotes">\n<ol class="footnotes-list">\n'},oA.footnote_block_close=function(){return"</ol>\n</section>\n"},oA.footnote_open=function(s,o){return'<li id="fn'+Number(s[o].id+1).toString()+'"  class="footnote-item">'},oA.footnote_close=function(){return"</li>\n"},oA.footnote_anchor=function(s,o){var i="fnref"+Number(s[o].id+1).toString();return s[o].subId>0&&(i+=":"+s[o].subId),' <a href="#'+i+'" class="footnote-backref">↩</a>'},oA.dl_open=function(){return"<dl>\n"},oA.dt_open=function(){return"<dt>"},oA.dd_open=function(){return"<dd>"},oA.dl_close=function(){return"</dl>\n"},oA.dt_close=function(){return"</dt>\n"},oA.dd_close=function(){return"</dd>\n"};var iA=oA.getBreak=function getBreak(s,o){return(o=nextToken(s,o))<s.length&&"list_item_close"===s[o].type?"":"\n"};function Renderer(){this.rules=index_browser_assign({},oA),this.getBreak=oA.getBreak}function Ruler(){this.__rules__=[],this.__cache__=null}function StateInline(s,o,i,a,u){this.src=s,this.env=a,this.options=i,this.parser=o,this.tokens=u,this.pos=0,this.posMax=this.src.length,this.level=0,this.pending="",this.pendingLevel=0,this.cache=[],this.isInLabel=!1,this.linkLevel=0,this.linkContent="",this.labelUnmatchedScopes=0}function parseLinkLabel(s,o){var i,a,u,_=-1,w=s.posMax,x=s.pos,C=s.isInLabel;if(s.isInLabel)return-1;if(s.labelUnmatchedScopes)return s.labelUnmatchedScopes--,-1;for(s.pos=o+1,s.isInLabel=!0,i=1;s.pos<w;){if(91===(u=s.src.charCodeAt(s.pos)))i++;else if(93===u&&0===--i){a=!0;break}s.parser.skipToken(s)}return a?(_=s.pos,s.labelUnmatchedScopes=0):s.labelUnmatchedScopes=i-1,s.pos=x,s.isInLabel=C,_}function parseAbbr(s,o,i,a){var u,_,w,x,C,j;if(42!==s.charCodeAt(0))return-1;if(91!==s.charCodeAt(1))return-1;if(-1===s.indexOf("]:"))return-1;if((_=parseLinkLabel(u=new StateInline(s,o,i,a,[]),1))<0||58!==s.charCodeAt(_+1))return-1;for(x=u.posMax,w=_+2;w<x&&10!==u.src.charCodeAt(w);w++);return C=s.slice(2,_),0===(j=s.slice(_+2,w).trim()).length?-1:(a.abbreviations||(a.abbreviations={}),void 0===a.abbreviations[":"+C]&&(a.abbreviations[":"+C]=j),w)}function normalizeLink(s){var o=replaceEntities(s);try{o=decodeURI(o)}catch(s){}return encodeURI(o)}function parseLinkDestination(s,o){var i,a,u,_=o,w=s.posMax;if(60===s.src.charCodeAt(o)){for(o++;o<w;){if(10===(i=s.src.charCodeAt(o)))return!1;if(62===i)return u=normalizeLink(unescapeMd(s.src.slice(_+1,o))),!!s.parser.validateLink(u)&&(s.pos=o+1,s.linkContent=u,!0);92===i&&o+1<w?o+=2:o++}return!1}for(a=0;o<w&&32!==(i=s.src.charCodeAt(o))&&!(i<32||127===i);)if(92===i&&o+1<w)o+=2;else{if(40===i&&++a>1)break;if(41===i&&--a<0)break;o++}return _!==o&&(u=unescapeMd(s.src.slice(_,o)),!!s.parser.validateLink(u)&&(s.linkContent=u,s.pos=o,!0))}function parseLinkTitle(s,o){var i,a=o,u=s.posMax,_=s.src.charCodeAt(o);if(34!==_&&39!==_&&40!==_)return!1;for(o++,40===_&&(_=41);o<u;){if((i=s.src.charCodeAt(o))===_)return s.pos=o+1,s.linkContent=unescapeMd(s.src.slice(a+1,o)),!0;92===i&&o+1<u?o+=2:o++}return!1}function normalizeReference(s){return s.trim().replace(/\s+/g," ").toUpperCase()}function parseReference(s,o,i,a){var u,_,w,x,C,j,L,B,$;if(91!==s.charCodeAt(0))return-1;if(-1===s.indexOf("]:"))return-1;if((_=parseLinkLabel(u=new StateInline(s,o,i,a,[]),0))<0||58!==s.charCodeAt(_+1))return-1;for(x=u.posMax,w=_+2;w<x&&(32===(C=u.src.charCodeAt(w))||10===C);w++);if(!parseLinkDestination(u,w))return-1;for(L=u.linkContent,j=w=u.pos,w+=1;w<x&&(32===(C=u.src.charCodeAt(w))||10===C);w++);for(w<x&&j!==w&&parseLinkTitle(u,w)?(B=u.linkContent,w=u.pos):(B="",w=j);w<x&&32===u.src.charCodeAt(w);)w++;return w<x&&10!==u.src.charCodeAt(w)?-1:($=normalizeReference(s.slice(1,_)),void 0===a.references[$]&&(a.references[$]={title:B,href:L}),w)}Renderer.prototype.renderInline=function(s,o,i){for(var a=this.rules,u=s.length,_=0,w="";u--;)w+=a[s[_].type](s,_++,o,i,this);return w},Renderer.prototype.render=function(s,o,i){for(var a=this.rules,u=s.length,_=-1,w="";++_<u;)"inline"===s[_].type?w+=this.renderInline(s[_].children,o,i):w+=a[s[_].type](s,_,o,i,this);return w},Ruler.prototype.__find__=function(s){for(var o=this.__rules__.length,i=-1;o--;)if(this.__rules__[++i].name===s)return i;return-1},Ruler.prototype.__compile__=function(){var s=this,o=[""];s.__rules__.forEach((function(s){s.enabled&&s.alt.forEach((function(s){o.indexOf(s)<0&&o.push(s)}))})),s.__cache__={},o.forEach((function(o){s.__cache__[o]=[],s.__rules__.forEach((function(i){i.enabled&&(o&&i.alt.indexOf(o)<0||s.__cache__[o].push(i.fn))}))}))},Ruler.prototype.at=function(s,o,i){var a=this.__find__(s),u=i||{};if(-1===a)throw new Error("Parser rule not found: "+s);this.__rules__[a].fn=o,this.__rules__[a].alt=u.alt||[],this.__cache__=null},Ruler.prototype.before=function(s,o,i,a){var u=this.__find__(s),_=a||{};if(-1===u)throw new Error("Parser rule not found: "+s);this.__rules__.splice(u,0,{name:o,enabled:!0,fn:i,alt:_.alt||[]}),this.__cache__=null},Ruler.prototype.after=function(s,o,i,a){var u=this.__find__(s),_=a||{};if(-1===u)throw new Error("Parser rule not found: "+s);this.__rules__.splice(u+1,0,{name:o,enabled:!0,fn:i,alt:_.alt||[]}),this.__cache__=null},Ruler.prototype.push=function(s,o,i){var a=i||{};this.__rules__.push({name:s,enabled:!0,fn:o,alt:a.alt||[]}),this.__cache__=null},Ruler.prototype.enable=function(s,o){s=Array.isArray(s)?s:[s],o&&this.__rules__.forEach((function(s){s.enabled=!1})),s.forEach((function(s){var o=this.__find__(s);if(o<0)throw new Error("Rules manager: invalid rule name "+s);this.__rules__[o].enabled=!0}),this),this.__cache__=null},Ruler.prototype.disable=function(s){(s=Array.isArray(s)?s:[s]).forEach((function(s){var o=this.__find__(s);if(o<0)throw new Error("Rules manager: invalid rule name "+s);this.__rules__[o].enabled=!1}),this),this.__cache__=null},Ruler.prototype.getRules=function(s){return null===this.__cache__&&this.__compile__(),this.__cache__[s]||[]},StateInline.prototype.pushPending=function(){this.tokens.push({type:"text",content:this.pending,level:this.pendingLevel}),this.pending=""},StateInline.prototype.push=function(s){this.pending&&this.pushPending(),this.tokens.push(s),this.pendingLevel=this.level},StateInline.prototype.cacheSet=function(s,o){for(var i=this.cache.length;i<=s;i++)this.cache.push(0);this.cache[s]=o},StateInline.prototype.cacheGet=function(s){return s<this.cache.length?this.cache[s]:0};var aA=" \n()[]'\".,!?-";function regEscape(s){return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g,"\\$1")}var cA=/\+-|\.\.|\?\?\?\?|!!!!|,,|--/,lA=/\((c|tm|r|p)\)/gi,uA={c:"©",r:"®",p:"§",tm:"™"};function replaceScopedAbbr(s){return s.indexOf("(")<0?s:s.replace(lA,(function(s,o){return uA[o.toLowerCase()]}))}var pA=/['"]/,hA=/['"]/g,dA=/[-\s()\[\]]/;function isLetter(s,o){return!(o<0||o>=s.length)&&!dA.test(s[o])}function replaceAt(s,o,i){return s.substr(0,o)+i+s.substr(o+1)}var fA=[["block",function block(s){s.inlineMode?s.tokens.push({type:"inline",content:s.src.replace(/\n/g," ").trim(),level:0,lines:[0,1],children:[]}):s.block.parse(s.src,s.options,s.env,s.tokens)}],["abbr",function abbr(s){var o,i,a,u,_=s.tokens;if(!s.inlineMode)for(o=1,i=_.length-1;o<i;o++)if("paragraph_open"===_[o-1].type&&"inline"===_[o].type&&"paragraph_close"===_[o+1].type){for(a=_[o].content;a.length&&!((u=parseAbbr(a,s.inline,s.options,s.env))<0);)a=a.slice(u).trim();_[o].content=a,a.length||(_[o-1].tight=!0,_[o+1].tight=!0)}}],["references",function references(s){var o,i,a,u,_=s.tokens;if(s.env.references=s.env.references||{},!s.inlineMode)for(o=1,i=_.length-1;o<i;o++)if("inline"===_[o].type&&"paragraph_open"===_[o-1].type&&"paragraph_close"===_[o+1].type){for(a=_[o].content;a.length&&!((u=parseReference(a,s.inline,s.options,s.env))<0);)a=a.slice(u).trim();_[o].content=a,a.length||(_[o-1].tight=!0,_[o+1].tight=!0)}}],["inline",function inline(s){var o,i,a,u=s.tokens;for(i=0,a=u.length;i<a;i++)"inline"===(o=u[i]).type&&s.inline.parse(o.content,s.options,s.env,o.children)}],["footnote_tail",function footnote_block(s){var o,i,a,u,_,w,x,C,j,L=0,B=!1,$={};if(s.env.footnotes&&(s.tokens=s.tokens.filter((function(s){return"footnote_reference_open"===s.type?(B=!0,C=[],j=s.label,!1):"footnote_reference_close"===s.type?(B=!1,$[":"+j]=C,!1):(B&&C.push(s),!B)})),s.env.footnotes.list)){for(w=s.env.footnotes.list,s.tokens.push({type:"footnote_block_open",level:L++}),o=0,i=w.length;o<i;o++){for(s.tokens.push({type:"footnote_open",id:o,level:L++}),w[o].tokens?((x=[]).push({type:"paragraph_open",tight:!1,level:L++}),x.push({type:"inline",content:"",level:L,children:w[o].tokens}),x.push({type:"paragraph_close",tight:!1,level:--L})):w[o].label&&(x=$[":"+w[o].label]),s.tokens=s.tokens.concat(x),_="paragraph_close"===s.tokens[s.tokens.length-1].type?s.tokens.pop():null,u=w[o].count>0?w[o].count:1,a=0;a<u;a++)s.tokens.push({type:"footnote_anchor",id:o,subId:a,level:L});_&&s.tokens.push(_),s.tokens.push({type:"footnote_close",level:--L})}s.tokens.push({type:"footnote_block_close",level:--L})}}],["abbr2",function abbr2(s){var o,i,a,u,_,w,x,C,j,L,B,$,U=s.tokens;if(s.env.abbreviations)for(s.env.abbrRegExp||($="(^|["+aA.split("").map(regEscape).join("")+"])("+Object.keys(s.env.abbreviations).map((function(s){return s.substr(1)})).sort((function(s,o){return o.length-s.length})).map(regEscape).join("|")+")($|["+aA.split("").map(regEscape).join("")+"])",s.env.abbrRegExp=new RegExp($,"g")),L=s.env.abbrRegExp,i=0,a=U.length;i<a;i++)if("inline"===U[i].type)for(o=(u=U[i].children).length-1;o>=0;o--)if("text"===(_=u[o]).type){for(C=0,w=_.content,L.lastIndex=0,j=_.level,x=[];B=L.exec(w);)L.lastIndex>C&&x.push({type:"text",content:w.slice(C,B.index+B[1].length),level:j}),x.push({type:"abbr_open",title:s.env.abbreviations[":"+B[2]],level:j++}),x.push({type:"text",content:B[2],level:j}),x.push({type:"abbr_close",level:--j}),C=L.lastIndex-B[3].length;x.length&&(C<w.length&&x.push({type:"text",content:w.slice(C),level:j}),U[i].children=u=[].concat(u.slice(0,o),x,u.slice(o+1)))}}],["replacements",function index_browser_replace(s){var o,i,a,u,_;if(s.options.typographer)for(_=s.tokens.length-1;_>=0;_--)if("inline"===s.tokens[_].type)for(o=(u=s.tokens[_].children).length-1;o>=0;o--)"text"===(i=u[o]).type&&(a=replaceScopedAbbr(a=i.content),cA.test(a)&&(a=a.replace(/\+-/g,"±").replace(/\.{2,}/g,"…").replace(/([?!])…/g,"$1..").replace(/([?!]){4,}/g,"$1$1$1").replace(/,{2,}/g,",").replace(/(^|[^-])---([^-]|$)/gm,"$1—$2").replace(/(^|\s)--(\s|$)/gm,"$1–$2").replace(/(^|[^-\s])--([^-\s]|$)/gm,"$1–$2")),i.content=a)}],["smartquotes",function smartquotes(s){var o,i,a,u,_,w,x,C,j,L,B,$,U,V,z,Y,Z;if(s.options.typographer)for(Z=[],z=s.tokens.length-1;z>=0;z--)if("inline"===s.tokens[z].type)for(Y=s.tokens[z].children,Z.length=0,o=0;o<Y.length;o++)if("text"===(i=Y[o]).type&&!pA.test(i.text)){for(x=Y[o].level,U=Z.length-1;U>=0&&!(Z[U].level<=x);U--);Z.length=U+1,_=0,w=(a=i.content).length;e:for(;_<w&&(hA.lastIndex=_,u=hA.exec(a));)if(C=!isLetter(a,u.index-1),_=u.index+1,V="'"===u[0],(j=!isLetter(a,_))||C){if(B=!j,$=!C)for(U=Z.length-1;U>=0&&(L=Z[U],!(Z[U].level<x));U--)if(L.single===V&&Z[U].level===x){L=Z[U],V?(Y[L.token].content=replaceAt(Y[L.token].content,L.pos,s.options.quotes[2]),i.content=replaceAt(i.content,u.index,s.options.quotes[3])):(Y[L.token].content=replaceAt(Y[L.token].content,L.pos,s.options.quotes[0]),i.content=replaceAt(i.content,u.index,s.options.quotes[1])),Z.length=U;continue e}B?Z.push({token:o,pos:u.index,single:V,level:x}):$&&V&&(i.content=replaceAt(i.content,u.index,"’"))}else V&&(i.content=replaceAt(i.content,u.index,"’"))}}]];function Core(){this.options={},this.ruler=new Ruler;for(var s=0;s<fA.length;s++)this.ruler.push(fA[s][0],fA[s][1])}function StateBlock(s,o,i,a,u){var _,w,x,C,j,L,B;for(this.src=s,this.parser=o,this.options=i,this.env=a,this.tokens=u,this.bMarks=[],this.eMarks=[],this.tShift=[],this.blkIndent=0,this.line=0,this.lineMax=0,this.tight=!1,this.parentType="root",this.ddIndent=-1,this.level=0,this.result="",L=0,B=!1,x=C=L=0,j=(w=this.src).length;C<j;C++){if(_=w.charCodeAt(C),!B){if(32===_){L++;continue}B=!0}10!==_&&C!==j-1||(10!==_&&C++,this.bMarks.push(x),this.eMarks.push(C),this.tShift.push(L),B=!1,L=0,x=C+1)}this.bMarks.push(w.length),this.eMarks.push(w.length),this.tShift.push(0),this.lineMax=this.bMarks.length-1}function skipBulletListMarker(s,o){var i,a,u;return(a=s.bMarks[o]+s.tShift[o])>=(u=s.eMarks[o])||42!==(i=s.src.charCodeAt(a++))&&45!==i&&43!==i||a<u&&32!==s.src.charCodeAt(a)?-1:a}function skipOrderedListMarker(s,o){var i,a=s.bMarks[o]+s.tShift[o],u=s.eMarks[o];if(a+1>=u)return-1;if((i=s.src.charCodeAt(a++))<48||i>57)return-1;for(;;){if(a>=u)return-1;if(!((i=s.src.charCodeAt(a++))>=48&&i<=57)){if(41===i||46===i)break;return-1}}return a<u&&32!==s.src.charCodeAt(a)?-1:a}Core.prototype.process=function(s){var o,i,a;for(o=0,i=(a=this.ruler.getRules("")).length;o<i;o++)a[o](s)},StateBlock.prototype.isEmpty=function isEmpty(s){return this.bMarks[s]+this.tShift[s]>=this.eMarks[s]},StateBlock.prototype.skipEmptyLines=function skipEmptyLines(s){for(var o=this.lineMax;s<o&&!(this.bMarks[s]+this.tShift[s]<this.eMarks[s]);s++);return s},StateBlock.prototype.skipSpaces=function skipSpaces(s){for(var o=this.src.length;s<o&&32===this.src.charCodeAt(s);s++);return s},StateBlock.prototype.skipChars=function skipChars(s,o){for(var i=this.src.length;s<i&&this.src.charCodeAt(s)===o;s++);return s},StateBlock.prototype.skipCharsBack=function skipCharsBack(s,o,i){if(s<=i)return s;for(;s>i;)if(o!==this.src.charCodeAt(--s))return s+1;return s},StateBlock.prototype.getLines=function getLines(s,o,i,a){var u,_,w,x,C,j=s;if(s>=o)return"";if(j+1===o)return _=this.bMarks[j]+Math.min(this.tShift[j],i),w=a?this.eMarks[j]+1:this.eMarks[j],this.src.slice(_,w);for(x=new Array(o-s),u=0;j<o;j++,u++)(C=this.tShift[j])>i&&(C=i),C<0&&(C=0),_=this.bMarks[j]+C,w=j+1<o||a?this.eMarks[j]+1:this.eMarks[j],x[u]=this.src.slice(_,w);return x.join("")};var mA={};["article","aside","button","blockquote","body","canvas","caption","col","colgroup","dd","div","dl","dt","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","hr","iframe","li","map","object","ol","output","p","pre","progress","script","section","style","table","tbody","td","textarea","tfoot","th","tr","thead","ul","video"].forEach((function(s){mA[s]=!0}));var gA=/^<([a-zA-Z]{1,15})[\s\/>]/,yA=/^<\/([a-zA-Z]{1,15})[\s>]/;function index_browser_getLine(s,o){var i=s.bMarks[o]+s.blkIndent,a=s.eMarks[o];return s.src.substr(i,a-i)}function skipMarker(s,o){var i,a,u=s.bMarks[o]+s.tShift[o],_=s.eMarks[o];return u>=_||126!==(a=s.src.charCodeAt(u++))&&58!==a||u===(i=s.skipSpaces(u))||i>=_?-1:i}var vA=[["code",function code(s,o,i){var a,u;if(s.tShift[o]-s.blkIndent<4)return!1;for(u=a=o+1;a<i;)if(s.isEmpty(a))a++;else{if(!(s.tShift[a]-s.blkIndent>=4))break;u=++a}return s.line=a,s.tokens.push({type:"code",content:s.getLines(o,u,4+s.blkIndent,!0),block:!0,lines:[o,s.line],level:s.level}),!0}],["fences",function fences(s,o,i,a){var u,_,w,x,C,j=!1,L=s.bMarks[o]+s.tShift[o],B=s.eMarks[o];if(L+3>B)return!1;if(126!==(u=s.src.charCodeAt(L))&&96!==u)return!1;if(C=L,(_=(L=s.skipChars(L,u))-C)<3)return!1;if((w=s.src.slice(L,B).trim()).indexOf("`")>=0)return!1;if(a)return!0;for(x=o;!(++x>=i)&&!((L=C=s.bMarks[x]+s.tShift[x])<(B=s.eMarks[x])&&s.tShift[x]<s.blkIndent);)if(s.src.charCodeAt(L)===u&&!(s.tShift[x]-s.blkIndent>=4||(L=s.skipChars(L,u))-C<_||(L=s.skipSpaces(L))<B)){j=!0;break}return _=s.tShift[o],s.line=x+(j?1:0),s.tokens.push({type:"fence",params:w,content:s.getLines(o+1,x,_,!0),lines:[o,s.line],level:s.level}),!0},["paragraph","blockquote","list"]],["blockquote",function blockquote(s,o,i,a){var u,_,w,x,C,j,L,B,$,U,V,z=s.bMarks[o]+s.tShift[o],Y=s.eMarks[o];if(z>Y)return!1;if(62!==s.src.charCodeAt(z++))return!1;if(s.level>=s.options.maxNesting)return!1;if(a)return!0;for(32===s.src.charCodeAt(z)&&z++,C=s.blkIndent,s.blkIndent=0,x=[s.bMarks[o]],s.bMarks[o]=z,_=(z=z<Y?s.skipSpaces(z):z)>=Y,w=[s.tShift[o]],s.tShift[o]=z-s.bMarks[o],B=s.parser.ruler.getRules("blockquote"),u=o+1;u<i&&!((z=s.bMarks[u]+s.tShift[u])>=(Y=s.eMarks[u]));u++)if(62!==s.src.charCodeAt(z++)){if(_)break;for(V=!1,$=0,U=B.length;$<U;$++)if(B[$](s,u,i,!0)){V=!0;break}if(V)break;x.push(s.bMarks[u]),w.push(s.tShift[u]),s.tShift[u]=-1337}else 32===s.src.charCodeAt(z)&&z++,x.push(s.bMarks[u]),s.bMarks[u]=z,_=(z=z<Y?s.skipSpaces(z):z)>=Y,w.push(s.tShift[u]),s.tShift[u]=z-s.bMarks[u];for(j=s.parentType,s.parentType="blockquote",s.tokens.push({type:"blockquote_open",lines:L=[o,0],level:s.level++}),s.parser.tokenize(s,o,u),s.tokens.push({type:"blockquote_close",level:--s.level}),s.parentType=j,L[1]=s.line,$=0;$<w.length;$++)s.bMarks[$+o]=x[$],s.tShift[$+o]=w[$];return s.blkIndent=C,!0},["paragraph","blockquote","list"]],["hr",function hr(s,o,i,a){var u,_,w,x=s.bMarks[o],C=s.eMarks[o];if((x+=s.tShift[o])>C)return!1;if(42!==(u=s.src.charCodeAt(x++))&&45!==u&&95!==u)return!1;for(_=1;x<C;){if((w=s.src.charCodeAt(x++))!==u&&32!==w)return!1;w===u&&_++}return!(_<3)&&(a||(s.line=o+1,s.tokens.push({type:"hr",lines:[o,s.line],level:s.level})),!0)},["paragraph","blockquote","list"]],["list",function index_browser_list(s,o,i,a){var u,_,w,x,C,j,L,B,$,U,V,z,Y,Z,ee,ie,ae,ce,le,pe,de,fe=!0;if((B=skipOrderedListMarker(s,o))>=0)z=!0;else{if(!((B=skipBulletListMarker(s,o))>=0))return!1;z=!1}if(s.level>=s.options.maxNesting)return!1;if(V=s.src.charCodeAt(B-1),a)return!0;for(Z=s.tokens.length,z?(L=s.bMarks[o]+s.tShift[o],U=Number(s.src.substr(L,B-L-1)),s.tokens.push({type:"ordered_list_open",order:U,lines:ie=[o,0],level:s.level++})):s.tokens.push({type:"bullet_list_open",lines:ie=[o,0],level:s.level++}),u=o,ee=!1,ce=s.parser.ruler.getRules("list");!(!(u<i)||(($=(Y=s.skipSpaces(B))>=s.eMarks[u]?1:Y-B)>4&&($=1),$<1&&($=1),_=B-s.bMarks[u]+$,s.tokens.push({type:"list_item_open",lines:ae=[o,0],level:s.level++}),x=s.blkIndent,C=s.tight,w=s.tShift[o],j=s.parentType,s.tShift[o]=Y-s.bMarks[o],s.blkIndent=_,s.tight=!0,s.parentType="list",s.parser.tokenize(s,o,i,!0),s.tight&&!ee||(fe=!1),ee=s.line-o>1&&s.isEmpty(s.line-1),s.blkIndent=x,s.tShift[o]=w,s.tight=C,s.parentType=j,s.tokens.push({type:"list_item_close",level:--s.level}),u=o=s.line,ae[1]=u,Y=s.bMarks[o],u>=i)||s.isEmpty(u)||s.tShift[u]<s.blkIndent);){for(de=!1,le=0,pe=ce.length;le<pe;le++)if(ce[le](s,u,i,!0)){de=!0;break}if(de)break;if(z){if((B=skipOrderedListMarker(s,u))<0)break}else if((B=skipBulletListMarker(s,u))<0)break;if(V!==s.src.charCodeAt(B-1))break}return s.tokens.push({type:z?"ordered_list_close":"bullet_list_close",level:--s.level}),ie[1]=u,s.line=u,fe&&function markTightParagraphs(s,o){var i,a,u=s.level+2;for(i=o+2,a=s.tokens.length-2;i<a;i++)s.tokens[i].level===u&&"paragraph_open"===s.tokens[i].type&&(s.tokens[i+2].tight=!0,s.tokens[i].tight=!0,i+=2)}(s,Z),!0},["paragraph","blockquote"]],["footnote",function footnote(s,o,i,a){var u,_,w,x,C,j=s.bMarks[o]+s.tShift[o],L=s.eMarks[o];if(j+4>L)return!1;if(91!==s.src.charCodeAt(j))return!1;if(94!==s.src.charCodeAt(j+1))return!1;if(s.level>=s.options.maxNesting)return!1;for(x=j+2;x<L;x++){if(32===s.src.charCodeAt(x))return!1;if(93===s.src.charCodeAt(x))break}return x!==j+2&&(!(x+1>=L||58!==s.src.charCodeAt(++x))&&(a||(x++,s.env.footnotes||(s.env.footnotes={}),s.env.footnotes.refs||(s.env.footnotes.refs={}),C=s.src.slice(j+2,x-2),s.env.footnotes.refs[":"+C]=-1,s.tokens.push({type:"footnote_reference_open",label:C,level:s.level++}),u=s.bMarks[o],_=s.tShift[o],w=s.parentType,s.tShift[o]=s.skipSpaces(x)-x,s.bMarks[o]=x,s.blkIndent+=4,s.parentType="footnote",s.tShift[o]<s.blkIndent&&(s.tShift[o]+=s.blkIndent,s.bMarks[o]-=s.blkIndent),s.parser.tokenize(s,o,i,!0),s.parentType=w,s.blkIndent-=4,s.tShift[o]=_,s.bMarks[o]=u,s.tokens.push({type:"footnote_reference_close",level:--s.level})),!0))},["paragraph"]],["heading",function heading(s,o,i,a){var u,_,w,x=s.bMarks[o]+s.tShift[o],C=s.eMarks[o];if(x>=C)return!1;if(35!==(u=s.src.charCodeAt(x))||x>=C)return!1;for(_=1,u=s.src.charCodeAt(++x);35===u&&x<C&&_<=6;)_++,u=s.src.charCodeAt(++x);return!(_>6||x<C&&32!==u)&&(a||(C=s.skipCharsBack(C,32,x),(w=s.skipCharsBack(C,35,x))>x&&32===s.src.charCodeAt(w-1)&&(C=w),s.line=o+1,s.tokens.push({type:"heading_open",hLevel:_,lines:[o,s.line],level:s.level}),x<C&&s.tokens.push({type:"inline",content:s.src.slice(x,C).trim(),level:s.level+1,lines:[o,s.line],children:[]}),s.tokens.push({type:"heading_close",hLevel:_,level:s.level})),!0)},["paragraph","blockquote"]],["lheading",function lheading(s,o,i){var a,u,_,w=o+1;return!(w>=i)&&(!(s.tShift[w]<s.blkIndent)&&(!(s.tShift[w]-s.blkIndent>3)&&(!((u=s.bMarks[w]+s.tShift[w])>=(_=s.eMarks[w]))&&((45===(a=s.src.charCodeAt(u))||61===a)&&(u=s.skipChars(u,a),!((u=s.skipSpaces(u))<_)&&(u=s.bMarks[o]+s.tShift[o],s.line=w+1,s.tokens.push({type:"heading_open",hLevel:61===a?1:2,lines:[o,s.line],level:s.level}),s.tokens.push({type:"inline",content:s.src.slice(u,s.eMarks[o]).trim(),level:s.level+1,lines:[o,s.line-1],children:[]}),s.tokens.push({type:"heading_close",hLevel:61===a?1:2,level:s.level}),!0))))))}],["htmlblock",function htmlblock(s,o,i,a){var u,_,w,x=s.bMarks[o],C=s.eMarks[o],j=s.tShift[o];if(x+=j,!s.options.html)return!1;if(j>3||x+2>=C)return!1;if(60!==s.src.charCodeAt(x))return!1;if(33===(u=s.src.charCodeAt(x+1))||63===u){if(a)return!0}else{if(47!==u&&!function isLetter$1(s){var o=32|s;return o>=97&&o<=122}(u))return!1;if(47===u){if(!(_=s.src.slice(x,C).match(yA)))return!1}else if(!(_=s.src.slice(x,C).match(gA)))return!1;if(!0!==mA[_[1].toLowerCase()])return!1;if(a)return!0}for(w=o+1;w<s.lineMax&&!s.isEmpty(w);)w++;return s.line=w,s.tokens.push({type:"htmlblock",level:s.level,lines:[o,s.line],content:s.getLines(o,w,0,!0)}),!0},["paragraph","blockquote"]],["table",function table(s,o,i,a){var u,_,w,x,C,j,L,B,$,U,V;if(o+2>i)return!1;if(C=o+1,s.tShift[C]<s.blkIndent)return!1;if((w=s.bMarks[C]+s.tShift[C])>=s.eMarks[C])return!1;if(124!==(u=s.src.charCodeAt(w))&&45!==u&&58!==u)return!1;if(_=index_browser_getLine(s,o+1),!/^[-:| ]+$/.test(_))return!1;if((j=_.split("|"))<=2)return!1;for(B=[],x=0;x<j.length;x++){if(!($=j[x].trim())){if(0===x||x===j.length-1)continue;return!1}if(!/^:?-+:?$/.test($))return!1;58===$.charCodeAt($.length-1)?B.push(58===$.charCodeAt(0)?"center":"right"):58===$.charCodeAt(0)?B.push("left"):B.push("")}if(-1===(_=index_browser_getLine(s,o).trim()).indexOf("|"))return!1;if(j=_.replace(/^\||\|$/g,"").split("|"),B.length!==j.length)return!1;if(a)return!0;for(s.tokens.push({type:"table_open",lines:U=[o,0],level:s.level++}),s.tokens.push({type:"thead_open",lines:[o,o+1],level:s.level++}),s.tokens.push({type:"tr_open",lines:[o,o+1],level:s.level++}),x=0;x<j.length;x++)s.tokens.push({type:"th_open",align:B[x],lines:[o,o+1],level:s.level++}),s.tokens.push({type:"inline",content:j[x].trim(),lines:[o,o+1],level:s.level,children:[]}),s.tokens.push({type:"th_close",level:--s.level});for(s.tokens.push({type:"tr_close",level:--s.level}),s.tokens.push({type:"thead_close",level:--s.level}),s.tokens.push({type:"tbody_open",lines:V=[o+2,0],level:s.level++}),C=o+2;C<i&&!(s.tShift[C]<s.blkIndent)&&-1!==(_=index_browser_getLine(s,C).trim()).indexOf("|");C++){for(j=_.replace(/^\||\|$/g,"").split("|"),s.tokens.push({type:"tr_open",level:s.level++}),x=0;x<j.length;x++)s.tokens.push({type:"td_open",align:B[x],level:s.level++}),L=j[x].substring(124===j[x].charCodeAt(0)?1:0,124===j[x].charCodeAt(j[x].length-1)?j[x].length-1:j[x].length).trim(),s.tokens.push({type:"inline",content:L,level:s.level,children:[]}),s.tokens.push({type:"td_close",level:--s.level});s.tokens.push({type:"tr_close",level:--s.level})}return s.tokens.push({type:"tbody_close",level:--s.level}),s.tokens.push({type:"table_close",level:--s.level}),U[1]=V[1]=C,s.line=C,!0},["paragraph"]],["deflist",function deflist(s,o,i,a){var u,_,w,x,C,j,L,B,$,U,V,z,Y,Z;if(a)return!(s.ddIndent<0)&&skipMarker(s,o)>=0;if(L=o+1,s.isEmpty(L)&&++L>i)return!1;if(s.tShift[L]<s.blkIndent)return!1;if((u=skipMarker(s,L))<0)return!1;if(s.level>=s.options.maxNesting)return!1;j=s.tokens.length,s.tokens.push({type:"dl_open",lines:C=[o,0],level:s.level++}),w=o,_=L;e:for(;;){for(Z=!0,Y=!1,s.tokens.push({type:"dt_open",lines:[w,w],level:s.level++}),s.tokens.push({type:"inline",content:s.getLines(w,w+1,s.blkIndent,!1).trim(),level:s.level+1,lines:[w,w],children:[]}),s.tokens.push({type:"dt_close",level:--s.level});;){if(s.tokens.push({type:"dd_open",lines:x=[L,0],level:s.level++}),z=s.tight,$=s.ddIndent,B=s.blkIndent,V=s.tShift[_],U=s.parentType,s.blkIndent=s.ddIndent=s.tShift[_]+2,s.tShift[_]=u-s.bMarks[_],s.tight=!0,s.parentType="deflist",s.parser.tokenize(s,_,i,!0),s.tight&&!Y||(Z=!1),Y=s.line-_>1&&s.isEmpty(s.line-1),s.tShift[_]=V,s.tight=z,s.parentType=U,s.blkIndent=B,s.ddIndent=$,s.tokens.push({type:"dd_close",level:--s.level}),x[1]=L=s.line,L>=i)break e;if(s.tShift[L]<s.blkIndent)break e;if((u=skipMarker(s,L))<0)break;_=L}if(L>=i)break;if(w=L,s.isEmpty(w))break;if(s.tShift[w]<s.blkIndent)break;if((_=w+1)>=i)break;if(s.isEmpty(_)&&_++,_>=i)break;if(s.tShift[_]<s.blkIndent)break;if((u=skipMarker(s,_))<0)break}return s.tokens.push({type:"dl_close",level:--s.level}),C[1]=L,s.line=L,Z&&function markTightParagraphs$1(s,o){var i,a,u=s.level+2;for(i=o+2,a=s.tokens.length-2;i<a;i++)s.tokens[i].level===u&&"paragraph_open"===s.tokens[i].type&&(s.tokens[i+2].tight=!0,s.tokens[i].tight=!0,i+=2)}(s,j),!0},["paragraph"]],["paragraph",function paragraph(s,o){var i,a,u,_,w,x,C=o+1;if(C<(i=s.lineMax)&&!s.isEmpty(C))for(x=s.parser.ruler.getRules("paragraph");C<i&&!s.isEmpty(C);C++)if(!(s.tShift[C]-s.blkIndent>3)){for(u=!1,_=0,w=x.length;_<w;_++)if(x[_](s,C,i,!0)){u=!0;break}if(u)break}return a=s.getLines(o,C,s.blkIndent,!1).trim(),s.line=C,a.length&&(s.tokens.push({type:"paragraph_open",tight:!1,lines:[o,s.line],level:s.level}),s.tokens.push({type:"inline",content:a,level:s.level+1,lines:[o,s.line],children:[]}),s.tokens.push({type:"paragraph_close",tight:!1,level:s.level})),!0}]];function ParserBlock(){this.ruler=new Ruler;for(var s=0;s<vA.length;s++)this.ruler.push(vA[s][0],vA[s][1],{alt:(vA[s][2]||[]).slice()})}ParserBlock.prototype.tokenize=function(s,o,i){for(var a,u=this.ruler.getRules(""),_=u.length,w=o,x=!1;w<i&&(s.line=w=s.skipEmptyLines(w),!(w>=i))&&!(s.tShift[w]<s.blkIndent);){for(a=0;a<_&&!u[a](s,w,i,!1);a++);if(s.tight=!x,s.isEmpty(s.line-1)&&(x=!0),(w=s.line)<i&&s.isEmpty(w)){if(x=!0,++w<i&&"list"===s.parentType&&s.isEmpty(w))break;s.line=w}}};var bA=/[\n\t]/g,SA=/\r[\n\u0085]|[\u2424\u2028\u0085]/g,_A=/\u00a0/g;function isTerminatorChar(s){switch(s){case 10:case 92:case 96:case 42:case 95:case 94:case 91:case 93:case 33:case 38:case 60:case 62:case 123:case 125:case 36:case 37:case 64:case 126:case 43:case 61:case 58:return!0;default:return!1}}ParserBlock.prototype.parse=function(s,o,i,a){var u,_=0,w=0;if(!s)return[];(s=(s=s.replace(_A," ")).replace(SA,"\n")).indexOf("\t")>=0&&(s=s.replace(bA,(function(o,i){var a;return 10===s.charCodeAt(i)?(_=i+1,w=0,o):(a="    ".slice((i-_-w)%4),w=i-_+1,a)}))),u=new StateBlock(s,this,o,i,a),this.tokenize(u,u.line,u.lineMax)};for(var EA=[],wA=0;wA<256;wA++)EA.push(0);function isAlphaNum(s){return s>=48&&s<=57||s>=65&&s<=90||s>=97&&s<=122}function scanDelims(s,o){var i,a,u,_=o,w=!0,x=!0,C=s.posMax,j=s.src.charCodeAt(o);for(i=o>0?s.src.charCodeAt(o-1):-1;_<C&&s.src.charCodeAt(_)===j;)_++;return _>=C&&(w=!1),(u=_-o)>=4?w=x=!1:(32!==(a=_<C?s.src.charCodeAt(_):-1)&&10!==a||(w=!1),32!==i&&10!==i||(x=!1),95===j&&(isAlphaNum(i)&&(w=!1),isAlphaNum(a)&&(x=!1))),{can_open:w,can_close:x,delims:u}}"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach((function(s){EA[s.charCodeAt(0)]=1}));var xA=/\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;var kA=/\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;var OA=["coap","doi","javascript","aaa","aaas","about","acap","cap","cid","crid","data","dav","dict","dns","file","ftp","geo","go","gopher","h323","http","https","iax","icap","im","imap","info","ipp","iris","iris.beep","iris.xpc","iris.xpcs","iris.lwz","ldap","mailto","mid","msrp","msrps","mtqp","mupdate","news","nfs","ni","nih","nntp","opaquelocktoken","pop","pres","rtsp","service","session","shttp","sieve","sip","sips","sms","snmp","soap.beep","soap.beeps","tag","tel","telnet","tftp","thismessage","tn3270","tip","tv","urn","vemmi","ws","wss","xcon","xcon-userid","xmlrpc.beep","xmlrpc.beeps","xmpp","z39.50r","z39.50s","adiumxtra","afp","afs","aim","apt","attachment","aw","beshare","bitcoin","bolo","callto","chrome","chrome-extension","com-eventbrite-attendee","content","cvs","dlna-playsingle","dlna-playcontainer","dtn","dvb","ed2k","facetime","feed","finger","fish","gg","git","gizmoproject","gtalk","hcp","icon","ipn","irc","irc6","ircs","itms","jar","jms","keyparc","lastfm","ldaps","magnet","maps","market","message","mms","ms-help","msnim","mumble","mvn","notes","oid","palm","paparazzi","platform","proxy","psyc","query","res","resource","rmi","rsync","rtmp","secondlife","sftp","sgn","skype","smb","soldat","spotify","ssh","steam","svn","teamspeak","things","udp","unreal","ut2004","ventrilo","view-source","webcal","wtai","wyciwyg","xfire","xri","ymsgr"],AA=/^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/,CA=/^<([a-zA-Z.\-]{1,25}):([^<>\x00-\x20]*)>/;function replace$1(s,o){return s=s.source,o=o||"",function self(i,a){return i?(a=a.source||a,s=s.replace(i,a),self):new RegExp(s,o)}}var jA=replace$1(/(?:unquoted|single_quoted|double_quoted)/)("unquoted",/[^"'=<>`\x00-\x20]+/)("single_quoted",/'[^']*'/)("double_quoted",/"[^"]*"/)(),PA=replace$1(/(?:\s+attr_name(?:\s*=\s*attr_value)?)/)("attr_name",/[a-zA-Z_:][a-zA-Z0-9:._-]*/)("attr_value",jA)(),IA=replace$1(/<[A-Za-z][A-Za-z0-9]*attribute*\s*\/?>/)("attribute",PA)(),TA=replace$1(/^(?:open_tag|close_tag|comment|processing|declaration|cdata)/)("open_tag",IA)("close_tag",/<\/[A-Za-z][A-Za-z0-9]*\s*>/)("comment",/<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->/)("processing",/<[?].*?[?]>/)("declaration",/<![A-Z]+\s+[^>]*>/)("cdata",/<!\[CDATA\[[\s\S]*?\]\]>/)();var NA=/^&#((?:x[a-f0-9]{1,8}|[0-9]{1,8}));/i,MA=/^&([a-z][a-z0-9]{1,31});/i;var RA=[["text",function index_browser_text(s,o){for(var i=s.pos;i<s.posMax&&!isTerminatorChar(s.src.charCodeAt(i));)i++;return i!==s.pos&&(o||(s.pending+=s.src.slice(s.pos,i)),s.pos=i,!0)}],["newline",function newline(s,o){var i,a,u=s.pos;if(10!==s.src.charCodeAt(u))return!1;if(i=s.pending.length-1,a=s.posMax,!o)if(i>=0&&32===s.pending.charCodeAt(i))if(i>=1&&32===s.pending.charCodeAt(i-1)){for(var _=i-2;_>=0;_--)if(32!==s.pending.charCodeAt(_)){s.pending=s.pending.substring(0,_+1);break}s.push({type:"hardbreak",level:s.level})}else s.pending=s.pending.slice(0,-1),s.push({type:"softbreak",level:s.level});else s.push({type:"softbreak",level:s.level});for(u++;u<a&&32===s.src.charCodeAt(u);)u++;return s.pos=u,!0}],["escape",function index_browser_escape(s,o){var i,a=s.pos,u=s.posMax;if(92!==s.src.charCodeAt(a))return!1;if(++a<u){if((i=s.src.charCodeAt(a))<256&&0!==EA[i])return o||(s.pending+=s.src[a]),s.pos+=2,!0;if(10===i){for(o||s.push({type:"hardbreak",level:s.level}),a++;a<u&&32===s.src.charCodeAt(a);)a++;return s.pos=a,!0}}return o||(s.pending+="\\"),s.pos++,!0}],["backticks",function backticks(s,o){var i,a,u,_,w,x=s.pos;if(96!==s.src.charCodeAt(x))return!1;for(i=x,x++,a=s.posMax;x<a&&96===s.src.charCodeAt(x);)x++;for(u=s.src.slice(i,x),_=w=x;-1!==(_=s.src.indexOf("`",w));){for(w=_+1;w<a&&96===s.src.charCodeAt(w);)w++;if(w-_===u.length)return o||s.push({type:"code",content:s.src.slice(x,_).replace(/[ \n]+/g," ").trim(),block:!1,level:s.level}),s.pos=w,!0}return o||(s.pending+=u),s.pos+=u.length,!0}],["del",function del(s,o){var i,a,u,_,w,x=s.posMax,C=s.pos;if(126!==s.src.charCodeAt(C))return!1;if(o)return!1;if(C+4>=x)return!1;if(126!==s.src.charCodeAt(C+1))return!1;if(s.level>=s.options.maxNesting)return!1;if(_=C>0?s.src.charCodeAt(C-1):-1,w=s.src.charCodeAt(C+2),126===_)return!1;if(126===w)return!1;if(32===w||10===w)return!1;for(a=C+2;a<x&&126===s.src.charCodeAt(a);)a++;if(a>C+3)return s.pos+=a-C,o||(s.pending+=s.src.slice(C,a)),!0;for(s.pos=C+2,u=1;s.pos+1<x;){if(126===s.src.charCodeAt(s.pos)&&126===s.src.charCodeAt(s.pos+1)&&(_=s.src.charCodeAt(s.pos-1),126!==(w=s.pos+2<x?s.src.charCodeAt(s.pos+2):-1)&&126!==_&&(32!==_&&10!==_?u--:32!==w&&10!==w&&u++,u<=0))){i=!0;break}s.parser.skipToken(s)}return i?(s.posMax=s.pos,s.pos=C+2,o||(s.push({type:"del_open",level:s.level++}),s.parser.tokenize(s),s.push({type:"del_close",level:--s.level})),s.pos=s.posMax+2,s.posMax=x,!0):(s.pos=C,!1)}],["ins",function ins(s,o){var i,a,u,_,w,x=s.posMax,C=s.pos;if(43!==s.src.charCodeAt(C))return!1;if(o)return!1;if(C+4>=x)return!1;if(43!==s.src.charCodeAt(C+1))return!1;if(s.level>=s.options.maxNesting)return!1;if(_=C>0?s.src.charCodeAt(C-1):-1,w=s.src.charCodeAt(C+2),43===_)return!1;if(43===w)return!1;if(32===w||10===w)return!1;for(a=C+2;a<x&&43===s.src.charCodeAt(a);)a++;if(a!==C+2)return s.pos+=a-C,o||(s.pending+=s.src.slice(C,a)),!0;for(s.pos=C+2,u=1;s.pos+1<x;){if(43===s.src.charCodeAt(s.pos)&&43===s.src.charCodeAt(s.pos+1)&&(_=s.src.charCodeAt(s.pos-1),43!==(w=s.pos+2<x?s.src.charCodeAt(s.pos+2):-1)&&43!==_&&(32!==_&&10!==_?u--:32!==w&&10!==w&&u++,u<=0))){i=!0;break}s.parser.skipToken(s)}return i?(s.posMax=s.pos,s.pos=C+2,o||(s.push({type:"ins_open",level:s.level++}),s.parser.tokenize(s),s.push({type:"ins_close",level:--s.level})),s.pos=s.posMax+2,s.posMax=x,!0):(s.pos=C,!1)}],["mark",function mark(s,o){var i,a,u,_,w,x=s.posMax,C=s.pos;if(61!==s.src.charCodeAt(C))return!1;if(o)return!1;if(C+4>=x)return!1;if(61!==s.src.charCodeAt(C+1))return!1;if(s.level>=s.options.maxNesting)return!1;if(_=C>0?s.src.charCodeAt(C-1):-1,w=s.src.charCodeAt(C+2),61===_)return!1;if(61===w)return!1;if(32===w||10===w)return!1;for(a=C+2;a<x&&61===s.src.charCodeAt(a);)a++;if(a!==C+2)return s.pos+=a-C,o||(s.pending+=s.src.slice(C,a)),!0;for(s.pos=C+2,u=1;s.pos+1<x;){if(61===s.src.charCodeAt(s.pos)&&61===s.src.charCodeAt(s.pos+1)&&(_=s.src.charCodeAt(s.pos-1),61!==(w=s.pos+2<x?s.src.charCodeAt(s.pos+2):-1)&&61!==_&&(32!==_&&10!==_?u--:32!==w&&10!==w&&u++,u<=0))){i=!0;break}s.parser.skipToken(s)}return i?(s.posMax=s.pos,s.pos=C+2,o||(s.push({type:"mark_open",level:s.level++}),s.parser.tokenize(s),s.push({type:"mark_close",level:--s.level})),s.pos=s.posMax+2,s.posMax=x,!0):(s.pos=C,!1)}],["emphasis",function emphasis(s,o){var i,a,u,_,w,x,C,j=s.posMax,L=s.pos,B=s.src.charCodeAt(L);if(95!==B&&42!==B)return!1;if(o)return!1;if(i=(C=scanDelims(s,L)).delims,!C.can_open)return s.pos+=i,o||(s.pending+=s.src.slice(L,s.pos)),!0;if(s.level>=s.options.maxNesting)return!1;for(s.pos=L+i,x=[i];s.pos<j;)if(s.src.charCodeAt(s.pos)!==B)s.parser.skipToken(s);else{if(a=(C=scanDelims(s,s.pos)).delims,C.can_close){for(_=x.pop(),w=a;_!==w;){if(w<_){x.push(_-w);break}if(w-=_,0===x.length)break;s.pos+=_,_=x.pop()}if(0===x.length){i=_,u=!0;break}s.pos+=a;continue}C.can_open&&x.push(a),s.pos+=a}return u?(s.posMax=s.pos,s.pos=L+i,o||(2!==i&&3!==i||s.push({type:"strong_open",level:s.level++}),1!==i&&3!==i||s.push({type:"em_open",level:s.level++}),s.parser.tokenize(s),1!==i&&3!==i||s.push({type:"em_close",level:--s.level}),2!==i&&3!==i||s.push({type:"strong_close",level:--s.level})),s.pos=s.posMax+i,s.posMax=j,!0):(s.pos=L,!1)}],["sub",function sub(s,o){var i,a,u=s.posMax,_=s.pos;if(126!==s.src.charCodeAt(_))return!1;if(o)return!1;if(_+2>=u)return!1;if(s.level>=s.options.maxNesting)return!1;for(s.pos=_+1;s.pos<u;){if(126===s.src.charCodeAt(s.pos)){i=!0;break}s.parser.skipToken(s)}return i&&_+1!==s.pos?(a=s.src.slice(_+1,s.pos)).match(/(^|[^\\])(\\\\)*\s/)?(s.pos=_,!1):(s.posMax=s.pos,s.pos=_+1,o||s.push({type:"sub",level:s.level,content:a.replace(xA,"$1")}),s.pos=s.posMax+1,s.posMax=u,!0):(s.pos=_,!1)}],["sup",function sup(s,o){var i,a,u=s.posMax,_=s.pos;if(94!==s.src.charCodeAt(_))return!1;if(o)return!1;if(_+2>=u)return!1;if(s.level>=s.options.maxNesting)return!1;for(s.pos=_+1;s.pos<u;){if(94===s.src.charCodeAt(s.pos)){i=!0;break}s.parser.skipToken(s)}return i&&_+1!==s.pos?(a=s.src.slice(_+1,s.pos)).match(/(^|[^\\])(\\\\)*\s/)?(s.pos=_,!1):(s.posMax=s.pos,s.pos=_+1,o||s.push({type:"sup",level:s.level,content:a.replace(kA,"$1")}),s.pos=s.posMax+1,s.posMax=u,!0):(s.pos=_,!1)}],["links",function links(s,o){var i,a,u,_,w,x,C,j,L=!1,B=s.pos,$=s.posMax,U=s.pos,V=s.src.charCodeAt(U);if(33===V&&(L=!0,V=s.src.charCodeAt(++U)),91!==V)return!1;if(s.level>=s.options.maxNesting)return!1;if(i=U+1,(a=parseLinkLabel(s,U))<0)return!1;if((x=a+1)<$&&40===s.src.charCodeAt(x)){for(x++;x<$&&(32===(j=s.src.charCodeAt(x))||10===j);x++);if(x>=$)return!1;for(U=x,parseLinkDestination(s,x)?(_=s.linkContent,x=s.pos):_="",U=x;x<$&&(32===(j=s.src.charCodeAt(x))||10===j);x++);if(x<$&&U!==x&&parseLinkTitle(s,x))for(w=s.linkContent,x=s.pos;x<$&&(32===(j=s.src.charCodeAt(x))||10===j);x++);else w="";if(x>=$||41!==s.src.charCodeAt(x))return s.pos=B,!1;x++}else{if(s.linkLevel>0)return!1;for(;x<$&&(32===(j=s.src.charCodeAt(x))||10===j);x++);if(x<$&&91===s.src.charCodeAt(x)&&(U=x+1,(x=parseLinkLabel(s,x))>=0?u=s.src.slice(U,x++):x=U-1),u||(void 0===u&&(x=a+1),u=s.src.slice(i,a)),!(C=s.env.references[normalizeReference(u)]))return s.pos=B,!1;_=C.href,w=C.title}return o||(s.pos=i,s.posMax=a,L?s.push({type:"image",src:_,title:w,alt:s.src.substr(i,a-i),level:s.level}):(s.push({type:"link_open",href:_,title:w,level:s.level++}),s.linkLevel++,s.parser.tokenize(s),s.linkLevel--,s.push({type:"link_close",level:--s.level}))),s.pos=x,s.posMax=$,!0}],["footnote_inline",function footnote_inline(s,o){var i,a,u,_,w=s.posMax,x=s.pos;return!(x+2>=w)&&(94===s.src.charCodeAt(x)&&(91===s.src.charCodeAt(x+1)&&(!(s.level>=s.options.maxNesting)&&(i=x+2,!((a=parseLinkLabel(s,x+1))<0)&&(o||(s.env.footnotes||(s.env.footnotes={}),s.env.footnotes.list||(s.env.footnotes.list=[]),u=s.env.footnotes.list.length,s.pos=i,s.posMax=a,s.push({type:"footnote_ref",id:u,level:s.level}),s.linkLevel++,_=s.tokens.length,s.parser.tokenize(s),s.env.footnotes.list[u]={tokens:s.tokens.splice(_)},s.linkLevel--),s.pos=a+1,s.posMax=w,!0)))))}],["footnote_ref",function footnote_ref(s,o){var i,a,u,_,w=s.posMax,x=s.pos;if(x+3>w)return!1;if(!s.env.footnotes||!s.env.footnotes.refs)return!1;if(91!==s.src.charCodeAt(x))return!1;if(94!==s.src.charCodeAt(x+1))return!1;if(s.level>=s.options.maxNesting)return!1;for(a=x+2;a<w;a++){if(32===s.src.charCodeAt(a))return!1;if(10===s.src.charCodeAt(a))return!1;if(93===s.src.charCodeAt(a))break}return a!==x+2&&(!(a>=w)&&(a++,i=s.src.slice(x+2,a-1),void 0!==s.env.footnotes.refs[":"+i]&&(o||(s.env.footnotes.list||(s.env.footnotes.list=[]),s.env.footnotes.refs[":"+i]<0?(u=s.env.footnotes.list.length,s.env.footnotes.list[u]={label:i,count:0},s.env.footnotes.refs[":"+i]=u):u=s.env.footnotes.refs[":"+i],_=s.env.footnotes.list[u].count,s.env.footnotes.list[u].count++,s.push({type:"footnote_ref",id:u,subId:_,level:s.level})),s.pos=a,s.posMax=w,!0)))}],["autolink",function autolink(s,o){var i,a,u,_,w,x=s.pos;return 60===s.src.charCodeAt(x)&&(!((i=s.src.slice(x)).indexOf(">")<0)&&((a=i.match(CA))?!(OA.indexOf(a[1].toLowerCase())<0)&&(w=normalizeLink(_=a[0].slice(1,-1)),!!s.parser.validateLink(_)&&(o||(s.push({type:"link_open",href:w,level:s.level}),s.push({type:"text",content:_,level:s.level+1}),s.push({type:"link_close",level:s.level})),s.pos+=a[0].length,!0)):!!(u=i.match(AA))&&(w=normalizeLink("mailto:"+(_=u[0].slice(1,-1))),!!s.parser.validateLink(w)&&(o||(s.push({type:"link_open",href:w,level:s.level}),s.push({type:"text",content:_,level:s.level+1}),s.push({type:"link_close",level:s.level})),s.pos+=u[0].length,!0))))}],["htmltag",function htmltag(s,o){var i,a,u,_=s.pos;return!!s.options.html&&(u=s.posMax,!(60!==s.src.charCodeAt(_)||_+2>=u)&&(!(33!==(i=s.src.charCodeAt(_+1))&&63!==i&&47!==i&&!function isLetter$2(s){var o=32|s;return o>=97&&o<=122}(i))&&(!!(a=s.src.slice(_).match(TA))&&(o||s.push({type:"htmltag",content:s.src.slice(_,_+a[0].length),level:s.level}),s.pos+=a[0].length,!0))))}],["entity",function entity(s,o){var i,a,u=s.pos,_=s.posMax;if(38!==s.src.charCodeAt(u))return!1;if(u+1<_)if(35===s.src.charCodeAt(u+1)){if(a=s.src.slice(u).match(NA))return o||(i="x"===a[1][0].toLowerCase()?parseInt(a[1].slice(1),16):parseInt(a[1],10),s.pending+=isValidEntityCode(i)?fromCodePoint(i):fromCodePoint(65533)),s.pos+=a[0].length,!0}else if(a=s.src.slice(u).match(MA)){var w=decodeEntity(a[1]);if(a[1]!==w)return o||(s.pending+=w),s.pos+=a[0].length,!0}return o||(s.pending+="&"),s.pos++,!0}]];function ParserInline(){this.ruler=new Ruler;for(var s=0;s<RA.length;s++)this.ruler.push(RA[s][0],RA[s][1]);this.validateLink=validateLink}function validateLink(s){var o=s.trim().toLowerCase();return-1===(o=replaceEntities(o)).indexOf(":")||-1===["vbscript","javascript","file","data"].indexOf(o.split(":")[0])}ParserInline.prototype.skipToken=function(s){var o,i,a=this.ruler.getRules(""),u=a.length,_=s.pos;if((i=s.cacheGet(_))>0)s.pos=i;else{for(o=0;o<u;o++)if(a[o](s,!0))return void s.cacheSet(_,s.pos);s.pos++,s.cacheSet(_,s.pos)}},ParserInline.prototype.tokenize=function(s){for(var o,i,a=this.ruler.getRules(""),u=a.length,_=s.posMax;s.pos<_;){for(i=0;i<u&&!(o=a[i](s,!1));i++);if(o){if(s.pos>=_)break}else s.pending+=s.src[s.pos++]}s.pending&&s.pushPending()},ParserInline.prototype.parse=function(s,o,i,a){var u=new StateInline(s,this,o,i,a);this.tokenize(u)};var DA={default:{options:{html:!1,xhtmlOut:!1,breaks:!1,langPrefix:"language-",linkTarget:"",typographer:!1,quotes:"“”‘’",highlight:null,maxNesting:20},components:{core:{rules:["block","inline","references","replacements","smartquotes","references","abbr2","footnote_tail"]},block:{rules:["blockquote","code","fences","footnote","heading","hr","htmlblock","lheading","list","paragraph","table"]},inline:{rules:["autolink","backticks","del","emphasis","entity","escape","footnote_ref","htmltag","links","newline","text"]}}},full:{options:{html:!1,xhtmlOut:!1,breaks:!1,langPrefix:"language-",linkTarget:"",typographer:!1,quotes:"“”‘’",highlight:null,maxNesting:20},components:{core:{},block:{},inline:{}}},commonmark:{options:{html:!0,xhtmlOut:!0,breaks:!1,langPrefix:"language-",linkTarget:"",typographer:!1,quotes:"“”‘’",highlight:null,maxNesting:20},components:{core:{rules:["block","inline","references","abbr2"]},block:{rules:["blockquote","code","fences","heading","hr","htmlblock","lheading","list","paragraph"]},inline:{rules:["autolink","backticks","emphasis","entity","escape","htmltag","links","newline","text"]}}}};function StateCore(s,o,i){this.src=o,this.env=i,this.options=s.options,this.tokens=[],this.inlineMode=!1,this.inline=s.inline,this.block=s.block,this.renderer=s.renderer,this.typographer=s.typographer}function Remarkable(s,o){"string"!=typeof s&&(o=s,s="default"),o&&null!=o.linkify&&console.warn("linkify option is removed. Use linkify plugin instead:\n\nimport Remarkable from 'remarkable';\nimport linkify from 'remarkable/linkify';\nnew Remarkable().use(linkify)\n"),this.inline=new ParserInline,this.block=new ParserBlock,this.core=new Core,this.renderer=new Renderer,this.ruler=new Ruler,this.options={},this.configure(DA[s]),this.set(o||{})}Remarkable.prototype.set=function(s){index_browser_assign(this.options,s)},Remarkable.prototype.configure=function(s){var o=this;if(!s)throw new Error("Wrong `remarkable` preset, check name/content");s.options&&o.set(s.options),s.components&&Object.keys(s.components).forEach((function(i){s.components[i].rules&&o[i].ruler.enable(s.components[i].rules,!0)}))},Remarkable.prototype.use=function(s,o){return s(this,o),this},Remarkable.prototype.parse=function(s,o){var i=new StateCore(this,s,o);return this.core.process(i),i.tokens},Remarkable.prototype.render=function(s,o){return o=o||{},this.renderer.render(this.parse(s,o),this.options,o)},Remarkable.prototype.parseInline=function(s,o){var i=new StateCore(this,s,o);return i.inlineMode=!0,this.core.process(i),i.tokens},Remarkable.prototype.renderInline=function(s,o){return o=o||{},this.renderer.render(this.parseInline(s,o),this.options,o)};function indexOf(s,o){if(Array.prototype.indexOf)return s.indexOf(o);for(var i=0,a=s.length;i<a;i++)if(s[i]===o)return i;return-1}function utils_remove(s,o){for(var i=s.length-1;i>=0;i--)!0===o(s[i])&&s.splice(i,1)}function throwUnhandledCaseError(s){throw new Error("Unhandled case for value: '".concat(s,"'"))}var LA=function(){function HtmlTag(s){void 0===s&&(s={}),this.tagName="",this.attrs={},this.innerHTML="",this.whitespaceRegex=/\s+/,this.tagName=s.tagName||"",this.attrs=s.attrs||{},this.innerHTML=s.innerHtml||s.innerHTML||""}return HtmlTag.prototype.setTagName=function(s){return this.tagName=s,this},HtmlTag.prototype.getTagName=function(){return this.tagName||""},HtmlTag.prototype.setAttr=function(s,o){return this.getAttrs()[s]=o,this},HtmlTag.prototype.getAttr=function(s){return this.getAttrs()[s]},HtmlTag.prototype.setAttrs=function(s){return Object.assign(this.getAttrs(),s),this},HtmlTag.prototype.getAttrs=function(){return this.attrs||(this.attrs={})},HtmlTag.prototype.setClass=function(s){return this.setAttr("class",s)},HtmlTag.prototype.addClass=function(s){for(var o,i=this.getClass(),a=this.whitespaceRegex,u=i?i.split(a):[],_=s.split(a);o=_.shift();)-1===indexOf(u,o)&&u.push(o);return this.getAttrs().class=u.join(" "),this},HtmlTag.prototype.removeClass=function(s){for(var o,i=this.getClass(),a=this.whitespaceRegex,u=i?i.split(a):[],_=s.split(a);u.length&&(o=_.shift());){var w=indexOf(u,o);-1!==w&&u.splice(w,1)}return this.getAttrs().class=u.join(" "),this},HtmlTag.prototype.getClass=function(){return this.getAttrs().class||""},HtmlTag.prototype.hasClass=function(s){return-1!==(" "+this.getClass()+" ").indexOf(" "+s+" ")},HtmlTag.prototype.setInnerHTML=function(s){return this.innerHTML=s,this},HtmlTag.prototype.setInnerHtml=function(s){return this.setInnerHTML(s)},HtmlTag.prototype.getInnerHTML=function(){return this.innerHTML||""},HtmlTag.prototype.getInnerHtml=function(){return this.getInnerHTML()},HtmlTag.prototype.toAnchorString=function(){var s=this.getTagName(),o=this.buildAttrsStr();return["<",s,o=o?" "+o:"",">",this.getInnerHtml(),"</",s,">"].join("")},HtmlTag.prototype.buildAttrsStr=function(){if(!this.attrs)return"";var s=this.getAttrs(),o=[];for(var i in s)s.hasOwnProperty(i)&&o.push(i+'="'+s[i]+'"');return o.join(" ")},HtmlTag}();var FA=function(){function AnchorTagBuilder(s){void 0===s&&(s={}),this.newWindow=!1,this.truncate={},this.className="",this.newWindow=s.newWindow||!1,this.truncate=s.truncate||{},this.className=s.className||""}return AnchorTagBuilder.prototype.build=function(s){return new LA({tagName:"a",attrs:this.createAttrs(s),innerHtml:this.processAnchorText(s.getAnchorText())})},AnchorTagBuilder.prototype.createAttrs=function(s){var o={href:s.getAnchorHref()},i=this.createCssClass(s);return i&&(o.class=i),this.newWindow&&(o.target="_blank",o.rel="noopener noreferrer"),this.truncate&&this.truncate.length&&this.truncate.length<s.getAnchorText().length&&(o.title=s.getAnchorHref()),o},AnchorTagBuilder.prototype.createCssClass=function(s){var o=this.className;if(o){for(var i=[o],a=s.getCssClassSuffixes(),u=0,_=a.length;u<_;u++)i.push(o+"-"+a[u]);return i.join(" ")}return""},AnchorTagBuilder.prototype.processAnchorText=function(s){return s=this.doTruncate(s)},AnchorTagBuilder.prototype.doTruncate=function(s){var o=this.truncate;if(!o||!o.length)return s;var i=o.length,a=o.location;return"smart"===a?function truncateSmart(s,o,i){var a,u;null==i?(i="&hellip;",u=3,a=8):(u=i.length,a=i.length);var buildUrl=function(s){var o="";return s.scheme&&s.host&&(o+=s.scheme+"://"),s.host&&(o+=s.host),s.path&&(o+="/"+s.path),s.query&&(o+="?"+s.query),s.fragment&&(o+="#"+s.fragment),o},buildSegment=function(s,o){var a=o/2,u=Math.ceil(a),_=-1*Math.floor(a),w="";return _<0&&(w=s.substr(_)),s.substr(0,u)+i+w};if(s.length<=o)return s;var _=o-u,w=function(s){var o={},i=s,a=i.match(/^([a-z]+):\/\//i);return a&&(o.scheme=a[1],i=i.substr(a[0].length)),(a=i.match(/^(.*?)(?=(\?|#|\/|$))/i))&&(o.host=a[1],i=i.substr(a[0].length)),(a=i.match(/^\/(.*?)(?=(\?|#|$))/i))&&(o.path=a[1],i=i.substr(a[0].length)),(a=i.match(/^\?(.*?)(?=(#|$))/i))&&(o.query=a[1],i=i.substr(a[0].length)),(a=i.match(/^#(.*?)$/i))&&(o.fragment=a[1]),o}(s);if(w.query){var x=w.query.match(/^(.*?)(?=(\?|\#))(.*?)$/i);x&&(w.query=w.query.substr(0,x[1].length),s=buildUrl(w))}if(s.length<=o)return s;if(w.host&&(w.host=w.host.replace(/^www\./,""),s=buildUrl(w)),s.length<=o)return s;var C="";if(w.host&&(C+=w.host),C.length>=_)return w.host.length==o?(w.host.substr(0,o-u)+i).substr(0,_+a):buildSegment(C,_).substr(0,_+a);var j="";if(w.path&&(j+="/"+w.path),w.query&&(j+="?"+w.query),j){if((C+j).length>=_)return(C+j).length==o?(C+j).substr(0,o):(C+buildSegment(j,_-C.length)).substr(0,_+a);C+=j}if(w.fragment){var L="#"+w.fragment;if((C+L).length>=_)return(C+L).length==o?(C+L).substr(0,o):(C+buildSegment(L,_-C.length)).substr(0,_+a);C+=L}if(w.scheme&&w.host){var B=w.scheme+"://";if((C+B).length<_)return(B+C).substr(0,o)}if(C.length<=o)return C;var $="";return _>0&&($=C.substr(-1*Math.floor(_/2))),(C.substr(0,Math.ceil(_/2))+i+$).substr(0,_+a)}(s,i):"middle"===a?function truncateMiddle(s,o,i){if(s.length<=o)return s;var a,u;null==i?(i="&hellip;",a=8,u=3):(a=i.length,u=i.length);var _=o-u,w="";return _>0&&(w=s.substr(-1*Math.floor(_/2))),(s.substr(0,Math.ceil(_/2))+i+w).substr(0,_+a)}(s,i):function truncateEnd(s,o,i){return function ellipsis(s,o,i){var a;return s.length>o&&(null==i?(i="&hellip;",a=3):a=i.length,s=s.substring(0,o-a)+i),s}(s,o,i)}(s,i)},AnchorTagBuilder}(),BA=function(){function Match(s){this.__jsduckDummyDocProp=null,this.matchedText="",this.offset=0,this.tagBuilder=s.tagBuilder,this.matchedText=s.matchedText,this.offset=s.offset}return Match.prototype.getMatchedText=function(){return this.matchedText},Match.prototype.setOffset=function(s){this.offset=s},Match.prototype.getOffset=function(){return this.offset},Match.prototype.getCssClassSuffixes=function(){return[this.getType()]},Match.prototype.buildTag=function(){return this.tagBuilder.build(this)},Match}(),extendStatics=function(s,o){return extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(s,o){s.__proto__=o}||function(s,o){for(var i in o)Object.prototype.hasOwnProperty.call(o,i)&&(s[i]=o[i])},extendStatics(s,o)};function tslib_es6_extends(s,o){if("function"!=typeof o&&null!==o)throw new TypeError("Class extends value "+String(o)+" is not a constructor or null");function __(){this.constructor=s}extendStatics(s,o),s.prototype=null===o?Object.create(o):(__.prototype=o.prototype,new __)}var __assign=function(){return __assign=Object.assign||function __assign(s){for(var o,i=1,a=arguments.length;i<a;i++)for(var u in o=arguments[i])Object.prototype.hasOwnProperty.call(o,u)&&(s[u]=o[u]);return s},__assign.apply(this,arguments)};Object.create;Object.create;"function"==typeof SuppressedError&&SuppressedError;var $A,qA=function(s){function EmailMatch(o){var i=s.call(this,o)||this;return i.email="",i.email=o.email,i}return tslib_es6_extends(EmailMatch,s),EmailMatch.prototype.getType=function(){return"email"},EmailMatch.prototype.getEmail=function(){return this.email},EmailMatch.prototype.getAnchorHref=function(){return"mailto:"+this.email},EmailMatch.prototype.getAnchorText=function(){return this.email},EmailMatch}(BA),UA=function(s){function HashtagMatch(o){var i=s.call(this,o)||this;return i.serviceName="",i.hashtag="",i.serviceName=o.serviceName,i.hashtag=o.hashtag,i}return tslib_es6_extends(HashtagMatch,s),HashtagMatch.prototype.getType=function(){return"hashtag"},HashtagMatch.prototype.getServiceName=function(){return this.serviceName},HashtagMatch.prototype.getHashtag=function(){return this.hashtag},HashtagMatch.prototype.getAnchorHref=function(){var s=this.serviceName,o=this.hashtag;switch(s){case"twitter":return"https://twitter.com/hashtag/"+o;case"facebook":return"https://www.facebook.com/hashtag/"+o;case"instagram":return"https://instagram.com/explore/tags/"+o;case"tiktok":return"https://www.tiktok.com/tag/"+o;default:throw new Error("Unknown service name to point hashtag to: "+s)}},HashtagMatch.prototype.getAnchorText=function(){return"#"+this.hashtag},HashtagMatch}(BA),VA=function(s){function MentionMatch(o){var i=s.call(this,o)||this;return i.serviceName="twitter",i.mention="",i.mention=o.mention,i.serviceName=o.serviceName,i}return tslib_es6_extends(MentionMatch,s),MentionMatch.prototype.getType=function(){return"mention"},MentionMatch.prototype.getMention=function(){return this.mention},MentionMatch.prototype.getServiceName=function(){return this.serviceName},MentionMatch.prototype.getAnchorHref=function(){switch(this.serviceName){case"twitter":return"https://twitter.com/"+this.mention;case"instagram":return"https://instagram.com/"+this.mention;case"soundcloud":return"https://soundcloud.com/"+this.mention;case"tiktok":return"https://www.tiktok.com/@"+this.mention;default:throw new Error("Unknown service name to point mention to: "+this.serviceName)}},MentionMatch.prototype.getAnchorText=function(){return"@"+this.mention},MentionMatch.prototype.getCssClassSuffixes=function(){var o=s.prototype.getCssClassSuffixes.call(this),i=this.getServiceName();return i&&o.push(i),o},MentionMatch}(BA),zA=function(s){function PhoneMatch(o){var i=s.call(this,o)||this;return i.number="",i.plusSign=!1,i.number=o.number,i.plusSign=o.plusSign,i}return tslib_es6_extends(PhoneMatch,s),PhoneMatch.prototype.getType=function(){return"phone"},PhoneMatch.prototype.getPhoneNumber=function(){return this.number},PhoneMatch.prototype.getNumber=function(){return this.getPhoneNumber()},PhoneMatch.prototype.getAnchorHref=function(){return"tel:"+(this.plusSign?"+":"")+this.number},PhoneMatch.prototype.getAnchorText=function(){return this.matchedText},PhoneMatch}(BA),WA=function(s){function UrlMatch(o){var i=s.call(this,o)||this;return i.url="",i.urlMatchType="scheme",i.protocolUrlMatch=!1,i.protocolRelativeMatch=!1,i.stripPrefix={scheme:!0,www:!0},i.stripTrailingSlash=!0,i.decodePercentEncoding=!0,i.schemePrefixRegex=/^(https?:\/\/)?/i,i.wwwPrefixRegex=/^(https?:\/\/)?(www\.)?/i,i.protocolRelativeRegex=/^\/\//,i.protocolPrepended=!1,i.urlMatchType=o.urlMatchType,i.url=o.url,i.protocolUrlMatch=o.protocolUrlMatch,i.protocolRelativeMatch=o.protocolRelativeMatch,i.stripPrefix=o.stripPrefix,i.stripTrailingSlash=o.stripTrailingSlash,i.decodePercentEncoding=o.decodePercentEncoding,i}return tslib_es6_extends(UrlMatch,s),UrlMatch.prototype.getType=function(){return"url"},UrlMatch.prototype.getUrlMatchType=function(){return this.urlMatchType},UrlMatch.prototype.getUrl=function(){var s=this.url;return this.protocolRelativeMatch||this.protocolUrlMatch||this.protocolPrepended||(s=this.url="http://"+s,this.protocolPrepended=!0),s},UrlMatch.prototype.getAnchorHref=function(){return this.getUrl().replace(/&amp;/g,"&")},UrlMatch.prototype.getAnchorText=function(){var s=this.getMatchedText();return this.protocolRelativeMatch&&(s=this.stripProtocolRelativePrefix(s)),this.stripPrefix.scheme&&(s=this.stripSchemePrefix(s)),this.stripPrefix.www&&(s=this.stripWwwPrefix(s)),this.stripTrailingSlash&&(s=this.removeTrailingSlash(s)),this.decodePercentEncoding&&(s=this.removePercentEncoding(s)),s},UrlMatch.prototype.stripSchemePrefix=function(s){return s.replace(this.schemePrefixRegex,"")},UrlMatch.prototype.stripWwwPrefix=function(s){return s.replace(this.wwwPrefixRegex,"$1")},UrlMatch.prototype.stripProtocolRelativePrefix=function(s){return s.replace(this.protocolRelativeRegex,"")},UrlMatch.prototype.removeTrailingSlash=function(s){return"/"===s.charAt(s.length-1)&&(s=s.slice(0,-1)),s},UrlMatch.prototype.removePercentEncoding=function(s){var o=s.replace(/%22/gi,"&quot;").replace(/%26/gi,"&amp;").replace(/%27/gi,"&#39;").replace(/%3C/gi,"&lt;").replace(/%3E/gi,"&gt;");try{return decodeURIComponent(o)}catch(s){return o}},UrlMatch}(BA),JA=function JA(s){this.__jsduckDummyDocProp=null,this.tagBuilder=s.tagBuilder},HA=/[A-Za-z]/,KA=/[\d]/,GA=/[\D]/,YA=/\s/,XA=/['"]/,QA=/[\x00-\x1F\x7F]/,ZA=/A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC/.source,eC=ZA+/\u2700-\u27bf\udde6-\uddff\ud800-\udbff\udc00-\udfff\ufe0e\ufe0f\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0\ud83c\udffb-\udfff\u200d\u3299\u3297\u303d\u3030\u24c2\ud83c\udd70-\udd71\udd7e-\udd7f\udd8e\udd91-\udd9a\udde6-\uddff\ude01-\ude02\ude1a\ude2f\ude32-\ude3a\ude50-\ude51\u203c\u2049\u25aa-\u25ab\u25b6\u25c0\u25fb-\u25fe\u00a9\u00ae\u2122\u2139\udc04\u2600-\u26FF\u2b05\u2b06\u2b07\u2b1b\u2b1c\u2b50\u2b55\u231a\u231b\u2328\u23cf\u23e9-\u23f3\u23f8-\u23fa\udccf\u2935\u2934\u2190-\u21ff/.source+/\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D01-\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F/.source,tC=/0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19/.source,rC=eC+tC,nC=eC+tC,sC=new RegExp("[".concat(nC,"]")),oC="(?:["+tC+"]{1,3}\\.){3}["+tC+"]{1,3}",iC="["+nC+"](?:["+nC+"\\-_]{0,61}["+nC+"])?",getDomainLabelStr=function(s){return"(?=("+iC+"))\\"+s},getDomainNameStr=function(s){return"(?:"+getDomainLabelStr(s)+"(?:\\."+getDomainLabelStr(s+1)+"){0,126}|"+oC+")"},aC=(new RegExp("["+nC+".\\-]*["+nC+"\\-]"),sC),cC=/(?:xn--vermgensberatung-pwb|xn--vermgensberater-ctb|xn--clchc0ea0b2g2a9gcd|xn--w4r85el8fhu5dnra|northwesternmutual|travelersinsurance|vermögensberatung|xn--5su34j936bgsg|xn--bck1b9a5dre4c|xn--mgbah1a3hjkrd|xn--mgbai9azgqp6j|xn--mgberp4a5d4ar|xn--xkc2dl3a5ee0h|vermögensberater|xn--fzys8d69uvgm|xn--mgba7c0bbn0a|xn--mgbcpq6gpa1a|xn--xkc2al3hye2a|americanexpress|kerryproperties|sandvikcoromant|xn--i1b6b1a6a2e|xn--kcrx77d1x4a|xn--lgbbat1ad8j|xn--mgba3a4f16a|xn--mgbaakc7dvf|xn--mgbc0a9azcg|xn--nqv7fs00ema|americanfamily|bananarepublic|cancerresearch|cookingchannel|kerrylogistics|weatherchannel|xn--54b7fta0cc|xn--6qq986b3xl|xn--80aqecdr1a|xn--b4w605ferd|xn--fiq228c5hs|xn--h2breg3eve|xn--jlq480n2rg|xn--jlq61u9w7b|xn--mgba3a3ejt|xn--mgbaam7a8h|xn--mgbayh7gpa|xn--mgbbh1a71e|xn--mgbca7dzdo|xn--mgbi4ecexp|xn--mgbx4cd0ab|xn--rvc1e0am3e|international|lifeinsurance|travelchannel|wolterskluwer|xn--cckwcxetd|xn--eckvdtc9d|xn--fpcrj9c3d|xn--fzc2c9e2c|xn--h2brj9c8c|xn--tiq49xqyj|xn--yfro4i67o|xn--ygbi2ammx|construction|lplfinancial|scholarships|versicherung|xn--3e0b707e|xn--45br5cyl|xn--4dbrk0ce|xn--80adxhks|xn--80asehdb|xn--8y0a063a|xn--gckr3f0f|xn--mgb9awbf|xn--mgbab2bd|xn--mgbgu82a|xn--mgbpl2fh|xn--mgbt3dhd|xn--mk1bu44c|xn--ngbc5azd|xn--ngbe9e0a|xn--ogbpf8fl|xn--qcka1pmc|accountants|barclaycard|blackfriday|blockbuster|bridgestone|calvinklein|contractors|creditunion|engineering|enterprises|foodnetwork|investments|kerryhotels|lamborghini|motorcycles|olayangroup|photography|playstation|productions|progressive|redumbrella|williamhill|xn--11b4c3d|xn--1ck2e1b|xn--1qqw23a|xn--2scrj9c|xn--3bst00m|xn--3ds443g|xn--3hcrj9c|xn--42c2d9a|xn--45brj9c|xn--55qw42g|xn--6frz82g|xn--80ao21a|xn--9krt00a|xn--cck2b3b|xn--czr694b|xn--d1acj3b|xn--efvy88h|xn--fct429k|xn--fjq720a|xn--flw351e|xn--g2xx48c|xn--gecrj9c|xn--gk3at1e|xn--h2brj9c|xn--hxt814e|xn--imr513n|xn--j6w193g|xn--jvr189m|xn--kprw13d|xn--kpry57d|xn--mgbbh1a|xn--mgbtx2b|xn--mix891f|xn--nyqy26a|xn--otu796d|xn--pgbs0dh|xn--q9jyb4c|xn--rhqv96g|xn--rovu88b|xn--s9brj9c|xn--ses554g|xn--t60b56a|xn--vuq861b|xn--w4rs40l|xn--xhq521b|xn--zfr164b|சிங்கப்பூர்|accountant|apartments|associates|basketball|bnpparibas|boehringer|capitalone|consulting|creditcard|cuisinella|eurovision|extraspace|foundation|healthcare|immobilien|industries|management|mitsubishi|nextdirect|properties|protection|prudential|realestate|republican|restaurant|schaeffler|tatamotors|technology|university|vlaanderen|volkswagen|xn--30rr7y|xn--3pxu8k|xn--45q11c|xn--4gbrim|xn--55qx5d|xn--5tzm5g|xn--80aswg|xn--90a3ac|xn--9dbq2a|xn--9et52u|xn--c2br7g|xn--cg4bki|xn--czrs0t|xn--czru2d|xn--fiq64b|xn--fiqs8s|xn--fiqz9s|xn--io0a7i|xn--kput3i|xn--mxtq1m|xn--o3cw4h|xn--pssy2u|xn--q7ce6a|xn--unup4y|xn--wgbh1c|xn--wgbl6a|xn--y9a3aq|accenture|alfaromeo|allfinanz|amsterdam|analytics|aquarelle|barcelona|bloomberg|christmas|community|directory|education|equipment|fairwinds|financial|firestone|fresenius|frontdoor|furniture|goldpoint|hisamitsu|homedepot|homegoods|homesense|institute|insurance|kuokgroup|lancaster|landrover|lifestyle|marketing|marshalls|melbourne|microsoft|panasonic|passagens|pramerica|richardli|shangrila|solutions|statebank|statefarm|stockholm|travelers|vacations|xn--90ais|xn--c1avg|xn--d1alf|xn--e1a4c|xn--fhbei|xn--j1aef|xn--j1amh|xn--l1acc|xn--ngbrx|xn--nqv7f|xn--p1acf|xn--qxa6a|xn--tckwe|xn--vhquv|yodobashi|موريتانيا|abudhabi|airforce|allstate|attorney|barclays|barefoot|bargains|baseball|boutique|bradesco|broadway|brussels|builders|business|capetown|catering|catholic|cipriani|cityeats|cleaning|clinique|clothing|commbank|computer|delivery|deloitte|democrat|diamonds|discount|discover|download|engineer|ericsson|etisalat|exchange|feedback|fidelity|firmdale|football|frontier|goodyear|grainger|graphics|guardian|hdfcbank|helsinki|holdings|hospital|infiniti|ipiranga|istanbul|jpmorgan|lighting|lundbeck|marriott|maserati|mckinsey|memorial|merckmsd|mortgage|observer|partners|pharmacy|pictures|plumbing|property|redstone|reliance|saarland|samsclub|security|services|shopping|showtime|softbank|software|stcgroup|supplies|training|vanguard|ventures|verisign|woodside|xn--90ae|xn--node|xn--p1ai|xn--qxam|yokohama|السعودية|abogado|academy|agakhan|alibaba|android|athleta|auction|audible|auspost|avianca|banamex|bauhaus|bentley|bestbuy|booking|brother|bugatti|capital|caravan|careers|channel|charity|chintai|citadel|clubmed|college|cologne|comcast|company|compare|contact|cooking|corsica|country|coupons|courses|cricket|cruises|dentist|digital|domains|exposed|express|farmers|fashion|ferrari|ferrero|finance|fishing|fitness|flights|florist|flowers|forsale|frogans|fujitsu|gallery|genting|godaddy|grocery|guitars|hamburg|hangout|hitachi|holiday|hosting|hoteles|hotmail|hyundai|ismaili|jewelry|juniper|kitchen|komatsu|lacaixa|lanxess|lasalle|latrobe|leclerc|limited|lincoln|markets|monster|netbank|netflix|network|neustar|okinawa|oldnavy|organic|origins|philips|pioneer|politie|realtor|recipes|rentals|reviews|rexroth|samsung|sandvik|schmidt|schwarz|science|shiksha|singles|staples|storage|support|surgery|systems|temasek|theater|theatre|tickets|tiffany|toshiba|trading|walmart|wanggou|watches|weather|website|wedding|whoswho|windows|winners|xfinity|yamaxun|youtube|zuerich|католик|اتصالات|البحرين|الجزائر|العليان|پاکستان|كاثوليك|இந்தியா|abarth|abbott|abbvie|africa|agency|airbus|airtel|alipay|alsace|alstom|amazon|anquan|aramco|author|bayern|beauty|berlin|bharti|bostik|boston|broker|camera|career|casino|center|chanel|chrome|church|circle|claims|clinic|coffee|comsec|condos|coupon|credit|cruise|dating|datsun|dealer|degree|dental|design|direct|doctor|dunlop|dupont|durban|emerck|energy|estate|events|expert|family|flickr|futbol|gallup|garden|george|giving|global|google|gratis|health|hermes|hiphop|hockey|hotels|hughes|imamat|insure|intuit|jaguar|joburg|juegos|kaufen|kinder|kindle|kosher|lancia|latino|lawyer|lefrak|living|locker|london|luxury|madrid|maison|makeup|market|mattel|mobile|monash|mormon|moscow|museum|mutual|nagoya|natura|nissan|nissay|norton|nowruz|office|olayan|online|oracle|orange|otsuka|pfizer|photos|physio|pictet|quebec|racing|realty|reisen|repair|report|review|rocher|rogers|ryukyu|safety|sakura|sanofi|school|schule|search|secure|select|shouji|soccer|social|stream|studio|supply|suzuki|swatch|sydney|taipei|taobao|target|tattoo|tennis|tienda|tjmaxx|tkmaxx|toyota|travel|unicom|viajes|viking|villas|virgin|vision|voting|voyage|vuelos|walter|webcam|xihuan|yachts|yandex|zappos|москва|онлайн|ابوظبي|ارامكو|الاردن|المغرب|امارات|فلسطين|مليسيا|भारतम्|இலங்கை|ファッション|actor|adult|aetna|amfam|amica|apple|archi|audio|autos|azure|baidu|beats|bible|bingo|black|boats|bosch|build|canon|cards|chase|cheap|cisco|citic|click|cloud|coach|codes|crown|cymru|dabur|dance|deals|delta|drive|dubai|earth|edeka|email|epson|faith|fedex|final|forex|forum|gallo|games|gifts|gives|glass|globo|gmail|green|gripe|group|gucci|guide|homes|honda|horse|house|hyatt|ikano|irish|jetzt|koeln|kyoto|lamer|lease|legal|lexus|lilly|linde|lipsy|loans|locus|lotte|lotto|macys|mango|media|miami|money|movie|music|nexus|nikon|ninja|nokia|nowtv|omega|osaka|paris|parts|party|phone|photo|pizza|place|poker|praxi|press|prime|promo|quest|radio|rehab|reise|ricoh|rocks|rodeo|rugby|salon|sener|seven|sharp|shell|shoes|skype|sling|smart|smile|solar|space|sport|stada|store|study|style|sucks|swiss|tatar|tires|tirol|tmall|today|tokyo|tools|toray|total|tours|trade|trust|tunes|tushu|ubank|vegas|video|vodka|volvo|wales|watch|weber|weibo|works|world|xerox|yahoo|ישראל|ایران|بازار|بھارت|سودان|سورية|همراه|भारोत|संगठन|বাংলা|భారత్|ഭാരതം|嘉里大酒店|aarp|able|adac|aero|akdn|ally|amex|arab|army|arpa|arte|asda|asia|audi|auto|baby|band|bank|bbva|beer|best|bike|bing|blog|blue|bofa|bond|book|buzz|cafe|call|camp|care|cars|casa|case|cash|cbre|cern|chat|citi|city|club|cool|coop|cyou|data|date|dclk|deal|dell|desi|diet|dish|docs|dvag|erni|fage|fail|fans|farm|fast|fiat|fido|film|fire|fish|flir|food|ford|free|fund|game|gbiz|gent|ggee|gift|gmbh|gold|golf|goog|guge|guru|hair|haus|hdfc|help|here|hgtv|host|hsbc|icbc|ieee|imdb|immo|info|itau|java|jeep|jobs|jprs|kddi|kids|kiwi|kpmg|kred|land|lego|lgbt|lidl|life|like|limo|link|live|loan|loft|love|ltda|luxe|maif|meet|meme|menu|mini|mint|mobi|moda|moto|name|navy|news|next|nico|nike|ollo|open|page|pars|pccw|pics|ping|pink|play|plus|pohl|porn|post|prod|prof|qpon|read|reit|rent|rest|rich|room|rsvp|ruhr|safe|sale|sarl|save|saxo|scot|seat|seek|sexy|shaw|shia|shop|show|silk|sina|site|skin|sncf|sohu|song|sony|spot|star|surf|talk|taxi|team|tech|teva|tiaa|tips|town|toys|tube|vana|visa|viva|vivo|vote|voto|wang|weir|wien|wiki|wine|work|xbox|yoga|zara|zero|zone|дети|сайт|بارت|بيتك|ڀارت|تونس|شبكة|عراق|عمان|موقع|भारत|ভারত|ভাৰত|ਭਾਰਤ|ભારત|ଭାରତ|ಭಾರತ|ලංකා|アマゾン|グーグル|クラウド|ポイント|组织机构|電訊盈科|香格里拉|aaa|abb|abc|aco|ads|aeg|afl|aig|anz|aol|app|art|aws|axa|bar|bbc|bbt|bcg|bcn|bet|bid|bio|biz|bms|bmw|bom|boo|bot|box|buy|bzh|cab|cal|cam|car|cat|cba|cbn|cbs|ceo|cfa|cfd|com|cpa|crs|dad|day|dds|dev|dhl|diy|dnp|dog|dot|dtv|dvr|eat|eco|edu|esq|eus|fan|fit|fly|foo|fox|frl|ftr|fun|fyi|gal|gap|gay|gdn|gea|gle|gmo|gmx|goo|gop|got|gov|hbo|hiv|hkt|hot|how|ibm|ice|icu|ifm|inc|ing|ink|int|ist|itv|jcb|jio|jll|jmp|jnj|jot|joy|kfh|kia|kim|kpn|krd|lat|law|lds|llc|llp|lol|lpl|ltd|man|map|mba|med|men|mil|mit|mlb|mls|mma|moe|moi|mom|mov|msd|mtn|mtr|nab|nba|nec|net|new|nfl|ngo|nhk|now|nra|nrw|ntt|nyc|obi|one|ong|onl|ooo|org|ott|ovh|pay|pet|phd|pid|pin|pnc|pro|pru|pub|pwc|red|ren|ril|rio|rip|run|rwe|sap|sas|sbi|sbs|sca|scb|ses|sew|sex|sfr|ski|sky|soy|spa|srl|stc|tab|tax|tci|tdk|tel|thd|tjx|top|trv|tui|tvs|ubs|uno|uol|ups|vet|vig|vin|vip|wed|win|wme|wow|wtc|wtf|xin|xxx|xyz|you|yun|zip|бел|ком|қаз|мкд|мон|орг|рус|срб|укр|հայ|קום|عرب|قطر|كوم|مصر|कॉम|नेट|คอม|ไทย|ລາວ|ストア|セール|みんな|中文网|亚马逊|天主教|我爱你|新加坡|淡马锡|诺基亚|飞利浦|ac|ad|ae|af|ag|ai|al|am|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cw|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|ss|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw|ελ|ευ|бг|ею|рф|გე|닷넷|닷컴|삼성|한국|コム|世界|中信|中国|中國|企业|佛山|信息|健康|八卦|公司|公益|台湾|台灣|商城|商店|商标|嘉里|在线|大拿|娱乐|家電|广东|微博|慈善|手机|招聘|政务|政府|新闻|时尚|書籍|机构|游戏|澳門|点看|移动|网址|网店|网站|网络|联通|谷歌|购物|通販|集团|食品|餐厅|香港)/,lC=new RegExp("[".concat(nC,"!#$%&'*+/=?^_`{|}~-]")),uC=new RegExp("^".concat(cC.source,"$")),pC=function(s){function EmailMatcher(){var o=null!==s&&s.apply(this,arguments)||this;return o.localPartCharRegex=lC,o.strictTldRegex=uC,o}return tslib_es6_extends(EmailMatcher,s),EmailMatcher.prototype.parseMatches=function(s){for(var o=this.tagBuilder,i=this.localPartCharRegex,a=this.strictTldRegex,u=[],_=s.length,w=new hC,x={m:"a",a:"i",i:"l",l:"t",t:"o",o:":"},C=0,j=0,L=w;C<_;){var B=s.charAt(C);switch(j){case 0:stateNonEmailAddress(B);break;case 1:stateMailTo(s.charAt(C-1),B);break;case 2:stateLocalPart(B);break;case 3:stateLocalPartDot(B);break;case 4:stateAtSign(B);break;case 5:stateDomainChar(B);break;case 6:stateDomainHyphen(B);break;case 7:stateDomainDot(B);break;default:throwUnhandledCaseError(j)}C++}return captureMatchIfValidAndReset(),u;function stateNonEmailAddress(s){"m"===s?beginEmailMatch(1):i.test(s)&&beginEmailMatch()}function stateMailTo(s,o){":"===s?i.test(o)?(j=2,L=new hC(__assign(__assign({},L),{hasMailtoPrefix:!0}))):resetToNonEmailMatchState():x[s]===o||(i.test(o)?j=2:"."===o?j=3:"@"===o?j=4:resetToNonEmailMatchState())}function stateLocalPart(s){"."===s?j=3:"@"===s?j=4:i.test(s)||resetToNonEmailMatchState()}function stateLocalPartDot(s){"."===s||"@"===s?resetToNonEmailMatchState():i.test(s)?j=2:resetToNonEmailMatchState()}function stateAtSign(s){aC.test(s)?j=5:resetToNonEmailMatchState()}function stateDomainChar(s){"."===s?j=7:"-"===s?j=6:aC.test(s)||captureMatchIfValidAndReset()}function stateDomainHyphen(s){"-"===s||"."===s?captureMatchIfValidAndReset():aC.test(s)?j=5:captureMatchIfValidAndReset()}function stateDomainDot(s){"."===s||"-"===s?captureMatchIfValidAndReset():aC.test(s)?(j=5,L=new hC(__assign(__assign({},L),{hasDomainDot:!0}))):captureMatchIfValidAndReset()}function beginEmailMatch(s){void 0===s&&(s=2),j=s,L=new hC({idx:C})}function resetToNonEmailMatchState(){j=0,L=w}function captureMatchIfValidAndReset(){if(L.hasDomainDot){var i=s.slice(L.idx,C);/[-.]$/.test(i)&&(i=i.slice(0,-1));var _=L.hasMailtoPrefix?i.slice(7):i;(function doesEmailHaveValidTld(s){var o=s.split(".").pop()||"",i=o.toLowerCase();return a.test(i)})(_)&&u.push(new qA({tagBuilder:o,matchedText:i,offset:L.idx,email:_}))}resetToNonEmailMatchState()}},EmailMatcher}(JA),hC=function hC(s){void 0===s&&(s={}),this.idx=void 0!==s.idx?s.idx:-1,this.hasMailtoPrefix=!!s.hasMailtoPrefix,this.hasDomainDot=!!s.hasDomainDot},dC=function(){function UrlMatchValidator(){}return UrlMatchValidator.isValid=function(s,o){return!(o&&!this.isValidUriScheme(o)||this.urlMatchDoesNotHaveProtocolOrDot(s,o)||this.urlMatchDoesNotHaveAtLeastOneWordChar(s,o)&&!this.isValidIpAddress(s)||this.containsMultipleDots(s))},UrlMatchValidator.isValidIpAddress=function(s){var o=new RegExp(this.hasFullProtocolRegex.source+this.ipRegex.source);return null!==s.match(o)},UrlMatchValidator.containsMultipleDots=function(s){var o=s;return this.hasFullProtocolRegex.test(s)&&(o=s.split("://")[1]),o.split("/")[0].indexOf("..")>-1},UrlMatchValidator.isValidUriScheme=function(s){var o=s.match(this.uriSchemeRegex),i=o&&o[0].toLowerCase();return"javascript:"!==i&&"vbscript:"!==i},UrlMatchValidator.urlMatchDoesNotHaveProtocolOrDot=function(s,o){return!(!s||o&&this.hasFullProtocolRegex.test(o)||-1!==s.indexOf("."))},UrlMatchValidator.urlMatchDoesNotHaveAtLeastOneWordChar=function(s,o){return!(!s||!o)&&(!this.hasFullProtocolRegex.test(o)&&!this.hasWordCharAfterProtocolRegex.test(s))},UrlMatchValidator.hasFullProtocolRegex=/^[A-Za-z][-.+A-Za-z0-9]*:\/\//,UrlMatchValidator.uriSchemeRegex=/^[A-Za-z][-.+A-Za-z0-9]*:/,UrlMatchValidator.hasWordCharAfterProtocolRegex=new RegExp(":[^\\s]*?["+ZA+"]"),UrlMatchValidator.ipRegex=/[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?(:[0-9]*)?\/?$/,UrlMatchValidator}(),fC=($A=new RegExp("[/?#](?:["+nC+"\\-+&@#/%=~_()|'$*\\[\\]{}?!:,.;^✓]*["+nC+"\\-+&@#/%=~_()|'$*\\[\\]{}✓])?"),new RegExp(["(?:","(",/(?:[A-Za-z][-.+A-Za-z0-9]{0,63}:(?![A-Za-z][-.+A-Za-z0-9]{0,63}:\/\/)(?!\d+\/?)(?:\/\/)?)/.source,getDomainNameStr(2),")","|","(","(//)?",/(?:www\.)/.source,getDomainNameStr(6),")","|","(","(//)?",getDomainNameStr(10)+"\\.",cC.source,"(?![-"+rC+"])",")",")","(?::[0-9]+)?","(?:"+$A.source+")?"].join(""),"gi")),mC=new RegExp("["+nC+"]"),gC=function(s){function UrlMatcher(o){var i=s.call(this,o)||this;return i.stripPrefix={scheme:!0,www:!0},i.stripTrailingSlash=!0,i.decodePercentEncoding=!0,i.matcherRegex=fC,i.wordCharRegExp=mC,i.stripPrefix=o.stripPrefix,i.stripTrailingSlash=o.stripTrailingSlash,i.decodePercentEncoding=o.decodePercentEncoding,i}return tslib_es6_extends(UrlMatcher,s),UrlMatcher.prototype.parseMatches=function(s){for(var o,i=this.matcherRegex,a=this.stripPrefix,u=this.stripTrailingSlash,_=this.decodePercentEncoding,w=this.tagBuilder,x=[],_loop_1=function(){var i=o[0],j=o[1],L=o[4],B=o[5],$=o[9],U=o.index,V=B||$,z=s.charAt(U-1);if(!dC.isValid(i,j))return"continue";if(U>0&&"@"===z)return"continue";if(U>0&&V&&C.wordCharRegExp.test(z))return"continue";if(/\?$/.test(i)&&(i=i.substr(0,i.length-1)),C.matchHasUnbalancedClosingParen(i))i=i.substr(0,i.length-1);else{var Y=C.matchHasInvalidCharAfterTld(i,j);Y>-1&&(i=i.substr(0,Y))}var Z=["http://","https://"].find((function(s){return!!j&&-1!==j.indexOf(s)}));if(Z){var ee=i.indexOf(Z);i=i.substr(ee),j=j.substr(ee),U+=ee}var ie=j?"scheme":L?"www":"tld",ae=!!j;x.push(new WA({tagBuilder:w,matchedText:i,offset:U,urlMatchType:ie,url:i,protocolUrlMatch:ae,protocolRelativeMatch:!!V,stripPrefix:a,stripTrailingSlash:u,decodePercentEncoding:_}))},C=this;null!==(o=i.exec(s));)_loop_1();return x},UrlMatcher.prototype.matchHasUnbalancedClosingParen=function(s){var o,i=s.charAt(s.length-1);if(")"===i)o="(";else if("]"===i)o="[";else{if("}"!==i)return!1;o="{"}for(var a=0,u=0,_=s.length-1;u<_;u++){var w=s.charAt(u);w===o?a++:w===i&&(a=Math.max(a-1,0))}return 0===a},UrlMatcher.prototype.matchHasInvalidCharAfterTld=function(s,o){if(!s)return-1;var i=0;o&&(i=s.indexOf(":"),s=s.slice(i));var a=new RegExp("^((.?//)?[-."+nC+"]*[-"+nC+"]\\.[-"+nC+"]+)").exec(s);return null===a?-1:(i+=a[1].length,s=s.slice(a[1].length),/^[^-.A-Za-z0-9:\/?#]/.test(s)?i:-1)},UrlMatcher}(JA),yC=new RegExp("[_".concat(nC,"]")),vC=function(s){function HashtagMatcher(o){var i=s.call(this,o)||this;return i.serviceName="twitter",i.serviceName=o.serviceName,i}return tslib_es6_extends(HashtagMatcher,s),HashtagMatcher.prototype.parseMatches=function(s){for(var o=this.tagBuilder,i=this.serviceName,a=[],u=s.length,_=0,w=-1,x=0;_<u;){var C=s.charAt(_);switch(x){case 0:stateNone(C);break;case 1:stateNonHashtagWordChar(C);break;case 2:stateHashtagHashChar(C);break;case 3:stateHashtagTextChar(C);break;default:throwUnhandledCaseError(x)}_++}return captureMatchIfValid(),a;function stateNone(s){"#"===s?(x=2,w=_):sC.test(s)&&(x=1)}function stateNonHashtagWordChar(s){sC.test(s)||(x=0)}function stateHashtagHashChar(s){x=yC.test(s)?3:sC.test(s)?1:0}function stateHashtagTextChar(s){yC.test(s)||(captureMatchIfValid(),w=-1,x=sC.test(s)?1:0)}function captureMatchIfValid(){if(w>-1&&_-w<=140){var u=s.slice(w,_),x=new UA({tagBuilder:o,matchedText:u,offset:w,serviceName:i,hashtag:u.slice(1)});a.push(x)}}},HashtagMatcher}(JA),bC=["twitter","facebook","instagram","tiktok"],SC=new RegExp("".concat(/(?:(?:(?:(\+)?\d{1,3}[-\040.]?)?\(?\d{3}\)?[-\040.]?\d{3}[-\040.]?\d{4})|(?:(\+)(?:9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)[-\040.]?(?:\d[-\040.]?){6,12}\d+))([,;]+[0-9]+#?)*/.source,"|").concat(/(0([1-9]{1}-?[1-9]\d{3}|[1-9]{2}-?\d{3}|[1-9]{2}\d{1}-?\d{2}|[1-9]{2}\d{2}-?\d{1})-?\d{4}|0[789]0-?\d{4}-?\d{4}|050-?\d{4}-?\d{4})/.source),"g"),_C=function(s){function PhoneMatcher(){var o=null!==s&&s.apply(this,arguments)||this;return o.matcherRegex=SC,o}return tslib_es6_extends(PhoneMatcher,s),PhoneMatcher.prototype.parseMatches=function(s){for(var o,i=this.matcherRegex,a=this.tagBuilder,u=[];null!==(o=i.exec(s));){var _=o[0],w=_.replace(/[^0-9,;#]/g,""),x=!(!o[1]&&!o[2]),C=0==o.index?"":s.substr(o.index-1,1),j=s.substr(o.index+_.length,1),L=!C.match(/\d/)&&!j.match(/\d/);this.testMatch(o[3])&&this.testMatch(_)&&L&&u.push(new zA({tagBuilder:a,matchedText:_,offset:o.index,number:w,plusSign:x}))}return u},PhoneMatcher.prototype.testMatch=function(s){return GA.test(s)},PhoneMatcher}(JA),EC=new RegExp("@[_".concat(nC,"]{1,50}(?![_").concat(nC,"])"),"g"),wC=new RegExp("@[_.".concat(nC,"]{1,30}(?![_").concat(nC,"])"),"g"),xC=new RegExp("@[-_.".concat(nC,"]{1,50}(?![-_").concat(nC,"])"),"g"),kC=new RegExp("@[_.".concat(nC,"]{1,23}[_").concat(nC,"](?![_").concat(nC,"])"),"g"),OC=new RegExp("[^"+nC+"]"),AC=function(s){function MentionMatcher(o){var i=s.call(this,o)||this;return i.serviceName="twitter",i.matcherRegexes={twitter:EC,instagram:wC,soundcloud:xC,tiktok:kC},i.nonWordCharRegex=OC,i.serviceName=o.serviceName,i}return tslib_es6_extends(MentionMatcher,s),MentionMatcher.prototype.parseMatches=function(s){var o,i=this.serviceName,a=this.matcherRegexes[this.serviceName],u=this.nonWordCharRegex,_=this.tagBuilder,w=[];if(!a)return w;for(;null!==(o=a.exec(s));){var x=o.index,C=s.charAt(x-1);if(0===x||u.test(C)){var j=o[0].replace(/\.+$/g,""),L=j.slice(1);w.push(new VA({tagBuilder:_,matchedText:j,offset:x,serviceName:i,mention:L}))}}return w},MentionMatcher}(JA);function parseHtml(s,o){for(var i=o.onOpenTag,a=o.onCloseTag,u=o.onText,_=o.onComment,w=o.onDoctype,x=new CC,C=0,j=s.length,L=0,B=0,$=x;C<j;){var U=s.charAt(C);switch(L){case 0:stateData(U);break;case 1:stateTagOpen(U);break;case 2:stateEndTagOpen(U);break;case 3:stateTagName(U);break;case 4:stateBeforeAttributeName(U);break;case 5:stateAttributeName(U);break;case 6:stateAfterAttributeName(U);break;case 7:stateBeforeAttributeValue(U);break;case 8:stateAttributeValueDoubleQuoted(U);break;case 9:stateAttributeValueSingleQuoted(U);break;case 10:stateAttributeValueUnquoted(U);break;case 11:stateAfterAttributeValueQuoted(U);break;case 12:stateSelfClosingStartTag(U);break;case 13:stateMarkupDeclarationOpen(U);break;case 14:stateCommentStart(U);break;case 15:stateCommentStartDash(U);break;case 16:stateComment(U);break;case 17:stateCommentEndDash(U);break;case 18:stateCommentEnd(U);break;case 19:stateCommentEndBang(U);break;case 20:stateDoctype(U);break;default:throwUnhandledCaseError(L)}C++}function stateData(s){"<"===s&&startNewTag()}function stateTagOpen(s){"!"===s?L=13:"/"===s?(L=2,$=new CC(__assign(__assign({},$),{isClosing:!0}))):"<"===s?startNewTag():HA.test(s)?(L=3,$=new CC(__assign(__assign({},$),{isOpening:!0}))):(L=0,$=x)}function stateTagName(s){YA.test(s)?($=new CC(__assign(__assign({},$),{name:captureTagName()})),L=4):"<"===s?startNewTag():"/"===s?($=new CC(__assign(__assign({},$),{name:captureTagName()})),L=12):">"===s?($=new CC(__assign(__assign({},$),{name:captureTagName()})),emitTagAndPreviousTextNode()):HA.test(s)||KA.test(s)||":"===s||resetToDataState()}function stateEndTagOpen(s){">"===s?resetToDataState():HA.test(s)?L=3:resetToDataState()}function stateBeforeAttributeName(s){YA.test(s)||("/"===s?L=12:">"===s?emitTagAndPreviousTextNode():"<"===s?startNewTag():"="===s||XA.test(s)||QA.test(s)?resetToDataState():L=5)}function stateAttributeName(s){YA.test(s)?L=6:"/"===s?L=12:"="===s?L=7:">"===s?emitTagAndPreviousTextNode():"<"===s?startNewTag():XA.test(s)&&resetToDataState()}function stateAfterAttributeName(s){YA.test(s)||("/"===s?L=12:"="===s?L=7:">"===s?emitTagAndPreviousTextNode():"<"===s?startNewTag():XA.test(s)?resetToDataState():L=5)}function stateBeforeAttributeValue(s){YA.test(s)||('"'===s?L=8:"'"===s?L=9:/[>=`]/.test(s)?resetToDataState():"<"===s?startNewTag():L=10)}function stateAttributeValueDoubleQuoted(s){'"'===s&&(L=11)}function stateAttributeValueSingleQuoted(s){"'"===s&&(L=11)}function stateAttributeValueUnquoted(s){YA.test(s)?L=4:">"===s?emitTagAndPreviousTextNode():"<"===s&&startNewTag()}function stateAfterAttributeValueQuoted(s){YA.test(s)?L=4:"/"===s?L=12:">"===s?emitTagAndPreviousTextNode():"<"===s?startNewTag():(L=4,function reconsumeCurrentCharacter(){C--}())}function stateSelfClosingStartTag(s){">"===s?($=new CC(__assign(__assign({},$),{isClosing:!0})),emitTagAndPreviousTextNode()):L=4}function stateMarkupDeclarationOpen(o){"--"===s.substr(C,2)?(C+=2,$=new CC(__assign(__assign({},$),{type:"comment"})),L=14):"DOCTYPE"===s.substr(C,7).toUpperCase()?(C+=7,$=new CC(__assign(__assign({},$),{type:"doctype"})),L=20):resetToDataState()}function stateCommentStart(s){"-"===s?L=15:">"===s?resetToDataState():L=16}function stateCommentStartDash(s){"-"===s?L=18:">"===s?resetToDataState():L=16}function stateComment(s){"-"===s&&(L=17)}function stateCommentEndDash(s){L="-"===s?18:16}function stateCommentEnd(s){">"===s?emitTagAndPreviousTextNode():"!"===s?L=19:"-"===s||(L=16)}function stateCommentEndBang(s){"-"===s?L=17:">"===s?emitTagAndPreviousTextNode():L=16}function stateDoctype(s){">"===s?emitTagAndPreviousTextNode():"<"===s&&startNewTag()}function resetToDataState(){L=0,$=x}function startNewTag(){L=1,$=new CC({idx:C})}function emitTagAndPreviousTextNode(){var o=s.slice(B,$.idx);o&&u(o,B),"comment"===$.type?_($.idx):"doctype"===$.type?w($.idx):($.isOpening&&i($.name,$.idx),$.isClosing&&a($.name,$.idx)),resetToDataState(),B=C+1}function captureTagName(){var o=$.idx+($.isClosing?2:1);return s.slice(o,C).toLowerCase()}B<C&&function emitText(){var o=s.slice(B,C);u(o,B),B=C+1}()}var CC=function CC(s){void 0===s&&(s={}),this.idx=void 0!==s.idx?s.idx:-1,this.type=s.type||"tag",this.name=s.name||"",this.isOpening=!!s.isOpening,this.isClosing=!!s.isClosing},jC=function(){function Autolinker(s){void 0===s&&(s={}),this.version=Autolinker.version,this.urls={},this.email=!0,this.phone=!0,this.hashtag=!1,this.mention=!1,this.newWindow=!0,this.stripPrefix={scheme:!0,www:!0},this.stripTrailingSlash=!0,this.decodePercentEncoding=!0,this.truncate={length:0,location:"end"},this.className="",this.replaceFn=null,this.context=void 0,this.sanitizeHtml=!1,this.matchers=null,this.tagBuilder=null,this.urls=this.normalizeUrlsCfg(s.urls),this.email="boolean"==typeof s.email?s.email:this.email,this.phone="boolean"==typeof s.phone?s.phone:this.phone,this.hashtag=s.hashtag||this.hashtag,this.mention=s.mention||this.mention,this.newWindow="boolean"==typeof s.newWindow?s.newWindow:this.newWindow,this.stripPrefix=this.normalizeStripPrefixCfg(s.stripPrefix),this.stripTrailingSlash="boolean"==typeof s.stripTrailingSlash?s.stripTrailingSlash:this.stripTrailingSlash,this.decodePercentEncoding="boolean"==typeof s.decodePercentEncoding?s.decodePercentEncoding:this.decodePercentEncoding,this.sanitizeHtml=s.sanitizeHtml||!1;var o=this.mention;if(!1!==o&&-1===["twitter","instagram","soundcloud","tiktok"].indexOf(o))throw new Error("invalid `mention` cfg '".concat(o,"' - see docs"));var i=this.hashtag;if(!1!==i&&-1===bC.indexOf(i))throw new Error("invalid `hashtag` cfg '".concat(i,"' - see docs"));this.truncate=this.normalizeTruncateCfg(s.truncate),this.className=s.className||this.className,this.replaceFn=s.replaceFn||this.replaceFn,this.context=s.context||this}return Autolinker.link=function(s,o){return new Autolinker(o).link(s)},Autolinker.parse=function(s,o){return new Autolinker(o).parse(s)},Autolinker.prototype.normalizeUrlsCfg=function(s){return null==s&&(s=!0),"boolean"==typeof s?{schemeMatches:s,wwwMatches:s,tldMatches:s}:{schemeMatches:"boolean"!=typeof s.schemeMatches||s.schemeMatches,wwwMatches:"boolean"!=typeof s.wwwMatches||s.wwwMatches,tldMatches:"boolean"!=typeof s.tldMatches||s.tldMatches}},Autolinker.prototype.normalizeStripPrefixCfg=function(s){return null==s&&(s=!0),"boolean"==typeof s?{scheme:s,www:s}:{scheme:"boolean"!=typeof s.scheme||s.scheme,www:"boolean"!=typeof s.www||s.www}},Autolinker.prototype.normalizeTruncateCfg=function(s){return"number"==typeof s?{length:s,location:"end"}:function defaults(s,o){for(var i in o)o.hasOwnProperty(i)&&void 0===s[i]&&(s[i]=o[i]);return s}(s||{},{length:Number.POSITIVE_INFINITY,location:"end"})},Autolinker.prototype.parse=function(s){var o=this,i=["a","style","script"],a=0,u=[];return parseHtml(s,{onOpenTag:function(s){i.indexOf(s)>=0&&a++},onText:function(s,i){if(0===a){var _=function splitAndCapture(s,o){if(!o.global)throw new Error("`splitRegex` must have the 'g' flag set");for(var i,a=[],u=0;i=o.exec(s);)a.push(s.substring(u,i.index)),a.push(i[0]),u=i.index+i[0].length;return a.push(s.substring(u)),a}(s,/(&nbsp;|&#160;|&lt;|&#60;|&gt;|&#62;|&quot;|&#34;|&#39;)/gi),w=i;_.forEach((function(s,i){if(i%2==0){var a=o.parseText(s,w);u.push.apply(u,a)}w+=s.length}))}},onCloseTag:function(s){i.indexOf(s)>=0&&(a=Math.max(a-1,0))},onComment:function(s){},onDoctype:function(s){}}),u=this.compactMatches(u),u=this.removeUnwantedMatches(u)},Autolinker.prototype.compactMatches=function(s){s.sort((function(s,o){return s.getOffset()-o.getOffset()}));for(var o=0;o<s.length-1;){var i=s[o],a=i.getOffset(),u=i.getMatchedText().length,_=a+u;if(o+1<s.length){if(s[o+1].getOffset()===a){var w=s[o+1].getMatchedText().length>u?o:o+1;s.splice(w,1);continue}if(s[o+1].getOffset()<_){s.splice(o+1,1);continue}}o++}return s},Autolinker.prototype.removeUnwantedMatches=function(s){return this.hashtag||utils_remove(s,(function(s){return"hashtag"===s.getType()})),this.email||utils_remove(s,(function(s){return"email"===s.getType()})),this.phone||utils_remove(s,(function(s){return"phone"===s.getType()})),this.mention||utils_remove(s,(function(s){return"mention"===s.getType()})),this.urls.schemeMatches||utils_remove(s,(function(s){return"url"===s.getType()&&"scheme"===s.getUrlMatchType()})),this.urls.wwwMatches||utils_remove(s,(function(s){return"url"===s.getType()&&"www"===s.getUrlMatchType()})),this.urls.tldMatches||utils_remove(s,(function(s){return"url"===s.getType()&&"tld"===s.getUrlMatchType()})),s},Autolinker.prototype.parseText=function(s,o){void 0===o&&(o=0),o=o||0;for(var i=this.getMatchers(),a=[],u=0,_=i.length;u<_;u++){for(var w=i[u].parseMatches(s),x=0,C=w.length;x<C;x++)w[x].setOffset(o+w[x].getOffset());a.push.apply(a,w)}return a},Autolinker.prototype.link=function(s){if(!s)return"";this.sanitizeHtml&&(s=s.replace(/</g,"&lt;").replace(/>/g,"&gt;"));for(var o=this.parse(s),i=[],a=0,u=0,_=o.length;u<_;u++){var w=o[u];i.push(s.substring(a,w.getOffset())),i.push(this.createMatchReturnVal(w)),a=w.getOffset()+w.getMatchedText().length}return i.push(s.substring(a)),i.join("")},Autolinker.prototype.createMatchReturnVal=function(s){var o;return this.replaceFn&&(o=this.replaceFn.call(this.context,s)),"string"==typeof o?o:!1===o?s.getMatchedText():o instanceof LA?o.toAnchorString():s.buildTag().toAnchorString()},Autolinker.prototype.getMatchers=function(){if(this.matchers)return this.matchers;var s=this.getTagBuilder(),o=[new vC({tagBuilder:s,serviceName:this.hashtag}),new pC({tagBuilder:s}),new _C({tagBuilder:s}),new AC({tagBuilder:s,serviceName:this.mention}),new gC({tagBuilder:s,stripPrefix:this.stripPrefix,stripTrailingSlash:this.stripTrailingSlash,decodePercentEncoding:this.decodePercentEncoding})];return this.matchers=o},Autolinker.prototype.getTagBuilder=function(){var s=this.tagBuilder;return s||(s=this.tagBuilder=new FA({newWindow:this.newWindow,truncate:this.truncate,className:this.className})),s},Autolinker.version="3.16.2",Autolinker.AnchorTagBuilder=FA,Autolinker.HtmlTag=LA,Autolinker.matcher={Email:pC,Hashtag:vC,Matcher:JA,Mention:AC,Phone:_C,Url:gC},Autolinker.match={Email:qA,Hashtag:UA,Match:BA,Mention:VA,Phone:zA,Url:WA},Autolinker}();const PC=jC;var IC=/www|@|\:\/\//;function isLinkOpen(s){return/^<a[>\s]/i.test(s)}function isLinkClose(s){return/^<\/a\s*>/i.test(s)}function createLinkifier(){var s=[],o=new PC({stripPrefix:!1,url:!0,email:!0,replaceFn:function(o){switch(o.getType()){case"url":s.push({text:o.matchedText,url:o.getUrl()});break;case"email":s.push({text:o.matchedText,url:"mailto:"+o.getEmail().replace(/^mailto:/i,"")})}return!1}});return{links:s,autolinker:o}}function parseTokens(s){var o,i,a,u,_,w,x,C,j,L,B,$,U,V=s.tokens,z=null;for(i=0,a=V.length;i<a;i++)if("inline"===V[i].type)for(B=0,o=(u=V[i].children).length-1;o>=0;o--)if("link_close"!==(_=u[o]).type){if("htmltag"===_.type&&(isLinkOpen(_.content)&&B>0&&B--,isLinkClose(_.content)&&B++),!(B>0)&&"text"===_.type&&IC.test(_.content)){if(z||($=(z=createLinkifier()).links,U=z.autolinker),w=_.content,$.length=0,U.link(w),!$.length)continue;for(x=[],L=_.level,C=0;C<$.length;C++)s.inline.validateLink($[C].url)&&((j=w.indexOf($[C].text))&&x.push({type:"text",content:w.slice(0,j),level:L}),x.push({type:"link_open",href:$[C].url,title:"",level:L++}),x.push({type:"text",content:$[C].text,level:L}),x.push({type:"link_close",level:--L}),w=w.slice(j+$[C].text.length));w.length&&x.push({type:"text",content:w,level:L}),V[i].children=u=[].concat(u.slice(0,o),x,u.slice(o+1))}}else for(o--;u[o].level!==_.level&&"link_open"!==u[o].type;)o--}function linkify(s){s.core.ruler.push("linkify",parseTokens)}const{entries:TC,setPrototypeOf:NC,isFrozen:MC,getPrototypeOf:RC,getOwnPropertyDescriptor:DC}=Object;let{freeze:LC,seal:FC,create:BC}=Object,{apply:$C,construct:qC}="undefined"!=typeof Reflect&&Reflect;LC||(LC=function freeze(s){return s}),FC||(FC=function seal(s){return s}),$C||($C=function apply(s,o){for(var i=arguments.length,a=new Array(i>2?i-2:0),u=2;u<i;u++)a[u-2]=arguments[u];return s.apply(o,a)}),qC||(qC=function construct(s){for(var o=arguments.length,i=new Array(o>1?o-1:0),a=1;a<o;a++)i[a-1]=arguments[a];return new s(...i)});const UC=unapply(Array.prototype.forEach),VC=unapply(Array.prototype.lastIndexOf),zC=unapply(Array.prototype.pop),WC=unapply(Array.prototype.push),JC=unapply(Array.prototype.splice),HC=unapply(String.prototype.toLowerCase),KC=unapply(String.prototype.toString),GC=unapply(String.prototype.match),YC=unapply(String.prototype.replace),XC=unapply(String.prototype.indexOf),QC=unapply(String.prototype.trim),ZC=unapply(Object.prototype.hasOwnProperty),ej=unapply(RegExp.prototype.test),fj=function unconstruct(s){return function(){for(var o=arguments.length,i=new Array(o),a=0;a<o;a++)i[a]=arguments[a];return qC(s,i)}}(TypeError);function unapply(s){return function(o){o instanceof RegExp&&(o.lastIndex=0);for(var i=arguments.length,a=new Array(i>1?i-1:0),u=1;u<i;u++)a[u-1]=arguments[u];return $C(s,o,a)}}function addToSet(s,o){let i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:HC;NC&&NC(s,null);let a=o.length;for(;a--;){let u=o[a];if("string"==typeof u){const s=i(u);s!==u&&(MC(o)||(o[a]=s),u=s)}s[u]=!0}return s}function purify_es_cleanArray(s){for(let o=0;o<s.length;o++){ZC(s,o)||(s[o]=null)}return s}function clone(s){const o=BC(null);for(const[i,a]of TC(s)){ZC(s,i)&&(Array.isArray(a)?o[i]=purify_es_cleanArray(a):a&&"object"==typeof a&&a.constructor===Object?o[i]=clone(a):o[i]=a)}return o}function lookupGetter(s,o){for(;null!==s;){const i=DC(s,o);if(i){if(i.get)return unapply(i.get);if("function"==typeof i.value)return unapply(i.value)}s=RC(s)}return function fallbackValue(){return null}}const mj=LC(["a","abbr","acronym","address","area","article","aside","audio","b","bdi","bdo","big","blink","blockquote","body","br","button","canvas","caption","center","cite","code","col","colgroup","content","data","datalist","dd","decorator","del","details","dfn","dialog","dir","div","dl","dt","element","em","fieldset","figcaption","figure","font","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","img","input","ins","kbd","label","legend","li","main","map","mark","marquee","menu","menuitem","meter","nav","nobr","ol","optgroup","option","output","p","picture","pre","progress","q","rp","rt","ruby","s","samp","search","section","select","shadow","slot","small","source","spacer","span","strike","strong","style","sub","summary","sup","table","tbody","td","template","textarea","tfoot","th","thead","time","tr","track","tt","u","ul","var","video","wbr"]),_j=LC(["svg","a","altglyph","altglyphdef","altglyphitem","animatecolor","animatemotion","animatetransform","circle","clippath","defs","desc","ellipse","enterkeyhint","exportparts","filter","font","g","glyph","glyphref","hkern","image","inputmode","line","lineargradient","marker","mask","metadata","mpath","part","path","pattern","polygon","polyline","radialgradient","rect","stop","style","switch","symbol","text","textpath","title","tref","tspan","view","vkern"]),Aj=LC(["feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feDropShadow","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence"]),Cj=LC(["animate","color-profile","cursor","discard","font-face","font-face-format","font-face-name","font-face-src","font-face-uri","foreignobject","hatch","hatchpath","mesh","meshgradient","meshpatch","meshrow","missing-glyph","script","set","solidcolor","unknown","use"]),Nj=LC(["math","menclose","merror","mfenced","mfrac","mglyph","mi","mlabeledtr","mmultiscripts","mn","mo","mover","mpadded","mphantom","mroot","mrow","ms","mspace","msqrt","mstyle","msub","msup","msubsup","mtable","mtd","mtext","mtr","munder","munderover","mprescripts"]),Bj=LC(["maction","maligngroup","malignmark","mlongdiv","mscarries","mscarry","msgroup","mstack","msline","msrow","semantics","annotation","annotation-xml","mprescripts","none"]),$j=LC(["#text"]),zj=LC(["accept","action","align","alt","autocapitalize","autocomplete","autopictureinpicture","autoplay","background","bgcolor","border","capture","cellpadding","cellspacing","checked","cite","class","clear","color","cols","colspan","controls","controlslist","coords","crossorigin","datetime","decoding","default","dir","disabled","disablepictureinpicture","disableremoteplayback","download","draggable","enctype","enterkeyhint","exportparts","face","for","headers","height","hidden","high","href","hreflang","id","inert","inputmode","integrity","ismap","kind","label","lang","list","loading","loop","low","max","maxlength","media","method","min","minlength","multiple","muted","name","nonce","noshade","novalidate","nowrap","open","optimum","part","pattern","placeholder","playsinline","popover","popovertarget","popovertargetaction","poster","preload","pubdate","radiogroup","readonly","rel","required","rev","reversed","role","rows","rowspan","spellcheck","scope","selected","shape","size","sizes","slot","span","srclang","start","src","srcset","step","style","summary","tabindex","title","translate","type","usemap","valign","value","width","wrap","xmlns","slot"]),Jj=LC(["accent-height","accumulate","additive","alignment-baseline","amplitude","ascent","attributename","attributetype","azimuth","basefrequency","baseline-shift","begin","bias","by","class","clip","clippathunits","clip-path","clip-rule","color","color-interpolation","color-interpolation-filters","color-profile","color-rendering","cx","cy","d","dx","dy","diffuseconstant","direction","display","divisor","dur","edgemode","elevation","end","exponent","fill","fill-opacity","fill-rule","filter","filterunits","flood-color","flood-opacity","font-family","font-size","font-size-adjust","font-stretch","font-style","font-variant","font-weight","fx","fy","g1","g2","glyph-name","glyphref","gradientunits","gradienttransform","height","href","id","image-rendering","in","in2","intercept","k","k1","k2","k3","k4","kerning","keypoints","keysplines","keytimes","lang","lengthadjust","letter-spacing","kernelmatrix","kernelunitlength","lighting-color","local","marker-end","marker-mid","marker-start","markerheight","markerunits","markerwidth","maskcontentunits","maskunits","max","mask","mask-type","media","method","mode","min","name","numoctaves","offset","operator","opacity","order","orient","orientation","origin","overflow","paint-order","path","pathlength","patterncontentunits","patterntransform","patternunits","points","preservealpha","preserveaspectratio","primitiveunits","r","rx","ry","radius","refx","refy","repeatcount","repeatdur","restart","result","rotate","scale","seed","shape-rendering","slope","specularconstant","specularexponent","spreadmethod","startoffset","stddeviation","stitchtiles","stop-color","stop-opacity","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke","stroke-width","style","surfacescale","systemlanguage","tabindex","tablevalues","targetx","targety","transform","transform-origin","text-anchor","text-decoration","text-rendering","textlength","type","u1","u2","unicode","values","viewbox","visibility","version","vert-adv-y","vert-origin-x","vert-origin-y","width","word-spacing","wrap","writing-mode","xchannelselector","ychannelselector","x","x1","x2","xmlns","y","y1","y2","z","zoomandpan"]),Kj=LC(["accent","accentunder","align","bevelled","close","columnalign","columnlines","columnspacing","columnspan","denomalign","depth","dir","display","displaystyle","encoding","fence","frame","height","href","id","largeop","length","linethickness","lquote","lspace","mathbackground","mathcolor","mathsize","mathvariant","maxsize","minsize","movablelimits","notation","numalign","open","rowalign","rowlines","rowspacing","rowspan","rspace","rquote","scriptlevel","scriptminsize","scriptsizemultiplier","selection","separator","separators","stretchy","subscriptshift","supscriptshift","symmetric","voffset","width","xmlns"]),Gj=LC(["xlink:href","xml:id","xlink:title","xml:space","xmlns:xlink"]),Xj=FC(/\{\{[\w\W]*|[\w\W]*\}\}/gm),eP=FC(/<%[\w\W]*|[\w\W]*%>/gm),tP=FC(/\$\{[\w\W]*/gm),rP=FC(/^data-[\-\w.\u00B7-\uFFFF]+$/),nP=FC(/^aria-[\-\w]+$/),sP=FC(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),oP=FC(/^(?:\w+script|data):/i),iP=FC(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),aP=FC(/^html$/i),cP=FC(/^[a-z][.\w]*(-[.\w]+)+$/i);var lP=Object.freeze({__proto__:null,ARIA_ATTR:nP,ATTR_WHITESPACE:iP,CUSTOM_ELEMENT:cP,DATA_ATTR:rP,DOCTYPE_NAME:aP,ERB_EXPR:eP,IS_ALLOWED_URI:sP,IS_SCRIPT_OR_DATA:oP,MUSTACHE_EXPR:Xj,TMPLIT_EXPR:tP});const uP=1,pP=3,hP=7,dP=8,fP=9,mP=function getGlobal(){return"undefined"==typeof window?null:window};var gP=function createDOMPurify(){let s=arguments.length>0&&void 0!==arguments[0]?arguments[0]:mP();const DOMPurify=s=>createDOMPurify(s);if(DOMPurify.version="3.4.0",DOMPurify.removed=[],!s||!s.document||s.document.nodeType!==fP||!s.Element)return DOMPurify.isSupported=!1,DOMPurify;let{document:o}=s;const i=o,a=i.currentScript,{DocumentFragment:u,HTMLTemplateElement:_,Node:w,Element:x,NodeFilter:C,NamedNodeMap:j=s.NamedNodeMap||s.MozNamedAttrMap,HTMLFormElement:L,DOMParser:B,trustedTypes:$}=s,U=x.prototype,V=lookupGetter(U,"cloneNode"),z=lookupGetter(U,"remove"),Y=lookupGetter(U,"nextSibling"),Z=lookupGetter(U,"childNodes"),ee=lookupGetter(U,"parentNode");if("function"==typeof _){const s=o.createElement("template");s.content&&s.content.ownerDocument&&(o=s.content.ownerDocument)}let ie,ae="";const{implementation:ce,createNodeIterator:le,createDocumentFragment:pe,getElementsByTagName:de}=o,{importNode:fe}=i;let ye={afterSanitizeAttributes:[],afterSanitizeElements:[],afterSanitizeShadowDOM:[],beforeSanitizeAttributes:[],beforeSanitizeElements:[],beforeSanitizeShadowDOM:[],uponSanitizeAttribute:[],uponSanitizeElement:[],uponSanitizeShadowNode:[]};DOMPurify.isSupported="function"==typeof TC&&"function"==typeof ee&&ce&&void 0!==ce.createHTMLDocument;const{MUSTACHE_EXPR:be,ERB_EXPR:Se,TMPLIT_EXPR:_e,DATA_ATTR:we,ARIA_ATTR:xe,IS_SCRIPT_OR_DATA:Pe,ATTR_WHITESPACE:Te,CUSTOM_ELEMENT:Re}=lP;let{IS_ALLOWED_URI:$e}=lP,qe=null;const ze=addToSet({},[...mj,..._j,...Aj,...Nj,...$j]);let We=null;const He=addToSet({},[...zj,...Jj,...Kj,...Gj]);let Ye=Object.seal(BC(null,{tagNameCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},attributeNameCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},allowCustomizedBuiltInElements:{writable:!0,configurable:!1,enumerable:!0,value:!1}})),Xe=null,Qe=null;const et=Object.seal(BC(null,{tagCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},attributeCheck:{writable:!0,configurable:!1,enumerable:!0,value:null}}));let tt=!0,rt=!0,nt=!1,st=!0,ot=!1,it=!0,at=!1,ct=!1,lt=!1,ut=!1,pt=!1,ht=!1,dt=!0,mt=!1,gt=!0,yt=!1,vt={},bt=null;const St=addToSet({},["annotation-xml","audio","colgroup","desc","foreignobject","head","iframe","math","mi","mn","mo","ms","mtext","noembed","noframes","noscript","plaintext","script","style","svg","template","thead","title","video","xmp"]);let _t=null;const Et=addToSet({},["audio","video","img","source","image","track"]);let wt=null;const xt=addToSet({},["alt","class","for","id","label","name","pattern","placeholder","role","summary","title","value","style","xmlns"]),kt="http://www.w3.org/1998/Math/MathML",Ot="http://www.w3.org/2000/svg",At="http://www.w3.org/1999/xhtml";let Ct=At,jt=!1,Pt=null;const It=addToSet({},[kt,Ot,At],KC);let Tt=addToSet({},["mi","mo","mn","ms","mtext"]),Nt=addToSet({},["annotation-xml"]);const Mt=addToSet({},["title","style","font","a","script"]);let Rt=null;const Dt=["application/xhtml+xml","text/html"];let Lt=null,Ft=null;const Bt=o.createElement("form"),$t=function isRegexOrFunction(s){return s instanceof RegExp||s instanceof Function},qt=function _parseConfig(){let s=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(!Ft||Ft!==s){if(s&&"object"==typeof s||(s={}),s=clone(s),Rt=-1===Dt.indexOf(s.PARSER_MEDIA_TYPE)?"text/html":s.PARSER_MEDIA_TYPE,Lt="application/xhtml+xml"===Rt?KC:HC,qe=ZC(s,"ALLOWED_TAGS")?addToSet({},s.ALLOWED_TAGS,Lt):ze,We=ZC(s,"ALLOWED_ATTR")?addToSet({},s.ALLOWED_ATTR,Lt):He,Pt=ZC(s,"ALLOWED_NAMESPACES")?addToSet({},s.ALLOWED_NAMESPACES,KC):It,wt=ZC(s,"ADD_URI_SAFE_ATTR")?addToSet(clone(xt),s.ADD_URI_SAFE_ATTR,Lt):xt,_t=ZC(s,"ADD_DATA_URI_TAGS")?addToSet(clone(Et),s.ADD_DATA_URI_TAGS,Lt):Et,bt=ZC(s,"FORBID_CONTENTS")?addToSet({},s.FORBID_CONTENTS,Lt):St,Xe=ZC(s,"FORBID_TAGS")?addToSet({},s.FORBID_TAGS,Lt):clone({}),Qe=ZC(s,"FORBID_ATTR")?addToSet({},s.FORBID_ATTR,Lt):clone({}),vt=!!ZC(s,"USE_PROFILES")&&s.USE_PROFILES,tt=!1!==s.ALLOW_ARIA_ATTR,rt=!1!==s.ALLOW_DATA_ATTR,nt=s.ALLOW_UNKNOWN_PROTOCOLS||!1,st=!1!==s.ALLOW_SELF_CLOSE_IN_ATTR,ot=s.SAFE_FOR_TEMPLATES||!1,it=!1!==s.SAFE_FOR_XML,at=s.WHOLE_DOCUMENT||!1,ut=s.RETURN_DOM||!1,pt=s.RETURN_DOM_FRAGMENT||!1,ht=s.RETURN_TRUSTED_TYPE||!1,lt=s.FORCE_BODY||!1,dt=!1!==s.SANITIZE_DOM,mt=s.SANITIZE_NAMED_PROPS||!1,gt=!1!==s.KEEP_CONTENT,yt=s.IN_PLACE||!1,$e=s.ALLOWED_URI_REGEXP||sP,Ct=s.NAMESPACE||At,Tt=s.MATHML_TEXT_INTEGRATION_POINTS||Tt,Nt=s.HTML_INTEGRATION_POINTS||Nt,Ye=s.CUSTOM_ELEMENT_HANDLING||BC(null),s.CUSTOM_ELEMENT_HANDLING&&$t(s.CUSTOM_ELEMENT_HANDLING.tagNameCheck)&&(Ye.tagNameCheck=s.CUSTOM_ELEMENT_HANDLING.tagNameCheck),s.CUSTOM_ELEMENT_HANDLING&&$t(s.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)&&(Ye.attributeNameCheck=s.CUSTOM_ELEMENT_HANDLING.attributeNameCheck),s.CUSTOM_ELEMENT_HANDLING&&"boolean"==typeof s.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements&&(Ye.allowCustomizedBuiltInElements=s.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements),ot&&(rt=!1),pt&&(ut=!0),vt&&(qe=addToSet({},$j),We=BC(null),!0===vt.html&&(addToSet(qe,mj),addToSet(We,zj)),!0===vt.svg&&(addToSet(qe,_j),addToSet(We,Jj),addToSet(We,Gj)),!0===vt.svgFilters&&(addToSet(qe,Aj),addToSet(We,Jj),addToSet(We,Gj)),!0===vt.mathMl&&(addToSet(qe,Nj),addToSet(We,Kj),addToSet(We,Gj))),et.tagCheck=null,et.attributeCheck=null,s.ADD_TAGS&&("function"==typeof s.ADD_TAGS?et.tagCheck=s.ADD_TAGS:(qe===ze&&(qe=clone(qe)),addToSet(qe,s.ADD_TAGS,Lt))),s.ADD_ATTR&&("function"==typeof s.ADD_ATTR?et.attributeCheck=s.ADD_ATTR:(We===He&&(We=clone(We)),addToSet(We,s.ADD_ATTR,Lt))),s.ADD_URI_SAFE_ATTR&&addToSet(wt,s.ADD_URI_SAFE_ATTR,Lt),s.FORBID_CONTENTS&&(bt===St&&(bt=clone(bt)),addToSet(bt,s.FORBID_CONTENTS,Lt)),s.ADD_FORBID_CONTENTS&&(bt===St&&(bt=clone(bt)),addToSet(bt,s.ADD_FORBID_CONTENTS,Lt)),gt&&(qe["#text"]=!0),at&&addToSet(qe,["html","head","body"]),qe.table&&(addToSet(qe,["tbody"]),delete Xe.tbody),s.TRUSTED_TYPES_POLICY){if("function"!=typeof s.TRUSTED_TYPES_POLICY.createHTML)throw fj('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');if("function"!=typeof s.TRUSTED_TYPES_POLICY.createScriptURL)throw fj('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');ie=s.TRUSTED_TYPES_POLICY,ae=ie.createHTML("")}else void 0===ie&&(ie=function _createTrustedTypesPolicy(s,o){if("object"!=typeof s||"function"!=typeof s.createPolicy)return null;let i=null;const a="data-tt-policy-suffix";o&&o.hasAttribute(a)&&(i=o.getAttribute(a));const u="dompurify"+(i?"#"+i:"");try{return s.createPolicy(u,{createHTML:s=>s,createScriptURL:s=>s})}catch(s){return console.warn("TrustedTypes policy "+u+" could not be created."),null}}($,a)),null!==ie&&"string"==typeof ae&&(ae=ie.createHTML(""));LC&&LC(s),Ft=s}},Ut=addToSet({},[..._j,...Aj,...Cj]),Vt=addToSet({},[...Nj,...Bj]),zt=function _forceRemove(s){WC(DOMPurify.removed,{element:s});try{ee(s).removeChild(s)}catch(o){z(s)}},Wt=function _removeAttribute(s,o){try{WC(DOMPurify.removed,{attribute:o.getAttributeNode(s),from:o})}catch(s){WC(DOMPurify.removed,{attribute:null,from:o})}if(o.removeAttribute(s),"is"===s)if(ut||pt)try{zt(o)}catch(s){}else try{o.setAttribute(s,"")}catch(s){}},Jt=function _initDocument(s){let i=null,a=null;if(lt)s="<remove></remove>"+s;else{const o=GC(s,/^[\r\n\t ]+/);a=o&&o[0]}"application/xhtml+xml"===Rt&&Ct===At&&(s='<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>'+s+"</body></html>");const u=ie?ie.createHTML(s):s;if(Ct===At)try{i=(new B).parseFromString(u,Rt)}catch(s){}if(!i||!i.documentElement){i=ce.createDocument(Ct,"template",null);try{i.documentElement.innerHTML=jt?ae:u}catch(s){}}const _=i.body||i.documentElement;return s&&a&&_.insertBefore(o.createTextNode(a),_.childNodes[0]||null),Ct===At?de.call(i,at?"html":"body")[0]:at?i.documentElement:_},Ht=function _createNodeIterator(s){return le.call(s.ownerDocument||s,s,C.SHOW_ELEMENT|C.SHOW_COMMENT|C.SHOW_TEXT|C.SHOW_PROCESSING_INSTRUCTION|C.SHOW_CDATA_SECTION,null)},Kt=function _isClobbered(s){return s instanceof L&&("string"!=typeof s.nodeName||"string"!=typeof s.textContent||"function"!=typeof s.removeChild||!(s.attributes instanceof j)||"function"!=typeof s.removeAttribute||"function"!=typeof s.setAttribute||"string"!=typeof s.namespaceURI||"function"!=typeof s.insertBefore||"function"!=typeof s.hasChildNodes)},Gt=function _isNode(s){return"function"==typeof w&&s instanceof w};function _executeHooks(s,o,i){UC(s,(s=>{s.call(DOMPurify,o,i,Ft)}))}const Yt=function _sanitizeElements(s){let o=null;if(_executeHooks(ye.beforeSanitizeElements,s,null),Kt(s))return zt(s),!0;const i=Lt(s.nodeName);if(_executeHooks(ye.uponSanitizeElement,s,{tagName:i,allowedTags:qe}),it&&s.hasChildNodes()&&!Gt(s.firstElementChild)&&ej(/<[/\w!]/g,s.innerHTML)&&ej(/<[/\w!]/g,s.textContent))return zt(s),!0;if(it&&s.namespaceURI===At&&"style"===i&&Gt(s.firstElementChild))return zt(s),!0;if(s.nodeType===hP)return zt(s),!0;if(it&&s.nodeType===dP&&ej(/<[/\w]/g,s.data))return zt(s),!0;if(Xe[i]||!(et.tagCheck instanceof Function&&et.tagCheck(i))&&!qe[i]){if(!Xe[i]&&Qt(i)){if(Ye.tagNameCheck instanceof RegExp&&ej(Ye.tagNameCheck,i))return!1;if(Ye.tagNameCheck instanceof Function&&Ye.tagNameCheck(i))return!1}if(gt&&!bt[i]){const o=ee(s)||s.parentNode,i=Z(s)||s.childNodes;if(i&&o){for(let a=i.length-1;a>=0;--a){const u=V(i[a],!0);u.__removalCount=(s.__removalCount||0)+1,o.insertBefore(u,Y(s))}}}return zt(s),!0}return s instanceof x&&!function _checkValidNamespace(s){let o=ee(s);o&&o.tagName||(o={namespaceURI:Ct,tagName:"template"});const i=HC(s.tagName),a=HC(o.tagName);return!!Pt[s.namespaceURI]&&(s.namespaceURI===Ot?o.namespaceURI===At?"svg"===i:o.namespaceURI===kt?"svg"===i&&("annotation-xml"===a||Tt[a]):Boolean(Ut[i]):s.namespaceURI===kt?o.namespaceURI===At?"math"===i:o.namespaceURI===Ot?"math"===i&&Nt[a]:Boolean(Vt[i]):s.namespaceURI===At?!(o.namespaceURI===Ot&&!Nt[a])&&!(o.namespaceURI===kt&&!Tt[a])&&!Vt[i]&&(Mt[i]||!Ut[i]):!("application/xhtml+xml"!==Rt||!Pt[s.namespaceURI]))}(s)?(zt(s),!0):"noscript"!==i&&"noembed"!==i&&"noframes"!==i||!ej(/<\/no(script|embed|frames)/i,s.innerHTML)?(ot&&s.nodeType===pP&&(o=s.textContent,UC([be,Se,_e],(s=>{o=YC(o,s," ")})),s.textContent!==o&&(WC(DOMPurify.removed,{element:s.cloneNode()}),s.textContent=o)),_executeHooks(ye.afterSanitizeElements,s,null),!1):(zt(s),!0)},Xt=function _isValidAttribute(s,i,a){if(Qe[i])return!1;if(dt&&("id"===i||"name"===i)&&(a in o||a in Bt))return!1;if(rt&&!Qe[i]&&ej(we,i));else if(tt&&ej(xe,i));else if(et.attributeCheck instanceof Function&&et.attributeCheck(i,s));else if(!We[i]||Qe[i]){if(!(Qt(s)&&(Ye.tagNameCheck instanceof RegExp&&ej(Ye.tagNameCheck,s)||Ye.tagNameCheck instanceof Function&&Ye.tagNameCheck(s))&&(Ye.attributeNameCheck instanceof RegExp&&ej(Ye.attributeNameCheck,i)||Ye.attributeNameCheck instanceof Function&&Ye.attributeNameCheck(i,s))||"is"===i&&Ye.allowCustomizedBuiltInElements&&(Ye.tagNameCheck instanceof RegExp&&ej(Ye.tagNameCheck,a)||Ye.tagNameCheck instanceof Function&&Ye.tagNameCheck(a))))return!1}else if(wt[i]);else if(ej($e,YC(a,Te,"")));else if("src"!==i&&"xlink:href"!==i&&"href"!==i||"script"===s||0!==XC(a,"data:")||!_t[s]){if(nt&&!ej(Pe,YC(a,Te,"")));else if(a)return!1}else;return!0},Qt=function _isBasicCustomElement(s){return"annotation-xml"!==s&&GC(s,Re)},Zt=function _sanitizeAttributes(s){_executeHooks(ye.beforeSanitizeAttributes,s,null);const{attributes:o}=s;if(!o||Kt(s))return;const i={attrName:"",attrValue:"",keepAttr:!0,allowedAttributes:We,forceKeepAttr:void 0};let a=o.length;for(;a--;){const u=o[a],{name:_,namespaceURI:w,value:x}=u,C=Lt(_),j=x;let L="value"===_?j:QC(j);if(i.attrName=C,i.attrValue=L,i.keepAttr=!0,i.forceKeepAttr=void 0,_executeHooks(ye.uponSanitizeAttribute,s,i),L=i.attrValue,!mt||"id"!==C&&"name"!==C||(Wt(_,s),L="user-content-"+L),it&&ej(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i,L)){Wt(_,s);continue}if("attributename"===C&&GC(L,"href")){Wt(_,s);continue}if(i.forceKeepAttr)continue;if(!i.keepAttr){Wt(_,s);continue}if(!st&&ej(/\/>/i,L)){Wt(_,s);continue}ot&&UC([be,Se,_e],(s=>{L=YC(L,s," ")}));const B=Lt(s.nodeName);if(Xt(B,C,L)){if(ie&&"object"==typeof $&&"function"==typeof $.getAttributeType)if(w);else switch($.getAttributeType(B,C)){case"TrustedHTML":L=ie.createHTML(L);break;case"TrustedScriptURL":L=ie.createScriptURL(L)}if(L!==j)try{w?s.setAttributeNS(w,_,L):s.setAttribute(_,L),Kt(s)?zt(s):zC(DOMPurify.removed)}catch(o){Wt(_,s)}}else Wt(_,s)}_executeHooks(ye.afterSanitizeAttributes,s,null)},er=function _sanitizeShadowDOM(s){let o=null;const i=Ht(s);for(_executeHooks(ye.beforeSanitizeShadowDOM,s,null);o=i.nextNode();)_executeHooks(ye.uponSanitizeShadowNode,o,null),Yt(o),Zt(o),o.content instanceof u&&er(o.content);_executeHooks(ye.afterSanitizeShadowDOM,s,null)};return DOMPurify.sanitize=function(s){let o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},a=null,_=null,x=null,C=null;if(jt=!s,jt&&(s="\x3c!--\x3e"),"string"!=typeof s&&!Gt(s)){if("function"!=typeof s.toString)throw fj("toString is not a function");if("string"!=typeof(s=s.toString()))throw fj("dirty is not a string, aborting")}if(!DOMPurify.isSupported)return s;if(ct||qt(o),DOMPurify.removed=[],"string"==typeof s&&(yt=!1),yt){if(s.nodeName){const o=Lt(s.nodeName);if(!qe[o]||Xe[o])throw fj("root node is forbidden and cannot be sanitized in-place")}}else if(s instanceof w)a=Jt("\x3c!----\x3e"),_=a.ownerDocument.importNode(s,!0),_.nodeType===uP&&"BODY"===_.nodeName||"HTML"===_.nodeName?a=_:a.appendChild(_);else{if(!ut&&!ot&&!at&&-1===s.indexOf("<"))return ie&&ht?ie.createHTML(s):s;if(a=Jt(s),!a)return ut?null:ht?ae:""}a&&lt&&zt(a.firstChild);const j=Ht(yt?s:a);for(;x=j.nextNode();)Yt(x),Zt(x),x.content instanceof u&&er(x.content);if(yt)return s;if(ut){if(ot){a.normalize();let s=a.innerHTML;UC([be,Se,_e],(o=>{s=YC(s,o," ")})),a.innerHTML=s}if(pt)for(C=pe.call(a.ownerDocument);a.firstChild;)C.appendChild(a.firstChild);else C=a;return(We.shadowroot||We.shadowrootmode)&&(C=fe.call(i,C,!0)),C}let L=at?a.outerHTML:a.innerHTML;return at&&qe["!doctype"]&&a.ownerDocument&&a.ownerDocument.doctype&&a.ownerDocument.doctype.name&&ej(aP,a.ownerDocument.doctype.name)&&(L="<!DOCTYPE "+a.ownerDocument.doctype.name+">\n"+L),ot&&UC([be,Se,_e],(s=>{L=YC(L,s," ")})),ie&&ht?ie.createHTML(L):L},DOMPurify.setConfig=function(){qt(arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}),ct=!0},DOMPurify.clearConfig=function(){Ft=null,ct=!1},DOMPurify.isValidAttribute=function(s,o,i){Ft||qt({});const a=Lt(s),u=Lt(o);return Xt(a,u,i)},DOMPurify.addHook=function(s,o){"function"==typeof o&&WC(ye[s],o)},DOMPurify.removeHook=function(s,o){if(void 0!==o){const i=VC(ye[s],o);return-1===i?void 0:JC(ye[s],i,1)[0]}return zC(ye[s])},DOMPurify.removeHooks=function(s){ye[s]=[]},DOMPurify.removeAllHooks=function(){ye={afterSanitizeAttributes:[],afterSanitizeElements:[],afterSanitizeShadowDOM:[],beforeSanitizeAttributes:[],beforeSanitizeElements:[],beforeSanitizeShadowDOM:[],uponSanitizeAttribute:[],uponSanitizeElement:[],uponSanitizeShadowNode:[]}},DOMPurify}();gP.addHook&&gP.addHook("beforeSanitizeElements",(function(s){return s.href&&s.setAttribute("rel","noopener noreferrer"),s}));const yP=function Markdown({source:s,className:o="",getConfigs:i=()=>({useUnsafeMarkdown:!1})}){if("string"!=typeof s)return null;const a=new Remarkable({html:!0,typographer:!0,breaks:!0,linkTarget:"_blank"}).use(linkify);a.core.ruler.disable(["replacements","smartquotes"]);const{useUnsafeMarkdown:u}=i(),_=a.render(s),w=sanitizer(_,{useUnsafeMarkdown:u});return s&&_&&w?Re.createElement("div",{className:Jn()(o,"markdown"),dangerouslySetInnerHTML:{__html:w}}):null};function sanitizer(s,{useUnsafeMarkdown:o=!1}={}){const i=o,a=o?[]:["style","class"];return o&&!sanitizer.hasWarnedAboutDeprecation&&(console.warn("useUnsafeMarkdown display configuration parameter is deprecated since >3.26.0 and will be removed in v4.0.0."),sanitizer.hasWarnedAboutDeprecation=!0),gP.sanitize(s,{ADD_ATTR:["target"],FORBID_TAGS:["style","form"],ALLOW_DATA_ATTR:i,FORBID_ATTR:a})}sanitizer.hasWarnedAboutDeprecation=!1;class BaseLayout extends Re.Component{render(){const{errSelectors:s,specSelectors:o,getComponent:i}=this.props,a=i("SvgAssets"),u=i("InfoContainer",!0),_=i("VersionPragmaFilter"),w=i("operations",!0),x=i("Models",!0),C=i("Webhooks",!0),j=i("Row"),L=i("Col"),B=i("errors",!0),$=i("ServersContainer",!0),U=i("SchemesContainer",!0),V=i("AuthorizeBtnContainer",!0),z=i("FilterContainer",!0),Y=o.isSwagger2(),Z=o.isOAS3(),ee=o.isOAS31(),ie=o.isOAS32(),ae=!o.specStr(),ce=o.loadingStatus();let le=null;if("loading"===ce&&(le=Re.createElement("div",{className:"info"},Re.createElement("div",{className:"loading-container"},Re.createElement("div",{className:"loading"})))),"failed"===ce&&(le=Re.createElement("div",{className:"info"},Re.createElement("div",{className:"loading-container"},Re.createElement("h4",{className:"title"},"Failed to load API definition."),Re.createElement(B,null)))),"failedConfig"===ce){const o=s.lastError(),i=o?o.get("message"):"";le=Re.createElement("div",{className:"info failed-config"},Re.createElement("div",{className:"loading-container"},Re.createElement("h4",{className:"title"},"Failed to load remote configuration."),Re.createElement("p",null,i)))}if(!le&&ae&&(le=Re.createElement("h4",null,"No API definition provided.")),le)return Re.createElement("div",{className:"swagger-ui"},Re.createElement("div",{className:"loading-container"},le));const pe=o.servers(),de=o.schemes(),fe=pe&&pe.size,ye=de&&de.size,be=!!o.securityDefinitions();return Re.createElement("div",{className:"swagger-ui"},Re.createElement(a,null),Re.createElement(_,{isSwagger2:Y,isOAS3:Z,isOAS31:ee,isOAS32:ie,alsoShow:Re.createElement(B,null)},Re.createElement(B,null),Re.createElement(j,{className:"information-container"},Re.createElement(L,{mobile:12},Re.createElement(u,null))),fe||ye||be?Re.createElement("div",{className:"scheme-container"},Re.createElement(L,{className:"schemes wrapper",mobile:12},fe||ye?Re.createElement("div",{className:"schemes-server-container"},fe?Re.createElement($,null):null,ye?Re.createElement(U,null):null):null,be?Re.createElement(V,null):null)):null,Re.createElement(z,null),Re.createElement(j,null,Re.createElement(L,{mobile:12,desktop:12},Re.createElement(w,null))),ee&&Re.createElement(j,{className:"webhooks-container"},Re.createElement(L,{mobile:12,desktop:12},Re.createElement(C,null))),Re.createElement(j,null,Re.createElement(L,{mobile:12,desktop:12},Re.createElement(x,null)))))}}const core_components=()=>({components:{App:FO,authorizationPopup:AuthorizationPopup,authorizeBtn:AuthorizeBtn,AuthorizeBtnContainer,authorizeOperationBtn:AuthorizeOperationBtn,auths:Auths,AuthItem:auth_item_Auths,authError:AuthError,oauth2:Oauth2,apiKeyAuth:ApiKeyAuth,basicAuth:BasicAuth,clear:Clear,liveResponse:LiveResponse,InitializedInput,info:HO,InfoContainer,InfoUrl,InfoBasePath,Contact:KO,License:GO,JumpToPath,CopyToClipboardBtn,onlineValidatorBadge:OnlineValidatorBadge,operations:Operations,operation:operation_Operation,OperationSummary,OperationSummaryMethod,OperationSummaryPath,responses:responses_Responses,response:response_Response,ResponseExtension:response_extension,responseBody:ResponseBody,parameters:Parameters,parameterRow:ParameterRow,execute:Execute,headers:headers_Headers,errors:Errors,contentType:ContentType,overview:Overview,footer:Footer,FilterContainer,ParamBody,curl:Curl,Property:property,TryItOutButton,Markdown:yP,BaseLayout,VersionPragmaFilter,VersionStamp:version_stamp,OperationExt:operation_extensions,OperationExtRow:operation_extension_row,ParameterExt:parameter_extension,ParameterIncludeEmpty,OperationTag,OperationContainer,OpenAPIVersion:openapi_version,DeepLink:deep_link,SvgAssets:svg_assets,Example:example_Example,ExamplesSelect,ExamplesSelectValueRetainer}}),form_components=()=>({components:{...Se}}),base=()=>[configsPlugin,util,logs,view,view_legacy,plugins_spec,err,icons,plugins_layout,json_schema_5,json_schema_5_samples,core_components,form_components,swagger_client,auth,downloadUrlPlugin,deep_linking,filter,on_complete,plugins_request_snippets,syntax_highlighting,versions,safe_render()],vP=(0,ze.Map)();function onlyOAS3(s){return(o,i)=>(...a)=>{if(i.getSystem().specSelectors.isOAS3()){const o=s(...a);return"function"==typeof o?o(i):o}return o(...a)}}const bP=onlyOAS3(xs()(null)),SP=onlyOAS3(((s,o)=>s=>s.getSystem().specSelectors.findSchema(o))),_P=onlyOAS3((()=>s=>{const o=s.getSystem().specSelectors.specJson().getIn(["components","schemas"]);return ze.Map.isMap(o)?o:vP})),EP=onlyOAS3((()=>s=>s.getSystem().specSelectors.specJson().hasIn(["servers",0]))),wP=onlyOAS3(Ut(Ns,(s=>s.getIn(["components","securitySchemes"])||null))),wrap_selectors_validOperationMethods=(s,o)=>(i,...a)=>o.specSelectors.isOAS3()?o.oas3Selectors.validOperationMethods():s(...a),xP=bP,kP=bP,OP=bP,AP=bP,CP=bP;const jP=function wrap_selectors_onlyOAS3(s){return(o,i)=>(...a)=>{if(i.getSystem().specSelectors.isOAS3()){let o=i.getState().getIn(["spec","resolvedSubtrees","components","securitySchemes"]);return s(i,o,...a)}return o(...a)}}(Ut((s=>s),(({specSelectors:s})=>s.securityDefinitions()),((s,o)=>{let i=(0,ze.List)();return o?(o.entrySeq().forEach((([s,o])=>{const a=o?.get("type");if("oauth2"===a&&o.get("flows").entrySeq().forEach((([a,u])=>{let _=(0,ze.fromJS)({flow:a,authorizationUrl:u.get("authorizationUrl"),tokenUrl:u.get("tokenUrl"),scopes:u.get("scopes"),type:o.get("type"),description:o.get("description")});i=i.push(new ze.Map({[s]:_.filter((s=>void 0!==s))}))})),"http"!==a&&"apiKey"!==a||(i=i.push(new ze.Map({[s]:o}))),"openIdConnect"===a&&o.get("openIdConnectData")){let a=o.get("openIdConnectData");(a.get("grant_types_supported")||["authorization_code","implicit"]).forEach((u=>{let _=a.get("scopes_supported")&&a.get("scopes_supported").reduce(((s,o)=>s.set(o,"")),new ze.Map),w=(0,ze.fromJS)({flow:u,authorizationUrl:a.get("authorization_endpoint"),tokenUrl:a.get("token_endpoint"),scopes:_,type:"oauth2",openIdConnectUrl:o.get("openIdConnectUrl")});i=i.push(new ze.Map({[s]:w.filter((s=>void 0!==s))}))}))}})),i):i})));function OAS3ComponentWrapFactory(s){return(o,i)=>a=>"function"==typeof i.specSelectors?.isOAS3?i.specSelectors.isOAS3()?Re.createElement(s,Mn()({},a,i,{Ori:o})):Re.createElement(o,a):(console.warn("OAS3 wrapper: couldn't get spec"),null)}const PP=(0,ze.Map)(),selectors_isSwagger2=()=>s=>function isSwagger2(s){const o=s.get("swagger");return"string"==typeof o&&"2.0"===o}(s.getSystem().specSelectors.specJson()),selectors_isOAS30=()=>s=>function isOAS30(s){const o=s.get("openapi");return"string"==typeof o&&/^3\.0\.(?:[1-9]\d*|0)$/.test(o)}(s.getSystem().specSelectors.specJson()),selectors_isOAS3=()=>s=>s.getSystem().specSelectors.isOAS30();function selectors_onlyOAS3(s){return(o,...i)=>a=>{if(a.specSelectors.isOAS3()){const u=s(o,...i);return"function"==typeof u?u(a):u}return null}}const IP=selectors_onlyOAS3((()=>s=>s.specSelectors.specJson().get("servers",PP))),findSchema=(s,o)=>{const i=s.getIn(["resolvedSubtrees","components","schemas",o],null),a=s.getIn(["json","components","schemas",o],null);return i||a||null},TP=selectors_onlyOAS3(((s,{callbacks:o,specPath:i})=>s=>{const a=s.specSelectors.validOperationMethods();return ze.Map.isMap(o)?o.reduce(((s,o,u)=>{if(!ze.Map.isMap(o))return s;const _=o.reduce(((s,o,_)=>{if(!ze.Map.isMap(o))return s;const w=o.entrySeq().filter((([s])=>a.includes(s))).map((([s,o])=>({operation:(0,ze.Map)({operation:o}),method:s,path:_,callbackName:u,specPath:i.concat([u,_,s])})));return s.concat(w)}),(0,ze.List)());return s.concat(_)}),(0,ze.List)()).groupBy((s=>s.callbackName)).map((s=>s.toArray())).toObject():{}})),callbacks=({callbacks:s,specPath:o,specSelectors:i,getComponent:a})=>{const u=i.callbacksOperations({callbacks:s,specPath:o}),_=Object.keys(u),w=a("OperationContainer",!0);return 0===_.length?Re.createElement("span",null,"No callbacks"):Re.createElement("div",null,_.map((s=>Re.createElement("div",{key:`${s}`},Re.createElement("h2",null,s),u[s].map((o=>Re.createElement(w,{key:`${s}-${o.path}-${o.method}`,op:o.operation,tag:"callbacks",method:o.method,path:o.path,specPath:o.specPath,allowTryItOut:!1})))))))},getDefaultRequestBodyValue=(s,o,i,a)=>{const u=s.getIn(["content",o])??(0,ze.OrderedMap)(),_=u.get("schema",(0,ze.OrderedMap)()),w=void 0!==u.get("examples"),x=u.get("example"),C=w?u.getIn(["examples",i,"value"]):x;return stringify(a.getSampleSchema(_,o,{includeWriteOnly:!0},C))},components_request_body=({userHasEditedBody:s,requestBody:o,requestBodyValue:i,requestBodyInclusionSetting:a,requestBodyErrors:u,getComponent:_,getConfigs:w,specSelectors:x,fn:C,contentType:j,isExecute:L,specPath:B,onChange:$,onChangeIncludeEmpty:U,activeExamplesKey:V,updateActiveExamplesKey:z,setRetainRequestBodyValueFlag:Y})=>{const handleFile=s=>{$(s.target.files[0])},setIsIncludedOptions=s=>{let o={key:s,shouldDispatchInit:!1,defaultValue:!0};return"no value"===a.get(s,"no value")&&(o.shouldDispatchInit=!0),o},Z=_("Markdown",!0),ee=_("modelExample"),ie=_("RequestBodyEditor"),ae=_("HighlightCode",!0),ce=_("ExamplesSelectValueRetainer"),le=_("Example"),pe=_("ParameterIncludeEmpty"),{showCommonExtensions:de}=w(),fe=o?.get("description")??null,ye=o?.get("content")??new ze.OrderedMap;j=j||ye.keySeq().first()||"";const be=ye.get(j)??(0,ze.OrderedMap)(),Se=be.get("schema",(0,ze.OrderedMap)()),_e=be.get("examples",null),we=_e?.map(((s,i)=>{const a=s?.get("value",null);return a&&(s=s.set("value",getDefaultRequestBodyValue(o,j,i,C),a)),s}));u=ze.List.isList(u)?u:(0,ze.List)();if(C.isFileUploadIntended(be?.get("schema"),j)){const s=_("Input");return L?Re.createElement(s,{type:"file",onChange:handleFile}):Re.createElement("i",null,"Example values are not available for ",Re.createElement("code",null,j)," media types.")}if(!be.size)return null;if(C.hasSchemaType(be.get("schema"),"object")&&("application/x-www-form-urlencoded"===j||0===j.indexOf("multipart/"))&&Se.get("properties",(0,ze.OrderedMap)()).size>0){const s=_("JsonSchemaForm"),o=_("ParameterExt"),j=Se.get("properties",(0,ze.OrderedMap)());return i=ze.Map.isMap(i)?i:(0,ze.OrderedMap)(),Re.createElement("div",{className:"table-container"},fe&&Re.createElement(Z,{source:fe}),Re.createElement("table",null,Re.createElement("tbody",null,ze.Map.isMap(j)&&j.entrySeq().map((([j,V])=>{if(V.get("readOnly"))return;const z=V.get("oneOf")?.get(0)?.toJS(),Y=V.get("anyOf")?.get(0)?.toJS();V=(0,ze.fromJS)(C.mergeJsonSchema(V.toJS(),z??Y??{}));let ie=de?getCommonExtensions(V):null;const ae=Se.get("required",(0,ze.List)()).includes(j),ce=C.getSchemaObjectType(V),le=C.getSchemaObjectTypeLabel(V),fe=C.getSchemaObjectType(V?.get("items")),ye=V.get("format"),be=V.get("description"),_e=i.getIn([j,"value"]),we=i.getIn([j,"errors"])||u,xe=a.get(j)||!1;let Pe=C.getSampleSchema(V,!1,{includeWriteOnly:!0});!1===Pe&&(Pe="false"),0===Pe&&(Pe="0"),"string"!=typeof Pe&&"object"===ce&&(Pe=stringify(Pe)),"string"==typeof Pe&&"array"===ce&&(Pe=JSON.parse(Pe));const Te=C.isFileUploadIntended(V),$e=Re.createElement(s,{fn:C,dispatchInitialValue:!Te,schema:V,description:j,getComponent:_,value:void 0===_e?Pe:_e,required:ae,errors:we,onChange:s=>{$(s,[j])}});return Re.createElement("tr",{key:j,className:"parameters","data-property-name":j},Re.createElement("td",{className:"parameters-col_name"},Re.createElement("div",{className:ae?"parameter__name required":"parameter__name"},j,ae?Re.createElement("span",null," *"):null),Re.createElement("div",{className:"parameter__type"},le,ye&&Re.createElement("span",{className:"prop-format"},"($",ye,")"),de&&ie.size?ie.entrySeq().map((([s,i])=>Re.createElement(o,{key:`${s}-${i}`,xKey:s,xVal:i}))):null),Re.createElement("div",{className:"parameter__deprecated"},V.get("deprecated")?"deprecated":null)),Re.createElement("td",{className:"parameters-col_description"},Re.createElement(Z,{source:be}),L?Re.createElement("div",null,"object"===ce||"object"===fe?Re.createElement(ee,{getComponent:_,specPath:B.push("schema"),getConfigs:w,isExecute:L,specSelectors:x,schema:V,example:$e}):$e,ae?null:Re.createElement(pe,{onChange:s=>U(j,s),isIncluded:xe,isIncludedOptions:setIsIncludedOptions(j),isDisabled:Array.isArray(_e)?0!==_e.length:!isEmptyValue(_e)})):null))})))))}const xe=getDefaultRequestBodyValue(o,j,V,C);let Pe=null;getKnownSyntaxHighlighterLanguage(xe)&&(Pe="json");const Te=L?Re.createElement(ie,{value:i,errors:u,defaultValue:xe,onChange:$,getComponent:_}):Re.createElement(ae,{className:"body-param__example",language:Pe},stringify(i)||xe);return Re.createElement("div",null,fe&&Re.createElement(Z,{source:fe}),we?Re.createElement(ce,{userHasEditedBody:s,examples:we,currentKey:V,currentUserInputValue:i,onSelect:s=>{z(s)},updateValue:$,defaultToFirstExample:!0,getComponent:_,setRetainRequestBodyValueFlag:Y}):null,Re.createElement(ee,{getComponent:_,getConfigs:w,specSelectors:x,expandDepth:1,isExecute:L,schema:be.get("schema"),specPath:B.push("content",j,"schema"),example:Te,includeWriteOnly:!0}),we?Re.createElement(le,{example:we.get(V),getComponent:_,getConfigs:w}):null)};class operation_link_OperationLink extends Re.Component{render(){const{link:s,name:o,getComponent:i}=this.props,a=i("Markdown",!0);let u=s.get("operationId")||s.get("operationRef"),_=s.get("parameters")&&s.get("parameters").toJS(),w=s.get("description");return Re.createElement("div",{className:"operation-link"},Re.createElement("div",{className:"description"},Re.createElement("b",null,Re.createElement("code",null,o)),w?Re.createElement(a,{source:w}):null),Re.createElement("pre",null,"Operation `",u,"`",Re.createElement("br",null),Re.createElement("br",null),"Parameters ",function padString(s,o){if("string"!=typeof o)return"";return o.split("\n").map(((o,i)=>i>0?Array(s+1).join(" ")+o:o)).join("\n")}(0,JSON.stringify(_,null,2))||"{}",Re.createElement("br",null)))}}const NP=operation_link_OperationLink,components_servers=({servers:s,currentServer:o,setSelectedServer:i,setServerVariableValue:a,getServerVariable:u,getEffectiveServerValue:_})=>{const w=(s.find((s=>s.get("url")===o))||(0,ze.OrderedMap)()).get("variables")||(0,ze.OrderedMap)(),x=0!==w.size;(0,Re.useEffect)((()=>{o||i(s.first()?.get("url"))}),[]),(0,Re.useEffect)((()=>{const u=s.find((s=>s.get("url")===o));if(!u)return void i(s.first().get("url"));(u.get("variables")||(0,ze.OrderedMap)()).map(((s,i)=>{a({server:o,key:i,val:s.get("default")||""})}))}),[o,s]);const C=(0,Re.useCallback)((s=>{i(s.target.value)}),[i]),j=(0,Re.useCallback)((s=>{const i=s.target.getAttribute("data-variable"),u=s.target.value;a({server:o,key:i,val:u})}),[a,o]);return Re.createElement("div",{className:"servers"},Re.createElement("label",{htmlFor:"servers"},Re.createElement("select",{onChange:C,value:o,id:"servers"},s.valueSeq().map((s=>Re.createElement("option",{value:s.get("url"),key:s.get("url")},s.get("url"),s.get("description")&&` - ${s.get("description")}`))).toArray())),x&&Re.createElement("div",null,Re.createElement("div",{className:"computed-url"},"Computed URL:",Re.createElement("code",null,_(o))),Re.createElement("h4",null,"Server variables"),Re.createElement("table",null,Re.createElement("tbody",null,w.entrySeq().map((([s,i])=>Re.createElement("tr",{key:s},Re.createElement("td",null,s),Re.createElement("td",null,i.get("enum")?Re.createElement("select",{"data-variable":s,onChange:j},i.get("enum").map((i=>Re.createElement("option",{selected:i===u(o,s),key:i,value:i},i)))):Re.createElement("input",{type:"text",value:u(o,s)||"",onChange:j,"data-variable":s})))))))))};class ServersContainer extends Re.Component{render(){const{specSelectors:s,oas3Selectors:o,oas3Actions:i,getComponent:a}=this.props,u=s.servers(),_=a("Servers");return u&&u.size?Re.createElement("div",null,Re.createElement("span",{className:"servers-title"},"Servers"),Re.createElement(_,{servers:u,currentServer:o.selectedServer(),setSelectedServer:i.setSelectedServer,setServerVariableValue:i.setServerVariableValue,getServerVariable:o.serverVariableValue,getEffectiveServerValue:o.serverEffectiveValue})):null}}const MP=Function.prototype;class RequestBodyEditor extends Re.PureComponent{static defaultProps={onChange:MP,userHasEditedBody:!1};constructor(s,o){super(s,o),this.state={value:stringify(s.value)||s.defaultValue},s.onChange(s.value)}applyDefaultValue=s=>{const{onChange:o,defaultValue:i}=s||this.props;return this.setState({value:i}),o(i)};onChange=s=>{this.props.onChange(stringify(s))};onDomChange=s=>{const o=s.target.value;this.setState({value:o},(()=>this.onChange(o)))};UNSAFE_componentWillReceiveProps(s){this.props.value!==s.value&&s.value!==this.state.value&&this.setState({value:stringify(s.value)}),!s.value&&s.defaultValue&&this.state.value&&this.applyDefaultValue(s)}render(){let{getComponent:s,errors:o}=this.props,{value:i}=this.state,a=o.size>0;const u=s("TextArea");return Re.createElement("div",{className:"body-param"},Re.createElement(u,{className:Jn()("body-param__text",{invalid:a}),title:o.size?o.join(", "):"",value:i,onChange:this.onDomChange}))}}class HttpAuth extends Re.Component{constructor(s,o){super(s,o);let{name:i,schema:a}=this.props,u=this.getValue();this.state={name:i,schema:a,value:u}}getValue(){let{name:s,authorized:o}=this.props;return o&&o.getIn([s,"value"])}onChange=s=>{let{onChange:o}=this.props,{value:i,name:a}=s.target,u=Object.assign({},this.state.value);a?u[a]=i:u=i,this.setState({value:u},(()=>o(this.state)))};render(){let{schema:s,getComponent:o,errSelectors:i,name:a,authSelectors:u}=this.props;const _=o("Input"),w=o("Row"),x=o("Col"),C=o("authError"),j=o("Markdown",!0),L=o("JumpToPath",!0),B=(s.get("scheme")||"").toLowerCase(),$=u.selectAuthPath(a);let U=this.getValue(),V=i.allErrors().filter((s=>s.get("authId")===a));if("basic"===B){let o=U?U.get("username"):null;return Re.createElement("div",null,Re.createElement("h4",null,Re.createElement("code",null,a),"  (http, Basic)",Re.createElement(L,{path:$})),o&&Re.createElement("h6",null,"Authorized"),Re.createElement(w,null,Re.createElement(j,{source:s.get("description")})),Re.createElement(w,null,Re.createElement("label",{htmlFor:"auth-basic-username"},"Username:"),o?Re.createElement("code",null," ",o," "):Re.createElement(x,null,Re.createElement(_,{id:"auth-basic-username",type:"text",required:"required",name:"username","aria-label":"auth-basic-username",onChange:this.onChange,autoFocus:!0}))),Re.createElement(w,null,Re.createElement("label",{htmlFor:"auth-basic-password"},"Password:"),o?Re.createElement("code",null," ****** "):Re.createElement(x,null,Re.createElement(_,{id:"auth-basic-password",autoComplete:"new-password",name:"password",type:"password","aria-label":"auth-basic-password",onChange:this.onChange}))),V.valueSeq().map(((s,o)=>Re.createElement(C,{error:s,key:o}))))}return"bearer"===B?Re.createElement("div",null,Re.createElement("h4",null,Re.createElement("code",null,a),"  (http, Bearer)",Re.createElement(L,{path:$})),U&&Re.createElement("h6",null,"Authorized"),Re.createElement(w,null,Re.createElement(j,{source:s.get("description")})),Re.createElement(w,null,Re.createElement("label",{htmlFor:"auth-bearer-value"},"Value:"),U?Re.createElement("code",null," ****** "):Re.createElement(x,null,Re.createElement(_,{id:"auth-bearer-value",type:"text","aria-label":"auth-bearer-value",onChange:this.onChange,autoFocus:!0}))),V.valueSeq().map(((s,o)=>Re.createElement(C,{error:s,key:o})))):Re.createElement("div",null,Re.createElement("em",null,Re.createElement("b",null,a)," HTTP authentication: unsupported scheme ",`'${B}'`))}}class operation_servers_OperationServers extends Re.Component{setSelectedServer=s=>{const{path:o,method:i}=this.props;return this.forceUpdate(),this.props.setSelectedServer(s,`${o}:${i}`)};setServerVariableValue=s=>{const{path:o,method:i}=this.props;return this.forceUpdate(),this.props.setServerVariableValue({...s,namespace:`${o}:${i}`})};getSelectedServer=()=>{const{path:s,method:o}=this.props;return this.props.getSelectedServer(`${s}:${o}`)};getServerVariable=(s,o)=>{const{path:i,method:a}=this.props;return this.props.getServerVariable({namespace:`${i}:${a}`,server:s},o)};getEffectiveServerValue=s=>{const{path:o,method:i}=this.props;return this.props.getEffectiveServerValue({server:s,namespace:`${o}:${i}`})};render(){const{operationServers:s,pathServers:o,getComponent:i}=this.props;if(!s&&!o)return null;const a=i("Servers"),u=s||o,_=s?"operation":"path";return Re.createElement("div",{className:"opblock-section operation-servers"},Re.createElement("div",{className:"opblock-section-header"},Re.createElement("div",{className:"tab-header"},Re.createElement("h4",{className:"opblock-title"},"Servers"))),Re.createElement("div",{className:"opblock-description-wrapper"},Re.createElement("h4",{className:"message"},"These ",_,"-level options override the global server options."),Re.createElement(a,{servers:u,currentServer:this.getSelectedServer(),setSelectedServer:this.setSelectedServer,setServerVariableValue:this.setServerVariableValue,getServerVariable:this.getServerVariable,getEffectiveServerValue:this.getEffectiveServerValue})))}}const RP={Callbacks:callbacks,HttpAuth,RequestBody:components_request_body,Servers:components_servers,ServersContainer,RequestBodyEditor,OperationServers:operation_servers_OperationServers,operationLink:NP},DP=new Remarkable("commonmark");DP.block.ruler.enable(["table"]),DP.set({linkTarget:"_blank"});const LP=OAS3ComponentWrapFactory((({source:s,className:o="",getConfigs:i=()=>({useUnsafeMarkdown:!1})})=>{if("string"!=typeof s)return null;if(s){const{useUnsafeMarkdown:a}=i(),u=sanitizer(DP.render(s),{useUnsafeMarkdown:a});let _;return"string"==typeof u&&(_=u.trim()),Re.createElement("div",{dangerouslySetInnerHTML:{__html:_},className:Jn()(o,"renderedMarkdown")})}return null})),FP=OAS3ComponentWrapFactory((({Ori:s,...o})=>{const{schema:i,getComponent:a,errSelectors:u,authorized:_,onAuthChange:w,name:x,authSelectors:C}=o,j=a("HttpAuth");return"http"===i.get("type")?Re.createElement(j,{key:x,schema:i,name:x,errSelectors:u,authorized:_,getComponent:a,onChange:w,authSelectors:C}):Re.createElement(s,o)})),BP=OAS3ComponentWrapFactory(OnlineValidatorBadge);class ModelComponent extends Re.Component{render(){let{getConfigs:s,schema:o,Ori:i}=this.props,a=["model-box"],u=null;return!0===o.get("deprecated")&&(a.push("deprecated"),u=Re.createElement("span",{className:"model-deprecated-warning"},"Deprecated:")),Re.createElement("div",{className:a.join(" ")},u,Re.createElement(i,Mn()({},this.props,{getConfigs:s,depth:1,expandDepth:this.props.expandDepth||0})))}}const $P=OAS3ComponentWrapFactory(ModelComponent),qP=OAS3ComponentWrapFactory((({Ori:s,...o})=>{const{schema:i,getComponent:a,errors:u,onChange:_,fn:w}=o,x=w.isFileUploadIntended(i),C=a("Input");return x?Re.createElement(C,{type:"file",className:u.length?"invalid":"",title:u.length?u:"",onChange:s=>{_(s.target.files[0])},disabled:s.isDisabled}):Re.createElement(s,o)})),UP={Markdown:LP,AuthItem:FP,OpenAPIVersion:function OAS30ComponentWrapFactory(s){return(o,i)=>a=>"function"==typeof i.specSelectors?.isOAS30?i.specSelectors.isOAS30()?Re.createElement(s,Mn()({},a,i,{Ori:o})):Re.createElement(o,a):(console.warn("OAS30 wrapper: couldn't get spec"),null)}((s=>{const{Ori:o}=s;return Re.createElement(o,{oasVersion:"3.0"})})),JsonSchema_string:qP,model:$P,onlineValidatorBadge:BP},VP="oas3_set_servers",zP="oas3_set_request_body_value",WP="oas3_set_request_body_retain_flag",JP="oas3_set_request_body_inclusion",HP="oas3_set_active_examples_member",KP="oas3_set_request_content_type",GP="oas3_set_response_content_type",YP="oas3_set_server_variable_value",XP="oas3_set_request_body_validate_error",QP="oas3_clear_request_body_validate_error",ZP="oas3_clear_request_body_value";function setSelectedServer(s,o){return{type:VP,payload:{selectedServerUrl:s,namespace:o}}}function setRequestBodyValue({value:s,pathMethod:o}){return{type:zP,payload:{value:s,pathMethod:o}}}const setRetainRequestBodyValueFlag=({value:s,pathMethod:o})=>({type:WP,payload:{value:s,pathMethod:o}});function setRequestBodyInclusion({value:s,pathMethod:o,name:i}){return{type:JP,payload:{value:s,pathMethod:o,name:i}}}function setActiveExamplesMember({name:s,pathMethod:o,contextType:i,contextName:a}){return{type:HP,payload:{name:s,pathMethod:o,contextType:i,contextName:a}}}function setRequestContentType({value:s,pathMethod:o}){return{type:KP,payload:{value:s,pathMethod:o}}}function setResponseContentType({value:s,path:o,method:i}){return{type:GP,payload:{value:s,path:o,method:i}}}function setServerVariableValue({server:s,namespace:o,key:i,val:a}){return{type:YP,payload:{server:s,namespace:o,key:i,val:a}}}const setRequestBodyValidateError=({path:s,method:o,validationErrors:i})=>({type:XP,payload:{path:s,method:o,validationErrors:i}}),clearRequestBodyValidateError=({path:s,method:o})=>({type:QP,payload:{path:s,method:o}}),initRequestBodyValidateError=({pathMethod:s})=>({type:QP,payload:{path:s[0],method:s[1]}}),clearRequestBodyValue=({pathMethod:s})=>({type:ZP,payload:{pathMethod:s}});var eI=__webpack_require__(60680),tI=__webpack_require__.n(eI);const oas3_selectors_onlyOAS3=s=>(o,...i)=>a=>{if(a.getSystem().specSelectors.isOAS3()){const u=s(o,...i);return"function"==typeof u?u(a):u}return null};const rI=oas3_selectors_onlyOAS3(((s,o)=>{const i=o?[o,"selectedServer"]:["selectedServer"];return s.getIn(i)||""})),nI=oas3_selectors_onlyOAS3(((s,o,i)=>s.getIn(["requestData",o,i,"bodyValue"])||null)),sI=oas3_selectors_onlyOAS3(((s,o,i)=>s.getIn(["requestData",o,i,"retainBodyValue"])||!1)),selectDefaultRequestBodyValue=(s,o,i)=>s=>{const{oas3Selectors:a,specSelectors:u,fn:_}=s.getSystem();if(u.isOAS3()){const s=a.requestContentType(o,i);if(s)return getDefaultRequestBodyValue(u.specResolvedSubtree(["paths",o,i,"requestBody"]),s,a.activeExamplesMember(o,i,"requestBody","requestBody"),_)}return null},oI=oas3_selectors_onlyOAS3(((s,o,i)=>s=>{const{oas3Selectors:a,specSelectors:u,fn:_}=s;let w=!1;const x=a.requestContentType(o,i);let C=a.requestBodyValue(o,i);const j=u.specResolvedSubtree(["paths",o,i,"requestBody"]);if(!j)return!1;if(ze.Map.isMap(C)&&(C=stringify(C.mapEntries((s=>ze.Map.isMap(s[1])?[s[0],s[1].get("value")]:s)).toJS())),ze.List.isList(C)&&(C=stringify(C)),x){const s=getDefaultRequestBodyValue(j,x,a.activeExamplesMember(o,i,"requestBody","requestBody"),_);w=!!C&&C!==s}return w})),iI=oas3_selectors_onlyOAS3(((s,o,i)=>s.getIn(["requestData",o,i,"bodyInclusion"])||(0,ze.Map)())),aI=oas3_selectors_onlyOAS3(((s,o,i)=>s.getIn(["requestData",o,i,"errors"])||null)),cI=oas3_selectors_onlyOAS3(((s,o,i,a,u)=>s.getIn(["examples",o,i,a,u,"activeExample"])||null)),lI=oas3_selectors_onlyOAS3(((s,o,i)=>s.getIn(["requestData",o,i,"requestContentType"])||null)),uI=oas3_selectors_onlyOAS3(((s,o,i)=>s.getIn(["requestData",o,i,"responseContentType"])||null)),pI=oas3_selectors_onlyOAS3(((s,o,i)=>{let a;if("string"!=typeof o){const{server:s,namespace:u}=o;a=u?[u,"serverVariableValues",s,i]:["serverVariableValues",s,i]}else{a=["serverVariableValues",o,i]}return s.getIn(a)||null})),hI=oas3_selectors_onlyOAS3(((s,o)=>{let i;if("string"!=typeof o){const{server:s,namespace:a}=o;i=a?[a,"serverVariableValues",s]:["serverVariableValues",s]}else{i=["serverVariableValues",o]}return s.getIn(i)||(0,ze.OrderedMap)()})),dI=oas3_selectors_onlyOAS3(((s,o)=>{var i,a;if("string"!=typeof o){const{server:u,namespace:_}=o;a=u,i=_?s.getIn([_,"serverVariableValues",a]):s.getIn(["serverVariableValues",a])}else a=o,i=s.getIn(["serverVariableValues",a]);i=i||(0,ze.OrderedMap)();let u=a;return i.map(((s,o)=>{u=u.replace(new RegExp(`{${tI()(o)}}`,"g"),s)})),u})),fI=function validateRequestBodyIsRequired(s){return(...o)=>i=>{const a=i.getSystem().specSelectors.specJson();let u=[...o][1]||[];return!a.getIn(["paths",...u,"requestBody","required"])||s(...o)}}(((s,o)=>((s,o)=>(o=o||[],!!s.getIn(["requestData",...o,"bodyValue"])))(s,o))),validateShallowRequired=(s,{oas3RequiredRequestBodyContentType:o,oas3RequestContentType:i,oas3RequestBodyValue:a})=>{let u=[];if(!ze.Map.isMap(a))return u;let _=[];return Object.keys(o.requestContentType).forEach((s=>{if(s===i){o.requestContentType[s].forEach((s=>{_.indexOf(s)<0&&_.push(s)}))}})),_.forEach((s=>{a.getIn([s,"value"])||u.push(s)})),u},mI=xs()(["get","put","post","delete","options","head","patch","trace"]),gI={[VP]:(s,{payload:{selectedServerUrl:o,namespace:i}})=>{const a=i?[i,"selectedServer"]:["selectedServer"];return s.setIn(a,o)},[zP]:(s,{payload:{value:o,pathMethod:i}})=>{let[a,u]=i;if(!ze.Map.isMap(o))return s.setIn(["requestData",a,u,"bodyValue"],o);let _=s.getIn(["requestData",a,u,"bodyValue"])||(0,ze.Map)();ze.Map.isMap(_)||(_=(0,ze.Map)());let w=_;const[...x]=o.keys();return x.forEach((s=>{let i=o.getIn([s]);w.has(s)&&ze.Map.isMap(i)||(w=w.setIn([s,"value"],i))})),s.setIn(["requestData",a,u,"bodyValue"],w)},[WP]:(s,{payload:{value:o,pathMethod:i}})=>{let[a,u]=i;return s.setIn(["requestData",a,u,"retainBodyValue"],o)},[JP]:(s,{payload:{value:o,pathMethod:i,name:a}})=>{let[u,_]=i;return s.setIn(["requestData",u,_,"bodyInclusion",a],o)},[HP]:(s,{payload:{name:o,pathMethod:i,contextType:a,contextName:u}})=>{let[_,w]=i;return s.setIn(["examples",_,w,a,u,"activeExample"],o)},[KP]:(s,{payload:{value:o,pathMethod:i}})=>{let[a,u]=i;return s.setIn(["requestData",a,u,"requestContentType"],o)},[GP]:(s,{payload:{value:o,path:i,method:a}})=>s.setIn(["requestData",i,a,"responseContentType"],o),[YP]:(s,{payload:{server:o,namespace:i,key:a,val:u}})=>{const _=i?[i,"serverVariableValues",o,a]:["serverVariableValues",o,a];return s.setIn(_,u)},[XP]:(s,{payload:{path:o,method:i,validationErrors:a}})=>{let u=[];if(u.push("Required field is not provided"),a.missingBodyValue)return s.setIn(["requestData",o,i,"errors"],(0,ze.fromJS)(u));if(a.missingRequiredKeys&&a.missingRequiredKeys.length>0){const{missingRequiredKeys:_}=a;return s.updateIn(["requestData",o,i,"bodyValue"],(0,ze.fromJS)({}),(s=>_.reduce(((s,o)=>s.setIn([o,"errors"],(0,ze.fromJS)(u))),s)))}return console.warn("unexpected result: SET_REQUEST_BODY_VALIDATE_ERROR"),s},[QP]:(s,{payload:{path:o,method:i}})=>{const a=s.getIn(["requestData",o,i,"bodyValue"]);if(!ze.Map.isMap(a))return s.setIn(["requestData",o,i,"errors"],(0,ze.fromJS)([]));const[...u]=a.keys();return u?s.updateIn(["requestData",o,i,"bodyValue"],(0,ze.fromJS)({}),(s=>u.reduce(((s,o)=>s.setIn([o,"errors"],(0,ze.fromJS)([]))),s))):s},[ZP]:(s,{payload:{pathMethod:o}})=>{let[i,a]=o;const u=s.getIn(["requestData",i,a,"bodyValue"]);return u?ze.Map.isMap(u)?s.setIn(["requestData",i,a,"bodyValue"],(0,ze.Map)()):s.setIn(["requestData",i,a,"bodyValue"],""):s}};function oas3({getSystem:s}){const o=(s=>(o,i=null)=>{const{getConfigs:a,fn:u}=s(),{fileUploadMediaTypes:_}=a();if("string"==typeof i&&_.some((s=>i.startsWith(s))))return!0;const w=ze.Map.isMap(o);if(!w&&!as()(o))return!1;const x=w?o.get("format"):o.format;return u.hasSchemaType(o,"string")&&["binary","byte"].includes(x)})(s);return{components:RP,wrapComponents:UP,statePlugins:{spec:{wrapSelectors:_e,selectors:xe},auth:{wrapSelectors:we},oas3:{actions:{...Pe},reducers:gI,selectors:{...Te}}},fn:{isFileUploadIntended:o,isFileUploadIntendedOAS30:o}}}const webhooks=({specSelectors:s,getComponent:o})=>{const i=s.selectWebhooksOperations();if(!i)return null;const a=Object.keys(i),u=o("OperationContainer",!0);return 0===a.length?null:Re.createElement("div",{className:"webhooks"},Re.createElement("h2",null,"Webhooks"),a.map((s=>Re.createElement("div",{key:`${s}-webhook`},i[s].map((o=>Re.createElement(u,{key:`${s}-${o.method}-webhook`,op:o.operation,tag:"webhooks",method:o.method,path:s,specPath:(0,ze.List)(o.specPath),allowTryItOut:!1})))))))},oas31_components_license=({getComponent:s,specSelectors:o})=>{const i=o.selectLicenseNameField(),a=o.selectLicenseUrl(),u=s("Link");return Re.createElement("div",{className:"info__license"},a?Re.createElement("div",{className:"info__license__url"},Re.createElement(u,{target:"_blank",href:sanitizeUrl(a)},i)):Re.createElement("span",null,i))},oas31_components_contact=({getComponent:s,specSelectors:o})=>{const i=o.selectContactNameField(),a=o.selectContactUrl(),u=o.selectContactEmailField(),_=s("Link");return Re.createElement("div",{className:"info__contact"},a&&Re.createElement("div",null,Re.createElement(_,{href:sanitizeUrl(a),target:"_blank"},i," - Website")),u&&Re.createElement(_,{href:sanitizeUrl(`mailto:${u}`)},a?`Send email to ${i}`:`Contact ${i}`))},oas31_components_info=({getComponent:s,specSelectors:o})=>{const i=o.version(),a=o.url(),u=o.basePath(),_=o.host(),w=o.selectInfoSummaryField(),x=o.selectInfoDescriptionField(),C=o.selectInfoTitleField(),j=o.selectInfoTermsOfServiceUrl(),L=o.selectExternalDocsUrl(),B=o.selectExternalDocsDescriptionField(),$=o.contact(),U=o.license(),V=s("Markdown",!0),z=s("Link"),Y=s("VersionStamp"),Z=s("OpenAPIVersion"),ee=s("InfoUrl"),ie=s("InfoBasePath"),ae=s("License",!0),ce=s("Contact",!0),le=s("JsonSchemaDialect",!0);return Re.createElement("div",{className:"info"},Re.createElement("hgroup",{className:"main"},Re.createElement("h1",{className:"title"},C,Re.createElement("span",null,i&&Re.createElement(Y,{version:i}),Re.createElement(Z,{oasVersion:"3.1"}))),(_||u)&&Re.createElement(ie,{host:_,basePath:u}),a&&Re.createElement(ee,{getComponent:s,url:a})),w&&Re.createElement("p",{className:"info__summary"},w),Re.createElement("div",{className:"info__description description"},Re.createElement(V,{source:x})),j&&Re.createElement("div",{className:"info__tos"},Re.createElement(z,{target:"_blank",href:sanitizeUrl(j)},"Terms of service")),$.size>0&&Re.createElement(ce,null),U.size>0&&Re.createElement(ae,null),L&&Re.createElement(z,{className:"info__extdocs",target:"_blank",href:sanitizeUrl(L)},B||L),Re.createElement(le,null))},json_schema_dialect=({getComponent:s,specSelectors:o})=>{const i=o.selectJsonSchemaDialectField(),a=o.selectJsonSchemaDialectDefault(),u=s("Link");return Re.createElement(Re.Fragment,null,i&&i===a&&Re.createElement("p",{className:"info__jsonschemadialect"},"JSON Schema dialect:"," ",Re.createElement(u,{target:"_blank",href:sanitizeUrl(i)},i)),i&&i!==a&&Re.createElement("div",{className:"error-wrapper"},Re.createElement("div",{className:"no-margin"},Re.createElement("div",{className:"errors"},Re.createElement("div",{className:"errors-wrapper"},Re.createElement("h4",{className:"center"},"Warning"),Re.createElement("p",{className:"message"},Re.createElement("strong",null,"OpenAPI.jsonSchemaDialect")," field contains a value different from the default value of"," ",Re.createElement(u,{target:"_blank",href:a},a),". Values different from the default one are currently not supported. Please either omit the field or provide it with the default value."))))))},version_pragma_filter=({bypass:s,isSwagger2:o,isOAS3:i,isOAS31:a,alsoShow:u,children:_})=>s?Re.createElement("div",null,_):o&&(i||a)?Re.createElement("div",{className:"version-pragma"},u,Re.createElement("div",{className:"version-pragma__message version-pragma__message--ambiguous"},Re.createElement("div",null,Re.createElement("h3",null,"Unable to render this definition"),Re.createElement("p",null,Re.createElement("code",null,"swagger")," and ",Re.createElement("code",null,"openapi")," fields cannot be present in the same Swagger or OpenAPI definition. Please remove one of the fields."),Re.createElement("p",null,"Supported version fields are ",Re.createElement("code",null,'swagger: "2.0"'),","," ",Re.createElement("code",null,"openapi: 3.0.x"),", or ",Re.createElement("code",null,"openapi: 3.1.x")," (for example, ",Re.createElement("code",null,"openapi: 3.1.0"),").")))):o||i||a?Re.createElement("div",null,_):Re.createElement("div",{className:"version-pragma"},u,Re.createElement("div",{className:"version-pragma__message version-pragma__message--missing"},Re.createElement("div",null,Re.createElement("h3",null,"Unable to render this definition"),Re.createElement("p",null,"The provided definition does not specify a valid version field."),Re.createElement("p",null,"Please indicate a valid Swagger or OpenAPI version field. Supported version fields are ",Re.createElement("code",null,'swagger: "2.0"'),","," ",Re.createElement("code",null,"openapi: 3.0.x"),", or ",Re.createElement("code",null,"openapi: 3.1.x")," (for example, ",Re.createElement("code",null,"openapi: 3.1.0"),").")))),getModelName=s=>"string"==typeof s&&s.includes("#/components/schemas/")?(s=>{const o=s.replace(/~1/g,"/").replace(/~0/g,"~");try{return decodeURIComponent(o)}catch{return o}})(s.replace(/^.*#\/components\/schemas\//,"")):null,yI=(0,Re.forwardRef)((({schema:s,getComponent:o,onToggle:i=()=>{},specPath:a},u)=>{const _=o("JSONSchema202012"),w=getModelName(s.get("$$ref")),x=(0,Re.useCallback)(((s,o)=>{i(w,o)}),[w,i]);return Re.createElement(_,{name:w,schema:s.toJS(),ref:u,onExpand:x,identifier:a.toJS().join("_")})})),vI=yI,models=({specActions:s,specSelectors:o,layoutSelectors:i,layoutActions:a,getComponent:u,getConfigs:_,fn:w})=>{const x=o.selectSchemas(),C=Object.keys(x).length>0,j=["components","schemas"],{docExpansion:L,defaultModelsExpandDepth:B}=_(),$=B>0&&"none"!==L,U=i.isShown(j,$),V=u("Collapse"),z=u("JSONSchema202012"),Y=u("ArrowUpIcon"),Z=u("ArrowDownIcon"),{getTitle:ee}=w.jsonSchema202012.useFn();(0,Re.useEffect)((()=>{const a=Object.entries(x).some((([s])=>i.isShown([...j,s],!1))),u=U&&(B>1||a),_=null!=o.specResolvedSubtree(j);u&&!_&&s.requestResolvedSubtree(j)}),[U,B]);const ie=(0,Re.useCallback)((()=>{a.show(j,!U)}),[U]),ae=(0,Re.useCallback)((s=>{null!==s&&a.readyToScroll(j,s)}),[]),handleJSONSchema202012Ref=s=>o=>{null!==o&&a.readyToScroll([...j,s],o)},handleJSONSchema202012Expand=i=>(u,_)=>{const w=[...j,i];if(_){null!=o.specResolvedSubtree(w)||s.requestResolvedSubtree([...j,i]),a.show(w,!0)}else a.show(w,!1)};return!C||B<0?null:Re.createElement("section",{className:Jn()("models",{"is-open":U}),ref:ae},Re.createElement("h4",null,Re.createElement("button",{"aria-expanded":U,className:"models-control",onClick:ie},Re.createElement("span",null,"Schemas"),U?Re.createElement(Y,null):Re.createElement(Z,null))),Re.createElement(V,{isOpened:U},Object.entries(x).map((([s,o])=>{const i=ee(o,{lookup:"basic"})||s;return Re.createElement(z,{key:s,ref:handleJSONSchema202012Ref(s),schema:o,name:i,onExpand:handleJSONSchema202012Expand(s)})}))))},mutual_tls_auth=({schema:s,getComponent:o,name:i,authSelectors:a})=>{const u=o("JumpToPath",!0),_=a.selectAuthPath(i);return Re.createElement("div",null,Re.createElement("h4",null,i," (mutualTLS) ",Re.createElement(u,{path:_})),Re.createElement("p",null,"Mutual TLS is required by this API/Operation. Certificates are managed via your Operating System and/or your browser."),Re.createElement("p",null,s.get("description")))};class auths_Auths extends Re.Component{constructor(s,o){super(s,o),this.state={}}onAuthChange=s=>{let{name:o}=s;this.setState({[o]:s})};submitAuth=s=>{s.preventDefault();let{authActions:o}=this.props;o.authorizeWithPersistOption(this.state)};logoutClick=s=>{s.preventDefault();let{authActions:o,definitions:i}=this.props,a=i.map(((s,o)=>o)).toArray();this.setState(a.reduce(((s,o)=>(s[o]="",s)),{})),o.logoutWithPersistOption(a)};close=s=>{s.preventDefault();let{authActions:o}=this.props;o.showDefinitions(!1)};render(){let{definitions:s,getComponent:o,authSelectors:i,errSelectors:a}=this.props;const u=o("AuthItem"),_=o("oauth2",!0),w=o("Button"),x=i.authorized(),C=s.filter(((s,o)=>!!x.get(o))),j=s.filter((s=>"oauth2"!==s.get("type")&&"mutualTLS"!==s.get("type"))),L=s.filter((s=>"oauth2"===s.get("type"))),B=s.filter((s=>"mutualTLS"===s.get("type")));return Re.createElement("div",{className:"auth-container"},j.size>0&&Re.createElement("form",{onSubmit:this.submitAuth},j.map(((s,_)=>Re.createElement(u,{key:_,schema:s,name:_,getComponent:o,onAuthChange:this.onAuthChange,authorized:x,errSelectors:a,authSelectors:i}))).toArray(),Re.createElement("div",{className:"auth-btn-wrapper"},j.size===C.size?Re.createElement(w,{className:"btn modal-btn auth",onClick:this.logoutClick,"aria-label":"Remove authorization"},"Logout"):Re.createElement(w,{type:"submit",className:"btn modal-btn auth authorize","aria-label":"Apply credentials"},"Authorize"),Re.createElement(w,{className:"btn modal-btn auth btn-done",onClick:this.close},"Close"))),L.size>0?Re.createElement("div",null,Re.createElement("div",{className:"scope-def"},Re.createElement("p",null,"Scopes are used to grant an application different levels of access to data on behalf of the end user. Each API may declare one or more scopes."),Re.createElement("p",null,"API requires the following scopes. Select which ones you want to grant to Swagger UI.")),s.filter((s=>"oauth2"===s.get("type"))).map(((s,o)=>Re.createElement("div",{key:o},Re.createElement(_,{authorized:x,schema:s,name:o})))).toArray()):null,B.size>0&&Re.createElement("div",null,B.map(((s,_)=>Re.createElement(u,{key:_,schema:s,name:_,getComponent:o,onAuthChange:this.onAuthChange,authorized:x,errSelectors:a,authSelectors:i}))).toArray()))}}const bI=auths_Auths,isOAS31=s=>{const o=s.get("openapi");return"string"==typeof o&&/^3\.1\.(?:[1-9]\d*|0)$/.test(o)},fn_createOnlyOAS31Selector=s=>(o,...i)=>a=>{if(a.getSystem().specSelectors.isOAS31()){const u=s(o,...i);return"function"==typeof u?u(a):u}return null},createOnlyOAS31SelectorWrapper=s=>(o,i)=>(a,...u)=>{if(i.getSystem().specSelectors.isOAS31()){const _=s(a,...u);return"function"==typeof _?_(o,i):_}return o(...u)},fn_createSystemSelector=s=>(o,...i)=>a=>{const u=s(o,a,...i);return"function"==typeof u?u(a):u},createOnlyOAS31ComponentWrapper=s=>(o,i)=>a=>i.specSelectors.isOAS31()?Re.createElement(s,Mn()({},a,{originalComponent:o,getSystem:i.getSystem})):Re.createElement(o,a),wrapOAS31Fn=(s,o)=>{const{fn:i,specSelectors:a}=o;return Object.fromEntries(Object.entries(s).map((([s,o])=>{const u=i[s];return[s,(...s)=>a.isOAS31()?o(...s):"function"==typeof u?u(...s):void 0]})))},SI=createOnlyOAS31ComponentWrapper((({getSystem:s})=>{const o=s().getComponent("OAS31License",!0);return Re.createElement(o,null)})),_I=createOnlyOAS31ComponentWrapper((({getSystem:s})=>{const o=s().getComponent("OAS31Contact",!0);return Re.createElement(o,null)})),EI=createOnlyOAS31ComponentWrapper((({getSystem:s})=>{const o=s().getComponent("OAS31Info",!0);return Re.createElement(o,null)})),getProperties=(s,{includeReadOnly:o,includeWriteOnly:i})=>{if(!s?.properties)return{};const a=Object.entries(s.properties).filter((([,s])=>(!(!0===s?.readOnly)||o)&&(!(!0===s?.writeOnly)||i)));return Object.fromEntries(a)},makeGetSchemaKeywords=s=>{if("function"!=typeof s)return null;const o=s();return()=>[...o,"discriminator","xml","externalDocs","example","$$ref"]},wI=createOnlyOAS31ComponentWrapper((({getSystem:s,...o})=>{const i=s(),{getComponent:a,fn:u,getConfigs:_}=i,w=_(),x=window?.location?.pathname??"/";if(wI.ModelWithJSONSchemaContext&&wI.pathname===x)return Re.createElement(wI.ModelWithJSONSchemaContext,o);const C=a("OAS31Model"),j=a("withJSONSchema202012SystemContext");return wI.ModelWithJSONSchemaContext=j(C,{config:{default$schema:"https://spec.openapis.org/oas/3.1/dialect/base",defaultExpandedLevels:w.defaultModelExpandDepth,includeReadOnly:o.includeReadOnly,includeWriteOnly:o.includeWriteOnly},fn:{getProperties:u.jsonSchema202012.getProperties,isExpandable:u.jsonSchema202012.isExpandable,getSchemaKeywords:makeGetSchemaKeywords(u.jsonSchema202012.getSchemaKeywords)}}),wI.pathname=x,Re.createElement(wI.ModelWithJSONSchemaContext,o)}));wI.ModelWithJSONSchemaContext=null,wI.pathname=null;const xI=wI,kI=createOnlyOAS31ComponentWrapper((({getSystem:s})=>{const{getComponent:o,fn:i,getConfigs:a}=s(),u=a(),_=window?.location?.pathname??"/";if(kI.ModelsWithJSONSchemaContext&&kI.pathname===_)return Re.createElement(kI.ModelsWithJSONSchemaContext,null);const w=o("OAS31Models",!0),x=o("withJSONSchema202012SystemContext");return kI.ModelsWithJSONSchemaContext=x(w,{config:{default$schema:"https://spec.openapis.org/oas/3.1/dialect/base",defaultExpandedLevels:u.defaultModelsExpandDepth-1,includeReadOnly:!0,includeWriteOnly:!0},fn:{getProperties:i.jsonSchema202012.getProperties,isExpandable:i.jsonSchema202012.isExpandable,getSchemaKeywords:makeGetSchemaKeywords(i.jsonSchema202012.getSchemaKeywords)}}),kI.pathname=_,Re.createElement(kI.ModelsWithJSONSchemaContext,null)}));kI.ModelsWithJSONSchemaContext=null,kI.pathname=null;const OI=kI,wrap_components_version_pragma_filter=(s,o)=>s=>{const i=o.specSelectors.isOAS31(),a=o.getComponent("OAS31VersionPragmaFilter");return Re.createElement(a,Mn()({isOAS31:i},s))},AI=createOnlyOAS31ComponentWrapper((({originalComponent:s,...o})=>{const{getComponent:i,schema:a,name:u}=o,_=i("MutualTLSAuth",!0);return"mutualTLS"===a.get("type")?Re.createElement(_,{schema:a,name:u}):Re.createElement(s,o)})),CI=AI,jI=createOnlyOAS31ComponentWrapper((({getSystem:s,...o})=>{const i=s().getComponent("OAS31Auths",!0);return Re.createElement(i,o)})),PI=(0,ze.Map)(),II=Ut(((s,o)=>o.specSelectors.specJson()),isOAS31),selectors_webhooks=()=>s=>{const o=s.specSelectors.specJson().get("webhooks");return ze.Map.isMap(o)?o:PI},TI=Ut([(s,o)=>o.specSelectors.webhooks(),(s,o)=>o.specSelectors.validOperationMethods(),(s,o)=>o.specSelectors.specResolvedSubtree(["webhooks"])],((s,o)=>s.reduce(((s,i,a)=>{if(!ze.Map.isMap(i))return s;const u=i.entrySeq().filter((([s])=>o.includes(s))).map((([s,o])=>({operation:(0,ze.Map)({operation:o}),method:s,path:a,specPath:["webhooks",a,s]})));return s.concat(u)}),(0,ze.List)()).groupBy((s=>s.path)).map((s=>s.toArray())).toObject())),selectors_license=()=>s=>{const o=s.specSelectors.info().get("license");return ze.Map.isMap(o)?o:PI},selectLicenseNameField=()=>s=>s.specSelectors.license().get("name","License"),selectLicenseUrlField=()=>s=>s.specSelectors.license().get("url"),NI=Ut([(s,o)=>o.specSelectors.url(),(s,o)=>o.oas3Selectors.selectedServer(),(s,o)=>o.specSelectors.selectLicenseUrlField()],((s,o,i)=>{if(i)return safeBuildUrl(i,s,{selectedServer:o})})),selectLicenseIdentifierField=()=>s=>s.specSelectors.license().get("identifier"),selectors_contact=()=>s=>{const o=s.specSelectors.info().get("contact");return ze.Map.isMap(o)?o:PI},selectContactNameField=()=>s=>s.specSelectors.contact().get("name","the developer"),selectContactEmailField=()=>s=>s.specSelectors.contact().get("email"),selectContactUrlField=()=>s=>s.specSelectors.contact().get("url"),MI=Ut([(s,o)=>o.specSelectors.url(),(s,o)=>o.oas3Selectors.selectedServer(),(s,o)=>o.specSelectors.selectContactUrlField()],((s,o,i)=>{if(i)return safeBuildUrl(i,s,{selectedServer:o})})),selectInfoTitleField=()=>s=>s.specSelectors.info().get("title"),selectInfoSummaryField=()=>s=>s.specSelectors.info().get("summary"),selectInfoDescriptionField=()=>s=>s.specSelectors.info().get("description"),selectInfoTermsOfServiceField=()=>s=>s.specSelectors.info().get("termsOfService"),RI=Ut([(s,o)=>o.specSelectors.url(),(s,o)=>o.oas3Selectors.selectedServer(),(s,o)=>o.specSelectors.selectInfoTermsOfServiceField()],((s,o,i)=>{if(i)return safeBuildUrl(i,s,{selectedServer:o})})),selectExternalDocsDescriptionField=()=>s=>s.specSelectors.externalDocs().get("description"),selectExternalDocsUrlField=()=>s=>s.specSelectors.externalDocs().get("url"),DI=Ut([(s,o)=>o.specSelectors.url(),(s,o)=>o.oas3Selectors.selectedServer(),(s,o)=>o.specSelectors.selectExternalDocsUrlField()],((s,o,i)=>{if(i)return safeBuildUrl(i,s,{selectedServer:o})})),selectJsonSchemaDialectField=()=>s=>s.specSelectors.specJson().get("jsonSchemaDialect"),selectJsonSchemaDialectDefault=()=>"https://spec.openapis.org/oas/3.1/dialect/base",LI=Ut(((s,o)=>o.specSelectors.definitions()),((s,o)=>o.specSelectors.specResolvedSubtree(["components","schemas"])),((s,o)=>ze.Map.isMap(s)?ze.Map.isMap(o)?Object.entries(s.toJS()).reduce(((s,[i,a])=>{const u=o.get(i);return s[i]=u?.toJS()||a,s}),{}):s.toJS():{})),wrap_selectors_isOAS3=(s,o)=>(i,...a)=>o.specSelectors.isOAS31()||s(...a),FI=createOnlyOAS31SelectorWrapper((()=>(s,o)=>o.oas31Selectors.selectLicenseUrl())),BI=createOnlyOAS31SelectorWrapper((()=>(s,o)=>{const i=o.specSelectors.securityDefinitions();let a=s();return i?(i.entrySeq().forEach((([s,o])=>{const i=o?.get("type");"mutualTLS"===i&&(a=a.push(new ze.Map({[s]:o})))})),a):a})),$I=Ut([(s,o)=>o.specSelectors.url(),(s,o)=>o.oas3Selectors.selectedServer(),(s,o)=>o.specSelectors.selectLicenseUrlField(),(s,o)=>o.specSelectors.selectLicenseIdentifierField()],((s,o,i,a)=>i?safeBuildUrl(i,s,{selectedServer:o}):a?`https://spdx.org/licenses/${a}.html`:void 0)),keywords_Example=({schema:s,getSystem:o})=>{const{fn:i,getComponent:a}=o(),{hasKeyword:u}=i.jsonSchema202012.useFn(),_=a("JSONSchema202012JSONViewer");return u(s,"example")?Re.createElement(_,{name:"Example",value:s.example,className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--example"}):null},keywords_Xml=({schema:s,getSystem:o})=>{const i=s?.xml||{},{fn:a,getComponent:u,getConfigs:_}=o(),{showExtensions:w}=_(),{useComponent:x,useIsExpanded:C,usePath:j,useLevel:L}=a.jsonSchema202012,{path:B}=j("xml"),{isExpanded:$,setExpanded:U,setCollapsed:V}=C("xml"),[z,Y]=L(),Z=w?getExtensions(i):[],ee=!!(i.name||i.namespace||i.prefix||Z.length>0),ie=x("Accordion"),ae=x("ExpandDeepButton"),ce=u("OpenAPI31Extensions"),le=u("JSONSchema202012PathContext")(),pe=u("JSONSchema202012LevelContext")(),de=(0,Re.useCallback)((()=>{$?V():U()}),[$,U,V]),fe=(0,Re.useCallback)(((s,o)=>{o?U({deep:!0}):V({deep:!0})}),[U,V]);return 0===Object.keys(i).length?null:Re.createElement(le.Provider,{value:B},Re.createElement(pe.Provider,{value:Y},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--xml","data-json-schema-level":z},ee?Re.createElement(Re.Fragment,null,Re.createElement(ie,{expanded:$,onChange:de},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"XML")),Re.createElement(ae,{expanded:$,onClick:fe})):Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"XML"),!0===i.attribute&&Re.createElement("span",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--muted"},"attribute"),!0===i.wrapped&&Re.createElement("span",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--muted"},"wrapped"),Re.createElement("strong",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--primary"},"object"),Re.createElement("ul",{className:Jn()("json-schema-2020-12-keyword__children",{"json-schema-2020-12-keyword__children--collapsed":!$})},$&&Re.createElement(Re.Fragment,null,i.name&&Re.createElement("li",{className:"json-schema-2020-12-property"},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword"},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"name"),Re.createElement("span",{className:"json-schema-2020-12-keyword__value json-schema-2020-12-keyword__value--secondary"},i.name))),i.namespace&&Re.createElement("li",{className:"json-schema-2020-12-property"},Re.createElement("div",{className:"json-schema-2020-12-keyword"},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"namespace"),Re.createElement("span",{className:"json-schema-2020-12-keyword__value json-schema-2020-12-keyword__value--secondary"},i.namespace))),i.prefix&&Re.createElement("li",{className:"json-schema-2020-12-property"},Re.createElement("div",{className:"json-schema-2020-12-keyword"},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"prefix"),Re.createElement("span",{className:"json-schema-2020-12-keyword__value json-schema-2020-12-keyword__value--secondary"},i.prefix)))),Z.length>0&&Re.createElement(ce,{openAPISpecObj:i,openAPIExtensions:Z,getSystem:o})))))},Discriminator_DiscriminatorMapping=({discriminator:s})=>{const o=s?.mapping||{};return 0===Object.keys(o).length?null:Object.entries(o).map((([s,o])=>Re.createElement("div",{key:`${s}-${o}`,className:"json-schema-2020-12-keyword"},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},s),Re.createElement("span",{className:"json-schema-2020-12-keyword__value json-schema-2020-12-keyword__value--secondary"},o))))},keywords_Discriminator_Discriminator=({schema:s,getSystem:o})=>{const i=s?.discriminator||{},{fn:a,getComponent:u,getConfigs:_}=o(),{showExtensions:w}=_(),{useComponent:x,useIsExpanded:C,usePath:j,useLevel:L}=a.jsonSchema202012,B="discriminator",{path:$}=j(B),{isExpanded:U,setExpanded:V,setCollapsed:z}=C(B),[Y,Z]=L(),ee=w?getExtensions(i):[],ie=!!(i.mapping||ee.length>0),ae=x("Accordion"),ce=x("ExpandDeepButton"),le=u("OpenAPI31Extensions"),pe=u("JSONSchema202012PathContext")(),de=u("JSONSchema202012LevelContext")(),fe=(0,Re.useCallback)((()=>{U?z():V()}),[U,V,z]),ye=(0,Re.useCallback)(((s,o)=>{o?V({deep:!0}):z({deep:!0})}),[V,z]);return 0===Object.keys(i).length?null:Re.createElement(pe.Provider,{value:$},Re.createElement(de.Provider,{value:Z},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--discriminator","data-json-schema-level":Y},ie?Re.createElement(Re.Fragment,null,Re.createElement(ae,{expanded:U,onChange:fe},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"Discriminator")),Re.createElement(ce,{expanded:U,onClick:ye})):Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"Discriminator"),i.propertyName&&Re.createElement("span",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--muted"},i.propertyName),Re.createElement("strong",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--primary"},"object"),Re.createElement("ul",{className:Jn()("json-schema-2020-12-keyword__children",{"json-schema-2020-12-keyword__children--collapsed":!U})},U&&Re.createElement("li",{className:"json-schema-2020-12-property"},Re.createElement(Discriminator_DiscriminatorMapping,{discriminator:i})),ee.length>0&&Re.createElement(le,{openAPISpecObj:i,openAPIExtensions:ee,getSystem:o})))))},keywords_OpenAPIExtensions=({openAPISpecObj:s,getSystem:o,openAPIExtensions:i})=>{const{fn:a}=o(),{useComponent:u}=a.jsonSchema202012,_=u("JSONViewer");return i.map((o=>Re.createElement(_,{key:o,name:o,value:s[o],className:"json-schema-2020-12-json-viewer-extension-keyword"})))},keywords_ExternalDocs=({schema:s,getSystem:o})=>{const i=s?.externalDocs||{},{fn:a,getComponent:u,getConfigs:_}=o(),{showExtensions:w}=_(),{useComponent:x,useIsExpanded:C,usePath:j,useLevel:L}=a.jsonSchema202012,B="externalDocs",{path:$}=j(B),{isExpanded:U,setExpanded:V,setCollapsed:z}=C(B),[Y,Z]=L(),ee=w?getExtensions(i):[],ie=!!(i.description||i.url||ee.length>0),ae=x("Accordion"),ce=x("ExpandDeepButton"),le=u("JSONSchema202012KeywordDescription"),pe=u("Link"),de=u("OpenAPI31Extensions"),fe=u("JSONSchema202012PathContext")(),ye=u("JSONSchema202012LevelContext")(),be=(0,Re.useCallback)((()=>{U?z():V()}),[U,V,z]),Se=(0,Re.useCallback)(((s,o)=>{o?V({deep:!0}):z({deep:!0})}),[V,z]);return 0===Object.keys(i).length?null:Re.createElement(fe.Provider,{value:$},Re.createElement(ye.Provider,{value:Z},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--externalDocs","data-json-schema-level":Y},ie?Re.createElement(Re.Fragment,null,Re.createElement(ae,{expanded:U,onChange:be},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"External documentation")),Re.createElement(ce,{expanded:U,onClick:Se})):Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"External documentation"),Re.createElement("strong",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--primary"},"object"),Re.createElement("ul",{className:Jn()("json-schema-2020-12-keyword__children",{"json-schema-2020-12-keyword__children--collapsed":!U})},U&&Re.createElement(Re.Fragment,null,i.description&&Re.createElement("li",{className:"json-schema-2020-12-property"},Re.createElement(le,{schema:i,getSystem:o})),i.url&&Re.createElement("li",{className:"json-schema-2020-12-property"},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword"},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"url"),Re.createElement("span",{className:"json-schema-2020-12-keyword__value json-schema-2020-12-keyword__value--secondary"},Re.createElement(pe,{target:"_blank",href:sanitizeUrl(i.url)},i.url))))),ee.length>0&&Re.createElement(de,{openAPISpecObj:i,openAPIExtensions:ee,getSystem:o})))))},keywords_Description=({schema:s,getSystem:o})=>{if(!s?.description)return null;const{getComponent:i}=o(),a=i("Markdown");return Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--description"},Re.createElement("div",{className:"json-schema-2020-12-core-keyword__value json-schema-2020-12-core-keyword__value--secondary"},Re.createElement(a,{source:s.description})))},qI=createOnlyOAS31ComponentWrapper(keywords_Description),UI=createOnlyOAS31ComponentWrapper((({schema:s,getSystem:o,originalComponent:i})=>{const{getComponent:a}=o(),u=a("JSONSchema202012KeywordDiscriminator"),_=a("JSONSchema202012KeywordXml"),w=a("JSONSchema202012KeywordExample"),x=a("JSONSchema202012KeywordExternalDocs");return Re.createElement(Re.Fragment,null,Re.createElement(i,{schema:s}),Re.createElement(u,{schema:s,getSystem:o}),Re.createElement(_,{schema:s,getSystem:o}),Re.createElement(x,{schema:s,getSystem:o}),Re.createElement(w,{schema:s,getSystem:o}))})),VI=UI,keywords_Properties=({schema:s,getSystem:o})=>{const{fn:i,getComponent:a}=o(),{useComponent:u,usePath:_}=i.jsonSchema202012,{getDependentRequired:w,getProperties:x}=i.jsonSchema202012.useFn(),C=i.jsonSchema202012.useConfig(),j=Array.isArray(s?.required)?s.required:[],{path:L}=_("properties"),B=u("JSONSchema"),$=a("JSONSchema202012PathContext")(),U=x(s,C);return 0===Object.keys(U).length?null:Re.createElement($.Provider,{value:L},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--properties"},Re.createElement("ul",null,Object.entries(U).map((([o,i])=>{const a=j.includes(o),u=w(o,s);return Re.createElement("li",{key:o,className:Jn()("json-schema-2020-12-property",{"json-schema-2020-12-property--required":a})},Re.createElement(B,{name:o,schema:i,dependentRequired:u}))})))))},zI=createOnlyOAS31ComponentWrapper(keywords_Properties);const WI=function oas31_after_load_afterLoad({fn:s,getSystem:o}){if(s.jsonSchema202012){const i=((s,o)=>{const{fn:i}=o();if("function"!=typeof s)return null;const{hasKeyword:a}=i.jsonSchema202012;return o=>s(o)||a(o,"example")||o?.xml||o?.discriminator||o?.externalDocs})(s.jsonSchema202012.isExpandable,o);Object.assign(this.fn.jsonSchema202012,{isExpandable:i,getProperties})}if("function"==typeof s.sampleFromSchema&&s.jsonSchema202012){const i=wrapOAS31Fn({sampleFromSchema:s.jsonSchema202012.sampleFromSchema,sampleFromSchemaGeneric:s.jsonSchema202012.sampleFromSchemaGeneric,createXMLExample:s.jsonSchema202012.createXMLExample,memoizedSampleFromSchema:s.jsonSchema202012.memoizedSampleFromSchema,memoizedCreateXMLExample:s.jsonSchema202012.memoizedCreateXMLExample,getJsonSampleSchema:s.jsonSchema202012.getJsonSampleSchema,getYamlSampleSchema:s.jsonSchema202012.getYamlSampleSchema,getXmlSampleSchema:s.jsonSchema202012.getXmlSampleSchema,getSampleSchema:s.jsonSchema202012.getSampleSchema,mergeJsonSchema:s.jsonSchema202012.mergeJsonSchema,getSchemaObjectTypeLabel:o=>s.jsonSchema202012.getType(immutableToJS(o)),getSchemaObjectType:o=>s.jsonSchema202012.foldType(immutableToJS(o)?.type)},o());Object.assign(this.fn,i)}const i=(s=>(o,i=null)=>{const{fn:a}=s();if(a.isFileUploadIntendedOAS30(o,i))return!0;const u=ze.Map.isMap(o);if(!u&&!as()(o))return!1;const _=u?o.get("contentMediaType"):o.contentMediaType,w=u?o.get("contentEncoding"):o.contentEncoding;return"string"==typeof _&&""!==_||"string"==typeof w&&""!==w})(o),{isFileUploadIntended:a}=wrapOAS31Fn({isFileUploadIntended:i},o());if(this.fn.isFileUploadIntended=a,this.fn.isFileUploadIntendedOAS31=i,s.jsonSchema202012){const{hasSchemaType:i}=wrapOAS31Fn({hasSchemaType:s.jsonSchema202012.hasSchemaType},o());this.fn.hasSchemaType=i}},oas31=({fn:s})=>{const o=s.createSystemSelector||fn_createSystemSelector,i=s.createOnlyOAS31Selector||fn_createOnlyOAS31Selector;return{afterLoad:WI,fn:{isOAS31,createSystemSelector:fn_createSystemSelector,createOnlyOAS31Selector:fn_createOnlyOAS31Selector},components:{Webhooks:webhooks,JsonSchemaDialect:json_schema_dialect,MutualTLSAuth:mutual_tls_auth,OAS31Info:oas31_components_info,OAS31License:oas31_components_license,OAS31Contact:oas31_components_contact,OAS31VersionPragmaFilter:version_pragma_filter,OAS31Model:vI,OAS31Models:models,OAS31Auths:bI,JSONSchema202012KeywordExample:keywords_Example,JSONSchema202012KeywordXml:keywords_Xml,JSONSchema202012KeywordDiscriminator:keywords_Discriminator_Discriminator,JSONSchema202012KeywordExternalDocs:keywords_ExternalDocs,OpenAPI31Extensions:keywords_OpenAPIExtensions},wrapComponents:{InfoContainer:EI,License:SI,Contact:_I,VersionPragmaFilter:wrap_components_version_pragma_filter,Model:xI,Models:OI,AuthItem:CI,auths:jI,JSONSchema202012KeywordDescription:qI,JSONSchema202012KeywordExamples:VI,JSONSchema202012KeywordProperties:zI},statePlugins:{auth:{wrapSelectors:{definitionsToAuthorize:BI}},spec:{selectors:{isOAS31:o(II),license:selectors_license,selectLicenseNameField,selectLicenseUrlField,selectLicenseIdentifierField:i(selectLicenseIdentifierField),selectLicenseUrl:o(NI),contact:selectors_contact,selectContactNameField,selectContactEmailField,selectContactUrlField,selectContactUrl:o(MI),selectInfoTitleField,selectInfoSummaryField:i(selectInfoSummaryField),selectInfoDescriptionField,selectInfoTermsOfServiceField,selectInfoTermsOfServiceUrl:o(RI),selectExternalDocsDescriptionField,selectExternalDocsUrlField,selectExternalDocsUrl:o(DI),webhooks:i(selectors_webhooks),selectWebhooksOperations:i(o(TI)),selectJsonSchemaDialectField,selectJsonSchemaDialectDefault,selectSchemas:o(LI)},wrapSelectors:{isOAS3:wrap_selectors_isOAS3,selectLicenseUrl:FI}},oas31:{selectors:{selectLicenseUrl:i(o($I))}}}}},components_version_pragma_filter=({bypass:s,isSwagger2:o,isOAS3:i,isOAS31:a,isOAS32:u,alsoShow:_,children:w})=>s?Re.createElement("div",null,w):o&&(i||a||u)?Re.createElement("div",{className:"version-pragma"},_,Re.createElement("div",{className:"version-pragma__message version-pragma__message--ambiguous"},Re.createElement("div",null,Re.createElement("h3",null,"Unable to render this definition"),Re.createElement("p",null,Re.createElement("code",null,"swagger")," and ",Re.createElement("code",null,"openapi")," fields cannot be present in the same Swagger or OpenAPI definition. Please remove one of the fields."),Re.createElement("p",null,"Supported version fields are ",Re.createElement("code",null,'swagger: "2.0"')," ","and ",Re.createElement("code",null,"openapi: 3.0.x"),", ",Re.createElement("code",null,"openapi: 3.1.x"),", or"," ",Re.createElement("code",null,"openapi: 3.2.x")," (for example,"," ",Re.createElement("code",null,"openapi: 3.2.0"),").")))):o||i||a||u?Re.createElement("div",null,w):Re.createElement("div",{className:"version-pragma"},_,Re.createElement("div",{className:"version-pragma__message version-pragma__message--missing"},Re.createElement("div",null,Re.createElement("h3",null,"Unable to render this definition"),Re.createElement("p",null,"The provided definition does not specify a valid version field."),Re.createElement("p",null,"Please indicate a valid Swagger or OpenAPI version field. Supported version fields are ",Re.createElement("code",null,'swagger: "2.0"')," ","and ",Re.createElement("code",null,"openapi: 3.0.x"),", ",Re.createElement("code",null,"openapi: 3.1.x"),", or"," ",Re.createElement("code",null,"openapi: 3.2.x")," (for example,"," ",Re.createElement("code",null,"openapi: 3.2.0"),").")))),isOAS32=s=>{const o=s.get("openapi");return"string"==typeof o&&/^3\.2\.(?:[1-9]\d*|0)$/.test(o)},createOnlyOAS32Selector=s=>(o,...i)=>a=>{if(a.getSystem().specSelectors.isOAS32()){const u=s(o,...i);return"function"==typeof u?u(a):u}return null},oas32_fn_createSystemSelector=s=>(o,...i)=>a=>{const u=s(o,a,...i);return"function"==typeof u?u(a):u},createOnlyOAS32ComponentWrapper=s=>(o,i)=>a=>i.specSelectors.isOAS32()?Re.createElement(s,Mn()({},a,{originalComponent:o,getSystem:i.getSystem})):Re.createElement(o,a),wrapOAS32Fn=(s,o)=>{const{fn:i,specSelectors:a}=o;return Object.fromEntries(Object.entries(s).map((([s,o])=>{const u=i[s];return[s,(...s)=>a.isOAS32()?o(...s):"function"==typeof u?u(...s):void 0]})))},JI=createOnlyOAS32ComponentWrapper((s=>{const{getSystem:o}=s,i=o().getComponent("OAS31Contact",!0);return Re.createElement(i,s)})),HI=createOnlyOAS32ComponentWrapper((({getSystem:s})=>{const o=s().getComponent("OAS31Info",!0);return Re.createElement(o,null)})),KI=createOnlyOAS32ComponentWrapper((s=>{const{getSystem:o}=s,i=o().getComponent("OAS31License",!0);return Re.createElement(i,s)})),fn_makeGetSchemaKeywords=s=>{if("function"!=typeof s)return null;const o=s();return()=>[...o,"discriminator","xml","externalDocs","example","$$ref"]},GI=createOnlyOAS32ComponentWrapper((({getSystem:s,...o})=>{const i=s(),{getComponent:a,fn:u,getConfigs:_}=i,w=_(),x=window?.location?.pathname??"/";if(GI.ModelWithJSONSchemaContext&&GI.pathname===x)return Re.createElement(GI.ModelWithJSONSchemaContext,o);const C=a("OAS31Model"),j=a("withJSONSchema202012SystemContext");return GI.ModelWithJSONSchemaContext=j(C,{config:{default$schema:"https://spec.openapis.org/oas/3.2/schema/2025-09-17",defaultExpandedLevels:w.defaultModelExpandDepth,includeReadOnly:o.includeReadOnly,includeWriteOnly:o.includeWriteOnly},fn:{getProperties:u.jsonSchema202012.getProperties,isExpandable:u.jsonSchema202012.isExpandable,getSchemaKeywords:fn_makeGetSchemaKeywords(u.jsonSchema202012.getSchemaKeywords)}}),GI.pathname=x,Re.createElement(GI.ModelWithJSONSchemaContext,o)}));GI.ModelWithJSONSchemaContext=null,GI.pathname=null;const YI=GI,XI=createOnlyOAS32ComponentWrapper((({getSystem:s})=>{const{getComponent:o,fn:i,getConfigs:a}=s(),u=a(),_=window?.location?.pathname??"/";if(XI.ModelsWithJSONSchemaContext&&XI.pathname===_)return Re.createElement(XI.ModelsWithJSONSchemaContext,null);const w=o("OAS31Models",!0),x=o("withJSONSchema202012SystemContext");return XI.ModelsWithJSONSchemaContext=x(w,{config:{default$schema:"https://spec.openapis.org/oas/3.2/schema/2025-09-17",defaultExpandedLevels:u.defaultModelsExpandDepth-1,includeReadOnly:!0,includeWriteOnly:!0},fn:{getProperties:i.jsonSchema202012.getProperties,isExpandable:i.jsonSchema202012.isExpandable,getSchemaKeywords:fn_makeGetSchemaKeywords(i.jsonSchema202012.getSchemaKeywords)}}),XI.pathname=_,Re.createElement(XI.ModelsWithJSONSchemaContext,null)}));XI.ModelsWithJSONSchemaContext=null,XI.pathname=null;const QI=XI,ZI=createOnlyOAS32ComponentWrapper((s=>{const{originalComponent:o}=s;return Re.createElement(o,{oasVersion:"3.2"})})),oas32_wrap_components_version_pragma_filter=(s,o)=>s=>{const i=o.specSelectors.isOAS32(),a=o.getComponent("OAS32VersionPragmaFilter");return Re.createElement(a,Mn()({isOAS32:i},s))},components_keywords_Description=({schema:s,getSystem:o})=>{if(!s?.description)return null;const{getComponent:i}=o(),a=i("Markdown");return Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--description"},Re.createElement("div",{className:"json-schema-2020-12-core-keyword__value json-schema-2020-12-core-keyword__value--secondary"},Re.createElement(a,{source:s.description})))},eT=createOnlyOAS32ComponentWrapper(components_keywords_Description),tT=createOnlyOAS32ComponentWrapper((({schema:s,getSystem:o,originalComponent:i})=>{const{getComponent:a}=o(),u=a("JSONSchema202012KeywordDiscriminator"),_=a("JSONSchema202012KeywordXml"),w=a("JSONSchema202012KeywordExample"),x=a("JSONSchema202012KeywordExternalDocs");return Re.createElement(Re.Fragment,null,Re.createElement(i,{schema:s}),Re.createElement(u,{schema:s,getSystem:o}),Re.createElement(_,{schema:s,getSystem:o}),Re.createElement(x,{schema:s,getSystem:o}),Re.createElement(w,{schema:s,getSystem:o}))})),rT=tT,components_keywords_Properties=({schema:s,getSystem:o})=>{const{fn:i,getComponent:a}=o(),{useComponent:u,usePath:_}=i.jsonSchema202012,{getDependentRequired:w,getProperties:x}=i.jsonSchema202012.useFn(),C=i.jsonSchema202012.useConfig(),j=Array.isArray(s?.required)?s.required:[],{path:L}=_("properties"),B=u("JSONSchema"),$=a("JSONSchema202012PathContext")(),U=x(s,C);return 0===Object.keys(U).length?null:Re.createElement($.Provider,{value:L},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--properties"},Re.createElement("ul",null,Object.entries(U).map((([o,i])=>{const a=j.includes(o),u=w(o,s);return Re.createElement("li",{key:o,className:Jn()("json-schema-2020-12-property",{"json-schema-2020-12-property--required":a})},Re.createElement(B,{name:o,schema:i,dependentRequired:u}))})))))},nT=createOnlyOAS32ComponentWrapper(components_keywords_Properties),sT=xs()(["get","put","post","delete","options","head","patch","trace","query"]),spec_extensions_wrap_selectors_isOAS3=(s,o)=>(i,...a)=>o.specSelectors.isOAS32()||s(...a),oT=(iT=()=>(s,o)=>o.oas32Selectors.validOperationMethods(),(s,o)=>(i,...a)=>{if(o.getSystem().specSelectors.isOAS32()){const u=iT(i,...a);return"function"==typeof u?u(s,o):u}return s(...a)});var iT;const aT=(0,ze.Map)(),selectIsOAS32=(s,o)=>()=>{const s=o.specSelectors.specJson();return isOAS32(s)},spec_extensions_selectors_license=()=>s=>{const o=s.specSelectors.info().get("license");return ze.Map.isMap(o)?o:aT},selectors_selectLicenseNameField=()=>s=>s.specSelectors.license().get("name","License"),selectors_selectLicenseUrlField=()=>s=>s.specSelectors.license().get("url"),cT=Ut([(s,o)=>o.specSelectors.url(),(s,o)=>o.oas3Selectors.selectedServer(),(s,o)=>o.specSelectors.selectLicenseUrlField()],((s,o,i)=>{if(i)return safeBuildUrl(i,s,{selectedServer:o})})),selectors_selectLicenseIdentifierField=()=>s=>s.specSelectors.license().get("identifier"),spec_extensions_selectors_contact=()=>s=>{const o=s.specSelectors.info().get("contact");return ze.Map.isMap(o)?o:aT},selectors_selectContactNameField=()=>s=>s.specSelectors.contact().get("name","the developer"),selectors_selectContactEmailField=()=>s=>s.specSelectors.contact().get("email"),selectors_selectContactUrlField=()=>s=>s.specSelectors.contact().get("url"),lT=Ut([(s,o)=>o.specSelectors.url(),(s,o)=>o.oas3Selectors.selectedServer(),(s,o)=>o.specSelectors.selectContactUrlField()],((s,o,i)=>{if(i)return safeBuildUrl(i,s,{selectedServer:o})})),selectors_selectInfoSummaryField=()=>s=>s.specSelectors.info().get("summary");const uT=function oas32_after_load_afterLoad({fn:s,getSystem:o}){if("function"==typeof s.sampleFromSchema&&s.jsonSchema202012){const i=wrapOAS32Fn({sampleFromSchema:s.jsonSchema202012.sampleFromSchema,sampleFromSchemaGeneric:s.jsonSchema202012.sampleFromSchemaGeneric,createXMLExample:s.jsonSchema202012.createXMLExample,memoizedSampleFromSchema:s.jsonSchema202012.memoizedSampleFromSchema,memoizedCreateXMLExample:s.jsonSchema202012.memoizedCreateXMLExample,getJsonSampleSchema:s.jsonSchema202012.getJsonSampleSchema,getYamlSampleSchema:s.jsonSchema202012.getYamlSampleSchema,getXmlSampleSchema:s.jsonSchema202012.getXmlSampleSchema,getSampleSchema:s.jsonSchema202012.getSampleSchema,mergeJsonSchema:s.jsonSchema202012.mergeJsonSchema,getSchemaObjectTypeLabel:o=>s.jsonSchema202012.getType(immutableToJS(o)),getSchemaObjectType:o=>s.jsonSchema202012.foldType(immutableToJS(o)?.type)},o());Object.assign(this.fn,i)}const i=(s=>(o,i=null)=>{const{fn:a}=s();if(a.isFileUploadIntendedOAS30(o,i))return!0;const u=ze.Map.isMap(o);if(!u&&!as()(o))return!1;const _=u?o.get("contentMediaType"):o.contentMediaType,w=u?o.get("contentEncoding"):o.contentEncoding;return"string"==typeof _&&""!==_||"string"==typeof w&&""!==w})(o),{isFileUploadIntended:a}=wrapOAS32Fn({isFileUploadIntended:i},o());if(this.fn.isFileUploadIntended=a,this.fn.isFileUploadIntendedOAS32=i,s.jsonSchema202012){const{hasSchemaType:i}=wrapOAS32Fn({hasSchemaType:s.jsonSchema202012.hasSchemaType},o());this.fn.hasSchemaType=i}},oas32=({fn:s})=>{const o=s.createSystemSelector||oas32_fn_createSystemSelector;return{afterLoad:uT,fn:{isOAS32,createSystemSelector:oas32_fn_createSystemSelector,createOnlyOAS32Selector},components:{OAS32VersionPragmaFilter:components_version_pragma_filter},wrapComponents:{Contact:JI,InfoContainer:HI,License:KI,Model:YI,Models:QI,OpenAPIVersion:ZI,VersionPragmaFilter:oas32_wrap_components_version_pragma_filter,JSONSchema202012KeywordDescription:eT,JSONSchema202012KeywordExamples:rT,JSONSchema202012KeywordProperties:nT},statePlugins:{spec:{selectors:{isOAS32:o(selectIsOAS32),selectInfoSummaryField:selectors_selectInfoSummaryField,license:spec_extensions_selectors_license,selectLicenseNameField:selectors_selectLicenseNameField,selectLicenseUrlField:selectors_selectLicenseUrlField,selectLicenseIdentifierField:selectors_selectLicenseIdentifierField,selectLicenseUrl:o(cT),contact:spec_extensions_selectors_contact,selectContactNameField:selectors_selectContactNameField,selectContactEmailField:selectors_selectContactEmailField,selectContactUrlField:selectors_selectContactUrlField,selectContactUrl:o(lT)},wrapSelectors:{isOAS3:spec_extensions_wrap_selectors_isOAS3,validOperationMethods:oT}},oas32:{selectors:{validOperationMethods:sT}}}}},pT=es().object,hT=es().bool,dT=(es().oneOfType([pT,hT]),(0,Re.createContext)(null));dT.displayName="JSONSchemaContext";const fT=(0,Re.createContext)(0);fT.displayName="JSONSchemaLevelContext";const mT=(0,Re.createContext)(new Set),gT=(0,Re.createContext)([]);class JSONSchemaIsExpandedState{static Collapsed="collapsed";static Expanded="expanded";static DeeplyExpanded="deeply-expanded"}const useConfig=()=>{const{config:s}=(0,Re.useContext)(dT);return s},useComponent=s=>{const{components:o}=(0,Re.useContext)(dT);return o[s]||null},useFn=(s=void 0)=>{const{fn:o}=(0,Re.useContext)(dT);return void 0!==s?o[s]:o},useJSONSchemaContextState=()=>{const[,s]=(0,Re.useState)(null),{state:o}=(0,Re.useContext)(dT);return{state:o,setState:i=>{i(o),s({})}}},useLevel=()=>{const s=(0,Re.useContext)(fT);return[s,s+1]},usePath=s=>{const o=(0,Re.useContext)(gT),{setState:i}=useJSONSchemaContextState(),a="string"==typeof s?[...o,s]:o;return{path:a,pathMutator:(s,o={deep:!1})=>{const u=a.toString(),updateFn=o=>{o.paths[u]=s,s===JSONSchemaIsExpandedState.Collapsed&&Object.keys(o.paths).forEach((s=>{s.startsWith(u)&&o.paths[s]===JSONSchemaIsExpandedState.DeeplyExpanded&&(o.paths[s]=JSONSchemaIsExpandedState.Expanded)}))},updateDeepFn=o=>{Object.keys(o.paths).forEach((i=>{i.startsWith(u)&&(o.paths[i]=s)}))};o.deep?i(updateDeepFn):i(updateFn)}}},useIsExpanded=s=>{const[o]=useLevel(),{defaultExpandedLevels:i}=useConfig(),{path:a,pathMutator:u}=usePath(s),{path:_}=usePath(),{state:w}=useJSONSchemaContextState(),x=w.paths[a.toString()],C=w.paths[_.toString()]??w.paths[_.slice(0,-1).toString()],j=x??(i-o>0?JSONSchemaIsExpandedState.Expanded:JSONSchemaIsExpandedState.Collapsed),L=j!==JSONSchemaIsExpandedState.Collapsed;(0,Re.useEffect)((()=>{u(C===JSONSchemaIsExpandedState.DeeplyExpanded?JSONSchemaIsExpandedState.DeeplyExpanded:j)}),[C]);return{isExpanded:L,setExpanded:(0,Re.useCallback)(((s={deep:!1})=>{u(s.deep?JSONSchemaIsExpandedState.DeeplyExpanded:JSONSchemaIsExpandedState.Expanded)}),[]),setCollapsed:(0,Re.useCallback)(((s={deep:!1})=>{u(JSONSchemaIsExpandedState.Collapsed,s)}),[])}},useRenderedSchemas=(s=void 0)=>{if(void 0===s)return(0,Re.useContext)(mT);const o=(0,Re.useContext)(mT);return new Set([...o,s])},yT=(0,Re.forwardRef)((({schema:s,name:o="",dependentRequired:i=[],onExpand:a=()=>{},identifier:u=""},_)=>{const w=useFn(),x=u||s?.$id||o,{path:C}=usePath(x),{isExpanded:j,setExpanded:L,setCollapsed:B}=useIsExpanded(x),[$,U]=useLevel(),V=(()=>{const[s]=useLevel();return s>0})(),z=w.isExpandable(s)||i.length>0,Y=(s=>useRenderedSchemas().has(s))(s),Z=useRenderedSchemas(s),ee=w.stringifyConstraints(s),ie=useComponent("Accordion"),ae=useComponent("Keyword$schema"),ce=useComponent("Keyword$vocabulary"),le=useComponent("Keyword$id"),pe=useComponent("Keyword$anchor"),de=useComponent("Keyword$dynamicAnchor"),fe=useComponent("Keyword$ref"),ye=useComponent("Keyword$dynamicRef"),be=useComponent("Keyword$defs"),Se=useComponent("Keyword$comment"),_e=useComponent("KeywordAllOf"),we=useComponent("KeywordAnyOf"),xe=useComponent("KeywordOneOf"),Pe=useComponent("KeywordNot"),Te=useComponent("KeywordIf"),$e=useComponent("KeywordThen"),qe=useComponent("KeywordElse"),ze=useComponent("KeywordDependentSchemas"),We=useComponent("KeywordPrefixItems"),He=useComponent("KeywordItems"),Ye=useComponent("KeywordContains"),Xe=useComponent("KeywordProperties"),Qe=useComponent("KeywordPatternProperties"),et=useComponent("KeywordAdditionalProperties"),tt=useComponent("KeywordPropertyNames"),rt=useComponent("KeywordUnevaluatedItems"),nt=useComponent("KeywordUnevaluatedProperties"),st=useComponent("KeywordType"),ot=useComponent("KeywordEnum"),it=useComponent("KeywordConst"),at=useComponent("KeywordConstraint"),ct=useComponent("KeywordDependentRequired"),lt=useComponent("KeywordContentSchema"),ut=useComponent("KeywordTitle"),pt=useComponent("KeywordDescription"),ht=useComponent("KeywordDefault"),dt=useComponent("KeywordDeprecated"),mt=useComponent("KeywordReadOnly"),gt=useComponent("KeywordWriteOnly"),yt=useComponent("KeywordExamples"),vt=useComponent("ExtensionKeywords"),bt=useComponent("ExpandDeepButton"),St=(0,Re.useCallback)(((s,o)=>{o?L():B(),a(s,o,!1)}),[a,L,B]),_t=(0,Re.useCallback)(((s,o)=>{o?L({deep:!0}):B({deep:!0}),a(s,o,!0)}),[a,L,B]);return Re.createElement(gT.Provider,{value:C},Re.createElement(fT.Provider,{value:U},Re.createElement(mT.Provider,{value:Z},Re.createElement("article",{ref:_,"data-json-schema-level":$,className:Jn()("json-schema-2020-12",{"json-schema-2020-12--embedded":V,"json-schema-2020-12--circular":Y})},Re.createElement("div",{className:"json-schema-2020-12-head"},z&&!Y?Re.createElement(Re.Fragment,null,Re.createElement(ie,{expanded:j,onChange:St},Re.createElement(ut,{title:o,schema:s})),Re.createElement(bt,{expanded:j,onClick:_t})):Re.createElement(ut,{title:o,schema:s}),Re.createElement(dt,{schema:s}),Re.createElement(mt,{schema:s}),Re.createElement(gt,{schema:s}),Re.createElement(st,{schema:s,isCircular:Y}),ee.length>0&&ee.map((s=>Re.createElement(at,{key:`${s.scope}-${s.value}`,constraint:s})))),Re.createElement("div",{className:Jn()("json-schema-2020-12-body",{"json-schema-2020-12-body--collapsed":!j})},j&&Re.createElement(Re.Fragment,null,Re.createElement(pt,{schema:s}),!Y&&z&&Re.createElement(Re.Fragment,null,Re.createElement(Xe,{schema:s}),Re.createElement(Qe,{schema:s}),Re.createElement(et,{schema:s}),Re.createElement(nt,{schema:s}),Re.createElement(tt,{schema:s}),Re.createElement(_e,{schema:s}),Re.createElement(we,{schema:s}),Re.createElement(xe,{schema:s}),Re.createElement(Pe,{schema:s}),Re.createElement(Te,{schema:s}),Re.createElement($e,{schema:s}),Re.createElement(qe,{schema:s}),Re.createElement(ze,{schema:s}),Re.createElement(We,{schema:s}),Re.createElement(He,{schema:s}),Re.createElement(rt,{schema:s}),Re.createElement(Ye,{schema:s}),Re.createElement(lt,{schema:s})),Re.createElement(ot,{schema:s}),Re.createElement(it,{schema:s}),Re.createElement(ct,{schema:s,dependentRequired:i}),Re.createElement(ht,{schema:s}),Re.createElement(yt,{schema:s}),Re.createElement(ae,{schema:s}),Re.createElement(ce,{schema:s}),Re.createElement(le,{schema:s}),Re.createElement(pe,{schema:s}),Re.createElement(de,{schema:s}),Re.createElement(fe,{schema:s}),!Y&&z&&Re.createElement(be,{schema:s}),Re.createElement(ye,{schema:s}),Re.createElement(Se,{schema:s}),Re.createElement(vt,{schema:s})))))))})),vT=yT,keywords_$schema=({schema:s})=>s?.$schema?Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--$schema"},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"$schema"),Re.createElement("span",{className:"json-schema-2020-12-keyword__value json-schema-2020-12-keyword__value--secondary"},s.$schema)):null,$vocabulary_$vocabulary=({schema:s})=>{const o="$vocabulary",{path:i}=usePath(o),{isExpanded:a,setExpanded:u,setCollapsed:_}=useIsExpanded(o),w=useComponent("Accordion"),x=(0,Re.useCallback)((()=>{a?_():u()}),[a,u,_]);return s?.$vocabulary?"object"!=typeof s.$vocabulary?null:Re.createElement(gT.Provider,{value:i},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--$vocabulary"},Re.createElement(w,{expanded:a,onChange:x},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"$vocabulary")),Re.createElement("strong",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--primary"},"object"),Re.createElement("ul",null,a&&Object.entries(s.$vocabulary).map((([s,o])=>Re.createElement("li",{key:s,className:Jn()("json-schema-2020-12-$vocabulary-uri",{"json-schema-2020-12-$vocabulary-uri--disabled":!o})},Re.createElement("span",{className:"json-schema-2020-12-keyword__value json-schema-2020-12-keyword__value--secondary"},s))))))):null},keywords_$id=({schema:s})=>s?.$id?Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--$id"},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"$id"),Re.createElement("span",{className:"json-schema-2020-12-keyword__value json-schema-2020-12-keyword__value--secondary"},s.$id)):null,keywords_$anchor=({schema:s})=>s?.$anchor?Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--$anchor"},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"$anchor"),Re.createElement("span",{className:"json-schema-2020-12-keyword__value json-schema-2020-12-keyword__value--secondary"},s.$anchor)):null,keywords_$dynamicAnchor=({schema:s})=>s?.$dynamicAnchor?Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--$dynamicAnchor"},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"$dynamicAnchor"),Re.createElement("span",{className:"json-schema-2020-12-keyword__value json-schema-2020-12-keyword__value--secondary"},s.$dynamicAnchor)):null,keywords_$ref=({schema:s})=>s?.$ref?Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--$ref"},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"$ref"),Re.createElement("span",{className:"json-schema-2020-12-keyword__value json-schema-2020-12-keyword__value--secondary"},s.$ref)):null,keywords_$dynamicRef=({schema:s})=>s?.$dynamicRef?Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--$dynamicRef"},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"$dynamicRef"),Re.createElement("span",{className:"json-schema-2020-12-keyword__value json-schema-2020-12-keyword__value--secondary"},s.$dynamicRef)):null,keywords_$defs=({schema:s})=>{const o=s?.$defs||{},i="$defs",{path:a}=usePath(i),{isExpanded:u,setExpanded:_,setCollapsed:w}=useIsExpanded(i),[x,C]=useLevel(),j=useComponent("Accordion"),L=useComponent("ExpandDeepButton"),B=useComponent("JSONSchema"),$=(0,Re.useCallback)((()=>{u?w():_()}),[u,_,w]),U=(0,Re.useCallback)(((s,o)=>{o?_({deep:!0}):w({deep:!0})}),[_,w]);return 0===Object.keys(o).length?null:Re.createElement(gT.Provider,{value:a},Re.createElement(fT.Provider,{value:C},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--$defs","data-json-schema-level":x},Re.createElement(j,{expanded:u,onChange:$},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"$defs")),Re.createElement(L,{expanded:u,onClick:U}),Re.createElement("strong",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--primary"},"object"),Re.createElement("ul",{className:Jn()("json-schema-2020-12-keyword__children",{"json-schema-2020-12-keyword__children--collapsed":!u})},u&&Re.createElement(Re.Fragment,null,Object.entries(o).map((([s,o])=>Re.createElement("li",{key:s,className:"json-schema-2020-12-property"},Re.createElement(B,{name:s,schema:o})))))))))},keywords_$comment=({schema:s})=>s?.$comment?Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--$comment"},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--secondary"},"$comment"),Re.createElement("span",{className:"json-schema-2020-12-keyword__value json-schema-2020-12-keyword__value--secondary"},s.$comment)):null,keywords_AllOf=({schema:s})=>{const o=s?.allOf||[],i=useFn(),a="allOf",{path:u}=usePath(a),{isExpanded:_,setExpanded:w,setCollapsed:x}=useIsExpanded(a),[C,j]=useLevel(),L=useComponent("Accordion"),B=useComponent("ExpandDeepButton"),$=useComponent("JSONSchema"),U=useComponent("KeywordType"),V=(0,Re.useCallback)((()=>{_?x():w()}),[_,w,x]),z=(0,Re.useCallback)(((s,o)=>{o?w({deep:!0}):x({deep:!0})}),[w,x]);return Array.isArray(o)&&0!==o.length?Re.createElement(gT.Provider,{value:u},Re.createElement(fT.Provider,{value:j},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--allOf","data-json-schema-level":C},Re.createElement(L,{expanded:_,onChange:V},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"All of")),Re.createElement(B,{expanded:_,onClick:z}),Re.createElement(U,{schema:{allOf:o}}),Re.createElement("ul",{className:Jn()("json-schema-2020-12-keyword__children",{"json-schema-2020-12-keyword__children--collapsed":!_})},_&&Re.createElement(Re.Fragment,null,o.map(((s,o)=>Re.createElement("li",{key:`#${o}`,className:"json-schema-2020-12-property"},Re.createElement($,{name:`#${o} ${i.getTitle(s)}`,schema:s}))))))))):null},keywords_AnyOf=({schema:s})=>{const o=s?.anyOf||[],i=useFn(),a="anyOf",{path:u}=usePath(a),{isExpanded:_,setExpanded:w,setCollapsed:x}=useIsExpanded(a),[C,j]=useLevel(),L=useComponent("Accordion"),B=useComponent("ExpandDeepButton"),$=useComponent("JSONSchema"),U=useComponent("KeywordType"),V=(0,Re.useCallback)((()=>{_?x():w()}),[_,w,x]),z=(0,Re.useCallback)(((s,o)=>{o?w({deep:!0}):x({deep:!0})}),[w,x]);return Array.isArray(o)&&0!==o.length?Re.createElement(gT.Provider,{value:u},Re.createElement(fT.Provider,{value:j},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--anyOf","data-json-schema-level":C},Re.createElement(L,{expanded:_,onChange:V},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"Any of")),Re.createElement(B,{expanded:_,onClick:z}),Re.createElement(U,{schema:{anyOf:o}}),Re.createElement("ul",{className:Jn()("json-schema-2020-12-keyword__children",{"json-schema-2020-12-keyword__children--collapsed":!_})},_&&Re.createElement(Re.Fragment,null,o.map(((s,o)=>Re.createElement("li",{key:`#${o}`,className:"json-schema-2020-12-property"},Re.createElement($,{name:`#${o} ${i.getTitle(s)}`,schema:s}))))))))):null},keywords_OneOf=({schema:s})=>{const o=s?.oneOf||[],i=useFn(),a="oneOf",{path:u}=usePath(a),{isExpanded:_,setExpanded:w,setCollapsed:x}=useIsExpanded(a),[C,j]=useLevel(),L=useComponent("Accordion"),B=useComponent("ExpandDeepButton"),$=useComponent("JSONSchema"),U=useComponent("KeywordType"),V=(0,Re.useCallback)((()=>{_?x():w()}),[_,w,x]),z=(0,Re.useCallback)(((s,o)=>{o?w({deep:!0}):x({deep:!0})}),[w,x]);return Array.isArray(o)&&0!==o.length?Re.createElement(gT.Provider,{value:u},Re.createElement(fT.Provider,{value:j},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--oneOf","data-json-schema-level":C},Re.createElement(L,{expanded:_,onChange:V},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"One of")),Re.createElement(B,{expanded:_,onClick:z}),Re.createElement(U,{schema:{oneOf:o}}),Re.createElement("ul",{className:Jn()("json-schema-2020-12-keyword__children",{"json-schema-2020-12-keyword__children--collapsed":!_})},_&&Re.createElement(Re.Fragment,null,o.map(((s,o)=>Re.createElement("li",{key:`#${o}`,className:"json-schema-2020-12-property"},Re.createElement($,{name:`#${o} ${i.getTitle(s)}`,schema:s}))))))))):null},keywords_Not=({schema:s})=>{const o=useFn(),i=useComponent("JSONSchema");if(!o.hasKeyword(s,"not"))return null;const a=Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"Not");return Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--not"},Re.createElement(i,{name:a,schema:s.not,identifier:"not"}))},keywords_If=({schema:s})=>{const o=useFn(),i=useComponent("JSONSchema");if(!o.hasKeyword(s,"if"))return null;const a=Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"If");return Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--if"},Re.createElement(i,{name:a,schema:s.if,identifier:"if"}))},keywords_Then=({schema:s})=>{const o=useFn(),i=useComponent("JSONSchema");if(!o.hasKeyword(s,"then"))return null;const a=Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"Then");return Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--then"},Re.createElement(i,{name:a,schema:s.then,identifier:"then"}))},keywords_Else=({schema:s})=>{const o=useFn(),i=useComponent("JSONSchema");if(!o.hasKeyword(s,"else"))return null;const a=Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"Else");return Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--if"},Re.createElement(i,{name:a,schema:s.else,identifier:"else"}))},keywords_DependentSchemas=({schema:s})=>{const o=s?.dependentSchemas||[],i="dependentSchemas",{path:a}=usePath(i),{isExpanded:u,setExpanded:_,setCollapsed:w}=useIsExpanded(i),[x,C]=useLevel(),j=useComponent("Accordion"),L=useComponent("ExpandDeepButton"),B=useComponent("JSONSchema"),$=(0,Re.useCallback)((()=>{u?w():_()}),[u,_,w]),U=(0,Re.useCallback)(((s,o)=>{o?_({deep:!0}):w({deep:!0})}),[_,w]);return"object"!=typeof o||0===Object.keys(o).length?null:Re.createElement(gT.Provider,{value:a},Re.createElement(fT.Provider,{value:C},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--dependentSchemas","data-json-schema-level":x},Re.createElement(j,{expanded:u,onChange:$},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"Dependent schemas")),Re.createElement(L,{expanded:u,onClick:U}),Re.createElement("strong",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--primary"},"object"),Re.createElement("ul",{className:Jn()("json-schema-2020-12-keyword__children",{"json-schema-2020-12-keyword__children--collapsed":!u})},u&&Re.createElement(Re.Fragment,null,Object.entries(o).map((([s,o])=>Re.createElement("li",{key:s,className:"json-schema-2020-12-property"},Re.createElement(B,{name:s,schema:o})))))))))},keywords_PrefixItems=({schema:s})=>{const o=s?.prefixItems||[],i=useFn(),a="prefixItems",{path:u}=usePath(a),{isExpanded:_,setExpanded:w,setCollapsed:x}=useIsExpanded(a),[C,j]=useLevel(),L=useComponent("Accordion"),B=useComponent("ExpandDeepButton"),$=useComponent("JSONSchema"),U=useComponent("KeywordType"),V=(0,Re.useCallback)((()=>{_?x():w()}),[_,w,x]),z=(0,Re.useCallback)(((s,o)=>{o?w({deep:!0}):x({deep:!0})}),[w,x]);return Array.isArray(o)&&0!==o.length?Re.createElement(gT.Provider,{value:u},Re.createElement(fT.Provider,{value:j},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--prefixItems","data-json-schema-level":C},Re.createElement(L,{expanded:_,onChange:V},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"Prefix items")),Re.createElement(B,{expanded:_,onClick:z}),Re.createElement(U,{schema:{prefixItems:o}}),Re.createElement("ul",{className:Jn()("json-schema-2020-12-keyword__children",{"json-schema-2020-12-keyword__children--collapsed":!_})},_&&Re.createElement(Re.Fragment,null,o.map(((s,o)=>Re.createElement("li",{key:`#${o}`,className:"json-schema-2020-12-property"},Re.createElement($,{name:`#${o} ${i.getTitle(s)}`,schema:s}))))))))):null},keywords_Items=({schema:s})=>{const o=useFn(),i=useComponent("JSONSchema");if(!o.hasKeyword(s,"items"))return null;const a=Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"Items");return Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--items"},Re.createElement(i,{name:a,schema:s.items,identifier:"items"}))},keywords_Contains=({schema:s})=>{const o=useFn(),i=useComponent("JSONSchema");if(!o.hasKeyword(s,"contains"))return null;const a=Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"Contains");return Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--contains"},Re.createElement(i,{name:a,schema:s.contains,identifier:"contains"}))},keywords_Properties_Properties=({schema:s})=>{const o=useFn(),i=s?.properties||{},a=Array.isArray(s?.required)?s.required:[],u=useComponent("JSONSchema"),{path:_}=usePath("properties");return 0===Object.keys(i).length?null:Re.createElement(gT.Provider,{value:_},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--properties"},Re.createElement("ul",null,Object.entries(i).map((([i,_])=>{const w=a.includes(i),x=o.getDependentRequired(i,s);return Re.createElement("li",{key:i,className:Jn()("json-schema-2020-12-property",{"json-schema-2020-12-property--required":w})},Re.createElement(u,{name:i,schema:_,dependentRequired:x}))})))))},PatternProperties_PatternProperties=({schema:s})=>{const o=s?.patternProperties||{},i=useComponent("JSONSchema"),{path:a}=usePath("patternProperties");return 0===Object.keys(o).length?null:Re.createElement(gT.Provider,{value:a},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--patternProperties"},Re.createElement("ul",null,Object.entries(o).map((([s,o])=>Re.createElement("li",{key:s,className:"json-schema-2020-12-property"},Re.createElement(i,{name:s,schema:o})))))))},keywords_AdditionalProperties=({schema:s})=>{const o=useFn(),i=useComponent("JSONSchema");if(!o.hasKeyword(s,"additionalProperties"))return null;const a=Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"Additional properties");return Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--additionalProperties"},!0===s.additionalProperties?Re.createElement(Re.Fragment,null,a,Re.createElement("span",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--primary"},"allowed")):!1===s.additionalProperties?Re.createElement(Re.Fragment,null,a,Re.createElement("span",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--primary"},"forbidden")):Re.createElement(i,{name:a,schema:s.additionalProperties,identifier:"additionalProperties"}))},keywords_PropertyNames=({schema:s})=>{const o=useFn(),i=useComponent("JSONSchema"),a=Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"Property names");return o.hasKeyword(s,"propertyNames")?Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--propertyNames"},Re.createElement(i,{name:a,schema:s.propertyNames,identifier:"propertyNames"})):null},keywords_UnevaluatedItems=({schema:s})=>{const o=useFn(),i=useComponent("JSONSchema");if(!o.hasKeyword(s,"unevaluatedItems"))return null;const a=Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"Unevaluated items");return Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--unevaluatedItems"},Re.createElement(i,{name:a,schema:s.unevaluatedItems,identifier:"unevaluatedItems"}))},keywords_UnevaluatedProperties=({schema:s})=>{const o=useFn(),i=useComponent("JSONSchema");if(!o.hasKeyword(s,"unevaluatedProperties"))return null;const a=Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"Unevaluated properties");return Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--unevaluatedProperties"},Re.createElement(i,{name:a,schema:s.unevaluatedProperties,identifier:"unevaluatedProperties"}))},keywords_Type=({schema:s,isCircular:o=!1})=>{const i=useFn().getType(s),a=o?" [circular]":"";return Re.createElement("strong",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--primary"},`${i}${a}`)},Enum_Enum=({schema:s})=>{const o=useComponent("JSONViewer");return Array.isArray(s?.enum)?Re.createElement(o,{name:"Enum",value:s.enum,className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--enum"}):null},Const_Const=({schema:s})=>{const o=useFn(),i=useComponent("JSONViewer");return o.hasKeyword(s,"const")?Re.createElement(i,{name:"Const",value:s.const,className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--const"}):null},fn_upperFirst=s=>"string"==typeof s?`${s.charAt(0).toUpperCase()}${s.slice(1)}`:s,makeGetTitle=s=>(o,{lookup:i="extended"}={})=>{const a=s();if(null!=o?.title)return a.upperFirst(String(o.title));if("extended"===i){if(null!=o?.$anchor)return a.upperFirst(String(o.$anchor));if(null!=o?.$id)return String(o.$id)}return""},makeGetType=s=>{const getType=(o,i=new WeakSet)=>{const a=s();if(null==o)return"any";if(a.isBooleanJSONSchema(o))return o?"any":"never";if("object"!=typeof o)return"any";if(i.has(o))return"any";i.add(o);const{type:u,prefixItems:_,items:w}=o,getArrayType=()=>{if(Array.isArray(_)){const s=_.map((s=>getType(s,i))),o=w?getType(w,i):"any";return`array<[${s.join(", ")}], ${o}>`}if(w){return`array<${getType(w,i)}>`}return"array<any>"};if(o.not&&"any"===getType(o.not))return"never";const handleCombiningKeywords=(s,a)=>{if(Array.isArray(o[s])){return`(${o[s].map((s=>getType(s,i))).join(a)})`}return null},x=[Array.isArray(u)?u.map((s=>"array"===s?getArrayType():s)).join(" | "):"array"===u?getArrayType():["null","boolean","object","array","number","integer","string"].includes(u)?u:(()=>{if(Object.hasOwn(o,"prefixItems")||Object.hasOwn(o,"items")||Object.hasOwn(o,"contains"))return getArrayType();if(Object.hasOwn(o,"properties")||Object.hasOwn(o,"additionalProperties")||Object.hasOwn(o,"patternProperties"))return"object";if(["int32","int64"].includes(o.format))return"integer";if(["float","double"].includes(o.format))return"number";if(Object.hasOwn(o,"minimum")||Object.hasOwn(o,"maximum")||Object.hasOwn(o,"exclusiveMinimum")||Object.hasOwn(o,"exclusiveMaximum")||Object.hasOwn(o,"multipleOf"))return"number | integer";if(Object.hasOwn(o,"pattern")||Object.hasOwn(o,"format")||Object.hasOwn(o,"minLength")||Object.hasOwn(o,"maxLength")||Object.hasOwn(o,"contentEncoding")||Object.hasOwn(o,"contentMediaType"))return"string";if(void 0!==o.const){if(null===o.const)return"null";if("boolean"==typeof o.const)return"boolean";if("number"==typeof o.const)return Number.isInteger(o.const)?"integer":"number";if("string"==typeof o.const)return"string";if(Array.isArray(o.const))return"array<any>";if("object"==typeof o.const)return"object"}return null})(),handleCombiningKeywords("oneOf"," | "),handleCombiningKeywords("anyOf"," | "),handleCombiningKeywords("allOf"," & ")].filter(Boolean).join(" | ");return i.delete(o),x||"any"};return getType},isBooleanJSONSchema=s=>"boolean"==typeof s,hasKeyword=(s,o)=>null!==s&&"object"==typeof s&&Object.hasOwn(s,o),fn_makeIsExpandable=s=>o=>{const i=s();return o?.$schema||o?.$vocabulary||o?.$id||o?.$anchor||o?.$dynamicAnchor||o?.$ref||o?.$dynamicRef||o?.$defs||o?.$comment||o?.allOf||o?.anyOf||o?.oneOf||i.hasKeyword(o,"not")||i.hasKeyword(o,"if")||i.hasKeyword(o,"then")||i.hasKeyword(o,"else")||o?.dependentSchemas||o?.prefixItems||i.hasKeyword(o,"items")||i.hasKeyword(o,"contains")||o?.properties||o?.patternProperties||i.hasKeyword(o,"additionalProperties")||i.hasKeyword(o,"propertyNames")||i.hasKeyword(o,"unevaluatedItems")||i.hasKeyword(o,"unevaluatedProperties")||o?.description||o?.enum||i.hasKeyword(o,"const")||i.hasKeyword(o,"contentSchema")||i.hasKeyword(o,"default")||o?.examples||i.getExtensionKeywords(o).length>0},fn_stringify=s=>null===s||["number","bigint","boolean"].includes(typeof s)?String(s):Array.isArray(s)?`[${s.map(fn_stringify).join(", ")}]`:JSON.stringify(s),stringifyConstraintRange=(s,o,i)=>{const a="number"==typeof o,u="number"==typeof i;return a&&u?o===i?`${o} ${s}`:`[${o}, ${i}] ${s}`:a?`≥ ${o} ${s}`:u?`≤ ${i} ${s}`:null},stringifyConstraints=s=>{const o=[],i=(s=>{if("number"!=typeof s?.multipleOf)return null;if(s.multipleOf<=0)return null;if(1===s.multipleOf)return null;const{multipleOf:o}=s;if(Number.isInteger(o))return`multiple of ${o}`;const i=10**o.toString().split(".")[1].length;return`multiple of ${o*i}/${i}`})(s);null!==i&&o.push({scope:"number",value:i});const a=(s=>{const o=s?.minimum,i=s?.maximum,a=s?.exclusiveMinimum,u=s?.exclusiveMaximum,_="number"==typeof o,w="number"==typeof i,x="number"==typeof a,C="number"==typeof u,j=x&&(!_||o<a),L=C&&(!w||i>u);if((_||x)&&(w||C))return`${j?"(":"["}${j?a:o}, ${L?u:i}${L?")":"]"}`;if(_||x)return`${j?">":"≥"} ${j?a:o}`;if(w||C)return`${L?"<":"≤"} ${L?u:i}`;return null})(s);null!==a&&o.push({scope:"number",value:a}),s?.format&&o.push({scope:"string",value:s.format});const u=stringifyConstraintRange("characters",s?.minLength,s?.maxLength);null!==u&&o.push({scope:"string",value:u}),s?.pattern&&o.push({scope:"string",value:`matches ${s?.pattern}`}),s?.contentMediaType&&o.push({scope:"string",value:`media type: ${s.contentMediaType}`}),s?.contentEncoding&&o.push({scope:"string",value:`encoding: ${s.contentEncoding}`});const _=stringifyConstraintRange(s?.uniqueItems?"unique items":"items",s?.minItems,s?.maxItems);null!==_&&o.push({scope:"array",value:_}),s?.uniqueItems&&!_&&o.push({scope:"array",value:"unique"});const w=stringifyConstraintRange("contained items",s?.minContains,s?.maxContains);null!==w&&o.push({scope:"array",value:w});const x=stringifyConstraintRange("properties",s?.minProperties,s?.maxProperties);return null!==x&&o.push({scope:"object",value:x}),o},getDependentRequired=(s,o)=>o?.dependentRequired?Array.from(Object.entries(o.dependentRequired).reduce(((o,[i,a])=>Array.isArray(a)&&a.includes(s)?(o.add(i),o):o),new Set)):[],fn_isPlainObject=s=>"object"==typeof s&&null!==s&&!Array.isArray(s)&&(null===Object.getPrototypeOf(s)||Object.getPrototypeOf(s)===Object.prototype),getSchemaKeywords=()=>["$schema","$vocabulary","$id","$anchor","$dynamicAnchor","$dynamicRef","$ref","$defs","$comment","allOf","anyOf","oneOf","not","if","then","else","dependentSchemas","prefixItems","items","contains","properties","patternProperties","additionalProperties","propertyNames","unevaluatedItems","unevaluatedProperties","type","enum","const","multipleOf","maximum","exclusiveMaximum","minimum","exclusiveMinimum","maxLength","minLength","pattern","maxItems","minItems","uniqueItems","maxContains","minContains","maxProperties","minProperties","required","dependentRequired","title","description","default","deprecated","readOnly","writeOnly","examples","format","contentEncoding","contentMediaType","contentSchema"],makeGetExtensionKeywords=s=>o=>{const i=s().getSchemaKeywords();return fn_isPlainObject(o)?((s,o)=>{const i=new Set(o);return s.filter((s=>!i.has(s)))})(Object.keys(o),i):[]},fn_hasSchemaType=(s,o)=>{const i=ze.Map.isMap(s);if(!i&&!fn_isPlainObject(s))return!1;const hasType=s=>o===s||Array.isArray(o)&&o.includes(s),a=i?s.get("type"):s.type;return ze.List.isList(a)||Array.isArray(a)?a.some((s=>hasType(s))):hasType(a)},Constraint=({constraint:s})=>fn_isPlainObject(s)&&"string"==typeof s.scope&&"string"==typeof s.value?Re.createElement("span",{className:`json-schema-2020-12__constraint json-schema-2020-12__constraint--${s.scope}`},s.value):null,bT=Re.memo(Constraint),DependentRequired_DependentRequired=({dependentRequired:s})=>Array.isArray(s)&&0!==s.length?Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--dependentRequired"},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"Required when defined"),Re.createElement("ul",null,s.map((s=>Re.createElement("li",{key:s},Re.createElement("span",{className:"json-schema-2020-12-keyword__value json-schema-2020-12-keyword__value--warning"},s)))))):null,keywords_ContentSchema=({schema:s})=>{const o=useFn(),i=useComponent("JSONSchema");if(!o.hasKeyword(s,"contentSchema"))return null;const a=Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--primary"},"Content schema");return Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--contentSchema"},Re.createElement(i,{name:a,schema:s.contentSchema,identifier:"contentSchema"}))},Title_Title=({title:s="",schema:o})=>{const i=useFn(),a=s||i.getTitle(o);return a?Re.createElement("div",{className:"json-schema-2020-12__title"},a):null},keywords_Description_Description=({schema:s})=>s?.description?Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--description"},Re.createElement("div",{className:"json-schema-2020-12-core-keyword__value json-schema-2020-12-core-keyword__value--secondary"},s.description)):null,Default_Default=({schema:s})=>{const o=useFn(),i=useComponent("JSONViewer");return o.hasKeyword(s,"default")?Re.createElement(i,{name:"Default",value:s.default,className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--default"}):null},keywords_Deprecated=({schema:s})=>!0!==s?.deprecated?null:Re.createElement("span",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--warning"},"deprecated"),keywords_ReadOnly=({schema:s})=>!0!==s?.readOnly?null:Re.createElement("span",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--muted"},"read-only"),keywords_WriteOnly=({schema:s})=>!0!==s?.writeOnly?null:Re.createElement("span",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--muted"},"write-only"),keywords_Examples_Examples=({schema:s})=>{const o=s?.examples||[],i=useComponent("JSONViewer");return Array.isArray(o)&&0!==o.length?Re.createElement(i,{name:"Examples",value:s.examples,className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--examples"}):null},ExtensionKeywords_ExtensionKeywords=({schema:s})=>{const o=useFn(),i="ExtensionKeywords",{path:a}=usePath(i),{isExpanded:u,setExpanded:_,setCollapsed:w}=useIsExpanded(i),[x,C]=useLevel(),j=useComponent("Accordion"),L=useComponent("ExpandDeepButton"),B=useComponent("JSONViewer"),{showExtensionKeywords:$}=useConfig(),U=o.getExtensionKeywords(s),V=(0,Re.useCallback)((()=>{u?w():_()}),[u,_,w]),z=(0,Re.useCallback)(((s,o)=>{o?_({deep:!0}):w({deep:!0})}),[_,w]);return $&&0!==U.length?Re.createElement(gT.Provider,{value:a},Re.createElement(fT.Provider,{value:C},Re.createElement("div",{className:"json-schema-2020-12-keyword json-schema-2020-12-keyword--extension-keywords","data-json-schema-level":x},Re.createElement(j,{expanded:u,onChange:V},Re.createElement("span",{className:"json-schema-2020-12-keyword__name json-schema-2020-12-keyword__name--extension"},"Extension Keywords")),Re.createElement(L,{expanded:u,onClick:z}),Re.createElement("ul",{className:Jn()("json-schema-2020-12-keyword__children",{"json-schema-2020-12-keyword__children--collapsed":!u})},u&&Re.createElement(Re.Fragment,null,U.map((o=>Re.createElement(B,{key:o,name:o,value:s[o],className:"json-schema-2020-12-json-viewer-extension-keyword"})))))))):null},JSONViewer=({name:s,value:o,className:i})=>{const a=useFn(),{path:u}=usePath(s),{isExpanded:_,setExpanded:w,setCollapsed:x}=useIsExpanded(s),[C,j]=useLevel(),L=useComponent("Accordion"),B=useComponent("ExpandDeepButton"),$="string"==typeof o||"number"==typeof o||"bigint"==typeof o||"boolean"==typeof o||"symbol"==typeof o||null==o,U=(s=>fn_isPlainObject(s)&&0===Object.keys(s).length)(o)||(s=>Array.isArray(s)&&0===s.length)(o),V=(0,Re.useCallback)((()=>{_?x():w()}),[_,w,x]),z=(0,Re.useCallback)(((s,o)=>{o?w({deep:!0}):x({deep:!0})}),[w,x]);return $?Re.createElement("div",{className:Jn()("json-schema-2020-12-json-viewer",i)},Re.createElement("span",{className:"json-schema-2020-12-json-viewer__name json-schema-2020-12-json-viewer__name--secondary"},s),Re.createElement("span",{className:"json-schema-2020-12-json-viewer__value json-schema-2020-12-json-viewer__value--secondary"},a.stringify(o))):U?Re.createElement("div",{className:Jn()("json-schema-2020-12-json-viewer",i)},Re.createElement("span",{className:"json-schema-2020-12-json-viewer__name json-schema-2020-12-json-viewer__name--secondary"},s),Re.createElement("strong",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--primary"},Array.isArray(o)?"empty array":"empty object")):Re.createElement(gT.Provider,{value:u},Re.createElement(fT.Provider,{value:j},Re.createElement("div",{className:Jn()("json-schema-2020-12-json-viewer",i),"data-json-schema-level":C},Re.createElement(L,{expanded:_,onChange:V},Re.createElement("span",{className:"json-schema-2020-12-json-viewer__name json-schema-2020-12-json-viewer__name--secondary"},s)),Re.createElement(B,{expanded:_,onClick:z}),Re.createElement("strong",{className:"json-schema-2020-12__attribute json-schema-2020-12__attribute--primary"},Array.isArray(o)?"array":"object"),Re.createElement("ul",{className:Jn()("json-schema-2020-12-json-viewer__children",{"json-schema-2020-12-json-viewer__children--collapsed":!_})},_&&Re.createElement(Re.Fragment,null,Array.isArray(o)?o.map(((s,o)=>Re.createElement("li",{key:`#${o}`,className:"json-schema-2020-12-property"},Re.createElement(JSONViewer,{name:`#${o}`,value:s,className:i})))):Object.entries(o).map((([s,o])=>Re.createElement("li",{key:s,className:"json-schema-2020-12-property"},Re.createElement(JSONViewer,{name:s,value:o,className:i})))))))))},ST=JSONViewer,Accordion_Accordion=({expanded:s=!1,children:o,onChange:i})=>{const a=useComponent("ChevronRightIcon"),u=(0,Re.useCallback)((o=>{i(o,!s)}),[s,i]);return Re.createElement("button",{type:"button",className:"json-schema-2020-12-accordion",onClick:u},Re.createElement("div",{className:"json-schema-2020-12-accordion__children"},o),Re.createElement("span",{className:Jn()("json-schema-2020-12-accordion__icon",{"json-schema-2020-12-accordion__icon--expanded":s,"json-schema-2020-12-accordion__icon--collapsed":!s})},Re.createElement(a,null)))},ExpandDeepButton_ExpandDeepButton=({expanded:s,onClick:o})=>{const i=(0,Re.useCallback)((i=>{o(i,!s)}),[s,o]);return Re.createElement("button",{type:"button",className:"json-schema-2020-12-expand-deep-button",onClick:i},s?"Collapse all":"Expand all")},icons_ChevronRight=()=>Re.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24"},Re.createElement("path",{d:"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"})),withJSONSchemaContext=(s,o={})=>{const i={components:{JSONSchema:vT,Keyword$schema:keywords_$schema,Keyword$vocabulary:$vocabulary_$vocabulary,Keyword$id:keywords_$id,Keyword$anchor:keywords_$anchor,Keyword$dynamicAnchor:keywords_$dynamicAnchor,Keyword$ref:keywords_$ref,Keyword$dynamicRef:keywords_$dynamicRef,Keyword$defs:keywords_$defs,Keyword$comment:keywords_$comment,KeywordAllOf:keywords_AllOf,KeywordAnyOf:keywords_AnyOf,KeywordOneOf:keywords_OneOf,KeywordNot:keywords_Not,KeywordIf:keywords_If,KeywordThen:keywords_Then,KeywordElse:keywords_Else,KeywordDependentSchemas:keywords_DependentSchemas,KeywordPrefixItems:keywords_PrefixItems,KeywordItems:keywords_Items,KeywordContains:keywords_Contains,KeywordProperties:keywords_Properties_Properties,KeywordPatternProperties:PatternProperties_PatternProperties,KeywordAdditionalProperties:keywords_AdditionalProperties,KeywordPropertyNames:keywords_PropertyNames,KeywordUnevaluatedItems:keywords_UnevaluatedItems,KeywordUnevaluatedProperties:keywords_UnevaluatedProperties,KeywordType:keywords_Type,KeywordEnum:Enum_Enum,KeywordConst:Const_Const,KeywordConstraint:bT,KeywordDependentRequired:DependentRequired_DependentRequired,KeywordContentSchema:keywords_ContentSchema,KeywordTitle:Title_Title,KeywordDescription:keywords_Description_Description,KeywordDefault:Default_Default,KeywordDeprecated:keywords_Deprecated,KeywordReadOnly:keywords_ReadOnly,KeywordWriteOnly:keywords_WriteOnly,KeywordExamples:keywords_Examples_Examples,ExtensionKeywords:ExtensionKeywords_ExtensionKeywords,JSONViewer:ST,Accordion:Accordion_Accordion,ExpandDeepButton:ExpandDeepButton_ExpandDeepButton,ChevronRightIcon:icons_ChevronRight,...o.components},config:{default$schema:"https://json-schema.org/draft/2020-12/schema",defaultExpandedLevels:0,showExtensionKeywords:!0,...o.config},fn:{upperFirst:fn_upperFirst,getTitle:makeGetTitle(useFn),getType:makeGetType(useFn),isBooleanJSONSchema,hasKeyword,isExpandable:fn_makeIsExpandable(useFn),stringify:fn_stringify,stringifyConstraints,getDependentRequired,getSchemaKeywords,getExtensionKeywords:makeGetExtensionKeywords(useFn),...o.fn},state:{paths:{}}},HOC=o=>Re.createElement(dT.Provider,{value:i},Re.createElement(s,o));return HOC.contexts={JSONSchemaContext:dT},HOC.displayName=s.displayName,HOC},makeWithJSONSchemaSystemContext=({getSystem:s})=>(o,i={})=>{const{getComponent:a,getConfigs:u}=s(),_=u(),w=a("JSONSchema202012"),x=a("JSONSchema202012Keyword$schema"),C=a("JSONSchema202012Keyword$vocabulary"),j=a("JSONSchema202012Keyword$id"),L=a("JSONSchema202012Keyword$anchor"),B=a("JSONSchema202012Keyword$dynamicAnchor"),$=a("JSONSchema202012Keyword$ref"),U=a("JSONSchema202012Keyword$dynamicRef"),V=a("JSONSchema202012Keyword$defs"),z=a("JSONSchema202012Keyword$comment"),Y=a("JSONSchema202012KeywordAllOf"),Z=a("JSONSchema202012KeywordAnyOf"),ee=a("JSONSchema202012KeywordOneOf"),ie=a("JSONSchema202012KeywordNot"),ae=a("JSONSchema202012KeywordIf"),ce=a("JSONSchema202012KeywordThen"),le=a("JSONSchema202012KeywordElse"),pe=a("JSONSchema202012KeywordDependentSchemas"),de=a("JSONSchema202012KeywordPrefixItems"),fe=a("JSONSchema202012KeywordItems"),ye=a("JSONSchema202012KeywordContains"),be=a("JSONSchema202012KeywordProperties"),Se=a("JSONSchema202012KeywordPatternProperties"),_e=a("JSONSchema202012KeywordAdditionalProperties"),we=a("JSONSchema202012KeywordPropertyNames"),xe=a("JSONSchema202012KeywordUnevaluatedItems"),Pe=a("JSONSchema202012KeywordUnevaluatedProperties"),Te=a("JSONSchema202012KeywordType"),Re=a("JSONSchema202012KeywordEnum"),$e=a("JSONSchema202012KeywordConst"),qe=a("JSONSchema202012KeywordConstraint"),ze=a("JSONSchema202012KeywordDependentRequired"),We=a("JSONSchema202012KeywordContentSchema"),He=a("JSONSchema202012KeywordTitle"),Ye=a("JSONSchema202012KeywordDescription"),Xe=a("JSONSchema202012KeywordDefault"),Qe=a("JSONSchema202012KeywordDeprecated"),et=a("JSONSchema202012KeywordReadOnly"),tt=a("JSONSchema202012KeywordWriteOnly"),rt=a("JSONSchema202012KeywordExamples"),nt=a("JSONSchema202012ExtensionKeywords"),st=a("JSONSchema202012JSONViewer"),ot=a("JSONSchema202012Accordion"),it=a("JSONSchema202012ExpandDeepButton"),at=a("JSONSchema202012ChevronRightIcon");return withJSONSchemaContext(o,{components:{JSONSchema:w,Keyword$schema:x,Keyword$vocabulary:C,Keyword$id:j,Keyword$anchor:L,Keyword$dynamicAnchor:B,Keyword$ref:$,Keyword$dynamicRef:U,Keyword$defs:V,Keyword$comment:z,KeywordAllOf:Y,KeywordAnyOf:Z,KeywordOneOf:ee,KeywordNot:ie,KeywordIf:ae,KeywordThen:ce,KeywordElse:le,KeywordDependentSchemas:pe,KeywordPrefixItems:de,KeywordItems:fe,KeywordContains:ye,KeywordProperties:be,KeywordPatternProperties:Se,KeywordAdditionalProperties:_e,KeywordPropertyNames:we,KeywordUnevaluatedItems:xe,KeywordUnevaluatedProperties:Pe,KeywordType:Te,KeywordEnum:Re,KeywordConst:$e,KeywordConstraint:qe,KeywordDependentRequired:ze,KeywordContentSchema:We,KeywordTitle:He,KeywordDescription:Ye,KeywordDefault:Xe,KeywordDeprecated:Qe,KeywordReadOnly:et,KeywordWriteOnly:tt,KeywordExamples:rt,ExtensionKeywords:nt,JSONViewer:st,Accordion:ot,ExpandDeepButton:it,ChevronRightIcon:at,...i.components},config:{showExtensionKeywords:_.showExtensions,...i.config},fn:{...i.fn}})},json_schema_2020_12=({getSystem:s,fn:o})=>{const fnAccessor=()=>({upperFirst:o.upperFirst,...o.jsonSchema202012});return{components:{JSONSchema202012:vT,JSONSchema202012Keyword$schema:keywords_$schema,JSONSchema202012Keyword$vocabulary:$vocabulary_$vocabulary,JSONSchema202012Keyword$id:keywords_$id,JSONSchema202012Keyword$anchor:keywords_$anchor,JSONSchema202012Keyword$dynamicAnchor:keywords_$dynamicAnchor,JSONSchema202012Keyword$ref:keywords_$ref,JSONSchema202012Keyword$dynamicRef:keywords_$dynamicRef,JSONSchema202012Keyword$defs:keywords_$defs,JSONSchema202012Keyword$comment:keywords_$comment,JSONSchema202012KeywordAllOf:keywords_AllOf,JSONSchema202012KeywordAnyOf:keywords_AnyOf,JSONSchema202012KeywordOneOf:keywords_OneOf,JSONSchema202012KeywordNot:keywords_Not,JSONSchema202012KeywordIf:keywords_If,JSONSchema202012KeywordThen:keywords_Then,JSONSchema202012KeywordElse:keywords_Else,JSONSchema202012KeywordDependentSchemas:keywords_DependentSchemas,JSONSchema202012KeywordPrefixItems:keywords_PrefixItems,JSONSchema202012KeywordItems:keywords_Items,JSONSchema202012KeywordContains:keywords_Contains,JSONSchema202012KeywordProperties:keywords_Properties_Properties,JSONSchema202012KeywordPatternProperties:PatternProperties_PatternProperties,JSONSchema202012KeywordAdditionalProperties:keywords_AdditionalProperties,JSONSchema202012KeywordPropertyNames:keywords_PropertyNames,JSONSchema202012KeywordUnevaluatedItems:keywords_UnevaluatedItems,JSONSchema202012KeywordUnevaluatedProperties:keywords_UnevaluatedProperties,JSONSchema202012KeywordType:keywords_Type,JSONSchema202012KeywordEnum:Enum_Enum,JSONSchema202012KeywordConst:Const_Const,JSONSchema202012KeywordConstraint:bT,JSONSchema202012KeywordDependentRequired:DependentRequired_DependentRequired,JSONSchema202012KeywordContentSchema:keywords_ContentSchema,JSONSchema202012KeywordTitle:Title_Title,JSONSchema202012KeywordDescription:keywords_Description_Description,JSONSchema202012KeywordDefault:Default_Default,JSONSchema202012KeywordDeprecated:keywords_Deprecated,JSONSchema202012KeywordReadOnly:keywords_ReadOnly,JSONSchema202012KeywordWriteOnly:keywords_WriteOnly,JSONSchema202012KeywordExamples:keywords_Examples_Examples,JSONSchema202012ExtensionKeywords:ExtensionKeywords_ExtensionKeywords,JSONSchema202012JSONViewer:ST,JSONSchema202012Accordion:Accordion_Accordion,JSONSchema202012ExpandDeepButton:ExpandDeepButton_ExpandDeepButton,JSONSchema202012ChevronRightIcon:icons_ChevronRight,withJSONSchema202012Context:withJSONSchemaContext,withJSONSchema202012SystemContext:makeWithJSONSchemaSystemContext(s()),JSONSchema202012PathContext:()=>gT,JSONSchema202012LevelContext:()=>fT},fn:{upperFirst:fn_upperFirst,jsonSchema202012:{getTitle:makeGetTitle(fnAccessor),getType:makeGetType(fnAccessor),isExpandable:fn_makeIsExpandable(fnAccessor),isBooleanJSONSchema,hasKeyword,useFn,useConfig,useComponent,useIsExpanded,usePath,useLevel,getSchemaKeywords,getExtensionKeywords:makeGetExtensionKeywords(fnAccessor),hasSchemaType:fn_hasSchemaType}}}},array=(s,{sample:o=[]}={})=>((s,o={})=>{const{minItems:i,maxItems:a,uniqueItems:u}=o,{contains:_,minContains:w,maxContains:x}=o;let C=[...s];if(null!=_&&"object"==typeof _){if(Number.isInteger(w)&&w>1){const s=C.at(0);for(let o=1;o<w;o+=1)C.unshift(s)}Number.isInteger(x)}if(Number.isInteger(a)&&a>0&&(C=s.slice(0,a)),Number.isInteger(i)&&i>0)for(let s=0;C.length<i;s+=1)C.push(C[s%C.length]);return!0===u&&(C=Array.from(new Set(C))),C})(o,s),object=()=>{throw new Error("Not implemented")},bytes=s=>xt()(s),random_pick=s=>s.at(0),predicates_isBooleanJSONSchema=s=>"boolean"==typeof s,isJSONSchemaObject=s=>as()(s),isJSONSchema=s=>predicates_isBooleanJSONSchema(s)||isJSONSchemaObject(s);const _T=class Registry{data={};register(s,o){this.data[s]=o}unregister(s){void 0===s?this.data={}:delete this.data[s]}get(s){return this.data[s]}},int32=()=>0,int64=()=>0,generators_float=()=>.1,generators_double=()=>.1,email=()=>"user@example.com",idn_email=()=>"실례@example.com",hostname=()=>"example.com",idn_hostname=()=>"실례.com",ipv4=()=>"198.51.100.42",ipv6=()=>"2001:0db8:5b96:0000:0000:426f:8e17:642a",uri=()=>"https://example.com/",uri_reference=()=>"path/index.html",iri=()=>"https://실례.com/",iri_reference=()=>"path/실례.html",uuid=()=>"3fa85f64-5717-4562-b3fc-2c963f66afa6",uri_template=()=>"https://example.com/dictionary/{term:1}/{term}",generators_json_pointer=()=>"/a/b/c",relative_json_pointer=()=>"1/0",date_time=()=>(new Date).toISOString(),date=()=>(new Date).toISOString().substring(0,10),time=()=>(new Date).toISOString().substring(11),duration=()=>"P3D",generators_password=()=>"********",regex=()=>"^[a-z]+$";const ET=new class FormatRegistry extends _T{#s={int32,int64,float:generators_float,double:generators_double,email,"idn-email":idn_email,hostname,"idn-hostname":idn_hostname,ipv4,ipv6,uri,"uri-reference":uri_reference,iri,"iri-reference":iri_reference,uuid,"uri-template":uri_template,"json-pointer":generators_json_pointer,"relative-json-pointer":relative_json_pointer,"date-time":date_time,date,time,duration,password:generators_password,regex};data={...this.#s};get defaults(){return{...this.#s}}},formatAPI=(s,o)=>"function"==typeof o?ET.register(s,o):null===o?ET.unregister(s):ET.get(s);formatAPI.getDefaults=()=>ET.defaults;const wT=formatAPI;var xT=__webpack_require__(48287).Buffer;const _7bit=s=>xT.from(s).toString("ascii");var kT=__webpack_require__(48287).Buffer;const _8bit=s=>kT.from(s).toString("utf8");var OT=__webpack_require__(48287).Buffer;const encoders_binary=s=>OT.from(s).toString("binary"),quoted_printable=s=>{let o="";for(let i=0;i<s.length;i++){const a=s.charCodeAt(i);if(61===a)o+="=3D";else if(a>=33&&a<=60||a>=62&&a<=126||9===a||32===a)o+=s.charAt(i);else if(13===a||10===a)o+="\r\n";else if(a>126){const a=unescape(encodeURIComponent(s.charAt(i)));for(let s=0;s<a.length;s++)o+="="+("0"+a.charCodeAt(s).toString(16)).slice(-2).toUpperCase()}else o+="="+("0"+a.toString(16)).slice(-2).toUpperCase()}return o};var AT=__webpack_require__(48287).Buffer;const base16=s=>AT.from(s).toString("hex");var CT=__webpack_require__(48287).Buffer;const base32=s=>{const o=CT.from(s).toString("utf8"),i="ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";let a=0,u="",_=0,w=0;for(let s=0;s<o.length;s++)for(_=_<<8|o.charCodeAt(s),w+=8;w>=5;)u+=i.charAt(_>>>w-5&31),w-=5;w>0&&(u+=i.charAt(_<<5-w&31),a=(8-8*o.length%5)%5);for(let s=0;s<a;s++)u+="=";return u};var jT=__webpack_require__(48287).Buffer;const base64=s=>jT.from(s).toString("base64");var PT=__webpack_require__(48287).Buffer;const base64url=s=>PT.from(s).toString("base64url");const IT=new class EncoderRegistry extends _T{#s={"7bit":_7bit,"8bit":_8bit,binary:encoders_binary,"quoted-printable":quoted_printable,base16,base32,base64,base64url};data={...this.#s};get defaults(){return{...this.#s}}},encoderAPI=(s,o)=>"function"==typeof o?IT.register(s,o):null===o?IT.unregister(s):IT.get(s);encoderAPI.getDefaults=()=>IT.defaults;const TT=encoderAPI,NT={"text/plain":()=>"string","text/css":()=>".selector { border: 1px solid red }","text/csv":()=>"value1,value2,value3","text/html":()=>"<p>content</p>","text/calendar":()=>"BEGIN:VCALENDAR","text/javascript":()=>"console.dir('Hello world!');","text/xml":()=>'<person age="30">John Doe</person>',"text/*":()=>"string"},MT={"image/*":()=>bytes(25).toString("binary")},RT={"audio/*":()=>bytes(25).toString("binary")},DT={"video/*":()=>bytes(25).toString("binary")},LT={"application/json":()=>'{"key":"value"}',"application/ld+json":()=>'{"name": "John Doe"}',"application/x-httpd-php":()=>"<?php echo '<p>Hello World!</p>'; ?>","application/rtf":()=>String.raw`{\rtf1\adeflang1025\ansi\ansicpg1252\uc1`,"application/x-sh":()=>'echo "Hello World!"',"application/xhtml+xml":()=>"<p>content</p>","application/*":()=>bytes(25).toString("binary")};const FT=new class MediaTypeRegistry extends _T{#s={...NT,...MT,...RT,...DT,...LT};data={...this.#s};get defaults(){return{...this.#s}}},mediaTypeAPI=(s,o)=>{if("function"==typeof o)return FT.register(s,o);if(null===o)return FT.unregister(s);const i=s.split(";").at(0),a=`${i.split("/").at(0)}/*`;return FT.get(s)||FT.get(i)||FT.get(a)};mediaTypeAPI.getDefaults=()=>FT.defaults;const BT=mediaTypeAPI,applyStringConstraints=(s,o={})=>{const{maxLength:i,minLength:a}=o;let u=s;if(Number.isInteger(i)&&i>0&&(u=u.slice(0,i)),Number.isInteger(a)&&a>0){let s=0;for(;u.length<a;)u+=u[s++%u.length]}return u},types_string=(s,{sample:o}={})=>{const{contentEncoding:i,contentMediaType:a,contentSchema:u}=s,{pattern:_,format:w}=s,x=TT(i)||cO();let C;return C="string"==typeof _?applyStringConstraints((s=>{try{const o=/(?<=(?<!\\)\{)(\d{3,})(?=\})|(?<=(?<!\\)\{\d*,)(\d{3,})(?=\})|(?<=(?<!\\)\{)(\d{3,})(?=,\d*\})/g,i=s.replace(o,"100"),a=new(ps())(i);return a.max=100,a.gen()}catch{return"string"}})(_),s):"string"==typeof w?(s=>{const{format:o}=s,i=wT(o);return"function"==typeof i?i(s):"string"})(s):isJSONSchema(u)&&"string"==typeof a&&void 0!==o?Array.isArray(o)||"object"==typeof o?JSON.stringify(o):applyStringConstraints(String(o),s):"string"==typeof a?(s=>{const{contentMediaType:o}=s,i=BT(o);return"function"==typeof i?i(s):"string"})(s):applyStringConstraints("string",s),x(C)},applyNumberConstraints=(s,o={})=>{const{minimum:i,maximum:a,exclusiveMinimum:u,exclusiveMaximum:_}=o,{multipleOf:w}=o,x=Number.isInteger(s)?1:Number.EPSILON;let C="number"==typeof i?i:null,j="number"==typeof a?a:null,L=s;if("number"==typeof u&&(C=null!==C?Math.max(C,u+x):u+x),"number"==typeof _&&(j=null!==j?Math.min(j,_-x):_-x),L=C>j&&s||C||j||L,"number"==typeof w&&w>0){const s=L%w;L=0===s?L:L+w-s}return L},types_number=s=>{const{format:o}=s;let i;return i="string"==typeof o?(s=>{const{format:o}=s,i=wT(o);return"function"==typeof i?i(s):0})(s):0,applyNumberConstraints(i,s)},types_integer=s=>{const{format:o}=s;let i;return i="string"==typeof o?(s=>{const{format:o}=s,i=wT(o);if("function"==typeof i)return i(s);switch(o){case"int32":return int32();case"int64":return int64()}return 0})(s):0,applyNumberConstraints(i,s)},types_boolean=s=>"boolean"!=typeof s.default||s.default,$T=new Proxy({array,object,string:types_string,number:types_number,integer:types_integer,boolean:types_boolean,null:()=>null},{get:(s,o)=>"string"==typeof o&&Object.hasOwn(s,o)?s[o]:()=>`Unknown Type: ${o}`}),qT=["array","object","number","integer","string","boolean","null"],hasExample=s=>{if(!isJSONSchemaObject(s))return!1;const{examples:o,example:i,default:a}=s;return!!(Array.isArray(o)&&o.length>=1)||(void 0!==a||void 0!==i)},extractExample=s=>{if(!isJSONSchemaObject(s))return null;const{examples:o,example:i,default:a}=s;return Array.isArray(o)&&o.length>=1?o.at(0):void 0!==a?a:void 0!==i?i:void 0},UT={array:["items","prefixItems","contains","maxContains","minContains","maxItems","minItems","uniqueItems","unevaluatedItems"],object:["properties","additionalProperties","patternProperties","propertyNames","minProperties","maxProperties","required","dependentSchemas","dependentRequired","unevaluatedProperties"],string:["pattern","format","minLength","maxLength","contentEncoding","contentMediaType","contentSchema"],integer:["minimum","maximum","exclusiveMinimum","exclusiveMaximum","multipleOf"]};UT.number=UT.integer;const VT="string",inferTypeFromValue=s=>void 0===s?null:null===s?"null":Array.isArray(s)?"array":Number.isInteger(s)?"integer":typeof s,foldType=s=>{if(Array.isArray(s)&&s.length>=1){if(s.includes("array"))return"array";if(s.includes("object"))return"object";{const o=s.filter((s=>"null"!==s)),i=random_pick(o.length>0?o:s);if(qT.includes(i))return i}}return qT.includes(s)?s:null},inferType=(s,o=new WeakSet)=>{if(!isJSONSchemaObject(s))return VT;if(o.has(s))return VT;o.add(s);let{type:i,const:a}=s;if(i=foldType(i),"string"!=typeof i){const o=Object.keys(UT);e:for(let a=0;a<o.length;a+=1){const u=o[a],_=UT[u];for(let o=0;o<_.length;o+=1){const a=_[o];if(Object.hasOwn(s,a)){i=u;break e}}}}if("string"!=typeof i&&void 0!==a){const s=inferTypeFromValue(a);i="string"==typeof s?s:i}if("string"!=typeof i){const combineTypes=i=>{if(Array.isArray(s[i])){const a=s[i].map((s=>inferType(s,o)));return foldType(a)}return null},a=combineTypes("allOf"),u=combineTypes("anyOf"),_=combineTypes("oneOf"),w=s.not?inferType(s.not,o):null;(a||u||_||w)&&(i=foldType([a,u,_,w].filter(Boolean)))}if("string"!=typeof i&&hasExample(s)){const o=extractExample(s),a=inferTypeFromValue(o);i="string"==typeof a?a:i}return o.delete(s),i||VT},type_getType=s=>inferType(s),typeCast=s=>predicates_isBooleanJSONSchema(s)?(s=>!1===s?{not:{}}:{})(s):isJSONSchemaObject(s)?s:{},merge_merge=(s,o,i={})=>{if(predicates_isBooleanJSONSchema(s)&&!0===s)return!0;if(predicates_isBooleanJSONSchema(s)&&!1===s)return!1;if(predicates_isBooleanJSONSchema(o)&&!0===o)return!0;if(predicates_isBooleanJSONSchema(o)&&!1===o)return!1;if(!isJSONSchema(s))return o;if(!isJSONSchema(o))return s;const a={...o,...s};if(o.type&&s.type&&Array.isArray(o.type)&&"string"==typeof o.type){const i=normalizeArray(o.type).concat(s.type);a.type=Array.from(new Set(i))}if(Array.isArray(o.required)&&Array.isArray(s.required)&&(a.required=[...new Set([...s.required,...o.required])]),o.properties&&s.properties){const u=new Set([...Object.keys(o.properties),...Object.keys(s.properties)]);a.properties={};for(const _ of u){const u=o.properties[_]||{},w=s.properties[_]||{};u.readOnly&&!i.includeReadOnly||u.writeOnly&&!i.includeWriteOnly?a.required=(a.required||[]).filter((s=>s!==_)):a.properties[_]=merge_merge(w,u,i)}}return isJSONSchema(o.items)&&isJSONSchema(s.items)&&(a.items=merge_merge(s.items,o.items,i)),isJSONSchema(o.contains)&&isJSONSchema(s.contains)&&(a.contains=merge_merge(s.contains,o.contains,i)),isJSONSchema(o.contentSchema)&&isJSONSchema(s.contentSchema)&&(a.contentSchema=merge_merge(s.contentSchema,o.contentSchema,i)),a},zT=merge_merge,main_sampleFromSchemaGeneric=(s,o={},i=void 0,a=!1)=>{if(null==s&&void 0===i)return;"function"==typeof s?.toJS&&(s=s.toJS()),s=typeCast(s);let u=void 0!==i||hasExample(s);const _=!u&&Array.isArray(s.oneOf)&&s.oneOf.length>0,w=!u&&Array.isArray(s.anyOf)&&s.anyOf.length>0;if(!u&&(_||w)){const i=typeCast(random_pick(_?s.oneOf:s.anyOf));!(s=zT(s,i,o)).xml&&i.xml&&(s.xml=i.xml),hasExample(s)&&hasExample(i)&&(u=!0)}const x={};let{xml:C,properties:j,additionalProperties:L,items:B,contains:$}=s||{},U=type_getType(s),{includeReadOnly:V,includeWriteOnly:z}=o;C=C||{};let Y,{name:Z,prefix:ee,namespace:ie}=C,ae={};if(Object.hasOwn(s,"type")||(s.type=U),a&&(Z=Z||"notagname",Y=(ee?`${ee}:`:"")+Z,ie)){x[ee?`xmlns:${ee}`:"xmlns"]=ie}a&&(ae[Y]=[]);const ce=objectify(j);let le,pe=0;const hasExceededMaxProperties=()=>Number.isInteger(s.maxProperties)&&s.maxProperties>0&&pe>=s.maxProperties,canAddProperty=o=>!(Number.isInteger(s.maxProperties)&&s.maxProperties>0)||!hasExceededMaxProperties()&&(!(o=>!Array.isArray(s.required)||0===s.required.length||!s.required.includes(o))(o)||s.maxProperties-pe-(()=>{if(!Array.isArray(s.required)||0===s.required.length)return 0;let o=0;return a?s.required.forEach((s=>o+=void 0===ae[s]?0:1)):s.required.forEach((s=>{o+=void 0===ae[Y]?.find((o=>void 0!==o[s]))?0:1})),s.required.length-o})()>0);if(le=a?(i,u=void 0)=>{if(s&&ce[i]){if(ce[i].xml=ce[i].xml||{},ce[i].xml.attribute){const s=Array.isArray(ce[i].enum)?random_pick(ce[i].enum):void 0;if(hasExample(ce[i]))x[ce[i].xml.name||i]=extractExample(ce[i]);else if(void 0!==s)x[ce[i].xml.name||i]=s;else{const s=typeCast(ce[i]),a=type_getType(s),_=ce[i].xml.name||i;if("array"===a){const s=main_sampleFromSchemaGeneric(ce[i],o,u,!1);x[_]=s.map((s=>as()(s)?"UnknownTypeObject":Array.isArray(s)?"UnknownTypeArray":s)).join(" ")}else x[_]="object"===a?"UnknownTypeObject":$T[a](s)}return}ce[i].xml.name=ce[i].xml.name||i}else ce[i]||!1===L||(ce[i]={xml:{name:i}});let _=main_sampleFromSchemaGeneric(ce[i],o,u,a);canAddProperty(i)&&(pe++,Array.isArray(_)?ae[Y]=ae[Y].concat(_):ae[Y].push(_))}:(i,u)=>{if(canAddProperty(i)){if(as()(s.discriminator?.mapping)&&s.discriminator.propertyName===i&&"string"==typeof s.$$ref){for(const o in s.discriminator.mapping)if(-1!==s.$$ref.search(s.discriminator.mapping[o])){ae[i]=o;break}}else ae[i]=main_sampleFromSchemaGeneric(ce[i],o,u,a);pe++}},u){let u;if(u=void 0!==i?i:extractExample(s),!a){if("number"==typeof u&&"string"===U)return`${u}`;if("string"!=typeof u||"string"===U)return u;try{return JSON.parse(u)}catch{return u}}if("array"===U){if(!Array.isArray(u)){if("string"==typeof u)return u;u=[u]}let i=[];return isJSONSchemaObject(B)&&(B.xml=B.xml||C||{},B.xml.name=B.xml.name||C.name,i=u.map((s=>main_sampleFromSchemaGeneric(B,o,s,a)))),isJSONSchemaObject($)&&($.xml=$.xml||C||{},$.xml.name=$.xml.name||C.name,i=[main_sampleFromSchemaGeneric($,o,void 0,a),...i]),i=$T.array(s,{sample:i}),C.wrapped?(ae[Y]=i,ds()(x)||ae[Y].push({_attr:x})):ae=i,ae}if("object"===U){if("string"==typeof u)return u;for(const s in u)Object.hasOwn(u,s)&&(ce[s]?.readOnly&&!V||ce[s]?.writeOnly&&!z||(ce[s]?.xml?.attribute?x[ce[s].xml.name||s]=u[s]:le(s,u[s])));return ds()(x)||ae[Y].push({_attr:x}),ae}return ae[Y]=ds()(x)?u:[{_attr:x},u],ae}if("array"===U){let i=[];if(isJSONSchemaObject($))if(a&&($.xml=$.xml||s.xml||{},$.xml.name=$.xml.name||C.name),Array.isArray($.anyOf)){const{anyOf:s,...u}=B;i.push(...$.anyOf.map((s=>main_sampleFromSchemaGeneric(zT(s,u,o),o,void 0,a))))}else if(Array.isArray($.oneOf)){const{oneOf:s,...u}=B;i.push(...$.oneOf.map((s=>main_sampleFromSchemaGeneric(zT(s,u,o),o,void 0,a))))}else{if(!(!a||a&&C.wrapped))return main_sampleFromSchemaGeneric($,o,void 0,a);i.push(main_sampleFromSchemaGeneric($,o,void 0,a))}if(isJSONSchemaObject(B))if(a&&(B.xml=B.xml||s.xml||{},B.xml.name=B.xml.name||C.name),Array.isArray(B.anyOf)){const{anyOf:s,...u}=B;i.push(...B.anyOf.map((s=>main_sampleFromSchemaGeneric(zT(s,u,o),o,void 0,a))))}else if(Array.isArray(B.oneOf)){const{oneOf:s,...u}=B;i.push(...B.oneOf.map((s=>main_sampleFromSchemaGeneric(zT(s,u,o),o,void 0,a))))}else{if(!(!a||a&&C.wrapped))return main_sampleFromSchemaGeneric(B,o,void 0,a);i.push(main_sampleFromSchemaGeneric(B,o,void 0,a))}return i=$T.array(s,{sample:i}),a&&C.wrapped?(ae[Y]=i,ds()(x)||ae[Y].push({_attr:x}),ae):i}if("object"===U){for(let s in ce)Object.hasOwn(ce,s)&&(ce[s]?.deprecated||ce[s]?.readOnly&&!V||ce[s]?.writeOnly&&!z||le(s));if(a&&x&&ae[Y].push({_attr:x}),hasExceededMaxProperties())return ae;if(predicates_isBooleanJSONSchema(L)&&L)a?ae[Y].push({additionalProp:"Anything can be here"}):ae.additionalProp1={},pe++;else if(isJSONSchemaObject(L)){const i=L,u=main_sampleFromSchemaGeneric(i,o,void 0,a);if(a&&"string"==typeof i?.xml?.name&&"notagname"!==i?.xml?.name)ae[Y].push(u);else{const o=i?.["x-additionalPropertiesName"]||"additionalProp",_=Number.isInteger(s.minProperties)&&s.minProperties>0&&pe<s.minProperties?s.minProperties-pe:3;for(let s=1;s<=_;s++){if(hasExceededMaxProperties())return ae;if(a){const i={};i[o+s]=u.notagname,ae[Y].push(i)}else ae[o+s]=u;pe++}}}return ae}let de;if(void 0!==s.const)de=s.const;else if(s&&Array.isArray(s.enum))de=random_pick(normalizeArray(s.enum));else{const i=isJSONSchemaObject(s.contentSchema)?main_sampleFromSchemaGeneric(s.contentSchema,o,void 0,a):void 0;de=$T[U](s,{sample:i})}return a?(ae[Y]=ds()(x)?de:[{_attr:x},de],ae):de},main_createXMLExample=(s,o,i)=>{const a=main_sampleFromSchemaGeneric(s,o,i,!0);if(a)return"string"==typeof a?a:ls()(a,{declaration:!0,indent:"\t"})},main_sampleFromSchema=(s,o,i)=>main_sampleFromSchemaGeneric(s,o,i,!1),main_resolver=(s,o,i)=>[s,JSON.stringify(o),JSON.stringify(i)],WT=utils_memoizeN(main_createXMLExample,main_resolver),JT=utils_memoizeN(main_sampleFromSchema,main_resolver);const HT=new class OptionRegistry extends _T{#s={};data={...this.#s};get defaults(){return{...this.#s}}},api_optionAPI=(s,o)=>(void 0!==o&&HT.register(s,o),HT.get(s)),KT=[{when:/json/,shouldStringifyTypes:["string"]}],GT=["object"],fn_get_json_sample_schema=s=>(o,i,a,u)=>{const{fn:_}=s(),w=_.jsonSchema202012.memoizedSampleFromSchema(o,i,u),x=typeof w,C=KT.reduce(((s,o)=>o.when.test(a)?[...s,...o.shouldStringifyTypes]:s),GT);return gt()(C,(s=>s===x))?JSON.stringify(w,null,2):w},fn_get_yaml_sample_schema=s=>(o,i,a,u)=>{const{fn:_}=s(),w=_.jsonSchema202012.getJsonSampleSchema(o,i,a,u);let x;try{x=fn.dump(fn.load(w),{lineWidth:-1},{schema:rn}),"\n"===x[x.length-1]&&(x=x.slice(0,x.length-1))}catch(s){return console.error(s),"error: could not generate yaml example"}return x.replace(/\t/g,"  ")},fn_get_xml_sample_schema=s=>(o,i,a)=>{const{fn:u}=s();if(o&&!o.xml&&(o.xml={}),o&&!o.xml.name){if(!o.$$ref&&(o.type||o.items||o.properties||o.additionalProperties))return'<?xml version="1.0" encoding="UTF-8"?>\n\x3c!-- XML example cannot be generated; root element name is undefined --\x3e';if(o.$$ref){let s=o.$$ref.match(/\S*\/(\S+)$/);o.xml.name=s[1]}}return u.jsonSchema202012.memoizedCreateXMLExample(o,i,a)},fn_get_sample_schema=s=>(o,i="",a={},u=void 0)=>{const{fn:_}=s();return"function"==typeof o?.toJS&&(o=o.toJS()),"function"==typeof u?.toJS&&(u=u.toJS()),/xml/.test(i)?_.jsonSchema202012.getXmlSampleSchema(o,a,u):/(yaml|yml)/.test(i)?_.jsonSchema202012.getYamlSampleSchema(o,a,i,u):_.jsonSchema202012.getJsonSampleSchema(o,a,i,u)},json_schema_2020_12_samples=({getSystem:s})=>{const o=fn_get_json_sample_schema(s),i=fn_get_yaml_sample_schema(s),a=fn_get_xml_sample_schema(s),u=fn_get_sample_schema(s);return{fn:{jsonSchema202012:{sampleFromSchema:main_sampleFromSchema,sampleFromSchemaGeneric:main_sampleFromSchemaGeneric,sampleOptionAPI:api_optionAPI,sampleEncoderAPI:TT,sampleFormatAPI:wT,sampleMediaTypeAPI:BT,createXMLExample:main_createXMLExample,memoizedSampleFromSchema:JT,memoizedCreateXMLExample:WT,getJsonSampleSchema:o,getYamlSampleSchema:i,getXmlSampleSchema:a,getSampleSchema:u,mergeJsonSchema:zT,foldType}}}};function PresetApis(){return[base,oas3,json_schema_2020_12,json_schema_2020_12_samples,oas31,oas32]}const inline_plugin=s=>()=>({fn:s.fn,components:s.components}),factorization_system=s=>{const o=Ye()({layout:{layout:s.layout,filter:s.filter},spec:{spec:"",url:s.url},requestSnippets:s.requestSnippets},s.initialState);if(s.initialState)for(const[i,a]of Object.entries(s.initialState))void 0===a&&delete o[i];return{system:{configs:s.configs},plugins:s.presets,state:o}},sources_query=()=>s=>{const o=s.queryConfigEnabled?(()=>{const s=new URLSearchParams(lt.location.search);return Object.fromEntries(s)})():{};return Object.entries(o).reduce(((s,[o,i])=>("config"===o?s.configUrl=i:"urls.primaryName"===o?s[o]=i:s=co()(s,o,i),s)),{})},sources_url=({url:s,system:o})=>async i=>{if(!s)return{};if("function"!=typeof o.configsActions?.getConfigByUrl)return{};const a=(()=>{const s={};return s.promise=new Promise(((o,i)=>{s.resolve=o,s.reject=i})),s})();return o.configsActions.getConfigByUrl({url:s,loadRemoteConfig:!0,requestInterceptor:i.requestInterceptor,responseInterceptor:i.responseInterceptor},(s=>{a.resolve(s)})),a.promise},runtime=()=>()=>{const s={};return globalThis.location&&(s.oauth2RedirectUrl=`${globalThis.location.protocol}//${globalThis.location.host}${globalThis.location.pathname.substring(0,globalThis.location.pathname.lastIndexOf("/"))}/oauth2-redirect.html`),s},YT=Object.freeze({dom_id:null,domNode:null,spec:{},url:"",urls:null,configUrl:null,layout:"BaseLayout",docExpansion:"list",maxDisplayedTags:-1,filter:!1,validatorUrl:"https://validator.swagger.io/validator",oauth2RedirectUrl:void 0,persistAuthorization:!1,configs:{},displayOperationId:!1,displayRequestDuration:!1,deepLinking:!1,tryItOutEnabled:!1,requestInterceptor:s=>(s.curlOptions=[],s),responseInterceptor:s=>s,showMutatedRequest:!0,defaultModelRendering:"example",defaultModelExpandDepth:1,defaultModelsExpandDepth:1,showExtensions:!1,showCommonExtensions:!1,withCredentials:!1,requestSnippetsEnabled:!1,requestSnippets:{generators:{curl_bash:{title:"cURL (bash)",syntax:"bash"},curl_powershell:{title:"cURL (PowerShell)",syntax:"powershell"},curl_cmd:{title:"cURL (CMD)",syntax:"bash"}},defaultExpanded:!0,languages:null},supportedSubmitMethods:["get","put","post","delete","options","head","patch","trace"],queryConfigEnabled:!1,presets:[PresetApis],plugins:[],initialState:{},fn:{},components:{},syntaxHighlight:{activated:!0,theme:"agate"},operationsSorter:null,tagsSorter:null,onComplete:null,modelPropertyMacro:null,parameterMacro:null,fileUploadMediaTypes:["application/octet-stream","image/","audio/","video/"],uncaughtExceptionHandler:null});var XT=__webpack_require__(61448),QT=__webpack_require__.n(XT),ZT=__webpack_require__(77731),eN=__webpack_require__.n(ZT);const type_casters_array=(s,o=[])=>Array.isArray(s)?s:o,type_casters_boolean=(s,o=!1)=>!0===s||"true"===s||1===s||"1"===s||!1!==s&&"false"!==s&&0!==s&&"0"!==s&&o,dom_node=s=>null===s||"null"===s?null:s,type_casters_filter=s=>{const o=String(s);return type_casters_boolean(s,o)},type_casters_function=(s,o)=>"function"==typeof s?s:o,nullable_array=s=>Array.isArray(s)?s:null,nullable_function=s=>"function"==typeof s?s:null,nullable_string=s=>null===s||"null"===s?null:String(s),type_casters_number=(s,o=-1)=>{const i=parseInt(s,10);return Number.isNaN(i)?o:i},type_casters_object=(s,o={})=>as()(s)?s:o,sorter=s=>"function"==typeof s||"string"==typeof s?s:null,type_casters_string=s=>String(s),syntax_highlight=(s,o)=>as()(s)?s:!1===s||"false"===s||0===s||"0"===s?{activated:!1}:o,undefined_string=s=>void 0===s||"undefined"===s?void 0:String(s),tN={components:{typeCaster:type_casters_object},configs:{typeCaster:type_casters_object},configUrl:{typeCaster:nullable_string},deepLinking:{typeCaster:type_casters_boolean,defaultValue:YT.deepLinking},defaultModelExpandDepth:{typeCaster:type_casters_number,defaultValue:YT.defaultModelExpandDepth},defaultModelRendering:{typeCaster:type_casters_string},defaultModelsExpandDepth:{typeCaster:type_casters_number,defaultValue:YT.defaultModelsExpandDepth},displayOperationId:{typeCaster:type_casters_boolean,defaultValue:YT.displayOperationId},displayRequestDuration:{typeCaster:type_casters_boolean,defaultValue:YT.displayRequestDuration},docExpansion:{typeCaster:type_casters_string},dom_id:{typeCaster:nullable_string},domNode:{typeCaster:dom_node},fileUploadMediaTypes:{typeCaster:type_casters_array,defaultValue:YT.fileUploadMediaTypes},filter:{typeCaster:type_casters_filter},fn:{typeCaster:type_casters_object},initialState:{typeCaster:type_casters_object},layout:{typeCaster:type_casters_string},maxDisplayedTags:{typeCaster:type_casters_number,defaultValue:YT.maxDisplayedTags},modelPropertyMacro:{typeCaster:nullable_function},oauth2RedirectUrl:{typeCaster:undefined_string},onComplete:{typeCaster:nullable_function},operationsSorter:{typeCaster:sorter},paramaterMacro:{typeCaster:nullable_function},persistAuthorization:{typeCaster:type_casters_boolean,defaultValue:YT.persistAuthorization},plugins:{typeCaster:type_casters_array,defaultValue:YT.plugins},presets:{typeCaster:type_casters_array,defaultValue:YT.presets},requestInterceptor:{typeCaster:type_casters_function,defaultValue:YT.requestInterceptor},requestSnippets:{typeCaster:type_casters_object,defaultValue:YT.requestSnippets},requestSnippetsEnabled:{typeCaster:type_casters_boolean,defaultValue:YT.requestSnippetsEnabled},responseInterceptor:{typeCaster:type_casters_function,defaultValue:YT.responseInterceptor},showCommonExtensions:{typeCaster:type_casters_boolean,defaultValue:YT.showCommonExtensions},showExtensions:{typeCaster:type_casters_boolean,defaultValue:YT.showExtensions},showMutatedRequest:{typeCaster:type_casters_boolean,defaultValue:YT.showMutatedRequest},spec:{typeCaster:type_casters_object,defaultValue:YT.spec},supportedSubmitMethods:{typeCaster:type_casters_array,defaultValue:YT.supportedSubmitMethods},syntaxHighlight:{typeCaster:syntax_highlight,defaultValue:YT.syntaxHighlight},"syntaxHighlight.activated":{typeCaster:type_casters_boolean,defaultValue:YT.syntaxHighlight.activated},"syntaxHighlight.theme":{typeCaster:type_casters_string},tagsSorter:{typeCaster:sorter},tryItOutEnabled:{typeCaster:type_casters_boolean,defaultValue:YT.tryItOutEnabled},url:{typeCaster:type_casters_string},urls:{typeCaster:nullable_array},"urls.primaryName":{typeCaster:type_casters_string},validatorUrl:{typeCaster:nullable_string},withCredentials:{typeCaster:type_casters_boolean,defaultValue:YT.withCredentials},uncaughtExceptionHandler:{typeCaster:nullable_function}},type_cast=s=>Object.entries(tN).reduce(((s,[o,{typeCaster:i,defaultValue:a}])=>{if(QT()(s,o)){const u=i(Cn()(s,o),a);s=eN()(o,u,s)}return s}),{...s}),config_merge=(s,...o)=>{let i=Symbol.for("domNode"),a=Symbol.for("primaryName");const u=[];for(const s of o){const o={...s};Object.hasOwn(o,"domNode")&&(i=o.domNode,delete o.domNode),Object.hasOwn(o,"urls.primaryName")?(a=o["urls.primaryName"],delete o["urls.primaryName"]):Array.isArray(o.urls)&&Object.hasOwn(o.urls,"primaryName")&&(a=o.urls.primaryName,delete o.urls.primaryName),u.push(o)}const _=Ye()(s,...u);return i!==Symbol.for("domNode")&&(_.domNode=i),a!==Symbol.for("primaryName")&&Array.isArray(_.urls)&&(_.urls.primaryName=a),type_cast(_)};function SwaggerUI(s){const o=sources_query()(s),i=runtime()(),a=SwaggerUI.config.merge({},SwaggerUI.config.defaults,i,s,o),u=factorization_system(a),_=inline_plugin(a),w=new Store(u);w.register([a.plugins,_]);const x=w.getSystem(),persistConfigs=s=>{w.setConfigs(s),x.configsActions.loaded()},updateSpec=s=>{!o.url&&"object"==typeof s.spec&&Object.keys(s.spec).length>0?(x.specActions.updateUrl(""),x.specActions.updateLoadingStatus("success"),x.specActions.updateSpec(JSON.stringify(s.spec))):"function"==typeof x.specActions.download&&s.url&&!s.urls&&(x.specActions.updateUrl(s.url),x.specActions.download(s.url))},render=s=>{if(s.domNode)x.render(s.domNode,"App");else if(s.dom_id){const o=document.querySelector(s.dom_id);x.render(o,"App")}else null===s.dom_id||null===s.domNode||console.error("Skipped rendering: no `dom_id` or `domNode` was specified")};return a.configUrl?((async()=>{const{configUrl:s}=a,i=await sources_url({url:s,system:x})(a),u=SwaggerUI.config.merge({},a,i,o);persistConfigs(u),null!==i&&updateSpec(u),render(u)})(),x):(persistConfigs(a),updateSpec(a),render(a),x)}SwaggerUI.System=Store,SwaggerUI.config={defaults:YT,merge:config_merge,typeCast:type_cast,typeCastMappings:tN},SwaggerUI.presets={base,apis:PresetApis},SwaggerUI.plugins={Auth:auth,Configs:configsPlugin,DeepLining:deep_linking,Err:err,Filter:filter,Icons:icons,JSONSchema5:json_schema_5,JSONSchema5Samples:json_schema_5_samples,JSONSchema202012:json_schema_2020_12,JSONSchema202012Samples:json_schema_2020_12_samples,Layout:plugins_layout,Logs:logs,OpenAPI30:oas3,OpenAPI31:oas3,OnComplete:on_complete,RequestSnippets:plugins_request_snippets,Spec:plugins_spec,SwaggerClient:swagger_client,Util:util,View:view,ViewLegacy:view_legacy,DownloadUrl:downloadUrlPlugin,SyntaxHighlighting:syntax_highlighting,Versions:versions,SafeRender:safe_render};const rN=SwaggerUI})(),i=i.default})()));
/*! For license information please see swagger-ui-standalone-preset.js.LICENSE.txt */
!function webpackUniversalModuleDefinition(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.SwaggerUIStandalonePreset=e():t.SwaggerUIStandalonePreset=e()}(this,(()=>(()=>{var t={7526(t,e){"use strict";e.byteLength=function byteLength(t){var e=getLens(t),r=e[0],n=e[1];return 3*(r+n)/4-n},e.toByteArray=function toByteArray(t){var e,r,i=getLens(t),a=i[0],s=i[1],u=new o(function _byteLength(t,e,r){return 3*(e+r)/4-r}(0,a,s)),c=0,f=s>0?a-4:a;for(r=0;r<f;r+=4)e=n[t.charCodeAt(r)]<<18|n[t.charCodeAt(r+1)]<<12|n[t.charCodeAt(r+2)]<<6|n[t.charCodeAt(r+3)],u[c++]=e>>16&255,u[c++]=e>>8&255,u[c++]=255&e;2===s&&(e=n[t.charCodeAt(r)]<<2|n[t.charCodeAt(r+1)]>>4,u[c++]=255&e);1===s&&(e=n[t.charCodeAt(r)]<<10|n[t.charCodeAt(r+1)]<<4|n[t.charCodeAt(r+2)]>>2,u[c++]=e>>8&255,u[c++]=255&e);return u},e.fromByteArray=function fromByteArray(t){for(var e,n=t.length,o=n%3,i=[],a=16383,s=0,u=n-o;s<u;s+=a)i.push(encodeChunk(t,s,s+a>u?u:s+a));1===o?(e=t[n-1],i.push(r[e>>2]+r[e<<4&63]+"==")):2===o&&(e=(t[n-2]<<8)+t[n-1],i.push(r[e>>10]+r[e>>4&63]+r[e<<2&63]+"="));return i.join("")};for(var r=[],n=[],o="undefined"!=typeof Uint8Array?Uint8Array:Array,i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",a=0;a<64;++a)r[a]=i[a],n[i.charCodeAt(a)]=a;function getLens(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var r=t.indexOf("=");return-1===r&&(r=e),[r,r===e?0:4-r%4]}function encodeChunk(t,e,n){for(var o,i,a=[],s=e;s<n;s+=3)o=(t[s]<<16&16711680)+(t[s+1]<<8&65280)+(255&t[s+2]),a.push(r[(i=o)>>18&63]+r[i>>12&63]+r[i>>6&63]+r[63&i]);return a.join("")}n["-".charCodeAt(0)]=62,n["_".charCodeAt(0)]=63},8287(t,e,r){"use strict";const n=r(7526),o=r(251),i="function"==typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("nodejs.util.inspect.custom"):null;e.Buffer=Buffer,e.SlowBuffer=function SlowBuffer(t){+t!=t&&(t=0);return Buffer.alloc(+t)},e.INSPECT_MAX_BYTES=50;const a=2147483647;function createBuffer(t){if(t>a)throw new RangeError('The value "'+t+'" is invalid for option "size"');const e=new Uint8Array(t);return Object.setPrototypeOf(e,Buffer.prototype),e}function Buffer(t,e,r){if("number"==typeof t){if("string"==typeof e)throw new TypeError('The "string" argument must be of type string. Received type number');return allocUnsafe(t)}return from(t,e,r)}function from(t,e,r){if("string"==typeof t)return function fromString(t,e){"string"==typeof e&&""!==e||(e="utf8");if(!Buffer.isEncoding(e))throw new TypeError("Unknown encoding: "+e);const r=0|byteLength(t,e);let n=createBuffer(r);const o=n.write(t,e);o!==r&&(n=n.slice(0,o));return n}(t,e);if(ArrayBuffer.isView(t))return function fromArrayView(t){if(isInstance(t,Uint8Array)){const e=new Uint8Array(t);return fromArrayBuffer(e.buffer,e.byteOffset,e.byteLength)}return fromArrayLike(t)}(t);if(null==t)throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof t);if(isInstance(t,ArrayBuffer)||t&&isInstance(t.buffer,ArrayBuffer))return fromArrayBuffer(t,e,r);if("undefined"!=typeof SharedArrayBuffer&&(isInstance(t,SharedArrayBuffer)||t&&isInstance(t.buffer,SharedArrayBuffer)))return fromArrayBuffer(t,e,r);if("number"==typeof t)throw new TypeError('The "value" argument must not be of type number. Received type number');const n=t.valueOf&&t.valueOf();if(null!=n&&n!==t)return Buffer.from(n,e,r);const o=function fromObject(t){if(Buffer.isBuffer(t)){const e=0|checked(t.length),r=createBuffer(e);return 0===r.length||t.copy(r,0,0,e),r}if(void 0!==t.length)return"number"!=typeof t.length||numberIsNaN(t.length)?createBuffer(0):fromArrayLike(t);if("Buffer"===t.type&&Array.isArray(t.data))return fromArrayLike(t.data)}(t);if(o)return o;if("undefined"!=typeof Symbol&&null!=Symbol.toPrimitive&&"function"==typeof t[Symbol.toPrimitive])return Buffer.from(t[Symbol.toPrimitive]("string"),e,r);throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof t)}function assertSize(t){if("number"!=typeof t)throw new TypeError('"size" argument must be of type number');if(t<0)throw new RangeError('The value "'+t+'" is invalid for option "size"')}function allocUnsafe(t){return assertSize(t),createBuffer(t<0?0:0|checked(t))}function fromArrayLike(t){const e=t.length<0?0:0|checked(t.length),r=createBuffer(e);for(let n=0;n<e;n+=1)r[n]=255&t[n];return r}function fromArrayBuffer(t,e,r){if(e<0||t.byteLength<e)throw new RangeError('"offset" is outside of buffer bounds');if(t.byteLength<e+(r||0))throw new RangeError('"length" is outside of buffer bounds');let n;return n=void 0===e&&void 0===r?new Uint8Array(t):void 0===r?new Uint8Array(t,e):new Uint8Array(t,e,r),Object.setPrototypeOf(n,Buffer.prototype),n}function checked(t){if(t>=a)throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+a.toString(16)+" bytes");return 0|t}function byteLength(t,e){if(Buffer.isBuffer(t))return t.length;if(ArrayBuffer.isView(t)||isInstance(t,ArrayBuffer))return t.byteLength;if("string"!=typeof t)throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type '+typeof t);const r=t.length,n=arguments.length>2&&!0===arguments[2];if(!n&&0===r)return 0;let o=!1;for(;;)switch(e){case"ascii":case"latin1":case"binary":return r;case"utf8":case"utf-8":return utf8ToBytes(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*r;case"hex":return r>>>1;case"base64":return base64ToBytes(t).length;default:if(o)return n?-1:utf8ToBytes(t).length;e=(""+e).toLowerCase(),o=!0}}function slowToString(t,e,r){let n=!1;if((void 0===e||e<0)&&(e=0),e>this.length)return"";if((void 0===r||r>this.length)&&(r=this.length),r<=0)return"";if((r>>>=0)<=(e>>>=0))return"";for(t||(t="utf8");;)switch(t){case"hex":return hexSlice(this,e,r);case"utf8":case"utf-8":return utf8Slice(this,e,r);case"ascii":return asciiSlice(this,e,r);case"latin1":case"binary":return latin1Slice(this,e,r);case"base64":return base64Slice(this,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return utf16leSlice(this,e,r);default:if(n)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),n=!0}}function swap(t,e,r){const n=t[e];t[e]=t[r],t[r]=n}function bidirectionalIndexOf(t,e,r,n,o){if(0===t.length)return-1;if("string"==typeof r?(n=r,r=0):r>2147483647?r=2147483647:r<-2147483648&&(r=-2147483648),numberIsNaN(r=+r)&&(r=o?0:t.length-1),r<0&&(r=t.length+r),r>=t.length){if(o)return-1;r=t.length-1}else if(r<0){if(!o)return-1;r=0}if("string"==typeof e&&(e=Buffer.from(e,n)),Buffer.isBuffer(e))return 0===e.length?-1:arrayIndexOf(t,e,r,n,o);if("number"==typeof e)return e&=255,"function"==typeof Uint8Array.prototype.indexOf?o?Uint8Array.prototype.indexOf.call(t,e,r):Uint8Array.prototype.lastIndexOf.call(t,e,r):arrayIndexOf(t,[e],r,n,o);throw new TypeError("val must be string, number or Buffer")}function arrayIndexOf(t,e,r,n,o){let i,a=1,s=t.length,u=e.length;if(void 0!==n&&("ucs2"===(n=String(n).toLowerCase())||"ucs-2"===n||"utf16le"===n||"utf-16le"===n)){if(t.length<2||e.length<2)return-1;a=2,s/=2,u/=2,r/=2}function read(t,e){return 1===a?t[e]:t.readUInt16BE(e*a)}if(o){let n=-1;for(i=r;i<s;i++)if(read(t,i)===read(e,-1===n?0:i-n)){if(-1===n&&(n=i),i-n+1===u)return n*a}else-1!==n&&(i-=i-n),n=-1}else for(r+u>s&&(r=s-u),i=r;i>=0;i--){let r=!0;for(let n=0;n<u;n++)if(read(t,i+n)!==read(e,n)){r=!1;break}if(r)return i}return-1}function hexWrite(t,e,r,n){r=Number(r)||0;const o=t.length-r;n?(n=Number(n))>o&&(n=o):n=o;const i=e.length;let a;for(n>i/2&&(n=i/2),a=0;a<n;++a){const n=parseInt(e.substr(2*a,2),16);if(numberIsNaN(n))return a;t[r+a]=n}return a}function utf8Write(t,e,r,n){return blitBuffer(utf8ToBytes(e,t.length-r),t,r,n)}function asciiWrite(t,e,r,n){return blitBuffer(function asciiToBytes(t){const e=[];for(let r=0;r<t.length;++r)e.push(255&t.charCodeAt(r));return e}(e),t,r,n)}function base64Write(t,e,r,n){return blitBuffer(base64ToBytes(e),t,r,n)}function ucs2Write(t,e,r,n){return blitBuffer(function utf16leToBytes(t,e){let r,n,o;const i=[];for(let a=0;a<t.length&&!((e-=2)<0);++a)r=t.charCodeAt(a),n=r>>8,o=r%256,i.push(o),i.push(n);return i}(e,t.length-r),t,r,n)}function base64Slice(t,e,r){return 0===e&&r===t.length?n.fromByteArray(t):n.fromByteArray(t.slice(e,r))}function utf8Slice(t,e,r){r=Math.min(t.length,r);const n=[];let o=e;for(;o<r;){const e=t[o];let i=null,a=e>239?4:e>223?3:e>191?2:1;if(o+a<=r){let r,n,s,u;switch(a){case 1:e<128&&(i=e);break;case 2:r=t[o+1],128==(192&r)&&(u=(31&e)<<6|63&r,u>127&&(i=u));break;case 3:r=t[o+1],n=t[o+2],128==(192&r)&&128==(192&n)&&(u=(15&e)<<12|(63&r)<<6|63&n,u>2047&&(u<55296||u>57343)&&(i=u));break;case 4:r=t[o+1],n=t[o+2],s=t[o+3],128==(192&r)&&128==(192&n)&&128==(192&s)&&(u=(15&e)<<18|(63&r)<<12|(63&n)<<6|63&s,u>65535&&u<1114112&&(i=u))}}null===i?(i=65533,a=1):i>65535&&(i-=65536,n.push(i>>>10&1023|55296),i=56320|1023&i),n.push(i),o+=a}return function decodeCodePointsArray(t){const e=t.length;if(e<=s)return String.fromCharCode.apply(String,t);let r="",n=0;for(;n<e;)r+=String.fromCharCode.apply(String,t.slice(n,n+=s));return r}(n)}e.kMaxLength=a,Buffer.TYPED_ARRAY_SUPPORT=function typedArraySupport(){try{const t=new Uint8Array(1),e={foo:function(){return 42}};return Object.setPrototypeOf(e,Uint8Array.prototype),Object.setPrototypeOf(t,e),42===t.foo()}catch(t){return!1}}(),Buffer.TYPED_ARRAY_SUPPORT||"undefined"==typeof console||"function"!=typeof console.error||console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."),Object.defineProperty(Buffer.prototype,"parent",{enumerable:!0,get:function(){if(Buffer.isBuffer(this))return this.buffer}}),Object.defineProperty(Buffer.prototype,"offset",{enumerable:!0,get:function(){if(Buffer.isBuffer(this))return this.byteOffset}}),Buffer.poolSize=8192,Buffer.from=function(t,e,r){return from(t,e,r)},Object.setPrototypeOf(Buffer.prototype,Uint8Array.prototype),Object.setPrototypeOf(Buffer,Uint8Array),Buffer.alloc=function(t,e,r){return function alloc(t,e,r){return assertSize(t),t<=0?createBuffer(t):void 0!==e?"string"==typeof r?createBuffer(t).fill(e,r):createBuffer(t).fill(e):createBuffer(t)}(t,e,r)},Buffer.allocUnsafe=function(t){return allocUnsafe(t)},Buffer.allocUnsafeSlow=function(t){return allocUnsafe(t)},Buffer.isBuffer=function isBuffer(t){return null!=t&&!0===t._isBuffer&&t!==Buffer.prototype},Buffer.compare=function compare(t,e){if(isInstance(t,Uint8Array)&&(t=Buffer.from(t,t.offset,t.byteLength)),isInstance(e,Uint8Array)&&(e=Buffer.from(e,e.offset,e.byteLength)),!Buffer.isBuffer(t)||!Buffer.isBuffer(e))throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');if(t===e)return 0;let r=t.length,n=e.length;for(let o=0,i=Math.min(r,n);o<i;++o)if(t[o]!==e[o]){r=t[o],n=e[o];break}return r<n?-1:n<r?1:0},Buffer.isEncoding=function isEncoding(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},Buffer.concat=function concat(t,e){if(!Array.isArray(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return Buffer.alloc(0);let r;if(void 0===e)for(e=0,r=0;r<t.length;++r)e+=t[r].length;const n=Buffer.allocUnsafe(e);let o=0;for(r=0;r<t.length;++r){let e=t[r];if(isInstance(e,Uint8Array))o+e.length>n.length?(Buffer.isBuffer(e)||(e=Buffer.from(e)),e.copy(n,o)):Uint8Array.prototype.set.call(n,e,o);else{if(!Buffer.isBuffer(e))throw new TypeError('"list" argument must be an Array of Buffers');e.copy(n,o)}o+=e.length}return n},Buffer.byteLength=byteLength,Buffer.prototype._isBuffer=!0,Buffer.prototype.swap16=function swap16(){const t=this.length;if(t%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(let e=0;e<t;e+=2)swap(this,e,e+1);return this},Buffer.prototype.swap32=function swap32(){const t=this.length;if(t%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(let e=0;e<t;e+=4)swap(this,e,e+3),swap(this,e+1,e+2);return this},Buffer.prototype.swap64=function swap64(){const t=this.length;if(t%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(let e=0;e<t;e+=8)swap(this,e,e+7),swap(this,e+1,e+6),swap(this,e+2,e+5),swap(this,e+3,e+4);return this},Buffer.prototype.toString=function toString(){const t=this.length;return 0===t?"":0===arguments.length?utf8Slice(this,0,t):slowToString.apply(this,arguments)},Buffer.prototype.toLocaleString=Buffer.prototype.toString,Buffer.prototype.equals=function equals(t){if(!Buffer.isBuffer(t))throw new TypeError("Argument must be a Buffer");return this===t||0===Buffer.compare(this,t)},Buffer.prototype.inspect=function inspect(){let t="";const r=e.INSPECT_MAX_BYTES;return t=this.toString("hex",0,r).replace(/(.{2})/g,"$1 ").trim(),this.length>r&&(t+=" ... "),"<Buffer "+t+">"},i&&(Buffer.prototype[i]=Buffer.prototype.inspect),Buffer.prototype.compare=function compare(t,e,r,n,o){if(isInstance(t,Uint8Array)&&(t=Buffer.from(t,t.offset,t.byteLength)),!Buffer.isBuffer(t))throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type '+typeof t);if(void 0===e&&(e=0),void 0===r&&(r=t?t.length:0),void 0===n&&(n=0),void 0===o&&(o=this.length),e<0||r>t.length||n<0||o>this.length)throw new RangeError("out of range index");if(n>=o&&e>=r)return 0;if(n>=o)return-1;if(e>=r)return 1;if(this===t)return 0;let i=(o>>>=0)-(n>>>=0),a=(r>>>=0)-(e>>>=0);const s=Math.min(i,a),u=this.slice(n,o),c=t.slice(e,r);for(let t=0;t<s;++t)if(u[t]!==c[t]){i=u[t],a=c[t];break}return i<a?-1:a<i?1:0},Buffer.prototype.includes=function includes(t,e,r){return-1!==this.indexOf(t,e,r)},Buffer.prototype.indexOf=function indexOf(t,e,r){return bidirectionalIndexOf(this,t,e,r,!0)},Buffer.prototype.lastIndexOf=function lastIndexOf(t,e,r){return bidirectionalIndexOf(this,t,e,r,!1)},Buffer.prototype.write=function write(t,e,r,n){if(void 0===e)n="utf8",r=this.length,e=0;else if(void 0===r&&"string"==typeof e)n=e,r=this.length,e=0;else{if(!isFinite(e))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");e>>>=0,isFinite(r)?(r>>>=0,void 0===n&&(n="utf8")):(n=r,r=void 0)}const o=this.length-e;if((void 0===r||r>o)&&(r=o),t.length>0&&(r<0||e<0)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");n||(n="utf8");let i=!1;for(;;)switch(n){case"hex":return hexWrite(this,t,e,r);case"utf8":case"utf-8":return utf8Write(this,t,e,r);case"ascii":case"latin1":case"binary":return asciiWrite(this,t,e,r);case"base64":return base64Write(this,t,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ucs2Write(this,t,e,r);default:if(i)throw new TypeError("Unknown encoding: "+n);n=(""+n).toLowerCase(),i=!0}},Buffer.prototype.toJSON=function toJSON(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};const s=4096;function asciiSlice(t,e,r){let n="";r=Math.min(t.length,r);for(let o=e;o<r;++o)n+=String.fromCharCode(127&t[o]);return n}function latin1Slice(t,e,r){let n="";r=Math.min(t.length,r);for(let o=e;o<r;++o)n+=String.fromCharCode(t[o]);return n}function hexSlice(t,e,r){const n=t.length;(!e||e<0)&&(e=0),(!r||r<0||r>n)&&(r=n);let o="";for(let n=e;n<r;++n)o+=f[t[n]];return o}function utf16leSlice(t,e,r){const n=t.slice(e,r);let o="";for(let t=0;t<n.length-1;t+=2)o+=String.fromCharCode(n[t]+256*n[t+1]);return o}function checkOffset(t,e,r){if(t%1!=0||t<0)throw new RangeError("offset is not uint");if(t+e>r)throw new RangeError("Trying to access beyond buffer length")}function checkInt(t,e,r,n,o,i){if(!Buffer.isBuffer(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(e>o||e<i)throw new RangeError('"value" argument is out of bounds');if(r+n>t.length)throw new RangeError("Index out of range")}function wrtBigUInt64LE(t,e,r,n,o){checkIntBI(e,n,o,t,r,7);let i=Number(e&BigInt(4294967295));t[r++]=i,i>>=8,t[r++]=i,i>>=8,t[r++]=i,i>>=8,t[r++]=i;let a=Number(e>>BigInt(32)&BigInt(4294967295));return t[r++]=a,a>>=8,t[r++]=a,a>>=8,t[r++]=a,a>>=8,t[r++]=a,r}function wrtBigUInt64BE(t,e,r,n,o){checkIntBI(e,n,o,t,r,7);let i=Number(e&BigInt(4294967295));t[r+7]=i,i>>=8,t[r+6]=i,i>>=8,t[r+5]=i,i>>=8,t[r+4]=i;let a=Number(e>>BigInt(32)&BigInt(4294967295));return t[r+3]=a,a>>=8,t[r+2]=a,a>>=8,t[r+1]=a,a>>=8,t[r]=a,r+8}function checkIEEE754(t,e,r,n,o,i){if(r+n>t.length)throw new RangeError("Index out of range");if(r<0)throw new RangeError("Index out of range")}function writeFloat(t,e,r,n,i){return e=+e,r>>>=0,i||checkIEEE754(t,0,r,4),o.write(t,e,r,n,23,4),r+4}function writeDouble(t,e,r,n,i){return e=+e,r>>>=0,i||checkIEEE754(t,0,r,8),o.write(t,e,r,n,52,8),r+8}Buffer.prototype.slice=function slice(t,e){const r=this.length;(t=~~t)<0?(t+=r)<0&&(t=0):t>r&&(t=r),(e=void 0===e?r:~~e)<0?(e+=r)<0&&(e=0):e>r&&(e=r),e<t&&(e=t);const n=this.subarray(t,e);return Object.setPrototypeOf(n,Buffer.prototype),n},Buffer.prototype.readUintLE=Buffer.prototype.readUIntLE=function readUIntLE(t,e,r){t>>>=0,e>>>=0,r||checkOffset(t,e,this.length);let n=this[t],o=1,i=0;for(;++i<e&&(o*=256);)n+=this[t+i]*o;return n},Buffer.prototype.readUintBE=Buffer.prototype.readUIntBE=function readUIntBE(t,e,r){t>>>=0,e>>>=0,r||checkOffset(t,e,this.length);let n=this[t+--e],o=1;for(;e>0&&(o*=256);)n+=this[t+--e]*o;return n},Buffer.prototype.readUint8=Buffer.prototype.readUInt8=function readUInt8(t,e){return t>>>=0,e||checkOffset(t,1,this.length),this[t]},Buffer.prototype.readUint16LE=Buffer.prototype.readUInt16LE=function readUInt16LE(t,e){return t>>>=0,e||checkOffset(t,2,this.length),this[t]|this[t+1]<<8},Buffer.prototype.readUint16BE=Buffer.prototype.readUInt16BE=function readUInt16BE(t,e){return t>>>=0,e||checkOffset(t,2,this.length),this[t]<<8|this[t+1]},Buffer.prototype.readUint32LE=Buffer.prototype.readUInt32LE=function readUInt32LE(t,e){return t>>>=0,e||checkOffset(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},Buffer.prototype.readUint32BE=Buffer.prototype.readUInt32BE=function readUInt32BE(t,e){return t>>>=0,e||checkOffset(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},Buffer.prototype.readBigUInt64LE=defineBigIntMethod((function readBigUInt64LE(t){validateNumber(t>>>=0,"offset");const e=this[t],r=this[t+7];void 0!==e&&void 0!==r||boundsError(t,this.length-8);const n=e+256*this[++t]+65536*this[++t]+this[++t]*2**24,o=this[++t]+256*this[++t]+65536*this[++t]+r*2**24;return BigInt(n)+(BigInt(o)<<BigInt(32))})),Buffer.prototype.readBigUInt64BE=defineBigIntMethod((function readBigUInt64BE(t){validateNumber(t>>>=0,"offset");const e=this[t],r=this[t+7];void 0!==e&&void 0!==r||boundsError(t,this.length-8);const n=e*2**24+65536*this[++t]+256*this[++t]+this[++t],o=this[++t]*2**24+65536*this[++t]+256*this[++t]+r;return(BigInt(n)<<BigInt(32))+BigInt(o)})),Buffer.prototype.readIntLE=function readIntLE(t,e,r){t>>>=0,e>>>=0,r||checkOffset(t,e,this.length);let n=this[t],o=1,i=0;for(;++i<e&&(o*=256);)n+=this[t+i]*o;return o*=128,n>=o&&(n-=Math.pow(2,8*e)),n},Buffer.prototype.readIntBE=function readIntBE(t,e,r){t>>>=0,e>>>=0,r||checkOffset(t,e,this.length);let n=e,o=1,i=this[t+--n];for(;n>0&&(o*=256);)i+=this[t+--n]*o;return o*=128,i>=o&&(i-=Math.pow(2,8*e)),i},Buffer.prototype.readInt8=function readInt8(t,e){return t>>>=0,e||checkOffset(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},Buffer.prototype.readInt16LE=function readInt16LE(t,e){t>>>=0,e||checkOffset(t,2,this.length);const r=this[t]|this[t+1]<<8;return 32768&r?4294901760|r:r},Buffer.prototype.readInt16BE=function readInt16BE(t,e){t>>>=0,e||checkOffset(t,2,this.length);const r=this[t+1]|this[t]<<8;return 32768&r?4294901760|r:r},Buffer.prototype.readInt32LE=function readInt32LE(t,e){return t>>>=0,e||checkOffset(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},Buffer.prototype.readInt32BE=function readInt32BE(t,e){return t>>>=0,e||checkOffset(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},Buffer.prototype.readBigInt64LE=defineBigIntMethod((function readBigInt64LE(t){validateNumber(t>>>=0,"offset");const e=this[t],r=this[t+7];void 0!==e&&void 0!==r||boundsError(t,this.length-8);const n=this[t+4]+256*this[t+5]+65536*this[t+6]+(r<<24);return(BigInt(n)<<BigInt(32))+BigInt(e+256*this[++t]+65536*this[++t]+this[++t]*2**24)})),Buffer.prototype.readBigInt64BE=defineBigIntMethod((function readBigInt64BE(t){validateNumber(t>>>=0,"offset");const e=this[t],r=this[t+7];void 0!==e&&void 0!==r||boundsError(t,this.length-8);const n=(e<<24)+65536*this[++t]+256*this[++t]+this[++t];return(BigInt(n)<<BigInt(32))+BigInt(this[++t]*2**24+65536*this[++t]+256*this[++t]+r)})),Buffer.prototype.readFloatLE=function readFloatLE(t,e){return t>>>=0,e||checkOffset(t,4,this.length),o.read(this,t,!0,23,4)},Buffer.prototype.readFloatBE=function readFloatBE(t,e){return t>>>=0,e||checkOffset(t,4,this.length),o.read(this,t,!1,23,4)},Buffer.prototype.readDoubleLE=function readDoubleLE(t,e){return t>>>=0,e||checkOffset(t,8,this.length),o.read(this,t,!0,52,8)},Buffer.prototype.readDoubleBE=function readDoubleBE(t,e){return t>>>=0,e||checkOffset(t,8,this.length),o.read(this,t,!1,52,8)},Buffer.prototype.writeUintLE=Buffer.prototype.writeUIntLE=function writeUIntLE(t,e,r,n){if(t=+t,e>>>=0,r>>>=0,!n){checkInt(this,t,e,r,Math.pow(2,8*r)-1,0)}let o=1,i=0;for(this[e]=255&t;++i<r&&(o*=256);)this[e+i]=t/o&255;return e+r},Buffer.prototype.writeUintBE=Buffer.prototype.writeUIntBE=function writeUIntBE(t,e,r,n){if(t=+t,e>>>=0,r>>>=0,!n){checkInt(this,t,e,r,Math.pow(2,8*r)-1,0)}let o=r-1,i=1;for(this[e+o]=255&t;--o>=0&&(i*=256);)this[e+o]=t/i&255;return e+r},Buffer.prototype.writeUint8=Buffer.prototype.writeUInt8=function writeUInt8(t,e,r){return t=+t,e>>>=0,r||checkInt(this,t,e,1,255,0),this[e]=255&t,e+1},Buffer.prototype.writeUint16LE=Buffer.prototype.writeUInt16LE=function writeUInt16LE(t,e,r){return t=+t,e>>>=0,r||checkInt(this,t,e,2,65535,0),this[e]=255&t,this[e+1]=t>>>8,e+2},Buffer.prototype.writeUint16BE=Buffer.prototype.writeUInt16BE=function writeUInt16BE(t,e,r){return t=+t,e>>>=0,r||checkInt(this,t,e,2,65535,0),this[e]=t>>>8,this[e+1]=255&t,e+2},Buffer.prototype.writeUint32LE=Buffer.prototype.writeUInt32LE=function writeUInt32LE(t,e,r){return t=+t,e>>>=0,r||checkInt(this,t,e,4,4294967295,0),this[e+3]=t>>>24,this[e+2]=t>>>16,this[e+1]=t>>>8,this[e]=255&t,e+4},Buffer.prototype.writeUint32BE=Buffer.prototype.writeUInt32BE=function writeUInt32BE(t,e,r){return t=+t,e>>>=0,r||checkInt(this,t,e,4,4294967295,0),this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t,e+4},Buffer.prototype.writeBigUInt64LE=defineBigIntMethod((function writeBigUInt64LE(t,e=0){return wrtBigUInt64LE(this,t,e,BigInt(0),BigInt("0xffffffffffffffff"))})),Buffer.prototype.writeBigUInt64BE=defineBigIntMethod((function writeBigUInt64BE(t,e=0){return wrtBigUInt64BE(this,t,e,BigInt(0),BigInt("0xffffffffffffffff"))})),Buffer.prototype.writeIntLE=function writeIntLE(t,e,r,n){if(t=+t,e>>>=0,!n){const n=Math.pow(2,8*r-1);checkInt(this,t,e,r,n-1,-n)}let o=0,i=1,a=0;for(this[e]=255&t;++o<r&&(i*=256);)t<0&&0===a&&0!==this[e+o-1]&&(a=1),this[e+o]=(t/i|0)-a&255;return e+r},Buffer.prototype.writeIntBE=function writeIntBE(t,e,r,n){if(t=+t,e>>>=0,!n){const n=Math.pow(2,8*r-1);checkInt(this,t,e,r,n-1,-n)}let o=r-1,i=1,a=0;for(this[e+o]=255&t;--o>=0&&(i*=256);)t<0&&0===a&&0!==this[e+o+1]&&(a=1),this[e+o]=(t/i|0)-a&255;return e+r},Buffer.prototype.writeInt8=function writeInt8(t,e,r){return t=+t,e>>>=0,r||checkInt(this,t,e,1,127,-128),t<0&&(t=255+t+1),this[e]=255&t,e+1},Buffer.prototype.writeInt16LE=function writeInt16LE(t,e,r){return t=+t,e>>>=0,r||checkInt(this,t,e,2,32767,-32768),this[e]=255&t,this[e+1]=t>>>8,e+2},Buffer.prototype.writeInt16BE=function writeInt16BE(t,e,r){return t=+t,e>>>=0,r||checkInt(this,t,e,2,32767,-32768),this[e]=t>>>8,this[e+1]=255&t,e+2},Buffer.prototype.writeInt32LE=function writeInt32LE(t,e,r){return t=+t,e>>>=0,r||checkInt(this,t,e,4,2147483647,-2147483648),this[e]=255&t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24,e+4},Buffer.prototype.writeInt32BE=function writeInt32BE(t,e,r){return t=+t,e>>>=0,r||checkInt(this,t,e,4,2147483647,-2147483648),t<0&&(t=4294967295+t+1),this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t,e+4},Buffer.prototype.writeBigInt64LE=defineBigIntMethod((function writeBigInt64LE(t,e=0){return wrtBigUInt64LE(this,t,e,-BigInt("0x8000000000000000"),BigInt("0x7fffffffffffffff"))})),Buffer.prototype.writeBigInt64BE=defineBigIntMethod((function writeBigInt64BE(t,e=0){return wrtBigUInt64BE(this,t,e,-BigInt("0x8000000000000000"),BigInt("0x7fffffffffffffff"))})),Buffer.prototype.writeFloatLE=function writeFloatLE(t,e,r){return writeFloat(this,t,e,!0,r)},Buffer.prototype.writeFloatBE=function writeFloatBE(t,e,r){return writeFloat(this,t,e,!1,r)},Buffer.prototype.writeDoubleLE=function writeDoubleLE(t,e,r){return writeDouble(this,t,e,!0,r)},Buffer.prototype.writeDoubleBE=function writeDoubleBE(t,e,r){return writeDouble(this,t,e,!1,r)},Buffer.prototype.copy=function copy(t,e,r,n){if(!Buffer.isBuffer(t))throw new TypeError("argument should be a Buffer");if(r||(r=0),n||0===n||(n=this.length),e>=t.length&&(e=t.length),e||(e=0),n>0&&n<r&&(n=r),n===r)return 0;if(0===t.length||0===this.length)return 0;if(e<0)throw new RangeError("targetStart out of bounds");if(r<0||r>=this.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("sourceEnd out of bounds");n>this.length&&(n=this.length),t.length-e<n-r&&(n=t.length-e+r);const o=n-r;return this===t&&"function"==typeof Uint8Array.prototype.copyWithin?this.copyWithin(e,r,n):Uint8Array.prototype.set.call(t,this.subarray(r,n),e),o},Buffer.prototype.fill=function fill(t,e,r,n){if("string"==typeof t){if("string"==typeof e?(n=e,e=0,r=this.length):"string"==typeof r&&(n=r,r=this.length),void 0!==n&&"string"!=typeof n)throw new TypeError("encoding must be a string");if("string"==typeof n&&!Buffer.isEncoding(n))throw new TypeError("Unknown encoding: "+n);if(1===t.length){const e=t.charCodeAt(0);("utf8"===n&&e<128||"latin1"===n)&&(t=e)}}else"number"==typeof t?t&=255:"boolean"==typeof t&&(t=Number(t));if(e<0||this.length<e||this.length<r)throw new RangeError("Out of range index");if(r<=e)return this;let o;if(e>>>=0,r=void 0===r?this.length:r>>>0,t||(t=0),"number"==typeof t)for(o=e;o<r;++o)this[o]=t;else{const i=Buffer.isBuffer(t)?t:Buffer.from(t,n),a=i.length;if(0===a)throw new TypeError('The value "'+t+'" is invalid for argument "value"');for(o=0;o<r-e;++o)this[o+e]=i[o%a]}return this};const u={};function E(t,e,r){u[t]=class NodeError extends r{constructor(){super(),Object.defineProperty(this,"message",{value:e.apply(this,arguments),writable:!0,configurable:!0}),this.name=`${this.name} [${t}]`,this.stack,delete this.name}get code(){return t}set code(t){Object.defineProperty(this,"code",{configurable:!0,enumerable:!0,value:t,writable:!0})}toString(){return`${this.name} [${t}]: ${this.message}`}}}function addNumericalSeparator(t){let e="",r=t.length;const n="-"===t[0]?1:0;for(;r>=n+4;r-=3)e=`_${t.slice(r-3,r)}${e}`;return`${t.slice(0,r)}${e}`}function checkIntBI(t,e,r,n,o,i){if(t>r||t<e){const n="bigint"==typeof e?"n":"";let o;throw o=i>3?0===e||e===BigInt(0)?`>= 0${n} and < 2${n} ** ${8*(i+1)}${n}`:`>= -(2${n} ** ${8*(i+1)-1}${n}) and < 2 ** ${8*(i+1)-1}${n}`:`>= ${e}${n} and <= ${r}${n}`,new u.ERR_OUT_OF_RANGE("value",o,t)}!function checkBounds(t,e,r){validateNumber(e,"offset"),void 0!==t[e]&&void 0!==t[e+r]||boundsError(e,t.length-(r+1))}(n,o,i)}function validateNumber(t,e){if("number"!=typeof t)throw new u.ERR_INVALID_ARG_TYPE(e,"number",t)}function boundsError(t,e,r){if(Math.floor(t)!==t)throw validateNumber(t,r),new u.ERR_OUT_OF_RANGE(r||"offset","an integer",t);if(e<0)throw new u.ERR_BUFFER_OUT_OF_BOUNDS;throw new u.ERR_OUT_OF_RANGE(r||"offset",`>= ${r?1:0} and <= ${e}`,t)}E("ERR_BUFFER_OUT_OF_BOUNDS",(function(t){return t?`${t} is outside of buffer bounds`:"Attempt to access memory outside buffer bounds"}),RangeError),E("ERR_INVALID_ARG_TYPE",(function(t,e){return`The "${t}" argument must be of type number. Received type ${typeof e}`}),TypeError),E("ERR_OUT_OF_RANGE",(function(t,e,r){let n=`The value of "${t}" is out of range.`,o=r;return Number.isInteger(r)&&Math.abs(r)>2**32?o=addNumericalSeparator(String(r)):"bigint"==typeof r&&(o=String(r),(r>BigInt(2)**BigInt(32)||r<-(BigInt(2)**BigInt(32)))&&(o=addNumericalSeparator(o)),o+="n"),n+=` It must be ${e}. Received ${o}`,n}),RangeError);const c=/[^+/0-9A-Za-z-_]/g;function utf8ToBytes(t,e){let r;e=e||1/0;const n=t.length;let o=null;const i=[];for(let a=0;a<n;++a){if(r=t.charCodeAt(a),r>55295&&r<57344){if(!o){if(r>56319){(e-=3)>-1&&i.push(239,191,189);continue}if(a+1===n){(e-=3)>-1&&i.push(239,191,189);continue}o=r;continue}if(r<56320){(e-=3)>-1&&i.push(239,191,189),o=r;continue}r=65536+(o-55296<<10|r-56320)}else o&&(e-=3)>-1&&i.push(239,191,189);if(o=null,r<128){if((e-=1)<0)break;i.push(r)}else if(r<2048){if((e-=2)<0)break;i.push(r>>6|192,63&r|128)}else if(r<65536){if((e-=3)<0)break;i.push(r>>12|224,r>>6&63|128,63&r|128)}else{if(!(r<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;i.push(r>>18|240,r>>12&63|128,r>>6&63|128,63&r|128)}}return i}function base64ToBytes(t){return n.toByteArray(function base64clean(t){if((t=(t=t.split("=")[0]).trim().replace(c,"")).length<2)return"";for(;t.length%4!=0;)t+="=";return t}(t))}function blitBuffer(t,e,r,n){let o;for(o=0;o<n&&!(o+r>=e.length||o>=t.length);++o)e[o+r]=t[o];return o}function isInstance(t,e){return t instanceof e||null!=t&&null!=t.constructor&&null!=t.constructor.name&&t.constructor.name===e.name}function numberIsNaN(t){return t!=t}const f=function(){const t="0123456789abcdef",e=new Array(256);for(let r=0;r<16;++r){const n=16*r;for(let o=0;o<16;++o)e[n+o]=t[r]+t[o]}return e}();function defineBigIntMethod(t){return"undefined"==typeof BigInt?BufferBigIntNotDefined:t}function BufferBigIntNotDefined(){throw new Error("BigInt not supported")}},3144(t,e,r){"use strict";var n=r(6743),o=r(1002),i=r(76),a=r(7119);t.exports=a||n.call(i,o)},4586(t,e,r){"use strict";var n=r(6743),o=r(1002),i=r(3144);t.exports=function applyBind(){return i(n,o,arguments)}},1002(t){"use strict";t.exports=Function.prototype.apply},76(t){"use strict";t.exports=Function.prototype.call},3126(t,e,r){"use strict";var n=r(6743),o=r(9675),i=r(76),a=r(3144);t.exports=function callBindBasic(t){if(t.length<1||"function"!=typeof t[0])throw new o("a function is required");return a(n,i,t)}},7119(t){"use strict";t.exports="undefined"!=typeof Reflect&&Reflect&&Reflect.apply},487(t,e,r){"use strict";var n=r(6897),o=r(655),i=r(3126),a=r(4586);t.exports=function callBind(t){var e=i(arguments),r=t.length-(arguments.length-1);return n(e,1+(r>0?r:0),!0)},o?o(t.exports,"apply",{value:a}):t.exports.apply=a},6556(t,e,r){"use strict";var n=r(453),o=r(3126),i=o([n("%String.prototype.indexOf%")]);t.exports=function callBoundIntrinsic(t,e){var r=n(t,!!e);return"function"==typeof r&&i(t,".prototype.")>-1?o([r]):r}},2205(t,e,r){var n;n=void 0!==r.g?r.g:this,t.exports=function(t){if(t.CSS&&t.CSS.escape)return t.CSS.escape;var cssEscape=function(t){if(0==arguments.length)throw new TypeError("`CSS.escape` requires an argument.");for(var e,r=String(t),n=r.length,o=-1,i="",a=r.charCodeAt(0);++o<n;)0!=(e=r.charCodeAt(o))?i+=e>=1&&e<=31||127==e||0==o&&e>=48&&e<=57||1==o&&e>=48&&e<=57&&45==a?"\\"+e.toString(16)+" ":0==o&&1==n&&45==e||!(e>=128||45==e||95==e||e>=48&&e<=57||e>=65&&e<=90||e>=97&&e<=122)?"\\"+r.charAt(o):r.charAt(o):i+="�";return i};return t.CSS||(t.CSS={}),t.CSS.escape=cssEscape,cssEscape}(n)},41(t,e,r){"use strict";var n=r(655),o=r(8068),i=r(9675),a=r(5795);t.exports=function defineDataProperty(t,e,r){if(!t||"object"!=typeof t&&"function"!=typeof t)throw new i("`obj` must be an object or a function`");if("string"!=typeof e&&"symbol"!=typeof e)throw new i("`property` must be a string or a symbol`");if(arguments.length>3&&"boolean"!=typeof arguments[3]&&null!==arguments[3])throw new i("`nonEnumerable`, if provided, must be a boolean or null");if(arguments.length>4&&"boolean"!=typeof arguments[4]&&null!==arguments[4])throw new i("`nonWritable`, if provided, must be a boolean or null");if(arguments.length>5&&"boolean"!=typeof arguments[5]&&null!==arguments[5])throw new i("`nonConfigurable`, if provided, must be a boolean or null");if(arguments.length>6&&"boolean"!=typeof arguments[6])throw new i("`loose`, if provided, must be a boolean");var s=arguments.length>3?arguments[3]:null,u=arguments.length>4?arguments[4]:null,c=arguments.length>5?arguments[5]:null,f=arguments.length>6&&arguments[6],l=!!a&&a(t,e);if(n)n(t,e,{configurable:null===c&&l?l.configurable:!c,enumerable:null===s&&l?l.enumerable:!s,value:r,writable:null===u&&l?l.writable:!u});else{if(!f&&(s||u||c))throw new o("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");t[e]=r}}},7176(t,e,r){"use strict";var n,o=r(3126),i=r(5795);try{n=[].__proto__===Array.prototype}catch(t){if(!t||"object"!=typeof t||!("code"in t)||"ERR_PROTO_ACCESS"!==t.code)throw t}var a=!!n&&i&&i(Object.prototype,"__proto__"),s=Object,u=s.getPrototypeOf;t.exports=a&&"function"==typeof a.get?o([a.get]):"function"==typeof u&&function getDunder(t){return u(null==t?t:s(t))}},655(t){"use strict";var e=Object.defineProperty||!1;if(e)try{e({},"a",{value:1})}catch(t){e=!1}t.exports=e},1237(t){"use strict";t.exports=EvalError},9383(t){"use strict";t.exports=Error},9290(t){"use strict";t.exports=RangeError},9538(t){"use strict";t.exports=ReferenceError},8068(t){"use strict";t.exports=SyntaxError},9675(t){"use strict";t.exports=TypeError},5345(t){"use strict";t.exports=URIError},9612(t){"use strict";t.exports=Object},2682(t,e,r){"use strict";var n=r(9600),o=Object.prototype.toString,i=Object.prototype.hasOwnProperty;t.exports=function forEach(t,e,r){if(!n(e))throw new TypeError("iterator must be a function");var a;arguments.length>=3&&(a=r),function isArray(t){return"[object Array]"===o.call(t)}(t)?function forEachArray(t,e,r){for(var n=0,o=t.length;n<o;n++)i.call(t,n)&&(null==r?e(t[n],n,t):e.call(r,t[n],n,t))}(t,e,a):"string"==typeof t?function forEachString(t,e,r){for(var n=0,o=t.length;n<o;n++)null==r?e(t.charAt(n),n,t):e.call(r,t.charAt(n),n,t)}(t,e,a):function forEachObject(t,e,r){for(var n in t)i.call(t,n)&&(null==r?e(t[n],n,t):e.call(r,t[n],n,t))}(t,e,a)}},9353(t){"use strict";var e=Object.prototype.toString,r=Math.max,n=function concatty(t,e){for(var r=[],n=0;n<t.length;n+=1)r[n]=t[n];for(var o=0;o<e.length;o+=1)r[o+t.length]=e[o];return r};t.exports=function bind(t){var o=this;if("function"!=typeof o||"[object Function]"!==e.apply(o))throw new TypeError("Function.prototype.bind called on incompatible "+o);for(var i,a=function slicy(t,e){for(var r=[],n=e||0,o=0;n<t.length;n+=1,o+=1)r[o]=t[n];return r}(arguments,1),s=r(0,o.length-a.length),u=[],c=0;c<s;c++)u[c]="$"+c;if(i=Function("binder","return function ("+function(t,e){for(var r="",n=0;n<t.length;n+=1)r+=t[n],n+1<t.length&&(r+=e);return r}(u,",")+"){ return binder.apply(this,arguments); }")((function(){if(this instanceof i){var e=o.apply(this,n(a,arguments));return Object(e)===e?e:this}return o.apply(t,n(a,arguments))})),o.prototype){var f=function Empty(){};f.prototype=o.prototype,i.prototype=new f,f.prototype=null}return i}},6743(t,e,r){"use strict";var n=r(9353);t.exports=Function.prototype.bind||n},453(t,e,r){"use strict";var n,o=r(9612),i=r(9383),a=r(1237),s=r(9290),u=r(9538),c=r(8068),f=r(9675),l=r(5345),p=r(1514),h=r(8968),d=r(6188),y=r(8002),_=r(5880),g=r(414),m=r(3093),v=Function,getEvalledConstructor=function(t){try{return v('"use strict"; return ('+t+").constructor;")()}catch(t){}},b=r(5795),w=r(655),throwTypeError=function(){throw new f},I=b?function(){try{return throwTypeError}catch(t){try{return b(arguments,"callee").get}catch(t){return throwTypeError}}}():throwTypeError,x=r(4039)(),B=r(3628),k=r(1064),C=r(8648),j=r(1002),q=r(76),L={},P="undefined"!=typeof Uint8Array&&B?B(Uint8Array):n,U={__proto__:null,"%AggregateError%":"undefined"==typeof AggregateError?n:AggregateError,"%Array%":Array,"%ArrayBuffer%":"undefined"==typeof ArrayBuffer?n:ArrayBuffer,"%ArrayIteratorPrototype%":x&&B?B([][Symbol.iterator]()):n,"%AsyncFromSyncIteratorPrototype%":n,"%AsyncFunction%":L,"%AsyncGenerator%":L,"%AsyncGeneratorFunction%":L,"%AsyncIteratorPrototype%":L,"%Atomics%":"undefined"==typeof Atomics?n:Atomics,"%BigInt%":"undefined"==typeof BigInt?n:BigInt,"%BigInt64Array%":"undefined"==typeof BigInt64Array?n:BigInt64Array,"%BigUint64Array%":"undefined"==typeof BigUint64Array?n:BigUint64Array,"%Boolean%":Boolean,"%DataView%":"undefined"==typeof DataView?n:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":i,"%eval%":eval,"%EvalError%":a,"%Float32Array%":"undefined"==typeof Float32Array?n:Float32Array,"%Float64Array%":"undefined"==typeof Float64Array?n:Float64Array,"%FinalizationRegistry%":"undefined"==typeof FinalizationRegistry?n:FinalizationRegistry,"%Function%":v,"%GeneratorFunction%":L,"%Int8Array%":"undefined"==typeof Int8Array?n:Int8Array,"%Int16Array%":"undefined"==typeof Int16Array?n:Int16Array,"%Int32Array%":"undefined"==typeof Int32Array?n:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":x&&B?B(B([][Symbol.iterator]())):n,"%JSON%":"object"==typeof JSON?JSON:n,"%Map%":"undefined"==typeof Map?n:Map,"%MapIteratorPrototype%":"undefined"!=typeof Map&&x&&B?B((new Map)[Symbol.iterator]()):n,"%Math%":Math,"%Number%":Number,"%Object%":o,"%Object.getOwnPropertyDescriptor%":b,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":"undefined"==typeof Promise?n:Promise,"%Proxy%":"undefined"==typeof Proxy?n:Proxy,"%RangeError%":s,"%ReferenceError%":u,"%Reflect%":"undefined"==typeof Reflect?n:Reflect,"%RegExp%":RegExp,"%Set%":"undefined"==typeof Set?n:Set,"%SetIteratorPrototype%":"undefined"!=typeof Set&&x&&B?B((new Set)[Symbol.iterator]()):n,"%SharedArrayBuffer%":"undefined"==typeof SharedArrayBuffer?n:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":x&&B?B(""[Symbol.iterator]()):n,"%Symbol%":x?Symbol:n,"%SyntaxError%":c,"%ThrowTypeError%":I,"%TypedArray%":P,"%TypeError%":f,"%Uint8Array%":"undefined"==typeof Uint8Array?n:Uint8Array,"%Uint8ClampedArray%":"undefined"==typeof Uint8ClampedArray?n:Uint8ClampedArray,"%Uint16Array%":"undefined"==typeof Uint16Array?n:Uint16Array,"%Uint32Array%":"undefined"==typeof Uint32Array?n:Uint32Array,"%URIError%":l,"%WeakMap%":"undefined"==typeof WeakMap?n:WeakMap,"%WeakRef%":"undefined"==typeof WeakRef?n:WeakRef,"%WeakSet%":"undefined"==typeof WeakSet?n:WeakSet,"%Function.prototype.call%":q,"%Function.prototype.apply%":j,"%Object.defineProperty%":w,"%Object.getPrototypeOf%":k,"%Math.abs%":p,"%Math.floor%":h,"%Math.max%":d,"%Math.min%":y,"%Math.pow%":_,"%Math.round%":g,"%Math.sign%":m,"%Reflect.getPrototypeOf%":C};if(B)try{null.error}catch(t){var D=B(B(t));U["%Error.prototype%"]=D}var z=function doEval(t){var e;if("%AsyncFunction%"===t)e=getEvalledConstructor("async function () {}");else if("%GeneratorFunction%"===t)e=getEvalledConstructor("function* () {}");else if("%AsyncGeneratorFunction%"===t)e=getEvalledConstructor("async function* () {}");else if("%AsyncGenerator%"===t){var r=doEval("%AsyncGeneratorFunction%");r&&(e=r.prototype)}else if("%AsyncIteratorPrototype%"===t){var n=doEval("%AsyncGenerator%");n&&B&&(e=B(n.prototype))}return U[t]=e,e},W={__proto__:null,"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]},V=r(6743),K=r(9957),$=V.call(q,Array.prototype.concat),H=V.call(j,Array.prototype.splice),Y=V.call(q,String.prototype.replace),Z=V.call(q,String.prototype.slice),J=V.call(q,RegExp.prototype.exec),tt=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,et=/\\(\\)?/g,rt=function getBaseIntrinsic(t,e){var r,n=t;if(K(W,n)&&(n="%"+(r=W[n])[0]+"%"),K(U,n)){var o=U[n];if(o===L&&(o=z(n)),void 0===o&&!e)throw new f("intrinsic "+t+" exists, but is not available. Please file an issue!");return{alias:r,name:n,value:o}}throw new c("intrinsic "+t+" does not exist!")};t.exports=function GetIntrinsic(t,e){if("string"!=typeof t||0===t.length)throw new f("intrinsic name must be a non-empty string");if(arguments.length>1&&"boolean"!=typeof e)throw new f('"allowMissing" argument must be a boolean');if(null===J(/^%?[^%]*%?$/,t))throw new c("`%` may not be present anywhere but at the beginning and end of the intrinsic name");var r=function stringToPath(t){var e=Z(t,0,1),r=Z(t,-1);if("%"===e&&"%"!==r)throw new c("invalid intrinsic syntax, expected closing `%`");if("%"===r&&"%"!==e)throw new c("invalid intrinsic syntax, expected opening `%`");var n=[];return Y(t,tt,(function(t,e,r,o){n[n.length]=r?Y(o,et,"$1"):e||t})),n}(t),n=r.length>0?r[0]:"",o=rt("%"+n+"%",e),i=o.name,a=o.value,s=!1,u=o.alias;u&&(n=u[0],H(r,$([0,1],u)));for(var l=1,p=!0;l<r.length;l+=1){var h=r[l],d=Z(h,0,1),y=Z(h,-1);if(('"'===d||"'"===d||"`"===d||'"'===y||"'"===y||"`"===y)&&d!==y)throw new c("property names with quotes must have matching quotes");if("constructor"!==h&&p||(s=!0),K(U,i="%"+(n+="."+h)+"%"))a=U[i];else if(null!=a){if(!(h in a)){if(!e)throw new f("base intrinsic for "+t+" exists, but the property is not available.");return}if(b&&l+1>=r.length){var _=b(a,h);a=(p=!!_)&&"get"in _&&!("originalValue"in _.get)?_.get:a[h]}else p=K(a,h),a=a[h];p&&!s&&(U[i]=a)}}return a}},1064(t,e,r){"use strict";var n=r(9612);t.exports=n.getPrototypeOf||null},8648(t){"use strict";t.exports="undefined"!=typeof Reflect&&Reflect.getPrototypeOf||null},3628(t,e,r){"use strict";var n=r(8648),o=r(1064),i=r(7176);t.exports=n?function getProto(t){return n(t)}:o?function getProto(t){if(!t||"object"!=typeof t&&"function"!=typeof t)throw new TypeError("getProto: not an object");return o(t)}:i?function getProto(t){return i(t)}:null},6549(t){"use strict";t.exports=Object.getOwnPropertyDescriptor},5795(t,e,r){"use strict";var n=r(6549);if(n)try{n([],"length")}catch(t){n=null}t.exports=n},592(t,e,r){"use strict";var n=r(655),o=function hasPropertyDescriptors(){return!!n};o.hasArrayLengthDefineBug=function hasArrayLengthDefineBug(){if(!n)return null;try{return 1!==n([],"length",{value:1}).length}catch(t){return!0}},t.exports=o},4039(t,e,r){"use strict";var n="undefined"!=typeof Symbol&&Symbol,o=r(1333);t.exports=function hasNativeSymbols(){return"function"==typeof n&&("function"==typeof Symbol&&("symbol"==typeof n("foo")&&("symbol"==typeof Symbol("bar")&&o())))}},1333(t){"use strict";t.exports=function hasSymbols(){if("function"!=typeof Symbol||"function"!=typeof Object.getOwnPropertySymbols)return!1;if("symbol"==typeof Symbol.iterator)return!0;var t={},e=Symbol("test"),r=Object(e);if("string"==typeof e)return!1;if("[object Symbol]"!==Object.prototype.toString.call(e))return!1;if("[object Symbol]"!==Object.prototype.toString.call(r))return!1;for(var n in t[e]=42,t)return!1;if("function"==typeof Object.keys&&0!==Object.keys(t).length)return!1;if("function"==typeof Object.getOwnPropertyNames&&0!==Object.getOwnPropertyNames(t).length)return!1;var o=Object.getOwnPropertySymbols(t);if(1!==o.length||o[0]!==e)return!1;if(!Object.prototype.propertyIsEnumerable.call(t,e))return!1;if("function"==typeof Object.getOwnPropertyDescriptor){var i=Object.getOwnPropertyDescriptor(t,e);if(42!==i.value||!0!==i.enumerable)return!1}return!0}},9092(t,e,r){"use strict";var n=r(1333);t.exports=function hasToStringTagShams(){return n()&&!!Symbol.toStringTag}},9957(t,e,r){"use strict";var n=Function.prototype.call,o=Object.prototype.hasOwnProperty,i=r(6743);t.exports=i.call(n,o)},251(t,e){e.read=function(t,e,r,n,o){var i,a,s=8*o-n-1,u=(1<<s)-1,c=u>>1,f=-7,l=r?o-1:0,p=r?-1:1,h=t[e+l];for(l+=p,i=h&(1<<-f)-1,h>>=-f,f+=s;f>0;i=256*i+t[e+l],l+=p,f-=8);for(a=i&(1<<-f)-1,i>>=-f,f+=n;f>0;a=256*a+t[e+l],l+=p,f-=8);if(0===i)i=1-c;else{if(i===u)return a?NaN:1/0*(h?-1:1);a+=Math.pow(2,n),i-=c}return(h?-1:1)*a*Math.pow(2,i-n)},e.write=function(t,e,r,n,o,i){var a,s,u,c=8*i-o-1,f=(1<<c)-1,l=f>>1,p=23===o?Math.pow(2,-24)-Math.pow(2,-77):0,h=n?0:i-1,d=n?1:-1,y=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(s=isNaN(e)?1:0,a=f):(a=Math.floor(Math.log(e)/Math.LN2),e*(u=Math.pow(2,-a))<1&&(a--,u*=2),(e+=a+l>=1?p/u:p*Math.pow(2,1-l))*u>=2&&(a++,u/=2),a+l>=f?(s=0,a=f):a+l>=1?(s=(e*u-1)*Math.pow(2,o),a+=l):(s=e*Math.pow(2,l-1)*Math.pow(2,o),a=0));o>=8;t[r+h]=255&s,h+=d,s/=256,o-=8);for(a=a<<o|s,c+=o;c>0;t[r+h]=255&a,h+=d,a/=256,c-=8);t[r+h-d]|=128*y}},9404(t){t.exports=function(){"use strict";var t=Array.prototype.slice;function createClass(t,e){e&&(t.prototype=Object.create(e.prototype)),t.prototype.constructor=t}function Iterable(t){return isIterable(t)?t:Seq(t)}function KeyedIterable(t){return isKeyed(t)?t:KeyedSeq(t)}function IndexedIterable(t){return isIndexed(t)?t:IndexedSeq(t)}function SetIterable(t){return isIterable(t)&&!isAssociative(t)?t:SetSeq(t)}function isIterable(t){return!(!t||!t[e])}function isKeyed(t){return!(!t||!t[r])}function isIndexed(t){return!(!t||!t[n])}function isAssociative(t){return isKeyed(t)||isIndexed(t)}function isOrdered(t){return!(!t||!t[o])}createClass(KeyedIterable,Iterable),createClass(IndexedIterable,Iterable),createClass(SetIterable,Iterable),Iterable.isIterable=isIterable,Iterable.isKeyed=isKeyed,Iterable.isIndexed=isIndexed,Iterable.isAssociative=isAssociative,Iterable.isOrdered=isOrdered,Iterable.Keyed=KeyedIterable,Iterable.Indexed=IndexedIterable,Iterable.Set=SetIterable;var e="@@__IMMUTABLE_ITERABLE__@@",r="@@__IMMUTABLE_KEYED__@@",n="@@__IMMUTABLE_INDEXED__@@",o="@@__IMMUTABLE_ORDERED__@@",i="delete",a=5,s=1<<a,u=s-1,c={},f={value:!1},l={value:!1};function MakeRef(t){return t.value=!1,t}function SetRef(t){t&&(t.value=!0)}function OwnerID(){}function arrCopy(t,e){e=e||0;for(var r=Math.max(0,t.length-e),n=new Array(r),o=0;o<r;o++)n[o]=t[o+e];return n}function ensureSize(t){return void 0===t.size&&(t.size=t.__iterate(returnTrue)),t.size}function wrapIndex(t,e){if("number"!=typeof e){var r=e>>>0;if(""+r!==e||4294967295===r)return NaN;e=r}return e<0?ensureSize(t)+e:e}function returnTrue(){return!0}function wholeSlice(t,e,r){return(0===t||void 0!==r&&t<=-r)&&(void 0===e||void 0!==r&&e>=r)}function resolveBegin(t,e){return resolveIndex(t,e,0)}function resolveEnd(t,e){return resolveIndex(t,e,e)}function resolveIndex(t,e,r){return void 0===t?r:t<0?Math.max(0,e+t):void 0===e?t:Math.min(e,t)}var p=0,h=1,d=2,y="function"==typeof Symbol&&Symbol.iterator,_="@@iterator",g=y||_;function Iterator(t){this.next=t}function iteratorValue(t,e,r,n){var o=0===t?e:1===t?r:[e,r];return n?n.value=o:n={value:o,done:!1},n}function iteratorDone(){return{value:void 0,done:!0}}function hasIterator(t){return!!getIteratorFn(t)}function isIterator(t){return t&&"function"==typeof t.next}function getIterator(t){var e=getIteratorFn(t);return e&&e.call(t)}function getIteratorFn(t){var e=t&&(y&&t[y]||t[_]);if("function"==typeof e)return e}function isArrayLike(t){return t&&"number"==typeof t.length}function Seq(t){return null==t?emptySequence():isIterable(t)?t.toSeq():seqFromValue(t)}function KeyedSeq(t){return null==t?emptySequence().toKeyedSeq():isIterable(t)?isKeyed(t)?t.toSeq():t.fromEntrySeq():keyedSeqFromValue(t)}function IndexedSeq(t){return null==t?emptySequence():isIterable(t)?isKeyed(t)?t.entrySeq():t.toIndexedSeq():indexedSeqFromValue(t)}function SetSeq(t){return(null==t?emptySequence():isIterable(t)?isKeyed(t)?t.entrySeq():t:indexedSeqFromValue(t)).toSetSeq()}Iterator.prototype.toString=function(){return"[Iterator]"},Iterator.KEYS=p,Iterator.VALUES=h,Iterator.ENTRIES=d,Iterator.prototype.inspect=Iterator.prototype.toSource=function(){return this.toString()},Iterator.prototype[g]=function(){return this},createClass(Seq,Iterable),Seq.of=function(){return Seq(arguments)},Seq.prototype.toSeq=function(){return this},Seq.prototype.toString=function(){return this.__toString("Seq {","}")},Seq.prototype.cacheResult=function(){return!this._cache&&this.__iterateUncached&&(this._cache=this.entrySeq().toArray(),this.size=this._cache.length),this},Seq.prototype.__iterate=function(t,e){return seqIterate(this,t,e,!0)},Seq.prototype.__iterator=function(t,e){return seqIterator(this,t,e,!0)},createClass(KeyedSeq,Seq),KeyedSeq.prototype.toKeyedSeq=function(){return this},createClass(IndexedSeq,Seq),IndexedSeq.of=function(){return IndexedSeq(arguments)},IndexedSeq.prototype.toIndexedSeq=function(){return this},IndexedSeq.prototype.toString=function(){return this.__toString("Seq [","]")},IndexedSeq.prototype.__iterate=function(t,e){return seqIterate(this,t,e,!1)},IndexedSeq.prototype.__iterator=function(t,e){return seqIterator(this,t,e,!1)},createClass(SetSeq,Seq),SetSeq.of=function(){return SetSeq(arguments)},SetSeq.prototype.toSetSeq=function(){return this},Seq.isSeq=isSeq,Seq.Keyed=KeyedSeq,Seq.Set=SetSeq,Seq.Indexed=IndexedSeq;var m,v,b,w="@@__IMMUTABLE_SEQ__@@";function ArraySeq(t){this._array=t,this.size=t.length}function ObjectSeq(t){var e=Object.keys(t);this._object=t,this._keys=e,this.size=e.length}function IterableSeq(t){this._iterable=t,this.size=t.length||t.size}function IteratorSeq(t){this._iterator=t,this._iteratorCache=[]}function isSeq(t){return!(!t||!t[w])}function emptySequence(){return m||(m=new ArraySeq([]))}function keyedSeqFromValue(t){var e=Array.isArray(t)?new ArraySeq(t).fromEntrySeq():isIterator(t)?new IteratorSeq(t).fromEntrySeq():hasIterator(t)?new IterableSeq(t).fromEntrySeq():"object"==typeof t?new ObjectSeq(t):void 0;if(!e)throw new TypeError("Expected Array or iterable object of [k, v] entries, or keyed object: "+t);return e}function indexedSeqFromValue(t){var e=maybeIndexedSeqFromValue(t);if(!e)throw new TypeError("Expected Array or iterable object of values: "+t);return e}function seqFromValue(t){var e=maybeIndexedSeqFromValue(t)||"object"==typeof t&&new ObjectSeq(t);if(!e)throw new TypeError("Expected Array or iterable object of values, or keyed object: "+t);return e}function maybeIndexedSeqFromValue(t){return isArrayLike(t)?new ArraySeq(t):isIterator(t)?new IteratorSeq(t):hasIterator(t)?new IterableSeq(t):void 0}function seqIterate(t,e,r,n){var o=t._cache;if(o){for(var i=o.length-1,a=0;a<=i;a++){var s=o[r?i-a:a];if(!1===e(s[1],n?s[0]:a,t))return a+1}return a}return t.__iterateUncached(e,r)}function seqIterator(t,e,r,n){var o=t._cache;if(o){var i=o.length-1,a=0;return new Iterator((function(){var t=o[r?i-a:a];return a++>i?iteratorDone():iteratorValue(e,n?t[0]:a-1,t[1])}))}return t.__iteratorUncached(e,r)}function fromJS(t,e){return e?fromJSWith(e,t,"",{"":t}):fromJSDefault(t)}function fromJSWith(t,e,r,n){return Array.isArray(e)?t.call(n,r,IndexedSeq(e).map((function(r,n){return fromJSWith(t,r,n,e)}))):isPlainObj(e)?t.call(n,r,KeyedSeq(e).map((function(r,n){return fromJSWith(t,r,n,e)}))):e}function fromJSDefault(t){return Array.isArray(t)?IndexedSeq(t).map(fromJSDefault).toList():isPlainObj(t)?KeyedSeq(t).map(fromJSDefault).toMap():t}function isPlainObj(t){return t&&(t.constructor===Object||void 0===t.constructor)}function is(t,e){if(t===e||t!=t&&e!=e)return!0;if(!t||!e)return!1;if("function"==typeof t.valueOf&&"function"==typeof e.valueOf){if((t=t.valueOf())===(e=e.valueOf())||t!=t&&e!=e)return!0;if(!t||!e)return!1}return!("function"!=typeof t.equals||"function"!=typeof e.equals||!t.equals(e))}function deepEqual(t,e){if(t===e)return!0;if(!isIterable(e)||void 0!==t.size&&void 0!==e.size&&t.size!==e.size||void 0!==t.__hash&&void 0!==e.__hash&&t.__hash!==e.__hash||isKeyed(t)!==isKeyed(e)||isIndexed(t)!==isIndexed(e)||isOrdered(t)!==isOrdered(e))return!1;if(0===t.size&&0===e.size)return!0;var r=!isAssociative(t);if(isOrdered(t)){var n=t.entries();return e.every((function(t,e){var o=n.next().value;return o&&is(o[1],t)&&(r||is(o[0],e))}))&&n.next().done}var o=!1;if(void 0===t.size)if(void 0===e.size)"function"==typeof t.cacheResult&&t.cacheResult();else{o=!0;var i=t;t=e,e=i}var a=!0,s=e.__iterate((function(e,n){if(r?!t.has(e):o?!is(e,t.get(n,c)):!is(t.get(n,c),e))return a=!1,!1}));return a&&t.size===s}function Repeat(t,e){if(!(this instanceof Repeat))return new Repeat(t,e);if(this._value=t,this.size=void 0===e?1/0:Math.max(0,e),0===this.size){if(v)return v;v=this}}function invariant(t,e){if(!t)throw new Error(e)}function Range(t,e,r){if(!(this instanceof Range))return new Range(t,e,r);if(invariant(0!==r,"Cannot step a Range by 0"),t=t||0,void 0===e&&(e=1/0),r=void 0===r?1:Math.abs(r),e<t&&(r=-r),this._start=t,this._end=e,this._step=r,this.size=Math.max(0,Math.ceil((e-t)/r-1)+1),0===this.size){if(b)return b;b=this}}function Collection(){throw TypeError("Abstract")}function KeyedCollection(){}function IndexedCollection(){}function SetCollection(){}Seq.prototype[w]=!0,createClass(ArraySeq,IndexedSeq),ArraySeq.prototype.get=function(t,e){return this.has(t)?this._array[wrapIndex(this,t)]:e},ArraySeq.prototype.__iterate=function(t,e){for(var r=this._array,n=r.length-1,o=0;o<=n;o++)if(!1===t(r[e?n-o:o],o,this))return o+1;return o},ArraySeq.prototype.__iterator=function(t,e){var r=this._array,n=r.length-1,o=0;return new Iterator((function(){return o>n?iteratorDone():iteratorValue(t,o,r[e?n-o++:o++])}))},createClass(ObjectSeq,KeyedSeq),ObjectSeq.prototype.get=function(t,e){return void 0===e||this.has(t)?this._object[t]:e},ObjectSeq.prototype.has=function(t){return this._object.hasOwnProperty(t)},ObjectSeq.prototype.__iterate=function(t,e){for(var r=this._object,n=this._keys,o=n.length-1,i=0;i<=o;i++){var a=n[e?o-i:i];if(!1===t(r[a],a,this))return i+1}return i},ObjectSeq.prototype.__iterator=function(t,e){var r=this._object,n=this._keys,o=n.length-1,i=0;return new Iterator((function(){var a=n[e?o-i:i];return i++>o?iteratorDone():iteratorValue(t,a,r[a])}))},ObjectSeq.prototype[o]=!0,createClass(IterableSeq,IndexedSeq),IterableSeq.prototype.__iterateUncached=function(t,e){if(e)return this.cacheResult().__iterate(t,e);var r=getIterator(this._iterable),n=0;if(isIterator(r))for(var o;!(o=r.next()).done&&!1!==t(o.value,n++,this););return n},IterableSeq.prototype.__iteratorUncached=function(t,e){if(e)return this.cacheResult().__iterator(t,e);var r=getIterator(this._iterable);if(!isIterator(r))return new Iterator(iteratorDone);var n=0;return new Iterator((function(){var e=r.next();return e.done?e:iteratorValue(t,n++,e.value)}))},createClass(IteratorSeq,IndexedSeq),IteratorSeq.prototype.__iterateUncached=function(t,e){if(e)return this.cacheResult().__iterate(t,e);for(var r,n=this._iterator,o=this._iteratorCache,i=0;i<o.length;)if(!1===t(o[i],i++,this))return i;for(;!(r=n.next()).done;){var a=r.value;if(o[i]=a,!1===t(a,i++,this))break}return i},IteratorSeq.prototype.__iteratorUncached=function(t,e){if(e)return this.cacheResult().__iterator(t,e);var r=this._iterator,n=this._iteratorCache,o=0;return new Iterator((function(){if(o>=n.length){var e=r.next();if(e.done)return e;n[o]=e.value}return iteratorValue(t,o,n[o++])}))},createClass(Repeat,IndexedSeq),Repeat.prototype.toString=function(){return 0===this.size?"Repeat []":"Repeat [ "+this._value+" "+this.size+" times ]"},Repeat.prototype.get=function(t,e){return this.has(t)?this._value:e},Repeat.prototype.includes=function(t){return is(this._value,t)},Repeat.prototype.slice=function(t,e){var r=this.size;return wholeSlice(t,e,r)?this:new Repeat(this._value,resolveEnd(e,r)-resolveBegin(t,r))},Repeat.prototype.reverse=function(){return this},Repeat.prototype.indexOf=function(t){return is(this._value,t)?0:-1},Repeat.prototype.lastIndexOf=function(t){return is(this._value,t)?this.size:-1},Repeat.prototype.__iterate=function(t,e){for(var r=0;r<this.size;r++)if(!1===t(this._value,r,this))return r+1;return r},Repeat.prototype.__iterator=function(t,e){var r=this,n=0;return new Iterator((function(){return n<r.size?iteratorValue(t,n++,r._value):iteratorDone()}))},Repeat.prototype.equals=function(t){return t instanceof Repeat?is(this._value,t._value):deepEqual(t)},createClass(Range,IndexedSeq),Range.prototype.toString=function(){return 0===this.size?"Range []":"Range [ "+this._start+"..."+this._end+(1!==this._step?" by "+this._step:"")+" ]"},Range.prototype.get=function(t,e){return this.has(t)?this._start+wrapIndex(this,t)*this._step:e},Range.prototype.includes=function(t){var e=(t-this._start)/this._step;return e>=0&&e<this.size&&e===Math.floor(e)},Range.prototype.slice=function(t,e){return wholeSlice(t,e,this.size)?this:(t=resolveBegin(t,this.size),(e=resolveEnd(e,this.size))<=t?new Range(0,0):new Range(this.get(t,this._end),this.get(e,this._end),this._step))},Range.prototype.indexOf=function(t){var e=t-this._start;if(e%this._step==0){var r=e/this._step;if(r>=0&&r<this.size)return r}return-1},Range.prototype.lastIndexOf=function(t){return this.indexOf(t)},Range.prototype.__iterate=function(t,e){for(var r=this.size-1,n=this._step,o=e?this._start+r*n:this._start,i=0;i<=r;i++){if(!1===t(o,i,this))return i+1;o+=e?-n:n}return i},Range.prototype.__iterator=function(t,e){var r=this.size-1,n=this._step,o=e?this._start+r*n:this._start,i=0;return new Iterator((function(){var a=o;return o+=e?-n:n,i>r?iteratorDone():iteratorValue(t,i++,a)}))},Range.prototype.equals=function(t){return t instanceof Range?this._start===t._start&&this._end===t._end&&this._step===t._step:deepEqual(this,t)},createClass(Collection,Iterable),createClass(KeyedCollection,Collection),createClass(IndexedCollection,Collection),createClass(SetCollection,Collection),Collection.Keyed=KeyedCollection,Collection.Indexed=IndexedCollection,Collection.Set=SetCollection;var I="function"==typeof Math.imul&&-2===Math.imul(4294967295,2)?Math.imul:function imul(t,e){var r=65535&(t|=0),n=65535&(e|=0);return r*n+((t>>>16)*n+r*(e>>>16)<<16>>>0)|0};function smi(t){return t>>>1&1073741824|3221225471&t}function hash(t){if(!1===t||null==t)return 0;if("function"==typeof t.valueOf&&(!1===(t=t.valueOf())||null==t))return 0;if(!0===t)return 1;var e=typeof t;if("number"===e){if(t!=t||t===1/0)return 0;var r=0|t;for(r!==t&&(r^=4294967295*t);t>4294967295;)r^=t/=4294967295;return smi(r)}if("string"===e)return t.length>L?cachedHashString(t):hashString(t);if("function"==typeof t.hashCode)return t.hashCode();if("object"===e)return hashJSObj(t);if("function"==typeof t.toString)return hashString(t.toString());throw new Error("Value type "+e+" cannot be hashed.")}function cachedHashString(t){var e=D[t];return void 0===e&&(e=hashString(t),U===P&&(U=0,D={}),U++,D[t]=e),e}function hashString(t){for(var e=0,r=0;r<t.length;r++)e=31*e+t.charCodeAt(r)|0;return smi(e)}function hashJSObj(t){var e;if(C&&void 0!==(e=k.get(t)))return e;if(void 0!==(e=t[q]))return e;if(!B){if(void 0!==(e=t.propertyIsEnumerable&&t.propertyIsEnumerable[q]))return e;if(void 0!==(e=getIENodeHash(t)))return e}if(e=++j,1073741824&j&&(j=0),C)k.set(t,e);else{if(void 0!==x&&!1===x(t))throw new Error("Non-extensible objects are not allowed as keys.");if(B)Object.defineProperty(t,q,{enumerable:!1,configurable:!1,writable:!1,value:e});else if(void 0!==t.propertyIsEnumerable&&t.propertyIsEnumerable===t.constructor.prototype.propertyIsEnumerable)t.propertyIsEnumerable=function(){return this.constructor.prototype.propertyIsEnumerable.apply(this,arguments)},t.propertyIsEnumerable[q]=e;else{if(void 0===t.nodeType)throw new Error("Unable to set a non-enumerable property on object.");t[q]=e}}return e}var x=Object.isExtensible,B=function(){try{return Object.defineProperty({},"@",{}),!0}catch(t){return!1}}();function getIENodeHash(t){if(t&&t.nodeType>0)switch(t.nodeType){case 1:return t.uniqueID;case 9:return t.documentElement&&t.documentElement.uniqueID}}var k,C="function"==typeof WeakMap;C&&(k=new WeakMap);var j=0,q="__immutablehash__";"function"==typeof Symbol&&(q=Symbol(q));var L=16,P=255,U=0,D={};function assertNotInfinite(t){invariant(t!==1/0,"Cannot perform this action with an infinite size.")}function Map(t){return null==t?emptyMap():isMap(t)&&!isOrdered(t)?t:emptyMap().withMutations((function(e){var r=KeyedIterable(t);assertNotInfinite(r.size),r.forEach((function(t,r){return e.set(r,t)}))}))}function isMap(t){return!(!t||!t[W])}createClass(Map,KeyedCollection),Map.of=function(){var e=t.call(arguments,0);return emptyMap().withMutations((function(t){for(var r=0;r<e.length;r+=2){if(r+1>=e.length)throw new Error("Missing value for key: "+e[r]);t.set(e[r],e[r+1])}}))},Map.prototype.toString=function(){return this.__toString("Map {","}")},Map.prototype.get=function(t,e){return this._root?this._root.get(0,void 0,t,e):e},Map.prototype.set=function(t,e){return updateMap(this,t,e)},Map.prototype.setIn=function(t,e){return this.updateIn(t,c,(function(){return e}))},Map.prototype.remove=function(t){return updateMap(this,t,c)},Map.prototype.deleteIn=function(t){return this.updateIn(t,(function(){return c}))},Map.prototype.update=function(t,e,r){return 1===arguments.length?t(this):this.updateIn([t],e,r)},Map.prototype.updateIn=function(t,e,r){r||(r=e,e=void 0);var n=updateInDeepMap(this,forceIterator(t),e,r);return n===c?void 0:n},Map.prototype.clear=function(){return 0===this.size?this:this.__ownerID?(this.size=0,this._root=null,this.__hash=void 0,this.__altered=!0,this):emptyMap()},Map.prototype.merge=function(){return mergeIntoMapWith(this,void 0,arguments)},Map.prototype.mergeWith=function(e){return mergeIntoMapWith(this,e,t.call(arguments,1))},Map.prototype.mergeIn=function(e){var r=t.call(arguments,1);return this.updateIn(e,emptyMap(),(function(t){return"function"==typeof t.merge?t.merge.apply(t,r):r[r.length-1]}))},Map.prototype.mergeDeep=function(){return mergeIntoMapWith(this,deepMerger,arguments)},Map.prototype.mergeDeepWith=function(e){var r=t.call(arguments,1);return mergeIntoMapWith(this,deepMergerWith(e),r)},Map.prototype.mergeDeepIn=function(e){var r=t.call(arguments,1);return this.updateIn(e,emptyMap(),(function(t){return"function"==typeof t.mergeDeep?t.mergeDeep.apply(t,r):r[r.length-1]}))},Map.prototype.sort=function(t){return OrderedMap(sortFactory(this,t))},Map.prototype.sortBy=function(t,e){return OrderedMap(sortFactory(this,e,t))},Map.prototype.withMutations=function(t){var e=this.asMutable();return t(e),e.wasAltered()?e.__ensureOwner(this.__ownerID):this},Map.prototype.asMutable=function(){return this.__ownerID?this:this.__ensureOwner(new OwnerID)},Map.prototype.asImmutable=function(){return this.__ensureOwner()},Map.prototype.wasAltered=function(){return this.__altered},Map.prototype.__iterator=function(t,e){return new MapIterator(this,t,e)},Map.prototype.__iterate=function(t,e){var r=this,n=0;return this._root&&this._root.iterate((function(e){return n++,t(e[1],e[0],r)}),e),n},Map.prototype.__ensureOwner=function(t){return t===this.__ownerID?this:t?makeMap(this.size,this._root,t,this.__hash):(this.__ownerID=t,this.__altered=!1,this)},Map.isMap=isMap;var z,W="@@__IMMUTABLE_MAP__@@",V=Map.prototype;function ArrayMapNode(t,e){this.ownerID=t,this.entries=e}function BitmapIndexedNode(t,e,r){this.ownerID=t,this.bitmap=e,this.nodes=r}function HashArrayMapNode(t,e,r){this.ownerID=t,this.count=e,this.nodes=r}function HashCollisionNode(t,e,r){this.ownerID=t,this.keyHash=e,this.entries=r}function ValueNode(t,e,r){this.ownerID=t,this.keyHash=e,this.entry=r}function MapIterator(t,e,r){this._type=e,this._reverse=r,this._stack=t._root&&mapIteratorFrame(t._root)}function mapIteratorValue(t,e){return iteratorValue(t,e[0],e[1])}function mapIteratorFrame(t,e){return{node:t,index:0,__prev:e}}function makeMap(t,e,r,n){var o=Object.create(V);return o.size=t,o._root=e,o.__ownerID=r,o.__hash=n,o.__altered=!1,o}function emptyMap(){return z||(z=makeMap(0))}function updateMap(t,e,r){var n,o;if(t._root){var i=MakeRef(f),a=MakeRef(l);if(n=updateNode(t._root,t.__ownerID,0,void 0,e,r,i,a),!a.value)return t;o=t.size+(i.value?r===c?-1:1:0)}else{if(r===c)return t;o=1,n=new ArrayMapNode(t.__ownerID,[[e,r]])}return t.__ownerID?(t.size=o,t._root=n,t.__hash=void 0,t.__altered=!0,t):n?makeMap(o,n):emptyMap()}function updateNode(t,e,r,n,o,i,a,s){return t?t.update(e,r,n,o,i,a,s):i===c?t:(SetRef(s),SetRef(a),new ValueNode(e,n,[o,i]))}function isLeafNode(t){return t.constructor===ValueNode||t.constructor===HashCollisionNode}function mergeIntoNode(t,e,r,n,o){if(t.keyHash===n)return new HashCollisionNode(e,n,[t.entry,o]);var i,s=(0===r?t.keyHash:t.keyHash>>>r)&u,c=(0===r?n:n>>>r)&u;return new BitmapIndexedNode(e,1<<s|1<<c,s===c?[mergeIntoNode(t,e,r+a,n,o)]:(i=new ValueNode(e,n,o),s<c?[t,i]:[i,t]))}function createNodes(t,e,r,n){t||(t=new OwnerID);for(var o=new ValueNode(t,hash(r),[r,n]),i=0;i<e.length;i++){var a=e[i];o=o.update(t,0,void 0,a[0],a[1])}return o}function packNodes(t,e,r,n){for(var o=0,i=0,a=new Array(r),s=0,u=1,c=e.length;s<c;s++,u<<=1){var f=e[s];void 0!==f&&s!==n&&(o|=u,a[i++]=f)}return new BitmapIndexedNode(t,o,a)}function expandNodes(t,e,r,n,o){for(var i=0,a=new Array(s),u=0;0!==r;u++,r>>>=1)a[u]=1&r?e[i++]:void 0;return a[n]=o,new HashArrayMapNode(t,i+1,a)}function mergeIntoMapWith(t,e,r){for(var n=[],o=0;o<r.length;o++){var i=r[o],a=KeyedIterable(i);isIterable(i)||(a=a.map((function(t){return fromJS(t)}))),n.push(a)}return mergeIntoCollectionWith(t,e,n)}function deepMerger(t,e,r){return t&&t.mergeDeep&&isIterable(e)?t.mergeDeep(e):is(t,e)?t:e}function deepMergerWith(t){return function(e,r,n){if(e&&e.mergeDeepWith&&isIterable(r))return e.mergeDeepWith(t,r);var o=t(e,r,n);return is(e,o)?e:o}}function mergeIntoCollectionWith(t,e,r){return 0===(r=r.filter((function(t){return 0!==t.size}))).length?t:0!==t.size||t.__ownerID||1!==r.length?t.withMutations((function(t){for(var n=e?function(r,n){t.update(n,c,(function(t){return t===c?r:e(t,r,n)}))}:function(e,r){t.set(r,e)},o=0;o<r.length;o++)r[o].forEach(n)})):t.constructor(r[0])}function updateInDeepMap(t,e,r,n){var o=t===c,i=e.next();if(i.done){var a=o?r:t,s=n(a);return s===a?t:s}invariant(o||t&&t.set,"invalid keyPath");var u=i.value,f=o?c:t.get(u,c),l=updateInDeepMap(f,e,r,n);return l===f?t:l===c?t.remove(u):(o?emptyMap():t).set(u,l)}function popCount(t){return t=(t=(858993459&(t-=t>>1&1431655765))+(t>>2&858993459))+(t>>4)&252645135,t+=t>>8,127&(t+=t>>16)}function setIn(t,e,r,n){var o=n?t:arrCopy(t);return o[e]=r,o}function spliceIn(t,e,r,n){var o=t.length+1;if(n&&e+1===o)return t[e]=r,t;for(var i=new Array(o),a=0,s=0;s<o;s++)s===e?(i[s]=r,a=-1):i[s]=t[s+a];return i}function spliceOut(t,e,r){var n=t.length-1;if(r&&e===n)return t.pop(),t;for(var o=new Array(n),i=0,a=0;a<n;a++)a===e&&(i=1),o[a]=t[a+i];return o}V[W]=!0,V[i]=V.remove,V.removeIn=V.deleteIn,ArrayMapNode.prototype.get=function(t,e,r,n){for(var o=this.entries,i=0,a=o.length;i<a;i++)if(is(r,o[i][0]))return o[i][1];return n},ArrayMapNode.prototype.update=function(t,e,r,n,o,i,a){for(var s=o===c,u=this.entries,f=0,l=u.length;f<l&&!is(n,u[f][0]);f++);var p=f<l;if(p?u[f][1]===o:s)return this;if(SetRef(a),(s||!p)&&SetRef(i),!s||1!==u.length){if(!p&&!s&&u.length>=K)return createNodes(t,u,n,o);var h=t&&t===this.ownerID,d=h?u:arrCopy(u);return p?s?f===l-1?d.pop():d[f]=d.pop():d[f]=[n,o]:d.push([n,o]),h?(this.entries=d,this):new ArrayMapNode(t,d)}},BitmapIndexedNode.prototype.get=function(t,e,r,n){void 0===e&&(e=hash(r));var o=1<<((0===t?e:e>>>t)&u),i=this.bitmap;return i&o?this.nodes[popCount(i&o-1)].get(t+a,e,r,n):n},BitmapIndexedNode.prototype.update=function(t,e,r,n,o,i,s){void 0===r&&(r=hash(n));var f=(0===e?r:r>>>e)&u,l=1<<f,p=this.bitmap,h=!!(p&l);if(!h&&o===c)return this;var d=popCount(p&l-1),y=this.nodes,_=h?y[d]:void 0,g=updateNode(_,t,e+a,r,n,o,i,s);if(g===_)return this;if(!h&&g&&y.length>=$)return expandNodes(t,y,p,f,g);if(h&&!g&&2===y.length&&isLeafNode(y[1^d]))return y[1^d];if(h&&g&&1===y.length&&isLeafNode(g))return g;var m=t&&t===this.ownerID,v=h?g?p:p^l:p|l,b=h?g?setIn(y,d,g,m):spliceOut(y,d,m):spliceIn(y,d,g,m);return m?(this.bitmap=v,this.nodes=b,this):new BitmapIndexedNode(t,v,b)},HashArrayMapNode.prototype.get=function(t,e,r,n){void 0===e&&(e=hash(r));var o=(0===t?e:e>>>t)&u,i=this.nodes[o];return i?i.get(t+a,e,r,n):n},HashArrayMapNode.prototype.update=function(t,e,r,n,o,i,s){void 0===r&&(r=hash(n));var f=(0===e?r:r>>>e)&u,l=o===c,p=this.nodes,h=p[f];if(l&&!h)return this;var d=updateNode(h,t,e+a,r,n,o,i,s);if(d===h)return this;var y=this.count;if(h){if(!d&&--y<H)return packNodes(t,p,y,f)}else y++;var _=t&&t===this.ownerID,g=setIn(p,f,d,_);return _?(this.count=y,this.nodes=g,this):new HashArrayMapNode(t,y,g)},HashCollisionNode.prototype.get=function(t,e,r,n){for(var o=this.entries,i=0,a=o.length;i<a;i++)if(is(r,o[i][0]))return o[i][1];return n},HashCollisionNode.prototype.update=function(t,e,r,n,o,i,a){void 0===r&&(r=hash(n));var s=o===c;if(r!==this.keyHash)return s?this:(SetRef(a),SetRef(i),mergeIntoNode(this,t,e,r,[n,o]));for(var u=this.entries,f=0,l=u.length;f<l&&!is(n,u[f][0]);f++);var p=f<l;if(p?u[f][1]===o:s)return this;if(SetRef(a),(s||!p)&&SetRef(i),s&&2===l)return new ValueNode(t,this.keyHash,u[1^f]);var h=t&&t===this.ownerID,d=h?u:arrCopy(u);return p?s?f===l-1?d.pop():d[f]=d.pop():d[f]=[n,o]:d.push([n,o]),h?(this.entries=d,this):new HashCollisionNode(t,this.keyHash,d)},ValueNode.prototype.get=function(t,e,r,n){return is(r,this.entry[0])?this.entry[1]:n},ValueNode.prototype.update=function(t,e,r,n,o,i,a){var s=o===c,u=is(n,this.entry[0]);return(u?o===this.entry[1]:s)?this:(SetRef(a),s?void SetRef(i):u?t&&t===this.ownerID?(this.entry[1]=o,this):new ValueNode(t,this.keyHash,[n,o]):(SetRef(i),mergeIntoNode(this,t,e,hash(n),[n,o])))},ArrayMapNode.prototype.iterate=HashCollisionNode.prototype.iterate=function(t,e){for(var r=this.entries,n=0,o=r.length-1;n<=o;n++)if(!1===t(r[e?o-n:n]))return!1},BitmapIndexedNode.prototype.iterate=HashArrayMapNode.prototype.iterate=function(t,e){for(var r=this.nodes,n=0,o=r.length-1;n<=o;n++){var i=r[e?o-n:n];if(i&&!1===i.iterate(t,e))return!1}},ValueNode.prototype.iterate=function(t,e){return t(this.entry)},createClass(MapIterator,Iterator),MapIterator.prototype.next=function(){for(var t=this._type,e=this._stack;e;){var r,n=e.node,o=e.index++;if(n.entry){if(0===o)return mapIteratorValue(t,n.entry)}else if(n.entries){if(o<=(r=n.entries.length-1))return mapIteratorValue(t,n.entries[this._reverse?r-o:o])}else if(o<=(r=n.nodes.length-1)){var i=n.nodes[this._reverse?r-o:o];if(i){if(i.entry)return mapIteratorValue(t,i.entry);e=this._stack=mapIteratorFrame(i,e)}continue}e=this._stack=this._stack.__prev}return iteratorDone()};var K=s/4,$=s/2,H=s/4;function List(t){var e=emptyList();if(null==t)return e;if(isList(t))return t;var r=IndexedIterable(t),n=r.size;return 0===n?e:(assertNotInfinite(n),n>0&&n<s?makeList(0,n,a,null,new VNode(r.toArray())):e.withMutations((function(t){t.setSize(n),r.forEach((function(e,r){return t.set(r,e)}))})))}function isList(t){return!(!t||!t[Y])}createClass(List,IndexedCollection),List.of=function(){return this(arguments)},List.prototype.toString=function(){return this.__toString("List [","]")},List.prototype.get=function(t,e){if((t=wrapIndex(this,t))>=0&&t<this.size){var r=listNodeFor(this,t+=this._origin);return r&&r.array[t&u]}return e},List.prototype.set=function(t,e){return updateList(this,t,e)},List.prototype.remove=function(t){return this.has(t)?0===t?this.shift():t===this.size-1?this.pop():this.splice(t,1):this},List.prototype.insert=function(t,e){return this.splice(t,0,e)},List.prototype.clear=function(){return 0===this.size?this:this.__ownerID?(this.size=this._origin=this._capacity=0,this._level=a,this._root=this._tail=null,this.__hash=void 0,this.__altered=!0,this):emptyList()},List.prototype.push=function(){var t=arguments,e=this.size;return this.withMutations((function(r){setListBounds(r,0,e+t.length);for(var n=0;n<t.length;n++)r.set(e+n,t[n])}))},List.prototype.pop=function(){return setListBounds(this,0,-1)},List.prototype.unshift=function(){var t=arguments;return this.withMutations((function(e){setListBounds(e,-t.length);for(var r=0;r<t.length;r++)e.set(r,t[r])}))},List.prototype.shift=function(){return setListBounds(this,1)},List.prototype.merge=function(){return mergeIntoListWith(this,void 0,arguments)},List.prototype.mergeWith=function(e){return mergeIntoListWith(this,e,t.call(arguments,1))},List.prototype.mergeDeep=function(){return mergeIntoListWith(this,deepMerger,arguments)},List.prototype.mergeDeepWith=function(e){var r=t.call(arguments,1);return mergeIntoListWith(this,deepMergerWith(e),r)},List.prototype.setSize=function(t){return setListBounds(this,0,t)},List.prototype.slice=function(t,e){var r=this.size;return wholeSlice(t,e,r)?this:setListBounds(this,resolveBegin(t,r),resolveEnd(e,r))},List.prototype.__iterator=function(t,e){var r=0,n=iterateList(this,e);return new Iterator((function(){var e=n();return e===et?iteratorDone():iteratorValue(t,r++,e)}))},List.prototype.__iterate=function(t,e){for(var r,n=0,o=iterateList(this,e);(r=o())!==et&&!1!==t(r,n++,this););return n},List.prototype.__ensureOwner=function(t){return t===this.__ownerID?this:t?makeList(this._origin,this._capacity,this._level,this._root,this._tail,t,this.__hash):(this.__ownerID=t,this)},List.isList=isList;var Y="@@__IMMUTABLE_LIST__@@",Z=List.prototype;function VNode(t,e){this.array=t,this.ownerID=e}Z[Y]=!0,Z[i]=Z.remove,Z.setIn=V.setIn,Z.deleteIn=Z.removeIn=V.removeIn,Z.update=V.update,Z.updateIn=V.updateIn,Z.mergeIn=V.mergeIn,Z.mergeDeepIn=V.mergeDeepIn,Z.withMutations=V.withMutations,Z.asMutable=V.asMutable,Z.asImmutable=V.asImmutable,Z.wasAltered=V.wasAltered,VNode.prototype.removeBefore=function(t,e,r){if(r===e?1<<e:0===this.array.length)return this;var n=r>>>e&u;if(n>=this.array.length)return new VNode([],t);var o,i=0===n;if(e>0){var s=this.array[n];if((o=s&&s.removeBefore(t,e-a,r))===s&&i)return this}if(i&&!o)return this;var c=editableVNode(this,t);if(!i)for(var f=0;f<n;f++)c.array[f]=void 0;return o&&(c.array[n]=o),c},VNode.prototype.removeAfter=function(t,e,r){if(r===(e?1<<e:0)||0===this.array.length)return this;var n,o=r-1>>>e&u;if(o>=this.array.length)return this;if(e>0){var i=this.array[o];if((n=i&&i.removeAfter(t,e-a,r))===i&&o===this.array.length-1)return this}var s=editableVNode(this,t);return s.array.splice(o+1),n&&(s.array[o]=n),s};var J,tt,et={};function iterateList(t,e){var r=t._origin,n=t._capacity,o=getTailOffset(n),i=t._tail;return iterateNodeOrLeaf(t._root,t._level,0);function iterateNodeOrLeaf(t,e,r){return 0===e?iterateLeaf(t,r):iterateNode(t,e,r)}function iterateLeaf(t,a){var u=a===o?i&&i.array:t&&t.array,c=a>r?0:r-a,f=n-a;return f>s&&(f=s),function(){if(c===f)return et;var t=e?--f:c++;return u&&u[t]}}function iterateNode(t,o,i){var u,c=t&&t.array,f=i>r?0:r-i>>o,l=1+(n-i>>o);return l>s&&(l=s),function(){for(;;){if(u){var t=u();if(t!==et)return t;u=null}if(f===l)return et;var r=e?--l:f++;u=iterateNodeOrLeaf(c&&c[r],o-a,i+(r<<o))}}}}function makeList(t,e,r,n,o,i,a){var s=Object.create(Z);return s.size=e-t,s._origin=t,s._capacity=e,s._level=r,s._root=n,s._tail=o,s.__ownerID=i,s.__hash=a,s.__altered=!1,s}function emptyList(){return J||(J=makeList(0,0,a))}function updateList(t,e,r){if((e=wrapIndex(t,e))!=e)return t;if(e>=t.size||e<0)return t.withMutations((function(t){e<0?setListBounds(t,e).set(0,r):setListBounds(t,0,e+1).set(e,r)}));e+=t._origin;var n=t._tail,o=t._root,i=MakeRef(l);return e>=getTailOffset(t._capacity)?n=updateVNode(n,t.__ownerID,0,e,r,i):o=updateVNode(o,t.__ownerID,t._level,e,r,i),i.value?t.__ownerID?(t._root=o,t._tail=n,t.__hash=void 0,t.__altered=!0,t):makeList(t._origin,t._capacity,t._level,o,n):t}function updateVNode(t,e,r,n,o,i){var s,c=n>>>r&u,f=t&&c<t.array.length;if(!f&&void 0===o)return t;if(r>0){var l=t&&t.array[c],p=updateVNode(l,e,r-a,n,o,i);return p===l?t:((s=editableVNode(t,e)).array[c]=p,s)}return f&&t.array[c]===o?t:(SetRef(i),s=editableVNode(t,e),void 0===o&&c===s.array.length-1?s.array.pop():s.array[c]=o,s)}function editableVNode(t,e){return e&&t&&e===t.ownerID?t:new VNode(t?t.array.slice():[],e)}function listNodeFor(t,e){if(e>=getTailOffset(t._capacity))return t._tail;if(e<1<<t._level+a){for(var r=t._root,n=t._level;r&&n>0;)r=r.array[e>>>n&u],n-=a;return r}}function setListBounds(t,e,r){void 0!==e&&(e|=0),void 0!==r&&(r|=0);var n=t.__ownerID||new OwnerID,o=t._origin,i=t._capacity,s=o+e,c=void 0===r?i:r<0?i+r:o+r;if(s===o&&c===i)return t;if(s>=c)return t.clear();for(var f=t._level,l=t._root,p=0;s+p<0;)l=new VNode(l&&l.array.length?[void 0,l]:[],n),p+=1<<(f+=a);p&&(s+=p,o+=p,c+=p,i+=p);for(var h=getTailOffset(i),d=getTailOffset(c);d>=1<<f+a;)l=new VNode(l&&l.array.length?[l]:[],n),f+=a;var y=t._tail,_=d<h?listNodeFor(t,c-1):d>h?new VNode([],n):y;if(y&&d>h&&s<i&&y.array.length){for(var g=l=editableVNode(l,n),m=f;m>a;m-=a){var v=h>>>m&u;g=g.array[v]=editableVNode(g.array[v],n)}g.array[h>>>a&u]=y}if(c<i&&(_=_&&_.removeAfter(n,0,c)),s>=d)s-=d,c-=d,f=a,l=null,_=_&&_.removeBefore(n,0,s);else if(s>o||d<h){for(p=0;l;){var b=s>>>f&u;if(b!==d>>>f&u)break;b&&(p+=(1<<f)*b),f-=a,l=l.array[b]}l&&s>o&&(l=l.removeBefore(n,f,s-p)),l&&d<h&&(l=l.removeAfter(n,f,d-p)),p&&(s-=p,c-=p)}return t.__ownerID?(t.size=c-s,t._origin=s,t._capacity=c,t._level=f,t._root=l,t._tail=_,t.__hash=void 0,t.__altered=!0,t):makeList(s,c,f,l,_)}function mergeIntoListWith(t,e,r){for(var n=[],o=0,i=0;i<r.length;i++){var a=r[i],s=IndexedIterable(a);s.size>o&&(o=s.size),isIterable(a)||(s=s.map((function(t){return fromJS(t)}))),n.push(s)}return o>t.size&&(t=t.setSize(o)),mergeIntoCollectionWith(t,e,n)}function getTailOffset(t){return t<s?0:t-1>>>a<<a}function OrderedMap(t){return null==t?emptyOrderedMap():isOrderedMap(t)?t:emptyOrderedMap().withMutations((function(e){var r=KeyedIterable(t);assertNotInfinite(r.size),r.forEach((function(t,r){return e.set(r,t)}))}))}function isOrderedMap(t){return isMap(t)&&isOrdered(t)}function makeOrderedMap(t,e,r,n){var o=Object.create(OrderedMap.prototype);return o.size=t?t.size:0,o._map=t,o._list=e,o.__ownerID=r,o.__hash=n,o}function emptyOrderedMap(){return tt||(tt=makeOrderedMap(emptyMap(),emptyList()))}function updateOrderedMap(t,e,r){var n,o,i=t._map,a=t._list,u=i.get(e),f=void 0!==u;if(r===c){if(!f)return t;a.size>=s&&a.size>=2*i.size?(n=(o=a.filter((function(t,e){return void 0!==t&&u!==e}))).toKeyedSeq().map((function(t){return t[0]})).flip().toMap(),t.__ownerID&&(n.__ownerID=o.__ownerID=t.__ownerID)):(n=i.remove(e),o=u===a.size-1?a.pop():a.set(u,void 0))}else if(f){if(r===a.get(u)[1])return t;n=i,o=a.set(u,[e,r])}else n=i.set(e,a.size),o=a.set(a.size,[e,r]);return t.__ownerID?(t.size=n.size,t._map=n,t._list=o,t.__hash=void 0,t):makeOrderedMap(n,o)}function ToKeyedSequence(t,e){this._iter=t,this._useKeys=e,this.size=t.size}function ToIndexedSequence(t){this._iter=t,this.size=t.size}function ToSetSequence(t){this._iter=t,this.size=t.size}function FromEntriesSequence(t){this._iter=t,this.size=t.size}function flipFactory(t){var e=makeSequence(t);return e._iter=t,e.size=t.size,e.flip=function(){return t},e.reverse=function(){var e=t.reverse.apply(this);return e.flip=function(){return t.reverse()},e},e.has=function(e){return t.includes(e)},e.includes=function(e){return t.has(e)},e.cacheResult=cacheResultThrough,e.__iterateUncached=function(e,r){var n=this;return t.__iterate((function(t,r){return!1!==e(r,t,n)}),r)},e.__iteratorUncached=function(e,r){if(e===d){var n=t.__iterator(e,r);return new Iterator((function(){var t=n.next();if(!t.done){var e=t.value[0];t.value[0]=t.value[1],t.value[1]=e}return t}))}return t.__iterator(e===h?p:h,r)},e}function mapFactory(t,e,r){var n=makeSequence(t);return n.size=t.size,n.has=function(e){return t.has(e)},n.get=function(n,o){var i=t.get(n,c);return i===c?o:e.call(r,i,n,t)},n.__iterateUncached=function(n,o){var i=this;return t.__iterate((function(t,o,a){return!1!==n(e.call(r,t,o,a),o,i)}),o)},n.__iteratorUncached=function(n,o){var i=t.__iterator(d,o);return new Iterator((function(){var o=i.next();if(o.done)return o;var a=o.value,s=a[0];return iteratorValue(n,s,e.call(r,a[1],s,t),o)}))},n}function reverseFactory(t,e){var r=makeSequence(t);return r._iter=t,r.size=t.size,r.reverse=function(){return t},t.flip&&(r.flip=function(){var e=flipFactory(t);return e.reverse=function(){return t.flip()},e}),r.get=function(r,n){return t.get(e?r:-1-r,n)},r.has=function(r){return t.has(e?r:-1-r)},r.includes=function(e){return t.includes(e)},r.cacheResult=cacheResultThrough,r.__iterate=function(e,r){var n=this;return t.__iterate((function(t,r){return e(t,r,n)}),!r)},r.__iterator=function(e,r){return t.__iterator(e,!r)},r}function filterFactory(t,e,r,n){var o=makeSequence(t);return n&&(o.has=function(n){var o=t.get(n,c);return o!==c&&!!e.call(r,o,n,t)},o.get=function(n,o){var i=t.get(n,c);return i!==c&&e.call(r,i,n,t)?i:o}),o.__iterateUncached=function(o,i){var a=this,s=0;return t.__iterate((function(t,i,u){if(e.call(r,t,i,u))return s++,o(t,n?i:s-1,a)}),i),s},o.__iteratorUncached=function(o,i){var a=t.__iterator(d,i),s=0;return new Iterator((function(){for(;;){var i=a.next();if(i.done)return i;var u=i.value,c=u[0],f=u[1];if(e.call(r,f,c,t))return iteratorValue(o,n?c:s++,f,i)}}))},o}function countByFactory(t,e,r){var n=Map().asMutable();return t.__iterate((function(o,i){n.update(e.call(r,o,i,t),0,(function(t){return t+1}))})),n.asImmutable()}function groupByFactory(t,e,r){var n=isKeyed(t),o=(isOrdered(t)?OrderedMap():Map()).asMutable();t.__iterate((function(i,a){o.update(e.call(r,i,a,t),(function(t){return(t=t||[]).push(n?[a,i]:i),t}))}));var i=iterableClass(t);return o.map((function(e){return reify(t,i(e))}))}function sliceFactory(t,e,r,n){var o=t.size;if(void 0!==e&&(e|=0),void 0!==r&&(r===1/0?r=o:r|=0),wholeSlice(e,r,o))return t;var i=resolveBegin(e,o),a=resolveEnd(r,o);if(i!=i||a!=a)return sliceFactory(t.toSeq().cacheResult(),e,r,n);var s,u=a-i;u==u&&(s=u<0?0:u);var c=makeSequence(t);return c.size=0===s?s:t.size&&s||void 0,!n&&isSeq(t)&&s>=0&&(c.get=function(e,r){return(e=wrapIndex(this,e))>=0&&e<s?t.get(e+i,r):r}),c.__iterateUncached=function(e,r){var o=this;if(0===s)return 0;if(r)return this.cacheResult().__iterate(e,r);var a=0,u=!0,c=0;return t.__iterate((function(t,r){if(!u||!(u=a++<i))return c++,!1!==e(t,n?r:c-1,o)&&c!==s})),c},c.__iteratorUncached=function(e,r){if(0!==s&&r)return this.cacheResult().__iterator(e,r);var o=0!==s&&t.__iterator(e,r),a=0,u=0;return new Iterator((function(){for(;a++<i;)o.next();if(++u>s)return iteratorDone();var t=o.next();return n||e===h?t:iteratorValue(e,u-1,e===p?void 0:t.value[1],t)}))},c}function takeWhileFactory(t,e,r){var n=makeSequence(t);return n.__iterateUncached=function(n,o){var i=this;if(o)return this.cacheResult().__iterate(n,o);var a=0;return t.__iterate((function(t,o,s){return e.call(r,t,o,s)&&++a&&n(t,o,i)})),a},n.__iteratorUncached=function(n,o){var i=this;if(o)return this.cacheResult().__iterator(n,o);var a=t.__iterator(d,o),s=!0;return new Iterator((function(){if(!s)return iteratorDone();var t=a.next();if(t.done)return t;var o=t.value,u=o[0],c=o[1];return e.call(r,c,u,i)?n===d?t:iteratorValue(n,u,c,t):(s=!1,iteratorDone())}))},n}function skipWhileFactory(t,e,r,n){var o=makeSequence(t);return o.__iterateUncached=function(o,i){var a=this;if(i)return this.cacheResult().__iterate(o,i);var s=!0,u=0;return t.__iterate((function(t,i,c){if(!s||!(s=e.call(r,t,i,c)))return u++,o(t,n?i:u-1,a)})),u},o.__iteratorUncached=function(o,i){var a=this;if(i)return this.cacheResult().__iterator(o,i);var s=t.__iterator(d,i),u=!0,c=0;return new Iterator((function(){var t,i,f;do{if((t=s.next()).done)return n||o===h?t:iteratorValue(o,c++,o===p?void 0:t.value[1],t);var l=t.value;i=l[0],f=l[1],u&&(u=e.call(r,f,i,a))}while(u);return o===d?t:iteratorValue(o,i,f,t)}))},o}function concatFactory(t,e){var r=isKeyed(t),n=[t].concat(e).map((function(t){return isIterable(t)?r&&(t=KeyedIterable(t)):t=r?keyedSeqFromValue(t):indexedSeqFromValue(Array.isArray(t)?t:[t]),t})).filter((function(t){return 0!==t.size}));if(0===n.length)return t;if(1===n.length){var o=n[0];if(o===t||r&&isKeyed(o)||isIndexed(t)&&isIndexed(o))return o}var i=new ArraySeq(n);return r?i=i.toKeyedSeq():isIndexed(t)||(i=i.toSetSeq()),(i=i.flatten(!0)).size=n.reduce((function(t,e){if(void 0!==t){var r=e.size;if(void 0!==r)return t+r}}),0),i}function flattenFactory(t,e,r){var n=makeSequence(t);return n.__iterateUncached=function(n,o){var i=0,a=!1;function flatDeep(t,s){var u=this;t.__iterate((function(t,o){return(!e||s<e)&&isIterable(t)?flatDeep(t,s+1):!1===n(t,r?o:i++,u)&&(a=!0),!a}),o)}return flatDeep(t,0),i},n.__iteratorUncached=function(n,o){var i=t.__iterator(n,o),a=[],s=0;return new Iterator((function(){for(;i;){var t=i.next();if(!1===t.done){var u=t.value;if(n===d&&(u=u[1]),e&&!(a.length<e)||!isIterable(u))return r?t:iteratorValue(n,s++,u,t);a.push(i),i=u.__iterator(n,o)}else i=a.pop()}return iteratorDone()}))},n}function flatMapFactory(t,e,r){var n=iterableClass(t);return t.toSeq().map((function(o,i){return n(e.call(r,o,i,t))})).flatten(!0)}function interposeFactory(t,e){var r=makeSequence(t);return r.size=t.size&&2*t.size-1,r.__iterateUncached=function(r,n){var o=this,i=0;return t.__iterate((function(t,n){return(!i||!1!==r(e,i++,o))&&!1!==r(t,i++,o)}),n),i},r.__iteratorUncached=function(r,n){var o,i=t.__iterator(h,n),a=0;return new Iterator((function(){return(!o||a%2)&&(o=i.next()).done?o:a%2?iteratorValue(r,a++,e):iteratorValue(r,a++,o.value,o)}))},r}function sortFactory(t,e,r){e||(e=defaultComparator);var n=isKeyed(t),o=0,i=t.toSeq().map((function(e,n){return[n,e,o++,r?r(e,n,t):e]})).toArray();return i.sort((function(t,r){return e(t[3],r[3])||t[2]-r[2]})).forEach(n?function(t,e){i[e].length=2}:function(t,e){i[e]=t[1]}),n?KeyedSeq(i):isIndexed(t)?IndexedSeq(i):SetSeq(i)}function maxFactory(t,e,r){if(e||(e=defaultComparator),r){var n=t.toSeq().map((function(e,n){return[e,r(e,n,t)]})).reduce((function(t,r){return maxCompare(e,t[1],r[1])?r:t}));return n&&n[0]}return t.reduce((function(t,r){return maxCompare(e,t,r)?r:t}))}function maxCompare(t,e,r){var n=t(r,e);return 0===n&&r!==e&&(null==r||r!=r)||n>0}function zipWithFactory(t,e,r){var n=makeSequence(t);return n.size=new ArraySeq(r).map((function(t){return t.size})).min(),n.__iterate=function(t,e){for(var r,n=this.__iterator(h,e),o=0;!(r=n.next()).done&&!1!==t(r.value,o++,this););return o},n.__iteratorUncached=function(t,n){var o=r.map((function(t){return t=Iterable(t),getIterator(n?t.reverse():t)})),i=0,a=!1;return new Iterator((function(){var r;return a||(r=o.map((function(t){return t.next()})),a=r.some((function(t){return t.done}))),a?iteratorDone():iteratorValue(t,i++,e.apply(null,r.map((function(t){return t.value}))))}))},n}function reify(t,e){return isSeq(t)?e:t.constructor(e)}function validateEntry(t){if(t!==Object(t))throw new TypeError("Expected [K, V] tuple: "+t)}function resolveSize(t){return assertNotInfinite(t.size),ensureSize(t)}function iterableClass(t){return isKeyed(t)?KeyedIterable:isIndexed(t)?IndexedIterable:SetIterable}function makeSequence(t){return Object.create((isKeyed(t)?KeyedSeq:isIndexed(t)?IndexedSeq:SetSeq).prototype)}function cacheResultThrough(){return this._iter.cacheResult?(this._iter.cacheResult(),this.size=this._iter.size,this):Seq.prototype.cacheResult.call(this)}function defaultComparator(t,e){return t>e?1:t<e?-1:0}function forceIterator(t){var e=getIterator(t);if(!e){if(!isArrayLike(t))throw new TypeError("Expected iterable or array-like: "+t);e=getIterator(Iterable(t))}return e}function Record(t,e){var r,n=function Record(i){if(i instanceof n)return i;if(!(this instanceof n))return new n(i);if(!r){r=!0;var a=Object.keys(t);setProps(o,a),o.size=a.length,o._name=e,o._keys=a,o._defaultValues=t}this._map=Map(i)},o=n.prototype=Object.create(rt);return o.constructor=n,n}createClass(OrderedMap,Map),OrderedMap.of=function(){return this(arguments)},OrderedMap.prototype.toString=function(){return this.__toString("OrderedMap {","}")},OrderedMap.prototype.get=function(t,e){var r=this._map.get(t);return void 0!==r?this._list.get(r)[1]:e},OrderedMap.prototype.clear=function(){return 0===this.size?this:this.__ownerID?(this.size=0,this._map.clear(),this._list.clear(),this):emptyOrderedMap()},OrderedMap.prototype.set=function(t,e){return updateOrderedMap(this,t,e)},OrderedMap.prototype.remove=function(t){return updateOrderedMap(this,t,c)},OrderedMap.prototype.wasAltered=function(){return this._map.wasAltered()||this._list.wasAltered()},OrderedMap.prototype.__iterate=function(t,e){var r=this;return this._list.__iterate((function(e){return e&&t(e[1],e[0],r)}),e)},OrderedMap.prototype.__iterator=function(t,e){return this._list.fromEntrySeq().__iterator(t,e)},OrderedMap.prototype.__ensureOwner=function(t){if(t===this.__ownerID)return this;var e=this._map.__ensureOwner(t),r=this._list.__ensureOwner(t);return t?makeOrderedMap(e,r,t,this.__hash):(this.__ownerID=t,this._map=e,this._list=r,this)},OrderedMap.isOrderedMap=isOrderedMap,OrderedMap.prototype[o]=!0,OrderedMap.prototype[i]=OrderedMap.prototype.remove,createClass(ToKeyedSequence,KeyedSeq),ToKeyedSequence.prototype.get=function(t,e){return this._iter.get(t,e)},ToKeyedSequence.prototype.has=function(t){return this._iter.has(t)},ToKeyedSequence.prototype.valueSeq=function(){return this._iter.valueSeq()},ToKeyedSequence.prototype.reverse=function(){var t=this,e=reverseFactory(this,!0);return this._useKeys||(e.valueSeq=function(){return t._iter.toSeq().reverse()}),e},ToKeyedSequence.prototype.map=function(t,e){var r=this,n=mapFactory(this,t,e);return this._useKeys||(n.valueSeq=function(){return r._iter.toSeq().map(t,e)}),n},ToKeyedSequence.prototype.__iterate=function(t,e){var r,n=this;return this._iter.__iterate(this._useKeys?function(e,r){return t(e,r,n)}:(r=e?resolveSize(this):0,function(o){return t(o,e?--r:r++,n)}),e)},ToKeyedSequence.prototype.__iterator=function(t,e){if(this._useKeys)return this._iter.__iterator(t,e);var r=this._iter.__iterator(h,e),n=e?resolveSize(this):0;return new Iterator((function(){var o=r.next();return o.done?o:iteratorValue(t,e?--n:n++,o.value,o)}))},ToKeyedSequence.prototype[o]=!0,createClass(ToIndexedSequence,IndexedSeq),ToIndexedSequence.prototype.includes=function(t){return this._iter.includes(t)},ToIndexedSequence.prototype.__iterate=function(t,e){var r=this,n=0;return this._iter.__iterate((function(e){return t(e,n++,r)}),e)},ToIndexedSequence.prototype.__iterator=function(t,e){var r=this._iter.__iterator(h,e),n=0;return new Iterator((function(){var e=r.next();return e.done?e:iteratorValue(t,n++,e.value,e)}))},createClass(ToSetSequence,SetSeq),ToSetSequence.prototype.has=function(t){return this._iter.includes(t)},ToSetSequence.prototype.__iterate=function(t,e){var r=this;return this._iter.__iterate((function(e){return t(e,e,r)}),e)},ToSetSequence.prototype.__iterator=function(t,e){var r=this._iter.__iterator(h,e);return new Iterator((function(){var e=r.next();return e.done?e:iteratorValue(t,e.value,e.value,e)}))},createClass(FromEntriesSequence,KeyedSeq),FromEntriesSequence.prototype.entrySeq=function(){return this._iter.toSeq()},FromEntriesSequence.prototype.__iterate=function(t,e){var r=this;return this._iter.__iterate((function(e){if(e){validateEntry(e);var n=isIterable(e);return t(n?e.get(1):e[1],n?e.get(0):e[0],r)}}),e)},FromEntriesSequence.prototype.__iterator=function(t,e){var r=this._iter.__iterator(h,e);return new Iterator((function(){for(;;){var e=r.next();if(e.done)return e;var n=e.value;if(n){validateEntry(n);var o=isIterable(n);return iteratorValue(t,o?n.get(0):n[0],o?n.get(1):n[1],e)}}}))},ToIndexedSequence.prototype.cacheResult=ToKeyedSequence.prototype.cacheResult=ToSetSequence.prototype.cacheResult=FromEntriesSequence.prototype.cacheResult=cacheResultThrough,createClass(Record,KeyedCollection),Record.prototype.toString=function(){return this.__toString(recordName(this)+" {","}")},Record.prototype.has=function(t){return this._defaultValues.hasOwnProperty(t)},Record.prototype.get=function(t,e){if(!this.has(t))return e;var r=this._defaultValues[t];return this._map?this._map.get(t,r):r},Record.prototype.clear=function(){if(this.__ownerID)return this._map&&this._map.clear(),this;var t=this.constructor;return t._empty||(t._empty=makeRecord(this,emptyMap()))},Record.prototype.set=function(t,e){if(!this.has(t))throw new Error('Cannot set unknown key "'+t+'" on '+recordName(this));if(this._map&&!this._map.has(t)&&e===this._defaultValues[t])return this;var r=this._map&&this._map.set(t,e);return this.__ownerID||r===this._map?this:makeRecord(this,r)},Record.prototype.remove=function(t){if(!this.has(t))return this;var e=this._map&&this._map.remove(t);return this.__ownerID||e===this._map?this:makeRecord(this,e)},Record.prototype.wasAltered=function(){return this._map.wasAltered()},Record.prototype.__iterator=function(t,e){var r=this;return KeyedIterable(this._defaultValues).map((function(t,e){return r.get(e)})).__iterator(t,e)},Record.prototype.__iterate=function(t,e){var r=this;return KeyedIterable(this._defaultValues).map((function(t,e){return r.get(e)})).__iterate(t,e)},Record.prototype.__ensureOwner=function(t){if(t===this.__ownerID)return this;var e=this._map&&this._map.__ensureOwner(t);return t?makeRecord(this,e,t):(this.__ownerID=t,this._map=e,this)};var rt=Record.prototype;function makeRecord(t,e,r){var n=Object.create(Object.getPrototypeOf(t));return n._map=e,n.__ownerID=r,n}function recordName(t){return t._name||t.constructor.name||"Record"}function setProps(t,e){try{e.forEach(setProp.bind(void 0,t))}catch(t){}}function setProp(t,e){Object.defineProperty(t,e,{get:function(){return this.get(e)},set:function(t){invariant(this.__ownerID,"Cannot set on an immutable record."),this.set(e,t)}})}function Set(t){return null==t?emptySet():isSet(t)&&!isOrdered(t)?t:emptySet().withMutations((function(e){var r=SetIterable(t);assertNotInfinite(r.size),r.forEach((function(t){return e.add(t)}))}))}function isSet(t){return!(!t||!t[ot])}rt[i]=rt.remove,rt.deleteIn=rt.removeIn=V.removeIn,rt.merge=V.merge,rt.mergeWith=V.mergeWith,rt.mergeIn=V.mergeIn,rt.mergeDeep=V.mergeDeep,rt.mergeDeepWith=V.mergeDeepWith,rt.mergeDeepIn=V.mergeDeepIn,rt.setIn=V.setIn,rt.update=V.update,rt.updateIn=V.updateIn,rt.withMutations=V.withMutations,rt.asMutable=V.asMutable,rt.asImmutable=V.asImmutable,createClass(Set,SetCollection),Set.of=function(){return this(arguments)},Set.fromKeys=function(t){return this(KeyedIterable(t).keySeq())},Set.prototype.toString=function(){return this.__toString("Set {","}")},Set.prototype.has=function(t){return this._map.has(t)},Set.prototype.add=function(t){return updateSet(this,this._map.set(t,!0))},Set.prototype.remove=function(t){return updateSet(this,this._map.remove(t))},Set.prototype.clear=function(){return updateSet(this,this._map.clear())},Set.prototype.union=function(){var e=t.call(arguments,0);return 0===(e=e.filter((function(t){return 0!==t.size}))).length?this:0!==this.size||this.__ownerID||1!==e.length?this.withMutations((function(t){for(var r=0;r<e.length;r++)SetIterable(e[r]).forEach((function(e){return t.add(e)}))})):this.constructor(e[0])},Set.prototype.intersect=function(){var e=t.call(arguments,0);if(0===e.length)return this;e=e.map((function(t){return SetIterable(t)}));var r=this;return this.withMutations((function(t){r.forEach((function(r){e.every((function(t){return t.includes(r)}))||t.remove(r)}))}))},Set.prototype.subtract=function(){var e=t.call(arguments,0);if(0===e.length)return this;e=e.map((function(t){return SetIterable(t)}));var r=this;return this.withMutations((function(t){r.forEach((function(r){e.some((function(t){return t.includes(r)}))&&t.remove(r)}))}))},Set.prototype.merge=function(){return this.union.apply(this,arguments)},Set.prototype.mergeWith=function(e){var r=t.call(arguments,1);return this.union.apply(this,r)},Set.prototype.sort=function(t){return OrderedSet(sortFactory(this,t))},Set.prototype.sortBy=function(t,e){return OrderedSet(sortFactory(this,e,t))},Set.prototype.wasAltered=function(){return this._map.wasAltered()},Set.prototype.__iterate=function(t,e){var r=this;return this._map.__iterate((function(e,n){return t(n,n,r)}),e)},Set.prototype.__iterator=function(t,e){return this._map.map((function(t,e){return e})).__iterator(t,e)},Set.prototype.__ensureOwner=function(t){if(t===this.__ownerID)return this;var e=this._map.__ensureOwner(t);return t?this.__make(e,t):(this.__ownerID=t,this._map=e,this)},Set.isSet=isSet;var nt,ot="@@__IMMUTABLE_SET__@@",it=Set.prototype;function updateSet(t,e){return t.__ownerID?(t.size=e.size,t._map=e,t):e===t._map?t:0===e.size?t.__empty():t.__make(e)}function makeSet(t,e){var r=Object.create(it);return r.size=t?t.size:0,r._map=t,r.__ownerID=e,r}function emptySet(){return nt||(nt=makeSet(emptyMap()))}function OrderedSet(t){return null==t?emptyOrderedSet():isOrderedSet(t)?t:emptyOrderedSet().withMutations((function(e){var r=SetIterable(t);assertNotInfinite(r.size),r.forEach((function(t){return e.add(t)}))}))}function isOrderedSet(t){return isSet(t)&&isOrdered(t)}it[ot]=!0,it[i]=it.remove,it.mergeDeep=it.merge,it.mergeDeepWith=it.mergeWith,it.withMutations=V.withMutations,it.asMutable=V.asMutable,it.asImmutable=V.asImmutable,it.__empty=emptySet,it.__make=makeSet,createClass(OrderedSet,Set),OrderedSet.of=function(){return this(arguments)},OrderedSet.fromKeys=function(t){return this(KeyedIterable(t).keySeq())},OrderedSet.prototype.toString=function(){return this.__toString("OrderedSet {","}")},OrderedSet.isOrderedSet=isOrderedSet;var at,st=OrderedSet.prototype;function makeOrderedSet(t,e){var r=Object.create(st);return r.size=t?t.size:0,r._map=t,r.__ownerID=e,r}function emptyOrderedSet(){return at||(at=makeOrderedSet(emptyOrderedMap()))}function Stack(t){return null==t?emptyStack():isStack(t)?t:emptyStack().unshiftAll(t)}function isStack(t){return!(!t||!t[ct])}st[o]=!0,st.__empty=emptyOrderedSet,st.__make=makeOrderedSet,createClass(Stack,IndexedCollection),Stack.of=function(){return this(arguments)},Stack.prototype.toString=function(){return this.__toString("Stack [","]")},Stack.prototype.get=function(t,e){var r=this._head;for(t=wrapIndex(this,t);r&&t--;)r=r.next;return r?r.value:e},Stack.prototype.peek=function(){return this._head&&this._head.value},Stack.prototype.push=function(){if(0===arguments.length)return this;for(var t=this.size+arguments.length,e=this._head,r=arguments.length-1;r>=0;r--)e={value:arguments[r],next:e};return this.__ownerID?(this.size=t,this._head=e,this.__hash=void 0,this.__altered=!0,this):makeStack(t,e)},Stack.prototype.pushAll=function(t){if(0===(t=IndexedIterable(t)).size)return this;assertNotInfinite(t.size);var e=this.size,r=this._head;return t.reverse().forEach((function(t){e++,r={value:t,next:r}})),this.__ownerID?(this.size=e,this._head=r,this.__hash=void 0,this.__altered=!0,this):makeStack(e,r)},Stack.prototype.pop=function(){return this.slice(1)},Stack.prototype.unshift=function(){return this.push.apply(this,arguments)},Stack.prototype.unshiftAll=function(t){return this.pushAll(t)},Stack.prototype.shift=function(){return this.pop.apply(this,arguments)},Stack.prototype.clear=function(){return 0===this.size?this:this.__ownerID?(this.size=0,this._head=void 0,this.__hash=void 0,this.__altered=!0,this):emptyStack()},Stack.prototype.slice=function(t,e){if(wholeSlice(t,e,this.size))return this;var r=resolveBegin(t,this.size);if(resolveEnd(e,this.size)!==this.size)return IndexedCollection.prototype.slice.call(this,t,e);for(var n=this.size-r,o=this._head;r--;)o=o.next;return this.__ownerID?(this.size=n,this._head=o,this.__hash=void 0,this.__altered=!0,this):makeStack(n,o)},Stack.prototype.__ensureOwner=function(t){return t===this.__ownerID?this:t?makeStack(this.size,this._head,t,this.__hash):(this.__ownerID=t,this.__altered=!1,this)},Stack.prototype.__iterate=function(t,e){if(e)return this.reverse().__iterate(t);for(var r=0,n=this._head;n&&!1!==t(n.value,r++,this);)n=n.next;return r},Stack.prototype.__iterator=function(t,e){if(e)return this.reverse().__iterator(t);var r=0,n=this._head;return new Iterator((function(){if(n){var e=n.value;return n=n.next,iteratorValue(t,r++,e)}return iteratorDone()}))},Stack.isStack=isStack;var ut,ct="@@__IMMUTABLE_STACK__@@",lt=Stack.prototype;function makeStack(t,e,r,n){var o=Object.create(lt);return o.size=t,o._head=e,o.__ownerID=r,o.__hash=n,o.__altered=!1,o}function emptyStack(){return ut||(ut=makeStack(0))}function mixin(t,e){var keyCopier=function(r){t.prototype[r]=e[r]};return Object.keys(e).forEach(keyCopier),Object.getOwnPropertySymbols&&Object.getOwnPropertySymbols(e).forEach(keyCopier),t}function isProtoKey(t){return"string"==typeof t&&("__proto__"===t||"constructor"===t)}lt[ct]=!0,lt.withMutations=V.withMutations,lt.asMutable=V.asMutable,lt.asImmutable=V.asImmutable,lt.wasAltered=V.wasAltered,Iterable.Iterator=Iterator,mixin(Iterable,{toArray:function(){assertNotInfinite(this.size);var t=new Array(this.size||0);return this.valueSeq().__iterate((function(e,r){t[r]=e})),t},toIndexedSeq:function(){return new ToIndexedSequence(this)},toJS:function(){return this.toSeq().map((function(t){return t&&"function"==typeof t.toJS?t.toJS():t})).__toJS()},toJSON:function(){return this.toSeq().map((function(t){return t&&"function"==typeof t.toJSON?t.toJSON():t})).__toJS()},toKeyedSeq:function(){return new ToKeyedSequence(this,!0)},toMap:function(){return Map(this.toKeyedSeq())},toObject:function(){assertNotInfinite(this.size);var t={};return this.__iterate((function(e,r){isProtoKey(r)||(t[r]=e)})),t},toOrderedMap:function(){return OrderedMap(this.toKeyedSeq())},toOrderedSet:function(){return OrderedSet(isKeyed(this)?this.valueSeq():this)},toSet:function(){return Set(isKeyed(this)?this.valueSeq():this)},toSetSeq:function(){return new ToSetSequence(this)},toSeq:function(){return isIndexed(this)?this.toIndexedSeq():isKeyed(this)?this.toKeyedSeq():this.toSetSeq()},toStack:function(){return Stack(isKeyed(this)?this.valueSeq():this)},toList:function(){return List(isKeyed(this)?this.valueSeq():this)},toString:function(){return"[Iterable]"},__toString:function(t,e){return 0===this.size?t+e:t+" "+this.toSeq().map(this.__toStringMapper).join(", ")+" "+e},concat:function(){return reify(this,concatFactory(this,t.call(arguments,0)))},includes:function(t){return this.some((function(e){return is(e,t)}))},entries:function(){return this.__iterator(d)},every:function(t,e){assertNotInfinite(this.size);var r=!0;return this.__iterate((function(n,o,i){if(!t.call(e,n,o,i))return r=!1,!1})),r},filter:function(t,e){return reify(this,filterFactory(this,t,e,!0))},find:function(t,e,r){var n=this.findEntry(t,e);return n?n[1]:r},forEach:function(t,e){return assertNotInfinite(this.size),this.__iterate(e?t.bind(e):t)},join:function(t){assertNotInfinite(this.size),t=void 0!==t?""+t:",";var e="",r=!0;return this.__iterate((function(n){r?r=!1:e+=t,e+=null!=n?n.toString():""})),e},keys:function(){return this.__iterator(p)},map:function(t,e){return reify(this,mapFactory(this,t,e))},reduce:function(t,e,r){var n,o;return assertNotInfinite(this.size),arguments.length<2?o=!0:n=e,this.__iterate((function(e,i,a){o?(o=!1,n=e):n=t.call(r,n,e,i,a)})),n},reduceRight:function(t,e,r){var n=this.toKeyedSeq().reverse();return n.reduce.apply(n,arguments)},reverse:function(){return reify(this,reverseFactory(this,!0))},slice:function(t,e){return reify(this,sliceFactory(this,t,e,!0))},some:function(t,e){return!this.every(not(t),e)},sort:function(t){return reify(this,sortFactory(this,t))},values:function(){return this.__iterator(h)},butLast:function(){return this.slice(0,-1)},isEmpty:function(){return void 0!==this.size?0===this.size:!this.some((function(){return!0}))},count:function(t,e){return ensureSize(t?this.toSeq().filter(t,e):this)},countBy:function(t,e){return countByFactory(this,t,e)},equals:function(t){return deepEqual(this,t)},entrySeq:function(){var t=this;if(t._cache)return new ArraySeq(t._cache);var e=t.toSeq().map(entryMapper).toIndexedSeq();return e.fromEntrySeq=function(){return t.toSeq()},e},filterNot:function(t,e){return this.filter(not(t),e)},findEntry:function(t,e,r){var n=r;return this.__iterate((function(r,o,i){if(t.call(e,r,o,i))return n=[o,r],!1})),n},findKey:function(t,e){var r=this.findEntry(t,e);return r&&r[0]},findLast:function(t,e,r){return this.toKeyedSeq().reverse().find(t,e,r)},findLastEntry:function(t,e,r){return this.toKeyedSeq().reverse().findEntry(t,e,r)},findLastKey:function(t,e){return this.toKeyedSeq().reverse().findKey(t,e)},first:function(){return this.find(returnTrue)},flatMap:function(t,e){return reify(this,flatMapFactory(this,t,e))},flatten:function(t){return reify(this,flattenFactory(this,t,!0))},fromEntrySeq:function(){return new FromEntriesSequence(this)},get:function(t,e){return this.find((function(e,r){return is(r,t)}),void 0,e)},getIn:function(t,e){for(var r,n=this,o=forceIterator(t);!(r=o.next()).done;){var i=r.value;if((n=n&&n.get?n.get(i,c):c)===c)return e}return n},groupBy:function(t,e){return groupByFactory(this,t,e)},has:function(t){return this.get(t,c)!==c},hasIn:function(t){return this.getIn(t,c)!==c},isSubset:function(t){return t="function"==typeof t.includes?t:Iterable(t),this.every((function(e){return t.includes(e)}))},isSuperset:function(t){return(t="function"==typeof t.isSubset?t:Iterable(t)).isSubset(this)},keyOf:function(t){return this.findKey((function(e){return is(e,t)}))},keySeq:function(){return this.toSeq().map(keyMapper).toIndexedSeq()},last:function(){return this.toSeq().reverse().first()},lastKeyOf:function(t){return this.toKeyedSeq().reverse().keyOf(t)},max:function(t){return maxFactory(this,t)},maxBy:function(t,e){return maxFactory(this,e,t)},min:function(t){return maxFactory(this,t?neg(t):defaultNegComparator)},minBy:function(t,e){return maxFactory(this,e?neg(e):defaultNegComparator,t)},rest:function(){return this.slice(1)},skip:function(t){return this.slice(Math.max(0,t))},skipLast:function(t){return reify(this,this.toSeq().reverse().skip(t).reverse())},skipWhile:function(t,e){return reify(this,skipWhileFactory(this,t,e,!0))},skipUntil:function(t,e){return this.skipWhile(not(t),e)},sortBy:function(t,e){return reify(this,sortFactory(this,e,t))},take:function(t){return this.slice(0,Math.max(0,t))},takeLast:function(t){return reify(this,this.toSeq().reverse().take(t).reverse())},takeWhile:function(t,e){return reify(this,takeWhileFactory(this,t,e))},takeUntil:function(t,e){return this.takeWhile(not(t),e)},valueSeq:function(){return this.toIndexedSeq()},hashCode:function(){return this.__hash||(this.__hash=hashIterable(this))}});var pt=Iterable.prototype;pt[e]=!0,pt[g]=pt.values,pt.__toJS=pt.toArray,pt.__toStringMapper=quoteString,pt.inspect=pt.toSource=function(){return this.toString()},pt.chain=pt.flatMap,pt.contains=pt.includes,mixin(KeyedIterable,{flip:function(){return reify(this,flipFactory(this))},mapEntries:function(t,e){var r=this,n=0;return reify(this,this.toSeq().map((function(o,i){return t.call(e,[i,o],n++,r)})).fromEntrySeq())},mapKeys:function(t,e){var r=this;return reify(this,this.toSeq().flip().map((function(n,o){return t.call(e,n,o,r)})).flip())}});var ht=KeyedIterable.prototype;function keyMapper(t,e){return e}function entryMapper(t,e){return[e,t]}function not(t){return function(){return!t.apply(this,arguments)}}function neg(t){return function(){return-t.apply(this,arguments)}}function quoteString(t){return"string"==typeof t?JSON.stringify(t):String(t)}function defaultZipper(){return arrCopy(arguments)}function defaultNegComparator(t,e){return t<e?1:t>e?-1:0}function hashIterable(t){if(t.size===1/0)return 0;var e=isOrdered(t),r=isKeyed(t),n=e?1:0;return murmurHashOfSize(t.__iterate(r?e?function(t,e){n=31*n+hashMerge(hash(t),hash(e))|0}:function(t,e){n=n+hashMerge(hash(t),hash(e))|0}:e?function(t){n=31*n+hash(t)|0}:function(t){n=n+hash(t)|0}),n)}function murmurHashOfSize(t,e){return e=I(e,3432918353),e=I(e<<15|e>>>-15,461845907),e=I(e<<13|e>>>-13,5),e=I((e=e+3864292196^t)^e>>>16,2246822507),e=smi((e=I(e^e>>>13,3266489909))^e>>>16)}function hashMerge(t,e){return t^e+2654435769+(t<<6)+(t>>2)}return ht[r]=!0,ht[g]=pt.entries,ht.__toJS=pt.toObject,ht.__toStringMapper=function(t,e){return JSON.stringify(e)+": "+quoteString(t)},mixin(IndexedIterable,{toKeyedSeq:function(){return new ToKeyedSequence(this,!1)},filter:function(t,e){return reify(this,filterFactory(this,t,e,!1))},findIndex:function(t,e){var r=this.findEntry(t,e);return r?r[0]:-1},indexOf:function(t){var e=this.keyOf(t);return void 0===e?-1:e},lastIndexOf:function(t){var e=this.lastKeyOf(t);return void 0===e?-1:e},reverse:function(){return reify(this,reverseFactory(this,!1))},slice:function(t,e){return reify(this,sliceFactory(this,t,e,!1))},splice:function(t,e){var r=arguments.length;if(e=Math.max(0|e,0),0===r||2===r&&!e)return this;t=resolveBegin(t,t<0?this.count():this.size);var n=this.slice(0,t);return reify(this,1===r?n:n.concat(arrCopy(arguments,2),this.slice(t+e)))},findLastIndex:function(t,e){var r=this.findLastEntry(t,e);return r?r[0]:-1},first:function(){return this.get(0)},flatten:function(t){return reify(this,flattenFactory(this,t,!1))},get:function(t,e){return(t=wrapIndex(this,t))<0||this.size===1/0||void 0!==this.size&&t>this.size?e:this.find((function(e,r){return r===t}),void 0,e)},has:function(t){return(t=wrapIndex(this,t))>=0&&(void 0!==this.size?this.size===1/0||t<this.size:-1!==this.indexOf(t))},interpose:function(t){return reify(this,interposeFactory(this,t))},interleave:function(){var t=[this].concat(arrCopy(arguments)),e=zipWithFactory(this.toSeq(),IndexedSeq.of,t),r=e.flatten(!0);return e.size&&(r.size=e.size*t.length),reify(this,r)},keySeq:function(){return Range(0,this.size)},last:function(){return this.get(-1)},skipWhile:function(t,e){return reify(this,skipWhileFactory(this,t,e,!1))},zip:function(){return reify(this,zipWithFactory(this,defaultZipper,[this].concat(arrCopy(arguments))))},zipWith:function(t){var e=arrCopy(arguments);return e[0]=this,reify(this,zipWithFactory(this,t,e))}}),IndexedIterable.prototype[n]=!0,IndexedIterable.prototype[o]=!0,mixin(SetIterable,{get:function(t,e){return this.has(t)?t:e},includes:function(t){return this.has(t)},keySeq:function(){return this.valueSeq()}}),SetIterable.prototype.has=pt.includes,SetIterable.prototype.contains=SetIterable.prototype.includes,mixin(KeyedSeq,KeyedIterable.prototype),mixin(IndexedSeq,IndexedIterable.prototype),mixin(SetSeq,SetIterable.prototype),mixin(KeyedCollection,KeyedIterable.prototype),mixin(IndexedCollection,IndexedIterable.prototype),mixin(SetCollection,SetIterable.prototype),{Iterable,Seq,Collection,Map,OrderedMap,List,Stack,Set,OrderedSet,Record,Range,Repeat,is,fromJS}}()},6698(t){"function"==typeof Object.create?t.exports=function inherits(t,e){e&&(t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}))}:t.exports=function inherits(t,e){if(e){t.super_=e;var TempCtor=function(){};TempCtor.prototype=e.prototype,t.prototype=new TempCtor,t.prototype.constructor=t}}},9600(t){"use strict";var e,r,n=Function.prototype.toString,o="object"==typeof Reflect&&null!==Reflect&&Reflect.apply;if("function"==typeof o&&"function"==typeof Object.defineProperty)try{e=Object.defineProperty({},"length",{get:function(){throw r}}),r={},o((function(){throw 42}),null,e)}catch(t){t!==r&&(o=null)}else o=null;var i=/^\s*class\b/,a=function isES6ClassFunction(t){try{var e=n.call(t);return i.test(e)}catch(t){return!1}},s=function tryFunctionToStr(t){try{return!a(t)&&(n.call(t),!0)}catch(t){return!1}},u=Object.prototype.toString,c="function"==typeof Symbol&&!!Symbol.toStringTag,f=!(0 in[,]),l=function isDocumentDotAll(){return!1};if("object"==typeof document){var p=document.all;u.call(p)===u.call(document.all)&&(l=function isDocumentDotAll(t){if((f||!t)&&(void 0===t||"object"==typeof t))try{var e=u.call(t);return("[object HTMLAllCollection]"===e||"[object HTML document.all class]"===e||"[object HTMLCollection]"===e||"[object Object]"===e)&&null==t("")}catch(t){}return!1})}t.exports=o?function isCallable(t){if(l(t))return!0;if(!t)return!1;if("function"!=typeof t&&"object"!=typeof t)return!1;try{o(t,null,e)}catch(t){if(t!==r)return!1}return!a(t)&&s(t)}:function isCallable(t){if(l(t))return!0;if(!t)return!1;if("function"!=typeof t&&"object"!=typeof t)return!1;if(c)return s(t);if(a(t))return!1;var e=u.call(t);return!("[object Function]"!==e&&"[object GeneratorFunction]"!==e&&!/^\[object HTML/.test(e))&&s(t)}},5680(t,e,r){"use strict";var n=r(5767);t.exports=function isTypedArray(t){return!!n(t)}},4634(t){var e={}.toString;t.exports=Array.isArray||function(t){return"[object Array]"==e.call(t)}},5580(t,e,r){var n=r(6110)(r(9325),"DataView");t.exports=n},1549(t,e,r){var n=r(2032),o=r(3862),i=r(6721),a=r(2749),s=r(5749);function Hash(t){var e=-1,r=null==t?0:t.length;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}Hash.prototype.clear=n,Hash.prototype.delete=o,Hash.prototype.get=i,Hash.prototype.has=a,Hash.prototype.set=s,t.exports=Hash},79(t,e,r){var n=r(3702),o=r(80),i=r(4739),a=r(8655),s=r(1175);function ListCache(t){var e=-1,r=null==t?0:t.length;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}ListCache.prototype.clear=n,ListCache.prototype.delete=o,ListCache.prototype.get=i,ListCache.prototype.has=a,ListCache.prototype.set=s,t.exports=ListCache},8223(t,e,r){var n=r(6110)(r(9325),"Map");t.exports=n},3661(t,e,r){var n=r(3040),o=r(7670),i=r(289),a=r(4509),s=r(2949);function MapCache(t){var e=-1,r=null==t?0:t.length;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}MapCache.prototype.clear=n,MapCache.prototype.delete=o,MapCache.prototype.get=i,MapCache.prototype.has=a,MapCache.prototype.set=s,t.exports=MapCache},2804(t,e,r){var n=r(6110)(r(9325),"Promise");t.exports=n},6545(t,e,r){var n=r(6110)(r(9325),"Set");t.exports=n},8859(t,e,r){var n=r(3661),o=r(1380),i=r(1459);function SetCache(t){var e=-1,r=null==t?0:t.length;for(this.__data__=new n;++e<r;)this.add(t[e])}SetCache.prototype.add=SetCache.prototype.push=o,SetCache.prototype.has=i,t.exports=SetCache},7217(t,e,r){var n=r(79),o=r(1420),i=r(938),a=r(3605),s=r(9817),u=r(945);function Stack(t){var e=this.__data__=new n(t);this.size=e.size}Stack.prototype.clear=o,Stack.prototype.delete=i,Stack.prototype.get=a,Stack.prototype.has=s,Stack.prototype.set=u,t.exports=Stack},1873(t,e,r){var n=r(9325).Symbol;t.exports=n},7828(t,e,r){var n=r(9325).Uint8Array;t.exports=n},8303(t,e,r){var n=r(6110)(r(9325),"WeakMap");t.exports=n},9770(t){t.exports=function arrayFilter(t,e){for(var r=-1,n=null==t?0:t.length,o=0,i=[];++r<n;){var a=t[r];e(a,r,t)&&(i[o++]=a)}return i}},695(t,e,r){var n=r(8096),o=r(2428),i=r(6449),a=r(3656),s=r(361),u=r(7167),c=Object.prototype.hasOwnProperty;t.exports=function arrayLikeKeys(t,e){var r=i(t),f=!r&&o(t),l=!r&&!f&&a(t),p=!r&&!f&&!l&&u(t),h=r||f||l||p,d=h?n(t.length,String):[],y=d.length;for(var _ in t)!e&&!c.call(t,_)||h&&("length"==_||l&&("offset"==_||"parent"==_)||p&&("buffer"==_||"byteLength"==_||"byteOffset"==_)||s(_,y))||d.push(_);return d}},4932(t){t.exports=function arrayMap(t,e){for(var r=-1,n=null==t?0:t.length,o=Array(n);++r<n;)o[r]=e(t[r],r,t);return o}},4528(t){t.exports=function arrayPush(t,e){for(var r=-1,n=e.length,o=t.length;++r<n;)t[o+r]=e[r];return t}},882(t){t.exports=function arrayReduce(t,e,r,n){var o=-1,i=null==t?0:t.length;for(n&&i&&(r=t[++o]);++o<i;)r=e(r,t[o],o,t);return r}},4248(t){t.exports=function arraySome(t,e){for(var r=-1,n=null==t?0:t.length;++r<n;)if(e(t[r],r,t))return!0;return!1}},1074(t){t.exports=function asciiToArray(t){return t.split("")}},1733(t){var e=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;t.exports=function asciiWords(t){return t.match(e)||[]}},6547(t,e,r){var n=r(3360),o=r(5288),i=Object.prototype.hasOwnProperty;t.exports=function assignValue(t,e,r){var a=t[e];i.call(t,e)&&o(a,r)&&(void 0!==r||e in t)||n(t,e,r)}},6025(t,e,r){var n=r(5288);t.exports=function assocIndexOf(t,e){for(var r=t.length;r--;)if(n(t[r][0],e))return r;return-1}},3360(t,e,r){var n=r(3243);t.exports=function baseAssignValue(t,e,r){"__proto__"==e&&n?n(t,e,{configurable:!0,enumerable:!0,value:r,writable:!0}):t[e]=r}},909(t,e,r){var n=r(641),o=r(8329)(n);t.exports=o},2523(t){t.exports=function baseFindIndex(t,e,r,n){for(var o=t.length,i=r+(n?1:-1);n?i--:++i<o;)if(e(t[i],i,t))return i;return-1}},6649(t,e,r){var n=r(3221)();t.exports=n},641(t,e,r){var n=r(6649),o=r(5950);t.exports=function baseForOwn(t,e){return t&&n(t,e,o)}},7422(t,e,r){var n=r(1769),o=r(7797);t.exports=function baseGet(t,e){for(var r=0,i=(e=n(e,t)).length;null!=t&&r<i;)t=t[o(e[r++])];return r&&r==i?t:void 0}},2199(t,e,r){var n=r(4528),o=r(6449);t.exports=function baseGetAllKeys(t,e,r){var i=e(t);return o(t)?i:n(i,r(t))}},2552(t,e,r){var n=r(1873),o=r(659),i=r(9350),a=n?n.toStringTag:void 0;t.exports=function baseGetTag(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":a&&a in Object(t)?o(t):i(t)}},8077(t){t.exports=function baseHasIn(t,e){return null!=t&&e in Object(t)}},7534(t,e,r){var n=r(2552),o=r(346);t.exports=function baseIsArguments(t){return o(t)&&"[object Arguments]"==n(t)}},270(t,e,r){var n=r(7068),o=r(346);t.exports=function baseIsEqual(t,e,r,i,a){return t===e||(null==t||null==e||!o(t)&&!o(e)?t!=t&&e!=e:n(t,e,r,i,baseIsEqual,a))}},7068(t,e,r){var n=r(7217),o=r(5911),i=r(1986),a=r(689),s=r(5861),u=r(6449),c=r(3656),f=r(7167),l="[object Arguments]",p="[object Array]",h="[object Object]",d=Object.prototype.hasOwnProperty;t.exports=function baseIsEqualDeep(t,e,r,y,_,g){var m=u(t),v=u(e),b=m?p:s(t),w=v?p:s(e),I=(b=b==l?h:b)==h,x=(w=w==l?h:w)==h,B=b==w;if(B&&c(t)){if(!c(e))return!1;m=!0,I=!1}if(B&&!I)return g||(g=new n),m||f(t)?o(t,e,r,y,_,g):i(t,e,b,r,y,_,g);if(!(1&r)){var k=I&&d.call(t,"__wrapped__"),C=x&&d.call(e,"__wrapped__");if(k||C){var j=k?t.value():t,q=C?e.value():e;return g||(g=new n),_(j,q,r,y,g)}}return!!B&&(g||(g=new n),a(t,e,r,y,_,g))}},1799(t,e,r){var n=r(7217),o=r(270);t.exports=function baseIsMatch(t,e,r,i){var a=r.length,s=a,u=!i;if(null==t)return!s;for(t=Object(t);a--;){var c=r[a];if(u&&c[2]?c[1]!==t[c[0]]:!(c[0]in t))return!1}for(;++a<s;){var f=(c=r[a])[0],l=t[f],p=c[1];if(u&&c[2]){if(void 0===l&&!(f in t))return!1}else{var h=new n;if(i)var d=i(l,p,f,t,e,h);if(!(void 0===d?o(p,l,3,i,h):d))return!1}}return!0}},5083(t,e,r){var n=r(1882),o=r(7296),i=r(3805),a=r(7473),s=/^\[object .+?Constructor\]$/,u=Function.prototype,c=Object.prototype,f=u.toString,l=c.hasOwnProperty,p=RegExp("^"+f.call(l).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");t.exports=function baseIsNative(t){return!(!i(t)||o(t))&&(n(t)?p:s).test(a(t))}},4901(t,e,r){var n=r(2552),o=r(294),i=r(346),a={};a["[object Float32Array]"]=a["[object Float64Array]"]=a["[object Int8Array]"]=a["[object Int16Array]"]=a["[object Int32Array]"]=a["[object Uint8Array]"]=a["[object Uint8ClampedArray]"]=a["[object Uint16Array]"]=a["[object Uint32Array]"]=!0,a["[object Arguments]"]=a["[object Array]"]=a["[object ArrayBuffer]"]=a["[object Boolean]"]=a["[object DataView]"]=a["[object Date]"]=a["[object Error]"]=a["[object Function]"]=a["[object Map]"]=a["[object Number]"]=a["[object Object]"]=a["[object RegExp]"]=a["[object Set]"]=a["[object String]"]=a["[object WeakMap]"]=!1,t.exports=function baseIsTypedArray(t){return i(t)&&o(t.length)&&!!a[n(t)]}},5389(t,e,r){var n=r(3663),o=r(7978),i=r(3488),a=r(6449),s=r(583);t.exports=function baseIteratee(t){return"function"==typeof t?t:null==t?i:"object"==typeof t?a(t)?o(t[0],t[1]):n(t):s(t)}},8984(t,e,r){var n=r(5527),o=r(3650),i=Object.prototype.hasOwnProperty;t.exports=function baseKeys(t){if(!n(t))return o(t);var e=[];for(var r in Object(t))i.call(t,r)&&"constructor"!=r&&e.push(r);return e}},3663(t,e,r){var n=r(1799),o=r(776),i=r(7197);t.exports=function baseMatches(t){var e=o(t);return 1==e.length&&e[0][2]?i(e[0][0],e[0][1]):function(r){return r===t||n(r,t,e)}}},7978(t,e,r){var n=r(270),o=r(8156),i=r(631),a=r(8586),s=r(756),u=r(7197),c=r(7797);t.exports=function baseMatchesProperty(t,e){return a(t)&&s(e)?u(c(t),e):function(r){var a=o(r,t);return void 0===a&&a===e?i(r,t):n(e,a,3)}}},7237(t){t.exports=function baseProperty(t){return function(e){return null==e?void 0:e[t]}}},7255(t,e,r){var n=r(7422);t.exports=function basePropertyDeep(t){return function(e){return n(e,t)}}},4552(t){t.exports=function basePropertyOf(t){return function(e){return null==t?void 0:t[e]}}},5160(t){t.exports=function baseSlice(t,e,r){var n=-1,o=t.length;e<0&&(e=-e>o?0:o+e),(r=r>o?o:r)<0&&(r+=o),o=e>r?0:r-e>>>0,e>>>=0;for(var i=Array(o);++n<o;)i[n]=t[n+e];return i}},916(t,e,r){var n=r(909);t.exports=function baseSome(t,e){var r;return n(t,(function(t,n,o){return!(r=e(t,n,o))})),!!r}},8096(t){t.exports=function baseTimes(t,e){for(var r=-1,n=Array(t);++r<t;)n[r]=e(r);return n}},7556(t,e,r){var n=r(1873),o=r(4932),i=r(6449),a=r(4394),s=n?n.prototype:void 0,u=s?s.toString:void 0;t.exports=function baseToString(t){if("string"==typeof t)return t;if(i(t))return o(t,baseToString)+"";if(a(t))return u?u.call(t):"";var e=t+"";return"0"==e&&1/t==-1/0?"-0":e}},4128(t,e,r){var n=r(1800),o=/^\s+/;t.exports=function baseTrim(t){return t?t.slice(0,n(t)+1).replace(o,""):t}},7301(t){t.exports=function baseUnary(t){return function(e){return t(e)}}},1234(t){t.exports=function baseZipObject(t,e,r){for(var n=-1,o=t.length,i=e.length,a={};++n<o;){var s=n<i?e[n]:void 0;r(a,t[n],s)}return a}},9219(t){t.exports=function cacheHas(t,e){return t.has(e)}},1769(t,e,r){var n=r(6449),o=r(8586),i=r(1802),a=r(3222);t.exports=function castPath(t,e){return n(t)?t:o(t,e)?[t]:i(a(t))}},8754(t,e,r){var n=r(5160);t.exports=function castSlice(t,e,r){var o=t.length;return r=void 0===r?o:r,!e&&r>=o?t:n(t,e,r)}},5481(t,e,r){var n=r(9325)["__core-js_shared__"];t.exports=n},8329(t,e,r){var n=r(4894);t.exports=function createBaseEach(t,e){return function(r,o){if(null==r)return r;if(!n(r))return t(r,o);for(var i=r.length,a=e?i:-1,s=Object(r);(e?a--:++a<i)&&!1!==o(s[a],a,s););return r}}},3221(t){t.exports=function createBaseFor(t){return function(e,r,n){for(var o=-1,i=Object(e),a=n(e),s=a.length;s--;){var u=a[t?s:++o];if(!1===r(i[u],u,i))break}return e}}},2507(t,e,r){var n=r(8754),o=r(9698),i=r(3912),a=r(3222);t.exports=function createCaseFirst(t){return function(e){e=a(e);var r=o(e)?i(e):void 0,s=r?r[0]:e.charAt(0),u=r?n(r,1).join(""):e.slice(1);return s[t]()+u}}},5539(t,e,r){var n=r(882),o=r(828),i=r(6645),a=RegExp("['’]","g");t.exports=function createCompounder(t){return function(e){return n(i(o(e).replace(a,"")),t,"")}}},2006(t,e,r){var n=r(5389),o=r(4894),i=r(5950);t.exports=function createFind(t){return function(e,r,a){var s=Object(e);if(!o(e)){var u=n(r,3);e=i(e),r=function(t){return u(s[t],t,s)}}var c=t(e,r,a);return c>-1?s[u?e[c]:c]:void 0}}},4647(t,e,r){var n=r(4552)({À:"A",Á:"A",Â:"A",Ã:"A",Ä:"A",Å:"A",à:"a",á:"a",â:"a",ã:"a",ä:"a",å:"a",Ç:"C",ç:"c",Ð:"D",ð:"d",È:"E",É:"E",Ê:"E",Ë:"E",è:"e",é:"e",ê:"e",ë:"e",Ì:"I",Í:"I",Î:"I",Ï:"I",ì:"i",í:"i",î:"i",ï:"i",Ñ:"N",ñ:"n",Ò:"O",Ó:"O",Ô:"O",Õ:"O",Ö:"O",Ø:"O",ò:"o",ó:"o",ô:"o",õ:"o",ö:"o",ø:"o",Ù:"U",Ú:"U",Û:"U",Ü:"U",ù:"u",ú:"u",û:"u",ü:"u",Ý:"Y",ý:"y",ÿ:"y",Æ:"Ae",æ:"ae",Þ:"Th",þ:"th",ß:"ss",Ā:"A",Ă:"A",Ą:"A",ā:"a",ă:"a",ą:"a",Ć:"C",Ĉ:"C",Ċ:"C",Č:"C",ć:"c",ĉ:"c",ċ:"c",č:"c",Ď:"D",Đ:"D",ď:"d",đ:"d",Ē:"E",Ĕ:"E",Ė:"E",Ę:"E",Ě:"E",ē:"e",ĕ:"e",ė:"e",ę:"e",ě:"e",Ĝ:"G",Ğ:"G",Ġ:"G",Ģ:"G",ĝ:"g",ğ:"g",ġ:"g",ģ:"g",Ĥ:"H",Ħ:"H",ĥ:"h",ħ:"h",Ĩ:"I",Ī:"I",Ĭ:"I",Į:"I",İ:"I",ĩ:"i",ī:"i",ĭ:"i",į:"i",ı:"i",Ĵ:"J",ĵ:"j",Ķ:"K",ķ:"k",ĸ:"k",Ĺ:"L",Ļ:"L",Ľ:"L",Ŀ:"L",Ł:"L",ĺ:"l",ļ:"l",ľ:"l",ŀ:"l",ł:"l",Ń:"N",Ņ:"N",Ň:"N",Ŋ:"N",ń:"n",ņ:"n",ň:"n",ŋ:"n",Ō:"O",Ŏ:"O",Ő:"O",ō:"o",ŏ:"o",ő:"o",Ŕ:"R",Ŗ:"R",Ř:"R",ŕ:"r",ŗ:"r",ř:"r",Ś:"S",Ŝ:"S",Ş:"S",Š:"S",ś:"s",ŝ:"s",ş:"s",š:"s",Ţ:"T",Ť:"T",Ŧ:"T",ţ:"t",ť:"t",ŧ:"t",Ũ:"U",Ū:"U",Ŭ:"U",Ů:"U",Ű:"U",Ų:"U",ũ:"u",ū:"u",ŭ:"u",ů:"u",ű:"u",ų:"u",Ŵ:"W",ŵ:"w",Ŷ:"Y",ŷ:"y",Ÿ:"Y",Ź:"Z",Ż:"Z",Ž:"Z",ź:"z",ż:"z",ž:"z",Ĳ:"IJ",ĳ:"ij",Œ:"Oe",œ:"oe",ŉ:"'n",ſ:"s"});t.exports=n},3243(t,e,r){var n=r(6110),o=function(){try{var t=n(Object,"defineProperty");return t({},"",{}),t}catch(t){}}();t.exports=o},5911(t,e,r){var n=r(8859),o=r(4248),i=r(9219);t.exports=function equalArrays(t,e,r,a,s,u){var c=1&r,f=t.length,l=e.length;if(f!=l&&!(c&&l>f))return!1;var p=u.get(t),h=u.get(e);if(p&&h)return p==e&&h==t;var d=-1,y=!0,_=2&r?new n:void 0;for(u.set(t,e),u.set(e,t);++d<f;){var g=t[d],m=e[d];if(a)var v=c?a(m,g,d,e,t,u):a(g,m,d,t,e,u);if(void 0!==v){if(v)continue;y=!1;break}if(_){if(!o(e,(function(t,e){if(!i(_,e)&&(g===t||s(g,t,r,a,u)))return _.push(e)}))){y=!1;break}}else if(g!==m&&!s(g,m,r,a,u)){y=!1;break}}return u.delete(t),u.delete(e),y}},1986(t,e,r){var n=r(1873),o=r(7828),i=r(5288),a=r(5911),s=r(317),u=r(4247),c=n?n.prototype:void 0,f=c?c.valueOf:void 0;t.exports=function equalByTag(t,e,r,n,c,l,p){switch(r){case"[object DataView]":if(t.byteLength!=e.byteLength||t.byteOffset!=e.byteOffset)return!1;t=t.buffer,e=e.buffer;case"[object ArrayBuffer]":return!(t.byteLength!=e.byteLength||!l(new o(t),new o(e)));case"[object Boolean]":case"[object Date]":case"[object Number]":return i(+t,+e);case"[object Error]":return t.name==e.name&&t.message==e.message;case"[object RegExp]":case"[object String]":return t==e+"";case"[object Map]":var h=s;case"[object Set]":var d=1&n;if(h||(h=u),t.size!=e.size&&!d)return!1;var y=p.get(t);if(y)return y==e;n|=2,p.set(t,e);var _=a(h(t),h(e),n,c,l,p);return p.delete(t),_;case"[object Symbol]":if(f)return f.call(t)==f.call(e)}return!1}},689(t,e,r){var n=r(2),o=Object.prototype.hasOwnProperty;t.exports=function equalObjects(t,e,r,i,a,s){var u=1&r,c=n(t),f=c.length;if(f!=n(e).length&&!u)return!1;for(var l=f;l--;){var p=c[l];if(!(u?p in e:o.call(e,p)))return!1}var h=s.get(t),d=s.get(e);if(h&&d)return h==e&&d==t;var y=!0;s.set(t,e),s.set(e,t);for(var _=u;++l<f;){var g=t[p=c[l]],m=e[p];if(i)var v=u?i(m,g,p,e,t,s):i(g,m,p,t,e,s);if(!(void 0===v?g===m||a(g,m,r,i,s):v)){y=!1;break}_||(_="constructor"==p)}if(y&&!_){var b=t.constructor,w=e.constructor;b==w||!("constructor"in t)||!("constructor"in e)||"function"==typeof b&&b instanceof b&&"function"==typeof w&&w instanceof w||(y=!1)}return s.delete(t),s.delete(e),y}},4840(t,e,r){var n="object"==typeof r.g&&r.g&&r.g.Object===Object&&r.g;t.exports=n},2(t,e,r){var n=r(2199),o=r(4664),i=r(5950);t.exports=function getAllKeys(t){return n(t,i,o)}},2651(t,e,r){var n=r(4218);t.exports=function getMapData(t,e){var r=t.__data__;return n(e)?r["string"==typeof e?"string":"hash"]:r.map}},776(t,e,r){var n=r(756),o=r(5950);t.exports=function getMatchData(t){for(var e=o(t),r=e.length;r--;){var i=e[r],a=t[i];e[r]=[i,a,n(a)]}return e}},6110(t,e,r){var n=r(5083),o=r(392);t.exports=function getNative(t,e){var r=o(t,e);return n(r)?r:void 0}},659(t,e,r){var n=r(1873),o=Object.prototype,i=o.hasOwnProperty,a=o.toString,s=n?n.toStringTag:void 0;t.exports=function getRawTag(t){var e=i.call(t,s),r=t[s];try{t[s]=void 0;var n=!0}catch(t){}var o=a.call(t);return n&&(e?t[s]=r:delete t[s]),o}},4664(t,e,r){var n=r(9770),o=r(3345),i=Object.prototype.propertyIsEnumerable,a=Object.getOwnPropertySymbols,s=a?function(t){return null==t?[]:(t=Object(t),n(a(t),(function(e){return i.call(t,e)})))}:o;t.exports=s},5861(t,e,r){var n=r(5580),o=r(8223),i=r(2804),a=r(6545),s=r(8303),u=r(2552),c=r(7473),f="[object Map]",l="[object Promise]",p="[object Set]",h="[object WeakMap]",d="[object DataView]",y=c(n),_=c(o),g=c(i),m=c(a),v=c(s),b=u;(n&&b(new n(new ArrayBuffer(1)))!=d||o&&b(new o)!=f||i&&b(i.resolve())!=l||a&&b(new a)!=p||s&&b(new s)!=h)&&(b=function(t){var e=u(t),r="[object Object]"==e?t.constructor:void 0,n=r?c(r):"";if(n)switch(n){case y:return d;case _:return f;case g:return l;case m:return p;case v:return h}return e}),t.exports=b},392(t){t.exports=function getValue(t,e){return null==t?void 0:t[e]}},9326(t,e,r){var n=r(1769),o=r(2428),i=r(6449),a=r(361),s=r(294),u=r(7797);t.exports=function hasPath(t,e,r){for(var c=-1,f=(e=n(e,t)).length,l=!1;++c<f;){var p=u(e[c]);if(!(l=null!=t&&r(t,p)))break;t=t[p]}return l||++c!=f?l:!!(f=null==t?0:t.length)&&s(f)&&a(p,f)&&(i(t)||o(t))}},9698(t){var e=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");t.exports=function hasUnicode(t){return e.test(t)}},5434(t){var e=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;t.exports=function hasUnicodeWord(t){return e.test(t)}},2032(t,e,r){var n=r(1042);t.exports=function hashClear(){this.__data__=n?n(null):{},this.size=0}},3862(t){t.exports=function hashDelete(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e}},6721(t,e,r){var n=r(1042),o=Object.prototype.hasOwnProperty;t.exports=function hashGet(t){var e=this.__data__;if(n){var r=e[t];return"__lodash_hash_undefined__"===r?void 0:r}return o.call(e,t)?e[t]:void 0}},2749(t,e,r){var n=r(1042),o=Object.prototype.hasOwnProperty;t.exports=function hashHas(t){var e=this.__data__;return n?void 0!==e[t]:o.call(e,t)}},5749(t,e,r){var n=r(1042);t.exports=function hashSet(t,e){var r=this.__data__;return this.size+=this.has(t)?0:1,r[t]=n&&void 0===e?"__lodash_hash_undefined__":e,this}},361(t){var e=/^(?:0|[1-9]\d*)$/;t.exports=function isIndex(t,r){var n=typeof t;return!!(r=null==r?9007199254740991:r)&&("number"==n||"symbol"!=n&&e.test(t))&&t>-1&&t%1==0&&t<r}},6800(t,e,r){var n=r(5288),o=r(4894),i=r(361),a=r(3805);t.exports=function isIterateeCall(t,e,r){if(!a(r))return!1;var s=typeof e;return!!("number"==s?o(r)&&i(e,r.length):"string"==s&&e in r)&&n(r[e],t)}},8586(t,e,r){var n=r(6449),o=r(4394),i=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,a=/^\w*$/;t.exports=function isKey(t,e){if(n(t))return!1;var r=typeof t;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=t&&!o(t))||(a.test(t)||!i.test(t)||null!=e&&t in Object(e))}},4218(t){t.exports=function isKeyable(t){var e=typeof t;return"string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t}},7296(t,e,r){var n,o=r(5481),i=(n=/[^.]+$/.exec(o&&o.keys&&o.keys.IE_PROTO||""))?"Symbol(src)_1."+n:"";t.exports=function isMasked(t){return!!i&&i in t}},5527(t){var e=Object.prototype;t.exports=function isPrototype(t){var r=t&&t.constructor;return t===("function"==typeof r&&r.prototype||e)}},756(t,e,r){var n=r(3805);t.exports=function isStrictComparable(t){return t==t&&!n(t)}},3702(t){t.exports=function listCacheClear(){this.__data__=[],this.size=0}},80(t,e,r){var n=r(6025),o=Array.prototype.splice;t.exports=function listCacheDelete(t){var e=this.__data__,r=n(e,t);return!(r<0)&&(r==e.length-1?e.pop():o.call(e,r,1),--this.size,!0)}},4739(t,e,r){var n=r(6025);t.exports=function listCacheGet(t){var e=this.__data__,r=n(e,t);return r<0?void 0:e[r][1]}},8655(t,e,r){var n=r(6025);t.exports=function listCacheHas(t){return n(this.__data__,t)>-1}},1175(t,e,r){var n=r(6025);t.exports=function listCacheSet(t,e){var r=this.__data__,o=n(r,t);return o<0?(++this.size,r.push([t,e])):r[o][1]=e,this}},3040(t,e,r){var n=r(1549),o=r(79),i=r(8223);t.exports=function mapCacheClear(){this.size=0,this.__data__={hash:new n,map:new(i||o),string:new n}}},7670(t,e,r){var n=r(2651);t.exports=function mapCacheDelete(t){var e=n(this,t).delete(t);return this.size-=e?1:0,e}},289(t,e,r){var n=r(2651);t.exports=function mapCacheGet(t){return n(this,t).get(t)}},4509(t,e,r){var n=r(2651);t.exports=function mapCacheHas(t){return n(this,t).has(t)}},2949(t,e,r){var n=r(2651);t.exports=function mapCacheSet(t,e){var r=n(this,t),o=r.size;return r.set(t,e),this.size+=r.size==o?0:1,this}},317(t){t.exports=function mapToArray(t){var e=-1,r=Array(t.size);return t.forEach((function(t,n){r[++e]=[n,t]})),r}},7197(t){t.exports=function matchesStrictComparable(t,e){return function(r){return null!=r&&(r[t]===e&&(void 0!==e||t in Object(r)))}}},2224(t,e,r){var n=r(104);t.exports=function memoizeCapped(t){var e=n(t,(function(t){return 500===r.size&&r.clear(),t})),r=e.cache;return e}},1042(t,e,r){var n=r(6110)(Object,"create");t.exports=n},3650(t,e,r){var n=r(4335)(Object.keys,Object);t.exports=n},6009(t,e,r){t=r.nmd(t);var n=r(4840),o=e&&!e.nodeType&&e,i=o&&t&&!t.nodeType&&t,a=i&&i.exports===o&&n.process,s=function(){try{var t=i&&i.require&&i.require("util").types;return t||a&&a.binding&&a.binding("util")}catch(t){}}();t.exports=s},9350(t){var e=Object.prototype.toString;t.exports=function objectToString(t){return e.call(t)}},4335(t){t.exports=function overArg(t,e){return function(r){return t(e(r))}}},9325(t,e,r){var n=r(4840),o="object"==typeof self&&self&&self.Object===Object&&self,i=n||o||Function("return this")();t.exports=i},1380(t){t.exports=function setCacheAdd(t){return this.__data__.set(t,"__lodash_hash_undefined__"),this}},1459(t){t.exports=function setCacheHas(t){return this.__data__.has(t)}},4247(t){t.exports=function setToArray(t){var e=-1,r=Array(t.size);return t.forEach((function(t){r[++e]=t})),r}},1420(t,e,r){var n=r(79);t.exports=function stackClear(){this.__data__=new n,this.size=0}},938(t){t.exports=function stackDelete(t){var e=this.__data__,r=e.delete(t);return this.size=e.size,r}},3605(t){t.exports=function stackGet(t){return this.__data__.get(t)}},9817(t){t.exports=function stackHas(t){return this.__data__.has(t)}},945(t,e,r){var n=r(79),o=r(8223),i=r(3661);t.exports=function stackSet(t,e){var r=this.__data__;if(r instanceof n){var a=r.__data__;if(!o||a.length<199)return a.push([t,e]),this.size=++r.size,this;r=this.__data__=new i(a)}return r.set(t,e),this.size=r.size,this}},3912(t,e,r){var n=r(1074),o=r(9698),i=r(2054);t.exports=function stringToArray(t){return o(t)?i(t):n(t)}},1802(t,e,r){var n=r(2224),o=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,i=/\\(\\)?/g,a=n((function(t){var e=[];return 46===t.charCodeAt(0)&&e.push(""),t.replace(o,(function(t,r,n,o){e.push(n?o.replace(i,"$1"):r||t)})),e}));t.exports=a},7797(t,e,r){var n=r(4394);t.exports=function toKey(t){if("string"==typeof t||n(t))return t;var e=t+"";return"0"==e&&1/t==-1/0?"-0":e}},7473(t){var e=Function.prototype.toString;t.exports=function toSource(t){if(null!=t){try{return e.call(t)}catch(t){}try{return t+""}catch(t){}}return""}},1800(t){var e=/\s/;t.exports=function trimmedEndIndex(t){for(var r=t.length;r--&&e.test(t.charAt(r)););return r}},2054(t){var e="\\ud800-\\udfff",r="["+e+"]",n="[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",o="\\ud83c[\\udffb-\\udfff]",i="[^"+e+"]",a="(?:\\ud83c[\\udde6-\\uddff]){2}",s="[\\ud800-\\udbff][\\udc00-\\udfff]",u="(?:"+n+"|"+o+")"+"?",c="[\\ufe0e\\ufe0f]?",f=c+u+("(?:\\u200d(?:"+[i,a,s].join("|")+")"+c+u+")*"),l="(?:"+[i+n+"?",n,a,s,r].join("|")+")",p=RegExp(o+"(?="+o+")|"+l+f,"g");t.exports=function unicodeToArray(t){return t.match(p)||[]}},2225(t){var e="\\ud800-\\udfff",r="\\u2700-\\u27bf",n="a-z\\xdf-\\xf6\\xf8-\\xff",o="A-Z\\xc0-\\xd6\\xd8-\\xde",i="\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",a="["+i+"]",s="\\d+",u="["+r+"]",c="["+n+"]",f="[^"+e+i+s+r+n+o+"]",l="(?:\\ud83c[\\udde6-\\uddff]){2}",p="[\\ud800-\\udbff][\\udc00-\\udfff]",h="["+o+"]",d="(?:"+c+"|"+f+")",y="(?:"+h+"|"+f+")",_="(?:['’](?:d|ll|m|re|s|t|ve))?",g="(?:['’](?:D|LL|M|RE|S|T|VE))?",m="(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?",v="[\\ufe0e\\ufe0f]?",b=v+m+("(?:\\u200d(?:"+["[^"+e+"]",l,p].join("|")+")"+v+m+")*"),w="(?:"+[u,l,p].join("|")+")"+b,I=RegExp([h+"?"+c+"+"+_+"(?="+[a,h,"$"].join("|")+")",y+"+"+g+"(?="+[a,h+d,"$"].join("|")+")",h+"?"+d+"+"+_,h+"+"+g,"\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])","\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",s,w].join("|"),"g");t.exports=function unicodeWords(t){return t.match(I)||[]}},4058(t,e,r){var n=r(4792),o=r(5539)((function(t,e,r){return e=e.toLowerCase(),t+(r?n(e):e)}));t.exports=o},4792(t,e,r){var n=r(3222),o=r(5808);t.exports=function capitalize(t){return o(n(t).toLowerCase())}},828(t,e,r){var n=r(4647),o=r(3222),i=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,a=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g");t.exports=function deburr(t){return(t=o(t))&&t.replace(i,n).replace(a,"")}},5288(t){t.exports=function eq(t,e){return t===e||t!=t&&e!=e}},7309(t,e,r){var n=r(2006)(r(4713));t.exports=n},4713(t,e,r){var n=r(2523),o=r(5389),i=r(1489),a=Math.max;t.exports=function findIndex(t,e,r){var s=null==t?0:t.length;if(!s)return-1;var u=null==r?0:i(r);return u<0&&(u=a(s+u,0)),n(t,o(e,3),u)}},8156(t,e,r){var n=r(7422);t.exports=function get(t,e,r){var o=null==t?void 0:n(t,e);return void 0===o?r:o}},631(t,e,r){var n=r(8077),o=r(9326);t.exports=function hasIn(t,e){return null!=t&&o(t,e,n)}},3488(t){t.exports=function identity(t){return t}},2428(t,e,r){var n=r(7534),o=r(346),i=Object.prototype,a=i.hasOwnProperty,s=i.propertyIsEnumerable,u=n(function(){return arguments}())?n:function(t){return o(t)&&a.call(t,"callee")&&!s.call(t,"callee")};t.exports=u},6449(t){var e=Array.isArray;t.exports=e},4894(t,e,r){var n=r(1882),o=r(294);t.exports=function isArrayLike(t){return null!=t&&o(t.length)&&!n(t)}},3656(t,e,r){t=r.nmd(t);var n=r(9325),o=r(9935),i=e&&!e.nodeType&&e,a=i&&t&&!t.nodeType&&t,s=a&&a.exports===i?n.Buffer:void 0,u=(s?s.isBuffer:void 0)||o;t.exports=u},1882(t,e,r){var n=r(2552),o=r(3805);t.exports=function isFunction(t){if(!o(t))return!1;var e=n(t);return"[object Function]"==e||"[object GeneratorFunction]"==e||"[object AsyncFunction]"==e||"[object Proxy]"==e}},294(t){t.exports=function isLength(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=9007199254740991}},3805(t){t.exports=function isObject(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}},346(t){t.exports=function isObjectLike(t){return null!=t&&"object"==typeof t}},4394(t,e,r){var n=r(2552),o=r(346);t.exports=function isSymbol(t){return"symbol"==typeof t||o(t)&&"[object Symbol]"==n(t)}},7167(t,e,r){var n=r(4901),o=r(7301),i=r(6009),a=i&&i.isTypedArray,s=a?o(a):n;t.exports=s},5950(t,e,r){var n=r(695),o=r(8984),i=r(4894);t.exports=function keys(t){return i(t)?n(t):o(t)}},104(t,e,r){var n=r(3661);function memoize(t,e){if("function"!=typeof t||null!=e&&"function"!=typeof e)throw new TypeError("Expected a function");var memoized=function(){var r=arguments,n=e?e.apply(this,r):r[0],o=memoized.cache;if(o.has(n))return o.get(n);var i=t.apply(this,r);return memoized.cache=o.set(n,i)||o,i};return memoized.cache=new(memoize.Cache||n),memoized}memoize.Cache=n,t.exports=memoize},583(t,e,r){var n=r(7237),o=r(7255),i=r(8586),a=r(7797);t.exports=function property(t){return i(t)?n(a(t)):o(t)}},2426(t,e,r){var n=r(4248),o=r(5389),i=r(916),a=r(6449),s=r(6800);t.exports=function some(t,e,r){var u=a(t)?n:i;return r&&s(t,e,r)&&(e=void 0),u(t,o(e,3))}},3345(t){t.exports=function stubArray(){return[]}},9935(t){t.exports=function stubFalse(){return!1}},7400(t,e,r){var n=r(9374),o=1/0;t.exports=function toFinite(t){return t?(t=n(t))===o||t===-1/0?17976931348623157e292*(t<0?-1:1):t==t?t:0:0===t?t:0}},1489(t,e,r){var n=r(7400);t.exports=function toInteger(t){var e=n(t),r=e%1;return e==e?r?e-r:e:0}},9374(t,e,r){var n=r(4128),o=r(3805),i=r(4394),a=/^[-+]0x[0-9a-f]+$/i,s=/^0b[01]+$/i,u=/^0o[0-7]+$/i,c=parseInt;t.exports=function toNumber(t){if("number"==typeof t)return t;if(i(t))return NaN;if(o(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=o(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=n(t);var r=s.test(t);return r||u.test(t)?c(t.slice(2),r?2:8):a.test(t)?NaN:+t}},3222(t,e,r){var n=r(7556);t.exports=function toString(t){return null==t?"":n(t)}},5808(t,e,r){var n=r(2507)("toUpperCase");t.exports=n},6645(t,e,r){var n=r(1733),o=r(5434),i=r(3222),a=r(2225);t.exports=function words(t,e,r){return t=i(t),void 0===(e=r?void 0:e)?o(t)?a(t):n(t):t.match(e)||[]}},7248(t,e,r){var n=r(6547),o=r(1234);t.exports=function zipObject(t,e){return o(t||[],e||[],n)}},1514(t){"use strict";t.exports=Math.abs},8968(t){"use strict";t.exports=Math.floor},4459(t){"use strict";t.exports=Number.isNaN||function isNaN(t){return t!=t}},6188(t){"use strict";t.exports=Math.max},8002(t){"use strict";t.exports=Math.min},5880(t){"use strict";t.exports=Math.pow},414(t){"use strict";t.exports=Math.round},3093(t,e,r){"use strict";var n=r(4459);t.exports=function sign(t){return n(t)||0===t?t:t<0?-1:1}},6578(t){"use strict";t.exports=["Float16Array","Float32Array","Float64Array","Int8Array","Int16Array","Int32Array","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","BigInt64Array","BigUint64Array"]},5606(t){var e,r,n=t.exports={};function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}function runTimeout(t){if(e===setTimeout)return setTimeout(t,0);if((e===defaultSetTimout||!e)&&setTimeout)return e=setTimeout,setTimeout(t,0);try{return e(t,0)}catch(r){try{return e.call(null,t,0)}catch(r){return e.call(this,t,0)}}}!function(){try{e="function"==typeof setTimeout?setTimeout:defaultSetTimout}catch(t){e=defaultSetTimout}try{r="function"==typeof clearTimeout?clearTimeout:defaultClearTimeout}catch(t){r=defaultClearTimeout}}();var o,i=[],a=!1,s=-1;function cleanUpNextTick(){a&&o&&(a=!1,o.length?i=o.concat(i):s=-1,i.length&&drainQueue())}function drainQueue(){if(!a){var t=runTimeout(cleanUpNextTick);a=!0;for(var e=i.length;e;){for(o=i,i=[];++s<e;)o&&o[s].run();s=-1,e=i.length}o=null,a=!1,function runClearTimeout(t){if(r===clearTimeout)return clearTimeout(t);if((r===defaultClearTimeout||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(t);try{return r(t)}catch(e){try{return r.call(null,t)}catch(e){return r.call(this,t)}}}(t)}}function Item(t,e){this.fun=t,this.array=e}function noop(){}n.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var r=1;r<arguments.length;r++)e[r-1]=arguments[r];i.push(new Item(t,e)),1!==i.length||a||runTimeout(drainQueue)},Item.prototype.run=function(){this.fun.apply(null,this.array)},n.title="browser",n.browser=!0,n.env={},n.argv=[],n.version="",n.versions={},n.on=noop,n.addListener=noop,n.once=noop,n.off=noop,n.removeListener=noop,n.removeAllListeners=noop,n.emit=noop,n.prependListener=noop,n.prependOnceListener=noop,n.listeners=function(t){return[]},n.binding=function(t){throw new Error("process.binding is not supported")},n.cwd=function(){return"/"},n.chdir=function(t){throw new Error("process.chdir is not supported")},n.umask=function(){return 0}},3209(t,e,r){"use strict";var n=r(5606),o=65536,i=4294967295;var a=r(2861).Buffer,s=r.g.crypto||r.g.msCrypto;s&&s.getRandomValues?t.exports=function randomBytes(t,e){if(t>i)throw new RangeError("requested too many random bytes");var r=a.allocUnsafe(t);if(t>0)if(t>o)for(var u=0;u<t;u+=o)s.getRandomValues(r.slice(u,u+o));else s.getRandomValues(r);if("function"==typeof e)return n.nextTick((function(){e(null,r)}));return r}:t.exports=function oldBrowser(){throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11")}},5287(t,e){"use strict";var r=Symbol.for("react.element"),n=Symbol.for("react.portal"),o=Symbol.for("react.fragment"),i=Symbol.for("react.strict_mode"),a=Symbol.for("react.profiler"),s=Symbol.for("react.provider"),u=Symbol.for("react.context"),c=Symbol.for("react.forward_ref"),f=Symbol.for("react.suspense"),l=Symbol.for("react.memo"),p=Symbol.for("react.lazy"),h=Symbol.iterator;var d={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},y=Object.assign,_={};function E(t,e,r){this.props=t,this.context=e,this.refs=_,this.updater=r||d}function F(){}function G(t,e,r){this.props=t,this.context=e,this.refs=_,this.updater=r||d}E.prototype.isReactComponent={},E.prototype.setState=function(t,e){if("object"!=typeof t&&"function"!=typeof t&&null!=t)throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,t,e,"setState")},E.prototype.forceUpdate=function(t){this.updater.enqueueForceUpdate(this,t,"forceUpdate")},F.prototype=E.prototype;var g=G.prototype=new F;g.constructor=G,y(g,E.prototype),g.isPureReactComponent=!0;var m=Array.isArray,v=Object.prototype.hasOwnProperty,b={current:null},w={key:!0,ref:!0,__self:!0,__source:!0};function M(t,e,n){var o,i={},a=null,s=null;if(null!=e)for(o in void 0!==e.ref&&(s=e.ref),void 0!==e.key&&(a=""+e.key),e)v.call(e,o)&&!w.hasOwnProperty(o)&&(i[o]=e[o]);var u=arguments.length-2;if(1===u)i.children=n;else if(1<u){for(var c=Array(u),f=0;f<u;f++)c[f]=arguments[f+2];i.children=c}if(t&&t.defaultProps)for(o in u=t.defaultProps)void 0===i[o]&&(i[o]=u[o]);return{$$typeof:r,type:t,key:a,ref:s,props:i,_owner:b.current}}function O(t){return"object"==typeof t&&null!==t&&t.$$typeof===r}var I=/\/+/g;function Q(t,e){return"object"==typeof t&&null!==t&&null!=t.key?function escape(t){var e={"=":"=0",":":"=2"};return"$"+t.replace(/[=:]/g,(function(t){return e[t]}))}(""+t.key):e.toString(36)}function R(t,e,o,i,a){var s=typeof t;"undefined"!==s&&"boolean"!==s||(t=null);var u=!1;if(null===t)u=!0;else switch(s){case"string":case"number":u=!0;break;case"object":switch(t.$$typeof){case r:case n:u=!0}}if(u)return a=a(u=t),t=""===i?"."+Q(u,0):i,m(a)?(o="",null!=t&&(o=t.replace(I,"$&/")+"/"),R(a,e,o,"",(function(t){return t}))):null!=a&&(O(a)&&(a=function N(t,e){return{$$typeof:r,type:t.type,key:e,ref:t.ref,props:t.props,_owner:t._owner}}(a,o+(!a.key||u&&u.key===a.key?"":(""+a.key).replace(I,"$&/")+"/")+t)),e.push(a)),1;if(u=0,i=""===i?".":i+":",m(t))for(var c=0;c<t.length;c++){var f=i+Q(s=t[c],c);u+=R(s,e,o,f,a)}else if(f=function A(t){return null===t||"object"!=typeof t?null:"function"==typeof(t=h&&t[h]||t["@@iterator"])?t:null}(t),"function"==typeof f)for(t=f.call(t),c=0;!(s=t.next()).done;)u+=R(s=s.value,e,o,f=i+Q(s,c++),a);else if("object"===s)throw e=String(t),Error("Objects are not valid as a React child (found: "+("[object Object]"===e?"object with keys {"+Object.keys(t).join(", ")+"}":e)+"). If you meant to render a collection of children, use an array instead.");return u}function S(t,e,r){if(null==t)return t;var n=[],o=0;return R(t,n,"","",(function(t){return e.call(r,t,o++)})),n}function T(t){if(-1===t._status){var e=t._result;(e=e()).then((function(e){0!==t._status&&-1!==t._status||(t._status=1,t._result=e)}),(function(e){0!==t._status&&-1!==t._status||(t._status=2,t._result=e)})),-1===t._status&&(t._status=0,t._result=e)}if(1===t._status)return t._result.default;throw t._result}var x={current:null},B={transition:null},k={ReactCurrentDispatcher:x,ReactCurrentBatchConfig:B,ReactCurrentOwner:b};function X(){throw Error("act(...) is not supported in production builds of React.")}e.Children={map:S,forEach:function(t,e,r){S(t,(function(){e.apply(this,arguments)}),r)},count:function(t){var e=0;return S(t,(function(){e++})),e},toArray:function(t){return S(t,(function(t){return t}))||[]},only:function(t){if(!O(t))throw Error("React.Children.only expected to receive a single React element child.");return t}},e.Component=E,e.Fragment=o,e.Profiler=a,e.PureComponent=G,e.StrictMode=i,e.Suspense=f,e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=k,e.act=X,e.cloneElement=function(t,e,n){if(null==t)throw Error("React.cloneElement(...): The argument must be a React element, but you passed "+t+".");var o=y({},t.props),i=t.key,a=t.ref,s=t._owner;if(null!=e){if(void 0!==e.ref&&(a=e.ref,s=b.current),void 0!==e.key&&(i=""+e.key),t.type&&t.type.defaultProps)var u=t.type.defaultProps;for(c in e)v.call(e,c)&&!w.hasOwnProperty(c)&&(o[c]=void 0===e[c]&&void 0!==u?u[c]:e[c])}var c=arguments.length-2;if(1===c)o.children=n;else if(1<c){u=Array(c);for(var f=0;f<c;f++)u[f]=arguments[f+2];o.children=u}return{$$typeof:r,type:t.type,key:i,ref:a,props:o,_owner:s}},e.createContext=function(t){return(t={$$typeof:u,_currentValue:t,_currentValue2:t,_threadCount:0,Provider:null,Consumer:null,_defaultValue:null,_globalName:null}).Provider={$$typeof:s,_context:t},t.Consumer=t},e.createElement=M,e.createFactory=function(t){var e=M.bind(null,t);return e.type=t,e},e.createRef=function(){return{current:null}},e.forwardRef=function(t){return{$$typeof:c,render:t}},e.isValidElement=O,e.lazy=function(t){return{$$typeof:p,_payload:{_status:-1,_result:t},_init:T}},e.memo=function(t,e){return{$$typeof:l,type:t,compare:void 0===e?null:e}},e.startTransition=function(t){var e=B.transition;B.transition={};try{t()}finally{B.transition=e}},e.unstable_act=X,e.useCallback=function(t,e){return x.current.useCallback(t,e)},e.useContext=function(t){return x.current.useContext(t)},e.useDebugValue=function(){},e.useDeferredValue=function(t){return x.current.useDeferredValue(t)},e.useEffect=function(t,e){return x.current.useEffect(t,e)},e.useId=function(){return x.current.useId()},e.useImperativeHandle=function(t,e,r){return x.current.useImperativeHandle(t,e,r)},e.useInsertionEffect=function(t,e){return x.current.useInsertionEffect(t,e)},e.useLayoutEffect=function(t,e){return x.current.useLayoutEffect(t,e)},e.useMemo=function(t,e){return x.current.useMemo(t,e)},e.useReducer=function(t,e,r){return x.current.useReducer(t,e,r)},e.useRef=function(t){return x.current.useRef(t)},e.useState=function(t){return x.current.useState(t)},e.useSyncExternalStore=function(t,e,r){return x.current.useSyncExternalStore(t,e,r)},e.useTransition=function(){return x.current.useTransition()},e.version="18.3.1"},6540(t,e,r){"use strict";t.exports=r(5287)},2861(t,e,r){var n=r(8287),o=n.Buffer;function copyProps(t,e){for(var r in t)e[r]=t[r]}function SafeBuffer(t,e,r){return o(t,e,r)}o.from&&o.alloc&&o.allocUnsafe&&o.allocUnsafeSlow?t.exports=n:(copyProps(n,e),e.Buffer=SafeBuffer),SafeBuffer.prototype=Object.create(o.prototype),copyProps(o,SafeBuffer),SafeBuffer.from=function(t,e,r){if("number"==typeof t)throw new TypeError("Argument must not be a number");return o(t,e,r)},SafeBuffer.alloc=function(t,e,r){if("number"!=typeof t)throw new TypeError("Argument must be a number");var n=o(t);return void 0!==e?"string"==typeof r?n.fill(e,r):n.fill(e):n.fill(0),n},SafeBuffer.allocUnsafe=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return o(t)},SafeBuffer.allocUnsafeSlow=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return n.SlowBuffer(t)}},6897(t,e,r){"use strict";var n=r(453),o=r(41),i=r(592)(),a=r(5795),s=r(9675),u=n("%Math.floor%");t.exports=function setFunctionLength(t,e){if("function"!=typeof t)throw new s("`fn` is not a function");if("number"!=typeof e||e<0||e>4294967295||u(e)!==e)throw new s("`length` must be a positive 32-bit integer");var r=arguments.length>2&&!!arguments[2],n=!0,c=!0;if("length"in t&&a){var f=a(t,"length");f&&!f.configurable&&(n=!1),f&&!f.writable&&(c=!1)}return(n||c||!r)&&(i?o(t,"length",e,!0,!0):o(t,"length",e)),t}},8011(t,e,r){"use strict";var n=r(2861).Buffer,o=r(5377);function Hash(t,e){this._block=n.alloc(t),this._finalSize=e,this._blockSize=t,this._len=0}Hash.prototype.update=function(t,e){t=o(t,e||"utf8");for(var r=this._block,n=this._blockSize,i=t.length,a=this._len,s=0;s<i;){for(var u=a%n,c=Math.min(i-s,n-u),f=0;f<c;f++)r[u+f]=t[s+f];s+=c,(a+=c)%n==0&&this._update(r)}return this._len+=i,this},Hash.prototype.digest=function(t){var e=this._len%this._blockSize;this._block[e]=128,this._block.fill(0,e+1),e>=this._finalSize&&(this._update(this._block),this._block.fill(0));var r=8*this._len;if(r<=4294967295)this._block.writeUInt32BE(r,this._blockSize-4);else{var n=(4294967295&r)>>>0,o=(r-n)/4294967296;this._block.writeUInt32BE(o,this._blockSize-8),this._block.writeUInt32BE(n,this._blockSize-4)}this._update(this._block);var i=this._hash();return t?i.toString(t):i},Hash.prototype._update=function(){throw new Error("_update must be implemented by subclass")},t.exports=Hash},2802(t,e,r){"use strict";t.exports=function SHA(e){var r=e.toLowerCase(),n=t.exports[r];if(!n)throw new Error(r+" is not supported (we accept pull requests)");return new n},t.exports.sha=r(7816),t.exports.sha1=r(3737),t.exports.sha224=r(6710),t.exports.sha256=r(4107),t.exports.sha384=r(2827),t.exports.sha512=r(2890)},7816(t,e,r){"use strict";var n=r(6698),o=r(8011),i=r(2861).Buffer,a=[1518500249,1859775393,-1894007588,-899497514],s=new Array(80);function Sha(){this.init(),this._w=s,o.call(this,64,56)}function rotl30(t){return t<<30|t>>>2}function ft(t,e,r,n){return 0===t?e&r|~e&n:2===t?e&r|e&n|r&n:e^r^n}n(Sha,o),Sha.prototype.init=function(){return this._a=1732584193,this._b=4023233417,this._c=2562383102,this._d=271733878,this._e=3285377520,this},Sha.prototype._update=function(t){for(var e,r=this._w,n=0|this._a,o=0|this._b,i=0|this._c,s=0|this._d,u=0|this._e,c=0;c<16;++c)r[c]=t.readInt32BE(4*c);for(;c<80;++c)r[c]=r[c-3]^r[c-8]^r[c-14]^r[c-16];for(var f=0;f<80;++f){var l=~~(f/20),p=0|((e=n)<<5|e>>>27)+ft(l,o,i,s)+u+r[f]+a[l];u=s,s=i,i=rotl30(o),o=n,n=p}this._a=n+this._a|0,this._b=o+this._b|0,this._c=i+this._c|0,this._d=s+this._d|0,this._e=u+this._e|0},Sha.prototype._hash=function(){var t=i.allocUnsafe(20);return t.writeInt32BE(0|this._a,0),t.writeInt32BE(0|this._b,4),t.writeInt32BE(0|this._c,8),t.writeInt32BE(0|this._d,12),t.writeInt32BE(0|this._e,16),t},t.exports=Sha},3737(t,e,r){"use strict";var n=r(6698),o=r(8011),i=r(2861).Buffer,a=[1518500249,1859775393,-1894007588,-899497514],s=new Array(80);function Sha1(){this.init(),this._w=s,o.call(this,64,56)}function rotl5(t){return t<<5|t>>>27}function rotl30(t){return t<<30|t>>>2}function ft(t,e,r,n){return 0===t?e&r|~e&n:2===t?e&r|e&n|r&n:e^r^n}n(Sha1,o),Sha1.prototype.init=function(){return this._a=1732584193,this._b=4023233417,this._c=2562383102,this._d=271733878,this._e=3285377520,this},Sha1.prototype._update=function(t){for(var e,r=this._w,n=0|this._a,o=0|this._b,i=0|this._c,s=0|this._d,u=0|this._e,c=0;c<16;++c)r[c]=t.readInt32BE(4*c);for(;c<80;++c)r[c]=(e=r[c-3]^r[c-8]^r[c-14]^r[c-16])<<1|e>>>31;for(var f=0;f<80;++f){var l=~~(f/20),p=rotl5(n)+ft(l,o,i,s)+u+r[f]+a[l]|0;u=s,s=i,i=rotl30(o),o=n,n=p}this._a=n+this._a|0,this._b=o+this._b|0,this._c=i+this._c|0,this._d=s+this._d|0,this._e=u+this._e|0},Sha1.prototype._hash=function(){var t=i.allocUnsafe(20);return t.writeInt32BE(0|this._a,0),t.writeInt32BE(0|this._b,4),t.writeInt32BE(0|this._c,8),t.writeInt32BE(0|this._d,12),t.writeInt32BE(0|this._e,16),t},t.exports=Sha1},6710(t,e,r){"use strict";var n=r(6698),o=r(4107),i=r(8011),a=r(2861).Buffer,s=new Array(64);function Sha224(){this.init(),this._w=s,i.call(this,64,56)}n(Sha224,o),Sha224.prototype.init=function(){return this._a=3238371032,this._b=914150663,this._c=812702999,this._d=4144912697,this._e=4290775857,this._f=1750603025,this._g=1694076839,this._h=3204075428,this},Sha224.prototype._hash=function(){var t=a.allocUnsafe(28);return t.writeInt32BE(this._a,0),t.writeInt32BE(this._b,4),t.writeInt32BE(this._c,8),t.writeInt32BE(this._d,12),t.writeInt32BE(this._e,16),t.writeInt32BE(this._f,20),t.writeInt32BE(this._g,24),t},t.exports=Sha224},4107(t,e,r){"use strict";var n=r(6698),o=r(8011),i=r(2861).Buffer,a=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],s=new Array(64);function Sha256(){this.init(),this._w=s,o.call(this,64,56)}function ch(t,e,r){return r^t&(e^r)}function maj(t,e,r){return t&e|r&(t|e)}function sigma0(t){return(t>>>2|t<<30)^(t>>>13|t<<19)^(t>>>22|t<<10)}function sigma1(t){return(t>>>6|t<<26)^(t>>>11|t<<21)^(t>>>25|t<<7)}function gamma0(t){return(t>>>7|t<<25)^(t>>>18|t<<14)^t>>>3}n(Sha256,o),Sha256.prototype.init=function(){return this._a=1779033703,this._b=3144134277,this._c=1013904242,this._d=2773480762,this._e=1359893119,this._f=2600822924,this._g=528734635,this._h=1541459225,this},Sha256.prototype._update=function(t){for(var e,r=this._w,n=0|this._a,o=0|this._b,i=0|this._c,s=0|this._d,u=0|this._e,c=0|this._f,f=0|this._g,l=0|this._h,p=0;p<16;++p)r[p]=t.readInt32BE(4*p);for(;p<64;++p)r[p]=0|(((e=r[p-2])>>>17|e<<15)^(e>>>19|e<<13)^e>>>10)+r[p-7]+gamma0(r[p-15])+r[p-16];for(var h=0;h<64;++h){var d=l+sigma1(u)+ch(u,c,f)+a[h]+r[h]|0,y=sigma0(n)+maj(n,o,i)|0;l=f,f=c,c=u,u=s+d|0,s=i,i=o,o=n,n=d+y|0}this._a=n+this._a|0,this._b=o+this._b|0,this._c=i+this._c|0,this._d=s+this._d|0,this._e=u+this._e|0,this._f=c+this._f|0,this._g=f+this._g|0,this._h=l+this._h|0},Sha256.prototype._hash=function(){var t=i.allocUnsafe(32);return t.writeInt32BE(this._a,0),t.writeInt32BE(this._b,4),t.writeInt32BE(this._c,8),t.writeInt32BE(this._d,12),t.writeInt32BE(this._e,16),t.writeInt32BE(this._f,20),t.writeInt32BE(this._g,24),t.writeInt32BE(this._h,28),t},t.exports=Sha256},2827(t,e,r){"use strict";var n=r(6698),o=r(2890),i=r(8011),a=r(2861).Buffer,s=new Array(160);function Sha384(){this.init(),this._w=s,i.call(this,128,112)}n(Sha384,o),Sha384.prototype.init=function(){return this._ah=3418070365,this._bh=1654270250,this._ch=2438529370,this._dh=355462360,this._eh=1731405415,this._fh=2394180231,this._gh=3675008525,this._hh=1203062813,this._al=3238371032,this._bl=914150663,this._cl=812702999,this._dl=4144912697,this._el=4290775857,this._fl=1750603025,this._gl=1694076839,this._hl=3204075428,this},Sha384.prototype._hash=function(){var t=a.allocUnsafe(48);function writeInt64BE(e,r,n){t.writeInt32BE(e,n),t.writeInt32BE(r,n+4)}return writeInt64BE(this._ah,this._al,0),writeInt64BE(this._bh,this._bl,8),writeInt64BE(this._ch,this._cl,16),writeInt64BE(this._dh,this._dl,24),writeInt64BE(this._eh,this._el,32),writeInt64BE(this._fh,this._fl,40),t},t.exports=Sha384},2890(t,e,r){"use strict";var n=r(6698),o=r(8011),i=r(2861).Buffer,a=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591],s=new Array(160);function Sha512(){this.init(),this._w=s,o.call(this,128,112)}function Ch(t,e,r){return r^t&(e^r)}function maj(t,e,r){return t&e|r&(t|e)}function sigma0(t,e){return(t>>>28|e<<4)^(e>>>2|t<<30)^(e>>>7|t<<25)}function sigma1(t,e){return(t>>>14|e<<18)^(t>>>18|e<<14)^(e>>>9|t<<23)}function Gamma0(t,e){return(t>>>1|e<<31)^(t>>>8|e<<24)^t>>>7}function Gamma0l(t,e){return(t>>>1|e<<31)^(t>>>8|e<<24)^(t>>>7|e<<25)}function Gamma1(t,e){return(t>>>19|e<<13)^(e>>>29|t<<3)^t>>>6}function Gamma1l(t,e){return(t>>>19|e<<13)^(e>>>29|t<<3)^(t>>>6|e<<26)}function getCarry(t,e){return t>>>0<e>>>0?1:0}n(Sha512,o),Sha512.prototype.init=function(){return this._ah=1779033703,this._bh=3144134277,this._ch=1013904242,this._dh=2773480762,this._eh=1359893119,this._fh=2600822924,this._gh=528734635,this._hh=1541459225,this._al=4089235720,this._bl=2227873595,this._cl=4271175723,this._dl=1595750129,this._el=2917565137,this._fl=725511199,this._gl=4215389547,this._hl=327033209,this},Sha512.prototype._update=function(t){for(var e=this._w,r=0|this._ah,n=0|this._bh,o=0|this._ch,i=0|this._dh,s=0|this._eh,u=0|this._fh,c=0|this._gh,f=0|this._hh,l=0|this._al,p=0|this._bl,h=0|this._cl,d=0|this._dl,y=0|this._el,_=0|this._fl,g=0|this._gl,m=0|this._hl,v=0;v<32;v+=2)e[v]=t.readInt32BE(4*v),e[v+1]=t.readInt32BE(4*v+4);for(;v<160;v+=2){var b=e[v-30],w=e[v-30+1],I=Gamma0(b,w),x=Gamma0l(w,b),B=Gamma1(b=e[v-4],w=e[v-4+1]),k=Gamma1l(w,b),C=e[v-14],j=e[v-14+1],q=e[v-32],L=e[v-32+1],P=x+j|0,U=I+C+getCarry(P,x)|0;U=(U=U+B+getCarry(P=P+k|0,k)|0)+q+getCarry(P=P+L|0,L)|0,e[v]=U,e[v+1]=P}for(var D=0;D<160;D+=2){U=e[D],P=e[D+1];var z=maj(r,n,o),W=maj(l,p,h),V=sigma0(r,l),K=sigma0(l,r),$=sigma1(s,y),H=sigma1(y,s),Y=a[D],Z=a[D+1],J=Ch(s,u,c),tt=Ch(y,_,g),et=m+H|0,rt=f+$+getCarry(et,m)|0;rt=(rt=(rt=rt+J+getCarry(et=et+tt|0,tt)|0)+Y+getCarry(et=et+Z|0,Z)|0)+U+getCarry(et=et+P|0,P)|0;var nt=K+W|0,ot=V+z+getCarry(nt,K)|0;f=c,m=g,c=u,g=_,u=s,_=y,s=i+rt+getCarry(y=d+et|0,d)|0,i=o,d=h,o=n,h=p,n=r,p=l,r=rt+ot+getCarry(l=et+nt|0,et)|0}this._al=this._al+l|0,this._bl=this._bl+p|0,this._cl=this._cl+h|0,this._dl=this._dl+d|0,this._el=this._el+y|0,this._fl=this._fl+_|0,this._gl=this._gl+g|0,this._hl=this._hl+m|0,this._ah=this._ah+r+getCarry(this._al,l)|0,this._bh=this._bh+n+getCarry(this._bl,p)|0,this._ch=this._ch+o+getCarry(this._cl,h)|0,this._dh=this._dh+i+getCarry(this._dl,d)|0,this._eh=this._eh+s+getCarry(this._el,y)|0,this._fh=this._fh+u+getCarry(this._fl,_)|0,this._gh=this._gh+c+getCarry(this._gl,g)|0,this._hh=this._hh+f+getCarry(this._hl,m)|0},Sha512.prototype._hash=function(){var t=i.allocUnsafe(64);function writeInt64BE(e,r,n){t.writeInt32BE(e,n),t.writeInt32BE(r,n+4)}return writeInt64BE(this._ah,this._al,0),writeInt64BE(this._bh,this._bl,8),writeInt64BE(this._ch,this._cl,16),writeInt64BE(this._dh,this._dl,24),writeInt64BE(this._eh,this._el,32),writeInt64BE(this._fh,this._fl,40),writeInt64BE(this._gh,this._gl,48),writeInt64BE(this._hh,this._hl,56),t},t.exports=Sha512},5377(t,e,r){"use strict";var n=r(2861).Buffer,o=r(4634),i=r(4372),a=ArrayBuffer.isView||function isView(t){try{return i(t),!0}catch(t){return!1}},s="undefined"!=typeof Uint8Array,u="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array,c=u&&(n.prototype instanceof Uint8Array||n.TYPED_ARRAY_SUPPORT);t.exports=function toBuffer(t,e){if(t instanceof n)return t;if("string"==typeof t)return n.from(t,e);if(u&&a(t)){if(0===t.byteLength)return n.alloc(0);if(c){var r=n.from(t.buffer,t.byteOffset,t.byteLength);if(r.byteLength===t.byteLength)return r}var i=t instanceof Uint8Array?t:new Uint8Array(t.buffer,t.byteOffset,t.byteLength),f=n.from(i);if(f.length===t.byteLength)return f}if(s&&t instanceof Uint8Array)return n.from(t);var l=o(t);if(l)for(var p=0;p<t.length;p+=1){var h=t[p];if("number"!=typeof h||h<0||h>255||~~h!==h)throw new RangeError("Array items must be numbers in the range 0-255.")}if(l||n.isBuffer(t)&&t.constructor&&"function"==typeof t.constructor.isBuffer&&t.constructor.isBuffer(t))return n.from(t);throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.')}},4372(t,e,r){"use strict";var n=r(9675),o=r(6556)("TypedArray.prototype.buffer",!0),i=r(5680);t.exports=o||function typedArrayBuffer(t){if(!i(t))throw new n("Not a Typed Array");return t.buffer}},5767(t,e,r){"use strict";var n=r(2682),o=r(9209),i=r(487),a=r(6556),s=r(5795),u=a("Object.prototype.toString"),c=r(9092)(),f="undefined"==typeof globalThis?r.g:globalThis,l=o(),p=a("String.prototype.slice"),h=Object.getPrototypeOf,d=a("Array.prototype.indexOf",!0)||function indexOf(t,e){for(var r=0;r<t.length;r+=1)if(t[r]===e)return r;return-1},y={__proto__:null};n(l,c&&s&&h?function(t){var e=new f[t];if(Symbol.toStringTag in e){var r=h(e),n=s(r,Symbol.toStringTag);if(!n){var o=h(r);n=s(o,Symbol.toStringTag)}y["$"+t]=i(n.get)}}:function(t){var e=new f[t],r=e.slice||e.set;r&&(y["$"+t]=i(r))});t.exports=function whichTypedArray(t){if(!t||"object"!=typeof t)return!1;if(!c){var e=p(u(t),8,-1);return d(l,e)>-1?e:"Object"===e&&function tryAllSlices(t){var e=!1;return n(y,(function(r,n){if(!e)try{r(t),e=p(n,1)}catch(t){}})),e}(t)}return s?function tryAllTypedArrays(t){var e=!1;return n(y,(function(r,n){if(!e)try{"$"+r(t)===n&&(e=p(n,1))}catch(t){}})),e}(t):null}},7666(t,e,r){var n=r(4851),o=r(953);function _extends(){var e;return t.exports=_extends=n?o(e=n).call(e):function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var n in r)({}).hasOwnProperty.call(r,n)&&(t[n]=r[n])}return t},t.exports.__esModule=!0,t.exports.default=t.exports,_extends.apply(null,arguments)}t.exports=_extends,t.exports.__esModule=!0,t.exports.default=t.exports},9209(t,e,r){"use strict";var n=r(6578),o="undefined"==typeof globalThis?r.g:globalThis;t.exports=function availableTypedArrays(){for(var t=[],e=0;e<n.length;e++)"function"==typeof o[n[e]]&&(t[t.length]=n[e]);return t}},3700(t,e,r){"use strict";var n=r(9709);t.exports=n},462(t,e,r){"use strict";var n=r(975);t.exports=n},2567(t,e,r){"use strict";r(9307);var n=r(1747);t.exports=n("Function","bind")},3034(t,e,r){"use strict";var n=r(8280),o=r(2567),i=Function.prototype;t.exports=function(t){var e=t.bind;return t===i||n(i,t)&&e===i.bind?o:e}},9748(t,e,r){"use strict";r(1340);var n=r(2046);t.exports=n.Object.assign},953(t,e,r){"use strict";t.exports=r(3375)},4851(t,e,r){"use strict";t.exports=r(5401)},3375(t,e,r){"use strict";var n=r(3700);t.exports=n},5401(t,e,r){"use strict";var n=r(462);t.exports=n},2159(t,e,r){"use strict";var n=r(2250),o=r(4640),i=TypeError;t.exports=function(t){if(n(t))return t;throw new i(o(t)+" is not a function")}},6624(t,e,r){"use strict";var n=r(6285),o=String,i=TypeError;t.exports=function(t){if(n(t))return t;throw new i(o(t)+" is not an object")}},4436(t,e,r){"use strict";var n=r(7374),o=r(4849),i=r(575),createMethod=function(t){return function(e,r,a){var s=n(e),u=i(s);if(0===u)return!t&&-1;var c,f=o(a,u);if(t&&r!=r){for(;u>f;)if((c=s[f++])!=c)return!0}else for(;u>f;f++)if((t||f in s)&&s[f]===r)return t||f||0;return!t&&-1}};t.exports={includes:createMethod(!0),indexOf:createMethod(!1)}},3427(t,e,r){"use strict";var n=r(1907);t.exports=n([].slice)},5807(t,e,r){"use strict";var n=r(1907),o=n({}.toString),i=n("".slice);t.exports=function(t){return i(o(t),8,-1)}},1626(t,e,r){"use strict";var n=r(9447),o=r(4284),i=r(5817);t.exports=n?function(t,e,r){return o.f(t,e,i(1,r))}:function(t,e,r){return t[e]=r,t}},5817(t){"use strict";t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},2532(t,e,r){"use strict";var n=r(5951),o=Object.defineProperty;t.exports=function(t,e){try{o(n,t,{value:e,configurable:!0,writable:!0})}catch(r){n[t]=e}return e}},9447(t,e,r){"use strict";var n=r(8828);t.exports=!n((function(){return 7!==Object.defineProperty({},1,{get:function(){return 7}})[1]}))},9552(t,e,r){"use strict";var n=r(5951),o=r(6285),i=n.document,a=o(i)&&o(i.createElement);t.exports=function(t){return a?i.createElement(t):{}}},376(t){"use strict";t.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"]},6794(t,e,r){"use strict";var n=r(5951).navigator,o=n&&n.userAgent;t.exports=o?String(o):""},798(t,e,r){"use strict";var n,o,i=r(5951),a=r(6794),s=i.process,u=i.Deno,c=s&&s.versions||u&&u.version,f=c&&c.v8;f&&(o=(n=f.split("."))[0]>0&&n[0]<4?1:+(n[0]+n[1])),!o&&a&&(!(n=a.match(/Edge\/(\d+)/))||n[1]>=74)&&(n=a.match(/Chrome\/(\d+)/))&&(o=+n[1]),t.exports=o},1091(t,e,r){"use strict";var n=r(5951),o=r(6024),i=r(2361),a=r(2250),s=r(3846).f,u=r(7463),c=r(2046),f=r(8311),l=r(1626),p=r(9724);r(6128);var wrapConstructor=function(t){var Wrapper=function(e,r,n){if(this instanceof Wrapper){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,r)}return new t(e,r,n)}return o(t,this,arguments)};return Wrapper.prototype=t.prototype,Wrapper};t.exports=function(t,e){var r,o,h,d,y,_,g,m,v,b=t.target,w=t.global,I=t.stat,x=t.proto,B=w?n:I?n[b]:n[b]&&n[b].prototype,k=w?c:c[b]||l(c,b,{})[b],C=k.prototype;for(d in e)o=!(r=u(w?d:b+(I?".":"#")+d,t.forced))&&B&&p(B,d),_=k[d],o&&(g=t.dontCallGetSet?(v=s(B,d))&&v.value:B[d]),y=o&&g?g:e[d],(r||x||typeof _!=typeof y)&&(m=t.bind&&o?f(y,n):t.wrap&&o?wrapConstructor(y):x&&a(y)?i(y):y,(t.sham||y&&y.sham||_&&_.sham)&&l(m,"sham",!0),l(k,d,m),x&&(p(c,h=b+"Prototype")||l(c,h,{}),l(c[h],d,y),t.real&&C&&(r||!C[d])&&l(C,d,y)))}},8828(t){"use strict";t.exports=function(t){try{return!!t()}catch(t){return!0}}},6024(t,e,r){"use strict";var n=r(1505),o=Function.prototype,i=o.apply,a=o.call;t.exports="object"==typeof Reflect&&Reflect.apply||(n?a.bind(i):function(){return a.apply(i,arguments)})},8311(t,e,r){"use strict";var n=r(2361),o=r(2159),i=r(1505),a=n(n.bind);t.exports=function(t,e){return o(t),void 0===e?t:i?a(t,e):function(){return t.apply(e,arguments)}}},1505(t,e,r){"use strict";var n=r(8828);t.exports=!n((function(){var t=function(){}.bind();return"function"!=typeof t||t.hasOwnProperty("prototype")}))},4673(t,e,r){"use strict";var n=r(1907),o=r(2159),i=r(6285),a=r(9724),s=r(3427),u=r(1505),c=Function,f=n([].concat),l=n([].join),p={};t.exports=u?c.bind:function bind(t){var e=o(this),r=e.prototype,n=s(arguments,1),u=function bound(){var r=f(n,s(arguments));return this instanceof u?function(t,e,r){if(!a(p,e)){for(var n=[],o=0;o<e;o++)n[o]="a["+o+"]";p[e]=c("C,a","return new C("+l(n,",")+")")}return p[e](t,r)}(e,r.length,r):e.apply(t,r)};return i(r)&&(u.prototype=r),u}},3930(t,e,r){"use strict";var n=r(1505),o=Function.prototype.call;t.exports=n?o.bind(o):function(){return o.apply(o,arguments)}},2361(t,e,r){"use strict";var n=r(5807),o=r(1907);t.exports=function(t){if("Function"===n(t))return o(t)}},1907(t,e,r){"use strict";var n=r(1505),o=Function.prototype,i=o.call,a=n&&o.bind.bind(i,i);t.exports=n?a:function(t){return function(){return i.apply(t,arguments)}}},1747(t,e,r){"use strict";var n=r(5951),o=r(2046);t.exports=function(t,e){var r=o[t+"Prototype"],i=r&&r[e];if(i)return i;var a=n[t],s=a&&a.prototype;return s&&s[e]}},5582(t,e,r){"use strict";var n=r(2046),o=r(5951),i=r(2250),aFunction=function(t){return i(t)?t:void 0};t.exports=function(t,e){return arguments.length<2?aFunction(n[t])||aFunction(o[t]):n[t]&&n[t][e]||o[t]&&o[t][e]}},9367(t,e,r){"use strict";var n=r(2159),o=r(7136);t.exports=function(t,e){var r=t[e];return o(r)?void 0:n(r)}},5951(t,e,r){"use strict";var check=function(t){return t&&t.Math===Math&&t};t.exports=check("object"==typeof globalThis&&globalThis)||check("object"==typeof window&&window)||check("object"==typeof self&&self)||check("object"==typeof r.g&&r.g)||check("object"==typeof this&&this)||function(){return this}()||Function("return this")()},9724(t,e,r){"use strict";var n=r(1907),o=r(9298),i=n({}.hasOwnProperty);t.exports=Object.hasOwn||function hasOwn(t,e){return i(o(t),e)}},8530(t){"use strict";t.exports={}},3648(t,e,r){"use strict";var n=r(9447),o=r(8828),i=r(9552);t.exports=!n&&!o((function(){return 7!==Object.defineProperty(i("div"),"a",{get:function(){return 7}}).a}))},6946(t,e,r){"use strict";var n=r(1907),o=r(8828),i=r(5807),a=Object,s=n("".split);t.exports=o((function(){return!a("z").propertyIsEnumerable(0)}))?function(t){return"String"===i(t)?s(t,""):a(t)}:a},2250(t){"use strict";var e="object"==typeof document&&document.all;t.exports=void 0===e&&void 0!==e?function(t){return"function"==typeof t||t===e}:function(t){return"function"==typeof t}},7463(t,e,r){"use strict";var n=r(8828),o=r(2250),i=/#|\.prototype\./,isForced=function(t,e){var r=s[a(t)];return r===c||r!==u&&(o(e)?n(e):!!e)},a=isForced.normalize=function(t){return String(t).replace(i,".").toLowerCase()},s=isForced.data={},u=isForced.NATIVE="N",c=isForced.POLYFILL="P";t.exports=isForced},7136(t){"use strict";t.exports=function(t){return null==t}},6285(t,e,r){"use strict";var n=r(2250);t.exports=function(t){return"object"==typeof t?null!==t:n(t)}},7376(t){"use strict";t.exports=!0},5594(t,e,r){"use strict";var n=r(5582),o=r(2250),i=r(8280),a=r(3556),s=Object;t.exports=a?function(t){return"symbol"==typeof t}:function(t){var e=n("Symbol");return o(e)&&i(e.prototype,s(t))}},575(t,e,r){"use strict";var n=r(3121);t.exports=function(t){return n(t.length)}},1176(t){"use strict";var e=Math.ceil,r=Math.floor;t.exports=Math.trunc||function trunc(t){var n=+t;return(n>0?r:e)(n)}},7157(t,e,r){"use strict";var n=r(9447),o=r(1907),i=r(3930),a=r(8828),s=r(2875),u=r(7170),c=r(2574),f=r(9298),l=r(6946),p=Object.assign,h=Object.defineProperty,d=o([].concat);t.exports=!p||a((function(){if(n&&1!==p({b:1},p(h({},"a",{enumerable:!0,get:function(){h(this,"b",{value:3,enumerable:!1})}}),{b:2})).b)return!0;var t={},e={},r=Symbol("assign detection"),o="abcdefghijklmnopqrst";return t[r]=7,o.split("").forEach((function(t){e[t]=t})),7!==p({},t)[r]||s(p({},e)).join("")!==o}))?function assign(t,e){for(var r=f(t),o=arguments.length,a=1,p=u.f,h=c.f;o>a;)for(var y,_=l(arguments[a++]),g=p?d(s(_),p(_)):s(_),m=g.length,v=0;m>v;)y=g[v++],n&&!i(h,_,y)||(r[y]=_[y]);return r}:p},4284(t,e,r){"use strict";var n=r(9447),o=r(3648),i=r(8661),a=r(6624),s=r(470),u=TypeError,c=Object.defineProperty,f=Object.getOwnPropertyDescriptor,l="enumerable",p="configurable",h="writable";e.f=n?i?function defineProperty(t,e,r){if(a(t),e=s(e),a(r),"function"==typeof t&&"prototype"===e&&"value"in r&&h in r&&!r[h]){var n=f(t,e);n&&n[h]&&(t[e]=r.value,r={configurable:p in r?r[p]:n[p],enumerable:l in r?r[l]:n[l],writable:!1})}return c(t,e,r)}:c:function defineProperty(t,e,r){if(a(t),e=s(e),a(r),o)try{return c(t,e,r)}catch(t){}if("get"in r||"set"in r)throw new u("Accessors not supported");return"value"in r&&(t[e]=r.value),t}},3846(t,e,r){"use strict";var n=r(9447),o=r(3930),i=r(2574),a=r(5817),s=r(7374),u=r(470),c=r(9724),f=r(3648),l=Object.getOwnPropertyDescriptor;e.f=n?l:function getOwnPropertyDescriptor(t,e){if(t=s(t),e=u(e),f)try{return l(t,e)}catch(t){}if(c(t,e))return a(!o(i.f,t,e),t[e])}},7170(t,e){"use strict";e.f=Object.getOwnPropertySymbols},8280(t,e,r){"use strict";var n=r(1907);t.exports=n({}.isPrototypeOf)},3045(t,e,r){"use strict";var n=r(1907),o=r(9724),i=r(7374),a=r(4436).indexOf,s=r(8530),u=n([].push);t.exports=function(t,e){var r,n=i(t),c=0,f=[];for(r in n)!o(s,r)&&o(n,r)&&u(f,r);for(;e.length>c;)o(n,r=e[c++])&&(~a(f,r)||u(f,r));return f}},2875(t,e,r){"use strict";var n=r(3045),o=r(376);t.exports=Object.keys||function keys(t){return n(t,o)}},2574(t,e){"use strict";var r={}.propertyIsEnumerable,n=Object.getOwnPropertyDescriptor,o=n&&!r.call({1:2},1);e.f=o?function propertyIsEnumerable(t){var e=n(this,t);return!!e&&e.enumerable}:r},581(t,e,r){"use strict";var n=r(3930),o=r(2250),i=r(6285),a=TypeError;t.exports=function(t,e){var r,s;if("string"===e&&o(r=t.toString)&&!i(s=n(r,t)))return s;if(o(r=t.valueOf)&&!i(s=n(r,t)))return s;if("string"!==e&&o(r=t.toString)&&!i(s=n(r,t)))return s;throw new a("Can't convert object to primitive value")}},2046(t){"use strict";t.exports={}},4239(t,e,r){"use strict";var n=r(7136),o=TypeError;t.exports=function(t){if(n(t))throw new o("Can't call method on "+t);return t}},6128(t,e,r){"use strict";var n=r(7376),o=r(5951),i=r(2532),a="__core-js_shared__",s=t.exports=o[a]||i(a,{});(s.versions||(s.versions=[])).push({version:"3.40.0",mode:n?"pure":"global",copyright:"© 2014-2025 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.40.0/LICENSE",source:"https://github.com/zloirock/core-js"})},5816(t,e,r){"use strict";var n=r(6128);t.exports=function(t,e){return n[t]||(n[t]=e||{})}},9846(t,e,r){"use strict";var n=r(798),o=r(8828),i=r(5951).String;t.exports=!!Object.getOwnPropertySymbols&&!o((function(){var t=Symbol("symbol detection");return!i(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&n&&n<41}))},4849(t,e,r){"use strict";var n=r(5482),o=Math.max,i=Math.min;t.exports=function(t,e){var r=n(t);return r<0?o(r+e,0):i(r,e)}},7374(t,e,r){"use strict";var n=r(6946),o=r(4239);t.exports=function(t){return n(o(t))}},5482(t,e,r){"use strict";var n=r(1176);t.exports=function(t){var e=+t;return e!=e||0===e?0:n(e)}},3121(t,e,r){"use strict";var n=r(5482),o=Math.min;t.exports=function(t){var e=n(t);return e>0?o(e,9007199254740991):0}},9298(t,e,r){"use strict";var n=r(4239),o=Object;t.exports=function(t){return o(n(t))}},6028(t,e,r){"use strict";var n=r(3930),o=r(6285),i=r(5594),a=r(9367),s=r(581),u=r(6264),c=TypeError,f=u("toPrimitive");t.exports=function(t,e){if(!o(t)||i(t))return t;var r,u=a(t,f);if(u){if(void 0===e&&(e="default"),r=n(u,t,e),!o(r)||i(r))return r;throw new c("Can't convert object to primitive value")}return void 0===e&&(e="number"),s(t,e)}},470(t,e,r){"use strict";var n=r(6028),o=r(5594);t.exports=function(t){var e=n(t,"string");return o(e)?e:e+""}},4640(t){"use strict";var e=String;t.exports=function(t){try{return e(t)}catch(t){return"Object"}}},6499(t,e,r){"use strict";var n=r(1907),o=0,i=Math.random(),a=n(1..toString);t.exports=function(t){return"Symbol("+(void 0===t?"":t)+")_"+a(++o+i,36)}},3556(t,e,r){"use strict";var n=r(9846);t.exports=n&&!Symbol.sham&&"symbol"==typeof Symbol.iterator},8661(t,e,r){"use strict";var n=r(9447),o=r(8828);t.exports=n&&o((function(){return 42!==Object.defineProperty((function(){}),"prototype",{value:42,writable:!1}).prototype}))},6264(t,e,r){"use strict";var n=r(5951),o=r(5816),i=r(9724),a=r(6499),s=r(9846),u=r(3556),c=n.Symbol,f=o("wks"),l=u?c.for||c:c&&c.withoutSetter||a;t.exports=function(t){return i(f,t)||(f[t]=s&&i(c,t)?c[t]:l("Symbol."+t)),f[t]}},9307(t,e,r){"use strict";var n=r(1091),o=r(4673);n({target:"Function",proto:!0,forced:Function.bind!==o},{bind:o})},1340(t,e,r){"use strict";var n=r(1091),o=r(7157);n({target:"Object",stat:!0,arity:2,forced:Object.assign!==o},{assign:o})},9709(t,e,r){"use strict";var n=r(3034);t.exports=n},975(t,e,r){"use strict";var n=r(9748);t.exports=n}},e={};function __webpack_require__(r){var n=e[r];if(void 0!==n)return n.exports;var o=e[r]={id:r,loaded:!1,exports:{}};return t[r].call(o.exports,o,o.exports,__webpack_require__),o.loaded=!0,o.exports}__webpack_require__.n=t=>{var e=t&&t.__esModule?()=>t.default:()=>t;return __webpack_require__.d(e,{a:e}),e},__webpack_require__.d=(t,e)=>{for(var r in e)__webpack_require__.o(e,r)&&!__webpack_require__.o(t,r)&&Object.defineProperty(t,r,{enumerable:!0,get:e[r]})},__webpack_require__.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(t){if("object"==typeof window)return window}}(),__webpack_require__.o=(t,e)=>Object.prototype.hasOwnProperty.call(t,e),__webpack_require__.r=t=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},__webpack_require__.nmd=t=>(t.paths=[],t.children||(t.children=[]),t);var r={};return(()=>{"use strict";__webpack_require__.d(r,{default:()=>ce});var t={};__webpack_require__.r(t),__webpack_require__.d(t,{TOGGLE_CONFIGS:()=>ee,UPDATE_CONFIGS:()=>te,downloadConfig:()=>downloadConfig,getConfigByUrl:()=>getConfigByUrl,loaded:()=>loaded,toggle:()=>toggle,update:()=>update});var e={};__webpack_require__.r(e),__webpack_require__.d(e,{get:()=>get});var n=__webpack_require__(6540);class StandaloneLayout extends n.Component{render(){const{getComponent:t}=this.props,e=t("Container"),r=t("Row"),o=t("Col"),i=t("Topbar",!0),a=t("BaseLayout",!0),s=t("onlineValidatorBadge",!0);return n.createElement(e,{className:"swagger-ui"},i?n.createElement(i,null):null,n.createElement(a,null),n.createElement(r,null,n.createElement(o,null,n.createElement(s,null))))}}const o=StandaloneLayout,stadalone_layout=()=>({components:{StandaloneLayout:o}});var i=__webpack_require__(9404),a=__webpack_require__.n(i);__webpack_require__(4058),__webpack_require__(5808),__webpack_require__(104),__webpack_require__(7309),__webpack_require__(2426),__webpack_require__(5288),__webpack_require__(1882),__webpack_require__(2205),__webpack_require__(3209),__webpack_require__(2802);const s=function makeWindow(){var t={location:{},history:{},open:()=>{},close:()=>{},File:function(){},FormData:function(){}};if("undefined"==typeof window)return t;try{t=window;for(var e of["File","Blob","FormData"])e in window&&(t[e]=window[e])}catch(t){console.error(t)}return t}();a().Set.of("type","format","items","default","maximum","exclusiveMaximum","minimum","exclusiveMinimum","maxLength","minLength","pattern","maxItems","minItems","uniqueItems","enum","multipleOf");__webpack_require__(8287).Buffer;const parseSearch=()=>{const t=new URLSearchParams(s.location.search);return Object.fromEntries(t)};class TopBar extends n.Component{constructor(t,e){super(t,e),this.state={url:t.specSelectors.url(),selectedIndex:0}}UNSAFE_componentWillReceiveProps(t){this.setState({url:t.specSelectors.url()})}onUrlChange=t=>{let{target:{value:e}}=t;this.setState({url:e})};flushAuthData(){const{persistAuthorization:t}=this.props.getConfigs();t||this.props.authActions.restoreAuthorization({authorized:{}})}loadSpec=t=>{this.flushAuthData(),this.props.specActions.updateUrl(t),this.props.specActions.download(t)};onUrlSelect=t=>{let e=t.target.value||t.target.href;this.loadSpec(e),this.setSelectedUrl(e),t.preventDefault()};downloadUrl=t=>{this.loadSpec(this.state.url),t.preventDefault()};setSearch=t=>{let e=parseSearch();e["urls.primaryName"]=t.name;const r=`${window.location.protocol}//${window.location.host}${window.location.pathname}`;window&&window.history&&window.history.pushState&&window.history.replaceState(null,"",`${r}?${(t=>{const e=new URLSearchParams(Object.entries(t));return String(e)})(e)}`)};setSelectedUrl=t=>{const e=this.props.getConfigs().urls||[];e&&e.length&&t&&e.forEach(((e,r)=>{e.url===t&&(this.setState({selectedIndex:r}),this.setSearch(e))}))};componentDidMount(){const t=this.props.getConfigs(),e=t.urls||[];if(e&&e.length){var r=this.state.selectedIndex;let n=parseSearch()["urls.primaryName"]||t.urls.primaryName;n&&e.forEach(((t,e)=>{t.name===n&&(this.setState({selectedIndex:e}),r=e)})),this.loadSpec(e[r].url)}}onFilterChange=t=>{let{target:{value:e}}=t;this.props.layoutActions.updateFilter(e)};render(){let{getComponent:t,specSelectors:e,getConfigs:r}=this.props;const o=t("Button"),i=t("Link"),a=t("Logo"),s=t("DarkModeToggle");let u="loading"===e.loadingStatus();const c=["download-url-input"];"failed"===e.loadingStatus()&&c.push("failed"),u&&c.push("loading");const{urls:f}=r();let l=[],p=null;if(f){let t=[];f.forEach(((e,r)=>{t.push(n.createElement("option",{key:r,value:e.url},e.name))})),l.push(n.createElement("label",{className:"select-label",htmlFor:"select"},n.createElement("span",null,"Select a definition"),n.createElement("select",{id:"select",disabled:u,onChange:this.onUrlSelect,value:f[this.state.selectedIndex].url},t)))}else p=this.downloadUrl,l.push(n.createElement("input",{className:c.join(" "),type:"text",onChange:this.onUrlChange,value:this.state.url,disabled:u,id:"download-url-input"})),l.push(n.createElement(o,{className:"download-url-button",onClick:this.downloadUrl},"Explore"));return n.createElement("div",{className:"topbar"},n.createElement("div",{className:"wrapper"},n.createElement("div",{className:"topbar-wrapper"},n.createElement(i,null,n.createElement(a,null)),n.createElement("form",{className:"download-url-wrapper",onSubmit:p},l.map(((t,e)=>(0,n.cloneElement)(t,{key:e})))),n.createElement(s,null))))}}const u=TopBar;var c,f,l,p,h,d,y,_,g,m,v,b,w,I,x,B,k,C,j,q,L,P,U,D,z,W,V,K,$,H,Y,Z;function _extends(){return _extends=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var n in r)({}).hasOwnProperty.call(r,n)&&(t[n]=r[n])}return t},_extends.apply(null,arguments)}const logo_small=t=>n.createElement("svg",_extends({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 407 116"},t),c||(c=n.createElement("defs",null,n.createElement("clipPath",{id:"logo_small_svg__clip-SW_TM-logo-on-dark"},n.createElement("path",{d:"M0 0h407v116H0z"})),n.createElement("style",null,".logo_small_svg__cls-2{fill:#fff}.logo_small_svg__cls-3{fill:#85ea2d}"))),n.createElement("g",{id:"logo_small_svg__SW_TM-logo-on-dark",style:{clipPath:"url(#logo_small_svg__clip-SW_TM-logo-on-dark)"}},n.createElement("g",{id:"logo_small_svg__SW_In-Product",transform:"translate(-.301)"},f||(f=n.createElement("path",{id:"logo_small_svg__Path_2936",d:"M359.15 70.674h-.7v-3.682h-1.26v-.6h3.219v.6h-1.259Z",className:"logo_small_svg__cls-2","data-name":"Path 2936"})),l||(l=n.createElement("path",{id:"logo_small_svg__Path_2937",d:"m363.217 70.674-1.242-3.574h-.023q.05.8.05 1.494v2.083h-.636v-4.286h.987l1.19 3.407h.017l1.225-3.407h.99v4.283h-.675v-2.118a30 30 0 0 1 .044-1.453h-.023l-1.286 3.571Z",className:"logo_small_svg__cls-2","data-name":"Path 2937"})),p||(p=n.createElement("path",{id:"logo_small_svg__Path_2938",d:"M50.328 97.669a47.642 47.642 0 1 1 47.643-47.642 47.64 47.64 0 0 1-47.643 47.642",className:"logo_small_svg__cls-3","data-name":"Path 2938"})),h||(h=n.createElement("path",{id:"logo_small_svg__Path_2939",d:"M50.328 4.769A45.258 45.258 0 1 1 5.07 50.027 45.26 45.26 0 0 1 50.328 4.769m0-4.769a50.027 50.027 0 1 0 50.027 50.027A50.027 50.027 0 0 0 50.328 0",className:"logo_small_svg__cls-3","data-name":"Path 2939"})),n.createElement("path",{id:"logo_small_svg__Path_2940",d:"M31.8 33.854c-.154 1.712.058 3.482-.057 5.213a43 43 0 0 1-.693 5.156 9.53 9.53 0 0 1-4.1 5.829c4.079 2.654 4.54 6.771 4.81 10.946.135 2.25.077 4.52.308 6.752.173 1.731.846 2.174 2.636 2.231.73.02 1.48 0 2.327 0v5.349c-5.29.9-9.657-.6-10.734-5.079a31 31 0 0 1-.654-5c-.117-1.789.076-3.578-.058-5.367-.386-4.906-1.02-6.56-5.713-6.791v-6.1a9 9 0 0 1 1.028-.173c2.577-.135 3.674-.924 4.231-3.463a29 29 0 0 0 .481-4.329 82 82 0 0 1 .6-8.406c.673-3.982 3.136-5.906 7.234-6.137 1.154-.057 2.327 0 3.655 0v5.464c-.558.038-1.039.115-1.539.115-3.336-.115-3.51 1.02-3.762 3.79m6.406 12.658h-.077a3.515 3.515 0 1 0-.346 7.021h.231a3.46 3.46 0 0 0 3.655-3.251v-.192a3.523 3.523 0 0 0-3.461-3.578Zm12.062 0a3.373 3.373 0 0 0-3.482 3.251 2 2 0 0 0 .02.327 3.3 3.3 0 0 0 3.578 3.443 3.263 3.263 0 0 0 3.443-3.558 3.308 3.308 0 0 0-3.557-3.463Zm12.351 0a3.59 3.59 0 0 0-3.655 3.482 3.53 3.53 0 0 0 3.536 3.539h.039c1.769.309 3.559-1.4 3.674-3.462a3.57 3.57 0 0 0-3.6-3.559Zm16.948.288c-2.232-.1-3.348-.846-3.9-2.962a21.5 21.5 0 0 1-.635-4.136c-.154-2.578-.135-5.175-.308-7.753-.4-6.117-4.828-8.252-11.254-7.195v5.31c1.019 0 1.808 0 2.6.019 1.366.019 2.4.539 2.539 2.059.135 1.385.135 2.789.27 4.193.269 2.79.422 5.618.9 8.369a8.72 8.72 0 0 0 3.921 5.348c-3.4 2.289-4.406 5.559-4.578 9.234-.1 2.52-.154 5.059-.289 7.6-.115 2.308-.923 3.058-3.251 3.116-.654.019-1.289.077-2.019.115v5.445c1.365 0 2.616.077 3.866 0 3.886-.231 6.233-2.117 7-5.887A49 49 0 0 0 75 63.4c.135-1.923.116-3.866.308-5.771.289-2.982 1.655-4.213 4.636-4.4a4 4 0 0 0 .828-.192v-6.1c-.5-.058-.843-.115-1.208-.135Z","data-name":"Path 2940",style:{fill:"#173647"}}),d||(d=n.createElement("path",{id:"logo_small_svg__Path_2941",d:"M152.273 58.122a11.23 11.23 0 0 1-4.384 9.424q-4.383 3.382-11.9 3.382-8.14 0-12.524-2.1V63.7a33 33 0 0 0 6.137 1.879 32.3 32.3 0 0 0 6.575.689q5.322 0 8.015-2.02a6.63 6.63 0 0 0 2.692-5.62 7.2 7.2 0 0 0-.954-3.9 8.9 8.9 0 0 0-3.194-2.8 44.6 44.6 0 0 0-6.81-2.911q-6.387-2.286-9.126-5.417a11.96 11.96 0 0 1-2.74-8.172A10.16 10.16 0 0 1 128.039 27q3.977-3.131 10.52-3.131a31 31 0 0 1 12.555 2.5L149.455 31a28.4 28.4 0 0 0-11.021-2.38 10.67 10.67 0 0 0-6.606 1.816 5.98 5.98 0 0 0-2.38 5.041 7.7 7.7 0 0 0 .877 3.9 8.24 8.24 0 0 0 2.959 2.786 36.7 36.7 0 0 0 6.371 2.8q7.2 2.566 9.91 5.51a10.84 10.84 0 0 1 2.708 7.649",className:"logo_small_svg__cls-2","data-name":"Path 2941"})),y||(y=n.createElement("path",{id:"logo_small_svg__Path_2942",d:"M185.288 70.3 179 50.17q-.594-1.848-2.222-8.391h-.251q-1.252 5.479-2.192 8.453L167.849 70.3h-6.011l-9.361-34.315h5.447q3.318 12.931 5.057 19.693a80 80 0 0 1 1.988 9.111h.25q.345-1.785 1.112-4.618t1.33-4.493l6.294-19.693h5.635l6.137 19.693a66 66 0 0 1 2.379 9.048h.251a33 33 0 0 1 .673-3.475q.548-2.347 6.528-25.266h5.385L191.456 70.3Z",className:"logo_small_svg__cls-2","data-name":"Path 2942"})),_||(_=n.createElement("path",{id:"logo_small_svg__Path_2943",d:"m225.115 70.3-1.033-4.885h-.25a14.45 14.45 0 0 1-5.119 4.368 15.6 15.6 0 0 1-6.372 1.143q-5.1 0-8-2.63t-2.9-7.483q0-10.4 16.626-10.9l5.823-.188V47.6q0-4.038-1.738-5.964t-5.552-1.923a22.6 22.6 0 0 0-9.706 2.63l-1.6-3.977a24.4 24.4 0 0 1 5.557-2.16 24 24 0 0 1 6.058-.783q6.136 0 9.1 2.724t2.959 8.735V70.3Zm-11.741-3.663a10.55 10.55 0 0 0 7.626-2.66 9.85 9.85 0 0 0 2.771-7.451v-3.1l-5.2.219q-6.2.219-8.939 1.926a5.8 5.8 0 0 0-2.74 5.306 5.35 5.35 0 0 0 1.707 4.29 7.08 7.08 0 0 0 4.775 1.472Z",className:"logo_small_svg__cls-2","data-name":"Path 2943"})),g||(g=n.createElement("path",{id:"logo_small_svg__Path_2944",d:"M264.6 35.987v3.287l-6.356.752a11.16 11.16 0 0 1 2.255 6.856 10.15 10.15 0 0 1-3.444 8.047q-3.444 3-9.456 3a15.7 15.7 0 0 1-2.88-.25Q241.4 59.438 241.4 62.1a2.24 2.24 0 0 0 1.159 2.082 8.46 8.46 0 0 0 3.976.673h6.074q5.573 0 8.563 2.348a8.16 8.16 0 0 1 2.99 6.825 9.74 9.74 0 0 1-4.571 8.688q-4.572 2.989-13.338 2.99-6.732 0-10.379-2.5a8.09 8.09 0 0 1-3.647-7.076 7.95 7.95 0 0 1 2-5.417 10.2 10.2 0 0 1 5.636-3.1 5.43 5.43 0 0 1-2.207-1.847 4.9 4.9 0 0 1-.893-2.912 5.53 5.53 0 0 1 1-3.288 10.5 10.5 0 0 1 3.162-2.723 9.28 9.28 0 0 1-4.336-3.726 10.95 10.95 0 0 1-1.675-6.012q0-5.634 3.382-8.688t9.58-3.052a17.4 17.4 0 0 1 4.853.626Zm-27.367 40.075a4.66 4.66 0 0 0 2.348 4.227 12.97 12.97 0 0 0 6.732 1.44q6.543 0 9.69-1.956a5.99 5.99 0 0 0 3.147-5.307q0-2.787-1.723-3.867t-6.481-1.08h-6.23a8.2 8.2 0 0 0-5.51 1.69 6.04 6.04 0 0 0-1.973 4.853m2.818-29.086a6.98 6.98 0 0 0 2.035 5.448 8.12 8.12 0 0 0 5.667 1.847q7.608 0 7.608-7.389 0-7.733-7.7-7.733a7.63 7.63 0 0 0-5.635 1.972q-1.976 1.973-1.975 5.855",className:"logo_small_svg__cls-2","data-name":"Path 2944"})),m||(m=n.createElement("path",{id:"logo_small_svg__Path_2945",d:"M299.136 35.987v3.287l-6.356.752a11.17 11.17 0 0 1 2.254 6.856 10.15 10.15 0 0 1-3.444 8.047q-3.444 3-9.455 3a15.7 15.7 0 0 1-2.88-.25q-3.32 1.754-3.319 4.415a2.24 2.24 0 0 0 1.158 2.082 8.46 8.46 0 0 0 3.976.673h6.074q5.574 0 8.563 2.348a8.16 8.16 0 0 1 2.99 6.825 9.74 9.74 0 0 1-4.571 8.688q-4.57 2.989-13.337 2.99-6.732 0-10.379-2.5a8.09 8.09 0 0 1-3.648-7.076 7.95 7.95 0 0 1 2-5.417 10.2 10.2 0 0 1 5.636-3.1 5.43 5.43 0 0 1-2.208-1.847 4.9 4.9 0 0 1-.892-2.912 5.53 5.53 0 0 1 1-3.288 10.5 10.5 0 0 1 3.162-2.723 9.27 9.27 0 0 1-4.336-3.726 10.95 10.95 0 0 1-1.675-6.012q0-5.634 3.381-8.688t9.581-3.052a17.4 17.4 0 0 1 4.853.626Zm-27.364 40.075a4.66 4.66 0 0 0 2.348 4.227 12.97 12.97 0 0 0 6.731 1.44q6.544 0 9.691-1.956a5.99 5.99 0 0 0 3.146-5.307q0-2.787-1.722-3.867t-6.481-1.08h-6.23a8.2 8.2 0 0 0-5.511 1.69 6.04 6.04 0 0 0-1.972 4.853m2.818-29.086a6.98 6.98 0 0 0 2.035 5.448 8.12 8.12 0 0 0 5.667 1.847q7.607 0 7.608-7.389 0-7.733-7.7-7.733a7.63 7.63 0 0 0-5.635 1.972q-1.975 1.973-1.975 5.855",className:"logo_small_svg__cls-2","data-name":"Path 2945"})),v||(v=n.createElement("path",{id:"logo_small_svg__Path_2946",d:"M316.778 70.928q-7.608 0-12.007-4.634t-4.4-12.868q0-8.3 4.086-13.181a13.57 13.57 0 0 1 10.974-4.884 12.94 12.94 0 0 1 10.207 4.239q3.762 4.247 3.762 11.2v3.287h-23.643q.156 6.044 3.053 9.174t8.156 3.131a27.6 27.6 0 0 0 10.958-2.317v4.634a27.5 27.5 0 0 1-5.213 1.706 29.3 29.3 0 0 1-5.933.513m-1.409-31.215a8.49 8.49 0 0 0-6.591 2.692 12.4 12.4 0 0 0-2.9 7.452h17.94q0-4.916-2.191-7.53a7.71 7.71 0 0 0-6.258-2.614",className:"logo_small_svg__cls-2","data-name":"Path 2946"})),b||(b=n.createElement("path",{id:"logo_small_svg__Path_2947",d:"M350.9 35.361a20.4 20.4 0 0 1 4.1.375l-.721 4.822a17.7 17.7 0 0 0-3.757-.47 9.14 9.14 0 0 0-7.122 3.382 12.33 12.33 0 0 0-2.959 8.422V70.3h-5.2V35.987h4.29l.6 6.356h.25a15.1 15.1 0 0 1 4.6-5.166 10.36 10.36 0 0 1 5.919-1.816",className:"logo_small_svg__cls-2","data-name":"Path 2947"})),w||(w=n.createElement("path",{id:"logo_small_svg__Path_2948",d:"M255.857 96.638s-3.43-.391-4.85-.391c-2.058 0-3.111.735-3.111 2.18 0 1.568.882 1.935 3.748 2.719 3.527.98 4.8 1.911 4.8 4.777 0 3.675-2.3 5.267-5.61 5.267a36 36 0 0 1-5.487-.662l.27-2.18s3.306.441 5.046.441c2.082 0 3.037-.931 3.037-2.7 0-1.421-.759-1.91-3.331-2.523-3.626-.93-5.193-2.033-5.193-4.948 0-3.381 2.229-4.776 5.585-4.776a37 37 0 0 1 5.315.587Z",className:"logo_small_svg__cls-2","data-name":"Path 2948"})),I||(I=n.createElement("path",{id:"logo_small_svg__Path_2949",d:"M262.967 94.14h4.733l3.748 13.106L275.2 94.14h4.752v16.78H277.2v-14.5h-.145l-4.191 13.816h-2.842l-4.191-13.816h-.145v14.5h-2.719Z",className:"logo_small_svg__cls-2","data-name":"Path 2949"})),x||(x=n.createElement("path",{id:"logo_small_svg__Path_2950",d:"M322.057 94.14H334.3v2.425h-4.728v14.355h-2.743V96.565h-4.777Z",className:"logo_small_svg__cls-2","data-name":"Path 2950"})),B||(B=n.createElement("path",{id:"logo_small_svg__Path_2951",d:"M346.137 94.14c3.332 0 5.12 1.249 5.12 4.361 0 2.033-.637 3.037-1.984 3.772 1.445.563 2.4 1.592 2.4 3.9 0 3.43-2.081 4.752-5.339 4.752h-6.566V94.14Zm-3.65 2.352v4.8h3.6c1.666 0 2.4-.832 2.4-2.474 0-1.617-.833-2.327-2.5-2.327Zm0 7.1v4.973h3.7c1.689 0 2.694-.539 2.694-2.548 0-1.911-1.421-2.425-2.744-2.425Z",className:"logo_small_svg__cls-2","data-name":"Path 2951"})),k||(k=n.createElement("path",{id:"logo_small_svg__Path_2952",d:"M358.414 94.14H369v2.377h-7.864v4.751h6.394v2.332h-6.394v4.924H369v2.4h-10.586Z",className:"logo_small_svg__cls-2","data-name":"Path 2952"})),C||(C=n.createElement("path",{id:"logo_small_svg__Path_2953",d:"M378.747 94.14h5.414l4.164 16.78h-2.744l-1.239-4.92h-5.777l-1.239 4.923h-2.719Zm.361 9.456h4.708l-1.737-7.178h-1.225Z",className:"logo_small_svg__cls-2","data-name":"Path 2953"})),j||(j=n.createElement("path",{id:"logo_small_svg__Path_2954",d:"M397.1 105.947v4.973h-2.719V94.14h6.37c3.7 0 5.683 2.12 5.683 5.843 0 2.376-.956 4.519-2.744 5.352l2.769 5.585h-2.989l-2.426-4.973Zm3.651-9.455H397.1v7.1h3.7c2.057 0 2.841-1.85 2.841-3.589 0-1.9-.934-3.511-2.894-3.511Z",className:"logo_small_svg__cls-2","data-name":"Path 2954"})),q||(q=n.createElement("path",{id:"logo_small_svg__Path_2955",d:"M290.013 94.14h5.413l4.164 16.78h-2.743l-1.239-4.92h-5.777l-1.239 4.923h-2.719Zm.361 9.456h4.707l-1.737-7.178h-1.225Z",className:"logo_small_svg__cls-2","data-name":"Path 2955"})),L||(L=n.createElement("path",{id:"logo_small_svg__Path_2956",d:"M308.362 105.947v4.973h-2.719V94.14h6.369c3.7 0 5.683 2.12 5.683 5.843 0 2.376-.955 4.519-2.743 5.352l2.768 5.585h-2.989l-2.425-4.973Zm3.65-9.455h-3.65v7.1h3.7c2.058 0 2.841-1.85 2.841-3.589-.003-1.903-.931-3.511-2.891-3.511",className:"logo_small_svg__cls-2","data-name":"Path 2956"})),P||(P=n.createElement("path",{id:"logo_small_svg__Path_2957",d:"M130.606 107.643a3.02 3.02 0 0 1-1.18 2.537 5.1 5.1 0 0 1-3.2.91 8 8 0 0 1-3.371-.564v-1.383a9 9 0 0 0 1.652.506 8.7 8.7 0 0 0 1.77.186 3.57 3.57 0 0 0 2.157-.544 1.78 1.78 0 0 0 .725-1.512 1.95 1.95 0 0 0-.257-1.05 2.4 2.4 0 0 0-.86-.754 12 12 0 0 0-1.833-.784 5.84 5.84 0 0 1-2.456-1.458 3.2 3.2 0 0 1-.738-2.2 2.74 2.74 0 0 1 1.071-2.267 4.44 4.44 0 0 1 2.831-.843 8.3 8.3 0 0 1 3.38.675l-.447 1.247a7.6 7.6 0 0 0-2.966-.641 2.88 2.88 0 0 0-1.779.489 1.61 1.61 0 0 0-.64 1.357 2.1 2.1 0 0 0 .236 1.049 2.2 2.2 0 0 0 .8.75 10 10 0 0 0 1.715.754 6.8 6.8 0 0 1 2.667 1.483 2.92 2.92 0 0 1 .723 2.057",className:"logo_small_svg__cls-2","data-name":"Path 2957"})),U||(U=n.createElement("path",{id:"logo_small_svg__Path_2958",d:"M134.447 101.686v5.991a2.4 2.4 0 0 0 .515 1.686 2.1 2.1 0 0 0 1.609.556 2.63 2.63 0 0 0 2.12-.792 4 4 0 0 0 .67-2.587v-4.854h1.4v9.236H139.6l-.2-1.239h-.075a2.8 2.8 0 0 1-1.193 1.045 4 4 0 0 1-1.74.362 3.53 3.53 0 0 1-2.524-.8 3.4 3.4 0 0 1-.839-2.562v-6.042Z",className:"logo_small_svg__cls-2","data-name":"Path 2958"})),D||(D=n.createElement("path",{id:"logo_small_svg__Path_2959",d:"M148.206 111.09a4 4 0 0 1-1.647-.333 3.1 3.1 0 0 1-1.252-1.023h-.1a12 12 0 0 1 .1 1.533v3.8h-1.4v-13.381h1.137l.194 1.264h.067a3.26 3.26 0 0 1 1.256-1.1 3.8 3.8 0 0 1 1.643-.337 3.41 3.41 0 0 1 2.836 1.256 6.68 6.68 0 0 1-.017 7.057 3.42 3.42 0 0 1-2.817 1.264m-.2-8.385a2.48 2.48 0 0 0-2.048.784 4.04 4.04 0 0 0-.649 2.494v.312a4.63 4.63 0 0 0 .649 2.785 2.47 2.47 0 0 0 2.082.839 2.16 2.16 0 0 0 1.875-.969 4.6 4.6 0 0 0 .678-2.671 4.43 4.43 0 0 0-.678-2.651 2.23 2.23 0 0 0-1.915-.923Z",className:"logo_small_svg__cls-2","data-name":"Path 2959"})),z||(z=n.createElement("path",{id:"logo_small_svg__Path_2960",d:"M159.039 111.09a4 4 0 0 1-1.647-.333 3.1 3.1 0 0 1-1.252-1.023h-.1a12 12 0 0 1 .1 1.533v3.8h-1.4v-13.381h1.137l.194 1.264h.067a3.26 3.26 0 0 1 1.256-1.1 3.8 3.8 0 0 1 1.643-.337 3.41 3.41 0 0 1 2.836 1.256 6.68 6.68 0 0 1-.017 7.057 3.42 3.42 0 0 1-2.817 1.264m-.2-8.385a2.48 2.48 0 0 0-2.048.784 4.04 4.04 0 0 0-.649 2.494v.312a4.63 4.63 0 0 0 .649 2.785 2.47 2.47 0 0 0 2.082.839 2.16 2.16 0 0 0 1.875-.969 4.6 4.6 0 0 0 .678-2.671 4.43 4.43 0 0 0-.678-2.651 2.23 2.23 0 0 0-1.911-.923Z",className:"logo_small_svg__cls-2","data-name":"Path 2960"})),W||(W=n.createElement("path",{id:"logo_small_svg__Path_2961",d:"M173.612 106.3a5.1 5.1 0 0 1-1.137 3.527 4 4 0 0 1-3.143 1.268 4.17 4.17 0 0 1-2.2-.581 3.84 3.84 0 0 1-1.483-1.669 5.8 5.8 0 0 1-.522-2.545 5.1 5.1 0 0 1 1.129-3.518 4 4 0 0 1 3.135-1.26 3.9 3.9 0 0 1 3.08 1.29 5.07 5.07 0 0 1 1.141 3.488m-7.036 0a4.4 4.4 0 0 0 .708 2.7 2.81 2.81 0 0 0 4.167 0 4.37 4.37 0 0 0 .712-2.7 4.3 4.3 0 0 0-.712-2.675 2.5 2.5 0 0 0-2.1-.915 2.46 2.46 0 0 0-2.072.9 4.33 4.33 0 0 0-.7 2.69Z",className:"logo_small_svg__cls-2","data-name":"Path 2961"})),V||(V=n.createElement("path",{id:"logo_small_svg__Path_2962",d:"M180.525 101.517a5.5 5.5 0 0 1 1.1.1l-.194 1.3a4.8 4.8 0 0 0-1.011-.127 2.46 2.46 0 0 0-1.917.911 3.32 3.32 0 0 0-.8 2.267v4.955h-1.4v-9.236h1.154l.16 1.71h.068a4.05 4.05 0 0 1 1.238-1.39 2.8 2.8 0 0 1 1.6-.49Z",className:"logo_small_svg__cls-2","data-name":"Path 2962"})),K||(K=n.createElement("path",{id:"logo_small_svg__Path_2963",d:"M187.363 109.936a4.5 4.5 0 0 0 .716-.055 4 4 0 0 0 .548-.114v1.07a2.5 2.5 0 0 1-.67.181 5 5 0 0 1-.8.072q-2.68 0-2.68-2.823v-5.494h-1.323v-.673l1.323-.582.59-1.972h.809v2.141h2.68v1.087h-2.68v5.435a1.87 1.87 0 0 0 .4 1.281 1.38 1.38 0 0 0 1.087.446",className:"logo_small_svg__cls-2","data-name":"Path 2963"})),$||($=n.createElement("path",{id:"logo_small_svg__Path_2964",d:"M194.538 111.09a4.24 4.24 0 0 1-3.231-1.247 4.82 4.82 0 0 1-1.184-3.463 5.36 5.36 0 0 1 1.1-3.548 3.65 3.65 0 0 1 2.954-1.315 3.48 3.48 0 0 1 2.747 1.142 4.38 4.38 0 0 1 1.011 3.013v.885h-6.362a3.66 3.66 0 0 0 .822 2.469 2.84 2.84 0 0 0 2.2.843 7.4 7.4 0 0 0 2.949-.624v1.247a7.4 7.4 0 0 1-1.4.459 8 8 0 0 1-1.6.139Zm-.379-8.4a2.29 2.29 0 0 0-1.774.725 3.34 3.34 0 0 0-.779 2.006h4.828a3.07 3.07 0 0 0-.59-2.027 2.08 2.08 0 0 0-1.685-.706Z",className:"logo_small_svg__cls-2","data-name":"Path 2964"})),H||(H=n.createElement("path",{id:"logo_small_svg__Path_2965",d:"M206.951 109.683h-.076a3.29 3.29 0 0 1-2.9 1.407 3.43 3.43 0 0 1-2.819-1.239 5.45 5.45 0 0 1-1.006-3.522 5.54 5.54 0 0 1 1.011-3.548 3.4 3.4 0 0 1 2.814-1.264 3.36 3.36 0 0 1 2.883 1.365h.109l-.059-.665-.034-.649v-3.759h1.4v13.113h-1.138Zm-2.8.236a2.55 2.55 0 0 0 2.078-.779 3.95 3.95 0 0 0 .644-2.516v-.3a4.64 4.64 0 0 0-.653-2.8 2.48 2.48 0 0 0-2.086-.839 2.14 2.14 0 0 0-1.883.957 4.76 4.76 0 0 0-.653 2.7 4.55 4.55 0 0 0 .649 2.671 2.2 2.2 0 0 0 1.906.906Z",className:"logo_small_svg__cls-2","data-name":"Path 2965"})),Y||(Y=n.createElement("path",{id:"logo_small_svg__Path_2966",d:"M220.712 101.534a3.44 3.44 0 0 1 2.827 1.243 6.65 6.65 0 0 1-.009 7.053 3.42 3.42 0 0 1-2.818 1.26 4 4 0 0 1-1.648-.333 3.1 3.1 0 0 1-1.251-1.023h-.1l-.295 1.188h-1V97.809h1.4V101q0 1.069-.068 1.921h.068a3.32 3.32 0 0 1 2.894-1.387m-.2 1.171a2.44 2.44 0 0 0-2.064.822 6.34 6.34 0 0 0 .017 5.553 2.46 2.46 0 0 0 2.081.839 2.16 2.16 0 0 0 1.922-.94 4.83 4.83 0 0 0 .632-2.7 4.64 4.64 0 0 0-.632-2.689 2.24 2.24 0 0 0-1.959-.885Z",className:"logo_small_svg__cls-2","data-name":"Path 2966"})),Z||(Z=n.createElement("path",{id:"logo_small_svg__Path_2967",d:"M225.758 101.686h1.5l2.023 5.267a20 20 0 0 1 .826 2.6h.067q.109-.431.459-1.471t2.288-6.4h1.5l-3.969 10.518a5.25 5.25 0 0 1-1.378 2.212 2.93 2.93 0 0 1-1.934.653 5.7 5.7 0 0 1-1.264-.143V113.8a5 5 0 0 0 1.037.1 2.136 2.136 0 0 0 2.056-1.618l.514-1.314Z",className:"logo_small_svg__cls-2","data-name":"Path 2967"}))))),components_Logo=()=>n.createElement(logo_small,{height:"40"});var J;function lightbulb_extends(){return lightbulb_extends=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var n in r)({}).hasOwnProperty.call(r,n)&&(t[n]=r[n])}return t},lightbulb_extends.apply(null,arguments)}const lightbulb=t=>n.createElement("svg",lightbulb_extends({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24"},t),J||(J=n.createElement("path",{d:"M12 2a7 7 0 0 0-7 7c0 2.38 1.19 4.47 3 5.74V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.26c1.81-1.27 3-3.36 3-5.74a7 7 0 0 0-7-7M9 21a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1H9z"})));var tt;function lightbulb_off_extends(){return lightbulb_off_extends=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var n in r)({}).hasOwnProperty.call(r,n)&&(t[n]=r[n])}return t},lightbulb_off_extends.apply(null,arguments)}const lightbulb_off=t=>n.createElement("svg",lightbulb_off_extends({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 24 24"},t),tt||(tt=n.createElement("path",{d:"M12 2C9.76 2 7.78 3.05 6.5 4.68l9.81 9.82C17.94 13.21 19 11.24 19 9a7 7 0 0 0-7-7M3.28 4 2 5.27 5.04 8.3C5 8.53 5 8.76 5 9c0 2.38 1.19 4.47 3 5.74V17a1 1 0 0 0 1 1h5.73l4 4L20 20.72zM9 20v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1z"})));class DarkModeToggle extends n.Component{constructor(t){super(t),this.state={isDarkMode:!1},this.toggleIsDarkMode=this.toggleIsDarkMode.bind(this)}componentDidMount(){window.matchMedia("(prefers-color-scheme: dark)").matches&&(document.documentElement.classList.add("dark-mode"),this.setState({isDarkMode:!0}))}toggleIsDarkMode(){document.documentElement.classList.toggle("dark-mode"),this.setState((t=>({isDarkMode:!t.isDarkMode})))}render(){const{isDarkMode:t}=this.state;return n.createElement("div",{className:"dark-mode-toggle"},n.createElement("button",{onClick:this.toggleIsDarkMode},t?n.createElement(lightbulb,{height:"24"}):n.createElement(lightbulb_off,{height:"24"})))}}const et=DarkModeToggle,top_bar=()=>({components:{Topbar:u,Logo:components_Logo,DarkModeToggle:et}});function isNothing(t){return null==t}var rt={isNothing,isObject:function js_yaml_isObject(t){return"object"==typeof t&&null!==t},toArray:function toArray(t){return Array.isArray(t)?t:isNothing(t)?[]:[t]},repeat:function repeat(t,e){var r,n="";for(r=0;r<e;r+=1)n+=t;return n},isNegativeZero:function isNegativeZero(t){return 0===t&&Number.NEGATIVE_INFINITY===1/t},extend:function extend(t,e){var r,n,o,i;if(e)for(r=0,n=(i=Object.keys(e)).length;r<n;r+=1)t[o=i[r]]=e[o];return t}};function formatError(t,e){var r="",n=t.reason||"(unknown reason)";return t.mark?(t.mark.name&&(r+='in "'+t.mark.name+'" '),r+="("+(t.mark.line+1)+":"+(t.mark.column+1)+")",!e&&t.mark.snippet&&(r+="\n\n"+t.mark.snippet),n+" "+r):n}function YAMLException$1(t,e){Error.call(this),this.name="YAMLException",this.reason=t,this.mark=e,this.message=formatError(this,!1),Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):this.stack=(new Error).stack||""}YAMLException$1.prototype=Object.create(Error.prototype),YAMLException$1.prototype.constructor=YAMLException$1,YAMLException$1.prototype.toString=function toString(t){return this.name+": "+formatError(this,t)};var nt=YAMLException$1;function getLine(t,e,r,n,o){var i="",a="",s=Math.floor(o/2)-1;return n-e>s&&(e=n-s+(i=" ... ").length),r-n>s&&(r=n+s-(a=" ...").length),{str:i+t.slice(e,r).replace(/\t/g,"→")+a,pos:n-e+i.length}}function padStart(t,e){return rt.repeat(" ",e-t.length)+t}var ot=function makeSnippet(t,e){if(e=Object.create(e||null),!t.buffer)return null;e.maxLength||(e.maxLength=79),"number"!=typeof e.indent&&(e.indent=1),"number"!=typeof e.linesBefore&&(e.linesBefore=3),"number"!=typeof e.linesAfter&&(e.linesAfter=2);for(var r,n=/\r?\n|\r|\0/g,o=[0],i=[],a=-1;r=n.exec(t.buffer);)i.push(r.index),o.push(r.index+r[0].length),t.position<=r.index&&a<0&&(a=o.length-2);a<0&&(a=o.length-1);var s,u,c="",f=Math.min(t.line+e.linesAfter,i.length).toString().length,l=e.maxLength-(e.indent+f+3);for(s=1;s<=e.linesBefore&&!(a-s<0);s++)u=getLine(t.buffer,o[a-s],i[a-s],t.position-(o[a]-o[a-s]),l),c=rt.repeat(" ",e.indent)+padStart((t.line-s+1).toString(),f)+" | "+u.str+"\n"+c;for(u=getLine(t.buffer,o[a],i[a],t.position,l),c+=rt.repeat(" ",e.indent)+padStart((t.line+1).toString(),f)+" | "+u.str+"\n",c+=rt.repeat("-",e.indent+f+3+u.pos)+"^\n",s=1;s<=e.linesAfter&&!(a+s>=i.length);s++)u=getLine(t.buffer,o[a+s],i[a+s],t.position-(o[a]-o[a+s]),l),c+=rt.repeat(" ",e.indent)+padStart((t.line+s+1).toString(),f)+" | "+u.str+"\n";return c.replace(/\n$/,"")},it=["kind","multi","resolve","construct","instanceOf","predicate","represent","representName","defaultStyle","styleAliases"],at=["scalar","sequence","mapping"];var st=function Type$1(t,e){if(e=e||{},Object.keys(e).forEach((function(e){if(-1===it.indexOf(e))throw new nt('Unknown option "'+e+'" is met in definition of "'+t+'" YAML type.')})),this.options=e,this.tag=t,this.kind=e.kind||null,this.resolve=e.resolve||function(){return!0},this.construct=e.construct||function(t){return t},this.instanceOf=e.instanceOf||null,this.predicate=e.predicate||null,this.represent=e.represent||null,this.representName=e.representName||null,this.defaultStyle=e.defaultStyle||null,this.multi=e.multi||!1,this.styleAliases=function compileStyleAliases(t){var e={};return null!==t&&Object.keys(t).forEach((function(r){t[r].forEach((function(t){e[String(t)]=r}))})),e}(e.styleAliases||null),-1===at.indexOf(this.kind))throw new nt('Unknown kind "'+this.kind+'" is specified for "'+t+'" YAML type.')};function compileList(t,e){var r=[];return t[e].forEach((function(t){var e=r.length;r.forEach((function(r,n){r.tag===t.tag&&r.kind===t.kind&&r.multi===t.multi&&(e=n)})),r[e]=t})),r}function Schema$1(t){return this.extend(t)}Schema$1.prototype.extend=function extend(t){var e=[],r=[];if(t instanceof st)r.push(t);else if(Array.isArray(t))r=r.concat(t);else{if(!t||!Array.isArray(t.implicit)&&!Array.isArray(t.explicit))throw new nt("Schema.extend argument should be a Type, [ Type ], or a schema definition ({ implicit: [...], explicit: [...] })");t.implicit&&(e=e.concat(t.implicit)),t.explicit&&(r=r.concat(t.explicit))}e.forEach((function(t){if(!(t instanceof st))throw new nt("Specified list of YAML types (or a single Type object) contains a non-Type object.");if(t.loadKind&&"scalar"!==t.loadKind)throw new nt("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");if(t.multi)throw new nt("There is a multi type in the implicit list of a schema. Multi tags can only be listed as explicit.")})),r.forEach((function(t){if(!(t instanceof st))throw new nt("Specified list of YAML types (or a single Type object) contains a non-Type object.")}));var n=Object.create(Schema$1.prototype);return n.implicit=(this.implicit||[]).concat(e),n.explicit=(this.explicit||[]).concat(r),n.compiledImplicit=compileList(n,"implicit"),n.compiledExplicit=compileList(n,"explicit"),n.compiledTypeMap=function compileMap(){var t,e,r={scalar:{},sequence:{},mapping:{},fallback:{},multi:{scalar:[],sequence:[],mapping:[],fallback:[]}};function collectType(t){t.multi?(r.multi[t.kind].push(t),r.multi.fallback.push(t)):r[t.kind][t.tag]=r.fallback[t.tag]=t}for(t=0,e=arguments.length;t<e;t+=1)arguments[t].forEach(collectType);return r}(n.compiledImplicit,n.compiledExplicit),n};var ut=Schema$1,ct=new st("tag:yaml.org,2002:str",{kind:"scalar",construct:function(t){return null!==t?t:""}}),lt=new st("tag:yaml.org,2002:seq",{kind:"sequence",construct:function(t){return null!==t?t:[]}}),pt=new st("tag:yaml.org,2002:map",{kind:"mapping",construct:function(t){return null!==t?t:{}}}),ht=new ut({explicit:[ct,lt,pt]});var dt=new st("tag:yaml.org,2002:null",{kind:"scalar",resolve:function resolveYamlNull(t){if(null===t)return!0;var e=t.length;return 1===e&&"~"===t||4===e&&("null"===t||"Null"===t||"NULL"===t)},construct:function constructYamlNull(){return null},predicate:function isNull(t){return null===t},represent:{canonical:function(){return"~"},lowercase:function(){return"null"},uppercase:function(){return"NULL"},camelcase:function(){return"Null"},empty:function(){return""}},defaultStyle:"lowercase"});var yt=new st("tag:yaml.org,2002:bool",{kind:"scalar",resolve:function resolveYamlBoolean(t){if(null===t)return!1;var e=t.length;return 4===e&&("true"===t||"True"===t||"TRUE"===t)||5===e&&("false"===t||"False"===t||"FALSE"===t)},construct:function constructYamlBoolean(t){return"true"===t||"True"===t||"TRUE"===t},predicate:function isBoolean(t){return"[object Boolean]"===Object.prototype.toString.call(t)},represent:{lowercase:function(t){return t?"true":"false"},uppercase:function(t){return t?"TRUE":"FALSE"},camelcase:function(t){return t?"True":"False"}},defaultStyle:"lowercase"});function isOctCode(t){return 48<=t&&t<=55}function isDecCode(t){return 48<=t&&t<=57}var _t=new st("tag:yaml.org,2002:int",{kind:"scalar",resolve:function resolveYamlInteger(t){if(null===t)return!1;var e,r,n=t.length,o=0,i=!1;if(!n)return!1;if("-"!==(e=t[o])&&"+"!==e||(e=t[++o]),"0"===e){if(o+1===n)return!0;if("b"===(e=t[++o])){for(o++;o<n;o++)if("_"!==(e=t[o])){if("0"!==e&&"1"!==e)return!1;i=!0}return i&&"_"!==e}if("x"===e){for(o++;o<n;o++)if("_"!==(e=t[o])){if(!(48<=(r=t.charCodeAt(o))&&r<=57||65<=r&&r<=70||97<=r&&r<=102))return!1;i=!0}return i&&"_"!==e}if("o"===e){for(o++;o<n;o++)if("_"!==(e=t[o])){if(!isOctCode(t.charCodeAt(o)))return!1;i=!0}return i&&"_"!==e}}if("_"===e)return!1;for(;o<n;o++)if("_"!==(e=t[o])){if(!isDecCode(t.charCodeAt(o)))return!1;i=!0}return!(!i||"_"===e)},construct:function constructYamlInteger(t){var e,r=t,n=1;if(-1!==r.indexOf("_")&&(r=r.replace(/_/g,"")),"-"!==(e=r[0])&&"+"!==e||("-"===e&&(n=-1),e=(r=r.slice(1))[0]),"0"===r)return 0;if("0"===e){if("b"===r[1])return n*parseInt(r.slice(2),2);if("x"===r[1])return n*parseInt(r.slice(2),16);if("o"===r[1])return n*parseInt(r.slice(2),8)}return n*parseInt(r,10)},predicate:function isInteger(t){return"[object Number]"===Object.prototype.toString.call(t)&&t%1==0&&!rt.isNegativeZero(t)},represent:{binary:function(t){return t>=0?"0b"+t.toString(2):"-0b"+t.toString(2).slice(1)},octal:function(t){return t>=0?"0o"+t.toString(8):"-0o"+t.toString(8).slice(1)},decimal:function(t){return t.toString(10)},hexadecimal:function(t){return t>=0?"0x"+t.toString(16).toUpperCase():"-0x"+t.toString(16).toUpperCase().slice(1)}},defaultStyle:"decimal",styleAliases:{binary:[2,"bin"],octal:[8,"oct"],decimal:[10,"dec"],hexadecimal:[16,"hex"]}}),gt=new RegExp("^(?:[-+]?(?:[0-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$");var mt=/^[-+]?[0-9]+e/;var vt=new st("tag:yaml.org,2002:float",{kind:"scalar",resolve:function resolveYamlFloat(t){return null!==t&&!(!gt.test(t)||"_"===t[t.length-1])},construct:function constructYamlFloat(t){var e,r;return r="-"===(e=t.replace(/_/g,"").toLowerCase())[0]?-1:1,"+-".indexOf(e[0])>=0&&(e=e.slice(1)),".inf"===e?1===r?Number.POSITIVE_INFINITY:Number.NEGATIVE_INFINITY:".nan"===e?NaN:r*parseFloat(e,10)},predicate:function isFloat(t){return"[object Number]"===Object.prototype.toString.call(t)&&(t%1!=0||rt.isNegativeZero(t))},represent:function representYamlFloat(t,e){var r;if(isNaN(t))switch(e){case"lowercase":return".nan";case"uppercase":return".NAN";case"camelcase":return".NaN"}else if(Number.POSITIVE_INFINITY===t)switch(e){case"lowercase":return".inf";case"uppercase":return".INF";case"camelcase":return".Inf"}else if(Number.NEGATIVE_INFINITY===t)switch(e){case"lowercase":return"-.inf";case"uppercase":return"-.INF";case"camelcase":return"-.Inf"}else if(rt.isNegativeZero(t))return"-0.0";return r=t.toString(10),mt.test(r)?r.replace("e",".e"):r},defaultStyle:"lowercase"}),bt=ht.extend({implicit:[dt,yt,_t,vt]}),St=bt,wt=new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"),It=new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$");var xt=new st("tag:yaml.org,2002:timestamp",{kind:"scalar",resolve:function resolveYamlTimestamp(t){return null!==t&&(null!==wt.exec(t)||null!==It.exec(t))},construct:function constructYamlTimestamp(t){var e,r,n,o,i,a,s,u,c=0,f=null;if(null===(e=wt.exec(t))&&(e=It.exec(t)),null===e)throw new Error("Date resolve error");if(r=+e[1],n=+e[2]-1,o=+e[3],!e[4])return new Date(Date.UTC(r,n,o));if(i=+e[4],a=+e[5],s=+e[6],e[7]){for(c=e[7].slice(0,3);c.length<3;)c+="0";c=+c}return e[9]&&(f=6e4*(60*+e[10]+ +(e[11]||0)),"-"===e[9]&&(f=-f)),u=new Date(Date.UTC(r,n,o,i,a,s,c)),f&&u.setTime(u.getTime()-f),u},instanceOf:Date,represent:function representYamlTimestamp(t){return t.toISOString()}});var Et=new st("tag:yaml.org,2002:merge",{kind:"scalar",resolve:function resolveYamlMerge(t){return"<<"===t||null===t}}),At="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r";var Ot=new st("tag:yaml.org,2002:binary",{kind:"scalar",resolve:function resolveYamlBinary(t){if(null===t)return!1;var e,r,n=0,o=t.length,i=At;for(r=0;r<o;r++)if(!((e=i.indexOf(t.charAt(r)))>64)){if(e<0)return!1;n+=6}return n%8==0},construct:function constructYamlBinary(t){var e,r,n=t.replace(/[\r\n=]/g,""),o=n.length,i=At,a=0,s=[];for(e=0;e<o;e++)e%4==0&&e&&(s.push(a>>16&255),s.push(a>>8&255),s.push(255&a)),a=a<<6|i.indexOf(n.charAt(e));return 0===(r=o%4*6)?(s.push(a>>16&255),s.push(a>>8&255),s.push(255&a)):18===r?(s.push(a>>10&255),s.push(a>>2&255)):12===r&&s.push(a>>4&255),new Uint8Array(s)},predicate:function isBinary(t){return"[object Uint8Array]"===Object.prototype.toString.call(t)},represent:function representYamlBinary(t){var e,r,n="",o=0,i=t.length,a=At;for(e=0;e<i;e++)e%3==0&&e&&(n+=a[o>>18&63],n+=a[o>>12&63],n+=a[o>>6&63],n+=a[63&o]),o=(o<<8)+t[e];return 0===(r=i%3)?(n+=a[o>>18&63],n+=a[o>>12&63],n+=a[o>>6&63],n+=a[63&o]):2===r?(n+=a[o>>10&63],n+=a[o>>4&63],n+=a[o<<2&63],n+=a[64]):1===r&&(n+=a[o>>2&63],n+=a[o<<4&63],n+=a[64],n+=a[64]),n}}),Bt=Object.prototype.hasOwnProperty,kt=Object.prototype.toString;var Mt=new st("tag:yaml.org,2002:omap",{kind:"sequence",resolve:function resolveYamlOmap(t){if(null===t)return!0;var e,r,n,o,i,a=[],s=t;for(e=0,r=s.length;e<r;e+=1){if(n=s[e],i=!1,"[object Object]"!==kt.call(n))return!1;for(o in n)if(Bt.call(n,o)){if(i)return!1;i=!0}if(!i)return!1;if(-1!==a.indexOf(o))return!1;a.push(o)}return!0},construct:function constructYamlOmap(t){return null!==t?t:[]}}),Ct=Object.prototype.toString;var jt=new st("tag:yaml.org,2002:pairs",{kind:"sequence",resolve:function resolveYamlPairs(t){if(null===t)return!0;var e,r,n,o,i,a=t;for(i=new Array(a.length),e=0,r=a.length;e<r;e+=1){if(n=a[e],"[object Object]"!==Ct.call(n))return!1;if(1!==(o=Object.keys(n)).length)return!1;i[e]=[o[0],n[o[0]]]}return!0},construct:function constructYamlPairs(t){if(null===t)return[];var e,r,n,o,i,a=t;for(i=new Array(a.length),e=0,r=a.length;e<r;e+=1)n=a[e],o=Object.keys(n),i[e]=[o[0],n[o[0]]];return i}}),qt=Object.prototype.hasOwnProperty;var Lt=new st("tag:yaml.org,2002:set",{kind:"mapping",resolve:function resolveYamlSet(t){if(null===t)return!0;var e,r=t;for(e in r)if(qt.call(r,e)&&null!==r[e])return!1;return!0},construct:function constructYamlSet(t){return null!==t?t:{}}}),Nt=St.extend({implicit:[xt,Et],explicit:[Ot,Mt,jt,Lt]}),Tt=Object.prototype.hasOwnProperty,Pt=/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/,Rt=/[\x85\u2028\u2029]/,Ft=/[,\[\]\{\}]/,Ut=/^(?:!|!!|![a-z\-]+!)$/i,Dt=/^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;function _class(t){return Object.prototype.toString.call(t)}function is_EOL(t){return 10===t||13===t}function is_WHITE_SPACE(t){return 9===t||32===t}function is_WS_OR_EOL(t){return 9===t||32===t||10===t||13===t}function is_FLOW_INDICATOR(t){return 44===t||91===t||93===t||123===t||125===t}function fromHexCode(t){var e;return 48<=t&&t<=57?t-48:97<=(e=32|t)&&e<=102?e-97+10:-1}function simpleEscapeSequence(t){return 48===t?"\0":97===t?"":98===t?"\b":116===t||9===t?"\t":110===t?"\n":118===t?"\v":102===t?"\f":114===t?"\r":101===t?"":32===t?" ":34===t?'"':47===t?"/":92===t?"\\":78===t?"":95===t?" ":76===t?"\u2028":80===t?"\u2029":""}function charFromCodepoint(t){return t<=65535?String.fromCharCode(t):String.fromCharCode(55296+(t-65536>>10),56320+(t-65536&1023))}function setProperty(t,e,r){"__proto__"===e?Object.defineProperty(t,e,{configurable:!0,enumerable:!0,writable:!0,value:r}):t[e]=r}for(var zt=new Array(256),Wt=new Array(256),Vt=0;Vt<256;Vt++)zt[Vt]=simpleEscapeSequence(Vt)?1:0,Wt[Vt]=simpleEscapeSequence(Vt);function State$1(t,e){this.input=t,this.filename=e.filename||null,this.schema=e.schema||Nt,this.onWarning=e.onWarning||null,this.legacy=e.legacy||!1,this.json=e.json||!1,this.listener=e.listener||null,this.implicitTypes=this.schema.compiledImplicit,this.typeMap=this.schema.compiledTypeMap,this.length=t.length,this.position=0,this.line=0,this.lineStart=0,this.lineIndent=0,this.firstTabInLine=-1,this.documents=[]}function generateError(t,e){var r={name:t.filename,buffer:t.input.slice(0,-1),position:t.position,line:t.line,column:t.position-t.lineStart};return r.snippet=ot(r),new nt(e,r)}function throwError(t,e){throw generateError(t,e)}function throwWarning(t,e){t.onWarning&&t.onWarning.call(null,generateError(t,e))}var Kt={YAML:function handleYamlDirective(t,e,r){var n,o,i;null!==t.version&&throwError(t,"duplication of %YAML directive"),1!==r.length&&throwError(t,"YAML directive accepts exactly one argument"),null===(n=/^([0-9]+)\.([0-9]+)$/.exec(r[0]))&&throwError(t,"ill-formed argument of the YAML directive"),o=parseInt(n[1],10),i=parseInt(n[2],10),1!==o&&throwError(t,"unacceptable YAML version of the document"),t.version=r[0],t.checkLineBreaks=i<2,1!==i&&2!==i&&throwWarning(t,"unsupported YAML version of the document")},TAG:function handleTagDirective(t,e,r){var n,o;2!==r.length&&throwError(t,"TAG directive accepts exactly two arguments"),n=r[0],o=r[1],Ut.test(n)||throwError(t,"ill-formed tag handle (first argument) of the TAG directive"),Tt.call(t.tagMap,n)&&throwError(t,'there is a previously declared suffix for "'+n+'" tag handle'),Dt.test(o)||throwError(t,"ill-formed tag prefix (second argument) of the TAG directive");try{o=decodeURIComponent(o)}catch(e){throwError(t,"tag prefix is malformed: "+o)}t.tagMap[n]=o}};function captureSegment(t,e,r,n){var o,i,a,s;if(e<r){if(s=t.input.slice(e,r),n)for(o=0,i=s.length;o<i;o+=1)9===(a=s.charCodeAt(o))||32<=a&&a<=1114111||throwError(t,"expected valid JSON character");else Pt.test(s)&&throwError(t,"the stream contains non-printable characters");t.result+=s}}function mergeMappings(t,e,r,n){var o,i,a,s;for(rt.isObject(r)||throwError(t,"cannot merge mappings; the provided source object is unacceptable"),a=0,s=(o=Object.keys(r)).length;a<s;a+=1)i=o[a],Tt.call(e,i)||(setProperty(e,i,r[i]),n[i]=!0)}function storeMappingPair(t,e,r,n,o,i,a,s,u){var c,f;if(Array.isArray(o))for(c=0,f=(o=Array.prototype.slice.call(o)).length;c<f;c+=1)Array.isArray(o[c])&&throwError(t,"nested arrays are not supported inside keys"),"object"==typeof o&&"[object Object]"===_class(o[c])&&(o[c]="[object Object]");if("object"==typeof o&&"[object Object]"===_class(o)&&(o="[object Object]"),o=String(o),null===e&&(e={}),"tag:yaml.org,2002:merge"===n)if(Array.isArray(i))for(c=0,f=i.length;c<f;c+=1)mergeMappings(t,e,i[c],r);else mergeMappings(t,e,i,r);else t.json||Tt.call(r,o)||!Tt.call(e,o)||(t.line=a||t.line,t.lineStart=s||t.lineStart,t.position=u||t.position,throwError(t,"duplicated mapping key")),setProperty(e,o,i),delete r[o];return e}function readLineBreak(t){var e;10===(e=t.input.charCodeAt(t.position))?t.position++:13===e?(t.position++,10===t.input.charCodeAt(t.position)&&t.position++):throwError(t,"a line break is expected"),t.line+=1,t.lineStart=t.position,t.firstTabInLine=-1}function skipSeparationSpace(t,e,r){for(var n=0,o=t.input.charCodeAt(t.position);0!==o;){for(;is_WHITE_SPACE(o);)9===o&&-1===t.firstTabInLine&&(t.firstTabInLine=t.position),o=t.input.charCodeAt(++t.position);if(e&&35===o)do{o=t.input.charCodeAt(++t.position)}while(10!==o&&13!==o&&0!==o);if(!is_EOL(o))break;for(readLineBreak(t),o=t.input.charCodeAt(t.position),n++,t.lineIndent=0;32===o;)t.lineIndent++,o=t.input.charCodeAt(++t.position)}return-1!==r&&0!==n&&t.lineIndent<r&&throwWarning(t,"deficient indentation"),n}function testDocumentSeparator(t){var e,r=t.position;return!(45!==(e=t.input.charCodeAt(r))&&46!==e||e!==t.input.charCodeAt(r+1)||e!==t.input.charCodeAt(r+2)||(r+=3,0!==(e=t.input.charCodeAt(r))&&!is_WS_OR_EOL(e)))}function writeFoldedLines(t,e){1===e?t.result+=" ":e>1&&(t.result+=rt.repeat("\n",e-1))}function readBlockSequence(t,e){var r,n,o=t.tag,i=t.anchor,a=[],s=!1;if(-1!==t.firstTabInLine)return!1;for(null!==t.anchor&&(t.anchorMap[t.anchor]=a),n=t.input.charCodeAt(t.position);0!==n&&(-1!==t.firstTabInLine&&(t.position=t.firstTabInLine,throwError(t,"tab characters must not be used in indentation")),45===n)&&is_WS_OR_EOL(t.input.charCodeAt(t.position+1));)if(s=!0,t.position++,skipSeparationSpace(t,!0,-1)&&t.lineIndent<=e)a.push(null),n=t.input.charCodeAt(t.position);else if(r=t.line,composeNode(t,e,3,!1,!0),a.push(t.result),skipSeparationSpace(t,!0,-1),n=t.input.charCodeAt(t.position),(t.line===r||t.lineIndent>e)&&0!==n)throwError(t,"bad indentation of a sequence entry");else if(t.lineIndent<e)break;return!!s&&(t.tag=o,t.anchor=i,t.kind="sequence",t.result=a,!0)}function readTagProperty(t){var e,r,n,o,i=!1,a=!1;if(33!==(o=t.input.charCodeAt(t.position)))return!1;if(null!==t.tag&&throwError(t,"duplication of a tag property"),60===(o=t.input.charCodeAt(++t.position))?(i=!0,o=t.input.charCodeAt(++t.position)):33===o?(a=!0,r="!!",o=t.input.charCodeAt(++t.position)):r="!",e=t.position,i){do{o=t.input.charCodeAt(++t.position)}while(0!==o&&62!==o);t.position<t.length?(n=t.input.slice(e,t.position),o=t.input.charCodeAt(++t.position)):throwError(t,"unexpected end of the stream within a verbatim tag")}else{for(;0!==o&&!is_WS_OR_EOL(o);)33===o&&(a?throwError(t,"tag suffix cannot contain exclamation marks"):(r=t.input.slice(e-1,t.position+1),Ut.test(r)||throwError(t,"named tag handle cannot contain such characters"),a=!0,e=t.position+1)),o=t.input.charCodeAt(++t.position);n=t.input.slice(e,t.position),Ft.test(n)&&throwError(t,"tag suffix cannot contain flow indicator characters")}n&&!Dt.test(n)&&throwError(t,"tag name cannot contain such characters: "+n);try{n=decodeURIComponent(n)}catch(e){throwError(t,"tag name is malformed: "+n)}return i?t.tag=n:Tt.call(t.tagMap,r)?t.tag=t.tagMap[r]+n:"!"===r?t.tag="!"+n:"!!"===r?t.tag="tag:yaml.org,2002:"+n:throwError(t,'undeclared tag handle "'+r+'"'),!0}function readAnchorProperty(t){var e,r;if(38!==(r=t.input.charCodeAt(t.position)))return!1;for(null!==t.anchor&&throwError(t,"duplication of an anchor property"),r=t.input.charCodeAt(++t.position),e=t.position;0!==r&&!is_WS_OR_EOL(r)&&!is_FLOW_INDICATOR(r);)r=t.input.charCodeAt(++t.position);return t.position===e&&throwError(t,"name of an anchor node must contain at least one character"),t.anchor=t.input.slice(e,t.position),!0}function composeNode(t,e,r,n,o){var i,a,s,u,c,f,l,p,h,d=1,y=!1,_=!1;if(null!==t.listener&&t.listener("open",t),t.tag=null,t.anchor=null,t.kind=null,t.result=null,i=a=s=4===r||3===r,n&&skipSeparationSpace(t,!0,-1)&&(y=!0,t.lineIndent>e?d=1:t.lineIndent===e?d=0:t.lineIndent<e&&(d=-1)),1===d)for(;readTagProperty(t)||readAnchorProperty(t);)skipSeparationSpace(t,!0,-1)?(y=!0,s=i,t.lineIndent>e?d=1:t.lineIndent===e?d=0:t.lineIndent<e&&(d=-1)):s=!1;if(s&&(s=y||o),1!==d&&4!==r||(p=1===r||2===r?e:e+1,h=t.position-t.lineStart,1===d?s&&(readBlockSequence(t,h)||function readBlockMapping(t,e,r){var n,o,i,a,s,u,c,f=t.tag,l=t.anchor,p={},h=Object.create(null),d=null,y=null,_=null,g=!1,m=!1;if(-1!==t.firstTabInLine)return!1;for(null!==t.anchor&&(t.anchorMap[t.anchor]=p),c=t.input.charCodeAt(t.position);0!==c;){if(g||-1===t.firstTabInLine||(t.position=t.firstTabInLine,throwError(t,"tab characters must not be used in indentation")),n=t.input.charCodeAt(t.position+1),i=t.line,63!==c&&58!==c||!is_WS_OR_EOL(n)){if(a=t.line,s=t.lineStart,u=t.position,!composeNode(t,r,2,!1,!0))break;if(t.line===i){for(c=t.input.charCodeAt(t.position);is_WHITE_SPACE(c);)c=t.input.charCodeAt(++t.position);if(58===c)is_WS_OR_EOL(c=t.input.charCodeAt(++t.position))||throwError(t,"a whitespace character is expected after the key-value separator within a block mapping"),g&&(storeMappingPair(t,p,h,d,y,null,a,s,u),d=y=_=null),m=!0,g=!1,o=!1,d=t.tag,y=t.result;else{if(!m)return t.tag=f,t.anchor=l,!0;throwError(t,"can not read an implicit mapping pair; a colon is missed")}}else{if(!m)return t.tag=f,t.anchor=l,!0;throwError(t,"can not read a block mapping entry; a multiline key may not be an implicit key")}}else 63===c?(g&&(storeMappingPair(t,p,h,d,y,null,a,s,u),d=y=_=null),m=!0,g=!0,o=!0):g?(g=!1,o=!0):throwError(t,"incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line"),t.position+=1,c=n;if((t.line===i||t.lineIndent>e)&&(g&&(a=t.line,s=t.lineStart,u=t.position),composeNode(t,e,4,!0,o)&&(g?y=t.result:_=t.result),g||(storeMappingPair(t,p,h,d,y,_,a,s,u),d=y=_=null),skipSeparationSpace(t,!0,-1),c=t.input.charCodeAt(t.position)),(t.line===i||t.lineIndent>e)&&0!==c)throwError(t,"bad indentation of a mapping entry");else if(t.lineIndent<e)break}return g&&storeMappingPair(t,p,h,d,y,null,a,s,u),m&&(t.tag=f,t.anchor=l,t.kind="mapping",t.result=p),m}(t,h,p))||function readFlowCollection(t,e){var r,n,o,i,a,s,u,c,f,l,p,h,d=!0,y=t.tag,_=t.anchor,g=Object.create(null);if(91===(h=t.input.charCodeAt(t.position)))a=93,c=!1,i=[];else{if(123!==h)return!1;a=125,c=!0,i={}}for(null!==t.anchor&&(t.anchorMap[t.anchor]=i),h=t.input.charCodeAt(++t.position);0!==h;){if(skipSeparationSpace(t,!0,e),(h=t.input.charCodeAt(t.position))===a)return t.position++,t.tag=y,t.anchor=_,t.kind=c?"mapping":"sequence",t.result=i,!0;d?44===h&&throwError(t,"expected the node content, but found ','"):throwError(t,"missed comma between flow collection entries"),p=null,s=u=!1,63===h&&is_WS_OR_EOL(t.input.charCodeAt(t.position+1))&&(s=u=!0,t.position++,skipSeparationSpace(t,!0,e)),r=t.line,n=t.lineStart,o=t.position,composeNode(t,e,1,!1,!0),l=t.tag,f=t.result,skipSeparationSpace(t,!0,e),h=t.input.charCodeAt(t.position),!u&&t.line!==r||58!==h||(s=!0,h=t.input.charCodeAt(++t.position),skipSeparationSpace(t,!0,e),composeNode(t,e,1,!1,!0),p=t.result),c?storeMappingPair(t,i,g,l,f,p,r,n,o):s?i.push(storeMappingPair(t,null,g,l,f,p,r,n,o)):i.push(f),skipSeparationSpace(t,!0,e),44===(h=t.input.charCodeAt(t.position))?(d=!0,h=t.input.charCodeAt(++t.position)):d=!1}throwError(t,"unexpected end of the stream within a flow collection")}(t,p)?_=!0:(a&&function readBlockScalar(t,e){var r,n,o,i,a,s=1,u=!1,c=!1,f=e,l=0,p=!1;if(124===(i=t.input.charCodeAt(t.position)))n=!1;else{if(62!==i)return!1;n=!0}for(t.kind="scalar",t.result="";0!==i;)if(43===(i=t.input.charCodeAt(++t.position))||45===i)1===s?s=43===i?3:2:throwError(t,"repeat of a chomping mode identifier");else{if(!((o=48<=(a=i)&&a<=57?a-48:-1)>=0))break;0===o?throwError(t,"bad explicit indentation width of a block scalar; it cannot be less than one"):c?throwError(t,"repeat of an indentation width identifier"):(f=e+o-1,c=!0)}if(is_WHITE_SPACE(i)){do{i=t.input.charCodeAt(++t.position)}while(is_WHITE_SPACE(i));if(35===i)do{i=t.input.charCodeAt(++t.position)}while(!is_EOL(i)&&0!==i)}for(;0!==i;){for(readLineBreak(t),t.lineIndent=0,i=t.input.charCodeAt(t.position);(!c||t.lineIndent<f)&&32===i;)t.lineIndent++,i=t.input.charCodeAt(++t.position);if(!c&&t.lineIndent>f&&(f=t.lineIndent),is_EOL(i))l++;else{if(t.lineIndent<f){3===s?t.result+=rt.repeat("\n",u?1+l:l):1===s&&u&&(t.result+="\n");break}for(n?is_WHITE_SPACE(i)?(p=!0,t.result+=rt.repeat("\n",u?1+l:l)):p?(p=!1,t.result+=rt.repeat("\n",l+1)):0===l?u&&(t.result+=" "):t.result+=rt.repeat("\n",l):t.result+=rt.repeat("\n",u?1+l:l),u=!0,c=!0,l=0,r=t.position;!is_EOL(i)&&0!==i;)i=t.input.charCodeAt(++t.position);captureSegment(t,r,t.position,!1)}}return!0}(t,p)||function readSingleQuotedScalar(t,e){var r,n,o;if(39!==(r=t.input.charCodeAt(t.position)))return!1;for(t.kind="scalar",t.result="",t.position++,n=o=t.position;0!==(r=t.input.charCodeAt(t.position));)if(39===r){if(captureSegment(t,n,t.position,!0),39!==(r=t.input.charCodeAt(++t.position)))return!0;n=t.position,t.position++,o=t.position}else is_EOL(r)?(captureSegment(t,n,o,!0),writeFoldedLines(t,skipSeparationSpace(t,!1,e)),n=o=t.position):t.position===t.lineStart&&testDocumentSeparator(t)?throwError(t,"unexpected end of the document within a single quoted scalar"):(t.position++,o=t.position);throwError(t,"unexpected end of the stream within a single quoted scalar")}(t,p)||function readDoubleQuotedScalar(t,e){var r,n,o,i,a,s,u;if(34!==(s=t.input.charCodeAt(t.position)))return!1;for(t.kind="scalar",t.result="",t.position++,r=n=t.position;0!==(s=t.input.charCodeAt(t.position));){if(34===s)return captureSegment(t,r,t.position,!0),t.position++,!0;if(92===s){if(captureSegment(t,r,t.position,!0),is_EOL(s=t.input.charCodeAt(++t.position)))skipSeparationSpace(t,!1,e);else if(s<256&&zt[s])t.result+=Wt[s],t.position++;else if((a=120===(u=s)?2:117===u?4:85===u?8:0)>0){for(o=a,i=0;o>0;o--)(a=fromHexCode(s=t.input.charCodeAt(++t.position)))>=0?i=(i<<4)+a:throwError(t,"expected hexadecimal character");t.result+=charFromCodepoint(i),t.position++}else throwError(t,"unknown escape sequence");r=n=t.position}else is_EOL(s)?(captureSegment(t,r,n,!0),writeFoldedLines(t,skipSeparationSpace(t,!1,e)),r=n=t.position):t.position===t.lineStart&&testDocumentSeparator(t)?throwError(t,"unexpected end of the document within a double quoted scalar"):(t.position++,n=t.position)}throwError(t,"unexpected end of the stream within a double quoted scalar")}(t,p)?_=!0:!function readAlias(t){var e,r,n;if(42!==(n=t.input.charCodeAt(t.position)))return!1;for(n=t.input.charCodeAt(++t.position),e=t.position;0!==n&&!is_WS_OR_EOL(n)&&!is_FLOW_INDICATOR(n);)n=t.input.charCodeAt(++t.position);return t.position===e&&throwError(t,"name of an alias node must contain at least one character"),r=t.input.slice(e,t.position),Tt.call(t.anchorMap,r)||throwError(t,'unidentified alias "'+r+'"'),t.result=t.anchorMap[r],skipSeparationSpace(t,!0,-1),!0}(t)?function readPlainScalar(t,e,r){var n,o,i,a,s,u,c,f,l=t.kind,p=t.result;if(is_WS_OR_EOL(f=t.input.charCodeAt(t.position))||is_FLOW_INDICATOR(f)||35===f||38===f||42===f||33===f||124===f||62===f||39===f||34===f||37===f||64===f||96===f)return!1;if((63===f||45===f)&&(is_WS_OR_EOL(n=t.input.charCodeAt(t.position+1))||r&&is_FLOW_INDICATOR(n)))return!1;for(t.kind="scalar",t.result="",o=i=t.position,a=!1;0!==f;){if(58===f){if(is_WS_OR_EOL(n=t.input.charCodeAt(t.position+1))||r&&is_FLOW_INDICATOR(n))break}else if(35===f){if(is_WS_OR_EOL(t.input.charCodeAt(t.position-1)))break}else{if(t.position===t.lineStart&&testDocumentSeparator(t)||r&&is_FLOW_INDICATOR(f))break;if(is_EOL(f)){if(s=t.line,u=t.lineStart,c=t.lineIndent,skipSeparationSpace(t,!1,-1),t.lineIndent>=e){a=!0,f=t.input.charCodeAt(t.position);continue}t.position=i,t.line=s,t.lineStart=u,t.lineIndent=c;break}}a&&(captureSegment(t,o,i,!1),writeFoldedLines(t,t.line-s),o=i=t.position,a=!1),is_WHITE_SPACE(f)||(i=t.position+1),f=t.input.charCodeAt(++t.position)}return captureSegment(t,o,i,!1),!!t.result||(t.kind=l,t.result=p,!1)}(t,p,1===r)&&(_=!0,null===t.tag&&(t.tag="?")):(_=!0,null===t.tag&&null===t.anchor||throwError(t,"alias node should not have any properties")),null!==t.anchor&&(t.anchorMap[t.anchor]=t.result)):0===d&&(_=s&&readBlockSequence(t,h))),null===t.tag)null!==t.anchor&&(t.anchorMap[t.anchor]=t.result);else if("?"===t.tag){for(null!==t.result&&"scalar"!==t.kind&&throwError(t,'unacceptable node kind for !<?> tag; it should be "scalar", not "'+t.kind+'"'),u=0,c=t.implicitTypes.length;u<c;u+=1)if((l=t.implicitTypes[u]).resolve(t.result)){t.result=l.construct(t.result),t.tag=l.tag,null!==t.anchor&&(t.anchorMap[t.anchor]=t.result);break}}else if("!"!==t.tag){if(Tt.call(t.typeMap[t.kind||"fallback"],t.tag))l=t.typeMap[t.kind||"fallback"][t.tag];else for(l=null,u=0,c=(f=t.typeMap.multi[t.kind||"fallback"]).length;u<c;u+=1)if(t.tag.slice(0,f[u].tag.length)===f[u].tag){l=f[u];break}l||throwError(t,"unknown tag !<"+t.tag+">"),null!==t.result&&l.kind!==t.kind&&throwError(t,"unacceptable node kind for !<"+t.tag+'> tag; it should be "'+l.kind+'", not "'+t.kind+'"'),l.resolve(t.result,t.tag)?(t.result=l.construct(t.result,t.tag),null!==t.anchor&&(t.anchorMap[t.anchor]=t.result)):throwError(t,"cannot resolve a node with !<"+t.tag+"> explicit tag")}return null!==t.listener&&t.listener("close",t),null!==t.tag||null!==t.anchor||_}function readDocument(t){var e,r,n,o,i=t.position,a=!1;for(t.version=null,t.checkLineBreaks=t.legacy,t.tagMap=Object.create(null),t.anchorMap=Object.create(null);0!==(o=t.input.charCodeAt(t.position))&&(skipSeparationSpace(t,!0,-1),o=t.input.charCodeAt(t.position),!(t.lineIndent>0||37!==o));){for(a=!0,o=t.input.charCodeAt(++t.position),e=t.position;0!==o&&!is_WS_OR_EOL(o);)o=t.input.charCodeAt(++t.position);for(n=[],(r=t.input.slice(e,t.position)).length<1&&throwError(t,"directive name must not be less than one character in length");0!==o;){for(;is_WHITE_SPACE(o);)o=t.input.charCodeAt(++t.position);if(35===o){do{o=t.input.charCodeAt(++t.position)}while(0!==o&&!is_EOL(o));break}if(is_EOL(o))break;for(e=t.position;0!==o&&!is_WS_OR_EOL(o);)o=t.input.charCodeAt(++t.position);n.push(t.input.slice(e,t.position))}0!==o&&readLineBreak(t),Tt.call(Kt,r)?Kt[r](t,r,n):throwWarning(t,'unknown document directive "'+r+'"')}skipSeparationSpace(t,!0,-1),0===t.lineIndent&&45===t.input.charCodeAt(t.position)&&45===t.input.charCodeAt(t.position+1)&&45===t.input.charCodeAt(t.position+2)?(t.position+=3,skipSeparationSpace(t,!0,-1)):a&&throwError(t,"directives end mark is expected"),composeNode(t,t.lineIndent-1,4,!1,!0),skipSeparationSpace(t,!0,-1),t.checkLineBreaks&&Rt.test(t.input.slice(i,t.position))&&throwWarning(t,"non-ASCII line breaks are interpreted as content"),t.documents.push(t.result),t.position===t.lineStart&&testDocumentSeparator(t)?46===t.input.charCodeAt(t.position)&&(t.position+=3,skipSeparationSpace(t,!0,-1)):t.position<t.length-1&&throwError(t,"end of the stream or a document separator is expected")}function loadDocuments(t,e){e=e||{},0!==(t=String(t)).length&&(10!==t.charCodeAt(t.length-1)&&13!==t.charCodeAt(t.length-1)&&(t+="\n"),65279===t.charCodeAt(0)&&(t=t.slice(1)));var r=new State$1(t,e),n=t.indexOf("\0");for(-1!==n&&(r.position=n,throwError(r,"null byte is not allowed in input")),r.input+="\0";32===r.input.charCodeAt(r.position);)r.lineIndent+=1,r.position+=1;for(;r.position<r.length-1;)readDocument(r);return r.documents}var $t={loadAll:function loadAll$1(t,e,r){null!==e&&"object"==typeof e&&void 0===r&&(r=e,e=null);var n=loadDocuments(t,r);if("function"!=typeof e)return n;for(var o=0,i=n.length;o<i;o+=1)e(n[o])},load:function load$1(t,e){var r=loadDocuments(t,e);if(0!==r.length){if(1===r.length)return r[0];throw new nt("expected a single document in the stream, but found more")}}},Ht=Object.prototype.toString,Yt=Object.prototype.hasOwnProperty,Gt=65279,Zt={0:"\\0",7:"\\a",8:"\\b",9:"\\t",10:"\\n",11:"\\v",12:"\\f",13:"\\r",27:"\\e",34:'\\"',92:"\\\\",133:"\\N",160:"\\_",8232:"\\L",8233:"\\P"},Jt=["y","Y","yes","Yes","YES","on","On","ON","n","N","no","No","NO","off","Off","OFF"],Qt=/^[-+]?[0-9_]+(?::[0-9_]+)+(?:\.[0-9_]*)?$/;function encodeHex(t){var e,r,n;if(e=t.toString(16).toUpperCase(),t<=255)r="x",n=2;else if(t<=65535)r="u",n=4;else{if(!(t<=4294967295))throw new nt("code point within a string may not be greater than 0xFFFFFFFF");r="U",n=8}return"\\"+r+rt.repeat("0",n-e.length)+e}function State(t){this.schema=t.schema||Nt,this.indent=Math.max(1,t.indent||2),this.noArrayIndent=t.noArrayIndent||!1,this.skipInvalid=t.skipInvalid||!1,this.flowLevel=rt.isNothing(t.flowLevel)?-1:t.flowLevel,this.styleMap=function compileStyleMap(t,e){var r,n,o,i,a,s,u;if(null===e)return{};for(r={},o=0,i=(n=Object.keys(e)).length;o<i;o+=1)a=n[o],s=String(e[a]),"!!"===a.slice(0,2)&&(a="tag:yaml.org,2002:"+a.slice(2)),(u=t.compiledTypeMap.fallback[a])&&Yt.call(u.styleAliases,s)&&(s=u.styleAliases[s]),r[a]=s;return r}(this.schema,t.styles||null),this.sortKeys=t.sortKeys||!1,this.lineWidth=t.lineWidth||80,this.noRefs=t.noRefs||!1,this.noCompatMode=t.noCompatMode||!1,this.condenseFlow=t.condenseFlow||!1,this.quotingType='"'===t.quotingType?2:1,this.forceQuotes=t.forceQuotes||!1,this.replacer="function"==typeof t.replacer?t.replacer:null,this.implicitTypes=this.schema.compiledImplicit,this.explicitTypes=this.schema.compiledExplicit,this.tag=null,this.result="",this.duplicates=[],this.usedDuplicates=null}function indentString(t,e){for(var r,n=rt.repeat(" ",e),o=0,i=-1,a="",s=t.length;o<s;)-1===(i=t.indexOf("\n",o))?(r=t.slice(o),o=s):(r=t.slice(o,i+1),o=i+1),r.length&&"\n"!==r&&(a+=n),a+=r;return a}function generateNextLine(t,e){return"\n"+rt.repeat(" ",t.indent*e)}function isWhitespace(t){return 32===t||9===t}function isPrintable(t){return 32<=t&&t<=126||161<=t&&t<=55295&&8232!==t&&8233!==t||57344<=t&&t<=65533&&t!==Gt||65536<=t&&t<=1114111}function isNsCharOrWhitespace(t){return isPrintable(t)&&t!==Gt&&13!==t&&10!==t}function isPlainSafe(t,e,r){var n=isNsCharOrWhitespace(t),o=n&&!isWhitespace(t);return(r?n:n&&44!==t&&91!==t&&93!==t&&123!==t&&125!==t)&&35!==t&&!(58===e&&!o)||isNsCharOrWhitespace(e)&&!isWhitespace(e)&&35===t||58===e&&o}function codePointAt(t,e){var r,n=t.charCodeAt(e);return n>=55296&&n<=56319&&e+1<t.length&&(r=t.charCodeAt(e+1))>=56320&&r<=57343?1024*(n-55296)+r-56320+65536:n}function needIndentIndicator(t){return/^\n* /.test(t)}function chooseScalarStyle(t,e,r,n,o,i,a,s){var u,c=0,f=null,l=!1,p=!1,h=-1!==n,d=-1,y=function isPlainSafeFirst(t){return isPrintable(t)&&t!==Gt&&!isWhitespace(t)&&45!==t&&63!==t&&58!==t&&44!==t&&91!==t&&93!==t&&123!==t&&125!==t&&35!==t&&38!==t&&42!==t&&33!==t&&124!==t&&61!==t&&62!==t&&39!==t&&34!==t&&37!==t&&64!==t&&96!==t}(codePointAt(t,0))&&function isPlainSafeLast(t){return!isWhitespace(t)&&58!==t}(codePointAt(t,t.length-1));if(e||a)for(u=0;u<t.length;c>=65536?u+=2:u++){if(!isPrintable(c=codePointAt(t,u)))return 5;y=y&&isPlainSafe(c,f,s),f=c}else{for(u=0;u<t.length;c>=65536?u+=2:u++){if(10===(c=codePointAt(t,u)))l=!0,h&&(p=p||u-d-1>n&&" "!==t[d+1],d=u);else if(!isPrintable(c))return 5;y=y&&isPlainSafe(c,f,s),f=c}p=p||h&&u-d-1>n&&" "!==t[d+1]}return l||p?r>9&&needIndentIndicator(t)?5:a?2===i?5:2:p?4:3:!y||a||o(t)?2===i?5:2:1}function writeScalar(t,e,r,n,o){t.dump=function(){if(0===e.length)return 2===t.quotingType?'""':"''";if(!t.noCompatMode&&(-1!==Jt.indexOf(e)||Qt.test(e)))return 2===t.quotingType?'"'+e+'"':"'"+e+"'";var i=t.indent*Math.max(1,r),a=-1===t.lineWidth?-1:Math.max(Math.min(t.lineWidth,40),t.lineWidth-i),s=n||t.flowLevel>-1&&r>=t.flowLevel;switch(chooseScalarStyle(e,s,t.indent,a,(function testAmbiguity(e){return function testImplicitResolving(t,e){var r,n;for(r=0,n=t.implicitTypes.length;r<n;r+=1)if(t.implicitTypes[r].resolve(e))return!0;return!1}(t,e)}),t.quotingType,t.forceQuotes&&!n,o)){case 1:return e;case 2:return"'"+e.replace(/'/g,"''")+"'";case 3:return"|"+blockHeader(e,t.indent)+dropEndingNewline(indentString(e,i));case 4:return">"+blockHeader(e,t.indent)+dropEndingNewline(indentString(function foldString(t,e){var r,n,o=/(\n+)([^\n]*)/g,i=(s=t.indexOf("\n"),s=-1!==s?s:t.length,o.lastIndex=s,foldLine(t.slice(0,s),e)),a="\n"===t[0]||" "===t[0];var s;for(;n=o.exec(t);){var u=n[1],c=n[2];r=" "===c[0],i+=u+(a||r||""===c?"":"\n")+foldLine(c,e),a=r}return i}(e,a),i));case 5:return'"'+function escapeString(t){for(var e,r="",n=0,o=0;o<t.length;n>=65536?o+=2:o++)n=codePointAt(t,o),!(e=Zt[n])&&isPrintable(n)?(r+=t[o],n>=65536&&(r+=t[o+1])):r+=e||encodeHex(n);return r}(e)+'"';default:throw new nt("impossible error: invalid scalar style")}}()}function blockHeader(t,e){var r=needIndentIndicator(t)?String(e):"",n="\n"===t[t.length-1];return r+(n&&("\n"===t[t.length-2]||"\n"===t)?"+":n?"":"-")+"\n"}function dropEndingNewline(t){return"\n"===t[t.length-1]?t.slice(0,-1):t}function foldLine(t,e){if(""===t||" "===t[0])return t;for(var r,n,o=/ [^ ]/g,i=0,a=0,s=0,u="";r=o.exec(t);)(s=r.index)-i>e&&(n=a>i?a:s,u+="\n"+t.slice(i,n),i=n+1),a=s;return u+="\n",t.length-i>e&&a>i?u+=t.slice(i,a)+"\n"+t.slice(a+1):u+=t.slice(i),u.slice(1)}function writeBlockSequence(t,e,r,n){var o,i,a,s="",u=t.tag;for(o=0,i=r.length;o<i;o+=1)a=r[o],t.replacer&&(a=t.replacer.call(r,String(o),a)),(writeNode(t,e+1,a,!0,!0,!1,!0)||void 0===a&&writeNode(t,e+1,null,!0,!0,!1,!0))&&(n&&""===s||(s+=generateNextLine(t,e)),t.dump&&10===t.dump.charCodeAt(0)?s+="-":s+="- ",s+=t.dump);t.tag=u,t.dump=s||"[]"}function detectType(t,e,r){var n,o,i,a,s,u;for(i=0,a=(o=r?t.explicitTypes:t.implicitTypes).length;i<a;i+=1)if(((s=o[i]).instanceOf||s.predicate)&&(!s.instanceOf||"object"==typeof e&&e instanceof s.instanceOf)&&(!s.predicate||s.predicate(e))){if(r?s.multi&&s.representName?t.tag=s.representName(e):t.tag=s.tag:t.tag="?",s.represent){if(u=t.styleMap[s.tag]||s.defaultStyle,"[object Function]"===Ht.call(s.represent))n=s.represent(e,u);else{if(!Yt.call(s.represent,u))throw new nt("!<"+s.tag+'> tag resolver accepts not "'+u+'" style');n=s.represent[u](e,u)}t.dump=n}return!0}return!1}function writeNode(t,e,r,n,o,i,a){t.tag=null,t.dump=r,detectType(t,r,!1)||detectType(t,r,!0);var s,u=Ht.call(t.dump),c=n;n&&(n=t.flowLevel<0||t.flowLevel>e);var f,l,p="[object Object]"===u||"[object Array]"===u;if(p&&(l=-1!==(f=t.duplicates.indexOf(r))),(null!==t.tag&&"?"!==t.tag||l||2!==t.indent&&e>0)&&(o=!1),l&&t.usedDuplicates[f])t.dump="*ref_"+f;else{if(p&&l&&!t.usedDuplicates[f]&&(t.usedDuplicates[f]=!0),"[object Object]"===u)n&&0!==Object.keys(t.dump).length?(!function writeBlockMapping(t,e,r,n){var o,i,a,s,u,c,f="",l=t.tag,p=Object.keys(r);if(!0===t.sortKeys)p.sort();else if("function"==typeof t.sortKeys)p.sort(t.sortKeys);else if(t.sortKeys)throw new nt("sortKeys must be a boolean or a function");for(o=0,i=p.length;o<i;o+=1)c="",n&&""===f||(c+=generateNextLine(t,e)),s=r[a=p[o]],t.replacer&&(s=t.replacer.call(r,a,s)),writeNode(t,e+1,a,!0,!0,!0)&&((u=null!==t.tag&&"?"!==t.tag||t.dump&&t.dump.length>1024)&&(t.dump&&10===t.dump.charCodeAt(0)?c+="?":c+="? "),c+=t.dump,u&&(c+=generateNextLine(t,e)),writeNode(t,e+1,s,!0,u)&&(t.dump&&10===t.dump.charCodeAt(0)?c+=":":c+=": ",f+=c+=t.dump));t.tag=l,t.dump=f||"{}"}(t,e,t.dump,o),l&&(t.dump="&ref_"+f+t.dump)):(!function writeFlowMapping(t,e,r){var n,o,i,a,s,u="",c=t.tag,f=Object.keys(r);for(n=0,o=f.length;n<o;n+=1)s="",""!==u&&(s+=", "),t.condenseFlow&&(s+='"'),a=r[i=f[n]],t.replacer&&(a=t.replacer.call(r,i,a)),writeNode(t,e,i,!1,!1)&&(t.dump.length>1024&&(s+="? "),s+=t.dump+(t.condenseFlow?'"':"")+":"+(t.condenseFlow?"":" "),writeNode(t,e,a,!1,!1)&&(u+=s+=t.dump));t.tag=c,t.dump="{"+u+"}"}(t,e,t.dump),l&&(t.dump="&ref_"+f+" "+t.dump));else if("[object Array]"===u)n&&0!==t.dump.length?(t.noArrayIndent&&!a&&e>0?writeBlockSequence(t,e-1,t.dump,o):writeBlockSequence(t,e,t.dump,o),l&&(t.dump="&ref_"+f+t.dump)):(!function writeFlowSequence(t,e,r){var n,o,i,a="",s=t.tag;for(n=0,o=r.length;n<o;n+=1)i=r[n],t.replacer&&(i=t.replacer.call(r,String(n),i)),(writeNode(t,e,i,!1,!1)||void 0===i&&writeNode(t,e,null,!1,!1))&&(""!==a&&(a+=","+(t.condenseFlow?"":" ")),a+=t.dump);t.tag=s,t.dump="["+a+"]"}(t,e,t.dump),l&&(t.dump="&ref_"+f+" "+t.dump));else{if("[object String]"!==u){if("[object Undefined]"===u)return!1;if(t.skipInvalid)return!1;throw new nt("unacceptable kind of an object to dump "+u)}"?"!==t.tag&&writeScalar(t,t.dump,e,i,c)}null!==t.tag&&"?"!==t.tag&&(s=encodeURI("!"===t.tag[0]?t.tag.slice(1):t.tag).replace(/!/g,"%21"),s="!"===t.tag[0]?"!"+s:"tag:yaml.org,2002:"===s.slice(0,18)?"!!"+s.slice(18):"!<"+s+">",t.dump=s+" "+t.dump)}return!0}function getDuplicateReferences(t,e){var r,n,o=[],i=[];for(inspectNode(t,o,i),r=0,n=i.length;r<n;r+=1)e.duplicates.push(o[i[r]]);e.usedDuplicates=new Array(n)}function inspectNode(t,e,r){var n,o,i;if(null!==t&&"object"==typeof t)if(-1!==(o=e.indexOf(t)))-1===r.indexOf(o)&&r.push(o);else if(e.push(t),Array.isArray(t))for(o=0,i=t.length;o<i;o+=1)inspectNode(t[o],e,r);else for(o=0,i=(n=Object.keys(t)).length;o<i;o+=1)inspectNode(t[n[o]],e,r)}function renamed(t,e){return function(){throw new Error("Function yaml."+t+" is removed in js-yaml 4. Use yaml."+e+" instead, which is now safe by default.")}}var Xt={Type:st,Schema:ut,FAILSAFE_SCHEMA:ht,JSON_SCHEMA:bt,CORE_SCHEMA:St,DEFAULT_SCHEMA:Nt,load:$t.load,loadAll:$t.loadAll,dump:{dump:function dump$1(t,e){var r=new State(e=e||{});r.noRefs||getDuplicateReferences(t,r);var n=t;return r.replacer&&(n=r.replacer.call({"":n},"",n)),writeNode(r,0,n,!0,!0)?r.dump+"\n":""}}.dump,YAMLException:nt,types:{binary:Ot,float:vt,map:pt,null:dt,pairs:jt,set:Lt,timestamp:xt,bool:yt,int:_t,merge:Et,omap:Mt,seq:lt,str:ct},safeLoad:renamed("safeLoad","load"),safeLoadAll:renamed("safeLoadAll","loadAll"),safeDump:renamed("safeDump","dump")};const te="configs_update",ee="configs_toggle";function update(t,e){return{type:te,payload:{[t]:e}}}function toggle(t){return{type:ee,payload:t}}const loaded=()=>()=>{},downloadConfig=t=>e=>{const{fn:{fetch:r}}=e;return r(t)},getConfigByUrl=(t,e)=>r=>{const{specActions:n,configsActions:o}=r;if(t)return o.downloadConfig(t).then(next,next);function next(o){o instanceof Error||o.status>=400?(n.updateLoadingStatus("failedConfig"),n.updateLoadingStatus("failedConfig"),n.updateUrl(""),console.error(o.statusText+" "+t.url),e(null)):e(((t,e)=>{try{return Xt.load(t)}catch(t){return e&&e.errActions.newThrownErr(new Error(t)),{}}})(o.text,r))}},get=(t,e)=>t.getIn(Array.isArray(e)?e:[e]),re={[te]:(t,e)=>t.merge((0,i.fromJS)(e.payload)),[ee]:(t,e)=>{const r=e.payload,n=t.get(r);return t.set(r,!n)}};var ne=__webpack_require__(7248),oe=__webpack_require__.n(ne),ie=__webpack_require__(7666),ae=__webpack_require__.n(ie);const se=console.error,withErrorBoundary=t=>e=>{const{getComponent:r,fn:o}=t(),i=r("ErrorBoundary"),a=o.getDisplayName(e);class WithErrorBoundary extends n.Component{render(){return n.createElement(i,{targetName:a,getComponent:r,fn:o},n.createElement(e,ae()({},this.props,this.context)))}}var s;return WithErrorBoundary.displayName=`WithErrorBoundary(${a})`,(s=e).prototype&&s.prototype.isReactComponent&&(WithErrorBoundary.prototype.mapStateToProps=e.prototype.mapStateToProps),WithErrorBoundary},fallback=({name:t})=>n.createElement("div",{className:"fallback"},"😱 ",n.createElement("i",null,"Could not render ","t"===t?"this component":t,", see the console."));class ErrorBoundary extends n.Component{static defaultProps={targetName:"this component",getComponent:()=>fallback,fn:{componentDidCatch:se},children:null};static getDerivedStateFromError(t){return{hasError:!0,error:t}}constructor(...t){super(...t),this.state={hasError:!1,error:null}}componentDidCatch(t,e){this.props.fn.componentDidCatch(t,e)}render(){const{getComponent:t,targetName:e,children:r}=this.props;if(this.state.hasError){const r=t("Fallback");return n.createElement(r,{name:e})}return r}}const ue=ErrorBoundary,ce=[top_bar,function configsPlugin(){return{statePlugins:{configs:{reducers:re,actions:t,selectors:e}}}},stadalone_layout,(({componentList:t=[],fullOverride:e=!1}={})=>({getSystem:r})=>{const n=e?t:["App","BaseLayout","VersionPragmaFilter","InfoContainer","ServersContainer","SchemesContainer","AuthorizeBtnContainer","FilterContainer","Operations","OperationContainer","parameters","responses","OperationServers","Models","ModelWrapper",...t],o=oe()(n,Array(n.length).fill(((t,{fn:e})=>e.withErrorBoundary(t))));return{fn:{componentDidCatch:se,withErrorBoundary:withErrorBoundary(r)},components:{ErrorBoundary:ue,Fallback:fallback},wrapComponents:o}})({fullOverride:!0,componentList:["Topbar","StandaloneLayout","onlineValidatorBadge"]})]})(),r=r.default})()));
!function(e){if(!e.hasInitialised){var t={escapeRegExp:function(e){return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")},hasClass:function(e,t){var i=" ";return 1===e.nodeType&&(i+e.className+i).replace(/[\n\t]/g,i).indexOf(i+t+i)>=0},addClass:function(e,t){e.className+=" "+t},removeClass:function(e,t){var i=new RegExp("\\b"+this.escapeRegExp(t)+"\\b");e.className=e.className.replace(i,"")},interpolateString:function(e,t){return e.replace(/{{([a-z][a-z0-9\-_]*)}}/gi,function(e){return t(arguments[1])||""})},getCookie:function(e){var t=("; "+document.cookie).split("; "+e+"=");return t.length<2?void 0:t.pop().split(";").shift()},setCookie:function(e,t,i,n,o,s){var r=new Date;r.setHours(r.getHours()+24*(i||365));var a=[e+"="+t,"expires="+r.toUTCString(),"path="+(o||"/")];n&&a.push("domain="+n),s&&a.push("secure"),document.cookie=a.join(";")},deepExtend:function(e,t){for(var i in t)t.hasOwnProperty(i)&&(i in e&&this.isPlainObject(e[i])&&this.isPlainObject(t[i])?this.deepExtend(e[i],t[i]):e[i]=t[i]);return e},throttle:function(e,t){var i=!1;return function(){i||(e.apply(this,arguments),i=!0,setTimeout(function(){i=!1},t))}},hash:function(e){var t,i,n=0;if(0===e.length)return n;for(t=0,i=e.length;t<i;++t)n=(n<<5)-n+e.charCodeAt(t),n|=0;return n},normaliseHex:function(e){return"#"==e[0]&&(e=e.substr(1)),3==e.length&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2]),e},getContrast:function(e){return e=this.normaliseHex(e),(299*parseInt(e.substr(0,2),16)+587*parseInt(e.substr(2,2),16)+114*parseInt(e.substr(4,2),16))/1e3>=128?"#000":"#fff"},getLuminance:function(e){var t=parseInt(this.normaliseHex(e),16),i=38+(t>>16),n=38+(t>>8&255),o=38+(255&t);return"#"+(16777216+65536*(i<255?i<1?0:i:255)+256*(n<255?n<1?0:n:255)+(o<255?o<1?0:o:255)).toString(16).slice(1)},isMobile:function(){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)},isPlainObject:function(e){return"object"==typeof e&&null!==e&&e.constructor==Object},traverseDOMPath:function(e,i){return e&&e.parentNode?t.hasClass(e,i)?e:this.traverseDOMPath(e.parentNode,i):null}};e.status={deny:"deny",allow:"allow",dismiss:"dismiss"},e.transitionEnd=function(){var e=document.createElement("div"),t={t:"transitionend",OT:"oTransitionEnd",msT:"MSTransitionEnd",MozT:"transitionend",WebkitT:"webkitTransitionEnd"};for(var i in t)if(t.hasOwnProperty(i)&&void 0!==e.style[i+"ransition"])return t[i];return""}(),e.hasTransition=!!e.transitionEnd;var i=Object.keys(e.status).map(t.escapeRegExp);e.customStyles={},e.Popup=function(){var n={enabled:!0,container:null,cookie:{name:"cookieconsent_status",path:"/",domain:"",expiryDays:365,secure:!1},onPopupOpen:function(){},onPopupClose:function(){},onInitialise:function(e){},onStatusChange:function(e,t){},onRevokeChoice:function(){},onNoCookieLaw:function(e,t){},content:{header:"Cookies used on the website!",message:"This website uses cookies to ensure you get the best experience on our website.",dismiss:"Got it!",allow:"Allow cookies",deny:"Decline",link:"Learn more",href:"https://www.cookiesandyou.com",close:"&#x274c;",target:"_blank",policy:"Cookie Policy"},elements:{header:'<span class="cc-header">{{header}}</span>&nbsp;',message:'<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',messagelink:'<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a></span>',dismiss:'<a aria-label="dismiss cookie message" role=button tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a>',allow:'<a aria-label="allow cookies" role=button tabindex="0"  class="cc-btn cc-allow">{{allow}}</a>',deny:'<a aria-label="deny cookies" role=button tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',link:'<a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a>',close:'<span aria-label="dismiss cookie message" role=button tabindex="0" class="cc-close">{{close}}</span>'},window:'<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}">\x3c!--googleoff: all--\x3e{{children}}\x3c!--googleon: all--\x3e</div>',revokeBtn:'<div class="cc-revoke {{classes}}">{{policy}}</div>',compliance:{info:'<div class="cc-compliance">{{dismiss}}</div>',"opt-in":'<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>',"opt-out":'<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>'},type:"info",layouts:{basic:"{{messagelink}}{{compliance}}","basic-close":"{{messagelink}}{{compliance}}{{close}}","basic-header":"{{header}}{{message}}{{link}}{{compliance}}"},layout:"basic",position:"bottom",theme:"block",static:!1,palette:null,revokable:!1,animateRevokable:!0,showLink:!0,dismissOnScroll:!1,dismissOnTimeout:!1,dismissOnWindowClick:!1,ignoreClicksFrom:["cc-revoke","cc-btn"],autoOpen:!0,autoAttach:!0,whitelistPage:[],blacklistPage:[],overrideHTML:null};function o(){this.initialise.apply(this,arguments)}function s(e){this.openingTimeout=null,t.removeClass(e,"cc-invisible")}function r(t){t.style.display="none",t.removeEventListener(e.transitionEnd,this.afterTransition),this.afterTransition=null}function a(){var e=this.options.position.split("-"),t=[];return e.forEach(function(e){t.push("cc-"+e)}),t}function c(n){var o=this.options,s=document.createElement("div"),r=o.container&&1===o.container.nodeType?o.container:document.body;s.innerHTML=n;var a=s.children[0];return a.style.display="none",t.hasClass(a,"cc-window")&&e.hasTransition&&t.addClass(a,"cc-invisible"),this.onButtonClick=function(n){var o=t.traverseDOMPath(n.target,"cc-btn")||n.target;if(t.hasClass(o,"cc-btn")){var s=o.className.match(new RegExp("\\bcc-("+i.join("|")+")\\b")),r=s&&s[1]||!1;r&&(this.setStatus(r),this.close(!0))}t.hasClass(o,"cc-close")&&(this.setStatus(e.status.dismiss),this.close(!0));t.hasClass(o,"cc-revoke")&&this.revokeChoice()}.bind(this),a.addEventListener("click",this.onButtonClick),o.autoAttach&&(r.firstChild?r.insertBefore(a,r.firstChild):r.appendChild(a)),a}function l(e){return"000000"==(e=t.normaliseHex(e))?"#222":t.getLuminance(e)}function u(e,t){for(var i=0,n=e.length;i<n;++i){var o=e[i];if(o instanceof RegExp&&o.test(t)||"string"==typeof o&&o.length&&o===t)return!0}return!1}return o.prototype.initialise=function(i){this.options&&this.destroy(),t.deepExtend(this.options={},n),t.isPlainObject(i)&&t.deepExtend(this.options,i),function(){var t=this.options.onInitialise.bind(this);if(!window.navigator.cookieEnabled)return t(e.status.deny),!0;if(window.CookiesOK||window.navigator.CookiesOK)return t(e.status.allow),!0;var i=Object.keys(e.status),n=this.getStatus(),o=i.indexOf(n)>=0;o&&t(n);return o}.call(this)&&(this.options.enabled=!1),u(this.options.blacklistPage,location.pathname)&&(this.options.enabled=!1),u(this.options.whitelistPage,location.pathname)&&(this.options.enabled=!0);var o=this.options.window.replace("{{classes}}",function(){var i=this.options,n="top"==i.position||"bottom"==i.position?"banner":"floating";t.isMobile()&&(n="floating");var o=["cc-"+n,"cc-type-"+i.type,"cc-theme-"+i.theme];i.static&&o.push("cc-static");o.push.apply(o,a.call(this));(function(i){var n=t.hash(JSON.stringify(i)),o="cc-color-override-"+n,s=t.isPlainObject(i);this.customStyleSelector=s?o:null,s&&function(i,n,o){if(e.customStyles[i])return void++e.customStyles[i].references;var s={},r=n.popup,a=n.button,c=n.highlight;r&&(r.text=r.text?r.text:t.getContrast(r.background),r.link=r.link?r.link:r.text,s[o+".cc-window"]=["color: "+r.text,"background-color: "+r.background],s[o+".cc-revoke"]=["color: "+r.text,"background-color: "+r.background],s[o+" .cc-link,"+o+" .cc-link:active,"+o+" .cc-link:visited"]=["color: "+r.link],a&&(a.text=a.text?a.text:t.getContrast(a.background),a.border=a.border?a.border:"transparent",s[o+" .cc-btn"]=["color: "+a.text,"border-color: "+a.border,"background-color: "+a.background],a.padding&&s[o+" .cc-btn"].push("padding: "+a.padding),"transparent"!=a.background&&(s[o+" .cc-btn:hover, "+o+" .cc-btn:focus"]=["background-color: "+(a.hover||l(a.background))]),c?(c.text=c.text?c.text:t.getContrast(c.background),c.border=c.border?c.border:"transparent",s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+c.text,"border-color: "+c.border,"background-color: "+c.background]):s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+r.text]));var u=document.createElement("style");document.head.appendChild(u),e.customStyles[i]={references:1,element:u.sheet};var h=-1;for(var p in s)s.hasOwnProperty(p)&&u.sheet.insertRule(p+"{"+s[p].join(";")+"}",++h)}(n,i,"."+o);return s}).call(this,this.options.palette);this.customStyleSelector&&o.push(this.customStyleSelector);return o}.call(this).join(" ")).replace("{{children}}",function(){var e={},i=this.options;i.showLink||(i.elements.link="",i.elements.messagelink=i.elements.message);Object.keys(i.elements).forEach(function(n){e[n]=t.interpolateString(i.elements[n],function(e){var t=i.content[e];return e&&"string"==typeof t&&t.length?t:""})});var n=i.compliance[i.type];n||(n=i.compliance.info);e.compliance=t.interpolateString(n,function(t){return e[t]});var o=i.layouts[i.layout];o||(o=i.layouts.basic);return t.interpolateString(o,function(t){return e[t]})}.call(this)),s=this.options.overrideHTML;if("string"==typeof s&&s.length&&(o=s),this.options.static){var r=c.call(this,'<div class="cc-grower">'+o+"</div>");r.style.display="",this.element=r.firstChild,this.element.style.display="none",t.addClass(this.element,"cc-invisible")}else this.element=c.call(this,o);(function(){var i=this.setStatus.bind(this),n=this.close.bind(this),o=this.options.dismissOnTimeout;"number"==typeof o&&o>=0&&(this.dismissTimeout=window.setTimeout(function(){i(e.status.dismiss),n(!0)},Math.floor(o)));var s=this.options.dismissOnScroll;if("number"==typeof s&&s>=0){var r=function(t){window.pageYOffset>Math.floor(s)&&(i(e.status.dismiss),n(!0),window.removeEventListener("scroll",r),this.onWindowScroll=null)};this.options.enabled&&(this.onWindowScroll=r,window.addEventListener("scroll",r))}var a=this.options.dismissOnWindowClick,c=this.options.ignoreClicksFrom;if(a){var l=function(o){for(var s=!1,r=o.path.length,a=c.length,u=0;u<r;u++)if(!s)for(var h=0;h<a;h++)s||(s=t.hasClass(o.path[u],c[h]));s||(i(e.status.dismiss),n(!0),window.removeEventListener("click",l),window.removeEventListener("touchend",l),this.onWindowClick=null)}.bind(this);this.options.enabled&&(this.onWindowClick=l,window.addEventListener("click",l),window.addEventListener("touchend",l))}}).call(this),function(){"info"!=this.options.type&&(this.options.revokable=!0);t.isMobile()&&(this.options.animateRevokable=!1);if(this.options.revokable){var e=a.call(this);this.options.animateRevokable&&e.push("cc-animate"),this.customStyleSelector&&e.push(this.customStyleSelector);var i=this.options.revokeBtn.replace("{{classes}}",e.join(" ")).replace("{{policy}}",this.options.content.policy);this.revokeBtn=c.call(this,i);var n=this.revokeBtn;if(this.options.animateRevokable){var o=t.throttle(function(e){var i=!1,o=window.innerHeight-20;t.hasClass(n,"cc-top")&&e.clientY<20&&(i=!0),t.hasClass(n,"cc-bottom")&&e.clientY>o&&(i=!0),i?t.hasClass(n,"cc-active")||t.addClass(n,"cc-active"):t.hasClass(n,"cc-active")&&t.removeClass(n,"cc-active")},200);this.onMouseMove=o,window.addEventListener("mousemove",o)}}}.call(this),this.options.autoOpen&&this.autoOpen()},o.prototype.destroy=function(){this.onButtonClick&&this.element&&(this.element.removeEventListener("click",this.onButtonClick),this.onButtonClick=null),this.dismissTimeout&&(clearTimeout(this.dismissTimeout),this.dismissTimeout=null),this.onWindowScroll&&(window.removeEventListener("scroll",this.onWindowScroll),this.onWindowScroll=null),this.onWindowClick&&(window.removeEventListener("click",this.onWindowClick),this.onWindowClick=null),this.onMouseMove&&(window.removeEventListener("mousemove",this.onMouseMove),this.onMouseMove=null),this.element&&this.element.parentNode&&this.element.parentNode.removeChild(this.element),this.element=null,this.revokeBtn&&this.revokeBtn.parentNode&&this.revokeBtn.parentNode.removeChild(this.revokeBtn),this.revokeBtn=null,function(i){if(t.isPlainObject(i)){var n=t.hash(JSON.stringify(i)),o=e.customStyles[n];if(o&&!--o.references){var s=o.element.ownerNode;s&&s.parentNode&&s.parentNode.removeChild(s),e.customStyles[n]=null}}}(this.options.palette),this.options=null},o.prototype.open=function(t){if(this.element)return this.isOpen()||(e.hasTransition?this.fadeIn():this.element.style.display="",this.options.revokable&&this.toggleRevokeButton(),this.options.onPopupOpen.call(this)),this},o.prototype.close=function(t){if(this.element)return this.isOpen()&&(e.hasTransition?this.fadeOut():this.element.style.display="none",t&&this.options.revokable&&this.toggleRevokeButton(!0),this.options.onPopupClose.call(this)),this},o.prototype.fadeIn=function(){var i=this.element;if(e.hasTransition&&i&&(this.afterTransition&&r.call(this,i),t.hasClass(i,"cc-invisible"))){if(i.style.display="",this.options.static){var n=this.element.clientHeight;this.element.parentNode.style.maxHeight=n+"px"}this.openingTimeout=setTimeout(s.bind(this,i),20)}},o.prototype.fadeOut=function(){var i=this.element;e.hasTransition&&i&&(this.openingTimeout&&(clearTimeout(this.openingTimeout),s.bind(this,i)),t.hasClass(i,"cc-invisible")||(this.options.static&&(this.element.parentNode.style.maxHeight=""),this.afterTransition=r.bind(this,i),i.addEventListener(e.transitionEnd,this.afterTransition),t.addClass(i,"cc-invisible")))},o.prototype.isOpen=function(){return this.element&&""==this.element.style.display&&(!e.hasTransition||!t.hasClass(this.element,"cc-invisible"))},o.prototype.toggleRevokeButton=function(e){this.revokeBtn&&(this.revokeBtn.style.display=e?"":"none")},o.prototype.revokeChoice=function(e){this.options.enabled=!0,this.clearStatus(),this.options.onRevokeChoice.call(this),e||this.autoOpen()},o.prototype.hasAnswered=function(t){return Object.keys(e.status).indexOf(this.getStatus())>=0},o.prototype.hasConsented=function(t){var i=this.getStatus();return i==e.status.allow||i==e.status.dismiss},o.prototype.autoOpen=function(e){!this.hasAnswered()&&this.options.enabled?this.open():this.hasAnswered()&&this.options.revokable&&this.toggleRevokeButton(!0)},o.prototype.setStatus=function(i){var n=this.options.cookie,o=t.getCookie(n.name),s=Object.keys(e.status).indexOf(o)>=0;Object.keys(e.status).indexOf(i)>=0?(t.setCookie(n.name,i,n.expiryDays,n.domain,n.path,n.secure),this.options.onStatusChange.call(this,i,s)):this.clearStatus()},o.prototype.getStatus=function(){return t.getCookie(this.options.cookie.name)},o.prototype.clearStatus=function(){var e=this.options.cookie;t.setCookie(e.name,"",-1,e.domain,e.path)},o}(),e.Location=function(){var e={timeout:5e3,services:["ipinfo"],serviceDefinitions:{ipinfo:function(){return{url:"//ipinfo.io",headers:["Accept: application/json"],callback:function(e,t){try{var i=JSON.parse(t);return i.error?s(i):{code:i.country}}catch(e){return s({error:"Invalid response ("+e+")"})}}}},ipinfodb:function(e){return{url:"//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return"ERROR"==i.statusCode?s({error:i.statusMessage}):{code:i.countryCode}}catch(e){return s({error:"Invalid response ("+e+")"})}}}},maxmind:function(){return{url:"//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js",isScript:!0,callback:function(e){window.geoip2?geoip2.country(function(t){try{e({code:t.country.iso_code})}catch(t){e(s(t))}},function(t){e(s(t))}):e(new Error("Unexpected response format. The downloaded script should have exported `geoip2` to the global scope"))}}}}};function i(i){t.deepExtend(this.options={},e),t.isPlainObject(i)&&t.deepExtend(this.options,i),this.currentServiceIndex=-1}function n(e,t,i){var n,o=document.createElement("script");o.type="text/"+(e.type||"javascript"),o.src=e.src||e,o.async=!1,o.onreadystatechange=o.onload=function(){var e=o.readyState;clearTimeout(n),t.done||e&&!/loaded|complete/.test(e)||(t.done=!0,t(),o.onreadystatechange=o.onload=null)},document.body.appendChild(o),n=setTimeout(function(){t.done=!0,t(),o.onreadystatechange=o.onload=null},i)}function o(e,t,i,n,o){var s=new(window.XMLHttpRequest||window.ActiveXObject)("MSXML2.XMLHTTP.3.0");if(s.open(n?"POST":"GET",e,1),s.setRequestHeader("Content-type","application/x-www-form-urlencoded"),Array.isArray(o))for(var r=0,a=o.length;r<a;++r){var c=o[r].split(":",2);s.setRequestHeader(c[0].replace(/^\s+|\s+$/g,""),c[1].replace(/^\s+|\s+$/g,""))}"function"==typeof t&&(s.onreadystatechange=function(){s.readyState>3&&t(s)}),s.send(n)}function s(e){return new Error("Error ["+(e.code||"UNKNOWN")+"]: "+e.error)}return i.prototype.getNextService=function(){var e;do{e=this.getServiceByIdx(++this.currentServiceIndex)}while(this.currentServiceIndex<this.options.services.length&&!e);return e},i.prototype.getServiceByIdx=function(e){var i=this.options.services[e];if("function"==typeof i){var n=i();return n.name&&t.deepExtend(n,this.options.serviceDefinitions[n.name](n)),n}return"string"==typeof i?this.options.serviceDefinitions[i]():t.isPlainObject(i)?this.options.serviceDefinitions[i.name](i):null},i.prototype.locate=function(e,t){var i=this.getNextService();i?(this.callbackComplete=e,this.callbackError=t,this.runService(i,this.runNextServiceOnError.bind(this))):t(new Error("No services to run"))},i.prototype.setupUrl=function(e){var t=this.getCurrentServiceOpts();return e.url.replace(/\{(.*?)\}/g,function(i,n){if("callback"===n){var o="callback"+Date.now();return window[o]=function(t){e.__JSONP_DATA=JSON.stringify(t)},o}if(n in t.interpolateUrl)return t.interpolateUrl[n]})},i.prototype.runService=function(e,t){var i=this;e&&e.url&&e.callback&&(e.isScript?n:o)(this.setupUrl(e),function(n){var o=n?n.responseText:"";e.__JSONP_DATA&&(o=e.__JSONP_DATA,delete e.__JSONP_DATA),i.runServiceCallback.call(i,t,e,o)},this.options.timeout,e.data,e.headers)},i.prototype.runServiceCallback=function(e,t,i){var n=this,o=t.callback(function(t){o||n.onServiceResult.call(n,e,t)},i);o&&this.onServiceResult.call(this,e,o)},i.prototype.onServiceResult=function(e,t){t instanceof Error||t&&t.error?e.call(this,t,null):e.call(this,null,t)},i.prototype.runNextServiceOnError=function(e,t){if(e){this.logError(e);var i=this.getNextService();i?this.runService(i,this.runNextServiceOnError.bind(this)):this.completeService.call(this,this.callbackError,new Error("All services failed"))}else this.completeService.call(this,this.callbackComplete,t)},i.prototype.getCurrentServiceOpts=function(){var e=this.options.services[this.currentServiceIndex];return"string"==typeof e?{name:e}:"function"==typeof e?e():t.isPlainObject(e)?e:{}},i.prototype.completeService=function(e,t){this.currentServiceIndex=-1,e&&e(t)},i.prototype.logError=function(e){var t=this.currentServiceIndex,i=this.getServiceByIdx(t);console.warn("The service["+t+"] ("+i.url+") responded with the following error",e)},i}(),e.Law=function(){var e={regionalLaw:!0,hasLaw:["AT","BE","BG","HR","CZ","CY","DK","EE","FI","FR","DE","EL","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","SK","ES","SE","GB","UK","GR","EU"],revokable:["HR","CY","DK","EE","FR","DE","LV","LT","NL","PT","ES"],explicitAction:["HR","IT","ES"]};function i(e){this.initialise.apply(this,arguments)}return i.prototype.initialise=function(i){t.deepExtend(this.options={},e),t.isPlainObject(i)&&t.deepExtend(this.options,i)},i.prototype.get=function(e){var t=this.options;return{hasLaw:t.hasLaw.indexOf(e)>=0,revokable:t.revokable.indexOf(e)>=0,explicitAction:t.explicitAction.indexOf(e)>=0}},i.prototype.applyLaw=function(e,t){var i=this.get(t);return i.hasLaw||(e.enabled=!1,"function"==typeof e.onNoCookieLaw&&e.onNoCookieLaw(t,i)),this.options.regionalLaw&&(i.revokable&&(e.revokable=!0),i.explicitAction&&(e.dismissOnScroll=!1,e.dismissOnTimeout=!1)),e},i}(),e.initialise=function(i,n,o){var s=new e.Law(i.law);n||(n=function(){}),o||(o=function(){});var r=Object.keys(e.status),a=t.getCookie("cookieconsent_status");r.indexOf(a)>=0?n(new e.Popup(i)):e.getCountryCode(i,function(t){delete i.law,delete i.location,t.code&&(i=s.applyLaw(i,t.code)),n(new e.Popup(i))},function(t){delete i.law,delete i.location,o(t,new e.Popup(i))})},e.getCountryCode=function(t,i,n){t.law&&t.law.countryCode?i({code:t.law.countryCode}):t.location?new e.Location(t.location).locate(function(e){i(e||{})},n):i({})},e.utils=t,e.hasInitialised=!0,window.cookieconsent=e}}(window.cookieconsent||{});
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.igv = factory());
})(this, (function () { 'use strict';

    /*!
     * jQuery JavaScript Library v3.3.1 -ajax,-ajax/jsonp,-ajax/load,-ajax/parseXML,-ajax/script,-ajax/var/location,-ajax/var/nonce,-ajax/var/rquery,-ajax/xhr,-manipulation/_evalUrl,-event/ajax,-effects,-effects/Tween,-effects/animatedSelector
     * https://jquery.com/
     *
     * Includes Sizzle.js
     * https://sizzlejs.com/
     *
     * Copyright JS Foundation and other contributors
     * Released under the MIT license
     * https://jquery.org/license
     *
     * Date: 2018-01-20T17:24Z
     */

    var arr = [];

    var document$1 = window.document;

    var getProto = Object.getPrototypeOf;

    var slice = arr.slice;

    var concat = arr.concat;

    var push = arr.push;

    var indexOf = arr.indexOf;

    var class2type = {};

    var toString$3 = class2type.toString;

    var hasOwn = class2type.hasOwnProperty;

    var fnToString = hasOwn.toString;

    var ObjectFunctionString = fnToString.call(Object);

    var support = {};

    var isFunction = function isFunction(obj) {

        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        return typeof obj === "function" && typeof obj.nodeType !== "number";
    };


    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };


    var preservedScriptAttributes = {
        type: true,
        src: true,
        noModule: true
    };

    function DOMEval(code, doc, node) {
        doc = doc || document$1;

        var i,
            script = doc.createElement("script");

        script.text = code;
        if (node) {
            for (i in preservedScriptAttributes) {
                if (node[i]) {
                    script[i] = node[i];
                }
            }
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }


    function toType(obj) {
        if (obj == null) {
            return obj + "";
        }

        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ?
            class2type[toString$3.call(obj)] || "object" :
            typeof obj;
    }

    // global Symbol
    // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module


    var
        version$1 = "3.3.1 -ajax,-ajax/jsonp,-ajax/load,-ajax/parseXML,-ajax/script,-ajax/var/location,-ajax/var/nonce,-ajax/var/rquery,-ajax/xhr,-manipulation/_evalUrl,-event/ajax,-effects,-effects/Tween,-effects/animatedSelector",

        // Define a local copy of jQuery
        jQuery = function (selector, context) {

            // The jQuery object is actually just the init constructor 'enhanced'
            // Need init if jQuery is called (just allow error to be thrown if not included)
            return new jQuery.fn.init(selector, context);
        },

        // Support: Android <=4.0 only
        // Make sure we trim BOM and NBSP
        rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

    jQuery.fn = jQuery.prototype = {

        // The current version of jQuery being used
        jquery: version$1,

        constructor: jQuery,

        // The default length of a jQuery object is 0
        length: 0,

        toArray: function () {
            return slice.call(this);
        },

        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function (num) {

            // Return all the elements in a clean array
            if (num == null) {
                return slice.call(this);
            }

            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },

        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function (elems) {

            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);

            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;

            // Return the newly-formed element set
            return ret;
        },

        // Execute a callback for every element in the matched set.
        each: function (callback) {
            return jQuery.each(this, callback);
        },

        map: function (callback) {
            return this.pushStack(jQuery.map(this, function (elem, i) {
                return callback.call(elem, i, elem);
            }));
        },

        slice: function () {
            return this.pushStack(slice.apply(this, arguments));
        },

        first: function () {
            return this.eq(0);
        },

        last: function () {
            return this.eq(-1);
        },

        eq: function (i) {
            var len = this.length,
                j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
        },

        end: function () {
            return this.prevObject || this.constructor();
        },

        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };

    jQuery.extend = jQuery.fn.extend = function () {
        var options, name, src, copy, copyIsArray, clone,
            target = arguments[0] || {},
            i = 1,
            length = arguments.length,
            deep = false;

        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;

            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }

        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) {
            target = {};
        }

        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }

        for (; i < length; i++) {

            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) {

                // Extend the base object
                for (name in options) {
                    src = target[name];
                    copy = options[name];

                    // Prevent never-ending loop
                    if (target === copy) {
                        continue;
                    }

                    // Recurse if we're merging plain objects or arrays
                    if (deep && copy && (jQuery.isPlainObject(copy) ||
                        (copyIsArray = Array.isArray(copy)))) {

                        if (copyIsArray) {
                            copyIsArray = false;
                            clone = src && Array.isArray(src) ? src : [];

                        } else {
                            clone = src && jQuery.isPlainObject(src) ? src : {};
                        }

                        // Never move original objects, clone them
                        target[name] = jQuery.extend(deep, clone, copy);

                        // Don't bring in undefined values
                    } else if (copy !== undefined) {
                        target[name] = copy;
                    }
                }
            }
        }

        // Return the modified object
        return target;
    };

    jQuery.extend({

        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version$1 + Math.random()).replace(/\D/g, ""),

        // Assume jQuery is ready without the ready module
        isReady: true,

        error: function (msg) {
            throw new Error(msg);
        },

        noop: function () {
        },

        isPlainObject: function (obj) {
            var proto, Ctor;

            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString$3.call(obj) !== "[object Object]") {
                return false;
            }

            proto = getProto(obj);

            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) {
                return true;
            }

            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },

        isEmptyObject: function (obj) {

            /* eslint-disable no-unused-vars */
            // See https://github.com/eslint/eslint/issues/6125
            var name;

            for (name in obj) {
                return false;
            }
            return true;
        },

        // Evaluates a script in a global context
        globalEval: function (code) {
            DOMEval(code);
        },

        each: function (obj, callback) {
            var length, i = 0;

            if (isArrayLike(obj)) {
                length = obj.length;
                for (; i < length; i++) {
                    if (callback.call(obj[i], i, obj[i]) === false) {
                        break;
                    }
                }
            } else {
                for (i in obj) {
                    if (callback.call(obj[i], i, obj[i]) === false) {
                        break;
                    }
                }
            }

            return obj;
        },

        // Support: Android <=4.0 only
        trim: function (text) {
            return text == null ?
                "" :
                (text + "").replace(rtrim, "");
        },

        // results is for internal usage only
        makeArray: function (arr, results) {
            var ret = results || [];

            if (arr != null) {
                if (isArrayLike(Object(arr))) {
                    jQuery.merge(ret,
                        typeof arr === "string" ?
                            [arr] : arr
                    );
                } else {
                    push.call(ret, arr);
                }
            }

            return ret;
        },

        inArray: function (elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },

        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function (first, second) {
            var len = +second.length,
                j = 0,
                i = first.length;

            for (; j < len; j++) {
                first[i++] = second[j];
            }

            first.length = i;

            return first;
        },

        grep: function (elems, callback, invert) {
            var callbackInverse,
                matches = [],
                i = 0,
                length = elems.length,
                callbackExpect = !invert;

            // Go through the array, only saving the items
            // that pass the validator function
            for (; i < length; i++) {
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) {
                    matches.push(elems[i]);
                }
            }

            return matches;
        },

        // arg is for internal usage only
        map: function (elems, callback, arg) {
            var length, value,
                i = 0,
                ret = [];

            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for (; i < length; i++) {
                    value = callback(elems[i], i, arg);

                    if (value != null) {
                        ret.push(value);
                    }
                }

                // Go through every key on the object,
            } else {
                for (i in elems) {
                    value = callback(elems[i], i, arg);

                    if (value != null) {
                        ret.push(value);
                    }
                }
            }

            // Flatten any nested arrays
            return concat.apply([], ret);
        },

        // A global GUID counter for objects
        guid: 1,

        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });

    if (typeof Symbol === "function") {
        jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    }

    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
        function (i, name) {
            class2type["[object " + name + "]"] = name.toLowerCase();
        });

    function isArrayLike(obj) {

        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length,
            type = toType(obj);

        if (isFunction(obj) || isWindow(obj)) {
            return false;
        }

        return type === "array" || length === 0 ||
            typeof length === "number" && length > 0 && (length - 1) in obj;
    }

    var Sizzle =
        /*!
     * Sizzle CSS Selector Engine v2.3.3
     * https://sizzlejs.com/
     *
     * Copyright jQuery Foundation and other contributors
     * Released under the MIT license
     * http://jquery.org/license
     *
     * Date: 2016-08-08
     */
        (function (window) {

            var i,
                support,
                Expr,
                getText,
                isXML,
                tokenize,
                compile,
                select,
                outermostContext,
                sortInput,
                hasDuplicate,

                // Local document vars
                setDocument,
                document,
                docElem,
                documentIsHTML,
                rbuggyQSA,
                rbuggyMatches,
                matches,
                contains,

                // Instance-specific data
                expando = "sizzle" + 1 * new Date(),
                preferredDoc = window.document,
                dirruns = 0,
                done = 0,
                classCache = createCache(),
                tokenCache = createCache(),
                compilerCache = createCache(),
                sortOrder = function (a, b) {
                    if (a === b) {
                        hasDuplicate = true;
                    }
                    return 0;
                },

                // Instance methods
                hasOwn = ({}).hasOwnProperty,
                arr = [],
                pop = arr.pop,
                push_native = arr.push,
                push = arr.push,
                slice = arr.slice,
                // Use a stripped-down indexOf as it's faster than native
                // https://jsperf.com/thor-indexof-vs-for/5
                indexOf = function (list, elem) {
                    var i = 0,
                        len = list.length;
                    for (; i < len; i++) {
                        if (list[i] === elem) {
                            return i;
                        }
                    }
                    return -1;
                },

                booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

                // Regular expressions

                // http://www.w3.org/TR/css3-selectors/#whitespace
                whitespace = "[\\x20\\t\\r\\n\\f]",

                // http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
                identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

                // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
                attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
                    // Operator (capture 2)
                    "*([*^$|!~]?=)" + whitespace +
                    // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
                    "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
                    "*\\]",

                pseudos = ":(" + identifier + ")(?:\\((" +
                    // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
                    // 1. quoted (capture 3; capture 4 or capture 5)
                    "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
                    // 2. simple (capture 6)
                    "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
                    // 3. anything else (capture 2)
                    ".*" +
                    ")\\)|)",

                // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
                rwhitespace = new RegExp(whitespace + "+", "g"),
                rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),

                rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
                rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),

                rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"),

                rpseudo = new RegExp(pseudos),
                ridentifier = new RegExp("^" + identifier + "$"),

                matchExpr = {
                    "ID": new RegExp("^#(" + identifier + ")"),
                    "CLASS": new RegExp("^\\.(" + identifier + ")"),
                    "TAG": new RegExp("^(" + identifier + "|[*])"),
                    "ATTR": new RegExp("^" + attributes),
                    "PSEUDO": new RegExp("^" + pseudos),
                    "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
                        "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
                        "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
                    "bool": new RegExp("^(?:" + booleans + ")$", "i"),
                    // For use in libraries implementing .is()
                    // We use this for POS matching in `select`
                    "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                        whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
                },

                rinputs = /^(?:input|select|textarea|button)$/i,
                rheader = /^h\d$/i,

                rnative = /^[^{]+\{\s*\[native \w/,

                // Easily-parseable/retrievable ID or TAG or CLASS selectors
                rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

                rsibling = /[+~]/,

                // CSS escapes
                // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
                runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"),
                funescape = function (_, escaped, escapedWhitespace) {
                    var high = "0x" + escaped - 0x10000;
                    // NaN means non-codepoint
                    // Support: Firefox<24
                    // Workaround erroneous numeric interpretation of +"0x"
                    return high !== high || escapedWhitespace ?
                        escaped :
                        high < 0 ?
                            // BMP codepoint
                            String.fromCharCode(high + 0x10000) :
                            // Supplemental Plane codepoint (surrogate pair)
                            String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
                },

                // CSS string/identifier serialization
                // https://drafts.csswg.org/cssom/#common-serializing-idioms
                // eslint-disable-next-line no-control-regex
                rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                fcssescape = function (ch, asCodePoint) {
                    if (asCodePoint) {

                        // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                        if (ch === "\0") {
                            return "\uFFFD";
                        }

                        // Control characters and (dependent upon position) numbers get escaped as code points
                        return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
                    }

                    // Other potentially-special ASCII characters get backslash-escaped
                    return "\\" + ch;
                },

                // Used for iframes
                // See setDocument()
                // Removing the function wrapper causes a "Permission Denied"
                // error in IE
                unloadHandler = function () {
                    setDocument();
                },

                disabledAncestor = addCombinator(
                    function (elem) {
                        return elem.disabled === true && ("form" in elem || "label" in elem);
                    },
                    {dir: "parentNode", next: "legend"}
                );

    // Optimize for push.apply( _, NodeList )
            try {
                push.apply(
                    (arr = slice.call(preferredDoc.childNodes)),
                    preferredDoc.childNodes
                );
                // Support: Android<4.0
                // Detect silently failing push.apply
                arr[preferredDoc.childNodes.length].nodeType;
            } catch (e) {
                push = {
                    apply: arr.length ?

                        // Leverage slice if possible
                        function (target, els) {
                            push_native.apply(target, slice.call(els));
                        } :

                        // Support: IE<9
                        // Otherwise append directly
                        function (target, els) {
                            var j = target.length,
                                i = 0;
                            // Can't trust NodeList.length
                            while ((target[j++] = els[i++])) {
                            }
                            target.length = j - 1;
                        }
                };
            }

            function Sizzle(selector, context, results, seed) {
                var m, i, elem, nid, match, groups, newSelector,
                    newContext = context && context.ownerDocument,

                    // nodeType defaults to 9, since context defaults to document
                    nodeType = context ? context.nodeType : 9;

                results = results || [];

                // Return early from calls with invalid selector or context
                if (typeof selector !== "string" || !selector ||
                    nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {

                    return results;
                }

                // Try to shortcut find operations (as opposed to filters) in HTML documents
                if (!seed) {

                    if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
                        setDocument(context);
                    }
                    context = context || document;

                    if (documentIsHTML) {

                        // If the selector is sufficiently simple, try using a "get*By*" DOM method
                        // (excepting DocumentFragment context, where the methods don't exist)
                        if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {

                            // ID selector
                            if ((m = match[1])) {

                                // Document context
                                if (nodeType === 9) {
                                    if ((elem = context.getElementById(m))) {

                                        // Support: IE, Opera, Webkit
                                        // TODO: identify versions
                                        // getElementById can match elements by name instead of ID
                                        if (elem.id === m) {
                                            results.push(elem);
                                            return results;
                                        }
                                    } else {
                                        return results;
                                    }

                                    // Element context
                                } else {

                                    // Support: IE, Opera, Webkit
                                    // TODO: identify versions
                                    // getElementById can match elements by name instead of ID
                                    if (newContext && (elem = newContext.getElementById(m)) &&
                                        contains(context, elem) &&
                                        elem.id === m) {

                                        results.push(elem);
                                        return results;
                                    }
                                }

                                // Type selector
                            } else if (match[2]) {
                                push.apply(results, context.getElementsByTagName(selector));
                                return results;

                                // Class selector
                            } else if ((m = match[3]) && support.getElementsByClassName &&
                                context.getElementsByClassName) {

                                push.apply(results, context.getElementsByClassName(m));
                                return results;
                            }
                        }

                        // Take advantage of querySelectorAll
                        if (support.qsa &&
                            !compilerCache[selector + " "] &&
                            (!rbuggyQSA || !rbuggyQSA.test(selector))) {

                            if (nodeType !== 1) {
                                newContext = context;
                                newSelector = selector;

                                // qSA looks outside Element context, which is not what we want
                                // Thanks to Andrew Dupont for this workaround technique
                                // Support: IE <=8
                                // Exclude object elements
                            } else if (context.nodeName.toLowerCase() !== "object") {

                                // Capture the context ID, setting it first if necessary
                                if ((nid = context.getAttribute("id"))) {
                                    nid = nid.replace(rcssescape, fcssescape);
                                } else {
                                    context.setAttribute("id", (nid = expando));
                                }

                                // Prefix every selector in the list
                                groups = tokenize(selector);
                                i = groups.length;
                                while (i--) {
                                    groups[i] = "#" + nid + " " + toSelector(groups[i]);
                                }
                                newSelector = groups.join(",");

                                // Expand context for sibling selectors
                                newContext = rsibling.test(selector) && testContext(context.parentNode) ||
                                    context;
                            }

                            if (newSelector) {
                                try {
                                    push.apply(results,
                                        newContext.querySelectorAll(newSelector)
                                    );
                                    return results;
                                } catch (qsaError) {
                                } finally {
                                    if (nid === expando) {
                                        context.removeAttribute("id");
                                    }
                                }
                            }
                        }
                    }
                }

                // All others
                return select(selector.replace(rtrim, "$1"), context, results, seed);
            }

            /**
             * Create key-value caches of limited size
             * @returns {function(string, object)} Returns the Object data after storing it on itself with
             *    property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
             *    deleting the oldest entry
             */
            function createCache() {
                var keys = [];

                function cache(key, value) {
                    // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                    if (keys.push(key + " ") > Expr.cacheLength) {
                        // Only keep the most recent entries
                        delete cache[keys.shift()];
                    }
                    return (cache[key + " "] = value);
                }

                return cache;
            }

            /**
             * Mark a function for special use by Sizzle
             * @param {Function} fn The function to mark
             */
            function markFunction(fn) {
                fn[expando] = true;
                return fn;
            }

            /**
             * Support testing using an element
             * @param {Function} fn Passed the created element and returns a boolean result
             */
            function assert(fn) {
                var el = document.createElement("fieldset");

                try {
                    return !!fn(el);
                } catch (e) {
                    return false;
                } finally {
                    // Remove from its parent by default
                    if (el.parentNode) {
                        el.parentNode.removeChild(el);
                    }
                    // release memory in IE
                    el = null;
                }
            }

            /**
             * Checks document order of two siblings
             * @param {Element} a
             * @param {Element} b
             * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
             */
            function siblingCheck(a, b) {
                var cur = b && a,
                    diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
                        a.sourceIndex - b.sourceIndex;

                // Use IE sourceIndex if available on both nodes
                if (diff) {
                    return diff;
                }

                // Check if b follows a
                if (cur) {
                    while ((cur = cur.nextSibling)) {
                        if (cur === b) {
                            return -1;
                        }
                    }
                }

                return a ? 1 : -1;
            }

            /**
             * Returns a function to use in pseudos for input types
             * @param {String} type
             */
            function createInputPseudo(type) {
                return function (elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === type;
                };
            }

            /**
             * Returns a function to use in pseudos for buttons
             * @param {String} type
             */
            function createButtonPseudo(type) {
                return function (elem) {
                    var name = elem.nodeName.toLowerCase();
                    return (name === "input" || name === "button") && elem.type === type;
                };
            }

            /**
             * Returns a function to use in pseudos for :enabled/:disabled
             * @param {Boolean} disabled true for :disabled; false for :enabled
             */
            function createDisabledPseudo(disabled) {

                // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
                return function (elem) {

                    // Only certain elements can match :enabled or :disabled
                    // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                    // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                    if ("form" in elem) {

                        // Check for inherited disabledness on relevant non-disabled elements:
                        // * listed form-associated elements in a disabled fieldset
                        //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                        //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                        // * option elements in a disabled optgroup
                        //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                        // All such elements have a "form" property.
                        if (elem.parentNode && elem.disabled === false) {

                            // Option elements defer to a parent optgroup if present
                            if ("label" in elem) {
                                if ("label" in elem.parentNode) {
                                    return elem.parentNode.disabled === disabled;
                                } else {
                                    return elem.disabled === disabled;
                                }
                            }

                            // Support: IE 6 - 11
                            // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                            return elem.isDisabled === disabled ||

                                // Where there is no isDisabled, check manually
                                /* jshint -W018 */
                                elem.isDisabled !== !disabled &&
                                disabledAncestor(elem) === disabled;
                        }

                        return elem.disabled === disabled;

                        // Try to winnow out elements that can't be disabled before trusting the disabled property.
                        // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                        // even exist on them, let alone have a boolean value.
                    } else if ("label" in elem) {
                        return elem.disabled === disabled;
                    }

                    // Remaining elements are neither :enabled nor :disabled
                    return false;
                };
            }

            /**
             * Returns a function to use in pseudos for positionals
             * @param {Function} fn
             */
            function createPositionalPseudo(fn) {
                return markFunction(function (argument) {
                    argument = +argument;
                    return markFunction(function (seed, matches) {
                        var j,
                            matchIndexes = fn([], seed.length, argument),
                            i = matchIndexes.length;

                        // Match elements found at the specified indexes
                        while (i--) {
                            if (seed[(j = matchIndexes[i])]) {
                                seed[j] = !(matches[j] = seed[j]);
                            }
                        }
                    });
                });
            }

            /**
             * Checks a node for validity as a Sizzle context
             * @param {Element|Object=} context
             * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
             */
            function testContext(context) {
                return context && typeof context.getElementsByTagName !== "undefined" && context;
            }

    // Expose support vars for convenience
            support = Sizzle.support = {};

            /**
             * Detects XML nodes
             * @param {Element|Object} elem An element or a document
             * @returns {Boolean} True iff elem is a non-HTML XML node
             */
            isXML = Sizzle.isXML = function (elem) {
                // documentElement is verified for cases where it doesn't yet exist
                // (such as loading iframes in IE - #4833)
                var documentElement = elem && (elem.ownerDocument || elem).documentElement;
                return documentElement ? documentElement.nodeName !== "HTML" : false;
            };

            /**
             * Sets document-related variables once based on the current document
             * @param {Element|Object} [doc] An element or document object to use to set the document
             * @returns {Object} Returns the current document
             */
            setDocument = Sizzle.setDocument = function (node) {
                var hasCompare, subWindow,
                    doc = node ? node.ownerDocument || node : preferredDoc;

                // Return early if doc is invalid or already selected
                if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
                    return document;
                }

                // Update global variables
                document = doc;
                docElem = document.documentElement;
                documentIsHTML = !isXML(document);

                // Support: IE 9-11, Edge
                // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
                if (preferredDoc !== document &&
                    (subWindow = document.defaultView) && subWindow.top !== subWindow) {

                    // Support: IE 11, Edge
                    if (subWindow.addEventListener) {
                        subWindow.addEventListener("unload", unloadHandler, false);

                        // Support: IE 9 - 10 only
                    } else if (subWindow.attachEvent) {
                        subWindow.attachEvent("onunload", unloadHandler);
                    }
                }

                /* Attributes
    	---------------------------------------------------------------------- */

                // Support: IE<8
                // Verify that getAttribute really returns attributes and not properties
                // (excepting IE8 booleans)
                support.attributes = assert(function (el) {
                    el.className = "i";
                    return !el.getAttribute("className");
                });

                /* getElement(s)By*
    	---------------------------------------------------------------------- */

                // Check if getElementsByTagName("*") returns only elements
                support.getElementsByTagName = assert(function (el) {
                    el.appendChild(document.createComment(""));
                    return !el.getElementsByTagName("*").length;
                });

                // Support: IE<9
                support.getElementsByClassName = rnative.test(document.getElementsByClassName);

                // Support: IE<10
                // Check if getElementById returns elements by name
                // The broken getElementById methods don't pick up programmatically-set names,
                // so use a roundabout getElementsByName test
                support.getById = assert(function (el) {
                    docElem.appendChild(el).id = expando;
                    return !document.getElementsByName || !document.getElementsByName(expando).length;
                });

                // ID filter and find
                if (support.getById) {
                    Expr.filter["ID"] = function (id) {
                        var attrId = id.replace(runescape, funescape);
                        return function (elem) {
                            return elem.getAttribute("id") === attrId;
                        };
                    };
                    Expr.find["ID"] = function (id, context) {
                        if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                            var elem = context.getElementById(id);
                            return elem ? [elem] : [];
                        }
                    };
                } else {
                    Expr.filter["ID"] = function (id) {
                        var attrId = id.replace(runescape, funescape);
                        return function (elem) {
                            var node = typeof elem.getAttributeNode !== "undefined" &&
                                elem.getAttributeNode("id");
                            return node && node.value === attrId;
                        };
                    };

                    // Support: IE 6 - 7 only
                    // getElementById is not reliable as a find shortcut
                    Expr.find["ID"] = function (id, context) {
                        if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                            var node, i, elems,
                                elem = context.getElementById(id);

                            if (elem) {

                                // Verify the id attribute
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) {
                                    return [elem];
                                }

                                // Fall back on getElementsByName
                                elems = context.getElementsByName(id);
                                i = 0;
                                while ((elem = elems[i++])) {
                                    node = elem.getAttributeNode("id");
                                    if (node && node.value === id) {
                                        return [elem];
                                    }
                                }
                            }

                            return [];
                        }
                    };
                }

                // Tag
                Expr.find["TAG"] = support.getElementsByTagName ?
                    function (tag, context) {
                        if (typeof context.getElementsByTagName !== "undefined") {
                            return context.getElementsByTagName(tag);

                            // DocumentFragment nodes don't have gEBTN
                        } else if (support.qsa) {
                            return context.querySelectorAll(tag);
                        }
                    } :

                    function (tag, context) {
                        var elem,
                            tmp = [],
                            i = 0,
                            // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                            results = context.getElementsByTagName(tag);

                        // Filter out possible comments
                        if (tag === "*") {
                            while ((elem = results[i++])) {
                                if (elem.nodeType === 1) {
                                    tmp.push(elem);
                                }
                            }

                            return tmp;
                        }
                        return results;
                    };

                // Class
                Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
                    if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
                        return context.getElementsByClassName(className);
                    }
                };

                /* QSA/matchesSelector
    	---------------------------------------------------------------------- */

                // QSA and matchesSelector support

                // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
                rbuggyMatches = [];

                // qSa(:focus) reports false when true (Chrome 21)
                // We allow this because of a bug in IE8/9 that throws an error
                // whenever `document.activeElement` is accessed on an iframe
                // So, we allow :focus to pass through QSA all the time to avoid the IE error
                // See https://bugs.jquery.com/ticket/13378
                rbuggyQSA = [];

                if ((support.qsa = rnative.test(document.querySelectorAll))) {
                    // Build QSA regex
                    // Regex strategy adopted from Diego Perini
                    assert(function (el) {
                        // Select is set to empty string on purpose
                        // This is to test IE's treatment of not explicitly
                        // setting a boolean content attribute,
                        // since its presence should be enough
                        // https://bugs.jquery.com/ticket/12359
                        docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" +
                            "<select id='" + expando + "-\r\\' msallowcapture=''>" +
                            "<option selected=''></option></select>";

                        // Support: IE8, Opera 11-12.16
                        // Nothing should be selected when empty strings follow ^= or $= or *=
                        // The test attribute must be unknown in Opera but "safe" for WinRT
                        // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                        if (el.querySelectorAll("[msallowcapture^='']").length) {
                            rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                        }

                        // Support: IE8
                        // Boolean attributes and "value" are not treated correctly
                        if (!el.querySelectorAll("[selected]").length) {
                            rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                        }

                        // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                        if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
                            rbuggyQSA.push("~=");
                        }

                        // Webkit/Opera - :checked should return selected option elements
                        // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                        // IE8 throws error here and will not see later tests
                        if (!el.querySelectorAll(":checked").length) {
                            rbuggyQSA.push(":checked");
                        }

                        // Support: Safari 8+, iOS 8+
                        // https://bugs.webkit.org/show_bug.cgi?id=136851
                        // In-page `selector#id sibling-combinator selector` fails
                        if (!el.querySelectorAll("a#" + expando + "+*").length) {
                            rbuggyQSA.push(".#.+[+~]");
                        }
                    });

                    assert(function (el) {
                        el.innerHTML = "<a href='' disabled='disabled'></a>" +
                            "<select disabled='disabled'><option/></select>";

                        // Support: Windows 8 Native Apps
                        // The type and name attributes are restricted during .innerHTML assignment
                        var input = document.createElement("input");
                        input.setAttribute("type", "hidden");
                        el.appendChild(input).setAttribute("name", "D");

                        // Support: IE8
                        // Enforce case-sensitivity of name attribute
                        if (el.querySelectorAll("[name=d]").length) {
                            rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                        }

                        // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                        // IE8 throws error here and will not see later tests
                        if (el.querySelectorAll(":enabled").length !== 2) {
                            rbuggyQSA.push(":enabled", ":disabled");
                        }

                        // Support: IE9-11+
                        // IE's :disabled selector does not pick up the children of disabled fieldsets
                        docElem.appendChild(el).disabled = true;
                        if (el.querySelectorAll(":disabled").length !== 2) {
                            rbuggyQSA.push(":enabled", ":disabled");
                        }

                        // Opera 10-11 does not throw on post-comma invalid pseudos
                        el.querySelectorAll("*,:x");
                        rbuggyQSA.push(",.*:");
                    });
                }

                if ((support.matchesSelector = rnative.test((matches = docElem.matches ||
                    docElem.webkitMatchesSelector ||
                    docElem.mozMatchesSelector ||
                    docElem.oMatchesSelector ||
                    docElem.msMatchesSelector)))) {

                    assert(function (el) {
                        // Check to see if it's possible to do matchesSelector
                        // on a disconnected node (IE 9)
                        support.disconnectedMatch = matches.call(el, "*");

                        // This should fail with an exception
                        // Gecko does not error, returns false instead
                        matches.call(el, "[s!='']:x");
                        rbuggyMatches.push("!=", pseudos);
                    });
                }

                rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
                rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));

                /* Contains
    	---------------------------------------------------------------------- */
                hasCompare = rnative.test(docElem.compareDocumentPosition);

                // Element contains another
                // Purposefully self-exclusive
                // As in, an element does not contain itself
                contains = hasCompare || rnative.test(docElem.contains) ?
                    function (a, b) {
                        var adown = a.nodeType === 9 ? a.documentElement : a,
                            bup = b && b.parentNode;
                        return a === bup || !!(bup && bup.nodeType === 1 && (
                            adown.contains ?
                                adown.contains(bup) :
                                a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
                        ));
                    } :
                    function (a, b) {
                        if (b) {
                            while ((b = b.parentNode)) {
                                if (b === a) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    };

                /* Sorting
    	---------------------------------------------------------------------- */

                // Document order sorting
                sortOrder = hasCompare ?
                    function (a, b) {

                        // Flag for duplicate removal
                        if (a === b) {
                            hasDuplicate = true;
                            return 0;
                        }

                        // Sort on method existence if only one input has compareDocumentPosition
                        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                        if (compare) {
                            return compare;
                        }

                        // Calculate position if both inputs belong to the same document
                        compare = (a.ownerDocument || a) === (b.ownerDocument || b) ?
                            a.compareDocumentPosition(b) :

                            // Otherwise we know they are disconnected
                            1;

                        // Disconnected nodes
                        if (compare & 1 ||
                            (!support.sortDetached && b.compareDocumentPosition(a) === compare)) {

                            // Choose the first element that is related to our preferred document
                            if (a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
                                return -1;
                            }
                            if (b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
                                return 1;
                            }

                            // Maintain original order
                            return sortInput ?
                                (indexOf(sortInput, a) - indexOf(sortInput, b)) :
                                0;
                        }

                        return compare & 4 ? -1 : 1;
                    } :
                    function (a, b) {
                        // Exit early if the nodes are identical
                        if (a === b) {
                            hasDuplicate = true;
                            return 0;
                        }

                        var cur,
                            i = 0,
                            aup = a.parentNode,
                            bup = b.parentNode,
                            ap = [a],
                            bp = [b];

                        // Parentless nodes are either documents or disconnected
                        if (!aup || !bup) {
                            return a === document ? -1 :
                                b === document ? 1 :
                                    aup ? -1 :
                                        bup ? 1 :
                                            sortInput ?
                                                (indexOf(sortInput, a) - indexOf(sortInput, b)) :
                                                0;

                            // If the nodes are siblings, we can do a quick check
                        } else if (aup === bup) {
                            return siblingCheck(a, b);
                        }

                        // Otherwise we need full lists of their ancestors for comparison
                        cur = a;
                        while ((cur = cur.parentNode)) {
                            ap.unshift(cur);
                        }
                        cur = b;
                        while ((cur = cur.parentNode)) {
                            bp.unshift(cur);
                        }

                        // Walk down the tree looking for a discrepancy
                        while (ap[i] === bp[i]) {
                            i++;
                        }

                        return i ?
                            // Do a sibling check if the nodes have a common ancestor
                            siblingCheck(ap[i], bp[i]) :

                            // Otherwise nodes in our document sort first
                            ap[i] === preferredDoc ? -1 :
                                bp[i] === preferredDoc ? 1 :
                                    0;
                    };

                return document;
            };

            Sizzle.matches = function (expr, elements) {
                return Sizzle(expr, null, null, elements);
            };

            Sizzle.matchesSelector = function (elem, expr) {
                // Set document vars if needed
                if ((elem.ownerDocument || elem) !== document) {
                    setDocument(elem);
                }

                // Make sure that attribute selectors are quoted
                expr = expr.replace(rattributeQuotes, "='$1']");

                if (support.matchesSelector && documentIsHTML &&
                    !compilerCache[expr + " "] &&
                    (!rbuggyMatches || !rbuggyMatches.test(expr)) &&
                    (!rbuggyQSA || !rbuggyQSA.test(expr))) {

                    try {
                        var ret = matches.call(elem, expr);

                        // IE 9's matchesSelector returns false on disconnected nodes
                        if (ret || support.disconnectedMatch ||
                            // As well, disconnected nodes are said to be in a document
                            // fragment in IE 9
                            elem.document && elem.document.nodeType !== 11) {
                            return ret;
                        }
                    } catch (e) {
                    }
                }

                return Sizzle(expr, document, null, [elem]).length > 0;
            };

            Sizzle.contains = function (context, elem) {
                // Set document vars if needed
                if ((context.ownerDocument || context) !== document) {
                    setDocument(context);
                }
                return contains(context, elem);
            };

            Sizzle.attr = function (elem, name) {
                // Set document vars if needed
                if ((elem.ownerDocument || elem) !== document) {
                    setDocument(elem);
                }

                var fn = Expr.attrHandle[name.toLowerCase()],
                    // Don't get fooled by Object.prototype properties (jQuery #13807)
                    val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ?
                        fn(elem, name, !documentIsHTML) :
                        undefined;

                return val !== undefined ?
                    val :
                    support.attributes || !documentIsHTML ?
                        elem.getAttribute(name) :
                        (val = elem.getAttributeNode(name)) && val.specified ?
                            val.value :
                            null;
            };

            Sizzle.escape = function (sel) {
                return (sel + "").replace(rcssescape, fcssescape);
            };

            Sizzle.error = function (msg) {
                throw new Error("Syntax error, unrecognized expression: " + msg);
            };

            /**
             * Document sorting and removing duplicates
             * @param {ArrayLike} results
             */
            Sizzle.uniqueSort = function (results) {
                var elem,
                    duplicates = [],
                    j = 0,
                    i = 0;

                // Unless we *know* we can detect duplicates, assume their presence
                hasDuplicate = !support.detectDuplicates;
                sortInput = !support.sortStable && results.slice(0);
                results.sort(sortOrder);

                if (hasDuplicate) {
                    while ((elem = results[i++])) {
                        if (elem === results[i]) {
                            j = duplicates.push(i);
                        }
                    }
                    while (j--) {
                        results.splice(duplicates[j], 1);
                    }
                }

                // Clear input after sorting to release objects
                // See https://github.com/jquery/sizzle/pull/225
                sortInput = null;

                return results;
            };

            /**
             * Utility function for retrieving the text value of an array of DOM nodes
             * @param {Array|Element} elem
             */
            getText = Sizzle.getText = function (elem) {
                var node,
                    ret = "",
                    i = 0,
                    nodeType = elem.nodeType;

                if (!nodeType) {
                    // If no nodeType, this is expected to be an array
                    while ((node = elem[i++])) {
                        // Do not traverse comment nodes
                        ret += getText(node);
                    }
                } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                    // Use textContent for elements
                    // innerText usage removed for consistency of new lines (jQuery #11153)
                    if (typeof elem.textContent === "string") {
                        return elem.textContent;
                    } else {
                        // Traverse its children
                        for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                            ret += getText(elem);
                        }
                    }
                } else if (nodeType === 3 || nodeType === 4) {
                    return elem.nodeValue;
                }
                // Do not include comment or processing instruction nodes

                return ret;
            };

            Expr = Sizzle.selectors = {

                // Can be adjusted by the user
                cacheLength: 50,

                createPseudo: markFunction,

                match: matchExpr,

                attrHandle: {},

                find: {},

                relative: {
                    ">": {dir: "parentNode", first: true},
                    " ": {dir: "parentNode"},
                    "+": {dir: "previousSibling", first: true},
                    "~": {dir: "previousSibling"}
                },

                preFilter: {
                    "ATTR": function (match) {
                        match[1] = match[1].replace(runescape, funescape);

                        // Move the given value to match[3] whether quoted or unquoted
                        match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);

                        if (match[2] === "~=") {
                            match[3] = " " + match[3] + " ";
                        }

                        return match.slice(0, 4);
                    },

                    "CHILD": function (match) {
                        /* matches from matchExpr["CHILD"]
    				1 type (only|nth|...)
    				2 what (child|of-type)
    				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
    				4 xn-component of xn+y argument ([+-]?\d*n|)
    				5 sign of xn-component
    				6 x of xn-component
    				7 sign of y-component
    				8 y of y-component
    			*/
                        match[1] = match[1].toLowerCase();

                        if (match[1].slice(0, 3) === "nth") {
                            // nth-* requires argument
                            if (!match[3]) {
                                Sizzle.error(match[0]);
                            }

                            // numeric x and y parameters for Expr.filter.CHILD
                            // remember that false/true cast respectively to 0/1
                            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                            match[5] = +((match[7] + match[8]) || match[3] === "odd");

                            // other types prohibit arguments
                        } else if (match[3]) {
                            Sizzle.error(match[0]);
                        }

                        return match;
                    },

                    "PSEUDO": function (match) {
                        var excess,
                            unquoted = !match[6] && match[2];

                        if (matchExpr["CHILD"].test(match[0])) {
                            return null;
                        }

                        // Accept quoted arguments as-is
                        if (match[3]) {
                            match[2] = match[4] || match[5] || "";

                            // Strip excess characters from unquoted arguments
                        } else if (unquoted && rpseudo.test(unquoted) &&
                            // Get excess from tokenize (recursively)
                            (excess = tokenize(unquoted, true)) &&
                            // advance to the next closing parenthesis
                            (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {

                            // excess is a negative index
                            match[0] = match[0].slice(0, excess);
                            match[2] = unquoted.slice(0, excess);
                        }

                        // Return only captures needed by the pseudo filter method (type and argument)
                        return match.slice(0, 3);
                    }
                },

                filter: {

                    "TAG": function (nodeNameSelector) {
                        var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                        return nodeNameSelector === "*" ?
                            function () {
                                return true;
                            } :
                            function (elem) {
                                return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                            };
                    },

                    "CLASS": function (className) {
                        var pattern = classCache[className + " "];

                        return pattern ||
                            (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) &&
                            classCache(className, function (elem) {
                                return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                            });
                    },

                    "ATTR": function (name, operator, check) {
                        return function (elem) {
                            var result = Sizzle.attr(elem, name);

                            if (result == null) {
                                return operator === "!=";
                            }
                            if (!operator) {
                                return true;
                            }

                            result += "";

                            return operator === "=" ? result === check :
                                operator === "!=" ? result !== check :
                                    operator === "^=" ? check && result.indexOf(check) === 0 :
                                        operator === "*=" ? check && result.indexOf(check) > -1 :
                                            operator === "$=" ? check && result.slice(-check.length) === check :
                                                operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 :
                                                    operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" :
                                                        false;
                        };
                    },

                    "CHILD": function (type, what, argument, first, last) {
                        var simple = type.slice(0, 3) !== "nth",
                            forward = type.slice(-4) !== "last",
                            ofType = what === "of-type";

                        return first === 1 && last === 0 ?

                            // Shortcut for :nth-*(n)
                            function (elem) {
                                return !!elem.parentNode;
                            } :

                            function (elem, context, xml) {
                                var cache, uniqueCache, outerCache, node, nodeIndex, start,
                                    dir = simple !== forward ? "nextSibling" : "previousSibling",
                                    parent = elem.parentNode,
                                    name = ofType && elem.nodeName.toLowerCase(),
                                    useCache = !xml && !ofType,
                                    diff = false;

                                if (parent) {

                                    // :(first|last|only)-(child|of-type)
                                    if (simple) {
                                        while (dir) {
                                            node = elem;
                                            while ((node = node[dir])) {
                                                if (ofType ?
                                                    node.nodeName.toLowerCase() === name :
                                                    node.nodeType === 1) {

                                                    return false;
                                                }
                                            }
                                            // Reverse direction for :only-* (if we haven't yet done so)
                                            start = dir = type === "only" && !start && "nextSibling";
                                        }
                                        return true;
                                    }

                                    start = [forward ? parent.firstChild : parent.lastChild];

                                    // non-xml :nth-child(...) stores cache data on `parent`
                                    if (forward && useCache) {

                                        // Seek `elem` from a previously-cached index

                                        // ...in a gzip-friendly way
                                        node = parent;
                                        outerCache = node[expando] || (node[expando] = {});

                                        // Support: IE <9 only
                                        // Defend against cloned attroperties (jQuery gh-1709)
                                        uniqueCache = outerCache[node.uniqueID] ||
                                            (outerCache[node.uniqueID] = {});

                                        cache = uniqueCache[type] || [];
                                        nodeIndex = cache[0] === dirruns && cache[1];
                                        diff = nodeIndex && cache[2];
                                        node = nodeIndex && parent.childNodes[nodeIndex];

                                        while ((node = ++nodeIndex && node && node[dir] ||

                                            // Fallback to seeking `elem` from the start
                                            (diff = nodeIndex = 0) || start.pop())) {

                                            // When found, cache indexes on `parent` and break
                                            if (node.nodeType === 1 && ++diff && node === elem) {
                                                uniqueCache[type] = [dirruns, nodeIndex, diff];
                                                break;
                                            }
                                        }

                                    } else {
                                        // Use previously-cached element index if available
                                        if (useCache) {
                                            // ...in a gzip-friendly way
                                            node = elem;
                                            outerCache = node[expando] || (node[expando] = {});

                                            // Support: IE <9 only
                                            // Defend against cloned attroperties (jQuery gh-1709)
                                            uniqueCache = outerCache[node.uniqueID] ||
                                                (outerCache[node.uniqueID] = {});

                                            cache = uniqueCache[type] || [];
                                            nodeIndex = cache[0] === dirruns && cache[1];
                                            diff = nodeIndex;
                                        }

                                        // xml :nth-child(...)
                                        // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                        if (diff === false) {
                                            // Use the same loop as above to seek `elem` from the start
                                            while ((node = ++nodeIndex && node && node[dir] ||
                                                (diff = nodeIndex = 0) || start.pop())) {

                                                if ((ofType ?
                                                    node.nodeName.toLowerCase() === name :
                                                    node.nodeType === 1) &&
                                                    ++diff) {

                                                    // Cache the index of each encountered element
                                                    if (useCache) {
                                                        outerCache = node[expando] || (node[expando] = {});

                                                        // Support: IE <9 only
                                                        // Defend against cloned attroperties (jQuery gh-1709)
                                                        uniqueCache = outerCache[node.uniqueID] ||
                                                            (outerCache[node.uniqueID] = {});

                                                        uniqueCache[type] = [dirruns, diff];
                                                    }

                                                    if (node === elem) {
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    // Incorporate the offset, then check against cycle size
                                    diff -= last;
                                    return diff === first || (diff % first === 0 && diff / first >= 0);
                                }
                            };
                    },

                    "PSEUDO": function (pseudo, argument) {
                        // pseudo-class names are case-insensitive
                        // http://www.w3.org/TR/selectors/#pseudo-classes
                        // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                        // Remember that setFilters inherits from pseudos
                        var args,
                            fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] ||
                                Sizzle.error("unsupported pseudo: " + pseudo);

                        // The user may use createPseudo to indicate that
                        // arguments are needed to create the filter function
                        // just as Sizzle does
                        if (fn[expando]) {
                            return fn(argument);
                        }

                        // But maintain support for old signatures
                        if (fn.length > 1) {
                            args = [pseudo, pseudo, "", argument];
                            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ?
                                markFunction(function (seed, matches) {
                                    var idx,
                                        matched = fn(seed, argument),
                                        i = matched.length;
                                    while (i--) {
                                        idx = indexOf(seed, matched[i]);
                                        seed[idx] = !(matches[idx] = matched[i]);
                                    }
                                }) :
                                function (elem) {
                                    return fn(elem, 0, args);
                                };
                        }

                        return fn;
                    }
                },

                pseudos: {
                    // Potentially complex pseudos
                    "not": markFunction(function (selector) {
                        // Trim the selector passed to compile
                        // to avoid treating leading and trailing
                        // spaces as combinators
                        var input = [],
                            results = [],
                            matcher = compile(selector.replace(rtrim, "$1"));

                        return matcher[expando] ?
                            markFunction(function (seed, matches, context, xml) {
                                var elem,
                                    unmatched = matcher(seed, null, xml, []),
                                    i = seed.length;

                                // Match elements unmatched by `matcher`
                                while (i--) {
                                    if ((elem = unmatched[i])) {
                                        seed[i] = !(matches[i] = elem);
                                    }
                                }
                            }) :
                            function (elem, context, xml) {
                                input[0] = elem;
                                matcher(input, null, xml, results);
                                // Don't keep the element (issue #299)
                                input[0] = null;
                                return !results.pop();
                            };
                    }),

                    "has": markFunction(function (selector) {
                        return function (elem) {
                            return Sizzle(selector, elem).length > 0;
                        };
                    }),

                    "contains": markFunction(function (text) {
                        text = text.replace(runescape, funescape);
                        return function (elem) {
                            return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
                        };
                    }),

                    // "Whether an element is represented by a :lang() selector
                    // is based solely on the element's language value
                    // being equal to the identifier C,
                    // or beginning with the identifier C immediately followed by "-".
                    // The matching of C against the element's language value is performed case-insensitively.
                    // The identifier C does not have to be a valid language name."
                    // http://www.w3.org/TR/selectors/#lang-pseudo
                    "lang": markFunction(function (lang) {
                        // lang value must be a valid identifier
                        if (!ridentifier.test(lang || "")) {
                            Sizzle.error("unsupported lang: " + lang);
                        }
                        lang = lang.replace(runescape, funescape).toLowerCase();
                        return function (elem) {
                            var elemLang;
                            do {
                                if ((elemLang = documentIsHTML ?
                                    elem.lang :
                                    elem.getAttribute("xml:lang") || elem.getAttribute("lang"))) {

                                    elemLang = elemLang.toLowerCase();
                                    return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                                }
                            } while ((elem = elem.parentNode) && elem.nodeType === 1);
                            return false;
                        };
                    }),

                    // Miscellaneous
                    "target": function (elem) {
                        var hash = window.location && window.location.hash;
                        return hash && hash.slice(1) === elem.id;
                    },

                    "root": function (elem) {
                        return elem === docElem;
                    },

                    "focus": function (elem) {
                        return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                    },

                    // Boolean properties
                    "enabled": createDisabledPseudo(false),
                    "disabled": createDisabledPseudo(true),

                    "checked": function (elem) {
                        // In CSS3, :checked should return both checked and selected elements
                        // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                        var nodeName = elem.nodeName.toLowerCase();
                        return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
                    },

                    "selected": function (elem) {
                        // Accessing this property makes selected-by-default
                        // options in Safari work properly
                        if (elem.parentNode) {
                            elem.parentNode.selectedIndex;
                        }

                        return elem.selected === true;
                    },

                    // Contents
                    "empty": function (elem) {
                        // http://www.w3.org/TR/selectors/#empty-pseudo
                        // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                        //   but not by others (comment: 8; processing instruction: 7; etc.)
                        // nodeType < 6 works because attributes (2) do not appear as children
                        for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                            if (elem.nodeType < 6) {
                                return false;
                            }
                        }
                        return true;
                    },

                    "parent": function (elem) {
                        return !Expr.pseudos["empty"](elem);
                    },

                    // Element/input types
                    "header": function (elem) {
                        return rheader.test(elem.nodeName);
                    },

                    "input": function (elem) {
                        return rinputs.test(elem.nodeName);
                    },

                    "button": function (elem) {
                        var name = elem.nodeName.toLowerCase();
                        return name === "input" && elem.type === "button" || name === "button";
                    },

                    "text": function (elem) {
                        var attr;
                        return elem.nodeName.toLowerCase() === "input" &&
                            elem.type === "text" &&

                            // Support: IE<8
                            // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                            ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                    },

                    // Position-in-collection
                    "first": createPositionalPseudo(function () {
                        return [0];
                    }),

                    "last": createPositionalPseudo(function (matchIndexes, length) {
                        return [length - 1];
                    }),

                    "eq": createPositionalPseudo(function (matchIndexes, length, argument) {
                        return [argument < 0 ? argument + length : argument];
                    }),

                    "even": createPositionalPseudo(function (matchIndexes, length) {
                        var i = 0;
                        for (; i < length; i += 2) {
                            matchIndexes.push(i);
                        }
                        return matchIndexes;
                    }),

                    "odd": createPositionalPseudo(function (matchIndexes, length) {
                        var i = 1;
                        for (; i < length; i += 2) {
                            matchIndexes.push(i);
                        }
                        return matchIndexes;
                    }),

                    "lt": createPositionalPseudo(function (matchIndexes, length, argument) {
                        var i = argument < 0 ? argument + length : argument;
                        for (; --i >= 0;) {
                            matchIndexes.push(i);
                        }
                        return matchIndexes;
                    }),

                    "gt": createPositionalPseudo(function (matchIndexes, length, argument) {
                        var i = argument < 0 ? argument + length : argument;
                        for (; ++i < length;) {
                            matchIndexes.push(i);
                        }
                        return matchIndexes;
                    })
                }
            };

            Expr.pseudos["nth"] = Expr.pseudos["eq"];

    // Add button/input type pseudos
            for (i in {radio: true, checkbox: true, file: true, password: true, image: true}) {
                Expr.pseudos[i] = createInputPseudo(i);
            }
            for (i in {submit: true, reset: true}) {
                Expr.pseudos[i] = createButtonPseudo(i);
            }

    // Easy API for creating new setFilters
            function setFilters() {
            }

            setFilters.prototype = Expr.filters = Expr.pseudos;
            Expr.setFilters = new setFilters();

            tokenize = Sizzle.tokenize = function (selector, parseOnly) {
                var matched, match, tokens, type,
                    soFar, groups, preFilters,
                    cached = tokenCache[selector + " "];

                if (cached) {
                    return parseOnly ? 0 : cached.slice(0);
                }

                soFar = selector;
                groups = [];
                preFilters = Expr.preFilter;

                while (soFar) {

                    // Comma and first run
                    if (!matched || (match = rcomma.exec(soFar))) {
                        if (match) {
                            // Don't consume trailing commas as valid
                            soFar = soFar.slice(match[0].length) || soFar;
                        }
                        groups.push((tokens = []));
                    }

                    matched = false;

                    // Combinators
                    if ((match = rcombinators.exec(soFar))) {
                        matched = match.shift();
                        tokens.push({
                            value: matched,
                            // Cast descendant combinators to space
                            type: match[0].replace(rtrim, " ")
                        });
                        soFar = soFar.slice(matched.length);
                    }

                    // Filters
                    for (type in Expr.filter) {
                        if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] ||
                            (match = preFilters[type](match)))) {
                            matched = match.shift();
                            tokens.push({
                                value: matched,
                                type: type,
                                matches: match
                            });
                            soFar = soFar.slice(matched.length);
                        }
                    }

                    if (!matched) {
                        break;
                    }
                }

                // Return the length of the invalid excess
                // if we're just parsing
                // Otherwise, throw an error or return tokens
                return parseOnly ?
                    soFar.length :
                    soFar ?
                        Sizzle.error(selector) :
                        // Cache the tokens
                        tokenCache(selector, groups).slice(0);
            };

            function toSelector(tokens) {
                var i = 0,
                    len = tokens.length,
                    selector = "";
                for (; i < len; i++) {
                    selector += tokens[i].value;
                }
                return selector;
            }

            function addCombinator(matcher, combinator, base) {
                var dir = combinator.dir,
                    skip = combinator.next,
                    key = skip || dir,
                    checkNonElements = base && key === "parentNode",
                    doneName = done++;

                return combinator.first ?
                    // Check against closest ancestor/preceding element
                    function (elem, context, xml) {
                        while ((elem = elem[dir])) {
                            if (elem.nodeType === 1 || checkNonElements) {
                                return matcher(elem, context, xml);
                            }
                        }
                        return false;
                    } :

                    // Check against all ancestor/preceding elements
                    function (elem, context, xml) {
                        var oldCache, uniqueCache, outerCache,
                            newCache = [dirruns, doneName];

                        // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                        if (xml) {
                            while ((elem = elem[dir])) {
                                if (elem.nodeType === 1 || checkNonElements) {
                                    if (matcher(elem, context, xml)) {
                                        return true;
                                    }
                                }
                            }
                        } else {
                            while ((elem = elem[dir])) {
                                if (elem.nodeType === 1 || checkNonElements) {
                                    outerCache = elem[expando] || (elem[expando] = {});

                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});

                                    if (skip && skip === elem.nodeName.toLowerCase()) {
                                        elem = elem[dir] || elem;
                                    } else if ((oldCache = uniqueCache[key]) &&
                                        oldCache[0] === dirruns && oldCache[1] === doneName) {

                                        // Assign to newCache so results back-propagate to previous elements
                                        return (newCache[2] = oldCache[2]);
                                    } else {
                                        // Reuse newcache so results back-propagate to previous elements
                                        uniqueCache[key] = newCache;

                                        // A match means we're done; a fail means we have to keep checking
                                        if ((newCache[2] = matcher(elem, context, xml))) {
                                            return true;
                                        }
                                    }
                                }
                            }
                        }
                        return false;
                    };
            }

            function elementMatcher(matchers) {
                return matchers.length > 1 ?
                    function (elem, context, xml) {
                        var i = matchers.length;
                        while (i--) {
                            if (!matchers[i](elem, context, xml)) {
                                return false;
                            }
                        }
                        return true;
                    } :
                    matchers[0];
            }

            function multipleContexts(selector, contexts, results) {
                var i = 0,
                    len = contexts.length;
                for (; i < len; i++) {
                    Sizzle(selector, contexts[i], results);
                }
                return results;
            }

            function condense(unmatched, map, filter, context, xml) {
                var elem,
                    newUnmatched = [],
                    i = 0,
                    len = unmatched.length,
                    mapped = map != null;

                for (; i < len; i++) {
                    if ((elem = unmatched[i])) {
                        if (!filter || filter(elem, context, xml)) {
                            newUnmatched.push(elem);
                            if (mapped) {
                                map.push(i);
                            }
                        }
                    }
                }

                return newUnmatched;
            }

            function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
                if (postFilter && !postFilter[expando]) {
                    postFilter = setMatcher(postFilter);
                }
                if (postFinder && !postFinder[expando]) {
                    postFinder = setMatcher(postFinder, postSelector);
                }
                return markFunction(function (seed, results, context, xml) {
                    var temp, i, elem,
                        preMap = [],
                        postMap = [],
                        preexisting = results.length,

                        // Get initial elements from seed or context
                        elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),

                        // Prefilter to get matcher input, preserving a map for seed-results synchronization
                        matcherIn = preFilter && (seed || !selector) ?
                            condense(elems, preMap, preFilter, context, xml) :
                            elems,

                        matcherOut = matcher ?
                            // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                            postFinder || (seed ? preFilter : preexisting || postFilter) ?

                                // ...intermediate processing is necessary
                                [] :

                                // ...otherwise use results directly
                                results :
                            matcherIn;

                    // Find primary matches
                    if (matcher) {
                        matcher(matcherIn, matcherOut, context, xml);
                    }

                    // Apply postFilter
                    if (postFilter) {
                        temp = condense(matcherOut, postMap);
                        postFilter(temp, [], context, xml);

                        // Un-match failing elements by moving them back to matcherIn
                        i = temp.length;
                        while (i--) {
                            if ((elem = temp[i])) {
                                matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                            }
                        }
                    }

                    if (seed) {
                        if (postFinder || preFilter) {
                            if (postFinder) {
                                // Get the final matcherOut by condensing this intermediate into postFinder contexts
                                temp = [];
                                i = matcherOut.length;
                                while (i--) {
                                    if ((elem = matcherOut[i])) {
                                        // Restore matcherIn since elem is not yet a final match
                                        temp.push((matcherIn[i] = elem));
                                    }
                                }
                                postFinder(null, (matcherOut = []), temp, xml);
                            }

                            // Move matched elements from seed to results to keep them synchronized
                            i = matcherOut.length;
                            while (i--) {
                                if ((elem = matcherOut[i]) &&
                                    (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {

                                    seed[temp] = !(results[temp] = elem);
                                }
                            }
                        }

                        // Add elements to results, through postFinder if defined
                    } else {
                        matcherOut = condense(
                            matcherOut === results ?
                                matcherOut.splice(preexisting, matcherOut.length) :
                                matcherOut
                        );
                        if (postFinder) {
                            postFinder(null, results, matcherOut, xml);
                        } else {
                            push.apply(results, matcherOut);
                        }
                    }
                });
            }

            function matcherFromTokens(tokens) {
                var checkContext, matcher, j,
                    len = tokens.length,
                    leadingRelative = Expr.relative[tokens[0].type],
                    implicitRelative = leadingRelative || Expr.relative[" "],
                    i = leadingRelative ? 1 : 0,

                    // The foundational matcher ensures that elements are reachable from top-level context(s)
                    matchContext = addCombinator(function (elem) {
                        return elem === checkContext;
                    }, implicitRelative, true),
                    matchAnyContext = addCombinator(function (elem) {
                        return indexOf(checkContext, elem) > -1;
                    }, implicitRelative, true),
                    matchers = [function (elem, context, xml) {
                        var ret = (!leadingRelative && (xml || context !== outermostContext)) || (
                            (checkContext = context).nodeType ?
                                matchContext(elem, context, xml) :
                                matchAnyContext(elem, context, xml));
                        // Avoid hanging onto element (issue #299)
                        checkContext = null;
                        return ret;
                    }];

                for (; i < len; i++) {
                    if ((matcher = Expr.relative[tokens[i].type])) {
                        matchers = [addCombinator(elementMatcher(matchers), matcher)];
                    } else {
                        matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);

                        // Return special upon seeing a positional matcher
                        if (matcher[expando]) {
                            // Find the next relative operator (if any) for proper handling
                            j = ++i;
                            for (; j < len; j++) {
                                if (Expr.relative[tokens[j].type]) {
                                    break;
                                }
                            }
                            return setMatcher(
                                i > 1 && elementMatcher(matchers),
                                i > 1 && toSelector(
                                // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                                tokens.slice(0, i - 1).concat({value: tokens[i - 2].type === " " ? "*" : ""})
                                ).replace(rtrim, "$1"),
                                matcher,
                                i < j && matcherFromTokens(tokens.slice(i, j)),
                                j < len && matcherFromTokens((tokens = tokens.slice(j))),
                                j < len && toSelector(tokens)
                            );
                        }
                        matchers.push(matcher);
                    }
                }

                return elementMatcher(matchers);
            }

            function matcherFromGroupMatchers(elementMatchers, setMatchers) {
                var bySet = setMatchers.length > 0,
                    byElement = elementMatchers.length > 0,
                    superMatcher = function (seed, context, xml, results, outermost) {
                        var elem, j, matcher,
                            matchedCount = 0,
                            i = "0",
                            unmatched = seed && [],
                            setMatched = [],
                            contextBackup = outermostContext,
                            // We must always have either seed elements or outermost context
                            elems = seed || byElement && Expr.find["TAG"]("*", outermost),
                            // Use integer dirruns iff this is the outermost matcher
                            dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
                            len = elems.length;

                        if (outermost) {
                            outermostContext = context === document || context || outermost;
                        }

                        // Add elements passing elementMatchers directly to results
                        // Support: IE<9, Safari
                        // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                        for (; i !== len && (elem = elems[i]) != null; i++) {
                            if (byElement && elem) {
                                j = 0;
                                if (!context && elem.ownerDocument !== document) {
                                    setDocument(elem);
                                    xml = !documentIsHTML;
                                }
                                while ((matcher = elementMatchers[j++])) {
                                    if (matcher(elem, context || document, xml)) {
                                        results.push(elem);
                                        break;
                                    }
                                }
                                if (outermost) {
                                    dirruns = dirrunsUnique;
                                }
                            }

                            // Track unmatched elements for set filters
                            if (bySet) {
                                // They will have gone through all possible matchers
                                if ((elem = !matcher && elem)) {
                                    matchedCount--;
                                }

                                // Lengthen the array for every element, matched or not
                                if (seed) {
                                    unmatched.push(elem);
                                }
                            }
                        }

                        // `i` is now the count of elements visited above, and adding it to `matchedCount`
                        // makes the latter nonnegative.
                        matchedCount += i;

                        // Apply set filters to unmatched elements
                        // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                        // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                        // no element matchers and no seed.
                        // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                        // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                        // numerically zero.
                        if (bySet && i !== matchedCount) {
                            j = 0;
                            while ((matcher = setMatchers[j++])) {
                                matcher(unmatched, setMatched, context, xml);
                            }

                            if (seed) {
                                // Reintegrate element matches to eliminate the need for sorting
                                if (matchedCount > 0) {
                                    while (i--) {
                                        if (!(unmatched[i] || setMatched[i])) {
                                            setMatched[i] = pop.call(results);
                                        }
                                    }
                                }

                                // Discard index placeholder values to get only actual matches
                                setMatched = condense(setMatched);
                            }

                            // Add matches to results
                            push.apply(results, setMatched);

                            // Seedless set matches succeeding multiple successful matchers stipulate sorting
                            if (outermost && !seed && setMatched.length > 0 &&
                                (matchedCount + setMatchers.length) > 1) {

                                Sizzle.uniqueSort(results);
                            }
                        }

                        // Override manipulation of globals by nested matchers
                        if (outermost) {
                            dirruns = dirrunsUnique;
                            outermostContext = contextBackup;
                        }

                        return unmatched;
                    };

                return bySet ?
                    markFunction(superMatcher) :
                    superMatcher;
            }

            compile = Sizzle.compile = function (selector, match /* Internal Use Only */) {
                var i,
                    setMatchers = [],
                    elementMatchers = [],
                    cached = compilerCache[selector + " "];

                if (!cached) {
                    // Generate a function of recursive functions that can be used to check each element
                    if (!match) {
                        match = tokenize(selector);
                    }
                    i = match.length;
                    while (i--) {
                        cached = matcherFromTokens(match[i]);
                        if (cached[expando]) {
                            setMatchers.push(cached);
                        } else {
                            elementMatchers.push(cached);
                        }
                    }

                    // Cache the compiled function
                    cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));

                    // Save selector and tokenization
                    cached.selector = selector;
                }
                return cached;
            };

            /**
             * A low-level selection function that works with Sizzle's compiled
             *  selector functions
             * @param {String|Function} selector A selector or a pre-compiled
             *  selector function built with Sizzle.compile
             * @param {Element} context
             * @param {Array} [results]
             * @param {Array} [seed] A set of elements to match against
             */
            select = Sizzle.select = function (selector, context, results, seed) {
                var i, tokens, token, type, find,
                    compiled = typeof selector === "function" && selector,
                    match = !seed && tokenize((selector = compiled.selector || selector));

                results = results || [];

                // Try to minimize operations if there is only one selector in the list and no seed
                // (the latter of which guarantees us context)
                if (match.length === 1) {

                    // Reduce context if the leading compound selector is an ID
                    tokens = match[0] = match[0].slice(0);
                    if (tokens.length > 2 && (token = tokens[0]).type === "ID" &&
                        context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {

                        context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
                        if (!context) {
                            return results;

                            // Precompiled matchers will still verify ancestry, so step up a level
                        } else if (compiled) {
                            context = context.parentNode;
                        }

                        selector = selector.slice(tokens.shift().value.length);
                    }

                    // Fetch a seed set for right-to-left matching
                    i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                    while (i--) {
                        token = tokens[i];

                        // Abort if we hit a combinator
                        if (Expr.relative[(type = token.type)]) {
                            break;
                        }
                        if ((find = Expr.find[type])) {
                            // Search, expanding context for leading sibling combinators
                            if ((seed = find(
                                token.matches[0].replace(runescape, funescape),
                                rsibling.test(tokens[0].type) && testContext(context.parentNode) || context
                            ))) {

                                // If seed is empty or no tokens remain, we can return early
                                tokens.splice(i, 1);
                                selector = seed.length && toSelector(tokens);
                                if (!selector) {
                                    push.apply(results, seed);
                                    return results;
                                }

                                break;
                            }
                        }
                    }
                }

                // Compile and execute a filtering function if one is not provided
                // Provide `match` to avoid retokenization if we modified the selector above
                (compiled || compile(selector, match))(
                    seed,
                    context,
                    !documentIsHTML,
                    results,
                    !context || rsibling.test(selector) && testContext(context.parentNode) || context
                );
                return results;
            };

    // One-time assignments

    // Sort stability
            support.sortStable = expando.split("").sort(sortOrder).join("") === expando;

    // Support: Chrome 14-35+
    // Always assume duplicates if they aren't passed to the comparison function
            support.detectDuplicates = !!hasDuplicate;

    // Initialize against the default document
            setDocument();
            
            return Sizzle;

        })(window);


    jQuery.find = Sizzle;
    jQuery.expr = Sizzle.selectors;

    // Deprecated
    jQuery.expr[":"] = jQuery.expr.pseudos;
    jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
    jQuery.text = Sizzle.getText;
    jQuery.isXMLDoc = Sizzle.isXML;
    jQuery.contains = Sizzle.contains;
    jQuery.escapeSelector = Sizzle.escape;


    var dir = function (elem, dir, until) {
        var matched = [],
            truncate = until !== undefined;

        while ((elem = elem[dir]) && elem.nodeType !== 9) {
            if (elem.nodeType === 1) {
                if (truncate && jQuery(elem).is(until)) {
                    break;
                }
                matched.push(elem);
            }
        }
        return matched;
    };


    var siblings = function (n, elem) {
        var matched = [];

        for (; n; n = n.nextSibling) {
            if (n.nodeType === 1 && n !== elem) {
                matched.push(n);
            }
        }

        return matched;
    };


    var rneedsContext = jQuery.expr.match.needsContext;


    function nodeName(elem, name) {

        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

    }
    var rsingleTag = (/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i);


    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) {
            return jQuery.grep(elements, function (elem, i) {
                return !!qualifier.call(elem, i, elem) !== not;
            });
        }

        // Single element
        if (qualifier.nodeType) {
            return jQuery.grep(elements, function (elem) {
                return (elem === qualifier) !== not;
            });
        }

        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") {
            return jQuery.grep(elements, function (elem) {
                return (indexOf.call(qualifier, elem) > -1) !== not;
            });
        }

        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }

    jQuery.filter = function (expr, elems, not) {
        var elem = elems[0];

        if (not) {
            expr = ":not(" + expr + ")";
        }

        if (elems.length === 1 && elem.nodeType === 1) {
            return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
        }

        return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
            return elem.nodeType === 1;
        }));
    };

    jQuery.fn.extend({
        find: function (selector) {
            var i, ret,
                len = this.length,
                self = this;

            if (typeof selector !== "string") {
                return this.pushStack(jQuery(selector).filter(function () {
                    for (i = 0; i < len; i++) {
                        if (jQuery.contains(self[i], this)) {
                            return true;
                        }
                    }
                }));
            }

            ret = this.pushStack([]);

            for (i = 0; i < len; i++) {
                jQuery.find(selector, self[i], ret);
            }

            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function (selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function (selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function (selector) {
            return !!winnow(
                this,

                // If this is a positional/relative selector, check membership in the returned set
                // so $("p:first").is("p:last") won't return true for a doc with two "p".
                typeof selector === "string" && rneedsContext.test(selector) ?
                    jQuery(selector) :
                    selector || [],
                false
            ).length;
        }
    });


    // Initialize a jQuery object


    // A central reference to the root jQuery(document)
    var rootjQuery,

        // A simple way to check for HTML strings
        // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
        // Strict HTML recognition (#11290: must start with <)
        // Shortcut simple #id case for speed
        rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

        init$2 = jQuery.fn.init = function (selector, context, root) {
            var match, elem;

            // HANDLE: $(""), $(null), $(undefined), $(false)
            if (!selector) {
                return this;
            }

            // Method init() accepts an alternate rootjQuery
            // so migrate can support jQuery.sub (gh-2101)
            root = root || rootjQuery;

            // Handle HTML strings
            if (typeof selector === "string") {
                if (selector[0] === "<" &&
                    selector[selector.length - 1] === ">" &&
                    selector.length >= 3) {

                    // Assume that strings that start and end with <> are HTML and skip the regex check
                    match = [null, selector, null];

                } else {
                    match = rquickExpr.exec(selector);
                }

                // Match html or make sure no context is specified for #id
                if (match && (match[1] || !context)) {

                    // HANDLE: $(html) -> $(array)
                    if (match[1]) {
                        context = context instanceof jQuery ? context[0] : context;

                        // Option to run scripts is true for back-compat
                        // Intentionally let the error be thrown if parseHTML is not present
                        jQuery.merge(this, jQuery.parseHTML(
                            match[1],
                            context && context.nodeType ? context.ownerDocument || context : document$1,
                            true
                        ));

                        // HANDLE: $(html, props)
                        if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                            for (match in context) {

                                // Properties of context are called as methods if possible
                                if (isFunction(this[match])) {
                                    this[match](context[match]);

                                    // ...and otherwise set as attributes
                                } else {
                                    this.attr(match, context[match]);
                                }
                            }
                        }

                        return this;

                        // HANDLE: $(#id)
                    } else {
                        elem = document$1.getElementById(match[2]);

                        if (elem) {

                            // Inject the element directly into the jQuery object
                            this[0] = elem;
                            this.length = 1;
                        }
                        return this;
                    }

                    // HANDLE: $(expr, $(...))
                } else if (!context || context.jquery) {
                    return (context || root).find(selector);

                    // HANDLE: $(expr, context)
                    // (which is just equivalent to: $(context).find(expr)
                } else {
                    return this.constructor(context).find(selector);
                }

                // HANDLE: $(DOMElement)
            } else if (selector.nodeType) {
                this[0] = selector;
                this.length = 1;
                return this;

                // HANDLE: $(function)
                // Shortcut for document ready
            } else if (isFunction(selector)) {
                return root.ready !== undefined ?
                    root.ready(selector) :

                    // Execute immediately if ready is not present
                    selector(jQuery);
            }

            return jQuery.makeArray(selector, this);
        };

    // Give the init function the jQuery prototype for later instantiation
    init$2.prototype = jQuery.fn;

    // Initialize central reference
    rootjQuery = jQuery(document$1);


    var rparentsprev = /^(?:parents|prev(?:Until|All))/,

        // Methods guaranteed to produce a unique set when starting from a unique set
        guaranteedUnique = {
            children: true,
            contents: true,
            next: true,
            prev: true
        };

    jQuery.fn.extend({
        has: function (target) {
            var targets = jQuery(target, this),
                l = targets.length;

            return this.filter(function () {
                var i = 0;
                for (; i < l; i++) {
                    if (jQuery.contains(this, targets[i])) {
                        return true;
                    }
                }
            });
        },

        closest: function (selectors, context) {
            var cur,
                i = 0,
                l = this.length,
                matched = [],
                targets = typeof selectors !== "string" && jQuery(selectors);

            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) {
                for (; i < l; i++) {
                    for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {

                        // Always skip document fragments
                        if (cur.nodeType < 11 && (targets ?
                            targets.index(cur) > -1 :

                            // Don't pass non-elements to Sizzle
                            cur.nodeType === 1 &&
                            jQuery.find.matchesSelector(cur, selectors))) {

                            matched.push(cur);
                            break;
                        }
                    }
                }
            }

            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },

        // Determine the position of an element within the set
        index: function (elem) {

            // No argument, return index in parent
            if (!elem) {
                return (this[0] && this[0].parentNode) ? this.first().prevAll().length : -1;
            }

            // Index in selector
            if (typeof elem === "string") {
                return indexOf.call(jQuery(elem), this[0]);
            }

            // Locate the position of the desired element
            return indexOf.call(this,

                // If it receives a jQuery object, the first element is used
                elem.jquery ? elem[0] : elem
            );
        },

        add: function (selector, context) {
            return this.pushStack(
                jQuery.uniqueSort(
                    jQuery.merge(this.get(), jQuery(selector, context))
                )
            );
        },

        addBack: function (selector) {
            return this.add(selector == null ?
                this.prevObject : this.prevObject.filter(selector)
            );
        }
    });

    function sibling(cur, dir) {
        while ((cur = cur[dir]) && cur.nodeType !== 1) {
        }
        return cur;
    }

    jQuery.each({
        parent: function (elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function (elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function (elem, i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function (elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function (elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function (elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function (elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function (elem, i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function (elem, i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function (elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function (elem) {
            return siblings(elem.firstChild);
        },
        contents: function (elem) {
            if (nodeName(elem, "iframe")) {
                return elem.contentDocument;
            }

            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) {
                elem = elem.content || elem;
            }

            return jQuery.merge([], elem.childNodes);
        }
    }, function (name, fn) {
        jQuery.fn[name] = function (until, selector) {
            var matched = jQuery.map(this, fn, until);

            if (name.slice(-5) !== "Until") {
                selector = until;
            }

            if (selector && typeof selector === "string") {
                matched = jQuery.filter(selector, matched);
            }

            if (this.length > 1) {

                // Remove duplicates
                if (!guaranteedUnique[name]) {
                    jQuery.uniqueSort(matched);
                }

                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) {
                    matched.reverse();
                }
            }

            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = (/[^\x20\t\r\n\f]+/g);


    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
            object[flag] = true;
        });
        return object;
    }

    /*
     * Create a callback list using the following parameters:
     *
     *	options: an optional list of space-separated options that will change how
     *			the callback list behaves or a more traditional option object
     *
     * By default a callback list will act like an event callback list and can be
     * "fired" multiple times.
     *
     * Possible options:
     *
     *	once:			will ensure the callback list can only be fired once (like a Deferred)
     *
     *	memory:			will keep track of previous values and will call any callback added
     *					after the list has been fired right away with the latest "memorized"
     *					values (like a Deferred)
     *
     *	unique:			will ensure a callback can only be added once (no duplicate in the list)
     *
     *	stopOnFalse:	interrupt callings when a callback returns false
     *
     */
    jQuery.Callbacks = function (options) {

        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ?
            createOptions(options) :
            jQuery.extend({}, options);

        var // Flag to know if list is currently firing
            firing,

            // Last fire value for non-forgettable lists
            memory,

            // Flag to know if list was already fired
            fired,

            // Flag to prevent firing
            locked,

            // Actual callback list
            list = [],

            // Queue of execution data for repeatable lists
            queue = [],

            // Index of currently firing callback (modified by add/remove as needed)
            firingIndex = -1,

            // Fire callbacks
            fire = function () {

                // Enforce single-firing
                locked = locked || options.once;

                // Execute callbacks for all pending executions,
                // respecting firingIndex overrides and runtime changes
                fired = firing = true;
                for (; queue.length; firingIndex = -1) {
                    memory = queue.shift();
                    while (++firingIndex < list.length) {

                        // Run callback and check for early termination
                        if (list[firingIndex].apply(memory[0], memory[1]) === false &&
                            options.stopOnFalse) {

                            // Jump to end and forget the data so .add doesn't re-fire
                            firingIndex = list.length;
                            memory = false;
                        }
                    }
                }

                // Forget the data if we're done with it
                if (!options.memory) {
                    memory = false;
                }

                firing = false;

                // Clean up if we're done firing for good
                if (locked) {

                    // Keep an empty list if we have data for future add calls
                    if (memory) {
                        list = [];

                        // Otherwise, this object is spent
                    } else {
                        list = "";
                    }
                }
            },

            // Actual Callbacks object
            self = {

                // Add a callback or a collection of callbacks to the list
                add: function () {
                    if (list) {

                        // If we have memory from a past run, we should fire after adding
                        if (memory && !firing) {
                            firingIndex = list.length - 1;
                            queue.push(memory);
                        }

                        (function add(args) {
                            jQuery.each(args, function (_, arg) {
                                if (isFunction(arg)) {
                                    if (!options.unique || !self.has(arg)) {
                                        list.push(arg);
                                    }
                                } else if (arg && arg.length && toType(arg) !== "string") {

                                    // Inspect recursively
                                    add(arg);
                                }
                            });
                        })(arguments);

                        if (memory && !firing) {
                            fire();
                        }
                    }
                    return this;
                },

                // Remove a callback from the list
                remove: function () {
                    jQuery.each(arguments, function (_, arg) {
                        var index;
                        while ((index = jQuery.inArray(arg, list, index)) > -1) {
                            list.splice(index, 1);

                            // Handle firing indexes
                            if (index <= firingIndex) {
                                firingIndex--;
                            }
                        }
                    });
                    return this;
                },

                // Check if a given callback is in the list.
                // If no argument is given, return whether or not list has callbacks attached.
                has: function (fn) {
                    return fn ?
                        jQuery.inArray(fn, list) > -1 :
                        list.length > 0;
                },

                // Remove all callbacks from the list
                empty: function () {
                    if (list) {
                        list = [];
                    }
                    return this;
                },

                // Disable .fire and .add
                // Abort any current/pending executions
                // Clear all callbacks and values
                disable: function () {
                    locked = queue = [];
                    list = memory = "";
                    return this;
                },
                disabled: function () {
                    return !list;
                },

                // Disable .fire
                // Also disable .add unless we have memory (since it would have no effect)
                // Abort any pending executions
                lock: function () {
                    locked = queue = [];
                    if (!memory && !firing) {
                        list = memory = "";
                    }
                    return this;
                },
                locked: function () {
                    return !!locked;
                },

                // Call all callbacks with the given context and arguments
                fireWith: function (context, args) {
                    if (!locked) {
                        args = args || [];
                        args = [context, args.slice ? args.slice() : args];
                        queue.push(args);
                        if (!firing) {
                            fire();
                        }
                    }
                    return this;
                },

                // Call all the callbacks with the given arguments
                fire: function () {
                    self.fireWith(this, arguments);
                    return this;
                },

                // To know if the callbacks have already been called at least once
                fired: function () {
                    return !!fired;
                }
            };

        return self;
    };


    function Identity(v) {
        return v;
    }

    function Thrower(ex) {
        throw ex;
    }

    function adoptValue(value, resolve, reject, noValue) {
        var method;

        try {

            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction((method = value.promise))) {
                method.call(value).done(resolve).fail(reject);

                // Other thenables
            } else if (value && isFunction((method = value.then))) {
                method.call(value, resolve, reject);

                // Other non-thenables
            } else {

                // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
                // * false: [ value ].slice( 0 ) => resolve( value )
                // * true: [ value ].slice( 1 ) => resolve()
                resolve.apply(undefined, [value].slice(noValue));
            }

            // For Promises/A+, convert exceptions into rejections
            // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
            // Deferred#then to conditionally suppress rejection.
        } catch (value) {

            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [value]);
        }
    }

    jQuery.extend({

        Deferred: function (func) {
            var tuples = [

                    // action, add listener, callbacks,
                    // ... .then handlers, argument index, [final state]
                    ["notify", "progress", jQuery.Callbacks("memory"),
                        jQuery.Callbacks("memory"), 2],
                    ["resolve", "done", jQuery.Callbacks("once memory"),
                        jQuery.Callbacks("once memory"), 0, "resolved"],
                    ["reject", "fail", jQuery.Callbacks("once memory"),
                        jQuery.Callbacks("once memory"), 1, "rejected"]
                ],
                state = "pending",
                promise = {
                    state: function () {
                        return state;
                    },
                    always: function () {
                        deferred.done(arguments).fail(arguments);
                        return this;
                    },
                    "catch": function (fn) {
                        return promise.then(null, fn);
                    },

                    // Keep pipe for back-compat
                    pipe: function ( /* fnDone, fnFail, fnProgress */) {
                        var fns = arguments;

                        return jQuery.Deferred(function (newDefer) {
                            jQuery.each(tuples, function (i, tuple) {

                                // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                                var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

                                // deferred.progress(function() { bind to newDefer or newDefer.notify })
                                // deferred.done(function() { bind to newDefer or newDefer.resolve })
                                // deferred.fail(function() { bind to newDefer or newDefer.reject })
                                deferred[tuple[1]](function () {
                                    var returned = fn && fn.apply(this, arguments);
                                    if (returned && isFunction(returned.promise)) {
                                        returned.promise()
                                            .progress(newDefer.notify)
                                            .done(newDefer.resolve)
                                            .fail(newDefer.reject);
                                    } else {
                                        newDefer[tuple[0] + "With"](
                                            this,
                                            fn ? [returned] : arguments
                                        );
                                    }
                                });
                            });
                            fns = null;
                        }).promise();
                    },
                    then: function (onFulfilled, onRejected, onProgress) {
                        var maxDepth = 0;

                        function resolve(depth, deferred, handler, special) {
                            return function () {
                                var that = this,
                                    args = arguments,
                                    mightThrow = function () {
                                        var returned, then;

                                        // Support: Promises/A+ section 2.3.3.3.3
                                        // https://promisesaplus.com/#point-59
                                        // Ignore double-resolution attempts
                                        if (depth < maxDepth) {
                                            return;
                                        }

                                        returned = handler.apply(that, args);

                                        // Support: Promises/A+ section 2.3.1
                                        // https://promisesaplus.com/#point-48
                                        if (returned === deferred.promise()) {
                                            throw new TypeError("Thenable self-resolution");
                                        }

                                        // Support: Promises/A+ sections 2.3.3.1, 3.5
                                        // https://promisesaplus.com/#point-54
                                        // https://promisesaplus.com/#point-75
                                        // Retrieve `then` only once
                                        then = returned &&

                                            // Support: Promises/A+ section 2.3.4
                                            // https://promisesaplus.com/#point-64
                                            // Only check objects and functions for thenability
                                            (typeof returned === "object" ||
                                                typeof returned === "function") &&
                                            returned.then;

                                        // Handle a returned thenable
                                        if (isFunction(then)) {

                                            // Special processors (notify) just wait for resolution
                                            if (special) {
                                                then.call(
                                                    returned,
                                                    resolve(maxDepth, deferred, Identity, special),
                                                    resolve(maxDepth, deferred, Thrower, special)
                                                );

                                                // Normal processors (resolve) also hook into progress
                                            } else {

                                                // ...and disregard older resolution values
                                                maxDepth++;

                                                then.call(
                                                    returned,
                                                    resolve(maxDepth, deferred, Identity, special),
                                                    resolve(maxDepth, deferred, Thrower, special),
                                                    resolve(maxDepth, deferred, Identity,
                                                        deferred.notifyWith)
                                                );
                                            }

                                            // Handle all other returned values
                                        } else {

                                            // Only substitute handlers pass on context
                                            // and multiple values (non-spec behavior)
                                            if (handler !== Identity) {
                                                that = undefined;
                                                args = [returned];
                                            }

                                            // Process the value(s)
                                            // Default process is resolve
                                            (special || deferred.resolveWith)(that, args);
                                        }
                                    },

                                    // Only normal processors (resolve) catch and reject exceptions
                                    process = special ?
                                        mightThrow :
                                        function () {
                                            try {
                                                mightThrow();
                                            } catch (e) {

                                                if (jQuery.Deferred.exceptionHook) {
                                                    jQuery.Deferred.exceptionHook(e,
                                                        process.stackTrace);
                                                }

                                                // Support: Promises/A+ section 2.3.3.3.4.1
                                                // https://promisesaplus.com/#point-61
                                                // Ignore post-resolution exceptions
                                                if (depth + 1 >= maxDepth) {

                                                    // Only substitute handlers pass on context
                                                    // and multiple values (non-spec behavior)
                                                    if (handler !== Thrower) {
                                                        that = undefined;
                                                        args = [e];
                                                    }

                                                    deferred.rejectWith(that, args);
                                                }
                                            }
                                        };

                                // Support: Promises/A+ section 2.3.3.3.1
                                // https://promisesaplus.com/#point-57
                                // Re-resolve promises immediately to dodge false rejection from
                                // subsequent errors
                                if (depth) {
                                    process();
                                } else {

                                    // Call an optional hook to record the stack, in case of exception
                                    // since it's otherwise lost when execution goes async
                                    if (jQuery.Deferred.getStackHook) {
                                        process.stackTrace = jQuery.Deferred.getStackHook();
                                    }
                                    window.setTimeout(process);
                                }
                            };
                        }

                        return jQuery.Deferred(function (newDefer) {

                            // progress_handlers.add( ... )
                            tuples[0][3].add(
                                resolve(
                                    0,
                                    newDefer,
                                    isFunction(onProgress) ?
                                        onProgress :
                                        Identity,
                                    newDefer.notifyWith
                                )
                            );

                            // fulfilled_handlers.add( ... )
                            tuples[1][3].add(
                                resolve(
                                    0,
                                    newDefer,
                                    isFunction(onFulfilled) ?
                                        onFulfilled :
                                        Identity
                                )
                            );

                            // rejected_handlers.add( ... )
                            tuples[2][3].add(
                                resolve(
                                    0,
                                    newDefer,
                                    isFunction(onRejected) ?
                                        onRejected :
                                        Thrower
                                )
                            );
                        }).promise();
                    },

                    // Get a promise for this deferred
                    // If obj is provided, the promise aspect is added to the object
                    promise: function (obj) {
                        return obj != null ? jQuery.extend(obj, promise) : promise;
                    }
                },
                deferred = {};

            // Add list-specific methods
            jQuery.each(tuples, function (i, tuple) {
                var list = tuple[2],
                    stateString = tuple[5];

                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;

                // Handle state
                if (stateString) {
                    list.add(
                        function () {

                            // state = "resolved" (i.e., fulfilled)
                            // state = "rejected"
                            state = stateString;
                        },

                        // rejected_callbacks.disable
                        // fulfilled_callbacks.disable
                        tuples[3 - i][2].disable,

                        // rejected_handlers.disable
                        // fulfilled_handlers.disable
                        tuples[3 - i][3].disable,

                        // progress_callbacks.lock
                        tuples[0][2].lock,

                        // progress_handlers.lock
                        tuples[0][3].lock
                    );
                }

                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);

                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function () {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };

                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });

            // Make the deferred a promise
            promise.promise(deferred);

            // Call given func if any
            if (func) {
                func.call(deferred, deferred);
            }

            // All done!
            return deferred;
        },

        // Deferred helper
        when: function (singleValue) {
            var

                // count of uncompleted subordinates
                remaining = arguments.length,

                // count of unprocessed arguments
                i = remaining,

                // subordinate fulfillment data
                resolveContexts = Array(i),
                resolveValues = slice.call(arguments),

                // the master Deferred
                master = jQuery.Deferred(),

                // subordinate callback factory
                updateFunc = function (i) {
                    return function (value) {
                        resolveContexts[i] = this;
                        resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                        if (!(--remaining)) {
                            master.resolveWith(resolveContexts, resolveValues);
                        }
                    };
                };

            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, master.done(updateFunc(i)).resolve, master.reject,
                    !remaining);

                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (master.state() === "pending" ||
                    isFunction(resolveValues[i] && resolveValues[i].then)) {

                    return master.then();
                }
            }

            // Multiple arguments are aggregated like Promise.all array elements
            while (i--) {
                adoptValue(resolveValues[i], updateFunc(i), master.reject);
            }

            return master.promise();
        }
    });


    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

    jQuery.Deferred.exceptionHook = function (error, stack) {

        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
            window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
        }
    };


    jQuery.readyException = function (error) {
        window.setTimeout(function () {
            throw error;
        });
    };


    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();

    jQuery.fn.ready = function (fn) {

        readyList
            .then(fn)

            // Wrap jQuery.readyException in a function so that the lookup
            // happens at the time of error handling instead of callback
            // registration.
            .catch(function (error) {
                jQuery.readyException(error);
            });

        return this;
    };

    jQuery.extend({

        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,

        // A counter to track how many items to wait for before
        // the ready event fires. See #6781
        readyWait: 1,

        // Handle when the DOM is ready
        ready: function (wait) {

            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
                return;
            }

            // Remember that the DOM is ready
            jQuery.isReady = true;

            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) {
                return;
            }

            // If there are functions bound, to execute
            readyList.resolveWith(document$1, [jQuery]);
        }
    });

    jQuery.ready.then = readyList.then;

    // The ready event handler and self cleanup method
    function completed() {
        document$1.removeEventListener("DOMContentLoaded", completed);
        window.removeEventListener("load", completed);
        jQuery.ready();
    }

    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document$1.readyState === "complete" ||
        (document$1.readyState !== "loading" && !document$1.documentElement.doScroll)) {

        // Handle it asynchronously to allow scripts the opportunity to delay ready
        window.setTimeout(jQuery.ready);

    } else {

        // Use the handy event callback
        document$1.addEventListener("DOMContentLoaded", completed);

        // A fallback to window.onload, that will always work
        window.addEventListener("load", completed);
    }


    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function (elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0,
            len = elems.length,
            bulk = key == null;

        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for (i in key) {
                access(elems, fn, i, key[i], true, emptyGet, raw);
            }

            // Sets one value
        } else if (value !== undefined) {
            chainable = true;

            if (!isFunction(value)) {
                raw = true;
            }

            if (bulk) {

                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;

                    // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function (elem, key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }

            if (fn) {
                for (; i < len; i++) {
                    fn(
                        elems[i], key, raw ?
                            value :
                            value.call(elems[i], i, fn(elems[i], key))
                    );
                }
            }
        }

        if (chainable) {
            return elems;
        }

        // Gets
        if (bulk) {
            return fn.call(elems);
        }

        return len ? fn(elems[0], key) : emptyGet;
    };


    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/,
        rdashAlpha = /-([a-z])/g;

    // Used by camelCase as callback to replace()
    function fcamelCase(all, letter) {
        return letter.toUpperCase();
    }

    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (#9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }

    var acceptData = function (owner) {

        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !(+owner.nodeType);
    };


    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }

    Data.uid = 1;

    Data.prototype = {

        cache: function (owner) {

            // Check if the owner object already has a cache
            var value = owner[this.expando];

            // If not, create one
            if (!value) {
                value = {};

                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see #8335.
                // Always return an empty object.
                if (acceptData(owner)) {

                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) {
                        owner[this.expando] = value;

                        // Otherwise secure it in a non-enumerable property
                        // configurable must be true to allow the property to be
                        // deleted when data is removed
                    } else {
                        Object.defineProperty(owner, this.expando, {
                            value: value,
                            configurable: true
                        });
                    }
                }
            }

            return value;
        },
        set: function (owner, data, value) {
            var prop,
                cache = this.cache(owner);

            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") {
                cache[camelCase(data)] = value;

                // Handle: [ owner, { properties } ] args
            } else {

                // Copy the properties one-by-one to the cache object
                for (prop in data) {
                    cache[camelCase(prop)] = data[prop];
                }
            }
            return cache;
        },
        get: function (owner, key) {
            return key === undefined ?
                this.cache(owner) :

                // Always use camelCase key (gh-2257)
                owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function (owner, key, value) {

            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined ||
                ((key && typeof key === "string") && value === undefined)) {

                return this.get(owner, key);
            }

            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);

            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function (owner, key) {
            var i,
                cache = owner[this.expando];

            if (cache === undefined) {
                return;
            }

            if (key !== undefined) {

                // Support array or space separated string of keys
                if (Array.isArray(key)) {

                    // If key is an array of keys...
                    // We always set camelCase keys, so remove that.
                    key = key.map(camelCase);
                } else {
                    key = camelCase(key);

                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ?
                        [key] :
                        (key.match(rnothtmlwhite) || []);
                }

                i = key.length;

                while (i--) {
                    delete cache[key[i]];
                }
            }

            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {

                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) {
                    owner[this.expando] = undefined;
                } else {
                    delete owner[this.expando];
                }
            }
        },
        hasData: function (owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();

    var dataUser = new Data();


    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014

    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        rmultiDash = /[A-Z]/g;

    function getData(data) {
        if (data === "true") {
            return true;
        }

        if (data === "false") {
            return false;
        }

        if (data === "null") {
            return null;
        }

        // Only convert to a number if it doesn't change the string
        if (data === +data + "") {
            return +data;
        }

        if (rbrace.test(data)) {
            return JSON.parse(data);
        }

        return data;
    }

    function dataAttr(elem, key, data) {
        var name;

        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);

            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {
                }

                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else {
                data = undefined;
            }
        }
        return data;
    }

    jQuery.extend({
        hasData: function (elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },

        data: function (elem, name, data) {
            return dataUser.access(elem, name, data);
        },

        removeData: function (elem, name) {
            dataUser.remove(elem, name);
        },

        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function (elem, name, data) {
            return dataPriv.access(elem, name, data);
        },

        _removeData: function (elem, name) {
            dataPriv.remove(elem, name);
        }
    });

    jQuery.fn.extend({
        data: function (key, value) {
            var i, name, data,
                elem = this[0],
                attrs = elem && elem.attributes;

            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);

                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while (i--) {

                            // Support: IE 11 only
                            // The attrs elements can be null (#14894)
                            if (attrs[i]) {
                                name = attrs[i].name;
                                if (name.indexOf("data-") === 0) {
                                    name = camelCase(name.slice(5));
                                    dataAttr(elem, name, data[name]);
                                }
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }

                return data;
            }

            // Sets multiple values
            if (typeof key === "object") {
                return this.each(function () {
                    dataUser.set(this, key);
                });
            }

            return access(this, function (value) {
                var data;

                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {

                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) {
                        return data;
                    }

                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) {
                        return data;
                    }

                    // We tried really hard, but the data doesn't exist.
                    return;
                }

                // Set the data...
                this.each(function () {

                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },

        removeData: function (key) {
            return this.each(function () {
                dataUser.remove(this, key);
            });
        }
    });


    jQuery.extend({
        queue: function (elem, type, data) {
            var queue;

            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);

                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) {
                        queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    } else {
                        queue.push(data);
                    }
                }
                return queue || [];
            }
        },

        dequeue: function (elem, type) {
            type = type || "fx";

            var queue = jQuery.queue(elem, type),
                startLength = queue.length,
                fn = queue.shift(),
                hooks = jQuery._queueHooks(elem, type),
                next = function () {
                    jQuery.dequeue(elem, type);
                };

            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }

            if (fn) {

                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") {
                    queue.unshift("inprogress");
                }

                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }

            if (!startLength && hooks) {
                hooks.empty.fire();
            }
        },

        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function (elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function () {
                    dataPriv.remove(elem, [type + "queue", key]);
                })
            });
        }
    });

    jQuery.fn.extend({
        queue: function (type, data) {
            var setter = 2;

            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }

            if (arguments.length < setter) {
                return jQuery.queue(this[0], type);
            }

            return data === undefined ?
                this :
                this.each(function () {
                    var queue = jQuery.queue(this, type, data);

                    // Ensure a hooks for this queue
                    jQuery._queueHooks(this, type);

                    if (type === "fx" && queue[0] !== "inprogress") {
                        jQuery.dequeue(this, type);
                    }
                });
        },
        dequeue: function (type) {
            return this.each(function () {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function (type) {
            return this.queue(type || "fx", []);
        },

        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function (type, obj) {
            var tmp,
                count = 1,
                defer = jQuery.Deferred(),
                elements = this,
                i = this.length,
                resolve = function () {
                    if (!(--count)) {
                        defer.resolveWith(elements, [elements]);
                    }
                };

            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";

            while (i--) {
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;

    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");


    var cssExpand = ["Top", "Right", "Bottom", "Left"];

    var isHiddenWithinTree = function (elem, el) {

        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;

        // Inline style trumps all
        return elem.style.display === "none" ||
            elem.style.display === "" &&

            // Otherwise, check computed style
            // Support: Firefox <=43 - 45
            // Disconnected elements can have computed display: none, so first confirm that elem is
            // in the document.
            jQuery.contains(elem.ownerDocument, elem) &&

            jQuery.css(elem, "display") === "none";
    };

    var swap = function (elem, options, callback, args) {
        var ret, name,
            old = {};

        // Remember the old values, and insert the new ones
        for (name in options) {
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }

        ret = callback.apply(elem, args || []);

        // Revert the old values
        for (name in options) {
            elem.style[name] = old[name];
        }

        return ret;
    };


    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale,
            maxIterations = 20,
            currentValue = tween ?
                function () {
                    return tween.cur();
                } :
                function () {
                    return jQuery.css(elem, prop, "");
                },
            initial = currentValue(),
            unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),

            // Starting value computation is required for potential unit mismatches
            initialInUnit = (jQuery.cssNumber[prop] || unit !== "px" && +initial) &&
                rcssNum.exec(jQuery.css(elem, prop));

        if (initialInUnit && initialInUnit[3] !== unit) {

            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;

            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];

            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;

            while (maxIterations--) {

                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
                    maxIterations = 0;
                }
                initialInUnit = initialInUnit / scale;

            }

            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);

            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }

        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;

            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ?
                initialInUnit + (valueParts[1] + 1) * valueParts[2] :
                +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }


    var defaultDisplayMap = {};

    function getDefaultDisplay(elem) {
        var temp,
            doc = elem.ownerDocument,
            nodeName = elem.nodeName,
            display = defaultDisplayMap[nodeName];

        if (display) {
            return display;
        }

        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");

        temp.parentNode.removeChild(temp);

        if (display === "none") {
            display = "block";
        }
        defaultDisplayMap[nodeName] = display;

        return display;
    }

    function showHide(elements, show) {
        var display, elem,
            values = [],
            index = 0,
            length = elements.length;

        // Determine new display value for elements that need to change
        for (; index < length; index++) {
            elem = elements[index];
            if (!elem.style) {
                continue;
            }

            display = elem.style.display;
            if (show) {

                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) {
                        elem.style.display = "";
                    }
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) {
                    values[index] = getDefaultDisplay(elem);
                }
            } else {
                if (display !== "none") {
                    values[index] = "none";

                    // Remember what we're overwriting
                    dataPriv.set(elem, "display", display);
                }
            }
        }

        // Set the display of the elements in a second loop to avoid constant reflow
        for (index = 0; index < length; index++) {
            if (values[index] != null) {
                elements[index].style.display = values[index];
            }
        }

        return elements;
    }

    jQuery.fn.extend({
        show: function () {
            return showHide(this, true);
        },
        hide: function () {
            return showHide(this);
        },
        toggle: function (state) {
            if (typeof state === "boolean") {
                return state ? this.show() : this.hide();
            }

            return this.each(function () {
                if (isHiddenWithinTree(this)) {
                    jQuery(this).show();
                } else {
                    jQuery(this).hide();
                }
            });
        }
    });
    var rcheckableType = (/^(?:checkbox|radio)$/i);

    var rtagName = (/<([a-z][^\/\0>\x20\t\r\n\f]+)/i);

    var rscriptType = (/^$|^module$|\/(?:java|ecma)script/i);


    // We have to close these tags to support XHTML (#13200)
    var wrapMap = {

        // Support: IE <=9 only
        option: [1, "<select multiple='multiple'>", "</select>"],

        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],

        _default: [0, "", ""]
    };

    // Support: IE <=9 only
    wrapMap.optgroup = wrapMap.option;

    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;


    function getAll(context, tag) {

        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (#15151)
        var ret;

        if (typeof context.getElementsByTagName !== "undefined") {
            ret = context.getElementsByTagName(tag || "*");

        } else if (typeof context.querySelectorAll !== "undefined") {
            ret = context.querySelectorAll(tag || "*");

        } else {
            ret = [];
        }

        if (tag === undefined || tag && nodeName(context, tag)) {
            return jQuery.merge([context], ret);
        }

        return ret;
    }


    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0,
            l = elems.length;

        for (; i < l; i++) {
            dataPriv.set(
                elems[i],
                "globalEval",
                !refElements || dataPriv.get(refElements[i], "globalEval")
            );
        }
    }


    var rhtml = /<|&#?\w+;/;

    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, contains, j,
            fragment = context.createDocumentFragment(),
            nodes = [],
            i = 0,
            l = elems.length;

        for (; i < l; i++) {
            elem = elems[i];

            if (elem || elem === 0) {

                // Add nodes directly
                if (toType(elem) === "object") {

                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

                    // Convert non-html into a text node
                } else if (!rhtml.test(elem)) {
                    nodes.push(context.createTextNode(elem));

                    // Convert html into DOM nodes
                } else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));

                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while (j--) {
                        tmp = tmp.lastChild;
                    }

                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);

                    // Remember the top-level container
                    tmp = fragment.firstChild;

                    // Ensure the created nodes are orphaned (#12392)
                    tmp.textContent = "";
                }
            }
        }

        // Remove wrapper from fragment
        fragment.textContent = "";

        i = 0;
        while ((elem = nodes[i++])) {

            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) {
                    ignored.push(elem);
                }
                continue;
            }

            contains = jQuery.contains(elem.ownerDocument, elem);

            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");

            // Preserve script evaluation history
            if (contains) {
                setGlobalEval(tmp);
            }

            // Capture executables
            if (scripts) {
                j = 0;
                while ((elem = tmp[j++])) {
                    if (rscriptType.test(elem.type || "")) {
                        scripts.push(elem);
                    }
                }
            }
        }

        return fragment;
    }


    (function () {
        var fragment = document$1.createDocumentFragment(),
            div = fragment.appendChild(document$1.createElement("div")),
            input = document$1.createElement("input");

        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (#11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (#14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");

        div.appendChild(input);

        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;

        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
    })();
    var documentElement = document$1.documentElement;


    var
        rkeyEvent = /^key/,
        rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

    function returnTrue() {
        return true;
    }

    function returnFalse() {
        return false;
    }

    // Support: IE <=9 only
    // See #13393 for more info
    function safeActiveElement() {
        try {
            return document$1.activeElement;
        } catch (err) {
        }
    }

    function on(elem, types, selector, data, fn, one) {
        var origFn, type;

        // Types can be a map of types/handlers
        if (typeof types === "object") {

            // ( types-Object, selector, data )
            if (typeof selector !== "string") {

                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for (type in types) {
                on(elem, type, selector, data, types[type], one);
            }
            return elem;
        }

        if (data == null && fn == null) {

            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {

                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {

                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) {
            fn = returnFalse;
        } else if (!fn) {
            return elem;
        }

        if (one === 1) {
            origFn = fn;
            fn = function (event) {

                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };

            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function () {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }

    /*
     * Helper functions for managing events -- not part of the public interface.
     * Props to Dean Edwards' addEvent library for many of the ideas.
     */
    jQuery.event = {

        global: {},

        add: function (elem, types, handler, data, selector) {

            var handleObjIn, eventHandle, tmp,
                events, t, handleObj,
                special, handlers, type, namespaces, origType,
                elemData = dataPriv.get(elem);

            // Don't attach events to noData or text/comment nodes (but allow plain objects)
            if (!elemData) {
                return;
            }

            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }

            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) {
                jQuery.find.matchesSelector(documentElement, selector);
            }

            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) {
                handler.guid = jQuery.guid++;
            }

            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) {
                events = elemData.events = {};
            }
            if (!(eventHandle = elemData.handle)) {
                eventHandle = elemData.handle = function (e) {

                    // Discard the second event of a jQuery.event.trigger() and
                    // when an event is called after a page has unloaded
                    return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
                        jQuery.event.dispatch.apply(elem, arguments) : undefined;
                };
            }

            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [""];
            t = types.length;
            while (t--) {
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();

                // There *must* be a type, no attaching namespace-only handlers
                if (!type) {
                    continue;
                }

                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};

                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;

                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};

                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);

                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;

                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup ||
                        special.setup.call(elem, data, namespaces, eventHandle) === false) {

                        if (elem.addEventListener) {
                            elem.addEventListener(type, eventHandle);
                        }
                    }
                }

                if (special.add) {
                    special.add.call(elem, handleObj);

                    if (!handleObj.handler.guid) {
                        handleObj.handler.guid = handler.guid;
                    }
                }

                // Add to the element's handler list, delegates in front
                if (selector) {
                    handlers.splice(handlers.delegateCount++, 0, handleObj);
                } else {
                    handlers.push(handleObj);
                }

                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }

        },

        // Detach an event or set of events from an element
        remove: function (elem, types, handler, selector, mappedTypes) {

            var j, origCount, tmp,
                events, t, handleObj,
                special, handlers, type, namespaces, origType,
                elemData = dataPriv.hasData(elem) && dataPriv.get(elem);

            if (!elemData || !(events = elemData.events)) {
                return;
            }

            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [""];
            t = types.length;
            while (t--) {
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();

                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for (type in events) {
                        jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    }
                    continue;
                }

                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] &&
                    new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");

                // Remove matching events
                origCount = j = handlers.length;
                while (j--) {
                    handleObj = handlers[j];

                    if ((mappedTypes || origType === handleObj.origType) &&
                        (!handler || handler.guid === handleObj.guid) &&
                        (!tmp || tmp.test(handleObj.namespace)) &&
                        (!selector || selector === handleObj.selector ||
                            selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);

                        if (handleObj.selector) {
                            handlers.delegateCount--;
                        }
                        if (special.remove) {
                            special.remove.call(elem, handleObj);
                        }
                    }
                }

                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown ||
                        special.teardown.call(elem, namespaces, elemData.handle) === false) {

                        jQuery.removeEvent(elem, type, elemData.handle);
                    }

                    delete events[type];
                }
            }

            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) {
                dataPriv.remove(elem, "handle events");
            }
        },

        dispatch: function (nativeEvent) {

            // Make a writable jQuery.Event from the native event object
            var event = jQuery.event.fix(nativeEvent);

            var i, j, ret, matched, handleObj, handlerQueue,
                args = new Array(arguments.length),
                handlers = (dataPriv.get(this, "events") || {})[event.type] || [],
                special = jQuery.event.special[event.type] || {};

            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;

            for (i = 1; i < arguments.length; i++) {
                args[i] = arguments[i];
            }

            event.delegateTarget = this;

            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) {
                return;
            }

            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);

            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
                event.currentTarget = matched.elem;

                j = 0;
                while ((handleObj = matched.handlers[j++]) &&
                !event.isImmediatePropagationStopped()) {

                    // Triggered event must either 1) have no namespace, or 2) have namespace(s)
                    // a subset or equal to those in the bound event (both can have no namespace).
                    if (!event.rnamespace || event.rnamespace.test(handleObj.namespace)) {

                        event.handleObj = handleObj;
                        event.data = handleObj.data;

                        ret = ((jQuery.event.special[handleObj.origType] || {}).handle ||
                            handleObj.handler).apply(matched.elem, args);

                        if (ret !== undefined) {
                            if ((event.result = ret) === false) {
                                event.preventDefault();
                                event.stopPropagation();
                            }
                        }
                    }
                }
            }

            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) {
                special.postDispatch.call(this, event);
            }

            return event.result;
        },

        handlers: function (event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors,
                handlerQueue = [],
                delegateCount = handlers.delegateCount,
                cur = event.target;

            // Find delegate handlers
            if (delegateCount &&

                // Support: IE <=9
                // Black-hole SVG <use> instance trees (trac-13180)
                cur.nodeType &&

                // Support: Firefox <=42
                // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
                // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
                // Support: IE 11 only
                // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
                !(event.type === "click" && event.button >= 1)) {

                for (; cur !== this; cur = cur.parentNode || this) {

                    // Don't check non-elements (#13208)
                    // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                    if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                        matchedHandlers = [];
                        matchedSelectors = {};
                        for (i = 0; i < delegateCount; i++) {
                            handleObj = handlers[i];

                            // Don't conflict with Object.prototype properties (#13203)
                            sel = handleObj.selector + " ";

                            if (matchedSelectors[sel] === undefined) {
                                matchedSelectors[sel] = handleObj.needsContext ?
                                    jQuery(sel, this).index(cur) > -1 :
                                    jQuery.find(sel, this, null, [cur]).length;
                            }
                            if (matchedSelectors[sel]) {
                                matchedHandlers.push(handleObj);
                            }
                        }
                        if (matchedHandlers.length) {
                            handlerQueue.push({elem: cur, handlers: matchedHandlers});
                        }
                    }
                }
            }

            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) {
                handlerQueue.push({elem: cur, handlers: handlers.slice(delegateCount)});
            }

            return handlerQueue;
        },

        addProp: function (name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,

                get: isFunction(hook) ?
                    function () {
                        if (this.originalEvent) {
                            return hook(this.originalEvent);
                        }
                    } :
                    function () {
                        if (this.originalEvent) {
                            return this.originalEvent[name];
                        }
                    },

                set: function (value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },

        fix: function (originalEvent) {
            return originalEvent[jQuery.expando] ?
                originalEvent :
                new jQuery.Event(originalEvent);
        },

        special: {
            load: {

                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            focus: {

                // Fire native event if possible so blur/focus sequence is correct
                trigger: function () {
                    if (this !== safeActiveElement() && this.focus) {
                        this.focus();
                        return false;
                    }
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function () {
                    if (this === safeActiveElement() && this.blur) {
                        this.blur();
                        return false;
                    }
                },
                delegateType: "focusout"
            },
            click: {

                // For checkbox, fire native event so checked state will be right
                trigger: function () {
                    if (this.type === "checkbox" && this.click && nodeName(this, "input")) {
                        this.click();
                        return false;
                    }
                },

                // For cross-browser consistency, don't fire native .click() on links
                _default: function (event) {
                    return nodeName(event.target, "a");
                }
            },

            beforeunload: {
                postDispatch: function (event) {

                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) {
                        event.originalEvent.returnValue = event.result;
                    }
                }
            }
        }
    };

    jQuery.removeEvent = function (elem, type, handle) {

        // This "if" is needed for plain objects
        if (elem.removeEventListener) {
            elem.removeEventListener(type, handle);
        }
    };

    jQuery.Event = function (src, props) {

        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) {
            return new jQuery.Event(src, props);
        }

        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;

            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented ||
            src.defaultPrevented === undefined &&

            // Support: Android <=2.3 only
            src.returnValue === false ?
                returnTrue :
                returnFalse;

            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (#504, #13143)
            this.target = (src.target && src.target.nodeType === 3) ?
                src.target.parentNode :
                src.target;

            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;

            // Event type
        } else {
            this.type = src;
        }

        // Put explicitly provided properties onto the event object
        if (props) {
            jQuery.extend(this, props);
        }

        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();

        // Mark it as fixed
        this[jQuery.expando] = true;
    };

    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,

        preventDefault: function () {
            var e = this.originalEvent;

            this.isDefaultPrevented = returnTrue;

            if (e && !this.isSimulated) {
                e.preventDefault();
            }
        },
        stopPropagation: function () {
            var e = this.originalEvent;

            this.isPropagationStopped = returnTrue;

            if (e && !this.isSimulated) {
                e.stopPropagation();
            }
        },
        stopImmediatePropagation: function () {
            var e = this.originalEvent;

            this.isImmediatePropagationStopped = returnTrue;

            if (e && !this.isSimulated) {
                e.stopImmediatePropagation();
            }

            this.stopPropagation();
        }
    };

    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,

        which: function (event) {
            var button = event.button;

            // Add which for key events
            if (event.which == null && rkeyEvent.test(event.type)) {
                return event.charCode != null ? event.charCode : event.keyCode;
            }

            // Add which for click: 1 === left; 2 === middle; 3 === right
            if (!event.which && button !== undefined && rmouseEvent.test(event.type)) {
                if (button & 1) {
                    return 1;
                }

                if (button & 2) {
                    return 3;
                }

                if (button & 4) {
                    return 2;
                }

                return 0;
            }

            return event.which;
        }
    }, jQuery.event.addProp);

    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function (orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,

            handle: function (event) {
                var ret,
                    target = this,
                    related = event.relatedTarget,
                    handleObj = event.handleObj;

                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || (related !== target && !jQuery.contains(target, related))) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });

    jQuery.fn.extend({

        on: function (types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function (types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function (types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {

                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(
                    handleObj.namespace ?
                        handleObj.origType + "." + handleObj.namespace :
                        handleObj.origType,
                    handleObj.selector,
                    handleObj.handler
                );
                return this;
            }
            if (typeof types === "object") {

                // ( types-object [, selector] )
                for (type in types) {
                    this.off(type, selector, types[type]);
                }
                return this;
            }
            if (selector === false || typeof selector === "function") {

                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) {
                fn = returnFalse;
            }
            return this.each(function () {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });


    var

        /* eslint-disable max-len */

        // See https://github.com/eslint/eslint/issues/3229
        rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

        /* eslint-enable */

        // Support: IE <=10 - 11, Edge 12 - 13 only
        // In IE/Edge using regex groups here causes severe slowdowns.
        // See https://connect.microsoft.com/IE/feedback/details/1736512/
        rnoInnerhtml = /<script|<style|<link/i,

        // checked="checked" or checked
        rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
        rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") &&
            nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {

            return jQuery(elem).children("tbody")[0] || elem;
        }

        return elem;
    }

    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }

    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") {
            elem.type = elem.type.slice(5);
        } else {
            elem.removeAttribute("type");
        }

        return elem;
    }

    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

        if (dest.nodeType !== 1) {
            return;
        }

        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.access(src);
            pdataCur = dataPriv.set(dest, pdataOld);
            events = pdataOld.events;

            if (events) {
                delete pdataCur.handle;
                pdataCur.events = {};

                for (type in events) {
                    for (i = 0, l = events[type].length; i < l; i++) {
                        jQuery.event.add(dest, type, events[type][i]);
                    }
                }
            }
        }

        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);

            dataUser.set(dest, udataCur);
        }
    }

    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();

        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) {
            dest.checked = src.checked;

            // Fails to return the selected option to the default selected state when cloning options
        } else if (nodeName === "input" || nodeName === "textarea") {
            dest.defaultValue = src.defaultValue;
        }
    }

    function domManip(collection, args, callback, ignored) {

        // Flatten any nested arrays
        args = concat.apply([], args);

        var fragment, first, scripts, hasScripts, node, doc,
            i = 0,
            l = collection.length,
            iNoClone = l - 1,
            value = args[0],
            valueIsFunction = isFunction(value);

        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction ||
            (l > 1 && typeof value === "string" &&
                !support.checkClone && rchecked.test(value))) {
            return collection.each(function (index) {
                var self = collection.eq(index);
                if (valueIsFunction) {
                    args[0] = value.call(this, index, self.html());
                }
                domManip(self, args, callback, ignored);
            });
        }

        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;

            if (fragment.childNodes.length === 1) {
                fragment = first;
            }

            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;

                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (#8070).
                for (; i < l; i++) {
                    node = fragment;

                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);

                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) {

                            // Support: Android <=4.0 only, PhantomJS 1 only
                            // push.apply(_, arraylike) throws on ancient WebKit
                            jQuery.merge(scripts, getAll(node, "script"));
                        }
                    }

                    callback.call(collection[i], node, i);
                }

                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;

                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);

                    // Evaluate executable scripts on first document insertion
                    for (i = 0; i < hasScripts; i++) {
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") &&
                            !dataPriv.access(node, "globalEval") &&
                            jQuery.contains(doc, node)) {

                            if (node.src && (node.type || "").toLowerCase() !== "module") {

                                // Optional AJAX dependency, but won't run scripts if not present
                                if (jQuery._evalUrl) {
                                    jQuery._evalUrl(node.src);
                                }
                            } else {
                                DOMEval(node.textContent.replace(rcleanScript, ""), doc, node);
                            }
                        }
                    }
                }
            }
        }

        return collection;
    }

    function remove(elem, selector, keepData) {
        var node,
            nodes = selector ? jQuery.filter(selector, elem) : elem,
            i = 0;

        for (; (node = nodes[i]) != null; i++) {
            if (!keepData && node.nodeType === 1) {
                jQuery.cleanData(getAll(node));
            }

            if (node.parentNode) {
                if (keepData && jQuery.contains(node.ownerDocument, node)) {
                    setGlobalEval(getAll(node, "script"));
                }
                node.parentNode.removeChild(node);
            }
        }

        return elem;
    }

    jQuery.extend({
        htmlPrefilter: function (html) {
            return html.replace(rxhtmlTag, "<$1></$2>");
        },

        clone: function (elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements,
                clone = elem.cloneNode(true),
                inPage = jQuery.contains(elem.ownerDocument, elem);

            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) &&
                !jQuery.isXMLDoc(elem)) {

                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);

                for (i = 0, l = srcElements.length; i < l; i++) {
                    fixInput(srcElements[i], destElements[i]);
                }
            }

            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);

                    for (i = 0, l = srcElements.length; i < l; i++) {
                        cloneCopyEvent(srcElements[i], destElements[i]);
                    }
                } else {
                    cloneCopyEvent(elem, clone);
                }
            }

            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) {
                setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            }

            // Return the cloned set
            return clone;
        },

        cleanData: function (elems) {
            var data, elem, type,
                special = jQuery.event.special,
                i = 0;

            for (; (elem = elems[i]) !== undefined; i++) {
                if (acceptData(elem)) {
                    if ((data = elem[dataPriv.expando])) {
                        if (data.events) {
                            for (type in data.events) {
                                if (special[type]) {
                                    jQuery.event.remove(elem, type);

                                    // This is a shortcut to avoid jQuery.event.remove's overhead
                                } else {
                                    jQuery.removeEvent(elem, type, data.handle);
                                }
                            }
                        }

                        // Support: Chrome <=35 - 45+
                        // Assign undefined instead of using delete, see Data#remove
                        elem[dataPriv.expando] = undefined;
                    }
                    if (elem[dataUser.expando]) {

                        // Support: Chrome <=35 - 45+
                        // Assign undefined instead of using delete, see Data#remove
                        elem[dataUser.expando] = undefined;
                    }
                }
            }
        }
    });

    jQuery.fn.extend({
        detach: function (selector) {
            return remove(this, selector, true);
        },

        remove: function (selector) {
            return remove(this, selector);
        },

        text: function (value) {
            return access(this, function (value) {
                return value === undefined ?
                    jQuery.text(this) :
                    this.empty().each(function () {
                        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                            this.textContent = value;
                        }
                    });
            }, null, value, arguments.length);
        },

        append: function () {
            return domManip(this, arguments, function (elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },

        prepend: function () {
            return domManip(this, arguments, function (elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },

        before: function () {
            return domManip(this, arguments, function (elem) {
                if (this.parentNode) {
                    this.parentNode.insertBefore(elem, this);
                }
            });
        },

        after: function () {
            return domManip(this, arguments, function (elem) {
                if (this.parentNode) {
                    this.parentNode.insertBefore(elem, this.nextSibling);
                }
            });
        },

        empty: function () {
            var elem,
                i = 0;

            for (; (elem = this[i]) != null; i++) {
                if (elem.nodeType === 1) {

                    // Prevent memory leaks
                    jQuery.cleanData(getAll(elem, false));

                    // Remove any remaining nodes
                    elem.textContent = "";
                }
            }

            return this;
        },

        clone: function (dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

            return this.map(function () {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },

        html: function (value) {
            return access(this, function (value) {
                var elem = this[0] || {},
                    i = 0,
                    l = this.length;

                if (value === undefined && elem.nodeType === 1) {
                    return elem.innerHTML;
                }

                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) &&
                    !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {

                    value = jQuery.htmlPrefilter(value);

                    try {
                        for (; i < l; i++) {
                            elem = this[i] || {};

                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }

                        elem = 0;

                        // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {
                    }
                }

                if (elem) {
                    this.empty().append(value);
                }
            }, null, value, arguments.length);
        },

        replaceWith: function () {
            var ignored = [];

            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function (elem) {
                var parent = this.parentNode;

                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) {
                        parent.replaceChild(elem, this);
                    }
                }

                // Force callback invocation
            }, ignored);
        }
    });

    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function (name, original) {
        jQuery.fn[name] = function (selector) {
            var elems,
                ret = [],
                insert = jQuery(selector),
                last = insert.length - 1,
                i = 0;

            for (; i <= last; i++) {
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);

                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }

            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");

    var getStyles = function (elem) {

        // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;

        if (!view || !view.opener) {
            view = window;
        }

        return view.getComputedStyle(elem);
    };

    var rboxStyle = new RegExp(cssExpand.join("|"), "i");


    (function () {

        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {

            // This is a singleton, we need to execute it only once
            if (!div) {
                return;
            }

            container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
                "margin-top:1px;padding:0;border:0";
            div.style.cssText =
                "position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
                "margin:auto;border:1px;padding:1px;" +
                "width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);

            var divStyle = window.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";

            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;

            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            div.style.position = "absolute";
            scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

            documentElement.removeChild(container);

            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }

        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }

        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
            reliableMarginLeftVal,
            container = document$1.createElement("div"),
            div = document$1.createElement("div");

        // Finish early in limited (non-browser) environments
        if (!div.style) {
            return;
        }

        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (#8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";

        jQuery.extend(support, {
            boxSizingReliable: function () {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function () {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function () {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function () {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function () {
                computeStyleTests();
                return scrollboxSizeVal;
            }
        });
    })();


    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret,

            // Support: Firefox 51+
            // Retrieving style before computed somehow
            // fixes an issue with getting wrong values
            // on detached elements
            style = elem.style;

        computed = computed || getStyles(elem);

        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, #12537)
        //   .css('--customProperty) (#3144)
        if (computed) {
            ret = computed.getPropertyValue(name) || computed[name];

            if (ret === "" && !jQuery.contains(elem.ownerDocument, elem)) {
                ret = jQuery.style(elem, name);
            }

            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {

                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;

                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;

                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }

        return ret !== undefined ?

            // Support: IE <=9 - 11 only
            // IE returns zIndex value as an integer.
            ret + "" :
            ret;
    }


    function addGetHookIf(conditionFn, hookFn) {

        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function () {
                if (conditionFn()) {

                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }

                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }


    var

        // Swappable if display is none or starts with table
        // except "table", "table-cell", or "table-caption"
        // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
        rdisplayswap = /^(none|table(?!-c[ea]).+)/,
        rcustomProp = /^--/,
        cssShow = {position: "absolute", visibility: "hidden", display: "block"},
        cssNormalTransform = {
            letterSpacing: "0",
            fontWeight: "400"
        },

        cssPrefixes = ["Webkit", "Moz", "ms"],
        emptyStyle = document$1.createElement("div").style;

    // Return a css property mapped to a potentially vendor prefixed property
    function vendorPropName(name) {

        // Shortcut for names that are not vendor prefixed
        if (name in emptyStyle) {
            return name;
        }

        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1),
            i = cssPrefixes.length;

        while (i--) {
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) {
                return name;
            }
        }
    }

    // Return a property mapped along what jQuery.cssProps suggests or to
    // a vendor prefixed property.
    function finalPropName(name) {
        var ret = jQuery.cssProps[name];
        if (!ret) {
            ret = jQuery.cssProps[name] = vendorPropName(name) || name;
        }
        return ret;
    }

    function setPositiveNumber(elem, value, subtract) {

        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ?

            // Guard against undefined "subtract", e.g., when used as in cssHooks
            Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") :
            value;
    }

    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0,
            extra = 0,
            delta = 0;

        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) {
            return 0;
        }

        for (; i < 4; i += 2) {

            // Both box models exclude margin
            if (box === "margin") {
                delta += jQuery.css(elem, box + cssExpand[i], true, styles);
            }

            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {

                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);

                // For "border" or "margin", add border
                if (box !== "padding") {
                    delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);

                    // But still keep track of it otherwise
                } else {
                    extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                }

                // If we get here with a border-box (content + padding + border), we're seeking "content" or
                // "padding" or "margin"
            } else {

                // For "content", subtract padding
                if (box === "content") {
                    delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                }

                // For "content" or "padding", subtract border
                if (box !== "margin") {
                    delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                }
            }
        }

        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) {

            // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
            // Assuming integer scroll gutter, subtract the rest and round down
            delta += Math.max(0, Math.ceil(
                elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] -
                computedVal -
                delta -
                extra -
                0.5
            ));
        }

        return delta;
    }

    function getWidthOrHeight(elem, dimension, extra) {

        // Start with computed style
        var styles = getStyles(elem),
            val = curCSS(elem, dimension, styles),
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box",
            valueIsBorderBox = isBorderBox;

        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) {
                return val;
            }
            val = "auto";
        }

        // Check for style in case a browser which returns unreliable values
        // for getComputedStyle silently falls back to the reliable elem.style
        valueIsBorderBox = valueIsBorderBox &&
            (support.boxSizingReliable() || val === elem.style[dimension]);

        // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        if (val === "auto" ||
            !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") {

            val = elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)];

            // offsetWidth/offsetHeight provide border-box values
            valueIsBorderBox = true;
        }

        // Normalize "" and auto
        val = parseFloat(val) || 0;

        // Adjust for the element's box model
        return (val +
            boxModelAdjustment(
                elem,
                dimension,
                extra || (isBorderBox ? "border" : "content"),
                valueIsBorderBox,
                styles,

                // Provide the current computed size to request scroll gutter calculation (gh-3589)
                val
            )
        ) + "px";
    }

    jQuery.extend({

        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function (elem, computed) {
                    if (computed) {

                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },

        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            "animationIterationCount": true,
            "columnCount": true,
            "fillOpacity": true,
            "flexGrow": true,
            "flexShrink": true,
            "fontWeight": true,
            "lineHeight": true,
            "opacity": true,
            "order": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
        },

        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},

        // Get and set the style property on a DOM Node
        style: function (elem, name, value, extra) {

            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
                return;
            }

            // Make sure that we're working with the right name
            var ret, type, hooks,
                origName = camelCase(name),
                isCustomProp = rcustomProp.test(name),
                style = elem.style;

            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) {
                name = finalPropName(origName);
            }

            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;

                // Convert "+=" or "-=" to relative numbers (#7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);

                    // Fixes bug #9237
                    type = "number";
                }

                // Make sure that null and NaN values aren't set (#7116)
                if (value == null || value !== value) {
                    return;
                }

                // If a number was passed in, add the unit (except for certain CSS properties)
                if (type === "number") {
                    value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                }

                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
                    style[name] = "inherit";
                }

                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) ||
                    (value = hooks.set(elem, value, extra)) !== undefined) {

                    if (isCustomProp) {
                        style.setProperty(name, value);
                    } else {
                        style[name] = value;
                    }
                }

            } else {

                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks &&
                    (ret = hooks.get(elem, false, extra)) !== undefined) {

                    return ret;
                }

                // Otherwise just get the value from the style object
                return style[name];
            }
        },

        css: function (elem, name, extra, styles) {
            var val, num, hooks,
                origName = camelCase(name),
                isCustomProp = rcustomProp.test(name);

            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) {
                name = finalPropName(origName);
            }

            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) {
                val = hooks.get(elem, true, extra);
            }

            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) {
                val = curCSS(elem, name, styles);
            }

            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) {
                val = cssNormalTransform[name];
            }

            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }

            return val;
        }
    });

    jQuery.each(["height", "width"], function (i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function (elem, computed, extra) {
                if (computed) {

                    // Certain elements can have dimension info if we invisibly show them
                    // but it must have a current display style that would benefit
                    return rdisplayswap.test(jQuery.css(elem, "display")) &&

                    // Support: Safari 8+
                    // Table columns in Safari have non-zero offsetWidth & zero
                    // getBoundingClientRect().width unless display is changed.
                    // Support: IE <=11 only
                    // Running getBoundingClientRect on a disconnected node
                    // in IE throws an error.
                    (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ?
                        swap(elem, cssShow, function () {
                            return getWidthOrHeight(elem, dimension, extra);
                        }) :
                        getWidthOrHeight(elem, dimension, extra);
                }
            },

            set: function (elem, value, extra) {
                var matches,
                    styles = getStyles(elem),
                    isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box",
                    subtract = extra && boxModelAdjustment(
                        elem,
                        dimension,
                        extra,
                        isBorderBox,
                        styles
                    );

                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && support.scrollboxSize() === styles.position) {
                    subtract -= Math.ceil(
                        elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] -
                        parseFloat(styles[dimension]) -
                        boxModelAdjustment(elem, dimension, "border", false, styles) -
                        0.5
                    );
                }

                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) &&
                    (matches[3] || "px") !== "px") {

                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }

                return setPositiveNumber(elem, value, subtract);
            }
        };
    });

    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft,
        function (elem, computed) {
            if (computed) {
                return (parseFloat(curCSS(elem, "marginLeft")) ||
                    elem.getBoundingClientRect().left -
                    swap(elem, {marginLeft: 0}, function () {
                        return elem.getBoundingClientRect().left;
                    })
                ) + "px";
            }
        }
    );

    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function (prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function (value) {
                var i = 0,
                    expanded = {},

                    // Assumes a single number if not a string
                    parts = typeof value === "string" ? value.split(" ") : [value];

                for (; i < 4; i++) {
                    expanded[prefix + cssExpand[i] + suffix] =
                        parts[i] || parts[i - 2] || parts[0];
                }

                return expanded;
            }
        };

        if (prefix !== "margin") {
            jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
        }
    });

    jQuery.fn.extend({
        css: function (name, value) {
            return access(this, function (elem, name, value) {
                var styles, len,
                    map = {},
                    i = 0;

                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;

                    for (; i < len; i++) {
                        map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    }

                    return map;
                }

                return value !== undefined ?
                    jQuery.style(elem, name, value) :
                    jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });


    // Based off of the plugin by Clint Helfers, with permission.
    // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
    jQuery.fn.delay = function (time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";

        return this.queue(type, function (next, hooks) {
            var timeout = window.setTimeout(next, time);
            hooks.stop = function () {
                window.clearTimeout(timeout);
            };
        });
    };


    (function () {
        var input = document$1.createElement("input"),
            select = document$1.createElement("select"),
            opt = select.appendChild(document$1.createElement("option"));

        input.type = "checkbox";

        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";

        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;

        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document$1.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();


    var boolHook,
        attrHandle = jQuery.expr.attrHandle;

    jQuery.fn.extend({
        attr: function (name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },

        removeAttr: function (name) {
            return this.each(function () {
                jQuery.removeAttr(this, name);
            });
        }
    });

    jQuery.extend({
        attr: function (elem, name, value) {
            var ret, hooks,
                nType = elem.nodeType;

            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) {
                return;
            }

            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") {
                return jQuery.prop(elem, name, value);
            }

            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                hooks = jQuery.attrHooks[name.toLowerCase()] ||
                    (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            }

            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }

                if (hooks && "set" in hooks &&
                    (ret = hooks.set(elem, value, name)) !== undefined) {
                    return ret;
                }

                elem.setAttribute(name, value + "");
                return value;
            }

            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
                return ret;
            }

            ret = jQuery.find.attr(elem, name);

            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },

        attrHooks: {
            type: {
                set: function (elem, value) {
                    if (!support.radioValue && value === "radio" &&
                        nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) {
                            elem.value = val;
                        }
                        return value;
                    }
                }
            }
        },

        removeAttr: function (elem, value) {
            var name,
                i = 0,

                // Attribute names can contain non-HTML whitespace characters
                // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
                attrNames = value && value.match(rnothtmlwhite);

            if (attrNames && elem.nodeType === 1) {
                while ((name = attrNames[i++])) {
                    elem.removeAttribute(name);
                }
            }
        }
    });

    // Hooks for boolean attributes
    boolHook = {
        set: function (elem, value, name) {
            if (value === false) {

                // Remove boolean attributes when set to false
                jQuery.removeAttr(elem, name);
            } else {
                elem.setAttribute(name, name);
            }
            return name;
        }
    };

    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;

        attrHandle[name] = function (elem, name, isXML) {
            var ret, handle,
                lowercaseName = name.toLowerCase();

            if (!isXML) {

                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ?
                    lowercaseName :
                    null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });


    var rfocusable = /^(?:input|select|textarea|button)$/i,
        rclickable = /^(?:a|area)$/i;

    jQuery.fn.extend({
        prop: function (name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },

        removeProp: function (name) {
            return this.each(function () {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });

    jQuery.extend({
        prop: function (elem, name, value) {
            var ret, hooks,
                nType = elem.nodeType;

            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) {
                return;
            }

            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {

                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }

            if (value !== undefined) {
                if (hooks && "set" in hooks &&
                    (ret = hooks.set(elem, value, name)) !== undefined) {
                    return ret;
                }

                return (elem[name] = value);
            }

            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
                return ret;
            }

            return elem[name];
        },

        propHooks: {
            tabIndex: {
                get: function (elem) {

                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                    // Use proper attribute retrieval(#12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");

                    if (tabindex) {
                        return parseInt(tabindex, 10);
                    }

                    if (
                        rfocusable.test(elem.nodeName) ||
                        rclickable.test(elem.nodeName) &&
                        elem.href
                    ) {
                        return 0;
                    }

                    return -1;
                }
            }
        },

        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });

    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) {
        jQuery.propHooks.selected = {
            get: function (elem) {

                /* eslint no-unused-expressions: "off" */

                var parent = elem.parentNode;
                if (parent && parent.parentNode) {
                    parent.parentNode.selectedIndex;
                }
                return null;
            },
            set: function (elem) {

                /* eslint no-unused-expressions: "off" */

                var parent = elem.parentNode;
                if (parent) {
                    parent.selectedIndex;

                    if (parent.parentNode) {
                        parent.parentNode.selectedIndex;
                    }
                }
            }
        };
    }

    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function () {
        jQuery.propFix[this.toLowerCase()] = this;
    });


    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }


    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }

    function classesToArray(value) {
        if (Array.isArray(value)) {
            return value;
        }
        if (typeof value === "string") {
            return value.match(rnothtmlwhite) || [];
        }
        return [];
    }

    jQuery.fn.extend({
        addClass: function (value) {
            var classes, elem, cur, curValue, clazz, j, finalValue,
                i = 0;

            if (isFunction(value)) {
                return this.each(function (j) {
                    jQuery(this).addClass(value.call(this, j, getClass(this)));
                });
            }

            classes = classesToArray(value);

            if (classes.length) {
                while ((elem = this[i++])) {
                    curValue = getClass(elem);
                    cur = elem.nodeType === 1 && (" " + stripAndCollapse(curValue) + " ");

                    if (cur) {
                        j = 0;
                        while ((clazz = classes[j++])) {
                            if (cur.indexOf(" " + clazz + " ") < 0) {
                                cur += clazz + " ";
                            }
                        }

                        // Only assign if different to avoid unneeded rendering.
                        finalValue = stripAndCollapse(cur);
                        if (curValue !== finalValue) {
                            elem.setAttribute("class", finalValue);
                        }
                    }
                }
            }

            return this;
        },

        removeClass: function (value) {
            var classes, elem, cur, curValue, clazz, j, finalValue,
                i = 0;

            if (isFunction(value)) {
                return this.each(function (j) {
                    jQuery(this).removeClass(value.call(this, j, getClass(this)));
                });
            }

            if (!arguments.length) {
                return this.attr("class", "");
            }

            classes = classesToArray(value);

            if (classes.length) {
                while ((elem = this[i++])) {
                    curValue = getClass(elem);

                    // This expression is here for better compressibility (see addClass)
                    cur = elem.nodeType === 1 && (" " + stripAndCollapse(curValue) + " ");

                    if (cur) {
                        j = 0;
                        while ((clazz = classes[j++])) {

                            // Remove *all* instances
                            while (cur.indexOf(" " + clazz + " ") > -1) {
                                cur = cur.replace(" " + clazz + " ", " ");
                            }
                        }

                        // Only assign if different to avoid unneeded rendering.
                        finalValue = stripAndCollapse(cur);
                        if (curValue !== finalValue) {
                            elem.setAttribute("class", finalValue);
                        }
                    }
                }
            }

            return this;
        },

        toggleClass: function (value, stateVal) {
            var type = typeof value,
                isValidValue = type === "string" || Array.isArray(value);

            if (typeof stateVal === "boolean" && isValidValue) {
                return stateVal ? this.addClass(value) : this.removeClass(value);
            }

            if (isFunction(value)) {
                return this.each(function (i) {
                    jQuery(this).toggleClass(
                        value.call(this, i, getClass(this), stateVal),
                        stateVal
                    );
                });
            }

            return this.each(function () {
                var className, i, self, classNames;

                if (isValidValue) {

                    // Toggle individual class names
                    i = 0;
                    self = jQuery(this);
                    classNames = classesToArray(value);

                    while ((className = classNames[i++])) {

                        // Check each className given, space separated list
                        if (self.hasClass(className)) {
                            self.removeClass(className);
                        } else {
                            self.addClass(className);
                        }
                    }

                    // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) {

                        // Store className if set
                        dataPriv.set(this, "__className__", className);
                    }

                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) {
                        this.setAttribute("class",
                            className || value === false ?
                                "" :
                                dataPriv.get(this, "__className__") || ""
                        );
                    }
                }
            });
        },

        hasClass: function (selector) {
            var className, elem,
                i = 0;

            className = " " + selector + " ";
            while ((elem = this[i++])) {
                if (elem.nodeType === 1 &&
                    (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
                    return true;
                }
            }

            return false;
        }
    });


    var rreturn = /\r/g;

    jQuery.fn.extend({
        val: function (value) {
            var hooks, ret, valueIsFunction,
                elem = this[0];

            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] ||
                        jQuery.valHooks[elem.nodeName.toLowerCase()];

                    if (hooks &&
                        "get" in hooks &&
                        (ret = hooks.get(elem, "value")) !== undefined
                    ) {
                        return ret;
                    }

                    ret = elem.value;

                    // Handle most common string cases
                    if (typeof ret === "string") {
                        return ret.replace(rreturn, "");
                    }

                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }

                return;
            }

            valueIsFunction = isFunction(value);

            return this.each(function (i) {
                var val;

                if (this.nodeType !== 1) {
                    return;
                }

                if (valueIsFunction) {
                    val = value.call(this, i, jQuery(this).val());
                } else {
                    val = value;
                }

                // Treat null/undefined as ""; convert numbers to string
                if (val == null) {
                    val = "";

                } else if (typeof val === "number") {
                    val += "";

                } else if (Array.isArray(val)) {
                    val = jQuery.map(val, function (value) {
                        return value == null ? "" : value + "";
                    });
                }

                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];

                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
                    this.value = val;
                }
            });
        }
    });

    jQuery.extend({
        valHooks: {
            option: {
                get: function (elem) {

                    var val = jQuery.find.attr(elem, "value");
                    return val != null ?
                        val :

                        // Support: IE <=10 - 11 only
                        // option.text throws exceptions (#14686, #14858)
                        // Strip and collapse whitespace
                        // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                        stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function (elem) {
                    var value, option, i,
                        options = elem.options,
                        index = elem.selectedIndex,
                        one = elem.type === "select-one",
                        values = one ? null : [],
                        max = one ? index + 1 : options.length;

                    if (index < 0) {
                        i = max;

                    } else {
                        i = one ? index : 0;
                    }

                    // Loop through all the selected options
                    for (; i < max; i++) {
                        option = options[i];

                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (#2551)
                        if ((option.selected || i === index) &&

                            // Don't return options that are disabled or in a disabled optgroup
                            !option.disabled &&
                            (!option.parentNode.disabled ||
                                !nodeName(option.parentNode, "optgroup"))) {

                            // Get the specific value for the option
                            value = jQuery(option).val();

                            // We don't need an array for one selects
                            if (one) {
                                return value;
                            }

                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }

                    return values;
                },

                set: function (elem, value) {
                    var optionSet, option,
                        options = elem.options,
                        values = jQuery.makeArray(value),
                        i = options.length;

                    while (i--) {
                        option = options[i];

                        /* eslint-disable no-cond-assign */

                        if (option.selected =
                            jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1
                        ) {
                            optionSet = true;
                        }

                        /* eslint-enable no-cond-assign */
                    }

                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) {
                        elem.selectedIndex = -1;
                    }
                    return values;
                }
            }
        }
    });

    // Radios and checkboxes getter/setter
    jQuery.each(["radio", "checkbox"], function () {
        jQuery.valHooks[this] = {
            set: function (elem, value) {
                if (Array.isArray(value)) {
                    return (elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1);
                }
            }
        };
        if (!support.checkOn) {
            jQuery.valHooks[this].get = function (elem) {
                return elem.getAttribute("value") === null ? "on" : elem.value;
            };
        }
    });


    // Return jQuery for attributes-only inclusion


    support.focusin = "onfocusin" in window;


    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
        stopPropagationCallback = function (e) {
            e.stopPropagation();
        };

    jQuery.extend(jQuery.event, {

        trigger: function (event, data, elem, onlyHandlers) {

            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
                eventPath = [elem || document$1],
                type = hasOwn.call(event, "type") ? event.type : event,
                namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];

            cur = lastElement = tmp = elem = elem || document$1;

            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) {
                return;
            }

            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) {
                return;
            }

            if (type.indexOf(".") > -1) {

                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;

            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ?
                event :
                new jQuery.Event(type, typeof event === "object" && event);

            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ?
                new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") :
                null;

            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) {
                event.target = elem;
            }

            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ?
                [event] :
                jQuery.makeArray(data, [event]);

            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
                return;
            }

            // Determine event propagation path in advance, per W3C events spec (#9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {

                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) {
                    cur = cur.parentNode;
                }
                for (; cur; cur = cur.parentNode) {
                    eventPath.push(cur);
                    tmp = cur;
                }

                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document$1)) {
                    eventPath.push(tmp.defaultView || tmp.parentWindow || window);
                }
            }

            // Fire handlers on the event path
            i = 0;
            while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
                lastElement = cur;
                event.type = i > 1 ?
                    bubbleType :
                    special.bindType || type;

                // jQuery handler
                handle = (dataPriv.get(cur, "events") || {})[event.type] &&
                    dataPriv.get(cur, "handle");
                if (handle) {
                    handle.apply(cur, data);
                }

                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) {
                        event.preventDefault();
                    }
                }
            }
            event.type = type;

            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {

                if ((!special._default ||
                    special._default.apply(eventPath.pop(), data) === false) &&
                    acceptData(elem)) {

                    // Call a native DOM method on the target with the same name as the event.
                    // Don't do default actions on window, that's where global variables be (#6170)
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {

                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];

                        if (tmp) {
                            elem[ontype] = null;
                        }

                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;

                        if (event.isPropagationStopped()) {
                            lastElement.addEventListener(type, stopPropagationCallback);
                        }

                        elem[type]();

                        if (event.isPropagationStopped()) {
                            lastElement.removeEventListener(type, stopPropagationCallback);
                        }

                        jQuery.event.triggered = undefined;

                        if (tmp) {
                            elem[ontype] = tmp;
                        }
                    }
                }
            }

            return event.result;
        },

        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function (type, elem, event) {
            var e = jQuery.extend(
                new jQuery.Event(),
                event,
                {
                    type: type,
                    isSimulated: true
                }
            );

            jQuery.event.trigger(e, null, elem);
        }

    });

    jQuery.fn.extend({

        trigger: function (type, data) {
            return this.each(function () {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function (type, data) {
            var elem = this[0];
            if (elem) {
                return jQuery.event.trigger(type, data, elem, true);
            }
        }
    });


    // Support: Firefox <=44
    // Firefox doesn't have focus(in | out) events
    // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
    //
    // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
    // focus(in | out) events fire after focus & blur events,
    // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
    // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
    if (!support.focusin) {
        jQuery.each({focus: "focusin", blur: "focusout"}, function (orig, fix) {

            // Attach a single capturing handler on the document while someone wants focusin/focusout
            var handler = function (event) {
                jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
            };

            jQuery.event.special[fix] = {
                setup: function () {
                    var doc = this.ownerDocument || this,
                        attaches = dataPriv.access(doc, fix);

                    if (!attaches) {
                        doc.addEventListener(orig, handler, true);
                    }
                    dataPriv.access(doc, fix, (attaches || 0) + 1);
                },
                teardown: function () {
                    var doc = this.ownerDocument || this,
                        attaches = dataPriv.access(doc, fix) - 1;

                    if (!attaches) {
                        doc.removeEventListener(orig, handler, true);
                        dataPriv.remove(doc, fix);

                    } else {
                        dataPriv.access(doc, fix, attaches);
                    }
                }
            };
        });
    }


    var
        rbracket = /\[\]$/,
        rCRLF = /\r?\n/g,
        rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
        rsubmittable = /^(?:input|select|textarea|keygen)/i;

    function buildParams(prefix, obj, traditional, add) {
        var name;

        if (Array.isArray(obj)) {

            // Serialize array item.
            jQuery.each(obj, function (i, v) {
                if (traditional || rbracket.test(prefix)) {

                    // Treat each array item as a scalar.
                    add(prefix, v);

                } else {

                    // Item is non-scalar (array or object), encode its numeric index.
                    buildParams(
                        prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]",
                        v,
                        traditional,
                        add
                    );
                }
            });

        } else if (!traditional && toType(obj) === "object") {

            // Serialize object item.
            for (name in obj) {
                buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
            }

        } else {

            // Serialize scalar item.
            add(prefix, obj);
        }
    }

    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function (a, traditional) {
        var prefix,
            s = [],
            add = function (key, valueOrFunction) {

                // If value is a function, invoke it and use its return value
                var value = isFunction(valueOrFunction) ?
                    valueOrFunction() :
                    valueOrFunction;

                s[s.length] = encodeURIComponent(key) + "=" +
                    encodeURIComponent(value == null ? "" : value);
            };

        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {

            // Serialize the form elements
            jQuery.each(a, function () {
                add(this.name, this.value);
            });

        } else {

            // If traditional, encode the "old" way (the way 1.3.2 or older
            // did it), otherwise encode params recursively.
            for (prefix in a) {
                buildParams(prefix, a[prefix], traditional, add);
            }
        }

        // Return the resulting serialization
        return s.join("&");
    };

    jQuery.fn.extend({
        serialize: function () {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function () {
            return this.map(function () {

                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            })
                .filter(function () {
                    var type = this.type;

                    // Use .is( ":disabled" ) so that fieldset[disabled] works
                    return this.name && !jQuery(this).is(":disabled") &&
                        rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) &&
                        (this.checked || !rcheckableType.test(type));
                })
                .map(function (i, elem) {
                    var val = jQuery(this).val();

                    if (val == null) {
                        return null;
                    }

                    if (Array.isArray(val)) {
                        return jQuery.map(val, function (val) {
                            return {name: elem.name, value: val.replace(rCRLF, "\r\n")};
                        });
                    }

                    return {name: elem.name, value: val.replace(rCRLF, "\r\n")};
                }).get();
        }
    });


    jQuery.fn.extend({
        wrapAll: function (html) {
            var wrap;

            if (this[0]) {
                if (isFunction(html)) {
                    html = html.call(this[0]);
                }

                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

                if (this[0].parentNode) {
                    wrap.insertBefore(this[0]);
                }

                wrap.map(function () {
                    var elem = this;

                    while (elem.firstElementChild) {
                        elem = elem.firstElementChild;
                    }

                    return elem;
                }).append(this);
            }

            return this;
        },

        wrapInner: function (html) {
            if (isFunction(html)) {
                return this.each(function (i) {
                    jQuery(this).wrapInner(html.call(this, i));
                });
            }

            return this.each(function () {
                var self = jQuery(this),
                    contents = self.contents();

                if (contents.length) {
                    contents.wrapAll(html);

                } else {
                    self.append(html);
                }
            });
        },

        wrap: function (html) {
            var htmlIsFunction = isFunction(html);

            return this.each(function (i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },

        unwrap: function (selector) {
            this.parent(selector).not("body").each(function () {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });


    jQuery.expr.pseudos.hidden = function (elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function (elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };


    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = (function () {
        var body = document$1.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    })();


    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function (data, context, keepScripts) {
        if (typeof data !== "string") {
            return [];
        }
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }

        var base, parsed, scripts;

        if (!context) {

            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document$1.implementation.createHTMLDocument("");

                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document$1.location.href;
                context.head.appendChild(base);
            } else {
                context = document$1;
            }
        }

        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];

        // Single tag
        if (parsed) {
            return [context.createElement(parsed[1])];
        }

        parsed = buildFragment([data], context, scripts);

        if (scripts && scripts.length) {
            jQuery(scripts).remove();
        }

        return jQuery.merge([], parsed.childNodes);
    };


    jQuery.offset = {
        setOffset: function (elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
                position = jQuery.css(elem, "position"),
                curElem = jQuery(elem),
                props = {};

            // Set position first, in-case top/left are set even on static elem
            if (position === "static") {
                elem.style.position = "relative";
            }

            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") &&
                (curCSSTop + curCSSLeft).indexOf("auto") > -1;

            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;

            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }

            if (isFunction(options)) {

                // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
                options = options.call(elem, i, jQuery.extend({}, curOffset));
            }

            if (options.top != null) {
                props.top = (options.top - curOffset.top) + curTop;
            }
            if (options.left != null) {
                props.left = (options.left - curOffset.left) + curLeft;
            }

            if ("using" in options) {
                options.using.call(elem, props);

            } else {
                curElem.css(props);
            }
        }
    };

    jQuery.fn.extend({

        // offset() relates an element's border box to the document origin
        offset: function (options) {

            // Preserve chaining for setter
            if (arguments.length) {
                return options === undefined ?
                    this :
                    this.each(function (i) {
                        jQuery.offset.setOffset(this, options, i);
                    });
            }

            var rect, win,
                elem = this[0];

            if (!elem) {
                return;
            }

            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) {
                return {top: 0, left: 0};
            }

            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },

        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function () {
            if (!this[0]) {
                return;
            }

            var offsetParent, offset, doc,
                elem = this[0],
                parentOffset = {top: 0, left: 0};

            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") {

                // Assume position:fixed implies availability of getBoundingClientRect
                offset = elem.getBoundingClientRect();

            } else {
                offset = this.offset();

                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while (offsetParent &&
                (offsetParent === doc.body || offsetParent === doc.documentElement) &&
                jQuery.css(offsetParent, "position") === "static") {

                    offsetParent = offsetParent.parentNode;
                }
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {

                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }

            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },

        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function () {
            return this.map(function () {
                var offsetParent = this.offsetParent;

                while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
                    offsetParent = offsetParent.offsetParent;
                }

                return offsetParent || documentElement;
            });
        }
    });

    // Create scrollLeft and scrollTop methods
    jQuery.each({scrollLeft: "pageXOffset", scrollTop: "pageYOffset"}, function (method, prop) {
        var top = "pageYOffset" === prop;

        jQuery.fn[method] = function (val) {
            return access(this, function (elem, method, val) {

                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) {
                    win = elem;
                } else if (elem.nodeType === 9) {
                    win = elem.defaultView;
                }

                if (val === undefined) {
                    return win ? win[prop] : elem[method];
                }

                if (win) {
                    win.scrollTo(
                        !top ? val : win.pageXOffset,
                        top ? val : win.pageYOffset
                    );

                } else {
                    elem[method] = val;
                }
            }, method, val, arguments.length);
        };
    });

    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each(["top", "left"], function (i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition,
            function (elem, computed) {
                if (computed) {
                    computed = curCSS(elem, prop);

                    // If curCSS returns percentage, fallback to offset
                    return rnumnonpx.test(computed) ?
                        jQuery(elem).position()[prop] + "px" :
                        computed;
                }
            }
        );
    });


    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({Height: "height", Width: "width"}, function (name, type) {
        jQuery.each({padding: "inner" + name, content: type, "": "outer" + name},
            function (defaultExtra, funcName) {

                // Margin is only for outerHeight, outerWidth
                jQuery.fn[funcName] = function (margin, value) {
                    var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
                        extra = defaultExtra || (margin === true || value === true ? "margin" : "border");

                    return access(this, function (elem, type, value) {
                        var doc;

                        if (isWindow(elem)) {

                            // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                            return funcName.indexOf("outer") === 0 ?
                                elem["inner" + name] :
                                elem.document.documentElement["client" + name];
                        }

                        // Get document width or height
                        if (elem.nodeType === 9) {
                            doc = elem.documentElement;

                            // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                            // whichever is greatest
                            return Math.max(
                                elem.body["scroll" + name], doc["scroll" + name],
                                elem.body["offset" + name], doc["offset" + name],
                                doc["client" + name]
                            );
                        }

                        return value === undefined ?

                            // Get width or height on the element, requesting but not forcing parseFloat
                            jQuery.css(elem, type, extra) :

                            // Set width or height on the element
                            jQuery.style(elem, type, value, extra);
                    }, type, chainable ? margin : undefined, chainable);
                };
            });
    });


    jQuery.each(("blur focus focusin focusout resize scroll click dblclick " +
        "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
        "change select submit keydown keypress keyup contextmenu").split(" "),
        function (i, name) {

            // Handle event binding
            jQuery.fn[name] = function (data, fn) {
                return arguments.length > 0 ?
                    this.on(name, null, data, fn) :
                    this.trigger(name);
            };
        });

    jQuery.fn.extend({
        hover: function (fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });


    jQuery.fn.extend({

        bind: function (types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function (types, fn) {
            return this.off(types, null, fn);
        },

        delegate: function (selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function (selector, types, fn) {

            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ?
                this.off(selector, "**") :
                this.off(types, selector || "**", fn);
        }
    });

    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function (fn, context) {
        var tmp, args, proxy;

        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }

        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) {
            return undefined;
        }

        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function () {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };

        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;

        return proxy;
    };

    jQuery.holdReady = function (hold) {
        if (hold) {
            jQuery.readyWait++;
        } else {
            jQuery.ready(true);
        }
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;

    jQuery.now = Date.now;

    jQuery.isNumeric = function (obj) {

        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") &&

            // parseFloat NaNs numeric-cast false positives ("")
            // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
            // subtraction forces infinities to NaN
            !isNaN(obj - parseFloat(obj));
    };

    const $$1 = jQuery;

    function div(options) {
        return create$1("div", options);
    }

    function create$1(tag, options) {
        const elem = document.createElement(tag);
        if (options) {
            if (options.class) {
                elem.classList.add(options.class);
            }
            if (options.id) {
                elem.id = options.id;
            }
            if(options.style) {
                applyStyle(elem, options.style);
            }
        }
        return elem;
    }

    function hide(elem) {
        const cssStyle = getComputedStyle(elem);
        if(cssStyle.display !== "none") {
            elem._initialDisplay = cssStyle.display;
        }
        elem.style.display = "none";
    }

    function show(elem) {
        const currentDisplay = getComputedStyle(elem).display;
        if (currentDisplay === "none") {
            const d = elem._initialDisplay || "block";
            elem.style.display = d;
        }
    }

    function hideAll(selector) {
        document.querySelectorAll(selector).forEach(elem => { hide(elem); });
    }

    function empty(elem) {
        while(elem.firstChild){
            elem.removeChild(elem.firstChild);
        }
    }

    function offset(elem) {
        // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
        // Support: IE <=11 only
        // Running getBoundingClientRect on a
        // disconnected node in IE throws an error
        if (!elem.getClientRects().length) {
            return {top: 0, left: 0};
        }

        // Get document-relative position by adding viewport scroll to viewport-relative gBCR
        const rect = elem.getBoundingClientRect();
        const win = elem.ownerDocument.defaultView;
        return {
            top: rect.top + win.pageYOffset,
            left: rect.left + win.pageXOffset
        };
    }

    function pageCoordinates(e) {

        if (e.type.startsWith("touch")) {
            const touch = e.touches[0];
            return {x: touch.pageX, y: touch.pageY};
        } else {
            return {x: e.pageX, y: e.pageY}
        }
    }

    const relativeDOMBBox = (parentElement, childElement) => {
        const { x: x_p, y: y_p, width: width_p, height: height_p } = parentElement.getBoundingClientRect();
        const { x: x_c, y: y_c, width: width_c, height: height_c } = childElement.getBoundingClientRect();
        return { x: (x_c - x_p), y: (y_c - y_p), width: width_c, height:height_c };
    };

    function applyStyle(elem, style) {
        for (let key of Object.keys(style)) {
            elem.style[key] = style[key];
        }
    }

    function guid$2  () {
        return ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
    }

    let getMouseXY = (domElement, { clientX, clientY }) => {

        // DOMRect object with eight properties: left, top, right, bottom, x, y, width, height
        const { left, top, width, height } = domElement.getBoundingClientRect();

        const x = clientX - left;
        const y = clientY - top;
        return { x, y, xNormalized: x/width, yNormalized: y/height, width, height };

    };

    /**
     * Translate the mouse coordinates for the event to the coordinates for the given target element
     * @param event
     * @param domElement
     * @returns {{x: number, y: number}}
     */
    function translateMouseCoordinates(event, domElement) {

        const { clientX, clientY } = event;
        return getMouseXY(domElement, { clientX, clientY });

    }

    var domUtils = /*#__PURE__*/Object.freeze({
        __proto__: null,
        applyStyle: applyStyle,
        create: create$1,
        div: div,
        empty: empty,
        guid: guid$2,
        hide: hide,
        hideAll: hideAll,
        offset: offset,
        pageCoordinates: pageCoordinates,
        relativeDOMBBox: relativeDOMBBox,
        show: show,
        translateMouseCoordinates: translateMouseCoordinates
    });

    /*! @license DOMPurify 3.0.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.0.5/LICENSE */

    const {
      entries,
      setPrototypeOf,
      isFrozen,
      getPrototypeOf,
      getOwnPropertyDescriptor
    } = Object;
    let {
      freeze,
      seal,
      create
    } = Object; // eslint-disable-line import/no-mutable-exports

    let {
      apply,
      construct
    } = typeof Reflect !== 'undefined' && Reflect;

    if (!apply) {
      apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
      };
    }

    if (!freeze) {
      freeze = function freeze(x) {
        return x;
      };
    }

    if (!seal) {
      seal = function seal(x) {
        return x;
      };
    }

    if (!construct) {
      construct = function construct(Func, args) {
        return new Func(...args);
      };
    }

    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
      return function (thisArg) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return apply(func, thisArg, args);
      };
    }
    function unconstruct(func) {
      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return construct(func, args);
      };
    }
    /* Add properties to a lookup table */

    function addToSet(set, array, transformCaseFunc) {
      var _transformCaseFunc;

      transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;

      if (setPrototypeOf) {
        // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
      }

      let l = array.length;

      while (l--) {
        let element = array[l];

        if (typeof element === 'string') {
          const lcElement = transformCaseFunc(element);

          if (lcElement !== element) {
            // Config presets (e.g. tags.js, attrs.js) are immutable.
            if (!isFrozen(array)) {
              array[l] = lcElement;
            }

            element = lcElement;
          }
        }

        set[element] = true;
      }

      return set;
    }
    /* Shallow clone an object */

    function clone(object) {
      const newObject = create(null);

      for (const [property, value] of entries(object)) {
        newObject[property] = value;
      }

      return newObject;
    }
    /* This method automatically checks if the prop is function
     * or getter and behaves accordingly. */

    function lookupGetter(object, prop) {
      while (object !== null) {
        const desc = getOwnPropertyDescriptor(object, prop);

        if (desc) {
          if (desc.get) {
            return unapply(desc.get);
          }

          if (typeof desc.value === 'function') {
            return unapply(desc.value);
          }
        }

        object = getPrototypeOf(object);
      }

      function fallbackValue(element) {
        console.warn('fallback value for', element);
        return null;
      }

      return fallbackValue;
    }

    const html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

    const svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
    const svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.

    const svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
    const mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover', 'mprescripts']); // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.

    const mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
    const text = freeze(['#text']);

    const html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
    const svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
    const mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
    const xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);

    var EXPRESSIONS = /*#__PURE__*/Object.freeze({
      __proto__: null,
      MUSTACHE_EXPR: MUSTACHE_EXPR,
      ERB_EXPR: ERB_EXPR,
      TMPLIT_EXPR: TMPLIT_EXPR,
      DATA_ATTR: DATA_ATTR,
      ARIA_ATTR: ARIA_ATTR,
      IS_ALLOWED_URI: IS_ALLOWED_URI,
      IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
      ATTR_WHITESPACE: ATTR_WHITESPACE,
      DOCTYPE_NAME: DOCTYPE_NAME
    });

    const getGlobal = () => typeof window === 'undefined' ? null : window;
    /**
     * Creates a no-op policy for internal use only.
     * Don't export this function outside this module!
     * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
     * @param {HTMLScriptElement} purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
     * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
     * are not supported or creating the policy failed).
     */


    const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
      if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
        return null;
      } // Allow the callers to control the unique policy name
      // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
      // Policy creation with duplicate names throws in Trusted Types.


      let suffix = null;
      const ATTR_NAME = 'data-tt-policy-suffix';

      if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
        suffix = purifyHostElement.getAttribute(ATTR_NAME);
      }

      const policyName = 'dompurify' + (suffix ? '#' + suffix : '');

      try {
        return trustedTypes.createPolicy(policyName, {
          createHTML(html) {
            return html;
          },

          createScriptURL(scriptUrl) {
            return scriptUrl;
          }

        });
      } catch (_) {
        // Policy creation failed (most likely another DOMPurify script has
        // already run). Skip creating the policy, as this will only cause errors
        // if TT are enforced.
        console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
        return null;
      }
    };

    function createDOMPurify() {
      let window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

      const DOMPurify = root => createDOMPurify(root);
      /**
       * Version label, exposed for easier checks
       * if DOMPurify is up to date or not
       */


      DOMPurify.version = '3.0.5';
      /**
       * Array of elements that DOMPurify removed during sanitation.
       * Empty if nothing was removed.
       */

      DOMPurify.removed = [];

      if (!window || !window.document || window.document.nodeType !== 9) {
        // Not running in a browser, provide a factory function
        // so that you can pass your own Window
        DOMPurify.isSupported = false;
        return DOMPurify;
      }

      const originalDocument = window.document;
      const currentScript = originalDocument.currentScript;
      let {
        document
      } = window;
      const {
        DocumentFragment,
        HTMLTemplateElement,
        Node,
        Element,
        NodeFilter,
        NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap,
        HTMLFormElement,
        DOMParser,
        trustedTypes
      } = window;
      const ElementPrototype = Element.prototype;
      const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
      const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
      const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
      const getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
      // new document created via createHTMLDocument. As per the spec
      // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
      // a new empty registry is used when creating a template contents owner
      // document, so we use that as our parent document to ensure nothing
      // is inherited.

      if (typeof HTMLTemplateElement === 'function') {
        const template = document.createElement('template');

        if (template.content && template.content.ownerDocument) {
          document = template.content.ownerDocument;
        }
      }

      let trustedTypesPolicy;
      let emptyHTML = '';
      const {
        implementation,
        createNodeIterator,
        createDocumentFragment,
        getElementsByTagName
      } = document;
      const {
        importNode
      } = originalDocument;
      let hooks = {};
      /**
       * Expose whether this browser supports running the full DOMPurify.
       */

      DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
      const {
        MUSTACHE_EXPR,
        ERB_EXPR,
        TMPLIT_EXPR,
        DATA_ATTR,
        ARIA_ATTR,
        IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE
      } = EXPRESSIONS;
      let {
        IS_ALLOWED_URI: IS_ALLOWED_URI$1
      } = EXPRESSIONS;
      /**
       * We consider the elements and attributes below to be safe. Ideally
       * don't add any new ones but feel free to remove unwanted ones.
       */

      /* allowed element names */

      let ALLOWED_TAGS = null;
      const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...text]);
      /* Allowed attribute names */

      let ALLOWED_ATTR = null;
      const DEFAULT_ALLOWED_ATTR = addToSet({}, [...html, ...svg, ...mathMl, ...xml]);
      /*
       * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
       * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
       * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
       * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
       */

      let CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
        tagNameCheck: {
          writable: true,
          configurable: false,
          enumerable: true,
          value: null
        },
        attributeNameCheck: {
          writable: true,
          configurable: false,
          enumerable: true,
          value: null
        },
        allowCustomizedBuiltInElements: {
          writable: true,
          configurable: false,
          enumerable: true,
          value: false
        }
      }));
      /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

      let FORBID_TAGS = null;
      /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

      let FORBID_ATTR = null;
      /* Decide if ARIA attributes are okay */

      let ALLOW_ARIA_ATTR = true;
      /* Decide if custom data attributes are okay */

      let ALLOW_DATA_ATTR = true;
      /* Decide if unknown protocols are okay */

      let ALLOW_UNKNOWN_PROTOCOLS = false;
      /* Decide if self-closing tags in attributes are allowed.
       * Usually removed due to a mXSS issue in jQuery 3.0 */

      let ALLOW_SELF_CLOSE_IN_ATTR = true;
      /* Output should be safe for common template engines.
       * This means, DOMPurify removes data attributes, mustaches and ERB
       */

      let SAFE_FOR_TEMPLATES = false;
      /* Decide if document with <html>... should be returned */

      let WHOLE_DOCUMENT = false;
      /* Track whether config is already set on this instance of DOMPurify. */

      let SET_CONFIG = false;
      /* Decide if all elements (e.g. style, script) must be children of
       * document.body. By default, browsers might move them to document.head */

      let FORCE_BODY = false;
      /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
       * string (or a TrustedHTML object if Trusted Types are supported).
       * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
       */

      let RETURN_DOM = false;
      /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
       * string  (or a TrustedHTML object if Trusted Types are supported) */

      let RETURN_DOM_FRAGMENT = false;
      /* Try to return a Trusted Type object instead of a string, return a string in
       * case Trusted Types are not supported  */

      let RETURN_TRUSTED_TYPE = false;
      /* Output should be free from DOM clobbering attacks?
       * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
       */

      let SANITIZE_DOM = true;
      /* Achieve full DOM Clobbering protection by isolating the namespace of named
       * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
       *
       * HTML/DOM spec rules that enable DOM Clobbering:
       *   - Named Access on Window (§7.3.3)
       *   - DOM Tree Accessors (§3.1.5)
       *   - Form Element Parent-Child Relations (§4.10.3)
       *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
       *   - HTMLCollection (§4.2.10.2)
       *
       * Namespace isolation is implemented by prefixing `id` and `name` attributes
       * with a constant string, i.e., `user-content-`
       */

      let SANITIZE_NAMED_PROPS = false;
      const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
      /* Keep element content when removing element? */

      let KEEP_CONTENT = true;
      /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
       * of importing it into a new Document and returning a sanitized copy */

      let IN_PLACE = false;
      /* Allow usage of profiles like html, svg and mathMl */

      let USE_PROFILES = {};
      /* Tags to ignore content of when KEEP_CONTENT is true */

      let FORBID_CONTENTS = null;
      const DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
      /* Tags that are safe for data: URIs */

      let DATA_URI_TAGS = null;
      const DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
      /* Attributes safe for values like "javascript:" */

      let URI_SAFE_ATTRIBUTES = null;
      const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
      const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
      const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
      const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
      /* Document namespace */

      let NAMESPACE = HTML_NAMESPACE;
      let IS_EMPTY_INPUT = false;
      /* Allowed XHTML+XML namespaces */

      let ALLOWED_NAMESPACES = null;
      const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
      /* Parsing of strict XHTML documents */

      let PARSER_MEDIA_TYPE;
      const SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
      const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
      let transformCaseFunc;
      /* Keep a reference to config to pass to hooks */

      let CONFIG = null;
      /* Ideally, do not touch anything below this line */

      /* ______________________________________________ */

      const formElement = document.createElement('form');

      const isRegexOrFunction = function isRegexOrFunction(testValue) {
        return testValue instanceof RegExp || testValue instanceof Function;
      };
      /**
       * _parseConfig
       *
       * @param  {Object} cfg optional config literal
       */
      // eslint-disable-next-line complexity


      const _parseConfig = function _parseConfig(cfg) {
        if (CONFIG && CONFIG === cfg) {
          return;
        }
        /* Shield configuration object from tampering */


        if (!cfg || typeof cfg !== 'object') {
          cfg = {};
        }
        /* Shield configuration object from prototype pollution */


        cfg = clone(cfg);
        PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
        SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

        transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
        /* Set configuration parameters */

        ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
        ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
        ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
        URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
        cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
        transformCaseFunc // eslint-disable-line indent
        ) // eslint-disable-line indent
        : DEFAULT_URI_SAFE_ATTRIBUTES;
        DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
        cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
        transformCaseFunc // eslint-disable-line indent
        ) // eslint-disable-line indent
        : DEFAULT_DATA_URI_TAGS;
        FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
        FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
        FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
        USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true

        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

        RETURN_DOM = cfg.RETURN_DOM || false; // Default false

        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

        FORCE_BODY = cfg.FORCE_BODY || false; // Default false

        SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

        KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

        IN_PLACE = cfg.IN_PLACE || false; // Default false

        IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
        NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
        CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};

        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
          CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
        }

        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
          CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
        }

        if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
          CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
        }

        if (SAFE_FOR_TEMPLATES) {
          ALLOW_DATA_ATTR = false;
        }

        if (RETURN_DOM_FRAGMENT) {
          RETURN_DOM = true;
        }
        /* Parse profile info */


        if (USE_PROFILES) {
          ALLOWED_TAGS = addToSet({}, [...text]);
          ALLOWED_ATTR = [];

          if (USE_PROFILES.html === true) {
            addToSet(ALLOWED_TAGS, html$1);
            addToSet(ALLOWED_ATTR, html);
          }

          if (USE_PROFILES.svg === true) {
            addToSet(ALLOWED_TAGS, svg$1);
            addToSet(ALLOWED_ATTR, svg);
            addToSet(ALLOWED_ATTR, xml);
          }

          if (USE_PROFILES.svgFilters === true) {
            addToSet(ALLOWED_TAGS, svgFilters);
            addToSet(ALLOWED_ATTR, svg);
            addToSet(ALLOWED_ATTR, xml);
          }

          if (USE_PROFILES.mathMl === true) {
            addToSet(ALLOWED_TAGS, mathMl$1);
            addToSet(ALLOWED_ATTR, mathMl);
            addToSet(ALLOWED_ATTR, xml);
          }
        }
        /* Merge configuration parameters */


        if (cfg.ADD_TAGS) {
          if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
            ALLOWED_TAGS = clone(ALLOWED_TAGS);
          }

          addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
        }

        if (cfg.ADD_ATTR) {
          if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
            ALLOWED_ATTR = clone(ALLOWED_ATTR);
          }

          addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
        }

        if (cfg.ADD_URI_SAFE_ATTR) {
          addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
        }

        if (cfg.FORBID_CONTENTS) {
          if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
            FORBID_CONTENTS = clone(FORBID_CONTENTS);
          }

          addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
        }
        /* Add #text in case KEEP_CONTENT is set to true */


        if (KEEP_CONTENT) {
          ALLOWED_TAGS['#text'] = true;
        }
        /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


        if (WHOLE_DOCUMENT) {
          addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
        }
        /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


        if (ALLOWED_TAGS.table) {
          addToSet(ALLOWED_TAGS, ['tbody']);
          delete FORBID_TAGS.tbody;
        }

        if (cfg.TRUSTED_TYPES_POLICY) {
          if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') {
            throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
          }

          if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') {
            throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
          } // Overwrite existing TrustedTypes policy.


          trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY; // Sign local variables required by `sanitize`.

          emptyHTML = trustedTypesPolicy.createHTML('');
        } else {
          // Uninitialized policy, attempt to initialize the internal dompurify policy.
          if (trustedTypesPolicy === undefined) {
            trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
          } // If creating the internal policy succeeded sign internal variables.


          if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') {
            emptyHTML = trustedTypesPolicy.createHTML('');
          }
        } // Prevent further manipulation of configuration.
        // Not available in IE8, Safari 5, etc.


        if (freeze) {
          freeze(cfg);
        }

        CONFIG = cfg;
      };

      const MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
      const HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
      // namespace. We need to specify them explicitly
      // so that they don't get erroneously deleted from
      // HTML namespace.

      const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
      /* Keep track of all possible SVG and MathML tags
       * so that we can perform the namespace checks
       * correctly. */

      const ALL_SVG_TAGS = addToSet({}, svg$1);
      addToSet(ALL_SVG_TAGS, svgFilters);
      addToSet(ALL_SVG_TAGS, svgDisallowed);
      const ALL_MATHML_TAGS = addToSet({}, mathMl$1);
      addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
      /**
       *
       *
       * @param  {Element} element a DOM element whose namespace is being checked
       * @returns {boolean} Return false if the element has a
       *  namespace that a spec-compliant parser would never
       *  return. Return true otherwise.
       */

      const _checkValidNamespace = function _checkValidNamespace(element) {
        let parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
        // can be null. We just simulate parent in this case.

        if (!parent || !parent.tagName) {
          parent = {
            namespaceURI: NAMESPACE,
            tagName: 'template'
          };
        }

        const tagName = stringToLowerCase(element.tagName);
        const parentTagName = stringToLowerCase(parent.tagName);

        if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
          return false;
        }

        if (element.namespaceURI === SVG_NAMESPACE) {
          // The only way to switch from HTML namespace to SVG
          // is via <svg>. If it happens via any other tag, then
          // it should be killed.
          if (parent.namespaceURI === HTML_NAMESPACE) {
            return tagName === 'svg';
          } // The only way to switch from MathML to SVG is via`
          // svg if parent is either <annotation-xml> or MathML
          // text integration points.


          if (parent.namespaceURI === MATHML_NAMESPACE) {
            return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
          } // We only allow elements that are defined in SVG
          // spec. All others are disallowed in SVG namespace.


          return Boolean(ALL_SVG_TAGS[tagName]);
        }

        if (element.namespaceURI === MATHML_NAMESPACE) {
          // The only way to switch from HTML namespace to MathML
          // is via <math>. If it happens via any other tag, then
          // it should be killed.
          if (parent.namespaceURI === HTML_NAMESPACE) {
            return tagName === 'math';
          } // The only way to switch from SVG to MathML is via
          // <math> and HTML integration points


          if (parent.namespaceURI === SVG_NAMESPACE) {
            return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
          } // We only allow elements that are defined in MathML
          // spec. All others are disallowed in MathML namespace.


          return Boolean(ALL_MATHML_TAGS[tagName]);
        }

        if (element.namespaceURI === HTML_NAMESPACE) {
          // The only way to switch from SVG to HTML is via
          // HTML integration points, and from MathML to HTML
          // is via MathML text integration points
          if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
            return false;
          }

          if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
            return false;
          } // We disallow tags that are specific for MathML
          // or SVG and should never appear in HTML namespace


          return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
        } // For XHTML and XML documents that support custom namespaces


        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
          return true;
        } // The code should never reach this place (this means
        // that the element somehow got namespace that is not
        // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
        // Return false just in case.


        return false;
      };
      /**
       * _forceRemove
       *
       * @param  {Node} node a DOM node
       */


      const _forceRemove = function _forceRemove(node) {
        arrayPush(DOMPurify.removed, {
          element: node
        });

        try {
          // eslint-disable-next-line unicorn/prefer-dom-node-remove
          node.parentNode.removeChild(node);
        } catch (_) {
          node.remove();
        }
      };
      /**
       * _removeAttribute
       *
       * @param  {String} name an Attribute name
       * @param  {Node} node a DOM node
       */


      const _removeAttribute = function _removeAttribute(name, node) {
        try {
          arrayPush(DOMPurify.removed, {
            attribute: node.getAttributeNode(name),
            from: node
          });
        } catch (_) {
          arrayPush(DOMPurify.removed, {
            attribute: null,
            from: node
          });
        }

        node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

        if (name === 'is' && !ALLOWED_ATTR[name]) {
          if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
            try {
              _forceRemove(node);
            } catch (_) {}
          } else {
            try {
              node.setAttribute(name, '');
            } catch (_) {}
          }
        }
      };
      /**
       * _initDocument
       *
       * @param  {String} dirty a string of dirty markup
       * @return {Document} a DOM, filled with the dirty markup
       */


      const _initDocument = function _initDocument(dirty) {
        /* Create a HTML document */
        let doc;
        let leadingWhitespace;

        if (FORCE_BODY) {
          dirty = '<remove></remove>' + dirty;
        } else {
          /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
          const matches = stringMatch(dirty, /^[\r\n\t ]+/);
          leadingWhitespace = matches && matches[0];
        }

        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
          // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
          dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
        }

        const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
        /*
         * Use the DOMParser API by default, fallback later if needs be
         * DOMParser not work for svg when has multiple root element.
         */

        if (NAMESPACE === HTML_NAMESPACE) {
          try {
            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
          } catch (_) {}
        }
        /* Use createHTMLDocument in case DOMParser is not available */


        if (!doc || !doc.documentElement) {
          doc = implementation.createDocument(NAMESPACE, 'template', null);

          try {
            doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
          } catch (_) {// Syntax error if dirtyPayload is invalid xml
          }
        }

        const body = doc.body || doc.documentElement;

        if (dirty && leadingWhitespace) {
          body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
        }
        /* Work on whole document or just its body */


        if (NAMESPACE === HTML_NAMESPACE) {
          return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
        }

        return WHOLE_DOCUMENT ? doc.documentElement : body;
      };
      /**
       * _createIterator
       *
       * @param  {Document} root document/fragment to create iterator for
       * @return {Iterator} iterator instance
       */


      const _createIterator = function _createIterator(root) {
        return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
        NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
      };
      /**
       * _isClobbered
       *
       * @param  {Node} elm element to check for clobbering attacks
       * @return {Boolean} true if clobbered, false if safe
       */


      const _isClobbered = function _isClobbered(elm) {
        return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
      };
      /**
       * _isNode
       *
       * @param  {Node} obj object to check whether it's a DOM node
       * @return {Boolean} true is object is a DOM node
       */


      const _isNode = function _isNode(object) {
        return typeof Node === 'object' ? object instanceof Node : object && typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
      };
      /**
       * _executeHook
       * Execute user configurable hooks
       *
       * @param  {String} entryPoint  Name of the hook's entry point
       * @param  {Node} currentNode node to work on with the hook
       * @param  {Object} data additional hook parameters
       */


      const _executeHook = function _executeHook(entryPoint, currentNode, data) {
        if (!hooks[entryPoint]) {
          return;
        }

        arrayForEach(hooks[entryPoint], hook => {
          hook.call(DOMPurify, currentNode, data, CONFIG);
        });
      };
      /**
       * _sanitizeElements
       *
       * @protect nodeName
       * @protect textContent
       * @protect removeChild
       *
       * @param   {Node} currentNode to check for permission to exist
       * @return  {Boolean} true if node was killed, false if left alive
       */


      const _sanitizeElements = function _sanitizeElements(currentNode) {
        let content;
        /* Execute a hook if present */

        _executeHook('beforeSanitizeElements', currentNode, null);
        /* Check if element is clobbered or can clobber */


        if (_isClobbered(currentNode)) {
          _forceRemove(currentNode);

          return true;
        }
        /* Now let's check the element's type and name */


        const tagName = transformCaseFunc(currentNode.nodeName);
        /* Execute a hook if present */

        _executeHook('uponSanitizeElement', currentNode, {
          tagName,
          allowedTags: ALLOWED_TAGS
        });
        /* Detect mXSS attempts abusing namespace confusion */


        if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
          _forceRemove(currentNode);

          return true;
        }
        /* Remove element if anything forbids its presence */


        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          /* Check if we have a custom element to handle */
          if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
          }
          /* Keep content except for bad-listed elements */


          if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
            const parentNode = getParentNode(currentNode) || currentNode.parentNode;
            const childNodes = getChildNodes(currentNode) || currentNode.childNodes;

            if (childNodes && parentNode) {
              const childCount = childNodes.length;

              for (let i = childCount - 1; i >= 0; --i) {
                parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
              }
            }
          }

          _forceRemove(currentNode);

          return true;
        }
        /* Check whether element has a valid namespace */


        if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
          _forceRemove(currentNode);

          return true;
        }
        /* Make sure that older browsers don't get fallback-tag mXSS */


        if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
          _forceRemove(currentNode);

          return true;
        }
        /* Sanitize element content to be template-safe */


        if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
          /* Get the element's text content */
          content = currentNode.textContent;
          content = stringReplace(content, MUSTACHE_EXPR, ' ');
          content = stringReplace(content, ERB_EXPR, ' ');
          content = stringReplace(content, TMPLIT_EXPR, ' ');

          if (currentNode.textContent !== content) {
            arrayPush(DOMPurify.removed, {
              element: currentNode.cloneNode()
            });
            currentNode.textContent = content;
          }
        }
        /* Execute a hook if present */


        _executeHook('afterSanitizeElements', currentNode, null);

        return false;
      };
      /**
       * _isValidAttribute
       *
       * @param  {string} lcTag Lowercase tag name of containing element.
       * @param  {string} lcName Lowercase attribute name.
       * @param  {string} value Attribute value.
       * @return {Boolean} Returns true if `value` is valid, otherwise false.
       */
      // eslint-disable-next-line complexity


      const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
        /* Make sure attribute cannot clobber */
        if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
          return false;
        }
        /* Allow valid data-* attributes: At least one character after "-"
            (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
            XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
            We don't need to check the value; it's always URI safe. */


        if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
          if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
            return false;
          }
          /* Check value is safe. First, is attr inert? If so, is safe */

        } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ; else if (value) {
          return false;
        } else ;

        return true;
      };
      /**
       * _basicCustomElementCheck
       * checks if at least one dash is included in tagName, and it's not the first char
       * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
       * @param {string} tagName name of the tag of the node to sanitize
       */


      const _basicCustomElementTest = function _basicCustomElementTest(tagName) {
        return tagName.indexOf('-') > 0;
      };
      /**
       * _sanitizeAttributes
       *
       * @protect attributes
       * @protect nodeName
       * @protect removeAttribute
       * @protect setAttribute
       *
       * @param  {Node} currentNode to sanitize
       */


      const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
        let attr;
        let value;
        let lcName;
        let l;
        /* Execute a hook if present */

        _executeHook('beforeSanitizeAttributes', currentNode, null);

        const {
          attributes
        } = currentNode;
        /* Check if we have attributes; if not we might have a text node */

        if (!attributes) {
          return;
        }

        const hookEvent = {
          attrName: '',
          attrValue: '',
          keepAttr: true,
          allowedAttributes: ALLOWED_ATTR
        };
        l = attributes.length;
        /* Go backwards over all attributes; safely remove bad ones */

        while (l--) {
          attr = attributes[l];
          const {
            name,
            namespaceURI
          } = attr;
          value = name === 'value' ? attr.value : stringTrim(attr.value);
          lcName = transformCaseFunc(name);
          /* Execute a hook if present */

          hookEvent.attrName = lcName;
          hookEvent.attrValue = value;
          hookEvent.keepAttr = true;
          hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

          _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

          value = hookEvent.attrValue;
          /* Did the hooks approve of the attribute? */

          if (hookEvent.forceKeepAttr) {
            continue;
          }
          /* Remove attribute */


          _removeAttribute(name, currentNode);
          /* Did the hooks approve of the attribute? */


          if (!hookEvent.keepAttr) {
            continue;
          }
          /* Work around a security issue in jQuery 3.0 */


          if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
            _removeAttribute(name, currentNode);

            continue;
          }
          /* Sanitize attribute content to be template-safe */


          if (SAFE_FOR_TEMPLATES) {
            value = stringReplace(value, MUSTACHE_EXPR, ' ');
            value = stringReplace(value, ERB_EXPR, ' ');
            value = stringReplace(value, TMPLIT_EXPR, ' ');
          }
          /* Is `value` valid for this attribute? */


          const lcTag = transformCaseFunc(currentNode.nodeName);

          if (!_isValidAttribute(lcTag, lcName, value)) {
            continue;
          }
          /* Full DOM Clobbering protection via namespace isolation,
           * Prefix id and name attributes with `user-content-`
           */


          if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
            // Remove the attribute with this value
            _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


            value = SANITIZE_NAMED_PROPS_PREFIX + value;
          }
          /* Handle attributes that require Trusted Types */


          if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
            if (namespaceURI) ; else {
              switch (trustedTypes.getAttributeType(lcTag, lcName)) {
                case 'TrustedHTML':
                  {
                    value = trustedTypesPolicy.createHTML(value);
                    break;
                  }

                case 'TrustedScriptURL':
                  {
                    value = trustedTypesPolicy.createScriptURL(value);
                    break;
                  }
              }
            }
          }
          /* Handle invalid data-* attribute set by try-catching it */


          try {
            if (namespaceURI) {
              currentNode.setAttributeNS(namespaceURI, name, value);
            } else {
              /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
              currentNode.setAttribute(name, value);
            }

            arrayPop(DOMPurify.removed);
          } catch (_) {}
        }
        /* Execute a hook if present */


        _executeHook('afterSanitizeAttributes', currentNode, null);
      };
      /**
       * _sanitizeShadowDOM
       *
       * @param  {DocumentFragment} fragment to iterate over recursively
       */


      const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
        let shadowNode;

        const shadowIterator = _createIterator(fragment);
        /* Execute a hook if present */


        _executeHook('beforeSanitizeShadowDOM', fragment, null);

        while (shadowNode = shadowIterator.nextNode()) {
          /* Execute a hook if present */
          _executeHook('uponSanitizeShadowNode', shadowNode, null);
          /* Sanitize tags and elements */


          if (_sanitizeElements(shadowNode)) {
            continue;
          }
          /* Deep shadow DOM detected */


          if (shadowNode.content instanceof DocumentFragment) {
            _sanitizeShadowDOM(shadowNode.content);
          }
          /* Check attributes, sanitize if necessary */


          _sanitizeAttributes(shadowNode);
        }
        /* Execute a hook if present */


        _executeHook('afterSanitizeShadowDOM', fragment, null);
      };
      /**
       * Sanitize
       * Public method providing core sanitation functionality
       *
       * @param {String|Node} dirty string or DOM node
       * @param {Object} configuration object
       */
      // eslint-disable-next-line complexity


      DOMPurify.sanitize = function (dirty) {
        let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let body;
        let importedNode;
        let currentNode;
        let returnNode;
        /* Make sure we have a string to sanitize.
          DO NOT return early, as this will return the wrong type if
          the user has requested a DOM object rather than a string */

        IS_EMPTY_INPUT = !dirty;

        if (IS_EMPTY_INPUT) {
          dirty = '<!-->';
        }
        /* Stringify, in case dirty is an object */


        if (typeof dirty !== 'string' && !_isNode(dirty)) {
          if (typeof dirty.toString === 'function') {
            dirty = dirty.toString();

            if (typeof dirty !== 'string') {
              throw typeErrorCreate('dirty is not a string, aborting');
            }
          } else {
            throw typeErrorCreate('toString is not a function');
          }
        }
        /* Return dirty HTML if DOMPurify cannot run */


        if (!DOMPurify.isSupported) {
          return dirty;
        }
        /* Assign config vars */


        if (!SET_CONFIG) {
          _parseConfig(cfg);
        }
        /* Clean up removed elements */


        DOMPurify.removed = [];
        /* Check if dirty is correctly typed for IN_PLACE */

        if (typeof dirty === 'string') {
          IN_PLACE = false;
        }

        if (IN_PLACE) {
          /* Do some early pre-sanitization to avoid unsafe root nodes */
          if (dirty.nodeName) {
            const tagName = transformCaseFunc(dirty.nodeName);

            if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
              throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
            }
          }
        } else if (dirty instanceof Node) {
          /* If dirty is a DOM element, append to an empty document to avoid
             elements being stripped by the parser */
          body = _initDocument('<!---->');
          importedNode = body.ownerDocument.importNode(dirty, true);

          if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
            /* Node is already a body, use as is */
            body = importedNode;
          } else if (importedNode.nodeName === 'HTML') {
            body = importedNode;
          } else {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            body.appendChild(importedNode);
          }
        } else {
          /* Exit directly if we have nothing to do */
          if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
          dirty.indexOf('<') === -1) {
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
          }
          /* Initialize the document to work on */


          body = _initDocument(dirty);
          /* Check we have a DOM node from the data */

          if (!body) {
            return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
          }
        }
        /* Remove first element node (ours) if FORCE_BODY is set */


        if (body && FORCE_BODY) {
          _forceRemove(body.firstChild);
        }
        /* Get node iterator */


        const nodeIterator = _createIterator(IN_PLACE ? dirty : body);
        /* Now start iterating over the created document */


        while (currentNode = nodeIterator.nextNode()) {
          /* Sanitize tags and elements */
          if (_sanitizeElements(currentNode)) {
            continue;
          }
          /* Shadow DOM detected, sanitize it */


          if (currentNode.content instanceof DocumentFragment) {
            _sanitizeShadowDOM(currentNode.content);
          }
          /* Check attributes, sanitize if necessary */


          _sanitizeAttributes(currentNode);
        }
        /* If we sanitized `dirty` in-place, return it. */


        if (IN_PLACE) {
          return dirty;
        }
        /* Return sanitized string or DOM */


        if (RETURN_DOM) {
          if (RETURN_DOM_FRAGMENT) {
            returnNode = createDocumentFragment.call(body.ownerDocument);

            while (body.firstChild) {
              // eslint-disable-next-line unicorn/prefer-dom-node-append
              returnNode.appendChild(body.firstChild);
            }
          } else {
            returnNode = body;
          }

          if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) {
            /*
              AdoptNode() is not used because internal state is not reset
              (e.g. the past names map of a HTMLFormElement), this is safe
              in theory but we would rather not risk another attack vector.
              The state that is cloned by importNode() is explicitly defined
              by the specs.
            */
            returnNode = importNode.call(originalDocument, returnNode, true);
          }

          return returnNode;
        }

        let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
        /* Serialize doctype if allowed */

        if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
          serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
        }
        /* Sanitize final string template-safe */


        if (SAFE_FOR_TEMPLATES) {
          serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR, ' ');
          serializedHTML = stringReplace(serializedHTML, ERB_EXPR, ' ');
          serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR, ' ');
        }

        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
      };
      /**
       * Public method to set the configuration once
       * setConfig
       *
       * @param {Object} cfg configuration object
       */


      DOMPurify.setConfig = function (cfg) {
        _parseConfig(cfg);

        SET_CONFIG = true;
      };
      /**
       * Public method to remove the configuration
       * clearConfig
       *
       */


      DOMPurify.clearConfig = function () {
        CONFIG = null;
        SET_CONFIG = false;
      };
      /**
       * Public method to check if an attribute value is valid.
       * Uses last set config, if any. Otherwise, uses config defaults.
       * isValidAttribute
       *
       * @param  {string} tag Tag name of containing element.
       * @param  {string} attr Attribute name.
       * @param  {string} value Attribute value.
       * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
       */


      DOMPurify.isValidAttribute = function (tag, attr, value) {
        /* Initialize shared config vars if necessary. */
        if (!CONFIG) {
          _parseConfig({});
        }

        const lcTag = transformCaseFunc(tag);
        const lcName = transformCaseFunc(attr);
        return _isValidAttribute(lcTag, lcName, value);
      };
      /**
       * AddHook
       * Public method to add DOMPurify hooks
       *
       * @param {String} entryPoint entry point for the hook to add
       * @param {Function} hookFunction function to execute
       */


      DOMPurify.addHook = function (entryPoint, hookFunction) {
        if (typeof hookFunction !== 'function') {
          return;
        }

        hooks[entryPoint] = hooks[entryPoint] || [];
        arrayPush(hooks[entryPoint], hookFunction);
      };
      /**
       * RemoveHook
       * Public method to remove a DOMPurify hook at a given entryPoint
       * (pops it from the stack of hooks if more are present)
       *
       * @param {String} entryPoint entry point for the hook to remove
       * @return {Function} removed(popped) hook
       */


      DOMPurify.removeHook = function (entryPoint) {
        if (hooks[entryPoint]) {
          return arrayPop(hooks[entryPoint]);
        }
      };
      /**
       * RemoveHooks
       * Public method to remove all DOMPurify hooks at a given entryPoint
       *
       * @param  {String} entryPoint entry point for the hooks to remove
       */


      DOMPurify.removeHooks = function (entryPoint) {
        if (hooks[entryPoint]) {
          hooks[entryPoint] = [];
        }
      };
      /**
       * RemoveAllHooks
       * Public method to remove all DOMPurify hooks
       *
       */


      DOMPurify.removeAllHooks = function () {
        hooks = {};
      };

      return DOMPurify;
    }

    var purify = createDOMPurify();

    function createCheckbox$1(name, initialState) {
        const container = div({class: 'igv-ui-trackgear-popover-check-container'});
        const svg = iconMarkup('check', (true === initialState ? '#444' : 'transparent'));
        svg.style.borderColor = 'gray';
        svg.style.borderWidth = '1px';
        svg.style.borderStyle = 'solid';

        container.appendChild(svg);
        let label = div(); //{ class: 'igv-some-label-class' });
        label.textContent = name;
        container.appendChild(label);

        return container;
    }

    function createIcon(name, color) {
        return iconMarkup(name, color);
    }

    function iconMarkup(name, color) {
        color = color || "currentColor";
        let icon = icons[name];
        if (!icon) {
            console.error(`No icon named: ${name}`);
            icon = icons["question"];
        }

        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttributeNS(null,'viewBox', '0 0 ' + icon[0] + ' ' + icon[1]);
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttributeNS(null,'fill',  color );
        path.setAttributeNS(null,'d', icon[4]);
        svg.appendChild(path);
        return svg;
    }

    const icons = {
        "check": [512, 512, [], "f00c", "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"],
        "cog": [512, 512, [], "f013", "M444.788 291.1l42.616 24.599c4.867 2.809 7.126 8.618 5.459 13.985-11.07 35.642-29.97 67.842-54.689 94.586a12.016 12.016 0 0 1-14.832 2.254l-42.584-24.595a191.577 191.577 0 0 1-60.759 35.13v49.182a12.01 12.01 0 0 1-9.377 11.718c-34.956 7.85-72.499 8.256-109.219.007-5.49-1.233-9.403-6.096-9.403-11.723v-49.184a191.555 191.555 0 0 1-60.759-35.13l-42.584 24.595a12.016 12.016 0 0 1-14.832-2.254c-24.718-26.744-43.619-58.944-54.689-94.586-1.667-5.366.592-11.175 5.459-13.985L67.212 291.1a193.48 193.48 0 0 1 0-70.199l-42.616-24.599c-4.867-2.809-7.126-8.618-5.459-13.985 11.07-35.642 29.97-67.842 54.689-94.586a12.016 12.016 0 0 1 14.832-2.254l42.584 24.595a191.577 191.577 0 0 1 60.759-35.13V25.759a12.01 12.01 0 0 1 9.377-11.718c34.956-7.85 72.499-8.256 109.219-.007 5.49 1.233 9.403 6.096 9.403 11.723v49.184a191.555 191.555 0 0 1 60.759 35.13l42.584-24.595a12.016 12.016 0 0 1 14.832 2.254c24.718 26.744 43.619 58.944 54.689 94.586 1.667 5.366-.592 11.175-5.459 13.985L444.788 220.9a193.485 193.485 0 0 1 0 70.2zM336 256c0-44.112-35.888-80-80-80s-80 35.888-80 80 35.888 80 80 80 80-35.888 80-80z"],
        "exclamation": [192, 512, [], "f12a", "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"],
        "exclamation-circle": [512, 512, [], "f06a", "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"],
        "exclamation-triangle": [576, 512, [], "f071", "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"],
        "minus": [448, 512, [], "f068", "M424 318.2c13.3 0 24-10.7 24-24v-76.4c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v76.4c0 13.3 10.7 24 24 24h400z"],
        "minus-circle": [512, 512, [], "f056", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"],
        "minus-square": [448, 512, [], "f146", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"],
        "plus": [448, 512, [], "f067", "M448 294.2v-76.4c0-13.3-10.7-24-24-24H286.2V56c0-13.3-10.7-24-24-24h-76.4c-13.3 0-24 10.7-24 24v137.8H24c-13.3 0-24 10.7-24 24v76.4c0 13.3 10.7 24 24 24h137.8V456c0 13.3 10.7 24 24 24h76.4c13.3 0 24-10.7 24-24V318.2H424c13.3 0 24-10.7 24-24z"],
        "plus-circle": [512, 512, [], "f055", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"],
        "plus-square": [448, 512, [], "f0fe", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"],
        "question": [384, 512, [], "f128", "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"],
        "save": [448, 512, [], "f0c7", "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"],
        "search": [512, 512, [], "f002", "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"],
        "share": [512, 512, [], "f064", "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"],
        "spinner": [512, 512, [], "f110", "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"],
        "square": [448, 512, [], "f0c8", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"],
        "square-full": [512, 512, [], "f45c", "M512 512H0V0h512v512z"],
        "times": [384, 512, [], "f00d", "M323.1 441l53.9-53.9c9.4-9.4 9.4-24.5 0-33.9L279.8 256l97.2-97.2c9.4-9.4 9.4-24.5 0-33.9L323.1 71c-9.4-9.4-24.5-9.4-33.9 0L192 168.2 94.8 71c-9.4-9.4-24.5-9.4-33.9 0L7 124.9c-9.4 9.4-9.4 24.5 0 33.9l97.2 97.2L7 353.2c-9.4 9.4-9.4 24.5 0 33.9L60.9 441c9.4 9.4 24.5 9.4 33.9 0l97.2-97.2 97.2 97.2c9.3 9.3 24.5 9.3 33.9 0z"],
        "times-circle": [512, 512, [], "f057", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"],
        "wrench": [512, 512, [], "f0ad", "M481.156 200c9.3 0 15.12 10.155 10.325 18.124C466.295 259.992 420.419 288 368 288c-79.222 0-143.501-63.974-143.997-143.079C223.505 65.469 288.548-.001 368.002 0c52.362.001 98.196 27.949 123.4 69.743C496.24 77.766 490.523 88 481.154 88H376l-40 56 40 56h105.156zm-171.649 93.003L109.255 493.255c-24.994 24.993-65.515 24.994-90.51 0-24.993-24.994-24.993-65.516 0-90.51L218.991 202.5c16.16 41.197 49.303 74.335 90.516 90.503zM104 432c0-13.255-10.745-24-24-24s-24 10.745-24 24 10.745 24 24 24 24-10.745 24-24z"],
    };

    var icons$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        createCheckbox: createCheckbox$1,
        createIcon: createIcon
    });

    function attachDialogCloseHandlerWithParent(parent, closeHandler) {

        var container = document.createElement("div");
        parent.appendChild(container);
        container.appendChild(createIcon("times"));
        container.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            closeHandler();
        });
    }

    var uiUtils = /*#__PURE__*/Object.freeze({
        __proto__: null,
        attachDialogCloseHandlerWithParent: attachDialogCloseHandlerWithParent
    });

    /**
     * Make the target element movable by clicking and dragging on the handle.  This is not a general purprose function,
     * it makes several options specific to igv dialogs, the primary one being that the
     * target is absolutely positioned in pixel coordinates

     */

    let dragData;  // Its assumed we are only dragging one element at a time.

    function makeDraggable(target, handle, constraint) {

        handle.addEventListener('mousedown', dragStart.bind(target));

        function dragStart(event) {

            event.stopPropagation();
            event.preventDefault();

            const dragFunction = drag.bind(this);
            const dragEndFunction = dragEnd.bind(this);
            const computedStyle = getComputedStyle(this);

            dragData =
                {
                    constraint,
                    dragFunction,
                    dragEndFunction,
                    screenX: event.screenX,
                    screenY: event.screenY,
                    top: parseInt(computedStyle.top.replace("px", "")),
                    left: parseInt(computedStyle.left.replace("px", ""))
                };

            document.addEventListener('mousemove', dragFunction);
            document.addEventListener('mouseup', dragEndFunction);
            document.addEventListener('mouseleave', dragEndFunction);
            document.addEventListener('mouseexit', dragEndFunction);
        }
    }

    function drag(event) {

        if (!dragData) {
            console.error("No drag data!");
            return;
        }
        event.stopPropagation();
        event.preventDefault();
        const dx = event.screenX - dragData.screenX;
        const dy = event.screenY - dragData.screenY;

        const left = dragData.left + dx;
        const  top = dragData.constraint ? Math.max(dragData.constraint.minY, dragData.top  + dy) : dragData.top  + dy;

        this.style.left = `${ left }px`;
        this.style.top  = `${  top }px`;
    }

    function dragEnd(event) {

        if (!dragData) {
            console.error("No drag data!");
            return;
        }
        event.stopPropagation();
        event.preventDefault();

        const dragFunction = dragData.dragFunction;
        const dragEndFunction = dragData.dragEndFunction;
        document.removeEventListener('mousemove', dragFunction);
        document.removeEventListener('mouseup', dragEndFunction);
        document.removeEventListener('mouseleave', dragEndFunction);
        document.removeEventListener('mouseexit', dragEndFunction);
        dragData = undefined;
    }

    const httpMessages =
        {
            "401": "Access unauthorized",
            "403": "Access forbidden",
            "404": "Not found"
        };


    class AlertDialog {
        /**
         * Initialize a new alert dialog
         * @param parent
         * @param alertProps - Optional - properties such as scroll to error
         */
        constructor(parent, alertProps) {
            this.alertProps = Object.assign({
                /** When an alert is presented - focus occur */
                shouldFocus: true,
                /** When focus occur - scroll into that element in the view */
                preventScroll: false
            }, alertProps);

            // container
            this.container = div({class: "igv-ui-alert-dialog-container"});
            parent.appendChild(this.container);
            this.container.setAttribute('tabIndex', '-1');

            // header
            const header = div();
            this.container.appendChild(header);

            this.errorHeadline = div();
            header.appendChild(this.errorHeadline);
            this.errorHeadline.textContent = '';

            // body container
            let bodyContainer = div({class: 'igv-ui-alert-dialog-body'});
            this.container.appendChild(bodyContainer);

            // body copy
            this.body = div({class: 'igv-ui-alert-dialog-body-copy'});
            bodyContainer.appendChild(this.body);

            // ok container
            let ok_container = div();
            this.container.appendChild(ok_container);

            // ok
            this.ok = div();
            ok_container.appendChild(this.ok);
            this.ok.textContent = 'OK';

            const okHandler = () => {

                if (typeof this.callback === 'function') {
                    this.callback("OK");
                    this.callback = undefined;
                }
                this.body.innerHTML = '';
                hide(this.container);
            };

            this.ok.addEventListener('click', event => {

                event.stopPropagation();

                okHandler();
            });

            this.container.addEventListener('keypress', event => {

                event.stopPropagation();

                if ('Enter' === event.key) {
                    okHandler();
                }
            });

            makeDraggable(this.container, header);

            hide(this.container);
        }

        present(alert, callback) {

            this.errorHeadline.textContent = alert.message ? 'ERROR' : '';
            let string = alert.message || alert;

            if (httpMessages.hasOwnProperty(string)) {
                string = httpMessages[string];
            }

            const clean = purify.sanitize(string);

            this.body.innerHTML = clean;
            this.callback = callback;
            show(this.container);
            if (this.alertProps.shouldFocus) {
                this.container.focus(
                    { preventScroll: this.alertProps.preventScroll }
                );
            }
        }
    }

    class InputDialog {

        constructor(parent) {

            this.parent = parent;

            // dialog container
            this.container = div({class: 'igv-ui-generic-dialog-container'});
            parent.appendChild(this.container);

            // const { x, y, width, height } = this.container.getBoundingClientRect();
            // console.log(`InputDialog - x ${ x } y ${ y } width ${ width } height ${ height }`)

            // dialog header
            const header = div({class: 'igv-ui-generic-dialog-header'});
            this.container.appendChild(header);

            // dialog label
            this.label = div({class: 'igv-ui-generic-dialog-one-liner'});
            this.container.appendChild(this.label);
            this.label.text = 'Unlabeled';

            // input container
            this.input_container = div({class: 'igv-ui-generic-dialog-input'});
            this.container.appendChild(this.input_container);
            //
            this.input = document.createElement("input");
            this.input_container.appendChild(this.input);


            // ok | cancel
            const buttons = div({class: 'igv-ui-generic-dialog-ok-cancel'});
            this.container.appendChild(buttons);

            // ok
            this.ok = div();
            buttons.appendChild(this.ok);
            this.ok.textContent = 'OK';

            // cancel
            this.cancel = div();
            buttons.appendChild(this.cancel);
            this.cancel.textContent = 'Cancel';

            hide(this.container);

            this.input.addEventListener('keyup', e => {
                if (13 === e.keyCode) {
                    if (typeof this.callback === 'function') {
                        this.callback(this.input.value);
                        this.callback = undefined;
                    }
                    this.input.value = undefined;
                    hide(this.container);
                }
            });

            this.ok.addEventListener('click', () => {
                if (typeof this.callback === 'function') {
                    this.callback(this.input.value);
                    this.callback = undefined;
                }
                this.input.value = undefined;
                hide(this.container);
            });

            const cancel = () => {
                this.input.value = '';
                hide(this.container);
            };

            this.cancel.addEventListener('click', cancel);

            attachDialogCloseHandlerWithParent(header, cancel);
            makeDraggable(this.container, header);

        }

        get value() {
            return purify.sanitize(this.input.value)
        }

        present(options, e) {

            this.label.textContent = options.label;
            this.input.value = options.value;
            this.callback = options.callback || options.click;

            show(this.container);
            this.clampLocation(e.clientX, e.clientY);

        }

        clampLocation(clientX, clientY) {

            const {width: w, height: h} = this.container.getBoundingClientRect();
            const wh = window.innerHeight;
            const ww = window.innerWidth;

            const y = Math.min(wh - h, clientY);
            const x = Math.min(ww - w, clientX);
            this.container.style.left = `${x}px`;
            this.container.style.top = `${y}px`;

        }
    }

    const appleCrayonPalette =
        {
            licorice: "#000000",
            lead: "#1e1e1e",
            tungsten: "#3a3a3a",
            iron: "#545453",
            steel: "#6e6e6e",
            tin: "#878687",
            nickel: "#888787",
            aluminum: "#a09fa0",
            magnesium: "#b8b8b8",
            silver: "#d0d0d0",
            mercury: "#e8e8e8",
            snow: "#ffffff",
            //
            cayenne: "#891100",
            mocha: "#894800",
            aspargus: "#888501",
            fern: "#458401",
            clover: "#028401",
            moss: "#018448",
            teal: "#008688",
            ocean: "#004a88",
            midnight: "#001888",
            eggplant: "#491a88",
            plum: "#891e88",
            maroon: "#891648",
            //
            maraschino: "#ff2101",
            tangerine: "#ff8802",
            lemon: "#fffa03",
            lime: "#83f902",
            spring: "#05f802",
            seam_foam: "#03f987",
            turquoise: "#00fdff",
            aqua: "#008cff",
            blueberry: "#002eff",
            grape: "#8931ff",
            magenta: "#ff39ff",
            strawberry: "#ff2987",
            //
            salmon: "#ff726e",
            cantaloupe: "#ffce6e",
            banana: "#fffb6d",
            honeydew: "#cefa6e",
            flora: "#68f96e",
            spindrift: "#68fbd0",
            ice: "#68fdff",
            sky: "#6acfff",
            orchid: "#6e76ff",
            lavender: "#d278ff",
            bubblegum: "#ff7aff",
            carnation: "#ff7fd3"
        };

    class GenericContainer {

        constructor({parent,  top, left, width, height, border, closeHandler}) {

            let container = div({class: 'igv-ui-generic-container'});
            parent.appendChild(container);
            hide(container);
            this.container = container;

            if(top !== undefined) {
                this.container.style.top = `${ top }px`;
            }
            if(left !== undefined) {
                this.container.style.left = `${ left }px`;
            }
            if (width !== undefined) {
                this.container.style.width = `${ width }px`;
            }
            if (height !== undefined) {
                this.container.style.height = `${ height }px`;
            }
            if(border) {
                this.container.style.border = border;
            }
            //
            // let bbox = parent.getBoundingClientRect();
            // this.origin = {x: bbox.x, y: bbox.y};
            // this.container.offset({left: this.origin.x, top: this.origin.y});

            // header
            const header = div();
            this.container.appendChild(header);

            // close button
            attachDialogCloseHandlerWithParent(header, (e) => {
                hide(this.container);
                if(typeof closeHandler === "function") {
                    closeHandler(e);
                }
            });

            makeDraggable(this.container, header);
        }

        show() {
            show(this.container);
        }

        hide() {
            hide(this.container);
        }

        dispose() {
            if(this.container.parent)  {
                this.container.parent.removeChild(this.container);
            }
        }
    }

    class ColorPicker extends GenericContainer {

        constructor({parent, top, left, width, height, defaultColors, colorHandler}) {

            super({ parent, top, left, width, height, border: '1px solid gray'});

            createColorSwatchSelector(this.container, colorHandler, defaultColors);
        }

    }

    const createColorSwatchSelector = (container, colorHandler, defaultColors) => {

        const hexColorStrings = Object.values(appleCrayonPalette);

        for (let hexColorString of hexColorStrings) {
            const swatch = div({ class: 'igv-ui-color-swatch' });
            container.appendChild(swatch);
            decorateSwatch(swatch, hexColorString, colorHandler);
        }

        if (defaultColors) {
            for (let hexColorString of defaultColors) {
                const swatch = div({ class: 'igv-ui-color-swatch' });
                container.appendChild(swatch);
                decorateSwatch(swatch, hexColorString, colorHandler);
            }
        }

    };

    const decorateSwatch = (swatch, hexColorString, colorHandler) => {

        swatch.style.backgroundColor = hexColorString;

        swatch.addEventListener('mouseenter', e => swatch.style.borderColor = hexColorString);

        swatch.addEventListener('mouseleave', e => swatch.style.borderColor = 'white');

        swatch.addEventListener('click', event => {
            event.stopPropagation();
            colorHandler(hexColorString);
        });

        swatch.addEventListener('touchend', event => {
            event.stopPropagation();
            colorHandler(hexColorString);
        });

    };

    class Popover {

        constructor(parent, title) {

            this.parent = parent;

            // popover
            this.popover = div({ class: "igv-ui-popover" });
            parent.appendChild(this.popover);

            // header
            const popoverHeader = div();
            this.popover.appendChild(popoverHeader);

            const titleElement = div();
            popoverHeader.appendChild(titleElement);
            if (title) {
                titleElement.textContent = title;
            }

            attachDialogCloseHandlerWithParent(popoverHeader,  () => this.hide());
            makeDraggable(this.popover, popoverHeader);

            // content
            this.popoverContent = div();
            this.popover.appendChild(this.popoverContent);

            this.popover.style.display = 'none';


        }

        presentContentWithEvent(e, content) {

            this.popover.style.display = 'block';

            this.popoverContent.innerHTML = content;

            present$1(e, this.popover, this.popoverContent);

        }

        presentMenu(e, menuItems) {

            if (0 === menuItems.length) {
                return
            }

            this.popover.style.display = 'block';

            const menuElements = createMenuElements$1(menuItems, this.popover);
            for (let item of menuElements) {
                this.popoverContent.appendChild(item.object);
            }

            present$1(e, this.popover, this.popoverContent);
        }

        hide() {
            this.popover.style.display = 'none';
            this.dispose();
        }

        dispose() {

            if (this.popover) {
                this.popover.parentNode.removeChild(this.popover);
            }

            const keys = Object.keys(this);
            for (let key of keys) {
                this[ key ] = undefined;
            }
        }

    }

    function present$1(e, popover, popoverContent) {

        const { x, y, width } = translateMouseCoordinates(e, popover.parentNode);
        popover.style.top  = `${ y }px`;

        const { width: w } = popover.getBoundingClientRect();

        const xmax = x + w;
        const delta = xmax - width;

        popover.style.left = `${ xmax > width ? (x - delta) : x }px`;
        popoverContent.style.maxWidth = `${ Math.min(w, width) }px`;


    }

    function createMenuElements$1(itemList, popover) {

        const list  = itemList.map(function (item, i) {
            let elem;

            if (typeof item === 'string') {
                elem = div();
                elem.innerHTML = item;
            } else if (typeof item === 'Node') {
                elem = item;
            } else {
                if (typeof item.init === 'function') {
                    item.init();
                }

                if ("checkbox" === item.type) {
                    elem = createCheckbox$1("Show all bases", item.value);
                } else if("color" === item.type) {
                    const colorPicker = new ColorPicker({
                        parent: popover.parentElement,
                        width: 364,
                        //defaultColor: 'aqua',
                        colorHandler: (color) => item.click(color)
                    });
                    elem = div();
                    if (typeof item.label === 'string') {
                        elem.innerHTML = item.label;
                    }
                    const clickHandler =  e => {
                        colorPicker.show();
                        hide(popover);
                        e.preventDefault();
                        e.stopPropagation();
                    };
                    elem.addEventListener('click', clickHandler);
                    elem.addEventListener('touchend', clickHandler);
                    elem.addEventListener('mouseup', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    });
                }

                else {
                    elem = div();
                    if (typeof item.label === 'string') {
                        elem.innerHTML = item.label;
                    }
                }

                if (item.click && "color" !== item.type) {
                    elem.addEventListener('click', handleClick);
                    elem.addEventListener('touchend', handleClick);
                    elem.addEventListener('mouseup', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    });

                    // eslint-disable-next-line no-inner-declarations
                    function handleClick(e) {
                        item.click();
                        hide(popover);
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
            }


            return { object: elem, init: item.init };
        });

        return list;
    }

    class GenericColorPicker extends GenericContainer {

        constructor({parent, width}) {
            super({parent, width, border: '1px solid gray'});
        }

        configure(defaultColors, colorHandlers) {

            this.colorHandlers = colorHandlers;

            // active color handler defaults to handler with 'color' as key
            this.setActiveColorHandler('color');

            this.createSwatches(defaultColors);

        }

        setActiveColorHandler(option) {
            this.activeColorHandler = this.colorHandlers[option];
        }

        createSwatches(defaultColors) {

            this.container.querySelectorAll('.igv-ui-color-swatch').forEach(swatch => swatch.remove());

            const hexColorStrings = Object.values(appleCrayonPalette);

            for (let hexColorString of hexColorStrings) {
                const swatch = div({class: 'igv-ui-color-swatch'});
                this.container.appendChild(swatch);
                this.decorateSwatch(swatch, hexColorString);
            }

            if (defaultColors) {
                for (let hexColorString of defaultColors) {
                    const swatch = div({class: 'igv-ui-color-swatch'});
                    this.container.appendChild(swatch);
                    this.decorateSwatch(swatch, hexColorString);
                }
            }

        }

        decorateSwatch(swatch, hexColorString) {

            swatch.style.backgroundColor = hexColorString;

            swatch.addEventListener('mouseenter', () => swatch.style.borderColor = hexColorString);

            swatch.addEventListener('mouseleave', () => swatch.style.borderColor = 'white');

            swatch.addEventListener('click', event => {
                event.stopPropagation();
                this.activeColorHandler(hexColorString);
            });

            swatch.addEventListener('touchend', event => {
                event.stopPropagation();
                this.activeColorHandler(hexColorString);
            });

        }

    }

    function embedCSS$2() {
        const style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.setAttribute('title', 'igv-ui.css');
        style.innerHTML = `.igv-ui-popover {
  cursor: default;
  position: absolute;
  z-index: 2048;
  border-color: #7F7F7F;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  font-family: "Open Sans", sans-serif;
  font-size: small;
  background-color: white;
}
.igv-ui-popover > div:first-child {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 24px;
  cursor: move;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-color: #7F7F7F;
  border-bottom-style: solid;
  border-bottom-width: thin;
  background-color: #eee;
}
.igv-ui-popover > div:first-child > div:first-child {
  margin-left: 4px;
}
.igv-ui-popover > div:first-child > div:last-child {
  margin-right: 4px;
  height: 12px;
  width: 12px;
  color: #7F7F7F;
}
.igv-ui-popover > div:first-child > div:last-child:hover {
  cursor: pointer;
  color: #444;
}
.igv-ui-popover > div:last-child {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 400px;
  max-width: 800px;
  background-color: white;
}
.igv-ui-popover > div:last-child > div {
  user-select: all;
  margin-left: 4px;
  margin-right: 4px;
  min-width: 220px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.igv-ui-popover > div:last-child > div > span {
  font-weight: bolder;
}
.igv-ui-popover > div:last-child hr {
  width: 100%;
}

.igv-ui-alert-dialog-container {
  box-sizing: content-box;
  position: absolute;
  z-index: 2048;
  top: 50%;
  left: 50%;
  width: 400px;
  height: 200px;
  border-color: #7F7F7F;
  border-radius: 4px;
  border-style: solid;
  border-width: thin;
  outline: none;
  font-family: "Open Sans", sans-serif;
  font-size: 15px;
  font-weight: 400;
  background-color: white;
  display: flex;
  flex-flow: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}
.igv-ui-alert-dialog-container > div:first-child {
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 24px;
  cursor: move;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-color: #7F7F7F;
  border-bottom-style: solid;
  border-bottom-width: thin;
  background-color: #eee;
}
.igv-ui-alert-dialog-container > div:first-child div:first-child {
  padding-left: 8px;
}
.igv-ui-alert-dialog-container .igv-ui-alert-dialog-body {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
  color: #373737;
  width: 100%;
  height: calc(100% - 24px - 64px);
  overflow-y: scroll;
}
.igv-ui-alert-dialog-container .igv-ui-alert-dialog-body .igv-ui-alert-dialog-body-copy {
  margin: 16px;
  width: auto;
  height: auto;
  overflow-wrap: break-word;
  word-break: break-word;
  background-color: white;
  border: unset;
}
.igv-ui-alert-dialog-container > div:last-child {
  width: 100%;
  margin-bottom: 10px;
  background-color: white;
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.igv-ui-alert-dialog-container > div:last-child div {
  margin: unset;
  width: 40px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: white;
  font-family: "Open Sans", sans-serif;
  font-size: small;
  font-weight: 400;
  border-color: #2B81AF;
  border-style: solid;
  border-width: thin;
  border-radius: 4px;
  background-color: #2B81AF;
}
.igv-ui-alert-dialog-container > div:last-child div:hover {
  cursor: pointer;
  border-color: #25597f;
  background-color: #25597f;
}

.igv-ui-color-swatch {
  position: relative;
  box-sizing: content-box;
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-style: solid;
  border-width: 2px;
  border-color: white;
  border-radius: 4px;
}

.igv-ui-color-swatch:hover {
  border-color: dimgray;
}

.igv-ui-colorpicker-menu-close-button {
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 32px;
  margin-top: 4px;
  margin-bottom: 4px;
  padding-right: 8px;
}
.igv-ui-colorpicker-menu-close-button i.fa {
  display: block;
  margin-left: 4px;
  margin-right: 4px;
  color: #5f5f5f;
}
.igv-ui-colorpicker-menu-close-button i.fa:hover,
.igv-ui-colorpicker-menu-close-button i.fa:focus,
.igv-ui-colorpicker-menu-close-button i.fa:active {
  cursor: pointer;
  color: #0f0f0f;
}

.igv-ui-generic-dialog-container {
  box-sizing: content-box;
  position: fixed;
  top: 0;
  left: 0;
  width: 300px;
  height: 200px;
  border-color: #7F7F7F;
  border-radius: 4px;
  border-style: solid;
  border-width: thin;
  font-family: "Open Sans", sans-serif;
  font-size: medium;
  font-weight: 400;
  z-index: 2048;
  background-color: white;
  display: flex;
  flex-flow: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-header {
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 24px;
  cursor: move;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-color: #7F7F7F;
  border-bottom-style: solid;
  border-bottom-width: thin;
  background-color: #eee;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-header div {
  margin-right: 4px;
  margin-bottom: 2px;
  height: 12px;
  width: 12px;
  color: #7F7F7F;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-header div:hover {
  cursor: pointer;
  color: #444;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-one-liner {
  color: #373737;
  width: 95%;
  height: 24px;
  line-height: 24px;
  text-align: left;
  margin-top: 8px;
  padding-left: 8px;
  overflow-wrap: break-word;
  background-color: white;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-label-input {
  margin-top: 8px;
  width: 95%;
  height: 24px;
  color: #373737;
  line-height: 24px;
  padding-left: 8px;
  background-color: white;
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-label-input div {
  width: 30%;
  height: 100%;
  font-size: 16px;
  text-align: right;
  padding-right: 8px;
  background-color: white;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-label-input input {
  display: block;
  height: 100%;
  width: 100%;
  padding-left: 4px;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  color: #373737;
  text-align: left;
  outline: none;
  border-style: solid;
  border-width: thin;
  border-color: #7F7F7F;
  background-color: white;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-label-input input {
  width: 50%;
  font-size: 16px;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-input {
  margin-top: 8px;
  width: calc(100% - 16px);
  height: 24px;
  color: #373737;
  line-height: 24px;
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-input input {
  display: block;
  height: 100%;
  width: 100%;
  padding-left: 4px;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  color: #373737;
  text-align: left;
  outline: none;
  border-style: solid;
  border-width: thin;
  border-color: #7F7F7F;
  background-color: white;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-input input {
  font-size: 16px;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-ok-cancel {
  width: 100%;
  height: 28px;
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-ok-cancel div {
  margin-top: 32px;
  color: white;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  width: 75px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-color: transparent;
  border-style: solid;
  border-width: thin;
  border-radius: 2px;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-ok-cancel div:first-child {
  margin-left: 32px;
  margin-right: 0;
  background-color: #5ea4e0;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-ok-cancel div:last-child {
  margin-left: 0;
  margin-right: 32px;
  background-color: #c4c4c4;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-ok-cancel div:first-child:hover {
  cursor: pointer;
  background-color: #3b5c7f;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-ok-cancel div:last-child:hover {
  cursor: pointer;
  background-color: #7f7f7f;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-ok {
  width: 100%;
  height: 36px;
  margin-top: 32px;
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-ok div {
  width: 98px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  color: white;
  font-family: "Open Sans", sans-serif;
  font-size: medium;
  font-weight: 400;
  border-color: white;
  border-style: solid;
  border-width: thin;
  border-radius: 4px;
  background-color: #2B81AF;
}
.igv-ui-generic-dialog-container .igv-ui-generic-dialog-ok div:hover {
  cursor: pointer;
  background-color: #25597f;
}

.igv-ui-generic-container {
  box-sizing: content-box;
  position: absolute;
  z-index: 2048;
  background-color: white;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.igv-ui-generic-container > div:first-child {
  cursor: move;
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  height: 24px;
  width: 100%;
  background-color: #dddddd;
}
.igv-ui-generic-container > div:first-child > div {
  display: block;
  color: #5f5f5f;
  cursor: pointer;
  width: 14px;
  height: 14px;
  margin-right: 8px;
  margin-bottom: 4px;
}

.igv-ui-dialog {
  z-index: 2048;
  position: fixed;
  width: fit-content;
  height: fit-content;
  display: flex;
  flex-flow: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  background-color: white;
  border-color: #7F7F7F;
  border-radius: 4px;
  border-style: solid;
  border-width: thin;
  font-family: "Open Sans", sans-serif;
  font-size: medium;
  font-weight: 400;
}
.igv-ui-dialog .igv-ui-dialog-header {
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 24px;
  cursor: move;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-color: #7F7F7F;
  border-bottom-style: solid;
  border-bottom-width: thin;
  background-color: #eee;
}
.igv-ui-dialog .igv-ui-dialog-header div {
  margin-right: 4px;
  margin-bottom: 2px;
  height: 12px;
  width: 12px;
  color: #7F7F7F;
}
.igv-ui-dialog .igv-ui-dialog-header div:hover {
  cursor: pointer;
  color: #444;
}
.igv-ui-dialog .igv-ui-dialog-one-liner {
  width: 95%;
  height: 24px;
  line-height: 24px;
  text-align: left;
  margin: 8px;
  overflow-wrap: break-word;
  background-color: white;
  font-weight: bold;
}
.igv-ui-dialog .igv-ui-dialog-ok-cancel {
  width: 100%;
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
}
.igv-ui-dialog .igv-ui-dialog-ok-cancel div {
  margin: 16px;
  margin-top: 32px;
  color: white;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  width: 75px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-color: transparent;
  border-style: solid;
  border-width: thin;
  border-radius: 2px;
}
.igv-ui-dialog .igv-ui-dialog-ok-cancel div:first-child {
  background-color: #5ea4e0;
}
.igv-ui-dialog .igv-ui-dialog-ok-cancel div:last-child {
  background-color: #c4c4c4;
}
.igv-ui-dialog .igv-ui-dialog-ok-cancel div:first-child:hover {
  cursor: pointer;
  background-color: #3b5c7f;
}
.igv-ui-dialog .igv-ui-dialog-ok-cancel div:last-child:hover {
  cursor: pointer;
  background-color: #7f7f7f;
}
.igv-ui-dialog .igv-ui-dialog-ok {
  width: 100%;
  height: 36px;
  margin-top: 32px;
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
}
.igv-ui-dialog .igv-ui-dialog-ok div {
  width: 98px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  color: white;
  font-family: "Open Sans", sans-serif;
  font-size: medium;
  font-weight: 400;
  border-color: white;
  border-style: solid;
  border-width: thin;
  border-radius: 4px;
  background-color: #2B81AF;
}
.igv-ui-dialog .igv-ui-dialog-ok div:hover {
  cursor: pointer;
  background-color: #25597f;
}

.igv-ui-panel, .igv-ui-panel-row, .igv-ui-panel-column {
  z-index: 2048;
  background-color: white;
  font-family: "Open Sans", sans-serif;
  font-size: medium;
  font-weight: 400;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.igv-ui-panel-column {
  display: flex;
  flex-direction: column;
}

.igv-ui-panel-row {
  display: flex;
  flex-direction: row;
}

.igv-ui-textbox {
  background-color: white;
  font-family: "Open Sans", sans-serif;
  font-size: medium;
  font-weight: 400;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.igv-ui-table {
  background-color: white;
}

.igv-ui-table thead {
  position: sticky;
  top: 0;
}

.igv-ui-table th {
  text-align: left;
}

.igv-ui-table td {
  padding-right: 20px;
}

.igv-ui-table tr:hover {
  background-color: lightblue;
}

/*# sourceMappingURL=igv-ui.css.map */
`;
        document.head.append(style);
    }

    if (typeof document !== 'undefined') {

        if (!stylesheetExists("igv-ui.css")) {
            embedCSS$2();
        }

        function stylesheetExists(stylesheetName) {
            for (let ss of document.styleSheets) {
                ss = ss.href ? ss.href.replace(/^.*[\\\/]/, '') : '';
                if (ss === stylesheetName) {
                    return true
                }
            }
            return false
        }
    }

    function createCheckbox(name, initialState) {

        const container = domUtils.div({class: 'igv-menu-popup-check-container'});

        const div = domUtils.div();
        container.appendChild(div);

        const svg = icons$1.createIcon('check', (true === initialState ? '#444' : 'transparent'));
        div.appendChild(svg);

        const label = domUtils.div();
        label.innerText = name;
        container.appendChild(label);

        return container
    }

    /**
     * Configure item list for track "gear" menu.
     * @param trackView
     */
    const MenuUtils = {

        trackMenuItemList: function (trackView) {

            const vizWindowTypes = new Set(['alignment', 'annotation', 'variant', 'eqtl', 'snp']);

            const hasVizWindow = trackView.track.config && trackView.track.config.visibilityWindow !== undefined;

            let menuItems = [];

            if (trackView.track.config.type !== 'sequence') {
                menuItems.push(trackRenameMenuItem(trackView));
                menuItems.push(trackHeightMenuItem(trackView));
            }

            if (this.showColorPicker(trackView.track)) {
                menuItems.push('<hr/>');
                menuItems.push(colorPickerMenuItem({trackView, label: "Set track color", option: "color"}));
                menuItems.push(unsetColorMenuItem({trackView, label: "Unset track color"}));
               if(trackView.track.config.type === 'wig' || trackView.track.config.type === 'annotation') {
                   menuItems.push(colorPickerMenuItem({trackView, label: "Set alt color", option: "altColor"}));
                   menuItems.push(unsetAltColorMenuItem({trackView, label: "Unset alt color"}));
               }
            }

            if (trackView.track.menuItemList) {
                menuItems = menuItems.concat(trackView.track.menuItemList());
            }

            if (hasVizWindow || vizWindowTypes.has(trackView.track.type)) {
                menuItems.push('<hr/>');
                menuItems.push(visibilityWindowMenuItem(trackView));
            }

            if (trackView.track.removable !== false) {
                menuItems.push('<hr/>');
                menuItems.push(trackRemovalMenuItem(trackView));
            }

            return menuItems
        },

        numericDataMenuItems: function (trackView) {

            const menuItems = [];

            menuItems.push('<hr/>');

            // Data range
            const object = $$1('<div>');
            object.text('Set data range');

            const click = () => {
                trackView.browser.dataRangeDialog.configure(trackView);
                trackView.browser.dataRangeDialog.present($$1(trackView.browser.columnContainer));
            };
            menuItems.push({object, click});

            if (trackView.track.logScale !== undefined) {
                menuItems.push({
                        object: $$1(createCheckbox("Log scale", trackView.track.logScale)),
                        click: () => {
                            trackView.track.logScale = !trackView.track.logScale;
                            trackView.repaintViews();
                        }
                    }
                );
            }

            menuItems.push({
                    object: $$1(createCheckbox("Autoscale", trackView.track.autoscale)),
                    click: () => {
                        trackView.track.autoscale = !trackView.track.autoscale;
                        trackView.updateViews();
                    }
                }
            );


            return menuItems
        },

        trackMenuItemListHelper: function (itemList, menuPopup) {

            var list = [];

            if (itemList.length > 0) {

                list = itemList.map(function (item, i) {
                    var $e;

                    // name and object fields checked for backward compatibility
                    if (item.name) {
                        $e = $$1('<div>');
                        $e.text(item.name);
                    } else if (item.object) {
                        $e = item.object;
                    } else if (typeof item.label === 'string') {
                        $e = $$1('<div>');
                        $e.html(item.label);
                    } else if (typeof item === 'string') {

                        if (item.startsWith("<")) {
                            $e = $$1(item);
                        } else {
                            $e = $$1("<div>" + item + "</div>");
                        }
                    }

                    if (0 === i) {
                        $e.addClass('igv-track-menu-border-top');
                    }

                    if (item.click) {
                        $e.on('click', handleClick);
                        $e.on('touchend', function (e) {
                            handleClick(e);
                        });
                        $e.on('mouseup', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                        });

                        // eslint-disable-next-line no-inner-declarations
                        function handleClick(e) {
                            item.click(e);
                            menuPopup.hide();
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }

                    return {object: $e, init: (item.init || undefined)}
                });
            }

            return list
        },

        showColorPicker(track) {
            return (
                undefined === track.type ||
                "bedtype" === track.type ||
                "alignment" === track.type ||
                "annotation" === track.type ||
                "variant" === track.type ||
                "wig" === track.type) ||
                'interact' === track.type
        },

        createMenuItem(label, action) {
            const object = $$1('<div>');
            object.text(label);
            return {object, click: action}
        }
    };


    function visibilityWindowMenuItem(trackView) {

        const click = e => {

            const callback = () => {

                let value = trackView.browser.inputDialog.value;
                value = '' === value || undefined === value ? -1 : value.trim();

                trackView.track.visibilityWindow = Number.parseInt(value);
                trackView.track.config.visibilityWindow = Number.parseInt(value);

                trackView.updateViews();
            };

            const config =
                {
                    label: 'Visibility Window',
                    value: (trackView.track.visibilityWindow),
                    callback
                };
            trackView.browser.inputDialog.present(config, e);

        };

        const object = $$1('<div>');
        object.text('Set visibility window');
        return {object, click}

    }

    function trackRemovalMenuItem(trackView) {

        const object = $$1('<div>');
        object.text('Remove track');

        return {object, click: () => trackView.browser.removeTrack(trackView.track)}

    }

    function colorPickerMenuItem({trackView, label, option}) {

        const $e = $$1('<div>');
        $e.text(label);

        return {
            object: $e,
            click: () => trackView.presentColorPicker(option)
        }
    }

    function unsetColorMenuItem({trackView, label}) {

        const $e = $$1('<div>');
        $e.text(label);

        return {
            object: $e,
            click: () => {
                trackView.track.color = undefined;
                trackView.repaintViews();
            }
        }
    }

    function unsetAltColorMenuItem({trackView, label}) {

        const $e = $$1('<div>');
        $e.text(label);

        return {
            object: $e,
            click: () => {
                trackView.track.altColor = undefined;
                trackView.repaintViews();
            }
        }
    }

    function trackRenameMenuItem(trackView) {

        const click = e => {

            const callback = function () {
                let value = trackView.browser.inputDialog.value;
                value = ('' === value || undefined === value) ? 'untitled' : value.trim();
                trackView.track.name = value;
            };

            const config =
                {
                    label: 'Track Name',
                    value: (getTrackLabelText(trackView.track) || 'unnamed'),
                    callback
                };

            trackView.browser.inputDialog.present(config, e);

        };

        const object = $$1('<div>');
        object.text('Set track name');
        return {object, click}


    }

    function trackHeightMenuItem(trackView) {

        const click = e => {

            const callback = () => {

                const number = Number(trackView.browser.inputDialog.value, 10);

                if (undefined !== number) {

                    // If explicitly setting the height adust min or max, if neccessary.
                    if (trackView.track.minHeight !== undefined && trackView.track.minHeight > number) {
                        trackView.track.minHeight = number;
                    }
                    if (trackView.track.maxHeight !== undefined && trackView.track.maxHeight < number) {
                        trackView.track.minHeight = number;
                    }
                    trackView.setTrackHeight(number, true);

                    trackView.checkContentHeight();
                    trackView.repaintViews();


                    // Explicitly setting track height turns off autoHeight
                    trackView.track.autoHeight = false;
                }

            };

            const config =
                {
                    label: 'Track Height',
                    value: trackView.track.height,
                    callback
                };

            trackView.browser.inputDialog.present(config, e);

        };

        const object = $$1('<div>');
        object.text('Set track height');
        return {object, click}


    }

    function getTrackLabelText(track) {
        var vp,
            txt;

        vp = track.trackView.viewports[0];
        txt = vp.$trackLabel.text();

        return txt
    }

    class DataRangeDialog {

        constructor(browser, $parent, alert) {

            this.browser = browser;

            // dialog container
            this.$container = $$1("<div>", {class: 'igv-generic-dialog-container'});
            $parent.append(this.$container);
            this.$container.offset({left: 0, top: 0});

            // dialog header
            const $header = $$1("<div>", {class: 'igv-generic-dialog-header'});
            this.$container.append($header);
            uiUtils.attachDialogCloseHandlerWithParent($header[0], () => {
                this.$minimum_input.val(undefined);
                this.$maximum_input.val(undefined);
                this.$container.offset({left: 0, top: 0});
                this.$container.hide();
            });


            // minimun
            this.$minimum = $$1("<div>", {class: 'igv-generic-dialog-label-input'});
            this.$container.append(this.$minimum);
            const $mindiv = $$1('<div>');
            $mindiv.text('Minimum');
            this.$minimum.append($mindiv);
            this.$minimum_input = $$1("<input>");
            this.$minimum.append(this.$minimum_input);


            // maximum
            this.$maximum = $$1("<div>", {class: 'igv-generic-dialog-label-input'});
            this.$container.append(this.$maximum);
            const $maxdiv = $$1('<div>');
            $maxdiv.text('Maximum');
            this.$maximum.append($maxdiv);
            this.$maximum_input = $$1("<input>");
            this.$maximum.append(this.$maximum_input);

            // ok | cancel
            const $buttons = $$1("<div>", {class: 'igv-generic-dialog-ok-cancel'});
            this.$container.append($buttons);

            // ok
            this.$ok = $$1("<div>");
            $buttons.append(this.$ok);
            this.$ok.text('OK');

            // cancel
            this.$cancel = $$1("<div>");
            $buttons.append(this.$cancel);
            this.$cancel.text('Cancel');

            this.$cancel.on('click', () => {
                this.$minimum_input.val(undefined);
                this.$maximum_input.val(undefined);
                this.$container.offset({left: 0, top: 0});
                this.$container.hide();
            });

            //this.$container.draggable({ handle:$header.get(0) });
            makeDraggable(this.$container.get(0), $header.get(0));

            this.$container.hide();
        }

        configure(trackView) {

            const dataRange = trackView.dataRange();
            let min;
            let max;
            if (dataRange) {
                min = dataRange.min;
                max = dataRange.max;
            } else {
                min = 0;
                max = 100;
            }

            this.$minimum_input.val(min);
            this.$maximum_input.val(max);

            this.$minimum_input.unbind();
            this.$minimum_input.on('keyup', (e) => {
                if (13 === e.keyCode) {
                    this.processResults(trackView);
                }
            });

            this.$maximum_input.unbind();
            this.$maximum_input.on('keyup', (e) => {
                if (13 === e.keyCode) {
                    this.processResults(trackView);
                }
            });

            this.$ok.unbind();
            this.$ok.on('click', (e) => {
                this.processResults(trackView);
            });
        }


        processResults(trackView) {

            const min = Number(this.$minimum_input.val());
            const max = Number(this.$maximum_input.val());
            if (isNaN(min) || isNaN(max)) {
                this.browser.alert.present(new Error('Must input numeric values'), undefined);
            } else {
                trackView.setDataRange(min, max);
            }

            this.$minimum_input.val(undefined);
            this.$maximum_input.val(undefined);
            this.$container.offset({left: 0, top: 0});
            this.$container.hide();
        }

        present($parent) {

            const offset_top = $parent.offset().top;
            const scroll_top = $$1('body').scrollTop();

            this.$container.offset({left: $parent.width() - this.$container.width(), top: (offset_top + scroll_top)});
            this.$container.show();
        }
    }

    /**
     * Covers string literals and String objects
     * @param x
     * @returns {boolean}
     */
    function isString$2(x) {
        return typeof x === "string" || x instanceof String
    }


    // StackOverflow: http://stackoverflow.com/a/10810674/116169
    function numberFormatter$1(rawNumber) {

        var dec = String(rawNumber).split(/[.,]/),
            sep = ',',
            decsep = '.';

        return dec[0].split('').reverse().reduce(function (prev, now, i) {
            return i % 3 === 0 ? prev + sep + now : prev + now;
        }).split('').reverse().join('') + (dec[1] ? decsep + dec[1] : '');
    }

    const splitLines$5 = function (string) {
        return string.split(/\n|\r\n|\r/g);
    };


    function splitStringRespectingQuotes(string, delim) {

        var tokens = [],
            len = string.length,
            i,
            n = 0,
            quote = false,
            c;

        if (len > 0) {

            tokens[n] = string.charAt(0);
            for (i = 1; i < len; i++) {
                c = string.charAt(i);
                if (c === '"') {
                    quote = !quote;
                } else if (!quote && c === delim) {
                    n++;
                    tokens[n] = "";
                } else {
                    tokens[n] += c;
                }
            }
        }
        return tokens;
    }

    function stripQuotes$1(str) {
        if(str === undefined) {
            return str;
        }
        if(str.startsWith("'") || str.startsWith('"')) {
            str = str.substring(1);
        }
        if (str.endsWith("'") || str.endsWith('"')) {
            str = str.substring(0, str.length - 1);
        }
        return str;
    }

    function capitalize(str) {
        return str.length > 0 ? str.charAt(0).toUpperCase() + str.slice(1) : str;
    }


    /**
     * Parse a locus string and return a range object.  Locus string is of the form chr:start-end.  End is optional
     *
     */
    function parseLocusString$1(string) {

        const t1 = string.split(":");
        const t2 = t1[1].split("-");

        const range = {
            chr: t1[0],
            start: Number.parseInt(t2[0].replace(/,/g, '')) - 1
        };

        if (t2.length > 1) {
            range.end = Number.parseInt(t2[1].replace(/,/g, ''));
        } else {
            range.end = range.start + 1;
        }

        return range;
    }

    /**
     * Return the filename from the path.   Example
     *   https://foo.com/bar.bed?param=2   => bar.bed
     * @param urlOrFile
     */

    function getFilename$2(urlOrFile) {

        if (urlOrFile.name !== undefined) {
            return urlOrFile.name
        } else if (isString$2(urlOrFile)) {

            let index = urlOrFile.lastIndexOf("/");
            let filename = index < 0 ? urlOrFile : urlOrFile.substr(index + 1);

            //Strip parameters -- handle local files later
            index = filename.indexOf("?");
            if (index > 0) {
                filename = filename.substr(0, index);
            }
            return filename
        } else {
            throw Error(`Expected File or string, got ${typeof urlOrFile}`)
        }
    }


    /**
     * Test if object is a File or File-like object.
     *
     * @param object
     */
    function isFile(object) {
        if(!object) {
            return false;
        }
        return typeof object !== 'function' &&
            (object instanceof File ||
                (object.hasOwnProperty("name") && typeof object.slice === 'function' && typeof object.arrayBuffer === 'function'))
    }

    function download(filename, data) {

        const element = document.createElement('a');
        element.setAttribute('href', data);
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    if (typeof process === 'object' && typeof window === 'undefined') {
        global.atob = function (str) {
            return Buffer.from(str, 'base64').toString('binary');
        };
    }


    function parseUri(str) {

        var o = options,
            m = o.parser["loose"].exec(str),
            uri = {},
            i = 14;

        while (i--) uri[o.key[i]] = m[i] || "";

        uri[o.q.name] = {};
        uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
            if ($1) uri[o.q.name][$1] = $2;
        });

        return uri;
    }

    const options = {
        strictMode: false,
        key: ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"],
        q: {
            name: "queryKey",
            parser: /(?:^|&)([^&=]*)=?([^&]*)/g
        },
        parser: {
            strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
            loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
        }
    };

    /**
     * Resolve a url, which might be a string, function (that returns a string or Promse), or Promise (that resolves to a string)
     *
     * @param url
     * @returns {Promise<*>}
     */
    async function resolveURL(url) {
        return (typeof url === 'function')  ?  url() :  url;
    }

    /*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    /* eslint-disable space-unary-ops */

    /* Public constants ==========================================================*/
    /* ===========================================================================*/


    //const Z_FILTERED          = 1;
    //const Z_HUFFMAN_ONLY      = 2;
    //const Z_RLE               = 3;
    const Z_FIXED$1               = 4;
    //const Z_DEFAULT_STRATEGY  = 0;

    /* Possible values of the data_type field (though see inflate()) */
    const Z_BINARY              = 0;
    const Z_TEXT                = 1;
    //const Z_ASCII             = 1; // = Z_TEXT
    const Z_UNKNOWN$1             = 2;

    /*============================================================================*/


    function zero$1$1(buf) { let len = buf.length; while (--len >= 0) { buf[len] = 0; } }

    // From zutil.h

    const STORED_BLOCK = 0;
    const STATIC_TREES = 1;
    const DYN_TREES    = 2;
    /* The three kinds of block type */

    const MIN_MATCH$1$1    = 3;
    const MAX_MATCH$1$1    = 258;
    /* The minimum and maximum match lengths */

    // From deflate.h
    /* ===========================================================================
     * Internal compression state.
     */

    const LENGTH_CODES$1$1  = 29;
    /* number of length codes, not counting the special END_BLOCK code */

    const LITERALS$1$1      = 256;
    /* number of literal bytes 0..255 */

    const L_CODES$1$1       = LITERALS$1$1 + 1 + LENGTH_CODES$1$1;
    /* number of Literal or Length codes, including the END_BLOCK code */

    const D_CODES$1$1       = 30;
    /* number of distance codes */

    const BL_CODES$1      = 19;
    /* number of codes used to transfer the bit lengths */

    const HEAP_SIZE$1     = 2 * L_CODES$1$1 + 1;
    /* maximum heap size */

    const MAX_BITS$1      = 15;
    /* All codes must not exceed MAX_BITS bits */

    const Buf_size      = 16;
    /* size of bit buffer in bi_buf */


    /* ===========================================================================
     * Constants
     */

    const MAX_BL_BITS = 7;
    /* Bit length codes must not exceed MAX_BL_BITS bits */

    const END_BLOCK   = 256;
    /* end of block literal code */

    const REP_3_6     = 16;
    /* repeat previous bit length 3-6 times (2 bits of repeat count) */

    const REPZ_3_10   = 17;
    /* repeat a zero length 3-10 times  (3 bits of repeat count) */

    const REPZ_11_138 = 18;
    /* repeat a zero length 11-138 times  (7 bits of repeat count) */

    /* eslint-disable comma-spacing,array-bracket-spacing */
    const extra_lbits =   /* extra bits for each length code */
      new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]);

    const extra_dbits =   /* extra bits for each distance code */
      new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]);

    const extra_blbits =  /* extra bits for each bit length code */
      new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]);

    const bl_order =
      new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);
    /* eslint-enable comma-spacing,array-bracket-spacing */

    /* The lengths of the bit length codes are sent in order of decreasing
     * probability, to avoid transmitting the lengths for unused bit length codes.
     */

    /* ===========================================================================
     * Local data. These are initialized only once.
     */

    // We pre-fill arrays with 0 to avoid uninitialized gaps

    const DIST_CODE_LEN$1 = 512; /* see definition of array dist_code below */

    // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
    const static_ltree$1  = new Array((L_CODES$1$1 + 2) * 2);
    zero$1$1(static_ltree$1);
    /* The static literal tree. Since the bit lengths are imposed, there is no
     * need for the L_CODES extra codes used during heap construction. However
     * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
     * below).
     */

    const static_dtree$1  = new Array(D_CODES$1$1 * 2);
    zero$1$1(static_dtree$1);
    /* The static distance tree. (Actually a trivial tree since all codes use
     * 5 bits.)
     */

    const _dist_code$1    = new Array(DIST_CODE_LEN$1);
    zero$1$1(_dist_code$1);
    /* Distance codes. The first 256 values correspond to the distances
     * 3 .. 258, the last 256 values correspond to the top 8 bits of
     * the 15 bit distances.
     */

    const _length_code$1  = new Array(MAX_MATCH$1$1 - MIN_MATCH$1$1 + 1);
    zero$1$1(_length_code$1);
    /* length code for each normalized match length (0 == MIN_MATCH) */

    const base_length$1   = new Array(LENGTH_CODES$1$1);
    zero$1$1(base_length$1);
    /* First normalized length for each code (0 = MIN_MATCH) */

    const base_dist$1     = new Array(D_CODES$1$1);
    zero$1$1(base_dist$1);
    /* First normalized distance for each code (0 = distance of 1) */


    function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

      this.static_tree  = static_tree;  /* static tree or NULL */
      this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
      this.extra_base   = extra_base;   /* base index for extra_bits */
      this.elems        = elems;        /* max number of elements in the tree */
      this.max_length   = max_length;   /* max bit length for the codes */

      // show if `static_tree` has data or dummy - needed for monomorphic objects
      this.has_stree    = static_tree && static_tree.length;
    }


    let static_l_desc;
    let static_d_desc;
    let static_bl_desc;


    function TreeDesc(dyn_tree, stat_desc) {
      this.dyn_tree = dyn_tree;     /* the dynamic tree */
      this.max_code = 0;            /* largest code with non zero frequency */
      this.stat_desc = stat_desc;   /* the corresponding static tree */
    }



    const d_code = (dist) => {

      return dist < 256 ? _dist_code$1[dist] : _dist_code$1[256 + (dist >>> 7)];
    };


    /* ===========================================================================
     * Output a short LSB first on the stream.
     * IN assertion: there is enough room in pendingBuf.
     */
    const put_short = (s, w) => {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
      s.pending_buf[s.pending++] = (w) & 0xff;
      s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
    };


    /* ===========================================================================
     * Send a value on a given number of bits.
     * IN assertion: length <= 16 and value fits in length bits.
     */
    const send_bits = (s, value, length) => {

      if (s.bi_valid > (Buf_size - length)) {
        s.bi_buf |= (value << s.bi_valid) & 0xffff;
        put_short(s, s.bi_buf);
        s.bi_buf = value >> (Buf_size - s.bi_valid);
        s.bi_valid += length - Buf_size;
      } else {
        s.bi_buf |= (value << s.bi_valid) & 0xffff;
        s.bi_valid += length;
      }
    };


    const send_code = (s, c, tree) => {

      send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
    };


    /* ===========================================================================
     * Reverse the first len bits of a code, using straightforward code (a faster
     * method would use a table)
     * IN assertion: 1 <= len <= 15
     */
    const bi_reverse = (code, len) => {

      let res = 0;
      do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
      } while (--len > 0);
      return res >>> 1;
    };


    /* ===========================================================================
     * Flush the bit buffer, keeping at most 7 bits in it.
     */
    const bi_flush = (s) => {

      if (s.bi_valid === 16) {
        put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;

      } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
      }
    };


    /* ===========================================================================
     * Compute the optimal bit lengths for a tree and update the total bit length
     * for the current block.
     * IN assertion: the fields freq and dad are set, heap[heap_max] and
     *    above are the tree nodes sorted by increasing frequency.
     * OUT assertions: the field len is set to the optimal bit length, the
     *     array bl_count contains the frequencies for each bit length.
     *     The length opt_len is updated; static_len is also updated if stree is
     *     not null.
     */
    const gen_bitlen = (s, desc) => {
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */

      const tree            = desc.dyn_tree;
      const max_code        = desc.max_code;
      const stree           = desc.stat_desc.static_tree;
      const has_stree       = desc.stat_desc.has_stree;
      const extra           = desc.stat_desc.extra_bits;
      const base            = desc.stat_desc.extra_base;
      const max_length      = desc.stat_desc.max_length;
      let h;              /* heap index */
      let n, m;           /* iterate over the tree elements */
      let bits;           /* bit length */
      let xbits;          /* extra bits */
      let f;              /* frequency */
      let overflow = 0;   /* number of elements with bit length too large */

      for (bits = 0; bits <= MAX_BITS$1; bits++) {
        s.bl_count[bits] = 0;
      }

      /* In a first pass, compute the optimal bit lengths (which may
       * overflow in the case of the bit length tree).
       */
      tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

      for (h = s.heap_max + 1; h < HEAP_SIZE$1; h++) {
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
        if (bits > max_length) {
          bits = max_length;
          overflow++;
        }
        tree[n * 2 + 1]/*.Len*/ = bits;
        /* We overwrite tree[n].Dad which is no longer needed */

        if (n > max_code) { continue; } /* not a leaf node */

        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) {
          xbits = extra[n - base];
        }
        f = tree[n * 2]/*.Freq*/;
        s.opt_len += f * (bits + xbits);
        if (has_stree) {
          s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
        }
      }
      if (overflow === 0) { return; }

      // Tracev((stderr,"\nbit length overflow\n"));
      /* This happens for example on obj2 and pic of the Calgary corpus */

      /* Find the first bit length which could increase: */
      do {
        bits = max_length - 1;
        while (s.bl_count[bits] === 0) { bits--; }
        s.bl_count[bits]--;      /* move one leaf down the tree */
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
         * but this does not affect bl_count[max_length]
         */
        overflow -= 2;
      } while (overflow > 0);

      /* Now recompute all bit lengths, scanning in increasing frequency.
       * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
       * lengths instead of fixing only the wrong ones. This idea is taken
       * from 'ar' written by Haruhiko Okumura.)
       */
      for (bits = max_length; bits !== 0; bits--) {
        n = s.bl_count[bits];
        while (n !== 0) {
          m = s.heap[--h];
          if (m > max_code) { continue; }
          if (tree[m * 2 + 1]/*.Len*/ !== bits) {
            // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
            s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
            tree[m * 2 + 1]/*.Len*/ = bits;
          }
          n--;
        }
      }
    };


    /* ===========================================================================
     * Generate the codes for a given tree and bit counts (which need not be
     * optimal).
     * IN assertion: the array bl_count contains the bit length statistics for
     * the given tree and the field len is set for all tree elements.
     * OUT assertion: the field code is set for all tree elements of non
     *     zero code length.
     */
    const gen_codes = (tree, max_code, bl_count) => {
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */

      const next_code = new Array(MAX_BITS$1 + 1); /* next code value for each bit length */
      let code = 0;              /* running code value */
      let bits;                  /* bit index */
      let n;                     /* code index */

      /* The distribution counts are first used to generate the code values
       * without bit reversal.
       */
      for (bits = 1; bits <= MAX_BITS$1; bits++) {
        code = (code + bl_count[bits - 1]) << 1;
        next_code[bits] = code;
      }
      /* Check that the bit counts in bl_count are consistent. The last code
       * must be all ones.
       */
      //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
      //        "inconsistent bit counts");
      //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

      for (n = 0;  n <= max_code; n++) {
        let len = tree[n * 2 + 1]/*.Len*/;
        if (len === 0) { continue; }
        /* Now reverse the bits */
        tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

        //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
        //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
      }
    };


    /* ===========================================================================
     * Initialize the various 'constant' tables.
     */
    const tr_static_init = () => {

      let n;        /* iterates over tree elements */
      let bits;     /* bit counter */
      let length;   /* length value */
      let code;     /* code value */
      let dist;     /* distance index */
      const bl_count = new Array(MAX_BITS$1 + 1);
      /* number of codes at each bit length for an optimal tree */

      // do check in _tr_init()
      //if (static_init_done) return;

      /* For some embedded targets, global variables are not initialized: */
    /*#ifdef NO_INIT_GLOBAL_POINTERS
      static_l_desc.static_tree = static_ltree;
      static_l_desc.extra_bits = extra_lbits;
      static_d_desc.static_tree = static_dtree;
      static_d_desc.extra_bits = extra_dbits;
      static_bl_desc.extra_bits = extra_blbits;
    #endif*/

      /* Initialize the mapping length (0..255) -> length code (0..28) */
      length = 0;
      for (code = 0; code < LENGTH_CODES$1$1 - 1; code++) {
        base_length$1[code] = length;
        for (n = 0; n < (1 << extra_lbits[code]); n++) {
          _length_code$1[length++] = code;
        }
      }
      //Assert (length == 256, "tr_static_init: length != 256");
      /* Note that the length 255 (match length 258) can be represented
       * in two different ways: code 284 + 5 bits or code 285, so we
       * overwrite length_code[255] to use the best encoding:
       */
      _length_code$1[length - 1] = code;

      /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
      dist = 0;
      for (code = 0; code < 16; code++) {
        base_dist$1[code] = dist;
        for (n = 0; n < (1 << extra_dbits[code]); n++) {
          _dist_code$1[dist++] = code;
        }
      }
      //Assert (dist == 256, "tr_static_init: dist != 256");
      dist >>= 7; /* from now on, all distances are divided by 128 */
      for (; code < D_CODES$1$1; code++) {
        base_dist$1[code] = dist << 7;
        for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
          _dist_code$1[256 + dist++] = code;
        }
      }
      //Assert (dist == 256, "tr_static_init: 256+dist != 512");

      /* Construct the codes of the static literal tree */
      for (bits = 0; bits <= MAX_BITS$1; bits++) {
        bl_count[bits] = 0;
      }

      n = 0;
      while (n <= 143) {
        static_ltree$1[n * 2 + 1]/*.Len*/ = 8;
        n++;
        bl_count[8]++;
      }
      while (n <= 255) {
        static_ltree$1[n * 2 + 1]/*.Len*/ = 9;
        n++;
        bl_count[9]++;
      }
      while (n <= 279) {
        static_ltree$1[n * 2 + 1]/*.Len*/ = 7;
        n++;
        bl_count[7]++;
      }
      while (n <= 287) {
        static_ltree$1[n * 2 + 1]/*.Len*/ = 8;
        n++;
        bl_count[8]++;
      }
      /* Codes 286 and 287 do not exist, but we must include them in the
       * tree construction to get a canonical Huffman tree (longest code
       * all ones)
       */
      gen_codes(static_ltree$1, L_CODES$1$1 + 1, bl_count);

      /* The static distance tree is trivial: */
      for (n = 0; n < D_CODES$1$1; n++) {
        static_dtree$1[n * 2 + 1]/*.Len*/ = 5;
        static_dtree$1[n * 2]/*.Code*/ = bi_reverse(n, 5);
      }

      // Now data ready and we can init static trees
      static_l_desc = new StaticTreeDesc(static_ltree$1, extra_lbits, LITERALS$1$1 + 1, L_CODES$1$1, MAX_BITS$1);
      static_d_desc = new StaticTreeDesc(static_dtree$1, extra_dbits, 0,          D_CODES$1$1, MAX_BITS$1);
      static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES$1, MAX_BL_BITS);

      //static_init_done = true;
    };


    /* ===========================================================================
     * Initialize a new block.
     */
    const init_block = (s) => {

      let n; /* iterates over tree elements */

      /* Initialize the trees. */
      for (n = 0; n < L_CODES$1$1;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
      for (n = 0; n < D_CODES$1$1;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
      for (n = 0; n < BL_CODES$1; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

      s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
      s.opt_len = s.static_len = 0;
      s.sym_next = s.matches = 0;
    };


    /* ===========================================================================
     * Flush the bit buffer and align the output on a byte boundary
     */
    const bi_windup = (s) =>
    {
      if (s.bi_valid > 8) {
        put_short(s, s.bi_buf);
      } else if (s.bi_valid > 0) {
        //put_byte(s, (Byte)s->bi_buf);
        s.pending_buf[s.pending++] = s.bi_buf;
      }
      s.bi_buf = 0;
      s.bi_valid = 0;
    };

    /* ===========================================================================
     * Compares to subtrees, using the tree depth as tie breaker when
     * the subtrees have equal frequency. This minimizes the worst case length.
     */
    const smaller = (tree, n, m, depth) => {

      const _n2 = n * 2;
      const _m2 = m * 2;
      return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
             (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
    };

    /* ===========================================================================
     * Restore the heap property by moving down the tree starting at node k,
     * exchanging a node with the smallest of its two sons if necessary, stopping
     * when the heap property is re-established (each father smaller than its
     * two sons).
     */
    const pqdownheap = (s, tree, k) => {
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */

      const v = s.heap[k];
      let j = k << 1;  /* left son of k */
      while (j <= s.heap_len) {
        /* Set j to the smallest of the two sons: */
        if (j < s.heap_len &&
          smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
          j++;
        }
        /* Exit if v is smaller than both sons */
        if (smaller(tree, v, s.heap[j], s.depth)) { break; }

        /* Exchange v with the smallest son */
        s.heap[k] = s.heap[j];
        k = j;

        /* And continue down the tree, setting j to the left son of k */
        j <<= 1;
      }
      s.heap[k] = v;
    };


    // inlined manually
    // const SMALLEST = 1;

    /* ===========================================================================
     * Send the block data compressed using the given Huffman trees
     */
    const compress_block = (s, ltree, dtree) => {
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */

      let dist;           /* distance of matched string */
      let lc;             /* match length or unmatched char (if dist == 0) */
      let sx = 0;         /* running index in sym_buf */
      let code;           /* the code to send */
      let extra;          /* number of extra bits to send */

      if (s.sym_next !== 0) {
        do {
          dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
          dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
          lc = s.pending_buf[s.sym_buf + sx++];
          if (dist === 0) {
            send_code(s, lc, ltree); /* send a literal byte */
            //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
          } else {
            /* Here, lc is the match length - MIN_MATCH */
            code = _length_code$1[lc];
            send_code(s, code + LITERALS$1$1 + 1, ltree); /* send the length code */
            extra = extra_lbits[code];
            if (extra !== 0) {
              lc -= base_length$1[code];
              send_bits(s, lc, extra);       /* send the extra length bits */
            }
            dist--; /* dist is now the match distance - 1 */
            code = d_code(dist);
            //Assert (code < D_CODES, "bad d_code");

            send_code(s, code, dtree);       /* send the distance code */
            extra = extra_dbits[code];
            if (extra !== 0) {
              dist -= base_dist$1[code];
              send_bits(s, dist, extra);   /* send the extra distance bits */
            }
          } /* literal or match pair ? */

          /* Check that the overlay between pending_buf and sym_buf is ok: */
          //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");

        } while (sx < s.sym_next);
      }

      send_code(s, END_BLOCK, ltree);
    };


    /* ===========================================================================
     * Construct one Huffman tree and assigns the code bit strings and lengths.
     * Update the total bit length for the current block.
     * IN assertion: the field freq is set for all tree elements.
     * OUT assertions: the fields len and code are set to the optimal bit length
     *     and corresponding code. The length opt_len is updated; static_len is
     *     also updated if stree is not null. The field max_code is set.
     */
    const build_tree = (s, desc) => {
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */

      const tree     = desc.dyn_tree;
      const stree    = desc.stat_desc.static_tree;
      const has_stree = desc.stat_desc.has_stree;
      const elems    = desc.stat_desc.elems;
      let n, m;          /* iterate over heap elements */
      let max_code = -1; /* largest code with non zero frequency */
      let node;          /* new node being created */

      /* Construct the initial heap, with least frequent element in
       * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
       * heap[0] is not used.
       */
      s.heap_len = 0;
      s.heap_max = HEAP_SIZE$1;

      for (n = 0; n < elems; n++) {
        if (tree[n * 2]/*.Freq*/ !== 0) {
          s.heap[++s.heap_len] = max_code = n;
          s.depth[n] = 0;

        } else {
          tree[n * 2 + 1]/*.Len*/ = 0;
        }
      }

      /* The pkzip format requires that at least one distance code exists,
       * and that at least one bit should be sent even if there is only one
       * possible code. So to avoid special checks later on we force at least
       * two codes of non zero frequency.
       */
      while (s.heap_len < 2) {
        node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
        tree[node * 2]/*.Freq*/ = 1;
        s.depth[node] = 0;
        s.opt_len--;

        if (has_stree) {
          s.static_len -= stree[node * 2 + 1]/*.Len*/;
        }
        /* node is 0 or 1 so it does not have extra bits */
      }
      desc.max_code = max_code;

      /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
       * establish sub-heaps of increasing lengths:
       */
      for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

      /* Construct the Huffman tree by repeatedly combining the least two
       * frequent nodes.
       */
      node = elems;              /* next internal node of the tree */
      do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/
        n = s.heap[1/*SMALLEST*/];
        s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
        pqdownheap(s, tree, 1/*SMALLEST*/);
        /***/

        m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
        s.heap[--s.heap_max] = m;

        /* Create a new node father of n and m */
        tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

        /* and insert the new node in the heap */
        s.heap[1/*SMALLEST*/] = node++;
        pqdownheap(s, tree, 1/*SMALLEST*/);

      } while (s.heap_len >= 2);

      s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

      /* At this point, the fields freq and dad are set. We can now
       * generate the bit lengths.
       */
      gen_bitlen(s, desc);

      /* The field len is now set, we can generate the bit codes */
      gen_codes(tree, max_code, s.bl_count);
    };


    /* ===========================================================================
     * Scan a literal or distance tree to determine the frequencies of the codes
     * in the bit length tree.
     */
    const scan_tree = (s, tree, max_code) => {
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */

      let n;                     /* iterates over all tree elements */
      let prevlen = -1;          /* last emitted length */
      let curlen;                /* length of current code */

      let nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

      let count = 0;             /* repeat count of the current code */
      let max_count = 7;         /* max repeat count */
      let min_count = 4;         /* min repeat count */

      if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
      }
      tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

      for (n = 0; n <= max_code; n++) {
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

        if (++count < max_count && curlen === nextlen) {
          continue;

        } else if (count < min_count) {
          s.bl_tree[curlen * 2]/*.Freq*/ += count;

        } else if (curlen !== 0) {

          if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
          s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

        } else if (count <= 10) {
          s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

        } else {
          s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
        }

        count = 0;
        prevlen = curlen;

        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;

        } else if (curlen === nextlen) {
          max_count = 6;
          min_count = 3;

        } else {
          max_count = 7;
          min_count = 4;
        }
      }
    };


    /* ===========================================================================
     * Send a literal or distance tree in compressed form, using the codes in
     * bl_tree.
     */
    const send_tree = (s, tree, max_code) => {
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */

      let n;                     /* iterates over all tree elements */
      let prevlen = -1;          /* last emitted length */
      let curlen;                /* length of current code */

      let nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

      let count = 0;             /* repeat count of the current code */
      let max_count = 7;         /* max repeat count */
      let min_count = 4;         /* min repeat count */

      /* tree[max_code+1].Len = -1; */  /* guard already set */
      if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
      }

      for (n = 0; n <= max_code; n++) {
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

        if (++count < max_count && curlen === nextlen) {
          continue;

        } else if (count < min_count) {
          do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

        } else if (curlen !== 0) {
          if (curlen !== prevlen) {
            send_code(s, curlen, s.bl_tree);
            count--;
          }
          //Assert(count >= 3 && count <= 6, " 3_6?");
          send_code(s, REP_3_6, s.bl_tree);
          send_bits(s, count - 3, 2);

        } else if (count <= 10) {
          send_code(s, REPZ_3_10, s.bl_tree);
          send_bits(s, count - 3, 3);

        } else {
          send_code(s, REPZ_11_138, s.bl_tree);
          send_bits(s, count - 11, 7);
        }

        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;

        } else if (curlen === nextlen) {
          max_count = 6;
          min_count = 3;

        } else {
          max_count = 7;
          min_count = 4;
        }
      }
    };


    /* ===========================================================================
     * Construct the Huffman tree for the bit lengths and return the index in
     * bl_order of the last bit length code to send.
     */
    const build_bl_tree = (s) => {

      let max_blindex;  /* index of last bit length code of non zero freq */

      /* Determine the bit length frequencies for literal and distance trees */
      scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
      scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

      /* Build the bit length tree: */
      build_tree(s, s.bl_desc);
      /* opt_len now includes the length of the tree representations, except
       * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
       */

      /* Determine the number of bit length codes to send. The pkzip format
       * requires that at least 4 bit length codes be sent. (appnote.txt says
       * 3 but the actual value used is 4.)
       */
      for (max_blindex = BL_CODES$1 - 1; max_blindex >= 3; max_blindex--) {
        if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
          break;
        }
      }
      /* Update opt_len to include the bit length tree and counts */
      s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
      //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
      //        s->opt_len, s->static_len));

      return max_blindex;
    };


    /* ===========================================================================
     * Send the header for a block using dynamic Huffman trees: the counts, the
     * lengths of the bit length codes, the literal tree and the distance tree.
     * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
     */
    const send_all_trees = (s, lcodes, dcodes, blcodes) => {
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */

      let rank;                    /* index in bl_order */

      //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
      //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
      //        "too many codes");
      //Tracev((stderr, "\nbl counts: "));
      send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
      send_bits(s, dcodes - 1,   5);
      send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
      for (rank = 0; rank < blcodes; rank++) {
        //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
        send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
      }
      //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

      send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
      //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

      send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
      //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
    };


    /* ===========================================================================
     * Check if the data type is TEXT or BINARY, using the following algorithm:
     * - TEXT if the two conditions below are satisfied:
     *    a) There are no non-portable control characters belonging to the
     *       "block list" (0..6, 14..25, 28..31).
     *    b) There is at least one printable character belonging to the
     *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
     * - BINARY otherwise.
     * - The following partially-portable control characters form a
     *   "gray list" that is ignored in this detection algorithm:
     *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
     * IN assertion: the fields Freq of dyn_ltree are set.
     */
    const detect_data_type = (s) => {
      /* block_mask is the bit mask of block-listed bytes
       * set bits 0..6, 14..25, and 28..31
       * 0xf3ffc07f = binary 11110011111111111100000001111111
       */
      let block_mask = 0xf3ffc07f;
      let n;

      /* Check for non-textual ("block-listed") bytes. */
      for (n = 0; n <= 31; n++, block_mask >>>= 1) {
        if ((block_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
          return Z_BINARY;
        }
      }

      /* Check for textual ("allow-listed") bytes. */
      if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
          s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
        return Z_TEXT;
      }
      for (n = 32; n < LITERALS$1$1; n++) {
        if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
          return Z_TEXT;
        }
      }

      /* There are no "block-listed" or "allow-listed" bytes:
       * this stream either is empty or has tolerated ("gray-listed") bytes only.
       */
      return Z_BINARY;
    };


    let static_init_done = false;

    /* ===========================================================================
     * Initialize the tree data structures for a new zlib stream.
     */
    const _tr_init$1 = (s) =>
    {

      if (!static_init_done) {
        tr_static_init();
        static_init_done = true;
      }

      s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
      s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
      s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

      s.bi_buf = 0;
      s.bi_valid = 0;

      /* Initialize the first block of the first file: */
      init_block(s);
    };


    /* ===========================================================================
     * Send a stored block
     */
    const _tr_stored_block$1 = (s, buf, stored_len, last) => {
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */

      send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
      bi_windup(s);        /* align on byte boundary */
      put_short(s, stored_len);
      put_short(s, ~stored_len);
      if (stored_len) {
        s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
      }
      s.pending += stored_len;
    };


    /* ===========================================================================
     * Send one empty static block to give enough lookahead for inflate.
     * This takes 10 bits, of which 7 may remain in the bit buffer.
     */
    const _tr_align$1 = (s) => {
      send_bits(s, STATIC_TREES << 1, 3);
      send_code(s, END_BLOCK, static_ltree$1);
      bi_flush(s);
    };


    /* ===========================================================================
     * Determine the best encoding for the current block: dynamic trees, static
     * trees or store, and write out the encoded block.
     */
    const _tr_flush_block$1 = (s, buf, stored_len, last) => {
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */

      let opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
      let max_blindex = 0;        /* index of last bit length code of non zero freq */

      /* Build the Huffman trees unless a stored block is forced */
      if (s.level > 0) {

        /* Check if the file is binary or text */
        if (s.strm.data_type === Z_UNKNOWN$1) {
          s.strm.data_type = detect_data_type(s);
        }

        /* Construct the literal and distance trees */
        build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));

        build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
         * the compressed block data, excluding the tree representations.
         */

        /* Build the bit length tree for the above two trees, and get the index
         * in bl_order of the last bit length code to send.
         */
        max_blindex = build_bl_tree(s);

        /* Determine the best encoding. Compute the block lengths in bytes. */
        opt_lenb = (s.opt_len + 3 + 7) >>> 3;
        static_lenb = (s.static_len + 3 + 7) >>> 3;

        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));

        if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

      } else {
        // Assert(buf != (char*)0, "lost buf");
        opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
      }

      if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
        /* 4: two words for the lengths */

        /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
         * Otherwise we can't have processed more than WSIZE input bytes since
         * the last block flush, because compression would have been
         * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
         * transform a block into a stored block.
         */
        _tr_stored_block$1(s, buf, stored_len, last);

      } else if (s.strategy === Z_FIXED$1 || static_lenb === opt_lenb) {

        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
        compress_block(s, static_ltree$1, static_dtree$1);

      } else {
        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        compress_block(s, s.dyn_ltree, s.dyn_dtree);
      }
      // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
      /* The above check is made mod 2^32, for files larger than 512 MB
       * and uLong implemented on 32 bits.
       */
      init_block(s);

      if (last) {
        bi_windup(s);
      }
      // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
      //       s->compressed_len-7*last));
    };

    /* ===========================================================================
     * Save the match info and tally the frequency counts. Return true if
     * the current block must be flushed.
     */
    const _tr_tally$1 = (s, dist, lc) => {
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */

      s.pending_buf[s.sym_buf + s.sym_next++] = dist;
      s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
      s.pending_buf[s.sym_buf + s.sym_next++] = lc;
      if (dist === 0) {
        /* lc is the unmatched char */
        s.dyn_ltree[lc * 2]/*.Freq*/++;
      } else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */
        dist--;             /* dist = match distance - 1 */
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

        s.dyn_ltree[(_length_code$1[lc] + LITERALS$1$1 + 1) * 2]/*.Freq*/++;
        s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
      }

      return (s.sym_next === s.sym_end);
    };

    var _tr_init_1  = _tr_init$1;
    var _tr_stored_block_1 = _tr_stored_block$1;
    var _tr_flush_block_1  = _tr_flush_block$1;
    var _tr_tally_1 = _tr_tally$1;
    var _tr_align_1 = _tr_align$1;

    var trees = {
    	_tr_init: _tr_init_1,
    	_tr_stored_block: _tr_stored_block_1,
    	_tr_flush_block: _tr_flush_block_1,
    	_tr_tally: _tr_tally_1,
    	_tr_align: _tr_align_1
    };

    // Note: adler32 takes 12% for level 0 and 2% for level 6.
    // It isn't worth it to make additional optimizations as in original.
    // Small size is preferable.

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    const adler32$1 = (adler, buf, len, pos) => {
      let s1 = (adler & 0xffff) |0,
          s2 = ((adler >>> 16) & 0xffff) |0,
          n = 0;

      while (len !== 0) {
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;

        do {
          s1 = (s1 + buf[pos++]) |0;
          s2 = (s2 + s1) |0;
        } while (--n);

        s1 %= 65521;
        s2 %= 65521;
      }

      return (s1 | (s2 << 16)) |0;
    };


    var adler32_1$1 = adler32$1;

    // Note: we can't get significant speed boost here.
    // So write code to minimize size - no pregenerated tables
    // and array tools dependencies.

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    // Use ordinary array, since untyped makes no boost here
    const makeTable$1 = () => {
      let c, table = [];

      for (var n = 0; n < 256; n++) {
        c = n;
        for (var k = 0; k < 8; k++) {
          c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
        }
        table[n] = c;
      }

      return table;
    };

    // Create table on load. Just 255 signed longs. Not a problem.
    const crcTable$1 = new Uint32Array(makeTable$1());


    const crc32$1 = (crc, buf, len, pos) => {
      const t = crcTable$1;
      const end = pos + len;

      crc ^= -1;

      for (let i = pos; i < end; i++) {
        crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
      }

      return (crc ^ (-1)); // >>> 0;
    };


    var crc32_1$1 = crc32$1;

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    var messages$1 = {
      2:      'need dictionary',     /* Z_NEED_DICT       2  */
      1:      'stream end',          /* Z_STREAM_END      1  */
      0:      '',                    /* Z_OK              0  */
      '-1':   'file error',          /* Z_ERRNO         (-1) */
      '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
      '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
      '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
      '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
      '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
    };

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    var constants$2$1 = {

      /* Allowed flush values; see deflate() and inflate() below for details */
      Z_NO_FLUSH:         0,
      Z_PARTIAL_FLUSH:    1,
      Z_SYNC_FLUSH:       2,
      Z_FULL_FLUSH:       3,
      Z_FINISH:           4,
      Z_BLOCK:            5,
      Z_TREES:            6,

      /* Return codes for the compression/decompression functions. Negative values
      * are errors, positive values are used for special but normal events.
      */
      Z_OK:               0,
      Z_STREAM_END:       1,
      Z_NEED_DICT:        2,
      Z_ERRNO:           -1,
      Z_STREAM_ERROR:    -2,
      Z_DATA_ERROR:      -3,
      Z_MEM_ERROR:       -4,
      Z_BUF_ERROR:       -5,
      //Z_VERSION_ERROR: -6,

      /* compression levels */
      Z_NO_COMPRESSION:         0,
      Z_BEST_SPEED:             1,
      Z_BEST_COMPRESSION:       9,
      Z_DEFAULT_COMPRESSION:   -1,


      Z_FILTERED:               1,
      Z_HUFFMAN_ONLY:           2,
      Z_RLE:                    3,
      Z_FIXED:                  4,
      Z_DEFAULT_STRATEGY:       0,

      /* Possible values of the data_type field (though see inflate()) */
      Z_BINARY:                 0,
      Z_TEXT:                   1,
      //Z_ASCII:                1, // = Z_TEXT (deprecated)
      Z_UNKNOWN:                2,

      /* The deflate compression method */
      Z_DEFLATED:               8
      //Z_NULL:                 null // Use -1 or null inline, depending on var type
    };

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    const { _tr_init, _tr_stored_block, _tr_flush_block, _tr_tally, _tr_align } = trees;




    /* Public constants ==========================================================*/
    /* ===========================================================================*/

    const {
      Z_NO_FLUSH: Z_NO_FLUSH$2, Z_PARTIAL_FLUSH, Z_FULL_FLUSH: Z_FULL_FLUSH$1, Z_FINISH: Z_FINISH$3, Z_BLOCK: Z_BLOCK$1,
      Z_OK: Z_OK$3, Z_STREAM_END: Z_STREAM_END$3, Z_STREAM_ERROR: Z_STREAM_ERROR$2, Z_DATA_ERROR: Z_DATA_ERROR$2, Z_BUF_ERROR: Z_BUF_ERROR$1,
      Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1,
      Z_FILTERED, Z_HUFFMAN_ONLY, Z_RLE, Z_FIXED, Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1,
      Z_UNKNOWN,
      Z_DEFLATED: Z_DEFLATED$2
    } = constants$2$1;

    /*============================================================================*/


    const MAX_MEM_LEVEL = 9;
    /* Maximum value for memLevel in deflateInit2 */
    const MAX_WBITS$1 = 15;
    /* 32K LZ77 window */
    const DEF_MEM_LEVEL = 8;


    const LENGTH_CODES  = 29;
    /* number of length codes, not counting the special END_BLOCK code */
    const LITERALS      = 256;
    /* number of literal bytes 0..255 */
    const L_CODES       = LITERALS + 1 + LENGTH_CODES;
    /* number of Literal or Length codes, including the END_BLOCK code */
    const D_CODES       = 30;
    /* number of distance codes */
    const BL_CODES      = 19;
    /* number of codes used to transfer the bit lengths */
    const HEAP_SIZE     = 2 * L_CODES + 1;
    /* maximum heap size */
    const MAX_BITS  = 15;
    /* All codes must not exceed MAX_BITS bits */

    const MIN_MATCH = 3;
    const MAX_MATCH = 258;
    const MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

    const PRESET_DICT = 0x20;

    const INIT_STATE    =  42;    /* zlib header -> BUSY_STATE */
    //#ifdef GZIP
    const GZIP_STATE    =  57;    /* gzip header -> BUSY_STATE | EXTRA_STATE */
    //#endif
    const EXTRA_STATE   =  69;    /* gzip extra block -> NAME_STATE */
    const NAME_STATE    =  73;    /* gzip file name -> COMMENT_STATE */
    const COMMENT_STATE =  91;    /* gzip comment -> HCRC_STATE */
    const HCRC_STATE    = 103;    /* gzip header CRC -> BUSY_STATE */
    const BUSY_STATE    = 113;    /* deflate -> FINISH_STATE */
    const FINISH_STATE  = 666;    /* stream complete */

    const BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
    const BS_BLOCK_DONE     = 2; /* block flush performed */
    const BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
    const BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

    const OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

    const err = (strm, errorCode) => {
      strm.msg = messages$1[errorCode];
      return errorCode;
    };

    const rank = (f) => {
      return ((f) * 2) - ((f) > 4 ? 9 : 0);
    };

    const zero = (buf) => {
      let len = buf.length; while (--len >= 0) { buf[len] = 0; }
    };

    /* ===========================================================================
     * Slide the hash table when sliding the window down (could be avoided with 32
     * bit values at the expense of memory usage). We slide even when level == 0 to
     * keep the hash table consistent if we switch back to level > 0 later.
     */
    const slide_hash = (s) => {
      let n, m;
      let p;
      let wsize = s.w_size;

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= wsize ? m - wsize : 0);
      } while (--n);
      n = wsize;
    //#ifndef FASTEST
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= wsize ? m - wsize : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);
    //#endif
    };

    /* eslint-disable new-cap */
    let HASH_ZLIB = (s, prev, data) => ((prev << s.hash_shift) ^ data) & s.hash_mask;
    // This hash causes less collisions, https://github.com/nodeca/pako/issues/135
    // But breaks binary compatibility
    //let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
    let HASH = HASH_ZLIB;


    /* =========================================================================
     * Flush as much pending output as possible. All deflate() output, except for
     * some deflate_stored() output, goes through this function so some
     * applications may wish to modify it to avoid allocating a large
     * strm->next_out buffer and copying into it. (See also read_buf()).
     */
    const flush_pending = (strm) => {
      const s = strm.state;

      //_tr_flush_bits(s);
      let len = s.pending;
      if (len > strm.avail_out) {
        len = strm.avail_out;
      }
      if (len === 0) { return; }

      strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
      strm.next_out  += len;
      s.pending_out  += len;
      strm.total_out += len;
      strm.avail_out -= len;
      s.pending      -= len;
      if (s.pending === 0) {
        s.pending_out = 0;
      }
    };


    const flush_block_only = (s, last) => {
      _tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
      s.block_start = s.strstart;
      flush_pending(s.strm);
    };


    const put_byte = (s, b) => {
      s.pending_buf[s.pending++] = b;
    };


    /* =========================================================================
     * Put a short in the pending buffer. The 16-bit value is put in MSB order.
     * IN assertion: the stream state is correct and there is enough room in
     * pending_buf.
     */
    const putShortMSB = (s, b) => {

      //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
      s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
      s.pending_buf[s.pending++] = b & 0xff;
    };


    /* ===========================================================================
     * Read a new buffer from the current input stream, update the adler32
     * and total number of bytes read.  All deflate() input goes through
     * this function so some applications may wish to modify it to avoid
     * allocating a large strm->input buffer and copying from it.
     * (See also flush_pending()).
     */
    const read_buf = (strm, buf, start, size) => {

      let len = strm.avail_in;

      if (len > size) { len = size; }
      if (len === 0) { return 0; }

      strm.avail_in -= len;

      // zmemcpy(buf, strm->next_in, len);
      buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
      if (strm.state.wrap === 1) {
        strm.adler = adler32_1$1(strm.adler, buf, len, start);
      }

      else if (strm.state.wrap === 2) {
        strm.adler = crc32_1$1(strm.adler, buf, len, start);
      }

      strm.next_in += len;
      strm.total_in += len;

      return len;
    };


    /* ===========================================================================
     * Set match_start to the longest match starting at the given string and
     * return its length. Matches shorter or equal to prev_length are discarded,
     * in which case the result is equal to prev_length and match_start is
     * garbage.
     * IN assertions: cur_match is the head of the hash chain for the current
     *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
     * OUT assertion: the match length is not greater than s->lookahead.
     */
    const longest_match = (s, cur_match) => {

      let chain_length = s.max_chain_length;      /* max hash chain length */
      let scan = s.strstart; /* current string */
      let match;                       /* matched string */
      let len;                           /* length of current match */
      let best_len = s.prev_length;              /* best match length so far */
      let nice_match = s.nice_match;             /* stop if match long enough */
      const limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
          s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

      const _win = s.window; // shortcut

      const wmask = s.w_mask;
      const prev  = s.prev;

      /* Stop when cur_match becomes <= limit. To simplify the code,
       * we prevent matches with the string of window index 0.
       */

      const strend = s.strstart + MAX_MATCH;
      let scan_end1  = _win[scan + best_len - 1];
      let scan_end   = _win[scan + best_len];

      /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
       * It is easy to get rid of this optimization if necessary.
       */
      // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

      /* Do not waste too much time if we already have a good match: */
      if (s.prev_length >= s.good_match) {
        chain_length >>= 2;
      }
      /* Do not look for matches beyond the end of the input. This is necessary
       * to make deflate deterministic.
       */
      if (nice_match > s.lookahead) { nice_match = s.lookahead; }

      // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

      do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;

        /* Skip to next match if the match length cannot increase
         * or if the match length is less than 2.  Note that the checks below
         * for insufficient lookahead only occur occasionally for performance
         * reasons.  Therefore uninitialized memory will be accessed, and
         * conditional jumps will be made that depend on those values.
         * However the length of the match is limited to the lookahead, so
         * the output of deflate is not affected by the uninitialized values.
         */

        if (_win[match + best_len]     !== scan_end  ||
            _win[match + best_len - 1] !== scan_end1 ||
            _win[match]                !== _win[scan] ||
            _win[++match]              !== _win[scan + 1]) {
          continue;
        }

        /* The check at best_len-1 can be removed because it will be made
         * again later. (This heuristic is not always a win.)
         * It is not necessary to compare scan[2] and match[2] since they
         * are always equal when the other bytes match, given that
         * the hash keys are equal and that HASH_BITS >= 8.
         */
        scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");

        /* We check for insufficient lookahead only every 8th comparison;
         * the 256th check will be made at strstart+258.
         */
        do {
          /*jshint noempty:false*/
        } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
                 _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
                 _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
                 _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
                 scan < strend);

        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

        len = MAX_MATCH - (strend - scan);
        scan = strend - MAX_MATCH;

        if (len > best_len) {
          s.match_start = cur_match;
          best_len = len;
          if (len >= nice_match) {
            break;
          }
          scan_end1  = _win[scan + best_len - 1];
          scan_end   = _win[scan + best_len];
        }
      } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

      if (best_len <= s.lookahead) {
        return best_len;
      }
      return s.lookahead;
    };


    /* ===========================================================================
     * Fill the window when the lookahead becomes insufficient.
     * Updates strstart and lookahead.
     *
     * IN assertion: lookahead < MIN_LOOKAHEAD
     * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
     *    At least one byte has been read, or avail_in == 0; reads are
     *    performed for at least two bytes (required for the zip translate_eol
     *    option -- not supported here).
     */
    const fill_window = (s) => {

      const _w_size = s.w_size;
      let n, more, str;

      //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

      do {
        more = s.window_size - s.lookahead - s.strstart;

        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */
        //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}


        /* If the window is almost full and there is insufficient lookahead,
         * move the upper half to the lower one to make room in the upper half.
         */
        if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

          s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
          s.match_start -= _w_size;
          s.strstart -= _w_size;
          /* we now have strstart >= MAX_DIST */
          s.block_start -= _w_size;
          if (s.insert > s.strstart) {
            s.insert = s.strstart;
          }
          slide_hash(s);
          more += _w_size;
        }
        if (s.strm.avail_in === 0) {
          break;
        }

        /* If there was no sliding:
         *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
         *    more == window_size - lookahead - strstart
         * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
         * => more >= window_size - 2*WSIZE + 2
         * In the BIG_MEM or MMAP case (not yet supported),
         *   window_size == input_size + MIN_LOOKAHEAD  &&
         *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
         * Otherwise, window_size == 2*WSIZE so more >= 2.
         * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
         */
        //Assert(more >= 2, "more < 2");
        n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;

        /* Initialize the hash value now that we have some input: */
        if (s.lookahead + s.insert >= MIN_MATCH) {
          str = s.strstart - s.insert;
          s.ins_h = s.window[str];

          /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
          s.ins_h = HASH(s, s.ins_h, s.window[str + 1]);
    //#if MIN_MATCH != 3
    //        Call update_hash() MIN_MATCH-3 more times
    //#endif
          while (s.insert) {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
            s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);

            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
            s.insert--;
            if (s.lookahead + s.insert < MIN_MATCH) {
              break;
            }
          }
        }
        /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
         * but this is not important since only literal bytes will be emitted.
         */

      } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

      /* If the WIN_INIT bytes after the end of the current data have never been
       * written, then zero those bytes in order to avoid memory check reports of
       * the use of uninitialized (or uninitialised as Julian writes) bytes by
       * the longest match routines.  Update the high water mark for the next
       * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
       * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
       */
    //  if (s.high_water < s.window_size) {
    //    const curr = s.strstart + s.lookahead;
    //    let init = 0;
    //
    //    if (s.high_water < curr) {
    //      /* Previous high water mark below current data -- zero WIN_INIT
    //       * bytes or up to end of window, whichever is less.
    //       */
    //      init = s.window_size - curr;
    //      if (init > WIN_INIT)
    //        init = WIN_INIT;
    //      zmemzero(s->window + curr, (unsigned)init);
    //      s->high_water = curr + init;
    //    }
    //    else if (s->high_water < (ulg)curr + WIN_INIT) {
    //      /* High water mark at or above current data, but below current data
    //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
    //       * to end of window, whichever is less.
    //       */
    //      init = (ulg)curr + WIN_INIT - s->high_water;
    //      if (init > s->window_size - s->high_water)
    //        init = s->window_size - s->high_water;
    //      zmemzero(s->window + s->high_water, (unsigned)init);
    //      s->high_water += init;
    //    }
    //  }
    //
    //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
    //    "not enough room for search");
    };

    /* ===========================================================================
     * Copy without compression as much as possible from the input stream, return
     * the current block state.
     *
     * In case deflateParams() is used to later switch to a non-zero compression
     * level, s->matches (otherwise unused when storing) keeps track of the number
     * of hash table slides to perform. If s->matches is 1, then one hash table
     * slide will be done when switching. If s->matches is 2, the maximum value
     * allowed here, then the hash table will be cleared, since two or more slides
     * is the same as a clear.
     *
     * deflate_stored() is written to minimize the number of times an input byte is
     * copied. It is most efficient with large input and output buffers, which
     * maximizes the opportunites to have a single copy from next_in to next_out.
     */
    const deflate_stored = (s, flush) => {

      /* Smallest worthy block size when not flushing or finishing. By default
       * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
       * large input and output buffers, the stored block size will be larger.
       */
      let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;

      /* Copy as many min_block or larger stored blocks directly to next_out as
       * possible. If flushing, copy the remaining available input to next_out as
       * stored blocks, if there is enough space.
       */
      let len, left, have, last = 0;
      let used = s.strm.avail_in;
      do {
        /* Set len to the maximum size block that we can copy directly with the
         * available input data and output space. Set left to how much of that
         * would be copied from what's left in the window.
         */
        len = 65535/* MAX_STORED */;     /* maximum deflate stored block length */
        have = (s.bi_valid + 42) >> 3;     /* number of header bytes */
        if (s.strm.avail_out < have) {         /* need room for header */
          break;
        }
          /* maximum stored block length that will fit in avail_out: */
        have = s.strm.avail_out - have;
        left = s.strstart - s.block_start;  /* bytes left in window */
        if (len > left + s.strm.avail_in) {
          len = left + s.strm.avail_in;   /* limit len to the input */
        }
        if (len > have) {
          len = have;             /* limit len to the output */
        }

        /* If the stored block would be less than min_block in length, or if
         * unable to copy all of the available input when flushing, then try
         * copying to the window and the pending buffer instead. Also don't
         * write an empty block when flushing -- deflate() does that.
         */
        if (len < min_block && ((len === 0 && flush !== Z_FINISH$3) ||
                            flush === Z_NO_FLUSH$2 ||
                            len !== left + s.strm.avail_in)) {
          break;
        }

        /* Make a dummy stored block in pending to get the header bytes,
         * including any pending bits. This also updates the debugging counts.
         */
        last = flush === Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        _tr_stored_block(s, 0, 0, last);

        /* Replace the lengths in the dummy stored block with len. */
        s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;

        /* Write the stored block header bytes. */
        flush_pending(s.strm);

    //#ifdef ZLIB_DEBUG
    //    /* Update debugging counts for the data about to be copied. */
    //    s->compressed_len += len << 3;
    //    s->bits_sent += len << 3;
    //#endif

        /* Copy uncompressed bytes from the window to next_out. */
        if (left) {
          if (left > len) {
            left = len;
          }
          //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
          s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
          s.strm.next_out += left;
          s.strm.avail_out -= left;
          s.strm.total_out += left;
          s.block_start += left;
          len -= left;
        }

        /* Copy uncompressed bytes directly from next_in to next_out, updating
         * the check value.
         */
        if (len) {
          read_buf(s.strm, s.strm.output, s.strm.next_out, len);
          s.strm.next_out += len;
          s.strm.avail_out -= len;
          s.strm.total_out += len;
        }
      } while (last === 0);

      /* Update the sliding window with the last s->w_size bytes of the copied
       * data, or append all of the copied data to the existing window if less
       * than s->w_size bytes were copied. Also update the number of bytes to
       * insert in the hash tables, in the event that deflateParams() switches to
       * a non-zero compression level.
       */
      used -= s.strm.avail_in;    /* number of input bytes directly copied */
      if (used) {
        /* If any input was used, then no unused input remains in the window,
         * therefore s->block_start == s->strstart.
         */
        if (used >= s.w_size) {  /* supplant the previous history */
          s.matches = 2;     /* clear hash */
          //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
          s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
          s.strstart = s.w_size;
          s.insert = s.strstart;
        }
        else {
          if (s.window_size - s.strstart <= used) {
            /* Slide the window down. */
            s.strstart -= s.w_size;
            //zmemcpy(s->window, s->window + s->w_size, s->strstart);
            s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
            if (s.matches < 2) {
              s.matches++;   /* add a pending slide_hash() */
            }
            if (s.insert > s.strstart) {
              s.insert = s.strstart;
            }
          }
          //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
          s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
          s.strstart += used;
          s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
      }
      if (s.high_water < s.strstart) {
        s.high_water = s.strstart;
      }

      /* If the last block was written to next_out, then done. */
      if (last) {
        return BS_FINISH_DONE;
      }

      /* If flushing and all input has been consumed, then done. */
      if (flush !== Z_NO_FLUSH$2 && flush !== Z_FINISH$3 &&
        s.strm.avail_in === 0 && s.strstart === s.block_start) {
        return BS_BLOCK_DONE;
      }

      /* Fill the window with any remaining input. */
      have = s.window_size - s.strstart;
      if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */
        s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) {
          s.matches++;       /* add a pending slide_hash() */
        }
        have += s.w_size;      /* more space now */
        if (s.insert > s.strstart) {
          s.insert = s.strstart;
        }
      }
      if (have > s.strm.avail_in) {
        have = s.strm.avail_in;
      }
      if (have) {
        read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
      }
      if (s.high_water < s.strstart) {
        s.high_water = s.strstart;
      }

      /* There was not enough avail_out to write a complete worthy or flushed
       * stored block to next_out. Write a stored block to pending instead, if we
       * have enough input for a worthy block, or if flushing and there is enough
       * room for the remaining input as a stored block in the pending buffer.
       */
      have = (s.bi_valid + 42) >> 3;     /* number of header bytes */
        /* maximum stored block length that will fit in pending: */
      have = s.pending_buf_size - have > 65535/* MAX_STORED */ ? 65535/* MAX_STORED */ : s.pending_buf_size - have;
      min_block = have > s.w_size ? s.w_size : have;
      left = s.strstart - s.block_start;
      if (left >= min_block ||
         ((left || flush === Z_FINISH$3) && flush !== Z_NO_FLUSH$2 &&
         s.strm.avail_in === 0 && left <= have)) {
        len = left > have ? have : left;
        last = flush === Z_FINISH$3 && s.strm.avail_in === 0 &&
             len === left ? 1 : 0;
        _tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        flush_pending(s.strm);
      }

      /* We've done all we can with the available input and output. */
      return last ? BS_FINISH_STARTED : BS_NEED_MORE;
    };


    /* ===========================================================================
     * Compress as much as possible from the input stream, return the current
     * block state.
     * This function does not perform lazy evaluation of matches and inserts
     * new strings in the dictionary only for unmatched strings or for short
     * matches. It is used only for the fast compression options.
     */
    const deflate_fast = (s, flush) => {

      let hash_head;        /* head of the hash chain */
      let bflush;           /* set if current block must be flushed */

      for (;;) {
        /* Make sure that we always have enough lookahead, except
         * at the end of the input file. We need MAX_MATCH bytes
         * for the next match, plus MIN_MATCH bytes to insert the
         * string following the next match.
         */
        if (s.lookahead < MIN_LOOKAHEAD) {
          fill_window(s);
          if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) {
            return BS_NEED_MORE;
          }
          if (s.lookahead === 0) {
            break; /* flush the current block */
          }
        }

        /* Insert the string window[strstart .. strstart+2] in the
         * dictionary, and set hash_head to the head of the hash chain:
         */
        hash_head = 0/*NIL*/;
        if (s.lookahead >= MIN_MATCH) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }

        /* Find the longest match, discarding those <= prev_length.
         * At this point we have always match_length < MIN_MATCH
         */
        if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
          /* To simplify the code, we prevent matches with the string
           * of window index 0 (in particular we have to avoid a match
           * of the string with itself at the start of the input file).
           */
          s.match_length = longest_match(s, hash_head);
          /* longest_match() sets match_start */
        }
        if (s.match_length >= MIN_MATCH) {
          // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

          /*** _tr_tally_dist(s, s.strstart - s.match_start,
                         s.match_length - MIN_MATCH, bflush); ***/
          bflush = _tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

          s.lookahead -= s.match_length;

          /* Insert new strings in the hash table only if the match length
           * is not too large. This saves time but degrades compression.
           */
          if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
            s.match_length--; /* string at strstart already in table */
            do {
              s.strstart++;
              /*** INSERT_STRING(s, s.strstart, hash_head); ***/
              s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
              hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
              s.head[s.ins_h] = s.strstart;
              /***/
              /* strstart never exceeds WSIZE-MAX_MATCH, so there are
               * always MIN_MATCH bytes ahead.
               */
            } while (--s.match_length !== 0);
            s.strstart++;
          } else
          {
            s.strstart += s.match_length;
            s.match_length = 0;
            s.ins_h = s.window[s.strstart];
            /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]);

    //#if MIN_MATCH != 3
    //                Call UPDATE_HASH() MIN_MATCH-3 more times
    //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
             * matter since it will be recomputed at next deflate call.
             */
          }
        } else {
          /* No match, output a literal byte */
          //Tracevv((stderr,"%c", s.window[s.strstart]));
          /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
          bflush = _tr_tally(s, 0, s.window[s.strstart]);

          s.lookahead--;
          s.strstart++;
        }
        if (bflush) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }
      }
      s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
      if (flush === Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/
        flush_block_only(s, true);
        if (s.strm.avail_out === 0) {
          return BS_FINISH_STARTED;
        }
        /***/
        return BS_FINISH_DONE;
      }
      if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }
      return BS_BLOCK_DONE;
    };

    /* ===========================================================================
     * Same as above, but achieves better compression. We use a lazy
     * evaluation for matches: a match is finally adopted only if there is
     * no better match at the next window position.
     */
    const deflate_slow = (s, flush) => {

      let hash_head;          /* head of hash chain */
      let bflush;              /* set if current block must be flushed */

      let max_insert;

      /* Process the input block. */
      for (;;) {
        /* Make sure that we always have enough lookahead, except
         * at the end of the input file. We need MAX_MATCH bytes
         * for the next match, plus MIN_MATCH bytes to insert the
         * string following the next match.
         */
        if (s.lookahead < MIN_LOOKAHEAD) {
          fill_window(s);
          if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) {
            return BS_NEED_MORE;
          }
          if (s.lookahead === 0) { break; } /* flush the current block */
        }

        /* Insert the string window[strstart .. strstart+2] in the
         * dictionary, and set hash_head to the head of the hash chain:
         */
        hash_head = 0/*NIL*/;
        if (s.lookahead >= MIN_MATCH) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }

        /* Find the longest match, discarding those <= prev_length.
         */
        s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = MIN_MATCH - 1;

        if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
            s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
          /* To simplify the code, we prevent matches with the string
           * of window index 0 (in particular we have to avoid a match
           * of the string with itself at the start of the input file).
           */
          s.match_length = longest_match(s, hash_head);
          /* longest_match() sets match_start */

          if (s.match_length <= 5 &&
             (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

            /* If prev_match is also MIN_MATCH, match_start is garbage
             * but we will ignore the current match anyway.
             */
            s.match_length = MIN_MATCH - 1;
          }
        }
        /* If there was a match at the previous step and the current
         * match is not better, output the previous match:
         */
        if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
          max_insert = s.strstart + s.lookahead - MIN_MATCH;
          /* Do not insert strings in hash table beyond this. */

          //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

          /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                         s.prev_length - MIN_MATCH, bflush);***/
          bflush = _tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
          /* Insert in hash table all strings up to the end of the match.
           * strstart-1 and strstart are already inserted. If there is not
           * enough lookahead, the last two strings are not inserted in
           * the hash table.
           */
          s.lookahead -= s.prev_length - 1;
          s.prev_length -= 2;
          do {
            if (++s.strstart <= max_insert) {
              /*** INSERT_STRING(s, s.strstart, hash_head); ***/
              s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
              hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
              s.head[s.ins_h] = s.strstart;
              /***/
            }
          } while (--s.prev_length !== 0);
          s.match_available = 0;
          s.match_length = MIN_MATCH - 1;
          s.strstart++;

          if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }

        } else if (s.match_available) {
          /* If there was no match at the previous position, output a
           * single literal. If there was a match but the current match
           * is longer, truncate the previous match to a single literal.
           */
          //Tracevv((stderr,"%c", s->window[s->strstart-1]));
          /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
          bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);

          if (bflush) {
            /*** FLUSH_BLOCK_ONLY(s, 0) ***/
            flush_block_only(s, false);
            /***/
          }
          s.strstart++;
          s.lookahead--;
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
        } else {
          /* There is no previous match to compare with, wait for
           * the next step to decide.
           */
          s.match_available = 1;
          s.strstart++;
          s.lookahead--;
        }
      }
      //Assert (flush != Z_NO_FLUSH, "no flush?");
      if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
        bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);

        s.match_available = 0;
      }
      s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
      if (flush === Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/
        flush_block_only(s, true);
        if (s.strm.avail_out === 0) {
          return BS_FINISH_STARTED;
        }
        /***/
        return BS_FINISH_DONE;
      }
      if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

      return BS_BLOCK_DONE;
    };


    /* ===========================================================================
     * For Z_RLE, simply look for runs of bytes, generate matches only of distance
     * one.  Do not maintain a hash table.  (It will be regenerated if this run of
     * deflate switches away from Z_RLE.)
     */
    const deflate_rle = (s, flush) => {

      let bflush;            /* set if current block must be flushed */
      let prev;              /* byte at distance one to match */
      let scan, strend;      /* scan goes up to strend for length of run */

      const _win = s.window;

      for (;;) {
        /* Make sure that we always have enough lookahead, except
         * at the end of the input file. We need MAX_MATCH bytes
         * for the longest run, plus one for the unrolled loop.
         */
        if (s.lookahead <= MAX_MATCH) {
          fill_window(s);
          if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH$2) {
            return BS_NEED_MORE;
          }
          if (s.lookahead === 0) { break; } /* flush the current block */
        }

        /* See how many times the previous byte repeats */
        s.match_length = 0;
        if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
          scan = s.strstart - 1;
          prev = _win[scan];
          if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
            strend = s.strstart + MAX_MATCH;
            do {
              /*jshint noempty:false*/
            } while (prev === _win[++scan] && prev === _win[++scan] &&
                     prev === _win[++scan] && prev === _win[++scan] &&
                     prev === _win[++scan] && prev === _win[++scan] &&
                     prev === _win[++scan] && prev === _win[++scan] &&
                     scan < strend);
            s.match_length = MAX_MATCH - (strend - scan);
            if (s.match_length > s.lookahead) {
              s.match_length = s.lookahead;
            }
          }
          //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }

        /* Emit match if have run of MIN_MATCH or longer, else emit literal */
        if (s.match_length >= MIN_MATCH) {
          //check_match(s, s.strstart, s.strstart - 1, s.match_length);

          /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
          bflush = _tr_tally(s, 1, s.match_length - MIN_MATCH);

          s.lookahead -= s.match_length;
          s.strstart += s.match_length;
          s.match_length = 0;
        } else {
          /* No match, output a literal byte */
          //Tracevv((stderr,"%c", s->window[s->strstart]));
          /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
          bflush = _tr_tally(s, 0, s.window[s.strstart]);

          s.lookahead--;
          s.strstart++;
        }
        if (bflush) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }
      }
      s.insert = 0;
      if (flush === Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/
        flush_block_only(s, true);
        if (s.strm.avail_out === 0) {
          return BS_FINISH_STARTED;
        }
        /***/
        return BS_FINISH_DONE;
      }
      if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }
      return BS_BLOCK_DONE;
    };

    /* ===========================================================================
     * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
     * (It will be regenerated if this run of deflate switches away from Huffman.)
     */
    const deflate_huff = (s, flush) => {

      let bflush;             /* set if current block must be flushed */

      for (;;) {
        /* Make sure that we have a literal to write. */
        if (s.lookahead === 0) {
          fill_window(s);
          if (s.lookahead === 0) {
            if (flush === Z_NO_FLUSH$2) {
              return BS_NEED_MORE;
            }
            break;      /* flush the current block */
          }
        }

        /* Output a literal byte */
        s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
        bflush = _tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }
      }
      s.insert = 0;
      if (flush === Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/
        flush_block_only(s, true);
        if (s.strm.avail_out === 0) {
          return BS_FINISH_STARTED;
        }
        /***/
        return BS_FINISH_DONE;
      }
      if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }
      return BS_BLOCK_DONE;
    };

    /* Values for max_lazy_match, good_match and max_chain_length, depending on
     * the desired pack level (0..9). The values given below have been tuned to
     * exclude worst case performance for pathological files. Better values may be
     * found for specific files.
     */
    function Config(good_length, max_lazy, nice_length, max_chain, func) {

      this.good_length = good_length;
      this.max_lazy = max_lazy;
      this.nice_length = nice_length;
      this.max_chain = max_chain;
      this.func = func;
    }

    const configuration_table = [
      /*      good lazy nice chain */
      new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
      new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
      new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
      new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

      new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
      new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
      new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
      new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
      new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
      new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
    ];


    /* ===========================================================================
     * Initialize the "longest match" routines for a new zlib stream
     */
    const lm_init = (s) => {

      s.window_size = 2 * s.w_size;

      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);

      /* Set the default configuration parameters:
       */
      s.max_lazy_match = configuration_table[s.level].max_lazy;
      s.good_match = configuration_table[s.level].good_length;
      s.nice_match = configuration_table[s.level].nice_length;
      s.max_chain_length = configuration_table[s.level].max_chain;

      s.strstart = 0;
      s.block_start = 0;
      s.lookahead = 0;
      s.insert = 0;
      s.match_length = s.prev_length = MIN_MATCH - 1;
      s.match_available = 0;
      s.ins_h = 0;
    };


    function DeflateState() {
      this.strm = null;            /* pointer back to this zlib stream */
      this.status = 0;            /* as the name implies */
      this.pending_buf = null;      /* output still pending */
      this.pending_buf_size = 0;  /* size of pending_buf */
      this.pending_out = 0;       /* next pending byte to output to the stream */
      this.pending = 0;           /* nb of bytes in the pending buffer */
      this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
      this.gzhead = null;         /* gzip header information to write */
      this.gzindex = 0;           /* where in extra, name, or comment */
      this.method = Z_DEFLATED$2; /* can only be DEFLATED */
      this.last_flush = -1;   /* value of flush param for previous deflate call */

      this.w_size = 0;  /* LZ77 window size (32K by default) */
      this.w_bits = 0;  /* log2(w_size)  (8..16) */
      this.w_mask = 0;  /* w_size - 1 */

      this.window = null;
      /* Sliding window. Input bytes are read into the second half of the window,
       * and move to the first half later to keep a dictionary of at least wSize
       * bytes. With this organization, matches are limited to a distance of
       * wSize-MAX_MATCH bytes, but this ensures that IO is always
       * performed with a length multiple of the block size.
       */

      this.window_size = 0;
      /* Actual size of window: 2*wSize, except when the user input buffer
       * is directly used as sliding window.
       */

      this.prev = null;
      /* Link to older string with same hash index. To limit the size of this
       * array to 64K, this link is maintained only for the last 32K strings.
       * An index in this array is thus a window index modulo 32K.
       */

      this.head = null;   /* Heads of the hash chains or NIL. */

      this.ins_h = 0;       /* hash index of string to be inserted */
      this.hash_size = 0;   /* number of elements in hash table */
      this.hash_bits = 0;   /* log2(hash_size) */
      this.hash_mask = 0;   /* hash_size-1 */

      this.hash_shift = 0;
      /* Number of bits by which ins_h must be shifted at each input
       * step. It must be such that after MIN_MATCH steps, the oldest
       * byte no longer takes part in the hash key, that is:
       *   hash_shift * MIN_MATCH >= hash_bits
       */

      this.block_start = 0;
      /* Window position at the beginning of the current output block. Gets
       * negative when the window is moved backwards.
       */

      this.match_length = 0;      /* length of best match */
      this.prev_match = 0;        /* previous match */
      this.match_available = 0;   /* set if previous match exists */
      this.strstart = 0;          /* start of string to insert */
      this.match_start = 0;       /* start of matching string */
      this.lookahead = 0;         /* number of valid bytes ahead in window */

      this.prev_length = 0;
      /* Length of the best match at previous step. Matches not greater than this
       * are discarded. This is used in the lazy match evaluation.
       */

      this.max_chain_length = 0;
      /* To speed up deflation, hash chains are never searched beyond this
       * length.  A higher limit improves compression ratio but degrades the
       * speed.
       */

      this.max_lazy_match = 0;
      /* Attempt to find a better match only when the current match is strictly
       * smaller than this value. This mechanism is used only for compression
       * levels >= 4.
       */
      // That's alias to max_lazy_match, don't use directly
      //this.max_insert_length = 0;
      /* Insert new strings in the hash table only if the match length is not
       * greater than this length. This saves time but degrades compression.
       * max_insert_length is used only for compression levels <= 3.
       */

      this.level = 0;     /* compression level (1..9) */
      this.strategy = 0;  /* favor or force Huffman coding*/

      this.good_match = 0;
      /* Use a faster search when the previous match is longer than this */

      this.nice_match = 0; /* Stop searching when current match exceeds this */

                  /* used by trees.c: */

      /* Didn't use ct_data typedef below to suppress compiler warning */

      // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
      // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
      // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

      // Use flat array of DOUBLE size, with interleaved fata,
      // because JS does not support effective
      this.dyn_ltree  = new Uint16Array(HEAP_SIZE * 2);
      this.dyn_dtree  = new Uint16Array((2 * D_CODES + 1) * 2);
      this.bl_tree    = new Uint16Array((2 * BL_CODES + 1) * 2);
      zero(this.dyn_ltree);
      zero(this.dyn_dtree);
      zero(this.bl_tree);

      this.l_desc   = null;         /* desc. for literal tree */
      this.d_desc   = null;         /* desc. for distance tree */
      this.bl_desc  = null;         /* desc. for bit length tree */

      //ush bl_count[MAX_BITS+1];
      this.bl_count = new Uint16Array(MAX_BITS + 1);
      /* number of codes at each bit length for an optimal tree */

      //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
      this.heap = new Uint16Array(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
      zero(this.heap);

      this.heap_len = 0;               /* number of elements in the heap */
      this.heap_max = 0;               /* element of largest frequency */
      /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
       * The same heap array is used to build all trees.
       */

      this.depth = new Uint16Array(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
      zero(this.depth);
      /* Depth of each subtree used as tie breaker for trees of equal frequency
       */

      this.sym_buf = 0;        /* buffer for distances and literals/lengths */

      this.lit_bufsize = 0;
      /* Size of match buffer for literals/lengths.  There are 4 reasons for
       * limiting lit_bufsize to 64K:
       *   - frequencies can be kept in 16 bit counters
       *   - if compression is not successful for the first block, all input
       *     data is still in the window so we can still emit a stored block even
       *     when input comes from standard input.  (This can also be done for
       *     all blocks if lit_bufsize is not greater than 32K.)
       *   - if compression is not successful for a file smaller than 64K, we can
       *     even emit a stored file instead of a stored block (saving 5 bytes).
       *     This is applicable only for zip (not gzip or zlib).
       *   - creating new Huffman trees less frequently may not provide fast
       *     adaptation to changes in the input data statistics. (Take for
       *     example a binary file with poorly compressible code followed by
       *     a highly compressible string table.) Smaller buffer sizes give
       *     fast adaptation but have of course the overhead of transmitting
       *     trees more frequently.
       *   - I can't count above 4
       */

      this.sym_next = 0;      /* running index in sym_buf */
      this.sym_end = 0;       /* symbol table full when sym_next reaches this */

      this.opt_len = 0;       /* bit length of current block with optimal trees */
      this.static_len = 0;    /* bit length of current block with static trees */
      this.matches = 0;       /* number of string matches in current block */
      this.insert = 0;        /* bytes at end of window left to insert */


      this.bi_buf = 0;
      /* Output buffer. bits are inserted starting at the bottom (least
       * significant bits).
       */
      this.bi_valid = 0;
      /* Number of valid bits in bi_buf.  All bits above the last valid bit
       * are always zero.
       */

      // Used for window memory init. We safely ignore it for JS. That makes
      // sense only for pointers and memory check tools.
      //this.high_water = 0;
      /* High water mark offset in window for initialized bytes -- bytes above
       * this are set to zero in order to avoid memory check warnings when
       * longest match routines access bytes past the input.  This is then
       * updated to the new high water mark.
       */
    }


    /* =========================================================================
     * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
     */
    const deflateStateCheck = (strm) => {

      if (!strm) {
        return 1;
      }
      const s = strm.state;
      if (!s || s.strm !== strm || (s.status !== INIT_STATE &&
    //#ifdef GZIP
                                    s.status !== GZIP_STATE &&
    //#endif
                                    s.status !== EXTRA_STATE &&
                                    s.status !== NAME_STATE &&
                                    s.status !== COMMENT_STATE &&
                                    s.status !== HCRC_STATE &&
                                    s.status !== BUSY_STATE &&
                                    s.status !== FINISH_STATE)) {
        return 1;
      }
      return 0;
    };


    const deflateResetKeep = (strm) => {

      if (deflateStateCheck(strm)) {
        return err(strm, Z_STREAM_ERROR$2);
      }

      strm.total_in = strm.total_out = 0;
      strm.data_type = Z_UNKNOWN;

      const s = strm.state;
      s.pending = 0;
      s.pending_out = 0;

      if (s.wrap < 0) {
        s.wrap = -s.wrap;
        /* was made negative by deflate(..., Z_FINISH); */
      }
      s.status =
    //#ifdef GZIP
        s.wrap === 2 ? GZIP_STATE :
    //#endif
        s.wrap ? INIT_STATE : BUSY_STATE;
      strm.adler = (s.wrap === 2) ?
        0  // crc32(0, Z_NULL, 0)
      :
        1; // adler32(0, Z_NULL, 0)
      s.last_flush = -2;
      _tr_init(s);
      return Z_OK$3;
    };


    const deflateReset = (strm) => {

      const ret = deflateResetKeep(strm);
      if (ret === Z_OK$3) {
        lm_init(strm.state);
      }
      return ret;
    };


    const deflateSetHeader = (strm, head) => {

      if (deflateStateCheck(strm) || strm.state.wrap !== 2) {
        return Z_STREAM_ERROR$2;
      }
      strm.state.gzhead = head;
      return Z_OK$3;
    };


    const deflateInit2 = (strm, level, method, windowBits, memLevel, strategy) => {

      if (!strm) { // === Z_NULL
        return Z_STREAM_ERROR$2;
      }
      let wrap = 1;

      if (level === Z_DEFAULT_COMPRESSION$1) {
        level = 6;
      }

      if (windowBits < 0) { /* suppress zlib wrapper */
        wrap = 0;
        windowBits = -windowBits;
      }

      else if (windowBits > 15) {
        wrap = 2;           /* write gzip wrapper instead */
        windowBits -= 16;
      }


      if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED$2 ||
        windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
        strategy < 0 || strategy > Z_FIXED || (windowBits === 8 && wrap !== 1)) {
        return err(strm, Z_STREAM_ERROR$2);
      }


      if (windowBits === 8) {
        windowBits = 9;
      }
      /* until 256-byte window bug fixed */

      const s = new DeflateState();

      strm.state = s;
      s.strm = strm;
      s.status = INIT_STATE;     /* to pass state test in deflateReset() */

      s.wrap = wrap;
      s.gzhead = null;
      s.w_bits = windowBits;
      s.w_size = 1 << s.w_bits;
      s.w_mask = s.w_size - 1;

      s.hash_bits = memLevel + 7;
      s.hash_size = 1 << s.hash_bits;
      s.hash_mask = s.hash_size - 1;
      s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

      s.window = new Uint8Array(s.w_size * 2);
      s.head = new Uint16Array(s.hash_size);
      s.prev = new Uint16Array(s.w_size);

      // Don't need mem init magic for JS.
      //s.high_water = 0;  /* nothing written to s->window yet */

      s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

      /* We overlay pending_buf and sym_buf. This works since the average size
       * for length/distance pairs over any compressed block is assured to be 31
       * bits or less.
       *
       * Analysis: The longest fixed codes are a length code of 8 bits plus 5
       * extra bits, for lengths 131 to 257. The longest fixed distance codes are
       * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
       * possible fixed-codes length/distance pair is then 31 bits total.
       *
       * sym_buf starts one-fourth of the way into pending_buf. So there are
       * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
       * in sym_buf is three bytes -- two for the distance and one for the
       * literal/length. As each symbol is consumed, the pointer to the next
       * sym_buf value to read moves forward three bytes. From that symbol, up to
       * 31 bits are written to pending_buf. The closest the written pending_buf
       * bits gets to the next sym_buf symbol to read is just before the last
       * code is written. At that time, 31*(n-2) bits have been written, just
       * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
       * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
       * symbols are written.) The closest the writing gets to what is unread is
       * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
       * can range from 128 to 32768.
       *
       * Therefore, at a minimum, there are 142 bits of space between what is
       * written and what is read in the overlain buffers, so the symbols cannot
       * be overwritten by the compressed data. That space is actually 139 bits,
       * due to the three-bit fixed-code block header.
       *
       * That covers the case where either Z_FIXED is specified, forcing fixed
       * codes, or when the use of fixed codes is chosen, because that choice
       * results in a smaller compressed block than dynamic codes. That latter
       * condition then assures that the above analysis also covers all dynamic
       * blocks. A dynamic-code block will only be chosen to be emitted if it has
       * fewer bits than a fixed-code block would for the same set of symbols.
       * Therefore its average symbol length is assured to be less than 31. So
       * the compressed data for a dynamic block also cannot overwrite the
       * symbols from which it is being constructed.
       */

      s.pending_buf_size = s.lit_bufsize * 4;
      s.pending_buf = new Uint8Array(s.pending_buf_size);

      // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
      //s->sym_buf = s->pending_buf + s->lit_bufsize;
      s.sym_buf = s.lit_bufsize;

      //s->sym_end = (s->lit_bufsize - 1) * 3;
      s.sym_end = (s.lit_bufsize - 1) * 3;
      /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
       * on 16 bit machines and because stored blocks are restricted to
       * 64K-1 bytes.
       */

      s.level = level;
      s.strategy = strategy;
      s.method = method;

      return deflateReset(strm);
    };

    const deflateInit = (strm, level) => {

      return deflateInit2(strm, level, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1);
    };


    /* ========================================================================= */
    const deflate$2 = (strm, flush) => {

      if (deflateStateCheck(strm) || flush > Z_BLOCK$1 || flush < 0) {
        return strm ? err(strm, Z_STREAM_ERROR$2) : Z_STREAM_ERROR$2;
      }

      const s = strm.state;

      if (!strm.output ||
          (strm.avail_in !== 0 && !strm.input) ||
          (s.status === FINISH_STATE && flush !== Z_FINISH$3)) {
        return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$2);
      }

      const old_flush = s.last_flush;
      s.last_flush = flush;

      /* Flush as much pending output as possible */
      if (s.pending !== 0) {
        flush_pending(strm);
        if (strm.avail_out === 0) {
          /* Since avail_out is 0, deflate will be called again with
           * more output space, but possibly with both pending and
           * avail_in equal to zero. There won't be anything to do,
           * but this is not an error situation so make sure we
           * return OK instead of BUF_ERROR at next call of deflate:
           */
          s.last_flush = -1;
          return Z_OK$3;
        }

        /* Make sure there is something to do and avoid duplicate consecutive
         * flushes. For repeated and useless calls with Z_FINISH, we keep
         * returning Z_STREAM_END instead of Z_BUF_ERROR.
         */
      } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
        flush !== Z_FINISH$3) {
        return err(strm, Z_BUF_ERROR$1);
      }

      /* User must not provide more input after the first FINISH: */
      if (s.status === FINISH_STATE && strm.avail_in !== 0) {
        return err(strm, Z_BUF_ERROR$1);
      }

      /* Write the header */
      if (s.status === INIT_STATE && s.wrap === 0) {
        s.status = BUSY_STATE;
      }
      if (s.status === INIT_STATE) {
        /* zlib header */
        let header = (Z_DEFLATED$2 + ((s.w_bits - 8) << 4)) << 8;
        let level_flags = -1;

        if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
          level_flags = 0;
        } else if (s.level < 6) {
          level_flags = 1;
        } else if (s.level === 6) {
          level_flags = 2;
        } else {
          level_flags = 3;
        }
        header |= (level_flags << 6);
        if (s.strstart !== 0) { header |= PRESET_DICT; }
        header += 31 - (header % 31);

        putShortMSB(s, header);

        /* Save the adler32 of the preset dictionary: */
        if (s.strstart !== 0) {
          putShortMSB(s, strm.adler >>> 16);
          putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;

        /* Compression must start with an empty pending buffer */
        flush_pending(strm);
        if (s.pending !== 0) {
          s.last_flush = -1;
          return Z_OK$3;
        }
      }
    //#ifdef GZIP
      if (s.status === GZIP_STATE) {
        /* gzip header */
        strm.adler = 0;  //crc32(0L, Z_NULL, 0);
        put_byte(s, 31);
        put_byte(s, 139);
        put_byte(s, 8);
        if (!s.gzhead) { // s->gzhead == Z_NULL
          put_byte(s, 0);
          put_byte(s, 0);
          put_byte(s, 0);
          put_byte(s, 0);
          put_byte(s, 0);
          put_byte(s, s.level === 9 ? 2 :
                      (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                       4 : 0));
          put_byte(s, OS_CODE);
          s.status = BUSY_STATE;

          /* Compression must start with an empty pending buffer */
          flush_pending(strm);
          if (s.pending !== 0) {
            s.last_flush = -1;
            return Z_OK$3;
          }
        }
        else {
          put_byte(s, (s.gzhead.text ? 1 : 0) +
                      (s.gzhead.hcrc ? 2 : 0) +
                      (!s.gzhead.extra ? 0 : 4) +
                      (!s.gzhead.name ? 0 : 8) +
                      (!s.gzhead.comment ? 0 : 16)
          );
          put_byte(s, s.gzhead.time & 0xff);
          put_byte(s, (s.gzhead.time >> 8) & 0xff);
          put_byte(s, (s.gzhead.time >> 16) & 0xff);
          put_byte(s, (s.gzhead.time >> 24) & 0xff);
          put_byte(s, s.level === 9 ? 2 :
                      (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                       4 : 0));
          put_byte(s, s.gzhead.os & 0xff);
          if (s.gzhead.extra && s.gzhead.extra.length) {
            put_byte(s, s.gzhead.extra.length & 0xff);
            put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
          }
          if (s.gzhead.hcrc) {
            strm.adler = crc32_1$1(strm.adler, s.pending_buf, s.pending, 0);
          }
          s.gzindex = 0;
          s.status = EXTRA_STATE;
        }
      }
      if (s.status === EXTRA_STATE) {
        if (s.gzhead.extra/* != Z_NULL*/) {
          let beg = s.pending;   /* start of bytes to update crc */
          let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
          while (s.pending + left > s.pending_buf_size) {
            let copy = s.pending_buf_size - s.pending;
            // zmemcpy(s.pending_buf + s.pending,
            //    s.gzhead.extra + s.gzindex, copy);
            s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
            s.pending = s.pending_buf_size;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32_1$1(strm.adler, s.pending_buf, s.pending - beg, beg);
            }
            //---//
            s.gzindex += copy;
            flush_pending(strm);
            if (s.pending !== 0) {
              s.last_flush = -1;
              return Z_OK$3;
            }
            beg = 0;
            left -= copy;
          }
          // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
          //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
          let gzhead_extra = new Uint8Array(s.gzhead.extra);
          // zmemcpy(s->pending_buf + s->pending,
          //     s->gzhead->extra + s->gzindex, left);
          s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
          s.pending += left;
          //--- HCRC_UPDATE(beg) ---//
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32_1$1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          //---//
          s.gzindex = 0;
        }
        s.status = NAME_STATE;
      }
      if (s.status === NAME_STATE) {
        if (s.gzhead.name/* != Z_NULL*/) {
          let beg = s.pending;   /* start of bytes to update crc */
          let val;
          do {
            if (s.pending === s.pending_buf_size) {
              //--- HCRC_UPDATE(beg) ---//
              if (s.gzhead.hcrc && s.pending > beg) {
                strm.adler = crc32_1$1(strm.adler, s.pending_buf, s.pending - beg, beg);
              }
              //---//
              flush_pending(strm);
              if (s.pending !== 0) {
                s.last_flush = -1;
                return Z_OK$3;
              }
              beg = 0;
            }
            // JS specific: little magic to add zero terminator to end of string
            if (s.gzindex < s.gzhead.name.length) {
              val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
            } else {
              val = 0;
            }
            put_byte(s, val);
          } while (val !== 0);
          //--- HCRC_UPDATE(beg) ---//
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32_1$1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          //---//
          s.gzindex = 0;
        }
        s.status = COMMENT_STATE;
      }
      if (s.status === COMMENT_STATE) {
        if (s.gzhead.comment/* != Z_NULL*/) {
          let beg = s.pending;   /* start of bytes to update crc */
          let val;
          do {
            if (s.pending === s.pending_buf_size) {
              //--- HCRC_UPDATE(beg) ---//
              if (s.gzhead.hcrc && s.pending > beg) {
                strm.adler = crc32_1$1(strm.adler, s.pending_buf, s.pending - beg, beg);
              }
              //---//
              flush_pending(strm);
              if (s.pending !== 0) {
                s.last_flush = -1;
                return Z_OK$3;
              }
              beg = 0;
            }
            // JS specific: little magic to add zero terminator to end of string
            if (s.gzindex < s.gzhead.comment.length) {
              val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
            } else {
              val = 0;
            }
            put_byte(s, val);
          } while (val !== 0);
          //--- HCRC_UPDATE(beg) ---//
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32_1$1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          //---//
        }
        s.status = HCRC_STATE;
      }
      if (s.status === HCRC_STATE) {
        if (s.gzhead.hcrc) {
          if (s.pending + 2 > s.pending_buf_size) {
            flush_pending(strm);
            if (s.pending !== 0) {
              s.last_flush = -1;
              return Z_OK$3;
            }
          }
          put_byte(s, strm.adler & 0xff);
          put_byte(s, (strm.adler >> 8) & 0xff);
          strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = BUSY_STATE;

        /* Compression must start with an empty pending buffer */
        flush_pending(strm);
        if (s.pending !== 0) {
          s.last_flush = -1;
          return Z_OK$3;
        }
      }
    //#endif

      /* Start a new block or continue the current one.
       */
      if (strm.avail_in !== 0 || s.lookahead !== 0 ||
        (flush !== Z_NO_FLUSH$2 && s.status !== FINISH_STATE)) {
        let bstate = s.level === 0 ? deflate_stored(s, flush) :
                     s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) :
                     s.strategy === Z_RLE ? deflate_rle(s, flush) :
                     configuration_table[s.level].func(s, flush);

        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
          s.status = FINISH_STATE;
        }
        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
          if (strm.avail_out === 0) {
            s.last_flush = -1;
            /* avoid BUF_ERROR next call, see above */
          }
          return Z_OK$3;
          /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
           * of deflate should use the same flush parameter to make sure
           * that the flush is complete. So we don't have to output an
           * empty block here, this will be done at next call. This also
           * ensures that for a very small output buffer, we emit at most
           * one empty block.
           */
        }
        if (bstate === BS_BLOCK_DONE) {
          if (flush === Z_PARTIAL_FLUSH) {
            _tr_align(s);
          }
          else if (flush !== Z_BLOCK$1) { /* FULL_FLUSH or SYNC_FLUSH */

            _tr_stored_block(s, 0, 0, false);
            /* For a full flush, this empty block will be recognized
             * as a special marker by inflate_sync().
             */
            if (flush === Z_FULL_FLUSH$1) {
              /*** CLEAR_HASH(s); ***/             /* forget history */
              zero(s.head); // Fill with NIL (= 0);

              if (s.lookahead === 0) {
                s.strstart = 0;
                s.block_start = 0;
                s.insert = 0;
              }
            }
          }
          flush_pending(strm);
          if (strm.avail_out === 0) {
            s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
            return Z_OK$3;
          }
        }
      }

      if (flush !== Z_FINISH$3) { return Z_OK$3; }
      if (s.wrap <= 0) { return Z_STREAM_END$3; }

      /* Write the trailer */
      if (s.wrap === 2) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        put_byte(s, (strm.adler >> 16) & 0xff);
        put_byte(s, (strm.adler >> 24) & 0xff);
        put_byte(s, strm.total_in & 0xff);
        put_byte(s, (strm.total_in >> 8) & 0xff);
        put_byte(s, (strm.total_in >> 16) & 0xff);
        put_byte(s, (strm.total_in >> 24) & 0xff);
      }
      else
      {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }

      flush_pending(strm);
      /* If avail_out is zero, the application will call deflate again
       * to flush the rest.
       */
      if (s.wrap > 0) { s.wrap = -s.wrap; }
      /* write the trailer only once! */
      return s.pending !== 0 ? Z_OK$3 : Z_STREAM_END$3;
    };


    const deflateEnd = (strm) => {

      if (deflateStateCheck(strm)) {
        return Z_STREAM_ERROR$2;
      }

      const status = strm.state.status;

      strm.state = null;

      return status === BUSY_STATE ? err(strm, Z_DATA_ERROR$2) : Z_OK$3;
    };


    /* =========================================================================
     * Initializes the compression dictionary from the given byte
     * sequence without producing any compressed output.
     */
    const deflateSetDictionary = (strm, dictionary) => {

      let dictLength = dictionary.length;

      if (deflateStateCheck(strm)) {
        return Z_STREAM_ERROR$2;
      }

      const s = strm.state;
      const wrap = s.wrap;

      if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
        return Z_STREAM_ERROR$2;
      }

      /* when using zlib wrappers, compute Adler-32 for provided dictionary */
      if (wrap === 1) {
        /* adler32(strm->adler, dictionary, dictLength); */
        strm.adler = adler32_1$1(strm.adler, dictionary, dictLength, 0);
      }

      s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

      /* if dictionary would fill window, just replace the history */
      if (dictLength >= s.w_size) {
        if (wrap === 0) {            /* already empty otherwise */
          /*** CLEAR_HASH(s); ***/
          zero(s.head); // Fill with NIL (= 0);
          s.strstart = 0;
          s.block_start = 0;
          s.insert = 0;
        }
        /* use the tail */
        // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
      }
      /* insert dictionary into window and hash */
      const avail = strm.avail_in;
      const next = strm.next_in;
      const input = strm.input;
      strm.avail_in = dictLength;
      strm.next_in = 0;
      strm.input = dictionary;
      fill_window(s);
      while (s.lookahead >= MIN_MATCH) {
        let str = s.strstart;
        let n = s.lookahead - (MIN_MATCH - 1);
        do {
          /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
          s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);

          s.prev[str & s.w_mask] = s.head[s.ins_h];

          s.head[s.ins_h] = str;
          str++;
        } while (--n);
        s.strstart = str;
        s.lookahead = MIN_MATCH - 1;
        fill_window(s);
      }
      s.strstart += s.lookahead;
      s.block_start = s.strstart;
      s.insert = s.lookahead;
      s.lookahead = 0;
      s.match_length = s.prev_length = MIN_MATCH - 1;
      s.match_available = 0;
      strm.next_in = next;
      strm.input = input;
      strm.avail_in = avail;
      s.wrap = wrap;
      return Z_OK$3;
    };


    var deflateInit_1 = deflateInit;
    var deflateInit2_1 = deflateInit2;
    var deflateReset_1 = deflateReset;
    var deflateResetKeep_1 = deflateResetKeep;
    var deflateSetHeader_1 = deflateSetHeader;
    var deflate_2$1 = deflate$2;
    var deflateEnd_1 = deflateEnd;
    var deflateSetDictionary_1 = deflateSetDictionary;
    var deflateInfo = 'pako deflate (from Nodeca project)';

    /* Not implemented
    module.exports.deflateBound = deflateBound;
    module.exports.deflateCopy = deflateCopy;
    module.exports.deflateGetDictionary = deflateGetDictionary;
    module.exports.deflateParams = deflateParams;
    module.exports.deflatePending = deflatePending;
    module.exports.deflatePrime = deflatePrime;
    module.exports.deflateTune = deflateTune;
    */

    var deflate_1$2 = {
    	deflateInit: deflateInit_1,
    	deflateInit2: deflateInit2_1,
    	deflateReset: deflateReset_1,
    	deflateResetKeep: deflateResetKeep_1,
    	deflateSetHeader: deflateSetHeader_1,
    	deflate: deflate_2$1,
    	deflateEnd: deflateEnd_1,
    	deflateSetDictionary: deflateSetDictionary_1,
    	deflateInfo: deflateInfo
    };

    const _has$1 = (obj, key) => {
      return Object.prototype.hasOwnProperty.call(obj, key);
    };

    var assign$1 = function (obj /*from1, from2, from3, ...*/) {
      const sources = Array.prototype.slice.call(arguments, 1);
      while (sources.length) {
        const source = sources.shift();
        if (!source) { continue; }

        if (typeof source !== 'object') {
          throw new TypeError(source + 'must be non-object');
        }

        for (const p in source) {
          if (_has$1(source, p)) {
            obj[p] = source[p];
          }
        }
      }

      return obj;
    };


    // Join array of chunks to single array.
    var flattenChunks$1 = (chunks) => {
      // calculate data length
      let len = 0;

      for (let i = 0, l = chunks.length; i < l; i++) {
        len += chunks[i].length;
      }

      // join chunks
      const result = new Uint8Array(len);

      for (let i = 0, pos = 0, l = chunks.length; i < l; i++) {
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
      }

      return result;
    };

    var common$1 = {
    	assign: assign$1,
    	flattenChunks: flattenChunks$1
    };

    // String encode/decode helpers


    // Quick check if we can use fast array to bin string conversion
    //
    // - apply(Array) can fail on Android 2.2
    // - apply(Uint8Array) can fail on iOS 5.1 Safari
    //
    let STR_APPLY_UIA_OK$1 = true;

    try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK$1 = false; }


    // Table with utf8 lengths (calculated by first byte of sequence)
    // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
    // because max possible codepoint is 0x10ffff
    const _utf8len$1 = new Uint8Array(256);
    for (let q = 0; q < 256; q++) {
      _utf8len$1[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
    }
    _utf8len$1[254] = _utf8len$1[254] = 1; // Invalid sequence start


    // convert string to array (typed, when possible)
    var string2buf$1 = (str) => {
      if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) {
        return new TextEncoder().encode(str);
      }

      let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

      // count binary size
      for (m_pos = 0; m_pos < str_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
          c2 = str.charCodeAt(m_pos + 1);
          if ((c2 & 0xfc00) === 0xdc00) {
            c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
            m_pos++;
          }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
      }

      // allocate buffer
      buf = new Uint8Array(buf_len);

      // convert
      for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
          c2 = str.charCodeAt(m_pos + 1);
          if ((c2 & 0xfc00) === 0xdc00) {
            c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
            m_pos++;
          }
        }
        if (c < 0x80) {
          /* one byte */
          buf[i++] = c;
        } else if (c < 0x800) {
          /* two bytes */
          buf[i++] = 0xC0 | (c >>> 6);
          buf[i++] = 0x80 | (c & 0x3f);
        } else if (c < 0x10000) {
          /* three bytes */
          buf[i++] = 0xE0 | (c >>> 12);
          buf[i++] = 0x80 | (c >>> 6 & 0x3f);
          buf[i++] = 0x80 | (c & 0x3f);
        } else {
          /* four bytes */
          buf[i++] = 0xf0 | (c >>> 18);
          buf[i++] = 0x80 | (c >>> 12 & 0x3f);
          buf[i++] = 0x80 | (c >>> 6 & 0x3f);
          buf[i++] = 0x80 | (c & 0x3f);
        }
      }

      return buf;
    };

    // Helper
    const buf2binstring$1 = (buf, len) => {
      // On Chrome, the arguments in a function call that are allowed is `65534`.
      // If the length of the buffer is smaller than that, we can use this optimization,
      // otherwise we will take a slower path.
      if (len < 65534) {
        if (buf.subarray && STR_APPLY_UIA_OK$1) {
          return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
        }
      }

      let result = '';
      for (let i = 0; i < len; i++) {
        result += String.fromCharCode(buf[i]);
      }
      return result;
    };


    // convert array to string
    var buf2string$1 = (buf, max) => {
      const len = max || buf.length;

      if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) {
        return new TextDecoder().decode(buf.subarray(0, max));
      }

      let i, out;

      // Reserve max possible length (2 words per char)
      // NB: by unknown reasons, Array is significantly faster for
      //     String.fromCharCode.apply than Uint16Array.
      const utf16buf = new Array(len * 2);

      for (out = 0, i = 0; i < len;) {
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) { utf16buf[out++] = c; continue; }

        let c_len = _utf8len$1[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while (c_len > 1 && i < len) {
          c = (c << 6) | (buf[i++] & 0x3f);
          c_len--;
        }

        // terminated by end of string?
        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

        if (c < 0x10000) {
          utf16buf[out++] = c;
        } else {
          c -= 0x10000;
          utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
          utf16buf[out++] = 0xdc00 | (c & 0x3ff);
        }
      }

      return buf2binstring$1(utf16buf, out);
    };


    // Calculate max possible position in utf8 buffer,
    // that will not break sequence. If that's not possible
    // - (very small limits) return max size as is.
    //
    // buf[] - utf8 bytes array
    // max   - length limit (mandatory);
    var utf8border$1 = (buf, max) => {

      max = max || buf.length;
      if (max > buf.length) { max = buf.length; }

      // go back from last position, until start of sequence found
      let pos = max - 1;
      while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

      // Very small and broken sequence,
      // return max, because we should return something anyway.
      if (pos < 0) { return max; }

      // If we came to start of buffer - that means buffer is too small,
      // return max too.
      if (pos === 0) { return max; }

      return (pos + _utf8len$1[buf[pos]] > max) ? pos : max;
    };

    var strings$1 = {
    	string2buf: string2buf$1,
    	buf2string: buf2string$1,
    	utf8border: utf8border$1
    };

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    function ZStream$1() {
      /* next input byte */
      this.input = null; // JS specific, because we have no pointers
      this.next_in = 0;
      /* number of bytes available at input */
      this.avail_in = 0;
      /* total number of input bytes read so far */
      this.total_in = 0;
      /* next output byte should be put there */
      this.output = null; // JS specific, because we have no pointers
      this.next_out = 0;
      /* remaining free space at output */
      this.avail_out = 0;
      /* total number of bytes output so far */
      this.total_out = 0;
      /* last error message, NULL if no error */
      this.msg = ''/*Z_NULL*/;
      /* not visible by applications */
      this.state = null;
      /* best guess about the data type: binary or text */
      this.data_type = 2/*Z_UNKNOWN*/;
      /* adler32 value of the uncompressed data */
      this.adler = 0;
    }

    var zstream$1 = ZStream$1;

    const toString$1 = Object.prototype.toString;

    /* Public constants ==========================================================*/
    /* ===========================================================================*/

    const {
      Z_NO_FLUSH: Z_NO_FLUSH$1, Z_SYNC_FLUSH, Z_FULL_FLUSH, Z_FINISH: Z_FINISH$2,
      Z_OK: Z_OK$2, Z_STREAM_END: Z_STREAM_END$2,
      Z_DEFAULT_COMPRESSION,
      Z_DEFAULT_STRATEGY,
      Z_DEFLATED: Z_DEFLATED$1
    } = constants$2$1;

    /* ===========================================================================*/


    /**
     * class Deflate
     *
     * Generic JS-style wrapper for zlib calls. If you don't need
     * streaming behaviour - use more simple functions: [[deflate]],
     * [[deflateRaw]] and [[gzip]].
     **/

    /* internal
     * Deflate.chunks -> Array
     *
     * Chunks of output data, if [[Deflate#onData]] not overridden.
     **/

    /**
     * Deflate.result -> Uint8Array
     *
     * Compressed result, generated by default [[Deflate#onData]]
     * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
     * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
     **/

    /**
     * Deflate.err -> Number
     *
     * Error code after deflate finished. 0 (Z_OK) on success.
     * You will not need it in real life, because deflate errors
     * are possible only on wrong options or bad `onData` / `onEnd`
     * custom handlers.
     **/

    /**
     * Deflate.msg -> String
     *
     * Error message, if [[Deflate.err]] != 0
     **/


    /**
     * new Deflate(options)
     * - options (Object): zlib deflate options.
     *
     * Creates new deflator instance with specified params. Throws exception
     * on bad params. Supported options:
     *
     * - `level`
     * - `windowBits`
     * - `memLevel`
     * - `strategy`
     * - `dictionary`
     *
     * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
     * for more information on these.
     *
     * Additional options, for internal needs:
     *
     * - `chunkSize` - size of generated data chunks (16K by default)
     * - `raw` (Boolean) - do raw deflate
     * - `gzip` (Boolean) - create gzip wrapper
     * - `header` (Object) - custom header for gzip
     *   - `text` (Boolean) - true if compressed data believed to be text
     *   - `time` (Number) - modification time, unix timestamp
     *   - `os` (Number) - operation system code
     *   - `extra` (Array) - array of bytes with extra data (max 65536)
     *   - `name` (String) - file name (binary string)
     *   - `comment` (String) - comment (binary string)
     *   - `hcrc` (Boolean) - true if header crc should be added
     *
     * ##### Example:
     *
     * ```javascript
     * const pako = require('pako')
     *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
     *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
     *
     * const deflate = new pako.Deflate({ level: 3});
     *
     * deflate.push(chunk1, false);
     * deflate.push(chunk2, true);  // true -> last chunk
     *
     * if (deflate.err) { throw new Error(deflate.err); }
     *
     * console.log(deflate.result);
     * ```
     **/
    function Deflate$1(options) {
      this.options = common$1.assign({
        level: Z_DEFAULT_COMPRESSION,
        method: Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: Z_DEFAULT_STRATEGY
      }, options || {});

      let opt = this.options;

      if (opt.raw && (opt.windowBits > 0)) {
        opt.windowBits = -opt.windowBits;
      }

      else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
        opt.windowBits += 16;
      }

      this.err    = 0;      // error code, if happens (0 = Z_OK)
      this.msg    = '';     // error message
      this.ended  = false;  // used to avoid multiple onEnd() calls
      this.chunks = [];     // chunks of compressed data

      this.strm = new zstream$1();
      this.strm.avail_out = 0;

      let status = deflate_1$2.deflateInit2(
        this.strm,
        opt.level,
        opt.method,
        opt.windowBits,
        opt.memLevel,
        opt.strategy
      );

      if (status !== Z_OK$2) {
        throw new Error(messages$1[status]);
      }

      if (opt.header) {
        deflate_1$2.deflateSetHeader(this.strm, opt.header);
      }

      if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') {
          // If we need to compress text, change encoding to utf8.
          dict = strings$1.string2buf(opt.dictionary);
        } else if (toString$1.call(opt.dictionary) === '[object ArrayBuffer]') {
          dict = new Uint8Array(opt.dictionary);
        } else {
          dict = opt.dictionary;
        }

        status = deflate_1$2.deflateSetDictionary(this.strm, dict);

        if (status !== Z_OK$2) {
          throw new Error(messages$1[status]);
        }

        this._dict_set = true;
      }
    }

    /**
     * Deflate#push(data[, flush_mode]) -> Boolean
     * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
     *   converted to utf8 byte sequence.
     * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
     *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
     *
     * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
     * new compressed chunks. Returns `true` on success. The last data block must
     * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
     * buffers and call [[Deflate#onEnd]].
     *
     * On fail call [[Deflate#onEnd]] with error code and return false.
     *
     * ##### Example
     *
     * ```javascript
     * push(chunk, false); // push one of data chunks
     * ...
     * push(chunk, true);  // push last chunk
     * ```
     **/
    Deflate$1.prototype.push = function (data, flush_mode) {
      const strm = this.strm;
      const chunkSize = this.options.chunkSize;
      let status, _flush_mode;

      if (this.ended) { return false; }

      if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
      else _flush_mode = flush_mode === true ? Z_FINISH$2 : Z_NO_FLUSH$1;

      // Convert data if needed
      if (typeof data === 'string') {
        // If we need to compress text, change encoding to utf8.
        strm.input = strings$1.string2buf(data);
      } else if (toString$1.call(data) === '[object ArrayBuffer]') {
        strm.input = new Uint8Array(data);
      } else {
        strm.input = data;
      }

      strm.next_in = 0;
      strm.avail_in = strm.input.length;

      for (;;) {
        if (strm.avail_out === 0) {
          strm.output = new Uint8Array(chunkSize);
          strm.next_out = 0;
          strm.avail_out = chunkSize;
        }

        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH) && strm.avail_out <= 6) {
          this.onData(strm.output.subarray(0, strm.next_out));
          strm.avail_out = 0;
          continue;
        }

        status = deflate_1$2.deflate(strm, _flush_mode);

        // Ended => flush and finish
        if (status === Z_STREAM_END$2) {
          if (strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
          }
          status = deflate_1$2.deflateEnd(this.strm);
          this.onEnd(status);
          this.ended = true;
          return status === Z_OK$2;
        }

        // Flush if out buffer full
        if (strm.avail_out === 0) {
          this.onData(strm.output);
          continue;
        }

        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
          this.onData(strm.output.subarray(0, strm.next_out));
          strm.avail_out = 0;
          continue;
        }

        if (strm.avail_in === 0) break;
      }

      return true;
    };


    /**
     * Deflate#onData(chunk) -> Void
     * - chunk (Uint8Array): output data.
     *
     * By default, stores data blocks in `chunks[]` property and glue
     * those in `onEnd`. Override this handler, if you need another behaviour.
     **/
    Deflate$1.prototype.onData = function (chunk) {
      this.chunks.push(chunk);
    };


    /**
     * Deflate#onEnd(status) -> Void
     * - status (Number): deflate status. 0 (Z_OK) on success,
     *   other if not.
     *
     * Called once after you tell deflate that the input stream is
     * complete (Z_FINISH). By default - join collected chunks,
     * free memory and fill `results` / `err` properties.
     **/
    Deflate$1.prototype.onEnd = function (status) {
      // On success - join
      if (status === Z_OK$2) {
        this.result = common$1.flattenChunks(this.chunks);
      }
      this.chunks = [];
      this.err = status;
      this.msg = this.strm.msg;
    };


    /**
     * deflate(data[, options]) -> Uint8Array
     * - data (Uint8Array|ArrayBuffer|String): input data to compress.
     * - options (Object): zlib deflate options.
     *
     * Compress `data` with deflate algorithm and `options`.
     *
     * Supported options are:
     *
     * - level
     * - windowBits
     * - memLevel
     * - strategy
     * - dictionary
     *
     * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
     * for more information on these.
     *
     * Sugar (options):
     *
     * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
     *   negative windowBits implicitly.
     *
     * ##### Example:
     *
     * ```javascript
     * const pako = require('pako')
     * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
     *
     * console.log(pako.deflate(data));
     * ```
     **/
    function deflate$1(input, options) {
      const deflator = new Deflate$1(options);

      deflator.push(input, true);

      // That will never happens, if you don't cheat with options :)
      if (deflator.err) { throw deflator.msg || messages$1[deflator.err]; }

      return deflator.result;
    }


    /**
     * deflateRaw(data[, options]) -> Uint8Array
     * - data (Uint8Array|ArrayBuffer|String): input data to compress.
     * - options (Object): zlib deflate options.
     *
     * The same as [[deflate]], but creates raw data, without wrapper
     * (header and adler32 crc).
     **/
    function deflateRaw$1(input, options) {
      options = options || {};
      options.raw = true;
      return deflate$1(input, options);
    }


    /**
     * gzip(data[, options]) -> Uint8Array
     * - data (Uint8Array|ArrayBuffer|String): input data to compress.
     * - options (Object): zlib deflate options.
     *
     * The same as [[deflate]], but create gzip wrapper instead of
     * deflate one.
     **/
    function gzip$1(input, options) {
      options = options || {};
      options.gzip = true;
      return deflate$1(input, options);
    }


    var Deflate_1$1 = Deflate$1;
    var deflate_2 = deflate$1;
    var deflateRaw_1$1 = deflateRaw$1;
    var gzip_1$1 = gzip$1;
    var constants$1 = constants$2$1;

    var deflate_1$1 = {
    	Deflate: Deflate_1$1,
    	deflate: deflate_2,
    	deflateRaw: deflateRaw_1$1,
    	gzip: gzip_1$1,
    	constants: constants$1
    };

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    // See state defs from inflate.js
    const BAD$1$1 = 16209;       /* got a data error -- remain here until reset */
    const TYPE$1$1 = 16191;      /* i: waiting for type bits, including last-flag bit */

    /*
       Decode literal, length, and distance codes and write out the resulting
       literal and match bytes until either not enough input or output is
       available, an end-of-block is encountered, or a data error is encountered.
       When large enough input and output buffers are supplied to inflate(), for
       example, a 16K input buffer and a 64K output buffer, more than 95% of the
       inflate execution time is spent in this routine.

       Entry assumptions:

            state.mode === LEN
            strm.avail_in >= 6
            strm.avail_out >= 258
            start >= strm.avail_out
            state.bits < 8

       On return, state.mode is one of:

            LEN -- ran out of enough output space or enough available input
            TYPE -- reached end of block code, inflate() to interpret next block
            BAD -- error in block data

       Notes:

        - The maximum input bits used by a length/distance pair is 15 bits for the
          length code, 5 bits for the length extra, 15 bits for the distance code,
          and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
          Therefore if strm.avail_in >= 6, then there is enough input to avoid
          checking for available input while decoding.

        - The maximum bytes that a single length/distance pair can output is 258
          bytes, which is the maximum length that can be coded.  inflate_fast()
          requires strm.avail_out >= 258 for each loop to avoid checking for
          output space.
     */
    var inffast$1 = function inflate_fast(strm, start) {
      let _in;                    /* local strm.input */
      let last;                   /* have enough input while in < last */
      let _out;                   /* local strm.output */
      let beg;                    /* inflate()'s initial strm.output */
      let end;                    /* while out < end, enough space available */
    //#ifdef INFLATE_STRICT
      let dmax;                   /* maximum distance from zlib header */
    //#endif
      let wsize;                  /* window size or zero if not using window */
      let whave;                  /* valid bytes in the window */
      let wnext;                  /* window write index */
      // Use `s_window` instead `window`, avoid conflict with instrumentation tools
      let s_window;               /* allocated sliding window, if wsize != 0 */
      let hold;                   /* local strm.hold */
      let bits;                   /* local strm.bits */
      let lcode;                  /* local strm.lencode */
      let dcode;                  /* local strm.distcode */
      let lmask;                  /* mask for first level of length codes */
      let dmask;                  /* mask for first level of distance codes */
      let here;                   /* retrieved table entry */
      let op;                     /* code bits, operation, extra bits, or */
                                  /*  window position, window bytes to copy */
      let len;                    /* match length, unused bytes */
      let dist;                   /* match distance */
      let from;                   /* where to copy match from */
      let from_source;


      let input, output; // JS specific, because we have no pointers

      /* copy state to local variables */
      const state = strm.state;
      //here = state.here;
      _in = strm.next_in;
      input = strm.input;
      last = _in + (strm.avail_in - 5);
      _out = strm.next_out;
      output = strm.output;
      beg = _out - (start - strm.avail_out);
      end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
      dmax = state.dmax;
    //#endif
      wsize = state.wsize;
      whave = state.whave;
      wnext = state.wnext;
      s_window = state.window;
      hold = state.hold;
      bits = state.bits;
      lcode = state.lencode;
      dcode = state.distcode;
      lmask = (1 << state.lenbits) - 1;
      dmask = (1 << state.distbits) - 1;


      /* decode literals and length/distances until end-of-block or not enough
         input data or output space */

      top:
      do {
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }

        here = lcode[hold & lmask];

        dolen:
        for (;;) { // Goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;
          if (op === 0) {                          /* literal */
            //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff/*here.val*/;
          }
          else if (op & 16) {                     /* length base */
            len = here & 0xffff/*here.val*/;
            op &= 15;                           /* number of extra bits */
            if (op) {
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
              len += hold & ((1 << op) - 1);
              hold >>>= op;
              bits -= op;
            }
            //Tracevv((stderr, "inflate:         length %u\n", len));
            if (bits < 15) {
              hold += input[_in++] << bits;
              bits += 8;
              hold += input[_in++] << bits;
              bits += 8;
            }
            here = dcode[hold & dmask];

            dodist:
            for (;;) { // goto emulation
              op = here >>> 24/*here.bits*/;
              hold >>>= op;
              bits -= op;
              op = (here >>> 16) & 0xff/*here.op*/;

              if (op & 16) {                      /* distance base */
                dist = here & 0xffff/*here.val*/;
                op &= 15;                       /* number of extra bits */
                if (bits < op) {
                  hold += input[_in++] << bits;
                  bits += 8;
                  if (bits < op) {
                    hold += input[_in++] << bits;
                    bits += 8;
                  }
                }
                dist += hold & ((1 << op) - 1);
    //#ifdef INFLATE_STRICT
                if (dist > dmax) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD$1$1;
                  break top;
                }
    //#endif
                hold >>>= op;
                bits -= op;
                //Tracevv((stderr, "inflate:         distance %u\n", dist));
                op = _out - beg;                /* max distance in output */
                if (dist > op) {                /* see if copy from window */
                  op = dist - op;               /* distance back in window */
                  if (op > whave) {
                    if (state.sane) {
                      strm.msg = 'invalid distance too far back';
                      state.mode = BAD$1$1;
                      break top;
                    }

    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
    //                if (len <= op - whave) {
    //                  do {
    //                    output[_out++] = 0;
    //                  } while (--len);
    //                  continue top;
    //                }
    //                len -= op - whave;
    //                do {
    //                  output[_out++] = 0;
    //                } while (--op > whave);
    //                if (op === 0) {
    //                  from = _out - dist;
    //                  do {
    //                    output[_out++] = output[from++];
    //                  } while (--len);
    //                  continue top;
    //                }
    //#endif
                  }
                  from = 0; // window index
                  from_source = s_window;
                  if (wnext === 0) {           /* very common case */
                    from += wsize - op;
                    if (op < len) {         /* some from window */
                      len -= op;
                      do {
                        output[_out++] = s_window[from++];
                      } while (--op);
                      from = _out - dist;  /* rest from output */
                      from_source = output;
                    }
                  }
                  else if (wnext < op) {      /* wrap around window */
                    from += wsize + wnext - op;
                    op -= wnext;
                    if (op < len) {         /* some from end of window */
                      len -= op;
                      do {
                        output[_out++] = s_window[from++];
                      } while (--op);
                      from = 0;
                      if (wnext < len) {  /* some from start of window */
                        op = wnext;
                        len -= op;
                        do {
                          output[_out++] = s_window[from++];
                        } while (--op);
                        from = _out - dist;      /* rest from output */
                        from_source = output;
                      }
                    }
                  }
                  else {                      /* contiguous in window */
                    from += wnext - op;
                    if (op < len) {         /* some from window */
                      len -= op;
                      do {
                        output[_out++] = s_window[from++];
                      } while (--op);
                      from = _out - dist;  /* rest from output */
                      from_source = output;
                    }
                  }
                  while (len > 2) {
                    output[_out++] = from_source[from++];
                    output[_out++] = from_source[from++];
                    output[_out++] = from_source[from++];
                    len -= 3;
                  }
                  if (len) {
                    output[_out++] = from_source[from++];
                    if (len > 1) {
                      output[_out++] = from_source[from++];
                    }
                  }
                }
                else {
                  from = _out - dist;          /* copy direct from output */
                  do {                        /* minimum length is three */
                    output[_out++] = output[from++];
                    output[_out++] = output[from++];
                    output[_out++] = output[from++];
                    len -= 3;
                  } while (len > 2);
                  if (len) {
                    output[_out++] = output[from++];
                    if (len > 1) {
                      output[_out++] = output[from++];
                    }
                  }
                }
              }
              else if ((op & 64) === 0) {          /* 2nd level distance code */
                here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
                continue dodist;
              }
              else {
                strm.msg = 'invalid distance code';
                state.mode = BAD$1$1;
                break top;
              }

              break; // need to emulate goto via "continue"
            }
          }
          else if ((op & 64) === 0) {              /* 2nd level length code */
            here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dolen;
          }
          else if (op & 32) {                     /* end-of-block */
            //Tracevv((stderr, "inflate:         end of block\n"));
            state.mode = TYPE$1$1;
            break top;
          }
          else {
            strm.msg = 'invalid literal/length code';
            state.mode = BAD$1$1;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      } while (_in < last && _out < end);

      /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
      len = bits >> 3;
      _in -= len;
      bits -= len << 3;
      hold &= (1 << bits) - 1;

      /* update state and return */
      strm.next_in = _in;
      strm.next_out = _out;
      strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
      strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
      state.hold = hold;
      state.bits = bits;
      return;
    };

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    const MAXBITS$1 = 15;
    const ENOUGH_LENS$1$1 = 852;
    const ENOUGH_DISTS$1$1 = 592;
    //const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

    const CODES$1$1 = 0;
    const LENS$1$1 = 1;
    const DISTS$1$1 = 2;

    const lbase$1 = new Uint16Array([ /* Length codes 257..285 base */
      3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
      35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
    ]);

    const lext$1 = new Uint8Array([ /* Length codes 257..285 extra */
      16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
      19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
    ]);

    const dbase$1 = new Uint16Array([ /* Distance codes 0..29 base */
      1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
      257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
      8193, 12289, 16385, 24577, 0, 0
    ]);

    const dext$1 = new Uint8Array([ /* Distance codes 0..29 extra */
      16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
      23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
      28, 28, 29, 29, 64, 64
    ]);

    const inflate_table$1 = (type, lens, lens_index, codes, table, table_index, work, opts) =>
    {
      const bits = opts.bits;
          //here = opts.here; /* table entry for duplication */

      let len = 0;               /* a code's length in bits */
      let sym = 0;               /* index of code symbols */
      let min = 0, max = 0;          /* minimum and maximum code lengths */
      let root = 0;              /* number of index bits for root table */
      let curr = 0;              /* number of index bits for current table */
      let drop = 0;              /* code bits to drop for sub-table */
      let left = 0;                   /* number of prefix codes available */
      let used = 0;              /* code entries in table used */
      let huff = 0;              /* Huffman code */
      let incr;              /* for incrementing code, index */
      let fill;              /* index for replicating entries */
      let low;               /* low bits for current root entry */
      let mask;              /* mask for low root bits */
      let next;             /* next available space in table */
      let base = null;     /* base value table to use */
    //  let shoextra;    /* extra bits table to use */
      let match;                  /* use base and extra for symbol >= match */
      const count = new Uint16Array(MAXBITS$1 + 1); //[MAXBITS+1];    /* number of codes of each length */
      const offs = new Uint16Array(MAXBITS$1 + 1); //[MAXBITS+1];     /* offsets in table for each length */
      let extra = null;

      let here_bits, here_op, here_val;

      /*
       Process a set of code lengths to create a canonical Huffman code.  The
       code lengths are lens[0..codes-1].  Each length corresponds to the
       symbols 0..codes-1.  The Huffman code is generated by first sorting the
       symbols by length from short to long, and retaining the symbol order
       for codes with equal lengths.  Then the code starts with all zero bits
       for the first code of the shortest length, and the codes are integer
       increments for the same length, and zeros are appended as the length
       increases.  For the deflate format, these bits are stored backwards
       from their more natural integer increment ordering, and so when the
       decoding tables are built in the large loop below, the integer codes
       are incremented backwards.

       This routine assumes, but does not check, that all of the entries in
       lens[] are in the range 0..MAXBITS.  The caller must assure this.
       1..MAXBITS is interpreted as that code length.  zero means that that
       symbol does not occur in this code.

       The codes are sorted by computing a count of codes for each length,
       creating from that a table of starting indices for each length in the
       sorted table, and then entering the symbols in order in the sorted
       table.  The sorted table is work[], with that space being provided by
       the caller.

       The length counts are used for other purposes as well, i.e. finding
       the minimum and maximum length codes, determining if there are any
       codes at all, checking for a valid set of lengths, and looking ahead
       at length counts to determine sub-table sizes when building the
       decoding tables.
       */

      /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
      for (len = 0; len <= MAXBITS$1; len++) {
        count[len] = 0;
      }
      for (sym = 0; sym < codes; sym++) {
        count[lens[lens_index + sym]]++;
      }

      /* bound code lengths, force root to be within code lengths */
      root = bits;
      for (max = MAXBITS$1; max >= 1; max--) {
        if (count[max] !== 0) { break; }
      }
      if (root > max) {
        root = max;
      }
      if (max === 0) {                     /* no symbols to code at all */
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = (1 << 24) | (64 << 16) | 0;


        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = (1 << 24) | (64 << 16) | 0;

        opts.bits = 1;
        return 0;     /* no symbols, but wait for decoding to report error */
      }
      for (min = 1; min < max; min++) {
        if (count[min] !== 0) { break; }
      }
      if (root < min) {
        root = min;
      }

      /* check for an over-subscribed or incomplete set of lengths */
      left = 1;
      for (len = 1; len <= MAXBITS$1; len++) {
        left <<= 1;
        left -= count[len];
        if (left < 0) {
          return -1;
        }        /* over-subscribed */
      }
      if (left > 0 && (type === CODES$1$1 || max !== 1)) {
        return -1;                      /* incomplete set */
      }

      /* generate offsets into symbol table for each length for sorting */
      offs[1] = 0;
      for (len = 1; len < MAXBITS$1; len++) {
        offs[len + 1] = offs[len] + count[len];
      }

      /* sort symbols by length, by symbol order within each length */
      for (sym = 0; sym < codes; sym++) {
        if (lens[lens_index + sym] !== 0) {
          work[offs[lens[lens_index + sym]]++] = sym;
        }
      }

      /*
       Create and fill in decoding tables.  In this loop, the table being
       filled is at next and has curr index bits.  The code being used is huff
       with length len.  That code is converted to an index by dropping drop
       bits off of the bottom.  For codes where len is less than drop + curr,
       those top drop + curr - len bits are incremented through all values to
       fill the table with replicated entries.

       root is the number of index bits for the root table.  When len exceeds
       root, sub-tables are created pointed to by the root entry with an index
       of the low root bits of huff.  This is saved in low to check for when a
       new sub-table should be started.  drop is zero when the root table is
       being filled, and drop is root when sub-tables are being filled.

       When a new sub-table is needed, it is necessary to look ahead in the
       code lengths to determine what size sub-table is needed.  The length
       counts are used for this, and so count[] is decremented as codes are
       entered in the tables.

       used keeps track of how many table entries have been allocated from the
       provided *table space.  It is checked for LENS and DIST tables against
       the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
       the initial root table size constants.  See the comments in inftrees.h
       for more information.

       sym increments through all symbols, and the loop terminates when
       all codes of length max, i.e. all codes, have been processed.  This
       routine permits incomplete codes, so another loop after this one fills
       in the rest of the decoding tables with invalid code markers.
       */

      /* set up for code type */
      // poor man optimization - use if-else instead of switch,
      // to avoid deopts in old v8
      if (type === CODES$1$1) {
        base = extra = work;    /* dummy value--not used */
        match = 20;

      } else if (type === LENS$1$1) {
        base = lbase$1;
        extra = lext$1;
        match = 257;

      } else {                    /* DISTS */
        base = dbase$1;
        extra = dext$1;
        match = 0;
      }

      /* initialize opts for loop */
      huff = 0;                   /* starting code */
      sym = 0;                    /* starting code symbol */
      len = min;                  /* starting code length */
      next = table_index;              /* current table to fill in */
      curr = root;                /* current table index bits */
      drop = 0;                   /* current bits to drop from code for index */
      low = -1;                   /* trigger new sub-table when len > root */
      used = 1 << root;          /* use root table entries */
      mask = used - 1;            /* mask for comparing low */

      /* check available table space */
      if ((type === LENS$1$1 && used > ENOUGH_LENS$1$1) ||
        (type === DISTS$1$1 && used > ENOUGH_DISTS$1$1)) {
        return 1;
      }

      /* process all codes and make table entries */
      for (;;) {
        /* create table entry */
        here_bits = len - drop;
        if (work[sym] + 1 < match) {
          here_op = 0;
          here_val = work[sym];
        }
        else if (work[sym] >= match) {
          here_op = extra[work[sym] - match];
          here_val = base[work[sym] - match];
        }
        else {
          here_op = 32 + 64;         /* end of block */
          here_val = 0;
        }

        /* replicate for those indices with low len bits equal to huff */
        incr = 1 << (len - drop);
        fill = 1 << curr;
        min = fill;                 /* save offset to next table */
        do {
          fill -= incr;
          table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
        } while (fill !== 0);

        /* backwards increment the len-bit code huff */
        incr = 1 << (len - 1);
        while (huff & incr) {
          incr >>= 1;
        }
        if (incr !== 0) {
          huff &= incr - 1;
          huff += incr;
        } else {
          huff = 0;
        }

        /* go to next symbol, update count, len */
        sym++;
        if (--count[len] === 0) {
          if (len === max) { break; }
          len = lens[lens_index + work[sym]];
        }

        /* create new sub-table if needed */
        if (len > root && (huff & mask) !== low) {
          /* if first time, transition to sub-tables */
          if (drop === 0) {
            drop = root;
          }

          /* increment past last table */
          next += min;            /* here min is 1 << curr */

          /* determine length of next table */
          curr = len - drop;
          left = 1 << curr;
          while (curr + drop < max) {
            left -= count[curr + drop];
            if (left <= 0) { break; }
            curr++;
            left <<= 1;
          }

          /* check for enough space */
          used += 1 << curr;
          if ((type === LENS$1$1 && used > ENOUGH_LENS$1$1) ||
            (type === DISTS$1$1 && used > ENOUGH_DISTS$1$1)) {
            return 1;
          }

          /* point entry in root table to sub-table */
          low = huff & mask;
          /*table.op[low] = curr;
          table.bits[low] = root;
          table.val[low] = next - opts.table_index;*/
          table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
        }
      }

      /* fill in remaining table entry if code is incomplete (guaranteed to have
       at most one remaining entry, since if the code is incomplete, the
       maximum code length that was allowed to get this far is one bit) */
      if (huff !== 0) {
        //table.op[next + huff] = 64;            /* invalid code marker */
        //table.bits[next + huff] = len - drop;
        //table.val[next + huff] = 0;
        table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
      }

      /* set return parameters */
      //opts.table_index += used;
      opts.bits = root;
      return 0;
    };


    var inftrees$1 = inflate_table$1;

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.






    const CODES$2 = 0;
    const LENS$2 = 1;
    const DISTS$2 = 2;

    /* Public constants ==========================================================*/
    /* ===========================================================================*/

    const {
      Z_FINISH: Z_FINISH$1$1, Z_BLOCK: Z_BLOCK$2, Z_TREES: Z_TREES$1,
      Z_OK: Z_OK$1$1, Z_STREAM_END: Z_STREAM_END$1$1, Z_NEED_DICT: Z_NEED_DICT$1$1, Z_STREAM_ERROR: Z_STREAM_ERROR$1$1, Z_DATA_ERROR: Z_DATA_ERROR$1$1, Z_MEM_ERROR: Z_MEM_ERROR$1$1, Z_BUF_ERROR: Z_BUF_ERROR$2,
      Z_DEFLATED: Z_DEFLATED$3
    } = constants$2$1;


    /* STATES ====================================================================*/
    /* ===========================================================================*/


    const    HEAD$1 = 16180;       /* i: waiting for magic header */
    const    FLAGS$1 = 16181;      /* i: waiting for method and flags (gzip) */
    const    TIME$1 = 16182;       /* i: waiting for modification time (gzip) */
    const    OS$1 = 16183;         /* i: waiting for extra flags and operating system (gzip) */
    const    EXLEN$1 = 16184;      /* i: waiting for extra length (gzip) */
    const    EXTRA$1 = 16185;      /* i: waiting for extra bytes (gzip) */
    const    NAME$1 = 16186;       /* i: waiting for end of file name (gzip) */
    const    COMMENT$1 = 16187;    /* i: waiting for end of comment (gzip) */
    const    HCRC$1 = 16188;       /* i: waiting for header crc (gzip) */
    const    DICTID$1 = 16189;    /* i: waiting for dictionary check value */
    const    DICT$1 = 16190;      /* waiting for inflateSetDictionary() call */
    const        TYPE$2 = 16191;      /* i: waiting for type bits, including last-flag bit */
    const        TYPEDO$1 = 16192;    /* i: same, but skip check to exit inflate on new block */
    const        STORED$1 = 16193;    /* i: waiting for stored size (length and complement) */
    const        COPY_$1 = 16194;     /* i/o: same as COPY below, but only first time in */
    const        COPY$1 = 16195;      /* i/o: waiting for input or output to copy stored block */
    const        TABLE$1 = 16196;     /* i: waiting for dynamic block table lengths */
    const        LENLENS$1 = 16197;   /* i: waiting for code length code lengths */
    const        CODELENS$1 = 16198;  /* i: waiting for length/lit and distance code lengths */
    const            LEN_$1 = 16199;      /* i: same as LEN below, but only first time in */
    const            LEN$1 = 16200;       /* i: waiting for length/lit/eob code */
    const            LENEXT$1 = 16201;    /* i: waiting for length extra bits */
    const            DIST$1 = 16202;      /* i: waiting for distance code */
    const            DISTEXT$1 = 16203;   /* i: waiting for distance extra bits */
    const            MATCH$1 = 16204;     /* o: waiting for output space to copy string */
    const            LIT$1 = 16205;       /* o: waiting for output space to write literal */
    const    CHECK$1 = 16206;     /* i: waiting for 32-bit check value */
    const    LENGTH$1 = 16207;    /* i: waiting for 32-bit length (gzip) */
    const    DONE$1 = 16208;      /* finished check, done -- remain here until reset */
    const    BAD$2 = 16209;       /* got a data error -- remain here until reset */
    const    MEM$1 = 16210;       /* got an inflate() memory error -- remain here until reset */
    const    SYNC$1 = 16211;      /* looking for synchronization bytes to restart inflate() */

    /* ===========================================================================*/



    const ENOUGH_LENS$2 = 852;
    const ENOUGH_DISTS$2 = 592;
    //const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

    const MAX_WBITS$2 = 15;
    /* 32K LZ77 window */
    const DEF_WBITS$1 = MAX_WBITS$2;


    const zswap32$1 = (q) => {

      return  (((q >>> 24) & 0xff) +
              ((q >>> 8) & 0xff00) +
              ((q & 0xff00) << 8) +
              ((q & 0xff) << 24));
    };


    function InflateState$1() {
      this.strm = null;           /* pointer back to this zlib stream */
      this.mode = 0;              /* current inflate mode */
      this.last = false;          /* true if processing last block */
      this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip,
                                     bit 2 true to validate check value */
      this.havedict = false;      /* true if dictionary provided */
      this.flags = 0;             /* gzip header method and flags (0 if zlib), or
                                     -1 if raw or no header yet */
      this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
      this.check = 0;             /* protected copy of check value */
      this.total = 0;             /* protected copy of output count */
      // TODO: may be {}
      this.head = null;           /* where to save gzip header information */

      /* sliding window */
      this.wbits = 0;             /* log base 2 of requested window size */
      this.wsize = 0;             /* window size or zero if not using window */
      this.whave = 0;             /* valid bytes in the window */
      this.wnext = 0;             /* window write index */
      this.window = null;         /* allocated sliding window, if needed */

      /* bit accumulator */
      this.hold = 0;              /* input bit accumulator */
      this.bits = 0;              /* number of bits in "in" */

      /* for string and stored block copying */
      this.length = 0;            /* literal or length of data to copy */
      this.offset = 0;            /* distance back to copy string from */

      /* for table and code decoding */
      this.extra = 0;             /* extra bits needed */

      /* fixed and dynamic code tables */
      this.lencode = null;          /* starting table for length/literal codes */
      this.distcode = null;         /* starting table for distance codes */
      this.lenbits = 0;           /* index bits for lencode */
      this.distbits = 0;          /* index bits for distcode */

      /* dynamic table building */
      this.ncode = 0;             /* number of code length code lengths */
      this.nlen = 0;              /* number of length code lengths */
      this.ndist = 0;             /* number of distance code lengths */
      this.have = 0;              /* number of code lengths in lens[] */
      this.next = null;              /* next available space in codes[] */

      this.lens = new Uint16Array(320); /* temporary storage for code lengths */
      this.work = new Uint16Array(288); /* work area for code table building */

      /*
       because we don't have pointers in js, we use lencode and distcode directly
       as buffers so we don't need codes
      */
      //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
      this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
      this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
      this.sane = 0;                   /* if false, allow invalid distance too far */
      this.back = 0;                   /* bits back of last unprocessed length/lit */
      this.was = 0;                    /* initial length of match */
    }


    const inflateStateCheck = (strm) => {

      if (!strm) {
        return 1;
      }
      const state = strm.state;
      if (!state || state.strm !== strm ||
        state.mode < HEAD$1 || state.mode > SYNC$1) {
        return 1;
      }
      return 0;
    };


    const inflateResetKeep$1 = (strm) => {

      if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1$1; }
      const state = strm.state;
      strm.total_in = strm.total_out = state.total = 0;
      strm.msg = ''; /*Z_NULL*/
      if (state.wrap) {       /* to support ill-conceived Java test suite */
        strm.adler = state.wrap & 1;
      }
      state.mode = HEAD$1;
      state.last = 0;
      state.havedict = 0;
      state.flags = -1;
      state.dmax = 32768;
      state.head = null/*Z_NULL*/;
      state.hold = 0;
      state.bits = 0;
      //state.lencode = state.distcode = state.next = state.codes;
      state.lencode = state.lendyn = new Int32Array(ENOUGH_LENS$2);
      state.distcode = state.distdyn = new Int32Array(ENOUGH_DISTS$2);

      state.sane = 1;
      state.back = -1;
      //Tracev((stderr, "inflate: reset\n"));
      return Z_OK$1$1;
    };


    const inflateReset$1 = (strm) => {

      if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1$1; }
      const state = strm.state;
      state.wsize = 0;
      state.whave = 0;
      state.wnext = 0;
      return inflateResetKeep$1(strm);

    };


    const inflateReset2$1 = (strm, windowBits) => {
      let wrap;

      /* get the state */
      if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1$1; }
      const state = strm.state;

      /* extract wrap request from windowBits parameter */
      if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
      }
      else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) {
          windowBits &= 15;
        }
      }

      /* set number of window bits, free window if different */
      if (windowBits && (windowBits < 8 || windowBits > 15)) {
        return Z_STREAM_ERROR$1$1;
      }
      if (state.window !== null && state.wbits !== windowBits) {
        state.window = null;
      }

      /* update state and reset the rest of it */
      state.wrap = wrap;
      state.wbits = windowBits;
      return inflateReset$1(strm);
    };


    const inflateInit2$1 = (strm, windowBits) => {

      if (!strm) { return Z_STREAM_ERROR$1$1; }
      //strm.msg = Z_NULL;                 /* in case we return an error */

      const state = new InflateState$1();

      //if (state === Z_NULL) return Z_MEM_ERROR;
      //Tracev((stderr, "inflate: allocated\n"));
      strm.state = state;
      state.strm = strm;
      state.window = null/*Z_NULL*/;
      state.mode = HEAD$1;     /* to pass state test in inflateReset2() */
      const ret = inflateReset2$1(strm, windowBits);
      if (ret !== Z_OK$1$1) {
        strm.state = null/*Z_NULL*/;
      }
      return ret;
    };


    const inflateInit$1 = (strm) => {

      return inflateInit2$1(strm, DEF_WBITS$1);
    };


    /*
     Return state with length and distance decoding tables and index sizes set to
     fixed code decoding.  Normally this returns fixed tables from inffixed.h.
     If BUILDFIXED is defined, then instead this routine builds the tables the
     first time it's called, and returns those tables the first time and
     thereafter.  This reduces the size of the code by about 2K bytes, in
     exchange for a little execution time.  However, BUILDFIXED should not be
     used for threaded applications, since the rewriting of the tables and virgin
     may not be thread-safe.
     */
    let virgin$1 = true;

    let lenfix$1, distfix$1; // We have no pointers in JS, so keep tables separate


    const fixedtables$1 = (state) => {

      /* build fixed huffman tables if first call (may not be thread safe) */
      if (virgin$1) {
        lenfix$1 = new Int32Array(512);
        distfix$1 = new Int32Array(32);

        /* literal/length table */
        let sym = 0;
        while (sym < 144) { state.lens[sym++] = 8; }
        while (sym < 256) { state.lens[sym++] = 9; }
        while (sym < 280) { state.lens[sym++] = 7; }
        while (sym < 288) { state.lens[sym++] = 8; }

        inftrees$1(LENS$2,  state.lens, 0, 288, lenfix$1,   0, state.work, { bits: 9 });

        /* distance table */
        sym = 0;
        while (sym < 32) { state.lens[sym++] = 5; }

        inftrees$1(DISTS$2, state.lens, 0, 32,   distfix$1, 0, state.work, { bits: 5 });

        /* do this just once */
        virgin$1 = false;
      }

      state.lencode = lenfix$1;
      state.lenbits = 9;
      state.distcode = distfix$1;
      state.distbits = 5;
    };


    /*
     Update the window with the last wsize (normally 32K) bytes written before
     returning.  If window does not exist yet, create it.  This is only called
     when a window is already in use, or when output has been written during this
     inflate call, but the end of the deflate stream has not been reached yet.
     It is also called to create a window for dictionary data when a dictionary
     is loaded.

     Providing output buffers larger than 32K to inflate() should provide a speed
     advantage, since only the last 32K of output is copied to the sliding window
     upon return from inflate(), and since all distances after the first 32K of
     output will fall in the output data, making match copies simpler and faster.
     The advantage may be dependent on the size of the processor's data caches.
     */
    const updatewindow$1 = (strm, src, end, copy) => {

      let dist;
      const state = strm.state;

      /* if it hasn't been done already, allocate space for the window */
      if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;

        state.window = new Uint8Array(state.wsize);
      }

      /* copy state->wsize or less output bytes into the circular window */
      if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
      }
      else {
        dist = state.wsize - state.wnext;
        if (dist > copy) {
          dist = copy;
        }
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
          //zmemcpy(state->window, end - copy, copy);
          state.window.set(src.subarray(end - copy, end), 0);
          state.wnext = copy;
          state.whave = state.wsize;
        }
        else {
          state.wnext += dist;
          if (state.wnext === state.wsize) { state.wnext = 0; }
          if (state.whave < state.wsize) { state.whave += dist; }
        }
      }
      return 0;
    };


    const inflate$2$1 = (strm, flush) => {

      let state;
      let input, output;          // input/output buffers
      let next;                   /* next input INDEX */
      let put;                    /* next output INDEX */
      let have, left;             /* available input and output */
      let hold;                   /* bit buffer */
      let bits;                   /* bits in bit buffer */
      let _in, _out;              /* save starting available input and output */
      let copy;                   /* number of stored or match bytes to copy */
      let from;                   /* where to copy match bytes from */
      let from_source;
      let here = 0;               /* current decoding table entry */
      let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
      //let last;                   /* parent table entry */
      let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
      let len;                    /* length to copy for repeats, bits to drop */
      let ret;                    /* return code */
      const hbuf = new Uint8Array(4);    /* buffer for gzip header crc calculation */
      let opts;

      let n; // temporary variable for NEED_BITS

      const order = /* permutation of code lengths */
        new Uint8Array([ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ]);


      if (inflateStateCheck(strm) || !strm.output ||
          (!strm.input && strm.avail_in !== 0)) {
        return Z_STREAM_ERROR$1$1;
      }

      state = strm.state;
      if (state.mode === TYPE$2) { state.mode = TYPEDO$1; }    /* skip check */


      //--- LOAD() ---
      put = strm.next_out;
      output = strm.output;
      left = strm.avail_out;
      next = strm.next_in;
      input = strm.input;
      have = strm.avail_in;
      hold = state.hold;
      bits = state.bits;
      //---

      _in = have;
      _out = left;
      ret = Z_OK$1$1;

      inf_leave: // goto emulation
      for (;;) {
        switch (state.mode) {
          case HEAD$1:
            if (state.wrap === 0) {
              state.mode = TYPEDO$1;
              break;
            }
            //=== NEEDBITS(16);
            while (bits < 16) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
              if (state.wbits === 0) {
                state.wbits = 15;
              }
              state.check = 0/*crc32(0L, Z_NULL, 0)*/;
              //=== CRC2(state.check, hold);
              hbuf[0] = hold & 0xff;
              hbuf[1] = (hold >>> 8) & 0xff;
              state.check = crc32_1$1(state.check, hbuf, 2, 0);
              //===//

              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = FLAGS$1;
              break;
            }
            if (state.head) {
              state.head.done = false;
            }
            if (!(state.wrap & 1) ||   /* check if zlib header allowed */
              (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
              strm.msg = 'incorrect header check';
              state.mode = BAD$2;
              break;
            }
            if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED$3) {
              strm.msg = 'unknown compression method';
              state.mode = BAD$2;
              break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f)/*BITS(4)*/ + 8;
            if (state.wbits === 0) {
              state.wbits = len;
            }
            if (len > 15 || len > state.wbits) {
              strm.msg = 'invalid window size';
              state.mode = BAD$2;
              break;
            }

            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;

            state.flags = 0;               /* indicate zlib header */
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
            state.mode = hold & 0x200 ? DICTID$1 : TYPE$2;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            break;
          case FLAGS$1:
            //=== NEEDBITS(16); */
            while (bits < 16) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== Z_DEFLATED$3) {
              strm.msg = 'unknown compression method';
              state.mode = BAD$2;
              break;
            }
            if (state.flags & 0xe000) {
              strm.msg = 'unknown header flags set';
              state.mode = BAD$2;
              break;
            }
            if (state.head) {
              state.head.text = ((hold >> 8) & 1);
            }
            if ((state.flags & 0x0200) && (state.wrap & 4)) {
              //=== CRC2(state.check, hold);
              hbuf[0] = hold & 0xff;
              hbuf[1] = (hold >>> 8) & 0xff;
              state.check = crc32_1$1(state.check, hbuf, 2, 0);
              //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = TIME$1;
            /* falls through */
          case TIME$1:
            //=== NEEDBITS(32); */
            while (bits < 32) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            if (state.head) {
              state.head.time = hold;
            }
            if ((state.flags & 0x0200) && (state.wrap & 4)) {
              //=== CRC4(state.check, hold)
              hbuf[0] = hold & 0xff;
              hbuf[1] = (hold >>> 8) & 0xff;
              hbuf[2] = (hold >>> 16) & 0xff;
              hbuf[3] = (hold >>> 24) & 0xff;
              state.check = crc32_1$1(state.check, hbuf, 4, 0);
              //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = OS$1;
            /* falls through */
          case OS$1:
            //=== NEEDBITS(16); */
            while (bits < 16) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            if (state.head) {
              state.head.xflags = (hold & 0xff);
              state.head.os = (hold >> 8);
            }
            if ((state.flags & 0x0200) && (state.wrap & 4)) {
              //=== CRC2(state.check, hold);
              hbuf[0] = hold & 0xff;
              hbuf[1] = (hold >>> 8) & 0xff;
              state.check = crc32_1$1(state.check, hbuf, 2, 0);
              //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = EXLEN$1;
            /* falls through */
          case EXLEN$1:
            if (state.flags & 0x0400) {
              //=== NEEDBITS(16); */
              while (bits < 16) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              state.length = hold;
              if (state.head) {
                state.head.extra_len = hold;
              }
              if ((state.flags & 0x0200) && (state.wrap & 4)) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = (hold >>> 8) & 0xff;
                state.check = crc32_1$1(state.check, hbuf, 2, 0);
                //===//
              }
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
            }
            else if (state.head) {
              state.head.extra = null/*Z_NULL*/;
            }
            state.mode = EXTRA$1;
            /* falls through */
          case EXTRA$1:
            if (state.flags & 0x0400) {
              copy = state.length;
              if (copy > have) { copy = have; }
              if (copy) {
                if (state.head) {
                  len = state.head.extra_len - state.length;
                  if (!state.head.extra) {
                    // Use untyped array for more convenient processing later
                    state.head.extra = new Uint8Array(state.head.extra_len);
                  }
                  state.head.extra.set(
                    input.subarray(
                      next,
                      // extra field is limited to 65536 bytes
                      // - no need for additional size check
                      next + copy
                    ),
                    /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                    len
                  );
                  //zmemcpy(state.head.extra + len, next,
                  //        len + copy > state.head.extra_max ?
                  //        state.head.extra_max - len : copy);
                }
                if ((state.flags & 0x0200) && (state.wrap & 4)) {
                  state.check = crc32_1$1(state.check, input, copy, next);
                }
                have -= copy;
                next += copy;
                state.length -= copy;
              }
              if (state.length) { break inf_leave; }
            }
            state.length = 0;
            state.mode = NAME$1;
            /* falls through */
          case NAME$1:
            if (state.flags & 0x0800) {
              if (have === 0) { break inf_leave; }
              copy = 0;
              do {
                // TODO: 2 or 1 bytes?
                len = input[next + copy++];
                /* use constant limit because in js we should not preallocate memory */
                if (state.head && len &&
                    (state.length < 65536 /*state.head.name_max*/)) {
                  state.head.name += String.fromCharCode(len);
                }
              } while (len && copy < have);

              if ((state.flags & 0x0200) && (state.wrap & 4)) {
                state.check = crc32_1$1(state.check, input, copy, next);
              }
              have -= copy;
              next += copy;
              if (len) { break inf_leave; }
            }
            else if (state.head) {
              state.head.name = null;
            }
            state.length = 0;
            state.mode = COMMENT$1;
            /* falls through */
          case COMMENT$1:
            if (state.flags & 0x1000) {
              if (have === 0) { break inf_leave; }
              copy = 0;
              do {
                len = input[next + copy++];
                /* use constant limit because in js we should not preallocate memory */
                if (state.head && len &&
                    (state.length < 65536 /*state.head.comm_max*/)) {
                  state.head.comment += String.fromCharCode(len);
                }
              } while (len && copy < have);
              if ((state.flags & 0x0200) && (state.wrap & 4)) {
                state.check = crc32_1$1(state.check, input, copy, next);
              }
              have -= copy;
              next += copy;
              if (len) { break inf_leave; }
            }
            else if (state.head) {
              state.head.comment = null;
            }
            state.mode = HCRC$1;
            /* falls through */
          case HCRC$1:
            if (state.flags & 0x0200) {
              //=== NEEDBITS(16); */
              while (bits < 16) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              if ((state.wrap & 4) && hold !== (state.check & 0xffff)) {
                strm.msg = 'header crc mismatch';
                state.mode = BAD$2;
                break;
              }
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
            }
            if (state.head) {
              state.head.hcrc = ((state.flags >> 9) & 1);
              state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = TYPE$2;
            break;
          case DICTID$1:
            //=== NEEDBITS(32); */
            while (bits < 32) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            strm.adler = state.check = zswap32$1(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = DICT$1;
            /* falls through */
          case DICT$1:
            if (state.havedict === 0) {
              //--- RESTORE() ---
              strm.next_out = put;
              strm.avail_out = left;
              strm.next_in = next;
              strm.avail_in = have;
              state.hold = hold;
              state.bits = bits;
              //---
              return Z_NEED_DICT$1$1;
            }
            strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
            state.mode = TYPE$2;
            /* falls through */
          case TYPE$2:
            if (flush === Z_BLOCK$2 || flush === Z_TREES$1) { break inf_leave; }
            /* falls through */
          case TYPEDO$1:
            if (state.last) {
              //--- BYTEBITS() ---//
              hold >>>= bits & 7;
              bits -= bits & 7;
              //---//
              state.mode = CHECK$1;
              break;
            }
            //=== NEEDBITS(3); */
            while (bits < 3) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            state.last = (hold & 0x01)/*BITS(1)*/;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//

            switch ((hold & 0x03)/*BITS(2)*/) {
              case 0:                             /* stored block */
                //Tracev((stderr, "inflate:     stored block%s\n",
                //        state.last ? " (last)" : ""));
                state.mode = STORED$1;
                break;
              case 1:                             /* fixed block */
                fixedtables$1(state);
                //Tracev((stderr, "inflate:     fixed codes block%s\n",
                //        state.last ? " (last)" : ""));
                state.mode = LEN_$1;             /* decode codes */
                if (flush === Z_TREES$1) {
                  //--- DROPBITS(2) ---//
                  hold >>>= 2;
                  bits -= 2;
                  //---//
                  break inf_leave;
                }
                break;
              case 2:                             /* dynamic block */
                //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                //        state.last ? " (last)" : ""));
                state.mode = TABLE$1;
                break;
              case 3:
                strm.msg = 'invalid block type';
                state.mode = BAD$2;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            //---//
            break;
          case STORED$1:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while (bits < 32) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
              strm.msg = 'invalid stored block lengths';
              state.mode = BAD$2;
              break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = COPY_$1;
            if (flush === Z_TREES$1) { break inf_leave; }
            /* falls through */
          case COPY_$1:
            state.mode = COPY$1;
            /* falls through */
          case COPY$1:
            copy = state.length;
            if (copy) {
              if (copy > have) { copy = have; }
              if (copy > left) { copy = left; }
              if (copy === 0) { break inf_leave; }
              //--- zmemcpy(put, next, copy); ---
              output.set(input.subarray(next, next + copy), put);
              //---//
              have -= copy;
              next += copy;
              left -= copy;
              put += copy;
              state.length -= copy;
              break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = TYPE$2;
            break;
          case TABLE$1:
            //=== NEEDBITS(14); */
            while (bits < 14) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
    //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
              strm.msg = 'too many length or distance symbols';
              state.mode = BAD$2;
              break;
            }
    //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = LENLENS$1;
            /* falls through */
          case LENLENS$1:
            while (state.have < state.ncode) {
              //=== NEEDBITS(3);
              while (bits < 3) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            while (state.have < 19) {
              state.lens[order[state.have++]] = 0;
            }
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;

            opts = { bits: state.lenbits };
            ret = inftrees$1(CODES$2, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;

            if (ret) {
              strm.msg = 'invalid code lengths set';
              state.mode = BAD$2;
              break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = CODELENS$1;
            /* falls through */
          case CODELENS$1:
            while (state.have < state.nlen + state.ndist) {
              for (;;) {
                here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
                here_bits = here >>> 24;
                here_op = (here >>> 16) & 0xff;
                here_val = here & 0xffff;

                if ((here_bits) <= bits) { break; }
                //--- PULLBYTE() ---//
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
                //---//
              }
              if (here_val < 16) {
                //--- DROPBITS(here.bits) ---//
                hold >>>= here_bits;
                bits -= here_bits;
                //---//
                state.lens[state.have++] = here_val;
              }
              else {
                if (here_val === 16) {
                  //=== NEEDBITS(here.bits + 2);
                  n = here_bits + 2;
                  while (bits < n) {
                    if (have === 0) { break inf_leave; }
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                  }
                  //===//
                  //--- DROPBITS(here.bits) ---//
                  hold >>>= here_bits;
                  bits -= here_bits;
                  //---//
                  if (state.have === 0) {
                    strm.msg = 'invalid bit length repeat';
                    state.mode = BAD$2;
                    break;
                  }
                  len = state.lens[state.have - 1];
                  copy = 3 + (hold & 0x03);//BITS(2);
                  //--- DROPBITS(2) ---//
                  hold >>>= 2;
                  bits -= 2;
                  //---//
                }
                else if (here_val === 17) {
                  //=== NEEDBITS(here.bits + 3);
                  n = here_bits + 3;
                  while (bits < n) {
                    if (have === 0) { break inf_leave; }
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                  }
                  //===//
                  //--- DROPBITS(here.bits) ---//
                  hold >>>= here_bits;
                  bits -= here_bits;
                  //---//
                  len = 0;
                  copy = 3 + (hold & 0x07);//BITS(3);
                  //--- DROPBITS(3) ---//
                  hold >>>= 3;
                  bits -= 3;
                  //---//
                }
                else {
                  //=== NEEDBITS(here.bits + 7);
                  n = here_bits + 7;
                  while (bits < n) {
                    if (have === 0) { break inf_leave; }
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                  }
                  //===//
                  //--- DROPBITS(here.bits) ---//
                  hold >>>= here_bits;
                  bits -= here_bits;
                  //---//
                  len = 0;
                  copy = 11 + (hold & 0x7f);//BITS(7);
                  //--- DROPBITS(7) ---//
                  hold >>>= 7;
                  bits -= 7;
                  //---//
                }
                if (state.have + copy > state.nlen + state.ndist) {
                  strm.msg = 'invalid bit length repeat';
                  state.mode = BAD$2;
                  break;
                }
                while (copy--) {
                  state.lens[state.have++] = len;
                }
              }
            }

            /* handle error breaks in while */
            if (state.mode === BAD$2) { break; }

            /* check for end-of-block code (better have one) */
            if (state.lens[256] === 0) {
              strm.msg = 'invalid code -- missing end-of-block';
              state.mode = BAD$2;
              break;
            }

            /* build code tables -- note: do not change the lenbits or distbits
               values here (9 and 6) without reading the comments in inftrees.h
               concerning the ENOUGH constants, which depend on those values */
            state.lenbits = 9;

            opts = { bits: state.lenbits };
            ret = inftrees$1(LENS$2, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;

            if (ret) {
              strm.msg = 'invalid literal/lengths set';
              state.mode = BAD$2;
              break;
            }

            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = { bits: state.distbits };
            ret = inftrees$1(DISTS$2, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;

            if (ret) {
              strm.msg = 'invalid distances set';
              state.mode = BAD$2;
              break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = LEN_$1;
            if (flush === Z_TREES$1) { break inf_leave; }
            /* falls through */
          case LEN_$1:
            state.mode = LEN$1;
            /* falls through */
          case LEN$1:
            if (have >= 6 && left >= 258) {
              //--- RESTORE() ---
              strm.next_out = put;
              strm.avail_out = left;
              strm.next_in = next;
              strm.avail_in = have;
              state.hold = hold;
              state.bits = bits;
              //---
              inffast$1(strm, _out);
              //--- LOAD() ---
              put = strm.next_out;
              output = strm.output;
              left = strm.avail_out;
              next = strm.next_in;
              input = strm.input;
              have = strm.avail_in;
              hold = state.hold;
              bits = state.bits;
              //---

              if (state.mode === TYPE$2) {
                state.back = -1;
              }
              break;
            }
            state.back = 0;
            for (;;) {
              here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
              here_bits = here >>> 24;
              here_op = (here >>> 16) & 0xff;
              here_val = here & 0xffff;

              if (here_bits <= bits) { break; }
              //--- PULLBYTE() ---//
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
              //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
              last_bits = here_bits;
              last_op = here_op;
              last_val = here_val;
              for (;;) {
                here = state.lencode[last_val +
                        ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
                here_bits = here >>> 24;
                here_op = (here >>> 16) & 0xff;
                here_val = here & 0xffff;

                if ((last_bits + here_bits) <= bits) { break; }
                //--- PULLBYTE() ---//
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
                //---//
              }
              //--- DROPBITS(last.bits) ---//
              hold >>>= last_bits;
              bits -= last_bits;
              //---//
              state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
              //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
              //        "inflate:         literal '%c'\n" :
              //        "inflate:         literal 0x%02x\n", here.val));
              state.mode = LIT$1;
              break;
            }
            if (here_op & 32) {
              //Tracevv((stderr, "inflate:         end of block\n"));
              state.back = -1;
              state.mode = TYPE$2;
              break;
            }
            if (here_op & 64) {
              strm.msg = 'invalid literal/length code';
              state.mode = BAD$2;
              break;
            }
            state.extra = here_op & 15;
            state.mode = LENEXT$1;
            /* falls through */
          case LENEXT$1:
            if (state.extra) {
              //=== NEEDBITS(state.extra);
              n = state.extra;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
              //--- DROPBITS(state.extra) ---//
              hold >>>= state.extra;
              bits -= state.extra;
              //---//
              state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = DIST$1;
            /* falls through */
          case DIST$1:
            for (;;) {
              here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
              here_bits = here >>> 24;
              here_op = (here >>> 16) & 0xff;
              here_val = here & 0xffff;

              if ((here_bits) <= bits) { break; }
              //--- PULLBYTE() ---//
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
              //---//
            }
            if ((here_op & 0xf0) === 0) {
              last_bits = here_bits;
              last_op = here_op;
              last_val = here_val;
              for (;;) {
                here = state.distcode[last_val +
                        ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
                here_bits = here >>> 24;
                here_op = (here >>> 16) & 0xff;
                here_val = here & 0xffff;

                if ((last_bits + here_bits) <= bits) { break; }
                //--- PULLBYTE() ---//
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
                //---//
              }
              //--- DROPBITS(last.bits) ---//
              hold >>>= last_bits;
              bits -= last_bits;
              //---//
              state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
              strm.msg = 'invalid distance code';
              state.mode = BAD$2;
              break;
            }
            state.offset = here_val;
            state.extra = (here_op) & 15;
            state.mode = DISTEXT$1;
            /* falls through */
          case DISTEXT$1:
            if (state.extra) {
              //=== NEEDBITS(state.extra);
              n = state.extra;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
              //--- DROPBITS(state.extra) ---//
              hold >>>= state.extra;
              bits -= state.extra;
              //---//
              state.back += state.extra;
            }
    //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD$2;
              break;
            }
    //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = MATCH$1;
            /* falls through */
          case MATCH$1:
            if (left === 0) { break inf_leave; }
            copy = _out - left;
            if (state.offset > copy) {         /* copy from window */
              copy = state.offset - copy;
              if (copy > state.whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD$2;
                  break;
                }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
    //          Trace((stderr, "inflate.c too far\n"));
    //          copy -= state.whave;
    //          if (copy > state.length) { copy = state.length; }
    //          if (copy > left) { copy = left; }
    //          left -= copy;
    //          state.length -= copy;
    //          do {
    //            output[put++] = 0;
    //          } while (--copy);
    //          if (state.length === 0) { state.mode = LEN; }
    //          break;
    //#endif
              }
              if (copy > state.wnext) {
                copy -= state.wnext;
                from = state.wsize - copy;
              }
              else {
                from = state.wnext - copy;
              }
              if (copy > state.length) { copy = state.length; }
              from_source = state.window;
            }
            else {                              /* copy from output */
              from_source = output;
              from = put - state.offset;
              copy = state.length;
            }
            if (copy > left) { copy = left; }
            left -= copy;
            state.length -= copy;
            do {
              output[put++] = from_source[from++];
            } while (--copy);
            if (state.length === 0) { state.mode = LEN$1; }
            break;
          case LIT$1:
            if (left === 0) { break inf_leave; }
            output[put++] = state.length;
            left--;
            state.mode = LEN$1;
            break;
          case CHECK$1:
            if (state.wrap) {
              //=== NEEDBITS(32);
              while (bits < 32) {
                if (have === 0) { break inf_leave; }
                have--;
                // Use '|' instead of '+' to make sure that result is signed
                hold |= input[next++] << bits;
                bits += 8;
              }
              //===//
              _out -= left;
              strm.total_out += _out;
              state.total += _out;
              if ((state.wrap & 4) && _out) {
                strm.adler = state.check =
                    /*UPDATE_CHECK(state.check, put - _out, _out);*/
                    (state.flags ? crc32_1$1(state.check, output, _out, put - _out) : adler32_1$1(state.check, output, _out, put - _out));

              }
              _out = left;
              // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
              if ((state.wrap & 4) && (state.flags ? hold : zswap32$1(hold)) !== state.check) {
                strm.msg = 'incorrect data check';
                state.mode = BAD$2;
                break;
              }
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = LENGTH$1;
            /* falls through */
          case LENGTH$1:
            if (state.wrap && state.flags) {
              //=== NEEDBITS(32);
              while (bits < 32) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              if ((state.wrap & 4) && hold !== (state.total & 0xffffffff)) {
                strm.msg = 'incorrect length check';
                state.mode = BAD$2;
                break;
              }
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = DONE$1;
            /* falls through */
          case DONE$1:
            ret = Z_STREAM_END$1$1;
            break inf_leave;
          case BAD$2:
            ret = Z_DATA_ERROR$1$1;
            break inf_leave;
          case MEM$1:
            return Z_MEM_ERROR$1$1;
          case SYNC$1:
            /* falls through */
          default:
            return Z_STREAM_ERROR$1$1;
        }
      }

      // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

      /*
         Return from inflate(), updating the total counts and the check value.
         If there was no progress during the inflate() call, return a buffer
         error.  Call updatewindow() to create and/or update the window state.
         Note: a memory error from inflate() is non-recoverable.
       */

      //--- RESTORE() ---
      strm.next_out = put;
      strm.avail_out = left;
      strm.next_in = next;
      strm.avail_in = have;
      state.hold = hold;
      state.bits = bits;
      //---

      if (state.wsize || (_out !== strm.avail_out && state.mode < BAD$2 &&
                          (state.mode < CHECK$1 || flush !== Z_FINISH$1$1))) {
        if (updatewindow$1(strm, strm.output, strm.next_out, _out - strm.avail_out)) ;
      }
      _in -= strm.avail_in;
      _out -= strm.avail_out;
      strm.total_in += _in;
      strm.total_out += _out;
      state.total += _out;
      if ((state.wrap & 4) && _out) {
        strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
          (state.flags ? crc32_1$1(state.check, output, _out, strm.next_out - _out) : adler32_1$1(state.check, output, _out, strm.next_out - _out));
      }
      strm.data_type = state.bits + (state.last ? 64 : 0) +
                        (state.mode === TYPE$2 ? 128 : 0) +
                        (state.mode === LEN_$1 || state.mode === COPY_$1 ? 256 : 0);
      if (((_in === 0 && _out === 0) || flush === Z_FINISH$1$1) && ret === Z_OK$1$1) {
        ret = Z_BUF_ERROR$2;
      }
      return ret;
    };


    const inflateEnd$1 = (strm) => {

      if (inflateStateCheck(strm)) {
        return Z_STREAM_ERROR$1$1;
      }

      let state = strm.state;
      if (state.window) {
        state.window = null;
      }
      strm.state = null;
      return Z_OK$1$1;
    };


    const inflateGetHeader$1 = (strm, head) => {

      /* check state */
      if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1$1; }
      const state = strm.state;
      if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR$1$1; }

      /* save header structure */
      state.head = head;
      head.done = false;
      return Z_OK$1$1;
    };


    const inflateSetDictionary$1 = (strm, dictionary) => {
      const dictLength = dictionary.length;

      let state;
      let dictid;
      let ret;

      /* check state */
      if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1$1; }
      state = strm.state;

      if (state.wrap !== 0 && state.mode !== DICT$1) {
        return Z_STREAM_ERROR$1$1;
      }

      /* check for correct dictionary identifier */
      if (state.mode === DICT$1) {
        dictid = 1; /* adler32(0, null, 0)*/
        /* dictid = adler32(dictid, dictionary, dictLength); */
        dictid = adler32_1$1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) {
          return Z_DATA_ERROR$1$1;
        }
      }
      /* copy dictionary to window using updatewindow(), which will amend the
       existing dictionary if appropriate */
      ret = updatewindow$1(strm, dictionary, dictLength, dictLength);
      if (ret) {
        state.mode = MEM$1;
        return Z_MEM_ERROR$1$1;
      }
      state.havedict = 1;
      // Tracev((stderr, "inflate:   dictionary set\n"));
      return Z_OK$1$1;
    };


    var inflateReset_1$1 = inflateReset$1;
    var inflateReset2_1$1 = inflateReset2$1;
    var inflateResetKeep_1$1 = inflateResetKeep$1;
    var inflateInit_1$1 = inflateInit$1;
    var inflateInit2_1$1 = inflateInit2$1;
    var inflate_2$1$1 = inflate$2$1;
    var inflateEnd_1$1 = inflateEnd$1;
    var inflateGetHeader_1$1 = inflateGetHeader$1;
    var inflateSetDictionary_1$1 = inflateSetDictionary$1;
    var inflateInfo$1 = 'pako inflate (from Nodeca project)';

    /* Not implemented
    module.exports.inflateCodesUsed = inflateCodesUsed;
    module.exports.inflateCopy = inflateCopy;
    module.exports.inflateGetDictionary = inflateGetDictionary;
    module.exports.inflateMark = inflateMark;
    module.exports.inflatePrime = inflatePrime;
    module.exports.inflateSync = inflateSync;
    module.exports.inflateSyncPoint = inflateSyncPoint;
    module.exports.inflateUndermine = inflateUndermine;
    module.exports.inflateValidate = inflateValidate;
    */

    var inflate_1$2$1 = {
    	inflateReset: inflateReset_1$1,
    	inflateReset2: inflateReset2_1$1,
    	inflateResetKeep: inflateResetKeep_1$1,
    	inflateInit: inflateInit_1$1,
    	inflateInit2: inflateInit2_1$1,
    	inflate: inflate_2$1$1,
    	inflateEnd: inflateEnd_1$1,
    	inflateGetHeader: inflateGetHeader_1$1,
    	inflateSetDictionary: inflateSetDictionary_1$1,
    	inflateInfo: inflateInfo$1
    };

    // (C) 1995-2013 Jean-loup Gailly and Mark Adler
    // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
    //
    // This software is provided 'as-is', without any express or implied
    // warranty. In no event will the authors be held liable for any damages
    // arising from the use of this software.
    //
    // Permission is granted to anyone to use this software for any purpose,
    // including commercial applications, and to alter it and redistribute it
    // freely, subject to the following restrictions:
    //
    // 1. The origin of this software must not be misrepresented; you must not
    //   claim that you wrote the original software. If you use this software
    //   in a product, an acknowledgment in the product documentation would be
    //   appreciated but is not required.
    // 2. Altered source versions must be plainly marked as such, and must not be
    //   misrepresented as being the original software.
    // 3. This notice may not be removed or altered from any source distribution.

    function GZheader$1() {
      /* true if compressed data believed to be text */
      this.text       = 0;
      /* modification time */
      this.time       = 0;
      /* extra flags (not used when writing a gzip file) */
      this.xflags     = 0;
      /* operating system */
      this.os         = 0;
      /* pointer to extra field or Z_NULL if none */
      this.extra      = null;
      /* extra field length (valid if extra != Z_NULL) */
      this.extra_len  = 0; // Actually, we don't need it in JS,
                           // but leave for few code modifications

      //
      // Setup limits is not necessary because in js we should not preallocate memory
      // for inflate use constant limit in 65536 bytes
      //

      /* space at extra (only when reading header) */
      // this.extra_max  = 0;
      /* pointer to zero-terminated file name or Z_NULL */
      this.name       = '';
      /* space at name (only when reading header) */
      // this.name_max   = 0;
      /* pointer to zero-terminated comment or Z_NULL */
      this.comment    = '';
      /* space at comment (only when reading header) */
      // this.comm_max   = 0;
      /* true if there was or will be a header crc */
      this.hcrc       = 0;
      /* true when done reading gzip header (not used when writing a gzip file) */
      this.done       = false;
    }

    var gzheader$1 = GZheader$1;

    const toString$2 = Object.prototype.toString;

    /* Public constants ==========================================================*/
    /* ===========================================================================*/

    const {
      Z_NO_FLUSH: Z_NO_FLUSH$3, Z_FINISH: Z_FINISH$4,
      Z_OK: Z_OK$4, Z_STREAM_END: Z_STREAM_END$4, Z_NEED_DICT: Z_NEED_DICT$2, Z_STREAM_ERROR: Z_STREAM_ERROR$3, Z_DATA_ERROR: Z_DATA_ERROR$3, Z_MEM_ERROR: Z_MEM_ERROR$2
    } = constants$2$1;

    /* ===========================================================================*/


    /**
     * class Inflate
     *
     * Generic JS-style wrapper for zlib calls. If you don't need
     * streaming behaviour - use more simple functions: [[inflate]]
     * and [[inflateRaw]].
     **/

    /* internal
     * inflate.chunks -> Array
     *
     * Chunks of output data, if [[Inflate#onData]] not overridden.
     **/

    /**
     * Inflate.result -> Uint8Array|String
     *
     * Uncompressed result, generated by default [[Inflate#onData]]
     * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
     * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
     **/

    /**
     * Inflate.err -> Number
     *
     * Error code after inflate finished. 0 (Z_OK) on success.
     * Should be checked if broken data possible.
     **/

    /**
     * Inflate.msg -> String
     *
     * Error message, if [[Inflate.err]] != 0
     **/


    /**
     * new Inflate(options)
     * - options (Object): zlib inflate options.
     *
     * Creates new inflator instance with specified params. Throws exception
     * on bad params. Supported options:
     *
     * - `windowBits`
     * - `dictionary`
     *
     * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
     * for more information on these.
     *
     * Additional options, for internal needs:
     *
     * - `chunkSize` - size of generated data chunks (16K by default)
     * - `raw` (Boolean) - do raw inflate
     * - `to` (String) - if equal to 'string', then result will be converted
     *   from utf8 to utf16 (javascript) string. When string output requested,
     *   chunk length can differ from `chunkSize`, depending on content.
     *
     * By default, when no options set, autodetect deflate/gzip data format via
     * wrapper header.
     *
     * ##### Example:
     *
     * ```javascript
     * const pako = require('pako')
     * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
     * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
     *
     * const inflate = new pako.Inflate({ level: 3});
     *
     * inflate.push(chunk1, false);
     * inflate.push(chunk2, true);  // true -> last chunk
     *
     * if (inflate.err) { throw new Error(inflate.err); }
     *
     * console.log(inflate.result);
     * ```
     **/
    function Inflate$1$1(options) {
      this.options = common$1.assign({
        chunkSize: 1024 * 64,
        windowBits: 15,
        to: ''
      }, options || {});

      const opt = this.options;

      // Force window size for `raw` data, if not set directly,
      // because we have no header for autodetect.
      if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) { opt.windowBits = -15; }
      }

      // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
      if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
          !(options && options.windowBits)) {
        opt.windowBits += 32;
      }

      // Gzip header has no info about windows size, we can do autodetect only
      // for deflate. So, if window size not set, force it to max when gzip possible
      if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
        // bit 3 (16) -> gzipped data
        // bit 4 (32) -> autodetect gzip/deflate
        if ((opt.windowBits & 15) === 0) {
          opt.windowBits |= 15;
        }
      }

      this.err    = 0;      // error code, if happens (0 = Z_OK)
      this.msg    = '';     // error message
      this.ended  = false;  // used to avoid multiple onEnd() calls
      this.chunks = [];     // chunks of compressed data

      this.strm   = new zstream$1();
      this.strm.avail_out = 0;

      let status  = inflate_1$2$1.inflateInit2(
        this.strm,
        opt.windowBits
      );

      if (status !== Z_OK$4) {
        throw new Error(messages$1[status]);
      }

      this.header = new gzheader$1();

      inflate_1$2$1.inflateGetHeader(this.strm, this.header);

      // Setup dictionary
      if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') {
          opt.dictionary = strings$1.string2buf(opt.dictionary);
        } else if (toString$2.call(opt.dictionary) === '[object ArrayBuffer]') {
          opt.dictionary = new Uint8Array(opt.dictionary);
        }
        if (opt.raw) { //In raw mode we need to set the dictionary early
          status = inflate_1$2$1.inflateSetDictionary(this.strm, opt.dictionary);
          if (status !== Z_OK$4) {
            throw new Error(messages$1[status]);
          }
        }
      }
    }

    /**
     * Inflate#push(data[, flush_mode]) -> Boolean
     * - data (Uint8Array|ArrayBuffer): input data
     * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
     *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
     *   `true` means Z_FINISH.
     *
     * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
     * new output chunks. Returns `true` on success. If end of stream detected,
     * [[Inflate#onEnd]] will be called.
     *
     * `flush_mode` is not needed for normal operation, because end of stream
     * detected automatically. You may try to use it for advanced things, but
     * this functionality was not tested.
     *
     * On fail call [[Inflate#onEnd]] with error code and return false.
     *
     * ##### Example
     *
     * ```javascript
     * push(chunk, false); // push one of data chunks
     * ...
     * push(chunk, true);  // push last chunk
     * ```
     **/
    Inflate$1$1.prototype.push = function (data, flush_mode) {
      const strm = this.strm;
      const chunkSize = this.options.chunkSize;
      const dictionary = this.options.dictionary;
      let status, _flush_mode, last_avail_out;

      if (this.ended) return false;

      if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
      else _flush_mode = flush_mode === true ? Z_FINISH$4 : Z_NO_FLUSH$3;

      // Convert data if needed
      if (toString$2.call(data) === '[object ArrayBuffer]') {
        strm.input = new Uint8Array(data);
      } else {
        strm.input = data;
      }

      strm.next_in = 0;
      strm.avail_in = strm.input.length;

      for (;;) {
        if (strm.avail_out === 0) {
          strm.output = new Uint8Array(chunkSize);
          strm.next_out = 0;
          strm.avail_out = chunkSize;
        }

        status = inflate_1$2$1.inflate(strm, _flush_mode);

        if (status === Z_NEED_DICT$2 && dictionary) {
          status = inflate_1$2$1.inflateSetDictionary(strm, dictionary);

          if (status === Z_OK$4) {
            status = inflate_1$2$1.inflate(strm, _flush_mode);
          } else if (status === Z_DATA_ERROR$3) {
            // Replace code with more verbose
            status = Z_NEED_DICT$2;
          }
        }

        // Skip snyc markers if more data follows and not raw mode
        while (strm.avail_in > 0 &&
               status === Z_STREAM_END$4 &&
               strm.state.wrap > 0 &&
               data[strm.next_in] !== 0)
        {
          inflate_1$2$1.inflateReset(strm);
          status = inflate_1$2$1.inflate(strm, _flush_mode);
        }

        switch (status) {
          case Z_STREAM_ERROR$3:
          case Z_DATA_ERROR$3:
          case Z_NEED_DICT$2:
          case Z_MEM_ERROR$2:
            this.onEnd(status);
            this.ended = true;
            return false;
        }

        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;

        if (strm.next_out) {
          if (strm.avail_out === 0 || status === Z_STREAM_END$4) {

            if (this.options.to === 'string') {

              let next_out_utf8 = strings$1.utf8border(strm.output, strm.next_out);

              let tail = strm.next_out - next_out_utf8;
              let utf8str = strings$1.buf2string(strm.output, next_out_utf8);

              // move tail & realign counters
              strm.next_out = tail;
              strm.avail_out = chunkSize - tail;
              if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);

              this.onData(utf8str);

            } else {
              this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
          }
        }

        // Must repeat iteration if out buffer is full
        if (status === Z_OK$4 && last_avail_out === 0) continue;

        // Finalize if end of stream reached.
        if (status === Z_STREAM_END$4) {
          status = inflate_1$2$1.inflateEnd(this.strm);
          this.onEnd(status);
          this.ended = true;
          return true;
        }

        if (strm.avail_in === 0) break;
      }

      return true;
    };


    /**
     * Inflate#onData(chunk) -> Void
     * - chunk (Uint8Array|String): output data. When string output requested,
     *   each chunk will be string.
     *
     * By default, stores data blocks in `chunks[]` property and glue
     * those in `onEnd`. Override this handler, if you need another behaviour.
     **/
    Inflate$1$1.prototype.onData = function (chunk) {
      this.chunks.push(chunk);
    };


    /**
     * Inflate#onEnd(status) -> Void
     * - status (Number): inflate status. 0 (Z_OK) on success,
     *   other if not.
     *
     * Called either after you tell inflate that the input stream is
     * complete (Z_FINISH). By default - join collected chunks,
     * free memory and fill `results` / `err` properties.
     **/
    Inflate$1$1.prototype.onEnd = function (status) {
      // On success - join
      if (status === Z_OK$4) {
        if (this.options.to === 'string') {
          this.result = this.chunks.join('');
        } else {
          this.result = common$1.flattenChunks(this.chunks);
        }
      }
      this.chunks = [];
      this.err = status;
      this.msg = this.strm.msg;
    };


    /**
     * inflate(data[, options]) -> Uint8Array|String
     * - data (Uint8Array|ArrayBuffer): input data to decompress.
     * - options (Object): zlib inflate options.
     *
     * Decompress `data` with inflate/ungzip and `options`. Autodetect
     * format via wrapper header by default. That's why we don't provide
     * separate `ungzip` method.
     *
     * Supported options are:
     *
     * - windowBits
     *
     * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
     * for more information.
     *
     * Sugar (options):
     *
     * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
     *   negative windowBits implicitly.
     * - `to` (String) - if equal to 'string', then result will be converted
     *   from utf8 to utf16 (javascript) string. When string output requested,
     *   chunk length can differ from `chunkSize`, depending on content.
     *
     *
     * ##### Example:
     *
     * ```javascript
     * const pako = require('pako');
     * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
     * let output;
     *
     * try {
     *   output = pako.inflate(input);
     * } catch (err) {
     *   console.log(err);
     * }
     * ```
     **/
    function inflate$1$1(input, options) {
      const inflator = new Inflate$1$1(options);

      inflator.push(input);

      // That will never happens, if you don't cheat with options :)
      if (inflator.err) throw inflator.msg || messages$1[inflator.err];

      return inflator.result;
    }


    /**
     * inflateRaw(data[, options]) -> Uint8Array|String
     * - data (Uint8Array|ArrayBuffer): input data to decompress.
     * - options (Object): zlib inflate options.
     *
     * The same as [[inflate]], but creates raw data, without wrapper
     * (header and adler32 crc).
     **/
    function inflateRaw$1$1(input, options) {
      options = options || {};
      options.raw = true;
      return inflate$1$1(input, options);
    }


    /**
     * ungzip(data[, options]) -> Uint8Array|String
     * - data (Uint8Array|ArrayBuffer): input data to decompress.
     * - options (Object): zlib inflate options.
     *
     * Just shortcut to [[inflate]], because it autodetects format
     * by header.content. Done for convenience.
     **/


    var Inflate_1$1$1 = Inflate$1$1;
    var inflate_2$2 = inflate$1$1;
    var inflateRaw_1$1$1 = inflateRaw$1$1;
    var ungzip$1$1 = inflate$1$1;
    var constants$3 = constants$2$1;

    var inflate_1$1$1 = {
    	Inflate: Inflate_1$1$1,
    	inflate: inflate_2$2,
    	inflateRaw: inflateRaw_1$1$1,
    	ungzip: ungzip$1$1,
    	constants: constants$3
    };

    const { Deflate, deflate, deflateRaw, gzip } = deflate_1$1;

    const { Inflate: Inflate$2, inflate: inflate$3, inflateRaw: inflateRaw$2, ungzip: ungzip$2 } = inflate_1$1$1;
    var deflateRaw_1 = deflateRaw;
    var inflate_1$3 = inflate$3;
    var inflateRaw_1 = inflateRaw$2;
    var ungzip_1$1 = ungzip$2;

    const FEXTRA = 4;  // gzip spec F.EXTRA flag

    function isgzipped(data) {
        const b = ArrayBuffer.isView(data) ? data : new Uint8Array(data);
        return b[0] ===31 && b[1] === 139;
    }

    /**
     * Pako does not properly ungzip block compressed files if > 1 block is present.  Test for bgzip and use wrapper.
     */
    function ungzip_blocks(data) {
        const ba = ArrayBuffer.isView(data) ? data : new Uint8Array(data);
        const b = ba[3] & FEXTRA;
        if (b !== 0 && ba[12] === 66 && ba[13] === 67) {
            return unbgzf(ba.buffer);
        } else {
            return ungzip_1$1(ba);
        }
    }

    // Uncompress data,  assumed to be series of bgzipped blocks
    function unbgzf(data, lim) {

        const oBlockList = [];
        let ptr = 0;
        let totalSize = 0;

        lim = lim || data.byteLength - 18;

        while (ptr < lim) {
            try {
                const ba = ArrayBuffer.isView(data) ? data : new Uint8Array(data, ptr, 18);
                const xlen = (ba[11] << 8) | (ba[10]);
                const flg = ba[3];
                const fextra = flg & FEXTRA;
                const si1 = ba[12];
                const si2 = ba[13];
                const slen = (ba[15] << 8) | (ba[14]);
                const bsize = ((ba[17] << 8) | (ba[16])) + 1;
                const start = 12 + xlen + ptr;    // Start of CDATA
                const bytesLeft = data.byteLength - start;
                const cDataSize = bsize - xlen - 19;
                if (bytesLeft < cDataSize || cDataSize <= 0) break;

                const a = new Uint8Array(data, start, cDataSize);
                const unc = inflateRaw_1(a);

                // const inflate = new Zlib.RawInflate(a);
                // const unc = inflate.decompress();

                ptr += (cDataSize - 1) + 26; //inflate.ip + 26
                totalSize += unc.byteLength;
                oBlockList.push(unc);
            } catch (e) {
                console.error(e);
                break;
            }
        }

        // Concatenate decompressed blocks
        if (oBlockList.length === 1) {
            return oBlockList[0];
        } else {
            const out = new Uint8Array(totalSize);
            let cursor = 0;
            for (let i = 0; i < oBlockList.length; ++i) {
                var b = new Uint8Array(oBlockList[i]);
                arrayCopy(b, 0, out, cursor, b.length);
                cursor += b.length;
            }
            return out;
        }
    }

    function bgzBlockSize$1(data) {
        const ba = ArrayBuffer.isView(data) ? data : new Uint8Array(data);
        const bsize = (ba[17] << 8 | ba[16]) + 1;
        return bsize;
    }

    // From Thomas Down's zlib implementation

    const testArray = new Uint8Array(1);
    const hasSubarray = (typeof testArray.subarray === 'function');

    function arrayCopy(src, srcOffset, dest, destOffset, count) {
        if (count === 0) {
            return;
        }
        if (!src) {
            throw "Undef src";
        } else if (!dest) {
            throw "Undef dest";
        }
        if (srcOffset === 0 && count === src.length) {
            arrayCopy_fast(src, dest, destOffset);
        } else if (hasSubarray) {
            arrayCopy_fast(src.subarray(srcOffset, srcOffset + count), dest, destOffset);
        } else if (src.BYTES_PER_ELEMENT === 1 && count > 100) {
            arrayCopy_fast(new Uint8Array(src.buffer, src.byteOffset + srcOffset, count), dest, destOffset);
        } else {
            arrayCopy_slow(src, srcOffset, dest, destOffset, count);
        }
    }

    function arrayCopy_slow(src, srcOffset, dest, destOffset, count) {
        for (let i = 0; i < count; ++i) {
            dest[destOffset + i] = src[srcOffset + i];
        }
    }

    function arrayCopy_fast(src, dest, destOffset) {
        dest.set(src, destOffset);
    }


    /**
     * Compress string and encode in a url safe form
     * @param s
     */
    function compressString(str) {

        const bytes = new Uint8Array(str.length);
        for (var i = 0; i < str.length; i++) {
            bytes[i] = str.charCodeAt(i);
        }
        const compressedBytes = new deflateRaw_1(bytes);            // UInt8Arry
        const compressedString = String.fromCharCode.apply(null, compressedBytes);      // Convert to string
        let enc = btoa(compressedString);
        return enc.replace(/\+/g, '.').replace(/\//g, '_').replace(/=/g, '-');   // URL safe
    }

    /**
     * Uncompress the url-safe encoded compressed string, presumably created by compressString above
     *
     * @param enc
     * @returns {string}
     */
    function uncompressString(enc) {

        enc = enc.replace(/\./g, '+').replace(/_/g, '/').replace(/-/g, '=');

        const compressedString = atob(enc);
        const compressedBytes = [];
        for (let i = 0; i < compressedString.length; i++) {
            compressedBytes.push(compressedString.charCodeAt(i));
        }
        //const bytes = new Zlib.RawInflate(compressedBytes).decompress();
        const bytes = inflateRaw_1(compressedBytes);

        let str = '';
        for (let b of bytes) {
            str += String.fromCharCode(b);
        }
        return str;
    }


    /**
     * @param dataURI
     * @returns {Array<number>|Uint8Array}
     */
    function decodeDataURI$1(dataURI, gzip) {

        const split = dataURI.split(',');
        const info = split[0].split(':')[1];
        let dataString = split[1];

        if (info.indexOf('base64') >= 0) {
            dataString = atob(dataString);

            const bytes = new Uint8Array(dataString.length);
            for (let i = 0; i < dataString.length; i++) {
                bytes[i] = dataString.charCodeAt(i);
            }

            let plain;
            if (gzip || info.indexOf('gzip') > 0) {
                plain = ungzip_1$1(bytes);
            } else {
                plain = bytes;
            }
            return plain
        } else {
            return decodeURIComponent(dataString);      // URL encoded string -- not currently used or tested
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */
    const IGVMath = {

        lerp: (v0, v1, t) => {
            return (1 - t) * v0 + t * v1;
        },

        mean: function (array) {

            var t = 0, n = 0,
                i;
            for (i = 0; i < array.length; i++) {
                if (!isNaN(array[i])) {
                    t += array[i];
                    n++;
                }
            }
            return n > 0 ? t / n : 0;
        },

        meanAndStdev: function (array) {

            var v, t = 0, t2 = 0, n = 0, i;

            for (i = 0; i < array.length; i++) {

                v = array[i];

                if (!isNaN(v)) {
                    t += v;
                    t2 += v * v;
                    n++;
                }
            }
            return n > 0 ? {mean: t / n, stdev: Math.sqrt(t2 - t * t / n)} : {mean: 0, stdev: 0};
        },

        median: function (numbers) {
            // median of [3, 5, 4, 4, 1, 1, 2, 3] = 3
            var median = 0, numsLen = numbers.length;
            numbers.sort();

            if (
                numsLen % 2 === 0 // is even
            ) {
                // average of two middle numbers
                median = (numbers[numsLen / 2 - 1] + numbers[numsLen / 2]) / 2;
            } else { // is odd
                // middle number only
                median = numbers[(numsLen - 1) / 2];
            }

            return median;
        },

        // Fast percentile function for "p" near edges.  This needs profiled for p in middle (e.g. median)
        percentile: function (array, p) {

            if (array.length === 0) return undefined;

            var k = Math.floor(array.length * ((100 - p) / 100));
            if (k === 0) {
                array.sort(function (a, b) {
                    return b - a
                });
                return array[k];
            } else {
                return selectElement(array, k);
            }

        },


        clamp: function (value, min, max) {
            return Math.min(Math.max(value, min), max);
        },

        log2: function (x) {
            return Math.log(x) / Math.LN2;
        }

    };

    function selectElement(array, k) {

        // Credit Steve Hanov http://stevehanov.ca/blog/index.php?id=122
        var heap = new BinaryHeap(),
            i;

        for (i = 0; i < array.length; i++) {

            var item = array[i];

            // If we have not yet found k items, or the current item is larger than
            // the smallest item on the heap, add current item
            if (heap.content.length < k || item > heap.content[0]) {
                // If the heap is full, remove the smallest element on the heap.
                if (heap.content.length === k) {
                    heap.pop();
                }
                heap.push(item);
            }
        }

        return heap.content[0];
    }


    function BinaryHeap() {
        this.content = [];
    }

    BinaryHeap.prototype = {
        push: function (element) {
            // Add the new element to the end of the array.
            this.content.push(element);
            // Allow it to bubble up.
            this.bubbleUp(this.content.length - 1);
        },

        pop: function () {
            // Store the first element so we can return it later.
            var result = this.content[0];
            // Get the element at the end of the array.
            var end = this.content.pop();
            // If there are any elements left, put the end element at the
            // start, and let it sink down.
            if (this.content.length > 0) {
                this.content[0] = end;
                this.sinkDown(0);
            }
            return result;
        },

        remove: function (node) {
            var length = this.content.length;
            // To remove a value, we must search through the array to find
            // it.
            for (var i = 0; i < length; i++) {
                if (this.content[i] !== node) continue;
                // When it is found, the process seen in 'pop' is repeated
                // to fill up the hole.
                var end = this.content.pop();
                // If the element we popped was the one we needed to remove,
                // we're done.
                if (i === length - 1) break;
                // Otherwise, we replace the removed element with the popped
                // one, and allow it to float up or sink down as appropriate.
                this.content[i] = end;
                this.bubbleUp(i);
                this.sinkDown(i);
                break;
            }
        },

        size: function () {
            return this.content.length;
        },

        bubbleUp: function (n) {
            // Fetch the element that has to be moved.
            var element = this.content[n], score = element;
            // When at 0, an element can not go up any further.
            while (n > 0) {
                // Compute the parent element's index, and fetch it.
                var parentN = Math.floor((n + 1) / 2) - 1,
                    parent = this.content[parentN];
                // If the parent has a lesser score, things are in order and we
                // are done.
                if (score >= parent)
                    break;

                // Otherwise, swap the parent with the current element and
                // continue.
                this.content[parentN] = element;
                this.content[n] = parent;
                n = parentN;
            }
        },

        sinkDown: function (n) {
            // Look up the target element and its score.
            var length = this.content.length,
                element = this.content[n],
                elemScore = element;

            while (true) {
                // Compute the indices of the child elements.
                var child2N = (n + 1) * 2, child1N = child2N - 1;
                // This is used to store the new position of the element,
                // if any.
                var swap = null;
                // If the first child exists (is inside the array)...
                if (child1N < length) {
                    // Look it up and compute its score.
                    var child1 = this.content[child1N],
                        child1Score = child1;
                    // If the score is less than our element's, we need to swap.
                    if (child1Score < elemScore)
                        swap = child1N;
                }
                // Do the same checks for the other child.
                if (child2N < length) {
                    var child2 = this.content[child2N],
                        child2Score = child2;
                    if (child2Score < (swap == null ? elemScore : child1Score))
                        swap = child2N;
                }

                // No need to swap further, we are done.
                if (swap == null) break;

                // Otherwise, swap and continue.
                this.content[n] = this.content[swap];
                this.content[swap] = element;
                n = swap;
            }
        }
    };

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    function _random(min, max) {
        return Math.random() * (max - min) + min
    }

    const IGVColor = {

        rgbListFromHSV: () => {

            let s = 1;
            let accumulation = [];
            for (let v = 1; v >= 0.5; v -= .1) {
                for (let h = 0; h < 1; h += 1 / 28) {
                    const r = "rgb(" + IGVColor.hsvToRgb(h, s, v).join(",") + ")";
                    accumulation.push(r);
                }
            }

            // add black
            accumulation.pop();
            accumulation.push(IGVColor.rgbColor(16, 16, 16));

            return accumulation
        },

        rgbToHex: function (rgb) {
            rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
            return (rgb && rgb.length === 4) ? "#" +
                ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : ''
        },

        hexToRgb: function (hex) {

            var cooked = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

            if (null === cooked) {
                return undefined
            }

            return "rgb(" + parseInt(cooked[1], 16) + "," + parseInt(cooked[2], 16) + "," + parseInt(cooked[3], 16) + ")"
        },

        /**
         * Converts an HSV color value to RGB. Conversion formula
         * adapted from http://en.wikipedia.org/wiki/HSV_color_space.
         * Assumes h, s, and v are contained in the set [0, 1] and
         * returns r, g, and b in the set [0, 255].
         *
         * Credit: https://gist.githubusercontent.com/mjackson/5311256
         *
         * @param   h       The hue
         * @param   s       The saturation
         * @param   v       The value
         * @return  Array   The RGB representation
         */
        hsvToRgb: function (h, s, v) {
            var r, g, b;

            var i = Math.floor(h * 6);
            var f = h * 6 - i;
            var p = v * (1 - s);
            var q = v * (1 - f * s);
            var t = v * (1 - (1 - f) * s);

            switch (i % 6) {
                case 0:
                    r = v, g = t, b = p;
                    break
                case 1:
                    r = q, g = v, b = p;
                    break
                case 2:
                    r = p, g = v, b = t;
                    break
                case 3:
                    r = p, g = q, b = v;
                    break
                case 4:
                    r = t, g = p, b = v;
                    break
                case 5:
                    r = v, g = p, b = q;
                    break
            }

            return [Math.floor(r * 255), Math.floor(g * 255), Math.floor(b * 255)]
        },

        /**
         * Converts an HSL color value to RGB. Conversion formula
         * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
         * Assumes h, s, and l are contained in the set [0, 1] and
         * returns r, g, and b in the set [0, 255].
         *
         * Credit: https://gist.githubusercontent.com/mjackson/5311256
         *
         * @param   h       The hue
         * @param   s       The saturation
         * @param   l       The lightness
         * @return  Array   The RGB representation
         */
        hslToRgb: function (h, s, l) {
            var r, g, b;

            if (s === 0) {
                r = g = b = l; // achromatic
            } else {


                var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;

                r = IGVColor.hue2rgb(p, q, h + 1 / 3);
                g = IGVColor.hue2rgb(p, q, h);
                b = IGVColor.hue2rgb(p, q, h - 1 / 3);
            }

            return [r * 255, g * 255, b * 255]
        },

        hue2rgb: (p, q, t) => {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t
            if (t < 1 / 2) return q
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
            return p
        },

        rgbaColor: function (r, g, b, a) {

            r = IGVMath.clamp(r, 0, 255);
            g = IGVMath.clamp(g, 0, 255);
            b = IGVMath.clamp(b, 0, 255);
            a = IGVMath.clamp(a, 0.0, 1.0);

            return "rgba(" + r + "," + g + "," + b + "," + a + ")"
        },

        rgbColor: function (r, g, b) {

            r = IGVMath.clamp(r, 0, 255);
            g = IGVMath.clamp(g, 0, 255);
            b = IGVMath.clamp(b, 0, 255);

            return "rgb(" + r + "," + g + "," + b + ")"
        },

        greyScale: function (value) {

            var grey = IGVMath.clamp(value, 0, 255);

            return "rgb(" + grey + "," + grey + "," + grey + ")"
        },

        randomGrey: function (min, max) {

            min = IGVMath.clamp(min, 0, 255);
            max = IGVMath.clamp(max, 0, 255);

            var g = Math.round(_random(min, max)).toString(10);

            return "rgb(" + g + "," + g + "," + g + ")"
        },

        randomRGB: function (min, max) {

            min = IGVMath.clamp(min, 0, 255);
            max = IGVMath.clamp(max, 0, 255);

            var r = Math.round(_random(min, max)).toString(10);
            var g = Math.round(_random(min, max)).toString(10);
            var b = Math.round(_random(min, max)).toString(10);

            return "rgb(" + r + "," + g + "," + b + ")"
        },

        randomRGBConstantAlpha: function (min, max, alpha) {

            min = IGVMath.clamp(min, 0, 255);
            max = IGVMath.clamp(max, 0, 255);

            var r = Math.round(_random(min, max)).toString(10);
            var g = Math.round(_random(min, max)).toString(10);
            var b = Math.round(_random(min, max)).toString(10);

            return "rgba(" + r + "," + g + "," + b + "," + alpha + ")"
        },

        addAlpha: function (color, alpha) {

            if (color === "0" || color === ".") {
                color = "rgb(0,0,0)";
            } else {
                const c = this.colorNameToHex(color);
                if (c) {
                    color = c;
                }
            }

            var isHex = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);

            if (color.startsWith("rgba")) {
                const idx = color.lastIndexOf(",");
                return color.substring(0, idx + 1) + alpha.toString() + ")"
            }

            if (isHex) {
                color = IGVColor.hexToRgb(color);
            }

            if (color.startsWith("rgb")) {
                return color.replace("rgb", "rgba").replace(")", ", " + alpha + ")")
            } else {
                console.log(color + " is not an rgb style string");
                return color
            }
        },

        rgbComponents: function (color) {

            if (color === "0" || color === ".") {
                return [0, 0, 0]
            }
            const isHex = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);
            if (isHex) {
                color = IGVColor.hexToRgb(color);
            } else {
                if (!color.startsWith("rgb")) {
                    const hex = this.colorNameToHex(color);
                    color = this.hexToRgb(hex);
                }
            }

            if (color.startsWith("rgb(")) {
                return color.substring(4, color.length - 1).split(",").map(s => Number.parseInt(s.trim()))
            } else if (color.startsWith("rgba(")) {
                return color.substring(5, color.length - 1).split(",").map((s, i) => {
                    s = s.trim();
                    return i === 3 ? Number.parseFloat(s) : Number.parseInt(s)
                })
            } else {
                throw Error("Unrecognized color string: color")
            }
        },

        /**
         *
         * @param dest  RGB components as an array
         * @param src  RGB components as an array
         * @param alpha   alpha transparancy in the range 0-1
         * @returns {}
         */
        getCompositeColor: function (dest, src, alpha) {

            var r = Math.floor(alpha * src[0] + (1 - alpha) * dest[0]),
                g = Math.floor(alpha * src[1] + (1 - alpha) * dest[1]),
                b = Math.floor(alpha * src[2] + (1 - alpha) * dest[2]);

            return "rgb(" + r + "," + g + "," + b + ")"

        },

        /**
         * Return a color represented by the string.  If the string is not a recognized color format return the
         * string itself.  This function exists for backward compatibility,  createColorStringSafe is preferredz
         * @param str
         */
        createColorString: function (str) {
            // Excel will quote color strings, strip all quotes
            const color = this.createColorStringSafe(str);
            return color ? color : str
        },

        /**
         * If str is a recognized color format return a string encoding the color
         * @param str
         */
        createColorStringSafe: function (str) {
            // Excel will quote color strings, strip all quotes
            str = stripQuotes$1(str);

            if (str.startsWith('rgb(') && str.endsWith(')')) {
                return str
            }
            if (str.startsWith('#') && str.length < 8) {
                return str
            }

            // See if string is a recognized web color
            const hex = this.colorNameToHex(str);
            if (hex) {
                return hex
            }

            // UCSC format (e.g.  0,0,255)
            const tokens = str.split(",");
            if (tokens.length === 3 && isColorComponent(tokens[0]) && isColorComponent(tokens[1]) && isColorComponent(tokens[2])) {
                return `rgb(${str})`
            }
        },

        darkenLighten: function (color, amt) {

            let src;
            let hexColor = this.colorNameToHex(color);
            if (hexColor) {
                src = IGVColor.hexToRgb(hexColor);
            } else {
                src = color.startsWith('rgb(') ? color : IGVColor.hexToRgb(color);
            }

            const components = src.replace(")", "").substring(4).split(",");

            const r = Math.max(0, Math.min(255, Number.parseInt(components[0].trim()) + amt));
            const g = Math.max(0, Math.min(255, Number.parseInt(components[1].trim()) + amt));
            const b = Math.max(0, Math.min(255, Number.parseInt(components[2].trim()) + amt));

            return 'rgb(' + r.toString() + ',' + g.toString() + ',' + b.toString() + ')'

        },

        /**
         * Convert html/css color name to hex value.  Adapted from https://gist.github.com/mxfh/4719348
         * @param colorName
         * @returns {*}
         */
        colorNameToHex: function (colorName) { // color list from http://stackoverflow.com/q/1573053/731179  with added gray/gray
            const definedColorNames = {
                "aliceblue": "#f0f8ff",
                "antiquewhite": "#faebd7",
                "aqua": "#00ffff",
                "aquamarine": "#7fffd4",
                "azure": "#f0ffff",
                "beige": "#f5f5dc",
                "bisque": "#ffe4c4",
                "black": "#000000",
                "blanchedalmond": "#ffebcd",
                "blue": "#0000ff",
                "blueviolet": "#8a2be2",
                "brown": "#a52a2a",
                "burlywood": "#deb887",
                "cadetblue": "#5f9ea0",
                "chartreuse": "#7fff00",
                "chocolate": "#d2691e",
                "coral": "#ff7f50",
                "cornflowerblue": "#6495ed",
                "cornsilk": "#fff8dc",
                "crimson": "#dc143c",
                "cyan": "#00ffff",
                "darkblue": "#00008b",
                "darkcyan": "#008b8b",
                "darkgoldenrod": "#b8860b",
                "darkgray": "#a9a9a9",
                "darkgreen": "#006400",
                "darkkhaki": "#bdb76b",
                "darkmagenta": "#8b008b",
                "darkolivegreen": "#556b2f",
                "darkorange": "#ff8c00",
                "darkorchid": "#9932cc",
                "darkred": "#8b0000",
                "darksalmon": "#e9967a",
                "darkseagreen": "#8fbc8f",
                "darkslateblue": "#483d8b",
                "darkslategray": "#2f4f4f",
                "darkturquoise": "#00ced1",
                "darkviolet": "#9400d3",
                "deeppink": "#ff1493",
                "deepskyblue": "#00bfff",
                "dimgray": "#696969",
                "dodgerblue": "#1e90ff",
                "firebrick": "#b22222",
                "floralwhite": "#fffaf0",
                "forestgreen": "#228b22",
                "fuchsia": "#ff00ff",
                "gainsboro": "#dcdcdc",
                "ghostwhite": "#f8f8ff",
                "gold": "#ffd700",
                "goldenrod": "#daa520",
                "gray": "#808080",
                "green": "#008000",
                "greenyellow": "#adff2f",
                "honeydew": "#f0fff0",
                "hotpink": "#ff69b4",
                "indianred ": "#cd5c5c",
                "indigo ": "#4b0082",
                "ivory": "#fffff0",
                "khaki": "#f0e68c",
                "lavender": "#e6e6fa",
                "lavenderblush": "#fff0f5",
                "lawngreen": "#7cfc00",
                "lemonchiffon": "#fffacd",
                "lightblue": "#add8e6",
                "lightcoral": "#f08080",
                "lightcyan": "#e0ffff",
                "lightgoldenrodyellow": "#fafad2",
                "lightgrey": "#d3d3d3",
                "lightgreen": "#90ee90",
                "lightpink": "#ffb6c1",
                "lightsalmon": "#ffa07a",
                "lightseagreen": "#20b2aa",
                "lightskyblue": "#87cefa",
                "lightslategray": "#778899",
                "lightsteelblue": "#b0c4de",
                "lightyellow": "#ffffe0",
                "lime": "#00ff00",
                "limegreen": "#32cd32",
                "linen": "#faf0e6",
                "magenta": "#ff00ff",
                "maroon": "#800000",
                "mediumaquamarine": "#66cdaa",
                "mediumblue": "#0000cd",
                "mediumorchid": "#ba55d3",
                "mediumpurple": "#9370d8",
                "mediumseagreen": "#3cb371",
                "mediumslateblue": "#7b68ee",
                "mediumspringgreen": "#00fa9a",
                "mediumturquoise": "#48d1cc",
                "mediumvioletred": "#c71585",
                "midnightblue": "#191970",
                "mintcream": "#f5fffa",
                "mistyrose": "#ffe4e1",
                "moccasin": "#ffe4b5",
                "navajowhite": "#ffdead",
                "navy": "#000080",
                "oldlace": "#fdf5e6",
                "olive": "#808000",
                "olivedrab": "#6b8e23",
                "orange": "#ffa500",
                "orangered": "#ff4500",
                "orchid": "#da70d6",
                "palegoldenrod": "#eee8aa",
                "palegreen": "#98fb98",
                "paleturquoise": "#afeeee",
                "palevioletred": "#d87093",
                "papayawhip": "#ffefd5",
                "peachpuff": "#ffdab9",
                "peru": "#cd853f",
                "pink": "#ffc0cb",
                "plum": "#dda0dd",
                "powderblue": "#b0e0e6",
                "purple": "#800080",
                "red": "#ff0000",
                "rosybrown": "#bc8f8f",
                "royalblue": "#4169e1",
                "saddlebrown": "#8b4513",
                "salmon": "#fa8072",
                "sandybrown": "#f4a460",
                "seagreen": "#2e8b57",
                "seashell": "#fff5ee",
                "sienna": "#a0522d",
                "silver": "#c0c0c0",
                "skyblue": "#87ceeb",
                "slateblue": "#6a5acd",
                "slategray": "#708090",
                "snow": "#fffafa",
                "springgreen": "#00ff7f",
                "steelblue": "#4682b4",
                "tan": "#d2b48c",
                "teal": "#008080",
                "thistle": "#d8bfd8",
                "tomato": "#ff6347",
                "turquoise": "#40e0d0",
                "violet": "#ee82ee",
                "wheat": "#f5deb3",
                "white": "#ffffff",
                "whitesmoke": "#f5f5f5",
                "yellow": "#ffff00",
                "yellowgreen": "#9acd32",
                "darkgrey": "#a9a9a9",
                "darkslategrey": "#2f4f4f",
                "dimgrey": "#696969",
                "grey": "#808080",
                "lightgray": "#d3d3d3",
                "lightslategrey": "#778899",
                "slategrey": "#708090"
            };
            return definedColorNames[colorName]
        }
    };

    function isColorComponent(str) {
        const num = Number.parseInt(str);
        return !Number.isNaN(num) && num >= 0 && num <= 255
    }

    // Support for oauth token based authorization
    // This class supports explicit setting of an oauth token either globally or for specific hosts.
    //
    // The variable oauth.google.access_token, which becomes igv.oauth.google.access_token on ES5 conversion is
    // supported for backward compatibility

    const DEFAULT_HOST = "googleapis";

    class Oauth {

        constructor() {
            this.oauthTokens = {};
        }


        setToken(token, host) {
            host = host || DEFAULT_HOST;
            this.oauthTokens[host] = token;
        }

        getToken(host) {
            host = host || DEFAULT_HOST;
            let token;
            for (let key of Object.keys(this.oauthTokens)) {
                const regex = wildcardToRegExp(key);
                if (regex.test(host)) {
                    token = this.oauthTokens[key];
                    break
                }
            }
            return token
        }

        removeToken(host) {
            host = host || DEFAULT_HOST;
            for (let key of Object.keys(this.oauthTokens)) {
                const regex = wildcardToRegExp(key);
                if (regex.test(host)) {
                    this.oauthTokens[key] = undefined;
                }
            }
        }

        // Special object for google -- legacy support
        // google: {
        //     setToken: function (token) {
        //         oauth.setToken(token);
        //     }
        // }
    }


    /**
     * Creates a RegExp from the given string, converting asterisks to .* expressions,
     * and escaping all other characters.
     *
     * credit https://gist.github.com/donmccurdy/6d073ce2c6f3951312dfa45da14a420f
     */
    function wildcardToRegExp(s) {
        return new RegExp('^' + s.split(/\*+/).map(regExpEscape).join('.*') + '$')
    }

    /**
     * RegExp-escapes all characters in the given string.
     *
     * credit https://gist.github.com/donmccurdy/6d073ce2c6f3951312dfa45da14a420f
     */
    function regExpEscape(s) {
        return s.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
    }

    function isGoogleURL(url) {
        return (url.includes("googleapis") && !url.includes("urlshortener")) ||
            isGoogleStorageURL(url) ||
            isGoogleDriveURL(url)
    }

    function isGoogleStorageURL(url) {
        return url.startsWith("gs://") ||
            url.startsWith("https://www.googleapis.com/storage") ||
            url.startsWith("https://storage.cloud.google.com") ||
            url.startsWith("https://storage.googleapis.com");
    }

    function isGoogleDriveURL(url) {
        return url.indexOf("drive.google.com") >= 0 || url.indexOf("www.googleapis.com/drive") > 0
    }

    /**
     * Translate gs:// urls to https
     * See https://cloud.google.com/storage/docs/json_api/v1
     * @param gsUrl
     * @returns {string|*}
     */
    function translateGoogleCloudURL(gsUrl) {

        let {bucket, object} = parseBucketName(gsUrl);
        object = encode(object);

        const qIdx = gsUrl.indexOf('?');
        const paramString = (qIdx > 0) ? gsUrl.substring(qIdx) + "&alt=media" : "?alt=media";

        return `https://storage.googleapis.com/storage/v1/b/${bucket}/o/${object}${paramString}`
    }

    /**
     * Parse a google bucket and object name from a google storage URL.  Known forms include
     *
     * gs://BUCKET_NAME/OBJECT_NAME
     * https://storage.googleapis.com/BUCKET_NAME/OBJECT_NAME
     * https://storage.googleapis.com/storage/v1/b/BUCKET_NAME/o/OBJECT_NAME
     * https://www.googleapis.com/storage/v1/b/BUCKET_NAME/o/OBJECT_NAME"
     * https://storage.googleapis.com/download/storage/v1/b/BUCKET_NAME/o/OBJECT_NAME
     *
     * @param url
     */
    function parseBucketName(url) {

        let bucket;
        let object;

        if (url.startsWith("gs://")) {
            const i = url.indexOf('/', 5);
            if (i >= 0) {
                bucket = url.substring(5, i);
                const qIdx = url.indexOf('?');
                object = (qIdx < 0) ? url.substring(i + 1) : url.substring(i + 1, qIdx);
            }

        } else if (url.startsWith("https://storage.googleapis.com") || url.startsWith("https://storage.cloud.google.com")) {
            const bucketIdx = url.indexOf("/v1/b/", 8);
            if (bucketIdx > 0) {
                const objIdx = url.indexOf("/o/", bucketIdx);
                if (objIdx > 0) {
                    const queryIdx = url.indexOf("?", objIdx);
                    bucket = url.substring(bucketIdx + 6, objIdx);
                    object = queryIdx > 0 ? url.substring(objIdx + 3, queryIdx) : url.substring(objIdx + 3);
                }

            } else {
                const idx1 = url.indexOf("/", 8);
                const idx2 = url.indexOf("/", idx1+1);
                const idx3 = url.indexOf("?", idx2);
                if (idx2 > 0) {
                    bucket = url.substring(idx1+1, idx2);
                    object = idx3 < 0 ? url.substring(idx2+1) : url.substring(idx2+1, idx3);
                }
            }

        } else if (url.startsWith("https://www.googleapis.com/storage/v1/b")) {
            const bucketIdx = url.indexOf("/v1/b/", 8);
            const objIdx = url.indexOf("/o/", bucketIdx);
            if (objIdx > 0) {
                const queryIdx = url.indexOf("?", objIdx);
                bucket = url.substring(bucketIdx + 6, objIdx);
                object = queryIdx > 0 ? url.substring(objIdx + 3, queryIdx) : url.substring(objIdx + 3);
            }
        }

        if (bucket && object) {
            return {
                bucket, object
            }
        } else {
            throw Error(`Unrecognized Google Storage URI: ${url}`)
        }

    }

    /**
     * Percent a GCS object name.  See https://cloud.google.com/storage/docs/request-endpoints
     * Specific characters to encode:
     *   !, #, $, &, ', (, ), *, +, ,, /, :, ;, =, ?, @, [, ], and space characters.
     * @param obj
     */

    function encode(objectName) {

        let result = '';
        objectName.split('').forEach(function(letter) {
            if(encodings$1.has(letter)) {
                result += encodings$1.get(letter);
            } else {
                result += letter;
            }
        });
        return result;
    }

    //	%23	%24	%25	%26	%27	%28	%29	%2A	%2B	%2C	%2F	%3A	%3B	%3D	%3F	%40	%5B	%5D
    const encodings$1 = new Map();
    encodings$1.set("!", "%21");
    encodings$1.set("#", "%23");
    encodings$1.set("$", "%24");
    encodings$1.set("%", "%25");
    encodings$1.set("&", "%26");
    encodings$1.set("'", "%27");
    encodings$1.set("(", "%28");
    encodings$1.set(")", "%29");
    encodings$1.set("*", "%2A");
    encodings$1.set("+", "%2B");
    encodings$1.set(",", "%2C");
    encodings$1.set("/", "%2F");
    encodings$1.set(":", "%3A");
    encodings$1.set(";", "%3B");
    encodings$1.set("=", "%3D");
    encodings$1.set("?", "%3F");
    encodings$1.set("@", "%40");
    encodings$1.set("[", "%5B");
    encodings$1.set("]", "%5D");
    encodings$1.set(" ", "%20");

    // Convenience functions for the gapi oAuth library.

    async function init$1(config) {

        if (!(google.accounts.oauth2.initTokenClient)) {
            throw new Error("Google accounts token client not loaded (https://accounts.google.com/gsi/client)")
        }

        if (isInitialized()) {
            throw new Error("Google client is already initialized")
        }

        // Note: callback is added when accessToken is requested
        const codeClientConfig = {
            client_id: config.client_id || config.clientId,
            scope: config.scope || 'https://www.googleapis.com/auth/userinfo.profile',
            state: config.state || 'igv',
            error: (err) => {
                throw new Error(err.type)
            },
            hint: config.hint,     // Optional
            hosted_domain: config.hosted_domain  // Optional
        };

        const tokenClient = google.accounts.oauth2.initTokenClient(codeClientConfig);

        // Attach an object to keep igv state
        google.igv = {
            tokenClient: tokenClient,
            apiKey: config.apiKey
        };
    }

    function isInitialized() {
        return window.google && window.google.igv
    }

    /**
     * Return the current access token if the user is signed in, or undefined otherwise.  This function does not
     * attempt a signIn or request any specfic scopes.
     *
     * @returns access_token || undefined
     */
    function getCurrentAccessToken() {
        return (isInitialized() && google.igv.tokenResponse && Date.now() < google.igv.tokenExpiresAt) ?
            google.igv.tokenResponse.access_token :
            undefined
    }


    /**
     * Return a promise for an access token for the given scope.  If the user hasn't authorized the scope request it
     *
     * @param scope
     * @returns {Promise<unknown>}
     */
    async function getAccessToken(scope) {

        if (!isInitialized()) {
            throw Error("Google oAuth has not been initialized")
        }

        if (google.igv.tokenResponse &&
            Date.now() < google.igv.tokenExpiresAt &&
            google.accounts.oauth2.hasGrantedAllScopes(google.igv.tokenResponse, scope)) {
            return google.igv.tokenResponse.access_token
        } else {
            const tokenClient = google.igv.tokenClient;
            return new Promise((resolve, reject) => {
                try {
                    // Settle this promise in the response callback for requestAccessToken()
                    tokenClient.callback = (tokenResponse) => {
                        if (tokenResponse.error !== undefined) {
                            reject(tokenResponse);
                        }
                        google.igv.tokenResponse = tokenResponse;
                        google.igv.tokenExpiresAt = Date.now() + tokenResponse.expires_in * 1000;
                        resolve(tokenResponse.access_token);
                    };
                    tokenClient.requestAccessToken({scope});
                } catch (err) {
                    console.log(err);
                }
            })
        }
    }

    // gapi.auth2.getAuthInstance().isSignedIn.listen(status => {
    //     const user = gapi.auth2.getAuthInstance().currentUser.get()
    //     queryGoogleAuthenticationStatus(user, status)
    // })

    function getScopeForURL(url) {
        if (isGoogleDriveURL(url)) {
            return "https://www.googleapis.com/auth/drive.file"
        } else if (isGoogleStorageURL(url)) {
            return "https://www.googleapis.com/auth/devstorage.read_only"
        } else {
            return 'https://www.googleapis.com/auth/userinfo.profile'
        }
    }

    function getApiKey() {
        return google.igv.apiKey
    }

    /**
     * Return information about a specific google drive URL
     *
     * @param googleDriveURL
     * @returns {Promise<any>}
     */
    async function getDriveFileInfo(googleDriveURL) {

        const id = getGoogleDriveFileID(googleDriveURL);
        let endPoint = "https://www.googleapis.com/drive/v3/files/" + id + "?supportsTeamDrives=true";
        const apiKey = getApiKey();
        if (apiKey) {
            endPoint += "&key=" + apiKey;
        }
        const response = await fetch(endPoint);
        let json = await response.json();
        if (json.error && json.error.code === 404) {
            let scope = "https://www.googleapis.com/auth/drive.readonly";
            const access_token = await getAccessToken(scope);
            if (access_token) {
                const response = await fetch(endPoint, {
                    headers: {
                        'Authorization': `Bearer ${access_token}`
                    }
                });
                json = await response.json();
                if (json.error) {
                    throw Error(json.error);
                }
            } else {
                throw Error(json.error);
            }
        }
        return json;
    }


    function getDriveDownloadURL(link) {
        // Return a google drive download url for the sharable link
        //https://drive.google.com/open?id=0B-lleX9c2pZFbDJ4VVRxakJzVGM
        //https://drive.google.com/file/d/1_FC4kCeO8E3V4dJ1yIW7A0sn1yURKIX-/view?usp=sharing
        var id = getGoogleDriveFileID(link);
        return id ? "https://www.googleapis.com/drive/v3/files/" + id + "?alt=media&supportsTeamDrives=true" : link;
    }

    function getGoogleDriveFileID(link) {

        //https://drive.google.com/file/d/1_FC4kCeO8E3V4dJ1yIW7A0sn1yURKIX-/view?usp=sharing
        //https://www.googleapis.com/drive/v3/files/1w-tvo6p1SH4p1OaQSVxpkV_EJgGIstWF?alt=media&supportsTeamDrives=true"

        if (link.includes("/open?id=")) {
            const i1 = link.indexOf("/open?id=") + 9;
            const i2 = link.indexOf("&");
            if (i1 > 0 && i2 > i1) {
                return link.substring(i1, i2)
            } else if (i1 > 0) {
                return link.substring(i1);
            }

        } else if (link.includes("/file/d/")) {
            const i1 = link.indexOf("/file/d/") + 8;
            const i2 = link.lastIndexOf("/");
            return link.substring(i1, i2);

        } else if (link.startsWith("https://www.googleapis.com/drive")) {
            let i1 = link.indexOf("/files/");
            const i2 = link.indexOf("?");
            if (i1 > 0) {
                i1 += 7;
                return i2 > 0 ?
                    link.substring(i1, i2) :
                    link.substring(i1)
            }
        }

        throw Error("Unknown Google Drive url format: " + link);


    }

    // The MIT License (MIT)

    /**
     * @constructor
     * @param {Object} options A set op options to pass to the throttle function
     *        @param {number} requestsPerSecond The amount of requests per second
     *                                          the library will limit to
     */
    class Throttle {
        constructor(options) {
            this.requestsPerSecond = options.requestsPerSecond || 10;
            this.lastStartTime = 0;
            this.queued = [];
        }

        /**
         * Adds a promise
         * @param {Function} async function to be executed
         * @param {Object} options A set of options.
         * @return {Promise} A promise
         */
        add(asyncFunction, options) {

            var self = this;
            return new Promise(function (resolve, reject) {
                self.queued.push({
                    resolve: resolve,
                    reject: reject,
                    asyncFunction: asyncFunction,
                });
                self.dequeue();
            });
        }

        /**
         * Adds all the promises passed as parameters
         * @param {Function} promises An array of functions that return a promise
         * @param {Object} options A set of options.
         * @param {number} options.signal An AbortSignal object that can be used to abort the returned promise
         * @param {number} options.weight A "weight" of each operation resolving by array of promises
         * @return {Promise} A promise that succeeds when all the promises passed as options do
         */
        addAll(promises, options) {
            var addedPromises = promises.map(function (promise) {
                return this.add(promise, options);
            }.bind(this));

            return Promise.all(addedPromises);
        };

        /**
         * Dequeues a promise
         * @return {void}
         */
        dequeue() {
            if (this.queued.length > 0) {
                var now = new Date(),
                    inc = (1000 / this.requestsPerSecond) + 1,
                    elapsed = now - this.lastStartTime;

                if (elapsed >= inc) {
                    this._execute();
                } else {
                    // we have reached the limit, schedule a dequeue operation
                    setTimeout(function () {
                        this.dequeue();
                    }.bind(this), inc - elapsed);
                }
            }
        }

        /**
         * Executes the promise
         * @private
         * @return {void}
         */
        async _execute() {
            this.lastStartTime = new Date();
            var candidate = this.queued.shift();
            const f = candidate.asyncFunction;
            try {
                const r = await f();
                candidate.resolve(r);
            } catch (e) {
                candidate.reject(e);
            }

        }


    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class IGVXhr {

        constructor() {
            this.apiKey = undefined;
            this.googleThrottle = new Throttle({
                requestsPerSecond: 8
            });
            this.RANGE_WARNING_GIVEN = false;
            this.oauth = new Oauth();
        }

        setApiKey(key) {
            this.apiKey = key;
        }

        async loadArrayBuffer(url, options) {
            options = options || {};
            if (!options.responseType) {
                options.responseType = "arraybuffer";
            }
            if (isFile(url)) {
                return this._loadFileSlice(url, options)
            } else {
                return this.load(url, options)
            }
        }

        /**
         * A wrapper around loadArrayBuffer that inflates gzipped data
         * @param url
         * @param options
         * @returns {Promise<Uint8Array>}
         */
         async loadByteArray(url, options) {
            const arraybuffer = await this.loadArrayBuffer(url, options);
            let plain;
            if (isgzipped(arraybuffer)) {
                plain = ungzip_blocks(arraybuffer);
            } else {
                plain = new Uint8Array(arraybuffer);
            }
            return plain
        }


        async loadJson(url, options) {
            options = options || {};
            const method = options.method || (options.sendData ? "POST" : "GET");
            if (method === "POST") {
                options.contentType = "application/json";
            }
            const result = await this.loadString(url, options);
            if (result) {
                return JSON.parse(result)
            } else {
                return result
            }
        }

        async loadString(path, options) {
            options = options || {};
            if (path instanceof File) {
                return this._loadStringFromFile(path, options)
            } else {
                return this._loadStringFromUrl(path, options)
            }
        }

        async load(url, options) {

            options = options || {};
            const urlType = typeof url;

            // Resolve functions, promises, and functions that return promises
            url = await (typeof url === 'function' ? url() : url);

            if (isFile(url)) {
                return this._loadFileSlice(url, options)
            } else if (typeof url.startsWith === 'function') {   // Test for string
                if (url.startsWith("data:")) {
                    const buffer = decodeDataURI$1(url).buffer;
                    if (options.range) {
                        const rangeEnd = options.range.size ? options.range.start + options.range.size : buffer.byteLength;
                        return buffer.slice(options.range.start, rangeEnd)
                    } else {
                        return buffer
                    }
                } else {
                    if (url.startsWith("https://drive.google.com")) {
                        url = getDriveDownloadURL(url);
                    }
                    if (isGoogleDriveURL(url) || url.startsWith("https://www.dropbox.com")) {
                        return this.googleThrottle.add(async () => {
                            return this._loadURL(url, options)
                        })
                    } else {
                        return this._loadURL(url, options)
                    }
                }
            } else {
                throw Error(`url must be either a 'File', 'string', 'function', or 'Promise'.  Actual type: ${urlType}`)
            }
        }

        async _loadURL(url, options) {

            const self = this;
            const _url = url;   // The unmodified URL, needed in case of an oAuth retry

            url = mapUrl$1(url);

            options = options || {};

            let oauthToken = options.oauthToken || this.getOauthToken(url);
            if (oauthToken) {
                oauthToken = await (typeof oauthToken === 'function' ? oauthToken() : oauthToken);
            }

            return new Promise(function (resolve, reject) {

                // Various Google tansformations
                if (isGoogleURL(url) && !isGoogleStorageSigned(url)) {
                    if (isGoogleStorageURL(url)) {
                        url = translateGoogleCloudURL(url);
                    }
                    url = addApiKey(url);

                    if (isGoogleDriveURL(url)) {
                        addTeamDrive(url);
                    }

                    // If we have an access token try it, but don't force a signIn or request for scopes yet
                    if (!oauthToken) {
                        oauthToken = getCurrentGoogleAccessToken();
                    }
                }

                const headers = options.headers || {};
                if (oauthToken) {
                    addOauthHeaders(headers, oauthToken);
                }
                const range = options.range;


                const xhr = new XMLHttpRequest();
                const sendData = options.sendData || options.body;
                const method = options.method || (sendData ? "POST" : "GET");
                const responseType = options.responseType;
                const contentType = options.contentType;
                const mimeType = options.mimeType;

                xhr.open(method, url);

                if (options.timeout) {
                    xhr.timeout = options.timeout;
                }

                if (range) {
                    let rangeEnd = "";
                    if (range.size) {
                        rangeEnd = range.start + range.size - 1;
                    }
                    xhr.setRequestHeader("Range", "bytes=" + range.start + "-" + rangeEnd);
                    //      xhr.setRequestHeader("Cache-Control", "no-cache");    <= This can cause CORS issues, disabled for now
                }
                if (contentType) {
                    xhr.setRequestHeader("Content-Type", contentType);
                }
                if (mimeType) {
                    xhr.overrideMimeType(mimeType);
                }
                if (responseType) {
                    xhr.responseType = responseType;
                }
                if (headers) {
                    for (let key of Object.keys(headers)) {
                        const value = headers[key];
                        xhr.setRequestHeader(key, value);
                    }
                }

                // NOTE: using withCredentials with servers that return "*" for access-allowed-origin will fail
                if (options.withCredentials === true) {
                    xhr.withCredentials = true;
                }

                xhr.onload = async function (event) {

                    // when the url points to a local file, the status is 0
                    if (xhr.status === 0 || (xhr.status >= 200 && xhr.status <= 300)) {
                        if ("HEAD" === options.method) {
                            // Support fetching specific headers.  Attempting to fetch all headers can be problematic with CORS
                            const headers = options.requestedHeaders || ['content-length'];
                            const headerMap = {};
                            for (let h of headers) {
                                headerMap[h] = xhr.getResponseHeader(h);
                            }
                            resolve(headerMap);
                        } else {
                            // Assume "GET" or "POST"
                            if (range && xhr.status !== 206 && range.start !== 0) {

                                // For small files a range starting at 0 can return the whole file => 200
                                // Provide just the slice we asked for, throw out the rest quietly
                                // If file is large warn user
                                if (xhr.response.length > 100000 && !self.RANGE_WARNING_GIVEN) {
                                    alert(`Warning: Range header ignored for URL: ${url}.  This can have severe performance impacts.`);
                                }
                                resolve(xhr.response.slice(range.start, range.start + range.size));
                            } else {
                                resolve(xhr.response);
                            }
                        }
                    } else if (xhr.status === 416) {
                        handleError(Error(`416 Unsatisfiable Range`));
                    } else if (isInitialized() &&
                        ((xhr.status === 404 || xhr.status === 401 || xhr.status === 403) &&
                            isGoogleURL(url)) &&
                        !options.retries) {
                        tryGoogleAuth();

                    } else {
                        if (xhr.status === 403) {
                            handleError("Access forbidden: " + url);
                        } else {
                            handleError(xhr.status);
                        }
                    }
                };


                xhr.onerror = function (event) {
                    if (isGoogleURL(url) && !options.retries) {
                        tryGoogleAuth();
                    } else {
                        handleError("Error accessing resource: " + url + " Status: " + xhr.status);
                    }
                };

                xhr.ontimeout = function (event) {
                    handleError("Timed out");
                };

                xhr.onabort = function (event) {
                    console.log("Aborted");
                    reject(event);
                };

                try {
                    xhr.send(sendData);
                } catch (e) {
                    if (isGoogleURL(url) && !options.retries) {
                        tryGoogleAuth();
                    } else {
                        handleError(e);
                    }
                }


                function handleError(error) {
                    if (reject) {
                        reject(error);
                    } else {
                        throw error
                    }
                }

                async function tryGoogleAuth() {
                    try {
                        const accessToken = await fetchGoogleAccessToken(_url);
                        options.retries = 1;
                        options.oauthToken = accessToken;
                        const response = await self.load(_url, options);
                        resolve(response);
                    } catch (e) {
                        if (e.error) {
                            const msg = e.error.startsWith("popup_blocked") ?
                                "Google login popup blocked by browser." :
                                e.error;
                            alert(msg);
                        } else {
                            handleError(e);
                        }
                    }
                }
            })

        }

        async _loadFileSlice(localfile, options) {

            let blob = (options && options.range) ?
                localfile.slice(options.range.start, options.range.start + options.range.size) :
                localfile;

            const arrayBuffer = await blob.arrayBuffer();

            if ("arraybuffer" === options.responseType) {
                return arrayBuffer
            } else {
                return arrayBufferToString(arrayBuffer)
            }
        }

        async _loadStringFromFile(localfile, options) {

            const blob = options.range ? localfile.slice(options.range.start, options.range.start + options.range.size) : localfile;
            const arrayBuffer = await blob.arrayBuffer();
            return arrayBufferToString(arrayBuffer)
        }

        async _loadStringFromUrl(url, options) {

            options = options || {};
            options.responseType = "arraybuffer";
            const data = await this.load(url, options);
            return arrayBufferToString(data)
        }

        /**
         * Explicity set an oAuth token for use with given host.  If host is undefined token is used for google api access*
         * @param token
         * @param host
         */
        setOauthToken(token, host) {
            this.oauth.setToken(token, host);
        }

        /**
         * Return an oauth token for the URL if we have one.  This method does not force sign-in, and the token may
         * or may not be valid.  Sign-in is triggered on request failure.
         * *
         * @param url
         * @returns {*}
         */
        getOauthToken(url) {

            // Google is the default provider, don't try to parse host for google URLs
            const host = isGoogleURL(url) ?
                undefined :
                parseUri(url).host;

            // First check the explicit settings (i.e. token set through the API)
            let token = this.oauth.getToken(host);
            if (token) {
                return token
            } else if (host === undefined) {
                // Now try Google oauth tokens previously obtained.  This will return undefined if google oauth is not
                // configured.
                const googleToken = getCurrentGoogleAccessToken();
                if (googleToken && googleToken.expires_at > Date.now()) {
                    return googleToken.access_token
                }
            }
        }

        /**
         * This method should only be called when it is known the server supports HEAD requests.  It is used to recover
         * from 416 errors from out-of-spec WRT range request servers.  Notably Globus.
         * * *
         * @param url
         * @param options
         * @returns {Promise<unknown>}
         */
        async getContentLength(url, options) {
            options = options || {};
            options.method = 'HEAD';
            options.requestedHeaders = ['content-length'];
            const headerMap = await this._loadURL(url, options);
            const contentLengthString = headerMap['content-length'];
            return contentLengthString ? Number.parseInt(contentLengthString) : 0
        }

    }

    function isGoogleStorageSigned(url) {
        return url.indexOf("X-Goog-Signature") > -1
    }


    /**
     * Return a Google oAuth token, triggering a sign in if required.   This method should not be called until we know
     * a token is required, that is until we've tried the url and received a 401, 403, or 404.
     *
     * @param url
     * @returns the oauth token
     */
    async function fetchGoogleAccessToken(url) {
        if (isInitialized()) {
            const scope = getScopeForURL(url);
            const access_token = await getAccessToken(scope);
            return access_token
        } else {
            throw Error(
                `Authorization is required, but Google oAuth has not been initalized. Contact your site administrator for assistance.`)
        }
    }

    /**
     * Return the current google access token, if one exists.  Do not triger signOn or request additional scopes.
     * @returns {undefined|access_token}
     */
    function getCurrentGoogleAccessToken() {
        if (isInitialized()) {
            const access_token = getCurrentAccessToken();
            return access_token
        } else {
            return undefined
        }
    }

    function addOauthHeaders(headers, acToken) {
        if (acToken) {
            headers["Cache-Control"] = "no-cache";
            headers["Authorization"] = "Bearer " + acToken;
        }
        return headers
    }


    function addApiKey(url) {
        let apiKey = igvxhr.apiKey;
        if (!apiKey && typeof gapi !== "undefined") {
            apiKey = gapi.apiKey;
        }
        if (apiKey !== undefined && !url.includes("key=")) {
            const paramSeparator = url.includes("?") ? "&" : "?";
            url = url + paramSeparator + "key=" + apiKey;
        }
        return url
    }

    function addTeamDrive(url) {
        if (url.includes("supportsTeamDrive")) {
            return url
        } else {
            const paramSeparator = url.includes("?") ? "&" : "?";
            url = url + paramSeparator + "supportsTeamDrive=true";
        }
    }

    /**
     * Perform some well-known url mappings.
     * @param url
     */
    function mapUrl$1(url) {

        if (url.startsWith("https://www.dropbox.com")) {
            return url.replace("//www.dropbox.com", "//dl.dropboxusercontent.com")
        } else if (url.startsWith("https://drive.google.com")) {
            return getDriveDownloadURL(url)
        } else if (url.includes("//www.broadinstitute.org/igvdata")) {
            return url.replace("//www.broadinstitute.org/igvdata", "//data.broadinstitute.org/igvdata")
        } else if (url.includes("//igvdata.broadinstitute.org")) {
            return url.replace("//igvdata.broadinstitute.org", "//s3.amazonaws.com/igv.broadinstitute.org")
        } else if (url.includes("//igv.genepattern.org")) {
            return url.replace("//igv.genepattern.org", "//igv-genepattern-org.s3.amazonaws.com")
        } else if (url.startsWith("ftp://ftp.ncbi.nlm.nih.gov/geo")) {
            return url.replace("ftp://", "https://")
        } else {
            return url
        }
    }


    function arrayBufferToString(arraybuffer) {

        let plain;
        if (isgzipped(arraybuffer)) {
            plain = ungzip_blocks(arraybuffer);
        } else {
            plain = new Uint8Array(arraybuffer);
        }

        if ('TextDecoder' in getGlobalObject()) {
            return new TextDecoder().decode(plain)
        } else {
            return decodeUTF8(plain)
        }
    }

    /**
     * Use when TextDecoder is not available (primarily IE).
     *
     * From: https://gist.github.com/Yaffle/5458286
     *
     * @param octets
     * @returns {string}
     */
    function decodeUTF8(octets) {
        var string = "";
        var i = 0;
        while (i < octets.length) {
            var octet = octets[i];
            var bytesNeeded = 0;
            var codePoint = 0;
            if (octet <= 0x7F) {
                bytesNeeded = 0;
                codePoint = octet & 0xFF;
            } else if (octet <= 0xDF) {
                bytesNeeded = 1;
                codePoint = octet & 0x1F;
            } else if (octet <= 0xEF) {
                bytesNeeded = 2;
                codePoint = octet & 0x0F;
            } else if (octet <= 0xF4) {
                bytesNeeded = 3;
                codePoint = octet & 0x07;
            }
            if (octets.length - i - bytesNeeded > 0) {
                var k = 0;
                while (k < bytesNeeded) {
                    octet = octets[i + k + 1];
                    codePoint = (codePoint << 6) | (octet & 0x3F);
                    k += 1;
                }
            } else {
                codePoint = 0xFFFD;
                bytesNeeded = octets.length - i;
            }
            string += String.fromCodePoint(codePoint);
            i += bytesNeeded + 1;
        }
        return string
    }


    function getGlobalObject() {
        if (typeof self !== 'undefined') {
            return self
        }
        if (typeof global !== 'undefined') {
            return global
        } else {
            return window
        }
    }


    const igvxhr = new IGVXhr();

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    /** An implementation of an interval tree, following the explanation.
     * from CLR.
     *
     * Public interface:
     *   Constructor  IntervalTree
     *   Insertion    insert
     *   Search       findOverlapping
     */

    var BLACK = 1;
    var RED = 2;

    var NIL = {};
    NIL.color = BLACK;
    NIL.parent = NIL;
    NIL.left = NIL;
    NIL.right = NIL;


    class IntervalTree {

        constructor() {
            this.root = NIL;
        }

        insert(start, end, value) {

            var interval = new Interval(start, end, value);
            var x = new Node(interval);
            this.treeInsert(x);
            x.color = RED;
            while (x !== this.root && x.parent.color === RED) {
                if (x.parent === x.parent.parent.left) {
                    let y = x.parent.parent.right;
                    if (y.color === RED) {
                        x.parent.color = BLACK;
                        y.color = BLACK;
                        x.parent.parent.color = RED;
                        x = x.parent.parent;
                    } else {
                        if (x === x.parent.right) {
                            x = x.parent;
                            leftRotate.call(this, x);
                        }
                        x.parent.color = BLACK;
                        x.parent.parent.color = RED;
                        rightRotate.call(this, x.parent.parent);
                    }
                } else {
                    let y = x.parent.parent.left;
                    if (y.color === RED) {
                        x.parent.color = BLACK;
                        y.color = BLACK;
                        x.parent.parent.color = RED;
                        x = x.parent.parent;
                    } else {
                        if (x === x.parent.left) {
                            x = x.parent;
                            rightRotate.call(this, x);
                        }
                        x.parent.color = BLACK;
                        x.parent.parent.color = RED;
                        leftRotate.call(this, x.parent.parent);
                    }
                }
            }
            this.root.color = BLACK;
        }

        /**
         *
         * @param start - query interval
         * @param end - query interval
         * @returns Array of all intervals overlapping the query region
         */
        findOverlapping(start, end) {


            var searchInterval = new Interval(start, end, 0);

            if (this.root === NIL) return [];

            var intervals = searchAll.call(this, searchInterval, this.root, []);

            if (intervals.length > 1) {
                intervals.sort(function (i1, i2) {
                    return i1.low - i2.low;
                });
            }

            return intervals;
        }

        /**
         * Dump info on intervals to console.  For debugging.
         */
        logIntervals() {

            logNode(this.root, 0);

            function logNode(node, indent) {

                var space = "";
                for (var i = 0; i < indent; i++) space += " ";
                console.log(space + node.interval.low + " " + node.interval.high); // + " " + (node.interval.value ? node.interval.value : " null"));

                indent += 5;

                if (node.left !== NIL) logNode(node.left, indent);
                if (node.right !== NIL) logNode(node.right, indent);
            }

        }

        mapIntervals(func) {

            applyInterval(this.root);

            function applyInterval(node) {

                func(node.interval);

                if (node.left !== NIL) applyInterval(node.left);
                if (node.right !== NIL) applyInterval(node.right);
            }
        }


        /**
         * Note:  Does not maintain RB constraints,  this is done post insert
         *
         * @param x  a Node
         */
        treeInsert(x) {
            var node = this.root;
            var y = NIL;
            while (node !== NIL) {
                y = node;
                if (x.interval.low <= node.interval.low) {
                    node = node.left;
                } else {
                    node = node.right;
                }
            }
            x.parent = y;

            if (y === NIL) {
                this.root = x;
                x.left = x.right = NIL;
            } else {
                if (x.interval.low <= y.interval.low) {
                    y.left = x;
                } else {
                    y.right = x;
                }
            }

            applyUpdate.call(this, x);
        }
    }

    function searchAll(interval, node, results) {

        if (node.interval.overlaps(interval)) {
            results.push(node.interval);
        }

        if (node.left !== NIL && node.left.max >= interval.low) {
            searchAll.call(this, interval, node.left, results);
        }

        if (node.right !== NIL && node.right.min <= interval.high) {
            searchAll.call(this, interval, node.right, results);
        }

        return results;
    }

    function leftRotate(x) {
        var y = x.right;
        x.right = y.left;
        if (y.left !== NIL) {
            y.left.parent = x;
        }
        y.parent = x.parent;
        if (x.parent === NIL) {
            this.root = y;
        } else {
            if (x.parent.left === x) {
                x.parent.left = y;
            } else {
                x.parent.right = y;
            }
        }
        y.left = x;
        x.parent = y;

        applyUpdate.call(this, x);
        // no need to apply update on y, since it'll y is an ancestor
        // of x, and will be touched by applyUpdate().
    }


    function rightRotate(x) {
        var y = x.left;
        x.left = y.right;
        if (y.right !== NIL) {
            y.right.parent = x;
        }
        y.parent = x.parent;
        if (x.parent === NIL) {
            this.root = y;
        } else {
            if (x.parent.right === x) {
                x.parent.right = y;
            } else {
                x.parent.left = y;
            }
        }
        y.right = x;
        x.parent = y;


        applyUpdate.call(this, x);
        // no need to apply update on y, since it'll y is an ancestor
        // of x, and will be touched by applyUpdate().
    }


    // Applies the statistic update on the node and its ancestors.
    function applyUpdate(node) {
        while (node !== NIL) {
            var nodeMax = node.left.max > node.right.max ? node.left.max : node.right.max;
            var intervalHigh = node.interval.high;
            node.max = nodeMax > intervalHigh ? nodeMax : intervalHigh;

            var nodeMin = node.left.min < node.right.min ? node.left.min : node.right.min;
            var intervalLow = node.interval.low;
            node.min = nodeMin < intervalLow ? nodeMin : intervalLow;

            node = node.parent;
        }
    }


    class Interval {
        constructor(low, high, value) {
            this.low = low;
            this.high = high;
            this.value = value;
        }

        equals(other) {
            if (!other) {
                return false;
            }
            if (this === other) {
                return true;
            }
            return (this.low === other.low &&
                this.high === other.high);

        }

        compareTo(other) {
            if (this.low < other.low)
                return -1;
            if (this.low > other.low)
                return 1;

            if (this.high < other.high)
                return -1;
            if (this.high > other.high)
                return 1;

            return 0;
        }

        /**
         * Returns true if this interval overlaps the other.
         */
        overlaps(other) {
                return (this.low <= other.high && other.low <= this.high);
        }
    }

    function Node(interval) {
        this.parent = NIL;
        this.left = NIL;
        this.right = NIL;
        this.interval = interval;
        this.color = RED;
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    /**
     * Object for caching lists of features.  Supports effecient queries for sub-range  (chr, start, end)
     *
     * @param featureList
     * @param The genomic range spanned by featureList (optional)
     * @constructor
     */

    class FeatureCache$1 {

        constructor(featureList, genome, range) {

            featureList = featureList || [];
            this.treeMap = this.buildTreeMap(featureList, genome);
            this.range = range;
            this.count = featureList.length;
        }

        containsRange(genomicRange) {
            // No range means cache contains all features
            return (this.range === undefined || this.range.contains(genomicRange.chr, genomicRange.start, genomicRange.end));
        }

        queryFeatures(chr, start, end) {

            const tree = this.treeMap[chr];

            if (!tree) return [];

            const intervals = tree.findOverlapping(start, end);

            if (intervals.length === 0) {
                return [];
            } else {
                // Trim the list of features in the intervals to those
                // overlapping the requested range.
                // Assumption: features are sorted by start position

                const featureList = [];
                const all = this.allFeatures[chr];
                if (all) {
                    for (let interval of intervals) {
                        const indexRange = interval.value;
                        for (let i = indexRange.start; i < indexRange.end; i++) {
                            let feature = all[i];
                            if (feature.start > end) break;
                            else if (feature.end >= start) {
                                featureList.push(feature);
                            }
                        }
                    }
                    featureList.sort(function (a, b) {
                        return a.start - b.start;
                    });
                }
                return featureList;
            }
        };

        /**
         * Returns all features, unsorted.
         *
         * @returns {Array}
         */
        getAllFeatures() {
            return this.allFeatures;
        }

        buildTreeMap(featureList, genome) {

            const treeMap = {};
            const chromosomes = [];
            this.allFeatures = {};

            if (featureList) {
                for (let feature of featureList) {

                    let chr = feature.chr;
                    // Translate to "official" name
                    if (genome) {
                        chr = genome.getChromosomeName(chr);
                    }

                    let geneList = this.allFeatures[chr];
                    if (!geneList) {
                        chromosomes.push(chr);
                        geneList = [];
                        this.allFeatures[chr] = geneList;
                    }
                    geneList.push(feature);
                }


                // Now build interval tree for each chromosome
                for (let chr of chromosomes) {
                    const chrFeatures = this.allFeatures[chr];
                    chrFeatures.sort(function (f1, f2) {
                        return (f1.start === f2.start ? 0 : (f1.start > f2.start ? 1 : -1));
                    });
                    treeMap[chr] = buildIntervalTree$1(chrFeatures);
                }
            }

            return treeMap;
        }
    }

    /**
     * Build an interval tree from the feature list for fast interval based queries.   We lump features in groups
     * of 10, or total size / 100,   to reduce size of the tree.
     *
     * @param featureList
     */
    function buildIntervalTree$1(featureList) {

        const tree = new IntervalTree();
        const len = featureList.length;
        const chunkSize = Math.max(10, Math.round(len / 10));

        for (let i = 0; i < len; i += chunkSize) {
            const e = Math.min(len, i + chunkSize);
            const subArray = new IndexRange(i, e); //featureList.slice(i, e);
            const iStart = featureList[i].start;
            //
            let iEnd = iStart;
            for (let j = i; j < e; j++) {
                iEnd = Math.max(iEnd, featureList[j].end);
            }
            tree.insert(iStart, iEnd, subArray);
        }

        return tree;
    }


    class IndexRange {
        constructor(start, end) {
            this.start = start;
            this.end = end;
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const FeatureUtils = {

        packFeatures: function (features, maxRows, sorted) {

            var start;
            var end;

            if (!features) return;

            maxRows = maxRows || 10000;

            if (!sorted) {
                features.sort(function (a, b) {
                    return a.start - b.start;
                });
            }


            if (features.length === 0) {
                return [];

            } else {

                var bucketList = [],
                    allocatedCount = 0,
                    lastAllocatedCount = 0,
                    nextStart,
                    row,
                    index,
                    bucket,
                    feature,
                    gap = 2,
                    bucketStart;

                start = features[0].start;
                end = features[features.length - 1].start;

                bucketStart = Math.max(start, features[0].start);
                nextStart = bucketStart;

                features.forEach(function (alignment) {

                    var buckListIndex = Math.max(0, alignment.start - bucketStart);
                    if (bucketList[buckListIndex] === undefined) {
                        bucketList[buckListIndex] = [];
                    }
                    bucketList[buckListIndex].push(alignment);
                });


                row = 0;


                while (allocatedCount < features.length && row <= maxRows) {


                    while (nextStart <= end) {

                        bucket = undefined;

                        while (!bucket && nextStart <= end) {

                            index = nextStart - bucketStart;
                            if (bucketList[index] === undefined) {
                                ++nextStart;                     // No buckets at this index
                            } else {
                                bucket = bucketList[index];
                            }

                        } // while (bucket)

                        if (!bucket) {
                            break;
                        }
                        feature = bucket.pop();
                        if (0 === bucket.length) {
                            bucketList[index] = undefined;
                        }

                        feature.row = row;

                        nextStart = feature.end + gap;
                        ++allocatedCount;

                    } // while (nextStart)

                    row++;
                    nextStart = bucketStart;

                    if (allocatedCount === lastAllocatedCount) break;   // Protect from infinite loops

                    lastAllocatedCount = allocatedCount;

                } // while (allocatedCount)

            }
        },


        /**
         * Find features overlapping the given interval.  It is assumed that all features share the same chromosome.
         *
         * TODO -- significant overlap with FeatureCache, refactor to combine
         *
         * @param featureList
         * @param start
         * @param end
         */
        findOverlapping: function (featureList, start, end) {

            if (!featureList || featureList.length === 0) {
                return [];
            } else {
                const tree = buildIntervalTree(featureList);
                const intervals = tree.findOverlapping(start, end);

                if (intervals.length === 0) {
                    return [];
                } else {
                    // Trim the list of features in the intervals to those
                    // overlapping the requested range.
                    // Assumption: features are sorted by start position

                    featureList = [];

                    intervals.forEach(function (interval) {
                        const intervalFeatures = interval.value;
                        const len = intervalFeatures.length;
                        for (let i = 0; i < len; i++) {
                            const feature = intervalFeatures[i];
                            if (feature.start > end) break;
                            else if (feature.end > start) {
                                featureList.push(feature);
                            }
                        }
                    });

                    featureList.sort(function (a, b) {
                        return a.start - b.start;
                    });

                    return featureList;
                }
            }

        }
    };


    /**
     * Build an interval tree from the feature list for fast interval based queries.   We lump features in groups
     * of 10, or total size / 100,   to reduce size of the tree.
     *
     * @param featureList
     */
    function buildIntervalTree(featureList) {

        const tree = new IntervalTree();
        const len = featureList.length;
        const chunkSize = Math.max(10, Math.round(len / 100));

        featureList.sort(function (f1, f2) {
            return (f1.start === f2.start ? 0 : (f1.start > f2.start ? 1 : -1));
        });

        for (let i = 0; i < len; i += chunkSize) {
            const e = Math.min(len, i + chunkSize);
            const subArray = featureList.slice(i, e);
            const iStart = subArray[0].start;
            let iEnd = iStart;
            subArray.forEach(function (feature) {
                iEnd = Math.max(iEnd, feature.end);
            });
            tree.insert(iStart, iEnd, subArray);
        }

        return tree;
    }

    const appleCrayonRGBPalette =
        {
            cantaloupe: {r: 255, g: 206, b: 110},
            honeydew: {r: 206, g: 250, b: 110},
            spindrift: {r: 104, g: 251, b: 208},
            sky: {r: 106, g: 207, b: 255},
            lavender: {r: 210, g: 120, b: 255},
            carnation: {r: 255, g: 127, b: 211},
            licorice: {r: 0, g: 0, b: 0},
            snow: {r: 255, g: 255, b: 255},
            salmon: {r: 255, g: 114, b: 110},
            banana: {r: 255, g: 251, b: 109},
            flora: {r: 104, g: 249, b: 110},
            ice: {r: 104, g: 253, b: 255},
            orchid: {r: 110, g: 118, b: 255},
            bubblegum: {r: 255, g: 122, b: 255},
            lead: {r: 30, g: 30, b: 30},
            mercury: {r: 232, g: 232, b: 232},
            tangerine: {r: 255, g: 136, b: 2},
            lime: {r: 131, g: 249, b: 2},
            sea_foam: {r: 3, g: 249, b: 135},
            aqua: {r: 0, g: 140, b: 255},
            grape: {r: 137, g: 49, b: 255},
            strawberry: {r: 255, g: 41, b: 135},
            tungsten: {r: 58, g: 58, b: 58},
            silver: {r: 208, g: 208, b: 208},
            maraschino: {r: 255, g: 33, b: 1},
            lemon: {r: 255, g: 250, b: 3},
            spring: {r: 5, g: 248, b: 2},
            turquoise: {r: 0, g: 253, b: 255},
            blueberry: {r: 0, g: 46, b: 255},
            magenta: {r: 255, g: 57, b: 255},
            iron: {r: 84, g: 84, b: 83},
            magnesium: {r: 184, g: 184, b: 184},
            mocha: {r: 137, g: 72, b: 0},
            fern: {r: 69, g: 132, b: 1},
            moss: {r: 1, g: 132, b: 72},
            ocean: {r: 0, g: 74, b: 136},
            eggplant: {r: 73, g: 26, b: 136},
            maroon: {r: 137, g: 22, b: 72},
            steel: {r: 110, g: 110, b: 110},
            aluminum: {r: 160, g: 159, b: 160},
            cayenne: {r: 137, g: 17, b: 0},
            aspargus: {r: 136, g: 133, b: 1},
            clover: {r: 2, g: 132, b: 1},
            teal: {r: 0, g: 134, b: 136},
            midnight: {r: 0, g: 24, b: 136},
            plum: {r: 137, g: 30, b: 136},
            tin: {r: 135, g: 134, b: 135},
            nickel: {r: 136, g: 135, b: 135}
        };

    function appleCrayonRGB(name) {
        const {r, g, b} = appleCrayonRGBPalette[name];
        return `rgb(${r},${g},${b})`
    }

    function appleCrayonRGBA(name, alpha) {
        const {r, g, b} = appleCrayonRGBPalette[name];
        return `rgba(${r},${g},${b},${alpha})`
    }

    const colorPalettes = {

        Set1:
            [
                "rgb(228,26,28)",
                "rgb(55,126,184)",
                "rgb(77,175,74)",
                "rgb(166,86,40)",
                "rgb(152,78,163)",
                "rgb(255,127,0)",
                "rgb(247,129,191)",
                "rgb(153,153,153)",
                "rgb(255,255,51)"
            ],

        Dark2:
            [
                "rgb(27,158,119)",
                "rgb(217,95,2)",
                "rgb(117,112,179)",
                "rgb(231,41,138)",
                "rgb(102,166,30)",
                "rgb(230,171,2)",
                "rgb(166,118,29)",
                "rgb(102,102,102)"
            ],

        Set2:
            [
                "rgb(102, 194,165)",
                "rgb(252,141,98)",
                "rgb(141,160,203)",
                "rgb(231,138,195)",
                "rgb(166,216,84)",
                "rgb(255,217,47)",
                "rgb(229,196,148)",
                "rgb(179,179,179)"
            ],

        Set3:
            [
                "rgb(141,211,199)",
                "rgb(255,255,179)",
                "rgb(190,186,218)",
                "rgb(251,128,114)",
                "rgb(128,177,211)",
                "rgb(253,180,98)",
                "rgb(179,222,105)",
                "rgb(252,205,229)",
                "rgb(217,217,217)",
                "rgb(188,128,189)",
                "rgb(204,235,197)",
                "rgb(255,237,111)"
            ],

        Pastel1:
            [
                "rgb(251,180,174)",
                "rgb(179,205,227)",
                "rgb(204,235,197)",
                "rgb(222,203,228)",
                "rgb(254,217,166)",
                "rgb(255,255,204)",
                "rgb(229,216,189)",
                "rgb(253,218,236)"
            ],

        Pastel2:
            [
                "rgb(173,226,207)",
                "rgb(253,205,172)",
                "rgb(203,213,232)",
                "rgb(244,202,228)",
                "rgb(230,245,201)",
                "rgb(255,242,174)",
                "rgb(243,225,206)"
            ],

        Accent:
            [
                "rgb(127,201,127)",
                "rgb(190,174,212)",
                "rgb(253,192,134)",
                "rgb(255,255,153)",
                "rgb(56,108,176)",
                "rgb(240,2,127)",
                "rgb(191,91,23)"
            ]
    };

    class PaletteColorTable {

        constructor(palette) {
            this.colors = colorPalettes[palette];
            if (!Array.isArray(this.colors)) this.colors = [];
            this.colorTable = {};
            this.nextIdx = 0;
            this.colorGenerator = new RandomColorGenerator();
        }

        getColor(key) {
            if (!this.colorTable.hasOwnProperty(key)) {
                if (this.nextIdx < this.colors.length) {
                    this.colorTable[key] = this.colors[this.nextIdx];
                } else {
                    this.colorTable[key] = this.colorGenerator.get();
                }
                this.nextIdx++;
            }
            return this.colorTable[key]
        }
    }

    class ColorTable {
        constructor(colors) {
            this.colorTable = colors || {};
            this.nextIdx = 0;
            this.colorGenerator = new RandomColorGenerator();
        }

        getColor(key) {
            if (!this.colorTable.hasOwnProperty(key)) {
                if (this.colorTable.hasOwnProperty("*")) {
                    return this.colorTable["*"]
                }
                this.colorTable[key] = this.colorGenerator.get();
            }
            return this.colorTable[key]
        }
    }

    // Random color generator from https://github.com/sterlingwes/RandomColor/blob/master/rcolor.js
    // Free to use & distribute under the MIT license
    // Wes Johnson (@SterlingWes)
    //
    // inspired by http://martin.ankerl.com/2009/12/09/how-to-create-random-colors-programmatically/
    function RandomColorGenerator() {
        this.hue = Math.random();
        this.goldenRatio = 0.618033988749895;
        this.hexwidth = 2;
    }

    RandomColorGenerator.prototype.hsvToRgb = function (h, s, v) {
        var h_i = Math.floor(h * 6),
            f = h * 6 - h_i,
            p = v * (1 - s),
            q = v * (1 - f * s),
            t = v * (1 - (1 - f) * s),
            r = 255,
            g = 255,
            b = 255;
        switch (h_i) {
            case 0:
                r = v, g = t, b = p;
                break
            case 1:
                r = q, g = v, b = p;
                break
            case 2:
                r = p, g = v, b = t;
                break
            case 3:
                r = p, g = q, b = v;
                break
            case 4:
                r = t, g = p, b = v;
                break
            case 5:
                r = v, g = p, b = q;
                break
        }
        return [Math.floor(r * 256), Math.floor(g * 256), Math.floor(b * 256)]
    };

    RandomColorGenerator.prototype.padHex = function (str) {
        if (str.length > this.hexwidth) return str
        return new Array(this.hexwidth - str.length + 1).join('0') + str
    };

    RandomColorGenerator.prototype.get = function (saturation, value) {
        this.hue += this.goldenRatio;
        this.hue %= 1;
        if (typeof saturation !== "number") saturation = 0.5;
        if (typeof value !== "number") value = 0.95;
        var rgb = this.hsvToRgb(this.hue, saturation, value);

        return "#" + this.padHex(rgb[0].toString(16))
            + this.padHex(rgb[1].toString(16))
            + this.padHex(rgb[2].toString(16))

    };

    new RandomColorGenerator();

    function randomRGB$1(min, max) {

        min = IGVMath.clamp(min, 0, 255);
        max = IGVMath.clamp(max, 0, 255);

        const r = Math.round(Math.random() * (max - min) + min).toString(10);
        const g = Math.round(Math.random() * (max - min) + min).toString(10);
        const b = Math.round(Math.random() * (max - min) + min).toString(10);
        return `rgb(${r},${g},${b})`

    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of ctx software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and ctx permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */


    const IGVGraphics = {

        configureHighDPICanvas: function (ctx, w, h) {

            const scaleFactor = window.devicePixelRatio;
            // const scaleFactor = 1

            ctx.canvas.style.width = (`${w}px`);
            ctx.canvas.width = Math.floor(scaleFactor * w);

            ctx.canvas.style.height = (`${h}px`);
            ctx.canvas.height = Math.floor(scaleFactor * h);

            ctx.scale(scaleFactor, scaleFactor);

        },

        setProperties: function (ctx, properties) {

            for (var key in properties) {
                if (properties.hasOwnProperty(key)) {
                    var value = properties[key];
                    ctx[key] = value;
                }
            }
        },

        strokeLine: function (ctx, x1, y1, x2, y2, properties) {

            x1 = Math.floor(x1) + 0.5;
            y1 = Math.floor(y1) + 0.5;
            x2 = Math.floor(x2) + 0.5;
            y2 = Math.floor(y2) + 0.5;

            if (properties) {
                ctx.save();
                IGVGraphics.setProperties(ctx, properties);
            }

            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y2);
            ctx.stroke();

            if (properties) ctx.restore();
        },

        fillRect: function (ctx, x, y, w, h, properties) {
            x = Math.round(x);
            y = Math.round(y);

            if (properties) {
                ctx.save();
                IGVGraphics.setProperties(ctx, properties);
            }

            ctx.fillRect(x, y, w, h);

            if (properties) ctx.restore();
        },

        fillPolygon: function (ctx, x, y, properties) {
            if (properties) {
                ctx.save();
                IGVGraphics.setProperties(ctx, properties);
            }
            doPath(ctx, x, y);
            ctx.fill();
            if (properties) ctx.restore();
        },

        strokePolygon: function (ctx, x, y, properties) {
            if (properties) {
                ctx.save();
                IGVGraphics.setProperties(ctx, properties);
            }
            doPath(ctx, x, y);
            ctx.stroke();
            if (properties) ctx.restore();
        },

        fillText: function (ctx, text, x, y, properties, transforms) {

            if (properties || transforms) {
                ctx.save();
            }

            if (properties) {
                IGVGraphics.setProperties(ctx, properties);
            }

            if (transforms) {
                // Slow path with context saving and extra translate
                ctx.translate(x, y);

                for (var transform in transforms) {
                    var value = transforms[transform];

                    // TODO: Add error checking for robustness
                    if (transform === 'translate') {
                        ctx.translate(value['x'], value['y']);
                    }
                    if (transform === 'rotate') {
                        ctx.rotate(value['angle'] * Math.PI / 180);
                    }
                }

                ctx.fillText(text, 0, 0);
            } else {
                ctx.fillText(text, x, y);
            }

            if (properties || transforms) ctx.restore();
        },

        strokeText: function (ctx, text, x, y, properties, transforms) {


            if (properties || transforms) {
                ctx.save();
            }

            if (properties) {
                IGVGraphics.setProperties(ctx, properties);
            }

            if (transforms) {
                ctx.translate(x, y);

                for (var transform in transforms) {
                    var value = transforms[transform];

                    // TODO: Add error checking for robustness
                    if (transform === 'translate') {
                        ctx.translate(value['x'], value['y']);
                    }
                    if (transform === 'rotate') {
                        ctx.rotate(value['angle'] * Math.PI / 180);
                    }
                }

                ctx.strokeText(text, 0, 0);
            } else {
                ctx.strokeText(text, x, y);
            }

            if (properties || transforms) ctx.restore();
        },

        strokeCircle: function (ctx, x, y, radius, properties) {
            if (properties) {
                ctx.save();
                IGVGraphics.setProperties(ctx, properties);
            }
            ctx.beginPath();
            ctx.arc(x, y, radius, 0, 2 * Math.PI);
            ctx.stroke();
            if (properties) ctx.restore();
        },

        fillCircle: function (ctx, x, y, radius, properties) {
            if (properties) {
                ctx.save();
                IGVGraphics.setProperties(ctx, properties);
            }
            ctx.beginPath();
            ctx.arc(x, y, radius, 0, 2 * Math.PI);
            ctx.fill();
            if (properties) ctx.restore();
        },

        drawArrowhead: function (ctx, x, y, size, lineWidth) {

            ctx.save();
            if (!size) {
                size = 5;
            }
            if (lineWidth) {
                ctx.lineWidth = lineWidth;
            }
            ctx.beginPath();
            ctx.moveTo(x, y - size / 2);
            ctx.lineTo(x, y + size / 2);
            ctx.lineTo(x + size, y);
            ctx.lineTo(x, y - size / 2);
            ctx.closePath();
            ctx.fill();
            ctx.restore();
        },

        dashedLine: function (ctx, x1, y1, x2, y2, dashLen, properties = {}) {
            if (dashLen === undefined) dashLen = 2;
            ctx.setLineDash([dashLen, dashLen]);
            IGVGraphics.strokeLine(ctx, x1, y1, x2, y2, properties);
            ctx.setLineDash([]);
        },

        roundRect: function (ctx, x, y, width, height, radius, fill, stroke) {

            if (typeof stroke == "undefined") {
                stroke = true;
            }
            if (typeof radius === "undefined") {
                radius = 5;
            }
            ctx.beginPath();
            ctx.moveTo(x + radius, y);
            ctx.lineTo(x + width - radius, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
            ctx.lineTo(x + width, y + height - radius);
            ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
            ctx.lineTo(x + radius, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
            ctx.closePath();
            if (stroke) {
                ctx.stroke();
            }
            if (fill) {
                ctx.fill();
            }
        },
        polygon: function (ctx, x, y, fill, stroke) {

            if (typeof stroke == "undefined") {
                stroke = true;
            }

            ctx.beginPath();
            var len = x.length;
            ctx.moveTo(x[0], y[0]);
            for (var i = 1; i < len; i++) {
                ctx.lineTo(x[i], y[i]);
                // this.moveTo(x[i], y[i]);
            }

            ctx.closePath();
            if (stroke) {
                ctx.stroke();
            }
            if (fill) {
                ctx.fill();
            }
        },

        drawRandomColorVerticalLines: ctx => {
            for (let x = 0; x < ctx.canvas.width; x++) {
                IGVGraphics.fillRect(ctx, x, 0, 1, ctx.canvas.height, { fillStyle: randomRGB$1(100, 250) });
            }
        },

        labelTransformWithContext: (ctx, exe) => {
            ctx.translate(exe, 0);
            ctx.scale(-1, 1);
            ctx.translate(-exe, 0);
        }

    };

    function doPath(ctx, x, y) {


        var i, len = x.length;
        for (i = 0; i < len; i++) {
            x[i] = Math.round(x[i]);
            y[i] = Math.round(y[i]);
        }

        ctx.beginPath();
        ctx.moveTo(x[0], y[0]);
        for (i = 1; i < len; i++) {
            ctx.lineTo(x[i], y[i]);
        }
        ctx.closePath();
    }

    class Alert {
        constructor(parent) {
            this.dialog = new AlertDialog(parent);

        }

        present(alert, callback) {
            this.dialog.present(alert, callback);
        }
    }

    const FileFormats = {

        gwascatalog: {
            fields: [
                'bin',
                'chr',
                'start',
                'end',
                'name',
                'pubMedID',
                'author',
                'pubDate',
                'journal',
                'title',
                'trait',
                'initSample',
                'replSample',
                'region',
                'genes',
                'riskAllele',
                'riskAlFreq',
                'pValue',
                'pValueDesc',
                'orOrBeta',
                'ci95',
                'platform',
                'cnv'
            ]
        },

        wgrna: {
            fields:
                [
                    'bin',
                    'chr',
                    'start',
                    'end',
                    'name',
                    'score',
                    'strand',
                    'thickStart',
                    'thickEnd',
                    'type'
                ]
        },

        cpgislandext: {
            fields:

                [
                    'bin',
                    'chr',
                    'start',
                    'end',
                    'name',
                    'length',
                    'cpgNum',
                    'gcNum',
                    'perCpg',
                    'perGc',
                    'obsExp'
                ]
        },

        clinVarMain: {
            fields: [
                'chr1',
                'start',
                'end',
                'name',
                'score',
                'strand',
                'thickStart',
                'thickEnd',
                'reserved',
                'blockCount',  // Number of blocks
                'blockSizes',  // Comma separated list of block sizes
                'chromStarts', // Start positions relative to chromStart
                'origName',    // NM_198053.2(CD247):c.462C>T (p.Asp154=)	ClinVar Variation Report
                'clinSign',    // Likely benign	Clinical significance
                'reviewStatus', // 	based on: criteria provided,single submitter	Review Status
                'type',         // single nucleotide variant	Type of Variant
                'geneId', 	    // CD247	Gene Symbol
                'snpId',       //	181656780	dbSNP ID
                'nsvId',       //		dbVar ID
                'rcvAcc',      //	RCV000642347	ClinVar Allele Submission
                'testedInGtr', //	N	Genetic Testing Registry
                'phenotypeList', //	Immunodeficiency due to defect in cd3-zeta	Phenotypes
                'phenotype', //	MedGen:C1857798, OMIM:610163	Phenotype identifiers
                'origin', //	germline	Data origin
                'assembly', //	GRCh37	Genome assembly
                'cytogenetic', //	1q24.2	Cytogenetic status
                'hgvsCod', //	NM_198053.2:c.462C>T	Nucleotide HGVS
                'hgvsProt', //	NP_932170.1:p.Asp154=	Protein HGVS
                'numSubmit', //	1	Number of submitters
                'lastEval', //	Dec 19,2017	Last evaluation
                'guidelines', //		Guidelines
                'otherIds'
            ]
        }
    };

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    /**
     * Test if the given value is a string or number.  Not using typeof as it fails on boxed primitives.
     *
     * @param value
     * @returns boolean
     */

    function isSimpleType(value) {
        const simpleTypes = new Set(["boolean", "number", "string", "symbol"]);
        const valueType = typeof value;
        return (value !== undefined && (simpleTypes.has(valueType) || value.substring || value.toFixed))
    }

    function buildOptions(config, options) {

        var defaultOptions = {
            oauthToken: config.oauthToken,
            headers: config.headers,
            withCredentials: config.withCredentials,
            filename: config.filename
        };

        return Object.assign(defaultOptions, options)
    }

    /**
     * isMobile test from http://detectmobilebrowsers.com
     * TODO -- improve UI design so this isn't neccessary
     * @returns {boolean}
     */

    // igv.isMobile = function () {
    //
    //     const a = (navigator.userAgent || navigator.vendor || window.opera);
    //     return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) ||
    //         /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
    //
    // }

    const doAutoscale = function (features) {
        var min, max;

        if (features && features.length > 0) {
            min = Number.MAX_VALUE;
            max = -Number.MAX_VALUE;

            for(let f of features) {
                if (!Number.isNaN(f.value)) {
                    min = Math.min(min, f.value);
                    max = Math.max(max, f.value);
                }
            }

            // Insure we have a zero baseline
            if (max > 0) min = Math.min(0, min);
            if (max < 0) max = 0;
        } else {
            // No features -- default
            min = 0;
            max = 100;
        }

        return {min: min, max: max}
    };

    const validateGenomicExtent = function (chromosomeLengthBP, genomicExtent, minimumBP) {

        let ss = genomicExtent.start;
        let ee = genomicExtent.end;

        if (undefined === ee) {

            ss -= minimumBP / 2;
            ee = ss + minimumBP;

            if (ee > chromosomeLengthBP) {
                ee = chromosomeLengthBP;
                ss = ee - minimumBP;
            } else if (ss < 0) {
                ss = 0;
                ee = minimumBP;
            }

        } else if (ee - ss < minimumBP) {

            const center = (ee + ss) / 2;

            if (center - minimumBP / 2 < 0) {
                ss = 0;
                ee = ss + minimumBP;
            } else if (center + minimumBP / 2 > chromosomeLengthBP) {
                ee = chromosomeLengthBP;
                ss = ee - minimumBP;
            } else {
                ss = center - minimumBP / 2;
                ee = ss + minimumBP;
            }
        }

        genomicExtent.start = Math.ceil(ss);
        genomicExtent.end = Math.floor(ee);
    };

    /*!
     * is-number <https://github.com/jonschlinkert/is-number>
     *
     * Copyright (c) 2014-present, Jon Schlinkert.
     * Released under the MIT License.
     */

    const isNumber = function (num) {
        if (typeof num === 'number') {
            return num - num === 0
        }
        if (typeof num === 'string' && num.trim() !== '') {
            return Number.isFinite ? Number.isFinite(+num) : isFinite(+num)
        }
        return false
    };

    async function getFilename$1(url) {
        if (isString$2(url) && url.startsWith("https://drive.google.com")) {
            // This will fail if Google API key is not defined
            if (getApiKey() === undefined) {
                throw Error("Google drive is referenced, but API key is not defined.  An API key is required for Google Drive access")
            }
            const json = await getDriveFileInfo(url);
            return json.originalFileName || json.name
        } else {
            return getFilename$2(url)
        }
    }

    function prettyBasePairNumber(raw) {

        var denom,
            units,
            value,
            floored;

        if (raw > 1e7) {
            denom = 1e6;
            units = " mb";
        } else if (raw > 1e4) {

            denom = 1e3;
            units = " kb";

            value = raw / denom;
            floored = Math.floor(value);
            return numberFormatter$1(floored) + units
        } else {
            return numberFormatter$1(raw) + " bp"
        }

        value = raw / denom;
        floored = Math.floor(value);

        return floored.toString() + units
    }


    function isDataURL(obj) {
        return (isString$2(obj) && obj.startsWith("data:"))
    }

    function createColumn(columnContainer, className) {
        const column = domUtils.div({class: className});
        columnContainer.appendChild(column);
    }


    function insertElementBefore(element, referenceNode) {
        referenceNode.parentNode.insertBefore(element, referenceNode);
    }

    function insertElementAfter(element, referenceNode) {
        referenceNode.parentNode.insertBefore(element, referenceNode.nextSibling);
    }

    /**
     * Test to see if page is loaded in a secure context, that is by https or is localhost.
     */
    function isSecureContext() {
        return window.location.protocol === "https:" || window.location.hostname === "localhost"
    }

    // reference: https://pretagteam.com/question/find-element-height-including-margin
    function getElementAbsoluteHeight(element) {

        // Get the DOM Node if you pass in a string
        element = (typeof element === 'string') ? document.querySelector(element) : element;

        const styles = window.getComputedStyle(element);
        const margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);
        const height = element.offsetHeight;

        return Math.ceil(margin + height);
    }

    /**
     * Decoder for bedpe records.
     *
     * Bedpe format was created by Aaron Quinlan et al as part of the bedtools project.
     * The spec is here:  https://bedtools.readthedocs.io/en/latest/content/general-usage.html,
     *
     * 1      2      3    4      5      6    7    8     9       10      11-
     * chrom1 start1 end1 chrom2 start2 end2 name score strand1 strand2 <Any number of additional, user-defined fields>
     *
     * However there are off spec variants, an important one being a 7 column format with score in place of the standard
     * name column.
     *
     * A common variant is a "hiccups" output file, which is standard bedpe with the exception of a header line
     * of the form
     *
     * chr1    x1    x2    chr2    y1    y2    name    score    strand1    strand2    color    observed    expectedBL    expectedDonut    expectedH    expectedV    fdrBL    fdrDonut    fdrH    fdrV
     *
     * The "hiccups" output is apparently not standardized as this is found at ENCODE, with a non-helpful "tsv" extension
     *
     * chr1    x1    x2    chr2    y1    y2    color    observed    expectedBL    expectedDonut    expectedH    expectedV    fdrBL    fdrDonut    fdrH    fdrV    numCollapsed    centroid1    centroid2    radius
     * chr9    136790000    136795000    chr9    136990000    136995000    0,255,255    101.0    31.100368    38.40316    56.948116    34.040756    1.1876738E-13    1.05936405E-13    2.5148233E-4    1.7220993E-13    1    136792500    136992500    25590
     *
     * The "hiccups" documentation specfies yet another set of column headers
     * chromosome1    x1    x2    chromosome2    y1    y2    color    observed expected_bottom_left    expected_donut    expected_horizontal    expected_vertical fdr_bottom_left    fdr_donut    fdr_horizontal    fdr_vertical number_collapsed    centroid1    centroid2    radius
     *
     * @param tokens
     * @param ignore
     * @returns {{start1: number, end2: number, end1: number, chr1: *, chr2: *, start2: number}|undefined}
     */

    function decodeBedpe(tokens, header) {

        if (tokens.length < 6) {
            console.log("Skipping line: " + tokens.join(' '));
            return undefined
        }

        var feature = {
            chr1: tokens[0],
            start1: Number.parseInt(tokens[1]),
            end1: Number.parseInt(tokens[2]),
            chr2: tokens[3],
            start2: Number.parseInt(tokens[4]),
            end2: Number.parseInt(tokens[5])
        };

        if (isNaN(feature.start1) || isNaN(feature.end1) || isNaN(feature.start2) || isNaN(feature.end2)) {
            //throw Error(`Error parsing line: ${tokens.join('\t')}`);
            return undefined
        }

        // Determine if this is a "hiccups" file.  Store result on "header" so it doesn't need repeated for every feature
        if(header && header.hiccups === undefined) {
            header.hiccups = header.columnNames ? isHiccups(header.columnNames) : false;
        }
        const hiccups = header && header.hiccups;
        const stdColumns = hiccups ? 6 : 10;

        if(!hiccups) {
            if (tokens.length > 6 && tokens[6] !== ".") {
                feature.name = tokens[6];
            }

            if (tokens.length > 7 && tokens[7] !== ".") {
                feature.score = Number(tokens[7]);
            }

            if (tokens.length > 8 && tokens[8] !== ".") {
                feature.strand1 = tokens[8];
            }

            if (tokens.length > 9 && tokens[9] !== ".") {
                feature.strand2 = tokens[9];
            }
        }

        // Optional extra columns
        if (header) {
            const colorColumn = header.colorColumn;
            if (colorColumn && colorColumn < tokens.length) {
                feature.color = IGVColor.createColorString(tokens[colorColumn]);
            }
            const thicknessColumn = header.thicknessColumn;
            if (thicknessColumn && thicknessColumn < tokens.length) {
                feature.thickness = tokens[thicknessColumn];
            }

            if (tokens.length > stdColumns && header.columnNames && header.columnNames.length === tokens.length) {
                feature.extras = tokens.slice(stdColumns);
            }
        }


        // Set total extent of feature
        if (feature.chr1 === feature.chr2) {
            feature.chr = feature.chr1;
            feature.start = Math.min(feature.start1, feature.start2);
            feature.end = Math.max(feature.end1, feature.end2);

        }
        return feature
    }

    /**
     * Hack for non-standard bedPE formats, where numeric score can be in column 7 (name field from spec)
     * @param features
     */
    function fixBedPE(features) {

        if (features.length == 0) return

        // Assume all features have same properties
        const firstFeature = features[0];
        if (firstFeature.score === undefined && firstFeature.name !== undefined) {
            // Name field (col 7) is sometimes used for score.
            for (let f of features) {
                if (!(isNumber(f.name) || f.name === '.')) return
            }
            for (let f of features) {
                f.score = Number(f.name);
                delete f.name;
            }
        }

        // Make copies of inter-chr features, one for each chromosome
        const interChrFeatures = features.filter(f => f.chr1 !== f.chr2);
        for (let f1 of interChrFeatures) {
            const f2 = Object.assign({}, f1);
            f2.dup = true;
            features.push(f2);

            f1.chr = f1.chr1;
            f1.start = f1.start1;
            f1.end = f1.end1;

            f2.chr = f2.chr2;
            f2.start = f2.start2;
            f2.end = f2.end2;
        }
    }


    /**
     * Special decoder for Hic Domain files.   In these files feature1 == feature2, they are really bed records.
     * @param tokens
     * @param ignore
     * @returns {*}
     */
    function decodeBedpeDomain(tokens, header) {

        if (tokens.length < 8) return undefined

        return {
            chr: tokens[0],
            start: Number.parseInt(tokens[1]),
            end: Number.parseInt(tokens[2]),
            color: IGVColor.createColorString(tokens[6]),
            value: Number(tokens[7])
        }
    }

    function isHiccups(columns) {
        return columns && (columns.includes("fdrDonut") || columns.includes("fdr_donut"))
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const knownFileExtensions = new Set([

        "narrowpeak",
        "broadpeak",
        "regionpeak",
        "peaks",
        "bedgraph",
        "wig",
        "gff3",
        "gff",
        "gtf",
        "fusionjuncspan",
        "refflat",
        "seg",
        "aed",
        "bed",
        "vcf",
        "bb",
        "bigbed",
        "biginteract",
        "biggenepred",
        "bignarrowpeak",
        "bw",
        "bigwig",
        "bam",
        "tdf",
        "refgene",
        "genepred",
        "genepredext",
        "bedpe",
        "bp",
        "snp",
        "rmsk",
        "cram",
        "gwas",
        "maf",
        "mut",
        "tsv",
        "hiccups",
        "fasta",
        "fa",
        "fna",
        "pytor"
    ]);

    /**
     * Return a custom format object with the given name.
     * @param name
     * @returns {*}
     */
    function getFormat(name) {

        if (FileFormats && FileFormats[name]) {
            return expandFormat(FileFormats[name])
        } else {
            return undefined
        }

        function expandFormat(format) {

            const fields = format.fields;
            const keys = ['chr', 'start', 'end'];

            for (let i = 0; i < fields.length; i++) {
                for (let key of keys) {
                    if (key === fields[i]) {
                        format[key] = i;
                    }
                }
            }

            return format
        }
    }

    function inferFileFormat(fn) {

        var idx, ext;

        fn = fn.toLowerCase();

        // Special case -- UCSC refgene files
        if (fn.endsWith("refgene.txt.gz") ||
            fn.endsWith("refgene.txt.bgz") ||
            fn.endsWith("refgene.txt") ||
            fn.endsWith("refgene.sorted.txt.gz") ||
            fn.endsWith("refgene.sorted.txt.bgz")) {
            return "refgene"
        }


        //Strip parameters -- handle local files later
        idx = fn.indexOf("?");
        if (idx > 0) {
            fn = fn.substr(0, idx);
        }

        //Strip aux extensions .gz, .tab, and .txt
        if (fn.endsWith(".gz")) {
            fn = fn.substr(0, fn.length - 3);
        }

        if (fn.endsWith(".txt") || fn.endsWith(".tab") || fn.endsWith(".bgz")) {
            fn = fn.substr(0, fn.length - 4);
        }


        idx = fn.lastIndexOf(".");
        ext = idx < 0 ? fn : fn.substr(idx + 1);

        switch (ext) {
            case "bw":
                return "bigwig"
            case "bb":
                return "bigbed"
            case "fasta":
            case "fa":
            case "fna":
                return "fasta"
            default:
                if (knownFileExtensions.has(ext)) {
                    return ext
                } else {
                    return undefined
                }

        }

    }

    function inferIndexPath(url, extension) {

        if (isString$2(url)) {
            if (url.includes("?")) {
                const idx = url.indexOf("?");
                return url.substring(0, idx) + "." + extension + url.substring(idx)
            } else {
                return url + "." + extension
            }
        } else {
            return undefined
        }
    }


    function inferTrackType(config) {

        translateDeprecatedTypes(config);

        if (config.type) {
            return config.type
        }

        if (config.format) {
            const format = config.format.toLowerCase();
            switch (format) {
                case "bw":
                case "bigwig":
                case "wig":
                case "bedgraph":
                case "tdf":
                    return "wig"
                case "vcf":
                    return "variant"
                case "seg":
                    return "seg"
                case "mut":
                case "maf":
                    return "mut"
                case "bam":
                case "cram":
                    return "alignment"
                case "hiccups":
                case "bedpe":
                case "bedpe-loop":
                case "biginteract":
                    return "interact"
                case "bp":
                    return "arc"
                case "gwas":
                    return "gwas"
                case "bed":
                case "bigbed":
                case "bb":
                case "biggenepred":
                case "bignarrowpeak":
                    return "bedtype"
                case "fasta":
                    return "sequence"
                case "pytor":
                    return "cnvpytor"
                default:
                    return "annotation"
            }
        }
    }

    function translateDeprecatedTypes(config) {

        if (config.featureType) {  // Translate deprecated "feature" type
            config.type = config.type || config.featureType;
            config.featureType = undefined;
        }
        if ("junctions" === config.type) {
            config.type = "junction";
        } else if ("bed" === config.type) {
            config.type = "annotation";
            config.format = config.format || "bed";
        } else if ("annotations" === config.type) {
            config.type = "annotation";
        } else if ("alignments" === config.type) {
            config.type = "alignment";
        } else if ("bam" === config.type) {
            config.type = "alignment";
            config.format = "bam";
        } else if ("vcf" === config.type) {
            config.type = "variant";
            config.format = "vcf";
        } else if ("t2d" === config.type) {
            config.type = "gwas";
        } else if ("FusionJuncSpan" === config.type && !config.format) {
            config.format = "fusionjuncspan";
        } else if ("aed" === config.type) {
            config.type = "annotation";
            config.format = config.format || "aed";
        }
    }

    /**
     * Attempt to infer the file format by reading a few lines from the header.  Currently this only supports "tsv" extensions,
     * it was added specifically for "hiccups" type tsv files in ENCODE.  Might be expanded in the future.
     *
     * @param url
     * @returns {Promise<void>}
     */
    async function inferFileFormatFromHeader(config) {

        if (config.url) {
            const firstBytes = await igvxhr.loadString(config.url, buildOptions(config, {range: {start: 0, size: 1000}}));
            if(firstBytes) {
                const columnNames = firstBytes.split('\n')[0].split('\t');
                if(isHiccups(columnNames)) {
                    return "hiccups"
                }
            }
        }

        return undefined

    }

    function registerFileFormats(name, fields) {
        FileFormats[name] = {fields: fields};
    }

    var TrackUtils = /*#__PURE__*/Object.freeze({
        __proto__: null,
        knownFileExtensions: knownFileExtensions,
        getFormat: getFormat,
        inferFileFormat: inferFileFormat,
        inferFileFormatFromHeader: inferFileFormatFromHeader,
        inferTrackType: inferTrackType,
        inferIndexPath: inferIndexPath,
        registerFileFormats: registerFileFormats
    });

    const pairs =
        [
            ['A', 'T'],
            ['G', 'C'],
            ['Y', 'R'],
            ['W', 'S'],
            ['K', 'M'],
            ['D', 'H'],
            ['B', 'V']
        ];

    const complements = new Map();
    for (let p of pairs) {
        const p1 = p[0];
        const p2 = p[1];
        complements.set(p1, p2);
        complements.set(p2, p1);
        complements.set(p1.toLowerCase(), p2.toLowerCase());
        complements.set(p2.toLowerCase(), p1.toLowerCase());
    }

    function reverseComplementSequence(sequence) {

        let comp = '';
        let idx = sequence.length;
        while (idx-- > 0) {
            const base = sequence[idx];
            comp += complements.has(base) ? complements.get(base) : base;
        }
        return comp
    }

    class Chromosome {
        constructor(name, order, bpLength) {
            this.name = name;
            this.order = order;
            this.bpLength = bpLength;
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const splitLines$4 = splitLines$5;

    const reservedProperties$1 = new Set(['fastaURL', 'indexURL', 'cytobandURL', 'indexed']);

    class NonIndexedFasta {


        constructor(reference) {

            this.fastaURL = reference.fastaURL;
            this.withCredentials = reference.withCredentials;
            this.chromosomeNames = [];
            this.chromosomes = {};
            this.sequences = new Map();

            // Build a track-like config object from the referenceObject
            const config = {};
            for (let key in reference) {
                if (reference.hasOwnProperty(key) && !reservedProperties$1.has(key)) {
                    config[key] = reference[key];
                }
            }
            this.config = config;
        }


        async init() {
            return this.loadAll()
        }

        async getSequence(chr, start, end) {

            if (!this.sequences.has(chr)) {
                return undefined
            }

            let seqSlice = this.sequences.get(chr).find(ss => ss.contains(start, end));
            if (!seqSlice) {
                seqSlice = this.sequences.get(chr).find(ss => ss.overlaps(start, end));
                if (!seqSlice) {
                    return undefined
                }
            }

            start -= seqSlice.offset;
            end -= seqSlice.offset;

            let prefix = "";
            if (start < 0) {
                for (let i = start; i < Math.min(end, 0); i++) {
                    prefix += "*";
                }
            }

            if (end <= 0) {
                return Promise.resolve(prefix)
            }

            const seq = seqSlice.sequence;
            const seqEnd = Math.min(end, seq.length);
            return prefix + seq.substring(start, seqEnd)
        }

        async loadAll() {

            let data;
            if (isDataURL(this.fastaURL)) {
                let bytes = decodeDataURI$1(this.fastaURL);
                data = "";
                for (let b of bytes) {
                    data += String.fromCharCode(b);
                }
            } else {
                data = await igvxhr.load(this.fastaURL, buildOptions(this.config));
            }

            const chrNameSet = new Set();
            const lines = splitLines$4(data);
            const len = lines.length;
            let lineNo = 0;
            let order = 0;
            let nextLine;
            let current = {};
            while (lineNo < len) {
                nextLine = lines[lineNo++].trim();
                if (nextLine.startsWith("#") || nextLine.length === 0) ; else if (nextLine.startsWith(">")) {
                    // Start the next sequence
                    if(current && current.seq) {
                        pushChromosome.call(this, current, order++);
                    }

                    const parts = nextLine.substr(1).split(/\s+/);

                    // Check for samtools style locus string.   This is not perfect, and could fail on weird sequence names
                    const nameParts = parts[0].split(':');
                    current.chr = nameParts[0];
                    current.seq = "";
                    current.offset = 0;
                    if (nameParts.length > 1 && nameParts[1].indexOf('-') > 0) {
                        const locusParts = nameParts[1].split('-');
                        if (locusParts.length === 2 &&
                            /^[0-9]+$/.test(locusParts[0]) &&
                            /^[0-9]+$/.test(locusParts[1])) ;
                        const from = Number.parseInt(locusParts[0]);
                        const to = Number.parseInt(locusParts[1]);
                        if (to > from) {   // TODO this should be an error
                            current.offset = from - 1;
                        }

                        // Check for chromosome length token
                        if (parts.length > 1 && parts[1].startsWith("@len=")) {
                            try {
                                current.length = parseInt(parts[1].trim().substring(5));
                            } catch (e) {
                                current.length = undefined;
                                console.error(`Error parsing sequence length for ${nextLine}`);
                            }
                        } else {
                            current.length = undefined;
                        }
                    }
                } else {
                    current.seq += nextLine;
                }
                // add last seq
                if (current && current.seq) {
                    pushChromosome.call(this, current, order);
                }
            }

            function pushChromosome(current, order) {
                const length = current.length || (current.offset + current.seq.length);
                if (!chrNameSet.has(current.chr)) {
                    this.chromosomeNames.push(current.chr);
                    this.sequences.set(current.chr, []);
                    this.chromosomes[current.chr] = new Chromosome(current.chr, order, length);
                    chrNameSet.add(current.chr);
                } else {
                    const c = this.chromosomes[current.chr];
                    c.bpLength = Math.max(c.bpLength, length);
                }
                this.sequences.get(current.chr).push(new SequenceSlice(current.offset, current.seq));
            }
        }
    }

    class SequenceSlice {

        constructor(offset, sequence) {
            this.offset = offset;
            this.sequence = sequence;
        }

        contains(start, end) {
            return this.offset <= start && this.end >= end
        }

        overlaps(start, end) {
            return this.offset < end && this.end > start
        }

        get end() {
            return this.offset + this.sequence.length
        }

    }

    const GenomicInterval = function (chr, start, end, features) {
        this.chr = chr;
        this.start = start;
        this.end = end;
        this.features = features;
    };

    GenomicInterval.prototype.contains = function (chr, start, end) {
        return this.chr === chr &&
            this.start <= start &&
            this.end >= end
    };

    GenomicInterval.prototype.containsRange = function (range) {
        return this.chr === range.chr &&
            this.start <= range.start &&
            this.end >= range.end
    };

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const splitLines$3 = splitLines$5;

    const reservedProperties = new Set(['fastaURL', 'indexURL', 'compressedIndexURL', 'cytobandURL', 'indexed']);

    class FastaSequence {

        constructor(reference) {

            this.file = reference.fastaURL;
            this.indexFile = reference.indexURL || reference.indexFile || this.file + ".fai";
            this.compressedIndexFile = reference.compressedIndexURL || false;
            this.withCredentials = reference.withCredentials;
            this.chromosomeNames = [];
            this.chromosomes = {};
            this.sequences = {};
            this.offsets = {};

            // Build a track-like config object from the referenceObject
            const config = {};
            for (let key in reference) {
                if (reference.hasOwnProperty(key) && !reservedProperties.has(key)) {
                    config[key] = reference[key];
                }
            }
            this.config = config;
        }


        async init() {
            return this.getIndex()
        }

        async getSequence(chr, start, end) {

            const hasCachedSquence = this.interval && this.interval.contains(chr, start, end);

            if (!hasCachedSquence) {

                // Expand query, to minimum of 50kb
                let qstart = start;
                let qend = end;
                if ((end - start) < 50000) {
                    const w = (end - start);
                    const center = Math.round(start + w / 2);
                    qstart = Math.max(0, center - 25000);
                    qend = center + 25000;
                }

                const seqBytes = await this.readSequence(chr, qstart, qend);
                this.interval = new GenomicInterval(chr, qstart, qend, seqBytes);
            }

            const offset = start - this.interval.start;
            const n = end - start;
            const seq = this.interval.features ? this.interval.features.substr(offset, n) : null;
            return seq
        }

        async getIndex() {

            if (this.index) {
                return this.index
            } else {
                const data = await igvxhr.load(this.indexFile, buildOptions(this.config));
                const lines = splitLines$3(data);
                const len = lines.length;
                let lineNo = 0;
                let order = 0;
                this.index = {};

                while (lineNo < len) {
                    const tokens = lines[lineNo++].split("\t");
                    const nTokens = tokens.length;

                    if (nTokens === 5) {
                        // Parse the index line.
                        const chr = tokens[0];
                        const size = parseInt(tokens[1]);
                        const position = parseInt(tokens[2]);
                        const basesPerLine = parseInt(tokens[3]);
                        const bytesPerLine = parseInt(tokens[4]);

                        const indexEntry = {
                            size: size,
                            position: position,
                            basesPerLine: basesPerLine,
                            bytesPerLine: bytesPerLine
                        };

                        this.chromosomeNames.push(chr);
                        this.index[chr] = indexEntry;
                        this.chromosomes[chr] = new Chromosome(chr, order++, size);
                    }
                }
                return this.index
            }
        }


        //Code is losely based on https://github.com/GMOD/bgzf-filehandle
        //Reworked however in orde to work with the igvxhr interface for loading files
        //Additionally, replaced calls to the Long.js interface with standard JS calls for ArrayBuffers and the associated views
        //
        //The compressed index is an array of blocks, with each block being a pair: compressed-position & uncompressed-position (both in bytes)
        async getCompressedIndex() {
            const GZI_NUM_BYTES_OFFSET = 8;
            const GZI_NUM_BYTES_BLOCK = 8;
            if (this.compressedIndex) {
                return this.compressedIndex
            }
            if (!this.compressedIndexFile) {
                this.compressedIndex = [];
                return this.compressedIndex
            }
            //In contrast to the 'normal' reference (for which the index is chromosome based), this index is block-based
            //As such there is not need to make it a hash. An array is sufficient.
            this.compressedIndex = [];
            const gziData = await igvxhr.loadArrayBuffer(this.compressedIndexFile, buildOptions(this.config));
            const givenFileSize = gziData.byteLength;
            if (givenFileSize < GZI_NUM_BYTES_OFFSET) {
                console.log("Cannot parse GZI index file: length (" + givenFileSize + " bytes) is insufficient to determine content of index.");
                return this.compressedIndex
            }
            //First 8 bytes are a little endian unsigned bigint (64bit), indicating the number of blocks in the index.
            const numBlocksBuffer = gziData.slice(0, GZI_NUM_BYTES_OFFSET);
            const numBlocks = Number((new DataView(numBlocksBuffer)).getBigUint64(0, true));
            //The remainder of the gzi content are pairs of little endian unsigned bigint (64bit) numbers.
            //The first of the pair is the compressed position of a block
            //The second of the pair is the uncompressed position of a block

            //Sanity check:
            //Is the size of the array-buffer (of the entire file) correct with regards to the number of blocks detailled by the first 8 bytes of the file?
            //Total file-size should be:
            // 8 + 2*(num_entries*8) bytes, with the first 8 bytes indicating the number of entries
            const expectedFileSize = GZI_NUM_BYTES_OFFSET + numBlocks * 2 * GZI_NUM_BYTES_BLOCK;
            if (givenFileSize != expectedFileSize) {
                console.log("Incorrect file size of reference genome index. Expected : " + expectedFileSize + ". Received : " + givenFileSize);
                return this.compressedIndex
            }

            //Push the first block to the index: the first block always has positions 0 for both the compressed and uncompressed file
            this.compressedIndex.push([0, 0]);

            //Further process all the blocks of the GZI index, and keep them in memory
            for (let blockNumber = 0; blockNumber < numBlocks; blockNumber++) {
                const bufferBlockStart = GZI_NUM_BYTES_OFFSET + blockNumber * 2 * GZI_NUM_BYTES_BLOCK;
                const bufferBlockEnd = GZI_NUM_BYTES_OFFSET + blockNumber * 2 * GZI_NUM_BYTES_BLOCK + 2 * GZI_NUM_BYTES_BLOCK;
                const bufferBlock = gziData.slice(bufferBlockStart, bufferBlockEnd);
                const viewBlock = new DataView(bufferBlock);
                const compressedPosition = Number(viewBlock.getBigUint64(0, true));  //First 8 bytes
                const uncompressedPosition = Number(viewBlock.getBigUint64(GZI_NUM_BYTES_BLOCK, true)); //Last 8 bytes
                this.compressedIndex.push([compressedPosition, uncompressedPosition]);
            }
            return this.compressedIndex
        }

        //The Fasta-index gives a byte-position of the chromosomal sequences within the FASTA file.
        //These locations need to be remapped to the locations within the zipped reference genome, using the GZI index
        //This function provides this functionality by 
        //1) taking the indicated start/stop byte locations within the UNCOMPRESSED FASTA file
        //2) remapping these byte locations to the correct blocks (and associated positions) within the COMPRESSED FASTA file
        //Subsequently, the calling method can then extract the correct blocks from the compressed FASTA files and uncompressed the data
        async getRelevantCompressedBlockNumbers(queryPositionStart, queryPositionEnd) {
            const UNCOMPRESSED_POSITION = 1;
            //Fallback for impossible values
            if (queryPositionStart < 0 || queryPositionEnd < 0 || queryPositionEnd < queryPositionStart) {
                console.log("Incompatible query positions for reference-genome. Start:" + queryPositionStart + " | End:" + queryPositionEnd);
                return []
            }
            //Ensure compressed index is loaded
            await this.getCompressedIndex();
            let result = [];
            //Now search for the correct block-numbers (going from 0 to length(compressed-index)) which overlap with the provided byte-positions
            const lowestBlockNumber = 0;
            const highestBlockNumber = this.compressedIndex.length - 1;
            //Failsafe if for some reason the compressed index wasn't loaded or doesn't contain any data
            if (this.compressedIndex.length == 0) {
                console.log("Compressed index does not contain any content");
                return []
            }
            //Failsafe: if the queryPositionStart is greater than the uncompressed-position of the final block,
            //then this final block is the only possible result
            if (queryPositionStart > (this.compressedIndex)[highestBlockNumber][UNCOMPRESSED_POSITION]) {
                return [highestBlockNumber]
            }

            //Rather than doing a linear search over all blocks, a binary search is done for speed considerations
            //We are searching for the highest block number for which its position is smaller than the query start position
            //Afterwards we will simply expand the blocks until the entire query range is covered
            let searchLow = lowestBlockNumber;
            let searchHigh = highestBlockNumber;
            let searchPosition = Math.floor(this.compressedIndex.length / 2);
            let maxIterations = this.compressedIndex.length + 1;
            let solutionFound = false;
            //instead of doing a while(true), this for-loop prevents eternal loops in case of issues
            for (let iteration = 0; iteration < maxIterations; iteration++) {
                const searchUncompressedPosition = (this.compressedIndex)[searchPosition][UNCOMPRESSED_POSITION];
                const nextSearchUncompressedPosition = (searchPosition < (this.compressedIndex.length - 1)) ? (this.compressedIndex)[searchPosition + 1][UNCOMPRESSED_POSITION] : Infinity;
                //The query position lies within the current search block
                if (searchUncompressedPosition <= queryPositionStart && nextSearchUncompressedPosition > queryPositionStart) {
                    solutionFound = true;
                    break //searchPosition is the correct block number index
                }
                //Current block lies before the query position
                else if (searchUncompressedPosition < queryPositionStart) {
                    searchLow = searchPosition + 1;
                }
                //Current block lies after the query position
                else {
                    searchHigh = searchPosition - 1;
                }
                searchPosition = Math.ceil((searchHigh - searchLow) / 2) + searchLow;
            }
            //If for some reason the binary search did not reveal a correct block index, then we return the empty result
            if (!solutionFound) {
                console.log("No blocks within compressed index found that correspond with query positions " + queryPositionStart + "," + queryPositionEnd);
                console.log(this.compressedIndex);
                return []
            }

            //Now extend the result by adding additional blocks until the entire query range is covered
            result.push(searchPosition);
            for (let blockIndex = searchPosition + 1; blockIndex < this.compressedIndex.length; blockIndex++) {
                result.push(blockIndex);
                const blockUncompressedPosition = (this.compressedIndex)[blockIndex][UNCOMPRESSED_POSITION];
                if (blockUncompressedPosition >= queryPositionEnd) {
                    break
                }
            }

            //It is possible that the query end position lies AFTER the start of the final block
            //If this is the case, we add a 'fake' negative index which will be interpreted by the loadAndUncompressBlocks method as an indicator
            //to read until the end of the file 
            const finalRelevantBlock = result[result.length - 1];
            const finalIndexBlock = this.compressedIndex.length - 1;
            if (finalRelevantBlock === finalIndexBlock && (this.compressedIndex)[finalRelevantBlock][UNCOMPRESSED_POSITION] < queryPositionEnd) {
                result.push(-1);
            }

            return result
        }


        //Load the content from the blockIndices.
        //This is done on a per-block basis
        //Content of the first block will be trimmed in order to match the expected offset
        async loadAndUncompressBlocks(blockIndices, startByte) {
            const COMPRESSED_POSITION = 0;
            const UNCOMPRESSED_POSITION = 1;
            //Normally the compressed index should already exist, we're just makeing sure here
            await this.getCompressedIndex();

            if (blockIndices.length == 0) {
                return ""
            }

            //Storing data in seperate array with indices in order to assert order due to async behaviour of loops
            let resultCache = Array(blockIndices.length - 1);
            for (let i = 0; i < blockIndices.length - 1; i++) {
                const currentBlockNumber = blockIndices[i];
                const currentBlockInfo = (this.compressedIndex)[currentBlockNumber];
                const currentBlockCompressedPosition = currentBlockInfo[COMPRESSED_POSITION];

                const nextBlockNumber = blockIndices[i + 1];
                let compressedBytes = [];
                if (nextBlockNumber != -1) {  //default : read current entire block only
                    const nextBlockInfo = (this.compressedIndex)[nextBlockNumber];
                    const nextBlockCompressedPosition = nextBlockInfo[COMPRESSED_POSITION];
                    const compressedLength = nextBlockCompressedPosition - currentBlockCompressedPosition;
                    compressedBytes = await igvxhr.loadArrayBuffer(this.file, buildOptions(this.config, {
                        range: {
                            start: currentBlockCompressedPosition,
                            size: compressedLength
                        }
                    }));
                } else {   // special case for query within final block: read until the end of the file
                    compressedBytes = await igvxhr.loadArrayBuffer(this.file, buildOptions(this.config, {
                        range: {
                            start: currentBlockCompressedPosition
                        }
                    }));
                }
                //now unzip the compressed bytes, and store them in the resultCache
                const uncompressedBytes = await unbgzf(compressedBytes);
                resultCache[i] = uncompressedBytes;
            }

            //Iterate over the result cache, create sequences from the data, and create a full sequence string from the data
            let result = "";
            for (let i = 0; i < resultCache.length; i++) {
                for (let j = 0; j < resultCache[i].length; j++) {
                    const c = String.fromCharCode(resultCache[i][j]);
                    result = result + c;
                }
            }

            //postprocess this data: because entire blocks are read we need to remove the first N bases of the first used block, 
            //which are not included in the original query positions
            const firstBlockInfo = (this.compressedIndex)[blockIndices[0]];
            const offset = startByte - firstBlockInfo[UNCOMPRESSED_POSITION];
            result = result.substring(offset);

            return result
        }


        async readSequence(chr, qstart, qend) {

            await this.getIndex();
            await this.getCompressedIndex(); //This will work even if no compressed index file is set

            const idxEntry = this.index[chr];
            if (!idxEntry) {
                console.log("No index entry for chr: " + chr);
                // Tag interval with null so we don't try again
                this.interval = new GenomicInterval(chr, qstart, qend, null);
                return null
            }

            const start = Math.max(0, qstart);    // qstart should never be < 0
            const end = Math.min(idxEntry.size, qend);
            const bytesPerLine = idxEntry.bytesPerLine;
            const basesPerLine = idxEntry.basesPerLine;
            const position = idxEntry.position;
            const nEndBytes = bytesPerLine - basesPerLine;
            const startLine = Math.floor(start / basesPerLine);
            const endLine = Math.floor(end / basesPerLine);
            const base0 = startLine * basesPerLine;   // Base at beginning of start line
            const offset = start - base0;
            const startByte = position + startLine * bytesPerLine + offset;
            const base1 = endLine * basesPerLine;
            const offset1 = end - base1;
            const endByte = position + endLine * bytesPerLine + offset1 - 1;
            const byteCount = endByte - startByte + 1;

            if (byteCount <= 0) {
                console.error("No sequence for " + chr + ":" + qstart + "-" + qend);
                return null
            }

            //If the compressed index file is set, then we are dealing with a compressed genome sequence
            //The selection of startByte/endByte is done for the non-compressed genome sequence.
            //These need to be 'converted' to the correct byte positions in the compressed genome sequence,
            //by making use of the compressed index (GZI file)
            let allBytes;
            if (!this.compressedIndexFile) {
                allBytes = await igvxhr.load(this.file, buildOptions(this.config, {
                    range: {
                        start: startByte,
                        size: byteCount
                    }
                }));
            } else {
                let relevantBlockIndices = await this.getRelevantCompressedBlockNumbers(startByte, endByte);
                if (relevantBlockIndices.length === 0) {
                    console.log("No blocks in the compressed index that correspond with the requested byte positions (" + startByte + "," + endByte + ")");
                    return null
                }
                allBytes = await this.loadAndUncompressBlocks(relevantBlockIndices, startByte);
            }

            if (!allBytes) {
                return null
            }

            let nBases,
                seqBytes = "",
                srcPos = 0,
                allBytesLength = allBytes.length;

            if (offset > 0) {
                nBases = Math.min(end - start, basesPerLine - offset);
                seqBytes += allBytes.substr(srcPos, nBases);
                srcPos += (nBases + nEndBytes);
            }

            while (srcPos < allBytesLength) {
                nBases = Math.min(basesPerLine, allBytesLength - srcPos);
                seqBytes += allBytes.substr(srcPos, nBases);
                srcPos += (nBases + nEndBytes);
            }

            return seqBytes

        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const splitLines$2 = splitLines$5;

    class ChromSizes {


        constructor(url) {
            this.url = url;
            this.chromosomeNames = [];
            this.chromosomes = {};
        }


        async init() {
            return this.loadAll()
        }

        async getSequence(chr, start, end) {

            return undefined // TODO -- return array of "N"s?
        }

        async loadAll() {

            let data;
            if (isDataURL(this.url)) {
                let bytes = decodeDataURI$1(this.fastaURL);
                data = "";
                for (let b of bytes) {
                    data += String.fromCharCode(b);
                }
            } else {
                data = await igvxhr.load(this.url, {});
            }


            this.chromosomeNames = [];
            this.chromosomes = {};

            const lines = splitLines$2(data);
            let order = 0;
            for (let nextLine of lines) {
                const tokens = nextLine.split('\t');
                this.chromosomeNames.push(tokens[0]);
                const chrLength = Number.parseInt(tokens[1]);
                const chromosome = new Chromosome(tokens[0], order++, chrLength);
                this.chromosomes[tokens[0]] = chromosome;

            }
        }

    }

    async function loadFasta(reference) {

        let fasta;
        if ("chromsizes" === reference.format) {
            fasta = new ChromSizes(reference.fastaURL);
        } else if (isDataURL(reference.fastaURL) || reference.indexed === false) {
            fasta = new NonIndexedFasta(reference);
        } else {
            fasta = new FastaSequence(reference);
        }
        await fasta.init();
        return fasta
    }

    const defaultNucleotideColors = {
        "A": "rgb(  0, 200,   0)",
        "C": "rgb(  0,0,200)",
        "T": "rgb(255,0,0)",
        "G": "rgb(209,113,  5)",
        "N": "rgb(80,80,80)"
    };

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const defaultSequenceTrackOrder = Number.MIN_SAFE_INTEGER;

    const translationDict = {
        'TTT': 'F',
        'TTC': 'F',
        'TTA': 'L',
        'TTG': 'L',
        'CTT': 'L',
        'CTC': 'L',
        'CTA': 'L',
        'CTG': 'L',
        'ATT': 'I',
        'ATC': 'I',
        'ATA': 'I',
        'ATG': 'M',
        'GTT': 'V',
        'GTC': 'V',
        'GTA': 'V',
        'GTG': 'V',
        'TCT': 'S',
        'TCC': 'S',
        'TCA': 'S',
        'TCG': 'S',
        'CCT': 'P',
        'CCC': 'P',
        'CCA': 'P',
        'CCG': 'P',
        'ACT': 'T',
        'ACC': 'T',
        'ACA': 'T',
        'ACG': 'T',
        'GCT': 'A',
        'GCC': 'A',
        'GCA': 'A',
        'GCG': 'A',
        'TAT': 'Y',
        'TAC': 'Y',
        'TAA': 'STOP',
        'TAG': 'STOP',
        'CAT': 'H',
        'CAC': 'H',
        'CAA': 'Q',
        'CAG': 'Q',
        'AAT': 'N',
        'AAC': 'N',
        'AAA': 'K',
        'AAG': 'K',
        'GAT': 'D',
        'GAC': 'D',
        'GAA': 'E',
        'GAG': 'E',
        'TGT': 'C',
        'TGC': 'C',
        'TGA': 'STOP',
        'TGG': 'W',
        'CGT': 'R',
        'CGC': 'R',
        'CGA': 'R',
        'CGG': 'R',
        'AGT': 'S',
        'AGC': 'S',
        'AGA': 'R',
        'AGG': 'R',
        'GGT': 'G',
        'GGC': 'G',
        'GGA': 'G',
        'GGG': 'G'
    };

    const complement = {};
    const t1 = ['A', 'G', 'C', 'T', 'Y', 'R', 'W', 'S', 'K', 'M', 'D', 'V', 'H', 'B', 'N', 'X'];
    const t2 = ['T', 'C', 'G', 'A', 'R', 'Y', 'W', 'S', 'M', 'K', 'H', 'B', 'D', 'V', 'N', 'X'];
    for (let i = 0; i < t1.length; i++) {
        complement[t1[i]] = t2[i];
        complement[t1[i].toLowerCase()] = t2[i].toLowerCase();
    }

    const DEFAULT_HEIGHT = 25;
    const TRANSLATED_HEIGHT = 115;
    const SEQUENCE_HEIGHT = 15;
    const FRAME_HEIGHT = 25;
    const FRAME_BORDER = 5;
    const BP_PER_PIXEL_THRESHOLD = 1 / 10;

    const bppFeatureFetchThreshold = 10;

    class SequenceTrack {

        constructor(config, browser) {

            this.config = config;
            this.browser = browser;
            this.type = "sequence";
            this.removable = config.removable === undefined ? true : config.removable;      // Defaults to true
            this.name = config.name;
            this.id = config.id;
            this.sequenceType = config.sequenceType || "dna";             //   dna | rna | prot
            this.disableButtons = false;
            this.order = config.order || defaultSequenceTrackOrder;
            this.ignoreTrackMenu = false;

            this.reversed = config.reversed === true;
            this.frameTranslate = config.frameTranslate === true;
            this.height = this.frameTranslate ? TRANSLATED_HEIGHT : DEFAULT_HEIGHT;

            // Hack for backward compatibility
            if(config.url) {
                config.fastaURL = config.url;
            }

            if(!config.fastaURL) {
                // Mark this as the genome reference sequence ==> backward compatibility convention
                this.id = config.id || "sequence";
            }

        }

        menuItemList() {
            return [
                {
                    name: this.reversed ? "Forward" : "Reverse",
                    click: () => {
                        this.reversed = !this.reversed;
                        this.trackView.repaintViews();
                    }
                },
                {
                    name: this.frameTranslate ? "Close Translation" : "Three-frame Translate",
                    click: () => {
                        this.frameTranslate = !this.frameTranslate;
                        if (this.frameTranslate) {
                            for (let vp of this.trackView.viewports) {
                                vp.setContentHeight(TRANSLATED_HEIGHT);
                            }
                            this.trackView.setTrackHeight(TRANSLATED_HEIGHT);
                        } else {
                            for (let vp of this.trackView.viewports) {
                                vp.setContentHeight(DEFAULT_HEIGHT);
                            }
                            this.trackView.setTrackHeight(DEFAULT_HEIGHT);
                        }
                        this.trackView.repaintViews();

                    }
                }
            ]
        }

        contextMenuItemList(clickState) {
            const viewport = clickState.viewport;
            if (viewport.referenceFrame.bpPerPixel <= 1) {
                const pixelWidth = viewport.getWidth();
                const bpWindow = pixelWidth * viewport.referenceFrame.bpPerPixel;
                const chr = viewport.referenceFrame.chr;
                const start = Math.floor(viewport.referenceFrame.start);
                const end = Math.ceil(start + bpWindow);
                const items = [
                    {
                        label: this.reversed ? 'View visible sequence (reversed)...' : 'View visible sequence...',
                        click: async () => {
                            let seq = await this.browser.genome.sequence.getSequence(chr, start, end);
                            if (!seq) {
                                seq = "Unknown sequence";
                            } else if (this.reversed) {
                                seq = reverseComplementSequence(seq);
                            }
                            this.browser.alert.present(seq);
                        }
                    }
                ];
                if (isSecureContext()) {
                    items.push({
                        label: 'Copy visible sequence',
                        click: async () => {
                            let seq = await this.browser.genome.sequence.getSequence(chr, start, end);
                            if (!seq) {
                                seq = "Unknown sequence";
                            } else if (this.reversed) {
                                seq = reverseComplementSequence(seq);
                            }
                            try {
                                await navigator.clipboard.writeText(seq);
                            } catch (e) {
                                console.error(e);
                                this.browser.alert.present(`error copying sequence to clipboard ${e}`);
                            }
                        }

                    });
                }
                items.push('<hr/>');

                return items
            } else {
                return undefined
            }
        }

        translateSequence(seq) {

            const threeFrame = [[], [], []];

            for (let fNum of [0, 1, 2]) {
                let idx = fNum;

                while ((seq.length - idx) >= 3) {
                    let st = seq.slice(idx, idx + 3);
                    if (this.reversed) {
                        st = st.split('').reverse().join('');
                    }

                    const aa = translationDict[st.toUpperCase()] || "";
                    threeFrame[fNum].push({
                        codons: st,
                        aminoA: aa
                    });
                    idx += 3;
                }
            }

            return threeFrame
        }

        /**
         * Return the source for sequence.  If an explicit fasta url is defined, use it, otherwise fetch sequence
         * from the current genome
         * *
         * @returns {Promise<WrappedFasta|*>}
         */
        async getSequenceSource() {
            if(this.config.fastaURL) {
                if(!this.fasta) {
                    this.fasta = new WrappedFasta(this.config, this.browser.genome);
                    await this.fasta.init();
                }
                return this.fasta
            } else {
                return this.browser.genome.sequence
            }
        }

        async getFeatures(chr, start, end, bpPerPixel) {

            start = Math.floor(start);
            end = Math.floor(end);

            if (bpPerPixel && bpPerPixel > bppFeatureFetchThreshold) {
                return null
            } else {
                const sequenceSource = await this.getSequenceSource();
                const sequence = await sequenceSource.getSequence(chr, start, end);
                return {
                    bpStart: start,
                    sequence: sequence
                }
            }
        }

        draw(options) {

            const ctx = options.context;

            if (options.features) {

                let sequence = options.features.sequence;
                if(!sequence) {
                    return
                }

                if (this.reversed) {
                    sequence = sequence.split('').map(function (cv) {
                        return complement[cv]
                    }).join('');
                }

                const sequenceBpStart = options.features.bpStart;  // genomic position at start of sequence
                const bpEnd = 1 + options.bpStart + (options.pixelWidth * options.bpPerPixel);

                for (let bp = Math.floor(options.bpStart); bp <= bpEnd; bp++) {

                    const seqIdx = Math.floor(bp - sequenceBpStart);

                    if (seqIdx >= 0 && seqIdx < sequence.length) {

                        const offsetBP = bp - options.bpStart;
                        const aPixel = offsetBP / options.bpPerPixel;
                        const pixelWidth = 1 / options.bpPerPixel;
                        const baseLetter = sequence[seqIdx];
                        const color = this.fillColor(baseLetter.toUpperCase());

                        if (options.bpPerPixel > BP_PER_PIXEL_THRESHOLD) {
                            IGVGraphics.fillRect(ctx, aPixel, FRAME_BORDER, pixelWidth, SEQUENCE_HEIGHT - FRAME_BORDER, {fillStyle: color});
                        } else {
                            const textPixel = aPixel + 0.5 * (pixelWidth - ctx.measureText(baseLetter).width);




                            if ('y' === options.axis) {
                                ctx.save();
                                IGVGraphics.labelTransformWithContext(ctx, textPixel);
                                IGVGraphics.strokeText(ctx, baseLetter, textPixel, SEQUENCE_HEIGHT, {strokeStyle: color});
                                ctx.restore();
                            } else {
                                IGVGraphics.strokeText(ctx, baseLetter, textPixel, SEQUENCE_HEIGHT, {strokeStyle: color});
                            }

                        }
                    }
                }

                if (this.frameTranslate) {

                    let y = SEQUENCE_HEIGHT + 2 * FRAME_BORDER;
                    const translatedSequence = this.translateSequence(sequence);

                    for (let fNum = 0; fNum < translatedSequence.length; fNum++) {    // == 3, 1 for each frame

                        const aaSequence = translatedSequence[fNum];  // AA sequence for this frame

                        for (let idx = 0; idx < aaSequence.length; idx++) {

                            let color = 0 === idx % 2 ? 'rgb(160,160,160)' : 'rgb(224,224,224)';
                            const cv = aaSequence[idx];

                            const bpPos = sequenceBpStart + fNum + (idx * 3);
                            const bpOffset = bpPos - options.bpStart;
                            const p0 = Math.floor(bpOffset / options.bpPerPixel);
                            const p1 = Math.floor((bpOffset + 3) / options.bpPerPixel);
                            const pc = Math.round((p0 + p1) / 2);

                            if (p1 < 0) {
                                continue   // off left edge
                            } else if (p0 > options.pixelWidth) {
                                break      // off right edge
                            }

                            let aaLabel = cv.aminoA;
                            if (cv.aminoA.indexOf('STOP') > -1) {
                                color = 'rgb(255, 0, 0)';
                                aaLabel = 'STOP'; //Color blind accessible
                            } else if (cv.aminoA === 'M') {
                                color = 'rgb(0, 153, 0)';
                                aaLabel = 'START'; //Color blind accessible
                            }

                            IGVGraphics.fillRect(ctx, p0, y, p1 - p0, FRAME_HEIGHT, {fillStyle: color});

                            if (options.bpPerPixel <= 1 / 10) {
                                IGVGraphics.strokeText(ctx, aaLabel, pc - (ctx.measureText(aaLabel).width / 2), y + 15);
                            }
                        }
                        y += (FRAME_HEIGHT + FRAME_BORDER);
                    }
                }
            }
        }

        get supportsWholeGenome() {
            return false
        }

        computePixelHeight(ignore) {
            this.height = this.frameTranslate ? TRANSLATED_HEIGHT : DEFAULT_HEIGHT;
            return this.height
        }

        fillColor(index) {

            if (this.color) {
                return this.color
            } else if ("dna" === this.sequenceType) {
                // return this.browser.nucleotideColors[index] || 'gray'
                return defaultNucleotideColors[index] || 'gray'
            } else {
                return 'rgb(0, 0, 150)'
            }
        }

        /**
         * Return the current state of the track.  Used to create sessions and bookmarks.
         *
         * @returns {*|{}}
         */
        getState() {
            const config = {
                type: "sequence"
            };
            if (this.order !== defaultSequenceTrackOrder) {
                config.order = this.order;
            }
            if (this.reversed) {
                config.revealed = true;
            }
            return config
        }

    }

    /**
     * Wrapper for a Fasta object that does chr name alias translation.   This is not neccessary for the genome fasta,
     * as it defines the reference name, but can be neccessary if loading an additional fasta as a track
     *
     */
    class WrappedFasta {

        constructor(config, genome) {
            this.config = config;
            this.genome = genome;
        }

        async init() {
            this.fasta = await loadFasta(this.config);
            this.chrNameMap = new Map();
            for(let name of this.fasta.chromosomeNames) {
                this.chrNameMap.set(this.genome.getChromosomeName(name), name);
            }
        }

        async getSequence(chr, start, end) {
            const chrName = this.chrNameMap.has(chr) ? this.chrNameMap.get(chr) : chr;
            return this.fasta.getSequence(chrName, start, end)
        }

    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class Viewport {

        constructor(trackView, viewportColumn, referenceFrame, width) {

            this.guid = domUtils.guid();
            this.trackView = trackView;
            this.referenceFrame = referenceFrame;

            this.browser = trackView.browser;

            this.$viewport = $$1('<div class="igv-viewport">');
            viewportColumn.appendChild(this.$viewport.get(0));

            if (trackView.track.height) {
                this.$viewport.get(0).style.height = `${trackView.track.height}px`;
            }

            // Create an alert dialog for the sequence track to copy ref sequence to.
            if (trackView.track instanceof SequenceTrack) {
                this.alert = new AlertDialog(this.$viewport.get(0));
            }

            this.contentTop = 0;
            this.contentHeight = this.$viewport.height();


            this.$viewport.width(width);

            this.initializationHelper();

        }

        initializationHelper() {

        }

        showMessage(message) {
            if (!this.messageDiv) {
                this.messageDiv = document.createElement('div');
                this.messageDiv.className = 'igv-viewport-message';
                //this.contentDiv.append(this.messageDiv)
                this.$viewport.append($$1(this.messageDiv));
            }
            this.messageDiv.textContent = message;
            this.messageDiv.style.display = 'inline-block';
        }

        hideMessage(message) {
            if (this.messageDiv)
                this.messageDiv.style.display = 'none';
        }

        setTrackLabel(label) {
        }

        startSpinner() {
        }

        stopSpinner() {
        }

        checkZoomIn() {
            return true
        }

        shift() {
        }

        setTop(contentTop) {

            this.contentTop = contentTop;
            this.$viewport.height();

            //this.$content.css('top', `${contentTop}px`)
            //
            // if (undefined === this.canvasVerticalRange || this.canvasVerticalRange.bottom < viewBottom || this.canvasVerticalRange.top > viewTop) {
            //     console.log("Repaint " + this.canvasVerticalRange)
            //    this.repaint()
            // }

        }

        async loadFeatures() {
            return undefined
        }

        clearCache() {

        }

        async repaint() {
        }

        draw(drawConfiguration, features, roiFeatures) {
            console.log('Viewport - draw(drawConfiguration, features, roiFeatures)');
        }

        checkContentHeight(features) {

            let track = this.trackView.track;
            features = features || this.cachedFeatures;
            if ("FILL" === track.displayMode) {
                this.setContentHeight(this.$viewport.height());
            } else if (typeof track.computePixelHeight === 'function') {
                if (features && features.length > 0) {
                    let requiredContentHeight = track.computePixelHeight(features);
                    //let currentContentHeight = this.$content.height()
                    let currentContentHeight = this.contentHeight;
                    if (requiredContentHeight !== currentContentHeight) {
                        this.setContentHeight(requiredContentHeight);
                    }
                }
            }
        }

        getContentHeight() {
            //return this.$content.height()
            return this.contentHeight
        }

        setContentHeight(contentHeight) {
           this.contentHeight = contentHeight;
        }

        isLoading() {
            return false
        }

        saveSVG() {

        }

        isVisible() {
            return this.$viewport.width()
        }

        setWidth(width) {
            this.$viewport.width(width);
        }

        getWidth() {
            return this.$viewport.width()
        }

        getContentTop() {
            return this.contentTop
        }

        containsPosition(chr, position) {
            console.log('Viewport - containsPosition(chr, position)');
        }

        addMouseHandlers() {
        }

        removeMouseHandlers() {
        }

        /**
         * Called when the associated track is removed.  Do any needed cleanup here.
         */
        dispose() {

            if (this.popover) {
                this.popover.dispose();
            }

            this.$viewport.get(0).remove();

            // Null out all properties -- this should not be neccessary, but just in case there is a
            // reference to self somewhere we want to free memory.
            for (let key of Object.keys(this)) {
                this[key] = undefined;
            }
        }

    }

    /*!!
     *  Canvas 2 Svg v1.0.19
     *  A low level canvas to SVG converter. Uses a mock canvas context to build an SVG document.
     *
     *  Licensed under the MIT license:
     *  http://www.opensource.org/licenses/mit-license.php
     *
     *  Author:
     *  Kerry Liu
     *
     *  Copyright (c) 2014 Gliffy Inc.
     */

    //helper function to format a string
    function format(str, args) {
        var keys = Object.keys(args), i;
        for (i = 0; i < keys.length; i++) {
            str = str.replace(new RegExp("\\{" + keys[i] + "\\}", "gi"), args[keys[i]]);
        }
        return str
    }

    //helper function that generates a random string
    function randomString(holder) {
        var chars, randomstring, i;
        if (!holder) {
            throw new Error("cannot create a random attribute name for an undefined object")
        }
        chars = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
        randomstring = "";
        do {
            randomstring = "";
            for (i = 0; i < 12; i++) {
                randomstring += chars[Math.floor(Math.random() * chars.length)];
            }
        } while (holder[randomstring])
        return randomstring
    }

    //helper function to map named to numbered entities
    function createNamedToNumberedLookup(items, radix) {
        var i, entity, lookup = {}, base10;
        items = items.split(',');
        radix = radix || 10;
        // Map from named to numbered entities.
        for (i = 0; i < items.length; i += 2) {
            entity = '&' + items[i + 1] + ';';
            base10 = parseInt(items[i], radix);
            lookup[entity] = '&#' + base10 + ';';
        }
        //FF and IE need to create a regex from hex values ie &nbsp; == \xa0
        lookup["\\xa0"] = '&#160;';
        return lookup
    }

    //helper function to map canvas-textAlign to svg-textAnchor
    function getTextAnchor(textAlign) {
        //TODO: support rtl languages
        var mapping = {"left": "start", "right": "end", "center": "middle", "start": "start", "end": "end"};
        return mapping[textAlign] || mapping.start
    }

    //helper function to map canvas-textBaseline to svg-dominantBaseline
    function getDominantBaseline(textBaseline) {
        //INFO: not supported in all browsers
        var mapping = {
            "alphabetic": "alphabetic",
            "hanging": "hanging",
            "top": "text-before-edge",
            "bottom": "text-after-edge",
            "middle": "central"
        };
        return mapping[textBaseline] || mapping.alphabetic
    }


    /**
     * Return a new normalized vector of given vector
     */
    function normalize(vector) {
        var len = Math.sqrt(vector[0] * vector[0] + vector[1] * vector[1]);
        return [vector[0] / len, vector[1] / len]
    }


    function intersectRect(rect1, rect2) {
        return (rect1.x < rect2.x + rect2.width &&
            rect1.x + rect1.width > rect2.x &&
            rect1.y < rect2.y + rect2.height &&
            rect1.y + rect1.height > rect2.y)
    }


    // Unpack entities lookup where the numbers are in radix 32 to reduce the size
    // entity mapping courtesy of tinymce
    const namedEntities = createNamedToNumberedLookup(
        '50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,' +
        '5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,' +
        '5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,' +
        '5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,' +
        '68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,' +
        '6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,' +
        '6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,' +
        '75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,' +
        '7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,' +
        '7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,' +
        'sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,' +
        'st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,' +
        't9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,' +
        'tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,' +
        'u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,' +
        '81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,' +
        '8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,' +
        '8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,' +
        '8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,' +
        '8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,' +
        'nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,' +
        'rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,' +
        'Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,' +
        '80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,' +
        '811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro', 32);


    //Some basic mappings for attributes and default values.
    const STYLES = {
        "strokeStyle": {
            svgAttr: "stroke", //corresponding svg attribute
            canvas: "#000000", //canvas default
            svg: "none",       //svg default
            apply: "stroke"    //apply on stroke() or fill()
        },
        "fillStyle": {
            svgAttr: "fill",
            canvas: "#000000",
            svg: null, //svg default is black, but we need to special case this to handle canvas stroke without fill
            apply: "fill"
        },
        "lineCap": {
            svgAttr: "stroke-linecap",
            canvas: "butt",
            svg: "butt",
            apply: "stroke"
        },
        "lineJoin": {
            svgAttr: "stroke-linejoin",
            canvas: "miter",
            svg: "miter",
            apply: "stroke"
        },
        "miterLimit": {
            svgAttr: "stroke-miterlimit",
            canvas: 10,
            svg: 4,
            apply: "stroke"
        },
        "lineWidth": {
            svgAttr: "stroke-width",
            canvas: 1,
            svg: 1,
            apply: "stroke"
        },
        "globalAlpha": {
            svgAttr: "opacity",
            canvas: 1,
            svg: 1,
            apply: "fill stroke"
        },
        "font": {
            //font converts to multiple svg attributes, there is custom logic for this
            canvas: "10px sans-serif"
        },
        "shadowColor": {
            canvas: "#000000"
        },
        "shadowOffsetX": {
            canvas: 0
        },
        "shadowOffsetY": {
            canvas: 0
        },
        "shadowBlur": {
            canvas: 0
        },
        "textAlign": {
            canvas: "start"
        },
        "textBaseline": {
            canvas: "alphabetic"
        },
        "lineDash": {
            svgAttr: "stroke-dasharray",
            canvas: [],
            svg: null,
            apply: "stroke"
        }
    };

    /**
     *
     * @param gradientNode - reference to the gradient
     * @constructor
     */
    class CanvasGradient {
        constructor(gradientNode, ctx) {
            this.__root = gradientNode;
            this.__ctx = ctx;
        }

        /**
         * Adds a color stop to the gradient root
         */
        addColorStop(offset, color) {
            var stop = this.__ctx.__createElement("stop"), regex, matches;
            stop.setAttribute("offset", offset);
            if (color && color.indexOf("rgba") !== -1) {
                //separate alpha value, since webkit can't handle it
                regex = /rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d?\.?\d*)\s*\)/gi;
                matches = regex.exec(color);
                stop.setAttribute("stop-color", format("rgb({r},{g},{b})", {r: matches[1], g: matches[2], b: matches[3]}));
                stop.setAttribute("stop-opacity", matches[4]);
            } else {
                stop.setAttribute("stop-color", color);
            }
            this.__root.appendChild(stop);
        }
    }

    class CanvasPattern {
        constructor(pattern, ctx) {
            this.__root = pattern;
            this.__ctx = ctx;
        }
    }

    /**
     * The mock canvas context
     * @param config - options include:
     * ctx - existing Context2D to wrap around
     * width - width of your canvas (defaults to 500)
     * height - height of your canvas (defaults to 500)
     * enableMirroring - enables canvas mirroring (get image data) (defaults to false)
     * document - the document object (defaults to the current document)
     */
    class ctx {
        constructor(config) {

            if (!(this instanceof ctx)) {
                //did someone call this without new?
                return new ctx(config)
            }

            // clone config
            this.config = config;

            //setup options
            this.width = config.width;
            this.height = config.height;
            this.enableMirroring = config.enableMirroring || false;

            this.canvas = this;   ///point back to this instance!
            this.__document = document;

            // allow passing in an existing context to wrap around
            // if a context is passed in, we know a canvas already exist
            if (config.ctx) {
                this.__ctx = config.ctx;
            } else {
                this.__canvas = this.__document.createElement("canvas");
                this.__ctx = this.__canvas.getContext("2d");
            }

            // give this canvas a type
            this.isSVG = true;

            this.__setDefaultStyles();
            this.__stack = [this.__getStyleState()];
            this.__groupStack = [];

            // root svg element
            this.__root = this.__createElement("svg");
            this.__root.setAttribute("width", this.width);
            this.__root.setAttribute("height", this.height);

            // allow contents to overflow svg bbox
            this.__root.setAttribute('overflow', 'visible');

            // viewbox
            if (config.viewbox) {
                const str = config.viewbox.x + ' ' + config.viewbox.y + ' ' + config.viewbox.width + ' ' + config.viewbox.height;
                this.__root.setAttribute("viewBox", str);

                this.viewbox = config.viewbox;
            }

            // make sure we don't generate the same ids in defs
            this.__ids = {};

            // defs
            this.__defs = this.__createElement("defs");
            this.__root.appendChild(this.__defs);

            this.multiLocusGap = config.multiLocusGap;

            // svg background color
            let backdropConfig =
                {
                    id: 'svg_output_backdrop',
                    width: '100%',
                    height: '100%',
                    fill: config.backdropColor || 'white'
                };

            let backdropRect = this.__createElement('rect', backdropConfig);
            this.__root.appendChild(backdropRect);

            // root group
            this.__rootGroup = this.__createElement('g', {id: 'root-group'});
            this.__root.appendChild(this.__rootGroup);

            // point current element to root group
            this.__currentElement = this.__rootGroup;
        }

        setWidth(width) {

            this.width = width;
            this.__root.setAttribute("width", this.width);

            const str = this.config.viewbox.x + ' ' + this.config.viewbox.y + ' ' + width + ' ' + this.config.viewbox.height;
            this.__root.setAttribute("viewBox", str);

        };

        setHeight(height) {

            this.height = height;
            this.__root.setAttribute("height", this.height);

            const str = this.config.viewbox.x + ' ' + this.config.viewbox.y + ' ' + this.config.viewbox.width + ' ' + height;
            this.__root.setAttribute("viewBox", str);

        };

        /**
         * Creates the specified svg element
         * @private
         */
        __createElement(elementName, properties, resetFill) {

            if (typeof properties === "undefined") {
                properties = {};
            }

            let element = this.__document.createElementNS("http://www.w3.org/2000/svg", elementName);

            if (resetFill) {
                //if fill or stroke is not specified, the svg element should not display. By default SVG's fill is black.
                element.setAttribute("fill", "none");
                element.setAttribute("stroke", "none");
            }

            for (let key of Object.keys(properties)) {
                element.setAttribute(key, properties[key]);
            }

            return element
        };

        /**
         * Applies default canvas styles to the context
         * @private
         */
        __setDefaultStyles() {
            //default 2d canvas context properties see:http://www.w3.org/TR/2dcontext/
            var keys = Object.keys(STYLES), i, key;
            for (i = 0; i < keys.length; i++) {
                key = keys[i];
                this[key] = STYLES[key].canvas;
            }
        };

        /**
         * Applies styles on restore
         * @param styleState
         * @private
         */
        __applyStyleState(styleState) {
            var keys = Object.keys(styleState), i, key;
            for (i = 0; i < keys.length; i++) {
                key = keys[i];
                this[key] = styleState[key];
            }
        };

        /**
         * Gets the current style state
         * @return {Object}
         * @private
         */
        __getStyleState() {
            var i, styleState = {}, keys = Object.keys(STYLES), key;
            for (i = 0; i < keys.length; i++) {
                key = keys[i];
                styleState[key] = this[key];
            }
            return styleState
        };

        /**
         * Apples the current styles to the current SVG element. On "ctx.fill" or "ctx.stroke"
         * @param type
         * @private
         */
        __applyStyleToCurrentElement(type) {
            var currentElement = this.__currentElement;
            var currentStyleGroup = this.__currentElementsToStyle;
            if (currentStyleGroup) {
                currentElement.setAttribute(type, "");
                currentElement = currentStyleGroup.element;
                currentStyleGroup.children.forEach(function (node) {
                    node.setAttribute(type, "");
                });
            }

            var keys = Object.keys(STYLES), i, style, value, id, regex, matches;
            for (i = 0; i < keys.length; i++) {
                style = STYLES[keys[i]];
                value = this[keys[i]];
                if (style.apply) {
                    //is this a gradient or pattern?
                    if (value instanceof CanvasPattern) {
                        //pattern
                        if (value.__ctx) {
                            //copy over defs
                            while (value.__ctx.__defs.childNodes.length) {
                                id = value.__ctx.__defs.childNodes[0].getAttribute("id");
                                this.__ids[id] = id;
                                this.__defs.appendChild(value.__ctx.__defs.childNodes[0]);
                            }
                        }
                        currentElement.setAttribute(style.apply, format("url(#{id})", {id: value.__root.getAttribute("id")}));
                    } else if (value instanceof CanvasGradient) {
                        //gradient
                        currentElement.setAttribute(style.apply, format("url(#{id})", {id: value.__root.getAttribute("id")}));
                    } else if (style && style.apply.indexOf(type) !== -1 && style.svg !== value) {
                        if ((style.svgAttr === "stroke" || style.svgAttr === "fill") && value && value.indexOf("rgba") !== -1) {
                            //separate alpha value, since illustrator can't handle it
                            regex = /rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d?\.?\d*)\s*\)/gi;
                            matches = regex.exec(value);
                            currentElement.setAttribute(style.svgAttr, format("rgb({r},{g},{b})", {
                                r: matches[1],
                                g: matches[2],
                                b: matches[3]
                            }));
                            //should take globalAlpha here
                            var opacity = matches[4];
                            var globalAlpha = this.globalAlpha;
                            if (globalAlpha != null) {
                                opacity *= globalAlpha;
                            }
                            currentElement.setAttribute(style.svgAttr + "-opacity", opacity);
                        } else {
                            var attr = style.svgAttr;
                            if (keys[i] === 'globalAlpha') {
                                attr = type + '-' + style.svgAttr;
                                if (currentElement.getAttribute(attr)) {
                                    //fill-opacity or stroke-opacity has already been set by stroke or fill.
                                    continue
                                }
                            }
                            //otherwise only update attribute if right type, and not svg default
                            currentElement.setAttribute(attr, value);
                        }
                    }
                }
            }
        };

        /**
         * Will return the closest group or svg node. May return the current element.
         * @private
         */
        __closestGroupOrSvg(node) {
            node = node || this.__currentElement;
            if (node.nodeName === "g" || node.nodeName === "svg") {
                return node
            } else {
                return this.__closestGroupOrSvg(node.parentNode)
            }
        };

        /**
         * Returns the serialized value of the svg so far
         * @param fixNamedEntities - Standalone SVG doesn't support named entities, which document.createTextNode encodes.
         *                           If true, we attempt to find all named entities and encode it as a numeric entity.
         * @return serialized svg
         */
        getSerializedSvg(fixNamedEntities) {
            var serialized = new XMLSerializer().serializeToString(this.__root),
                keys, i, key, value, regexp;

            //IE search for a duplicate xmnls because they didn't implement setAttributeNS correctly
            // xmlns = /xmlns="http:\/\/www\.w3\.org\/2000\/svg".+xmlns="http:\/\/www\.w3\.org\/2000\/svg/gi;
            // if (xmlns.test(serialized)) {
            //     serialized = serialized.replace('xmlns="http://www.w3.org/2000/svg','xmlns:xlink="http://www.w3.org/1999/xlink');
            // }

            if (fixNamedEntities) {
                keys = Object.keys(namedEntities);
                //loop over each named entity and replace with the proper equivalent.
                for (i = 0; i < keys.length; i++) {
                    key = keys[i];
                    value = namedEntities[key];
                    regexp = new RegExp(key, "gi");
                    if (regexp.test(serialized)) {
                        serialized = serialized.replace(regexp, value);
                    }
                }
            }

            return serialized
        };


        /**
         * Returns the root svg
         * @return
         */
        getSvg() {
            return this.__root
        };

        /**
         * Will generate a group tag.
         */
        saveWithTranslationAndClipRect(id, tx, ty, width, height, clipYOffset) {

            // clip rect
            const clip_id = `${id}_clip_rect`;
            let clipPath = this.__createElement('clipPath', {id: clip_id});

            this.__defs.appendChild(clipPath);

            const config =
                {
                    x: '0',
                    y: clipYOffset.toString(),
                    width: width.toString(),
                    height: height.toString()
                };

            clipPath.appendChild(this.__createElement('rect', config));

            const group = this.__createElement("g");
            group.setAttribute('transform', format('translate({x},{y})', {x: tx, y: ty}));
            group.setAttribute('clip-path', format('url(#{id})', {id: clip_id}));

            const parent = this.__closestGroupOrSvg();
            parent.appendChild(group);
            this.__groupStack.push(parent);

            this.__currentElement = group;
            this.__stack.push(this.__getStyleState());
        };

        save() {
            var group = this.__createElement("g");
            var parent = this.__closestGroupOrSvg();
            this.__groupStack.push(parent);
            parent.appendChild(group);
            this.__currentElement = group;
            this.__stack.push(this.__getStyleState());
        };

        /**
         * Sets current element to parent, or just root if already root
         */
        restore() {
            this.__currentElement = this.__groupStack.pop();
            this.__currentElementsToStyle = null;
            //Clearing canvas will make the poped group invalid, currentElement is set to the root group node.
            if (!this.__currentElement) {
                this.__currentElement = this.__root.childNodes[1];
            }
            var state = this.__stack.pop();
            this.__applyStyleState(state);
        };

        /**
         * Helper method to add transform
         * @private
         */
        __addTransform(t) {
            //if the current element has siblings, add another group
            var parent = this.__closestGroupOrSvg();
            if (parent.childNodes.length > 0) {
                if (this.__currentElement.nodeName === "path") {
                    if (!this.__currentElementsToStyle) this.__currentElementsToStyle = {element: parent, children: []};
                    this.__currentElementsToStyle.children.push(this.__currentElement);
                    this.__applyCurrentDefaultPath();
                }

                var group = this.__createElement("g");
                parent.appendChild(group);
                this.__currentElement = group;
            }

            var transform = this.__currentElement.getAttribute("transform");
            if (transform) {
                transform += " ";
            } else {
                transform = "";
            }
            transform += t;
            this.__currentElement.setAttribute("transform", transform);
        };

        addTrackGroupWithTranslationAndClipRect(id, tx, ty, width, height, clipYOffset) {

            // clip rect
            const clip_id = id + '_clip_rect';
            let clipPath = this.__createElement('clipPath', {id: clip_id});

            this.__defs.appendChild(clipPath);
            clipPath.appendChild(this.__createElement('rect', {
                x: '0',
                y: clipYOffset.toString(),
                width: width.toString(),
                height: height.toString()
            }));

            let group = this.__createElement('g');
            this.__rootGroup.appendChild(group);

            group.setAttribute('transform', format('translate({x},{y})', {x: tx, y: ty}));
            group.setAttribute('id', (id + '_group'));

            // add clip rect
            group.setAttribute('clip-path', format('url(#{id})', {id: clip_id}));

            this.__currentElement = group;
        };

        /**
         *  scales the current element
         */
        scale(x, y) {
            if (y === undefined) {
                y = x;
            }
            this.__addTransform(format("scale({x},{y})", {x: x, y: y}));
        };

        /**
         * rotates the current element
         */
        rotate(angle) {
            var degrees = (angle * 180 / Math.PI);
            this.__addTransform(format("rotate({angle},{cx},{cy})", {angle: degrees, cx: 0, cy: 0}));
        };

        /**
         * translates the current element
         */
        translate(x, y) {
            this.__addTransform(format("translate({x},{y})", {x: x, y: y}));
        };

        /**
         * applies a transform to the current element
         */
        transform(a, b, c, d, e, f) {
            this.__addTransform(format("matrix({a},{b},{c},{d},{e},{f})", {a: a, b: b, c: c, d: d, e: e, f: f}));
        };

        /**
         * Create a new Path Element
         */
        beginPath() {
            var path, parent;

            // Note that there is only one current default path, it is not part of the drawing state.
            // See also: https://html.spec.whatwg.org/multipage/scripting.html#current-default-path
            this.__currentDefaultPath = "";
            this.__currentPosition = {};

            path = this.__createElement("path", {}, true);
            parent = this.__closestGroupOrSvg();
            parent.appendChild(path);
            this.__currentElement = path;
        };

        /**
         * Helper function to apply currentDefaultPath to current path element
         * @private
         */
        __applyCurrentDefaultPath() {
            var currentElement = this.__currentElement;
            if (currentElement.nodeName === "path") {
                currentElement.setAttribute("d", this.__currentDefaultPath);
            } else {
                console.error("Attempted to apply path command to node", currentElement.nodeName);
            }
        };

        /**
         * Helper function to add path command
         * @private
         */
        __addPathCommand(command) {
            this.__currentDefaultPath += " ";
            this.__currentDefaultPath += command;
        };

        /**
         * Adds the move command to the current path element,
         * if the currentPathElement is not empty create a new path element
         */
        moveTo(x, y) {
            if (this.__currentElement.nodeName !== "path") {
                this.beginPath();
            }

            // creates a new subpath with the given point
            this.__currentPosition = {x: x, y: y};
            this.__addPathCommand(format("M {x} {y}", {x: x, y: y}));
        };

        /**
         * Closes the current path
         */
        closePath() {
            if (this.__currentDefaultPath) {
                this.__addPathCommand("Z");
            }
        };

        /**
         * Adds a line to command
         */
        lineTo(x, y) {
            this.__currentPosition = {x: x, y: y};
            if (this.__currentDefaultPath && this.__currentDefaultPath.indexOf('M') > -1) {
                this.__addPathCommand(format("L {x} {y}", {x: x, y: y}));
            } else {
                this.__addPathCommand(format("M {x} {y}", {x: x, y: y}));
            }
        };

        /**
         * Add a bezier command
         */
        bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
            this.__currentPosition = {x: x, y: y};
            this.__addPathCommand(format("C {cp1x} {cp1y} {cp2x} {cp2y} {x} {y}",
                {cp1x: cp1x, cp1y: cp1y, cp2x: cp2x, cp2y: cp2y, x: x, y: y}));
        };

        /**
         * Adds a quadratic curve to command
         */
        quadraticCurveTo(cpx, cpy, x, y) {
            this.__currentPosition = {x: x, y: y};
            this.__addPathCommand(format("Q {cpx} {cpy} {x} {y}", {cpx: cpx, cpy: cpy, x: x, y: y}));
        };

        /**
         * Adds the arcTo to the current path
         *
         * @see http://www.w3.org/TR/2015/WD-2dcontext-20150514/#dom-context-2d-arcto
         */
        arcTo(x1, y1, x2, y2, radius) {
            // Let the point (x0, y0) be the last point in the subpath.
            var x0 = this.__currentPosition && this.__currentPosition.x;
            var y0 = this.__currentPosition && this.__currentPosition.y;

            // First ensure there is a subpath for (x1, y1).
            if (typeof x0 == "undefined" || typeof y0 == "undefined") {
                return
            }

            // Negative values for radius must cause the implementation to throw an IndexSizeError exception.
            if (radius < 0) {
                throw new Error("IndexSizeError: The radius provided (" + radius + ") is negative.")
            }

            // If the point (x0, y0) is equal to the point (x1, y1),
            // or if the point (x1, y1) is equal to the point (x2, y2),
            // or if the radius radius is zero,
            // then the method must add the point (x1, y1) to the subpath,
            // and connect that point to the previous point (x0, y0) by a straight line.
            if (((x0 === x1) && (y0 === y1))
                || ((x1 === x2) && (y1 === y2))
                || (radius === 0)) {
                this.lineTo(x1, y1);
                return
            }

            // Otherwise, if the points (x0, y0), (x1, y1), and (x2, y2) all lie on a single straight line,
            // then the method must add the point (x1, y1) to the subpath,
            // and connect that point to the previous point (x0, y0) by a straight line.
            var unit_vec_p1_p0 = normalize([x0 - x1, y0 - y1]);
            var unit_vec_p1_p2 = normalize([x2 - x1, y2 - y1]);
            if (unit_vec_p1_p0[0] * unit_vec_p1_p2[1] === unit_vec_p1_p0[1] * unit_vec_p1_p2[0]) {
                this.lineTo(x1, y1);
                return
            }

            // Otherwise, let The Arc be the shortest arc given by circumference of the circle that has radius radius,
            // and that has one point tangent to the half-infinite line that crosses the point (x0, y0) and ends at the point (x1, y1),
            // and that has a different point tangent to the half-infinite line that ends at the point (x1, y1), and crosses the point (x2, y2).
            // The points at which this circle touches these two lines are called the start and end tangent points respectively.

            // note that both vectors are unit vectors, so the length is 1
            var cos = (unit_vec_p1_p0[0] * unit_vec_p1_p2[0] + unit_vec_p1_p0[1] * unit_vec_p1_p2[1]);
            var theta = Math.acos(Math.abs(cos));

            // Calculate origin
            var unit_vec_p1_origin = normalize([
                unit_vec_p1_p0[0] + unit_vec_p1_p2[0],
                unit_vec_p1_p0[1] + unit_vec_p1_p2[1]
            ]);
            var len_p1_origin = radius / Math.sin(theta / 2);
            var x = x1 + len_p1_origin * unit_vec_p1_origin[0];
            var y = y1 + len_p1_origin * unit_vec_p1_origin[1];

            // Calculate start angle and end angle
            // rotate 90deg clockwise (note that y axis points to its down)
            var unit_vec_origin_start_tangent = [
                -unit_vec_p1_p0[1],
                unit_vec_p1_p0[0]
            ];
            // rotate 90deg counter clockwise (note that y axis points to its down)
            var unit_vec_origin_end_tangent = [
                unit_vec_p1_p2[1],
                -unit_vec_p1_p2[0]
            ];
            var getAngle = function (vector) {
                // get angle (clockwise) between vector and (1, 0)
                var x = vector[0];
                var y = vector[1];
                if (y >= 0) { // note that y axis points to its down
                    return Math.acos(x)
                } else {
                    return -Math.acos(x)
                }
            };
            var startAngle = getAngle(unit_vec_origin_start_tangent);
            var endAngle = getAngle(unit_vec_origin_end_tangent);

            // Connect the point (x0, y0) to the start tangent point by a straight line
            this.lineTo(x + unit_vec_origin_start_tangent[0] * radius,
                y + unit_vec_origin_start_tangent[1] * radius);

            // Connect the start tangent point to the end tangent point by arc
            // and adding the end tangent point to the subpath.
            this.arc(x, y, radius, startAngle, endAngle);
        };

        /**
         * Sets the stroke property on the current element
         */
        stroke() {
            if (this.__currentElement.nodeName === "path") {
                this.__currentElement.setAttribute("paint-order", "fill stroke markers");
            }
            this.__applyCurrentDefaultPath();
            this.__applyStyleToCurrentElement("stroke");
        };

        /**
         * Sets fill properties on the current element
         */
        fill() {
            if (this.__currentElement.nodeName === "path") {
                this.__currentElement.setAttribute("paint-order", "stroke fill markers");
            }
            this.__applyCurrentDefaultPath();
            this.__applyStyleToCurrentElement("fill");
        };

        /**
         *  Adds a rectangle to the path.
         */
        rect(x, y, width, height) {
            if (this.__currentElement.nodeName !== "path") {
                this.beginPath();
            }
            this.moveTo(x, y);
            this.lineTo(x + width, y);
            this.lineTo(x + width, y + height);
            this.lineTo(x, y + height);
            this.lineTo(x, y);
            this.closePath();
        };


        /**
         * adds a rectangle element
         */
        fillRect(x, y, width, height) {

            if (height < 0) {
                y += height;
                height = -height;
            }
            if (width < 0) {
                x += width;
                width = -width;
            }
            // See if rect intersects current viewbox
            var r2 = {
                x: x,
                y: y,
                width: width,
                height: height
            };

            if (this.viewbox) {
                if (!intersectRect(this.viewbox, r2)) {
                    return
                }
            }

            var rect, parent;
            rect = this.__createElement("rect", r2, true);
            parent = this.__closestGroupOrSvg();
            parent.appendChild(rect);
            this.__currentElement = rect;
            this.__applyStyleToCurrentElement("fill");
        };

        /**
         * Draws a rectangle with no fill
         * @param x
         * @param y
         * @param width
         * @param height
         */
        strokeRect(x, y, width, height) {
            var rect, parent;
            rect = this.__createElement("rect", {
                x: x,
                y: y,
                width: width,
                height: height
            }, true);
            parent = this.__closestGroupOrSvg();
            parent.appendChild(rect);
            this.__currentElement = rect;
            this.__applyStyleToCurrentElement("stroke");
        };

        // stroke ellipse
        strokeEllipse(cx, cy, rx, ry, rotation, startAngle, endAngle, isCCW) {
            this.__ellipse(cx, cy, rx, ry, rotation, startAngle, endAngle, isCCW, 'stroke');
        }

        // fill ellipse
        fillEllipse(cx, cy, rx, ry, rotation, startAngle, endAngle, isCCW) {
            this.__ellipse(cx, cy, rx, ry, rotation, startAngle, endAngle, isCCW, 'fill');
        }

        // ellipse helper
        __ellipse(cx, cy, rx, ry, rotation, startAngle, endAngle, isCCW, style) {

            const config =
                {
                    cx,
                    cy,
                    rx,
                    ry
                };
            const element = this.__createElement('ellipse', config, true);
            const parent = this.__closestGroupOrSvg();
            parent.appendChild(element);
            this.__currentElement = element;
            this.__applyStyleToCurrentElement(style);
        }

        /**
         * Clear entire canvas:
         * 1. save current transforms
         * 2. remove all the childNodes of the root g element
         */
        __clearCanvas() {
            var current = this.__closestGroupOrSvg(),
                transform = current.getAttribute("transform");
            var rootGroup = this.__root.childNodes[1];
            var childNodes = rootGroup.childNodes;
            for (var i = childNodes.length - 1; i >= 0; i--) {
                if (childNodes[i]) {
                    rootGroup.removeChild(childNodes[i]);
                }
            }
            this.__currentElement = rootGroup;
            //reset __groupStack as all the child group nodes are all removed.
            this.__groupStack = [];
            if (transform) {
                this.__addTransform(transform);
            }
        };

        /**
         * "Clears" a canvas by just drawing a white rectangle in the current group.
         */
        clearRect(x, y, width, height) {
            //clear entire canvas
            if (x === 0 && y === 0 && width === this.width && height === this.height) {
                this.__clearCanvas();
                return
            }
            var rect, parent = this.__closestGroupOrSvg();
            rect = this.__createElement("rect", {
                x: x,
                y: y,
                width: width,
                height: height,
                fill: "#FFFFFF"
            }, true);
            parent.appendChild(rect);
        };

        /**
         * Adds a linear gradient to a defs tag.
         * Returns a canvas gradient object that has a reference to it's parent def
         */
        createLinearGradient(x1, y1, x2, y2) {
            var grad = this.__createElement("linearGradient", {
                id: randomString(this.__ids),
                x1: x1 + "px",
                x2: x2 + "px",
                y1: y1 + "px",
                y2: y2 + "px",
                "gradientUnits": "userSpaceOnUse"
            }, false);
            this.__defs.appendChild(grad);
            return new CanvasGradient(grad, this)
        };

        /**
         * Adds a radial gradient to a defs tag.
         * Returns a canvas gradient object that has a reference to it's parent def
         */
        createRadialGradient(x0, y0, r0, x1, y1, r1) {
            var grad = this.__createElement("radialGradient", {
                id: randomString(this.__ids),
                cx: x1 + "px",
                cy: y1 + "px",
                r: r1 + "px",
                fx: x0 + "px",
                fy: y0 + "px",
                "gradientUnits": "userSpaceOnUse"
            }, false);
            this.__defs.appendChild(grad);
            return new CanvasGradient(grad, this)

        };

        /**
         * Parses the font string and returns svg mapping
         * @private
         */
        __parseFont() {
            var regex = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-,\'\"\sa-z0-9]+?)\s*$/i;
            var fontPart = regex.exec(this.font);
            var data = {
                style: fontPart[1] || 'normal',
                size: fontPart[4] || '10px',
                family: fontPart[6] || 'sans-serif',
                weight: fontPart[3] || 'normal',
                decoration: fontPart[2] || 'normal',
                href: null
            };

            //canvas doesn't support underline natively, but we can pass this attribute
            if (this.__fontUnderline === "underline") {
                data.decoration = "underline";
            }

            //canvas also doesn't support linking, but we can pass this as well
            if (this.__fontHref) {
                data.href = this.__fontHref;
            }

            return data
        };

        /**
         * Helper to link text fragments
         * @param font
         * @param element
         * @return {*}
         * @private
         */
        __wrapTextLink(font, element) {
            if (font.href) {
                var a = this.__createElement("a");
                a.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", font.href);
                a.appendChild(element);
                return a
            }
            return element
        };

        /**
         * Fills or strokes text
         * @param text
         * @param x
         * @param y
         * @param action - stroke or fill
         * @private
         */
        __applyText(text, x, y, action) {
            var font = this.__parseFont(),
                parent = this.__closestGroupOrSvg(),
                textElement = this.__createElement("text", {
                    "font-family": font.family,
                    "font-size": font.size,
                    "font-style": font.style,
                    "font-weight": font.weight,
                    "text-decoration": font.decoration,
                    "x": x,
                    "y": y,
                    "text-anchor": getTextAnchor(this.textAlign),
                    "dominant-baseline": getDominantBaseline(this.textBaseline)
                }, true);

            textElement.appendChild(this.__document.createTextNode(text));
            this.__currentElement = textElement;
            this.__applyStyleToCurrentElement(action);
            parent.appendChild(this.__wrapTextLink(font, textElement));
        };

        /**
         * Creates a text element
         * @param text
         * @param x
         * @param y
         */
        fillText(text, x, y) {
            this.__applyText(text, x, y, "fill");
        };

        /**
         * Strokes text
         * @param text
         * @param x
         * @param y
         */
        strokeText(text, x, y) {
            this.__applyText(text, x, y, "stroke");
        };

        /**
         * No need to implement this for svg.
         * @param text
         * @return {TextMetrics}
         */
        measureText(text) {
            this.__ctx.font = this.font;
            return this.__ctx.measureText(text)
        };

        /**
         *  Arc command!
         */
        arc(x, y, radius, startAngle, endAngle, counterClockwise) {
            // in canvas no circle is drawn if no angle is provided.
            if (startAngle === endAngle) {
                return
            }
            startAngle = startAngle % (2 * Math.PI);
            endAngle = endAngle % (2 * Math.PI);
            if (startAngle === endAngle) {
                //circle time! subtract some of the angle so svg is happy (svg elliptical arc can't draw a full circle)
                endAngle = ((endAngle + (2 * Math.PI)) - 0.001 * (counterClockwise ? -1 : 1)) % (2 * Math.PI);
            }
            var endX = x + radius * Math.cos(endAngle),
                endY = y + radius * Math.sin(endAngle),
                startX = x + radius * Math.cos(startAngle),
                startY = y + radius * Math.sin(startAngle),
                sweepFlag = counterClockwise ? 0 : 1,
                largeArcFlag = 0,
                diff = endAngle - startAngle;

            // https://github.com/gliffy/canvas2svg/issues/4
            if (diff < 0) {
                diff += 2 * Math.PI;
            }

            if (counterClockwise) {
                largeArcFlag = diff > Math.PI ? 0 : 1;
            } else {
                largeArcFlag = diff > Math.PI ? 1 : 0;
            }

            this.lineTo(startX, startY);
            this.__addPathCommand(format("A {rx} {ry} {xAxisRotation} {largeArcFlag} {sweepFlag} {endX} {endY}",
                {
                    rx: radius,
                    ry: radius,
                    xAxisRotation: 0,
                    largeArcFlag: largeArcFlag,
                    sweepFlag: sweepFlag,
                    endX: endX,
                    endY: endY
                }));

            this.__currentPosition = {x: endX, y: endY};
        };

        /**
         * The ellipse() method creates an elliptical arc centered at (x, y) with the radii radiusX and radiusY. The path
         * starts at startAngle and ends at endAngle, and travels in the direction given by counterclockwise (defaulting to clockwise).
         */
    // ellipse (x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise) {
    //     // TODO -- implement
    // }

        /**
         * Generates a ClipPath from the clip command.
         */
        clip() {
            var group = this.__closestGroupOrSvg(),
                clipPath = this.__createElement("clipPath"),
                id = randomString(this.__ids),
                newGroup = this.__createElement("g");

            this.__applyCurrentDefaultPath();
            group.removeChild(this.__currentElement);
            clipPath.setAttribute("id", id);
            clipPath.appendChild(this.__currentElement);

            this.__defs.appendChild(clipPath);

            //set the clip path to this group
            group.setAttribute("clip-path", format("url(#{id})", {id: id}));

            //clip paths can be scaled and transformed, we need to add another wrapper group to avoid later transformations
            // to this path
            group.appendChild(newGroup);

            this.__currentElement = newGroup;

        };

        /**
         * Draws a canvas, image or mock context to this canvas.
         * Note that all svg dom manipulation uses node.childNodes rather than node.children for IE support.
         * http://www.whatwg.org/specs/web-apps/current-work/multipage/the-canvas-element.html#dom-context-2d-drawimage
         */
        drawImage() {
            //convert arguments to a real array
            var args = Array.prototype.slice.call(arguments),
                image = args[0],
                dx, dy, dw, dh, sx = 0, sy = 0, sw, sh, parent, svg, defs, group,
                svgImage, canvas, context, id;

            if (args.length === 3) {
                dx = args[1];
                dy = args[2];
                sw = image.width;
                sh = image.height;
                dw = sw;
                dh = sh;
            } else if (args.length === 5) {
                dx = args[1];
                dy = args[2];
                dw = args[3];
                dh = args[4];
                sw = image.width;
                sh = image.height;
            } else if (args.length === 9) {
                sx = args[1];
                sy = args[2];
                sw = args[3];
                sh = args[4];
                dx = args[5];
                dy = args[6];
                dw = args[7];
                dh = args[8];
            } else {
                throw new Error("Invalid number of arguments passed to drawImage: " + arguments.length)
            }

            parent = this.__closestGroupOrSvg();
            this.__currentElement;
            var translateDirective = "translate(" + dx + ", " + dy + ")";
            if (image instanceof ctx) {
                //canvas2svg mock canvas context. In the future we may want to clone nodes instead.
                //also I'm currently ignoring dw, dh, sw, sh, sx, sy for a mock context.
                svg = image.getSvg().cloneNode(true);
                if (svg.childNodes && svg.childNodes.length > 1) {
                    defs = svg.childNodes[0];
                    while (defs.childNodes.length) {
                        id = defs.childNodes[0].getAttribute("id");
                        this.__ids[id] = id;
                        this.__defs.appendChild(defs.childNodes[0]);
                    }
                    group = svg.childNodes[1];
                    if (group) {
                        //save original transform
                        var originTransform = group.getAttribute("transform");
                        var transformDirective;
                        if (originTransform) {
                            transformDirective = originTransform + " " + translateDirective;
                        } else {
                            transformDirective = translateDirective;
                        }
                        group.setAttribute("transform", transformDirective);
                        parent.appendChild(group);
                    }
                }
            } else if (image.nodeName === "CANVAS" || image.nodeName === "IMG") {
                //canvas or image
                svgImage = this.__createElement("image");
                svgImage.setAttribute("width", dw);
                svgImage.setAttribute("height", dh);
                svgImage.setAttribute("preserveAspectRatio", "none");

                if (sx || sy || sw !== image.width || sh !== image.height) {
                    //crop the image using a temporary canvas
                    canvas = this.__document.createElement("canvas");
                    canvas.width = dw;
                    canvas.height = dh;
                    context = canvas.getContext("2d");
                    context.drawImage(image, sx, sy, sw, sh, 0, 0, dw, dh);
                    image = canvas;
                }
                svgImage.setAttribute("transform", translateDirective);
                svgImage.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href",
                    image.nodeName === "CANVAS" ? image.toDataURL() : image.getAttribute("src"));
                parent.appendChild(svgImage);
            }
        };

        /**
         * Generates a pattern tag
         */
        createPattern(image, repetition) {

            let pattern = this.__document.__createElement("pattern");
            let id = randomString(this.__ids);
            let img;

            pattern.setAttribute("id", id);
            pattern.setAttribute("width", image.width);
            pattern.setAttribute("height", image.height);
            if (image.nodeName === "CANVAS" || image.nodeName === "IMG") {
                img = this.__createElement("image");
                img.setAttribute("width", image.width);
                img.setAttribute("height", image.height);
                img.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href",
                    image.nodeName === "CANVAS" ? image.toDataURL() : image.getAttribute("src"));
                pattern.appendChild(img);
                this.__defs.appendChild(pattern);
            } else if (image instanceof ctx) {
                pattern.appendChild(image.__root.childNodes[1]);
                this.__defs.appendChild(pattern);
            }
            return new CanvasPattern(pattern, this)
        };

        setLineDash(dashArray) {
            if (dashArray && dashArray.length > 0) {
                this.lineDash = dashArray.join(",");
            } else {
                this.lineDash = null;
            }
        };

        /**
         * Not yet implemented
         */
        drawFocusRing() {
        };

        createImageData() {
        };

        getImageData() {
        };

        putImageData() {
        };

        globalCompositeOperation() {
        };

        setTransform() {
        };
    }

    const Cytoband = function (start, end, name, typestain) {
        this.start = start;
        this.end = end;
        this.name = name;
        this.stain = 0;

        // Set the type, either p, n, or c
        if (typestain === 'acen') {
            this.type = 'c';
        } else {
            this.type = typestain.charAt(1);
            if (this.type === 'p') {
                this.stain = parseInt(typestain.substring(4));
            }
        }
    };

    const _version = "2.15.13";
    function version() {
        return _version
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const DEFAULT_GENOMES_URL = "https://igv.org/genomes/genomes.json";
    const BACKUP_GENOMES_URL = "https://s3.amazonaws.com/igv.org.genomes/genomes.json";

    const splitLines$1 = splitLines$5;

    const GenomeUtils = {

        loadGenome: async function (options) {

            const cytobandUrl = options.cytobandURL;
            const aliasURL = options.aliasURL;
            const sequence = await loadFasta(options);

            let aliases;
            if (aliasURL) {
                aliases = await loadAliases(aliasURL, sequence.config);
            }

            const genome = new Genome(options, sequence, aliases);

            // Delay loading cytbands untils after genome initialization to use chromosome aliases (1 vs chr1, etc).
            if (cytobandUrl) {
                genome.cytobands = await loadCytobands(cytobandUrl, sequence.config, genome);
            }

            return genome
        },

        initializeGenomes: async function (config) {

            if (!GenomeUtils.KNOWN_GENOMES) {

                const table = {};

                // Get default genomes
                if (config.loadDefaultGenomes !== false) {
                    try {
                        const url = DEFAULT_GENOMES_URL + `?randomSeed=${Math.random().toString(36)}&version=${version()}`;  // prevent caching
                        const jsonArray = await igvxhr.loadJson(url, {timeout: 5000});
                        processJson(jsonArray);
                    } catch (e) {
                        console.error(e);
                        try {
                            const url = BACKUP_GENOMES_URL + `?randomSeed=${Math.random().toString(36)}&version=${version()}`;  // prevent caching
                            const jsonArray = await igvxhr.loadJson(url, {});
                            processJson(jsonArray);
                        } catch (e) {
                            console.error(e);
                            console.warn("Errors loading default genome definitions.");
                        }
                    }
                }

                // Add user-defined genomes
                const genomeList = config.genomeList || config.genomes;
                if (genomeList) {
                    if (typeof genomeList === 'string') {
                        const jsonArray = await igvxhr.loadJson(genomeList, {});
                        processJson(jsonArray);
                    } else {
                        processJson(genomeList);
                    }
                }

                GenomeUtils.KNOWN_GENOMES = table;

                function processJson(jsonArray) {
                    jsonArray.forEach(function (json) {
                        table[json.id] = json;
                    });
                    return table
                }
            }
        },

        isWholeGenomeView: function (chr) {
            return 'all' === chr.toLowerCase()
        },

        // Expand a genome id to a reference object, if needed
        expandReference: function (alert, idOrConfig) {

            // idOrConfig might be json
            if (isString$2(idOrConfig) && idOrConfig.startsWith("{")) {
                try {
                    idOrConfig = JSON.parse(idOrConfig);
                } catch (e) {
                    // Apparently its not json,  could be an ID starting with "{".  Unusual but legal.
                }
            }

            let genomeID;
            if (isString$2(idOrConfig)) {
                genomeID = idOrConfig;
            } else if (idOrConfig.genome) {
                genomeID = idOrConfig.genome;
            } else if (idOrConfig.id !== undefined && idOrConfig.fastaURL === undefined) {
                // Backward compatibility
                genomeID = idOrConfig.id;
            }

            if (genomeID) {
                const knownGenomes = GenomeUtils.KNOWN_GENOMES;
                const reference = knownGenomes[genomeID];
                if (!reference) {
                    alert.present(new Error(`Unknown genome id: ${genomeID}`), undefined);
                }
                return reference
            } else {
                return idOrConfig
            }
        }
    };


    class Genome {

        constructor(config, sequence, aliases) {

            this.config = config;
            this.id = config.id || generateGenomeID(config);
            this.sequence = sequence;
            this.chromosomeNames = sequence.chromosomeNames;
            this.chromosomes = sequence.chromosomes;  // An object (functions as a dictionary)
            this.featureDB = new Map();   // Hash of name -> feature, used for search function.

            this.wholeGenomeView = config.wholeGenomeView === undefined || config.wholeGenomeView;
            if (this.wholeGenomeView && Object.keys(sequence.chromosomes).length > 1) {
                constructWG(this, config);
            } else {
                this.wgChromosomeNames = sequence.chromosomeNames;
            }

            /**
             * Return the official chromosome name for the (possibly) alias.  Deals with
             * 1 <-> chr1,  chrM <-> MT,  IV <-> chr4, etc.
             * @param str
             */
            var chrAliasTable = {},
                self = this;


            // The standard mappings
            chrAliasTable["all"] = "all";
            this.chromosomeNames.forEach(function (name) {
                var alias = name.startsWith("chr") ? name.substring(3) : "chr" + name;
                chrAliasTable[alias.toLowerCase()] = name;
                if (name === "chrM") chrAliasTable["mt"] = "chrM";
                if (name === "MT") chrAliasTable["chrm"] = "MT";
                chrAliasTable[name.toLowerCase()] = name;
            });

            // Custom mappings
            if (aliases) {
                aliases.forEach(function (array) {
                    // Find the official chr name
                    var defName, i;

                    for (i = 0; i < array.length; i++) {
                        if (self.chromosomes[array[i]]) {
                            defName = array[i];
                            break
                        }
                    }

                    if (defName) {
                        array.forEach(function (alias) {
                            if (alias !== defName) {
                                chrAliasTable[alias.toLowerCase()] = defName;
                                chrAliasTable[alias] = defName;      // Should not be needed
                            }
                        });
                    }

                });
            }

            this.chrAliasTable = chrAliasTable;

        }

        showWholeGenomeView() {
            return this.config.wholeGenomeView !== false
        }

        toJSON() {
            return Object.assign({}, this.config, {tracks: undefined})
        }

        getInitialLocus() {

        }

        getHomeChromosomeName() {
            if (this.showWholeGenomeView() && this.chromosomes.hasOwnProperty("all")) {
                return "all"
            } else {
                return this.chromosomeNames[0]

            }
        }

        getChromosomeName(str) {
            const chr = str ? this.chrAliasTable[str.toLowerCase()] : str;
            return chr ? chr : str
        }

        getChromosome(chr) {
            chr = this.getChromosomeName(chr);
            return this.chromosomes[chr]
        }

        getCytobands(chr) {
            return this.cytobands ? this.cytobands[chr] : null
        }

        getLongestChromosome() {

            var longestChr,
                chromosomes = this.chromosomes;
            for (let key in chromosomes) {
                if (chromosomes.hasOwnProperty(key)) {
                    var chr = chromosomes[key];
                    if (longestChr === undefined || chr.bpLength > longestChr.bpLength) {
                        longestChr = chr;
                    }
                }
                return longestChr
            }
        }

        getChromosomes() {
            return this.chromosomes
        }

        /**
         * Return the genome coordinate in kb for the give chromosome and position.
         * NOTE: This might return undefined if the chr is filtered from whole genome view.
         */
        getGenomeCoordinate(chr, bp) {

            var offset = this.getCumulativeOffset(chr);
            if (offset === undefined) return undefined

            return offset + bp
        }

        /**
         * Return the chromosome and coordinate in bp for the given genome coordinate
         */
        getChromosomeCoordinate(genomeCoordinate) {

            if (this.cumulativeOffsets === undefined) {
                this.cumulativeOffsets = computeCumulativeOffsets.call(this);
            }

            let lastChr = undefined;
            let lastCoord = 0;
            for (let name of this.wgChromosomeNames) {

                const cumulativeOffset = this.cumulativeOffsets[name];
                if (cumulativeOffset > genomeCoordinate) {
                    const position = genomeCoordinate - lastCoord;
                    return {chr: lastChr, position: position}
                }
                lastChr = name;
                lastCoord = cumulativeOffset;
            }

            // If we get here off the end
            return {chr: this.wgChromosomeNames[this.wgChromosomeNames.length - 1], position: 0}

        };


        /**
         * Return the offset in genome coordinates (kb) of the start of the given chromosome
         * NOTE:  This might return undefined if the chromosome is filtered from whole genome view.
         */
        getCumulativeOffset(chr) {

            if (this.cumulativeOffsets === undefined) {
                this.cumulativeOffsets = computeCumulativeOffsets.call(this);
            }

            const queryChr = this.getChromosomeName(chr);
            return this.cumulativeOffsets[queryChr]

            function computeCumulativeOffsets() {

                let self = this;
                let acc = {};
                let offset = 0;
                for (let name of self.wgChromosomeNames) {

                    acc[name] = Math.floor(offset);

                    const chromosome = self.getChromosome(name);

                    offset += chromosome.bpLength;
                }

                return acc
            }
        }

        /**
         * Return the nominal genome length, this is the length of the main chromosomes (no scaffolds, etc).
         */
        getGenomeLength() {

            let self = this;

            if (!this.bpLength) {
                let bpLength = 0;
                self.wgChromosomeNames.forEach(function (cname) {
                    let c = self.chromosomes[cname];
                    bpLength += c.bpLength;
                });
                this.bpLength = bpLength;
            }
            return this.bpLength
        }

        async getSequence(chr, start, end) {
            chr = this.getChromosomeName(chr);
            return this.sequence.getSequence(chr, start, end)
        }

        addFeaturesToDB(featureList, config) {

            const insertFeature = (name, feature) => {
                const current = this.featureDB.get(name);
                if (current) {
                    feature = (feature.end - feature.start) > (current.end - current.start) ? feature : current;

                }
                this.featureDB.set(name, feature);
            };

            for (let feature of featureList) {
                if (feature.name) {
                    insertFeature(feature.name.toUpperCase(), feature);
                }
                if (feature.gene && feature.gene.name) {
                    insertFeature(feature.gene.name.toUpperCase(), feature);
                }

                if (config.searchableFields) {
                    for (let f of config.searchableFields) {
                        const value = feature.getAttributeValue(f);
                        if (value) {
                            if (value.indexOf(" ") > 0) {
                                insertFeature(value.replaceAll(" ", "+").toUpperCase(), feature);
                            } else {
                                insertFeature(value.toUpperCase(), feature);
                            }
                        }
                    }
                }
            }
        }
    }

    async function loadCytobands(cytobandUrl, config, genome) {

        let data;
        if (isDataURL(cytobandUrl)) {
            const plain = decodeDataURI$1(cytobandUrl);
            data = "";
            const len = plain.length;
            for (let i = 0; i < len; i++) {
                data += String.fromCharCode(plain[i]);
            }
        } else {
            data = await igvxhr.loadString(cytobandUrl, buildOptions(config));
        }

        // var bands = [],
        //     lastChr,
        //     n = 0,
        //     c = 1,
        //
        //     len = lines.length,
        const cytobands = {};
        let lastChr;
        let bands = [];
        const lines = splitLines$1(data);
        for (let line of lines) {
            var tokens = line.split("\t");
            var chr = genome.getChromosomeName(tokens[0]);
            if (!lastChr) lastChr = chr;

            if (chr !== lastChr) {
                cytobands[lastChr] = bands;
                bands = [];
                lastChr = chr;
            }

            if (tokens.length === 5) {
                //10	0	3000000	p15.3	gneg
                var start = parseInt(tokens[1]);
                var end = parseInt(tokens[2]);
                var name = tokens[3];
                var stain = tokens[4];
                bands.push(new Cytoband(start, end, name, stain));
            }
        }

        return cytobands
    }

    function loadAliases(aliasURL, config) {

        return igvxhr.loadString(aliasURL, buildOptions(config))

            .then(function (data) {

                var lines = splitLines$1(data),
                    aliases = [];

                lines.forEach(function (line) {
                    if (!line.startsWith("#") && line.length > 0) aliases.push(line.split("\t"));
                });

                return aliases
            })

    }

    function constructWG(genome, config) {

        let wgChromosomes;
        if (config.chromosomeOrder) {
            if (Array.isArray(config.chromosomeOrder)) {
                genome.wgChromosomeNames = config.chromosomeOrder;
            } else {
                genome.wgChromosomeNames = config.chromosomeOrder.split(',').map(nm => nm.trim());
            }
            wgChromosomes = genome.wgChromosomeNames.map(nm => genome.chromosomes[nm]).filter(chr => chr !== undefined);

        } else {

            // Trim small chromosomes.
            const lengths = Object.keys(genome.chromosomes).map(key => genome.chromosomes[key].bpLength);
            const median = lengths.reduce((a, b) => Math.max(a, b));
            const threshold = median / 50;
            wgChromosomes = Object.values(genome.chromosomes).filter(chr => chr.bpLength > threshold);

            // Sort chromosomes.  First segregate numeric and alpha names, sort numeric, leave alpha as is
            const numericChromosomes = wgChromosomes.filter(chr => isDigit(chr.name.replace('chr', '')));
            const alphaChromosomes = wgChromosomes.filter(chr => !isDigit(chr.name.replace('chr', '')));
            numericChromosomes.sort((a, b) => Number.parseInt(a.name.replace('chr', '')) - Number.parseInt(b.name.replace('chr', '')));

            const wgChromosomeNames = numericChromosomes.map(chr => chr.name);
            for (let chr of alphaChromosomes) {
                wgChromosomeNames.push(chr.name);
            }
            genome.wgChromosomeNames = wgChromosomeNames;
        }


        // Compute psuedo-chromosome "all"
        const l = wgChromosomes.reduce((accumulator, currentValue) => accumulator += currentValue.bpLength, 0);
        genome.chromosomes["all"] = {
            name: "all",
            bpLength: l
        };

        function isDigit(val) {
            return /^\d+$/.test(val)
        }

    }

    function generateGenomeID(config) {
        if (config.id !== undefined) {
            return config.id
        } else if (config.fastaURL && isString$2(config.fastaURL)) {
            return config.fastaURL
        } else if (config.fastaURL && config.fastaURL.name) {
            return config.fastaURL.name
        } else {
            return ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4)
        }
    }

    /**
     * Created by dat on 9/16/16.
     */

    const NOT_LOADED_MESSAGE = 'Error loading track data';
    let lastClickTime = 0;
    let lastHoverUpdateTime = 0;
    let popupTimerID;

    class TrackViewport extends Viewport {

        constructor(trackView, viewportColumn, referenceFrame, width) {
            super(trackView, viewportColumn, referenceFrame, width);
        }

        initializationHelper() {

            this.$spinner = $$1('<div>', {class: 'igv-loading-spinner-container'});
            this.$viewport.append(this.$spinner);
            this.$spinner.append($$1('<div>'));

            const track = this.trackView.track;
            if ('sequence' !== track.type) {
                this.$zoomInNotice = this.createZoomInNotice(this.$viewport);
            }

            if (track.name && "sequence" !== track.id) {
                this.$trackLabel = $$1('<div class="igv-track-label">');
                this.$viewport.append(this.$trackLabel);
                this.setTrackLabel(track.name);
                if (false === this.browser.trackLabelsVisible) {
                    this.$trackLabel.hide();
                }
            }

            this.stopSpinner();
            this.addMouseHandlers();
        }

        setContentHeight(contentHeight) {
            super.setContentHeight(contentHeight);
            if (this.featureCache) this.featureCache.redraw = true;
        }

        setTrackLabel(label) {

            this.$trackLabel.empty();
            this.$trackLabel.html(label);

            const txt = this.$trackLabel.text();
            this.$trackLabel.attr('title', txt);
        }

        startSpinner() {
            this.$spinner.show();
        }

        stopSpinner() {
            if (this.$spinner) {
                this.$spinner.hide();
            }
        }

        /**
         * Test to determine if we are zoomed in far enough to see features. Applicable to tracks with visibility windows.
         *
         * As a side effect the viewports canvas is removed if zoomed out.
         *
         * @returns {boolean} true if we are zoomed in past visibility window, false otherwise
         */
        checkZoomIn() {

            const zoomedOutOfWindow = () => {
                if (this.referenceFrame.chr.toLowerCase() === "all" && !this.trackView.track.supportsWholeGenome) {
                    return true
                } else {
                    const visibilityWindow = this.trackView.track.visibilityWindow;
                    return (
                        visibilityWindow !== undefined && visibilityWindow > 0 &&
                        (this.referenceFrame.bpPerPixel * this.$viewport.width() > visibilityWindow))
                }
            };

            if (this.trackView.track && "sequence" === this.trackView.track.type && this.referenceFrame.bpPerPixel > bppFeatureFetchThreshold) {
                $$1(this.canvas).remove();
                this.canvas = undefined;
                //this.featureCache = undefined
                return false
            }

            if (!(this.viewIsReady())) {
                return false
            }


            if (zoomedOutOfWindow()) {

                // Out of visibility window
                if (this.canvas) {
                    $$1(this.canvas).remove();
                    this.canvas = undefined;
                    //this.featureCache = undefined
                }
                if (this.trackView.track.autoHeight) {
                    const minHeight = this.trackView.minHeight || 0;
                    this.setContentHeight(minHeight);
                }
                if (this.$zoomInNotice) {
                    this.$zoomInNotice.show();
                }
                return false
            } else {
                if (this.$zoomInNotice) {
                    this.$zoomInNotice.hide();
                }
                return true
            }

        }

        /**
         * Adjust the canvas to the current genomic state.
         */
        shift() {
            const referenceFrame = this.referenceFrame;
            if (this.canvas &&
                this.canvas._data &&
                this.canvas._data.referenceFrame.chr === this.referenceFrame.chr &&
                this.canvas._data.bpPerPixel === referenceFrame.bpPerPixel) {
                const pixelOffset = Math.round((this.canvas._data.bpStart - referenceFrame.start) / referenceFrame.bpPerPixel);
                this.canvas.style.left = pixelOffset + "px";
            }
        }

        /**
         * Set the content top of the current view.  This is triggered by scrolling.   If the current canvas extent is not
         * sufficient to cover the new vertical range repaint.
         *
         * @param contentTop - the "top" property of the virtual content div, 0 unless track is scrolled vertically
         *
         *
         */
        setTop(contentTop) {

            super.setTop(contentTop);

            if (!this.canvas) {
                this.repaint();
            } else {
                // See if currently painted canvas covers the vertical range of the viewport.  If not repaint
                const h = this.$viewport.height();
                const vt = contentTop + this.canvas._data.pixelTop;
                const vb = vt + this.canvas._data.pixelHeight;
                if (vt > 0 || vb < h) {
                    this.repaint();
                }
            }

            // Now offset backing canvas to align with the contentTop visual offset.
            let offset = contentTop + this.canvas._data.pixelTop;
            this.canvas.style.top = `${offset}px`;
        }

        async loadFeatures() {

            const referenceFrame = this.referenceFrame;
            const chr = referenceFrame.chr;

            // Expand the requested range so we can pan a bit without reloading.  But not beyond chromosome bounds
            const chrLength = this.browser.genome.getChromosome(chr).bpLength;
            const pixelWidth = this.$viewport.width();// * 3;
            const bpWidth = pixelWidth * referenceFrame.bpPerPixel;
            const bpStart = Math.floor(Math.max(0, referenceFrame.start - bpWidth));
            const bpEnd = Math.ceil(Math.min(chrLength, referenceFrame.start + bpWidth + bpWidth));  // Add one screen width to end

            if (this.loading && this.loading.start === bpStart && this.loading.end === bpEnd) {
                return undefined
            }
            this.loading = {start: bpStart, end: bpEnd};
            this.startSpinner();

            try {
                const track = this.trackView.track;
                const features = await this.getFeatures(track, chr, bpStart, bpEnd, referenceFrame.bpPerPixel);
                if (features) {
                    let roiFeatures = [];
                    if (track.roiSets && track.roiSets.length > 0) {
                        for (let roiSet of track.roiSets) {
                            const features = await roiSet.getFeatures(chr, bpStart, bpEnd, referenceFrame.bpPerPixel);
                            roiFeatures.push({track: roiSet, features});
                        }
                    }

                    const mr = track && ("wig" === track.type || "merged" === track.type);   // wig tracks are potentially multiresolution (e.g. bigwig)
                    this.featureCache = new FeatureCache(chr, bpStart, bpEnd, referenceFrame.bpPerPixel, features, roiFeatures, mr);
                    this.loading = false;
                    this.hideMessage();
                    this.stopSpinner();
                    return this.featureCache
                }
            } catch (error) {
                // Track might have been removed during load
                if (this.trackView && this.trackView.disposed !== true) {
                    this.showMessage(NOT_LOADED_MESSAGE);
                    this.browser.alert.present(error);
                    console.error(error);
                }
            } finally {
                this.loading = false;
                this.stopSpinner();
            }
        }

        /**
         * Compute the genomic extent and needed pixelWidth to repaint the canvas for the current genomic state.
         * Normally the canvas is size 3X the width of the viewport, however there is no left-right panning for WGV so
         * canvas width is viewport width.
         * @returns {{bpEnd: *, pixelWidth: (*|number), bpStart: number}}
         */
        repaintDimensions() {
            const isWGV = GenomeUtils.isWholeGenomeView(this.referenceFrame.chr);
            const pixelWidth = isWGV ? this.$viewport.width() : 3 * this.$viewport.width();
            const bpPerPixel = this.referenceFrame.bpPerPixel;
            const bpStart = this.referenceFrame.start - (isWGV ? 0 : pixelWidth / 3 * bpPerPixel);
            const bpEnd = this.referenceFrame.end + (isWGV ? 0 : pixelWidth / 3 * bpPerPixel);
            return {
                bpStart, bpEnd, pixelWidth
            }
        }

        /**
         * Repaint the canvas using the cached features
         *
         */
        repaint() {

            if (undefined === this.featureCache) {
                return
            }

            const {features, roiFeatures} = this.featureCache;

            // Canvas dimensions.
            // For deep tracks we paint a canvas == 3*viewportHeight centered on the current vertical scroll position
            const {bpStart, bpEnd, pixelWidth} = this.repaintDimensions();
            const viewportHeight = this.$viewport.height();
            const contentHeight = this.getContentHeight();
            const maxHeight = roiFeatures ? Math.max(contentHeight, viewportHeight) : contentHeight;  // Need to fill viewport for ROIs.
            const pixelHeight = Math.min(maxHeight, 3 * viewportHeight);
            if (0 === pixelWidth || 0 === pixelHeight) {
                if (this.canvas) {
                    $$1(this.canvas).remove();
                }
                return
            }
            const pixelTop = Math.max(0, -this.contentTop - Math.floor(pixelHeight / 3));

            const bpPerPixel = this.referenceFrame.bpPerPixel;
            const pixelXOffset = Math.round((bpStart - this.referenceFrame.start) / bpPerPixel);
            const canvasTop = (this.contentTop || 0) + pixelTop;
            const newCanvas = document.createElement('canvas');//  $('<canvas class="igv-canvas">').get(0)
            newCanvas.style.position = 'relative';
            newCanvas.style.display = 'block';
            newCanvas.style.width = pixelWidth + "px";
            newCanvas.style.height = pixelHeight + "px";
            newCanvas.style.left = pixelXOffset + "px";
            newCanvas.style.top = canvasTop + "px";

            // Always use high DPI if in "FILL" display mode, otherwise use track setting;
            const devicePixelRatio = ("FILL" === this.trackView.track.displayMode || this.trackView.track.supportHiDPI !== false) ?
                window.devicePixelRatio : 1;
            newCanvas.width = devicePixelRatio * pixelWidth;
            newCanvas.height = devicePixelRatio * pixelHeight;

            const ctx = newCanvas.getContext("2d");
            ctx.scale(devicePixelRatio, devicePixelRatio);
            ctx.translate(0, -pixelTop);

            const drawConfiguration =
                {
                    context: ctx,
                    pixelXOffset,
                    pixelWidth,
                    pixelHeight,
                    pixelTop,
                    bpStart,
                    bpEnd: bpEnd,
                    bpPerPixel,
                    referenceFrame: this.referenceFrame,
                    selection: this.selection,
                    viewport: this,
                    viewportWidth: this.$viewport.width()
                };

            this.draw(drawConfiguration, features, roiFeatures);

            if (this.canvas) {
                $$1(this.canvas).remove();
            }
            newCanvas._data = drawConfiguration;
            this.canvas = newCanvas;
            this.$viewport.append($$1(newCanvas));

        }

        refresh() {
            if (!(this.canvas && this.featureCache)) return

            const drawConfiguration = this.canvas._data;
            drawConfiguration.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
            const {features, roiFeatures} = this.featureCache;
            this.draw(drawConfiguration, features, roiFeatures);
        }

        /**
         * Draw the associated track.
         *
         * @param drawConfiguration
         * @param features
         * @param roiFeatures
         */
        draw(drawConfiguration, features, roiFeatures) {

            if (features) {
                drawConfiguration.features = features;
                this.trackView.track.draw(drawConfiguration);
            }
            if (roiFeatures && roiFeatures.length > 0) {
                for (let r of roiFeatures) {
                    drawConfiguration.features = r.features;
                    r.track.draw(drawConfiguration);
                }
            }
        }

        containsPosition(chr, position) {
            if (this.referenceFrame.chr === chr && position >= this.referenceFrame.start) {
                return position <= this.referenceFrame.calculateEnd(this.getWidth())
            } else {
                return false
            }
        }

        isLoading() {
            return this.loading
        }

        savePNG() {

            if (!this.canvas) return

            const canvasMetadata = this.canvas._data;
            const canvasTop = canvasMetadata ? canvasMetadata.pixelTop : 0;
            const devicePixelRatio = window.devicePixelRatio;
            const w = this.$viewport.width() * devicePixelRatio;
            const h = this.$viewport.height() * devicePixelRatio;
            const x = -$$1(this.canvas).position().left * devicePixelRatio;
            const y = (-this.contentTop - canvasTop) * devicePixelRatio;

            const ctx = this.canvas.getContext("2d");
            const imageData = ctx.getImageData(x, y, w, h);
            const exportCanvas = document.createElement('canvas');
            const exportCtx = exportCanvas.getContext('2d');
            exportCanvas.width = imageData.width;
            exportCanvas.height = imageData.height;
            exportCtx.putImageData(imageData, 0, 0);

            // filename = this.trackView.track.name + ".png";
            const filename = (this.$trackLabel.text() ? this.$trackLabel.text() : "image") + ".png";
            const data = exportCanvas.toDataURL("image/png");
            download(filename, data);
        }

        saveSVG() {

            const marginTop = 32;
            const marginLeft = 32;

            let {width, height} = this.browser.columnContainer.getBoundingClientRect();

            const h_render = 8000;

            const config =
                {

                    width,
                    height: h_render,

                    backdropColor: 'white',

                    multiLocusGap: 0,

                    viewbox:
                        {
                            x: 0,
                            y: 0,
                            width,
                            height: h_render
                        }

                };

            const context = new ctx(config);

            const delta =
                {
                    deltaX: marginLeft,
                    deltaY: marginTop
                };

            this.renderViewportToSVG(context, delta);

            // reset height to trim away unneeded svg canvas real estate. Yes, a bit of a hack.
            context.setHeight(height);

            const str = (this.trackView.track.name || this.trackView.track.id).replace(/\W/g, '');
            const index = this.browser.referenceFrameList.indexOf(this.referenceFrame);

            const svg = context.getSerializedSvg(true);
            const data = URL.createObjectURL(new Blob([svg], {type: "application/octet-stream"}));

            const id = `${str}_referenceFrame_${index}_guid_${domUtils.guid()}`;
            download(`${id}.svg`, data);

        }

        // called by trackView.renderSVGContext() when rendering
        // entire browser as SVG

        renderViewportToSVG(context, {deltaX, deltaY}) {

            if (this.$zoomInNotice && this.$zoomInNotice.is(":visible")) {
                return
            }

            const {width, height} = this.$viewport.get(0).getBoundingClientRect();

            const str = (this.trackView.track.name || this.trackView.track.id).replace(/\W/g, '');
            const index = this.browser.referenceFrameList.indexOf(this.referenceFrame);
            const id = `${str}_referenceFrame_${index}_guid_${domUtils.guid()}`;
            this.drawSVGWithContext(context, width, height, id, deltaX, deltaY + this.contentTop, -this.contentTop);

        }

        renderSVGContext(context, {deltaX, deltaY}) {

            this.renderViewportToSVG(context, {deltaX, deltaY});

            if (this.$zoomInNotice && this.$zoomInNotice.is(":visible")) {
                return
            }

            if (this.$trackLabel && true === this.browser.trackLabelsVisible) {
                const {x, y, width, height} = domUtils.relativeDOMBBox(this.$viewport.get(0), this.$trackLabel.get(0));
                this.renderTrackLabelSVG(context, deltaX + x, deltaY + y, width, height);
            }

        }

        // render track label element called from renderSVGContext()
        renderTrackLabelSVG(context, tx, ty, width, height) {

            const str = (this.trackView.track.name || this.trackView.track.id).replace(/\W/g, '');
            const id = `${str}_track_label_guid_${domUtils.guid()}`;

            context.saveWithTranslationAndClipRect(id, tx, ty, width, height, 0);

            context.fillStyle = "white";
            context.fillRect(0, 0, width, height);

            context.font = "12px Arial";
            context.fillStyle = 'rgb(68, 68, 68)';

            const {width: stringWidth} = context.measureText(this.$trackLabel.text());
            const dx = 0.25 * (width - stringWidth);
            const dy = 0.7 * (height - 12);
            context.fillText(this.$trackLabel.text(), dx, height - dy);

            context.strokeStyle = 'rgb(68, 68, 68)';
            context.strokeRect(0, 0, width, height);

            context.restore();

        }

        // called by renderSVGContext()
        drawSVGWithContext(context, width, height, id, x, y, yClipOffset) {

            context.saveWithTranslationAndClipRect(id, x, y, width, height, yClipOffset);

            let {start, bpPerPixel} = this.referenceFrame;

            const config =
                {
                    context,
                    viewport: this,
                    referenceFrame: this.referenceFrame,
                    top: yClipOffset,
                    pixelTop: yClipOffset,
                    pixelWidth: width,
                    pixelHeight: height,
                    bpStart: start,
                    bpEnd: start + (width * bpPerPixel),
                    bpPerPixel,
                    viewportWidth: width,
                    selection: this.selection
                };

            const features = this.featureCache ? this.featureCache.features : undefined;
            const roiFeatures = this.featureCache ? this.featureCache.roiFeatures : undefined;
            this.draw(config, features, roiFeatures);

            context.restore();

        }

        get cachedFeatures() {
            return this.featureCache ? this.featureCache.features : []
        }

        clearCache() {
            this.featureCache = undefined;
            if (this.canvas) this.canvas._data = undefined;
        }

        async getFeatures(track, chr, start, end, bpPerPixel) {
            if (this.featureCache && this.featureCache.containsRange(chr, start, end, bpPerPixel)) {
                return this.featureCache.features
            } else if (typeof track.getFeatures === "function") {
                const features = await track.getFeatures(chr, start, end, bpPerPixel, this);
                this.checkContentHeight(features);
                return features
            } else {
                return undefined
            }
        }

        needsRepaint() {

            if (!this.canvas) return true

            const data = this.canvas._data;
            return !data ||
                this.referenceFrame.start < data.bpStart ||
                this.referenceFrame.end > data.bpEnd ||
                this.referenceFrame.chr !== data.referenceFrame.chr ||
                this.referenceFrame.bpPerPixel != data.bpPerPixel
        }

        needsReload() {
            if (!this.featureCache) return true
            const {chr, bpPerPixel} = this.referenceFrame;
            const {bpStart, bpEnd} = this.repaintDimensions();
            return (!this.featureCache.containsRange(chr, bpStart, bpEnd, bpPerPixel))
        }

        createZoomInNotice($parent) {

            const $container = $$1('<div>', {class: 'igv-zoom-in-notice-container'});
            $parent.append($container);

            const $e = $$1('<div>');
            $container.append($e);

            $e.text('Zoom in to see features');

            $container.hide();

            return $container
        }

        viewIsReady() {
            return this.browser && this.browser.referenceFrameList && this.referenceFrame
        }

        addMouseHandlers() {

            const viewport = this.$viewport.get(0);

            this.addViewportContextMenuHandler(viewport);

            // Mouse down
            const md = (event) => {
                this.enableClick = true;
                this.browser.mouseDownOnViewport(event, this);
                domUtils.pageCoordinates(event);
            };
            viewport.addEventListener('mousedown', md);
            viewport.addEventListener('touchstart', md);

            // Mouse up
            const mu = (event) => {
                // Any mouse up cancels drag and scrolling
                if (this.browser.dragObject || this.browser.isScrolling) {
                    this.browser.cancelTrackPan();
                    // event.preventDefault();
                    // event.stopPropagation();
                    this.enableClick = false;   // Until next mouse down
                } else {
                    this.browser.cancelTrackPan();
                    this.browser.endTrackDrag();
                }
            };
            viewport.addEventListener('mouseup', mu);
            viewport.addEventListener('touchend', mu);

            // Mouse move
            if (typeof this.trackView.track.hoverText === 'function') {
                viewport.addEventListener('mousemove', (event => {
                    if (event.buttons === 0 && (Date.now() - lastHoverUpdateTime > 100)) {
                        lastHoverUpdateTime = Date.now();
                        const clickState = this.createClickState(event);
                        if (clickState) {
                            const tooltip = this.trackView.track.hoverText(clickState);
                            if (tooltip) {
                                this.$viewport[0].setAttribute("title", tooltip);
                            } else {
                                this.$viewport[0].removeAttribute("title");
                            }
                        }
                    }
                }));
            }

            this.addViewportClickHandler(this.$viewport.get(0));

            if (this.trackView.track.name && "sequence" !== this.trackView.track.config.type) {
                this.addTrackLabelClickHandler(this.$trackLabel.get(0));
            }

        }

        addViewportContextMenuHandler(viewport) {

            viewport.addEventListener('contextmenu', (event) => {

                // Ignore if we are doing a drag.  This can happen with touch events.
                if (this.browser.dragObject) {
                    return false
                }

                const clickState = this.createClickState(event);

                if (undefined === clickState) {
                    return false
                }

                event.preventDefault();

                // Track specific items
                let menuItems = [];
                if (typeof this.trackView.track.contextMenuItemList === "function") {
                    const trackMenuItems = this.trackView.track.contextMenuItemList(clickState);
                    if (trackMenuItems) {
                        menuItems = trackMenuItems;
                    }
                }

                // Add items common to all tracks
                if (menuItems.length > 0) {
                    menuItems.push({label: $$1('<HR>')});
                }

                menuItems.push({label: 'Save Image (PNG)', click: () => this.savePNG()});
                menuItems.push({label: 'Save Image (SVG)', click: () => this.saveSVG()});

                this.browser.menuPopup.presentTrackContextMenu(event, menuItems);
            });

        }


        addViewportClickHandler(viewport) {

            viewport.addEventListener('click', (event) => {

                if (this.enableClick && this.canvas) {
                    if (3 === event.which || event.ctrlKey) {
                        return
                    }

                    // Close any currently open popups
                    $$1('.igv-popover').hide();


                    if (this.browser.dragObject || this.browser.isScrolling) {
                        return
                    }

                    // Treat as a mouse click, its either a single or double click.
                    // Handle here and stop propogation / default
                    event.preventDefault();

                    const mouseX = domUtils.translateMouseCoordinates(event, this.$viewport.get(0)).x;
                    const mouseXCanvas = domUtils.translateMouseCoordinates(event, this.canvas).x;
                    const referenceFrame = this.referenceFrame;
                    const xBP = Math.floor((referenceFrame.start) + referenceFrame.toBP(mouseXCanvas));

                    const time = Date.now();

                    if (time - lastClickTime < this.browser.constants.doubleClickDelay) {

                        // double-click
                        if (popupTimerID) {
                            window.clearTimeout(popupTimerID);
                            popupTimerID = undefined;
                        }

                        const centerBP = Math.round(referenceFrame.start + referenceFrame.toBP(mouseX));

                        let string;

                        if ('all' === this.referenceFrame.chr.toLowerCase()) {

                            const chr = this.browser.genome.getChromosomeCoordinate(centerBP).chr;

                            if (1 === this.browser.referenceFrameList.length) {
                                string = chr;
                            } else {
                                const loci = this.browser.referenceFrameList.map(({locusSearchString}) => locusSearchString);
                                const index = this.browser.referenceFrameList.indexOf(this.referenceFrame);
                                loci[index] = chr;
                                string = loci.join(' ');
                            }

                            this.browser.search(string);

                        } else {
                            this.browser.zoomWithScaleFactor(0.5, centerBP, this.referenceFrame);
                        }


                    } else {
                        // single-click

                        if (event.shiftKey && typeof this.trackView.track.shiftClick === "function") {

                            this.trackView.track.shiftClick(xBP, event);

                        } else if (typeof this.trackView.track.popupData === "function") {

                            popupTimerID = setTimeout(() => {

                                    const content = this.getPopupContent(event);
                                    if (content) {
                                        if (this.popover) this.popover.dispose();
                                        this.popover = new Popover(this.browser.columnContainer);
                                        this.popover.presentContentWithEvent(event, content);
                                    }
                                    window.clearTimeout(popupTimerID);
                                    popupTimerID = undefined;
                                },
                                this.browser.constants.doubleClickDelay);
                        }
                    }

                    lastClickTime = time;

                }
            });
        }

        addTrackLabelClickHandler(trackLabel) {

            trackLabel.addEventListener('click', (event) => {

                event.stopPropagation();

                const {track} = this.trackView;

                let str;
                if (typeof track.description === 'function') {
                    str = track.description();
                } else if (track.description) {
                    str = `<div>${track.description}</div>`;
                }

                if (str) {
                    if (this.popover) {
                        this.popover.dispose();
                    }
                    this.popover = new Popover(this.browser.columnContainer, (track.name || ''));
                    this.popover.presentContentWithEvent(event, str);
                }
            });
        }

        createClickState(event) {

            if (!this.canvas) return  // Can happen during initialization

            const referenceFrame = this.referenceFrame;
            const viewportCoords = domUtils.translateMouseCoordinates(event, this.$viewport.get(0));
            const canvasCoords = domUtils.translateMouseCoordinates(event, this.canvas);
            const genomicLocation = ((referenceFrame.start) + referenceFrame.toBP(viewportCoords.x));

            return {
                event,
                viewport: this,
                referenceFrame,
                genomicLocation,
                y: viewportCoords.y - this.contentTop,
                canvasX: canvasCoords.x,
                canvasY: canvasCoords.y
            }

        }

        getPopupContent(event) {

            const clickState = this.createClickState(event);

            if (undefined === clickState) {
                return
            }

            let track = this.trackView.track;
            const dataList = track.popupData(clickState);

            const popupClickHandlerResult = this.browser.fireEvent('trackclick', [track, dataList]);

            let content;
            if (undefined === popupClickHandlerResult || true === popupClickHandlerResult) {
                // Indicates handler did not handle the result, or the handler wishes default behavior to occur
                if (dataList && dataList.length > 0) {
                    content = formatPopoverText(dataList);
                }

            } else if (typeof popupClickHandlerResult === 'string') {
                content = popupClickHandlerResult;
            }

            return content
        }


    }


    function formatPopoverText(nameValues) {

        const rows = nameValues.map(nameValue => {

            if (nameValue.name) {
                const str = `<span>${nameValue.name}</span>&nbsp&nbsp&nbsp${nameValue.value}`;
                return `<div title="${nameValue.value}">${str}</div>`
            } else if ('<hr>' === nameValue) { // this can be retired if nameValue.html is allowed.
                return nameValue
            } else if (nameValue.html) {
                return nameValue.html
            } else {
                return `<div title="${nameValue}">${nameValue}</div>`
            }

        });

        return rows.join('')
    }

    class FeatureCache {

        constructor(chr, tileStart, tileEnd, bpPerPixel, features, roiFeatures, multiresolution) {
            this.chr = chr;
            this.bpStart = tileStart;
            this.bpEnd = tileEnd;
            this.bpPerPixel = bpPerPixel;
            this.features = features;
            this.roiFeatures = roiFeatures;
            this.multiresolution = multiresolution;
        }

        containsRange(chr, start, end, bpPerPixel) {

            // For multi-resolution tracks allow for a 2X change in bpPerPixel
            const r = this.multiresolution ? this.bpPerPixel / bpPerPixel : 1;

            return start >= this.bpStart && end <= this.bpEnd && chr === this.chr && r > 0.5 && r < 2
        }

        overlapsRange(chr, start, end) {
            return this.chr === chr && end >= this.bpStart && start <= this.bpEnd
        }
    }

    /**
     * Decode UCSC "interact" files.  See https://genome.ucsc.edu/goldenpath/help/interact.html
     *
     0  string chrom;        "Chromosome (or contig, scaffold, etc.). For interchromosomal, use 2 records"
     1  uint chromStart;     "Start position of lower region. For interchromosomal, set to chromStart of this region"
     2  uint chromEnd;       "End position of upper region. For interchromosomal, set to chromEnd of this region"
     3  string name;         "Name of item, for display.  Usually 'sourceName/targetName/exp' or empty"
     4  uint score;          "Score (0-1000)"
     5  double value;        "Strength of interaction or other data value. Typically basis for score"
     6  string exp;          "Experiment name (metadata for filtering). Use . if not applicable"
     7  string color;        "Item color.  Specified as r,g,b or hexadecimal #RRGGBB or html color name, as in //www.w3.org/TR/css3-color/#html4. Use 0 and spectrum setting to shade by score"
     8  string sourceChrom;  "Chromosome of source region (directional) or lower region. For non-directional interchromosomal, chrom of this region."
     9  uint sourceStart;    "Start position in chromosome of source/lower/this region"
     10 uint sourceEnd;      "End position in chromosome of source/lower/this region"
     11 string sourceName;   "Identifier of source/lower/this region"
     12 string sourceStrand; "Orientation of source/lower/this region: + or -.  Use . if not applicable"
     13 string targetChrom;  "Chromosome of target region (directional) or upper region. For non-directional interchromosomal, chrom of other region"
     14 uint targetStart;    "Start position in chromosome of target/upper/this region"
     15 uint targetEnd;      "End position in chromosome of target/upper/this region"
     16 string targetName;   "Identifier of target/upper/this region"
     17 string targetStrand; "Orientation of target/upper/this region: + or -.  Use . if not applicable"
     *
     * @param tokens
     * @param ignore
     * @returns {*}
     */
    function decodeInteract(tokens, header) {

        if (tokens.length < 6) {
            console.log("Skipping line: " + tokens.join(' '));
            return undefined
        }

        var feature = {
            chr: tokens[0],
            start: tokens[1],
            end: tokens[2],

            chr1: tokens[8],
            start1: Number.parseInt(tokens[9]),
            end1: Number.parseInt(tokens[10]),

            chr2: tokens[13],
            start2: Number.parseInt(tokens[14]),
            end2: Number.parseInt(tokens[15]),

            name: tokens[3],
            score: Number(tokens[4]),
            value: Number(tokens[5]),
            color: tokens[7] === '.' ? undefined : tokens[7] === "0" ? "rgb(0,0,0)" : tokens[7],

        };

        return feature
    }

    /**
     * Some interpretations of the sequence ontology needed to assemble GFF transcripts.
     *
     */

    const transcriptTypes = new Set(['transcript', 'primary_transcript', 'processed_transcript', 'mRNA', 'mrna',
        'lnc_RNA', 'miRNA', 'ncRNA', 'rRNA', 'scRNA', 'snRNA', 'snoRNA', 'tRNA']);
    const cdsTypes = new Set(['CDS', 'cds']);
    const codonTypes = new Set(['start_codon', 'stop_codon']);
    const utrTypes = new Set(['5UTR', '3UTR', 'UTR', 'five_prime_UTR', 'three_prime_UTR', "3'-UTR", "5'-UTR"]);
    const exonTypes = new Set(['exon', 'coding-exon']);

    const transcriptPartTypes = new Set();
    for (let cltn of [cdsTypes, codonTypes, utrTypes, exonTypes]) {
        for (let t of cltn) {
            transcriptPartTypes.add(t);
        }
    }

    function isExon(type) {
        return exonTypes.has(type)
    }

    function isIntron(type) {
        return type.includes("intron")
    }

    function isCoding(type) {
        return cdsTypes.has(type) || codonTypes.has(type)
    }

    function isUTR(type) {
        return utrTypes.has(type)
    }

    function isTranscript(type) {
        return transcriptTypes.has(type) || type.endsWith("RNA") || type.endsWith("transcript")
    }

    function isTranscriptPart(type) {
        return transcriptPartTypes.has(type) || type.endsWith("RNA") || isIntron(type)
    }

    const filterPopupProperties = new Set(["id", "parent", "name"]);

    class GFFFeature {

        constructor(properties) {
            Object.assign(this, properties);
        }

        popupData(genomicLocation) {

            const pd = this.geneObject ? this.geneObject.popupData() : [];

            if (this.geneObject) {
                pd.push('<hr/>');
            }

            if (this.name) {
                pd.push({name: 'Name', value: this.name});
            }

            pd.push({name: 'Type', value: this.type});
            pd.push({name: 'Source', value: this.source});
            if (this.score !== undefined) {
                pd.push({name: 'Score', value: this.score});
            }

            if (this.attributeString) {
                const atts = parseAttributeString(this.attributeString, this.delim);
                for (let [key, value] of atts) {
                    if (value !== undefined && value.length > 0 && !filterPopupProperties.has(key.toLowerCase())) {
                        pd.push({name: key + ":", value: value});
                    }
                }
            }
            pd.push({
                name: 'Location',
                value: `${this.chr}:${numberFormatter$1(this.start + 1)}-${numberFormatter$1(this.end)}`
            });
            return pd
        }

        getAttributeValue(attributeName) {
            if (this.hasOwnProperty(attributeName)) {
                return this[attributeName]
            } else {
                // TODO -- fetch from attribute string and cache
                if (!this._attributeCache) {
                    this._attributeCache = new Map();
                }
                if (this._attributeCache.has(attributeName)) {
                    return this._attributeCache.get(attributeName)
                } else {
                    const atts = parseAttributeString(this.attributeString, this.delim);
                    let v;
                    for (let [key, value] of atts) {
                        if (key === attributeName) {
                            v = value;
                            break
                        }
                    }
                    this._attributeCache.set(attributeName, v);
                    return v
                }
            }
        }
    }

    class GFFTranscript extends GFFFeature {

        constructor(feature) {
            super(feature);
            this.exons = [];
            this.parts = [];
        }

        addExon(feature) {

            this.exons.push(feature);

            // Expand feature --  for transcripts not explicitly represented in the file (gtf)
            this.start = Math.min(this.start, feature.start);
            this.end = Math.max(this.end, feature.end);
        }

        addPart(feature) {
            this.parts.push(feature);
        }

        assembleParts() {

            if (this.parts.length === 0) return

            this.parts.sort(function (a, b) {
                return a.start - b.start
            });

            // Create exons, if neccessary
            let lastStart = this.parts[0].start;
            let lastEnd = this.parts[0].end;
            for (let i = 1; i < this.parts.length; i++) {
                const part = this.parts[i];
                if (isIntron(part.type)) {
                    continue
                }
                if (part.start <= lastEnd) {
                    lastEnd = Math.max(lastEnd, part.end);
                } else {
                    let exon = this.findExonContaining({start: lastStart, end: lastEnd});
                    if (!exon) {
                        this.exons.push({start: lastStart, end: lastEnd, psuedo: true});
                    }
                    lastStart = part.start;
                    lastEnd = part.end;
                }
            }
            let exon = this.findExonContaining({start: lastStart, end: lastEnd});
            if (!exon) {
                this.exons.push({start: lastStart, end: lastEnd, psuedo: true});
                this.start = Math.min(this.start, lastStart);
                this.end = Math.max(this.end, lastEnd);
            }


            for (let part of this.parts) {
                const type = part.type;
                if (isCoding(type)) {
                    this.addCDS(part);
                } else if (isUTR(type)) {
                    this.addUTR(part);
                }
            }
        }

        findExonContaining({start, end}) {
            for (let exon of this.exons) {
                if (exon.end >= end && exon.start <= start) {
                    return exon
                }
            }
            return undefined
        }

        addCDS(cds) {

            let exon;
            const exons = this.exons;

            for (let e of exons) {
                if (e.start <= cds.start && e.end >= cds.end) {
                    exon = e;
                    break
                }
            }

            if (exon) {
                exon.cdStart = exon.cdStart ? Math.min(cds.start, exon.cdStart) : cds.start;
                exon.cdEnd = exon.cdEnd ? Math.max(cds.end, exon.cdEnd) : cds.end;
            } else {
                // cds.cdStart = cds.start
                // cds.cdEnd = cds.end
                // exons.push(cds)
                console.error("No exon found spanning " + cds.start + "-" + cds.end);
            }

            // Expand feature --  for transcripts not explicitly represented in the file (gtf files)
            // this.start = Math.min(this.start, cds.start);
            // this.end = Math.max(this.end, cds.end);

            this.cdStart = this.cdStart ? Math.min(cds.start, this.cdStart) : cds.start;
            this.cdEnd = this.cdEnd ? Math.max(cds.end, this.cdEnd) : cds.end;
        }

        addUTR(utr) {

            let exon;
            const exons = this.exons;

            // Find exon containing CDS
            for (let i = 0; i < exons.length; i++) {
                if (exons[i].start <= utr.start && exons[i].end >= utr.end) {
                    exon = exons[i];
                    break
                }
            }

            if (exon) {
                if (utr.start === exon.start && utr.end === exon.end) {
                    exon.utr = true;
                } else {
                    if (utr.end < exon.end) {
                        exon.cdStart = utr.end;
                    }
                    if (utr.start > exon.start) {
                        exon.cdEnd = utr.start;
                    }
                }

            } else {
                // utr.utr = true
                // exons.push(utr)
                console.error("No exon found spanning " + cds.start + "-" + cds.end);
            }

            // Expand feature --  for transcripts not explicitly represented in the file
            // this.start = Math.min(this.start, utr.start);
            // this.end = Math.max(this.end, utr.end);

        }

        finish() {

            this.assembleParts();

            var cdStart = this.cdStart;
            var cdEnd = this.cdEnd;

            this.exons.sort(function (a, b) {
                return a.start - b.start
            });

            // Search for UTR exons that were not explicitly tagged
            if (cdStart) {
                this.exons.forEach(function (exon) {
                    if (exon.end < cdStart || exon.start > cdEnd) exon.utr = true;
                });
            }
        }

        popupData(genomicLocation) {

            const pd = super.popupData(genomicLocation);

            // If clicked over an exon add its attributes
            for (let exon of this.exons) {
                if (exon.pseudo) continue  // An implicit exon
                if (genomicLocation >= exon.start && genomicLocation < exon.end && typeof exon.popupData === 'function') {
                    pd.push('<hr/>');
                    const exonData = exon.popupData(genomicLocation);
                    for (let att of exonData) {
                        pd.push(att);
                    }
                }
            }

            for (let part of this.parts) {
                if (genomicLocation >= part.start && genomicLocation < part.end && typeof part.popupData === 'function') {
                    pd.push('<hr/>');
                    const partData = part.popupData(genomicLocation);
                    for (let att of partData) {
                        pd.push(att);
                    }
                }
            }


            return pd
        }
    }

    function decode(tokens, header) {

        const format = header.format;
        if (tokens.length < 9) {
            return undefined      // Not a valid gff record
        }

        const delim = ('gff3' === format) ? '=' : ' ';
        return new GFFFeature({
            source: decodeGFFAttribute(tokens[1]),
            type: tokens[2],
            chr: tokens[0],
            start: parseInt(tokens[3]) - 1,
            end: parseInt(tokens[4]),
            score: "." === tokens[5] ? undefined : Number(tokens[5]),
            strand: tokens[6],
            phase: "." === tokens[7] ? 0 : parseInt(tokens[7]),
            attributeString: tokens[8],
            delim: delim
        })
    }


    /**
     * Decode a single gff record (1 line in file).  Aggregations such as gene models are constructed at a higher level.
     *      ctg123 . mRNA            1050  9000  .  +  .  ID=mRNA00001;Parent=gene00001
     * @param tokens
     * @param ignore
     * @returns {*}
     */
    function decodeGFF3(tokens, header) {

        const feature = decode(tokens, header);

        if (!feature) {
            return
        }

        const attributes = parseAttributeString(feature.attributeString, feature.delim);

        // Search for color value as case insenstivie key
        for (let [key, value] of attributes) {
            const keyLower = key.toLowerCase();
            if ("color" === keyLower || "colour" === keyLower) {
                feature.color = IGVColor.createColorString(value);
            } else if (key === "ID") {
                feature.id = value;
            } else if (key === "Parent") {
                feature.parent = value;
            }
        }
        return feature
    }

    /**
     * GTF format example:
     NC_000008.11    BestRefSeq    gene    127735434    127742951    .    +    .    gene_id "MYC"; transcript_id ""; db_xref "GeneID:4609"; db_xref "HGNC:HGNC:7553"; db_xref "MIM:190080"; description "MYC proto-oncogene, bHLH transcription factor"; gbkey "Gene"; gene "MYC"; gene_biotype "protein_coding"; gene_synonym "bHLHe39"; gene_synonym "c-Myc"; gene_synonym "MRTL"; gene_synonym "MYCC";
     NC_000008.11    BestRefSeq    transcript    127735434    127742951    .    +    .    gene_id "MYC"; transcript_id "NM_001354870.1"; db_xref "GeneID:4609"; gbkey "mRNA"; gene "MYC"; product "MYC proto-oncogene, bHLH transcription factor, transcript variant 2"; transcript_biotype "mRNA";
     NC_000008.11    BestRefSeq    exon    127735434    127736623    .    +    .    gene_id "MYC"; transcript_id "NM_001354870.1"; db_xref "GeneID:4609"; gene "MYC"; product "MYC proto-oncogene, bHLH transcription factor, transcript variant 2"; transcript_biotype "mRNA"; exon_number "1";
     *
     * @param tokens
     * @param ignore
     * @returns {*}
     */
    function decodeGTF(tokens, header) {

        const feature = decode(tokens, header);

        if (!feature) {
            return
        }

        const attributes = parseAttributeString(feature.attributeString, feature.delim);

        // GTF files specify neither ID nor parent fields, but they can be inferred from common conventions
        let idField;
        let parentField;
        switch (feature.type) {
            case "gene":
                idField = "gene_id";
                break
            case "transcript":
                idField = "transcript_id";
                parentField = "gene_id";
                break
            default:
                parentField = "transcript_id";
        }

        for (let [key, value] of attributes) {
            const keyLower = key.toLowerCase();
            if ("color" === keyLower || "colour" === keyLower) {
                feature.color = IGVColor.createColorString(value);
            } else if (key === idField) {
                feature.id = value;
            } else if (key === parentField) {
                feature.parent = value;
            }
        }
        return feature

    }


    /**
     * Parse the attribute string, returning an array of key-value pairs.  An array is used rather than a map as attribute
     * keys are not required to be unique.
     *
     * @param attributeString
     * @param keyValueDelim
     * @returns {[]}
     */
    function parseAttributeString(attributeString, keyValueDelim, relaxed = false) {
        // parse 'attributes' string (see column 9 docs in https://github.com/The-Sequence-Ontology/Specifications/blob/master/gff3.md)
        var attributes = [];
        for (let kv of attributeString.split(';')) {
            kv = kv.trim();
            const idx = kv.indexOf(keyValueDelim);
            if (idx > 0 && idx < kv.length - 1) {
                const key = stripQuotes(decodeGFFAttribute(kv.substring(0, idx).trim(), relaxed));
                let value = stripQuotes(decodeGFFAttribute(kv.substring(idx + 1).trim(), relaxed));
                attributes.push([key, value]);
            }
        }
        return attributes
    }

    function stripQuotes(value) {
        if (value.startsWith('"') && value.endsWith('"')) {
            value = value.substr(1, value.length - 2);
        }
        return value
    }

    // GFF3 attributes have specific percent encoding rules, the list below are required, all others are forbidden
    /*
    tab (%09)
    newline (%0A)
    carriage return (%0D)
    % percent (%25)
    control characters (%00 through %1F, %7F)
    In addition, the following characters have reserved meanings in column 9 and must be escaped when used in other contexts:
    ; semicolon (%3B)
    = equals (%3D)
    & ampersand (%26)
    , comma (%2C)
     */

    const encodings = new Map([
        ["%09", "\t"],
        ["%0A", "\n"],
        ["%0D", "\r"],
        ["%25", "%"],
        ["%3B", ";"],
        ["%3D", "="],
        ["%26", "&"],
        ["%2C", ","]
    ]);

    function decodeGFFAttribute(str, relaxed = false) {

        if (!str.includes("%")) {
            return str
        }
        if (relaxed) {
            return decodeURIComponent(str);
        }
        let decoded = "";
        for (let i = 0; i < str.length; i++) {

            if (str.charCodeAt(i) === 37 && i < str.length - 2) {
                const key = str.substring(i, i + 3);
                if (encodings.has(key)) {
                    decoded += encodings.get(key);
                } else {
                    decoded += key;
                }
                i += 2;
            } else {
                decoded += str.charAt(i);
            }
        }
        return decoded

    }

    /**
     * Wrapper class to record a decoding error.
     */

    class DecodeError {
        constructor(message) {
            this.message = message;
        }
    }

    /**
     * Decode the UCSC bed format.  Only the first 3 columns (chr, start, end) are required.   The remaining columns
     * must follow standard bed order, but we will tolerate deviations after column 3.
     *
     * @param tokens
     * @param ignore
     * @returns decoded feature, or null if this is not a valid record
     */
    function decodeBed(tokens, header) {


        if (tokens.length < 3) return undefined

        header && header.gffTags;

        const chr = tokens[0];
        const start = parseInt(tokens[1]);
        const end = tokens.length > 2 ? parseInt(tokens[2]) : start + 1;
        if (isNaN(start) || isNaN(end)) {
            return new DecodeError(`Unparsable bed record.`)
        }
        const feature = new UCSCBedFeature({chr: chr, start: start, end: end, score: 1000});

        try {
            if (tokens.length > 3) {

                // Potentially parse name field as GFF column 9 style streng.
                if (tokens[3].indexOf(';') > 0 && tokens[3].indexOf('=') > 0) {
                    const attributeKVs = parseAttributeString(tokens[3], '=', true);
                    feature.attributes = {};
                    for (let kv of attributeKVs) {
                        feature.attributes[kv[0]] = kv[1];
                        if (header.nameField != undefined && kv[0] === header.nameField) {
                            feature.name = kv[1];
                        }
                    }
                }
                if (!feature.name) {
                    feature.name = tokens[3] === '.' ? '' : tokens[3];
                }
            }

            if (tokens.length > 4) {
                feature.score = tokens[4] === '.' ? 0 : Number(tokens[4]);
                if (isNaN(feature.score)) {
                    return feature
                }
            }

            if (tokens.length > 5) {
                feature.strand = tokens[5];
                if (!(feature.strand === '.' || feature.strand === '+' || feature.strand === '-')) {
                    return feature
                }
            }

            if (tokens.length > 6) {
                feature.cdStart = parseInt(tokens[6]);
                if (isNaN(feature.cdStart)) {
                    return feature
                }
            }

            if (tokens.length > 7) {
                feature.cdEnd = parseInt(tokens[7]);
                if (isNaN(feature.cdEnd)) {
                    return feature
                }
            }

            if (tokens.length > 8) {
                if (tokens[8] !== "." && tokens[8] !== "0")
                    feature.color = IGVColor.createColorString(tokens[8]);
            }

            if (tokens.length > 11) {
                const exonCount = parseInt(tokens[9]);
                // Some basic validation
                if (exonCount > 1000) {
                    // unlikely
                    return feature
                }

                const exonSizes = tokens[10].replace(/,$/, '').split(',');
                const exonStarts = tokens[11].replace(/,$/, '').split(',');
                if (!(exonSizes.length === exonStarts.length && exonCount === exonSizes.length)) {
                    return feature
                }

                const exons = [];
                for (let i = 0; i < exonCount; i++) {
                    const eStart = start + parseInt(exonStarts[i]);
                    const eEnd = eStart + parseInt(exonSizes[i]);
                    exons.push({start: eStart, end: eEnd});
                }
                if (exons.length > 0) {
                    findUTRs$1(exons, feature.cdStart, feature.cdEnd);
                    feature.exons = exons;
                }
            }

            // Optional extra columns
            if (header) {
                let thicknessColumn = header.thicknessColumn;
                let colorColumn = header.colorColumn;
                if (colorColumn && colorColumn < tokens.length) {
                    feature.color = IGVColor.createColorString(tokens[colorColumn]);
                }
                if (thicknessColumn && thicknessColumn < tokens.length) {
                    feature.thickness = tokens[thicknessColumn];
                }
            }
        } catch
            (e) {

        }

        return feature
    }

    /**
     * Decode a UCSC repeat masker record.
     */
    function decodeRepeatMasker(tokens, header) {

        /**
         * Columns, from UCSC documentation
         *
         * 0  bin    585    smallint(5) unsigned    Indexing field to speed chromosome range queries.
         * 1  swScore    1504    int(10) unsigned    Smith Waterman alignment score
         * 2  milliDiv    13    int(10) unsigned    Base mismatches in parts per thousand
         * 3  milliDel    4    int(10) unsigned    Bases deleted in parts per thousand
         * 4  milliIns    13    int(10) unsigned    Bases inserted in parts per thousand
         * 5  genoName    chr1    varchar(255)    Genomic sequence name
         * 6  genoStart    10000    int(10) unsigned    Start in genomic sequence
         * 7  genoEnd    10468    int(10) unsigned    End in genomic sequence
         * 8  genoLeft    -249240153    int(11)    -#bases after match in genomic sequence
         * 9  strand    +    char(1)    Relative orientation + or -
         * 10 repName    (CCCTAA)n    varchar(255)    Name of repeat
         * 11 repClass    Simple_repeat    varchar(255)    Class of repeat
         * 12 repFamily    Simple_repeat    varchar(255)    Family of repeat
         * 13 repStart    1    int(11)    Start (if strand is +) or -#bases after match (if strand is -) in repeat sequence
         * 14 repEnd    463    int(11)    End in repeat sequence
         * 15 repLeft    0    int(11)    -#bases after match (if strand is +) or start (if strand is -) in repeat sequence
         * 16 id    1    char(1)    First digit of id field in RepeatMasker .out file. Best ignored.
         */
        if (tokens.length <= 15) return undefined

        const feature = {
            swScore: Number.parseInt(tokens[1]),
            milliDiv: Number.parseInt(tokens[2]),
            milliDel: Number.parseInt(tokens[3]),
            milliIns: Number.parseInt(tokens[4]),
            chr: tokens[5],
            start: Number.parseInt(tokens[6]),
            end: Number.parseInt(tokens[7]),
            //genoLeft: tokens[8],
            strand: tokens[9],
            repName: tokens[10],
            repClass: tokens[11],
            repFamily: tokens[12],
            repStart: Number.parseInt(tokens[13]),
            repEnd: Number.parseInt(tokens[14]),
            repLeft: Number.parseInt(tokens[15])
        };

        return feature

    }

    /**
     * Decode a UCSC "genePred" record.
     *
     * @param tokens
     * @param ignore
     * @returns {*}
     */
    function decodeGenePred(tokens, header) {

        var shift = header.shift === undefined ? 0 : 1;

        if (tokens.length <= 9 + shift) return undefined

        const cdStart = parseInt(tokens[5 + shift]);
        const cdEnd = parseInt(tokens[6 + shift]);
        var feature = {
            name: tokens[0 + shift],
            chr: tokens[1 + shift],
            strand: tokens[2 + shift],
            start: parseInt(tokens[3 + shift]),
            end: parseInt(tokens[4 + shift]),
            cdStart: cdStart,
            cdEnd: cdEnd,
            id: tokens[0 + shift]
        };
        const exons = decodeExons(parseInt(tokens[7 + shift]), tokens[8 + shift], tokens[9 + shift]);
        findUTRs$1(exons, cdStart, cdEnd);

        feature.exons = exons;

        return feature

    }

    /**
     * Decode a UCSC "genePredExt" record.  refGene files are in this format.
     *
     * @param tokens
     * @param ignore
     * @returns {*}
     */
    function decodeGenePredExt(tokens, header) {

        var shift = header.shift === undefined ? 0 : 1;

        if (tokens.length <= 11 + shift) return undefined

        const cdStart = parseInt(tokens[5 + shift]);
        const cdEnd = parseInt(tokens[6 + shift]);
        const feature = {
            name: tokens[11 + shift],
            chr: tokens[1 + shift],
            strand: tokens[2 + shift],
            start: parseInt(tokens[3 + shift]),
            end: parseInt(tokens[4 + shift]),
            cdStart: cdStart,
            cdEnd: cdEnd,
            id: tokens[0 + shift]
        };

        const exons = decodeExons(parseInt(tokens[7 + shift]), tokens[8 + shift], tokens[9 + shift]);
        findUTRs$1(exons, cdStart, cdEnd);

        feature.exons = exons;

        return feature
    }

    /**
     * Decode a UCSC "refFlat" record
     * @param tokens
     * @param ignore
     * @returns {*}
     */
    function decodeReflat(tokens, header) {

        var shift = header.shift === undefined ? 0 : 1;

        if (tokens.length <= 10 + shift) return undefined

        const cdStart = parseInt(tokens[6 + shift]);
        const cdEnd = parseInt(tokens[7 + shift]);
        var feature = {
            name: tokens[0 + shift],
            id: tokens[1 + shift],
            chr: tokens[2 + shift],
            strand: tokens[3 + shift],
            start: parseInt(tokens[4 + shift]),
            end: parseInt(tokens[5 + shift]),
            cdStart: cdStart,
            cdEnd: cdEnd
        };

        const exons = decodeExons(parseInt(tokens[8 + shift]), tokens[9 + shift], tokens[10 + shift]);
        findUTRs$1(exons, cdStart, cdEnd);
        feature.exons = exons;

        return feature
    }

    /**
     * Decode a UCS PSL record *
     * @param tokens
     * @param header
     * @returns {DecodeError|UCSCBedFeature|undefined}
     */
    function decodePSL(tokens, header) {

        /*
        * 0 matches - Number of bases that match that aren't repeats
        * 1 misMatches - Number of bases that don't match
        * 2 repMatches - Number of bases that match but are part of repeats
        * 3 nCount - Number of "N" bases
        * 4 qNumInsert - Number of inserts in query
        * 5 qBaseInsert - Number of bases inserted in query
        * 6 tNumInsert - Number of inserts in target
        * 7 tBaseInsert - Number of bases inserted in target
        * 8 strand - "+" or "-" for query strand. For translated alignments, second "+"or "-" is for target genomic strand.
        * 9 qName - Query sequence name
        * 10 qSize - Query sequence size.
        * 11 qStart - Alignment start position in query
        * 12 qEnd - Alignment end position in query
        * 13 tName - Target sequence name
        * 14 tSize - Target sequence size
        * 15 tStart - Alignment start position in target
        * 16 tEnd - Alignment end position in target
        * 17 blockCount - Number of blocks in the alignment (a block contains no gaps)
        * 18 blockSizes - Comma-separated list of sizes of each block. If the query is a protein and the target the genome, blockSizes are in amino acids. See below for more information on protein query PSLs.
        * 19 qStarts - Comma-separated list of starting positions of each block in query
        * 20 tStarts - Comma-separated list of starting positions of each block in target
         */


        if (tokens.length < 21) return undefined

        const chr = tokens[13];
        const start = parseInt(tokens[15]);
        const end = parseInt(tokens[16]);
        const strand = tokens[8].charAt(0);
        const exonCount = parseInt(tokens[17]);
        const exons = [];
        const exonStarts = tokens[20].replace(/,$/, '').split(',');
        const exonSizes = tokens[18].replace(/,$/, '').split(',');

        for (let i = 0; i < exonCount; i++) {
            const start = parseInt(exonStarts[i]);
            const end = start + parseInt(exonSizes[i]);
            exons.push({start: start, end: end});
        }

        return new PSLFeature({chr, start, end, strand, exons, tokens})
    }


    function decodeExons(exonCountToken, exonStartsToken, exonEndsToken) {

        const exonCount = parseInt(exonCountToken);
        const exonStarts = exonStartsToken.replace(/,$/, '').split(',');
        const exonEnds = exonEndsToken.replace(/,$/, '').split(',');
        const exons = [];
        for (let i = 0; i < exonCount; i++) {
            const start = parseInt(exonStarts[i]);
            const end = parseInt(exonEnds[i]);
            exons.push({start: start, end: end});
        }
        return exons

    }

    function findUTRs$1(exons, cdStart, cdEnd) {

        for (let exon of exons) {
            const end = exon.end;
            const start = exon.start;
            if (end < cdStart || start > cdEnd) {
                exon.utr = true;
            } else {
                if (cdStart >= start && cdStart <= end) {
                    exon.cdStart = cdStart;
                }
                if (cdEnd >= start && cdEnd <= end) {
                    exon.cdEnd = cdEnd;
                }
            }
        }

    }

    function decodePeak(tokens, header) {

        var tokenCount, chr, start, end, strand, name, score, qValue, signal, pValue;

        tokenCount = tokens.length;
        if (tokenCount < 9) {
            return undefined
        }

        chr = tokens[0];
        start = parseInt(tokens[1]);
        end = parseInt(tokens[2]);
        name = tokens[3];
        score = Number(tokens[4]);
        strand = tokens[5].trim();
        signal = Number(tokens[6]);
        pValue = Number(tokens[7]);
        qValue = Number(tokens[8]);

        if (score === 0) score = signal;

        return {
            chr: chr, start: start, end: end, name: name, score: score, strand: strand, signal: signal,
            pValue: pValue, qValue: qValue
        }
    }

    function decodeBedGraph(tokens, header) {

        var chr, start, end, value;

        if (tokens.length <= 3) return undefined

        chr = tokens[0];
        start = parseInt(tokens[1]);
        end = parseInt(tokens[2]);
        value = Number(tokens[3]);
        const feature = {chr: chr, start: start, end: end, value: value};

        // Optional extra columns
        if (header) {
            let colorColumn = header.colorColumn;
            if (colorColumn && colorColumn < tokens.length) {
                feature.color = IGVColor.createColorString(tokens[colorColumn]);
            }
        }

        return feature
    }

    function decodeWig(tokens, header) {

        const wig = header.wig;

        if (wig && wig.format === "fixedStep") {
            const ss = (wig.index * wig.step) + wig.start;
            const ee = ss + wig.span;
            const value = Number(tokens[0]);
            ++(wig.index);
            return isNaN(value) ? null : {chr: wig.chrom, start: ss, end: ee, value: value}
        } else if (wig && wig.format === "variableStep") {

            if (tokens.length < 2) return null
            const ss = parseInt(tokens[0], 10) - 1;
            const ee = ss + wig.span;
            const value = Number(tokens[1]);
            return isNaN(value) ? null : {chr: wig.chrom, start: ss, end: ee, value: value}

        } else {
            return decodeBedGraph(tokens)
        }
    }

    function decodeSNP(tokens, header) {

        if (tokens.length < 6) return undefined

        const autoSql = [
            'bin',
            'chr',
            'start',
            'end',
            'name',
            'score',
            'strand',
            'refNCBI',
            'refUCSC',
            'observed',
            'molType',
            'class',
            'valid',
            'avHet',
            'avHetSE',
            'func',
            'locType',
            'weight',
            'exceptions',
            'submitterCount',
            'submitters',
            'alleleFreqCount',
            'alleles',
            'alleleNs',
            'alleleFreqs',
            'bitfields'
        ];


        const feature = {
            chr: tokens[1],
            start: Number.parseInt(tokens[2]),
            end: Number.parseInt(tokens[3]),
            name: tokens[4],
            score: Number.parseInt(tokens[5])
        };

        const n = Math.min(tokens.length, autoSql.length);
        for (let i = 6; i < n; i++) {
            feature[autoSql[i]] = tokens[i];
        }
        return feature

    }

    class UCSCBedFeature {

        constructor(properties) {
            Object.assign(this, properties);
        }

        getAttributeValue(attributeName) {
            if (this.hasOwnProperty(attributeName)) {
                return this[attributeName]
            } else if (this.attributes) {
                return this.attributes[attributeName]
            }
        }
    }

    /*
    * 0 matches - Number of bases that match that aren't repeats
    * 1 misMatches - Number of bases that don't match
    * 2 repMatches - Number of bases that match but are part of repeats
    * 3 nCount - Number of "N" bases
    * 4 qNumInsert - Number of inserts in query
    * 5 qBaseInsert - Number of bases inserted in query
    * 6 tNumInsert - Number of inserts in target
    * 7 tBaseInsert - Number of bases inserted in target
    * 8 strand - "+" or "-" for query strand. For translated alignments, second "+"or "-" is for target genomic strand.
    * 9 qName - Query sequence name
    * 10 qSize - Query sequence size.
    * 11 qStart - Alignment start position in query
    * 12 qEnd - Alignment end position in query
    * 13 tName - Target sequence name
    * 14 tSize - Target sequence size
    * 15 tStart - Alignment start position in target
    * 16 tEnd - Alignment end position in target
    * 17 blockCount - Number of blocks in the alignment (a block contains no gaps)
    * 18 blockSizes - Comma-separated list of sizes of each block. If the query is a protein and the target the genome, blockSizes are in amino acids. See below for more information on protein query PSLs.
    * 19 qStarts - Comma-separated list of starting positions of each block in query
    * 20 tStarts - Comma-separated list of starting positions of each block in target
     */

    class PSLFeature {


        constructor(properties) {
            Object.assign(this, properties);
        }

        get score() {
            const tokens = this.tokens;
            const match = parseInt(tokens[0]);
            const repMatch = parseInt(tokens[2]);
            const misMatch = parseInt(tokens[1]);
            const qGapCount = parseInt(tokens[4]);
            const tGapCount = parseInt(tokens[6]);
            const qSize = parseInt(tokens[10]);
            return Math.floor((1000 * (match + repMatch - misMatch - qGapCount - tGapCount)) / qSize)
        }

        get matches() {
            return this.tokens[0]
        }

        get misMatches() {
            return this.tokens[1]
        }

        get repMatches() {
            return this.tokens[2]
        }

        get nCount() {
            return this.tokens[3]
        }

        get qNumInsert() {
            return this.tokens[4]
        }

        get qBaseInsert() {
            return this.tokens[5]
        }

        get tNumInsert() {
            return this.tokens[6]
        }

        get tBaseInsert() {
            return this.tokens[7]

        }

        popupData() {
            return [
                {name: 'chr', value: this.chr},
                {name: 'start', value: this.start + 1},
                {name: 'end', value: this.end},
                {name: 'strand', value: this.strand},
                {name: 'score', value: this.score},
                {name: 'match', value: this.matches},
                {name: "mis-match", value: this.misMatches},
                {name: "rep. match", value: this.repMatches},
                {name: "N's", value: this.nCount},
                {name: 'Q gap count', value: this.qNumInsert},
                {name: 'Q gap bases', value: this.qBaseInsert},
                {name: 'T gap count', value: this.tNumInsert},
                {name: 'T gap bases', value: this.tBaseInsert},
            ]
        }

    }

    function decodeFusionJuncSpan(tokens, header) {

        /*
         Format:

         0       #scaffold
         1       fusion_break_name
         2       break_left
         3       break_right
         4       num_junction_reads
         5       num_spanning_frags
         6       spanning_frag_coords

         0       B3GNT1--NPSR1
         1       B3GNT1--NPSR1|2203-10182
         2       2203
         3       10182
         4       189
         5       1138
         6       1860-13757,1798-13819,1391-18127,1443-17174,...

         */


        if (tokens.length < 7) return undefined

        var chr = tokens[0];
        var fusion_name = tokens[1];
        var junction_left = parseInt(tokens[2]);
        var junction_right = parseInt(tokens[3]);
        var num_junction_reads = parseInt(tokens[4]);
        var num_spanning_frags = parseInt(tokens[5]);

        var spanning_frag_coords_text = tokens[6];

        var feature = {
            chr: chr,
            name: fusion_name,
            junction_left: junction_left,
            junction_right: junction_right,
            num_junction_reads: num_junction_reads,
            num_spanning_frags: num_spanning_frags,
            spanning_frag_coords: [],

            start: -1,
            end: -1
        }; // set start and end later based on min/max of span coords

        var min_coord = junction_left;
        var max_coord = junction_right;

        if (num_spanning_frags > 0) {

            var coord_pairs = spanning_frag_coords_text.split(',');

            for (var i = 0; i < coord_pairs.length; i++) {
                var split_coords = coord_pairs[i].split('-');

                var span_left = split_coords[0];
                var span_right = split_coords[1];

                if (span_left < min_coord) {
                    min_coord = span_left;
                }
                if (span_right > max_coord) {
                    max_coord = span_right;
                }
                feature.spanning_frag_coords.push({left: span_left, right: span_right});

            }
        }

        feature.start = min_coord;
        feature.end = max_coord;


        return feature

    }

    function decodeGtexGWAS(tokens, header) {
        //chrom	chromStart	chromEnd	Strongest SNP-risk allele	Disease/Phenotype	P-value	Odds ratio or beta	PUBMEDID
        //1	1247493	1247494	rs12103-A	Inflammatory bowel disease	8.00E-13	1.1	23128233

        const tokenCount = tokens.length;
        if (tokenCount < 7) {
            return null
        }
        const feature = {
            chr: tokens[0],
            start: parseInt(tokens[1]) - 1,
            end: parseInt(tokens[2]),
            'Strongest SNP-risk allele': tokens[3],
            'Disease/Phenotype': tokens[4],
            'P-value': tokens[5],
            'Odds ratio or beta': tokens[6],
        };
        if (tokens.length > 6) {
            feature['PUBMEDID'] = `<a target = "blank" href = "https://www.ncbi.nlm.nih.gov/pubmed/${tokens[7]}">${tokens[7]}</a>`;
        }
        return feature
    }

    /**
     * Decode a custom columnar format.  Required columns are 'chr' and 'start'
     *
     * @param tokens
     * @param ignore
     * @returns decoded feature, or null if this is not a valid record
     */
    function decodeCustom(tokens, header) {

        const format = header.customFormat;

        if (tokens.length < format.fields.length) return undefined

        const coords = format.coords || 0;

        const chr = tokens[format.chr];
        const start = parseInt(tokens[format.start]) - coords;
        const end = format.end !== undefined ? parseInt(tokens[format.end]) : start + 1;

        const feature = {chr: chr, start: start, end: end};

        if (format.fields) {
            format.fields.forEach(function (field, index) {

                if (index !== format.chr &&
                    index !== format.start &&
                    index !== format.end) {

                    feature[field] = tokens[index];
                }
            });
        }

        return feature

    }

    /**
     * Decode a gcnv record, a bed style format encoding copy number variation
     *
     * @param tokens
     * @param header
     */

    function decodeGcnv(tokens, header) {

        const columnNames = header.columnNames;
        if (!columnNames) {
            throw Error("Sample names are not defined.   Missing column headers?")
        }
        const sampleCount = columnNames.length - 3;

        const chr = tokens[0];
        const start = parseInt(tokens[1]);
        const end = parseInt(tokens[2]);
        const values = tokens.slice(3).map(Number);

        if (values.length == sampleCount) {
            return {
                chr: chr,
                start: start,
                end: end,
                values: values,
            }
        } else {
            // TODO Throw error?
            console.warn(`${chr}:${start}-${end} row contains ${values.length} sample columns instead of the expected ${sampleCount} columns. Skipping...`);
            return undefined
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    /**
     *  Parser for column style (tab delimited, etc) text file formats (bed, gff, vcf, etc).
     *
     *
     */


    /**
     * Return a parser for the given file format.
     */
    class FeatureParser {

        constructor(config) {

            this.config = config;
            this.header = {};
            if (config.nameField) {
                this.header.nameField = config.nameField;
            }

            this.skipRows = 0;   // The number of fixed header rows to skip.  Override for specific types as needed

            if (config.decode) {
                this.decode = config.decode;
                this.delimiter = config.delimiter || "\t";
            } else if (config.format) {
                this.header.format = config.format.toLowerCase();
                this.setDecoder(this.header.format);
            }

            if (!this.delimiter) {
                this.delimiter = "\t";
            }
        }

        /**
         * Parse metadata from the file.   A variety of conventions are in use to supply metadata about file contents
         * through header lines (e.g. 'track') and # directives. This method unifies metadata as properties of a
         * 'header' object.
         *
         * @param data
         * @returns {{}}
         */
        async parseHeader(dataWrapper) {

            let header = this.header;
            let columnNames;
            let line;
            while ((line = await dataWrapper.nextLine()) !== undefined) {
                if (line.startsWith("track") || line.startsWith("#track")) {
                    let h = parseTrackLine$1(line);
                    Object.assign(header, h);
                } else if (line.startsWith("browser")) ; else if (line.startsWith("#columns")) {
                    let h = parseColumnsDirective$1(line);
                    Object.assign(header, h);
                } else if (line.startsWith("##gff-version 3")) {
                    header.format = "gff3";
                } else if (line.startsWith("#gffTags")) {
                    header.gffTags = true;
                } else if (line.startsWith("fixedStep") || line.startsWith("variableStep")) {
                    // Wig directives -- we are in the data section
                    break
                } else if (line.startsWith("#")) {
                    const tokens = line.split(this.delimiter || "\t");
                    if (tokens.length > 1) {
                        columnNames = tokens;   // Possible column names
                    }
                } else {
                    // All directives that could change the format, and thus decoder, should have been read by now.
                    this.setDecoder(header.format);

                    // If the line can be parsed as a feature assume we are beyond the header, if any
                    const tokens = line.split(this.delimiter || "\t");
                    try {
                        const tmpHeader = Object.assign({columnNames}, header);
                        if (this.decode(tokens, tmpHeader)) {
                            break
                        } else {
                            if (tokens.length > 1) {
                                columnNames = tokens; // possible column names
                            }
                        }
                    } catch (e) {
                        // Not a feature
                        if (tokens.length > 1) {
                            columnNames = tokens; // possible column names
                        }
                    }
                }
            }

            if (columnNames) {
                header.columnNames = columnNames;
                for (let n = 0; n < columnNames.length; n++) {
                    if (columnNames[n] === "color" || columnNames[n] === "colour") {
                        header.colorColumn = n;
                    } else if (columnNames[n] === "thickness") {
                        header.thicknessColumn = n;
                    }
                }
            }

            this.header = header;    // Directives might be needed for parsing lines
            return header
        }

        async parseFeatures(dataWrapper) {

            const allFeatures = [];
            const decode = this.decode;
            const format = this.header.format;
            const delimiter = this.delimiter || "\t";
            let i = 0;
            let errorCount = 0;
            let line;
            while ((line = await dataWrapper.nextLine()) !== undefined) {
                i++;
                if (i <= this.skipRows) continue

                if (!line || line.startsWith("track") || line.startsWith("#") || line.startsWith("browser")) {
                    continue
                } else if (format === "wig" && line.startsWith("fixedStep")) {
                    this.header.wig = parseFixedStep(line);
                    continue
                } else if (format === "wig" && line.startsWith("variableStep")) {
                    this.header.wig = parseVariableStep(line);
                    continue
                }

                const tokens = line.split(delimiter);
                if (tokens.length < 1) {
                    continue
                }

                const feature = decode(tokens, this.header);

                if (feature instanceof DecodeError) {
                    errorCount++;
                    if (errorCount > 0) {
                        console.error(`Error parsing line '${line}': ${feature.message}`);
                    }
                    continue
                }

                if (feature) {
                    allFeatures.push(feature);
                }
            }

            // Special hack for bedPE
            if (decode === decodeBedpe) {
                fixBedPE(allFeatures);
            }

            return allFeatures

        }

        setDecoder(format) {

            switch (format) {
                case "narrowpeak":
                case "broadpeak":
                case "regionpeak":
                case "peaks":
                    this.decode = decodePeak;
                    this.delimiter = this.config.delimiter || /\s+/;
                    break
                case "bedgraph":
                    this.decode = decodeBedGraph;
                    this.delimiter = /\s+/;
                    break
                case "wig":
                    this.decode = decodeWig;
                    this.delimiter = this.config.delimiter || /\s+/;
                    break
                case "gff3" :
                case "gff":
                    this.decode = decodeGFF3;
                    this.delimiter = "\t";
                    break
                case "gtf" :
                    this.decode = decodeGTF;
                    this.delimiter = "\t";
                    break
                case "fusionjuncspan":
                    // bhaas, needed for FusionInspector view
                    this.decode = decodeFusionJuncSpan;
                    this.delimiter = this.config.delimiter || /\s+/;
                    break
                case "gtexgwas":
                    this.skipRows = 1;
                    this.decode = decodeGtexGWAS;
                    this.delimiter = "\t";
                    break
                case "refflat":
                    this.decode = decodeReflat;
                    this.delimiter = this.config.delimiter || /\s+/;
                    break
                case "genepred":
                    this.decode = decodeGenePred;
                    this.delimiter = this.config.delimiter || /\s+/;
                    break
                case "genepredext":
                    this.decode = decodeGenePredExt;
                    this.delimiter = this.config.delimiter || /\s+/;
                    break
                case "ensgene":
                    this.decode = decodeGenePred;
                    this.header.shift = 1;
                    this.delimiter = this.config.delimiter || /\s+/;
                    break
                case "refgene":
                    this.decode = decodeGenePredExt;
                    this.delimiter = this.config.delimiter || /\s+/;
                    this.header.shift = 1;
                    break
                case "bed":
                    this.decode = decodeBed;
                    this.delimiter = this.config.delimiter || /\s+/;
                    break
                case "bedpe":
                case "hiccups":
                    this.decode = decodeBedpe;
                    this.delimiter = this.config.delimiter || "\t";
                    break
                case "bedpe-domain":
                    this.decode = decodeBedpeDomain;
                    this.headerLine = true;
                    this.delimiter = this.config.delimiter || "\t";
                    break
                case "bedpe-loop":
                    this.decode = decodeBedpe;
                    this.delimiter = this.config.delimiter || "\t";
                    this.header = {colorColumn: 7};
                    break
                case "interact":
                    this.decode = decodeInteract;
                    this.delimiter = this.config.delimiter || /\s+/;
                    break
                case "snp":
                    this.decode = decodeSNP;
                    this.delimiter = "\t";
                    break
                case "rmsk":
                    this.decode = decodeRepeatMasker;
                    this.delimiter = "\t";
                    break
                case "gcnv":
                    this.decode = decodeGcnv;
                    this.delimiter = "\t";
                    break
                default:
                    const customFormat = getFormat(format);
                    if (customFormat !== undefined) {
                        this.decode = decodeCustom;
                        this.header.customFormat = customFormat;
                        this.delimiter = customFormat.delimiter || "\t";
                    } else {
                        this.decode = decodeBed;
                        this.delimiter = this.config.delimiter || /\s+/;
                    }
            }

        }
    }

    function parseTrackLine$1(line) {

        const properties = {};
        const tokens = line.split(/(?:")([^"]+)(?:")|([^\s"]+)(?=\s+|$)/g);

        // Clean up tokens array
        let curr;
        const tmp = [];
        for (let tk of tokens) {
            if (!tk || tk.trim().length === 0) continue
            if (tk.endsWith("=")) {
                curr = tk;
            } else if (curr) {
                tmp.push(curr + tk);
                curr = undefined;
            } else {
                tmp.push(tk);
            }
        }

        for (let str of tmp) {
            if (!str) return
            var kv = str.split('=', 2);
            if (kv.length === 2) {
                const key = kv[0].trim();
                const value = kv[1].trim();
                if (properties.hasOwnProperty(key)) {
                    let currentValue = properties[key];
                    if (Array.isArray(currentValue)) {
                        currentValue.push(value);
                    } else {
                        properties[key] = [currentValue, value];
                    }
                } else {
                    properties[key] = value;
                }
            }
        }
        if ("interact" == properties["type"]) {
            properties["format"] = "interact";
        } else if ("gcnv" === properties["type"]) {
            properties["format"] = "gcnv";
        }
        return properties
    }

    function parseColumnsDirective$1(line) {

        let properties = {};
        let t1 = line.split(/\s+/);

        if (t1.length === 2) {
            let t2 = t1[1].split(";");
            t2.forEach(function (keyValue) {
                let t = keyValue.split("=");
                if (t[0] === "color") {
                    properties.colorColumn = Number.parseInt(t[1]) - 1;
                } else if (t[0] === "thickness") {
                    properties.thicknessColumn = Number.parseInt(t[1]) - 1;
                }
            });
        }

        return properties
    }

    function parseFixedStep(line) {
        const tokens = line.split(/\s+/);
        const chrom = tokens[1].split("=")[1];
        const start = parseInt(tokens[2].split("=")[1], 10) - 1;
        const step = parseInt(tokens[3].split("=")[1], 10);
        const span = (tokens.length > 4) ? parseInt(tokens[4].split("=")[1], 10) : 1;
        return {format: "fixedStep", chrom, start, step, span, index: 0}
    }

    function parseVariableStep(line) {
        const tokens = line.split(/\s+/);
        const chrom = tokens[1].split("=")[1];
        const span = tokens.length > 2 ? parseInt(tokens[2].split("=")[1], 10) : 1;
        return {format: "variableStep", chrom, span}
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2018 Regents of the University of California
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const fixColor = (colorString) => {
        if (isString$2(colorString)) {
            return (colorString.indexOf(",") > 0 && !(colorString.startsWith("rgb(") || colorString.startsWith("rgba("))) ?
                `rgb(${colorString})` : colorString
        } else {
            return colorString
        }
    };

    /**
     * A collection of properties and methods shared by all (or most) track types.
     *
     * @param config
     * @param browser
     * @constructor
     */
    class TrackBase {

        static defaults = {
            height: 50,
            autoHeight: false,
            visibilityWindow: undefined,   // Identifies property that should be copied from config
            color: undefined,  // Identifies property that should be copied from config
            altColor: undefined,  // Identifies property that should be copied from config
            supportHiDPI: true
        }

        constructor(config, browser) {
            this.browser = browser;
            this.init(config);
        }

        /**
         * Initialize track properties from the config object.  This method is typically overriden in subclasses, which
         * will call this implementation as super.init(config).
         *
         * @param config
         */
        init(config) {

            this.config = config;

            if (config.displayMode) {
                config.displayMode = config.displayMode.toUpperCase();
            }

            // Set default properties
            const defaults = Object.assign({}, TrackBase.defaults);
            if(this.constructor.defaults) {
                for(let key of Object.keys(this.constructor.defaults)) {
                    defaults[key] = this.constructor.defaults[key];
                }
            }
            for(let key of Object.keys(defaults)) {
                this[key] = config.hasOwnProperty(key) ? config[key] : defaults[key];
                if(key === 'color' || key === 'altColor') {
                    this[key] = fixColor(this[key]);
                }
            }

            if (config.name || config.label) {
                this.name = config.name || config.label;
            } else if (isFile(config.url)) {
                this.name = config.url.name;
            } else if (isString$2(config.url) && !config.url.startsWith("data:")) {
                this.name = getFilename$2(config.url);
            }

            this.url = config.url;
            if(this.config.type) this.type = this.config.type;
            this.id = this.config.id === undefined ? this.name : this.config.id;
            this.order = config.order;
            this.autoscaleGroup = config.autoscaleGroup;
            this.removable = config.removable === undefined ? true : config.removable;      // Defaults to true
            this.minHeight = config.minHeight || Math.min(25, this.height);
            this.maxHeight = config.maxHeight || Math.max(1000, this.height);

            if (config.onclick) {
                this.onclick = config.onclick;
                config.onclick = undefined;   // functions cannot be saved in sessions, clear it here.
            }

            if (config.description) {
                // Override description -- displayed when clicking on track label.  Convert to function if neccessary
                if (typeof config.description === 'function') {
                    this.description = config.description;
                } else {
                    this.description = () => config.description;
                }
            }

            // Support for mouse hover text.  This can be expensive, off by default.
            // this.hoverText = function(clickState) => return tool tip text
            if (config.hoverTextFields) {
                this.hoverText = hoverText.bind(this);
            } else if (typeof this.config.hoverText === 'function') {
                this.hoverText = this.config.hoverText;
            }
        }

        get name() {
            return this._name
        }

        set name(name) {
            this._name = name;
            if (this.trackView) {
                this.trackView.setTrackLabelName(name);
            }
        }

        /**
         * Update track properties from the config object.
         *
         * @param config
         */
        updateConfig(config) {
            this.init(config);
        }

        clearCachedFeatures() {
            if (this.trackView) {
                this.trackView.clearCachedFeatures();
            }
        }

        updateViews() {
            if (this.trackView) {
                this.trackView.updateViews();
            }
        }

        /**
         * Used to create session object for bookmarking, sharing.  Only simple property values (string, number, boolean)
         * are saved.
         */
        getState() {

            const jsonable = (v) => !(v === undefined || typeof v === 'function' || v instanceof File || v instanceof Promise);

            // Create copy of config, minus transient properties (convention is name starts with '_').  Also, all
            // function properties are transient as they cannot be saved in json
            const state = {};
            for (let key of Object.keys(this.config)) {
                if (!key.startsWith("_") && jsonable(this.config[key])) {
                    state[key] = this.config[key];
                }
            }

            // Update original config values with any changes
            for (let key of Object.keys(state)) {
                if (key.startsWith("_")) continue   // transient property
                const value = this[key];
                if (value && (isSimpleType(value) || typeof value === "boolean" || key === "metadata")) {
                    state[key] = value;
                }
            }

            // If user has changed other properties from defaults update state.
            const defs = TrackBase.defaults;
            if (this.constructor.defaults) {
                for (let key of Object.keys(this.constructor.defaults)) {
                    defs[key] = this.constructor.defaults[key];
                }
            }
            for (let key of Object.keys(defs)) {
                if (undefined !== this[key] && defs[key] !== this[key]) {
                    state[key] = this[key];
                }
            }

            // Flatten dataRange if present
            if (!this.autoscale && this.dataRange) {
                state.min = this.dataRange.min;
                state.max = this.dataRange.max;
            }

            return state
        }

        get supportsWholeGenome() {
            return this.config.supportsWholeGenome === true
        }

        /**
         * Does the track support sample names.  Current sample aware tracks include VCF (with genotypes), MUT, MAF, and SEG
         * @returns {boolean}
         */
        hasSamples() {
            return false
        }

        getGenomeId() {
            return this.browser.genome ? this.browser.genome.id : undefined
        }

        /**
         * Set certain track properties, usually from a "track" line.  Not all UCSC properties are supported.
         *
         * Track configuration settings have precendence over track line properties, so if both are present ignore the
         * track line.
         *
         * @param properties
         */
        setTrackProperties(properties) {

            if (this.disposed) return   // This track was removed during async load

            const tracklineConfg = {};
            let tokens;
            for (let key of Object.keys(properties)) {
                switch (key.toLowerCase()) {
                    case "usescore":
                        tracklineConfg.useScore = (
                            properties[key] === 1 || properties[key] === "1" || properties[key] === "on" || properties[key] === true);
                        break
                    case "visibility":
                        //0 - hide, 1 - dense, 2 - full, 3 - pack, and 4 - squish
                        switch (properties[key]) {
                            case "2":
                            case "3":
                            case "pack":
                            case "full":
                                tracklineConfg.displayMode = "EXPANDED";
                                break
                            case "4":
                            case "squish":
                                tracklineConfg.displayMode = "SQUISHED";
                                break
                            case "1":
                            case "dense":
                                tracklineConfg.displayMode = "COLLAPSED";
                        }
                        break
                    case "color":
                    case "altcolor":
                        tracklineConfg[key] = properties[key].startsWith("rgb(") ? properties[key] : "rgb(" + properties[key] + ")";
                        break
                    case "featurevisiblitywindow":
                    case "visibilitywindow":
                        tracklineConfg.visibilityWindow = Number.parseInt(properties[key]);
                        break
                    case "maxheightpixels":
                        tokens = properties[key].split(":");
                        if (tokens.length === 3) {
                            tracklineConfg.minHeight = Number.parseInt(tokens[2]);
                            tracklineConfg.height = Number.parseInt(tokens[1]);
                            tracklineConfg.maxHeight = Number.parseInt(tokens[0]);
                        }
                        break
                    case "viewlimits":
                        if (!this.config.autoscale) {   // autoscale in the config has precedence
                            tokens = properties[key].split(":");
                            let min = 0;
                            let max;
                            if (tokens.length == 1) {
                                max = Number(tokens[0]);
                            } else if (tokens.length == 2) {
                                min = Number(tokens[0]);
                                max = Number(tokens[1]);
                            }
                            tracklineConfg.autoscale = false;
                            tracklineConfg.dataRange = {min, max};
                            this.viewLimitMin = min;
                            this.viewLimitMax = max;
                        }
                    case "name":
                        tracklineConfg[key] = properties[key];
                        break
                    case "url":
                        tracklineConfg["infoURL"] = properties[key];
                        break
                    case "type":
                        const v = properties[key];
                        if (UCSCTypeMappings.has(v)) {
                            tracklineConfg[key] = UCSCTypeMappings.get(v);
                        } else {
                            tracklineConfg[key] = v;
                        }
                        break
                    case "graphtype":
                        tracklineConfg["graphType"] = properties[key];
                        break
                    default:
                        tracklineConfg[key] = properties[key];
                }
            }

            // Track configuration objects have precedence over track line properties in general.  The "name" property
            // is an exception if it was derived and not explicitly entered (that is derived from the web app from filename).
            for (let key of Object.keys(tracklineConfg)) {

                if (!this.config.hasOwnProperty(key) || (key === "name" && this.config._derivedName)) {
                    let value = tracklineConfg[key];
                    if ("true" === value) value = true;
                    if ("false" === value) value = false;

                    this[key] = value;
                    if (key === "height" && this.trackView) {
                        try {
                            const h = Number.parseInt(value);
                            this.trackView.setTrackHeight(h);
                        } catch (e) {
                            console.error(e);
                        }
                    }
                }
            }
        }

        /**
         * Return the features clicked over.  Default implementation assumes an array of features and only considers
         * the genomic location.   Overriden by most subclasses.
         *
         * @param clickState
         * @param features
         * @returns {[]|*[]}
         */
        clickedFeatures(clickState) {

            // We use the cached features rather than method to avoid async load.  If the
            // feature is not already loaded this won't work,  but the user wouldn't be mousing over it either.
            const features = clickState.viewport.cachedFeatures;

            if (!features || !Array.isArray(features) || features.length === 0) {
                return []
            }

            const genomicLocation = clickState.genomicLocation;

            // When zoomed out we need some tolerance around genomicLocation
            const tolerance = (clickState.referenceFrame.bpPerPixel > 0.2) ? 3 * clickState.referenceFrame.bpPerPixel : 0.2;
            const ss = genomicLocation - tolerance;
            const ee = genomicLocation + tolerance;
            return (FeatureUtils.findOverlapping(features, ss, ee))
        }

        /**
         * Default popup text function -- just extracts string and number properties in random order.
         * @param feature
         * @returns {Array}
         */
        extractPopupData(feature, genomeId) {

            const filteredProperties = new Set(['row', 'color', 'chr', 'start', 'end', 'cdStart', 'cdEnd', 'strand', 'alpha']);
            const data = [];

            let alleles, alleleFreqs;
            for (let property in feature) {

                if (feature.hasOwnProperty(property) &&
                    !filteredProperties.has(property) &&
                    isSimpleType(feature[property])) {

                    let value = feature[property];
                    data.push({name: capitalize(property), value: value});

                    if (property === "alleles") {
                        alleles = feature[property];
                    } else if (property === "alleleFreqs") {
                        alleleFreqs = feature[property];
                    }
                }
            }

            if (alleles && alleleFreqs) {

                if (alleles.endsWith(",")) {
                    alleles = alleles.substr(0, alleles.length - 1);
                }
                if (alleleFreqs.endsWith(",")) {
                    alleleFreqs = alleleFreqs.substr(0, alleleFreqs.length - 1);
                }

                let a = alleles.split(",");
                let af = alleleFreqs.split(",");
                if (af.length > 1) {
                    let b = [];
                    for (let i = 0; i < af.length; i++) {
                        b.push({a: a[i], af: Number(af[i])});
                    }
                    b.sort(function (x, y) {
                        return x.af - y.af
                    });

                    let ref = b[b.length - 1].a;
                    if (ref.length === 1) {
                        for (let i = b.length - 2; i >= 0; i--) {
                            let alt = b[i].a;
                            if (alt.length === 1) {
                                if (!genomeId) genomeId = this.getGenomeId();
                                const cravatLink = TrackBase.getCravatLink(feature.chr, feature.start + 1, ref, alt, genomeId);
                                console.log(cravatLink);
                                if (cravatLink) {
                                    data.push('<hr/>');
                                    data.push({html: cravatLink});
                                    data.push('<hr/>');
                                }
                            }
                        }
                    }
                }
            }

            if (feature.attributes) {
                for (let key of Object.keys(feature.attributes)) {
                    data.push({name: key, value: feature.attributes[key]});
                }
            }

            // final chr position
            let posString = `${feature.chr}:${numberFormatter$1(feature.start + 1)}-${numberFormatter$1(feature.end)}`;
            if (feature.strand) {
                posString += ` (${feature.strand})`;
            }

            data.push({name: 'Location', value: posString});

            return data

        }


        /**
         * Default track description -- displayed on click of track label.  This can be overriden in the track
         * configuration, or in subclasses.
         */
        description() {

            const wrapKeyValue = (k, v) => `<div class="igv-track-label-popup-shim"><b>${k}: </b>${v}</div>`;

            let str = '<div class="igv-track-label-popup">';
            if (this.url) {
                if (isFile(this.url)) {
                    str += wrapKeyValue('Filename', this.url.name);
                } else {
                    str += wrapKeyValue('URL', this.url);
                }
            } else {
                str = this.name;
            }
            if (this.config) {
                if (this.config.metadata) {
                    for (let key of Object.keys(this.config.metadata)) {
                        const value = this.config.metadata[key];
                        str += wrapKeyValue(key, value);
                    }
                }

                // Add any config properties that are capitalized
                for (let key of Object.keys(this.config)) {
                    if (key.startsWith("_")) continue   // transient property
                    let first = key.substr(0, 1);
                    if (first !== first.toLowerCase()) {
                        const value = this.config[key];
                        if (value && isSimpleType(value)) {
                            str += wrapKeyValue(key, value);
                        }
                    }
                }

            }
            str += '</div>';
            return str
        }

        /**
         * Return color for a specific feature of this track.  This default implementation is overriden by subclasses*
         * @param f
         * @returns {*|string|string}
         */
        getColorForFeature(f) {
            return (typeof this.color === "function") ? this.color(feature) : this.color
        }

        /**
         * Track has been permanently removed.  Release resources and other cleanup
         */
        dispose() {

            this.disposed = true;

            // This should not be neccessary, but in case there is some unknown reference holding onto this track object,
            // for example in client code, release any resources here.
            for (let key of Object.keys(this)) {
                this[key] = undefined;
            }
        }

        static getCravatLink(chr, position, ref, alt, genomeID) {

            if ("hg38" === genomeID || "GRCh38" === genomeID) {

                const cravatChr = chr.startsWith("chr") ? chr : "chr" + chr;
                return `<a target="_blank" href="https://run.opencravat.org/result/nocache/variant.html` +
                    `?chrom=${cravatChr}&pos=${position}&ref_base=${ref}&alt_base=${alt}"><b>Cravat ${ref}->${alt}</b></a>`

            } else {
                return undefined
            }
        }
    }

    function hoverText(clickState) {

        if (!this.hoverTextFields) return

        const features = this.clickedFeatures(clickState);

        if (features && features.length > 0) {
            let str = "";
            for (let i = 0; i < features.length; i++) {
                if (i === 10) {
                    str += "; ...";
                    break
                }
                if (!features[i]) continue

                const f = features[i]._f || features[i];
                if (str.length > 0) str += "\n";

                str = "";
                for (let field of this.hoverTextFields) {
                    if (str.length > 0) str += "\n";
                    if (f.hasOwnProperty(field)) {
                        str += f[field];
                    } else if (typeof f.getAttribute === "function") {
                        str += f.getAttribute(field);
                    }
                }

            }
            return str
        }
    }

    /**
     * Map UCSC track line "type" setting to file format.  In igv.js "type" refers to the track type, not the input file format
     * @type {Map<string, string>}
     */
    const UCSCTypeMappings = new Map([
        ["wiggle_0", "wig"],
        ["bed", "bed"],
        ["bigBed", "bigBed"],
        ["bigWig", "bigWig"]
    ]);

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */


    /**
     *  Define parser for seg files  (.bed, .gff, .vcf, etc).  A parser should implement 2 methods
     *
     *     parseHeader(data) - return an object representing a header.  Details are format specific
     *
     *     parseFeatures(data) - return a list of features
     *
     */


    class SegParser {

        constructor(type) {
            this.type = type || 'seg';   // One of seg, mut, or maf

            switch (this.type) {
                case 'mut':
                    this.sampleColumn = 3;
                    this.chrColumn = 0;
                    this.startColumn = 1;
                    this.endColumn = 2;
                    this.dataColumn = 4;
                    break
                case 'maf':
                    this.sampleColumn = 15;
                    this.chrColumn = 4;
                    this.startColumn = 5;
                    this.endColumn = 6;
                    this.dataColumn = 8;
                    break
                default:
                    this.sampleColumn = 0;
                    this.chrColumn = 1;
                    this.startColumn = 2;
                    this.endColumn = 3;
                // Data column determined after reading header
            }
        }

        async parseHeader(dataWrapper) {
            let line;
            while ((line = await dataWrapper.nextLine()) !== undefined) {
                if (line.startsWith("#")) ; else {
                    const tokens = line.split("\t");
                    this.header = {headings: tokens};
                    break
                }
            }
            return this.header
        }

        async parseFeatures(dataWrapper) {

            const allFeatures = [];
            let extraHeaders;
            if (!this.header) {
                this.header = await this.parseHeader(dataWrapper);  // This will only work for non-indexed files
            }
            if ('seg' === this.type) {
                this.dataColumn = this.header.headings.length - 1;
            }
            if (this.header.headings.length > 5) {
                extraHeaders = this.extractExtraColumns(this.header.headings);
            }
            const valueColumnName = this.header.headings[this.dataColumn];

            let line;
            while ((line = await dataWrapper.nextLine()) !== undefined) {
                const tokens = line.split("\t");
                const value = ('seg' === this.type) ? Number(tokens[this.dataColumn]) : tokens[this.dataColumn];
                if (tokens.length > this.dataColumn) {
                    const feature = new SegFeature({
                        sample: tokens[this.sampleColumn],
                        chr: tokens[this.chrColumn],
                        start: parseInt(tokens[this.startColumn]) - 1,
                        end: parseInt(tokens[this.endColumn]),
                        value,
                        valueColumnName
                    });
                    if (extraHeaders) {
                        const extraValues = this.extractExtraColumns(tokens);
                        feature.setAttributes({names: extraHeaders, values: extraValues});
                    }
                    allFeatures.push(feature);
                }
            }
            return allFeatures
        }

        extractExtraColumns(tokens) {
            const extras = [];
            for (let i = 0; i < tokens.length; i++) {
                if (i !== this.chrColumn && i !== this.startColumn && i !== this.endColumn && i !== this.sampleColumn) {
                    extras.push(tokens[i]);
                }
            }
            return extras
        }

    }

    class SegFeature {

        constructor({sample, chr, start, end, value, valueColumnName}) {
            this.sample = sample;
            this.chr = chr;
            this.start = start;
            this.end = end;
            this.value = value;
            this.valueColumnName = valueColumnName;
        }

        setAttributes({names, values}) {
            this.attributeNames = names;
            this.attributeValues = values;
        }

        getAttribute(name) {
            if (this.attributeNames) {
                const idx = this.attributeNames.indexOf(name);
                if (idx >= 0) {
                    return this.attributeValues[idx]
                }
            }
            return undefined
        }


        popupData(type, genomeID) {
            const filteredProperties = new Set(['chr', 'start', 'end', 'sample', 'value', 'row', 'color', 'sampleKey',
                'uniqueSampleKey', 'sampleId', 'chromosome', 'uniquePatientKey']);
            const locationString = (this.chr + ":" +
                numberFormatter$1(this.start + 1) + "-" +
                numberFormatter$1(this.end));
            const pd = [
                {name: "Sample", value: this.sample},
                {name: "Location", value: locationString},
                {name: this.valueColumnName ? capitalize(this.valueColumnName) : "Value", value: this.value}
            ];

            // TODO -- the Cravat stuff should probably be in the track (SegTrack)
            if ("mut" === type && "hg38" === genomeID) {
                const l = this.extractCravatLink(genomeID);
                if (l) {
                    pd.push('<hr/>');
                    pd.push({html: l});
                    pd.push('<hr/>');
                }
            }

            if (this.attributeNames && this.attributeNames.length > 0) {
                for (let i = 0; i < this.attributeNames.length; i++) {
                    if (!filteredProperties.has(this.attributeNames[i]) & this.valueColumnName !== this.attributeNames[i]) {
                        pd.push({name: capitalize(this.attributeNames[i]), value: this.attributeValues[i]});
                    }
                }
            }
            return pd
        }

        extractCravatLink(genomeId) {

            let ref, alt;
            if (this.attributeNames && this.attributeNames.length > 0) {
                for (let i = 0; i < this.attributeNames.length; i++) {
                    if (!ref && "Reference_Allele" === this.attributeNames[i]) {
                        ref = this.attributeValues[i];
                    }
                    if (!alt && this.attributeNames[i].startsWith("Tumor_Seq_Allele") && this.attributeValues[i] !== ref) {
                        alt = this.attributeValues[i];
                    }
                    if (ref && alt) {
                        return TrackBase.getCravatLink(this.chr, this.start + 1, ref, alt, genomeId)
                    }
                }
            }

        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    /**
     * Create a variant from an array of tokens representing a line in a "VCF" file
     * @param tokens
     */
    function createVCFVariant(tokens) {
        const variant = new Variant();
        variant.chr = tokens[0]; // TODO -- use genome aliases
        variant.pos = parseInt(tokens[1]);
        variant.names = tokens[2];    // id in VCF
        variant.referenceBases = tokens[3];
        variant.alternateBases = tokens[4];
        variant.quality = tokens[5];
        variant.filter = tokens[6];
        variant.info = {};
        const infoStr = tokens[7];
        if (infoStr) {
            for (let elem of infoStr.split(';')) {
                var element = elem.split('=');
                variant.info[element[0]] = element[1];
            }
        }
        variant.init();
        return variant
    }


    /**
     * @deprecated - the GA4GH API has been deprecated.  This code no longer maintained.
     * @param json
     * @returns {Variant}
     */
    function createGAVariant(json) {

        var variant = new Variant();

        variant.chr = json.referenceName;
        variant.start = parseInt(json.start);  // Might get overriden below
        variant.end = parseInt(json.end);      // Might get overriden below
        variant.pos = variant.start + 1;       // GA4GH is 0 based.
        variant.names = arrayToString(json.names, "; ");
        variant.referenceBases = json.referenceBases;
        variant.alternateBases = arrayToString(json.alternateBases);
        variant.quality = json.quality;
        variant.filter = arrayToString(json.filter);


        // Flatten GA4GH attributes array
        variant.info = {};
        if (json.info) {
            Object.keys(json.info).forEach(function (key) {
                var value,
                    valueArray = json.info[key];

                if (Array.isArray(valueArray)) {
                    value = valueArray.join(",");
                } else {
                    value = valueArray;
                }
                variant.info[key] = value;
            });
        }


        // Need to build a hash of calls for fast lookup
        // Note from the GA4GH spec on call ID:
        //
        // The ID of the call set this variant call belongs to. If this field is not present,
        // the ordering of the call sets from a SearchCallSetsRequest over this GAVariantSet
        // is guaranteed to match the ordering of the calls on this GAVariant.
        // The number of results will also be the same.
        variant.calls = {};
        var id;
        if (json.calls) {
            json.calls.forEach(function (call) {
                id = call.callSetId;
                variant.calls[id] = call;

            });
        }

        init(variant);

        return variant

    }


    class Variant {

        init() {

            const ref = this.referenceBases;
            const altBases = this.alternateBases;

            if (this.info) {
                if (this.info["VT"]) {
                    this.type = this.info["VT"];
                } else if (this.info["SVTYPE"]) {
                    this.type = "SV";
                } else if (this.info["PERIOD"]) {
                    this.type = "STR";
                }
            }
            if (this.type === undefined) {
                this.type = determineType(ref, altBases);
            }
            if (this.type === "NONVARIANT") {
                this.heterozygosity = 0;
            }

            // Determine start/end coordinates -- these are the coordinates representing the actual variant,
            // not the leading or trailing reference
            if (this.info["END"]) {
                this.start = this.pos - 1;
                if (this.info["CHR2"] && this.info["CHR2"] !== this.chr) {
                    this.end = this.start + 1;
                } else {
                    this.end = Number.parseInt(this.info["END"]);
                }
            } else {
                if (this.type === "NONVARIANT") {
                    this.start = this.pos - 1;      // convert to 0-based coordinate convention
                    this.end = this.start + ref.length;
                } else {

                    const altTokens = altBases.split(",").filter(token => token.length > 0);
                    this.alleles = [];
                    this.start = undefined;
                    this.end = undefined;

                    for (let alt of altTokens) {

                        this.alleles.push(alt);

                        // We don't yet handle  SV and other special alt representations
                        if ("SV" !== this.type && isKnownAlt(alt)) {

                            let altLength = alt.length;
                            let lengthOnRef = ref.length;
                            const lmin = Math.min(altLength, lengthOnRef);

                            // Trim off matching bases.  Try first match, then right -> left,  then any remaining left -> right
                            let s = 0;

                            while (s < lmin && (ref.charCodeAt(s) === alt.charCodeAt(s))) {
                                s++;
                                altLength--;
                                lengthOnRef--;
                            }

                            // right -> left from end
                            while (altLength > 0 && lengthOnRef > 0) {
                                const altIdx = s + altLength - 1;
                                const refIdx = s + lengthOnRef - 1;
                                if (alt.charCodeAt(altIdx) === ref.charCodeAt(refIdx)) {
                                    altLength--;
                                    lengthOnRef--;
                                } else {
                                    break
                                }
                            }

                            // if any remaining, left -> right
                            while (altLength > 0 && lengthOnRef > 0) {
                                const altIdx = s;
                                const refIdx = s;
                                if (alt.charCodeAt(altIdx) === ref.charCodeAt(refIdx)) {
                                    s++;
                                    altLength--;
                                    lengthOnRef--;
                                } else {
                                    break
                                }
                            }

                            const alleleStart = this.pos + s - 1;      // -1 for zero based coordinates
                            const alleleEnd = alleleStart + lengthOnRef;
                            this.start = this.start === undefined ? alleleStart : Math.min(this.start, alleleStart);
                            this.end = this.end === undefined ? alleleEnd : Math.max(this.end, alleleEnd);
                        }
                    }

                    // Default to single base representation @ position for variant types not otherwise handled
                    if (this.start === undefined) {
                        this.start = this.pos - 1;
                        this.end = this.pos;
                    }
                }
            }
        }

        popupData(genomicLocation, genomeId) {

            const posString = `${numberFormatter$1(this.pos)}`;
            const locString = this.start === this.end ?
                `${numberFormatter$1(this.start)} | ${numberFormatter$1(this.start + 1)}` :
                `${numberFormatter$1(this.start + 1)}-${numberFormatter$1(this.end)}`;
            const fields = [
                {name: "Chr", value: this.chr},
                {name: "Pos", value: posString},
                {name: "Loc", value: locString},
                {name: "ID", value: this.names ? this.names : ""},
                {name: "Ref", value: this.referenceBases},
                {name: "Alt", value: this.alternateBases.replace("<", "&lt;")},
                {name: "Qual", value: this.quality},
                {name: "Filter", value: this.filter}
            ];

            if ("SNP" === this.type) {
                let ref = this.referenceBases;
                if (ref.length === 1) {
                    let altArray = this.alternateBases.split(",");
                    for (let alt of altArray) {
                        if (alt.length === 1) {
                            let l = TrackBase.getCravatLink(this.chr, this.pos, ref, alt, genomeId);
                            if (l) {
                                fields.push('<hr/>');
                                fields.push({html: l});
                            }
                        }
                    }
                }
            }

            if (this.hasOwnProperty("heterozygosity")) {
                fields.push({name: "Heterozygosity", value: this.heterozygosity});
            }

            if (this.info) {
                fields.push({html: '<hr style="border-top: dotted 1px;border-color: #c9c3ba" />'});
                for (let key of Object.keys(this.info)) {
                    fields.push({name: key, value: arrayToString(decodeURIComponent(this.info[key]))});
                }
            }

            return fields
        }

        getInfo(tag) {
            return this.info ? this.info[tag] : undefined;
        }

        isRefBlock() {
            return "NONVARIANT" === this.type
        }

    }

    const knownAltBases = new Set(["A", "C", "T", "G"].map(c => c.charCodeAt(0)));

    function isKnownAlt(alt) {
        for (let i = 0; i < alt.length; i++) {
            if (!knownAltBases.has(alt.charCodeAt(i))) {
                return false
            }
        }
        return true
    }


    function determineType(ref, altAlleles) {
        const refLength = ref.length;
        if (altAlleles === undefined) {
            return "UNKNOWN"
        } else if (altAlleles.trim().length === 0 ||
            altAlleles === "<NON_REF>" ||
            altAlleles === "<*>" ||
            altAlleles === ".") {
            return "NONVARIANT"
        } else {
            const alleles = altAlleles.split(",");
            const types = alleles.map(function (a) {
                if (refLength === 1 && a.length === 1) {
                    return "SNP"
                } else {
                    return "<NON_REF>" === a ? "NONVARIANT" : "OTHER"
                }
            });
            let type = types[0];
            for (let t of types) {
                if (t !== type) {
                    return "MIXED"
                }
            }
            return type
        }
    }

    function arrayToString(value, delim) {

        if (delim === undefined) delim = ",";

        if (!(Array.isArray(value))) {
            return value
        }
        return value.join(delim)
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    /**
     * Parser for VCF files.
     */

    class VcfParser {

        construtor() {
        }

        async parseHeader(dataWrapper, genome) {

            const header = {};

            header.chrAliasTable = new Map();

            // First line must be file format
            let line = await dataWrapper.nextLine();
            if (line.startsWith("##fileformat")) {
                header.version = line.substr(13);
            } else {
                throw new Error("Invalid VCF file: missing fileformat line")
            }

            while ((line = await dataWrapper.nextLine()) !== undefined) {

                if (line.startsWith("#")) {

                    let id;
                    const values = {};

                    if (line.startsWith("##")) {

                        if (line.startsWith("##INFO") || line.startsWith("##FILTER") || line.startsWith("##FORMAT")) {

                            const ltIdx = line.indexOf("<");
                            const gtIdx = line.lastIndexOf(">");

                            if (!(ltIdx > 2 && gtIdx > 0)) {
                                console.log("Malformed VCF header line: " + line);
                                continue
                            }

                            const type = line.substring(2, ltIdx - 1);
                            if (!header[type]) header[type] = {};

                            //##INFO=<ID=AF,Number=A,Type=Float,Description="Allele frequency based on Flow Evaluator observation counts">
                            // ##FILTER=<ID=NOCALL,Description="Generic filter. Filtering details stored in FR info tag.">
                            // ##FORMAT=<ID=AF,Number=A,Type=Float,Description="Allele frequency based on Flow Evaluator observation counts">

                            const tokens = splitStringRespectingQuotes(line.substring(ltIdx + 1, gtIdx - 1), ",");

                            for (let token of tokens) {
                                var kv = token.split("=");
                                if (kv.length > 1) {
                                    if (kv[0] === "ID") {
                                        id = kv[1];
                                    } else {
                                        values[kv[0]] = kv[1];
                                    }
                                }
                            }

                            if (id) {
                                header[type][id] = values;
                            }
                        } else if (line.startsWith("##contig") && genome) {
                            const idx1 = line.indexOf("<ID=");
                            let idx2 = line.indexOf(",", idx1);
                            if (idx2 == -1) {
                                idx2 = line.indexOf(">", idx1);
                            }
                            const chr = line.substring(idx1 + 4, idx2);
                            const canonicalChromosome = genome.getChromosomeName(chr);
                            header.chrAliasTable.set(canonicalChromosome, chr);
                        } else ;
                    } else if (line.startsWith("#CHROM")) {
                        const tokens = line.split("\t");

                        if (tokens.length > 8) {

                            // call set names -- use column index for id
                            header.callSets = [];
                            for (let j = 9; j < tokens.length; j++) {
                                header.callSets.push({id: j, name: tokens[j]});
                            }
                        }
                    }

                } else {
                    break
                }

            }

            this.header = header;  // Will need to intrepret genotypes and info field

            return header
        }


        /**
         * Parse data as a collection of Variant objects.
         *
         * @param data
         * @returns {Array}
         */
        async parseFeatures(dataWrapper) {

            const allFeatures = [];
            const callSets = this.header.callSets;
            const nExpectedColumns = 8 + (callSets ? callSets.length + 1 : 0);
            let line;
            while ((line = await dataWrapper.nextLine()) !== undefined) {
                if (line && !line.startsWith("#")) {

                    const tokens = line.split("\t");
                    if (tokens.length === nExpectedColumns) {
                        const variant = createVCFVariant(tokens);
                        variant.header = this.header;       // Keep a pointer to the header to interpret fields for popup text
                        //variant.line = line              // Uncomment for debugging
                        allFeatures.push(variant);

                        if (tokens.length > 9) {

                            // Format
                            const callFields = extractCallFields(tokens[8].split(":"));

                            variant.calls = {};
                            for (let index = 9; index < tokens.length; index++) {

                                const token = tokens[index];

                                const callSet = callSets[index - 9];
                                const call = {
                                    callSetName: callSet.name,
                                    info: {}
                                };

                                variant.calls[callSet.id] = call;

                                token.split(":").forEach(function (callToken, idx) {

                                    switch (idx) {
                                        case callFields.genotypeIndex:
                                            call.genotype = [];
                                            callToken.split(/[\|\/]/).forEach(function (s) {
                                                call.genotype.push('.' === s ? s : parseInt(s));
                                            });
                                            break

                                        default:
                                            call.info[callFields.fields[idx]] = callToken;
                                    }
                                });
                            }
                        }

                        // If this is a structural variant create a complement of this variant for the other end
                        // The test for "SV" is not comprehensive, there is not yet a standard for this
                        if (variant.info && variant.info.CHR2 && variant.info.END) {
                            allFeatures.push(svComplement(variant));
                        }
                    }
                }
            }

            return allFeatures
        }
    }

    function extractCallFields(tokens) {

        const callFields = {
            genotypeIndex: -1,
            fields: tokens
        };
        for (let i = 0; i < tokens.length; i++) {
            if ("GT" === tokens[i]) {
                callFields.genotypeIndex = i;
            }
        }
        return callFields
    }

    function svComplement(v) {

        const chr2 = v.info.CHR2;
        const pos2 = Number.parseInt(v.info.END);
        return {
            chr: chr2,
            start: pos2 - 1,
            end: pos2,
            _f: v
        }

    }

    /**
     * Parser for IGV desktop GWAS files.  See http://software.broadinstitute.org/software/igv/GWAS
     */
    class GWASParser {

        constructor(config) {
            // Defaults - can be overriden by header
            this.config = config;
            if (config.columns) {
                if (config.columns.chromosome === undefined ||
                    config.columns.position === undefined ||
                    config.columns.value === undefined) {
                    throw Error("columns property must define chrCol, posCol, and valueCol")
                }
                this.posCol = config.columns.position - 1;
                this.chrCol = config.columns.chromosome - 1;
                this.valueCol = config.columns.value - 1;
            } else {
                // Defaults -- can be overriden in header
                this.posCol = 2;
                this.chrCol = 1;
                this.valueCol = 3;
            }
        }

        async parseHeader(dataWrapper) {
            const headerLine = await dataWrapper.nextLine();
            return this.parseHeaderLine(headerLine)
        }

        parseHeaderLine(headerLine) {
            this.columns = headerLine.split(/\t/);
            if (!this.config.columns) {
                for (let i = 0; i < this.columns.length; i++) {
                    const c = this.columns[i].toLowerCase();
                    switch (c) {
                        case 'chr':
                        case 'chromosome':
                        case 'chr_id':
                            this.chrCol = i;
                            break
                        case 'bp':
                        case 'pos':
                        case 'position':
                        case 'chr_pos':
                            this.posCol = i;
                            break
                        case 'p':
                        case 'pval':
                        case 'pvalue':
                        case 'p-value':
                        case 'p.value':
                            this.valueCol = i;
                            break
                    }
                }
            }
            return this.columns
        }

        async parseFeatures(dataWrapper) {

            const allFeatures = [];
            const headerLine = dataWrapper.nextLine();
            if (!this.columns) {
                this.parseHeaderLine(headerLine);
            }
            let line;
            while ((line = dataWrapper.nextLine()) !== undefined) {
                const tokens = line.split(/\t/);
                if (tokens.length === this.columns.length) {
                    const chr = tokens[this.chrCol];
                    const start = parseInt(tokens[this.posCol]) - 1;
                    const end = start + 1;
                    const value = Number(tokens[this.valueCol]);
                    allFeatures.push(new GWASFeature({
                        chr: chr,
                        start: start,
                        end: end,
                        value: value,
                        line: line,
                        columns: this.columns
                    }));
                }
            }
            return allFeatures
        }
    }

    class GWASFeature {

        constructor({chr, start, end, value, line, columns}) {
            this.chr = chr;
            this.start = start;
            this.end = end;
            this.value = value;
            this.line = line;
            this.columns = columns;
        }

        popupData() {
            const tokens = this.line.split(/\t/);
            return this.columns.map(function (c, index) {
                return {name: c, value: tokens[index]}
            })
        }

        getAttribute(attrName) {
            const tokens = this.line.split(/\t/);
            for (let i = 0; i < this.columns.length; i++) {
                if (this.columns[i] === attrName) {
                    return tokens[i]
                }
            }
            return undefined
        }

    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    /**
     *  Define parsers for bed-like files  (.bed, .gff, .vcf, etc).  A parser should implement 2 methods
     *
     *     parseHeader(data) - return an object representing a header or metadata.  Details are format specific
     *
     *     parseFeatures(data) - return an array of features
     *
     */

    var aedRegexpNoNamespace = new RegExp("([^:]*)\\(([^)]*)\\)"); // name(type) for AED parsing (namespace undefined)
    var aedRegexpNamespace = new RegExp("([^:]*):([^(]*)\\(([^)]*)\\)"); // namespace:name(type) for AED parsing


    class AEDParser {

        constructor(config) {
            const decode = config ? config.decode : undefined;
            this.nameField = config ? config.nameField : undefined;
            this.skipRows = 0;   // The number of fixed header rows to skip.  Override for specific types as needed
            if (decode) {
                this.decode = decode;
            } else {
                this.decode = decodeAed;
            }
            this.delimiter = "\t";
        }

        async parseHeader(dataWrapper) {
            let line;
            let header;
            while (line = await dataWrapper.nextLine()) {
                if (line.startsWith("track") || line.startsWith("#") || line.startsWith("browser")) {
                    if (line.startsWith("track") || line.startsWith("#track")) {
                        let h = parseTrackLine(line);
                        if (header) {
                            Object.assign(header, h);
                        } else {
                            header = h;
                        }
                    } else if (line.startsWith("#columns")) {
                        let h = parseColumnsDirective(line);
                        if (header) {
                            Object.assign(header, h);
                        } else {
                            header = h;
                        }
                    } else if (line.startsWith("##gff-version 3")) {
                        this.format = "gff3";
                        if (!header) header = {};
                        header["format"] = "gff3";
                    }
                } else {
                    break
                }
            }
            this.header = header;    // Directives might be needed for parsing lines
            return header
        }

        async parseFeatures(dataWrapper) {

            const allFeatures = [];
            const decode = this.decode;
            const delimiter = this.delimiter || "\t";
            let i = 0;
            let line;
            let wig;

            while ((line = dataWrapper.nextLine()) !== undefined) {
                i++;
                if (i <= this.skipRows || line.startsWith("track") || line.startsWith("#") || line.startsWith("browser")) {
                    continue
                }

                let tokens = readTokensAed();
                if (tokens.length < 1) {
                    continue
                }

                if (!this.aed) {
                    // Store information about the aed header in the parser itself
                    // This is done only once - on the first row
                    this.aed = parseAedHeaderRow(tokens);
                    continue
                }

                const feature = decode.call(this, tokens, wig);
                if (feature) {
                    allFeatures.push(feature);
                }
            }

            return allFeatures

            // Double quoted strings can contain newlines in AED
            // "" is an escape for a ".
            // Parse all this, clean it up, split into tokens in a custom way
            function readTokensAed() {
                var tokens = [],
                    token = "",
                    quotedString = false,
                    n,
                    c;

                while (line || line === '') {
                    for (n = 0; n < line.length; n++) {
                        c = line.charAt(n);
                        if (c === delimiter) {
                            if (!quotedString) {
                                tokens.push(token);
                                token = "";
                            } else {
                                token += c;
                            }
                        } else if (c === "\"") {
                            // Look ahead to the next character
                            if (n + 1 < line.length && line.charAt(n + 1) === "\"") {
                                if (quotedString) {
                                    // Turn "" into a single " in the output string
                                    token += "\"";
                                }
                                // Skip the next double quote
                                n++;
                            } else {
                                // We know the next character is NOT a double quote, flip our state
                                quotedString = !quotedString;
                            }
                        } else {
                            token += c;
                        }
                    }
                    // We are at the end of the line
                    if (quotedString) {
                        token += '\n'; // Add newline to the token
                        line = nextLine(); // Keep going
                    } else {
                        // We can end the loop
                        break
                    }
                }
                // Push the last token
                tokens.push(token);
                return tokens
            }
        }
    }


    function parseAedToken(value) {
        // Example: refseq:accessionNumber(aed:String)
        // refseq - namespace, will be declared later
        // accessionNumber - name of the field
        // aed:String - type of the field
        // The namespace part may be missing
        var match = aedRegexpNamespace.exec(value);
        if (match) {
            return {
                namespace: match[1],
                name: match[2],
                type: match[3]
            }
        }

        match = aedRegexpNoNamespace.exec(value);
        if (match) {
            return {
                namespace: '?',
                name: match[1],
                type: match[2]
            }
        } else {
            throw new Error("Error parsing the header row of AED file - column not in ns:name(ns:type) format")
        }
    }

    function parseAedHeaderRow(tokens) {
        // First row of AED file defines column names
        // Each header item is an aed token - see parseAedToken
        var aed,
            k,
            token,
            aedToken;

        // Initialize aed section to be filled in
        aed = {
            columns: [ // Information about the namespace, name and type of each column
                // Example entry:
                // { namespace: 'bio', name: 'start', type: 'aed:Integer' }
            ],
            metadata: { // Metadata about the entire AED file
                // Example:
                // {
                //    aed: {
                //       application: { value: "CHaS Browser 3.3.0.139 (r10838)", type: "aed:String" },
                //       created: { value: "2018-01-02T10:20:30.123+01:00", type: "aed:DateTime" },
                //       modified: { value: "2018-03-04T11:22:33.456+01:00", type: "aed:DateTime" },
                //    }
                //    affx: {
                //       ucscGenomeVersion: { value: "hg19", type: "aed:String" }
                //    },
                //    namespace: {
                //       omim: { value: "http://affymetrix.com/ontology/www.ncbi.nlm.nih.gov/omim/", type: "aed:URI" },
                //       affx: { value: "http://affymetrix.com/ontology/", type: "aed:URI" },
                //       refseq: { value: "http://affymetrix.com/ontology/www.ncbi.nlm.nih.gov/RefSeq/", type: "aed:URI" }
                //    }
                // }
            }
        };
        for (k = 0; k < tokens.length; k++) {
            token = tokens[k];
            aedToken = parseAedToken(token);
            aed.columns.push(aedToken);
        }

        return aed
    }

    function parseTrackLine(line) {

        const properties = {};
        const tokens = line.split(/(?:")([^"]+)(?:")|([^\s"]+)(?=\s+|$)/g);


        // Clean up tokens array
        let curr;
        const tmp = [];
        for (let tk of tokens) {
            if (!tk || tk.trim().length === 0) continue
            if (tk.endsWith("=") > 0) {
                curr = tk;
            } else if (curr) {
                tmp.push(curr + tk);
                curr = undefined;
            } else {
                tmp.push(tk);
            }
        }
        for (let str of tmp) {
            if (!str) return
            var kv = str.split('=', 2);
            if (kv.length === 2) {
                const key = kv[0].trim();
                const value = kv[1].trim();
                properties[key] = value;
            }

        }

        return properties
    }

    function parseColumnsDirective(line) {

        let properties = {};
        let t1 = line.split(/\s+/);

        if (t1.length === 2) {

            let t2 = t1[1].split(";");

            t2.forEach(function (keyValue) {

                let t = keyValue.split("=");

                if (t[0] === "color") {
                    properties.colorColumn = Number.parseInt(t[1]) - 1;
                } else if (t[0] === "thickness") {
                    properties.thicknessColumn = Number.parseInt(t[1]) - 1;
                }
            });
        }

        return properties
    }

    /**
     * AED file feature.
     *
     * @param aed link to the AED file object containing file-level metadata and column descriptors
     * @param allColumns All columns as parsed from the AED
     *
     * Other values are parsed one by one
     */
    function AedFeature(aed, allColumns) {
        var token, aedColumn, aedColumns = aed.columns;

        // Link to AED file (for metadata)
        this.aed = aed;

        // Unparsed columns from AED file
        this.allColumns = allColumns;

        // Prepare space for the parsed values
        this.chr = null;
        this.start = null;
        this.end = null;
        this.score = 1000;
        this.strand = '.';
        this.cdStart = null;
        this.cdEnd = null;
        this.name = null;
        this.color = null;

        for (let i = 0; i < allColumns.length; i++) {
            token = allColumns[i];
            if (!token) {
                // Skip empty fields
                continue
            }
            aedColumn = aedColumns[i];
            if (aedColumn.type === 'aed:Integer') {
                token = parseInt(token);
            }
            var arr = [];
            if (aedColumn.namespace.length > 0) {
                for (let j = 0; j < aedColumn.namespace.length; j++) {
                    arr.push(aedColumn.namespace.charCodeAt(j));
                }
            }
            if (aedColumn.namespace.trim() === 'bio') {
                if (aedColumn.name === 'sequence') {
                    this.chr = token;
                } else if (aedColumn.name === 'start') {
                    this.start = token;
                } else if (aedColumn.name === 'end') {
                    this.end = token;
                } else if (aedColumn.name === 'cdsMin') {
                    this.cdStart = token;
                } else if (aedColumn.name === 'cdsMax') {
                    this.cdEnd = token;
                } else if (aedColumn.name === 'strand') {
                    this.strand = token;
                }
            } else if (aedColumn.namespace === 'aed') {
                if (aedColumn.name === 'name') {
                    this.name = token;
                }
            } else if (aedColumn.namespace === 'style') {
                if (aedColumn.name === 'color') {
                    this.color = IGVColor.createColorString(token);
                }
            }
        }
    }

    AedFeature.prototype.popupData = function () {
        var data = [],
            aed = this.aed;
        // Just dump everything we have for now
        for (var i = 0; i < this.allColumns.length; i++) {
            var featureValue = this.allColumns[i];
            var name = aed.columns[i].name;
            // Skip columns that are not interesting - you know the sequence, and you can see color
            if (name !== 'sequence' && name !== 'color') {
                if (featureValue) {
                    data.push({name: name, value: featureValue});
                }
            }
        }
        return data
    };

    /**
     * Decode the AED file format
     * @param tokens
     * @param ignore
     * @returns decoded feature, or null if this is not a valid record
     */
    function decodeAed(tokens, ignore) {
        var name, value, token,
            nonEmptyTokens = 0,
            aedColumns = this.aed.columns,
            aedColumn,
            aedKey,
            i;

        // Each aed row must match the exact number of columns or we skip it
        if (tokens.length !== aedColumns.length) {
            console.log('Corrupted AED file row: ' + tokens.join(','));
            return undefined
        }

        for (i = 0; i < tokens.length; i++) {
            aedColumn = aedColumns[i];
            token = tokens[i];
            if (token !== '') {
                nonEmptyTokens++;
            }
            if (aedColumn.name === 'name' && aedColumn.namespace === 'aed') {
                name = token;
            } else if (aedColumn.name === 'value' && aedColumn.namespace === 'aed') {
                value = token;
            }
        }

        if (nonEmptyTokens === 2 && name && value) {
            // Special row that defines metadata for the entire file
            aedKey = parseAedToken(name);
            // Store in the metadata section
            if (!this.aed.metadata[aedKey.namespace]) {
                this.aed.metadata[aedKey.namespace] = {};
            }
            if (!this.aed.metadata[aedKey.namespace][aedKey.name]) {
                this.aed.metadata[aedKey.namespace][aedKey.name] = {
                    type: aedKey.type,
                    value: value
                };
            }
            // Ignore this value
            return undefined
        }

        var feature = new AedFeature(this.aed, tokens);

        if (!feature.chr || (!feature.start && feature.start !== 0) || !feature.end) {
            console.log('Cannot parse feature: ' + tokens.join(','));
            return undefined
        }

        return feature
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */


    // TODO -- big endian?

    class BinaryParser {
        constructor(dataView, littleEndian) {

            this.littleEndian = littleEndian !== undefined ? littleEndian : true;
            this.position = 0;
            this.view = dataView;
            this.length = dataView.byteLength;
        }

        available() {
            return this.length - this.position
        }

        remLength() {
            return this.length - this.position
        }

        hasNext() {
            return this.position < this.length - 1
        }

        getByte() {
            var retValue = this.view.getUint8(this.position, this.littleEndian);
            this.position++;
            return retValue
        }

        getShort() {

            var retValue = this.view.getInt16(this.position, this.littleEndian);
            this.position += 2;
            return retValue
        }

        getUShort() {

            // var byte1 = this.getByte(),
            //     byte2 = this.getByte(),
            //     retValue = ((byte2 << 24 >>> 16) + (byte1 << 24 >>> 24));
            //     return retValue;

            //
            var retValue = this.view.getUint16(this.position, this.littleEndian);
            this.position += 2;
            return retValue
        }


        getInt() {

            var retValue = this.view.getInt32(this.position, this.littleEndian);
            this.position += 4;
            return retValue
        }


        getUInt() {
            var retValue = this.view.getUint32(this.position, this.littleEndian);
            this.position += 4;
            return retValue
        }

        getLong() {

            // DataView doesn't support long. So we'll try manually

            var b = [];
            b[0] = this.view.getUint8(this.position);
            b[1] = this.view.getUint8(this.position + 1);
            b[2] = this.view.getUint8(this.position + 2);
            b[3] = this.view.getUint8(this.position + 3);
            b[4] = this.view.getUint8(this.position + 4);
            b[5] = this.view.getUint8(this.position + 5);
            b[6] = this.view.getUint8(this.position + 6);
            b[7] = this.view.getUint8(this.position + 7);

            var value = 0;
            if (this.littleEndian) {
                for (let i = b.length - 1; i >= 0; i--) {
                    value = (value * 256) + b[i];
                }
            } else {
                for (let i = 0; i < b.length; i++) {
                    value = (value * 256) + b[i];
                }
            }


            this.position += 8;
            return value
        }

        getString(len) {

            var s = "";
            var c;
            while ((c = this.view.getUint8(this.position++)) !== 0) {
                s += String.fromCharCode(c);
                if (len && s.length === len) break
            }
            return s
        }

        getFixedLengthString(len) {

            var s = "";
            var i;
            var c;
            for (i = 0; i < len; i++) {
                c = this.view.getUint8(this.position++);
                if (c > 0) {
                    s += String.fromCharCode(c);
                }
            }
            return s
        }

        getFixedLengthTrimmedString(len) {

            var s = "";
            var i;
            var c;
            for (i = 0; i < len; i++) {
                c = this.view.getUint8(this.position++);
                if (c > 32) {
                    s += String.fromCharCode(c);
                }
            }
            return s
        }

        getFloat() {

            var retValue = this.view.getFloat32(this.position, this.littleEndian);
            this.position += 4;
            return retValue


        }

        getDouble() {

            var retValue = this.view.getFloat64(this.position, this.littleEndian);
            this.position += 8;
            return retValue
        }

        skip(n) {

            this.position += n;
            return this.position
        }


        /**
         * Return a BGZip (bam and tabix) virtual pointer
         * TODO -- why isn't 8th byte used ?
         * @returns {*}
         */
        getVPointer() {

            var position = this.position,
                offset = (this.view.getUint8(position + 1) << 8) | (this.view.getUint8(position)),
                byte6 = ((this.view.getUint8(position + 6) & 0xff) * 0x100000000),
                byte5 = ((this.view.getUint8(position + 5) & 0xff) * 0x1000000),
                byte4 = ((this.view.getUint8(position + 4) & 0xff) * 0x10000),
                byte3 = ((this.view.getUint8(position + 3) & 0xff) * 0x100),
                byte2 = ((this.view.getUint8(position + 2) & 0xff)),
                block = byte6 + byte5 + byte4 + byte3 + byte2;
            this.position += 8;

            //       if (block == 0 && offset == 0) {
            //           return null;
            //       } else {
            return new VPointer(block, offset)
            //       }
        }
    }

    class VPointer {
        constructor(block, offset) {
            this.block = block;
            this.offset = offset;
        }

        isLessThan(vp) {
            return this.block < vp.block ||
                (this.block === vp.block && this.offset < vp.offset)
        }

        isGreaterThan(vp) {
            return this.block > vp.block ||
                (this.block === vp.block && this.offset > vp.offset)
        }

        isEqualTo(vp) {
            return this.block === vp.block && this.offset === vp.offset
        }

        print() {
            return "" + this.block + ":" + this.offset
        }
    }

    function optimizeChunks(chunks, lowest) {

        if (chunks.length === 0) return chunks

        chunks.sort(function (c0, c1) {

            const dif = c0.minv.block - c1.minv.block;
            if (dif !== 0) {
                return dif
            } else {
                return c0.minv.offset - c1.minv.offset
            }
        });

        if(chunks.length <= 1) {
            return chunks
        }

        // console.log("Before trimming " + chunks.length)
        // for (let c of chunks) {
        //     console.log(`${c.minv.block} ${c.minv.offset}  -  ${c.maxv.block} ${c.maxv.offset}`)
        // }

        if (lowest) {
            chunks = chunks.filter(c => c.maxv.isGreaterThan(lowest));
        }

        // console.log("Before merging " + chunks.length)
        // for (let c of chunks) {
        //     console.log(`${c.minv.block} ${c.minv.offset}  -  ${c.maxv.block} ${c.maxv.offset}`)
        // }

        const mergedChunks = [];
        let lastChunk;
        for (let chunk of chunks) {

            if (!lastChunk) {
                mergedChunks.push(chunk);
                lastChunk = chunk;
            } else {
                if (canMerge(lastChunk, chunk)) {
                    if (chunk.maxv.isGreaterThan(lastChunk.maxv)) {
                        lastChunk.maxv = chunk.maxv;
                    }
                } else {
                    mergedChunks.push(chunk);
                    lastChunk = chunk;
                }
            }
        }

        // console.log("After merging " + mergedChunks.length)
        // for (let c of mergedChunks) {
        //     console.log(`${c.minv.block} ${c.minv.offset}  -  ${c.maxv.block} ${c.maxv.offset}`)
        // }

        return mergedChunks
    }


    /**
     * Merge 2 blocks if the file position gap between them is < 16 kb, and the total size is < ~5 mb
     * @param chunk1
     * @param chunk2
     * @returns {boolean|boolean}
     */
    function canMerge(chunk1, chunk2) {
        chunk2.minv.block - chunk1.maxv.block;
        const sizeEstimate = chunk1.maxv.block - chunk1.minv.block;
        return sizeEstimate < 5000000
    }

    // Represents a CSI Bam or Tabix index

    const CSI1_MAGIC$1 = 21582659; // CSI\1
    const CSI2_MAGIC$1 = 38359875; // CSI\2

    async function parseCsiIndex(arrayBuffer, genome) {

        const idx = new CSIIndex();
        idx.parse(arrayBuffer, genome);
        return idx
    }

    class CSIIndex {

        constructor(tabix) {
            this.tabix = true;   // Means whatever is indexed is BGZipped
        }

        parse(arrayBuffer, genome) {
            const parser = new BinaryParser(new DataView(arrayBuffer));

            const magic = parser.getInt();

            if (magic !== CSI1_MAGIC$1) {
                if (magic === CSI2_MAGIC$1) {
                    throw Error("CSI version 2 is not supported.  Please enter an issue at https://github.com/igvteam/igv.js")
                } else {
                    throw Error("Not a CSI index")
                }
            }

            this.indices = [];
            this.blockMin = Number.MAX_SAFE_INTEGER;
            this.lastBlockPosition = [];
            this.sequenceIndexMap = {};

            this.minShift = parser.getInt();
            this.depth = parser.getInt();
            const lAux = parser.getInt();
            const seqNames = [];
            let bmax = 0;

            if (lAux >= 28) {
                // Tabix header parameters aren't used, but they must be read to advance the pointer
                parser.getInt();
                parser.getInt();
                parser.getInt();
                parser.getInt();
                parser.getInt();
                parser.getInt();
                const l_nm = parser.getInt();
                const nameEndPos = parser.position + l_nm;
                let i = 0;
                while (parser.position < nameEndPos) {
                    let seq_name = parser.getString();
                    // Translate to "official" chr name.
                    if (genome) {
                        seq_name = genome.getChromosomeName(seq_name);
                    }
                    this.sequenceIndexMap[seq_name] = i;
                    seqNames[i] = seq_name;
                    i++;
                }
            }

            const MAX_BIN = this.bin_limit() + 1;
            const nref = parser.getInt();
            for (let ref = 0; ref < nref; ref++) {
                const binIndex = [];
                const loffset = [];
                const nbin = parser.getInt();
                for (let b = 0; b < nbin; b++) {

                    const binNumber = parser.getInt();
                    loffset[binNumber] = parser.getVPointer();

                    if (binNumber > MAX_BIN) {
                        // This is a psuedo bin, not used but we have to consume the bytes
                        parser.getInt(); // # of chunks for this bin
                        parser.getVPointer();   // unmapped beg
                        parser.getVPointer();   // unmapped end
                        parser.getLong();
                        parser.getLong();

                    } else {

                        binIndex[binNumber] = [];
                        const nchnk = parser.getInt(); // # of chunks for this bin

                        for (let i = 0; i < nchnk; i++) {
                            const cs = parser.getVPointer();    //chunk_beg
                            const ce = parser.getVPointer();    //chunk_end
                            if (cs && ce) {
                                if (cs.block < this.blockMin) {
                                    this.blockMin = cs.block;    // Block containing first alignment
                                }
                                if (ce.block > bmax) {
                                    bmax = ce.block;
                                }
                                binIndex[binNumber].push([cs, ce]);
                            }
                        }
                    }
                }

                if (nbin > 0) {
                    this.indices[ref] = {
                        binIndex: binIndex,
                        loffset: loffset
                    };
                }
            }
            this.lastBlockPosition = bmax;
        }

        get chromosomeNames() {
            return Object.keys(this.sequenceIndexMap)
        }

        /**
         * Fetch blocks for a particular genomic range.  This method is public so it can be unit-tested.
         *
         * @param refId  the sequence dictionary index of the chromosome
         * @param min  genomic start position
         * @param max  genomic end position
         * @param return an array of {minv: {filePointer, offset}, {maxv: {filePointer, offset}}
         */
        chunksForRange(refId, min, max) {

            const ba = this.indices[refId];
            if (!ba) {
                return []
            } else {
                const overlappingBins = this.reg2bins(min, max);        // List of bin #s that overlap min, max
                if (overlappingBins.length == 0) return []

                const chunks = [];
                // Find chunks in overlapping bins.  Leaf bins (< 4681) are not pruned
                for (let binRange of overlappingBins) {
                    for (let bin = binRange[0]; bin <= binRange[1]; bin++) {
                        if (ba.binIndex[bin]) {
                            const binChunks = ba.binIndex[bin];
                            for (let c of binChunks) {
                                const cs = c[0];
                                const ce = c[1];
                                chunks.push({minv: cs, maxv: ce, bin: bin});
                            }
                        }
                    }
                }

                const lowestOffset = ba.loffset[overlappingBins[0]];

                return optimizeChunks(chunks, lowestOffset)
            }

        }

        // reg2bins implementation adapted from GMOD/tabix-js  https://github.com/GMOD/tabix-js/blob/master/src/csi.ts
        reg2bins(beg, end) {
            beg -= 1; // < convert to 1-based closed
            if (beg < 1) beg = 1;
            if (end > 2 ** 34) end = 2 ** 34; // 17 GiB ought to be enough for anybody
            end -= 1;
            let l = 0;
            let t = 0;
            let s = this.minShift + this.depth * 3;
            const bins = [];
            for (; l <= this.depth; s -= 3, t += (1 << l * 3), l += 1) {
                const b = t + (beg >> s);
                const e = t + (end >> s);
                //
                // ITS NOT CLEAR WHERE THIS TEST CAME FROM,  but maxBinNumber is never set, and its not clear what it represents.
                // if (e - b + bins.length > this.maxBinNumber)
                //     throw new Error(
                //         `query ${beg}-${end} is too large for current binning scheme (shift ${this.minShift}, depth ${this.depth}), try a smaller query or a coarser index binning scheme`,
                //     )
                //
                bins.push([b, e]);
            }
            return bins
        }


        bin_limit() {
            return ((1 << (this.depth + 1) * 3) - 1) / 7
        }

    }

    // Represents a BAM or Tabix index.

    const BAI_MAGIC$1 = 21578050;
    const TABIX_MAGIC$1 = 21578324;


    async function parseBamIndex(arrayBuffer, genome) {
        const index = new BamIndex();
        await index.parse(arrayBuffer, false, genome);
        return index
    }

    async function parseTabixIndex(arrayBuffer, genome) {
        const index = new BamIndex();
        await index.parse(arrayBuffer, true, genome);
        return index
    }

    class BamIndex {

        constructor() {

        }

        async parse(arrayBuffer, tabix, genome) {

            const indices = [];
            let blockMin = Number.MAX_SAFE_INTEGER;
            let blockMax = 0;

            const parser = new BinaryParser(new DataView(arrayBuffer));
            const magic = parser.getInt();
            const sequenceIndexMap = {};
            if (magic === BAI_MAGIC$1 || (tabix && magic === TABIX_MAGIC$1)) {

                const nref = parser.getInt();
                if (tabix) {
                    // Tabix header parameters aren't used, but they must be read to advance the pointer
                    parser.getInt();
                    parser.getInt();
                    parser.getInt();
                    parser.getInt();
                    parser.getInt();
                    parser.getInt();
                    parser.getInt();

                    for (let i = 0; i < nref; i++) {
                        let seq_name = parser.getString();
                        // Translate to "official" chr name.
                        if (genome) {
                            seq_name = genome.getChromosomeName(seq_name);
                        }
                        sequenceIndexMap[seq_name] = i;
                    }
                }

                // Loop through sequences
                for (let ref = 0; ref < nref; ref++) {

                    const binIndex = {};
                    const linearIndex = [];
                    const nbin = parser.getInt();

                    for (let b = 0; b < nbin; b++) {
                        const binNumber = parser.getInt();
                        if (binNumber === 37450) {
                            // This is a psuedo bin, not used but we have to consume the bytes
                            parser.getInt(); // # of chunks for this bin
                            parser.getVPointer();   // unmapped beg
                            parser.getVPointer();   // unmapped end
                            parser.getLong();
                            parser.getLong();

                        } else {

                            binIndex[binNumber] = [];
                            const nchnk = parser.getInt(); // # of chunks for this bin

                            for (let i = 0; i < nchnk; i++) {
                                const cs = parser.getVPointer();    //chunk_beg
                                const ce = parser.getVPointer();    //chunk_end
                                if (cs && ce) {
                                    if (cs.block < blockMin) {
                                        blockMin = cs.block;    // Block containing first alignment
                                    }
                                    if (ce.block > blockMax) {
                                        blockMax = ce.block;
                                    }
                                    binIndex[binNumber].push([cs, ce]);
                                }
                            }
                        }
                    }

                    const nintv = parser.getInt();
                    for (let i = 0; i < nintv; i++) {
                        const cs = parser.getVPointer();
                        linearIndex.push(cs);   // Might be null
                    }

                    if (nbin > 0) {
                        indices[ref] = {
                            binIndex: binIndex,
                            linearIndex: linearIndex
                        };
                    }
                }

                this.firstBlockPosition = blockMin;
                this.lastBlockPosition = blockMax;
                this.indices = indices;
                this.sequenceIndexMap = sequenceIndexMap;
                this.tabix = tabix;

            } else {
                throw new Error(indexURL + " is not a " + (tabix ? "tabix" : "bai") + " file")
            }


        }

        get chromosomeNames() {
            return Object.keys(this.sequenceIndexMap)
        }

        /**
         * Fetch chunks for a particular genomic range.  This method is public so it can be unit-tested.
         *
         * @param refId  the sequence dictionary index of the chromosome
         * @param min  genomic start position
         * @param max  genomic end position
         * @param return an array of objects representing chunks (file spans) {minv: {block, offset}, {maxv: {block, offset}}
         */
        chunksForRange(refId, min, max) {

            const bam = this;
            const ba = bam.indices[refId];

            if (!ba) {
                return []
            } else {
                const overlappingBins = reg2bins(min, max);        // List of bin #s that overlap min, max

                //console.log("bin ranges")
                //for(let b of overlappingBins) {
                //    console.log(`${b[0]} - ${b[1]}`)
                //}

                const chunks = [];
                // Find chunks in overlapping bins.  Leaf bins (< 4681) are not pruned
                for (let binRange of overlappingBins) {
                    for (let bin = binRange[0]; bin <= binRange[1]; bin++) {
                        if (ba.binIndex[bin]) {
                            const binChunks = ba.binIndex[bin];
                            for (let c of binChunks) {
                                const cs = c[0];
                                const ce = c[1];
                                chunks.push({minv: cs, maxv: ce});
                            }
                        }
                    }
                }

                // Use the linear index to find minimum file position of chunks that could contain alignments in the region
                const nintv = ba.linearIndex.length;

                let lowest;
                const minLin = Math.min(min >> 14, nintv - 1);    // i.e. min / 16384
                const maxLin = Math.min(max >> 14, nintv - 1);
                for (let i = minLin; i <= maxLin; i++) {
                    const vp = ba.linearIndex[i];
                    if (vp) {
                        lowest = vp;       // lowest file offset that contains alignments overlapping (min, max)
                        break
                    }
                }

                return optimizeChunks(chunks, lowest)
            }
        }
    }



    /**
     * Calculate the list of bins that overlap with region [beg, end]
     *
     */
    function reg2bins(beg, end) {
        const list = [];
        if (end >= 1 << 29) end = 1 << 29;
        --end;
        list.push([0, 0]);
        list.push([1 + (beg >> 26), 1 + (end >> 26)]);
        list.push([9 + (beg >> 23), 9 + (end >> 23)]);
        list.push([73 + (beg >> 20), 73 + (end >> 20)]);
        list.push([585 + (beg >> 17), 585 + (end >> 17)]);
        list.push([4681 + (beg >> 14), 4681 + (end >> 14)]);

        // for (k = 1 + (beg >> 26); k <= 1 + (end >> 26); ++k) list.push(k);
        // for (k = 9 + (beg >> 23); k <= 9 + (end >> 23); ++k) list.push(k);
        // for (k = 73 + (beg >> 20); k <= 73 + (end >> 20); ++k) list.push(k);
        // for (k = 585 + (beg >> 17); k <= 585 + (end >> 17); ++k) list.push(k);
        // for (k = 4681 + (beg >> 14); k <= 4681 + (end >> 14); ++k) list.push(k);
        return list
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    async function parseTribbleIndex(arrayBuffer, genome) {

        const index = new TribbleIndex();
        index.parse(arrayBuffer, genome);
        return index
    }

    class TribbleIndex {

        constructor() {

        }

        async parse(arrayBuffer, genome) {

            let blockMax = 0;
            this.chrIndex = {};
            this.lastBlockPosition = [];
            const parser = new BinaryParser(new DataView(arrayBuffer));
            readHeader(parser);

            let nChrs = parser.getInt();
            while (nChrs-- > 0) {

                // todo -- support interval tree index, we're assuming its a linear index

                let chr = parser.getString();
                if (genome) chr = genome.getChromosomeName(chr); // Translate to canonical name

                const binWidth = parser.getInt();
                const nBins = parser.getInt();
                const longestFeature = parser.getInt();
                parser.getInt() > 0;
                parser.getInt();

                // note the code below accounts for > 60% of the total time to read an index
                let pos = parser.getLong();
                const blocks = [];
                for (let binNumber = 0; binNumber < nBins; binNumber++) {
                    const nextPos = parser.getLong();
                    blocks.push({min: pos, max: nextPos}); //        {position: pos, size: size});
                    pos = nextPos;
                    if (nextPos > blockMax) {
                        blockMax = nextPos;
                    }
                }
                this.chrIndex[chr] = {chr: chr, blocks: blocks, longestFeature: longestFeature, binWidth: binWidth};
            }

            this.lastBlockPosition = blockMax;


            /**
             * Read the header .   Data here is not used in igv.js but we need to read it to advance the pointer.
             * @param parser
             */
            function readHeader(parser) {

                parser.getInt();     //   view._getInt32(offset += 32, true);
                parser.getInt();
                const version = parser.getInt();
                parser.getString();
                parser.getLong();
                parser.getLong();
                parser.getString();
                parser.getInt();
                if (version >= 3) {
                    let nProperties = parser.getInt();
                    while (nProperties-- > 0) {
                        parser.getString();
                        parser.getString();
                    }
                }
            }
        }

        get chromosomeNames() {
            return Object.keys(this.chrIndex)
        }


        /**
         * Fetch blocks for a particular genomic range.
         *
         * @param queryChr the sequence dictionary index of the chromosome
         * @param min  genomic start position
         * @param max  genomic end position
         */
        chunksForRange(queryChr, min, max) { //function (refId, min, max) {
            const chrIdx = this.chrIndex[queryChr];

            if (chrIdx) {
                const blocks = chrIdx.blocks;
                const longestFeature = chrIdx.longestFeature;
                const binWidth = chrIdx.binWidth;
                const adjustedPosition = Math.max(min - longestFeature, 0);
                const startBinNumber = Math.floor(adjustedPosition / binWidth);

                if (startBinNumber >= blocks.length) // are we off the end of the bin list, so return nothing
                    return []
                else {
                    const endBinNumber = Math.min(Math.floor((max - 1) / binWidth), blocks.length - 1);

                    // By definition blocks are adjacent in the file for the liner index.  Combine them into one merged block
                    const startPos = blocks[startBinNumber].min;
                    const endPos = blocks[endBinNumber].max;
                    const size = endPos - startPos;
                    if (size === 0) {
                        return []
                    } else {
                        const mergedBlock = {minv: {block: startPos, offset: 0}, maxv: {block: endPos, offset: 0}};
                        return [mergedBlock]
                    }
                }
            } else {
                return undefined
            }
        }
    }

    const CSI1_MAGIC = 21582659; // CSI\1
    const CSI2_MAGIC = 38359875; // CSI\2
    const BAI_MAGIC = 21578050;
    const TABIX_MAGIC = 21578324;
    const TRIBBLE_MAGIC = 1480870228;   //  byte[]{'T', 'I', 'D', 'X'};

    /**
     * @param indexURL
     * @param config
     * @param tabix
     *
     */
    async function loadIndex(indexURL, config, genome) {

        let arrayBuffer = await igvxhr.loadArrayBuffer(indexURL, buildOptions(config));
        let dv = new DataView(arrayBuffer);

        // Some indexs are bgzipped, specifically tabix, and csi.  Bam (bai) are not.  Tribble is usually not.
        // Check first 2 bytes of file for gzip magic number, and inflate if neccessary
        if (dv.getUint8(0) === 0x1f && dv.getUint8(1) === 0x8b) {    // gzipped
            const inflate = unbgzf(arrayBuffer);
            arrayBuffer = inflate.buffer;
            dv = new DataView(arrayBuffer);
        }

        const magic = dv.getInt32(0, true);
        switch (magic) {
            case BAI_MAGIC:
                return parseBamIndex(arrayBuffer, genome)
            case TABIX_MAGIC:
                return parseTabixIndex(arrayBuffer, genome)
            case CSI1_MAGIC:
                return parseCsiIndex(arrayBuffer, genome)
            case TRIBBLE_MAGIC:
                return parseTribbleIndex(arrayBuffer, genome)
            case CSI2_MAGIC:
                throw Error("CSI version 2 is not supported.")
            default:
                throw Error(`Unrecognized index type: ${indexURL}`)
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    function getDataWrapper(data) {

        if (typeof (data) == 'string' || data instanceof String) {
            return new StringDataWrapper(data)
        } else {
            return new ByteArrayDataWrapper(data)
        }
    }


    // Data might be a string, or an UInt8Array
    class StringDataWrapper {

        constructor(string) {
            this.data = string;
            this.ptr = 0;
        }

        nextLine() {
            var start = this.ptr,
                idx = this.data.indexOf('\n', start),
                data = this.data;

            if (idx > 0) {
                this.ptr = idx + 1;   // Advance pointer for next line
                if (idx > start && data.charAt(idx - 1) === '\r') {
                    // Trim CR manually in CR/LF sequence
                    return data.substring(start, idx - 1)
                }
                return data.substring(start, idx)
            } else {
                var length = data.length;
                this.ptr = length;
                // Return undefined only at the very end of the data
                return (start >= length) ? undefined : data.substring(start)
            }
        }
    }

    class ByteArrayDataWrapper {

        constructor(array) {
            this.data = array;
            this.length = this.data.length;
            this.ptr = 0;
        }

        nextLine() {

            var c, result;
            result = "";

            if (this.ptr >= this.length) return undefined

            for (var i = this.ptr; i < this.length; i++) {
                c = String.fromCharCode(this.data[i]);
                if (c === '\r') continue
                if (c === '\n') break
                result = result + c;
            }

            this.ptr = i + 1;
            return result
        }

    }

    /**
     * Class to iterate line-by-line over a BGZipped text file.  This class is useful for iterating from the start of
     * the file.  Not useful for indexed queries.
     */

    class BGZLineReader {

        constructor(config) {
            this.config = config;
            this.filePtr = 0;
            this.bufferPtr = 0;
            this.buffer;
        }

        async nextLine() {

            let result = undefined;

            try {
                while (true) {
                    const length = this.buffer ? this.buffer.length : 0;
                    while (this.bufferPtr < length) {
                        const c = String.fromCharCode(this.buffer[this.bufferPtr++]);
                        if (c === '\r') continue
                        if (c === '\n') {
                            return result
                        }
                        result = result ? result + c : c;
                    }
                    if (this.eof) {
                        return result
                    } else {
                        await this.readNextBlock();
                    }
                }
            } catch (e) {
                console.warn(e);
                this.eof = true;
                return result
            }
        }

        async readNextBlock() {

            const bsizeOptions = buildOptions(this.config, {
                range: {
                    start: this.filePtr,
                    size: 26
                }
            });
            const abuffer = await igvxhr.loadArrayBuffer(this.config.url, bsizeOptions);
            const bufferSize = bgzBlockSize$1(abuffer);

            if (bufferSize === 0) {
                this.eof = true;
                this.buffer = undefined;
            } else {

                const options = buildOptions(this.config, {range: {start: this.filePtr, size: bufferSize}});
                const data = await igvxhr.loadArrayBuffer(this.config.url, options);
                if (data.byteLength < bufferSize) {
                    this.eof = true; // Assumption
                }
                this.buffer = unbgzf(data);
                if(this.buffer.byteLength == 0) {
                    this.eof = true;
                }
                this.bufferPtr = 0;
                this.filePtr += data.byteLength; //data.byteLength;
            }
        }

    }

    function concatenateArrayBuffers(arrayBuffers) {

        if (arrayBuffers.length === 1) {
            return arrayBuffers[0]
        }

        let len = 0;
        for (const b of arrayBuffers) {
            len += b.byteLength;
        }
        const c = new Uint8Array(len);
        let offset = 0;
        for (const b of arrayBuffers) {
            c.set(new Uint8Array(b), offset);
            offset += b.byteLength;
        }
        return c.buffer
    }

    /**
     * Return the block size for the data buffer.
     * @param data
     * @returns {number}
     */
    const bgzBlockSize = (data) => {
        const ba = ArrayBuffer.isView(data) ? data : new Uint8Array(data);
        const bsize = (ba[17] << 8 | ba[16]) + 1;
        return bsize
    };

    class BGZBlockLoader {

        constructor(config) {
            this.config = config;
            this.cacheBlocks = false != config.cacheBlocks;   // Default to true
            this.cache = undefined;
        }

        /**
         * Return inflated data from startBlock through endBlock as an UInt8Array
         *
         * @param minv minimum virtual pointer  {block, offset}
         * @param maxv maximum virtual pointer  {block, offset}
         * @returns {Promise<Uint8Array>}
         */
        async getData(minv, maxv) {

            const startBlock = minv.block;
            const endBlock = maxv.block;
            const skipEnd = maxv.offset === 0;

            const blocks = await this.getInflatedBlocks(startBlock, endBlock, skipEnd);
            if (blocks.length === 1) {
                return blocks[0]
            }

            let len = 0;
            for (const b of blocks) {
                len += b.byteLength;
            }
            const c = new Uint8Array(len);
            let offset = 0;
            for (const b of blocks) {
                c.set(b, offset);
                offset += b.byteLength;
            }
            return c
        }

        /**
         * Return the inflated data for the specified blocks as an array of Uint8Arrays.  This method is public so
         * it can be unit tested. *
         * @param startBlock
         * @param endBlock
         * @returns {Promise<*[Uint8Array]>}
         */
        async getInflatedBlocks(startBlock, endBlock, skipEnd) {

            if (!this.cacheBlocks) {
                const buffer = await this.loadBLockData(startBlock, endBlock, {skipEnd});
                return inflateBlocks(buffer)
            } else {

                const c = this.cache;
                if (c &&
                    c.startBlock <= startBlock &&
                    (c.endBlock >= endBlock || skipEnd && c.nextEndBlock === endBlock)) {
                    //console.log("Complete overlap")
                    const startOffset = startBlock - c.startBlock;
                    const endOffset = endBlock - c.startBlock;
                    return inflateBlocks(c.buffer, startOffset, endOffset)
                    // Don't update cache, still valid
                } else {

                    let buffer;
                    if (!c || (c.startBlock > endBlock || c.endBlock < startBlock)) {
                        // no overlap with cache
                        buffer = await this.loadBLockData(startBlock, endBlock, {skipEnd});
                    } else {

                        //console.log("Some overlap")
                        const arrayBuffers = [];

                        // Load blocks preceding cache start, if any
                        if (startBlock < c.startBlock) {
                            // load first blocks
                            const startBuffer = await this.loadBLockData(startBlock, c.startBlock, {skipEnd: true});
                            arrayBuffers.push(startBuffer);
                        }

                        // Slice cached buffer as needed
                        let cachedBuffer;
                        if (startBlock <= c.startBlock && endBlock >= c.endBlock) {
                            cachedBuffer = c.buffer;
                        } else {
                            const start = Math.max(0, startBlock - c.startBlock);
                            let end;
                            if (endBlock >= c.endBlock) {
                                end = c.buffer.byteLength;
                            } else {
                                // We need to find the byte position of the end of "endBlock"
                                const boundaries = findBlockBoundaries(c.buffer);
                                for (let i = 0; i < boundaries.length - 1; i++) {
                                    if (c.startBlock + boundaries[i] === endBlock) {
                                        end = boundaries[i + 1];
                                        break
                                    }
                                }
                                // Do something if end not found
                            }
                            cachedBuffer = c.buffer.slice(start, end);
                        }
                        arrayBuffers.push(cachedBuffer);

                        // Load end blocks, if any
                        if (endBlock > c.endBlock) {
                            const endBuffer = await this.loadBLockData(c.endBlock, endBlock, {skipStart: true, skipEnd});
                            arrayBuffers.push(endBuffer);
                        }

                        buffer = concatenateArrayBuffers(arrayBuffers);
                    }

                    // If skipEnd === true we need to find boundary of last block in cache
                    let nextEndBlock = endBlock;
                    if(skipEnd) {
                        const boundaries = findBlockBoundaries(buffer);
                        endBlock = boundaries[boundaries.length - 1];
                    }

                    this.cache = {startBlock, endBlock, nextEndBlock, buffer};
                    return inflateBlocks(buffer)
                }
            }
        }

        async loadBLockData(startBlock, endBlock, options) {

            const config = this.config;
            const skipStart = options && options.skipStart;
            const skipEnd = options && options.skipEnd;

            // Get size of last block if not skipped
            let lastBlockSize = 0;
            if (!skipEnd) {
                const bsizeOptions = buildOptions(config, {range: {start: endBlock, size: 26}});
                const abuffer = await igvxhr.loadArrayBuffer(config.url, bsizeOptions);
                lastBlockSize = bgzBlockSize(abuffer);
            }

            if (skipStart) {
                const bsizeOptions = buildOptions(config, {range: {start: startBlock, size: 26}});
                const abuffer = await igvxhr.loadArrayBuffer(config.url, bsizeOptions);
                startBlock += bgzBlockSize(abuffer);
            }

            // Load data for all blocks
            const loadOptions = buildOptions(config, {
                range: {
                    start: startBlock,
                    size: endBlock + lastBlockSize - startBlock
                }
            });

            //console.log(`${this.config.name}  Loaded ${startBlock} - ${endBlock + lastBlockSize}   (${(endBlock + lastBlockSize - startBlock) / 1000} kb)`)

            return igvxhr.loadArrayBuffer(config.url, loadOptions)
        }
    }

    function findBlockBoundaries(arrayBuffer) {

        const byteLengh = arrayBuffer.byteLength;
        let offset = 0;
        const blockBoundaries = [0];
        while (offset < byteLengh) {
            //console.log("Cache block "  + offset)
            const ba = new Uint8Array(arrayBuffer, offset);
            const bsize = (ba[17] << 8 | ba[16]) + 1;
            offset += bsize;
            if (offset < byteLengh) {
                blockBoundaries.push(offset);
            }
        }
        return blockBoundaries
    }


    /**
     * Inflate compressed blocks within the data buffer*
     * @param data
     * @param startBlock - optional file location for start block.  Default == 0
     * @param endBlock - optional file location for last block to decompress.
     * @returns {*[]}
     */
    function inflateBlocks(data, startBlock, endBlock) {

        startBlock = startBlock || 0;

        const oBlockList = [];
        let ptr = startBlock;

        const lim = data.byteLength - 18;
        while (ptr < lim) {
            try {
                //console.log(113873 + ptr)
                const header = new Uint8Array(data, ptr, 18);
                const xlen = (header[11] << 8) | (header[10]);
                const bsize = ((header[17] << 8) | (header[16]));  // Total block size, including header, minus 1
                const start = 12 + xlen + ptr;    // Start of CDATA
                const bytesLeft = data.byteLength - start;
                const cDataSize = bsize - xlen - 18;

                if (bytesLeft < cDataSize || cDataSize <= 0) {
                    // This is unexpected.  Throw error?
                    break
                }

                const cdata = new Uint8Array(data, start, cDataSize);
                const unc = inflateRaw_1(cdata);
                oBlockList.push(unc);

                if (endBlock === ptr) {
                    break
                } else {
                    // Advance to next block
                    ptr += bsize + 1;
                }

            } catch (e) {
                console.error(e);
                break
            }
        }
        return oBlockList
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    /**
     * Reader for "bed like" files (tab delimited files with 1 feature per line: bed, gff, vcf, etc)
     *
     * @param config
     * @constructor
     */
    class FeatureFileReader {

        constructor(config, genome) {

            var uriParts;

            this.config = config || {};
            this.genome = genome;
            this.indexURL = config.indexURL;
            this.indexed = config.indexed || this.indexURL !== undefined;
            this.queryable = this.indexed;

            if (isFile(this.config.url)) {
                this.filename = this.config.url.name;
            } else if (isDataURL(this.config.url)) {
                this.indexed = false;  // by definition
                this.dataURI = config.url;
            } else {
                uriParts = parseUri(this.config.url);
                this.filename = config.filename || uriParts.file;
            }

            this.parser = this.getParser(this.config);

            if (this.config.format === "vcf" && !this.config.indexURL) {
                console.warn("Warning: index file not specified.  The entire vcf file will be loaded.");
            }

        }

        async defaultVisibilityWindow() {
            if (this.config.indexURL) {
                const index = await this.getIndex();
                if (index && index.lastBlockPosition) {
                    let gl = 0;
                    const s = 10000;
                    for (let c of index.chromosomeNames) {
                        const chromosome = this.genome.getChromosome(c);
                        if (chromosome) {
                            gl += chromosome.bpLength;
                        }
                    }
                    return Math.round((gl / index.lastBlockPosition) * s)
                }
            }
        }

        /**
         * Return a promise to load features for the genomic interval
         * @param chr
         * @param start
         * @param end
         */
        async readFeatures(chr, start, end) {

            const index = await this.getIndex();
            if (index) {
                this.indexed = true;
                return this.loadFeaturesWithIndex(chr, start, end)
            } else if (this.dataURI) {
                this.indexed = false;
                return this.loadFeaturesFromDataURI()
            } else {
                this.indexed = false;
                return this.loadFeaturesNoIndex()
            }

        }

        async readHeader() {

            if (this.dataURI) {
                await this.loadFeaturesFromDataURI(this.dataURI);
                return this.header
            } else {

                if (this.config.indexURL) {
                    const index = await this.getIndex();
                    if (!index) {
                        // Note - it should be impossible to get here
                        throw new Error("Unable to load index: " + this.config.indexURL)
                    }

                    let dataWrapper;
                    if (index.tabix) {
                        this._blockLoader = new BGZBlockLoader(this.config);
                        dataWrapper = new BGZLineReader(this.config);
                    } else {
                        // Tribble
                        const maxSize = Object.values(index.chrIndex)
                            .flatMap(chr => chr.blocks)
                            .map(block => block.max)
                            .reduce((previous, current) =>
                                Math.min(previous, current), Number.MAX_SAFE_INTEGER);

                        const options = buildOptions(this.config, {bgz: index.tabix, range: {start: 0, size: maxSize}});
                        const data = await igvxhr.loadString(this.config.url, options);
                        dataWrapper = getDataWrapper(data);
                    }


                    this.header = await this.parser.parseHeader(dataWrapper);  // Cache header, might be needed to parse features
                    return this.header

                } else {
                    // If this is a non-indexed file we will load all features in advance
                    const options = buildOptions(this.config);
                    const data = await igvxhr.loadString(this.config.url, options);
                    let dataWrapper = getDataWrapper(data);
                    this.header = await this.parser.parseHeader(dataWrapper);

                    // Reset data wrapper and parse features
                    dataWrapper = getDataWrapper(data);
                    this.features = await this.parser.parseFeatures(dataWrapper);   // cache features
                    return this.header
                }
            }
        }


        getParser(config) {

            switch (config.format) {
                case "vcf":
                    return new VcfParser(config)
                case "seg" :
                    return new SegParser("seg")
                case "mut":
                    return new SegParser("mut")
                case "maf":
                    return new SegParser("maf")
                case "gwas" :
                    return new GWASParser(config)
                case "aed" :
                    return new AEDParser(config)
                default:
                    return new FeatureParser(config)
            }
        }

        async loadFeaturesNoIndex() {

            if (this.features) {
                // An optimization hack for non-indexed files, features are temporarily cached when header is read.
                const tmp = this.features;
                delete this.features;
                return tmp
            } else {
                const options = buildOptions(this.config);    // Add oauth token, if any
                const data = await igvxhr.loadString(this.config.url, options);
                if (!this.header) {
                    const dataWrapper = getDataWrapper(data);
                    this.header = await this.parser.parseHeader(dataWrapper);
                }
                const dataWrapper = getDataWrapper(data);
                const features = await this.parser.parseFeatures(dataWrapper);   // <= PARSING DONE HERE
                return features
            }
        }

        async loadFeaturesWithIndex(chr, start, end) {

            // insure that header has been loaded -- tabix _blockLoader is initialized as side effect
            if(!this.dataURI && !this.header) {
                await this.readHeader();
            }

            //console.log("Using index"
            const config = this.config;
            const parser = this.parser;
            const tabix = this.index.tabix;
            const refId = tabix ? this.index.sequenceIndexMap[chr] : chr;
            if (refId === undefined) {
                return []
            }

            const genome = this.genome;
            const chunks = this.index.chunksForRange(refId, start, end);
            if (!chunks || chunks.length === 0) {
                return []
            } else {
                const allFeatures = [];
                for (let chunk of chunks) {

                    let inflated;
                    if (tabix) {
                        inflated = await this._blockLoader.getData(chunk.minv, chunk.maxv);
                    } else {
                        const options = buildOptions(config, {
                            range: {
                                start: chunk.minv.block,
                                size: chunk.maxv.block - chunk.minv.block + 1
                            }
                        });
                        inflated = await igvxhr.loadString(config.url, options);
                    }

                    const slicedData = chunk.minv.offset ? inflated.slice(chunk.minv.offset) : inflated;
                    const dataWrapper = getDataWrapper(slicedData);
                    let slicedFeatures = await parser.parseFeatures(dataWrapper);

                    // Filter psuedo-features (e.g. created mates for VCF SV records)
                    slicedFeatures = slicedFeatures.filter(f => f._f === undefined);

                    // Filter features not in requested range.
                    let inInterval = false;
                    for (let i = 0; i < slicedFeatures.length; i++) {
                        const f = slicedFeatures[i];

                        const canonicalChromosome = genome ? genome.getChromosomeName(f.chr) : f.chr;
                        if (canonicalChromosome !== chr) {
                            if (allFeatures.length === 0) {
                                continue  //adjacent chr to the left
                            } else {
                                break //adjacent chr to the right
                            }
                        }
                        if (f.start > end) {
                            allFeatures.push(f);  // First feature beyond interval
                            break
                        }
                        if (f.end >= start && f.start <= end) {
                            if (!inInterval) {
                                inInterval = true;
                                if (i > 0) {
                                    allFeatures.push(slicedFeatures[i - 1]);
                                }
                            }
                            allFeatures.push(f);
                        }
                    }

                }
                allFeatures.sort(function (a, b) {
                    return a.start - b.start
                });

                return allFeatures
            }
        }

        async getIndex() {
            if (this.index) {
                return this.index
            } else if (this.config.indexURL) {
                this.index = await this.loadIndex();
                return this.index
            }
        }

        /**
         * Return a Promise for the async loaded index
         */
        async loadIndex() {
            const indexURL = this.config.indexURL;
            return loadIndex(indexURL, this.config, this.genome)
        }

        async loadFeaturesFromDataURI() {

            if (this.features) {
                // An optimization hack for non-indexed files, features are temporarily cached when header is read.
                const tmp = this.features;
                delete this.features;
                return tmp
            } else {
                const plain = decodeDataURI$1(this.dataURI);
                let dataWrapper = getDataWrapper(plain);
                this.header = await this.parser.parseHeader(dataWrapper);
                if (this.header instanceof String && this.header.startsWith("##gff-version 3")) {
                    this.format = 'gff3';
                }

                dataWrapper = getDataWrapper(plain);
                this.features = await this.parser.parseFeatures(dataWrapper);
                return this.features
            }
        }

    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 University of California San Diego
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const isString$1 = isString$2;


    class CustomServiceReader {
        constructor(config) {
            this.config = config;
        }

        async readFeatures(chr, start, end) {

            let url;
            if (typeof this.config.url === 'function') {
                url = this.config.url({chr, start, end});
            } else {
                url = this.config.url
                    .replace("$CHR", chr)
                    .replace("$START", start)
                    .replace("$END", end);
            }

            let config = Object.assign({}, this.config);
            if (this.config.body !== undefined) {
                if (typeof this.config.body === 'function') {
                    config.body = this.config.body({chr, start, end});
                } else {
                    config.body =
                        this.config.body
                            .replace("$CHR", chr)
                            .replace("$START", start)
                            .replace("$END", end);
                }
            }


            let features;
            const data = await igvxhr.load(url, config);
            if (data) {
                if (typeof this.config.parser === "function") {
                    features = this.config.parser(data);
                } else if (isString$1(data)) {
                    features = JSON.parse(data);
                } else {
                    features = data;
                }
            }
            if (this.config.mappings) {
                let mappingKeys = Object.keys(this.config.mappings);
                for (let f of features) {
                    for (let key of mappingKeys) {
                        f[key] = f[this.config.mappings[key]];
                    }
                }
            }
            return features
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const UCSCServiceReader = function (config, genome) {
        this.config = config;
        this.genome = genome;
        this.expandQueryInterval = false;
    };

    UCSCServiceReader.prototype.readFeatures = function (chr, start, end) {

        const s = Math.max(0, Math.floor(start));
        let e = Math.ceil(end);

        if (this.genome) {
            const c = this.genome.getChromosome(chr);
            if (c && e > c.bpLength) {
                e = c.bpLength;
            }
        }


        const url = this.config.url + '?db=' + this.config.db + '&table=' + this.config.tableName + '&chr=' + chr + '&start=' + s + '&end=' + e;

        return igvxhr.loadJson(url, this.config)
            .then(function (data) {
                if (data) {
                    data.forEach(function (sample) {
                        if (sample.hasOwnProperty('exonStarts') &&
                            sample.hasOwnProperty('exonEnds') &&
                            sample.hasOwnProperty('exonCount') &&
                            sample.hasOwnProperty('cdsStart') &&
                            sample.hasOwnProperty('cdsEnd')) {
                            addExons(sample);
                        }
                    });
                    return data
                } else {
                    return null
                }
            })
    };

    function addExons(sample) {
        var exonCount, exonStarts, exonEnds, exons, eStart, eEnd;
        exonCount = sample['exonCount'];
        exonStarts = sample['exonStarts'].split(',');
        exonEnds = sample['exonEnds'].split(',');
        exons = [];

        for (var i = 0; i < exonCount; i++) {
            eStart = parseInt(exonStarts[i]);
            eEnd = parseInt(exonEnds[i]);
            var exon = {start: eStart, end: eEnd};

            if (sample.cdsStart > eEnd || sample.cdsEnd < sample.cdsStart) exon.utr = true;   // Entire exon is UTR
            if (sample.cdsStart >= eStart && sample.cdsStart <= eEnd) exon.cdStart = sample.cdsStart;
            if (sample.cdsEnd >= eStart && sample.cdsEnd <= eEnd) exon.cdEnd = sample.cdsEnd;

            exons.push(exon);
        }

        sample.exons = exons;
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2021 University of California San Diego
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const gffNameFields = ["Name", "gene_name", "gene", "gene_id", "alias", "locus", "name"];

    class GFFHelper {

        constructor(options) {
            this.format = options.format;
            this.nameField = options.nameField;
            this.filterTypes = options.filterTypes === undefined ?
                new Set(['chromosome']) :
                new Set(options.filterTypes);
        }

        combineFeatures(features, genomicInterval) {

            let combinedFeatures;

            const filterTypes = this.filterTypes;
            features = features.filter(f => filterTypes === undefined || !filterTypes.has(f.type));

            if ("gff3" === this.format) {
                const tmp = this.combineFeaturesById(features);
                combinedFeatures = this.combineFeaturesByType(tmp);
            } else {
                combinedFeatures = this.combineFeaturesByType(features);
            }
            combinedFeatures.sort(function (a, b) {
                return a.start - b.start
            });
            this.numberExons(combinedFeatures, genomicInterval);
            this.nameFeatures(combinedFeatures);
            return combinedFeatures
        }

        /**
         * Combine multiple non-transcript model features with the same ID on the same chromosome into a single feature.
         * Features that are part of the transcript model (e.g. exon, mRNA, etc) are combined later.
         *
         * @param features
         * @returns {[]}
         */
        combineFeaturesById(features) {

            const chrIdMap = new Map();
            const combinedFeatures = [];

            for (let f of features) {
                if (isTranscriptPart(f.type) || isTranscript(f.type) || !f.id) {
                    combinedFeatures.push(f);
                } else {
                    let idMap = chrIdMap.get(f.chr);
                    if (!idMap) {
                        idMap = new Map();
                        chrIdMap.set(f.chr, idMap);
                    }

                    let featureArray = idMap.get(f.id);
                    if (featureArray) {
                        featureArray.push(f);
                    } else {
                        idMap.set(f.id, [f]);
                    }
                }
            }

            for (let idMap of chrIdMap.values()) {
                for (let featureArray of idMap.values()) {
                    if (featureArray.length > 1) {
                        // Use the first feature as prototypical (for column 9 attributes), and adjust start/end
                        // Parts are represented as "exons", as that is how they are presented visually
                        const cf = featureArray[0];
                        cf.exons = [];
                        for (let f of featureArray) {
                            cf.start = Math.min(cf.start, f.start);
                            cf.end = Math.max(cf.end, f.end);
                            cf.exons.push({
                                start: f.start,
                                end: f.end
                            });
                        }
                        combinedFeatures.push(cf);
                    } else {
                        combinedFeatures.push(featureArray[0]);
                    }
                }
            }

            return combinedFeatures
        }

        combineFeaturesByType(features) {

            // Build dictionary of genes
            const genes = features.filter(f => "gene" === f.type || f.type.endsWith("_gene"));
            const geneMap = Object.create(null);
            for (let g of genes) {
                geneMap[g.id] = g;
            }

            // 1. Build dictionary of transcripts
            const transcripts = Object.create(null);
            const combinedFeatures = [];
            const consumedFeatures = new Set();
            const filterTypes = this.filterTypes;

            features = features.filter(f => filterTypes === undefined || !filterTypes.has(f.type));

            for (let f of features) {

                if (f.type === "biological_region") {
                    console.log();
                }

                if (isTranscript(f.type)) {
                    const transcriptId = f.id; // getAttribute(f.attributeString, "transcript_id", /\s+/);
                    if (undefined !== transcriptId) {
                        const gffTranscript = new GFFTranscript(f);
                        transcripts[transcriptId] = gffTranscript;
                        combinedFeatures.push(gffTranscript);
                        consumedFeatures.add(f);
                        const g = geneMap[f.parent];
                        if (g) {
                            gffTranscript.geneObject = g;
                            consumedFeatures.add(g);
                        }
                    }
                }
            }

            // Add exons and transcript parts
            for (let f of features) {
                if (isTranscriptPart(f.type)) {
                    const parents = getParents(f);
                    if (parents) {
                        for (let id of parents) {

                            let transcript = transcripts[id];
                            if (!transcript && this.format === "gtf") {
                                // GTF does not require explicit transcript record, start one with this feature.
                                const psuedoTranscript = Object.assign({}, f);
                                psuedoTranscript.type = "transcript";
                                transcript = new GFFTranscript(psuedoTranscript);
                                transcripts[id] = transcript;
                                combinedFeatures.push(transcript);
                            }
                            if (transcript !== undefined) {

                                if (isExon(f.type)) {
                                    if (parents.length > 1) {
                                        // Make a copy as exon can be modified differently by CDS, etc, for each transcript
                                        const e2 = new GFFFeature(f);
                                        transcript.addExon(e2);
                                    } else {
                                        transcript.addExon(f);
                                    }
                                } else {
                                    transcript.addPart(f);
                                }
                                consumedFeatures.add(f);
                            }
                        }
                    }
                }
            }

            // Finish transcripts
            combinedFeatures.forEach(function (f) {
                if (typeof f.finish === "function") {
                    f.finish();
                }
            });

            // Add other features
            const others = features.filter(f => !consumedFeatures.has(f));
            for (let f of others) {
                combinedFeatures.push(f);
            }

            return combinedFeatures

            function getParents(f) {
                if (f.parent && f.parent.trim() !== "") {
                    return f.parent.trim().split(",")
                } else {
                    return null
                }
            }
        }

        numberExons(features, genomicInterval) {

            for (let f of features) {
                if (f.exons &&
                    (!genomicInterval ||
                        (f.end <= genomicInterval.end && f.start > genomicInterval.start))) {
                    for (let i = 0; i < f.exons.length; i++) {
                        const exon = f.exons[i];
                        exon.number = f.strand === "-" ? f.exons.length - i : i + 1;
                    }
                }
            }
        }

        nameFeatures(features) {
            // Find name (label) property
            for (let f of features) {
                if (f.attributeString) {
                    const delim = ('gff3' === this.format) ? '=' : ' ';
                    const attributes = parseAttributeString(f.attributeString, delim);
                    const attributesMap = new Map(attributes);
                    if (this.nameField) {
                        f.name = attributesMap.get(this.nameField);
                    } else {
                        for (let nameField of gffNameFields) {
                            if (attributesMap.has(nameField)) {
                                f.name = attributesMap.get(nameField);
                                break
                            }
                        }
                    }
                }
            }
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2015 UC San Diego
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const GtexReader = function (config) {

        this.config = config;
        this.url = config.url;
        this.tissueId = config.tissueSiteDetailId;
        this.indexed = true;
        this.datasetId = config.datasetId || "gtex_v8";
    };

    GtexReader.prototype.readFeatures = async function (chr, bpStart, bpEnd) {


        let self = this,
            queryChr = chr.startsWith("chr") ? chr : "chr" + chr,
            queryStart = Math.floor(bpStart),
            queryEnd = Math.ceil(bpEnd),
            datasetId = this.datasetId,
            queryURL = this.url + "?chromosome=" + queryChr + "&start=" + queryStart + "&end=" + queryEnd +
                "&tissueSiteDetailId=" + this.tissueId + "&datasetId=" + datasetId;

        const json = await igvxhr.loadJson(queryURL, {
            withCredentials: self.config.withCredentials
        });
        if (json && json.singleTissueEqtl) {
            //variants = json.variants;
            //variants.sort(function (a, b) {
            //    return a.POS - b.POS;
            //});
            //source.cache = new FeatureCache(chr, queryStart, queryEnd, variants);

            json.singleTissueEqtl.forEach(function (eqtl) {
                eqtl.chr = eqtl.chromosome;
                eqtl.position = eqtl.pos;
                eqtl.start = eqtl.pos - 1;
                eqtl.end = eqtl.start + 1;
                eqtl.snp = eqtl.snpId;
                eqtl.geneName = eqtl.geneSymbol;
                eqtl.geneId = eqtl.gencodeId;

            });

            return json.singleTissueEqtl
        } else {
            return undefined
        }
    };

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    // Experimental class for fetching features from an mpg webservice.
    // http://immvar.broadinstitute.org:3000/load_data?chromosome=&start=&end=&categories=

    const ImmVarReader = function (config) {

        this.config = config;
        this.url = config.url;
        this.cellConditionId = config.cellConditionId;
        this.valueThreshold = config.valueThreshold ? config.valueThreshold : 5E-2;

    };

    ImmVarReader.prototype.readFeatures = function (queryChr, queryStart, queryEnd) {

        var self = this,
            queryURL = this.url + "?chromosome=" + queryChr + "&start=" + queryStart + "&end=" + queryEnd +
                "&cell_condition_id=" + this.cellConditionId;

        return new Promise(function (fulfill, reject) {
            igvxhr.loadJson(queryURL, {
                withCredentials: self.config.withCredentials
            }).then(function (json) {

                if (json) {
                    //variants = json.variants;
                    //variants.sort(function (a, b) {
                    //    return a.POS - b.POS;
                    //});
                    //source.cache = new FeatureCache(chr, queryStart, queryEnd, variants);

                    json.eqtls.forEach(function (eqtl) {
                        eqtl.chr = eqtl.chromosome;
                        eqtl.start = eqtl.position;
                        eqtl.end = eqtl.position + 1;
                    });

                    fulfill(json.eqtls);
                } else {
                    fulfill(null);
                }

            }).catch(function (error) {
                reject(error);
            });

        })
    };

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const apiKey = igvxhr.apiKey;

    function ga4ghGet(options) {
        var url = options.url + "/" + options.entity + "/" + options.entityId;
        options.headers = ga4ghHeaders();
        return igvxhr.loadJson(url, options)      // Returns a promise
    }

    function ga4ghSearch(options) {

        return new Promise(function (fulfill, reject) {
            var results = options.results ? options.results : [],
                url = options.url,
                body = options.body,
                decode = options.decode,
                paramSeparator = "?",
                fields = options.fields;  // Partial response


            if (apiKey) {
                url = url + paramSeparator + "key=" + apiKey;
                paramSeparator = "&";
            }

            if (fields) {
                url = url + paramSeparator + "fields=" + fields;
            }


            // Start the recursive load cycle.  Data is fetched in chunks, if more data is available a "nextPageToken" is returned.
            return loadChunk()

            function loadChunk(pageToken) {

                if (pageToken) {
                    body.pageToken = pageToken;
                } else {
                    if (body.pageToken !== undefined) delete body.pageToken;    // Remove previous page token, if any
                }

                var sendData = JSON.stringify(body);

                igvxhr.loadJson(url, {
                    sendData: sendData,
                    contentType: "application/json",
                    headers: ga4ghHeaders(),
                    //    oauthToken: ga4ghToken()
                })
                    .then(function (json) {
                        var nextPageToken, tmp;

                        if (json) {

                            tmp = decode ? decode(json) : json;

                            if (tmp) {

                                tmp.forEach(function (a) {
                                    {
                                        results.push(a);
                                    }
                                });
                            }


                            nextPageToken = json["nextPageToken"];

                            if (nextPageToken) {
                                loadChunk(nextPageToken);
                            } else {
                                fulfill(results);
                            }
                        } else {
                            fulfill(results);
                        }

                    })
                    .catch(function (error) {
                        reject(error);
                    });
            }

        })


    }

    function ga4ghHeaders() {
        return {
            "Cache-Control": "no-cache"
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const Ga4ghVariantReader = function (config, genome) {

        this.config = config;
        this.genome = genome;
        this.url = config.url;
        this.variantSetId = config.variantSetId;
        this.callSetIds = config.callSetIds;
        this.includeCalls = (config.includeCalls === undefined ? true : config.includeCalls);

    };

    // Simulate a VCF file header
    Ga4ghVariantReader.prototype.readHeader = function () {

        var self = this;


        if (self.header) {
            return Promise.resolve(self.header)
        } else {

            self.header = {};

            if (self.includeCalls === false) {
                return Promise.resolve(self.header)
            } else {

                var readURL = self.url + "/callsets/search";

                return ga4ghSearch({
                    url: readURL,
                    fields: "nextPageToken,callSets(id,name)",
                    body: {
                        "variantSetIds": (Array.isArray(self.variantSetId) ? self.variantSetId : [self.variantSetId]),
                        "pageSize": "10000"
                    },
                    decode: function (json) {
                        // If specific callSetIds are specified filter to those
                        if (self.callSetIds) {
                            var callSets = [],
                                csIdSet = new Set();

                            self.callSetIds.forEach(function (csid) {
                                csIdSet.add(csid);
                            });

                            json.callSets.forEach(function (cs) {
                                if (csIdSet.has(cs.id)) {
                                    callSets.push(cs);
                                }
                            });
                            return callSets
                        } else {
                            return json.callSets
                        }
                    }
                })
                    .then(function (callSets) {
                        self.header.callSets = callSets;
                        return self.header
                    })
            }
        }
    };


    Ga4ghVariantReader.prototype.readFeatures = function (chr, bpStart, bpEnd) {

        const self = this;
        const genome = this.genome;

        return self.readHeader()

            .then(function (header) {
                return getChrAliasTable()
            })

            .then(function (chrAliasTable) {

                var queryChr = chrAliasTable.hasOwnProperty(chr) ? chrAliasTable[chr] : chr,
                    readURL = self.url + "/variants/search";

                return ga4ghSearch({
                    url: readURL,
                    fields: (self.includeCalls ? undefined : "nextPageToken,variants(id,variantSetId,names,referenceName,start,end,referenceBases,alternateBases,quality,filter,info)"),
                    body: {
                        "variantSetIds": (Array.isArray(self.variantSetId) ? self.variantSetId : [self.variantSetId]),
                        "callSetIds": (self.callSetIds ? self.callSetIds : undefined),
                        "referenceName": queryChr,
                        "start": bpStart.toString(),
                        "end": bpEnd.toString(),
                        "pageSize": "10000"
                    },
                    decode: function (json) {

                        var v;

                        var variants = [];

                        json.variants.forEach(function (json) {

                            v = createGAVariant(json);

                            if (!v.isRefBlock()) {
                                variants.push(v);
                            }
                        });

                        return variants
                    }
                })
            })


        function getChrAliasTable() {

            return new Promise(function (fulfill, reject) {

                if (self.chrAliasTable) {
                    fulfill(self.chrAliasTable);
                } else {
                    self.readMetadata().then(function (json) {

                        self.metadata = json.metadata;
                        self.chrAliasTable = {};

                        if (json.referenceBounds && genome) {

                            json.referenceBounds.forEach(function (rb) {
                                var refName = rb.referenceName,
                                    alias = genome.getChromosomeName(refName);
                                self.chrAliasTable[alias] = refName;

                            });
                        }
                        fulfill(self.chrAliasTable);

                    });
                }

            })
        }

    };


    Ga4ghVariantReader.prototype.readMetadata = function () {

        return ga4ghGet({
            url: this.url,
            entity: "variantsets",
            entityId: this.variantSetId
        })
    };

    class CivicReader {

        constructor(config) {
            this.config = config;
        }

        async readFeatures(chr, start, end) {

            const json = await igvxhr.loadJson(this.config.url + "/variants/?count=50000");
            const records = json.records;
            const features = [];

            for (let record of records) {

                if (record.coordinates) {

                    record.id;
                    const coordinates = record.coordinates;

                    if (coordinates.chromosome) {
                        features.push(
                            new CivicVariant(
                                coordinates.chromosome,
                                coordinates.start - 1,     // UCSC 0 convention
                                coordinates.stop,
                                record
                            ));
                    }

                    if (coordinates.chromosome2) {
                        features.push(
                            new CivicVariant(
                                coordinates.chromosome2,
                                coordinates.start2 - 1,     // UCSC 0 convention
                                coordinates.stop2,
                                record
                            ));
                    }
                }

            }
            return features

        }
    }

    class CivicVariant {

        constructor(chr, start, end, record) {
            this.chr = chr;
            this.start = start;
            this.end = end;
            this.id = record.id;
            this.entrezName = record.entrez_name;
            this.name = record.name;
            this.actionabilityScore = record.civic_actionability_score;

            if (record.coordinates.reference_bases) {
                this.refBases = record.coordinates.reference_bases;
            }
            if (record.coordinates.variant_bases) {
                this.altBases = record.coordinates.variant_bases;
            }
            if (record.variant_types) {
                this.variant_types = record.variant_types;
            }

            this.locationString = (this.chr + ":" +
                numberFormatter$1(this.start + 1) + "-" +
                numberFormatter$1(this.end));

            // Color based on actionability score
            if (this.actionabilityScore !== undefined) {
                let alpha;
                if (this.actionabilityScore <= 10) {
                    alpha = 0.2;
                } else {
                    const v = Math.min(30, this.actionabilityScore);
                    alpha = 0.2 + 0.8 * Math.log10((v - 10) / 2);
                }
                this.alpha = alpha;
            }


        }

        popupData() {


            const link = createLink("CIViC", "https://civicdb.org/links/variants/" + this.id);
            this.refBases !== this.altBases &&
                this.refBases && this.refBases.length === 1 &&
                this.altBases && this.altBases.length === 1;


            const pd = [link];
            pd.push({
                name: "Entrez",
                value: createLink(this.entrezName, "https://ghr.nlm.nih.gov/gene/" + this.entrezName)
            });
            pd.push({name: "Name", value: this.name});

            if (this.variant_types && this.variant_types.length > 0) {

                const name = this.variant_types.length === 1 ? "Type" : "Types";
                let typeString;
                for (let vt of this.variant_types) {
                    if (!typeString) typeString = vt.display_name;
                    else typeString += ", " + vt.display_name;
                }

                pd.push({name: name, value: typeString});
            }

            pd.push({name: "Actionability", value: this.actionabilityScore});


            pd.push({name: "Location", value: this.locationString});

            return pd


            function createLink(text, href) {
                return "<a target='_blank' " + "href='" + href + "'>" + text + "</a>"
            }

        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class HtsgetReader {

        constructor(config, genome) {
            this.config = config;
            this.genome = genome;
            this.format = config.format ? config.format.toUpperCase() : "BAM";    // Backward compatibility
            if (!(this.format === "BAM" || this.format === "VCF")) {
                throw  Error(`htsget format ${config.format} is not supported`)
            }
        }

        async readHeaderData() {
            const url = `${getUrl(this.config)}?class=header&format=${this.format}`;
            const ticket = await igvxhr.loadJson(url, buildOptions(this.config));
            return await this.loadUrls(ticket.htsget.urls)
        }

        async readData(chr, start, end) {
            const url = `${getUrl(this.config)}?format=${this.format}&referenceName=${chr}&start=${Math.floor(start)}&end=${Math.ceil(end)}`;
            const ticket = await igvxhr.loadJson(url, buildOptions(this.config));
            return this.loadUrls(ticket.htsget.urls)
        }

        async loadUrls(urls) {

            const promiseArray = [];
            for (let urlData of urls) {

                if (urlData.url.startsWith('data:')) {
                    // this is a data-uri
                    promiseArray.push(Promise.resolve(dataUriToBytes(urlData.url)));

                } else {

                    const options = buildOptions(this.config || {});

                    if (urlData.headers) {
                        options.headers = Object.assign(options.headers || {}, urlData.headers);
                    }

                    promiseArray.push(igvxhr.loadArrayBuffer(urlData.url, options));
                }
            }
            const arrayBuffers = await Promise.all(promiseArray);
            return concatArrays(arrayBuffers)
        }


        static async inferFormat(config) {
            try {
                const url = getUrl(config);
                const headerURL = `${url}${url.includes("?") ? "&" : "?"}class=header`;
                const ticket = await igvxhr.loadJson(headerURL, buildOptions(config));
                if (ticket.htsget) {
                    const format = ticket.htsget.format;
                    if (!(format === "BAM" || format === "VCF")) {
                        throw  Error(`htsget format ${format} is not supported`)
                    }
                    config.format = format.toLowerCase();
                    config.sourceType = "htsget";
                    if (!config.name) {
                        config.name = await getFilename$1(config.url);
                    }
                }
            } catch (e) {
                // Errors => this is not an htsget source, not an application error.  Ignore
            }
        }
    }

    /**
     * Extract the full url from the config.  Striving for backward compatibility, "endpoint" and "id" are deprecated.
     *
     * @param config
     */
    function getUrl(config) {
        if (config.url && config.endpoint && config.id) {
            return config.url + config.endpoint + config.id    // Deprecated
        } else if (config.endpoint && config.id) {
            return config.endpoint + config.id                // Deprecated
        } else if (config.url) {
            if (config.url.startsWith("htsget://")) {
                return config.url.replace("htsget://", "https://")    // htsget -> http not supported
            } else {
                return config.url
            }
        } else {
            throw Error("Must specify either 'url', or 'endpoint' and 'id")
        }


    }

    /**
     * Concatenate a list of array buffers, returning an UInt8Array
     * @param arrayBuffers
     */
    function concatArrays(arrayBuffers) {

        let len = 0;
        for (let a of arrayBuffers) {
            len += a.byteLength;
        }

        let offset = 0;
        const newArray = new Uint8Array(len);
        for (let buf of arrayBuffers) {
            const a = new Uint8Array(buf);
            newArray.set(a, offset);
            offset += a.length;
        }

        return newArray
    }

    function dataUriToBytes(dataUri) {

        const split = dataUri.split(',');
        const info = split[0].split(':')[1];
        let dataString = split[1];

        if (info.indexOf('base64') >= 0) {
            dataString = atob(dataString);
        } else {
            dataString = decodeURI(dataString);
        }

        const bytes = new Uint8Array(dataString.length);
        for (var i = 0; i < dataString.length; i++) {
            bytes[i] = dataString.charCodeAt(i);
        }

        return bytes
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class HtsgetVariantReader extends HtsgetReader {

        constructor(config, genome) {
            super(config, genome);
            this.parser = new VcfParser();
        }

        async readHeader() {
            if (!this.header) {
                const data = await this.readHeaderData();
                const dataWrapper = getDataWrapper(data);
                this.header = await this.parser.parseHeader(dataWrapper, this.genome);
                this.chrAliasTable = this.header.chrAliasTable;
            }
            return this.header
        }

        async readFeatures(chr, start, end) {

            if (this.config.format && this.config.format.toUpperCase() !== "VCF") {
                throw  Error(`htsget format ${this.config.format} is not supported`)
            }

            if (!this.chrAliasTable) {
                await this.readHeader();
            }

            let queryChr = this.chrAliasTable.has(chr) ? this.chrAliasTable.get(chr) : chr;

            const data = await this.readData(queryChr, start, end);

            const dataWrapper = getDataWrapper(data);

            return this.parser.parseFeatures(dataWrapper)

            //  return dataWrapper;

        }

    }

    // Assigns a row # to each feature.  If the feature does not fit in any row and #rows == maxRows no
    // row number is assigned.
    function pack(featureList, maxRows) {

        maxRows = maxRows || Number.MAX_SAFE_INTEGER;
        const rows = [];
        featureList.sort(function (a, b) {
            return a.start - b.start
        });
        rows.push(-1000);

        for (let feature of featureList) {
            let r = 0;
            const len = Math.min(rows.length, maxRows);
            for (r = 0; r < len; r++) {
                if (feature.start >= rows[r]) {
                    feature.row = r;
                    rows[r] = feature.end;
                    break
                }
            }
            feature.row = r;
            rows[r] = feature.end;
        }
    }

    const DEFAULT_MAX_WG_COUNT$1 = 10000;

    /**
     * Return a collection of "whole genome" features wrapping the supplied features, possibly downsampled.  The purpose
     * is to support painting features in "whole genome view".
     *
     * @param allFeatures - dictionary (object), keys are chromosome names, values are lists of features
     * @param genome
     * @param maxWGCount - optional, maximum # of whole genome features to computer
     * @returns {*[]}
     */
    function computeWGFeatures(allFeatures, genome, maxWGCount) {

        const max = maxWGCount || DEFAULT_MAX_WG_COUNT$1;

        const makeWGFeature = (f) => {
            const wg = Object.assign({}, f);
            wg.chr = "all";
            wg.start = genome.getGenomeCoordinate(f.chr, f.start);
            wg.end = genome.getGenomeCoordinate(f.chr, f.end);
            wg._f = f;
            // Don't draw exons in whole genome view
            if (wg["exons"]) delete wg["exons"];
            return wg
        };

        const wgChromosomeNames = new Set(genome.wgChromosomeNames);
        const wgFeatures = [];
        let count = 0;
        for (let c of genome.wgChromosomeNames) {

            if(Array.isArray(allFeatures)) {
                const featureDict = {};
                for(let f of allFeatures) {
                    const chr = genome.getChromosomeName(f.chr);
                    if(!featureDict.hasOwnProperty(chr)) {
                        featureDict[chr] = [];
                    }
                    featureDict[chr].push(f);
                }
                allFeatures = featureDict;
            }

            const features = allFeatures[c];

            if (features) {
                for (let f of features) {
                    let queryChr = genome.getChromosomeName(f.chr);
                    if (wgChromosomeNames.has(queryChr)) {
                        if (wgFeatures.length < max) {
                            wgFeatures.push(makeWGFeature(f));
                        } else {
                            //Reservoir sampling
                            const samplingProb = max / (count + 1);
                            if (Math.random() < samplingProb) {
                                const idx = Math.floor(Math.random() * (max - 1));
                                wgFeatures[idx] = makeWGFeature(f);
                            }
                        }
                    }
                    count++;
                }
            }
        }

        wgFeatures.sort(function (a, b) {
            return a.start - b.start
        });

        return wgFeatures
    }

    function packFeatures(features, maxRows) {

        maxRows = maxRows || 1000;
        if (features == null || features.length === 0) {
            return
        }
        // Segregate by chromosome
        const chrFeatureMap = {};
        const chrs = [];
        for (let feature of features) {
            const chr = feature.chr;
            let flist = chrFeatureMap[chr];
            if (!flist) {
                flist = [];
                chrFeatureMap[chr] = flist;
                chrs.push(chr);
            }
            flist.push(feature);
        }

        // Loop through chrosomosomes and pack features;
        for (let chr of chrs) {
            pack(chrFeatureMap[chr], maxRows);
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014-2015 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const DEFAULT_MAX_WG_COUNT = 10000;

    /**
     * feature source for "bed like" files (tab or whitespace delimited files with 1 feature per line: bed, gff, vcf, etc)
     *
     * @param config
     * @constructor
     */
    class TextFeatureSource {

        constructor(config, genome) {

            this.config = config || {};
            this.genome = genome;
            this.sourceType = (config.sourceType === undefined ? "file" : config.sourceType);
            this.maxWGCount = config.maxWGCount || DEFAULT_MAX_WG_COUNT;

            const queryableFormats = new Set(["bigwig", "bw", "bigbed", "bb", "biginteract", "biggenepred", "bignarrowpeak", "tdf"]);

            this.queryable = config.indexURL || config.queryable === true;   // False by default, unless explicitly set
            if (config.reader) {
                // Explicit reader implementation
                this.reader = config.reader;
                this.queryable = config.queryable !== false;
            } else if (config.sourceType === "ga4gh") {
                this.reader = new Ga4ghVariantReader(config, genome);
                this.queryable = true;
            } else if (config.sourceType === "immvar") {
                this.reader = new ImmVarReader(config);
                this.queryable = true;
            } else if (config.type === "eqtl" && config.sourceType === "gtex-ws") {
                this.reader = new GtexReader(config);
                this.queryable = true;
            } else if ("htsget" === config.sourceType) {
                this.reader = new HtsgetVariantReader(config, genome);
                this.queryable = true;
            } else if (config.sourceType === 'ucscservice') {
                this.reader = new UCSCServiceReader(config.source);
                this.queryable = true;
            } else if (config.sourceType === 'custom') {
                this.reader = new CustomServiceReader(config.source);
                this.queryable = false !== config.source.queryable;
            } else if ("civic-ws" === config.sourceType) {
                this.reader = new CivicReader(config);
                this.queryable = false;
            } else {
                // File of some type (i.e. not a webservice)
                this.reader = new FeatureFileReader(config, genome);
                if (config.queryable !== undefined) {
                    this.queryable = config.queryable;
                } else if (queryableFormats.has(config.format) || this.reader.indexed) {
                    this.queryable = true;
                } else ;
            }

            // Set  searchable unless explicitly turned off, or track uses in indexed or otherwise queryable
            // feature source.  queryable => features loaded on demand (by query)
            this.searchable = config.searchable === true || config.searchableFields || (config.searchable !== false && !this.queryable);

        }

        async defaultVisibilityWindow() {
            if (this.reader && typeof this.reader.defaultVisibilityWindow === 'function') {
                return this.reader.defaultVisibilityWindow()
            }
        }

        async trackType() {
            const header = await this.getHeader();
            if (header) {
                return header.type
            } else {
                return undefined    // Convention for unknown or unspecified
            }
        }

        async getHeader() {
            if (!this.header) {

                if (this.reader && typeof this.reader.readHeader === "function") {
                    const header = await this.reader.readHeader();
                    if (header) {
                        this.header = header;
                        if (header.format) {
                            this.config.format = header.format;
                        }
                    } else {
                        this.header = {};
                    }
                } else {
                    this.header = {};
                }
            }
            return this.header
        }

        /**
         * Required function for all data source objects.  Fetches features for the
         * range requested.
         *
         * This function is quite complex due to the variety of reader types backing it, some indexed, some queryable,
         * some not.
         *
         * @param chr
         * @param start
         * @param end
         * @param bpPerPixel
         */
        async getFeatures({chr, start, end, bpPerPixel, visibilityWindow}) {

            const genome = this.genome;
            const queryChr = genome ? genome.getChromosomeName(chr) : chr;
            const isWholeGenome = ("all" === queryChr.toLowerCase());

            // Various conditions that can require a feature load
            //   * view is "whole genome" but no features are loaded
            //   * cache is disabled
            //   * cache does not contain requested range
           // const containsRange = this.featureCache.containsRange(new GenomicInterval(queryChr, start, end))
            if ((isWholeGenome && !this.wgFeatures && this.supportsWholeGenome()) ||
                this.config.disableCache ||
                !this.featureCache ||
                !this.featureCache.containsRange(new GenomicInterval(queryChr, start, end))) {
                await this.loadFeatures(queryChr, start, end, visibilityWindow);
            }

            if (isWholeGenome) {
                if (!this.wgFeatures) {
                    if (this.supportsWholeGenome()) {
                        this.wgFeatures = computeWGFeatures(this.featureCache.getAllFeatures(), this.genome, this.maxWGCount);
                    } else {
                        this.wgFeatures = [];
                    }
                }
                return this.wgFeatures
            } else {
                return this.featureCache.queryFeatures(queryChr, start, end)
            }
        }

        supportsWholeGenome() {
            return !this.queryable   // queryable (indexed, web services) sources don't support whole genome view
        }

        // TODO -- experimental, will only work for non-indexed sources
        getAllFeatures() {
            if (this.queryable || !this.featureCache) {   // queryable sources don't support all features
                return []
            } else {
                return this.featureCache.getAllFeatures()
            }
        }


        async loadFeatures(queryChr, start, end, visibilityWindow) {

            const reader = this.reader;
            let intervalStart = start;
            let intervalEnd = end;

            // Use visibility window to potentially expand query interval.
            // This can save re-queries as we zoom out.  Visibility window <= 0 is a special case
            // indicating whole chromosome should be read at once.
            if ((!visibilityWindow || visibilityWindow <= 0) && this.config.expandQuery !== false) {
                // Whole chromosome
                const chromosome = this.genome ? this.genome.getChromosome(queryChr) : undefined;
                intervalStart = 0;
                intervalEnd = Math.max(chromosome ? chromosome.bpLength : Number.MAX_SAFE_INTEGER, end);
            } else if (visibilityWindow > (end - start) && this.config.expandQuery !== false) {
                const expansionWindow = Math.min(4.1 * (end - start), visibilityWindow);
                intervalStart = Math.max(0, (start + end) / 2 - expansionWindow);
                intervalEnd = start + expansionWindow;
            }

            let features = await reader.readFeatures(queryChr, intervalStart, intervalEnd);
            if (this.queryable === undefined) {
                this.queryable = reader.indexed;
            }

            const genomicInterval = this.queryable ?
                new GenomicInterval(queryChr, intervalStart, intervalEnd) :
                undefined;

            if (features) {

                if (this.config.assembleGFF !== false &&
                    ("gtf" === this.config.format || "gff3" === this.config.format || "gff" === this.config.format)) {
                    features = (new GFFHelper(this.config)).combineFeatures(features, genomicInterval);
                }

                // Assign overlapping features to rows
                if (this.config.format !== "wig" && this.config.type !== "junctions") {
                    const maxRows = this.config.maxRows || Number.MAX_SAFE_INTEGER;
                    packFeatures(features, maxRows);
                }

                // Note - replacing previous cache with new one.  genomicInterval is optional (might be undefined => includes all features)
                this.featureCache = new FeatureCache$1(features, this.genome, genomicInterval);

                // If track is marked "searchable"< cache features by name -- use this with caution, memory intensive
                if (this.searchable) {
                    this.genome.addFeaturesToDB(features, this.config);
                }
            } else {
                this.featureCache = new FeatureCache$1([], genomicInterval);     // Empty cache
            }
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class BufferedReader {

        constructor(config, contentLength, bufferSize) {
            this.path = config.url;
            this.bufferSize = bufferSize ? bufferSize : 512000;
            this.range = {start: -1, size: -1};
            this.config = config;
        }

        /**
         *
         * @param requestedRange - byte rangeas {start, size}
         * @param fulfill - function to receive result
         * @param asUint8 - optional flag to return result as an UInt8Array
         */
        async dataViewForRange(requestedRange, asUint8, retries = 0) {
            try {

                const hasData = (this.data && (this.range.start <= requestedRange.start) &&
                    ((this.range.start + this.range.size) >= (requestedRange.start + requestedRange.size)));

                if (!hasData) {
                    let bufferSize;
                    // If requested range size is specified, potentially expand buffer size
                    if (requestedRange.size) {
                        bufferSize = Math.max(this.bufferSize, requestedRange.size);
                    } else {
                        bufferSize = this.bufferSize;
                    }
                    if (this.contentLength) {
                        bufferSize = Math.min(bufferSize, this.contentLength - requestedRange.start);
                    }
                    const loadRange = {start: requestedRange.start, size: bufferSize};
                    const arrayBuffer = await igvxhr.loadArrayBuffer(this.path, buildOptions(this.config, {range: loadRange}));
                    this.data = arrayBuffer;
                    this.range = loadRange;
                }

                const len = this.data.byteLength;
                const bufferStart = requestedRange.start - this.range.start;
                return asUint8 ?
                    new Uint8Array(this.data, bufferStart, len - bufferStart) :
                    new DataView(this.data, bufferStart, len - bufferStart)
            } catch (e) {
                if (retries === 0 && e.message && e.message.startsWith("416")) {
                    try {
                        this.contentLength = await igvxhr.getContentLength(this.path, buildOptions(this.config));
                        return this.dataViewForRange(requestedRange, asUint8, ++retries)
                    } catch (e1) {
                        console.error(e1);
                    }
                    throw e
                }
            }
        }
    }

    function getDecoder(definedFieldCount, fieldCount, autoSql, format) {

        if ("biginteract" === format || (autoSql && ('chromatinInteract' === autoSql.table) || 'interact' === autoSql.table)) {
            return decodeInteract
        } else {
            const standardFieldCount = definedFieldCount - 3;
            return function (feature, tokens) {

                if (standardFieldCount > 0) {
                    feature.name = tokens[0];
                }
                if (standardFieldCount > 1) {
                    feature.score = Number(tokens[1]);
                }
                if (standardFieldCount > 2) {
                    feature.strand = tokens[2];
                }
                if (standardFieldCount > 3) {
                    feature.cdStart = parseInt(tokens[3]);
                }
                if (standardFieldCount > 4) {
                    feature.cdEnd = parseInt(tokens[4]);
                }
                if (standardFieldCount > 5) {
                    if (tokens[5] !== "." && tokens[5] !== "0" && tokens[5] !== "-1") {
                        const c = IGVColor.createColorString(tokens[5]);
                        feature.color = c.startsWith("rgb") ? c : undefined;
                    }
                }
                if (standardFieldCount > 8) {
                    const exonCount = parseInt(tokens[6]);
                    const exonSizes = tokens[7].split(',');
                    const exonStarts = tokens[8].split(',');
                    const exons = [];
                    for (let i = 0; i < exonCount; i++) {
                        const eStart = feature.start + parseInt(exonStarts[i]);
                        const eEnd = eStart + parseInt(exonSizes[i]);
                        exons.push({start: eStart, end: eEnd});
                    }
                    findUTRs(exons, feature.cdStart, feature.cdEnd);
                    feature.exons = exons;
                }

                if (autoSql) {
                    // TODO -- these should be equal, validate?  fieldCount-definedFieldCount, as.fields.length, tokens.length-3
                    const extraStart = definedFieldCount;
                    for (let i = extraStart; i < fieldCount; i++) {
                        if (i < autoSql.fields.length) {
                            const name = autoSql.fields[i].name;
                            const value = tokens[i - 3];
                            feature[name] = value;
                        }
                    }
                }
            }
        }

        //table chromatinInteract
    // "Chromatin interaction between two regions"
    //     (
    //     string chrom;      "Chromosome (or contig, scaffold, etc.). For interchromosomal, use 2 records"
    //     uint chromStart;   "Start position of lower region. For interchromosomal, set to chromStart of this region"
    //     uint chromEnd;     "End position of upper region. For interchromosomal, set to chromEnd of this region"
    //     string name;       "Name of item, for display"
    //     uint score;        "Score from 0-1000"
    //     double value;      "Strength of interaction or other data value. Typically basis for score"
    //     string exp;        "Experiment name (metadata for filtering). Use . if not applicable"
    //     string color;      "Item color.  Specified as r,g,b or hexadecimal #RRGGBB or html color name, as in //www.w3.org/TR/css3-color/#html4."
    //     string region1Chrom;  "Chromosome of lower region. For non-directional interchromosomal, chrom of this region."
    //     uint region1Start;  "Start position of lower/this region"
    //     uint region1End;    "End position in chromosome of lower/this region"
    //     string region1Name;  "Identifier of lower/this region"
    //     string region1Strand; "Orientation of lower/this region: + or -.  Use . if not applicable"
    //     string region2Chrom; "Chromosome of upper region. For non-directional interchromosomal, chrom of other region"
    //     uint region2Start;  "Start position in chromosome of upper/this region"
    //     uint region2End;    "End position in chromosome of upper/this region"
    //     string region2Name; "Identifier of upper/this region"
    //     string region2Strand; "Orientation of upper/this region: + or -.  Use . if not applicable"
    //     )
        function decodeInteract(feature, tokens) {

            feature.chr1 = tokens[5];
            feature.start1 = Number.parseInt(tokens[6]);
            feature.end1 = Number.parseInt(tokens[7]);

            feature.chr2 = tokens[10];
            feature.start2 = Number.parseInt(tokens[11]);
            feature.end2 = Number.parseInt(tokens[12]);

            feature.name = tokens[0];
            feature.score = Number(tokens[1]);
            feature.value = Number(tokens[2]);
            feature.color = tokens[4] === '.' ? undefined : tokens[4] === "0" ? "rgb(0,0,0)" : tokens[4];

            return feature
        }
    }

    function findUTRs(exons, cdStart, cdEnd) {

        for (let exon of exons) {
            const end = exon.end;
            const start = exon.start;
            if (end < cdStart || start > cdEnd) {
                exon.utr = true;
            } else {
                if (cdStart >= start && cdStart <= end) {
                    exon.cdStart = cdStart;
                }
                if (cdEnd >= start && cdEnd <= end) {
                    exon.cdEnd = cdEnd;
                }
            }
        }
    }

    function scoreShade(score, color) {
        const alpha = Math.min(1, 0.11 + 0.89 * (score / 779));
        return alpha.toString()
    }

    function parseAutoSQL(str) {

        let table;
        const fields = [];
        let startDecoding = false;
        const lines = str.trim().split(/\s*[\r\n]+\s*/g);
        for (let line of lines) {
            if (line.startsWith('table')) {
                table = line.split(/\s+/)[1].trim();
            } else if (line.startsWith('(')) {
                startDecoding = true;
            } else if (line.startsWith(')')) ; else if (startDecoding) {
                if (line.length > 0) {
                    const idx = line.indexOf(';');
                    const tokens = line.substr(0, idx).split(/\s+/);
                    const description = line.substr(idx + 1).replace(/"/g, '').trim();
                    fields.push({
                        type: tokens[0],
                        name: tokens[1],
                        description: description
                    });
                }
            }
        }
        return {
            table: table,
            fields: fields
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    let BIGWIG_MAGIC_LTH = 0x888FFC26; // BigWig Magic Low to High
    let BIGWIG_MAGIC_HTL = 0x26FC8F66; // BigWig Magic High to Low
    let BIGBED_MAGIC_LTH = 0x8789F2EB; // BigBed Magic Low to High
    let BIGBED_MAGIC_HTL = 0xEBF28987; // BigBed Magic High to Low
    let BBFILE_HEADER_SIZE = 64;
    let RPTREE_HEADER_SIZE = 48;
    let RPTREE_NODE_LEAF_ITEM_SIZE = 32;   // leaf item size
    let RPTREE_NODE_CHILD_ITEM_SIZE = 24;  // child item size
    let BUFFER_SIZE = 512000;     //  buffer

    class BWReader {

        constructor(config, genome) {
            this.path = config.url;
            this.format = config.format || "bigwig";
            this.genome = genome;
            this.rpTreeCache = {};
            this.config = config;
            this.loader = isDataURL(this.path) ? new DataBuffer(this.path) : igvxhr;
        }

        async readWGFeatures(bpPerPixel, windowFunction) {
            await this.loadHeader();
            const chrIdx1 = 0;
            const chrIdx2 = this.chromTree.idToChrom.length - 1;
            const chr1 = this.chromTree.idToChrom[chrIdx1];
            const chr2 = this.chromTree.idToChrom[chrIdx2];
            return this.readFeatures(chr1, 0, chr2, Number.MAX_VALUE, bpPerPixel, windowFunction)
        }

        async readFeatures(chr1, bpStart, chr2, bpEnd, bpPerPixel, windowFunction) {

            await this.loadHeader();
            const chrIdx1 = this.chromTree.chromToID[chr1];
            const chrIdx2 = this.chromTree.chromToID[chr2];
            if (chrIdx1 === undefined || chrIdx2 === undefined) {
                return []
            }

            let treeOffset;
            let decodeFunction;
            if (this.type === "bigwig") {
                // Select a biwig "zoom level" appropriate for the current resolution.
                const zoomLevelHeaders = await this.getZoomHeaders();
                let zoomLevelHeader = bpPerPixel ? zoomLevelForScale$1(bpPerPixel, zoomLevelHeaders) : undefined;
                if (zoomLevelHeader) {
                    treeOffset = zoomLevelHeader.indexOffset;
                    decodeFunction = decodeZoomData;
                } else {
                    treeOffset = this.header.fullIndexOffset;
                    decodeFunction = decodeWigData;
                }
            } else {
                // bigbed, zoom data is not currently used in igv for bed type features
                treeOffset = this.header.fullIndexOffset;
                decodeFunction = getBedDataDecoder.call(this);
            }


            // Load the R Tree and fine leaf items
            const rpTree = await this.loadRPTree(treeOffset);
            const leafItems = await rpTree.findLeafItemsOverlapping(chrIdx1, bpStart, chrIdx2, bpEnd);
            if (!leafItems || leafItems.length === 0) {
                return []
            } else {

                // Consolidate leaf items and get all data at once
                let start = Number.MAX_VALUE;
                let end = 0;
                for (let item of leafItems) {
                    start = Math.min(start, item.dataOffset);
                    end = Math.max(end, item.dataOffset + item.dataSize);
                }
                const size = end - start;
                const arrayBuffer = await this.loader.loadArrayBuffer(this.config.url, buildOptions(this.config, {
                    range: {
                        start: start,
                        size: size
                    }
                }));

                // Parse data and return features
                const allFeatures = [];
                for (let item of leafItems) {
                    const uint8Array = new Uint8Array(arrayBuffer, item.dataOffset - start, item.dataSize);
                    let plain;
                    const isCompressed = this.header.uncompressBuffSize > 0;
                    if (isCompressed) {
                        plain = inflate_1$3(uint8Array);
                    } else {
                        plain = uint8Array;
                    }
                    decodeFunction.call(this, new DataView(plain.buffer), chrIdx1, bpStart, chrIdx2, bpEnd, allFeatures, this.chromTree.idToChrom, windowFunction);
                }

                allFeatures.sort(function (a, b) {
                    return a.start - b.start
                });

                return allFeatures
            }
        }

        async getZoomHeaders() {
            if (this.zoomLevelHeaders) {
                return this.zoomLevelHeaders
            } else {
                await this.loadHeader();
                return this.zoomLevelHeaders
            }
        }

        async loadHeader() {

            if (this.header) {
                return this.header
            } else {
                let data = await this.loader.loadArrayBuffer(this.path, buildOptions(this.config, {
                    range: {
                        start: 0,
                        size: BBFILE_HEADER_SIZE
                    }
                }));

                let header;

                // Assume low-to-high unless proven otherwise
                this.littleEndian = true;

                let binaryParser = new BinaryParser(new DataView(data));
                let magic = binaryParser.getUInt();
                if (magic === BIGWIG_MAGIC_LTH) {
                    this.type = "bigwig";
                } else if (magic === BIGBED_MAGIC_LTH) {
                    this.type = "bigbed";
                } else {
                    //Try big endian order
                    this.littleEndian = false;

                    binaryParser.littleEndian = false;
                    binaryParser.position = 0;
                    let magic = binaryParser.getUInt();

                    if (magic === BIGWIG_MAGIC_HTL) {
                        this.type = "bigwig";
                    } else if (magic === BIGBED_MAGIC_HTL) {
                        this.type = "bigbed";
                    } else ;
                }
                // Table 5  "Common header for bigwig and bigbed files"
                header = {
                    bwVersion: binaryParser.getUShort(),
                    nZoomLevels: binaryParser.getUShort(),
                    chromTreeOffset: binaryParser.getLong(),
                    fullDataOffset: binaryParser.getLong(),
                    fullIndexOffset: binaryParser.getLong(),
                    fieldCount: binaryParser.getUShort(),
                    definedFieldCount: binaryParser.getUShort(),
                    autoSqlOffset: binaryParser.getLong(),
                    totalSummaryOffset: binaryParser.getLong(),
                    uncompressBuffSize: binaryParser.getInt(),
                    extensionOffset: binaryParser.getLong()
                };

                ///////////

                const startOffset = BBFILE_HEADER_SIZE;
                let range = {start: startOffset, size: (header.fullDataOffset - startOffset + 5)};
                data = await this.loader.loadArrayBuffer(this.path, buildOptions(this.config, {range: range}));

                const nZooms = header.nZoomLevels;
                binaryParser = new BinaryParser(new DataView(data));

                this.zoomLevelHeaders = [];
                this.firstZoomDataOffset = Number.MAX_SAFE_INTEGER;
                for (let i = 1; i <= nZooms; i++) {
                    const zoomNumber = nZooms - i;
                    const zlh = new ZoomLevelHeader(zoomNumber, binaryParser);
                    this.firstZoomDataOffset = Math.min(zlh.dataOffset, this.firstZoomDataOffset);
                    this.zoomLevelHeaders[zoomNumber] = zlh;
                }

                // Autosql
                if (header.autoSqlOffset > 0) {
                    binaryParser.position = header.autoSqlOffset - startOffset;
                    const autoSqlString = binaryParser.getString();
                    if (autoSqlString) {
                        this.autoSql = parseAutoSQL(autoSqlString);
                    }
                }

                // Total summary
                if (header.totalSummaryOffset > 0) {
                    binaryParser.position = header.totalSummaryOffset - startOffset;
                    this.totalSummary = new BWTotalSummary(binaryParser);
                }

                // Chrom data index
                if (header.chromTreeOffset > 0) {
                    binaryParser.position = header.chromTreeOffset - startOffset;
                    this.chromTree = new BPTree(binaryParser, startOffset, this.genome);
                } else {
                    // TODO -- this is an error, not expected
                    throw "BigWig chromosome tree offset <= 0"
                }

                //Finally total data count
                binaryParser.position = header.fullDataOffset - startOffset;
                header.dataCount = binaryParser.getInt();
                ///////////

                this.setDefaultVisibilityWindow(header);

                this.header = header;
                return this.header

            }
        }

        async loadRPTree(offset) {

            let rpTree = this.rpTreeCache[offset];
            if (rpTree) {
                return rpTree
            } else {
                rpTree = new RPTree(offset, this.config, this.littleEndian, this.loader);
                await rpTree.load();
                this.rpTreeCache[offset] = rpTree;
                return rpTree
            }
        }

        async getType() {
            await this.loadHeader();
            return this.type
        }

        async getTrackType() {
            await this.loadHeader();
            if (this.type === "bigwig") {
                return "wig"
            } else {
                return this.autoSql && this.autoSql.table === "chromatinInteract" ? "interact" : "annotation"
            }
        }

        setDefaultVisibilityWindow(header) {
            if (this.type === "bigwig") {
                this.visibilityWindow = -1;
            } else {
                // bigbed
                let genomeSize = this.genome ? this.genome.getGenomeLength() : 3088286401;
                // Estimate window size to return ~ 1,000 features, assuming even distribution across the genome
                this.visibilityWindow = header.dataCount < 1000 ? -1 : 1000 * (genomeSize / header.dataCount);

            }
        }
    }


    class ZoomLevelHeader {
        constructor(index, byteBuffer) {
            this.index = index;
            this.reductionLevel = byteBuffer.getInt();
            this.reserved = byteBuffer.getInt();
            this.dataOffset = byteBuffer.getLong();
            this.indexOffset = byteBuffer.getLong();
        }
    }

    class RPTree {

        constructor(fileOffset, config, littleEndian, loader) {

            this.config = config;
            this.loader = loader;
            this.fileOffset = fileOffset; // File offset to beginning of tree
            this.path = config.url;
            this.littleEndian = littleEndian;
        }

        async load() {
            const rootNodeOffset = this.fileOffset + RPTREE_HEADER_SIZE;
            const bufferedReader = isDataURL(this.path) ?
                this.loader :
                new BufferedReader(this.config, BUFFER_SIZE);
            this.rootNode = await this.readNode(rootNodeOffset, bufferedReader);
            return this
        }

        async readNode(filePosition, bufferedReader) {

            let dataView = await bufferedReader.dataViewForRange({start: filePosition, size: 4}, false);
            let binaryParser = new BinaryParser(dataView, this.littleEndian);
            const type = binaryParser.getByte();
            const isLeaf = (type === 1);
            binaryParser.getByte();
            const count = binaryParser.getUShort();
            filePosition += 4;

            let bytesRequired = count * (isLeaf ? RPTREE_NODE_LEAF_ITEM_SIZE : RPTREE_NODE_CHILD_ITEM_SIZE);
            let range2 = {start: filePosition, size: bytesRequired};
            dataView = await bufferedReader.dataViewForRange(range2, false);
            const items = new Array(count);
            binaryParser = new BinaryParser(dataView);

            if (isLeaf) {
                for (let i = 0; i < count; i++) {
                    let item = {
                        isLeaf: true,
                        startChrom: binaryParser.getInt(),
                        startBase: binaryParser.getInt(),
                        endChrom: binaryParser.getInt(),
                        endBase: binaryParser.getInt(),
                        dataOffset: binaryParser.getLong(),
                        dataSize: binaryParser.getLong()
                    };
                    items[i] = item;

                }
                return new RPTreeNode(items)
            } else { // non-leaf
                for (let i = 0; i < count; i++) {

                    let item = {
                        isLeaf: false,
                        startChrom: binaryParser.getInt(),
                        startBase: binaryParser.getInt(),
                        endChrom: binaryParser.getInt(),
                        endBase: binaryParser.getInt(),
                        childOffset: binaryParser.getLong()
                    };
                    items[i] = item;
                }

                return new RPTreeNode(items)
            }

        }

        async findLeafItemsOverlapping(chrIdx1, startBase, chrIdx2, endBase) {

            let self = this;

            return new Promise(function (fulfill, reject) {

                let leafItems = [],
                    processing = new Set(),
                    bufferedReader = isDataURL(self.path) ?
                        self.loader :
                        new BufferedReader(self.config, BUFFER_SIZE);

                processing.add(0);  // Zero represents the root node
                findLeafItems(self.rootNode, 0);

                function findLeafItems(node, nodeId) {

                    if (overlaps(node, chrIdx1, startBase, chrIdx2, endBase)) {

                        let items = node.items;

                        items.forEach(function (item) {

                            if (overlaps(item, chrIdx1, startBase, chrIdx2, endBase)) {

                                if (item.isLeaf) {
                                    leafItems.push(item);
                                } else {
                                    if (item.childNode) {
                                        findLeafItems(item.childNode);
                                    } else {
                                        processing.add(item.childOffset);  // Represent node to-be-loaded by its file position

                                        self.readNode(item.childOffset, bufferedReader)
                                            .then(function (node) {
                                                item.childNode = node;
                                                findLeafItems(node, item.childOffset);
                                            })
                                            .catch(reject);
                                    }
                                }
                            }
                        });

                    }

                    if (nodeId !== undefined) processing.delete(nodeId);

                    // Wait until all nodes are processed
                    if (processing.size === 0) {
                        fulfill(leafItems);
                    }
                }
            })
        }
    }

    class RPTreeNode {

        constructor(items) {

            this.items = items;

            let minChromId = Number.MAX_SAFE_INTEGER,
                maxChromId = 0,
                minStartBase = Number.MAX_SAFE_INTEGER,
                maxEndBase = 0,
                i,
                item;

            for (i = 0; i < items.length; i++) {
                item = items[i];
                minChromId = Math.min(minChromId, item.startChrom);
                maxChromId = Math.max(maxChromId, item.endChrom);
                minStartBase = Math.min(minStartBase, item.startBase);
                maxEndBase = Math.max(maxEndBase, item.endBase);
            }

            this.startChrom = minChromId;
            this.endChrom = maxChromId;
            this.startBase = minStartBase;
            this.endBase = maxEndBase;
        }
    }

    class BPTree {

        constructor(binaryParser, startOffset, genome) {

            let magic = binaryParser.getInt();
            let blockSize = binaryParser.getInt();
            let keySize = binaryParser.getInt();
            let valSize = binaryParser.getInt();
            let itemCount = binaryParser.getLong();
            let reserved = binaryParser.getLong();
            let chromToId = {};
            let idToChrom = [];

            this.header = {
                magic: magic,
                blockSize: blockSize,
                keySize: keySize,
                valSize: valSize,
                itemCount: itemCount,
                reserved: reserved
            };
            this.chromToID = chromToId;
            this.idToChrom = idToChrom;

            // Recursively walk tree to populate dictionary
            readTreeNode(binaryParser, -1);


            function readTreeNode(byteBuffer, offset) {

                if (offset >= 0) byteBuffer.position = offset;

                let type = byteBuffer.getByte();
                    byteBuffer.getByte();
                    let count = byteBuffer.getUShort(),
                    i,
                    key,
                    chromId,
                    childOffset,
                    bufferOffset,
                    currOffset;


                if (type === 1) {

                    for (i = 0; i < count; i++) {

                        key = byteBuffer.getFixedLengthTrimmedString(keySize);
                        chromId = byteBuffer.getInt();
                        byteBuffer.getInt();

                        if (genome) key = genome.getChromosomeName(key);  // Translate to canonical chr name
                        chromToId[key] = chromId;
                        idToChrom[chromId] = key;

                    }
                } else { // non-leaf

                    for (i = 0; i < count; i++) {

                        key = byteBuffer.getFixedLengthTrimmedString(keySize);
                        childOffset = byteBuffer.getLong();
                        bufferOffset = childOffset - startOffset;
                        currOffset = byteBuffer.position;
                        readTreeNode(byteBuffer, bufferOffset);
                        byteBuffer.position = currOffset;
                    }
                }

            }
        }
    }

    /**
     * Return true if {chrIdx1:startBase-chrIdx2:endBase} overlaps item's interval
     * @returns {boolean}
     */
    function overlaps(item, chrIdx1, startBase, chrIdx2, endBase) {

        if (!item) {
            console.log("null item for " + chrIdx1 + " " + startBase + " " + endBase);
            return false
        }

        return ((chrIdx2 > item.startChrom) || (chrIdx2 === item.startChrom && endBase >= item.startBase)) &&
            ((chrIdx1 < item.endChrom) || (chrIdx1 === item.endChrom && startBase <= item.endBase))


    }

    class BWTotalSummary {

        constructor(byteBuffer) {
            if (byteBuffer) {
                this.basesCovered = byteBuffer.getLong();
                this.minVal = byteBuffer.getDouble();
                this.maxVal = byteBuffer.getDouble();
                this.sumData = byteBuffer.getDouble();
                this.sumSquares = byteBuffer.getDouble();
                computeStats.call(this);
            } else {
                this.basesCovered = 0;
                this.minVal = 0;
                this.maxVal = 0;
                this.sumData = 0;
                this.sumSquares = 0;
                this.mean = 0;
                this.stddev = 0;
            }
        }
    }

    function computeStats() {
        let n = this.basesCovered;
        if (n > 0) {
            this.mean = this.sumData / n;
            this.stddev = Math.sqrt(this.sumSquares / (n - 1));

            let min = this.minVal < 0 ? this.mean - 2 * this.stddev : 0,
                max = this.maxVal > 0 ? this.mean + 2 * this.stddev : 0;

            this.defaultRange = {
                min: min,
                max: max
            };
        }
    }

    function zoomLevelForScale$1(bpPerPixel, zoomLevelHeaders) {
        let level;
        for (let i = 0; i < zoomLevelHeaders.length; i++) {
            const zl = zoomLevelHeaders[i];
            if (zl.reductionLevel < bpPerPixel) {
                level = zl;
                break
            }
        }
        return level
    }


    function decodeWigData(data, chrIdx1, bpStart, chrIdx2, bpEnd, featureArray, chrDict) {

        const binaryParser = new BinaryParser(data);
        const chromId = binaryParser.getInt();
        const blockStart = binaryParser.getInt();
        let chromStart = blockStart;
        let chromEnd = binaryParser.getInt();
        const itemStep = binaryParser.getInt();
        const itemSpan = binaryParser.getInt();
        const type = binaryParser.getByte();
        binaryParser.getByte();
        let itemCount = binaryParser.getUShort();

        if (chromId >= chrIdx1 && chromId <= chrIdx2) {

            let idx = 0;
            while (itemCount-- > 0) {
                let value;
                switch (type) {
                    case 1:
                        chromStart = binaryParser.getInt();
                        chromEnd = binaryParser.getInt();
                        value = binaryParser.getFloat();
                        break
                    case 2:
                        chromStart = binaryParser.getInt();
                        value = binaryParser.getFloat();
                        chromEnd = chromStart + itemSpan;
                        break
                    case 3:  // Fixed step
                        value = binaryParser.getFloat();
                        chromStart = blockStart + idx * itemStep;
                        chromEnd = chromStart + itemSpan;
                        idx++;
                        break
                }

                if (chromId < chrIdx1 || (chromId === chrIdx1 && chromEnd < bpStart)) continue
                else if (chromId > chrIdx2 || (chromId === chrIdx2 && chromStart >= bpEnd)) break

                if (Number.isFinite(value)) {
                    const chr = chrDict[chromId];
                    featureArray.push({chr: chr, start: chromStart, end: chromEnd, value: value});
                }

            }
        }
    }

    function getBedDataDecoder() {

        const minSize = 3 * 4 + 1;   // Minimum # of bytes required for a bed record
        const decoder = getDecoder(this.header.definedFieldCount, this.header.fieldCount, this.autoSql, this.format);
        return function (data, chrIdx1, bpStart, chrIdx2, bpEnd, featureArray, chrDict) {
            const binaryParser = new BinaryParser(data);
            while (binaryParser.remLength() >= minSize) {

                const chromId = binaryParser.getInt();
                const chr = chrDict[chromId];
                const chromStart = binaryParser.getInt();
                const chromEnd = binaryParser.getInt();
                const rest = binaryParser.getString();
                if (chromId < chrIdx1 || (chromId === chrIdx1 && chromEnd < bpStart)) continue
                else if (chromId > chrIdx2 || (chromId === chrIdx2 && chromStart >= bpEnd)) break

                if (chromEnd > 0) {
                    const feature = {chr: chr, start: chromStart, end: chromEnd};
                    featureArray.push(feature);
                    const tokens = rest.split("\t");
                    decoder(feature, tokens);
                }
            }
        }
    }


    function decodeZoomData(data, chrIdx1, bpStart, chrIdx2, bpEnd, featureArray, chrDict, windowFunction) {

        const binaryParser = new BinaryParser(data);
        const minSize = 8 * 4;  // Minimum # of bytes required for a zoom record


        while (binaryParser.remLength() >= minSize) {
            const chromId = binaryParser.getInt();
            const chr = chrDict[chromId];
            const chromStart = binaryParser.getInt();
            const chromEnd = binaryParser.getInt();
            const validCount = binaryParser.getInt();
            const minVal = binaryParser.getFloat();
            const maxVal = binaryParser.getFloat();
            const sumData = binaryParser.getFloat();
            binaryParser.getFloat();
            let value;
            switch (windowFunction) {
                case "min":
                    value = minVal;
                    break
                case "max":
                    value = maxVal;
                    break
                default:
                    value = validCount === 0 ? 0 : sumData / validCount;
            }

            if (chromId < chrIdx1 || (chromId === chrIdx1 && chromEnd < bpStart)) continue
            else if (chromId > chrIdx2 || (chromId === chrIdx2 && chromStart >= bpEnd)) break


            if (Number.isFinite(value)) {
                featureArray.push({chr: chr, start: chromStart, end: chromEnd, value: value});


            }
        }
    }

    class DataBuffer {

        constructor(dataURI) {
            this.data = decodeDataURI$1(dataURI).buffer;
        }

        /**
         * igvxhr interface
         * @param ignore
         * @param options
         * @returns {any}
         */
        loadArrayBuffer(ignore, options) {
            const range = options.range;
            return range ? this.data.slice(range.start, range.start + range.size) : this.data
        }

        /**
         * BufferedReader interface
         *
         * @param requestedRange - byte rangeas {start, size}
         * @param fulfill - function to receive result
         * @param asUint8 - optional flag to return result as an UInt8Array
         */
        async dataViewForRange(requestedRange, asUint8) {
            const len = Math.min(this.data.byteLength - requestedRange.start, requestedRange.size);
            return asUint8 ?
                new Uint8Array(this.data, requestedRange.start, len) :
                new DataView(this.data, requestedRange.start, len)
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class BWSource {

        constructor(config, genome) {
            this.reader = new BWReader(config, genome);
            this.genome = genome;
            this.format = config.format || "bigwig";
            this.wgValues = {};
            this.queryable = true;
        }

        async getFeatures({chr, start, end, bpPerPixel, windowFunction}) {

            const isBigWig = this.reader.type === "bigwig";

            const features = (chr.toLowerCase() === "all") ?
                (isBigWig ? await this.getWGValues(windowFunction) : []) :
                await this.reader.readFeatures(chr, start, chr, end, bpPerPixel, windowFunction);

            if (!isBigWig) {
                pack(features);
            }
            return features
        }

        async getHeader() {
            return this.reader.loadHeader()
        }

        getDefaultRange() {
            if (this.reader.totalSummary !== undefined) {
                return this.reader.totalSummary.defaultRange
            } else {
                return undefined
            }
        }

        async defaultVisibilityWindow() {
            return this.reader.defaultVisibilityWindow
        }

        async getWGValues(windowFunction) {

            const nominalScreenWidth = 1000;      // This doesn't need to be precise
            const genome = this.genome;

            if (this.wgValues[windowFunction]) {
                return this.wgValues[windowFunction]
            } else {

                const bpPerPixel = genome.getGenomeLength() / nominalScreenWidth;
                const features = await this.reader.readWGFeatures(bpPerPixel, windowFunction);
                let wgValues = [];
                for (let f of features) {
                    const chr = f.chr;
                    const offset = genome.getCumulativeOffset(chr);
                    const wgFeature = Object.assign({}, f);
                    wgFeature.chr = "all";
                    wgFeature.start = offset + f.start;
                    wgFeature.end = offset + f.end;
                    wgValues.push(wgFeature);
                }
                this.wgValues[windowFunction] = wgValues;
                return wgValues
            }
        }

        supportsWholeGenome() {
            return this.reader.type === "bigwig"
        }

        async trackType() {
            return this.reader.getTrackType()
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 University of California San Diego
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const GZIP_FLAG = 0x1;

    class TDFReader {

        constructor(config, genome) {
            this.config = config;
            this.genome = genome;
            this.path = config.url;
            this.groupCache = {};
            this.datasetCache = {};
        }


        async readHeader() {

            if (this.magic !== undefined) {
                return this   // Already read
            }

            let data = await igvxhr.loadArrayBuffer(this.path, buildOptions(this.config, {range: {start: 0, size: 64000}}));
            let binaryParser = new BinaryParser(new DataView(data));
            this.magic = binaryParser.getInt();
            this.version = binaryParser.getInt();
            this.indexPos = binaryParser.getLong();
            this.indexSize = binaryParser.getInt();
            binaryParser.getInt();


            if (this.version >= 2) {
                let nWindowFunctions = binaryParser.getInt();
                this.windowFunctions = [];
                while (nWindowFunctions-- > 0) {
                    this.windowFunctions.push(binaryParser.getString());
                }
            }

            this.trackType = binaryParser.getString();
            this.trackLine = binaryParser.getString();

            let nTracks = binaryParser.getInt();
            this.trackNames = [];
            while (nTracks-- > 0) {
                this.trackNames.push(binaryParser.getString());
            }
            this.genomeID = binaryParser.getString();
            this.flags = binaryParser.getInt();
            this.compressed = (this.flags & GZIP_FLAG) !== 0;

            // Now read index
            data = await igvxhr.loadArrayBuffer(this.path, buildOptions(this.config, {
                range: {
                    start: this.indexPos,
                    size: this.indexSize
                }
            }));
            binaryParser = new BinaryParser(new DataView(data));
            this.datasetIndex = {};
            let nEntries = binaryParser.getInt();
            while (nEntries-- > 0) {
                const name = binaryParser.getString();
                const pos = binaryParser.getLong();
                const size = binaryParser.getInt();
                this.datasetIndex[name] = {position: pos, size: size};
            }

            this.groupIndex = {};
            nEntries = binaryParser.getInt();
            while (nEntries-- > 0) {
                const name = binaryParser.getString();
                const pos = binaryParser.getLong();
                const size = binaryParser.getInt();
                this.groupIndex[name] = {position: pos, size: size};
            }

            return this
        }

        async readDataset(chr, windowFunction, zoom) {

            const key = chr + "_" + windowFunction + "_" + zoom;

            if (this.datasetCache[key]) {
                return this.datasetCache[key]

            } else {
                await this.readHeader();
                const wf = (this.version < 2) ? "" : "/" + windowFunction;
                const zoomString = (chr.toLowerCase() === "all" || zoom === undefined) ? "0" : zoom.toString();

                let dsName;
                if (windowFunction === "raw") {
                    dsName = "/" + chr + "/raw";
                } else {
                    dsName = "/" + chr + "/z" + zoomString + wf;
                }
                const indexEntry = this.datasetIndex[dsName];

                if (indexEntry === undefined) {
                    return undefined
                }

                const data = await igvxhr.loadArrayBuffer(this.path, buildOptions(this.config, {
                    range: {
                        start: indexEntry.position,
                        size: indexEntry.size
                    }
                }));

                if (!data) {
                    return undefined
                }

                const binaryParser = new BinaryParser(new DataView(data));
                let nAttributes = binaryParser.getInt();
                const attributes = {};
                while (nAttributes-- > 0) {
                    attributes[binaryParser.getString()] = binaryParser.getString();
                }
                const dataType = binaryParser.getString();
                const tileWidth = binaryParser.getFloat();
                let nTiles = binaryParser.getInt();
                const tiles = [];
                while (nTiles-- > 0) {
                    tiles.push({position: binaryParser.getLong(), size: binaryParser.getInt()});
                }

                const dataset = {
                    name: dsName,
                    attributes: attributes,
                    dataType: dataType,
                    tileWidth: tileWidth,
                    tiles: tiles
                };

                this.datasetCache[key] = dataset;
                return dataset
            }
        }

        async readRootGroup() {

            const genome = this.genome;
            const rootGroup = this.groupCache["/"];
            if (rootGroup) {
                return rootGroup
            } else {

                const group = await this.readGroup("/");
                const names = group["chromosomes"];
                const maxZoomString = group["maxZoom"];

                // Now parse out interesting attributes.
                if (maxZoomString) {
                    this.maxZoom = Number(maxZoomString);
                }

                const totalCountString = group["totalCount"];
                if (totalCountString) {
                    group.totalCount = Number(totalCountString);
                }

                // Chromosome names
                const chrAliasTable = {};
                if (names) {
                    names.split(",").forEach(function (chr) {
                        const canonicalName = genome.getChromosomeName(chr);
                        chrAliasTable[canonicalName] = chr;
                    });
                }
                this.chrAliasTable = chrAliasTable;

                this.groupCache["/"] = group;
                return group
            }
        }

        async readGroup(name) {

            const group = this.groupCache[name];
            if (group) {
                return group
            } else {

                await this.readHeader();
                const indexEntry = this.groupIndex[name];
                if (indexEntry === undefined) {
                    return undefined
                }

                const data = await igvxhr.loadArrayBuffer(this.path, buildOptions(this.config, {
                    range: {
                        start: indexEntry.position,
                        size: indexEntry.size
                    }
                }));

                if (!data) {
                    return undefined
                }

                const binaryParser = new BinaryParser(new DataView(data));
                const group = {name: name};
                let nAttributes = binaryParser.getInt();
                while (nAttributes-- > 0) {
                    const key = binaryParser.getString();
                    const value = binaryParser.getString();
                    group[key] = value;
                }
                this.groupCache[name] = group;
                return group
            }
        }


        async readTiles(tileIndeces, nTracks) {

            tileIndeces.sort(function (a, b) {
                return a.position - b.position
            });

            tileIndeces = tileIndeces.filter(function (idx) {
                return idx.size > 0
            });

            if (tileIndeces.length === 0) {
                return Promise.resolve([])
            }

            const firstEntry = tileIndeces[0];
            const lastEntry = tileIndeces[tileIndeces.length - 1];
            const position = firstEntry.position;
            const size = (lastEntry.position + lastEntry.size) - position;
            const data = await igvxhr.loadArrayBuffer(this.path, buildOptions(this.config, {
                range: {
                    start: position,
                    size: size
                }
            }));

            const tiles = [];

            // Loop through and decode tiles
            for (let indexEntry of tileIndeces) {
                const start = indexEntry.position - position;
                const size = indexEntry.size;
                if (size > 0) {
                    let tileData;
                    if (this.compressed) {
                        const plain = inflate_1$3(data.slice(start, start + size));
                        tileData = plain.buffer;
                    } else {
                        tileData = data.slice(start, start + size);
                    }

                    const binaryParser = new BinaryParser(new DataView(tileData));
                    const type = binaryParser.getString();
                    let tile;
                    switch (type) {
                        case "fixedStep":
                            tile = createFixedStep(binaryParser, nTracks);
                            break
                        case "variableStep":
                            tile = createVariableStep(binaryParser, nTracks);
                            break
                        case "bed":
                        case "bedWithName":
                            tile = createBed(binaryParser, nTracks, type);
                            break
                        default:
                            throw "Unknown tile type: " + type
                    }
                    tiles.push(tile);
                }
            }
            return tiles
        }

        async readTile(indexEntry, nTracks) {

            let data = await igvxhr.loadArrayBuffer(this.path, buildOptions(this.config, {
                range: {
                    start: indexEntry.position,
                    size: indexEntry.size
                }
            }));

            if (this.compressed) {
                const plain = inflate_1$3(data);
                data = plain.buffer;
            }

            const binaryParser = new BinaryParser(new DataView(data));
            const type = binaryParser.getString();
            switch (type) {
                case "fixedStep":
                    return createFixedStep(binaryParser, nTracks)
                case "variableStep":
                    return createVariableStep(binaryParser, nTracks)
                case "bed":
                case "bedWithName":
                    return createBed(binaryParser, nTracks, type)
                default:
                    throw "Unknown tile type: " + type
            }
        }

    }

    function createFixedStep(binaryParser, nTracks) {
        const nPositions = binaryParser.getInt();
        const start = binaryParser.getInt();
        const span = binaryParser.getFloat();

        const data = [];
        let nt = nTracks;
        while (nt-- > 0) {
            let np = nPositions;
            const dtrack = [];
            while (np-- > 0) {
                dtrack.push(binaryParser.getFloat());
            }
            data.push(dtrack);
        }

        return {
            type: "fixedStep",
            start: start,
            span: span,
            data: data,
            nTracks: nTracks,
            nPositions: nPositions
        }
    }

    function createVariableStep(binaryParser, nTracks) {

        const tileStart = binaryParser.getInt();
        const span = binaryParser.getFloat();
        const nPositions = binaryParser.getInt();
        const start = [];

        let np = nPositions;
        while (np-- > 0) {
            start.push(binaryParser.getInt());
        }
        binaryParser.getInt();  // # of samples, ignored but should === nTracks

        const data = [];
        let nt = nTracks;
        while (nt-- > 0) {
            np = nPositions;
            const dtrack = [];
            while (np-- > 0) {
                dtrack.push(binaryParser.getFloat());
            }
            data.push(dtrack);
        }

        return {
            type: "variableStep",
            tileStart: tileStart,
            span: span,
            start: start,
            data: data,
            nTracks: nTracks,
            nPositions: nPositions
        }
    }

    function createBed(binaryParser, nTracks, type) {

        const nPositions = binaryParser.getInt();

        let n = nPositions;
        const start = [];
        while (n-- > 0) {
            start.push(binaryParser.getInt());
        }

        n = nPositions;
        const end = [];
        while (n-- > 0) {
            end.push(binaryParser.getInt());
        }

        binaryParser.getInt();  // # of samples, ignored but should === nTracks
        const data = [];
        let nt = nTracks;
        while (nt-- > 0) {
            let np = nPositions;
            const dtrack = [];
            while (np-- > 0) {
                dtrack.push(binaryParser.getFloat());
            }
            data.push(dtrack);
        }

        if (type === "bedWithName") {
            n = nPositions;
            const name = [];
            while (n-- > 0) {
                name.push(binaryParser.getString());
            }
        }

        return {
            type: type,
            start: start,
            end: end,
            data: data,
            nTracks: nTracks,
            nPositions: nPositions
        }

    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 University of California San Diego
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class TDFSource {

        constructor(config, genome) {
            this.genome = genome;
            this.windowFunction = config.windowFunction || "mean";
            this.reader = new TDFReader(config, genome);
            this.queryable = true;
        }

        async getFeatures({chr, start, end, bpPerPixel}) {

            if (chr.toLowerCase() === "all") {
                const wgFeatures = [];
                const genome = this.genome;
                const chrNames = this.genome.wgChromosomeNames;
                if (chrNames) {
                    for (let c of genome.wgChromosomeNames) {
                        const len = genome.getChromosome(c).bpLength;
                        bpPerPixel = len / 1000;
                        const chrFeatures = await this._getFeatures(c, 0, len, bpPerPixel);
                        if (chrFeatures) {
                            for (let f of chrFeatures) {
                                const wg = Object.assign({}, f);
                                wg.chr = "all";
                                wg.start = genome.getGenomeCoordinate(f.chr, f.start);
                                wg.end = genome.getGenomeCoordinate(f.chr, f.end);
                                wg._f = f;
                                wgFeatures.push(wg);
                            }
                        }
                    }
                }
                return wgFeatures

            } else {
                return this._getFeatures(chr, start, end, bpPerPixel)
            }
        }

        async _getFeatures(chr, start, end, bpPerPixel) {
            const genomicInterval = new GenomicInterval(chr, start, end);
            const genome = this.genome;


            if (!this.rootGroup) {
                this.rootGroup = await this.reader.readRootGroup();
                if (!this.normalizationFactor) {
                    const totalCount = this.rootGroup.totalCount;
                    if (totalCount) {
                        this.normalizationFactor = 1.0e6 / totalCount;
                    }
                }
            }

            genomicInterval.bpPerPixel = bpPerPixel;
            const zoom = zoomLevelForScale(chr, bpPerPixel, genome);
            let queryChr = this.reader.chrAliasTable[chr];
            let maxZoom = this.reader.maxZoom;
            if (queryChr === undefined) queryChr = chr;
            if (maxZoom === undefined) maxZoom = -1;

            const wf = zoom > maxZoom ? "raw" : this.windowFunction;
            const dataset = await this.reader.readDataset(queryChr, wf, zoom);
            if (dataset == null) {
                return []
            }

            const tileWidth = dataset.tileWidth;
            const startTile = Math.floor(start / tileWidth);
            const endTile = Math.floor(end / tileWidth);
            const NTRACKS = 1;   // TODO read this
            const tiles = await this.reader.readTiles(dataset.tiles.slice(startTile, endTile + 1), NTRACKS);
            const features = [];
            for (let tile of tiles) {
                switch (tile.type) {
                    case "bed":
                        decodeBedTile(tile, chr, start, end, bpPerPixel, features);
                        break
                    case "variableStep":
                        decodeVaryTile(tile, chr, start, end, bpPerPixel, features);
                        break
                    case "fixedStep":
                        decodeFixedTile(tile, chr, start, end, bpPerPixel, features);
                        break
                    default:
                        throw ("Unknown tile type: " + tile.type)
                }
            }
            features.sort(function (a, b) {
                return a.start - b.start
            });

            return features
        }

        get supportsWholeGenome() {
            return true
        }
    }

    function decodeBedTile(tile, chr, bpStart, bpEnd, bpPerPixel, features) {

        const nPositions = tile.nPositions;
        const starts = tile.start;
        const ends = tile.end;
        const data = tile.data[0];   // Single track for now
        for (let i = 0; i < nPositions; i++) {
            const s = starts[i];
            const e = ends[i];
            if (e < bpStart) continue
            if (s > bpEnd) break
            features.push({
                chr: chr,
                start: s,
                end: e,
                value: data[i]
            });
        }
    }

    function decodeVaryTile(tile, chr, bpStart, bpEnd, bpPerPixel, features) {

        const nPositions = tile.nPositions;
        const starts = tile.start;
        const span = tile.span;
        const data = tile.data[0];   // Single track for now
        for (let i = 0; i < nPositions; i++) {
            const s = starts[i];
            const e = s + span;
            if (e < bpStart) continue
            if (s > bpEnd) break
            features.push({
                chr: chr,
                start: s,
                end: e,
                value: data[i]
            });
        }
    }

    function decodeFixedTile(tile, chr, bpStart, bpEnd, bpPerPixel, features) {

        const nPositions = tile.nPositions;
        let s = tile.start;
        const span = tile.span;
        const data = tile.data[0];   // Single track for now

        for (let i = 0; i < nPositions; i++) {
            const e = s + span;
            if (s > bpEnd) break
            if (e >= bpStart) {
                if (!Number.isNaN(data[i])) {
                    features.push({
                        chr: chr,
                        start: s,
                        end: e,
                        value: data[i]
                    });
                }
            }
            s = e;
        }
    }


    var log2 = Math.log(2);

    function zoomLevelForScale(chr, bpPerPixel, genome) {

        // Convert bpPerPixel to IGV "zoom" level.   This is a bit convoluted,  IGV computes zoom levels assuming
        // display in a 700 pixel window.  The fully zoomed out view of a chromosome is zoom level "0".
        // Zoom level 1 is magnified 2X,  and so forth

        var chrSize = genome.getChromosome(chr).bpLength;

        return Math.ceil(Math.log(Math.max(0, (chrSize / (bpPerPixel * 700)))) / log2)
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014-2015 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    /**
     * feature source for features supplied directly, as opposed to reading and parsing from a file or webservice
     *
     * @param config
     * @constructor
     */
    class StaticFeatureSource {

        constructor(config, genome) {

            this.config = config;
            this.genome = genome;
            this.queryable = false;
            this.searchable = config.searchable !== false;  // searchable by default
            this.updateFeatures(config.features);
        }

        updateFeatures(features) {
            features = fixFeatures(features, this.genome);
            packFeatures(features);
            if (this.config.mappings) {
                mapProperties(features, this.config.mappings);
            }
            this.featureCache = new FeatureCache$1(features, this.genome);

            if (this.searchable || this.config.searchableFields) {
                this.genome.addFeaturesToDB(features, this.config);
            }
        }

        /**
         * Required function for all data source objects.  Fetches features for the
         * range requested.
         *
         * This function is complex due to the variety of reader types backing it, some indexed, some queryable,
         * some not.
         *
         * @param chr
         * @param start
         * @param end
         * @param bpPerPixel
         */
        async getFeatures({chr, start, end, bpPerPixel, visibilityWindow}) {

            const genome = this.genome;
            const queryChr = genome ? genome.getChromosomeName(chr) : chr;
            const isWholeGenome = ("all" === queryChr.toLowerCase());

            // Various conditions that can require a feature load
            //   * view is "whole genome" but no features are loaded
            //   * cache is disabled
            //   * cache does not contain requested range
            if (isWholeGenome) {
                return computeWGFeatures(this.featureCache.getAllFeatures(), this.genome, this.maxWGCount)
            } else {
                return this.featureCache.queryFeatures(queryChr, start, end)
            }
        }

        //
        // supportsWholeGenome() {
        //    return true
        // }

        getAllFeatures() {
            return this.featureCache.getAllFeatures()
        }

        supportsWholeGenome() {
            return true
        }


    }


    /**
     * This function is used to apply properties normally added during parsing to  features supplied directly in the
     * config as an array of objects.   At the moment the only application is bedpe type features.
     * @param features
     */
    function fixFeatures(features, genome) {

        if (genome) {
            for (let feature of features) {
                feature.chr = genome.getChromosomeName(feature.chr);
            }
        }

        return features
    }



    function mapProperties(features, mappings) {
        let mappingKeys = Object.keys(mappings);
        features.forEach(function (f) {
            mappingKeys.forEach(function (key) {
                f[key] = f[mappings[key]];
            });
        });
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014-2015 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const bbFormats = new Set(['bigwig', 'bw', 'bigbed', 'bb', 'biginteract', 'biggenepred', 'bignarrowpeak']);

    function FeatureSource(config, genome) {

        const format = config.format ? config.format.toLowerCase() : undefined;

        if (config.features) {
            return new StaticFeatureSource(config, genome)
        } else if (bbFormats.has(format)) {
            return new BWSource(config, genome)
        } else if ("tdf" === format) {
            return new TDFSource(config, genome)
        } else {
            return new TextFeatureSource(config, genome)
        }
    }

    const appleCrayonColorName = 'nickel';

    const ROI_DEFAULT_ALPHA = 2 / 16;

    const ROI_DEFAULT_COLOR = appleCrayonRGBA(appleCrayonColorName, ROI_DEFAULT_ALPHA);
    const ROI_DEFAULT_HEADER_COLOR = 'rgb(190,190,190)';

    const ROI_USER_HEADER_DEFINED_COLOR = 'rgba(155,185,129)';
    const ROI_USER_DEFINED_COLOR = ROI_DEFAULT_COLOR;

    class ROISet {

        constructor(config, genome) {

            this.url = config.url;

            if (config.name) {
                this.name = config.name;
            } else if (config.url && isFile(config.url)) {
                this.name = config.url.name;
            } else if (config.url && isString$2(config.url) && !config.url.startsWith("data:")) {
                this.name = getFilename$2(config.url);
            }

            this.isUserDefined = config.isUserDefined;

            if (config.features) {
                this.featureSource = new DynamicFeatureSource(config.features, genome);
            } else {
                if (config.format) {
                    config.format = config.format.toLowerCase();
                } else {
                    const filename = getFilename$2(config.url);
                    config.format = inferFileFormat(filename);
                }
                this.featureSource = config.featureSource || FeatureSource(config, genome);
            }

            if (true === this.isUserDefined) {
                this.color = config.color || ROI_USER_DEFINED_COLOR;
                this.headerColor = ROI_USER_HEADER_DEFINED_COLOR;

            } else {

                this.color = config.color || ROI_DEFAULT_COLOR;
                this.headerColor = ROI_DEFAULT_HEADER_COLOR;

                // Use body color with alpha pinned to 1
                // const [ r, g, b, discard ] = rgbaStringTokens(this.color)
                // this.headerColor = `rgba(${ r },${ g },${ b },${ 1.0 })`

            }
        }

        async getFeatures(chr, start, end) {
            return this.featureSource.getFeatures({chr, start, end})
        }

        async getAllFeatures() {
            return typeof this.featureSource.getAllFeatures === 'function' ? await this.featureSource.getAllFeatures() : {}
        }

        addFeature(feature) {
            if (this.isUserDefined) {
                this.featureSource.addFeature(feature);
            } else {
                console.error("Attempt to add ROI to non user-defined set");
            }
        }

        removeFeature(feature) {
            if (this.isUserDefined) {
                this.featureSource.removeFeature(feature);
            } else {
                console.error("Attempt to remove ROI from non user-defined set");
            }
        }

        toJSON() {
            if (this.url) {
                return {name: this.name, color: this.color, url: this.url, isUserDefined: this.isUserDefined}
            } else {
                const featureMap = this.featureSource.getAllFeatures();
                const features = [];
                for (let chr of Object.keys(featureMap)) {
                    for (let f of featureMap[chr]) {
                        features.push(f);
                    }
                }
                return {name: this.name, color: this.color, features: features, isUserDefined: this.isUserDefined}
            }
        }

        dispose() {
            for (let key of Object.keys(this)) {
                this[key] = undefined;
            }
        }

    }

    const SCREEN_COORDS_WIDTH_THRESHOLD = 3;

    function screenCoordinates(regionStartBP, regionEndBP, bpStart, bpp) {

        let xStart = Math.round((regionStartBP - bpStart) / bpp);
        const xEnd = Math.round((regionEndBP - bpStart) / bpp);

        let width = xEnd - xStart;

        if (width < SCREEN_COORDS_WIDTH_THRESHOLD) {
            width = SCREEN_COORDS_WIDTH_THRESHOLD;
            xStart -= 1;
        }

        return {x: xStart, width}
    }


    /**
     * Special feature source that allows addition of features dynamically
     */
    class DynamicFeatureSource {

        constructor(features, genome) {
            this.featureMap = {};
            this.genome = genome;

            for (let feature of features) {

                // Store as canonical chr name (i.e. translate aliases)
                const chrKey = genome ? genome.getChromosomeName(feature.chr) : feature.chr;

                let featureList = this.featureMap[chrKey];
                if (!featureList) {
                    featureList = [];
                    this.featureMap[chrKey] = featureList;
                }
                featureList.push(feature);
            }

            for (let key of Object.keys(this.featureMap)) {
                this.featureMap[key].sort((a, b) => a.start - b.start);
            }
        }

        getFeatures({chr, start, end}) {
            if (chr.toLowerCase() === 'all') {
                return computeWGFeatures(this.featureMap, this.genome)
            } else {
                // TODO -- this use of filter is O(N), and might not scale well for large feature lists.
                const featureList = this.featureMap[chr];
                return featureList ? featureList.filter(feature => feature.end > start && feature.start < end) : []
            }
        }

        getAllFeatures() {
            return this.featureMap
        }

        supportsWholeGenome() {
            return true
        }

        addFeature(feature) {
            let featureList = this.featureMap[feature.chr];
            if (!featureList) {
                featureList = [];
                this.featureMap[feature.chr] = featureList;
            }
            featureList.push(feature);
            featureList.sort((a, b) => a.start - b.start);
        }

        removeFeature({chr, start, end}) {

            if (this.featureMap[chr]) {
                const match = `${chr}-${start}-${end}`;
                this.featureMap[chr] = this.featureMap[chr].filter(feature => match !== `${feature.chr}-${feature.start}-${feature.end}`);
            }
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const RULER_SWEEPER_COLOR = 'rgba(68, 134, 247, 0.25)';

    class RulerSweeper {

        constructor(rulerViewport, column, browser, referenceFrame) {

            this.rulerViewport = rulerViewport;

            this.rulerSweeper = domUtils.div({class: 'igv-ruler-sweeper'});
            column.appendChild(this.rulerSweeper);

            this.browser = browser;
            this.referenceFrame = referenceFrame;

            this.isMouseHandlers = undefined;

            this.addBrowserObserver();
        }

        addBrowserObserver() {

            const observerHandler = () => {
                if (this.referenceFrame) {
                    GenomeUtils.isWholeGenomeView(this.referenceFrame.chr) ? this.removeMouseHandlers() : this.addMouseHandlers();
                }
            };

            // Viewport Content
            this.boundObserverHandler = observerHandler.bind(this);
            this.browser.on('locuschange', this.boundObserverHandler);

        }

        removeBrowserObserver() {
            this.browser.off('locuschange', this.boundObserverHandler);
        }

        addMouseHandlers() {

            if (true === this.isMouseHandlers) {
                return
            }

            const threshold = 1;

            let isMouseDown;
            let isMouseIn;
            let mouseDownX;
            let left;
            let width;
            let dx;

            // Viewport Content
            this.boundContentMouseDownHandler = contentMouseDownHandler.bind(this);
            this.rulerViewport.contentDiv.addEventListener('mousedown', this.boundContentMouseDownHandler);

            function contentMouseDownHandler(event) {

                isMouseDown = true;
                isMouseIn = true;

                const {x} = domUtils.translateMouseCoordinates(event, this.rulerViewport.contentDiv);
                left = mouseDownX = x;

                width = threshold;


                this.rulerSweeper.style.display = 'block';
                this.rulerSweeper.style.backgroundColor = true === event.shiftKey ? ROI_USER_DEFINED_COLOR : RULER_SWEEPER_COLOR;

                this.rulerSweeper.style.left = `${left}px`;
                this.rulerSweeper.style.width = `${width}px`;

            }

            // Document
            this.boundDocumentMouseMoveHandler = documentMouseMoveHandler.bind(this);
            document.addEventListener('mousemove', this.boundDocumentMouseMoveHandler);

            function documentMouseMoveHandler(event) {

                let mouseCurrentX;

                if (isMouseDown && isMouseIn) {

                    const {x} = domUtils.translateMouseCoordinates(event, this.rulerViewport.contentDiv);
                    mouseCurrentX = Math.max(Math.min(x, this.rulerViewport.contentDiv.clientWidth), 0);

                    dx = mouseCurrentX - mouseDownX;

                    width = Math.abs(dx);
                    this.rulerSweeper.style.width = `${width}px`;

                    if (dx < 0) {
                        left = mouseDownX + dx;
                        this.rulerSweeper.style.left = `${left}px`;
                    }

                }

            }

            this.boundDocumentMouseUpHandler = documentMouseUpHandler.bind(this);
            document.addEventListener('mouseup', this.boundDocumentMouseUpHandler);

            function documentMouseUpHandler(event) {

                let genomicExtent;

                if (true === isMouseDown && true === isMouseIn) {

                    isMouseDown = isMouseIn = undefined;

                    this.rulerSweeper.style.display = 'none';

                    if (width > threshold) {

                        genomicExtent =
                            {
                                start: Math.floor(this.referenceFrame.calculateEnd(left)),
                                end: Math.floor(this.referenceFrame.calculateEnd(left + width)),
                            };


                        const shiftKeyPressed = event.shiftKey;

                        if (true === shiftKeyPressed) {
                            this.browser.roiManager.updateUserDefinedROISet(Object.assign({chr: this.referenceFrame.chr}, genomicExtent));
                        } else {

                            validateGenomicExtent(this.browser.genome.getChromosome(this.referenceFrame.chr).bpLength, genomicExtent, this.browser.minimumBases());
                            updateReferenceFrame(this.referenceFrame, genomicExtent, this.rulerViewport.contentDiv.clientWidth);
                            this.browser.updateViews(this.referenceFrame);

                        }

                    }

                }

            }

            this.isMouseHandlers = true;
        }

        removeMouseHandlers() {
            this.rulerViewport.contentDiv.removeEventListener('mousedown', this.boundContentMouseDownHandler);
            document.removeEventListener('mousemove', this.boundDocumentMouseMoveHandler);
            document.removeEventListener('mouseup', this.boundDocumentMouseUpHandler);
            this.isMouseHandlers = false;
        }

        dispose() {
            this.removeBrowserObserver();
            this.removeMouseHandlers();
            this.rulerSweeper.remove();
        }

    }

    function updateReferenceFrame(referenceFrame, genomicExtent, pixelWidth) {
        referenceFrame.start = Math.round(genomicExtent.start);
        referenceFrame.end = Math.round(genomicExtent.end);
        referenceFrame.bpPerPixel = (referenceFrame.end - referenceFrame.start) / pixelWidth;
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 University of California San Diego
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */


    class PairedAlignment {

        constructor(firstAlignment) {

            this.paired = true;
            this.firstAlignment = firstAlignment;
            this.chr = firstAlignment.chr;
            this.readName = firstAlignment.readName;

            if (firstAlignment.start < firstAlignment.mate.position) {
                this.start = firstAlignment.start;
                this.scStart = firstAlignment.scStart;
                this.connectingStart = firstAlignment.start + firstAlignment.lengthOnRef;
                this.connectingEnd = firstAlignment.mate.position;
            } else {
                this.start = firstAlignment.mate.position;
                this.scStart = this.start;
                this.connectingStart = firstAlignment.mate.position;
                this.connectingEnd = firstAlignment.start;
            }

            this.end = Math.max(firstAlignment.mate.position, firstAlignment.start + firstAlignment.lengthOnRef);  // Approximate
            this.lengthOnRef = this.end - this.start;

            let scEnd = Math.max(this.end, firstAlignment.scStart + firstAlignment.scLengthOnRef);
            this.scLengthOnRef = scEnd - this.scStart;

        }

        setSecondAlignment(secondAlignment) {

            // TODO -- check the chrs are equal,  error otherwise
            this.secondAlignment = secondAlignment;
            const firstAlignment = this.firstAlignment;

            if (secondAlignment.start > firstAlignment.start) {
                this.connectingEnd = secondAlignment.start;
            } else {
                this.connectingStart = secondAlignment.start + secondAlignment.lengthOnRef;
            }

            this.start = Math.min(firstAlignment.start, secondAlignment.start);
            this.end = Math.max(firstAlignment.start + firstAlignment.lengthOnRef, secondAlignment.start + secondAlignment.lengthOnRef);
            this.lengthOnRef = this.end - this.start;

            this.scStart = Math.min(firstAlignment.scStart, secondAlignment.scStart);
            const scEnd = Math.max(firstAlignment.scStart + firstAlignment.scLengthOnRef, secondAlignment.scStart + secondAlignment.scLengthOnRef);
            this.scLengthOnRef = scEnd - this.scStart;

        }

        containsLocation(genomicLocation, showSoftClips) {
            const s = showSoftClips ? this.scStart : this.start;
            const l = showSoftClips ? this.scLengthOnRef : this.lengthOnRef;
            return (genomicLocation >= s && genomicLocation <= (s + l))
        }

        alignmentContaining(genomicLocation, showSoftClips) {
            if (this.firstAlignment.containsLocation(genomicLocation, showSoftClips)) {
                return this.firstAlignment
            } else if (this.secondAlignment && this.secondAlignment.containsLocation(genomicLocation, showSoftClips)) {
                return this.secondAlignment
            } else {
                return undefined
            }
        }

        popupData(genomicLocation) {

            let nameValues = this.firstAlignment.popupData(genomicLocation);

            if (this.secondAlignment) {
                nameValues.push("-------------------------------");
                nameValues = nameValues.concat(this.secondAlignment.popupData(genomicLocation));
            }
            return nameValues
        }

        isPaired() {
            return true // By definition
        }

        isMateMapped() {
            return true // By definition
        }

        isProperPair() {
            return this.firstAlignment.isProperPair()
        }

        get fragmentLength() {
            return Math.abs(this.firstAlignment.fragmentLength)
        }

        firstOfPairStrand() {

            if (this.firstAlignment.isFirstOfPair()) {
                return this.firstAlignment.strand
            } else if (this.secondAlignment && this.secondAlignment.isFirstOfPair()) {
                return this.secondAlignment.strand
            } else {
                return this.firstAlignment.mate.strand    // Assumption is mate is first-of-pair
            }
        }

        hasTag(str) {
            return this.firstAlignment.hasTag(str) || (this.secondAlignment &&  this.secondAlignment.hasTag(str))
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class BamAlignmentRow {

        constructor() {

            this.alignments = [];
            this.score = undefined;
        }

        findAlignment(genomicLocation) {

            const alignmentContains = (a, genomicLocation) => {
                return genomicLocation >= a.start && genomicLocation < a.start + a.lengthOnRef
            };

            // find single alignment that overlaps sort location
            let centerAlignment;
            for (let i = 0; i < this.alignments.length; i++) {
                const a = this.alignments[i];
                if (genomicLocation >= a.start && genomicLocation < a.start + a.lengthOnRef) {
                    if (a.paired) {
                        if (a.firstAlignment && alignmentContains(a.firstAlignment, genomicLocation)) {
                            centerAlignment = a.firstAlignment;
                        } else if (a.secondAlignment && alignmentContains(a.secondAlignment, genomicLocation)) {
                            centerAlignment = a.secondAlignment;
                        }
                    } else {
                        centerAlignment = a;
                    }
                    break
                }
            }

            return centerAlignment

        }

        getSortValue({position, option, tag}, alignmentContainer) {

            if (!option) option = "BASE";

            const alignment = this.findAlignment(position);
            if (undefined === alignment) {  // This condition should never occur
                return Number.MAX_VALUE
            }

            switch (option) {
                case "NUCLEOTIDE":
                case "BASE": {
                    return calculateBaseScore(alignment, alignmentContainer, position)
                }
                case "STRAND":
                    return alignment.strand ? 1 : -1
                case "START":
                    return alignment.start
                case "TAG": {
                    return alignment.tags()[tag]
                }
                case "READ_NAME":
                    return alignment.readName
                case "INSERT_SIZE":
                    return -Math.abs(alignment.fragmentLength)
                case "GAP_SIZE":
                    return -alignment.gapSizeAt(position)
                case "MATE_CHR":
                    return alignment.mate
                case "MQ":
                    return alignment.mq === undefined ? Number.MAX_VALUE : -alignment.mq
                case "ALIGNED_READ_LENGTH":
                    return -alignment.lengthOnRef
                default:
                    return Number.MAX_VALUE
            }


            function calculateBaseScore(alignment, alignmentContainer, genomicLocation) {

                let reference;
                const idx = Math.floor(genomicLocation) - alignmentContainer.start;
                if (idx < alignmentContainer.sequence.length) {
                    reference = alignmentContainer.sequence.charAt(idx);
                }
                if (!reference) {
                    return 0
                }
                const base = alignment.readBaseAt(genomicLocation);
                const quality = alignment.readBaseQualityAt(genomicLocation);

                const coverageMap = alignmentContainer.coverageMap;
                const coverageMapIndex = Math.floor(genomicLocation - coverageMap.bpStart);
                const coverage = coverageMap.coverage[coverageMapIndex];

                // Insertions.  These are additive with base scores as they occur between bases, so you can have a
                // base mismatch AND an insertion
                let baseScore = 0;
                if (alignment.insertions) {
                    for (let ins of alignment.insertions) {
                        if (ins.start === genomicLocation) {
                            baseScore = -coverage.ins;
                        }
                    }
                }


                if (!base) {
                    // Either deletion or skipped (splice junction)
                    const delCount = coverage.del;
                    if (delCount > 0) {
                        baseScore -= delCount;
                    } else if (baseScore === 0) {    // Don't modify insertion score, if any
                        baseScore = 1;
                    }
                } else {
                    reference = reference.toUpperCase();
                    if ('N' === base && baseScore === 0) {
                        baseScore = 2;
                    } else if ((reference === base || '=' === base) && baseScore === 0) {
                        baseScore = 4 - quality / 1000;
                    } else if ("X" === base || reference !== base) {
                        const count = coverage["pos" + base] + coverage["neg" + base];
                        baseScore -= (count + (quality / 1000));
                    }
                }


                return baseScore
            }
        }


    }

    const alignmentSpace = 2;

    function canBePaired(alignment) {
        return alignment.isPaired() &&
            alignment.mate &&
            alignment.isMateMapped() &&
            alignment.chr === alignment.mate.chr &&
            (alignment.isFirstOfPair() || alignment.isSecondOfPair()) && !(alignment.isSecondary() || alignment.isSupplementary())
    }


    function pairAlignments(rows) {

        const pairCache = {};
        const result = [];

        for (let row of rows) {
            for (let alignment of row.alignments) {
                if (canBePaired(alignment)) {
                    let pairedAlignment = pairCache[alignment.readName];
                    if (pairedAlignment) {
                        pairedAlignment.setSecondAlignment(alignment);
                        pairCache[alignment.readName] = undefined;   // Don't need to track this anymore.
                    } else {
                        pairedAlignment = new PairedAlignment(alignment);
                        pairCache[alignment.readName] = pairedAlignment;
                        result.push(pairedAlignment);
                    }
                } else {
                    result.push(alignment);
                }
            }
        }
        return result
    }

    function unpairAlignments(rows) {
        const result = [];
        for (let row of rows) {
            for (let alignment of row.alignments) {
                if (alignment instanceof PairedAlignment) {
                    if (alignment.firstAlignment) result.push(alignment.firstAlignment);  // shouldn't need the null test
                    if (alignment.secondAlignment) result.push(alignment.secondAlignment);
                } else {
                    result.push(alignment);
                }
            }
        }
        return result
    }

    function packAlignmentRows(alignments, start, end, showSoftClips) {

        //console.log(`packAlignmentRows ${start} ${end}`)
        //const t0 = Date.now()

        if (!alignments) {
            return undefined
        } else if (alignments.length === 0) {
            return []
        } else {
            alignments.sort(function (a, b) {
                return showSoftClips ? a.scStart - b.scStart : a.start - b.start
            });

            const packedAlignmentRows = [];
            let alignmentRow;
            let nextStart = 0;
            let nextIDX = 0;
            const allocated = new Set();
            const startNewRow = () => {
                alignmentRow = new BamAlignmentRow();
                packedAlignmentRows.push(alignmentRow);
                nextStart = 0;
                nextIDX = 0;
                allocated.clear();
            };
            startNewRow();

            while (alignments.length > 0) {
                if (nextIDX >= 0 && nextIDX < alignments.length) {
                    const alignment = alignments[nextIDX];
                    allocated.add(alignment);
                    alignmentRow.alignments.push(alignment);
                    nextStart = showSoftClips ?
                        alignment.scStart + alignment.scLengthOnRef + alignmentSpace :
                        alignment.start + alignment.lengthOnRef + alignmentSpace;
                    nextIDX = binarySearch$1(alignments, (a) => (showSoftClips ? a.scStart : a.start) > nextStart, nextIDX);
                } else {
                    // Remove allocated alignments and start new row
                    alignments = alignments.filter(a => !allocated.has(a));
                    startNewRow();
                }
            }
            //console.log(`Done in ${Date.now() - t0} ms`)
            return packedAlignmentRows
        }
    }


    /**
     * Return 0 <= i <= array.length such that !pred(array[i - 1]) && pred(array[i]).
     *
     * returns an index 0 ≤ i ≤ array.length such that the given predicate is false for array[i - 1] and true for array[i]* *
     */
    function binarySearch$1(array, pred, min) {
        let lo = min - 1, hi = array.length;
        while (1 + lo < hi) {
            const mi = lo + ((hi - lo) >> 1);
            if (pred(array[mi])) {
                hi = mi;
            } else {
                lo = mi;
            }
        }
        return hi
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 University of California San Diego
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */


    class AlignmentContainer {

        //            this.config.samplingWindowSize, this.config.samplingDepth,
        //             this.config.pairsSupported, this.config.alleleFreqThreshold)
        constructor(chr, start, end, {samplingWindowSize, samplingDepth, pairsSupported, alleleFreqThreshold}) {

            this.chr = chr;
            this.start = Math.floor(start);
            this.end = Math.ceil(end);
            this.length = (end - start);

            this.alleleFreqThreshold = alleleFreqThreshold === undefined ? 0.2 : alleleFreqThreshold;

            this.coverageMap = new CoverageMap(chr, start, end, this.alleleFreqThreshold);
            this.alignments = [];
            this.downsampledIntervals = [];

            this.samplingWindowSize = samplingWindowSize === undefined ? 100 : samplingWindowSize;
            this.samplingDepth = samplingDepth === undefined ? 1000 : samplingDepth;

            this.pairsSupported = pairsSupported === undefined ? true : pairsSupported;
            this.paired = false;  // false until proven otherwise
            this.pairsCache = {};  // working cache of paired alignments by read name

            this.downsampledReads = new Set();

            this.currentBucket = new DownsampleBucket(this.start, this.start + this.samplingWindowSize, this);

            this.filter = function filter(alignment) {         // TODO -- pass this in
                return alignment.isMapped() && !alignment.isFailsVendorQualityCheck()
            };

        }

        push(alignment) {

            if (this.filter(alignment) === false) return

            this.coverageMap.incCounts(alignment);   // Count coverage before any downsampling

            if (this.pairsSupported && this.downsampledReads.has(alignment.readName)) {
                return   // Mate already downsampled -- pairs are treated as a single alignment for downsampling
            }

            if (alignment.start >= this.currentBucket.end) {
                this.finishBucket();
                this.currentBucket = new DownsampleBucket(alignment.start, alignment.start + this.samplingWindowSize, this);
            }

            this.currentBucket.addAlignment(alignment);

        }

        forEach(callback) {
            this.alignments.forEach(callback);
        }

        finish() {

            if (this.currentBucket !== undefined) {
                this.finishBucket();
            }

            this.alignments.sort(function (a, b) {
                return a.start - b.start
            });

            this.pairsCache = undefined;
            this.downsampledReads = undefined;
        }

        contains(chr, start, end) {
            return this.chr === chr &&
                this.start <= start &&
                this.end >= end
        }

        hasDownsampledIntervals() {
            return this.downsampledIntervals && this.downsampledIntervals.length > 0
        }

        finishBucket() {
            this.alignments = this.alignments.concat(this.currentBucket.alignments);
            if (this.currentBucket.downsampledCount > 0) {
                this.downsampledIntervals.push(new DownsampledInterval(
                    this.currentBucket.start,
                    this.currentBucket.end,
                    this.currentBucket.downsampledCount));
            }
            this.paired = this.paired || this.currentBucket.paired;
        }

        setViewAsPairs(bool) {
            let alignments;
            if (bool) {
                alignments = pairAlignments(this.packedAlignmentRows);
            } else {
                alignments = unpairAlignments(this.packedAlignmentRows);
            }
            this.packedAlignmentRows = packAlignmentRows(alignments, this.start, this.end);
        }

        setShowSoftClips(bool) {
            const alignments = this.allAlignments();
            this.packedAlignmentRows = packAlignmentRows(alignments, this.start, this.end, bool);
        }

        repack(bpPerPixel, showSoftClips) {
            const alignments = this.allAlignments();
            this.packedAlignmentRows = packAlignmentRows(alignments, this.start, this.end, showSoftClips);

        }

        allAlignments() {
            const alignments = [];
            for (let row of this.packedAlignmentRows) {
                for (let alignment of row.alignments) {
                    alignments.push(alignment);
                }
            }
            return alignments
        }

        getMax(start, end) {
            return this.coverageMap.getMax(start, end)
        }

        sortRows(options) {

            const newRows = [];
            const undefinedRow = [];
            for (let row of this.packedAlignmentRows) {
                const alignment = row.findAlignment(options.position);
                if (undefined !== alignment) {
                    newRows.push(row);
                } else {
                    undefinedRow.push(row);
                }
            }

            newRows.sort((rowA, rowB) => {
                const direction = options.direction;
                const rowAValue = rowA.getSortValue(options, this);
                const rowBValue = rowB.getSortValue(options, this);

                if (rowBValue === undefined && rowBValue !== undefined) return 1
                else if (rowAValue !== undefined && rowBValue === undefined) return -1

                const i = rowAValue > rowBValue ? 1 : (rowAValue < rowBValue ? -1 : 0);
                return true === direction ? i : -i
            });

            for (let row of undefinedRow) {
                newRows.push(row);
            }

            this.packedAlignmentRows = newRows;
        }

    }


    class DownsampleBucket {

        constructor(start, end, alignmentContainer) {

            this.start = start;
            this.end = end;
            this.alignments = [];
            this.downsampledCount = 0;
            this.samplingDepth = alignmentContainer.samplingDepth;
            this.pairsSupported = alignmentContainer.pairsSupported;
            this.downsampledReads = alignmentContainer.downsampledReads;
            this.pairsCache = alignmentContainer.pairsCache;
        }

        addAlignment(alignment) {

            var idx, replacedAlignment, pairedAlignment;

            if (this.pairsSupported && canBePaired(alignment)) {
                pairedAlignment = this.pairsCache[alignment.readName];
                if (pairedAlignment) {
                    // Not subject to downsampling, just update the existing alignment
                    pairedAlignment.setSecondAlignment(alignment);
                    this.pairsCache[alignment.readName] = undefined;   // Don't need to track this anymore. NOTE: Don't "delete", causes runtime performance issues
                    return
                }
            }

            if (this.alignments.length < this.samplingDepth) {

                if (this.pairsSupported && canBePaired(alignment)) {

                    // First alignment in a pair
                    pairedAlignment = new PairedAlignment(alignment);
                    this.paired = true;
                    this.pairsCache[alignment.readName] = pairedAlignment;
                    this.alignments.push(pairedAlignment);

                } else {
                    this.alignments.push(alignment);
                }

            } else {

                idx = Math.floor(Math.random() * (this.samplingDepth + this.downsampledCount - 1));

                if (idx < this.samplingDepth) {

                    // Keep the new item
                    //  idx = Math.floor(Math.random() * (this.alignments.length - 1));
                    replacedAlignment = this.alignments[idx];   // To be replaced

                    if (this.pairsSupported && canBePaired(alignment)) {

                        if (this.pairsCache[replacedAlignment.readName] !== undefined) {
                            this.pairsCache[replacedAlignment.readName] = undefined;
                        }

                        pairedAlignment = new PairedAlignment(alignment);
                        this.paired = true;
                        this.pairsCache[alignment.readName] = pairedAlignment;
                        this.alignments[idx] = pairedAlignment;

                    } else {
                        this.alignments[idx] = alignment;
                    }
                    this.downsampledReads.add(replacedAlignment.readName);

                } else {
                    this.downsampledReads.add(alignment.readName);
                }

                this.downsampledCount++;
            }


        }
    }

    class CoverageMap {

        constructor(chr, start, end, alleleFreqThreshold) {

            this.chr = chr;
            this.bpStart = start;
            this.length = (end - start);

            this.coverage = new Array(this.length);
            this.maximum = 0;

            this.threshold = alleleFreqThreshold;
            this.qualityWeight = true;
        }

        /**
         * Return the maximum coverage value between start and end.  This is used for autoscaling.
         * @param start
         * @param end
         */
        getMax(start, end) {
            let max = 0;
            const len = this.coverage.length;
            for (let i = 0; i < len; i++) {
                const pos = this.bpStart + i;
                if (pos > end) break
                const cov = this.coverage[i];
                if (pos >= start && cov) {
                    max = Math.max(max, cov.total);
                }
            }
            return max
        }

        incCounts(alignment) {

            var self = this;

            if (alignment.blocks === undefined) {
                incBlockCount(alignment);
            } else {
                alignment.blocks.forEach(function (block) {
                    incBlockCount(block);
                });
            }

            if (alignment.gaps) {
                for (let del of alignment.gaps) {
                    if (del.type === 'D') {
                        const offset = del.start - self.bpStart;
                        for (let i = offset; i < offset + del.len; i++) {
                            if (i < 0) continue
                            if (!this.coverage[i]) {
                                this.coverage[i] = new Coverage(self.threshold);
                            }
                            this.coverage[i].del++;
                        }
                    }
                }
            }

            if (alignment.insertions) {
                for (let del of alignment.insertions) {
                    const i = del.start - this.bpStart;
                    if (i < 0) continue
                    if (!this.coverage[i]) {
                        this.coverage[i] = new Coverage(self.threshold);
                    }
                    this.coverage[i].ins++;
                }
            }

            function incBlockCount(block) {

                if ('S' === block.type) return

                const seq = alignment.seq;
                const qual = alignment.qual;
                const seqOffset = block.seqOffset;

                for (let i = block.start - self.bpStart, j = 0; j < block.len; i++, j++) {

                    if (!self.coverage[i]) {
                        self.coverage[i] = new Coverage(self.threshold);
                    }

                    const base = (seq == undefined) ? "N" : seq.charAt(seqOffset + j);
                    const key = (alignment.strand) ? "pos" + base : "neg" + base;
                    const q = qual && seqOffset + j < qual.length ? qual[seqOffset + j] : 30;

                    self.coverage[i][key] += 1;
                    self.coverage[i]["qual" + base] += q;

                    self.coverage[i].total += 1;
                    self.coverage[i].qual += q;

                    self.maximum = Math.max(self.coverage[i].total, self.maximum);

                }
            }
        }
    }


    class Coverage {

        constructor(alleleThreshold) {

            this.qualityWeight = true;

            this.posA = 0;
            this.negA = 0;

            this.posT = 0;
            this.negT = 0;

            this.posC = 0;
            this.negC = 0;
            this.posG = 0;

            this.negG = 0;

            this.posN = 0;
            this.negN = 0;

            this.pos = 0;
            this.neg = 0;

            this.qualA = 0;
            this.qualT = 0;
            this.qualC = 0;
            this.qualG = 0;
            this.qualN = 0;

            this.qual = 0;

            this.total = 0;
            this.del = 0;
            this.ins = 0;

            this.threshold = alleleThreshold;
        }

        hoverText() {
            const pos = this.posA + this.posT + this.posC + this.posG + this.posN;
            const neg = this.negA + this.negT + this.negC + this.negG + this.negN;
            return `${this.total} (${pos}+, ${neg}-)`
        }

        isMismatch(refBase) {
            const threshold = this.threshold * ((this.qualityWeight && this.qual) ? this.qual : this.total);
            let mismatchQualitySum = 0;
            for (let base of ["A", "T", "C", "G"]) {
                if (base !== refBase) {
                    mismatchQualitySum += ((this.qualityWeight && this.qual) ? this["qual" + base] : (this["pos" + base] + this["neg" + base]));
                }
            }
            return mismatchQualitySum >= threshold
        }
    }

    class DownsampledInterval {

        constructor(start, end, counts) {
            this.start = start;
            this.end = end;
            this.counts = counts;
        }

        popupData(genomicLocation) {
            return [
                {name: "start", value: this.start + 1},
                {name: "end", value: this.end},
                {name: "# downsampled:", value: this.counts}]
        }
    }

    class SupplementaryAlignment {

        constructor(rec) {
            const tokens = rec.split(',');
            this.chr = tokens[0];
            this.start = parseInt(tokens[1]);
            this.strand = tokens[2].charAt(0);
            this.mapQ = parseInt(tokens[4]);
            this.numMismatches = parseInt(tokens[5]);
            this.lenOnRef = BamUtils.computeLengthOnReference(tokens[3]);
        }

        printString() {
            return this.chr + ":" + numberFormatter$1(this.start) + "-" + numberFormatter$1(this.start + this.lenOnRef)
                + " (" + this.strand + ") = " + numberFormatter$1(this.lenOnRef) + "bp @MAPQ: " + this.mapQ + " NM: " + this.numMismatches
        }
    }

    function createSupplementaryAlignments(str) {
        const tokens = str.split(';');
        return tokens.filter(t => t.length > 0).map(str => new SupplementaryAlignment(str))
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const READ_PAIRED_FLAG = 0x1;
    const PROPER_PAIR_FLAG = 0x2;
    const READ_UNMAPPED_FLAG = 0x4;
    const MATE_UNMAPPED_FLAG = 0x8;
    const READ_STRAND_FLAG$2 = 0x10;
    const MATE_STRAND_FLAG$2 = 0x20;
    const FIRST_OF_PAIR_FLAG = 0x40;
    const SECOND_OF_PAIR_FLAG = 0x80;
    const SECONDARY_ALIGNMNET_FLAG = 0x100;
    const READ_FAILS_VENDOR_QUALITY_CHECK_FLAG = 0x200;
    const DUPLICATE_READ_FLAG = 0x400;
    const SUPPLEMENTARY_ALIGNMENT_FLAG = 0x800;
    const ELEMENT_SIZE = {
        c: 1,
        C: 1,
        s: 2,
        S: 2,
        i: 4,
        I: 4,
        f: 4
    };

    const MAX_CIGAR = 50;

    /**
     * readName
     * chr
     * cigar
     * lengthOnRef
     * start
     * seq
     * qual
     * mq
     * strand
     * blocks
     */

    class BamAlignment {

        constructor() {
            this.hidden = false;
        }

        isMapped() {
            return (this.flags & READ_UNMAPPED_FLAG) === 0
        }

        isPaired() {
            return (this.flags & READ_PAIRED_FLAG) !== 0
        }

        isProperPair() {
            return (this.flags & PROPER_PAIR_FLAG) !== 0
        }

        isFirstOfPair() {
            return (this.flags & FIRST_OF_PAIR_FLAG) !== 0
        }

        isSecondOfPair() {
            return (this.flags & SECOND_OF_PAIR_FLAG) !== 0
        }

        isSecondary() {
            return (this.flags & SECONDARY_ALIGNMNET_FLAG) !== 0
        }

        isSupplementary() {
            return (this.flags & SUPPLEMENTARY_ALIGNMENT_FLAG) !== 0
        }

        isFailsVendorQualityCheck() {
            return (this.flags & READ_FAILS_VENDOR_QUALITY_CHECK_FLAG) !== 0
        }

        isDuplicate() {
            return (this.flags & DUPLICATE_READ_FLAG) !== 0
        }

        isMateMapped() {
            return (this.flags & MATE_UNMAPPED_FLAG) === 0
        }

        isNegativeStrand() {
            return (this.flags & READ_STRAND_FLAG$2) !== 0
        }

        isMateNegativeStrand() {
            return (this.flags & MATE_STRAND_FLAG$2) !== 0
        }

        hasTag(tag) {
            const tmpTags = this.tagDict || decodeTags(this.tagBA);
            return tmpTags.hasOwnProperty(tag)
        }

        tags() {
            if (!this.tagDict) {
                if (this.tagBA) {
                    this.tagDict = decodeTags(this.tagBA);
                    this.tagBA = undefined;
                } else {
                    this.tagDict = {};  // Mark so we don't try again.  The record has no tags
                }
            }
            return this.tagDict
        }

        /**
         * Does alignment (or alignment extended by soft clips) contain the genomic location?
         *
         * @param genomicLocation
         * @param showSoftClips
         * @returns {boolean|boolean}
         */
        containsLocation(genomicLocation, showSoftClips) {
            const s = showSoftClips ? this.scStart : this.start;
            const l = showSoftClips ? this.scLengthOnRef : this.lengthOnRef;
            return (genomicLocation >= s && genomicLocation <= (s + l))
        }

        popupData(genomicLocation) {

            // if the user clicks on a base next to an insertion, show just the
            // inserted bases in a popup (like in desktop IGV).
            const nameValues = [];

            // Consert genomic location to int
            genomicLocation = Math.floor(genomicLocation);

            if (this.insertions) {

                const seq = this.seq;

                for (let insertion of this.insertions) {
                    var ins_start = insertion.start;
                    if (genomicLocation === ins_start || genomicLocation === ins_start - 1) {
                        nameValues.push({name: 'Insertion', value: seq.substr(insertion.seqOffset, insertion.len)});
                        nameValues.push({name: 'Location', value: ins_start});
                        return nameValues
                    }
                }
            }

            nameValues.push({name: 'Read Name', value: this.readName});

            // Sample
            // Read group
            nameValues.push('<hr/>');

            // Add 1 to genomic location to map from 0-based computer units to user-based units
            nameValues.push({name: 'Alignment Start', value: numberFormatter$1(1 + this.start), borderTop: true});
            nameValues.push({name: 'Read Strand', value: (true === this.strand ? '(+)' : '(-)'), borderTop: true});

            // Abbreviate long cigar strings, keeping the beginning and end to show cliping
            let cigar = this.cigar;
            if (cigar && cigar.length > MAX_CIGAR) {
                const half = MAX_CIGAR / 2;
                cigar = `${cigar.substring(0, half - 2)} ... ${cigar.substring(cigar.length - half + 2)}`;
            }
            nameValues.push({name: 'Cigar', value: cigar});

            nameValues.push({name: 'Mapping Quality', value: this.mq});
            nameValues.push({name: 'Secondary', value: yesNo(this.isSecondary())});
            nameValues.push({name: 'Supplementary', value: yesNo(this.isSupplementary())});
            nameValues.push({name: 'Duplicate', value: yesNo(this.isDuplicate())});
            nameValues.push({name: 'Failed QC', value: yesNo(this.isFailsVendorQualityCheck())});

            if (this.isPaired()) {
                nameValues.push('<hr/>');
                nameValues.push({name: 'First in Pair', value: !this.isSecondOfPair(), borderTop: true});
                nameValues.push({name: 'Mate is Mapped', value: yesNo(this.isMateMapped())});
                if (this.pairOrientation) {
                    nameValues.push({name: 'Pair Orientation', value: this.pairOrientation});
                }
                if (this.isMateMapped()) {
                    nameValues.push({name: 'Mate Chromosome', value: this.mate.chr});
                    nameValues.push({name: 'Mate Start', value: (this.mate.position + 1)});
                    nameValues.push({name: 'Mate Strand', value: (true === this.mate.strand ? '(+)' : '(-)')});
                    nameValues.push({name: 'Insert Size', value: this.fragmentLength});
                    // Mate Start
                    // Mate Strand
                    // Insert Size
                }
                // First in Pair
                // Pair Orientation

            }

            const tagDict = this.tags();

            if (tagDict.hasOwnProperty('SA')) {
                nameValues.push('<hr/>');
                nameValues.push({name: 'Supplementary Alignments', value: ''});
                const sa = createSupplementaryAlignments(tagDict['SA']);
                if (sa) {
                    nameValues.push('<ul>');
                    for (let s of sa) {
                        nameValues.push(`<li>${s.printString()}</li>`);
                    }
                    nameValues.push('</ul>');
                }
            }

            const hiddenTags = new Set(['SA', 'MD']);
            nameValues.push('<hr/>');
            for (let key in tagDict) {
                if (!hiddenTags.has(key)) {
                    nameValues.push({name: key, value: tagDict[key]});
                }
            }

            nameValues.push({name: 'Hidden Tags', value: 'SA, MD'});

            nameValues.push('<hr/>');
            nameValues.push({name: 'Genomic Location: ', value: numberFormatter$1(1 + genomicLocation)});
            nameValues.push({name: 'Read Base:', value: this.readBaseAt(genomicLocation)});
            nameValues.push({name: 'Base Quality:', value: this.readBaseQualityAt(genomicLocation)});

            return nameValues


            function yesNo(bool) {
                return bool ? 'Yes' : 'No'
            }
        }

        readBaseAt(genomicLocation) {

            const block = blockAtGenomicLocation(this.blocks, genomicLocation);
            if (block) {
                if ("*" === this.seq) {
                    return "*"
                } else {
                    const idx = block.seqIndexAt(genomicLocation);
                    // if (idx >= 0 && idx < this.seq.length) {
                    return this.seq[idx]
                    //  }
                }
            } else {
                return undefined
            }
        }

        readBaseQualityAt(genomicLocation) {

            const block = blockAtGenomicLocation(this.blocks, genomicLocation);
            if (block) {
                if ("*" === this.qual) {
                    return 30
                } else {
                    const idx = block.seqIndexAt(genomicLocation);
                    if (idx >= 0 && this.qual && idx < this.qual.length) {
                        return this.qual[idx]
                    } else {
                        return 30
                    }
                }
            } else {
                return undefined
            }
        }

        gapSizeAt(genomicLocation) {
            if (this.gaps) {
                for (let gap of this.gaps) {
                    if (genomicLocation >= gap.start && genomicLocation < gap.start + gap.len) {
                        return gap.len
                    }
                }
            }
            return 0
        }

        /**
         * Return soft clipped blocks, if they exist, keyed by alignment end (left or right)
         */
        softClippedBlocks() {
            let left;
            let right;
            let interiorSeen;
            for(let b of this.blocks) {
                if('S' === b.type) {
                    if(interiorSeen) {
                        right = b;
                    } else {
                        left = b;
                    }
                } else if('H' !== b.type) {
                    interiorSeen = true;
                }
            }
            return {left, right}
        }

    }

    function blockAtGenomicLocation(blocks, genomicLocation) {

        for (let i = 0; i < blocks.length; i++) {
            const block = blocks[i];
            if (genomicLocation >= block.start && genomicLocation < block.start + block.len) {
                return block
            }
        }
        return undefined
    }

    function decodeTags(ba) {

        let p = 0;
        const len = ba.length;
        const tags = {};

        while (p < len) {
            const tag = String.fromCharCode(ba[p]) + String.fromCharCode(ba[p + 1]);
            p += 2;

            const type = String.fromCharCode(ba[p++]);
            let value;
            if (type === 'A') {
                value = String.fromCharCode(ba[p]);
                p++;
            } else if (type === 'i' || type === 'I') {
                value = readInt$1(ba, p);
                p += 4;
            } else if (type === 'c') {
                value = readInt8(ba, p);
                p++;
            } else if (type === 'C') {
                value = readUInt8(ba, p);
                p++;
            } else if (type === 's' || type === 'S') {
                value = readShort(ba, p);
                p += 2;
            } else if (type === 'f') {
                value = readFloat(ba, p);
                p += 4;
            } else if (type === 'Z') {
                value = '';
                for (; ;) {
                    var cc = ba[p++];
                    if (cc === 0) {
                        break
                    } else {
                        value += String.fromCharCode(cc);
                    }
                }
            } else if (type === 'B') {
                const elementType = String.fromCharCode(ba[p++]);
                let elementSize = ELEMENT_SIZE[elementType];
                if (elementSize === undefined) {
                    tags[tag] = `Error: unknown element type '${elementType}'`;
                    break
                }
                const numElements = readInt$1(ba, p);
                p += (4 + numElements * elementSize);
                value = '[not shown]';
            } else {
                //'Unknown type ' + type;
                value = 'Error unknown type: ' + type;
                tags[tag] = value;
                break
            }
            tags[tag] = value;
        }
        return tags
    }


    function readInt$1(ba, offset) {
        return (ba[offset + 3] << 24) | (ba[offset + 2] << 16) | (ba[offset + 1] << 8) | (ba[offset])
    }

    function readShort(ba, offset) {
        return (ba[offset + 1] << 8) | (ba[offset])
    }

    function readFloat(ba, offset) {
        const dataView = new DataView(ba.buffer);
        return dataView.getFloat32(offset)
    }

    function readInt8(ba, offset) {
        const dataView = new DataView(ba.buffer);
        return dataView.getInt8(offset)
    }

    function readUInt8(ba, offset) {
        const dataView = new DataView(ba.buffer);
        return dataView.getUint8(offset)
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    /**
     * Created by jrobinso on 4/5/18.
     */


    class AlignmentBlock {
        constructor(b) {
            if (b) {
                Object.assign(this, b);
            }
        }

        seqIndexAt(genomicLocation) {
            return Math.floor(genomicLocation) - this.start + this.seqOffset
        }
    }

    class BamFilter {
        constructor(options) {
            if (!options) options = {};
            this.vendorFailed = options.vendorFailed === undefined ? true : options.vendorFailed;
            this.duplicates = options.duplicates === undefined ? true : options.duplicates;
            this.secondary = options.secondary || false;
            this.supplementary = options.supplementary || false;
            this.mqThreshold = options.mqThreshold === undefined ? 0 : options.mqThreshold;
            if (options.readgroups) {
                this.readgroups = new Set(options.readgroups);
            }
        }

        pass(alignment) {
            if (this.vendorFailed && alignment.isFailsVendorQualityCheck()) return false
            if (this.duplicates && alignment.isDuplicate()) return false
            if (this.secondary && alignment.isSecondary()) return false
            if (this.supplementary && alignment.isSupplementary()) return false
            if (alignment.mq < this.mqThreshold) return false
            if (this.readgroups) {
                var rg = alignment.tags()['RG'];
                return this.readgroups.has(rg)
            }
            return true
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */


    /**
     * This code is based on the Biodalliance BAM reader by Thomas Down,  2011
     *
     * https://github.com/dasmoth/dalliance/blob/master/js/bam.js
     */

    const SEQ_DECODER = ['=', 'A', 'C', 'x', 'G', 'x', 'x', 'x', 'T', 'x', 'x', 'x', 'x', 'x', 'x', 'N'];
    const CIGAR_DECODER = ['M', 'I', 'D', 'N', 'S', 'H', 'P', '=', 'X', '?', '?', '?', '?', '?', '?', '?'];
    const READ_STRAND_FLAG$1 = 0x10;
    const MATE_STRAND_FLAG$1 = 0x20;

    const BAM1_MAGIC_BYTES = new Uint8Array([0x42, 0x41, 0x4d, 0x01]); // BAM\1
    const BAM1_MAGIC_NUMBER = readInt(BAM1_MAGIC_BYTES, 0);

    const DEFAULT_ALLELE_FREQ_THRESHOLD = 0.2;
    const DEFAULT_SAMPLING_WINDOW_SIZE = 100;
    const DEFAULT_SAMPLING_DEPTH = 500;
    const MAXIMUM_SAMPLING_DEPTH = 10000;

    const BamUtils = {

        readHeader: function (url, options, genome) {

            return igvxhr.loadArrayBuffer(url, options)

                .then(function (compressedBuffer) {

                    var header, unc, uncba;

                    unc = unbgzf(compressedBuffer);
                    uncba = unc;

                    header = BamUtils.decodeBamHeader(uncba, genome);

                    return header

                })

        },

        /**
         *
         * @param ba  bytes to decode as a UInt8Array
         * @param genome  optional igv genome object
         * @returns {{ magicNumer: number, size: number, chrNames: Array, chrToIndex: ({}|*), chrAliasTable: ({}|*) }}
         */
        decodeBamHeader: function (ba, genome) {

            var magic, samHeaderLen, samHeader, chrToIndex, chrNames, chrAliasTable, alias;

            magic = readInt(ba, 0);
            if (magic !== BAM1_MAGIC_NUMBER) {
                throw new Error('BAM header errror: bad magic number.  This could be caused by either a corrupt or missing file.')
            }

            samHeaderLen = readInt(ba, 4);
            samHeader = '';

            for (var i = 0; i < samHeaderLen; ++i) {
                samHeader += String.fromCharCode(ba[i + 8]);
            }

            var nRef = readInt(ba, samHeaderLen + 8);
            var p = samHeaderLen + 12;

            chrToIndex = {};
            chrNames = [];
            chrAliasTable = {};

            for (i = 0; i < nRef; ++i) {
                var lName = readInt(ba, p);
                var name = '';
                for (var j = 0; j < lName - 1; ++j) {
                    name += String.fromCharCode(ba[p + 4 + j]);
                }
                readInt(ba, p + lName + 4);
                //dlog(name + ': ' + lRef);

                chrToIndex[name] = i;
                chrNames[i] = name;

                if (genome) {
                    alias = genome.getChromosomeName(name);
                    chrAliasTable[alias] = name;
                }

                p = p + 8 + lName;
            }

            return {
                magicNumber: magic,
                size: p,
                chrNames: chrNames,
                chrToIndex: chrToIndex,
                chrAliasTable: chrAliasTable
            }

        },

        bam_tag2cigar: function (ba, block_end, seq_offset, lseq, al, cigarArray) {

            function type2size(x) {
                if (x === 'C' || x === 'c' || x === 'A') return 1
                else if (x === 'S' || x === 's') return 2
                else if (x === 'I' || x === 'i' || x === 'f') return 4
                else return 0
            }

            // test if the real CIGAR is encoded in a CG:B,I tag
            if (cigarArray.length !== 1 || al.start < 0) return false
            var p = seq_offset + ((lseq + 1) >> 1) + lseq;
            while (p + 4 < block_end) {
                var tag = String.fromCharCode(ba[p]) + String.fromCharCode(ba[p + 1]);
                if (tag === 'CG') break
                var type = String.fromCharCode(ba[p + 2]);
                if (type === 'B') { // the binary array type
                    type = String.fromCharCode(ba[p + 3]);
                    var size = type2size(type);
                    var len = readInt(ba, p + 4);
                    p += 8 + size * len;
                } else if (type === 'Z' || type === 'H') { // 0-terminated string
                    p += 3;
                    while (ba[p++] !== 0) {
                    }
                } else { // other atomic types
                    p += 3 + type2size(type);
                }
            }
            if (p >= block_end) return false // no CG tag
            if (String.fromCharCode(ba[p + 2]) !== 'B' || String.fromCharCode(ba[p + 3]) !== 'I') return false // not of type B,I

            // now we know the real CIGAR length and its offset in the binary array
            var cigar_len = readInt(ba, p + 4);
            var cigar_offset = p + 8; // 4 for "CGBI" and 4 for length
            if (cigar_offset + cigar_len * 4 > block_end) return false // out of bound

            // decode CIGAR
            var cigar = '';
            var lengthOnRef = 0;
            cigarArray.length = 0; // empty the old array
            p = cigar_offset;
            for (var k = 0; k < cigar_len; ++k, p += 4) {
                var cigop = readInt(ba, p);
                var opLen = (cigop >> 4);
                var opLtr = CIGAR_DECODER[cigop & 0xf];
                if (opLtr === 'M' || opLtr === 'EQ' || opLtr === 'X' || opLtr === 'D' || opLtr === 'N' || opLtr === '=')
                    lengthOnRef += opLen;
                cigar = cigar + opLen + opLtr;
                cigarArray.push({len: opLen, ltr: opLtr});
            }

            // update alignment record. We are not updating bin, as apparently it is not used.
            al.cigar = cigar;
            al.lengthOnRef = lengthOnRef;
            return true
        },

        /**
         *
         * @param ba                 bytes to decode as an UInt8Array
         * @param offset             offset position of ba array to start decoding
         * @param alignmentContainer container to receive the decoded alignments
         * @param min                minimum genomic position
         * @param max                maximum genomic position
         * @param chrIdx             chromosome index
         * @param chrNames            array of chromosome names
         * @param filter             a BamFilter object
         *
         * @return true if we have moved beyond the right end of the genomic range.
         */
        decodeBamRecords: function (ba, offset, alignmentContainer, chrNames, chrIdx, min, max, filter) {

            while (offset < ba.length) {

                const blockSize = readInt(ba, offset);
                const blockEnd = offset + blockSize + 4;
                const alignment = new BamAlignment();
                const refID = readInt(ba, offset + 4);
                const pos = readInt(ba, offset + 8);

                if (blockEnd > ba.length) {
                    return
                }
                if (refID < 0) {
                    offset = blockEnd;
                    continue   // unmapped read
                } else if (chrIdx !== undefined && (refID > chrIdx || pos > max)) {
                    return true    // off right edge, we're done
                } else if (chrIdx !== undefined && (refID < chrIdx)) {
                    offset = blockEnd;
                    continue   // ref ID to left of start, not sure this is possible
                }

                const bin_mq_nl = readInt(ba, offset + 12);
                const mq = (bin_mq_nl & 0xff00) >> 8;
                const nl = bin_mq_nl & 0xff;

                const flag_nc = readInt(ba, offset + 16);
                const flag = (flag_nc & 0xffff0000) >> 16;
                const nc = flag_nc & 0xffff;

                const lseq = readInt(ba, offset + 20);
                const mateChrIdx = readInt(ba, offset + 24);
                const matePos = readInt(ba, offset + 28);
                const fragmentLength = readInt(ba, offset + 32);

                let readName = [];
                for (let j = 0; j < nl - 1; ++j) {
                    readName.push(String.fromCharCode(ba[offset + 36 + j]));
                }
                readName = readName.join('');

                let lengthOnRef = 0;
                let cigar = '';
                let p = offset + 36 + nl;
                const cigarArray = [];
                // concatenate M,=,EQ,and X

                let lastCigRecord;
                for (let c = 0; c < nc; ++c) {
                    var cigop = readInt(ba, p);
                    var opLen = (cigop >> 4);
                    var opLtr = CIGAR_DECODER[cigop & 0xf];
                    if (opLtr === 'M' || opLtr === 'EQ' || opLtr === 'X' || opLtr === 'D' || opLtr === 'N' || opLtr === '=')
                        lengthOnRef += opLen;
                    cigar = cigar + opLen + opLtr;
                    p += 4;

                    // if(mOperators.has(opLtr) && mOperators.has(lastCigRecord.ltr)) {
                    //     lastCigRecord.len += opLen;
                    //     lastCigRecord.ltr = 'M'
                    // }
                    // else {
                    lastCigRecord = {len: opLen, ltr: opLtr};
                    cigarArray.push(lastCigRecord);
                    //}
                }

                alignment.chr = chrNames[refID];
                alignment.start = pos;
                alignment.flags = flag;
                alignment.strand = !(flag & READ_STRAND_FLAG$1);
                alignment.readName = readName;
                alignment.cigar = cigar;
                alignment.lengthOnRef = lengthOnRef;
                alignment.fragmentLength = fragmentLength;
                alignment.mq = mq;

                BamUtils.bam_tag2cigar(ba, blockEnd, p, lseq, alignment, cigarArray);

                alignment.end = alignment.start + alignment.lengthOnRef;

                if (alignment.end < min) {
                    offset = blockEnd;
                    continue
                }  // Record out-of-range "to the left", skip to next one


                let seq = [];
                const seqBytes = (lseq + 1) >> 1;
                for (let j = 0; j < seqBytes; ++j) {
                    var sb = ba[p + j];
                    seq.push(SEQ_DECODER[(sb & 0xf0) >> 4]);
                    seq.push(SEQ_DECODER[(sb & 0x0f)]);
                }
                seq = seq.slice(0, lseq).join('');  // seq might have one extra character (if lseq is an odd number)
                p += seqBytes;


                const qualArray = [];
                for (let j = 0; j < lseq; ++j) {
                    qualArray.push(ba[p + j]);
                }
                p += lseq;

                if (mateChrIdx >= 0) {
                    alignment.mate = {
                        chr: chrNames[mateChrIdx],
                        position: matePos,
                        strand: !(flag & MATE_STRAND_FLAG$1)
                    };
                }

                alignment.seq = seq;
                alignment.qual = qualArray;
                alignment.tagBA = new Uint8Array(ba.buffer.slice(p, blockEnd));  // decode these on demand

                this.setPairOrientation(alignment);

                if ((undefined === filter || filter.pass(alignment))) {
                    makeBlocks(alignment, cigarArray);
                    alignmentContainer.push(alignment);
                }
                offset = blockEnd;
            }
        },

        decodeSamRecords: function (sam, alignmentContainer, chr, min, max, filter) {

            var lines, i, j, len, tokens, qualString, rnext, lengthOnRef,
                alignment, cigarArray, started;

            lines = splitLines$5(sam);
            len = lines.length;
            started = false;

            for (i = 0; i < len; i++) {

                tokens = lines[i].split('\t');

                alignment = new BamAlignment();

                alignment.chr = tokens[2];
                alignment.start = Number.parseInt(tokens[3]) - 1;
                alignment.flags = Number.parseInt(tokens[1]);
                alignment.readName = tokens[0];
                alignment.strand = !(alignment.flags & READ_STRAND_FLAG$1);
                alignment.mq = Number.parseInt(tokens[4]);
                alignment.cigar = tokens[5];
                alignment.fragmentLength = Number.parseInt(tokens[8]);
                alignment.seq = tokens[9];

                if (alignment.chr === '*' || !alignment.isMapped()) continue  // Unmapped

                if (alignment.chr !== chr) {
                    if (started) break // Off the right edge, we're done
                    else continue // Possibly to the left, skip but keep looping
                } else if (alignment.start > max) {
                    break    // off right edge, we're done
                }

                lengthOnRef = 0;
                cigarArray = buildOperators(alignment.cigar);
                cigarArray.forEach(function (op) {
                    var opLen = op.len;
                    var opLtr = op.ltr;
                    if (opLtr === 'M' || opLtr === 'EQ' || opLtr === 'X' || opLtr === 'D' || opLtr === 'N' || opLtr === '=')
                        lengthOnRef += opLen;
                });
                alignment.lengthOnRef = lengthOnRef;
                // TODO for lh3: parse the CG:B,I tag in SAM here

                if (alignment.start + lengthOnRef < min) {
                    continue    // To the left, skip and continue
                }


                qualString = tokens[10];
                alignment.qual = [];
                for (j = 0; j < qualString.length; j++) {
                    alignment.qual[j] = qualString.charCodeAt(j) - 33;
                }
                alignment.tagDict = tokens.length < 11 ? {} : decodeSamTags(tokens.slice(11));

                if (alignment.isMateMapped()) {
                    rnext = tokens[6];
                    alignment.mate = {
                        chr: (rnext === '=') ? alignment.chr : rnext,
                        position: Number.parseInt(tokens[7]),
                        strand: !(alignment.flags & MATE_STRAND_FLAG$1)
                    };
                }

                this.setPairOrientation(alignment);

                if (undefined === filter || filter.pass(alignment)) {
                    makeBlocks(alignment, cigarArray);
                    alignmentContainer.push(alignment);
                }
            }
        },

        setReaderDefaults: function (reader, config) {

            reader.filter = new BamFilter(config.filter);

            if (config.readgroup) {
                reader.filter.readgroups = new Set([config.readgroup]);
            }

            reader.alleleFreqThreshold = config.alleleFreqThreshold === undefined ? DEFAULT_ALLELE_FREQ_THRESHOLD : config.alleleFreqThreshold;

            reader.samplingWindowSize = config.samplingWindowSize === undefined ? DEFAULT_SAMPLING_WINDOW_SIZE : config.samplingWindowSize;
            reader.samplingDepth = config.samplingDepth === undefined ? DEFAULT_SAMPLING_DEPTH : config.samplingDepth;

            if (reader.samplingDepth > MAXIMUM_SAMPLING_DEPTH) {
                console.log("Warning: attempt to set sampling depth > maximum value of " + MAXIMUM_SAMPLING_DEPTH);
                reader.samplingDepth = MAXIMUM_SAMPLING_DEPTH;
            }

            if (config.viewAsPairs) {
                reader.pairsSupported = true;
            } else {
                reader.pairsSupported = config.pairsSupported === undefined ? true : config.pairsSupported;
            }
        },

        setPairOrientation: function (alignment) {

            if (alignment.isMapped() && alignment.mate && alignment.isMateMapped() && alignment.mate.chr === alignment.chr) {
                var s1 = alignment.strand ? 'F' : 'R';

                var mate = alignment.mate;
                var s2 = mate.strand ? 'F' : 'R';
                var o1 = ' ';
                var o2 = ' ';
                if (alignment.isFirstOfPair()) {
                    o1 = '1';
                    o2 = '2';
                } else if (alignment.isSecondOfPair()) {
                    o1 = '2';
                    o2 = '1';
                }

                var tmp = [];
                var isize = alignment.fragmentLength;
                var estReadLen = alignment.end - alignment.start;
                if (isize === 0) {
                    //isize not recorded.  Need to estimate.  This calculation was validated against an Illumina
                    // -> <- library bam.
                    var estMateEnd = alignment.start < mate.position ?
                        mate.position + estReadLen : mate.position - estReadLen;
                    isize = estMateEnd - alignment.start;
                }

                //if (isize > estReadLen) {
                if (isize > 0) {
                    tmp[0] = s1;
                    tmp[1] = o1;
                    tmp[2] = s2;
                    tmp[3] = o2;

                } else {
                    tmp[2] = s1;
                    tmp[3] = o1;
                    tmp[0] = s2;
                    tmp[1] = o2;
                }
                // }
                alignment.pairOrientation = tmp.join('');
            }
        },

        computeLengthOnReference: function (cigarString) {

            let len = 0;
            let buf = '';

            for (let i = 0; i < cigarString.length; i++) {
                const c = cigarString.charCodeAt(i);
                if (c > 47 && c < 58) {
                    buf += cigarString.charAt(i);
                } else {
                    switch (c) {
                        case 78:  // N
                        case 68:  // D
                        case 77:  // M
                        case 61:  // =
                        case 88:  // X
                            len += parseInt(buf.toString());
                    }
                    buf = '';
                }
            }
            return len
        }
    };


    /**
     * Split the alignment record into blocks as specified in the cigarArray.  Each aligned block contains
     * its portion of the read sequence and base quality strings.  A read sequence or base quality string
     * of "*" indicates the value is not recorded.  In all other cases the length of the block sequence (block.seq)
     * and quality string (block.qual) must == the block length.
     *
     * @param alignment
     * @param cigarArray
     * @returns array of blocks
     */
    function makeBlocks(alignment, cigarArray) {

        const blocks = [];

        let insertions;
        let gaps;
        let seqOffset = 0;
        let pos = alignment.start;

        alignment.scStart = alignment.start;
        alignment.scLengthOnRef = alignment.lengthOnRef;

        for (let c of cigarArray) {

            let scPos;
            switch (c.ltr) {
                case 'H' :
                    break // ignore hard clips
                case 'P' :
                    break // ignore pads
                case 'S' :

                    scPos = pos;
                    alignment.scLengthOnRef += c.len;
                    if (blocks.length === 0) {
                        alignment.scStart -= c.len;
                        scPos -= c.len;
                    }
                    blocks.push(new AlignmentBlock({
                        start: scPos,
                        seqOffset: seqOffset,
                        len: c.len,
                        type: 'S'
                    }));
                    seqOffset += c.len;
                    break // soft clip read bases
                case 'N' :
                case 'D':
                    if (gaps === undefined) {
                        gaps = [];
                    }
                    gaps.push({
                        start: pos,
                        len: c.len,
                        type: c.ltr
                    });
                    pos += c.len;
                    break
                case 'I' :

                    if (insertions === undefined) {
                        insertions = [];
                    }
                    insertions.push(new AlignmentBlock({
                        start: pos,
                        len: c.len,
                        seqOffset: seqOffset,
                        type: 'I'
                    }));
                    seqOffset += c.len;
                    break
                case 'M' :
                case 'EQ' :
                case '=' :
                case 'X' :
                    blocks.push(new AlignmentBlock({
                        start: pos,
                        seqOffset: seqOffset,
                        len: c.len,
                        type: 'M'
                    }));
                    seqOffset += c.len;
                    pos += c.len;

                    break

                default :
                    console.log('Error processing cigar element: ' + c.len + c.ltr);
            }
        }

        alignment.blocks = blocks;
        alignment.insertions = insertions;
        alignment.gaps = gaps;

    }

    function readInt(ba, offset) {
        return (ba[offset + 3] << 24) | (ba[offset + 2] << 16) | (ba[offset + 1] << 8) | (ba[offset])
    }

    /**
     * Build a list of cigar operators from a cigarString.  Removes padding operators and concatenates consecutive
     * operators of the same type
     *
     * @param cigarString
     * @return
     */
    function buildOperators(cigarString) {

        var operators, buffer, i, len, prevOp, next, op, nBases;

        operators = [];
        buffer = [];

        // Create list of cigar operators
        prevOp = null;
        len = cigarString.length;
        for (i = 0; i < len; i++) {
            next = cigarString.charAt(i);
            if (isDigit(next)) {
                buffer.push(next);
            } else {
                op = next;
                nBases = Number.parseInt(buffer.join(''));
                buffer = [];

                if (prevOp !== null && prevOp.ltr === op) {
                    prevOp.len += nBases;
                } else {
                    prevOp = {len: nBases, ltr: op};
                    operators.push(prevOp);
                }
            }
        }
        return operators

    }

    function isDigit(a) {
        var charCode = a.charCodeAt(0);
        return (charCode >= 48 && charCode <= 57) // 0-9
    }

    function decodeSamTags(tags) {

        var tagDict = {};
        tags.forEach(function (tag) {
            var tokens = tag.split(':');
            tagDict[tokens[0]] = tokens[2];
        });

        return tagDict
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    /**
     * Class for reading a bam file
     *
     * @param config
     * @constructor
     */
    class BamReaderNonIndexed {

        constructor(config, genome) {
            this.config = config;
            this.genome = genome;
            this.bamPath = config.url;
            this.isDataUri = isDataURL(config.url);
            BamUtils.setReaderDefaults(this, config);
        }

        // Return an alignment container
        async readAlignments(chr, bpStart, bpEnd) {

            if (this.alignmentCache) {
                const header = this.header;
                const queryChr = header.chrAliasTable.hasOwnProperty(chr) ? header.chrAliasTable[chr] : chr;
                const qAlignments = this.alignmentCache.queryFeatures(queryChr, bpStart, bpEnd);
                const alignmentContainer = new AlignmentContainer(chr, bpStart, bpEnd, this.config);
                for (let a of qAlignments) {
                    alignmentContainer.push(a);
                }
                alignmentContainer.finish();
                return alignmentContainer

            } else {
                if (this.isDataUri) {
                    const data = decodeDataURI(this.bamPath);
                    const unc = unbgzf(data.buffer);
                    this.parseAlignments(unc);
                    return this.fetchAlignments(chr, bpStart, bpEnd)
                } else {
                    const arrayBuffer = await igvxhr.loadArrayBuffer(this.bamPath, buildOptions(this.config));
                    const unc = unbgzf(arrayBuffer);
                    this.parseAlignments(unc);
                    return this.fetchAlignments(chr, bpStart, bpEnd)
                }
            }

        }

        parseAlignments(data) {
            const alignments = [];
            this.header = BamUtils.decodeBamHeader(data);
            BamUtils.decodeBamRecords(data, this.header.size, alignments, this.header.chrNames);
            this.alignmentCache = new FeatureCache$1(alignments, this.genome);
        }

        fetchAlignments(chr, bpStart, bpEnd) {
            const queryChr = this.header.chrAliasTable.hasOwnProperty(chr) ? this.header.chrAliasTable[chr] : chr;
            const features = this.alignmentCache.queryFeatures(queryChr, bpStart, bpEnd);
            const alignmentContainer = new AlignmentContainer(chr, bpStart, bpEnd, this.config);
            for (let feature of features) {
                alignmentContainer.push(feature);
            }
            alignmentContainer.finish();
            return alignmentContainer
        }

    }

    function decodeDataURI(dataURI) {

        const split = dataURI.split(',');
        const info = split[0].split(':')[1];
        let dataString = split[1];

        if (info.indexOf('base64') >= 0) {
            dataString = atob(dataString);
        } else {
            dataString = decodeURI(dataString);
        }

        const bytes = new Uint8Array(dataString.length);
        for (var i = 0; i < dataString.length; i++) {
            bytes[i] = dataString.charCodeAt(i);
        }
        return bytes
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    /**
     * Class for reading a bam file
     *
     * @param config
     * @constructor
     */
    class BamReader {

        constructor(config, genome) {
            this.config = config;
            this.genome = genome;
            this.bamPath = config.url;
            this.baiPath = config.indexURL;
            BamUtils.setReaderDefaults(this, config);

            this._blockLoader = new BGZBlockLoader(config);
        }

        async readAlignments(chr, bpStart, bpEnd) {

            const chrToIndex = await this.getChrIndex();
            const queryChr = this.chrAliasTable.hasOwnProperty(chr) ? this.chrAliasTable[chr] : chr;
            const chrId = chrToIndex[queryChr];
            const alignmentContainer = new AlignmentContainer(chr, bpStart, bpEnd, this.config);

            if (chrId === undefined) {
                return alignmentContainer

            } else {

                const bamIndex = await this.getIndex();
                const chunks = bamIndex.chunksForRange(chrId, bpStart, bpEnd);

                if (!chunks || chunks.length === 0) {
                    return alignmentContainer
                }

                for (let c of chunks) {
                    const ba = await this._blockLoader.getData(c.minv, c.maxv);
                    const done = BamUtils.decodeBamRecords(ba, c.minv.offset, alignmentContainer, this.indexToChr, chrId, bpStart, bpEnd, this.filter);
                    if (done) {
                        break
                    }
                }
                alignmentContainer.finish();
                return alignmentContainer
            }
        }

        async getHeader() {
            if (!this.header) {
                const genome = this.genome;
                const index = await this.getIndex();
                let len;
                if (index.firstBlockPosition) {
                    const bsizeOptions = buildOptions(this.config, {range: {start: index.firstBlockPosition, size: 26}});
                    const abuffer = await igvxhr.loadArrayBuffer(this.bamPath, bsizeOptions);
                    const bsize = bgzBlockSize$1(abuffer);
                    len = index.firstBlockPosition + bsize;   // Insure we get the complete compressed block containing the header
                } else {
                    len = 64000;
                }

                const options = buildOptions(this.config, {range: {start: 0, size: len}});
                this.header = await BamUtils.readHeader(this.bamPath, options, genome);
            }
            return this.header
        }

        async getIndex() {
            const genome = this.genome;
            if (!this.index) {
                this.index = await loadIndex(this.baiPath, this.config, genome);
            }
            return this.index
        }

        async getChrIndex() {
            if (this.chrToIndex) {
                return this.chrToIndex
            } else {
                const header = await this.getHeader();
                this.chrToIndex = header.chrToIndex;
                this.indexToChr = header.chrNames;
                this.chrAliasTable = header.chrAliasTable;
                return this.chrToIndex

            }
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class ShardedBamReader {

        constructor(config, genome) {

            this.config = config;
            this.genome = genome;

            const bamReaders = {};

            config.sources.sequences.forEach(function (chr) {
                const queryChr = genome ? genome.getChromosomeName(chr) : chr;
                bamReaders[queryChr] = getReader(config, genome, chr);
            });

            this.bamReaders = bamReaders;

            BamUtils.setReaderDefaults(this, config);
        }

        async readAlignments(chr, start, end) {

            if (!this.bamReaders.hasOwnProperty(chr)) {
                return new AlignmentContainer(chr, start, end, this.config)
            } else {

                let reader = this.bamReaders[chr];
                const a = await reader.readAlignments(chr, start, end);
                return a
            }
        }
    }

    function getReader(config, genome, chr) {
        const tmp = {
            url: config.sources.url.replace("$CHR", chr)
        };
        if (config.sources.indexURL) {
            tmp.indexURL = config.sources.indexURL.replace("$CHR", chr);
        }
        const bamConfig = Object.assign(config, tmp);

        // TODO -- support non-indexed, htsget, etc
        return new BamReader(bamConfig, genome)
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    /**
     * Class for reading bam records from an igv.js-flask server backed by pysam.  Deprecated.
     *
     * @param config
     * @constructor
     */
    const BamWebserviceReader = function (config, genome) {

        this.config = config;
        this.genome = genome;
        BamUtils.setReaderDefaults(this, config);

    };

    // Example http://localhost:5000/alignments/?reference=/Users/jrobinso/hg19mini.fa&file=/Users/jrobinso/cram_with_crai_index.cram&region=1:100-2000

    BamWebserviceReader.prototype.readAlignments = function (chr, bpStart, bpEnd) {

        var self = this;

        return getHeader.call(self)

            .then(function (header) {

                var queryChr, url;

                queryChr = header.chrAliasTable.hasOwnProperty(chr) ? header.chrAliasTable[chr] : chr;

                url = self.config.url +
                    "?reference=" + self.config.referenceFile +
                    "&file=" + self.config.alignmentFile + "" +
                    "&region=" + queryChr + ":" + bpStart + "-" + bpEnd;


                return igvxhr.loadString(url, buildOptions(self.config))

                    .then(function (sam) {

                        var alignmentContainer;

                        header.chrToIndex[queryChr];

                        alignmentContainer = new AlignmentContainer(chr, bpStart, bpEnd, self.config);

                        BamUtils.decodeSamRecords(sam, alignmentContainer, queryChr, bpStart, bpEnd, self.filter);

                        return alignmentContainer

                    })

            })
    };


    // Example  http://localhost:5000/alignments/?reference=/Users/jrobinso/hg19mini.fa&file=/Users/jrobinso/cram_with_crai_index.cram&options=-b%20-H
    function getHeader() {

        const self = this;
        const genome = this.genome;

        if (this.header) {

            return Promise.resolve(this.header)

        } else {

            const url = this.config.url + "?file=" + this.config.alignmentFile + "&options=-b,-H";
            const options = buildOptions(this.config);

            return BamUtils.readHeader(url, options, genome)

                .then(function (header) {

                    self.header = header;
                    return header

                })
        }

    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class HtsgetBamReader extends HtsgetReader {

        constructor(config, genome) {
            super(config, genome);
            BamUtils.setReaderDefaults(this, config);
        }


        async readAlignments(chr, start, end) {

            if (!this.header) {
                const compressedData = await this.readHeaderData();
                const ba = unbgzf(compressedData.buffer);
                this.header = BamUtils.decodeBamHeader(ba, this.genome);
                this.chrAliasTable = new Map();
                for (let key of Object.keys(this.header.chrAliasTable)) {
                    this.chrAliasTable.set(key, this.header.chrAliasTable[key]);
                }
            }

            let queryChr = this.chrAliasTable.has(chr) ? this.chrAliasTable.get(chr) : chr;

            const compressedData = await this.readData(queryChr, start, end);

            // BAM decoding
            const ba = unbgzf(compressedData.buffer);

            const chrIdx = this.header.chrToIndex[chr];
            const alignmentContainer = new AlignmentContainer(chr, start, end, this.config);
            BamUtils.decodeBamRecords(ba, this.header.size, alignmentContainer, this.header.chrNames, chrIdx, start, end);
            alignmentContainer.finish();

            return alignmentContainer

        }

    }

    /*! For license information please see cram-bundle.js.LICENSE.txt */
    const fn = ()=>{var e={368:function(e,t,r){var n=this&&this.__awaiter||function(e,t,r,n){return new(r||(r=Promise))((function(i,o){function s(e){try{f(n.next(e));}catch(e){o(e);}}function a(e){try{f(n.throw(e));}catch(e){o(e);}}function f(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t);}))).then(s,a);}f((n=n.apply(e,t||[])).next());}))},i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const o=i(r(4105)),s=i(r(1269)),a=r(597),f=r(3427),h=r(8577);function l(e,t){if(t.some((e=>void 0===e)))throw new h.CramMalformedError("invalid .crai index file");const[r,n,i,o,s,a]=t;e[r]||(e[r]=[]),e[r].push({start:n,span:i,containerStart:o,sliceStart:s,sliceBytes:a});}t.default=class{constructor(e){this.filehandle=(0, f.open)(e.url,e.path,e.filehandle),this._parseCache=new o.default({cache:new s.default({maxSize:1}),fill:(e,t)=>this.parseIndex()});}parseIndex(){const e={};return this.filehandle.readFile().then((e=>31===e[0]&&139===e[1]?(0, a.unzip)(e):e)).then((t=>{if(t.length>4&&21578050===t.readUInt32LE(0))throw new h.CramMalformedError("invalid .crai index file. note: file appears to be a .bai index. this is technically legal but please open a github issue if you need support");let r=[],n="";for(let i=0;i<t.length;i+=1){const o=t[i];if(o>=48&&o<=57||!n&&45===o)n+=String.fromCharCode(o);else if(9===o)r.push(Number.parseInt(n,10)),n="";else if(10===o)r.push(Number.parseInt(n,10)),n="",l(e,r),r=[];else if(13!==o&&32!==o)throw new h.CramMalformedError("invalid .crai index file")}return n&&r.push(Number.parseInt(n,10)),6===r.length&&l(e,r),Object.entries(e).forEach((([t,r])=>{e[t]=r.sort(((e,t)=>e.start-t.start||e.span-t.span));})),e}))}getIndex(e={}){return this._parseCache.get("index",null,e.signal)}hasDataForReferenceSequence(e){return n(this,void 0,void 0,(function*(){return !!(yield this.getIndex())[e]}))}getEntriesForRange(e,t,r){return n(this,void 0,void 0,(function*(){const n=(yield this.getIndex())[e];if(!n)return [];const i=e=>{const n=e.start,i=e.start+e.span;return n>r?-1:i<=t?1:0},o=[];for(let e=0;e<n.length;e+=1)0===i(n[e])&&o.push(n[e]);return o}))}};},1050:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.default=class{constructor(e,t){this.parameters=e,this.dataType=t;}};},4863:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const i=r(8577),o=n(r(1050)),s=r(1074);class a extends o.default{constructor(e,t){if(super(e,t),"int"!==this.dataType)throw new i.CramUnimplementedError(`${this.dataType} decoding not yet implemented by BETA codec`)}decode(e,t,r,n){return (0, s.getBits)(t.content,n.coreBlock,this.parameters.length)-this.parameters.offset}}t.default=a;},1738:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const i=r(9488),o=n(r(1050));class s extends o.default{constructor(e,t,r){if(super(e,t),this.instantiateCodec=r,"byteArray"!==t)throw new TypeError(`byteArrayLength does not support data type ${t}`)}decode(e,t,r,n){const i=this._getLengthCodec().decode(e,t,r,n),o=this._getDataCodec(),s=new Uint8Array(i);for(let a=0;a<i;a+=1)s[a]=o.decode(e,t,r,n);return s}_getLengthCodec(){const e=this.parameters.lengthsEncoding;return this.instantiateCodec(e,"int")}_getDataCodec(){const e=this.parameters.valuesEncoding;return this.instantiateCodec(e,"byte")}}t.default=s,"_getLengthCodec _getDataCodec".split(" ").forEach((e=>(0, i.tinyMemoize)(s,e)));},1405:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const i=r(8577),o=n(r(1050)),s=r(1074);class a extends o.default{constructor(e,t){if(super(e,t),"byteArray"!==t)throw new TypeError(`byteArrayStop codec does not support data type ${t}`)}decode(e,t,r,n){const{blockContentId:o}=this.parameters,s=r[o];if(!s)throw new i.CramMalformedError(`no block found with content ID ${o}`);const a=n.externalBlocks.getCursor(o);return this._decodeByteArray(s,a)}_decodeByteArray(e,t){const r=e.content,{stopByte:n}=this.parameters,i=t.bytePosition;let o=t.bytePosition;for(;r[o]!==n&&o<r.length;){if(o===r.length)throw new s.CramBufferOverrunError("byteArrayStop reading beyond length of data buffer?");o+=1;}return t.bytePosition=o+1,r.subarray(i,o)}}t.default=a;},5844:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const i=r(8577),o=n(r(1050)),s=r(9488),a=r(1074);class f extends o.default{constructor(e,t){if(super(e,t),"int"===this.dataType)this._decodeData=this._decodeInt;else {if("byte"!==this.dataType)throw new i.CramUnimplementedError(`${this.dataType} decoding not yet implemented by EXTERNAL codec`);this._decodeData=this._decodeByte;}}decode(e,t,r,n){const{blockContentId:o}=this.parameters,s=r[o];if(!s)throw new i.CramMalformedError(`no block found with content ID ${o}`);const a=n.externalBlocks.getCursor(o);return this._decodeData(s,a)}_decodeInt(e,t){const[r,n]=(0, s.parseItf8)(e.content,t.bytePosition);return t.bytePosition=t.bytePosition+n,r}_decodeByte(e,t){if(t.bytePosition>=e.content.length)throw new a.CramBufferOverrunError("attempted to read beyond end of block. this file seems truncated.");return e.content[t.bytePosition++]}}t.default=f;},4229:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const i=r(8577),o=n(r(1050)),s=r(1074);class a extends o.default{constructor(e,t){if(super(e,t),"int"!==this.dataType)throw new i.CramUnimplementedError(`${this.dataType} decoding not yet implemented by GAMMA codec`)}decode(e,t,r,n){let i=1;for(;0===(0, s.getBits)(t.content,n.coreBlock,1);)i+=1;return ((0, s.getBits)(t.content,n.coreBlock,i-1)|1<<i-1)-this.parameters.offset}}t.default=a;},1074:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.getBits=t.CramBufferOverrunError=void 0;class r extends Error{}t.CramBufferOverrunError=r,t.getBits=function(e,t,n){let i=0;if(t.bytePosition+(7-t.bitPosition+n)/8>e.length)throw new r("read error during decoding. the file seems to be truncated.");for(let r=n;r;r--)i<<=1,i|=e[t.bytePosition]>>t.bitPosition&1,t.bitPosition-=1,t.bitPosition<0&&(t.bytePosition+=1),t.bitPosition&=7;return i};},2082:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const i=r(8577),o=n(r(1050)),s=r(1074);class a extends o.default{constructor(e,t){if(super(e,t),this.codes={},this.codeBook={},this.sortedByValue=[],this.sortedCodes=[],this.sortedValuesByBitCode=[],this.sortedBitCodes=[],this.sortedBitLengthsByBitCode=[],this.bitCodeToValue=[],!["byte","int"].includes(this.dataType))throw new TypeError(`${this.dataType} decoding not yet implemented by HUFFMAN_INT codec`);this.buildCodeBook(),this.buildCodes(),this.buildCaches(),0===this.sortedCodes[0].bitLength&&(this._decode=this._decodeZeroLengthCode);}buildCodeBook(){let e=new Array(this.parameters.numCodes);for(let t=0;t<this.parameters.numCodes;t+=1)e[t]={symbol:this.parameters.symbols[t],bitLength:this.parameters.bitLengths[t]};e=e.sort(((e,t)=>e.bitLength-t.bitLength||e.symbol-t.symbol)),this.codeBook={},e.forEach((e=>{this.codeBook[e.bitLength]||(this.codeBook[e.bitLength]=[]),this.codeBook[e.bitLength].push(e.symbol);}));}buildCodes(){this.codes={};let e=0,t=-1;Object.entries(this.codeBook).forEach((([r,n])=>{const o=parseInt(r,10);n.forEach((r=>{const n={bitLength:o,value:r,bitCode:0};t+=1;const s=o-e;if(t<<=s,n.bitCode=t,e+=s,function(e){let t=e-(e>>1)&1431655765;return t=(858993459&t)+(t>>2&858993459),16843009*(t+(t>>4)&252645135)>>24}(t)>o)throw new i.CramMalformedError("Symbol out of range");this.codes[r]=n;}));}));}buildCaches(){this.sortedCodes=Object.values(this.codes).sort(((e,t)=>e.bitLength-t.bitLength||e.bitCode-t.bitCode)),this.sortedByValue=Object.values(this.codes).sort(((e,t)=>e.value-t.value)),this.sortedValuesByBitCode=this.sortedCodes.map((e=>e.value)),this.sortedBitCodes=this.sortedCodes.map((e=>e.bitCode)),this.sortedBitLengthsByBitCode=this.sortedCodes.map((e=>e.bitLength));const e=Math.max(...this.sortedBitCodes);this.bitCodeToValue=new Array(e+1).fill(-1);for(let e=0;e<this.sortedBitCodes.length;e+=1)this.bitCodeToValue[this.sortedCodes[e].bitCode]=e;}decode(e,t,r,n){return this._decode(e,t,n.coreBlock)}_decodeZeroLengthCode(){return this.sortedCodes[0].value}_decode(e,t,r){const n=t.content;let o=0,a=0;for(let e=0;e<this.sortedCodes.length;e+=1){const t=this.sortedCodes[e].bitLength;a<<=t-o,a|=(0, s.getBits)(n,r,t-o),o=t;{const r=this.bitCodeToValue[a];if(r>-1&&this.sortedBitLengthsByBitCode[r]===t)return this.sortedValuesByBitCode[r];for(let r=e;this.sortedCodes[r+1].bitLength===t&&r<this.sortedCodes.length;r+=1)e+=1;}}throw new i.CramMalformedError("Huffman symbol not found.")}}t.default=a;},8772:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0}),t.instantiateCodec=void 0;const i=r(8577),o=n(r(2082)),s=n(r(5844)),a=n(r(1405)),f=n(r(1738)),h=n(r(4863)),l=n(r(4229)),u=n(r(8821)),c={1:s.default,3:o.default,4:f.default,5:a.default,6:h.default,7:u.default,9:l.default};t.instantiateCodec=function e(t,r){const n=(o="ignore"===r?0:t.codecId,c[o]);var o;if(!n)throw new i.CramUnimplementedError(`no codec implemented for codec ID ${t.codecId}`);return new n(t.parameters,r,e)};},8821:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const i=r(8577),o=n(r(1050)),s=r(1074);class a extends o.default{constructor(e,t){if(super(e,t),"int"!==this.dataType)throw new i.CramUnimplementedError(`${this.dataType} decoding not yet implemented by SUBEXP codec`)}decode(e,t,r,n){let i,o,a=0;for(;(0, s.getBits)(t.content,n.coreBlock,1);)a+=1;return 0===a?(i=this.parameters.K,o=(0, s.getBits)(t.content,n.coreBlock,i)):(i=a+this.parameters.K-1,o=1<<i|(0, s.getBits)(t.content,n.coreBlock,i)),o-this.parameters.offset}}t.default=a;},2615:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.default={CRAM_FLAG_PRESERVE_QUAL_SCORES:1,CRAM_FLAG_DETACHED:2,CRAM_FLAG_MATE_DOWNSTREAM:4,CRAM_FLAG_NO_SEQ:8,CRAM_FLAG_MASK:15,CRAM_M_REVERSE:1,CRAM_M_UNMAP:2,BAM_FPAIRED:1,BAM_FPROPER_PAIR:2,BAM_FUNMAP:4,BAM_FMUNMAP:8,BAM_FREVERSE:16,BAM_FMREVERSE:32,BAM_FREAD1:64,BAM_FREAD2:128,BAM_FSECONDARY:256,BAM_FQCFAIL:512,BAM_FDUP:1024,BAM_FSUPPLEMENTARY:2048,BAM_CMATCH:0,BAM_CINS:1,BAM_CDEL:2,BAM_CREF_SKIP:3,BAM_CSOFT_CLIP:4,BAM_CHARD_CLIP:5,BAM_CPAD:6,BAM_CEQUAL:7,BAM_CDIFF:8,BAM_CBACK:9,BAM_CIGAR_STR:"MIDNSHP:XB",BAM_CIGAR_SHIFT:4,BAM_CIGAR_MASK:15,BAM_CIGAR_TYPE:246183};},8543:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0});const n=r(8772),i=r(8577),o={BF:"int",CF:"int",RI:"int",RL:"int",AP:"int",RG:"int",MF:"int",NS:"int",NP:"int",TS:"int",NF:"int",TC:"byte",TN:"int",FN:"int",FC:"byte",FP:"int",BS:"byte",IN:"byteArray",SC:"byteArray",DL:"int",BA:"byte",BB:"byteArray",RS:"int",PD:"int",HC:"int",MQ:"int",RN:"byteArray",QS:"byte",QQ:"byteArray",TL:"int"};t.default=class{constructor(e){this.dataSeriesCodecCache={},this.tagCodecCache={},this.tagEncoding={},this.readNamesIncluded=e.preservation.RN,this.APdelta=e.preservation.AP,this.referenceRequired=!!e.preservation.RR,this.tagIdsDictionary=e.preservation.TD,this.substitutionMatrix=function(e){const t=new Array(5);for(let e=0;e<5;e+=1)t[e]=new Array(4);return t[0][e[0]>>6&3]="C",t[0][e[0]>>4&3]="G",t[0][e[0]>>2&3]="T",t[0][e[0]>>0&3]="N",t[1][e[1]>>6&3]="A",t[1][e[1]>>4&3]="G",t[1][e[1]>>2&3]="T",t[1][e[1]>>0&3]="N",t[2][e[2]>>6&3]="A",t[2][e[2]>>4&3]="C",t[2][e[2]>>2&3]="T",t[2][e[2]>>0&3]="N",t[3][e[3]>>6&3]="A",t[3][e[3]>>4&3]="C",t[3][e[3]>>2&3]="G",t[3][e[3]>>0&3]="N",t[4][e[4]>>6&3]="A",t[4][e[4]>>4&3]="C",t[4][e[4]>>2&3]="G",t[4][e[4]>>0&3]="T",t}(e.preservation.SM),this.dataSeriesEncoding=e.dataSeriesEncoding,this.tagEncoding=e.tagEncoding,this.preservation=e.preservation,this._size=e._size,this._endPosition=e._endPosition;}getCodecForTag(e){if(!this.tagCodecCache[e]){const t=this.tagEncoding[e];t&&(this.tagCodecCache[e]=(0, n.instantiateCodec)(t,"byteArray"));}return this.tagCodecCache[e]}getTagNames(e){return this.tagIdsDictionary[e]}getCodecForDataSeries(e){let t=this.dataSeriesCodecCache[e];if(void 0===t){const r=this.dataSeriesEncoding[e];if(r){const s=o[e];if(!s)throw new i.CramMalformedError(`data series name ${e} not defined in file compression header`);t=(0, n.instantiateCodec)(r,s),this.dataSeriesCodecCache[e]=t;}}return t}toJSON(){const e={};return Object.keys(this).forEach((t=>{/Cache$/.test(t)||(e[t]=this[t]);})),e}};},6284:function(e,t,r){var n=this&&this.__awaiter||function(e,t,r,n){return new(r||(r=Promise))((function(i,o){function s(e){try{f(n.next(e));}catch(e){o(e);}}function a(e){try{f(n.throw(e));}catch(e){o(e);}}function f(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t);}))).then(s,a);}f((n=n.apply(e,t||[])).next());}))},i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const o=r(8577),s=r(9488),a=i(r(6601)),f=i(r(8543));class h{constructor(e,t){this.file=e,this.filePosition=t;}getHeader(){return this._readContainerHeader(this.filePosition)}getCompressionHeaderBlock(){return n(this,void 0,void 0,(function*(){if(!(yield this.getHeader()).numRecords)return null;const e=yield this.file.getSectionParsers(),t=yield this.getFirstBlock();if(void 0===t)return;if("COMPRESSION_HEADER"!==t.contentType)throw new o.CramMalformedError(`invalid content type ${t.contentType} in what is supposed to be the compression header block`);const r=(0, s.parseItem)(t.content,e.cramCompressionHeader.parser,0,t.contentPosition);return Object.assign(Object.assign({},t),{parsedContent:r})}))}getFirstBlock(){return n(this,void 0,void 0,(function*(){const e=yield this.getHeader();return this.file.readBlock(e._endPosition)}))}getCompressionScheme(){return n(this,void 0,void 0,(function*(){const e=yield this.getCompressionHeaderBlock();if(e)return new f.default(e.parsedContent)}))}getSlice(e,t){return new a.default(this,e,t)}_readContainerHeader(e){return n(this,void 0,void 0,(function*(){const t=yield this.file.getSectionParsers(),{cramContainerHeader1:r,cramContainerHeader2:n}=t,{size:i}=yield this.file.stat();if(e>=i)return;const o=Buffer.allocUnsafe(r.maxLength);yield this.file.read(o,0,r.maxLength,e);const a=(0, s.parseItem)(o,r.parser),f=(0, s.itf8Size)(a.numLandmarks);if(e+a.length>=i)return void console.warn(`${this.file}: container header at ${e} indicates that the container has length ${a.length}, which extends beyond the length of the file. Skipping this container.`);const h=Buffer.allocUnsafe(n.maxLength(a.numLandmarks));yield this.file.read(h,0,n.maxLength(a.numLandmarks),e+a._size-f);const l=(0, s.parseItem)(h,n.parser);return this.file.validateChecksums&&void 0!==l.crc32&&(yield this.file.checkCrc32(e,a._size+l._size-f-4,l.crc32,`container header beginning at position ${e}`)),Object.assign(a,l,{_size:a._size+l._size-f,_endPosition:a._size+l._size-f+e})}))}}t.default=h,"getHeader getCompressionHeaderBlock getCompressionScheme".split(" ").forEach((e=>(0, s.tinyMemoize)(h,e)));},5457:function(e,t,r){var n=this&&this.__awaiter||function(e,t,r,n){return new(r||(r=Promise))((function(i,o){function s(e){try{f(n.next(e));}catch(e){o(e);}}function a(e){try{f(n.throw(e));}catch(e){o(e);}}function f(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t);}))).then(s,a);}f((n=n.apply(e,t||[])).next());}))},i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const o=r(597),s=i(r(2779)),a=i(r(1269)),f=r(8577),h=i(r(9675)),l=r(6141),u=i(r(3498)),c=i(r(6284)),d=r(3427),p=r(9488),g=r(7578);class m{constructor(e){var t;if(this.file=(0, d.open)(e.url,e.path,e.filehandle),this.validateChecksums=!0,this.fetchReferenceSequenceCallback=e.seqFetch,this.options={checkSequenceMD5:e.checkSequenceMD5,cacheSize:null!==(t=e.cacheSize)&&void 0!==t?t:2e4},this.featureCache=new a.default({maxSize:this.options.cacheSize}),function(){const e=new Uint32Array([287454020]),t=new Uint8Array(e.buffer);return 68===t[0]?0:17===t[0]?1:2}()>0)throw new Error("Detected big-endian machine, may be unable to run")}read(e,t,r,n){return this.file.read(e,t,r,n)}stat(){return this.file.stat()}getDefinition(){return n(this,void 0,void 0,(function*(){const e=Buffer.allocUnsafe(l.cramFileDefinition.maxLength);yield this.file.read(e,0,l.cramFileDefinition.maxLength,0);const t=l.cramFileDefinition.parser.parse(e).result;if(2!==t.majorVersion&&3!==t.majorVersion)throw new f.CramUnimplementedError(`CRAM version ${t.majorVersion} not supported`);return t}))}getSamHeader(){return n(this,void 0,void 0,(function*(){const e=yield this.getContainerById(0);if(!e)throw new f.CramMalformedError("file contains no containers");const t=yield e.getFirstBlock();if(void 0===t)return (0, g.parseHeaderText)("");const r=t.content,n=r.readInt32LE(0),i=r.toString("utf8",4,4+n);return this.header=i,(0, g.parseHeaderText)(i)}))}getHeaderText(){return n(this,void 0,void 0,(function*(){return yield this.getSamHeader(),this.header}))}getSectionParsers(){return n(this,void 0,void 0,(function*(){const{majorVersion:e}=yield this.getDefinition();return (0, l.getSectionParsers)(e)}))}getContainerById(e){return n(this,void 0,void 0,(function*(){const t=yield this.getSectionParsers();let r=t.cramFileDefinition.maxLength;const{size:n}=yield this.file.stat(),{cramContainerHeader1:i}=t;let o;for(let t=0;t<=e;t+=1){if(r+i.maxLength+8>=n)return;o=this.getContainerAtPosition(r);const s=yield o.getHeader();if(!s)throw new f.CramMalformedError(`container ${e} not found in file`);if(0===t){r=s._endPosition;for(let e=0;e<s.numBlocks;e+=1){const e=yield this.readBlock(r);if(void 0===e)return;r=e._endPosition;}}else r+=s._size+s.length;}return o}))}checkCrc32(e,t,r,i){return n(this,void 0,void 0,(function*(){const n=Buffer.allocUnsafe(t);yield this.file.read(n,0,t,e);const o=s.default.unsigned(n);if(o!==r)throw new f.CramMalformedError(`crc mismatch in ${i}: recorded CRC32 = ${r}, but calculated CRC32 = ${o}`)}))}containerCount(){return n(this,void 0,void 0,(function*(){const e=yield this.getSectionParsers(),{size:t}=yield this.file.stat(),{cramContainerHeader1:r}=e;let n=0,i=e.cramFileDefinition.maxLength;for(;i+r.maxLength+8<t;){const e=yield this.getContainerAtPosition(i).getHeader();if(!e)break;if(0===n){i=e._endPosition;for(let t=0;t<e.numBlocks;t+=1){const e=yield this.readBlock(i);if(void 0===e)return;i=e._endPosition;}}else i+=e._size+e.length;n+=1;}return n}))}getContainerAtPosition(e){return new c.default(this,e)}readBlockHeader(e){return n(this,void 0,void 0,(function*(){const t=yield this.getSectionParsers(),{cramBlockHeader:r}=t,{size:n}=yield this.file.stat();if(e+r.maxLength>=n)return;const i=Buffer.allocUnsafe(r.maxLength);return yield this.file.read(i,0,r.maxLength,e),(0, p.parseItem)(i,r.parser,0,e)}))}_parseSection(e,t,r=e.maxLength,i){return n(this,void 0,void 0,(function*(){let n;if(i)n=i;else {const{size:e}=yield this.file.stat();if(t+r>=e)return;n=Buffer.allocUnsafe(r),yield this.file.read(n,0,r,t);}const o=(0, p.parseItem)(n,e.parser,0,t);if(o._size!==r)throw new f.CramMalformedError(`section read error: requested size ${r} does not equal parsed size ${o._size}`);return o}))}_uncompress(e,t,r){if("gzip"===e)(0, o.unzip)(t).copy(r);else if("bzip2"===e){const e=bzip2.array(t);let n,i=bzip2.header(e),o=0;do{n=bzip2.decompress(e,i),-1!=n&&(Buffer.from(n).copy(r,o),o+=n.length,i-=n.length);}while(-1!=n)}else if("rans"===e)(0, h.default)(t,r);else if("rans4x16"===e)u.default.r4x16_uncompress(t,r);else if("arith"===e)u.default.arith_uncompress(t,r);else if("fqzcomp"===e)u.default.fqzcomp_uncompress(t,r);else {if("tok3"!==e)throw new f.CramUnimplementedError(`${e} decompression not yet implemented`);u.default.tok3_uncompress(t,r);}}readBlock(e){return n(this,void 0,void 0,(function*(){const{majorVersion:t}=yield this.getDefinition(),r=yield this.getSectionParsers(),n=yield this.readBlockHeader(e);if(void 0===n)return;const i=n._endPosition,o=Buffer.allocUnsafe(n.uncompressedSize),s=Object.assign(Object.assign({},n),{_endPosition:i,contentPosition:i,content:o});if("raw"!==n.compressionMethod){const e=Buffer.allocUnsafe(n.compressedSize);yield this.read(e,0,n.compressedSize,i),this._uncompress(n.compressionMethod,e,o);}else yield this.read(o,0,n.uncompressedSize,i);if(t>=3){const t=yield this._parseSection(r.cramBlockCrc32,i+n.compressedSize);if(void 0===t)return;s.crc32=t.crc32,this.validateChecksums&&(yield this.checkCrc32(e,n._size+n.compressedSize,t.crc32,"block data")),s._endPosition=t._endPosition,s._size=s.compressedSize+r.cramBlockCrc32.maxLength;}else s._endPosition=i+s.compressedSize,s._size=s.compressedSize;return s}))}}t.default=m,"getDefinition getSectionParsers getSamHeader".split(" ").forEach((e=>(0, p.tinyMemoize)(m,e)));},8222:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0}),t.CramRecord=void 0;const i=n(r(5457));var o=r(8631);Object.defineProperty(t,"CramRecord",{enumerable:!0,get:function(){return n(o).default}}),t.default=i.default;},8631:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0}),t.MateFlagsDecoder=t.CramFlagsDecoder=t.BamFlagsDecoder=t.MateFlags=t.CramFlags=t.BamFlags=void 0;const i=n(r(2615)),o={a:0,A:0,c:1,C:1,g:2,G:2,t:3,T:3,n:4,N:4};function s(e){const t={};for(const[r,n]of e)t["is"+n]=e=>!!(e&r),t["set"+n]=e=>e|r;return t}t.BamFlags=[[1,"Paired"],[2,"ProperlyPaired"],[4,"SegmentUnmapped"],[8,"MateUnmapped"],[16,"ReverseComplemented"],[32,"MateReverseComplemented"],[64,"Read1"],[128,"Read2"],[256,"Secondary"],[512,"FailedQc"],[1024,"Duplicate"],[2048,"Supplementary"]],t.CramFlags=[[1,"PreservingQualityScores"],[2,"Detached"],[4,"WithMateDownstream"],[8,"DecodeSequenceAsStar"]],t.MateFlags=[[1,"OnNegativeStrand"],[2,"Unmapped"]],t.BamFlagsDecoder=s(t.BamFlags),t.CramFlagsDecoder=s(t.CramFlags),t.MateFlagsDecoder=s(t.MateFlags),t.default=class{constructor({flags:e,cramFlags:t,readLength:r,mappingQuality:n,lengthOnRef:i,qualityScores:o,mateRecordNumber:s,readBases:a,readFeatures:f,mateToUse:h,readGroupId:l,readName:u,sequenceId:c,uniqueId:d,templateSize:p,alignmentStart:g,tags:m}){this.flags=e,this.cramFlags=t,this.readLength=r,this.mappingQuality=n,this.lengthOnRef=i,this.qualityScores=o,a&&(this.readBases=a),this.readGroupId=l,this.readName=u,this.sequenceId=c,this.uniqueId=d,this.templateSize=p,this.alignmentStart=g,this.tags=m,f&&(this.readFeatures=f),h&&(this.mate={flags:h.mateFlags,readName:h.mateReadName,sequenceId:h.mateSequenceId,alignmentStart:h.mateAlignmentStart}),s&&(this.mateRecordNumber=s);}isPaired(){return !!(this.flags&i.default.BAM_FPAIRED)}isProperlyPaired(){return !!(this.flags&i.default.BAM_FPROPER_PAIR)}isSegmentUnmapped(){return !!(this.flags&i.default.BAM_FUNMAP)}isMateUnmapped(){return !!(this.flags&i.default.BAM_FMUNMAP)}isReverseComplemented(){return !!(this.flags&i.default.BAM_FREVERSE)}isMateReverseComplemented(){return !!(this.flags&i.default.BAM_FMREVERSE)}isRead1(){return !!(this.flags&i.default.BAM_FREAD1)}isRead2(){return !!(this.flags&i.default.BAM_FREAD2)}isSecondary(){return !!(this.flags&i.default.BAM_FSECONDARY)}isFailedQc(){return !!(this.flags&i.default.BAM_FQCFAIL)}isDuplicate(){return !!(this.flags&i.default.BAM_FDUP)}isSupplementary(){return !!(this.flags&i.default.BAM_FSUPPLEMENTARY)}isDetached(){return !!(this.cramFlags&i.default.CRAM_FLAG_DETACHED)}hasMateDownStream(){return !!(this.cramFlags&i.default.CRAM_FLAG_MATE_DOWNSTREAM)}isPreservingQualityScores(){return !!(this.cramFlags&i.default.CRAM_FLAG_PRESERVE_QUAL_SCORES)}isUnknownBases(){return !!(this.cramFlags&i.default.CRAM_FLAG_NO_SEQ)}getReadBases(){if(!this.readBases&&this._refRegion){const e=function(e,t){if(!e.lengthOnRef&&!e.readLength)return null;if(e.isUnknownBases())return null;const r=e.alignmentStart-t.start;if(!e.readFeatures)return t.seq.substr(r,e.lengthOnRef).toUpperCase();let n="",i=r,o=0;for(;n.length<e.readLength;)if(o<e.readFeatures.length){const r=e.readFeatures[o];if("Q"===r.code||"q"===r.code)o+=1;else if(r.pos===n.length+1)if(o+=1,"b"===r.code){const e=r.data;n+=e,i+=e.length;}else "B"===r.code?(n+=r.data[0],i+=1):"X"===r.code?(n+=r.sub,i+=1):"I"===r.code?n+=r.data:"D"===r.code?i+=r.data:"i"===r.code?n+=r.data:"N"===r.code?i+=r.data:"S"===r.code?n+=r.data:"P"===r.code||r.code;else if(o<e.readFeatures.length){const r=t.seq.substr(i,e.readFeatures[o].pos-n.length-1);n+=r,i+=r.length;}}else {const r=t.seq.substr(i,e.readLength-n.length);n+=r,i+=r.length;}return n.toUpperCase()}(this,this._refRegion);e&&(this.readBases=e);}return this.readBases}getPairOrientation(){if(!this.isSegmentUnmapped()&&this.isPaired()&&!this.isMateUnmapped()&&this.mate&&this.sequenceId===this.mate.sequenceId){const e=this.isReverseComplemented()?"R":"F",t=this.isMateReverseComplemented()?"R":"F";let r=" ",n=" ";this.isRead1()?(r="1",n="2"):this.isRead2()&&(r="2",n="1");const i=[];let o=this.templateLength||this.templateSize;if(void 0===o)throw new Error("One of templateSize and templateLength must be set");return this.alignmentStart>this.mate.alignmentStart&&o>0&&(o=-o),o>0?(i[0]=e,i[1]=r,i[2]=t,i[3]=n):(i[2]=e,i[3]=r,i[0]=t,i[1]=n),i.join("")}return null}addReferenceSequence(e,t){this.readFeatures&&this.readFeatures.forEach((r=>{"X"===r.code&&function(e,t,r,n){if(!t)return;const i=n.refPos-t.start,s=t.seq.charAt(i);s&&(n.ref=s);let a=o[s];void 0===a&&(a=4);const f=r.substitutionMatrix[a][n.data];f&&(n.sub=f);}(0,e,t,r);})),!this.readBases&&e.start<=this.alignmentStart&&e.end>=this.alignmentStart+(this.lengthOnRef||this.readLength)-1&&(this._refRegion=e);}toJSON(){const e={};return Object.keys(this).forEach((t=>{"_"!==t.charAt(0)&&(e[t]=this[t]);})),e.readBases=this.getReadBases(),e}};},6141:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.getSectionParsers=t.cramFileDefinition=t.isMappedSliceHeader=void 0;const n=r(9996),i=(new n.Parser).itf8(),o={parser:(new n.Parser).string("magic",{length:4}).uint8("majorVersion").uint8("minorVersion").string("fileId",{length:20,stripNull:!0}),maxLength:26};t.cramFileDefinition=o;const s={parser:(new n.Parser).uint8("compressionMethod",{formatter:e=>{const t=["raw","gzip","bzip2","lzma","rans","rans4x16","arith","fqzcomp","tok3"][e];if(!t)throw new Error(`compression method number ${e} not implemented`);return t}}).uint8("contentType",{formatter:e=>{const t=["FILE_HEADER","COMPRESSION_HEADER","MAPPED_SLICE_HEADER","UNMAPPED_SLICE_HEADER","EXTERNAL_DATA","CORE_DATA"][e];if(!t)throw new Error(`invalid block content type id ${e}`);return t}}).itf8("contentId").itf8("compressedSize").itf8("uncompressedSize"),maxLength:17},a={parser:(new n.Parser).uint32("crc32"),maxLength:4},f=(new n.Parser).itf8("size").buffer("ents",{length:"size",formatter:e=>{function t(t,r){const n=e.toString("utf8",t,r),i=[];for(let e=0;e<n.length;e+=3)i.push(n.substr(e,3));return i}var r,n=[],i=0;for(r=0;r<e.length;r+=1)e[r]||(n.push(t(i,r)),i=r+1);return r>i&&n.push(t(i,r)),n}}),h=(new n.Parser).uint8(null,{formatter:e=>!!e}),l=(new n.Parser).itf8("mapSize").itf8("mapCount").array("ents",{length:"mapCount",type:(new n.Parser).string("key",{length:2,stripNull:!1}).choice("value",{tag:"key",choices:{MI:h,UI:h,PI:h,RN:h,AP:h,RR:h,SM:(new n.Parser).array(null,{type:"uint8",length:5}),TD:(new n.Parser).nest(null,{type:f,formatter:e=>e.ents})}})});function u(e){const t={};for(let r=0;r<e.ents.length;r+=1){const{key:n,value:i}=e.ents[r];t[n]&&console.warn(`duplicate key ${n} in map`),t[n]=i;}return t}const c={cramFileDefinition:o,cramBlockHeader:s,cramBlockCrc32:a};t.isMappedSliceHeader=function(e){return "number"==typeof e.refSeqId};const d={cramUnmappedSliceHeader(e){let t=0,r=(new n.Parser).itf8("numRecords");return t+=5,e>=3?(r=r.ltf8("recordCounter"),t+=9):2===e&&(r=r.itf8("recordCounter"),t+=5),r=r.itf8("numBlocks").itf8("numContentIds").array("contentIds",{type:i,length:"numContentIds"}),t+=10,e>=2&&(r=r.array("md5",{type:"uint8",length:16}),t+=16),{parser:r,maxLength:e=>t+5*e}},cramMappedSliceHeader(e){let t=(new n.Parser).itf8("refSeqId").itf8("refSeqStart").itf8("refSeqSpan").itf8("numRecords"),r=20;return e>=3?(t=t.ltf8("recordCounter"),r+=9):2===e&&(t=t.itf8("recordCounter"),r+=5),t=t.itf8("numBlocks").itf8("numContentIds").array("contentIds",{type:i,length:"numContentIds"}).itf8("refBaseBlockId"),r+=15,e>=2&&(t=t.array("md5",{type:"uint8",length:16}),r+=16),{parser:t,maxLength:e=>r+5*e}},cramEncoding:e=>({parser:(new n.Parser).namely("cramEncoding").itf8("codecId").itf8("parametersBytes").choice("parameters",{tag:"codecId",choices:{0:new n.Parser,1:(new n.Parser).itf8("blockContentId"),2:(new n.Parser).itf8("offset").itf8("M"),3:n.Parser.start().itf8("numCodes").array("symbols",{length:"numCodes",type:i}).itf8("numLengths").array("bitLengths",{length:"numLengths",type:i}),4:n.Parser.start().nest("lengthsEncoding",{type:"cramEncoding"}).nest("valuesEncoding",{type:"cramEncoding"}),5:(new n.Parser).uint8("stopByte").itf8("blockContentId"),6:(new n.Parser).itf8("offset").itf8("length"),7:(new n.Parser).itf8("offset").itf8("K"),8:(new n.Parser).itf8("offset").itf8("log2m"),9:(new n.Parser).itf8("offset")}})}),cramDataSeriesEncodingMap(e){return (new n.Parser).itf8("mapSize").itf8("mapCount").array("ents",{length:"mapCount",type:(new n.Parser).string("key",{length:2,stripNull:!1}).nest("value",{type:this.cramEncoding(e).parser})})},cramTagEncodingMap(e){return (new n.Parser).itf8("mapSize").itf8("mapCount").array("ents",{length:"mapCount",type:(new n.Parser).itf8("key",{formatter:e=>String.fromCharCode(e>>16&255)+String.fromCharCode(e>>8&255)+String.fromCharCode(255&e)}).nest("value",{type:this.cramEncoding(e).parser})})},cramCompressionHeader(e){let t=new n.Parser;return t=t.nest("preservation",{type:l,formatter:u}).nest("dataSeriesEncoding",{type:this.cramDataSeriesEncodingMap(e),formatter:u}).nest("tagEncoding",{type:this.cramTagEncodingMap(e),formatter:u}),{parser:t}},cramContainerHeader1(e){let t=(new n.Parser).int32("length").itf8("refSeqId").itf8("refSeqStart").itf8("alignmentSpan").itf8("numRecords"),r=24;return e>=3?(t=t.ltf8("recordCounter"),r+=9):2===e&&(t=t.itf8("recordCounter"),r+=5),e>1&&(t=t.ltf8("numBases"),r+=9),t=t.itf8("numBlocks").itf8("numLandmarks"),r+=10,{parser:t,maxLength:r}},cramContainerHeader2(e){let t=(new n.Parser).itf8("numLandmarks").array("landmarks",{type:(new n.Parser).itf8(),length:"numLandmarks"}),r=0;return e>=3&&(t=t.uint32("crc32"),r=4),{parser:t,maxLength:e=>5+5*e+r}}};t.getSectionParsers=function(e){const t=Object.assign({},c);return Object.keys(d).forEach((r=>{t[r]=d[r](e);})),t};},3757:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const i=n(r(3720)),o=r(8577),s=r(8631),a=r(6141);function f(e){let t="";for(let r=0;r<e.length&&0!==e[r];r++)t+=String.fromCharCode(e[r]);return t}function h(e,t){if("Z"===e)return f(t);if("A"===e)return String.fromCharCode(t[0]);if("I"===e)return i.default.fromBytesLE(t).toNumber();if("i"===e)return new Int32Array(t.buffer)[0];if("s"===e)return new Int16Array(t.buffer)[0];if("S"===e)return new Uint16Array(t.buffer)[0];if("c"===e)return new Int8Array(t.buffer)[0];if("C"===e)return t[0];if("f"===e)return new Float32Array(t.buffer)[0];if("H"===e)return Number.parseInt(f(t).replace(/^0x/,""),16);if("B"===e)return function(e){const t=String.fromCharCode(e[0]),r=Int32Array.from(e.slice(1))[0],n=new Array(r);if(e=e.slice(5),"c"===t){const t=new Int8Array(e.buffer);for(let e=0;e<r;e+=1)n[e]=t[e];}else if("C"===t){const t=new Uint8Array(e.buffer);for(let e=0;e<r;e+=1)n[e]=t[e];}else if("s"===t){const t=new Int16Array(e.buffer);for(let e=0;e<r;e+=1)n[e]=t[e];}else if("S"===t){const t=new Uint16Array(e.buffer);for(let e=0;e<r;e+=1)n[e]=t[e];}else if("i"===t){const t=new Int32Array(e.buffer);for(let e=0;e<r;e+=1)n[e]=t[e];}else if("I"===t){const t=new Uint32Array(e.buffer);for(let e=0;e<r;e+=1)n[e]=t[e];}else {if("f"!==t)throw new Error("unknown type: "+t);{const t=new Float32Array(e.buffer);for(let e=0;e<r;e+=1)n[e]=t[e];}}return n}(t);throw new o.CramMalformedError(`Unrecognized tag type ${e}`)}t.default=function(e,t,r,n,i,l,u,c,d){let p=t("BF");const g=t("CF");if(!(0, a.isMappedSliceHeader)(n.parsedContent))throw new Error;let m;m=c>1&&-2===n.parsedContent.refSeqId?t("RI"):n.parsedContent.refSeqId;const y=t("RL");let b=t("AP");r.APdelta&&(b+=u.lastAlignmentStart),u.lastAlignmentStart=b;const v=t("RG");let w,_,B,E;if(r.readNamesIncluded&&(w=f(t("RN"))),s.CramFlagsDecoder.isDetached(g)){const e=t("MF");let n;r.readNamesIncluded||(n=f(t("RN")),w=n);const i=t("NS"),o=t("NP");(e||i>-1)&&(_={mateFlags:e,mateSequenceId:i,mateAlignmentStart:o,mateReadName:n}),B=t("TS"),s.MateFlagsDecoder.isUnmapped(e)&&(p=s.BamFlagsDecoder.setMateUnmapped(p)),s.MateFlagsDecoder.isOnNegativeStrand(e)&&(p=s.BamFlagsDecoder.setMateReverseComplemented(p));}else s.CramFlagsDecoder.isWithMateDownstream(g)&&(E=t("NF")+d+1);const S=t("TL");if(S<0)throw new o.CramMalformedError("invalid TL index");const A={},C=r.getTagNames(S),R=C.length;for(let t=0;t<R;t+=1){const n=C[t],s=n.substr(0,2),a=n.substr(2,1),f=r.getCodecForTag(n);if(!f)throw new o.CramMalformedError(`no codec defined for auxiliary tag ${n}`);const c=f.decode(e,i,l,u);A[s]=h(a,c);}let k,x,I,M,F;if(s.BamFlagsDecoder.isSegmentUnmapped(p))if(s.CramFlagsDecoder.isDecodeSequenceAsStar(g))F=null,M=null;else {const e=new Array(y);for(let r=0;r<e.length;r+=1)e[r]=t("BA");if(F=String.fromCharCode(...e),s.CramFlagsDecoder.isPreservingQualityScores(g)){M=new Array(y);for(let r=0;r<e.length;r+=1)M[r]=t("QS");}}else {const e=t("FN");if(e&&(k=function(e,t,r,n,i){let s=0,a=e-1;const f=new Array(t);function h([e,t]){const n=r(t);if("character"===e)return String.fromCharCode(n);if("string"===e){let e="";for(let t=0;t<n.byteLength;t++)e+=String.fromCharCode(n[t]);return e}return "numArray"===e?n.toArray():n}for(let e=0;e<t;e+=1){const t=String.fromCharCode(r("FC")),n=r("FP"),l={B:["character","BA"],S:["string",i>1?"SC":"IN"],X:["number","BS"],D:["number","DL"],I:["string","IN"],i:["character","BA"],b:["string","BB"],q:["numArray","QQ"],Q:["number","QS"],H:["number","HC"],P:["number","PD"],N:["number","RS"]}[t];if(!l)throw new o.CramMalformedError(`invalid read feature code "${t}"`);let u=h(l);const c={B:["number","QS"]}[t];c&&(u=[u,h(c)]),s+=n;const d=s;a+=n;const p=a;"D"===t||"N"===t?a+=u:"I"===t||"S"===t?a-=u.length:"i"===t&&(a-=1),f[e]={code:t,pos:d,refPos:p,data:u};}return f}(b,e,t,0,c)),x=y,k)for(const{code:e,data:t}of k)"D"===e||"N"===e?x+=t:"I"===e||"S"===e?x-=t.length:"i"===e&&(x-=1);if(Number.isNaN(x)&&(console.warn(`${w||`${m}:${b}`} record has invalid read features`),x=y),I=t("MQ"),s.CramFlagsDecoder.isPreservingQualityScores(g)){M=new Array(y);for(let e=0;e<M.length;e++)M[e]=t("QS");}}return {readLength:y,sequenceId:m,cramFlags:g,flags:p,alignmentStart:b,readGroupId:v,readName:w,mateToUse:_,templateSize:B,mateRecordNumber:E,readFeatures:k,lengthOnRef:x,mappingQuality:I,qualityScores:M,readBases:F,tags:A}};},6601:function(e,t,r){var n=this&&this.__awaiter||function(e,t,r,n){return new(r||(r=Promise))((function(i,o){function s(e){try{f(n.next(e));}catch(e){o(e);}}function a(e){try{f(n.throw(e));}catch(e){o(e);}}function f(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t);}))).then(s,a);}f((n=n.apply(e,t||[])).next());}))},i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const o=r(8577),s=r(9488),a=i(r(2615)),f=i(r(3757)),h=i(r(8631)),l=r(6141),u=r(1074);function c(e,t,r,n){if(!n)throw new o.CramMalformedError("could not resolve intra-slice mate pairs, file seems truncated or malformed");const i=!!(n.mate||void 0!==n.mateRecordNumber&&n.mateRecordNumber!==t);r.readName||(r.readName=String(r.uniqueId),n.readName=r.readName),r.mate={sequenceId:n.sequenceId,alignmentStart:n.alignmentStart,uniqueId:n.uniqueId},n.readName&&(r.mate.readName=n.readName),n.mate||void 0!==n.mateRecordNumber||(n.mate={sequenceId:r.sequenceId,alignmentStart:r.alignmentStart,uniqueId:r.uniqueId},r.readName&&(n.mate.readName=r.readName)),r.flags|=a.default.BAM_FPAIRED,n.flags&a.default.BAM_FUNMAP&&(r.flags|=a.default.BAM_FMUNMAP),r.flags&a.default.BAM_FUNMAP&&(n.flags|=a.default.BAM_FMUNMAP),n.flags&a.default.BAM_FREVERSE&&(r.flags|=a.default.BAM_FMREVERSE),r.flags&a.default.BAM_FREVERSE&&(n.flags|=a.default.BAM_FMREVERSE),void 0===r.templateLength&&(i?function(e,t,r){const n=function t(r){const n=[r];if(void 0!==r.mateRecordNumber&&r.mateRecordNumber>=0){const i=e[r.mateRecordNumber];if(!i)throw new o.CramMalformedError("intra-slice mate record not found, this file seems malformed");n.push(...t(i));}return n}(r),i=n.map((e=>e.alignmentStart)),s=n.map((e=>e.alignmentStart+e.readLength-1)),a=Math.max(...s)-Math.min(...i)+1;a>=0&&n.forEach((e=>{if(void 0!==e.templateLength)throw new o.CramMalformedError("mate pair group has some members that have template lengths already, this file seems malformed");e.templateLength=a;}));}(e,0,r):function(e,t){const r=Math.min(e.alignmentStart,t.alignmentStart),n=Math.max(e.alignmentStart+e.readLength-1,t.alignmentStart+t.readLength-1)-r+1;e.templateLength=n,t.templateLength=n;}(r,n)),delete r.mateRecordNumber;}class d{constructor(e,t,r){this.container=e,this.containerPosition=t,this.file=e.file;}getHeader(){return n(this,void 0,void 0,(function*(){const e=yield this.file.getSectionParsers(),t=yield this.container.getHeader(),r=yield this.file.readBlock(t._endPosition+this.containerPosition);if(void 0===r)throw new Error;if("MAPPED_SLICE_HEADER"===r.contentType){const n=(0, s.parseItem)(r.content,e.cramMappedSliceHeader.parser,0,t._endPosition);return Object.assign(Object.assign({},r),{parsedContent:n})}if("UNMAPPED_SLICE_HEADER"===r.contentType){const n=(0, s.parseItem)(r.content,e.cramUnmappedSliceHeader.parser,0,t._endPosition);return Object.assign(Object.assign({},r),{parsedContent:n})}throw new o.CramMalformedError(`error reading slice header block, invalid content type ${r.contentType}`)}))}getBlocks(){return n(this,void 0,void 0,(function*(){const e=yield this.getHeader();let t=e._endPosition;const r=new Array(e.parsedContent.numBlocks);for(let e=0;e<r.length;e+=1){const n=yield this.file.readBlock(t);if(void 0===n)throw new Error;r[e]=n,t=r[e]._endPosition;}return r}))}getCoreDataBlock(){return n(this,void 0,void 0,(function*(){return (yield this.getBlocks())[0]}))}_getBlocksContentIdIndex(){return n(this,void 0,void 0,(function*(){const e=yield this.getBlocks(),t={};return e.forEach((e=>{"EXTERNAL_DATA"===e.contentType&&(t[e.contentId]=e);})),t}))}getBlockByContentId(e){return n(this,void 0,void 0,(function*(){return (yield this._getBlocksContentIdIndex())[e]}))}getReferenceRegion(){return n(this,void 0,void 0,(function*(){const e=(yield this.getHeader()).parsedContent;if(!(0, l.isMappedSliceHeader)(e))throw new Error;if(e.refSeqId<0)return;const t=yield this.container.getCompressionScheme();if(void 0===t)throw new Error;if(e.refBaseBlockId>=0){const t=yield this.getBlockByContentId(e.refBaseBlockId);if(!t)throw new o.CramMalformedError("embedded reference specified, but reference block does not exist");return {seq:t.data.toString("utf8"),start:e.refSeqStart,end:e.refSeqStart+e.refSeqSpan-1,span:e.refSeqSpan}}if(t.referenceRequired||this.file.fetchReferenceSequenceCallback){if(!this.file.fetchReferenceSequenceCallback)throw new Error("reference sequence not embedded, and seqFetch callback not provided, cannot fetch reference sequence");const t=yield this.file.fetchReferenceSequenceCallback(e.refSeqId,e.refSeqStart,e.refSeqStart+e.refSeqSpan-1);if(t.length!==e.refSeqSpan)throw new o.CramArgumentError("seqFetch callback returned a reference sequence of the wrong length");return {seq:t,start:e.refSeqStart,end:e.refSeqStart+e.refSeqSpan-1,span:e.refSeqSpan}}}))}getAllRecords(){return this.getRecords((()=>!0))}_fetchRecords(){return n(this,void 0,void 0,(function*(){const{majorVersion:e}=yield this.file.getDefinition(),t=yield this.container.getCompressionScheme();if(void 0===t)throw new Error;const r=yield this.getHeader();if(void 0===r)throw new Error;const n=yield this._getBlocksContentIdIndex();if(e>1&&this.file.options.checkSequenceMD5&&(0, l.isMappedSliceHeader)(r.parsedContent)&&r.parsedContent.refSeqId>=0&&"0000000000000000"!==r.parsedContent.md5.join("")){const e=yield this.getReferenceRegion();if(e){const{seq:t,start:n,end:i}=e,a=(0, s.sequenceMD5)(t),f=r.parsedContent.md5.map((e=>(e<16?"0":"")+e.toString(16))).join("");if(a!==f)throw new o.CramMalformedError(`MD5 checksum reference mismatch for ref ${r.parsedContent.refSeqId} pos ${n}..${i}. recorded MD5: ${f}, calculated MD5: ${a}`)}}const i=yield this.getCoreDataBlock(),a={lastAlignmentStart:(0, l.isMappedSliceHeader)(r.parsedContent)?r.parsedContent.refSeqStart:0,coreBlock:{bitPosition:7,bytePosition:0},externalBlocks:{map:new Map,getCursor(e){let t=this.map.get(e);return void 0===t&&(t={bitPosition:7,bytePosition:0},this.map.set(e,t)),t}}},d=e=>{const r=t.getCodecForDataSeries(e);if(!r)throw new o.CramMalformedError(`no codec defined for ${e} data series`);return r.decode(this,i,n,a)};let p=new Array(r.parsedContent.numRecords);for(let o=0;o<p.length;o+=1)try{const s=(0,f.default)(this,d,t,r,i,n,a,e,o);p[o]=new h.default(Object.assign(Object.assign({},s),{uniqueId:r.contentPosition+r.parsedContent.recordCounter+o+1}));}catch(e){if(e instanceof u.CramBufferOverrunError){console.warn("read attempted beyond end of buffer, file seems truncated."),p=p.filter((e=>!!e));break}throw e}for(let e=0;e<p.length;e+=1){const{mateRecordNumber:t}=p[e];void 0!==t&&t>=0&&c(p,e,p[e],p[t]);}return p}))}getRecords(e){return n(this,void 0,void 0,(function*(){const t=this.container.filePosition+this.containerPosition;let r=this.file.featureCache.get(t.toString());r||(r=this._fetchRecords(),this.file.featureCache.set(t.toString(),r));const i=(yield r).filter(e);if(i.length&&this.file.fetchReferenceSequenceCallback){const e=yield this.getHeader();if((0, l.isMappedSliceHeader)(e.parsedContent)&&(e.parsedContent.refSeqId>=0||-2===e.parsedContent.refSeqId)){const t=e.parsedContent.refSeqId>=0?e.parsedContent.refSeqId:void 0,r=yield this.container.getCompressionScheme();if(void 0===r)throw new Error;const o={};for(let e=0;e<i.length;e+=1){const r=void 0!==t?t:i[e].sequenceId;let n=o[r];n||(n={id:r,start:i[e].alignmentStart,end:-1/0,seq:null},o[r]=n);const s=i[e].alignmentStart+(i[e].lengthOnRef||i[e].readLength)-1;s>n.end&&(n.end=s),i[e].alignmentStart<n.start&&(n.start=i[e].alignmentStart);}yield Promise.all(Object.values(o).map((e=>n(this,void 0,void 0,(function*(){-1!==e.id&&e.start<=e.end&&(e.seq=yield this.file.fetchReferenceSequenceCallback(e.id,e.start,e.end));})))));for(let e=0;e<i.length;e+=1){const n=o[void 0!==t?t:i[e].sequenceId];if(n&&n.seq){const t=n.seq;i[e].addReferenceSequence(Object.assign(Object.assign({},n),{seq:t}),r);}}}}return i}))}}t.default=d,"getHeader getBlocks _getBlocksContentIdIndex".split(" ").forEach((e=>(0, s.tinyMemoize)(d,e)));},9488:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0}),t.sequenceMD5=t.tinyMemoize=t.parseItem=t.parseItf8=t.itf8Size=void 0;const i=n(r(2568)),o=r(1074);t.itf8Size=function(e){return -128&e?-16384&e?-2097152&e?-268435456&e?5:4:3:2:1},t.parseItf8=function(e,t){let r=t;const n=e[r];let i;if(n<128?(i=n,r+=1):n<192?(i=16383&(n<<8|e[r+1]),r+=2):n<224?(i=2097151&(n<<16|e[r+1]<<8|e[r+2]),r+=3):n<240?(i=268435455&(n<<24|e[r+1]<<16|e[r+2]<<8|e[r+3]),r+=4):(i=(15&n)<<28|e[r+1]<<20|e[r+2]<<12|e[r+3]<<4|15&e[r+4],r+=5),r>e.length)throw new o.CramBufferOverrunError("Attempted to read beyond end of buffer; this file seems truncated.");return [i,r-t]},t.parseItem=function(e,t,r=0,n=0){const{offset:i,result:o}=t.parse(e);return Object.assign(Object.assign({},o),{_endPosition:i+n,_size:i-r})},t.tinyMemoize=function(e,t){const r=e.prototype[t],n=`_memo_${t}`;e.prototype[t]=function(){if(!(n in this)){const e=r.call(this);this[n]=e,Promise.resolve(e).catch((()=>{delete this[n];}));}return this[n]};},t.sequenceMD5=function(e){return (0, i.default)(e.toUpperCase().replace(/[^\x21-\x7e]/g,""))};},8577:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.CramArgumentError=t.CramSizeLimitError=t.CramMalformedError=t.CramUnimplementedError=t.CramError=void 0;class r extends Error{}t.CramError=r;class n extends Error{}t.CramUnimplementedError=n,t.CramMalformedError=class extends r{},t.CramSizeLimitError=class extends r{},t.CramArgumentError=class extends r{};},5590:function(e,t,r){var n=this&&this.__createBinding||(Object.create?function(e,t,r,n){void 0===n&&(n=r);var i=Object.getOwnPropertyDescriptor(t,r);i&&!("get"in i?!t.__esModule:i.writable||i.configurable)||(i={enumerable:!0,get:function(){return t[r]}}),Object.defineProperty(e,n,i);}:function(e,t,r,n){void 0===n&&(n=r),e[n]=t[r];}),i=this&&this.__setModuleDefault||(Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t});}:function(e,t){e.default=t;}),o=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var r in e)"default"!==r&&Object.prototype.hasOwnProperty.call(e,r)&&n(t,e,r);return i(t,e),t},s=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0}),t.CramRecord=t.CraiIndex=t.IndexedCramFile=t.CramFile=void 0;const a=o(r(8222));t.CramFile=a.default,Object.defineProperty(t,"CramRecord",{enumerable:!0,get:function(){return a.CramRecord}});const f=s(r(946));t.IndexedCramFile=f.default;const h=s(r(368));t.CraiIndex=h.default;},946:function(e,t,r){var n=this&&this.__awaiter||function(e,t,r,n){return new(r||(r=Promise))((function(i,o){function s(e){try{f(n.next(e));}catch(e){o(e);}}function a(e){try{f(n.throw(e));}catch(e){o(e);}}function f(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t);}))).then(s,a);}f((n=n.apply(e,t||[])).next());}))},i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const o=r(8577),s=i(r(8222));t.default=class{constructor(e){if(e.cram?this.cram=e.cram:this.cram=new s.default({url:e.cramUrl,path:e.cramPath,filehandle:e.cramFilehandle,seqFetch:e.seqFetch,checkSequenceMD5:e.checkSequenceMD5,cacheSize:e.cacheSize}),!(this.cram instanceof s.default))throw new Error("invalid arguments: no cramfile");if(this.index=e.index,!this.index.getEntriesForRange)throw new Error("invalid arguments: not an index");this.fetchSizeLimit=e.fetchSizeLimit||3e6;}getRecordsForRange(e,t,r,i={}){return n(this,void 0,void 0,(function*(){if(i.viewAsPairs=i.viewAsPairs||!1,i.pairAcrossChr=i.pairAcrossChr||!1,i.maxInsertSize=i.maxInsertSize||2e5,"string"==typeof e)throw new o.CramUnimplementedError("string sequence names not yet supported");const n=e,s=yield this.index.getEntriesForRange(n,t,r),a=s.map((e=>e.sliceBytes)).reduce(((e,t)=>e+t),0);if(a>this.fetchSizeLimit)throw new o.CramSizeLimitError(`data size of ${a.toLocaleString()} bytes exceeded fetch size limit of ${this.fetchSizeLimit.toLocaleString()} bytes`);const f=n=>n.sequenceId===e&&n.alignmentStart<=r&&void 0!==n.lengthOnRef&&n.alignmentStart+n.lengthOnRef-1>=t,h=yield Promise.all(s.map((e=>this.getRecordsInSlice(e,f))));let l=Array.prototype.concat(...h);if(i.viewAsPairs){const e={},t={};for(let r=0;r<l.length;r+=1){const n=l[r].readName;if(void 0===n)throw new Error;const i=l[r].uniqueId;e[n]||(e[n]=0),e[n]+=1,t[i]=1;}const r={};Object.entries(e).forEach((([e,t])=>{1===t&&(r[e]=!0);}));const o=[];for(let e=0;e<l.length;e+=1){const t=l[e],s=t.readName;if(void 0===s)throw new Error;if(r[s]&&t.mate&&(t.mate.sequenceId===n||i.pairAcrossChr)&&Math.abs(t.alignmentStart-t.mate.alignmentStart)<i.maxInsertSize){const e=this.index.getEntriesForRange(t.mate.sequenceId,t.mate.alignmentStart,t.mate.alignmentStart+1);o.push(e);}}const s=yield Promise.all(o);let a=[];for(let e=0;e<s.length;e+=1)a.push(...s[e]);a=a.sort(((e,t)=>e.toString().localeCompare(t.toString()))).filter(((e,t,r)=>!t||e.toString()!==r[t-1].toString()));const h=[],u=a.map((e=>e.sliceBytes)).reduce(((e,t)=>e+t),0);if(u>this.fetchSizeLimit)throw new Error(`mate data size of ${u.toLocaleString()} bytes exceeded fetch size limit of ${this.fetchSizeLimit.toLocaleString()} bytes`);a.forEach((e=>{let n=this.cram.featureCache.get(e.toString());n||(n=this.getRecordsInSlice(e,(()=>!0)),this.cram.featureCache.set(e.toString(),n));const i=n.then((e=>{const n=[];for(let i=0;i<e.length;i+=1){const o=e[i];if(void 0===o.readName)throw new Error;r[o.readName]&&!t[o.uniqueId]&&n.push(o);}return n}));h.push(i);}));const c=yield Promise.all(h);if(c.length){const e=c.reduce(((e,t)=>e.concat(t)));l=l.concat(e);}}return l}))}getRecordsInSlice({containerStart:e,sliceStart:t,sliceBytes:r},n){return this.cram.getContainerAtPosition(e).getSlice(t,r).getRecords(n)}hasDataForReferenceSequence(e){return this.index.hasDataForReferenceSequence(e)}};},3427:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0}),t.open=t.fromUrl=t.RemoteFile=t.LocalFile=void 0;const i=n(r(8575)),o=r(4319),s=r(2949);function a(e){const{protocol:t,pathname:r}=i.default.parse(e);return "file:"===t?new s.LocalFile(unescape((0, o.ensureNotNullish)(r))):new s.RemoteFile(e)}Object.defineProperty(t,"LocalFile",{enumerable:!0,get:function(){return s.LocalFile}}),Object.defineProperty(t,"RemoteFile",{enumerable:!0,get:function(){return s.RemoteFile}}),t.fromUrl=a,t.open=function(e,t,r){if(r)return r;if(e)return a(e);if(t)return new s.LocalFile(t);throw new Error("no url, path, or filehandle provided, cannot open")};},5702:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.RANS_BYTE_L=t.TOTFREQ=t.TF_SHIFT=void 0,t.TF_SHIFT=12,t.TOTFREQ=4096,t.RANS_BYTE_L=1<<23;},6484:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const i=r(8577),o=r(5702),s=n(r(7634));t.default=function(e,t,r,n){let a=e.getInt(),f=e.getInt(),h=e.getInt(),l=e.getInt();const u=n.remaining(),c=-4&u;for(let i=0;i<c;i+=4){const u=t.R[s.default.get(a,o.TF_SHIFT)],c=t.R[s.default.get(f,o.TF_SHIFT)],d=t.R[s.default.get(h,o.TF_SHIFT)],p=t.R[s.default.get(l,o.TF_SHIFT)];n.putAt(i,u),n.putAt(i+1,c),n.putAt(i+2,d),n.putAt(i+3,p),a=s.default.advanceSymbolStep(a,r[255&u],o.TF_SHIFT),f=s.default.advanceSymbolStep(f,r[255&c],o.TF_SHIFT),h=s.default.advanceSymbolStep(h,r[255&d],o.TF_SHIFT),l=s.default.advanceSymbolStep(l,r[255&p],o.TF_SHIFT),a=s.default.renormalize(a,e),f=s.default.renormalize(f,e),h=s.default.renormalize(h,e),l=s.default.renormalize(l,e);}let d;switch(n.setPosition(c),3&u){case 0:break;case 1:d=t.R[s.default.get(a,o.TF_SHIFT)],s.default.advanceSymbol(a,e,r[255&d],o.TF_SHIFT),n.put(d);break;case 2:d=t.R[s.default.get(a,o.TF_SHIFT)],s.default.advanceSymbol(a,e,r[255&d],o.TF_SHIFT),n.put(d),d=t.R[s.default.get(f,o.TF_SHIFT)],s.default.advanceSymbol(f,e,r[255&d],o.TF_SHIFT),n.put(d);break;case 3:d=t.R[s.default.get(a,o.TF_SHIFT)],s.default.advanceSymbol(a,e,r[255&d],o.TF_SHIFT),n.put(d),d=t.R[s.default.get(f,o.TF_SHIFT)],s.default.advanceSymbol(f,e,r[255&d],o.TF_SHIFT),n.put(d),d=t.R[s.default.get(h,o.TF_SHIFT)],s.default.advanceSymbol(h,e,r[255&d],o.TF_SHIFT),n.put(d);break;default:throw new i.CramMalformedError("invalid output size encountered during rANS decoding")}n.setPosition(0);};},7121:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const i=r(5702),o=n(r(7634));t.default=function(e,t,r,n){const s=t.remaining();let a=e.getInt(),f=e.getInt(),h=e.getInt(),l=e.getInt();const u=s>>2;let c=0,d=u,p=2*u,g=3*u,m=0,y=0,b=0,v=0;for(;c<u;c+=1,d+=1,p+=1,g+=1){const s=255&r[m].R[o.default.get(a,i.TF_SHIFT)],u=255&r[y].R[o.default.get(f,i.TF_SHIFT)],w=255&r[b].R[o.default.get(h,i.TF_SHIFT)],_=255&r[v].R[o.default.get(l,i.TF_SHIFT)];t.putAt(c,s),t.putAt(d,u),t.putAt(p,w),t.putAt(g,_),a=o.default.advanceSymbolStep(a,n[m][s],i.TF_SHIFT),f=o.default.advanceSymbolStep(f,n[y][u],i.TF_SHIFT),h=o.default.advanceSymbolStep(h,n[b][w],i.TF_SHIFT),l=o.default.advanceSymbolStep(l,n[v][_],i.TF_SHIFT),a=o.default.renormalize(a,e),f=o.default.renormalize(f,e),h=o.default.renormalize(h,e),l=o.default.renormalize(l,e),m=s,y=u,b=w,v=_;}for(;g<s;g+=1){const s=255&r[v].R[o.default.get(l,i.TF_SHIFT)];t.putAt(g,s),l=o.default.advanceSymbol(l,e,n[v][s],i.TF_SHIFT),v=s;}};},7634:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0});const n=r(8577),i=r(5702);class o{constructor(){this.F=void 0,this.C=void 0;}}function s(e,t,r,n){return r*(e>>n)+(e&(1<<n)-1)-t}const a={FC:o,AriDecoder:class{constructor(){this.fc=new Array(256);for(let e=0;e<this.fc.length;e+=1)this.fc[e]=new o;this.R=null;}},Symbol:class{constructor(){this.start=void 0,this.freq=void 0;}},symbolInit:function(e,t,r){if(!(t<=65536))throw new n.CramMalformedError("assertion failed: start <= 1<<16");if(!(r<=65536-t))throw new n.CramMalformedError("assertion failed: freq <= 1<<16");e.start=t,e.freq=r;},advanceStep:s,advanceSymbolStep:function(e,t,r){return s(e,t.start,t.freq,r)},get:function(e,t){return e&(1<<t)-1},advanceSymbol:function(e,t,r,n){return function(e,t,r,n,o){if((e=n*(e>>o)+(e&(1<<o)-1)-r)<i.RANS_BYTE_L)do{e=e<<8|255&t.get();}while(e<i.RANS_BYTE_L);return e}(e,t,r.start,r.freq,n)},renormalize:function(e,t){if(e<i.RANS_BYTE_L)do{e=e<<8|255&t.get();}while(e<i.RANS_BYTE_L);return e}};t.default=a;},696:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0}),t.readStatsO1=t.readStatsO0=void 0;const i=r(8577),o=r(5702),s=n(r(7634));function a(e){if(!e)throw new i.CramMalformedError("assertion failed")}t.readStatsO0=function(e,t,r){let n=0,i=0,f=255&e.get();do{null==t.fc[f]&&(t.fc[f]=new s.default.FC),t.fc[f].F=255&e.get(),t.fc[f].F>=128&&(t.fc[f].F&=-129,t.fc[f].F=(127&t.fc[f].F)<<8|255&e.get()),t.fc[f].C=i,s.default.symbolInit(r[f],t.fc[f].C,t.fc[f].F),t.R||(t.R=new Array(o.TOTFREQ)),t.R.fill(f,i,i+t.fc[f].F),i+=t.fc[f].F,0===n&&f+1===(255&e.getByteAt(e.position()))?(f=255&e.get(),n=255&e.get()):0!==n?(n-=1,f+=1):f=255&e.get();}while(0!==f);a(i<o.TOTFREQ);},t.readStatsO1=function(e,t,r){let n=0,i=255&e.get();do{let f=0,h=0,l=255&e.get();null==t[i]&&(t[i]=new s.default.AriDecoder);do{null==t[i].fc[l]&&(t[i].fc[l]=new s.default.FC),t[i].fc[l].F=255&e.get(),t[i].fc[l].F>=128&&(t[i].fc[l].F&=-129,t[i].fc[l].F=(127&t[i].fc[l].F)<<8|255&e.get()),t[i].fc[l].C=h,0===t[i].fc[l].F&&(t[i].fc[l].F=o.TOTFREQ),null==r[i][l]&&(r[i][l]=new s.default.RansDecSymbol),s.default.symbolInit(r[i][l],t[i].fc[l].C,t[i].fc[l].F),null==t[i].R&&(t[i].R=new Array(o.TOTFREQ)),t[i].R.fill(l,h,h+t[i].fc[l].F),h+=t[i].fc[l].F,a(h<=o.TOTFREQ),0===f&&l+1===(255&e.getByteAt(e.position()))?(l=255&e.get(),f=255&e.get()):0!==f?(f-=1,l+=1):l=255&e.get();}while(0!==l);0===n&&i+1===(255&e.getByteAt(e.position()))?(i=255&e.get(),n=255&e.get()):0!==n?(n-=1,i+=1):i=255&e.get();}while(0!==i)};},9675:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const i=r(8577),o=n(r(7634)),s=r(696),a=n(r(6484)),f=n(r(7121));class h{constructor(e,t=0){this._buffer=e,this._position=t,this.length=e.length;}get(){const e=this._buffer[this._position];return this._position+=1,e}getByte(){return this.get()}getByteAt(e){return this._buffer[e]}position(){return this._position}put(e){return this._buffer[this._position]=e,this._position+=1,e}putAt(e,t){return this._buffer[e]=t,t}setPosition(e){return this._position=e,e}getInt(){const e=this._buffer.readInt32LE(this._position);return this._position+=4,e}remaining(){return this._buffer.length-this._position}}t.default=function(e,t,r=0){if(0===e.length)return t.fill(0),t;const n=new h(e,r),l=n.get();if(0!==l&&1!==l)throw new i.CramMalformedError(`Invalid rANS order ${l}`);if(n.getInt()!==n.remaining()-4)throw new i.CramMalformedError("Incorrect input length.");const u=n.getInt(),c=new h(t||Buffer.allocUnsafe(u));if(c.length<u)throw new i.CramMalformedError(`Output buffer too small to fit ${u} bytes.`);switch(l){case 0:return function(e,t){const r=new o.default.AriDecoder,n=new Array(256);for(let e=0;e<n.length;e+=1)n[e]=new o.default.Symbol;return (0, s.readStatsO0)(e,r,n),(0, a.default)(e,r,n,t),t}(n,c);case 1:return function(e,t){const r=new Array(256);for(let e=0;e<r.length;e+=1)r[e]=new o.default.AriDecoder;const n=new Array(256);for(let e=0;e<n.length;e+=1){n[e]=new Array(256);for(let t=0;t<n[e].length;t+=1)n[e][t]=new o.default.Symbol;}return (0, s.readStatsO1)(e,r,n),(0, f.default)(e,t,r,n),t}(n,c);default:throw new i.CramMalformedError(`Invalid rANS order: ${l}`)}};},7578:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.parseHeaderText=void 0,t.parseHeaderText=function(e){const t=e.split(/\r?\n/),r=[];return t.forEach((e=>{const[t,...n]=e.split(/\t/),i=n.map((e=>{const[t,r]=e.split(":",2);return {tag:t,value:r}}));t&&r.push({tag:t.substr(1),data:i});})),r};},4319:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.ensureNotNullish=void 0,t.ensureNotNullish=function(e){if(null==e)throw new Error("Value must not be nullish.");return e};},597:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.unzip=void 0;const n=r(9591);t.unzip=function(e){return Buffer.from((0, n.inflate)(e))};},9996:(e,t,r)=>{function n(e){return n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},n(e)}var i=r(8764).Buffer,o=r(22),s=r(2961)._,a=r(3720);"undefined"!=typeof window&&(window.Buffer=i),"undefined"!=typeof self&&(self.Buffer=i);var f={UInt8:1,UInt16LE:2,UInt16BE:2,UInt32LE:4,UInt32BE:4,Int8:1,Int16LE:2,Int16BE:2,Int32LE:4,Int32BE:4,FloatLE:4,FloatBE:4,DoubleLE:8,DoubleBE:8,UInt64:8,Int64:8},h={},l="___parser_",u=[];!function(){var e;for(e=1;e<=32;e++)u.push(e);}();var c={};Object.keys(f).concat(Object.keys({String:null,Buffer:null,Array:null,Skip:null,Choice:null,Nest:null,Bit:null,Itf8:null,Ltf8:null})).forEach((function(e){c[e.toLowerCase()]=e;}));var d=function(){this.varName="",this.type="",this.options={},this.next=null,this.head=null,this.compiled=null,this.endian="le",this.constructorFn=null,this.alias=null;};d.start=function(){return new d},Object.keys(f).forEach((function(e){d.prototype[e.toLowerCase()]=function(t,r){return this.setNextParser(e.toLowerCase(),t,r)};var t=e.replace(/BE|LE/,"").toLowerCase();t in d.prototype||(d.prototype[t]=function(e,r){return this[t+this.endian](e,r)});})),u.forEach((function(e){d.prototype["bit".concat(e.toString())]=function(t,r){return r||(r={}),r.length=e,this.setNextParser("bit",t,r)};})),d.prototype.namely=function(e){return h[e]=this,this.alias=e,this},d.prototype.skip=function(e,t){if(t&&t.assert)throw new Error("assert option on skip is not allowed.");return this.setNextParser("skip","",{length:e})},d.prototype.string=function(e,t){if(!t.zeroTerminated&&!t.length&&!t.greedy)throw new Error("Neither length, zeroTerminated, nor greedy is defined for string.");if((t.zeroTerminated||t.length)&&t.greedy)throw new Error("greedy is mutually exclusive with length and zeroTerminated for string.");if(t.stripNull&&!t.length&&!t.greedy)throw new Error("Length or greedy must be defined if stripNull is defined.");return t.encoding=t.encoding||"utf8",this.setNextParser("string",e,t)},d.prototype.buffer=function(e,t){if(!t.length&&!t.readUntil)throw new Error("Length nor readUntil is defined in buffer parser");return this.setNextParser("buffer",e,t)},d.prototype.array=function(e,t){if(!t.readUntil&&!t.length&&!t.lengthInBytes)throw new Error("Length option of array is not defined.");if(!t.type)throw new Error("Type option of array is not defined.");if("string"==typeof t.type&&!h[t.type]&&Object.keys(f).indexOf(c[t.type])<0)throw new Error('Specified primitive type "'.concat(t.type,'" is not supported.'));return this.setNextParser("array",e,t)},d.prototype.choice=function(e,t){if(1===arguments.length&&"object"===n(e)&&(t=e,e=null),!t.tag)throw new Error("Tag option of array is not defined.");if(!t.choices)throw new Error("Choices option of array is not defined.");return Object.keys(t.choices).forEach((function(r){if(!t.choices[r])throw new Error("Choice Case ".concat(r," of ").concat(e," is not valid."));if("string"==typeof t.choices[r]&&!h[t.choices[r]]&&Object.keys(f).indexOf(c[t.choices[r]])<0)throw new Error('Specified primitive type "'.concat(t.choices[r],'" is not supported.'))}),this),this.setNextParser("choice",e,t)},d.prototype.nest=function(e,t){if(1===arguments.length&&"object"===n(e)&&(t=e,e=null),!t.type)throw new Error("Type option of nest is not defined.");if(!(t.type instanceof d||h[t.type]))throw new Error("Type option of nest must be a Parser object.");if(!(t.type instanceof d||e))throw new Error("options.type must be a object if variable name is omitted.");return this.setNextParser("nest",e,t)},d.prototype.endianess=function(e){switch(e.toLowerCase()){case"little":this.endian="le";break;case"big":this.endian="be";break;default:throw new Error("Invalid endianess: ".concat(e))}return this},d.prototype.create=function(e){if(!(e instanceof Function))throw new Error("Constructor must be a Function object.");return this.constructorFn=e,this},d.prototype.getCode=function(){var e=new s;return e.pushCode("if (!Buffer.isBuffer(buffer)) {"),e.generateError('"argument buffer is not a Buffer object"'),e.pushCode("}"),this.alias?this.addAliasedCode(e):this.addRawCode(e),this.alias?e.pushCode("return {0}(0)",l+this.alias):e.pushCode("return { offset: offset, result: vars };"),e.code},d.prototype.addRawCode=function(e){e.pushCode("var offset = 0;"),this.constructorFn?e.pushCode("var vars = new constructorFn();"):e.pushCode("var vars = {};"),this.generate(e),this.resolveReferences(e),e.pushCode("return { offset: offset, result: vars };");},d.prototype.addAliasedCode=function(e){return e.pushCode("function {0}(offset) {",l+this.alias),this.constructorFn?e.pushCode("var vars = new constructorFn();"):e.pushCode("var vars = {};"),this.generate(e),e.markResolved(this.alias),this.resolveReferences(e),e.pushCode("return { offset: offset, result: vars };"),e.pushCode("}"),e},d.prototype.resolveReferences=function(e){var t=e.getUnresolvedReferences();e.markRequested(t),t.forEach((function(t){h[t].addAliasedCode(e);}));},d.prototype.compile=function(){var e="(function(buffer, constructorFn, Long) { ".concat(this.getCode()," })");this.compiled=o.runInThisContext(e);},d.prototype.sizeOf=function(){var e=NaN;if(Object.keys(f).indexOf(this.type)>=0)e=f[this.type];else if("String"===this.type&&"number"==typeof this.options.length)e=this.options.length;else if("Buffer"===this.type&&"number"==typeof this.options.length)e=this.options.length;else if("Array"===this.type&&"number"==typeof this.options.length){var t=NaN;"string"==typeof this.options.type?t=f[c[this.options.type]]:this.options.type instanceof d&&(t=this.options.type.sizeOf()),e=this.options.length*t;}else "Skip"===this.type?e=this.options.length:"Nest"===this.type?e=this.options.type.sizeOf():this.type||(e=0);return this.next&&(e+=this.next.sizeOf()),e},d.prototype.parse=function(e){return this.compiled||this.compile(),this.compiled(e,this.constructorFn,a)},d.prototype.setNextParser=function(e,t,r){var n=new d;return n.type=c[e],n.varName=t,n.options=r||n.options,n.endian=this.endian,this.head?this.head.next=n:this.next=n,this.head=n,this},d.prototype.generate=function(e){this.type&&(this["generate".concat(this.type)](e),this.generateAssert(e));var t=e.generateVariable(this.varName);return this.options.formatter&&this.generateFormatter(e,t,this.options.formatter),this.generateNext(e)},d.prototype.generateAssert=function(e){if(this.options.assert){var t=e.generateVariable(this.varName);switch(n(this.options.assert)){case"function":e.pushCode("if (!({0}).call(vars, {1})) {",this.options.assert,t);break;case"number":e.pushCode("if ({0} !== {1}) {",this.options.assert,t);break;case"string":e.pushCode('if ("{0}" !== {1}) {',this.options.assert,t);break;default:throw new Error("Assert option supports only strings, numbers and assert functions.")}e.generateError('"Assert error: {0} is " + {0}',t),e.pushCode("}");}},d.prototype.generateNext=function(e){return this.next&&(e=this.next.generate(e)),e},Object.keys(f).forEach((function(e){d.prototype["generate".concat(e)]=function(t){"UInt64"===e?t.pushCode("{0} = Long.fromBytes(buffer.slice(offset,offset+8), true, this.endian === 'le').toNumber();",t.generateVariable(this.varName),e):"Int64"===e?t.pushCode("{0} = Long.fromBytes(buffer.slice(offset,offset+8), false, this.endian === 'le').toNumber();",t.generateVariable(this.varName),e):t.pushCode("{0} = buffer.read{1}(offset);",t.generateVariable(this.varName),e),t.pushCode("offset += {0};",f[e]);};})),d.prototype.generateBit=function(e){var t=JSON.parse(JSON.stringify(this));if(t.varName=e.generateVariable(t.varName),e.bitFields.push(t),!this.next||this.next&&["Bit","Nest"].indexOf(this.next.type)<0){var r=0;e.bitFields.forEach((function(e){r+=e.options.length;}));var n=e.generateTmpVariable();if(r<=8)e.pushCode("var {0} = buffer.readUInt8(offset);",n),r=8;else if(r<=16)e.pushCode("var {0} = buffer.readUInt16BE(offset);",n),r=16;else if(r<=24){var i=e.generateTmpVariable(),o=e.generateTmpVariable();e.pushCode("var {0} = buffer.readUInt16BE(offset);",i),e.pushCode("var {0} = buffer.readUInt8(offset + 2);",o),e.pushCode("var {2} = ({0} << 8) | {1};",i,o,n),r=24;}else {if(!(r<=32))throw new Error("Currently, bit field sequence longer than 4-bytes is not supported.");e.pushCode("var {0} = buffer.readUInt32BE(offset);",n),r=32;}e.pushCode("offset += {0};",r/8);var s=0,a="be"===this.endian;e.bitFields.forEach((function(t){e.pushCode("{0} = {1} >> {2} & {3};",t.varName,n,a?r-s-t.options.length:s,(1<<t.options.length)-1),s+=t.options.length;})),e.bitFields=[];}},d.prototype.generateSkip=function(e){var t=e.generateOption(this.options.length);e.pushCode("offset += {0};",t);},d.prototype.generateString=function(e){var t=e.generateVariable(this.varName),r=e.generateTmpVariable();this.options.length&&this.options.zeroTerminated?(e.pushCode("var {0} = offset;",r),e.pushCode("while(buffer.readUInt8(offset++) !== 0 && offset - {0}  < {1});",r,this.options.length),e.pushCode("{0} = buffer.toString('{1}', {2}, offset - {2} < {3} ? offset - 1 : offset);",t,this.options.encoding,r,this.options.length)):this.options.length?(e.pushCode("{0} = buffer.toString('{1}', offset, offset + {2});",t,this.options.encoding,e.generateOption(this.options.length)),e.pushCode("offset += {0};",e.generateOption(this.options.length))):this.options.zeroTerminated?(e.pushCode("var {0} = offset;",r),e.pushCode("while(buffer.readUInt8(offset++) !== 0);"),e.pushCode("{0} = buffer.toString('{1}', {2}, offset - 1);",t,this.options.encoding,r)):this.options.greedy&&(e.pushCode("var {0} = offset;",r),e.pushCode("while(buffer.length > offset++);"),e.pushCode("{0} = buffer.toString('{1}', {2}, offset);",t,this.options.encoding,r)),this.options.stripNull&&e.pushCode("{0} = {0}.replace(/\\x00+$/g, '')",t);},d.prototype.generateBuffer=function(e){"eof"===this.options.readUntil?e.pushCode("{0} = buffer.slice(offset);",e.generateVariable(this.varName)):(e.pushCode("{0} = buffer.slice(offset, offset + {1});",e.generateVariable(this.varName),e.generateOption(this.options.length)),e.pushCode("offset += {0};",e.generateOption(this.options.length))),this.options.clone&&e.pushCode("{0} = Buffer.from({0});",e.generateVariable(this.varName));},d.prototype.generateArray=function(e){var t=e.generateOption(this.options.length),r=e.generateOption(this.options.lengthInBytes),n=this.options.type,i=e.generateTmpVariable(),o=e.generateVariable(this.varName),s=e.generateTmpVariable(),a=this.options.key,u="string"==typeof a;if(u?e.pushCode("{0} = {};",o):e.pushCode("{0} = [];",o),"function"==typeof this.options.readUntil?e.pushCode("do {"):"eof"===this.options.readUntil?e.pushCode("for (var {0} = 0; offset < buffer.length; {0}++) {",i):void 0!==r?e.pushCode("for (var {0} = offset; offset - {0} < {1}; ) {",i,r):e.pushCode("for (var {0} = 0; {0} < {1}; {0}++) {",i,t),"string"==typeof n)if(h[n]){var p=e.generateTmpVariable();e.pushCode("var {0} = {1}(offset);",p,l+n),e.pushCode("var {0} = {1}.result; offset = {1}.offset;",s,p),n!==this.alias&&e.addReference(n);}else e.pushCode("var {0} = buffer.read{1}(offset);",s,c[n]),e.pushCode("offset += {0};",f[c[n]]);else n instanceof d&&(e.pushCode("var {0} = {};",s),e.pushScope(s),n.generate(e),e.popScope());u?e.pushCode("{0}[{2}.{1}] = {2};",o,a,s):e.pushCode("{0}.push({1});",o,s),e.pushCode("}"),"function"==typeof this.options.readUntil&&e.pushCode(" while (!({0}).call(this, {1}, buffer.slice(offset)));",this.options.readUntil,s);},d.prototype.generateChoiceCase=function(e,t,r){if("string"==typeof r)if(h[r]){var n=e.generateTmpVariable();e.pushCode("var {0} = {1}(offset);",n,l+r),e.pushCode("{0} = {1}.result; offset = {1}.offset;",e.generateVariable(this.varName),n),r!==this.alias&&e.addReference(r);}else e.pushCode("{0} = buffer.read{1}(offset);",e.generateVariable(this.varName),c[r]),e.pushCode("offset += {0};",f[c[r]]);else r instanceof d&&(e.pushPath(t),r.generate(e),e.popPath(t));},d.prototype.generateChoice=function(e){var t=e.generateOption(this.options.tag);this.varName&&e.pushCode("{0} = {};",e.generateVariable(this.varName)),e.pushCode("switch({0}) {",t),Object.keys(this.options.choices).forEach((function(t){var r=this.options.choices[t];Number.isNaN(parseInt(t,10))?e.pushCode("case '{0}':",t):e.pushCode("case {0}:",t),this.generateChoiceCase(e,this.varName,r),e.pushCode("break;");}),this),e.pushCode("default:"),this.options.defaultChoice?this.generateChoiceCase(e,this.varName,this.options.defaultChoice):e.generateError('"Met undefined tag value " + {0} + " at choice"',t),e.pushCode("}");},d.prototype.generateNest=function(e){var t=e.generateVariable(this.varName);if(this.options.type instanceof d)this.varName&&e.pushCode("{0} = {};",t),e.pushPath(this.varName),this.options.type.generate(e),e.popPath(this.varName);else if(h[this.options.type]){var r=e.generateTmpVariable();e.pushCode("var {0} = {1}(offset);",r,l+this.options.type),e.pushCode("{0} = {1}.result; offset = {1}.offset;",t,r),this.options.type!==this.alias&&e.addReference(this.options.type);}},d.prototype.generateFormatter=function(e,t,r){"function"==typeof r&&e.pushCode("{0} = ({1}).call(this, {0});",t,r);},d.prototype.isInteger=function(){return !!this.type.match(/U?Int[8|16|32][BE|LE]?|Bit\d+/)},d.prototype.itf8=function(e,t){return this.setNextParser("itf8",e,t)},d.prototype.itf8=function(e,t){return this.setNextParser("itf8",e,t)},d.prototype.generateItf8=function(e){var t=e.generateVariable(this.varName),r=e.generateTmpVariable();e.pushCode("\n    var ".concat(r," = buffer[offset];\n    if (").concat(r," < 0x80) {\n      ").concat(t," = ").concat(r,";\n      offset += 1;\n    } else if (").concat(r," < 0xc0) {\n      ").concat(t," = ((").concat(r,"<<8) | buffer[offset+1]) & 0x3fff;\n      offset += 2;\n    } else if (").concat(r," < 0xe0) {\n      ").concat(t," = ((").concat(r,"<<16) | (buffer[offset+1]<< 8) |  buffer[offset+2]) & 0x1fffff;\n      offset += 3;\n    } else if (").concat(r," < 0xf0) {\n      ").concat(t," = ((").concat(r,"<<24) | (buffer[offset+1]<<16) | (buffer[offset+2]<<8) | buffer[offset+3]) & 0x0fffffff;\n      offset += 4\n    } else {\n      ").concat(t," = ((").concat(r," & 0x0f)<<28) | (buffer[offset+1]<<20) | (buffer[offset+2]<<12) | (buffer[offset+3]<<4) | (buffer[offset+4] & 0x0f);\n      // x=((0xff & 0x0f)<<28) | (0xff<<20) | (0xff<<12) | (0xff<<4) | (0x0f & 0x0f);\n      // TODO *val_p = uv < 0x80000000UL ? uv : -((int32_t) (0xffffffffUL - uv)) - 1;\n      offset += 5\n    }\n  "));},d.prototype.ltf8=function(e,t){return this.setNextParser("ltf8",e,t)},d.prototype.generateLtf8=function(e){var t=e.generateVariable(this.varName),r=e.generateTmpVariable();e.pushCode("\n  var ".concat(r," = buffer[offset];\n  if (").concat(r," < 0x80) {\n    ").concat(t," = ").concat(r,";\n    offset += 1;\n  } else if (").concat(r," < 0xc0) {\n    ").concat(t," = ((buffer[offset]<<8) | buffer[offset+1]) & 0x3fff;\n    offset += 2;\n  } else if (").concat(r," < 0xe0) {\n    ").concat(t," = ((buffer[offset]<<16) | (buffer[offset+1]<<8) | buffer[offset+2]) & 0x1fffff;\n    ").concat(t," = (((").concat(r," & 63) << 16) | buffer.readUInt16LE(offset + 1));\n    offset += 3;\n  } else if (").concat(r," < 0xf0) {\n    ").concat(t," = ((buffer[offset]<<24) | (buffer[offset+1]<<16) | (buffer[offset+2]<<8) | buffer[offset+3]) & 0x0fffffff;\n    offset += 4;\n  } else if (").concat(r," < 0xf8) {\n    ").concat(t," = (((buffer[offset] & 15) * Math.pow(2,32))) +\n      (buffer[offset+1]<<24) | (buffer[offset+2]<<16 | buffer[offset+3]<<8 | buffer[offset+4])\n    // TODO *val_p = uv < 0x80000000UL ? uv : -((int32_t) (0xffffffffUL - uv)) - 1;\n    offset += 5;\n  } else if (").concat(r," < 0xfc) {\n    ").concat(t," = ((((buffer[offset] & 7) << 8) | buffer[offset+1] )) * Math.pow(2,32) +\n      (buffer[offset+2]<<24) | (buffer[offset+3]<<16 | buffer[offset+4]<<8 | buffer[offset+5])\n    offset += 6;\n  } else if (").concat(r," < 0xfe) {\n    ").concat(t," = ((((buffer[offset] & 3) << 16) | buffer[offset+1]<<8 | buffer[offset+2])) * Math.pow(2,32) +\n      (buffer[offset+3]<<24) | (buffer[offset+4]<<16 | buffer[offset+5]<<8 | buffer[offset+6])\n    offset += 7;\n  } else if (").concat(r," < 0xff) {\n    ").concat(t," = Long.fromBytesBE(buffer.slice(offset+1,offset+8));\n    if (").concat(t,".greaterThan(Number.MAX_SAFE_INTEGER) || ").concat(t,".lessThan(Number.MIN_SAFE_INTEGER))\n      throw new Error('integer overflow')\n    ").concat(t," = ").concat(t,".toNumber()\n    offset += 8;\n  } else {\n    ").concat(t," = Long.fromBytesBE(buffer.slice(offset+1,offset+9));\n    if (").concat(t,".greaterThan(Number.MAX_SAFE_INTEGER) || ").concat(t,".lessThan(Number.MIN_SAFE_INTEGER))\n      throw new Error('integer overflow')\n    ").concat(t," = ").concat(t,".toNumber()\n    offset += 9;\n  }\n  "));},t.Parser=d;},2961:(e,t)=>{function r(e){return r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},r(e)}var n=function(){this.code="",this.scopes=[["vars"]],this.isAsync=!1,this.bitFields=[],this.tmpVariableCount=0,this.references={};};n.prototype.generateVariable=function(e){var t=[];for(Array.prototype.push.apply(t,this.scopes[this.scopes.length-1]);/^\$parent\./.test(e);)t.pop(),e=e.replace(/^\$parent\./,"");return e&&t.push(e),t.join(".")},n.prototype.generateOption=function(e){switch(r(e)){case"number":return e.toString();case"string":return this.generateVariable(e);case"function":return "(".concat(e,").call(").concat(this.generateVariable(),", vars)");default:return}},n.prototype.generateError=function(){var e=Array.prototype.slice.call(arguments),t=n.interpolate.apply(this,e);this.isAsync?this.pushCode("return process.nextTick(function() { callback(new Error(".concat(t,"), vars); });")):this.pushCode("throw new Error(".concat(t,");"));},n.prototype.generateTmpVariable=function(){return "$tmp".concat(this.tmpVariableCount++)},n.prototype.pushCode=function(){var e=Array.prototype.slice.call(arguments);this.code+="".concat(n.interpolate.apply(this,e),"\n");},n.prototype.pushPath=function(e){e&&this.scopes[this.scopes.length-1].push(e);},n.prototype.popPath=function(e){e&&this.scopes[this.scopes.length-1].pop();},n.prototype.pushScope=function(e){this.scopes.push([e]);},n.prototype.popScope=function(){this.scopes.pop();},n.prototype.addReference=function(e){this.references[e]||(this.references[e]={resolved:!1,requested:!1});},n.prototype.markResolved=function(e){this.references[e].resolved=!0;},n.prototype.markRequested=function(e){e.forEach(function(e){this.references[e].requested=!0;}.bind(this));},n.prototype.getUnresolvedReferences=function(){var e=this.references;return Object.keys(this.references).filter((function(t){return !e[t].resolved&&!e[t].requested}))},n.interpolate=function(e){var t=/{\d+}/g,r=e.match(t),n=Array.prototype.slice.call(arguments,1);return r&&r.forEach((function(t){var r=parseInt(t.substr(1,t.length-2),10);e=e.replace(t,n[r].toString());})),e},t._=n;},22:e=>{e.exports.runInThisContext=function(e){return new Function("code","return eval(code);").call(globalThis,e)};},445:(e,t,r)=>{const n=r(7381),i=r(9260),o=r(576),s=r(4693),a=128;e.exports=class{decode(e){return this.stream=new i(e),this.decodeStream(this.stream)}decodeStream(e,t=0){var r=this.stream.ReadByte();16&r||(t=this.stream.ReadUint7());var n,i=t,o=1&r;if(8&r)return this.decodeStripe(this.stream,t);if(r&a&&([n,i]=this.decodePackMeta(this.stream)),32&r)var s=this.decodeCat(this.stream,i);else s=4&r?this.decodeExt(this.stream,i):64&r?o?this.decodeRLE1(this.stream,i):this.decodeRLE0(this.stream,i):o?this.decode1(this.stream,i):this.decode0(this.stream,i);return r&a&&(s=this.decodePack(s,n,t)),s}encode(e,t){if(this.stream=new i("",0,1.1*e.length+100),this.stream.WriteByte(t),16&t||this.stream.WriteUint7(e.length),8&t)return Buffer.concat([this.stream.buf.slice(0,this.stream.pos),this.encodeStripe(this.stream,e,t>>8)]);var r,n=1&t,o=e.length;return t&a&&([r,e,o]=this.encodePack(e)),t&a&&this.stream.WriteStream(r),64&t?n?this.encodeRLE1(e,o,this.stream):this.encodeRLE0(e,o,this.stream):n?this.encode1(e,o,this.stream):this.encode0(e,o,this.stream)}decode0(e,t){var r=new Buffer.allocUnsafe(t),i=e.ReadByte();0==i&&(i=256);var s=new o(i),a=new n(e);a.RangeStartDecode(e);for(var f=0;f<t;f++)r[f]=s.ModelDecode(e,a);return r}encode0(e,t,r){for(var i=0,s=0;s<t;s++)i<e[s]&&(i=e[s]);i++;var a=new o(i);r.WriteByte(i);var f=new n(r);for(s=0;s<t;s++)a.ModelEncode(r,f,e[s]);return f.RangeFinishEncode(r),r.buf.slice(0,r.pos)}decode1(e,t){var r=new Buffer.allocUnsafe(t),i=e.ReadByte();0==i&&(i=256);for(var s=new Array(i),a=0;a<i;a++)s[a]=new o(i);var f=new n(e);f.RangeStartDecode(e);var h=0;for(a=0;a<t;a++)r[a]=s[h].ModelDecode(e,f),h=r[a];return r}encode1(e,t,r){for(var i=0,s=0;s<t;s++)i<e[s]&&(i=e[s]);i++;var a=new Array(i);for(s=0;s<i;s++)a[s]=new o(i);r.WriteByte(i);var f=new n(r),h=0;for(s=0;s<t;s++)a[h].ModelEncode(r,f,e[s]),h=e[s];return f.RangeFinishEncode(r),r.buf.slice(0,r.pos)}decodeExt(e,t){var r=new Buffer.allocUnsafe(t),n=s.array(e.buf.slice(e.pos)),i=s.header(n),o=0;do{var a=s.decompress(n,i);-1!=a&&(Buffer.from(a).copy(r,o),o+=a.length,i-=a.length);}while(-1!=a);return r}encodeExt(e,t){}decodeRLE0(e,t){var r=new Buffer.allocUnsafe(t),i=e.ReadByte();0==i&&(i=256);for(var s=new o(i),a=new Array(258),f=0;f<=257;f++)a[f]=new o(4);var h=new n(e);for(h.RangeStartDecode(e),f=0;f<t;){r[f]=s.ModelDecode(e,h);for(var l=a[r[f]].ModelDecode(e,h),u=l,c=256;3==l;)l=a[c].ModelDecode(e,h),c=257,u+=l;for(var d=1;d<=u;d++)r[f+d]=r[f];f+=u+1;}return r}encodeRLE0(e,t,r){for(var i=0,s=0;s<t;s++)i<e[s]&&(i=e[s]);i++;var a=new o(i),f=new Array(258);for(s=0;s<=257;s++)f[s]=new o(4);r.WriteByte(i);var h=new n(r);for(s=0;s<t;){a.ModelEncode(r,h,e[s]);for(var l=1;s+l<t&&e[s+l]==e[s];)l++;l--;var u=e[s];e[s],s+=l+1;var c=l>=3?3:l;for(f[u].ModelEncode(r,h,c),l-=c,u=256;3==c;)c=l>=3?3:l,f[u].ModelEncode(r,h,c),u=257,l-=c;}return h.RangeFinishEncode(r),r.buf.slice(0,r.pos)}decodeRLE1(e,t){var r=new Buffer.allocUnsafe(t),i=e.ReadByte();0==i&&(i=256);for(var s=new Array(i),a=0;a<i;a++)s[a]=new o(i);var f=new Array(258);for(a=0;a<=257;a++)f[a]=new o(4);var h=new n(e);h.RangeStartDecode(e);var l=0;for(a=0;a<t;){r[a]=s[l].ModelDecode(e,h),l=r[a];for(var u=f[r[a]].ModelDecode(e,h),c=u,d=256;3==u;)u=f[d].ModelDecode(e,h),d=257,c+=u;for(var p=1;p<=c;p++)r[a+p]=r[a];a+=c+1;}return r}encodeRLE1(e,t,r){for(var i=0,s=0;s<t;s++)i<e[s]&&(i=e[s]);i++;var a=new Array(i);for(s=0;s<i;s++)a[s]=new o(i);var f=new Array(258);for(s=0;s<=257;s++)f[s]=new o(4);r.WriteByte(i);for(var h=new n(r),l=(s=0,0);s<t;){a[l].ModelEncode(r,h,e[s]);for(var u=1;s+u<t&&e[s+u]==e[s];)u++;u--;var c=e[s];l=e[s],s+=u+1;var d=u>=3?3:u;for(f[c].ModelEncode(r,h,d),u-=d,c=256;3==d;)d=u>=3?3:u,f[c].ModelEncode(r,h,d),c=257,u-=d;}return h.RangeFinishEncode(r),r.buf.slice(0,r.pos)}decodePackMeta(e){this.nsym=e.ReadByte();for(var t=new Array(this.nsym),r=0;r<this.nsym;r++)t[r]=e.ReadByte();return [t,e.ReadUint7()]}decodePack(e,t,r){var n=new Buffer.allocUnsafe(r);if(this.nsym<=1)for(var i=0;i<r;i++)n[i]=t[0];else if(this.nsym<=2){i=0;for(var o=0;i<r;i++){if(i%8==0)var s=e[o++];n[i]=t[1&s],s>>=1;}}else if(this.nsym<=4)for(i=0,o=0;i<r;i++)i%4==0&&(s=e[o++]),n[i]=t[3&s],s>>=2;else {if(!(this.nsym<=16))return e;for(i=0,o=0;i<r;i++)i%2==0&&(s=e[o++]),n[i]=t[15&s],s>>=4;}return n}packMeta(e){for(var t=new i("",0,1024),r=new Array(256),n=0;n<e.length;n++)r[e[n]]=1;var o=0;for(n=0;n<256;n++)r[n]&&(r[n]=++o);for(t.WriteByte(o),n=0;n<256;n++)r[n]&&(t.WriteByte(n),r[n]--);return [t,r,o]}encodePack(e){var t,r,n;[t,r,n]=this.packMeta(e);var i=e.length,o=0;if(n<=1)return t.WriteUint7(0),[t,new Buffer.allocUnsafe(0),0];if(n<=2){for(var s=new Buffer.allocUnsafe(Math.floor((i+7)/8)),a=(o=0,0);o<(-8&i);o+=8,a++)s[a]=(r[e[o+0]]<<0)+(r[e[o+1]]<<1)+(r[e[o+2]]<<2)+(r[e[o+3]]<<3)+(r[e[o+4]]<<4)+(r[e[o+5]]<<5)+(r[e[o+6]]<<6)+(r[e[o+7]]<<7);if(o<i){s[a]=0;for(var f=0;o<i;)s[a]|=r[e[o++]]<<f,f++;a++;}return t.WriteUint7(a),[t,s,s.length]}if(n<=4){for(s=new Buffer.allocUnsafe(Math.floor((i+3)/4)),o=0,a=0;o<(-4&i);o+=4,a++)s[a]=(r[e[o+0]]<<0)+(r[e[o+1]]<<2)+(r[e[o+2]]<<4)+(r[e[o+3]]<<6);if(o<i){for(s[a]=0,f=0;o<i;)s[a]|=r[e[o++]]<<f,f+=2;a++;}return t.WriteUint7(a),[t,s,s.length]}if(n<=16){for(s=new Buffer.allocUnsafe(Math.floor((i+1)/2)),o=0,a=0;o<(-2&i);o+=2,a++)s[a]=(r[e[o+0]]<<0)+(r[e[o+1]]<<4);return o<i&&(s[a++]=r[e[o++]]),t.WriteUint7(a),[t,s,s.length]}return t.WriteUint7(e.length),[t,e,e.length]}encodeStripe(e,t,r){0==r&&(r=4);for(var n=new Array(r),o=new Array(r),s=0;s<r;s++)o[s]=Math.floor(t.length/r)+(t.length%r>s),n[s]=new Array(o[s]);for(var a=0,f=0;f<t.length;f+=r,a++)for(var h=0;h<r;h++)a<n[h].length&&(n[h][a]=t[f+h]);var l=new Array(r),u=0;for(s=0;s<r;s++){var c=this.encode(n[s],0),d=this.encode(n[s],1);l[s]=d.length<c.length?d:c,u+=l[s].length;}var p=new i("",0,u+5*r+1);for(p.WriteByte(r),s=0;s<r;s++)p.WriteUint7(l[s].length);for(s=0;s<r;s++)p.WriteData(l[s],l[s].length);return p.buf.slice(0,p.buf.pos)}decodeStripe(e,t){for(var r=e.ReadByte(),n=new Array(r),i=new Array(r),o=0;o<r;o++)n[o]=e.ReadUint7();var s=new Array(r);for(o=0;o<r;o++)i[o]=Math.floor(t/r)+(t%r>o),s[o]=this.decodeStream(e,i[o]);var a=new Buffer.allocUnsafe(t);for(o=0;o<r;o++)for(var f=0;f<i[o];f++)a[f*r+o]=s[o][f];return a}decodeCat(e,t){for(var r=new Buffer.allocUnsafe(t),n=0;n<t;n++)r[n]=e.ReadByte();return r}};},7381:e=>{e.exports=class{constructor(e){this.low=0,this.range=4294967295,this.code=0,this.FFnum=0,this.carry=0,this.cache=0;}RangeStartDecode(e){for(var t=0;t<5;t++)this.code=(this.code<<8)+e.ReadByte();this.code&=4294967295,this.code>>>=0;}RangeGetFrequency(e){return this.range=Math.floor(this.range/e),Math.floor(this.code/this.range)}RangeDecode(e,t,r,n){for(this.code-=t*this.range,this.range*=r;this.range<1<<24;)this.range*=256,this.code=256*this.code+e.ReadByte();}RangeShiftLow(e){if(this.low<4278190080|this.carry){for(e.WriteByte(this.cache+this.carry);this.FFnum;)e.WriteByte(this.carry-1),this.FFnum--;this.cache=this.low>>>24,this.carry=0;}else this.FFnum++;this.low<<=8,this.low>>>=0;}RangeEncode(e,t,r,n){var i=this.low;for(this.range=Math.floor(this.range/n),this.low+=t*this.range,this.low>>>=0,this.range*=r,this.low<i&&(0!=this.carry&&console.log("ERROR: Multiple carry"),this.carry=1);this.range<1<<24;)this.range*=256,this.RangeShiftLow(e);}RangeFinishEncode(e){for(var t=0;t<5;t++)this.RangeShiftLow(e);}};},576:e=>{e.exports=class{constructor(e=256){this.total_freq=e,this.max_sym=e-1,this.S=new Array,this.F=new Array;for(var t=0;t<=this.max_sym;t++)this.S[t]=t,this.F[t]=1;}ModelDecode(e,t){for(var r=t.RangeGetFrequency(this.total_freq),n=0,i=0;n+this.F[i]<=r;)n+=this.F[i++];t.RangeDecode(e,n,this.F[i],this.total_freq),this.F[i]+=16,this.total_freq+=16,this.total_freq>65519&&this.ModelRenormalise();var o=this.S[i];if(i>0&&this.F[i]>this.F[i-1]){var s=this.F[i];this.F[i]=this.F[i-1],this.F[i-1]=s,s=this.S[i],this.S[i]=this.S[i-1],this.S[i-1]=s;}return o}ModelRenormalise(){this.total_freq=0;for(var e=0;e<=this.max_sym;e++)this.F[e]-=Math.floor(this.F[e]/2),this.total_freq+=this.F[e];}ModelEncode(e,t,r){for(var n=0,i=0;this.S[i]!=r;i++)n+=this.F[i];if(t.RangeEncode(e,n,this.F[i],this.total_freq),this.F[i]+=16,this.total_freq+=16,this.total_freq>65519&&this.ModelRenormalise(),r=this.S[i],i>0&&this.F[i]>this.F[i-1]){var o=this.F[i];this.F[i]=this.F[i-1],this.F[i-1]=o,o=this.S[i],this.S[i]=this.S[i-1],this.S[i-1]=o;}}};},5260:(e,t,r)=>{const n=r(9260),i=r(576),o=r(7381);function s(e,t,r){for(var n=0,i=0,o=-1,s=new Array(1024);i<r;){var a=e.ReadByte();if(s[n++]=a,i+=a,a==o){var f=e.ReadByte();for(i+=a*f;f--;)s[n++]=a;}o=a;}var h=0;for(n=0,i=0;i<r;){var l=0;do{var u=s[n++];l+=u;}while(255==u);for(;l--;)t[i++]=h;h++;}}function a(e,t,r){var n=e.context;return t.qctx=(t.qctx<<e.qshift)+e.qtab[r],n+=(t.qctx&(1<<e.qbits)-1)<<e.qloc,e.do_pos&&(n+=e.ptab[Math.min(t.p,1023)]<<e.ploc),e.do_delta&&(n+=e.dtab[Math.min(t.delta,255)]<<e.dloc,t.delta+=t.prevq!=r?1:0,t.prevq=r),e.do_sel&&(n+=t.s<<e.sloc),t.p--,65535&n}function f(e){var t={};t.context=e.ReadUint16(),t.pflags=e.ReadByte(),t.do_dedup=2&t.pflags,t.fixed_len=4&t.pflags,t.do_sel=8&t.pflags,t.do_qmap=16&t.pflags,t.do_pos=32&t.pflags,t.do_delta=64&t.pflags,t.do_qtab=128&t.pflags,t.max_sym=e.ReadByte();var r=e.ReadByte();if(t.qbits=r>>4,t.qshift=15&r,r=e.ReadByte(),t.qloc=r>>4,t.sloc=15&r,r=e.ReadByte(),t.ploc=r>>4,t.dloc=15&r,t.qmap=new Array(256),16&t.pflags)for(var n=0;n<t.max_sym;n++)t.qmap[n]=e.ReadByte();else for(n=0;n<256;n++)t.qmap[n]=n;if(t.qtab=new Array(1024),t.qbits>0&&128&t.pflags)s(e,t.qtab,256);else for(n=0;n<256;n++)t.qtab[n]=n;return t.ptab=new Array(1024),32&t.pflags&&s(e,t.ptab,1024),t.dtab=new Array(256),64&t.pflags&&s(e,t.dtab,256),t}function h(e,t,r,n,i,o){r.max_sel>0?i.s=n.sel.ModelDecode(e,t):i.s=0,i.x=r.stab[i.s];var s=r.params[i.x];if(s.fixed_len>=0){var a=n.len[0].ModelDecode(e,t);a|=n.len[1].ModelDecode(e,t)<<8,a|=n.len[2].ModelDecode(e,t)<<16,a|=n.len[3].ModelDecode(e,t)<<24,s.fixed_len>0&&(s.fixed_len=-a);}else a=-s.fixed_len;i.len=a,r.do_rev&&(o[i.rec]=n.rev.ModelDecode(e,t)),i.is_dup=0,2&s.pflags&&n.dup.ModelDecode(e,t)&&(i.is_dup=1),i.p=a,i.delta=0,i.qctx=0,i.prevq=0,i.rec++;}function l(e,t,r){for(var n=0,i=0,o=new Array(2*r),s=0;n<r;){for(var a=n;n<r&&t[n]==i;)n++;var f=n-a;do{var h=Math.min(255,f);o[s++]=h,f-=h;}while(255==h);i++;}var l=-1,u=new Array(2*r),c=0;for(n=0;n<s;){var d=o[n++];if(u[c++]=d,d==l){for(a=n;n<s&&o[n]==l&&n-a<255;)n++;u[c++]=n-a;}else l=d;}e.WriteData(u,c);}e.exports={decode:function(e,t){return function(e,t){var r=e.ReadUint7(),n=function(e){var t={max_sym:0};if(5==e.ReadByte()){var r=e.ReadByte(),n=1&r?e.ReadByte():1,i=r.nparam>1?r.nparam-1:0,o=new Array(256);if(2&r)i=e.ReadByte(),s(e,o,256);else {for(var a=0;a<n;a++)o[a]=a;for(;a<256;a++)o[a]=n-1;}t.do_rev=4&r,t.stab=o,t.max_sel=i,t.params=new Array(t.nparam);for(var h=0;h<n;h++)t.params[h]=f(e),t.max_sym<t.params[h].max_sym&&(t.max_sym=t.params[h].max_sym);return t}console.error("Invalid FQZComp version number");}(e);if(n){var l=n.params,u=new Array(t.length),c=function(e){var t={};t.qual=new Array(65536);for(var r=0;r<65536;r++)t.qual[r]=new i(e.max_sym+1);for(t.len=new Array(4),r=0;r<4;r++)t.len[r]=new i(256);return t.rev=new i(2),t.dup=new i(2),e.max_sel>0&&(t.sel=new i(e.max_sel+1)),t}(n),d=new o(e);d.RangeStartDecode(e);for(var p=new Buffer.allocUnsafe(r),g={qctx:0,prevq:0,delta:0,p:0,s:0,x:0,len:0,is_dup:0,rec:0},m=0;m<r;){if(0==g.p){if(h(e,d,n,c,g,u),g.is_dup>0&&c.dup.ModelDecode(e,d)){for(var y=0;y<len;y++)p[m+y]=p[m+y-g.len];m+=g.len,g.p=0;continue}t.push(g.len);var b=(l=n.params[g.x]).context;}var v=c.qual[b].ModelDecode(e,d);p[m++]=l.qmap[v],b=a(l,g,v);}return n.do_rev&&function(e,t,r,n){for(var i=0,o=0;o<t;){if(r[i])for(var s=0,a=n[i]-1;s<a;){var f=e[o+s];e[o+s]=e[o+a],e[o+a]=f,s++,a--;}o+=n[i++];}}(p,r,u,t),p}}(new n(e),t)},encode:function(e,t,r){for(var s=new Array(2),a=new Array(2),f=new Array(2),h=new Array(2),u=new Array(256),c=0;c<2;c++)s[c]=new Array(256),a[c]=new Array(256),f[c]=new Array(1024),h[c]=new Array(256);(p=new n("",0,1.1*e.length+100)).WriteUint7(e.length);var d=function(e,t,r,n){for(var i=r[0],o=0;o<r.length&&r[o]==i;o++);var s=o==r.length?1:0,a=0,f=0;for(o=0;o<256;o++)n[0][o]=0;var h=0,l=0;for(o=0;o<e.length;o++)0==l&&(l=t[h<t.length-1?h++:h]),n[0][e[o]]++,l--;for(o=0;o<256;o++)n[0][o]&&(f<o&&(f=o),a++);var u=5,c=0;return a<=16&&(c=1,u=a<=2?1:a<=4?2:a<=8?3:4),[{qbits:8+(u>4),qshift:u,qloc:7,pbits:7,pshift:t[0]>128?1:0,ploc:0,dbits:u>4?0:1,dshift:3,dloc:15,sbits:0,sloc:15,do_stab:0,context:0,max_sym:f,nsym:a,do_qmap:c,do_dedup:0,fixed_len:1==t.length?1:0,do_sel:0,do_rev:0,do_pos:1,do_delta:u<=4?1:0,do_qtab:0,qbits:8+(u>4)-(0==s),sbits:1,sloc:15-(u<=4),do_stab:1,do_sel:1}]}(e,t,r,s),p=function(e,t,r,n,i,o,s){for(var a=[0,1,1,1,2,2,2,2,2,3,3,3,3,3,3,3,4,4,4,4,4,4,4,4,4,5,5,5,5,5,5,5,5,5,5,5,6,6,6,6,6,6,6,6,6,6,6,6,6,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7],f=0;f<t.length;f++)s[f]=f;for(;f<256;f++)s[f]=t.length-1;e.WriteByte(5);var h=(t.length>1?1:0)|(t[0].do_stab?2:0);if(e.WriteByte(h),1&h&&e.WriteByte(t.length),2&h){var u=1<<t[0].sbits;u>0&&u--,e.WriteByte(u),l(e,s,256);}for(var c=0;c<t.length;c++){if(e.WriteUint16(t[c].context),e.WriteByte((t[c].do_qtab?128:0)|(t[c].do_delta?64:0)|(t[c].do_pos?32:0)|(t[c].do_qmap?16:0)|(t[c].do_sel?8:0)|(t[c].fixed_len?4:0)|(t[c].do_dedup?2:0)),t[c].do_qmap?e.WriteByte(t[c].nsym):e.WriteByte(t[c].max_sym),e.WriteByte(t[c].qbits<<4|t[c].qshift),e.WriteByte(t[c].qloc<<4|t[c].sloc),e.WriteByte(t[c].ploc<<4|t[c].dloc),t[c].do_qmap){t[c].max_sym=t[c].nsym;var d=0;for(f=0;f<256;f++)r[c][f]&&(e.WriteByte(f),r[c][f]=d++);for(;d<t[c].nsym;d++)e.WriteByte(0);}else for(f=0;f<256;f++)r[c][f]=f;if(t[c].qbits>0){for(f=0;f<256;f++)n[c][f]=f;t[c].do_qtab&&l(e,n[c],256);}if(t[c].pbits>0){for(f=0;f<1024;f++)i[c][f]=Math.min((1<<t[c].pbits)-1,f>>t[c].pshift);l(e,i[c],1024);}if(t[c].dbits>0){for(f=0;f<256;f++)a[f]>(1<<t[c].dbits)-1&&(a[f]=(1<<t[c].dbits)-1);for(f=0;f<256;f++)o[c][f]=a[Math.min(a.length-1,f>>t[c].dshift)];l(e,o[c],256);}}return e}(p,d,s,a,f,h,u);return function(e,t,r,n,s,a,f,h,l,u){var c=1<<s[0].sbits;c>0&&c--;for(var d=t.length,p=0,g=0;g<s.length;g++)p<s[g].max_sym&&(p=s[g].max_sym);for(var m=new Array(65536),y=0;y<65536;y++)m[y]=new i(p+1);var b=new Array(4);for(y=0;y<4;y++)b[y]=new i(256);new i(2),new i(2);for(var v=new i(c+1),w=new o(t),_=(g=0,y=0,0);y<d;){if(0==g){var B=n[_];s[0].sbits>0&&v.ModelEncode(e,w,B);var E=u[B],S=r[Math.min(r.length-1,_++)];s[E].fixed_len?s[E].fixed_len>0&&(b[0].ModelEncode(e,w,255&S),b[1].ModelEncode(e,w,S>>8&255),b[2].ModelEncode(e,w,S>>16&255),b[3].ModelEncode(e,w,S>>24&255),s[E].fixed_len=-1):(b[0].ModelEncode(e,w,255&S),b[1].ModelEncode(e,w,S>>8&255),b[2].ModelEncode(e,w,S>>16&255),b[3].ModelEncode(e,w,S>>24&255)),s[E].do_dedup&&process.exit(1),g=S;var A=0,C=s[E].context,R=0,k=0;}var x=t[y++],I=a[E][x];m[C].ModelEncode(e,w,I),R=(R<<s[E].qshift)+f[E][I],C=s[E].context,C+=(R&(1<<s[E].qbits)-1)<<s[E].qloc,s[E].pbits>0&&(C+=h[E][Math.min(g,1023)]<<s[E].ploc),s[E].dbits>0&&(C+=l[E][Math.min(A,255)]<<s[E].dloc,A+=k!=I?1:0,k=I),s[E].do_sel&&(C+=B<<s[E].sloc),C&=65535,g--;}return w.RangeFinishEncode(e),e.buf.slice(0,e.pos)}(p,e,t,r,d,s,a,f,h,u)}};},3498:(e,t,r)=>{var n=r(4459),i=r(594),o=r(445),s=r(5260),a=r(2881);e.exports={r4x8_uncompress:function(e,t){n.decode(e).copy(t,0,0);},r4x16_uncompress:function(e,t){i.decode(e).copy(t,0,0);},arith_uncompress:function(e,t){o.decode(e).copy(t,0,0);},fqzcomp_uncompress:function(e,t){var r=new Array;s.decode(e,r).copy(t,0,0);},tok3_uncompress:function(e,t){var r=a.decode(e,0,"\0");Buffer.from(r,"binary").copy(t,0,0);}};},9260:e=>{e.exports=class{constructor(e,t=0,r=0){0!=r?(this.buf=Buffer.allocUnsafe(r),this.length=r):(this.buf=e,this.length=e.length),this.pos=t;}EOF(){return this.pos>=this.length}ReadData(e){var t=this.buf.slice(this.pos,this.pos+e);return this.pos+=e,t}ReadByte(){const e=this.buf[this.pos];return this.pos++,e}ReadChar(){const e=this.buf[this.pos];return this.pos++,String.fromCharCode(e)}ReadUint16(){return this.ReadByte()|this.ReadByte()<<8}ReadUint32(){const e=this.buf.readInt32LE(this.pos);return this.pos+=4,e}ReadString(){var e="";do{var t=this.buf[this.pos++];t&&(e+=String.fromCharCode(t));}while(t);return e}ReadUint7(){var e=0;do{var t=this.ReadByte();e=e<<7|127&t;}while(128&t);return e}ReadITF8(){var e=this.buf[this.pos];return this.pos++,e>=240?(e=(15&e)<<28,e+=(this.buf[this.pos+0]<<20)+(this.buf[this.pos+1]<<12)+(this.buf[this.pos+2]<<4)+(this.buf[this.pos+3]>>4),this.pos+=4):e>=224?(e=(15&e)<<24,e+=(this.buf[this.pos+0]<<16)+(this.buf[this.pos+1]<<8)+(this.buf[this.pos+2]<<0),this.pos+=3):e>=192?(e=(31&e)<<16,e+=(this.buf[this.pos+0]<<8)+(this.buf[this.pos+1]<<0),this.pos+=2):e>=128&&(e=(63&e)<<8,e+=this.buf[this.pos],this.pos++),e}WriteByte(e){this.buf[this.pos++]=e;}WriteChar(e){this.buf[this.pos++]=e.charCodeAt(0);}WriteString(e){for(var t=0;t<e.length;t++)this.buf[this.pos++]=e.charCodeAt(t);this.buf[this.pos++]=0;}WriteData(e,t){for(var r=0;r<t;r++)this.buf[this.pos++]=e[r];}WriteStream(e){this.WriteData(e.buf,e.pos);}WriteUint16(e){this.WriteByte(255&e),this.WriteByte(e>>8&255);}WriteUint32(e){this.buf.writeInt32LE(e,this.pos),this.pos+=4;}WriteUint7(e){var t=0,r=e;do{t+=7,r>>=7;}while(r>0);do{t-=7,this.WriteByte((e>>t&127)+((t>0)<<7));}while(t>0)}WriteITF8(e){e<0&&(e=1+e),e<=127?this.buf[this.pos++]=e:e<=16383?(this.buf[this.pos++]=128|Math.floor(e/256),this.buf[this.pos++]=255&e):e<131071?(this.buf[this.pos++]=192|Math.floor(e/65536),this.buf[this.pos++]=255&Math.floor(e/256),this.buf[this.pos++]=255&e):e<268435455?(this.buf[this.pos++]=224|Math.floor(e/16777216),this.buf[this.pos++]=255&Math.floor(e/65536),this.buf[this.pos++]=255&Math.floor(e/256),this.buf[this.pos++]=255&e):(this.buf[this.pos++]=240|Math.floor(e/268435456),this.buf[this.pos++]=255&Math.floor(e/1048576),this.buf[this.pos++]=255&Math.floor(e/4096),this.buf[this.pos++]=255&Math.floor(e/4),this.buf[this.pos++]=15&e);}WriteByteNeg(e){this.buf[--this.pos]=e;}};},4459:(e,t,r)=>{const n=r(9260);function i(e){return 4095&e}function o(e,t){for(var r=0;t>=e[r+1];)r++;return r}function s(e){for(var t=new Array(4096),r=0,n=0;n<4096;n++){for(;n>=e[r+1];)r++;t[n]=r;}return t}function a(e,t,r){return r*(e>>12)+(4095&e)-t}function f(e,t){for(;t<1<<23;)t=(t<<8)+e.ReadByte();return t}function h(e,t){t.WriteByteNeg(e>>24&255),t.WriteByteNeg(e>>16&255),t.WriteByteNeg(e>>8&255),t.WriteByteNeg(e>>0&255);}function l(e,t,r,n,i){return e=function(e,t,r,n){for(var i=(1<<23>>n<<8)*r;e>=i;)t.WriteByteNeg(255&e),e>>=8;return e}(e,t,n,i),(Math.floor(e/n)<<i)+e%n+r}function u(e,t,r){for(var n=0;n<256;n++)t[n]=0;var i=e.ReadByte(),o=i,s=0;do{var a=e.ReadITF8();t[i]=a,s>0?(s--,i++):(i=e.ReadByte())==o+1&&(s=e.ReadByte()),o=i;}while(0!=i);for(r[0]=0,n=0;n<=255;n++)r[n+1]=r[n]+t[n];}function c(e){for(var t=0,r=0;r<256;r++)t+=e[r];const n=4096;var i=n/t;do{var o=0,s=0,a=0;for(t=0,r=0;r<256;r++)0!=e[r]&&(o<e[r]&&(o=e[r],s=r),e[r]=Math.floor(e[r]*i),0==e[r]&&(e[r]=1),t+=e[r]);t<n?e[s]+=n-t:t-n<e[s]/2&&e[s]>2?e[s]-=t-n:t!=n&&(i*=.99,a=1);}while(a)}function d(e,t){for(var r=0,n=0;n<256;n++)if(t[n]){if(r>0)r--;else if(e.WriteByte(n),n>0&&t[n-1]>0){for(r=n+1;r<256&&t[r];r++);r-=n+1,e.WriteByte(r);}e.WriteITF8(t[n]);}e.WriteByte(0);}e.exports={decode:function(e){var t=new n(e),r=t.ReadByte(),h=(t.ReadUint32(),t.ReadUint32());return 0==r?function(e,t){var r=new Array(256),n=new Array(256);u(e,r,n);for(var o=s(n),h=new Array(4),l=0;l<4;l++)h[l]=e.ReadUint32();var c=new Buffer.allocUnsafe(t);for(l=0;l<t;l++){var d=l%4,p=o[i(h[d])];c[l]=p,h[d]=a(h[d],n[p],r[p]),h[d]=f(e,h[d]);}return c}(t,h):function(e,t){var r=new Array(256),n=new Array(256);!function(e,t,r){for(var n=0;n<256;n++){t[n]=new Array(256),r[n]=new Array(256);for(var i=0;i<256;i++)t[n][i]=0;}var o=e.ReadByte(),s=o,a=0;do{u(e,t[o],r[o]),a>0?(a--,o++):(o=e.ReadByte())==s+1&&(a=e.ReadByte()),s=o;}while(0!=o)}(e,r,n);for(var h=new Array(256),l=0;l<256;l++)h[l]=s(n[l]);for(var c=new Array(4),d=new Array(4),p=0;p<4;p++)c[p]=e.ReadUint32(),d[p]=0;var g=new Buffer.allocUnsafe(t),m=Math.floor(t/4);for(l=0;l<m;l++)for(p=0;p<4;p++){var y=i(c[p]),b=h[d[p]][y];g[l+p*m]=b,c[p]=a(c[p],n[d[p]][b],r[d[p]][b]),c[p]=f(e,c[p]),d[p]=b;}for(l*=4;l<t;)y=i(c[3]),b=o(n[d[3]],y),g[l++]=b,c[3]=a(c[3],n[d[3]][b],r[d[3]][b]),c[3]=f(e,c[3]),d[3]=b;return g}(t,h)},encode:function(e,t){return 0==t?function(e){const t=e.length;var r=new n("",0,780);r.WriteByte(0),r.WriteUint32(0),r.WriteUint32(0);var i=new Array(256);((function(e,t){for(var r=0;r<256;r++)t[r]=0;for(r=0;r<e.length;r++)t[e[r]]++;}))(e,i),c(i),d(r,i);var o=new Array(256);o[0]=0;for(var s=1;s<256;s++)o[s]=o[s-1]+i[s-1];var a=new Array(4);for(s=0;s<4;s++)a[s]=1<<23;var f=Math.floor(1.05*t+100),u=new n("",f,f);for(s=t-1;s>=0;s--)a[s%4]=l(a[s%4],u,o[e[s]],i[e[s]],12);for(s=3;s>=0;s--)h(a[s],u);var p=r.pos;return r.buf.writeInt32LE(p-9+(u.length-u.pos),1),r.buf.writeInt32LE(t,5),Buffer.concat([r.buf.slice(0,r.pos),u.buf.slice(u.pos,u.length)],r.pos+u.length-u.pos)}(e):function(e){const t=e.length;var r=new n("",0,198156);r.WriteByte(1),r.WriteUint32(0),r.WriteUint32(0);for(var i=new Array(256),o=new Array(256),s=new Array(256),a=0;a<256;a++)o[a]=new Array(256),s[a]=new Array(256);for(function(e,t,r){for(var n=0;n<256;n++){r[n]=0;for(var i=0;i<256;i++)t[n][i]=0;}var o=0;for(n=0;n<e.length;n++)r[e[n]]++,t[o][e[n]]++,o=e[n];t[0][e[1*(e.length>>2)]]++,t[0][e[2*(e.length>>2)]]++,t[0][e[3*(e.length>>2)]]++,r[0]+=3;}(e,o,i),function(e,t){for(var r=0;r<256;r++)t[r]&&c(e[r]);}(o,i),function(e,t,r){for(var n=0,i=0;i<256;i++)if(r[i]){if(n>0)n--;else if(e.WriteByte(i),i>0&&r[i-1]>0){for(n=i+1;n<256&&r[n];n++);n-=i+1,e.WriteByte(n);}d(e,t[i]);}e.WriteByte(0);}(r,o,i),a=0;a<256;a++)if(i[a]){s[a][0]=0;for(var f=1;f<256;f++)s[a][f]=s[a][f-1]+o[a][f-1];}var u=new Array(4),p=new Array(4);for(f=0;f<4;f++)u[f]=1<<23,p[f]=0;var g=new n("",t,t),m=Math.floor(t/4),y=new Array(4),b=new Array(4);for(f=0;f<4;f++)y[f]=(f+1)*m-2,b[f]=e[y[f]+1];for(b[3]=e[t-1],a=t-2;a>4*m-2;a--)u[3]=l(u[3],g,s[e[a]][b[3]],o[e[a]][b[3]],12),b[3]=e[a];for(;y[0]>=0;)for(f=3;f>=0;f--){var v=e[y[f]];u[f]=l(u[f],g,s[v][b[f]],o[v][b[f]],12),b[f]=v,y[f]--;}for(f=3;f>=0;f--)u[f]=l(u[f],g,s[0][b[f]],o[0][b[f]],12);for(a=3;a>=0;a--)h(u[a],g);var w=r.pos;return r.buf.writeInt32LE(w-9+(g.length-g.pos),1),r.buf.writeInt32LE(t,5),Buffer.concat([r.buf.slice(0,r.pos),g.buf.slice(g.pos,g.length)],r.pos+g.length-g.pos)}(e)}};},594:(e,t,r)=>{const n=r(9260);function i(e,t){return e&(1<<t)-1}function o(e,t){for(var r=0;t>=e[r+1];)r++;return r}function s(e,t){for(var r=1<<t,n=new Array(r),i=0,o=0;o<r;o++){for(;o>=e[i+1];)i++;n[o]=i;}return n}function a(e,t,r,n){return r*(e>>n)+(e&(1<<n)-1)-t}function f(e,t){return t<32768&&(t=(t<<16)+e.ReadUint16()),t}function h(e,t){t.WriteByteNeg(e>>24&255),t.WriteByteNeg(e>>16&255),t.WriteByteNeg(e>>8&255),t.WriteByteNeg(e>>0&255);}function l(e,t,r,n,i){return e=function(e,t,r,n){for(var i=(1<<31-n)*r;e>=i;)t.WriteByteNeg(e>>8&255),t.WriteByteNeg(255&e),e>>=16;return e}(e,t,n,i),(Math.floor(e/n)<<i)+e%n+r}function u(e,t,r){0==r&&(r=4);for(var i=new Array(r),o=new Array(r),s=0;s<r;s++)o[s]=Math.floor(t.length/r)+(t.length%r>s),i[s]=new Array(o[s]);for(var a=0,f=0;f<t.length;f+=r,a++)for(var h=0;h<r;h++)a<i[h].length&&(i[h][a]=t[f+h]);var l=new Array(r),u=0;for(s=0;s<r;s++){var c=d(i[s],0),p=d(i[s],1);l[s]=p.length<c.length?p:c,u+=l[s].length;}var g=new n("",0,u+5*r+1);for(g.WriteByte(r),s=0;s<r;s++)g.WriteUint7(l[s].length);for(s=0;s<r;s++)g.WriteData(l[s],l[s].length);return g.buf.slice(0,g.buf.pos)}function c(e,t){var r=e.ReadByte(),h=1&r,l=8&r,u=32&r,d=64&r,m=128&r;if(16&r||(t=e.ReadUint7()),l)return function(e,t){for(var r=e.ReadByte(),n=new Array(r),i=new Array(r),o=0;o<r;o++)n[o]=e.ReadUint7();var s=new Array(r);for(o=0;o<r;o++)i[o]=Math.floor(t/r)+(t%r>o),s[o]=c(e,i[o]);var a=new Buffer.allocUnsafe(t);for(o=0;o<r;o++)for(var f=0;f<i[o];f++)a[f*r+o]=s[o][f];return a}(e,t);if(m)var b=t,[v,w,t]=function(e){for(var t=e.ReadByte(),r=new Array(t),n=0;n<t;n++)r[n]=e.ReadByte();return [r,t,e.ReadUint7()]}(e);if(d)var _=t,[B,E,t]=function(e){var t=e.ReadUint7(),r=e.ReadUint7();if(1&t)var i=e.ReadData((t-1)/2);else {var o=e.ReadUint7();i=e.ReadData(o),i=g(new n(i),t/2);}i=new n(i);var s=new Array(256),a=i.ReadByte();0==a&&(a=256);for(var f=0;f<a;f++)s[i.ReadByte()]=1;return [s,i,r]}(e);if(u)var S=e.ReadData(t);else S=0==h?g(e,t):function(e,t){var r=(c=e.ReadByte())>>4,h=e;if(1&c){var l=e.ReadUint7(),u=e.ReadUint7(),c=new n(e.ReadData(u));h=new n(g(c,l));}var d=new Array(256),m=new Array(256);!function(e,t,r,n){for(var i=0;i<256;i++){t[i]=new Array(256),r[i]=new Array(256);for(var o=0;o<256;o++)t[i][o]=0;}var s=p(e);for(i=0;i<256;i++)if(s[i]){var a=0;for(o=0;o<256;o++)s[o]&&(a>0?a--:(t[i][o]=e.ReadUint7(),0==t[i][o]&&(a=e.ReadByte())));for(y(t[i],n),r[i][0]=0,o=0;o<256;o++)r[i][o+1]=r[i][o]+t[i][o];}}(h,d,m,r);for(var b=new Array(256),v=0;v<256;v++)b[v]=s(m[v],r);for(var w=new Array(4),_=new Array(4),B=0;B<4;B++)w[B]=e.ReadUint32(),_[B]=0;var E=new Buffer.allocUnsafe(t),S=Math.floor(t/4);for(v=0;v<S;v++)for(B=0;B<4;B++){var A=i(w[B],r),C=b[_[B]][A];E[v+B*S]=C,w[B]=a(w[B],m[_[B]][C],d[_[B]][C],r),w[B]=f(e,w[B]),_[B]=C;}for(v*=4;v<t;)A=i(w[3],r),C=o(m[_[3]],A),E[v++]=C,w[3]=a(w[3],m[_[3]][C],d[_[3]][C],r),w[3]=f(e,w[3]),_[3]=C;return E}(e,t);return d&&(S=function(e,t,r,i){new n(e);for(var o=new Buffer.allocUnsafe(i),s=0,a=0;s<i;a++){var f=e[a];if(t[f])for(var h=r.ReadUint7(),l=0;l<=h;l++)o[s++]=f;else o[s++]=f;}return o}(S,B,E,_)),m&&(S=function(e,t,r,n){var i=new Buffer.allocUnsafe(n),o=0;if(r<=1)for(var s=0;s<n;s++)i[s]=t[0];else if(r<=2)for(s=0;s<n;s++){if(s%8==0)var a=e[o++];i[s]=t[1&a],a>>=1;}else if(r<=4)for(s=0;s<n;s++)s%4==0&&(a=e[o++]),i[s]=t[3&a],a>>=2;else if(r<=16)for(s=0;s<n;s++)s%2==0&&(a=e[o++]),i[s]=t[15&a],a>>=4;return i}(S,v,w,b)),S}function d(e,t){var r=new n("",0,10);r.WriteByte(t);var i=1&t,o=8&t,s=32&t,a=64&t,f=128&t,c=t>>8;if(16&t||r.WriteUint7(e.length),o)return Buffer.concat([r.buf.slice(0,r.pos),u(0,e,c)]);var d=new Buffer.alloc(0);f&&([d,e]=function(e){for(var t=new Array(256),r=0;r<256;r++)t[r]=0;for(r=0;r<e.length;r++)t[e[r]]++;var i=new Array(256),o=0;for(r=0;r<256;r++)t[r]>0&&(i[r]=o++);if(!(o>16)){if(o<=1)var s=new Buffer.allocUnsafe(0);else if(o<=2){s=new Buffer.allocUnsafe(Math.ceil(e.length/8));var a=-1;for(r=0;r<e.length;r++)r%8==0&&(s[++a]=0),s[a]+=i[e[r]]<<r%8;}else if(o<=4)for(s=new Buffer.allocUnsafe(Math.ceil(e.length/4)),a=-1,r=0;r<e.length;r++)r%4==0&&(s[++a]=0),s[a]+=i[e[r]]<<r%4*2;else for(s=new Buffer.allocUnsafe(Math.ceil(e.length/2)),a=-1,r=0;r<e.length;r++)r%2==0&&(s[++a]=0),s[a]+=i[e[r]]<<r%2*4;var f=new n("",0,o+5);for(f.WriteByte(o),a=0,r=0;r<256;r++)t[r]>0&&(t[r]=a++,f.WriteByte(r));return f.WriteUint7(s.length),[f.buf.slice(0,f.pos),s]}}(e));var p=new Buffer.alloc(0);if(a&&([p,e]=function(e){for(var t=new Array(256),r=0;r<256;r++)t[r]=0;var i=-1;for(r=0;r<e.length;r++)t[e[r]]+=e[r]==i?1:-1,i=e[r];var o=0;for(r=0;r<256;r++)t[r]>0&&o++;for(o||(o=1,t[0]=1),(h=new n("",0,o+1+e.length)).WriteByte(o),r=0;r<256;r++)t[r]>0&&h.WriteByte(r);var s=new Buffer.allocUnsafe(e.length),a=0;for(r=0;r<e.length;r++)if(s[a++]=e[r],t[e[r]]>0){i=e[r];for(var f=0;r+f+1<e.length&&e[r+f+1]==i;)f++;h.WriteUint7(f),r+=f;}var h,l=v(h.buf.slice(0,h.pos)),u=new n("",0,16);return u.WriteUint7(2*h.pos),u.WriteUint7(a),u.WriteUint7(l.length),[h=Buffer.concat([u.buf.slice(0,u.pos),l]),s.slice(0,a)]}(e)),e.length<4&&1==i&&(i=0,r.buf[0]&=-2),s)var g=e;else g=0==i?v(e):function(e){const t=e.length;for(var r=new n("",0,198156),i=new Array(256),o=new Array(256),s=new Array(256),a=0;a<256;a++)o[a]=new Array(256),s[a]=new Array(256);var f=12;((function(e,t,r){for(var n=0;n<256;n++){r[n]=0;for(var i=0;i<256;i++)t[n][i]=0;}var o=0;for(n=0;n<e.length;n++)r[o]++,t[o][e[n]]++,o=e[n];r[o]++,t[0][e[1*(e.length>>2)]]++,t[0][e[2*(e.length>>2)]]++,t[0][e[3*(e.length>>2)]]++,r[0]+=3;}))(e,o,i),function(e,t,r){for(var n=0;n<256;n++)if(t[n]){var i=Math.ceil(Math.log2(t[n]));i>12&&(i=12),m(e[n],i);}}(o,i);var u=new n("",0,198156);!function(e,t,r){b(e,r);for(var n=0;n<256;n++)if(r[n])for(var i=0,o=0;o<256;o++)if(r[o])if(i)i--;else if(e.WriteUint7(t[n][o]),!t[n][o]){for(var s=o+1;s<256;s++)if(r[s]){if(0!=t[n][s])break;i++;}e.WriteByte(i);}}(u,o,i);var c=v(u.buf.slice(0,u.pos));for(c.length<u.pos?(r.WriteByte(193),r.WriteUint7(u.pos),r.WriteUint7(c.length),r.WriteData(c,c.length)):(r.WriteByte(192),r.WriteData(u.buf,u.pos)),function(e,t,r){for(var n=0;n<256;n++)t[n]&&y(e[n],12);}(o,i),a=0;a<256;a++)if(i[a]){s[a][0]=0;for(var d=1;d<256;d++)s[a][d]=s[a][d-1]+o[a][d-1];}var p=new Array(4),g=new Array(4);for(d=0;d<4;d++)p[d]=32768,g[d]=0;var w=new n("",1.05*t+100>>0,1.05*t+100>>0),_=Math.floor(t/4),B=new Array(4),E=new Array(4);for(d=0;d<4;d++)B[d]=(d+1)*_-2,E[d]=e[B[d]+1];for(E[3]=e[t-1],a=t-2;a>4*_-2;a--)p[3]=l(p[3],w,s[e[a]][E[3]],o[e[a]][E[3]],f),E[3]=e[a];for(;B[0]>=0;)for(d=3;d>=0;d--){var S=e[B[d]];p[d]=l(p[d],w,s[S][E[d]],o[S][E[d]],f),E[d]=S,B[d]--;}for(d=3;d>=0;d--)p[d]=l(p[d],w,s[0][E[d]],o[0][E[d]],f);for(a=3;a>=0;a--)h(p[a],w);return Buffer.concat([r.buf.slice(0,r.pos),w.buf.slice(w.pos,w.length)],r.pos+w.length-w.pos)}(e);return Buffer.concat([r.buf.slice(0,r.pos),d,p,g])}function p(e){for(var t=new Array(256),r=0;r<256;r++)t[r]=0;var n=0,i=e.ReadByte(),o=i;do{t[i]=1,n>0?(n--,i++):(i=e.ReadByte())==o+1&&(n=e.ReadByte()),o=i;}while(0!=i);return t}function g(e,t){var r=new Array(256),n=new Array(256);!function(e,t,r){for(var n=0;n<256;n++)t[n]=0;var i=p(e);for(n=0;n<256;n++)i[n]>0&&(t[n]=e.ReadUint7());for(y(t,12),r[0]=0,n=0;n<=255;n++)r[n+1]=r[n]+t[n];}(e,r,n);for(var o=s(n,12),h=new Array(4),l=0;l<4;l++)h[l]=e.ReadUint32();var u=new Buffer.allocUnsafe(t);for(l=0;l<t;l++){var c=l%4,d=o[i(h[c],12)];u[l]=d,h[c]=a(h[c],n[d],r[d],12),h[c]=f(e,h[c]);}return u}function m(e,t){for(var r=0,n=0;n<256;n++)r+=e[n];const i=1<<t;var o=i/r;do{var s=0,a=0,f=0;for(r=0,n=0;n<256;n++)0!=e[n]&&(s<e[n]&&(s=e[n],a=n),e[n]=Math.floor(e[n]*o),0==e[n]&&(e[n]=1),r+=e[n]);r<i?e[a]+=i-r:r-i<e[a]/2&&e[a]>2?e[a]-=r-i:r!=i&&(o=i/r,f=1);}while(f)}function y(e,t){for(var r=0,n=0;n<256;n++)r+=e[n];if(0!=r&&r!=1<<t){for(var i=0;r<1<<t;)r*=2,i++;for(n=0;n<256;n++)e[n]<<=i;}}function b(e,t){for(var r=0,n=0;n<256;n++)if(t[n])if(r>0)r--;else if(e.WriteByte(n),n>0&&t[n-1]>0){for(r=n+1;r<256&&t[r];r++);r-=n+1,e.WriteByte(r);}e.WriteByte(0);}function v(e){const t=e.length;var r=new n("",0,780),i=new Array(256);!function(e,t){for(var r=0;r<256;r++)t[r]=0;for(r=0;r<e.length;r++)t[e[r]]++;}(e,i);var o=Math.ceil(Math.log2(t));o>12&&(o=12),m(i,o),function(e,t){b(e,t);for(var r=0;r<256;r++)t[r]&&e.WriteUint7(t[r]);}(r,i),m(i,12);var s=new Array(256);s[0]=0;for(var a=1;a<256;a++)s[a]=s[a-1]+i[a-1];var f=new Array(4);for(a=0;a<4;a++)f[a]=32768;var u=new n("",1.05*t+100>>0,1.05*t+100>>0);for(a=t-1;a>=0;a--)f[a%4]=l(f[a%4],u,s[e[a]],i[e[a]],12);for(a=3;a>=0;a--)h(f[a],u);return Buffer.concat([r.buf.slice(0,r.pos),u.buf.slice(u.pos,u.length)],r.pos+u.length-u.pos)}e.exports={decode:function(e){return c(new n(e),0)},encode:d};},2881:(e,t,r)=>{const n=r(9260),i=r(594);var o=new(r(445));function s(e,t){for(var r=e+"";r.length<t;)r="0"+r;return r}function a(e,t,r,n){var i=e[0][0].ReadByte(),o=n-e[0][i].ReadUint32();if(5==i)return t[n]=t[o],r[n]=r[o],t[n];var a=1;t[n]="",r[n]=new Array(256);do{switch(i=e[a][0].ReadByte()){case 2:r[n][a]=e[a][2].ReadChar();break;case 1:r[n][a]=e[a][1].ReadString();break;case 7:r[n][a]=e[a][7].ReadUint32();break;case 3:var f=e[a][3].ReadUint32(),h=e[a][4].ReadByte();r[n][a]=s(f,h);break;case 8:r[n][a]=(r[o][a]>>0)+e[a][8].ReadByte();break;case 9:f=(r[o][a]>>0)+e[a][9].ReadByte(),h=r[o][a].length,r[n][a]=s(f,h);break;case 10:r[n][a]=r[o][a];break;default:r[n][a]="";}t[n]+=r[n][a++];}while(12!=i);return t[n]}function f(e,t,r,n,i,o){for(var s=0;s<n.length;s++)if(!(r>0&&5==t[s][0].type)&&t[s][r])switch(e[0].WriteByte(t[s][r].type),t[s][r].type){case 6:e[6].WriteUint32(t[s][r].val);break;case 5:e[5].WriteUint32(t[s][r].val);break;case 1:e[1].WriteString(t[s][r].val);break;case 2:e[2].WriteChar(t[s][r].val);break;case 7:e[7].WriteUint32(t[s][r].val);break;case 3:e[3].WriteUint32(t[s][r].val),e[4].WriteByte(t[s][r].val.length);break;case 8:case 9:e[t[s][r].type].WriteByte(t[s][r].val);}}function h(e,t,r,n){for(var i=0;i<=12;i++)if(!(e[i].pos<=0)){n.WriteByte(i+(0==i?128:0)),e[i]=e[i].buf.slice(0,e[i].pos);var o=l(e[i],r);n.WriteUint7(o.length),n.WriteData(o,o.length);}}function l(e,t){var r,n=1<<30,s=[0,1,64,65,128,129,201];for(var a in s){var f=s[a];if(!(1&f&&e.length<100||8&f&&e.length%4!=0)){try{var h=t?o.encode(e,f):i.encode(e,f);}catch(e){h=0;}h&&n>h.length&&(n=h.length,r=h);}}return r}function u(e,t,r,n,i){var o=0,s=i-1;e[i]=new Array(256),t[n]?e[i][0]={type:5,val:i-t[n]}:e[i][0]={type:6,val:0==i?0:1},t[n]=i;for(var a=n.match(/([a-zA-Z0-9]{1,9})|([^a-zA-Z0-9]+)/g),f=0;f<a.length;f++){var h=f+1,l=1,u=a[f];if(a[f].match(/^0+[0-9]*$/g)?l=3:a[f].match(/^[0-9]+$/g)?l=7:1==a[f].length&&(l=2),s>=0&&e[s][h])if(e[s][h].str==a[f])l=10,u="";else if(7==e[s][h].type||8==e[s][h].type){var c=u-e[s][h].str;r[h]++,c>=0&&c<256&&r[h]>i/2&&(l=8,u=c);}else 3!=e[s][h].type&&9!=e[s][h].type||e[s][h].str.length!=u.length||(c=u-e[s][h].str,r[h]++,c>=0&&c<256&&r[h]>i/2&&(l=9,u=c));e[i][h]={str:a[f],val:u,type:l},o<e[i][h].val.length+3&&(o=e[i][h].val.length+3);}return e[i][++h]={type:12},[h+1,o]}e.exports={encode:function(e,t){var r=e.toString();"\n"==r[r.length-1]&&(r=r.substring(0,r.length-1));var i=r.split("\n"),o=new n("",0,2*r.length+1e4);o.WriteUint32(r.length),o.WriteUint32(i.length),o.WriteByte(t);for(var s=new Array(i.length),a={},l=new Array(256).fill(0),c=0,d=0,p=0;p<i.length;p++){var[g,m]=u(s,a,l,i[p],p);c<g&&(c=g),d<m&&(d=m);}for(var y=0;y<c;y++){for(var b=new Array(13),v=0;v<=12;v++)b[v]=new n("",0,i.length*d);f(b,s,y,i),h(b,0,t,o);}return o.buf.slice(0,o.pos)},decode:function(e,t,r){(e=new n(e)).ReadUint32();var s=e.ReadUint32(),f=e.ReadByte(),h=function(e,t,r,s){for(var a=-1,f=new Array(256);!e.EOF();){var h=e.ReadByte(),l=128&h,u=64&h,c=63&h;if(l&&(f[++a]=new Array(13)),0!=c&&l){var d=new Array(s-1).fill(10);f[a][0]=new n(Buffer.from([c].concat(d)));}if(u){var p=e.ReadByte(),g=e.ReadByte();f[a][c]=new n(f[p][g].buf);}else {var m=e.ReadUint7(),y=e.ReadData(m);f[a][c]=r?o.decode(y):i.decode(y),f[a][c]=new n(f[a][c]);}}return f}(e,0,f,s),l=new Array(s),u=new Array(s),c="";void 0===r&&(r="\n");for(var d=0;d<s;d++)c+=a(h,l,u,d)+r;return c}};},1422:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const i=r(8904),o=n(r(9049)),s=n(r(450));class a{constructor({fill:e,cache:t}){if("function"!=typeof e)throw new TypeError("must pass a fill function");if("object"!=typeof t)throw new TypeError("must pass a cache object");if("function"!=typeof t.get||"function"!=typeof t.set||"function"!=typeof t.delete)throw new TypeError("cache must implement get(key), set(key, val), and and delete(key)");this.cache=t,this.fillCallback=e;}static isAbortException(e){return "AbortError"===e.name||"ERR_ABORTED"===e.code||"AbortError: aborted"===e.message||"Error: aborted"===e.message}evict(e,t){this.cache.get(e)===t&&this.cache.delete(e);}fill(e,t,r,n){const i=new o.default,a=new s.default;a.addCallback(n);const f={aborter:i,promise:this.fillCallback(t,i.signal,(e=>{a.callback(e);})),settled:!1,statusReporter:a,get aborted(){return this.aborter.signal.aborted}};f.aborter.addSignal(r),f.aborter.signal.addEventListener("abort",(()=>{f.settled||this.evict(e,f);})),f.promise.then((()=>{f.settled=!0;}),(()=>{f.settled=!0,this.evict(e,f);})).catch((e=>{throw console.error(e),e})),this.cache.set(e,f);}static checkSinglePromise(e,t){function r(){if(t&&t.aborted)throw Object.assign(new Error("aborted"),{code:"ERR_ABORTED"})}return e.then((e=>(r(),e)),(e=>{throw r(),e}))}has(e){return this.cache.has(e)}get(e,t,r,n){if(!r&&t instanceof i.AbortSignal)throw new TypeError("second get argument appears to be an AbortSignal, perhaps you meant to pass `null` for the fill data?");const o=this.cache.get(e);return o?o.aborted&&!o.settled?(this.evict(e,o),this.get(e,t,r,n)):o.settled?o.promise:(o.aborter.addSignal(r),o.statusReporter.addCallback(n),a.checkSinglePromise(o.promise,r)):(this.fill(e,t,r,n),a.checkSinglePromise(this.cache.get(e).promise,r))}delete(e){const t=this.cache.get(e);t&&(t.settled||t.aborter.abort(),this.cache.delete(e));}clear(){const e=this.cache.keys();let t=0;for(let r=e.next();!r.done;r=e.next())this.delete(r.value),t+=1;return t}}t.default=a;},9049:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0});const n=r(8904);class i{}t.default=class{constructor(){this.signals=new Set,this.abortController=new n.AbortController;}addSignal(e=new i){if(this.signal.aborted)throw new Error("cannot add a signal, already aborted!");this.signals.add(e),e.aborted?this.handleAborted(e):"function"==typeof e.addEventListener&&e.addEventListener("abort",(()=>{this.handleAborted(e);}));}handleAborted(e){this.signals.delete(e),0===this.signals.size&&this.abortController.abort();}get signal(){return this.abortController.signal}abort(){this.abortController.abort();}};},450:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.default=class{constructor(){this.callbacks=new Set;}addCallback(e=(()=>{})){this.callbacks.add(e),e(this.currentMessage);}callback(e){this.currentMessage=e,this.callbacks.forEach((t=>{t(e);}));}};},8904:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.AbortSignal=t.AbortController=void 0;const n=r(5988);var i=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if(void 0!==r.g)return r.g;throw new Error("unable to locate global object")};let o=void 0===i().AbortController?n.AbortController:i().AbortController;t.AbortController=o;let s=void 0===i().AbortController?n.AbortSignal:i().AbortSignal;t.AbortSignal=s;},4105:function(e,t,r){var n=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const i=n(r(1422));t.default=i.default;},5988:(e,t)=>{function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function n(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}function i(e,t,r){return t&&n(e.prototype,t),r&&n(e,r),Object.defineProperty(e,"prototype",{writable:!1}),e}function o(e){return o=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},o(e)}function s(e,t){return s=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},s(e,t)}function a(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function f(e,t){if(t&&("object"==typeof t||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return a(e)}function h(e,t){for(;!Object.prototype.hasOwnProperty.call(e,t)&&null!==(e=o(e)););return e}function l(){return l="undefined"!=typeof Reflect&&Reflect.get?Reflect.get.bind():function(e,t,r){var n=h(e,t);if(n){var i=Object.getOwnPropertyDescriptor(n,t);return i.get?i.get.call(arguments.length<3?e:r):i.value}},l.apply(this,arguments)}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(){r(this,e),Object.defineProperty(this,"listeners",{value:{},writable:!0,configurable:!0});}return i(e,[{key:"addEventListener",value:function(e,t,r){e in this.listeners||(this.listeners[e]=[]),this.listeners[e].push({callback:t,options:r});}},{key:"removeEventListener",value:function(e,t){if(e in this.listeners)for(var r=this.listeners[e],n=0,i=r.length;n<i;n++)if(r[n].callback===t)return void r.splice(n,1)}},{key:"dispatchEvent",value:function(e){if(e.type in this.listeners){for(var t=this.listeners[e.type].slice(),r=0,n=t.length;r<n;r++){var i=t[r];try{i.callback.call(this,e);}catch(e){Promise.resolve().then((function(){throw e}));}i.options&&i.options.once&&this.removeEventListener(e.type,i.callback);}return !e.defaultPrevented}}}]),e}(),c=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&s(e,t);}(c,e);var t,n,h=(t=c,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}(),function(){var e,r=o(t);if(n){var i=o(this).constructor;e=Reflect.construct(r,arguments,i);}else e=r.apply(this,arguments);return f(this,e)});function c(){var e;return r(this,c),(e=h.call(this)).listeners||u.call(a(e)),Object.defineProperty(a(e),"aborted",{value:!1,writable:!0,configurable:!0}),Object.defineProperty(a(e),"onabort",{value:null,writable:!0,configurable:!0}),Object.defineProperty(a(e),"reason",{value:void 0,writable:!0,configurable:!0}),e}return i(c,[{key:"toString",value:function(){return "[object AbortSignal]"}},{key:"dispatchEvent",value:function(e){"abort"===e.type&&(this.aborted=!0,"function"==typeof this.onabort&&this.onabort.call(this,e)),l(o(c.prototype),"dispatchEvent",this).call(this,e);}}]),c}(u),d=function(){function e(){r(this,e),Object.defineProperty(this,"signal",{value:new c,writable:!0,configurable:!0});}return i(e,[{key:"abort",value:function(e){var t;try{t=new Event("abort");}catch(e){"undefined"!=typeof document?document.createEvent?(t=document.createEvent("Event")).initEvent("abort",!1,!1):(t=document.createEventObject()).type="abort":t={type:"abort",bubbles:!1,cancelable:!1};}var r=e;if(void 0===r)if("undefined"==typeof document)(r=new Error("This operation was aborted")).name="AbortError";else try{r=new DOMException("signal is aborted without reason");}catch(e){(r=new Error("This operation was aborted")).name="AbortError";}this.signal.reason=r,this.signal.dispatchEvent(t);}},{key:"toString",value:function(){return "[object AbortController]"}}]),e}();"undefined"!=typeof Symbol&&Symbol.toStringTag&&(d.prototype[Symbol.toStringTag]="AbortController",c.prototype[Symbol.toStringTag]="AbortSignal"),t.AbortController=d,t.AbortSignal=c,t.abortableFetch=function(e){"function"==typeof e&&(e={fetch:e});var t=e,r=t.fetch,n=t.Request,i=void 0===n?r.Request:n,o=t.AbortController,s=t.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL,a=void 0!==s&&s;if(!function(e){return e.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL?(console.log("__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill"),!0):"function"==typeof e.Request&&!e.Request.prototype.hasOwnProperty("signal")||!e.AbortController}({fetch:r,Request:i,AbortController:o,__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL:a}))return {fetch:r,Request:f};var f=i;(f&&!f.prototype.hasOwnProperty("signal")||a)&&((f=function(e,t){var r;t&&t.signal&&(r=t.signal,delete t.signal);var n=new i(e,t);return r&&Object.defineProperty(n,"signal",{writable:!1,enumerable:!1,configurable:!0,value:r}),n}).prototype=i.prototype);var h=r;return {fetch:function(e,t){var r=f&&f.prototype.isPrototypeOf(e)?e.signal:t?t.signal:void 0;if(r){var n;try{n=new DOMException("Aborted","AbortError");}catch(e){(n=new Error("Aborted")).name="AbortError";}if(r.aborted)return Promise.reject(n);var i=new Promise((function(e,t){r.addEventListener("abort",(function(){return t(n)}),{once:!0});}));return t&&t.signal&&delete t.signal,Promise.race([i,h(e,t)])}return h(e,t)},Request:f}};},9742:(e,t)=>{t.byteLength=function(e){var t=f(e),r=t[0],n=t[1];return 3*(r+n)/4-n},t.toByteArray=function(e){var t,r,o=f(e),s=o[0],a=o[1],h=new i(function(e,t,r){return 3*(t+r)/4-r}(0,s,a)),l=0,u=a>0?s-4:s;for(r=0;r<u;r+=4)t=n[e.charCodeAt(r)]<<18|n[e.charCodeAt(r+1)]<<12|n[e.charCodeAt(r+2)]<<6|n[e.charCodeAt(r+3)],h[l++]=t>>16&255,h[l++]=t>>8&255,h[l++]=255&t;return 2===a&&(t=n[e.charCodeAt(r)]<<2|n[e.charCodeAt(r+1)]>>4,h[l++]=255&t),1===a&&(t=n[e.charCodeAt(r)]<<10|n[e.charCodeAt(r+1)]<<4|n[e.charCodeAt(r+2)]>>2,h[l++]=t>>8&255,h[l++]=255&t),h},t.fromByteArray=function(e){for(var t,n=e.length,i=n%3,o=[],s=16383,a=0,f=n-i;a<f;a+=s)o.push(h(e,a,a+s>f?f:a+s));return 1===i?(t=e[n-1],o.push(r[t>>2]+r[t<<4&63]+"==")):2===i&&(t=(e[n-2]<<8)+e[n-1],o.push(r[t>>10]+r[t>>4&63]+r[t<<2&63]+"=")),o.join("")};for(var r=[],n=[],i="undefined"!=typeof Uint8Array?Uint8Array:Array,o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",s=0,a=o.length;s<a;++s)r[s]=o[s],n[o.charCodeAt(s)]=s;function f(e){var t=e.length;if(t%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var r=e.indexOf("=");return -1===r&&(r=t),[r,r===t?0:4-r%4]}function h(e,t,n){for(var i,o,s=[],a=t;a<n;a+=3)i=(e[a]<<16&16711680)+(e[a+1]<<8&65280)+(255&e[a+2]),s.push(r[(o=i)>>18&63]+r[o>>12&63]+r[o>>6&63]+r[63&o]);return s.join("")}n["-".charCodeAt(0)]=62,n["_".charCodeAt(0)]=63;},2779:(e,t,r)=>{var n=r(8764).Buffer,i=[0,1996959894,3993919788,2567524794,124634137,1886057615,3915621685,2657392035,249268274,2044508324,3772115230,2547177864,162941995,2125561021,3887607047,2428444049,498536548,1789927666,4089016648,2227061214,450548861,1843258603,4107580753,2211677639,325883990,1684777152,4251122042,2321926636,335633487,1661365465,4195302755,2366115317,997073096,1281953886,3579855332,2724688242,1006888145,1258607687,3524101629,2768942443,901097722,1119000684,3686517206,2898065728,853044451,1172266101,3705015759,2882616665,651767980,1373503546,3369554304,3218104598,565507253,1454621731,3485111705,3099436303,671266974,1594198024,3322730930,2970347812,795835527,1483230225,3244367275,3060149565,1994146192,31158534,2563907772,4023717930,1907459465,112637215,2680153253,3904427059,2013776290,251722036,2517215374,3775830040,2137656763,141376813,2439277719,3865271297,1802195444,476864866,2238001368,4066508878,1812370925,453092731,2181625025,4111451223,1706088902,314042704,2344532202,4240017532,1658658271,366619977,2362670323,4224994405,1303535960,984961486,2747007092,3569037538,1256170817,1037604311,2765210733,3554079995,1131014506,879679996,2909243462,3663771856,1141124467,855842277,2852801631,3708648649,1342533948,654459306,3188396048,3373015174,1466479909,544179635,3110523913,3462522015,1591671054,702138776,2966460450,3352799412,1504918807,783551873,3082640443,3233442989,3988292384,2596254646,62317068,1957810842,3939845945,2647816111,81470997,1943803523,3814918930,2489596804,225274430,2053790376,3826175755,2466906013,167816743,2097651377,4027552580,2265490386,503444072,1762050814,4150417245,2154129355,426522225,1852507879,4275313526,2312317920,282753626,1742555852,4189708143,2394877945,397917763,1622183637,3604390888,2714866558,953729732,1340076626,3518719985,2797360999,1068828381,1219638859,3624741850,2936675148,906185462,1090812512,3747672003,2825379669,829329135,1181335161,3412177804,3160834842,628085408,1382605366,3423369109,3138078467,570562233,1426400815,3317316542,2998733608,733239954,1555261956,3268935591,3050360625,752459403,1541320221,2607071920,3965973030,1969922972,40735498,2617837225,3943577151,1913087877,83908371,2512341634,3803740692,2075208622,213261112,2463272603,3855990285,2094854071,198958881,2262029012,4057260610,1759359992,534414190,2176718541,4139329115,1873836001,414664567,2282248934,4279200368,1711684554,285281116,2405801727,4167216745,1634467795,376229701,2685067896,3608007406,1308918612,956543938,2808555105,3495958263,1231636301,1047427035,2932959818,3654703836,1088359270,936918e3,2847714899,3736837829,1202900863,817233897,3183342108,3401237130,1404277552,615818150,3134207493,3453421203,1423857449,601450431,3009837614,3294710456,1567103746,711928724,3020668471,3272380065,1510334235,755167117];function o(e){if(n.isBuffer(e))return e;var t="function"==typeof n.alloc&&"function"==typeof n.from;if("number"==typeof e)return t?n.alloc(e):new n(e);if("string"==typeof e)return t?n.from(e):new n(e);throw new Error("input must be buffer, number, or string, received "+typeof e)}function s(e){var t=o(4);return t.writeInt32BE(e,0),t}function a(e,t){e=o(e),n.isBuffer(t)&&(t=t.readUInt32BE(0));for(var r=-1^~~t,s=0;s<e.length;s++)r=i[255&(r^e[s])]^r>>>8;return -1^r}function f(){return s(a.apply(null,arguments))}"undefined"!=typeof Int32Array&&(i=new Int32Array(i)),f.signed=function(){return a.apply(null,arguments)},f.unsigned=function(){return a.apply(null,arguments)>>>0},e.exports=f;},8764:(e,t,r)=>{const n=r(9742),i=r(645),o="function"==typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("nodejs.util.inspect.custom"):null;t.Buffer=f,t.SlowBuffer=function(e){return +e!=e&&(e=0),f.alloc(+e)},t.INSPECT_MAX_BYTES=50;const s=2147483647;function a(e){if(e>s)throw new RangeError('The value "'+e+'" is invalid for option "size"');const t=new Uint8Array(e);return Object.setPrototypeOf(t,f.prototype),t}function f(e,t,r){if("number"==typeof e){if("string"==typeof t)throw new TypeError('The "string" argument must be of type string. Received type number');return u(e)}return h(e,t,r)}function h(e,t,r){if("string"==typeof e)return function(e,t){if("string"==typeof t&&""!==t||(t="utf8"),!f.isEncoding(t))throw new TypeError("Unknown encoding: "+t);const r=0|g(e,t);let n=a(r);const i=n.write(e,t);return i!==r&&(n=n.slice(0,i)),n}(e,t);if(ArrayBuffer.isView(e))return function(e){if(Q(e,Uint8Array)){const t=new Uint8Array(e);return d(t.buffer,t.byteOffset,t.byteLength)}return c(e)}(e);if(null==e)throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof e);if(Q(e,ArrayBuffer)||e&&Q(e.buffer,ArrayBuffer))return d(e,t,r);if("undefined"!=typeof SharedArrayBuffer&&(Q(e,SharedArrayBuffer)||e&&Q(e.buffer,SharedArrayBuffer)))return d(e,t,r);if("number"==typeof e)throw new TypeError('The "value" argument must not be of type number. Received type number');const n=e.valueOf&&e.valueOf();if(null!=n&&n!==e)return f.from(n,t,r);const i=function(e){if(f.isBuffer(e)){const t=0|p(e.length),r=a(t);return 0===r.length||e.copy(r,0,0,t),r}return void 0!==e.length?"number"!=typeof e.length||Y(e.length)?a(0):c(e):"Buffer"===e.type&&Array.isArray(e.data)?c(e.data):void 0}(e);if(i)return i;if("undefined"!=typeof Symbol&&null!=Symbol.toPrimitive&&"function"==typeof e[Symbol.toPrimitive])return f.from(e[Symbol.toPrimitive]("string"),t,r);throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof e)}function l(e){if("number"!=typeof e)throw new TypeError('"size" argument must be of type number');if(e<0)throw new RangeError('The value "'+e+'" is invalid for option "size"')}function u(e){return l(e),a(e<0?0:0|p(e))}function c(e){const t=e.length<0?0:0|p(e.length),r=a(t);for(let n=0;n<t;n+=1)r[n]=255&e[n];return r}function d(e,t,r){if(t<0||e.byteLength<t)throw new RangeError('"offset" is outside of buffer bounds');if(e.byteLength<t+(r||0))throw new RangeError('"length" is outside of buffer bounds');let n;return n=void 0===t&&void 0===r?new Uint8Array(e):void 0===r?new Uint8Array(e,t):new Uint8Array(e,t,r),Object.setPrototypeOf(n,f.prototype),n}function p(e){if(e>=s)throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+s.toString(16)+" bytes");return 0|e}function g(e,t){if(f.isBuffer(e))return e.length;if(ArrayBuffer.isView(e)||Q(e,ArrayBuffer))return e.byteLength;if("string"!=typeof e)throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type '+typeof e);const r=e.length,n=arguments.length>2&&!0===arguments[2];if(!n&&0===r)return 0;let i=!1;for(;;)switch(t){case"ascii":case"latin1":case"binary":return r;case"utf8":case"utf-8":return V(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*r;case"hex":return r>>>1;case"base64":return Z(e).length;default:if(i)return n?-1:V(e).length;t=(""+t).toLowerCase(),i=!0;}}function m(e,t,r){let n=!1;if((void 0===t||t<0)&&(t=0),t>this.length)return "";if((void 0===r||r>this.length)&&(r=this.length),r<=0)return "";if((r>>>=0)<=(t>>>=0))return "";for(e||(e="utf8");;)switch(e){case"hex":return I(this,t,r);case"utf8":case"utf-8":return C(this,t,r);case"ascii":return k(this,t,r);case"latin1":case"binary":return x(this,t,r);case"base64":return A(this,t,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return M(this,t,r);default:if(n)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase(),n=!0;}}function y(e,t,r){const n=e[t];e[t]=e[r],e[r]=n;}function b(e,t,r,n,i){if(0===e.length)return -1;if("string"==typeof r?(n=r,r=0):r>2147483647?r=2147483647:r<-2147483648&&(r=-2147483648),Y(r=+r)&&(r=i?0:e.length-1),r<0&&(r=e.length+r),r>=e.length){if(i)return -1;r=e.length-1;}else if(r<0){if(!i)return -1;r=0;}if("string"==typeof t&&(t=f.from(t,n)),f.isBuffer(t))return 0===t.length?-1:v(e,t,r,n,i);if("number"==typeof t)return t&=255,"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(e,t,r):Uint8Array.prototype.lastIndexOf.call(e,t,r):v(e,[t],r,n,i);throw new TypeError("val must be string, number or Buffer")}function v(e,t,r,n,i){let o,s=1,a=e.length,f=t.length;if(void 0!==n&&("ucs2"===(n=String(n).toLowerCase())||"ucs-2"===n||"utf16le"===n||"utf-16le"===n)){if(e.length<2||t.length<2)return -1;s=2,a/=2,f/=2,r/=2;}function h(e,t){return 1===s?e[t]:e.readUInt16BE(t*s)}if(i){let n=-1;for(o=r;o<a;o++)if(h(e,o)===h(t,-1===n?0:o-n)){if(-1===n&&(n=o),o-n+1===f)return n*s}else -1!==n&&(o-=o-n),n=-1;}else for(r+f>a&&(r=a-f),o=r;o>=0;o--){let r=!0;for(let n=0;n<f;n++)if(h(e,o+n)!==h(t,n)){r=!1;break}if(r)return o}return -1}function w(e,t,r,n){r=Number(r)||0;const i=e.length-r;n?(n=Number(n))>i&&(n=i):n=i;const o=t.length;let s;for(n>o/2&&(n=o/2),s=0;s<n;++s){const n=parseInt(t.substr(2*s,2),16);if(Y(n))return s;e[r+s]=n;}return s}function _(e,t,r,n){return G(V(t,e.length-r),e,r,n)}function B(e,t,r,n){return G(function(e){const t=[];for(let r=0;r<e.length;++r)t.push(255&e.charCodeAt(r));return t}(t),e,r,n)}function E(e,t,r,n){return G(Z(t),e,r,n)}function S(e,t,r,n){return G(function(e,t){let r,n,i;const o=[];for(let s=0;s<e.length&&!((t-=2)<0);++s)r=e.charCodeAt(s),n=r>>8,i=r%256,o.push(i),o.push(n);return o}(t,e.length-r),e,r,n)}function A(e,t,r){return 0===t&&r===e.length?n.fromByteArray(e):n.fromByteArray(e.slice(t,r))}function C(e,t,r){r=Math.min(e.length,r);const n=[];let i=t;for(;i<r;){const t=e[i];let o=null,s=t>239?4:t>223?3:t>191?2:1;if(i+s<=r){let r,n,a,f;switch(s){case 1:t<128&&(o=t);break;case 2:r=e[i+1],128==(192&r)&&(f=(31&t)<<6|63&r,f>127&&(o=f));break;case 3:r=e[i+1],n=e[i+2],128==(192&r)&&128==(192&n)&&(f=(15&t)<<12|(63&r)<<6|63&n,f>2047&&(f<55296||f>57343)&&(o=f));break;case 4:r=e[i+1],n=e[i+2],a=e[i+3],128==(192&r)&&128==(192&n)&&128==(192&a)&&(f=(15&t)<<18|(63&r)<<12|(63&n)<<6|63&a,f>65535&&f<1114112&&(o=f));}}null===o?(o=65533,s=1):o>65535&&(o-=65536,n.push(o>>>10&1023|55296),o=56320|1023&o),n.push(o),i+=s;}return function(e){const t=e.length;if(t<=R)return String.fromCharCode.apply(String,e);let r="",n=0;for(;n<t;)r+=String.fromCharCode.apply(String,e.slice(n,n+=R));return r}(n)}t.kMaxLength=s,f.TYPED_ARRAY_SUPPORT=function(){try{const e=new Uint8Array(1),t={foo:function(){return 42}};return Object.setPrototypeOf(t,Uint8Array.prototype),Object.setPrototypeOf(e,t),42===e.foo()}catch(e){return !1}}(),f.TYPED_ARRAY_SUPPORT||"undefined"==typeof console||"function"!=typeof console.error||console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."),Object.defineProperty(f.prototype,"parent",{enumerable:!0,get:function(){if(f.isBuffer(this))return this.buffer}}),Object.defineProperty(f.prototype,"offset",{enumerable:!0,get:function(){if(f.isBuffer(this))return this.byteOffset}}),f.poolSize=8192,f.from=function(e,t,r){return h(e,t,r)},Object.setPrototypeOf(f.prototype,Uint8Array.prototype),Object.setPrototypeOf(f,Uint8Array),f.alloc=function(e,t,r){return function(e,t,r){return l(e),e<=0?a(e):void 0!==t?"string"==typeof r?a(e).fill(t,r):a(e).fill(t):a(e)}(e,t,r)},f.allocUnsafe=function(e){return u(e)},f.allocUnsafeSlow=function(e){return u(e)},f.isBuffer=function(e){return null!=e&&!0===e._isBuffer&&e!==f.prototype},f.compare=function(e,t){if(Q(e,Uint8Array)&&(e=f.from(e,e.offset,e.byteLength)),Q(t,Uint8Array)&&(t=f.from(t,t.offset,t.byteLength)),!f.isBuffer(e)||!f.isBuffer(t))throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');if(e===t)return 0;let r=e.length,n=t.length;for(let i=0,o=Math.min(r,n);i<o;++i)if(e[i]!==t[i]){r=e[i],n=t[i];break}return r<n?-1:n<r?1:0},f.isEncoding=function(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return !0;default:return !1}},f.concat=function(e,t){if(!Array.isArray(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return f.alloc(0);let r;if(void 0===t)for(t=0,r=0;r<e.length;++r)t+=e[r].length;const n=f.allocUnsafe(t);let i=0;for(r=0;r<e.length;++r){let t=e[r];if(Q(t,Uint8Array))i+t.length>n.length?(f.isBuffer(t)||(t=f.from(t)),t.copy(n,i)):Uint8Array.prototype.set.call(n,t,i);else {if(!f.isBuffer(t))throw new TypeError('"list" argument must be an Array of Buffers');t.copy(n,i);}i+=t.length;}return n},f.byteLength=g,f.prototype._isBuffer=!0,f.prototype.swap16=function(){const e=this.length;if(e%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(let t=0;t<e;t+=2)y(this,t,t+1);return this},f.prototype.swap32=function(){const e=this.length;if(e%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(let t=0;t<e;t+=4)y(this,t,t+3),y(this,t+1,t+2);return this},f.prototype.swap64=function(){const e=this.length;if(e%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(let t=0;t<e;t+=8)y(this,t,t+7),y(this,t+1,t+6),y(this,t+2,t+5),y(this,t+3,t+4);return this},f.prototype.toString=function(){const e=this.length;return 0===e?"":0===arguments.length?C(this,0,e):m.apply(this,arguments)},f.prototype.toLocaleString=f.prototype.toString,f.prototype.equals=function(e){if(!f.isBuffer(e))throw new TypeError("Argument must be a Buffer");return this===e||0===f.compare(this,e)},f.prototype.inspect=function(){let e="";const r=t.INSPECT_MAX_BYTES;return e=this.toString("hex",0,r).replace(/(.{2})/g,"$1 ").trim(),this.length>r&&(e+=" ... "),"<Buffer "+e+">"},o&&(f.prototype[o]=f.prototype.inspect),f.prototype.compare=function(e,t,r,n,i){if(Q(e,Uint8Array)&&(e=f.from(e,e.offset,e.byteLength)),!f.isBuffer(e))throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type '+typeof e);if(void 0===t&&(t=0),void 0===r&&(r=e?e.length:0),void 0===n&&(n=0),void 0===i&&(i=this.length),t<0||r>e.length||n<0||i>this.length)throw new RangeError("out of range index");if(n>=i&&t>=r)return 0;if(n>=i)return -1;if(t>=r)return 1;if(this===e)return 0;let o=(i>>>=0)-(n>>>=0),s=(r>>>=0)-(t>>>=0);const a=Math.min(o,s),h=this.slice(n,i),l=e.slice(t,r);for(let e=0;e<a;++e)if(h[e]!==l[e]){o=h[e],s=l[e];break}return o<s?-1:s<o?1:0},f.prototype.includes=function(e,t,r){return -1!==this.indexOf(e,t,r)},f.prototype.indexOf=function(e,t,r){return b(this,e,t,r,!0)},f.prototype.lastIndexOf=function(e,t,r){return b(this,e,t,r,!1)},f.prototype.write=function(e,t,r,n){if(void 0===t)n="utf8",r=this.length,t=0;else if(void 0===r&&"string"==typeof t)n=t,r=this.length,t=0;else {if(!isFinite(t))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");t>>>=0,isFinite(r)?(r>>>=0,void 0===n&&(n="utf8")):(n=r,r=void 0);}const i=this.length-t;if((void 0===r||r>i)&&(r=i),e.length>0&&(r<0||t<0)||t>this.length)throw new RangeError("Attempt to write outside buffer bounds");n||(n="utf8");let o=!1;for(;;)switch(n){case"hex":return w(this,e,t,r);case"utf8":case"utf-8":return _(this,e,t,r);case"ascii":case"latin1":case"binary":return B(this,e,t,r);case"base64":return E(this,e,t,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return S(this,e,t,r);default:if(o)throw new TypeError("Unknown encoding: "+n);n=(""+n).toLowerCase(),o=!0;}},f.prototype.toJSON=function(){return {type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};const R=4096;function k(e,t,r){let n="";r=Math.min(e.length,r);for(let i=t;i<r;++i)n+=String.fromCharCode(127&e[i]);return n}function x(e,t,r){let n="";r=Math.min(e.length,r);for(let i=t;i<r;++i)n+=String.fromCharCode(e[i]);return n}function I(e,t,r){const n=e.length;(!t||t<0)&&(t=0),(!r||r<0||r>n)&&(r=n);let i="";for(let n=t;n<r;++n)i+=K[e[n]];return i}function M(e,t,r){const n=e.slice(t,r);let i="";for(let e=0;e<n.length-1;e+=2)i+=String.fromCharCode(n[e]+256*n[e+1]);return i}function F(e,t,r){if(e%1!=0||e<0)throw new RangeError("offset is not uint");if(e+t>r)throw new RangeError("Trying to access beyond buffer length")}function O(e,t,r,n,i,o){if(!f.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(t>i||t<o)throw new RangeError('"value" argument is out of bounds');if(r+n>e.length)throw new RangeError("Index out of range")}function T(e,t,r,n,i){j(t,n,i,e,r,7);let o=Number(t&BigInt(4294967295));e[r++]=o,o>>=8,e[r++]=o,o>>=8,e[r++]=o,o>>=8,e[r++]=o;let s=Number(t>>BigInt(32)&BigInt(4294967295));return e[r++]=s,s>>=8,e[r++]=s,s>>=8,e[r++]=s,s>>=8,e[r++]=s,r}function U(e,t,r,n,i){j(t,n,i,e,r,7);let o=Number(t&BigInt(4294967295));e[r+7]=o,o>>=8,e[r+6]=o,o>>=8,e[r+5]=o,o>>=8,e[r+4]=o;let s=Number(t>>BigInt(32)&BigInt(4294967295));return e[r+3]=s,s>>=8,e[r+2]=s,s>>=8,e[r+1]=s,s>>=8,e[r]=s,r+8}function P(e,t,r,n,i,o){if(r+n>e.length)throw new RangeError("Index out of range");if(r<0)throw new RangeError("Index out of range")}function N(e,t,r,n,o){return t=+t,r>>>=0,o||P(e,0,r,4),i.write(e,t,r,n,23,4),r+4}function L(e,t,r,n,o){return t=+t,r>>>=0,o||P(e,0,r,8),i.write(e,t,r,n,52,8),r+8}f.prototype.slice=function(e,t){const r=this.length;(e=~~e)<0?(e+=r)<0&&(e=0):e>r&&(e=r),(t=void 0===t?r:~~t)<0?(t+=r)<0&&(t=0):t>r&&(t=r),t<e&&(t=e);const n=this.subarray(e,t);return Object.setPrototypeOf(n,f.prototype),n},f.prototype.readUintLE=f.prototype.readUIntLE=function(e,t,r){e>>>=0,t>>>=0,r||F(e,t,this.length);let n=this[e],i=1,o=0;for(;++o<t&&(i*=256);)n+=this[e+o]*i;return n},f.prototype.readUintBE=f.prototype.readUIntBE=function(e,t,r){e>>>=0,t>>>=0,r||F(e,t,this.length);let n=this[e+--t],i=1;for(;t>0&&(i*=256);)n+=this[e+--t]*i;return n},f.prototype.readUint8=f.prototype.readUInt8=function(e,t){return e>>>=0,t||F(e,1,this.length),this[e]},f.prototype.readUint16LE=f.prototype.readUInt16LE=function(e,t){return e>>>=0,t||F(e,2,this.length),this[e]|this[e+1]<<8},f.prototype.readUint16BE=f.prototype.readUInt16BE=function(e,t){return e>>>=0,t||F(e,2,this.length),this[e]<<8|this[e+1]},f.prototype.readUint32LE=f.prototype.readUInt32LE=function(e,t){return e>>>=0,t||F(e,4,this.length),(this[e]|this[e+1]<<8|this[e+2]<<16)+16777216*this[e+3]},f.prototype.readUint32BE=f.prototype.readUInt32BE=function(e,t){return e>>>=0,t||F(e,4,this.length),16777216*this[e]+(this[e+1]<<16|this[e+2]<<8|this[e+3])},f.prototype.readBigUInt64LE=X((function(e){H(e>>>=0,"offset");const t=this[e],r=this[e+7];void 0!==t&&void 0!==r||W(e,this.length-8);const n=t+256*this[++e]+65536*this[++e]+this[++e]*2**24,i=this[++e]+256*this[++e]+65536*this[++e]+r*2**24;return BigInt(n)+(BigInt(i)<<BigInt(32))})),f.prototype.readBigUInt64BE=X((function(e){H(e>>>=0,"offset");const t=this[e],r=this[e+7];void 0!==t&&void 0!==r||W(e,this.length-8);const n=t*2**24+65536*this[++e]+256*this[++e]+this[++e],i=this[++e]*2**24+65536*this[++e]+256*this[++e]+r;return (BigInt(n)<<BigInt(32))+BigInt(i)})),f.prototype.readIntLE=function(e,t,r){e>>>=0,t>>>=0,r||F(e,t,this.length);let n=this[e],i=1,o=0;for(;++o<t&&(i*=256);)n+=this[e+o]*i;return i*=128,n>=i&&(n-=Math.pow(2,8*t)),n},f.prototype.readIntBE=function(e,t,r){e>>>=0,t>>>=0,r||F(e,t,this.length);let n=t,i=1,o=this[e+--n];for(;n>0&&(i*=256);)o+=this[e+--n]*i;return i*=128,o>=i&&(o-=Math.pow(2,8*t)),o},f.prototype.readInt8=function(e,t){return e>>>=0,t||F(e,1,this.length),128&this[e]?-1*(255-this[e]+1):this[e]},f.prototype.readInt16LE=function(e,t){e>>>=0,t||F(e,2,this.length);const r=this[e]|this[e+1]<<8;return 32768&r?4294901760|r:r},f.prototype.readInt16BE=function(e,t){e>>>=0,t||F(e,2,this.length);const r=this[e+1]|this[e]<<8;return 32768&r?4294901760|r:r},f.prototype.readInt32LE=function(e,t){return e>>>=0,t||F(e,4,this.length),this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24},f.prototype.readInt32BE=function(e,t){return e>>>=0,t||F(e,4,this.length),this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]},f.prototype.readBigInt64LE=X((function(e){H(e>>>=0,"offset");const t=this[e],r=this[e+7];void 0!==t&&void 0!==r||W(e,this.length-8);const n=this[e+4]+256*this[e+5]+65536*this[e+6]+(r<<24);return (BigInt(n)<<BigInt(32))+BigInt(t+256*this[++e]+65536*this[++e]+this[++e]*2**24)})),f.prototype.readBigInt64BE=X((function(e){H(e>>>=0,"offset");const t=this[e],r=this[e+7];void 0!==t&&void 0!==r||W(e,this.length-8);const n=(t<<24)+65536*this[++e]+256*this[++e]+this[++e];return (BigInt(n)<<BigInt(32))+BigInt(this[++e]*2**24+65536*this[++e]+256*this[++e]+r)})),f.prototype.readFloatLE=function(e,t){return e>>>=0,t||F(e,4,this.length),i.read(this,e,!0,23,4)},f.prototype.readFloatBE=function(e,t){return e>>>=0,t||F(e,4,this.length),i.read(this,e,!1,23,4)},f.prototype.readDoubleLE=function(e,t){return e>>>=0,t||F(e,8,this.length),i.read(this,e,!0,52,8)},f.prototype.readDoubleBE=function(e,t){return e>>>=0,t||F(e,8,this.length),i.read(this,e,!1,52,8)},f.prototype.writeUintLE=f.prototype.writeUIntLE=function(e,t,r,n){e=+e,t>>>=0,r>>>=0,n||O(this,e,t,r,Math.pow(2,8*r)-1,0);let i=1,o=0;for(this[t]=255&e;++o<r&&(i*=256);)this[t+o]=e/i&255;return t+r},f.prototype.writeUintBE=f.prototype.writeUIntBE=function(e,t,r,n){e=+e,t>>>=0,r>>>=0,n||O(this,e,t,r,Math.pow(2,8*r)-1,0);let i=r-1,o=1;for(this[t+i]=255&e;--i>=0&&(o*=256);)this[t+i]=e/o&255;return t+r},f.prototype.writeUint8=f.prototype.writeUInt8=function(e,t,r){return e=+e,t>>>=0,r||O(this,e,t,1,255,0),this[t]=255&e,t+1},f.prototype.writeUint16LE=f.prototype.writeUInt16LE=function(e,t,r){return e=+e,t>>>=0,r||O(this,e,t,2,65535,0),this[t]=255&e,this[t+1]=e>>>8,t+2},f.prototype.writeUint16BE=f.prototype.writeUInt16BE=function(e,t,r){return e=+e,t>>>=0,r||O(this,e,t,2,65535,0),this[t]=e>>>8,this[t+1]=255&e,t+2},f.prototype.writeUint32LE=f.prototype.writeUInt32LE=function(e,t,r){return e=+e,t>>>=0,r||O(this,e,t,4,4294967295,0),this[t+3]=e>>>24,this[t+2]=e>>>16,this[t+1]=e>>>8,this[t]=255&e,t+4},f.prototype.writeUint32BE=f.prototype.writeUInt32BE=function(e,t,r){return e=+e,t>>>=0,r||O(this,e,t,4,4294967295,0),this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e,t+4},f.prototype.writeBigUInt64LE=X((function(e,t=0){return T(this,e,t,BigInt(0),BigInt("0xffffffffffffffff"))})),f.prototype.writeBigUInt64BE=X((function(e,t=0){return U(this,e,t,BigInt(0),BigInt("0xffffffffffffffff"))})),f.prototype.writeIntLE=function(e,t,r,n){if(e=+e,t>>>=0,!n){const n=Math.pow(2,8*r-1);O(this,e,t,r,n-1,-n);}let i=0,o=1,s=0;for(this[t]=255&e;++i<r&&(o*=256);)e<0&&0===s&&0!==this[t+i-1]&&(s=1),this[t+i]=(e/o>>0)-s&255;return t+r},f.prototype.writeIntBE=function(e,t,r,n){if(e=+e,t>>>=0,!n){const n=Math.pow(2,8*r-1);O(this,e,t,r,n-1,-n);}let i=r-1,o=1,s=0;for(this[t+i]=255&e;--i>=0&&(o*=256);)e<0&&0===s&&0!==this[t+i+1]&&(s=1),this[t+i]=(e/o>>0)-s&255;return t+r},f.prototype.writeInt8=function(e,t,r){return e=+e,t>>>=0,r||O(this,e,t,1,127,-128),e<0&&(e=255+e+1),this[t]=255&e,t+1},f.prototype.writeInt16LE=function(e,t,r){return e=+e,t>>>=0,r||O(this,e,t,2,32767,-32768),this[t]=255&e,this[t+1]=e>>>8,t+2},f.prototype.writeInt16BE=function(e,t,r){return e=+e,t>>>=0,r||O(this,e,t,2,32767,-32768),this[t]=e>>>8,this[t+1]=255&e,t+2},f.prototype.writeInt32LE=function(e,t,r){return e=+e,t>>>=0,r||O(this,e,t,4,2147483647,-2147483648),this[t]=255&e,this[t+1]=e>>>8,this[t+2]=e>>>16,this[t+3]=e>>>24,t+4},f.prototype.writeInt32BE=function(e,t,r){return e=+e,t>>>=0,r||O(this,e,t,4,2147483647,-2147483648),e<0&&(e=4294967295+e+1),this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e,t+4},f.prototype.writeBigInt64LE=X((function(e,t=0){return T(this,e,t,-BigInt("0x8000000000000000"),BigInt("0x7fffffffffffffff"))})),f.prototype.writeBigInt64BE=X((function(e,t=0){return U(this,e,t,-BigInt("0x8000000000000000"),BigInt("0x7fffffffffffffff"))})),f.prototype.writeFloatLE=function(e,t,r){return N(this,e,t,!0,r)},f.prototype.writeFloatBE=function(e,t,r){return N(this,e,t,!1,r)},f.prototype.writeDoubleLE=function(e,t,r){return L(this,e,t,!0,r)},f.prototype.writeDoubleBE=function(e,t,r){return L(this,e,t,!1,r)},f.prototype.copy=function(e,t,r,n){if(!f.isBuffer(e))throw new TypeError("argument should be a Buffer");if(r||(r=0),n||0===n||(n=this.length),t>=e.length&&(t=e.length),t||(t=0),n>0&&n<r&&(n=r),n===r)return 0;if(0===e.length||0===this.length)return 0;if(t<0)throw new RangeError("targetStart out of bounds");if(r<0||r>=this.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("sourceEnd out of bounds");n>this.length&&(n=this.length),e.length-t<n-r&&(n=e.length-t+r);const i=n-r;return this===e&&"function"==typeof Uint8Array.prototype.copyWithin?this.copyWithin(t,r,n):Uint8Array.prototype.set.call(e,this.subarray(r,n),t),i},f.prototype.fill=function(e,t,r,n){if("string"==typeof e){if("string"==typeof t?(n=t,t=0,r=this.length):"string"==typeof r&&(n=r,r=this.length),void 0!==n&&"string"!=typeof n)throw new TypeError("encoding must be a string");if("string"==typeof n&&!f.isEncoding(n))throw new TypeError("Unknown encoding: "+n);if(1===e.length){const t=e.charCodeAt(0);("utf8"===n&&t<128||"latin1"===n)&&(e=t);}}else "number"==typeof e?e&=255:"boolean"==typeof e&&(e=Number(e));if(t<0||this.length<t||this.length<r)throw new RangeError("Out of range index");if(r<=t)return this;let i;if(t>>>=0,r=void 0===r?this.length:r>>>0,e||(e=0),"number"==typeof e)for(i=t;i<r;++i)this[i]=e;else {const o=f.isBuffer(e)?e:f.from(e,n),s=o.length;if(0===s)throw new TypeError('The value "'+e+'" is invalid for argument "value"');for(i=0;i<r-t;++i)this[i+t]=o[i%s];}return this};const z={};function D(e,t,r){z[e]=class extends r{constructor(){super(),Object.defineProperty(this,"message",{value:t.apply(this,arguments),writable:!0,configurable:!0}),this.name=`${this.name} [${e}]`,this.stack,delete this.name;}get code(){return e}set code(e){Object.defineProperty(this,"code",{configurable:!0,enumerable:!0,value:e,writable:!0});}toString(){return `${this.name} [${e}]: ${this.message}`}};}function q(e){let t="",r=e.length;const n="-"===e[0]?1:0;for(;r>=n+4;r-=3)t=`_${e.slice(r-3,r)}${t}`;return `${e.slice(0,r)}${t}`}function j(e,t,r,n,i,o){if(e>r||e<t){const n="bigint"==typeof t?"n":"";let i;throw i=o>3?0===t||t===BigInt(0)?`>= 0${n} and < 2${n} ** ${8*(o+1)}${n}`:`>= -(2${n} ** ${8*(o+1)-1}${n}) and < 2 ** ${8*(o+1)-1}${n}`:`>= ${t}${n} and <= ${r}${n}`,new z.ERR_OUT_OF_RANGE("value",i,e)}!function(e,t,r){H(t,"offset"),void 0!==e[t]&&void 0!==e[t+r]||W(t,e.length-(r+1));}(n,i,o);}function H(e,t){if("number"!=typeof e)throw new z.ERR_INVALID_ARG_TYPE(t,"number",e)}function W(e,t,r){if(Math.floor(e)!==e)throw H(e,r),new z.ERR_OUT_OF_RANGE(r||"offset","an integer",e);if(t<0)throw new z.ERR_BUFFER_OUT_OF_BOUNDS;throw new z.ERR_OUT_OF_RANGE(r||"offset",`>= ${r?1:0} and <= ${t}`,e)}D("ERR_BUFFER_OUT_OF_BOUNDS",(function(e){return e?`${e} is outside of buffer bounds`:"Attempt to access memory outside buffer bounds"}),RangeError),D("ERR_INVALID_ARG_TYPE",(function(e,t){return `The "${e}" argument must be of type number. Received type ${typeof t}`}),TypeError),D("ERR_OUT_OF_RANGE",(function(e,t,r){let n=`The value of "${e}" is out of range.`,i=r;return Number.isInteger(r)&&Math.abs(r)>2**32?i=q(String(r)):"bigint"==typeof r&&(i=String(r),(r>BigInt(2)**BigInt(32)||r<-(BigInt(2)**BigInt(32)))&&(i=q(i)),i+="n"),n+=` It must be ${t}. Received ${i}`,n}),RangeError);const $=/[^+/0-9A-Za-z-_]/g;function V(e,t){let r;t=t||1/0;const n=e.length;let i=null;const o=[];for(let s=0;s<n;++s){if(r=e.charCodeAt(s),r>55295&&r<57344){if(!i){if(r>56319){(t-=3)>-1&&o.push(239,191,189);continue}if(s+1===n){(t-=3)>-1&&o.push(239,191,189);continue}i=r;continue}if(r<56320){(t-=3)>-1&&o.push(239,191,189),i=r;continue}r=65536+(i-55296<<10|r-56320);}else i&&(t-=3)>-1&&o.push(239,191,189);if(i=null,r<128){if((t-=1)<0)break;o.push(r);}else if(r<2048){if((t-=2)<0)break;o.push(r>>6|192,63&r|128);}else if(r<65536){if((t-=3)<0)break;o.push(r>>12|224,r>>6&63|128,63&r|128);}else {if(!(r<1114112))throw new Error("Invalid code point");if((t-=4)<0)break;o.push(r>>18|240,r>>12&63|128,r>>6&63|128,63&r|128);}}return o}function Z(e){return n.toByteArray(function(e){if((e=(e=e.split("=")[0]).trim().replace($,"")).length<2)return "";for(;e.length%4!=0;)e+="=";return e}(e))}function G(e,t,r,n){let i;for(i=0;i<n&&!(i+r>=t.length||i>=e.length);++i)t[i+r]=e[i];return i}function Q(e,t){return e instanceof t||null!=e&&null!=e.constructor&&null!=e.constructor.name&&e.constructor.name===t.name}function Y(e){return e!=e}const K=function(){const e="0123456789abcdef",t=new Array(256);for(let r=0;r<16;++r){const n=16*r;for(let i=0;i<16;++i)t[n+i]=e[r]+e[i];}return t}();function X(e){return "undefined"==typeof BigInt?J:e}function J(){throw new Error("BigInt not supported")}},4693:e=>{var t={array:function(e){var t=0,r=0,n=[0,1,3,7,15,31,63,127,255];return function(i){for(var o=0;i>0;){var s=8-t;i>=s?(o<<=s,o|=n[s]&e[r++],t=0,i-=s):(o<<=i,o|=(e[r]&n[i]<<8-i-t)>>8-i-t,t+=i,i=0);}return o}},simple:function(e){var r,n,i=t.header(e),o=[],s=0;do{-1!=(n=t.decompress(e,i))&&(o.push(n),s+=n.byteLength);}while(-1!=n);r=new Uint8Array(s),s=0;for(var a=0;a<o.length;++a)n=o[a],r.set(n,s),s+=n.byteLength;return r},header:function(e){if(4348520!=e(24))throw "No magic number found";var t=e(8)-48;if(t<1||t>9)throw "Not a BZIP archive";return t},decompress:function(e,t,r){for(var n=9e5,i="",o=0;o<6;o++)i+=e(8).toString(16);if("177245385090"==i)return -1;if("314159265359"!=i)throw "eek not valid bzip data";if(e(32),e(1))throw "unsupported obsolete version";var s=e(24);if(s>n)throw "Initial position larger than buffer size";var a=e(16),f=new Uint8Array(256),h=0;for(o=0;o<16;o++)if(a&1<<15-o){var l=e(16);for(g=0;g<16;g++)l&1<<15-g&&(f[h++]=16*o+g);}var u=e(3);if(u<2||u>6)throw "another error";var c=e(15);if(0==c)throw "meh";var d=[];for(o=0;o<u;o++)d[o]=o;var p=new Uint8Array(32768);for(o=0;o<c;o++){for(var g=0;e(1);g++)if(g>=u)throw "whoops another error";var m=d[g];d.splice(g,1),d.splice(0,0,m),p[o]=m;}var y=h+2,b=[];for(g=0;g<u;g++){var v,w,_,B=new Uint8Array(258),E=new Uint8Array(21);for(a=e(5),o=0;o<y;o++){for(;;){if(a<1||a>20)throw "I gave up a while ago on writing error messages";if(!e(1))break;e(1)?a--:a++;}B[o]=a;}for(v=w=B[0],o=1;o<y;o++)B[o]>w?w=B[o]:B[o]<v&&(v=B[o]);(_=b[g]={}).permute=new Uint32Array(258),_.limit=new Uint32Array(21),_.base=new Uint32Array(21),_.minLen=v,_.maxLen=w;var S=_.base.subarray(1),A=_.limit.subarray(1),C=0;for(o=v;o<=w;o++)for(a=0;a<y;a++)B[a]==o&&(_.permute[C++]=a);for(o=v;o<=w;o++)E[o]=A[o]=0;for(o=0;o<y;o++)E[B[o]]++;for(C=a=0,o=v;o<w;o++)C+=E[o],A[o]=C-1,C<<=1,S[o+1]=C-(a+=E[o]);A[w]=C+E[w]-1,S[v]=0;}var R,k,x,I=new Uint32Array(256);for(o=0;o<256;o++)d[o]=o;R=k=y=x=0;for(var M=new Uint32Array(n);;){if(!y--){if(y=49,x>=c)throw "meow i'm a kitty, that's an error";S=(_=b[p[x++]]).base.subarray(1),A=_.limit.subarray(1);}for(g=e(o=_.minLen);;){if(o>_.maxLen)throw "rawr i'm a dinosaur";if(g<=A[o])break;o++,g=g<<1|e(1);}if((g-=S[o])<0||g>=258)throw "moo i'm a cow";var F=_.permute[g];if(0!=F&&1!=F){if(R){if(R=0,k+a>=n)throw "Boom.";for(I[m=f[d[0]]]+=a;a--;)M[k++]=m;}if(F>h)break;if(k>=n)throw "I can't think of anything. Error";m=d[o=F-1],d.splice(o,1),d.splice(0,0,m),I[m=f[m]]++,M[k++]=m;}else R||(R=1,a=0),a+=0==F?R:2*R,R<<=1;}if(s<0||s>=k)throw "I'm a monkey and I'm throwing something at someone, namely you";for(g=0,o=0;o<256;o++)l=g+I[o],I[o]=g,g=l;for(o=0;o<k;o++)M[I[m=255&M[o]]]|=o<<8,I[m]++;var O=0,T=0,U=0;k&&(T=255&(O=M[s]),O>>=8,U=-1);var P,N,L,z=new Uint8Array(n),D=0;for(r||(r=1/0);k;){for(k--,N=T,T=255&(O=M[O]),O>>=8,3==U++?(P=T,L=N,T=-1):(P=1,L=T);P--;)if(z[D++]=L,!--r)return z;T!=N&&(U=0);}return z.subarray(0,D)}};e.exports=t;},487:e=>{var t={utf8:{stringToBytes:function(e){return t.bin.stringToBytes(unescape(encodeURIComponent(e)))},bytesToString:function(e){return decodeURIComponent(escape(t.bin.bytesToString(e)))}},bin:{stringToBytes:function(e){for(var t=[],r=0;r<e.length;r++)t.push(255&e.charCodeAt(r));return t},bytesToString:function(e){for(var t=[],r=0;r<e.length;r++)t.push(String.fromCharCode(e[r]));return t.join("")}}};e.exports=t;},1012:e=>{var t,r;t="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",r={rotl:function(e,t){return e<<t|e>>>32-t},rotr:function(e,t){return e<<32-t|e>>>t},endian:function(e){if(e.constructor==Number)return 16711935&r.rotl(e,8)|4278255360&r.rotl(e,24);for(var t=0;t<e.length;t++)e[t]=r.endian(e[t]);return e},randomBytes:function(e){for(var t=[];e>0;e--)t.push(Math.floor(256*Math.random()));return t},bytesToWords:function(e){for(var t=[],r=0,n=0;r<e.length;r++,n+=8)t[n>>>5]|=e[r]<<24-n%32;return t},wordsToBytes:function(e){for(var t=[],r=0;r<32*e.length;r+=8)t.push(e[r>>>5]>>>24-r%32&255);return t},bytesToHex:function(e){for(var t=[],r=0;r<e.length;r++)t.push((e[r]>>>4).toString(16)),t.push((15&e[r]).toString(16));return t.join("")},hexToBytes:function(e){for(var t=[],r=0;r<e.length;r+=2)t.push(parseInt(e.substr(r,2),16));return t},bytesToBase64:function(e){for(var r=[],n=0;n<e.length;n+=3)for(var i=e[n]<<16|e[n+1]<<8|e[n+2],o=0;o<4;o++)8*n+6*o<=8*e.length?r.push(t.charAt(i>>>6*(3-o)&63)):r.push("=");return r.join("")},base64ToBytes:function(e){e=e.replace(/[^A-Z0-9+\/]/gi,"");for(var r=[],n=0,i=0;n<e.length;i=++n%4)0!=i&&r.push((t.indexOf(e.charAt(n-1))&Math.pow(2,-2*i+8)-1)<<2*i|t.indexOf(e.charAt(n))>>>6-2*i);return r}},e.exports=r;},2949:(e,t,r)=>{r.r(t),r.d(t,{BlobFile:()=>h,LocalFile:()=>i(),RemoteFile:()=>a,fromUrl:()=>l,open:()=>u});var n=r(7067),i=r.n(n),o=r(8764);const s="undefined"!=typeof window?window:"undefined"!=typeof self?self:{fetch:void 0};class a{constructor(e,t={}){this.baseOverrides={},this.url=e;const r=t.fetch||s.fetch&&s.fetch.bind(s);if(!r)throw new TypeError("no fetch function supplied, and none found in global environment");t.overrides&&(this.baseOverrides=t.overrides),this.fetchImplementation=r;}async getBufferFromResponse(e){if("function"==typeof e.buffer)return e.buffer();if("function"==typeof e.arrayBuffer){const t=await e.arrayBuffer();return o.Buffer.from(t)}throw new TypeError("invalid HTTP response object, has no buffer method, and no arrayBuffer method")}async fetch(e,t){let r;try{r=await this.fetchImplementation(e,t);}catch(n){if(!`${n}`.includes("Failed to fetch"))throw n;console.warn(`generic-filehandle: refetching ${e} to attempt to work around chrome CORS header caching bug`),r=await this.fetchImplementation(e,{...t,cache:"reload"});}return r}async read(e,t=0,r,n=0,i={}){const{headers:o={},signal:s,overrides:a={}}=i;r<1/0?o.range=`bytes=${n}-${n+r}`:r===1/0&&0!==n&&(o.range=`bytes=${n}-`);const f={...this.baseOverrides,...a,headers:{...o,...a.headers,...this.baseOverrides.headers},method:"GET",redirect:"follow",mode:"cors",signal:s},h=await this.fetch(this.url,f);if(!h.ok)throw new Error(`HTTP ${h.status} ${h.statusText} ${this.url}`);if(200===h.status&&0===n||206===h.status){const n=await this.getBufferFromResponse(h),i=n.copy(e,t,0,Math.min(r,n.length)),o=h.headers.get("content-range"),s=/\/(\d+)$/.exec(o||"");return s&&s[1]&&(this._stat={size:parseInt(s[1],10)}),{bytesRead:i,buffer:e}}if(200===h.status)throw new Error("${this.url} fetch returned status 200, expected 206");throw new Error(`HTTP ${h.status} fetching ${this.url}`)}async readFile(e={}){let t,r;"string"==typeof e?(t=e,r={}):(t=e.encoding,r=e,delete r.encoding);const{headers:n={},signal:i,overrides:o={}}=r,s={headers:n,method:"GET",redirect:"follow",mode:"cors",signal:i,...this.baseOverrides,...o},a=await this.fetch(this.url,s);if(!a)throw new Error("generic-filehandle failed to fetch");if(200!==a.status)throw Object.assign(new Error(`HTTP ${a.status} fetching ${this.url}`),{status:a.status});if("utf8"===t)return a.text();if(t)throw new Error(`unsupported encoding: ${t}`);return this.getBufferFromResponse(a)}async stat(){if(!this._stat){const e=o.Buffer.allocUnsafe(10);if(await this.read(e,0,10,0),!this._stat)throw new Error(`unable to determine size of file at ${this.url}`)}return this._stat}async close(){}}function f(e){const t=new FileReader;return new Promise(((r,n)=>{t.onerror=()=>{t.abort(),n(new Error("problem reading blob"));},t.onabort=()=>{n(new Error("blob reading was aborted"));},t.onload=()=>{t.result&&"string"!=typeof t.result?r(t.result):n(new Error("unknown error reading blob"));},t.readAsArrayBuffer(e);}))}class h{constructor(e){this.blob=e,this.size=e.size;}async read(e,t=0,r,n=0){if(!r)return {bytesRead:0,buffer:e};const i=n,s=i+r,a=await f(this.blob.slice(i,s)),h=o.Buffer.from(a);return {bytesRead:h.copy(e,t),buffer:h}}async readFile(e){let t;if(t="string"==typeof e?e:e&&e.encoding,"utf8"===t)return function(e){const t=new FileReader;return new Promise(((r,n)=>{t.onerror=()=>{t.abort(),n(new Error("problem reading blob"));},t.onabort=()=>{n(new Error("blob reading was aborted"));},t.onload=()=>{t.result&&"string"==typeof t.result?r(t.result):n(new Error("unknown error reading blob"));},t.readAsText(e);}))}(this.blob);if(t)throw new Error(`unsupported encoding: ${t}`);const r=await f(this.blob);return o.Buffer.from(r)}async stat(){return {size:this.size}}async close(){}}function l(e,t={}){return new a(e,t)}function u(e,t,r,n={}){if(void 0!==r)return r;if(void 0!==e)return l(e,n);if(void 0!==t)return new(i())(t,n);throw new Error("no url, path, or filehandle provided, cannot open")}},645:(e,t)=>{t.read=function(e,t,r,n,i){var o,s,a=8*i-n-1,f=(1<<a)-1,h=f>>1,l=-7,u=r?i-1:0,c=r?-1:1,d=e[t+u];for(u+=c,o=d&(1<<-l)-1,d>>=-l,l+=a;l>0;o=256*o+e[t+u],u+=c,l-=8);for(s=o&(1<<-l)-1,o>>=-l,l+=n;l>0;s=256*s+e[t+u],u+=c,l-=8);if(0===o)o=1-h;else {if(o===f)return s?NaN:1/0*(d?-1:1);s+=Math.pow(2,n),o-=h;}return (d?-1:1)*s*Math.pow(2,o-n)},t.write=function(e,t,r,n,i,o){var s,a,f,h=8*o-i-1,l=(1<<h)-1,u=l>>1,c=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,d=n?0:o-1,p=n?1:-1,g=t<0||0===t&&1/t<0?1:0;for(t=Math.abs(t),isNaN(t)||t===1/0?(a=isNaN(t)?1:0,s=l):(s=Math.floor(Math.log(t)/Math.LN2),t*(f=Math.pow(2,-s))<1&&(s--,f*=2),(t+=s+u>=1?c/f:c*Math.pow(2,1-u))*f>=2&&(s++,f/=2),s+u>=l?(a=0,s=l):s+u>=1?(a=(t*f-1)*Math.pow(2,i),s+=u):(a=t*Math.pow(2,u-1)*Math.pow(2,i),s=0));i>=8;e[r+d]=255&a,d+=p,a/=256,i-=8);for(s=s<<i|a,h+=i;h>0;e[r+d]=255&s,d+=p,s/=256,h-=8);e[r+d-p]|=128*g;};},8738:e=>{function t(e){return !!e.constructor&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)}e.exports=function(e){return null!=e&&(t(e)||function(e){return "function"==typeof e.readFloatLE&&"function"==typeof e.slice&&t(e.slice(0,0))}(e)||!!e._isBuffer)};},3720:e=>{e.exports=r;var t=null;try{t=new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([0,97,115,109,1,0,0,0,1,13,2,96,0,1,127,96,4,127,127,127,127,1,127,3,7,6,0,1,1,1,1,1,6,6,1,127,1,65,0,11,7,50,6,3,109,117,108,0,1,5,100,105,118,95,115,0,2,5,100,105,118,95,117,0,3,5,114,101,109,95,115,0,4,5,114,101,109,95,117,0,5,8,103,101,116,95,104,105,103,104,0,0,10,191,1,6,4,0,35,0,11,36,1,1,126,32,0,173,32,1,173,66,32,134,132,32,2,173,32,3,173,66,32,134,132,126,34,4,66,32,135,167,36,0,32,4,167,11,36,1,1,126,32,0,173,32,1,173,66,32,134,132,32,2,173,32,3,173,66,32,134,132,127,34,4,66,32,135,167,36,0,32,4,167,11,36,1,1,126,32,0,173,32,1,173,66,32,134,132,32,2,173,32,3,173,66,32,134,132,128,34,4,66,32,135,167,36,0,32,4,167,11,36,1,1,126,32,0,173,32,1,173,66,32,134,132,32,2,173,32,3,173,66,32,134,132,129,34,4,66,32,135,167,36,0,32,4,167,11,36,1,1,126,32,0,173,32,1,173,66,32,134,132,32,2,173,32,3,173,66,32,134,132,130,34,4,66,32,135,167,36,0,32,4,167,11])),{}).exports;}catch(e){}function r(e,t,r){this.low=0|e,this.high=0|t,this.unsigned=!!r;}function n(e){return !0===(e&&e.__isLong__)}r.prototype.__isLong__,Object.defineProperty(r.prototype,"__isLong__",{value:!0}),r.isLong=n;var i={},o={};function s(e,t){var r,n,s;return t?(s=0<=(e>>>=0)&&e<256)&&(n=o[e])?n:(r=f(e,(0|e)<0?-1:0,!0),s&&(o[e]=r),r):(s=-128<=(e|=0)&&e<128)&&(n=i[e])?n:(r=f(e,e<0?-1:0,!1),s&&(i[e]=r),r)}function a(e,t){if(isNaN(e))return t?y:m;if(t){if(e<0)return y;if(e>=d)return B}else {if(e<=-p)return E;if(e+1>=p)return _}return e<0?a(-e,t).neg():f(e%c|0,e/c|0,t)}function f(e,t,n){return new r(e,t,n)}r.fromInt=s,r.fromNumber=a,r.fromBits=f;var h=Math.pow;function l(e,t,r){if(0===e.length)throw Error("empty string");if("NaN"===e||"Infinity"===e||"+Infinity"===e||"-Infinity"===e)return m;if("number"==typeof t?(r=t,t=!1):t=!!t,(r=r||10)<2||36<r)throw RangeError("radix");var n;if((n=e.indexOf("-"))>0)throw Error("interior hyphen");if(0===n)return l(e.substring(1),t,r).neg();for(var i=a(h(r,8)),o=m,s=0;s<e.length;s+=8){var f=Math.min(8,e.length-s),u=parseInt(e.substring(s,s+f),r);if(f<8){var c=a(h(r,f));o=o.mul(c).add(a(u));}else o=(o=o.mul(i)).add(a(u));}return o.unsigned=t,o}function u(e,t){return "number"==typeof e?a(e,t):"string"==typeof e?l(e,t):f(e.low,e.high,"boolean"==typeof t?t:e.unsigned)}r.fromString=l,r.fromValue=u;var c=4294967296,d=c*c,p=d/2,g=s(1<<24),m=s(0);r.ZERO=m;var y=s(0,!0);r.UZERO=y;var b=s(1);r.ONE=b;var v=s(1,!0);r.UONE=v;var w=s(-1);r.NEG_ONE=w;var _=f(-1,2147483647,!1);r.MAX_VALUE=_;var B=f(-1,-1,!0);r.MAX_UNSIGNED_VALUE=B;var E=f(0,-2147483648,!1);r.MIN_VALUE=E;var S=r.prototype;S.toInt=function(){return this.unsigned?this.low>>>0:this.low},S.toNumber=function(){return this.unsigned?(this.high>>>0)*c+(this.low>>>0):this.high*c+(this.low>>>0)},S.toString=function(e){if((e=e||10)<2||36<e)throw RangeError("radix");if(this.isZero())return "0";if(this.isNegative()){if(this.eq(E)){var t=a(e),r=this.div(t),n=r.mul(t).sub(this);return r.toString(e)+n.toInt().toString(e)}return "-"+this.neg().toString(e)}for(var i=a(h(e,6),this.unsigned),o=this,s="";;){var f=o.div(i),l=(o.sub(f.mul(i)).toInt()>>>0).toString(e);if((o=f).isZero())return l+s;for(;l.length<6;)l="0"+l;s=""+l+s;}},S.getHighBits=function(){return this.high},S.getHighBitsUnsigned=function(){return this.high>>>0},S.getLowBits=function(){return this.low},S.getLowBitsUnsigned=function(){return this.low>>>0},S.getNumBitsAbs=function(){if(this.isNegative())return this.eq(E)?64:this.neg().getNumBitsAbs();for(var e=0!=this.high?this.high:this.low,t=31;t>0&&0==(e&1<<t);t--);return 0!=this.high?t+33:t+1},S.isZero=function(){return 0===this.high&&0===this.low},S.eqz=S.isZero,S.isNegative=function(){return !this.unsigned&&this.high<0},S.isPositive=function(){return this.unsigned||this.high>=0},S.isOdd=function(){return 1==(1&this.low)},S.isEven=function(){return 0==(1&this.low)},S.equals=function(e){return n(e)||(e=u(e)),(this.unsigned===e.unsigned||this.high>>>31!=1||e.high>>>31!=1)&&this.high===e.high&&this.low===e.low},S.eq=S.equals,S.notEquals=function(e){return !this.eq(e)},S.neq=S.notEquals,S.ne=S.notEquals,S.lessThan=function(e){return this.comp(e)<0},S.lt=S.lessThan,S.lessThanOrEqual=function(e){return this.comp(e)<=0},S.lte=S.lessThanOrEqual,S.le=S.lessThanOrEqual,S.greaterThan=function(e){return this.comp(e)>0},S.gt=S.greaterThan,S.greaterThanOrEqual=function(e){return this.comp(e)>=0},S.gte=S.greaterThanOrEqual,S.ge=S.greaterThanOrEqual,S.compare=function(e){if(n(e)||(e=u(e)),this.eq(e))return 0;var t=this.isNegative(),r=e.isNegative();return t&&!r?-1:!t&&r?1:this.unsigned?e.high>>>0>this.high>>>0||e.high===this.high&&e.low>>>0>this.low>>>0?-1:1:this.sub(e).isNegative()?-1:1},S.comp=S.compare,S.negate=function(){return !this.unsigned&&this.eq(E)?E:this.not().add(b)},S.neg=S.negate,S.add=function(e){n(e)||(e=u(e));var t=this.high>>>16,r=65535&this.high,i=this.low>>>16,o=65535&this.low,s=e.high>>>16,a=65535&e.high,h=e.low>>>16,l=0,c=0,d=0,p=0;return d+=(p+=o+(65535&e.low))>>>16,c+=(d+=i+h)>>>16,l+=(c+=r+a)>>>16,l+=t+s,f((d&=65535)<<16|(p&=65535),(l&=65535)<<16|(c&=65535),this.unsigned)},S.subtract=function(e){return n(e)||(e=u(e)),this.add(e.neg())},S.sub=S.subtract,S.multiply=function(e){if(this.isZero())return m;if(n(e)||(e=u(e)),t)return f(t.mul(this.low,this.high,e.low,e.high),t.get_high(),this.unsigned);if(e.isZero())return m;if(this.eq(E))return e.isOdd()?E:m;if(e.eq(E))return this.isOdd()?E:m;if(this.isNegative())return e.isNegative()?this.neg().mul(e.neg()):this.neg().mul(e).neg();if(e.isNegative())return this.mul(e.neg()).neg();if(this.lt(g)&&e.lt(g))return a(this.toNumber()*e.toNumber(),this.unsigned);var r=this.high>>>16,i=65535&this.high,o=this.low>>>16,s=65535&this.low,h=e.high>>>16,l=65535&e.high,c=e.low>>>16,d=65535&e.low,p=0,y=0,b=0,v=0;return b+=(v+=s*d)>>>16,y+=(b+=o*d)>>>16,b&=65535,y+=(b+=s*c)>>>16,p+=(y+=i*d)>>>16,y&=65535,p+=(y+=o*c)>>>16,y&=65535,p+=(y+=s*l)>>>16,p+=r*d+i*c+o*l+s*h,f((b&=65535)<<16|(v&=65535),(p&=65535)<<16|(y&=65535),this.unsigned)},S.mul=S.multiply,S.divide=function(e){if(n(e)||(e=u(e)),e.isZero())throw Error("division by zero");var r,i,o;if(t)return this.unsigned||-2147483648!==this.high||-1!==e.low||-1!==e.high?f((this.unsigned?t.div_u:t.div_s)(this.low,this.high,e.low,e.high),t.get_high(),this.unsigned):this;if(this.isZero())return this.unsigned?y:m;if(this.unsigned){if(e.unsigned||(e=e.toUnsigned()),e.gt(this))return y;if(e.gt(this.shru(1)))return v;o=y;}else {if(this.eq(E))return e.eq(b)||e.eq(w)?E:e.eq(E)?b:(r=this.shr(1).div(e).shl(1)).eq(m)?e.isNegative()?b:w:(i=this.sub(e.mul(r)),o=r.add(i.div(e)));if(e.eq(E))return this.unsigned?y:m;if(this.isNegative())return e.isNegative()?this.neg().div(e.neg()):this.neg().div(e).neg();if(e.isNegative())return this.div(e.neg()).neg();o=m;}for(i=this;i.gte(e);){r=Math.max(1,Math.floor(i.toNumber()/e.toNumber()));for(var s=Math.ceil(Math.log(r)/Math.LN2),l=s<=48?1:h(2,s-48),c=a(r),d=c.mul(e);d.isNegative()||d.gt(i);)d=(c=a(r-=l,this.unsigned)).mul(e);c.isZero()&&(c=b),o=o.add(c),i=i.sub(d);}return o},S.div=S.divide,S.modulo=function(e){return n(e)||(e=u(e)),t?f((this.unsigned?t.rem_u:t.rem_s)(this.low,this.high,e.low,e.high),t.get_high(),this.unsigned):this.sub(this.div(e).mul(e))},S.mod=S.modulo,S.rem=S.modulo,S.not=function(){return f(~this.low,~this.high,this.unsigned)},S.and=function(e){return n(e)||(e=u(e)),f(this.low&e.low,this.high&e.high,this.unsigned)},S.or=function(e){return n(e)||(e=u(e)),f(this.low|e.low,this.high|e.high,this.unsigned)},S.xor=function(e){return n(e)||(e=u(e)),f(this.low^e.low,this.high^e.high,this.unsigned)},S.shiftLeft=function(e){return n(e)&&(e=e.toInt()),0==(e&=63)?this:e<32?f(this.low<<e,this.high<<e|this.low>>>32-e,this.unsigned):f(0,this.low<<e-32,this.unsigned)},S.shl=S.shiftLeft,S.shiftRight=function(e){return n(e)&&(e=e.toInt()),0==(e&=63)?this:e<32?f(this.low>>>e|this.high<<32-e,this.high>>e,this.unsigned):f(this.high>>e-32,this.high>=0?0:-1,this.unsigned)},S.shr=S.shiftRight,S.shiftRightUnsigned=function(e){if(n(e)&&(e=e.toInt()),0==(e&=63))return this;var t=this.high;return e<32?f(this.low>>>e|t<<32-e,t>>>e,this.unsigned):f(32===e?t:t>>>e-32,0,this.unsigned)},S.shru=S.shiftRightUnsigned,S.shr_u=S.shiftRightUnsigned,S.toSigned=function(){return this.unsigned?f(this.low,this.high,!1):this},S.toUnsigned=function(){return this.unsigned?this:f(this.low,this.high,!0)},S.toBytes=function(e){return e?this.toBytesLE():this.toBytesBE()},S.toBytesLE=function(){var e=this.high,t=this.low;return [255&t,t>>>8&255,t>>>16&255,t>>>24,255&e,e>>>8&255,e>>>16&255,e>>>24]},S.toBytesBE=function(){var e=this.high,t=this.low;return [e>>>24,e>>>16&255,e>>>8&255,255&e,t>>>24,t>>>16&255,t>>>8&255,255&t]},r.fromBytes=function(e,t,n){return n?r.fromBytesLE(e,t):r.fromBytesBE(e,t)},r.fromBytesLE=function(e,t){return new r(e[0]|e[1]<<8|e[2]<<16|e[3]<<24,e[4]|e[5]<<8|e[6]<<16|e[7]<<24,t)},r.fromBytesBE=function(e,t){return new r(e[4]<<24|e[5]<<16|e[6]<<8|e[7],e[0]<<24|e[1]<<16|e[2]<<8|e[3],t)};},2568:(e,t,r)=>{var n,i,o,s,a;n=r(1012),i=r(487).utf8,o=r(8738),s=r(487).bin,(a=function(e,t){e.constructor==String?e=t&&"binary"===t.encoding?s.stringToBytes(e):i.stringToBytes(e):o(e)?e=Array.prototype.slice.call(e,0):Array.isArray(e)||e.constructor===Uint8Array||(e=e.toString());for(var r=n.bytesToWords(e),f=8*e.length,h=1732584193,l=-271733879,u=-1732584194,c=271733878,d=0;d<r.length;d++)r[d]=16711935&(r[d]<<8|r[d]>>>24)|4278255360&(r[d]<<24|r[d]>>>8);r[f>>>5]|=128<<f%32,r[14+(f+64>>>9<<4)]=f;var p=a._ff,g=a._gg,m=a._hh,y=a._ii;for(d=0;d<r.length;d+=16){var b=h,v=l,w=u,_=c;h=p(h,l,u,c,r[d+0],7,-680876936),c=p(c,h,l,u,r[d+1],12,-389564586),u=p(u,c,h,l,r[d+2],17,606105819),l=p(l,u,c,h,r[d+3],22,-1044525330),h=p(h,l,u,c,r[d+4],7,-176418897),c=p(c,h,l,u,r[d+5],12,1200080426),u=p(u,c,h,l,r[d+6],17,-1473231341),l=p(l,u,c,h,r[d+7],22,-45705983),h=p(h,l,u,c,r[d+8],7,1770035416),c=p(c,h,l,u,r[d+9],12,-1958414417),u=p(u,c,h,l,r[d+10],17,-42063),l=p(l,u,c,h,r[d+11],22,-1990404162),h=p(h,l,u,c,r[d+12],7,1804603682),c=p(c,h,l,u,r[d+13],12,-40341101),u=p(u,c,h,l,r[d+14],17,-1502002290),h=g(h,l=p(l,u,c,h,r[d+15],22,1236535329),u,c,r[d+1],5,-165796510),c=g(c,h,l,u,r[d+6],9,-1069501632),u=g(u,c,h,l,r[d+11],14,643717713),l=g(l,u,c,h,r[d+0],20,-373897302),h=g(h,l,u,c,r[d+5],5,-701558691),c=g(c,h,l,u,r[d+10],9,38016083),u=g(u,c,h,l,r[d+15],14,-660478335),l=g(l,u,c,h,r[d+4],20,-405537848),h=g(h,l,u,c,r[d+9],5,568446438),c=g(c,h,l,u,r[d+14],9,-1019803690),u=g(u,c,h,l,r[d+3],14,-187363961),l=g(l,u,c,h,r[d+8],20,1163531501),h=g(h,l,u,c,r[d+13],5,-1444681467),c=g(c,h,l,u,r[d+2],9,-51403784),u=g(u,c,h,l,r[d+7],14,1735328473),h=m(h,l=g(l,u,c,h,r[d+12],20,-1926607734),u,c,r[d+5],4,-378558),c=m(c,h,l,u,r[d+8],11,-2022574463),u=m(u,c,h,l,r[d+11],16,1839030562),l=m(l,u,c,h,r[d+14],23,-35309556),h=m(h,l,u,c,r[d+1],4,-1530992060),c=m(c,h,l,u,r[d+4],11,1272893353),u=m(u,c,h,l,r[d+7],16,-155497632),l=m(l,u,c,h,r[d+10],23,-1094730640),h=m(h,l,u,c,r[d+13],4,681279174),c=m(c,h,l,u,r[d+0],11,-358537222),u=m(u,c,h,l,r[d+3],16,-722521979),l=m(l,u,c,h,r[d+6],23,76029189),h=m(h,l,u,c,r[d+9],4,-640364487),c=m(c,h,l,u,r[d+12],11,-421815835),u=m(u,c,h,l,r[d+15],16,530742520),h=y(h,l=m(l,u,c,h,r[d+2],23,-995338651),u,c,r[d+0],6,-198630844),c=y(c,h,l,u,r[d+7],10,1126891415),u=y(u,c,h,l,r[d+14],15,-1416354905),l=y(l,u,c,h,r[d+5],21,-57434055),h=y(h,l,u,c,r[d+12],6,1700485571),c=y(c,h,l,u,r[d+3],10,-1894986606),u=y(u,c,h,l,r[d+10],15,-1051523),l=y(l,u,c,h,r[d+1],21,-2054922799),h=y(h,l,u,c,r[d+8],6,1873313359),c=y(c,h,l,u,r[d+15],10,-30611744),u=y(u,c,h,l,r[d+6],15,-1560198380),l=y(l,u,c,h,r[d+13],21,1309151649),h=y(h,l,u,c,r[d+4],6,-145523070),c=y(c,h,l,u,r[d+11],10,-1120210379),u=y(u,c,h,l,r[d+2],15,718787259),l=y(l,u,c,h,r[d+9],21,-343485551),h=h+b>>>0,l=l+v>>>0,u=u+w>>>0,c=c+_>>>0;}return n.endian([h,l,u,c])})._ff=function(e,t,r,n,i,o,s){var a=e+(t&r|~t&n)+(i>>>0)+s;return (a<<o|a>>>32-o)+t},a._gg=function(e,t,r,n,i,o,s){var a=e+(t&n|r&~n)+(i>>>0)+s;return (a<<o|a>>>32-o)+t},a._hh=function(e,t,r,n,i,o,s){var a=e+(t^r^n)+(i>>>0)+s;return (a<<o|a>>>32-o)+t},a._ii=function(e,t,r,n,i,o,s){var a=e+(r^(t|~n))+(i>>>0)+s;return (a<<o|a>>>32-o)+t},a._blocksize=16,a._digestsize=16,e.exports=function(e,t){if(null==e)throw new Error("Illegal argument "+e);var r=n.wordsToBytes(a(e,t));return t&&t.asBytes?r:t&&t.asString?s.bytesToString(r):n.bytesToHex(r)};},9591:(e,t,r)=>{var n={};(0, r(4236).assign)(n,r(4555),r(8843),r(1619)),e.exports=n;},4555:(e,t,r)=>{var n=r(405),i=r(4236),o=r(9373),s=r(8898),a=r(2292),f=Object.prototype.toString;function h(e){if(!(this instanceof h))return new h(e);this.options=i.assign({level:-1,method:8,chunkSize:16384,windowBits:15,memLevel:8,strategy:0,to:""},e||{});var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new a,this.strm.avail_out=0;var r=n.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(0!==r)throw new Error(s[r]);if(t.header&&n.deflateSetHeader(this.strm,t.header),t.dictionary){var l;if(l="string"==typeof t.dictionary?o.string2buf(t.dictionary):"[object ArrayBuffer]"===f.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,0!==(r=n.deflateSetDictionary(this.strm,l)))throw new Error(s[r]);this._dict_set=!0;}}function l(e,t){var r=new h(t);if(r.push(e,!0),r.err)throw r.msg||s[r.err];return r.result}h.prototype.push=function(e,t){var r,s,a=this.strm,h=this.options.chunkSize;if(this.ended)return !1;s=t===~~t?t:!0===t?4:0,"string"==typeof e?a.input=o.string2buf(e):"[object ArrayBuffer]"===f.call(e)?a.input=new Uint8Array(e):a.input=e,a.next_in=0,a.avail_in=a.input.length;do{if(0===a.avail_out&&(a.output=new i.Buf8(h),a.next_out=0,a.avail_out=h),1!==(r=n.deflate(a,s))&&0!==r)return this.onEnd(r),this.ended=!0,!1;0!==a.avail_out&&(0!==a.avail_in||4!==s&&2!==s)||("string"===this.options.to?this.onData(o.buf2binstring(i.shrinkBuf(a.output,a.next_out))):this.onData(i.shrinkBuf(a.output,a.next_out)));}while((a.avail_in>0||0===a.avail_out)&&1!==r);return 4===s?(r=n.deflateEnd(this.strm),this.onEnd(r),this.ended=!0,0===r):2!==s||(this.onEnd(0),a.avail_out=0,!0)},h.prototype.onData=function(e){this.chunks.push(e);},h.prototype.onEnd=function(e){0===e&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=i.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg;},t.Deflate=h,t.deflate=l,t.deflateRaw=function(e,t){return (t=t||{}).raw=!0,l(e,t)},t.gzip=function(e,t){return (t=t||{}).gzip=!0,l(e,t)};},8843:(e,t,r)=>{var n=r(7948),i=r(4236),o=r(9373),s=r(1619),a=r(8898),f=r(2292),h=r(2401),l=Object.prototype.toString;function u(e){if(!(this instanceof u))return new u(e);this.options=i.assign({chunkSize:16384,windowBits:0,to:""},e||{});var t=this.options;t.raw&&t.windowBits>=0&&t.windowBits<16&&(t.windowBits=-t.windowBits,0===t.windowBits&&(t.windowBits=-15)),!(t.windowBits>=0&&t.windowBits<16)||e&&e.windowBits||(t.windowBits+=32),t.windowBits>15&&t.windowBits<48&&0==(15&t.windowBits)&&(t.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new f,this.strm.avail_out=0;var r=n.inflateInit2(this.strm,t.windowBits);if(r!==s.Z_OK)throw new Error(a[r]);if(this.header=new h,n.inflateGetHeader(this.strm,this.header),t.dictionary&&("string"==typeof t.dictionary?t.dictionary=o.string2buf(t.dictionary):"[object ArrayBuffer]"===l.call(t.dictionary)&&(t.dictionary=new Uint8Array(t.dictionary)),t.raw&&(r=n.inflateSetDictionary(this.strm,t.dictionary))!==s.Z_OK))throw new Error(a[r])}function c(e,t){var r=new u(t);if(r.push(e,!0),r.err)throw r.msg||a[r.err];return r.result}u.prototype.push=function(e,t){var r,a,f,h,u,c=this.strm,d=this.options.chunkSize,p=this.options.dictionary,g=!1;if(this.ended)return !1;a=t===~~t?t:!0===t?s.Z_FINISH:s.Z_NO_FLUSH,"string"==typeof e?c.input=o.binstring2buf(e):"[object ArrayBuffer]"===l.call(e)?c.input=new Uint8Array(e):c.input=e,c.next_in=0,c.avail_in=c.input.length;do{if(0===c.avail_out&&(c.output=new i.Buf8(d),c.next_out=0,c.avail_out=d),(r=n.inflate(c,s.Z_NO_FLUSH))===s.Z_NEED_DICT&&p&&(r=n.inflateSetDictionary(this.strm,p)),r===s.Z_BUF_ERROR&&!0===g&&(r=s.Z_OK,g=!1),r!==s.Z_STREAM_END&&r!==s.Z_OK)return this.onEnd(r),this.ended=!0,!1;c.next_out&&(0!==c.avail_out&&r!==s.Z_STREAM_END&&(0!==c.avail_in||a!==s.Z_FINISH&&a!==s.Z_SYNC_FLUSH)||("string"===this.options.to?(f=o.utf8border(c.output,c.next_out),h=c.next_out-f,u=o.buf2string(c.output,f),c.next_out=h,c.avail_out=d-h,h&&i.arraySet(c.output,c.output,f,h,0),this.onData(u)):this.onData(i.shrinkBuf(c.output,c.next_out)))),0===c.avail_in&&0===c.avail_out&&(g=!0);}while((c.avail_in>0||0===c.avail_out)&&r!==s.Z_STREAM_END);return r===s.Z_STREAM_END&&(a=s.Z_FINISH),a===s.Z_FINISH?(r=n.inflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===s.Z_OK):a!==s.Z_SYNC_FLUSH||(this.onEnd(s.Z_OK),c.avail_out=0,!0)},u.prototype.onData=function(e){this.chunks.push(e);},u.prototype.onEnd=function(e){e===s.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=i.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg;},t.Inflate=u,t.inflate=c,t.inflateRaw=function(e,t){return (t=t||{}).raw=!0,c(e,t)},t.ungzip=c;},4236:(e,t)=>{var r="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;function n(e,t){return Object.prototype.hasOwnProperty.call(e,t)}t.assign=function(e){for(var t=Array.prototype.slice.call(arguments,1);t.length;){var r=t.shift();if(r){if("object"!=typeof r)throw new TypeError(r+"must be non-object");for(var i in r)n(r,i)&&(e[i]=r[i]);}}return e},t.shrinkBuf=function(e,t){return e.length===t?e:e.subarray?e.subarray(0,t):(e.length=t,e)};var i={arraySet:function(e,t,r,n,i){if(t.subarray&&e.subarray)e.set(t.subarray(r,r+n),i);else for(var o=0;o<n;o++)e[i+o]=t[r+o];},flattenChunks:function(e){var t,r,n,i,o,s;for(n=0,t=0,r=e.length;t<r;t++)n+=e[t].length;for(s=new Uint8Array(n),i=0,t=0,r=e.length;t<r;t++)o=e[t],s.set(o,i),i+=o.length;return s}},o={arraySet:function(e,t,r,n,i){for(var o=0;o<n;o++)e[i+o]=t[r+o];},flattenChunks:function(e){return [].concat.apply([],e)}};t.setTyped=function(e){e?(t.Buf8=Uint8Array,t.Buf16=Uint16Array,t.Buf32=Int32Array,t.assign(t,i)):(t.Buf8=Array,t.Buf16=Array,t.Buf32=Array,t.assign(t,o));},t.setTyped(r);},9373:(e,t,r)=>{var n=r(4236),i=!0,o=!0;try{String.fromCharCode.apply(null,[0]);}catch(e){i=!1;}try{String.fromCharCode.apply(null,new Uint8Array(1));}catch(e){o=!1;}for(var s=new n.Buf8(256),a=0;a<256;a++)s[a]=a>=252?6:a>=248?5:a>=240?4:a>=224?3:a>=192?2:1;function f(e,t){if(t<65534&&(e.subarray&&o||!e.subarray&&i))return String.fromCharCode.apply(null,n.shrinkBuf(e,t));for(var r="",s=0;s<t;s++)r+=String.fromCharCode(e[s]);return r}s[254]=s[254]=1,t.string2buf=function(e){var t,r,i,o,s,a=e.length,f=0;for(o=0;o<a;o++)55296==(64512&(r=e.charCodeAt(o)))&&o+1<a&&56320==(64512&(i=e.charCodeAt(o+1)))&&(r=65536+(r-55296<<10)+(i-56320),o++),f+=r<128?1:r<2048?2:r<65536?3:4;for(t=new n.Buf8(f),s=0,o=0;s<f;o++)55296==(64512&(r=e.charCodeAt(o)))&&o+1<a&&56320==(64512&(i=e.charCodeAt(o+1)))&&(r=65536+(r-55296<<10)+(i-56320),o++),r<128?t[s++]=r:r<2048?(t[s++]=192|r>>>6,t[s++]=128|63&r):r<65536?(t[s++]=224|r>>>12,t[s++]=128|r>>>6&63,t[s++]=128|63&r):(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63,t[s++]=128|r>>>6&63,t[s++]=128|63&r);return t},t.buf2binstring=function(e){return f(e,e.length)},t.binstring2buf=function(e){for(var t=new n.Buf8(e.length),r=0,i=t.length;r<i;r++)t[r]=e.charCodeAt(r);return t},t.buf2string=function(e,t){var r,n,i,o,a=t||e.length,h=new Array(2*a);for(n=0,r=0;r<a;)if((i=e[r++])<128)h[n++]=i;else if((o=s[i])>4)h[n++]=65533,r+=o-1;else {for(i&=2===o?31:3===o?15:7;o>1&&r<a;)i=i<<6|63&e[r++],o--;o>1?h[n++]=65533:i<65536?h[n++]=i:(i-=65536,h[n++]=55296|i>>10&1023,h[n++]=56320|1023&i);}return f(h,n)},t.utf8border=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;r>=0&&128==(192&e[r]);)r--;return r<0||0===r?t:r+s[e[r]]>t?r:t};},6069:e=>{e.exports=function(e,t,r,n){for(var i=65535&e|0,o=e>>>16&65535|0,s=0;0!==r;){r-=s=r>2e3?2e3:r;do{o=o+(i=i+t[n++]|0)|0;}while(--s);i%=65521,o%=65521;}return i|o<<16|0};},1619:e=>{e.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8};},2869:e=>{var t=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e;}return t}();e.exports=function(e,r,n,i){var o=t,s=i+n;e^=-1;for(var a=i;a<s;a++)e=e>>>8^o[255&(e^r[a])];return -1^e};},405:(e,t,r)=>{var n,i=r(4236),o=r(342),s=r(6069),a=r(2869),f=r(8898),h=-2,l=258,u=262,c=103,d=113,p=666;function g(e,t){return e.msg=f[t],t}function m(e){return (e<<1)-(e>4?9:0)}function y(e){for(var t=e.length;--t>=0;)e[t]=0;}function b(e){var t=e.state,r=t.pending;r>e.avail_out&&(r=e.avail_out),0!==r&&(i.arraySet(e.output,t.pending_buf,t.pending_out,r,e.next_out),e.next_out+=r,t.pending_out+=r,e.total_out+=r,e.avail_out-=r,t.pending-=r,0===t.pending&&(t.pending_out=0));}function v(e,t){o._tr_flush_block(e,e.block_start>=0?e.block_start:-1,e.strstart-e.block_start,t),e.block_start=e.strstart,b(e.strm);}function w(e,t){e.pending_buf[e.pending++]=t;}function _(e,t){e.pending_buf[e.pending++]=t>>>8&255,e.pending_buf[e.pending++]=255&t;}function B(e,t,r,n){var o=e.avail_in;return o>n&&(o=n),0===o?0:(e.avail_in-=o,i.arraySet(t,e.input,e.next_in,o,r),1===e.state.wrap?e.adler=s(e.adler,t,o,r):2===e.state.wrap&&(e.adler=a(e.adler,t,o,r)),e.next_in+=o,e.total_in+=o,o)}function E(e,t){var r,n,i=e.max_chain_length,o=e.strstart,s=e.prev_length,a=e.nice_match,f=e.strstart>e.w_size-u?e.strstart-(e.w_size-u):0,h=e.window,c=e.w_mask,d=e.prev,p=e.strstart+l,g=h[o+s-1],m=h[o+s];e.prev_length>=e.good_match&&(i>>=2),a>e.lookahead&&(a=e.lookahead);do{if(h[(r=t)+s]===m&&h[r+s-1]===g&&h[r]===h[o]&&h[++r]===h[o+1]){o+=2,r++;do{}while(h[++o]===h[++r]&&h[++o]===h[++r]&&h[++o]===h[++r]&&h[++o]===h[++r]&&h[++o]===h[++r]&&h[++o]===h[++r]&&h[++o]===h[++r]&&h[++o]===h[++r]&&o<p);if(n=l-(p-o),o=p-l,n>s){if(e.match_start=t,s=n,n>=a)break;g=h[o+s-1],m=h[o+s];}}}while((t=d[t&c])>f&&0!=--i);return s<=e.lookahead?s:e.lookahead}function S(e){var t,r,n,o,s,a=e.w_size;do{if(o=e.window_size-e.lookahead-e.strstart,e.strstart>=a+(a-u)){i.arraySet(e.window,e.window,a,a,0),e.match_start-=a,e.strstart-=a,e.block_start-=a,t=r=e.hash_size;do{n=e.head[--t],e.head[t]=n>=a?n-a:0;}while(--r);t=r=a;do{n=e.prev[--t],e.prev[t]=n>=a?n-a:0;}while(--r);o+=a;}if(0===e.strm.avail_in)break;if(r=B(e.strm,e.window,e.strstart+e.lookahead,o),e.lookahead+=r,e.lookahead+e.insert>=3)for(s=e.strstart-e.insert,e.ins_h=e.window[s],e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+1])&e.hash_mask;e.insert&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+3-1])&e.hash_mask,e.prev[s&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=s,s++,e.insert--,!(e.lookahead+e.insert<3)););}while(e.lookahead<u&&0!==e.strm.avail_in)}function A(e,t){for(var r,n;;){if(e.lookahead<u){if(S(e),e.lookahead<u&&0===t)return 1;if(0===e.lookahead)break}if(r=0,e.lookahead>=3&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+3-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!==r&&e.strstart-r<=e.w_size-u&&(e.match_length=E(e,r)),e.match_length>=3)if(n=o._tr_tally(e,e.strstart-e.match_start,e.match_length-3),e.lookahead-=e.match_length,e.match_length<=e.max_lazy_match&&e.lookahead>=3){e.match_length--;do{e.strstart++,e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+3-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart;}while(0!=--e.match_length);e.strstart++;}else e.strstart+=e.match_length,e.match_length=0,e.ins_h=e.window[e.strstart],e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask;else n=o._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++;if(n&&(v(e,!1),0===e.strm.avail_out))return 1}return e.insert=e.strstart<2?e.strstart:2,4===t?(v(e,!0),0===e.strm.avail_out?3:4):e.last_lit&&(v(e,!1),0===e.strm.avail_out)?1:2}function C(e,t){for(var r,n,i;;){if(e.lookahead<u){if(S(e),e.lookahead<u&&0===t)return 1;if(0===e.lookahead)break}if(r=0,e.lookahead>=3&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+3-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),e.prev_length=e.match_length,e.prev_match=e.match_start,e.match_length=2,0!==r&&e.prev_length<e.max_lazy_match&&e.strstart-r<=e.w_size-u&&(e.match_length=E(e,r),e.match_length<=5&&(1===e.strategy||3===e.match_length&&e.strstart-e.match_start>4096)&&(e.match_length=2)),e.prev_length>=3&&e.match_length<=e.prev_length){i=e.strstart+e.lookahead-3,n=o._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-3),e.lookahead-=e.prev_length-1,e.prev_length-=2;do{++e.strstart<=i&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+3-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart);}while(0!=--e.prev_length);if(e.match_available=0,e.match_length=2,e.strstart++,n&&(v(e,!1),0===e.strm.avail_out))return 1}else if(e.match_available){if((n=o._tr_tally(e,0,e.window[e.strstart-1]))&&v(e,!1),e.strstart++,e.lookahead--,0===e.strm.avail_out)return 1}else e.match_available=1,e.strstart++,e.lookahead--;}return e.match_available&&(n=o._tr_tally(e,0,e.window[e.strstart-1]),e.match_available=0),e.insert=e.strstart<2?e.strstart:2,4===t?(v(e,!0),0===e.strm.avail_out?3:4):e.last_lit&&(v(e,!1),0===e.strm.avail_out)?1:2}function R(e,t,r,n,i){this.good_length=e,this.max_lazy=t,this.nice_length=r,this.max_chain=n,this.func=i;}function k(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=8,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new i.Buf16(1146),this.dyn_dtree=new i.Buf16(122),this.bl_tree=new i.Buf16(78),y(this.dyn_ltree),y(this.dyn_dtree),y(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new i.Buf16(16),this.heap=new i.Buf16(573),y(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new i.Buf16(573),y(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0;}function x(e){var t;return e&&e.state?(e.total_in=e.total_out=0,e.data_type=2,(t=e.state).pending=0,t.pending_out=0,t.wrap<0&&(t.wrap=-t.wrap),t.status=t.wrap?42:d,e.adler=2===t.wrap?0:1,t.last_flush=0,o._tr_init(t),0):g(e,h)}function I(e){var t,r=x(e);return 0===r&&((t=e.state).window_size=2*t.w_size,y(t.head),t.max_lazy_match=n[t.level].max_lazy,t.good_match=n[t.level].good_length,t.nice_match=n[t.level].nice_length,t.max_chain_length=n[t.level].max_chain,t.strstart=0,t.block_start=0,t.lookahead=0,t.insert=0,t.match_length=t.prev_length=2,t.match_available=0,t.ins_h=0),r}function M(e,t,r,n,o,s){if(!e)return h;var a=1;if(-1===t&&(t=6),n<0?(a=0,n=-n):n>15&&(a=2,n-=16),o<1||o>9||8!==r||n<8||n>15||t<0||t>9||s<0||s>4)return g(e,h);8===n&&(n=9);var f=new k;return e.state=f,f.strm=e,f.wrap=a,f.gzhead=null,f.w_bits=n,f.w_size=1<<f.w_bits,f.w_mask=f.w_size-1,f.hash_bits=o+7,f.hash_size=1<<f.hash_bits,f.hash_mask=f.hash_size-1,f.hash_shift=~~((f.hash_bits+3-1)/3),f.window=new i.Buf8(2*f.w_size),f.head=new i.Buf16(f.hash_size),f.prev=new i.Buf16(f.w_size),f.lit_bufsize=1<<o+6,f.pending_buf_size=4*f.lit_bufsize,f.pending_buf=new i.Buf8(f.pending_buf_size),f.d_buf=1*f.lit_bufsize,f.l_buf=3*f.lit_bufsize,f.level=t,f.strategy=s,f.method=r,I(e)}n=[new R(0,0,0,0,(function(e,t){var r=65535;for(r>e.pending_buf_size-5&&(r=e.pending_buf_size-5);;){if(e.lookahead<=1){if(S(e),0===e.lookahead&&0===t)return 1;if(0===e.lookahead)break}e.strstart+=e.lookahead,e.lookahead=0;var n=e.block_start+r;if((0===e.strstart||e.strstart>=n)&&(e.lookahead=e.strstart-n,e.strstart=n,v(e,!1),0===e.strm.avail_out))return 1;if(e.strstart-e.block_start>=e.w_size-u&&(v(e,!1),0===e.strm.avail_out))return 1}return e.insert=0,4===t?(v(e,!0),0===e.strm.avail_out?3:4):(e.strstart>e.block_start&&(v(e,!1),e.strm.avail_out),1)})),new R(4,4,8,4,A),new R(4,5,16,8,A),new R(4,6,32,32,A),new R(4,4,16,16,C),new R(8,16,32,32,C),new R(8,16,128,128,C),new R(8,32,128,256,C),new R(32,128,258,1024,C),new R(32,258,258,4096,C)],t.deflateInit=function(e,t){return M(e,t,8,15,8,0)},t.deflateInit2=M,t.deflateReset=I,t.deflateResetKeep=x,t.deflateSetHeader=function(e,t){return e&&e.state?2!==e.state.wrap?h:(e.state.gzhead=t,0):h},t.deflate=function(e,t){var r,i,s,f;if(!e||!e.state||t>5||t<0)return e?g(e,h):h;if(i=e.state,!e.output||!e.input&&0!==e.avail_in||i.status===p&&4!==t)return g(e,0===e.avail_out?-5:h);if(i.strm=e,r=i.last_flush,i.last_flush=t,42===i.status)if(2===i.wrap)e.adler=0,w(i,31),w(i,139),w(i,8),i.gzhead?(w(i,(i.gzhead.text?1:0)+(i.gzhead.hcrc?2:0)+(i.gzhead.extra?4:0)+(i.gzhead.name?8:0)+(i.gzhead.comment?16:0)),w(i,255&i.gzhead.time),w(i,i.gzhead.time>>8&255),w(i,i.gzhead.time>>16&255),w(i,i.gzhead.time>>24&255),w(i,9===i.level?2:i.strategy>=2||i.level<2?4:0),w(i,255&i.gzhead.os),i.gzhead.extra&&i.gzhead.extra.length&&(w(i,255&i.gzhead.extra.length),w(i,i.gzhead.extra.length>>8&255)),i.gzhead.hcrc&&(e.adler=a(e.adler,i.pending_buf,i.pending,0)),i.gzindex=0,i.status=69):(w(i,0),w(i,0),w(i,0),w(i,0),w(i,0),w(i,9===i.level?2:i.strategy>=2||i.level<2?4:0),w(i,3),i.status=d);else {var u=8+(i.w_bits-8<<4)<<8;u|=(i.strategy>=2||i.level<2?0:i.level<6?1:6===i.level?2:3)<<6,0!==i.strstart&&(u|=32),u+=31-u%31,i.status=d,_(i,u),0!==i.strstart&&(_(i,e.adler>>>16),_(i,65535&e.adler)),e.adler=1;}if(69===i.status)if(i.gzhead.extra){for(s=i.pending;i.gzindex<(65535&i.gzhead.extra.length)&&(i.pending!==i.pending_buf_size||(i.gzhead.hcrc&&i.pending>s&&(e.adler=a(e.adler,i.pending_buf,i.pending-s,s)),b(e),s=i.pending,i.pending!==i.pending_buf_size));)w(i,255&i.gzhead.extra[i.gzindex]),i.gzindex++;i.gzhead.hcrc&&i.pending>s&&(e.adler=a(e.adler,i.pending_buf,i.pending-s,s)),i.gzindex===i.gzhead.extra.length&&(i.gzindex=0,i.status=73);}else i.status=73;if(73===i.status)if(i.gzhead.name){s=i.pending;do{if(i.pending===i.pending_buf_size&&(i.gzhead.hcrc&&i.pending>s&&(e.adler=a(e.adler,i.pending_buf,i.pending-s,s)),b(e),s=i.pending,i.pending===i.pending_buf_size)){f=1;break}f=i.gzindex<i.gzhead.name.length?255&i.gzhead.name.charCodeAt(i.gzindex++):0,w(i,f);}while(0!==f);i.gzhead.hcrc&&i.pending>s&&(e.adler=a(e.adler,i.pending_buf,i.pending-s,s)),0===f&&(i.gzindex=0,i.status=91);}else i.status=91;if(91===i.status)if(i.gzhead.comment){s=i.pending;do{if(i.pending===i.pending_buf_size&&(i.gzhead.hcrc&&i.pending>s&&(e.adler=a(e.adler,i.pending_buf,i.pending-s,s)),b(e),s=i.pending,i.pending===i.pending_buf_size)){f=1;break}f=i.gzindex<i.gzhead.comment.length?255&i.gzhead.comment.charCodeAt(i.gzindex++):0,w(i,f);}while(0!==f);i.gzhead.hcrc&&i.pending>s&&(e.adler=a(e.adler,i.pending_buf,i.pending-s,s)),0===f&&(i.status=c);}else i.status=c;if(i.status===c&&(i.gzhead.hcrc?(i.pending+2>i.pending_buf_size&&b(e),i.pending+2<=i.pending_buf_size&&(w(i,255&e.adler),w(i,e.adler>>8&255),e.adler=0,i.status=d)):i.status=d),0!==i.pending){if(b(e),0===e.avail_out)return i.last_flush=-1,0}else if(0===e.avail_in&&m(t)<=m(r)&&4!==t)return g(e,-5);if(i.status===p&&0!==e.avail_in)return g(e,-5);if(0!==e.avail_in||0!==i.lookahead||0!==t&&i.status!==p){var B=2===i.strategy?function(e,t){for(var r;;){if(0===e.lookahead&&(S(e),0===e.lookahead)){if(0===t)return 1;break}if(e.match_length=0,r=o._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++,r&&(v(e,!1),0===e.strm.avail_out))return 1}return e.insert=0,4===t?(v(e,!0),0===e.strm.avail_out?3:4):e.last_lit&&(v(e,!1),0===e.strm.avail_out)?1:2}(i,t):3===i.strategy?function(e,t){for(var r,n,i,s,a=e.window;;){if(e.lookahead<=l){if(S(e),e.lookahead<=l&&0===t)return 1;if(0===e.lookahead)break}if(e.match_length=0,e.lookahead>=3&&e.strstart>0&&(n=a[i=e.strstart-1])===a[++i]&&n===a[++i]&&n===a[++i]){s=e.strstart+l;do{}while(n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&i<s);e.match_length=l-(s-i),e.match_length>e.lookahead&&(e.match_length=e.lookahead);}if(e.match_length>=3?(r=o._tr_tally(e,1,e.match_length-3),e.lookahead-=e.match_length,e.strstart+=e.match_length,e.match_length=0):(r=o._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++),r&&(v(e,!1),0===e.strm.avail_out))return 1}return e.insert=0,4===t?(v(e,!0),0===e.strm.avail_out?3:4):e.last_lit&&(v(e,!1),0===e.strm.avail_out)?1:2}(i,t):n[i.level].func(i,t);if(3!==B&&4!==B||(i.status=p),1===B||3===B)return 0===e.avail_out&&(i.last_flush=-1),0;if(2===B&&(1===t?o._tr_align(i):5!==t&&(o._tr_stored_block(i,0,0,!1),3===t&&(y(i.head),0===i.lookahead&&(i.strstart=0,i.block_start=0,i.insert=0))),b(e),0===e.avail_out))return i.last_flush=-1,0}return 4!==t?0:i.wrap<=0?1:(2===i.wrap?(w(i,255&e.adler),w(i,e.adler>>8&255),w(i,e.adler>>16&255),w(i,e.adler>>24&255),w(i,255&e.total_in),w(i,e.total_in>>8&255),w(i,e.total_in>>16&255),w(i,e.total_in>>24&255)):(_(i,e.adler>>>16),_(i,65535&e.adler)),b(e),i.wrap>0&&(i.wrap=-i.wrap),0!==i.pending?0:1)},t.deflateEnd=function(e){var t;return e&&e.state?42!==(t=e.state.status)&&69!==t&&73!==t&&91!==t&&t!==c&&t!==d&&t!==p?g(e,h):(e.state=null,t===d?g(e,-3):0):h},t.deflateSetDictionary=function(e,t){var r,n,o,a,f,l,u,c,d=t.length;if(!e||!e.state)return h;if(2===(a=(r=e.state).wrap)||1===a&&42!==r.status||r.lookahead)return h;for(1===a&&(e.adler=s(e.adler,t,d,0)),r.wrap=0,d>=r.w_size&&(0===a&&(y(r.head),r.strstart=0,r.block_start=0,r.insert=0),c=new i.Buf8(r.w_size),i.arraySet(c,t,d-r.w_size,r.w_size,0),t=c,d=r.w_size),f=e.avail_in,l=e.next_in,u=e.input,e.avail_in=d,e.next_in=0,e.input=t,S(r);r.lookahead>=3;){n=r.strstart,o=r.lookahead-2;do{r.ins_h=(r.ins_h<<r.hash_shift^r.window[n+3-1])&r.hash_mask,r.prev[n&r.w_mask]=r.head[r.ins_h],r.head[r.ins_h]=n,n++;}while(--o);r.strstart=n,r.lookahead=2,S(r);}return r.strstart+=r.lookahead,r.block_start=r.strstart,r.insert=r.lookahead,r.lookahead=0,r.match_length=r.prev_length=2,r.match_available=0,e.next_in=l,e.input=u,e.avail_in=f,r.wrap=a,0},t.deflateInfo="pako deflate (from Nodeca project)";},2401:e=>{e.exports=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1;};},4264:e=>{e.exports=function(e,t){var r,n,i,o,s,a,f,h,l,u,c,d,p,g,m,y,b,v,w,_,B,E,S,A,C;r=e.state,n=e.next_in,A=e.input,i=n+(e.avail_in-5),o=e.next_out,C=e.output,s=o-(t-e.avail_out),a=o+(e.avail_out-257),f=r.dmax,h=r.wsize,l=r.whave,u=r.wnext,c=r.window,d=r.hold,p=r.bits,g=r.lencode,m=r.distcode,y=(1<<r.lenbits)-1,b=(1<<r.distbits)-1;e:do{p<15&&(d+=A[n++]<<p,p+=8,d+=A[n++]<<p,p+=8),v=g[d&y];t:for(;;){if(d>>>=w=v>>>24,p-=w,0==(w=v>>>16&255))C[o++]=65535&v;else {if(!(16&w)){if(0==(64&w)){v=g[(65535&v)+(d&(1<<w)-1)];continue t}if(32&w){r.mode=12;break e}e.msg="invalid literal/length code",r.mode=30;break e}_=65535&v,(w&=15)&&(p<w&&(d+=A[n++]<<p,p+=8),_+=d&(1<<w)-1,d>>>=w,p-=w),p<15&&(d+=A[n++]<<p,p+=8,d+=A[n++]<<p,p+=8),v=m[d&b];r:for(;;){if(d>>>=w=v>>>24,p-=w,!(16&(w=v>>>16&255))){if(0==(64&w)){v=m[(65535&v)+(d&(1<<w)-1)];continue r}e.msg="invalid distance code",r.mode=30;break e}if(B=65535&v,p<(w&=15)&&(d+=A[n++]<<p,(p+=8)<w&&(d+=A[n++]<<p,p+=8)),(B+=d&(1<<w)-1)>f){e.msg="invalid distance too far back",r.mode=30;break e}if(d>>>=w,p-=w,B>(w=o-s)){if((w=B-w)>l&&r.sane){e.msg="invalid distance too far back",r.mode=30;break e}if(E=0,S=c,0===u){if(E+=h-w,w<_){_-=w;do{C[o++]=c[E++];}while(--w);E=o-B,S=C;}}else if(u<w){if(E+=h+u-w,(w-=u)<_){_-=w;do{C[o++]=c[E++];}while(--w);if(E=0,u<_){_-=w=u;do{C[o++]=c[E++];}while(--w);E=o-B,S=C;}}}else if(E+=u-w,w<_){_-=w;do{C[o++]=c[E++];}while(--w);E=o-B,S=C;}for(;_>2;)C[o++]=S[E++],C[o++]=S[E++],C[o++]=S[E++],_-=3;_&&(C[o++]=S[E++],_>1&&(C[o++]=S[E++]));}else {E=o-B;do{C[o++]=C[E++],C[o++]=C[E++],C[o++]=C[E++],_-=3;}while(_>2);_&&(C[o++]=C[E++],_>1&&(C[o++]=C[E++]));}break}}break}}while(n<i&&o<a);n-=_=p>>3,d&=(1<<(p-=_<<3))-1,e.next_in=n,e.next_out=o,e.avail_in=n<i?i-n+5:5-(n-i),e.avail_out=o<a?a-o+257:257-(o-a),r.hold=d,r.bits=p;};},7948:(e,t,r)=>{var n=r(4236),i=r(6069),o=r(2869),s=r(4264),a=r(9241),f=-2,h=12,l=30;function u(e){return (e>>>24&255)+(e>>>8&65280)+((65280&e)<<8)+((255&e)<<24)}function c(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new n.Buf16(320),this.work=new n.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0;}function d(e){var t;return e&&e.state?(t=e.state,e.total_in=e.total_out=t.total=0,e.msg="",t.wrap&&(e.adler=1&t.wrap),t.mode=1,t.last=0,t.havedict=0,t.dmax=32768,t.head=null,t.hold=0,t.bits=0,t.lencode=t.lendyn=new n.Buf32(852),t.distcode=t.distdyn=new n.Buf32(592),t.sane=1,t.back=-1,0):f}function p(e){var t;return e&&e.state?((t=e.state).wsize=0,t.whave=0,t.wnext=0,d(e)):f}function g(e,t){var r,n;return e&&e.state?(n=e.state,t<0?(r=0,t=-t):(r=1+(t>>4),t<48&&(t&=15)),t&&(t<8||t>15)?f:(null!==n.window&&n.wbits!==t&&(n.window=null),n.wrap=r,n.wbits=t,p(e))):f}function m(e,t){var r,n;return e?(n=new c,e.state=n,n.window=null,0!==(r=g(e,t))&&(e.state=null),r):f}var y,b,v=!0;function w(e){if(v){var t;for(y=new n.Buf32(512),b=new n.Buf32(32),t=0;t<144;)e.lens[t++]=8;for(;t<256;)e.lens[t++]=9;for(;t<280;)e.lens[t++]=7;for(;t<288;)e.lens[t++]=8;for(a(1,e.lens,0,288,y,0,e.work,{bits:9}),t=0;t<32;)e.lens[t++]=5;a(2,e.lens,0,32,b,0,e.work,{bits:5}),v=!1;}e.lencode=y,e.lenbits=9,e.distcode=b,e.distbits=5;}function _(e,t,r,i){var o,s=e.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new n.Buf8(s.wsize)),i>=s.wsize?(n.arraySet(s.window,t,r-s.wsize,s.wsize,0),s.wnext=0,s.whave=s.wsize):((o=s.wsize-s.wnext)>i&&(o=i),n.arraySet(s.window,t,r-i,o,s.wnext),(i-=o)?(n.arraySet(s.window,t,r-i,i,0),s.wnext=i,s.whave=s.wsize):(s.wnext+=o,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=o))),0}t.inflateReset=p,t.inflateReset2=g,t.inflateResetKeep=d,t.inflateInit=function(e){return m(e,15)},t.inflateInit2=m,t.inflate=function(e,t){var r,c,d,p,g,m,y,b,v,B,E,S,A,C,R,k,x,I,M,F,O,T,U,P,N=0,L=new n.Buf8(4),z=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&0!==e.avail_in)return f;(r=e.state).mode===h&&(r.mode=13),g=e.next_out,d=e.output,y=e.avail_out,p=e.next_in,c=e.input,m=e.avail_in,b=r.hold,v=r.bits,B=m,E=y,T=0;e:for(;;)switch(r.mode){case 1:if(0===r.wrap){r.mode=13;break}for(;v<16;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}if(2&r.wrap&&35615===b){r.check=0,L[0]=255&b,L[1]=b>>>8&255,r.check=o(r.check,L,2,0),b=0,v=0,r.mode=2;break}if(r.flags=0,r.head&&(r.head.done=!1),!(1&r.wrap)||(((255&b)<<8)+(b>>8))%31){e.msg="incorrect header check",r.mode=l;break}if(8!=(15&b)){e.msg="unknown compression method",r.mode=l;break}if(v-=4,O=8+(15&(b>>>=4)),0===r.wbits)r.wbits=O;else if(O>r.wbits){e.msg="invalid window size",r.mode=l;break}r.dmax=1<<O,e.adler=r.check=1,r.mode=512&b?10:h,b=0,v=0;break;case 2:for(;v<16;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}if(r.flags=b,8!=(255&r.flags)){e.msg="unknown compression method",r.mode=l;break}if(57344&r.flags){e.msg="unknown header flags set",r.mode=l;break}r.head&&(r.head.text=b>>8&1),512&r.flags&&(L[0]=255&b,L[1]=b>>>8&255,r.check=o(r.check,L,2,0)),b=0,v=0,r.mode=3;case 3:for(;v<32;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}r.head&&(r.head.time=b),512&r.flags&&(L[0]=255&b,L[1]=b>>>8&255,L[2]=b>>>16&255,L[3]=b>>>24&255,r.check=o(r.check,L,4,0)),b=0,v=0,r.mode=4;case 4:for(;v<16;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}r.head&&(r.head.xflags=255&b,r.head.os=b>>8),512&r.flags&&(L[0]=255&b,L[1]=b>>>8&255,r.check=o(r.check,L,2,0)),b=0,v=0,r.mode=5;case 5:if(1024&r.flags){for(;v<16;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}r.length=b,r.head&&(r.head.extra_len=b),512&r.flags&&(L[0]=255&b,L[1]=b>>>8&255,r.check=o(r.check,L,2,0)),b=0,v=0;}else r.head&&(r.head.extra=null);r.mode=6;case 6:if(1024&r.flags&&((S=r.length)>m&&(S=m),S&&(r.head&&(O=r.head.extra_len-r.length,r.head.extra||(r.head.extra=new Array(r.head.extra_len)),n.arraySet(r.head.extra,c,p,S,O)),512&r.flags&&(r.check=o(r.check,c,S,p)),m-=S,p+=S,r.length-=S),r.length))break e;r.length=0,r.mode=7;case 7:if(2048&r.flags){if(0===m)break e;S=0;do{O=c[p+S++],r.head&&O&&r.length<65536&&(r.head.name+=String.fromCharCode(O));}while(O&&S<m);if(512&r.flags&&(r.check=o(r.check,c,S,p)),m-=S,p+=S,O)break e}else r.head&&(r.head.name=null);r.length=0,r.mode=8;case 8:if(4096&r.flags){if(0===m)break e;S=0;do{O=c[p+S++],r.head&&O&&r.length<65536&&(r.head.comment+=String.fromCharCode(O));}while(O&&S<m);if(512&r.flags&&(r.check=o(r.check,c,S,p)),m-=S,p+=S,O)break e}else r.head&&(r.head.comment=null);r.mode=9;case 9:if(512&r.flags){for(;v<16;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}if(b!==(65535&r.check)){e.msg="header crc mismatch",r.mode=l;break}b=0,v=0;}r.head&&(r.head.hcrc=r.flags>>9&1,r.head.done=!0),e.adler=r.check=0,r.mode=h;break;case 10:for(;v<32;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}e.adler=r.check=u(b),b=0,v=0,r.mode=11;case 11:if(0===r.havedict)return e.next_out=g,e.avail_out=y,e.next_in=p,e.avail_in=m,r.hold=b,r.bits=v,2;e.adler=r.check=1,r.mode=h;case h:if(5===t||6===t)break e;case 13:if(r.last){b>>>=7&v,v-=7&v,r.mode=27;break}for(;v<3;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}switch(r.last=1&b,v-=1,3&(b>>>=1)){case 0:r.mode=14;break;case 1:if(w(r),r.mode=20,6===t){b>>>=2,v-=2;break e}break;case 2:r.mode=17;break;case 3:e.msg="invalid block type",r.mode=l;}b>>>=2,v-=2;break;case 14:for(b>>>=7&v,v-=7&v;v<32;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}if((65535&b)!=(b>>>16^65535)){e.msg="invalid stored block lengths",r.mode=l;break}if(r.length=65535&b,b=0,v=0,r.mode=15,6===t)break e;case 15:r.mode=16;case 16:if(S=r.length){if(S>m&&(S=m),S>y&&(S=y),0===S)break e;n.arraySet(d,c,p,S,g),m-=S,p+=S,y-=S,g+=S,r.length-=S;break}r.mode=h;break;case 17:for(;v<14;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}if(r.nlen=257+(31&b),b>>>=5,v-=5,r.ndist=1+(31&b),b>>>=5,v-=5,r.ncode=4+(15&b),b>>>=4,v-=4,r.nlen>286||r.ndist>30){e.msg="too many length or distance symbols",r.mode=l;break}r.have=0,r.mode=18;case 18:for(;r.have<r.ncode;){for(;v<3;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}r.lens[z[r.have++]]=7&b,b>>>=3,v-=3;}for(;r.have<19;)r.lens[z[r.have++]]=0;if(r.lencode=r.lendyn,r.lenbits=7,U={bits:r.lenbits},T=a(0,r.lens,0,19,r.lencode,0,r.work,U),r.lenbits=U.bits,T){e.msg="invalid code lengths set",r.mode=l;break}r.have=0,r.mode=19;case 19:for(;r.have<r.nlen+r.ndist;){for(;k=(N=r.lencode[b&(1<<r.lenbits)-1])>>>16&255,x=65535&N,!((R=N>>>24)<=v);){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}if(x<16)b>>>=R,v-=R,r.lens[r.have++]=x;else {if(16===x){for(P=R+2;v<P;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}if(b>>>=R,v-=R,0===r.have){e.msg="invalid bit length repeat",r.mode=l;break}O=r.lens[r.have-1],S=3+(3&b),b>>>=2,v-=2;}else if(17===x){for(P=R+3;v<P;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}v-=R,O=0,S=3+(7&(b>>>=R)),b>>>=3,v-=3;}else {for(P=R+7;v<P;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}v-=R,O=0,S=11+(127&(b>>>=R)),b>>>=7,v-=7;}if(r.have+S>r.nlen+r.ndist){e.msg="invalid bit length repeat",r.mode=l;break}for(;S--;)r.lens[r.have++]=O;}}if(r.mode===l)break;if(0===r.lens[256]){e.msg="invalid code -- missing end-of-block",r.mode=l;break}if(r.lenbits=9,U={bits:r.lenbits},T=a(1,r.lens,0,r.nlen,r.lencode,0,r.work,U),r.lenbits=U.bits,T){e.msg="invalid literal/lengths set",r.mode=l;break}if(r.distbits=6,r.distcode=r.distdyn,U={bits:r.distbits},T=a(2,r.lens,r.nlen,r.ndist,r.distcode,0,r.work,U),r.distbits=U.bits,T){e.msg="invalid distances set",r.mode=l;break}if(r.mode=20,6===t)break e;case 20:r.mode=21;case 21:if(m>=6&&y>=258){e.next_out=g,e.avail_out=y,e.next_in=p,e.avail_in=m,r.hold=b,r.bits=v,s(e,E),g=e.next_out,d=e.output,y=e.avail_out,p=e.next_in,c=e.input,m=e.avail_in,b=r.hold,v=r.bits,r.mode===h&&(r.back=-1);break}for(r.back=0;k=(N=r.lencode[b&(1<<r.lenbits)-1])>>>16&255,x=65535&N,!((R=N>>>24)<=v);){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}if(k&&0==(240&k)){for(I=R,M=k,F=x;k=(N=r.lencode[F+((b&(1<<I+M)-1)>>I)])>>>16&255,x=65535&N,!(I+(R=N>>>24)<=v);){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}b>>>=I,v-=I,r.back+=I;}if(b>>>=R,v-=R,r.back+=R,r.length=x,0===k){r.mode=26;break}if(32&k){r.back=-1,r.mode=h;break}if(64&k){e.msg="invalid literal/length code",r.mode=l;break}r.extra=15&k,r.mode=22;case 22:if(r.extra){for(P=r.extra;v<P;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}r.length+=b&(1<<r.extra)-1,b>>>=r.extra,v-=r.extra,r.back+=r.extra;}r.was=r.length,r.mode=23;case 23:for(;k=(N=r.distcode[b&(1<<r.distbits)-1])>>>16&255,x=65535&N,!((R=N>>>24)<=v);){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}if(0==(240&k)){for(I=R,M=k,F=x;k=(N=r.distcode[F+((b&(1<<I+M)-1)>>I)])>>>16&255,x=65535&N,!(I+(R=N>>>24)<=v);){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}b>>>=I,v-=I,r.back+=I;}if(b>>>=R,v-=R,r.back+=R,64&k){e.msg="invalid distance code",r.mode=l;break}r.offset=x,r.extra=15&k,r.mode=24;case 24:if(r.extra){for(P=r.extra;v<P;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}r.offset+=b&(1<<r.extra)-1,b>>>=r.extra,v-=r.extra,r.back+=r.extra;}if(r.offset>r.dmax){e.msg="invalid distance too far back",r.mode=l;break}r.mode=25;case 25:if(0===y)break e;if(S=E-y,r.offset>S){if((S=r.offset-S)>r.whave&&r.sane){e.msg="invalid distance too far back",r.mode=l;break}S>r.wnext?(S-=r.wnext,A=r.wsize-S):A=r.wnext-S,S>r.length&&(S=r.length),C=r.window;}else C=d,A=g-r.offset,S=r.length;S>y&&(S=y),y-=S,r.length-=S;do{d[g++]=C[A++];}while(--S);0===r.length&&(r.mode=21);break;case 26:if(0===y)break e;d[g++]=r.length,y--,r.mode=21;break;case 27:if(r.wrap){for(;v<32;){if(0===m)break e;m--,b|=c[p++]<<v,v+=8;}if(E-=y,e.total_out+=E,r.total+=E,E&&(e.adler=r.check=r.flags?o(r.check,d,E,g-E):i(r.check,d,E,g-E)),E=y,(r.flags?b:u(b))!==r.check){e.msg="incorrect data check",r.mode=l;break}b=0,v=0;}r.mode=28;case 28:if(r.wrap&&r.flags){for(;v<32;){if(0===m)break e;m--,b+=c[p++]<<v,v+=8;}if(b!==(4294967295&r.total)){e.msg="incorrect length check",r.mode=l;break}b=0,v=0;}r.mode=29;case 29:T=1;break e;case l:T=-3;break e;case 31:return -4;default:return f}return e.next_out=g,e.avail_out=y,e.next_in=p,e.avail_in=m,r.hold=b,r.bits=v,(r.wsize||E!==e.avail_out&&r.mode<l&&(r.mode<27||4!==t))&&_(e,e.output,e.next_out,E-e.avail_out)?(r.mode=31,-4):(B-=e.avail_in,E-=e.avail_out,e.total_in+=B,e.total_out+=E,r.total+=E,r.wrap&&E&&(e.adler=r.check=r.flags?o(r.check,d,E,e.next_out-E):i(r.check,d,E,e.next_out-E)),e.data_type=r.bits+(r.last?64:0)+(r.mode===h?128:0)+(20===r.mode||15===r.mode?256:0),(0===B&&0===E||4===t)&&0===T&&(T=-5),T)},t.inflateEnd=function(e){if(!e||!e.state)return f;var t=e.state;return t.window&&(t.window=null),e.state=null,0},t.inflateGetHeader=function(e,t){var r;return e&&e.state?0==(2&(r=e.state).wrap)?f:(r.head=t,t.done=!1,0):f},t.inflateSetDictionary=function(e,t){var r,n=t.length;return e&&e.state?0!==(r=e.state).wrap&&11!==r.mode?f:11===r.mode&&i(1,t,n,0)!==r.check?-3:_(e,t,n,n)?(r.mode=31,-4):(r.havedict=1,0):f},t.inflateInfo="pako inflate (from Nodeca project)";},9241:(e,t,r)=>{var n=r(4236),i=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],o=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],s=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],a=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];e.exports=function(e,t,r,f,h,l,u,c){var d,p,g,m,y,b,v,w,_,B=c.bits,E=0,S=0,A=0,C=0,R=0,k=0,x=0,I=0,M=0,F=0,O=null,T=0,U=new n.Buf16(16),P=new n.Buf16(16),N=null,L=0;for(E=0;E<=15;E++)U[E]=0;for(S=0;S<f;S++)U[t[r+S]]++;for(R=B,C=15;C>=1&&0===U[C];C--);if(R>C&&(R=C),0===C)return h[l++]=20971520,h[l++]=20971520,c.bits=1,0;for(A=1;A<C&&0===U[A];A++);for(R<A&&(R=A),I=1,E=1;E<=15;E++)if(I<<=1,(I-=U[E])<0)return -1;if(I>0&&(0===e||1!==C))return -1;for(P[1]=0,E=1;E<15;E++)P[E+1]=P[E]+U[E];for(S=0;S<f;S++)0!==t[r+S]&&(u[P[t[r+S]]++]=S);if(0===e?(O=N=u,b=19):1===e?(O=i,T-=257,N=o,L-=257,b=256):(O=s,N=a,b=-1),F=0,S=0,E=A,y=l,k=R,x=0,g=-1,m=(M=1<<R)-1,1===e&&M>852||2===e&&M>592)return 1;for(;;){v=E-x,u[S]<b?(w=0,_=u[S]):u[S]>b?(w=N[L+u[S]],_=O[T+u[S]]):(w=96,_=0),d=1<<E-x,A=p=1<<k;do{h[y+(F>>x)+(p-=d)]=v<<24|w<<16|_|0;}while(0!==p);for(d=1<<E-1;F&d;)d>>=1;if(0!==d?(F&=d-1,F+=d):F=0,S++,0==--U[E]){if(E===C)break;E=t[r+u[S]];}if(E>R&&(F&m)!==g){for(0===x&&(x=R),y+=A,I=1<<(k=E-x);k+x<C&&!((I-=U[k+x])<=0);)k++,I<<=1;if(M+=1<<k,1===e&&M>852||2===e&&M>592)return 1;h[g=F&m]=R<<24|k<<16|y-l|0;}}return 0!==F&&(h[y+F]=E-x<<24|64<<16|0),c.bits=R,0};},8898:e=>{e.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"};},342:(e,t,r)=>{var n=r(4236);function i(e){for(var t=e.length;--t>=0;)e[t]=0;}var o=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],s=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],a=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],f=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],h=new Array(576);i(h);var l=new Array(60);i(l);var u=new Array(512);i(u);var c=new Array(256);i(c);var d=new Array(29);i(d);var p,g,m,y=new Array(30);function b(e,t,r,n,i){this.static_tree=e,this.extra_bits=t,this.extra_base=r,this.elems=n,this.max_length=i,this.has_stree=e&&e.length;}function v(e,t){this.dyn_tree=e,this.max_code=0,this.stat_desc=t;}function w(e){return e<256?u[e]:u[256+(e>>>7)]}function _(e,t){e.pending_buf[e.pending++]=255&t,e.pending_buf[e.pending++]=t>>>8&255;}function B(e,t,r){e.bi_valid>16-r?(e.bi_buf|=t<<e.bi_valid&65535,_(e,e.bi_buf),e.bi_buf=t>>16-e.bi_valid,e.bi_valid+=r-16):(e.bi_buf|=t<<e.bi_valid&65535,e.bi_valid+=r);}function E(e,t,r){B(e,r[2*t],r[2*t+1]);}function S(e,t){var r=0;do{r|=1&e,e>>>=1,r<<=1;}while(--t>0);return r>>>1}function A(e,t,r){var n,i,o=new Array(16),s=0;for(n=1;n<=15;n++)o[n]=s=s+r[n-1]<<1;for(i=0;i<=t;i++){var a=e[2*i+1];0!==a&&(e[2*i]=S(o[a]++,a));}}function C(e){var t;for(t=0;t<286;t++)e.dyn_ltree[2*t]=0;for(t=0;t<30;t++)e.dyn_dtree[2*t]=0;for(t=0;t<19;t++)e.bl_tree[2*t]=0;e.dyn_ltree[512]=1,e.opt_len=e.static_len=0,e.last_lit=e.matches=0;}function R(e){e.bi_valid>8?_(e,e.bi_buf):e.bi_valid>0&&(e.pending_buf[e.pending++]=e.bi_buf),e.bi_buf=0,e.bi_valid=0;}function k(e,t,r,n){var i=2*t,o=2*r;return e[i]<e[o]||e[i]===e[o]&&n[t]<=n[r]}function x(e,t,r){for(var n=e.heap[r],i=r<<1;i<=e.heap_len&&(i<e.heap_len&&k(t,e.heap[i+1],e.heap[i],e.depth)&&i++,!k(t,n,e.heap[i],e.depth));)e.heap[r]=e.heap[i],r=i,i<<=1;e.heap[r]=n;}function I(e,t,r){var n,i,a,f,h=0;if(0!==e.last_lit)do{n=e.pending_buf[e.d_buf+2*h]<<8|e.pending_buf[e.d_buf+2*h+1],i=e.pending_buf[e.l_buf+h],h++,0===n?E(e,i,t):(E(e,(a=c[i])+256+1,t),0!==(f=o[a])&&B(e,i-=d[a],f),E(e,a=w(--n),r),0!==(f=s[a])&&B(e,n-=y[a],f));}while(h<e.last_lit);E(e,256,t);}function M(e,t){var r,n,i,o=t.dyn_tree,s=t.stat_desc.static_tree,a=t.stat_desc.has_stree,f=t.stat_desc.elems,h=-1;for(e.heap_len=0,e.heap_max=573,r=0;r<f;r++)0!==o[2*r]?(e.heap[++e.heap_len]=h=r,e.depth[r]=0):o[2*r+1]=0;for(;e.heap_len<2;)o[2*(i=e.heap[++e.heap_len]=h<2?++h:0)]=1,e.depth[i]=0,e.opt_len--,a&&(e.static_len-=s[2*i+1]);for(t.max_code=h,r=e.heap_len>>1;r>=1;r--)x(e,o,r);i=f;do{r=e.heap[1],e.heap[1]=e.heap[e.heap_len--],x(e,o,1),n=e.heap[1],e.heap[--e.heap_max]=r,e.heap[--e.heap_max]=n,o[2*i]=o[2*r]+o[2*n],e.depth[i]=(e.depth[r]>=e.depth[n]?e.depth[r]:e.depth[n])+1,o[2*r+1]=o[2*n+1]=i,e.heap[1]=i++,x(e,o,1);}while(e.heap_len>=2);e.heap[--e.heap_max]=e.heap[1],function(e,t){var r,n,i,o,s,a,f=t.dyn_tree,h=t.max_code,l=t.stat_desc.static_tree,u=t.stat_desc.has_stree,c=t.stat_desc.extra_bits,d=t.stat_desc.extra_base,p=t.stat_desc.max_length,g=0;for(o=0;o<=15;o++)e.bl_count[o]=0;for(f[2*e.heap[e.heap_max]+1]=0,r=e.heap_max+1;r<573;r++)(o=f[2*f[2*(n=e.heap[r])+1]+1]+1)>p&&(o=p,g++),f[2*n+1]=o,n>h||(e.bl_count[o]++,s=0,n>=d&&(s=c[n-d]),a=f[2*n],e.opt_len+=a*(o+s),u&&(e.static_len+=a*(l[2*n+1]+s)));if(0!==g){do{for(o=p-1;0===e.bl_count[o];)o--;e.bl_count[o]--,e.bl_count[o+1]+=2,e.bl_count[p]--,g-=2;}while(g>0);for(o=p;0!==o;o--)for(n=e.bl_count[o];0!==n;)(i=e.heap[--r])>h||(f[2*i+1]!==o&&(e.opt_len+=(o-f[2*i+1])*f[2*i],f[2*i+1]=o),n--);}}(e,t),A(o,h,e.bl_count);}function F(e,t,r){var n,i,o=-1,s=t[1],a=0,f=7,h=4;for(0===s&&(f=138,h=3),t[2*(r+1)+1]=65535,n=0;n<=r;n++)i=s,s=t[2*(n+1)+1],++a<f&&i===s||(a<h?e.bl_tree[2*i]+=a:0!==i?(i!==o&&e.bl_tree[2*i]++,e.bl_tree[32]++):a<=10?e.bl_tree[34]++:e.bl_tree[36]++,a=0,o=i,0===s?(f=138,h=3):i===s?(f=6,h=3):(f=7,h=4));}function O(e,t,r){var n,i,o=-1,s=t[1],a=0,f=7,h=4;for(0===s&&(f=138,h=3),n=0;n<=r;n++)if(i=s,s=t[2*(n+1)+1],!(++a<f&&i===s)){if(a<h)do{E(e,i,e.bl_tree);}while(0!=--a);else 0!==i?(i!==o&&(E(e,i,e.bl_tree),a--),E(e,16,e.bl_tree),B(e,a-3,2)):a<=10?(E(e,17,e.bl_tree),B(e,a-3,3)):(E(e,18,e.bl_tree),B(e,a-11,7));a=0,o=i,0===s?(f=138,h=3):i===s?(f=6,h=3):(f=7,h=4);}}i(y);var T=!1;function U(e,t,r,i){B(e,0+(i?1:0),3),function(e,t,r,i){R(e),_(e,r),_(e,~r),n.arraySet(e.pending_buf,e.window,t,r,e.pending),e.pending+=r;}(e,t,r);}t._tr_init=function(e){T||(function(){var e,t,r,n,i,f=new Array(16);for(r=0,n=0;n<28;n++)for(d[n]=r,e=0;e<1<<o[n];e++)c[r++]=n;for(c[r-1]=n,i=0,n=0;n<16;n++)for(y[n]=i,e=0;e<1<<s[n];e++)u[i++]=n;for(i>>=7;n<30;n++)for(y[n]=i<<7,e=0;e<1<<s[n]-7;e++)u[256+i++]=n;for(t=0;t<=15;t++)f[t]=0;for(e=0;e<=143;)h[2*e+1]=8,e++,f[8]++;for(;e<=255;)h[2*e+1]=9,e++,f[9]++;for(;e<=279;)h[2*e+1]=7,e++,f[7]++;for(;e<=287;)h[2*e+1]=8,e++,f[8]++;for(A(h,287,f),e=0;e<30;e++)l[2*e+1]=5,l[2*e]=S(e,5);p=new b(h,o,257,286,15),g=new b(l,s,0,30,15),m=new b(new Array(0),a,0,19,7);}(),T=!0),e.l_desc=new v(e.dyn_ltree,p),e.d_desc=new v(e.dyn_dtree,g),e.bl_desc=new v(e.bl_tree,m),e.bi_buf=0,e.bi_valid=0,C(e);},t._tr_stored_block=U,t._tr_flush_block=function(e,t,r,n){var i,o,s=0;e.level>0?(2===e.strm.data_type&&(e.strm.data_type=function(e){var t,r=4093624447;for(t=0;t<=31;t++,r>>>=1)if(1&r&&0!==e.dyn_ltree[2*t])return 0;if(0!==e.dyn_ltree[18]||0!==e.dyn_ltree[20]||0!==e.dyn_ltree[26])return 1;for(t=32;t<256;t++)if(0!==e.dyn_ltree[2*t])return 1;return 0}(e)),M(e,e.l_desc),M(e,e.d_desc),s=function(e){var t;for(F(e,e.dyn_ltree,e.l_desc.max_code),F(e,e.dyn_dtree,e.d_desc.max_code),M(e,e.bl_desc),t=18;t>=3&&0===e.bl_tree[2*f[t]+1];t--);return e.opt_len+=3*(t+1)+5+5+4,t}(e),i=e.opt_len+3+7>>>3,(o=e.static_len+3+7>>>3)<=i&&(i=o)):i=o=r+5,r+4<=i&&-1!==t?U(e,t,r,n):4===e.strategy||o===i?(B(e,2+(n?1:0),3),I(e,h,l)):(B(e,4+(n?1:0),3),function(e,t,r,n){var i;for(B(e,t-257,5),B(e,r-1,5),B(e,n-4,4),i=0;i<n;i++)B(e,e.bl_tree[2*f[i]+1],3);O(e,e.dyn_ltree,t-1),O(e,e.dyn_dtree,r-1);}(e,e.l_desc.max_code+1,e.d_desc.max_code+1,s+1),I(e,e.dyn_ltree,e.dyn_dtree)),C(e),n&&R(e);},t._tr_tally=function(e,t,r){return e.pending_buf[e.d_buf+2*e.last_lit]=t>>>8&255,e.pending_buf[e.d_buf+2*e.last_lit+1]=255&t,e.pending_buf[e.l_buf+e.last_lit]=255&r,e.last_lit++,0===t?e.dyn_ltree[2*r]++:(e.matches++,t--,e.dyn_ltree[2*(c[r]+256+1)]++,e.dyn_dtree[2*w(t)]++),e.last_lit===e.lit_bufsize-1},t._tr_align=function(e){B(e,2,3),E(e,256,h),function(e){16===e.bi_valid?(_(e,e.bi_buf),e.bi_buf=0,e.bi_valid=0):e.bi_valid>=8&&(e.pending_buf[e.pending++]=255&e.bi_buf,e.bi_buf>>=8,e.bi_valid-=8);}(e);};},2292:e=>{e.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0;};},2587:e=>{function t(e,t){return Object.prototype.hasOwnProperty.call(e,t)}e.exports=function(e,r,n,i){r=r||"&",n=n||"=";var o={};if("string"!=typeof e||0===e.length)return o;var s=/\+/g;e=e.split(r);var a=1e3;i&&"number"==typeof i.maxKeys&&(a=i.maxKeys);var f=e.length;a>0&&f>a&&(f=a);for(var h=0;h<f;++h){var l,u,c,d,p=e[h].replace(s,"%20"),g=p.indexOf(n);g>=0?(l=p.substr(0,g),u=p.substr(g+1)):(l=p,u=""),c=decodeURIComponent(l),d=decodeURIComponent(u),t(o,c)?Array.isArray(o[c])?o[c].push(d):o[c]=[o[c],d]:o[c]=d;}return o};},2361:e=>{var t=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return ""}};e.exports=function(e,r,n,i){return r=r||"&",n=n||"=",null===e&&(e=void 0),"object"==typeof e?Object.keys(e).map((function(i){var o=encodeURIComponent(t(i))+n;return Array.isArray(e[i])?e[i].map((function(e){return o+encodeURIComponent(t(e))})).join(r):o+encodeURIComponent(t(e[i]))})).join(r):i?encodeURIComponent(t(i))+n+encodeURIComponent(t(e)):""};},7673:(e,t,r)=>{t.decode=t.parse=r(2587),t.encode=t.stringify=r(2361);},1269:e=>{class t{constructor(e={}){if(!(e.maxSize&&e.maxSize>0))throw new TypeError("`maxSize` must be a number greater than 0");this.maxSize=e.maxSize,this.cache=new Map,this.oldCache=new Map,this._size=0;}_set(e,t){this.cache.set(e,t),this._size++,this._size>=this.maxSize&&(this._size=0,this.oldCache=this.cache,this.cache=new Map);}get(e){if(this.cache.has(e))return this.cache.get(e);if(this.oldCache.has(e)){const t=this.oldCache.get(e);return this.oldCache.delete(e),this._set(e,t),t}}set(e,t){return this.cache.has(e)?this.cache.set(e,t):this._set(e,t),this}has(e){return this.cache.has(e)||this.oldCache.has(e)}peek(e){return this.cache.has(e)?this.cache.get(e):this.oldCache.has(e)?this.oldCache.get(e):void 0}delete(e){const t=this.cache.delete(e);return t&&this._size--,this.oldCache.delete(e)||t}clear(){this.cache.clear(),this.oldCache.clear(),this._size=0;}*keys(){for(const[e]of this)yield e;}*values(){for(const[,e]of this)yield e;}*[Symbol.iterator](){for(const e of this.cache)yield e;for(const e of this.oldCache){const[t]=e;this.cache.has(t)||(yield e);}}get size(){let e=0;for(const t of this.oldCache.keys())this.cache.has(t)||e++;return this._size+e}}e.exports=t;},2511:function(e,t,r){var n;e=r.nmd(e),function(i){t&&t.nodeType,e&&e.nodeType;var o="object"==typeof r.g&&r.g;o.global!==o&&o.window!==o&&o.self;var s,a=2147483647,f=36,h=/^xn--/,l=/[^\x20-\x7E]/,u=/[\x2E\u3002\uFF0E\uFF61]/g,c={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},d=Math.floor,p=String.fromCharCode;function g(e){throw RangeError(c[e])}function m(e,t){for(var r=e.length,n=[];r--;)n[r]=t(e[r]);return n}function y(e,t){var r=e.split("@"),n="";return r.length>1&&(n=r[0]+"@",e=r[1]),n+m((e=e.replace(u,".")).split("."),t).join(".")}function b(e){for(var t,r,n=[],i=0,o=e.length;i<o;)(t=e.charCodeAt(i++))>=55296&&t<=56319&&i<o?56320==(64512&(r=e.charCodeAt(i++)))?n.push(((1023&t)<<10)+(1023&r)+65536):(n.push(t),i--):n.push(t);return n}function v(e){return m(e,(function(e){var t="";return e>65535&&(t+=p((e-=65536)>>>10&1023|55296),e=56320|1023&e),t+p(e)})).join("")}function w(e,t){return e+22+75*(e<26)-((0!=t)<<5)}function _(e,t,r){var n=0;for(e=r?d(e/700):e>>1,e+=d(e/t);e>455;n+=f)e=d(e/35);return d(n+36*e/(e+38))}function B(e){var t,r,n,i,o,s,h,l,u,c,p,m=[],y=e.length,b=0,w=128,B=72;for((r=e.lastIndexOf("-"))<0&&(r=0),n=0;n<r;++n)e.charCodeAt(n)>=128&&g("not-basic"),m.push(e.charCodeAt(n));for(i=r>0?r+1:0;i<y;){for(o=b,s=1,h=f;i>=y&&g("invalid-input"),((l=(p=e.charCodeAt(i++))-48<10?p-22:p-65<26?p-65:p-97<26?p-97:f)>=f||l>d((a-b)/s))&&g("overflow"),b+=l*s,!(l<(u=h<=B?1:h>=B+26?26:h-B));h+=f)s>d(a/(c=f-u))&&g("overflow"),s*=c;B=_(b-o,t=m.length+1,0==o),d(b/t)>a-w&&g("overflow"),w+=d(b/t),b%=t,m.splice(b++,0,w);}return v(m)}function E(e){var t,r,n,i,o,s,h,l,u,c,m,y,v,B,E,S=[];for(y=(e=b(e)).length,t=128,r=0,o=72,s=0;s<y;++s)(m=e[s])<128&&S.push(p(m));for(n=i=S.length,i&&S.push("-");n<y;){for(h=a,s=0;s<y;++s)(m=e[s])>=t&&m<h&&(h=m);for(h-t>d((a-r)/(v=n+1))&&g("overflow"),r+=(h-t)*v,t=h,s=0;s<y;++s)if((m=e[s])<t&&++r>a&&g("overflow"),m==t){for(l=r,u=f;!(l<(c=u<=o?1:u>=o+26?26:u-o));u+=f)E=l-c,B=f-c,S.push(p(w(c+E%B,0))),l=d(E/B);S.push(p(w(l,0))),o=_(r,v,n==i),r=0,++n;}++r,++t;}return S.join("")}s={version:"1.3.2",ucs2:{decode:b,encode:v},decode:B,encode:E,toASCII:function(e){return y(e,(function(e){return l.test(e)?"xn--"+E(e):e}))},toUnicode:function(e){return y(e,(function(e){return h.test(e)?B(e.slice(4).toLowerCase()):e}))}},void 0===(n=function(){return s}.call(t,r,t,e))||(e.exports=n);}();},8575:(e,t,r)=>{var n=r(2511),i=r(2502);function o(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null;}t.parse=v,t.resolve=function(e,t){return v(e,!1,!0).resolve(t)},t.resolveObject=function(e,t){return e?v(e,!1,!0).resolveObject(t):t},t.format=function(e){return i.isString(e)&&(e=v(e)),e instanceof o?e.format():o.prototype.format.call(e)},t.Url=o;var s=/^([a-z0-9.+-]+:)/i,a=/:[0-9]*$/,f=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,h=["{","}","|","\\","^","`"].concat(["<",">",'"',"`"," ","\r","\n","\t"]),l=["'"].concat(h),u=["%","/","?",";","#"].concat(l),c=["/","?","#"],d=/^[+a-z0-9A-Z_-]{0,63}$/,p=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,g={javascript:!0,"javascript:":!0},m={javascript:!0,"javascript:":!0},y={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},b=r(7673);function v(e,t,r){if(e&&i.isObject(e)&&e instanceof o)return e;var n=new o;return n.parse(e,t,r),n}o.prototype.parse=function(e,t,r){if(!i.isString(e))throw new TypeError("Parameter 'url' must be a string, not "+typeof e);var o=e.indexOf("?"),a=-1!==o&&o<e.indexOf("#")?"?":"#",h=e.split(a);h[0]=h[0].replace(/\\/g,"/");var v=e=h.join(a);if(v=v.trim(),!r&&1===e.split("#").length){var w=f.exec(v);if(w)return this.path=v,this.href=v,this.pathname=w[1],w[2]?(this.search=w[2],this.query=t?b.parse(this.search.substr(1)):this.search.substr(1)):t&&(this.search="",this.query={}),this}var _=s.exec(v);if(_){var B=(_=_[0]).toLowerCase();this.protocol=B,v=v.substr(_.length);}if(r||_||v.match(/^\/\/[^@\/]+@[^@\/]+/)){var E="//"===v.substr(0,2);!E||_&&m[_]||(v=v.substr(2),this.slashes=!0);}if(!m[_]&&(E||_&&!y[_])){for(var S,A,C=-1,R=0;R<c.length;R++)-1!==(k=v.indexOf(c[R]))&&(-1===C||k<C)&&(C=k);for(-1!==(A=-1===C?v.lastIndexOf("@"):v.lastIndexOf("@",C))&&(S=v.slice(0,A),v=v.slice(A+1),this.auth=decodeURIComponent(S)),C=-1,R=0;R<u.length;R++){var k;-1!==(k=v.indexOf(u[R]))&&(-1===C||k<C)&&(C=k);}-1===C&&(C=v.length),this.host=v.slice(0,C),v=v.slice(C),this.parseHost(),this.hostname=this.hostname||"";var x="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!x)for(var I=this.hostname.split(/\./),M=(R=0,I.length);R<M;R++){var F=I[R];if(F&&!F.match(d)){for(var O="",T=0,U=F.length;T<U;T++)F.charCodeAt(T)>127?O+="x":O+=F[T];if(!O.match(d)){var P=I.slice(0,R),N=I.slice(R+1),L=F.match(p);L&&(P.push(L[1]),N.unshift(L[2])),N.length&&(v="/"+N.join(".")+v),this.hostname=P.join(".");break}}}this.hostname.length>255?this.hostname="":this.hostname=this.hostname.toLowerCase(),x||(this.hostname=n.toASCII(this.hostname));var z=this.port?":"+this.port:"",D=this.hostname||"";this.host=D+z,this.href+=this.host,x&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==v[0]&&(v="/"+v));}if(!g[B])for(R=0,M=l.length;R<M;R++){var q=l[R];if(-1!==v.indexOf(q)){var j=encodeURIComponent(q);j===q&&(j=escape(q)),v=v.split(q).join(j);}}var H=v.indexOf("#");-1!==H&&(this.hash=v.substr(H),v=v.slice(0,H));var W=v.indexOf("?");if(-1!==W?(this.search=v.substr(W),this.query=v.substr(W+1),t&&(this.query=b.parse(this.query)),v=v.slice(0,W)):t&&(this.search="",this.query={}),v&&(this.pathname=v),y[B]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){z=this.pathname||"";var $=this.search||"";this.path=z+$;}return this.href=this.format(),this},o.prototype.format=function(){var e=this.auth||"";e&&(e=(e=encodeURIComponent(e)).replace(/%3A/i,":"),e+="@");var t=this.protocol||"",r=this.pathname||"",n=this.hash||"",o=!1,s="";this.host?o=e+this.host:this.hostname&&(o=e+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(o+=":"+this.port)),this.query&&i.isObject(this.query)&&Object.keys(this.query).length&&(s=b.stringify(this.query));var a=this.search||s&&"?"+s||"";return t&&":"!==t.substr(-1)&&(t+=":"),this.slashes||(!t||y[t])&&!1!==o?(o="//"+(o||""),r&&"/"!==r.charAt(0)&&(r="/"+r)):o||(o=""),n&&"#"!==n.charAt(0)&&(n="#"+n),a&&"?"!==a.charAt(0)&&(a="?"+a),t+o+(r=r.replace(/[?#]/g,(function(e){return encodeURIComponent(e)})))+(a=a.replace("#","%23"))+n},o.prototype.resolve=function(e){return this.resolveObject(v(e,!1,!0)).format()},o.prototype.resolveObject=function(e){if(i.isString(e)){var t=new o;t.parse(e,!1,!0),e=t;}for(var r=new o,n=Object.keys(this),s=0;s<n.length;s++){var a=n[s];r[a]=this[a];}if(r.hash=e.hash,""===e.href)return r.href=r.format(),r;if(e.slashes&&!e.protocol){for(var f=Object.keys(e),h=0;h<f.length;h++){var l=f[h];"protocol"!==l&&(r[l]=e[l]);}return y[r.protocol]&&r.hostname&&!r.pathname&&(r.path=r.pathname="/"),r.href=r.format(),r}if(e.protocol&&e.protocol!==r.protocol){if(!y[e.protocol]){for(var u=Object.keys(e),c=0;c<u.length;c++){var d=u[c];r[d]=e[d];}return r.href=r.format(),r}if(r.protocol=e.protocol,e.host||m[e.protocol])r.pathname=e.pathname;else {for(var p=(e.pathname||"").split("/");p.length&&!(e.host=p.shift()););e.host||(e.host=""),e.hostname||(e.hostname=""),""!==p[0]&&p.unshift(""),p.length<2&&p.unshift(""),r.pathname=p.join("/");}if(r.search=e.search,r.query=e.query,r.host=e.host||"",r.auth=e.auth,r.hostname=e.hostname||e.host,r.port=e.port,r.pathname||r.search){var g=r.pathname||"",b=r.search||"";r.path=g+b;}return r.slashes=r.slashes||e.slashes,r.href=r.format(),r}var v=r.pathname&&"/"===r.pathname.charAt(0),w=e.host||e.pathname&&"/"===e.pathname.charAt(0),_=w||v||r.host&&e.pathname,B=_,E=r.pathname&&r.pathname.split("/")||[],S=(p=e.pathname&&e.pathname.split("/")||[],r.protocol&&!y[r.protocol]);if(S&&(r.hostname="",r.port=null,r.host&&(""===E[0]?E[0]=r.host:E.unshift(r.host)),r.host="",e.protocol&&(e.hostname=null,e.port=null,e.host&&(""===p[0]?p[0]=e.host:p.unshift(e.host)),e.host=null),_=_&&(""===p[0]||""===E[0])),w)r.host=e.host||""===e.host?e.host:r.host,r.hostname=e.hostname||""===e.hostname?e.hostname:r.hostname,r.search=e.search,r.query=e.query,E=p;else if(p.length)E||(E=[]),E.pop(),E=E.concat(p),r.search=e.search,r.query=e.query;else if(!i.isNullOrUndefined(e.search))return S&&(r.hostname=r.host=E.shift(),(x=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@"))&&(r.auth=x.shift(),r.host=r.hostname=x.shift())),r.search=e.search,r.query=e.query,i.isNull(r.pathname)&&i.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.href=r.format(),r;if(!E.length)return r.pathname=null,r.search?r.path="/"+r.search:r.path=null,r.href=r.format(),r;for(var A=E.slice(-1)[0],C=(r.host||e.host||E.length>1)&&("."===A||".."===A)||""===A,R=0,k=E.length;k>=0;k--)"."===(A=E[k])?E.splice(k,1):".."===A?(E.splice(k,1),R++):R&&(E.splice(k,1),R--);if(!_&&!B)for(;R--;R)E.unshift("..");!_||""===E[0]||E[0]&&"/"===E[0].charAt(0)||E.unshift(""),C&&"/"!==E.join("/").substr(-1)&&E.push("");var x,I=""===E[0]||E[0]&&"/"===E[0].charAt(0);return S&&(r.hostname=r.host=I?"":E.length?E.shift():"",(x=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@"))&&(r.auth=x.shift(),r.host=r.hostname=x.shift())),(_=_||r.host&&E.length)&&!I&&E.unshift(""),E.length?r.pathname=E.join("/"):(r.pathname=null,r.path=null),i.isNull(r.pathname)&&i.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.auth=e.auth||r.auth,r.slashes=r.slashes||e.slashes,r.href=r.format(),r},o.prototype.parseHost=function(){var e=this.host,t=a.exec(e);t&&(":"!==(t=t[0])&&(this.port=t.substr(1)),e=e.substr(0,e.length-t.length)),e&&(this.hostname=e);};},2502:e=>{e.exports={isString:function(e){return "string"==typeof e},isObject:function(e){return "object"==typeof e&&null!==e},isNull:function(e){return null===e},isNullOrUndefined:function(e){return null==e}};},7067:()=>{}},t={};function r(n){var i=t[n];if(void 0!==i)return i.exports;var o=t[n]={id:n,loaded:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.loaded=!0,o.exports}r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var n in t)r.o(t,n)&&!r.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]});},r.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},r.nmd=e=>(e.paths=[],e.children||(e.children=[]),e);var n=r(5590);
        //window.gmodCRAM=n
        return n;
    };

    const gmodCRAM = fn();

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2018 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const READ_STRAND_FLAG = 0x10;
    const MATE_STRAND_FLAG = 0x20;

    const CRAM_MATE_STRAND_FLAG = 0x1;

    /**
     * Class for reading a cram file.  Wraps the gMOD Cram package.
     *
     * @param config
     * @constructor
     */
    class CramReader {

        constructor(config, genome, browser) {

            this.config = config;
            this.browser = browser;
            this.genome = genome;

            this.cramFile = new gmodCRAM.CramFile({
                filehandle: new FileHandler(config.url, config),
                seqFetch: config.seqFetch || seqFetch.bind(this),
                checkSequenceMD5: config.checkSequenceMD5 !== undefined ? config.checkSequenceMD5 : true
            });

            const indexFileHandle = new FileHandler(config.indexURL, config);
            this.indexedCramFile = new gmodCRAM.IndexedCramFile({
                cram: this.cramFile,
                index: new gmodCRAM.CraiIndex({
                    filehandle: indexFileHandle
                }),
                fetchSizeLimit: 30000000
            });

            BamUtils.setReaderDefaults(this, config);

            function seqFetch(seqID, start, end) {

                const sequence = this.genome.sequence;
                const genome = this.genome;

                return this.getHeader()
                    .then(function (header) {
                        const chr = genome.getChromosomeName(header.chrNames[seqID]);
                        return sequence.getSequence(chr, start - 1, end)
                    })
            }
        }


        /**
         * Parse the sequence dictionary from the SAM header and build chr name tables.  This function
         * is public so it can be unit tested.
         *
         * @returns {PromiseLike<chrName, chrToIndex, chrAliasTable}>}
         */

        async getHeader() {

            if (!this.header) {
                const genome = this.genome;
                const samHeader = await this.cramFile.getSamHeader();
                const chrToIndex = {};
                const chrNames = [];
                const chrAliasTable = {};
                const readGroups = [];

                for (let line of samHeader) {
                    if ('SQ' === line.tag) {
                        for (let d of line.data) {
                            if (d.tag === "SN") {
                                const seq = d.value;
                                chrToIndex[seq] = chrNames.length;
                                chrNames.push(seq);
                                if (genome) {
                                    const alias = genome.getChromosomeName(seq);
                                    chrAliasTable[alias] = seq;
                                }
                                break
                            }
                        }
                    } else if ('RG' === line.tag) {
                        readGroups.push(line.data);
                    }
                }

                this.header = {
                    chrNames: chrNames,
                    chrToIndex: chrToIndex,
                    chrAliasTable: chrAliasTable,
                    readGroups: readGroups
                };
            }

            return this.header
        }

        async readAlignments(chr, bpStart, bpEnd) {

            this.browser;
            const header = await this.getHeader();
            const queryChr = header.chrAliasTable.hasOwnProperty(chr) ? header.chrAliasTable[chr] : chr;
            const chrIdx = header.chrToIndex[queryChr];
            const alignmentContainer = new AlignmentContainer(chr, bpStart, bpEnd, this.config);

            if (chrIdx === undefined) {
                return alignmentContainer

            } else {

                try {
                    const records = await this.indexedCramFile.getRecordsForRange(chrIdx, bpStart, bpEnd);

                    for (let record of records) {

                        const refID = record.sequenceId;
                        const pos = record.alignmentStart;
                        const alignmentEnd = pos + record.lengthOnRef;

                        if (refID < 0) {
                            continue   // unmapped read
                        } else if (refID > chrIdx || pos > bpEnd) {
                            return    // off right edge, we're done
                        } else if (refID < chrIdx) {
                            continue   // Sequence to left of start, not sure this is possible
                        }
                        if (alignmentEnd < bpStart) {
                            continue
                        }  // Record out-of-range "to the left", skip to next one

                        const alignment = decodeCramRecord(record, header.chrNames);

                        if (this.filter.pass(alignment)) {
                            alignmentContainer.push(alignment);
                        }
                    }

                    alignmentContainer.finish();
                    return alignmentContainer
                } catch (error) {
                    let message = error.message;
                    if (message && message.indexOf("MD5") >= 0) {
                        message = "Sequence mismatch. Is this the correct genome for the loaded CRAM?";
                    }
                    this.browser.alert.present(new Error(message));
                    throw error
                }
            }

            function decodeCramRecord(record, chrNames) {

                const alignment = new BamAlignment();

                alignment.chr = chrNames[record.sequenceId];
                alignment.start = record.alignmentStart - 1;
                alignment.lengthOnRef = record.lengthOnRef;
                alignment.flags = record.flags;
                alignment.strand = !(record.flags & READ_STRAND_FLAG);
                alignment.fragmentLength = record.templateLength || record.templateSize;
                alignment.mq = record.mappingQuality;
                alignment.end = record.alignmentStart + record.lengthOnRef;
                alignment.readGroupId = record.readGroupId;

                if (record.mate && record.mate.sequenceId !== undefined) {
                    const strand = record.mate.flags !== undefined ?
                        !(record.mate.flags & CRAM_MATE_STRAND_FLAG) :
                        !(record.flags & MATE_STRAND_FLAG);

                    alignment.mate = {
                        chr: chrNames[record.mate.sequenceId],
                        position: record.mate.alignmentStart,
                        strand: strand
                    };
                }

                alignment.seq = record.getReadBases();
                alignment.qual = record.qualityScores;
                alignment.tagDict = record.tags;
                alignment.readName = record.readName;

                // TODO -- cigar encoded in tag?
                // BamUtils.bam_tag2cigar(ba, blockEnd, p, lseq, alignment, cigarArray);

                makeBlocks(record, alignment);

                if (alignment.mate && alignment.start > alignment.mate.position && alignment.fragmentLength > 0) {
                    alignment.fragmentLength = -alignment.fragmentLength;
                }

                BamUtils.setPairOrientation(alignment);

                return alignment

            }

            function makeBlocks(cramRecord, alignment) {

                const blocks = [];
                let insertions;
                let gaps;
                let basesUsed = 0;
                let cigarString = '';

                alignment.scStart = alignment.start;
                alignment.scLengthOnRef = alignment.lengthOnRef;

                if (cramRecord.readFeatures) {

                    for (let feature of cramRecord.readFeatures) {

                        const code = feature.code;
                        const data = feature.data;
                        const readPos = feature.pos - 1;
                        const refPos = feature.refPos - 1;

                        switch (code) {
                            case 'S' :
                            case 'I':
                            case 'i':
                            case 'N':
                            case 'D':
                                if (readPos > basesUsed) {
                                    const len = readPos - basesUsed;
                                    blocks.push(new AlignmentBlock({
                                        start: refPos - len,
                                        seqOffset: basesUsed,
                                        len: len,
                                        type: 'M'
                                    }));
                                    basesUsed += len;
                                    cigarString += len + 'M';
                                }

                                if ('S' === code) {
                                    let scPos = refPos;
                                    alignment.scLengthOnRef += data.length;
                                    if (readPos === 0) {
                                        alignment.scStart -= data.length;
                                        scPos -= data.length;
                                    }
                                    const len = data.length;
                                    blocks.push(new AlignmentBlock({
                                        start: scPos,
                                        seqOffset: basesUsed,
                                        len: len,
                                        type: 'S'
                                    }));
                                    basesUsed += len;
                                    cigarString += len + code;
                                } else if ('I' === code || 'i' === code) {
                                    if (insertions === undefined) {
                                        insertions = [];
                                    }
                                    const len = 'i' === code ? 1 : data.length;
                                    insertions.push(new AlignmentBlock({
                                        start: refPos,
                                        len: len,
                                        seqOffset: basesUsed,
                                        type: 'I'
                                    }));
                                    basesUsed += len;
                                    cigarString += len + code;
                                } else if ('D' === code || 'N' === code) {
                                    if (!gaps) {
                                        gaps = [];
                                    }
                                    gaps.push({
                                        start: refPos,
                                        len: data,
                                        type: code
                                    });
                                    cigarString += data + code;
                                }
                                break

                            case 'H':
                            case 'P':
                                cigarString += data + code;
                                break
                            //  Ignore
                        }
                    }
                }

                // Last block
                const len = cramRecord.readLength - basesUsed;
                if (len > 0) {
                    blocks.push(new AlignmentBlock({
                        start: cramRecord.alignmentStart + cramRecord.lengthOnRef - len - 1,
                        seqOffset: basesUsed,
                        len: len,
                        type: 'M'
                    }));

                    cigarString += len + 'M';
                }

                alignment.blocks = blocks;
                alignment.insertions = insertions;
                alignment.gaps = gaps;
                alignment.cigar = cigarString;

            }

        }
    }

    class FileHandler {

        constructor(source, config) {
            this.position = 0;
            this.url = source;
            this.config = config;
            this.cache = new BufferCache({
                fetch: (start, length) => this._fetch(start, length),
            });
        }

        async _fetch(position, length) {

            const loadRange = {start: position, size: length};
            this._stat = {size: undefined};
            const arrayBuffer = await igvxhr.loadArrayBuffer(this.url, buildOptions(this.config, {range: loadRange}));
            return Buffer.from(arrayBuffer)
        }

        async read(buffer, offset = 0, length = Infinity, position = 0) {
            let readPosition = position;
            if (readPosition === null) {
                readPosition = this.position;
                this.position += length;
            }
            return this.cache.get(buffer, offset, length, position)
        }

        async readFile() {
            const arrayBuffer = await igvxhr.loadArrayBuffer(this.url, buildOptions(this.config));
            return Buffer.from(arrayBuffer)
        }

        async stat() {
            if (!this._stat) {
                const buf = Buffer.allocUnsafe(10);
                await this.read(buf, 0, 10, 0);
                if (!this._stat)
                    throw new Error(`unable to determine size of file at ${this.url}`)
            }
            return this._stat
        }
    }

    class BufferCache {

        constructor({fetch, size = 10000000, chunkSize = 32768}) {

            this.fetch = fetch;
            this.chunkSize = chunkSize;
            this.lruCache = new QuickLRU({maxSize: Math.floor(size / chunkSize)});
        }

        async get(outputBuffer, offset, length, position) {
            if (outputBuffer.length < offset + length)
                throw new Error('output buffer not big enough for request')

            // calculate the list of chunks involved in this fetch
            const firstChunk = Math.floor(position / this.chunkSize);
            const lastChunk = Math.floor((position + length) / this.chunkSize);

            // fetch them all as necessary
            const fetches = new Array(lastChunk - firstChunk + 1);
            for (let chunk = firstChunk; chunk <= lastChunk; chunk += 1) {
                fetches[chunk - firstChunk] = this._getChunk(chunk).then(data => ({
                    data,
                    chunkNumber: chunk,
                }));
            }

            // stitch together the response buffer using them
            const chunks = await Promise.all(fetches);
            const chunksOffset = position - chunks[0].chunkNumber * this.chunkSize;
            chunks.forEach(({data, chunkNumber}) => {
                const chunkPositionStart = chunkNumber * this.chunkSize;
                let copyStart = 0;
                let copyEnd = this.chunkSize;
                let copyOffset =
                    offset + (chunkNumber - firstChunk) * this.chunkSize - chunksOffset;

                if (chunkNumber === firstChunk) {
                    copyOffset = offset;
                    copyStart = chunksOffset;
                }
                if (chunkNumber === lastChunk) {
                    copyEnd = position + length - chunkPositionStart;
                }

                data.copy(outputBuffer, copyOffset, copyStart, copyEnd);
            });
        }

        _getChunk(chunkNumber) {
            const cachedPromise = this.lruCache.get(chunkNumber);
            if (cachedPromise) return cachedPromise

            const freshPromise = this.fetch(
                chunkNumber * this.chunkSize,
                this.chunkSize,
            );
            this.lruCache.set(chunkNumber, freshPromise);
            return freshPromise
        }
    }

    class QuickLRU {
        constructor(options = {}) {
            if (!(options.maxSize && options.maxSize > 0)) {
                throw new TypeError('`maxSize` must be a number greater than 0')
            }

            this.maxSize = options.maxSize;
            this.cache = new Map();
            this.oldCache = new Map();
            this._size = 0;
        }

        _set(key, value) {
            this.cache.set(key, value);
            this._size++;

            if (this._size >= this.maxSize) {
                this._size = 0;
                this.oldCache = this.cache;
                this.cache = new Map();
            }
        }

        get(key) {
            if (this.cache.has(key)) {
                return this.cache.get(key)
            }

            if (this.oldCache.has(key)) {
                const value = this.oldCache.get(key);
                this._set(key, value);
                return value
            }
        }

        set(key, value) {
            if (this.cache.has(key)) {
                this.cache.set(key, value);
            } else {
                this._set(key, value);
            }

            return this
        }

        has(key) {
            return this.cache.has(key) || this.oldCache.has(key)
        }

        peek(key) {
            if (this.cache.has(key)) {
                return this.cache.get(key)
            }

            if (this.oldCache.has(key)) {
                return this.oldCache.get(key)
            }
        }

        delete(key) {
            const deleted = this.cache.delete(key);
            if (deleted) {
                this._size--;
            }

            return this.oldCache.delete(key) || deleted
        }

        clear() {
            this.cache.clear();
            this.oldCache.clear();
            this._size = 0;
        }

        * keys() {
            for (const [key] of this) {
                yield key;
            }
        }

        * values() {
            for (const [, value] of this) {
                yield value;
            }
        }

        * [Symbol.iterator]() {
            for (const item of this.cache) {
                yield item;
            }

            for (const item of this.oldCache) {
                const [key] = item;
                if (!this.cache.has(key)) {
                    yield item;
                }
            }
        }

        get size() {
            let oldCacheSize = 0;
            for (const key of this.oldCache.keys()) {
                if (!this.cache.has(key)) {
                    oldCacheSize++;
                }
            }

            return this._size + oldCacheSize
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    var CigarOperationTable = {
        "ALIGNMENT_MATCH": "M",
        "INSERT": "I",
        "DELETE": "D",
        "SKIP": "N",
        "CLIP_SOFT": "S",
        "CLIP_HARD": "H",
        "PAD": "P",
        "SEQUENCE_MATCH": "=",
        "SEQUENCE_MISMATCH": "X"
    };

    const Ga4ghAlignmentReader = function (config, genome) {

        this.config = config;
        this.genome = genome;
        this.url = config.url;
        this.filter = new BamFilter(config.filter);
        this.readGroupSetIds = config.readGroupSetIds;
        this.authKey = config.authKey;   // Might be undefined or nill

        this.samplingWindowSize = config.samplingWindowSize === undefined ? 100 : config.samplingWindowSize;
        this.samplingDepth = config.samplingDepth === undefined ? 1000 : config.samplingDepth;
        if (config.viewAsPairs) {
            this.pairsSupported = true;
        } else {
            this.pairsSupported = config.pairsSupported === undefined ? true : config.pairsSupported;
        }
    };


    Ga4ghAlignmentReader.prototype.readAlignments = function (chr, bpStart, bpEnd) {

        const genome = this.genome;
        const self = this;

        return getChrAliasTable()

            .then(function (chrAliasTable) {

                var queryChr = chrAliasTable.hasOwnProperty(chr) ? chrAliasTable[chr] : chr,
                    readURL = self.url + "/reads/search";

                return ga4ghSearch({
                    url: readURL,
                    body: {
                        "readGroupSetIds": [self.readGroupSetIds],
                        "referenceName": queryChr,
                        "start": bpStart,
                        "end": bpEnd,
                        "pageSize": "10000"
                    },
                    decode: decodeGa4ghReads,
                    results: new AlignmentContainer(chr, bpStart, bpEnd, self.config)
                })
            })


        function getChrAliasTable() {

            if (self.chrAliasTable) {

                return Promise.resolve(self.chrAliasTable)

            } else {

                return self.readMetadata()

                    .then(function (json) {

                        self.chrAliasTable = {};

                        if (genome && json.readGroups && json.readGroups.length > 0) {

                            var referenceSetId = json.readGroups[0].referenceSetId;

                            if (referenceSetId) {

                                // Query for reference names to build an alias table (map of genome ref names -> dataset ref names)
                                var readURL = self.url + "/references/search";

                                return ga4ghSearch({
                                    url: readURL,
                                    body: {
                                        "referenceSetId": referenceSetId
                                    },
                                    decode: function (j) {
                                        return j.references
                                    }
                                })
                                    .then(function (references) {


                                        references.forEach(function (ref) {
                                            var refName = ref.name,
                                                alias = genome.getChromosomeName(refName);
                                            self.chrAliasTable[alias] = refName;
                                        });


                                        return self.chrAliasTable

                                    })
                            } else {

                                // Try hardcoded constants -- workaround for non-compliant data at Google
                                populateChrAliasTable(self.chrAliasTable, self.config.datasetId);

                                return self.chrAliasTable
                            }
                        } else {
                            // No browser object, can't build map.  This can occur when run from unit tests
                            return self.chrAliasTable
                        }
                    })
            }
        }

        /**
         * Decode an array of ga4gh read records
         *

         */
        function decodeGa4ghReads(j) {

            var i,
                jsonRecords = j.alignments,
                len = jsonRecords.length,
                alignment,
                jsonAlignment,
                cigarDecoded,
                alignments = [],
                mate,
                blocks;

            for (i = 0; i < len; i++) {

                let record = jsonRecords[i];

                alignment = new BamAlignment();

                alignment.readName = record.fragmentName;
                alignment.properPlacement = record.properPlacement;
                alignment.duplicateFragment = record.duplicateFragment;
                alignment.numberReads = record.numberReads;
                alignment.fragmentLength = record.fragmentLength;
                alignment.readNumber = record.readNumber;
                alignment.failedVendorQualityChecks = record.failedVendorQualityChecks;
                alignment.secondaryAlignment = record.secondaryAlignment;
                alignment.supplementaryAlignment = record.supplementaryAlignment;
                alignment.seq = record.alignedSequence;
                alignment.qual = record.alignedQuality;
                alignment.matePos = record.nextMatePosition;
                alignment.tagDict = record.info;
                alignment.flags = encodeFlags();


                jsonAlignment = record.alignment;
                if (jsonAlignment) {
                    alignment.mapped = true;

                    alignment.chr = record.alignment.position.referenceName;
                    if (genome) alignment.chr = genome.getChromosomeName(alignment.chr);

                    alignment.start = parseInt(record.alignment.position.position);
                    alignment.strand = !(record.alignment.position.reverseStrand);
                    alignment.mq = record.alignment.mappingQuality;
                    alignment.cigar = encodeCigar(record.alignment.cigar);
                    cigarDecoded = translateCigar(record.alignment.cigar);

                    alignment.lengthOnRef = cigarDecoded.lengthOnRef;

                    blocks = makeBlocks(alignment, cigarDecoded.array);
                    alignment.blocks = blocks.blocks;
                    alignment.insertions = blocks.insertions;

                } else {
                    alignment.mapped = false;
                }

                mate = record.nextMatePosition;
                if (mate) {
                    alignment.mate = {
                        chr: mate.referenceFrame,
                        position: parseInt(mate.position),
                        strand: !mate.reverseStrand
                    };
                }

                if (self.filter.pass(alignment)) {
                    alignments.push(alignment);
                }


            }

            return alignments


            // Encode a cigar string -- used for popup text
            function encodeCigar(cigarArray) {

                var cigarString = "";
                cigarArray.forEach(function (cigarUnit) {
                    var op = CigarOperationTable[cigarUnit.operation],
                        len = cigarUnit.operationLength;
                    cigarString = cigarString + (len + op);
                });

                return cigarString
            }

            // TODO -- implement me
            function encodeFlags(json) {
                return 0
            }

            function translateCigar(cigar) {

                var cigarUnit, opLen, opLtr,
                    lengthOnRef = 0,
                    cigarArray = [],
                    i;

                for (i = 0; i < cigar.length; i++) {

                    cigarUnit = cigar[i];

                    opLtr = CigarOperationTable[cigarUnit.operation];
                    opLen = parseInt(cigarUnit.operationLength);    // Google represents long as a String

                    if (opLtr === 'M' || opLtr === 'EQ' || opLtr === 'X' || opLtr === 'D' || opLtr === 'N' || opLtr === '=')
                        lengthOnRef += opLen;

                    cigarArray.push({len: opLen, ltr: opLtr});

                }

                return {lengthOnRef: lengthOnRef, array: cigarArray}
            }


            /**
             * Split the alignment record into blocks as specified in the cigarArray.  Each aligned block contains
             * its portion of the read sequence and base quality strings.  A read sequence or base quality string
             * of "*" indicates the value is not recorded.  In all other cases the length of the block sequence (block.seq)
             * and quality string (block.qual) must == the block length.
             *
             * NOTE: Insertions are not yet treated // TODO
             *
             * @param record
             * @param cigarArray
             * @returns array of blocks
             */
            function makeBlocks(record, cigarArray) {


                var blocks = [],
                    gaps,
                    insertions,
                    seqOffset = 0,
                    pos = record.start,
                    len = cigarArray.length,
                    gapType;

                for (var i = 0; i < len; i++) {

                    var c = cigarArray[i];

                    switch (c.ltr) {
                        case 'H' :
                            break // ignore hard clips
                        case 'P' :
                            break // ignore pads
                        case 'S' :
                            seqOffset += c.len;
                            gapType = 'S';
                            break // soft clip read bases
                        case 'N' :
                        case 'D' :
                            if (gaps === undefined) {
                                gaps = [];
                            }
                            gaps.push({
                                start: pos,
                                len: c.len,
                                type: c.ltr
                            });
                            pos += c.len;
                            break
                        case 'I' :
                            if (insertions === undefined) insertions = [];
                            insertions.push(new AlignmentBlock({
                                start: pos,
                                len: c.len,
                                seqOffset: seqOffset
                            }));
                            seqOffset += c.len;
                            break
                        case 'M' :
                        case 'EQ' :
                        case '=' :
                        case 'X' :
                            blocks.push(
                                new AlignmentBlock({
                                    start: pos,
                                    len: c.len,
                                    seqOffset: seqOffset,
                                    gapType: gapType
                                }));
                            seqOffset += c.len;
                            pos += c.len;

                            break

                        default :
                            console.log("Error processing cigar element: " + c.len + c.ltr);
                    }
                }

                return {blocks: blocks, insertions: insertions, gaps: gaps}
            }
        }
    };


    Ga4ghAlignmentReader.prototype.readMetadata = function () {

        return ga4ghGet({
            url: this.url,
            entity: "readgroupsets",
            entityId: this.readGroupSetIds
        })
    };

    /**
     * Hardcoded hack to work around some non-compliant google datasets
     *
     * @param chrAliasTable
     * @param datasetId
     */
    function populateChrAliasTable(chrAliasTable, datasetId) {
        var i;
        if ("461916304629" === datasetId || "337315832689" === datasetId) {
            for (i = 1; i < 23; i++) {
                chrAliasTable["chr" + i] = i;
            }
            chrAliasTable["chrX"] = "X";
            chrAliasTable["chrY"] = "Y";
            chrAliasTable["chrM"] = "MT";
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class BamSource {

        constructor(config, browser) {

            const genome = browser.genome;

            this.config = config;
            this.genome = genome;

            if (isDataURL(config.url)) {
                this.config.indexed = false;
            }

            if ("ga4gh" === config.sourceType) {
                this.bamReader = new Ga4ghAlignmentReader(config, genome);
            } else if ("pysam" === config.sourceType) {
                this.bamReader = new BamWebserviceReader(config, genome);
            } else if ("htsget" === config.sourceType) {
                this.bamReader = new HtsgetBamReader(config, genome);
            } else if ("shardedBam" === config.sourceType) {
                this.bamReader = new ShardedBamReader(config, genome);
            } else if ("cram" === config.format) {
                this.bamReader = new CramReader(config, genome, browser);
            } else {
                if (!this.config.indexURL && config.indexed !== false) {
                    if (isString$2(this.config.url)) {
                        const inferIndexPath$1 = inferIndexPath(this.config.url, "bai");
                        if (inferIndexPath$1) {
                            console.error(`Warning: no indexURL specified for ${this.config.url}.  Guessing ${this.baiPath}`);
                            this.config.indexURL = inferIndexPath$1;
                        } else {
                            console.error(`Warning: no indexURL specified for ${this.config.url}.`);
                            this.config.indexed = false;
                        }
                    } else {
                        console.error(`Warning: no indexURL specified for ${this.config.name}.`);
                        this.config.indexed = false;
                    }
                }

                if (this.config.indexed !== false) { // && this.config.indexURL) {
                    this.bamReader = new BamReader(config, genome);
                } else {
                    this.bamReader = new BamReaderNonIndexed(config, genome);
                }
            }

            this.viewAsPairs = config.viewAsPairs;
            this.showSoftClips = config.showSoftClips;
        }

        setViewAsPairs(bool) {
            this.viewAsPairs = bool;
        }

        setShowSoftClips(bool) {
            this.showSoftClips = bool;
        }

        async getAlignments(chr, bpStart, bpEnd) {

            const genome = this.genome;
            const showSoftClips = this.showSoftClips;

            const alignmentContainer = await this.bamReader.readAlignments(chr, bpStart, bpEnd);
            let alignments = alignmentContainer.alignments;
            if (!this.viewAsPairs) {
                alignments = unpairAlignments([{alignments: alignments}]);
            }
            const hasAlignments = alignments.length > 0;
            alignmentContainer.packedAlignmentRows = packAlignmentRows(alignments, alignmentContainer.start, alignmentContainer.end, showSoftClips);

            this.alignmentContainer = alignmentContainer;

            if (hasAlignments) {
                const sequence = await genome.sequence.getSequence(chr, alignmentContainer.start, alignmentContainer.end);
                if (sequence) {
                    alignmentContainer.coverageMap.refSeq = sequence;    // TODO -- fix this
                    alignmentContainer.sequence = sequence;           // TODO -- fix this
                    return alignmentContainer
                } else {
                    console.error("No sequence for: " + chr + ":" + alignmentContainer.start + "-" + alignmentContainer.end);
                }
            }
            return alignmentContainer

        }
    }

    function paintAxis(ctx, pixelWidth, pixelHeight) {

        var x1,
            x2,
            y1,
            y2,
            a,
            b,
            reference,
            shim,
            font = {
                'font': 'normal 10px Arial',
                'textAlign': 'right',
                'strokeStyle': "black"
            };

        if (undefined === this.dataRange || undefined === this.dataRange.max || undefined === this.dataRange.min) {
            return
        }

        let flipAxis = (undefined === this.flipAxis) ? false : this.flipAxis;

        IGVGraphics.fillRect(ctx, 0, 0, pixelWidth, pixelHeight, {'fillStyle': "rgb(255, 255, 255)"});

        reference = 0.95 * pixelWidth;
        x1 = reference - 8;
        x2 = reference;

        //shim = 0.5 * 0.125;
        shim = .01;
        y1 = y2 = shim * pixelHeight;

        a = {x: x2, y: y1};

        // tick
        IGVGraphics.strokeLine(ctx, x1, y1, x2, y2, font);
        IGVGraphics.fillText(ctx, prettyPrint(flipAxis ? this.dataRange.min : this.dataRange.max), x1 + 4, y1 + 12, font);

        //shim = 0.25 * 0.125;
        y1 = y2 = (1.0 - shim) * pixelHeight;

        b = {x: x2, y: y1};

        // tick
        IGVGraphics.strokeLine(ctx, x1, y1, x2, y2, font);
        IGVGraphics.fillText(ctx, prettyPrint(flipAxis ? this.dataRange.max : this.dataRange.min), x1 + 4, y1 - 4, font);

        IGVGraphics.strokeLine(ctx, a.x, a.y, b.x, b.y, font);

        function prettyPrint(number) {
            // if number >= 100, show whole number
            // if >= 1 show 1 significant digits
            // if <  1 show 2 significant digits

            if (number === 0) {
                return "0"
            } else if (Math.abs(number) >= 10) {
                return number.toFixed()
            } else if (Math.abs(number) >= 1) {
                return number.toFixed(1)
            } else {
                return number.toFixed(2)
            }
        }
    }

    class Locus {

        constructor({chr, start, end}) {
            this.chr = chr;
            this.start = start;
            this.end = end;
        }


        contains(locus) {
            return locus.chr === this.chr && locus.start >= this.start && locus.end <= this.end
        }

        overlaps(locus) {
            return locus.chr === this.chr && !(locus.end < this.start || locus.start > this.end)
        }

        extend(l) {
            if (l.chr !== this.chr) return
            this.start = Math.min(l.start, this.start);
            this.end = Math.max(l.end, this.end);
        }

        getLocusString() {
            if ('all' === this.chr) {
                return 'all'
            } else {
                const ss = numberFormatter$1(Math.floor(this.start) + 1);
                const ee = numberFormatter$1(Math.round(this.end));
                return `${this.chr}:${ss}-${ee}`
            }
        }

        static fromLocusString(str) {
            if ('all' === str) {
                return new Locus({chr: 'all'})
            }
            const parts = str.split(':');
            const chr = parts[0];
            const se = parts[1].split("-");
            const start = Number.parseInt(se[0].replace(/,/g, "")) - 1;
            const end = Number.parseInt(se[1].replace(/,/g, ""));
            return new Locus({chr, start, end})
        }
    }

    /*!
     * vanilla-picker v2.12.1
     * https://vanilla-picker.js.org
     *
     * Copyright 2017-2021 Andreas Borgen (https://github.com/Sphinxxxx), Adam Brooks (https://github.com/dissimulate)
     * Released under the ISC license.
     */
    var classCallCheck = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };

    var createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    var slicedToArray = function () {
      function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;

        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);

            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"]) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }

        return _arr;
      }

      return function (arr, i) {
        if (Array.isArray(arr)) {
          return arr;
        } else if (Symbol.iterator in Object(arr)) {
          return sliceIterator(arr, i);
        } else {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
      };
    }();

    String.prototype.startsWith = String.prototype.startsWith || function (needle) {
        return this.indexOf(needle) === 0;
    };
    String.prototype.padStart = String.prototype.padStart || function (len, pad) {
        var str = this;while (str.length < len) {
            str = pad + str;
        }return str;
    };

    var colorNames = { cb: '0f8ff', tqw: 'aebd7', q: '-ffff', qmrn: '7fffd4', zr: '0ffff', bg: '5f5dc', bsq: 'e4c4', bck: '---', nch: 'ebcd', b: '--ff', bvt: '8a2be2', brwn: 'a52a2a', brw: 'deb887', ctb: '5f9ea0', hrt: '7fff-', chcT: 'd2691e', cr: '7f50', rnw: '6495ed', crns: '8dc', crms: 'dc143c', cn: '-ffff', Db: '--8b', Dcn: '-8b8b', Dgnr: 'b8860b', Dgr: 'a9a9a9', Dgrn: '-64-', Dkhk: 'bdb76b', Dmgn: '8b-8b', Dvgr: '556b2f', Drng: '8c-', Drch: '9932cc', Dr: '8b--', Dsmn: 'e9967a', Dsgr: '8fbc8f', DsTb: '483d8b', DsTg: '2f4f4f', Dtrq: '-ced1', Dvt: '94-d3', ppnk: '1493', pskb: '-bfff', mgr: '696969', grb: '1e90ff', rbrc: 'b22222', rwht: 'af0', stg: '228b22', chs: '-ff', gnsb: 'dcdcdc', st: '8f8ff', g: 'd7-', gnr: 'daa520', gr: '808080', grn: '-8-0', grnw: 'adff2f', hnw: '0fff0', htpn: '69b4', nnr: 'cd5c5c', ng: '4b-82', vr: '0', khk: '0e68c', vnr: 'e6e6fa', nrb: '0f5', wngr: '7cfc-', mnch: 'acd', Lb: 'add8e6', Lcr: '08080', Lcn: 'e0ffff', Lgnr: 'afad2', Lgr: 'd3d3d3', Lgrn: '90ee90', Lpnk: 'b6c1', Lsmn: 'a07a', Lsgr: '20b2aa', Lskb: '87cefa', LsTg: '778899', Lstb: 'b0c4de', Lw: 'e0', m: '-ff-', mgrn: '32cd32', nn: 'af0e6', mgnt: '-ff', mrn: '8--0', mqm: '66cdaa', mmb: '--cd', mmrc: 'ba55d3', mmpr: '9370db', msg: '3cb371', mmsT: '7b68ee', '': '-fa9a', mtr: '48d1cc', mmvt: 'c71585', mnLb: '191970', ntc: '5fffa', mstr: 'e4e1', mccs: 'e4b5', vjw: 'dead', nv: '--80', c: 'df5e6', v: '808-0', vrb: '6b8e23', rng: 'a5-', rngr: '45-', rch: 'da70d6', pgnr: 'eee8aa', pgrn: '98fb98', ptrq: 'afeeee', pvtr: 'db7093', ppwh: 'efd5', pchp: 'dab9', pr: 'cd853f', pnk: 'c0cb', pm: 'dda0dd', pwrb: 'b0e0e6', prp: '8-080', cc: '663399', r: '--', sbr: 'bc8f8f', rb: '4169e1', sbrw: '8b4513', smn: 'a8072', nbr: '4a460', sgrn: '2e8b57', ssh: '5ee', snn: 'a0522d', svr: 'c0c0c0', skb: '87ceeb', sTb: '6a5acd', sTgr: '708090', snw: 'afa', n: '-ff7f', stb: '4682b4', tn: 'd2b48c', t: '-8080', thst: 'd8bfd8', tmT: '6347', trqs: '40e0d0', vt: 'ee82ee', whT: '5deb3', wht: '', hts: '5f5f5', w: '-', wgrn: '9acd32' };

    function printNum(num) {
        var decs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        var str = decs > 0 ? num.toFixed(decs).replace(/0+$/, '').replace(/\.$/, '') : num.toString();
        return str || '0';
    }

    var Color = function () {
        function Color(r, g, b, a) {
            classCallCheck(this, Color);


            var that = this;
            function parseString(input) {

                if (input.startsWith('hsl')) {
                    var _input$match$map = input.match(/([\-\d\.e]+)/g).map(Number),
                        _input$match$map2 = slicedToArray(_input$match$map, 4),
                        h = _input$match$map2[0],
                        s = _input$match$map2[1],
                        l = _input$match$map2[2],
                        _a = _input$match$map2[3];

                    if (_a === undefined) {
                        _a = 1;
                    }

                    h /= 360;
                    s /= 100;
                    l /= 100;
                    that.hsla = [h, s, l, _a];
                } else if (input.startsWith('rgb')) {
                    var _input$match$map3 = input.match(/([\-\d\.e]+)/g).map(Number),
                        _input$match$map4 = slicedToArray(_input$match$map3, 4),
                        _r = _input$match$map4[0],
                        _g = _input$match$map4[1],
                        _b = _input$match$map4[2],
                        _a2 = _input$match$map4[3];

                    if (_a2 === undefined) {
                        _a2 = 1;
                    }

                    that.rgba = [_r, _g, _b, _a2];
                } else {
                    if (input.startsWith('#')) {
                        that.rgba = Color.hexToRgb(input);
                    } else {
                        that.rgba = Color.nameToRgb(input) || Color.hexToRgb(input);
                    }
                }
            }

            if (r === undefined) ; else if (Array.isArray(r)) {
                this.rgba = r;
            } else if (b === undefined) {
                var color = r && '' + r;
                if (color) {
                    parseString(color.toLowerCase());
                }
            } else {
                this.rgba = [r, g, b, a === undefined ? 1 : a];
            }
        }

        createClass(Color, [{
            key: 'printRGB',
            value: function printRGB(alpha) {
                var rgb = alpha ? this.rgba : this.rgba.slice(0, 3),
                    vals = rgb.map(function (x, i) {
                    return printNum(x, i === 3 ? 3 : 0);
                });

                return alpha ? 'rgba(' + vals + ')' : 'rgb(' + vals + ')';
            }
        }, {
            key: 'printHSL',
            value: function printHSL(alpha) {
                var mults = [360, 100, 100, 1],
                    suff = ['', '%', '%', ''];

                var hsl = alpha ? this.hsla : this.hsla.slice(0, 3),
                    vals = hsl.map(function (x, i) {
                    return printNum(x * mults[i], i === 3 ? 3 : 1) + suff[i];
                });

                return alpha ? 'hsla(' + vals + ')' : 'hsl(' + vals + ')';
            }
        }, {
            key: 'printHex',
            value: function printHex(alpha) {
                var hex = this.hex;
                return alpha ? hex : hex.substring(0, 7);
            }
        }, {
            key: 'rgba',
            get: function get() {
                if (this._rgba) {
                    return this._rgba;
                }
                if (!this._hsla) {
                    throw new Error('No color is set');
                }

                return this._rgba = Color.hslToRgb(this._hsla);
            },
            set: function set(rgb) {
                if (rgb.length === 3) {
                    rgb[3] = 1;
                }

                this._rgba = rgb;
                this._hsla = null;
            }
        }, {
            key: 'rgbString',
            get: function get() {
                return this.printRGB();
            }
        }, {
            key: 'rgbaString',
            get: function get() {
                return this.printRGB(true);
            }
        }, {
            key: 'hsla',
            get: function get() {
                if (this._hsla) {
                    return this._hsla;
                }
                if (!this._rgba) {
                    throw new Error('No color is set');
                }

                return this._hsla = Color.rgbToHsl(this._rgba);
            },
            set: function set(hsl) {
                if (hsl.length === 3) {
                    hsl[3] = 1;
                }

                this._hsla = hsl;
                this._rgba = null;
            }
        }, {
            key: 'hslString',
            get: function get() {
                return this.printHSL();
            }
        }, {
            key: 'hslaString',
            get: function get() {
                return this.printHSL(true);
            }
        }, {
            key: 'hex',
            get: function get() {
                var rgb = this.rgba,
                    hex = rgb.map(function (x, i) {
                    return i < 3 ? x.toString(16) : Math.round(x * 255).toString(16);
                });

                return '#' + hex.map(function (x) {
                    return x.padStart(2, '0');
                }).join('');
            },
            set: function set(hex) {
                this.rgba = Color.hexToRgb(hex);
            }
        }], [{
            key: 'hexToRgb',
            value: function hexToRgb(input) {

                var hex = (input.startsWith('#') ? input.slice(1) : input).replace(/^(\w{3})$/, '$1F').replace(/^(\w)(\w)(\w)(\w)$/, '$1$1$2$2$3$3$4$4').replace(/^(\w{6})$/, '$1FF');

                if (!hex.match(/^([0-9a-fA-F]{8})$/)) {
                    throw new Error('Unknown hex color; ' + input);
                }

                var rgba = hex.match(/^(\w\w)(\w\w)(\w\w)(\w\w)$/).slice(1).map(function (x) {
                    return parseInt(x, 16);
                });

                rgba[3] = rgba[3] / 255;
                return rgba;
            }
        }, {
            key: 'nameToRgb',
            value: function nameToRgb(input) {

                var hash = input.toLowerCase().replace('at', 'T').replace(/[aeiouyldf]/g, '').replace('ght', 'L').replace('rk', 'D').slice(-5, 4),
                    hex = colorNames[hash];
                return hex === undefined ? hex : Color.hexToRgb(hex.replace(/\-/g, '00').padStart(6, 'f'));
            }
        }, {
            key: 'rgbToHsl',
            value: function rgbToHsl(_ref) {
                var _ref2 = slicedToArray(_ref, 4),
                    r = _ref2[0],
                    g = _ref2[1],
                    b = _ref2[2],
                    a = _ref2[3];

                r /= 255;
                g /= 255;
                b /= 255;

                var max = Math.max(r, g, b),
                    min = Math.min(r, g, b);
                var h = void 0,
                    s = void 0,
                    l = (max + min) / 2;

                if (max === min) {
                    h = s = 0;
                } else {
                    var d = max - min;
                    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                    switch (max) {
                        case r:
                            h = (g - b) / d + (g < b ? 6 : 0);break;
                        case g:
                            h = (b - r) / d + 2;break;
                        case b:
                            h = (r - g) / d + 4;break;
                    }

                    h /= 6;
                }

                return [h, s, l, a];
            }
        }, {
            key: 'hslToRgb',
            value: function hslToRgb(_ref3) {
                var _ref4 = slicedToArray(_ref3, 4),
                    h = _ref4[0],
                    s = _ref4[1],
                    l = _ref4[2],
                    a = _ref4[3];

                var r = void 0,
                    g = void 0,
                    b = void 0;

                if (s === 0) {
                    r = g = b = l;
                } else {
                    var hue2rgb = function hue2rgb(p, q, t) {
                        if (t < 0) t += 1;
                        if (t > 1) t -= 1;
                        if (t < 1 / 6) return p + (q - p) * 6 * t;
                        if (t < 1 / 2) return q;
                        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                        return p;
                    };

                    var q = l < 0.5 ? l * (1 + s) : l + s - l * s,
                        p = 2 * l - q;

                    r = hue2rgb(p, q, h + 1 / 3);
                    g = hue2rgb(p, q, h);
                    b = hue2rgb(p, q, h - 1 / 3);
                }

                var rgba = [r * 255, g * 255, b * 255].map(Math.round);
                rgba[3] = a;

                return rgba;
            }
        }]);
        return Color;
    }();

    var EventBucket = function () {
        function EventBucket() {
            classCallCheck(this, EventBucket);

            this._events = [];
        }

        createClass(EventBucket, [{
            key: 'add',
            value: function add(target, type, handler) {
                target.addEventListener(type, handler, false);
                this._events.push({
                    target: target,
                    type: type,
                    handler: handler
                });
            }
        }, {
            key: 'remove',
            value: function remove(target, type, handler) {
                this._events = this._events.filter(function (e) {
                    var isMatch = true;
                    if (target && target !== e.target) {
                        isMatch = false;
                    }
                    if (type && type !== e.type) {
                        isMatch = false;
                    }
                    if (handler && handler !== e.handler) {
                        isMatch = false;
                    }

                    if (isMatch) {
                        EventBucket._doRemove(e.target, e.type, e.handler);
                    }
                    return !isMatch;
                });
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this._events.forEach(function (e) {
                    return EventBucket._doRemove(e.target, e.type, e.handler);
                });
                this._events = [];
            }
        }], [{
            key: '_doRemove',
            value: function _doRemove(target, type, handler) {
                target.removeEventListener(type, handler, false);
            }
        }]);
        return EventBucket;
    }();

    function parseHTML(htmlString) {

        var div = document.createElement('div');
        div.innerHTML = htmlString;
        return div.firstElementChild;
    }

    function dragTrack(eventBucket, area, callback) {
        var dragging = false;

        function clamp(val, min, max) {
            return Math.max(min, Math.min(val, max));
        }

        function onMove(e, info, starting) {
            if (starting) {
                dragging = true;
            }
            if (!dragging) {
                return;
            }

            e.preventDefault();

            var bounds = area.getBoundingClientRect(),
                w = bounds.width,
                h = bounds.height,
                x = info.clientX,
                y = info.clientY;

            var relX = clamp(x - bounds.left, 0, w),
                relY = clamp(y - bounds.top, 0, h);

            callback(relX / w, relY / h);
        }

        function onMouse(e, starting) {
            var button = e.buttons === undefined ? e.which : e.buttons;
            if (button === 1) {
                onMove(e, e, starting);
            } else {
                dragging = false;
            }
        }

        function onTouch(e, starting) {
            if (e.touches.length === 1) {
                onMove(e, e.touches[0], starting);
            } else {
                dragging = false;
            }
        }

        eventBucket.add(area, 'mousedown', function (e) {
            onMouse(e, true);
        });
        eventBucket.add(area, 'touchstart', function (e) {
            onTouch(e, true);
        });
        eventBucket.add(window, 'mousemove', onMouse);
        eventBucket.add(area, 'touchmove', onTouch);
        eventBucket.add(window, 'mouseup', function (e) {
            dragging = false;
        });
        eventBucket.add(area, 'touchend', function (e) {
            dragging = false;
        });
        eventBucket.add(area, 'touchcancel', function (e) {
            dragging = false;
        });
    }

    var BG_TRANSP = 'linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0 / 2em 2em,\n                   linear-gradient(45deg, lightgrey 25%,       white 25%,       white 75%, lightgrey 75%) 1em 1em / 2em 2em';
    var HUES = 360;

    var EVENT_KEY = 'keydown',
        EVENT_CLICK_OUTSIDE = 'mousedown',
        EVENT_TAB_MOVE = 'focusin';

    function $(selector, context) {
        return (context || document).querySelector(selector);
    }

    function stopEvent(e) {

        e.preventDefault();
        e.stopPropagation();
    }
    function onKey(bucket, target, keys, handler, stop) {
        bucket.add(target, EVENT_KEY, function (e) {
            if (keys.indexOf(e.key) >= 0) {
                if (stop) {
                    stopEvent(e);
                }
                handler(e);
            }
        });
    }

    var Picker = function () {
        function Picker(options) {
            classCallCheck(this, Picker);


            this.settings = {

                popup: 'right',
                layout: 'default',
                alpha: true,
                editor: true,
                editorFormat: 'hex',
                cancelButton: false,
                defaultColor: '#0cf'
            };

            this._events = new EventBucket();

            this.onChange = null;

            this.onDone = null;

            this.onOpen = null;

            this.onClose = null;

            this.setOptions(options);
        }

        createClass(Picker, [{
            key: 'setOptions',
            value: function setOptions(options) {
                var _this = this;

                if (!options) {
                    return;
                }
                var settings = this.settings;

                function transfer(source, target, skipKeys) {
                    for (var key in source) {
                        if (skipKeys && skipKeys.indexOf(key) >= 0) {
                            continue;
                        }

                        target[key] = source[key];
                    }
                }

                if (options instanceof HTMLElement) {
                    settings.parent = options;
                } else {

                    if (settings.parent && options.parent && settings.parent !== options.parent) {
                        this._events.remove(settings.parent);
                        this._popupInited = false;
                    }

                    transfer(options, settings);

                    if (options.onChange) {
                        this.onChange = options.onChange;
                    }
                    if (options.onDone) {
                        this.onDone = options.onDone;
                    }
                    if (options.onOpen) {
                        this.onOpen = options.onOpen;
                    }
                    if (options.onClose) {
                        this.onClose = options.onClose;
                    }

                    var col = options.color || options.colour;
                    if (col) {
                        this._setColor(col);
                    }
                }

                var parent = settings.parent;
                if (parent && settings.popup && !this._popupInited) {

                    var openProxy = function openProxy(e) {
                        return _this.openHandler(e);
                    };

                    this._events.add(parent, 'click', openProxy);

                    onKey(this._events, parent, [' ', 'Spacebar', 'Enter'], openProxy);

                    this._popupInited = true;
                } else if (options.parent && !settings.popup) {
                    this.show();
                }
            }
        }, {
            key: 'openHandler',
            value: function openHandler(e) {
                if (this.show()) {

                    e && e.preventDefault();

                    this.settings.parent.style.pointerEvents = 'none';

                    var toFocus = e && e.type === EVENT_KEY ? this._domEdit : this.domElement;
                    setTimeout(function () {
                        return toFocus.focus();
                    }, 100);

                    if (this.onOpen) {
                        this.onOpen(this.colour);
                    }
                }
            }
        }, {
            key: 'closeHandler',
            value: function closeHandler(e) {
                var event = e && e.type;
                var doHide = false;

                if (!e) {
                    doHide = true;
                } else if (event === EVENT_CLICK_OUTSIDE || event === EVENT_TAB_MOVE) {

                    var knownTime = (this.__containedEvent || 0) + 100;
                    if (e.timeStamp > knownTime) {
                        doHide = true;
                    }
                } else {

                    stopEvent(e);

                    doHide = true;
                }

                if (doHide && this.hide()) {
                    this.settings.parent.style.pointerEvents = '';

                    if (event !== EVENT_CLICK_OUTSIDE) {
                        this.settings.parent.focus();
                    }

                    if (this.onClose) {
                        this.onClose(this.colour);
                    }
                }
            }
        }, {
            key: 'movePopup',
            value: function movePopup(options, open) {

                this.closeHandler();

                this.setOptions(options);
                if (open) {
                    this.openHandler();
                }
            }
        }, {
            key: 'setColor',
            value: function setColor(color, silent) {
                this._setColor(color, { silent: silent });
            }
        }, {
            key: '_setColor',
            value: function _setColor(color, flags) {
                if (typeof color === 'string') {
                    color = color.trim();
                }
                if (!color) {
                    return;
                }

                flags = flags || {};
                var c = void 0;
                try {

                    c = new Color(color);
                } catch (ex) {
                    if (flags.failSilently) {
                        return;
                    }
                    throw ex;
                }

                if (!this.settings.alpha) {
                    var hsla = c.hsla;
                    hsla[3] = 1;
                    c.hsla = hsla;
                }
                this.colour = this.color = c;
                this._setHSLA(null, null, null, null, flags);
            }
        }, {
            key: 'setColour',
            value: function setColour(colour, silent) {
                this.setColor(colour, silent);
            }
        }, {
            key: 'show',
            value: function show() {
                var parent = this.settings.parent;
                if (!parent) {
                    return false;
                }

                if (this.domElement) {
                    var toggled = this._toggleDOM(true);

                    this._setPosition();

                    return toggled;
                }

                var html = this.settings.template || '<div class="picker_wrapper" tabindex="-1"><div class="picker_arrow"></div><div class="picker_hue picker_slider"><div class="picker_selector"></div></div><div class="picker_sl"><div class="picker_selector"></div></div><div class="picker_alpha picker_slider"><div class="picker_selector"></div></div><div class="picker_editor"><input aria-label="Type a color name or hex value"/></div><div class="picker_sample"></div><div class="picker_done"><button>Ok</button></div><div class="picker_cancel"><button>Cancel</button></div></div>';
                var wrapper = parseHTML(html);

                this.domElement = wrapper;
                this._domH = $('.picker_hue', wrapper);
                this._domSL = $('.picker_sl', wrapper);
                this._domA = $('.picker_alpha', wrapper);
                this._domEdit = $('.picker_editor input', wrapper);
                this._domSample = $('.picker_sample', wrapper);
                this._domOkay = $('.picker_done button', wrapper);
                this._domCancel = $('.picker_cancel button', wrapper);

                wrapper.classList.add('layout_' + this.settings.layout);
                if (!this.settings.alpha) {
                    wrapper.classList.add('no_alpha');
                }
                if (!this.settings.editor) {
                    wrapper.classList.add('no_editor');
                }
                if (!this.settings.cancelButton) {
                    wrapper.classList.add('no_cancel');
                }
                this._ifPopup(function () {
                    return wrapper.classList.add('popup');
                });

                this._setPosition();

                if (this.colour) {
                    this._updateUI();
                } else {
                    this._setColor(this.settings.defaultColor);
                }
                this._bindEvents();

                return true;
            }
        }, {
            key: 'hide',
            value: function hide() {
                return this._toggleDOM(false);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this._events.destroy();
                if (this.domElement) {
                    this.settings.parent.removeChild(this.domElement);
                }
            }
        }, {
            key: '_bindEvents',
            value: function _bindEvents() {
                var _this2 = this;

                var that = this,
                    dom = this.domElement,
                    events = this._events;

                function addEvent(target, type, handler) {
                    events.add(target, type, handler);
                }

                addEvent(dom, 'click', function (e) {
                    return e.preventDefault();
                });

                dragTrack(events, this._domH, function (x, y) {
                    return that._setHSLA(x);
                });

                dragTrack(events, this._domSL, function (x, y) {
                    return that._setHSLA(null, x, 1 - y);
                });

                if (this.settings.alpha) {
                    dragTrack(events, this._domA, function (x, y) {
                        return that._setHSLA(null, null, null, 1 - y);
                    });
                }

                var editInput = this._domEdit;
                {
                    addEvent(editInput, 'input', function (e) {
                        that._setColor(this.value, { fromEditor: true, failSilently: true });
                    });

                    addEvent(editInput, 'focus', function (e) {
                        var input = this;

                        if (input.selectionStart === input.selectionEnd) {
                            input.select();
                        }
                    });
                }

                this._ifPopup(function () {

                    var popupCloseProxy = function popupCloseProxy(e) {
                        return _this2.closeHandler(e);
                    };

                    addEvent(window, EVENT_CLICK_OUTSIDE, popupCloseProxy);
                    addEvent(window, EVENT_TAB_MOVE, popupCloseProxy);
                    onKey(events, dom, ['Esc', 'Escape'], popupCloseProxy);

                    var timeKeeper = function timeKeeper(e) {
                        _this2.__containedEvent = e.timeStamp;
                    };
                    addEvent(dom, EVENT_CLICK_OUTSIDE, timeKeeper);

                    addEvent(dom, EVENT_TAB_MOVE, timeKeeper);

                    addEvent(_this2._domCancel, 'click', popupCloseProxy);
                });

                var onDoneProxy = function onDoneProxy(e) {
                    _this2._ifPopup(function () {
                        return _this2.closeHandler(e);
                    });
                    if (_this2.onDone) {
                        _this2.onDone(_this2.colour);
                    }
                };
                addEvent(this._domOkay, 'click', onDoneProxy);
                onKey(events, dom, ['Enter'], onDoneProxy);
            }
        }, {
            key: '_setPosition',
            value: function _setPosition() {
                var parent = this.settings.parent,
                    elm = this.domElement;

                if (parent !== elm.parentNode) {
                    parent.appendChild(elm);
                }

                this._ifPopup(function (popup) {

                    if (getComputedStyle(parent).position === 'static') {
                        parent.style.position = 'relative';
                    }

                    var cssClass = popup === true ? 'popup_right' : 'popup_' + popup;

                    ['popup_top', 'popup_bottom', 'popup_left', 'popup_right'].forEach(function (c) {

                        if (c === cssClass) {
                            elm.classList.add(c);
                        } else {
                            elm.classList.remove(c);
                        }
                    });

                    elm.classList.add(cssClass);
                });
            }
        }, {
            key: '_setHSLA',
            value: function _setHSLA(h, s, l, a, flags) {
                flags = flags || {};

                var col = this.colour,
                    hsla = col.hsla;

                [h, s, l, a].forEach(function (x, i) {
                    if (x || x === 0) {
                        hsla[i] = x;
                    }
                });
                col.hsla = hsla;

                this._updateUI(flags);

                if (this.onChange && !flags.silent) {
                    this.onChange(col);
                }
            }
        }, {
            key: '_updateUI',
            value: function _updateUI(flags) {
                if (!this.domElement) {
                    return;
                }
                flags = flags || {};

                var col = this.colour,
                    hsl = col.hsla,
                    cssHue = 'hsl(' + hsl[0] * HUES + ', 100%, 50%)',
                    cssHSL = col.hslString,
                    cssHSLA = col.hslaString;

                var uiH = this._domH,
                    uiSL = this._domSL,
                    uiA = this._domA,
                    thumbH = $('.picker_selector', uiH),
                    thumbSL = $('.picker_selector', uiSL),
                    thumbA = $('.picker_selector', uiA);

                function posX(parent, child, relX) {
                    child.style.left = relX * 100 + '%';
                }
                function posY(parent, child, relY) {
                    child.style.top = relY * 100 + '%';
                }

                posX(uiH, thumbH, hsl[0]);

                this._domSL.style.backgroundColor = this._domH.style.color = cssHue;

                posX(uiSL, thumbSL, hsl[1]);
                posY(uiSL, thumbSL, 1 - hsl[2]);

                uiSL.style.color = cssHSL;

                posY(uiA, thumbA, 1 - hsl[3]);

                var opaque = cssHSL,
                    transp = opaque.replace('hsl', 'hsla').replace(')', ', 0)'),
                    bg = 'linear-gradient(' + [opaque, transp] + ')';

                this._domA.style.background = bg + ', ' + BG_TRANSP;

                if (!flags.fromEditor) {
                    var format = this.settings.editorFormat,
                        alpha = this.settings.alpha;

                    var value = void 0;
                    switch (format) {
                        case 'rgb':
                            value = col.printRGB(alpha);break;
                        case 'hsl':
                            value = col.printHSL(alpha);break;
                        default:
                            value = col.printHex(alpha);
                    }
                    this._domEdit.value = value;
                }

                this._domSample.style.color = cssHSLA;
            }
        }, {
            key: '_ifPopup',
            value: function _ifPopup(actionIf, actionElse) {
                if (this.settings.parent && this.settings.popup) {
                    actionIf && actionIf(this.settings.popup);
                } else {
                    actionElse && actionElse();
                }
            }
        }, {
            key: '_toggleDOM',
            value: function _toggleDOM(toVisible) {
                var dom = this.domElement;
                if (!dom) {
                    return false;
                }

                var displayStyle = toVisible ? '' : 'none',
                    toggle = dom.style.display !== displayStyle;

                if (toggle) {
                    dom.style.display = displayStyle;
                }
                return toggle;
            }
        }]);
        return Picker;
    }();

    {
        var style = document.createElement('style');
        style.textContent = '.picker_wrapper.no_alpha .picker_alpha{display:none}.picker_wrapper.no_editor .picker_editor{position:absolute;z-index:-1;opacity:0}.picker_wrapper.no_cancel .picker_cancel{display:none}.layout_default.picker_wrapper{display:flex;flex-flow:row wrap;justify-content:space-between;align-items:stretch;font-size:10px;width:25em;padding:.5em}.layout_default.picker_wrapper input,.layout_default.picker_wrapper button{font-size:1rem}.layout_default.picker_wrapper>*{margin:.5em}.layout_default.picker_wrapper::before{content:"";display:block;width:100%;height:0;order:1}.layout_default .picker_slider,.layout_default .picker_selector{padding:1em}.layout_default .picker_hue{width:100%}.layout_default .picker_sl{flex:1 1 auto}.layout_default .picker_sl::before{content:"";display:block;padding-bottom:100%}.layout_default .picker_editor{order:1;width:6.5rem}.layout_default .picker_editor input{width:100%;height:100%}.layout_default .picker_sample{order:1;flex:1 1 auto}.layout_default .picker_done,.layout_default .picker_cancel{order:1}.picker_wrapper{box-sizing:border-box;background:#f2f2f2;box-shadow:0 0 0 1px silver;cursor:default;font-family:sans-serif;color:#444;pointer-events:auto}.picker_wrapper:focus{outline:none}.picker_wrapper button,.picker_wrapper input{box-sizing:border-box;border:none;box-shadow:0 0 0 1px silver;outline:none}.picker_wrapper button:focus,.picker_wrapper button:active,.picker_wrapper input:focus,.picker_wrapper input:active{box-shadow:0 0 2px 1px #1e90ff}.picker_wrapper button{padding:.4em .6em;cursor:pointer;background-color:#f5f5f5;background-image:linear-gradient(0deg, gainsboro, transparent)}.picker_wrapper button:active{background-image:linear-gradient(0deg, transparent, gainsboro)}.picker_wrapper button:hover{background-color:#fff}.picker_selector{position:absolute;z-index:1;display:block;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);border:2px solid #fff;border-radius:100%;box-shadow:0 0 3px 1px #67b9ff;background:currentColor;cursor:pointer}.picker_slider .picker_selector{border-radius:2px}.picker_hue{position:relative;background-image:linear-gradient(90deg, red, yellow, lime, cyan, blue, magenta, red);box-shadow:0 0 0 1px silver}.picker_sl{position:relative;box-shadow:0 0 0 1px silver;background-image:linear-gradient(180deg, white, rgba(255, 255, 255, 0) 50%),linear-gradient(0deg, black, rgba(0, 0, 0, 0) 50%),linear-gradient(90deg, #808080, rgba(128, 128, 128, 0))}.picker_alpha,.picker_sample{position:relative;background:linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0/2em 2em,linear-gradient(45deg, lightgrey 25%, white 25%, white 75%, lightgrey 75%) 1em 1em/2em 2em;box-shadow:0 0 0 1px silver}.picker_alpha .picker_selector,.picker_sample .picker_selector{background:none}.picker_editor input{font-family:monospace;padding:.2em .4em}.picker_sample::before{content:"";position:absolute;display:block;width:100%;height:100%;background:currentColor}.picker_arrow{position:absolute;z-index:-1}.picker_wrapper.popup{position:absolute;z-index:2;margin:1.5em}.picker_wrapper.popup,.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{background:#f2f2f2;box-shadow:0 0 10px 1px rgba(0,0,0,.4)}.picker_wrapper.popup .picker_arrow{width:3em;height:3em;margin:0}.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{content:"";display:block;position:absolute;top:0;left:0;z-index:-99}.picker_wrapper.popup .picker_arrow::before{width:100%;height:100%;-webkit-transform:skew(45deg);transform:skew(45deg);-webkit-transform-origin:0 100%;transform-origin:0 100%}.picker_wrapper.popup .picker_arrow::after{width:150%;height:150%;box-shadow:none}.popup.popup_top{bottom:100%;left:0}.popup.popup_top .picker_arrow{bottom:0;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.popup.popup_bottom{top:100%;left:0}.popup.popup_bottom .picker_arrow{top:0;left:0;-webkit-transform:rotate(90deg) scale(1, -1);transform:rotate(90deg) scale(1, -1)}.popup.popup_left{top:0;right:100%}.popup.popup_left .picker_arrow{top:0;right:0;-webkit-transform:scale(-1, 1);transform:scale(-1, 1)}.popup.popup_right{top:0;left:100%}.popup.popup_right .picker_arrow{top:0;left:0}';
        document.documentElement.firstElementChild.appendChild(style);

        Picker.StyleElement = style;
    }

    function getChrColor$1(chr) {
        if (chrColorMap$1[chr]) {
            return chrColorMap$1[chr];
        } else if (chrColorMap$1["chr" + chr]) {
            const color = chrColorMap$1["chr" + chr];
            chrColorMap$1[chr] = color;
            return color;
        } else {
            const color = randomRGB();
            chrColorMap$1[chr] = color;
            return color;
        }
    }

    function randomRGB (min, max) {

        var r = Math.round(Math.random() * 255).toString(10);
        var g = Math.round(Math.random() * 255).toString(10);
        var b = Math.round(Math.random() * 255).toString(10);
        return "rgb(" + r + "," + g + "," + b + ")";
    }

    const chrColorMap$1 = {
        "chrX": "rgb(204, 153, 0)",
        "chrY": "rgb(153, 204, 0",
        "chrUn": "rgb(50, 50, 50)",
        "chr1": "rgb(80, 80, 255)",
        "chrI": "rgb(139, 155, 187)",
        "chr2": "rgb(206, 61, 50)",
        "chrII": "rgb(206, 61, 50)",
        "chr2a": "rgb(216, 71, 60)",
        "chr2b": "rgb(226, 81, 70)",
        "chr3": "rgb(116, 155, 88)",
        "chrIII": "rgb(116, 155, 88)",
        "chr4": "rgb(240, 230, 133)",
        "chrIV": "rgb(240, 230, 133)",
        "chr5": "rgb(70, 105, 131)",
        "chr6": "rgb(186, 99, 56)",
        "chr7": "rgb(93, 177, 221)",
        "chr8": "rgb(128, 34, 104)",
        "chr9": "rgb(107, 215, 107)",
        "chr10": "rgb(213, 149, 167)",
        "chr11": "rgb(146, 72, 34)",
        "chr12": "rgb(131, 123, 141)",
        "chr13": "rgb(199, 81, 39)",
        "chr14": "rgb(213, 143, 92)",
        "chr15": "rgb(122, 101, 165)",
        "chr16": "rgb(228, 175, 105)",
        "chr17": "rgb(59, 27, 83)",
        "chr18": "rgb(205, 222, 183)",
        "chr19": "rgb(97, 42, 121)",
        "chr20": "rgb(174, 31, 99)",
        "chr21": "rgb(231, 199, 111)",
        "chr22": "rgb(90, 101, 94)",
        "chr23": "rgb(204, 153, 0)",
        "chr24": "rgb(153, 204, 0)",
        "chr25": "rgb(51, 204, 0)",
        "chr26": "rgb(0, 204, 51)",
        "chr27": "rgb(0, 204, 153)",
        "chr28": "rgb(0, 153, 204)",
        "chr29": "rgb(10, 71, 255)",
        "chr30": "rgb(71, 117, 255)",
        "chr31": "rgb(255, 194, 10)",
        "chr32": "rgb(255, 209, 71)",
        "chr33": "rgb(153, 0, 51)",
        "chr34": "rgb(153, 26, 0)",
        "chr35": "rgb(153, 102, 0)",
        "chr36": "rgb(128, 153, 0)",
        "chr37": "rgb(51, 153, 0)",
        "chr38": "rgb(0, 153, 26)",
        "chr39": "rgb(0, 153, 102)",
        "chr40": "rgb(0, 128, 153)",
        "chr41": "rgb(0, 51, 153)",
        "chr42": "rgb(26, 0, 153)",
        "chr43": "rgb(102, 0, 153)",
        "chr44": "rgb(153, 0, 128)",
        "chr45": "rgb(214, 0, 71)",
        "chr46": "rgb(255, 20, 99)",
        "chr47": "rgb(0, 214, 143)",
        "chr48": "rgb(20, 255, 177)",
    };

    class ChordSetManager {

        constructor(config) {
            this.tracks = [];
            this.chordSets = [];
        }

        addChordSet(chordSet) {

            // If a chord set with this name exists replace it (same track, same region)
            this.chordSets = this.chordSets.filter(g => g.name !== chordSet.name);
            this.chordSets.push(chordSet);

            let track = this.tracks.find(t => chordSet.trackName === t.name);
            if (track) {
                track.chordSets = track.chordSets.filter(cs => cs.name !== chordSet.name);
                track.chordSets.push(chordSet);
            }
            if (!track) {
                track = new IGVTrack(chordSet);
                this.tracks.push(track);
            }
        }

        clearChords() {
            this.tracks = [];
            this.chordSets = [];
        }

        getTrack(name) {
            return this.tracks.find(t => name === t.name)
        }

        getChordSet(name) {
            return this.chordSets.find(cs => name === cs.name)
        }

    }

    class IGVTrack {
        constructor(chordSet) {
            this.name = chordSet.trackName;
            this.color = chordSet.trackColor;
            this.visible = true;
            this.chordSets = [chordSet];
            this.id = guid$1();
        }

        get chords() {
            if (this.chordSets.length === 1) {
                return this.chordSets[0].chords
            }
            const chords = [];
            for (let cs of this.chordSets) {
                for (let c of cs.chords) {
                    chords.push(c);
                }
            }
            return chords
        }
    }


    function guid$1() {
        return ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4)
    }

    const EXP5 = Math.exp(5);

    class CircularView {

        static isInstalled() {
            return window["JBrowseReactCircularGenomeView"] !== undefined && window["React"] !== undefined && window["ReactDOM"] !== undefined
        }

        /**
         * Create a new CircularView
         *
         * @param parent
         * @param config - configuration options
         *   {
         *       assembly: {name: string, id: string, chromosomes: [{name: string, bpLength: integer, color: string}]
         *       onChordClick: function called upon chord click with chord feature as argument
         *   }
         */
        constructor(parent, config) {

            config = config || {};
            this.config = config;

            if (CircularView.isInstalled()) {

                this.parent = parent;
                this.groupByTrack = config.groupByTrack === true;
                this.chordManager = new ChordSetManager(config);

                // wrapper for toolbar and circular-view container
                const wrapper = document.createElement('div');
                wrapper.className = 'igv-circview-container';
                parent.appendChild(wrapper);

                // toolbar
                this.createControls(wrapper);
                this.resetControlPanel();

                // circular view container
                const element = document.createElement('div');
                element.className = 'igv-circview-circular-genome-view';
                wrapper.appendChild(element);
                this.container = element;

                if (config.assembly) {
                    this.setAssembly(config.assembly);
                }

                this.width = config.width || 500;
                this.height = config.height || 500;
                this.setSize(this.width, this.height);

            } else {
                console.error("JBrowse circular view is not installed");
            }
        }

        createControls(parent) {

            // toolbar
            const toolbarDiv = document.createElement('div');
            toolbarDiv.className = 'igv-circview-toolbar';
            parent.appendChild(toolbarDiv);
            this.toolbar = toolbarDiv;

            // control panel
            const controlPanelDiv = document.createElement('div');
            controlPanelDiv.className = 'igv-circview-track-panel';
            parent.appendChild(controlPanelDiv);
            this.controlPanel = controlPanelDiv;
            this.controlPanel.style.display = 'none';


            // toolbar button container - Track Options - Clear All
            const buttonContainer = document.createElement('div');
            buttonContainer.className = 'igv-circview-toolbar-button-container';
            this.toolbar.appendChild(buttonContainer);

            // Show Controls
            this.showControlsButton = document.createElement('div');
            this.showControlsButton.className = 'igv-circview-button';
            buttonContainer.appendChild(this.showControlsButton);
            this.showControlsButton.innerText = 'none' === this.controlPanel.style.display ? 'Show Controls' : 'Hide Controls';
            this.showControlsButton.addEventListener('click', (event) => {
                const panelRows = this.controlPanel.querySelectorAll('div');
                if (panelRows.length > 0) {
                    if ('none' === this.controlPanel.style.display) {
                        this.controlPanel.style.display = 'flex';
                        event.target.innerText = 'Hide Controls';
                    } else {
                        this.controlPanel.style.display = 'none';
                        event.target.innerText = 'Show Controls';
                    }
                }
            });

            // Clear All
            let button = document.createElement('div');
            button.className = 'igv-circview-button';
            buttonContainer.appendChild(button);
            button.innerText = 'Clear All';
            button.addEventListener('click', () => {
                this.clearChords();
            });

            // Close
            if (false !== this.config.showCloseButton) {
                button = document.createElement('div');
                button.className = 'igv-circview-button';
                buttonContainer.appendChild(button);
                button.innerText = 'Close';
                button.addEventListener('click', () => {
                    this.visible = false;
                });
            }
        }

        resetControlPanel() {
            this.controlPanel.innerHTML = '';
            this.controlPanel.appendChild(this.createGroupByCB());
            const chordSets = this.groupByTrack ? this.chordManager.tracks : this.chordManager.chordSets;
            for(let cs of chordSets) {
                this.addToControlPanel(cs);
            }
        }

        createGroupByCB() {
            const groupByCB = document.createElement('input');
            groupByCB.type = 'checkbox';
            groupByCB.id = 'groupByCB';
            groupByCB.style.width = '1.4em';
            groupByCB.style.height = '1.4em';
            groupByCB.checked = this.groupByTrack;

            groupByCB.onclick = (evt) => {
                this.groupByTrack = evt.target.checked;
                this.resetControlPanel();
                this.render();
            };

            const groupByLabel = document.createElement('label');
            groupByLabel.for = 'groupByCB';
            groupByLabel.innerText = 'Group by track';
            groupByLabel.style.color = 'black';
            groupByLabel.style.paddingLeft = '10px';
            const trackPanelRow = document.createElement('div');
            trackPanelRow.style.width = '100%';
            trackPanelRow.style.paddingTop = '5px';
            trackPanelRow.style.paddingBottom = '5px';
            trackPanelRow.style.background = 'rgb(216, 230, 234)';
            trackPanelRow.appendChild(groupByCB);
            trackPanelRow.appendChild(groupByLabel);
            return trackPanelRow
        }

        addToControlPanel(chordSet) {

            // single track row - container for hide-button | color-picker-swatch | track-name
            const row = document.createElement('div');
            this.controlPanel.appendChild(row);


            // track hide|show
            const hideShowButton = document.createElement('div');
            hideShowButton.className = 'igv-circview-button';
            row.appendChild(hideShowButton);
            hideShowButton.innerText = true === chordSet.visible ? 'Hide' : 'Show';
            hideShowButton.addEventListener('click', event => {
                if (true === chordSet.visible) {
                    this.hideChordSet(chordSet.name);
                    event.target.innerText = "Show";
                } else {
                    this.showChordSet(chordSet.name);
                    event.target.innerText = "Hide";
                }
            });

            // The alpha range slider.  Create this here so we can reference it from the color picker
            const alphaSlider = document.createElement('input');
            const valueToAlpha = (value) => Math.exp(value / 200) / EXP5;
            const alphaToValue = (alpha) => 200 * Math.log(alpha * EXP5);

            // color
            const colorPickerButton = document.createElement('div');
            colorPickerButton.className = 'igv-circview-button';
            colorPickerButton.innerHTML = '&nbsp;&nbsp;&nbsp;&nbsp;';   // <- important for button to size properly
            row.appendChild(colorPickerButton);
            colorPickerButton.style.backgroundColor = setAlpha(chordSet.color, 1);
            const pickerConfig =
                {
                    parent: colorPickerButton,
                    popup: 'right',
                    editorFormat: 'rgb',
                    color: chordSet.color,
                    onChange: ({rgbaString}) => {
                        colorPickerButton.style.backgroundColor = setAlpha(rgbaString, 1);
                        this.setColor(chordSet.name, rgbaString);
                        alphaSlider.value = alphaToValue(getAlpha(chordSet.color));
                    }
                };
            const picker = new Picker(pickerConfig);

            // alpha transparency
            alphaSlider.setAttribute('title', 'Adjust transparency of arcs');
            alphaSlider.type = 'range';
            //alphaSlider.className = 'igv-circview-alpha-slider'
            alphaSlider.style.width = '100px';
            alphaSlider.style.marginRight = '10px';
            alphaSlider.setAttribute('class', 'range');
            alphaSlider.setAttribute('min', '0');
            alphaSlider.setAttribute('max', '1000');
            alphaSlider.value = alphaToValue(getAlpha(chordSet.color));
            alphaSlider.oninput = () => {
                const v = valueToAlpha(alphaSlider.value);
                this.setColor(chordSet.name, setAlpha(chordSet.color, v));
                picker.setColor(chordSet.color);
            };
            row.appendChild(alphaSlider);

            // track name
            const trackNameDive = document.createElement('div');
            trackNameDive.style.color = 'black';
            row.appendChild(trackNameDive);
            trackNameDive.innerText = trackNameDive.title = chordSet.name;

        }

        /**
         * Reset view with a new set of chromosomes.
         *
         * @param igvGenome {name: string, id: string, chromosomes: [{name: string, bpLength: integer, color: string}
         */
        setAssembly(igvGenome) {

            const id = this.genomeId || guid();

            if (this.genomeId === id) {
                return
            }
            this.chordManager.clearChords();
            this.genomeId = id;
            this.chrNames = new Set(igvGenome.chromosomes.map(chr => shortChrName$1(chr.name)));

            const regions = [];
            const colors = [];
            for (let chr of igvGenome.chromosomes) {
                const shortName = shortChrName$1(chr.name);
                colors.push(chr.color || getChrColor$1(shortName));
                regions.push(
                    {
                        refName: shortName,
                        uniqueId: shortName,
                        start: 0,
                        end: chr.bpLength
                    }
                );
            }

            this.assembly = {
                name: igvGenome.name,
                sequence: {
                    trackId: id,
                    type: 'ReferenceSequenceTrack',
                    adapter: {
                        type: 'FromConfigSequenceAdapter',
                        features: regions,
                    },
                },
                refNameColors: colors
            };

            this.render();

        }

        /**
         * Append or replace current set of chords to the global set or a specific track.
         *
         * @param newChords array of chord feature objects.  Example:
         * [
         *   {
         *     "uniqueId": "chr1:129763372-129763376_chr1:129806775-129806790",
         *     "color": "rgba(0, 0, 255, 0.1)",
         *     "refName": "1",
         *     "start": 129763372,
         *     "end": 129763376,
         *     "mate": {
         *       "refName": "2",
         *       "start": 129806775,
         *       "end": 129806790
         *     }
         *   }
         * ]
         * @param options {
         *     name: string,    // Track name
         *     color: string,   // Track color
         *     append: boolean  // Replace or append chords to current set.  Default is append (true)
         * }
         */

        addChords(newChords, options = {}) {

            const tmp = options.name || options.track || "*";
            const trackName = tmp.split(' ')[0].replaceAll("%20", " ");
            const chordSetName = tmp.replaceAll("%20", " ");

            const chordSet =  {
                name: chordSetName,
                trackName: trackName,
                chords: newChords,
                color: options.color || "black",
                trackColor: options.trackColor || options.color || "black",
                visible: true,
                id: options.id || guid()
            };

            this.chordManager.addChordSet(chordSet);

            this.resetControlPanel();

            this.render();
        }

        /**
         * Set the nominal size of the view in pixels.  Size is reduced some aribtrary amount to account for borders and margins
         */
        setSize(width, height) {

            height = height || width;

            this.width = width;
            this.height = height;
            if (this.viewState) {
                const view = this.viewState.session.view;
                view.setWidth(width);
                view.setHeight(height /* this is the height of the area inside the border in pixels */);
                view.setBpPerPx(view.minBpPerPx);
            }
        }

        getSize() {
            return Math.min(this.width, this.height)
        }

        clearChords() {
            //this.tracks = []
            this.chordManager.clearChords();
            this.resetControlPanel();
            this.render();
        }

        clearSelection() {
            this.viewState.pluginManager.rootModel.session.clearSelection();
        }

        /**
         * Deprecated, use "visible" property
         */
        show() {
            this.parent.style.display = 'block';
        }

        /**
         * Deprecated, use "visible" property
         */
        hide() {
            this.parent.style.display = 'none';
        }

        get visible() {
            return this.parent.style.display !== 'none'
        }

        set visible(isVisible) {
            this.parent.style.display = isVisible ? 'block' : 'none';
        }

        hideChordSet(trackName) {
            let cs = this.getChordSet(trackName);
            if (cs) {
                cs.visible = false;
                this.render();
            } else {
                console.warn(`No track with name: ${name}`);
            }
        }

        showChordSet(name) {
            let cs = this.getChordSet(name);
            if (cs) {
                cs.visible = true;
                this.render();
            } else {
                console.warn(`No track with name: ${name}`);
            }
        }

        // showTrack(trackID) {
        //     let idx = this.tracks.findIndex(t => trackID === t.id)
        //     if (idx >= 0) {
        //         const track = this.tracks[idx]
        //         track.visible = true
        //         this.tracks.splice(idx, 1)   // Change z-order
        //         this.tracks.push(track)
        //         this.render()
        //     } else {
        //         console.warn(`No track with name: ${name}`)
        //     }
        // }

        // TODO -- remove corresponding row from track panel
        deleteTrack(trackID) {
            let idx = this.tracks.findIndex(t => trackID === t.name);
            if (idx >= 0) {
                this.tracks.splice(idx, 1);
            }
            this.render();
        }

        getChordSet(name) {
            return this.groupByTrack ? this.chordManager.getTrack(name) : this.chordManager.getChordSet(name)
        }

        setColor(name, color) {
            const t = this.getChordSet(name);
            if (t) {
                t.color = color;
                const trackID = t.id;
                for (let jbrowseTrack of this.viewState.config.tracks) {
                    if (trackID === jbrowseTrack.trackId) {
                        jbrowseTrack.displays[0].renderer.strokeColor.set(color);
                        break
                    }
                }
            }
        }

        /**
         * The main render function.  Render here means build the React DOM.  Trying to change react state dynamically
         * has been buggy, so we completely rebuild the DOM ("render") on any state change.
         */
        render() {

            const {
                createViewState,
                JBrowseCircularGenomeView,
            } = JBrowseReactCircularGenomeView;

            // Remove all children from possible previous renders.  React might do this for us when we render, but just in case.
            ReactDOM.unmountComponentAtNode(this.container);

            const visibleChordSets =
                (this.groupByTrack ? this.chordManager.tracks : this.chordManager.chordSets).filter(t => t.visible);

            const jbrowseTracks = [];
            const colors = [];

            for (let chordSet of visibleChordSets) {

                jbrowseTracks.push({
                    trackId: chordSet.id,
                    name: chordSet.name,
                    assemblyNames: ['forIGV'],
                    type: 'VariantTrack',
                    adapter: {
                        type: 'FromConfigAdapter',
                        features: chordSet.chords,
                    }
                });
                colors.push(chordSet.color);
            }

            this.viewState = createViewState({
                assembly: this.assembly,
                tracks: jbrowseTracks,
            });

            // Set view colors
            for (let i = 0; i < visibleChordSets.length; i++) {
                this.viewState.config.tracks[i].displays[0].renderer.strokeColor.set(colors[i]);
                //this.viewState.config.tracks[i].displays[0].renderer.strokeColor.set("jexl:get(feature, 'color') || 'black'");
                //this.viewState.config.tracks[i].displays[0].renderer.strokeColorSelected.set("jexl:get(feature, 'highlightColor') || 'red'");
            }

            this.element = React.createElement(JBrowseCircularGenomeView, {viewState: this.viewState});
            this.setSize(this.width, this.height);

            ReactDOM.render(this.element, this.container);

            const onChordClick = this.config.onChordClick || defaultOnChordClick;
            for (let i = 0; i < visibleChordSets.length; i++) {
                this.viewState.session.view.showTrack(this.viewState.config.tracks[i].trackId);
                if (onChordClick) {
                    this.viewState.pluginManager.jexl.addFunction('onChordClick', onChordClick);
                    this.viewState.config.tracks[i].displays[0].onChordClick.set(
                        'jexl:onChordClick(feature, track, pluginManager)'
                    );
                }
            }
        }
    }

    function setAlpha(rgba, alpha) {
        const [a, b, c, ignore] = rgba.split(','); // rgba(r g b alpha)
        return `${a},${b},${c},${alpha})`
    }

    function getAlpha(rgba) {
        if (rgba.startsWith("rgba(")) {
            return Number(rgba.split(',')[3].replace(')', ''))
        } else {
            return 1
        }
    }

    function shortChrName$1(chrName) {
        return chrName.startsWith("chr") ? chrName.substring(3) : chrName
    }

    function defaultOnChordClick(feature, chordTrack, pluginManager) {
        console.log(feature);
    }

    function guid() {
        return ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4)
    }

    function embedCSS$1() {

        const css =  '.igv-circview-container {\n  width: fit-content;\n  height: fit-content;\n  box-sizing: content-box;\n  color: dimgray;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  background-color: white;\n  border-color: dimgray;\n  border-style: solid;\n  border-width: thin;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.igv-circview-toolbar {\n  position: relative;\n  width: 100%;\n  height: 32px;\n  background-color: lightgrey;\n  border-bottom-style: solid;\n  border-bottom-color: dimgray;\n  border-bottom-width: thin;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.igv-circview-toolbar-button-container {\n  height: 100%;\n  width: fit-content;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n}\n.igv-circview-toolbar-button-container > div {\n  margin: 4px;\n}\n\n.igv-circview-track-panel {\n  z-index: 1024;\n  position: absolute;\n  top: 33px;\n  left: 0;\n  width: 100%;\n  height: fit-content;\n  border-bottom-style: solid;\n  border-bottom-color: dimgray;\n  border-bottom-width: thin;\n  background-color: white;\n  display: flex;\n  flex-flow: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.igv-circview-track-panel > div {\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n}\n.igv-circview-track-panel > div > div {\n  margin: 4px;\n}\n\n.igv-circview-swatch-button {\n  cursor: pointer;\n  padding: 5px;\n  width: 8px;\n  height: 8px;\n  border: 1px solid #8d8b8b;\n  border-radius: 16px;\n}\n\n.igv-circview-button {\n  cursor: pointer;\n  padding: 5px;\n  color: #444;\n  vertical-align: middle;\n  text-align: center;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  border: 1px solid #8d8b8b;\n  border-radius: 4px;\n  background: #efefef;\n  box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.2);\n}\n\n.igv-circview-button:hover {\n  background: #efefef;\n  box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.6);\n}\n\n.igv-circview-button:active {\n  color: #007bff;\n  box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.6);\n}\n\n/*# sourceMappingURL=circular-view.css.map */\n';

        const style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.innerHTML = css;
        document.head.insertBefore(style, document.head.childNodes[ document.head.childNodes.length - 1 ]);
    }

    if(typeof document !== 'undefined') {

        if (!stylesheetExists("circular-view.css")) {
            embedCSS$1();
        }

        function stylesheetExists(stylesheetName) {
            for (let ss of document.styleSheets) {
                ss = ss.href ? ss.href.replace(/^.*[\\\/]/, '') : '';
                if (ss === stylesheetName) {
                    return true;
                }
            }
            return false;
        }
    }

    /**
     * The minimum length for a VCF structural variant.  VCF records < this length are ignored in the circular view
     * @type {number}
     */
    const MINIMUM_SV_LENGTH = 1000000;

    const shortChrName = (chrName) => {
        return chrName.startsWith("chr") ? chrName.substring(3) : chrName
    };

    const makePairedAlignmentChords = (alignments) => {

        const chords = [];
        for (let a of alignments) {

            if(a.paired) {
                if(a.firstAlignment && a.secondAlignment) {
                    chords.push({
                        uniqueId: a.readName,
                        refName: shortChrName(a.firstAlignment.chr),
                        start: a.firstAlignment.start,
                        end: a.firstAlignment.end,
                        mate: {
                            refName: shortChrName(a.secondAlignment.chr),
                            start: a.secondAlignment.start,
                            end: a.secondAlignment.end,
                        }
                    });
                }
            }
            else {
                const mate = a.mate;
                if (mate && mate.chr && mate.position) {
                    chords.push({
                        uniqueId: a.readName,
                        refName: shortChrName(a.chr),
                        start: a.start,
                        end: a.end,
                        mate: {
                            refName: shortChrName(mate.chr),
                            start: mate.position - 1,
                            end: mate.position,
                        }
                    });
                }
            }
        }
        return chords
    };

    const makeSupplementalAlignmentChords = (alignments) => {

        const makeChords = (a) => {
            const sa = a.tags()['SA'];
            const supAl = createSupplementaryAlignments(sa);
            let n = 0;
            for (let s of supAl) {
                if (s.start !== a.start) {
                    chords.push({
                        uniqueId: `${a.readName}_${n++}`,
                        refName: shortChrName(a.chr),
                        start: a.start,
                        end: a.end,
                        mate: {
                            refName: shortChrName(s.chr),
                            start: s.start,
                            end: s.start + s.lenOnRef
                        }
                    });
                }
            }
        };

        const chords = [];
        for (let a of alignments) {
            if(a.paired) {
                makeChords(a.firstAlignment);
                if(a.secondAlignment) {
                    makeChords(a.secondAlignment);
                }
            } else {
                makeChords(a);
            }
        }
        return chords
    };

    const makeBedPEChords = (features) => {

        return features.map(v => {

            // If v is a whole-genome feature, get the true underlying variant.
            const f = v._f || v;

            return {
                uniqueId: `${f.chr1}:${f.start1}-${f.end1}_${f.chr2}:${f.start2}-${f.end2}`,
                refName: shortChrName(f.chr1),
                start: f.start1,
                end: f.end1,
                mate: {
                    refName: shortChrName(f.chr2),
                    start: f.start2,
                    end: f.end2,
                }
            }
        })
    };


    const makeVCFChords = (features) => {

        const svFeatures = features.filter(v => {
            const f = v._f || v;
            const isLargeEnough = f.info && f.info.CHR2 && f.info.END &&
                (f.info.CHR2 !== f.chr || Math.abs(Number.parseInt(f.info.END) - f.pos) > MINIMUM_SV_LENGTH);
            return isLargeEnough
        });
        return svFeatures.map(v => {

            // If v is a whole-genome feature, get the true underlying variant.
            const f = v._f || v;

            const pos2 = Number.parseInt(f.info.END);
            const start2 = pos2 - 100;
            const end2 = pos2 + 100;

            return {
                uniqueId: `${f.chr}:${f.start}-${f.end}_${f.info.CHR2}:${f.info.END}`,
                refName: shortChrName(f.chr),
                start: f.start,
                end: f.end,
                mate: {
                    refName: shortChrName(f.info.CHR2),
                    start: start2,
                    end: end2
                }
            }
        })
    };

    function makeCircViewChromosomes(genome) {
        const regions = [];
        const colors = [];
        for (let chrName of genome.wgChromosomeNames) {
            const chr = genome.getChromosome(chrName);
            colors.push(getChrColor(chr.name));
            regions.push(
                {
                    name: chr.name,
                    bpLength: chr.bpLength
                }
            );
        }
        return regions
    }

    function sendChords(chords, track, refFrame, alpha) {

        const baseColor =  track.color || 'rgb(0,0,255)';

        const chordSetColor = IGVColor.addAlpha("all" === refFrame.chr ? baseColor : getChrColor(refFrame.chr), alpha);
        const trackColor = IGVColor.addAlpha(baseColor, alpha);

        // name the chord set to include locus and filtering information
        const encodedName = track.name.replaceAll(' ', '%20');
        const chordSetName = "all" === refFrame.chr ? encodedName :
            `${encodedName}  ${refFrame.chr}:${refFrame.start}-${refFrame.end}`;
        track.browser.circularView.addChords(chords, {track: chordSetName, color: chordSetColor, trackColor: trackColor});

        // show circular view if hidden
        if(!track.browser.circularViewVisible) track.browser.circularViewVisible = true;

    }


    function createCircularView(el, browser) {

        const circularView = new CircularView(el, {

            onChordClick: (feature, chordTrack, pluginManager) => {

                const f1 = feature.data;
                const f2 = f1.mate;
                addFrameForFeature(f1);
                addFrameForFeature(f2);

                function addFrameForFeature(feature) {

                    feature.chr = browser.genome.getChromosomeName(feature.refName);
                    let frameFound = false;
                    for (let referenceFrame of browser.referenceFrameList) {
                        const l = Locus.fromLocusString(referenceFrame.getLocusString());
                        if (l.contains(feature)) {
                            frameFound = true;
                            break
                        } else if (l.overlaps(feature)) {
                            referenceFrame.extend(feature);
                            frameFound = true;
                            break
                        }
                    }
                    if (!frameFound) {
                        const flanking = 2000;
                        const center = (feature.start + feature.end) / 2;
                        browser.addMultiLocusPanel(feature.chr, center - flanking, center + flanking);

                    }
                }
            }
        });

        return circularView
    }

    class PairedEndStats {

        constructor(alignments, {minTLENPercentile, maxTLENPercentile}) {
            this.totalCount = 0;
            this.frCount = 0;
            this.rfCount = 0;
            this.ffCount = 0;
            this.sumF = 0;
            this.sumF2 = 0;
            this.lp = minTLENPercentile === undefined ? 0.1 : minTLENPercentile;
            this.up = maxTLENPercentile === undefined ? 99.5 : maxTLENPercentile;
            this.isizes = [];
            this.compute(alignments);
        }

        compute(alignments) {

            for (let alignment of alignments) {
                if (alignment.isProperPair()) {
                    var tlen = Math.abs(alignment.fragmentLength);
                    this.sumF += tlen;
                    this.sumF2 += tlen * tlen;
                    this.isizes.push(tlen);

                    var po = alignment.pairOrientation;

                    if (typeof po === "string" && po.length === 4) {
                        var tmp = '' + po.charAt(0) + po.charAt(2);
                        switch (tmp) {
                            case 'FF':
                            case 'RR':
                                this.ffCount++;
                                break
                            case "FR":
                                this.frCount++;
                                break
                            case"RF":
                                this.rfCount++;
                        }
                    }
                    this.totalCount++;
                }
            }

            if (this.ffCount / this.totalCount > 0.9) this.orienation = "ff";
            else if (this.frCount / this.totalCount > 0.9) this.orienation = "fr";
            else if (this.rfCount / this.totalCount > 0.9) this.orienation = "rf";

            this.minTLEN = this.lp === 0 ? 0 : percentile(this.isizes, this.lp);
            this.maxTLEN = percentile(this.isizes, this.up);

            // var fMean = this.sumF / this.totalCount
            // var stdDev = Math.sqrt((this.totalCount * this.sumF2 - this.sumF * this.sumF) / (this.totalCount * this.totalCount))
            // this.minTLEN = fMean - 3 * stdDev
            // this.maxTLEN = fMean + 3 * stdDev

        }
    }

    function percentile(array, p) {

        if (array.length === 0) return undefined
        var k = Math.floor(array.length * (p / 100));
        array.sort(function (a, b) {
            return a - b
        });
        return array[k]

    }

    const GtexUtils = {

        getTissueInfo: function (datasetId, baseURL) {
            datasetId = datasetId || 'gtex_v8';
            baseURL = baseURL || 'https://gtexportal.org/rest/v1';
            let url = baseURL + '/dataset/tissueInfo?datasetId=' + datasetId;
            return igvxhr.loadJson(url, {})
        },

        //https://gtexportal.org/rest/v1/association/singleTissueEqtlByLocation?chromosome=7&start=98358766&end=101523798&tissueName=Liver&datasetId=gtex_v7
        //https://gtexportal.org/rest/v1/association/singleTissueEqtlByLocation?chromosome=7&start=98358766&end=101523798&tissueSiteDetailId=Liver&datasetId=gtex_v8
        trackConfiguration: function (tissueSummary, baseURL) {
            baseURL = baseURL || 'https://gtexportal.org/rest/v1';
            return {
                type: "eqtl",
                sourceType: "gtex-ws",
                url: baseURL + '/association/singleTissueEqtlByLocation',
                tissueSiteDetailId: tissueSummary.tissueSiteDetailId,
                name: (tissueSummary.tissueSiteDetailId.split('_').join(' ')),
                visibilityWindow: 250000
            }
        }
    };

    /**
     * @param feature
     * @param bpStart  genomic location of the left edge of the current canvas
     * @param xScale  scale in base-pairs per pixel
     * @returns {{px: number, px1: number, pw: number, h: number, py: number}}
     */
    function calculateFeatureCoordinates(feature, bpStart, xScale) {
        let px = (feature.start - bpStart) / xScale;
        let px1 = (feature.end - bpStart) / xScale;
        //px = Math.round((feature.start - bpStart) / xScale),
        //px1 = Math.round((feature.end - bpStart) / xScale),
        let pw = px1 - px;

        if (pw < 3) {
            pw = 3;
            px -= 1.5;
        }

        return {
            px: px,
            px1: px1,
            pw: pw
        }
    }

    /**
     *
     * @param feature
     * @param bpStart  genomic location of the left edge of the current canvas
     * @param xScale  scale in base-pairs per pixel
     * @param pixelHeight  pixel height of the current canvas
     * @param ctx  the canvas 2d context
     * @param options  genomic state
     */
    function renderFeature(feature, bpStart, xScale, pixelHeight, ctx, options) {

        try {
            ctx.save();

            // Set ctx color to a known valid color.  If getColorForFeature returns an invalid color string it is ignored, and
            // this default will be used.
            ctx.fillStyle = this.color;
            ctx.strokeStyle = this.color;

            const color = this.getColorForFeature(feature);
            ctx.fillStyle = color;
            ctx.strokeStyle = color;

            let h;
            let py;
            if (this.displayMode === "SQUISHED" && feature.row !== undefined) {
                h = this.featureHeight / 2;
                py = this.margin + this.squishedRowHeight * feature.row;
            } else if (this.displayMode === "EXPANDED" && feature.row !== undefined) {
                h = this.featureHeight;
                py = this.margin + this.expandedRowHeight * feature.row;
            } else {  // collapsed
                h = this.featureHeight;
                py = this.margin;
            }

            const pixelWidth = options.pixelWidth;   // typical 3*viewportWidth

            const cy = py + h / 2;
            const h2 = h / 2;
            const py2 = cy - h2 / 2;

            const exonCount = feature.exons ? feature.exons.length : 0;
            const coord = calculateFeatureCoordinates(feature, bpStart, xScale);
            const step = this.arrowSpacing;
            const direction = feature.strand === '+' ? 1 : feature.strand === '-' ? -1 : 0;

            if (exonCount === 0) {
                // single-exon transcript
                const xLeft = Math.max(0, coord.px);
                const xRight = Math.min(pixelWidth, coord.px1);
                const width = xRight - xLeft;
                ctx.fillRect(xLeft, py, width, h);

                // Arrows
                // Do not draw if strand is not +/-
                if (direction !== 0) {
                    ctx.fillStyle = "white";
                    ctx.strokeStyle = "white";
                    for (let x = xLeft + step / 2; x < xRight; x += step) {
                        // draw arrowheads along central line indicating transcribed orientation
                        IGVGraphics.strokeLine(ctx, x - direction * 2, cy - 2, x, cy);
                        IGVGraphics.strokeLine(ctx, x - direction * 2, cy + 2, x, cy);
                    }
                    ctx.fillStyle = color;
                    ctx.strokeStyle = color;
                }
            } else {
                // multi-exon transcript
                IGVGraphics.strokeLine(ctx, coord.px + 1, cy, coord.px1 - 1, cy); // center line for introns


                const xLeft = Math.max(0, coord.px) + step / 2;
                const xRight = Math.min(pixelWidth, coord.px1);
                for (let x = xLeft; x < xRight; x += step) {
                    // draw arrowheads along central line indicating transcribed orientation
                    IGVGraphics.strokeLine(ctx, x - direction * 2, cy - 2, x, cy);
                    IGVGraphics.strokeLine(ctx, x - direction * 2, cy + 2, x, cy);
                }
                for (let e = 0; e < exonCount; e++) {
                    // draw the exons
                    const exon = feature.exons[e];
                    let ePx = Math.round((exon.start - bpStart) / xScale);
                    let ePx1 = Math.round((exon.end - bpStart) / xScale);
                    let ePw = Math.max(1, ePx1 - ePx);
                    let ePxU;

                    if (ePx + ePw < 0) {
                        continue  // Off the left edge
                    }
                    if (ePx > pixelWidth) {
                        break // Off the right edge
                    }

                    if (exon.utr) {
                        ctx.fillRect(ePx, py2, ePw, h2); // Entire exon is UTR
                    } else {
                        if (exon.cdStart) {
                            ePxU = Math.round((exon.cdStart - bpStart) / xScale);
                            ctx.fillRect(ePx, py2, ePxU - ePx, h2); // start is UTR
                            ePw -= (ePxU - ePx);
                            ePx = ePxU;

                        }
                        if (exon.cdEnd) {
                            ePxU = Math.round((exon.cdEnd - bpStart) / xScale);
                            ctx.fillRect(ePxU, py2, ePx1 - ePxU, h2); // start is UTR
                            ePw -= (ePx1 - ePxU);
                            ePx1 = ePxU;
                        }

                        ePw = Math.max(ePw, 1);
                        ctx.fillRect(ePx, py, ePw, h);

                        // Arrows
                        if (ePw > step + 5 && direction !== 0) {
                            ctx.fillStyle = "white";
                            ctx.strokeStyle = "white";
                            for (let x = ePx + step / 2; x < ePx1; x += step) {
                                // draw arrowheads along central line indicating transcribed orientation
                                IGVGraphics.strokeLine(ctx, x - direction * 2, cy - 2, x, cy);
                                IGVGraphics.strokeLine(ctx, x - direction * 2, cy + 2, x, cy);
                            }
                            ctx.fillStyle = color;
                            ctx.strokeStyle = color;

                        }
                    }
                }
            }

            if (options.drawLabel && this.displayMode !== "SQUISHED") {
                renderFeatureLabel.call(this, ctx, feature, coord.px, coord.px1, py, options.referenceFrame, options);
            }
        } finally {
            ctx.restore();
        }
    }

    /**
     * @param ctx       the canvas 2d context
     * @param feature
     * @param featureX  feature start in pixel coordinates
     * @param featureX1 feature end in pixel coordinates
     * @param featureY  feature y-coordinate
     * @param windowX   visible window start x-coordinate
     * @param windowX1  visible window end x-coordinate
     * @param referenceFrame  genomic state
     * @param options  options
     */
    function renderFeatureLabel(ctx, feature, featureX, featureX1, featureY, referenceFrame, options) {

        try {
            ctx.save();

            let name = feature.name;
            if (name === undefined && feature.gene) name = feature.gene.name;
            if (name === undefined) name = feature.id || feature.ID;
            if (!name || name === '.') return

            let centerX = (featureX + featureX1) / 2;

            let transform;
            if (this.displayMode === "COLLAPSED" && this.labelDisplayMode === "SLANT") {
                transform = {rotate: {angle: 45}};
            }
            const labelY = getFeatureLabelY(featureY, transform);

            let color = this.getColorForFeature(feature);
            let geneColor;
            let gtexSelection = false;
            if (referenceFrame.selection && GtexUtils.gtexLoaded) {
                // TODO -- for gtex, figure out a better way to do this
                gtexSelection = true;
                geneColor = referenceFrame.selection.colorForGene(name);
            }

            const geneFontStyle = {
                textAlign: "SLANT" === this.labelDisplayMode ? undefined : 'center',
                fillStyle: geneColor || color,
                strokeStyle: geneColor || color
            };

            const textBox = ctx.measureText(name);
            const xleft = centerX - textBox.width / 2;
            const xright = centerX + textBox.width / 2;
            const lastLabelX = options.rowLastLabelX[feature.row] || -Number.MAX_SAFE_INTEGER;
            if (options.labelAllFeatures || xleft > lastLabelX || gtexSelection) {
                options.rowLastLabelX[feature.row] = xright;

                if ('y' === options.axis) {
                    ctx.save();
                    IGVGraphics.labelTransformWithContext(ctx, centerX);
                    IGVGraphics.fillText(ctx, name, centerX, labelY, geneFontStyle, transform);
                    ctx.restore();
                } else {
                    IGVGraphics.fillText(ctx, name, centerX, labelY, geneFontStyle, transform);
                }
            }

        } finally {
            ctx.restore();
        }
    }

    function getFeatureLabelY(featureY, transform) {
        return transform ? featureY + 20 : featureY + 25
    }

    // SNP constants

    const codingNonSynonSet = new Set(['nonsense', 'missense', 'stop-loss', 'frameshift', 'cds-indel']);
    const codingSynonSet = new Set(['coding-synon']);
    const spliceSiteSet = new Set(['splice-3', 'splice-5']);
    const untranslatedSet = new Set(['untranslated-5', 'untranslated-3']);


    /**
     * Renderer for a UCSC snp track
     *
     * @param snp
     * @param bpStart  genomic location of the left edge of the current canvas
     * @param xScale  scale in base-pairs per pixel
     * @param pixelHeight  pixel height of the current canvas
     * @param ctx  the canvas 2d context
     */
    function renderSnp(snp, bpStart, xScale, pixelHeight, ctx) {

        var coord = calculateFeatureCoordinates(snp, bpStart, xScale),
            py = this.margin,
            h,
            colorArrLength = this.snpColors.length,
            colorPriority;

        h = this.displayMode === "squished" ? this.squishedRowHeight : this.expandedRowHeight;

        switch (this.colorBy) {
            case 'function':
                colorPriority = colorByFunc(snp.func);
                break
            case 'class':
                colorPriority = colorByClass(snp['class']);
        }

        ctx.fillStyle = this.snpColors[colorPriority];
        ctx.fillRect(coord.px, py, coord.pw, h);

        // Coloring functions, convert a value to a priority

        function colorByFunc(theFunc) {
            var priorities;
            var funcArray = theFunc.split(',');
            // possible func values


            priorities = funcArray.map(function (func) {
                if (codingNonSynonSet.has(func) || spliceSiteSet.has(func)) {
                    return colorArrLength - 1
                } else if (codingSynonSet.has(func)) {
                    return colorArrLength - 2
                } else if (untranslatedSet.has(func)) {
                    return colorArrLength - 3
                } else { // locusSet.has(func) || intronSet.has(func)
                    return 0
                }
            });

            return priorities.reduce(function (a, b) {
                return Math.max(a, b)
            })
        }

        function colorByClass(cls) {
            if (cls === 'deletion') {
                return colorArrLength - 1
            } else if (cls === 'mnp') {
                return colorArrLength - 2
            } else if (cls === 'microsatellite' || cls === 'named') {
                return colorArrLength - 3
            } else { // cls === 'single' || cls === 'in-del' || cls === 'insertion'
                return 0
            }
        }
    }

    /**
     *
     * @param feature
     * @param bpStart  genomic location of the left edge of the current canvas
     * @param xScale  scale in base-pairs per pixel
     * @param pixelHeight  pixel height of the current canvas
     * @param ctx  the canvas 2d context
     */
    function renderFusionJuncSpan(feature, bpStart, xScale, pixelHeight, ctx) {

        const rowHeight = (this.displayMode === "EXPANDED") ? this.expandedRowHeight : this.squishedRowHeight;
        let py = this.margin;
        if (this.displayMode !== "COLLAPSED" && feature.row !== undefined) {
            py += feature.row * rowHeight;
        }

        const cy = py + 0.5 * rowHeight;
        const topY = cy - 0.5 * rowHeight;
        const bottomY = cy + 0.5 * rowHeight;

        // draw the junction arc
        const junctionLeftPx = Math.round((feature.junction_left - bpStart) / xScale);
        const junctionRightPx = Math.round((feature.junction_right - bpStart) / xScale);

        ctx.beginPath();
        ctx.moveTo(junctionLeftPx, cy);
        ctx.bezierCurveTo(junctionLeftPx, topY, junctionRightPx, topY, junctionRightPx, cy);

        ctx.lineWidth = 1 + Math.log(feature.num_junction_reads) / Math.log(2);
        ctx.strokeStyle = 'blue';
        ctx.stroke();

        // draw the spanning arcs
        const spanningCoords = feature.spanning_frag_coords;
        for (let i = 0; i < spanningCoords.length; i++) {

            const spanningInfo = spanningCoords[i];
            const spanLeftPx = Math.round((spanningInfo.left - bpStart) / xScale);
            const spanRightPx = Math.round((spanningInfo.right - bpStart) / xScale);

            ctx.beginPath();
            ctx.moveTo(spanLeftPx, cy);
            ctx.bezierCurveTo(spanLeftPx, bottomY, spanRightPx, bottomY, spanRightPx, cy);

            ctx.lineWidth = 1;
            ctx.strokeStyle = 'purple';
            ctx.stroke();
        }
    }

    const DEFAULT_COLOR$2 = 'rgb(0, 0, 150)';


    class FeatureTrack extends TrackBase {

        static defaults = {
            type: "annotation",
            maxRows: 1000, // protects against pathological feature packing cases (# of rows of overlapping feaures)
            displayMode: "EXPANDED", // COLLAPSED | EXPANDED | SQUISHED
            margin: 10,
            featureHeight: 14,
            autoHeight: false,
            useScore: false
        }


        constructor(config, browser) {
            super(config, browser);
        }

        init(config) {
            super.init(config);


            // Obscure option, not common or supoorted, included for backward compatibility
            this.labelDisplayMode = config.labelDisplayMode;

            if (config._featureSource) {
                this.featureSource = config._featureSource;
                delete config._featureSource;
            } else {
                this.featureSource = config.featureSource ?
                    config.featureSource :
                    FeatureSource(config, this.browser.genome);
            }

            if ("FusionJuncSpan" === config.type) {
                this.render = config.render || renderFusionJuncSpan;
                this.squishedRowHeight = config.squishedRowHeight || 50;
                this.expandedRowHeight = config.expandedRowHeight || 50;
                this.height = config.height || this.margin + 2 * this.expandedRowHeight;
            } else if ('snp' === config.type) {
                this.render = config.render || renderSnp;
                // colors ordered based on priority least to greatest
                this.snpColors = ['rgb(0,0,0)', 'rgb(0,0,255)', 'rgb(0,255,0)', 'rgb(255,0,0)'];
                this.colorBy = 'function';
                this.expandedRowHeight = config.expandedRowHeight || 10;
                this.squishedRowHeight = config.squishedRowHeight || 5;
                this.height = config.height || 30;
            } else {
                this.render = config.render || renderFeature;
                this.arrowSpacing = 30;
                // adjust label positions to make sure they're always visible
                monitorTrackDrag(this);
                this.squishedRowHeight = config.squishedRowHeight || 15;
                this.expandedRowHeight = config.expandedRowHeight || 30;
                this.height = config.height || this.margin + 2 * this.expandedRowHeight;

                // Set colorBy fields considering legacy options for backward compatibility
                if (config.colorBy) {
                    if (config.colorBy.field) {
                        config.colorTable = config.colorBy.pallete || config.colorBy.palette;
                        config.colorBy = config.colorBy.field;
                    }
                    this.colorBy = config.colorBy;   // Can be undefined => default
                    if (config.colorTable) {
                        this.colorTable = new ColorTable(config.colorTable);
                    } else {
                        this.colorTable = new PaletteColorTable("Set1");
                    }
                }
            }
        }

        async postInit() {

            if (typeof this.featureSource.getHeader === "function") {
                this.header = await this.featureSource.getHeader();
                if (this.disposed) return   // This track was removed during async load
            }

            // Set properties from track line
            if (this.header) {
                this.setTrackProperties(this.header);
            }

            if (this.visibilityWindow === undefined && typeof this.featureSource.defaultVisibilityWindow === 'function') {
                this.visibilityWindow = await this.featureSource.defaultVisibilityWindow();
            }

            return this

        }

        get supportsWholeGenome() {
            if (this.config.supportsWholeGenome !== undefined) {
                return this.config.supportsWholeGenome
            } else if (this.featureSource && typeof this.featureSource.supportsWholeGenome === 'function') {
                return this.featureSource.supportsWholeGenome()
            } else {
                if (this.visibilityWindow === undefined && (this.config.indexed === false || !this.config.indexURL)) {
                    return true
                }
            }
        }

        async getFeatures(chr, start, end, bpPerPixel) {
            const visibilityWindow = this.visibilityWindow;
            return this.featureSource.getFeatures({chr, start, end, bpPerPixel, visibilityWindow})
        };


        /**
         * The required height in pixels required for the track content.   This is not the visible track height, which
         * can be smaller (with a scrollbar) or larger.
         *
         * @param features
         * @returns {*}
         */
        computePixelHeight(features) {

            if (this.displayMode === "COLLAPSED") {
                return this.margin + this.expandedRowHeight
            } else {
                let maxRow = 0;
                if (features && (typeof features.forEach === "function")) {
                    for (let feature of features) {
                        if (feature.row && feature.row > maxRow) {
                            maxRow = feature.row;
                        }
                    }
                }

                const height = this.margin + (maxRow + 1) * ("SQUISHED" === this.displayMode ? this.squishedRowHeight : this.expandedRowHeight);
                return height

            }
        };

        draw(options) {

            const featureList = options.features;
            const ctx = options.context;
            const bpPerPixel = options.bpPerPixel;
            const bpStart = options.bpStart;
            const pixelWidth = options.pixelWidth;
            const pixelHeight = options.pixelHeight;
            const bpEnd = bpStart + pixelWidth * bpPerPixel + 1;


            if (!this.config.isMergedTrack) {
                IGVGraphics.fillRect(ctx, 0, options.pixelTop, pixelWidth, pixelHeight, {'fillStyle': "rgb(255, 255, 255)"});
            }

            if (featureList) {

                const rowFeatureCount = [];
                options.rowLastX = [];
                options.rowLastLabelX = [];
                for (let feature of featureList) {
                    if (feature.start > bpStart && feature.end < bpEnd) {
                        const row = this.displayMode === "COLLAPSED" ? 0 : feature.row || 0;
                        if (rowFeatureCount[row] === undefined) {
                            rowFeatureCount[row] = 1;
                        } else {
                            rowFeatureCount[row]++;
                        }
                        options.rowLastX[row] = -Number.MAX_SAFE_INTEGER;
                        options.rowLastLabelX[row] = -Number.MAX_SAFE_INTEGER;
                    }
                }
                const maxFeatureCount = Math.max(1, Math.max(...rowFeatureCount));
                const pixelsPerFeature = pixelWidth / maxFeatureCount;

                let lastPxEnd = [];
                for (let feature of featureList) {
                    if (feature.end < bpStart) continue
                    if (feature.start > bpEnd) break
                    const row = this.displayMode === 'COLLAPSED' ? 0 : feature.row;
                    options.drawLabel = options.labelAllFeatures || pixelsPerFeature > 10;
                    const pxEnd = Math.ceil((feature.end - bpStart) / bpPerPixel);
                    const last = lastPxEnd[row];
                    if (!last || pxEnd > last) {
                        this.render.call(this, feature, bpStart, bpPerPixel, pixelHeight, ctx, options);

                        // Ensure a visible gap between features
                        const pxStart = Math.floor((feature.start - bpStart) / bpPerPixel);
                        if (last && pxStart - last <= 0) {
                            ctx.globalAlpha = 0.5;
                            IGVGraphics.strokeLine(ctx, pxStart, 0, pxStart, pixelHeight, {'strokeStyle': "rgb(255, 255, 255)"});
                            ctx.globalAlpha = 1.0;
                        }
                        lastPxEnd[row] = pxEnd;
                    }
                }

            } else {
                console.log("No feature list");
            }

        };

        clickedFeatures(clickState) {

            const y = clickState.y - this.margin;
            const allFeatures = super.clickedFeatures(clickState);

            let row;
            switch (this.displayMode) {
                case 'SQUISHED':
                    row = Math.floor(y / this.squishedRowHeight);
                    break
                case 'EXPANDED':
                    row = Math.floor(y / this.expandedRowHeight);
                    break
                default:
                    row = undefined;
            }

            return allFeatures.filter(function (feature) {
                return (row === undefined || feature.row === undefined || row === feature.row)
            })
        }

        /**
         * Return "popup data" for feature @ genomic location.  Data is an array of key-value pairs
         */
        popupData(clickState, features) {

            if (features === undefined) features = this.clickedFeatures(clickState);
            const genomicLocation = clickState.genomicLocation;
            const data = [];
            for (let feature of features) {

                // Whole genome hack, whole-genome psuedo features store the "real" feature in an _f field
                const f = feature._f || feature;

                const featureData = (typeof f.popupData === "function") ?
                    f.popupData(genomicLocation) :
                    this.extractPopupData(f);

                if (featureData) {

                    if (data.length > 0) {
                        data.push("<hr/><hr/>");
                    }

                    // If we have an infoURL, find the name property and create the link.  We do this at this level
                    // to catch name properties in both custom popupData functions and the generic extractPopupData function

                    const infoURL = this.infoURL || this.config.infoURL;
                    for (let fd of featureData) {
                        data.push(fd);
                        if (infoURL &&
                            fd.name &&
                            fd.name.toLowerCase() === "name" &&
                            fd.value &&
                            isString$2(fd.value) &&
                            !fd.value.startsWith("<")) {
                            const href = infoURL.replace("$$", feature.name);
                            fd.value = `<a target=_blank href=${href}>${fd.value}</a>`;
                        }
                    }


                    //Array.prototype.push.apply(data, featureData);

                    // If we have clicked over an exon number it.
                    // Disabled for GFF and GTF files if the visibility window is < the feature length since we don't know if we have all exons
                    const isGFF = "gff" === this.config.format || "gff3" === this.config.format || "gtf" === this.config.format;
                    if (f.exons) {
                        for (let i = 0; i < f.exons.length; i++) {
                            const exon = f.exons[i];
                            if (genomicLocation >= exon.start && genomicLocation <= exon.end) {
                                const exonNumber = isGFF ?
                                    exon.number :
                                    f.strand === "-" ? f.exons.length - i : i + 1;
                                if (exonNumber) {
                                    data.push('<hr/>');
                                    data.push({name: "Exon Number", value: exonNumber});
                                }
                                break
                            }
                        }
                    }
                }
            }

            return data

        }

        menuItemList() {

            const menuItems = [];

            if (this.render === renderSnp) {
                menuItems.push('<hr/>');
                for (let colorScheme of ["function", "class"]) {
                    menuItems.push({
                        object: $$1(createCheckbox('Color by ' + colorScheme, colorScheme === this.colorBy)),
                        click: () => {
                            this.colorBy = colorScheme;
                            this.trackView.repaintViews();
                        }
                    });
                }
            }

            menuItems.push('<hr/>');
            for (let displayMode of ["COLLAPSED", "SQUISHED", "EXPANDED"]) {
                const lut =
                    {
                        "COLLAPSED": "Collapse",
                        "SQUISHED": "Squish",
                        "EXPANDED": "Expand"
                    };

                menuItems.push(
                    {
                        object: $$1(createCheckbox(lut[displayMode], displayMode === this.displayMode)),
                        click: () => {
                            this.displayMode = displayMode;
                            this.config.displayMode = displayMode;
                            this.trackView.checkContentHeight();
                            this.trackView.repaintViews();
                        }
                    });
            }

            return menuItems

        };


        contextMenuItemList(clickState) {

            const features = this.clickedFeatures(clickState);

            if (undefined === features || 0 === features.length) {
                return undefined
            }

            if (features.length > 1) {
                features.sort((a, b) => (b.end - b.start) - (a.end - a.start));
            }
            const f = features[0];   // The shortest clicked feature

            if ((f.end - f.start) <= 1000000) {
                const list = [{
                    label: 'View feature sequence',
                    click: async () => {
                        let seq = await this.browser.genome.getSequence(f.chr, f.start, f.end);
                        if (!seq) {
                            seq = "Unknown sequence";
                        } else if (f.strand === '-') {
                            seq = reverseComplementSequence(seq);
                        }
                        this.browser.alert.present(seq);

                    }
                }];

                if (isSecureContext() && navigator.clipboard !== undefined) {
                    list.push(
                        {
                            label: 'Copy feature sequence',
                            click: async () => {
                                let seq = await this.browser.genome.getSequence(f.chr, f.start, f.end);
                                if (!seq) {
                                    seq = "Unknown sequence";
                                } else if (f.strand === '-') {
                                    seq = reverseComplementSequence(seq);
                                }
                                try {
                                    await navigator.clipboard.writeText(seq);
                                } catch (e) {
                                    console.error(e);
                                    this.browser.alert.present(`error copying sequence to clipboard ${e}`);
                                }
                            }
                        }
                    );
                }
                list.push('<hr/>');
                return list
            } else {
                return undefined
            }
        }

        description() {

            // if('snp' === this.type) {
            if (renderSnp === this.render) {
                let desc = "<html>" + this.name + '<hr/>';
                desc += '<em>Color By Function:</em><br>';
                desc += '<span style="color:red">Red</span>: Coding-Non-Synonymous, Splice Site<br>';
                desc += '<span style="color:green">Green</span>: Coding-Synonymous<br>';
                desc += '<span style="color:blue">Blue</span>: Untranslated<br>';
                desc += '<span style="color:black">Black</span>: Intron, Locus, Unknown<br><br>';
                desc += '<em>Color By Class:</em><br>';
                desc += '<span style="color:red">Red</span>: Deletion<br>';
                desc += '<span style="color:green">Green</span>: MNP<br>';
                desc += '<span style="color:blue">Blue</span>: Microsatellite, Named<br>';
                desc += '<span style="color:black">Black</span>: Indel, Insertion, SNP';
                desc += "</html>";
                return desc
            } else {
                return super.description()
            }

        };

        /**
         * Return color for feature.
         * @param feature
         * @returns {string}
         */

        getColorForFeature(feature) {

            let color;
            if (this.altColor && "-" === feature.strand) {
                color = (typeof this.altColor === "function") ? this.altColor(feature) : this.altColor;
            } else if (this.color) {
                color = (typeof this.color === "function") ? this.color(feature) : this.color;  // Explicit setting via menu, or possibly track line if !config.color
            } else if (this.colorBy) {
                const value = feature.getAttributeValue ?
                    feature.getAttributeValue(this.colorBy) :
                    feature[this.colorBy];
                color = this.colorTable.getColor(value);
            } else if (feature.color) {
                color = feature.color;   // Explicit color for feature
            }

            // If no explicit setting use the default
            if (!color) {
                color = DEFAULT_COLOR$2;   // Track default
            }

            if (feature.alpha && feature.alpha !== 1) {
                color = IGVColor.addAlpha(color, feature.alpha);
            } else if (this.useScore && feature.score && !Number.isNaN(feature.score)) {
                // UCSC useScore option, for scores between 0-1000.  See https://genome.ucsc.edu/goldenPath/help/customTrack.html#TRACK
                const min = this.config.min ? this.config.min : this.viewLimitMin ? this.viewLimitMin : 0;
                const max = this.config.max ? this.config.max : this.viewLimitMax ? this.viewLimitMax : 1000;
                const alpha = getAlpha(min, max, feature.score);
                feature.alpha = alpha;    // Avoid computing again
                color = IGVColor.addAlpha(color, alpha);
            }


            function getAlpha(min, max, score) {
                const binWidth = (max - min) / 9;
                const binNumber = Math.floor((score - min) / binWidth);
                return Math.min(1.0, 0.2 + (binNumber * 0.8) / 9)
            }

            return color
        }


        /**
         * Called when the track is removed.  Do any needed cleanup here
         */
        dispose() {
            this.trackView = undefined;
        }
    }

    /**
     * Monitors track drag events, updates label position to ensure that they're always visible.
     * @param track
     */
    function monitorTrackDrag(track) {

        if (track.browser.on) {
            track.browser.on('trackdragend', onDragEnd);
            track.browser.on('trackremoved', unSubscribe);
        }

        function onDragEnd() {
            if (track.trackView && track.displayMode !== "SQUISHED") {
                track.trackView.updateViews();      // TODO -- refine this to the viewport that was dragged after DOM refactor
            }
        }

        function unSubscribe(removedTrack) {
            if (track.browser.un && track === removedTrack) {
                track.browser.un('trackdragend', onDragEnd);
                track.browser.un('trackremoved', unSubscribe);
            }
        }

    }

    class RegionTableBase {
        constructor(config) {

            this.config = config;

            this.browser = config.browser;

            this.columnFormat = config.columnFormat;

            this.tableRowSelectionList = [];

            this.tableDOM = domUtils.div({ class: 'igv-roi-table' });
            // if(config.width) {
            //     let [ w ] = config.width.split('px')
            //     w = parseInt(w, 10)
            //     this.tableDOM.style.width = `${Math.min(w, 1600)}px`
            //
            // }

            config.parent.appendChild(this.tableDOM);

            this.headerDOM = config;

            this.tableColumnTitles = this.tableDOM;

            this.tableRowContainer = this.tableDOM;

            this.footerDOM = config.gotoButtonHandler;

        }

        set headerDOM({ browser, parent, headerTitle, dismissHandler }) {

            // header
            const dom = domUtils.div();
            this.tableDOM.appendChild(dom);

            // header title
            const div = domUtils.div();
            dom.appendChild(div);
            div.innerHTML = headerTitle;

            // table dismiss button
            const dismiss = domUtils.div();
            dom.appendChild(dismiss);
            dismiss.appendChild(icons$1.createIcon('times'));

            this.boundDismissHandler = mouseClickHandler.bind(this);

            dismiss.addEventListener('click', this.boundDismissHandler);

            function mouseClickHandler (event) {
                event.stopPropagation();
                dismissHandler();
            }

            const { y:y_root } = browser.root.getBoundingClientRect();
            const { y:y_parent } = parent.getBoundingClientRect();
            const constraint = -(y_parent - y_root);
            makeDraggable(this.tableDOM, dom, { minX:0, minY:constraint });

            this.tableDOM.style.display = 'none';

            this._headerDOM = dom;

        }

        set tableColumnTitles(tableDOM) {

            const tblColumnTitles = domUtils.div({ class: 'igv-roi-table-column-titles' });
            tableDOM.appendChild(tblColumnTitles);

            for (const { label, width } of this.columnFormat) {
                const col = domUtils.div();
                tblColumnTitles.appendChild(col);
                col.style.width = width;
                col.innerText = label;
            }

            this._tableColumnTitlesDOM = tblColumnTitles;

        }

        get tableColumnTitles() {
            return this._tableColumnTitlesDOM
        }

        set tableRowContainer(container) {

            const tblRowContainer = domUtils.div({ class: 'igv-roi-table-row-container' });
            container.appendChild(tblRowContainer);

            this._tableRowContainerDOM = tblRowContainer;

        }

        get tableRowContainer() {
            return this._tableRowContainerDOM
        }

        set footerDOM(gotoButtonHandler) {

            const dom = domUtils.div();
            this.tableDOM.appendChild(dom);

            // Go To Button
            const gotoButton = domUtils.div({class: 'igv-roi-table-button'});
            dom.appendChild(gotoButton);

            gotoButton.id = 'igv-roi-table-view-button';
            gotoButton.textContent = 'Go To';
            gotoButton.style.pointerEvents = 'none';

            this._footerDOM = dom;

            this.gotoButton = gotoButton;

            this.boundGotoButtonHandler = gotoButtonHandler.bind(this);

            this.gotoButton.addEventListener('click', this.boundGotoButtonHandler);

        }

        tableRowDOMHelper(dom) {

            dom.addEventListener('mousedown', event => {
                event.stopPropagation();

                dom.classList.toggle('igv-roi-table-row-selected');
                dom.classList.contains('igv-roi-table-row-selected') ? dom.classList.remove('igv-roi-table-row-hover') : dom.classList.add('igv-roi-table-row-hover');

                this.setTableRowSelectionState(dom.classList.contains('igv-roi-table-row-selected'));
            });

            dom.addEventListener('mouseover', e => {
                dom.classList.contains('igv-roi-table-row-selected') ? dom.classList.remove('igv-roi-table-row-hover') : dom.classList.add('igv-roi-table-row-hover');
            });

            dom.addEventListener('mouseout', e => {
                dom.classList.remove('igv-roi-table-row-hover');
            });

        }

        clearTable() {
            const elements = this.tableRowContainer.querySelectorAll('.igv-roi-table-row');
            for (let el of elements) {
                el.remove();
            }
        }

        setTableRowSelectionState(isTableRowSelected) {
            isTableRowSelected ? this.tableRowSelectionList.push(1) : this.tableRowSelectionList.pop();
            this.gotoButton.style.pointerEvents = this.tableRowSelectionList.length > 0 ? 'auto' : 'none';
        }

        present() {
            this.tableDOM.style.left = `${ 0 }px`;

            const { y:y_root } = this.browser.root.getBoundingClientRect();
            const { y:y_parent } = this.config.parent.getBoundingClientRect();

            this.tableDOM.style.top  = `${ y_root - y_parent }px`;
            this.tableDOM.style.display = 'flex';
        }

        dismiss() {
            this.tableDOM.style.display = 'none';
        }

        dispose() {

            this.tableDOM.innerHTML = '';
            this.tableDOM.remove();

            for (const key of Object.keys(this)) {
                this[key] = undefined;
            }

            document.removeEventListener('click', this.boundDismissHandler);

        }

    }

    class BlatTable extends RegionTableBase {

        constructor(config) {

            const cooked = Object.assign({ 'width':'1024px' }, config);
            super(cooked);

            this.descriptionDOM = config;

        }

        set descriptionDOM(config) {

            if (config.description) {

                let dom;

                // BLAT result for query sequence
                dom = domUtils.div({ class: 'igv-roi-table-description' });
                this.tableDOM.insertBefore(dom, this.tableColumnTitles);
                dom.style.height = 'auto';
                dom.innerHTML = `BLAT result for query sequence:`;

                // CTAATCAtctacactggtttctactg ...
                dom = domUtils.div({ class: 'igv-roi-table-description' });
                this.tableDOM.insertBefore(dom, this.tableColumnTitles);
                dom.style.height = 'auto';
                dom.style.maxHeight = '128px';
                dom.innerHTML = config.description;

                // Select one or more rows ...
                dom = domUtils.div({ class: 'igv-roi-table-goto-explainer' });
                this.tableDOM.insertBefore(dom, this.tableColumnTitles);
                dom.innerHTML = `Select one or more rows and click Go To to view the regions`;

            }

        }

        tableRowDOM(record) {

            const dom = domUtils.div({ class: 'igv-roi-table-row' });

            const pretty = record.map(item => isFinite(item) ? numberFormatter$1(item) : item);

            for (let i = 0; i < pretty.length; i++) {

                const el = domUtils.div();
                dom.appendChild(el);

                const format = this.columnFormat[ i ];
                el.style.width = format.width || 'fit-content';
                el.innerText = pretty[ i ];
            }

            this.tableRowDOMHelper(dom);

            return dom
        }

        renderTable(records) {

            Array.from(this.tableRowContainer.querySelectorAll('.igv-roi-table-row')).forEach(el => el.remove());

            if (records.length > 0) {

                for (let record of records) {
                    const row = this.tableRowDOM(record);
                    this.tableRowContainer.appendChild(row);
                }

            }

        }

        static getColumnFormatConfiguration() {

            /*
            return [
                { label:         'chr', width: '60px' },
                { label:       'start', width: '100px' },
                { label:         'end', width: '100px' },
                { label:      'strand', width: '50px' },
                { label:       'score', width: '50px' },
                { label:       'match', width: '50px' },
                { label:   "mis-match", width: '70px' },
                { label:  "rep. match", width: '70px' },
                { label:         "N's", width: '32px' },
                { label: 'Q gap count', width: '90px' },
                { label: 'Q gap bases', width: '90px' },
                { label: 'T gap count', width: '90px' },
                { label: 'T gap bases', width: '90px' },
            ]
            */

            return [
                { label:         'chr', width: '7%' },
                { label:       'start', width: '12%' },
                { label:         'end', width: '12%' },
                { label:      'strand', width: '5%' },
                { label:       'score', width: '5%' },
                { label:       'match', width: '5%' },
                { label:   "mis-match", width: '7%' },
                { label:  "rep. match", width: '7%' },
                { label:         "N's", width: '3%' },
                { label: 'Q gap count', width: '9%' },
                { label: 'Q gap bases', width: '9%' },
                { label: 'T gap count', width: '9%' },
                { label: 'T gap bases', width: '9%' },
            ]
        }

        static gotoButtonHandler (event) {

            event.stopPropagation();

            const selectedRows = this.tableDOM.querySelectorAll('.igv-roi-table-row-selected');

            const loci = [];
            for (const row of selectedRows) {

                const record = [];
                row.querySelectorAll('div').forEach(el => record.push(el.innerText));

                const [ chr, start, end ] = record;
                loci.push(`${ chr }:${ start }-${ end }`);
            }

            for (const el of this.tableDOM.querySelectorAll('.igv-roi-table-row')) {
                el.classList.remove('igv-roi-table-row-selected');
            }

            this.setTableRowSelectionState(false);

            this.browser.search(loci.join(' '));

            // console.log(`browser search( ${loci.join(' ')} )`)

        }

    }

    /*
    http://genome.ucsc.edu/cgi-bin/hgBlat
    ?userSeq=CTAATCAtctacactggtttctactgaaatgtctgttgtcatagacttaattgtgtcttcagatacagcagttctgttatttctgagttttacctggggcaagagaatctttagcaagtttaaaggcacctatatctggaatcacccctccctccagatgaatatcacagactctcccattaaaggtcttgccTTCCTTGATAGCATCATCACTCCA
    &type=DNA
    &db=hg38
    &output=json
     */

    //const blatServer = "https://genome.ucsc.edu/cgi-bin/hgBlat"
    const defaultBlatServer = "https://igv.org/services/blatUCSC.php";
    //const blatServer = "http://localhost:8000/blatUCSC.php"


    async function blat({url, userSeq, db}) {

        url = url || defaultBlatServer;

        const results = await postData(url, userSeq, db);

        results.fields;

        const features = results.blat.map(decodePSL);

        return features
    }

    async function postData(url = "", userSeq, db) {

        const data = new URLSearchParams();
        data.append("userSeq", userSeq);
        data.append("db", db);

        const response = await fetch(url, { method: "post", body: data });
        return response.json(); // parses JSON response into native JavaScript objects
    }

    const maxSequenceSize = 25000;

    class BlatTrack extends FeatureTrack {

        constructor(config, browser) {
            super(config, browser);
            if (!this.name) {
                this.name = 'Blat Results';
            }
            this.sequence = config.sequence;
            this.table = undefined;
        }

        openTableView() {

            if (undefined === this.table) {

                const rows = this.config.features.map(f => [
                    f.chr,
                    (f.start + 1),
                    f.end,
                    f.strand,
                    f.score,
                    f.matches,
                    f.misMatches,
                    f.repMatches,
                    f.nCount,
                    f.qNumInsert,
                    f.qBaseInsert,
                    f.tNumInsert,
                    f.tBaseInsert
                ]);

                const config =
                    {
                        browser: this.browser,
                        parent: this.browser.parent,
                        headerTitle: this.config.title,
                        description: this.sequence,
                        dismissHandler: () => {
                            this.table.dismiss();
                            this.table.dispose();
                            this.table = undefined;
                        },
                        columnFormat: BlatTable.getColumnFormatConfiguration(),
                        gotoButtonHandler: BlatTable.gotoButtonHandler
                    };

                this.table = new BlatTable(config);
                this.table.renderTable(rows);
            }

            this.table.present();

        }

        menuItemList() {

            const menuItems = super.menuItemList();

            menuItems.push('<hr/>');
            menuItems.push({
                label: 'Open table view',
                click: () => this.openTableView()
            });
            return menuItems
        }


        /**
         * Track has been permanently removed.  Release resources and other cleanup
         */
        dispose() {
            super.dispose();
            // Release DOM element for table
            if (this.table) {
                this.table.popover.parentElement.removeChild(this.table.popover);

            }


        }
    }


    async function createBlatTrack({sequence, browser, name, title}) {

        if (sequence.length > maxSequenceSize) {
            browser.alert.present(`Sequence size exceeds maximum allowed length (${sequence.length} > ${maxSequenceSize})`);
            return
        }

        const db = browser.genome.id;   // TODO -- blat specific property

        const url = browser.config["blatServerURL"];

        try {

            const features = await blat({url, userSeq: sequence, db});
            const trackConfig = {
                type: 'blat',
                name: name || 'blat results',
                title: title || 'blat results',
                sequence: sequence,
                altColor: 'rgb(176, 176, 236)',
                color: 'rgb(236, 176, 176)',
                features: features
            };

            const track = await browser.loadTrack(trackConfig);
            track.openTableView();

        } catch (e) {
            browser.alert.present(`Error performing blat search:  ${e}`);
        }

    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const alignmentStartGap = 5;
    const downsampleRowHeight = 5;
    const DEFAULT_ALIGNMENT_COLOR = "rgb(185, 185, 185)";
    const DEFAULT_COVERAGE_COLOR = "rgb(150, 150, 150)";
    const DEFAULT_CONNECTOR_COLOR = "rgb(200, 200, 200)";
    const MINIMUM_BLAT_LENGTH = 20;

    class BAMTrack extends TrackBase {

        static defaults = {
            alleleFreqThreshold: 0.2,
            visibilityWindow: 30000,
            showCoverage: true,
            showAlignments: true,
            viewAsPairs: false,
            pairsSupported: true,
            showSoftClips: false,
            showAllBases: false,
            showInsertions: true,
            showMismatches: true,
            height: 300,
            coverageTrackHeight: 50
        }

        constructor(config, browser) {
            super(config, browser);
        }

        init(config) {

            this.type = "alignment";
            this.featureSource = new BamSource(config, this.browser);
            this.coverageTrack = new CoverageTrack(config, this);
            this.alignmentTrack = new AlignmentTrack(config, this);

            super.init(config);

            this.alignmentTrack.setTop(this.coverageTrack, this.showCoverage);

            if(!this.showAlignments) {
                this._height = this.coverageTrackHeight;
            }

            // The sort object can be an array in the case of multi-locus view, however if multiple sort positions
            // are present for a given reference frame the last one will take precedence
            if (config.sort) {
                if (Array.isArray(config.sort)) {
                    // Legacy support
                    this.assignSort(config.sort[0]);
                } else {
                    this.assignSort(config.sort);
                }
            }

        }

        set height(h) {
            this._height = h;
            if (this.showAlignments) {
                this.alignmentTrack.height = this.showCoverage ? h - this.coverageTrackHeight : h;
            }
        }

        get height() {
            return this._height
        }

        get minTemplateLength() {
            const configMinTLEN = this.config.minTLEN !== undefined ? this.config.minTLEN : this.config.minFragmentLength;
            return (configMinTLEN !== undefined) ? configMinTLEN :
                this._pairedEndStats ? this._pairedEndStats.minTLEN : 0
        }

        get maxTemplateLength() {
            const configMaxTLEN = this.config.maxTLEN !== undefined ? this.config.maxTLEN : this.config.maxFragmentLength;
            return (configMaxTLEN !== undefined) ? configMaxTLEN :
                this._pairedEndStats ? this._pairedEndStats.maxTLEN : 1000
        }

        sort(options) {
            options = this.assignSort(options);

            for (let vp of this.trackView.viewports) {
                if (vp.containsPosition(options.chr, options.position)) {
                    const alignmentContainer = vp.cachedFeatures;
                    if (alignmentContainer) {
                        alignmentContainer.sortRows(options);
                        vp.repaint();
                    }
                }
            }
        }

        /**
         * Fix syntax problems for sort options.
         * @param options
         */
        assignSort(options) {
            // convert old syntax
            if (options.locus) {
                const range = parseLocusString$1(options.locus);
                options.chr = range.chr;
                options.position = range.start;
            } else {
                options.position--;
            }
            options.direction = options.direction === "ASC" || options.direction === true;

            // chr aliasing
            options.chr = this.browser.genome.getChromosomeName(options.chr);
            this.sortObject = options;

            return this.sortObject
        }

        async getFeatures(chr, bpStart, bpEnd, bpPerPixel, viewport) {

            const alignmentContainer = await this.featureSource.getAlignments(chr, bpStart, bpEnd);

            if (alignmentContainer.paired && !this._pairedEndStats && !this.config.maxFragmentLength) {
                const pairedEndStats = new PairedEndStats(alignmentContainer.alignments, this.config);
                if (pairedEndStats.totalCount > 99) {
                    this._pairedEndStats = pairedEndStats;
                }
            }
            alignmentContainer.alignments = undefined;  // Don't need to hold onto these anymore

            const sort = this.sortObject;
            if (sort) {
                if (sort.chr === chr && sort.position >= bpStart && sort.position <= bpEnd) {
                    alignmentContainer.sortRows(sort);
                }
            }

            return alignmentContainer
        }


        /**
         * Compute the pixel height required to display all content.  This is not the same as the viewport height
         * (track.height) which might include a scrollbar.
         *
         * @param alignmentContainer
         * @returns {number}
         */
        computePixelHeight(alignmentContainer) {
            return (this.showCoverage ? this.coverageTrackHeight : 0) +
                (this.showAlignments ? this.alignmentTrack.computePixelHeight(alignmentContainer) : 0)
        }

        draw(options) {

            IGVGraphics.fillRect(options.context, 0, options.pixelTop, options.pixelWidth, options.pixelHeight, {'fillStyle': "rgb(255, 255, 255)"});

            if (true === this.showCoverage && this.coverageTrackHeight > 0) {
                this.trackView.axisCanvas.style.display = 'block';
                this.coverageTrack.draw(options);
            } else {
                this.trackView.axisCanvas.style.display = 'none';
            }

            if (true === this.showAlignments) {
                this.alignmentTrack.setTop(this.coverageTrack, this.showCoverage);
                this.alignmentTrack.draw(options);
            }
        }

        paintAxis(ctx, pixelWidth, pixelHeight) {

            this.coverageTrack.paintAxis(ctx, pixelWidth, this.coverageTrackHeight);

            // if (this.browser.isMultiLocusMode()) {
            //     ctx.clearRect(0, 0, pixelWidth, pixelHeight);
            // } else {
            //     this.coverageTrack.paintAxis(ctx, pixelWidth, this.coverageTrackHeight);
            // }
        }

        contextMenuItemList(config) {
            return this.alignmentTrack.contextMenuItemList(config)
        }

        popupData(clickState) {
            if (true === this.showCoverage && clickState.y >= this.coverageTrack.top && clickState.y < this.coverageTrackHeight) {
                return this.coverageTrack.popupData(clickState)
            } else {
                return this.alignmentTrack.popupData(clickState)
            }
        }

        /**
         * Return the features (alignment, coverage, downsampled interval) clicked on.  Needed for "onclick" event.
         * @param clickState
         * @param features
         */
        clickedFeatures(clickState) {

            let clickedObject;
            if (true === this.showCoverage && clickState.y >= this.coverageTrack.top && clickState.y < this.coverageTrackHeight) {
                clickedObject = this.coverageTrack.getClickedObject(clickState);
            } else {
                clickedObject = this.alignmentTrack.getClickedObject(clickState);
            }
            return clickedObject ? [clickedObject] : undefined
        }

        hoverText(clickState) {
            if (true === this.showCoverage && clickState.y >= this.coverageTrack.top && clickState.y < this.coverageTrackHeight) {
                const clickedObject = this.coverageTrack.getClickedObject(clickState);
                if (clickedObject) {
                    return clickedObject.hoverText()
                }
            }

        }

        menuItemList() {


            // Start with overage track items
            let menuItems = [];

            menuItems = menuItems.concat(MenuUtils.numericDataMenuItems(this.trackView));

            // Color by items
            menuItems.push('<hr/>');
            const $e = $$1('<div class="igv-track-menu-category">');
            $e.text('Color by:');
            menuItems.push({name: undefined, object: $e, click: undefined, init: undefined});

            const colorByMenuItems = [{key: 'strand', label: 'read strand'}];
            if (this.alignmentTrack.hasPairs) {
                colorByMenuItems.push({key: 'firstOfPairStrand', label: 'first-of-pair strand'});
                colorByMenuItems.push({key: 'pairOrientation', label: 'pair orientation'});
                colorByMenuItems.push({key: 'tlen', label: 'insert size (TLEN)'});
                colorByMenuItems.push({key: 'unexpectedPair', label: 'pair orientation & insert size (TLEN)'});
            }
            const tagLabel = 'tag' + (this.alignmentTrack.colorByTag ? ' (' + this.alignmentTrack.colorByTag + ')' : '');
            colorByMenuItems.push({key: 'tag', label: tagLabel});
            for (let item of colorByMenuItems) {
                const selected = (this.alignmentTrack.colorBy === item.key);
                menuItems.push(this.colorByCB(item, selected));
            }

            // Show coverage / alignment options
            const adjustTrackHeight = () => {
                if (!this.autoHeight) {
                    const h =
                        (this.showCoverage ? this.coverageTrackHeight : 0) +
                        (this.showAlignments ? this.alignmentTrack.height : 0);
                    this.trackView.setTrackHeight(h);
                }
            };

            menuItems.push('<hr/>');
            menuItems.push({
                object: $$1(createCheckbox("Show Coverage", this.showCoverage)),
                click: () => {
                    this.showCoverage = !this.showCoverage;
                    adjustTrackHeight();
                    this.trackView.checkContentHeight();
                    this.trackView.repaintViews();
                }
            });
            menuItems.push({
                object: $$1(createCheckbox("Show Alignments", this.showAlignments)),
                click: () => {
                    this.showAlignments = !this.showAlignments;
                    adjustTrackHeight();
                    this.trackView.checkContentHeight();
                    this.trackView.repaintViews();
                }
            });

            // Show all bases
            menuItems.push('<hr/>');
            menuItems.push({
                object: $$1(createCheckbox("Show all bases", this.showAllBases)),
                click: () => {
                    this.showAllBases = !this.showAllBases;
                    this.config.showAllBases = this.showAllBases;
                    this.trackView.repaintViews();
                }
            });

            // Show mismatches
            menuItems.push('<hr/>');
            menuItems.push({
                object: $$1(createCheckbox("Show mismatches", this.showMismatches)),
                click: () => {
                    this.showMismatches = !this.showMismatches;
                    this.config.showMismatches = this.showMismatches;
                    this.trackView.repaintViews();
                }
            });

            // Insertions
            menuItems.push({
                object: $$1(createCheckbox("Show insertions", this.showInsertions)),
                click: () => {
                    this.showInsertions = !this.showInsertions;
                    this.config.showInsertions = this.showInsertions;
                    this.getCachedAlignmentContainers();
                    this.trackView.repaintViews();
                }
            });

            // Soft clips
            menuItems.push({
                object: $$1(createCheckbox("Show soft clips", this.showSoftClips)),
                click: () => {
                    this.showSoftClips = !this.showSoftClips;
                    this.config.showSoftClips = this.showSoftClips;
                    this.featureSource.setShowSoftClips(this.showSoftClips);
                    const alignmentContainers = this.getCachedAlignmentContainers();
                    for (let ac of alignmentContainers) {
                        ac.setShowSoftClips(this.showSoftClips);
                    }
                    this.trackView.repaintViews();
                }
            });

            // View as pairs
            if (this.pairsSupported && this.alignmentTrack.hasPairs) {
                menuItems.push('<hr/>');
                menuItems.push({
                    object: $$1(createCheckbox("View as pairs", this.viewAsPairs)),
                    click: () => {
                        this.viewAsPairs = !this.viewAsPairs;
                        this.config.viewAsPairs = this.viewAsPairs;
                        this.featureSource.setViewAsPairs(this.viewAsPairs);
                        const alignmentContainers = this.getCachedAlignmentContainers();
                        for (let ac of alignmentContainers) {
                            ac.setViewAsPairs(this.viewAsPairs);
                        }
                        this.trackView.repaintViews();
                    }
                });
            }

            // Add chords to JBrowse circular view, if present
            if (this.browser.circularView &&
                (this.alignmentTrack.hasPairs || this.alignmentTrack.hasSupplemental)) {
                menuItems.push('<hr/>');
                if (this.alignmentTrack.hasPairs) {
                    menuItems.push({
                        label: 'Add discordant pairs to circular view',
                        click: () => {
                            for (let viewport of this.trackView.viewports) {
                                this.addPairedChordsForViewport(viewport);
                            }
                        }
                    });
                }
                if (this.alignmentTrack.hasSupplemental) {
                    menuItems.push({
                        label: 'Add split reads to circular view',
                        click: () => {
                            for (let viewport of this.trackView.viewports) {
                                this.addSplitChordsForViewport(viewport);
                            }
                        }
                    });
                }
            }


            // Display mode
            menuItems.push('<hr/>');
            const $dml = $$1('<div class="igv-track-menu-category">');
            $dml.text('Display mode:');
            menuItems.push({name: undefined, object: $dml, click: undefined, init: undefined});

            menuItems.push({
                object: $$1(createCheckbox("expand", this.alignmentTrack.displayMode === "EXPANDED")),
                click: () => {
                    this.alignmentTrack.displayMode = "EXPANDED";
                    this.config.displayMode = "EXPANDED";
                    this.trackView.checkContentHeight();
                    this.trackView.repaintViews();
                }
            });

            menuItems.push({
                object: $$1(createCheckbox("squish", this.alignmentTrack.displayMode === "SQUISHED")),
                click: () => {
                    this.alignmentTrack.displayMode = "SQUISHED";
                    this.config.displayMode = "SQUISHED";
                    this.trackView.checkContentHeight();
                    this.trackView.repaintViews();
                }
            });

            return menuItems
        }


        /**
         * Create a "color by" checkbox menu item, optionally initially checked
         * @param menuItem
         * @param showCheck
         * @returns {{init: undefined, name: undefined, click: clickHandler, object: (jQuery|HTMLElement|jQuery.fn.init)}}
         */
        colorByCB(menuItem, showCheck) {
            const $e = $$1(createCheckbox(menuItem.label, showCheck));
            const clickHandler = (ev) => {

                if (menuItem.key !== 'tag') {
                    if (menuItem.key === this.alignmentTrack.colorBy) {
                        this.alignmentTrack.colorBy = 'none';
                        this.config.colorBy = 'none';
                        this.trackView.repaintViews();
                    } else {
                        this.alignmentTrack.colorBy = menuItem.key;
                        this.config.colorBy = menuItem.key;
                        this.trackView.repaintViews();
                    }
                } else {
                    this.browser.inputDialog.present({
                        label: 'Tag Name',
                        value: this.alignmentTrack.colorByTag ? this.alignmentTrack.colorByTag : '',
                        callback: (tag) => {
                            if (tag) {
                                this.alignmentTrack.colorBy = 'tag';
                                this.alignmentTrack.colorByTag = tag;
                                if (!this.alignmentTrack.tagColors) {
                                    this.alignmentTrack.tagColors = new PaletteColorTable("Set1");
                                }
                            } else {
                                this.alignmentTrack.colorBy = 'none';
                                this.alignmentTrack.colorByTag = '';
                            }
                            this.trackView.repaintViews();
                        }
                    }, ev);

                }

            };

            return {name: undefined, object: $e, click: clickHandler, init: undefined}
        }

        /**
         * Return the current state of the track.  Used to create sessions and bookmarks.
         *
         * @returns {*|{}}
         */
        getState() {

            const config = super.getState();

            if (this.sortObject) {
                config.sort = {
                    chr: this.sortObject.chr,
                    position: this.sortObject.position + 1,
                    option: this.sortObject.option,
                    direction: this.sortObject.direction ? "ASC" : "DESC"
                };
            }

            return config
        }

        getCachedAlignmentContainers() {
            return this.trackView.viewports.map(vp => vp.cachedFeatures)
        }

        get dataRange() {
            return this.coverageTrack.dataRange
        }

        set dataRange(dataRange) {
            this.coverageTrack.dataRange = dataRange;
        }

        get logScale() {
            return this.coverageTrack.logScale
        }

        set logScale(logScale) {
            this.coverageTrack.logScale = logScale;
        }

        get autoscale() {
            return this.coverageTrack.autoscale
        }

        set autoscale(autoscale) {
            this.coverageTrack.autoscale = autoscale;
        }

        /**
         * Add chords to the circular view for the given viewport, represented by its reference frame
         * @param refFrame
         */
        addPairedChordsForViewport(viewport) {

            const maxTemplateLength = this.maxTemplateLength;
            const inView = [];
            const refFrame = viewport.referenceFrame;
            for (let a of viewport.cachedFeatures.allAlignments()) {
                if (a.end >= refFrame.start
                    && a.start <= refFrame.end) {
                    if (a.paired) {
                        if (a.end - a.start > maxTemplateLength) {
                            inView.push(a);
                        }
                    } else {
                        if (a.mate
                            && a.mate.chr
                            && (a.mate.chr !== a.chr || Math.max(a.fragmentLength) > maxTemplateLength)) {
                            inView.push(a);
                        }
                    }
                }
            }
            const chords = makePairedAlignmentChords(inView);
            sendChords(chords, this, refFrame, 0.02);
        }

        addSplitChordsForViewport(viewport) {

            const inView = [];
            const refFrame = viewport.referenceFrame;
            for (let a of viewport.cachedFeatures.allAlignments()) {

                const sa = a.hasTag('SA');
                if (a.end >= refFrame.start && a.start <= refFrame.end && sa) {
                    inView.push(a);
                }
            }

            const chords = makeSupplementalAlignmentChords(inView);
            sendChords(chords, this, refFrame, 0.02);
        }
    }


    class CoverageTrack {

        constructor(config, parent) {
            this.parent = parent;
            this.featureSource = parent.featureSource;

            this.paintAxis = paintAxis;
            this.top = 0;

            this.autoscale = config.autoscale || config.max === undefined;
            if (!this.autoscale) {
                this.dataRange = {
                    min: config.min || 0,
                    max: config.max
                };
            }

        }

        get height() {
            return this.parent.coverageTrackHeight
        }

        draw(options) {

            const pixelTop = options.pixelTop;
            pixelTop + options.pixelHeight;
            const nucleotideColors = this.parent.browser.nucleotideColors;

            if (pixelTop > this.height) {
                return //scrolled out of view
            }

            const ctx = options.context;
            const alignmentContainer = options.features;
            const coverageMap = alignmentContainer.coverageMap;

            let sequence;
            if (coverageMap.refSeq) {
                sequence = coverageMap.refSeq.toUpperCase();
            }

            const bpPerPixel = options.bpPerPixel;
            const bpStart = options.bpStart;
            const pixelWidth = options.pixelWidth;
            const bpEnd = bpStart + pixelWidth * bpPerPixel + 1;

            // paint for all coverage buckets
            // If alignment track color is != default, use it
            let color;
            if (this.parent.coverageColor) {
                color = this.parent.coverageColor;
            } else if (this.parent.color  && typeof this.parent.color !== "function") {
                color = IGVColor.darkenLighten(this.parent.color, -35);
            } else {
                color = DEFAULT_COVERAGE_COLOR;
            }
            IGVGraphics.setProperties(ctx, {
                fillStyle: color,
                strokeStyle: color
            });

            const w = Math.max(1, Math.ceil(1.0 / bpPerPixel));
            for (let i = 0, len = coverageMap.coverage.length; i < len; i++) {

                const bp = (coverageMap.bpStart + i);
                if (bp < bpStart) continue
                if (bp > bpEnd) break

                const item = coverageMap.coverage[i];
                if (!item) continue

                const h = Math.round((item.total / this.dataRange.max) * this.height);
                const y = this.height - h;
                const x = Math.floor((bp - bpStart) / bpPerPixel);


                // IGVGraphics.setProperties(ctx, {fillStyle: "rgba(0, 200, 0, 0.25)", strokeStyle: "rgba(0, 200, 0, 0.25)" });
                IGVGraphics.fillRect(ctx, x, y, w, h);
            }

            // coverage mismatch coloring -- don't try to do this in above loop, color bar will be overwritten when w<1
            if (sequence) {
                for (let i = 0, len = coverageMap.coverage.length; i < len; i++) {

                    const bp = (coverageMap.bpStart + i);
                    if (bp < bpStart) continue
                    if (bp > bpEnd) break

                    const item = coverageMap.coverage[i];
                    if (!item) continue

                    const h = (item.total / this.dataRange.max) * this.height;
                    let y = this.height - h;
                    const x = Math.floor((bp - bpStart) / bpPerPixel);

                    const refBase = sequence[i];
                    if (item.isMismatch(refBase)) {
                        IGVGraphics.setProperties(ctx, {fillStyle: nucleotideColors[refBase]});
                        IGVGraphics.fillRect(ctx, x, y, w, h);

                        let accumulatedHeight = 0.0;
                        for (let nucleotide of ["A", "C", "T", "G"]) {

                            const count = item["pos" + nucleotide] + item["neg" + nucleotide];

                            // non-logoritmic
                            const hh = (count / this.dataRange.max) * this.height;
                            y = (this.height - hh) - accumulatedHeight;
                            accumulatedHeight += hh;
                            IGVGraphics.setProperties(ctx, {fillStyle: nucleotideColors[nucleotide]});
                            IGVGraphics.fillRect(ctx, x, y, w, hh);
                        }
                    }
                }
            }
        }

        getClickedObject(clickState) {

            let features = clickState.viewport.cachedFeatures;
            if (!features || features.length === 0) return

            const genomicLocation = Math.floor(clickState.genomicLocation);
            const coverageMap = features.coverageMap;
            const coverageMapIndex = Math.floor(genomicLocation - coverageMap.bpStart);
            return coverageMap.coverage[coverageMapIndex]
        }

        popupData(clickState) {

            const nameValues = [];

            const coverage = this.getClickedObject(clickState);
            if (coverage) {
                const genomicLocation = Math.floor(clickState.genomicLocation);
                const referenceFrame = clickState.viewport.referenceFrame;

                nameValues.push(referenceFrame.chr + ":" + numberFormatter$1(1 + genomicLocation));

                nameValues.push({name: 'Total Count', value: coverage.total});

                // A
                let tmp = coverage.posA + coverage.negA;
                if (tmp > 0) tmp = tmp.toString() + " (" + Math.round((tmp / coverage.total) * 100.0) + "%, " + coverage.posA + "+, " + coverage.negA + "- )";
                nameValues.push({name: 'A', value: tmp});

                // C
                tmp = coverage.posC + coverage.negC;
                if (tmp > 0) tmp = tmp.toString() + " (" + Math.round((tmp / coverage.total) * 100.0) + "%, " + coverage.posC + "+, " + coverage.negC + "- )";
                nameValues.push({name: 'C', value: tmp});

                // G
                tmp = coverage.posG + coverage.negG;
                if (tmp > 0) tmp = tmp.toString() + " (" + Math.round((tmp / coverage.total) * 100.0) + "%, " + coverage.posG + "+, " + coverage.negG + "- )";
                nameValues.push({name: 'G', value: tmp});

                // T
                tmp = coverage.posT + coverage.negT;
                if (tmp > 0) tmp = tmp.toString() + " (" + Math.round((tmp / coverage.total) * 100.0) + "%, " + coverage.posT + "+, " + coverage.negT + "- )";
                nameValues.push({name: 'T', value: tmp});

                // N
                tmp = coverage.posN + coverage.negN;
                if (tmp > 0) tmp = tmp.toString() + " (" + Math.round((tmp / coverage.total) * 100.0) + "%, " + coverage.posN + "+, " + coverage.negN + "- )";
                nameValues.push({name: 'N', value: tmp});

                nameValues.push('<HR/>');
                nameValues.push({name: 'DEL', value: coverage.del.toString()});
                nameValues.push({name: 'INS', value: coverage.ins.toString()});
            }

            return nameValues

        }

    }

    class AlignmentTrack {

        constructor(config, parent) {

            this.parent = parent;
            this.browser = parent.browser;
            this.featureSource = parent.featureSource;
            this.top = 0 === config.coverageTrackHeight ? 0 : config.coverageTrackHeight + 5;
            this.displayMode = config.displayMode || "EXPANDED";
            this.alignmentRowHeight = config.alignmentRowHeight || 14;
            this.squishedRowHeight = config.squishedRowHeight || 3;

            this.negStrandColor = config.negStrandColor || "rgba(150, 150, 230, 0.75)";
            this.posStrandColor = config.posStrandColor || "rgba(230, 150, 150, 0.75)";
            this.insertionColor = config.insertionColor || "rgb(138, 94, 161)";
            this.insertionTextColor = config.insertionTextColor || "white";
            this.showInsertionText = config.showInsertionText === undefined ? false : !!config.showInsertionText;
            this.deletionColor = config.deletionColor || "black";
            this.deletionTextColor = config.deletionTextColor || "black";
            this.showDeletionText = config.showDeletionText === undefined ? false : !!config.showDeletionText;
            this.skippedColor = config.skippedColor || "rgb(150, 170, 170)";
            this.pairConnectorColor = config.pairConnectorColor;

            this.smallTLENColor = config.smallTLENColor || config.smallFragmentLengthColor || "rgb(0, 0, 150)";
            this.largeTLENColor = config.largeTLENColor || config.largeFragmentLengthColor || "rgb(200, 0, 0)";

            this.pairOrientation = config.pairOrienation || 'fr';
            this.pairColors = {};
            this.pairColors["RL"] = config.rlColor || "rgb(0, 150, 0)";
            this.pairColors["RR"] = config.rrColor || "rgb(20, 50, 200)";
            this.pairColors["LL"] = config.llColor || "rgb(0, 150, 150)";

            this.colorBy = config.colorBy || "unexpectedPair";
            this.colorByTag = config.colorByTag ? config.colorByTag.toUpperCase() : undefined;
            this.bamColorTag = config.bamColorTag === undefined ? "YC" : config.bamColorTag;

            this.hideSmallIndels = config.hideSmallIndels;
            this.indelSizeThreshold = config.indelSizeThreshold || 1;

            this.hasPairs = false;   // Until proven otherwise
            this.hasSupplemental = false;
        }

        setTop(coverageTrack, showCoverage) {
            this.top = (0 === coverageTrack.height || false === showCoverage) ? 0 : (5 + coverageTrack.height);
        }

        /**
         * Compute the pixel height required to display all content.
         *
         * @param alignmentContainer
         * @returns {number|*}
         */
        computePixelHeight(alignmentContainer) {

            if (alignmentContainer.packedAlignmentRows) {
                const h = alignmentContainer.hasDownsampledIntervals() ? downsampleRowHeight + alignmentStartGap : 0;
                const alignmentRowHeight = this.displayMode === "SQUISHED" ?
                    this.squishedRowHeight :
                    this.alignmentRowHeight;
                return h + (alignmentRowHeight * alignmentContainer.packedAlignmentRows.length) + 5
            } else {
                return 0
            }
        }

        draw(options) {

            const alignmentContainer = options.features;
            const ctx = options.context;
            const bpPerPixel = options.bpPerPixel;
            const bpStart = options.bpStart;
            const pixelWidth = options.pixelWidth;
            const bpEnd = bpStart + pixelWidth * bpPerPixel + 1;
            const showSoftClips = this.parent.showSoftClips;
            const showAllBases = this.parent.showAllBases;
            const nucleotideColors = this.browser.nucleotideColors;

            //alignmentContainer.repack(bpPerPixel, showSoftClips);
            const packedAlignmentRows = alignmentContainer.packedAlignmentRows;


            ctx.save();

            let referenceSequence = alignmentContainer.sequence;
            if (referenceSequence) {
                referenceSequence = referenceSequence.toUpperCase();
            }
            let alignmentRowYInset = 0;

            let pixelTop = options.pixelTop;
            if (this.top) {
                ctx.translate(0, this.top);
            }
            const pixelBottom = pixelTop + options.pixelHeight;

            if (alignmentContainer.hasDownsampledIntervals()) {
                alignmentRowYInset = downsampleRowHeight + alignmentStartGap;

                alignmentContainer.downsampledIntervals.forEach(function (interval) {
                    var xBlockStart = (interval.start - bpStart) / bpPerPixel,
                        xBlockEnd = (interval.end - bpStart) / bpPerPixel;

                    if (xBlockEnd - xBlockStart > 5) {
                        xBlockStart += 1;
                        xBlockEnd -= 1;
                    }
                    IGVGraphics.fillRect(ctx, xBlockStart, 2, (xBlockEnd - xBlockStart), downsampleRowHeight - 2, {fillStyle: "black"});
                });

            } else {
                alignmentRowYInset = 0;
            }

            // Transient variable -- rewritten on every draw, used for click object selection
            this.alignmentsYOffset = alignmentRowYInset;
            const alignmentRowHeight = this.displayMode === "SQUISHED" ?
                this.squishedRowHeight :
                this.alignmentRowHeight;

            if (packedAlignmentRows) {

                const nRows = packedAlignmentRows.length;

                for (let rowIndex = 0; rowIndex < nRows; rowIndex++) {

                    const alignmentRow = packedAlignmentRows[rowIndex];
                    const alignmentY = alignmentRowYInset + (alignmentRowHeight * rowIndex);
                    const alignmentHeight = alignmentRowHeight <= 4 ? alignmentRowHeight : alignmentRowHeight - 2;

                    if (alignmentY > pixelBottom) {
                        break
                    } else if (alignmentY + alignmentHeight < pixelTop) {
                        continue
                    }

                    for (let alignment of alignmentRow.alignments) {

                        this.hasPairs = this.hasPairs || alignment.isPaired();
                        if (this.browser.circularView) {
                            // This is an expensive check, only do it if needed
                            this.hasSupplemental = this.hasSupplemental || alignment.hasTag('SA');
                        }

                        if ((alignment.start + alignment.lengthOnRef) < bpStart) continue
                        if (alignment.start > bpEnd) break
                        if (true === alignment.hidden) {
                            continue
                        }

                        if (alignment instanceof PairedAlignment) {

                            drawPairConnector.call(this, alignment, alignmentY, alignmentHeight);

                            drawSingleAlignment.call(this, alignment.firstAlignment, alignmentY, alignmentHeight);

                            if (alignment.secondAlignment) {
                                drawSingleAlignment.call(this, alignment.secondAlignment, alignmentY, alignmentHeight);
                            }

                        } else {
                            drawSingleAlignment.call(this, alignment, alignmentY, alignmentHeight);
                        }

                    }
                }
            }
            ctx.restore();

            // alignment is a PairedAlignment
            function drawPairConnector(alignment, yRect, alignmentHeight) {

                var connectorColor = this.getConnectorColor(alignment.firstAlignment),
                    xBlockStart = (alignment.connectingStart - bpStart) / bpPerPixel,
                    xBlockEnd = (alignment.connectingEnd - bpStart) / bpPerPixel,
                    yStrokedLine = yRect + alignmentHeight / 2;

                if ((alignment.connectingEnd) < bpStart || alignment.connectingStart > bpEnd) {
                    return
                }
                if (alignment.mq <= 0) {
                    connectorColor = IGVColor.addAlpha(connectorColor, 0.15);
                }
                IGVGraphics.setProperties(ctx, {fillStyle: connectorColor, strokeStyle: connectorColor});
                IGVGraphics.strokeLine(ctx, xBlockStart, yStrokedLine, xBlockEnd, yStrokedLine);

            }

            function drawSingleAlignment(alignment, yRect, alignmentHeight) {


                if ((alignment.start + alignment.lengthOnRef) < bpStart || alignment.start > bpEnd) {
                    return
                }

                const blocks = showSoftClips ? alignment.blocks : alignment.blocks.filter(b => 'S' !== b.type);

                let alignmentColor = this.getAlignmentColor(alignment);
                const outlineColor = alignmentColor;
                if (alignment.mq <= 0) {
                    alignmentColor = IGVColor.addAlpha(alignmentColor, 0.15);
                }
                IGVGraphics.setProperties(ctx, {fillStyle: alignmentColor, strokeStyle: outlineColor});

                // Save bases to draw into an array for later drawing, so they can be overlaid on insertion blocks,
                // which is relevant if we have insertions with size label
                const basesToDraw = [];

                for (let b = 0; b < blocks.length; b++) {   // Can't use forEach here -- we need ability to break

                    const block = blocks[b];

                    // Somewhat complex test, neccessary to insure gaps are drawn.
                    // If this is not the last block, and the next block starts before the orign (off screen to left) then skip.
                    if ((b !== blocks.length - 1) && blocks[b + 1].start < bpStart) continue

                    // drawBlock returns bases to draw, which are drawn on top of insertion blocks (if they're wider than
                    // the space between two bases) like in Java IGV
                    basesToDraw.push(...drawBlock.call(this, block, b));

                    if ((block.start + block.len) > bpEnd) {
                        // Do this after drawBlock to insure gaps are drawn
                        break
                    }
                }

                if (alignment.gaps) {
                    const yStrokedLine = yRect + alignmentHeight / 2;
                    for (let gap of alignment.gaps) {
                        const sPixel = (gap.start - bpStart) / bpPerPixel;
                        const ePixel = ((gap.start + gap.len) - bpStart) / bpPerPixel;
                        const lineWidth = ePixel - sPixel;
                        const gapLenText = gap.len.toString();
                        const gapTextWidth = gapLenText.length * 6;
                        const gapCenter = sPixel + (lineWidth / 2);

                        const color = ("D" === gap.type) ? this.deletionColor : this.skippedColor;

                        IGVGraphics.strokeLine(ctx, sPixel, yStrokedLine, ePixel, yStrokedLine, {
                            strokeStyle: color,
                            lineWidth: 2,
                        });

                        // Add gap width as text like Java IGV if it fits nicely and is a multi-base gap
                        if (this.showDeletionText && gap.len > 1 && lineWidth >= gapTextWidth + 8) {
                            const textStart = gapCenter - (gapTextWidth / 2);
                            IGVGraphics.fillRect(ctx, textStart - 1, yRect - 1, gapTextWidth + 2, 12, {fillStyle: "white"});
                            IGVGraphics.fillText(ctx, gapLenText, textStart, yRect + 10, {
                                'font': 'normal 10px monospace',
                                'fillStyle': this.deletionTextColor,
                            });
                        }
                    }
                }

                if (alignment.insertions && this.parent.showInsertions) {
                    let lastXBlockStart = -1;
                    for (let insertionBlock of alignment.insertions) {
                        if (this.hideSmallIndels && insertionBlock.len <= this.indelSizeThreshold) {
                            continue
                        }
                        if (insertionBlock.start < bpStart) {
                            continue
                        }
                        if (insertionBlock.start > bpEnd) {
                            break
                        }

                        const refOffset = insertionBlock.start - bpStart;
                        const insertLenText = insertionBlock.len.toString();

                        const textPixelWidth = 2 + (insertLenText.length * 6);
                        const basePixelWidth = (!this.showInsertionText || insertionBlock.len === 1)
                            ? 2
                            : Math.round(insertionBlock.len / bpPerPixel);
                        const widthBlock = Math.max(Math.min(textPixelWidth, basePixelWidth), 2);

                        const xBlockStart = (refOffset / bpPerPixel) - (widthBlock / 2);
                        if ((xBlockStart - lastXBlockStart) > 2) {
                            const props = {fillStyle: this.insertionColor};

                            // Draw decorations like Java IGV to make an 'I' shape
                            IGVGraphics.fillRect(ctx, xBlockStart - 2, yRect, widthBlock + 4, 2, props);
                            IGVGraphics.fillRect(ctx, xBlockStart, yRect + 2, widthBlock, alignmentHeight - 4, props);
                            IGVGraphics.fillRect(ctx, xBlockStart - 2, yRect + alignmentHeight - 2, widthBlock + 4, 2, props);

                            // Show # of inserted bases as text if it's a multi-base insertion and the insertion block
                            // is wide enough to hold text (its size is capped at the text label size, but can be smaller
                            // if the browser is zoomed out and the insertion is small)
                            if (this.showInsertionText && insertionBlock.len > 1 && basePixelWidth > textPixelWidth) {
                                IGVGraphics.fillText(ctx, insertLenText, xBlockStart + 1, yRect + 10, {
                                    'font': 'normal 10px monospace',
                                    'fillStyle': this.insertionTextColor,
                                });
                            }
                            lastXBlockStart = xBlockStart;
                        }
                    }
                }

                basesToDraw.forEach(({bbox, baseColor, readChar}) => {
                    renderBlockOrReadChar(ctx, bpPerPixel, bbox, baseColor, readChar);
                });


                function drawBlock(block, b) {
                    // Collect bases to draw for later rendering
                    const blockBasesToDraw = [];

                    const offsetBP = block.start - alignmentContainer.start;
                    const blockStartPixel = (block.start - bpStart) / bpPerPixel;
                    const blockEndPixel = ((block.start + block.len) - bpStart) / bpPerPixel;
                    const blockWidthPixel = Math.max(1, blockEndPixel - blockStartPixel);

                    //const arrowHeadWidthPixel = alignmentRowHeight / 2.0;
                    const nomPixelWidthOnRef = 100 / bpPerPixel;
                    const arrowHeadWidthPixel = Math.min(alignmentRowHeight / 2.0, nomPixelWidthOnRef / 6);

                    const isSoftClip = 'S' === block.type;

                    const strokeOutline =
                        alignment.mq <= 0 ||
                        this.highlightedAlignmentReadNamed === alignment.readName ||
                        isSoftClip;

                    let blockOutlineColor = outlineColor;
                    if (this.highlightedAlignmentReadNamed === alignment.readName) blockOutlineColor = 'red';
                    else if (isSoftClip) blockOutlineColor = 'rgb(50,50,50)';

                    const lastBlockPositiveStrand = (true === alignment.strand && b === blocks.length - 1);
                    const lastBlockReverseStrand = (false === alignment.strand && b === 0);
                    const lastBlock = lastBlockPositiveStrand | lastBlockReverseStrand;

                    if (lastBlock) {
                        let xListPixel;
                        let yListPixel;
                        if (lastBlockPositiveStrand) {
                            xListPixel = [
                                blockStartPixel,
                                blockEndPixel,
                                blockEndPixel + arrowHeadWidthPixel,
                                blockEndPixel,
                                blockStartPixel,
                                blockStartPixel];
                            yListPixel = [
                                yRect,
                                yRect,
                                yRect + (alignmentHeight / 2.0),
                                yRect + alignmentHeight,
                                yRect + alignmentHeight,
                                yRect];

                        }

                        // Last block on - strand ?
                        else if (lastBlockReverseStrand) {
                            xListPixel = [
                                blockEndPixel,
                                blockStartPixel,
                                blockStartPixel - arrowHeadWidthPixel,
                                blockStartPixel,
                                blockEndPixel,
                                blockEndPixel];
                            yListPixel = [
                                yRect,
                                yRect,
                                yRect + (alignmentHeight / 2.0),
                                yRect + alignmentHeight,
                                yRect + alignmentHeight,
                                yRect];

                        }
                        IGVGraphics.fillPolygon(ctx, xListPixel, yListPixel, {fillStyle: alignmentColor});

                        if (strokeOutline) {
                            IGVGraphics.strokePolygon(ctx, xListPixel, yListPixel, {strokeStyle: blockOutlineColor});
                        }
                    }

                    // Internal block
                    else {
                        IGVGraphics.fillRect(ctx, blockStartPixel, yRect, blockWidthPixel, alignmentHeight, {fillStyle: alignmentColor});

                        if (strokeOutline) {
                            ctx.save();
                            ctx.strokeStyle = blockOutlineColor;
                            ctx.strokeRect(blockStartPixel, yRect, blockWidthPixel, alignmentHeight);
                            ctx.restore();
                        }
                    }


                    // Read base coloring

                    if (isSoftClip ||
                        showAllBases ||
                        this.parent.showMismatches && (referenceSequence && alignment.seq && alignment.seq !== "*")) {

                        const seq = alignment.seq ? alignment.seq.toUpperCase() : undefined;
                        const qual = alignment.qual;
                        const seqOffset = block.seqOffset;
                        const widthPixel = Math.max(1, 1 / bpPerPixel);


                        for (let i = 0, len = block.len; i < len; i++) {

                            const xPixel = ((block.start + i) - bpStart) / bpPerPixel;

                            if (xPixel + widthPixel < 0) continue   // Off left edge
                            if (xPixel > pixelWidth) break  // Off right edge

                            let readChar = seq ? seq.charAt(seqOffset + i) : '';
                            const refChar = offsetBP + i >= 0 ? referenceSequence.charAt(offsetBP + i) : '';

                            if (readChar === "=") {
                                readChar = refChar;
                            }
                            if (readChar === "X" || refChar !== readChar || isSoftClip || showAllBases) {

                                let baseColor;
                                if (!isSoftClip && qual !== undefined && qual.length > seqOffset + i) {
                                    const readQual = qual[seqOffset + i];
                                    baseColor = shadedBaseColor(readQual, nucleotideColors[readChar]);
                                } else {
                                    baseColor = nucleotideColors[readChar];
                                }
                                if (baseColor) {
                                    blockBasesToDraw.push({
                                        bbox: {
                                            x: xPixel,
                                            y: yRect,
                                            width: widthPixel,
                                            height: alignmentHeight
                                        },
                                        baseColor,
                                        readChar,
                                    });
                                }
                            }
                        }
                    }

                    return blockBasesToDraw
                }

                function renderBlockOrReadChar(context, bpp, bbox, color, char) {
                    var threshold,
                        center;

                    threshold = 1.0 / 10.0;
                    if (bpp <= threshold && bbox.height >= 8) {

                        // render letter
                        const fontHeight = Math.min(10, bbox.height);
                        context.font = '' + fontHeight + 'px sans-serif';
                        center = bbox.x + (bbox.width / 2.0);
                        IGVGraphics.strokeText(context, char, center - (context.measureText(char).width / 2), fontHeight - 1 + bbox.y, {strokeStyle: color});
                    } else {

                        // render colored block
                        IGVGraphics.fillRect(context, bbox.x, bbox.y, bbox.width, bbox.height, {fillStyle: color});
                    }
                }
            }

        };

        popupData(clickState) {
            const clickedObject = this.getClickedObject(clickState);
            return clickedObject ? clickedObject.popupData(clickState.genomicLocation) : undefined
        };

        contextMenuItemList(clickState) {

            const viewport = clickState.viewport;
            const list = [];

            const sortByOption = (option) => {
                const cs = this.parent.sortObject;
                const direction = (cs && cs.position === Math.floor(clickState.genomicLocation)) ? !cs.direction : true;
                const newSortObject = {
                    chr: viewport.referenceFrame.chr,
                    position: Math.floor(clickState.genomicLocation),
                    option: option,
                    direction: direction
                };
                this.parent.sortObject = newSortObject;
                viewport.cachedFeatures.sortRows(newSortObject);
                viewport.repaint();
            };
            list.push('<b>Sort by...</b>');
            list.push({label: '&nbsp; base', click: () => sortByOption("BASE")});
            list.push({label: '&nbsp; read strand', click: () => sortByOption("STRAND")});
            list.push({label: '&nbsp; insert size', click: () => sortByOption("INSERT_SIZE")});
            list.push({label: '&nbsp; gap size', click: () => sortByOption("GAP_SIZE")});
            list.push({label: '&nbsp; chromosome of mate', click: () => sortByOption("MATE_CHR")});
            list.push({label: '&nbsp; mapping quality', click: () => sortByOption("MQ")});
            list.push({label: '&nbsp; read name', click: () => sortByOption("READ_NAME")});
            list.push({label: '&nbsp; aligned read length', click: () => sortByOption("ALIGNED_READ_LENGTH")});
            list.push({
                label: '&nbsp; tag', click: () => {
                    const cs = this.parent.sortObject;
                    const direction = (cs && cs.position === Math.floor(clickState.genomicLocation)) ? !cs.direction : true;
                    const config =
                        {
                            label: 'Tag Name',
                            value: this.sortByTag ? this.sortByTag : '',
                            callback: (tag) => {
                                if (tag) {
                                    const newSortObject = {
                                        chr: viewport.referenceFrame.chr,
                                        position: Math.floor(clickState.genomicLocation),
                                        option: "TAG",
                                        tag: tag,
                                        direction: direction
                                    };
                                    this.sortByTag = tag;
                                    this.parent.sortObject = newSortObject;
                                    viewport.cachedFeatures.sortRows(newSortObject);
                                    viewport.repaint();
                                }
                            }
                        };
                    this.browser.inputDialog.present(config, clickState.event);
                }
            });
            list.push('<hr/>');

            const clickedObject = this.getClickedObject(clickState);

            if (clickedObject) {

                const showSoftClips = this.parent.showSoftClips;
                const clickedAlignment = (typeof clickedObject.alignmentContaining === 'function') ?
                    clickedObject.alignmentContaining(clickState.genomicLocation, showSoftClips) :
                    clickedObject;
                if (clickedAlignment) {
                    if (clickedAlignment.isPaired() && clickedAlignment.isMateMapped()) {
                        list.push({
                            label: 'View mate in split screen',
                            click: () => {
                                if (clickedAlignment.mate) {
                                    const referenceFrame = clickState.viewport.referenceFrame;
                                    if (this.browser.genome.getChromosome(clickedAlignment.mate.chr)) {
                                        this.highlightedAlignmentReadNamed = clickedAlignment.readName;
                                        //this.browser.presentMultiLocusPanel(clickedAlignment, referenceFrame)
                                        const bpWidth = referenceFrame.end - referenceFrame.start;
                                        const frameStart = clickedAlignment.mate.position - bpWidth / 2;
                                        const frameEnd = clickedAlignment.mate.position + bpWidth / 2;
                                        this.browser.addMultiLocusPanel(clickedAlignment.mate.chr, frameStart, frameEnd, referenceFrame);
                                    } else {
                                        this.browser.alert.present(`Reference does not contain chromosome: ${clickedAlignment.mate.chr}`);
                                    }
                                }
                            },
                            init: undefined
                        });
                    }

                    list.push({
                        label: 'View read sequence',
                        click: () => {
                            const seqstring = clickedAlignment.seq; //.map(b => String.fromCharCode(b)).join("");
                            if (!seqstring || "*" === seqstring) {
                                this.browser.alert.present("Read sequence: *");
                            } else {
                                this.browser.alert.present(seqstring);
                            }
                        }
                    });

                    if (isSecureContext()) {
                        list.push({
                            label: 'Copy read sequence',
                            click: async () => {
                                const seq = clickedAlignment.seq; //.map(b => String.fromCharCode(b)).join("");
                                try {
                                    //console.log(`seq: ${seq}`)
                                    await navigator.clipboard.writeText(seq);
                                } catch (e) {
                                    console.error(e);
                                    this.browser.alert.present(`error copying sequence to clipboard ${e}`);
                                }

                            }
                        });
                    }

                    // TODO if genome supports blat
                    const seqstring = clickedAlignment.seq;
                    if (seqstring && "*" != seqstring) {

                        if (seqstring.length < maxSequenceSize) {
                            list.push({
                                label: 'BLAT read sequence',
                                click: () => {
                                    const sequence = clickedAlignment.isNegativeStrand() ? reverseComplementSequence(seqstring) : seqstring;
                                    const name = `${clickedAlignment.readName} - blat`;
                                    const title = `${this.parent.name} - ${name}`;
                                    createBlatTrack({sequence, browser: this.browser, name, title});
                                }
                            });
                        }

                        const softClips = clickedAlignment.softClippedBlocks();
                        if (softClips.left && softClips.left.len > MINIMUM_BLAT_LENGTH && softClips.left.len < maxSequenceSize) {
                            list.push({
                                label: 'BLAT left soft-clipped sequence',
                                click: () => {
                                    const clippedSequence = seqstring.substr(softClips.left.seqOffset, softClips.left.len);
                                    const sequence = clickedAlignment.isNegativeStrand() ? reverseComplementSequence(clippedSequence) : clippedSequence;
                                    const name = `${clickedAlignment.readName} - blat left clip`;
                                    const title = `${this.parent.name} - ${name}`;
                                    createBlatTrack({sequence, browser: this.browser, name, title});
                                }
                            });
                        }
                        if (softClips.right && softClips.right.len > MINIMUM_BLAT_LENGTH && softClips.right.len < maxSequenceSize) {
                            list.push({
                                label: 'BLAT right soft-clipped sequence',
                                click: () => {
                                    const clippedSequence = seqstring.substr(softClips.right.seqOffset, softClips.right.len);
                                    const sequence = clickedAlignment.isNegativeStrand() ? reverseComplementSequence(clippedSequence) : clippedSequence;
                                    const name = `${clickedAlignment.readName} - blat right clip`;
                                    const title = `${this.parent.name} - ${name}`;
                                    createBlatTrack({sequence, browser: this.browser, name, title});
                                }
                            });
                        }
                    }

                    list.push('<hr/>');
                }
            }

            // Experimental JBrowse feature
            if (this.browser.circularView && (this.hasPairs || this.hasSupplemental)) {
                if (this.hasPairs) {
                    list.push({
                        label: 'Add discordant pairs to circular view',
                        click: () => {
                            this.parent.addPairedChordsForViewport(viewport);
                        }
                    });
                }
                if (this.hasSupplemental) {
                    list.push({
                        label: 'Add split reads to circular view',
                        click: () => {
                            this.parent.addSplitChordsForViewport(viewport);
                        }
                    });
                }
                list.push('<hr/>');
            }

            return list

        }

        getClickedObject(clickState) {

            const viewport = clickState.viewport;
            const y = clickState.y;
            const genomicLocation = clickState.genomicLocation;

            const showSoftClips = this.parent.showSoftClips;

            let features = viewport.cachedFeatures;
            if (!features || features.length === 0) return

            let packedAlignmentRows = features.packedAlignmentRows;
            let downsampledIntervals = features.downsampledIntervals;
            const alignmentRowHeight = this.displayMode === "SQUISHED" ?
                this.squishedRowHeight :
                this.alignmentRowHeight;

            let packedAlignmentsIndex = Math.floor((y - this.top - this.alignmentsYOffset) / alignmentRowHeight);

            if (packedAlignmentsIndex < 0) {
                for (let i = 0; i < downsampledIntervals.length; i++) {
                    if (downsampledIntervals[i].start <= genomicLocation && (downsampledIntervals[i].end >= genomicLocation)) {
                        return downsampledIntervals[i]
                    }
                }
            } else if (packedAlignmentsIndex < packedAlignmentRows.length) {
                const alignmentRow = packedAlignmentRows[packedAlignmentsIndex];
                const clicked = alignmentRow.alignments.filter(alignment => alignment.containsLocation(genomicLocation, showSoftClips));
                if (clicked.length > 0) return clicked[0]
            }

            return undefined

        };

        /**
         * Return the color for connectors in paired alignment view.   If explicitly set return that, otherwise return
         * the alignment color, unless the color option can result in split colors (separte color for each mate).
         *
         * @param alignment
         * @returns {string}
         */
        getConnectorColor(alignment) {

            if (this.pairConnectorColor) {
                return this.pairConnectorColor
            }

            switch (this.colorBy) {
                case "strand":
                case "firstOfPairStrand":
                case "pairOrientation":
                case "tag":
                    if (this.parent.color) {
                        return (typeof this.parent.color === "function") ? this.parent.color(alignment) : this.parent.color
                    } else {
                        return DEFAULT_CONNECTOR_COLOR
                    }
                default:
                    return this.getAlignmentColor(alignment)

            }
        }

        getAlignmentColor(alignment) {

            let color = DEFAULT_ALIGNMENT_COLOR;   // The default color if nothing else applies
            if (this.parent.color) {
                color = (typeof this.parent.color === "function") ? this.parent.color(alignment) : this.parent.color;
            } else {
                color = DEFAULT_ALIGNMENT_COLOR;
            }
            const option = this.colorBy;
            switch (option) {
                case "strand":
                    color = alignment.strand ? this.posStrandColor : this.negStrandColor;
                    break

                case "firstOfPairStrand":

                    if (alignment instanceof PairedAlignment) {
                        color = alignment.firstOfPairStrand() ? this.posStrandColor : this.negStrandColor;
                    } else if (alignment.isPaired()) {

                        if (alignment.isFirstOfPair()) {
                            color = alignment.strand ? this.posStrandColor : this.negStrandColor;
                        } else if (alignment.isSecondOfPair()) {
                            color = alignment.strand ? this.negStrandColor : this.posStrandColor;
                        } else {
                            console.error("ERROR. Paired alignments are either first or second.");
                        }
                    }
                    break

                case "unexpectedPair":
                case "pairOrientation":

                    if (this.pairOrientation && alignment.pairOrientation) {
                        const oTypes = orientationTypes[this.pairOrientation];
                        if (oTypes) {
                            const pairColor = this.pairColors[oTypes[alignment.pairOrientation]];
                            if (pairColor) {
                                color = pairColor;
                                break
                            }
                        }
                    }
                    if ("pairOrientation" === option) {
                        break
                    }

                case "tlen":
                case "fragmentLength":

                    if (alignment.mate && alignment.isMateMapped()) {
                        if (alignment.mate.chr !== alignment.chr) {
                            color = getChrColor(alignment.mate.chr);
                        } else if (this.parent.minTemplateLength && Math.abs(alignment.fragmentLength) < this.parent.minTemplateLength) {
                            color = this.smallTLENColor;
                        } else if (this.parent.maxTemplateLength && Math.abs(alignment.fragmentLength) > this.parent.maxTemplateLength) {
                            color = this.largeTLENColor;
                        }
                    }
                    break

                case "tag":
                    const tagValue = alignment.tags()[this.colorByTag];
                    if (tagValue !== undefined) {
                        if (this.bamColorTag === this.colorByTag) {
                            // UCSC style color option
                            color = "rgb(" + tagValue + ")";
                        } else {

                            if (!this.tagColors) {
                                this.tagColors = new PaletteColorTable("Set1");
                            }
                            color = this.tagColors.getColor(tagValue);
                        }
                    }
                    break
            }

            return color

        }
    }

    function shadedBaseColor(qual, baseColor) {

        const minQ = 5;   //prefs.getAsInt(PreferenceManager.SAM_BASE_QUALITY_MIN),
        const maxQ = 20;  //prefs.getAsInt(PreferenceManager.SAM_BASE_QUALITY_MAX);

        let alpha;
        if (qual < minQ) {
            alpha = 0.1;
        } else {
            alpha = Math.max(0.1, Math.min(1.0, 0.1 + 0.9 * (qual - minQ) / (maxQ - minQ)));
        }
        // Round alpha to nearest 0.1
        alpha = Math.round(alpha * 10) / 10.0;

        if (alpha < 1) {
            baseColor = IGVColor.addAlpha(baseColor, alpha);
        }
        return baseColor
    }

    const orientationTypes = {

        "fr": {
            "F1R2": "LR",
            "F2R1": "LR",
            "F1F2": "LL",
            "F2F1": "LL",
            "R1R2": "RR",
            "R2R1": "RR",
            "R1F2": "RL",
            "R2F1": "RL"
        },

        "rf": {
            "R1F2": "LR",
            "R2F1": "LR",
            "R1R2": "LL",
            "R2R1": "LL",
            "F1F2": "RR",
            "F2F1": "RR",
            "F1R2": "RL",
            "F2R1": "RL"
        },

        "ff": {
            "F2F1": "LR",
            "R1R2": "LR",
            "F2R1": "LL",
            "R1F2": "LL",
            "R2F1": "RR",
            "F1R2": "RR",
            "R2R1": "RL",
            "F1F2": "RL"
        }
    };

    function getChrColor(chr) {
        if (chrColorMap[chr]) {
            return chrColorMap[chr]
        } else if (chrColorMap["chr" + chr]) {
            const color = chrColorMap["chr" + chr];
            chrColorMap[chr] = color;
            return color
        } else {
            const color = IGVColor.randomRGB(0, 255);
            chrColorMap[chr] = color;
            return color
        }
    }

    const chrColorMap = {
        "chrX": "rgb(204, 153, 0)",
        "chrY": "rgb(153, 204, 0)",
        "chrUn": "rgb(50, 50, 50)",
        "chr1": "rgb(80, 80, 255)",
        "chrI": "rgb(139, 155, 187)",
        "chr2": "rgb(206, 61, 50)",
        "chrII": "rgb(206, 61, 50)",
        "chr2a": "rgb(216, 71, 60)",
        "chr2b": "rgb(226, 81, 70)",
        "chr3": "rgb(116, 155, 88)",
        "chrIII": "rgb(116, 155, 88)",
        "chr4": "rgb(240, 230, 133)",
        "chrIV": "rgb(240, 230, 133)",
        "chr5": "rgb(70, 105, 131)",
        "chr6": "rgb(186, 99, 56)",
        "chr7": "rgb(93, 177, 221)",
        "chr8": "rgb(128, 34, 104)",
        "chr9": "rgb(107, 215, 107)",
        "chr10": "rgb(213, 149, 167)",
        "chr11": "rgb(146, 72, 34)",
        "chr12": "rgb(131, 123, 141)",
        "chr13": "rgb(199, 81, 39)",
        "chr14": "rgb(213, 143, 92)",
        "chr15": "rgb(122, 101, 165)",
        "chr16": "rgb(228, 175, 105)",
        "chr17": "rgb(59, 27, 83)",
        "chr18": "rgb(205, 222, 183)",
        "chr19": "rgb(97, 42, 121)",
        "chr20": "rgb(174, 31, 99)",
        "chr21": "rgb(231, 199, 111)",
        "chr22": "rgb(90, 101, 94)",
        "chr23": "rgb(204, 153, 0)",
        "chr24": "rgb(153, 204, 0)",
        "chr25": "rgb(51, 204, 0)",
        "chr26": "rgb(0, 204, 51)",
        "chr27": "rgb(0, 204, 153)",
        "chr28": "rgb(0, 153, 204)",
        "chr29": "rgb(10, 71, 255)",
        "chr30": "rgb(71, 117, 255)",
        "chr31": "rgb(255, 194, 10)",
        "chr32": "rgb(255, 209, 71)",
        "chr33": "rgb(153, 0, 51)",
        "chr34": "rgb(153, 26, 0)",
        "chr35": "rgb(153, 102, 0)",
        "chr36": "rgb(128, 153, 0)",
        "chr37": "rgb(51, 153, 0)",
        "chr38": "rgb(0, 153, 26)",
        "chr39": "rgb(0, 153, 102)",
        "chr40": "rgb(0, 128, 153)",
        "chr41": "rgb(0, 51, 153)",
        "chr42": "rgb(26, 0, 153)",
        "chr43": "rgb(102, 0, 153)",
        "chr44": "rgb(153, 0, 128)",
        "chr45": "rgb(214, 0, 71)",
        "chr46": "rgb(255, 20, 99)",
        "chr47": "rgb(0, 214, 143)",
        "chr48": "rgb(20, 255, 177)",
    };

    let timer;
    let currentViewport = undefined;
    const toolTipTimeout = 1e4;

    class RulerViewport extends TrackViewport {

        constructor(trackView, $viewportColumn, referenceFrame, width) {
            super(trackView, $viewportColumn, referenceFrame, width);
        }

        get contentDiv() {
            return this.$viewport.get(0)
        }

        initializationHelper() {

            this.$multiLocusCloseButton = $$1('<div>', {class: 'igv-multi-locus-close-button'});
            this.$viewport.append(this.$multiLocusCloseButton);
            this.$multiLocusCloseButton.get(0).appendChild(icons$1.createIcon("times-circle"));

            this.$multiLocusCloseButton.click(() => {
                this.browser.removeMultiLocusPanel(this.referenceFrame);
            });

            this.$rulerLabel = $$1('<div>', {class: 'igv-multi-locus-ruler-label'});
            this.$viewport.append(this.$rulerLabel);

            let div;
            div = document.createElement('div');
            this.$rulerLabel.append($$1(div));

            this.$rulerLabel.get(0).addEventListener('click', async event => {
                event.stopPropagation();
                await this.browser.gotoMultilocusPanel(this.referenceFrame);
            });

            this.$tooltip = $$1('<div>', {class: 'igv-ruler-tooltip'});
            this.$tooltip.height(this.$viewport.height());

            this.$viewport.append(this.$tooltip);

            this.$tooltipContent = $$1('<div>');
            this.$tooltip.append(this.$tooltipContent);

            this.rulerSweeper = new RulerSweeper(this, this.$viewport.get(0).parentElement, this.browser, this.referenceFrame);

            this.attachMouseHandlers(GenomeUtils.isWholeGenomeView(this.referenceFrame.chr));

            this.$tooltip.hide();

            this.dismissLocusLabel();
        }

        presentLocusLabel(viewportWidth) {

            this.$multiLocusCloseButton.show();

            this.$rulerLabel.show();
            this.$rulerLabel.get(0).style.backgroundColor = getChrColor(this.referenceFrame.chr);

            const textDiv = this.$rulerLabel.get(0).querySelector('div');

            const { width } = this.$rulerLabel.get(0).getBoundingClientRect();

            textDiv.innerHTML = `${ this.referenceFrame.getMultiLocusLabel(viewportWidth) }`;
            const { width:textDivWidth } = textDiv.getBoundingClientRect();

            if (textDivWidth/width > 0.5) {
                textDiv.innerHTML = `${ this.referenceFrame.getMultiLocusLabelBPLengthOnly(viewportWidth) }`;
            }

            //console.log(`${ Date.now() } textDiv ${ StringUtils.numberFormatter(Math.floor(textDivWidth)) }`)

        }

        // Use in conjuction with .igv-multi-locus-ruler-label-square-dot css class (_dom-misc.scss)
        dismissLocusLabel() {
            this.$rulerLabel.hide();
            this.$multiLocusCloseButton.hide();
        }

        attachMouseHandlers(isWholeGenomeView) {

            this.namespace = `.ruler_track_viewport_${this.browser.referenceFrameList.indexOf(this.referenceFrame)}`;

            this.$viewport.off(this.namespace);

            if (true === isWholeGenomeView) {

                const index = this.browser.referenceFrameList.indexOf(this.referenceFrame);

                const click = `click${this.namespace}`;
                this.$viewport.on(click, (e) => {

                    const {x: pixel} = domUtils.translateMouseCoordinates(e, this.$viewport.get(0));
                    const bp = Math.round(this.referenceFrame.start + this.referenceFrame.toBP(pixel));

                    let searchString;

                    const {chr} = this.browser.genome.getChromosomeCoordinate(bp);

                    if (1 === this.browser.referenceFrameList.length) {
                        searchString = chr;
                    } else {

                        let loci = this.browser.referenceFrameList.map(({locusSearchString}) => locusSearchString);

                        loci[index] = chr;

                        searchString = loci.join(' ');
                    }

                    this.browser.search(searchString);
                });

                this.$viewport.get(0).style.cursor = 'pointer';
            } else {
                this.$viewport.get(0).style.cursor = 'default';
            }

        }

        mouseMove(event) {

            if (true === this.browser.cursorGuideVisible) {

                if (undefined === currentViewport) {
                    currentViewport = this;
                    this.$tooltip.show();
                } else if (currentViewport.guid !== this.guid) {
                    if (currentViewport.$tooltip) {
                        currentViewport.$tooltip.hide();
                    }
                    this.$tooltip.show();
                    currentViewport = this;
                } else {
                    this.$tooltip.show();
                }

                const isWholeGenome = (this.browser.isMultiLocusWholeGenomeView() || GenomeUtils.isWholeGenomeView(this.referenceFrame.chr));

                if (isWholeGenome) {
                    this.$tooltip.hide();
                    return
                }

                const {x} = domUtils.translateMouseCoordinates(event, this.$viewport.get(0));
                const {start, bpPerPixel} = this.referenceFrame;
                const bp = Math.round(0.5 + start + Math.max(0, x) * bpPerPixel);

                this.$tooltipContent.text(numberFormatter$1(bp));

                const {width: ww} = this.$tooltipContent.get(0).getBoundingClientRect();
                const {width: w} = this.$viewport.get(0).getBoundingClientRect();

                this.$tooltip.css({left: `${IGVMath.clamp(x, 0, w - ww)}px`});

                // hide tooltip when movement stops
                clearTimeout(timer);
                timer = setTimeout(() => {
                    if (this.$tooltip) this.$tooltip.hide();
                }, toolTipTimeout);

            }

        }

        startSpinner() {
        }

        stopSpinner() {
        }

        dispose() {
            this.rulerSweeper.dispose();
            super.dispose();
        }

    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class IdeogramViewport extends TrackViewport {

        constructor(trackView, viewportColumn, referenceFrame, width) {
            super(trackView, viewportColumn, referenceFrame, width);
        }

        initializationHelper() {

            this.canvas = document.createElement('canvas');
            this.canvas.className = 'igv-ideogram-canvas';
            //this.$content.append($(this.canvas))
            this.$viewport.append($$1(this.canvas));
            this.ideogram_ctx = this.canvas.getContext('2d');

            this.addMouseHandlers();
        }

        addMouseHandlers() {
            this.addViewportClickHandler(this.$viewport.get(0));
        }

        addViewportClickHandler(viewport) {

            this.boundClickHandler = clickHandler.bind(this);
            viewport.addEventListener('click', this.boundClickHandler);

            function clickHandler(event) {

                const {xNormalized, width} = domUtils.translateMouseCoordinates(event, this.ideogram_ctx.canvas);
                const {bpLength} = this.browser.genome.getChromosome(this.referenceFrame.chr);
                const locusLength = this.referenceFrame.bpPerPixel * width;
                const chrCoveragePercentage = locusLength / bpLength;

                let xPercentage = xNormalized;
                if (xPercentage - (chrCoveragePercentage / 2.0) < 0) {
                    xPercentage = chrCoveragePercentage / 2.0;
                }

                if (xPercentage + (chrCoveragePercentage / 2.0) > 1.0) {
                    xPercentage = 1.0 - chrCoveragePercentage / 2.0;
                }

                const ss = Math.round((xPercentage - (chrCoveragePercentage / 2.0)) * bpLength);
                const ee = Math.round((xPercentage + (chrCoveragePercentage / 2.0)) * bpLength);

                this.referenceFrame.start = ss;
                this.referenceFrame.end = ee;
                this.referenceFrame.bpPerPixel = (ee - ss) / width;

                this.browser.updateViews(this.referenceFrame, this.browser.trackViews, true);

            }

        }

        setWidth(width) {
            this.$viewport.width(width);
        }

        drawSVGWithContext(context, width, height, id, x, y, yClipOffset) {

            context.saveWithTranslationAndClipRect(id, x, y, width, height, yClipOffset);

            this.trackView.track.draw({
                context,
                referenceFrame: this.referenceFrame,
                pixelWidth: width,
                pixelHeight: height
            });

            context.restore();
        }

        repaint() {
            this.draw({referenceFrame: this.referenceFrame});
        }

        draw({referenceFrame}) {

            IGVGraphics.configureHighDPICanvas(this.ideogram_ctx, this.$viewport.width(), this.$viewport.height());

            this.trackView.track.draw({
                context: this.ideogram_ctx,
                referenceFrame,
                pixelWidth: this.$viewport.width(),
                pixelHeight: this.$viewport.height()
            });
        }

        startSpinner() {
        }

        stopSpinner() {
        }

    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */


    function createViewport(trackView, column, referenceFrame, width) {

        if ('ruler' === trackView.track.type) {
            return new RulerViewport(trackView, column, referenceFrame, width)
        } else if ('ideogram' === trackView.track.id) {
            return new IdeogramViewport(trackView, column, referenceFrame, width)
        } else {
            const viewportObject = new TrackViewport(trackView, column, referenceFrame, width);

            // if ('sequence' === trackView.track.type) {
            //     viewportObject.$viewport.get(0).style.marginTop = '0px'
            // }

            return viewportObject
        }
    }

    const maxFontSize = 10;

    const fontConfigureTemplate =
        {
            // font: '2pt sans-serif',
            textAlign: 'start',
            textBaseline: 'bottom',
            strokeStyle: 'black',
            fillStyle: 'black'
        };

    class SampleNameViewport {

        constructor(trackView, column, unused, width) {

            this.guid = domUtils.guid();
            this.trackView = trackView;

            this.browser = trackView.browser;

            this.viewport = domUtils.div({class: 'igv-viewport'});

            column.appendChild(this.viewport);

            if (trackView.track.height) {
                this.viewport.style.height = `${trackView.track.height}px`;
            }

            this.canvas = document.createElement('canvas');
            this.viewport.appendChild(this.canvas);
            this.ctx = this.canvas.getContext("2d");

            this.trackScrollDelta = 0;

            this.contentTop = 0;

            this.setWidth(width);

            if (false === this.browser.showSampleNames) {
                this.hide();
            }

            this.addMouseHandlers();
        }

        checkCanvas() {

            const dpi = window.devicePixelRatio;
            const requiredHeight = this.viewport.clientHeight;
            const requiredWidth = this.browser.sampleNameViewportWidth;

            if (this.canvas.width !== requiredWidth * dpi || this.canvas.height !== requiredHeight * dpi) {
                const canvas = this.canvas;
                canvas.width = requiredWidth * dpi;
                canvas.height = requiredHeight * dpi;
                canvas.style.width = `${requiredWidth}px`;
                canvas.style.height = `${requiredHeight}px`;
                this.ctx = this.canvas.getContext("2d");
                this.ctx.scale(dpi, dpi);
            }

        }

        setTop(contentTop) {

            if (typeof this.trackView.track.getSamples === 'function') {
                this.contentTop = contentTop;
                const samples = this.trackView.track.getSamples();
                this.repaint(samples);
            }

        }

        setWidth(width) {
            this.viewport.innerWidth = width;
            this.checkCanvas();
        }

        show() {
            this.viewport.style.display = 'block';
        }

        hide() {
            this.viewport.style.display = 'none';
        }

        async repaint(samples) {

            this.checkCanvas();
            this.draw({context: this.ctx, samples});
        }

        draw({context, samples}) {

            if (!samples || samples.names.length === 0/* || samples.height < 1*/) {
                return
            }

            configureFont(context, fontConfigureTemplate, samples.height);
            const sampleNameXShim = 4;

            context.clearRect(0, 0, context.canvas.width, context.canvas.height);

            context.fillStyle = appleCrayonRGB('lead');

            const viewportHeight = this.viewport.getBoundingClientRect().height;
            let y = (samples.yOffset || 0) + this.contentTop;    // contentTop will always be a negative number (top relative to viewport)

            for (let name of samples.names) {
                if (y > viewportHeight) {
                    break
                }
                if (y + samples.height > 0) {
                    const text = name;
                    const yFont = getYFont(context, text, y, samples.height);
                    context.fillText(text, sampleNameXShim, yFont);

                }
                y += samples.height;
            }
        }

        renderSVGContext(context, {deltaX, deltaY}) {

            if (typeof this.trackView.track.getSamples === 'function') {

                const samples = this.trackView.track.getSamples();

                const yScrollDelta = 0;   // This is not relevant, scrolling is handled in "draw"

                const {width, height} = this.viewport.getBoundingClientRect();

                const str = (this.trackView.track.name || this.trackView.track.id).replace(/\W/g, '');
                const id = `${str}_sample_names_guid_${domUtils.guid()}`;

                context.saveWithTranslationAndClipRect(id, deltaX, deltaY + yScrollDelta, width, height, -yScrollDelta);

                this.draw({context, samples});

                context.restore();
            }
        }

        addMouseHandlers() {
            this.addViewportContextMenuHandler(this.viewport);
        }

        removeMouseHandlers() {
            this.removeViewportContextMenuHandler(this.viewport);
        }

        addViewportContextMenuHandler(viewport) {
            this.boundContextMenuHandler = contextMenuHandler.bind(this);
            viewport.addEventListener('contextmenu', this.boundContextMenuHandler);

            function contextMenuHandler(event) {

                event.preventDefault();
                event.stopPropagation();

                const config =
                    {
                        label: 'Name Panel Width',
                        value: this.browser.sampleNameViewportWidth,
                        callback: newWidth => {
                            this.browser.sampleNameViewportWidth = parseInt(newWidth);
                            for (let {sampleNameViewport} of this.browser.trackViews) {
                                sampleNameViewport.setWidth(this.browser.sampleNameViewportWidth);
                            }
                            this.browser.layoutChange();
                        }
                    };

                this.browser.inputDialog.present(config, event);
            }

        }

        removeViewportContextMenuHandler(viewport) {
            viewport.removeEventListener('contextmenu', this.boundContextMenuHandler);
        }

        dispose() {
            this.removeMouseHandlers();
            this.viewport.remove();
        }
    }

    function getYFont(context, text, y, height) {
        return y + height - getSampleNameYShim(context, text, height)
    }

    function getSampleNameYShim(context, text, h) {
        const {actualBoundingBoxAscent, actualBoundingBoxDescent} = context.measureText(text);
        return (h - (actualBoundingBoxAscent + actualBoundingBoxDescent)) / 2
    }

    function configureFont(ctx, {textAlign, textBaseline, strokeStyle, fillStyle}, sampleHeight) {
        const pixels = Math.min(sampleHeight, maxFontSize);
        ctx.font = `${pixels}px sans-serif`;
        ctx.textAlign = textAlign;
        ctx.textBaseline = textBaseline;
        ctx.fillStyle = fillStyle;
    }

    const MenuPopup = function (parent) {

        this.popover = domUtils.div({class: 'igv-menu-popup'});
        parent.appendChild(this.popover);

        const header = domUtils.div({class: 'igv-menu-popup-header'});
        this.popover.appendChild(header);

        uiUtils.attachDialogCloseHandlerWithParent(header, () => this.hide());

        this.popoverContent = domUtils.div();
        this.popover.appendChild(this.popoverContent);

        makeDraggable(this.popover, header);

        header.addEventListener('click', e => {
            e.stopPropagation();
            e.preventDefault();
            // absorb click to prevent it leaking through to parent DOM element
        });

        this.hide();

    };

    MenuPopup.prototype.hide = function () {
        this.popover.style.display = 'none';
    };

    MenuPopup.prototype.presentMenuList = function (menuList) {

        hideAllMenuPopups();

        if (menuList.length > 0) {

            this.popoverContent.innerHTML = '';

            menuList = MenuUtils.trackMenuItemListHelper(menuList, this);

            for (let item of menuList) {

                if (item.init) {
                    item.init();
                }

                let $e = item.object;
                if (0 === menuList.indexOf(item)) {
                    $e.removeClass('igv-track-menu-border-top');
                }

                if ($e.hasClass('igv-track-menu-border-top') || $e.hasClass('igv-menu-popup-check-container')) ; else if ($e.is('div')) {
                    $e.addClass('igv-menu-popup-shim');
                }

                this.popoverContent.appendChild($e.get(0));

            }

            // NOTE: style.display most NOT be 'none' when calculating width. a display = 'none' will always
            //       yield a width of zero (0).
            this.popover.style.display = 'flex';

            const {width} = this.popover.getBoundingClientRect();

            this.popover.style.left = `${-width}px`;
            this.popover.style.top = `${0}px`;

        }
    };

    MenuPopup.prototype.presentTrackContextMenu = function (e, menuItems) {

        this.popoverContent.innerHTML = '';

        const menuElements = createMenuElements(menuItems, this.popover);
        for (let {el} of menuElements) {
            this.popoverContent.appendChild(el);
        }

        present(e, this.popover);

    };

    MenuPopup.prototype.dispose = function () {

        this.popoverContent.innerHTML = '';
        this.popover.innerHTML = '';

        Object.keys(this).forEach(function (key) {
            this[key] = undefined;
        });
    };

    function createMenuElements(itemList, popover) {

        return itemList.map(item => {

            let el;

            if (typeof item === 'string' && '<hr/>' === item) {
                el = document.createElement('hr');
            } else if (typeof item === 'string') {
                el = domUtils.div({class: 'context-menu'});
                el.innerHTML = item;
            } else if (typeof item === 'Node') {
                el = item;
            } else {
                if (typeof item.init === 'function') {
                    item.init();
                }

                if ("checkbox" === item.type) {
                    el = createCheckbox("Show all bases", item.value);
                } else if ("color" === item.type) {

                    const colorPicker = new GenericColorPicker({parent: popover.parentElement, width: 364});
                    colorPicker.configure(undefined, {color: color => item.click(color)});

                    el = domUtils.div({class: 'context-menu'});
                    if (typeof item.label === 'string') {
                        el.innerHTML = item.label;
                    }
                    const clickHandler = e => {
                        colorPicker.show();
                        domUtils.hide(popover);
                        e.preventDefault();
                        e.stopPropagation();
                    };
                    el.addEventListener('click', clickHandler);
                    el.addEventListener('touchend', clickHandler);
                    el.addEventListener('mouseup', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    });
                } else {
                    el = domUtils.div({class: 'context-menu'});
                    if (typeof item.label === 'string') {
                        el.innerHTML = item.label;
                    }
                }

                if (item.click && "color" !== item.type) {
                    el.addEventListener('click', handleClick);
                    el.addEventListener('touchend', handleClick);
                    el.addEventListener('mouseup', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    });

                    // eslint-disable-next-line no-inner-declarations
                    function handleClick(e) {
                        item.click();
                        domUtils.hide(popover);
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
            }

            return {el, init: item.init}
        })

    }

    function present(e, popover) {

        // NOTE: style.display most NOT be 'none' when calculating width. a display = 'none' will always
        //       yield a width of zero (0).
        popover.style.display = 'flex';

        const {x, y} = domUtils.translateMouseCoordinates(e, popover.parentNode);
        const {width} = popover.getBoundingClientRect();
        const xmax = x + width;

        const {width: parentWidth} = popover.parentNode.getBoundingClientRect();

        popover.style.left = `${xmax > parentWidth ? (x - (xmax - parentWidth)) : x}px`;
        popover.style.top = `${y}px`;

    }

    const hideAllMenuPopups = () => {

        const menus = document.querySelectorAll('.igv-menu-popup');
        for (let i = 0; i < menus.length; i++) {
            menus[i].style.display = 'none';
        }

    };

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const igv_axis_column_width = 50;
    const scrollbarExclusionTypes = new Set(['ruler', 'ideogram']);
    const colorPickerExclusionTypes = new Set(['ruler', 'sequence', 'ideogram']);

    class TrackView {

        constructor(browser, columnContainer, track) {
            this.browser = browser;
            this.track = track;
            track.trackView = this;
            this.addDOMToColumnContainer(browser, columnContainer, browser.referenceFrameList);
        }

        /**
         * Start a spinner for the track on any of its viewports.  In practice this is called during initialization
         * when there is only one.
         */
        startSpinner() {
            if (this.viewports && this.viewports.length > 0) {
                this.viewports[0].startSpinner();
            }
        }

        stopSpinner() {
            if (this.viewports && this.viewports.length > 0) {
                this.viewports[0].stopSpinner();
            }
        }

        addDOMToColumnContainer(browser, columnContainer, referenceFrameList) {

            // Axis
            this.axis = this.createAxis(browser, this.track);

            // Create a viewport for each reference frame
            this.viewports = [];
            const viewportWidth = browser.calculateViewportWidth(referenceFrameList.length);
            const viewportColumns = columnContainer.querySelectorAll('.igv-column');
            for (let i = 0; i < viewportColumns.length; i++) {
                const viewport = createViewport(this, viewportColumns[i], referenceFrameList[i], viewportWidth);
                this.viewports.push(viewport);
            }

            // SampleName Viewport
            this.sampleNameViewport = new SampleNameViewport(this, browser.columnContainer.querySelector('.igv-sample-name-column'), undefined, browser.sampleNameViewportWidth);

            // Track Scrollbar
            this.createTrackScrollbar(browser);

            // Track Drag
            this.createTrackDragHandle(browser);

            // Track Gear
            this.createTrackGearPopup(browser);

        }

        createAxis(browser, track) {

            const axis = domUtils.div();
            browser.columnContainer.querySelector('.igv-axis-column').appendChild(axis);

            axis.style.height = `${track.height}px`;

            if (typeof track.paintAxis === 'function') {
                if (track.dataRange) {
                    axis.addEventListener('click', () => {
                        browser.dataRangeDialog.configure(this);
                        browser.dataRangeDialog.present($$1(browser.columnContainer));
                    });
                }


                const {width, height} = axis.getBoundingClientRect();
                this.axisCanvas = document.createElement('canvas');
                this.axisCanvas.style.width = `${width}px`;
                this.axisCanvas.style.height = `${height}px`;
                axis.appendChild(this.axisCanvas);
            }

            return axis

        }

        resizeAxisCanvas(width, height) {

            this.axis.style.width = `${width}px`;
            this.axis.style.height = `${height}px`;

            if (typeof this.track.paintAxis === 'function') {
                // Size the canvas in CSS (logical) pixels.  The buffer size will be set when painted.
                this.axisCanvas.style.width = `${width}px`;
                this.axisCanvas.style.height = `${height}px`;

            }
        }

        removeDOMFromColumnContainer() {

            // Axis
            if (this.boundAxisClickHander) {
                this.removeAxisEventListener(this.axis);
            }
            this.axis.remove();

            // Track Viewports
            for (let viewport of this.viewports) {
                viewport.$viewport.remove();
            }

            // SampleName Viewport
            this.sampleNameViewport.dispose();

            // empty trackScrollbar Column
            this.removeTrackScrollMouseHandlers();
            this.outerScroll.remove();

            // empty trackDrag Column
            this.removeTrackDragMouseHandlers();
            this.dragHandle.remove();

            // empty trackGear Column
            this.removeTrackGearMouseHandlers();
            this.gearContainer.remove();

        }

        renderSVGContext(context, {deltaX, deltaY}) {

            renderSVGAxis(context, this.track, this.axisCanvas, deltaX, deltaY);

            const {width: axisWidth} = this.axis.getBoundingClientRect();

            const {y} = this.viewports[0].$viewport.get(0).getBoundingClientRect();

            let delta =
                {
                    deltaX: axisWidth + deltaX,
                    deltaY: y + deltaY
                };

            for (let viewport of this.viewports) {
                viewport.renderSVGContext(context, delta);
                const {width} = viewport.$viewport.get(0).getBoundingClientRect();
                delta.deltaX += width;
            }
            
            if (true === this.browser.showSampleNames) {
                this.sampleNameViewport.renderSVGContext(context, delta);
            }
        }

        dataRange() {
            return this.track.dataRange ? this.track.dataRange : undefined
        }

        setDataRange(min, max) {
            if (min !== undefined) {
                this.track.dataRange.min = min;
            }
            if (max !== undefined) {
                this.track.dataRange.max = max;
            }
            this.track.autoscale = false;
            this.repaintViews();
        }

        presentColorPicker(key) {

            if (false === colorPickerExclusionTypes.has(this.track.type)) {

                const trackColors = [];
                const color = this.track.color || this.track.defaultColor;
                if (isString$2(color)) {
                    trackColors.push(color);
                }
                if (this.track.altColor && isString$2(this.track.altColor)) {
                    trackColors.push(this.track.altColor);
                }
                const defaultColors = trackColors.map(c => c.startsWith("#") ? c : c.startsWith("rgb(") ? IGVColor.rgbToHex(c) : IGVColor.colorNameToHex(c));
                const colorHandlers =
                    {
                        color: color => {
                            this.track.color = color;
                            this.repaintViews();
                        },
                        altColor: color => {
                            this.track.altColor = color;
                            this.repaintViews();
                        }

                    };
                this.browser.genericColorPicker.configure(defaultColors, colorHandlers);
                this.browser.genericColorPicker.setActiveColorHandler(key);
                this.browser.genericColorPicker.show();
            }

        }

        setTrackHeight(newHeight, force) {

            if (!force) {
                if (this.track.minHeight) {
                    newHeight = Math.max(this.track.minHeight, newHeight);
                }
                if (this.track.maxHeight) {
                    newHeight = Math.min(this.track.maxHeight, newHeight);
                }
            }

            this.track.height = newHeight;

            this.resizeAxisCanvas(this.axis.clientWidth, this.track.height);

            if (typeof this.track.paintAxis === 'function') {
                this.paintAxis();
            }

            for (let {$viewport} of this.viewports) {
                $viewport.height(newHeight);
            }

            this.sampleNameViewport.viewport.style.height = `${newHeight}px`;

            // If the track does not manage its own content height set it equal to the viewport height here
            if (typeof this.track.computePixelHeight !== "function") {
                for (let vp of this.viewports) {
                    vp.setContentHeight(newHeight);
                }
            }

            this.repaintViews();

            if (false === scrollbarExclusionTypes.has(this.track.type)) {
                this.updateScrollbar();
            }

            this.dragHandle.style.height = `${newHeight}px`;
            this.gearContainer.style.height = `${newHeight}px`;

        }

        updateScrollbar() {

            const viewportHeight = this.viewports[0].$viewport.height();
            this.outerScroll.style.height = `${viewportHeight}px`;

            const viewportContentHeight = this.maxViewportContentHeight();
            const innerScrollHeight = Math.round((viewportHeight / viewportContentHeight) * viewportHeight);

            if (viewportContentHeight > viewportHeight) {
                this.innerScroll.style.display = 'block';
                this.innerScroll.style.height = `${innerScrollHeight}px`;
            } else {
                this.innerScroll.style.display = 'none';
            }
        }

        moveScroller(delta) {

            const y = $$1(this.innerScroll).position().top + delta;
            const top = Math.min(Math.max(0, y), this.outerScroll.clientHeight - this.innerScroll.clientHeight);
            $$1(this.innerScroll).css('top', `${top}px`);

            const contentHeight = this.maxViewportContentHeight();
            const contentTop = -Math.round(top * (contentHeight / this.viewports[0].$viewport.height()));

            for (let viewport of this.viewports) {
                viewport.setTop(contentTop);
            }

            this.sampleNameViewport.trackScrollDelta = delta;
            this.sampleNameViewport.setTop(contentTop);

        }

        isLoading() {
            for (let viewport of this.viewports) {
                if (viewport.isLoading()) return true
            }
        }

        /**
         * Repaint all viewports without loading any new data.   Use this for events that change visual aspect of data,
         * e.g. color, sort order, etc, but do not change the genomic state.
         */
        repaintViews() {

            for (let viewport of this.viewports) {
                if (viewport.isVisible()) {
                    viewport.repaint();
                }
            }

            if (typeof this.track.paintAxis === 'function') {
                this.paintAxis();
            }

            // Repaint sample names last
            this.repaintSamples();
        }

        repaintSamples() {

            if (typeof this.track.getSamples === 'function') {
                const samples = this.track.getSamples();
                this.sampleNameViewport.repaint(samples);
            }
        }

        // track labels
        setTrackLabelName(name) {
            this.viewports.forEach(viewport => viewport.setTrackLabel(name));
        }

        /**
         * Called in response to a window resize event, change in # of multilocus panels, or other event that changes
         * the width of the track view.
         *
         * @param viewportWidth  The width of each viewport in this track view.
         */
        resize(viewportWidth) {
            for (let viewport of this.viewports) {
                viewport.setWidth(viewportWidth);
            }
        }

        /**
         * Update viewports to reflect current genomic state, possibly loading additional data.
         *
         * @param force - if true, force a repaint even if no new data is loaded
         * @returns {Promise<void>}
         */
        async updateViews() {

            if (!(this.browser && this.browser.referenceFrameList)) return

            const visibleViewports = this.viewports.filter(viewport => viewport.isVisible());

            // Shift viewports left/right to current genomic state (pans canvas)
            visibleViewports.forEach(viewport => viewport.shift());

            // If dragging (panning) return
            if (this.browser.dragObject) {
                return
            }

            // Filter zoomed out views.  This has the side effect or turning off or no the zoomed out notice
            const viewportsToRepaint = visibleViewports.filter(vp => vp.needsRepaint()).filter(viewport => viewport.checkZoomIn());

            // Get viewports that require a data load
            const viewportsToReload = viewportsToRepaint.filter(viewport => viewport.needsReload());

            // Trigger viewport to load features needed to cover current genomic range
            // NOTE: these must be loaded synchronously, do not user Promise.all,  not all file readers are thread safe
            for (let viewport of viewportsToReload) {
                await viewport.loadFeatures();
            }

            if (this.disposed) return   // Track was removed during load

            // Special case for variant tracks in multilocus view.  The # of rows to allocate to the variant (site)
            // section depends on data from all the views.  We only need to adjust this however if any data was loaded
            // (i.e. reloadableViewports.length > 0)
            if (this.track && typeof this.track.variantRowCount === 'function' && viewportsToReload.length > 0) {
                let maxRow = 0;
                for (let viewport of this.viewports) {
                    if (viewport.featureCache && viewport.featureCache.features) {
                        maxRow = Math.max(maxRow, viewport.featureCache.features.reduce((a, f) => Math.max(a, f.row || 0), 0));
                    }
                }
                const current = this.track.nVariantRows;
                if (current !== maxRow + 1) {
                    this.track.variantRowCount(maxRow + 1);
                    for (let viewport of this.viewports) {
                        viewport.checkContentHeight();
                    }
                }
            }

            if (this.track.autoscale) {
                let allFeatures = [];
                for (let visibleViewport of visibleViewports) {
                    const referenceFrame = visibleViewport.referenceFrame;
                    const start = referenceFrame.start;
                    const end = start + referenceFrame.toBP(visibleViewport.getWidth());
                    if (visibleViewport.featureCache && visibleViewport.featureCache.features) {
                        // If the "features" object has a getMax function use it.  Currently only alignmentContainer implements this, for coverage.
                        if (typeof visibleViewport.featureCache.features.getMax === 'function') {
                            const max = visibleViewport.featureCache.features.getMax(start, end);
                            allFeatures.push({value: max});
                        } else {
                            const viewFeatures = FeatureUtils.findOverlapping(visibleViewport.featureCache.features, start, end);
                            for (let f of viewFeatures) {
                                allFeatures.push(f);
                            }
                        }
                    }
                }
                if (typeof this.track.doAutoscale === 'function') {
                    this.track.dataRange = this.track.doAutoscale(allFeatures);
                } else {
                    this.track.dataRange = doAutoscale(allFeatures);
                }
            }

            const refreshView = (this.track.autoscale || this.track.autoscaleGroup || this.track.type === 'ruler');
            for (let vp of visibleViewports) {
                if (viewportsToRepaint.includes(vp)) {
                    vp.repaint();
                } else if (refreshView) {
                    vp.refresh();
                }
            }

            this.adjustTrackHeight();

            // Repaint sample names last
            this.repaintSamples();

            this.updateRulerViewportLabels();
        }

        clearCachedFeatures() {
            for (let viewport of this.viewports) {
                viewport.clearCache();
            }
        }

        updateRulerViewportLabels() {

            const viewportWidth = this.browser.calculateViewportWidth(this.viewports.length);

            for (let viewport of this.viewports) {
                if ('ruler' === this.track.type) {
                    if (this.viewports.length > 1) {
                        viewport.presentLocusLabel(viewportWidth);
                    } else {
                        viewport.dismissLocusLabel();
                    }
                }
            }

        }

        /**
         * Return a promise to get all in-view features across all viewports.  Used for group autoscaling.
         */
        async getInViewFeatures() {

            if (!(this.browser && this.browser.referenceFrameList)) {
                return []
            }

            let allFeatures = [];
            const visibleViewports = this.viewports.filter(viewport => viewport.isVisible());
            for (let vp of visibleViewports) {

                const referenceFrame = vp.referenceFrame;
                const {chr, start, bpPerPixel} = vp.referenceFrame;
                const end = start + referenceFrame.toBP(vp.getWidth());
                const needsReload = !vp.featureCache || !vp.featureCache.containsRange(chr, start, end, bpPerPixel);

                if (needsReload) {
                    await vp.loadFeatures();
                }
                if (vp.featureCache && vp.featureCache.features) {

                    if (typeof vp.featureCache.features.getMax === 'function') {
                        const max = vp.featureCache.features.getMax(start, end);
                        allFeatures.push({value: max});
                    } else {
                        const vpFeatures = typeof vp.featureCache.queryFeatures === 'function' ?
                            vp.featureCache.queryFeatures(chr, start, end) :
                            FeatureUtils.findOverlapping(vp.featureCache.features, start, end);
                        allFeatures = allFeatures.concat(vpFeatures);
                    }
                }
            }
            return allFeatures
        }

        checkContentHeight() {

            for (let viewport of this.viewports) {
                viewport.checkContentHeight();
            }
            this.adjustTrackHeight();

        }

        adjustTrackHeight() {

            var contentHeight = this.maxViewportContentHeight();
            if (this.track.autoHeight) {
                this.setTrackHeight(contentHeight, false);
            } else if (this.track.paintAxis) {   // Avoid duplication, paintAxis is already called in setTrackHeight
                this.paintAxis();
            }

            if (false === scrollbarExclusionTypes.has(this.track.type)) {

                // Adjust scrollbar, if needed, to insure content is in view
                const currentTop = this.viewports[0].getContentTop();
                const viewportHeight = this.viewports[0].$viewport.height();
                const minTop = Math.min(0, viewportHeight - contentHeight);
                if(currentTop < minTop) {
                     for (let viewport of this.viewports) {
                        viewport.setTop(minTop);
                    }
                }
                this.updateScrollbar();
            }
        }

        createTrackScrollbar(browser) {

            const outerScroll = domUtils.div();
            browser.columnContainer.querySelector('.igv-scrollbar-column').appendChild(outerScroll);
            outerScroll.style.height = `${this.track.height}px`;
            this.outerScroll = outerScroll;

            if (false === scrollbarExclusionTypes.has(this.track.type)) {
                const innerScroll = domUtils.div();
                outerScroll.appendChild(innerScroll);
                this.innerScroll = innerScroll;

                this.addTrackScrollMouseHandlers(browser);
            }

        }

        createTrackDragHandle(browser) {

            const className = 'ideogram' === this.track.type || 'ruler' === this.track.type ? 'igv-track-drag-shim' : 'igv-track-drag-handle';
            this.dragHandle = domUtils.div({class: className});
            browser.columnContainer.querySelector('.igv-track-drag-column').appendChild(this.dragHandle);
            this.dragHandle.style.height = `${this.track.height}px`;

            this.addTrackDragMouseHandlers(browser);

        }

        createTrackGearPopup(browser) {

            this.gearContainer = domUtils.div();
            browser.columnContainer.querySelector('.igv-gear-menu-column').appendChild(this.gearContainer);
            this.gearContainer.style.height = `${this.track.height}px`;

            if (true === this.track.ignoreTrackMenu) ; else {

                this.gear = domUtils.div();
                this.gearContainer.appendChild(this.gear);
                this.gear.appendChild(icons$1.createIcon('cog'));

                this.trackGearPopup = new MenuPopup(this.gear);

                this.addTrackGearMouseHandlers();
            }

        }

        addAxisEventListener(axis) {

            this.boundAxisClickHander = axisClickHandler.bind(this);
            axis.addEventListener('click', this.boundAxisClickHander);

            function axisClickHandler(event) {
                this.browser.dataRangeDialog.configure(this);
                this.browser.dataRangeDialog.present($$1(this.browser.columnContainer));
            }

        }

        removeAxisEventListener(axis) {
            axis.removeEventListener('click', this.boundAxisClickHander);
        }

        addTrackScrollMouseHandlers(browser) {

            // Mouse Down
            this.boundTrackScrollMouseDownHandler = trackScrollMouseDownHandler.bind(this);
            this.innerScroll.addEventListener('mousedown', this.boundTrackScrollMouseDownHandler);

            function trackScrollMouseDownHandler(event) {

                event.stopPropagation();

                const {y} = domUtils.pageCoordinates(event);

                $$1(this.innerScroll).data('yDown', y.toString());

                this.boundColumnContainerMouseMoveHandler = columnContainerMouseMoveHandler.bind(this);
                browser.columnContainer.addEventListener('mousemove', this.boundColumnContainerMouseMoveHandler);

                function columnContainerMouseMoveHandler(event) {

                    event.stopPropagation();

                    const {y} = domUtils.pageCoordinates(event);

                    this.moveScroller(y - parseInt($$1(this.innerScroll).data('yDown')));

                    $$1(this.innerScroll).data('yDown', y.toString());

                }
            }

            this.boundColumnContainerMouseUpHandler = columnContainerMouseUpHandler.bind(this);
            browser.columnContainer.addEventListener('mouseup', this.boundColumnContainerMouseUpHandler);

            function columnContainerMouseUpHandler(event) {
                browser.columnContainer.removeEventListener('mousemove', this.boundColumnContainerMouseMoveHandler);
            }

        }

        removeTrackScrollMouseHandlers() {
            if (false === scrollbarExclusionTypes.has(this.track.type)) {
                this.innerScroll.removeEventListener('mousedown', this.boundTrackScrollMouseDownHandler);
                this.browser.columnContainer.removeEventListener('mouseup', this.boundColumnContainerMouseUpHandler);
                this.browser.columnContainer.removeEventListener('mousemove', this.boundColumnContainerMouseMoveHandler);
            }
        }

        addTrackDragMouseHandlers(browser) {

            if ('ideogram' === this.track.id || 'ruler' === this.track.id) ; else {

                let currentDragHandle = undefined;

                // Mouse Down
                this.boundTrackDragMouseDownHandler = trackDragMouseDownHandler.bind(this);
                this.dragHandle.addEventListener('mousedown', this.boundTrackDragMouseDownHandler);

                function trackDragMouseDownHandler(event) {

                    event.preventDefault();

                    currentDragHandle = event.target;
                    currentDragHandle.classList.add('igv-track-drag-handle-hover');

                    browser.startTrackDrag(this);

                }

                // Mouse Up
                this.boundDocumentTrackDragMouseUpHandler = documentTrackDragMouseUpHandler.bind(this);
                document.addEventListener('mouseup', this.boundDocumentTrackDragMouseUpHandler);

                function documentTrackDragMouseUpHandler(event) {

                    browser.endTrackDrag();

                    if (currentDragHandle && event.target !== currentDragHandle) {
                        currentDragHandle.classList.remove('igv-track-drag-handle-hover');
                    }

                    currentDragHandle = undefined;
                }

                // Mouse Enter
                this.boundTrackDragMouseEnterHandler = trackDragMouseEnterHandler.bind(this);
                this.dragHandle.addEventListener('mouseenter', this.boundTrackDragMouseEnterHandler);

                function trackDragMouseEnterHandler(event) {
                    event.preventDefault();

                    if (undefined === currentDragHandle) {
                        event.target.classList.add('igv-track-drag-handle-hover');
                    }

                    browser.updateTrackDrag(this);

                }

                // Mouse Out
                this.dragHandle.addEventListener('mouseout', e => {
                    e.preventDefault();

                    if (undefined === currentDragHandle) {
                        e.target.classList.remove('igv-track-drag-handle-hover');
                    }
                });

                this.boundTrackDragMouseOutHandler = trackDragMouseOutHandler.bind(this);
                this.dragHandle.addEventListener('mouseout', this.boundTrackDragMouseOutHandler);

                function trackDragMouseOutHandler(event) {
                    event.preventDefault();

                    if (undefined === currentDragHandle) {
                        event.target.classList.remove('igv-track-drag-handle-hover');
                    }
                }

            }

        }

        removeTrackDragMouseHandlers() {

            if ('ideogram' === this.track.id || 'ruler' === this.track.id) ; else {
                this.dragHandle.removeEventListener('mousedown', this.boundTrackDragMouseDownHandler);
                document.removeEventListener('mouseup', this.boundDocumentTrackDragMouseUpHandler);
                this.dragHandle.removeEventListener('mouseup', this.boundTrackDragMouseEnterHandler);
                this.dragHandle.removeEventListener('mouseout', this.boundTrackDragMouseOutHandler);
            }

        }

        addTrackGearMouseHandlers() {
            if (true === this.track.ignoreTrackMenu) ; else {

                this.boundTrackGearClickHandler = trackGearClickHandler.bind(this);
                this.gear.addEventListener('click', this.boundTrackGearClickHandler);

                function trackGearClickHandler(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.trackGearPopup.presentMenuList(MenuUtils.trackMenuItemList(this));
                }

            }

        }

        removeTrackGearMouseHandlers() {
            if (true === this.track.ignoreTrackMenu) ; else {
                this.gear.removeEventListener('click', this.boundTrackGearClickHandler);
            }

        }

        /**
         * Do any cleanup here
         */
        dispose() {

            this.removeAxisEventListener(this.axis);
            this.axis.remove();

            for (let viewport of this.viewports) {
                viewport.dispose();
            }

            this.sampleNameViewport.dispose();

            this.removeTrackScrollMouseHandlers();
            this.outerScroll.remove();

            this.removeTrackDragMouseHandlers();
            this.dragHandle.remove();

            this.removeTrackGearMouseHandlers();
            this.gearContainer.remove();

            if (typeof this.track.dispose === "function") {
                this.track.dispose();
            }

            for (let key of Object.keys(this)) {
                this[key] = undefined;
            }

            if (this.alert) {
                this.alert.container.remove();    // This is quite obviously a hack, need a "dispose" method on AlertDialog
            }

            this.disposed = true;
        }

        paintAxis() {

            if (typeof this.track.paintAxis === 'function') {

                // Set the canvas buffer size, this is the resolution it is drawn at.  This is done here in case the browser
                // has been drug between screens at different dpi resolutions since the last repaint
                const {width, height} = this.axisCanvas.getBoundingClientRect();
                const dpi = window.devicePixelRatio || 1;
                this.axisCanvas.height = dpi * height;
                this.axisCanvas.width = dpi * width;

                // Get a scaled context to draw aon
                const axisCanvasContext = this.axisCanvas.getContext('2d');
                axisCanvasContext.scale(dpi, dpi);

                this.track.paintAxis(axisCanvasContext, width, height);
            }
        }

        maxViewportContentHeight() {
            return Math.max(this.viewports.map(viewport => viewport.getContentHeight()))
        }

    }

    function renderSVGAxis(context, track, axisCanvas, deltaX, deltaY) {

        if (typeof track.paintAxis === 'function') {

            const {y, width, height} = axisCanvas.getBoundingClientRect();

            const str = (track.name || track.id).replace(/\W/g, '');
            const id = `${str}_axis_guid_${domUtils.guid()}`;

            context.saveWithTranslationAndClipRect(id, deltaX, y + deltaY, width, height, 0);

            track.paintAxis(context, width, height);

            context.restore();
        }

    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const DEFAULT_COLOR$1 = 'rgb(150, 150, 150)';

    class WigTrack extends TrackBase {

        static defaults = {
            height: 50,
            flipAxis: false,
            logScale: false,
            windowFunction: 'mean',
            graphType: 'bar',
            autoscale: true,
            normalize: undefined,
            scaleFactor: undefined
        }

        constructor(config, browser) {
            super(config, browser);
        }

        init(config) {

            super.init(config);

            this.type = "wig";
            this.featureType = 'numeric';
            this.paintAxis = paintAxis;

            const format = config.format ? config.format.toLowerCase() : config.format;
            if (config.featureSource) {
                this.featureSource = config.featureSource;
                delete config.featureSource;
            } else if ("bigwig" === format) {
                this.featureSource = new BWSource(config, this.browser.genome);
            } else if ("tdf" === format) {
                this.featureSource = new TDFSource(config, this.browser.genome);
            } else {
                this.featureSource = FeatureSource(config, this.browser.genome);
            }


            // Override autoscale default
            if(config.max === undefined || config.autoscale === true) {
                this.autoscale = true;
            } else {
                this.dataRange = {
                    min: config.min || 0,
                    max: config.max
                };
            }
        }

        async postInit() {
            const header = await this.getHeader();
            if (this.disposed) return   // This track was removed during async load
            if (header) this.setTrackProperties(header);
        }

        async getFeatures(chr, start, end, bpPerPixel) {
            const features = await this.featureSource.getFeatures({
                chr,
                start,
                end,
                bpPerPixel,
                visibilityWindow: this.visibilityWindow,
                windowFunction: this.windowFunction
            });
            if (this.normalize && this.featureSource.normalizationFactor) {
                const scaleFactor = this.featureSource.normalizationFactor;
                for (let f of features) {
                    f.value *= scaleFactor;
                }
            }
            if (this.scaleFactor) {
                const scaleFactor = this.scaleFactor;
                for (let f of features) {
                    f.value *= scaleFactor;
                }
            }
            return features
        }

        menuItemList() {
            let items = [];

            if (this.flipAxis !== undefined) {
                items.push('<hr>');
                items.push({
                    label: "Flip y-axis",
                    click: () => {
                        this.flipAxis = !this.flipAxis;
                        this.trackView.repaintViews();
                    }
                });
            }

            items = items.concat(MenuUtils.numericDataMenuItems(this.trackView));

            return items
        }

        async getHeader() {

            if (typeof this.featureSource.getHeader === "function") {
                this.header = await this.featureSource.getHeader();
            }
            return this.header
        }

        // TODO: refactor to igvUtils.js
        getScaleFactor(min, max, height, logScale) {
            const scale = logScale ? height / (Math.log10(max + 1) - (min <= 0 ? 0 : Math.log10(min + 1))) : height / (max - min);
            return scale
        }

        computeYPixelValue(yValue, yScaleFactor) {
            return (this.flipAxis ? (yValue - this.dataRange.min) : (this.dataRange.max - yValue)) * yScaleFactor
        }

        computeYPixelValueInLogScale(yValue, yScaleFactor) {
            let maxValue = this.dataRange.max;
            let minValue = this.dataRange.min;
            if (maxValue <= 0) return 0 // TODO:
            if (minValue <= -1) minValue = 0;
            minValue = (minValue <= 0) ? 0 : Math.log10(minValue + 1);
            maxValue = Math.log10(maxValue + 1);
            yValue = Math.log10(yValue + 1);
            return ((this.flipAxis ? (yValue - minValue) : (maxValue - yValue)) * yScaleFactor)
        }

        draw(options) {

            const features = options.features;
            const ctx = options.context;
            const bpPerPixel = options.bpPerPixel;
            const bpStart = options.bpStart;
            const pixelWidth = options.pixelWidth;
            options.pixelHeight;
            const bpEnd = bpStart + pixelWidth * bpPerPixel + 1;
            const posColor = this.color || DEFAULT_COLOR$1;

            let baselineColor;
            if (typeof posColor === "string" && posColor.startsWith("rgb(")) {
                baselineColor = IGVColor.addAlpha(posColor, 0.1);
            }
            const scaleFactor = this.getScaleFactor(this.dataRange.min, this.dataRange.max, options.pixelHeight, this.logScale);
            const yScale = (yValue) => this.logScale
                ? this.computeYPixelValueInLogScale(yValue, scaleFactor)
                : this.computeYPixelValue(yValue, scaleFactor);

            if (features && features.length > 0) {

                if (this.dataRange.min === undefined) this.dataRange.min = 0;

                // Max can be less than min if config.min is set but max left to autoscale.   If that's the case there is
                // nothing to paint.
                if (this.dataRange.max > this.dataRange.min) {

                    let lastPixelEnd = -1;
                    let lastY;
                    const y0 = yScale(0);
                    for (let f of features) {

                        if (f.end < bpStart) continue
                        if (f.start > bpEnd) break

                        const x = Math.floor((f.start - bpStart) / bpPerPixel);
                        if (isNaN(x)) continue

                        let y = yScale(f.value);

                        const rectEnd = Math.ceil((f.end - bpStart) / bpPerPixel);
                        const width = Math.max(1, rectEnd - x);

                        const color = this.getColorForFeature(f);

                        if (this.graphType === "points") {
                            const pointSize = this.config.pointSize || 3;
                            const px = x + width / 2;
                            IGVGraphics.fillCircle(ctx, px, y, pointSize / 2, {"fillStyle": color, "strokeStyle": color});

                        } else if (this.graphType === "line") {
                            if (lastY != undefined) {
                                IGVGraphics.strokeLine(ctx, lastPixelEnd, lastY, x, y, {
                                    "fillStyle": color,
                                    "strokeStyle": color
                                });
                            }
                            IGVGraphics.strokeLine(ctx, x, y, x + width, y, {"fillStyle": color, "strokeStyle": color});
                        } else {
                            const height = y - y0;
                            IGVGraphics.fillRect(ctx, x, y0, width, height, {fillStyle: color});

                        }
                        lastPixelEnd = x + width;
                        lastY = y;
                    }

                    // If the track includes negative values draw a baseline
                    if (this.dataRange.min < 0) {
                        const basepx = (this.dataRange.max / (this.dataRange.max - this.dataRange.min)) * options.pixelHeight;
                        IGVGraphics.strokeLine(ctx, 0, basepx, options.pixelWidth, basepx, {strokeStyle: baselineColor});
                    }
                }
            }

            // Draw guidelines
            if (this.config.hasOwnProperty('guideLines')) {
                for (let line of this.config.guideLines) {
                    if (line.hasOwnProperty('color') && line.hasOwnProperty('y') && line.hasOwnProperty('dotted')) {
                        let y = yScale(line.y);
                        let props = {
                            'strokeStyle': line['color'],
                            'strokeWidth': 2
                        };
                        if (line['dotted']) IGVGraphics.dashedLine(options.context, 0, y, options.pixelWidth, y, 5, props);
                        else IGVGraphics.strokeLine(options.context, 0, y, options.pixelWidth, y, props);
                    }
                }
            }
        }

        popupData(clickState, features) {

            if (features === undefined) features = this.clickedFeatures(clickState);

            if (features && features.length > 0) {

                const genomicLocation = clickState.genomicLocation;
                const popupData = [];

                // Sort features based on distance from click
                features.sort(function (a, b) {
                    const distA = Math.abs((a.start + a.end) / 2 - genomicLocation);
                    const distB = Math.abs((b.start + b.end) / 2 - genomicLocation);
                    return distA - distB
                });

                // Display closest 10
                const displayFeatures = features.length > 10 ? features.slice(0, 10) : features;

                // Resort in ascending order
                displayFeatures.sort(function (a, b) {
                    return a.start - b.start
                });

                for (let selectedFeature of displayFeatures) {
                    if (selectedFeature) {
                        if (popupData.length > 0) {
                            popupData.push('<hr/>');
                        }
                        let posString = (selectedFeature.end - selectedFeature.start) === 1 ?
                            numberFormatter$1(selectedFeature.start + 1)
                            : numberFormatter$1(selectedFeature.start + 1) + "-" + numberFormatter$1(selectedFeature.end);
                        popupData.push({name: "Position:", value: posString});
                        popupData.push({
                            name: "Value:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
                            value: numberFormatter$1(selectedFeature.value)
                        });
                    }
                }
                if (displayFeatures.length < features.length) {
                    popupData.push("<hr/>...");
                }

                return popupData

            } else {
                return []
            }
        }

        get supportsWholeGenome() {
            return !this.config.indexURL && this.config.supportsWholeGenome !== false
        }

        /**
         * Return color for feature.
         * @param feature
         * @returns {string}
         */

        getColorForFeature(f) {
            let c = (f.value < 0 && this.altColor) ? this.altColor : this.color || DEFAULT_COLOR$1;
            return (typeof c === "function") ? c(f.value) : c
        }

        /**
         * Called when the track is removed.  Do any needed cleanup here
         */
        dispose() {
            this.trackView = undefined;
        }

    }

    /**
     *
     * @param cs - object containing
     * 1) array of threshold values defining bin boundaries in ascending order
     * 2) array of colors for bins  (length == thresholds.length + 1)
     * @constructor
     */
    function BinnedColorScale(cs) {
        this.thresholds = cs.thresholds;
        this.colors = cs.colors;
    }

    BinnedColorScale.prototype.getColor = function (value) {

        for (let threshold of this.thresholds) {
            if (value < threshold) {
                return this.colors[this.thresholds.indexOf(threshold)]
            }
        }

        return this.colors[this.colors.length - 1]

    };

    /**
     *
     * @param scale - object with the following properties
     *           low
     *           lowR
     *           lowG
     *           lowB
     *           high
     *           highR
     *           highG
     *           highB
     *
     * @constructor
     */
    function GradientColorScale(scale) {

        this.scale = scale;
        this.lowColor = "rgb(" + scale.lowR + "," + scale.lowG + "," + scale.lowB + ")";
        this.highColor = "rgb(" + scale.highR + "," + scale.highG + "," + scale.highB + ")";
        this.diff = scale.high - scale.low;

    }

    GradientColorScale.prototype.getColor = function (value) {

        var scale = this.scale, r, g, b, frac;

        if (value <= scale.low) return this.lowColor
        else if (value >= scale.high) return this.highColor

        frac = (value - scale.low) / this.diff;
        r = Math.floor(scale.lowR + frac * (scale.highR - scale.lowR));
        g = Math.floor(scale.lowG + frac * (scale.highG - scale.lowG));
        b = Math.floor(scale.lowB + frac * (scale.highB - scale.lowB));

        return "rgb(" + r + "," + g + "," + b + ")"
    };

    class ConstantColorScale {
        constructor(color) {
            this.color = color;
        }

        getColor() {
            return this.color
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class SegTrack extends TrackBase {

        constructor(config, browser) {
            super(config, browser);
        }

        init(config) {
            super.init(config);

            this.type = config.type || "seg";
            if (this.type === 'maf') this.type = 'mut';
            this.isLog = config.isLog;
            this.displayMode = config.displayMode || "EXPANDED"; // EXPANDED | SQUISHED
            this.height = config.height || 300;
            this.maxHeight = config.maxHeight || 500;
            this.squishedRowHeight = config.sampleSquishHeight || config.squishedRowHeight || 2;
            this.expandedRowHeight = config.sampleExpandHeight || config.expandedRowHeight || 13;
            this.sampleHeight = this.squishedRowHeight;      // Initial value, will get overwritten when rendered

            if (config.color) {
                this.color = config.color;
            } else {
                // Color scales for "seg" (copy number) tracks.
                this.posColorScale = config.posColorScale ||
                    new GradientColorScale({
                        low: 0.1,
                        lowR: 255,
                        lowG: 255,
                        lowB: 255,
                        high: 1.5,
                        highR: 255,
                        highG: 0,
                        highB: 0
                    });
                this.negColorScale = config.negColorScale ||
                    new GradientColorScale({
                        low: -1.5,
                        lowR: 0,
                        lowG: 0,
                        lowB: 255,
                        high: -0.1,
                        highR: 255,
                        highG: 255,
                        highB: 255
                    });

                // Default color table for mutation (mut and maf) tracks
                if (this.type === "mut") {
                    this.colorTable = new ColorTable(config.colorTable || MUT_COLORS);
                }
            }

            this.sampleKeys = [];
            this.sampleNames = new Map();
            if (config.samples) {
                // Explicit setting, keys == names
                for (let s of config.samples) {
                    this.sampleKeys.push(s);
                    this.sampleNames.set(s, s);
                }
                this.explicitSamples = true;
            }

            //   this.featureSource = config.sourceType === "bigquery" ?
            //       new igv.BigQueryFeatureSource(this.config) :

            // Disable whole genome downsampling unless explicitly.
            const configCopy = Object.assign({}, this.config);
            configCopy.maxWGCount = configCopy.maxWGCount || Number.MAX_SAFE_INTEGER;
            this.featureSource = FeatureSource(configCopy, this.browser.genome);

            this.initialSort = config.sort;
        }

        async postInit() {
            if (typeof this.featureSource.getHeader === "function") {
                this.header = await this.featureSource.getHeader();
                if(this.disposed) return;   // This track was removed during async load
            }
            // Set properties from track line
            if (this.header) {
                this.setTrackProperties(this.header);
            }
        }


        menuItemList() {

            const menuItems = [];
            const lut =
                {
                    "SQUISHED": "Squish",
                    "EXPANDED": "Expand",
                    "FILL": "Fill"
                };

            menuItems.push('<hr/>');
            menuItems.push("DisplayMode:");

            const displayOptions = this.type === 'seg' ? ["SQUISHED", "EXPANDED", "FILL"] : ["SQUISHED", "EXPANDED"];

            for (let displayMode of displayOptions) {

                const checkBox = createCheckbox(lut[displayMode], displayMode === this.displayMode);
                menuItems.push(
                    {
                        object: $$1(checkBox),
                        click: () => {
                            this.displayMode = displayMode;
                            this.config.displayMode = displayMode;
                            this.trackView.checkContentHeight();
                            this.trackView.repaintViews();
                            this.trackView.moveScroller(this.trackView.sampleNameViewport.trackScrollDelta);
                        }
                    });
            }

            return menuItems

        }

        hasSamples() {
            return true   // SEG, MUT, and MAF tracks have samples by definition
        }

        getSamples() {
            return {
                names: this.sampleKeys.map(key => this.sampleNames.get(key)),
                height: this.sampleHeight,
                yOffset: 0
            }
        }

        async getFeatures(chr, start, end) {
            const features = await this.featureSource.getFeatures({chr, start, end});
            if (this.initialSort) {
                const sort = this.initialSort;
                this.sortSamples(sort.chr, sort.start, sort.end, sort.direction, features);
                this.initialSort = undefined;  // Sample order is sorted,
            }
            return features
        }


        draw({context, renderSVG, pixelTop, pixelWidth, pixelHeight, features, bpPerPixel, bpStart}) {

            IGVGraphics.fillRect(context, 0, pixelTop, pixelWidth, pixelHeight, {'fillStyle': "rgb(255, 255, 255)"});

            if (features && features.length > 0) {

                this.checkForLog(features);

                // New segments could conceivably add new samples
                this.updateSampleKeys(features);

                // Create a map for fast id -> row lookup
                const samples = {};
                this.sampleKeys.forEach(function (id, index) {
                    samples[id] = index;
                });

                let border;
                switch (this.displayMode) {
                    case "FILL":
                        this.sampleHeight = pixelHeight / this.sampleKeys.length;
                        border = 0;
                        break

                    case "SQUISHED":
                        this.sampleHeight = this.squishedRowHeight;
                        border = 0;
                        break
                    default:   // EXPANDED
                        this.sampleHeight = this.expandedRowHeight;
                        border = 1;
                }
                const rowHeight = this.sampleHeight;


                // this.featureMap = new Map()

                for (let segment of features) {
                    segment.pixelRect = undefined;   // !important, reset this in case segment is not drawn
                }

                const pixelBottom = pixelTop + pixelHeight;
                const bpEnd = bpStart + pixelWidth * bpPerPixel + 1;
                const xScale = bpPerPixel;

                this.sampleYStart = undefined;
                for (let f of features) {

                    if (f.end < bpStart) continue
                    if (f.start > bpEnd) break

                    const sampleKey = f.sampleKey || f.sample;
                    f.row = samples[sampleKey];
                    const y = f.row * rowHeight + border;

                    if (undefined === this.sampleYStart) {
                        this.sampleYStart = y;
                    }

                    const bottom = y + rowHeight;

                    if (bottom < pixelTop || y > pixelBottom) {
                        continue
                    }

                    const segmentStart = Math.max(f.start, bpStart);
                    // const segmentStart = segment.start;
                    let x = Math.round((segmentStart - bpStart) / xScale);

                    const segmentEnd = Math.min(f.end, bpEnd);
                    // const segmentEnd = segment.end;
                    const x1 = Math.round((segmentEnd - bpStart) / xScale);
                    let w = Math.max(1, x1 - x);

                    let color;
                    if (this.color) {
                        if (typeof this.color === "function") {
                            color = this.color(f);
                        } else {
                            color = this.color;
                        }
                    } else if (this.colorTable) {
                        color = this.colorTable.getColor(f.value.toLowerCase());
                    }

                    let h;
                    if ("mut" === this.type) {
                        h = rowHeight - 2 * border;
                        if (w < 3) {
                            w = 3;
                            x -= 1;
                        }
                    } else {
                        // Assume seg track
                        let value = f.value;
                        if (!this.isLog) {
                            value = IGVMath.log2(value / 2);
                        }
                        if (value < -0.1) {
                            color = this.negColorScale.getColor(value);
                        } else if (value > 0.1) {
                            color = this.posColorScale.getColor(value);
                        } else {
                            color = "white";
                        }

                        let sh = rowHeight;
                        if (rowHeight < 0.25) {
                            const f = 0.1 + 2 * Math.abs(value);
                            sh = Math.min(1, f * rowHeight);
                        }
                        h = sh - 2 * border;
                    }


                    f.pixelRect = {x, y, w, h};

                    // Use for diagnostic rendering
                    // context.fillStyle = randomRGB(180, 240)
                    // context.fillStyle = randomGrey(200, 255)
                    context.fillStyle = color;
                    context.fillRect(x, y, w, h);
                }

            }

        }


        checkForLog(features) {
            if (this.isLog === undefined) {
                this.isLog = false;
                for (let feature of features) {
                    if (feature.value < 0) {
                        this.isLog = true;
                        return
                    }
                }
            }
        }

        /**
         * Optional method to compute pixel height to accomodate the list of features.  The implementation below
         * has side effects (modifiying the samples hash).  This is unfortunate, but harmless.
         *
         * Note displayMode "FILL" is handled by the viewport
         *
         * @param features
         * @returns {number}
         */
        computePixelHeight(features) {
            if (!features) return 0
            const sampleHeight = ("SQUISHED" === this.displayMode) ? this.squishedRowHeight : this.expandedRowHeight;
            this.updateSampleKeys(features);
            return this.sampleKeys.length * sampleHeight
        }

        /**
         * Sort samples by the average value over the genomic range in the direction indicated (1 = ascending, -1 descending)
         */
        async sortSamples(chr, start, end, direction, featureList) {

            if (!featureList) {
                featureList = await this.featureSource.getFeatures({chr, start, end});
            }
            if (!featureList) return

            this.updateSampleKeys(featureList);

            const scores = {};
            const d2 = (direction === "ASC" ? 1 : -1);

            const sortSeg = () => {
                // Compute weighted average score for each sample
                const bpLength = end - start + 1;
                for (let segment of featureList) {
                    if (segment.end < start) continue
                    if (segment.start > end) break
                    const min = Math.max(start, segment.start);
                    const max = Math.min(end, segment.end);
                    const f = (max - min) / bpLength;
                    const sampleKey = segment.sampleKey || segment.sample;
                    const s = scores[sampleKey] || 0;
                    scores[sampleKey] = s + f * segment.value;
                }

                // Now sort sample names by score
                this.sampleKeys.sort(function (a, b) {
                    let s1 = scores[a];
                    let s2 = scores[b];
                    if (!s1) s1 = d2 * Number.MAX_VALUE;
                    if (!s2) s2 = d2 * Number.MAX_VALUE;
                    if (s1 === s2) return 0
                    else if (s1 > s2) return d2
                    else return d2 * -1
                });
            };

            const sortMut = () => {
                // Compute weighted average score for each sample
                for (let segment of featureList) {
                    if (segment.end < start) continue
                    if (segment.start > end) break
                    const sampleKey = segment.sampleKey || segment.sample;
                    if (!scores.hasOwnProperty(sampleKey) || segment.value.localeCompare(scores[sampleKey]) > 0) {
                        scores[sampleKey] = segment.value;
                    }
                }
                // Now sort sample names by score
                this.sampleKeys.sort(function (a, b) {
                    let sa = scores[a] || "";
                    let sb = scores[b] || "";
                    return d2 * (sa.localeCompare(sb))
                });
            };

            if ("mut" === this.type) {
                sortMut();
            } else {
                sortSeg();
            }

            this.trackView.repaintViews();

        }

        clickedFeatures(clickState) {

            const allFeatures = super.clickedFeatures(clickState);
            const y = clickState.y;
            return allFeatures.filter(function (feature) {
                const rect = feature.pixelRect;
                return rect && y >= rect.y && y <= (rect.y + rect.h)
            })

        }

        hoverText(clickState) {
            const features = this.clickedFeatures(clickState);
            if(features && features.length > 0) {
                return `${features[0].sample}: ${features[0].value}`
            }
        }

        popupData(clickState, featureList) {

            if(featureList === undefined) featureList = this.clickedFeatures(clickState);

            const items = [];

            for (let feature of featureList) {

                // Double line divider between features
                if (items.length > 0) {
                    items.push('<hr/>');
                    items.push('<hr/>');
                }

                // hack for whole genome features, which save the original feature as "_f"
                const f = feature._f || feature;

                const data = (typeof f.popupData === 'function') ?
                    f.popupData(this.type, this.browser.genome.id) :
                    this.extractPopupData(f);
                Array.prototype.push.apply(items, data);

            }

            return items
        }

        contextMenuItemList(clickState) {

            const referenceFrame = clickState.viewport.referenceFrame;
            const genomicLocation = clickState.genomicLocation;

            // Define a region 5 "pixels" wide in genomic coordinates
            const sortDirection = this.config.sort ?
                (this.config.sort.direction === "ASC" ? "DESC" : "ASC") :      // Toggle from previous sort
                "DESC";
            const bpWidth = referenceFrame.toBP(2.5);

            const sortHandler = (sort) => {
                const viewport = clickState.viewport;
                const features = viewport.cachedFeatures;
                this.sortSamples(sort.chr, sort.start, sort.end, sort.direction, features);
            };

            const sortLabel = this.type === 'seg' ? 'Sort by value' : 'Sort by type';

            return [
                {
                    label: sortLabel, click: (e) => {


                        const sort = {
                            direction: sortDirection,
                            chr: clickState.viewport.referenceFrame.chr,
                            start: genomicLocation - bpWidth,
                            end: genomicLocation + bpWidth

                        };

                        sortHandler(sort);

                        this.config.sort = sort;

                    }
                }]

        }

        get supportsWholeGenome() {
            return (this.config.indexed === false || !this.config.indexURL) && this.config.supportsWholeGenome !== false
        }

        updateSampleKeys(featureList) {

            if (this.explicitSamples) return

            for (let feature of featureList) {
                const sampleKey = feature.sampleKey || feature.sample;
                if (!this.sampleNames.has(sampleKey)) {
                    this.sampleNames.set(sampleKey, feature.sample);
                    this.sampleKeys.push(sampleKey);
                }
            }
        }
    }

    // Mut and MAF file default color table

    const MUT_COLORS = {

        "indel": "rgb(0,200,0)",
        "targeted region": "rgb(236,155,43)",
        "truncating": "rgb(	150,0,0)",
        "non-coding transcript": "rgb(0,0,150)",

        // Colors from https://www.nature.com/articles/nature11404
        "synonymous": "rgb(109,165,95)",
        "silent": "rgb(109,135,80)",
        "missense_mutation": "rgb(72,130,187)",
        "missense": "rgb(72,130,187)",
        "splice site": "rgb(143,83,155)",
        "splice_region": "rgb(143,83,155)",
        "nonsense": "rgb(216, 57,81)",
        "nonsense_mutation": "rgb(216, 57,81)",
        "frame_shift_del": "rgb(226,135,65)",
        "frame_shift_ins": "rgb(226,135,65)",
        "in_frame_del": "rgb(247,235,94)",
        "in_frame_ins": "rgb(247,235,94)",
        "*other*": "rgb(159,91,50)"
        //
        // 3'Flank
        // 3'UTR
        // 5'Flank
        // 5'UTR
        // Frame_Shift_Del
        // Frame_Shift_Ins
        // IGR
        // In_Frame_Del
        // In_Frame_Ins
        // Intron
        // Missense_Mutation
        // Nonsense_Mutation
        // Nonstop_Mutation
        // RNA
        // Silent
        // Splice_Region
        // Splice_Site
        // Translation_Start_Site
        // Variant_Classification

    };

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */


    /**
     * Represents 2 or more wig tracks overlaid on a common viewport.
     */
    class MergedTrack extends TrackBase {

        constructor(config, browser) {
            super(config, browser);
            this.type = "merged";
            this.featureType = 'numeric';
            this.paintAxis = paintAxis;
            this.graphType = config.graphType;
        }

        init(config) {
            if (!config.tracks) {
                throw Error("Error: no tracks defined for merged track" + config)
            }

            super.init(config);
        }

        async postInit() {

            this.tracks = [];
            const p = [];
            for (let tconf of this.config.tracks) {
                tconf.isMergedTrack = true;
                const t = await this.browser.createTrack(tconf);
                if (t) {
                    t.autoscale = false;     // Scaling done from merged track
                    this.tracks.push(t);
                } else {
                    console.warn("Could not create track " + tconf);
                }

                if (typeof t.postInit === 'function') {
                    p.push(t.postInit());
                }
            }

            this.flipAxis = this.config.flipAxis ? this.config.flipAxis : false;
            this.logScale = this.config.logScale ? this.config.logScale : false;
            this.autoscale = this.config.autoscale || this.config.max === undefined;
            if (!this.autoscale) {
                this.dataRange = {
                    min: this.config.min || 0,
                    max: this.config.max
                };
            }
            for (let t of this.tracks) {
                t.autoscale = false;
                t.dataRange = this.dataRange;
            }

            this.height = this.config.height || 50;

            return Promise.all(p)
        }

        get height() {
            return this._height
        }

        set height(h) {
            this._height = h;
            if (this.tracks) {
                for (let t of this.tracks) {
                    t.height = h;
                    t.config.height = h;
                }
            }
        }

        menuItemList() {
            let items = [];
            if (this.flipAxis !== undefined) {
                items.push({
                    label: "Flip y-axis",
                    click: () => {
                        this.flipAxis = !this.flipAxis;
                        this.trackView.repaintViews();
                    }
                });
            }

            items = items.concat(MenuUtils.numericDataMenuItems(this.trackView));

            return items
        }

        /**
         * Returns a MergedFeatureCollection containing an array of features for the specified range, 1 for each track.
         */
        async getFeatures(chr, bpStart, bpEnd, bpPerPixel) {

            const promises = this.tracks.map((t) => t.getFeatures(chr, bpStart, bpEnd, bpPerPixel));
            const featureArrays = await Promise.all(promises);
            return new MergedFeatureCollection(featureArrays)
        }

        draw(options) {

            const mergedFeatures = options.features;    // A MergedFeatureCollection

            for (let i = 0, len = this.tracks.length; i < len; i++) {
                const trackOptions = Object.assign({}, options);
                trackOptions.features = mergedFeatures.featureArrays[i];
                this.tracks[i].dataRange = this.dataRange;
                this.tracks[i].flipAxis = this.flipAxis;
                this.tracks[i].logScale = this.logScale;
                if (this.graphType) {
                    this.tracks[i].graphType = this.graphType;
                }
                this.tracks[i].draw(trackOptions);
            }
        }

        popupData(clickState) {

            if(clickState.viewport && clickState.viewport.cachedFeatures) {

                const featuresArray = clickState.viewport.cachedFeatures.featureArrays;

                if (featuresArray && featuresArray.length === this.tracks.length) {
                    // Array of feature arrays, 1 for each track
                    const popupData = [];
                    for (let i = 0; i < this.tracks.length; i++) {
                        if (i > 0) popupData.push('<hr/>');
                        popupData.push(`<div style=background-color:rgb(245,245,245);border-bottom-style:dashed;border-bottom-width:1px;padding-bottom:5px;padding-top:10px;font-weight:bold;font-size:larger >${this.tracks[i].name}</div>`);
                        const trackPopupData = this.tracks[i].popupData(clickState, featuresArray[i]);
                        popupData.push(...trackPopupData);

                    }
                    return popupData
                }
            }
        }

        clickedFeatures(clickState) {


            // We use the cached features rather than method to avoid async load.  If the
            // feature is not already loaded this won't work,  but the user wouldn't be mousing over it either.
            const mergedFeaturesCollection = clickState.viewport.cachedFeatures;

            if(!mergedFeaturesCollection) {
                return [];
            }

            const genomicLocation = clickState.genomicLocation;
            const clickedFeatures = [];
            for(let features of mergedFeaturesCollection.featureArrays) {
                // When zoomed out we need some tolerance around genomicLocation
                const tolerance = (clickState.referenceFrame.bpPerPixel > 0.2) ? 3 * clickState.referenceFrame.bpPerPixel : 0.2;
                const ss = genomicLocation - tolerance;
                const ee = genomicLocation + tolerance;
                const tmp = (FeatureUtils.findOverlapping(features, ss, ee));
                for(let f of tmp) {
                    clickedFeatures.push(f);
                }
            }
            return clickedFeatures;
        }


        get supportsWholeGenome() {
            return this.tracks.every(track => track.supportsWholeGenome)
        }
    }


    class MergedFeatureCollection {

        constructor(featureArrays) {
            this.featureArrays = featureArrays;
        }

        getMax(start, end) {
            let max = -Number.MAX_VALUE;
            for (let a of this.featureArrays) {
                for (let f of a) {
                    if (typeof f.value !== 'undefined' && !Number.isNaN(f.value)) {
                        if (f.end < start) {
                            continue
                        }
                        if (f.start > end) {
                            break
                        }
                        max = Math.max(max, f.value);
                    }
                }
            }
            return max
        }

    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2018 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    function getArcType(config) {
        if (!config.arcType) {
            return "nested"
        }
        switch (config.arcType) {
            case "chiapet":
                return "inView"
            case "chiapetoutbound":
                return "partialInView"
            default:
                return config.arcType
        }
    }

    const DEFAULT_ARC_COLOR = "rgb(180,25,137)";

    class InteractionTrack extends TrackBase {

        static defaults = {
            height: 250,
            theta: Math.PI / 4,
            arcOrientation: true,
            showBlocks: true,
            blockHeight: 3,
            thickness: 1,
            alpha: 0.02,
            logScale: true,
        }

        constructor(config, browser) {
            super(config, browser);
        }

        init(config) {

            super.init(config);

            this.sinTheta = Math.sin(this.theta);
            this.cosTheta = Math.cos(this.theta);
            this.arcType = getArcType(config);   // nested | proportional | inView | partialInView
            this.alpha = config.alpha || 0.02;  // was: 0.15
            this.painter = {flipAxis: !this.arcOrientation, dataRange: this.dataRange, paintAxis: paintAxis};

            if (config.valueColumn) {
                this.valueColumn = config.valueColumn;
                this.hasValue = true;
            } else if (config.useScore) {
                this.hasValue = true;
                this.valueColumn = "score";
            }

            if (config.max) {
                this.dataRange = {
                    min: config.min || 0,
                    max: config.max
                };
                this.autoscale = false;
            } else {
                this.autoscale = true;
            }

            // Create the FeatureSource and override the default whole genome method
            if (config.featureSource) {
                this.featureSource = config.featureSource;
                delete config._featureSource;
            } else {
                this.featureSource = FeatureSource(config, this.browser.genome);
                this.featureSource.getWGFeatures = getWGFeatures;
            }
        }

        async postInit() {

            if (typeof this.featureSource.getHeader === "function") {
                this.header = await this.featureSource.getHeader();
                if (this.disposed) return;   // This track was removed during async load
            }

            // Set properties from track line
            if (this.header) {
                this.setTrackProperties(this.header);
            }

            if (this.visibilityWindow === undefined && typeof this.featureSource.defaultVisibilityWindow === 'function') {
                this.visibilityWindow = await this.featureSource.defaultVisibilityWindow();
                this.featureSource.visibilityWindow = this.visibilityWindow;  // <- this looks odd
            }

            return this
        }

        get supportsWholeGenome() {
            return true
        }

        async getFeatures(chr, start, end) {
            const visibilityWindow = this.visibilityWindow;
            const features = await this.featureSource.getFeatures({chr, start, end, visibilityWindow});

            // Check for score or value
            if (this.hasValue === undefined && features && features.length > 0) {
                this.hasValue = features[0].score !== undefined;
            }

            return features
        }

        draw(options) {

            if (this.arcType === "proportional") {
                this.drawProportional(options);
            } else if (this.arcType === "inView" || this.arcType === "partialInView") {
                this.drawProportional(options);
            } else {
                this.drawNested(options);
            }
        }

        drawNested(options) {

            const ctx = options.context;
            const pixelWidth = options.pixelWidth;
            const pixelHeight = options.pixelHeight;
            const viewportWidth = options.viewportWidth;
            const bpPerPixel = options.bpPerPixel;
            const bpStart = options.bpStart;
            const xScale = bpPerPixel;

            IGVGraphics.fillRect(ctx, 0, options.pixelTop, pixelWidth, pixelHeight, {'fillStyle': "rgb(255, 255, 255)"});

            const featureList = options.features;

            if (featureList) {

                // Autoscale theta
                autoscaleNested.call(this);
                const y = this.arcOrientation ? options.pixelHeight : 0;
                const direction = this.arcOrientation;

                ctx.font = "8px sans-serif";
                ctx.textAlign = "center";

                for (let feature of featureList) {

                    // Reset transient property drawState.  An undefined value => feature has not been drawn.
                    feature.drawState = undefined;

                    let color;
                    if (typeof this.color === 'function') {
                        color = this.color(feature);
                    } else {
                        color = this.color || feature.color || DEFAULT_ARC_COLOR;
                        if (color && this.config.useScore) {
                            color = getAlphaColor(color, scoreShade(feature.score));
                        }
                    }

                    ctx.lineWidth = feature.thickness || this.thickness || 1;

                    if (feature.chr1 === feature.chr2 || feature.chr === 'all') {

                        const {m1, m2} = getMidpoints(feature, this.browser.genome);

                        let pixelStart = Math.round((m1 - bpStart) / xScale);
                        let pixelEnd = Math.round((m2 - bpStart) / xScale);
                        if (pixelEnd < 0 || pixelStart > pixelWidth) continue

                        let w = (pixelEnd - pixelStart);
                        if (w < 3) {
                            w = 3;
                            pixelStart--;
                        }

                        const a = w / 2;
                        const r = a / this.sinTheta;
                        const b = this.cosTheta * r;
                        const xc = pixelStart + a;

                        let yc, startAngle, endAngle;
                        if (direction) { // UP
                            yc = this.height + b;
                            startAngle = Math.PI + Math.PI / 2 - this.theta;
                            endAngle = Math.PI + Math.PI / 2 + this.theta;
                        } else { // DOWN
                            yc = -b;
                            startAngle = Math.PI / 2 - this.theta;
                            endAngle = Math.PI / 2 + this.theta;
                        }

                        if (this.showBlocks && feature.chr !== 'all') {
                            const s1 = (feature.start1 - bpStart) / xScale;
                            const e1 = (feature.end1 - bpStart) / xScale;
                            const s2 = (feature.start2 - bpStart) / xScale;
                            const e2 = (feature.end2 - bpStart) / xScale;
                            const hb = this.arcOrientation ? -this.blockHeight : this.blockHeight;
                            ctx.fillRect(s1, y, e1 - s1, hb);
                            ctx.fillRect(s2, y, e2 - s2, hb);
                        }

                        // Alpha shade (de-emphasize) arcs that extend beyond viewport, unless alpha shading is used for score.
                        if (color && !this.config.useScore && w > viewportWidth) {
                            color = getAlphaColor(color, this.alpha);
                        }
                        ctx.strokeStyle = color;
                        ctx.fillStyle = color;
                        ctx.beginPath();
                        ctx.arc(xc, yc, r, startAngle, endAngle, false);
                        ctx.stroke();
                        feature.drawState = {xc, yc, r};
                    } else {

                        let pixelStart = Math.round((feature.start - bpStart) / xScale);
                        let pixelEnd = Math.round((feature.end - bpStart) / xScale);
                        if (pixelEnd < 0 || pixelStart > pixelWidth) continue

                        let w = (pixelEnd - pixelStart);
                        if (w < 3) {
                            w = 3;
                            pixelStart--;
                        }
                        const otherChr = feature.chr === feature.chr1 ? feature.chr2 : feature.chr1;
                        ctx.strokeStyle = color;
                        // get a sense of trans "spread"
                        ctx.fillStyle = getAlphaColor(getChrColor(otherChr), 0.5);
                        // ctx.fillStyle = color

                        if (direction) {
                            // UP
                            ctx.fillRect(pixelStart, this.height / 2, w, this.height / 2);
                            ctx.fillText(otherChr, pixelStart + w / 2, this.height / 2 - 5);
                            feature.drawState = {x: pixelStart, y: this.height / 2, w: w, h: this.height / 2};
                        } else {
                            ctx.fillRect(pixelStart, 0, w, this.height / 2);
                            ctx.fillText(otherChr, pixelStart + w / 2, this.height / 2 + 13);
                            feature.drawState = {x: pixelStart, y: 0, w: w, h: this.height / 2};
                        }
                    }
                }
            }

            function autoscaleNested() {
                let max = 0;
                for (let feature of featureList) {
                    let pixelStart = (feature.start - bpStart) / xScale;
                    let pixelEnd = (feature.end - bpStart) / xScale;
                    if (pixelStart >= 0 && pixelEnd <= pixelWidth) {
                        max = Math.max(max, pixelEnd - pixelStart);
                    }
                }
                let a = Math.min(viewportWidth, max) / 2;
                if (max > 0) {
                    let coa = (pixelHeight - 10) / a;
                    this.theta = estimateTheta(coa);
                    this.sinTheta = Math.sin(this.theta);
                    this.cosTheta = Math.cos(this.theta);
                }
            }
        }

        getScaleFactor(min, max, height, logScale) {
            const scale = logScale ? height / (Math.log10(max + 1) - (min <= 0 ? 0 : Math.log10(min + 1))) : height / (max - min);
            return scale
        }

        drawProportional(options) {

            const ctx = options.context;
            const pixelWidth = options.pixelWidth;
            const pixelHeight = options.pixelHeight;
            const bpPerPixel = options.bpPerPixel;
            const bpStart = options.bpStart;
            const xScale = bpPerPixel;
            const refStart = options.referenceFrame.start;
            const refEnd = options.referenceFrame.end;


            IGVGraphics.fillRect(ctx, 0, options.pixelTop, pixelWidth, pixelHeight, {'fillStyle': "rgb(255, 255, 255)"});

            const featureList = options.features;

            if (featureList && featureList.length > 0) {

                // we use the min as a filter but not moving the axis
                const effectiveMin = 0;
                const yScale = this.getScaleFactor(effectiveMin, this.dataRange.max, options.pixelHeight - 1, this.logScale);
                const y = this.arcOrientation ? options.pixelHeight : 0;

                for (let feature of featureList) {

                    // Reset transient property drawState.  An undefined value => feature has not been drawn.
                    feature.drawState = undefined;

                    const value = this.valueColumn ? feature[this.valueColumn] : feature.score;
                    if (value === undefined || Number.isNaN(value)) continue

                    const radiusY = Math.round((this.logScale ? Math.log10(value + 1) : value) * yScale);

                    if (feature.chr1 === feature.chr2 || feature.chr === 'all') {

                        const {m1, m2} = getMidpoints(feature, this.browser.genome);

                        let pixelStart = Math.round((m1 - bpStart) / xScale);
                        let pixelEnd = Math.round((m2 - bpStart) / xScale);
                        let w = (pixelEnd - pixelStart);
                        if (w < 3) {
                            w = 3;
                            pixelStart--;
                        }

                        // Various filters
                        if (value < this.dataRange.min || value > this.dataRange.max) continue
                        if ("proportional" !== this.arcType) {
                            const showOutbound = (this.arcType === "partialInView");
                            const within = (m1 >= refStart && m2 <= refEnd);
                            let outBound = false;
                            let inBound = false;
                            if (!within && showOutbound) {
                                outBound = (refStart <= m1 && m1 <= refEnd);
                                if (!outBound) inBound = (refStart <= m2 && m2 <= refEnd);
                            }
                            if (!(within || outBound || inBound)) continue
                        }


                        const radiusX = w / 2;
                        const xc = pixelStart + w / 2;
                        feature.drawState = {xc, yc: y, radiusX, radiusY};

                        // const arcKey = ((pixelStart << 16) | pixelEnd)
                        // let arc = arcCaches.get(arcKey)
                        // if (arc !== undefined) {
                        //     if (arc.has(radiusY)) {
                        //         continue
                        //     }
                        //     arc.add(radiusY)
                        // } else {
                        //     let arcHeights = new Set()
                        //     arcHeights.add(radiusY)
                        //     arcCaches.set(arcKey, arcHeights)
                        // }

                        const counterClockwise = this.arcOrientation ? true : false;
                        const color = feature.color || this.color;
                        ctx.strokeStyle = color;
                        ctx.lineWidth = feature.thickness || this.thickness || 1;

                        if (true === ctx.isSVG) {
                            ctx.strokeEllipse(xc, y, radiusX, radiusY, 0, 0, Math.PI, counterClockwise);
                        } else {
                            ctx.beginPath();
                            ctx.ellipse(xc, y, radiusX, radiusY, 0, 0, Math.PI, counterClockwise);
                            ctx.stroke();
                        }

                        if (this.alpha) {
                            ctx.fillStyle = getAlphaColor(color, this.alpha);
                            if (true === ctx.isSVG) {
                                ctx.fillEllipse(xc, y, radiusX, radiusY, 0, 0, Math.PI, counterClockwise);
                            } else {
                                ctx.fill();
                            }
                        }

                        if (this.showBlocks && feature.chr !== 'all') {
                            ctx.fillStyle = color;
                            const s1 = (feature.start1 - bpStart) / xScale;
                            const e1 = (feature.end1 - bpStart) / xScale;
                            const s2 = (feature.start2 - bpStart) / xScale;
                            const e2 = (feature.end2 - bpStart) / xScale;
                            const hb = this.arcOrientation ? -this.blockHeight : this.blockHeight;
                            ctx.fillRect(s1, y, e1 - s1, hb);
                            ctx.fillRect(s2, y, e2 - s2, hb);
                        }

                    } else {
                        // Inter chromosome
                        let pixelStart = Math.round((feature.start - bpStart) / xScale);
                        let pixelEnd = Math.round((feature.end - bpStart) / xScale);
                        if (pixelEnd < 0 || pixelStart > pixelWidth || value < this.dataRange.min || value > this.dataRange.max) continue

                        const h = Math.min(radiusY, this.height - 13);   // Leave room for text
                        let w = (pixelEnd - pixelStart);
                        if (w < 3) {
                            w = 3;
                            pixelStart--;
                        }
                        const otherChr = feature.chr === feature.chr1 ? feature.chr2 : feature.chr1;
                        ctx.font = "8px sans-serif";
                        ctx.textAlign = "center";
                        // get a sense of trans "spread"
                        ctx.fillStyle = getAlphaColor(getChrColor(otherChr), 0.5);
                        if (this.arcOrientation) {
                            // UP
                            const y = this.height - h;
                            ctx.fillRect(pixelStart, y, w, h);
                            ctx.fillText(otherChr, pixelStart + w / 2, y - 5);
                            feature.drawState = {x: pixelStart, y, w, h};
                        } else {
                            ctx.fillRect(pixelStart, 0, w, h);
                            ctx.fillText(otherChr, pixelStart + w / 2, h + 13);
                            feature.drawState = {x: pixelStart, y: 0, w, h};
                        }
                    }
                }
            }
        }

        clearAxis(ctx, pixelWidth, pixelHeight) {
            IGVGraphics.fillRect(ctx, 0, 0, pixelWidth, pixelHeight, {'fillStyle': "rgb(255, 255, 255)"});
        }

        paintAxis(ctx, pixelWidth, pixelHeight) {
            // dataRane is interpreted differently for interactino tracks -- all arcs are drawn from "zero", irrespective of dataRange.min
            const axisRange = {min: 0, max: this.dataRange.max};
            if (this.arcType === "proportional") {
                this.painter.flipAxis = !this.arcOrientation;
                this.painter.dataRange = axisRange;
                this.painter.paintAxis(ctx, pixelWidth, pixelHeight);
            } else if (this.arcType === "inView" || this.arcType === "partialInView") {
                this.painter.flipAxis = !this.arcOrientation;
                this.painter.dataRange = axisRange;
                this.painter.paintAxis(ctx, pixelWidth, pixelHeight);
            } else {
                this.clearAxis(ctx, pixelWidth, pixelHeight);
            }
        }

        menuItemList() {

            let items = [];

            if (this.hasValue) {
                items.push("<hr/>");
                const lut =
                    {
                        "nested": "Nested",
                        "proportional": "Proportional - All",
                        "inView": "Proportional - Both Ends in View",
                        "partialInView": "Proportional - One End in View"
                    };
                items.push("<b>Arc Type</b>");
                for (let arcType of ["nested", "proportional", "inView", "partialInView"]) {
                    items.push(
                        {
                            object: $$1(createCheckbox(lut[arcType], arcType === this.arcType)),
                            click: () => {
                                this.arcType = arcType;
                                this.trackView.repaintViews();
                            }
                        });
                }
            }
            items.push("<hr/>");

            items.push({
                name: "Toggle arc direction",
                click: () => {
                    this.arcOrientation = !this.arcOrientation;
                    this.trackView.repaintViews();
                }
            });
            items.push({
                name: this.showBlocks ? "Hide Blocks" : "Show Blocks",
                click: () => {
                    this.showBlocks = !this.showBlocks;
                    this.trackView.repaintViews();
                }
            });


            if (this.arcType === "proportional" || this.arcType === "inView" || this.arcType === "partialInView") {
                // MenuUtils.numericDataMenuItems(this.trackView).forEach(item => items.push(item))
                items = items.concat(MenuUtils.numericDataMenuItems(this.trackView));
            }

            if (this.browser.circularView) {
                items.push('<hr/>');
                items.push({
                    label: 'Add interactions to circular view',
                    click: () => {
                        for (let viewport of this.trackView.viewports) {
                            this.addChordsForViewport(viewport.referenceFrame);
                        }
                    }
                });
            }

            return items
        }

        contextMenuItemList(clickState) {

            // Experimental JBrowse feature
            if (this.browser.circularView) {
                const viewport = clickState.viewport;
                const list = [];

                list.push({
                    label: 'Add interactions to circular view',
                    click: () => {
                        const refFrame = viewport.referenceFrame;
                        // first pass: to get all the relevant features
                        this.addChordsForViewport(refFrame);
                    }
                });

                list.push('<hr/>');
                return list
            }
        }

        /**
         * Add chords to the circular view for the given viewport, represented by its reference frame
         * @param refFrame
         */
        addChordsForViewport(refFrame) {
            const cachedFeatures = "all" === refFrame.chr ?
                this.featureSource.getAllFeatures() :
                this.featureSource.featureCache.queryFeatures(refFrame.chr, refFrame.start, refFrame.end);

            // inView features are simply features that have been drawn, i.e. have a drawState
            const inView = cachedFeatures.filter(f => f.drawState);
            if (inView.length === 0) return;

            const chords = makeBedPEChords(inView);
            sendChords(chords, this, refFrame, 0.5);
            //
            //
            // // for filtered set, distinguishing the chromosomes is more critical than tracks
            // const chordSetColor = IGVColor.addAlpha("all" === refFrame.chr ? this.color : getChrColor(refFrame.chr), 0.5)
            // const trackColor = IGVColor.addAlpha(this.color, 0.5)
            //
            // // name the chord set to include locus and filtering information
            // const encodedName = this.name.replaceAll(' ', '%20')
            // const chordSetName = "all" === refFrame.chr ?
            //     encodedName :
            //     `${encodedName} (${refFrame.chr}:${refFrame.start}-${refFrame.end} ; range:${this.dataRange.min}-${this.dataRange.max})`
            // this.browser.circularView.addChords(chords, {track: chordSetName, color: chordSetColor, trackColor: trackColor})
        }

        doAutoscale(features) {

            // if ("proportional" === this.arcType) {
            let max = 0;
            if (features) {
                for (let f of features) {
                    const v = this.valueColumn ? f[this.valueColumn] : f.score;
                    if (!Number.isNaN(v)) {
                        max = Math.max(max, v);
                    }
                }
            }
            return {min: 0, max: max}
            // }
        }

        popupData(clickState, features) {

            if (features === undefined) features = this.clickedFeatures(clickState);

            const data = [];
            for (let feature of features) {

                const f = feature._ || feature;   // For "whole genome" features, which keeps a pointer to the original

                data.push({name: "Region 1", value: positionString(f.chr1, f.start1, f.end1, f.strand1)});
                data.push({name: "Region 2", value: positionString(f.chr2, f.start2, f.end2, f.strand2)});
                if (f.name) {
                    data.push({name: "Name", value: f.name});
                }
                if (f.value !== undefined) {
                    data.push({name: "Value", value: f.value});
                }
                if (f.score !== undefined) {
                    data.push({name: "Score", value: f.score});
                }


                if (f.extras && this.header && this.header.columnNames) {
                    const columnNames = this.header.columnNames;
                    const stdColumns = this.header.hiccups ? 6 : 10;
                    for (let i = stdColumns; i < columnNames.length; i++) {
                        if (this.header.colorColumn === i) continue;
                        if (columnNames[i] === 'info') {
                            extractInfoColumn(data, f.extras[i - stdColumns]);
                        } else {
                            data.push({name: columnNames[i], value: f.extras[i - stdColumns]});
                        }
                    }
                }
                // For now just return the top hit
                break

                //if (data.length > 0) {
                //     data.push("<HR>");
                // }
            }
            return data
        }

        clickedFeatures(clickState) {

            // We use the cached features rather than method to avoid async load.  If the
            // feature is not already loaded this won't work,  but the user wouldn't be mousing over it either.
            const featureList = clickState.viewport.cachedFeatures;
            const candidates = [];
            if (featureList) {
                const proportional = (this.arcType === "proportional" || this.arcType === "inView" || this.arcType === "partialInView");

                for (let feature of featureList) {

                    if (!feature.drawState) continue

                    if (feature.chr1 === feature.chr2 || feature.chr === 'all') {
                        if (proportional) {
                            //(x-xc)^2/radiusX^2 + (y-yc)^2/radiusY^2 <= 1
                            const {xc, yc, radiusX, radiusY} = feature.drawState;
                            const dx = clickState.canvasX - xc;
                            const dy = clickState.canvasY - yc;
                            const score = (dx / radiusX) * (dx / radiusX) + (dy / radiusY) * (dy / radiusY);
                            if (score <= 1) {
                                candidates.push({score: 1 / score, feature});
                            }
                        } else {
                            const {xc, yc, r} = feature.drawState;
                            const dx = clickState.canvasX - xc;
                            const dy = clickState.canvasY - yc;
                            const score = Math.abs(Math.sqrt(dx * dx + dy * dy) - r);
                            if (score < 5) {
                                candidates.push({score, feature});
                            }
                        }
                    } else {
                        const {x, y, w, h} = feature.drawState;
                        const tolerance = 5;
                        if (clickState.canvasX >= x - tolerance && clickState.canvasX <= x + w + tolerance &&
                            clickState.canvasY >= y && clickState.canvasY <= y + h) {
                            const score = -Math.abs(clickState.canvasX - (x + w / 2));
                            candidates.push({score, feature});
                            break
                        }
                    }
                }
            }

            if (candidates.length > 1) {
                candidates.sort((a, b) => a.score - b.score);
            }
            return candidates.map((c) => c.feature)
        }
    }

    function getMidpoints(feature, genome) {
        let m1 = (feature.start1 + feature.end1) / 2;
        let m2 = (feature.start2 + feature.end2) / 2;
        if (feature.chr === 'all') {
            m1 = genome.getGenomeCoordinate(feature.chr1, m1);
            m2 = genome.getGenomeCoordinate(feature.chr2, m2);
        }
        if (m1 > m2) {
            const tmp = m1;
            m1 = m2;
            m2 = tmp;
        }
        return {m1, m2}
    }

    function positionString(chr, start, end, strand) {

        return strand && strand !== '.' ?
            `${chr}:${numberFormatter$1(start + 1)}-${numberFormatter$1(end)} (${strand})` :
            `${chr}:${numberFormatter$1(start + 1)}-${numberFormatter$1(end)}`
    }

    /**
     * Estimate theta given the ratio of track height to 1/2 the feature width (coa).  This relationship is approximately linear.
     */
    function estimateTheta(x) {
        let coa = [0.01570925532366355, 0.15838444032453644, 0.3249196962329063, 0.5095254494944288, 0.7265425280053609, 0.9999999999999999];
        let theta = [0.031415926535897934, 0.3141592653589793, 0.6283185307179586, 0.9424777960769379, 1.2566370614359172, 1.5707963267948966];
        let idx;

        for (idx = 0; idx < coa.length; idx++) {
            if (coa[idx] > x) {
                break
            }
        }

        let left = idx === 0 ? 0 : coa[idx - 1];
        let right = idx < coa.length ? coa[idx] : 1;
        let r = (x - left) / (right - left);

        let thetaLeft = idx === 0 ? 0 : theta[idx - 1];
        let thetaRight = idx < theta.length ? theta[idx] : Math.PI / 2;

        return Math.min(Math.PI/2,  (thetaLeft + r * (thetaRight - thetaLeft)))

    }

    const colorAlphaCache = new Map();

    function getAlphaColor(color, alpha) {
        const key = `${color}_${alpha}`;
        let c = colorAlphaCache.get(key);
        if (!c) {
            c = IGVColor.addAlpha(color, alpha);
            colorAlphaCache.set(key, c);
        }
        return c
    }


    /**
     * Called in the context of FeatureSource  (i.e. this == the feature source (a TextFeatureSource) for the track
     *
     * @param allFeatures
     * @returns {[]}
     */
    function getWGFeatures(allFeatures) {

        const makeWGFeature = (f) => {
            const wg = Object.assign({}, f);
            wg.chr = "all";
            wg.start = genome.getGenomeCoordinate(f.chr1, f.start1);
            wg.end = genome.getGenomeCoordinate(f.chr2, f.end2);
            return wg
        };

        const genome = this.genome;

        // First pass -- find the max score feature
        let maxScoreFeature;
        let totalFeatureCount = 0;
        for (let c of genome.wgChromosomeNames) {
            let chrFeatures = allFeatures[c];
            if (chrFeatures) {
                for (let f of chrFeatures) {
                    if (!f.dup) {
                        totalFeatureCount++;
                        if (f.score && (!maxScoreFeature || f.score > maxScoreFeature.score)) {
                            maxScoreFeature = f;
                        }
                    }
                }
            }
        }

        const maxCount = this.maxWGCount;
        const nBins = maxScoreFeature && maxScoreFeature.score > 0 && totalFeatureCount > maxCount ? 5 : 1;   // TODO make a function of total # of features & maxCount?
        const featuresPerBin = Math.floor(maxCount / nBins);
        const binSize = maxScoreFeature && maxScoreFeature.score > 0 ? Math.log(maxScoreFeature.score) / nBins : Number.MAX_SAFE_INTEGER;

        let binnedFeatures = [];
        let counts = [];
        for (let i = 0; i < nBins; i++) {
            counts.push([0]);
            binnedFeatures.push([]);
        }

        for (let c of genome.wgChromosomeNames) {
            let chrFeatures = allFeatures[c];
            if (chrFeatures) {
                for (let f of chrFeatures) {
                    if (!f.dup) {
                        const bin = f.score  ? Math.max(0, Math.min(nBins - 1, Math.floor(Math.log(f.score) / binSize))) : 0;
                        if (binnedFeatures[bin].length < featuresPerBin) {
                            binnedFeatures[bin].push(makeWGFeature(f));
                        } else {
                            //Reservoir sampling
                            const samplingProb = featuresPerBin / (counts[bin] + 1);
                            if (Math.random() < samplingProb) {
                                const idx = Math.floor(Math.random() * (featuresPerBin - 1));
                                binnedFeatures[bin][idx] = makeWGFeature(f);
                            }
                        }
                        counts[bin]++;
                    }
                }
            }
        }

        let wgFeatures;
        if (nBins === 1) {
            wgFeatures = binnedFeatures[0];
        } else {
            wgFeatures = [];
            for (let bf of binnedFeatures) {
                for (let f of bf) wgFeatures.push(f);
            }
            // Keep the feature with max score
            if (maxScoreFeature) {
                wgFeatures.push(makeWGFeature(maxScoreFeature));
            }
            wgFeatures.sort(function (a, b) {
                return a.start - b.start
            });
            console.log(wgFeatures.length);
        }


        return wgFeatures
    }

    /**
     * Extract a gff style info column for popup text.  This convention used by 10X for bedpe files
     *     ALLELIC_FRAC=0.0375670840787;BLACK1=.;BLACK2=.;...
     * @param data
     * @param str
     */
    function extractInfoColumn(data, str) {
        const kvs = str.split(';');
        for (let t of kvs) {
            const kv = t.split('=');
            if (kv.length === 2) {
                data.push({name: kv[0], value: kv[1]});
            }
        }

    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 University of California San Diego
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const isString = isString$2;

    const DEFAULT_COLOR = "rgb(0,0,150)";
    const DEFAULT_VISIBILITY_WINDOW = 1000000;
    const TOP_MARGIN = 10;
    const STANDARD_FIELDS = new Map([["REF", "referenceBases"], ["ALT", "alternateBases"], ["QUAL", "quality"], ["FILTER", "filter"]]);


    class VariantTrack extends TrackBase {

        static defaults = {
            displayMode: "EXPANDED",
            sortDirection: "ASC",
            showGenotypes: true,
            squishedVariantHeight: 2,
            squishedCallHeight: 1,
            expandedCallHeight: 10,
            expandedVGap: 2,
            squishedVGap: 1,
            expandedGroupGap: 10,
            squishedGroupGap: 5,
            featureHeight: 14,
            noGenotypeColor: "rgb(200,180,180)",
            noCallColor: "rgb(225, 225, 225)",
            nonRefColor: "rgb(200, 200, 215)",
            mixedColor: "rgb(200, 220, 200)",
            homrefColor: "rgb(200, 200, 200)",
            homvarColor: "rgb(17,248,254)",
            hetvarColor: "rgb(34,12,253)",
            colorBy: undefined,
            visibilityWindow: undefined,
            labelDisplayMode: undefined,
            type: "variant"
        }

        constructor(config, browser) {
            super(config, browser);
        }

        init(config) {

            super.init(config);

            this.expandedVariantHeight = config.expandedVariantHeight || config.variantHeight || 10;

            this.featureSource = FeatureSource(config, this.browser.genome);

            this._initColorBy = config.colorBy;
            if (config.colorTable) {
                this.colorTables = new Map();
                this.colorTables.set(config.colorBy, new ColorTable(config.colorTable));
            }
            this._color = config.color;
            this._strokecolor = config.strokecolor;
            this._context_hook = config.context_hook;


            // The number of variant rows are computed dynamically, but start with "1" by default
            this.variantRowCount(1);

        }

        async postInit() {

            this.header = await this.getHeader();   // cricital, don't remove'
            if (this.disposed) return   // This track was removed during async load
            if (undefined === this.visibilityWindow && this.config.indexed !== false) {
                const fn = isFile(this.config.url) ? this.config.url.name : this.config.url;
                if (isString(fn) && fn.toLowerCase().includes("gnomad")) {
                    this.visibilityWindow = 1000;  // these are known to be very dense
                } else if (typeof this.featureSource.defaultVisibilityWindow === 'function') {
                    this.visibilityWindow = await this.featureSource.defaultVisibilityWindow();
                } else {
                    this.visibilityWindow = DEFAULT_VISIBILITY_WINDOW;
                }
            }
            return this

        }

        get supportsWholeGenome() {
            return this.config.indexed === false || this.config.supportsWholeGenome === true
        }

        get color() {
            return this._color || DEFAULT_COLOR
        }

        set color(c) {
            this._color = c;
            this.colorBy = undefined;
        }

        async getHeader() {

            if (!this.header) {
                if (typeof this.featureSource.getHeader === "function") {
                    const header = await this.featureSource.getHeader();
                    if (header) {
                        this.callSets = header.callSets || [];
                    }
                    this.header = header;
                }
                this.sampleNames = this.callSets ? this.callSets.map(cs => cs.name) : [];
            }

            return this.header
        }

        getCallsetsLength() {
            return this.callSets ? this.callSets.length : 0
        }

        async getFeatures(chr, start, end, bpPerPixel) {

            if (this.header === undefined) {
                this.header = await this.getHeader();
            }
            return this.featureSource.getFeatures({chr, start, end, bpPerPixel, visibilityWindow: this.visibilityWindow})
        }

        hasSamples() {
            return this.getCallsetsLength() > 0
        }

        getSamples() {
            return {
                yOffset: this.sampleYOffset,
                names: this.sampleNames,
                height: this.sampleHeight
            }
        }

        /**
         * The required height in pixels required for the track content.   This is not the visible track height, which
         * can be smaller (with a scrollbar) or larger.
         *
         * @param features
         * @returns {*}
         */
        computePixelHeight(features) {

            if (!features || features.length == 0) return TOP_MARGIN

            const nVariantRows = (this.displayMode === "COLLAPSED") ? 1 : this.nVariantRows;
            const vGap = (this.displayMode === "SQUISHED") ? this.squishedVGap : this.expandedVGap;
            const variantHeight = (this.displayMode === "SQUISHED") ? this.squishedVariantHeight : this.expandedVariantHeight;
            const callHeight = (this.displayMode === "SQUISHED") ? this.squishedCallHeight : this.expandedCallHeight;
            const nCalls = this.showGenotypes === false ? 0 : this.getCallsetsLength() * nVariantRows;
            const h = TOP_MARGIN + nVariantRows * (variantHeight + vGap);
            return h + vGap + (nCalls + 1) * (callHeight + vGap)

        }

        variantRowCount(count) {
            this.nVariantRows = count;
        }

        draw({context, pixelWidth, pixelHeight, bpPerPixel, bpStart, pixelTop, features}) {

            IGVGraphics.fillRect(context, 0, pixelTop, pixelWidth, pixelHeight, {'fillStyle': "rgb(255, 255, 255)"});

            const vGap = ("SQUISHED" === this.displayMode) ? this.squishedVGap : this.expandedVGap;
            const rowCount = ("COLLAPSED" === this.displayMode) ? 1 : this.nVariantRows;
            const variantHeight = ("SQUISHED" === this.displayMode) ? this.squishedVariantHeight : this.expandedVariantHeight;
            this.variantBandHeight = TOP_MARGIN + rowCount * (variantHeight + vGap);

            let callSets = this.callSets;
            if (!callSets && this._f) {
                callSets = this._f.callSets;   // "Complementary" variant for structural variants
            }
            const nCalls = this.getCallsetsLength();
            if (callSets && nCalls > 0 && this.showGenotypes !== false) {
                IGVGraphics.strokeLine(context, 0, this.variantBandHeight, pixelWidth, this.variantBandHeight, {strokeStyle: 'rgb(224,224,224) '});
            }

            if (features) {

                const callHeight = ("SQUISHED" === this.displayMode) ? this.squishedCallHeight : this.expandedCallHeight;
                const vGap = ("SQUISHED" === this.displayMode) ? this.squishedVGap : this.expandedVGap;
                const bpEnd = bpStart + pixelWidth * bpPerPixel + 1;

                // Loop through variants.  A variant == a row in a VCF file
                for (let variant of features) {

                    if (variant.end < bpStart) continue
                    if (variant.start > bpEnd) break

                    const variantHeight = ("SQUISHED" === this.displayMode) ? this.squishedVariantHeight : this.expandedVariantHeight;
                    const y = TOP_MARGIN + ("COLLAPSED" === this.displayMode ? 0 : variant.row * (variantHeight + vGap));
                    const h = variantHeight;

                    // Compute pixel width.   Minimum width is 3 pixels,  if > 5 pixels create gap between variants
                    let x = Math.round((variant.start - bpStart) / bpPerPixel);
                    let x1 = Math.round((variant.end - bpStart) / bpPerPixel);
                    let w = Math.max(1, x1 - x);
                    if (w < 3) {
                        w = 3;
                        x -= 1;
                    } else if (w > 5) {
                        x += 1;
                        w -= 2;
                    }
                    context.fillStyle = this.getColorForFeature(variant);
                    context.fillRect(x, y, w, h);

                    //only paint stroke if a color is defined
                    let strokecolor = this.getVariantStrokecolor(variant);
                    if (strokecolor) {
                        context.strokeStyle = strokecolor;
                        context.strokeRect(x, y, w, h);
                    }

                    // call hook if _context_hook fn is defined
                    this.callContextHook(variant, context, x, y, w, h);

                    variant.pixelRect = {x, y, w, h};

                    // Loop though the calls for this variant.  There will potentially be a call for each sample.
                    if (nCalls > 0 && this.showGenotypes !== false) {

                        const nVariantRows = "COLLAPSED" === this.displayMode ? 1 : this.nVariantRows;
                        this.sampleYOffset = this.variantBandHeight + vGap;
                        this.sampleHeight = nVariantRows * (callHeight + vGap);  // For each sample, there is a call for each variant at this position

                        let sampleNumber = 0;
                        if (callSets && variant.calls) {
                            for (let callSet of callSets) {
                                const call = variant.calls[callSet.id];
                                if (call) {
                                    const row = "COLLAPSED" === this.displayMode ? 0 : variant.row;
                                    const py = this.sampleYOffset + sampleNumber * this.sampleHeight + row * (callHeight + vGap);
                                    let allVar = true;  // until proven otherwise
                                    let allRef = true;
                                    let noCall = false;

                                    if (call.genotype) {
                                        for (let g of call.genotype) {
                                            if ('.' === g) {
                                                noCall = true;
                                                break
                                            } else {
                                                if (g !== 0) allRef = false;
                                                if (g === 0) allVar = false;
                                            }
                                        }
                                    }

                                    if (!call.genotype) {
                                        context.fillStyle = this.noGenotypeColor;
                                    } else if (noCall) {
                                        context.fillStyle = this.noCallColor;
                                    } else if (allRef) {
                                        context.fillStyle = this.homrefColor;
                                    } else if (allVar) {
                                        context.fillStyle = this.homvarColor;
                                    } else {
                                        context.fillStyle = this.hetvarColor;
                                    }

                                    context.fillRect(x, py, w, callHeight);

                                    callSet.pixelRect = {x, y: py, w, h: callHeight};
                                }
                                sampleNumber++;
                            }
                        }
                    }
                }

            } else {
                console.log("No feature list");
            }
        };


        getColorForFeature(variant) {

            const v = variant._f || variant;
            let variantColor;

            if (this.colorBy) {
                const colorBy = this.colorBy;
                let value;
                if (v.info.hasOwnProperty(colorBy)) {
                    value = v.info[colorBy];
                } else if (STANDARD_FIELDS.has(colorBy)) {
                    const key = STANDARD_FIELDS.get(colorBy);
                    value = v[key];
                }
                variantColor = this.getVariantColorTable(colorBy).getColor(value);
                if (!variantColor) {
                    variantColor = "gray";
                }

            } else if (this._color) {
                variantColor = (typeof this._color === "function") ? this._color(variant) : this._color;
            } else if ("NONVARIANT" === v.type) {
                variantColor = this.nonRefColor;
            } else if ("MIXED" === v.type) {
                variantColor = this.mixedColor;
            } else {
                variantColor = this.color;
            }
            return variantColor
        }


        getVariantStrokecolor(variant) {

            const v = variant._f || variant;
            let variantStrokeColor;

            if (this._strokecolor) {
                variantStrokeColor = (typeof this._strokecolor === "function") ? this._strokecolor(v) : this._strokecolor;
            } else {
                variantStrokeColor = undefined;
            }
            return variantStrokeColor
        }

        callContextHook(variant, context, x, y, w, h) {
            if (this._context_hook) {
                if (typeof this._context_hook === "function") {
                    const v = variant._f || variant;

                    context.save();
                    this._context_hook(v, context, x, y, w, h);
                    context.restore();
                }
            }
        }

        clickedFeatures(clickState) {

            let featureList = super.clickedFeatures(clickState);

            const vGap = (this.displayMode === 'EXPANDED') ? this.expandedVGap : this.squishedVGap;
            const callHeight = vGap + ("SQUISHED" === this.displayMode ? this.squishedCallHeight : this.expandedCallHeight);
            // Find the variant row (i.e. row assigned during feature packing)
            const yOffset = clickState.y;
            if (yOffset <= this.variantBandHeight) {
                // Variant
                const variantHeight = ("SQUISHED" === this.displayMode) ? this.squishedVariantHeight : this.expandedVariantHeight;
                const variantRow = Math.floor((yOffset - TOP_MARGIN) / (variantHeight + vGap));
                if ("COLLAPSED" !== this.displayMode) {
                    featureList = featureList.filter(f => f.row === variantRow);
                }
            } else if (this.callSets) {
                const callSets = this.callSets;
                const sampleY = yOffset - this.variantBandHeight;
                const sampleRow = Math.floor(sampleY / this.sampleHeight);
                if (sampleRow >= 0 && sampleRow < callSets.length) {
                    const variantRow = Math.floor((sampleY - sampleRow * this.sampleHeight) / callHeight);
                    const variants = "COLLAPSED" === this.displayMode ? featureList : featureList.filter(f => f.row === variantRow);
                    const cs = callSets[sampleRow];
                    featureList = variants.map(v => {
                        const call = v.calls[cs.id];
                        expandGenotype(call, v);
                        return call
                    });
                }
            }

            return featureList
        }


        /**
         * Return "popup data" for feature @ genomic location.  Data is an array of key-value pairs
         */
        popupData(clickState, featureList) {

            if (featureList === undefined) featureList = this.clickedFeatures(clickState);
            const genomicLocation = clickState.genomicLocation;
            const genomeID = this.browser.genome.id;
            const sampleInformation = this.browser.sampleInformation;

            let popupData = [];
            for (let v of featureList) {

                const f = v._f || v;    // Get real variant from psuedo-variant, e.g. whole genome or SV mate

                if (popupData.length > 0) {
                    popupData.push({html: '<hr style="border-top-width:2px ;border-color: #c9c3ba" />'});
                }

                if (typeof f.popupData === 'function') {
                    const v = f.popupData(genomicLocation, genomeID);
                    Array.prototype.push.apply(popupData, v);
                } else {
                    // Assume this is a call (genotype)
                    const call = f;

                    if (call.callSetName !== undefined) {
                        popupData.push({name: 'Name', value: call.callSetName});
                    }

                    if (call.genotypeName) {
                        popupData.push({name: 'Genotype', value: call.genotypeName});
                    }

                    if (call.phaseset !== undefined) {
                        popupData.push({name: 'Phase set', value: call.phaseset});
                    }
                    if (call.genotypeLikelihood !== undefined) {
                        popupData.push({name: 'genotypeLikelihood', value: call.genotypeLikelihood.toString()});
                    }

                    if (sampleInformation) {
                        var attr = sampleInformation.getAttributes(call.callSetName);
                        if (attr) {
                            Object.keys(attr).forEach(function (attrName) {
                                var displayText = attrName.replace(/([A-Z])/g, " $1");
                                displayText = displayText.charAt(0).toUpperCase() + displayText.slice(1);
                                popupData.push({name: displayText, value: attr[attrName]});
                            });
                        }
                    }

                    var infoKeys = Object.keys(call.info);
                    if (infoKeys.length) {
                        popupData.push('<hr/>');
                    }
                    infoKeys.forEach(function (key) {
                        popupData.push({name: key, value: decodeURIComponent(call.info[key])});
                    });
                }
            }
            return popupData

        }


    // VariantTrack.prototype.contextMenuItemList = function (clickState) {
    //
    //     const self = this;
    //     const menuItems = [];
    //
    //     const featureList = this.clickedFeatures(clickState);
    //
    //     if (this.callSets && featureList && featureList.length > 0) {
    //
    //         featureList.forEach(function (variant) {
    //
    //             if ('str' === variant.type) {
    //
    //                 menuItems.push({
    //                     label: 'Sort by allele length',
    //                     click: function () {
    //                         sortCallSetsByAlleleLength(self.callSets, variant, self.sortDirection);
    //                         self.sortDirection = (self.sortDirection === "ASC") ? "DESC" : "ASC";
    //                         self.trackView.repaintViews();
    //                     }
    //                 });
    //
    //             }
    //
    //         });
    //     }
    //
    //
    //     function sortCallSetsByAlleleLength(callSets, variant, direction) {
    //         var d = (direction === "DESC") ? 1 : -1;
    //         Object.keys(callSets).forEach(function (property) {
    //             callSets[property].sort(function (a, b) {
    //                 var aNan = isNaN(variant.calls[a.id].genotype[0]);
    //                 var bNan = isNaN(variant.calls[b.id].genotype[0]);
    //                 if (aNan && bNan) {
    //                     return 0;
    //                 } else if (aNan) {
    //                     return 1;
    //                 } else if (bNan) {
    //                     return -1;
    //                 } else {
    //                     var a0 = getAlleleString(variant.calls[a.id], variant, 0);
    //                     var a1 = getAlleleString(variant.calls[a.id], variant, 1);
    //                     var b0 = getAlleleString(variant.calls[b.id], variant, 0);
    //                     var b1 = getAlleleString(variant.calls[b.id], variant, 1);
    //                     var result = Math.max(b0.length, b1.length) - Math.max(a0.length, a1.length);
    //                     if (result === 0) {
    //                         result = Math.min(b0.length, b1.length) - Math.min(a0.length, a1.length);
    //                     }
    //                     return d * result;
    //                 }
    //             });
    //         });
    //     }
    //
    //
    //     return menuItems;
    //
    // };

        menuItemList() {

            const menuItems = [];

            // color-by INFO attribute
            if (this.header.INFO) {
                //Code below will present checkboxes for all info fields of type "String".   Wait until this is requested
                //const stringInfoKeys = Object.keys(this.header.INFO).filter(key => "String" === this.header.INFO[key].Type);

                // For now stick to explicit info fields (well, exactly 1 for starters)
                if (this.header.INFO) {
                    //const stringInfoKeys = Object.keys(this.header.INFO).filter(key => this.header.INFO[key].Type === "String")
                    const stringInfoKeys = this.header.INFO.SVTYPE ? ['SVTYPE'] : [];
                    if (this._initColorBy && this._initColorBy !== 'SVTYPE') {
                        stringInfoKeys.push(this._initColorBy);
                    }
                    if (stringInfoKeys.length > 0) {
                        menuItems.push('<hr/>');
                        const $e = $$1('<div class="igv-track-menu-category igv-track-menu-border-top">');
                        $e.text('Color by:');
                        menuItems.push({name: undefined, object: $e, click: undefined, init: undefined});
                        stringInfoKeys.sort();
                        for (let item of stringInfoKeys) {
                            const selected = (this.colorBy === item);
                            const label = item ? item : 'None';
                            menuItems.push(this.colorByCB({key: item, label: label}, selected));
                        }
                        menuItems.push(this.colorByCB({key: undefined, label: 'None'}, this.colorBy === undefined));
                        menuItems.push('<hr/>');
                    }
                }
            }

            if (this.getCallsetsLength() > 0) {
                menuItems.push({object: $$1('<div class="igv-track-menu-border-top">')});
                menuItems.push({
                    object: $$1(createCheckbox("Show Genotypes", this.showGenotypes)),
                    click: () => {
                        this.showGenotypes = !this.showGenotypes;
                        //adjustTrackHeight();
                        this.trackView.checkContentHeight();
                        this.trackView.repaintViews();
                    }
                });
            }

            menuItems.push({object: $$1('<div class="igv-track-menu-border-top">')});
            for (let displayMode of ["COLLAPSED", "SQUISHED", "EXPANDED"]) {
                var lut =
                    {
                        "COLLAPSED": "Collapse",
                        "SQUISHED": "Squish",
                        "EXPANDED": "Expand"
                    };

                menuItems.push(
                    {
                        object: $$1(createCheckbox(lut[displayMode], displayMode === this.displayMode)),
                        click: () => {
                            this.displayMode = displayMode;
                            this.trackView.checkContentHeight();
                            this.trackView.repaintViews();
                        }
                    });
            }

            // Experimental JBrowse circular view integration
            if (this.browser.circularView) {

                menuItems.push('<hr>');
                menuItems.push({
                    label: 'Add SVs to circular view',
                    click: () => {
                        for (let viewport of this.trackView.viewports) {
                            this.sendChordsForViewport(viewport);
                        }
                    }
                });
            }

            return menuItems
        }


        contextMenuItemList(clickState) {

            // Experimental JBrowse circular view integration
            if (this.browser.circularView) {
                const viewport = clickState.viewport;
                const list = [];

                list.push({
                    label: 'Add SVs to Circular View',
                    click: () => {
                        this.sendChordsForViewport(viewport);
                    }
                });

                list.push('<hr/>');
                return list
            }
        }


        sendChordsForViewport(viewport) {
            const refFrame = viewport.referenceFrame;
            let inView;
            if ("all" === refFrame.chr) {
                const all = this.featureSource.getAllFeatures();
                const arrays = Object.keys(all).map(k => all[k]);
                inView = [].concat(...arrays);
            } else {
                inView = this.featureSource.featureCache.queryFeatures(refFrame.chr, refFrame.start, refFrame.end);

            }

            const chords = makeVCFChords(inView);
            sendChords(chords, this, refFrame, 0.5);
        }

        /**
         * Create a "color by" checkbox menu item, optionally initially checked
         * @param menuItem
         * @param showCheck
         * @returns {{init: undefined, name: undefined, click: clickHandler, object: (jQuery|HTMLElement|jQuery.fn.init)}}
         */
        colorByCB(menuItem, showCheck) {

            const $e = $$1(createCheckbox(menuItem.label, showCheck));
            const clickHandler = () => {

                if (menuItem.key === this.colorBy) {
                    this.colorBy = undefined;
                    delete this.config.colorBy;
                    this.trackView.repaintViews();
                } else {
                    this.colorBy = menuItem.key;
                    this.config.colorBy = menuItem.key;
                    this.trackView.repaintViews();
                }

            };

            return {name: undefined, object: $e, click: clickHandler, init: undefined}
        }

        getState() {

            const config = super.getState();
            if (this._color && typeof this._color !== "function") {
                config.color = this._color;
            }
            return config

        }

        getVariantColorTable(key) {

            if (!this.colorTables) {
                this.colorTables = new Map();
            }

            if (!this.colorTables.has(key)) {
                let tbl;
                switch (key) {
                    case "SVTYPE" :
                        tbl = SV_COLOR_TABLE;
                        break
                    default:
                        tbl = new PaletteColorTable("Set1");
                }
                this.colorTables.set(key, tbl);
            }
            return this.colorTables.get(key)
        }
    }


    function expandGenotype(call, variant) {

        if (call.genotype) {
            let gt = '';
            if (variant.alternateBases === ".") {
                gt = "No Call";
            } else {
                const altArray = variant.alternateBases.split(",");
                for (let allele of call.genotype) {
                    if (gt.length > 0) {
                        gt += "|";
                    }
                    if ('.' === allele) {
                        gt += '.';
                    } else if (allele === 0) {
                        gt += variant.referenceBases;
                    } else {
                        let alt = altArray[allele - 1].replace("<", "&lt;");
                        gt += alt;
                    }
                }
            }
            call.genotypeName = gt;
        }
    }


    const SV_COLOR_TABLE = new ColorTable({
        'DEL': '#ff2101',
        'INS': '#001888',
        'DUP': '#028401',
        'INV': '#008688',
        'CNV': '#8931ff',
        'BND': '#891100',
        '*': '#002eff'
    });

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class EqtlTrack extends TrackBase {

        constructor(config, browser) {

            super(config, browser);
        }

        init(config) {
            super.init(config);

            this.name = config.name;
            this.pValueField = config.pValueField || "pValue";
            this.geneField = config.geneField || "geneSymbol";
            this.snpField = config.snpField || "snp";

            const min = config.minLogP || config.min;
            const max = config.maxLogP || config.max;
            this.dataRange = {
                min: min || 3.5,
                max: max || 25
            };
            if (!max) {
                this.autoscale = true;
            } else {
                this.autoscale = config.autoscale;
            }
            this.autoscalePercentile = (config.autoscalePercentile === undefined ? 98 : config.autoscalePercentile);


            this.background = config.background;    // No default
            this.divider = config.divider || "rgb(225,225,225)";
            this.dotSize = config.dotSize || 2;
            this.height = config.height || 100;
            this.autoHeight = false;
            this.disableButtons = config.disableButtons;

            // Limit visibility window to 2 mb,  gtex server gets flaky beyond that
            this.visibilityWindow = config.visibilityWindow === undefined ?
                2000000 : config.visibilityWindow >= 0 ? Math.min(2000000, config.visibilityWindow) : 2000000;

            this.featureSource = FeatureSource(config, this.browser.genome);

            GtexUtils.gtexLoaded = true;
        }

        paintAxis(ctx, pixelWidth, pixelHeight) {

            const yScale = (this.dataRange.max - this.dataRange.min) / pixelHeight;

            const font = {
                'font': 'normal 10px Arial',
                'textAlign': 'right',
                'strokeStyle': "black"
            };

            IGVGraphics.fillRect(ctx, 0, 0, pixelWidth, pixelHeight, {'fillStyle': "rgb(255, 255, 255)"});

            // Determine a tick spacing such that there is at least 10 pixels between ticks

            const n = Math.ceil((this.dataRange.max - this.dataRange.min) * 10 / pixelHeight);

            for (let p = 4; p <= this.dataRange.max; p += n) {

                // TODO: Dashes may not actually line up with correct scale. Ask Jim about this

                const ref = 0.85 * pixelWidth;
                const x1 = ref - 5;
                const x2 = ref;
                const y = pixelHeight - (p - this.dataRange.min) / yScale;

                IGVGraphics.strokeLine(ctx, x1, y, x2, y, font); // Offset dashes up by 2 pixel

                if (y > 8) {
                    IGVGraphics.fillText(ctx, p, x1 - 1, y + 2, font);
                } // Offset numbers down by 2 pixels;
            }

            font['textAlign'] = 'center';

            IGVGraphics.fillText(ctx, "-log10(pvalue)", pixelWidth / 4, pixelHeight / 2, font, {rotate: {angle: -90}});

        };

        async getFeatures(chr, start, end) {

            const pValueField = this.pValueField;
            const visibilityWindow = this.visibilityWindow;
            const features = await this.featureSource.getFeatures({chr, start, end, visibilityWindow});
            features.forEach(function (f) {
                f.value = f[pValueField];
            });
            return features
        }

        draw(options) {

            const ctx = options.context;

            const pixelWidth = options.pixelWidth;
            const pixelHeight = options.pixelHeight;

            if (this.background) {
                IGVGraphics.fillRect(ctx, 0, 0, pixelWidth, pixelHeight, {'fillStyle': this.background});
            }
            IGVGraphics.strokeLine(ctx, 0, pixelHeight - 1, pixelWidth, pixelHeight - 1, {'strokeStyle': this.divider});

            const drawEqtls = (drawSelected) => {

                const radius = drawSelected ? 2 * this.dotSize : this.dotSize;
                const bpStart = options.bpStart;
                const yScale = (this.dataRange.max - this.dataRange.min) / pixelHeight;
                const selection = options.referenceFrame.selection;

                for (let eqtl of options.features) {

                    const px = (eqtl.start - bpStart + 0.5) / options.bpPerPixel;
                    if (px < 0) continue
                    else if (px > pixelWidth) break

                    const snp = eqtl.snp.toUpperCase();
                    const geneName = eqtl[this.geneField].toUpperCase();

                    const isSelected = selection &&
                        (selection.snp === snp || selection.gene === geneName);

                    if (!drawSelected || isSelected) {

                        // Add eqtl's gene to the selection if this is the selected snp.
                        // TODO -- this should not be done here in the rendering code.
                        if (selection && selection.snp === snp) {
                            selection.addGene(geneName);
                        }

                        var mLogP = -Math.log(eqtl[this.pValueField]) / Math.LN10;
                        if (mLogP >= this.dataRange.min) {
                            let capped;
                            if (mLogP > this.dataRange.max) {
                                mLogP = this.dataRange.max;
                                capped = true;
                            } else {
                                capped = false;

                            }

                            const py = Math.max(0 + radius, pixelHeight - Math.round((mLogP - this.dataRange.min) / yScale));
                            eqtl.px = px;
                            eqtl.py = py;
                            eqtl.radius = radius;

                            let color;
                            if (drawSelected && selection) {
                                color = selection.colorForGene(geneName);
                                IGVGraphics.setProperties(ctx, {fillStyle: color, strokeStyle: "black"});
                            } else {
                                color = capped ? "rgb(150, 150, 150)" : "rgb(180, 180, 180)";
                                IGVGraphics.setProperties(ctx, {fillStyle: color, strokeStyle: color});
                            }

                            IGVGraphics.fillCircle(ctx, px, py, radius);
                            IGVGraphics.strokeCircle(ctx, px, py, radius);
                        }
                    }
                }
            };

            // Draw in two passes, with "selected" eqtls drawn last
            drawEqtls(false);
            drawEqtls(true);

        }

        /**
         * Return "popup data" for feature @ genomic location.  Data is an array of key-value pairs
         */
        popupData(clickState, features) {

            if(features === undefined) features = clickState.viewport.cachedFeatures;
            if (!features || features.length === 0) return []

            const tolerance = 3;
            const tissue = this.name;
            const popupData = [];

            for (let feature of features) {
                // Hit test --use square vs circle for efficiency (no sqrt)
                if (Math.abs(feature.px - clickState.canvasX) < (feature.radius + tolerance) &&
                    Math.abs(feature.py - clickState.canvasY) < (feature.radius + tolerance)) {

                    if (popupData.length > 0) {
                        popupData.push('<hr/>');
                    }
                    popupData.push(
                        {name: "snp id", value: feature.snp},
                        {name: "gene id", value: feature.geneId},
                        {name: "gene name", value: feature.geneName},
                        {name: "p value", value: feature.pValue},
                        {name: "tissue", value: tissue});

                }
            }

            return popupData
        }

        menuItemList() {
            return MenuUtils.numericDataMenuItems(this.trackView)
        }

        doAutoscale(featureList) {

            if (featureList.length > 0) {

                var values = featureList
                    .map(function (eqtl) {
                        return -Math.log(eqtl.value) / Math.LN10
                    });

                this.dataRange.max = IGVMath.percentile(values, this.autoscalePercentile);
            } else {
                // No features -- default
                const max = this.config.maxLogP || this.config.max;
                this.dataRange.max = max || 25;
            }

            return this.dataRange
        }

    }

    /**
     * Colors used for coding omosomes
     */

    const GWASColors = {
        "X": "rgb(204, 153, 0)",
        "Y": "rgb(153, 204, 0)",
        "Un": "darkGray)",
        "1": "rgb(80, 80, 255)",
        "2": "rgb(206, 61, 50)",
        "2a": "rgb(210, 65, 55)",
        "2b": "rgb(215, 70, 60)",
        "3": "rgb(116, 155, 88)",
        "4": "rgb(240, 230, 133)",
        "5": "rgb(70, 105, 131)",
        "6": "rgb(186, 99, 56)",
        "7": "rgb(93, 177, 221)",
        "8": "rgb(128, 34, 104)",
        "9": "rgb(107, 215, 107)",
        "10": "rgb(213, 149, 167)",
        "11": "rgb(146, 72, 34)",
        "12": "rgb(131, 123, 141)",
        "13": "rgb(199, 81, 39)",
        "14": "rgb(213, 143, 92)",
        "15": "rgb(122, 101, 165)",
        "16": "rgb(228, 175, 105)",
        "17": "rgb(59, 27, 83)",
        "18": "rgb(205, 222, 183)",
        "19": "rgb(97, 42, 121)",
        "20": "rgb(174, 31, 99)",
        "21": "rgb(231, 199, 111)",
        "22": "rgb(90, 101, 94)",
        "23": "rgb(204, 153, 0)",
        "24": "rgb(153, 204, 0)",
        "25": "rgb(51, 204, 0)",
        "26": "rgb(0, 204, 51)",
        "27": "rgb(0, 204, 153)",
        "28": "rgb(0, 153, 204)",
        "29": "rgb(10, 71, 255)",
        "30": "rgb(71, 117, 255)",
        "31": "rgb(255, 194, 10)",
        "32": "rgb(255, 209, 71)",
        "33": "rgb(153, 0, 51)",
        "34": "rgb(153, 26, 0)",
        "35": "rgb(153, 102, 0)",
        "36": "rgb(128, 153, 0)",
        "37": "rgb(51, 153, 0)",
        "38": "rgb(0, 153, 26)",
        "39": "rgb(0, 153, 102)",
        "40": "rgb(0, 128, 153)",
        "41": "rgb(0, 51, 153)",
        "42": "rgb(26, 0, 153)",
        "43": "rgb(102, 0, 153)",
        "44": "rgb(153, 0, 128)",
        "45": "rgb(214, 0, 71)",
        "46": "rgb(255, 20, 99)",
        "47": "rgb(0, 214, 143)",
        "48": "rgb(20, 255, 177)"
    };

    //  aliasing
    for (let key of Object.keys(GWASColors)) {
        const altName = "chr" + key;
        GWASColors[altName] = GWASColors[key];
    }

    // romanizing
    for(let a = 1; a <= 48; a++) {
        if(a === 10) continue   // Don't overide "X"
        const roman = romanize(a);
        GWASColors[roman] = GWASColors[a.toString()];
    }


    function romanize (num) {
        if (!+num) return false;
        var digits = String(+num).split('');
        var key = ['','C','CC','CCC','CD','D','DC','DCC','DCCC','CM',
            '','X','XX','XXX','XL','L','LX','LXX','LXXX','XC',
            '','I','II','III','IV','V','VI','VII','VIII','IX'];
        var roman = '', i = 3;
        while (i--) roman = (key[+digits.pop() + (i * 10)] || '') + roman;
        return Array(+digits.join('') + 1).join('M') + roman;
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const DEFAULT_POPOVER_WINDOW = 100000000;

    //const type = "gwas";

    class GWASTrack extends TrackBase {

        constructor(config, browser) {

            super(config, browser);
        }

        init(config) {

            super.init(config);

            this.useChrColors = config.useChrColors === undefined ? true : config.useChrColors;
            this.trait = config.trait;
            this.posteriorProbability = config.posteriorProbability;
            this.valueProperty = "bed" === config.format ? "score" : "value";
            this.height = config.height || 100;   // The preferred height
            this.autoscale = config.autoscale;
            this.autoscalePercentile = config.autoscalePercentile === undefined ? 98 : config.autoscalePercentile;
            this.background = config.background;    // No default
            this.divider = config.divider || "rgb(225,225,225)";
            this.dotSize = config.dotSize || 3;
            this.popoverWindow = (config.popoverWindow === undefined ? DEFAULT_POPOVER_WINDOW : config.popoverWindow);

            // Color settings
            if (this.useChrColors) {
                this.colorScale = new ColorTable(config.colorTable || GWASColors);
            } else if (config.color) {
                this.colorScale = new ConstantColorScale(config.color);
            } else {
                this.colorScale =
                    new BinnedColorScale(config.colorScale ||
                        {
                            thresholds: [5e-8, 5e-4, 0.5],
                            colors: ["rgb(255,50,50)", "rgb(251,100,100)", "rgb(251,170,170)", "rgb(227,238,249)"],
                        });
            }

            this.featureSource = FeatureSource(config, this.browser.genome);
        }

        async postInit() {

            if (typeof this.featureSource.getHeader === "function") {
                this.header = await this.featureSource.getHeader();
                if (this.disposed) return   // This track was removed during async load
            }

            // Set properties from track line
            if (this.header) {
                this.setTrackProperties(this.header);   // setTrackProperties defined in TrackBase
            }

            // Set initial range if specfied, unless autoscale == true
            if (!this.autoscale) {
                if (this.posteriorProbability) {
                    this.dataRange = {
                        min: this.config.min === undefined ? 0 : this.config.min,
                        max: this.config.max === undefined ? 1 : this.config.max
                    };
                } else {
                    this.dataRange = {
                        min: this.config.min === undefined ? 0 : this.config.min,
                        max: this.config.max === undefined ? 25 : this.config.max
                    };
                }
            }

            return this

        }


        get supportsWholeGenome() {
            return true
        }

        async getFeatures(chr, start, end) {
            const visibilityWindow = this.visibilityWindow;
            return this.featureSource.getFeatures({chr, start, end, visibilityWindow})
        }

        draw(options) {

            const featureList = options.features;
            const ctx = options.context;
            const pixelWidth = options.pixelWidth;
            const pixelHeight = options.pixelHeight;
            if (this.background) {
                IGVGraphics.fillRect(ctx, 0, 0, pixelWidth, pixelHeight, {'fillStyle': this.background});
            }
            IGVGraphics.strokeLine(ctx, 0, pixelHeight - 1, pixelWidth, pixelHeight - 1, {'strokeStyle': this.divider});

            if (featureList) {

                const bpPerPixel = options.bpPerPixel;
                const bpStart = options.bpStart;
                const bpEnd = bpStart + pixelWidth * bpPerPixel + 1;
                for (let variant of featureList) {
                    const pos = variant.start;
                    if (pos < bpStart) continue
                    if (pos > bpEnd) break

                    let val;
                    if (this.posteriorProbability) {
                        val = variant[this.valueProperty];
                    } else {
                        const pvalue = variant[this.valueProperty];
                        if (!pvalue) continue
                        val = -Math.log10(pvalue);
                    }

                    const colorKey = this.useChrColors ?
                        variant._f ? variant._f.chr : variant.chr :
                        val;

                    const color = this.colorScale.getColor(colorKey);
                    const yScale = (this.dataRange.max - this.dataRange.min) / pixelHeight;
                    const px = Math.round((pos - bpStart) / bpPerPixel);
                    const py = Math.max(this.dotSize, pixelHeight - Math.round((val - this.dataRange.min) / yScale));

                    if (color) {
                        IGVGraphics.setProperties(ctx, {fillStyle: color, strokeStyle: "black"});
                    }
                    IGVGraphics.fillCircle(ctx, px, py, this.dotSize);
                    variant.px = px;
                    variant.py = py;
                }
            }
        }

        paintAxis(ctx, pixelWidth, pixelHeight) {

            IGVGraphics.fillRect(ctx, 0, 0, pixelWidth, pixelHeight, {'fillStyle': "rgb(255, 255, 255)"});
            var font = {
                'font': 'normal 10px Arial',
                'textAlign': 'right',
                'strokeStyle': "black"
            };

            const yScale = (this.dataRange.max - this.dataRange.min) / pixelHeight;
            if (this.posteriorProbability) {
                const n = 0.1;
                for (let p = this.dataRange.min; p < this.dataRange.max; p += n) {
                    const yp = pixelHeight - Math.round((p - this.dataRange.min) / yScale);
                    IGVGraphics.strokeLine(ctx, 45, yp - 2, 50, yp - 2, font); // Offset dashes up by 2 pixel
                    IGVGraphics.fillText(ctx, p.toFixed(1), 44, yp + 2, font); // Offset numbers down by 2 pixels;
                }
            } else {
                const n = Math.ceil((this.dataRange.max - this.dataRange.min) * 10 / pixelHeight);
                for (let p = this.dataRange.min; p < this.dataRange.max; p += n) {
                    const yp = pixelHeight - Math.round((p - this.dataRange.min) / yScale);
                    IGVGraphics.strokeLine(ctx, 45, yp, 50, yp, font); // Offset dashes up by 2 pixel
                    IGVGraphics.fillText(ctx, Math.floor(p), 44, yp + 4, font); // Offset numbers down by 2 pixels;
                }
            }

            font['textAlign'] = 'center';
            if (this.posteriorProbability) {
                IGVGraphics.fillText(ctx, "PPA", pixelWidth / 2, pixelHeight / 2, font, {rotate: {angle: -90}});
            } else {
                IGVGraphics.fillText(ctx, "-log10(pvalue)", pixelWidth / 2, pixelHeight / 2, font, {rotate: {angle: -90}});
            }
        }

        popupData(clickState, features) {

            if (features === undefined) features = clickState.viewport.cachedFeatures;

            let data = [];
            const track = clickState.viewport.trackView.track;

            if (features) {
                let count = 0;
                for (let f of features) {
                    const xDelta = Math.abs(clickState.canvasX - f.px);
                    const yDelta = Math.abs(clickState.canvasY - f.py);
                    const value = f[this.valueProperty];
                    if (xDelta < this.dotSize && yDelta < this.dotSize) {
                        if (count > 0) {
                            data.push("<HR/>");
                        }
                        if (count == 5) {
                            data.push("...");
                            break
                        }
                        if (typeof f.popupData === 'function') {
                            data = data.concat(f.popupData());
                        } else {
                            const chr = f.realChr || f.chr;
                            const pos = (f.realStart || f.start) + 1;
                            data.push({name: 'chromosome', value: chr});
                            data.push({name: 'position', value: pos});
                            data.push({name: 'name', value: f.name});
                            if (track.posteriorProbability) {
                                data.push({name: 'posterior probability', value: value});
                            } else {
                                data.push({name: 'pValue', value: value});
                            }
                        }
                        count++;
                    }
                }
            }

            return data
        }

        menuItemList() {
            return MenuUtils.numericDataMenuItems(this.trackView)
        }

        doAutoscale(featureList) {

            if (featureList.length > 0) {
                // posterior probabilities are treated without modification, but we need to take a negative logarithm of P values
                const valueProperty = this.valueProperty;
                const posterior = this.posteriorProbability;
                const features =
                    featureList.map(function (feature) {
                        const v = feature[valueProperty];
                        return {value: posterior ? v : -Math.log(v) / Math.LN10}
                    });
                this.dataRange = doAutoscale(features);

            } else {
                // No features -- pick something reasonable for PPAs and p-values
                if (this.posteriorProbability) {
                    this.dataRange = {min: this.config.min || 0, max: this.config.max || 1};
                } else {
                    this.dataRange = {min: this.config.max || 25, max: this.config.min || 0};
                }
            }

            return this.dataRange
        }

    }

    const X_PIXEL_DIFF_THRESHOLD = 1;

    class GCNVTrack extends TrackBase {

        constructor(config, browser) {
            super(config, browser);
        }

        init(config) {
            super.init(config);

            this.autoscale = config.autoscale || config.max === undefined;
            this.dataRange = {
                min: config.min || 0,
                max: config.max
            };

            this.windowFunction = config.windowFunction || "mean";
            this.paintAxis = paintAxis;
            this.graphType = config.graphType || "bar";

            //hack to avoid creating feature source multiple times.  If config.type is not set the file must be read
            //to determine type, which results in creation of a feature source.
            if (config._featureSource) {
                this.featureSource = config._featureSource;
                delete config._featureSource;
            } else {
                this.featureSource = FeatureSource(this.config, this.browser.genome);
            }

            // Visibility window hardcoded to -1  (== whole chromosome).  Draw method needs feature beyond current view,
            // when/if this is resolved visibilityWindow can be used.
            this.visibilityWindow = -1;
            this.featureSource.visibilityWindow = this.visibilityWindow;
        }

        async postInit() {

            if (typeof this.featureSource.getHeader === "function") {
                this.header = await this.featureSource.getHeader();
                if(this.disposed) return;   // This track was removed during async load
                this.sampleNames = this.header.columnNames.slice(3);

                // Set generic properties from track line
                this.setTrackProperties(this.header);   // setTrackProperties defined in TrackBase

                // set option to highlight sample track line on click
                if (this.header.hasOwnProperty("clickToHighlight")) {
                    let colour = this.header["clickToHighlight"];
                    this.config.clickToHighlight = colour;
                    this.config.samplesClickedToHighlight = {};
                }

                // Special track line properties
                if (this.header.hasOwnProperty("highlight")) {
                    this.config.highlightSamples = {};
                    let v = this.header["highlight"];
                    if (!Array.isArray(v)) v = [v];
                    for (let h of v) {
                        const tokens = h.split(";");
                        if (tokens.length === 2) {
                            this.config.highlightSamples[tokens[0]] = tokens[1];
                        }

                    }
                }
            }
        }

        menuItemList() {
            return MenuUtils.numericDataMenuItems(this.trackView)
        }

        async getFeatures(chr, start, end) {
            const chrFeatures = await this.featureSource.getFeatures({
                chr,
                start: 0,
                end: Number.MAX_SAFE_INTEGER,
                visibilityWindow: this.visibilityWindow
            });
            let prevIndex = undefined;
            let nextIndex = undefined;
            for (let i = 1; i < chrFeatures.length - 1; i++) {
                if (prevIndex === undefined && chrFeatures[i].end > start) {
                    prevIndex = i - 1;
                }
                if (nextIndex === undefined && chrFeatures[i].start > end) {
                    nextIndex = i + 1;
                    break
                }
            }
            if (prevIndex === undefined) prevIndex = 0;
            if (nextIndex === undefined) nextIndex = chrFeatures.length;
            return chrFeatures.slice(prevIndex, nextIndex)
        }

        draw(options) {

            const {features, context, bpPerPixel, bpStart, pixelWidth, pixelHeight} = options;

            ///let baselineColor;
            //if (typeof self.color === "string" && self.color.startsWith("rgb(")) {
            //    baselineColor = IGVColor.addAlpha(self.color, 0.1);
            //}

            const yScale = (yValue) => {
                return ((this.dataRange.max - yValue) / (this.dataRange.max - this.dataRange.min)) * pixelHeight
            };

            const getX = function (bpPosition) {
                let x = Math.floor((bpPosition - bpStart) / bpPerPixel);
                if (isNaN(x)) console.warn('isNaN(x). feature start ' + numberFormatter$1(bpPosition) +
                    ' bp start ' + numberFormatter$1(bpStart));
                return x
            };

            const drawGuideLines = (options) => {
                if (this.config.hasOwnProperty('guideLines')) {
                    for (let line of this.config.guideLines) {
                        if (line.hasOwnProperty('color') && line.hasOwnProperty('y') && line.hasOwnProperty('dotted')) {
                            let y = yScale(line.y);
                            let props = {
                                'strokeStyle': line['color'],
                                'strokeWidth': 2
                            };
                            if (line['dotted']) IGVGraphics.dashedLine(options.context, 0, y, options.pixelWidth, y, 5, props);
                            else IGVGraphics.strokeLine(options.context, 0, y, options.pixelWidth, y, props);
                        }
                    }
                }
            };

            if (features && features.length > 0) {

                if (this.dataRange.min === undefined) this.dataRange.min = 0;

                // Max can be less than min if config.min is set but max left to autoscale. If that's the case there is
                // nothing to paint.
                if (this.dataRange.max > this.dataRange.min) {
                    const highlightSamples = this.config.highlightSamples;
                    const onlyHandleClicksForHighlightedSamples = this.config.onlyHandleClicksForHighlightedSamples;
                    const clickToHighlight = this.config.clickToHighlight;

                    let previousEnd = -1;
                    let previousValues = {};

                    let highlightConnectorLines = [];
                    let highlightFeatureLines = [];

                    // clickDetectorCache allows fast retrieval of whether a mouse click hits a rendered line segment
                    // by storing lists of rendered line segments, keyed by their right x coordinate in canvas pixel space.
                    // this cache is regenerated on every draw.
                    this.clickDetectorCache = {};

                    for (let feature of features) {
                        const x1 = getX(feature.start);
                        const x2 = getX(feature.end);
                        const previousX = previousEnd >= 0 ? getX(previousEnd) : x1;

                        if (isNaN(x1) || isNaN(x2)) continue
                        // if ((x1 - previousX < X_PIXEL_DIFF_THRESHOLD) && (x2 - x1 < X_PIXEL_DIFF_THRESHOLD)) continue;

                        this.clickDetectorCache[x1] = [];
                        this.clickDetectorCache[x2] = [];
                        for (let i = 0; i < feature.values.length; i++) {
                            const sampleName = this.sampleNames[i];
                            const value = feature.values[i];
                            const y = yScale(value);
                            if (x1 - previousX >= X_PIXEL_DIFF_THRESHOLD) {
                                const previousValue = previousValues[sampleName];
                                const previousY = yScale(previousValue);
                                const highlightColor = highlightSamples && highlightSamples[sampleName];


                                if (highlightColor) {
                                    highlightConnectorLines.push([previousX, previousY, x1, y, highlightColor]);
                                } else if (clickToHighlight && sampleName in this.config.samplesClickedToHighlight) {
                                    highlightConnectorLines.push([previousX, previousY, x1, y, this.config.samplesClickedToHighlight[sampleName]]);
                                } else {
                                    IGVGraphics.strokeLine(context, previousX, previousY, x1, y, {strokeStyle: '#D9D9D9'});
                                }
                                if (!onlyHandleClicksForHighlightedSamples || sampleName in highlightSamples) {
                                    this.clickDetectorCache[x1].push([previousX, previousY, x1, y, sampleName, highlightColor || 'gray']);
                                }
                            }

                            if (x2 - x1 >= X_PIXEL_DIFF_THRESHOLD) {
                                const highlightColor = highlightSamples && highlightSamples[sampleName];
                                if (highlightColor) {
                                    highlightFeatureLines.push([x1, y, x2, y, highlightColor]);
                                } else if (clickToHighlight && sampleName in this.config.samplesClickedToHighlight) {
                                    highlightFeatureLines.push([x1, y, x2, y, this.config.samplesClickedToHighlight[sampleName]]);
                                } else {
                                    IGVGraphics.strokeLine(context, x1, y, x2, y, {strokeStyle: 'gray'});
                                }
                                if (!onlyHandleClicksForHighlightedSamples || sampleName in highlightSamples) {
                                    this.clickDetectorCache[x2].push([x1, y, x2, y, sampleName, highlightColor || 'gray']);
                                }
                            }

                            previousValues[sampleName] = value;

                            //IGVGraphics.fillCircle(ctx, px, y, pointSize / 2, {"fillStyle": color, "strokeStyle": color});
                            //IGVGraphics.fillRect(ctx, x, y, width, height, {fillStyle: color});
                        }
                        previousEnd = feature.end;
                    }

                    for (let f of highlightConnectorLines) {
                        IGVGraphics.strokeLine(context, f[0], f[1], f[2], f[3], {strokeStyle: f[4], lineWidth: 1.3});
                    }
                    for (let f of highlightFeatureLines) {
                        IGVGraphics.strokeLine(context, f[0], f[1], f[2], f[3], {strokeStyle: f[4], lineWidth: 2});
                    }

                    /*
                    // If the track includes negative values draw a baseline
                    if (this.dataRange.min < 0) {
                        const basepx = (self.dataRange.max / (this.dataRange.max - this.dataRange.min)) * options.pixelHeight;
                        IGVGraphics.strokeLine(context, 0, basepx, options.pixelWidth, basepx, {strokeStyle: baselineColor});
                    }
                    */
                }
            }

            drawGuideLines(options);
        }

        doAutoscale(features) {

            let min, max;
            if (features.length > 0) {
                min = Number.MAX_VALUE;
                max = -Number.MAX_VALUE;

                features.forEach(function (feature) {
                    min = Math.min(min, ...feature.values);
                    max = Math.max(max, ...feature.values);
                });

                min -= 0.01;
                max += 0.01;
            } else {
                // No features -- default
                min = 0;
                max = 100;
            }

            return {min: min, max: max}
        }

        clickedFeatures(clickState) {
            //console.warn('click', clickState.canvasX, clickState.canvasY, clickState)

            const BOUNDING_BOX_PADDING = 10;
            const MIN_DISTANCE_TO_SEGMENT = 5;

            const clickX = clickState.canvasX;
            const clickY = clickState.canvasY;

            let key = null;
            for (key of Object.keys(this.clickDetectorCache)) {
                key = parseInt(key);
                if (key >= clickX) {
                    break
                }
            }


            if (key) {
                let closestDistanceSoFar = Number.MAX_VALUE;
                let closestResult = [];
                const segments = this.clickDetectorCache[key];
                for (let segment of segments) {
                    const x1 = segment[0];
                    const x2 = segment[2];
                    if (clickX < x1 || clickX > x2) return []

                    const y1 = segment[1];
                    const y2 = segment[3];

                    if ((clickY < Math.min(y1, y2) - BOUNDING_BOX_PADDING) || (clickY > Math.max(y1, y2) + BOUNDING_BOX_PADDING)) continue

                    const distance = distanceToLine(clickX, clickY, x1, y1, x2, y2);
                    if (distance < closestDistanceSoFar) {
                        closestResult = [{'name': segment[4], 'color': segment[5]}];
                        closestDistanceSoFar = distance;
                        //console.warn('closest:', 'name', segment[4], 'color', segment[5], distance);
                    }
                }

                if (closestDistanceSoFar < MIN_DISTANCE_TO_SEGMENT) {
                    // clickToHighlight set, add sample to dict of clicked lines
                    if (this.config.clickToHighlight) {
                        if (closestResult[0]['name'] in this.config.samplesClickedToHighlight) {
                            // clicked sample already highlighted => remove if clicked again
                            delete this.config.samplesClickedToHighlight[closestResult[0]['name']];
                        } else if (this.config.clickToHighlight === 'any') {
                            var colourList = [
                                'red', 'darkblue', 'green', 'teal', 'olivedrab',
                                'orange', 'maroon', 'purple', 'blue', 'gold',
                            ];
                            var colour = colourList[Math.floor(Math.random() * (colourList.length + 1))];
                            this.config.samplesClickedToHighlight[closestResult[0]['name']] = colour;
                        } else {
                            this.config.samplesClickedToHighlight[closestResult[0]['name']] = this.config.clickToHighlight;
                        }
                        this.trackView.repaintViews();  // prompt redraw to change colour of clicked sample
                    }
                    return closestResult
                }
            }

            return []
        }

        popupData(clickState, features) {

            if(features === undefined) features = this.clickedFeatures(clickState);

            const items = [];
            features.forEach(function (f) {
                for (let property of Object.keys(f)) {
                    if (isSimpleType(f[property])) {
                        items.push({name: property, value: f[property]});
                    }
                }
            });

            return items
        }

        get supportsWholeGenome() {
            return false
        }
    }


    function distanceToLine(x, y, ax, ay, bx, by) {
        /*
            Finds distance between point (x, y) and line defined by points (ax, ay) (bx, by)
            based on http://mathworld.wolfram.com/Point-LineDistance2-Dimensional.html
        */

        const bx_minus_ax = bx - ax;
        const by_minus_ay = by - ay;
        const v = Math.abs(bx_minus_ax * (ay - y) - (ax - x) * by_minus_ay);
        const r = Math.sqrt(bx_minus_ax * bx_minus_ax + by_minus_ay * by_minus_ay);

        const distance = r > 0 ? v / r : 0;
        //console.warn('Check if', x, y, 'is within', ax, ay, bx, by, '. Distance from line: ', distance);

        return distance
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class RnaStructTrack extends TrackBase {

        constructor(config, browser) {

            super(config, browser);

            // Set defaults
            if (!config.height) {
                this.height = 300;
            }

            this.arcOrientation = false;

            this.theta = Math.PI / 2;

            if ("bp" === config.format) {
                this.featureSource = new RNAFeatureSource(config, browser.genome);
            } else {
                this.featureSource = new TextFeatureSource(config, browser.genome);
            }
        }

        async getFeatures(chr, start, end) {
            const visibilityWindow = this.visibilityWindow;
            return this.featureSource.getFeatures({chr, start, end, visibilityWindow})
        }

        draw(options) {

            const ctx = options.context;

            const theta = Math.PI / 2;
            const pixelWidth = options.pixelWidth;
            const pixelHeight = options.pixelHeight;
            options.viewportWidth;
            const bpPerPixel = options.bpPerPixel;
            const bpStart = options.bpStart;
            const xScale = bpPerPixel;
            const orienation = this.arcOrientation;

            IGVGraphics.fillRect(ctx, 0, options.pixelTop, pixelWidth, pixelHeight, {'fillStyle': "rgb(255, 255, 255)"});

            const featureList = options.features;

            if (featureList) {

                // Sort by score -- draw lowest scored features first
                sortByScore(featureList, 1);

                for (let feature of featureList) {

                    if (feature.startLeft) {

                        let sl = Math.round((feature.startLeft - bpStart) / xScale);
                        let sr = Math.round((feature.startRight - bpStart) / xScale);
                        let el = Math.round((feature.endLeft - bpStart) / xScale);
                        let er = Math.round((feature.endRight - bpStart) / xScale);

                        ctx.fillStyle = feature.color;
                        ctx.strokeStyle = feature.color;
                        ctx.beginPath();

                        // First arc
                        let x1 = (sl + er) / 2;
                        let r1 = (er - sl) / 2;
                        let y1 = this.height;
                        let sa = Math.PI + (Math.PI / 2 - theta);
                        let ea = 2 * Math.PI - (Math.PI / 2 - theta);

                        if (orienation) {
                            y1 = 0;
                            ctx.arc(x1, y1, r1, ea, sa);
                            ctx.lineTo(er, y1);
                        } else {
                            ctx.arc(x1, y1, r1, sa, ea);
                            ctx.lineTo(el, y1);
                        }

                        // Second arc
                        const x2 = (sr + el) / 2;
                        const r2 = (el - sr) / 2;
                        const y2 = y1;                        // Only for theta == pi/2

                        if (orienation) {
                            ctx.arc(x2, y2, r2, sa, ea, true);
                            ctx.lineTo(el, y2);
                        } else {
                            ctx.arc(x2, y2, r2, ea, sa, true);
                            ctx.lineTo(sl, y2);
                        }

                        ctx.stroke();
                        ctx.fill();

                        feature.drawState = {x1: x1, y1: y1, r1: r1, x2: x2, y2: y2, r2: r2, sa: sa, ea: ea};
                    } else {
                        let s = Math.round((feature.start - bpStart) / xScale);
                        let e = Math.round((feature.end - bpStart) / xScale);

                        ctx.strokeStyle = feature.color;

                        ctx.beginPath();

                        // First arc
                        let x = (s + e) / 2;
                        let r = (e - s) / 2;
                        let y = this.height;
                        let sa = Math.PI + (Math.PI / 2 - theta);
                        let ea = 2 * Math.PI - (Math.PI / 2 - theta);

                        if (orienation) {
                            y = 0;
                            ctx.arc(x, y, r, ea, sa);
                        } else {
                            ctx.arc(x, y, r, sa, ea);
                        }

                        ctx.stroke();

                        feature.drawState = {x1: x, y1: y, r1: r, sa: sa, ea: ea};

                    }

                }
            }
        }

        clickedFeatures(clickState) {

            const features = super.clickedFeatures(clickState);

            const clicked = [];

            // Sort by score in descending order   (opposite order than drawn)
            sortByScore(features, -1);

            for (let f of features) {
                const ds = f.drawState;

                // Distance from arc radius, or outer arc for type ".bp"
                const dx1 = (clickState.canvasX - ds.x1);
                const dy1 = (clickState.canvasY - ds.y1);
                const d1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
                const outerLim = ds.r1 + 3;


                let d2;
                let innerLim;
                if (ds.x2 === undefined) {
                    d2 = d1;
                    innerLim = ds.r1 - 3;

                } else {
                    const dx2 = (clickState.canvasX - ds.x2);
                    const dy2 = (clickState.canvasY - ds.y2);
                    d2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
                    innerLim = ds.r2 - 3;
                }


                // Between outer and inner arcs, with some tolerance
                if (d1 < outerLim && d2 > innerLim) {
                    clicked.push(f);
                    break
                }
            }
            return clicked
        }

        popupData(clickState, features) {

            if(features === undefined) features = this.clickedFeatures(clickState);

            if (features && features.length > 0) {

                return this.extractPopupData(features[0], this.getGenomeId())

            }
        }

        menuItemList() {

            var self = this;

            return [
                {
                    name: "Toggle arc direction",
                    click: function () {
                        self.arcOrientation = !self.arcOrientation;
                        self.trackView.repaintViews();
                    }
                }
            ]

        };


    }

    function sortByScore(featureList, direction) {

        featureList.sort(function (a, b) {
            const s1 = a.score === undefined ? -Number.MAX_VALUE : a.score;
            const s2 = b.score === undefined ? -Number.MAX_VALUE : b.score;
            const d = direction === undefined ? 1 : direction;

            return d * (s1 - s2)
        });
    }


    class RNAFeatureSource {

        constructor(config, genome) {
            this.config = config;
            this.genome = genome;
        }

        async getFeatures({chr, start, end, bpPerPixel, visibilityWindow}) {


            const genome = this.genome;

            if (!this.featureCache) {

                const options = buildOptions(this.config);

                const data = await igvxhr.loadString(this.config.url, options);

                this.featureCache = new FeatureCache$1(parseBP(data), genome);

                return this.featureCache.queryFeatures(chr, start, end)

            } else {
                return this.featureCache.queryFeatures(chr, start, end)
            }

            function parseBP(data) {

                if (!data) return null

                const dataWrapper = getDataWrapper(data);

                let header = true;
                let line;
                const colors = [];
                const descriptors = [];
                const features = [];

                while ((line = dataWrapper.nextLine()) !== undefined) {

                    const tokens = line.split('\t');

                    if (header && line.startsWith("color:")) {
                        const color = "rgb(" + tokens[1] + "," + tokens[2] + "," + tokens[3] + ")";
                        colors.push(color);
                        if (tokens.length > 4) {
                            descriptors.push(tokens[4]);
                        }
                        // TODO - use label
                    } else {
                        header = false;

                        const chr = tokens[0];
                        const startLeftNuc = Number.parseInt(tokens[1]) - 1;
                        const startRightNuc = Number.parseInt(tokens[2]) - 1;
                        const endLeftNuc = Number.parseInt(tokens[3]);
                        const endRightNuc = Number.parseInt(tokens[4]);
                        var colorIdx = Number.parseInt(tokens[5]);
                        const color = colors[colorIdx];


                        let feature;
                        if (startLeftNuc <= endRightNuc) {
                            feature = {
                                chr: chr,
                                startLeft: Math.min(startLeftNuc, startRightNuc),
                                startRight: Math.max(startLeftNuc, startRightNuc),
                                endLeft: Math.min(endLeftNuc, endRightNuc),
                                endRight: Math.max(endLeftNuc, endRightNuc),
                                color: color,
                                score: colorIdx
                            };
                        } else {
                            feature = {
                                chr: chr,
                                startLeft: Math.min(endLeftNuc, endRightNuc),
                                startRight: Math.max(endLeftNuc, endRightNuc),
                                endLeft: Math.min(startLeftNuc, startRightNuc),
                                endRight: Math.max(startLeftNuc, startRightNuc),
                                color: color,
                                score: colorIdx
                            };
                        }

                        feature.start = feature.startLeft;
                        feature.end = feature.endRight;

                        if (descriptors.length > colorIdx) {
                            feature.description = descriptors[colorIdx];
                        }

                        features.push(feature);
                    }
                }

                return features
            }
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    /**
     * Class represents an ideogram of a chromsome cytobands.  It is used for the header of a track panel.
     *
     */
    class IdeogramTrack {
        constructor(browser) {
            this.browser = browser;
            this.type = 'ideogram';
            this.height = 16;
            this.order = Number.MIN_SAFE_INTEGER;
            this.disableButtons = true;
            this.ignoreTrackMenu = true;
        }

        async getFeatures(chr, start, end) {
            return []
        }

        computePixelHeight(ignore) {
            return this.height
        }

        draw({context, referenceFrame, pixelWidth, pixelHeight}) {

            const chr = referenceFrame.chr;
            const chromosome = referenceFrame.genome.getChromosome(chr);

            if (undefined === chromosome || pixelWidth <= 0 || pixelHeight <= 0 || 'all' === chr.toLowerCase()) {
                return
            }

            const stainColors = [];

            drawIdeogram({
                ctx: context,
                chr,
                referenceFrame,
                genome: referenceFrame.genome,
                width: pixelWidth,
                height: pixelHeight,
                stainColors
            });

            const widthBP = Math.round(referenceFrame.bpPerPixel * pixelWidth);
            const xBP = referenceFrame.start;

            // Total chromosome length can be > chromosome.bpLength for partial fastas.
            let chrLength = chromosome.bpLength;
            const cytobands = referenceFrame.genome.getCytobands(chr);
            if (cytobands && cytobands.length > 0 && cytobands[cytobands.length - 1].end) {
                chrLength = Math.max(chrLength, cytobands[cytobands.length - 1].end);
                chromosome.bpLength = chrLength;   // Correct bp length, bit of a hack
            }

            if (widthBP < chrLength) {

                const percentWidth = widthBP / chrLength;
                const percentX = xBP / chrLength;

                let x = Math.floor(percentX * pixelWidth);
                let ww = Math.floor(percentWidth * pixelWidth);

                x = Math.max(0, x);
                x = Math.min(pixelWidth - ww, x);

                // Push current context
                context.save();

                // Draw red box
                context.strokeStyle = "red";
                context.lineWidth = (ww < 2) ? 1 : 2;

                const xx = x + (context.lineWidth) / 2;
                ww = (ww < 2) ? 1 : ww - context.lineWidth;

                const yy = context.lineWidth / 2;
                const hh = pixelHeight - context.lineWidth;

                context.strokeRect(xx, yy, ww, hh);

                // Pop current context
                context.restore();
            }

        }

        dispose() {
            this.trackView = undefined;
        }
    }

    function drawIdeogram({ctx, chr, referenceFrame, genome, width, height, stainColors}) {

        const shim = 1;
        const shim2 = 0.5 * shim;
        const ideogramTop = 0;

        if (undefined === genome) {
            return
        }

        IGVGraphics.fillRect(ctx, 0, 0, width, height, {fillStyle: IGVColor.greyScale(255)});

        const cytobands = genome.getCytobands(chr);
        if (cytobands) {

            const center = (ideogramTop + height / 2);

            const xC = [];
            const yC = [];

            if (0 === cytobands.length) {
                return
            }

            // Get chrLength from the cytobands -- chromsome.bpLength might not work for igv-reports fasta files, which
            // contain only a portion of the chromosome sequence
            // *DOESNT WORK* const chrLength = referenceFrame.genome.getChromosome(chr).bpLength;

            const chrLength = cytobands[cytobands.length - 1].end;
            const scale = width / chrLength;

            // round rect clipping path
            ctx.beginPath();
            IGVGraphics.roundRect(ctx, shim2, shim2 + ideogramTop, width - 2 * shim2, height - 2 * shim2, (height - 2 * shim2) / 2, 0, 1);
            ctx.clip();

            for (let i = 0; i < cytobands.length; i++) {

                const cytoband = cytobands[i];
                const start = scale * cytoband.start;
                const end = scale * cytoband.end;

                if (cytoband.type === 'c') {

                    if (cytoband.name.charAt(0) === 'p') {
                        xC[0] = start;
                        yC[0] = height + ideogramTop;
                        xC[1] = start;
                        yC[1] = ideogramTop;
                        xC[2] = end;
                        yC[2] = center;
                    } else {
                        xC[0] = end;
                        yC[0] = height + ideogramTop;
                        xC[1] = end;
                        yC[1] = ideogramTop;
                        xC[2] = start;
                        yC[2] = center;
                    }

                    ctx.fillStyle = "rgb(150, 0, 0)";
                    ctx.strokeStyle = "rgb(150, 0, 0)";
                    IGVGraphics.polygon(ctx, xC, yC, 1, 0);
                } else {

                    ctx.fillStyle = getCytobandColor(stainColors, cytoband);
                    IGVGraphics.fillRect(ctx, start, shim + ideogramTop, (end - start), height - 2 * shim);
                }
            }
        }

        // round rect border
        ctx.strokeStyle = IGVColor.greyScale(41);
        IGVGraphics.roundRect(ctx, shim2, shim2 + ideogramTop, width - 2 * shim2, height - 2 * shim2, (height - 2 * shim2) / 2, 0, 1);
    }

    function getCytobandColor(colors, data) {

        if (data.type === 'c') { // centermere: "acen"
            return "rgb(150, 10, 10)"
        } else {
            var stain = data.stain; // + 4;

            var shade = 230;
            if (data.type === 'p') {
                shade = Math.floor(230 - stain / 100.0 * 230);
            }
            var c = colors[shade];
            if (!c) {
                c = "rgb(" + shade + "," + shade + "," + shade + ")";
                colors[shade] = c;
            }
            return c

        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    let JUNCTION_MOTIF_PALETTE = new PaletteColorTable("Dark2");

    // Lock in color-to-motif mapping so it's independent of data loading order. This list may not include all possible
    // motif values as this varies depending on the RNA-seq pipeline. The current list is based on STAR v2.4 docs.
    const someMotifValues = ['GT/AG', 'CT/AC', 'GC/AG', 'CT/GC', 'AT/AC', 'GT/AT', 'non-canonical'];
    someMotifValues.forEach(motif => {
        JUNCTION_MOTIF_PALETTE.getColor(motif);
    });

    // rendering context with values that only need to be computed once per render, rather than for each splice junction
    const junctionRenderingContext = {};

    class SpliceJunctionTrack extends TrackBase {

        constructor(config, browser) {
            super(config, browser);
        }


        init(config) {

            super.init(config);

            this.type = config.type || 'junctions';

            if (config._featureSource) {
                this.featureSource = config._featureSource;
                delete config._featureSource;
            } else {
                this.featureSource = config.featureSource ?
                    config.featureSource :
                    FeatureSource(config, this.browser.genome);
            }

            this.margin = config.margin === undefined ? 10 : config.margin;

            if (!this.height) {
                this.height = 100;
            }

            //set defaults
            if (config.colorByNumReadsThreshold === undefined) {
                config.colorByNumReadsThreshold = 5;
            }
        }

        async postInit() {

            if (typeof this.featureSource.getHeader === "function") {
                this.header = await this.featureSource.getHeader();
                if (this.disposed) return   // This track was removed during async load
            }

            // Set properties from track line
            if (this.header) {
                this.setTrackProperties(this.header);
            }

            if (this.visibilityWindow === undefined && typeof this.featureSource.defaultVisibilityWindow === 'function') {
                this.visibilityWindow = await this.featureSource.defaultVisibilityWindow();
            }

            return this

        }

        get supportsWholeGenome() {
            return false
        }

        async getFeatures(chr, start, end, bpPerPixel) {
            const visibilityWindow = this.visibilityWindow;
            return this.featureSource.getFeatures({chr, start, end, bpPerPixel, visibilityWindow})
        };


        /**
         * The required height in pixels required for the track content.   This is not the visible track height, which
         * can be smaller (with a scrollbar) or larger.
         *
         * @param features
         * @returns {*}
         */
        computePixelHeight(features) {
            return this.height
        };

        draw(options) {

            const featureList = options.features;
            const ctx = options.context;
            const bpPerPixel = options.bpPerPixel;
            const bpStart = options.bpStart;
            const pixelWidth = options.pixelWidth;
            const pixelHeight = options.pixelHeight;
            const bpEnd = bpStart + pixelWidth * bpPerPixel + 1;


            if (!this.config.isMergedTrack) {
                IGVGraphics.fillRect(ctx, 0, options.pixelTop, pixelWidth, pixelHeight, {'fillStyle': "rgb(255, 255, 255)"});
            }

            if (featureList) {


                junctionRenderingContext.referenceFrame = options.viewport.referenceFrame;
                junctionRenderingContext.referenceFrameStart = junctionRenderingContext.referenceFrame.start;
                junctionRenderingContext.referenceFrameEnd = junctionRenderingContext.referenceFrameStart +
                    junctionRenderingContext.referenceFrame.toBP(options.viewport.getWidth());

                // For a given viewport, records where features that are < 2px in width have been rendered already.
                // This prevents wasteful rendering of multiple such features onto the same pixels.
                junctionRenderingContext.featureZoomOutTracker = {};

                for (let feature of featureList) {
                    if (feature.end < bpStart) continue
                    if (feature.start > bpEnd) break
                    this.renderJunction(feature, bpStart, bpPerPixel, pixelHeight, ctx);
                }

            } else {
                console.log("No feature list");
            }

        };

        /**
         *
         * @param feature
         * @param bpStart  genomic location of the left edge of the current canvas
         * @param xScale  scale in base-pairs per pixel
         * @param pixelHeight  pixel height of the current canvas
         * @param ctx  the canvas 2d context
         */
        renderJunction(feature, bpStart, xScale, pixelHeight, ctx) {
            // cache whether this junction is rendered or filtered out. Use later to exclude non-rendered junctions from click detection.
            feature.isVisible = false;

            const junctionLeftPx = Math.round((feature.start - bpStart) / xScale);
            const junctionRightPx = Math.round((feature.end - bpStart) / xScale);
            const junctionMiddlePx = (junctionLeftPx + junctionRightPx) / 2;
            if (junctionRightPx - junctionLeftPx <= 3) {
                if (junctionMiddlePx in junctionRenderingContext.featureZoomOutTracker) {
                    return
                }
                junctionRenderingContext.featureZoomOutTracker[junctionMiddlePx] = true;
            }

            // TODO: cache filter and pixel calculations by doing them earlier when features are initially parsed?
            if (this.config.hideAnnotatedJunctions && feature.attributes.annotated_junction === "true") {
                return
            }
            if (this.config.hideUnannotatedJunctions && feature.attributes.annotated_junction === "false") {
                return
            }
            if (this.config.hideMotifs && this.config.hideMotifs.includes(feature.attributes.motif)) {
                return
            }
            if (this.config.hideStrand === feature.strand) {
                return
            }

            // check if splice junction is inside viewport
            if (this.config.minJunctionEndsVisible) {
                let numJunctionEndsVisible = 0;
                if (feature.start >= junctionRenderingContext.referenceFrameStart && feature.start <= junctionRenderingContext.referenceFrameEnd) {
                    numJunctionEndsVisible += 1;
                }
                if (feature.end >= junctionRenderingContext.referenceFrameStart && feature.end <= junctionRenderingContext.referenceFrameEnd) {
                    numJunctionEndsVisible += 1;
                }
                if (numJunctionEndsVisible < this.config.minJunctionEndsVisible) {
                    return
                }
            }

            let uniquelyMappedReadCount;
            let multiMappedReadCount;
            let totalReadCount;
            if (feature.attributes.uniquely_mapped) {
                uniquelyMappedReadCount = parseInt(feature.attributes.uniquely_mapped);
                if (uniquelyMappedReadCount < this.config.minUniquelyMappedReads) {
                    return
                }
                multiMappedReadCount = parseInt(feature.attributes.multi_mapped);
                totalReadCount = uniquelyMappedReadCount + multiMappedReadCount;
                if (totalReadCount < this.config.minTotalReads) {
                    return
                }
                if (totalReadCount > 0 && multiMappedReadCount / totalReadCount > this.config.maxFractionMultiMappedReads) {
                    return
                }
                if (feature.attributes.maximum_spliced_alignment_overhang && parseInt(feature.attributes.maximum_spliced_alignment_overhang) < this.config.minSplicedAlignmentOverhang) {
                    return
                }
            }

            let numSamplesWithThisJunction;
            if (feature.attributes.num_samples_with_this_junction) {
                numSamplesWithThisJunction = parseInt(feature.attributes.num_samples_with_this_junction);
                if (this.config.minSamplesWithThisJunction && numSamplesWithThisJunction < this.config.minSamplesWithThisJunction) {
                    return
                }
                if (this.config.maxSamplesWithThisJunction && numSamplesWithThisJunction > this.config.maxSamplesWithThisJunction) {
                    return
                }
                if (feature.attributes.num_samples_total) {
                    feature.attributes.percent_samples_with_this_junction = 100 * numSamplesWithThisJunction / Number(feature.attributes.num_samples_total);
                    if (this.config.minPercentSamplesWithThisJunction) {
                        if (feature.attributes.percent_samples_with_this_junction < this.config.minPercentSamplesWithThisJunction ||
                            feature.attributes.percent_samples_with_this_junction > this.config.maxPercentSamplesWithThisJunction) {
                            return
                        }
                    }
                }
            }

            const py = this.margin;
            const rowHeight = this.height;

            const cy = py + 0.5 * rowHeight;
            let topY = py;
            const bottomY = py + rowHeight;
            const bezierBottomY = bottomY - 10;

            // draw the junction arc
            const bezierControlLeftPx = (junctionLeftPx + junctionMiddlePx) / 2;
            const bezierControlRightPx = (junctionMiddlePx + junctionRightPx) / 2;

            let lineWidth = 1;
            if (feature.attributes.line_width) {
                lineWidth = Number(feature.attributes.line_width);
            } else {
                if (this.config.thicknessBasedOn === undefined || this.config.thicknessBasedOn === 'numUniqueReads') {
                    lineWidth = uniquelyMappedReadCount;
                } else if (this.config.thicknessBasedOn === 'numReads') {
                    lineWidth = totalReadCount;
                } else if (this.config.thicknessBasedOn === 'numSamplesWithThisJunction') {
                    if (numSamplesWithThisJunction !== undefined) {
                        lineWidth = numSamplesWithThisJunction;
                    }
                }
                lineWidth = 1 + Math.log(lineWidth + 1) / Math.log(12);
            }

            let bounceHeight;
            if (this.config.bounceHeightBasedOn === undefined || this.config.bounceHeightBasedOn === 'random') {
                // randomly but deterministically stagger topY coordinates to reduce overlap
                bounceHeight = (feature.start + feature.end) % 7;
            } else if (this.config.bounceHeightBasedOn === 'distance') {
                bounceHeight = 6 * (feature.end - feature.start) / (junctionRenderingContext.referenceFrameEnd - junctionRenderingContext.referenceFrameStart);
            } else if (this.config.bounceHeightBasedOn === 'thickness') {
                bounceHeight = 2 * lineWidth;
            }
            topY += rowHeight * Math.max(7 - bounceHeight, 0) / 10;

            let color;
            if (feature.attributes.color) {
                color = feature.attributes.color;  // Explicit setting
            } else if (this.config.colorBy === undefined || this.config.colorBy === 'numUniqueReads') {
                color = uniquelyMappedReadCount > this.config.colorByNumReadsThreshold ? 'blue' : '#AAAAAA';  // color gradient?
            } else if (this.config.colorBy === 'numReads') {
                color = totalReadCount > this.config.colorByNumReadsThreshold ? 'blue' : '#AAAAAA';
            } else if (this.config.colorBy === 'isAnnotatedJunction') {
                color = feature.attributes.annotated_junction === "true" ? '#b0b0ec' : 'orange';
            } else if (this.config.colorBy === 'strand') {
                color = feature.strand === "+" ? '#b0b0ec' : '#ecb0b0';
            } else if (this.config.colorBy === 'motif') {
                color = JUNCTION_MOTIF_PALETTE.getColor(feature.attributes.motif);
            } else {
                color = '#AAAAAA';
            }

            let label = "";
            if (feature.attributes.label) {
                label = feature.attributes.label.replace(/_/g, " ");
            } else if (this.config.labelWith === undefined || this.config.labelWith === 'uniqueReadCount') {
                //default label
                label = uniquelyMappedReadCount;
            } else if (this.config.labelWith === 'totalReadCount') {
                label = totalReadCount;
            } else if (this.config.labelWith === 'numSamplesWithThisJunction') {
                if (numSamplesWithThisJunction !== undefined) {
                    label = numSamplesWithThisJunction;
                }
            } else if (this.config.labelWith === 'percentSamplesWithThisJunction') {
                if (feature.attributes.percent_samples_with_this_junction !== undefined) {
                    label = feature.attributes.percent_samples_with_this_junction.toFixed(0) + '%';
                }
            } else if (this.config.labelWith === 'motif') {
                if (feature.attributes.motif !== undefined) {
                    label += feature.attributes.motif;
                }
            }

            if (this.config.labelWithInParen === 'uniqueReadCount') {
                label += ' (' + uniquelyMappedReadCount + ')';
            } else if (this.config.labelWithInParen === 'totalReadCount') {
                label += ' (' + totalReadCount + ')';
            } else if (this.config.labelWithInParen === 'multiMappedReadCount') {
                if (multiMappedReadCount > 0) {
                    label += ' (+' + multiMappedReadCount + ')';
                }
            } else if (this.config.labelWithInParen === 'numSamplesWithThisJunction') {
                if (numSamplesWithThisJunction !== undefined) {
                    label += ' (' + numSamplesWithThisJunction + ')';
                }
            } else if (this.config.labelWithInParen === 'percentSamplesWithThisJunction') {
                if (feature.attributes.percent_samples_with_this_junction !== undefined) {
                    label += ' (' + feature.attributes.percent_samples_with_this_junction.toFixed(0) + '%)';
                }
            } else if (this.config.labelWithInParen === 'motif') {
                if (feature.attributes.motif !== undefined) {
                    label += ` ${feature.attributes.motif}`;
                }
            }

            // data source: STAR splice junctions (eg. SJ.out.tab file converted to bed).
            // .bed "name" field used to store unique + multi-mapped read counts, so:
            // feature.score:  unique spanning read counts
            // feature.name:   unique + multi-mapped spanning read counts
            //example feature:  { chr: "chr17", start: 39662344, end: 39662803, name: "59", row: 0, score: 38, strand: "+"}
            feature.isVisible = true;
            ctx.beginPath();
            ctx.moveTo(junctionLeftPx, bezierBottomY);
            ctx.bezierCurveTo(bezierControlLeftPx, topY, bezierControlRightPx, topY, junctionRightPx, bezierBottomY);

            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = color;
            ctx.stroke();

            const drawArrowhead = (ctx, x, y, size) => {
                //TODO draw better arrow heads: https://stackoverflow.com/questions/21052972/curved-thick-arrows-on-canvas
                ctx.beginPath();
                ctx.moveTo(x, y);
                ctx.lineTo(x - size / 2, y - size);
                ctx.lineTo(x + size / 2, y - size);
                ctx.lineTo(x, y);
                ctx.closePath();
                ctx.fill();
            };

            if (feature.attributes.left_shape || feature.attributes.right_shape) {
                ctx.fillStyle = color;
                const arrowSize = ctx.lineWidth > 2 ? 10 : 7;
                if (feature.attributes.left_shape) {
                    drawArrowhead(ctx, junctionLeftPx, bezierBottomY, arrowSize);
                }
                if (feature.attributes.right_shape) {
                    drawArrowhead(ctx, junctionRightPx, bezierBottomY, arrowSize);
                }
            }

            ctx.fillText(label, junctionMiddlePx - ctx.measureText(label).width / 2, (7 * topY + cy) / 8);
        }

        clickedFeatures(clickState) {

            const allFeatures = super.clickedFeatures(clickState);

            return allFeatures.filter(function (feature) {
                return (feature.isVisible && feature.attributes)
            })
        }

        /**
         * Return "popup data" for feature @ genomic location.  Data is an array of key-value pairs
         */
        popupData(clickState, features) {

            if (features === undefined) features = this.clickedFeatures(clickState);
            const genomicLocation = clickState.genomicLocation;

            const data = [];
            for (let feature of features) {

                const featureData = (typeof feature.popupData === "function") ?
                    feature.popupData(genomicLocation) :
                    this.extractPopupData(feature._f || feature, this.getGenomeId());

                if (featureData) {
                    if (data.length > 0) {
                        data.push("<hr/><hr/>");
                    }

                    Array.prototype.push.apply(data, featureData);
                }
            }

            return data
        }

        /**
         * Called when the track is removed.  Do any needed cleanup here
         */
        dispose() {
            this.trackView = undefined;
        }
    }

    class RemoteFile {

        constructor(args) {
            this.config = args;
            this.url = mapUrl(args.path || args.url);
        }


        async read(position, length) {

            //console.log(`${position} - ${position + length} (${length})`)

            const headers = this.config.headers || {};

            if (position !== undefined && length) {
                const rangeString = "bytes=" + position + "-" + (position + length - 1);
                headers['Range'] = rangeString;
            }

            let url = this.url.slice();    // slice => copy
            if (this.config.oauthToken) {
                const token = resolveToken(this.config.oauthToken);
                headers['Authorization'] = `Bearer ${token}`;
            }

            if (this.config.apiKey) {
                url = addParameter(url, "key", this.config.apiKey);
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: headers,
                redirect: 'follow',
                mode: 'cors',
            });

            const status = response.status;

            if (status >= 400) {
                const err = Error(response.statusText);
                err.code = status;
                throw err
            } else {
                return response.arrayBuffer()
            }

            /**
             * token can be a string, a function that returns a string, or a function that returns a Promise for a string
             * @param token
             * @returns {Promise<*>}
             */
            async function resolveToken(token) {
                if (typeof token === 'function') {
                    return await Promise.resolve(token())    // Normalize the result to a promise, since we don't know what the function returns
                } else {
                    return token
                }
            }

        }
    }


    function mapUrl(url) {

        if (url.includes("//www.dropbox.com")) {
            return url.replace("//www.dropbox.com", "//dl.dropboxusercontent.com")
        } else if (url.startsWith("ftp://ftp.ncbi.nlm.nih.gov")) {
            return url.replace("ftp://", "https://")
        } else {
            return url
        }
    }


    function addParameter(url, name, value) {
        const paramSeparator = url.includes("?") ? "&" : "?";
        return url + paramSeparator + name + "=" + value
    }

    class BufferedFile {

        constructor(args) {
            this.file = args.file;
            this.fetchSize = args.fetchSize || 16000;
            this.maxSize = args.maxSize || 1000000;
            this.buffers = [];
        }

        async read(position, length) {


            let overlappingBuffers = this.buffers.filter( b => b.overlaps(position, position + length));

            // See if any buffers completely contain request, if so we're done
            for(let buffer of overlappingBuffers) {
                if(buffer.contains(position, position + length)) {
                  return buffer.slice(position, position + length)
                }
            }


            if(overlappingBuffers.length === 0) {

                // No overlap with any existing buffer
                let size = Math.max(length, this.fetchSize);

                // Find index of first buffer to the right, if any, to potentially limit size
                this.buffers.sort((a, b) => a.start - b.start);
                const idx = binarySearch(this.buffers, (b) => b.start > position, 0);
                if(idx < this.buffers.length) {
                    size = Math.min(size, this.buffers[idx].start - position);
                }

                const bufferStart = position;
                const bufferData = await this.file.read(bufferStart, size);
                const buffer = new Buffer$1(bufferStart, bufferData);
                this.addBuffer(buffer);

                return buffer.slice(position, position + length)
            } else {

                // console.log("Cache hit")
                // Some overlap.   Fill gaps
                overlappingBuffers.sort((a, b) => a.start - b.start);
                const allBuffers = [];
                let currentEnd = position;
                for (let ob of overlappingBuffers) {
                    if (currentEnd < ob.start) {
                        const bufferStart = currentEnd;
                        const bufferSize = ob.start - currentEnd;
                        const bufferData = await this.file.read(bufferStart, bufferSize);
                        const buffer = new Buffer$1(bufferStart, bufferData);
                        allBuffers.push(buffer);
                    }
                    allBuffers.push(ob);
                    currentEnd = ob.end;
                }

                // Check end
                const requestedEnd = position + length;
                if (requestedEnd > currentEnd) {
                    const bufferStart = currentEnd;
                    const bufferSize = requestedEnd - bufferStart;
                    const bufferData = await this.file.read(bufferStart, bufferSize);
                    const buffer = new Buffer$1(bufferStart, bufferData);
                    allBuffers.push(buffer);
                }

                const newStart = allBuffers[0].start;
                const newArrayBuffer = concatArrayBuffers(allBuffers.map(b => b.buffer));
                const newBuffer = new Buffer$1(newStart, newArrayBuffer);

                // Replace the overlapping buffers with the new composite one
                const tmp = new Set(overlappingBuffers);
                this.buffers = this.buffers.filter(b => !tmp.has(b));
                this.addBuffer(newBuffer);

                return newBuffer.slice(position, position + length)
            }

        }

        addBuffer(buffer) {

            const size = this.buffers.reduce((a,b) => a + b.size, 0) + buffer.size;
            if(size > this.maxSize) {
                // console.log(`max buffer size exceeded`)
                const overage = size - this.maxSize;
                this.buffers.sort((a,b) => a.creationTime - b.creationTime);
                let sum = 0;
                let i;
                for(i=0; i<this.buffers.length; i++) {
                    sum += this.buffers[i].size;
                    if(sum > overage) {
                        break
                    }
                }
                // console.log('removing buffers')
                // for(let j=0; j<i; j++) console.log(`  ${this.buffers[j].toString()}`)
                this.buffers = (i < this.buffers.length - 1)  ? this.buffers.slice(i)  : [];
            }

            if(buffer.size <= this.maxSize) {
                this.buffers.push(buffer);
            }
        }



    }

    class Buffer$1 {

        constructor(bufferStart, buffer) {
            this.creationTime = Date.now();
            this.start = bufferStart;
            this.buffer = buffer;
        }

        slice(start, end) {
            if(start < this.start || end - start > this.buffer.byteLength) {
                throw Error("buffer bounds error")
            }
            return this.buffer.slice(start - this.start, end - this.start)
        }

        get end() {
            return this.start + this.buffer.byteLength
        }

        get size() {
            return this.buffer.byteLength
        }

        contains(start, end) {
            return start >= this.start && end <= this.end
        }

        overlaps(start, end) {
            return (start > this.start && start < this.end) || (end > this.start && end < this.end)
        }

        toString() {
            return `Buffer ${this.creationTime}   ${this.start} - ${this.end}`
        }

    }

    /**
     * concatenates 2 array buffers.
     * Credit: https://gist.github.com/72lions/4528834
     *
     * @private
     * @param {ArrayBuffers} buffer1 The first buffer.
     * @param {ArrayBuffers} buffer2 The second buffer.
     * @return {ArrayBuffers} The new ArrayBuffer created out of the two.
     */
    function concatArrayBuffers(buffers) {
        const size = buffers.reduce((a,b) => a + b.byteLength, 0);
        const tmp = new Uint8Array(size);
        let offset = 0;
        for(let b of buffers) {
            tmp.set(new Uint8Array(b), offset);
            offset += b.byteLength;
        }
        return tmp.buffer
    }

    /**
     * Return 0 <= i <= array.length such that !pred(array[i - 1]) && pred(array[i]).
     *
     * returns an index 0 ≤ i ≤ array.length such that the given predicate is false for array[i - 1] and true for array[i]* *
     */
    function binarySearch(array, pred, min) {
        let lo = min - 1, hi = array.length;
        while (1 + lo < hi) {
            const mi = lo + ((hi - lo) >> 1);
            if (pred(array[mi])) {
                hi = mi;
            } else {
                lo = mi;
            }
        }
        return hi
    }

    class BlobFile {

        constructor(blob) {
            this.file = blob;
        }

        async read(position, length) {

            if(length === 0) {
                return new ArrayBuffer()
            }

            const blob = (position != undefined && length) ?
                this.file.slice(position, position + length) :
                this.file;

            return blob.arrayBuffer()
        }
    }

    var __defProp = Object.defineProperty;
    var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __publicField = (obj, key, value) => {
      __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
      return value;
    };

    // esm/core.js
    async function _unpack_struct_from_async(structure, async_buf, offset = 0) {
      var output = /* @__PURE__ */ new Map();
      for (let [key, fmt] of structure.entries()) {
        let value = await struct.unpack_from_async("<" + fmt, async_buf, offset);
        offset += struct.calcsize(fmt);
        if (value.length == 1) {
          value = value[0];
        }
        output.set(key, value);
      }
      return output;
    }
    function _unpack_struct_from(structure, buf, offset = 0) {
      var output = /* @__PURE__ */ new Map();
      for (let [key, fmt] of structure.entries()) {
        let value = struct.unpack_from("<" + fmt, buf, offset);
        offset += struct.calcsize(fmt);
        if (value.length == 1) {
          value = value[0];
        }
        output.set(key, value);
      }
      return output;
    }
    function assert(thing) {
      if (!thing) {
        thing();
      }
    }
    function _structure_size(structure) {
      var fmt = "<" + Array.from(structure.values()).join("");
      return struct.calcsize(fmt);
    }
    function _padded_size(size, padding_multiple = 8) {
      return Math.ceil(size / padding_multiple) * padding_multiple;
    }
    var dtype_to_format = {
      "u": "Uint",
      "i": "Int",
      "f": "Float"
    };
    function dtype_getter(dtype_str) {
      var big_endian = struct._is_big_endian(dtype_str);
      var getter, nbytes;
      if (/S/.test(dtype_str)) {
        getter = "getString";
        nbytes = ((dtype_str.match(/S(\d*)/) || [])[1] || 1) | 0;
      } else {
        let [_, fstr, bytestr] = dtype_str.match(/[<>=!@]?(i|u|f)(\d*)/);
        nbytes = parseInt(bytestr || 4, 10);
        let nbits = nbytes * 8;
        getter = "get" + dtype_to_format[fstr] + nbits.toFixed();
      }
      return [getter, big_endian, nbytes];
    }
    var Struct = class {
      constructor() {
        this.big_endian = isBigEndian();
        this.getters = {
          "s": "getUint8",
          "b": "getInt8",
          "B": "getUint8",
          "h": "getInt16",
          "H": "getUint16",
          "i": "getInt32",
          "I": "getUint32",
          "l": "getInt32",
          "L": "getUint32",
          "q": "getInt64",
          "Q": "getUint64",
          "f": "getFloat32",
          "d": "getFloat64"
        };
        this.byte_lengths = {
          "s": 1,
          "b": 1,
          "B": 1,
          "h": 2,
          "H": 2,
          "i": 4,
          "I": 4,
          "l": 4,
          "L": 4,
          "q": 8,
          "Q": 8,
          "f": 4,
          "d": 8
        };
        let all_formats = Object.keys(this.byte_lengths).join("");
        this.fmt_size_regex = "(\\d*)([" + all_formats + "])";
      }
      calcsize(fmt) {
        var size = 0;
        var match;
        var regex = new RegExp(this.fmt_size_regex, "g");
        while ((match = regex.exec(fmt)) !== null) {
          let n = parseInt(match[1] || 1, 10);
          let f = match[2];
          let subsize = this.byte_lengths[f];
          size += n * subsize;
        }
        return size;
      }
      _is_big_endian(fmt) {
        var big_endian;
        if (/^</.test(fmt)) {
          big_endian = false;
        } else if (/^(!|>)/.test(fmt)) {
          big_endian = true;
        } else {
          big_endian = this.big_endian;
        }
        return big_endian;
      }
      async unpack_from_async(fmt, async_buf, offset) {
        offset = Number.parseInt(offset || 0);
        const total_size = this.calcsize(fmt);
        const local_buffer = await async_buf.slice(offset, offset + total_size);
        let local_offset = 0;
        var view = new DataView64(local_buffer);
        var output = [];
        var big_endian = this._is_big_endian(fmt);
        var match;
        var regex = new RegExp(this.fmt_size_regex, "g");
        while ((match = regex.exec(fmt)) !== null) {
          let n = parseInt(match[1] || 1, 10);
          let f = match[2];
          let getter = this.getters[f];
          let size = this.byte_lengths[f];
          if (f == "s") {
            output.push(new TextDecoder().decode(local_buffer.slice(local_offset, local_offset + n)));
            local_offset += n;
          } else {
            for (var i = 0; i < n; i++) {
              output.push(view[getter](local_offset, !big_endian));
              local_offset += size;
            }
          }
        }
        return output;
      }
      unpack_from(fmt, buffer, offset) {
        offset = Number.parseInt(offset || 0);
        const total_size = this.calcsize(fmt);
        const local_buffer = buffer.slice(offset, offset + total_size);
        let local_offset = 0;
        var view = new DataView64(local_buffer);
        var output = [];
        var big_endian = this._is_big_endian(fmt);
        var match;
        var regex = new RegExp(this.fmt_size_regex, "g");
        while ((match = regex.exec(fmt)) !== null) {
          let n = parseInt(match[1] || 1, 10);
          let f = match[2];
          let getter = this.getters[f];
          let size = this.byte_lengths[f];
          if (f == "s") {
            output.push(new TextDecoder().decode(local_buffer.slice(local_offset, local_offset + n)));
            local_offset += n;
          } else {
            for (var i = 0; i < n; i++) {
              output.push(view[getter](local_offset, !big_endian));
              local_offset += size;
            }
          }
        }
        return output;
      }
    };
    var struct = new Struct();
    function isBigEndian() {
      const array = new Uint8Array(4);
      const view = new Uint32Array(array.buffer);
      return !((view[0] = 1) & array[0]);
    }
    var DataView64 = class extends DataView {
      getUint64(byteOffset, littleEndian) {
        const left = BigInt(this.getUint32(byteOffset, littleEndian));
        const right = BigInt(this.getUint32(byteOffset + 4, littleEndian));
        let combined = littleEndian ? left + (right << 32n) : (left << 32n) + right;
        return Number.parseInt(combined);
      }
      getInt64(byteOffset, littleEndian) {
        var low, high;
        if (littleEndian) {
          low = this.getUint32(byteOffset, true);
          high = this.getInt32(byteOffset + 4, true);
        } else {
          high = this.getInt32(byteOffset, false);
          low = this.getUint32(byteOffset + 4, false);
        }
        let combined = BigInt(low) + (BigInt(high) << 32n);
        return Number.parseInt(combined);
      }
      getString(byteOffset, littleEndian, length) {
        const str_buffer = this.buffer.slice(byteOffset, byteOffset + length);
        const decoder = new TextDecoder();
        return decoder.decode(str_buffer);
      }
      getVLENStruct(byteOffset, littleEndian, length) {
        let item_size = this.getUint32(byteOffset, littleEndian);
        let collection_address = this.getUint64(byteOffset + 4, littleEndian);
        let object_index = this.getUint32(byteOffset + 12, littleEndian);
        return [item_size, collection_address, object_index];
      }
    };
    function bitSize(integer) {
      return integer.toString(2).length;
    }
    function _unpack_integer(nbytes, buf, offset = 0, littleEndian = true) {
      const local_buffer = buf.slice(offset, offset + nbytes);
      let bytes = new Uint8Array(local_buffer);
      if (!littleEndian) {
        bytes.reverse();
      }
      let integer = bytes.reduce((accumulator, currentValue, index) => accumulator + (currentValue << index * 8), 0);
      return integer;
    }

    // esm/datatype-msg.js
    var DatatypeMessage = class {
      constructor(buf, offset) {
        this.buf = buf;
        this.offset = offset;
        this.dtype = this.determine_dtype();
      }
      async determine_dtype() {
        let datatype_msg = await _unpack_struct_from_async(DATATYPE_MSG, this.buf, this.offset);
        this.offset += DATATYPE_MSG_SIZE;
        let datatype_class = datatype_msg.get("class_and_version") & 15;
        if (datatype_class == DATATYPE_FIXED_POINT) {
          return this._determine_dtype_fixed_point(datatype_msg);
        } else if (datatype_class == DATATYPE_FLOATING_POINT) {
          return this._determine_dtype_floating_point(datatype_msg);
        } else if (datatype_class == DATATYPE_TIME) {
          throw "Time datatype class not supported.";
        } else if (datatype_class == DATATYPE_STRING) {
          return this._determine_dtype_string(datatype_msg);
        } else if (datatype_class == DATATYPE_BITFIELD) {
          throw "Bitfield datatype class not supported.";
        } else if (datatype_class == DATATYPE_OPAQUE) {
          return {
            datatype_class: DATATYPE_OPAQUE,
            size: datatype_msg.get("size")
          };
        } else if (datatype_class == DATATYPE_COMPOUND) {
          return this._determine_dtype_compound(datatype_msg);
        } else if (datatype_class == DATATYPE_REFERENCE) {
          return ["REFERENCE", datatype_msg.get("size")];
        } else if (datatype_class == DATATYPE_ENUMERATED) {
          return this.determine_dtype();
        } else if (datatype_class == DATATYPE_ARRAY) {
          throw "Array datatype class not supported.";
        } else if (datatype_class == DATATYPE_VARIABLE_LENGTH) {
          let vlen_type = this._determine_dtype_vlen(datatype_msg);
          if (vlen_type[0] == "VLEN_SEQUENCE") {
            let base_type = this.determine_dtype();
            vlen_type = ["VLEN_SEQUENCE", base_type];
          }
          return vlen_type;
        } else {
          throw "Invalid datatype class " + datatype_class;
        }
      }
      _determine_dtype_fixed_point(datatype_msg) {
        let length_in_bytes = datatype_msg.get("size");
        if (![1, 2, 4, 8].includes(length_in_bytes)) {
          throw "Unsupported datatype size";
        }
        let signed = datatype_msg.get("class_bit_field_0") & 8;
        var dtype_char;
        if (signed > 0) {
          dtype_char = "i";
        } else {
          dtype_char = "u";
        }
        let byte_order = datatype_msg.get("class_bit_field_0") & 1;
        var byte_order_char;
        if (byte_order == 0) {
          byte_order_char = "<";
        } else {
          byte_order_char = ">";
        }
        this.offset += 4;
        return byte_order_char + dtype_char + length_in_bytes.toFixed();
      }
      _determine_dtype_floating_point(datatype_msg) {
        let length_in_bytes = datatype_msg.get("size");
        if (![1, 2, 4, 8].includes(length_in_bytes)) {
          throw "Unsupported datatype size";
        }
        let dtype_char = "f";
        let byte_order = datatype_msg.get("class_bit_field_0") & 1;
        var byte_order_char;
        if (byte_order == 0) {
          byte_order_char = "<";
        } else {
          byte_order_char = ">";
        }
        this.offset += 12;
        return byte_order_char + dtype_char + length_in_bytes.toFixed();
      }
      _determine_dtype_string(datatype_msg) {
        return "S" + datatype_msg.get("size").toFixed();
      }
      _determine_dtype_vlen(datatype_msg) {
        let vlen_type = datatype_msg.get("class_bit_field_0") & 1;
        if (vlen_type != 1) {
          return ["VLEN_SEQUENCE", 0, 0];
        }
        let padding_type = datatype_msg.get("class_bit_field_0") >> 4;
        let character_set = datatype_msg.get("class_bit_field_1") & 1;
        return ["VLEN_STRING", padding_type, character_set];
      }
      _determine_dtype_compound(datatype_msg) {
        throw "Compound type not yet implemented!";
      }
    };
    var DATATYPE_MSG = /* @__PURE__ */ new Map([
      ["class_and_version", "B"],
      ["class_bit_field_0", "B"],
      ["class_bit_field_1", "B"],
      ["class_bit_field_2", "B"],
      ["size", "I"]
    ]);
    var DATATYPE_MSG_SIZE = _structure_size(DATATYPE_MSG);
    var COMPOUND_PROP_DESC_V1 = /* @__PURE__ */ new Map([
      ["offset", "I"],
      ["dimensionality", "B"],
      ["reserved_0", "B"],
      ["reserved_1", "B"],
      ["reserved_2", "B"],
      ["permutation", "I"],
      ["reserved_3", "I"],
      ["dim_size_1", "I"],
      ["dim_size_2", "I"],
      ["dim_size_3", "I"],
      ["dim_size_4", "I"]
    ]);
    _structure_size(COMPOUND_PROP_DESC_V1);
    var DATATYPE_FIXED_POINT = 0;
    var DATATYPE_FLOATING_POINT = 1;
    var DATATYPE_TIME = 2;
    var DATATYPE_STRING = 3;
    var DATATYPE_BITFIELD = 4;
    var DATATYPE_OPAQUE = 5;
    var DATATYPE_COMPOUND = 6;
    var DATATYPE_REFERENCE = 7;
    var DATATYPE_ENUMERATED = 8;
    var DATATYPE_VARIABLE_LENGTH = 9;
    var DATATYPE_ARRAY = 10;
    function zero$1(buf) {
      let len = buf.length;
      while (--len >= 0) {
        buf[len] = 0;
      }
    }
    var MIN_MATCH$1 = 3;
    var MAX_MATCH$1 = 258;
    var LENGTH_CODES$1 = 29;
    var LITERALS$1 = 256;
    var L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
    var D_CODES$1 = 30;
    var DIST_CODE_LEN = 512;
    var static_ltree = new Array((L_CODES$1 + 2) * 2);
    zero$1(static_ltree);
    var static_dtree = new Array(D_CODES$1 * 2);
    zero$1(static_dtree);
    var _dist_code = new Array(DIST_CODE_LEN);
    zero$1(_dist_code);
    var _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
    zero$1(_length_code);
    var base_length = new Array(LENGTH_CODES$1);
    zero$1(base_length);
    var base_dist = new Array(D_CODES$1);
    zero$1(base_dist);
    var adler32 = (adler, buf, len, pos) => {
      let s1 = adler & 65535 | 0, s2 = adler >>> 16 & 65535 | 0, n = 0;
      while (len !== 0) {
        n = len > 2e3 ? 2e3 : len;
        len -= n;
        do {
          s1 = s1 + buf[pos++] | 0;
          s2 = s2 + s1 | 0;
        } while (--n);
        s1 %= 65521;
        s2 %= 65521;
      }
      return s1 | s2 << 16 | 0;
    };
    var adler32_1 = adler32;
    var makeTable = () => {
      let c, table = [];
      for (var n = 0; n < 256; n++) {
        c = n;
        for (var k = 0; k < 8; k++) {
          c = c & 1 ? 3988292384 ^ c >>> 1 : c >>> 1;
        }
        table[n] = c;
      }
      return table;
    };
    var crcTable = new Uint32Array(makeTable());
    var crc32 = (crc, buf, len, pos) => {
      const t = crcTable;
      const end = pos + len;
      crc ^= -1;
      for (let i = pos; i < end; i++) {
        crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 255];
      }
      return crc ^ -1;
    };
    var crc32_1 = crc32;
    var messages = {
      2: "need dictionary",
      1: "stream end",
      0: "",
      "-1": "file error",
      "-2": "stream error",
      "-3": "data error",
      "-4": "insufficient memory",
      "-5": "buffer error",
      "-6": "incompatible version"
    };
    var constants$2 = {
      Z_NO_FLUSH: 0,
      Z_PARTIAL_FLUSH: 1,
      Z_SYNC_FLUSH: 2,
      Z_FULL_FLUSH: 3,
      Z_FINISH: 4,
      Z_BLOCK: 5,
      Z_TREES: 6,
      Z_OK: 0,
      Z_STREAM_END: 1,
      Z_NEED_DICT: 2,
      Z_ERRNO: -1,
      Z_STREAM_ERROR: -2,
      Z_DATA_ERROR: -3,
      Z_MEM_ERROR: -4,
      Z_BUF_ERROR: -5,
      Z_NO_COMPRESSION: 0,
      Z_BEST_SPEED: 1,
      Z_BEST_COMPRESSION: 9,
      Z_DEFAULT_COMPRESSION: -1,
      Z_FILTERED: 1,
      Z_HUFFMAN_ONLY: 2,
      Z_RLE: 3,
      Z_FIXED: 4,
      Z_DEFAULT_STRATEGY: 0,
      Z_BINARY: 0,
      Z_TEXT: 1,
      Z_UNKNOWN: 2,
      Z_DEFLATED: 8
    };
    var _has = (obj, key) => {
      return Object.prototype.hasOwnProperty.call(obj, key);
    };
    var assign = function(obj) {
      const sources = Array.prototype.slice.call(arguments, 1);
      while (sources.length) {
        const source = sources.shift();
        if (!source) {
          continue;
        }
        if (typeof source !== "object") {
          throw new TypeError(source + "must be non-object");
        }
        for (const p in source) {
          if (_has(source, p)) {
            obj[p] = source[p];
          }
        }
      }
      return obj;
    };
    var flattenChunks = (chunks) => {
      let len = 0;
      for (let i = 0, l = chunks.length; i < l; i++) {
        len += chunks[i].length;
      }
      const result = new Uint8Array(len);
      for (let i = 0, pos = 0, l = chunks.length; i < l; i++) {
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
      }
      return result;
    };
    var common = {
      assign,
      flattenChunks
    };
    var STR_APPLY_UIA_OK = true;
    try {
      String.fromCharCode.apply(null, new Uint8Array(1));
    } catch (__) {
      STR_APPLY_UIA_OK = false;
    }
    var _utf8len = new Uint8Array(256);
    for (let q = 0; q < 256; q++) {
      _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
    }
    _utf8len[254] = _utf8len[254] = 1;
    var string2buf = (str) => {
      if (typeof TextEncoder === "function" && TextEncoder.prototype.encode) {
        return new TextEncoder().encode(str);
      }
      let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
      for (m_pos = 0; m_pos < str_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 64512) === 55296 && m_pos + 1 < str_len) {
          c2 = str.charCodeAt(m_pos + 1);
          if ((c2 & 64512) === 56320) {
            c = 65536 + (c - 55296 << 10) + (c2 - 56320);
            m_pos++;
          }
        }
        buf_len += c < 128 ? 1 : c < 2048 ? 2 : c < 65536 ? 3 : 4;
      }
      buf = new Uint8Array(buf_len);
      for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 64512) === 55296 && m_pos + 1 < str_len) {
          c2 = str.charCodeAt(m_pos + 1);
          if ((c2 & 64512) === 56320) {
            c = 65536 + (c - 55296 << 10) + (c2 - 56320);
            m_pos++;
          }
        }
        if (c < 128) {
          buf[i++] = c;
        } else if (c < 2048) {
          buf[i++] = 192 | c >>> 6;
          buf[i++] = 128 | c & 63;
        } else if (c < 65536) {
          buf[i++] = 224 | c >>> 12;
          buf[i++] = 128 | c >>> 6 & 63;
          buf[i++] = 128 | c & 63;
        } else {
          buf[i++] = 240 | c >>> 18;
          buf[i++] = 128 | c >>> 12 & 63;
          buf[i++] = 128 | c >>> 6 & 63;
          buf[i++] = 128 | c & 63;
        }
      }
      return buf;
    };
    var buf2binstring = (buf, len) => {
      if (len < 65534) {
        if (buf.subarray && STR_APPLY_UIA_OK) {
          return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
        }
      }
      let result = "";
      for (let i = 0; i < len; i++) {
        result += String.fromCharCode(buf[i]);
      }
      return result;
    };
    var buf2string = (buf, max) => {
      const len = max || buf.length;
      if (typeof TextDecoder === "function" && TextDecoder.prototype.decode) {
        return new TextDecoder().decode(buf.subarray(0, max));
      }
      let i, out;
      const utf16buf = new Array(len * 2);
      for (out = 0, i = 0; i < len; ) {
        let c = buf[i++];
        if (c < 128) {
          utf16buf[out++] = c;
          continue;
        }
        let c_len = _utf8len[c];
        if (c_len > 4) {
          utf16buf[out++] = 65533;
          i += c_len - 1;
          continue;
        }
        c &= c_len === 2 ? 31 : c_len === 3 ? 15 : 7;
        while (c_len > 1 && i < len) {
          c = c << 6 | buf[i++] & 63;
          c_len--;
        }
        if (c_len > 1) {
          utf16buf[out++] = 65533;
          continue;
        }
        if (c < 65536) {
          utf16buf[out++] = c;
        } else {
          c -= 65536;
          utf16buf[out++] = 55296 | c >> 10 & 1023;
          utf16buf[out++] = 56320 | c & 1023;
        }
      }
      return buf2binstring(utf16buf, out);
    };
    var utf8border = (buf, max) => {
      max = max || buf.length;
      if (max > buf.length) {
        max = buf.length;
      }
      let pos = max - 1;
      while (pos >= 0 && (buf[pos] & 192) === 128) {
        pos--;
      }
      if (pos < 0) {
        return max;
      }
      if (pos === 0) {
        return max;
      }
      return pos + _utf8len[buf[pos]] > max ? pos : max;
    };
    var strings = {
      string2buf,
      buf2string,
      utf8border
    };
    function ZStream() {
      this.input = null;
      this.next_in = 0;
      this.avail_in = 0;
      this.total_in = 0;
      this.output = null;
      this.next_out = 0;
      this.avail_out = 0;
      this.total_out = 0;
      this.msg = "";
      this.state = null;
      this.data_type = 2;
      this.adler = 0;
    }
    var zstream = ZStream;
    var BAD$1 = 30;
    var TYPE$1 = 12;
    var inffast = function inflate_fast(strm, start) {
      let _in;
      let last;
      let _out;
      let beg;
      let end;
      let dmax;
      let wsize;
      let whave;
      let wnext;
      let s_window;
      let hold;
      let bits;
      let lcode;
      let dcode;
      let lmask;
      let dmask;
      let here;
      let op;
      let len;
      let dist;
      let from;
      let from_source;
      let input, output;
      const state = strm.state;
      _in = strm.next_in;
      input = strm.input;
      last = _in + (strm.avail_in - 5);
      _out = strm.next_out;
      output = strm.output;
      beg = _out - (start - strm.avail_out);
      end = _out + (strm.avail_out - 257);
      dmax = state.dmax;
      wsize = state.wsize;
      whave = state.whave;
      wnext = state.wnext;
      s_window = state.window;
      hold = state.hold;
      bits = state.bits;
      lcode = state.lencode;
      dcode = state.distcode;
      lmask = (1 << state.lenbits) - 1;
      dmask = (1 << state.distbits) - 1;
      top:
        do {
          if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
          }
          here = lcode[hold & lmask];
          dolen:
            for (; ; ) {
              op = here >>> 24;
              hold >>>= op;
              bits -= op;
              op = here >>> 16 & 255;
              if (op === 0) {
                output[_out++] = here & 65535;
              } else if (op & 16) {
                len = here & 65535;
                op &= 15;
                if (op) {
                  if (bits < op) {
                    hold += input[_in++] << bits;
                    bits += 8;
                  }
                  len += hold & (1 << op) - 1;
                  hold >>>= op;
                  bits -= op;
                }
                if (bits < 15) {
                  hold += input[_in++] << bits;
                  bits += 8;
                  hold += input[_in++] << bits;
                  bits += 8;
                }
                here = dcode[hold & dmask];
                dodist:
                  for (; ; ) {
                    op = here >>> 24;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 255;
                    if (op & 16) {
                      dist = here & 65535;
                      op &= 15;
                      if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                        if (bits < op) {
                          hold += input[_in++] << bits;
                          bits += 8;
                        }
                      }
                      dist += hold & (1 << op) - 1;
                      if (dist > dmax) {
                        strm.msg = "invalid distance too far back";
                        state.mode = BAD$1;
                        break top;
                      }
                      hold >>>= op;
                      bits -= op;
                      op = _out - beg;
                      if (dist > op) {
                        op = dist - op;
                        if (op > whave) {
                          if (state.sane) {
                            strm.msg = "invalid distance too far back";
                            state.mode = BAD$1;
                            break top;
                          }
                        }
                        from = 0;
                        from_source = s_window;
                        if (wnext === 0) {
                          from += wsize - op;
                          if (op < len) {
                            len -= op;
                            do {
                              output[_out++] = s_window[from++];
                            } while (--op);
                            from = _out - dist;
                            from_source = output;
                          }
                        } else if (wnext < op) {
                          from += wsize + wnext - op;
                          op -= wnext;
                          if (op < len) {
                            len -= op;
                            do {
                              output[_out++] = s_window[from++];
                            } while (--op);
                            from = 0;
                            if (wnext < len) {
                              op = wnext;
                              len -= op;
                              do {
                                output[_out++] = s_window[from++];
                              } while (--op);
                              from = _out - dist;
                              from_source = output;
                            }
                          }
                        } else {
                          from += wnext - op;
                          if (op < len) {
                            len -= op;
                            do {
                              output[_out++] = s_window[from++];
                            } while (--op);
                            from = _out - dist;
                            from_source = output;
                          }
                        }
                        while (len > 2) {
                          output[_out++] = from_source[from++];
                          output[_out++] = from_source[from++];
                          output[_out++] = from_source[from++];
                          len -= 3;
                        }
                        if (len) {
                          output[_out++] = from_source[from++];
                          if (len > 1) {
                            output[_out++] = from_source[from++];
                          }
                        }
                      } else {
                        from = _out - dist;
                        do {
                          output[_out++] = output[from++];
                          output[_out++] = output[from++];
                          output[_out++] = output[from++];
                          len -= 3;
                        } while (len > 2);
                        if (len) {
                          output[_out++] = output[from++];
                          if (len > 1) {
                            output[_out++] = output[from++];
                          }
                        }
                      }
                    } else if ((op & 64) === 0) {
                      here = dcode[(here & 65535) + (hold & (1 << op) - 1)];
                      continue dodist;
                    } else {
                      strm.msg = "invalid distance code";
                      state.mode = BAD$1;
                      break top;
                    }
                    break;
                  }
              } else if ((op & 64) === 0) {
                here = lcode[(here & 65535) + (hold & (1 << op) - 1)];
                continue dolen;
              } else if (op & 32) {
                state.mode = TYPE$1;
                break top;
              } else {
                strm.msg = "invalid literal/length code";
                state.mode = BAD$1;
                break top;
              }
              break;
            }
        } while (_in < last && _out < end);
      len = bits >> 3;
      _in -= len;
      bits -= len << 3;
      hold &= (1 << bits) - 1;
      strm.next_in = _in;
      strm.next_out = _out;
      strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
      strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
      state.hold = hold;
      state.bits = bits;
      return;
    };
    var MAXBITS = 15;
    var ENOUGH_LENS$1 = 852;
    var ENOUGH_DISTS$1 = 592;
    var CODES$1 = 0;
    var LENS$1 = 1;
    var DISTS$1 = 2;
    var lbase = new Uint16Array([
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      13,
      15,
      17,
      19,
      23,
      27,
      31,
      35,
      43,
      51,
      59,
      67,
      83,
      99,
      115,
      131,
      163,
      195,
      227,
      258,
      0,
      0
    ]);
    var lext = new Uint8Array([
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      17,
      17,
      17,
      17,
      18,
      18,
      18,
      18,
      19,
      19,
      19,
      19,
      20,
      20,
      20,
      20,
      21,
      21,
      21,
      21,
      16,
      72,
      78
    ]);
    var dbase = new Uint16Array([
      1,
      2,
      3,
      4,
      5,
      7,
      9,
      13,
      17,
      25,
      33,
      49,
      65,
      97,
      129,
      193,
      257,
      385,
      513,
      769,
      1025,
      1537,
      2049,
      3073,
      4097,
      6145,
      8193,
      12289,
      16385,
      24577,
      0,
      0
    ]);
    var dext = new Uint8Array([
      16,
      16,
      16,
      16,
      17,
      17,
      18,
      18,
      19,
      19,
      20,
      20,
      21,
      21,
      22,
      22,
      23,
      23,
      24,
      24,
      25,
      25,
      26,
      26,
      27,
      27,
      28,
      28,
      29,
      29,
      64,
      64
    ]);
    var inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts) => {
      const bits = opts.bits;
      let len = 0;
      let sym = 0;
      let min = 0, max = 0;
      let root = 0;
      let curr = 0;
      let drop = 0;
      let left = 0;
      let used = 0;
      let huff = 0;
      let incr;
      let fill;
      let low;
      let mask;
      let next;
      let base = null;
      let base_index = 0;
      let end;
      const count = new Uint16Array(MAXBITS + 1);
      const offs = new Uint16Array(MAXBITS + 1);
      let extra = null;
      let extra_index = 0;
      let here_bits, here_op, here_val;
      for (len = 0; len <= MAXBITS; len++) {
        count[len] = 0;
      }
      for (sym = 0; sym < codes; sym++) {
        count[lens[lens_index + sym]]++;
      }
      root = bits;
      for (max = MAXBITS; max >= 1; max--) {
        if (count[max] !== 0) {
          break;
        }
      }
      if (root > max) {
        root = max;
      }
      if (max === 0) {
        table[table_index++] = 1 << 24 | 64 << 16 | 0;
        table[table_index++] = 1 << 24 | 64 << 16 | 0;
        opts.bits = 1;
        return 0;
      }
      for (min = 1; min < max; min++) {
        if (count[min] !== 0) {
          break;
        }
      }
      if (root < min) {
        root = min;
      }
      left = 1;
      for (len = 1; len <= MAXBITS; len++) {
        left <<= 1;
        left -= count[len];
        if (left < 0) {
          return -1;
        }
      }
      if (left > 0 && (type === CODES$1 || max !== 1)) {
        return -1;
      }
      offs[1] = 0;
      for (len = 1; len < MAXBITS; len++) {
        offs[len + 1] = offs[len] + count[len];
      }
      for (sym = 0; sym < codes; sym++) {
        if (lens[lens_index + sym] !== 0) {
          work[offs[lens[lens_index + sym]]++] = sym;
        }
      }
      if (type === CODES$1) {
        base = extra = work;
        end = 19;
      } else if (type === LENS$1) {
        base = lbase;
        base_index -= 257;
        extra = lext;
        extra_index -= 257;
        end = 256;
      } else {
        base = dbase;
        extra = dext;
        end = -1;
      }
      huff = 0;
      sym = 0;
      len = min;
      next = table_index;
      curr = root;
      drop = 0;
      low = -1;
      used = 1 << root;
      mask = used - 1;
      if (type === LENS$1 && used > ENOUGH_LENS$1 || type === DISTS$1 && used > ENOUGH_DISTS$1) {
        return 1;
      }
      for (; ; ) {
        here_bits = len - drop;
        if (work[sym] < end) {
          here_op = 0;
          here_val = work[sym];
        } else if (work[sym] > end) {
          here_op = extra[extra_index + work[sym]];
          here_val = base[base_index + work[sym]];
        } else {
          here_op = 32 + 64;
          here_val = 0;
        }
        incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill;
        do {
          fill -= incr;
          table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        } while (fill !== 0);
        incr = 1 << len - 1;
        while (huff & incr) {
          incr >>= 1;
        }
        if (incr !== 0) {
          huff &= incr - 1;
          huff += incr;
        } else {
          huff = 0;
        }
        sym++;
        if (--count[len] === 0) {
          if (len === max) {
            break;
          }
          len = lens[lens_index + work[sym]];
        }
        if (len > root && (huff & mask) !== low) {
          if (drop === 0) {
            drop = root;
          }
          next += min;
          curr = len - drop;
          left = 1 << curr;
          while (curr + drop < max) {
            left -= count[curr + drop];
            if (left <= 0) {
              break;
            }
            curr++;
            left <<= 1;
          }
          used += 1 << curr;
          if (type === LENS$1 && used > ENOUGH_LENS$1 || type === DISTS$1 && used > ENOUGH_DISTS$1) {
            return 1;
          }
          low = huff & mask;
          table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
      }
      if (huff !== 0) {
        table[next + huff] = len - drop << 24 | 64 << 16 | 0;
      }
      opts.bits = root;
      return 0;
    };
    var inftrees = inflate_table;
    var CODES = 0;
    var LENS = 1;
    var DISTS = 2;
    var {
      Z_FINISH: Z_FINISH$1,
      Z_BLOCK,
      Z_TREES,
      Z_OK: Z_OK$1,
      Z_STREAM_END: Z_STREAM_END$1,
      Z_NEED_DICT: Z_NEED_DICT$1,
      Z_STREAM_ERROR: Z_STREAM_ERROR$1,
      Z_DATA_ERROR: Z_DATA_ERROR$1,
      Z_MEM_ERROR: Z_MEM_ERROR$1,
      Z_BUF_ERROR,
      Z_DEFLATED
    } = constants$2;
    var HEAD = 1;
    var FLAGS = 2;
    var TIME = 3;
    var OS = 4;
    var EXLEN = 5;
    var EXTRA = 6;
    var NAME = 7;
    var COMMENT = 8;
    var HCRC = 9;
    var DICTID = 10;
    var DICT = 11;
    var TYPE = 12;
    var TYPEDO = 13;
    var STORED = 14;
    var COPY_ = 15;
    var COPY = 16;
    var TABLE = 17;
    var LENLENS = 18;
    var CODELENS = 19;
    var LEN_ = 20;
    var LEN = 21;
    var LENEXT = 22;
    var DIST = 23;
    var DISTEXT = 24;
    var MATCH = 25;
    var LIT = 26;
    var CHECK = 27;
    var LENGTH = 28;
    var DONE = 29;
    var BAD = 30;
    var MEM = 31;
    var SYNC = 32;
    var ENOUGH_LENS = 852;
    var ENOUGH_DISTS = 592;
    var MAX_WBITS = 15;
    var DEF_WBITS = MAX_WBITS;
    var zswap32 = (q) => {
      return (q >>> 24 & 255) + (q >>> 8 & 65280) + ((q & 65280) << 8) + ((q & 255) << 24);
    };
    function InflateState() {
      this.mode = 0;
      this.last = false;
      this.wrap = 0;
      this.havedict = false;
      this.flags = 0;
      this.dmax = 0;
      this.check = 0;
      this.total = 0;
      this.head = null;
      this.wbits = 0;
      this.wsize = 0;
      this.whave = 0;
      this.wnext = 0;
      this.window = null;
      this.hold = 0;
      this.bits = 0;
      this.length = 0;
      this.offset = 0;
      this.extra = 0;
      this.lencode = null;
      this.distcode = null;
      this.lenbits = 0;
      this.distbits = 0;
      this.ncode = 0;
      this.nlen = 0;
      this.ndist = 0;
      this.have = 0;
      this.next = null;
      this.lens = new Uint16Array(320);
      this.work = new Uint16Array(288);
      this.lendyn = null;
      this.distdyn = null;
      this.sane = 0;
      this.back = 0;
      this.was = 0;
    }
    var inflateResetKeep = (strm) => {
      if (!strm || !strm.state) {
        return Z_STREAM_ERROR$1;
      }
      const state = strm.state;
      strm.total_in = strm.total_out = state.total = 0;
      strm.msg = "";
      if (state.wrap) {
        strm.adler = state.wrap & 1;
      }
      state.mode = HEAD;
      state.last = 0;
      state.havedict = 0;
      state.dmax = 32768;
      state.head = null;
      state.hold = 0;
      state.bits = 0;
      state.lencode = state.lendyn = new Int32Array(ENOUGH_LENS);
      state.distcode = state.distdyn = new Int32Array(ENOUGH_DISTS);
      state.sane = 1;
      state.back = -1;
      return Z_OK$1;
    };
    var inflateReset = (strm) => {
      if (!strm || !strm.state) {
        return Z_STREAM_ERROR$1;
      }
      const state = strm.state;
      state.wsize = 0;
      state.whave = 0;
      state.wnext = 0;
      return inflateResetKeep(strm);
    };
    var inflateReset2 = (strm, windowBits) => {
      let wrap;
      if (!strm || !strm.state) {
        return Z_STREAM_ERROR$1;
      }
      const state = strm.state;
      if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
      } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) {
          windowBits &= 15;
        }
      }
      if (windowBits && (windowBits < 8 || windowBits > 15)) {
        return Z_STREAM_ERROR$1;
      }
      if (state.window !== null && state.wbits !== windowBits) {
        state.window = null;
      }
      state.wrap = wrap;
      state.wbits = windowBits;
      return inflateReset(strm);
    };
    var inflateInit2 = (strm, windowBits) => {
      if (!strm) {
        return Z_STREAM_ERROR$1;
      }
      const state = new InflateState();
      strm.state = state;
      state.window = null;
      const ret = inflateReset2(strm, windowBits);
      if (ret !== Z_OK$1) {
        strm.state = null;
      }
      return ret;
    };
    var inflateInit = (strm) => {
      return inflateInit2(strm, DEF_WBITS);
    };
    var virgin = true;
    var lenfix;
    var distfix;
    var fixedtables = (state) => {
      if (virgin) {
        lenfix = new Int32Array(512);
        distfix = new Int32Array(32);
        let sym = 0;
        while (sym < 144) {
          state.lens[sym++] = 8;
        }
        while (sym < 256) {
          state.lens[sym++] = 9;
        }
        while (sym < 280) {
          state.lens[sym++] = 7;
        }
        while (sym < 288) {
          state.lens[sym++] = 8;
        }
        inftrees(LENS, state.lens, 0, 288, lenfix, 0, state.work, { bits: 9 });
        sym = 0;
        while (sym < 32) {
          state.lens[sym++] = 5;
        }
        inftrees(DISTS, state.lens, 0, 32, distfix, 0, state.work, { bits: 5 });
        virgin = false;
      }
      state.lencode = lenfix;
      state.lenbits = 9;
      state.distcode = distfix;
      state.distbits = 5;
    };
    var updatewindow = (strm, src, end, copy) => {
      let dist;
      const state = strm.state;
      if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
      }
      if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
      } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) {
          dist = copy;
        }
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
          state.window.set(src.subarray(end - copy, end), 0);
          state.wnext = copy;
          state.whave = state.wsize;
        } else {
          state.wnext += dist;
          if (state.wnext === state.wsize) {
            state.wnext = 0;
          }
          if (state.whave < state.wsize) {
            state.whave += dist;
          }
        }
      }
      return 0;
    };
    var inflate$2 = (strm, flush) => {
      let state;
      let input, output;
      let next;
      let put;
      let have, left;
      let hold;
      let bits;
      let _in, _out;
      let copy;
      let from;
      let from_source;
      let here = 0;
      let here_bits, here_op, here_val;
      let last_bits, last_op, last_val;
      let len;
      let ret;
      const hbuf = new Uint8Array(4);
      let opts;
      let n;
      const order = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
      if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) {
        return Z_STREAM_ERROR$1;
      }
      state = strm.state;
      if (state.mode === TYPE) {
        state.mode = TYPEDO;
      }
      put = strm.next_out;
      output = strm.output;
      left = strm.avail_out;
      next = strm.next_in;
      input = strm.input;
      have = strm.avail_in;
      hold = state.hold;
      bits = state.bits;
      _in = have;
      _out = left;
      ret = Z_OK$1;
      inf_leave:
        for (; ; ) {
          switch (state.mode) {
            case HEAD:
              if (state.wrap === 0) {
                state.mode = TYPEDO;
                break;
              }
              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              if (state.wrap & 2 && hold === 35615) {
                state.check = 0;
                hbuf[0] = hold & 255;
                hbuf[1] = hold >>> 8 & 255;
                state.check = crc32_1(state.check, hbuf, 2, 0);
                hold = 0;
                bits = 0;
                state.mode = FLAGS;
                break;
              }
              state.flags = 0;
              if (state.head) {
                state.head.done = false;
              }
              if (!(state.wrap & 1) || (((hold & 255) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = BAD;
                break;
              }
              if ((hold & 15) !== Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = BAD;
                break;
              }
              hold >>>= 4;
              bits -= 4;
              len = (hold & 15) + 8;
              if (state.wbits === 0) {
                state.wbits = len;
              } else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = BAD;
                break;
              }
              state.dmax = 1 << state.wbits;
              strm.adler = state.check = 1;
              state.mode = hold & 512 ? DICTID : TYPE;
              hold = 0;
              bits = 0;
              break;
            case FLAGS:
              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              state.flags = hold;
              if ((state.flags & 255) !== Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = BAD;
                break;
              }
              if (state.flags & 57344) {
                strm.msg = "unknown header flags set";
                state.mode = BAD;
                break;
              }
              if (state.head) {
                state.head.text = hold >> 8 & 1;
              }
              if (state.flags & 512) {
                hbuf[0] = hold & 255;
                hbuf[1] = hold >>> 8 & 255;
                state.check = crc32_1(state.check, hbuf, 2, 0);
              }
              hold = 0;
              bits = 0;
              state.mode = TIME;
            case TIME:
              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              if (state.head) {
                state.head.time = hold;
              }
              if (state.flags & 512) {
                hbuf[0] = hold & 255;
                hbuf[1] = hold >>> 8 & 255;
                hbuf[2] = hold >>> 16 & 255;
                hbuf[3] = hold >>> 24 & 255;
                state.check = crc32_1(state.check, hbuf, 4, 0);
              }
              hold = 0;
              bits = 0;
              state.mode = OS;
            case OS:
              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              if (state.head) {
                state.head.xflags = hold & 255;
                state.head.os = hold >> 8;
              }
              if (state.flags & 512) {
                hbuf[0] = hold & 255;
                hbuf[1] = hold >>> 8 & 255;
                state.check = crc32_1(state.check, hbuf, 2, 0);
              }
              hold = 0;
              bits = 0;
              state.mode = EXLEN;
            case EXLEN:
              if (state.flags & 1024) {
                while (bits < 16) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                state.length = hold;
                if (state.head) {
                  state.head.extra_len = hold;
                }
                if (state.flags & 512) {
                  hbuf[0] = hold & 255;
                  hbuf[1] = hold >>> 8 & 255;
                  state.check = crc32_1(state.check, hbuf, 2, 0);
                }
                hold = 0;
                bits = 0;
              } else if (state.head) {
                state.head.extra = null;
              }
              state.mode = EXTRA;
            case EXTRA:
              if (state.flags & 1024) {
                copy = state.length;
                if (copy > have) {
                  copy = have;
                }
                if (copy) {
                  if (state.head) {
                    len = state.head.extra_len - state.length;
                    if (!state.head.extra) {
                      state.head.extra = new Uint8Array(state.head.extra_len);
                    }
                    state.head.extra.set(input.subarray(next, next + copy), len);
                  }
                  if (state.flags & 512) {
                    state.check = crc32_1(state.check, input, copy, next);
                  }
                  have -= copy;
                  next += copy;
                  state.length -= copy;
                }
                if (state.length) {
                  break inf_leave;
                }
              }
              state.length = 0;
              state.mode = NAME;
            case NAME:
              if (state.flags & 2048) {
                if (have === 0) {
                  break inf_leave;
                }
                copy = 0;
                do {
                  len = input[next + copy++];
                  if (state.head && len && state.length < 65536) {
                    state.head.name += String.fromCharCode(len);
                  }
                } while (len && copy < have);
                if (state.flags & 512) {
                  state.check = crc32_1(state.check, input, copy, next);
                }
                have -= copy;
                next += copy;
                if (len) {
                  break inf_leave;
                }
              } else if (state.head) {
                state.head.name = null;
              }
              state.length = 0;
              state.mode = COMMENT;
            case COMMENT:
              if (state.flags & 4096) {
                if (have === 0) {
                  break inf_leave;
                }
                copy = 0;
                do {
                  len = input[next + copy++];
                  if (state.head && len && state.length < 65536) {
                    state.head.comment += String.fromCharCode(len);
                  }
                } while (len && copy < have);
                if (state.flags & 512) {
                  state.check = crc32_1(state.check, input, copy, next);
                }
                have -= copy;
                next += copy;
                if (len) {
                  break inf_leave;
                }
              } else if (state.head) {
                state.head.comment = null;
              }
              state.mode = HCRC;
            case HCRC:
              if (state.flags & 512) {
                while (bits < 16) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                if (hold !== (state.check & 65535)) {
                  strm.msg = "header crc mismatch";
                  state.mode = BAD;
                  break;
                }
                hold = 0;
                bits = 0;
              }
              if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
              }
              strm.adler = state.check = 0;
              state.mode = TYPE;
              break;
            case DICTID:
              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              strm.adler = state.check = zswap32(hold);
              hold = 0;
              bits = 0;
              state.mode = DICT;
            case DICT:
              if (state.havedict === 0) {
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                return Z_NEED_DICT$1;
              }
              strm.adler = state.check = 1;
              state.mode = TYPE;
            case TYPE:
              if (flush === Z_BLOCK || flush === Z_TREES) {
                break inf_leave;
              }
            case TYPEDO:
              if (state.last) {
                hold >>>= bits & 7;
                bits -= bits & 7;
                state.mode = CHECK;
                break;
              }
              while (bits < 3) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              state.last = hold & 1;
              hold >>>= 1;
              bits -= 1;
              switch (hold & 3) {
                case 0:
                  state.mode = STORED;
                  break;
                case 1:
                  fixedtables(state);
                  state.mode = LEN_;
                  if (flush === Z_TREES) {
                    hold >>>= 2;
                    bits -= 2;
                    break inf_leave;
                  }
                  break;
                case 2:
                  state.mode = TABLE;
                  break;
                case 3:
                  strm.msg = "invalid block type";
                  state.mode = BAD;
              }
              hold >>>= 2;
              bits -= 2;
              break;
            case STORED:
              hold >>>= bits & 7;
              bits -= bits & 7;
              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              if ((hold & 65535) !== (hold >>> 16 ^ 65535)) {
                strm.msg = "invalid stored block lengths";
                state.mode = BAD;
                break;
              }
              state.length = hold & 65535;
              hold = 0;
              bits = 0;
              state.mode = COPY_;
              if (flush === Z_TREES) {
                break inf_leave;
              }
            case COPY_:
              state.mode = COPY;
            case COPY:
              copy = state.length;
              if (copy) {
                if (copy > have) {
                  copy = have;
                }
                if (copy > left) {
                  copy = left;
                }
                if (copy === 0) {
                  break inf_leave;
                }
                output.set(input.subarray(next, next + copy), put);
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
              }
              state.mode = TYPE;
              break;
            case TABLE:
              while (bits < 14) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              state.nlen = (hold & 31) + 257;
              hold >>>= 5;
              bits -= 5;
              state.ndist = (hold & 31) + 1;
              hold >>>= 5;
              bits -= 5;
              state.ncode = (hold & 15) + 4;
              hold >>>= 4;
              bits -= 4;
              if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = BAD;
                break;
              }
              state.have = 0;
              state.mode = LENLENS;
            case LENLENS:
              while (state.have < state.ncode) {
                while (bits < 3) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                state.lens[order[state.have++]] = hold & 7;
                hold >>>= 3;
                bits -= 3;
              }
              while (state.have < 19) {
                state.lens[order[state.have++]] = 0;
              }
              state.lencode = state.lendyn;
              state.lenbits = 7;
              opts = { bits: state.lenbits };
              ret = inftrees(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
              state.lenbits = opts.bits;
              if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = BAD;
                break;
              }
              state.have = 0;
              state.mode = CODELENS;
            case CODELENS:
              while (state.have < state.nlen + state.ndist) {
                for (; ; ) {
                  here = state.lencode[hold & (1 << state.lenbits) - 1];
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 255;
                  here_val = here & 65535;
                  if (here_bits <= bits) {
                    break;
                  }
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                if (here_val < 16) {
                  hold >>>= here_bits;
                  bits -= here_bits;
                  state.lens[state.have++] = here_val;
                } else {
                  if (here_val === 16) {
                    n = here_bits + 2;
                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    hold >>>= here_bits;
                    bits -= here_bits;
                    if (state.have === 0) {
                      strm.msg = "invalid bit length repeat";
                      state.mode = BAD;
                      break;
                    }
                    len = state.lens[state.have - 1];
                    copy = 3 + (hold & 3);
                    hold >>>= 2;
                    bits -= 2;
                  } else if (here_val === 17) {
                    n = here_bits + 3;
                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    hold >>>= here_bits;
                    bits -= here_bits;
                    len = 0;
                    copy = 3 + (hold & 7);
                    hold >>>= 3;
                    bits -= 3;
                  } else {
                    n = here_bits + 7;
                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    hold >>>= here_bits;
                    bits -= here_bits;
                    len = 0;
                    copy = 11 + (hold & 127);
                    hold >>>= 7;
                    bits -= 7;
                  }
                  if (state.have + copy > state.nlen + state.ndist) {
                    strm.msg = "invalid bit length repeat";
                    state.mode = BAD;
                    break;
                  }
                  while (copy--) {
                    state.lens[state.have++] = len;
                  }
                }
              }
              if (state.mode === BAD) {
                break;
              }
              if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = BAD;
                break;
              }
              state.lenbits = 9;
              opts = { bits: state.lenbits };
              ret = inftrees(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
              state.lenbits = opts.bits;
              if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = BAD;
                break;
              }
              state.distbits = 6;
              state.distcode = state.distdyn;
              opts = { bits: state.distbits };
              ret = inftrees(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
              state.distbits = opts.bits;
              if (ret) {
                strm.msg = "invalid distances set";
                state.mode = BAD;
                break;
              }
              state.mode = LEN_;
              if (flush === Z_TREES) {
                break inf_leave;
              }
            case LEN_:
              state.mode = LEN;
            case LEN:
              if (have >= 6 && left >= 258) {
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                inffast(strm, _out);
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                if (state.mode === TYPE) {
                  state.back = -1;
                }
                break;
              }
              state.back = 0;
              for (; ; ) {
                here = state.lencode[hold & (1 << state.lenbits) - 1];
                here_bits = here >>> 24;
                here_op = here >>> 16 & 255;
                here_val = here & 65535;
                if (here_bits <= bits) {
                  break;
                }
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              if (here_op && (here_op & 240) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for (; ; ) {
                  here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 255;
                  here_val = here & 65535;
                  if (last_bits + here_bits <= bits) {
                    break;
                  }
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                hold >>>= last_bits;
                bits -= last_bits;
                state.back += last_bits;
              }
              hold >>>= here_bits;
              bits -= here_bits;
              state.back += here_bits;
              state.length = here_val;
              if (here_op === 0) {
                state.mode = LIT;
                break;
              }
              if (here_op & 32) {
                state.back = -1;
                state.mode = TYPE;
                break;
              }
              if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = BAD;
                break;
              }
              state.extra = here_op & 15;
              state.mode = LENEXT;
            case LENEXT:
              if (state.extra) {
                n = state.extra;
                while (bits < n) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                state.length += hold & (1 << state.extra) - 1;
                hold >>>= state.extra;
                bits -= state.extra;
                state.back += state.extra;
              }
              state.was = state.length;
              state.mode = DIST;
            case DIST:
              for (; ; ) {
                here = state.distcode[hold & (1 << state.distbits) - 1];
                here_bits = here >>> 24;
                here_op = here >>> 16 & 255;
                here_val = here & 65535;
                if (here_bits <= bits) {
                  break;
                }
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              if ((here_op & 240) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for (; ; ) {
                  here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 255;
                  here_val = here & 65535;
                  if (last_bits + here_bits <= bits) {
                    break;
                  }
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                hold >>>= last_bits;
                bits -= last_bits;
                state.back += last_bits;
              }
              hold >>>= here_bits;
              bits -= here_bits;
              state.back += here_bits;
              if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = BAD;
                break;
              }
              state.offset = here_val;
              state.extra = here_op & 15;
              state.mode = DISTEXT;
            case DISTEXT:
              if (state.extra) {
                n = state.extra;
                while (bits < n) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                state.offset += hold & (1 << state.extra) - 1;
                hold >>>= state.extra;
                bits -= state.extra;
                state.back += state.extra;
              }
              if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = BAD;
                break;
              }
              state.mode = MATCH;
            case MATCH:
              if (left === 0) {
                break inf_leave;
              }
              copy = _out - left;
              if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                  if (state.sane) {
                    strm.msg = "invalid distance too far back";
                    state.mode = BAD;
                    break;
                  }
                }
                if (copy > state.wnext) {
                  copy -= state.wnext;
                  from = state.wsize - copy;
                } else {
                  from = state.wnext - copy;
                }
                if (copy > state.length) {
                  copy = state.length;
                }
                from_source = state.window;
              } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
              }
              if (copy > left) {
                copy = left;
              }
              left -= copy;
              state.length -= copy;
              do {
                output[put++] = from_source[from++];
              } while (--copy);
              if (state.length === 0) {
                state.mode = LEN;
              }
              break;
            case LIT:
              if (left === 0) {
                break inf_leave;
              }
              output[put++] = state.length;
              left--;
              state.mode = LEN;
              break;
            case CHECK:
              if (state.wrap) {
                while (bits < 32) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold |= input[next++] << bits;
                  bits += 8;
                }
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) {
                  strm.adler = state.check = state.flags ? crc32_1(state.check, output, _out, put - _out) : adler32_1(state.check, output, _out, put - _out);
                }
                _out = left;
                if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                  strm.msg = "incorrect data check";
                  state.mode = BAD;
                  break;
                }
                hold = 0;
                bits = 0;
              }
              state.mode = LENGTH;
            case LENGTH:
              if (state.wrap && state.flags) {
                while (bits < 32) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                if (hold !== (state.total & 4294967295)) {
                  strm.msg = "incorrect length check";
                  state.mode = BAD;
                  break;
                }
                hold = 0;
                bits = 0;
              }
              state.mode = DONE;
            case DONE:
              ret = Z_STREAM_END$1;
              break inf_leave;
            case BAD:
              ret = Z_DATA_ERROR$1;
              break inf_leave;
            case MEM:
              return Z_MEM_ERROR$1;
            case SYNC:
            default:
              return Z_STREAM_ERROR$1;
          }
        }
      strm.next_out = put;
      strm.avail_out = left;
      strm.next_in = next;
      strm.avail_in = have;
      state.hold = hold;
      state.bits = bits;
      if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH$1)) {
        if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out))
          ;
      }
      _in -= strm.avail_in;
      _out -= strm.avail_out;
      strm.total_in += _in;
      strm.total_out += _out;
      state.total += _out;
      if (state.wrap && _out) {
        strm.adler = state.check = state.flags ? crc32_1(state.check, output, _out, strm.next_out - _out) : adler32_1(state.check, output, _out, strm.next_out - _out);
      }
      strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
      if ((_in === 0 && _out === 0 || flush === Z_FINISH$1) && ret === Z_OK$1) {
        ret = Z_BUF_ERROR;
      }
      return ret;
    };
    var inflateEnd = (strm) => {
      if (!strm || !strm.state) {
        return Z_STREAM_ERROR$1;
      }
      let state = strm.state;
      if (state.window) {
        state.window = null;
      }
      strm.state = null;
      return Z_OK$1;
    };
    var inflateGetHeader = (strm, head) => {
      if (!strm || !strm.state) {
        return Z_STREAM_ERROR$1;
      }
      const state = strm.state;
      if ((state.wrap & 2) === 0) {
        return Z_STREAM_ERROR$1;
      }
      state.head = head;
      head.done = false;
      return Z_OK$1;
    };
    var inflateSetDictionary = (strm, dictionary) => {
      const dictLength = dictionary.length;
      let state;
      let dictid;
      let ret;
      if (!strm || !strm.state) {
        return Z_STREAM_ERROR$1;
      }
      state = strm.state;
      if (state.wrap !== 0 && state.mode !== DICT) {
        return Z_STREAM_ERROR$1;
      }
      if (state.mode === DICT) {
        dictid = 1;
        dictid = adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) {
          return Z_DATA_ERROR$1;
        }
      }
      ret = updatewindow(strm, dictionary, dictLength, dictLength);
      if (ret) {
        state.mode = MEM;
        return Z_MEM_ERROR$1;
      }
      state.havedict = 1;
      return Z_OK$1;
    };
    var inflateReset_1 = inflateReset;
    var inflateReset2_1 = inflateReset2;
    var inflateResetKeep_1 = inflateResetKeep;
    var inflateInit_1 = inflateInit;
    var inflateInit2_1 = inflateInit2;
    var inflate_2$1 = inflate$2;
    var inflateEnd_1 = inflateEnd;
    var inflateGetHeader_1 = inflateGetHeader;
    var inflateSetDictionary_1 = inflateSetDictionary;
    var inflateInfo = "pako inflate (from Nodeca project)";
    var inflate_1$2 = {
      inflateReset: inflateReset_1,
      inflateReset2: inflateReset2_1,
      inflateResetKeep: inflateResetKeep_1,
      inflateInit: inflateInit_1,
      inflateInit2: inflateInit2_1,
      inflate: inflate_2$1,
      inflateEnd: inflateEnd_1,
      inflateGetHeader: inflateGetHeader_1,
      inflateSetDictionary: inflateSetDictionary_1,
      inflateInfo
    };
    function GZheader() {
      this.text = 0;
      this.time = 0;
      this.xflags = 0;
      this.os = 0;
      this.extra = null;
      this.extra_len = 0;
      this.name = "";
      this.comment = "";
      this.hcrc = 0;
      this.done = false;
    }
    var gzheader = GZheader;
    var toString = Object.prototype.toString;
    var {
      Z_NO_FLUSH,
      Z_FINISH,
      Z_OK,
      Z_STREAM_END,
      Z_NEED_DICT,
      Z_STREAM_ERROR,
      Z_DATA_ERROR,
      Z_MEM_ERROR
    } = constants$2;
    function Inflate$1(options) {
      this.options = common.assign({
        chunkSize: 1024 * 64,
        windowBits: 15,
        to: ""
      }, options || {});
      const opt = this.options;
      if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) {
          opt.windowBits = -15;
        }
      }
      if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) {
        opt.windowBits += 32;
      }
      if (opt.windowBits > 15 && opt.windowBits < 48) {
        if ((opt.windowBits & 15) === 0) {
          opt.windowBits |= 15;
        }
      }
      this.err = 0;
      this.msg = "";
      this.ended = false;
      this.chunks = [];
      this.strm = new zstream();
      this.strm.avail_out = 0;
      let status = inflate_1$2.inflateInit2(this.strm, opt.windowBits);
      if (status !== Z_OK) {
        throw new Error(messages[status]);
      }
      this.header = new gzheader();
      inflate_1$2.inflateGetHeader(this.strm, this.header);
      if (opt.dictionary) {
        if (typeof opt.dictionary === "string") {
          opt.dictionary = strings.string2buf(opt.dictionary);
        } else if (toString.call(opt.dictionary) === "[object ArrayBuffer]") {
          opt.dictionary = new Uint8Array(opt.dictionary);
        }
        if (opt.raw) {
          status = inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
          if (status !== Z_OK) {
            throw new Error(messages[status]);
          }
        }
      }
    }
    Inflate$1.prototype.push = function(data, flush_mode) {
      const strm = this.strm;
      const chunkSize = this.options.chunkSize;
      const dictionary = this.options.dictionary;
      let status, _flush_mode, last_avail_out;
      if (this.ended)
        return false;
      if (flush_mode === ~~flush_mode)
        _flush_mode = flush_mode;
      else
        _flush_mode = flush_mode === true ? Z_FINISH : Z_NO_FLUSH;
      if (toString.call(data) === "[object ArrayBuffer]") {
        strm.input = new Uint8Array(data);
      } else {
        strm.input = data;
      }
      strm.next_in = 0;
      strm.avail_in = strm.input.length;
      for (; ; ) {
        if (strm.avail_out === 0) {
          strm.output = new Uint8Array(chunkSize);
          strm.next_out = 0;
          strm.avail_out = chunkSize;
        }
        status = inflate_1$2.inflate(strm, _flush_mode);
        if (status === Z_NEED_DICT && dictionary) {
          status = inflate_1$2.inflateSetDictionary(strm, dictionary);
          if (status === Z_OK) {
            status = inflate_1$2.inflate(strm, _flush_mode);
          } else if (status === Z_DATA_ERROR) {
            status = Z_NEED_DICT;
          }
        }
        while (strm.avail_in > 0 && status === Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0) {
          inflate_1$2.inflateReset(strm);
          status = inflate_1$2.inflate(strm, _flush_mode);
        }
        switch (status) {
          case Z_STREAM_ERROR:
          case Z_DATA_ERROR:
          case Z_NEED_DICT:
          case Z_MEM_ERROR:
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
          if (strm.avail_out === 0 || status === Z_STREAM_END) {
            if (this.options.to === "string") {
              let next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
              let tail = strm.next_out - next_out_utf8;
              let utf8str = strings.buf2string(strm.output, next_out_utf8);
              strm.next_out = tail;
              strm.avail_out = chunkSize - tail;
              if (tail)
                strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
              this.onData(utf8str);
            } else {
              this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
          }
        }
        if (status === Z_OK && last_avail_out === 0)
          continue;
        if (status === Z_STREAM_END) {
          status = inflate_1$2.inflateEnd(this.strm);
          this.onEnd(status);
          this.ended = true;
          return true;
        }
        if (strm.avail_in === 0)
          break;
      }
      return true;
    };
    Inflate$1.prototype.onData = function(chunk) {
      this.chunks.push(chunk);
    };
    Inflate$1.prototype.onEnd = function(status) {
      if (status === Z_OK) {
        if (this.options.to === "string") {
          this.result = this.chunks.join("");
        } else {
          this.result = common.flattenChunks(this.chunks);
        }
      }
      this.chunks = [];
      this.err = status;
      this.msg = this.strm.msg;
    };
    function inflate$1(input, options) {
      const inflator = new Inflate$1(options);
      inflator.push(input);
      if (inflator.err)
        throw inflator.msg || messages[inflator.err];
      return inflator.result;
    }
    function inflateRaw$1(input, options) {
      options = options || {};
      options.raw = true;
      return inflate$1(input, options);
    }
    var Inflate_1$1 = Inflate$1;
    var inflate_2 = inflate$1;
    var inflateRaw_1$1 = inflateRaw$1;
    var ungzip$1 = inflate$1;
    var constants = constants$2;
    var inflate_1$1 = {
      Inflate: Inflate_1$1,
      inflate: inflate_2,
      inflateRaw: inflateRaw_1$1,
      ungzip: ungzip$1,
      constants
    };
    var { Inflate, inflate, inflateRaw, ungzip } = inflate_1$1;
    var inflate_1 = inflate;
    var ungzip_1 = ungzip;

    // esm/filters.js
    var zlib_decompress = function(buf, itemsize) {
      let input_array = new Uint8Array(buf);
      return inflate_1(input_array).buffer;
    };
    var unshuffle = function(buf, itemsize) {
      let buffer_size = buf.byteLength;
      let unshuffled_view = new Uint8Array(buffer_size);
      let step = Math.floor(buffer_size / itemsize);
      let shuffled_view = new DataView(buf);
      for (var j = 0; j < itemsize; j++) {
        for (var i = 0; i < step; i++) {
          unshuffled_view[j + i * itemsize] = shuffled_view.getUint8(j * step + i);
        }
      }
      return unshuffled_view.buffer;
    };
    var fletch32 = function(buf, itemsize) {
      _verify_fletcher32(buf);
      return buf.slice(0, -4);
    };
    function _verify_fletcher32(chunk_buffer) {
      var odd_chunk_buffer = chunk_buffer.byteLength % 2 != 0;
      var data_length = chunk_buffer.byteLength - 4;
      var view = new DataView(chunk_buffer);
      var sum1 = 0;
      var sum2 = 0;
      for (var offset = 0; offset < data_length - 1; offset += 2) {
        let datum = view.getUint16(offset, true);
        sum1 = (sum1 + datum) % 65535;
        sum2 = (sum2 + sum1) % 65535;
      }
      if (odd_chunk_buffer) {
        let datum = view.getUint8(data_length - 1);
        sum1 = (sum1 + datum) % 65535;
        sum2 = (sum2 + sum1) % 65535;
      }
      var [ref_sum1, ref_sum2] = struct.unpack_from(">HH", chunk_buffer, data_length);
      ref_sum1 = ref_sum1 % 65535;
      ref_sum2 = ref_sum2 % 65535;
      if (sum1 != ref_sum1 || sum2 != ref_sum2) {
        throw 'ValueError("fletcher32 checksum invalid")';
      }
      return true;
    }
    var GZIP_DEFLATE_FILTER = 1;
    var SHUFFLE_FILTER = 2;
    var FLETCH32_FILTER = 3;
    var Filters = /* @__PURE__ */ new Map([
      [GZIP_DEFLATE_FILTER, zlib_decompress],
      [SHUFFLE_FILTER, unshuffle],
      [FLETCH32_FILTER, fletch32]
    ]);

    // esm/btree.js
    var AbstractBTree = class {
      constructor(fh, offset) {
        this.fh = fh;
        this.offset = offset;
        this.depth = null;
      }
      async init() {
        this.all_nodes = /* @__PURE__ */ new Map();
        await this._read_root_node();
        await this._read_children();
      }
      async _read_children() {
        let node_level = this.depth;
        while (node_level > 0) {
          for (var parent_node of this.all_nodes.get(node_level)) {
            for (var child_addr of parent_node.get("addresses")) {
              this._add_node(await this._read_node(child_addr, node_level - 1));
            }
          }
          node_level--;
        }
      }
      async _read_root_node() {
        let root_node = await this._read_node(this.offset, null);
        this._add_node(root_node);
        this.depth = root_node.get("node_level");
      }
      _add_node(node) {
        let node_level = node.get("node_level");
        if (this.all_nodes.has(node_level)) {
          this.all_nodes.get(node_level).push(node);
        } else {
          this.all_nodes.set(node_level, [node]);
        }
      }
      async _read_node(offset, node_level) {
        let node = await this._read_node_header(offset, node_level);
        node.set("keys", []);
        node.set("addresses", []);
        return node;
      }
      async _read_node_header(offset) {
        throw "NotImplementedError: must define _read_node_header in implementation class";
      }
    };
    var BTreeV1 = class extends AbstractBTree {
      constructor() {
        super(...arguments);
        __publicField(this, "B_LINK_NODE", /* @__PURE__ */ new Map([
          ["signature", "4s"],
          ["node_type", "B"],
          ["node_level", "B"],
          ["entries_used", "H"],
          ["left_sibling", "Q"],
          ["right_sibling", "Q"]
        ]));
      }
      async _read_node_header(offset, node_level) {
        let node = await _unpack_struct_from_async(this.B_LINK_NODE, this.fh, offset);
        if (node_level != null) {
          if (node.get("node_level") != node_level) {
            throw "node level does not match";
          }
        }
        return node;
      }
    };
    var BTreeV1Groups = class extends BTreeV1 {
      constructor(fh, offset) {
        super(fh, offset);
        __publicField(this, "NODE_TYPE", 0);
        this.ready = this.init();
      }
      async _read_node(offset, node_level) {
        let node = await this._read_node_header(offset, node_level);
        offset += _structure_size(this.B_LINK_NODE);
        let keys = [];
        let addresses = [];
        let entries_used = node.get("entries_used");
        for (var i = 0; i < entries_used; i++) {
          let key = (await struct.unpack_from_async("<Q", this.fh, offset))[0];
          offset += 8;
          let address = (await struct.unpack_from_async("<Q", this.fh, offset))[0];
          offset += 8;
          keys.push(key);
          addresses.push(address);
        }
        keys.push((await struct.unpack_from_async("<Q", this.fh, offset))[0]);
        node.set("keys", keys);
        node.set("addresses", addresses);
        return node;
      }
      symbol_table_addresses() {
        var all_address = [];
        var root_nodes = this.all_nodes.get(0);
        for (var node of root_nodes) {
          all_address = all_address.concat(node.get("addresses"));
        }
        return all_address;
      }
    };
    var BTreeV1RawDataChunks = class extends BTreeV1 {
      constructor(fh, offset, dims) {
        super(fh, offset);
        __publicField(this, "NODE_TYPE", 1);
        this.dims = dims;
        this.ready = this.init();
      }
      async _read_node(offset, node_level) {
        let node = await this._read_node_header(offset, node_level);
        offset += _structure_size(this.B_LINK_NODE);
        var keys = [];
        var addresses = [];
        let entries_used = node.get("entries_used");
        for (var i = 0; i < entries_used; i++) {
          let [chunk_size, filter_mask] = await struct.unpack_from_async("<II", this.fh, offset);
          offset += 8;
          let fmt = "<" + this.dims.toFixed() + "Q";
          let fmt_size = struct.calcsize(fmt);
          let chunk_offset = await struct.unpack_from_async(fmt, this.fh, offset);
          offset += fmt_size;
          let chunk_address = (await struct.unpack_from_async("<Q", this.fh, offset))[0];
          offset += 8;
          keys.push(/* @__PURE__ */ new Map([
            ["chunk_size", chunk_size],
            ["filter_mask", filter_mask],
            ["chunk_offset", chunk_offset]
          ]));
          addresses.push(chunk_address);
        }
        node.set("keys", keys);
        node.set("addresses", addresses);
        return node;
      }
      async construct_data_from_chunks(chunk_shape, data_shape, dtype, filter_pipeline) {
        var item_getter, item_big_endian, item_size;
        if (dtype instanceof Array) {
          let dtype_class = dtype[0];
          if (dtype_class == "REFERENCE") {
            let size = dtype[1];
            if (size != 8) {
              throw "NotImplementedError('Unsupported Reference type')";
            }
            dtype = "<u8";
            item_getter = "getUint64";
            item_big_endian = false;
            item_size = 8;
          } else if (dtype_class == "VLEN_STRING" || dtype_class == "VLEN_SEQUENCE") {
            item_getter = "getVLENStruct";
            item_big_endian = false;
            item_size = 16;
          } else {
            throw "NotImplementedError('datatype not implemented')";
          }
        } else {
          [item_getter, item_big_endian, item_size] = dtype_getter(dtype);
        }
        var data_size = data_shape.reduce(function(a, b) {
          return a * b;
        }, 1);
        var chunk_size = chunk_shape.reduce(function(a, b) {
          return a * b;
        }, 1);
        let dims = data_shape.length;
        var current_stride = 1;
        chunk_shape.slice().map(function(d2) {
          let s = current_stride;
          current_stride *= d2;
          return s;
        });
        var current_stride = 1;
        var data_strides = data_shape.slice().reverse().map(function(d2) {
          let s = current_stride;
          current_stride *= d2;
          return s;
        }).reverse();
        var data = new Array(data_size);
        let chunk_buffer_size = chunk_size * item_size;
        for (var node of this.all_nodes.get(0)) {
          let node_keys = node.get("keys");
          let node_addresses = node.get("addresses");
          let nkeys = node_keys.length;
          for (var ik = 0; ik < nkeys; ik++) {
            let node_key = node_keys[ik];
            let addr = node_addresses[ik];
            var chunk_buffer;
            if (filter_pipeline == null) {
              chunk_buffer = await this.fh.slice(addr, addr + chunk_buffer_size);
            } else {
              chunk_buffer = await this.fh.slice(addr, addr + node_key.get("chunk_size"));
              let filter_mask = node_key.get("filter_mask");
              chunk_buffer = this._filter_chunk(chunk_buffer, filter_mask, filter_pipeline, item_size);
            }
            var chunk_offset = node_key.get("chunk_offset").slice();
            var apos = chunk_offset.slice();
            var cpos = apos.map(function() {
              return 0;
            });
            var cview = new DataView64(chunk_buffer);
            for (var ci = 0; ci < chunk_size; ci++) {
              for (var d = dims - 1; d >= 0; d--) {
                if (cpos[d] >= chunk_shape[d]) {
                  cpos[d] = 0;
                  apos[d] = chunk_offset[d];
                  if (d > 0) {
                    cpos[d - 1] += 1;
                    apos[d - 1] += 1;
                  }
                } else {
                  break;
                }
              }
              let inbounds = apos.slice(0, -1).every(function(p, d2) {
                return p < data_shape[d2];
              });
              if (inbounds) {
                let cb_offset = ci * item_size;
                let datum = cview[item_getter](cb_offset, !item_big_endian, item_size);
                let ai = apos.slice(0, -1).reduce(function(prev, curr, index) {
                  return curr * data_strides[index] + prev;
                }, 0);
                data[ai] = datum;
              }
              cpos[dims - 1] += 1;
              apos[dims - 1] += 1;
            }
          }
        }
        return data;
      }
      _filter_chunk(chunk_buffer, filter_mask, filter_pipeline, itemsize) {
        let num_filters = filter_pipeline.length;
        let buf = chunk_buffer.slice();
        for (var filter_index = num_filters - 1; filter_index >= 0; filter_index--) {
          if (filter_mask & 1 << filter_index) {
            continue;
          }
          let pipeline_entry = filter_pipeline[filter_index];
          let filter_id = pipeline_entry.get("filter_id");
          let client_data = pipeline_entry.get("client_data");
          if (Filters.has(filter_id)) {
            buf = Filters.get(filter_id)(buf, itemsize, client_data);
          } else {
            throw 'NotImplementedError("Filter with id:' + filter_id.toFixed() + ' not supported")';
          }
        }
        return buf;
      }
    };
    var BTreeV2 = class extends AbstractBTree {
      constructor(fh, offset) {
        super(fh, offset);
        __publicField(this, "B_TREE_HEADER", /* @__PURE__ */ new Map([
          ["signature", "4s"],
          ["version", "B"],
          ["node_type", "B"],
          ["node_size", "I"],
          ["record_size", "H"],
          ["depth", "H"],
          ["split_percent", "B"],
          ["merge_percent", "B"],
          ["root_address", "Q"],
          ["root_nrecords", "H"],
          ["total_nrecords", "Q"]
        ]));
        __publicField(this, "B_LINK_NODE", /* @__PURE__ */ new Map([
          ["signature", "4s"],
          ["version", "B"],
          ["node_type", "B"]
        ]));
        this.ready = this.init();
      }
      async _read_root_node() {
        let h = await this._read_tree_header(this.offset);
        this.address_formats = this._calculate_address_formats(h);
        this.header = h;
        this.depth = h.get("depth");
        let address = [h.get("root_address"), h.get("root_nrecords"), h.get("total_nrecords")];
        let root_node = await this._read_node(address, this.depth);
        this._add_node(root_node);
      }
      async _read_tree_header(offset) {
        let header = await _unpack_struct_from_async(this.B_TREE_HEADER, this.fh, this.offset);
        return header;
      }
      _calculate_address_formats(header) {
        let node_size = header.get("node_size");
        let record_size = header.get("record_size");
        let nrecords_max = 0;
        let ntotalrecords_max = 0;
        let address_formats = /* @__PURE__ */ new Map();
        let max_depth = header.get("depth");
        for (var node_level = 0; node_level <= max_depth; node_level++) {
          let offset_fmt = "";
          let num1_fmt = "";
          let num2_fmt = "";
          let offset_size, num1_size, num2_size;
          if (node_level == 0) {
            offset_size = 0;
            num1_size = 0;
            num2_size = 0;
          } else if (node_level == 1) {
            offset_size = 8;
            offset_fmt = "<Q";
            num1_size = this._required_bytes(nrecords_max);
            num1_fmt = this._int_format(num1_size);
            num2_size = 0;
          } else {
            offset_size = 8;
            offset_fmt = "<Q";
            num1_size = this._required_bytes(nrecords_max);
            num1_fmt = this._int_format(num1_size);
            num2_size = this._required_bytes(ntotalrecords_max);
            num2_fmt = this._int_format(num2_size);
          }
          address_formats.set(node_level, [
            offset_size,
            num1_size,
            num2_size,
            offset_fmt,
            num1_fmt,
            num2_fmt
          ]);
          if (node_level < max_depth) {
            let addr_size = offset_size + num1_size + num2_size;
            nrecords_max = this._nrecords_max(node_size, record_size, addr_size);
            if (ntotalrecords_max > 0) {
              ntotalrecords_max *= nrecords_max;
            } else {
              ntotalrecords_max = nrecords_max;
            }
          }
        }
        return address_formats;
      }
      _nrecords_max(node_size, record_size, addr_size) {
        return Math.floor((node_size - 10 - addr_size) / (record_size + addr_size));
      }
      _required_bytes(integer) {
        return Math.ceil(bitSize(integer) / 8);
      }
      _int_format(bytelength) {
        return ["<B", "<H", "<I", "<Q"][bytelength - 1];
      }
      async _read_node(address, node_level) {
        let [offset, nrecords, ntotalrecords] = address;
        let node = this._read_node_header(offset, node_level);
        offset += _structure_size(this.B_LINK_NODE);
        let record_size = this.header.get("record_size");
        let keys = [];
        for (let i = 0; i < nrecords; i++) {
          let record = await this._parse_record(this.fh, offset, record_size);
          offset += record_size;
          keys.push(record);
        }
        let addresses = [];
        let fmts = this.address_formats.get(node_level);
        if (node_level != 0) {
          let [offset_size, num1_size, num2_size, offset_fmt, num1_fmt, num2_fmt] = fmts;
          for (let j = 0; j <= nrecords; j++) {
            let address_offset = (await struct.unpack_from_async(offset_fmt, this.fh, offset))[0];
            offset += offset_size;
            let num1 = (await struct.unpack_from_async(num1_fmt, this.fh, offset))[0];
            offset += num1_size;
            let num2 = num1;
            if (num2_size > 0) {
              num2 = (await struct.unpack_from_async(num2_fmt, this.fh, offset))[0];
              offset += num2_size;
            }
            addresses.push([address_offset, num1, num2]);
          }
        }
        node.set("keys", keys);
        node.set("addresses", addresses);
        return node;
      }
      async _read_node_header(offset, node_level) {
        let node = await _unpack_struct_from_async(this.B_LINK_NODE, this.fh, offset);
        node.set("node_level", node_level);
        return node;
      }
      *iter_records() {
        for (let nodelist of this.all_nodes.values()) {
          for (let node of nodelist) {
            for (let key of node.get("keys")) {
              yield key;
            }
          }
        }
      }
      _parse_record(record) {
        throw "NotImplementedError";
      }
    };
    var BTreeV2GroupNames = class extends BTreeV2 {
      constructor() {
        super(...arguments);
        __publicField(this, "NODE_TYPE", 5);
      }
      async _parse_record(buf, offset, size) {
        let namehash = (await struct.unpack_from_async("<I", buf, offset))[0];
        offset += 4;
        const heapid = await buf.slice(offset, offset + 7);
        return /* @__PURE__ */ new Map([["namehash", namehash], ["heapid", heapid]]);
      }
    };
    var BTreeV2GroupOrders = class extends BTreeV2 {
      constructor() {
        super(...arguments);
        __publicField(this, "NODE_TYPE", 6);
      }
      async _parse_record(buf, offset, size) {
        let creationorder = (await struct.unpack_from_async("<Q", buf, offset))[0];
        offset += 8;
        const heapid = await buf.slice(offset, offset + 7);
        return /* @__PURE__ */ new Map([["creationorder", creationorder], ["heapid", heapid]]);
      }
    };

    // esm/misc-low-level.js
    var SuperBlock = class {
      constructor(fh, offset) {
        this.ready = this.init(fh, offset);
      }
      async init(fh, offset) {
        let version_hint = await struct.unpack_from_async("<B", fh, offset + 8);
        var contents;
        if (version_hint == 0) {
          contents = await _unpack_struct_from_async(SUPERBLOCK_V0, fh, offset);
          this._end_of_sblock = offset + SUPERBLOCK_V0_SIZE;
        } else if (version_hint == 2 || version_hint == 3) {
          contents = await _unpack_struct_from_async(SUPERBLOCK_V2_V3, fh, offset);
          this._end_of_sblock = offset + SUPERBLOCK_V2_V3_SIZE;
        } else {
          throw "unsupported superblock version: " + version_hint.toFixed();
        }
        if (contents.get("format_signature") != FORMAT_SIGNATURE) {
          throw "Incorrect file signature: " + contents.get("format_signature");
        }
        if (contents.get("offset_size") != 8 || contents.get("length_size") != 8) {
          throw "File uses non-64-bit addressing";
        }
        this.version = contents.get("superblock_version");
        this._contents = contents;
        this._root_symbol_table = null;
        this._fh = fh;
      }
      async get_offset_to_dataobjects() {
        if (this.version == 0) {
          var sym_table = new SymbolTable(this._fh, this._end_of_sblock, true);
          await sym_table.ready;
          this._root_symbol_table = sym_table;
          return sym_table.group_offset;
        } else if (this.version == 2 || this.version == 3) {
          return this._contents.get("root_group_address");
        } else {
          throw "Not implemented version = " + this.version.toFixed();
        }
      }
    };
    var Heap = class {
      constructor(fh, offset) {
        this.ready = this.init(fh, offset);
      }
      async init(fh, offset) {
        let local_heap = await _unpack_struct_from_async(LOCAL_HEAP, fh, offset);
        assert(local_heap.get("signature") == "HEAP");
        assert(local_heap.get("version") == 0);
        let data_offset = local_heap.get("address_of_data_segment");
        let heap_data = await fh.slice(data_offset, data_offset + local_heap.get("data_segment_size"));
        local_heap.set("heap_data", heap_data);
        this._contents = local_heap;
        this.data = heap_data;
      }
      get_object_name(offset) {
        let end = new Uint8Array(this.data).indexOf(0, offset);
        let name_size = end - offset;
        let name = struct.unpack_from("<" + name_size.toFixed() + "s", this.data, offset)[0];
        return name;
      }
    };
    var SymbolTable = class {
      constructor(fh, offset, root = false) {
        this.ready = this.init(fh, offset, root);
      }
      async init(fh, offset, root) {
        var node;
        if (root) {
          node = /* @__PURE__ */ new Map([["symbols", 1]]);
        } else {
          node = await _unpack_struct_from_async(SYMBOL_TABLE_NODE, fh, offset);
          if (node.get("signature") != "SNOD") {
            throw "incorrect node type";
          }
          offset += SYMBOL_TABLE_NODE_SIZE;
        }
        var entries = [];
        var n_symbols = node.get("symbols");
        for (var i = 0; i < n_symbols; i++) {
          entries.push(await _unpack_struct_from_async(SYMBOL_TABLE_ENTRY, fh, offset));
          offset += SYMBOL_TABLE_ENTRY_SIZE;
        }
        if (root) {
          this.group_offset = entries[0].get("object_header_address");
        }
        this.entries = entries;
        this._contents = node;
        return this;
      }
      assign_name(heap) {
        this.entries.forEach(function(entry) {
          let offset = entry.get("link_name_offset");
          let link_name = heap.get_object_name(offset);
          entry.set("link_name", link_name);
        });
      }
      get_links(heap) {
        var links = {};
        this.entries.forEach(function(e) {
          let cache_type = e.get("cache_type");
          let link_name = e.get("link_name");
          if (cache_type == 0 || cache_type == 1) {
            links[link_name] = e.get("object_header_address");
          } else if (cache_type == 2) {
            let scratch = e.get("scratch");
            let buf = new ArrayBuffer(4);
            let bufView = new Uint8Array(buf);
            for (var i = 0; i < 4; i++) {
              bufView[i] = scratch.charCodeAt(i);
            }
            let offset = struct.unpack_from("<I", buf, 0)[0];
            links[link_name] = heap.get_object_name(offset);
          }
        });
        return links;
      }
    };
    var GlobalHeap = class {
      constructor(fh, offset) {
        this.ready = this.init(fh, offset);
      }
      async init(fh, offset) {
        let header = await _unpack_struct_from_async(GLOBAL_HEAP_HEADER, fh, offset);
        offset += GLOBAL_HEAP_HEADER_SIZE;
        let heap_data_size = header.get("collection_size") - GLOBAL_HEAP_HEADER_SIZE;
        let heap_data = await fh.slice(offset, offset + heap_data_size);
        this.heap_data = heap_data;
        this._header = header;
        this._objects = null;
      }
      get objects() {
        if (this._objects == null) {
          this._objects = /* @__PURE__ */ new Map();
          var offset = 0;
          while (offset <= this.heap_data.byteLength - GLOBAL_HEAP_OBJECT_SIZE) {
            let info = _unpack_struct_from(GLOBAL_HEAP_OBJECT, this.heap_data, offset);
            if (info.get("object_index") == 0) {
              break;
            }
            offset += GLOBAL_HEAP_OBJECT_SIZE;
            let obj_data = this.heap_data.slice(offset, offset + info.get("object_size"));
            this._objects.set(info.get("object_index"), obj_data);
            offset += _padded_size(info.get("object_size"));
          }
        }
        return this._objects;
      }
    };
    var FractalHeap = class {
      constructor(fh, offset) {
        this.fh = fh;
        this.ready = this.init(offset);
      }
      async init(offset) {
        let header = await _unpack_struct_from_async(FRACTAL_HEAP_HEADER, this.fh, offset);
        offset += _structure_size(FRACTAL_HEAP_HEADER);
        assert(header.get("signature") == "FRHP");
        assert(header.get("version") == 0);
        if (header.get("filter_info_size") > 0) {
          throw "Filter info size not supported on FractalHeap";
        }
        if (header.get("btree_address_huge_objects") == UNDEFINED_ADDRESS) {
          header.set("btree_address_huge_objects", null);
        } else {
          throw "Huge objects not implemented in FractalHeap";
        }
        if (header.get("root_block_address") == UNDEFINED_ADDRESS) {
          header.set("root_block_address", null);
        }
        let nbits = header.get("log2_maximum_heap_size");
        let block_offset_size = this._min_size_nbits(nbits);
        let h = /* @__PURE__ */ new Map([
          ["signature", "4s"],
          ["version", "B"],
          ["heap_header_adddress", "Q"],
          ["block_offset", `${block_offset_size}B`]
        ]);
        this.indirect_block_header = new Map(h);
        this.indirect_block_header_size = _structure_size(h);
        if ((header.get("flags") & 2) == 2) {
          h.set("checksum", "I");
        }
        this.direct_block_header = h;
        this.direct_block_header_size = _structure_size(h);
        let maximum_dblock_size = header.get("maximum_direct_block_size");
        this._managed_object_offset_size = this._min_size_nbits(nbits);
        let value = Math.min(maximum_dblock_size, header.get("max_managed_object_size"));
        this._managed_object_length_size = this._min_size_integer(value);
        let start_block_size = header.get("starting_block_size");
        let table_width = header.get("table_width");
        if (!(start_block_size > 0)) {
          throw "Starting block size == 0 not implemented";
        }
        let log2_maximum_dblock_size = Number(Math.floor(Math.log2(maximum_dblock_size)));
        assert(1n << BigInt(log2_maximum_dblock_size) == maximum_dblock_size);
        let log2_start_block_size = Number(Math.floor(Math.log2(start_block_size)));
        assert(1n << BigInt(log2_start_block_size) == start_block_size);
        this._max_direct_nrows = log2_maximum_dblock_size - log2_start_block_size + 2;
        let log2_table_width = Math.floor(Math.log2(table_width));
        assert(1 << log2_table_width == table_width);
        this._indirect_nrows_sub = log2_table_width + log2_start_block_size - 1;
        this.header = header;
        this.nobjects = header.get("managed_object_count") + header.get("huge_object_count") + header.get("tiny_object_count");
        let managed = [];
        let root_address = header.get("root_block_address");
        let nrows = 0;
        if (root_address != null) {
          nrows = header.get("indirect_current_rows_count");
        }
        if (nrows > 0) {
          for await (let data of this._iter_indirect_block(this.fh, root_address, nrows)) {
            managed.push(data);
          }
        } else {
          let data = await this._read_direct_block(this.fh, root_address, start_block_size);
          managed.push(data);
        }
        let data_size = managed.reduce((p, c) => p + c.byteLength, 0);
        let combined = new Uint8Array(data_size);
        let moffset = 0;
        managed.forEach((m) => {
          combined.set(new Uint8Array(m), moffset);
          moffset += m.byteLength;
        });
        this.managed = combined.buffer;
      }
      async _read_direct_block(fh, offset, block_size) {
        let data = await fh.slice(offset, offset + block_size);
        let header = _unpack_struct_from(this.direct_block_header, data);
        assert(header.get("signature") == "FHDB");
        return data;
      }
      get_data(heapid) {
        let firstbyte = struct.unpack_from("<B", heapid, 0)[0];
        let idtype = firstbyte >> 4 & 3;
        let version = firstbyte >> 6;
        let data_offset = 1;
        if (idtype == 0) {
          assert(version == 0);
          let nbytes = this._managed_object_offset_size;
          let offset = _unpack_integer(nbytes, heapid, data_offset);
          data_offset += nbytes;
          nbytes = this._managed_object_length_size;
          let size = _unpack_integer(nbytes, heapid, data_offset);
          return this.managed.slice(offset, offset + size);
        } else if (idtype == 1) {
          throw "tiny objectID not supported in FractalHeap";
        } else if (idtype == 2) {
          throw "huge objectID not supported in FractalHeap";
        } else {
          throw "unknown objectID type in FractalHeap";
        }
      }
      _min_size_integer(integer) {
        return this._min_size_nbits(bitSize(integer));
      }
      _min_size_nbits(nbits) {
        return Math.ceil(nbits / 8);
      }
      async *_iter_indirect_block(fh, offset, nrows) {
        let header = await _unpack_struct_from_async(this.indirect_block_header, fh, offset);
        offset += this.indirect_block_header_size;
        assert(header.get("signature") == "FHIB");
        let block_offset_bytes = header.get("block_offset");
        let block_offset = block_offset_bytes.reduce((p, c, i) => p + (c << i * 8), 0);
        header.set("block_offset", block_offset);
        let [ndirect, nindirect] = this._indirect_info(nrows);
        let direct_blocks = [];
        for (let i = 0; i < ndirect; i++) {
          let address = (await struct.unpack_from_async("<Q", fh, offset))[0];
          offset += 8;
          if (address == UNDEFINED_ADDRESS) {
            break;
          }
          let block_size = this._calc_block_size(i);
          direct_blocks.push([address, block_size]);
        }
        let indirect_blocks = [];
        for (let i = ndirect; i < ndirect + nindirect; i++) {
          let address = (await struct.unpack_from_async("<Q", fh, offset))[0];
          offset += 8;
          if (address == UNDEFINED_ADDRESS) {
            break;
          }
          let block_size = this._calc_block_size(i);
          let nrows2 = this._iblock_nrows_from_block_size(block_size);
          indirect_blocks.push([address, nrows2]);
        }
        for (let [address, block_size] of direct_blocks) {
          let obj = await this._read_direct_block(fh, address, block_size);
          yield obj;
        }
        for (let [address, nrows2] of indirect_blocks) {
          for await (let obj of this._iter_indirect_block(fh, address, nrows2)) {
            yield obj;
          }
        }
      }
      _calc_block_size(iblock) {
        let row = Math.floor(iblock / this.header.get("table_width"));
        return 2 ** Math.max(row - 1, 0) * this.header.get("starting_block_size");
      }
      _iblock_nrows_from_block_size(block_size) {
        let log2_block_size = Math.floor(Math.log2(block_size));
        assert(2 ** log2_block_size == block_size);
        return log2_block_size - this._indirect_nrows_sub;
      }
      _indirect_info(nrows) {
        let table_width = this.header.get("table_width");
        let nobjects = nrows * table_width;
        let ndirect_max = this._max_direct_nrows * table_width;
        let ndirect, nindirect;
        if (nrows <= ndirect_max) {
          ndirect = nobjects;
          nindirect = 0;
        } else {
          ndirect = ndirect_max;
          nindirect = nobjects - ndirect_max;
        }
        return [ndirect, nindirect];
      }
      _int_format(bytelength) {
        return ["B", "H", "I", "Q"][bytelength - 1];
      }
    };
    var FORMAT_SIGNATURE = struct.unpack_from("8s", new Uint8Array([137, 72, 68, 70, 13, 10, 26, 10]).buffer)[0];
    var UNDEFINED_ADDRESS = struct.unpack_from("<Q", new Uint8Array([255, 255, 255, 255, 255, 255, 255, 255]).buffer)[0];
    var SUPERBLOCK_V0 = /* @__PURE__ */ new Map([
      ["format_signature", "8s"],
      ["superblock_version", "B"],
      ["free_storage_version", "B"],
      ["root_group_version", "B"],
      ["reserved_0", "B"],
      ["shared_header_version", "B"],
      ["offset_size", "B"],
      ["length_size", "B"],
      ["reserved_1", "B"],
      ["group_leaf_node_k", "H"],
      ["group_internal_node_k", "H"],
      ["file_consistency_flags", "L"],
      ["base_address_lower", "Q"],
      ["free_space_address", "Q"],
      ["end_of_file_address", "Q"],
      ["driver_information_address", "Q"]
    ]);
    var SUPERBLOCK_V0_SIZE = _structure_size(SUPERBLOCK_V0);
    var SUPERBLOCK_V2_V3 = /* @__PURE__ */ new Map([
      ["format_signature", "8s"],
      ["superblock_version", "B"],
      ["offset_size", "B"],
      ["length_size", "B"],
      ["file_consistency_flags", "B"],
      ["base_address", "Q"],
      ["superblock_extension_address", "Q"],
      ["end_of_file_address", "Q"],
      ["root_group_address", "Q"],
      ["superblock_checksum", "I"]
    ]);
    var SUPERBLOCK_V2_V3_SIZE = _structure_size(SUPERBLOCK_V2_V3);
    var SYMBOL_TABLE_ENTRY = /* @__PURE__ */ new Map([
      ["link_name_offset", "Q"],
      ["object_header_address", "Q"],
      ["cache_type", "I"],
      ["reserved", "I"],
      ["scratch", "16s"]
    ]);
    var SYMBOL_TABLE_ENTRY_SIZE = _structure_size(SYMBOL_TABLE_ENTRY);
    var SYMBOL_TABLE_NODE = /* @__PURE__ */ new Map([
      ["signature", "4s"],
      ["version", "B"],
      ["reserved_0", "B"],
      ["symbols", "H"]
    ]);
    var SYMBOL_TABLE_NODE_SIZE = _structure_size(SYMBOL_TABLE_NODE);
    var LOCAL_HEAP = /* @__PURE__ */ new Map([
      ["signature", "4s"],
      ["version", "B"],
      ["reserved", "3s"],
      ["data_segment_size", "Q"],
      ["offset_to_free_list", "Q"],
      ["address_of_data_segment", "Q"]
    ]);
    var GLOBAL_HEAP_HEADER = /* @__PURE__ */ new Map([
      ["signature", "4s"],
      ["version", "B"],
      ["reserved", "3s"],
      ["collection_size", "Q"]
    ]);
    var GLOBAL_HEAP_HEADER_SIZE = _structure_size(GLOBAL_HEAP_HEADER);
    var GLOBAL_HEAP_OBJECT = /* @__PURE__ */ new Map([
      ["object_index", "H"],
      ["reference_count", "H"],
      ["reserved", "I"],
      ["object_size", "Q"]
    ]);
    var GLOBAL_HEAP_OBJECT_SIZE = _structure_size(GLOBAL_HEAP_OBJECT);
    var FRACTAL_HEAP_HEADER = /* @__PURE__ */ new Map([
      ["signature", "4s"],
      ["version", "B"],
      ["object_index_size", "H"],
      ["filter_info_size", "H"],
      ["flags", "B"],
      ["max_managed_object_size", "I"],
      ["next_huge_object_index", "Q"],
      ["btree_address_huge_objects", "Q"],
      ["managed_freespace_size", "Q"],
      ["freespace_manager_address", "Q"],
      ["managed_space_size", "Q"],
      ["managed_alloc_size", "Q"],
      ["next_directblock_iterator_address", "Q"],
      ["managed_object_count", "Q"],
      ["huge_objects_total_size", "Q"],
      ["huge_object_count", "Q"],
      ["tiny_objects_total_size", "Q"],
      ["tiny_object_count", "Q"],
      ["table_width", "H"],
      ["starting_block_size", "Q"],
      ["maximum_direct_block_size", "Q"],
      ["log2_maximum_heap_size", "H"],
      ["indirect_starting_rows_count", "H"],
      ["root_block_address", "Q"],
      ["indirect_current_rows_count", "H"]
    ]);

    // esm/dataobjects.js
    var DataObjects = class {
      constructor(fh, offset) {
        this.ready = this.init(fh, offset);
      }
      async init(fh, offset) {
        let version_hint = (await struct.unpack_from_async("<B", fh, offset))[0];
        if (version_hint == 1) {
          var [msgs, msg_data, header] = await this._parse_v1_objects(fh, offset);
        } else if (version_hint == "O".charCodeAt(0)) {
          var [msgs, msg_data, header] = await this._parse_v2_objects(fh, offset);
        } else {
          throw "InvalidHDF5File('unknown Data Object Header')";
        }
        this.fh = fh;
        this.msgs = msgs;
        this.msg_data = msg_data;
        this.offset = offset;
        this._global_heaps = {};
        this._header = header;
        this._filter_pipeline = null;
        this._chunk_params_set = false;
        this._chunks = null;
        this._chunk_dims = null;
        this._chunk_address = null;
      }
      get dtype() {
        let msg = this.find_msg_type(DATATYPE_MSG_TYPE)[0];
        let msg_offset = msg.get("offset_to_message");
        return new DatatypeMessage(this.fh, msg_offset).dtype;
      }
      get chunks() {
        return this._get_chunk_params().then(() => {
          return this._chunks;
        });
      }
      get shape() {
        let msg = this.find_msg_type(DATASPACE_MSG_TYPE)[0];
        let msg_offset = msg.get("offset_to_message");
        return determine_data_shape(this.fh, msg_offset);
      }
      async get_filter_pipeline() {
        if (this._filter_pipeline != null) {
          return this._filter_pipeline;
        }
        let filter_msgs = this.find_msg_type(DATA_STORAGE_FILTER_PIPELINE_MSG_TYPE);
        if (!filter_msgs.length) {
          this._filter_pipeline = null;
          return this._filter_pipeline;
        }
        var offset = filter_msgs[0].get("offset_to_message");
        let [version, nfilters] = await struct.unpack_from_async("<BB", this.fh, offset);
        offset += struct.calcsize("<BB");
        var filters = [];
        if (version == 1) {
          await struct.unpack_from_async("<HI", this.fh, offset);
          offset += struct.calcsize("<HI");
          for (var _ = 0; _ < nfilters; _++) {
            let filter_info = await _unpack_struct_from_async(FILTER_PIPELINE_DESCR_V1, this.fh, offset);
            offset += FILTER_PIPELINE_DESCR_V1_SIZE;
            let padded_name_length = _padded_size(filter_info.get("name_length"), 8);
            let fmt = "<" + padded_name_length.toFixed() + "s";
            let filter_name = (await struct.unpack_from_async(fmt, this.fh, offset))[0];
            filter_info.set("filter_name", filter_name);
            offset += padded_name_length;
            fmt = "<" + filter_info.get("client_data_values").toFixed() + "I";
            let client_data = await struct.unpack_from_async(fmt, this.fh, offset);
            filter_info.set("client_data", client_data);
            offset += 4 * filter_info.get("client_data_values");
            if (filter_info.get("client_data_values") % 2) {
              offset += 4;
            }
            filters.push(filter_info);
          }
        } else if (version == 2) {
          for (let nf = 0; nf < nfilters; nf++) {
            let filter_info = /* @__PURE__ */ new Map();
            let buf = this.fh;
            let filter_id = (await struct.unpack_from_async("<H", buf, offset))[0];
            offset += 2;
            filter_info.set("filter_id", filter_id);
            let name_length = 0;
            if (filter_id > 255) {
              name_length = (await struct.unpack_from_async("<H", buf, offset))[0];
              offset += 2;
            }
            let flags = (await struct.unpack_from_async("<H", buf, offset))[0];
            offset += 2;
            let optional = (flags & 1) > 0;
            filter_info.set("optional", optional);
            let num_client_values = (await struct.unpack_from_async("<H", buf, offset))[0];
            offset += 2;
            let name;
            if (name_length > 0) {
              name = (await struct.unpack_from_async(`${name_length}s`, buf, offset))[0];
              offset += name_length;
            }
            filter_info.set("name", name);
            let client_values = await struct.unpack_from_async(`<${num_client_values}i`, buf, offset);
            offset += 4 * num_client_values;
            filter_info.set("client_data_values", client_values);
            filters.push(filter_info);
          }
        } else {
          throw `version ${version} is not supported`;
        }
        this._filter_pipeline = filters;
        return this._filter_pipeline;
      }
      find_msg_type(msg_type) {
        return this.msgs.filter(function(m) {
          return m.get("type") == msg_type;
        });
      }
      async get_attributes() {
        let attrs = {};
        let attr_msgs = this.find_msg_type(ATTRIBUTE_MSG_TYPE);
        for (let msg of attr_msgs) {
          let offset = msg.get("offset_to_message");
          let [name, value] = await this.unpack_attribute(offset);
          attrs[name] = value;
        }
        return attrs;
      }
      async get_fillvalue() {
        let msg = this.find_msg_type(FILLVALUE_MSG_TYPE)[0];
        var offset = msg.get("offset_to_message");
        var is_defined;
        let version = (await struct.unpack_from_async("<B", this.fh, offset))[0];
        var info, size, fillvalue;
        if (version == 1 || version == 2) {
          info = await _unpack_struct_from_async(FILLVAL_MSG_V1V2, this.fh, offset);
          offset += FILLVAL_MSG_V1V2_SIZE;
          is_defined = info.get("fillvalue_defined");
        } else if (version == 3) {
          info = await _unpack_struct_from_async(FILLVAL_MSG_V3, this.fh, offset);
          offset += FILLVAL_MSG_V3_SIZE;
          is_defined = info.get("flags") & 32;
        } else {
          throw 'InvalidHDF5File("Unknown fillvalue msg version: "' + String(version);
        }
        if (is_defined) {
          size = (await struct.unpack_from_async("<I", this.fh, offset))[0];
          offset += 4;
        } else {
          size = 0;
        }
        if (size) {
          let [getter, big_endian, size2] = dtype_getter(await this.dtype);
          let payload_view = new DataView64(await this.fh.slice(offset, offset + size2));
          fillvalue = payload_view[getter](offset, !big_endian, size2);
        } else {
          fillvalue = 0;
        }
        return fillvalue;
      }
      async unpack_attribute(offset) {
        let version = (await struct.unpack_from_async("<B", this.fh, offset))[0];
        var attr_map, padding_multiple;
        if (version == 1) {
          attr_map = await _unpack_struct_from_async(ATTR_MSG_HEADER_V1, this.fh, offset);
          assert(attr_map.get("version") == 1);
          offset += ATTR_MSG_HEADER_V1_SIZE;
          padding_multiple = 8;
        } else if (version == 3) {
          attr_map = await _unpack_struct_from_async(ATTR_MSG_HEADER_V3, this.fh, offset);
          assert(attr_map.get("version") == 3);
          offset += ATTR_MSG_HEADER_V3_SIZE;
          padding_multiple = 1;
        } else {
          throw "unsupported attribute message version: " + version;
        }
        let name_size = attr_map.get("name_size");
        let name = (await struct.unpack_from_async("<" + name_size.toFixed() + "s", this.fh, offset))[0];
        name = name.replace(/\x00$/, "");
        offset += _padded_size(name_size, padding_multiple);
        var dtype;
        try {
          dtype = await new DatatypeMessage(this.fh, offset).dtype;
        } catch (e) {
          console.warn("Attribute " + name + " type not implemented, set to null.");
          return [name, null];
        }
        offset += _padded_size(attr_map.get("datatype_size"), padding_multiple);
        let shape = await this.determine_data_shape(this.fh, offset);
        let items = shape.reduce(function(a, b) {
          return a * b;
        }, 1);
        offset += _padded_size(attr_map.get("dataspace_size"), padding_multiple);
        if (dtype.datatype_class === 5) {
          value = await this.fh.slice(offset, offset + dtype.size);
        } else {
          var value = await this._attr_value(dtype, this.fh, items, offset);
          if (shape.length == 0) {
            value = value[0];
          }
        }
        return [name, value];
      }
      async determine_data_shape(buf, offset) {
        let version = (await struct.unpack_from_async("<B", buf, offset))[0];
        var header;
        if (version == 1) {
          header = await _unpack_struct_from_async(DATASPACE_MSG_HEADER_V1, buf, offset);
          assert(header.get("version") == 1);
          offset += DATASPACE_MSG_HEADER_V1_SIZE;
        } else if (version == 2) {
          header = await _unpack_struct_from_async(DATASPACE_MSG_HEADER_V2, buf, offset);
          assert(header.get("version") == 2);
          offset += DATASPACE_MSG_HEADER_V2_SIZE;
        } else {
          throw "unknown dataspace message version";
        }
        let ndims = header.get("dimensionality");
        let dim_sizes = await struct.unpack_from_async("<" + ndims.toFixed() + "Q", buf, offset);
        return dim_sizes;
      }
      async _attr_value(dtype, buf, count, offset) {
        var value = new Array(count);
        if (dtype instanceof Array) {
          let dtype_class = dtype[0];
          for (var i = 0; i < count; i++) {
            if (dtype_class == "VLEN_STRING") {
              let character_set = dtype[2];
              var [vlen, vlen_data] = await this._vlen_size_and_data(buf, offset);
              const encoding = character_set == 0 ? "ascii" : "utf-8";
              const decoder = new TextDecoder(encoding);
              value[i] = decoder.decode(vlen_data);
              offset += 16;
            } else if (dtype_class == "REFERENCE") {
              var address = await struct.unpack_from_async("<Q", buf, offset);
              value[i] = address;
              offset += 8;
            } else if (dtype_class == "VLEN_SEQUENCE") {
              let base_dtype = dtype[1];
              var [vlen, vlen_data] = this._vlen_size_and_data(buf, offset);
              value[i] = this._attr_value(base_dtype, vlen_data, vlen, 0);
              offset += 16;
            } else {
              throw "NotImplementedError";
            }
          }
        } else {
          let [getter, big_endian, size] = dtype_getter(dtype);
          const arrayBuffer = await buf.slice(offset, offset + count * size);
          let view = new DataView64(arrayBuffer, 0);
          let bufferOffset = 0;
          for (var i = 0; i < count; i++) {
            value[i] = view[getter](bufferOffset, !big_endian, size);
            bufferOffset += size;
          }
        }
        return value;
      }
      async _vlen_size_and_data(buf, offset) {
        let vlen_size = (await struct.unpack_from_async("<I", buf, offset))[0];
        let gheap_id = await _unpack_struct_from_async(GLOBAL_HEAP_ID, buf, offset + 4);
        let gheap_address = gheap_id.get("collection_address");
        assert(gheap_id.get("collection_address") < Number.MAX_SAFE_INTEGER);
        var gheap;
        if (!(gheap_address in this._global_heaps)) {
          gheap = new GlobalHeap(this.fh, gheap_address);
          await gheap.ready;
          this._global_heaps[gheap_address] = gheap;
        }
        gheap = this._global_heaps[gheap_address];
        let vlen_data = gheap.objects.get(gheap_id.get("object_index"));
        return [vlen_size, vlen_data];
      }
      async _parse_v1_objects(fh, offset) {
        let header = await _unpack_struct_from_async(OBJECT_HEADER_V1, fh, offset);
        assert(header.get("version") == 1);
        let total_header_messages = header.get("total_header_messages");
        var block_size = header.get("object_header_size");
        var block_offset = offset + _structure_size(OBJECT_HEADER_V1);
        var msg_data = await fh.slice(block_offset, block_offset + block_size);
        var object_header_blocks = [[block_offset, block_size]];
        var current_block = 0;
        var local_offset = 0;
        var msgs = new Array(total_header_messages);
        for (var i = 0; i < total_header_messages; i++) {
          if (local_offset >= block_size) {
            [block_offset, block_size] = object_header_blocks[++current_block];
            local_offset = 0;
          }
          let msg = await _unpack_struct_from_async(HEADER_MSG_INFO_V1, fh, block_offset + local_offset);
          let offset_to_message = block_offset + local_offset + HEADER_MSG_INFO_V1_SIZE;
          msg.set("offset_to_message", offset_to_message);
          if (msg.get("type") == OBJECT_CONTINUATION_MSG_TYPE) {
            var [fh_off, size] = await struct.unpack_from_async("<QQ", fh, offset_to_message);
            object_header_blocks.push([fh_off, size]);
          }
          local_offset += HEADER_MSG_INFO_V1_SIZE + msg.get("size");
          msgs[i] = msg;
        }
        return [msgs, msg_data, header];
      }
      async _parse_v2_objects(buf, offset) {
        var [header, creation_order_size, block_offset] = await this._parse_v2_header(buf, offset);
        offset = block_offset;
        var msgs = [];
        var block_size = header.get("size_of_chunk_0");
        var msg_data = buf.slice(offset, offset += block_size);
        var object_header_blocks = [[block_offset, block_size]];
        var current_block = 0;
        var local_offset = 0;
        while (true) {
          if (local_offset >= block_size - HEADER_MSG_INFO_V2_SIZE) {
            let next_block = object_header_blocks[++current_block];
            if (next_block == null) {
              break;
            }
            [block_offset, block_size] = next_block;
            local_offset = 0;
          }
          let msg = await _unpack_struct_from_async(HEADER_MSG_INFO_V2, buf, block_offset + local_offset);
          let offset_to_message = block_offset + local_offset + HEADER_MSG_INFO_V2_SIZE + creation_order_size;
          msg.set("offset_to_message", offset_to_message);
          if (msg.get("type") == OBJECT_CONTINUATION_MSG_TYPE) {
            var [fh_off, size] = await struct.unpack_from_async("<QQ", buf, offset_to_message);
            object_header_blocks.push([fh_off + 4, size - 4]);
          }
          local_offset += HEADER_MSG_INFO_V2_SIZE + msg.get("size") + creation_order_size;
          msgs.push(msg);
        }
        return [msgs, msg_data, header];
      }
      async _parse_v2_header(buf, offset) {
        let header = await _unpack_struct_from_async(OBJECT_HEADER_V2, buf, offset);
        var creation_order_size;
        offset += _structure_size(OBJECT_HEADER_V2);
        assert(header.get("version") == 2);
        if (header.get("flags") & 4) {
          creation_order_size = 2;
        } else {
          creation_order_size = 0;
        }
        assert((header.get("flags") & 16) == 0);
        if (header.get("flags") & 32) {
          let times = await struct.unpack_from_async("<4I", buf, offset);
          offset += 16;
          header.set("access_time", times[0]);
          header.set("modification_time", times[1]);
          header.set("change_time", times[2]);
          header.set("birth_time", times[3]);
        }
        let chunk_fmt = ["<B", "<H", "<I", "<Q"][header.get("flags") & 3];
        header.set("size_of_chunk_0", (await struct.unpack_from_async(chunk_fmt, buf, offset))[0]);
        offset += struct.calcsize(chunk_fmt);
        return [header, creation_order_size, offset];
      }
      async find_link(name) {
        if (this._links) {
          for (link of this._links) {
            if (name === link[0]) {
              return link;
            }
          }
        } else {
          const links = [];
          for await (const link2 of this.iter_links()) {
            if (name === link2[0]) {
              return link2;
            }
            links.push(link2);
          }
          this._links = links;
        }
        return void 0;
      }
      async get_links() {
        const links = [];
        for await (const link2 of this.iter_links()) {
          links.push(link2);
        }
        return Object.fromEntries(links);
      }
      async *iter_links() {
        for (let msg of this.msgs) {
          if (msg.get("type") == SYMBOL_TABLE_MSG_TYPE) {
            yield* this._iter_links_from_symbol_tables(msg);
          } else if (msg.get("type") == LINK_MSG_TYPE) {
            yield this._get_link_from_link_msg(msg);
          } else if (msg.get("type") == LINK_INFO_MSG_TYPE) {
            yield* this._iter_link_from_link_info_msg(msg);
          }
        }
      }
      async *_iter_links_from_symbol_tables(sym_tbl_msg) {
        assert(sym_tbl_msg.get("size") == 16);
        let data = await _unpack_struct_from_async(SYMBOL_TABLE_MSG, this.fh, sym_tbl_msg.get("offset_to_message"));
        yield* this._iter_links_btree_v1(data.get("btree_address"), data.get("heap_address"));
      }
      async *_iter_links_btree_v1(btree_address, heap_address) {
        let btree = new BTreeV1Groups(this.fh, btree_address);
        await btree.ready;
        let heap = new Heap(this.fh, heap_address);
        await heap.ready;
        for (let symbol_table_address of btree.symbol_table_addresses()) {
          let table = new SymbolTable(this.fh, symbol_table_address);
          await table.ready;
          table.assign_name(heap);
          yield* Object.entries(table.get_links(heap));
        }
      }
      async _get_link_from_link_msg(link_msg) {
        let offset = link_msg.get("offset_to_message");
        return await this._decode_link_msg(this.fh, offset)[1];
      }
      async _decode_link_msg(data, offset) {
        let [version, flags] = await struct.unpack_from_async("<BB", data, offset);
        offset += 2;
        assert(version == 1);
        let size_of_length_of_link_name = 2 ** (flags & 3);
        let link_type_field_present = (flags & 2 ** 3) > 0;
        let link_name_character_set_field_present = (flags & 2 ** 4) > 0;
        let ordered = (flags & 2 ** 2) > 0;
        let link_type;
        if (link_type_field_present) {
          link_type = (await struct.unpack_from_async("<B", data, offset))[0];
          offset += 1;
        } else {
          link_type = 0;
        }
        assert([0, 1].includes(link_type));
        let creationorder;
        if (ordered) {
          creationorder = (await struct.unpack_from_async("<Q", data, offset))[0];
          offset += 8;
        }
        let link_name_character_set = 0;
        if (link_name_character_set_field_present) {
          link_name_character_set = (await struct.unpack_from_async("<B", data, offset))[0];
          offset += 1;
        }
        let encoding = link_name_character_set == 0 ? "ascii" : "utf-8";
        let name_size_fmt = ["<B", "<H", "<I", "<Q"][flags & 3];
        let name_size = (await struct.unpack_from_async(name_size_fmt, data, offset))[0];
        offset += size_of_length_of_link_name;
        let name = new TextDecoder(encoding).decode(await data.slice(offset, offset + name_size));
        offset += name_size;
        let address;
        if (link_type == 0) {
          address = (await struct.unpack_from_async("<Q", data, offset))[0];
        } else if (link_type == 1) {
          let length_of_soft_link_value = (await struct.unpack_from_async("<H", data, offset))[0];
          offset += 2;
          address = new TextDecoder(encoding).decode(await data.slice(offset, offset + length_of_soft_link_value));
        }
        return [creationorder, [name, address]];
      }
      async *_iter_link_from_link_info_msg(info_msg) {
        let offset = info_msg.get("offset_to_message");
        let data = await this._decode_link_info_msg(this.fh, offset);
        let heap_address = data.get("heap_address");
        let name_btree_address = data.get("name_btree_address");
        let order_btree_address = data.get("order_btree_address");
        if (name_btree_address != null) {
          yield* this._iter_links_btree_v2(name_btree_address, order_btree_address, heap_address);
        }
      }
      async *_iter_links_btree_v2(name_btree_address, order_btree_address, heap_address) {
        let heap = new FractalHeap(this.fh, heap_address);
        await heap.ready;
        let btree;
        const ordered = order_btree_address != null;
        if (ordered) {
          btree = new BTreeV2GroupOrders(this.fh, order_btree_address);
          await btree.ready;
        } else {
          btree = new BTreeV2GroupNames(this.fh, name_btree_address);
          await btree.ready;
        }
        let items = /* @__PURE__ */ new Map();
        for (let record of btree.iter_records()) {
          let data = heap.get_data(record.get("heapid"));
          let [creationorder, item] = await this._decode_link_msg(data, 0);
          const key = ordered ? creationorder : item[0];
          items.set(key, item);
        }
        let sorted_keys = Array.from(items.keys()).sort();
        for (let key of sorted_keys) {
          yield items.get(key);
        }
      }
      async _decode_link_info_msg(data, offset) {
        let [version, flags] = await struct.unpack_from_async("<BB", data, offset);
        assert(version == 0);
        offset += 2;
        if ((flags & 1) > 0) {
          offset += 8;
        }
        let fmt = (flags & 2) > 0 ? LINK_INFO_MSG2 : LINK_INFO_MSG1;
        let link_info = await _unpack_struct_from_async(fmt, data, offset);
        let output = /* @__PURE__ */ new Map();
        for (let [k, v] of link_info.entries()) {
          output.set(k, v == UNDEFINED_ADDRESS2 ? null : v);
        }
        return output;
      }
      get is_dataset() {
        return this.find_msg_type(DATASPACE_MSG_TYPE).length > 0;
      }
      async get_data() {
        let msg = this.find_msg_type(DATA_STORAGE_MSG_TYPE)[0];
        let msg_offset = msg.get("offset_to_message");
        var [version, dims, layout_class, property_offset] = await this._get_data_message_properties(msg_offset);
        if (layout_class == 0) {
          throw "Compact storage of DataObject not implemented";
        } else if (layout_class == 1) {
          return this._get_contiguous_data(property_offset);
        } else if (layout_class == 2) {
          return this._get_chunked_data(msg_offset);
        }
      }
      async _get_data_message_properties(msg_offset) {
        let dims, layout_class, property_offset;
        let [version, arg1, arg2] = await struct.unpack_from_async("<BBB", this.fh, msg_offset);
        if (version == 1 || version == 2) {
          dims = arg1;
          layout_class = arg2;
          property_offset = msg_offset;
          property_offset += struct.calcsize("<BBB");
          property_offset += struct.calcsize("<BI");
          assert(layout_class == 1 || layout_class == 2);
        } else if (version == 3 || version == 4) {
          layout_class = arg1;
          property_offset = msg_offset;
          property_offset += struct.calcsize("<BB");
        }
        assert(version >= 1 && version <= 4);
        return [version, dims, layout_class, property_offset];
      }
      async _get_contiguous_data(property_offset) {
        let [data_offset] = await struct.unpack_from_async("<Q", this.fh, property_offset);
        const shape = await this.shape;
        const dtype = await this.dtype;
        if (data_offset == UNDEFINED_ADDRESS2) {
          let size = shape.reduce(function(a, b) {
            return a * b;
          }, 1);
          return new Array(size);
        }
        var fullsize = shape.reduce(function(a, b) {
          return a * b;
        }, 1);
        if (!(dtype instanceof Array)) {
          if (/[<>=!@\|]?(i|u|f|S)(\d*)/.test(dtype)) {
            let [item_getter, item_is_big_endian, item_size] = dtype_getter(dtype);
            let output = new Array(fullsize);
            const local_buffer = await this.fh.slice(data_offset, data_offset + item_size * fullsize);
            let view = new DataView64(local_buffer);
            for (var i = 0; i < fullsize; i++) {
              output[i] = view[item_getter](i * item_size, !item_is_big_endian, item_size);
            }
            return output;
          } else if (dtype.datatype_class === 5) {
            return this.fh.slice(data_offset, data_offset + dtype.size);
          } else {
            throw "not Implemented - no proper dtype defined";
          }
        } else {
          let dtype_class = dtype[0];
          if (dtype_class == "REFERENCE") {
            let size = dtype[1];
            if (size != 8) {
              throw "NotImplementedError('Unsupported Reference type')";
            }
            let ref_addresses = await this.fh.slice(data_offset, data_offset + fullsize);
            return ref_addresses;
          } else if (dtype_class == "VLEN_STRING") {
            let character_set = dtype[2];
            const encoding = character_set == 0 ? "ascii" : "utf-8";
            const decoder = new TextDecoder(encoding);
            var value = [];
            for (var i = 0; i < fullsize; i++) {
              const [vlen, vlen_data] = await this._vlen_size_and_data(this.fh, data_offset);
              value[i] = decoder.decode(vlen_data);
              data_offset += 16;
            }
            return value;
          } else {
            throw "NotImplementedError('datatype not implemented')";
          }
        }
      }
      async _get_chunked_data(offset) {
        await this._get_chunk_params();
        if (this._chunk_address == UNDEFINED_ADDRESS2) {
          return [];
        }
        var chunk_btree = new BTreeV1RawDataChunks(this.fh, this._chunk_address, this._chunk_dims);
        await chunk_btree.ready;
        const dtype = await this.dtype;
        const shape = await this.shape;
        const chunks = await this.chunks;
        const filter_pipeline = await this.get_filter_pipeline();
        let data = await chunk_btree.construct_data_from_chunks(chunks, shape, dtype, filter_pipeline);
        if (dtype instanceof Array && /^VLEN/.test(dtype[0])) {
          let dtype_class = dtype[0];
          for (var i = 0; i < data.length; i++) {
            let [item_size, gheap_address, object_index] = data[i];
            var gheap;
            if (!(gheap_address in this._global_heaps)) {
              gheap = new GlobalHeap(this.fh, gheap_address);
              await gheap.ready;
              this._global_heaps[gheap_address] = gheap;
            } else {
              gheap = this._global_heaps[gheap_address];
            }
            let vlen_data = gheap.objects.get(object_index);
            if (dtype_class == "VLEN_STRING") {
              let character_set = dtype[2];
              const encoding = character_set == 0 ? "ascii" : "utf-8";
              const decoder = new TextDecoder(encoding);
              data[i] = decoder.decode(vlen_data);
            }
          }
        }
        return data;
      }
      async _get_chunk_params() {
        if (this._chunk_params_set) {
          return;
        }
        this._chunk_params_set = true;
        var msg = this.find_msg_type(DATA_STORAGE_MSG_TYPE)[0];
        var offset = msg.get("offset_to_message");
        var [version, dims, layout_class, property_offset] = await this._get_data_message_properties(offset);
        if (layout_class != 2) {
          return;
        }
        var data_offset;
        if (version == 1 || version == 2) {
          var address = (await struct.unpack_from_async("<Q", this.fh, property_offset))[0];
          data_offset = property_offset + struct.calcsize("<Q");
        } else if (version == 3) {
          var [dims, address] = await struct.unpack_from_async("<BQ", this.fh, property_offset);
          data_offset = property_offset + struct.calcsize("<BQ");
        }
        assert(version >= 1 && version <= 3);
        var fmt = "<" + (dims - 1).toFixed() + "I";
        var chunk_shape = await struct.unpack_from_async(fmt, this.fh, data_offset);
        this._chunks = chunk_shape;
        this._chunk_dims = dims;
        this._chunk_address = address;
        return;
      }
    };
    async function determine_data_shape(buf, offset) {
      let version = (await struct.unpack_from_async("<B", buf, offset))[0];
      var header;
      if (version == 1) {
        header = await _unpack_struct_from_async(DATASPACE_MSG_HEADER_V1, buf, offset);
        assert(header.get("version") == 1);
        offset += DATASPACE_MSG_HEADER_V1_SIZE;
      } else if (version == 2) {
        header = await _unpack_struct_from_async(DATASPACE_MSG_HEADER_V2, buf, offset);
        assert(header.get("version") == 2);
        offset += DATASPACE_MSG_HEADER_V2_SIZE;
      } else {
        throw "InvalidHDF5File('unknown dataspace message version')";
      }
      let ndims = header.get("dimensionality");
      let dim_sizes = await struct.unpack_from_async("<" + (ndims * 2).toFixed() + "I", buf, offset);
      return dim_sizes.filter(function(s, i) {
        return i % 2 == 0;
      });
    }
    var UNDEFINED_ADDRESS2 = struct.unpack_from("<Q", new Uint8Array([255, 255, 255, 255, 255, 255, 255, 255]).buffer);
    var GLOBAL_HEAP_ID = /* @__PURE__ */ new Map([
      ["collection_address", "Q"],
      ["object_index", "I"]
    ]);
    _structure_size(GLOBAL_HEAP_ID);
    var ATTR_MSG_HEADER_V1 = /* @__PURE__ */ new Map([
      ["version", "B"],
      ["reserved", "B"],
      ["name_size", "H"],
      ["datatype_size", "H"],
      ["dataspace_size", "H"]
    ]);
    var ATTR_MSG_HEADER_V1_SIZE = _structure_size(ATTR_MSG_HEADER_V1);
    var ATTR_MSG_HEADER_V3 = /* @__PURE__ */ new Map([
      ["version", "B"],
      ["flags", "B"],
      ["name_size", "H"],
      ["datatype_size", "H"],
      ["dataspace_size", "H"],
      ["character_set_encoding", "B"]
    ]);
    var ATTR_MSG_HEADER_V3_SIZE = _structure_size(ATTR_MSG_HEADER_V3);
    var OBJECT_HEADER_V1 = /* @__PURE__ */ new Map([
      ["version", "B"],
      ["reserved", "B"],
      ["total_header_messages", "H"],
      ["object_reference_count", "I"],
      ["object_header_size", "I"],
      ["padding", "I"]
    ]);
    var OBJECT_HEADER_V2 = /* @__PURE__ */ new Map([
      ["signature", "4s"],
      ["version", "B"],
      ["flags", "B"]
    ]);
    var DATASPACE_MSG_HEADER_V1 = /* @__PURE__ */ new Map([
      ["version", "B"],
      ["dimensionality", "B"],
      ["flags", "B"],
      ["reserved_0", "B"],
      ["reserved_1", "I"]
    ]);
    var DATASPACE_MSG_HEADER_V1_SIZE = _structure_size(DATASPACE_MSG_HEADER_V1);
    var DATASPACE_MSG_HEADER_V2 = /* @__PURE__ */ new Map([
      ["version", "B"],
      ["dimensionality", "B"],
      ["flags", "B"],
      ["type", "B"]
    ]);
    var DATASPACE_MSG_HEADER_V2_SIZE = _structure_size(DATASPACE_MSG_HEADER_V2);
    var HEADER_MSG_INFO_V1 = /* @__PURE__ */ new Map([
      ["type", "H"],
      ["size", "H"],
      ["flags", "B"],
      ["reserved", "3s"]
    ]);
    var HEADER_MSG_INFO_V1_SIZE = _structure_size(HEADER_MSG_INFO_V1);
    var HEADER_MSG_INFO_V2 = /* @__PURE__ */ new Map([
      ["type", "B"],
      ["size", "H"],
      ["flags", "B"]
    ]);
    var HEADER_MSG_INFO_V2_SIZE = _structure_size(HEADER_MSG_INFO_V2);
    var SYMBOL_TABLE_MSG = /* @__PURE__ */ new Map([
      ["btree_address", "Q"],
      ["heap_address", "Q"]
    ]);
    var LINK_INFO_MSG1 = /* @__PURE__ */ new Map([
      ["heap_address", "Q"],
      ["name_btree_address", "Q"]
    ]);
    var LINK_INFO_MSG2 = /* @__PURE__ */ new Map([
      ["heap_address", "Q"],
      ["name_btree_address", "Q"],
      ["order_btree_address", "Q"]
    ]);
    var FILLVAL_MSG_V1V2 = /* @__PURE__ */ new Map([
      ["version", "B"],
      ["space_allocation_time", "B"],
      ["fillvalue_write_time", "B"],
      ["fillvalue_defined", "B"]
    ]);
    var FILLVAL_MSG_V1V2_SIZE = _structure_size(FILLVAL_MSG_V1V2);
    var FILLVAL_MSG_V3 = /* @__PURE__ */ new Map([
      ["version", "B"],
      ["flags", "B"]
    ]);
    var FILLVAL_MSG_V3_SIZE = _structure_size(FILLVAL_MSG_V3);
    var FILTER_PIPELINE_DESCR_V1 = /* @__PURE__ */ new Map([
      ["filter_id", "H"],
      ["name_length", "H"],
      ["flags", "H"],
      ["client_data_values", "H"]
    ]);
    var FILTER_PIPELINE_DESCR_V1_SIZE = _structure_size(FILTER_PIPELINE_DESCR_V1);
    var DATASPACE_MSG_TYPE = 1;
    var LINK_INFO_MSG_TYPE = 2;
    var DATATYPE_MSG_TYPE = 3;
    var FILLVALUE_MSG_TYPE = 5;
    var LINK_MSG_TYPE = 6;
    var DATA_STORAGE_MSG_TYPE = 8;
    var DATA_STORAGE_FILTER_PIPELINE_MSG_TYPE = 11;
    var ATTRIBUTE_MSG_TYPE = 12;
    var OBJECT_CONTINUATION_MSG_TYPE = 16;
    var SYMBOL_TABLE_MSG_TYPE = 17;

    // esm/high-level.js
    var Group = class {
      constructor(name, parent) {
        if (parent == null) {
          this.parent = this;
          this.file = this;
        } else {
          this.parent = parent;
          this.file = parent.file;
        }
        this.name = name;
      }
      async init(dataobjects) {
        const index = this.file.index;
        if (index && this.name in index) {
          this._links = index[this.name];
        } else {
          this._links = await dataobjects.get_links();
        }
        this._dataobjects = dataobjects;
        this._attrs = null;
        this._keys = null;
      }
      get keys() {
        if (this._keys == null) {
          this._keys = Object.keys(this._links);
        }
        return this._keys.slice();
      }
      get values() {
        return this.keys.map((k) => this.get(k));
      }
      length() {
        return this.keys.length;
      }
      _dereference(ref) {
        if (!ref) {
          throw "cannot deference null reference";
        }
        let obj = this.file._get_object_by_address(ref);
        if (obj == null) {
          throw "reference not found in file";
        }
        return obj;
      }
      async get(y) {
        if (typeof y == "number") {
          return this._dereference(y);
        }
        var path = normpath(y);
        if (path == "/") {
          return this.file;
        }
        if (path == ".") {
          return this;
        }
        if (/^\//.test(path)) {
          return this.file.get(path.slice(1));
        }
        if (posix_dirname(path) != "") {
          var [next_obj, additional_obj] = path.split(/\/(.*)/);
        } else {
          var next_obj = path;
          var additional_obj = ".";
        }
        if (!(next_obj in this._links)) {
          throw next_obj + " not found in group";
        }
        var obj_name = normpath(this.name + "/" + next_obj);
        let link_target = this._links[next_obj];
        if (typeof link_target == "string") {
          try {
            return this.get(link_target);
          } catch (error) {
            return null;
          }
        }
        var dataobjs = new DataObjects(this.file._fh, link_target);
        await dataobjs.ready;
        if (dataobjs.is_dataset) {
          if (additional_obj != ".") {
            throw obj_name + " is a dataset, not a group";
          }
          return new Dataset(obj_name, dataobjs, this);
        } else {
          var new_group = new Group(obj_name, this);
          await new_group.init(dataobjs);
          return new_group.get(additional_obj);
        }
      }
      visit(func) {
        return this.visititems((name, obj) => func(name));
      }
      visititems(func) {
        var root_name_length = this.name.length;
        if (!/\/$/.test(this.name)) {
          root_name_length += 1;
        }
        var queue = this.values.slice();
        while (queue) {
          let obj = queue.shift();
          if (queue.length == 1)
            console.log(obj);
          let name = obj.name.slice(root_name_length);
          let ret = func(name, obj);
          if (ret != null) {
            return ret;
          }
          if (obj instanceof Group) {
            queue = queue.concat(obj.values);
          }
        }
        return null;
      }
      get attrs() {
        if (this._attrs == null) {
          this._attrs = this._dataobjects.get_attributes();
        }
        return this._attrs;
      }
    };
    var File$1 = class extends Group {
      constructor(fh, filename, options) {
        super("/", null);
        this.ready = this.init(fh, filename, options);
      }
      async init(fh, filename, options) {
        var superblock = new SuperBlock(fh, 0);
        await superblock.ready;
        var offset = await superblock.get_offset_to_dataobjects();
        var dataobjects = new DataObjects(fh, offset);
        await dataobjects.ready;
        this.parent = this;
        this.file = this;
        this.name = "/";
        this._dataobjects = dataobjects;
        this._attrs = null;
        this._keys = null;
        this._fh = fh;
        this.filename = filename || "";
        this.mode = "r";
        this.userblock_size = 0;
        if (options && options.index) {
          this.index = options.index;
        } else {
          let index_offset;
          if (options && options.indexOffset) {
            index_offset = options.indexOffset;
          } else {
            const attrs = await this.attrs;
            if (attrs.hasOwnProperty("_index_offset")) {
              index_offset = attrs["_index_offset"];
            } else {
              const indexName = this.indexName || "_index";
              const index_link = await dataobjects.find_link(indexName);
              if (index_link) {
                index_offset = index_link[1];
              }
            }
          }
          if (index_offset) {
            try {
              const dataobject = new DataObjects(fh, index_offset);
              await dataobject.ready;
              const comp_index_data = await dataobject.get_data();
              const inflated = ungzip_1(comp_index_data);
              const json = new TextDecoder().decode(inflated);
              this.index = JSON.parse(json);
            } catch (e) {
              console.error(`Error loading index by offset ${e}`);
            }
          }
        }
        if (this.index && this.name in this.index) {
          this._links = this.index[this.name];
        } else {
          this._links = await dataobjects.get_links();
        }
      }
      _get_object_by_address(obj_addr) {
        if (this._dataobjects.offset == obj_addr) {
          return this;
        }
        return this.visititems((y) => {
          y._dataobjects.offset == obj_addr ? y : null;
        });
      }
    };
    var Dataset = class extends Array {
      constructor(name, dataobjects, parent) {
        super();
        this.parent = parent;
        this.file = parent.file;
        this.name = name;
        this._dataobjects = dataobjects;
        this._attrs = null;
        this._astype = null;
      }
      get value() {
        var data = this._dataobjects.get_data();
        if (this._astype == null) {
          return this.getValue(data);
        }
        return data.astype(this._astype);
      }
      get shape() {
        return this._dataobjects.shape;
      }
      get attrs() {
        return this._dataobjects.get_attributes();
      }
      get dtype() {
        return this._dataobjects.dtype;
      }
      get fillvalue() {
        return this._dataobjects.get_fillvalue();
      }
      async to_array() {
        const value = await this.value;
        const shape = await this.shape;
        return create_nested_array(value, shape);
      }
      async getValue(data) {
        const dtype = await this.dtype;
        if ((typeof dtype === "string" || dtype instanceof String) && dtype.startsWith("S")) {
          return (await data).map((s) => {
            let idx = s.indexOf("\0");
            return idx >= 0 ? s.substring(0, idx) : s;
          });
        } else {
          return data;
        }
      }
    };
    function posix_dirname(p) {
      let sep = "/";
      let i = p.lastIndexOf(sep) + 1;
      let head = p.slice(0, i);
      let all_sep = new RegExp("^" + sep + "+$");
      let end_sep = new RegExp(sep + "$");
      if (head && !all_sep.test(head)) {
        head = head.replace(end_sep, "");
      }
      return head;
    }
    function normpath(path) {
      return path.replace(/\/(\/)+/g, "/");
    }
    function create_nested_array(value, shape) {
      const total_length = value.length;
      const dims_product = shape.reduce((previous, current) => previous * current, 1);
      if (total_length !== dims_product) {
        console.warn(`shape product: ${dims_product} does not match length of flattened array: ${total_length}`);
      }
      let output = value;
      const subdims = shape.slice(1).reverse();
      for (let dim of subdims) {
        const new_output = [];
        const { length } = output;
        let cursor = 0;
        while (cursor < length) {
          new_output.push(output.slice(cursor, cursor += dim));
        }
        output = new_output;
      }
      return output;
    }
    /*! pako 2.0.4 https://github.com/nodeca/pako @license (MIT AND Zlib) */

    async function openH5File(options) {

        // Some clients (notably igv-webapp) pass a File reference in the url field.  Fix this
        if(options.url && isBlobLike(options.url)) {
            options.file = options.url;
            options.url = undefined;
        }

        const isRemote = options.url !== undefined;
        let fileReader = options.reader ? options.reader : getReaderFor(options);

        // Set default options appropriate for spacewalk
        const fetchSize = options.fetchSize || 2000;
        const maxSize = options.maxSize || 200000;

        if (isRemote) {
            fileReader = new BufferedFile({file: fileReader, fetchSize, maxSize});
        }
        const asyncBuffer = new AsyncBuffer(fileReader);

        // Optional external index -- this is not common
        const index = await readExternalIndex(options);
        const indexOffset = options.indexOffset;

        // Create HDF5 file
        const filename = getFilenameFor(options);
        const hdfFile = new File$1(asyncBuffer, filename, {index, indexOffset});
        await hdfFile.ready;
        return hdfFile
    }

    async function readExternalIndex(options) {

        let indexReader;
        if(options.indexReader) {
            indexReader = options.indexReader;
        }
        else if(options.index) {
            return options.index
        } else if (options.indexURL) {
            indexReader = new RemoteFile({url: options.indexURL});
        } else if (options.indexPath) {
            indexReader = new NodeLocalFile({path: options.indexPath});
        } else if (options.indexFile) {
            indexReader = new BlobFile({file: options.indexFile});
        }
        if (indexReader) {
            const indexFileContents = await indexReader.read();
            const indexFileJson = new TextDecoder().decode(indexFileContents);
            return JSON.parse(indexFileJson)
        } else {
            return undefined
        }
    }


    function getReaderFor(options) {
        if (options.url) { // An absolute or relative URL
            return new RemoteFile(options)
        } else if (options.path) { // A file path
            return new NodeLocalFile(options)
        } else if (options.file) { // A Browser file blob
            return new BlobFile(options.file)
        } else {
            throw Error("One of 'url', 'path (node only)', or 'file (browser only)' must be specified")
        }
    }

    function getFilenameFor(options) {
        if (options.url) {
            return getFilename(options.url)
        } else if (options.path) {
            return getFilename(options.path)
        } else if (options.file) {
            return options.file.name
        }
    }

    /**
     * Wraps an io.Reader in an interface jsfive-async expects*
     */
    class AsyncBuffer {
        constructor(fileReader) {
            this.fileReader = fileReader;
        }

        async slice(start, end) {
            return this.fileReader.read(start, end - start)
        }
    }

    function getFilename(pathOrURL) {
        const idx = pathOrURL.lastIndexOf("/");
        return idx > 0 ? pathOrURL.substring(idx + 1) : pathOrURL
    }

    function isBlobLike(obj) {
        return typeof obj.slice === 'function' && typeof obj.arrayBuffer === 'function'
    }

    class HDF5Reader {
        
        constructor(h5_file, bin_size=100000){

            this.h5_file = h5_file;
            this.bin_size = bin_size;
            this.h5_obj = undefined;
        }
        
        async fetch(){

            if(!this.h5_obj) {
                this.h5_obj = await openH5File({
                    url: this.h5_file,
                    fetchSize: 1000000,
                    maxSize: 200000000
                });
            }
            return this.h5_obj
        }

        async get_keys(){
            /* returns a list of keys of the pytor file*/
            let h5_obj = await this.fetch();

            return h5_obj.keys
        }

        async get_rd_signal(bin_size=this.bin_size){

            let h5_obj = await this.fetch();
            let h5_obj_keys = h5_obj.keys;

            // console.log(h5_obj_keys)
            let signal_bin = new ParseSignals(h5_obj_keys);
            let rd_bins = signal_bin.get_rd_bins();
            let snp_bins = signal_bin.get_snp_bins();
            this.available_bins = [...new Set(rd_bins, snp_bins)];

            // let bin_size = this.bin_size
            if(! this.available_bins.includes(bin_size)){
                bin_size = this.available_bins.at(-1);    
            }

            const chr_ds = await h5_obj.get("rd_chromosomes");
            await chr_ds.dtype;
            let rd_chromosomes = await chr_ds.value;
            //console.log(`get_rd_signal rd_chromosomes  ${Date.now() - t0}`)
            //rd_chromosomes = fixString(rd_chromosomes)
            let rd_flag = "";

            // get rd stat
            let rd_stat = await this.rd_stat(h5_obj, h5_obj_keys, bin_size);
            
            var wigFeatures = [];
            var wigFeatures_gc = [];
            var wigFeatures_rd_call_meanshift = [];
            var wigFeatures_rd_call_combined = [];
            var wigFeatures_baf1 = [];
            var wigFeatures_baf2 = [];

            for (let chrom of rd_chromosomes) {
                // for normal rd signal
                var signal_rd = `his_rd_p_${chrom}_${bin_size}${rd_flag}`;
                let chr_wig = await this.get_chr_signal(h5_obj, h5_obj_keys, chrom, bin_size, signal_rd, rd_stat);
                wigFeatures = wigFeatures.concat(chr_wig);
                
                // rd gc corrected
                var signal_rd_gc = `his_rd_p_${chrom}_${bin_size}_GC`;
                let chr_wig_gc = await this.get_chr_signal(h5_obj, h5_obj_keys, chrom, bin_size, signal_rd_gc, rd_stat);
                wigFeatures_gc = wigFeatures_gc.concat(chr_wig_gc);

                // rd call MeanShift
                
                let signal_rd_call = `his_rd_p_${chrom}_${bin_size}_partition_GC_merge`;
                let chr_wig_rd_call_meanshift = await this.get_chr_signal(h5_obj, h5_obj_keys, chrom, bin_size, signal_rd_call, rd_stat);
                wigFeatures_rd_call_meanshift = wigFeatures_rd_call_meanshift.concat(chr_wig_rd_call_meanshift);
                
                let chr_wig_rd_call = await this.rd_call_combined(h5_obj, h5_obj_keys, chrom, bin_size, rd_stat);
                wigFeatures_rd_call_combined = wigFeatures_rd_call_combined.concat(chr_wig_rd_call);

                // baf likelihood
                let signal_baf_1 = `snp_likelihood_${chrom}_${bin_size}_mask`;
                let chr_wig_bafs = await this.get_baf_signals(h5_obj, h5_obj_keys, chrom, bin_size, signal_baf_1);

                // let signal_baf_1 = `snp_i1_${chrom}_${bin_size}_mask`
                // let chr_wig_bafs = await this.get_baf_signals_v2(h5_obj, h5_obj_keys, chrom, bin_size, signal_baf_1)

                wigFeatures_baf1 = wigFeatures_baf1.concat(chr_wig_bafs[0]);
                wigFeatures_baf2 = wigFeatures_baf2.concat(chr_wig_bafs[1]);
                // this.rd_call_combined(h5_obj, h5_obj_keys, chrom, bin_size, rd_stat)
            }
            this.callers = [];
            if (wigFeatures_rd_call_combined.length != 0){
                this.callers.push('ReadDepth');
            }
            if (wigFeatures_rd_call_combined.length != 0){
                this.callers.push('2D');
            }

            var obj = {};
            var signal_obj = {
                "RD_Raw": wigFeatures,
                "RD_Raw_gc_coor" : wigFeatures_gc,
                "ReadDepth": wigFeatures_rd_call_meanshift,
                "2D": wigFeatures_rd_call_combined,
                "BAF1": wigFeatures_baf1,
                "BAF2": wigFeatures_baf2
            };
            obj[bin_size] = signal_obj;
            return obj
        }

        decode_segments(segments_arr){
            let max = 2 ** 32 - 1;
            let segments = [];
            let l = [];
            for (let x of segments_arr){
                if(x == max){
                    segments.push(l);
                    l = [];
                } else {
                    l.push(x);
                }
            }
            return segments
        }

       async  rd_call_combined(h5_obj, h5_obj_keys, chrom, bin_size, rd_stat){
            let chr_wig = [];
            
            let segments;
            let mosaic_call_segments = `his_rd_p_${chrom}_${bin_size}_partition_GC_mosaic_segments_2d`;
            if (h5_obj_keys.includes(mosaic_call_segments)){
                const chrom_dataset = await h5_obj.get(mosaic_call_segments);
                let chrom_data = await chrom_dataset.value;
                //console.log(`rd_call_combined ${mosaic_call_segments}  ${Date.now() - t0}`)
                segments = this.decode_segments(chrom_data);
                
            }

            let mosaic_calls = `his_rd_p_${chrom}_${bin_size}_partition_GC_mosaic_call_2d`;
            if (h5_obj_keys.includes(mosaic_calls)){
                const segments_call_dataset = await h5_obj.get(mosaic_calls);
                let segments_call = await segments_call_dataset.to_array(); //create_nested_array(value, shape)
                segments.forEach((ind_segment, segment_idx) => {
                    ind_segment.forEach((bin_value, bin_idx) =>{
                        chr_wig.push({chr:chrom, start: bin_value*bin_size, end: (bin_value+1) * bin_size, value: (segments_call[0][segment_idx]/rd_stat[4]) *2});
                    });
                });
            }

            return chr_wig
            
        }

       async rd_stat(h5_obj, h5_obj_keys, bin_size){
            /* 
            returns a list for rd statistics information 
            paramter
            ---------
            h5_obj: cnvpytor read object
            h5_obj_keys: a list of available signal names
            bin_size: bin size
            
            */
            
            let rd_stat_signal =  `rd_stat_${bin_size}_auto`;
            let rd_stat;
            if (h5_obj_keys.includes(rd_stat_signal)){
                const rd_stat_dataset = await h5_obj.get(rd_stat_signal);
                rd_stat = await rd_stat_dataset.value;
                //console.log(`rd_stat_signal ${rd_stat_signal}  ${Date.now() - t0}`)
            }
            return rd_stat
        }

        
        async get_chr_signal(h5_obj, h5_obj_keys, chrom, bin_size, signal_name, rd_stat){
            /* return a list of dictionary for a chromosome */
            let chr_wig = [];
            
            if (h5_obj_keys.includes(signal_name)){
                const chrom_dataset = await h5_obj.get(signal_name);
                let chrom_data = await chrom_dataset.value;
                //console.log(`chr_signal ${signal_name}  ${Date.now() - t0}`)
                chrom_data.forEach((bin_value, bin_idx) => {
                    chr_wig.push({chr:chrom, start: bin_idx*bin_size, end: (bin_idx+1) * bin_size, value: (bin_value/rd_stat[4]) *2});
                });
            }
            return chr_wig
        }

        async get_baf_signals(h5_obj, h5_obj_keys, chrom, bin_size, signal_name){
            /* return two list of dictionary*/
            let chr_wig_1 = [];
            let chr_wig_2 = [];
            if (h5_obj_keys.includes(signal_name)){
                let chrom_dataset = await h5_obj.get(signal_name);
                let chrom_data = await chrom_dataset.to_array(); //create_nested_array(value, shape)
                chrom_data.forEach((bin_value, bin_idx) => {
                    let max_value =  Math.max(...bin_value);
                    const res = bin_value.indexOf(max_value);
                    let lh = Math.max(res / 200, 1 - res / 200);
                    chr_wig_1.push({chr:chrom, start: bin_idx*bin_size, end: (bin_idx+1) * bin_size, value: -2 * lh});
                    if(lh != 0.5){
                        chr_wig_2.push({chr:chrom, start: bin_idx*bin_size, end: (bin_idx+1) * bin_size, value: -2 *(1-lh)});
                    }
                });
            }
            return [chr_wig_1, chr_wig_2]
        }

        async get_baf_signals_v2(h5_obj, h5_obj_keys, chrom, bin_size, signal_name){
            
            /* return two list of dictionary*/
            let chr_wig_1 = [];
            let chr_wig_2 = [];
            if (h5_obj_keys.includes(signal_name)){
                let chrom_dataset = await h5_obj.get(signal_name);
                let chrom_data = await chrom_dataset.to_array(); //create_nested_array(value, shape)
                chrom_data.forEach((lh, bin_idx) => {
                    if (!isNaN(lh)){
                        chr_wig_1.push({chr:chrom, start: bin_idx*bin_size, end: (bin_idx+1) * bin_size, value: -2 * ( 0.5 - lh )});
                        if(lh != 0.5){
                            chr_wig_2.push({chr:chrom, start: bin_idx*bin_size, end: (bin_idx+1) * bin_size, value: -2 * ( 0.5 + lh )});
                        }
                    }
                });
            }
            console.log(chrom, chr_wig_1, chr_wig_2);
            return [chr_wig_1, chr_wig_2]

        }
    }

    class ParseSignals{

        constructor(signals){
            /*
            Parse a signal names

            parameter
            ---------
            signals: List of keys in pytor files
            */
            this.signals = signals;
        }

        get_rd_bins(){
            /* return list of rd bins */
            let rd_keys = [];
            this.signals.forEach( val => {
                let match = val.match(/^his_rd_p_(.*)_(\d+)$/);
                if(match){
                    rd_keys.push({chr:match[1], bin_size:match[2]});
                }});
            const rd_bins = [...new Set(rd_keys.map(item => Number(item.bin_size)))];
            return rd_bins
        }

        get_snp_bins(){
            /* return list of snp bins */
            let slected_signals = [];
            this.signals.forEach( val => {
                let match = val.match(/^snp_likelihood_(.*)_(\d+)_mask$/);
                if(match){
                    slected_signals.push({chr:match[1], bin_size:match[2]});
                }});
            const bins = [...new Set(slected_signals.map(item => Number(item.bin_size)))];
            return bins
        }
    }

    class GetFit {
      constructor(allBins) {
          this.allBins = allBins;
      }
      getValues() {
          const bins = Object.values(this.allBins).reduce(
              (binResult, bin) => { return binResult.concat(bin.filter(a => a.binScore > 0).map(a => a.binScore)) }, []);
          return bins
      }
      getMean(data) {
          return (data.reduce(function (a, b) { return a + b; }) / data.length);
      }
      fit_data() {
          let rd_list = this.getValues();
          let distParmas = getDistParams(rd_list);
          return distParmas
      }

      histogram(data, bins) {
          const step = bins[1] - bins[0];
          const hist_bins = [];

          data.forEach((value, index) => {
              bins.forEach((bin_value, bin_index) => {
                  if (!hist_bins[bin_value]) {
                      hist_bins[bin_value] = { count: 0 };
                  }
                  if (bin_value <= value && value < bin_value + step) {
                      hist_bins[bin_value].count++;
                      return false;
                  }
              });
          });
          const dist_p = [];
          hist_bins.forEach((bin, index) => { dist_p.push(bin.count); });
          return dist_p
      }

    }

    function range_function(start, stop, step) {
      const data_array = Array(Math.ceil((stop - start) / step))
        .fill(start)
        .map((x, y) => x + y * step);
      return data_array;
    }

    function filterOutliers(someArray) {

      if (someArray.length < 4)
        return someArray;

      let values, q1, q3, iqr, maxValue, minValue;

      values = someArray.slice().sort((a, b) => a - b); //copy array fast and sort

      if ((values.length / 4) % 1 === 0) { //find quartiles
        q1 = 1 / 2 * (values[(values.length / 4)] + values[(values.length / 4) + 1]);
        q3 = 1 / 2 * (values[(values.length * (3 / 4))] + values[(values.length * (3 / 4)) + 1]);
      } else {
        q1 = values[Math.floor(values.length / 4 + 1)];
        q3 = values[Math.ceil(values.length * (3 / 4) + 1)];
      }

      iqr = q3 - q1;
      maxValue = q3 + iqr * 1.5;
      minValue = q1 - iqr * 1.5;

      return values.filter((x) => (x >= minValue) && (x <= maxValue));
    }

    function getDistParams(bins) {
      let filteredBins = filterOutliers(bins);
      const n = filteredBins.length;
      const mean = filteredBins.reduce((a, b) => a + b) / n;
      const std = Math.sqrt(filteredBins.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n);
      return [mean, std]
    }

    function linspace(a, b, n) {
      if (typeof n === "undefined") n = Math.max(Math.round(b - a) + 1, 1);
      if (n < 2) {
          return n === 1 ? [a] : [];
      }
      var ret = Array(n);
      n--;
      for (let i = n; i >= 0; i--) {
          ret[i] = (i * b + (n - i) * a) / n;
      }
      return ret;
    }

    var g_utils = { range_function, getDistParams, linspace, GetFit};

    /** 
    * Evaluates the cumulative distribution function (CDF) for a Student's t distribution with degrees of freedom `v` at a value `t`.
    *
    * @params {number} t - value for the t test
    * @params {PositiveNumber} v - degree of freedom
    * @returns {Probability} evaluated CDF
    */
    function TdistributionCDF(t, v){
        if (isNaN( t ) || isNaN( v ) || v <= 0.0) {
    		return NaN;
    	}
    	if ( t === 0.0 ) {
    		return 0.5;
    	}
        return 1/2 + (1/2 * (incompbeta(1/2*v, 1/2, 1) - incompbeta(1/2*v, 1/2, v/(v+t*t)))) * Math.sign( t)

    }


    /** 
    * incompbeta(a,b,x) evaluates incomplete beta function, here a, b > 0 and 0 <= x <= 1. This function requires contfractbeta(a,b,x, ITMAX = 200) 
    *  code translated from  https://malishoaib.wordpress.com/2014/04/15/the-beautiful-beta-functions-in-raw-python/
    *
    * @params
    * @params
    * @params
    * @returns 
    */
    function incompbeta(a, b, x){
         
        if(x == 0){
            return 0;
        }
        else if (x == 1){
            return 1;
        }else
        {
            let lbeta = lgamma(a+b) - lgamma(a) - lgamma(b) + a * Math.log(x) + b * Math.log(1-x);
            if (x < (a+1) / (a+b+2)){
                return Math.exp(lbeta) * contfractbeta(a, b, x) / a;
            }
            else {
                return 1 - Math.exp(lbeta) * contfractbeta(b, a, 1-x) / b;
            }
        }
    }

    /**
     * contfractbeta() evaluates the continued fraction form of the incomplete Beta function; incompbeta().  
     *   (Code translated from: Numerical Recipes in C.)
     * 
     * @param {*} a 
     * @param {*} b 
     * @param {*} x 
     * @param {*} ITMAX 
     * @returns 
     */
    function contfractbeta(a,b,x, ITMAX = 1000){
         
        let EPS = 3.0e-7;
        let az = 1.0;
        let am = 1.0;
        let bm = 1.0;
        let qab = a + b;
        let qap = a + 1.0;
        let qam = a-1.0;
        let bz = 1.0 - qab*x/qap;
         
        //for i in range(ITMAX):
        for(let i =0; i<= ITMAX; i++){
            let em = parseFloat(i+1);
            let tem = em + em;
            let d = em*(b-em)*x/((qam+tem)*(a+tem));
            let ap = az + d*am;
            let bp = bz+d*bm;
            d = -(a+em)*(qab+em)*x/((qap+tem)*(a+tem));
            let app = ap+d*az;
            let bpp = bp+d*bz;
            let aold = az;
            am = ap/bpp;
            bm = bp/bpp;
            az = app/bpp;
            bz = 1.0;
            if (Math.abs(az-aold)<(EPS * Math.abs(az))){
                return az
            }
        }
    }

    /**
     * Evaluates factorial of a number
     * 
     * @param {Number} xf - Integer number 
     * @returns factorial of the number
     */
    function factorial(xf) {
        if ((xf == 0) || (xf == 1)) return 1;
        else {
            let result = (xf * factorial(xf - 1));
            return result
        }
    }

    /**
     * Evalues factorial for an integer or fraction using either either factorial or gamma function
     * 
     * @param {Number} a - integar or fraction number
     * @returns value of a gamma function
     */
    function gamma(a){
        let gamma;
        
        var qc = [75122.6331530, 80916.6278952, 36308.2951477, 8687.24529705, 1168.92649479, 83.8676043424, 2.50662827511];
        
        var sum1 = 0;
        var prod1 = 1;
        if (a == 0) { 
            gamma = 1e99; 
        }else {
            if ((a % 1) == 0) {//if integer
                gamma = factorial(a - 1);
            }
            else { //not integer
                for (let j = 0; j < qc.length; j++) {
                    sum1 = sum1 + qc[j] * Math.pow(a, j);
                    prod1 = prod1 * (a + j);
                }
                gamma = (sum1 * Math.pow((a + 5.5), (a + 0.5))) * Math.exp(-(a + 5.5)) / prod1;
            }
        }
        
        return gamma
    }

    /**
     * 
     * @param {Number} xg  - integar or fraction number
     * @returns natural log of gamma function
     */

    function lgamma(xg){
        return Math.log(gamma(xg))
    }

    function t_test_1_sample$1(mean, m, s, n) {
        if (s == 0) s = 1;
        var t = ((mean - m) / s) * Math.sqrt(n);
        var p = 1.0 - TdistributionCDF(Math.abs(t), (n - 1));
        return p
    }

    function t_test_2_samples$1(m1, s1, n1, m2, s2, n2) {
        if (s1 == 0) s1 = 1;
        if (s2 == 0) s2 = 1;
        var t = (m1 - m2) / Math.sqrt(s1 ** 2 / n1 + s2 ** 2 / n2);
        var df = ((s1 ** 2 / n1 + s2 ** 2 / n2) ** 2 * (n1 - 1) * (n2 - 1)) /
            ((s1 ** 4 * (n2 - 1)) / n1 ** 2 + (s2 ** 4 * (n1 - 1)) / n2 ** 2);

        var p = 1.0 - TdistributionCDF(Math.abs(t), parseInt(df + 0.5));

        return p
    }

    var t_dist = {TdistributionCDF, gamma, t_test_1_sample: t_test_1_sample$1, t_test_2_samples: t_test_2_samples$1};

    class CombinedCaller{
        constructor(wigFeatures, binSize) {
            this.wigFeatures = wigFeatures;
            this.binSize = binSize;
            // let fit_obj = this.get_fit()
            // this.globalMean = fit_obj.globalMean
            // this.globalStd = fit_obj.globalStd
        }
        get_fit(){
            var fit_info = new g_utils.GetFit(this.wigFeatures);
            var [globalMean, globalStd] = fit_info.fit_data();

            return {globalMean:globalMean, globalStd:globalStd}
           
        }
        async call_2d(omin=null, mcount=null, event_type="both", max_distance=0.1, baf_threshold=0, max_copy_number=10, min_cell_fraction=0.0){
            
            let fit_obj = this.get_fit();
            this.globalMean = fit_obj.globalMean;
            this.globalStd = fit_obj.globalStd;
            
            let overlap_min = omin==null ?  0.05 * this.binSize / 3e9: omin ;
            let min_count = mcount == null ? parseInt(this.binSize / 10000) : mcount ;

            let gstat_rd0 = [];
            let gstat_rd_all = [];
            let gstat_rd = [];
            let gstat_error = [];
            let gstat_lh = [];
            let gstat_n = [];
            
            for (const [chr, wig] of Object.entries(this.wigFeatures)) {
                let segments = [];
                let levels = [];
                let likelihoods = [];
                
                wig.forEach((bin, bin_idx) => {
                    if (bin.hets_count > 4 ){
                        
                        if( bin.dp_count > min_count ){
                            segments.push([bin_idx]);
                            levels.push(bin.binScore);
                            likelihoods.push(bin.likelihood_score);
                            delete bin.likelihood_score;
                            
                        }
                    }
                });

                let diff_level = [];
                for(let i=1; i<levels.length; i++){
                    diff_level.push(Math.abs(levels[i] - levels[i-1]));
                }
                let min_flank = [0];
                for(let i=1; i<diff_level.length; i++){
                    min_flank.push(Math.min(diff_level[i-1], diff_level[i]));    
                }
                min_flank.push(0);

                let error  = levels.map((x, x_idx) => {return Math.sqrt(Math.sqrt(x) ** 2 + this.globalStd ** 2 + Math.pow(min_flank[x_idx]/2, 2));});
                
                let overlaps = [];
                
                for(let i=0; i< segments.length-1; i++){
                    
                    let lh_overlap = 0;
                    try{
                        lh_overlap = likelihood_overlap(likelihoods[i], likelihoods[i+1]);
                    }catch{
                        console.log("Overlap failed: ", i, likelihoods[i], segments[i+1], likelihoods[i+1]);
                    }
                    
                    let rd_overlap = normal_overlap_approx(levels[i], error[i], levels[i+1], error[i+1]);
                    overlaps.push(rd_overlap * lh_overlap);
                    
                }
                
                while(overlaps.length >0) {
                    overlaps = overlaps.filter(num => typeof num === "number");
                    
                    let max_overlap = arrayMax(overlaps);
                    if(isNaN(max_overlap)){
                        console.log('NaN value', overlaps);
                    }
                    if(max_overlap < overlap_min){
                        // console.log("maxoverlap ",max_overlap,  "is smaller than overlap min")
                        break
                    }
                    let i = overlaps.indexOf(max_overlap);
                    
                    let merge_level = normal_merge(levels[i], error[i], levels[i + 1], error[i + 1]);
                    
                    let nlh;
                    let nlh_sum;
                    try{
                        nlh = likelihoods[i].map((l_value, l_idx) => { return l_value * likelihoods[i+1][l_idx]});
                    
                        nlh_sum = nlh.reduce((a, c_value) => {return a + c_value});
                        
                    }catch{
                        console.log(likelihoods);
                        console.log('max_overlap:', max_overlap, i, overlaps.length);
                        console.log('likelihood: ', i ,likelihoods[i], likelihoods[i+1]);
                        console.log('nlh: ', nlh_sum);
                    }
                    // nlh_sum = nlh.reduce((a, c_value) => {return a + c_value});

                    levels[i] = merge_level.nl;
                    error[i] = merge_level.ne;
                    
                    likelihoods[i] = nlh.map(function(item) { return item/nlh_sum } );
                    
                    segments[i].push(...segments[i+1]);

                    levels.splice(i + 1, 1);
                    error.splice(i + 1, 1);
                    segments.splice(i + 1, 1);
                    likelihoods.splice(i + 1, 1);
                    overlaps.splice(i, 1);
                    
                    if(i < overlaps.length){
                        
                        let rd_overlap = normal_overlap_approx(levels[i], error[i], levels[i+1], error[i+1]);
                        let new_overlap = rd_overlap * likelihood_overlap(likelihoods[i], likelihoods[i + 1]);
                        
                        overlaps[i] = new_overlap;
                    }
                    if(i > 0){
                        let new_overlap = normal_overlap_approx(levels[i - 1], error[i - 1], levels[i], error[i]) 
                        * likelihood_overlap(likelihoods[i - 1], likelihoods[i]);
                        overlaps[i - 1] = new_overlap;
                    }

                }
                let ons = -1;
                while(true){
                    overlaps = [];
                    for(let i=0; i< levels.length; i++){
                        for(let j=i; j<levels.length; j++){
                            if(segments[j][0] - segments[i].at(-1) < max_distance * (segments[i].length + segments[j].length)){
                                overlaps.push(normal_overlap_approx(levels[i], error[i], levels[j], error[j]) * likelihood_overlap(likelihoods[i], likelihoods[j]));
                            }
                        }
                    }
                    
                    if(overlaps.length == 0){
                        break
                    }
                    let max_overlap = arrayMax(overlaps);
                    if(max_overlap < overlap_min){
                        break
                    }
                    let i = 0; 
                    let j = 1;
                    while (i < segments.length - 1){
                        let overlap_value = normal_overlap_approx(levels[i], error[i], levels[j], error[j]) * likelihood_overlap(likelihoods[i], likelihoods[j]);

                        if((segments[j][0] - segments[i].at(-1)) < max_distance * (segments[i].length + segments[j].length) && overlap_value == max_overlap){
                            let merge_level = normal_merge(levels[i], error[i], levels[i + 1], error[i + 1]);

                            levels[i] = merge_level.nl;
                            error[i] = merge_level.ne;
                            let nlh = likelihoods[i].map((l_value, l_idx) => { return l_value * likelihoods[i+1][l_idx]});
                            let nlh_sum = nlh.reduce((a, c_value) => {return a + c_value});
                            likelihoods[i] = nlh.map(function(item) { return item/nlh_sum } );

                            
                            segments[i].push(...segments[i+1]);
                            segments[i] = segments[i].sort((a,b) => a-b);

                            levels.splice(j, 1);
                            error.splice(j, 1);
                            segments.splice(j, 1);
                            likelihoods.splice(j, 1);
                            
                            if(j >= segments.length){
                                i += 1;
                                j = i + 1;
                            }

                        }else {
                            j += 1;
                            if(j >= segments.length){
                                i += 1;
                                j = i + 1;
                            }
                        }
                    }
                    if(ons == segments.length){
                        break
                    }
                    ons = segments.length;
                }
                // console.log('final segments', segments)
                
                segments.forEach((seg_value, seg_idx) => {
                    let baf_info = likelihood_baf_pval(likelihoods[seg_idx]);
                    if(seg_value.length > 1){

                        seg_value.forEach((bin, bin_idx) =>{
                            gstat_rd_all.push(wig[bin]);
                            if(baf_info.mean <= baf_threshold){
                                gstat_rd0.push(wig[bin]);
                            }
                            wig[bin].segment_score = levels[seg_idx];
                        });
                        gstat_rd.push(levels[seg_idx]);
                        gstat_error.push(error[seg_idx]);
                        gstat_lh.push(likelihoods[seg_idx]);

                    }

                });

                continue
            }
            
            // Third stage for call
            
            // let data = gstat_rd0.lengthn == 0 ?  gstat_rd_all: gstat_rd0 ;
            
            let points = parseInt(1000 * (1 - min_cell_fraction));
            if(points == 0){
                points = 1;
            }
            let x = g_utils.linspace(min_cell_fraction, 1, points);
            let master_lh = {};
            let germline_lh = {};
            for(let cn=10; cn > -1; cn--){
                for(let h1=0; h1 < (cn/2+1); h1++){
                    let h2 = cn - h1;
                    let mrd = x.map((v, idx) => {return 1-v +v*cn/2});
                    let g_mrd = cn / 2;
                    let g_mbaf;
                    let mbaf;
                    if(cn > 0){
                        g_mbaf = 0.5 - (h1 / (h1 + h2));
                        mbaf = x.map((v, idx) => {return 0.5 - (1 - v + v * h1) / (2 - 2 * v + (h1 + h2) * v)});
                       
                    }else {
                        g_mbaf = 0;
                        mbaf =  x.map((v, idx) => {return 0*v});
                    }
                    
                    for( let ei=0; ei < gstat_rd.length; ei++){
                            
                        let g_lh = normal(g_mrd * this.globalMean, 1, gstat_rd[ei], gstat_error[ei]) * likelihood_of_baf(gstat_lh[ei], 0.5 + g_mbaf);
                        if(ei in germline_lh){
                            germline_lh[ei].push([cn, h1, h2, g_lh, 1.0]);
                        }else {
                            germline_lh[ei] = [cn, h1, h2, g_lh, 1.0];
                        }
                        let slh = 0;
                        let max_lh = 0;
                        let max_x = 0;
                        mrd.forEach((mi, idx) => {
                            if(!isNaN(mbaf[idx])){
                                let tmpl = normal(mi * this.globalMean, 1, gstat_rd[ei], gstat_error[ei]) * likelihood_of_baf(gstat_lh[ei], 0.5 + mbaf[idx]);
                                slh += tmpl;
                                if(tmpl > max_lh){
                                    max_lh = tmpl;
                                    max_x = x[idx];
                                }
                            }
                        });
                        if(ei in master_lh){
                            master_lh[ei].push([cn, h1, h2, slh / x.length, max_x]);
                        }else {
                            master_lh[ei] = [cn, h1, h2, slh / x.length, max_x];
                        }
                    }
                    
                    for( let ei=0; ei < gstat_rd.length; ei++){
                        if(event_type == "germline"){
                            master_lh[ei].sort((a, b) => a[3] - b[3]);
                        }
                        else {
                            master_lh[ei].sort((a, b) => a[3] - b[3]);
                            if(event_type == "both"){
                                
                                germline_lh[ei].sort((a, b) => a[3] - b[3]);
                                if(germline_lh[ei][0][3] > master_lh[ei][0][3]){
                                    //let tmp_list = list(filter( lambda x: x[0] != germline_lh[ei][0][0] and x[1] != germline_lh[ei][0][1], master_lh[ei]))
                                    let tmp_list = master_lh[ei].filter((x) => (x[0] != germline_lh[ei][0][0]) && (x[1] <= germline_lh[ei][0][1]));
                                    // console.log('tmp_list', tmp_list)
                                    // master_lh[ei] = [germline_lh[ei][0]] + tmp_list
                                    master_lh[ei] = [germline_lh[ei][0]].push(...tmp_list);
                                }
                            }
                        }
                    }
                    for( let ei=0; ei < gstat_rd.length; ei++){
                        if(master_lh[ei][0][0] > 2);
                        if(master_lh[ei][0][0] < 2);
                        gstat_rd[ei] / this.globalMean;
                        t_dist.t_test_1_sample(this.globalMean, gstat_rd[ei], gstat_error[ei], gstat_n[ei]);
                        // console.log(etype)

                    }
                    

                    // break
                }
                
            }
            
            var rawbinScore = this.formatDataStructure(this.wigFeatures, 'binScore', this.globalMean);
            var callScore = this.formatDataStructure(this.wigFeatures, 'segment_score', this.globalMean);
            
            return {binScore: rawbinScore, segment_score: callScore}
            
        }

        formatDataStructure(wigFeatures, feature_column, scaling_factor = 1) {
            const results = [];
            for (const [chr, wig] of Object.entries(wigFeatures)) {

                wig.forEach(sample => {
                    var new_sample = { ...sample };
                    if (scaling_factor != 1) {
                        new_sample.value = sample[feature_column] / scaling_factor * 2;
                    }
                    results.push(new_sample);
                });
            }

            return results
        }

        formatDataStructure_BAF(feature_column, scaling_factor = 2) {
            const baf1 = [];
            const baf2 = [];
            for (const [chr, wig] of Object.entries(this.wigFeatures)) {

                wig.forEach(sample => {
                    
                    var baf1_value = { ...sample };
                    var baf2_value = { ...sample };
                    
                    let value = sample[feature_column];
                    if (value != 0.5){
                        baf2_value.value = -2 * (1 - value);
                        baf2.push(baf2_value);
                    }
                    baf1_value.value = -2 * value;
                    baf1.push(baf1_value);
                        
                });
            }
            

            return [baf1, baf2]
        }
    }

    function arrayMax(arr) {
        return arr.reduce(function (p, v) {
          return ( p > v ? p : v );
        });
      }

    /**
     * Normal distribution.
     * 
     * @param {float} x - Variable.
     * @param {float} a - area
     * @param {float} x0 -  Mean value
     * @param {float} sigma - Sigma
     * @returns {float} - Value of distribution in x.
     */
    function normal(x, a, x0, sigma){
      
      return a * Math.exp(-1* (x - x0) ** 2 / (2 * sigma ** 2)) / Math.sqrt(2 * Math.PI) / sigma

    }

    /**
     *  Calculates two normal distributions overlap area.
     * 
     * @param {float} m1 - Mean value of the first distribution
     * @param {float} s1 - Sigma of the first distribution
     * @param {float} m2 - Mean value for second distribution
     * @param {float} s2 - Sigma of the second distribution
     * 
     * @returns {float} area - Area of overlap
     */
    function normal_overlap_approx(m1, s1, m2, s2){
       
        return Math.exp(-1* (m1-m2)**2/ (s1**2+s2**2))
    }


    /**
     * Returns overlap area of two likelihood functions.
     * 
     * @param {*} lk1 - First likelihood function.
     * @param {*} lk2 - Second likelihood function.
     * 
     * @returns {float}  - Overlap area.
     */
    function likelihood_overlap(likelihood_1, likelihood_2){
        let sum;
        try{
            sum = likelihood_1.reduce((accumulator, currentValue, currentIndex) => {return accumulator + Math.min(currentValue, likelihood_2[currentIndex])});
        }catch{
            console.log("Failed to find likelihood overlap: ", likelihood_1, likelihood_2);
            return 0
        }

        return sum
    }

    /**
     * Calculates normal distribution that is product of two given normal distributions.
     * 
     * @param {float} m1 - Mean value of the first distribution
     * @param {float} s1 - Sigma of the first distribution
     * @param {float} m2 - Mean value for second distribution
     * @param {float} s2 - Sigma of the second distribution
     * @returns {Object} An object representing the first distribution
     * @property {float} nl - Mean value of the first distribution
     * @property {float} ne - Sigma of the first distribution
     */
    function normal_merge(m1, s1, m2, s2){
       
        if((s1 == 0) && (s2 == 0)){
            return {nl: 0.5 * (m1 + m2), ne: 0}
        }
        else {
            return {nl: (m1 * s2 * s2 + m2 * s1 * s1) / (s1 * s1 + s2 * s2), ne: Math.sqrt(s1 * s1 * s2 * s2 / (s1 * s1 + s2 * s2))}
        }
    }

    /**
     * Calculates likelihood for given baf
     * @param {*} likelihood 
     * @param {*} baf 
     * @returns {float}  likelihood value
     */
    function likelihood_of_baf(likelihood, baf){
       
        let bin = parseInt(baf * (likelihood.length - 1));
        let fr = baf * (likelihood.length - 1) - bin;
        if(bin < likelihood.length - 1){
            return likelihood[bin] * (1 - fr) + likelihood[bin + 1] * fr
        }
        else {
            return likelihood[bin]
        }
    }

    /**
     * 
     * Calculates baf level and p-value for given likelihood function.
     * 
     * @param {*} likelihood 
     * @returns {Object} An object representing BAF
     * @property {float} mean  BAF level (difference from 1/2)
     * @property {float} p  p-value for event different than 1/2
     */
    function likelihood_baf_pval(likelihood) {
        const res = likelihood.length;
        const max_lh = Math.max(...likelihood);
        let ix = likelihood.indexOf(max_lh);
        if (ix > Math.floor(res / 2)) {
          ix = res - 1 - ix;
        }
        const b = (res / 2 - ix) / (res + 1);
      
        const ix1 = Math.floor((res / 2 + ix) / 2);
        const ix2 = res - 1 - ix1;
        let p = likelihood.slice(ix1, ix2 + 1).reduce((acc, val) => acc + val, 0) / likelihood.reduce((acc, val) => acc + val, 0);
        if (ix === Math.floor(res / 2)) {
          p = 1.0;
        }
        return {mean:b, p:p};
      }

      var combined_caller = {CombinedCaller};

    function erf(x) {
        var m = 1.0, s = 1.0, sum = x * 1.0;
        for (var i = 1; i < 50; i++) {
            m *= i;
            s *= -1;
            sum += (s * Math.pow(x, 2.0 * i + 1.0)) / (m * (2.0 * i + 1.0));
        }
        return (2 * sum) / Math.sqrt(3.14159265358979)
    }

    function getEValue(mean, sigma, rd, start, end) {
        var arr = new DataStat(rd.slice(start, end));
        if (arr.std == 0) {
            if (sigma > 0) { arr.std = (sigma * arr.mean) / mean; }
            else { arr.std = 1; }
        }
        var p_val = t_test_1_sample(mean, arr.mean, arr.std, end - start) / (end - start);
        return p_val
    }

    function gaussianEValue(mean, sigma, rd, start, end) {
        var arr = new DataStat(rd.slice(start, end));

        if (arr.mean < mean) {
            var x = (arr.max - arr.mean) / (sigma * Math.sqrt(2));
            return Math.pow(0.5 * (1 + erf(x)), end - start)
        }
        var x = (arr.min - arr.mean) / (sigma * Math.sqrt(2));
        return Math.pow(0.5 * (1 - erf(x)), end - start)
    }

    function adjustToEvalue(mean, sigma, rd, start, end, pval, max_steps = 1000) {
        var val = getEValue(mean, sigma, rd, start, end);
        var step = 0, done = false;
        while ((val > pval) & !done & (step < max_steps)) {
            done = true;
            step += 1;
            var [v1, v2, v3, v4] = [1e10, 1e10, 1e10, 1e10];
            if (start > 0) v1 = getEValue(mean, sigma, rd, start - 1, end);
            if (end - start > 2) {
                var v2 = getEValue(mean, sigma, rd, start + 1, end);
                var v3 = getEValue(mean, sigma, rd, start, end - 1);
            }
            if (end < rd.length) { var v4 = getEValue(mean, sigma, rd, start, end + 1); }
            if (Math.min[(v4)] < val) {
                done = false;
                if (v1 == Math.min[(v4)]) {
                    start -= 1;
                    val = v1;
                }
                elif(v2 == Math.min[(v4)]); {
                    start += 1;
                    val = v2;
                }
                elif(v3 == Math.min[(v4)]); {
                    end -= 1;
                    val = v3;
                }
                elif(v4 == Math.min[(v4)]); {
                    end += 1;
                    val = v4;
                }
            }
        }
        if (val <= pval) { return end }
        return 0;
    }

    class DataStat {
        constructor(data_array) {
            this.data = data_array;
            this.mean = data_array.reduce((acc, n) => acc + n) / data_array.length;
            this.std = Math.sqrt(data_array.reduce((acc, n) => (n - this.mean) ** 2) / data_array.length);
        }
    }

    function t_test_1_sample(mean, m, s, n) {
        if (s == 0) s = 1;
        var t = ((mean - m) / s) * Math.sqrt(n);
        var p = 1.0 - t_dist.TdistributionCDF(Math.abs(t), (n - 1));
        return p
    }

    function t_test_2_samples(m1, s1, n1, m2, s2, n2) {
        if (s1 == 0) s1 = 1;
        if (s2 == 0) s2 = 1;
        var t = (m1 - m2) / Math.sqrt(s1 ** 2 / n1 + s2 ** 2 / n2);
        var df = ((s1 ** 2 / n1 + s2 ** 2 / n2) ** 2 * (n1 - 1) * (n2 - 1)) /
            ((s1 ** 4 * (n2 - 1)) / n1 ** 2 + (s2 ** 4 * (n1 - 1)) / n2 ** 2);

        var p = 1.0 - t_dist.TdistributionCDF(Math.abs(t), parseInt(df + 0.5));

        return p
    }

    class Partition {

        constructor(rd, mean, std) {
            this.rd = rd;
            this.mean = mean;
            this.std = std;
            this.bin_bands = [2, 3, 4, 5, 6, 7, 8, 10, 12, 14, 16, 20, 24, 28, 32, 40, 48, 56, 64, 80, 96, 112, 128];
        }

        get_rd_signal_bandwidth(data_array) {
            var new_array = [];

            data_array.forEach((value, index) => {
                var tmp_value = 0;
                if (value > this.mean / 4) {
                    tmp_value = this.mean / (this.std ** 2 * value);
                } else {
                    tmp_value = 4 / this.std ** 2;
                }
                new_array.push(tmp_value);
            });
            return new_array
        }

        meanShiftCaller(repeats = 3) {
            var ChrLevels = {};
            
            Object.entries(this.rd).forEach(([chr, chr_rd]) => {
                var masked = new Array(chr_rd.length).fill(false);

                // set the level
                var levels = new Array(chr_rd.length);

                for (let b = 0; b < chr_rd.length; b++) {
                    if (!masked[b]) { levels[b] = chr_rd[b]; }
                }

                this.bin_bands.forEach((bin_band, bin_band_index) => {
                    // not masked levels at current bin
                    // get boolean values
                    var not_masked = masked.map((value, index) => { return !value; });

                    // not masked level at current bin
                    var nm_levels = [];

                    Object.entries(chr_rd).forEach(([k, v]) => { nm_levels.push(v.binScore); });
                    
                    // set the mask border
                    var mask_borders = [0];
                    var count = 0;

                    for (let i = 0; i < masked.length; i++) {
                        if (masked[i]) {
                            if (count > 0) {
                                mask_borders.push(mask_borders[mask_borders.length - 1] + count - 1);
                                count = 0;
                            }
                        } else { count += 1; }
                    }

                    mask_borders.shift();

                    // repeating steps
                    for (let step = 0; step < repeats; step++) {
                        var isig = this.get_rd_signal_bandwidth(nm_levels);
                        var grad = new Array(nm_levels.length).fill(0);

                        for (let i = 0; i < nm_levels.length; i++) {
                            for (let j = i - 3 * bin_band; j <= i + 3 * bin_band + 1; j++) {
                                if (j < 0 || j >= nm_levels.length) continue;
                                if (Math.abs(i - j) >= nm_levels.length) continue;

                                var g_value = (j - i) * Math.exp((-0.5 * (j - i) ** 2) / bin_band ** 2) *
                                    Math.exp(-0.5 * (nm_levels[i] - nm_levels[j]) ** 2 * isig[i]);

                                grad[i] += g_value;
                            }
                        }
                        
                        // get the border
                        var border = new Array();
                        for (var i = 0; i < grad.length - 1; i++) {
                            if ((grad[i] < 0) & (grad[i + 1] >= 0)) border.push(i);
                        }

                        border.push(grad.length - 1);
                        border = border.concat(mask_borders).sort((a, b) => a - b);
                        border = Array.from(new Set(border));

                        var pb = 0;
                        for (var i = 0; i < border.length; i++) {
                            var range_array = nm_levels.slice(pb, border[i] + 1);
                            var range_mean = range_array.reduce((acc, n) => acc + n) / range_array.length;

                            nm_levels.fill(range_mean, pb, border[i] + 1);
                            pb = border[i] + 1;
                        }
                    }

                    for (var i = 0, j = 0; i < levels.length; i++) {
                        if (not_masked[i]) {
                            levels[i] = nm_levels[j];
                            j++;
                        }
                    }

                    //get the border
                    var border = new Array();
                    for (var i = 0; i < levels.length - 1; i++) {
                        //if(i == levels.length -1) continue;
                        var diff = Math.abs(levels[i + 1] - levels[i]);

                        if (diff > 0.01) border.push(i + 1);
                    }

                    border.unshift(0);
                    border.push(levels.length);

                    // reset the mask
                    masked = new Array(this.rd.length).fill(false);

                    // check the borders
                    for (var i = 1; i < border.length; i++) {
                        var seg = [border[i - 1], border[i]];
                        var seg_left = [border[i - 1], border[i - 1]];
                        if (i > 1) { seg_left[0] = border[i - 2]; } else continue;

                        var seg_right = [border[i], border[i]];
                        if (i < border.length - 1) { seg_right[1] = border[i + 1]; } else continue;

                        var n = seg[1] - seg[0];
                        var n_left = seg_left[1] - seg_left[0];
                        var n_right = seg_right[1] - seg_right[0];
                        if (n <= 1) continue;
                        var seg_array = new DataStat(levels.slice(seg[0], seg[1]));

                        if (n_right <= 15 || n_left <= 15 || n <= 15) {
                            var ns = 1.8 * Math.sqrt(levels[seg_left[0]] / this.mean) * this.std;
                            if (Math.abs(levels[seg_left[0]] - levels[seg[0]]) < ns) { continue }

                            ns = 1.8 * Math.sqrt(levels[seg_right[0]] / this.mean) * this.std;
                            if (Math.abs(levels[seg_right[0]] - levels[seg[0]]) < ns) { continue }
                        } else {
                            var seg_left_array = levels.slice(seg_left[0], seg_left[1]);
                            var seg_left_1 = new DataStat(seg_left_array);

                            var seg_right_array = levels.slice(seg_right[0], seg_right[1]);
                            var seg_right_1 = new DataStat(seg_right_array);

                            var ttest_2sample_1 = t_test_2_samples(seg_array.mean, seg_array.std, seg_array.data.length,
                                seg_left_1.mean, seg_left_1.std, seg_left_1.data.length);
                            if (ttest_2sample_1 > (0.01 / genome_size) * bin_size * (n + n_left)) { continue }

                            var ttest_2sample_2 = t_test_2_samples(seg_array.mean, seg_array.std, seg_array.data.length,
                                seg_right_1.mean, seg_right_1.std, seg_right_1.data.length);
                            if (ttest_2sample_2 > (0.01 / genome_size) * bin_size * (n + n_right)) { continue }
                        }

                        var ttest_1sample_1 = t_test_1_sample(this.mean, seg_array.mean, seg_array.std, seg_array.data.length);
                        if (ttest_1sample_1 > 0.05) { continue }
                        let segments_rd = nm_levels.slice(seg[0], seg[1]);
                        var raw_seg_data = new DataStat(segments_rd);

                        masked.fill(true, seg[0], seg[1]);
                        levels.fill(raw_seg_data.mean, seg[0], seg[1]);
                    }
                });

                ChrLevels[chr] = levels;

            });
            return ChrLevels
        }
        call_mean_shift(repeats = 3) {
            const bin_size = 1000;
            // const genome_size = bin_size * this.rd.length;
            const genome_size = 2871000000;
            var masked = new Array(this.rd.length).fill(false);

            // set the level
            var levels = new Array(this.rd.length);
            for (var b = 0; b < this.rd.length; b++) {
                if (!masked[b]) {
                    levels[b] = this.rd[b];
                }
            }
            this.bin_bands.forEach((bin_band, bin_band_index) => {
                // not masked levels at current bin
                // get boolean values
                var not_masked = masked.map((value, index) => {
                    return !value;
                });

                // not masked level at current bin
                // var nm_levels = not_masked.map((value, index) => {if(value) return this.rd[index]});
                var nm_levels = [];
                not_masked.forEach((value, index) => {
                    if (value) nm_levels.push(this.rd[index]);
                });

                // console.log(bin_band, nm_levels);

                // set the mask border
                var mask_borders = [0];
                var count = 0;

                for (var i = 0; i < masked.length; i++) {
                    if (masked[i]) {
                        if (count > 0) {
                            mask_borders.push(
                                mask_borders[mask_borders.length - 1] + count - 1,
                            );
                            count = 0;
                        }
                    } else {
                        count += 1;
                    }
                }

                mask_borders.shift();
                // repeating steps
                for (var step = 0; step < repeats; step++) {
                    var isig = this.get_rd_signal_bandwidth(nm_levels);
                    // console.log(isig);
                    var grad = new Array(nm_levels.length).fill(0);

                    for (var i = 0; i < nm_levels.length; i++) {
                        for (var j = i - 3 * bin_band; j <= i + 3 * bin_band + 1; j++) {
                            if (j < 0 || j >= nm_levels.length) continue;
                            if (Math.abs(i - j) >= nm_levels.length) continue;

                            var g_value =
                                (j - i) *
                                Math.exp((-0.5 * (j - i) ** 2) / bin_band ** 2) *
                                Math.exp(-0.5 * (nm_levels[i] - nm_levels[j]) ** 2 * isig[i]);
                            // console.log(g_value);
                            grad[i] += g_value;
                        }
                    }
                    // console.log(grad);

                    // get the border
                    var border = new Array();
                    for (var i = 0; i < grad.length - 1; i++) {
                        if ((grad[i] < 0) & (grad[i + 1] >= 0)) border.push(i);
                    }

                    border.push(grad.length - 1);
                    border = border.concat(mask_borders).sort((a, b) => a - b);
                    border = Array.from(new Set(border));

                    var pb = 0;
                    for (var i = 0; i < border.length; i++) {
                        var range_array = nm_levels.slice(pb, border[i] + 1);
                        var range_mean =
                            range_array.reduce((acc, n) => acc + n) / range_array.length;

                        nm_levels.fill(range_mean, pb, border[i] + 1);
                        pb = border[i] + 1;
                    }
                }

                for (var i = 0, j = 0; i < levels.length; i++) {
                    if (not_masked[i]) {
                        levels[i] = nm_levels[j];
                        j++;
                    }
                }

                //get the border
                var border = new Array();
                for (var i = 0; i < levels.length - 1; i++) {
                    //if(i == levels.length -1) continue;
                    var diff = Math.abs(levels[i + 1] - levels[i]);

                    if (diff > 0.01) border.push(i + 1);
                }

                border.unshift(0);
                border.push(levels.length);

                // reset the mask
                masked = new Array(this.rd.length).fill(false);

                // check the borders
                for (var i = 1; i < border.length; i++) {
                    var seg = [border[i - 1], border[i]];
                    var seg_left = [border[i - 1], border[i - 1]];
                    if (i > 1) {
                        seg_left[0] = border[i - 2];
                    } else continue;

                    var seg_right = [border[i], border[i]];
                    if (i < border.length - 1) {
                        seg_right[1] = border[i + 1];
                    } else continue;

                    var n = seg[1] - seg[0];
                    var n_left = seg_left[1] - seg_left[0];
                    var n_right = seg_right[1] - seg_right[0];
                    if (n <= 1) continue;
                    var seg_array = new DataStat(levels.slice(seg[0], seg[1]));

                    if (n_right <= 15 || n_left <= 15 || n <= 15) {
                        var ns = 1.8 * Math.sqrt(levels[seg_left[0]] / this.mean) * this.std;
                        if (Math.abs(levels[seg_left[0]] - levels[seg[0]]) < ns) {
                            continue;
                        }

                        ns = 1.8 * Math.sqrt(levels[seg_right[0]] / this.mean) * this.std;
                        if (Math.abs(levels[seg_right[0]] - levels[seg[0]]) < ns) {
                            continue;
                        }
                    } else {
                        var seg_left_array = levels.slice(seg_left[0], seg_left[1]);
                        var seg_left_1 = new DataStat(seg_left_array);

                        var seg_right_array = levels.slice(seg_right[0], seg_right[1]);
                        var seg_right_1 = new DataStat(seg_right_array);

                        var ttest_2sample_1 = t_test_2_samples(
                            seg_array.mean,
                            seg_array.std,
                            seg_array.data.length,
                            seg_left_1.mean,
                            seg_left_1.std,
                            seg_left_1.data.length,
                        );
                        if (
                            ttest_2sample_1 >
                            (0.01 / genome_size) * bin_size * (n + n_left)
                        ) {
                            continue;
                        }

                        var ttest_2sample_2 = t_test_2_samples(
                            seg_array.mean,
                            seg_array.std,
                            seg_array.data.length,
                            seg_right_1.mean,
                            seg_right_1.std,
                            seg_right_1.data.length,
                        );
                        if (
                            ttest_2sample_2 >
                            (0.01 / genome_size) * bin_size * (n + n_right)
                        ) {
                            continue;
                        }
                    }

                    var ttest_1sample_1 = t_test_1_sample(
                        this.mean,
                        seg_array.mean,
                        seg_array.std,
                        seg_array.data.length,
                    );
                    if (ttest_1sample_1 > 0.05) {
                        continue;
                    }
                    var raw_seg_data = new DataStat(this.rd.slice(seg[0], seg[1]));

                    masked.fill(true, seg[0], seg[1]);
                    levels.fill(raw_seg_data.mean, seg[0], seg[1]);
                }
            });
            return levels;
        }

        cnv_calling(bin_size = 100000) {
            var delta = 0.25;
            var delta = delta * this.mean;

            var min = this.mean - delta, max = this.mean + delta;
            // console.log('min: ', min, ', Max: ', max)

            // console.log('delta', delta)
            var normal_genome_size = 2971000000;

            var levels = this.meanShiftCaller();

            
            var merged_level = {};
            var cnv_levels = [];
            // var t_value = cdf(Math.abs(10), (5)) 
            // console.log('Testing student t test:', t_value)

            Object.entries(levels).forEach(([chr, chr_levels]) => {
                
                var done = false;
                while (!done) {
                    done = true;

                    //
                    // get the borders
                    //
                    var borders = new Array(1).fill(0);
                    for (let i = 0; i < chr_levels.length - 1; i++) {
                        var diff = Math.abs(chr_levels[i + 1] - chr_levels[i]);
                        if (diff > 0.01) borders.push(i + 1);
                    }
                    borders.push(chr_levels.length);

                    for (let ix = 0; ix < borders.length - 2; ix++) {
                        var v1 = Math.abs(chr_levels[borders[ix]] - chr_levels[borders[ix + 1]]);
                        // console.log(ix, v1);
                        if (v1 < delta) {
                            var v2 = v1 + 1, v3 = v1 + 1;

                            if (ix > 0) { v2 = Math.abs(chr_levels[borders[ix]] - chr_levels[borders[ix - 1]]); }
                            if (ix < borders.length - 3) { v3 = Math.abs(levels[borders[ix + 1]] - chr_levels[borders[ix + 2]]); }

                            if (v1 < v2 && v1 < v3) {
                                done = false;

                                var tmp_array = new DataStat(chr_levels.slice(borders[ix], borders[ix + 2]));
                                chr_levels.fill(tmp_array.mean, borders[ix], borders[ix + 2]);
                                borders.splice(ix + 1, ix + 1);
                            }
                        }
                    }
                }
                // console.log('updated levels', chr_levels)

                // var chr_rd = this.rd[chr]
                var chr_rd = [];
                Object.entries(this.rd[chr]).forEach(([bin, binDict]) => { chr_rd.push(binDict.binScore); });
                // console.log('cnv_calling', chr_rd)

                //
                // Calling Segments
                //

                //var flags = [""] * levels.length;
                var flags = new Array(chr_levels.length).fill("");

                // console.log('default levels', chr, chr_levels)
                var b = 0;
                var pval = (0.05 * bin_size) / normal_genome_size;
                while (b < chr_levels.length) {
                    var b0 = b, border_start = b;
                    while ((b < chr_levels.length) & (chr_levels[b] < min)) {
                        b += 1;
                    }
                    var border_end = b;

                    if (border_end > border_start + 1) {
                        // console.log('border min', border_start, border_end)
                        var adj = adjustToEvalue(this.mean, this.std, chr_rd, border_start, border_end, pval);
                        // console.log(adj)
                        if (adj) {
                            var border_start, border_end = adj;
                            flags.fill("D", border_start, border_end);
                        }
                    }
                    border_start = b;
                    while ((b < chr_levels.length) & (chr_levels[b] > max)) { b += 1; }
                    border_end = b;

                    if (border_end > border_start + 1) {
                        adj = adjustToEvalue(this.mean, this.std, chr_rd, border_start, border_end, pval);
                        // console.log(adj)
                        if (adj) {
                            (border_end = adj);
                            // flags[bs:be] = ["A"] * (be - bs)
                            flags.fill("A", border_start, border_end);
                        }
                    }
                    if (b == b0) b += 1;
                }

                //console.log(chr, 'segments', segments)
                //
                //  Calling additional deletions
                //
                b = 0;
                while (b < chr_levels.length) {
                    while ((b < chr_levels.length) & (flags[b] != "")) b += 1;
                    border_start = b;
                    while ((b < chr_levels.length) & (chr_levels[b] < min)) b += 1;
                    border_end = b;
                    if (border_end > border_start + 1) {
                        if (gaussianEValue(this.mean, this.std, chr_rd, border_start, border_end) < 0.05 / normal_genome_size) {
                            flags.fill(["d"] * (border_end - border_start), border_start, border_end);
                        }
                        b -= 1;
                    }
                    b += 1;
                }

                b = 0;
                var cf;
                if (b < chr_levels.length) cf = flags[b];

                border_start = 0;

                //var merge = [...this.rd]
                var merge = [...chr_rd];
                // console.log('initial merge', merge)
                while (b < chr_levels.length) {
                    while (flags[b] == cf) {
                        b += 1;
                        if (b >= flags.length) break;
                    }
                    if (b > border_start) {
                        var merge_arr = new DataStat(merge.slice(border_start, b));
                        merge.fill(merge_arr.mean, border_start, b);
                    }
                    if (b < chr_levels.length) cf = flags[b];
                    border_start = b;
                }

                merged_level[chr] = merge;


                //
                // calculate calls
                // 
                b = 0;
                while (b < chr_levels.length) {
                    cf = flags[b];
                    if (cf == "") {
                        b += 1;
                        continue
                    }
                    border_start = b;
                    while (b < chr_levels.length & cf == flags[b]) { b += 1; }
                    var border_arr = new DataStat(merge.slice(border_start, b));
                    let cnv = border_arr.mean / this.mean;
                    let event_type;
                    if (cf == "D") {
                        event_type = "deletion";
                    } else {
                        event_type = "duplication";
                    }
                    let cnv_dict = {
                        chr: chr,
                        start: bin_size * border_start + 1,
                        end: bin_size * b,
                        size: bin_size * (b - border_start + 1),
                        value: cnv * 2,
                        event_type: event_type
                    };
                    cnv_levels.push(cnv_dict);

                }
            });

            return [merged_level, cnv_levels]
        }
    }



    var read_depth_caller = { Partition };

    class CNVpytorVCF {
        constructor(allVariants, binSize) {
            this.allVariants = allVariants;
            this.rowBinSize = 10000;
            this.binSize = binSize;
            this.binFactor = binSize / this.rowBinSize;

        }

        async computeDepthFeatures() {

            const chromosomes = Object.keys(this.allVariants);
            const wigFeatures = [];

            for (let chr of chromosomes) {
                const variants = this.allVariants[chr];
                if (variants.length === 0) continue

                const firstSnp = variants[0];

                let sum = 0;
                let count = 0;
                let binStart = firstSnp.start = firstSnp.start % this.binSize;   // Place start at integer multiple of binSize
                let binEnd = binStart + this.binSize;
                let featureBin = 0;

                for (let snp of variants) {
                    const position = snp.start + 1;    // Convert from 0-base to 1-base coords
                    featureBin = Math.max(Math.floor((snp.start - 1) / this.binSize), 0);
                    if (position > binEnd) {

                        if (count > 0) {
                            wigFeatures.push({ chr, start: binStart, end: binEnd, value: sum, bin: featureBin, count: count });
                        }

                        // Start new bin
                        sum = 0;
                        //count = 0
                        binStart = snp.start - snp.start % this.binSize;
                        binEnd = binStart + this.binSize;
                    }

                    const dpValue = snp.calls[9].info["DP"];
                    // const dpValue = snp.getInfo("DP")

                    if (dpValue) {
                        sum += Number.parseInt(dpValue);
                        count++;
                    }
                }

                // final bin
                if (count > 0) {
                    wigFeatures.push({ chr, start: binStart, end: binEnd, value: sum, bin: featureBin, count: count });
                }
            }

            return wigFeatures
        }

        // for for read depth calculation
        async computeReadDepth() {
            const chromosomes = Object.keys(this.allVariants);
            var wigFeatures = {};

            for (let chr of chromosomes) {
                const variants = this.allVariants[chr];
                var featureBin;
                if (variants.length === 0) continue
                for (let snp of variants) {
                    featureBin = Math.max(Math.floor(snp.start / this.rowBinSize), 0);
                    if (!wigFeatures[chr]) { wigFeatures[chr] = []; }
                    if (!wigFeatures[chr][featureBin]) {

                        wigFeatures[chr][featureBin] = {
                            chr,
                            start: featureBin * this.rowBinSize,
                            end: (featureBin + 1) * this.rowBinSize,
                            value: 0,
                            sum_score: 0,
                            count: 0,
                        };
                    }
                    const dpValue = snp.calls[9].info["DP"];
                    if (dpValue) {
                        // sum += Number.parseInt(dpValue)
                        wigFeatures[chr][featureBin].sum_score += Number.parseInt(dpValue);
                        wigFeatures[chr][featureBin].count++;
                    }

                }
                // for last bin
                //let last_bin = wigFeatures[chr][featureBin]
                //last_bin.value = parseInt(last_bin.sum_score / last_bin.count) * 100
            }

            // adjust the bin values to actual bin size
            var avgbin = {};
            for (let chr of chromosomes) {
                if (!avgbin[chr]) { avgbin[chr] = []; }
                for (let k = 0; k < wigFeatures[chr].length / this.binFactor; k++) {
                    const featureBin = k;
                    if (!avgbin[chr][k]) {
                        avgbin[chr][k] = {
                            chr,
                            binScore: 0,
                            start: featureBin * this.binSize,
                            end: (featureBin + 1) * this.binSize,
                        };
                    }

                    for (var j = k * 10; j < 10 * k + 10; j++) {
                        if (wigFeatures[chr][j]) {
                            var tmp_score = parseInt(wigFeatures[chr][j].sum_score / wigFeatures[chr][j].count) * 100;
                            avgbin[chr][k].binScore += tmp_score;
                        }
                    }
                }
            }

            var finalFeatureSet = this.readDepthMeanshift(avgbin);
            return finalFeatureSet

        }
        readDepthMeanshift(wigFeatures) {

            // Get global mean and standrad deviation
            var fit_info = new g_utils.GetFit(wigFeatures);
            var [globamMean, globalStd] = fit_info.fit_data();

            // Apply partition method
            var partition = new read_depth_caller.Partition(wigFeatures, globamMean, globalStd);
            var partition_array = partition.meanShiftCaller();
            var caller_array = partition.cnv_calling();

            // Assign the partition values to each bin
            Object.entries(wigFeatures).forEach(([chr, chr_rd]) => {
                chr_rd.forEach((bin, index) => {
                    bin.partition_level = parseInt(partition_array[chr][index]);
                    bin.partition_call = parseInt(caller_array[0][chr][index]);
                });
            });

            var rawbinScore = this.formatDataStructure(wigFeatures, 'binScore', globamMean);
            var partition_levels = this.formatDataStructure(wigFeatures, 'partition_level', globamMean);
            var partition_call = this.formatDataStructure(wigFeatures, 'partition_call', globamMean);

            return [rawbinScore, partition_levels, partition_call, caller_array[1]]

        }
        formatDataStructure(wigFeatures, feature_column, scaling_factor = 1) {
            const results = [];
            for (const [chr, wig] of Object.entries(wigFeatures)) {

                wig.forEach(sample => {
                    var new_sample = { ...sample };
                    if (scaling_factor != 1) {
                        new_sample.value = sample[feature_column] / scaling_factor * 2;
                    }
                    results.push(new_sample);
                });
            }

            return results
        }

        async computeBAF_v2() {

            const chromosomes = Object.keys(this.allVariants);
            const wigFeatures = {};
            const baf1 = [], baf2 = [];

            for (let chr of chromosomes) {
                const variants = this.allVariants[chr];
                if (variants.length === 0) continue
                var featureBin;
                for (let snp of variants) {
                    featureBin = Math.max(Math.floor(snp.start / this.binSize), 0);

                    if (!wigFeatures[chr]) {
                        wigFeatures[chr] = [];
                    }
                    if (!wigFeatures[chr][featureBin]) {
                        if (featureBin > 0) {
                            // calculating the BAF likelihood for previous bin
                            let previous_featureBin = featureBin - 1;
                            if (wigFeatures[chr][previous_featureBin]) {

                                const updated_bin = this.get_max_min_score(wigFeatures[chr][previous_featureBin]);

                                if (updated_bin.value != 0.5) {
                                    let baf_wig = Object.assign({}, updated_bin);
                                    baf_wig.value = -2 * (1 - updated_bin.value);
                                    baf2.push(baf_wig);
                                }
                                updated_bin.value = - 2 * updated_bin.value;
                                wigFeatures[chr][previous_featureBin] = updated_bin;

                                baf1.push(wigFeatures[chr][previous_featureBin]);

                            }
                        }
                        wigFeatures[chr][featureBin] = {
                            chr,
                            start: featureBin * this.binSize,
                            end: (featureBin + 1) * this.binSize,
                            value: 0,
                            count: 0,
                            likelihood_score: [],
                            min_score: 0,
                        };
                    }
                    const calls = snp.calls[9];
                    let genotype = calls.genotype;
                    let ad_score = calls.info["AD"].split(',');
                    let ad_a = ad_score[0], ad_b = ad_score[1];

                    if ((genotype[0] == 0 && genotype[1] == 1) || (genotype[0] == 1 && genotype[1] == 0)) {
                        //apply the beta function
                        if (wigFeatures[chr][featureBin].likelihood_score.length == 0) {
                            wigFeatures[chr][featureBin].likelihood_score = g_utils.linspace(0, 1, 100).map((value, index) => {
                                return beta(ad_a, ad_b, value);
                            });
                        } else {
                            var sum = 0;

                            wigFeatures[chr][featureBin].likelihood_score = g_utils.linspace(0, 1, 100).map((value, index) => {
                                var likelihood_value = wigFeatures[chr][featureBin].likelihood_score[index] * beta(ad_a, ad_b, value);
                                sum = sum + likelihood_value;
                                return likelihood_value;
                            });

                            wigFeatures[chr][featureBin].likelihood_score = g_utils.linspace(0, 1, 100).map((value, index) => {
                                return wigFeatures[chr][featureBin].likelihood_score[index] / sum;
                            });
                        }
                        wigFeatures[chr][featureBin].count++;
                    }
                }

                // last feature bin
                const updated_bin = this.get_max_min_score(wigFeatures[chr][featureBin]);

                if (updated_bin.value != 0.5) {
                    let baf_wig = Object.assign({}, updated_bin);
                    baf_wig.value = -2 * (1 - updated_bin.value);
                    baf2.push(baf_wig);
                }
                updated_bin.value = -2 * updated_bin.value;
                wigFeatures[chr][featureBin] = updated_bin;
                baf1.push(wigFeatures[chr][featureBin]);
            }

            return [baf1, baf2]

        }


        format_BAF_likelihood(wigFeatures) {
            const results = [];

            for (const [chr, wig] of Object.entries(wigFeatures)) {
                wig.forEach(sample => {
                    var new_sample = { ...sample };
                    if (sample.value != 0.5) {
                        new_sample.value = 1 - sample.value;
                        results.push(new_sample);
                    }
                });
            }
            return results
        }

        get_max_min_score(sample) {

            if (sample.likelihood_score.length > 0) {
                const max = Math.max(...sample.likelihood_score);
                const res = sample.likelihood_score.indexOf(max);
                sample.value = Math.max(res / 100, 1 - res / 100);
                sample.min_score = Math.min(res / 100, 1 - res / 100);

            } else {
                sample.score = 0;
            }

            return sample
        }

        async getAllbins() {
            const bins = await this.computeDepthFeatures();

            //console.log('getAllbins', bins["value"])

            const fitter = new g_utils.GetFit(bins);

            fitter.fit_data();
            //  dconsole.log('rd list', distParams)

            return bins
        }

        async read_rd_baf(caller='ReadDepth'){
            
            const chromosomes = Object.keys(this.allVariants);
            var wigFeatures = {};

            for (let chr of chromosomes) {
                const variants = this.allVariants[chr];
                var featureBin;
                if (variants.length === 0) continue
                for (let snp of variants) {
                    featureBin = Math.max(Math.floor(snp.start / this.rowBinSize), 0);
                    if (!wigFeatures[chr]) { wigFeatures[chr] = []; }
                    if (!wigFeatures[chr][featureBin]) {

                        wigFeatures[chr][featureBin] = {
                            chr,
                            start: featureBin * this.rowBinSize,
                            end: (featureBin + 1) * this.rowBinSize,
                            // value: 0,
                            dp_sum_score: 0,
                            dp_count: 0,
                            hets_count:0,
                            hets: [],
                            //likelihood_score: [],
                        };
                    }
                    const calls = snp.calls[9];
                    const dpValue = calls.info["DP"];
                    if (dpValue) {
                        
                        wigFeatures[chr][featureBin].dp_sum_score += Number.parseInt(dpValue);
                        wigFeatures[chr][featureBin].dp_count++;
                    }
                    
                    let ad_score = calls.info["AD"].split(',');
                    let genotype = calls.genotype;
                    if ((genotype[0] == 0 && genotype[1] == 1) || (genotype[0] == 1 && genotype[1] == 0)) {
                        //apply the beta function
                        wigFeatures[chr][featureBin].hets_count++;
                        let ad_a = parseInt(ad_score[0]), ad_b = parseInt(ad_score[1]);
                        wigFeatures[chr][featureBin].hets.push({ref:ad_a, alt:ad_b});
                    }
               
                }
            
            }
        
            var avgbin = this.adjust_bin_size(wigFeatures);
            var finalFeatureSet;
            if(caller == 'ReadDepth'){
                finalFeatureSet = this.readDepthMeanshift(avgbin);
                var baf = this.formatDataStructure_BAF(avgbin, 'max_likelihood');
            }else if(caller=='2D'){
                
                let caller_obj = new combined_caller.CombinedCaller(avgbin,  this.binSize);        
                let processed_bins = await caller_obj.call_2d();
                
                finalFeatureSet = [processed_bins.binScore, [], processed_bins.segment_score];
        
                var baf = caller_obj.formatDataStructure_BAF('max_likelihood');
            }
            

            return [finalFeatureSet, baf]
        }

        formatDataStructure_BAF(wigFeatures, feature_column, scaling_factor = 2) {
            const baf1 = [];
            const baf2 = [];
            for (const [chr, wig] of Object.entries(wigFeatures)) {

                wig.forEach(sample => {
                    delete sample.likelihood_score;
                    var baf1_value = { ...sample };
                    var baf2_value = { ...sample };
                    
                    let value = sample[feature_column];
                    if (value != 0.5){
                        baf2_value.value = -2 * (1 - value);
                        baf2.push(baf2_value);
                    }
                    baf1_value.value = -2 * value;
                    baf1.push(baf1_value);
                        
                });
            }
            

            return [baf1, baf2]
        }
        
        adjust_bin_size(wigFeatures){
            const chromosomes = Object.keys(this.allVariants);
            // adjust the bin values to actual bin size
            var avgbin = {};
            for (let chr of chromosomes) {
                if (!avgbin[chr]) { avgbin[chr] = []; }
                for (let k = 0; k < wigFeatures[chr].length / this.binFactor; k++) {
                    const featureBin = k;
                    if (!avgbin[chr][k]) {
                        avgbin[chr][k] = {
                            chr,
                            start: featureBin * this.binSize,
                            end: (featureBin + 1) * this.binSize,
                            dp_count: 0,
                            hets_count: 0,
                            binScore: 0,
                            likelihood_score: [],
                        };
                    }

                    for (var j = k * 10; j < 10 * k + 10; j++) {
                       
                        if (wigFeatures[chr][j]) {
                            var tmp_score = parseInt(wigFeatures[chr][j].dp_sum_score / wigFeatures[chr][j].dp_count) * 100;
                            avgbin[chr][k].binScore += tmp_score;
                            avgbin[chr][k].dp_count += wigFeatures[chr][j].dp_count;
                            avgbin[chr][k].hets_count += wigFeatures[chr][j].hets_count;

                            if (wigFeatures[chr][j].hets.length != 0){
                            
                                
                                wigFeatures[chr][j].hets.forEach((hets, hets_idx) => {
                                    if(avgbin[chr][k].likelihood_score.length == 0){
                                        avgbin[chr][k].likelihood_score = g_utils.linspace(0, 1, 100).map((value, index) => {
                                            return beta(hets.ref, hets.alt, value);
                                        });
                                    }
                                    else {
                                        var likelihood_sum = 0;
                                        avgbin[chr][k].likelihood_score = g_utils.linspace(0, 1, 100).map((value, index) => {
                                            var likelihood_value = avgbin[chr][k].likelihood_score[index] * beta(hets.ref, hets.alt, value);
                                            likelihood_sum += likelihood_value;
                                            return likelihood_value;
                                        });

                                        avgbin[chr][k].likelihood_score = g_utils.linspace(0, 1, 100).map((value, index) => {
                                            return avgbin[chr][k].likelihood_score[index] / likelihood_sum;
                                        });
                           
                                    }
                                });
                                
                                // avgbin[chr][k].likelihood_score *= wigFeatures[chr][j].likelihood_score
                            }
                        }
                    }

                    const updated_bin = this.get_max_min_score(avgbin[chr][k]);
                    avgbin[chr][k].max_likelihood = updated_bin.value;
                }
            }
            return avgbin
        }

    }

    function beta(a, b, p, phased = true) {
        return p ** a * (1 - p) ** b + p ** b * (1 - p) ** a;
    }

    /*
    * The MIT License (MIT)
    *
    * Copyright (c) 2016-2017 The Regents of the University of California
    * Author: Arijit Panda
    *
    * Permission is hereby granted, free of charge, to any person obtaining a copy
    * of this software and associated documentation files (the "Software"), to deal
    * in the Software without restriction, including without limitation the rights
    * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    * copies of the Software, and to permit persons to whom the Software is
    * furnished to do so, subject to the following conditions:
    *
    * The above copyright notice and this permission notice shall be included in
    * all copies or substantial portions of the Software.
    *
    *
    * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
    * THE SOFTWARE.
    */


    /**
     * Represents 2 or more wig tracks overlaid on a common viewport.
     */

    const DEFAULT_TRACK_HEIGHT = 250;

    class CNVPytorTrack extends TrackBase {

        constructor(config, browser) {
            super(config, browser);
            this.featureType = 'numeric';
            this.paintAxis = paintAxis;
            
            if (!config.max) {
                this.defaultScale = true;
                this.autoscale = false;
            }

            // Invoke height setter last to allocated to coverage and alignment tracks
            this.height = (config.height !== undefined ? config.height : DEFAULT_TRACK_HEIGHT);
        }

        async init(config) {

            this.type = "cnvpytor";
            this.graphType = config.graphType || "points";
            this.bin_size = config.bin_size || 100000;
            this.signal_name = config.signal_name || "rd_snp";
            this.cnv_caller = config.cnv_caller || '2D';
            this.colors = config.colors || ['gray', 'black', 'green', 'blue'];
            super.init(config);

        }

        get supportsWholeGenome() {
            return true
        }

        get_signals() {
            let signals = [];

            if (this.signal_name == 'rd_snp') {
                signals = ["RD_Raw", "RD_Raw_gc_coor", this.cnv_caller, "BAF1", "BAF2"];

            } else if (this.signal_name == 'rd') {
                signals = ["RD_Raw", "RD_Raw_gc_coor", this.cnv_caller];

            } else if (this.signal_name == 'snp') {
                signals = ["BAF1", "BAF2"];

            } else if (this.signal_name == 'cnh') {
                signals = [this.cnv_caller];
            }
            return signals
        }

        get_signal_colors() {
            
            let signal_colors = [
                { singal_name: 'RD_Raw', color: this.colors[0] },
                { singal_name: 'RD_Raw_gc_coor', color: this.colors[1] },
                { singal_name: 'ReadDepth', color: this.colors[2] },
                { singal_name: '2D', color: this.colors[2] },
                { singal_name: 'BAF1', color: this.colors[3] },
                { singal_name: 'BAF2', color: this.colors[3] },
            ];
            return signal_colors
        }

        async postInit() {

            if (this.config.format == 'vcf') {
                this.featureSource = FeatureSource(this.config, this.browser.genome);
                this.header = await this.getHeader();


                var allVariants = this.featureSource.reader.features.reduce(function (r, a) {
                    r[a.chr] = r[a.chr] || [];
                    r[a.chr].push(a);
                    return r
                }, Object.create(null));

                const cnvpytor_obj = new CNVpytorVCF(allVariants, this.bin_size);
                
                let wigFeatures;
                let bafFeatures;
                this.wigFeatures_obj = {};
                this.wigFeatures_obj[this.bin_size] = {};

                let dataWigs;
                if(this.config.cnv_caller == '2D'){
                    
                    dataWigs = await cnvpytor_obj.read_rd_baf('2D');

                    wigFeatures = dataWigs[0];
                    bafFeatures = dataWigs[1];
                    this.wigFeatures_obj[this.bin_size]['2D'] = wigFeatures[2];

                    this.available_callers = ['2D'];
                }else {
                    dataWigs = await cnvpytor_obj.read_rd_baf();
                    wigFeatures = dataWigs[0];
                    bafFeatures = dataWigs[1];
                    this.wigFeatures_obj[this.bin_size]['ReadDepth'] = wigFeatures[2];
                    this.available_callers = ['ReadDepth'];
                }
                
                this.wigFeatures_obj[this.bin_size]['RD_Raw'] = wigFeatures[0];
                this.wigFeatures_obj[this.bin_size]['RD_Raw_gc_coor'] = wigFeatures[1];
                this.wigFeatures_obj[this.bin_size]['BAF1'] = bafFeatures[0];
                this.wigFeatures_obj[this.bin_size]['BAF2'] = bafFeatures[1];
                
                this.available_bins = [this.bin_size];
                
                this.set_available_callers();

            } else {
                this.cnvpytor_obj =   new HDF5Reader(this.config.url, this.bin_size);
                this.wigFeatures_obj = await this.cnvpytor_obj.get_rd_signal(this.bin_size);
                this.available_bins = this.cnvpytor_obj.available_bins;
                this.available_callers = this.cnvpytor_obj.callers;
                this.set_available_callers();
            }

            this.tracks = [];
            const p = [];

            this.signals = this.get_signals();
            this.signal_colors = this.get_signal_colors();

            for (let bin_size in this.wigFeatures_obj) {

                for (const [signal_name, wig] of Object.entries(this.wigFeatures_obj[bin_size])) {

                    if (this.signals.includes(signal_name)) {
                        let tconf = {};
                        tconf.type = "wig";
                        tconf.isMergedTrack = true;
                        tconf.features = wig;
                        tconf.name = signal_name;
                        tconf.color = this.signal_colors.filter(x => x.singal_name === signal_name).map(x => x.color);
                        const t = await this.browser.createTrack(tconf);
                        if (t) {
                            t.autoscale = false;     // Scaling done from merged track
                            this.tracks.push(t);
                        } else {
                            console.warn("Could not create track " + tconf);
                        }

                        if (typeof t.postInit === 'function') {
                            p.push(t.postInit());
                        }
                    }
                }

            }


            this.flipAxis = this.config.flipAxis ? this.config.flipAxis : false;
            this.logScale = this.config.logScale ? this.config.logScale : false;
            this.autoscale = this.config.autoscale;
            if (!this.autoscale) {
                this.dataRange = {
                    min: this.config.min || 0,
                    max: this.config.max
                };
            }
            for (let t of this.tracks) {
                t.autoscale = false;
                t.dataRange = this.dataRange;
            }

            return Promise.all(p)
        }

        set_available_callers() {
            if (!this.available_callers.includes(this.cnv_caller)) {
                if (this.available_callers.length > 0) {
                    this.cnv_caller = this.available_callers[0];
                } else {
                    this.cnv_caller = null;
                }
            }
        }

        async getHeader() {

            if (!this.header) {
                if (typeof this.featureSource.getHeader === "function") {
                    const header = await this.featureSource.getHeader();
                    if (header) {
                        this.callSets = header.callSets || [];
                    }
                    this.header = header;
                }
                this.sampleNames = this.callSets ? this.callSets.map(cs => cs.name) : [];
            }

            return this.header
        }

        get height() {
            return this._height
        }

        set height(h) {
            this._height = h;
            if (this.tracks) {
                for (let t of this.tracks) {
                    t.height = h;
                    t.config.height = h;
                }
            }
        }

        menuItemList() {
            let items = [];

            if (this.flipAxis !== undefined) {
                items.push({
                    label: "Flip y-axis",
                    click: () => {
                        this.flipAxis = !this.flipAxis;
                        this.trackView.repaintViews();
                    }
                });
            }

            items = items.concat(MenuUtils.numericDataMenuItems(this.trackView));

            items.push('<hr/>');
            items.push("Bin Sizes");
            for (let rd_bin of this.available_bins) {
                const checkBox = createCheckbox(rd_bin, rd_bin === this.bin_size);
                items.push({
                    object: $$1(checkBox),
                    click: async () => {
                        this.bin_size = rd_bin;

                        await this.recreate_tracks(rd_bin);
                        this.clearCachedFeatures();
                        this.trackView.updateViews();
                        this.trackView.repaintViews();
                    }
                });
            }
            items.push('<hr/>');
            items.push("Signal Type");

            let signal_dct = {"rd_snp": "RD and BAF Likelihood", "rd": "RD Signal", "snp": "BAF Likelihood"};
            for (let signal_name in signal_dct) {
                const checkBox = createCheckbox(signal_dct[signal_name], signal_name === this.signal_name);
                items.push({
                    object: $$1(checkBox),
                    click: async () => {
                        this.signal_name = signal_name;
                        await this.recreate_tracks(this.bin_size);
                        this.clearCachedFeatures();
                        this.trackView.updateViews();
                        this.trackView.repaintViews();

                    }
                });
            }

            // cnv caller setting
            items.push('<hr/>');
            items.push("CNV caller");
            for (let cnv_caller of this.available_callers) {
                const checkBox = createCheckbox(cnv_caller, cnv_caller === this.cnv_caller);
                items.push({
                    object: $$1(checkBox),
                    click: async () => {
                        this.cnv_caller = cnv_caller;
                        await this.recreate_tracks(this.bin_size);
                        this.clearCachedFeatures();
                        this.trackView.updateViews();
                        this.trackView.repaintViews();
                    }
                });
            }

            return items
        }

        async recreate_tracks(bin_size) {
            this.tracks = [];
            const p = [];

            if (!(bin_size in this.wigFeatures_obj)) {
                this.wigFeatures_obj = {...this.wigFeatures_obj, ...await this.cnvpytor_obj.get_rd_signal(bin_size)};
            }

            this.signals = this.get_signals();
            this.signal_colors = this.get_signal_colors();

            for (const [signal_name, wig] of Object.entries(this.wigFeatures_obj[bin_size])) {
                if (this.signals.includes(signal_name)) {
                    let tconf = {};
                    tconf.type = "wig";
                    tconf.isMergedTrack = true;
                    tconf.features = wig;
                    tconf.name = signal_name;
                    tconf.color = this.signal_colors.filter(x => x.singal_name === signal_name).map(x => x.color); 
                    const t = await this.browser.createTrack(tconf);
                    if (t) {
                        t.autoscale = false;     // Scaling done from merged track
                        this.tracks.push(t);
                    } else {
                        console.warn("Could not create track " + tconf);
                    }

                    if (typeof t.postInit === 'function') {
                        p.push(t.postInit());
                    }
                }

            }


            this.flipAxis = this.config.flipAxis ? this.config.flipAxis : false;
            this.logScale = this.config.logScale ? this.config.logScale : false;
            this.autoscale = this.config.autoscale;
            if (!this.autoscale) {
                this.dataRange = {
                    min: this.config.min || 0,
                    max: this.config.max
                };
            }
            for (let t of this.tracks) {
                t.autoscale = false;
                t.dataRange = this.dataRange;
            }
            return Promise.all(p)
        }

        async getFeatures(chr, bpStart, bpEnd, bpPerPixel) {

            if(this.tracks) {
                const promises = this.tracks.map((t) => t.getFeatures(chr, bpStart, bpEnd, bpPerPixel));
                return Promise.all(promises)
            } else {
                return undefined  // This can happen if a redraw is triggered before the track has initialized.
            }
        }

        // TODO: refactor to igvUtils.js
        getScaleFactor(min, max, height, logScale) {
            const scale = logScale ? height / (Math.log10(max + 1) - (min <= 0 ? 0 : Math.log10(min + 1))) : height / (max - min);
            return scale
        }

        computeYPixelValue(yValue, yScaleFactor) {
            return (this.flipAxis ? (yValue - this.dataRange.min) : (this.dataRange.max - yValue)) * yScaleFactor
        }

        computeYPixelValueInLogScale(yValue, yScaleFactor) {
            let maxValue = this.dataRange.max;
            let minValue = this.dataRange.min;
            if (maxValue <= 0) return 0 // TODO:
            if (minValue <= -1) minValue = 0;
            minValue = (minValue <= 0) ? 0 : Math.log10(minValue + 1);
            maxValue = Math.log10(maxValue + 1);
            yValue = Math.log10(yValue + 1);
            return ((this.flipAxis ? (yValue - minValue) : (maxValue - yValue)) * yScaleFactor)
        }

        draw(options) {

            // const mergedFeatures = options.features    // Array of feature arrays, 1 for each track
            const mergedFeatures = options.features;
            if(!mergedFeatures) return

            if (this.defaultScale) {
                if (this.signal_name == 'rd_snp') {
                    this.dataRange = {
                        min: this.config.min || this.dataRange.min || -2,
                        max: this.config.max || this.dataRange.max || 6
                    };
                } else if (this.signal_name == 'rd') {
                    this.dataRange = {
                        min: this.config.min || this.dataRange.min || 0,
                        max: this.config.max || this.dataRange.max || 6
                    };
                } else if (this.signal_name == 'snp') {
                    this.dataRange = {
                        min: this.config.min || this.dataRange.min || -2,
                        max: this.config.max || this.dataRange.max || 0
                    };
                }
            }

            if (this.autoscale) {
                this.dataRange = autoscale(options.referenceFrame.chr, mergedFeatures);
            }

            if(this.tracks) {
                for (let i = 0, len = this.tracks.length; i < len; i++) {
                    const trackOptions = Object.assign({}, options);
                    trackOptions.features = mergedFeatures[i];
                    this.tracks[i].dataRange = this.dataRange;
                    this.tracks[i].flipAxis = this.flipAxis;
                    this.tracks[i].logScale = this.logScale;
                    if (this.graphType) {
                        this.tracks[i].graphType = this.graphType;
                    }
                    this.tracks[i].draw(trackOptions);
                }
            }

            // guides lines
            const scaleFactor = this.getScaleFactor(this.dataRange.min, this.dataRange.max, options.pixelHeight, this.logScale);
            const yScale = (yValue) => this.logScale
                ? this.computeYPixelValueInLogScale(yValue, scaleFactor)
                : this.computeYPixelValue(yValue, scaleFactor);

             // Draw guidelines
             if (this.config.hasOwnProperty('guideLines')) {
                for (let line of this.config.guideLines) {
                    if (line.hasOwnProperty('color') && line.hasOwnProperty('y') && line.hasOwnProperty('dotted')) {
                        let y = yScale(line.y);
                        let props = {
                            'strokeStyle': line['color'],
                            'strokeWidth': 1
                        };
                        if (line['dotted']) IGVGraphics.dashedLine(options.context, 0, y, options.pixelWidth, y, 5, props);
                        else IGVGraphics.strokeLine(options.context, 0, y, options.pixelWidth, y, props);
                    }
                }
            }
        }

        popupData(clickState, features) {

            const featuresArray = features || clickState.viewport.cachedFeatures;

            if (featuresArray && featuresArray.length === this.tracks.length) {
                // Array of feature arrays, 1 for each track
                const popupData = [];
                for (let i = 0; i < this.tracks.length; i++) {
                    if (i > 0) popupData.push('<hr/>');
                    popupData.push(`<div style=background-color:rgb(245,245,245);border-bottom-style:dashed;border-bottom-width:1px;padding-bottom:5px;padding-top:10px;font-weight:bold;font-size:larger >${this.tracks[i].name}</div>`);
                    const trackPopupData = this.tracks[i].popupData(clickState, featuresArray[i]);
                    popupData.push(...trackPopupData);

                }
                return popupData
            }
        }

    }

    function autoscale(chr, featureArrays) {

        let min = 0;
        let max = -Number.MAX_VALUE;
        for (let features of featureArrays) {
            for (let f of features) {
                if (typeof f.value !== 'undefined' && !Number.isNaN(f.value)) {
                    min = Math.min(min, f.value);
                    max = Math.max(max, f.value);
                }
            }
        }
        return {min: min, max: max}
    }

    //import CNVPytorTrack from "./CNVpytor/cnvpytorTrack.js"


    const trackFunctions =
        new Map([
            ['ideogram', (config, browser) => new IdeogramTrack(config, browser)],
            ['sequence', (config, browser) => new SequenceTrack(config, browser)],
            ['feature', (config, browser) => new FeatureTrack(config, browser)],
            ['seg', (config, browser) => new SegTrack(config, browser)],
            ['mut', (config, browser) => new SegTrack(config, browser)],
            ['maf', (config, browser) => new SegTrack(config, browser)],
            ['wig', (config, browser) => new WigTrack(config, browser)],
            ['merged', (config, browser) => new MergedTrack(config, browser)],
            ['alignment', (config, browser) => new BAMTrack(config, browser)],
            ['interaction', (config, browser) => new InteractionTrack(config, browser)],
            ['interact', (config, browser) => new InteractionTrack(config, browser)],
            ['variant', (config, browser) => new VariantTrack(config, browser)],
            ['eqtl', (config, browser) => new EqtlTrack(config, browser)],
            ['gwas', (config, browser) => new GWASTrack(config, browser)],
            ['arc', (config, browser) => new RnaStructTrack(config, browser)],
            ['gcnv', (config, browser) => new GCNVTrack(config, browser)],
            ['junction', (config, browser) => new SpliceJunctionTrack(config, browser)],
            ['blat', (config, browser) => new BlatTrack(config, browser)],
            ['cnvpytor', (config, browser) => new CNVPytorTrack(config, browser)]
        ]);


    /**
     * Add a track constructor  the the factory lookup table.
     *
     * @param type
     * @param track
     */
    const addTrackCreatorFunction = function (type, track) {
        trackFunctions.set(type, track);
    };

    const getTrack = function (type, config, browser) {

        let trackKey;
        switch (type) {
            case "annotation":
            case "genes":
            case "fusionjuncspan":
            case "snp":
                trackKey = "feature";
                break
            case 'seg':
            case 'maf':
            case 'mut':
                trackKey = 'seg';
                break
            case 'junctions':
            case 'splicejunctions':
                trackKey = 'junction';
                break
            default:
                trackKey = type;
        }

        return trackFunctions.has(trackKey) ?
            trackFunctions.get(trackKey)(config, browser) :
            undefined
    };

    var TrackFactory = {
        tracks: trackFunctions,
        addTrack: addTrackCreatorFunction,
        trackFunctions,
        addTrackCreatorFunction,
        getTrack
    };

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */


    /**
     * Minimal support for the legacy IGV desktop session format.
     */

    class XMLSession {

        constructor(xmlString, knownGenomes) {

            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlString, "text/xml");

            this.processRootNode(xmlDoc, knownGenomes);

            const resourceElements = xmlDoc.getElementsByTagName("Resource");
            const trackElements = xmlDoc.getElementsByTagName("Track");
            const hasTrackElements = trackElements && trackElements.length > 0;

            const tracks = [];
            this.tracks = tracks;

            const resourceMap = new Map();
            Array.from(resourceElements).forEach(function (r, idx) {
                var config = {
                    url: r.getAttribute("path"),
                    indexURL: r.getAttribute("index"),
                    order: idx
                };
                resourceMap.set(config.url, config);
                if (!hasTrackElements) {
                    tracks.push(config);
                }
            });

            // Check for optional Track section
            if (hasTrackElements) {

                Array.from(trackElements).forEach(function (track) {

                    const subtracks = track.getElementsByTagName("Track");

                    if (subtracks && subtracks.length > 0) {

                        const mergedTrack = {
                            type: 'merged',
                            tracks: []
                        };
                        extractTrackAttributes(track, mergedTrack);

                        tracks.push(mergedTrack);

                        Array.from(subtracks).forEach(function (t) {
                            t.processed = true;
                            const id = t.getAttribute("id");
                            const config = resourceMap.get(id);
                            if (config) {
                                mergedTrack.tracks.push(config);
                                extractTrackAttributes(t, config);
                                config.autoscale = false;
                                mergedTrack.height = config.height;

                                // Add alpha for merged track colors.  Alpha is not recorded by IGV desktop in XML session
                                //const color = t.getAttribute("color");
                                //if (color) {
                                //    config.color = "rgba(" + color + ",0.5)";
                                //}
                            }
                        });
                    } else if (!track.processed) {

                        const id = track.getAttribute("id");
                        const res = resourceMap.get(id);
                        if (res) {
                            tracks.push(res);
                            extractTrackAttributes(track, res);
                        }

                    }
                });
            }
        }

        processRootNode(xmlDoc, knownGenomes) {

            const elements = xmlDoc.getElementsByTagName("Session");
            if (!elements || elements.length === 0) ;
            const session = elements.item(0);
            const genome = session.getAttribute("genome");
            const locus = session.getAttribute("locus");
            const ucscID = session.getAttribute("ucscID");

            if (knownGenomes && knownGenomes.hasOwnProperty(genome)) {
                this.genome = genome;

            } else {
                this.reference = {
                    fastaURL: genome
                };
                if (ucscID) {
                    this.reference.id = ucscID;
                }
            }
            if (locus) {
                this.locus = locus;
            }
        }

    }


    function extractTrackAttributes(track, config) {


        config.name = track.getAttribute("name");

        const color = track.getAttribute("color");
        if (color) {
            config.color = "rgb(" + color + ")";
        }

        const altColor = track.getAttribute("altColor");
        if (color) {
            config.altColor = "rgb(" + altColor + ")";
        }

        const height = track.getAttribute("height");
        if (height) {
            config.height = parseInt(height);
        }

        const autoScale = track.getAttribute("autoScale");
        if (autoScale) {
            config.autoscale = (autoScale === "true");
        }

        const autoscaleGroup = track.getAttribute("autoscaleGroup");
        if (autoscaleGroup) {
            config.autoscaleGroup = autoscaleGroup;
        }

        const windowFunction = track.getAttribute("windowFunction");
        if (windowFunction) {
            config.windowFunction = windowFunction;
        }
        const visWindow = track.getAttribute("visibilityWindow") || track.getAttribute("featureVisibilityWindow");
        if (visWindow) {
            config.visibilityWindow = visWindow;
        }

        const indexed = track.getAttribute("indexed");
        if (indexed) {
            config.indexed = (indexed === "true");
        }

        const normalize = track.getAttribute("normalize");
        if (normalize) {
            config.normalize = normalize === "true";
        }

        const dataRangeCltn = track.getElementsByTagName("DataRange");
        if (dataRangeCltn.length > 0) {
            const dataRange = dataRangeCltn.item(0);
            config.min = Number(dataRange.getAttribute("minimum"));
            config.max = Number(dataRange.getAttribute("maximum"));
            config.logScale = dataRange.getAttribute("type") === "LOG";
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014-2015 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const splitLines = splitLines$5;

    class SampleInformation {
        constructor() {
            this.attributes = {};
            this.plinkLoaded = false;
        }

        async loadPlinkFile(url, config) {

            if (!config) config = {};

            var options = buildOptions(config);    // Add oauth token, if any
            const data = await igvxhr.loadString(url, options);
            var lines = splitLines(data);

            for (let line of lines) {
                var line_arr = line.split(' ');
                this.attributes[line_arr[1]] = {
                    familyId: line_arr[0],
                    fatherId: line_arr[2],
                    motherId: line_arr[3],
                    sex: line_arr[4],
                    phenotype: line_arr[5]
                };
            }
            this.plinkLoaded = true;
            return this
        }

        /**
         * Return the attributes for the given sample as a map-like object (key-value pairs)
         * @param sample
         */
        getAttributes(sample) {
            return this.attributes[sample]
        };

        getAttributeNames() {

            if (this.hasAttributes()) {
                return Object.keys(this.attributes[Object.keys(this.attributes)[0]])
            } else return []
        };

        hasAttributes() {
            return Object.keys(this.attributes).length > 0
        }
    }

    function loadPlinkFile(url, config) {
        const si = new SampleInformation();
        return si.loadPlinkFile(url, config)
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class GtexSelection {

        constructor(gene, snp) {
            this.geneColors = {};
            this.gene = null;
            this.snp = null;
            this.genesCount = 0;

            if (gene) {
                this.gene = gene.toUpperCase();
                this.geneColors[this.gene] = brewer[this.genesCount++];

            }
            if (snp) {
                this.snp = snp.toUpperCase();
            }
        }

        addGene(geneName) {
            if (!this.geneColors[geneName.toUpperCase()]) {
                this.geneColors[geneName.toUpperCase()] = brewer[this.genesCount++];
            }
        }

        colorForGene(geneName) {
            return this.geneColors[geneName.toUpperCase()]
        }
    }

    var brewer = [];
    // Set +!
    brewer.push("rgb(228,26,28)");
    brewer.push("rgb(55,126,184)");
    brewer.push("rgb(77,175,74)");
    brewer.push("rgb(166,86,40)");
    brewer.push("rgb(152,78,163)");
    brewer.push("rgb(255,127,0)");
    brewer.push("rgb(247,129,191)");
    brewer.push("rgb(153,153,153)");
    brewer.push("rgb(255,255,51)");

    // #Set 2
    brewer.push("rgb(102, 194, 165");
    brewer.push("rgb(252, 141, 98");
    brewer.push("rgb(141, 160, 203");
    brewer.push("rgb(231, 138, 195");
    brewer.push("rgb(166, 216, 84");
    brewer.push("rgb(255, 217, 47");
    brewer.push("rgb(229, 196, 148");
    brewer.push("rgb(179, 179, 179");

    //#Set 3
    brewer.push("rgb( 141, 211, 199");
    brewer.push("rgb(255, 255, 179");
    brewer.push("rgb(190, 186, 218");
    brewer.push("rgb(251, 128, 114");
    brewer.push("rgb(128, 177, 211");
    brewer.push("rgb(253, 180, 98");
    brewer.push("rgb(179, 222, 105");
    brewer.push("rgb(252, 205, 229");
    brewer.push("rgb(217, 217, 217");
    brewer.push("rgb(188, 128, 189");
    brewer.push("rgb(204, 235, 197");
    brewer.push("rgb(255, 237, 111");

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    // Reference frame classes.  Converts domain coordinates (usually genomic) to pixel coordinates

    class ReferenceFrame {

        constructor(genome, chr, start, end, bpPerPixel) {
            this.genome = genome;
            this.chr = chr;

            this.start = start;

            // TODO WARNING THIS IS NOT UPDATED !!!
            this.end = end;

            this.bpPerPixel = bpPerPixel;
            this.id = domUtils.guid();
        }

        /**
         * Extend this frame to accomodate the given locus.  Used th CircularView methods to merge 2 frames.
         * @param locus
         */
        extend(locus) {
            const newStart = Math.min(locus.start, this.start);
            const newEnd = Math.max(locus.end, this.end);
            const ratio = (newEnd - newStart) / (this.end - this.start);
            this.start = newStart;
            this.end = newEnd;
            this.bpPerPixel *= ratio;
        }

        calculateEnd(pixels) {
            return this.start + this.bpPerPixel * pixels
        }

        calculateBPP(end, pixels) {
            return (end - this.start) / pixels
        }

        set(json) {
            this.chr = json.chr;
            this.start = json.start;
            this.bpPerPixel = json.bpPerPixel;
        }

        toPixels(bp) {
            return bp / this.bpPerPixel
        }

        toBP(pixels) {
            return this.bpPerPixel * pixels
        }

        /**
         * Shift frame by stated pixels.  Return true if view changed, false if not.
         *
         * @param pixels
         * @param clamp -- if true "clamp" shift to prevent panning off edge of chromosome.  This is disabled if "show soft clipping" is on
         * @param viewportWidth
         */
        shiftPixels(pixels, viewportWidth, clamp) {

            const currentStart = this.start;
            const deltaBP = pixels * this.bpPerPixel;

            this.start += deltaBP;

            if(clamp) {
                this.clampStart(viewportWidth);
            }

            this.end = this.start + viewportWidth * this.bpPerPixel;

            return currentStart !== this.start
        }

        clampStart(viewportWidth) {
            // clamp left
            const min = (this.genome.getChromosome(this.chr).bpStart || 0);
            this.start = Math.max(min, this.start);

            // clamp right
            if (viewportWidth) {

                const {bpLength} = this.genome.getChromosome(this.chr);
                const maxStart = bpLength - (viewportWidth * this.bpPerPixel);

                if (this.start > maxStart) {
                    this.start = maxStart;
                }
            }
        }

        async zoomWithScaleFactor(browser, scaleFactor, viewportWidth, centerBPOrUndefined) {

            const centerBP = undefined === centerBPOrUndefined ? (this.start + this.toBP(viewportWidth / 2.0)) : centerBPOrUndefined;

            // save initial start and bpp
            const {start, bpPerPixel} = this.start;

            const {bpLength} = this.getChromosome();
            const bppThreshold = scaleFactor < 1.0 ? browser.minimumBases() / viewportWidth : bpLength / viewportWidth;

            // update bpp
            if (scaleFactor < 1.0) {
                this.bpPerPixel = Math.max(this.bpPerPixel * scaleFactor, bppThreshold);
            } else {
                this.bpPerPixel = Math.min(this.bpPerPixel * scaleFactor, bppThreshold);
            }

            // update start and end
            const widthBP = this.bpPerPixel * viewportWidth;
            this.start = centerBP - 0.5 * widthBP;
            this.clampStart(viewportWidth);

            this.end = this.start + widthBP;

            const viewChanged = start !== this.start || bpPerPixel !== this.bpPerPixel;
            if (viewChanged) {
                await browser.updateViews(true);
            }

        }

        getChromosome() {
            return this.genome.getChromosome(this.chr)
        }

        getMultiLocusLabelBPLengthOnly(pixels) {
            const margin = '&nbsp';
            const ss = Math.floor(this.start) + 1;
            const ee = Math.round(this.start + this.bpPerPixel * pixels);
            return `${margin}${this.chr}${margin}${prettyBasePairNumber(ee - ss)}${margin}`
        }

        getMultiLocusLabelLocusOnly(pixels) {
            const margin = '&nbsp';
            const {chr, start, end } = this.getPresentationLocusComponents(pixels);
            return `${margin}${chr}:${start}-${end}${margin}`
        }

        getMultiLocusLabel(pixels) {
            const margin = '&nbsp';
            const {chr, start, end } = this.getPresentationLocusComponents(pixels);
            const ss = Math.floor(this.start) + 1;
            const ee = Math.round(this.start + this.bpPerPixel * pixels);
            return `${margin}${chr}:${start}-${end}${margin}${margin}(${prettyBasePairNumber(ee - ss)})${margin}`
        }

        getPresentationLocusComponents(pixels) {

            if ('all' === this.chr) {
                return {chr: this.chr}
            } else {
                const ss = numberFormatter$1(Math.floor(this.start) + 1);
                const ee = numberFormatter$1(Math.round(this.start + this.bpPerPixel * pixels));

                return {chr: this.chr, start: ss, end: ee}
            }

        }

        getLocusString() {
            if ('all' === this.chr) {
                return 'all'
            } else {
                const ss = numberFormatter$1(Math.floor(this.start) + 1);
                const ee = numberFormatter$1(Math.round(this.end));
                return `${this.chr}:${ss}-${ee}`
            }
        }

        description(blurb) {
            console.log(` ${blurb || ''} referenceFrame - ${this.chr} bpp ${this.bpPerPixel.toFixed(3)} start ${numberFormatter$1(Math.round(this.start))} end ${numberFormatter$1(Math.round(this.end))} `);
        }
    }

    function createReferenceFrameList(loci, genome, browserFlanking, minimumBases, viewportWidth, isSoftclipped) {

        return loci.map(locus => {

            // If a flanking region is defined, and the search object is a symbol ("gene") type, adjust start and end
            if (browserFlanking && locus.gene) {
                locus.start = Math.max(0, locus.start - browserFlanking);
                locus.end += browserFlanking;
            }

            // Validate the range.  This potentionally modifies start & end of locus.
            if(!isSoftclipped) {
                const chromosome = genome.getChromosome(locus.chr);
                validateGenomicExtent(chromosome.bpLength, locus, minimumBases);
            }

            const referenceFrame = new ReferenceFrame(genome,
                locus.chr,
                locus.start,
                locus.end,
                (locus.end - locus.start) / viewportWidth);

            referenceFrame.locusSearchString = locus.locusSearchString;

            // GTEX hack
            if (locus.gene || locus.snp) {
                referenceFrame.selection = new GtexSelection(locus.gene, locus.snp);
            }

            return referenceFrame
        })
    }

    const DEFAULT_SEARCH_CONFIG = {
        timeout: 5000,
        type: "plain",   // Legacy plain text support -- deprecated
        url: 'https://igv.org/genomes/locus.php?genome=$GENOME$&name=$FEATURE$',
        coords: 0,
        chromosomeField: "chromosome",
        startField: "start",
        endField: "end",
        geneField: "gene",
        snpField: "snp"
    };

    /**
     * Return an object representing the locus of the given string.  Object is of the form
     * {
     *   chr,
     *   start,
     *   end,
     *   locusSearchString,
     *   gene,
     *   snp
     * }
     * @param browser
     * @param string
     * @returns {Promise<*>}
     */
    async function search(browser, string) {

        if (undefined === string || '' === string.trim()) {
            return
        }

        if (string && string.trim().toLowerCase() === "all" || string === "*") {
            string = "all";
        }

        const loci = string.split(' ');

        let searchConfig = browser.searchConfig || DEFAULT_SEARCH_CONFIG;
        let list = [];

        const searchLocus = async (locus) => {
            let locusObject = parseLocusString(browser, locus);

            if (!locusObject) {
                const feature = browser.genome.featureDB.get(locus.toUpperCase());
                if (feature) {
                    locusObject = {
                        chr: feature.chr,
                        start: feature.start,
                        end: feature.end,
                        gene: feature.name,
                        locusSearchString: string
                    };
                }
            }

            if (!locusObject && (browser.config && false !== browser.config.search)) {
                try {
                    locusObject = await searchWebService(browser, locus, searchConfig);
                } catch (error) {
                    console.error(error);
                    throw Error("Search service currently unavailable.")
                }
            }
            return locusObject
        };

        for (let locus of loci) {
            const locusObject = await searchLocus(locus);
            if (locusObject) {
                locusObject.locusSearchString = locus;
                list.push(locusObject);
            }
        }

        // If nothing is found, consider possibility that loci name itself has spaces
        if (list.length === 0) {
            const locusObject = await searchLocus(string);
            if (locusObject) {
                locusObject.locusSearchString = string;
                list.push(locusObject);
            }
        }


        return 0 === list.length ? undefined : list
    }

    function parseLocusString(browser, locus) {

        // Check for tab delimited locus string
        const tabTokens = locus.split('\t');
        if (tabTokens.length >= 3) {
            // Possibly a tab-delimited locus
            try {
                const chr = browser.genome.getChromosomeName(tabTokens[0]);
                const start = parseInt(tabTokens[1].replace(/,/g, ''), 10) - 1;
                const end = parseInt(tabTokens[2].replace(/,/g, ''), 10);
                if (!isNaN(start) && !isNaN(end)) {
                    return {chr, start, end}
                }
            } catch (e) {
                // Not a tab delimited locus, apparently, but not really an error as that was a guess
            }

        }

        const a = locus.split(':');
        const chr = a[0];
        if ('all' === chr && browser.genome.getChromosome(chr)) {
            return {chr, start: 0, end: browser.genome.getChromosome(chr).bpLength}

        } else if (undefined === browser.genome.getChromosome(chr)) {
            return undefined

        } else {
            const queryChr = browser.genome.getChromosomeName(chr);
            const extent = {
                chr: queryChr,
                start: 0,
                end: browser.genome.getChromosome(chr).bpLength
            };

            if (a.length > 1) {

                let b = a[1].split('-');
                if (b.length > 2) {
                    // Allow for negative coordinates, which is possible if showing alignment soft clips
                    if (a[1].startsWith('-')) {
                        const i = a[1].indexOf('-', 1);
                        if (i > 0) {
                            const t1 = a[1].substring(0, i);
                            const t2 = a[1].substring(i + 1);
                            b = [t1, t2];
                        }
                    } else {
                        return undefined
                    }

                }

                let numeric;
                numeric = b[0].replace(/,/g, '');
                if (isNaN(numeric)) {
                    return undefined
                }

                extent.start = parseInt(numeric, 10) - 1;
                extent.end = extent.start + 1;

                if (1 === b.length) {
                    // Don't clamp coordinates if single coordinate is supplied.
                    extent.start -= 20;
                    extent.end += 20;
                }

                if (2 === b.length) {
                    numeric = b[1].replace(/,/g, '');
                    if (isNaN(numeric)) {
                        return undefined
                    } else {
                        extent.end = parseInt(numeric, 10);
                    }

                    // Allow negative coordinates only if browser is softclipped, i.e. there is at least alignment track with softclipping on
                    if (extent.start < 0 && !browser.isSoftclipped()) {
                        const delta = -extent.start;
                        extent.start += delta;
                        extent.end += delta;
                    }
                }
            }

            return extent
        }
    }

    async function searchWebService(browser, locus, searchConfig) {

        let path = searchConfig.url.replace("$FEATURE$", locus.toUpperCase());
        if (path.indexOf("$GENOME$") > -1) {
            path = path.replace("$GENOME$", (browser.genome.id ? browser.genome.id : "hg19"));
        }
        const options = searchConfig.timeout ? {timeout: searchConfig.timeout} : undefined;
        const result = await igvxhr.loadString(path, options);

        const locusObject = processSearchResult(browser, result, searchConfig);
        if (locusObject) {
            locusObject.locusSearchString = locus;
        }
        return locusObject
    }

    function processSearchResult(browser, result, searchConfig) {

        let results;

        if ('plain' === searchConfig.type) {
            results = parseSearchResults(browser, result);
        } else {
            results = JSON.parse(result);
        }

        if (searchConfig.resultsField) {
            results = results[searchConfig.resultsField];
        }

        if (!results || 0 === results.length) {
            return undefined

        } else {

            const chromosomeField = searchConfig.chromosomeField || "chromosome";
            const startField = searchConfig.startField || "start";
            const endField = searchConfig.endField || "end";
            const coords = searchConfig.coords || 1;


            let result;
            if (Array.isArray(results)) {
                // Ignoring all but first result for now
                // TODO -- present all and let user select if results.length > 1
                result = results[0];
            } else {
                // When processing search results from Ensembl REST API
                // Example: https://rest.ensembl.org/lookup/symbol/macaca_fascicularis/BRCA2?content-type=application/json
                result = results;
            }

            if (!(result.hasOwnProperty(chromosomeField) && (result.hasOwnProperty(startField)))) {
                console.error("Search service results must include chromosome and start fields: " + result);
            }

            const chrResult = result[chromosomeField];
            const chromosome = browser.genome.getChromosome(chrResult);
            if (!chromosome) {
                return undefined
            }
            const chr = chromosome.name;

            let start = result[startField] - coords;
            let end = result[endField];
            if (undefined === end) {
                end = start + 1;
            }

            const locusObject = {chr, start, end};

            // Some GTEX hacks
            const type = result.type ? result.type : "gene";
            if (searchConfig.geneField && type === "gene") {
                locusObject.gene = result[searchConfig.geneField];
            }
            if (searchConfig.snpField && type === "snp") {
                locusObject.snp = result[searchConfig.snpField];
            }

            return locusObject
        }
    }

    /**
     * Parse the igv line-oriented (non json) search results.
     * Example
     *    EGFR    chr7:55,086,724-55,275,031    refseq
     *
     */
    function parseSearchResults(browser, data) {

        const linesTrimmed = [];
        const results = [];
        const lines = splitLines$5(data);

        lines.forEach(function (item) {
            if ("" === item) ; else {
                linesTrimmed.push(item);
            }
        });

        linesTrimmed.forEach(function (line) {

            var tokens = line.split("\t"),
                source,
                locusTokens,
                rangeTokens,
                obj;

            if (tokens.length >= 3) {

                locusTokens = tokens[1].split(":");
                rangeTokens = locusTokens[1].split("-");
                source = tokens[2].trim();

                obj =
                    {
                        gene: tokens[0],
                        chromosome: browser.genome.getChromosomeName(locusTokens[0].trim()),
                        start: parseInt(rangeTokens[0].replace(/,/g, '')),
                        end: parseInt(rangeTokens[1].replace(/,/g, '')),
                        type: ("gtex" === source ? "snp" : "gene")
                    };

                results.push(obj);

            }

        });

        return results

    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class NavbarManager {

        constructor(browser) {
            this.browser = browser;
        }

        navbarDidResize(width) {
            this.updateNavbar(this.createResponsiveClassSchedule(width));
        }

        updateNavbar(responsiveClassSchedule) {

            this.browser.$toggle_button_container.removeClass();
            this.browser.$toggle_button_container.addClass(responsiveClassSchedule.$toggle_button_container);

            $$1(this.browser.zoomWidget.zoomContainer).removeClass();
            $$1(this.browser.zoomWidget.zoomContainer).addClass(responsiveClassSchedule.zoomContainer);
        }

        createResponsiveClassSchedule(navbarWidth) {

            let candidates = {};

            const isWGV = this.browser.isMultiLocusWholeGenomeView() ||
                (this.browser.referenceFrameList &&
                    GenomeUtils.isWholeGenomeView(this.browser.referenceFrameList[0].chr));


            if (isWGV) {
                this.browser.windowSizePanel.hide();
            } else {
                this.browser.windowSizePanel.show();
            }

            if (navbarWidth > 990) {
                candidates.$toggle_button_container = 'igv-navbar-toggle-button-container';
                candidates.zoomContainer = 'igv-zoom-widget';
            } else if (navbarWidth > 860) {
                candidates.$toggle_button_container = 'igv-navbar-toggle-button-container';
                candidates.zoomContainer = 'igv-zoom-widget-900';
            } else if (navbarWidth > 540) {
                candidates.$toggle_button_container = 'igv-navbar-toggle-button-container-750';
                candidates.zoomContainer = 'igv-zoom-widget-900';
            } else {
                candidates.$toggle_button_container = 'igv-navbar-toggle-button-container-750';
                candidates.zoomContainer = 'igv-zoom-widget-900';
                this.browser.windowSizePanel.hide();
            }

            if (isWGV) {
                candidates['zoomContainer'] = 'igv-zoom-widget-hidden';
            }

            return candidates
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016-2017 The Regents of the University of California
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const ChromosomeSelectWidget = function (browser, parent) {

        this.container = domUtils.div({class: 'igv-chromosome-select-widget-container'});
        parent.appendChild(this.container);

        this.select = document.createElement('select');
        this.select.setAttribute('name', 'chromosome-select-widget');
        this.container.appendChild(this.select);

        this.select.addEventListener('change', () => {
            this.select.blur();
            if (this.select.value !== '') {
                browser.search(this.select.value);
            }
        });

        this.showAllChromosomes = browser.config.showAllChromosomes !== false;   // i.e. default to true

    };

    ChromosomeSelectWidget.prototype.show = function () {
        this.container.style.display = 'flex';
    };

    ChromosomeSelectWidget.prototype.hide = function () {
        this.container.style.display = 'none';
    };

    ChromosomeSelectWidget.prototype.update = function (genome) {

        const list = this.showAllChromosomes ? genome.chromosomeNames.slice() : genome.wgChromosomeNames.slice();
        // console.log(`${ this.showAllChromosomes ? 'Do' : 'Do not'} show all chromosomes. List ${ list }`)

        if (genome.showWholeGenomeView()) {
            list.unshift('all');
            list.unshift('');
        }

        this.select.innerHTML = '';

        for (let name of list) {
            const option = document.createElement('option');
            option.setAttribute('value', name);
            option.innerText = name;
            this.select.appendChild(option);
        }

    };

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class WindowSizePanel {
        constructor(parent, browser) {

            this.container = domUtils.div({class: 'igv-windowsize-panel-container'});
            parent.appendChild(this.container);

            browser.on('locuschange', (referenceFrameList) => {
                this.updatePanel(referenceFrameList);
            });

            this.browser = browser;

        }

        show() {
            this.container.style.display = 'block';
        }

        hide() {
            this.container.style.display = 'none';
        }

        updatePanel(referenceFrameList) {
            const width = this.browser.calculateViewportWidth(this.browser.referenceFrameList.length);
            this.container.innerText = 1 === referenceFrameList.length ? prettyBasePairNumber(Math.round(width * referenceFrameList[0].bpPerPixel)) : '';
        }
    }

    class CursorGuide {

        constructor(columnContainer, browser) {
            this.browser = browser;
            this.columnContainer = columnContainer;

            this.horizontalGuide = domUtils.div({class: 'igv-cursor-guide-horizontal'});
            columnContainer.appendChild(this.horizontalGuide);

            this.verticalGuide = domUtils.div({class: 'igv-cursor-guide-vertical'});
            columnContainer.appendChild(this.verticalGuide);

            this.addMouseHandler(browser);

            this.setVisibility(browser.config.showCursorGuide);

        }

        addMouseHandler(browser) {

            this.boundMouseMoveHandler = mouseMoveHandler.bind(this);
            this.columnContainer.addEventListener('mousemove', this.boundMouseMoveHandler);

            function mouseMoveHandler(event) {

                const {x, y} = domUtils.translateMouseCoordinates(event, this.columnContainer);
                this.horizontalGuide.style.top = `${y}px`;

                const target = document.elementFromPoint(event.clientX, event.clientY);

                const viewport = findAncestorOfClass(target, 'igv-viewport');

                if (viewport && browser.getRulerTrackView()) {

                    this.verticalGuide.style.left = `${x}px`;

                    const columns = browser.root.querySelectorAll('.igv-column');
                    let index = undefined;
                    const viewportParent = viewport.parentElement;
                    for (let i = 0; i < columns.length; i++) {
                        if (undefined === index && viewportParent === columns[i]) {
                            index = i;
                        }
                    }

                    const rulerViewport = browser.getRulerTrackView().viewports[index];
                    const result = rulerViewport.mouseMove(event);

                    if (result) {

                        const {start, bp, end} = result;
                        const interpolant = (bp - start) / (end - start);

                        if (this.customMouseHandler) {
                            this.customMouseHandler({start, bp, end, interpolant});
                        }
                    }
                }

            }
        }

        removeMouseHandler() {
            this.columnContainer.removeEventListener('mousemove', this.boundMouseMoveHandler);
        }

        setVisibility(showCursorGuide) {
            if (true === showCursorGuide) {
                this.show();
            } else {
                this.hide();
            }
        }

        show() {
            this.verticalGuide.style.display = 'block';
            this.horizontalGuide.style.display = 'block';

        }

        hide() {

            this.verticalGuide.style.display = 'none';
            this.horizontalGuide.style.display = 'none';

            if (this.browser.getRulerTrackView()) {
                for (let viewport of this.browser.getRulerTrackView().viewports) {
                    viewport.$tooltip.hide();
                }
            }

        }

    }

    /**
     * Walk up the tree until a parent is found with the given classname.  If no ancestor is found return undefined.
     * @param target
     * @param classname
     * @returns {*}
     */
    function findAncestorOfClass(target, classname) {

        while (target.parentElement) {
            if (target.parentElement.classList.contains(classname)) {
                return target.parentElement
            } else {
                target = target.parentElement;
            }
        }
        return undefined

    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 University of California San Diego
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class CursorGuideButton {

        constructor(browser, parent) {

            this.browser = browser;

            this.button = domUtils.div({class: 'igv-navbar-button'});
            parent.appendChild(this.button);

            this.button.textContent = 'cursor guide';

            this.button.addEventListener('click', () => {
                browser.cursorGuideVisible = !browser.cursorGuideVisible;
                browser.setCursorGuideVisibility(browser.cursorGuideVisible);
                this.setButtonState(browser.cursorGuideVisible);
            });

            this.setButtonState(browser.cursorGuideVisible);

            if (browser.config.showCursorTrackingGuideButton) {
                this.show();
            } else {
                this.hide();
            }

        }

        setButtonState(cursorGuideVisible) {
            if (true === cursorGuideVisible) {
                this.button.classList.add('igv-navbar-button-clicked');
            } else {
                this.button.classList.remove('igv-navbar-button-clicked');
            }
        }

        show() {
            this.button.style.display = 'block';
            this.setButtonState(this.browser.cursorGuideVisible);
        }

        hide() {
            this.button.style.display = 'none';
        }
    }

    class CenterLineButton {

        constructor(browser, parent) {

            this.browser = browser;

            this.button = domUtils.div({class: 'igv-navbar-button'});
            parent.appendChild(this.button);

            this.button.textContent = 'center line';

            this.button.addEventListener('click', () => {
                browser.isCenterLineVisible = !browser.isCenterLineVisible;
                browser.setCenterLineVisibility(browser.isCenterLineVisible);
                this.setButtonState(browser.isCenterLineVisible);
            });

            this.setButtonState(browser.isCenterLineVisible);

            if (browser.config.showCenterGuideButton) {
                this.show();
            } else {
                this.hide();
            }
        }

        setButtonState(isCenterLineVisible) {
            if (true === isCenterLineVisible) {
                this.button.classList.add('igv-navbar-button-clicked');
            } else {
                this.button.classList.remove('igv-navbar-button-clicked');
            }
        }

        show() {
            this.isVisible = true;
            this.button.style.display = 'block';
            this.setButtonState(this.browser.isCenterLineVisible);
        }

        hide() {
            this.isVisible = false;
            this.button.style.display = 'none';
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 University of California San Diego
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class TrackLabelControl {

        constructor(parent, browser) {

            this.button = domUtils.div({class: 'igv-navbar-button'});
            parent.appendChild(this.button);
            this.button.textContent = 'track labels';

            this.button.addEventListener('click', () => {
                browser.trackLabelsVisible = !browser.trackLabelsVisible;
                this.setState(browser.trackLabelsVisible);
                browser.setTrackLabelVisibility(browser.trackLabelsVisible);
            });

            this.browser = browser;

            this.setVisibility(browser.config.showTrackLabelButton);

            this.setState(browser.trackLabelsVisible);
        }

        setVisibility(showTrackLabelButton) {
            if (true === showTrackLabelButton) {
                this.show();
            } else {
                this.hide();
            }
        }

        setState(trackLabelsVisible) {
            if (true === trackLabelsVisible) {
                this.button.classList.add('igv-navbar-button-clicked');
            } else {
                this.button.classList.remove('igv-navbar-button-clicked');
            }
        }

        show() {
            this.button.style.display = 'block';
            this.setState(this.browser.trackLabelsVisible);
        }

        hide() {
            this.button.style.display = 'none';
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 University of California San Diego
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class SampleNameControl {

        constructor(parent, browser) {

            this.button = domUtils.div({class: 'igv-navbar-button'});
            parent.appendChild(this.button);

            this.button.innerText = 'Sample Names';

            this.setState(browser.showSampleNames);

            this.setVisibility(browser.showSampleNameButton);

            this.button.addEventListener('click', () => {

                browser.showSampleNames = !browser.showSampleNames;

                this.setState(browser.showSampleNames);

                for (let {sampleNameViewport} of browser.trackViews) {
                    if (false === browser.showSampleNames) {
                        sampleNameViewport.hide();
                    } else {
                        sampleNameViewport.show();
                    }
                }

                browser.layoutChange();


            });

        }

        setVisibility(showSampleNameButton) {

            if (true === showSampleNameButton) {
                this.show();
            } else {
                this.hide();
            }
        }

        setState(showSampleNames) {
            if (true === showSampleNames) {
                this.button.classList.add('igv-navbar-button-clicked');
            } else {
                this.button.classList.remove('igv-navbar-button-clicked');
            }
        }

        hide() {
            this.button.style.display = 'none';
        }

        show() {
            this.button.style.display = 'block';
        }

    }

    const sliderMin = 0;
    let sliderMax = 23;
    let sliderValueRaw = 0;

    const ZoomWidget = function (browser, parent) {

        this.browser = browser;

        this.zoomContainer = domUtils.div({class: 'igv-zoom-widget'});
        parent.appendChild(this.zoomContainer);

        // zoom out
        this.zoomOutButton = domUtils.div();
        this.zoomContainer.appendChild(this.zoomOutButton);
        this.zoomOutButton.appendChild(icons$1.createIcon('minus-circle'));
        this.zoomOutButton.addEventListener('click', () => {
            // browser.zoomWithScaleFactor(2.0)
            browser.zoomOut();
        });

        // Range slider
        const el = domUtils.div();
        this.zoomContainer.appendChild(el);
        this.slider = document.createElement('input');
        this.slider.type = 'range';

        this.slider.min = `${sliderMin}`;
        this.slider.max = `${sliderMax}`;

        el.appendChild(this.slider);

        this.slider.addEventListener('change', e => {

            e.preventDefault();
            e.stopPropagation();

            const referenceFrame = browser.referenceFrameList[0];
            const {bpLength} = referenceFrame.genome.getChromosome(referenceFrame.chr);
            const {end, start} = referenceFrame;

            const extent = end - start;

            // bpLength/(end - start)
            const scaleFactor = Math.pow(2, e.target.valueAsNumber);

            // (end - start) = bpLength/scaleFactor
            const zoomedExtent = bpLength / scaleFactor;

            // console.log(`zoom-widget - slider ${ e.target.value } scaleFactor ${ scaleFactor } extent-zoomed ${ StringUtils.numberFormatter(Math.round(zoomedExtent)) }`)

            browser.zoomWithScaleFactor(zoomedExtent / extent);

        });

        // zoom in
        this.zoomInButton = domUtils.div();
        this.zoomContainer.appendChild(this.zoomInButton);
        this.zoomInButton.appendChild(icons$1.createIcon('plus-circle'));
        this.zoomInButton.addEventListener('click', () => {
            // browser.zoomWithScaleFactor(0.5)
            browser.zoomIn();
        });

        browser.on('locuschange', (referenceFrameList) => {

            if (this.browser.isMultiLocusMode()) {
                this.disable();
            } else {
                this.enable();
                this.update(referenceFrameList);
            }

        });

    };

    ZoomWidget.prototype.update = function (referenceFrameList) {

        const referenceFrame = referenceFrameList[0];
        const {bpLength} = referenceFrame.genome.getChromosome(referenceFrame.chr);
        const {start, end} = referenceFrame;

        sliderMax = Math.ceil(Math.log2(bpLength / this.browser.minimumBases()));

        this.slider.max = `${sliderMax}`;

        const scaleFactor = bpLength / (end - start);
        sliderValueRaw = Math.log2(scaleFactor);
        this.slider.value = `${Math.round(sliderValueRaw)}`;

        // referenceFrame.description('zoom.update')

        // console.log(`${ Date.now() } update - slider ${ this.slider.value } scaleFactor ${ Math.round(scaleFactor) } extent ${ StringUtils.numberFormatter(Math.round(extent)) }`)

        // console.log(`update - sliderMin ${ sliderMin } sliderValue ${ this.slider.value } sliderMax ${ sliderMax } scaleFactor ${ scaleFactor.toFixed(3) } derived-scaleFactor ${ derivedScalefactor.toFixed(3) }`)

    };

    ZoomWidget.prototype.enable = function () {

        // this.zoomInButton.style.color = appleCrayonPalette[ 'steel' ];
        // this.zoomInButton.style.pointerEvents = 'auto';
        //
        // this.zoomOutButton.style.color = appleCrayonPalette[ 'steel' ];
        // this.zoomOutButton.style.pointerEvents = 'auto';

        this.slider.disabled = false;
    };

    ZoomWidget.prototype.disable = function () {

        // this.zoomInButton.style.color = appleCrayonPalette[ 'silver' ];
        // this.zoomInButton.style.pointerEvents = 'none';
        //
        // this.zoomOutButton.style.color = appleCrayonPalette[ 'silver' ];
        // this.zoomOutButton.style.pointerEvents = 'none';

        this.slider.disabled = true;
    };

    ZoomWidget.prototype.hide = function () {
        this.zoomContainer.style.display = 'none';
    };

    ZoomWidget.prototype.show = function () {
        this.zoomContainer.style.display = 'block';
    };

    ZoomWidget.prototype.hideSlider = function () {
        this.slider.style.display = 'none';
    };

    ZoomWidget.prototype.showSlider = function () {
        this.slider.style.display = 'block';
    };

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 University of California San Diego
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const SVGSaveControl = function (parent, browser) {
        const button = domUtils.div({class: 'igv-navbar-button'});
        parent.append(button);

        button.textContent = 'Save SVG';
        button.addEventListener('click', () => browser.saveSVGtoFile({}));
    };

    const viewportColumnManager =
        {
            createColumns: (columnContainer, count) => {

                for (let i = 0; i < count; i++) {
                    if (0 === i) {
                        createColumn(columnContainer, 'igv-column');
                    } else {
                        columnContainer.appendChild(domUtils.div({class: 'igv-column-shim'}));
                        createColumn(columnContainer, 'igv-column');
                    }
                }

            },

            removeColumnAtIndex: (i, column) => {
                const shim = 0 === i ? column.nextElementSibling : column.previousElementSibling;
                column.remove();
                shim.remove();
            },

            insertAfter: referenceElement => {

                const shim = domUtils.div({class: 'igv-column-shim'});
                insertElementAfter(shim, referenceElement);

                const column = domUtils.div({class: 'igv-column'});
                insertElementAfter(column, shim);

                return column
            },

            insertBefore: (referenceElement, count) => {

                for (let i = 0; i < count; i++) {

                    const column = domUtils.div({class: 'igv-column'});
                    insertElementBefore(column, referenceElement);

                    if (count > 1 && i > 0) {
                        const columnShim = domUtils.div({class: 'igv-column-shim'});
                        insertElementBefore(columnShim, column);
                    }

                }

            },

            indexOfColumn: (columnContainer, column) => {

                const allColumns = columnContainer.querySelectorAll('.igv-column');

                for (let i = 0; i < allColumns.length; i++) {
                    const c = allColumns[ i ];
                    if (c === column) {
                        return i
                    }
                }

                return undefined
            },
        };

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 University of California San Diego
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class ViewportCenterLine {

        constructor(browser, referenceFrame, column) {

            this.browser = browser;
            this.referenceFrame = referenceFrame;
            this.column = column;

            this.container = domUtils.div({class: 'igv-center-line'});
            column.appendChild(this.container);

            if (browser.isCenterLineVisible) {
                this.show();
            } else {
                this.hide();
            }
        }

        repaint() {

            if (this.referenceFrame) {

                const ppb = 1.0 / this.referenceFrame.bpPerPixel;
                if (ppb > 1) {
                    const width = Math.floor(this.referenceFrame.toPixels(1));
                    this.container.style.width = `${width}px`;
                    this.container.classList.remove('igv-center-line-thin');
                    this.container.classList.add('igv-center-line-wide');
                } else {
                    this.container.style.width = '1px';
                    this.container.classList.remove('igv-center-line-wide');
                    this.container.classList.add('igv-center-line-thin');
                }
            }
        }

        show() {
            this.isVisible = true;
            this.container.style.display = 'block';
            this.repaint();
        }

        hide() {
            this.isVisible = false;
            this.container.style.display = 'none';
        }

        resize() {
            this.repaint();
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const numberFormatter = numberFormatter$1;

    class RulerTrack {
        constructor(browser) {

            this.browser = browser;
            this.height = 40;
            this.name = "";
            this.id = "ruler";
            this.disableButtons = true;
            this.ignoreTrackMenu = true;
            this.order = Number.MIN_SAFE_INTEGER * 1e-2;
            this.removable = false;
            this.type = 'ruler';
        }

        async getFeatures(chr, start, end) {
            return []
        };

        computePixelHeight(ignore) {
            return this.height
        };

        draw({context, referenceFrame, pixelWidth, pixelHeight, bpPerPixel, bpStart}) {

            if (GenomeUtils.isWholeGenomeView(referenceFrame.chr)) {
                this.drawWholeGenome({context, pixelWidth, pixelHeight, bpPerPixel});
            } else {
                this.doDraw({context, referenceFrame, pixelWidth, pixelHeight, bpStart});
            }
        }

        drawWholeGenome({context, pixelWidth, pixelHeight, bpPerPixel}) {

            context.save();

            IGVGraphics.fillRect(context, 0, 0, pixelWidth, pixelHeight, {'fillStyle': 'white'});

            for (let name of this.browser.genome.wgChromosomeNames) {

                let xBP = this.browser.genome.getCumulativeOffset(name);
                let wBP = this.browser.genome.getChromosome(name).bpLength;

                let x = Math.round(xBP / bpPerPixel);
                let w = Math.round(wBP / bpPerPixel);

                this.renderChromosomeRect(context, x, 0, w, pixelHeight, name);
            }

            context.restore();

        }

        doDraw({context, referenceFrame, pixelWidth, pixelHeight, bpStart}) {

            context.clearRect(0, 0, pixelWidth, pixelHeight);

            const tickHeight = 6;
            const shim = 2;

            const bpLength = Math.floor(referenceFrame.toBP(pixelWidth));
            const tick = findSpacing(bpLength, context.isSVG);

            let nTick = Math.floor(bpStart / tick.majorTick) - 1;

            const {tickDelta, labelLength} = calculateDeltas(context, referenceFrame, bpStart, nTick, tick);

            this.browser.referenceFrameList.indexOf(referenceFrame);
            // console.log(`ruler(${ index }) label-length ${ labelLength > tickDelta ? 'clobbers' : 'less than' } tick-delta ${ StringUtils.numberFormatter(tickDelta)} `)

            let xTick;
            let bp;
            let accumulatedTickDelta = tickDelta;
            const labelLengthShim = 0.25 * labelLength;
            do {

                bp = Math.floor(nTick * tick.majorTick);
                const rulerLabel = `${numberFormatter$1(Math.floor(bp / tick.unitMultiplier))} ${tick.majorUnit}`;

                xTick = Math.round(referenceFrame.toPixels((bp - 1) - bpStart + 0.5));
                const xLabel = Math.round(xTick - context.measureText(rulerLabel).width / 2);

                if (xLabel > 0 && (labelLengthShim + labelLength) <= accumulatedTickDelta) {
                    IGVGraphics.fillText(context, rulerLabel, xLabel, this.height - (tickHeight / 0.75));
                    accumulatedTickDelta = 0;
                }

                if (xTick > 0) {
                    IGVGraphics.strokeLine(context, xTick, this.height - tickHeight, xTick, this.height - shim);
                }

                bp = Math.floor((1 + nTick) * tick.majorTick);
                let pixel = Math.round(referenceFrame.toPixels((bp - 1) - bpStart + 0.5));
                let delta = (pixel - xTick) / 2;
                let xx = xTick + delta;
                if (xx > 0) {
                    IGVGraphics.strokeLine(context, xx, this.height - tickHeight, xx, this.height - shim);
                }

                ++nTick;
                accumulatedTickDelta += tickDelta;

            } while (xTick < pixelWidth)

            IGVGraphics.strokeLine(context, 0, this.height - shim, pixelWidth, this.height - shim);

        }

        renderChromosomeRect(ctx, x, y, w, h, name) {

            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = '12px sans-serif';

            IGVGraphics.strokeLine(ctx, x + w, y, x + w, y + h, {strokeStyle: IGVColor.greyScale(191)});

            const shortName = (name.startsWith("chr")) ? name.substring(3) : name;

            if (w > ctx.measureText(shortName).width) {
                IGVGraphics.fillText(ctx, shortName, (x + (w / 2)), (y + (h / 2)), {fillStyle: IGVColor.greyScale(68)});
            }
        }

        get supportsWholeGenome() {
            return true
        };

        dispose() {
            // do stuff
        }
    }

    function findSpacing(bpLength, isSVG) {

        if (bpLength < 10) {
            return new Tick(1, 'bp', 1)
        }

        const nZeroes = Math.floor(Math.log10(bpLength));

        let majorUnit = 'bp';
        let unitMultiplier = 1;

        if (nZeroes > 9) {
            majorUnit = 'gb';
            unitMultiplier = 1e9;
        } else if (nZeroes > 6) {
            majorUnit = 'mb';
            unitMultiplier = 1e6;
        } else if (nZeroes > 3) {
            majorUnit = 'kb';
            unitMultiplier = 1e3;
        }

        const denom = Math.pow(10, nZeroes - 1);
        const nMajorTicks = bpLength / denom;

        // const threshold = 25
        const threshold = 3 * 25;

        const belowThresholdTick = Math.pow(10, nZeroes - 1);
        const aboveThresholdTick = Math.pow(10, nZeroes) / 2;

        // console.log(`zeros ${ nZeroes } tick-threshold ${ threshold } ticks ${ nMajorTicks } belowTick ${ StringUtils.numberFormatter(belowThresholdTick) } aboveTick ${ StringUtils.numberFormatter(aboveThresholdTick) }`)

        const majorTick = (nMajorTicks < threshold && isSVG !== true) ? belowThresholdTick : aboveThresholdTick;

        return new Tick(majorTick, majorUnit, unitMultiplier)
    }

    function calculateDeltas(context, referenceFrame, bpStart, nTick, tick) {

        const tickDelta = getX(referenceFrame, getBP(1 + nTick, tick), bpStart) - getX(referenceFrame, getBP(nTick, tick), bpStart);

        const label = `${numberFormatter$1(Math.floor(getBP(nTick, tick) / tick.unitMultiplier))} ${tick.majorUnit}`;
        const labelLength = Math.floor(context.measureText(label).width);

        return {tickDelta, labelLength}

        function getBP(nTick, tick) {
            return Math.floor(nTick * tick.majorTick)
        }

        function getX(referenceFrame, bp, bpStart) {
            return Math.round(referenceFrame.toPixels((bp - 1) - bpStart + 0.5))
        }
    }

    class Tick {

        constructor(majorTick, majorUnit, unitMultiplier) {
            this.majorTick = majorTick;
            this.minorTick = majorTick / 10.0;
            this.majorUnit = majorUnit;
            this.unitMultiplier = unitMultiplier;
        }

        description(blurb) {
            console.log((blurb || '') + ' tick ' + numberFormatter(this.majorTick) + ' label width ' + numberFormatter(this.labelWidthBP) + ' multiplier ' + this.unitMultiplier);
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 University of California San Diego
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    const CircularViewControl = function (parent, browser) {

        this.button = domUtils.div({class: 'igv-navbar-button'});
        parent.appendChild(this.button);
        this.button.textContent = 'circular view';

        this.button.addEventListener('click', () => {
            browser.circularViewVisible = !browser.circularViewVisible;
            //this.setState(browser.circularViewVisible)
        });

        this.browser = browser;

        this.setVisibility(browser.config.showCircularViewButton);

        this.setState(browser.circularViewVisible);

    };

    CircularViewControl.prototype.setVisibility = function (showCircularViewButton) {
        if (true === showCircularViewButton) {
            this.show();
        } else {
            this.hide();
        }
    };

    CircularViewControl.prototype.setState = function (circularViewVisible) {
        if (true === circularViewVisible) {
            this.button.classList.add('igv-navbar-button-clicked');
        } else {
            this.button.classList.remove('igv-navbar-button-clicked');
        }
    };

    CircularViewControl.prototype.show = function () {
        this.button.style.display = 'block';
        this.setState(this.browser.circularViewVisible);
    };

    CircularViewControl.prototype.hide = function () {
        this.button.style.display = 'none';
    };

    /**
     * User supplied button for the navbar
     */

    const CustomButton = function (parent, browser, b) {

        const button = domUtils.div({class: 'igv-navbar-button'});
        parent.append(button);
        button.textContent = b.label;
        button.addEventListener('click', () => b.callback(browser));
    };

    class ROIManager {

        constructor(browser, roiMenu, roiTable, top, roiSets) {

            this.browser = browser;
            this.roiMenu = roiMenu;
            this.roiTable = roiTable;
            this.top = top;
            this.roiSets = roiSets || [];
            this.boundLocusChangeHandler = locusChangeHandler.bind(this);
            browser.on('locuschange', this.boundLocusChangeHandler);

        }

        async initialize() {

            if (this.roiSets.length > 0) {
                this.browser.showROITableButton = true;
                this.browser.roiTableControl.setVisibility(this.browser.showROITableButton);
            }

            const promises = this.roiSets.map(roiSet => this.renderROISet({
                browser: this.browser,
                pixelTop: this.top,
                roiSet
            }));

            if (promises.length > 0) {
                await Promise.all(promises);
            }

            const records = await this.getTableRecords();
            this.roiTable.renderTable(records);

        }

        async loadROI(config, genome) {

            const configs = Array.isArray(config) ? config : [config];

            for (let c of configs) {
                this.roiSets.push(new ROISet(c, genome));
            }

            await this.initialize();

        }

        clearROIs() {

            this.roiTable.clearTable();

            const elements = this.browser.columnContainer.querySelectorAll('.igv-roi-region');
            for (let el of elements) {
                el.remove();
            }

            for (let roiSet of this.roiSets) {
                roiSet.dispose();
            }

            this.roiSets = [];

        }

        async getTableRecords() {

            const records = [];

            for (let roiSet of this.roiSets) {
                const setName = roiSet.isUserDefined ? '' : (roiSet.name || '');
                const allFeatures = await roiSet.getAllFeatures();
                for (let chr of Object.keys(allFeatures)) {
                    for (let feature of allFeatures[chr]) {
                        records.push({setName, feature});
                    }
                }
            }

            return records
        }

        presentTable() {
            this.roiTable.present();
        }

        async repaintTable() {
            const records = await this.getTableRecords();
            this.roiTable.renderTable(records);
        }

        dismissTable() {
            this.roiTable.dismiss();
        }

        async updateUserDefinedROISet(feature) {

            let userDefinedROISet = await this.getUserDefinedROISet();

            if (undefined === userDefinedROISet) {
                userDefinedROISet = this.initializeUserDefinedROISet();
            }

            userDefinedROISet.addFeature(feature);

            if (false === this.browser.showROITableButton) {
                this.setROITableButtonVisibility(true);
            }

            await this.renderROISet({browser: this.browser, pixelTop: this.top, roiSet: userDefinedROISet});

            const records = await this.getTableRecords();
            this.roiTable.renderTable(records);
        }

        setROITableButtonVisibility(isVisible) {
            this.browser.showROITableButton = isVisible;
            this.browser.roiTableControl.setVisibility(this.browser.showROITableButton);
        }

        async renderAllROISets() {

            for (let roiSet of this.roiSets) {
                await this.renderROISet({browser: this.browser, pixelTop: this.top, roiSet});
            }
        }

        async renderROISet({browser, pixelTop, roiSet}) {

            const columns = browser.columnContainer.querySelectorAll('.igv-column');

            for (let i = 0; i < columns.length; i++) {

                let {chr, start: viewStart, end: viewEnd, bpPerPixel} = browser.referenceFrameList[i];

                const elements = columns[i].querySelectorAll('.igv-roi-region');
                for (let el of elements) {
                    const regionKey = el.dataset.region;
                    const {chr: regionChr, start: regionStart, end: regionEnd} = parseRegionKey(regionKey);
                    if (regionChr !== chr || regionEnd < viewStart || regionStart > viewEnd) {
                        el.remove();
                    }
                }

                const features = await roiSet.getFeatures(chr, viewStart, viewEnd);

                if (features) {

                    for (let feature of features) {

                        const regionKey = createRegionKey(chr, feature.start, feature.end);

                        const {
                            x: pixelX,
                            width: pixelWidth
                        } = screenCoordinates(Math.max(viewStart, feature.start), Math.min(viewEnd, feature.end), viewStart, bpPerPixel);


                        const el = columns[i].querySelector(createSelector(regionKey));

                        if (el) {
                            el.style.left = `${pixelX}px`;
                            el.style.width = `${pixelWidth}px`;

                        } else {
                            const element = this.createRegionElement(browser.columnContainer, pixelTop, pixelX, pixelWidth, roiSet, regionKey, feature.name);
                            columns[i].appendChild(element);
                        }
                    }
                }
            }
        }

        createRegionElement(columnContainer, pixelTop, pixelX, pixelWidth, roiSet, regionKey, name) {

            const regionElement = domUtils.div({class: 'igv-roi-region'});

            regionElement.style.top = `${pixelTop}px`;
            regionElement.style.left = `${pixelX}px`;
            regionElement.style.width = `${pixelWidth}px`;
            regionElement.style.backgroundColor = roiSet.color;
            regionElement.dataset.region = regionKey;

            const header = domUtils.div();
            regionElement.appendChild(header);

            header.style.backgroundColor = roiSet.headerColor;

            if (true === roiSet.isUserDefined) {
                header.addEventListener('click', event => {
                    event.preventDefault();
                    event.stopPropagation();

                    const {x, y} = domUtils.translateMouseCoordinates(event, columnContainer);
                    this.roiMenu.present(x, y, this, columnContainer, regionElement);
                });
            } else if (name) {
                header.addEventListener('click', event => {
                    event.preventDefault();
                    event.stopPropagation();
                    if (this.popover) {
                        this.popover.dispose();
                    }
                    this.popover = new Popover(columnContainer, roiSet.name);
                    this.popover.presentContentWithEvent(event, name);
                });
            } else {
                header.style.pointerEvents = 'none';
            }

            return regionElement
        }

        renderSVGContext(context, {deltaX, deltaY}) {

            for (const regionElement of document.querySelectorAll('.igv-roi-region')) {

                // body
                const { x, y, width, height } = regionElement.getBoundingClientRect();
                context.fillStyle = regionElement.style.backgroundColor;
                context.fillRect(x+deltaX, y+deltaY, width, height);

                // header
                const header = regionElement.querySelector('div');
                const { x:xx, y:yy, width:ww, height:hh } = header.getBoundingClientRect();
                context.fillStyle = header.style.backgroundColor;
                context.fillRect(xx+deltaX, yy+deltaY, ww, hh);
            }
        }

        async getUserDefinedROISet() {
            return this.roiSets.find(roiSet => true === roiSet.isUserDefined)
        }

        initializeUserDefinedROISet() {

            const config =
                {
                    isUserDefined: true,
                    features: []
                };
            const userDefinedROISet = new ROISet(config, this.browser.genome);
            this.roiSets.push(userDefinedROISet);

            return userDefinedROISet
        }

        async deleteUserDefinedRegionWithKey(regionKey, columnContainer) {

            columnContainer.querySelectorAll(createSelector(regionKey)).forEach(node => node.remove());

            const feature = await this.findUserDefinedRegionWithKey(regionKey);

            const set = await this.getUserDefinedROISet();

            if (set) {
                set.removeFeature(feature);
            }

            const records = await this.getTableRecords();

            if (0 === records.length) {
                this.browser.roiTableControl.buttonHandler(false);
                this.setROITableButtonVisibility(false);
            }

        }

        async findUserDefinedRegionWithKey(regionKey) {

            const {chr, start, end} = parseRegionKey(regionKey);
            const set = await this.getUserDefinedROISet();

            if (set) {
                const features = await set.getFeatures(chr, start, end);

                for (let feature of features) {
                    if (feature.chr === chr && feature.start >= start && feature.end <= end) {
                        return feature
                    }
                }
            }

            return undefined
        }

        toJSON() {
            return this.roiSets.map(roiSet => roiSet.toJSON())
        }

        dispose() {

            this.browser.off('locuschange', this.boundLocusChangeHandler);

            const removable = this.browser.columnContainer.querySelectorAll('.igv-roi-region');

            for (let el of removable) {
                el.remove();
            }

            if (this.roiMenu) {
                this.roiMenu.dispose();
            }

            if (this.roiTable) {
                this.roiTable.dispose();
            }

            for (let roiSet of this.roiSets) {
                roiSet.dispose();
            }

            for (let key of Object.keys(this)) {
                this[key] = undefined;
            }

        }
    }

    function locusChangeHandler() {
        this.renderAllROISets();
    }

    function createRegionKey(chr, start, end) {
        return `${chr}-${start}-${end}`
    }

    function createSelector(regionKey) {
        return `[data-region="${regionKey}"]`
    }

    function parseRegionKey(regionKey) {
        let [chr, ss, ee] = regionKey.split('-');
        ss = parseInt(ss);
        ee = parseInt(ee);

        return {chr, start: ss, end: ee, locus: `${chr}:${ss}-${ee}`, bedRecord: `${chr}\t${ss}\t${ee}`}
    }

    class ROITable extends RegionTableBase {
        constructor(config) {

            const cooked = Object.assign({ 'width':'512px' }, config);
            super(cooked);
        }

        tableRowDOM(record) {

            const dom = domUtils.div({ class: 'igv-roi-table-row' });

            const { setName, feature } = record;
            dom.dataset.region = createRegionKey(feature.chr, feature.start, feature.end);

            let strings =
                [
                    feature.chr,
                    numberFormatter$1(feature.start),
                    numberFormatter$1(feature.end),
                    feature.name || '',
                    setName
                ];

            if (4 === this.columnFormat.length) {
                strings = strings.slice(0, 4);
            }

            for (let i = 0; i < strings.length; i++) {
                const el = domUtils.div();
                dom.appendChild(el);
                el.style.width = this.columnFormat[ i ].width;
                el.innerText = strings[ i ];
            }

            this.tableRowDOMHelper(dom);

            return dom
        }

        renderTable(records) {

            Array.from(this.tableRowContainer.querySelectorAll('.igv-roi-table-row')).forEach(el => el.remove());

            if (records.length > 0) {

                const sortedRecords = records.sort((a, b) => (a.feature.chr.localeCompare(b.feature.chr) || a.feature.start - b.feature.start || a.feature.end - b.feature.end));

                for (let record of sortedRecords) {
                    const row = this.tableRowDOM(record);
                    this.tableRowContainer.appendChild(row);
                }

            }
        }

        dispose() {

            document.removeEventListener('click', this.boundGotoButtonHandler);

            this.browser.roiTableControl.buttonHandler(false);
            super.dispose();
        }

        static getColumnFormatConfiguration(doIncludeROISetNames) {

            if (true === doIncludeROISetNames) {

                return [
                        { label: 'Chr', width: '20%' },
                        { label: 'Start', width: '15%' },
                        { label: 'End', width: '15%' },
                        { label: 'Description', width: '30%' },
                        { label: 'ROI Set', width: '20%' }
                    ]
            } else {
                return [
                        { label: 'Chr', width: '25%' },
                        { label: 'Start', width: '20%' },
                        { label: 'End', width: '20%' },
                        { label: 'Description', width: '35%' }
                    ]
            }

        }

        static gotoButtonHandler (event) {

            event.stopPropagation();

            const selected = this.tableDOM.querySelectorAll('.igv-roi-table-row-selected');
            const loci = [];
            for (let el of selected) {
                const { locus } = parseRegionKey(el.dataset.region);
                loci.push(locus);
            }

            for (let el of this.tableDOM.querySelectorAll('.igv-roi-table-row')) {
                el.classList.remove('igv-roi-table-row-selected');
            }

            this.setTableRowSelectionState(false);

            if (loci.length > 0) {
                this.browser.search(loci.join(' '));
            }

        }

    }

    class ROIMenu {
        constructor(browser, parent) {

            this.browser = browser;

            // container
            this.container = domUtils.div({ class: 'igv-roi-menu-next-gen' });
            parent.appendChild(this.container);

            // header
            const header = domUtils.div();
            this.container.appendChild(header);

            uiUtils.attachDialogCloseHandlerWithParent(header, () => this.container.style.display = 'none');

            // body
            this.body = domUtils.div();
            this.container.appendChild(this.body);

            this.container.style.display = 'none';

        }

        async present(x, y, roiManager, columnContainer, regionElement) {

            removeAllChildNodes(this.body);

            const feature = await this.browser.roiManager.findUserDefinedRegionWithKey(regionElement.dataset.region);

            // Description Copy
            const _description_copy_ = domUtils.div();
            this.body.appendChild(_description_copy_);

            const placeholder = 'Description';
            const str = (feature.name || placeholder);

            _description_copy_.innerText = str;
            _description_copy_.setAttribute('title', str);
            placeholder === str ? _description_copy_.classList.add('igv-roi-placeholder') : _description_copy_.classList.remove('igv-roi-placeholder');


            // Set Description
            const description = domUtils.div();
            this.body.appendChild(description);
            description.innerText = 'Set Description';

            description.addEventListener('click', event => {

                event.stopPropagation();

                this.container.style.display = 'none';

                const callback = () => {

                    const value = this.browser.inputDialog.value || '';
                    feature.name = value.trim();

                    this.container.style.display = 'none';

                    this.browser.roiManager.repaintTable();
                };

                const config =
                    {
                        label: 'Description',
                        value: (feature.name || ''),
                        callback
                    };

                this.browser.inputDialog.present(config, event);

            });


            // Delete Region
            const _delete_ = domUtils.div();
            this.body.appendChild(_delete_);
            _delete_.innerText = 'Delete Region';

            _delete_.addEventListener('click', event => {
                event.stopPropagation();
                this.container.style.display = 'none';
                this.browser.roiManager.deleteUserDefinedRegionWithKey(regionElement.dataset.region, this.browser.columnContainer);
            });







            // columnContainer.addEventListener('click', event => {
            //     event.stopPropagation()
            //     this.container.style.display = 'none'
            // })

            this.container.style.left = `${ x }px`;
            this.container.style.top  = `${ y }px`;
            this.container.style.display = 'flex';

        }

        async __present(x, y, roiManager, columnContainer, regionElement) {

            removeAllChildNodes(this.container);

            const feature = await this.browser.roiManager.findUserDefinedRegionWithKey(regionElement.dataset.region);

            let row;

            // Go To
            // row = DOMUtils.div({ class: 'igv-roi-menu-row' })
            // row.innerText = 'Go To'
            // this.container.appendChild(row)
            //
            // row.addEventListener('click', event => {
            //     event.stopPropagation()
            //     this.container.style.display = 'none'
            //
            //     const { locus } = parseRegionKey(regionElement.dataset.region)
            //     this.browser.search(locus)
            // })

            // Description:
            row = domUtils.div({ class: 'igv-roi-menu-row-edit-description' });
            this.container.appendChild(row);

            row.addEventListener('click', e => {
                e.stopPropagation();
            });

            const str = 'description-input';

            const label = document.createElement('label');
            row.appendChild(label);

            label.setAttribute('for', str);
            label.innerText = 'Description:';

            const input = document.createElement('input');
            row.appendChild(input);

            input.setAttribute('type', 'text');
            input.setAttribute('name', str);
            // input.setAttribute('placeholder', feature.name || 'Edit Description')
            input.setAttribute('placeholder', '');
            input.value = feature.name || '';

            input.addEventListener('change', async e => {

                e.stopPropagation();

                const feature = await this.browser.roiManager.findUserDefinedRegionWithKey(regionElement.dataset.region);
                feature.name = input.value;

                input.blur();
                this.container.style.display = 'none';

                await this.browser.roiManager.repaintTable();
            });


            // Delete
            row = domUtils.div({ class: 'igv-roi-menu-row' });
            row.innerText = 'Delete region';
            this.container.appendChild(row);

            row.addEventListener('click', event => {
                event.stopPropagation();
                this.container.style.display = 'none';
                this.browser.roiManager.deleteUserDefinedRegionWithKey(regionElement.dataset.region, this.browser.columnContainer);
            });

            this.container.style.left = `${ x }px`;
            this.container.style.top  = `${ y }px`;
            this.container.style.display = 'flex';

            columnContainer.addEventListener('click', event => {
                event.stopPropagation();
                this.container.style.display = 'none';
            });

        }

        dispose() {
            this.container.innerHTML = '';
        }

    }

    function removeAllChildNodes(parent) {
        while (parent.firstChild) {
            parent.removeChild(parent.firstChild);
        }
    }

    class TrackROISet {

        constructor(config, genome) {
            this.name = config.name;
            this.featureSource = config.featureSource || FeatureSource(config, genome);
            this.color = config.color || ROI_DEFAULT_COLOR;
        }

        async getFeatures(chr, start, end) {
            return this.featureSource.getFeatures({chr, start, end})
        }

        draw(drawConfiguration) {

            const { context, bpPerPixel, bpStart, pixelTop, pixelHeight, pixelWidth, features, } = drawConfiguration;

            if (!features) {
                return
            }

            const bpEnd = bpStart + (pixelWidth * bpPerPixel) + 1;
            for (let { start:regionStartBP, end:regionEndBP } of features) {

                if (regionEndBP < bpStart) {
                    continue
                }

                if (regionStartBP > bpEnd) {
                    break
                }

                const { x, width } = screenCoordinates(regionStartBP, regionEndBP, bpStart, bpPerPixel);
                IGVGraphics.fillRect(context, x, pixelTop, width, pixelHeight, { fillStyle: this.color });
            }
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 University of California San Diego
     * Author: Jim Robinson
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    class ROITableControl {

        constructor(parent, browser) {
            this.browser = browser;
            this.button = domUtils.div({class: 'igv-navbar-button'});
            parent.appendChild(this.button);
            this.button.textContent = 'ROI Table';

            this.button.addEventListener('click', () => {
                this.buttonHandler(!browser.roiTableVisible);
            });

            this.browser = browser;

            this.setVisibility(browser.showROITableButton);

            this.setState(browser.roiTableVisible);
        }

        buttonHandler(status) {
            this.browser.roiTableVisible = status;
            this.setState(this.browser.roiTableVisible);
            this.browser.setROITableVisibility(this.browser.roiTableVisible);
        }

        setVisibility(doShowROITablelButton) {
            if (true === doShowROITablelButton) {
                this.show();
            } else {
                this.hide();
            }
        }

        setState(roiTableVisible) {
            if (true === roiTableVisible) {
                this.button.classList.add('igv-navbar-button-clicked');
            } else {
                this.button.classList.remove('igv-navbar-button-clicked');
            }
        }

        show() {
            this.button.style.display = 'block';
            this.setState(this.browser.roiTableVisible);
        }

        hide() {
            this.button.style.display = 'none';
        }
    }

    // css - $igv-scrollbar-outer-width: 14px;
    const igv_scrollbar_outer_width = 14;

    // css - $igv-track-drag-column-width: 12px;
    const igv_track_manipulation_handle_width = 12;

    // css - $igv-track-gear-menu-column-width: 28px;
    const igv_track_gear_menu_column_width = 28;

    // $igv-column-shim-width: 1px;
    // $igv-column-shim-margin: 2px;
    const column_multi_locus_shim_width = 2 + 1 + 2;

    const defaultSampleNameViewportWidth = 200;

    class Browser {

        constructor(config, parentDiv) {

            this.config = config;
            this.guid = domUtils.guid();
            this.namespace = '.browser_' + this.guid;

            this.parent = parentDiv;

            this.root = domUtils.div({class: 'igv-container'});
            parentDiv.appendChild(this.root);

            this.alert = new Alert(this.root);

            this.columnContainer = domUtils.div({class: 'igv-column-container'});
            this.root.appendChild(this.columnContainer);

            this.menuPopup = new MenuPopup(this.columnContainer);

            this.initialize(config);

            this.trackViews = [];

            this.constants = {
                dragThreshold: 3,
                scrollThreshold: 5,
                defaultColor: "rgb(0,0,150)",
                doubleClickDelay: config.doubleClickDelay || 500
            };

            // Map of event name -> [ handlerFn, ... ]
            this.eventHandlers = {};

            this.addMouseHandlers();

            this.setControls(config);
        }

        initialize(config) {

            if (config.gtex) {
                GtexUtils.gtexLoaded = true;
            }
            this.flanking = config.flanking;
            this.crossDomainProxy = config.crossDomainProxy;
            this.formats = config.formats;
            this.trackDefaults = config.trackDefaults;
            this.nucleotideColors = config.nucleotideColors || defaultNucleotideColors;
            for (let key of Object.keys(this.nucleotideColors)) {
                this.nucleotideColors[key.toLowerCase()] = this.nucleotideColors[key];
            }

            this.trackLabelsVisible = config.showTrackLabels;

            this.roiTableVisible = config.showROITable;
            this.showROITableButton = config.showROITableButton;

            this.isCenterLineVisible = config.showCenterGuide;

            this.cursorGuideVisible = config.showCursorGuide;

            this.showSampleNames = config.showSampleNames;
            this.showSampleNameButton = config.showSampleNameButton;
            this.sampleNameViewportWidth = config.sampleNameViewportWidth || defaultSampleNameViewportWidth;

            if (config.search) {
                this.searchConfig = {
                    type: "json",
                    url: config.search.url,
                    coords: config.search.coords === undefined ? 1 : config.search.coords,
                    chromosomeField: config.search.chromosomeField || "chromosome",
                    startField: config.search.startField || "start",
                    endField: config.search.endField || "end",
                    geneField: config.search.geneField || "gene",
                    snpField: config.search.snpField || "snp",
                    resultsField: config.search.resultsField
                };
            }
        }

        setControls(config) {

            const $navBar = this.createStandardControls(config);
            $navBar.insertBefore($$1(this.columnContainer));
            this.$navigation = $navBar;

            if (false === config.showControls) {
                $navBar.hide();
            }

        }

        createStandardControls(config) {

            this.navbarManager = new NavbarManager(this);

            const $navBar = $$1('<div>', {class: 'igv-navbar'});
            this.$navigation = $navBar;

            const $navbarLeftContainer = $$1('<div>', {class: 'igv-navbar-left-container'});
            $navBar.append($navbarLeftContainer);

            // IGV logo
            const $logo = $$1('<div>', {class: 'igv-logo'});
            $navbarLeftContainer.append($logo);

            const logoSvg = logo();
            logoSvg.css("width", "34px");
            logoSvg.css("height", "32px");
            $logo.append(logoSvg);

            this.$current_genome = $$1('<div>', {class: 'igv-current-genome'});
            $navbarLeftContainer.append(this.$current_genome);
            this.$current_genome.text('');

            const $genomicLocation = $$1('<div>', {class: 'igv-navbar-genomic-location'});
            $navbarLeftContainer.append($genomicLocation);

            // chromosome select widget
            this.chromosomeSelectWidget = new ChromosomeSelectWidget(this, $genomicLocation.get(0));
            if (undefined === config.showChromosomeWidget) {
                config.showChromosomeWidget = true;   // Default to true
            }
            if (true === config.showChromosomeWidget) {
                this.chromosomeSelectWidget.show();
            } else {
                this.chromosomeSelectWidget.hide();
            }

            const $locusSizeGroup = $$1('<div>', {class: 'igv-locus-size-group'});
            $genomicLocation.append($locusSizeGroup);

            const $searchContainer = $$1('<div>', {class: 'igv-search-container'});
            $locusSizeGroup.append($searchContainer);

            // browser.$searchInput = $('<input type="text" placeholder="Locus Search">');
            this.$searchInput = $$1('<input>', {class: 'igv-search-input', type: 'text', placeholder: 'Locus Search'});
            $searchContainer.append(this.$searchInput);

            this.$searchInput.change(() => this.doSearch(this.$searchInput.val()));

            const searchIconContainer = domUtils.div({class: 'igv-search-icon-container'});
            $searchContainer.append($$1(searchIconContainer));

            searchIconContainer.appendChild(icons$1.createIcon("search"));

            searchIconContainer.addEventListener('click', () => this.doSearch(this.$searchInput.val()));

            this.windowSizePanel = new WindowSizePanel($locusSizeGroup.get(0), this);

            const $navbarRightContainer = $$1('<div>', {class: 'igv-navbar-right-container'});
            $navBar.append($navbarRightContainer);

            const $toggle_button_container = $$1('<div class="igv-navbar-toggle-button-container">');
            $navbarRightContainer.append($toggle_button_container);
            this.$toggle_button_container = $toggle_button_container;

            this.cursorGuide = new CursorGuide(this.columnContainer, this);

            this.cursorGuideButton = new CursorGuideButton(this, $toggle_button_container.get(0));

            this.centerLineButton = new CenterLineButton(this, $toggle_button_container.get(0));

            this.setTrackLabelVisibility(config.showTrackLabels);
            this.trackLabelControl = new TrackLabelControl($toggle_button_container.get(0), this);

            // ROI Control
            this.roiTableControl = new ROITableControl($toggle_button_container.get(0), this);

            this.sampleNameControl = new SampleNameControl($toggle_button_container.get(0), this);

            if (true === config.showSVGButton) {
                this.svgSaveControl = new SVGSaveControl($toggle_button_container.get(0), this);
            }

            if (config.customButtons) {
                for (let b of config.customButtons) {
                    new CustomButton($toggle_button_container.get(0), this, b);
                }
            }

            this.zoomWidget = new ZoomWidget(this, $navbarRightContainer.get(0));

            if (false === config.showNavigation) {
                this.$navigation.hide();
            }

            this.inputDialog = new InputDialog(this.root);
            this.inputDialog.container.id = `igv-input-dialog-${domUtils.guid()}`;

            this.dataRangeDialog = new DataRangeDialog(this, $$1(this.root));
            this.dataRangeDialog.$container.get(0).id = `igv-data-range-dialog-${domUtils.guid()}`;

            this.genericColorPicker = new GenericColorPicker({parent: this.columnContainer, width: 432});
            this.genericColorPicker.container.id = `igv-track-color-picker-${domUtils.guid()}`;

            return $navBar

        }

        getSampleNameViewportWidth() {
            return false === this.showSampleNames ? 0 : this.sampleNameViewportWidth
        }

        isMultiLocusMode() {
            return this.referenceFrameList && this.referenceFrameList.length > 1
        };

        addTrackToFactory(name, track) {
            TrackFactory.addTrack(name, track);
        }

        isMultiLocusWholeGenomeView() {

            if (undefined === this.referenceFrameList || 1 === this.referenceFrameList.length) {
                return false
            }

            for (let referenceFrame of this.referenceFrameList) {
                if ('all' === referenceFrame.chr.toLowerCase()) {
                    return true
                }
            }

            return false
        };

        /**
         * PUBLIC API FUNCTION
         *
         * Return the current genomic region as a locus string, or array of locus strings if in multi-locus view
         * @returns {string|*[]|*}
         */
        currentLoci() {
            const noCommaLocusString = (rf) => `${rf.chr}:${rf.start + 1}-${rf.end}`;
            if (undefined === this.referenceFrameList || 0 === this.referenceFrameList.length) {
                return ""
            } else if (1 === this.referenceFrameList.length) {
                return noCommaLocusString(this.referenceFrameList[0])
            } else {
                return this.referenceFrameList.map(rf => noCommaLocusString(rf))
            }
        }

        /**
         * Render browse display as SVG
         * @returns {string}
         */
        toSVG() {

            const {y, width, height} = this.columnContainer.getBoundingClientRect();

            const h_render = 8000;

            const config =
                {

                    width,
                    height: h_render,

                    backdropColor: 'white',

                    multiLocusGap: 0,

                    viewbox:
                        {
                            x: 0,
                            y: 0,
                            width,
                            height: h_render
                        }

                };

            const context = new ctx(config);

            // tracks -> SVG
            const delta = {deltaX: 0, deltaY: -y};
            for (let trackView of this.trackViews) {
                trackView.renderSVGContext(context, delta);
            }

            this.roiManager.renderSVGContext(context, delta);

            // reset height to trim away unneeded svg canvas real estate. Yes, a bit of a hack.
            context.setHeight(height);

            return context.getSerializedSvg(true)

        }

        renderSVG($container) {
            const svg = this.toSVG();
            $container.empty();
            $container.append(svg);

            return svg
        }

        saveSVGtoFile(config) {

            let svg = this.toSVG();

            if (config.$container) {
                config.$container.empty();
                config.$container.append(svg);
            }

            const path = config.filename || 'igvjs.svg';
            const data = URL.createObjectURL(new Blob([svg], {type: "application/octet-stream"}));
            download(path, data);
        }

        /**
         * Initialize a session from an object, json, or by loading from a file.
         *
         * TODO Really should be split into at least 2 functions, load from file and load from object/json
         *
         * @param options
         * @returns {*}
         */
        async loadSession(options) {

            // TODO: depricated
            this.roiSets = [];

            let session;
            if (options.url || options.file) {
                session = await loadSessionFile(options);
            } else {
                session = options;
            }
            return this.loadSessionObject(session)


            async function loadSessionFile(options) {

                const urlOrFile = options.url || options.file;

                if (options.url && (options.url.startsWith("blob:") || options.url.startsWith("data:"))) {
                    const json = Browser.uncompressSession(options.url);
                    return JSON.parse(json)

                } else {
                    let filename = options.filename;
                    if (!filename) {
                        filename = (options.url ? await getFilename$1(options.url) : options.file.name);
                    }

                    if (filename.endsWith(".xml")) {

                        const knownGenomes = GenomeUtils.KNOWN_GENOMES;
                        const string = await igvxhr.loadString(urlOrFile);
                        return new XMLSession(string, knownGenomes)

                    } else if (filename.endsWith(".json")) {
                        return igvxhr.loadJson(urlOrFile)
                    } else {
                        return undefined
                    }
                }
            }
        }


        /**
         * Note:  public API function
         * @param session
         * @returns {Promise<void>}
         */
        async loadSessionObject(session) {

            // prepare to load a new session, discarding DOM and state
            this.cleanHouseForSession();

            this.showSampleNames = session.showSampleNames || false;
            this.sampleNameControl.setState(this.showSampleNames === true);

            if (session.sampleNameViewportWidth) {
                this.sampleNameViewportWidth = session.sampleNameViewportWidth;
            }

            // axis column
            createColumn(this.columnContainer, 'igv-axis-column');

            // SampleName column
            createColumn(this.columnContainer, 'igv-sample-name-column');

            // Track scrollbar column
            createColumn(this.columnContainer, 'igv-scrollbar-column');

            // Track drag/reorder column
            createColumn(this.columnContainer, 'igv-track-drag-column');

            // Track gear column
            createColumn(this.columnContainer, 'igv-gear-menu-column');

            const genomeOrReference = session.reference || session.genome;
            if(!genomeOrReference) {
                console.warn("No genome or reference object specified");
                return;
            }
            const genomeConfig = await GenomeUtils.expandReference(this.alert, genomeOrReference);


            await this.loadReference(genomeConfig, session.locus);

            this.centerLineList = this.createCenterLineList(this.columnContainer);

            // Create ideogram and ruler track.  Really this belongs in browser initialization, but creation is
            // deferred because ideogram and ruler are treated as "tracks", and tracks require a reference frame
            let ideogramHeight = 0;
            if (false !== session.showIdeogram) {

                const track = new IdeogramTrack(this);
                track.id = 'ideogram';

                const trackView = new TrackView(this, this.columnContainer, track);
                const {$viewport} = trackView.viewports[0];
                ideogramHeight = getElementAbsoluteHeight($viewport.get(0));

                this.trackViews.push(trackView);
            }

            if (false !== session.showRuler) {
                this.trackViews.push(new TrackView(this, this.columnContainer, new RulerTrack(this)));
            }

            // Restore gtex selections.
            if (session.gtexSelections) {
                for (let referenceFrame of this.referenceFrameList) {
                    for (let s of Object.keys(session.gtexSelections)) {
                        const gene = session.gtexSelections[s].gene;
                        const snp = session.gtexSelections[s].snp;
                        referenceFrame.selection = new GtexSelection(gene, snp);
                    }
                }
            }

            if (this.roiManager) {
                this.roiManager.dispose();
            }

            const roiMenu = new ROIMenu(this, this.columnContainer);
            const roiTableConfig =
                {
                    browser: this,
                    parent: this.columnContainer,
                    headerTitle: 'Regions of Interest',
                    dismissHandler: () => this.roiTableControl.buttonHandler(false),
                    gotoButtonHandler: ROITable.gotoButtonHandler
                };
            if (session.roi) {

                const roiSetList = session.roi.map(c => new ROISet(c, this.genome));

                const named = roiSetList.filter(({name}) => name !== undefined && name.length > 0);

                roiTableConfig.columnFormat = ROITable.getColumnFormatConfiguration(named.length > 0);

                const roiTable = new ROITable(roiTableConfig);

                this.roiManager = new ROIManager(this, roiMenu, roiTable, ideogramHeight, roiSetList);
            } else {

                roiTableConfig.columnFormat = ROITable.getColumnFormatConfiguration(false);

                const roiTable = new ROITable(roiTableConfig);

                this.roiManager = new ROIManager(this, roiMenu, roiTable, ideogramHeight, undefined);
            }

            await this.roiManager.initialize();

            // Tracks.  Start with genome tracks, if any, then append session tracks
            const genomeTracks = genomeConfig.tracks || [];
            const trackConfigurations = session.tracks ? genomeTracks.concat(session.tracks) : genomeTracks;

            // Ensure that we always have a sequence track with no explicit URL (=> the reference genome sequence track)
            const pushSequenceTrack = trackConfigurations.filter(track => 'sequence' === track.type && !track.url && !track.fastaURL).length === 0;
            if (pushSequenceTrack /*&& false !== this.config.showSequence*/) {
                trackConfigurations.push({type: "sequence", order: defaultSequenceTrackOrder});
            }

            // Maintain track order unless explicitly set
            let trackOrder = 1;
            for (let t of trackConfigurations) {
                if (undefined === t.order) {
                    t.order = trackOrder++;
                }
            }

            await this.loadTrackList(trackConfigurations);

            // The ruler and ideogram tracks are not explicitly loaded, but needs updated nonetheless.
            for (let rtv of this.trackViews.filter((tv) => tv.track.type === 'ruler' || tv.track.type === 'ideogram')) {
                rtv.updateViews();
            }

            this.updateUIWithReferenceFrameList();

        }

        createCenterLineList(columnContainer) {

            const centerLines = columnContainer.querySelectorAll('.igv-center-line');
            for (let i = 0; i < centerLines.length; i++) {
                centerLines[i].remove();
            }

            const centerLineList = [];
            const viewportColumns = columnContainer.querySelectorAll('.igv-column');
            for (let i = 0; i < viewportColumns.length; i++) {
                centerLineList.push(new ViewportCenterLine(this, this.referenceFrameList[i], viewportColumns[i]));
            }

            return centerLineList
        }

        /**
         * Load a reference genome object.  This includes the fasta, and optional cytoband, but no tracks.  This method
         * is used by loadGenome and loadSession.
         *
         * @param genomeConfig
         * @param initialLocus
         */
        async loadReference(genomeConfig, initialLocus) {

            const genome = await GenomeUtils.loadGenome(genomeConfig);

            const genomeChange = undefined === this.genome || (this.genome.id !== genome.id);

            this.genome = genome;

            this.updateNavbarDOMWithGenome(genome);

            if (genomeChange) {
                this.removeAllTracks();
            }

            let locus = getInitialLocus(initialLocus, genome);
            const locusFound = await this.search(locus, true);
            if (!locusFound) {
                console.log("Initial locus not found: " + locus);
                locus = genome.getHomeChromosomeName();
                const locusFound = await this.search(locus, true);
                if (!locusFound) {
                    throw new Error("Cannot set initial locus")
                }
            }

            if (genomeChange && this.circularView) {
                this.circularView.setAssembly({
                    name: this.genome.id,
                    id: this.genome.id,
                    chromosomes: makeCircViewChromosomes(this.genome)
                });
            }
        }

        cleanHouseForSession() {

            for (let trackView of this.trackViews) {
                // empty axis column, viewport columns, sampleName column, scroll column, drag column, gear column
                trackView.removeDOMFromColumnContainer();
            }

            // discard all columns
            const elements = this.columnContainer.querySelectorAll('.igv-axis-column, .igv-column-shim, .igv-column, .igv-sample-name-column, .igv-scrollbar-column, .igv-track-drag-column, .igv-gear-menu-column');
            elements.forEach(column => column.remove());

            this.trackViews = [];

            if (this.circularView) {
                this.circularView.clearChords();
            }

        }

        updateNavbarDOMWithGenome(genome) {

            // If the genome is defined directly from a fasta file or data url the "id" will be the full url.  Don't display
            // this.
            let genomeLabel = (genome.id && genome.id.length < 10 ? genome.id : '');
            this.$current_genome.text(genomeLabel);
            this.$current_genome.attr('title', genome.id || '');
            this.chromosomeSelectWidget.update(genome);
        }

        /**
         * Load a genome, defined by a string ID or a json-like configuration object. This includes a fasta reference
         * as well as optional cytoband and annotation tracks.
         *
         * @param idOrConfig
         * @returns genome
         */
        async loadGenome(idOrConfig) {

            const genomeConfig = await GenomeUtils.expandReference(this.alert, idOrConfig);
            await this.loadReference(genomeConfig, undefined);

            const tracks = genomeConfig.tracks || [];

            // Insure that we always have a sequence track
            const pushSequenceTrack = tracks.filter(track => track.type === 'sequence').length === 0;
            if (pushSequenceTrack) {
                tracks.push({type: "sequence", order: defaultSequenceTrackOrder});
            }

            await this.loadTrackList(tracks);

            await this.updateViews();

            return this.genome
        }

        /**
         * Called after a session load, search, pan (horizontal drag), or resize
         *
         * @param referenceFrameList
         */
        updateUIWithReferenceFrameList() {

            const referenceFrameList = this.referenceFrameList;

            this.updateLocusSearchWidget();

            const isWGV = (this.isMultiLocusWholeGenomeView() || GenomeUtils.isWholeGenomeView(referenceFrameList[0].chr));

            this.navbarManager.navbarDidResize(this.$navigation.width(), isWGV);

            toggleTrackLabels(this.trackViews, this.trackLabelsVisible);

            this.setCenterLineAndCenterLineButtonVisibility(!GenomeUtils.isWholeGenomeView(referenceFrameList[0].chr));

        }

        setTrackLabelVisibility(isVisible) {
            toggleTrackLabels(this.trackViews, isVisible);
        }

        setROITableVisibility(isVisible) {
            true === isVisible ? this.roiManager.presentTable() : this.roiManager.dismissTable();
        }

        // cursor guide
        setCursorGuideVisibility(cursorGuideVisible) {

            if (cursorGuideVisible) {
                this.cursorGuide.show();
            } else {
                this.cursorGuide.hide();
            }
        }

        setCustomCursorGuideMouseHandler(mouseHandler) {
            this.cursorGuide.customMouseHandler = mouseHandler;
        }

        // center line
        setCenterLineVisibility(isCenterLineVisible) {
            for (let centerLine of this.centerLineList) {
                if (true === isCenterLineVisible) {
                    centerLine.show();
                    centerLine.repaint();
                } else {
                    centerLine.hide();
                }
            }
        }

        setCenterLineAndCenterLineButtonVisibility(isCenterLineVisible) {

            for (let centerLine of this.centerLineList) {
                const isShown = isCenterLineVisible && centerLine.isVisible;
                isShown ? centerLine.show() : centerLine.container.style.display = 'none';
            }

            const isShown = isCenterLineVisible && this.centerLineButton.isVisible;
            isShown ? this.centerLineButton.show() : this.centerLineButton.button.style.display = 'none';

        }

        /**
         * Public API function. Load a list of tracks.
         *
         * @param configList  Array of track configurations
         * @returns {Promise<*>}  Promise for track objects
         */
        async loadTrackList(configList) {

            const promises = [];
            for (let config of configList) {
                promises.push(this._loadTrack(config));
            }

            const loadedTracks = await Promise.all(promises);
            const groupAutoscaleViews = this.trackViews.filter(function (trackView) {
                return trackView.track.autoscaleGroup
            });
            if (groupAutoscaleViews.length > 0) {
                this.updateViews();
            }
            return loadedTracks
        }

        /**
         * Public API function
         *
         * Load an individual track.  If part of an autoscale group force a general update
         *
         * @param config  A track configuration
         * @returns {Promise<*>}  Promise for track object
         */
        async loadTrack(config) {

            const newTrack = this._loadTrack(config);

            if (config.autoscaleGroup) {
                // Await newTrack load and update all views
                await newTrack;
                this.updateViews();
            }

            return newTrack
        }

        /**
         * Return a promise to load a track.   Private function used by loadTrack() and loadTrackList()
         *
         * @param config
         * @returns {*}
         */

        async _loadTrack(config) {

            // config might be json
            if (isString$2(config)) {
                config = JSON.parse(config);
            }

            try {

                const newTrack = await this.createTrack(config);

                if (undefined === newTrack) {
                    return
                }

                // Set order field of track here.  Otherwise track order might get shuffled during asynchronous load
                if (undefined === newTrack.order) {
                    newTrack.order = this.trackViews.length;
                }

                const trackView = new TrackView(this, this.columnContainer, newTrack);
                this.trackViews.push(trackView);
                toggleTrackLabels(this.trackViews, this.trackLabelsVisible);
                this.reorderTracks();
                this.fireEvent('trackorderchanged', [this.getTrackOrder()]);

                if (typeof newTrack.postInit === 'function') {
                    try {
                        trackView.startSpinner();
                        await newTrack.postInit();
                    } finally {
                        trackView.stopSpinner();
                    }
                }

                if (!newTrack.autoscaleGroup) {
                    // Group autoscale will get updated later (as a group)
                    if (config.sync) {
                        await trackView.updateViews();
                    } else {
                        trackView.updateViews();
                    }
                }

                if (typeof newTrack.hasSamples === 'function' && newTrack.hasSamples()) {
                    if (this.config.showSampleNameButton !== false) {
                        this.sampleNameControl.show();   // If not explicitly set
                    }
                }

                return newTrack

            } catch (error) {
                const httpMessages =
                    {
                        "401": "Access unauthorized",
                        "403": "Access forbidden",
                        "404": "Not found"
                    };
                console.error(error);
                let msg = error.message || error.error || error.toString();
                if (httpMessages.hasOwnProperty(msg)) {
                    msg = httpMessages[msg];
                }
                msg += (": " + config.url);
                this.alert.present(new Error(msg), undefined);
            }
        }

        /**
         * Public API function - load a region of interest
         *
         * @param config  A "track" configuration object, or array of objects,  of type == "annotation" (bed, gff, etc)
         *
         * @returns {Promise<void>}
         */
        async loadROI(config) {
            await this.roiManager.loadROI(config, this.genome);
        }

        /**
         * Public API function - clear all regions of interest (ROI), including preloaded and user-defined ROIs
         */
        clearROIs() {
            this.roiManager.clearROIs();
        }

        /**
         * Public API function. Return a promise for the list of user-defined regions-of-interest
         */
        async getUserDefinedROIs() {

            if (this.roiManager) {

                const set = await this.roiManager.getUserDefinedROISet();
                if (undefined === set) {
                    return []
                }

                const featureHash = await set.getAllFeatures();
                const featureList = [];
                for (let value of Object.values(featureHash)) {
                    featureList.push(...value);
                }

                return featureList

            } else {
                return []
            }
        }

        getRulerTrackView() {
            const list = this.trackViews.filter(({track}) => 'ruler' === track.id);
            return list.length > 0 ? list[0] : undefined
        }

        /**
         * Create a Track object.
         * @param config
         * @returns {Promise<*>}
         */
        async createTrack(config) {

            // Resolve function and promise urls
            let url = await resolveURL(config.url || config.fastaURL);
            if (isString$2(url)) {
                url = url.trim();
            }

            if (url) {
                if (config.format) {
                    config.format = config.format.toLowerCase();
                } else if (config.fastaURL) {
                    config.format = "fasta";  // by definition
                } else {
                    let filename = config.filename;
                    if (!filename) {
                        filename = await getFilename$1(url);
                    }

                    const format = inferFileFormat(filename);

                    if ("tsv" === format) {
                        config.format = await inferFileFormatFromHeader(config);
                    } else if (format) {
                        config.format = format;
                    } else {
                        if (config.sourceType === "htsget") {
                            // Check for htsget URL.  This is a longshot
                            await HtsgetReader.inferFormat(config);
                        }
                    }
                }
            }


            let type = config.type ? config.type.toLowerCase() : undefined;

            if (!type) {
                type = inferTrackType(config);
                if ("bedtype" === type) {
                    // Bed files must be read to determine track type
                    const featureSource = FeatureSource(config, this.genome);
                    config._featureSource = featureSource;    // This is a temp variable, bit of a hack
                    const trackType = await featureSource.trackType();
                    if (trackType) {
                        type = trackType;
                    } else {
                        type = "annotation";
                    }
                }
                // Record in config to make type persistent in session
                config.type = type;
            }

            // Set defaults if specified
            if (this.trackDefaults && type) {
                const settings = this.trackDefaults[type];
                if (settings) {
                    for (let property in settings) {
                        if (settings.hasOwnProperty(property) && config[property] === undefined) {
                            config[property] = settings[property];
                        }
                    }
                }
            }

            const track = TrackFactory.getTrack(type, config, this);
            if (undefined === track) {
                this.alert.present(new Error(`Error creating track.  Could not determine track type for file: ${config.url || config}`), undefined);
            } else {

                if (config.roi && config.roi.length > 0) {
                    track.roiSets = config.roi.map(r => new TrackROISet(r, this.genome));
                }

                return track
            }
        }


        reorderTracks() {

            this.trackViews.sort(function (a, b) {

                const firstSortOrder = tv => {
                    return 'ideogram' === tv.track.id ? 1 :
                        'ruler' === tv.track.id ? 2 :
                            3
                };

                const aOrder1 = firstSortOrder(a);
                const bOrder1 = firstSortOrder(b);
                if (aOrder1 === bOrder1) {
                    const aOrder2 = a.track.order || 0;
                    const bOrder2 = b.track.order || 0;
                    return aOrder2 - bOrder2
                } else {
                    return aOrder1 - bOrder1
                }
            });

            // discard current track order
            for (let {axis, viewports, sampleNameViewport, outerScroll, dragHandle, gearContainer} of this.trackViews) {

                axis.remove();

                for (let {$viewport} of viewports) {
                    $viewport.detach();
                }

                sampleNameViewport.viewport.remove();

                outerScroll.remove();
                dragHandle.remove();
                gearContainer.remove();
            }

            // Reattach the divs to the dom in the correct order
            const viewportColumns = this.columnContainer.querySelectorAll('.igv-column');

            for (let {axis, viewports, sampleNameViewport, outerScroll, dragHandle, gearContainer} of this.trackViews) {

                this.columnContainer.querySelector('.igv-axis-column').appendChild(axis);

                for (let i = 0; i < viewportColumns.length; i++) {
                    const {$viewport} = viewports[i];
                    viewportColumns[i].appendChild($viewport.get(0));
                }

                this.columnContainer.querySelector('.igv-sample-name-column').appendChild(sampleNameViewport.viewport);

                this.columnContainer.querySelector('.igv-scrollbar-column').appendChild(outerScroll);

                this.columnContainer.querySelector('.igv-track-drag-column').appendChild(dragHandle);

                this.columnContainer.querySelector('.igv-gear-menu-column').appendChild(gearContainer);
            }

        }

        getTrackOrder() {
            return this.trackViews.filter(tv => tv.track && tv.track.name).map(tv => tv.track.name)
        }

        /**
         * NOTE: Public API function
         *
         * Remove all tracks matching the given name.  Usually this will be a single track, but there is no
         * guarantee names are unique
         *
         * @param name
         */
        removeTrackByName(name) {
            const copy = this.trackViews.slice();
            for (let trackView of copy) {
                if (name === trackView.track.name) {
                    this.removeTrack(trackView.track);
                }
            }
        }

        /**
         * NOTE: Public API function
         *
         * Remove the given track.  If it has already been removed this is a no-op.
         *
         * @param track
         */
        removeTrack(track) {
            for (let trackView of this.trackViews) {
                if (track === trackView.track) {
                    this._removeTrack(trackView.track);
                    break
                }
            }
        }

        _removeTrack(track) {
            if (track.disposed) return
            this.trackViews.splice(this.trackViews.indexOf(track.trackView), 1);
            this.fireEvent('trackremoved', [track]);
            this.fireEvent('trackorderchanged', [this.getTrackOrder()]);
            if (track.trackView) {
                track.trackView.dispose();
            }
        }

        /**
         * API function
         */
        removeAllTracks() {

            const remainingTrackViews = [];

            for (let trackView of this.trackViews) {

                if (trackView.track.id !== 'ruler' && trackView.track.id !== 'ideogram') {
                    this.fireEvent('trackremoved', [trackView.track]);
                    trackView.dispose();
                } else {
                    remainingTrackViews.push(trackView);
                }
            }

            this.trackViews = remainingTrackViews;
        }

        /**
         *
         * @param property
         * @param value
         * @returns {Array}  tracks with given property value.  e.g. findTracks("type", "annotation")
         */
        findTracks(property, value) {

            let f = typeof property === 'function' ?
                trackView => property(trackView.track) :
                trackView => value === trackView.track[property];

            return this.trackViews.filter(f).map(tv => tv.track)
        }

        /**
         * Set the track height globally for all tracks.  (Note: Its not clear why this is useful).
         * @param newHeight
         */
        setTrackHeight(newHeight) {

            this.trackHeight = newHeight;

            this.trackViews.forEach(function (trackView) {
                trackView.setTrackHeight(newHeight);
            });

        }

        /**
         * API function to signal that this browser visibility has changed, e.g. from hiding/showing in a tab interface.
         *
         * @returns {Promise<void>}
         */
        async visibilityChange() {
            this.layoutChange();
        }

        async layoutChange() {

            const status = this.referenceFrameList.find(referenceFrame => referenceFrame.bpPerPixel < 0);

            if (status) {
                const viewportWidth = this.calculateViewportWidth(this.referenceFrameList.length);
                for (let referenceFrame of this.referenceFrameList) {
                    referenceFrame.bpPerPixel = (referenceFrame.end - referenceFrame.start) / viewportWidth;
                }
            }

            if (this.referenceFrameList) {
                const isWGV = this.isMultiLocusWholeGenomeView() || GenomeUtils.isWholeGenomeView(this.referenceFrameList[0].chr);
                this.navbarManager.navbarDidResize(this.$navigation.width(), isWGV);
            }

            resize.call(this);
            await this.updateViews();
        }

        async updateViews() {

            const trackViews = this.trackViews;

            this.updateLocusSearchWidget();

            for (let centerGuide of this.centerLineList) {
                centerGuide.repaint();
            }

            // Don't autoscale while dragging.
            if (this.dragObject) {
                for (let trackView of trackViews) {
                    await trackView.updateViews();
                }
            } else {
                // Group autoscale
                const groupAutoscaleTracks = {};
                const otherTracks = [];
                for (let trackView of trackViews) {
                    const group = trackView.track.autoscaleGroup;
                    if (group) {
                        var l = groupAutoscaleTracks[group];
                        if (!l) {
                            l = [];
                            groupAutoscaleTracks[group] = l;
                        }
                        l.push(trackView);
                    } else {
                        otherTracks.push(trackView);
                    }
                }

                if (Object.entries(groupAutoscaleTracks).length > 0) {

                    const keys = Object.keys(groupAutoscaleTracks);
                    for (let group of keys) {

                        const groupTrackViews = groupAutoscaleTracks[group];
                        const promises = [];

                        for (let trackView of groupTrackViews) {
                            promises.push(trackView.getInViewFeatures());
                        }

                        const featureArray = await Promise.all(promises);

                        var allFeatures = [], dataRange;

                        for (let features of featureArray) {
                            allFeatures = allFeatures.concat(features);
                        }
                        dataRange = doAutoscale(allFeatures);

                        const p = [];
                        for (let trackView of groupTrackViews) {
                            trackView.track.dataRange = dataRange;
                            trackView.track.autoscale = false;
                            p.push(trackView.updateViews());
                        }
                        await Promise.all(p);
                    }

                }

                await Promise.all(otherTracks.map(tv => tv.updateViews()));
                // for (let trackView of otherTracks) {
                //     await trackView.updateViews(force);
                // }
            }

        }

        repaintViews() {
            for (let trackView of this.trackViews) {
                trackView.repaintViews();
            }
        }

        updateLocusSearchWidget() {

            if(!this.referenceFrameList) return
            const referenceFrameList = this.referenceFrameList;

            // Update end position of reference frames based on pixel widths.  This is hacky, but its been done here
            // for a long time, although indirectly.
            const width = this.calculateViewportWidth(this.referenceFrameList.length);
            for (let referenceFrame of referenceFrameList) {
                referenceFrame.end = referenceFrame.start + referenceFrame.bpPerPixel * width;
            }

            this.chromosomeSelectWidget.select.value = referenceFrameList.length === 1 ? this.referenceFrameList[0].chr : '';

            const loc = this.referenceFrameList.map(rf => rf.getLocusString()).join(' ');
            //const loc = this.referenceFrameList.length === 1 ?   this.referenceFrameList[0].getLocusString() : '';
            this.$searchInput.val(loc);

            this.fireEvent('locuschange', [this.referenceFrameList]);
        }

        calculateViewportWidth(columnCount) {

            let {width} = this.columnContainer.getBoundingClientRect();

            const sampleNameViewportWidth = this.getSampleNameViewportWidth();

            width -= igv_axis_column_width + sampleNameViewportWidth + igv_scrollbar_outer_width + igv_track_manipulation_handle_width + igv_track_gear_menu_column_width;

            width -= column_multi_locus_shim_width * (columnCount - 1);

            return Math.floor(width / columnCount)
        }

        getCenterLineXOffset() {
            let {width: columnContainerWidth} = this.columnContainer.getBoundingClientRect();
            columnContainerWidth -= igv_axis_column_width + this.getSampleNameViewportWidth() + igv_scrollbar_outer_width + igv_track_manipulation_handle_width + igv_track_gear_menu_column_width;
            return Math.floor(columnContainerWidth / 2 + igv_axis_column_width)
        }

        minimumBases() {
            return this.config.minimumBases
        }

        // Zoom in by a factor of 2, keeping the same center location
        zoomIn() {
            this.zoomWithScaleFactor(0.5);
        };

        // Zoom out by a factor of 2, keeping the same center location if possible
        zoomOut() {
            this.zoomWithScaleFactor(2.0);
        };

        async zoomWithScaleFactor(scaleFactor, centerBPOrUndefined, referenceFrameOrUndefined) {

            if(!this.referenceFrameList) return

            const viewportWidth = this.calculateViewportWidth(this.referenceFrameList.length);

            let referenceFrames = referenceFrameOrUndefined ? [referenceFrameOrUndefined] : this.referenceFrameList;

            for (let referenceFrame of referenceFrames) {
                referenceFrame.zoomWithScaleFactor(this, scaleFactor, viewportWidth, centerBPOrUndefined);
            }
        }

        /**
         * Add a new multi-locus panel for the specified region
         * @param chr
         * @param start
         * @param end
         * @param referenceFrameLeft - optional, if supplied new panel should be placed to the immediate right
         */
        async addMultiLocusPanel(chr, start, end, referenceFrameLeft) {

            if(!this.referenceFrameList) return

            // account for reduced viewport width as a result of adding right mate pair panel
            const viewportWidth = this.calculateViewportWidth(1 + this.referenceFrameList.length);
            const scaleFactor = this.calculateViewportWidth(this.referenceFrameList.length) / this.calculateViewportWidth(1 + this.referenceFrameList.length);
            for (let refFrame of this.referenceFrameList) {
                refFrame.bpPerPixel *= scaleFactor;
            }

            const bpp = (end - start) / viewportWidth;
            const newReferenceFrame = new ReferenceFrame(this.genome, chr, start, end, bpp);
            const indexLeft = referenceFrameLeft ? this.referenceFrameList.indexOf(referenceFrameLeft) : this.referenceFrameList.length - 1;
            const indexRight = 1 + indexLeft;

            // TODO -- this is really ugly
            const {$viewport} = this.trackViews[0].viewports[indexLeft];
            const viewportColumn = viewportColumnManager.insertAfter($viewport.get(0).parentElement);

            if (indexRight === this.referenceFrameList.length) {
                this.referenceFrameList.push(newReferenceFrame);
                for (let trackView of this.trackViews) {
                    const viewport = createViewport(trackView, viewportColumn, newReferenceFrame);
                    trackView.viewports.push(viewport);
                }
            } else {
                this.referenceFrameList.splice(indexRight, 0, newReferenceFrame);
                for (let trackView of this.trackViews) {
                    const viewport = createViewport(trackView, viewportColumn, newReferenceFrame);
                    trackView.viewports.splice(indexRight, 0, viewport);
                }
            }


            this.centerLineList = this.createCenterLineList(this.columnContainer);

            resize.call(this);
            await this.updateViews(true);
        }

        async removeMultiLocusPanel(referenceFrame) {

            // find the $column corresponding to this referenceFrame and remove it
            const index = this.referenceFrameList.indexOf(referenceFrame);
            const {$viewport} = this.trackViews[0].viewports[index];
            viewportColumnManager.removeColumnAtIndex(index, $viewport.parent().get(0));

            for (let {viewports} of this.trackViews) {
                viewports[index].dispose();
                viewports.splice(index, 1);
            }

            this.referenceFrameList.splice(index, 1);

            if (1 === this.referenceFrameList.length && this.getRulerTrackView()) {
                for (let rulerViewport of this.getRulerTrackView().viewports) {
                    rulerViewport.dismissLocusLabel();
                }
            }

            const scaleFactor = this.calculateViewportWidth(1 + this.referenceFrameList.length) / this.calculateViewportWidth(this.referenceFrameList.length);

            await this.rescaleForMultiLocus(scaleFactor);

        }

        /**
         * Goto the locus represented by the selected referenceFrame, discarding all other panels
         *
         * @param referenceFrame
         * @returns {Promise<void>}
         */
        async gotoMultilocusPanel(referenceFrame) {

            const referenceFrameIndex = this.referenceFrameList.indexOf(referenceFrame);

            // Remove columns for unselected panels
            this.columnContainer.querySelectorAll('.igv-column').forEach((column, c) => {
                if (c === referenceFrameIndex) ; else {
                    column.remove();
                }
            });

            // Remove all column shims
            this.columnContainer.querySelectorAll('.igv-column-shim').forEach(shim => shim.remove());

            // Discard viewports
            for (let trackView of this.trackViews) {
                const retain = trackView.viewports[referenceFrameIndex];
                trackView.viewports.filter((viewport, i) => i !== referenceFrameIndex).forEach(viewport => viewport.dispose());
                trackView.viewports = [retain];
            }

            const viewportWidth = this.calculateViewportWidth(1);
            referenceFrame.bpPerPixel = (referenceFrame.end - referenceFrame.start) / viewportWidth;
            this.referenceFrameList = [referenceFrame];

            this.trackViews.forEach(({viewports}) => viewports.forEach(viewport => viewport.setWidth(viewportWidth)));

            this.centerLineList = this.createCenterLineList(this.columnContainer);

            this.updateUIWithReferenceFrameList();

            await this.updateViews(true);

        }

        async rescaleForMultiLocus(scaleFactor) {

            const viewportWidth = this.calculateViewportWidth(this.referenceFrameList.length);

            for (let referenceFrame of this.referenceFrameList) {
                referenceFrame.bpPerPixel *= scaleFactor;
            }

            for (let {viewports} of this.trackViews) {

                for (let viewport of viewports) {
                    viewport.setWidth(viewportWidth);
                }
            }

            this.centerLineList = this.createCenterLineList(this.columnContainer);

            this.updateUIWithReferenceFrameList();

            await this.updateViews();

        }

        /**
         * @deprecated  This is a deprecated method with no known usages.  To be removed in a future release.
         */
        async goto(chr, start, end) {
            await this.search(chr + ":" + start + "-" + end);
        }

        /**

         * Search for the locus string -- this function is called from various igv.js GUI elements, and is not part of the
         * API.  Wraps ```search``` and presents an error dialog if false.
         *
         * @param string
         * @param init
         * @returns {Promise<void>}
         */
        async doSearch(string, init) {
            const success = await this.search(string, init);
            if (!success) {
                this.alert.present(new Error(`Unrecognized locus: <b> ${string} </b>`));
            }
            return success
        }


        /**
         * Search for the locus string
         * NOTE: This is part of the API
         * @param string
         * @param init  true if called during browser initialization
         * @returns {Promise<boolean>}  true if found, false if not
         */
        async search(string, init) {

            const loci = await search(this, string);

            if (loci && loci.length > 0) {

                // create reference frame list based on search loci
                this.referenceFrameList = createReferenceFrameList(loci, this.genome, this.flanking, this.minimumBases(), this.calculateViewportWidth(loci.length), this.isSoftclipped());

                // discard viewport DOM elements
                for (let trackView of this.trackViews) {
                    // empty axis column, viewport columns, sampleName column, scroll column, drag column, gear column
                    trackView.removeDOMFromColumnContainer();
                }

                // discard ONLY viewport columns
                this.columnContainer.querySelectorAll('.igv-column-shim, .igv-column').forEach(el => el.remove());

                // Insert viewport columns preceding the sample-name column
                viewportColumnManager.insertBefore(this.columnContainer.querySelector('.igv-sample-name-column'), this.referenceFrameList.length);

                this.centerLineList = this.createCenterLineList(this.columnContainer);

                // Populate the columns
                for (let trackView of this.trackViews) {
                    trackView.addDOMToColumnContainer(this, this.columnContainer, this.referenceFrameList);
                }

                this.updateUIWithReferenceFrameList();

                if (!init) {
                    await this.updateViews();
                }
                return true
            } else {
                return false
            }
        }

        async loadSampleInformation(url) {
            var name = url;
            if (isFile(url)) {
                name = url.name;
            }
            var ext = name.substr(name.lastIndexOf('.') + 1);
            if (ext === 'fam') {
                this.sampleInformation = await loadPlinkFile(url);
            }
        };

    // EVENTS

        on(eventName, fn) {
            if (!this.eventHandlers[eventName]) {
                this.eventHandlers[eventName] = [];
            }
            this.eventHandlers[eventName].push(fn);
        };

        /**
         * @deprecated use off()
         * @param eventName
         * @param fn
         */
        un(eventName, fn) {
            this.off(eventName, fn);
        };

        off(eventName, fn) {

            if (!eventName) {
                this.eventHandlers = {};   // Remove all event handlers
            } else if (!fn) {
                this.eventHandlers[eventName] = []; // Remove all eventhandlers matching name
            } else {
                // Remove specific event handler
                const handlers = this.eventHandlers[eventName];
                if (!handlers || handlers.length === 0) {
                    console.warn("No handlers to remove for event: " + eventName);
                } else {
                    const callbackIndex = handlers.indexOf(fn);
                    if (callbackIndex !== -1) {
                        this.eventHandlers[eventName].splice(callbackIndex, 1);
                    }
                }
            }
        }

        fireEvent(eventName, args, thisObj) {

            const handlers = this.eventHandlers[eventName];
            if (undefined === handlers || handlers.length === 0) {
                return undefined
            }

            const scope = thisObj || window;
            const results = handlers.map(function (event) {
                return event.apply(scope, args)
            });

            return results[0]
        }

        dispose() {
            this.removeMouseHandlers();
            for (let trackView of this.trackViews) {
                trackView.dispose();
            }
        }

        /**
         * Return a json-like object (note not a json string) representing the current state.
         *
         */
        toJSON() {

            const json = {
                "version": version()
            };

            if (this.showSampleNames !== undefined) {
                json['showSampleNames'] = this.showSampleNames;
            }
            if (this.sampleNameViewportWidth !== defaultSampleNameViewportWidth) {
                json['sampleNameViewportWidth'] = this.sampleNameViewportWidth;
            }

            json["reference"] = this.genome.toJSON();
            if (json.reference.fastaURL instanceof File) {   // Test specifically for File.  Other types of File-like objects might be savable) {
                throw new Error(`Error. Sessions cannot include local file references ${json.reference.fastaURL.name}.`)
            } else if (json.reference.indexURL instanceof File) {   // Test specifically for File.  Other types of File-like objects might be savable) {
                throw new Error(`Error. Sessions cannot include local file references ${json.reference.indexURL.name}.`)
            }

            // Build locus array (multi-locus view).  Use the first track to extract the loci, any track could be used.
            const locus = [];
            const gtexSelections = {};
            let hasGtexSelections = false;
            let anyTrackView = this.trackViews[0];
            for (let {referenceFrame} of anyTrackView.viewports) {
                const locusString = referenceFrame.getLocusString();
                locus.push(locusString);
                if (referenceFrame.selection) {
                    const selection = {
                        gene: referenceFrame.selection.gene,
                        snp: referenceFrame.selection.snp
                    };
                    gtexSelections[locusString] = selection;
                    hasGtexSelections = true;
                }
            }
            json["locus"] = locus.length === 1 ? locus[0] : locus;
            if (hasGtexSelections) {
                json["gtexSelections"] = gtexSelections;
            }

            json["roi"] = this.roiManager.toJSON();

            const trackJson = [];
            const errors = [];
            for (let {track} of this.trackViews) {
                try {
                    let config;
                    if (typeof track.getState === "function") {
                        config = track.getState();
                    } else {
                        config = track.config;
                    }

                    if (config) {
                        // null backpointer to browser
                        if (config.browser) {
                            delete config.browser;
                        }
                        config.order = track.order; //order++;
                        trackJson.push(config);
                    }
                } catch (e) {
                    console.error(`Track: ${track.name}: ${e}`);
                    errors.push(`Track: ${track.name}: ${e}`);
                }
            }

            if (errors.length > 0) {
                let n = 1;
                let message = 'Errors encountered saving session: </br>';
                for (let e of errors) {
                    message += ` (${n++}) ${e.toString()} <br/>`;
                }
                throw Error(message)
            }


            json["tracks"] = trackJson;

            return json        // This is an object, not a json string

        }

        compressedSession() {
            const json = JSON.stringify(this.toJSON());
            return compressString(json)
        }

        sessionURL() {
            const path = window.location.href.slice();
            const idx = path.indexOf("?");
            const surl = (idx > 0 ? path.substring(0, idx) : path) + "?sessionURL=blob:" + this.compressedSession();
            return surl
        }

        /**
         * Record a mouse click on a specific viewport.   This might be the start of a drag operation.   Dragging
         * (panning) is handled here so that the mouse can move out of a specific viewport (e.g. stray into another
         * track) without halting the drag.
         *
         * @param e
         * @param viewport
         */
        mouseDownOnViewport(e, viewport) {

            var coords;
            coords = domUtils.pageCoordinates(e);
            this.vpMouseDown = {
                viewport,
                lastMouseX: coords.x,
                mouseDownX: coords.x,
                lastMouseY: coords.y,
                mouseDownY: coords.y,
                referenceFrame: viewport.referenceFrame
            };
        };

        cancelTrackPan() {

            const dragObject = this.dragObject;
            this.dragObject = undefined;
            this.isScrolling = false;
            this.vpMouseDown = undefined;

            if (dragObject && dragObject.viewport.referenceFrame.start !== dragObject.start) {
                this.updateViews();
                this.fireEvent('trackdragend');
            }
        }

        isTrackPanning() {
            return this.dragObject
        }

        isSoftclipped() {
            const result = this.trackViews.find(tv => tv.track.showSoftClips === true);
            return result !== undefined
        }


        /**
         * Track drag here refers to vertical dragging to reorder tracks, not horizontal panning.
         *
         * @param trackView
         */
        startTrackDrag(trackView) {

            this.dragTrack = trackView;

        }

        /**
         * Track drag here refers to vertical dragging to reorder tracks, not horizontal panning.
         *
         * @param dragDestination
         */
        updateTrackDrag(dragDestination) {

            if (dragDestination && this.dragTrack) {

                const dragged = this.dragTrack;
                const indexDestination = this.trackViews.indexOf(dragDestination);
                const indexDragged = this.trackViews.indexOf(dragged);
                const trackViews = this.trackViews;

                trackViews[indexDestination] = dragged;
                trackViews[indexDragged] = dragDestination;

                const newOrder = this.trackViews[indexDestination].track.order;
                this.trackViews[indexDragged].track.order = newOrder;

                const nTracks = trackViews.length;
                let lastOrder = newOrder;

                if (indexDestination < indexDragged) {
                    // Displace tracks below

                    for (let i = indexDestination + 1; i < nTracks; i++) {
                        const track = trackViews[i].track;
                        if (track.order <= lastOrder) {
                            track.order = Math.min(Number.MAX_SAFE_INTEGER, lastOrder + 1);
                            lastOrder = track.order;
                        } else {
                            break
                        }
                    }
                } else {
                    // Displace tracks above.  First track (index 0) is "ruler"
                    for (let i = indexDestination - 1; i > 0; i--) {
                        const track = trackViews[i].track;
                        if (track.order >= lastOrder) {
                            track.order = Math.max(-Number.MAX_SAFE_INTEGER, lastOrder - 1);
                            lastOrder = track.order;
                        } else {
                            break
                        }
                    }
                }
                this.reorderTracks();
            }
        }

        /**
         * End vertical dragging of tracks (i.e. track re-order, not horizontal panning of data)
         */
        endTrackDrag() {
            if (this.dragTrack) {
                // this.dragTrack.$trackDragScrim.hide();
                this.dragTrack = undefined;
                this.fireEvent('trackorderchanged', [this.getTrackOrder()]);
            } else {
                this.dragTrack = undefined;
            }
        }

        /**
         * Mouse handlers to support drag (pan)
         */
        addMouseHandlers() {
            this.addWindowResizeHandler();
            this.addRootMouseUpHandler();
            this.addRootMouseLeaveHandler();
            this.addColumnContainerEventHandlers();
        }

        removeMouseHandlers() {
            this.removeWindowResizeHandler();
            this.removeRootMouseUpHandler();
            this.removeRootMouseLeaveHandler();
            this.removeColumnContainerEventHandlers();
        }

        addWindowResizeHandler() {
            // Create a copy of the prototype "resize" function bound to this instance.  Neccessary to support removing.
            this.boundWindowResizeHandler = resize.bind(this);
            window.addEventListener('resize', this.boundWindowResizeHandler);
        }

        removeWindowResizeHandler() {
            window.removeEventListener('resize', this.boundWindowResizeHandler);
        }

        addRootMouseUpHandler() {
            this.boundRootMouseUpHandler = mouseUpOrLeave.bind(this);
            this.root.addEventListener('mouseup', this.boundRootMouseUpHandler);
        }

        removeRootMouseUpHandler() {
            this.root.removeEventListener('mouseup', this.boundRootMouseUpHandler);
        }

        addRootMouseLeaveHandler() {
            this.boundRootMouseLeaveHandler = mouseUpOrLeave.bind(this);
            this.root.addEventListener('mouseleave', this.boundRootMouseLeaveHandler);
        }

        removeRootMouseLeaveHandler() {
            this.root.removeEventListener('mouseleave', this.boundRootMouseLeaveHandler);
        }

        addColumnContainerEventHandlers() {
            this.boundColumnContainerMouseMoveHandler = handleMouseMove.bind(this);
            this.boundColumnContainerTouchMoveHandler = handleMouseMove.bind(this);
            this.boundColumnContainerMouseLeaveHandler = mouseUpOrLeave.bind(this);
            this.boundColumnContainerMouseUpHandler = mouseUpOrLeave.bind(this);
            this.boundColumnContainerTouchEndHandler = mouseUpOrLeave.bind(this);

            this.columnContainer.addEventListener('mousemove', this.boundColumnContainerMouseMoveHandler);
            this.columnContainer.addEventListener('touchmove', this.boundColumnContainerTouchMoveHandler);

            this.columnContainer.addEventListener('mouseleave', this.boundColumnContainerMouseLeaveHandler);

            this.columnContainer.addEventListener('mouseup', this.boundColumnContainerMouseUpHandler);
            this.columnContainer.addEventListener('touchend', this.boundColumnContainerTouchEndHandler);
        }

        removeColumnContainerEventHandlers() {
            this.columnContainer.removeEventListener('mousemove', this.boundColumnContainerMouseMoveHandler);
            this.columnContainer.removeEventListener('touchmove', this.boundColumnContainerTouchMoveHandler);

            this.columnContainer.removeEventListener('mouseleave', this.boundColumnContainerMouseLeaveHandler);

            this.columnContainer.removeEventListener('mouseup', this.boundColumnContainerMouseUpHandler);
            this.columnContainer.removeEventListener('touchend', this.boundColumnContainerTouchEndHandler);
        }

        static uncompressSession(url) {

            let bytes;
            if (url.indexOf('/gzip;base64') > 0) {
                //Proper dataURI
                bytes = decodeDataURI$1(url);
                let json = '';
                for (let b of bytes) {
                    json += String.fromCharCode(b);
                }
                return json
            } else {

                let enc = url.substring(5);
                return uncompressString(enc)
            }
        }

        createCircularView(container, show) {
            show = show === true;   // convert undefined to boolean
            this.circularView = createCircularView(container, this);
            this.circularViewControl = new CircularViewControl(this.$toggle_button_container.get(0), this);
            this.circularView.setAssembly({
                name: this.genome.id,
                id: this.genome.id,
                chromosomes: makeCircViewChromosomes(this.genome)
            });
            this.circularViewVisible = show;
            return this.circularView
        }

        get circularViewVisible() {
            return this.circularView !== undefined && this.circularView.visible
        }

        set circularViewVisible(isVisible) {
            if (this.circularView) {
                this.circularView.visible = isVisible;
                this.circularViewControl.setState(isVisible);
            }
        }
    }

    /**
     * Function called win window is resized, or visibility changed (e.g. "show" from a tab).  This is a function rather
     * than class method because it needs to be copied and bound to specific instances of browser to support listener
     * removal
     *
     * @returns {Promise<void>}
     */
    async function resize() {

        if(!this.referenceFrameList) return

        const viewportWidth = this.calculateViewportWidth(this.referenceFrameList.length);

        for (let referenceFrame of this.referenceFrameList) {

            const index = this.referenceFrameList.indexOf(referenceFrame);

            const {chr, genome} = referenceFrame;

            const {bpLength} = genome.getChromosome(referenceFrame.chr);

            const viewportWidthBP = referenceFrame.toBP(viewportWidth);

            // viewportWidthBP > bpLength occurs when locus is full chromosome and user widens browser
            if (GenomeUtils.isWholeGenomeView(chr) || viewportWidthBP > bpLength) {
                // console.log(`${ Date.now() } Recalc referenceFrame(${ index }) bpp. viewport ${ StringUtils.numberFormatter(viewportWidthBP) } > ${ StringUtils.numberFormatter(bpLength) }.`)
                referenceFrame.bpPerPixel = bpLength / viewportWidth;
            } else {
                // console.log(`${ Date.now() } Recalc referenceFrame(${ index }) end.`)
                referenceFrame.end = referenceFrame.start + referenceFrame.toBP(viewportWidth);
            }

            for (let {viewports} of this.trackViews) {
                viewports[index].setWidth(viewportWidth);
            }

        }

        this.updateUIWithReferenceFrameList();

        //TODO -- update view only if needed.  Reducing size never needed.  Increasing size maybe

        await this.updateViews(true);
    }


    function handleMouseMove(e) {

        e.preventDefault();

        const {x, y} = domUtils.pageCoordinates(e);

        if (this.vpMouseDown) {

            const {viewport, referenceFrame} = this.vpMouseDown;

            // Determine direction,  true == horizontal
            const horizontal = Math.abs((x - this.vpMouseDown.mouseDownX)) > Math.abs((y - this.vpMouseDown.mouseDownY));

            if (!this.dragObject && !this.isScrolling) {
                if (horizontal) {
                    if (this.vpMouseDown.mouseDownX && Math.abs(x - this.vpMouseDown.mouseDownX) > this.constants.dragThreshold) {
                        this.dragObject = {viewport, start: referenceFrame.start};
                    }
                } else {
                    if (this.vpMouseDown.mouseDownY &&
                        Math.abs(y - this.vpMouseDown.mouseDownY) > this.constants.scrollThreshold) {
                        // Scrolling => dragging track vertically
                        this.isScrolling = true;
                        const viewportHeight = viewport.$viewport.height();
                        const contentHeight = viewport.trackView.maxViewportContentHeight();
                        this.vpMouseDown.r = viewportHeight / contentHeight;
                    }
                }
            }

            if (this.dragObject) {
                const clampDrag = !this.isSoftclipped();
                let deltaX = this.vpMouseDown.lastMouseX - x;
                const viewChanged = referenceFrame.shiftPixels(deltaX, viewport.$viewport.width(), clampDrag);
                if (viewChanged) {
                    this.updateViews();
                }
                this.fireEvent('trackdrag');
            }


            if (this.isScrolling) {
                const delta = this.vpMouseDown.r * (this.vpMouseDown.lastMouseY - y);
                viewport.trackView.moveScroller(delta);
            }


            this.vpMouseDown.lastMouseX = x;
            this.vpMouseDown.lastMouseY = y;
        }
    }

    function mouseUpOrLeave(e) {
        this.cancelTrackPan();
        this.endTrackDrag();
    }


    function getInitialLocus(locus, genome) {
        if (locus) {
            return Array.isArray(locus) ? locus.join(' ') : locus
        } else {
            return genome.getHomeChromosomeName()
        }
    }

    function logo() {

        return $$1(
            '<svg width="690px" height="324px" viewBox="0 0 690 324" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
            '<title>IGV</title>' +
            '<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
            '<g id="IGV" fill="#666666">' +
            '<polygon id="Path" points="379.54574 8.00169252 455.581247 8.00169252 515.564813 188.87244 532.884012 253.529506 537.108207 253.529506 554.849825 188.87244 614.833392 8.00169252 689.60164 8.00169252 582.729511 320.722144 486.840288 320.722144"></polygon>' +
            '<path d="M261.482414,323.793286 C207.975678,323.793286 168.339046,310.552102 142.571329,284.069337 C116.803612,257.586572 103.919946,217.158702 103.919946,162.784513 C103.919946,108.410325 117.437235,67.8415913 144.472217,41.0770945 C171.507199,14.3125977 212.903894,0.930550071 268.663545,0.930550071 C283.025879,0.930550071 298.232828,1.84616386 314.284849,3.6774189 C330.33687,5.50867394 344.839793,7.97378798 357.794056,11.072835 L357.794056,68.968378 C339.48912,65.869331 323.578145,63.5450806 310.060654,61.9955571 C296.543163,60.4460336 284.574731,59.6712835 274.154998,59.6712835 C255.850062,59.6712835 240.502308,61.4320792 228.111274,64.9537236 C215.720241,68.4753679 205.793482,74.2507779 198.330701,82.2801269 C190.867919,90.309476 185.587729,100.87425 182.48997,113.974767 C179.392212,127.075284 177.843356,143.345037 177.843356,162.784513 C177.843356,181.942258 179.251407,198.000716 182.067551,210.960367 C184.883695,223.920018 189.671068,234.41436 196.429813,242.443709 C203.188559,250.473058 212.059279,256.178037 223.042241,259.558815 C234.025202,262.939594 247.683295,264.629958 264.01693,264.629958 C268.241146,264.629958 273.098922,264.489094 278.590403,264.207362 C284.081883,263.925631 289.643684,263.50304 295.275972,262.939577 L295.275972,159.826347 L361.595831,159.826347 L361.595831,308.579859 C344.698967,313.087564 327.239137,316.750019 309.215815,319.567334 C291.192494,322.38465 275.281519,323.793286 261.482414,323.793286 L261.482414,323.793286 L261.482414,323.793286 Z" id="Path"></path>;' +
            '<polygon id="Path" points="0.81355666 5.00169252 73.0472883 5.00169252 73.0472883 317.722144 0.81355666 317.722144"></polygon>' +
            '</g> </g> </svg>'
        )
    }

    function toggleTrackLabels(trackViews, isVisible) {

        for (let {viewports} of trackViews) {
            for (let viewport of viewports) {
                if (viewport.$trackLabel) {
                    if (0 === viewports.indexOf(viewport) && true === isVisible) {
                        viewport.$trackLabel.show();
                    } else {
                        viewport.$trackLabel.hide();
                    }
                }
            }
        }
    }

    /*
     * The MIT License (MIT)
     *
     * Copyright (c) 2014 Broad Institute
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     */

    let allBrowsers = [];

    /**
     * Create an igv.browser instance.  This object defines the public API for interacting with the genome browser.
     *
     * @param parentDiv - DOM tree root
     * @param config - configuration options.
     *
     */
    async function createBrowser(parentDiv, config) {

        if (undefined === config) config = {};

        // Initialize pre-defined genomes.  The genome list is shared among all browser instances
        if (!GenomeUtils.KNOWN_GENOMES) {
            await GenomeUtils.initializeGenomes(config);
        }

        setDefaults(config);

        if (config.queryParametersSupported) {
            extractQuery(config);
        }
        if (config.apiKey) {
            igvxhr.setApiKey(config.apiKey);
        }
        if (config.oauthToken) {
            igvxhr.setOauthToken(config.oauthToken);
        }
        if (config.clientId && (!isInitialized())) {
            await init$1({
                clientId: config.clientId,
                apiKey: config.apiKey,
                scope: 'https://www.googleapis.com/auth/userinfo.profile'
            });
        }

        // Create browser
        const browser = new Browser(config, parentDiv);
        allBrowsers.push(browser);

        // Load initial session
        if (config.sessionURL) {
            await browser.loadSession({
                url: config.sessionURL
            });
        } else {
            await browser.loadSessionObject(config);
        }

        browser.navbarManager.navbarDidResize(browser.$navigation.width());

        return browser

    }

    function removeBrowser(browser) {
        browser.dispose();
        browser.root.remove();
        allBrowsers = allBrowsers.filter(item => item !== browser);
    }

    function removeAllBrowsers() {
        for (let browser of allBrowsers) {
            browser.dispose();
            browser.root.remove();
        }
        allBrowsers = [];
    }

    /**
     * This function provided so clients can inform igv of a visibility change, typically when an igv instance is
     * made visible from a tab, accordion, or similar widget.
     */
    async function visibilityChange() {
        for (let browser of allBrowsers) {
            await browser.visibilityChange();
        }
    }

    function setDefaults(config) {

        if (undefined === config.minimumBases) {
            config.minimumBases = 40;
        }

        if (undefined === config.showIdeogram) {
            config.showIdeogram = true;
        }

        if (undefined === config.showCircularView) {
            config.showCircularView = false;
        }

        if (undefined === config.showCircularViewButton) {
            config.showCircularViewButton = false;
        }

        if (undefined === config.showTrackLabelButton) {
            config.showTrackLabelButton = true;
        }

        if (undefined === config.showTrackLabels) {
            config.showTrackLabels = true;
        }

        if (undefined === config.showROITableButton) {
            config.showROITableButton = false;
        }

        if (undefined === config.showROITable) {
            config.showROITable = false;
        }

        if (undefined === config.showCursorTrackingGuideButton) {
            config.showCursorTrackingGuideButton = true;
        }


        if (undefined === config.showCursorGuide) {
            config.showCursorGuide = config.showCursorTrackingGuide || false;   // showCursorTrackingGuide is a synonym
        }

        if (undefined === config.showCenterGuideButton) {
            config.showCenterGuideButton = true;
        }

        if (undefined === config.showCenterGuide) {
            config.showCenterGuide = false;
        }

        if (undefined === config.showSampleNames) {
            config.showSampleNames = false;
        }

        if (undefined === config.showSVGButton) {
            config.showSVGButton = true;
        }

        if (config.showControls === undefined) {
            config.showControls = true;
        }

        if (config.showNavigation === undefined) {
            config.showNavigation = true;
        }

        if (config.showRuler === undefined) {
            config.showRuler = true;
        }

        if (config.flanking === undefined) {
            config.flanking = 1000;
        }

        if (config.pairsSupported === undefined) {
            config.pairsSupported = true;
        }

        if (!config.tracks) {
            config.tracks = [];
        }

    }


    function extractQuery(config) {

        var i1, i2, i, j, s, query, tokens, uri, key, value;

        uri = window.location.href;

        query = {};
        i1 = uri.indexOf("?");
        i2 = uri.lastIndexOf("#");

        let files;
        let indexURLs;
        let names;
        if (i1 >= 0) {
            if (i2 < 0) i2 = uri.length;
            for (i = i1 + 1; i < i2;) {
                j = uri.indexOf("&", i);
                if (j < 0) j = i2;

                s = uri.substring(i, j);
                tokens = s.split("=", 2);

                if (tokens.length === 2) {
                    key = tokens[0];
                    value = decodeURIComponent(tokens[1]);

                    if ('file' === key) {
                        // IGV desktop style file parameter
                        files = value.split(',');
                    } else if ('index' === key) {
                        // IGV desktop style index parameter
                        indexURLs = value.split(',');
                    } else if ('name' === key) {
                        // IGV desktop style index parameter
                        names = value.split(',');
                    } else if ('genome' === key && ((value.startsWith("https://") || value.startsWith("http://")) && !value.endsWith(".json"))) {
                        // IGV desktop compatibility -- assuming url to fasta
                        config['reference'] = {
                            fastaURL: value,
                            indexURL: value + ".fai"
                        };
                    } else {
                        config[key] = value;
                    }
                    i = j + 1;
                } else {
                    i++;
                }
            }
        }

        if (files) {

            if (!config.tracks)
                config.tracks = [];
            for (let i = 0; i < files.length; i++) {

                if (files[i].endsWith(".xml") || files[i].endsWith(".json")) {
                    config.sessionURL = files[i];
                    break
                }

                const trackConfig = {url: files[i]};
                if (indexURLs && indexURLs.length > i) {
                    trackConfig.indexURL = indexURLs[i];
                }
                if (names && names.length > i) {
                    trackConfig.name = names[i];
                }
                config.tracks.push(trackConfig);
            }
        }

        return query
    }


    async function createTrack(config, browser) {
        return await Browser.prototype.createTrack.call(browser, config)
    }

    function embedCSS() {

        var css = '.igv-navbar {\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  color: #444;\n  font-size: 12px;\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 400;\n  line-height: 32px;\n  padding-left: 8px;\n  padding-right: 8px;\n  margin-top: 2px;\n  margin-bottom: 6px;\n  height: 32px;\n  border-style: solid;\n  border-radius: 3px;\n  border-width: thin;\n  border-color: #bfbfbf;\n  background-color: #f3f3f3;\n}\n.igv-navbar .igv-navbar-left-container {\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  height: 32px;\n  line-height: 32px;\n}\n.igv-navbar .igv-navbar-left-container .igv-logo {\n  width: 34px;\n  height: 32px;\n  margin-right: 8px;\n}\n.igv-navbar .igv-navbar-left-container .igv-current-genome {\n  height: 32px;\n  margin-left: 4px;\n  margin-right: 4px;\n  user-select: none;\n  line-height: 32px;\n  vertical-align: middle;\n  text-align: center;\n}\n.igv-navbar .igv-navbar-left-container .igv-navbar-genomic-location {\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  height: 100%;\n}\n.igv-navbar .igv-navbar-left-container .igv-navbar-genomic-location .igv-chromosome-select-widget-container {\n  display: flex;\n  flex-flow: column;\n  flex-wrap: nowrap;\n  justify-content: space-around;\n  align-items: center;\n  height: 100%;\n  width: 125px;\n  margin-right: 4px;\n}\n.igv-navbar .igv-navbar-left-container .igv-navbar-genomic-location .igv-chromosome-select-widget-container select {\n  display: block;\n  cursor: pointer;\n  width: 100px;\n  height: 75%;\n  outline: none;\n  font-size: 12px;\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 400;\n}\n.igv-navbar .igv-navbar-left-container .igv-navbar-genomic-location .igv-locus-size-group {\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  margin-left: 8px;\n  height: 22px;\n}\n.igv-navbar .igv-navbar-left-container .igv-navbar-genomic-location .igv-locus-size-group .igv-search-container {\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  width: 210px;\n  height: 22px;\n  line-height: 22px;\n}\n.igv-navbar .igv-navbar-left-container .igv-navbar-genomic-location .igv-locus-size-group .igv-search-container input.igv-search-input {\n  cursor: text;\n  width: 85%;\n  height: 22px;\n  line-height: 22px;\n  font-size: 12px;\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 400;\n  text-align: left;\n  padding-left: 8px;\n  margin-right: 8px;\n  outline: none;\n  border-style: solid;\n  border-radius: 3px;\n  border-width: thin;\n  border-color: #bfbfbf;\n  background-color: white;\n}\n.igv-navbar .igv-navbar-left-container .igv-navbar-genomic-location .igv-locus-size-group .igv-search-container .igv-search-icon-container {\n  cursor: pointer;\n  height: 16px;\n  width: 16px;\n}\n.igv-navbar .igv-navbar-left-container .igv-navbar-genomic-location .igv-locus-size-group .igv-windowsize-panel-container {\n  margin-left: 4px;\n  user-select: none;\n}\n.igv-navbar .igv-navbar-right-container {\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  height: 32px;\n  line-height: 32px;\n}\n.igv-navbar .igv-navbar-right-container .igv-navbar-toggle-button-container {\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  height: 100%;\n}\n.igv-navbar .igv-navbar-right-container .igv-navbar-toggle-button-container div {\n  margin-left: 0;\n  margin-right: 4px;\n}\n.igv-navbar .igv-navbar-right-container .igv-navbar-toggle-button-container div:last-child {\n  margin-left: 0;\n  margin-right: 0;\n}\n.igv-navbar .igv-navbar-right-container .igv-navbar-toggle-button-container-750 {\n  display: none;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget {\n  color: #737373;\n  font-size: 18px;\n  height: 32px;\n  line-height: 32px;\n  margin-left: 8px;\n  user-select: none;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  align-items: center;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget div {\n  cursor: pointer;\n  margin-left: unset;\n  margin-right: unset;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget div:first-child {\n  height: 24px;\n  width: 24px;\n  margin-left: unset;\n  margin-right: 8px;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget div:last-child {\n  height: 24px;\n  width: 24px;\n  margin-left: 8px;\n  margin-right: unset;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget div:nth-child(even) {\n  display: block;\n  height: fit-content;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget input {\n  display: block;\n  width: 125px;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget svg {\n  display: block;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget-900 {\n  color: #737373;\n  font-size: 18px;\n  height: 32px;\n  line-height: 32px;\n  margin-left: 8px;\n  user-select: none;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  align-items: center;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget-900 div {\n  cursor: pointer;\n  margin-left: unset;\n  margin-right: unset;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget-900 div:first-child {\n  height: 24px;\n  width: 24px;\n  margin-left: unset;\n  margin-right: 8px;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget-900 div:last-child {\n  height: 24px;\n  width: 24px;\n  margin-left: 8px;\n  margin-right: unset;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget-900 div:nth-child(even) {\n  width: 0;\n  height: 0;\n  display: none;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget-900 input {\n  width: 0;\n  height: 0;\n  display: none;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget-900 svg {\n  display: block;\n}\n.igv-navbar .igv-navbar-right-container .igv-zoom-widget-hidden {\n  display: none;\n}\n\n.igv-navbar-button {\n  display: block;\n  box-sizing: unset;\n  padding-left: 6px;\n  padding-right: 6px;\n  height: 18px;\n  text-transform: capitalize;\n  user-select: none;\n  line-height: 18px;\n  text-align: center;\n  vertical-align: middle;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 11px;\n  font-weight: 200;\n  color: #737373;\n  background-color: #f3f3f3;\n  border-color: #737373;\n  border-style: solid;\n  border-width: thin;\n  border-radius: 6px;\n}\n\n.igv-navbar-button-clicked {\n  color: white;\n  background-color: #737373;\n}\n\n.igv-navbar-button:hover {\n  cursor: pointer;\n}\n\n.igv-zoom-in-notice-container {\n  z-index: 1024;\n  position: absolute;\n  top: 8px;\n  left: 50%;\n  transform: translate(-50%, 0%);\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n}\n.igv-zoom-in-notice-container > div {\n  padding-left: 4px;\n  padding-right: 4px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  width: 100%;\n  height: 100%;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #3f3f3f;\n}\n\n.igv-zoom-in-notice {\n  position: absolute;\n  top: 10px;\n  left: 50%;\n}\n.igv-zoom-in-notice div {\n  position: relative;\n  left: -50%;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: medium;\n  font-weight: 400;\n  color: #3f3f3f;\n  background-color: rgba(255, 255, 255, 0.51);\n  z-index: 64;\n}\n\n.igv-container-spinner {\n  position: absolute;\n  top: 90%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1024;\n  width: 24px;\n  height: 24px;\n  pointer-events: none;\n  color: #737373;\n}\n\n.igv-multi-locus-close-button {\n  position: absolute;\n  top: 2px;\n  right: 0;\n  padding-left: 2px;\n  padding-right: 2px;\n  width: 12px;\n  height: 12px;\n  color: #666666;\n  background-color: white;\n  z-index: 1000;\n}\n.igv-multi-locus-close-button > svg {\n  vertical-align: top;\n}\n\n.igv-multi-locus-close-button:hover {\n  cursor: pointer;\n  color: #434343;\n}\n\n.igv-multi-locus-ruler-label {\n  z-index: 64;\n  position: absolute;\n  top: 2px;\n  left: 0;\n  width: 100%;\n  height: 12px;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n}\n.igv-multi-locus-ruler-label > div {\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  color: rgb(16, 16, 16);\n  background-color: white;\n}\n.igv-multi-locus-ruler-label > div {\n  cursor: pointer;\n}\n\n.igv-multi-locus-ruler-label-square-dot {\n  z-index: 64;\n  position: absolute;\n  left: 50%;\n  top: 5%;\n  transform: translate(-50%, 0%);\n  background-color: white;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n}\n.igv-multi-locus-ruler-label-square-dot > div:first-child {\n  width: 14px;\n  height: 14px;\n}\n.igv-multi-locus-ruler-label-square-dot > div:last-child {\n  margin-left: 16px;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: rgb(16, 16, 16);\n}\n\n.igv-ruler-sweeper {\n  display: none;\n  pointer-events: none;\n  position: absolute;\n  top: 26px;\n  bottom: 0;\n  left: 0;\n  width: 0;\n  z-index: 99999;\n  background-color: rgba(68, 134, 247, 0.25);\n}\n\n.igv-ruler-tooltip {\n  pointer-events: none;\n  z-index: 128;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 1px;\n  height: 32px;\n  background-color: transparent;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n}\n.igv-ruler-tooltip > div {\n  pointer-events: none;\n  width: 128px;\n  height: auto;\n  padding: 1px;\n  color: #373737;\n  font-size: 10px;\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 400;\n  background-color: white;\n  border-style: solid;\n  border-width: thin;\n  border-color: #373737;\n}\n\n.igv-track-label {\n  position: absolute;\n  left: 8px;\n  top: 8px;\n  width: auto;\n  height: auto;\n  max-width: 50%;\n  padding-left: 4px;\n  padding-right: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: small;\n  font-weight: 400;\n  text-align: center;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  border-color: #444;\n  border-radius: 2px;\n  border-style: solid;\n  border-width: thin;\n  background-color: white;\n  z-index: 128;\n  cursor: pointer;\n}\n\n.igv-track-label:hover,\n.igv-track-label:focus,\n.igv-track-label:active {\n  background-color: #e8e8e8;\n}\n\n.igv-track-label-popup-shim {\n  padding-left: 8px;\n  padding-right: 8px;\n  padding-top: 4px;\n}\n\n.igv-center-line {\n  display: none;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 8;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  border-left-style: dashed;\n  border-left-width: thin;\n  border-right-style: dashed;\n  border-right-width: thin;\n}\n\n.igv-center-line-wide {\n  background-color: rgba(0, 0, 0, 0);\n  border-left-color: rgba(127, 127, 127, 0.51);\n  border-right-color: rgba(127, 127, 127, 0.51);\n}\n\n.igv-center-line-thin {\n  background-color: rgba(0, 0, 0, 0);\n  border-left-color: rgba(127, 127, 127, 0.51);\n  border-right-color: rgba(0, 0, 0, 0);\n}\n\n.igv-cursor-guide-horizontal {\n  display: none;\n  pointer-events: none;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  height: 1px;\n  z-index: 1;\n  margin-left: 50px;\n  margin-right: 54px;\n  border-top-style: dotted;\n  border-top-width: thin;\n  border-top-color: rgba(127, 127, 127, 0.76);\n}\n\n.igv-cursor-guide-vertical {\n  pointer-events: none;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 50%;\n  width: 1px;\n  z-index: 1;\n  border-left-style: dotted;\n  border-left-width: thin;\n  border-left-color: rgba(127, 127, 127, 0.76);\n  display: none;\n}\n\n.igv-user-feedback {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 512px;\n  height: 360px;\n  z-index: 2048;\n  background-color: white;\n  border-color: #a2a2a2;\n  border-style: solid;\n  border-width: thin;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: medium;\n  font-weight: 400;\n  color: #444;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n}\n.igv-user-feedback div:first-child {\n  position: relative;\n  height: 24px;\n  width: 100%;\n  background-color: white;\n  border-bottom-color: #a2a2a2;\n  border-bottom-style: solid;\n  border-bottom-width: thin;\n}\n.igv-user-feedback div:first-child div {\n  position: absolute;\n  top: 2px;\n  width: 16px;\n  height: 16px;\n  background-color: transparent;\n}\n.igv-user-feedback div:first-child div:first-child {\n  left: 8px;\n}\n.igv-user-feedback div:first-child div:last-child {\n  cursor: pointer;\n  right: 8px;\n}\n.igv-user-feedback div:last-child {\n  width: 100%;\n  height: calc(100% - 24px);\n  border-width: 0;\n}\n.igv-user-feedback div:last-child div {\n  width: auto;\n  height: auto;\n  margin: 8px;\n}\n\n.igv-generic-dialog-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 300px;\n  height: 200px;\n  border-color: #7F7F7F;\n  border-radius: 4px;\n  border-style: solid;\n  border-width: thin;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: medium;\n  font-weight: 400;\n  z-index: 2048;\n  background-color: white;\n  display: flex;\n  flex-flow: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n}\n.igv-generic-dialog-container .igv-generic-dialog-header {\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n  height: 24px;\n  cursor: move;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-color: #7F7F7F;\n  border-bottom-style: solid;\n  border-bottom-width: thin;\n  background-color: #eee;\n}\n.igv-generic-dialog-container .igv-generic-dialog-header div {\n  margin-right: 4px;\n  margin-bottom: 2px;\n  height: 12px;\n  width: 12px;\n  color: #7F7F7F;\n}\n.igv-generic-dialog-container .igv-generic-dialog-header div:hover {\n  cursor: pointer;\n  color: #444;\n}\n.igv-generic-dialog-container .igv-generic-dialog-one-liner {\n  color: #373737;\n  width: 95%;\n  height: 24px;\n  line-height: 24px;\n  text-align: left;\n  margin-top: 8px;\n  padding-left: 8px;\n  overflow-wrap: break-word;\n  background-color: white;\n}\n.igv-generic-dialog-container .igv-generic-dialog-label-input {\n  margin-top: 8px;\n  width: 95%;\n  height: 24px;\n  color: #373737;\n  line-height: 24px;\n  padding-left: 8px;\n  background-color: white;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n}\n.igv-generic-dialog-container .igv-generic-dialog-label-input div {\n  width: 30%;\n  height: 100%;\n  font-size: 16px;\n  text-align: right;\n  padding-right: 8px;\n  background-color: white;\n}\n.igv-generic-dialog-container .igv-generic-dialog-label-input input {\n  display: block;\n  height: 100%;\n  width: 100%;\n  padding-left: 4px;\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 400;\n  color: #373737;\n  text-align: left;\n  outline: none;\n  border-style: solid;\n  border-width: thin;\n  border-color: #7F7F7F;\n  background-color: white;\n}\n.igv-generic-dialog-container .igv-generic-dialog-label-input input {\n  width: 50%;\n  font-size: 16px;\n}\n.igv-generic-dialog-container .igv-generic-dialog-input {\n  margin-top: 8px;\n  width: calc(100% - 16px);\n  height: 24px;\n  color: #373737;\n  line-height: 24px;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: space-around;\n  align-items: center;\n}\n.igv-generic-dialog-container .igv-generic-dialog-input input {\n  display: block;\n  height: 100%;\n  width: 100%;\n  padding-left: 4px;\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 400;\n  color: #373737;\n  text-align: left;\n  outline: none;\n  border-style: solid;\n  border-width: thin;\n  border-color: #7F7F7F;\n  background-color: white;\n}\n.igv-generic-dialog-container .igv-generic-dialog-input input {\n  font-size: 16px;\n}\n.igv-generic-dialog-container .igv-generic-dialog-ok-cancel {\n  width: 100%;\n  height: 28px;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: space-around;\n  align-items: center;\n}\n.igv-generic-dialog-container .igv-generic-dialog-ok-cancel div {\n  margin-top: 32px;\n  color: white;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  width: 75px;\n  height: 28px;\n  line-height: 28px;\n  text-align: center;\n  border-color: transparent;\n  border-style: solid;\n  border-width: thin;\n  border-radius: 2px;\n}\n.igv-generic-dialog-container .igv-generic-dialog-ok-cancel div:first-child {\n  margin-left: 32px;\n  margin-right: 0;\n  background-color: #5ea4e0;\n}\n.igv-generic-dialog-container .igv-generic-dialog-ok-cancel div:last-child {\n  margin-left: 0;\n  margin-right: 32px;\n  background-color: #c4c4c4;\n}\n.igv-generic-dialog-container .igv-generic-dialog-ok-cancel div:first-child:hover {\n  cursor: pointer;\n  background-color: #3b5c7f;\n}\n.igv-generic-dialog-container .igv-generic-dialog-ok-cancel div:last-child:hover {\n  cursor: pointer;\n  background-color: #7f7f7f;\n}\n.igv-generic-dialog-container .igv-generic-dialog-ok {\n  width: 100%;\n  height: 36px;\n  margin-top: 32px;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: space-around;\n  align-items: center;\n}\n.igv-generic-dialog-container .igv-generic-dialog-ok div {\n  width: 98px;\n  height: 36px;\n  line-height: 36px;\n  text-align: center;\n  color: white;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: medium;\n  font-weight: 400;\n  border-color: white;\n  border-style: solid;\n  border-width: thin;\n  border-radius: 4px;\n  background-color: #2B81AF;\n}\n.igv-generic-dialog-container .igv-generic-dialog-ok div:hover {\n  cursor: pointer;\n  background-color: #25597f;\n}\n\n.igv-generic-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2048;\n  background-color: white;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: center;\n}\n.igv-generic-container div:first-child {\n  cursor: move;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24px;\n  width: 100%;\n  background-color: #dddddd;\n}\n.igv-generic-container div:first-child i {\n  display: block;\n  color: #5f5f5f;\n  cursor: pointer;\n  width: 14px;\n  height: 14px;\n  margin-right: 8px;\n  margin-bottom: 4px;\n}\n\n.igv-menu-popup {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: max-content;\n  z-index: 4096;\n  cursor: pointer;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: small;\n  font-weight: 400;\n  color: #4b4b4b;\n  background: white;\n  border-radius: 4px;\n  border-color: #7F7F7F;\n  border-style: solid;\n  border-width: thin;\n  display: flex;\n  flex-flow: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: flex-end;\n  text-align: left;\n}\n.igv-menu-popup > div:not(:first-child) {\n  width: 100%;\n}\n.igv-menu-popup > div:not(:first-child) > div {\n  background: white;\n}\n.igv-menu-popup > div:not(:first-child) > div.context-menu {\n  padding-left: 4px;\n  padding-right: 4px;\n}\n.igv-menu-popup > div:not(:first-child) > div:last-child {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-bottom-color: transparent;\n  border-bottom-style: solid;\n  border-bottom-width: thin;\n}\n.igv-menu-popup > div:not(:first-child) > div:hover {\n  background: #efefef;\n}\n\n.igv-menu-popup-shim {\n  padding-left: 8px;\n  padding-right: 8px;\n  padding-bottom: 1px;\n  padding-top: 1px;\n}\n\n.igv-menu-popup-header {\n  position: relative;\n  width: 100%;\n  height: 24px;\n  cursor: move;\n  border-top-color: transparent;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-color: #7F7F7F;\n  border-bottom-style: solid;\n  border-bottom-width: thin;\n  background-color: #eee;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  align-items: center;\n}\n.igv-menu-popup-header div {\n  margin-right: 4px;\n  height: 12px;\n  width: 12px;\n  color: #7F7F7F;\n}\n.igv-menu-popup-header div:hover {\n  cursor: pointer;\n  color: #444;\n}\n\n.igv-menu-popup-check-container {\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  height: 20px;\n  margin-right: 4px;\n  background-color: transparent;\n}\n.igv-menu-popup-check-container div {\n  padding-top: 2px;\n  padding-left: 8px;\n}\n.igv-menu-popup-check-container div:first-child {\n  position: relative;\n  width: 12px;\n  height: 12px;\n}\n.igv-menu-popup-check-container div:first-child svg {\n  position: absolute;\n  width: 12px;\n  height: 12px;\n}\n\n.igv-user-feedback {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 512px;\n  height: 360px;\n  z-index: 2048;\n  background-color: white;\n  border-color: #a2a2a2;\n  border-style: solid;\n  border-width: thin;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: medium;\n  font-weight: 400;\n  color: #444;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n}\n.igv-user-feedback div:first-child {\n  position: relative;\n  height: 24px;\n  width: 100%;\n  background-color: white;\n  border-bottom-color: #a2a2a2;\n  border-bottom-style: solid;\n  border-bottom-width: thin;\n}\n.igv-user-feedback div:first-child div {\n  position: absolute;\n  top: 2px;\n  width: 16px;\n  height: 16px;\n  background-color: transparent;\n}\n.igv-user-feedback div:first-child div:first-child {\n  left: 8px;\n}\n.igv-user-feedback div:first-child div:last-child {\n  cursor: pointer;\n  right: 8px;\n}\n.igv-user-feedback div:last-child {\n  width: 100%;\n  height: calc(100% - 24px);\n  border-width: 0;\n}\n.igv-user-feedback div:last-child div {\n  width: auto;\n  height: auto;\n  margin: 8px;\n}\n\n.igv-loading-spinner-container {\n  z-index: 1024;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 32px;\n  height: 32px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n}\n.igv-loading-spinner-container > div {\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 4px solid rgba(128, 128, 128, 0.5);\n  border-top-color: rgb(255, 255, 255);\n  animation: spin 1s ease-in-out infinite;\n  -webkit-animation: spin 1s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin {\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n.igv-roi-menu-next-gen {\n  position: absolute;\n  z-index: 512;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: small;\n  font-weight: 400;\n  color: #4b4b4b;\n  background-color: white;\n  width: 192px;\n  border-radius: 4px;\n  border-color: #7F7F7F;\n  border-style: solid;\n  border-width: thin;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: stretch;\n}\n.igv-roi-menu-next-gen > div:first-child {\n  height: 24px;\n  border-top-color: transparent;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-color: #7F7F7F;\n  border-bottom-style: solid;\n  border-bottom-width: thin;\n  background-color: #eee;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  align-items: center;\n}\n.igv-roi-menu-next-gen > div:first-child > div {\n  margin-right: 4px;\n  height: 12px;\n  width: 12px;\n  color: #7F7F7F;\n}\n.igv-roi-menu-next-gen > div:first-child > div:hover {\n  cursor: pointer;\n  color: #444;\n}\n.igv-roi-menu-next-gen > div:last-child {\n  background-color: white;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-bottom-color: transparent;\n  border-bottom-style: solid;\n  border-bottom-width: 0;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: stretch;\n  text-align: start;\n  vertical-align: middle;\n}\n.igv-roi-menu-next-gen > div:last-child > div {\n  height: 24px;\n  padding-left: 4px;\n  border-bottom-style: solid;\n  border-bottom-width: thin;\n  border-bottom-color: #7f7f7f;\n}\n.igv-roi-menu-next-gen > div:last-child > div:not(:first-child):hover {\n  background-color: rgba(127, 127, 127, 0.1);\n}\n.igv-roi-menu-next-gen > div:last-child div:first-child {\n  font-style: italic;\n  text-align: center;\n  padding-right: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.igv-roi-menu-next-gen > div:last-child > div:last-child {\n  border-bottom-width: 0;\n  border-bottom-color: transparent;\n}\n\n.igv-roi-placeholder {\n  font-style: normal;\n  color: rgba(75, 75, 75, 0.6);\n}\n\n.igv-roi-table {\n  position: absolute;\n  z-index: 1024;\n  width: min-content;\n  max-width: 1600px;\n  border-color: #7f7f7f;\n  border-radius: 4px;\n  border-style: solid;\n  border-width: thin;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  background-color: white;\n  display: flex;\n  flex-flow: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: stretch;\n  cursor: default;\n}\n.igv-roi-table > div {\n  height: 24px;\n  font-size: 14px;\n  text-align: start;\n  vertical-align: middle;\n  line-height: 24px;\n}\n.igv-roi-table > div:first-child {\n  border-color: transparent;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-top-width: 0;\n  border-bottom-color: #7f7f7f;\n  border-bottom-style: solid;\n  border-bottom-width: thin;\n  background-color: #eee;\n  cursor: move;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n}\n.igv-roi-table > div:first-child > div:first-child {\n  text-align: center;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-left: 4px;\n  margin-right: 4px;\n  width: calc(100% - 4px - 12px);\n}\n.igv-roi-table > div:first-child > div:last-child {\n  margin-right: 4px;\n  margin-bottom: 2px;\n  height: 12px;\n  width: 12px;\n  color: #7f7f7f;\n}\n.igv-roi-table > div:first-child > div:last-child > svg {\n  display: block;\n}\n.igv-roi-table > div:first-child > div:last-child:hover {\n  cursor: pointer;\n  color: #444;\n}\n.igv-roi-table > .igv-roi-table-description {\n  padding: 4px;\n  margin-left: 4px;\n  word-break: break-all;\n  overflow-y: auto;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  background-color: transparent;\n}\n.igv-roi-table > .igv-roi-table-goto-explainer {\n  margin-top: 5px;\n  margin-left: 4px;\n  color: #7F7F7F;\n  font-style: italic;\n  height: 24px;\n  border-top: solid lightgray;\n  background-color: transparent;\n}\n.igv-roi-table > .igv-roi-table-column-titles {\n  height: 24px;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: stretch;\n  align-items: stretch;\n  padding-right: 16px;\n  background-color: white;\n  border-top-color: #7f7f7f;\n  border-top-style: solid;\n  border-top-width: thin;\n  border-bottom-color: #7f7f7f;\n  border-bottom-style: solid;\n  border-bottom-width: thin;\n}\n.igv-roi-table > .igv-roi-table-column-titles > div {\n  font-size: 14px;\n  vertical-align: middle;\n  line-height: 24px;\n  text-align: left;\n  margin-left: 4px;\n  height: 24px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border-right-color: #7f7f7f;\n  border-right-style: solid;\n  border-right-width: thin;\n}\n.igv-roi-table > .igv-roi-table-column-titles > div:last-child {\n  border-right: unset;\n}\n.igv-roi-table > .igv-roi-table-row-container {\n  overflow: auto;\n  resize: both;\n  max-width: 1600px;\n  height: 360px;\n  background-color: transparent;\n  display: flex;\n  flex-flow: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: stretch;\n}\n.igv-roi-table > .igv-roi-table-row-container > .igv-roi-table-row {\n  height: 24px;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: stretch;\n  align-items: stretch;\n}\n.igv-roi-table > .igv-roi-table-row-container > .igv-roi-table-row > div {\n  font-size: 14px;\n  vertical-align: middle;\n  line-height: 24px;\n  text-align: left;\n  margin-left: 4px;\n  height: 24px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border-right-color: transparent;\n  border-right-style: solid;\n  border-right-width: thin;\n}\n.igv-roi-table > .igv-roi-table-row-container > .igv-roi-table-row > div:last-child {\n  border-right: unset;\n}\n.igv-roi-table > .igv-roi-table-row-container > .igv-roi-table-row-hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n.igv-roi-table > div:last-child {\n  height: 32px;\n  line-height: 32px;\n  border-top-color: #7f7f7f;\n  border-top-style: solid;\n  border-top-width: thin;\n  border-bottom-color: transparent;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-bottom-width: 0;\n  background-color: #eee;\n  display: flex;\n  flex-flow: row;\n  flex-wrap: nowrap;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.igv-roi-table-row-selected {\n  background-color: rgba(0, 0, 0, 0.125);\n}\n\n.igv-roi-table-button {\n  cursor: pointer;\n  height: 20px;\n  user-select: none;\n  line-height: 20px;\n  text-align: center;\n  vertical-align: middle;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  color: black;\n  padding-left: 6px;\n  padding-right: 6px;\n  background-color: rgb(239, 239, 239);\n  border-color: black;\n  border-style: solid;\n  border-width: thin;\n  border-radius: 3px;\n}\n\n.igv-roi-table-button:hover {\n  font-weight: 400;\n  background-color: rgba(0, 0, 0, 0.13);\n}\n\n.igv-roi-region {\n  z-index: 64;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: visible;\n  margin-top: 44px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: stretch;\n}\n.igv-roi-region > div {\n  position: relative;\n  width: 100%;\n  height: 8px;\n  pointer-events: auto;\n}\n\n.igv-roi-menu {\n  position: absolute;\n  z-index: 1024;\n  width: 144px;\n  border-color: #7f7f7f;\n  border-radius: 4px;\n  border-style: solid;\n  border-width: thin;\n  font-family: \"Open Sans\", sans-serif;\n  background-color: white;\n  display: flex;\n  flex-flow: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: stretch;\n}\n.igv-roi-menu > div:not(:last-child) {\n  border-bottom-color: rgba(128, 128, 128, 0.5);\n  border-bottom-style: solid;\n  border-bottom-width: thin;\n}\n.igv-roi-menu > div:first-child {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-top-color: transparent;\n  border-top-style: solid;\n  border-top-width: 0;\n}\n.igv-roi-menu > div:last-child {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-bottom-color: transparent;\n  border-bottom-style: solid;\n  border-bottom-width: 0;\n}\n\n.igv-roi-menu-row {\n  height: 24px;\n  padding-left: 8px;\n  font-size: small;\n  text-align: start;\n  vertical-align: middle;\n  line-height: 24px;\n  background-color: white;\n}\n\n.igv-roi-menu-row-edit-description {\n  width: -webkit-fill-available;\n  font-size: small;\n  text-align: start;\n  vertical-align: middle;\n  background-color: white;\n  padding-left: 4px;\n  padding-right: 4px;\n  padding-bottom: 4px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: stretch;\n  align-items: stretch;\n}\n.igv-roi-menu-row-edit-description > label {\n  margin-left: 2px;\n  margin-bottom: 0;\n  display: block;\n  width: -webkit-fill-available;\n}\n.igv-roi-menu-row-edit-description > input {\n  display: block;\n  margin-left: 2px;\n  margin-right: 2px;\n  margin-bottom: 1px;\n  width: -webkit-fill-available;\n}\n\n.igv-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding-top: 4px;\n  user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n}\n\n.igv-viewport {\n  position: relative;\n  margin-top: 5px;\n  line-height: 1;\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n\n.igv-viewport-content {\n  position: relative;\n  width: 100%;\n}\n.igv-viewport-content > canvas {\n  position: relative;\n  display: block;\n}\n\n.igv-column-container {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: stretch;\n  width: 100%;\n}\n\n.igv-column-shim {\n  width: 1px;\n  margin-left: 2px;\n  margin-right: 2px;\n  background-color: #545453;\n}\n\n.igv-column {\n  position: relative;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-sizing: border-box;\n  height: 100%;\n}\n\n.igv-axis-column {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-sizing: border-box;\n  height: 100%;\n  width: 50px;\n}\n.igv-axis-column > div {\n  margin-top: 5px;\n  width: 100%;\n}\n\n.igv-sample-name-column {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-sizing: border-box;\n  height: 100%;\n}\n\n.igv-scrollbar-column {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-sizing: border-box;\n  height: 100%;\n  width: 14px;\n}\n.igv-scrollbar-column > div {\n  position: relative;\n  margin-top: 5px;\n  width: 14px;\n}\n.igv-scrollbar-column > div > div {\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 2px;\n  width: 8px;\n  border-width: 1px;\n  border-style: solid;\n  border-color: #c4c4c4;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.igv-scrollbar-column > div > div:hover {\n  background-color: #c4c4c4;\n}\n\n.igv-track-drag-column {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-sizing: border-box;\n  height: 100%;\n  width: 12px;\n  background-color: white;\n}\n.igv-track-drag-column > .igv-track-drag-handle {\n  z-index: 512;\n  position: relative;\n  cursor: pointer;\n  margin-top: 5px;\n  width: 100%;\n  border-style: solid;\n  border-width: 0;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n  background-color: #c4c4c4;\n}\n.igv-track-drag-column .igv-track-drag-handle-hover {\n  background-color: #787878;\n}\n.igv-track-drag-column > .igv-track-drag-shim {\n  position: relative;\n  margin-top: 5px;\n  width: 100%;\n  border-style: solid;\n  border-width: 0;\n}\n\n.igv-gear-menu-column {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-sizing: border-box;\n  height: 100%;\n  width: 28px;\n}\n.igv-gear-menu-column > div {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 5px;\n  width: 100%;\n  background: white;\n}\n.igv-gear-menu-column > div > div {\n  position: relative;\n  margin-top: 4px;\n  width: 16px;\n  height: 16px;\n  color: #7F7F7F;\n}\n.igv-gear-menu-column > div > div:hover {\n  cursor: pointer;\n  color: #444;\n}\n\n/*# sourceMappingURL=dom.css.map */\n';

        var style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.innerHTML = css;

        document.head.append(style);

    }

    // Defines the top-level API for the igv module

    const setApiKey = igvxhr.setApiKey;

    embedCSS();

    function setGoogleOauthToken(accessToken) {
        return igvxhr.setOauthToken(accessToken)
    }

    function setOauthToken(accessToken, host) {
        return igvxhr.setOauthToken(accessToken, host)
    }

    // Backward compatibility
    const oauth = igvxhr.oauth;

    var index = {
        TrackUtils,
        IGVGraphics,
        MenuUtils,
        DataRangeDialog,
        createTrack,
        createBrowser,
        removeBrowser,
        removeAllBrowsers,
        visibilityChange,
        setGoogleOauthToken,
        setOauthToken,
        oauth,
        version,
        setApiKey,
        registerFileFormats
    };

    return index;

}));
